
(function () {
	'use strict';

	angular.module('RmsAppV2.pages', [
		'ui.router',

		'RmsAppV2.pages.dashboard',
		'RmsAppV2.pages.iotlvdashboard',
		'RmsAppV2.pages.smartkitchendashboard',
		//'RmsAppV2.pages.duriandashboard',
		'RmsAppV2.pages.affdashboard',
		'RmsAppV2.pages.iotdashboard',
		'RmsAppV2.pages.durianops',
		'RmsAppV2.pages.digitalhardware',
		'RmsAppV2.pages.smartkitchen',
		'RmsAppV2.pages.robotkiosk',
		'RmsAppV2.pages.franchise',
		'RmsAppV2.pages.pos',
		'RmsAppV2.pages.conference',
		'RmsAppV2.pages.outletops',
		'RmsAppV2.pages.requisitions',
		'RmsAppV2.pages.purchaseorders',
		'RmsAppV2.pages.receivings',
		'RmsAppV2.pages.salesorders',
		'RmsAppV2.pages.salesordercalendar',
		'RmsAppV2.pages.deliveryorders',
		'RmsAppV2.pages.consodeliveryorders',
		'RmsAppV2.pages.routeplan',
		'RmsAppV2.pages.jobs',
		'RmsAppV2.pages.bulkbreakjobs',
		'RmsAppV2.pages.withdrawalrequests',
		'RmsAppV2.pages.wastagereports',
		'RmsAppV2.pages.recipes',
		'RmsAppV2.pages.sops',
		'RmsAppV2.pages.assets',
		'RmsAppV2.pages.assetconfigs',
		'RmsAppV2.pages.services',
		'RmsAppV2.pages.serviceconfigs',
		'RmsAppV2.pages.label',
		'RmsAppV2.pages.inventory',
		'RmsAppV2.pages.tracktrace',
		'RmsAppV2.pages.reportcenter',
		'RmsAppV2.pages.reportinquiry',
		'RmsAppV2.pages.maintenance',
		'RmsAppV2.pages.settings',
		'RmsAppV2.pages.iotadmin',
		'RmsAppV2.pages.iotsettings',
		'RmsAppV2.pages.billing',
		'RmsAppV2.pages.permissioncenter',
		'RmsAppV2.pages.superadmin',
		'RmsAppV2.pages.subscribe',
		'RmsAppV2.pages.signuprms',
		'RmsAppV2.pages.signuprmsdealer',
		'RmsAppV2.pages.signupims',
		'RmsAppV2.pages.signupimsassign',
		'RmsAppV2.pages.ezyshare',
		'RmsAppV2.pages.ezytrack',
		'RmsAppV2.pages.wcsimulator',
		'RmsAppV2.pages.smartiotsettings'
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
	}

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'RmsAppV2.theme.components',
      'RmsAppV2.theme.inputs'
  ]);

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.assetconfigs', [
			'RmsAppV2.pages.assetconfigs.equipment',
			'RmsAppV2.pages.assetconfigs.eqbrands',
			'RmsAppV2.pages.assetconfigs.eqcategories',
			'RmsAppV2.pages.assetconfigs.eqtypes',
			'RmsAppV2.pages.assetconfigs.eqdoctypes',
			'RmsAppV2.pages.assetconfigs.pnreceiversettings',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('assetconfigs', {
				url: '/assetconfigs',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Asset Config',
				sidebarMeta: {
					icon: 'fa fa-cog',
					order: 1300,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.conference', [
			'RmsAppV2.pages.conference.datadownload',
			'RmsAppV2.pages.conference.attendeemgmt',
			'RmsAppV2.pages.conference.prospectmgmt',
			//'RmsAppV2.pages.conference.ghlmerchants'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('conference', {
				url: '/conference',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Conference Mgmt',
				sidebarMeta: {
					icon: 'fa fa-calendar',
					order: 60,
				},
			});
	}	
})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.dashboard', [
			'RmsAppV2.pages.dashboard.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('dashboard', {
				url: '/dashboard',
				templateUrl: 'app/pages/dashboard/dashboard.html',
				title: 'DASHBOARD',
				pageTitle: 'DASHBOARD',
                controller: 'DashboardCtrl',
                controllerAs: 'vm',
				sidebarMeta: {
					icon: 'fa fa-th',
					order: 10,
				},
			});
  }

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.bulkbreakjobs', [
			'RmsAppV2.pages.bulkbreakjobs.bbanalysis',
			'RmsAppV2.pages.bulkbreakjobs.bblist',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('bulkbreakjobs', {
				url: '/bulkbreakjobs',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Bulk-Break Jobs',
			});
	}	
})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.duriandashboard', [
			'RmsAppV2.pages.duriandashboard.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('duriandashboard', {
				url: '/duriandashboard',
				templateUrl: 'app/pages/dashboard_durian/duriandashboard.html',
				title: 'Durian Dashboard',
				pageTitle: 'Durian Dashboard',
                controller: 'DurianDashboardCtrl',
                controllerAs: 'vm',
				sidebarMeta: {
					icon: 'fa fa-tree',
					order: 12,
				},
			});
  }

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.assets', [
			'RmsAppV2.pages.assets.assetlist',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('assets', {
				url: '/assets',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Asset Mgmt',
				sidebarMeta: {
					icon: 'fa fa-laptop',
					order: 1200, 
				},
			});
	}	
})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.iotlvdashboard', [
			'RmsAppV2.pages.iotlvdashboard.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('iotlvdashboard', {
				url: '/iotlvdashboard',
				templateUrl: 'app/pages/dashboard_iotfloorview/iotlvdashboard.html',
				title: 'IMS Floor View',
				pageTitle: 'IMS Floor View',
                controller: 'IoTLvDashboardCtrl',
                controllerAs: 'vm',
			});
  }

})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.smartkitchendashboard', [
			'RmsAppV2.pages.smartkitchendashboard.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('smartkitchendashboard', {
				url: '/smartkitchendashboard',
				templateUrl: 'app/pages/dashboard_smartkitchen/smartkitchendashboard.html',
				title: 'SMARTKITCHEN_DASHBOARD',
				pageTitle: 'SMARTKITCHEN_DASHBOARD',
                controller: 'SmartKitchenDashboardCtrl',
                controllerAs: 'vm',
				sidebarMeta: {
					icon: 'fa fa-tree',
					order: 12,
				},
			});
  }

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.consodeliveryorders', [
			'RmsAppV2.pages.consodeliveryorders.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/consodeliveryorders', '/list')
			.when('/consodeliveryorders/', '/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('consodeliveryorders', {
				url: '/consodeliveryorders',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'CONSO_DELIVERY_ORDERS',
				sidebarMeta: {
					icon: 'fa fa-truck',
					order: 600,
				},
			})
			.state('consodeliveryorders.list', {
				url: '/list',
				templateUrl: 'app/pages/deliveryorderconsolidated/doConsoList.html',
				title: 'CONSO_DELIVERY_ORDERS',
				pageTitle: 'CONSO_DELIVERY_ORDERS',
				parentPath: 'CONSO_DELIVERY_ORDERS',
				controller: 'ConsoDeliveryOrderMainCtrl',
				controllerAs: 'vm',
				sidebarMeta: {
					order: 10,
				}
			})
			.state('consodeliveryorders.create', {
				url: '/create',
				templateUrl: "app/pages/deliveryorderconsolidated/doConsoCreate.html",
				title: 'CREATE_CONSO_DELIVERY_ORDER',
				pageTitle: 'CREATE_CONSO_DELIVERY_ORDER',
				parentPath: 'CONSO_DELIVERY_ORDERS',
				controller: 'ConsoDeliveryOrderCreateCtrl',
				controllerAs: 'vm'
			})
			.state('consodeliveryorders.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/deliveryorderconsolidated/doConsoUpdate.html',
				title: 'UPDATE_CONSO_DELIVERY_ORDER',
				pageTitle: 'UPDATE_CONSO_DELIVERY_ORDER',
				parentPath: 'CONSO_DELIVERY_ORDERS',
				controller: 'ConsoDeliveryOrderUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.deliveryorders', [
			'RmsAppV2.pages.deliveryorders.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/deliveryorders', '/list')
			.when('/deliveryorders/', '/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('deliveryorders', {
				url: '/deliveryorders',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Delivery Order',
				sidebarMeta: {
					icon: 'fa fa-truck',
					order: 600,
				},
			})
			.state('deliveryorders.list', {
				url: '/list',
				templateUrl: 'app/pages/deliveryorders/deliveryorderList.html',
				title: 'DELIVERY_ORDER_LIST',
				pageTitle: 'DELIVERY_ORDER_LIST',
				parentPath: 'DELIVERY_ORDERS',
				controller: 'DeliveryOrderMainCtrl',
				controllerAs: 'vm',
				sidebarMeta: {
					order: 10,
				}
			})
			.state('deliveryorders.create', {
				url: '/create',
				templateUrl: "app/pages/deliveryorders/deliveryorderCreate.html",
				title: 'CREATE_DELIVERY_ORDER',
				pageTitle: 'CREATE_DELIVERY_ORDER',
				parentPath: 'DELIVERY_ORDERS',
				controller: 'DeliveryOrderCreateCtrl',
				controllerAs: 'vm'
			})
			.state('deliveryorders.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/deliveryorders/deliveryorderUpdate.html',
				title: 'UPDATE_DELIVERY_ORDER',
				pageTitle: 'UPDATE_DELIVERY_ORDER',
				parentPath: 'DELIVERY_ORDERS',
				controller: 'DeliveryOrderUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.digitalhardware', [
			'RmsAppV2.pages.digitalhardware.dhmanagement',
			'RmsAppV2.pages.digitalhardware.dhsettings',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('digitalhardware', {
				url: '/digitalhardware',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Digital Hardware',
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.durianops', [
			'RmsAppV2.pages.durianops.collectdurian',
			'RmsAppV2.pages.durianops.processpulps',
			'RmsAppV2.pages.durianops.producepuree',
			'RmsAppV2.pages.durianops.durianinventory',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('durianops', {
				url: '/durianops',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Durian Operation',
				sidebarMeta: {
					icon: 'fa fa-tree',
					order: 40,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.ezyshare', [
			'RmsAppV2.pages.ezyshare.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
			.state('ezyshare', {
				url: '/ezyshare/:id',
				templateUrl: 'app/pages/ezyshare/ezyshareView.html',
				title: 'RMS EzyShare',
				pageTitle: 'RMS EzyShare',
				parentPath: '',
				controller: 'EzyShareCtrl',
				controllerAs: 'vm',
				icon: 'fa-paper-plane text-primary'
			});
	}
	
})();

(function () {
	'use strict';

	angular.module('RmsAppV2.pages.ezytrack', [
			'RmsAppV2.pages.ezytrack.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
			.state('ezytrack', {
				url: '/ezytrack/:id',
				templateUrl: 'app/pages/ezytrack/ezytrackView.html',
				title: 'RMS EzyTrack',
				pageTitle: 'RMS EzyTrack',
				parentPath: '',
				controller: 'EzyTrackCtrl',
				controllerAs: 'vm',
				icon: 'fa-truck text-primary'
			});
	}
	
})();

(function () {
	'use strict';

	angular.module('RmsAppV2.pages.billing', [
			//'RmsAppV2.pages.billing.subscriptions',
			//'RmsAppV2.pages.billing.addons',
			'RmsAppV2.pages.billing.invoices',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('billing', {
				url: '/billing',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Billing Center',
				sidebarMeta: {
					icon: 'fa fa-usd',
					order: 2100,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.franchise', [
			'RmsAppV2.pages.franchise.franchiseemgmt',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('franchise', {
				url: '/franchise',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Franchise',
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.inventory', [
			'RmsAppV2.pages.inventory.inventorydashboard',
			'RmsAppV2.pages.inventory.inventorylock',
			'RmsAppV2.pages.inventory.items',
			'RmsAppV2.pages.inventory.itemreturns',
			'RmsAppV2.pages.inventory.itemstockcounts',
			'RmsAppV2.pages.inventory.products',
			'RmsAppV2.pages.inventory.productstockcounts',
			'RmsAppV2.pages.inventory.semifgs',
			'RmsAppV2.pages.inventory.semifgstockcounts',
			'RmsAppV2.pages.inventory.stocktransfers',
			'RmsAppV2.pages.inventory.stockreturns'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('inventory', {
				url: '/inventory',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Inventory',
				sidebarMeta: {
					icon: 'fa fa-cubes',
					order: 900,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotadmin', [
			'RmsAppV2.pages.iotadmin.iotregdevices',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('iotadmin', {
				url: '/iotadmin',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'IoT Admin',
				sidebarMeta: {
					icon: 'fa fa-wifi',
					order: 2200,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotsettings', [
			'RmsAppV2.pages.iotsettings.floorviewdesigner',
			'RmsAppV2.pages.iotsettings.gateways',
			'RmsAppV2.pages.iotsettings.handhelds',
			'RmsAppV2.pages.iotsettings.sensors',
			'RmsAppV2.pages.iotsettings.settings',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('iotsettings', {
				url: '/iotsettings',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'IoT Settings',
				sidebarMeta: {
					icon: 'fa fa-wifi',
					order: 2300,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.jobs', [
			'RmsAppV2.pages.jobs.jobanalysisfg',
			'RmsAppV2.pages.jobs.jobanalysissemifg',
			'RmsAppV2.pages.jobs.joblist',
			'RmsAppV2.pages.jobs.jobdashboard',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('jobs', {
				url: '/jobs',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Job Production',
				sidebarMeta: {
					icon: 'fa fa-briefcase',
					order: 700,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.label', [
			'RmsAppV2.pages.label.items',
			'RmsAppV2.pages.label.semifgs',
			'RmsAppV2.pages.label.products',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('label', {
				url: '/label',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Label Printing',
				sidebarMeta: {
					icon: 'fa fa-tags',
					order: 800,
				},
			});
	}	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.login', ['ui.select', 'ngAnimate', 'ngSanitize', 'ngMessages'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('login', {
                url: '/login',
                templateUrl: 'app/pages/login/login.html',
                controller: 'LoginCtrl'
            })
			.state('changepassword', {
				url: '/login/changepassword',
				templateUrl: 'app/pages/login/change.html',
				title: 'Change Password',
				pageTitle: 'Change Password',
				controller: 'LoginChangeCtrl',
				controllerAs: 'vm'
			})
			.state('switch', {
				url: '/login/switch',
				templateUrl: 'app/pages/login/switch.html',
				title: 'SWITCH_COMPANY_AND_BRANCH',
				pageTitle: 'SWITCH_COMPANY_AND_BRANCH',
				controller: 'LoginSwitchCtrl'
			})
			.state('resetpassword', {
				url: '/login/resetpassword',
				templateUrl: 'app/pages/login/reset.html',
				controller: 'LoginCtrl'
			});
    }
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance', [
			'RmsAppV2.pages.maintenance.debtors',
			'RmsAppV2.pages.maintenance.debtorcategories',
			'RmsAppV2.pages.maintenance.suppliers',
			'RmsAppV2.pages.maintenance.items',
			'RmsAppV2.pages.maintenance.products',
			'RmsAppV2.pages.maintenance.semifgs',
			'RmsAppV2.pages.maintenance.foodmenus',
			'RmsAppV2.pages.maintenance.warehouses',
            'RmsAppV2.pages.maintenance.shippingfees',
			'RmsAppV2.pages.maintenance.shippingmethods',
			'RmsAppV2.pages.maintenance.packagingconditions',
			'RmsAppV2.pages.maintenance.yieldmanagement',
			'RmsAppV2.pages.maintenance.bulkbreakconfig',
			'RmsAppV2.pages.maintenance.storepurchaseconfigs',
			'RmsAppV2.pages.maintenance.stockrequestconfigs',
			'RmsAppV2.pages.maintenance.multilevelapprovals',
			'RmsAppV2.pages.maintenance.intercompanymappings',
			'RmsAppV2.pages.maintenance.intercompanyitemmappings',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');

		$stateProvider
			.state('maintenance', {
				url: '/maintenance',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Maintenance',
				sidebarMeta: {
					icon: 'fa fa-cog',
					order: 2000,
				},
			});
	}
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.outletops', [
			'RmsAppV2.pages.outletops.srnlist',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('outletops', {
				url: '/outletops',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Outlet Operations',
				sidebarMeta: {
					icon: 'ion ion-cube',
					order: 300,
				},
			});
	}	
})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.permissioncenter', [
			'RmsAppV2.pages.permissioncenter.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('permissioncenter', {
				url: '/permissioncenter',
				templateUrl: 'app/pages/permissioncenter/permissioncenter.html',
				title: 'Permission Center',
				pageTitle: 'Permission Center',
                controller: 'PermissionCenterCtrl',
                controllerAs: 'vm',
				sidebarMeta: {
					icon: 'fa fa-bar-chart',
					order: 2500,
				},
			});
  }

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.pos', [
			'RmsAppV2.pages.pos.products',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('pos', {
				url: '/pos',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'POS System',
				sidebarMeta: {
					icon: 'fa fa-desktop',
					order: 50,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.purchaseorders', [
			'RmsAppV2.pages.purchaseorders.pofromreq',
			'RmsAppV2.pages.purchaseorders.polist',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('purchaseorders', {
				url: '/purchaseorders',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Purchase Order',
				sidebarMeta: {
					icon: 'fa fa-file-powerpoint-o',
					order: 200,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.receivings', [
			'RmsAppV2.pages.receivings.grnlist',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('receivings', {
				url: '/receivings',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Goods Receive',
				sidebarMeta: {
					icon: 'ion ion-cube',
					order: 300,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.recipes', [
			'RmsAppV2.pages.recipes.categories',
			'RmsAppV2.pages.recipes.recipes',
			'RmsAppV2.pages.recipes.cards',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('recipes', {
				url: '/recipes',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Recipes',
				sidebarMeta: {
					icon: 'fa fa-book',
					order: 1000,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.requisitions', [
			'RmsAppV2.pages.requisitions.reqlist',
			'RmsAppV2.pages.requisitions.reqapproval',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('requisitions', {
				url: '/requisitions',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Requisition',
				sidebarMeta: {
					icon: 'fa fa-paw',
					order: 100,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk', [
			'RmsAppV2.pages.robotkiosk.kiosks',
			'RmsAppV2.pages.robotkiosk.equipments',
			'RmsAppV2.pages.robotkiosk.equipmenttypes',
			'RmsAppV2.pages.robotkiosk.categories',
			'RmsAppV2.pages.robotkiosk.products',
			'RmsAppV2.pages.robotkiosk.productsizes',
			'RmsAppV2.pages.robotkiosk.productflavors',
			'RmsAppV2.pages.robotkiosk.productothers',
			'RmsAppV2.pages.robotkiosk.productmappings'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('robotkiosk', {
				url: '/robotkiosk',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Robot Kiosk',
				sidebarMeta: {
					icon: 'fa fa-android',
					order: 30,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.routeplan', [
			'RmsAppV2.pages.routeplan.template',
			'RmsAppV2.pages.routeplan.preview',
			'RmsAppV2.pages.routeplan.actual',
			'RmsAppV2.pages.routeplan.actual_mercado',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');

		$stateProvider
			.state('routeplan', {
				url: '/routeplan',
				template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Route Planning',
				sidebarMeta: {
					icon: 'fa fa-tree',
					order: 40,
				},
			});
	}
})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.affdashboard', [
			'RmsAppV2.pages.affdashboard.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('affdashboard', {
				url: '/affdashboard',
				templateUrl: 'app/pages/dashboard_affiliate/affdashboard.html',
				title: 'Dealer Dashboard',
				pageTitle: 'Dealer Dashboard',
                controller: 'AffDashboardCtrl',
                controllerAs: 'vm',
				sidebarMeta: {
					icon: 'fa fa-line-chart',
					order: 20,
				},
			});
  }

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.salesorders', [
			'RmsAppV2.pages.salesorders.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/salesorders', '/list')
			.when('/salesorders/', '/list')
			.otherwise('/dashboard');

		$stateProvider
			.state('salesorders', {
				url: '/salesorders',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Sales Order',
				sidebarMeta: {
					icon: 'fa fa-magic',
					order: 500,
				},
			})
			.state('salesorders.list', {
				url: '/list',
				templateUrl: 'app/pages/salesorders/salesorderList.html',
				title: 'SALES_ORDER_LIST',
				pageTitle: 'SALES_ORDER_LIST',
				parentPath: 'SALES_ORDER',
				controller: 'SalesOrderMainCtrl',
				controllerAs: 'vm',
				sidebarMeta: {
					order: 10,
				}
			})
			.state('salesorders.create', {
				url: '/create',
				templateUrl: "app/pages/salesorders/salesorderCreate.html",
				title: 'CREATE_SALES_ORDER',
				pageTitle: 'CREATE_SALES_ORDER',
				parentPath: 'SALES_ORDER',
				controller: 'SalesOrderCreateCtrl',
				controllerAs: 'vm'
			})
			.state('salesorders.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/salesorders/salesorderUpdate.html',
				title: 'UPDATE_SALES_ORDER',
				pageTitle: 'UPDATE_SALES_ORDER',
				parentPath: 'SALES_ORDER',
				controller: 'SalesOrderUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('salesorders.clone', {
				url: '/clone/:id',
				templateUrl: "app/pages/salesorders/salesorderCreate.html",
				title: 'CLONE_SALES_ORDER',
				pageTitle: 'CLONE_SALES_ORDER',
				parentPath: 'SALES_ORDER',
				controller: 'SalesOrderCloneCtrl',
				controllerAs: 'vm'
			})
			.state('salesorders.import', {
				url: '/import/:id',
                templateUrl: 'app/pages/salesorders/salesOrderImport.html',
				title: 'IMPORT_SALES_ORDERS',
				pageTitle: 'IMPORT_SALES_ORDERS',
				parentPath: 'SALES_ORDER',
				controller: 'SalesOrderImportCtrl',
				controllerAs: 'vm'
			});
	}

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs', [
			'RmsAppV2.pages.serviceconfigs.spareparts',
			'RmsAppV2.pages.serviceconfigs.rostertypes',
			'RmsAppV2.pages.serviceconfigs.svctypes',
			'RmsAppV2.pages.serviceconfigs.worktypes',
			'RmsAppV2.pages.serviceconfigs.checklists',
			'RmsAppV2.pages.serviceconfigs.checklistentries',
			'RmsAppV2.pages.serviceconfigs.loanstatuses',
			'RmsAppV2.pages.serviceconfigs.loanitemstatuses',
			'RmsAppV2.pages.serviceconfigs.workorderstatuses',
			'RmsAppV2.pages.serviceconfigs.services',
			'RmsAppV2.pages.serviceconfigs.processes',
			'RmsAppV2.pages.serviceconfigs.techteams',
			'RmsAppV2.pages.serviceconfigs.zones',
			'RmsAppV2.pages.serviceconfigs.pnsettings',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs', {
				url: '/serviceconfigs',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'AfterSales Config',
				sidebarMeta: {
					icon: 'fa fa-cog',
					order: 1600,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.services', [
			'RmsAppV2.pages.services.workorders',
			'RmsAppV2.pages.services.loanrequests',
			'RmsAppV2.pages.services.casemanagement',
			'RmsAppV2.pages.services.warranty',
			'RmsAppV2.pages.services.warrantyclaim',
			'RmsAppV2.pages.services.dutyrosters',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('services', {
				url: '/services',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'AfterSales Service',
				sidebarMeta: {
					icon: 'fa fa-puzzle-piece',
					order: 1400,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.settings', [
			'RmsAppV2.pages.settings.branches',
			'RmsAppV2.pages.settings.departments',
			'RmsAppV2.pages.settings.emailtemplates',
			'RmsAppV2.pages.settings.labeltemplates',
			'RmsAppV2.pages.settings.notificationsettings',
			'RmsAppV2.pages.settings.usergroups',
			'RmsAppV2.pages.settings.users',
			'RmsAppV2.pages.settings.iprules',
			'RmsAppV2.pages.settings.resellercommconfig'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('settings', {
				url: '/settings',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Settings',
				sidebarMeta: {
					icon: 'fa fa-sliders',
					order: 2100,
				},
			});
	}	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.signup', [
		'RmsAppV2.pages.subscribe.controller',	
	])
        .config(routeConfig);

    /** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('signup', {
				url: '/signup',
				templateUrl: 'app/pages/signup/signup.html',
				title: '** New Sign Up **',
				pageTitle: 'New Sign Up Form',
				parentPath: '',
				controller: 'SignUpCtrl',
				controllerAs: 'vm',
				sidebarMeta: {
					icon: 'fa fa-star text-danger',
					order: 0,
				},
			});
			
			
		/* $stateProvider	
			.state('signup', {
                url: '/signup/{id:[^/]*}',
                templateUrl: 'app/pages/signup/signup.html',
                controller: 'SignUpCtrl',
                controllerAs: 'vm',
            })
			.state('signupthankyou', {
                url: '/signup-thankyou/{id:[^/]*}',
                templateUrl: 'app/pages/signup/thankyou.html',
                controller: 'SignUpCtrl',
                controllerAs: 'vm',
            }); */
    }
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.signupims', [
		'RmsAppV2.pages.signupims.controller',	
	])
        .config(routeConfig);

    /** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('signupims', {
				url: '/signupims',
				templateUrl: 'app/pages/signupims/signupIMS.html',
				title: 'SMART IOT - New Account Creation',
				pageTitle: 'SMART IOT - New Account Creation',
				parentPath: '',
				controller: 'SignUpIMSCtrl',
				controllerAs: 'vm',
			});
    }
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.signupimsassign', [
		'RmsAppV2.pages.signupimsassign.controller',	
	])
        .config(routeConfig);

    /** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('signupimsassign', {
				url: '/signupimsassign',
				templateUrl: 'app/pages/signupimsassign/signupIMSassign.html',
				title: 'IMS - IoT Device Assignment',
				pageTitle: 'IMS - IoT Device Assignment',
				parentPath: '',
				controller: 'SignUpIMSAssignCtrl',
				controllerAs: 'vm',
			});
    }
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.signuprms', [
		'RmsAppV2.pages.signuprms.controller',	
	])
        .config(routeConfig);

    /** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('signuprms', {
				url: '/signuprms',
				templateUrl: 'app/pages/signuprms/signupRMS.html',
				title: 'RMS - New Account Creation',
				pageTitle: 'RMS - New Account Creation',
				parentPath: '',
				controller: 'SignUpRMSCtrl',
				controllerAs: 'vm',
			});
    }
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.signuprmsdealer', [
		'RmsAppV2.pages.signuprmsdealer.controller',	
	])
        .config(routeConfig);

    /** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('signuprmsdealer', {
				url: '/signuprmsdealer',
				templateUrl: 'app/pages/signuprms_dealer/signupRMS_dealer.html',
				title: 'Sign Up RMS (Dealer)',
				pageTitle: 'Sign Up RMS (Dealer)',
				parentPath: '',
				controller: 'SignUpRMSDealerCtrl',
				controllerAs: 'vm',
			});
    }
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.smartiotsettings', [
			'RmsAppV2.pages.smartiotsettings.gateways',
			'RmsAppV2.pages.smartiotsettings.sensors',
			'RmsAppV2.pages.smartiotsettings.devicegroups',
			'RmsAppV2.pages.smartiotsettings.notifications',
			'RmsAppV2.pages.smartiotsettings.planviewdesigner'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('smartiotsettings', {
				url: '/smartiotsettings',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Smart IoT Settings',
			});
	}	
})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.smartkitchen', [
			'RmsAppV2.pages.smartkitchen.joblist',
			'RmsAppV2.pages.smartkitchen.skbranches',
			'RmsAppV2.pages.smartkitchen.machineconnectionprofiles'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('smartkitchen', {
				url: '/smartkitchen',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'SMART_KITCHEN'
			});
	}

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.sops', [
			'RmsAppV2.pages.sops.categories',
			'RmsAppV2.pages.sops.soptypes',
			'RmsAppV2.pages.sops.sops',
			'RmsAppV2.pages.sops.cards',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('sops', {
				url: '/sops',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'S.O.P.s',
				sidebarMeta: {
					icon: 'fa fa-list-ol',
					order: 1100,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.subscribe', [
			'RmsAppV2.pages.subscribe.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('subscribe', {
				url: '/subscribe',
				templateUrl: 'app/pages/subscribe/form.html',
				title: 'Subscribe',
				pageTitle: 'New Subscriber Form',
				parentPath: '',
				controller: 'SubscribeMainCtrl',
				controllerAs: 'vm',
				sidebarMeta: {
					icon: 'fa fa-file-text-o',
					order: 2300,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin', [
			'RmsAppV2.pages.superadmin.iotregdevices',
			'RmsAppV2.pages.superadmin.affiliates',
			'RmsAppV2.pages.superadmin.affiliates_newcustomer',
			'RmsAppV2.pages.superadmin.companies',
			'RmsAppV2.pages.superadmin.companysettings',
			'RmsAppV2.pages.superadmin.branches',
			'RmsAppV2.pages.superadmin.payments',
			'RmsAppV2.pages.superadmin.commissions',
			'RmsAppV2.pages.superadmin.users',
			'RmsAppV2.pages.superadmin.features',
			'RmsAppV2.pages.superadmin.uoms',
			'RmsAppV2.pages.superadmin.serverpackages',
			'RmsAppV2.pages.superadmin.serverpackagesettings',
			'RmsAppV2.pages.superadmin.intercompanymappings',
			'RmsAppV2.pages.superadmin.intercompanyitemmappings',
			'RmsAppV2.pages.superadmin.systemschedulersettings',
			'RmsAppV2.pages.superadmin.systemsettings',
			'RmsAppV2.pages.superadmin.systemversion',
			'RmsAppV2.pages.superadmin.businessmetrics',
			'RmsAppV2.pages.superadmin.siotdevices',
			'RmsAppV2.pages.superadmin.announcements'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');

		$stateProvider
			.state('superadmin', {
				url: '/superadmin',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Super Admin',
				requireSA: true,
				sidebarMeta: {
					icon: 'fa fa-shield',
					order: 2600,
				},
			});
	}
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.wastagereports', [
			'RmsAppV2.pages.wastagereports.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/wastagereports', '/list')
			.when('/wastagereports/', '/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('wastagereports', {
				url: '/wastagereports',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Wastage Reports'
			})
			.state('wastagereports.list', {
				url: '/list',
				templateUrl: 'app/pages/wastagereports/wastagereportList.html',
				title: 'Wastage Report Listing',
				pageTitle: 'Wastage Report Listing',
				parentPath: 'Wastage Report',
				controller: 'WastageReportMainCtrl',
				controllerAs: 'vm'
			})
			.state('wastagereports.create', {
				url: '/create',
				templateUrl: "app/pages/wastagereports/wastagereportCreate.html",
				title: 'Create W.R.',
				pageTitle: 'Create Wastage Report',
				parentPath: 'Wastage Report',
				controller: 'WastageReportCreateCtrl',
				controllerAs: 'vm'
			})
			.state('wastagereports.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/wastagereports/wastagereportUpdate.html',
				title: 'Update W.R.',
				pageTitle: 'Update Wastage Report',
				parentPath: 'Wastage Report',
				controller: 'WastageReportUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.wcsimulator', [
			'RmsAppV2.pages.wcsimulator.simulations',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('wcsimulator', {
				url: '/wcsimulator',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Weight Checker Simulator',
				sidebarMeta: {
					icon: 'fa fa-desktop',
					order: 10,
				},
			});
	}	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.withdrawalrequests', [
			'RmsAppV2.pages.withdrawalrequests.wrlist',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('withdrawalrequests', {
				url: '/withdrawalrequests',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Withdrawal Request',
				sidebarMeta: {
					icon: 'fa fa-stack-overflow',
					order: 800,
				},
			});
	}	
})();


(function () {
  'use strict';

  angular.module('RmsAppV2.theme.components', []);

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotdashboard', [
			'RmsAppV2.pages.iotdashboard.ezysite',
			'RmsAppV2.pages.iotdashboard.ezymap',
			'RmsAppV2.pages.iotdashboard.observatory',
			'RmsAppV2.pages.iotdashboard.smartiot',
			'RmsAppV2.pages.iotdashboard.smartiotplanview',
			'RmsAppV2.pages.iotdashboard.smartiotobservatory'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
			
		$stateProvider
			.state('iotdashboard', {
				url: '/iotdashboard',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'IMS Dashboard',
			});
	}	
})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme.inputs', []);

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.salesordercalendar', [
			'RmsAppV2.pages.salesordercalendar.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/salesordercalendar', '/list')
			.when('/salesordercalendar/', '/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('salesorders.calendar', {
				url: '/salesordercalendar',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title: 'Sales Order',
				sidebarMeta: {
					icon: 'fa fa-magic',
					order: 500,
				},
			})
			.state('salesorders.calendar.list', {
				url: '/list',
				templateUrl: 'app/pages/salesordercalendar/salesordercalendar.html',
				title: 'SALES_ORDER_CALENDAR',
				pageTitle: 'SALES_ORDER_CALENDAR',
				parentPath: 'SALES_ORDER',
				controller: 'SalesOrderCalendarMainCtrl',
				controllerAs: 'vm',
				sidebarMeta: {
					order: 10,
				}
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.assetconfigs.eqbrands', [
			'RmsAppV2.pages.assetconfigs.eqbrands.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/assetconfigs/eqbrands', '/assetconfigs/eqbrands/list')
			.when('/assetconfigs/eqbrands/', '/assetconfigs/eqbrands/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('assetconfigs.eqbrands', {
				url: '/eqbrands',
				title: 'Equipment Brands',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('assetconfigs.eqbrands.list', {
				url: '/list',
				templateUrl: 'app/pages/assetconfigs/eqbrands/eqbrandList.html',
				title: 'Equipment Brands',
				pageTitle: 'Equipment Brands',
				parentPath: 'Asset Config',
				controller: 'EqBrandMainCtrl',
				controllerAs: 'vm'
			})
			.state('assetconfigs.eqbrands.create', {
				url: '/create',
				templateUrl: "app/pages/assetconfigs/eqbrands/eqbrandCreate.html",
				title: 'Create Brand',
				pageTitle: 'Create Brand',
				parentPath: 'Asset Config',
				controller: 'EqBrandCreateCtrl',
				controllerAs: 'vm'
			})
			.state('assetconfigs.eqbrands.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/assetconfigs/eqbrands/eqbrandUpdate.html',
				title: 'Update Brand',
				pageTitle: 'Update Brand',
				parentPath: 'Asset Config',
				controller: 'EqBrandUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.assetconfigs.equipment', [
			'RmsAppV2.pages.assetconfigs.equipment.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/assetconfigs/equipment', '/assetconfigs/equipment/list')
			.when('/assetconfigs/equipment/', '/assetconfigs/equipment/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('assetconfigs.equipment', {
				url: '/equipment',
				title: 'Equipment',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('assetconfigs.equipment.list', {
				url: '/list',
				templateUrl: 'app/pages/assetconfigs/equipment/equipmentList.html',
				title: 'Equipment',
				pageTitle: 'Equipment List',
				parentPath: 'Asset Config',
				controller: 'EquipmentMainCtrl',
				controllerAs: 'vm'
			})
			.state('assetconfigs.equipment.create', {
				url: '/create',
				templateUrl: "app/pages/assetconfigs/equipment/equipmentCreate.html",
				title: 'Create Equipment',
				pageTitle: 'Create Equipment',
				parentPath: 'Asset Config',
				controller: 'EquipmentCreateCtrl',
				controllerAs: 'vm'
			})
			.state('assetconfigs.equipment.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/assetconfigs/equipment/equipmentUpdate.html',
				title: 'Update Equipment',
				pageTitle: 'Update Equipment',
				parentPath: 'Asset Config',
				controller: 'EquipmentUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('assetconfigs.equipment.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/assetconfigs/equipment/equipmentImport.html',
				title: 'Import Equipment',
				pageTitle: 'Import Equipment',
				parentPath: 'Asset Config',
				controller: 'EquipmentImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.assetconfigs.pnreceiversettings', [
			'RmsAppV2.pages.assetconfigs.pnreceiversettings.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/assetconfigs/pnreceiversettings', '/assetconfigs/pnreceiversettings/list')
			.when('/assetconfigs/pnreceiversettings/', '/assetconfigs/pnreceiversettings/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('assetconfigs.pnreceiversettings', {
				url: '/pnreceiversettings',
				title: 'Push Notifications',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 60,
				},
			})
			.state('assetconfigs.pnreceiversettings.list', {
				url: '/list',
				templateUrl: 'app/pages/assetconfigs/pnreceiversettings/pnreceiversettingList.html',
				title: 'Push Notification (Receiver) Settings',
				pageTitle: 'Push Notification (Receiver) Settings',
				parentPath: 'Asset Config',
				controller: 'PushNotificationReceiverSettingMainCtrl',
				controllerAs: 'vm'
			})
			.state('assetconfigs.pnreceiversettings.create', {
				url: '/create',
				templateUrl: "app/pages/assetconfigs/pnreceiversettings/pnreceiversettingCreate.html",
				title: 'Create New Push Notification (Receiver) Settings',
				pageTitle: 'Create New Push Notification (Receiver) Settings',
				parentPath: 'Asset Config',
				controller: 'PushNotificationReceiverSettingCreateCtrl',
				controllerAs: 'vm'
			})
			.state('assetconfigs.pnreceiversettings.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/assetconfigs/pnreceiversettings/pnreceiversettingUpdate.html',
				title: 'Update Push Notification (Receiver) Settings',
				pageTitle: 'Update Push Notification (Receiver) Settings',
				parentPath: 'Asset Config',
				controller: 'PushNotificationReceiverSettingUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.assetconfigs.eqdoctypes', [
			'RmsAppV2.pages.assetconfigs.eqdoctypes.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/assetconfigs/eqdoctypes', '/assetconfigs/eqdoctypes/list')
			.when('/assetconfigs/eqdoctypes/', '/assetconfigs/eqdoctypes/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('assetconfigs.eqdoctypes', {
				url: '/eqdoctypes',
				title: 'Equipment Doc Types',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 50,
				},
			})
			.state('assetconfigs.eqdoctypes.list', {
				url: '/list',
				templateUrl: 'app/pages/assetconfigs/eqdoctypes/eqdoctypeList.html',
				title: 'Equipment Doc Types',
				pageTitle: 'Equipment Doc Types',
				parentPath: 'Asset Config',
				controller: 'EqDocTypeMainCtrl',
				controllerAs: 'vm'
			})
			.state('assetconfigs.eqdoctypes.create', {
				url: '/create',
				templateUrl: "app/pages/assetconfigs/eqdoctypes/eqdoctypeCreate.html",
				title: 'Create Document Type',
				pageTitle: 'Create Document Type',
				parentPath: 'Asset Config',
				controller: 'EqDocTypeCreateCtrl',
				controllerAs: 'vm'
			})
			.state('assetconfigs.eqdoctypes.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/assetconfigs/eqdoctypes/eqdoctypeUpdate.html',
				title: 'Update Document Type',
				pageTitle: 'Update Document Type',
				parentPath: 'Asset Config',
				controller: 'EqDocTypeUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.conference.attendeemgmt', [
			'RmsAppV2.pages.conference.attendeemgmt.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/conference/attendeemgmt', '/conference/attendeemgmt/list')
			.when('/conference/attendeemgmt/', '/conference/attendeemgmt/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('conference.attendeemgmt', {
				url: '/attendeemgmt',
				title: 'Attendee Management',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('conference.attendeemgmt.list', {
				url: '/list',
				templateUrl: 'app/pages/conference/attendeemgmt/attendeeList.html',
				title: 'Attendee Management',
				pageTitle: 'Attendee Management',
				parentPath: 'Conference Management',
				controller: 'ConferenceAttendeeMgmtMainCtrl',
				controllerAs: 'vm'
			})
			.state('conference.attendeemgmt.create', {
				url: '/create',
				templateUrl: "app/pages/conference/attendeemgmt/attendeeCreate.html",
				title: 'Create Attendee',
				pageTitle: 'Create Attendee',
				parentPath: 'Conference Management',
				controller: 'ConferenceAttendeeMgmtCreateCtrl',
				controllerAs: 'vm'
			})
			.state('conference.attendeemgmt.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/conference/attendeemgmt/attendeeUpdate.html',
				title: 'Update Attendee',
				pageTitle: 'Update Attendee',
				parentPath: 'Conference Management',
				controller: 'ConferenceAttendeeMgmtUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.assetconfigs.eqtypes', [
			'RmsAppV2.pages.assetconfigs.eqtypes.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/assetconfigs/eqtypes', '/assetconfigs/eqtypes/list')
			.when('/assetconfigs/eqtypes/', '/assetconfigs/eqtypes/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('assetconfigs.eqtypes', {
				url: '/eqtypes',
				title: 'Equipment Types',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 40,
				},
			})
			.state('assetconfigs.eqtypes.list', {
				url: '/list',
				templateUrl: 'app/pages/assetconfigs/eqtypes/eqtypeList.html',
				title: 'Equipment Types',
				pageTitle: 'Equipment Types',
				parentPath: 'Asset Config',
				controller: 'EqTypeMainCtrl',
				controllerAs: 'vm'
			})
			.state('assetconfigs.eqtypes.create', {
				url: '/create',
				templateUrl: "app/pages/assetconfigs/eqtypes/eqtypeCreate.html",
				title: 'Create Type',
				pageTitle: 'Create Equipment Type',
				parentPath: 'Asset Config',
				controller: 'EqTypeCreateCtrl',
				controllerAs: 'vm'
			})
			.state('assetconfigs.eqtypes.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/assetconfigs/eqtypes/eqtypeUpdate.html',
				title: 'Update Type',
				pageTitle: 'Update Equipment Type',
				parentPath: 'Asset Config',
				controller: 'EqTypeUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.conference.datadownload', [
			'RmsAppV2.pages.conference.datadownload.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/conference/datadownload', '/conference/datadownload/create')
			.when('/conference/datadownload/', '/conference/datadownload/create')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('conference.datadownload', {
				url: '/datadownload',
				title: 'Data Download',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('conference.datadownload.create', {
				url: '/create',
				templateUrl: "app/pages/conference/datadownload/datadownload.html",
				title: 'Data Download',
				pageTitle: 'Data Download',
				parentPath: 'Conference Management',
				controller: 'ConferenceDataDownloadCreateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.conference.prospectmgmt', [
			'RmsAppV2.pages.conference.prospectmgmt.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/conference/prospectmgmt', '/conference/prospectmgmt/list')
			.when('/conference/prospectmgmt/', '/conference/prospectmgmt/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('conference.prospectmgmt', {
				url: '/prospectmgmt',
				title: 'Prospects Management',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('conference.prospectmgmt.list', {
				url: '/list',
				templateUrl: 'app/pages/conference/prospectmgmt/prospectList.html',
				title: 'Prospect Management',
				pageTitle: 'Prospect Management',
				parentPath: 'Conference Management',
				controller: 'ConferenceProspectMgmtMainCtrl',
				controllerAs: 'vm'
			})
			.state('conference.prospectmgmt.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/conference/prospectmgmt/prospectUpdate.html',
				title: 'Update Prospect',
				pageTitle: 'Update Prospect',
				parentPath: 'Conference Management',
				controller: 'ConferenceProspectMgmtUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.bulkbreakjobs.bbanalysis', [
			'RmsAppV2.pages.bulkbreakjobs.bbanalysis.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/bulkbreakjobs/bbanalysis', '/bulkbreakjobs/bbanalysis/list')
			.when('/bulkbreakjobs/bbanalysis/', '/bulkbreakjobs/bbanalysis/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('bulkbreakjobs.bbanalysis', {
				url: '/bbanalysis',
				title: 'Production Analysis (FG)',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			})
			.state('bulkbreakjobs.bbanalysis.list', {
				url: '/list',
				templateUrl: 'app/pages/bulkbreakjobs/bbanalysis/bbanalysis.html',
				title: 'Bulk-Break Analysis',
				pageTitle: 'Bulk-Break Analysis',
				parentPath: 'Bulk-Break',
				controller: 'BulkBreakAnalysisMainCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.assetconfigs.eqcategories', [
			'RmsAppV2.pages.assetconfigs.eqcategories.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/assetconfigs/eqcategories', '/assetconfigs/eqcategories/list')
			.when('/assetconfigs/eqcategories/', '/assetconfigs/eqcategories/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('assetconfigs.eqcategories', {
				url: '/eqcategories',
				title: 'Equipment Categories',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('assetconfigs.eqcategories.list', {
				url: '/list',
				templateUrl: 'app/pages/assetconfigs/eqcategories/eqcategoryList.html',
				title: 'Equipment Categories',
				pageTitle: 'Equipment Categories',
				parentPath: 'Asset Config',
				controller: 'EqCategoryMainCtrl',
				controllerAs: 'vm'
			})
			.state('assetconfigs.eqcategories.create', {
				url: '/create',
				templateUrl: "app/pages/assetconfigs/eqcategories/eqcategoryCreate.html",
				title: 'Create Equipment Category',
				pageTitle: 'Create Equipment Category',
				parentPath: 'Asset Config',
				controller: 'EqCategoryCreateCtrl',
				controllerAs: 'vm'
			})
			.state('assetconfigs.eqcategories.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/assetconfigs/eqcategories/eqcategoryUpdate.html',
				title: 'Update Equipment Category',
				pageTitle: 'Update Equipment Category',
				parentPath: 'Asset Config',
				controller: 'EqCategoryUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.bulkbreakjobs.bblist', [
			'RmsAppV2.pages.bulkbreakjobs.bblist.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/bulkbreakjobs/bblist', '/bulkbreakjobs/bblist/list')
			.when('/bulkbreakjobs/bblist/', '/bulkbreakjobs/bblist/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('bulkbreakjobs.bblist', {
				url: '/bblist',
				title: 'Bulk-Break Job Listing',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			})
			.state('bulkbreakjobs.bblist.list', {
				url: '/list',
				templateUrl: 'app/pages/bulkbreakjobs/bblist/bblistList.html',
				title: ' Bulk-Break Job Listing',
				pageTitle: 'Bulk-Break Job Listing',
				parentPath: 'Bulk-Break',
				controller: 'BulkBreakJobMainCtrl',
				controllerAs: 'vm'
			})
			.state('bulkbreakjobs.bblist.create', {
				url: '/create',
				templateUrl: "app/pages/bulkbreakjobs/bblist/bblistCreate.html",
				title: 'Create Bulk-Break Job',
				pageTitle: 'Create Bulk-Break Job',
				parentPath: 'Bulk-Break',
				controller: 'BulkBreakJobCreateCtrl',
				controllerAs: 'vm'
			})
			.state('bulkbreakjobs.bblist.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/bulkbreakjobs/bblist/bblistUpdate.html',
				title: 'Update Bulk-Break Job',
				pageTitle: 'Update Bulk-Break Job',
				parentPath: 'Bulk-Break',
				controller: 'BulkBreakJobUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.jobs.jobdashboard', [
			'RmsAppV2.pages.jobs.jobdashboard.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/jobs/jobdashboard', '/jobs/jobdashboard/list')
			.when('/jobs/jobdashboard/', '/jobs/jobdashboard/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('jobs.jobdashboard', {
				url: '/jobdashboard',
				title: 'Production Dashboard',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('jobs.jobdashboard.list', {
				url: '/list',
				templateUrl: 'app/pages/jobs/jobdashboard/jobdashboard.html',
				title: 'Production Dashboard',
				pageTitle: 'Production Dashboard',
				parentPath: '',
				controller: 'JobDashboardMainCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.assets.assetlist', [
			'RmsAppV2.pages.assets.assetlist.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/assets/assetlist', '/assets/assetlist/list')
			.when('/assets/assetlist/', '/assets/assetlist/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('assets.assetlist', {
				url: '/assetlist',
				title: 'Asset Listing',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('assets.assetlist.list', {
				url: '/list',
				templateUrl: 'app/pages/assets/assetlist/assetList.html',
				title: 'Asset Listing',
				pageTitle: 'Asset Listing',
				parentPath: 'Assets',
				controller: 'AssetMainCtrl',
				controllerAs: 'vm'
			})
			.state('assets.assetlist.create', {
				url: '/create',
				templateUrl: "app/pages/assets/assetlist/assetCreate.html",
				title: 'Create Asset',
				pageTitle: 'Create Asset',
				parentPath: 'Assets',
				controller: 'AssetCreateCtrl',
				controllerAs: 'vm'
			})
			.state('assets.assetlist.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/assets/assetlist/assetUpdate.html',
				title: 'Update Asset',
				pageTitle: 'Update Asset',
				parentPath: 'Assets',
				controller: 'AssetUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.digitalhardware.dhmanagement', [
			'RmsAppV2.pages.digitalhardware.dhmanagement.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/digitalhardware/dhmanagement', '/digitalhardware/dhmanagement/list')
			.when('/digitalhardware/dhmanagement/', '/digitalhardware/dhmanagement/list')
			.otherwise('/dashboard');

		$stateProvider
			.state('digitalhardware.dhmanagement', {
				url: '/dhmanagement',
				title: 'Digital Hardware',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			})
			.state('digitalhardware.dhmanagement.list', {
				url: '/list',
				templateUrl: 'app/pages/digitalhardware/dhmanagement/dhmgmtList.html',
				title: 'Digital Hardware Management',
				pageTitle: 'Digital Hardware Management',
				parentPath: 'Digital Hardware',
				controller: 'DigitalHardwareMgmtMainCtrl',
				controllerAs: 'vm'
			})
			.state('digitalhardware.dhmanagement.create', {
				url: '/create',
				templateUrl: "app/pages/digitalhardware/dhmanagement/dhmgmtCreate.html",
				title: 'Create',
				pageTitle: 'Create Digital Hardware',
				parentPath: 'Digital Hardware Management',
				controller: 'DigitalHardwareMgmtCreateCtrl',
				controllerAs: 'vm'
			})
			.state('digitalhardware.dhmanagement.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/digitalhardware/dhmanagement/dhmgmtUpdate.html',
				title: 'Update',
				pageTitle: 'Update Digital Hardware',
				parentPath: 'Digital Hardware Management',
				controller: 'DigitalHardwareMgmtUpdateCtrl',
				controllerAs: 'vm'
			});
  }

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.durianops.collectdurian', [
			'RmsAppV2.pages.durianops.collectdurian.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/durianops/collectdurian', '/durianops/collectdurian/create')
			.when('/durianops/collectdurian/', '/durianops/collectdurian/create')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('durianops.collectdurian', {
				url: '/collectdurian',
				title: 'Collect Durian',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('durianops.collectdurian.create', {
				url: '/create',
				templateUrl: 'app/pages/durianops/collectdurian/collectdurian.html',
				title: 'Collect Durian',
				pageTitle: 'Collect Durian',
				parentPath: 'Durian Ops',
				controller: 'DurianOpsCollectDurianCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.digitalhardware.dhsettings', [
			'RmsAppV2.pages.digitalhardware.dhsettings.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/digitalhardware/dhsettings', '/digitalhardware/dhsettings/list')
			.when('/digitalhardware/dhsettings/', '/digitalhardware/dhsettings/list')
			.otherwise('/dashboard');

		$stateProvider
			.state('digitalhardware.dhsettings', {
				url: '/dhsettings',
				title: 'Digital Hardware',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			})
			.state('digitalhardware.dhsettings.list', {
				url: '/list',
				templateUrl: 'app/pages/digitalhardware/dhsettings/dhsettingList.html',
				title: 'Digital Hardware Settings',
				pageTitle: 'Digital Hardware Settings',
				parentPath: 'Digital Hardware',
				controller: 'DigitalHardwareSettingMainCtrl',
				controllerAs: 'vm'
			})
			.state('digitalhardware.dhsettings.create', {
				url: '/create',
				templateUrl: "app/pages/digitalhardware/dhsettings/dhsettingCreate.html",
				title: 'Create',
				pageTitle: 'Create Setting',
				parentPath: 'Digital Hardware Settings',
				controller: 'DigitalHardwareSettingCreateCtrl',
				controllerAs: 'vm'
			})
			.state('digitalhardware.dhsettings.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/digitalhardware/dhsettings/dhsettingUpdate.html',
				title: 'Update',
				pageTitle: 'Update Setting',
				parentPath: 'Digital Hardware Settings',
				controller: 'DigitalHardwareSettingUpdateCtrl',
				controllerAs: 'vm'
			});
  }

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.durianops.processpulps', [
			'RmsAppV2.pages.durianops.processpulps.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/durianops/processpulps', '/durianops/processpulps/create')
			.when('/durianops/processpulps/', '/durianops/processpulps/create')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('durianops.processpulps', {
				url: '/processpulps',
				title: 'Process Pulps',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('durianops.processpulps.create', {
				url: '/create',
				templateUrl: 'app/pages/durianops/processpulps/processpulps.html',
				title: 'Process Pulps',
				pageTitle: 'Process Pulps',
				parentPath: 'Durian Ops',
				controller: 'DurianOpsProcessPulpsCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.durianops.durianinventory', [
			'RmsAppV2.pages.durianops.durianinventory.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/durianops/durianinventory', '/durianops/durianinventory/list')
			.when('/durianops/durianinventory/', '/durianops/durianinventory/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('durianops.durianinventory', {
				url: '/durianinventory',
				title: 'Inventory',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 40,
				},
			})
			.state('durianops.durianinventory.list', {
				url: '/list',
				templateUrl: 'app/pages/durianops/durianinventory/durianinventory.html',
				title: 'Inventory',
				pageTitle: 'Inventory',
				parentPath: 'Durian Ops',
				controller: 'DurianOpsDurianInventoryCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.billing.invoices', [
			'RmsAppV2.pages.billing.invoices.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/billing/invoices', '/billing/invoices/list')
			.when('/billing/invoices/', '/billing/invoices/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('billing.invoices', {
				url: '/invoices',
				title: 'Invoices',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('billing.invoices.list', {
				url: '/list',
				templateUrl: 'app/pages/billing/invoices/invoiceList.html',
				title: 'Invoices',
				pageTitle: 'Invoices',
				parentPath: 'Billing',
				controller: 'BillingInvoicesMainCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.durianops.producepuree', [
			'RmsAppV2.pages.durianops.producepuree.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/durianops/producepuree', '/durianops/producepuree/create')
			.when('/durianops/producepuree/', '/durianops/producepuree/create')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('durianops.producepuree', {
				url: '/producepuree',
				title: 'Produce Puree',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('durianops.producepuree.create', {
				url: '/create',
				templateUrl: 'app/pages/durianops/producepuree/producepuree.html',
				title: 'Produce Puree',
				pageTitle: 'Produce Puree',
				parentPath: 'Durian Ops',
				controller: 'DurianOpsProducePureeCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.billing.addons', [
			'RmsAppV2.pages.billing.addons.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/billing/addons', '/billing/addons/list')
			.when('/billing/addons/', '/billing/addons/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('billing.addons', {
				url: '/addons',
				title: 'Storage Add-Ons',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('billing.addons.list', {
				url: '/list',
				templateUrl: 'app/pages/billing/addons/addOnList.html',
				title: 'Storage Add-Ons',
				pageTitle: 'Storage Add-Ons',
				parentPath: 'Billing',
				controller: 'BillingAddOnMainCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.billing.subscriptions', [
			'RmsAppV2.pages.billing.subscriptions.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/billing/subscriptions', '/billing/subscriptions/list')
			.when('/billing/subscriptions/', '/billing/subscriptions/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('billing.subscriptions', {
				url: '/subscriptions',
				title: 'Subscription Plans',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('billing.subscriptions.list', {
				url: '/list',
				templateUrl: 'app/pages/billing/subscriptions/subscriptionList.html',
				title: 'Subscription Plans',
				pageTitle: 'Subscription Plans',
				parentPath: 'Billing',
				controller: 'BillingSubscriptionMainCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.franchise.franchiseemgmt', [
			'RmsAppV2.pages.franchise.franchiseemgmt.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/franchise/franchiseemgmt', '/franchise/franchiseemgmt/list')
			.when('/franchise/franchiseemgmt/', '/franchise/franchiseemgmt/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('franchise.franchiseemgmt', {
				url: '/franchiseemgmt',
				title: 'Franchisee',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 80,
				},
			})
			.state('franchise.franchiseemgmt.list', {
				url: '/list',
				templateUrl: 'app/pages/franchise/franchiseemgmt/franchiseeList.html',
				title: 'Franchisees Management',
				pageTitle: 'Franchisees Management',
				parentPath: 'Franchise',
				controller: 'FranchiseeMgmtMainCtrl',
				controllerAs: 'vm'
			})
			.state('franchise.franchiseemgmt.create', {
				url: '/create',
				templateUrl: "app/pages/franchise/franchiseemgmt/franchiseeCreate.html",
				title: 'Create Franchisee',
				pageTitle: 'Create Franchisee',
				parentPath: 'Franchise',
				controller: 'FranchiseeMgmtCreateCtrl',
				controllerAs: 'vm'
			})
			.state('franchise.franchiseemgmt.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/franchise/franchiseemgmt/franchiseeUpdate.html',
				title: 'Update Franchisee',
				pageTitle: 'Update Franchisee',
				parentPath: 'Franchise',
				controller: 'FranchiseeMgmtUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.inventory.inventorydashboard', [
			'RmsAppV2.pages.inventory.inventorydashboard.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/inventory/inventorydashboard', '/inventory/inventorydashboard/list')
			.when('/inventory/inventorydashboard/', '/inventory/inventorydashboard/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('inventory.inventorydashboard', {
				url: '/inventorydashboard',
				title: 'Inventory Dashboard',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 1,
				},
			})
			.state('inventory.inventorydashboard.list', {
				url: '/list',
				templateUrl: 'app/pages/inventory/inventorydashboard/inventorydashboard.html',
				title: 'Inventory Dashboard',
				pageTitle: 'Inventory Dashboard',
				parentPath: 'INVENTORY',
				controller: 'InventoryDashboardCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.inventory.inventorylock', [
			'RmsAppV2.pages.inventory.inventorylock.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/inventory/inventorylock', '/inventory/inventorylock/list')
			.when('/inventory/inventorylock/', '/inventory/inventorylock/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('inventory.inventorylock', {
				url: '/inventorylock',
				title: 'Inventory - Storage Lock',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 12,
				},
			})
			.state('inventory.inventorylock.list', {
				url: '/list',
				templateUrl: 'app/pages/inventory/inventorylock/inventorylock.html',
				title: 'Inventory - Storage Lock',
				pageTitle: 'Inventory - Storage Lock',
				parentPath: 'INVENTORY',
				controller: 'InvInventoryLockCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.inventory.items', [
			'RmsAppV2.pages.inventory.items.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/inventory/items', '/inventory/items/list')
			.when('/inventory/items/', '/inventory/items/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('inventory.items', {
				url: '/items',
				title: 'Raw Materials',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('inventory.items.list', {
				url: '/list',
				templateUrl: 'app/pages/inventory/items/itemList.html',
				title: 'RAW_MAT_INVENTORY',
				pageTitle: 'RAW_MAT_INVENTORY',
				parentPath: 'INVENTORY',
				controller: 'InvItemMainCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.items.stockin', {
				url: '/stockin',
				templateUrl: 'app/pages/inventory/items/itemStockIn.html',
				title: 'RAW_MAT_STOCK_IN',
				pageTitle: 'RAW_MAT_STOCK_IN',
				parentPath: 'INVENTORY',
				controller: 'InvItemStockInCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.items.stockout', {
				url: '/stockout',
				templateUrl: 'app/pages/inventory/items/itemStockOut.html',
				title: 'RAW_MAT_STOCK_OUT',
				pageTitle: 'RAW_MAT_STOCK_OUT',
				parentPath: 'INVENTORY',
				controller: 'InvItemStockOutCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.items.stockadjustment', {
				url: '/stockadjustment',
				templateUrl: 'app/pages/inventory/items/itemAdjustment.html',
				title: 'RAW_MAT_STOCK_ADJ',
				pageTitle: 'RAW_MAT_STOCK_ADJ',
				parentPath: 'INVENTORY',
				controller: 'InvItemStockAdjCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.items.stocktransfer', {
				url: '/stocktransfer',
				templateUrl: 'app/pages/inventory/items/itemTransfer.html',
				title: 'Raw Materials / Stock Transfer',
				pageTitle: 'Raw Materials Inventory - Stock Transfer',
				parentPath: 'INVENTORY',
				controller: 'InvItemStockTransferCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.inventory.itemreturns', [
			'RmsAppV2.pages.inventory.itemreturns.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/inventory/itemreturns', '/inventory/itemreturns/list')
			.when('/inventory/itemreturns/', '/inventory/itemreturns/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('inventory.itemreturns', {
				url: '/itemreturns',
				title: 'Raw Material Returns',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 12,
				},
			})
			.state('inventory.itemreturns.list', {
				url: '/list',
				templateUrl: 'app/pages/inventory/itemreturns/itemreturnList.html',
				title: 'Raw Material Return List',
				pageTitle: 'Raw Material Return List',
				parentPath: 'Raw Material Returns',
				controller: 'InvItemReturnMainCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.itemreturns.create', {
				url: '/create',
				templateUrl: "app/pages/inventory/itemreturns/itemreturnCreate.html",
				title: 'Create Raw Material Return',
				pageTitle: 'Create Raw Material Return',
				parentPath: 'Raw Material Returns',
				controller: 'InvItemReturnCreateCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.itemreturns.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/inventory/itemreturns/itemreturnUpdate.html',
				title: 'Update Raw Material Return',
				pageTitle: 'Update Raw Material Return',
				parentPath: 'Raw Material Returns',
				controller: 'InvItemReturnUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.inventory.itemstockcounts', [
			'RmsAppV2.pages.inventory.itemstockcounts.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/inventory/itemstockcounts', '/inventory/itemstockcounts/list')
			.when('/inventory/itemstockcounts/', '/inventory/itemstockcounts/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('inventory.itemstockcounts', {
				url: '/itemstockcounts',
				title: 'Raw Material Stock Count',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 12,
				},
			})
			.state('inventory.itemstockcounts.list', {
				url: '/list',
				templateUrl: 'app/pages/inventory/itemstockcounts/itemstockcountList.html',
				title: 'Raw Material Stock Count List',
				pageTitle: 'Raw Material Stock Count List',
				parentPath: 'INVENTORY',
				controller: 'InvItemStockCountMainCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.itemstockcounts.create', {
				url: '/create',
				templateUrl: "app/pages/inventory/itemstockcounts/itemstockcountCreate.html",
				title: 'Raw Material Stock Count Create',
				pageTitle: 'Create Stock Count',
				parentPath: 'INVENTORY',
				controller: 'InvItemStockCountCreateCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.itemstockcounts.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/inventory/itemstockcounts/itemstockcountUpdate.html',
				title: 'Raw Material Stock Count Update',
				pageTitle: 'Update Stock Count',
				parentPath: 'INVENTORY',
				controller: 'InvItemStockCountUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.inventory.productstockcounts', [
			'RmsAppV2.pages.inventory.productstockcounts.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/inventory/productstockcounts', '/inventory/productstockcounts/list')
			.when('/inventory/productstockcounts/', '/inventory/productstockcounts/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('inventory.productstockcounts', {
				url: '/productstockcounts',
				title: 'Finished Goods Stock Count',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 33,
				},
			})
			.state('inventory.productstockcounts.list', {
				url: '/list',
				templateUrl: 'app/pages/inventory/productstockcounts/productstockcountList.html',
				title: 'Finished Goods Stock Count List',
				pageTitle: 'Finished Goods Stock Count List',
				parentPath: 'INVENTORY',
				controller: 'InvProductStockCountMainCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.productstockcounts.create', {
				url: '/create',
				templateUrl: "app/pages/inventory/productstockcounts/productstockcountCreate.html",
				title: 'Finished Goods Stock Count Create',
				pageTitle: 'Create Stock Count',
				parentPath: 'INVENTORY',
				controller: 'InvProductStockCountCreateCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.productstockcounts.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/inventory/productstockcounts/productstockcountUpdate.html',
				title: 'Finished Goods Stock Count Update',
				pageTitle: 'Update Stock Count',
				parentPath: 'INVENTORY',
				controller: 'InvProductStockCountUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.inventory.products', [
			'RmsAppV2.pages.inventory.products.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/inventory/products', '/inventory/products/list')
			.when('/inventory/products/', '/inventory/products/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('inventory.products', {
				url: '/products',
				title: 'Finished Goods',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('inventory.products.list', {
				url: '/list',
				templateUrl: 'app/pages/inventory/products/productList.html',
				title: 'FG_INVENTORY',
				pageTitle: 'FG_INVENTORY',
				parentPath: 'INVENTORY',
				controller: 'InvProductMainCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.products.stockin', {
				url: '/stockin',
				templateUrl: 'app/pages/inventory/products/productStockIn.html',
				title: 'FG_STOCK_IN',
				pageTitle: 'FG_STOCK_IN',
				parentPath: 'INVENTORY',
				controller: 'InvProductStockInCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.products.stockout', {
				url: '/stockout',
				templateUrl: 'app/pages/inventory/products/productStockOut.html',
				title: 'FG_STOCK_OUT',
				pageTitle: 'FG_STOCK_OUT',
				parentPath: 'INVENTORY',
				controller: 'InvProductStockOutCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.products.stockadjustment', {
				url: '/stockadjustment',
				templateUrl: 'app/pages/inventory/items/itemAdjustment.html',
				title: 'FG_STOCK_ADJ',
				pageTitle: 'FG_STOCK_ADJ',
				parentPath: 'INVENTORY',
				controller: 'InvProductStockAdjCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.products.stocktransfer', {
				url: '/stocktransfer',
				templateUrl: 'app/pages/inventory/products/productTransfer.html',
				title: 'Finished Goods / Stock Transfer',
				pageTitle: 'Finished Goods Inventory - Stock Transfer',
				parentPath: 'INVENTORY',
				controller: 'InvProductStockTransferCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.inventory.semifgs', [
			'RmsAppV2.pages.inventory.semifgs.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/inventory/semifgs', '/inventory/semifgs/list')
			.when('/inventory/semifgs/', '/inventory/semifgs/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('inventory.semifgs', {
				url: '/semifgs',
				title: 'Semi Finished Goods',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('inventory.semifgs.list', {
				url: '/list',
				templateUrl: 'app/pages/inventory/semifgs/sfgList.html',
				title: 'SEMIFG_INVENTORY',
				pageTitle: 'SEMIFG_INVENTORY',
				parentPath: 'INVENTORY',
				controller: 'InvSfgMainCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.semifgs.stockin', {
				url: '/stockin',
				templateUrl: 'app/pages/inventory/semifgs/sfgStockIn.html',
				title: 'SEMIFG_STOCK_IN',
				pageTitle: 'SEMIFG_STOCK_IN',
				parentPath: 'INVENTORY',
				controller: 'InvSfgStockInCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.semifgs.stockout', {
				url: '/stockout',
				templateUrl: 'app/pages/inventory/semifgs/sfgStockOut.html',
				title: 'SEMIFG_STOCK_OUT',
				pageTitle: 'SEMIFG_STOCK_OUT',
				parentPath: 'INVENTORY',
				controller: 'InvSfgStockOutCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.semifgs.stockadjustment', {
				url: '/stockadjustment',
				templateUrl: 'app/pages/inventory/items/itemAdjustment.html',
				title: 'SEMIFG_STOCK_ADJ',
				pageTitle: 'SEMIFG_STOCK_ADJ',
				parentPath: 'INVENTORY',
				controller: 'InvSfgStockAdjCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.semifgs.stocktransfer', {
				url: '/stocktransfer',
				templateUrl: 'app/pages/inventory/semifgs/sfgTransfer.html',
				title: 'Semi Finished Goods / Stock Transfer',
				pageTitle: 'Semi Finished Goods Inventory - Stock Transfer',
				parentPath: 'INVENTORY',
				controller: 'InvSfgStockTransferCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.inventory.semifgstockcounts', [
			'RmsAppV2.pages.inventory.semifgstockcounts.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/inventory/semifgstockcounts', '/inventory/semifgstockcounts/list')
			.when('/inventory/semifgstockcounts/', '/inventory/semifgstockcounts/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('inventory.semifgstockcounts', {
				url: '/semifgstockcounts',
				title: 'Semi F.G. Stock Count',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 23,
				},
			})
			.state('inventory.semifgstockcounts.list', {
				url: '/list',
				templateUrl: 'app/pages/inventory/semifgstockcounts/semifgstockcountList.html',
				title: 'Semi F.G. Stock Count List',
				pageTitle: 'Semi F.G. Stock Count List',
				parentPath: 'INVENTORY',
				controller: 'InvSemiFgStockCountMainCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.semifgstockcounts.create', {
				url: '/create',
				templateUrl: "app/pages/inventory/semifgstockcounts/semifgstockcountCreate.html",
				title: 'Semi F.G. Stock Count Create',
				pageTitle: 'Create Stock Count',
				parentPath: 'INVENTORY',
				controller: 'InvSemiFgStockCountCreateCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.semifgstockcounts.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/inventory/semifgstockcounts/semifgstockcountUpdate.html',
				title: 'Semi F.G. Stock Count Update',
				pageTitle: 'Update Stock Count',
				parentPath: 'INVENTORY',
				controller: 'InvSemiFgStockCountUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.inventory.stockreturns', [
			'RmsAppV2.pages.inventory.stockreturns.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/inventory/stockreturns', '/inventory/stockreturns/list')
			.when('/inventory/stockreturns/', '/inventory/stockreturns/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('inventory.stockreturns', {
				url: '/stockreturns',
				title: 'Stock Returns',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 70,
				},
			})
			.state('inventory.stockreturns.list', {
				url: '/list',
				templateUrl: 'app/pages/inventory/stockreturns/stockreturnList.html',
				title: 'Stock Returns',
				pageTitle: 'Stock Returns',
				parentPath: 'INVENTORY',
				controller: 'StockReturnMainCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.stockreturns.create', {
				url: '/create',
				templateUrl: "app/pages/inventory/stockreturns/stockreturnCreate.html",
				title: 'Create Stock Return',
				pageTitle: 'Create Stock Return',
				parentPath: 'INVENTORY',
				controller: 'StockReturnCreateCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.stockreturns.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/inventory/stockreturns/stockreturnUpdate.html',
				title: 'Update Stock Return',
				pageTitle: 'Update Stock Return',
				parentPath: 'INVENTORY',
				controller: 'StockReturnUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.inventory.stocktransfers', [
			'RmsAppV2.pages.inventory.stocktransfers.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/inventory/stocktransfers', '/inventory/stocktransfers/list')
			.when('/inventory/stocktransfers/', '/inventory/stocktransfers/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('inventory.stocktransfers', {
				url: '/stocktransfers',
				title: 'Stock Transfers',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 70,
				},
			})
			.state('inventory.stocktransfers.list', {
				url: '/list',
				templateUrl: 'app/pages/inventory/stocktransfers/stocktransferList.html',
				title: 'Stock Transfers',
				pageTitle: 'Stock Transfers',
				parentPath: 'INVENTORY',
				controller: 'StockTransferMainCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.stocktransfers.create', {
				url: '/create',
				templateUrl: "app/pages/inventory/stocktransfers/stocktransferCreate.html",
				title: 'Create Stock Transfer',
				pageTitle: 'Create Stock Transfer',
				parentPath: 'INVENTORY',
				controller: 'StockTransferCreateCtrl',
				controllerAs: 'vm'
			})
			.state('inventory.stocktransfers.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/inventory/stocktransfers/stocktransferUpdate.html',
				title: 'Update Stock Transfer',
				pageTitle: 'Update Stock Transfer',
				parentPath: 'INVENTORY',
				controller: 'StockTransferUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotadmin.iotregdevices', [
			'RmsAppV2.pages.iotadmin.iotregdevices.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/iotadmin/iotregdevices', '/iotadmin/iotregdevices/list')
			.when('/iotadmin/iotregdevices/', '/iotadmin/iotregdevices/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('iotadmin.iotregdevices', {
				url: '/iotregdevices',
				title: 'IoT Registered Devices',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('iotadmin.iotregdevices.list', {
				url: '/list',
				templateUrl: 'app/pages/iotadmin/iotregdevices/iotRegDeviceList.html',
				title: 'IoT Registered Devices',
				pageTitle: 'IoT Registered Devices',
				parentPath: 'IoT Admin',
				controller: 'IoTAdminDeviceMainCtrl',
				controllerAs: 'vm'
			})
			.state('iotadmin.iotregdevices.create', {
				url: '/create',
				templateUrl: "app/pages/iotadmin/iotregdevices/iotRegDeviceCreate.html",
				title: 'Create IoT Device',
				pageTitle: 'Create IoT Device',
				parentPath: 'IoT Admin',
				controller: 'IotAdminDeviceCreateCtrl',
				controllerAs: 'vm'
			})
			.state('iotadmin.iotregdevices.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/iotadmin/iotregdevices/iotRegDeviceUpdate.html',
				title: 'Update IoT Device',
				pageTitle: 'Update IoT Device',
				parentPath: 'IoT Admin',
				controller: 'IoTAdminDeviceUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotsettings.gateways', [
			'RmsAppV2.pages.iotsettings.gateways.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/iotsettings/gateways', '/iotsettings/gateways/list')
			.when('/iotsettings/gateways/', '/iotsettings/gateways/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('iotsettings.gateways', {
				url: '/gateways',
				title: 'Gateways',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('iotsettings.gateways.list', {
				url: '/list',
				templateUrl: 'app/pages/iotsettings/gateways/gatewayList.html',
				title: 'Gateways',
				pageTitle: 'Gateways',
				parentPath: 'IoT Settings',
				controller: 'IoTGatewayMainCtrl',
				controllerAs: 'vm'
			})
			.state('iotsettings.gateways.create', {
				url: '/create',
				templateUrl: "app/pages/iotsettings/gateways/gatewayCreate.html",
				title: 'Create Gateway',
				pageTitle: 'Create Gateway',
				parentPath: 'IoT Settings',
				controller: 'IoTGatewayCreateCtrl',
				controllerAs: 'vm'
			})
			.state('iotsettings.gateways.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/iotsettings/gateways/gatewayUpdate.html',
				title: 'Update Gateway',
				pageTitle: 'Update Gateway',
				parentPath: 'IoT Settings',
				controller: 'IoTGatewayUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotsettings.handhelds', [
			'RmsAppV2.pages.iotsettings.handhelds.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/iotsettings/handhelds', '/iotsettings/handhelds/list')
			.when('/iotsettings/handhelds/', '/iotsettings/handhelds/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('iotsettings.handhelds', {
				url: '/handhelds',
				title: 'Handhelds',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('iotsettings.handhelds.list', {
				url: '/list',
				templateUrl: 'app/pages/iotsettings/handhelds/handheldList.html',
				title: 'Handhelds',
				pageTitle: 'Handhelds',
				parentPath: 'IoT Settings',
				controller: 'IoTHandheldMainCtrl',
				controllerAs: 'vm'
			})
			.state('iotsettings.handhelds.create', {
				url: '/create',
				templateUrl: "app/pages/iotsettings/handhelds/handheldCreate.html",
				title: 'Create Handheld',
				pageTitle: 'Create Handheld',
				parentPath: 'IoT Settings',
				controller: 'IoTHandheldCreateCtrl',
				controllerAs: 'vm'
			})
			.state('iotsettings.handhelds.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/iotsettings/handhelds/handheldUpdate.html',
				title: 'Update Handheld',
				pageTitle: 'Update Handheld',
				parentPath: 'IoT Settings',
				controller: 'IoTHandheldUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotsettings.floorviewdesigner', [
			'RmsAppV2.pages.iotsettings.floorviewdesigner.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/iotsettings/floorviewdesigner', '/iotsettings/floorviewdesigner/list')
			.when('/iotsettings/floorviewdesigner/', '/iotsettings/floorviewdesigner/list')
			.otherwise('/floorviewdesigner');
			
		$stateProvider
			.state('iotsettings.floorviewdesigner', {
				url: '/floorviewdesigner',
				title: 'IoT Floor View Designer',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('iotsettings.floorviewdesigner.list', {
				url: '/list',
				templateUrl: 'app/pages/iotsettings/floorviewdesigner/floorviewdesignerList.html',
				title: 'floorviewdesigner',
				pageTitle: 'IoT Floor View Designer',
				parentPath: 'IoT Floor View Designer',
				controller: 'IoTFloorViewDesignerMainCtrl',
				controllerAs: 'vm'
			})
			.state('iotsettings.floorviewdesigner.create', {
				url: '/create',
				templateUrl: "app/pages/iotsettings/floorviewdesigner/floorviewdesignerCreate.html",
				title: 'Create Floor View Design',
				pageTitle: 'Create Floor View Design',
				parentPath: 'IoT Floor View Designer',
				controller: 'IoTFloorViewDesignerCreateCtrl',
				controllerAs: 'vm'
			})
			.state('iotsettings.floorviewdesigner.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/iotsettings/floorviewdesigner/floorviewdesignerUpdate.html',
				title: 'Update Floor View Design',
				pageTitle: 'Update Floor View Design',
				parentPath: 'IoT Floor View Designer',
				controller: 'IoTFloorViewDesignerUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotsettings.settings', [
			'RmsAppV2.pages.iotsettings.settings.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/iotsettings/settings', '/iotsettings/settings/list')
			.when('/iotsettings/settings/', '/iotsettings/settings/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('iotsettings.settings', {
				url: '/settings',
				title: 'Notification Settings',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('iotsettings.settings.list', {
				url: '/list',
				templateUrl: 'app/pages/iotsettings/settings/settingList.html',
				title: 'IoT Notification Settings',
				pageTitle: 'IoT Notification Settings',
				parentPath: 'IoT Settings',
				controller: 'IoTSettingMainCtrl',
				controllerAs: 'vm'
			})
			.state('iotsettings.settings.create', {
				url: '/create',
				templateUrl: "app/pages/iotsettings/settings/settingCreate.html",
				title: 'Create Notification Setting',
				pageTitle: 'Create Notification Setting',
				parentPath: 'IoT Settings',
				controller: 'IoTSettingCreateCtrl',
				controllerAs: 'vm'
			})
			.state('iotsettings.settings.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/iotsettings/settings/settingUpdate.html',
				title: 'Update Notification Setting',
				pageTitle: 'Update Notification Setting',
				parentPath: 'IoT Settings',
				controller: 'IoTSettingUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.jobs.jobanalysisfg', [
			'RmsAppV2.pages.jobs.jobanalysisfg.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/jobs/jobanalysisfg', '/jobs/jobanalysisfg/list')
			.when('/jobs/jobanalysisfg/', '/jobs/jobanalysisfg/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('jobs.jobanalysisfg', {
				url: '/jobanalysisfg',
				title: 'PRODUCTION_ANALYSIS_(F.G.)',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('jobs.jobanalysisfg.list', {
				url: '/list',
				templateUrl: 'app/pages/jobs/jobanalysisfg/jobanalysisfgList.html',
				title: 'PRODUCTION_ANALYSIS_(F.G.)',
				pageTitle: 'PRODUCTION_ANALYSIS_(F.G.)',
				parentPath: 'PRODUCTIONS',
				controller: 'JobAnalysisFGMainCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotsettings.sensors', [
			'RmsAppV2.pages.iotsettings.sensors.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/iotsettings/sensors', '/iotsettings/sensors/list')
			.when('/iotsettings/sensors/', '/iotsettings/sensors/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('iotsettings.sensors', {
				url: '/sensors',
				title: 'Sensors',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('iotsettings.sensors.list', {
				url: '/list',
				templateUrl: 'app/pages/iotsettings/sensors/sensorList.html',
				title: 'Sensors',
				pageTitle: 'Sensors',
				parentPath: 'IoT Settings',
				controller: 'IoTSensorMainCtrl',
				controllerAs: 'vm'
			})
			.state('iotsettings.sensors.create', {
				url: '/create',
				templateUrl: "app/pages/iotsettings/sensors/sensorCreate.html",
				title: 'Create Sensor',
				pageTitle: 'Create Sensor',
				parentPath: 'IoT Settings',
				controller: 'IoTSensorCreateCtrl',
				controllerAs: 'vm'
			})
			.state('iotsettings.sensors.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/iotsettings/sensors/sensorUpdate.html',
				title: 'Update Sensor',
				pageTitle: 'Update Sensor',
				parentPath: 'IoT Settings',
				controller: 'IoTSensorUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.jobs.jobanalysissemifg', [
			'RmsAppV2.pages.jobs.jobanalysissemifg.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/jobs/jobanalysissemifg', '/jobs/jobanalysissemifg/list')
			.when('/jobs/jobanalysissemifg/', '/jobs/jobanalysissemifg/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('jobs.jobanalysissemifg', {
				url: '/jobanalysissemifg',
				title: 'PRODUCTION_ANALYSIS_(SEMI_F.G.)',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('jobs.jobanalysissemifg.list', {
				url: '/list',
				templateUrl: 'app/pages/jobs/jobanalysissemifg/jobanalysissemifgList.html',
				title: 'PRODUCTION_ANALYSIS_(SEMI_F.G.)',
				pageTitle: 'PRODUCTION_ANALYSIS_(SEMI_F.G.)',
				parentPath: 'PRODUCTIONS',
				controller: 'JobAnalysisSFGMainCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.jobs.jobdashboard', [
			'RmsAppV2.pages.jobs.jobdashboard.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/jobs/jobdashboard', '/jobs/jobdashboard/list')
			.when('/jobs/jobdashboard/', '/jobs/jobdashboard/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('jobs.jobdashboard', {
				url: '/jobdashboard',
				title: 'Production Dashboard',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('jobs.jobdashboard.list', {
				url: '/list',
				templateUrl: 'app/pages/jobs/jobdashboard/jobdashboard.html',
				title: 'PRODUCTION_DASHBOARD',
				pageTitle: 'PRODUCTION_DASHBOARD',
				parentPath: 'PRODUCTIONS',
				controller: 'JobDashboardMainCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.jobs.joblist', [
			'RmsAppV2.pages.jobs.joblist.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/jobs/joblist', '/jobs/joblist/list')
			.when('/jobs/joblist/', '/jobs/joblist/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('jobs.joblist', {
				url: '/joblist',
				title: 'Production Listing',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 240,
				},
			})
			.state('jobs.joblist.list', {
				url: '/list',
				templateUrl: 'app/pages/jobs/joblist/joblistList.html',
				title: ' PRODUCTION_JOBS',
				pageTitle: 'PRODUCTION_JOBS',
				parentPath: 'PRODUCTIONS',
				controller: 'JobMainCtrl',
				controllerAs: 'vm'
			})
			.state('jobs.joblist.create', {
				url: '/create',
				templateUrl: "app/pages/jobs/joblist/joblistCreate.html",
				title: 'CREATE_PRODUCTION_JOB',
				pageTitle: 'CREATE_PRODUCTION_JOB',
				parentPath: 'PRODUCTIONS',
				controller: 'JobCreateCtrl',
				controllerAs: 'vm'
			})
			.state('jobs.joblist.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/jobs/joblist/joblistUpdate.html',
				title: 'UPDATE_PRODUCTION_JOB',
				pageTitle: 'UPDATE_PRODUCTION_JOB',
				parentPath: 'PRODUCTIONS',
				controller: 'JobUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.label.items', [
			'RmsAppV2.pages.label.items.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/label/items', '/label/items/print')
			.when('/label/items/', '/label/items/print')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('label.items', {
				url: '/items',
				title: 'Raw Materials',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('label.itemadjustment', {
				url: '/itemadjustment',
				templateUrl: "app/pages/label/items/itemAdjustment.html",
				title: 'RAWMAT_LABEL_ADJUSTMENT',
				pageTitle: 'RAWMAT_LABEL_ADJUSTMENT',
				parentPath: 'LABELS',
				controller: 'ItemLabelAdjustmentCtrl',
				controllerAs: 'vm'
			})
			.state('label.items.print', {
				url: '/print',
				templateUrl: "app/pages/label/items/itemCreate.html",
				title: 'PRINT_RAW_MAT_LABELS',
				pageTitle: 'PRINT_RAW_MAT_LABELS',
				parentPath: 'LABELS',
				controller: 'ItemLabelPrintCtrl',
				controllerAs: 'vm'
			})
			.state('label.items.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/label/items/itemImport.html',
				title: 'IMPORT_RAW_MAT_OPEN_BAL',
				pageTitle: 'IMPORT_RAW_MAT_OPEN_BAL',
				parentPath: 'LABELS',
				controller: 'ItemLabelImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.label.semifgs', [
			'RmsAppV2.pages.label.semifgs.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/label/semifgs', '/label/semifgs/print')
			.when('/label/semifgs/', '/label/semifgs/print')
			.otherwise('/dashboard');

		$stateProvider
			.state('label.semifgs', {
				url: '/semifgs',
				title: 'Semi Finished Goods',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('label.semifgadjustment', {
				url: '/semifgadjustment',
				templateUrl: "app/pages/label/semifgs/semifgAdjustment.html",
				title: 'SEMIFG_LABEL_ADJUSTMENT',
				pageTitle: 'SEMIFG_LABEL_ADJUSTMENT',
				parentPath: 'LABELS',
				controller: 'SemiFGLabelAdjustmentCtrl',
				controllerAs: 'vm'
			})
			.state('label.semifgs.print', {
                url: '/print?jobNo',
				templateUrl: "app/pages/label/semifgs/semifgCreate.html",
				title: 'PRINT_SEMIFG_LABELS',
				pageTitle: 'PRINT_SEMIFG_LABELS',
				parentPath: 'LABELS',
				controller: 'SemiFGLabelPrintCtrl',
				controllerAs: 'vm'
			})
			.state('label.semifgs.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/label/semifgs/semifgImport.html',
				title: 'IMPORT_SEMIFG_OPEN_BAL',
				pageTitle: 'IMPORT_SEMIFG_OPEN_BAL',
				parentPath: 'LABELS',
				controller: 'SemiFGLabelImportCtrl',
				controllerAs: 'vm'
			});
	}

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.bulkbreakconfig', [
			'RmsAppV2.pages.maintenance.bulkbreakconfig.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/bulkbreakconfig', '/maintenance/bulkbreakconfig/list')
			.when('/maintenance/bulkbreakconfig/', '/maintenance/bulkbreakconfig/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.bulkbreakconfig', {
				url: '/bulkbreakconfig',
				title: 'Bulk Break Configuration',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 70,
				},
			})
			.state('maintenance.bulkbreakconfig.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/bulkbreakconfig/bulkbreakconfigList.html',
				title: 'BULK_BREAK_CONFIGURATION',
				pageTitle: 'BULK_BREAK_CONFIGURATION',
				parentPath: 'MAINTENANCE',
				controller: 'BulkBreakConfigMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.bulkbreakconfig.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/bulkbreakconfig/bulkbreakconfigCreate.html",
				title: 'CREATE_BULK_BREAK_CONFIGURATION',
				pageTitle: 'CREATE_BULK_BREAK_CONFIGURATION',
				parentPath: 'MAINTENANCE',
				controller: 'BulkBreakConfigCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.bulkbreakconfig.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/bulkbreakconfig/bulkbreakconfigUpdate.html',
				title: 'UPDATE_BULK_BREAK_CONFIGURATION',
				pageTitle: 'UPDATE_BULK_BREAK_CONFIGURATION',
				parentPath: 'MAINTENANCE',
				controller: 'BulkBreakConfigUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.label.products', [
			'RmsAppV2.pages.label.products.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/label/products', '/label/products/print')
			.when('/label/products/', '/label/products/print')
			.otherwise('/dashboard');

		$stateProvider
			.state('label.products', {
				url: '/products',
				title: 'Finished Goods',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('label.productadjustment', {
				url: '/productadjustment',
				templateUrl: "app/pages/label/products/productAdjustment.html",
				title: 'FG_LABEL_ADJUSTMENT',
				pageTitle: 'FG_LABEL_ADJUSTMENT',
				parentPath: 'LABELS',
				controller: 'ProductLabelAdjustmentCtrl',
				controllerAs: 'vm'
			})
			.state('label.products.print', {
                url: '/print?jobNo',
				templateUrl: "app/pages/label/products/productCreate.html",
				title: 'PRINT_FG_LABELS',
				pageTitle: 'PRINT_FG_LABELS',
				parentPath: 'LABELS',
				controller: 'ProductLabelPrintCtrl',
				controllerAs: 'vm'
			})
			.state('label.products.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/label/products/productImport.html',
				title: 'IMPORT_FG_OPEN_BAL',
				pageTitle: 'IMPORT_FG_OPEN_BAL',
				parentPath: 'LABELS',
				controller: 'ProductLabelImportCtrl',
				controllerAs: 'vm'
			});
	}

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.debtorcategories', [
			'RmsAppV2.pages.maintenance.debtorcategories.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/debtorcategories', '/maintenance/debtorcategories/list')
			.when('/maintenance/debtorcategories/', '/maintenance/debtorcategories/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.debtorcategories', {
				url: '/debtorcategories',
				title: 'Customer Categories',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 12,
				},
			})
			.state('maintenance.debtorcategories.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/debtorcategories/debtorcategoryList.html',
				title: 'CUSTOMER_CATEGORIES',
				pageTitle: 'CUSTOMER_CATEGORIES',
				parentPath: 'MAINTENANCE',
				controller: 'DebtorCategoryMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.debtorcategories.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/debtorcategories/debtorcategoryCreate.html",
				title: 'CREATE_CUSTOMER_CATEGORY',
				pageTitle: 'CREATE_CUSTOMER_CATEGORY',
				parentPath: 'MAINTENANCE',
				controller: 'DebtorCategoryCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.debtorcategories.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/debtorcategories/debtorcategoryUpdate.html',
				title: 'UPDATE_CUSTOMER_CATEGORY',
				pageTitle: 'UPDATE_CUSTOMER_CATEGORY',
				parentPath: 'MAINTENANCE',
				controller: 'DebtorCategoryUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.debtors', [
			'RmsAppV2.pages.maintenance.debtors.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/debtors', '/maintenance/debtors/list')
			.when('/maintenance/debtors/', '/maintenance/debtors/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.debtors', {
				url: '/debtors',
				title: 'Customers',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('maintenance.debtors.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/debtors/debtorList.html',
				title: 'CUSTOMER_LIST',
				pageTitle: 'CUSTOMER_LIST',
				parentPath: 'MAINTENANCE',
				controller: 'DebtorsMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.debtors.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/debtors/debtorCreate.html",
				title: 'CREATE_CUSTOMER',
				pageTitle: 'CREATE_CUSTOMER',
				parentPath: 'MAINTENANCE',
				controller: 'DebtorsCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.debtors.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/debtors/debtorUpdate.html',
				title: 'UPDATE_CUSTOMER',
				pageTitle: 'UPDATE_CUSTOMER',
				parentPath: 'MAINTENANCE',
				controller: 'DebtorsUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.debtors.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/maintenance/debtors/debtorImport.html',
				title: 'IMPORT_CUSTOMERS',
				pageTitle: 'IMPORT_CUSTOMERS',
				parentPath: 'MAINTENANCE',
				controller: 'DebtorsImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.foodmenus', [
			'RmsAppV2.pages.maintenance.foodmenus.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/foodmenus', '/maintenance/foodmenus/list')
			.when('/maintenance/foodmenus/', '/maintenance/foodmenus/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.foodmenus', {
				url: '/foodmenus',
				title: 'Food Menus',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 70,
				},
			})
			.state('maintenance.foodmenus.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/foodmenus/foodmenuList.html',
				title: 'FOOD_MENUS',
				pageTitle: 'FOOD_MENUS',
				parentPath: 'MAINTENANCE',
				controller: 'FoodMenuMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.foodmenus.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/foodmenus/foodmenuCreate.html",
				title: 'CREATE_FOOD_MENU',
				pageTitle: 'CREATE_FOOD_MENU',
				parentPath: 'MAINTENANCE',
				controller: 'FoodMenuCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.foodmenus.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/foodmenus/foodmenuUpdate.html',
				title: 'UPDATE_FOOD_MENU',
				pageTitle: 'UPDATE_FOOD_MENU',
				parentPath: 'MAINTENANCE',
				controller: 'FoodMenuUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.intercompanyitemmappings', [
			'RmsAppV2.pages.maintenance.intercompanyitemmappings.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/intercompanyitemmappings', '/maintenance/intercompanyitemmappings/list')
			.when('/maintenance/intercompanyitemmappings/', '/maintenance/intercompanyitemmappings/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.intercompanyitemmappings', {
				url: '/intercompanyitemmappings',
				title: 'Inter-Company Item Mappings',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			})
			.state('maintenance.intercompanyitemmappings.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/intercompanyitemmappings/mappingList.html',
				title: 'Inter-Company Item Mappings',
				pageTitle: 'Inter-Company Item Mappings',
				parentPath: 'Maintenance',
				controller: 'InterCompanyItemMappingMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.intercompanyitemmappings.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/intercompanyitemmappings/mappingCreate.html",
				title: 'Create Item Mapping',
				pageTitle: 'Create Item Mapping',
				parentPath: 'Maintenance',
				controller: 'InterCompanyItemMappingCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.intercompanyitemmappings.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/intercompanyitemmappings/mappingUpdate.html',
				title: 'Update Item Mapping',
				pageTitle: 'Update Item Mapping',
				parentPath: 'Maintenance',
				controller: 'InterCompanyItemMappingUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.intercompanyitemmappings.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/maintenance/intercompanyitemmappings/mappingImport.html',
				title: 'Import Item Mapping',
				pageTitle: 'Import Item Mapping',
				parentPath: 'Maintenance',
				controller: 'InterCompanyItemMappingImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.items', [
			'RmsAppV2.pages.maintenance.items.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/items', '/maintenance/items/list')
			.when('/maintenance/items/', '/maintenance/items/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.items', {
				url: '/items',
				title: 'Raw Materials',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('maintenance.items.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/items/itemList.html',
				title: 'RAW_MATERIAL_LIST',
				pageTitle: 'RAW_MATERIAL_LIST',
				parentPath: 'MAINTENANCE',
				controller: 'ItemMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.items.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/items/itemCreate.html",
				title: 'CREATE_RAW_MATERIAL',
				pageTitle: 'CREATE_RAW_MATERIAL',
				parentPath: 'MAINTENANCE',
				controller: 'ItemCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.items.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/items/itemUpdate.html',
				title: 'UPDATE_RAW_MATERIAL',
				pageTitle: 'UPDATE_RAW_MATERIAL',
				parentPath: 'MAINTENANCE',
				controller: 'ItemUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.items.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/maintenance/items/itemImport.html',
				title: 'IMPORT_RAW_MATERIALS',
				pageTitle: 'IMPORT_RAW_MATERIALS',
				parentPath: 'MAINTENANCE',
				controller: 'ItemImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.multilevelapprovals', [
			'RmsAppV2.pages.maintenance.multilevelapprovals.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/multilevelapprovals', '/maintenance/multilevelapprovals/list')
			.when('/maintenance/multilevelapprovals/', '/maintenance/multilevelapprovals/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.multilevelapprovals', {
				url: '/multilevelapprovals',
				title: 'Approval Flows',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 80,
				},
			})
			.state('maintenance.multilevelapprovals.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/multilevelapprovals/mlaList.html',
				title: 'MULTI_LEVEL_APPROVALS',
				pageTitle: 'MULTI_LEVEL_APPROVALS',
				parentPath: 'MAINTENANCE',
				controller: 'MultiLevelApprovalsMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.multilevelapprovals.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/multilevelapprovals/mlaCreate.html",
				title: 'CREATE_APPROVAL_FLOW',
				pageTitle: 'CREATE_APPROVAL_FLOW',
				parentPath: 'MAINTENANCE',
				controller: 'MultiLevelApprovalsCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.multilevelapprovals.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/multilevelapprovals/mlaUpdate.html',
				title: 'UPDATE_APPROVAL_FLOW',
				pageTitle: 'UPDATE_APPROVAL_FLOW',
				parentPath: 'MAINTENANCE',
				controller: 'MultiLevelApprovalsUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.intercompanymappings', [
			'RmsAppV2.pages.maintenance.intercompanymappings.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/intercompanymappings', '/maintenance/intercompanymappings/list')
			.when('/maintenance/intercompanymappings/', '/maintenance/intercompanymappings/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.intercompanymappings', {
				url: '/intercompanymappings',
				title: 'Inter-Company Mappings',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			})
			.state('maintenance.intercompanymappings.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/intercompanymappings/mappingList.html',
				title: 'Inter-Company Mappings',
				pageTitle: 'Inter-Company Mappings',
				parentPath: 'Maintenance',
				controller: 'InterCompanyMappingMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.intercompanymappings.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/intercompanymappings/mappingCreate.html",
				title: 'Create Mapping',
				pageTitle: 'Create Mapping',
				parentPath: 'Maintenance',
				controller: 'InterCompanyMappingCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.intercompanymappings.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/intercompanymappings/mappingUpdate.html',
				title: 'Update Mapping',
				pageTitle: 'Update Mapping',
				parentPath: 'Maintenance',
				controller: 'InterCompanyMappingUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.intercompanymappings.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/maintenance/intercompanymappings/mappingImport.html',
				title: 'Import Mapping',
				pageTitle: 'Import Mapping',
				parentPath: 'Maintenance',
				controller: 'InterCompanyMappingImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.products', [
			'RmsAppV2.pages.maintenance.products.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/products', '/maintenance/products/list')
			.when('/maintenance/products/', '/maintenance/products/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.products', {
				url: '/products',
				title: 'Finished Goods',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 50,
				},
			})
			.state('maintenance.products.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/products/productList.html',
				title: 'FINISHED_GOODS',
				pageTitle: 'FINISHED_GOODS',
				parentPath: 'MAINTENANCE',
				controller: 'ProductMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.products.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/products/productCreate.html",
				title: 'CREATE_FINISHED_GOOD',
				pageTitle: 'CREATE_FINISHED_GOOD',
				parentPath: 'MAINTENANCE',
				controller: 'ProductCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.products.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/products/productUpdate.html',
				title: 'UPDATE_FINISHED_GOOD',
				pageTitle: 'UPDATE_FINISHED_GOOD',
				parentPath: 'MAINTENANCE',
				controller: 'ProductUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.products.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/maintenance/products/productImport.html',
				title: 'IMPORT_FINISHED_GOODS',
				pageTitle: 'IMPORT_FINISHED_GOODS',
				parentPath: 'MAINTENANCE',
				controller: 'ProductImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.packagingconditions', [
			'RmsAppV2.pages.maintenance.packagingconditions.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/packagingconditions', '/maintenance/packagingconditions/list')
			.when('/maintenance/packagingconditions/', '/maintenance/packagingconditions/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.packagingconditions', {
				url: '/packagingconditions',
				title: 'PACKAGING_CONDITIONS',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 12,
				},
			})
			.state('maintenance.packagingconditions.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/packagingconditions/pkgconditionList.html',
				title: 'PACKAGING_CONDITIONS',
				pageTitle: 'PACKAGING_CONDITIONS',
				parentPath: 'MAINTENANCE',
				controller: 'PackagingConditionMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.packagingconditions.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/packagingconditions/pkgconditionCreate.html",
				title: 'CREATE_PACKAGING_CONDITION',
				pageTitle: 'CREATE_PACKAGING_CONDITION',
				parentPath: 'MAINTENANCE',
				controller: 'PackagingConditionCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.packagingconditions.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/packagingconditions/pkgconditionUpdate.html',
				title: 'UPDATE_PACKAGING_CONDITION',
				pageTitle: 'UPDATE_PACKAGING_CONDITION',
				parentPath: 'MAINTENANCE',
				controller: 'PackagingConditionUpdateCtrl',
				controllerAs: 'vm'
			})			
			.state('maintenance.packagingconditions.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/maintenance/shippingmethods/customDataListImport.html',
				title: 'IMPORT_PACKAGING_CONDITIONS',
				pageTitle: 'IMPORT_PACKAGING_CONDITIONS',
				parentPath: 'MAINTENANCE',
				controller: 'CustomDataListImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.semifgs', [
			'RmsAppV2.pages.maintenance.semifgs.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/semifgs', '/maintenance/semifgs/list')
			.when('/maintenance/semifgs/', '/maintenance/semifgs/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.semifgs', {
				url: '/semifgs',
				title: 'Semi Finished Goods',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 40,
				},
			})
			.state('maintenance.semifgs.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/semifgs/sfgList.html',
				title: 'SEMI_FINISHED_GOODS',
				pageTitle: 'SEMI_FINISHED_GOODS',
				parentPath: 'MAINTENANCE',
				controller: 'SfgMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.semifgs.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/semifgs/sfgCreate.html",
				title: 'CREATE_SEMIFG',
				pageTitle: 'CREATE_SEMIFG',
				parentPath: 'MAINTENANCE',
				controller: 'SfgCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.semifgs.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/semifgs/sfgUpdate.html',
				title: 'UPDATE_SEMIFG',
				pageTitle: 'UPDATE_SEMIFG',
				parentPath: 'MAINTENANCE',
				controller: 'SfgUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.semifgs.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/maintenance/semifgs/sfgImport.html',
				title: 'IMPORT_SEMIFGS',
				pageTitle: 'IMPORT_SEMIFGS',
				parentPath: 'MAINTENANCE',
				controller: 'SfgImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.shippingfees', [
			'RmsAppV2.pages.maintenance.shippingfees.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/shippingfees', '/maintenance/shippingfees/list')
			.when('/maintenance/shippingfees/', '/maintenance/shippingfees/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.shippingfees', {
				url: '/shippingfees',
				title: 'SHIPPING_FEES',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 12,
				},
			})
			.state('maintenance.shippingfees.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/shippingfees/shippingfeeList.html',
				title: 'SHIPPING_FEES',
				pageTitle: 'SHIPPING_FEES',
				parentPath: 'MAINTENANCE',
				controller: 'ShippingFeeMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.shippingfees.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/shippingfees/shippingfeeCreate.html",
				title: 'CREATE_SHIPPING_FEE',
				pageTitle: 'CREATE_SHIPPING_FEE',
				parentPath: 'MAINTENANCE',
				controller: 'ShippingFeeCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.shippingfees.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/shippingfees/shippingfeeUpdate.html',
				title: 'UPDATE_SHIPPING_FEE',
				pageTitle: 'UPDATE_SHIPPING_FEE',
				parentPath: 'MAINTENANCE',
				controller: 'ShippingFeeUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.shippingmethods', [
			'RmsAppV2.pages.maintenance.shippingmethods.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/shippingmethods', '/maintenance/shippingmethods/list')
			.when('/maintenance/shippingmethods/', '/maintenance/shippingmethods/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.shippingmethods', {
				url: '/shippingmethods',
				title: 'SHIPPING_METHODS',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 12,
				},
			})
			.state('maintenance.shippingmethods.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/shippingmethods/shippingmethodList.html',
				title: 'SHIPPING_METHODS',
				pageTitle: 'SHIPPING_METHODS',
				parentPath: 'MAINTENANCE',
				controller: 'ShippingMethodMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.shippingmethods.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/shippingmethods/shippingmethodCreate.html",
				title: 'CREATE_SHIPPING_METHOD',
				pageTitle: 'CREATE_SHIPPING_METHOD',
				parentPath: 'MAINTENANCE',
				controller: 'ShippingMethodCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.shippingmethods.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/shippingmethods/shippingmethodUpdate.html',
				title: 'UPDATE_SHIPPING_METHOD',
				pageTitle: 'UPDATE_SHIPPING_METHOD',
				parentPath: 'MAINTENANCE',
				controller: 'ShippingMethodUpdateCtrl',
				controllerAs: 'vm'
			})			
			.state('maintenance.shippingmethods.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/maintenance/shippingmethods/customDataListImport.html',
				title: 'IMPORT_SHIPPING_METHODS',
				pageTitle: 'IMPORT_SHIPPING_METHODS',
				parentPath: 'MAINTENANCE',
				controller: 'CustomDataListImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.storepurchaseconfigs', [
			'RmsAppV2.pages.maintenance.storepurchaseconfigs.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/storepurchaseconfigs', '/maintenance/storepurchaseconfigs/list')
			.when('/maintenance/storepurchaseconfigs/', '/maintenance/storepurchaseconfigs/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.storepurchaseconfigs', {
				url: '/storepurchaseconfigs',
				title: 'Store Purchase Configurations',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 80,
				},
			})
			.state('maintenance.storepurchaseconfigs.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/storepurchaseconfigs/spcList.html',
				title: 'STORE_PURCHASE_CONFIG',
				pageTitle: 'STORE_PURCHASE_CONFIG',
				parentPath: 'MAINTENANCE',
				controller: 'StorePurchaseConfigsMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.storepurchaseconfigs.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/storepurchaseconfigs/spcCreate.html",
				title: 'CREATE_STORE_PURCHASE_CONFIG',
				pageTitle: 'CREATE_STORE_PURCHASE_CONFIG',
				parentPath: 'MAINTENANCE',
				controller: 'StorePurchaseConfigsCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.storepurchaseconfigs.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/storepurchaseconfigs/spcUpdate.html',
				title: 'UPDATE_STORE_PURCHASE_CONFIG',
				pageTitle: 'UPDATE_STORE_PURCHASE_CONFIG',
				parentPath: 'MAINTENANCE',
				controller: 'StorePurchaseConfigsUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.storepurchaseconfigs.clone', {
				url: '/clone/:id',
				templateUrl: "app/pages/maintenance/storepurchaseconfigs/spcCreate.html",
				title: 'CLONE_STORE_PURCHASE_CONFIG',
				pageTitle: 'CLONE_STORE_PURCHASE_CONFIG',
				parentPath: 'MAINTENANCE',
				controller: 'StorePurchaseConfigsCloneCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.stockrequestconfigs', [
			'RmsAppV2.pages.maintenance.stockrequestconfigs.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/stockrequestconfigs', '/maintenance/stockrequestconfigs/list')
			.when('/maintenance/stockrequestconfigs/', '/maintenance/stockrequestconfigs/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.stockrequestconfigs', {
				url: '/stockrequestconfigs',
				title: 'Stock Request Configurations',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 80,
				},
			})
			.state('maintenance.stockrequestconfigs.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/stockrequestconfigs/srcList.html',
				title: 'STOCK_REQUEST_CONFIG',
				pageTitle: 'STOCK_REQUEST_CONFIG',
				parentPath: 'MAINTENANCE',
				controller: 'StockRequestConfigsMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.stockrequestconfigs.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/stockrequestconfigs/srcCreate.html",
				title: 'CREATE_STOCK_REQUEST_CONFIG',
				pageTitle: 'CREATE_STOCK_REQUEST_CONFIG',
				parentPath: 'MAINTENANCE',
				controller: 'StockRequestConfigsCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.stockrequestconfigs.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/stockrequestconfigs/srcUpdate.html',
				title: 'UPDATE_STOCK_REQUEST_CONFIG',
				pageTitle: 'UPDATE_STOCK_REQUEST_CONFIG',
				parentPath: 'MAINTENANCE',
				controller: 'StockRequestConfigsUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.stockrequestconfigs.clone', {
				url: '/clone/:id',
				templateUrl: "app/pages/maintenance/stockrequestconfigs/srcCreate.html",
				title: 'CLONE_STOCK_REQUEST_CONFIG',
				pageTitle: 'CLONE_STOCK_REQUEST_CONFIG',
				parentPath: 'MAINTENANCE',
				controller: 'StockRequestConfigsCloneCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.warehouses', [
			'RmsAppV2.pages.maintenance.warehouses.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/warehouses', '/maintenance/warehouses/list')
			.when('/maintenance/warehouses/', '/maintenance/warehouses/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.warehouses', {
				url: '/warehouses',
				title: 'Warehouses',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 80,
				},
			})
			.state('maintenance.warehouses.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/warehouses/warehouseList.html',
				title: 'WAREHOUSES',
				pageTitle: 'WAREHOUSES',
				parentPath: 'MAINTENANCE',
				controller: 'WarehousesMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.warehouses.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/warehouses/warehouseCreate.html",
				title: 'CREATE_WAREHOUSE',
				pageTitle: 'CREATE_WAREHOUSE',
				parentPath: 'MAINTENANCE',
				controller: 'WarehousesCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.warehouses.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/warehouses/warehouseUpdate.html',
				title: 'UPDATE_WAREHOUSE',
				pageTitle: 'UPDATE_WAREHOUSE',
				parentPath: 'MAINTENANCE',
				controller: 'WarehousesUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.yieldmanagement', [
			'RmsAppV2.pages.maintenance.yieldmanagement.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/yieldmanagement', '/maintenance/yieldmanagement/list')
			.when('/maintenance/yieldmanagement/', '/maintenance/yieldmanagement/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.yieldmanagement', {
				url: '/yieldmanagement',
				title: 'Yield Management',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 70,
				},
			})
			.state('maintenance.yieldmanagement.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/yieldmanagement/yieldmgmtList.html',
				title: 'YIELD_MANAGEMENT',
				pageTitle: 'YIELD_MANAGEMENT',
				parentPath: 'MAINTENANCE',
				controller: 'YieldManagementMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.yieldmanagement.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/yieldmanagement/yieldmgmtCreate.html",
				title: 'CREATE_YIELD_MANAGEMENT',
				pageTitle: 'CREATE_YIELD_MANAGEMENT',
				parentPath: 'MAINTENANCE',
				controller: 'YieldManagementCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.yieldmanagement.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/yieldmanagement/yieldmgmtUpdate.html',
				title: 'UPDATE_YIELD_MANAGEMENT',
				pageTitle: 'UPDATE_YIELD_MANAGEMENT',
				parentPath: 'MAINTENANCE',
				controller: 'YieldManagementUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.suppliers', [
			'RmsAppV2.pages.maintenance.suppliers.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/maintenance/suppliers', '/maintenance/suppliers/list')
			.when('/maintenance/suppliers/', '/maintenance/suppliers/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('maintenance.suppliers', {
				url: '/suppliers',
				title: 'Suppliers',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('maintenance.suppliers.list', {
				url: '/list',
				templateUrl: 'app/pages/maintenance/suppliers/supplierList.html',
				title: 'SUPPLIERS',
				pageTitle: 'SUPPLIERS',
				parentPath: 'MAINTENANCE',
				controller: 'SuppliersMainCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.suppliers.create', {
				url: '/create',
				templateUrl: "app/pages/maintenance/suppliers/supplierCreate.html",
				title: 'CREATE_SUPPLIER',
				pageTitle: 'CREATE_SUPPLIER',
				parentPath: 'MAINTENANCE',
				controller: 'SuppliersCreateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.suppliers.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/maintenance/suppliers/supplierUpdate.html',
				title: 'UPDATE_SUPPLIER',
				pageTitle: 'UPDATE_SUPPLIER',
				parentPath: 'MAINTENANCE',
				controller: 'SuppliersUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('maintenance.suppliers.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/maintenance/suppliers/supplierImport.html',
				title: 'IMPORT_SUPPLIERS',
				pageTitle: 'IMPORT_SUPPLIERS',
				parentPath: 'MAINTENANCE',
				controller: 'SuppliersImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.pos.products', [
			'RmsAppV2.pages.pos.products.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/pos/products', '/pos/products/list')
			.when('/pos/products/', '/pos/products/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('pos.products', {
				url: '/products',
				title: 'POS Products',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('pos.products.list', {
				url: '/list',
				templateUrl: 'app/pages/pos/products/posproductList.html',
				title: 'POS Products',
				pageTitle: 'POS Products',
				parentPath: 'POS Products',
				controller: 'PosProductMainCtrl',
				controllerAs: 'vm'
			})
			.state('pos.products.create', {
				url: '/create',
				templateUrl: "app/pages/pos/products/posproductCreate.html",
				title: 'Create POS Product',
				pageTitle: 'Create POS Product',
				parentPath: 'POS Products',
				controller: 'POSProductCreateCtrl',
				controllerAs: 'vm'
			})
			.state('pos.products.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/pos/products/posproductUpdate.html',
				title: 'Update POS Product',
				pageTitle: 'Update POS Product',
				parentPath: 'POS Products',
				controller: 'POSProductUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.outletops.srnlist', [
			'RmsAppV2.pages.outletops.srnlist.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/outletops/srnlist', '/outletops/srnlist/list')
			.when('/outletops/srnlist/', '/outletops/srnlist/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('outletops.srnlist', {
				url: '/srnlist',
				title: 'SRN Listing',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('outletops.srnlist.list', {
				url: '/list',
				templateUrl: 'app/pages/outletops/srnlist/srnList.html',
				title: 'SRN_LISTING',
				pageTitle: 'SRN_LISTING',
				parentPath: 'SRN_LISTING',
				controller: 'ReceivingsSrnMainCtrl',
				controllerAs: 'vm'
			})
			// .state('outletops.srnlist.create', {
			// 	url: '/create',
			// 	templateUrl: 'app/pages/outletops/srnlist/srnCreate.html',
			// 	title: 'New Receive',
			// 	pageTitle: 'New Receive (SRN)',
			// 	parentPath: 'Item Receiving',
			// 	controller: 'ReceivingsSrnCreateCtrl',
			// 	controllerAs: 'vm'
			// })
			.state('outletops.srnlist.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/outletops/srnlist/srnUpdate.html',
				title: 'View SRN',
				pageTitle: 'View SRN',
				parentPath: 'SRN_LISTING',
				controller: 'ReceivingsSrnUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.purchaseorders.pofromreq', [
			'RmsAppV2.pages.purchaseorders.pofromreq.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/purchaseorders/pofromreq', '/purchaseorders/pofromreq/list')
			.when('/purchaseorders/pofromreq/', '/purchaseorders/pofromreq/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('purchaseorders.pofromreq', {
				url: '/pofromreq',
				title: 'Approved Requisition',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('purchaseorders.pofromreq.list', {
				url: '/list',
				templateUrl: 'app/pages/purchaseorders/pofromreq/pofromreqList.html',
				title: 'APPROVED_REQUISTIONS',
				pageTitle: 'APPROVED_REQUISTIONS',
				parentPath: 'PURCHASE_ORDER',
				controller: 'PurchaseOrderFromReqMainCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.purchaseorders.polist', [
			'RmsAppV2.pages.purchaseorders.polist.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/purchaseorders/polist', '/purchaseorders/polist/list')
			.when('/purchaseorders/polist/', '/purchaseorders/polist/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('purchaseorders.polist', {
				url: '/polist',
				title: 'Purchase Order Listing',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('purchaseorders.polist.list', {
				url: '/list',
				templateUrl: 'app/pages/purchaseorders/polist/polistList.html',
				title: 'PURCHASE_ORDERS',
				pageTitle: 'PURCHASE_ORDERS',
				parentPath: 'PURCHASE_ORDER',
				controller: 'PurchaseOrderMainCtrl',
				controllerAs: 'vm'
			})
			.state('purchaseorders.polist.create', {
				url: '/create',
				templateUrl: "app/pages/purchaseorders/polist/polistCreate.html",
				title: 'CREATE_PURCHASE_ORDER',
				pageTitle: 'CREATE_PURCHASE_ORDER',
				parentPath: 'PURCHASE_ORDER',
				controller: 'PurchaseOrderCreateCtrl',
				controllerAs: 'vm'
			})
			.state('purchaseorders.polist.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/purchaseorders/polist/polistUpdate.html',
				title: 'UPDATE_PURCHASE_ORDER',
				pageTitle: 'UPDATE_PURCHASE_ORDER',
				parentPath: 'PURCHASE_ORDER',
				controller: 'PurchaseOrderUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.recipes.cards', [
			'RmsAppV2.pages.recipes.cards.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/recipes/cards', '/recipes/cards/card-categories')
			.when('/recipes/cards/', '/recipes/cards/card-categories')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('recipes.cards', {
				url: '/cards',
				title: 'Recipe Cards',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('recipes.cards.categories', {
				url: '/card-categories',
				templateUrl: 'app/pages/recipes/cards/cardCategories.html',
				title: 'RECIPE_CATEGORIES',
				pageTitle: 'RECIPE_CATEGORIES',
				parenparentPath: 'RECIPES',
				controller: 'RecipeCardCategoriesCtrl',
				controllerAs: 'vm'
			})
			.state('recipes.cards.recipes', {
				url: '/card-recipes/:id',
				templateUrl: "app/pages/recipes/cards/cardRecipes.html",
				title: 'RECIPE_CARDS',
				pageTitle: 'RECIPE_CARDS',
				parenparentPath: 'RECIPES',
				controller: 'RecipeCardRecipesCtrl',
				controllerAs: 'vm'
			})
			.state('recipes.cards.view', {
				url: '/card-view/:id',
				templateUrl: "app/pages/recipes/cards/cardView.html",
				title: 'RECIPE_CARD',
				pageTitle: 'RECIPE_CARD',
				parenparentPath: 'RECIPES',
				controller: 'RecipeCardViewCtrl',
				controllerAs: 'vm'
			});
	}
	
})();

(function () {
	'use strict';

	angular.module('RmsAppV2.pages.receivings.grnlist', [
			'RmsAppV2.pages.receivings.grnlist.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/receivings/grnlist', '/receivings/grnlist/list')
			.when('/receivings/grnlist/', '/receivings/grnlist/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('receivings.grnlist', {
				url: '/grnlist',
				title: 'GRN Listing',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('receivings.grnlist.list', {
				url: '/list',
				templateUrl: 'app/pages/receivings/grnlist/grnList.html',
				title: 'GOODS_RECEIVED_NOTES_GRN',
				pageTitle: 'GOODS_RECEIVED_NOTES_GRN',
				parentPath: 'GOODS_RECEIVED_NOTES',
				controller: 'ReceivingsGrnMainCtrl',
				controllerAs: 'vm'
			})
			.state('receivings.grnlist.create', {
				url: '/create',
				templateUrl: 'app/pages/receivings/grnlist/grnCreate.html',
				title: 'New Receive',
				pageTitle: 'New Receive (GRN)',
				parentPath: 'GOODS_RECEIVED_NOTES',
				controller: 'ReceivingsGrnCreateCtrl',
				controllerAs: 'vm'
			})
			.state('receivings.grnlist.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/receivings/grnlist/grnUpdate.html',
				title: 'VIEW_GOODS_RECEIVED_NOTE',
				pageTitle: 'VIEW_GOODS_RECEIVED_NOTE',
				parentPath: 'GOODS_RECEIVED_NOTES',
				controller: 'ReceivingsGrnUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.recipes.categories', [
			'RmsAppV2.pages.recipes.categories.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/recipes/categories', '/recipes/categories/list')
			.when('/recipes/categories/', '/recipes/categories/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('recipes.categories', {
				url: '/categories',
				title: 'Manage Categories',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('recipes.categories.list', {
				url: '/list',
				templateUrl: 'app/pages/recipes/categories/categoryList.html',
				title: 'RECIPE_CATEGORIES',
				pageTitle: 'RECIPE_CATEGORIES',
				parenparentPath: 'RECIPES',
				controller: 'RecipeCategoryMainCtrl',
				controllerAs: 'vm'
			})
			.state('recipes.categories.create', {
				url: '/create',
				templateUrl: "app/pages/recipes/categories/categoryCreate.html",
				title: 'CREATE_RECIPE_CATEGORY',
				pageTitle: 'CREATE_RECIPE_CATEGORY',
				parenparentPath: 'RECIPES',
				controller: 'RecipeCategoryCreateCtrl',
				controllerAs: 'vm'
			})
			.state('recipes.categories.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/recipes/categories/categoryUpdate.html',
				title: 'UPDATE_RECIPE_CATEGORY',
				pageTitle: 'UPDATE_RECIPE_CATEGORY',
				parenparentPath: 'RECIPES',
				controller: 'RecipeCategoryUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.reportcenter', [
			'RmsAppV2.pages.reportcenter.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('reportcenter', {
				url: '/reportcenter',
				templateUrl: 'app/pages/report/reportcenter/reportcenter.html',
				title: 'Report Center',
				pageTitle: 'Report Center',
                controller: 'ReportCenterCtrl',
                controllerAs: 'vm',
				sidebarMeta: {
					icon: 'fa fa-bar-chart',
					order: 1800,
				},
			});
  }

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.recipes.recipes', [
			'RmsAppV2.pages.recipes.recipes.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/recipes/recipes', '/recipes/recipes/category-list')
			.when('/recipes/recipes/', '/recipes/recipes/category-list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('recipes.recipes', {
				url: '/recipes',
				title: 'Manage Recipes',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('recipes.recipes.categorylist', {
				url: '/category-list',
				templateUrl: 'app/pages/recipes/recipes/recipeCategoryList.html',
				title: 'RECIPE_CATEGORIES',
				pageTitle: 'RECIPE_CATEGORIES',
				parenparentPath: 'RECIPES',
				controller: 'RecipeCatMainCtrl',
				controllerAs: 'vm'
			})
			.state('recipes.recipes.recipelist', {
				url: '/recipe-list/:id',
				templateUrl: 'app/pages/recipes/recipes/recipeList.html',
				title: 'RECIPE_LIST',
				pageTitle: 'RECIPE_LIST',
				parenparentPath: 'RECIPES',
				controller: 'RecipeMainCtrl',
				controllerAs: 'vm'
			})
			.state('recipes.recipes.create', {
				url: '/create',
				templateUrl: "app/pages/recipes/recipes/recipeCreate.html",
				title: 'CREATE_RECIPE',
				pageTitle: 'CREATE_RECIPE',
				parenparentPath: 'RECIPES',
				controller: 'RecipeCreateCtrl',
				controllerAs: 'vm'
			})
			.state('recipes.recipes.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/recipes/recipes/recipeUpdate.html',
				title: 'UPDATE_RECIPE',
				pageTitle: 'UPDATE_RECIPE',
				parenparentPath: 'RECIPES',
				controller: 'RecipeUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.reportinquiry', [
			'RmsAppV2.pages.reportinquiry.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('reportinquiry', {
				url: '/reportinquiry',
				templateUrl: 'app/pages/report/reportinquiry/reportinquiry.html',
				title: 'Report Inquiry',
				pageTitle: 'Report Inquiry',
                controller: 'ReportInquiryCtrl',
                controllerAs: 'vm',
				sidebarMeta: {
					icon: 'fa fa-bar-chart',
					order: 1800,
				},
			});
  }

})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.tracktrace', [
			'RmsAppV2.pages.tracktrace.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('tracktrace', {
				url: '/tracktrace',
				templateUrl: 'app/pages/report/tracktrace/tracktrace.html',
				title: 'Track & Trace',
				pageTitle: 'Track & Trace',
                controller: 'TrackTraceCtrl',
                controllerAs: 'vm',
				sidebarMeta: {
					icon: 'fa fa-search',
					order: 1700,
				},
			});
  }

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.requisitions.reqapproval', [
			'RmsAppV2.pages.requisitions.reqapproval.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/requisitions/reqapproval', '/requisitions/reqapproval/list')
			.when('/requisitions/reqapproval/', '/requisitions/reqapproval/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('requisitions.reqapproval', {
				url: '/reqapproval',
				title: 'Requisition Approval',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('requisitions.reqapproval.list', {
				url: '/list',
				templateUrl: 'app/pages/requisitions/reqapproval/reqapprovalList.html',
				title: 'REQUISITION_APPROVAL',
				pageTitle: 'REQUISITION_APPROVAL',
				parentPath: 'REQUISITION',
				controller: 'RequisitionApprovalMainCtrl',
				controllerAs: 'vm'
			})
			.state('requisitions.reqapproval.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/requisitions/reqapproval/reqapprovalUpdate.html',
				title: 'APPROVE_REQUISITION',
				pageTitle: 'APPROVE_REQUISITION',
				parentPath: 'REQUISITION',
				controller: 'RequisitionApprovalUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.requisitions.reqlist', [
			'RmsAppV2.pages.requisitions.reqlist.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/requisitions/reqlist', '/requisitions/reqlist/list')
			.when('/requisitions/reqlist/', '/requisitions/reqlist/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('requisitions.reqlist', {
				url: '/reqlist',
				title: 'Requisition Listing',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('requisitions.reqlist.list', {
				url: '/list',
				templateUrl: 'app/pages/requisitions/reqlist/reqlistList.html',
				title: 'REQUISITION_LIST',
				pageTitle: 'REQUISITION_LIST',
				parentPath: 'REQUISITION',
				controller: 'RequisitionMainCtrl',
				controllerAs: 'vm'
			})
			.state('requisitions.reqlist.create', {
				url: '/create',
				templateUrl: "app/pages/requisitions/reqlist/reqlistCreate.html",
				title: 'CREATE_REQUISITION',
				pageTitle: 'CREATE_REQUISITION',
				parentPath: 'REQUISITION',
				controller: 'RequisitionCreateCtrl',
				controllerAs: 'vm'
			})
			.state('requisitions.reqlist.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/requisitions/reqlist/reqlistUpdate.html',
				title: 'UPDATE_REQUISITION',
				pageTitle: 'UPDATE_REQUISITION',
				parentPath: 'REQUISITION',
				controller: 'RequisitionUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.categories', [
			'RmsAppV2.pages.robotkiosk.categories.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/robotkiosk/categories', '/robotkiosk/categories/list')
			.when('/robotkiosk/categories/', '/robotkiosk/categories/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('robotkiosk.categories', {
				url: '/categories',
				title: 'Product Categories',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('robotkiosk.categories.list', {
				url: '/list',
				templateUrl: 'app/pages/robotkiosk/categories/categoryList.html',
				title: 'Product Categories',
				pageTitle: 'Product Categories',
				parentPath: 'Robot Kiosk',
				controller: 'KioskCategoriesMainCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.categories.create', {
				url: '/create',
				templateUrl: "app/pages/robotkiosk/categories/categoryCreate.html",
				title: 'Create Product Category',
				pageTitle: 'Create Product Category',
				parentPath: 'Robot Kiosk',
				controller: 'KioskCategoriesCreateCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.categories.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/robotkiosk/categories/categoryUpdate.html',
				title: 'Update Product Category',
				pageTitle: 'Update Product Category',
				parentPath: 'Robot Kiosk',
				controller: 'KioskCategoriesUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.equipmenttypes', [
			'RmsAppV2.pages.robotkiosk.equipmenttypes.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/robotkiosk/equipmenttypes', '/robotkiosk/equipmenttypes/list')
			.when('/robotkiosk/equipmenttypes/', '/robotkiosk/equipmenttypes/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('robotkiosk.equipmenttypes', {
				url: '/equipmenttypes',
				title: 'Equipment Types',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('robotkiosk.equipmenttypes.list', {
				url: '/list',
				templateUrl: 'app/pages/robotkiosk/equipmenttypes/typeList.html',
				title: 'Equipment Types',
				pageTitle: 'Equipment Types',
				parentPath: 'Robot Kiosk',
				controller: 'KioskEquipmentTypesMainCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.equipmenttypes.create', {
				url: '/create',
				templateUrl: "app/pages/robotkiosk/equipmenttypes/typeCreate.html",
				title: 'Create Equipment Type',
				pageTitle: 'Create Equipment Type',
				parentPath: 'Robot Kiosk',
				controller: 'KioskEquipmentTypesCreateCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.equipmenttypes.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/robotkiosk/equipmenttypes/typeUpdate.html',
				title: 'Update Equipment Type',
				pageTitle: 'Update Equipment Type',
				parentPath: 'Robot Kiosk',
				controller: 'KioskEquipmentTypesUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.equipments', [
			'RmsAppV2.pages.robotkiosk.equipments.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/robotkiosk/equipments', '/robotkiosk/equipments/list')
			.when('/robotkiosk/equipments/', '/robotkiosk/equipments/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('robotkiosk.equipments', {
				url: '/equipments',
				title: 'Kiosk Equipments',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('robotkiosk.equipments.list', {
				url: '/list',
				templateUrl: 'app/pages/robotkiosk/equipments/eqptList.html',
				title: 'Kiosk Equipments',
				pageTitle: 'Kiosk Equipments',
				parentPath: 'Robot Kiosk',
				controller: 'KioskEquipmentsMainCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.equipments.create', {
				url: '/create',
				templateUrl: "app/pages/robotkiosk/equipments/eqptCreate.html",
				title: 'Create Kiosk Equipment',
				pageTitle: 'Create Kiosk Equipment',
				parentPath: 'Robot Kiosk',
				controller: 'KioskEquipmentsCreateCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.equipments.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/robotkiosk/equipments/eqptUpdate.html',
				title: 'Update Kiosk Equipment',
				pageTitle: 'Update Kiosk Equipment',
				parentPath: 'Robot Kiosk',
				controller: 'KioskEquipmentsUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.kiosks', [
			'RmsAppV2.pages.robotkiosk.kiosks.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/robotkiosk/kiosks', '/robotkiosk/kiosks/list')
			.when('/robotkiosk/kiosks/', '/robotkiosk/kiosks/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('robotkiosk.kiosks', {
				url: '/kiosks',
				title: 'Kiosks',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('robotkiosk.kiosks.list', {
				url: '/list',
				templateUrl: 'app/pages/robotkiosk/kiosks/kioskList.html',
				title: 'Kiosk Management',
				pageTitle: 'Kiosk Management',
				parentPath: 'Robot Kiosk',
				controller: 'KiosksMainCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.kiosks.create', {
				url: '/create',
				templateUrl: "app/pages/robotkiosk/kiosks/kioskCreate.html",
				title: 'Create Kiosk',
				pageTitle: 'Create Kiosk',
				parentPath: 'Robot Kiosk',
				controller: 'KiosksCreateCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.kiosks.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/robotkiosk/kiosks/kioskUpdate.html',
				title: 'Update Kiosk',
				pageTitle: 'Update Kiosk',
				parentPath: 'Robot Kiosk',
				controller: 'KiosksUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.productflavors', [
			'RmsAppV2.pages.robotkiosk.productflavors.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/robotkiosk/productflavors', '/robotkiosk/productflavors/list')
			.when('/robotkiosk/productflavors/', '/robotkiosk/productflavors/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('robotkiosk.productflavors', {
				url: '/productflavors',
				title: 'Product Flavors',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('robotkiosk.productflavors.list', {
				url: '/list',
				templateUrl: 'app/pages/robotkiosk/productflavors/flavorList.html',
				title: 'Product Flavors',
				pageTitle: 'Product Flavors',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductFlavorsMainCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.productflavors.create', {
				url: '/create',
				templateUrl: "app/pages/robotkiosk/productflavors/flavorCreate.html",
				title: 'Create Product Flavor',
				pageTitle: 'Create Product Flavor',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductFlavorsCreateCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.productflavors.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/robotkiosk/productflavors/flavorUpdate.html',
				title: 'Update Product Flavor',
				pageTitle: 'Update Product Flavor',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductFlavorsUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.productmappings', [
			'RmsAppV2.pages.robotkiosk.productmappings.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/robotkiosk/productmappings', '/robotkiosk/productmappings/list')
			.when('/robotkiosk/productmappings/', '/robotkiosk/productmappings/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('robotkiosk.productmappings', {
				url: '/productmappings',
				title: 'Product Mapping',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('robotkiosk.productmappings.list', {
				url: '/list',
				templateUrl: 'app/pages/robotkiosk/productmappings/mappingList.html',
				title: 'Product Mapping List',
				pageTitle: 'Product Mapping List',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductMappingMainCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.productmappings.create', {
				url: '/create',
				templateUrl: "app/pages/robotkiosk/productmappings/mappingCreate.html",
				title: 'Create Product Mapping',
				pageTitle: 'Create Product Mapping',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductMappingCreateCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.productmappings.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/robotkiosk/productmappings/mappingUpdate.html',
				title: 'Update Product Mapping',
				pageTitle: 'Update Product Mapping',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductMappingUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.productothers', [
			'RmsAppV2.pages.robotkiosk.productothers.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/robotkiosk/productothers', '/robotkiosk/productothers/list')
			.when('/robotkiosk/productothers/', '/robotkiosk/productothers/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('robotkiosk.productothers', {
				url: '/productothers',
				title: 'Product Other Options',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('robotkiosk.productothers.list', {
				url: '/list',
				templateUrl: 'app/pages/robotkiosk/productothers/otherList.html',
				title: 'Product Other Options',
				pageTitle: 'Product Other Options',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductOthersMainCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.productothers.create', {
				url: '/create',
				templateUrl: "app/pages/robotkiosk/productothers/otherCreate.html",
				title: 'Create Product Option',
				pageTitle: 'Create Product Option',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductOthersCreateCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.productothers.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/robotkiosk/productothers/otherUpdate.html',
				title: 'Update Product Option',
				pageTitle: 'Update Product Option',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductOthersUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.routeplan.actual', [
			'RmsAppV2.pages.routeplan.actual.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/routeplan/actual', '/routeplan/actual/list')
			.when('/routeplan/actual/', '/routeplan/actual/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('routeplan.actual', {
				url: '/actual',
				title: 'Route Plan (Actual)',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 70,
				},
			})
			.state('routeplan.actual.list', {
				url: '/list',
				templateUrl: 'app/pages/routeplan/actual/rpactualList.html',
				title: 'ROUTE_PLAN_ACTUAL',
				pageTitle: 'ROUTE_PLAN_ACTUAL',
				parentPath: 'ROUTE_PLANNING',
				controller: 'RoutePlanActualMainCtrl',
				controllerAs: 'vm'
			})
			.state('routeplan.actual.create', {
				url: '/create',
				templateUrl: "app/pages/routeplan/actual/rpactualCreate.html",
				title: 'CREATE_ROUTE_PLAN_ACTUAL',
				pageTitle: 'CREATE_ROUTE_PLAN_ACTUAL',
				parentPath: 'ROUTE_PLANNING',
				controller: 'RoutePlanActualCreateCtrl',
				controllerAs: 'vm'
			})
			.state('routeplan.actual.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/routeplan/actual/rpactualUpdate.html',
				title: 'UPDATE_ROUTE_PLAN_ACTUAL',
				pageTitle: 'UPDATE_ROUTE_PLAN_ACTUAL',
				parentPath: 'ROUTE_PLANNING',
				controller: 'RoutePlanActualUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.products', [
			'RmsAppV2.pages.robotkiosk.products.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/robotkiosk/products', '/robotkiosk/products/list')
			.when('/robotkiosk/products/', '/robotkiosk/products/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('robotkiosk.products', {
				url: '/products',
				title: 'Kiosk Products',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('robotkiosk.products.list', {
				url: '/list',
				templateUrl: 'app/pages/robotkiosk/products/productList.html',
				title: 'Kiosk Products',
				pageTitle: 'Kiosk Products',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductsMainCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.products.create', {
				url: '/create',
				templateUrl: "app/pages/robotkiosk/products/productCreate.html",
				title: 'Create Product',
				pageTitle: 'Create Product',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductsCreateCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.products.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/robotkiosk/products/productUpdate.html',
				title: 'Update Product',
				pageTitle: 'Update Product',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductsUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.productsizes', [
			'RmsAppV2.pages.robotkiosk.productsizes.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/robotkiosk/productsizes', '/robotkiosk/productsizes/list')
			.when('/robotkiosk/productsizes/', '/robotkiosk/productsizes/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('robotkiosk.productsizes', {
				url: '/productsizes',
				title: 'Product Sizes',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('robotkiosk.productsizes.list', {
				url: '/list',
				templateUrl: 'app/pages/robotkiosk/productsizes/sizeList.html',
				title: 'Product Sizes',
				pageTitle: 'Product Sizes',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductSizesMainCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.productsizes.create', {
				url: '/create',
				templateUrl: "app/pages/robotkiosk/productsizes/sizeCreate.html",
				title: 'Create Product Size',
				pageTitle: 'Create Product Size',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductSizesCreateCtrl',
				controllerAs: 'vm'
			})
			.state('robotkiosk.productsizes.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/robotkiosk/productsizes/sizeUpdate.html',
				title: 'Update Product Size',
				pageTitle: 'Update Product Size',
				parentPath: 'Robot Kiosk',
				controller: 'KioskProductSizesUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.routeplan.actual_mercado', [
			'RmsAppV2.pages.routeplan.actual_mercado.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/routeplan/actual_mercado', '/routeplan/actual_mercado/list')
			.when('/routeplan/actual_mercado/', '/routeplan/actual_mercado/list')
			.otherwise('/dashboard');

		$stateProvider
			.state('routeplan.actual_mercado', {
				url: '/actual_mercado',
				title: 'Route Plan (Actual)',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 70,
				},
			})
			.state('routeplan.actual_mercado.list', {
				url: '/list',
				templateUrl: 'app/pages/routeplan/actual_mercado/rpactualList.html',
				title: 'ROUTE_PLAN_ACTUAL',
				pageTitle: 'ROUTE_PLAN_ACTUAL',
				parentPath: 'ROUTE_PLANNING',
				controller: 'RoutePlanActualMainCtrl',
				controllerAs: 'vm'
			})
			.state('routeplan.actual_mercado.create', {
				url: '/create',
				templateUrl: "app/pages/routeplan/actual_mercado/rpactualCreate.html",
				title: 'CREATE_ROUTE_PLAN_ACTUAL',
				pageTitle: 'CREATE_ROUTE_PLAN_ACTUAL',
				parentPath: 'ROUTE_PLANNING',
				controller: 'RoutePlanActualCreateCtrl',
				controllerAs: 'vm'
			})
			.state('routeplan.actual_mercado.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/routeplan/actual_mercado/rpactualUpdate.html',
				title: 'UPDATE_ROUTE_PLAN_ACTUAL',
				pageTitle: 'UPDATE_ROUTE_PLAN_ACTUAL',
				parentPath: 'ROUTE_PLANNING',
				controller: 'RoutePlanActualUpdateCtrl',
				controllerAs: 'vm'
			});
	}

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.routeplan.preview', [
			'RmsAppV2.pages.routeplan.preview.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/routeplan/preview', '/routeplan/preview/list')
			.when('/routeplan/preview/', '/routeplan/preview/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('routeplan.preview', {
				url: '/preview',
				title: 'Route Plan Preview',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 70,
				},
			})
			.state('routeplan.preview.list', {
				url: '/list',
				templateUrl: 'app/pages/routeplan/preview/rppreviewList.html',
				title: 'ROUTE_PLAN_PREVIEW',
				pageTitle: 'ROUTE_PLAN_PREVIEW',
				parentPath: 'ROUTE_PLANNING',
				controller: 'RoutePlanPreviewMainCtrl',
				controllerAs: 'vm'
			})
			.state('routeplan.preview.create', {
				url: '/create',
				templateUrl: "app/pages/routeplan/preview/rppreviewCreate.html",
				title: 'CREATE_ROUTE_PLAN_PREVIEW',
				pageTitle: 'CREATE_ROUTE_PLAN_PREVIEW',
				parentPath: 'ROUTE_PLANNING',
				controller: 'RoutePlanPreviewCreateCtrl',
				controllerAs: 'vm'
			})
			.state('routeplan.preview.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/routeplan/preview/rppreviewUpdate.html',
				title: 'UPDATE_ROUTE_PLAN_PREVIEW',
				pageTitle: 'UPDATE_ROUTE_PLAN_PREVIEW',
				parentPath: 'ROUTE_PLANNING',
				controller: 'RoutePlanPreviewUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.routeplan.template', [
			'RmsAppV2.pages.routeplan.template.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/routeplan/template', '/routeplan/template/list')
			.when('/routeplan/template/', '/routeplan/template/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('routeplan.template', {
				url: '/template',
				title: 'Route Plan Template',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 70,
				},
			})
			.state('routeplan.template.list', {
				url: '/list',
				templateUrl: 'app/pages/routeplan/template/rptemplateList.html',
				title: 'ROUTE_PLAN_TEMPLATES',
				pageTitle: 'ROUTE_PLAN_TEMPLATES',
				parentPath: 'ROUTE_PLANNING',
				controller: 'RoutePlanTemplateMainCtrl',
				controllerAs: 'vm'
			})
			.state('routeplan.template.create', {
				url: '/create',
				templateUrl: "app/pages/routeplan/template/rptemplateCreate.html",
				title: 'CREATE_TEMPLATE',
				pageTitle: 'CREATE_TEMPLATE',
				parentPath: 'ROUTE_PLANNING',
				controller: 'RoutePlanTemplateCreateCtrl',
				controllerAs: 'vm'
			})
			.state('routeplan.template.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/routeplan/template/rptemplateUpdate.html',
				title: 'UPDATE_TEMPLATE',
				pageTitle: 'UPDATE_TEMPLATE',
				parentPath: 'ROUTE_PLANNING',
				controller: 'RoutePlanTemplateUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.checklistentries', [
			'RmsAppV2.pages.serviceconfigs.checklistentries.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/checklistentries', '/serviceconfigs/checklistentries/list')
			.when('/serviceconfigs/checklistentries/', '/serviceconfigs/checklistentries/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.checklistentries', {
				url: '/checklistentries',
				title: 'Checklist Entries',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 60,
				},
			})
			.state('serviceconfigs.checklistentries.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/checklistentries/checklistentryList.html',
				title: 'Checklist Entries',
				pageTitle: 'Checklist Entries',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcChecklistEntryMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.checklistentries.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/checklistentries/checklistentryCreate.html",
				title: 'Create Checklist Entry',
				pageTitle: 'Create Checklist Entry',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcChecklistEntryCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.checklistentries.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/checklistentries/checklistentryUpdate.html',
				title: 'Update Checklist Entry',
				pageTitle: 'Update Checklist Entry',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcChecklistEntryUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.loanitemstatuses', [
			'RmsAppV2.pages.serviceconfigs.loanitemstatuses.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/loanitemstatuses', '/serviceconfigs/loanitemstatuses/list')
			.when('/serviceconfigs/loanitemstatuses/', '/serviceconfigs/loanitemstatuses/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.loanitemstatuses', {
				url: '/loanitemstatuses',
				title: 'Loan Item Statuses',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 80,
				},
			})
			.state('serviceconfigs.loanitemstatuses.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/loanitemstatuses/loanitemstatusList.html',
				title: 'Loan Item Statuses',
				pageTitle: 'Loan Item  Statuses',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcLoanItemStatusMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.loanitemstatuses.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/loanitemstatuses/loanitemstatusCreate.html",
				title: 'Create Loan Item Status',
				pageTitle: 'Create Loan Item Status',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcLoanItemStatusCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.loanitemstatuses.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/loanitemstatuses/loanitemstatusUpdate.html',
				title: 'Update Loan Item Status',
				pageTitle: 'Update Loan Item Status',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcLoanItemStatusUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.checklists', [
			'RmsAppV2.pages.serviceconfigs.checklists.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/checklists', '/serviceconfigs/checklists/list')
			.when('/serviceconfigs/checklists/', '/serviceconfigs/checklists/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.checklists', {
				url: '/checklists',
				title: 'Checklists',
				template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 50,
				},
			})
			.state('serviceconfigs.checklists.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/checklists/checklistList.html',
				title: 'Checklists',
				pageTitle: 'Checklists',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcChecklistMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.checklists.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/checklists/checklistCreate.html",
				title: 'Create Checklist',
				pageTitle: 'Create Checklist',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcChecklistCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.checklists.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/checklists/checklistUpdate.html',
				title: 'Update Checklist',
				pageTitle: 'Update Checklist',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcChecklistUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.loanstatuses', [
			'RmsAppV2.pages.serviceconfigs.loanstatuses.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/loanstatuses', '/serviceconfigs/loanstatuses/list')
			.when('/serviceconfigs/loanstatuses/', '/serviceconfigs/loanstatuses/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.loanstatuses', {
				url: '/loanstatuses',
				title: 'Loan Statuses',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 70,
				},
			})
			.state('serviceconfigs.loanstatuses.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/loanstatuses/loanstatusList.html',
				title: 'Loan Statuses',
				pageTitle: 'Loan Statuses',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcLoanStatusMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.loanstatuses.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/loanstatuses/loanstatusCreate.html",
				title: 'Create Loan Status',
				pageTitle: 'Create Loan Status',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcLoanStatusCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.loanstatuses.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/loanstatuses/loanstatusUpdate.html',
				title: 'Update Loan Status',
				pageTitle: 'Update Loan Status',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcLoanStatusUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.pnsettings', [
			'RmsAppV2.pages.serviceconfigs.pnsettings.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/pnsettings', '/serviceconfigs/pnsettings/list')
			.when('/serviceconfigs/pnsettings/', '/serviceconfigs/pnsettings/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.pnsettings', {
				url: '/pnsettings',
				title: 'Push Notifications',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 60,
				},
			})
			.state('serviceconfigs.pnsettings.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/pnsettings/pnsettingList.html',
				title: 'PN_SETTINGS',
				pageTitle: 'PN_SETTINGS',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'PushNotificationSettingMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.pnsettings.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/pnsettings/pnsettingCreate.html",
				title: 'CREATE_PN_SETTING',
				pageTitle: 'CREATE_PN_SETTING',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'PushNotificationSettingCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.pnsettings.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/pnsettings/pnsettingUpdate.html',
				title: 'UPDATE_PN_SETTING',
				pageTitle: 'UPDATE_PN_SETTING',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'PushNotificationSettingUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.processes', [
			'RmsAppV2.pages.serviceconfigs.processes.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/processes', '/serviceconfigs/processes/list')
			.when('/serviceconfigs/processes/', '/serviceconfigs/processes/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.processes', {
				url: '/processes',
				title: 'Processes',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 110,
				},
			})
			.state('serviceconfigs.processes.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/processes/processList.html',
				title: 'PROCESSES',
				pageTitle: 'PROCESSES',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcProcessMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.processes.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/processes/processCreate.html",
				title: 'CREATE_PROCESS',
				pageTitle: 'CREATE_PROCESS',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcProcessCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.processes.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/processes/processUpdate.html',
				title: 'UPDATE_PROCESS',
				pageTitle: 'UPDATE_PROCESS',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcProcessUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.rostertypes', [
			'RmsAppV2.pages.serviceconfigs.rostertypes.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/rostertypes', '/serviceconfigs/rostertypes/list')
			.when('/serviceconfigs/rostertypes/', '/serviceconfigs/rostertypes/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.rostertypes', {
				url: '/rostertypes',
				title: 'Roster Types',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('serviceconfigs.rostertypes.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/rostertypes/rostertypeList.html',
				title: 'Roster Types',
				pageTitle: 'Roster Types',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcRosterTypeMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.rostertypes.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/rostertypes/rostertypeCreate.html",
				title: 'Create Roster Type',
				pageTitle: 'Create Roster Type',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcRosterTypeCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.rostertypes.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/rostertypes/rostertypeUpdate.html',
				title: 'Update Roster Type',
				pageTitle: 'Update Roster Type',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcRosterTypeUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.services', [
			'RmsAppV2.pages.serviceconfigs.services.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/services', '/serviceconfigs/services/list')
			.when('/serviceconfigs/services/', '/serviceconfigs/services/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.services', {
				url: '/services',
				title: 'Services',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 100,
				},
			})
			.state('serviceconfigs.services.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/services/serviceList.html',
				title: 'SERVICES',
				pageTitle: 'SERVICES',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcServiceMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.services.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/services/serviceCreate.html",
				title: 'CREATE_SERVICE',
				pageTitle: 'CREATE_SERVICE',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcServiceCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.services.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/services/serviceUpdate.html',
				title: 'UPDATE_SERVICE',
				pageTitle: 'UPDATE_SERVICE',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcServiceUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.services.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/serviceconfigs/services/serviceImport.html',
				title: 'IMPORT_SERVICE',
				pageTitle: 'IMPORT_SERVICE',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcServiceImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.svctypes', [
			'RmsAppV2.pages.serviceconfigs.svctypes.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/svctypes', '/serviceconfigs/svctypes/list')
			.when('/serviceconfigs/svctypes/', '/serviceconfigs/svctypes/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.svctypes', {
				url: '/svctypes',
				title: 'Service Types',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('serviceconfigs.svctypes.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/servicetypes/svctypeList.html',
				title: 'SERVICE_TYPES',
				pageTitle: 'SERVICE_TYPES',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcTypeMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.svctypes.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/servicetypes/svctypeCreate.html",
				title: 'CREATE_SERVICE_TYPE',
				pageTitle: 'CREATE_SERVICE_TYPE',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcTypeCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.svctypes.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/servicetypes/svctypeUpdate.html',
				title: 'UPDATE_SERVICE_TYPE',
				pageTitle: 'UPDATE_SERVICE_TYPE',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcTypeUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.spareparts', [
			'RmsAppV2.pages.serviceconfigs.spareparts.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/spareparts', '/serviceconfigs/spareparts/list')
			.when('/serviceconfigs/spareparts/', '/serviceconfigs/spareparts/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.spareparts', {
				url: '/spareparts',
				title: 'Spare Parts',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('serviceconfigs.spareparts.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/spareparts/sparepartList.html',
				title: 'SPARE_PARTS',
				pageTitle: 'SPARE_PARTS',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SparePartMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.spareparts.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/spareparts/sparepartCreate.html",
				title: 'CREATE_SPARE_PART',
				pageTitle: 'CREATE_SPARE_PART',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SparePartCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.spareparts.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/spareparts/sparepartUpdate.html',
				title: 'UPDATE_SPARE_PART',
				pageTitle: 'UPDATE_SPARE_PART',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SparePartUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.spareparts.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/serviceconfigs/spareparts/sparepartImport.html',
				title: 'IMPORT_SPARE_PARTS',
				pageTitle: 'IMPORT_SPARE_PARTS',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SparePartImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.techteams', [
			'RmsAppV2.pages.serviceconfigs.techteams.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/techteams', '/serviceconfigs/techteams/list')
			.when('/serviceconfigs/techteams/', '/serviceconfigs/techteams/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.techteams', {
				url: '/techteams',
				title: 'Tech Teams',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 120,
				},
			})
			.state('serviceconfigs.techteams.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/techteams/techTeamList.html',
				title: 'TECH_TEAMS',
				pageTitle: 'TECH_TEAMS',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'TechTeamMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.techteams.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/techteams/techTeamCreate.html",
				title: 'CREATE_TECH_TEAM',
				pageTitle: 'CREATE_TECH_TEAM',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'TechTeamCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.techteams.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/techteams/techTeamUpdate.html',
				title: 'UPDATE_TECH_TEAM',
				pageTitle: 'UPDATE_TECH_TEAM',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'TechTeamUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.workorderstatuses', [
			'RmsAppV2.pages.serviceconfigs.workorderstatuses.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/workorderstatuses', '/serviceconfigs/workorderstatuses/list')
			.when('/serviceconfigs/workorderstatuses/', '/serviceconfigs/workorderstatuses/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.workorderstatuses', {
				url: '/workorderstatuses',
				title: 'Work Order Statuses',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 90,
				},
			})
			.state('serviceconfigs.workorderstatuses.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/workorderstatuses/workorderstatusList.html',
				title: 'WORK_ORDER_STATUSES',
				pageTitle: 'WORK_ORDER_STATUSES',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcWorkOrderStatusMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.workorderstatuses.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/workorderstatuses/workorderstatusCreate.html",
				title: 'CREATE_WORK_ORDER_STATUS',
				pageTitle: 'CREATE_WORK_ORDER_STATUS',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcWorkOrderStatusCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.workorderstatuses.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/workorderstatuses/workorderstatusUpdate.html',
				title: 'UPDATE_WORK_ORDER_STATUS',
				pageTitle: 'UPDATE_WORK_ORDER_STATUS',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcWorkOrderStatusUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.zones', [
			'RmsAppV2.pages.serviceconfigs.zones.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/zones', '/serviceconfigs/zones/list')
			.when('/serviceconfigs/zones/', '/serviceconfigs/zones/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.zones', {
				url: '/zones',
				title: 'Zones',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 130,
				},
			})
			.state('serviceconfigs.zones.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/zones/zoneList.html',
				title: 'ZONES',
				pageTitle: 'ZONESZones',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcZoneMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.zones.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/zones/zoneCreate.html",
				title: 'CREATE_ZONE',
				pageTitle: 'CREATE_ZONE',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcZoneCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.zones.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/zones/zoneUpdate.html',
				title: 'UPDATE_ZONE',
				pageTitle: 'UPDATE_ZONE',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcZoneUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.serviceconfigs.worktypes', [
			'RmsAppV2.pages.serviceconfigs.worktypes.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/serviceconfigs/worktypes', '/serviceconfigs/worktypes/list')
			.when('/serviceconfigs/worktypes/', '/serviceconfigs/worktypes/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('serviceconfigs.worktypes', {
				url: '/worktypes',
				title: 'Work Types',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 40	,
				},
			})
			.state('serviceconfigs.worktypes.list', {
				url: '/list',
				templateUrl: 'app/pages/serviceconfigs/worktypes/worktypeList.html',
				title: 'WORK_TYPES',
				pageTitle: 'WORK_TYPES',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcWorkTypeMainCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.worktypes.create', {
				url: '/create',
				templateUrl: "app/pages/serviceconfigs/worktypes/worktypeCreate.html",
				title: 'CREATE_WORK_TYPE',
				pageTitle: 'CREATE_WORK_TYPE',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcWorkTypeCreateCtrl',
				controllerAs: 'vm'
			})
			.state('serviceconfigs.worktypes.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/serviceconfigs/worktypes/worktypeUpdate.html',
				title: 'UPDATE_WORK_TYPE',
				pageTitle: 'UPDATE_WORK_TYPE',
				parentPath: 'AFTERSALES_CONFIG',
				controller: 'SvcWorkTypeUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.services.loanrequests', [
			'RmsAppV2.pages.services.loanrequests.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/services/loanrequests', '/services/loanrequests/list')
			.when('/services/loanrequests/', '/services/loanrequests/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('services.loanrequests', {
				url: '/loanrequests',
				title: 'Loan Requests',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('services.loanrequests.list', {
				url: '/list',
				templateUrl: 'app/pages/services/loanrequests/loanrequestList.html',
				title: 'LOAN_REQUESTS',
				pageTitle: 'LOAN_REQUESTS',
				parentPath: 'SERVICES',
				controller: 'LoanRequestMainCtrl',
				controllerAs: 'vm'
			})
			.state('services.loanrequests.create', {
				url: '/create',
				templateUrl: "app/pages/services/loanrequests/loanrequestCreate.html",
				title: 'CREATE_LOAN_REQUEST',
				pageTitle: 'CREATE_LOAN_REQUEST',
				parentPath: 'SERVICES',
				controller: 'LoanRequestCreateCtrl',
				controllerAs: 'vm'
			})
			.state('services.loanrequests.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/services/loanrequests/loanrequestUpdate.html',
				title: 'UPDATE_LOAN_REQUEST',
				pageTitle: 'UPDATE_LOAN_REQUEST',
				parentPath: 'SERVICES',
				controller: 'LoanRequestUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.services.dutyrosters', [
			'RmsAppV2.pages.services.dutyrosters.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/services/dutyrosters', '/services/dutyrosters/list')
			.when('/services/dutyrosters/', '/services/dutyrosters/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('services.dutyrosters', {
				url: '/dutyrosters',
				title: 'Duty Rosters',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 60,
				},
			})
			.state('services.dutyrosters.list', {
				url: '/list',
				templateUrl: 'app/pages/services/dutyrosters/dutyrosterList.html',
				title: 'DUTY_ROSTERS',
				pageTitle: 'DUTY_ROSTERS',
				parentPath: 'SERVICES',
				controller: 'DutyRosterMainCtrl',
				controllerAs: 'vm'
			})
			.state('services.dutyrosters.create', {
				url: '/create',
				templateUrl: "app/pages/services/dutyrosters/dutyrosterCreate.html",
				title: 'CREATE_DUTY_ROSTER',
				pageTitle: 'CREATE_DUTY_ROSTER',
				parentPath: 'SERVICES',
				controller: 'DutyRosterCreateCtrl',
				controllerAs: 'vm'
			})
			.state('services.dutyrosters.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/services/dutyrosters/dutyrosterUpdate.html',
				title: 'UPDATE_DUTY_ROSTER',
				pageTitle: 'UPDATE_DUTY_ROSTER',
				parentPath: 'SERVICES',
				controller: 'DutyRosterUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.services.warrantyclaim', [
			'RmsAppV2.pages.services.warrantyclaim.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/services/warrantyclaim', '/services/warrantyclaim/list')
			.when('/services/warrantyclaim/', '/services/warrantyclaim/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('services.warrantyclaim', {
				url: '/warrantyclaim',
				title: 'Warranty Claim List',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 50,
				},
			})
			.state('services.warrantyclaim.list', {
				url: '/list',
				templateUrl: 'app/pages/services/warrantyclaim/warrantyclaimList.html',
				title: 'WARRANTY_CLAIM',
				pageTitle: 'WARRANTY_CLAIM',
				parentPath: 'SERVICES',
				controller: 'WarrantyClaimMainCtrl',
				controllerAs: 'vm'
			})
			.state('services.warrantyclaim.create', {
				url: '/create',
				templateUrl: "app/pages/services/warrantyclaim/warrantyclaimCreate.html",
				title: 'CREATE_WARRANTY_CLAIM',
				pageTitle: 'CREATE_WARRANTY_CLAIM',
				parentPath: 'SERVICES',
				controller: 'WarrantyClaimCreateCtrl',
				controllerAs: 'vm'
			})
			.state('services.warrantyclaim.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/services/warrantyclaim/warrantyclaimUpdate.html',
				title: 'UPDATE_WARRANTY_CLAIM',
				pageTitle: 'UPDATE_WARRANTY_CLAIM',
				parentPath: 'SERVICES',
				controller: 'WarrantyClaimUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.services.casemanagement', [
			'RmsAppV2.pages.services.casemanagement.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/services/casemanagement', '/services/casemanagement/list')
			.when('/services/casemanagement/', '/services/casemanagement/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('services.casemanagement', {
				url: '/casemanagement',
				title: 'Case Management',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('services.casemanagement.list', {
				url: '/list',
				templateUrl: 'app/pages/services/casemanagement/casemgmtList.html',
				title: 'CASE_MANAGEMENT',
				pageTitle: 'CASE_MANAGEMENT',
				parentPath: 'SERVICES',
				controller: 'CaseManagementMainCtrl',
				controllerAs: 'vm'
			})
			.state('services.casemanagement.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/services/casemanagement/casemgmtUpdate.html',
				title: 'MANAGE_CASE',
				pageTitle: 'MANAGE_CASE',
				parentPath: 'SERVICES',
				controller: 'CaseManagementUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.services.warranty', [
			'RmsAppV2.pages.services.warranty.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/services/warranty', '/services/warranty/list')
			.when('/services/warranty/', '/services/warranty/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('services.warranty', {
				url: '/warranty',
				title: 'Warranty Management',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 40,
				},
			})
			.state('services.warranty.list', {
				url: '/list',
				templateUrl: 'app/pages/services/warranty/warrantyList.html',
				title: 'WARRANTY_MANAGEMENT',
				pageTitle: 'WARRANTY_MANAGEMENT',
				parentPath: 'SERVICES',
				controller: 'WarrantyMainCtrl',
				controllerAs: 'vm'
			})
			.state('services.warranty.create', {
				url: '/create',
				templateUrl: "app/pages/services/warranty/warrantyCreate.html",
				title: 'CREATE_WARRANTY',
				pageTitle: 'CREATE_WARRANTY',
				parentPath: 'SERVICES',
				controller: 'WarrantyCreateCtrl',
				controllerAs: 'vm'
			})
			.state('services.warranty.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/services/warranty/warrantyUpdate.html',
				title: 'UPDATE_WARRANTY',
				pageTitle: 'UPDATE_WARRANTY',
				parentPath: 'SERVICES',
				controller: 'WarrantyUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('services.warranty.batchcreate', {
				url: '/batchcreate',
				templateUrl: 'app/pages/services/warranty/warrantyBatchCreate.html',
				title: 'Batch Warranty Creation',
				pageTitle: 'Batch Warranty Creation',
				parentPath: 'SERVICES',
				controller: 'WarrantyBatchCreateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.settings.departments', [
			'RmsAppV2.pages.settings.departments.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/settings/departments', '/settings/departments/list')
			.when('/settings/departments/', '/settings/departments/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('settings.departments', {
				url: '/departments',
				title: 'Departments',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('settings.departments.list', {
				url: '/list',
				templateUrl: 'app/pages/settings/departments/departmentList.html',
				title: 'DEPARTMENTS',
				pageTitle: 'DEPARTMENTS',
				parentPath: 'SETTINGS',
				controller: 'DepartmentMainCtrl',
				controllerAs: 'vm'
			})
			.state('settings.departments.create', {
				url: '/create',
				templateUrl: "app/pages/settings/departments/departmentCreate.html",
				title: 'CREATE_DEPARTMENT',
				pageTitle: 'CREATE_DEPARTMENT',
				parentPath: 'SETTINGS',
				controller: 'DepartmentCreateCtrl',
				controllerAs: 'vm'
			})
			.state('settings.departments.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/settings/departments/departmentUpdate.html',
				title: 'UPDATE_DEPARTMENT',
				pageTitle: 'UPDATE_DEPARTMENT',
				parentPath: 'SETTINGS',
				controller: 'DepartmentUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.settings.branches', [
			'RmsAppV2.pages.settings.branches.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/settings/branches', '/settings/branches/list')
			.when('/settings/branches/', '/settings/branches/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('settings.branches', {
				url: '/branches',
				title: 'Branches',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('settings.branches.list', {
				url: '/list',
				templateUrl: 'app/pages/settings/branches/branchList.html',
				title: 'BRANCHES',
				pageTitle: 'BRANCHES',
				parentPath: 'SETTINGS',
				controller: 'BranchMainCtrl',
				controllerAs: 'vm'
			})
			.state('settings.branches.create', {
				url: '/create',
				templateUrl: "app/pages/settings/branches/branchCreate.html",
				title: 'CREATE_BRANCH',
				pageTitle: 'CREATE_BRANCH',
				parentPath: 'SETTINGS',
				controller: 'BranchCreateCtrl',
				controllerAs: 'vm'
			})
			.state('settings.branches.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/settings/branches/branchUpdate.html',
				title: 'UPDATE_BRANCH',
				pageTitle: 'UPDATE_BRANCH',
				parentPath: 'SETTINGS',
				controller: 'BranchUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.services.workorders', [
			'RmsAppV2.pages.services.workorders.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/services/workorders', '/services/workorders/list')
			.when('/services/workorders/', '/services/workorders/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('services.workorders', {
				url: '/workorders',
				title: 'Work Orders',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('services.workorders.list', {
				url: '/list',
				templateUrl: 'app/pages/services/workorders/workList.html',
				title: 'WORK_ORDER_LIST',
				pageTitle: 'WORK_ORDER_LIST',
				parentPath: 'SERVICES',
				controller: 'WorkOrderMainCtrl',
				controllerAs: 'vm'
			})
			.state('services.workorders.create', {
				url: '/create',
				templateUrl: "app/pages/services/workorders/workCreate.html",
				title: 'CREATE_WORK_ORDER',
				pageTitle: 'CREATE_WORK_ORDER',
				parentPath: 'SERVICES',
				controller: 'WorkOrderCreateCtrl',
				controllerAs: 'vm'
			})
			.state('services.workorders.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/services/workorders/workUpdate.html',
				title: 'UPDATE_WORK_ORDER',
				pageTitle: 'UPDATE_WORK_ORDER',
				parentPath: 'SERVICES',
				controller: 'WorkOrderUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.settings.iprules', [
			'RmsAppV2.pages.settings.iprules.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/settings/iprules', '/settings/iprules/list')
			.when('/settings/iprules/', '/settings/iprules/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('settings.iprules', {
				url: '/iprules',
				title: 'IP Rules',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 90,
				},
			})
			.state('settings.iprules.list', {
				url: '/list',
				templateUrl: 'app/pages/settings/iprules/ipRuleList.html',
				title: 'IP Rules',
				pageTitle: 'IP Rules',
				parentPath: 'SETTINGS',
				controller: 'IPRuleMainCtrl',
				controllerAs: 'vm'
			})
			.state('settings.iprules.create', {
				url: '/create',
				templateUrl: "app/pages/settings/iprules/ipRuleCreate.html",
				title: 'Create IP Rule',
				pageTitle: 'Create IP Rule',
				parentPath: 'SETTINGS',
				controller: 'IPRuleCreateCtrl',
				controllerAs: 'vm'
			})
			.state('settings.iprules.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/settings/iprules/ipRuleUpdate.html',
				title: 'Update IP Rule',
				pageTitle: 'Update IP Rule',
				parentPath: 'SETTINGS',
				controller: 'IPRuleUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.settings.labeltemplates', [
			'RmsAppV2.pages.settings.labeltemplates.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/settings/labeltemplates', '/settings/labeltemplates/list')
			.when('/settings/labeltemplates/', '/settings/labeltemplates/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('settings.labeltemplates', {
				url: '/labeltemplates',
				title: 'Label Templates',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 40,
				},
			})
			.state('settings.labeltemplates.list', {
				url: '/list',
				templateUrl: 'app/pages/settings/labeltemplates/labeltemplateList.html',
				title: 'LABEL_TEMPLATES',
				pageTitle: 'LABEL_TEMPLATES',
				parentPath: 'SETTINGS',
				controller: 'LabelTemplateMainCtrl',
				controllerAs: 'vm'
			})
			.state('settings.labeltemplates.create', {
				url: '/create',
				templateUrl: "app/pages/settings/labeltemplates/labeltemplateCreate.html",
				title: 'CREATE_LABEL_TEMPLATE',
				pageTitle: 'CREATE_LABEL_TEMPLATE',
				parentPath: 'SETTINGS',
				controller: 'LabelTemplateCreateCtrl',
				controllerAs: 'vm'
			})
			.state('settings.labeltemplates.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/settings/labeltemplates/labeltemplateUpdate.html',
				title: 'UPDATE_LABEL_TEMPLATE',
				pageTitle: 'UPDATE_LABEL_TEMPLATE',
				parentPath: 'SETTINGS',
				controller: 'LabelTemplateUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.settings.usergroups', [
			'RmsAppV2.pages.settings.usergroups.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/settings/usergroups', '/settings/usergroups/list')
			.when('/settings/usergroups/', '/settings/usergroups/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('settings.usergroups', {
				url: '/usergroups',
				title: 'Usergroups',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 70,
				},
			})
			.state('settings.usergroups.list', {
				url: '/list',
				templateUrl: 'app/pages/settings/usergroups/usergroupList.html',
				title: 'USERGROUPS',
				pageTitle: 'USERGROUPS',
				parentPath: 'SETTINGS',
				controller: 'UsergroupMainCtrl',
				controllerAs: 'vm'
			})
			.state('settings.usergroups.create', {
				url: '/create',
				templateUrl: "app/pages/settings/usergroups/usergroupCreate.html",
				title: 'CREATE_USERGROUP',
				pageTitle: 'CREATE_USERGROUP',
				parentPath: 'SETTINGS',
				controller: 'UsergroupCreateCtrl',
				controllerAs: 'vm'
			})
			.state('settings.usergroups.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/settings/usergroups/usergroupUpdate.html',
				title: 'UPDATE_USERGROUP',
				pageTitle: 'UPDATE_USERGROUP',
				parentPath: 'SETTINGS',
				controller: 'UsergroupUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.settings.notificationsettings', [
			'RmsAppV2.pages.settings.notificationsettings.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/settings/notificationsettings', '/settings/notificationsettings/list')
			.when('/settings/notificationsettings/', '/settings/notificationsettings/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('settings.notificationsettings', {
				url: '/notificationsettings',
				title: 'Notifications',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 50,
				},
			})
			.state('settings.notificationsettings.list', {
				url: '/list',
				templateUrl: 'app/pages/settings/notificationsettings/notificationsettingList.html',
				title: 'NOTIFICATION_SETTINGS',
				pageTitle: 'NOTIFICATION_SETTINGS',
				parentPath: 'SETTINGS',
				controller: 'NotificationSettingMainCtrl',
				controllerAs: 'vm'
			})
			.state('settings.notificationsettings.create', {
				url: '/create',
				templateUrl: "app/pages/settings/notificationsettings/notificationsettingCreate.html",
				title: 'CREATE_NOTIFICATION',
				pageTitle: 'CREATE_NOTIFICATION',
				parentPath: 'SETTINGS',
				controller: 'NotificationSettingCreateCtrl',
				controllerAs: 'vm'
			})
			.state('settings.notificationsettings.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/settings/notificationsettings/notificationsettingUpdate.html',
				title: 'UPDATE_NOTIFICATION',
				pageTitle: 'UPDATE_NOTIFICATION',
				parentPath: 'SETTINGS',
				controller: 'NotificationSettingUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.settings.resellercommconfig', [
			'RmsAppV2.pages.settings.resellercommconfig.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/settings/resellercommconfig', '/settings/resellercommconfig/list')
			.when('/settings/resellercommconfig/', '/settings/resellercommconfig/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('settings.resellercommconfig', {
				url: '/resellercommconfig',
				title: 'Reseller Commission Configuration',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 13,
				},
			})
			.state('settings.resellercommconfig.list', {
				url: '/list',
				templateUrl: 'app/pages/settings/resellercommconfig/resellerCommConfigList.html',
				title: 'Reseller Commission Configuration',
				pageTitle: 'Reseller Commission Configuration',
				parentPath: 'SETTINGS',
				controller: 'ResellerCommissionConfigMainCtrl',
				controllerAs: 'vm'
			})
			.state('settings.resellercommconfig.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/settings/resellercommconfig/resellerCommConfigUpdate.html',
				title: 'Update Commission Configuration',
				pageTitle: 'Update Commission Configuration',
				parentPath: 'SETTINGS',
				controller: 'ResellerCommissionConfigUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.settings.users', [
			'RmsAppV2.pages.settings.users.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/settings/users', '/settings/users/list')
			.when('/settings/users/', '/settings/users/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('settings.users', {
				url: '/users',
				title: 'Users',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 80,
				},
			})
			.state('settings.users.list', {
				url: '/list',
				templateUrl: 'app/pages/settings/users/userList.html',
				title: 'USERS',
				pageTitle: 'USERS',
				parentPath: 'SETTINGS',
				controller: 'UserMainCtrl',
				controllerAs: 'vm'
			})
			.state('settings.users.create', {
				url: '/create',
				templateUrl: "app/pages/settings/users/userCreate.html",
				title: 'CREATE_USER',
				pageTitle: 'CREATE_USER',
				parentPath: 'SETTINGS',
				controller: 'UserCreateCtrl',
				controllerAs: 'vm'
			})
			.state('settings.users.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/settings/users/userUpdate.html',
				title: 'UPDATE_USER',
				pageTitle: 'UPDATE_USER',
				parentPath: 'SETTINGS',
				controller: 'UserUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.smartiotsettings.devicegroups', [
			'RmsAppV2.pages.smartiotsettings.devicegroups.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/smartiotsettings/devicegroups', '/smartiotsettings/devicegroups/list')
			.when('/smartiotsettings/devicegroups/', '/smartiotsettings/devicegroups/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('smartiotsettings.devicegroups', {
				url: '/devicegroups',
				title: 'Device Groups',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('smartiotsettings.devicegroups.list', {
				url: '/list',
				templateUrl: 'app/pages/smartiotsettings/devicegroups/groupingList.html',
				title: 'Device Groups',
				pageTitle: 'Device Groups',
				parentPath: 'Smart IoT Settings',
				controller: 'SmartIoTDeviceGroupMainCtrl',
				controllerAs: 'vm'
			})
			.state('smartiotsettings.devicegroups.create', {
				url: '/create',
				templateUrl: "app/pages/smartiotsettings/devicegroups/groupingCreate.html",
				title: 'Create Device Group',
				pageTitle: 'Create Device Group',
				parentPath: 'Smart IoT Settings',
				controller: 'SmartIoTDeviceGroupCreateCtrl',
				controllerAs: 'vm'
			})
			.state('smartiotsettings.devicegroups.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/smartiotsettings/devicegroups/groupingUpdate.html',
				title: 'Update Device Group',
				pageTitle: 'Update Device Group',
				parentPath: 'Smart IoT Settings',
				controller: 'SmartIoTDeviceGroupUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.smartiotsettings.gateways', [
			'RmsAppV2.pages.smartiotsettings.gateways.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/smartiotsettings/gateways', '/smartiotsettings/gateways/list')
			.when('/smartiotsettings/gateways/', '/smartiotsettings/gateways/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('smartiotsettings.gateways', {
				url: '/gateways',
				title: 'Smart Gateways',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('smartiotsettings.gateways.list', {
				url: '/list',
				templateUrl: 'app/pages/smartiotsettings/gateways/gatewayList.html',
				title: 'Smart Gateways',
				pageTitle: 'Smart Gateways',
				parentPath: 'Smart IoT Settings',
				controller: 'SmartIoTGatewayMainCtrl',
				controllerAs: 'vm'
			})
			.state('smartiotsettings.gateways.create', {
				url: '/create',
				templateUrl: "app/pages/smartiotsettings/gateways/gatewayCreate.html",
				title: 'Create Smart Gateway',
				pageTitle: 'Create Smart Gateway',
				parentPath: 'Smart IoT Settings',
				controller: 'SmartIoTGatewayCreateCtrl',
				controllerAs: 'vm'
			})
			.state('smartiotsettings.gateways.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/smartiotsettings/gateways/gatewayUpdate.html',
				title: 'Update Smart Gateway',
				pageTitle: 'Update Smart Gateway',
				parentPath: 'Smart IoT Settings',
				controller: 'SmartIoTGatewayUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.smartiotsettings.notifications', [
			'RmsAppV2.pages.smartiotsettings.notifications.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/smartiotsettings/notifications', '/smartiotsettings/notifications/list')
			.when('/smartiotsettings/notifications/', '/smartiotsettings/notifications/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('smartiotsettings.notifications', {
				url: '/notifications',
				title: 'Notification Settings',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('smartiotsettings.notifications.list', {
				url: '/list',
				templateUrl: 'app/pages/smartiotsettings/notifications/notificationList.html',
				title: 'Notification Settings',
				pageTitle: 'Notification Settings',
				parentPath: 'Smart IoT Settings',
				controller: 'SmartIoTNotificationMainCtrl',
				controllerAs: 'vm'
			})
			.state('smartiotsettings.notifications.create', {
				url: '/create',
				templateUrl: "app/pages/smartiotsettings/notifications/notificationCreate.html",
				title: 'Create Notification Setting',
				pageTitle: 'Create Notification Setting',
				parentPath: 'Smart IoT Settings',
				controller: 'SmartIoTNotificationCreateCtrl',
				controllerAs: 'vm'
			})
			.state('smartiotsettings.notifications.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/smartiotsettings/notifications/notificationUpdate.html',
				title: 'Update Notification Setting',
				pageTitle: 'Update Notification Setting',
				parentPath: 'Smart IoT Settings',
				controller: 'SmartIoTNotificationUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.smartkitchen.joblist', [
			'RmsAppV2.pages.smartkitchen.joblist.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/smartkitchen/joblist', '/smartkitchen/joblist/list')
			.when('/smartkitchen/joblist/', '/smartkitchen/joblist/list')
			.otherwise('/dashboard');

		$stateProvider
			.state('smartkitchen.joblist', {
				url: '/joblist',
				title: 'SMART_KITCHEN',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('smartkitchen.joblist.list', {
				url: '/list',
				templateUrl: 'app/pages/smartkitchen/joblist/skjobList.html',
				title: 'SMART_KITCHEN_JOB_LIST',
				pageTitle: 'SMART_KITCHEN_JOB_LIST',
				parentPath: 'SMART_KITCHEN',
                controller: 'SmartKitchenJobListCtrl',
                controllerAs: 'vm'
			})
			.state('smartkitchen.joblist.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/smartkitchen/joblist/skjob.html',
				title: 'SMART_KITCHEN',
				pageTitle: 'SMART_KITCHEN',
				parentPath: 'SMART_KITCHEN',
				controller: 'SmartKitchenJobCtrl',
				controllerAs: 'vm'
			});
  }

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.smartiotsettings.planviewdesigner', [
			'RmsAppV2.pages.smartiotsettings.planviewdesigner.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/smartiotsettings/planviewdesigner', '/smartiotsettings/planviewdesigner/list')
			.when('/smartiotsettings/planviewdesigner/', '/smartiotsettings/planviewdesigner/list')
			.otherwise('/planviewdesigner');
			
		$stateProvider
			.state('smartiotsettings.planviewdesigner', {
				url: '/planviewdesigner',
				title: 'Smart IOT PlanView Designer',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('smartiotsettings.planviewdesigner.list', {
				url: '/list',
				templateUrl: 'app/pages/smartiotsettings/planviewdesigner/planviewdesignerList.html',
				title: 'Smart IOT PlanView Designer',
				pageTitle: 'Smart IOT PlanView Designer',
				parentPath: 'Smart IOT Settings',
				controller: 'SmartIoTPlanViewDesignerMainCtrl',
				controllerAs: 'vm'
			})
			.state('smartiotsettings.planviewdesigner.create', {
				url: '/create',
				templateUrl: "app/pages/smartiotsettings/planviewdesigner/planviewdesignerCreate.html",
				title: 'Create PlanView Design',
				pageTitle: 'Create PlanView Design',
				parentPath: 'Smart IOT PlanView Designer',
				controller: 'SmartIoTPlanViewDesignerCreateCtrl',
				controllerAs: 'vm'
			})
			.state('smartiotsettings.planviewdesigner.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/smartiotsettings/planviewdesigner/planviewdesignerUpdate.html',
				title: 'Update PlanView Design',
				pageTitle: 'Update PlanView Design',
				parentPath: 'Smart IOT PlanView Designer',
				controller: 'SmartIoTPlanViewDesignerUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.smartkitchen.machineconnectionprofiles', [
			'RmsAppV2.pages.smartkitchen.machineconnectionprofiles.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/smartkitchen/machineconnectionprofiles', '/smartkitchen/machineconnectionprofiles/list')
			.when('/smartkitchen/machineconnectionprofiles/', '/smartkitchen/machineconnectionprofiles/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('smartkitchen.machineconnectionprofiles', {
				url: '/machineconnectionprofiles',
				title: 'MACHINE_CONNECTION_PROFILES',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('smartkitchen.machineconnectionprofiles.list', {
				url: '/list',
				templateUrl: 'app/pages/smartkitchen/mcprofiles/mcprofileList.html',
				title: 'MACHINE_CONNECTION_PROFILES',
				pageTitle: 'MACHINE_CONNECTION_PROFILES',
				parentPath: 'SMART_KITCHEN',
				controller: 'SmartKitchenMachineConnectionProfileMainCtrl',
				controllerAs: 'vm'
			})
			.state('smartkitchen.machineconnectionprofiles.create', {
				url: '/create',
				templateUrl: "app/pages/smartkitchen/mcprofiles/mcprofileCreate.html",
				title: 'CREATE_MACHINE_CONNECTION_PROFILE',
				pageTitle: 'CREATE_MACHINE_CONNECTION_PROFILE',
				parentPath: 'SMART_KITCHEN',
				controller: 'SmartKitchenMachineConnectionProfileCreateCtrl',
				controllerAs: 'vm'
			})
			.state('smartkitchen.machineconnectionprofiles.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/smartkitchen/mcprofiles/mcprofileUpdate.html',
				title: 'UPDATE_MACHINE_CONNECTION_PROFILE',
				pageTitle: 'UPDATE_MACHINE_CONNECTION_PROFILE',
				parentPath: 'SMART_KITCHEN',
				controller: 'SmartKitchenMachineConnectionProfileUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.smartiotsettings.sensors', [
			'RmsAppV2.pages.smartiotsettings.sensors.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/smartiotsettings/sensors', '/smartiotsettings/sensors/list')
			.when('/smartiotsettings/sensors/', '/smartiotsettings/sensors/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('smartiotsettings.sensors', {
				url: '/sensors',
				title: 'Sensors',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('smartiotsettings.sensors.list', {
				url: '/list',
				templateUrl: 'app/pages/smartiotsettings/sensors/sensorList.html',
				title: 'Sensors',
				pageTitle: 'Sensors',
				parentPath: 'Smart IoT Settings',
				controller: 'SmartIoTSensorMainCtrl',
				controllerAs: 'vm'
			})
			.state('smartiotsettings.sensors.create', {
				url: '/create',
				templateUrl: "app/pages/smartiotsettings/sensors/sensorCreate.html",
				title: 'Create Sensor',
				pageTitle: 'Create Sensor',
				parentPath: 'Smart IoT Settings',
				controller: 'SmartIoTSensorCreateCtrl',
				controllerAs: 'vm'
			})
			.state('smartiotsettings.sensors.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/smartiotsettings/sensors/sensorUpdate.html',
				title: 'Update Sensor',
				pageTitle: 'Update Sensor',
				parentPath: 'Smart IoT Settings',
				controller: 'SmartIoTSensorUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.smartkitchen.skbranches', [
			'RmsAppV2.pages.smartkitchen.skbranches.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/smartkitchen/skbranches', '/smartkitchen/skbranches/list')
			.when('/smartkitchen/skbranches/', '/smartkitchen/skbranches/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('smartkitchen.skbranches', {
				url: '/skbranches',
				title: 'SMART_KITCHEN_BRANCH_LIST',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('smartkitchen.skbranches.list', {
				url: '/list',
				templateUrl: 'app/pages/smartkitchen/skbranches/skBranchList.html',
				title: 'SMART_KITCHEN_BRANCH_LIST',
				pageTitle: 'SMART_KITCHEN_BRANCH_LIST',
				parentPath: 'SMART_KITCHEN',
				controller: 'SmartKitchenBranchesMainCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.sops.categories', [
			'RmsAppV2.pages.sops.categories.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/sops/categories', '/sops/categories/list')
			.when('/sops/categories/', '/sops/categories/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('sops.categories', {
				url: '/categories',
				title: 'Manage Categories',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('sops.categories.list', {
				url: '/list',
				templateUrl: 'app/pages/sops/categories/categoryList.html',
				title: 'SOP_CATEGORIES',
				pageTitle: 'SOP_CATEGORIES',
				parentPath: 'SOPS',
				controller: 'SOPCategoryMainCtrl',
				controllerAs: 'vm'
			})
			.state('sops.categories.create', {
				url: '/create',
				templateUrl: "app/pages/sops/categories/categoryCreate.html",
				title: 'CREATE_SOP_CATEGORY',
				pageTitle: 'CREATE_SOP_CATEGORY',
				parentPath: 'SOPS',
				controller: 'SOPCategoryCreateCtrl',
				controllerAs: 'vm'
			})
			.state('sops.categories.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/sops/categories/categoryUpdate.html',
				title: 'UPDATE_SOP_CATEGORY',
				pageTitle: 'UPDATE_SOP_CATEGORY',
				parentPath: 'SOPS',
				controller: 'SOPCategoryUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.sops.cards', [
			'RmsAppV2.pages.sops.cards.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/sops/cards', '/sops/cards/card-categories')
			.when('/sops/cards/', '/sops/cards/card-categories')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('sops.cards', {
				url: '/cards',
				title: 'S.O.P. Cards',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 40,
				},
			})
			.state('sops.cards.categories', {
				url: '/card-categories',
				templateUrl: 'app/pages/sops/cards/cardCategories.html',
				title: 'SOP_CATEGORIES',
				pageTitle: 'SOP_CATEGORIES',
				parentPath: 'SOPS',
				controller: 'SOPCardCategoriesCtrl',
				controllerAs: 'vm'
			})
			.state('sops.cards.sops', {
				url: '/card-sops/:id',
				templateUrl: "app/pages/sops/cards/cardSops.html",
				title: 'SOP_LIST',
				pageTitle: 'SOP_LIST',
				parentPath: 'SOPS',
				controller: 'SOPCardSOPsCtrl',
				controllerAs: 'vm'
			})
			.state('sops.cards.view', {
				url: '/card-view/:id',
				templateUrl: "app/pages/sops/cards/cardView.html",
				title: 'SOP_CARD',
				pageTitle: 'SOP_CARD',
				parentPath: 'SOPS',
				controller: 'SOPCardViewCtrl',
				controllerAs: 'vm'
			});
	}
	
})();

(function () {
	'use strict';

	angular.module('RmsAppV2.pages.sops.sops', [
			'RmsAppV2.pages.sops.sops.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/sops/sops', '/sops/sops/category-list')
			.when('/sops/sops/', '/sops/sops/category-list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('sops.sops', {
				url: '/sops',
				title: 'Manage S.O.P.s',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('sops.sops.categorylist', {
				url: '/category-list',
				templateUrl: 'app/pages/sops/sops/sopCategoryList.html',
				title: 'SOP_CATEGORIES',
				pageTitle: 'SOP_CATEGORIES',
				parentPath: 'SOPS',
				controller: 'SOPCatMainCtrl',
				controllerAs: 'vm'
			})
			.state('sops.sops.list', {
				url: '/list/:id',
				templateUrl: 'app/pages/sops/sops/sopList.html',
				title: 'SOP_LIST',
				pageTitle: 'SOP_LIST',
				pparentPath: 'SOPS',
				controller: 'SOPMainCtrl',
				controllerAs: 'vm'
			})
			.state('sops.sops.create', {
				url: '/create',
				templateUrl: "app/pages/sops/sops/sopCreate.html",
				title: 'CREATE_SOP',
				pageTitle: 'CREATE_SOP',
				pparentPath: 'SOPS',
				controller: 'SOPCreateCtrl',
				controllerAs: 'vm'
			})
			.state('sops.sops.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/sops/sops/sopUpdate.html',
				title: 'UPDATE_SOP',
				pageTitle: 'UPDATE_SOP',
				pparentPath: 'SOPS',
				controller: 'SOPUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.sops.soptypes', [
			'RmsAppV2.pages.sops.soptypes.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/sops/soptypes', '/sops/soptypes/list')
			.when('/sops/soptypes/', '/sops/soptypes/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('sops.soptypes', {
				url: '/soptypes',
				title: 'Manage Types',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('sops.soptypes.list', {
				url: '/list',
				templateUrl: 'app/pages/sops/soptypes/soptypeList.html',
				title: 'SOP_TYPES',
				pageTitle: 'SOP_TYPES',
				parentPath: 'SOPS',
				controller: 'SOPTypeMainCtrl',
				controllerAs: 'vm'
			})
			.state('sops.soptypes.create', {
				url: '/create',
				templateUrl: "app/pages/sops/soptypes/soptypeCreate.html",
				title: 'CREATE_SOP_TYPE',
				pageTitle: 'CREATE_SOP_TYPE',
				parentPath: 'SOPS',
				controller: 'SOPTypeCreateCtrl',
				controllerAs: 'vm'
			})
			.state('sops.soptypes.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/sops/soptypes/soptypeUpdate.html',
				title: 'UPDATE_SOP_TYPE',
				pageTitle: 'UPDATE_SOP_TYPE',
				parentPath: 'SOPS',
				controller: 'SOPTypeUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.affiliates', [
			'RmsAppV2.pages.superadmin.affiliates.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/affiliates', '/superadmin/affiliates/list')
			.when('/superadmin/affiliates/', '/superadmin/affiliates/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.affiliates', {
				url: '/affiliates',
				title: 'Affiliates Management',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 13,
				},
			})
			.state('superadmin.affiliates.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/affiliates/affiliateList.html',
				title: 'Affiliates Management',
				pageTitle: 'Affiliates Management',
				parentPath: 'Super Admin',
				controller: 'SAAffiliateMainCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.affiliates.create', {
				url: '/create',
				templateUrl: "app/pages/superadmin/affiliates/affiliateCreate.html",
				title: 'Create Affiliate',
				pageTitle: 'Create Affiliate',
				parentPath: 'Super Admin',
				controller: 'SAAffiliateCreateCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.affiliates.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/superadmin/affiliates/affiliateUpdate.html',
				title: 'Update Affiliate',
				pageTitle: 'Update Affiliate',
				parentPath: 'Super Admin',
				controller: 'SAAffiliateUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.announcements', [
        'RmsAppV2.pages.superadmin.announcements.controller',
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $urlRouterProvider
            .when('/superadmin/announcements', '/superadmin/announcements/list')
            .when('/superadmin/announcements/', '/superadmin/announcements/list')
            .otherwise('/dashboard');

        $stateProvider
            .state('superadmin.announcements', {
                url: '/announcements',
                title: 'Announcements',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
                sidebarMeta: {
                    order: 100,
                },
            })
            .state('superadmin.announcements.list', {
                url: '/list',
                templateUrl: 'app/pages/superadmin/announcements/announcementList.html',
                title: 'Announcements',
                pageTitle: 'Announcements',
                parentPath: 'Super Admin',
                controller: 'SAAnnouncementMainCtrl',
                controllerAs: 'vm'
            })
            .state('superadmin.announcements.create', {
                url: '/create',
                templateUrl: "app/pages/superadmin/announcements/announcementCreate.html",
                title: 'Create Announcement',
                pageTitle: 'Create Announcement',
                parentPath: 'Super Admin',
                controller: 'SAAnnouncementCreateCtrl',
                controllerAs: 'vm'
            })
            .state('superadmin.announcements.update', {
                url: '/update/:id',
                templateUrl: 'app/pages/superadmin/announcements/announcementUpdate.html',
                title: 'Update Announcement',
                pageTitle: 'Update Announcement',
                parentPath: 'Super Admin',
                controller: 'SAAnnouncementUpdateCtrl',
                controllerAs: 'vm'
            });
    }

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.affiliates_newcustomer', [
			'RmsAppV2.pages.superadmin.affiliates_newcustomer.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/affiliates_newcustomer', '/superadmin/affiliates_newcustomer/list')
			.when('/superadmin/affiliates_newcustomer/', '/superadmin/affiliates_newcustomer/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.affiliates_newcustomer', {
				url: '/affiliates_newcustomer',
				title: 'Affiliates Customers Approval',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 13,
				},
			})
			.state('superadmin.affiliates_newcustomer.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/affiliates_newcustomer/affCustomerList.html',
				title: 'Affiliates Customers Approval',
				pageTitle: 'Affiliates Customers Approval',
				parentPath: 'Super Admin',
				controller: 'SAAffiliateNewCustomerMainCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.branches', [
			'RmsAppV2.pages.superadmin.branches.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/branches', '/superadmin/branches/list')
			.when('/superadmin/branches/', '/superadmin/branches/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.branches', {
				url: '/branches',
				title: 'Branches',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 20,
				},
			})
			.state('superadmin.branches.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/branches/branchList.html',
				title: 'Branches',
				pageTitle: 'Branches',
				parentPath: 'Super Admin',
				controller: 'SABranchMainCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.branches.create', {
				url: '/create',
				templateUrl: "app/pages/superadmin/branches/branchCreate.html",
				title: 'Create Branch',
				pageTitle: 'Create Branch',
				parentPath: 'Super Admin',
				controller: 'SABranchCreateCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.branches.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/superadmin/branches/branchUpdate.html',
				title: 'Update Branch',
				pageTitle: 'Update Branch',
				parentPath: 'Super Admin',
				controller: 'SABranchUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.commissions', [
			'RmsAppV2.pages.superadmin.commissions.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/commissions', '/superadmin/commissions/create')
			.when('/superadmin/commissions/', '/superadmin/commissions/create')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.commissions', {
				url: '/commissions',
				title: 'commissions',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				requireSA: true,
				sidebarMeta: {
					order: 40,
				},
			})
			.state('superadmin.commissions.create', {
				url: '/create',
				templateUrl: "app/pages/superadmin/commissions/commissionCreate.html",
				title: 'Commissions (Dealer)',
				pageTitle: 'Commissions (Dealer)',
				parentPath: 'Super Admin',
				controller: 'SACommissionCtrl',
				controllerAs: 'vm',
				requireSA: true,
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.businessmetrics', [
			'RmsAppV2.pages.superadmin.businessmetrics.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/businessmetrics', '/superadmin/businessmetrics/list')
			.when('/superadmin/businessmetrics/', '/superadmin/businessmetrics/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.businessmetrics', {
				url: '/businessmetrics',
				title: 'Version',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				requireSA: true,
				sidebarMeta: {
					order: 100,
				},
			})
			.state('superadmin.businessmetrics.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/businessmetrics/businessmetric.html',
				title: 'Business Metrics',
				pageTitle: 'Business Metrics',
				parentPath: 'Super Admin',
				controller: 'BusinessMetricsCtrl',
				controllerAs: 'vm',
				requireSA: true,
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.companies', [
			'RmsAppV2.pages.superadmin.companies.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/companies', '/superadmin/companies/list')
			.when('/superadmin/companies/', '/superadmin/companies/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.companies', {
				url: '/companies',
				title: 'Companies',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				requireSA: true,
				sidebarMeta: {
					order: 15,
				},
			})
			.state('superadmin.companies.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/companies/companyList.html',
				title: 'Companies',
				pageTitle: 'Companies',
				parentPath: 'Super Admin',
				controller: 'CompanyMainCtrl',
				controllerAs: 'vm',
				requireSA: true,
			})
			.state('superadmin.companies.create', {
				url: '/create',
				templateUrl: "app/pages/superadmin/companies/companyCreate.html",
				title: 'Create Company',
				pageTitle: 'Create Company',
				parentPath: 'Super Admin',
				controller: 'CompanyCreateCtrl',
				controllerAs: 'vm',
				requireSA: true,
			})
			.state('superadmin.companies.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/superadmin/companies/companyUpdate.html',
				title: 'Update Company',
				pageTitle: 'Update Company',
				parentPath: 'Super Admin',
				controller: 'CompanyUpdateCtrl',
				controllerAs: 'vm',
				requireSA: true,
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.features', [
			'RmsAppV2.pages.superadmin.features.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/features', '/superadmin/features/list')
			.when('/superadmin/features/', '/superadmin/features/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.features', {
				url: '/features',
				title: 'Features',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				requireSA: true,
				sidebarMeta: {
					order: 50,
				},
			})
			.state('superadmin.features.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/features/featureList.html',
				title: 'Feature List',
				pageTitle: 'Feature List',
				parentPath: 'Super Admin',
				controller: 'FeatureMainCtrl',
				controllerAs: 'vm',
				requireSA: true,
			})
			.state('superadmin.features.create', {
				url: '/create',
				templateUrl: "app/pages/superadmin/features/featureCreate.html",
				title: 'Create Feature',
				pageTitle: 'Create Feature',
				parentPath: 'Super Admin',
				controller: 'FeatureCreateCtrl',
				controllerAs: 'vm',
				requireSA: true,
			})
			.state('superadmin.features.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/superadmin/features/featureUpdate.html',
				title: 'Update Feature',
				pageTitle: 'Update Feature',
				parentPath: 'Super Admin',
				controller: 'FeatureUpdateCtrl',
				controllerAs: 'vm',
				requireSA: true,
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.companysettings', [
			'RmsAppV2.pages.superadmin.companysettings.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/companysettings', '/superadmin/companysettings/list')
			.when('/superadmin/companysettings/', '/superadmin/companysettings/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.companysettings', {
				url: '/companysettings',
				title: 'Company Settings',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				//requireSA: true,
				sidebarMeta: {
					order: 15,
				},
			})
			.state('superadmin.companysettings.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/companysettings/companysettingList.html',
				title: 'Company Settings',
				pageTitle: 'Company Settings',
				parentPath: 'Super Admin',
				controller: 'CompanySettingMainCtrl',
				controllerAs: 'vm',
				//requireSA: true,
			})
			.state('superadmin.companysettings.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/superadmin/companysettings/companysettingUpdate.html',
				title: 'Update Company Settings',
				pageTitle: 'Update Company Settings',
				parentPath: 'Super Admin',
				controller: 'CompanySettingUpdateCtrl',
				controllerAs: 'vm',
				//requireSA: true,
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.intercompanyitemmappings', [
			'RmsAppV2.pages.superadmin.intercompanyitemmappings.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/intercompanyitemmappings', '/superadmin/intercompanyitemmappings/list')
			.when('/superadmin/intercompanyitemmappings/', '/superadmin/intercompanyitemmappings/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.intercompanyitemmappings', {
				url: '/intercompanyitemmappings',
				title: 'Inter-Company Item Mappings',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			})
			.state('superadmin.intercompanyitemmappings.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/intercompanyitemmappings/mappingList.html',
				title: 'Inter-Company Item Mappings',
				pageTitle: 'Inter-Company Item Mappings',
				parentPath: 'Super Admin',
				controller: 'SAInterCompanyItemMappingMainCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.intercompanyitemmappings.create', {
				url: '/create',
				templateUrl: "app/pages/superadmin/intercompanyitemmappings/mappingCreate.html",
				title: 'Create Item Mapping',
				pageTitle: 'Create Item Mapping',
				parentPath: 'Super Admin',
				controller: 'SAInterCompanyItemMappingCreateCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.intercompanyitemmappings.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/superadmin/intercompanyitemmappings/mappingUpdate.html',
				title: 'Update Item Mapping',
				pageTitle: 'Update Item Mapping',
				parentPath: 'Super Admin',
				controller: 'SAInterCompanyItemMappingUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.intercompanyitemmappings.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/superadmin/intercompanyitemmappings/mappingImport.html',
				title: 'Import Item Mapping',
				pageTitle: 'Import Item Mapping',
				parentPath: 'Super Admin',
				controller: 'SAInterCompanyItemMappingImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.iotregdevices', [
			'RmsAppV2.pages.superadmin.iotregdevices.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/iotregdevices', '/superadmin/iotregdevices/list')
			.when('/superadmin/iotregdevices/', '/superadmin/iotregdevices/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.iotregdevices', {
				url: '/iotregdevices',
				title: 'IoT Devices Management',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('superadmin.iotregdevices.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/iotregdevices/iotRegDeviceList.html',
				title: 'IoT Devices Management',
				pageTitle: 'IoT Devices Management',
				parentPath: 'Super Admin',
				controller: 'SAIoTRegDeviceMainCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.iotregdevices.create', {
				url: '/create',
				templateUrl: "app/pages/superadmin/iotregdevices/iotRegDeviceCreate.html",
				title: 'Create IoT Device',
				pageTitle: 'Create IoT Device',
				parentPath: 'Super Admin',
				controller: 'SAIoTRegDeviceCreateCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.iotregdevices.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/superadmin/iotregdevices/iotRegDeviceUpdate.html',
				title: 'Update IoT Device',
				pageTitle: 'Update IoT Device',
				parentPath: 'Super Admin',
				controller: 'SAIoTRegDeviceUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.payments', [
			'RmsAppV2.pages.superadmin.payments.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/payments', '/superadmin/payments/create')
			.when('/superadmin/payments/', '/superadmin/payments/create')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.payments', {
				url: '/payments',
				title: 'Payments',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				requireSA: true,
				sidebarMeta: {
					order: 40,
				},
			})
			.state('superadmin.payments.create', {
				url: '/create',
				templateUrl: "app/pages/superadmin/payments/paymentCreate.html",
				title: 'Payment (Customers)',
				pageTitle: 'Payment (Customers)',
				parentPath: 'Super Admin',
				controller: 'SAPaymentCtrl',
				controllerAs: 'vm',
				requireSA: true,
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.intercompanymappings', [
			'RmsAppV2.pages.superadmin.intercompanymappings.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/intercompanymappings', '/superadmin/intercompanymappings/list')
			.when('/superadmin/intercompanymappings/', '/superadmin/intercompanymappings/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.intercompanymappings', {
				url: '/intercompanymappings',
				title: 'Inter-Company Mappings',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			})
			.state('superadmin.intercompanymappings.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/intercompanymappings/mappingList.html',
				title: 'Inter-Company Mappings',
				pageTitle: 'Inter-Company Mappings',
				parentPath: 'Super Admin',
				controller: 'SAInterCompanyMappingMainCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.intercompanymappings.create', {
				url: '/create',
				templateUrl: "app/pages/superadmin/intercompanymappings/mappingCreate.html",
				title: 'Create Mapping',
				pageTitle: 'Create Mapping',
				parentPath: 'Super Admin',
				controller: 'SAInterCompanyMappingCreateCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.intercompanymappings.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/superadmin/intercompanymappings/mappingUpdate.html',
				title: 'Update Mapping',
				pageTitle: 'Update Mapping',
				parentPath: 'Super Admin',
				controller: 'SAInterCompanyMappingUpdateCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.intercompanymappings.import', {
				url: '/import/:id',
				templateUrl: 'app/pages/superadmin/intercompanymappings/mappingImport.html',
				title: 'Import Mapping',
				pageTitle: 'Import Mapping',
				parentPath: 'Super Admin',
				controller: 'SAInterCompanyMappingImportCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.serverpackages', [
			'RmsAppV2.pages.superadmin.serverpackages.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/serverpackages', '/superadmin/serverpackages/list')
			.when('/superadmin/serverpackages/', '/superadmin/serverpackages/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.serverpackages', {
				url: '/serverpackages',
				title: 'Packages',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				requireSA: true,
				sidebarMeta: {
					order: 70,
				},
			})
			.state('superadmin.serverpackages.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/serverpackages/packageList.html',
				title: 'Package List',
				pageTitle: 'Package List',
				parentPath: 'Super Admin',
				controller: 'PackageMainCtrl',
				controllerAs: 'vm',
				requireSA: true,
			})
			.state('superadmin.serverpackages.create', {
				url: '/create',
				templateUrl: "app/pages/superadmin/serverpackages/packageCreate.html",
				title: 'Create Package',
				pageTitle: 'Create Package',
				parentPath: 'Super Admin',
				controller: 'PackageCreateCtrl',
				controllerAs: 'vm',
				requireSA: true,
			})
			.state('superadmin.serverpackages.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/superadmin/serverpackages/packageUpdate.html',
				title: 'Update Package',
				pageTitle: 'Update Package',
				parentPath: 'Super Admin',
				controller: 'PackageUpdateCtrl',
				controllerAs: 'vm',
				requireSA: true,
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.serverpackagesettings', [
			'RmsAppV2.pages.superadmin.serverpackagesettings.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/serverpackagesettings', '/superadmin/serverpackagesettings/list')
			.when('/superadmin/serverpackagesettings/', '/superadmin/serverpackagesettings/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.serverpackagesettings', {
				url: '/serverpackagesettings',
				title: 'Packages',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 70,
				},
			})
			.state('superadmin.serverpackagesettings.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/serverpackagesettings/packageList.html',
				title: 'Package List',
				pageTitle: 'Package List',
				parentPath: 'Super Admin',
				controller: 'PackageSettingMainCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.serverpackagesettings.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/superadmin/serverpackagesettings/packageUpdate.html',
				title: 'Update Package Setting',
				pageTitle: 'Update Package Setting',
				parentPath: 'Super Admin',
				controller: 'PackageSettingUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.siotdevices', [
			'RmsAppV2.pages.superadmin.siotdevices.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/siotdevices', '/superadmin/siotdevices/list')
			.when('/superadmin/siotdevices/', '/superadmin/siotdevices/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.siotdevices', {
				url: '/siotdevices',
				title: 'Smart IoT Devices Management',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('superadmin.siotdevices.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/siotdevices/siotDeviceList.html',
				title: 'Smart IoT Devices Management',
				pageTitle: 'Smart IoT Devices Management',
				parentPath: 'Super Admin',
				controller: 'SASiotDeviceMainCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.siotdevices.create', {
				url: '/create',
				templateUrl: "app/pages/superadmin/siotdevices/siotDeviceCreate.html",
				title: 'Create Smart IoT Device',
				pageTitle: 'Create Smart IoT Device',
				parentPath: 'Super Admin',
				controller: 'SASiotDeviceCreateCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.siotdevices.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/superadmin/siotdevices/siotDeviceUpdate.html',
				title: 'Update Smart IoT Device',
				pageTitle: 'Update Smart IoT Device',
				parentPath: 'Super Admin',
				controller: 'SASiotDeviceUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.systemsettings', [
			'RmsAppV2.pages.superadmin.systemsettings.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/systemsettings', '/superadmin/systemsettings/update')
			.when('/superadmin/systemsettings/', '/superadmin/systemsettings/update')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.systemsettings', {
				url: '/systemsettings',
				title: 'System Settings',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				requireSA: true,
				sidebarMeta: {
					order: 90,
				},
			})
			.state('superadmin.systemsettings.update', {
				url: '/update',
				templateUrl: 'app/pages/superadmin/systemsettings/systemsettingsUpdate.html',
				title: 'System Settings',
				pageTitle: 'Update System Settings',
				parentPath: 'Super Admin',
				controller: 'SystemUpdateCtrl',
				controllerAs: 'vm',
				requireSA: true,
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.systemschedulersettings', [
			'RmsAppV2.pages.superadmin.systemschedulersettings.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/systemschedulersettings', '/superadmin/systemschedulersettings/update')
			.when('/superadmin/systemschedulersettings/', '/superadmin/systemschedulersettings/update')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.systemschedulersettings', {
				url: '/systemschedulersettings',
				title: 'Scheduler Settings',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				requireSA: true,
				sidebarMeta: {
					order: 80,
				},
			})
			.state('superadmin.systemschedulersettings.update', {
				url: '/update',
				templateUrl: 'app/pages/superadmin/systemschedulersettings/systemschedulersettingUpdate.html',
				title: 'System Version',
				pageTitle: 'Scheduler Settings',
				parentPath: 'Super Admin',
				controller: 'SystemSchedulerSettingUpdateCtrl',
				controllerAs: 'vm',
				requireSA: true,
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.systemversion', [
			'RmsAppV2.pages.superadmin.systemversion.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/systemversion', '/superadmin/systemversion/update')
			.when('/superadmin/systemversion/', '/superadmin/systemversion/update')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.systemversion', {
				url: '/systemversion',
				title: 'Version',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				requireSA: true,
				sidebarMeta: {
					order: 100,
				},
			})
			.state('superadmin.systemversion.update', {
				url: '/update',
				templateUrl: 'app/pages/superadmin/systemversion/systemversionUpdate.html',
				title: 'System Version',
				pageTitle: 'System Version',
				parentPath: 'Super Admin',
				controller: 'SystemVersionUpdateCtrl',
				controllerAs: 'vm',
				requireSA: true,
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.users', [
			'RmsAppV2.pages.superadmin.users.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/users', '/superadmin/users/list')
			.when('/superadmin/users/', '/superadmin/users/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.users', {
				url: '/users',
				title: 'Users',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 40,
				},
			})
			.state('superadmin.users.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/users/userList.html',
				title: 'Users',
				pageTitle: 'Users',
				parentPath: 'SETTINGS',
				controller: 'SAUserMainCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.users.create', {
				url: '/create',
				templateUrl: "app/pages/superadmin/users/userCreate.html",
				title: 'Create User',
				pageTitle: 'Create User',
				parentPath: 'SETTINGS',
				controller: 'SAUserCreateCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.users.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/superadmin/users/userUpdate.html',
				title: 'Update User',
				pageTitle: 'Update User',
				parentPath: 'SETTINGS',
				controller: 'SAUserUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.wcsimulator.simulations', [
			'RmsAppV2.pages.wcsimulator.simulations.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/wcsimulator/simulations', '/wcsimulator/simulations/list')
			.when('/wcsimulator/simulations/', '/wcsimulator/simulations/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('wcsimulator.simulations', {
				url: '/simulations',
				title: 'Simulations',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('wcsimulator.simulations.list', {
				url: '/list',
				templateUrl: 'app/pages/wcsimulator/simulations/simulationList.html',
				title: 'Simulations',
				pageTitle: 'Simulations',
				parentPath: 'Weight Checker Simulator',
				controller: 'WcSimulationMainCtrl',
				controllerAs: 'vm'
			})
			.state('wcsimulator.simulations.create', {
				url: '/create',
				templateUrl: "app/pages/wcsimulator/simulations/simulationCreate.html",
				title: 'Create Simulation',
				pageTitle: 'Create Simulation',
				parentPath: 'Weight Checker Simulator',
				controller: 'WcSimulationCreateCtrl',
				controllerAs: 'vm'
			})
			.state('wcsimulator.simulations.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/wcsimulator/simulations/simulationUpdate.html',
				title: 'Update Simulation',
				pageTitle: 'Update Simulation',
				parentPath: 'Weight Checker Simulator',
				controller: 'WcSimulationUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.superadmin.uoms', [
			'RmsAppV2.pages.superadmin.uoms.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/superadmin/uoms', '/superadmin/uoms/list')
			.when('/superadmin/uoms/', '/superadmin/uoms/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('superadmin.uoms', {
				url: '/uoms',
				title: 'U.O.M',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 60,
				},
			})
			.state('superadmin.uoms.list', {
				url: '/list',
				templateUrl: 'app/pages/superadmin/uoms/uomList.html',
				title: 'U.O.M.',
				pageTitle: 'U.O.M. List',
				parentPath: 'Super Admin',
				controller: 'UomMainCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.uoms.create', {
				url: '/create',
				templateUrl: "app/pages/superadmin/uoms/uomCreate.html",
				title: 'Create U.O.M.',
				pageTitle: 'Create U.O.M.',
				parentPath: 'Super Admin',
				controller: 'UomCreateCtrl',
				controllerAs: 'vm'
			})
			.state('superadmin.uoms.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/superadmin/uoms/uomUpdate.html',
				title: 'Update U.O.M.',
				pageTitle: 'Update U.O.M.',
				parentPath: 'Super Admin',
				controller: 'UomUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.withdrawalrequests.wrlist', [
			'RmsAppV2.pages.withdrawalrequests.wrlist.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/withdrawalrequests/wrlist', '/withdrawalrequests/wrlist/list')
			.when('/withdrawalrequests/wrlist/', '/withdrawalrequests/wrlist/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('withdrawalrequests.wrlist', {
				url: '/wrlist',
				title: 'Withdrawal Request Listing',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('withdrawalrequests.wrlist.list', {
				url: '/list',
				templateUrl: 'app/pages/withdrawalrequests/wrlist/wrList.html',
				title: 'Withdrawal Request Listing',
				pageTitle: 'Withdrawal Request Listing',
				parentPath: 'Withdrawal Request',
				controller: 'WithdrawalRequestMainCtrl',
				controllerAs: 'vm'
			})
			.state('withdrawalrequests.wrlist.create', {
				url: '/create',
				templateUrl: "app/pages/withdrawalrequests/wrlist/wrCreate.html",
				title: 'Create W.R.',
				pageTitle: 'Create Withdrawal Request',
				parentPath: 'Withdrawal Request',
				controller: 'WithdrawalRequestCreateCtrl',
				controllerAs: 'vm'
			})
			.state('withdrawalrequests.wrlist.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/withdrawalrequests/wrlist/wrUpdate.html',
				title: 'Update W.R.',
				pageTitle: 'Update Withdrawal Request',
				parentPath: 'Withdrawal Request',
				controller: 'WithdrawalRequestUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.settings.emailtemplates', [
			'RmsAppV2.pages.settings.emailtemplates.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/settings/emailtemplates', '/settings/emailtemplates/list')
			.when('/settings/emailtemplates/', '/settings/emailtemplates/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('settings.emailtemplates', {
				url: '/emailtemplates',
				title: 'Email Templates',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('settings.emailtemplates.list', {
				url: '/list',
				templateUrl: 'app/pages/settings/emailtemplates/emailtemplateList.html',
				title: 'EMAIL_TEMPLATES',
				pageTitle: 'EMAIL_TEMPLATES',
				parentPath: 'SETTINGS',
				controller: 'EmailtemplateMainCtrl',
				controllerAs: 'vm'
			})
			.state('settings.emailtemplates.create', {
				url: '/create',
				templateUrl: "app/pages/settings/emailtemplates/emailtemplateCreate.html",
				title: 'CREATE_EMAIL_TEMPLATE',
				pageTitle: 'CREATE_EMAIL_TEMPLATE',
				parentPath: 'SETTINGS',
				controller: 'EmailtemplateCreateCtrl',
				controllerAs: 'vm'
			})
			.state('settings.emailtemplates.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/settings/emailtemplates/emailtemplateUpdate.html',
				title: 'UPDATE_EMAIL_TEMPLATE',
				pageTitle: 'UPDATE_EMAIL_TEMPLATE',
				parentPath: 'SETTINGS',
				controller: 'EmailtemplateUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotdashboard.ezymap', [
			'RmsAppV2.pages.iotdashboard.ezymap.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('iotdashboard.ezymap', {
				url: '/ezymap',
				templateUrl: 'app/pages/dashboard_iot/ezymap/ezymap.html',
				title: 'IMS EzyMap',
				pageTitle: 'IMS EzyMap',
                controller: 'EzyMapCtrl',
                controllerAs: 'vm',
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.smartkitchen.machineconnectionprofiles', [
			'RmsAppV2.pages.smartkitchen.machineconnectionprofiles.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/smartkitchen/machineconnectionprofiles', '/smartkitchen/machineconnectionprofiles/list')
			.when('/smartkitchen/machineconnectionprofiles/', '/smartkitchen/machineconnectionprofiles/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('smartkitchen.machineconnectionprofiles', {
				url: '/machineconnectionprofiles',
				title: 'MACHINE_CONNECTION_PROFILES',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 10,
				},
			})
			.state('smartkitchen.machineconnectionprofiles.list', {
				url: '/list',
				templateUrl: 'app/pages/smartkitchen/mcprofiles/mcprofileList.html',
				title: 'MACHINE_CONNECTION_PROFILES',
				pageTitle: 'MACHINE_CONNECTION_PROFILES',
				parentPath: 'SMART_KITCHEN',
				controller: 'SmartKitchenMachineConnectionProfileMainCtrl',
				controllerAs: 'vm'
			})
			.state('smartkitchen.machineconnectionprofiles.create', {
				url: '/create',
				templateUrl: "app/pages/smartkitchen/mcprofiles/mcprofileCreate.html",
				title: 'CREATE_MACHINE_CONNECTION_PROFILE',
				pageTitle: 'CREATE_MACHINE_CONNECTION_PROFILE',
				parentPath: 'SMART_KITCHEN',
				controller: 'SmartKitchenMachineConnectionProfileCreateCtrl',
				controllerAs: 'vm'
			})
			.state('smartkitchen.machineconnectionprofiles.update', {
				url: '/update/:id',
				templateUrl: 'app/pages/smartkitchen/mcprofiles/mcprofileUpdate.html',
				title: 'UPDATE_MACHINE_CONNECTION_PROFILE',
				pageTitle: 'UPDATE_MACHINE_CONNECTION_PROFILE',
				parentPath: 'SMART_KITCHEN',
				controller: 'SmartKitchenMachineConnectionProfileUpdateCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotdashboard.ezymap', [
			'RmsAppV2.pages.iotdashboard.ezymap.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('iotdashboard.ezymap', {
				url: '/ezymap',
				templateUrl: 'app/pages/dashboard_iot/ezymap/ezymap.html',
				title: 'IMS EzyMap',
				pageTitle: 'IMS EzyMap',
                controller: 'EzyMapCtrl',
                controllerAs: 'vm',
			});
	}
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotdashboard.smartiotobservatory', [
			'RmsAppV2.pages.iotdashboard.smartiotobservatory.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/iotdashboard/smartiotobservatory', '/iotdashboard/smartiotobservatory/list')
			.when('/iotdashboard/smartiotobservatory/', '/iotdashboard/smartiotobservatory/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('iotdashboard.smartiotobservatory', {
				url: '/smartiotobservatory',
				title: 'Smart IOT Observatory',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('iotdashboard.smartiotobservatory.list', {
				url: '/list',
				templateUrl: 'app/pages/dashboard_iot/smartiotobservatory/observatory.html',
				title: 'Customer List',
				pageTitle: 'Smart IOT Observatory - Customer List',
				parentPath: 'Smart IOT Observatory',
				controller: 'SmartIoTObservatoryCtrl',
				controllerAs: 'vm'
			})
			.state('iotdashboard.smartiotobservatory.overview', {
				url: '/overview/:id',
				templateUrl: 'app/pages/dashboard_iot/smartiotobservatory/observatoryOverview.html',
				title: 'Customer IOT Monitoring',
				pageTitle: 'Smart IOT Observatory - Customer IOT Monitoring',
				parentPath: 'Smart IOT Observatory',
				controller: 'SmartIoTObservatoryOverviewCtrl',
				controllerAs: 'vm'
			});
	}
	
})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.iotdashboard.smartiotplanview', [
			'RmsAppV2.pages.iotdashboard.smartiotplanview.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('iotdashboard.smartiotplanview', {
				url: '/smartiotplanview',
				templateUrl: 'app/pages/dashboard_iot/smartiotplanview/planview.html',
				title: 'Smart IOT PlanView™',
				pageTitle: 'Smart IOT PlanView™',
                controller: 'SmartIoTPlanViewCtrl',
                controllerAs: 'vm',
			});
  }

})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.iotdashboard.ezysite', [
			'RmsAppV2.pages.iotdashboard.ezysite.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('iotdashboard.ezysite', {
				url: '/ezysite',
				templateUrl: 'app/pages/dashboard_iot/ezysite/ezysite.html',
				title: 'IMS EzySite',
				pageTitle: 'IMS EzySite',
                controller: 'IotEzySiteCtrl',
                controllerAs: 'vm',
				sidebarMeta: {
					order: 10,
				},
			});
  }

})();


(function () {
    'use strict';

	angular.module('RmsAppV2.pages.iotdashboard.smartiot', [
			'RmsAppV2.pages.iotdashboard.smartiot.controller'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('iotdashboard.smartiot', {
				url: '/smartiot',
				templateUrl: 'app/pages/dashboard_iot/smartiot/smartiot.html',
				title: 'Smart IoT',
				pageTitle: 'Smart IoT',
                controller: 'SmartIoTCtrl',
                controllerAs: 'vm',
				sidebarMeta: {
					order: 10,
				},
			});
  }

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotdashboard.observatory', [
			'RmsAppV2.pages.iotdashboard.observatory.controller',
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider
			.when('/iotdashboard/observatory', '/iotdashboard/observatory/list')
			.when('/iotdashboard/observatory/', '/iotdashboard/observatory/list')
			.otherwise('/dashboard');
			
		$stateProvider
			.state('iotdashboard.observatory', {
				url: '/observatory',
				title: 'IMS Observatory',
				template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
				sidebarMeta: {
					order: 30,
				},
			})
			.state('iotdashboard.observatory.list', {
				url: '/list',
				templateUrl: 'app/pages/dashboard_iot/observatory/observatory.html',
				title: 'IMS Observatory - Customer List',
				pageTitle: 'IMS Observatory - Customer List',
				parentPath: 'IMS Observatory',
				controller: 'IotObservatoryCtrl',
				controllerAs: 'vm'
			})
			.state('iotdashboard.observatory.overview', {
				url: '/overview/:id',
				templateUrl: 'app/pages/dashboard_iot/observatory/observatoryOverview.html',
				title: 'IMS Observatory - Customer Temperature Monitoring',
				pageTitle: 'IMS Observatory - Customer Temperature Monitoring',
				parentPath: 'IMS Observatory',
				controller: 'IotObservatoryOverviewCtrl',
				controllerAs: 'vm'
			});
	}
	
})();

/*!
 * accounting.js v0.4.2, copyright 2014 Open Exchange Rates, MIT license, http://openexchangerates.github.io/accounting.js
 */
(function(p,z){function q(a){return!!(""===a||a&&a.charCodeAt&&a.substr)}function m(a){return u?u(a):"[object Array]"===v.call(a)}function r(a){return"[object Object]"===v.call(a)}function s(a,b){var d,a=a||{},b=b||{};for(d in b)b.hasOwnProperty(d)&&null==a[d]&&(a[d]=b[d]);return a}function j(a,b,d){var c=[],e,h;if(!a)return c;if(w&&a.map===w)return a.map(b,d);for(e=0,h=a.length;e<h;e++)c[e]=b.call(d,a[e],e,a);return c}function n(a,b){a=Math.round(Math.abs(a));return isNaN(a)?b:a}function x(a){var b=c.settings.currency.format;"function"===typeof a&&(a=a());return q(a)&&a.match("%v")?{pos:a,neg:a.replace("-","").replace("%v","-%v"),zero:a}:!a||!a.pos||!a.pos.match("%v")?!q(b)?b:c.settings.currency.format={pos:b,neg:b.replace("%v","-%v"),zero:b}:a}var c={version:"0.4.1",settings:{currency:{symbol:"$",format:"%s%v",decimal:".",thousand:",",precision:2,grouping:3},number:{precision:0,grouping:3,thousand:",",decimal:"."}}},w=Array.prototype.map,u=Array.isArray,v=Object.prototype.toString,o=c.unformat=c.parse=function(a,b){if(m(a))return j(a,function(a){return o(a,b)});a=a||0;if("number"===typeof a)return a;var b=b||".",c=RegExp("[^0-9-"+b+"]",["g"]),c=parseFloat((""+a).replace(/\((.*)\)/,"-$1").replace(c,"").replace(b,"."));return!isNaN(c)?c:0},y=c.toFixed=function(a,b){var b=n(b,c.settings.number.precision),d=Math.pow(10,b);return(Math.round(c.unformat(a)*d)/d).toFixed(b)},t=c.formatNumber=c.format=function(a,b,d,i){if(m(a))return j(a,function(a){return t(a,b,d,i)});var a=o(a),e=s(r(b)?b:{precision:b,thousand:d,decimal:i},c.settings.number),h=n(e.precision),f=0>a?"-":"",g=parseInt(y(Math.abs(a||0),h),10)+"",l=3<g.length?g.length%3:0;return f+(l?g.substr(0,l)+e.thousand:"")+g.substr(l).replace(/(\d{3})(?=\d)/g,"$1"+e.thousand)+(h?e.decimal+y(Math.abs(a),h).split(".")[1]:"")},A=c.formatMoney=function(a,b,d,i,e,h){if(m(a))return j(a,function(a){return A(a,b,d,i,e,h)});var a=o(a),f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format);return(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal))};c.formatColumn=function(a,b,d,i,e,h){if(!a)return[];var f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format),l=g.pos.indexOf("%s")<g.pos.indexOf("%v")?!0:!1,k=0,a=j(a,function(a){if(m(a))return c.formatColumn(a,f);a=o(a);a=(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal));if(a.length>k)k=a.length;return a});return j(a,function(a){return q(a)&&a.length<k?l?a.replace(f.symbol,f.symbol+Array(k-a.length+1).join(" ")):Array(k-a.length+1).join(" ")+a:a})};if("undefined"!==typeof exports){if("undefined"!==typeof module&&module.exports)exports=module.exports=c;exports.accounting=c}else"function"===typeof define&&define.amd?define([],function(){return c}):(c.noConflict=function(a){return function(){p.accounting=a;c.noConflict=z;return c}}(p.accounting),p.accounting=c)})(this);


(function() {
    'use strict';

    angular.module('RmsAppV2.announcementService', ['ngResource', 'ngStorage'])
        .factory('AnnouncementSvc', AnnouncementService);

    /** @ngInject */
    function AnnouncementService($resource, $rootScope, $sessionStorage, $state, $q, HttpSvc, RmsApi, Auth, toastr, $filter) {

		Auth.init();

		var announcementSvc = {};

		$rootScope.announcementList = [];

		announcementSvc.loadList = function()
		{
			if(!Auth.isLoggedIn()) return;

			HttpSvc.get("announcement/allActiveOnly", {}, Auth.getTokenId(), true)
				.then(function(result) {
					$sessionStorage.announcementList = result;
					$rootScope.announcementList = $sessionStorage.announcementList;
				}, function() {
				});
		}

        announcementSvc.formatDate = function (dateString) {
            if (!dateString) return "";
            var date = new Date(dateString);
            return $filter('date')(date, 'yyyy-MM-dd');
        };

        return announcementSvc;
    }
})();


(function() {
    'use strict';

    angular.module('RmsAppV2.approvalService', ['ngResource', 'ngStorage'])
        .factory('ApprovalSvc', ApprovalService);

    /** @ngInject */
    function ApprovalService($resource, $rootScope, $sessionStorage, $state, $q, HttpSvc, RmsApi, Auth, toastr) {
				
		Auth.init();
		
		var approvalSvc = {};

		$rootScope.approvalList = [];
		$rootScope.currencyCode = Auth.getCurrency();
		
		approvalSvc.loadList = function() 
		{			
			if(!Auth.isLoggedIn()) return;
			
			HttpSvc.get("approvalcenters/list/approvalrequests", {}, Auth.getTokenId(), true)
				.then(function(result) {
					$sessionStorage.approvalList = result;
					$rootScope.approvalList = $sessionStorage.approvalList;
				}, function() {	
				});
		}
		
		approvalSvc.viewDocument = function(obj) 
		{
			if(!Auth.isLoggedIn()) return;

			if(obj.requisitionId != null) 
			{
				$state.go('requisitions.reqlist.update', { id: obj.requisitionId});
			}
			else if(obj.purchaseOrderId != null) 
			{
				$state.go('purchaseorders.polist.update', { id: obj.purchaseOrderId});
			}
			else if(obj.deliveryOrderId != null) 
			{
				$state.go('deliveryorders.update', { id: obj.deliveryOrderId});
			}
			else if(obj.jobId != null) 
			{
				$state.go('jobs.joblist.update', { id: obj.jobId});
			}
			else if(obj.withdrawalId != null) 
			{
				$state.go('withdrawalrequests.wrlist.update', { id: obj.withdrawalId});
			}
			else if(obj.wastageId != null) 
			{
				$state.go('wastagereports.update', { id: obj.wastageId});
			}
		}	
		
		approvalSvc.approve = function(obj)
		{
			if(!Auth.isLoggedIn()) return;
			if(!confirm('Confirm to approve [' + obj.docNo + '] ?')) return;

			var params = {
				approvalId: obj.id
			};

			if(obj.requisitionId != null) 
			{
				params.requisitionId =  obj.requisitionId;
			}
			else if(obj.purchaseOrderId != null) 
			{
				params.purchaseOrderId =  obj.purchaseOrderId;
			}
			else if(obj.deliveryOrderId != null) 
			{
				params.deliveryOrderId =  obj.deliveryOrderId;
			}
			else if(obj.jobId != null) 
			{
				params.jobId =  obj.jobId;
			}
			else if(obj.withdrawalId != null) 
			{
				params.withdrawalId =  obj.withdrawalId;
			}
			else if(obj.wastageId != null) 
			{
				params.wastageId =  obj.wastageId;
			}
			
			if(params.approvalId != null)
			{
				HttpSvc.put("approvalcenters/approve", params, Auth.getTokenId())
					.then(function() {
						approvalSvc.loadList();
					}, function(err) {	
						toastr.error(err, 'Approval Failed');
					});
			}
		}		
		
		approvalSvc.disapprove = function(obj)
		{
			if(!Auth.isLoggedIn()) return;
			if(!confirm('Confirm to disapprove [' + obj.docNo + '] ?')) return;

			var params = {
				approvalId: obj.id,
				rejectReason: "no comment"
			};

			if(obj.requisitionId != null) 
			{
				params.requisitionId =  obj.requisitionId;
			}
			else if(obj.purchaseOrderId != null) 
			{
				params.purchaseOrderId =  obj.purchaseOrderId;
			}
			else if(obj.deliveryOrderId != null) 
			{
				params.deliveryOrderId =  obj.deliveryOrderId;
			}
			else if(obj.jobId != null) 
			{
				params.jobId =  obj.jobId;
			}
			else if(obj.withdrawalId != null) 
			{
				params.withdrawalId =  obj.withdrawalId;
			}
			else if(obj.wastageId != null) 
			{
				params.wastageId =  obj.wastageId;
			}
			
			if(params.approvalId != null)
			{
				HttpSvc.put("approvalcenters/disapprove", params, Auth.getTokenId())
					.then(function(result) {
						approvalSvc.loadList();
					}, function(err) {	
						toastr.error(err, 'Disapproval Failed');
					});
			}
		}		
				
        return approvalSvc;
    }
})();


(function() {
    'use strict';

    angular.module('RmsAppV2.authService', ['ngResource', 'ngStorage'])
        .factory('Auth', AuthenticationService);

  /** @ngInject */
    function AuthenticationService($resource, $rootScope, $sessionStorage, $state, $translate, $q, HttpSvc, RmsApi, toastr) {

    var auth = {};

    auth.voice_EN = null;
    auth.voice_CN = null;
    auth.voice_KR = null;

    // Initialize
		auth.init = function(){
			if (auth.isLoggedIn()){
        $rootScope.user = $sessionStorage.user;
        $rootScope.user.serverMode = $sessionStorage.serverMode;
        $rootScope.user.isRmsStarterMode = $sessionStorage.isRmsStarterMode;
        $rootScope.user.isRmsLiteMode = $sessionStorage.isRmsLiteMode;
        $rootScope.user.isStockOutQuickMode = $sessionStorage.isStockOutQuickMode;
        $rootScope.user.isInvoiceEnabledForSO = $sessionStorage.isInvoiceEnabledForSO;
        $rootScope.user.isAfterSalesEnabled = $sessionStorage.isAfterSalesEnabled;
        $rootScope.user.isShowPriceForFranchisee = $sessionStorage.isShowPriceForFranchisee;
        $rootScope.user.integrationMode = $sessionStorage.integrationMode;
        $rootScope.user.companyFeatures = $sessionStorage.companyFeatures;
        $rootScope.user.companyLogo = auth.getCompanyLogo();
        $rootScope.user.companyId = $sessionStorage.companyId;
        $rootScope.user.companyName = $sessionStorage.companyName;
        $rootScope.user.branchId = $sessionStorage.branchId;
        $rootScope.user.branchName = $sessionStorage.branchName;
        $rootScope.user.isLoggedIn = $sessionStorage.isLoggedIn;
        $rootScope.user.isAnnouncementShown = $sessionStorage.isAnnouncementShown;
        $rootScope.user.isSuperAdmin = $sessionStorage.isSuperAdmin;
        $rootScope.user.isAfterSalesManager = $sessionStorage.isAfterSalesManager;

        $rootScope.user.packageName = $sessionStorage.packageName;
        $rootScope.user.isTrial = $sessionStorage.isTrial;
        $rootScope.user.trialPeriod = $sessionStorage.trialPeriod;
        $rootScope.user.trialExpiryDate = $sessionStorage.trialExpiryDate;
        $rootScope.user.isPastTrial = $sessionStorage.isPastTrial;

        $rootScope.user.assetLimit = $sessionStorage.assetLimit;
        $rootScope.user.recipeLimit = $sessionStorage.recipeLimit;
        $rootScope.user.sopLimit = $sessionStorage.sopLimit;
        $rootScope.user.standardUserLimit = $sessionStorage.standardUserLimit;
        $rootScope.user.limitedUserLimit = $sessionStorage.limitedUserLimit;

				$rootScope.user.totalAssetSupplierCount = $sessionStorage.totalAssetSupplierCount;
        $rootScope.user.totalAssetOwnCount = $sessionStorage.totalAssetOwnCount;
        $rootScope.user.totalSopCount = $sessionStorage.totalSopCount;
        $rootScope.user.totalRecipeCount = $sessionStorage.totalRecipeCount;
        $rootScope.user.totalStdUserCount = $sessionStorage.totalStdUserCount;
        $rootScope.user.totalLmtUserCount = $sessionStorage.totalLmtUserCount;

        $rootScope.user.azureBlobUsage = auth.getAzureBlobUsage("gb");
        $rootScope.user.azureBlobQuota = auth.getAzureBlobQuota("gb");
        $rootScope.user.azureBlobUsagePercent =
          Math.ceil($rootScope.user.azureBlobUsage / $rootScope.user.azureBlobQuota * 1000) / 1000 * 100;
        $rootScope.user.azureBlobUsagePercent =
          $rootScope.user.azureBlobUsagePercent > 100 ? 100 : $rootScope.user.azureBlobUsagePercent;

        $rootScope.user.setting_Job_StockInUponCompletion = $sessionStorage.setting_Job_StockInUponCompletion;
        $rootScope.user.setting_Grn_EnableAutoUpdateUom = $sessionStorage.setting_Grn_EnableAutoUpdateUom;
        $rootScope.user.setting_PurchaseOrder_WriteOffUponGrn = $sessionStorage.setting_PurchaseOrder_WriteOffUponGrn;
        $rootScope.user.setting_SalesOrder_UsePax = $sessionStorage.setting_SalesOrder_UsePax;
        $rootScope.user.setting_SalesOrder_DirectTriggerJobCreation = $sessionStorage.setting_SalesOrder_DirectTriggerJobCreation;
        $rootScope.user.setting_DeliveryOrder_EnableDeliveryWindow = $sessionStorage.setting_DeliveryOrder_EnableDeliveryWindow;
        $rootScope.user.setting_DeliveryOrder_AdvancedMode = $sessionStorage.setting_DeliveryOrder_AdvancedMode;
        $rootScope.user.setting_Recipe_UseLainoxNaboo = $sessionStorage.setting_Recipe_UseLainoxNaboo;
        $rootScope.user.setting_Recipe_UseFoodPortioningTable = $sessionStorage.setting_Recipe_UseFoodPortioningTable;
        $rootScope.user.setting_Stock_EnableCatchWeightManagement = $sessionStorage.setting_Stock_EnableCatchWeightManagement;
        $rootScope.user.setting_Stock_EnableCatchWeightManagement = $sessionStorage.setting_Stock_EnableCatchWeightManagement;
        $rootScope.user.isManualChargeInput = $sessionStorage.isManualChargeInput;

        $rootScope.user.currencyCode = $sessionStorage.currencyCode;
        $rootScope.user.languageDirection = $sessionStorage.languageDirection;
        $rootScope.user.autoCount_EnableSync_Creditor = $sessionStorage.autoCount_EnableSync_Creditor;
        $rootScope.user.autoCount_EnableSync_Debtor = $sessionStorage.autoCount_EnableSync_Debtor;
        $rootScope.user.autoCount_EnableSync_RawMat = $sessionStorage.autoCount_EnableSync_RawMat;
        $rootScope.user.autoCount_EnableSync_Product = $sessionStorage.autoCount_EnableSync_Product;
        $rootScope.user.autoCount_EnableSync_SemiFg = $sessionStorage.autoCount_EnableSync_SemiFg;
        $rootScope.user.autoCount_EnableSync_Warehouse = $sessionStorage.autoCount_EnableSync_Warehouse;
        $rootScope.user.idB_EnableSync_RawMat = $sessionStorage.idB_EnableSync_RawMat;
        $rootScope.user.idB_EnableSync_Creditor = $sessionStorage.idB_EnableSync_Creditor;
        $rootScope.user.sqL_EnableSync_RawMat = $sessionStorage.sqL_EnableSync_RawMat;
        $rootScope.user.sqL_EnableSync_SemiFg = $sessionStorage.sqL_EnableSync_SemiFg;
        $rootScope.user.sqL_EnableSync_Product = $sessionStorage.sqL_EnableSync_Product;
        $rootScope.user.sqL_EnableSync_Creditor = $sessionStorage.sqL_EnableSync_Creditor;
        $rootScope.user.sqL_EnableSync_Debtor = $sessionStorage.sqL_EnableSync_Debtor;
        $translate.use($rootScope.user.language);

        // Init Voices
				if(auth.voice_CN==null || auth.voice_KR==null)
				{
          var synth = window.speechSynthesis;
          var voices = synth.getVoices();
					voices.forEach(function(v) {
            //console.log(v.name + ' (' + v.lang + ')');

						if(v.lang=='ko-KR' && v.name=='Yuna')
						{
              auth.voice_KR = v;
              //console.log('Yuna (ko-KR)');
						}
						else if(v.lang=='zh-CN' && v.name=='Tingting')
						{
              auth.voice_CN = v;
              //console.log('Tingting (zh-CN)');
            }
          });
        }
      }
    };

    // Login
		auth.login = function(username, password){
      var params = {
        loginId: EncryptAES(username),
				password: EncryptAES(password)
			}
			return HttpSvc
						.post('users/authenticatev2', params, auth.getTokenId(), false)
						.then(function(data) {
        $sessionStorage.user = data;
        $rootScope.user = $sessionStorage.user;
      });
    };

		auth.selectCompany = function(companyId, companyName){
      $sessionStorage.companyId = companyId;
      $sessionStorage.companyName = companyName;
      $rootScope.user.companyId = $sessionStorage.companyId;
      $rootScope.user.companyName = $sessionStorage.companyName;
      $sessionStorage.user = $rootScope.user;
    };

		auth.selectBranch = function(branchId, branchName){
      $sessionStorage.branchId = branchId;
      $sessionStorage.branchName = branchName;
      $rootScope.user.branchId = $sessionStorage.branchId;
      $rootScope.user.branchName = $sessionStorage.branchName;
      $sessionStorage.user = $rootScope.user;
    };

    // Select Branch + Token (For single Company / Branch)
		auth.selectBranchTokenDefault = function(){
      var comp = auth.getUser().companies[0];
      auth.selectCompany(comp.id, comp.name);
      auth.selectBranch(comp.branches[0].id, comp.branches[0].name);
      return auth.selectBranchToken();
    };

    // Select Branch + Token
		auth.selectBranchToken = function(){
			var params = {}
			return HttpSvc
						.put('users/loginbranch/' + auth.getTokenId() + '/' + auth.getUser().branchId, params, auth.getTokenId(), false)
						.then(function(data) {
        $sessionStorage.companyLogo = data.companyLogo;
        $sessionStorage.packageName = data.packageName;
        $sessionStorage.isTrial = data.isTrial;
        $sessionStorage.trialPeriod = data.trialPeriod;
        $sessionStorage.trialExpiryDate = data.trialExpiryDate;
        $sessionStorage.isPastTrial = data.isPastTrial;

        $sessionStorage.assetLimit = data.assetLimit;
        $sessionStorage.recipeLimit = data.recipeLimit;
        $sessionStorage.sopLimit = data.sopLimit;
        $sessionStorage.standardUserLimit = data.standardUserLimit;
        $sessionStorage.limitedUserLimit = data.limitedUserLimit;

        $sessionStorage.totalAssetSupplierCount = data.totalAssetSupplierCount;
        $sessionStorage.totalAssetOwnCount = data.totalAssetOwnCount;
        $sessionStorage.totalRecipeCount = data.totalRecipeCount;
        $sessionStorage.totalSopCount = data.totalSopCount;
        $sessionStorage.totalStdUserCount = data.totalStdUserCount;
        $sessionStorage.totalLmtUserCount = data.totalLmtUserCount;

        $sessionStorage.azureBlobUsageMB = data.azureBlobUsageMB;
        $sessionStorage.azureBlobQuotaMB = data.azureBlobQuotaMB;
        $sessionStorage.isLoggedIn = true;
        $rootScope.user.isLoggedIn = true;
        $sessionStorage.isAnnouncementShown = false;
        $rootScope.user.isAnnouncementShown = false;

        $sessionStorage.setting_Job_StockInUponCompletion = data.setting_Job_StockInUponCompletion;
        $sessionStorage.setting_Grn_EnableAutoUpdateUom = data.setting_Grn_EnableAutoUpdateUom;
        $sessionStorage.setting_PurchaseOrder_WriteOffUponGrn = data.setting_PurchaseOrder_WriteOffUponGrn;
        $sessionStorage.setting_SalesOrder_UsePax = data.setting_SalesOrder_UsePax;
        $sessionStorage.setting_SalesOrder_DirectTriggerJobCreation = data.setting_SalesOrder_DirectTriggerJobCreation;
        $sessionStorage.setting_DeliveryOrder_EnableDeliveryWindow = data.setting_DeliveryOrder_EnableDeliveryWindow;
        $sessionStorage.setting_DeliveryOrder_AdvancedMode = data.setting_DeliveryOrder_AdvancedMode;
        $sessionStorage.setting_Recipe_UseLainoxNaboo = data.setting_Recipe_UseLainoxNaboo;
        $sessionStorage.setting_Recipe_UseFoodPortioningTable = data.setting_Recipe_UseFoodPortioningTable;
        $sessionStorage.setting_Stock_EnableCatchWeightManagement = data.setting_Stock_EnableCatchWeightManagement;
        $sessionStorage.serverMode = data.serverMode;
        $sessionStorage.isRmsStarterMode = data.isRmsStarterMode;
        $sessionStorage.isRmsLiteMode = data.isRmsLiteMode;
        $sessionStorage.isStockOutQuickMode = data.isStockOutQuickMode;
        $sessionStorage.isInvoiceEnabledForSO = data.isInvoiceEnabledForSO;
        $sessionStorage.isStockInSimpleMode = data.isStockInSimpleMode;
        $sessionStorage.isManualChargeInput = data.isManualChargeInput;
        $sessionStorage.isAfterSalesEnabled = data.isAfterSalesEnabled;
        $sessionStorage.isShowPriceForFranchisee = data.isShowPriceForFranchisee;
        $sessionStorage.integrationMode = data.integrationMode;
        $sessionStorage.companyFeatures = data.companyFeatures;

        $sessionStorage.autoCount_EnableSync_Creditor = data.autoCount_EnableSync_Creditor;
        $sessionStorage.autoCount_EnableSync_Debtor = data.autoCount_EnableSync_Debtor;
        $sessionStorage.autoCount_EnableSync_RawMat = data.autoCount_EnableSync_RawMat;
        $sessionStorage.autoCount_EnableSync_Product = data.autoCount_EnableSync_Product;
        $sessionStorage.autoCount_EnableSync_SemiFg = data.autoCount_EnableSync_SemiFg;
        $sessionStorage.autoCount_EnableSync_Warehouse = data.autoCount_EnableSync_Warehouse;
        $sessionStorage.idB_EnableSync_RawMat = data.idB_EnableSync_RawMat;
        $sessionStorage.idB_EnableSync_Creditor = data.idB_EnableSync_Creditor;
        $sessionStorage.sqL_EnableSync_RawMat = data.sqL_EnableSync_RawMat;
        $sessionStorage.sqL_EnableSync_SemiFg = data.sqL_EnableSync_SemiFg;
        $sessionStorage.sqL_EnableSync_Product = data.sqL_EnableSync_Product;
        $sessionStorage.sqL_EnableSync_Creditor = data.sqL_EnableSync_Creditor;
        $sessionStorage.sqL_EnableSync_Debtor = data.sqL_EnableSync_Debtor;

        $sessionStorage.currencyCode = data.currencyCode;
        $sessionStorage.languageDirection = data.languageDirection;

        auth.init();
      });
    };

    // Logout
		auth.logout = function() {
      delete $sessionStorage.user;
      delete $rootScope.user;
      delete $sessionStorage.companyId;
      delete $sessionStorage.companyName;
      delete $sessionStorage.branchId;
      delete $sessionStorage.branchName;
      delete $sessionStorage.isLoggedIn;
    };

    // Reset Password
		auth.resetPwd = function(emailAddress){
      var params = {
				userEmail: emailAddress
			}
			return HttpSvc.post('users/resetpassword', params, auth.getTokenId(), false);
    };

    // Reset Password
		auth.resetPwd2 = function(username, emailAddress){
      var params = {
        loginId: username,
				userEmail: emailAddress
			}
			return HttpSvc.post('users/resetpassword2', params, auth.getTokenId(), false);
    };

    // Change Password
		auth.changePwd = function(oldPassword, newPassword){
      var params = {
        oldPassword: EncryptAES(oldPassword),
				newPassword: EncryptAES(newPassword)
			}
			return HttpSvc.post('users/updatepassword', params, auth.getTokenId(), false);
    };

    /* **************************************************** */

		auth.translate = function(wordToTranslate) {
      return $translate.instant(wordToTranslate);
		}

		auth.tts = function(text) {
      var synth = window.speechSynthesis;
      var utter = new SpeechSynthesisUtterance(text);

			if($rootScope.user.language=='ko')
			{
        //console.log('Korean Voice: ' + auth.voice_KR.lang + ' - ' + auth.voice_KR.name);
        utter.voice = auth.voice_KR;
        utter.rate = 0.8;
        utter.pitch = 1;
			}
			else if($rootScope.user.language=='cn')
			{
        //console.log('Chinese Voice: ' + auth.voice_CN.lang + ' - ' + auth.voice_CN.name);
        utter.voice = auth.voice_CN;
        utter.rate = 0.9;
        utter.pitch = 1;
			}
			else
			{
        utter.rate = 0.9;
        utter.pitch = 1;
      }

      synth.speak(utter);
		}

    /* **************************************************** */

    // Check Menu Access Control
		auth.hasPerm = function(state, permType) {
      var features = auth.getUserFeatures();
      var result = false;

			features.forEach(function(f){

        var actualState = state.toLowerCase();
				actualState = actualState.replace('.list', '');
				actualState = actualState.replace('.create', '');
				actualState = actualState.replace('.batchcreate', '');
				actualState = actualState.replace('.update', '');
				actualState = actualState.replace('.clone', '');
				actualState = actualState.replace('.print', '');
				actualState = actualState.replace('.import', '');
				actualState = actualState.replace('.stockin', '');
				actualState = actualState.replace('.stockout', '');
				actualState = actualState.replace('.stockadjustment', '');
				actualState = actualState.replace('.recipes.categorylist', '.recipes');
				actualState = actualState.replace('.recipes.recipelist', '.recipes');
				actualState = actualState.replace('.sops.categorylist', '.sops');
				actualState = actualState.replace('.cards.categories', '.cards');
				actualState = actualState.replace('.cards.recipes', '.cards');
				actualState = actualState.replace('.cards.view', '.cards');
				actualState = actualState.replace('.cards.sops', '.cards');
				actualState = actualState.replace('.observatory.overview', '.observatory');
				actualState = actualState.replace('.smartiotobservatory.overview', '.smartiotobservatory');

				if(actualState == f.featureState.toLowerCase()) {
					switch(permType.toUpperCase()) {
						case 'ACCESS':
              result = f.canAccess;
              break;
						case 'READ':
              result = f.canRead;
              break;
						case 'CREATE':
              result = f.canCreate;
              break;
						case 'UPDATE':
              result = f.canUpdate;
              break;
						case 'DELETE':
              result = f.canDelete;
              break;
						case 'EXPORT':
              result = f.canExport;
              break;
						case 'APPROVE':
              result = f.canApprove;
              break;
            default:
              result = false;
              break;
          }
        }
      });

      return result;
    };

		auth.hasCompanyFeature = function(state) {
      var features = auth.getCompanyFeatures();
      var result = false;

			features.forEach(function(f){
        var actualState = state.toLowerCase();
				if(f.state==actualState) {
          result = true;
        }
      });

      return result;
		}

    /* **************************************************** */

    auth.setLanguage = function (languageCode) {
      $sessionStorage.user.language = languageCode;
      $translate.use(languageCode);
		}

    /* **************************************************** */

    // Retrieve Current User
		auth.getUser = function(){
      return $sessionStorage.user;
    };

    // Retrieve Current Usergroup ID
		auth.getUserGroupId = function(){
      return $sessionStorage.user.role.userGroupId;
    };

    // Retrieve Current CompanyId
		auth.getCompanyId = function(){
      return $sessionStorage.companyId;
    };

    // Retrieve Current BranchId
		auth.getBranchId = function(){
      return $sessionStorage.branchId;
    };

    // Retrieve Current User
		auth.getTokenId = function(){
			if(typeof $sessionStorage.user !== "undefined" && $sessionStorage.user !== null)
        return $sessionStorage.user.tokenID;
			else
				return "";
    };

    // Retrieve Current Company Logo
		auth.getCompanyLogo = function(){
			if($sessionStorage.companyLogo=="") {
        return "";
      } else {
				var rootUrl = auth.getServerMode()==0 ? RmsApi.LOCALURL : RmsApi.BLOBURL;
        return rootUrl + $sessionStorage.companyLogo;
      }
    };

    // Get Company's Branches
		auth.getCompanyBranches = function() {
      var companies = $sessionStorage.user.companies;
      var branches = [];

			companies.forEach(function(c) {
				if(c.id==$sessionStorage.companyId)
				{
          branches = c.branches;
        }
      });

      return branches;
		}

    // Retrieve User accessible Features
		auth.getCompanyFeatures = function() {
      return $sessionStorage.companyFeatures;
		}

		auth.getUserFeatures = function() {
			if($rootScope.user==null) return [];
      return $rootScope.user.features;
		}

		auth.getPackageName = function() {
      return $sessionStorage.packageName;
		}

		auth.getIsTrial = function() {
      return $sessionStorage.isTrial;
		}

		auth.getTrialPeriod = function() {
      return $sessionStorage.trialPeriod;
		}

		auth.getTrialExpiryDate = function() {
      return $sessionStorage.trialExpiryDate;
		}

		auth.getAssetLimit = function() {
      return $sessionStorage.assetLimit;
		}

		auth.getRecipeLimit = function() {
      return $sessionStorage.recipeLimit;
		}

		auth.getSopLimit = function() {
      return $sessionStorage.sopLimit;
		}

		auth.getUserLimit = function() {
      return $sessionStorage.userLimit;
		}

		auth.getTotalAssetCount = function() {
      return $sessionStorage.totalAssetOwnCount;
		}

		auth.getTotalRecipeCount = function() {
      return $sessionStorage.totalRecipeCount;
		}

		auth.getTotalSopCount = function() {
      return $sessionStorage.totalSopCount;
		}

		auth.getTotalUserCount = function() {
      return $sessionStorage.totalUserCount;
		}

    // Retrieve Azure Blob Current Usage (By Company)
		auth.getAzureBlobUsage = function(unit) {
			if(unit=="mb") {
        return $sessionStorage.azureBlobUsageMB;
      }
			if(unit=="gb") {
				return Math.ceil($sessionStorage.azureBlobUsageMB / 1024 * 1000) / 1000;
      }
		}

    // Retrieve Azure Blob Total Quota (By Company)
		auth.getAzureBlobQuota = function(unit) {
			if(unit=="mb") {
        return $sessionStorage.azureBlobQuotaMB;
      }
			if(unit=="gb") {
        return $sessionStorage.azureBlobQuotaMB / 1024;
      }
		}

    /* **************************************************** */

    // Check Is Logged In
		auth.isLoggedIn = function(){
			return $sessionStorage.user !== null && $sessionStorage.user !== undefined &&
				       $sessionStorage.companyId !== null && $sessionStorage.companyId !== undefined &&
					   $sessionStorage.branchId !== null && $sessionStorage.branchId !== undefined &&
					   $sessionStorage.isLoggedIn !== null && $sessionStorage.isLoggedIn !== undefined;
    };

    // Check Is Announcement Shown
    auth.isAnnouncementShown = function(){
        if ($rootScope.user == null) return true;
        return $rootScope.user.isAnnouncementShown == null
            ? false
            : $rootScope.user.isAnnouncementShown;
    };

    // Mark announcement as shown
    auth.markAnnouncementAsShown = function () {
        $rootScope.user.isAnnouncementShown = true;
        $sessionStorage.isAnnouncementShown = true;
    };

    // Get seen announcements from local storage
    auth.getSeenAnnouncements = function () {
        return JSON.parse(localStorage.getItem('seenAnnouncements') || '[]');
    };

    // Add announcement ID to seen announcements in local storage
    auth.markAnnouncementAsSeen = function (announcementId) {
        var seenAnnouncements = auth.getSeenAnnouncements();
        if (!seenAnnouncements.includes(announcementId)) {
            seenAnnouncements.push(announcementId);
            localStorage.setItem('seenAnnouncements', JSON.stringify(seenAnnouncements));
        }
    };

    // Check Is RMS Lite Mode
		auth.isStarterMode = function(){
			if($rootScope.user==null) return true;
			return $rootScope.user.isRmsStarterMode==null ? false : $rootScope.user.isRmsStarterMode;
    };

    // Check Is RMS Lite Mode
		auth.isLiteMode = function(){
			if($rootScope.user==null) return true;
			return $rootScope.user.isRmsLiteMode==null ? false : $rootScope.user.isRmsLiteMode;
    };

    // Check Is RMS Lite Mode
    auth.isStockOutQuickMode = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.isStockOutQuickMode == null
        ? false
        : $rootScope.user.isStockOutQuickMode;
    };

    // Check Is Invoice Enabled for Sales Order
    auth.isInvoiceEnabledForSO = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.isInvoiceEnabledForSO == null
        ? false
        : $rootScope.user.isInvoiceEnabledForSO;
    };

    auth.isAfterSalesEnabled = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.isAfterSalesEnabled == null
        ? false
        : $rootScope.user.isAfterSalesEnabled;
    };

    auth.isShowPriceForFranchisee = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.isShowPriceForFranchisee == null
        ? false
        : $rootScope.user.isShowPriceForFranchisee;
    };

    // Check Is Super Admin
		auth.isSuperAdmin = function(){
			if($rootScope.user==null) return false;
      return $rootScope.user.role.isSuperAdmin;
    };

    // Check Is Super Admin
		auth.isAfterSalesManager = function(){
			if($rootScope.user==null) return false;
      return $rootScope.user.role.isAfterSalesManager;
    };

    // Check Is View Own Recipe
		auth.isViewOwnRecipe = function(){
			if($rootScope.user==null) return false;
      return $rootScope.user.role.isViewOwnRecipe;
		}

    // Check Can Access Food Cost
		auth.canAccessFoodCost = function(){
			if($rootScope.user==null) return false;
      return $rootScope.user.role.canAccessFoodCost;
		}

    // Check Can Access Ingredient
		auth.canAccessIngredient = function(){
			if($rootScope.user==null) return false;
      return $rootScope.user.role.canAccessIngredient;
		}

    // Check Can Clone Recipe
		auth.canCloneRecipe = function(){
			if($rootScope.user==null) return false;
      return $rootScope.user.role.canCloneRecipe;
		}

    // Check Can Clone S.O.P
		auth.canCloneSop = function(){
			if($rootScope.user==null) return false;
      return $rootScope.user.role.canCloneSop;
		}

    // Check Can Set IOT Hardware Settings
		auth.canSetIoTHardwareSettings = function(){
			if($rootScope.user==null) return false;
      return $rootScope.user.role.canSetIoTHardwareSettings;
		}

    // Dashboard - General View
		auth.canViewDashboardGeneral = function(){
			if($rootScope.user==null) return false;
      return $rootScope.user.role.dashboardGeneralView;
		}

    // Dashboard - AfterSales View
		auth.canViewDashboardAfterSales = function(){
			if($rootScope.user==null) return false;
      return $rootScope.user.role.dashboardAfterSalesView;
		}

    // Special Access - Can Edit Company Settings
		auth.specialAccess_CanEditCompanySettings = function(){
			if($rootScope.user==null) return false;
      return $rootScope.user.specialAccess.canEditCompanySettings;
		}

    // Special Access - Can Edit Branch Settings
		auth.specialAccess_CanEditBranchSettings = function(){
			if($rootScope.user==null) return false;
      return $rootScope.user.specialAccess.canEditBranchSettings;
		}

    auth.autoCount_EnableSync_Creditor = function () {
    if ($rootScope.user == null) return true;
      return $rootScope.user.autoCount_EnableSync_Creditor == null
        ? false
        : $rootScope.user.autoCount_EnableSync_Creditor;
    };

    auth.autoCount_EnableSync_Debtor = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.autoCount_EnableSync_Debtor == null
        ? false
        : $rootScope.user.autoCount_EnableSync_Debtor;
    };

    auth.autoCount_EnableSync_RawMat = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.autoCount_EnableSync_RawMat == null
        ? false
        : $rootScope.user.autoCount_EnableSync_RawMat;
    };

    auth.autoCount_EnableSync_Product = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.autoCount_EnableSync_Product == null
        ? false
        : $rootScope.user.autoCount_EnableSync_Product;
    };

    auth.autoCount_EnableSync_SemiFg = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.autoCount_EnableSync_SemiFg == null
        ? false
        : $rootScope.user.autoCount_EnableSync_SemiFg;
    };

    auth.autoCount_EnableSync_Warehouse = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.autoCount_EnableSync_Warehouse == null
        ? false
        : $rootScope.user.autoCount_EnableSync_Warehouse;
    };

    auth.idB_EnableSync_RawMat = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.idB_EnableSync_RawMat == null
        ? false
        : $rootScope.user.idB_EnableSync_RawMat;
    };

    auth.idB_EnableSync_Creditor = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.idB_EnableSync_Creditor == null
        ? false
        : $rootScope.user.idB_EnableSync_Creditor;
    };
      
    auth.sqL_EnableSync_RawMat = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.sqL_EnableSync_RawMat == null
        ? false
        : $rootScope.user.sqL_EnableSync_RawMat;
    };

    auth.sqL_EnableSync_SemiFg = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.sqL_EnableSync_SemiFg == null
        ? false
        : $rootScope.user.sqL_EnableSync_SemiFg;
    };

    auth.sqL_EnableSync_Product = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.sqL_EnableSync_Product == null
        ? false
        : $rootScope.user.sqL_EnableSync_Product;
    };

    auth.sqL_EnableSync_Creditor = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.sqL_EnableSync_Creditor == null
        ? false
        : $rootScope.user.sqL_EnableSync_Creditor;
    };

    auth.sqL_EnableSync_Debtor = function () {
      if ($rootScope.user == null) return true;
      return $rootScope.user.sqL_EnableSync_Debtor == null
        ? false
        : $rootScope.user.sqL_EnableSync_Debtor;
    };
    /* **************************************************** */

    // Check Is selected Company / Branch
		auth.selectedCompanyBranch = function(){
			return $sessionStorage.companyId != null &&
        $sessionStorage.branchId != null &&
        $sessionStorage.isLoggedIn != null

    };

		auth.hasMultipleCompanies = function() {
      return $sessionStorage.user.companies.length > 1;
    };

		auth.hasMultipleBranches = function() {
      var hasMultipleBranches = false;
      $sessionStorage.user.companies.forEach(function (c) {
        if (c.branches.length > 1) {
          hasMultipleBranches = true;
        }
      });
      return hasMultipleBranches;
    };

    /* **************************************************** */

		auth.getCurrency = function() {
      return $sessionStorage.currencyCode;
		}

		auth.getLanguage = function() {
			if($rootScope.user==null) return 'en';
      return $sessionStorage.user.language;
		}

		auth.getLanguageName = function() {
      //return $sessionStorage.languageCode;
			if($sessionStorage.user.language=="en")
				return "ENGLISH";
			else if($sessionStorage.user.language=="ko")
				return "KOREAN";
		}

		auth.getSetting_Job_StockInUponCompletion = function() {
      return $sessionStorage.setting_Job_StockInUponCompletion;
		}

		auth.getSetting_Grn_EnableAutoUpdateUom = function() {
      return $sessionStorage.setting_Grn_EnableAutoUpdateUom;
		}

		auth.getSetting_PurchaseOrder_WriteOffUponGrn = function() {
      return $sessionStorage.setting_PurchaseOrder_WriteOffUponGrn;
		}

		auth.getSetting_SalesOrder_UsePax = function() {
      return $sessionStorage.setting_SalesOrder_UsePax;
		}

		auth.getSetting_SalesOrder_DirectTriggerJobCreation = function() {
      return $sessionStorage.setting_SalesOrder_DirectTriggerJobCreation;
    };

    auth.getSetting_DeliveryOrder_EnableDeliveryWindow = function () {
      return $sessionStorage.setting_DeliveryOrder_EnableDeliveryWindow;
		}

		auth.getSetting_DeliveryOrder_AdvancedMode = function() {
      return $sessionStorage.setting_DeliveryOrder_AdvancedMode;
		}

		auth.getSetting_Recipe_UseLainoxNaboo = function() {
      return $sessionStorage.setting_Recipe_UseLainoxNaboo;
		}

		auth.getSetting_Recipe_UseFoodPortioningTable = function() {
      return $sessionStorage.setting_Recipe_UseFoodPortioningTable;
		}

		auth.getSetting_Stock_EnableCatchWeightManagement = function() {
      return $sessionStorage.setting_Stock_EnableCatchWeightManagement;
		}

		auth.getSetting_IsManualChargeInput = function() {
      return $sessionStorage.isManualChargeInput;
		}

		auth.getSetting_isStockInSimpleMode = function() {
      return $sessionStorage.isStockInSimpleMode;
		}

		auth.getServerMode = function() {
      return $sessionStorage.serverMode;
		}

		auth.getIntegrationMode = function() {
      return $sessionStorage.integrationMode;
		}

    /* **************************************************** */

    // AES Encryption with Salt
    function EncryptAES(value) {
      //var salt = "foodmakesyouweak";
			var salt =   "codemaxisforever";
      if (auth.isLoggedIn()) {
        salt = $rootScope.user.code;
      }
      var key = CryptoJS.enc.Utf8.parse(salt);
      var iv = CryptoJS.enc.Utf8.parse(salt);
      return CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value), key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
				padding: CryptoJS.pad.Pkcs7
      }).toString();
    }

    return auth;
  }
})();


(function() {
    'use strict';

    angular.module('RmsAppV2.azureService', ['ngResource'])
        .factory('AzureSvc', AzureService);

    /** @ngInject */
    function AzureService($scope, $state, $q, RmsApi, Upload, toastr) {
				
		var azureSvc = {};
		
		azureSvc.uploadFile = function (fileToUpload, fileType, azureStorageUrl) {
			var fileReader = new FileReader();
			
			fileReader.readAsArrayBuffer(fileToUpload);
			return(fileReader.onload = function(e) {
				return $q(function(resolve, reject){
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': fileType
						},
						data: e.target.result
					}).then(function(response) {
						resolve(response);
					}, function(error) {
						if (typeof error.data !== "undefined" && error.data !== null) {
							reject(error.data.message);									
						} else {
							reject(error.message);
						}
					}, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				});
			});
		};
		
        return azureSvc;
    }
})();

(function() {
    'use strict';

	angular.module('RmsAppV2.config', [])
		
		.config(['$httpProvider', function($httpProvider) {
			delete $httpProvider.defaults.headers.common["X-Requested-With"];
		}])

		// .config(['qtipDefaultsProvider', function(qtipDefaultsProvider) {
		// 	qtipDefaultsProvider.setDefaults({
		// 		position: {
		// 			my: 'top right',
		// 			at: 'bottom right'
		// 		}
		// 	});
		// }])

		.config(['uiSelectConfig', function(uiSelectConfig) {
			//uiSelectConfig.theme = 'selectize';
			//Note: cannot use Selectize due to unable to bind scroll event
		}])

		.config(['$translateProvider', function($translateProvider) {
			$translateProvider
				.useStaticFilesLoader({
					prefix: 'translations/',
					suffix: '.json'
				})
				.preferredLanguage('en')
				.useSanitizeValueStrategy('sanitize')
				.useMissingTranslationHandlerLog();
		}]);
})();
(function() {
    'use strict';

	angular.module('RmsAppV2.constant', [])
		.constant("RmsApi", {

			"URL": 
				//"https://pd-rms-api-v2.azurewebsites.net/api/v1/",	// LIVE SERVER (OLD)
				"https://codemax-appsvc.azurewebsites.net/api/v1/",	// LIVE SERVER (V3)
				// "https://test-rmsapiv2.azurewebsites.net/api/v1/",	// TEST SERVER			
				// "http://192.168.0.10/rmsapi/api/v1/",			// BGR
				// "http://192.168.100.169/rmsapi/api/v1/",		// DULAI

			"LOCALURL": 
				"https://pd-rms-api-v2.azurewebsites.net/blobstorage/",	// LIVE & TEST SERVER
				// "http://192.168.0.10/rmsapi/blobstorage/", 	// BGR
				// "http://192.168.100.169/rmsapi/blobstorage/", 	// DULAI

			"BLOBURL": "https://pdrmsblob.blob.core.windows.net/",
			"BLOBCONNECTIONSTRING": "DefaultEndpointsProtocol=https;AccountName=acc_name;AccountKey=acc_key",
			"BLOBACCNAME": "pdrmsblob",
			"BLOBACCKEY": "7a/SCntarBHQxKnLEE4NvNZ8QmU26mLQ0XXeWIaP+hxkN6O02gE28/5QBnRMa+RmQNZ+9TlAiJmUwu/mfg0VgA==",
		});
})();
(function() {
    'use strict';

	angular.module('RmsAppV2.controller', [])
		.controller('MainCtrl', function($scope, $rootScope, $location, $state, Auth, toastr) {
		
		Auth.init();
			
		$rootScope.isLive = true;
		//$rootScope.isKorea = false;
		
		$rootScope.isLoggedIn = function(){
			return Auth.isLoggedIn();
		};
		
		$rootScope.selectedCompanyBranch = function(){
			return Auth.selectedCompanyBranch();
		};
		
		$rootScope.navigateChgPwd = function(){
			$location.path("/login/changepassword");
		};
		
		$rootScope.switchCompanyBranch = function(){
			$location.path("/login/switch");
		};
		
		$rootScope.logout = function(){
			toastr.info('', 'You have logged out.');
			Auth.logout();
			$location.path("/login");
		};

		$rootScope.navigateDashboard = function() 
		{				
			if(Auth.hasPerm('iotdashboard.smartiot', 'ACCESS'))
				$state.go('iotdashboard.smartiot', {}, {reload: true});
			else if(Auth.hasPerm('iotlvdashboard', 'ACCESS'))
				$state.go('iotlvdashboard', {}, {reload: true});
			else if(Auth.hasPerm('iotdashboard.ezysite', 'ACCESS'))
				$state.go('iotdashboard.ezysite', {}, {reload: true});
			else if(Auth.hasPerm('iotdashboard.ezymap', 'ACCESS'))
				$state.go('iotdashboard.ezymap', {}, {reload: true});
			else 
			{
				$state.go('dashboard', {}, {reload: true});
			}
		}
			
		// State Changed Watcher
		$rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {			
			
			// Check If User Has Logged In
			if (Auth.isLoggedIn()===false){
				if(toState.name==="login"){
					return;
				} else if(toState.name==="resetpassword"){
					return;
				} else if(toState.name==="ezyshare" || toState.name==="ezytrack"){					
					return;
				} else {
					event.preventDefault();
					toastr.error('You must login to access the RMS system.', 'Login Required');	
					$state.go('login', {}, {reload: true});
					return;
				}
			} else {
				if(toState.name==="ezyshare" || toState.name==="ezytrack") {
					return;
				} else if(toState.name==="login" || toState.name==="resetpassword") {
					event.preventDefault();
					$rootScope.navigateDashboard();
					return;
				}
			}
			
			if(toState.name=="permissioncenter" || toState.name=="changepassword" || toState.name=="switch") {				
				return;
			}
						
			if(!Auth.hasPerm(toState.name.trim(), 'ACCESS')) {
				event.preventDefault();
				toastr.warning('You do not have access to the page.', 'Unauthorized Access');
				$rootScope.navigateDashboard();
				return;
			}
			
			// Check Super Admin Access
			if(toState.requireSA && !Auth.isSuperAdmin()) {
				event.preventDefault();
				toastr.warning('The page you try to access requires <b>Super Admin</b> privilege.', 'Unauthorized Access');
				$rootScope.navigateDashboard();
				return;			
			}
			
			// Check CREATE Access
			if((toState.name.trim().endsWith('create') || toState.name.trim().endsWith('clone') || toState.name.trim().endsWith('print')) && 
					!Auth.hasPerm(toState.name.trim(), 'CREATE')) {
				event.preventDefault();
				toastr.warning('You do not have <b>CREATE</b> access to the page.', 'Unauthorized Access');
				$state.go(fromState.name, {}, {reload: true});
				return;
			}
			
			// Check UPDATE Access
			if(toState.name.trim().endsWith('update') && 
					!Auth.hasPerm(toState.name.trim(), 'UPDATE')) {
				event.preventDefault();
				toastr.warning('You do not have <b>UPDATE</b> access to the page.', 'Unauthorized Access');
				$state.go(fromState.name, {}, {reload: true});
				return;
			}
			
			// Check EXPORT Access
			if((toState.name.trim().endsWith('export') || toState.name.trim().endsWith('print')) && 
					!Auth.hasPerm(toState.name.trim(), 'EXPORT')) {
				event.preventDefault();
				toastr.warning('You do not have <b>EXPORT</b> access to the page.', 'Unauthorized Access');
				$state.go(fromState.name, {}, {reload: true});
				return;
			}
		});
	});
})();
(function() {
    'use strict';

	angular.module('RmsAppV2.directive', [])
		
		.directive('ngConfirmClick', [function(){
			return {
				link: function (scope, element, attr) {
					var msg = attr.ngConfirmClick || "Are you sure?";
					var clickAction = attr.confirmedClick;
					element.bind('click',function (event) {
						if ( window.confirm(msg) ) {
							scope.$eval(clickAction)
							scope.$apply();
						}
					});
				}
			};
		}])
		
		.directive('preventEnterKey', ['toastr', function (toastr) {
			return {
				link: function (scope, element, attr) {
					var keyAction = attr.preventEnterKey;
					
					$(element).keypress(function (e) {
						if (e.keyCode == 13) {
							scope.$eval(keyAction);
							scope.$apply();
							e.preventDefault();
						}
					});
				}
			}
		}])
		
		.directive('preventNavigateAway', [function(){
			return {
				restrict: 'A',
				link: function(scope, element, attrs){
					$(element).keydown(function (e) {
						var elid = $(document.activeElement)
							.filter(
								"input:not([type], [readonly]),"+
								"input[type=text]:not([readonly]), " +
								"input[type=password]:not([readonly]), " +
								"input[type=search]:not([readonly]), " +
								"input[type=number]:not([readonly]), " +
								"input[type=email]:not([readonly]), " +
								"input[type=date]:not([readonly]), " +
								"input[type=datetime]:not([readonly]), " +
								"input[type=datetime-local]:not([readonly]), " +
								"input[type=month]:not([readonly]), " +
								"input[type=tel]:not([readonly]), " +
								"input[type=time]:not([readonly]), " +
								"input[type=url]:not([readonly]), " +
								"input[type=week]:not([readonly]), " +
								"textarea")[0];

						if (e.keyCode === 8 && !elid) {
							//return confirm('Are you you want to leave this page? Any unsaved changes will be lost.');
							//return false;
						}
					});
				}
			}
		}])
			
		.directive('refreshTable', function(){
			return {
				require: 'stTable',
				restrict: 'A',
				link: function(scope, elem, attr, table){
					scope.$on("refreshStTable", function() {
						table.pipe(table.tableState());
					});
				}
		}})
		
		.directive('tooltip', function(){
			return {
				restrict: 'A',
				link: function(scope, element, attrs){
					$(element).hover(function(){
						// on mouseenter
						$(element).tooltip('show');
					}, function(){
						// on mouseleave
						$(element).tooltip('hide');
					});
				}
			};
		})
		
		// Check RMS CRUD Access
		.directive('rmsCheckAccess', ['Auth', function(Auth) {

			function link(scope, element, attrs) {
				var stateRef = attrs.rmsCheckAccess;
				var permType = attrs.rmsCheckAccessPermType.toUpperCase();
				
				if(!Auth.hasPerm(stateRef, permType)) {
					element.hide();
					return;
				} else {
					element.show();
					return;
				}
			}

			return {
				link: link
			};
		}])
		
		.directive('capitalize', function() {
			return {
				require: 'ngModel',
				link: function(scope, element, attrs, modelCtrl) {
					var capitalize = function(inputValue) {
						if (inputValue == undefined) inputValue = '';
						
						var capitalized = inputValue.toUpperCase();
						if (capitalized !== inputValue) {					
							modelCtrl.$setViewValue(capitalized);
							modelCtrl.$render();
						}
						return capitalized;
					}
					modelCtrl.$parsers.push(capitalize);
					capitalize(scope[attrs.ngModel]); // capitalize initial value
				}
			};
		})	

		.directive('blink', function($timeout) {
			return {
				restrict: 'E',
				transclude: true,
				scope: {},
				controller: function($scope, $element) {
					function showElement() {
						$element.css("display", "inline-block");
						$timeout(hideElement, 1000);
					}

					function hideElement() {
						$element.css("display", "none");
						$timeout(showElement, 1000);
					}

					$timeout(hideElement, 1000);
				},
				template: '<span ng-transclude></span>',
				replace: true
			};
		})

		.directive('stPersist', function () {
			return {
				require: '^stTable',
				link: function (scope, element, attr, ctrl) {
					var nameSpace = attr.stPersist;
	
					//save the table state every time it changes
					scope.$watch(function () {
						return ctrl.tableState();
					}, function (newValue, oldValue) {
						if (newValue !== oldValue) {
							//console.log ("oldValue:" + JSON.stringify(oldValue) + "\n\nnewValue:" + JSON.stringify(newValue))
							localStorage.setItem(nameSpace, JSON.stringify(newValue));
						}
					}, true);
	
					//fetch the table state when the directive is loaded
					if (localStorage.getItem(nameSpace)) {
						var savedState = JSON.parse(localStorage.getItem(nameSpace));
						var tableState = ctrl.tableState();
	
						angular.extend(tableState, savedState);
						ctrl.pipe();	
					}	
				}
			};
		})

		.directive("stResetSearch", function() {
			return {
				restrict: 'EA',
				require: '^stTable',
				link: function(scope, element, attrs, ctrl) {
					return element.bind('click', function() {
						return scope.$apply(function() {
							var tableState;
							tableState = ctrl.tableState();
							tableState.sort = {};
							tableState.search.predicateObject = {};
							tableState.pagination.start = 0;
							return ctrl.pipe();
						});
					});
				}
			};
	   	})

		// .directive('stSearch', ['stConfig', '$timeout','$parse', function (stConfig, $timeout, $parse) {
		// 	return {
		// 	  require: '^stTable',
		// 	  // Use a higher priority than the Smart Table stSearch
		// 	  priority: 1000,
		// 	  // Prevents the lower priority directive from compiling
		// 	  //terminal: true,
		// 	  link: function (scope, element, attr, ctrl) {
		// 		var tableCtrl = ctrl;
		// 		var promise = null;
		// 		var throttle = attr.stDelay || stConfig.search.delay;
		// 		var event = attr.stInputEvent || stConfig.search.inputEvent;
		// 		var trimSearch = attr.trimSearch || stConfig.search.trimSearch;
		
		// 		attr.$observe('stSearch', function (newValue, oldValue) {
		// 		  var input = element[0].value;
		// 		  if (newValue !== oldValue && input) {
		// 			//ctrl.tableState().search = {};
		// 			input = angular.isString(input) && trimSearch ? input.trim() : input;
		// 			tableCtrl.search(input, newValue);
		// 		  }
		// 		});
		
		// 		//table state -> view
		// 		scope.$watch(function () {
		// 		  return ctrl.tableState().search;
		// 		}, function (newValue, oldValue) {
		// 		  var predicateExpression = attr.stSearch || '$';
		// 		  if (newValue.predicateObject && $parse(predicateExpression)(newValue.predicateObject) !== element[0].value) {
		// 			element[0].value = $parse(predicateExpression)(newValue.predicateObject) || '';
		// 		  }
		// 		}, true);
		
		// 		// view -> table state
		// 		element.bind(event, function (evt) {
		// 		  evt = evt.originalEvent || evt;
		// 		  if (promise !== null) {
		// 			$timeout.cancel(promise);
		// 		  }
		
		// 		  promise = $timeout(function () {
		// 			var input = evt.target.value;
		// 			input = angular.isString(input) && trimSearch ? input.trim() : input;
		// 			tableCtrl.search(input, attr.stSearch || '');
		// 			promise = null;
		// 		  }, throttle);
		// 		});
		// 	  }
		// 	};
		// }])

		// Custom UI Choices
		// .directive('uiSelectChoices', ['$timeout', '$parse', '$compile', '$document', '$filter', function($timeout, $parse, $compile, $document, $filter) {
		// 	return function(scope, elm, attr) {
		// 		var raw = elm[0];
		// 		var scrollCompleted = true;
		// 		if (!attr.allChoices) {
		// 			return;
		// 	  		//throw new Error('ief:ui-select: Attribute all-choices is required in  ui-select-choices so that we can handle  pagination.');
		// 		}

		// 		scope.$watchCollection(attr.allChoices , function(newChoices, oldChoices){ 
		// 			scope.pagingOptions = {
		// 				allOptions: scope.$eval(attr.allChoices)
		// 			};
		// 		});
		
		// 		attr.refresh = 'addMoreItems()';
		// 		var refreshCallBack = $parse(attr.refresh);
				
		// 		elm.bind('scroll', function(event) {
		// 	  		var remainingHeight = raw.offsetHeight - raw.scrollHeight;
		// 	  		var scrollTop = raw.scrollTop;
		// 	  		var percent = Math.abs((scrollTop / remainingHeight) * 100);
		// 			if (percent >= 80) {
		// 				if (scrollCompleted) {
		// 					scrollCompleted = false;
		// 					event.preventDefault();
		// 					event.stopPropagation();
		// 					var callback = function() {
		// 						scope.addingMore = true;
		// 						refreshCallBack(scope, {
		// 						$event: event
		// 						});
		// 						scrollCompleted = true;
					
		// 					};
		// 					$timeout(callback, 100);
		// 				}
		// 	  		}
		// 		});
		
		// 		var closeDestroyer = scope.$on('uis:close', function() {
		// 			var pagingOptions = scope.$select.pagingOptions || {};
		// 			pagingOptions.filteredItems = undefined;
		// 			pagingOptions.page = 0;
		// 		});
		
		// 		scope.addMoreItems = function(doneCalBack) {
		// 			console.log('new addMoreItems');
		// 			var $select = scope.$select;
		// 			var allItems = scope.pagingOptions.allOptions;
		// 			var moreItems = [];
		// 			var itemsThreshold = 20;
		// 			var search = $select.search;
				
		// 			var pagingOptions = $select.pagingOptions = $select.pagingOptions || {
		// 				page: 0,
		// 				pageSize: 20,
		// 				items: $select.items
		// 			};
				
		// 			if (pagingOptions.page === 0) {
		// 				pagingOptions.items.length = 0;
		// 			}
		// 			if (!pagingOptions.originalAllItems) {
		// 				pagingOptions.originalAllItems = scope.pagingOptions.allOptions;
		// 			}
					
		// 			var searchDidNotChange = search && pagingOptions.prevSearch && search == pagingOptions.prevSearch;
		// 			if (pagingOptions.filteredItems && searchDidNotChange) {
		// 				allItems = pagingOptions.filteredItems;
		// 			}

		// 			pagingOptions.prevSearch = search;
		// 			moreItems = $filter('filter')(pagingOptions.originalAllItems, search);
		// 			if (search && search.length > 0 && pagingOptions.items.length < allItems.length && !searchDidNotChange) {
						
		// 				pagingOptions.filteredItems = undefined;

		// 				//if filtered items are too many scrolling should occur for filtered items
		// 				if (moreItems.length > itemsThreshold) {
		// 					if (!pagingOptions.filteredItems) {
		// 						pagingOptions.page = 0;
		// 						pagingOptions.items.length = 0;
		// 					} 

		// 					pagingOptions.page = 0;
		// 					pagingOptions.items.length = 0;
		// 					allItems = pagingOptions.filteredItems = moreItems;				
		// 				} else {
		// 					allItems = moreItems;
		// 					pagingOptions.items.length = 0;
		// 					pagingOptions.filteredItems = undefined;
		// 				}
		// 			} else {
		// 				// Check if Search did not change, but has Search Results, 
		// 				// limit Items to Search Results only
		// 				if(moreItems.length > 0)
		// 				{
		// 					allItems = moreItems;					
		// 					pagingOptions.items.length = 0;
		// 					pagingOptions.filteredItems = undefined;
		// 				}
		// 			}			  

		// 			pagingOptions.page++;

		// 			if(allItems!=null)
		// 			{
		// 				if (pagingOptions.page * pagingOptions.pageSize < allItems.length) {
		// 					moreItems = allItems.slice(pagingOptions.items.length, pagingOptions.page * pagingOptions.pageSize);
		// 				}
		// 				else
		// 				{
		// 					moreItems = allItems;
		// 				}
		// 			}
					
		// 			for (var k = 0; k < moreItems.length; k++) {
		// 				if (pagingOptions.items.indexOf(moreItems[k]) == -1){
		// 				pagingOptions.items.push(moreItems[k]);
		// 				}
		// 			}
			
		// 			scope.calculateDropdownPos();
		// 			scope.$broadcast('uis:refresh');
		// 			if (doneCalBack) doneCalBack();
		// 		};

		// 		scope.$on('$destroy', function() {
		// 			elm.off('scroll');
		// 			closeDestroyer();
		// 		});
		//   	};
		// }]);
})();
(function() {
    'use strict';

	angular.module('RmsAppV2.filter', [])
	
		.filter("trustUrl", function($sce) {
			return function(Url) {
				return $sce.trustAsResourceUrl(Url);
			};
		})
		
		.filter('unique', function() {
			return function (arr, field) {
				if(!arr) return [];
				
				var o = {}, i, l = arr.length, r = [];
				for(i=0; i<l;i+=1) {
					o[arr[i][field]] = arr[i];
				}
				for(i in o) {
					r.push(o[i]);
				}
				return r;
			};
		})
		
		.filter('showOpenOnly', function() {			
			return function(dataList, isOpenOnly) {				
				var list = [];
				dataList.forEach(function(d) {
					if(isOpenOnly) {
						if(d.status=='New' || d.status=='Confirmed' || d.status=='Approved') {
							list.push(d);
						}	
					} else {
						list.push(d);
					}					
				});
				
				return list;
			};
		})
		
		.filter('propsFilter', function() {
			return function(items, props) {
			  var out = [];
		  
			  if (angular.isArray(items)) {
				var keys = Object.keys(props);
		  
				items.forEach(function(item) {
				  if (!item) return;
				  var itemMatches = false;
		  
				  for (var i = 0; i < keys.length; i++) {
					var prop = keys[i];
					var text = props[prop].toLowerCase();
					if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
					  itemMatches = true;
					  break;
					}
				  }
		  
				  if (itemMatches) {
					out.push(item);
				  }
				});
			  } else {
				// Let the output be the input untouched
				out = items;
			  }
		  
			  return out;
			};
		})
		  
		.filter('numAbs', function() {
			return function(num) { return Math.abs(num); }
		}); ;
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.httpService', ['ngResource'])
        .factory('HttpSvc', HttpService);

    /** @ngInject */
    function HttpService($resource, $q, $http, RmsApi) {
				
		var httpSvc = {};
		
		httpSvc.get = function(method, params, tokenId, isArray) {
			
			var req = {
                    method: "GET",
					isArray : isArray
                };
			
			if (tokenId !== "") {
				req.headers = {
					'Authorization': 'basic ' + tokenId
				}
			}
				
			if (typeof params !== "undefined" && params !== null) {} 
			else { 
				params = "{}"; 
			}
				
			var endPoint = $resource(RmsApi.URL + method, {}, {get:req} );
			return $q(function(resolve, reject){
						endPoint
							.get(params)
							.$promise
							.then(function(data) {
								resolve(data);
							}, function(error) {
								if (typeof error.data !== "undefined" && error.data !== null) {
									reject(error.data.message);									
								} else {
									reject(error.message);
								}
							});
			});
		};
		
		httpSvc.getExt = function(method, params, isArray) {
			
			var req = {
                    method: "GET",
					isArray : isArray
                };
				
			if (typeof params !== "undefined" && params !== null) {} 
			else { 
				params = "{}"; 
			}
				
			var endPoint = $resource(method, {}, {get:req} );
			return $q(function(resolve, reject){
						endPoint
							.get(params)
							.$promise
							.then(function(data) {
								resolve(data);
							}, function(error) {
								if (typeof error.data !== "undefined" && error.data !== null) {
									reject(error.data.message);									
								} else {
									reject(error.message);
								}
							});
			});
		};
		
		httpSvc.getPdfObject = function(method, tokenId, filename) {
			
			var req = {
                    method: "GET",
					responseType: 'arraybuffer',
					cache: false,
					transformResponse: function (data) {
						var pdf;
						if (data) {
							pdf = new Blob([data], {
								type: 'application/pdf'
							});
						}
						return {
							object: pdf
						};
					}
                };
			
			if (tokenId !== "") {
				req.headers = {
					'Accept': 'application/pdf',
					'Authorization': 'basic ' + tokenId
				}
			}
			
			return $http.get(RmsApi.URL + method, req)
				.then(function (response) {
					var blob = new Blob([response.data.object], {
						type: 'application/pdf'
					});
					saveAs(blob, filename);
				});
		};
		
		httpSvc.postPdfObject = function(method, params, tokenId, filename) {
			
			var req = {
                    method: "POST",
					responseType: 'arraybuffer',
					cache: false,
					transformResponse: function (data) {
						var pdf;
						if (data) {
							pdf = new Blob([data], {
								type: 'application/pdf'
							});
						}
						return {
							object: pdf
						};
					}
                };
			
			if (tokenId !== "") {
				req.headers = {
					'Accept': 'application/pdf',
					'Authorization': 'basic ' + tokenId
				}
			}
				
			if (typeof params !== "undefined" && params !== null) {} 
			else { 
				params = "{}"; 
			}
			
			return $http.post(RmsApi.URL + method, params, req)
				.then(function (response) {
					var blob = new Blob([response.data.object], {
						type: 'application/pdf'
					});
					saveAs(blob, filename);
				});
		};
		
		httpSvc.getExcelObject = function(method, tokenId, filename) {
			
			var req = {
                    method: "GET",
					responseType: 'arraybuffer',
					cache: false,
					transformResponse: function (data) {
						var excel;
						if (data) {
							excel = new Blob([data], {
								type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
							});
						}
						return {
							object: excel
						};
					}
                };
			
			if (tokenId !== "") {
				req.headers = {
					'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
					'Authorization': 'basic ' + tokenId
				}
			}
			
			return $http.get(RmsApi.URL + method, req)
				.then(function (response) {
					var blob = new Blob([response.data.object], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					});
					saveAs(blob, filename);

					// var fileURL = window.URL.createObjectURL(response.data.object);
					
					// var a = document.createElement('a');
					// a.href = fileURL;
					// a.download = filename;
					// a.style.display = 'none';
					// document.body.appendChild(a);
					// a.click();
					//return response;
				});
		};
		
		httpSvc.post = function(method, params, tokenId, isArray) {
			
			var req = {
                    method: "POST",
					isArray : isArray
                };
			
			if (tokenId !== "") {
				req.headers = {
					'Authorization': 'basic ' + tokenId
				}
			}
				
			if (typeof params !== "undefined" && params !== null) {} 
			else { 
				params = "{}"; 
			}
				
			var endPoint = $resource(RmsApi.URL + method, {}, {post:req} );
			return $q(function(resolve, reject){
						endPoint
							.post(params)
							.$promise
							.then(function(data) {
								resolve(data);
							}, function(error) {
								if (typeof error.data !== "undefined" && error.data !== null) {
									reject(error.data.message);
								} else {
									reject(error.message);
								}
							});
			});
		};
					
		httpSvc.postExt = function(method, params, tokenId, isArray) {
			
			var req = {
                    method: "POST",
					isArray : isArray
                };
			
			if (tokenId !== "") {
				req.headers = {
					'Authorization': 'basic ' + tokenId,
					'Content-Type': undefined
				}
			}
				
			if (typeof params !== "undefined" && params !== null) {} 
			else { 
				params = "{}"; 
			}
				
			var endPoint = $resource(method, {}, {post:req} );
			return $q(function(resolve, reject){
						endPoint
							.post(params)
							.$promise
							.then(function(data) {
								resolve(data);
							}, function(error) {
								if (typeof error.data !== "undefined" && error.data !== null) {
									reject(error.data.message);
								} else {
									reject(error.message);
								}
							});
			});
		};
		
		httpSvc.put = function(method, params, tokenId, isArray) {
			
			var req = {
                    method: "PUT",
					isArray : isArray
                };
			
			if (tokenId !== "") {
				req.headers = {
					'Authorization': 'basic ' + tokenId
				}
			}
				
			if (typeof params !== "undefined" && params !== null) {} 
			else { 
				params = ""; 
			}
				
			var endPoint = $resource(RmsApi.URL + method, {}, {put:req} );
			return $q(function(resolve, reject){
						endPoint
							.put({}, params)
							.$promise
							.then(function(data) {
								resolve(data);
							}, function(error) {
								if (typeof error.data !== "undefined" && error.data !== null) {
									reject(error.data.message);									
								} else {
									reject(error.message);
								}
							});
			});
		};
		
		httpSvc.delete = function(method, params, tokenId, isArray) {
			
			var req = {
                    method: "DELETE",
					isArray : isArray
                };
			
			if (tokenId !== "") {
				req.headers = {
					'Authorization': 'basic ' + tokenId
				}
			}
				
			if (typeof params !== "undefined" && params !== null) {} 
			else { 
				params = "{}"; 
			}
				
			var endPoint = $resource(RmsApi.URL + method, {}, {delete:req} );
			return $q(function(resolve, reject){
						endPoint
							.delete(params)
							.$promise
							.then(function(data) {
								resolve(data);
							}, function(error) {
								if (typeof error.data !== "undefined" && error.data !== null) {
									reject(error.data.message);
								} else {
									reject(error.message);
								}
							});
			});
		};
		
        return httpSvc;
    }
})();


(function() {
	'use strict';

	angular.module('RmsAppV2', [
		'ngAnimate',
		'ngFileUpload',
		'ngJsTree',
		'ngMessages',
		"ngQtip2",
		'ngResource',
		'ngRoute',
		'ngTouch',
		'permission',
		'permission.ui',

		'ui.bootstrap',
		'ui.checkbox',
		'ui.router',
		'ui.slimscroll',
		'ui.sortable',
		'ui.toggle',

		'720kb.datepicker',
		'afkl.lazyImage',
		'angular.filter',
		'angular-fullcalendar',
		'angular-loading-bar',
		'angular-progress-button-styles',
		'angularjs-dropdown-multiselect',
		'angularModalService',
		'angularTrix',
		'checklist-model',
		'colorpicker.module',
		'daterangepicker',
		'duScroll',
		'fancyboxplus',
		'FBAngular',
		'moment-picker',
		'pascalprecht.translate',
		'pubnub.angular.service',
		'smart-table',
		"textAngular",
		'toastr',
		"xeditable",

		'RmsAppV2.theme',
		'RmsAppV2.pages',
		'RmsAppV2.login',
		'RmsAppV2.config',
		'RmsAppV2.constant',
		'RmsAppV2.controller',
		'RmsAppV2.directive',
		'RmsAppV2.filter',
		'RmsAppV2.authService',
		'RmsAppV2.httpService',
		'RmsAppV2.msgService',
		'RmsAppV2.approvalService',
		'RmsAppV2.announcementService',
		'RmsAppV2.utilities',
		'RmsAppV2.theme.components',
	])
	.value('duScrollOffset', 70);

})();


(function() {
    'use strict';

    angular.module('RmsAppV2.msgService', ['ngResource', 'ngStorage'])
        .factory('MsgSvc', MessagingService);

    /** @ngInject */
    function MessagingService($resource, $rootScope, $sessionStorage, $state, $q, HttpSvc, RmsApi, Auth, toastr) {
				
		Auth.init();
		
		var msgsvc = {};
		$rootScope.messageCount = 0;
		
		msgsvc.loadMessages = function() {
			
			if(!Auth.isLoggedIn()) return;
			
			HttpSvc.get("messagecenter/list", {}, Auth.getTokenId(), true)
				.then(function(result) {
					$sessionStorage.messages = result;
					$rootScope.messages = $sessionStorage.messages;
					
					msgsvc.updateUnreadCount();
				}, function() {	
				});
		}
		
		msgsvc.setMessageAllRead = function() {
			HttpSvc.put("messagecenter/markallasread", {}, Auth.getTokenId(), false)
				.then(function(result) {
					msgsvc.loadMessages();
				}, function() {	
				});	
		} 
		
		msgsvc.setMessageRead = function(msgId) {			
			HttpSvc.put("messagecenter/markasread/" + msgId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					msgsvc.loadMessages();
				}, function() {	
				});	
		} 
		
		msgsvc.updateUnreadCount = function() {
			var cnt = 0;
			
			$sessionStorage.messages.forEach(function(m) {
				if(!m.isRead) {
					cnt++;
				}
			});
			$rootScope.messageCount = cnt;
		}
				
        return msgsvc;
    }
})();


(function() {
    'use strict';

    angular.module('RmsAppV2.uploadService', ['ngResource'])
        .factory('UploadSvc', UploadService);

    /** @ngInject */
    function UploadService($resource, $q, $http, RmsApi) {
				
		var uploadSvc = {};
		
        var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		
		// Upload Image to Azure Blob Storage
		uploadSvc.upload = function (_serverMode, _fileToUpload, _objId, _storageUrl) {
			
			/* Initialize variables */
			/* ************************************* */	
			handleFileSelect(_fileToUpload);
			/* ************************************* */	
			
			/* Initialize File Reader */
			/* ************************************* */
			fileReader = new FileReader();
			/* ************************************* */
			
			if(_serverMode==0) {	// Local Server
			
				Upload.upload({
					url: _storageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (resp) {
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(_serverMode==1) { // Azure Server
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, _storageUrl, _objId);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = _storageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, _storageUrl, _objId);
							} else {
								// ##############################
								// ##############################
								// Return Positive Response
								// ##############################
								// ##############################
							} 
						}, null, function(evt) {
							// $mdl.uploadProgessTotal = _fileToUpload.size;
							// $mdl.uploadProgess = $mdl.uploadProgessTotal - totalBytesRemaining;
							// $mdl.uploadProgessPercent = Math.min(100, parseInt(100.0 * $mdl.uploadProgess / $mdl.uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl, _objId) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl, _objId);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl, _objId) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,
				
			}).then(function(response) {
				HttpSvc.put('mediaconversion/ready/recipestep/' + _objId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Media uploaded successfully.");
						$uibModalInstance.close($mdl.item);
					}, function(error) {
					});
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }
		
        return uploadSvc;
    }
})();


(function() {
    'use strict';

    angular.module('RmsAppV2.utilities', [])
        .factory('UtilSvc', UtilService);

    /** @ngInject */
    function UtilService($resource, $q, RmsApi) {
				
		var utilSvc = {};
		
		utilSvc.generateGuid = function () {
			return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
		}
		
		utilSvc.generateRandomString = function (length) {
			var chars = '23456789abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ';
			var result = '';
			for (var i = length; i > 0; --i) 
				result += chars[Math.floor(Math.random() * chars.length)];
			return result;
		}

		utilSvc.getErrorMessage = function (form) {
			var errorMsg = "";
			if(form.$error.required)
			{
				form.$error.required.forEach(function(e) {
					errorMsg += "<li><b>" + e.$name + "</b></li>";	
				});
			}
			if(form.$error.min)
			{
				form.$error.min.forEach(function(e) {
					errorMsg += "<li><b>" + e.$name + "</b></li>";	
				});
			}
			if(form.$error.number)
			{
				form.$error.number.forEach(function(e) {
					errorMsg += "<li><b>" + e.$name + "</b></li>";	
				});
			}
						
			if(errorMsg != "" || errorMsg != null)
			{
				errorMsg = "Please check the following field(s):<br /><br /><ul style='padding-left:15px'>" + errorMsg + "</ul>";
			}

			return errorMsg;
		}

		utilSvc.getObjectFromArray = function (array, value) {			
			for (var i=0; i<array.length; i++) 
			{			
				if (array[i].id == value) return arr[i];
			}
			return null;
		}
		
		function s4() {
			return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
		}
		
        return utilSvc;
    }
})();

/* interact.js 1.9.20 | https://raw.github.com/taye/interact.js/master/LICENSE */
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).interact=t()}}((function(){var t={};Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default=function(t){return!(!t||!t.Window)&&t instanceof t.Window};var e={};Object.defineProperty(e,"__esModule",{value:!0}),e.init=r,e.getWindow=o,e.default=void 0;var n={realWindow:void 0,window:void 0,getWindow:o,init:r};function r(t){n.realWindow=t;var e=t.document.createTextNode("");e.ownerDocument!==t.document&&"function"==typeof t.wrap&&t.wrap(e)===e&&(t=t.wrap(t)),n.window=t}function o(e){return(0,t.default)(e)?e:(e.ownerDocument||e).defaultView||n.window}"undefined"==typeof window?(n.window=void 0,n.realWindow=void 0):r(window),n.init=r;var i=n;e.default=i;var a={};function s(t){return(s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}Object.defineProperty(a,"__esModule",{value:!0}),a.default=void 0;var l=function(t){return!!t&&"object"===s(t)},u=function(t){return"function"==typeof t},c={window:function(n){return n===e.default.window||(0,t.default)(n)},docFrag:function(t){return l(t)&&11===t.nodeType},object:l,func:u,number:function(t){return"number"==typeof t},bool:function(t){return"boolean"==typeof t},string:function(t){return"string"==typeof t},element:function(t){if(!t||"object"!==s(t))return!1;var n=e.default.getWindow(t)||e.default.window;return/object|function/.test(s(n.Element))?t instanceof n.Element:1===t.nodeType&&"string"==typeof t.nodeName},plainObject:function(t){return l(t)&&!!t.constructor&&/function Object\b/.test(t.constructor.toString())},array:function(t){return l(t)&&void 0!==t.length&&u(t.splice)}};a.default=c;var f={};function d(t){var e=t.interaction;if("drag"===e.prepared.name){var n=e.prepared.axis;"x"===n?(e.coords.cur.page.y=e.coords.start.page.y,e.coords.cur.client.y=e.coords.start.client.y,e.coords.velocity.client.y=0,e.coords.velocity.page.y=0):"y"===n&&(e.coords.cur.page.x=e.coords.start.page.x,e.coords.cur.client.x=e.coords.start.client.x,e.coords.velocity.client.x=0,e.coords.velocity.page.x=0)}}function p(t){var e=t.iEvent,n=t.interaction;if("drag"===n.prepared.name){var r=n.prepared.axis;if("x"===r||"y"===r){var o="x"===r?"y":"x";e.page[o]=n.coords.start.page[o],e.client[o]=n.coords.start.client[o],e.delta[o]=0}}}Object.defineProperty(f,"__esModule",{value:!0}),f.default=void 0;var v={id:"actions/drag",install:function(t){var e=t.actions,n=t.Interactable,r=t.defaults;n.prototype.draggable=v.draggable,e.map.drag=v,e.methodDict.drag="draggable",r.actions.drag=v.defaults},listeners:{"interactions:before-action-move":d,"interactions:action-resume":d,"interactions:action-move":p,"auto-start:check":function(t){var e=t.interaction,n=t.interactable,r=t.buttons,o=n.options.drag;if(o&&o.enabled&&(!e.pointerIsDown||!/mouse|pointer/.test(e.pointerType)||0!=(r&n.options.drag.mouseButtons)))return t.action={name:"drag",axis:"start"===o.lockAxis?o.startAxis:o.lockAxis},!1}},draggable:function(t){return a.default.object(t)?(this.options.drag.enabled=!1!==t.enabled,this.setPerAction("drag",t),this.setOnEvents("drag",t),/^(xy|x|y|start)$/.test(t.lockAxis)&&(this.options.drag.lockAxis=t.lockAxis),/^(xy|x|y)$/.test(t.startAxis)&&(this.options.drag.startAxis=t.startAxis),this):a.default.bool(t)?(this.options.drag.enabled=t,this):this.options.drag},beforeMove:d,move:p,defaults:{startAxis:"xy",lockAxis:"xy"},getCursor:function(){return"move"}},h=v;f.default=h;var g={};Object.defineProperty(g,"__esModule",{value:!0}),g.default=void 0;var y={init:function(t){var e=t;y.document=e.document,y.DocumentFragment=e.DocumentFragment||m,y.SVGElement=e.SVGElement||m,y.SVGSVGElement=e.SVGSVGElement||m,y.SVGElementInstance=e.SVGElementInstance||m,y.Element=e.Element||m,y.HTMLElement=e.HTMLElement||y.Element,y.Event=e.Event,y.Touch=e.Touch||m,y.PointerEvent=e.PointerEvent||e.MSPointerEvent},document:null,DocumentFragment:null,SVGElement:null,SVGSVGElement:null,SVGElementInstance:null,Element:null,HTMLElement:null,Event:null,Touch:null,PointerEvent:null};function m(){}var b=y;g.default=b;var x={};Object.defineProperty(x,"__esModule",{value:!0}),x.default=void 0;var w={init:function(t){var n=g.default.Element,r=e.default.window.navigator;w.supportsTouch="ontouchstart"in t||a.default.func(t.DocumentTouch)&&g.default.document instanceof t.DocumentTouch,w.supportsPointerEvent=!1!==r.pointerEnabled&&!!g.default.PointerEvent,w.isIOS=/iP(hone|od|ad)/.test(r.platform),w.isIOS7=/iP(hone|od|ad)/.test(r.platform)&&/OS 7[^\d]/.test(r.appVersion),w.isIe9=/MSIE 9/.test(r.userAgent),w.isOperaMobile="Opera"===r.appName&&w.supportsTouch&&/Presto/.test(r.userAgent),w.prefixedMatchesSelector="matches"in n.prototype?"matches":"webkitMatchesSelector"in n.prototype?"webkitMatchesSelector":"mozMatchesSelector"in n.prototype?"mozMatchesSelector":"oMatchesSelector"in n.prototype?"oMatchesSelector":"msMatchesSelector",w.pEventTypes=w.supportsPointerEvent?g.default.PointerEvent===t.MSPointerEvent?{up:"MSPointerUp",down:"MSPointerDown",over:"mouseover",out:"mouseout",move:"MSPointerMove",cancel:"MSPointerCancel"}:{up:"pointerup",down:"pointerdown",over:"pointerover",out:"pointerout",move:"pointermove",cancel:"pointercancel"}:null,w.wheelEvent="onmousewheel"in g.default.document?"mousewheel":"wheel"},supportsTouch:null,supportsPointerEvent:null,isIOS7:null,isIOS:null,isIe9:null,isOperaMobile:null,prefixedMatchesSelector:null,pEventTypes:null,wheelEvent:null};var _=w;x.default=_;var S={};function P(t){var e=t.parentNode;if(a.default.docFrag(e)){for(;(e=e.host)&&a.default.docFrag(e););return e}return e}function O(t,n){return e.default.window!==e.default.realWindow&&(n=n.replace(/\/deep\//g," ")),t[x.default.prefixedMatchesSelector](n)}Object.defineProperty(S,"__esModule",{value:!0}),S.nodeContains=function(t,e){for(;e;){if(e===t)return!0;e=e.parentNode}return!1},S.closest=function(t,e){for(;a.default.element(t);){if(O(t,e))return t;t=P(t)}return null},S.parentNode=P,S.matchesSelector=O,S.indexOfDeepestElement=function(t){for(var n,r=[],o=0;o<t.length;o++){var i=t[o],a=t[n];if(i&&o!==n)if(a){var s=E(i),l=E(a);if(s!==i.ownerDocument)if(l!==i.ownerDocument)if(s!==l){r=r.length?r:T(a);var u=void 0;if(a instanceof g.default.HTMLElement&&i instanceof g.default.SVGElement&&!(i instanceof g.default.SVGSVGElement)){if(i===l)continue;u=i.ownerSVGElement}else u=i;for(var c=T(u,a.ownerDocument),f=0;c[f]&&c[f]===r[f];)f++;for(var d=[c[f-1],c[f],r[f]],p=d[0].lastChild;p;){if(p===d[1]){n=o,r=c;break}if(p===d[2])break;p=p.previousSibling}}else v=i,h=a,y=void 0,m=void 0,y=parseInt((0,e.getWindow)(v).getComputedStyle(v).zIndex,10)||0,m=parseInt((0,e.getWindow)(h).getComputedStyle(h).zIndex,10)||0,y>=m&&(n=o);else n=o}else n=o}var v,h,y,m;return n},S.matchesUpTo=function(t,e,n){for(;a.default.element(t);){if(O(t,e))return!0;if((t=P(t))===n)return O(t,e)}return!1},S.getActualElement=function(t){return t instanceof g.default.SVGElementInstance?t.correspondingUseElement:t},S.getScrollXY=M,S.getElementClientRect=j,S.getElementRect=function(t){var n=j(t);if(!x.default.isIOS7&&n){var r=M(e.default.getWindow(t));n.left+=r.x,n.right+=r.x,n.top+=r.y,n.bottom+=r.y}return n},S.getPath=function(t){var e=[];for(;t;)e.push(t),t=P(t);return e},S.trySelector=function(t){if(!a.default.string(t))return!1;return g.default.document.querySelector(t),!0};var E=function(t){return t.parentNode||t.host};function T(t,e){for(var n,r=[],o=t;(n=E(o))&&o!==e&&n!==o.ownerDocument;)r.unshift(o),o=n;return r}function M(t){return{x:(t=t||e.default.window).scrollX||t.document.documentElement.scrollLeft,y:t.scrollY||t.document.documentElement.scrollTop}}function j(t){var e=t instanceof g.default.SVGElement?t.getBoundingClientRect():t.getClientRects()[0];return e&&{left:e.left,right:e.right,top:e.top,bottom:e.bottom,width:e.width||e.right-e.left,height:e.height||e.bottom-e.top}}var k={};Object.defineProperty(k,"__esModule",{value:!0}),k.default=function(t,e){for(var n in e)t[n]=e[n];return t};var I={};function D(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=Array(e);n<e;n++)r[n]=t[n];return r}function A(t,e,n){return"parent"===t?(0,S.parentNode)(n):"self"===t?e.getRect(n):(0,S.closest)(n,t)}Object.defineProperty(I,"__esModule",{value:!0}),I.getStringOptionResult=A,I.resolveRectLike=function(t,e,n,r){var o=t;a.default.string(o)?o=A(o,e,n):a.default.func(o)&&(o=o.apply(void 0,function(t){if(Array.isArray(t))return D(t)}(i=r)||function(t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}(i)||function(t,e){if(t){if("string"==typeof t)return D(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?D(t,e):void 0}}(i)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()));var i;a.default.element(o)&&(o=(0,S.getElementRect)(o));return o},I.rectToXY=function(t){return t&&{x:"x"in t?t.x:t.left,y:"y"in t?t.y:t.top}},I.xywhToTlbr=function(t){!t||"left"in t&&"top"in t||((t=(0,k.default)({},t)).left=t.x||0,t.top=t.y||0,t.right=t.right||t.left+t.width,t.bottom=t.bottom||t.top+t.height);return t},I.tlbrToXywh=function(t){!t||"x"in t&&"y"in t||((t=(0,k.default)({},t)).x=t.left||0,t.y=t.top||0,t.width=t.width||(t.right||0)-t.x,t.height=t.height||(t.bottom||0)-t.y);return t},I.addEdges=function(t,e,n){t.left&&(e.left+=n.x);t.right&&(e.right+=n.x);t.top&&(e.top+=n.y);t.bottom&&(e.bottom+=n.y);e.width=e.right-e.left,e.height=e.bottom-e.top};var z={};Object.defineProperty(z,"__esModule",{value:!0}),z.default=function(t,e,n){var r=t.options[n],o=r&&r.origin||t.options.origin,i=(0,I.resolveRectLike)(o,t,e,[t&&e]);return(0,I.rectToXY)(i)||{x:0,y:0}};var C={};function R(t){return t.trim().split(/ +/)}Object.defineProperty(C,"__esModule",{value:!0}),C.default=function t(e,n,r){r=r||{},a.default.string(e)&&-1!==e.search(" ")&&(e=R(e));if(a.default.array(e))return e.reduce((function(e,o){return(0,k.default)(e,t(o,n,r))}),r);a.default.object(e)&&(n=e,e="");if(a.default.func(n))r[e]=r[e]||[],r[e].push(n);else if(a.default.array(n))for(var o=0;o<n.length;o++){var i;i=n[o],t(e,i,r)}else if(a.default.object(n))for(var s in n){var l=R(s).map((function(t){return"".concat(e).concat(t)}));t(l,n[s],r)}return r};var F={};Object.defineProperty(F,"__esModule",{value:!0}),F.default=void 0;F.default=function(t,e){return Math.sqrt(t*t+e*e)};var X={};function Y(t,e){for(var n in e){var r=Y.prefixedPropREs,o=!1;for(var i in r)if(0===n.indexOf(i)&&r[i].test(n)){o=!0;break}o||"function"==typeof e[n]||(t[n]=e[n])}return t}Object.defineProperty(X,"__esModule",{value:!0}),X.default=void 0,Y.prefixedPropREs={webkit:/(Movement[XY]|Radius[XY]|RotationAngle|Force)$/,moz:/(Pressure)$/};var W=Y;X.default=W;var L={};function B(t){return t instanceof g.default.Event||t instanceof g.default.Touch}function U(t,e,n){return t=t||"page",(n=n||{}).x=e[t+"X"],n.y=e[t+"Y"],n}function V(t,e){return e=e||{x:0,y:0},x.default.isOperaMobile&&B(t)?(U("screen",t,e),e.x+=window.scrollX,e.y+=window.scrollY):U("page",t,e),e}function q(t,e){return e=e||{},x.default.isOperaMobile&&B(t)?U("screen",t,e):U("client",t,e),e}function N(t){var e=[];return a.default.array(t)?(e[0]=t[0],e[1]=t[1]):"touchend"===t.type?1===t.touches.length?(e[0]=t.touches[0],e[1]=t.changedTouches[0]):0===t.touches.length&&(e[0]=t.changedTouches[0],e[1]=t.changedTouches[1]):(e[0]=t.touches[0],e[1]=t.touches[1]),e}function $(t){for(var e={pageX:0,pageY:0,clientX:0,clientY:0,screenX:0,screenY:0},n=0;n<t.length;n++){var r=t[n];for(var o in e)e[o]+=r[o]}for(var i in e)e[i]/=t.length;return e}Object.defineProperty(L,"__esModule",{value:!0}),L.copyCoords=function(t,e){t.page=t.page||{},t.page.x=e.page.x,t.page.y=e.page.y,t.client=t.client||{},t.client.x=e.client.x,t.client.y=e.client.y,t.timeStamp=e.timeStamp},L.setCoordDeltas=function(t,e,n){t.page.x=n.page.x-e.page.x,t.page.y=n.page.y-e.page.y,t.client.x=n.client.x-e.client.x,t.client.y=n.client.y-e.client.y,t.timeStamp=n.timeStamp-e.timeStamp},L.setCoordVelocity=function(t,e){var n=Math.max(e.timeStamp/1e3,.001);t.page.x=e.page.x/n,t.page.y=e.page.y/n,t.client.x=e.client.x/n,t.client.y=e.client.y/n,t.timeStamp=n},L.setZeroCoords=function(t){t.page.x=0,t.page.y=0,t.client.x=0,t.client.y=0},L.isNativePointer=B,L.getXY=U,L.getPageXY=V,L.getClientXY=q,L.getPointerId=function(t){return a.default.number(t.pointerId)?t.pointerId:t.identifier},L.setCoords=function(t,e,n){var r=e.length>1?$(e):e[0],o={};V(r,o),t.page.x=o.x,t.page.y=o.y,q(r,o),t.client.x=o.x,t.client.y=o.y,t.timeStamp=n},L.getTouchPair=N,L.pointerAverage=$,L.touchBBox=function(t){if(!(t.length||t.touches&&t.touches.length>1))return null;var e=N(t),n=Math.min(e[0].pageX,e[1].pageX),r=Math.min(e[0].pageY,e[1].pageY),o=Math.max(e[0].pageX,e[1].pageX),i=Math.max(e[0].pageY,e[1].pageY);return{x:n,y:r,left:n,top:r,right:o,bottom:i,width:o-n,height:i-r}},L.touchDistance=function(t,e){var n=e+"X",r=e+"Y",o=N(t),i=o[0][n]-o[1][n],a=o[0][r]-o[1][r];return(0,F.default)(i,a)},L.touchAngle=function(t,e){var n=e+"X",r=e+"Y",o=N(t),i=o[1][n]-o[0][n],a=o[1][r]-o[0][r];return 180*Math.atan2(a,i)/Math.PI},L.getPointerType=function(t){return a.default.string(t.pointerType)?t.pointerType:a.default.number(t.pointerType)?[void 0,void 0,"touch","pen","mouse"][t.pointerType]:/touch/.test(t.type)||t instanceof g.default.Touch?"touch":"mouse"},L.getEventTargets=function(t){var e=a.default.func(t.composedPath)?t.composedPath():t.path;return[S.getActualElement(e?e[0]:t.target),S.getActualElement(t.currentTarget)]},L.newCoords=function(){return{page:{x:0,y:0},client:{x:0,y:0},timeStamp:0}},L.coordsToEvent=function(t){return{coords:t,get page(){return this.coords.page},get client(){return this.coords.client},get timeStamp(){return this.coords.timeStamp},get pageX(){return this.coords.page.x},get pageY(){return this.coords.page.y},get clientX(){return this.coords.client.x},get clientY(){return this.coords.client.y},get pointerId(){return this.coords.pointerId},get target(){return this.coords.target},get type(){return this.coords.type},get pointerType(){return this.coords.pointerType},get buttons(){return this.coords.buttons},preventDefault:function(){}}},Object.defineProperty(L,"pointerExtend",{enumerable:!0,get:function(){return X.default}});var G={};function H(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}Object.defineProperty(G,"__esModule",{value:!0}),G.default=G.BaseEvent=void 0;var K=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.type=void 0,this.target=void 0,this.currentTarget=void 0,this.interactable=void 0,this._interaction=void 0,this.timeStamp=void 0,this.immediatePropagationStopped=!1,this.propagationStopped=!1,this._interaction=e}var e,n,r;return e=t,(n=[{key:"preventDefault",value:function(){}},{key:"stopPropagation",value:function(){this.propagationStopped=!0}},{key:"stopImmediatePropagation",value:function(){this.immediatePropagationStopped=this.propagationStopped=!0}}])&&H(e.prototype,n),r&&H(e,r),t}();G.BaseEvent=K,Object.defineProperty(K.prototype,"interaction",{get:function(){return this._interaction._proxy},set:function(){}});var Z=K;G.default=Z;var J={};Object.defineProperty(J,"__esModule",{value:!0}),J.find=J.findIndex=J.from=J.merge=J.remove=J.contains=void 0;J.contains=function(t,e){return-1!==t.indexOf(e)};J.remove=function(t,e){return t.splice(t.indexOf(e),1)};var Q=function(t,e){for(var n=0;n<e.length;n++){var r=e[n];t.push(r)}return t};J.merge=Q;J.from=function(t){return Q([],t)};var tt=function(t,e){for(var n=0;n<t.length;n++)if(e(t[n],n,t))return n;return-1};J.findIndex=tt;J.find=function(t,e){return t[tt(t,e)]};var et={};function nt(t){return(nt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function rt(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function ot(t,e){return(ot=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function it(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=st(t);if(e){var o=st(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return at(this,n)}}function at(t,e){return!e||"object"!==nt(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function st(t){return(st=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}Object.defineProperty(et,"__esModule",{value:!0}),et.DropEvent=void 0;var lt=function(t){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&ot(t,e)}(i,t);var e,n,r,o=it(i);function i(t,e,n){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(r=o.call(this,e._interaction)).target=void 0,r.dropzone=void 0,r.dragEvent=void 0,r.relatedTarget=void 0,r.draggable=void 0,r.timeStamp=void 0,r.propagationStopped=!1,r.immediatePropagationStopped=!1;var a="dragleave"===n?t.prev:t.cur,s=a.element,l=a.dropzone;return r.type=n,r.target=s,r.currentTarget=s,r.dropzone=l,r.dragEvent=e,r.relatedTarget=e.target,r.draggable=e.interactable,r.timeStamp=e.timeStamp,r}return e=i,(n=[{key:"reject",value:function(){var t=this,e=this._interaction.dropState;if("dropactivate"===this.type||this.dropzone&&e.cur.dropzone===this.dropzone&&e.cur.element===this.target)if(e.prev.dropzone=this.dropzone,e.prev.element=this.target,e.rejected=!0,e.events.enter=null,this.stopImmediatePropagation(),"dropactivate"===this.type){var n=e.activeDrops,r=J.findIndex(n,(function(e){var n=e.dropzone,r=e.element;return n===t.dropzone&&r===t.target}));e.activeDrops.splice(r,1);var o=new i(e,this.dragEvent,"dropdeactivate");o.dropzone=this.dropzone,o.target=this.target,this.dropzone.fire(o)}else this.dropzone.fire(new i(e,this.dragEvent,"dragleave"))}},{key:"preventDefault",value:function(){}},{key:"stopPropagation",value:function(){this.propagationStopped=!0}},{key:"stopImmediatePropagation",value:function(){this.immediatePropagationStopped=this.propagationStopped=!0}}])&&rt(e.prototype,n),r&&rt(e,r),i}(G.BaseEvent);et.DropEvent=lt;var ut={};function ct(t,e){for(var n=0;n<t.slice().length;n++){var r=t.slice()[n],o=r.dropzone,i=r.element;e.dropzone=o,e.target=i,o.fire(e),e.propagationStopped=e.immediatePropagationStopped=!1}}function ft(t,e){for(var n=function(t,e){for(var n=t.interactables,r=[],o=0;o<n.list.length;o++){var i=n.list[o];if(i.options.drop.enabled){var s=i.options.drop.accept;if(!(a.default.element(s)&&s!==e||a.default.string(s)&&!S.matchesSelector(e,s)||a.default.func(s)&&!s({dropzone:i,draggableElement:e})))for(var l=a.default.string(i.target)?i._context.querySelectorAll(i.target):a.default.array(i.target)?i.target:[i.target],u=0;u<l.length;u++){var c=l[u];c!==e&&r.push({dropzone:i,element:c})}}}return r}(t,e),r=0;r<n.length;r++){var o=n[r];o.rect=o.dropzone.getRect(o.element)}return n}function dt(t,e,n){for(var r=t.dropState,o=t.interactable,i=t.element,a=[],s=0;s<r.activeDrops.length;s++){var l=r.activeDrops[s],u=l.dropzone,c=l.element,f=l.rect;a.push(u.dropCheck(e,n,o,i,c,f)?c:null)}var d=S.indexOfDeepestElement(a);return r.activeDrops[d]||null}function pt(t,e,n){var r=t.dropState,o={enter:null,leave:null,activate:null,deactivate:null,move:null,drop:null};return"dragstart"===n.type&&(o.activate=new et.DropEvent(r,n,"dropactivate"),o.activate.target=null,o.activate.dropzone=null),"dragend"===n.type&&(o.deactivate=new et.DropEvent(r,n,"dropdeactivate"),o.deactivate.target=null,o.deactivate.dropzone=null),r.rejected||(r.cur.element!==r.prev.element&&(r.prev.dropzone&&(o.leave=new et.DropEvent(r,n,"dragleave"),n.dragLeave=o.leave.target=r.prev.element,n.prevDropzone=o.leave.dropzone=r.prev.dropzone),r.cur.dropzone&&(o.enter=new et.DropEvent(r,n,"dragenter"),n.dragEnter=r.cur.element,n.dropzone=r.cur.dropzone)),"dragend"===n.type&&r.cur.dropzone&&(o.drop=new et.DropEvent(r,n,"drop"),n.dropzone=r.cur.dropzone,n.relatedTarget=r.cur.element),"dragmove"===n.type&&r.cur.dropzone&&(o.move=new et.DropEvent(r,n,"dropmove"),o.move.dragmove=n,n.dropzone=r.cur.dropzone)),o}function vt(t,e){var n=t.dropState,r=n.activeDrops,o=n.cur,i=n.prev;e.leave&&i.dropzone.fire(e.leave),e.move&&o.dropzone.fire(e.move),e.enter&&o.dropzone.fire(e.enter),e.drop&&o.dropzone.fire(e.drop),e.deactivate&&ct(r,e.deactivate),n.prev.dropzone=o.dropzone,n.prev.element=o.element}function ht(t,e){var n=t.interaction,r=t.iEvent,o=t.event;if("dragmove"===r.type||"dragend"===r.type){var i=n.dropState;e.dynamicDrop&&(i.activeDrops=ft(e,n.element));var a=r,s=dt(n,a,o);i.rejected=i.rejected&&!!s&&s.dropzone===i.cur.dropzone&&s.element===i.cur.element,i.cur.dropzone=s&&s.dropzone,i.cur.element=s&&s.element,i.events=pt(n,0,a)}}Object.defineProperty(ut,"__esModule",{value:!0}),ut.default=void 0;var gt={id:"actions/drop",install:function(t){var e=t.actions,n=t.interactStatic,r=t.Interactable,o=t.defaults;t.usePlugin(f.default),r.prototype.dropzone=function(t){return function(t,e){if(a.default.object(e)){if(t.options.drop.enabled=!1!==e.enabled,e.listeners){var n=(0,C.default)(e.listeners),r=Object.keys(n).reduce((function(t,e){return t[/^(enter|leave)/.test(e)?"drag".concat(e):/^(activate|deactivate|move)/.test(e)?"drop".concat(e):e]=n[e],t}),{});t.off(t.options.drop.listeners),t.on(r),t.options.drop.listeners=r}return a.default.func(e.ondrop)&&t.on("drop",e.ondrop),a.default.func(e.ondropactivate)&&t.on("dropactivate",e.ondropactivate),a.default.func(e.ondropdeactivate)&&t.on("dropdeactivate",e.ondropdeactivate),a.default.func(e.ondragenter)&&t.on("dragenter",e.ondragenter),a.default.func(e.ondragleave)&&t.on("dragleave",e.ondragleave),a.default.func(e.ondropmove)&&t.on("dropmove",e.ondropmove),/^(pointer|center)$/.test(e.overlap)?t.options.drop.overlap=e.overlap:a.default.number(e.overlap)&&(t.options.drop.overlap=Math.max(Math.min(1,e.overlap),0)),"accept"in e&&(t.options.drop.accept=e.accept),"checker"in e&&(t.options.drop.checker=e.checker),t}if(a.default.bool(e))return t.options.drop.enabled=e,t;return t.options.drop}(this,t)},r.prototype.dropCheck=function(t,e,n,r,o,i){return function(t,e,n,r,o,i,s){var l=!1;if(!(s=s||t.getRect(i)))return!!t.options.drop.checker&&t.options.drop.checker(e,n,l,t,i,r,o);var u=t.options.drop.overlap;if("pointer"===u){var c=(0,z.default)(r,o,"drag"),f=L.getPageXY(e);f.x+=c.x,f.y+=c.y;var d=f.x>s.left&&f.x<s.right,p=f.y>s.top&&f.y<s.bottom;l=d&&p}var v=r.getRect(o);if(v&&"center"===u){var h=v.left+v.width/2,g=v.top+v.height/2;l=h>=s.left&&h<=s.right&&g>=s.top&&g<=s.bottom}if(v&&a.default.number(u)){var y=Math.max(0,Math.min(s.right,v.right)-Math.max(s.left,v.left))*Math.max(0,Math.min(s.bottom,v.bottom)-Math.max(s.top,v.top))/(v.width*v.height);l=y>=u}t.options.drop.checker&&(l=t.options.drop.checker(e,n,l,t,i,r,o));return l}(this,t,e,n,r,o,i)},n.dynamicDrop=function(e){return a.default.bool(e)?(t.dynamicDrop=e,n):t.dynamicDrop},(0,k.default)(e.phaselessTypes,{dragenter:!0,dragleave:!0,dropactivate:!0,dropdeactivate:!0,dropmove:!0,drop:!0}),e.methodDict.drop="dropzone",t.dynamicDrop=!1,o.actions.drop=gt.defaults},listeners:{"interactions:before-action-start":function(t){var e=t.interaction;"drag"===e.prepared.name&&(e.dropState={cur:{dropzone:null,element:null},prev:{dropzone:null,element:null},rejected:null,events:null,activeDrops:[]})},"interactions:after-action-start":function(t,e){var n=t.interaction,r=(t.event,t.iEvent);if("drag"===n.prepared.name){var o=n.dropState;o.activeDrops=null,o.events=null,o.activeDrops=ft(e,n.element),o.events=pt(n,0,r),o.events.activate&&(ct(o.activeDrops,o.events.activate),e.fire("actions/drop:start",{interaction:n,dragEvent:r}))}},"interactions:action-move":ht,"interactions:action-end":ht,"interactions:after-action-move":function(t,e){var n=t.interaction,r=t.iEvent;"drag"===n.prepared.name&&(vt(n,n.dropState.events),e.fire("actions/drop:move",{interaction:n,dragEvent:r}),n.dropState.events={})},"interactions:after-action-end":function(t,e){var n=t.interaction,r=t.iEvent;"drag"===n.prepared.name&&(vt(n,n.dropState.events),e.fire("actions/drop:end",{interaction:n,dragEvent:r}))},"interactions:stop":function(t){var e=t.interaction;if("drag"===e.prepared.name){var n=e.dropState;n&&(n.activeDrops=null,n.events=null,n.cur.dropzone=null,n.cur.element=null,n.prev.dropzone=null,n.prev.element=null,n.rejected=!1)}}},getActiveDrops:ft,getDrop:dt,getDropEvents:pt,fireDropEvents:vt,defaults:{enabled:!1,accept:null,overlap:"pointer"}},yt=gt;ut.default=yt;var mt={};function bt(t){var e=t.interaction,n=t.iEvent,r=t.phase;if("gesture"===e.prepared.name){var o=e.pointers.map((function(t){return t.pointer})),i="start"===r,s="end"===r,l=e.interactable.options.deltaSource;if(n.touches=[o[0],o[1]],i)n.distance=L.touchDistance(o,l),n.box=L.touchBBox(o),n.scale=1,n.ds=0,n.angle=L.touchAngle(o,l),n.da=0,e.gesture.startDistance=n.distance,e.gesture.startAngle=n.angle;else if(s){var u=e.prevEvent;n.distance=u.distance,n.box=u.box,n.scale=u.scale,n.ds=0,n.angle=u.angle,n.da=0}else n.distance=L.touchDistance(o,l),n.box=L.touchBBox(o),n.scale=n.distance/e.gesture.startDistance,n.angle=L.touchAngle(o,l),n.ds=n.scale-e.gesture.scale,n.da=n.angle-e.gesture.angle;e.gesture.distance=n.distance,e.gesture.angle=n.angle,a.default.number(n.scale)&&n.scale!==1/0&&!isNaN(n.scale)&&(e.gesture.scale=n.scale)}}Object.defineProperty(mt,"__esModule",{value:!0}),mt.default=void 0;var xt={id:"actions/gesture",before:["actions/drag","actions/resize"],install:function(t){var e=t.actions,n=t.Interactable,r=t.defaults;n.prototype.gesturable=function(t){return a.default.object(t)?(this.options.gesture.enabled=!1!==t.enabled,this.setPerAction("gesture",t),this.setOnEvents("gesture",t),this):a.default.bool(t)?(this.options.gesture.enabled=t,this):this.options.gesture},e.map.gesture=xt,e.methodDict.gesture="gesturable",r.actions.gesture=xt.defaults},listeners:{"interactions:action-start":bt,"interactions:action-move":bt,"interactions:action-end":bt,"interactions:new":function(t){t.interaction.gesture={angle:0,distance:0,scale:1,startAngle:0,startDistance:0}},"auto-start:check":function(t){if(!(t.interaction.pointers.length<2)){var e=t.interactable.options.gesture;if(e&&e.enabled)return t.action={name:"gesture"},!1}}},defaults:{},getCursor:function(){return""}},wt=xt;mt.default=wt;var _t={};function St(t,e,n,r,o,i,s){if(!e)return!1;if(!0===e){var l=a.default.number(i.width)?i.width:i.right-i.left,u=a.default.number(i.height)?i.height:i.bottom-i.top;if(s=Math.min(s,Math.abs(("left"===t||"right"===t?l:u)/2)),l<0&&("left"===t?t="right":"right"===t&&(t="left")),u<0&&("top"===t?t="bottom":"bottom"===t&&(t="top")),"left"===t)return n.x<(l>=0?i.left:i.right)+s;if("top"===t)return n.y<(u>=0?i.top:i.bottom)+s;if("right"===t)return n.x>(l>=0?i.right:i.left)-s;if("bottom"===t)return n.y>(u>=0?i.bottom:i.top)-s}return!!a.default.element(r)&&(a.default.element(e)?e===r:S.matchesUpTo(r,e,o))}function Pt(t){var e=t.iEvent,n=t.interaction;if("resize"===n.prepared.name&&n.resizeAxes){var r=e;n.interactable.options.resize.square?("y"===n.resizeAxes?r.delta.x=r.delta.y:r.delta.y=r.delta.x,r.axes="xy"):(r.axes=n.resizeAxes,"x"===n.resizeAxes?r.delta.y=0:"y"===n.resizeAxes&&(r.delta.x=0))}}Object.defineProperty(_t,"__esModule",{value:!0}),_t.default=void 0;var Ot={id:"actions/resize",before:["actions/drag"],install:function(t){var e=t.actions,n=t.browser,r=t.Interactable,o=t.defaults;Ot.cursors=function(t){return t.isIe9?{x:"e-resize",y:"s-resize",xy:"se-resize",top:"n-resize",left:"w-resize",bottom:"s-resize",right:"e-resize",topleft:"se-resize",bottomright:"se-resize",topright:"ne-resize",bottomleft:"ne-resize"}:{x:"ew-resize",y:"ns-resize",xy:"nwse-resize",top:"ns-resize",left:"ew-resize",bottom:"ns-resize",right:"ew-resize",topleft:"nwse-resize",bottomright:"nwse-resize",topright:"nesw-resize",bottomleft:"nesw-resize"}}(n),Ot.defaultMargin=n.supportsTouch||n.supportsPointerEvent?20:10,r.prototype.resizable=function(e){return function(t,e,n){if(a.default.object(e))return t.options.resize.enabled=!1!==e.enabled,t.setPerAction("resize",e),t.setOnEvents("resize",e),a.default.string(e.axis)&&/^x$|^y$|^xy$/.test(e.axis)?t.options.resize.axis=e.axis:null===e.axis&&(t.options.resize.axis=n.defaults.actions.resize.axis),a.default.bool(e.preserveAspectRatio)?t.options.resize.preserveAspectRatio=e.preserveAspectRatio:a.default.bool(e.square)&&(t.options.resize.square=e.square),t;if(a.default.bool(e))return t.options.resize.enabled=e,t;return t.options.resize}(this,e,t)},e.map.resize=Ot,e.methodDict.resize="resizable",o.actions.resize=Ot.defaults},listeners:{"interactions:new":function(t){t.interaction.resizeAxes="xy"},"interactions:action-start":function(t){!function(t){var e=t.iEvent,n=t.interaction;if("resize"===n.prepared.name&&n.prepared.edges){var r=e,o=n.rect;n._rects={start:(0,k.default)({},o),corrected:(0,k.default)({},o),previous:(0,k.default)({},o),delta:{left:0,right:0,width:0,top:0,bottom:0,height:0}},r.edges=n.prepared.edges,r.rect=n._rects.corrected,r.deltaRect=n._rects.delta}}(t),Pt(t)},"interactions:action-move":function(t){!function(t){var e=t.iEvent,n=t.interaction;if("resize"===n.prepared.name&&n.prepared.edges){var r=e,o=n.interactable.options.resize.invert,i="reposition"===o||"negate"===o,a=n.rect,s=n._rects,l=s.start,u=s.corrected,c=s.delta,f=s.previous;if((0,k.default)(f,u),i){if((0,k.default)(u,a),"reposition"===o){if(u.top>u.bottom){var d=u.top;u.top=u.bottom,u.bottom=d}if(u.left>u.right){var p=u.left;u.left=u.right,u.right=p}}}else u.top=Math.min(a.top,l.bottom),u.bottom=Math.max(a.bottom,l.top),u.left=Math.min(a.left,l.right),u.right=Math.max(a.right,l.left);for(var v in u.width=u.right-u.left,u.height=u.bottom-u.top,u)c[v]=u[v]-f[v];r.edges=n.prepared.edges,r.rect=u,r.deltaRect=c}}(t),Pt(t)},"interactions:action-end":function(t){var e=t.iEvent,n=t.interaction;if("resize"===n.prepared.name&&n.prepared.edges){var r=e;r.edges=n.prepared.edges,r.rect=n._rects.corrected,r.deltaRect=n._rects.delta}},"auto-start:check":function(t){var e=t.interaction,n=t.interactable,r=t.element,o=t.rect,i=t.buttons;if(o){var s=(0,k.default)({},e.coords.cur.page),l=n.options.resize;if(l&&l.enabled&&(!e.pointerIsDown||!/mouse|pointer/.test(e.pointerType)||0!=(i&l.mouseButtons))){if(a.default.object(l.edges)){var u={left:!1,right:!1,top:!1,bottom:!1};for(var c in u)u[c]=St(c,l.edges[c],s,e._latestPointer.eventTarget,r,o,l.margin||Ot.defaultMargin);u.left=u.left&&!u.right,u.top=u.top&&!u.bottom,(u.left||u.right||u.top||u.bottom)&&(t.action={name:"resize",edges:u})}else{var f="y"!==l.axis&&s.x>o.right-Ot.defaultMargin,d="x"!==l.axis&&s.y>o.bottom-Ot.defaultMargin;(f||d)&&(t.action={name:"resize",axes:(f?"x":"")+(d?"y":"")})}return!t.action&&void 0}}}},defaults:{square:!1,preserveAspectRatio:!1,axis:"xy",margin:NaN,edges:null,invert:"none"},cursors:null,getCursor:function(t){var e=t.edges,n=t.axis,r=t.name,o=Ot.cursors,i=null;if(n)i=o[r+n];else if(e){for(var a="",s=["top","bottom","left","right"],l=0;l<s.length;l++){var u=s[l];e[u]&&(a+=u)}i=o[a]}return i},defaultMargin:null},Et=Ot;_t.default=Et;var Tt={};Object.defineProperty(Tt,"__esModule",{value:!0}),Tt.default=void 0;var Mt={id:"actions",install:function(t){t.usePlugin(mt.default),t.usePlugin(_t.default),t.usePlugin(f.default),t.usePlugin(ut.default)}};Tt.default=Mt;var jt={};Object.defineProperty(jt,"__esModule",{value:!0}),jt.default=void 0;jt.default={};var kt={};Object.defineProperty(kt,"__esModule",{value:!0}),kt.default=void 0;var It,Dt,At=0;var zt={request:function(t){return It(t)},cancel:function(t){return Dt(t)},init:function(t){if(It=t.requestAnimationFrame,Dt=t.cancelAnimationFrame,!It)for(var e=["ms","moz","webkit","o"],n=0;n<e.length;n++){var r=e[n];It=t["".concat(r,"RequestAnimationFrame")],Dt=t["".concat(r,"CancelAnimationFrame")]||t["".concat(r,"CancelRequestAnimationFrame")]}It||(It=function(t){var e=Date.now(),n=Math.max(0,16-(e-At)),r=setTimeout((function(){t(e+n)}),n);return At=e+n,r},Dt=function(t){return clearTimeout(t)})}};kt.default=zt;var Ct={};Object.defineProperty(Ct,"__esModule",{value:!0}),Ct.getContainer=Ft,Ct.getScroll=Xt,Ct.getScrollSize=function(t){a.default.window(t)&&(t=window.document.body);return{x:t.scrollWidth,y:t.scrollHeight}},Ct.getScrollSizeDelta=function(t,e){var n=t.interaction,r=t.element,o=n&&n.interactable.options[n.prepared.name].autoScroll;if(!o||!o.enabled)return e(),{x:0,y:0};var i=Ft(o.container,n.interactable,r),a=Xt(i);e();var s=Xt(i);return{x:s.x-a.x,y:s.y-a.y}},Ct.default=void 0;var Rt={defaults:{enabled:!1,margin:60,container:null,speed:300},now:Date.now,interaction:null,i:0,x:0,y:0,isScrolling:!1,prevTime:0,margin:0,speed:0,start:function(t){Rt.isScrolling=!0,kt.default.cancel(Rt.i),t.autoScroll=Rt,Rt.interaction=t,Rt.prevTime=Rt.now(),Rt.i=kt.default.request(Rt.scroll)},stop:function(){Rt.isScrolling=!1,Rt.interaction&&(Rt.interaction.autoScroll=null),kt.default.cancel(Rt.i)},scroll:function(){var t=Rt.interaction,e=t.interactable,n=t.element,r=t.prepared.name,o=e.options[r].autoScroll,i=Ft(o.container,e,n),s=Rt.now(),l=(s-Rt.prevTime)/1e3,u=o.speed*l;if(u>=1){var c={x:Rt.x*u,y:Rt.y*u};if(c.x||c.y){var f=Xt(i);a.default.window(i)?i.scrollBy(c.x,c.y):i&&(i.scrollLeft+=c.x,i.scrollTop+=c.y);var d=Xt(i),p={x:d.x-f.x,y:d.y-f.y};(p.x||p.y)&&e.fire({type:"autoscroll",target:n,interactable:e,delta:p,interaction:t,container:i})}Rt.prevTime=s}Rt.isScrolling&&(kt.default.cancel(Rt.i),Rt.i=kt.default.request(Rt.scroll))},check:function(t,e){var n=t.options;return n[e].autoScroll&&n[e].autoScroll.enabled},onInteractionMove:function(t){var e=t.interaction,n=t.pointer;if(e.interacting()&&Rt.check(e.interactable,e.prepared.name))if(e.simulation)Rt.x=Rt.y=0;else{var r,o,i,s,l=e.interactable,u=e.element,c=e.prepared.name,f=l.options[c].autoScroll,d=Ft(f.container,l,u);if(a.default.window(d))s=n.clientX<Rt.margin,r=n.clientY<Rt.margin,o=n.clientX>d.innerWidth-Rt.margin,i=n.clientY>d.innerHeight-Rt.margin;else{var p=S.getElementClientRect(d);s=n.clientX<p.left+Rt.margin,r=n.clientY<p.top+Rt.margin,o=n.clientX>p.right-Rt.margin,i=n.clientY>p.bottom-Rt.margin}Rt.x=o?1:s?-1:0,Rt.y=i?1:r?-1:0,Rt.isScrolling||(Rt.margin=f.margin,Rt.speed=f.speed,Rt.start(e))}}};function Ft(t,n,r){return(a.default.string(t)?(0,I.getStringOptionResult)(t,n,r):t)||(0,e.getWindow)(r)}function Xt(t){return a.default.window(t)&&(t=window.document.body),{x:t.scrollLeft,y:t.scrollTop}}var Yt={id:"auto-scroll",install:function(t){var e=t.defaults,n=t.actions;t.autoScroll=Rt,Rt.now=function(){return t.now()},n.phaselessTypes.autoscroll=!0,e.perAction.autoScroll=Rt.defaults},listeners:{"interactions:new":function(t){t.interaction.autoScroll=null},"interactions:destroy":function(t){t.interaction.autoScroll=null,Rt.stop(),Rt.interaction&&(Rt.interaction=null)},"interactions:stop":Rt.stop,"interactions:action-move":function(t){return Rt.onInteractionMove(t)}}};Ct.default=Yt;var Wt={};Object.defineProperty(Wt,"__esModule",{value:!0}),Wt.warnOnce=function(t,n){var r=!1;return function(){return r||(e.default.window.console.warn(n),r=!0),t.apply(this,arguments)}},Wt.copyAction=function(t,e){return t.name=e.name,t.axis=e.axis,t.edges=e.edges,t};var Lt={};function Bt(t){return a.default.bool(t)?(this.options.styleCursor=t,this):null===t?(delete this.options.styleCursor,this):this.options.styleCursor}function Ut(t){return a.default.func(t)?(this.options.actionChecker=t,this):null===t?(delete this.options.actionChecker,this):this.options.actionChecker}Object.defineProperty(Lt,"__esModule",{value:!0}),Lt.default=void 0;var Vt={id:"auto-start/interactableMethods",install:function(t){var e=t.Interactable;e.prototype.getAction=function(e,n,r,o){var i=function(t,e,n,r,o){var i=t.getRect(r),a=e.buttons||{0:1,1:4,3:8,4:16}[e.button],s={action:null,interactable:t,interaction:n,element:r,rect:i,buttons:a};return o.fire("auto-start:check",s),s.action}(this,n,r,o,t);return this.options.actionChecker?this.options.actionChecker(e,n,i,this,o,r):i},e.prototype.ignoreFrom=(0,Wt.warnOnce)((function(t){return this._backCompatOption("ignoreFrom",t)}),"Interactable.ignoreFrom() has been deprecated. Use Interactble.draggable({ignoreFrom: newValue})."),e.prototype.allowFrom=(0,Wt.warnOnce)((function(t){return this._backCompatOption("allowFrom",t)}),"Interactable.allowFrom() has been deprecated. Use Interactble.draggable({allowFrom: newValue})."),e.prototype.actionChecker=Ut,e.prototype.styleCursor=Bt}};Lt.default=Vt;var qt={};function Nt(t,e,n,r,o){return e.testIgnoreAllow(e.options[t.name],n,r)&&e.options[t.name].enabled&&Kt(e,n,t,o)?t:null}function $t(t,e,n,r,o,i,a){for(var s=0,l=r.length;s<l;s++){var u=r[s],c=o[s],f=u.getAction(e,n,t,c);if(f){var d=Nt(f,u,c,i,a);if(d)return{action:d,interactable:u,element:c}}}return{action:null,interactable:null,element:null}}function Gt(t,e,n,r,o){var i=[],s=[],l=r;function u(t){i.push(t),s.push(l)}for(;a.default.element(l);){i=[],s=[],o.interactables.forEachMatch(l,u);var c=$t(t,e,n,i,s,r,o);if(c.action&&!c.interactable.options[c.action.name].manualStart)return c;l=S.parentNode(l)}return{action:null,interactable:null,element:null}}function Ht(t,e,n){var r=e.action,o=e.interactable,i=e.element;r=r||{name:null},t.interactable=o,t.element=i,(0,Wt.copyAction)(t.prepared,r),t.rect=o&&r.name?o.getRect(i):null,Qt(t,n),n.fire("autoStart:prepared",{interaction:t})}function Kt(t,e,n,r){var o=t.options,i=o[n.name].max,a=o[n.name].maxPerElement,s=r.autoStart.maxInteractions,l=0,u=0,c=0;if(!(i&&a&&s))return!1;for(var f=0;f<r.interactions.list.length;f++){var d=r.interactions.list[f],p=d.prepared.name;if(d.interacting()){if(++l>=s)return!1;if(d.interactable===t){if((u+=p===n.name?1:0)>=i)return!1;if(d.element===e&&(c++,p===n.name&&c>=a))return!1}}}return s>0}function Zt(t,e){return a.default.number(t)?(e.autoStart.maxInteractions=t,this):e.autoStart.maxInteractions}function Jt(t,e,n){var r=n.autoStart.cursorElement;r&&r!==t&&(r.style.cursor=""),t.ownerDocument.documentElement.style.cursor=e,t.style.cursor=e,n.autoStart.cursorElement=e?t:null}function Qt(t,e){var n=t.interactable,r=t.element,o=t.prepared;if("mouse"===t.pointerType&&n&&n.options.styleCursor){var i="";if(o.name){var s=n.options[o.name].cursorChecker;i=a.default.func(s)?s(o,n,r,t._interacting):e.actions.map[o.name].getCursor(o)}Jt(t.element,i||"",e)}else e.autoStart.cursorElement&&Jt(e.autoStart.cursorElement,"",e)}Object.defineProperty(qt,"__esModule",{value:!0}),qt.default=void 0;var te={id:"auto-start/base",before:["actions"],install:function(t){var e=t.interactStatic,n=t.defaults;t.usePlugin(Lt.default),n.base.actionChecker=null,n.base.styleCursor=!0,(0,k.default)(n.perAction,{manualStart:!1,max:1/0,maxPerElement:1,allowFrom:null,ignoreFrom:null,mouseButtons:1}),e.maxInteractions=function(e){return Zt(e,t)},t.autoStart={maxInteractions:1/0,withinInteractionLimit:Kt,cursorElement:null}},listeners:{"interactions:down":function(t,e){var n=t.interaction,r=t.pointer,o=t.event,i=t.eventTarget;n.interacting()||Ht(n,Gt(n,r,o,i,e),e)},"interactions:move":function(t,e){!function(t,e){var n=t.interaction,r=t.pointer,o=t.event,i=t.eventTarget;"mouse"!==n.pointerType||n.pointerIsDown||n.interacting()||Ht(n,Gt(n,r,o,i,e),e)}(t,e),function(t,e){var n=t.interaction;if(n.pointerIsDown&&!n.interacting()&&n.pointerWasMoved&&n.prepared.name){e.fire("autoStart:before-start",t);var r=n.interactable,o=n.prepared.name;o&&r&&(r.options[o].manualStart||!Kt(r,n.element,n.prepared,e)?n.stop():(n.start(n.prepared,r,n.element),Qt(n,e)))}}(t,e)},"interactions:stop":function(t,e){var n=t.interaction,r=n.interactable;r&&r.options.styleCursor&&Jt(n.element,"",e)}},maxInteractions:Zt,withinInteractionLimit:Kt,validateAction:Nt};qt.default=te;var ee={};Object.defineProperty(ee,"__esModule",{value:!0}),ee.default=void 0;var ne={id:"auto-start/dragAxis",listeners:{"autoStart:before-start":function(t,e){var n=t.interaction,r=t.eventTarget,o=t.dx,i=t.dy;if("drag"===n.prepared.name){var s=Math.abs(o),l=Math.abs(i),u=n.interactable.options.drag,c=u.startAxis,f=s>l?"x":s<l?"y":"xy";if(n.prepared.axis="start"===u.lockAxis?f[0]:u.lockAxis,"xy"!==f&&"xy"!==c&&c!==f){n.prepared.name=null;for(var d=r,p=function(t){if(t!==n.interactable){var o=n.interactable.options.drag;if(!o.manualStart&&t.testIgnoreAllow(o,d,r)){var i=t.getAction(n.downPointer,n.downEvent,n,d);if(i&&"drag"===i.name&&function(t,e){if(!e)return!1;var n=e.options.drag.startAxis;return"xy"===t||"xy"===n||n===t}(f,t)&&qt.default.validateAction(i,t,d,r,e))return t}}};a.default.element(d);){var v=e.interactables.forEachMatch(d,p);if(v){n.prepared.name="drag",n.interactable=v,n.element=d;break}d=(0,S.parentNode)(d)}}}}}};ee.default=ne;var re={};function oe(t){var e=t.prepared&&t.prepared.name;if(!e)return null;var n=t.interactable.options;return n[e].hold||n[e].delay}Object.defineProperty(re,"__esModule",{value:!0}),re.default=void 0;var ie={id:"auto-start/hold",install:function(t){var e=t.defaults;t.usePlugin(qt.default),e.perAction.hold=0,e.perAction.delay=0},listeners:{"interactions:new":function(t){t.interaction.autoStartHoldTimer=null},"autoStart:prepared":function(t){var e=t.interaction,n=oe(e);n>0&&(e.autoStartHoldTimer=setTimeout((function(){e.start(e.prepared,e.interactable,e.element)}),n))},"interactions:move":function(t){var e=t.interaction,n=t.duplicate;e.pointerWasMoved&&!n&&clearTimeout(e.autoStartHoldTimer)},"autoStart:before-start":function(t){var e=t.interaction;oe(e)>0&&(e.prepared.name=null)}},getHoldDuration:oe};re.default=ie;var ae={};Object.defineProperty(ae,"__esModule",{value:!0}),ae.default=void 0;var se={id:"auto-start",install:function(t){t.usePlugin(qt.default),t.usePlugin(re.default),t.usePlugin(ee.default)}};ae.default=se;var le={};Object.defineProperty(le,"__esModule",{value:!0}),le.default=void 0;le.default={};var ue={};function ce(t){return/^(always|never|auto)$/.test(t)?(this.options.preventDefault=t,this):a.default.bool(t)?(this.options.preventDefault=t?"always":"never",this):this.options.preventDefault}function fe(t){var e=t.interaction,n=t.event;e.interactable&&e.interactable.checkAndPreventDefault(n)}function de(t){var n=t.Interactable;n.prototype.preventDefault=ce,n.prototype.checkAndPreventDefault=function(n){return function(t,n,r){var o=t.options.preventDefault;if("never"!==o)if("always"!==o){if(n.events.supportsPassive&&/^touch(start|move)$/.test(r.type)){var i=(0,e.getWindow)(r.target).document,s=n.getDocOptions(i);if(!s||!s.events||!1!==s.events.passive)return}/^(mouse|pointer|touch)*(down|start)/i.test(r.type)||a.default.element(r.target)&&(0,S.matchesSelector)(r.target,"input,select,textarea,[contenteditable=true],[contenteditable=true] *")||r.preventDefault()}else r.preventDefault()}(this,t,n)},t.interactions.docEvents.push({type:"dragstart",listener:function(e){for(var n=0;n<t.interactions.list.length;n++){var r=t.interactions.list[n];if(r.element&&(r.element===e.target||(0,S.nodeContains)(r.element,e.target)))return void r.interactable.checkAndPreventDefault(e)}}})}Object.defineProperty(ue,"__esModule",{value:!0}),ue.install=de,ue.default=void 0;var pe={id:"core/interactablePreventDefault",install:de,listeners:["down","move","up","cancel"].reduce((function(t,e){return t["interactions:".concat(e)]=fe,t}),{})};ue.default=pe;var ve,he={};function ge(t){return function(t){if(Array.isArray(t))return ye(t)}(t)||function(t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}(t)||function(t,e){if(!t)return;if("string"==typeof t)return ye(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return ye(t,e)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function ye(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=Array(e);n<e;n++)r[n]=t[n];return r}Object.defineProperty(he,"__esModule",{value:!0}),he.default=void 0,function(t){t.touchAction="touchAction",t.boxSizing="boxSizing",t.noListeners="noListeners"}(ve||(ve={}));var me={touchAction:"https://developer.mozilla.org/en-US/docs/Web/CSS/touch-action",boxSizing:"https://developer.mozilla.org/en-US/docs/Web/CSS/box-sizing"};var be=[{name:ve.touchAction,perform:function(t){return!function(t,e,n){var r=t;for(;a.default.element(r);){if(xe(r,e,n))return!0;r=(0,S.parentNode)(r)}return!1}(t.element,"touchAction",/pan-|pinch|none/)},getInfo:function(t){return[t.element,me.touchAction]},text:'Consider adding CSS "touch-action: none" to this element\n'},{name:ve.boxSizing,perform:function(t){var e=t.element;return"resize"===t.prepared.name&&e instanceof g.default.HTMLElement&&!xe(e,"boxSizing",/border-box/)},text:'Consider adding CSS "box-sizing: border-box" to this resizable element',getInfo:function(t){return[t.element,me.boxSizing]}},{name:ve.noListeners,perform:function(t){var e=t.prepared.name;return!(t.interactable.events.types["".concat(e,"move")]||[]).length},getInfo:function(t){return[t.prepared.name,t.interactable]},text:"There are no listeners set for this action"}];function xe(t,n,r){var o=t.style[n]||e.default.window.getComputedStyle(t)[n];return r.test((o||"").toString())}var we="dev-tools",_e={id:we,install:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.logger,r=t.Interactable,o=t.defaults;t.logger=n||console,o.base.devTools={ignore:{}},r.prototype.devTools=function(t){return t?((0,k.default)(this.options.devTools,t),this):this.options.devTools}},listeners:{"interactions:action-start":function(t,e){for(var n=t.interaction,r=0;r<be.length;r++){var o,i=be[r],a=n.interactable&&n.interactable.options;if(!(a&&a.devTools&&a.devTools.ignore[i.name])&&i.perform(n))(o=e.logger).warn.apply(o,["[interact.js] "+i.text].concat(ge(i.getInfo(n))))}}},checks:be,CheckName:ve,links:me,prefix:"[interact.js] "};he.default=_e;var Se={};Object.defineProperty(Se,"__esModule",{value:!0}),Se.default=void 0;Se.default={};var Pe={};Object.defineProperty(Pe,"__esModule",{value:!0}),Pe.default=function t(e){var n={};for(var r in e){var o=e[r];a.default.plainObject(o)?n[r]=t(o):a.default.array(o)?n[r]=J.from(o):n[r]=o}return n};var Oe={};function Ee(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(t)))return;var n=[],r=!0,o=!1,i=void 0;try{for(var a,s=t[Symbol.iterator]();!(r=(a=s.next()).done)&&(n.push(a.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{r||null==s.return||s.return()}finally{if(o)throw i}}return n}(t,e)||function(t,e){if(!t)return;if("string"==typeof t)return Te(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return Te(t,e)}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Te(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=Array(e);n<e;n++)r[n]=t[n];return r}function Me(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}Object.defineProperty(Oe,"__esModule",{value:!0}),Oe.getRectOffset=Ie,Oe.default=void 0;var je=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.states=[],this.startOffset={left:0,right:0,top:0,bottom:0},this.startDelta=null,this.result=null,this.endResult=null,this.edges=void 0,this.interaction=void 0,this.interaction=e,this.result=ke()}var e,n,r;return e=t,(n=[{key:"start",value:function(t,e){var n=t.phase,r=this.interaction,o=function(t){var e=t.interactable.options[t.prepared.name],n=e.modifiers;return n&&n.length?n:["snap","snapSize","snapEdges","restrict","restrictEdges","restrictSize"].map((function(t){var n=e[t];return n&&n.enabled&&{options:n,methods:n._methods}})).filter((function(t){return!!t}))}(r);this.prepareStates(o),this.edges=(0,k.default)({},r.edges),this.startOffset=Ie(r.rect,e),this.startDelta={x:0,y:0};var i={phase:n,pageCoords:e,preEnd:!1};return this.result=ke(),this.startAll(i),this.result=this.setAll(i)}},{key:"fillArg",value:function(t){var e=this.interaction;t.interaction=e,t.interactable=e.interactable,t.element=e.element,t.rect=t.rect||e.rect,t.edges=this.edges,t.startOffset=this.startOffset}},{key:"startAll",value:function(t){this.fillArg(t);for(var e=0;e<this.states.length;e++){var n=this.states[e];n.methods.start&&(t.state=n,n.methods.start(t))}}},{key:"setAll",value:function(t){this.fillArg(t);var e=t.phase,n=t.preEnd,r=t.skipModifiers,o=t.rect;t.coords=(0,k.default)({},t.pageCoords),t.rect=(0,k.default)({},o);for(var i=r?this.states.slice(r):this.states,a=ke(t.coords,t.rect),s=0;s<i.length;s++){var l=i[s],u=l.options,c=(0,k.default)({},t.coords),f=null;l.methods.set&&this.shouldDo(u,n,e)&&(t.state=l,f=l.methods.set(t),I.addEdges(this.interaction.edges,t.rect,{x:t.coords.x-c.x,y:t.coords.y-c.y})),a.eventProps.push(f)}a.delta.x=t.coords.x-t.pageCoords.x,a.delta.y=t.coords.y-t.pageCoords.y,a.rectDelta.left=t.rect.left-o.left,a.rectDelta.right=t.rect.right-o.right,a.rectDelta.top=t.rect.top-o.top,a.rectDelta.bottom=t.rect.bottom-o.bottom;var d=this.result.coords,p=this.result.rect;if(d&&p){var v=a.rect.left!==p.left||a.rect.right!==p.right||a.rect.top!==p.top||a.rect.bottom!==p.bottom;a.changed=v||d.x!==a.coords.x||d.y!==a.coords.y}return a}},{key:"applyToInteraction",value:function(t){var e=this.interaction,n=t.phase,r=e.coords.cur,o=e.coords.start,i=this.result,a=this.startDelta,s=i.delta;"start"===n&&(0,k.default)(this.startDelta,i.delta);for(var l=[[o,a],[r,s]],u=0;u<l.length;u++){var c=Ee(l[u],2),f=c[0],d=c[1];f.page.x+=d.x,f.page.y+=d.y,f.client.x+=d.x,f.client.y+=d.y}var p=this.result.rectDelta,v=t.rect||e.rect;v.left+=p.left,v.right+=p.right,v.top+=p.top,v.bottom+=p.bottom,v.width=v.right-v.left,v.height=v.bottom-v.top}},{key:"setAndApply",value:function(t){var e=this.interaction,n=t.phase,r=t.preEnd,o=t.skipModifiers,i=this.setAll({preEnd:r,phase:n,pageCoords:t.modifiedCoords||e.coords.cur.page});if(this.result=i,!i.changed&&(!o||o<this.states.length)&&e.interacting())return!1;if(t.modifiedCoords){var a=e.coords.cur.page,s={x:t.modifiedCoords.x-a.x,y:t.modifiedCoords.y-a.y};i.coords.x+=s.x,i.coords.y+=s.y,i.delta.x+=s.x,i.delta.y+=s.y}this.applyToInteraction(t)}},{key:"beforeEnd",value:function(t){var e=t.interaction,n=t.event,r=this.states;if(r&&r.length){for(var o=!1,i=0;i<r.length;i++){var a=r[i];t.state=a;var s=a.options,l=a.methods,u=l.beforeEnd&&l.beforeEnd(t);if(u)return this.endResult=u,!1;o=o||!o&&this.shouldDo(s,!0,t.phase,!0)}o&&e.move({event:n,preEnd:!0})}}},{key:"stop",value:function(t){var e=t.interaction;if(this.states&&this.states.length){var n=(0,k.default)({states:this.states,interactable:e.interactable,element:e.element,rect:null},t);this.fillArg(n);for(var r=0;r<this.states.length;r++){var o=this.states[r];n.state=o,o.methods.stop&&o.methods.stop(n)}this.states=null,this.endResult=null}}},{key:"prepareStates",value:function(t){this.states=[];for(var e=0;e<t.length;e++){var n=t[e],r=n.options,o=n.methods,i=n.name;this.states.push({options:r,methods:o,index:e,name:i})}return this.states}},{key:"restoreInteractionCoords",value:function(t){var e=t.interaction,n=e.coords,r=e.rect,o=e.modification;if(o.result){for(var i=o.startDelta,a=o.result,s=a.delta,l=a.rectDelta,u=[[n.start,i],[n.cur,s]],c=0;c<u.length;c++){var f=Ee(u[c],2),d=f[0],p=f[1];d.page.x-=p.x,d.page.y-=p.y,d.client.x-=p.x,d.client.y-=p.y}r.left-=l.left,r.right-=l.right,r.top-=l.top,r.bottom-=l.bottom}}},{key:"shouldDo",value:function(t,e,n,r){return!(!t||!1===t.enabled||r&&!t.endOnly||t.endOnly&&!e||"start"===n&&!t.setStart)}},{key:"copyFrom",value:function(t){this.startOffset=t.startOffset,this.startDelta=t.startDelta,this.edges=t.edges,this.states=t.states.map((function(t){return(0,Pe.default)(t)})),this.result=ke((0,k.default)({},t.result.coords),(0,k.default)({},t.result.rect))}},{key:"destroy",value:function(){for(var t in this)this[t]=null}}])&&Me(e.prototype,n),r&&Me(e,r),t}();function ke(t,e){return{rect:e,coords:t,delta:{x:0,y:0},rectDelta:{left:0,right:0,top:0,bottom:0},eventProps:[],changed:!0}}function Ie(t,e){return t?{left:e.x-t.left,top:e.y-t.top,right:t.right-e.x,bottom:t.bottom-e.y}:{left:0,top:0,right:0,bottom:0}}Oe.default=je;var De={};function Ae(t){var e=t.iEvent,n=t.interaction.modification.result;n&&(e.modifiers=n.eventProps)}Object.defineProperty(De,"__esModule",{value:!0}),De.makeModifier=function(t,e){var n=t.defaults,r={start:t.start,set:t.set,beforeEnd:t.beforeEnd,stop:t.stop},o=function(t){var o=t||{};for(var i in o.enabled=!1!==o.enabled,n)i in o||(o[i]=n[i]);var a={options:o,methods:r,name:e,enable:function(){return o.enabled=!0,a},disable:function(){return o.enabled=!1,a}};return a};e&&"string"==typeof e&&(o._defaults=n,o._methods=r);return o},De.addEventModifiers=Ae,De.default=void 0;var ze={id:"modifiers/base",install:function(t){t.defaults.perAction.modifiers=[]},listeners:{"interactions:new":function(t){var e=t.interaction;e.modification=new Oe.default(e)},"interactions:before-action-start":function(t){var e=t.interaction.modification;e.start(t,t.interaction.coords.start.page),t.interaction.edges=e.edges,e.applyToInteraction(t)},"interactions:before-action-move":function(t){return t.interaction.modification.setAndApply(t)},"interactions:before-action-end":function(t){return t.interaction.modification.beforeEnd(t)},"interactions:action-start":Ae,"interactions:action-move":Ae,"interactions:action-end":Ae,"interactions:after-action-start":function(t){return t.interaction.modification.restoreInteractionCoords(t)},"interactions:after-action-move":function(t){return t.interaction.modification.restoreInteractionCoords(t)},"interactions:stop":function(t){return t.interaction.modification.stop(t)}},before:["actions"]};De.default=ze;var Ce={};Object.defineProperty(Ce,"__esModule",{value:!0}),Ce.defaults=void 0;Ce.defaults={base:{preventDefault:"auto",deltaSource:"page"},perAction:{enabled:!1,origin:{x:0,y:0}},actions:{}};var Re={};function Fe(t){return(Fe="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Xe(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function Ye(t,e){return(Ye=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function We(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Ue(t);if(e){var o=Ue(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return Le(this,n)}}function Le(t,e){return!e||"object"!==Fe(e)&&"function"!=typeof e?Be(t):e}function Be(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function Ue(t){return(Ue=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}Object.defineProperty(Re,"__esModule",{value:!0}),Re.InteractEvent=void 0;var Ve=function(t){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Ye(t,e)}(i,t);var e,n,r,o=We(i);function i(t,e,n,r,a,s,l){var u;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(u=o.call(this,t)).target=void 0,u.currentTarget=void 0,u.relatedTarget=null,u.screenX=void 0,u.screenY=void 0,u.button=void 0,u.buttons=void 0,u.ctrlKey=void 0,u.shiftKey=void 0,u.altKey=void 0,u.metaKey=void 0,u.page=void 0,u.client=void 0,u.delta=void 0,u.rect=void 0,u.x0=void 0,u.y0=void 0,u.t0=void 0,u.dt=void 0,u.duration=void 0,u.clientX0=void 0,u.clientY0=void 0,u.velocity=void 0,u.speed=void 0,u.swipe=void 0,u.timeStamp=void 0,u.dragEnter=void 0,u.dragLeave=void 0,u.axes=void 0,u.preEnd=void 0,a=a||t.element;var c=t.interactable,f=(c&&c.options||Ce.defaults).deltaSource,d=(0,z.default)(c,a,n),p="start"===r,v="end"===r,h=p?Be(u):t.prevEvent,g=p?t.coords.start:v?{page:h.page,client:h.client,timeStamp:t.coords.cur.timeStamp}:t.coords.cur;return u.page=(0,k.default)({},g.page),u.client=(0,k.default)({},g.client),u.rect=(0,k.default)({},t.rect),u.timeStamp=g.timeStamp,v||(u.page.x-=d.x,u.page.y-=d.y,u.client.x-=d.x,u.client.y-=d.y),u.ctrlKey=e.ctrlKey,u.altKey=e.altKey,u.shiftKey=e.shiftKey,u.metaKey=e.metaKey,u.button=e.button,u.buttons=e.buttons,u.target=a,u.currentTarget=a,u.preEnd=s,u.type=l||n+(r||""),u.interactable=c,u.t0=p?t.pointers[t.pointers.length-1].downTime:h.t0,u.x0=t.coords.start.page.x-d.x,u.y0=t.coords.start.page.y-d.y,u.clientX0=t.coords.start.client.x-d.x,u.clientY0=t.coords.start.client.y-d.y,u.delta=p||v?{x:0,y:0}:{x:u[f].x-h[f].x,y:u[f].y-h[f].y},u.dt=t.coords.delta.timeStamp,u.duration=u.timeStamp-u.t0,u.velocity=(0,k.default)({},t.coords.velocity[f]),u.speed=(0,F.default)(u.velocity.x,u.velocity.y),u.swipe=v||"inertiastart"===r?u.getSwipe():null,u}return e=i,(n=[{key:"getSwipe",value:function(){var t=this._interaction;if(t.prevEvent.speed<600||this.timeStamp-t.prevEvent.timeStamp>150)return null;var e=180*Math.atan2(t.prevEvent.velocityY,t.prevEvent.velocityX)/Math.PI;e<0&&(e+=360);var n=112.5<=e&&e<247.5,r=202.5<=e&&e<337.5;return{up:r,down:!r&&22.5<=e&&e<157.5,left:n,right:!n&&(292.5<=e||e<67.5),angle:e,speed:t.prevEvent.speed,velocity:{x:t.prevEvent.velocityX,y:t.prevEvent.velocityY}}}},{key:"preventDefault",value:function(){}},{key:"stopImmediatePropagation",value:function(){this.immediatePropagationStopped=this.propagationStopped=!0}},{key:"stopPropagation",value:function(){this.propagationStopped=!0}}])&&Xe(e.prototype,n),r&&Xe(e,r),i}(G.BaseEvent);Re.InteractEvent=Ve,Object.defineProperties(Ve.prototype,{pageX:{get:function(){return this.page.x},set:function(t){this.page.x=t}},pageY:{get:function(){return this.page.y},set:function(t){this.page.y=t}},clientX:{get:function(){return this.client.x},set:function(t){this.client.x=t}},clientY:{get:function(){return this.client.y},set:function(t){this.client.y=t}},dx:{get:function(){return this.delta.x},set:function(t){this.delta.x=t}},dy:{get:function(){return this.delta.y},set:function(t){this.delta.y=t}},velocityX:{get:function(){return this.velocity.x},set:function(t){this.velocity.x=t}},velocityY:{get:function(){return this.velocity.y},set:function(t){this.velocity.y=t}}});var qe={};Object.defineProperty(qe,"__esModule",{value:!0}),qe.PointerInfo=void 0;qe.PointerInfo=function t(e,n,r,o,i){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.id=void 0,this.pointer=void 0,this.event=void 0,this.downTime=void 0,this.downTarget=void 0,this.id=e,this.pointer=n,this.event=r,this.downTime=o,this.downTarget=i};var Ne,$e,Ge={};function He(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function Ke(t,e,n){return e&&He(t.prototype,e),n&&He(t,n),t}Object.defineProperty(Ge,"__esModule",{value:!0}),Object.defineProperty(Ge,"PointerInfo",{enumerable:!0,get:function(){return qe.PointerInfo}}),Ge.default=Ge.Interaction=Ge._ProxyMethods=Ge._ProxyValues=void 0,Ge._ProxyValues=Ne,function(t){t.interactable="",t.element="",t.prepared="",t.pointerIsDown="",t.pointerWasMoved="",t._proxy=""}(Ne||(Ge._ProxyValues=Ne={})),Ge._ProxyMethods=$e,function(t){t.start="",t.move="",t.end="",t.stop="",t.interacting=""}($e||(Ge._ProxyMethods=$e={}));var Ze=0,Je=function(){function t(e){var n=this,r=e.pointerType,o=e.scopeFire;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.interactable=null,this.element=null,this.rect=void 0,this._rects=void 0,this.edges=void 0,this._scopeFire=void 0,this.prepared={name:null,axis:null,edges:null},this.pointerType=void 0,this.pointers=[],this.downEvent=null,this.downPointer={},this._latestPointer={pointer:null,event:null,eventTarget:null},this.prevEvent=null,this.pointerIsDown=!1,this.pointerWasMoved=!1,this._interacting=!1,this._ending=!1,this._stopped=!0,this._proxy=null,this.simulation=null,this.doMove=(0,Wt.warnOnce)((function(t){this.move(t)}),"The interaction.doMove() method has been renamed to interaction.move()"),this.coords={start:L.newCoords(),prev:L.newCoords(),cur:L.newCoords(),delta:L.newCoords(),velocity:L.newCoords()},this._id=Ze++,this._scopeFire=o,this.pointerType=r;var i=this;this._proxy={};var a=function(t){Object.defineProperty(n._proxy,t,{get:function(){return i[t]}})};for(var s in Ne)a(s);var l=function(t){Object.defineProperty(n._proxy,t,{value:function(){return i[t].apply(i,arguments)}})};for(var u in $e)l(u);this._scopeFire("interactions:new",{interaction:this})}return Ke(t,[{key:"pointerMoveTolerance",get:function(){return 1}}]),Ke(t,[{key:"pointerDown",value:function(t,e,n){var r=this.updatePointer(t,e,n,!0),o=this.pointers[r];this._scopeFire("interactions:down",{pointer:t,event:e,eventTarget:n,pointerIndex:r,pointerInfo:o,type:"down",interaction:this})}},{key:"start",value:function(t,e,n){return!(this.interacting()||!this.pointerIsDown||this.pointers.length<("gesture"===t.name?2:1)||!e.options[t.name].enabled)&&((0,Wt.copyAction)(this.prepared,t),this.interactable=e,this.element=n,this.rect=e.getRect(n),this.edges=this.prepared.edges?(0,k.default)({},this.prepared.edges):{left:!0,right:!0,top:!0,bottom:!0},this._stopped=!1,this._interacting=this._doPhase({interaction:this,event:this.downEvent,phase:"start"})&&!this._stopped,this._interacting)}},{key:"pointerMove",value:function(t,e,n){this.simulation||this.modification&&this.modification.endResult||this.updatePointer(t,e,n,!1);var r,o,i=this.coords.cur.page.x===this.coords.prev.page.x&&this.coords.cur.page.y===this.coords.prev.page.y&&this.coords.cur.client.x===this.coords.prev.client.x&&this.coords.cur.client.y===this.coords.prev.client.y;this.pointerIsDown&&!this.pointerWasMoved&&(r=this.coords.cur.client.x-this.coords.start.client.x,o=this.coords.cur.client.y-this.coords.start.client.y,this.pointerWasMoved=(0,F.default)(r,o)>this.pointerMoveTolerance);var a=this.getPointerIndex(t),s={pointer:t,pointerIndex:a,pointerInfo:this.pointers[a],event:e,type:"move",eventTarget:n,dx:r,dy:o,duplicate:i,interaction:this};i||L.setCoordVelocity(this.coords.velocity,this.coords.delta),this._scopeFire("interactions:move",s),i||this.simulation||(this.interacting()&&(s.type=null,this.move(s)),this.pointerWasMoved&&L.copyCoords(this.coords.prev,this.coords.cur))}},{key:"move",value:function(t){t&&t.event||L.setZeroCoords(this.coords.delta),(t=(0,k.default)({pointer:this._latestPointer.pointer,event:this._latestPointer.event,eventTarget:this._latestPointer.eventTarget,interaction:this},t||{})).phase="move",this._doPhase(t)}},{key:"pointerUp",value:function(t,e,n,r){var o=this.getPointerIndex(t);-1===o&&(o=this.updatePointer(t,e,n,!1));var i=/cancel$/i.test(e.type)?"cancel":"up";this._scopeFire("interactions:".concat(i),{pointer:t,pointerIndex:o,pointerInfo:this.pointers[o],event:e,eventTarget:n,type:i,curEventTarget:r,interaction:this}),this.simulation||this.end(e),this.pointerIsDown=!1,this.removePointer(t,e)}},{key:"documentBlur",value:function(t){this.end(t),this._scopeFire("interactions:blur",{event:t,type:"blur",interaction:this})}},{key:"end",value:function(t){var e;this._ending=!0,t=t||this._latestPointer.event,this.interacting()&&(e=this._doPhase({event:t,interaction:this,phase:"end"})),this._ending=!1,!0===e&&this.stop()}},{key:"currentAction",value:function(){return this._interacting?this.prepared.name:null}},{key:"interacting",value:function(){return this._interacting}},{key:"stop",value:function(){this._scopeFire("interactions:stop",{interaction:this}),this.interactable=this.element=null,this._interacting=!1,this._stopped=!0,this.prepared.name=this.prevEvent=null}},{key:"getPointerIndex",value:function(t){var e=L.getPointerId(t);return"mouse"===this.pointerType||"pen"===this.pointerType?this.pointers.length-1:J.findIndex(this.pointers,(function(t){return t.id===e}))}},{key:"getPointerInfo",value:function(t){return this.pointers[this.getPointerIndex(t)]}},{key:"updatePointer",value:function(t,e,n,r){var o=L.getPointerId(t),i=this.getPointerIndex(t),a=this.pointers[i];return r=!1!==r&&(r||/(down|start)$/i.test(e.type)),a?a.pointer=t:(a=new qe.PointerInfo(o,t,e,null,null),i=this.pointers.length,this.pointers.push(a)),L.setCoords(this.coords.cur,this.pointers.map((function(t){return t.pointer})),this._now()),L.setCoordDeltas(this.coords.delta,this.coords.prev,this.coords.cur),r&&(this.pointerIsDown=!0,a.downTime=this.coords.cur.timeStamp,a.downTarget=n,L.pointerExtend(this.downPointer,t),this.interacting()||(L.copyCoords(this.coords.start,this.coords.cur),L.copyCoords(this.coords.prev,this.coords.cur),this.downEvent=e,this.pointerWasMoved=!1)),this._updateLatestPointer(t,e,n),this._scopeFire("interactions:update-pointer",{pointer:t,event:e,eventTarget:n,down:r,pointerInfo:a,pointerIndex:i,interaction:this}),i}},{key:"removePointer",value:function(t,e){var n=this.getPointerIndex(t);if(-1!==n){var r=this.pointers[n];this._scopeFire("interactions:remove-pointer",{pointer:t,event:e,eventTarget:null,pointerIndex:n,pointerInfo:r,interaction:this}),this.pointers.splice(n,1)}}},{key:"_updateLatestPointer",value:function(t,e,n){this._latestPointer.pointer=t,this._latestPointer.event=e,this._latestPointer.eventTarget=n}},{key:"destroy",value:function(){this._latestPointer.pointer=null,this._latestPointer.event=null,this._latestPointer.eventTarget=null}},{key:"_createPreparedEvent",value:function(t,e,n,r){return new Re.InteractEvent(this,t,this.prepared.name,e,this.element,n,r)}},{key:"_fireEvent",value:function(t){this.interactable.fire(t),(!this.prevEvent||t.timeStamp>=this.prevEvent.timeStamp)&&(this.prevEvent=t)}},{key:"_doPhase",value:function(t){var e=t.event,n=t.phase,r=t.preEnd,o=t.type,i=this.rect;if(i&&"move"===n&&(I.addEdges(this.edges,i,this.coords.delta[this.interactable.options.deltaSource]),i.width=i.right-i.left,i.height=i.bottom-i.top),!1===this._scopeFire("interactions:before-action-".concat(n),t))return!1;var a=t.iEvent=this._createPreparedEvent(e,n,r,o);return this._scopeFire("interactions:action-".concat(n),t),"start"===n&&(this.prevEvent=a),this._fireEvent(a),this._scopeFire("interactions:after-action-".concat(n),t),!0}},{key:"_now",value:function(){return Date.now()}}]),t}();Ge.Interaction=Je;var Qe=Je;Ge.default=Qe;var tn={};function en(t){t.pointerIsDown&&(an(t.coords.cur,t.offset.total),t.offset.pending.x=0,t.offset.pending.y=0)}function nn(t){rn(t.interaction)}function rn(t){if(!function(t){return!(!t.offset.pending.x&&!t.offset.pending.y)}(t))return!1;var e=t.offset.pending;return an(t.coords.cur,e),an(t.coords.delta,e),I.addEdges(t.edges,t.rect,e),e.x=0,e.y=0,!0}function on(t){var e=t.x,n=t.y;this.offset.pending.x+=e,this.offset.pending.y+=n,this.offset.total.x+=e,this.offset.total.y+=n}function an(t,e){var n=t.page,r=t.client,o=e.x,i=e.y;n.x+=o,n.y+=i,r.x+=o,r.y+=i}Object.defineProperty(tn,"__esModule",{value:!0}),tn.addTotal=en,tn.applyPending=rn,tn.default=void 0,Ge._ProxyMethods.offsetBy="";var sn={id:"offset",before:["modifiers"],install:function(t){t.Interaction.prototype.offsetBy=on},listeners:{"interactions:new":function(t){t.interaction.offset={total:{x:0,y:0},pending:{x:0,y:0}}},"interactions:update-pointer":function(t){return en(t.interaction)},"interactions:before-action-start":nn,"interactions:before-action-move":nn,"interactions:before-action-end":function(t){var e=t.interaction;if(rn(e))return e.move({offset:!0}),e.end(),!1},"interactions:stop":function(t){var e=t.interaction;e.offset.total.x=0,e.offset.total.y=0,e.offset.pending.x=0,e.offset.pending.y=0}}};tn.default=sn;var ln={};function un(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}Object.defineProperty(ln,"__esModule",{value:!0}),ln.default=ln.InertiaState=void 0;var cn=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.active=!1,this.isModified=!1,this.smoothEnd=!1,this.allowResume=!1,this.modification=null,this.modifierCount=0,this.modifierArg=null,this.startCoords=null,this.t0=0,this.v0=0,this.te=0,this.targetOffset=null,this.modifiedOffset=null,this.currentOffset=null,this.lambda_v0=0,this.one_ve_v0=0,this.timeout=null,this.interaction=void 0,this.interaction=e}var e,n,r;return e=t,(n=[{key:"start",value:function(t){var e=this.interaction,n=fn(e);if(!n||!n.enabled)return!1;var r=e.coords.velocity.client,o=(0,F.default)(r.x,r.y),i=this.modification||(this.modification=new Oe.default(e));if(i.copyFrom(e.modification),this.t0=e._now(),this.allowResume=n.allowResume,this.v0=o,this.currentOffset={x:0,y:0},this.startCoords=e.coords.cur.page,this.modifierArg={interaction:e,interactable:e.interactable,element:e.element,rect:e.rect,edges:e.edges,pageCoords:this.startCoords,preEnd:!0,phase:"inertiastart"},this.t0-e.coords.cur.timeStamp<50&&o>n.minSpeed&&o>n.endSpeed)this.startInertia();else{if(i.result=i.setAll(this.modifierArg),!i.result.changed)return!1;this.startSmoothEnd()}return e.modification.result.rect=null,e.offsetBy(this.targetOffset),e._doPhase({interaction:e,event:t,phase:"inertiastart"}),e.offsetBy({x:-this.targetOffset.x,y:-this.targetOffset.y}),e.modification.result.rect=null,this.active=!0,e.simulation=this,!0}},{key:"startInertia",value:function(){var t=this,e=this.interaction.coords.velocity.client,n=fn(this.interaction),r=n.resistance,o=-Math.log(n.endSpeed/this.v0)/r;this.targetOffset={x:(e.x-o)/r,y:(e.y-o)/r},this.te=o,this.lambda_v0=r/this.v0,this.one_ve_v0=1-n.endSpeed/this.v0;var i=this.modification,a=this.modifierArg;a.pageCoords={x:this.startCoords.x+this.targetOffset.x,y:this.startCoords.y+this.targetOffset.y},i.result=i.setAll(a),i.result.changed&&(this.isModified=!0,this.modifiedOffset={x:this.targetOffset.x+i.result.delta.x,y:this.targetOffset.y+i.result.delta.y}),this.timeout=kt.default.request((function(){return t.inertiaTick()}))}},{key:"startSmoothEnd",value:function(){var t=this;this.smoothEnd=!0,this.isModified=!0,this.targetOffset={x:this.modification.result.delta.x,y:this.modification.result.delta.y},this.timeout=kt.default.request((function(){return t.smoothEndTick()}))}},{key:"inertiaTick",value:function(){var t,e,n,r,o,i,a,s=this,l=this.interaction,u=fn(l).resistance,c=(l._now()-this.t0)/1e3;if(c<this.te){var f,d=1-(Math.exp(-u*c)-this.lambda_v0)/this.one_ve_v0;this.isModified?(t=0,e=0,n=this.targetOffset.x,r=this.targetOffset.y,o=this.modifiedOffset.x,i=this.modifiedOffset.y,f={x:dn(a=d,t,n,o),y:dn(a,e,r,i)}):f={x:this.targetOffset.x*d,y:this.targetOffset.y*d};var p={x:f.x-this.currentOffset.x,y:f.y-this.currentOffset.y};this.currentOffset.x+=p.x,this.currentOffset.y+=p.y,l.offsetBy(p),l.move(),this.timeout=kt.default.request((function(){return s.inertiaTick()}))}else l.offsetBy({x:this.modifiedOffset.x-this.currentOffset.x,y:this.modifiedOffset.y-this.currentOffset.y}),this.end()}},{key:"smoothEndTick",value:function(){var t=this,e=this.interaction,n=e._now()-this.t0,r=fn(e).smoothEndDuration;if(n<r){var o={x:pn(n,0,this.targetOffset.x,r),y:pn(n,0,this.targetOffset.y,r)},i={x:o.x-this.currentOffset.x,y:o.y-this.currentOffset.y};this.currentOffset.x+=i.x,this.currentOffset.y+=i.y,e.offsetBy(i),e.move({skipModifiers:this.modifierCount}),this.timeout=kt.default.request((function(){return t.smoothEndTick()}))}else e.offsetBy({x:this.targetOffset.x-this.currentOffset.x,y:this.targetOffset.y-this.currentOffset.y}),this.end()}},{key:"resume",value:function(t){var e=t.pointer,n=t.event,r=t.eventTarget,o=this.interaction;o.offsetBy({x:-this.currentOffset.x,y:-this.currentOffset.y}),o.updatePointer(e,n,r,!0),o._doPhase({interaction:o,event:n,phase:"resume"}),(0,L.copyCoords)(o.coords.prev,o.coords.cur),this.stop()}},{key:"end",value:function(){this.interaction.move(),this.interaction.end(),this.stop()}},{key:"stop",value:function(){this.active=this.smoothEnd=!1,this.interaction.simulation=null,kt.default.cancel(this.timeout)}}])&&un(e.prototype,n),r&&un(e,r),t}();function fn(t){var e=t.interactable,n=t.prepared;return e&&e.options&&n.name&&e.options[n.name].inertia}function dn(t,e,n,r){var o=1-t;return o*o*e+2*o*t*n+t*t*r}function pn(t,e,n,r){return-n*(t/=r)*(t-2)+e}ln.InertiaState=cn;var vn={id:"inertia",before:["modifiers"],install:function(t){var e=t.defaults;t.usePlugin(tn.default),t.usePlugin(De.default),t.actions.phases.inertiastart=!0,t.actions.phases.resume=!0,e.perAction.inertia={enabled:!1,resistance:10,minSpeed:100,endSpeed:10,allowResume:!0,smoothEndDuration:300}},listeners:{"interactions:new":function(t){var e=t.interaction;e.inertia=new cn(e)},"interactions:before-action-end":function(t){var e=t.interaction,n=t.event;return(!e._interacting||e.simulation||!e.inertia.start(n))&&null},"interactions:down":function(t){var e=t.interaction,n=t.eventTarget,r=e.inertia;if(r.active)for(var o=n;a.default.element(o);){if(o===e.element){r.resume(t);break}o=S.parentNode(o)}},"interactions:stop":function(t){var e=t.interaction.inertia;e.active&&e.stop()},"interactions:before-action-resume":function(t){var e=t.interaction.modification;e.stop(t),e.start(t,t.interaction.coords.cur.page),e.applyToInteraction(t)},"interactions:before-action-inertiastart":function(t){return t.interaction.modification.setAndApply(t)},"interactions:action-resume":De.addEventModifiers,"interactions:action-inertiastart":De.addEventModifiers,"interactions:after-action-inertiastart":function(t){return t.interaction.modification.restoreInteractionCoords(t)},"interactions:after-action-resume":function(t){return t.interaction.modification.restoreInteractionCoords(t)}}};ln.default=vn;var hn={};function gn(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function yn(t,e){for(var n=0;n<e.length;n++){var r=e[n];if(t.immediatePropagationStopped)break;r(t)}}Object.defineProperty(hn,"__esModule",{value:!0}),hn.Eventable=void 0;var mn=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.options=void 0,this.types={},this.propagationStopped=!1,this.immediatePropagationStopped=!1,this.global=void 0,this.options=(0,k.default)({},e||{})}var e,n,r;return e=t,(n=[{key:"fire",value:function(t){var e,n=this.global;(e=this.types[t.type])&&yn(t,e),!t.propagationStopped&&n&&(e=n[t.type])&&yn(t,e)}},{key:"on",value:function(t,e){var n=(0,C.default)(t,e);for(t in n)this.types[t]=J.merge(this.types[t]||[],n[t])}},{key:"off",value:function(t,e){var n=(0,C.default)(t,e);for(t in n){var r=this.types[t];if(r&&r.length)for(var o=0;o<n[t].length;o++){var i=n[t][o],a=r.indexOf(i);-1!==a&&r.splice(a,1)}}}},{key:"getRect",value:function(t){return null}}])&&gn(e.prototype,n),r&&gn(e,r),t}();hn.Eventable=mn;var bn={};Object.defineProperty(bn,"__esModule",{value:!0}),bn.default=function(t,e){if(e.phaselessTypes[t])return!0;for(var n in e.map)if(0===t.indexOf(n)&&t.substr(n.length)in e.phases)return!0;return!1};var xn={};function wn(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function _n(t,e,n){return e&&wn(t.prototype,e),n&&wn(t,n),t}Object.defineProperty(xn,"__esModule",{value:!0}),xn.Interactable=void 0;var Sn=function(){function t(n,r,o,i){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.options=void 0,this._actions=void 0,this.target=void 0,this.events=new hn.Eventable,this._context=void 0,this._win=void 0,this._doc=void 0,this._scopeEvents=void 0,this._rectChecker=void 0,this._actions=r.actions,this.target=n,this._context=r.context||o,this._win=(0,e.getWindow)((0,S.trySelector)(n)?this._context:n),this._doc=this._win.document,this._scopeEvents=i,this.set(r)}return _n(t,[{key:"_defaults",get:function(){return{base:{},perAction:{},actions:{}}}}]),_n(t,[{key:"setOnEvents",value:function(t,e){return a.default.func(e.onstart)&&this.on("".concat(t,"start"),e.onstart),a.default.func(e.onmove)&&this.on("".concat(t,"move"),e.onmove),a.default.func(e.onend)&&this.on("".concat(t,"end"),e.onend),a.default.func(e.oninertiastart)&&this.on("".concat(t,"inertiastart"),e.oninertiastart),this}},{key:"updatePerActionListeners",value:function(t,e,n){(a.default.array(e)||a.default.object(e))&&this.off(t,e),(a.default.array(n)||a.default.object(n))&&this.on(t,n)}},{key:"setPerAction",value:function(t,e){var n=this._defaults;for(var r in e){var o=r,i=this.options[t],s=e[o];"listeners"===o&&this.updatePerActionListeners(t,i.listeners,s),a.default.array(s)?i[o]=J.from(s):a.default.plainObject(s)?(i[o]=(0,k.default)(i[o]||{},(0,Pe.default)(s)),a.default.object(n.perAction[o])&&"enabled"in n.perAction[o]&&(i[o].enabled=!1!==s.enabled)):a.default.bool(s)&&a.default.object(n.perAction[o])?i[o].enabled=s:i[o]=s}}},{key:"getRect",value:function(t){return t=t||(a.default.element(this.target)?this.target:null),a.default.string(this.target)&&(t=t||this._context.querySelector(this.target)),(0,S.getElementRect)(t)}},{key:"rectChecker",value:function(t){var e=this;return a.default.func(t)?(this._rectChecker=t,this.getRect=function(t){var n=(0,k.default)({},e._rectChecker(t));return"width"in n||(n.width=n.right-n.left,n.height=n.bottom-n.top),n},this):null===t?(delete this.getRect,delete this._rectChecker,this):this.getRect}},{key:"_backCompatOption",value:function(t,e){if((0,S.trySelector)(e)||a.default.object(e)){for(var n in this.options[t]=e,this._actions.map)this.options[n][t]=e;return this}return this.options[t]}},{key:"origin",value:function(t){return this._backCompatOption("origin",t)}},{key:"deltaSource",value:function(t){return"page"===t||"client"===t?(this.options.deltaSource=t,this):this.options.deltaSource}},{key:"context",value:function(){return this._context}},{key:"inContext",value:function(t){return this._context===t.ownerDocument||(0,S.nodeContains)(this._context,t)}},{key:"testIgnoreAllow",value:function(t,e,n){return!this.testIgnore(t.ignoreFrom,e,n)&&this.testAllow(t.allowFrom,e,n)}},{key:"testAllow",value:function(t,e,n){return!t||!!a.default.element(n)&&(a.default.string(t)?(0,S.matchesUpTo)(n,t,e):!!a.default.element(t)&&(0,S.nodeContains)(t,n))}},{key:"testIgnore",value:function(t,e,n){return!(!t||!a.default.element(n))&&(a.default.string(t)?(0,S.matchesUpTo)(n,t,e):!!a.default.element(t)&&(0,S.nodeContains)(t,n))}},{key:"fire",value:function(t){return this.events.fire(t),this}},{key:"_onOff",value:function(t,e,n,r){a.default.object(e)&&!a.default.array(e)&&(r=n,n=null);var o="on"===t?"add":"remove",i=(0,C.default)(e,n);for(var s in i){"wheel"===s&&(s=x.default.wheelEvent);for(var l=0;l<i[s].length;l++){var u=i[s][l];(0,bn.default)(s,this._actions)?this.events[t](s,u):a.default.string(this.target)?this._scopeEvents["".concat(o,"Delegate")](this.target,this._context,s,u,r):this._scopeEvents[o](this.target,s,u,r)}}return this}},{key:"on",value:function(t,e,n){return this._onOff("on",t,e,n)}},{key:"off",value:function(t,e,n){return this._onOff("off",t,e,n)}},{key:"set",value:function(t){var e=this._defaults;for(var n in a.default.object(t)||(t={}),this.options=(0,Pe.default)(e.base),this._actions.methodDict){var r=n,o=this._actions.methodDict[r];this.options[r]={},this.setPerAction(r,(0,k.default)((0,k.default)({},e.perAction),e.actions[r])),this[o](t[r])}for(var i in t)a.default.func(this[i])&&this[i](t[i]);return this}},{key:"unset",value:function(){if(a.default.string(this.target))for(var t in this._scopeEvents.delegatedEvents)for(var e=this._scopeEvents.delegatedEvents[t],n=e.length-1;n>=0;n--){var r=e[n],o=r.selector,i=r.context,s=r.listeners;o===this.target&&i===this._context&&e.splice(n,1);for(var l=s.length-1;l>=0;l--)this._scopeEvents.removeDelegate(this.target,this._context,t,s[l][0],s[l][1])}else this._scopeEvents.remove(this.target,"all")}}]),t}();xn.Interactable=Sn;var Pn={};function On(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}Object.defineProperty(Pn,"__esModule",{value:!0}),Pn.InteractableSet=void 0;var En=function(){function t(e){var n=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.list=[],this.selectorMap={},this.scope=void 0,this.scope=e,e.addListeners({"interactable:unset":function(t){var e=t.interactable,r=e.target,o=e._context,i=a.default.string(r)?n.selectorMap[r]:r[n.scope.id],s=i.findIndex((function(t){return t.context===o}));i[s]&&(i[s].context=null,i[s].interactable=null),i.splice(s,1)}})}var e,n,r;return e=t,(n=[{key:"new",value:function(t,e){e=(0,k.default)(e||{},{actions:this.scope.actions});var n=new this.scope.Interactable(t,e,this.scope.document,this.scope.events),r={context:n._context,interactable:n};return this.scope.addDocument(n._doc),this.list.push(n),a.default.string(t)?(this.selectorMap[t]||(this.selectorMap[t]=[]),this.selectorMap[t].push(r)):(n.target[this.scope.id]||Object.defineProperty(t,this.scope.id,{value:[],configurable:!0}),t[this.scope.id].push(r)),this.scope.fire("interactable:new",{target:t,options:e,interactable:n,win:this.scope._win}),n}},{key:"get",value:function(t,e){var n=e&&e.context||this.scope.document,r=a.default.string(t),o=r?this.selectorMap[t]:t[this.scope.id];if(!o)return null;var i=J.find(o,(function(e){return e.context===n&&(r||e.interactable.inContext(t))}));return i&&i.interactable}},{key:"forEachMatch",value:function(t,e){for(var n=0;n<this.list.length;n++){var r=this.list[n],o=void 0;if((a.default.string(r.target)?a.default.element(t)&&S.matchesSelector(t,r.target):t===r.target)&&r.inContext(t)&&(o=e(r)),void 0!==o)return o}}}])&&On(e.prototype,n),r&&On(e,r),t}();Pn.InteractableSet=En;var Tn={};function Mn(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function jn(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(t)))return;var n=[],r=!0,o=!1,i=void 0;try{for(var a,s=t[Symbol.iterator]();!(r=(a=s.next()).done)&&(n.push(a.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{r||null==s.return||s.return()}finally{if(o)throw i}}return n}(t,e)||function(t,e){if(!t)return;if("string"==typeof t)return kn(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return kn(t,e)}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function kn(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=Array(e);n<e;n++)r[n]=t[n];return r}Object.defineProperty(Tn,"__esModule",{value:!0}),Tn.default=Tn.FakeEvent=void 0;var In=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.currentTarget=void 0,this.originalEvent=void 0,this.originalEvent=e,(0,X.default)(this,e)}var e,n,r;return e=t,(n=[{key:"preventOriginalDefault",value:function(){this.originalEvent.preventDefault()}},{key:"stopPropagation",value:function(){this.originalEvent.stopPropagation()}},{key:"stopImmediatePropagation",value:function(){this.originalEvent.stopImmediatePropagation()}}])&&Mn(e.prototype,n),r&&Mn(e,r),t}();function Dn(t){if(!a.default.object(t))return{capture:!!t,passive:!1};var e=(0,k.default)({},t);return e.capture=!!t.capture,e.passive=!!t.passive,e}Tn.FakeEvent=In;var An={id:"events",install:function(t){var e=[],n={},r=[],o={add:i,remove:s,addDelegate:function(t,e,o,a,s){var c=Dn(s);if(!n[o]){n[o]=[];for(var f=0;f<r.length;f++){var d=r[f];i(d,o,l),i(d,o,u,!0)}}var p=n[o],v=J.find(p,(function(n){return n.selector===t&&n.context===e}));v||(v={selector:t,context:e,listeners:[]},p.push(v));v.listeners.push([a,c])},removeDelegate:function(t,e,r,o,i){var a,c=Dn(i),f=n[r],d=!1;if(!f)return;for(a=f.length-1;a>=0;a--){var p=f[a];if(p.selector===t&&p.context===e){for(var v=p.listeners,h=v.length-1;h>=0;h--){var g=jn(v[h],2),y=g[0],m=g[1],b=m.capture,x=m.passive;if(y===o&&b===c.capture&&x===c.passive){v.splice(h,1),v.length||(f.splice(a,1),s(e,r,l),s(e,r,u,!0)),d=!0;break}}if(d)break}}},delegateListener:l,delegateUseCapture:u,delegatedEvents:n,documents:r,targets:e,supportsOptions:!1,supportsPassive:!1};function i(t,n,r,i){var a=Dn(i),s=J.find(e,(function(e){return e.eventTarget===t}));s||(s={eventTarget:t,events:{}},e.push(s)),s.events[n]||(s.events[n]=[]),t.addEventListener&&!J.contains(s.events[n],r)&&(t.addEventListener(n,r,o.supportsOptions?a:a.capture),s.events[n].push(r))}function s(t,n,r,i){var a=Dn(i),l=J.findIndex(e,(function(e){return e.eventTarget===t})),u=e[l];if(u&&u.events)if("all"!==n){var c=!1,f=u.events[n];if(f){if("all"===r){for(var d=f.length-1;d>=0;d--)s(t,n,f[d],a);return}for(var p=0;p<f.length;p++)if(f[p]===r){t.removeEventListener(n,r,o.supportsOptions?a:a.capture),f.splice(p,1),0===f.length&&(delete u.events[n],c=!0);break}}c&&!Object.keys(u.events).length&&e.splice(l,1)}else for(n in u.events)u.events.hasOwnProperty(n)&&s(t,n,"all")}function l(t,e){for(var r=Dn(e),o=new In(t),i=n[t.type],s=jn(L.getEventTargets(t),1)[0],l=s;a.default.element(l);){for(var u=0;u<i.length;u++){var c=i[u],f=c.selector,d=c.context;if(S.matchesSelector(l,f)&&S.nodeContains(d,s)&&S.nodeContains(d,l)){var p=c.listeners;o.currentTarget=l;for(var v=0;v<p.length;v++){var h=jn(p[v],2),g=h[0],y=h[1],m=y.capture,b=y.passive;m===r.capture&&b===r.passive&&g(o)}}}l=S.parentNode(l)}}function u(t){return l(t,!0)}return t.document.createElement("div").addEventListener("test",null,{get capture(){return o.supportsOptions=!0},get passive(){return o.supportsPassive=!0}}),t.events=o,o}};Tn.default=An;var zn={};Object.defineProperty(zn,"__esModule",{value:!0}),zn.createInteractStatic=function(t){var e=function e(n,r){var o=t.interactables.get(n,r);return o||((o=t.interactables.new(n,r)).events.global=e.globalEvents),o};return e.getPointerAverage=L.pointerAverage,e.getTouchBBox=L.touchBBox,e.getTouchDistance=L.touchDistance,e.getTouchAngle=L.touchAngle,e.getElementRect=S.getElementRect,e.getElementClientRect=S.getElementClientRect,e.matchesSelector=S.matchesSelector,e.closest=S.closest,e.globalEvents={},e.version=void 0,e.scope=t,e.use=function(t,e){return this.scope.usePlugin(t,e),this},e.isSet=function(t,e){return!!this.scope.interactables.get(t,e&&e.context)},e.on=function(t,e,n){if(a.default.string(t)&&-1!==t.search(" ")&&(t=t.trim().split(/ +/)),a.default.array(t)){for(var r=0;r<t.length;r++){var o=t[r];this.on(o,e,n)}return this}if(a.default.object(t)){for(var i in t)this.on(i,t[i],e);return this}return(0,bn.default)(t,this.scope.actions)?this.globalEvents[t]?this.globalEvents[t].push(e):this.globalEvents[t]=[e]:this.scope.events.add(this.scope.document,t,e,{options:n}),this},e.off=function(t,e,n){if(a.default.string(t)&&-1!==t.search(" ")&&(t=t.trim().split(/ +/)),a.default.array(t)){for(var r=0;r<t.length;r++){var o=t[r];this.off(o,e,n)}return this}if(a.default.object(t)){for(var i in t)this.off(i,t[i],e);return this}var s;(0,bn.default)(t,this.scope.actions)?t in this.globalEvents&&-1!==(s=this.globalEvents[t].indexOf(e))&&this.globalEvents[t].splice(s,1):this.scope.events.remove(this.scope.document,t,e,n);return this},e.debug=function(){return this.scope},e.supportsTouch=function(){return x.default.supportsTouch},e.supportsPointerEvent=function(){return x.default.supportsPointerEvent},e.stop=function(){for(var t=0;t<this.scope.interactions.list.length;t++){this.scope.interactions.list[t].stop()}return this},e.pointerMoveTolerance=function(t){return a.default.number(t)?(this.scope.interactions.pointerMoveTolerance=t,this):this.scope.interactions.pointerMoveTolerance},e.addDocument=function(t,e){this.scope.addDocument(t,e)},e.removeDocument=function(t){this.scope.removeDocument(t)},e};var Cn={};Object.defineProperty(Cn,"__esModule",{value:!0}),Cn.default=void 0;var Rn={methodOrder:["simulationResume","mouseOrPen","hasPointer","idle"],search:function(t){for(var e=0;e<Rn.methodOrder.length;e++){var n;n=Rn.methodOrder[e];var r=Rn[n](t);if(r)return r}return null},simulationResume:function(t){var e=t.pointerType,n=t.eventType,r=t.eventTarget,o=t.scope;if(!/down|start/i.test(n))return null;for(var i=0;i<o.interactions.list.length;i++){var a=o.interactions.list[i],s=r;if(a.simulation&&a.simulation.allowResume&&a.pointerType===e)for(;s;){if(s===a.element)return a;s=S.parentNode(s)}}return null},mouseOrPen:function(t){var e,n=t.pointerId,r=t.pointerType,o=t.eventType,i=t.scope;if("mouse"!==r&&"pen"!==r)return null;for(var a=0;a<i.interactions.list.length;a++){var s=i.interactions.list[a];if(s.pointerType===r){if(s.simulation&&!Fn(s,n))continue;if(s.interacting())return s;e||(e=s)}}if(e)return e;for(var l=0;l<i.interactions.list.length;l++){var u=i.interactions.list[l];if(!(u.pointerType!==r||/down/i.test(o)&&u.simulation))return u}return null},hasPointer:function(t){for(var e=t.pointerId,n=t.scope,r=0;r<n.interactions.list.length;r++){var o=n.interactions.list[r];if(Fn(o,e))return o}return null},idle:function(t){for(var e=t.pointerType,n=t.scope,r=0;r<n.interactions.list.length;r++){var o=n.interactions.list[r];if(1===o.pointers.length){var i=o.interactable;if(i&&(!i.options.gesture||!i.options.gesture.enabled))continue}else if(o.pointers.length>=2)continue;if(!o.interacting()&&e===o.pointerType)return o}return null}};function Fn(t,e){return t.pointers.some((function(t){return t.id===e}))}var Xn=Rn;Cn.default=Xn;var Yn={};function Wn(t){return(Wn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ln(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(t)))return;var n=[],r=!0,o=!1,i=void 0;try{for(var a,s=t[Symbol.iterator]();!(r=(a=s.next()).done)&&(n.push(a.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{r||null==s.return||s.return()}finally{if(o)throw i}}return n}(t,e)||function(t,e){if(!t)return;if("string"==typeof t)return Bn(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return Bn(t,e)}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Bn(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=Array(e);n<e;n++)r[n]=t[n];return r}function Un(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function Vn(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function qn(t,e){return(qn=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function Nn(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Gn(t);if(e){var o=Gn(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return $n(this,n)}}function $n(t,e){return!e||"object"!==Wn(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Gn(t){return(Gn=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}Object.defineProperty(Yn,"__esModule",{value:!0}),Yn.default=void 0;var Hn=["pointerDown","pointerMove","pointerUp","updatePointer","removePointer","windowBlur"];function Kn(t,e){return function(n){var r=e.interactions.list,o=L.getPointerType(n),i=Ln(L.getEventTargets(n),2),a=i[0],s=i[1],l=[];if(/^touch/.test(n.type)){e.prevTouchTime=e.now();for(var u=0;u<n.changedTouches.length;u++){var c=n.changedTouches[u],f={pointer:c,pointerId:L.getPointerId(c),pointerType:o,eventType:n.type,eventTarget:a,curEventTarget:s,scope:e},d=Zn(f);l.push([f.pointer,f.eventTarget,f.curEventTarget,d])}}else{var p=!1;if(!x.default.supportsPointerEvent&&/mouse/.test(n.type)){for(var v=0;v<r.length&&!p;v++)p="mouse"!==r[v].pointerType&&r[v].pointerIsDown;p=p||e.now()-e.prevTouchTime<500||0===n.timeStamp}if(!p){var h={pointer:n,pointerId:L.getPointerId(n),pointerType:o,eventType:n.type,curEventTarget:s,eventTarget:a,scope:e},g=Zn(h);l.push([h.pointer,h.eventTarget,h.curEventTarget,g])}}for(var y=0;y<l.length;y++){var m=Ln(l[y],4),b=m[0],w=m[1],_=m[2];m[3][t](b,n,w,_)}}}function Zn(t){var e=t.pointerType,n=t.scope,r={interaction:Cn.default.search(t),searchDetails:t};return n.fire("interactions:find",r),r.interaction||n.interactions.new({pointerType:e})}function Jn(t,e){var n=t.doc,r=t.scope,o=t.options,i=r.interactions.docEvents,a=r.events,s=a[e];for(var l in r.browser.isIOS&&!o.events&&(o.events={passive:!1}),a.delegatedEvents)s(n,l,a.delegateListener),s(n,l,a.delegateUseCapture,!0);for(var u=o&&o.events,c=0;c<i.length;c++){var f=i[c];s(n,f.type,f.listener,u)}}var Qn={id:"core/interactions",install:function(t){for(var e={},n=0;n<Hn.length;n++){var r=Hn[n];e[r]=Kn(r,t)}var o,i=x.default.pEventTypes;function a(){for(var e=0;e<t.interactions.list.length;e++){var n=t.interactions.list[e];if(n.pointerIsDown&&"touch"===n.pointerType&&!n._interacting)for(var r=function(){var e=n.pointers[o];t.documents.some((function(t){var n=t.doc;return(0,S.nodeContains)(n,e.downTarget)}))||n.removePointer(e.pointer,e.event)},o=0;o<n.pointers.length;o++){r()}}}(o=g.default.PointerEvent?[{type:i.down,listener:a},{type:i.down,listener:e.pointerDown},{type:i.move,listener:e.pointerMove},{type:i.up,listener:e.pointerUp},{type:i.cancel,listener:e.pointerUp}]:[{type:"mousedown",listener:e.pointerDown},{type:"mousemove",listener:e.pointerMove},{type:"mouseup",listener:e.pointerUp},{type:"touchstart",listener:a},{type:"touchstart",listener:e.pointerDown},{type:"touchmove",listener:e.pointerMove},{type:"touchend",listener:e.pointerUp},{type:"touchcancel",listener:e.pointerUp}]).push({type:"blur",listener:function(e){for(var n=0;n<t.interactions.list.length;n++){t.interactions.list[n].documentBlur(e)}}}),t.prevTouchTime=0,t.Interaction=function(e){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&qn(t,e)}(a,e);var n,r,o,i=Nn(a);function a(){return Un(this,a),i.apply(this,arguments)}return n=a,(r=[{key:"_now",value:function(){return t.now()}},{key:"pointerMoveTolerance",get:function(){return t.interactions.pointerMoveTolerance},set:function(e){t.interactions.pointerMoveTolerance=e}}])&&Vn(n.prototype,r),o&&Vn(n,o),a}(Ge.default),t.interactions={list:[],new:function(e){e.scopeFire=function(e,n){return t.fire(e,n)};var n=new t.Interaction(e);return t.interactions.list.push(n),n},listeners:e,docEvents:o,pointerMoveTolerance:1},t.usePlugin(ue.default)},listeners:{"scope:add-document":function(t){return Jn(t,"add")},"scope:remove-document":function(t){return Jn(t,"remove")},"interactable:unset":function(t,e){for(var n=t.interactable,r=e.interactions.list.length-1;r>=0;r--){var o=e.interactions.list[r];o.interactable===n&&(o.stop(),e.fire("interactions:destroy",{interaction:o}),o.destroy(),e.interactions.list.length>2&&e.interactions.list.splice(r,1))}}},onDocSignal:Jn,doOnInteractions:Kn,methodNames:Hn};Yn.default=Qn;var tr={};function er(t){return(er="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function nr(t,e,n){return(nr="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t,e,n){var r=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=ar(t)););return t}(t,e);if(r){var o=Object.getOwnPropertyDescriptor(r,e);return o.get?o.get.call(n):o.value}})(t,e,n||t)}function rr(t,e){return(rr=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function or(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=ar(t);if(e){var o=ar(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return ir(this,n)}}function ir(t,e){return!e||"object"!==er(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function ar(t){return(ar=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function sr(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function lr(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function ur(t,e,n){return e&&lr(t.prototype,e),n&&lr(t,n),t}Object.defineProperty(tr,"__esModule",{value:!0}),tr.initScope=fr,tr.Scope=void 0;var cr=function(){function t(){var e=this;sr(this,t),this.id="__interact_scope_".concat(Math.floor(100*Math.random())),this.isInitialized=!1,this.listenerMaps=[],this.browser=x.default,this.defaults=(0,Pe.default)(Ce.defaults),this.Eventable=hn.Eventable,this.actions={map:{},phases:{start:!0,move:!0,end:!0},methodDict:{},phaselessTypes:{}},this.interactStatic=(0,zn.createInteractStatic)(this),this.InteractEvent=Re.InteractEvent,this.Interactable=void 0,this.interactables=new Pn.InteractableSet(this),this._win=void 0,this.document=void 0,this.window=void 0,this.documents=[],this._plugins={list:[],map:{}},this.onWindowUnload=function(t){return e.removeDocument(t.target)};var n=this;this.Interactable=function(t){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&rr(t,e)}(r,t);var e=or(r);function r(){return sr(this,r),e.apply(this,arguments)}return ur(r,[{key:"set",value:function(t){return nr(ar(r.prototype),"set",this).call(this,t),n.fire("interactable:set",{options:t,interactable:this}),this}},{key:"unset",value:function(){nr(ar(r.prototype),"unset",this).call(this),n.interactables.list.splice(n.interactables.list.indexOf(this),1),n.fire("interactable:unset",{interactable:this})}},{key:"_defaults",get:function(){return n.defaults}}]),r}(xn.Interactable)}return ur(t,[{key:"addListeners",value:function(t,e){this.listenerMaps.push({id:e,map:t})}},{key:"fire",value:function(t,e){for(var n=0;n<this.listenerMaps.length;n++){var r=this.listenerMaps[n].map[t];if(r&&!1===r(e,this,t))return!1}}},{key:"init",value:function(t){return this.isInitialized?this:fr(this,t)}},{key:"pluginIsInstalled",value:function(t){return this._plugins.map[t.id]||-1!==this._plugins.list.indexOf(t)}},{key:"usePlugin",value:function(t,e){if(!this.isInitialized)return this;if(this.pluginIsInstalled(t))return this;if(t.id&&(this._plugins.map[t.id]=t),this._plugins.list.push(t),t.install&&t.install(this,e),t.listeners&&t.before){for(var n=0,r=this.listenerMaps.length,o=t.before.reduce((function(t,e){return t[e]=!0,t[dr(e)]=!0,t}),{});n<r;n++){var i=this.listenerMaps[n].id;if(o[i]||o[dr(i)])break}this.listenerMaps.splice(n,0,{id:t.id,map:t.listeners})}else t.listeners&&this.listenerMaps.push({id:t.id,map:t.listeners});return this}},{key:"addDocument",value:function(t,n){if(-1!==this.getDocIndex(t))return!1;var r=e.default.getWindow(t);n=n?(0,k.default)({},n):{},this.documents.push({doc:t,options:n}),this.events.documents.push(t),t!==this.document&&this.events.add(r,"unload",this.onWindowUnload),this.fire("scope:add-document",{doc:t,window:r,scope:this,options:n})}},{key:"removeDocument",value:function(t){var n=this.getDocIndex(t),r=e.default.getWindow(t),o=this.documents[n].options;this.events.remove(r,"unload",this.onWindowUnload),this.documents.splice(n,1),this.events.documents.splice(n,1),this.fire("scope:remove-document",{doc:t,window:r,scope:this,options:o})}},{key:"getDocIndex",value:function(t){for(var e=0;e<this.documents.length;e++)if(this.documents[e].doc===t)return e;return-1}},{key:"getDocOptions",value:function(t){var e=this.getDocIndex(t);return-1===e?null:this.documents[e].options}},{key:"now",value:function(){return(this.window.Date||Date).now()}}]),t}();function fr(t,n){return t.isInitialized=!0,e.default.init(n),g.default.init(n),x.default.init(n),kt.default.init(n),t.window=n,t.document=n.document,t.usePlugin(Yn.default),t.usePlugin(Tn.default),t}function dr(t){return t&&t.replace(/\/.*$/,"")}tr.Scope=cr;var pr={};function vr(t){return(vr="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}Object.defineProperty(pr,"__esModule",{value:!0}),pr.init=pr.default=void 0;var hr=new tr.Scope,gr=hr.interactStatic;pr.default=gr;var yr=function(t){return hr.init(t)};pr.init=yr,"object"===("undefined"==typeof window?"undefined":vr(window))&&window&&yr(window);var mr={};Object.defineProperty(mr,"__esModule",{value:!0}),mr.default=void 0;mr.default=function(){};var br={};Object.defineProperty(br,"__esModule",{value:!0}),br.default=void 0;br.default=function(){};var xr={};function wr(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(t)))return;var n=[],r=!0,o=!1,i=void 0;try{for(var a,s=t[Symbol.iterator]();!(r=(a=s.next()).done)&&(n.push(a.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{r||null==s.return||s.return()}finally{if(o)throw i}}return n}(t,e)||function(t,e){if(!t)return;if("string"==typeof t)return _r(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _r(t,e)}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function _r(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=Array(e);n<e;n++)r[n]=t[n];return r}Object.defineProperty(xr,"__esModule",{value:!0}),xr.default=void 0;xr.default=function(t){var e=[["x","y"],["left","top"],["right","bottom"],["width","height"]].filter((function(e){var n=wr(e,2),r=n[0],o=n[1];return r in t||o in t})),n=function(n,r){for(var o=t.range,i=t.limits,a=void 0===i?{left:-1/0,right:1/0,top:-1/0,bottom:1/0}:i,s=t.offset,l=void 0===s?{x:0,y:0}:s,u={range:o,grid:t,x:null,y:null},c=0;c<e.length;c++){var f=wr(e[c],2),d=f[0],p=f[1],v=Math.round((n-l.x)/t[d]),h=Math.round((r-l.y)/t[p]);u[d]=Math.max(a.left,Math.min(a.right,v*t[d]+l.x)),u[p]=Math.max(a.top,Math.min(a.bottom,h*t[p]+l.y))}return u};return n.grid=t,n.coordFields=e,n};var Sr={};Object.defineProperty(Sr,"__esModule",{value:!0}),Object.defineProperty(Sr,"edgeTarget",{enumerable:!0,get:function(){return mr.default}}),Object.defineProperty(Sr,"elements",{enumerable:!0,get:function(){return br.default}}),Object.defineProperty(Sr,"grid",{enumerable:!0,get:function(){return xr.default}});var Pr={};Object.defineProperty(Pr,"__esModule",{value:!0}),Pr.default=void 0;var Or={id:"snappers",install:function(t){var e=t.interactStatic;e.snappers=(0,k.default)(e.snappers||{},Sr),e.createSnapGrid=e.snappers.grid}};Pr.default=Or;var Er={};function Tr(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Mr(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Tr(Object(n),!0).forEach((function(e){jr(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Tr(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function jr(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}Object.defineProperty(Er,"__esModule",{value:!0}),Er.aspectRatio=Er.default=void 0;var kr={start:function(t){var e=t.state,n=t.rect,r=t.edges,o=t.pageCoords,i=e.options.ratio,a=e.options,s=a.equalDelta,l=a.modifiers;"preserve"===i&&(i=n.width/n.height),e.startCoords=(0,k.default)({},o),e.startRect=(0,k.default)({},n),e.ratio=i,e.equalDelta=s;var u=e.linkedEdges={top:r.top||r.left&&!r.bottom,left:r.left||r.top&&!r.right,bottom:r.bottom||r.right&&!r.top,right:r.right||r.bottom&&!r.left};if(e.xIsPrimaryAxis=!(!r.left&&!r.right),e.equalDelta)e.edgeSign=(u.left?1:-1)*(u.top?1:-1);else{var c=e.xIsPrimaryAxis?u.top:u.left;e.edgeSign=c?-1:1}if((0,k.default)(t.edges,u),l&&l.length){var f=new Oe.default(t.interaction);f.copyFrom(t.interaction.modification),f.prepareStates(l),e.subModification=f,f.startAll(Mr({},t))}},set:function(t){var e=t.state,n=t.rect,r=t.coords,o=(0,k.default)({},r),i=e.equalDelta?Ir:Dr;if(i(e,e.xIsPrimaryAxis,r,n),!e.subModification)return null;var a=(0,k.default)({},n);(0,I.addEdges)(e.linkedEdges,a,{x:r.x-o.x,y:r.y-o.y});var s=e.subModification.setAll(Mr(Mr({},t),{},{rect:a,edges:e.linkedEdges,pageCoords:r,prevCoords:r,prevRect:a})),l=s.delta;s.changed&&(i(e,Math.abs(l.x)>Math.abs(l.y),s.coords,s.rect),(0,k.default)(r,s.coords));return s.eventProps},defaults:{ratio:"preserve",equalDelta:!1,modifiers:[],enabled:!1}};function Ir(t,e,n){var r=t.startCoords,o=t.edgeSign;e?n.y=r.y+(n.x-r.x)*o:n.x=r.x+(n.y-r.y)*o}function Dr(t,e,n,r){var o=t.startRect,i=t.startCoords,a=t.ratio,s=t.edgeSign;if(e){var l=r.width/a;n.y=i.y+(l-o.height)*s}else{var u=r.height*a;n.x=i.x+(u-o.width)*s}}Er.aspectRatio=kr;var Ar=(0,De.makeModifier)(kr,"aspectRatio");Er.default=Ar;var zr={};Object.defineProperty(zr,"__esModule",{value:!0}),zr.default=void 0;var Cr=function(){};Cr._defaults={};var Rr=Cr;zr.default=Rr;var Fr={};Object.defineProperty(Fr,"__esModule",{value:!0}),Object.defineProperty(Fr,"default",{enumerable:!0,get:function(){return zr.default}});var Xr={};function Yr(t,e,n){return a.default.func(t)?I.resolveRectLike(t,e.interactable,e.element,[n.x,n.y,e]):I.resolveRectLike(t,e.interactable,e.element)}Object.defineProperty(Xr,"__esModule",{value:!0}),Xr.getRestrictionRect=Yr,Xr.restrict=Xr.default=void 0;var Wr={start:function(t){var e=t.rect,n=t.startOffset,r=t.state,o=t.interaction,i=t.pageCoords,a=r.options,s=a.elementRect,l=(0,k.default)({left:0,top:0,right:0,bottom:0},a.offset||{});if(e&&s){var u=Yr(a.restriction,o,i);if(u){var c=u.right-u.left-e.width,f=u.bottom-u.top-e.height;c<0&&(l.left+=c,l.right+=c),f<0&&(l.top+=f,l.bottom+=f)}l.left+=n.left-e.width*s.left,l.top+=n.top-e.height*s.top,l.right+=n.right-e.width*(1-s.right),l.bottom+=n.bottom-e.height*(1-s.bottom)}r.offset=l},set:function(t){var e=t.coords,n=t.interaction,r=t.state,o=r.options,i=r.offset,a=Yr(o.restriction,n,e);if(a){var s=I.xywhToTlbr(a);e.x=Math.max(Math.min(s.right-i.right,e.x),s.left+i.left),e.y=Math.max(Math.min(s.bottom-i.bottom,e.y),s.top+i.top)}},defaults:{restriction:null,elementRect:null,offset:null,endOnly:!1,enabled:!1}};Xr.restrict=Wr;var Lr=(0,De.makeModifier)(Wr,"restrict");Xr.default=Lr;var Br={};Object.defineProperty(Br,"__esModule",{value:!0}),Br.restrictEdges=Br.default=void 0;var Ur={top:1/0,left:1/0,bottom:-1/0,right:-1/0},Vr={top:-1/0,left:-1/0,bottom:1/0,right:1/0};function qr(t,e){for(var n=["top","left","bottom","right"],r=0;r<n.length;r++){var o=n[r];o in t||(t[o]=e[o])}return t}var Nr={noInner:Ur,noOuter:Vr,start:function(t){var e,n=t.interaction,r=t.startOffset,o=t.state,i=o.options;if(i){var a=(0,Xr.getRestrictionRect)(i.offset,n,n.coords.start.page);e=I.rectToXY(a)}e=e||{x:0,y:0},o.offset={top:e.y+r.top,left:e.x+r.left,bottom:e.y-r.bottom,right:e.x-r.right}},set:function(t){var e=t.coords,n=t.edges,r=t.interaction,o=t.state,i=o.offset,a=o.options;if(n){var s=(0,k.default)({},e),l=(0,Xr.getRestrictionRect)(a.inner,r,s)||{},u=(0,Xr.getRestrictionRect)(a.outer,r,s)||{};qr(l,Ur),qr(u,Vr),n.top?e.y=Math.min(Math.max(u.top+i.top,s.y),l.top+i.top):n.bottom&&(e.y=Math.max(Math.min(u.bottom+i.bottom,s.y),l.bottom+i.bottom)),n.left?e.x=Math.min(Math.max(u.left+i.left,s.x),l.left+i.left):n.right&&(e.x=Math.max(Math.min(u.right+i.right,s.x),l.right+i.right))}},defaults:{inner:null,outer:null,offset:null,endOnly:!1,enabled:!1}};Br.restrictEdges=Nr;var $r=(0,De.makeModifier)(Nr,"restrictEdges");Br.default=$r;var Gr={};Object.defineProperty(Gr,"__esModule",{value:!0}),Gr.restrictRect=Gr.default=void 0;var Hr=(0,k.default)({get elementRect(){return{top:0,left:0,bottom:1,right:1}},set elementRect(t){}},Xr.restrict.defaults),Kr={start:Xr.restrict.start,set:Xr.restrict.set,defaults:Hr};Gr.restrictRect=Kr;var Zr=(0,De.makeModifier)(Kr,"restrictRect");Gr.default=Zr;var Jr={};Object.defineProperty(Jr,"__esModule",{value:!0}),Jr.restrictSize=Jr.default=void 0;var Qr={width:-1/0,height:-1/0},to={width:1/0,height:1/0};var eo={start:function(t){return Br.restrictEdges.start(t)},set:function(t){var e=t.interaction,n=t.state,r=t.rect,o=t.edges,i=n.options;if(o){var a=I.tlbrToXywh((0,Xr.getRestrictionRect)(i.min,e,t.coords))||Qr,s=I.tlbrToXywh((0,Xr.getRestrictionRect)(i.max,e,t.coords))||to;n.options={endOnly:i.endOnly,inner:(0,k.default)({},Br.restrictEdges.noInner),outer:(0,k.default)({},Br.restrictEdges.noOuter)},o.top?(n.options.inner.top=r.bottom-a.height,n.options.outer.top=r.bottom-s.height):o.bottom&&(n.options.inner.bottom=r.top+a.height,n.options.outer.bottom=r.top+s.height),o.left?(n.options.inner.left=r.right-a.width,n.options.outer.left=r.right-s.width):o.right&&(n.options.inner.right=r.left+a.width,n.options.outer.right=r.left+s.width),Br.restrictEdges.set(t),n.options=i}},defaults:{min:null,max:null,endOnly:!1,enabled:!1}};Jr.restrictSize=eo;var no=(0,De.makeModifier)(eo,"restrictSize");Jr.default=no;var ro={};Object.defineProperty(ro,"__esModule",{value:!0}),Object.defineProperty(ro,"default",{enumerable:!0,get:function(){return zr.default}});var oo={};Object.defineProperty(oo,"__esModule",{value:!0}),oo.snap=oo.default=void 0;var io={start:function(t){var e,n=t.interaction,r=t.interactable,o=t.element,i=t.rect,a=t.state,s=t.startOffset,l=a.options,u=l.offsetWithOrigin?function(t){var e=t.interaction.element;return(0,I.rectToXY)((0,I.resolveRectLike)(t.state.options.origin,null,null,[e]))||(0,z.default)(t.interactable,e,t.interaction.prepared.name)}(t):{x:0,y:0};if("startCoords"===l.offset)e={x:n.coords.start.page.x,y:n.coords.start.page.y};else{var c=(0,I.resolveRectLike)(l.offset,r,o,[n]);(e=(0,I.rectToXY)(c)||{x:0,y:0}).x+=u.x,e.y+=u.y}var f=l.relativePoints;a.offsets=i&&f&&f.length?f.map((function(t,n){return{index:n,relativePoint:t,x:s.left-i.width*t.x+e.x,y:s.top-i.height*t.y+e.y}})):[(0,k.default)({index:0,relativePoint:null},e)]},set:function(t){var e=t.interaction,n=t.coords,r=t.state,o=r.options,i=r.offsets,s=(0,z.default)(e.interactable,e.element,e.prepared.name),l=(0,k.default)({},n),u=[];o.offsetWithOrigin||(l.x-=s.x,l.y-=s.y);for(var c=0;c<i.length;c++)for(var f=i[c],d=l.x-f.x,p=l.y-f.y,v=0,h=o.targets.length;v<h;v++){var g=o.targets[v],y=void 0;(y=a.default.func(g)?g(d,p,e._proxy,f,v):g)&&u.push({x:(a.default.number(y.x)?y.x:d)+f.x,y:(a.default.number(y.y)?y.y:p)+f.y,range:a.default.number(y.range)?y.range:o.range,source:g,index:v,offset:f})}for(var m={target:null,inRange:!1,distance:0,range:0,delta:{x:0,y:0}},b=0;b<u.length;b++){var x=u[b],w=x.range,_=x.x-l.x,S=x.y-l.y,P=(0,F.default)(_,S),O=P<=w;w===1/0&&m.inRange&&m.range!==1/0&&(O=!1),m.target&&!(O?m.inRange&&w!==1/0?P/w<m.distance/m.range:w===1/0&&m.range!==1/0||P<m.distance:!m.inRange&&P<m.distance)||(m.target=x,m.distance=P,m.range=w,m.inRange=O,m.delta.x=_,m.delta.y=S)}return m.inRange&&(n.x=m.target.x,n.y=m.target.y),r.closest=m,m},defaults:{range:1/0,targets:null,offset:null,offsetWithOrigin:!0,origin:null,relativePoints:null,endOnly:!1,enabled:!1}};oo.snap=io;var ao=(0,De.makeModifier)(io,"snap");oo.default=ao;var so={};function lo(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(t)))return;var n=[],r=!0,o=!1,i=void 0;try{for(var a,s=t[Symbol.iterator]();!(r=(a=s.next()).done)&&(n.push(a.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{r||null==s.return||s.return()}finally{if(o)throw i}}return n}(t,e)||function(t,e){if(!t)return;if("string"==typeof t)return uo(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return uo(t,e)}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function uo(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=Array(e);n<e;n++)r[n]=t[n];return r}Object.defineProperty(so,"__esModule",{value:!0}),so.snapSize=so.default=void 0;var co={start:function(t){var e=t.state,n=t.edges,r=e.options;if(!n)return null;t.state={options:{targets:null,relativePoints:[{x:n.left?0:1,y:n.top?0:1}],offset:r.offset||"self",origin:{x:0,y:0},range:r.range}},e.targetFields=e.targetFields||[["width","height"],["x","y"]],oo.snap.start(t),e.offsets=t.state.offsets,t.state=e},set:function(t){var e=t.interaction,n=t.state,r=t.coords,o=n.options,i=n.offsets,s={x:r.x-i[0].x,y:r.y-i[0].y};n.options=(0,k.default)({},o),n.options.targets=[];for(var l=0;l<(o.targets||[]).length;l++){var u=(o.targets||[])[l],c=void 0;if(c=a.default.func(u)?u(s.x,s.y,e):u){for(var f=0;f<n.targetFields.length;f++){var d=lo(n.targetFields[f],2),p=d[0],v=d[1];if(p in c||v in c){c.x=c[p],c.y=c[v];break}}n.options.targets.push(c)}}var h=oo.snap.set(t);return n.options=o,h},defaults:{range:1/0,targets:null,offset:null,endOnly:!1,enabled:!1}};so.snapSize=co;var fo=(0,De.makeModifier)(co,"snapSize");so.default=fo;var po={};Object.defineProperty(po,"__esModule",{value:!0}),po.snapEdges=po.default=void 0;var vo={start:function(t){var e=t.edges;return e?(t.state.targetFields=t.state.targetFields||[[e.left?"left":"right",e.top?"top":"bottom"]],so.snapSize.start(t)):null},set:so.snapSize.set,defaults:(0,k.default)((0,Pe.default)(so.snapSize.defaults),{targets:null,range:null,offset:{x:0,y:0}})};po.snapEdges=vo;var ho=(0,De.makeModifier)(vo,"snapEdges");po.default=ho;var go={};Object.defineProperty(go,"__esModule",{value:!0}),Object.defineProperty(go,"default",{enumerable:!0,get:function(){return zr.default}});var yo={};Object.defineProperty(yo,"__esModule",{value:!0}),Object.defineProperty(yo,"default",{enumerable:!0,get:function(){return zr.default}});var mo={};Object.defineProperty(mo,"__esModule",{value:!0}),mo.default=void 0;var bo={aspectRatio:Er.default,restrictEdges:Br.default,restrict:Xr.default,restrictRect:Gr.default,restrictSize:Jr.default,snapEdges:po.default,snap:oo.default,snapSize:so.default,spring:go.default,avoid:Fr.default,transform:yo.default,rubberband:ro.default};mo.default=bo;var xo={};Object.defineProperty(xo,"__esModule",{value:!0}),xo.default=void 0;var wo={id:"modifiers",install:function(t){var e=t.interactStatic;for(var n in t.usePlugin(De.default),t.usePlugin(Pr.default),e.modifiers=mo.default,mo.default){var r=mo.default[n],o=r._defaults,i=r._methods;o._methods=i,t.defaults.perAction[n]=o}}};xo.default=wo;var _o={};Object.defineProperty(_o,"__esModule",{value:!0}),_o.default=void 0;_o.default={};var So={};function Po(t){return(Po="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Oo(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function Eo(t,e){return(Eo=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function To(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=ko(t);if(e){var o=ko(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return Mo(this,n)}}function Mo(t,e){return!e||"object"!==Po(e)&&"function"!=typeof e?jo(t):e}function jo(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function ko(t){return(ko=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}Object.defineProperty(So,"__esModule",{value:!0}),So.PointerEvent=So.default=void 0;var Io=function(t){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Eo(t,e)}(i,t);var e,n,r,o=To(i);function i(t,e,n,r,a,s){var l;if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(l=o.call(this,a)).type=void 0,l.originalEvent=void 0,l.pointerId=void 0,l.pointerType=void 0,l.double=void 0,l.pageX=void 0,l.pageY=void 0,l.clientX=void 0,l.clientY=void 0,l.dt=void 0,l.eventable=void 0,L.pointerExtend(jo(l),n),n!==e&&L.pointerExtend(jo(l),e),l.timeStamp=s,l.originalEvent=n,l.type=t,l.pointerId=L.getPointerId(e),l.pointerType=L.getPointerType(e),l.target=r,l.currentTarget=null,"tap"===t){var u=a.getPointerIndex(e);l.dt=l.timeStamp-a.pointers[u].downTime;var c=l.timeStamp-a.tapTime;l.double=!!(a.prevTap&&"doubletap"!==a.prevTap.type&&a.prevTap.target===l.target&&c<500)}else"doubletap"===t&&(l.dt=e.timeStamp-a.tapTime);return l}return e=i,(n=[{key:"_subtractOrigin",value:function(t){var e=t.x,n=t.y;return this.pageX-=e,this.pageY-=n,this.clientX-=e,this.clientY-=n,this}},{key:"_addOrigin",value:function(t){var e=t.x,n=t.y;return this.pageX+=e,this.pageY+=n,this.clientX+=e,this.clientY+=n,this}},{key:"preventDefault",value:function(){this.originalEvent.preventDefault()}}])&&Oo(e.prototype,n),r&&Oo(e,r),i}(G.default);So.PointerEvent=So.default=Io;var Do={};Object.defineProperty(Do,"__esModule",{value:!0}),Do.default=void 0;var Ao={id:"pointer-events/base",before:["inertia","modifiers","auto-start","actions"],install:function(t){t.pointerEvents=Ao,t.defaults.actions.pointerEvents=Ao.defaults,(0,k.default)(t.actions.phaselessTypes,Ao.types)},listeners:{"interactions:new":function(t){var e=t.interaction;e.prevTap=null,e.tapTime=0},"interactions:update-pointer":function(t){var e=t.down,n=t.pointerInfo;if(!e&&n.hold)return;n.hold={duration:1/0,timeout:null}},"interactions:move":function(t,e){var n=t.interaction,r=t.pointer,o=t.event,i=t.eventTarget,a=t.duplicate,s=n.getPointerIndex(r);a||n.pointerIsDown&&!n.pointerWasMoved||(n.pointerIsDown&&clearTimeout(n.pointers[s].hold.timeout),zo({interaction:n,pointer:r,event:o,eventTarget:i,type:"move"},e))},"interactions:down":function(t,e){!function(t,e){for(var n=t.interaction,r=t.pointer,o=t.event,i=t.eventTarget,a=t.pointerIndex,s=n.pointers[a].hold,l=S.getPath(i),u={interaction:n,pointer:r,event:o,eventTarget:i,type:"hold",targets:[],path:l,node:null},c=0;c<l.length;c++){var f=l[c];u.node=f,e.fire("pointerEvents:collect-targets",u)}if(!u.targets.length)return;for(var d=1/0,p=0;p<u.targets.length;p++){var v=u.targets[p].eventable.options.holdDuration;v<d&&(d=v)}s.duration=d,s.timeout=setTimeout((function(){zo({interaction:n,eventTarget:i,pointer:r,event:o,type:"hold"},e)}),d)}(t,e),zo(t,e)},"interactions:up":function(t,e){Ro(t),zo(t,e),function(t,e){var n=t.interaction,r=t.pointer,o=t.event,i=t.eventTarget;n.pointerWasMoved||zo({interaction:n,eventTarget:i,pointer:r,event:o,type:"tap"},e)}(t,e)},"interactions:cancel":function(t,e){Ro(t),zo(t,e)}},PointerEvent:So.PointerEvent,fire:zo,collectEventTargets:Co,defaults:{holdDuration:600,ignoreFrom:null,allowFrom:null,origin:{x:0,y:0}},types:{down:!0,move:!0,up:!0,cancel:!0,tap:!0,doubletap:!0,hold:!0}};function zo(t,e){var n=t.interaction,r=t.pointer,o=t.event,i=t.eventTarget,a=t.type,s=t.targets,l=void 0===s?Co(t,e):s,u=new So.PointerEvent(a,r,o,i,n,e.now());e.fire("pointerEvents:new",{pointerEvent:u});for(var c={interaction:n,pointer:r,event:o,eventTarget:i,targets:l,type:a,pointerEvent:u},f=0;f<l.length;f++){var d=l[f];for(var p in d.props||{})u[p]=d.props[p];var v=(0,z.default)(d.eventable,d.node);if(u._subtractOrigin(v),u.eventable=d.eventable,u.currentTarget=d.node,d.eventable.fire(u),u._addOrigin(v),u.immediatePropagationStopped||u.propagationStopped&&f+1<l.length&&l[f+1].node!==u.currentTarget)break}if(e.fire("pointerEvents:fired",c),"tap"===a){var h=u.double?zo({interaction:n,pointer:r,event:o,eventTarget:i,type:"doubletap"},e):u;n.prevTap=h,n.tapTime=h.timeStamp}return u}function Co(t,e){var n=t.interaction,r=t.pointer,o=t.event,i=t.eventTarget,a=t.type,s=n.getPointerIndex(r),l=n.pointers[s];if("tap"===a&&(n.pointerWasMoved||!l||l.downTarget!==i))return[];for(var u=S.getPath(i),c={interaction:n,pointer:r,event:o,eventTarget:i,type:a,path:u,targets:[],node:null},f=0;f<u.length;f++){var d=u[f];c.node=d,e.fire("pointerEvents:collect-targets",c)}return"hold"===a&&(c.targets=c.targets.filter((function(t){return t.eventable.options.holdDuration===n.pointers[s].hold.duration}))),c.targets}function Ro(t){var e=t.interaction,n=t.pointerIndex;e.pointers[n].hold&&clearTimeout(e.pointers[n].hold.timeout)}var Fo=Ao;Do.default=Fo;var Xo={};function Yo(t){var e=t.interaction;e.holdIntervalHandle&&(clearInterval(e.holdIntervalHandle),e.holdIntervalHandle=null)}Object.defineProperty(Xo,"__esModule",{value:!0}),Xo.default=void 0;var Wo={id:"pointer-events/holdRepeat",install:function(t){t.usePlugin(Do.default);var e=t.pointerEvents;e.defaults.holdRepeatInterval=0,e.types.holdrepeat=t.actions.phaselessTypes.holdrepeat=!0},listeners:["move","up","cancel","endall"].reduce((function(t,e){return t["pointerEvents:".concat(e)]=Yo,t}),{"pointerEvents:new":function(t){var e=t.pointerEvent;"hold"===e.type&&(e.count=(e.count||0)+1)},"pointerEvents:fired":function(t,e){var n=t.interaction,r=t.pointerEvent,o=t.eventTarget,i=t.targets;if("hold"===r.type&&i.length){var a=i[0].eventable.options.holdRepeatInterval;a<=0||(n.holdIntervalHandle=setTimeout((function(){e.pointerEvents.fire({interaction:n,eventTarget:o,type:"hold",pointer:r,event:r},e)}),a))}}})};Xo.default=Wo;var Lo={};function Bo(t){return(0,k.default)(this.events.options,t),this}Object.defineProperty(Lo,"__esModule",{value:!0}),Lo.default=void 0;var Uo={id:"pointer-events/interactableTargets",install:function(t){var e=t.Interactable;e.prototype.pointerEvents=Bo;var n=e.prototype._backCompatOption;e.prototype._backCompatOption=function(t,e){var r=n.call(this,t,e);return r===this&&(this.events.options[t]=e),r}},listeners:{"pointerEvents:collect-targets":function(t,e){var n=t.targets,r=t.node,o=t.type,i=t.eventTarget;e.interactables.forEachMatch(r,(function(t){var e=t.events,a=e.options;e.types[o]&&e.types[o].length&&t.testIgnoreAllow(a,r,i)&&n.push({node:r,eventable:e,props:{interactable:t}})}))},"interactable:new":function(t){var e=t.interactable;e.events.getRect=function(t){return e.getRect(t)}},"interactable:set":function(t,e){var n=t.interactable,r=t.options;(0,k.default)(n.events.options,e.pointerEvents.defaults),(0,k.default)(n.events.options,r.pointerEvents||{})}}};Lo.default=Uo;var Vo={};Object.defineProperty(Vo,"__esModule",{value:!0}),Object.defineProperty(Vo,"holdRepeat",{enumerable:!0,get:function(){return Xo.default}}),Object.defineProperty(Vo,"interactableTargets",{enumerable:!0,get:function(){return Lo.default}}),Vo.pointerEvents=Vo.default=void 0,Vo.pointerEvents=Do;var qo={id:"pointer-events",install:function(t){t.usePlugin(Do),t.usePlugin(Xo.default),t.usePlugin(Lo.default)}};Vo.default=qo;var No={};Object.defineProperty(No,"__esModule",{value:!0}),No.default=void 0;No.default={};var $o={};function Go(t){var e=t.Interactable;t.actions.phases.reflow=!0,e.prototype.reflow=function(e){return function(t,e,n){for(var r=a.default.string(t.target)?J.from(t._context.querySelectorAll(t.target)):[t.target],o=n.window.Promise,i=o?[]:null,s=function(){var a=r[l],s=t.getRect(a);if(!s)return"break";var u=J.find(n.interactions.list,(function(n){return n.interacting()&&n.interactable===t&&n.element===a&&n.prepared.name===e.name})),c=void 0;if(u)u.move(),i&&(c=u._reflowPromise||new o((function(t){u._reflowResolve=t})));else{var f=(0,I.tlbrToXywh)(s),d={page:{x:f.x,y:f.y},client:{x:f.x,y:f.y},timeStamp:n.now()},p=L.coordsToEvent(d);c=function(t,e,n,r,o){var i=t.interactions.new({pointerType:"reflow"}),a={interaction:i,event:o,pointer:o,eventTarget:n,phase:"reflow"};i.interactable=e,i.element=n,i.prepared=(0,k.default)({},r),i.prevEvent=o,i.updatePointer(o,o,n,!0),i._doPhase(a);var s=t.window.Promise,l=s?new s((function(t){i._reflowResolve=t})):null;i._reflowPromise=l,i.start(r,e,n),i._interacting?(i.move(a),i.end(o)):i.stop();return i.removePointer(o,o),i.pointerIsDown=!1,l}(n,t,a,e,p)}i&&i.push(c)},l=0;l<r.length;l++){if("break"===s())break}return i&&o.all(i).then((function(){return t}))}(this,e,t)}}Object.defineProperty($o,"__esModule",{value:!0}),$o.install=Go,$o.default=void 0;var Ho={id:"reflow",install:Go,listeners:{"interactions:stop":function(t,e){var n=t.interaction;"reflow"===n.pointerType&&(n._reflowResolve&&n._reflowResolve(),J.remove(e.interactions.list,n))}}};$o.default=Ho;var Ko={};Object.defineProperty(Ko,"__esModule",{value:!0}),Ko.default=void 0;Ko.default={};var Zo={};Object.defineProperty(Zo,"__esModule",{value:!0}),Zo.exchange=void 0;Zo.exchange={};var Jo={};Object.defineProperty(Jo,"__esModule",{value:!0}),Jo.default=void 0;Jo.default={};var Qo={exports:{}};function ti(t){return(ti="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}Object.defineProperty(Qo.exports,"__esModule",{value:!0}),Qo.exports.default=void 0,pr.default.use(_o.default),pr.default.use(ue.default),pr.default.use(tn.default),pr.default.use(le.default),pr.default.use(jt.default),pr.default.use(Vo.default),pr.default.use(ln.default),pr.default.use(xo.default),pr.default.use(ae.default),pr.default.use(Tt.default),pr.default.use(Ct.default),pr.default.use($o.default),pr.default.use(Se.default),pr.default.use(Jo.default),pr.default.use(No.default),pr.default.__utils={exchange:Zo.exchange,displace:Ko,pointer:L},pr.default.use(he.default);var ei=pr.default;if(Qo.exports.default=ei,"object"===ti(Qo)&&Qo)try{Qo.exports=pr.default}catch(t){}pr.default.default=pr.default,Qo=Qo.exports;var ni={exports:{}};function ri(t){return(ri="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}Object.defineProperty(ni.exports,"__esModule",{value:!0}),ni.exports.default=void 0;var oi=Qo.default;if(ni.exports.default=oi,"object"===ri(ni)&&ni)try{ni.exports=Qo.default}catch(t){}return Qo.default.default=Qo.default,ni=ni.exports}));
//# sourceMappingURL=interact.min.js.map

!function(e){function n(r){if(t[r])return t[r].exports;var a=t[r]={exports:{},id:r,loaded:!1};return e[r].call(a.exports,a,a.exports,n),a.loaded=!0,a.exports}var t={};n.m=e,n.c=t,n.p="",n(0)}([function(e,n,t){"use strict";t(1),t(2),t(13),t(14)},function(e,n){"use strict";"function"!=typeof Object.create&&(Object.create=function(){var e=function(){};return function(n){if(arguments.length>1)throw new Error("Second argument not supported");if(n!==Object(n)&&null!==n)throw new TypeError("Argument must be an object or null");if(null===n)throw Error("null [[Prototype]] not supported");e.prototype=n;var t=new e;return e.prototype=null,t}}()),Array.prototype.map||(Array.prototype.map=function(e,n){var t,r,a;if(null==this)throw new TypeError(" this is null or not defined");var s=Object(this),o=s.length>>>0;if("function"!=typeof e)throw new TypeError(e+" is not a function");for(arguments.length>1&&(t=n),r=new Array(o),a=0;a<o;){var c,i;a in s&&(c=s[a],i=e.call(t,c,a,s),r[a]=i),a++}return r})},function(e,n,t){"use strict";var r=t(3),a=t(4),s=t(5),o=t(9);angular.module("pubnub.angular.service",[]).factory("Pubnub",["$rootScope",function(e){if("undefined"==typeof PUBNUB&&"undefined"==typeof PubNub)throw new Error("PUBNUB is not in global scope. Ensure that pubnub.js file is included before pubnub-angular.js");var n={},t={};return n.getPubNubVersion=function(){return"undefined"==typeof PUBNUB?"4":"3"},n.init=function(e){return n.getInstance(r.default_instance_name).init(e)},n.getInstance=function(r){var c=t[r];return angular.isDefined(c)&&c instanceof a?c:"string"==typeof r&&r.length>0?("3"===this.getPubNubVersion()?t[r]=new s(r,n,e):"4"===this.getPubNubVersion()&&(t[r]=new o(r,n,e)),t[r]):c},n.getEventNameFor=function(e,n){var t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:r.default_instance_name;return[r.pubnub_prefix,t,e,n].join(":")},n.getMessageEventNameFor=function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:r.default_instance_name;return[r.pubnub_prefix,n,"subscribe","callback",e].join(":")},n.getPresenceEventNameFor=function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:r.default_instance_name;return[r.pubnub_prefix,n,"subscribe","presence",e].join(":")},n.subscribe=function(e){this.getInstance(r.default_instance_name).subscribe(e)},n}])},function(e,n){e.exports={pubnub_prefix:"pubnub",default_instance_name:"default"}},function(e,n,t){"use strict";function r(e,n){if(!(e instanceof n))throw new TypeError("Cannot call a class as a function")}var a=function(){function e(e,n){for(var t=0;t<n.length;t++){var r=n[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(n,t,r){return t&&e(n.prototype,t),r&&e(n,r),n}}(),s=t(3);e.exports=function(){function e(n,t,a,o){var c=this;r(this,e),this.label=n,this.mockingInstance=null,this.pubnubInstance=null,o.methods_to_wrap.forEach(function(e){if(angular.isObject(e)){var n=Object.keys(e)[0],r=e[n];c[n]={},t[n]={},r.forEach(function(e){c.wrapMethod(e,n),t[n][e]=function(r,a){return t.getInstance(s.default_instance_name)[n][e](r,a)}})}else c.wrapMethod(e),t[e]=function(n,r){return t.getInstance(s.default_instance_name)[e](n,r)}}),o.methods_to_delegate.forEach(function(e){c[e]=function(){var n;return(n=c.getOriginalInstance())[e].apply(n,arguments)},t[e]=function(){var n;return(n=this.getInstance(s.default_instance_name))[e].apply(n,arguments)}})}return a(e,[{key:"getLabel",value:function(){return this.label}},{key:"getOriginalInstance",value:function(){if(this.pubnubInstance)return this.pubnubInstance;throw new ReferenceError("Pubnub default instance is not initialized yet. Invoke #init() method first.")}}]),e}()},function(e,n,t){"use strict";function r(e,n){if(!(e instanceof n))throw new TypeError("Cannot call a class as a function")}function a(e,n){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!=typeof n&&"function"!=typeof n?e:n}function s(e,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+typeof n);e.prototype=Object.create(n&&n.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),n&&(Object.setPrototypeOf?Object.setPrototypeOf(e,n):e.__proto__=n)}var o=function(){function e(e,n){for(var t=0;t<n.length;t++){var r=n[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(n,t,r){return t&&e(n.prototype,t),r&&e(n,r),n}}(),c=t(4),i=t(6),u=t(8);e.exports=function(e){function n(e,t,s){r(this,n);var o=a(this,(n.__proto__||Object.getPrototypeOf(n)).call(this,e,t,s,u));return o.mockingInstance=new i(e,t,s),o}return s(n,e),o(n,[{key:"init",value:function(e){this.pubnubInstance=new PUBNUB(e)}},{key:"subscribe",value:function(e){var n=this.mockingInstance.getCallbacksToMock(e,u.subscribe_callbacks_to_wrap);this.mockingInstance.mockCallbacks(this.getLabel(),"subscribe",e,n),this.getOriginalInstance().subscribe(e)}},{key:"wrapMethod",value:function(e){var n=this;this[e]=function(t){if(angular.isObject(t)){var r=n.mockingInstance.getCallbacksToMock(t,u.common_callbacks_to_wrap);n.mockingInstance.mockCallbacks(n.getLabel(),e,t,r)}return n.getOriginalInstance()[e](t)}}}]),n}(c)},function(e,n,t){"use strict";function r(e){if(Array.isArray(e)){for(var n=0,t=Array(e.length);n<e.length;n++)t[n]=e[n];return t}return Array.from(e)}function a(e,n){if(!(e instanceof n))throw new TypeError("Cannot call a class as a function")}function s(e,n){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!=typeof n&&"function"!=typeof n?e:n}function o(e,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+typeof n);e.prototype=Object.create(n&&n.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),n&&(Object.setPrototypeOf?Object.setPrototypeOf(e,n):e.__proto__=n)}var c=function(){function e(e,n){for(var t=0;t<n.length;t++){var r=n[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(n,t,r){return t&&e(n.prototype,t),r&&e(n,r),n}}(),i=t(7);e.exports=function(e){function n(){return a(this,n),s(this,(n.__proto__||Object.getPrototypeOf(n)).apply(this,arguments))}return o(n,e),c(n,[{key:"generateMockedVersionOfCallback",value:function(e,n,t,a,s){var o=this.$rootScope,c=this.service,i=s.channel||s.channel_group;return function(){var s,u,l;if((s=o.$broadcast).bind.apply(s,r([o,c.getEventNameFor(t,n,a)].concat(Array.prototype.slice.call(arguments))))(),n&&angular.isFunction(e)&&e.apply(void 0,arguments),"subscribe"===t)switch(n){case"callback":(u=o.$broadcast).bind.apply(u,r([o,c.getMessageEventNameFor(i,a)].concat(Array.prototype.slice.call(arguments))))();break;case"presence":(l=o.$broadcast).bind.apply(l,r([o,c.getPresenceEventNameFor(i,a)].concat(Array.prototype.slice.call(arguments))))()}}}},{key:"mockCallbacks",value:function(e,n,t,r){var a=void 0,s=void 0,o=r.length,c=void 0;for(c=0;c<o;c+=1){if(!angular.isObject(t))return;s=r[c],a=t[s],t[s]=this.generateMockedVersionOfCallback(a,s,n,e,t)}}}]),n}(i)},function(e,n){"use strict";function t(e,n){if(!(e instanceof n))throw new TypeError("Cannot call a class as a function")}var r=function(){function e(e,n){for(var t=0;t<n.length;t++){var r=n[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(n,t,r){return t&&e(n.prototype,t),r&&e(n,r),n}}();e.exports=function(){function e(n,r,a){t(this,e),this.label=n,this.$rootScope=a,this.service=r}return r(e,[{key:"getCallbacksToMock",value:function(e,n){var t=e.triggerEvents,r=[],a=void 0,s=void 0,o=void 0;if(!0===t)return n;if(angular.isObject(t)){for(a=t.length,o=0;o<a;o+=1)s=t[o],n.indexOf(s)>=0&&r.push(s);return r}return[]}}]),e}()},function(e,n){e.exports={methods_to_delegate:["replay","unsubscribe","revoke","audit","time","channel_group","channel_group_list_groups","channel_group_list_namespaces","channel_group_remove_namespace","channel_group_cloak","get_subscribed_channels","set_uuid","get_uuid","auth","set_cipher_key","get_cipher_key","raw_encrypt","raw_decrypt","set_heartbeat","get_heartbeat","set_heartbeat_interval","get_heartbeat_interval"],methods_to_wrap:["here_now","history","publish","fire","here_now","where_now","state","grant","revoke","channel_group_add_channel","channel_group_list_channels","channel_group_remove_channel","channel_group_remove_group","mobile_gw_provision"],subscribe_callbacks_to_wrap:["callback","connect","reconnect","disconnect","error","idle","presence"],common_callbacks_to_wrap:["callback","error"]}},function(e,n,t){"use strict";function r(e,n){if(!(e instanceof n))throw new TypeError("Cannot call a class as a function")}function a(e,n){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!=typeof n&&"function"!=typeof n?e:n}function s(e,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+typeof n);e.prototype=Object.create(n&&n.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),n&&(Object.setPrototypeOf?Object.setPrototypeOf(e,n):e.__proto__=n)}var o=function(){function e(e,n){for(var t=0;t<n.length;t++){var r=n[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(n,t,r){return t&&e(n.prototype,t),r&&e(n,r),n}}(),c=t(4),i=t(10),u=t(11),l=t(12);e.exports=function(e){function n(e,t,s){r(this,n);var o=a(this,(n.__proto__||Object.getPrototypeOf(n)).call(this,e,t,s,l));return o.mockingInstance=new i(e,t,s),o.subscribeEventsBroadcaster=new u(e,t,s,o),o}return s(n,e),o(n,[{key:"init",value:function(e){this.pubnubInstance=new PubNub(e)}},{key:"subscribe",value:function(e){var n=this.mockingInstance.getCallbacksToMock(e,l.subscribe_listener_events_to_broadcast);this.subscribeEventsBroadcaster.enableEventsBroadcast(n,e),this.getOriginalInstance().subscribe(e)}},{key:"wrapMethod",value:function(e,n){var t=this;void 0!==n?this[n][e]=function(r,a){if(angular.isObject(r)){if(t.mockingInstance.getCallbacksToMock(r,l.common_callbacks_to_wrap).length>0){var s=n+"."+e;a=t.mockingInstance.generateMockedVersionOfCallback(a,"callback",s,t.getLabel())}}return t.getOriginalInstance()[n][e](r,a)}:this[e]=function(n,r){if(angular.isObject(n)){t.mockingInstance.getCallbacksToMock(n,l.common_callbacks_to_wrap).length>0&&(r=t.mockingInstance.generateMockedVersionOfCallback(r,"callback",e,t.getLabel()))}return t.getOriginalInstance()[e](n,r)}}}]),n}(c)},function(e,n,t){"use strict";function r(e){if(Array.isArray(e)){for(var n=0,t=Array(e.length);n<e.length;n++)t[n]=e[n];return t}return Array.from(e)}function a(e,n){if(!(e instanceof n))throw new TypeError("Cannot call a class as a function")}function s(e,n){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!=typeof n&&"function"!=typeof n?e:n}function o(e,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+typeof n);e.prototype=Object.create(n&&n.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),n&&(Object.setPrototypeOf?Object.setPrototypeOf(e,n):e.__proto__=n)}var c=function(){function e(e,n){for(var t=0;t<n.length;t++){var r=n[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(n,t,r){return t&&e(n.prototype,t),r&&e(n,r),n}}(),i=t(7);e.exports=function(e){function n(){return a(this,n),s(this,(n.__proto__||Object.getPrototypeOf(n)).apply(this,arguments))}return o(n,e),c(n,[{key:"generateMockedVersionOfCallback",value:function(e,n,t,a){var s=this.$rootScope,o=this.service;return function(){var c;(c=s.$broadcast).bind.apply(c,r([s,o.getEventNameFor(t,n,a)].concat(Array.prototype.slice.call(arguments))))(),n&&angular.isFunction(e)&&e.apply(void 0,arguments)}}}]),n}(i)},function(e,n){"use strict";function t(e,n){if(!(e instanceof n))throw new TypeError("Cannot call a class as a function")}var r=function(){function e(e,n){for(var t=0;t<n.length;t++){var r=n[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(n,t,r){return t&&e(n.prototype,t),r&&e(n,r),n}}();e.exports=function(){function e(n,r,a,s){t(this,e),this.wrapper=s,this.label=n,this.$rootScope=a,this.service=r,this.broadcastStatus=!1,this.broadcastedChannels={},this.broadcastedPresenceChannels={},this.subscribeListener=null}return r(e,[{key:"initializeSubscribeListener",value:function(){var e=this.$rootScope,n=this.service,t=this;this.subscribeListener=this.service.getInstance(this.label).addListener({message:function(r){(r.subscription&&t.broadcastedChannels[r.subscription]||r.channel&&t.broadcastedChannels[r.channel])&&e.$broadcast.bind.apply(e.$broadcast,[e,n.getMessageEventNameFor(r.subscribedChannel,t.label)].concat(Array.prototype.slice.call(arguments)))()},presence:function(r){var a=null;null!==r.subscription&&t.broadcastedPresenceChannels[r.subscription]?a=r.subscription:null!==r.channel&&t.broadcastedPresenceChannels[r.channel]&&(a=r.channel),null!==a&&e.$broadcast.bind.apply(e.$broadcast,[e,n.getPresenceEventNameFor(a,t.label)].concat(Array.prototype.slice.call(arguments)))()},status:function(){if(t.broadcastStatus){var e=t.service.getEventNameFor("subscribe","status",t.label);t.$rootScope.$broadcast.bind.apply(t.$rootScope.$broadcast,[t.$rootScope,e].concat(Array.prototype.slice.call(arguments)))()}}})}},{key:"enableEventsBroadcast",value:function(e,n){var t=this,r=[];return!!n.triggerEvents&&(r=!0===n.triggerEvents?["status","message","presence"]:n.triggerEvents,e.forEach(function(e){"status"===e&&r.includes("status")&&(t.broadcastStatus=!0),"message"===e&&r.includes("message")&&(n.channels&&n.channels.length>0&&n.channels.forEach(function(e){"-pnpres"!==e.slice(-7)&&(t.broadcastedChannels[e]=!0)}),n.channelGroups&&n.channelGroups.length>0&&n.channelGroups.forEach(function(e){"-pnpres"!==e.slice(-7)&&(t.broadcastedChannels[e]=!0)})),"presence"===e&&r.includes("presence")&&(n.withPresence?(n.channels&&n.channels.length>0&&n.channels.forEach(function(e){return t.broadcastedPresenceChannels[e]=!0}),n.channelGroups&&n.channelGroups&&n.channelGroups.forEach(function(e){return t.broadcastedPresenceChannels[e]=!0})):(n.channels&&n.channels.length>0&&n.channels.forEach(function(e){"-pnpres"===e.slice(-7)&&(t.broadcastedPresenceChannels[e.slice(0,-7)]=!0)}),n.channelGroups&&n.channelGroups&&n.channelGroups.forEach(function(e){"-pnpres"===e.slice(-7)&&(t.broadcastedPresenceChannels[e.slice(0,-7)]=!0)})))}),null===this.subscribeListener&&this.initializeSubscribeListener(),!0)}}]),e}()},function(e,n){e.exports={methods_to_delegate:["setUUID","getUUID","setAuthKey","addListener","removeListener","unsubscribe","unsubscribeAll","time","stop","encrypt","reconnect","decrypt","setFilterExpression","setHeartbeatInterval"],methods_to_wrap:["publish","fire","deleteMessages","fetchMessages","hereNow","whereNow","setState","getState","grant","history",{push:["addChannels","deleteDevice","listChannels","removeChannels"]},{channelGroups:["addChannels","deleteGroup","listChannels","listGroups","removeChannels"]}],common_callbacks_to_wrap:["callback"],subscribe_listener_events_to_broadcast:["message","presence","status"]}},function(e,n,t){"use strict";var r=t(3);angular.module("pubnub.angular.service").factory("$pubnubChannel",["$rootScope","Pubnub","$q",function(e,n,t){function a(t){var s=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!(this instanceof a))return new a(t,s);if(!t)throw new Error("The channel name is required");if(s.autosubscribe&&"boolean"!=typeof s.autosubscribe)throw new Error("The autosubscribe parameter should be a boolean");if(s.presence&&"boolean"!=typeof s.presence)throw new Error("The presence parameter should be a boolean");if(s.autostore&&"boolean"!=typeof s.autostore)throw new Error("The autostore parameter should be a boolean");var o=this;this._channel=t,this.$messages=[],this._timeTokenFirstMessage=null,this._messagesAllFetched=!1,this._pubnubInstance=s.instance?n.getInstance(s.instance):n.getInstance(r.default_instance_name),this._autoload=null==s.autoload?0:s.autoload,this._presence=null!=s.presence&&s.presence,this._autosubscribe=null==s.autosubscribe||s.autosubscribe,this._autostore=null==s.autostore||s.autostore,this.$$getPublicMethods(function(e,n){o.$messages[n]=e.bind(o)}),this._unsubscribeHandler=null,0!==this._autoload&&this.$load(this._autoload);var c=null;if(c="3"===n.getPubNubVersion()?["callback","connect","reconnect","disconnect","error","idle"]:["status","message"],this._presence&&c.push("presence"),this._autosubscribe){var i={triggerEvents:c};"3"===n.getPubNubVersion()?(i.channel=this._channel,i.noheresync=!0):(i.channels=[this._channel],this._presence&&(i.withPresence=!0)),this._pubnubInstance.subscribe(i)}if(this._autostore){var u=n.getMessageEventNameFor(o._channel,this._pubnubInstance.label);this._unsubscribeHandler=e.$on(u,o.$$newMessage.bind(o))}return this.$messages}return a.prototype={$load:function(r){if(!(r>0&&r<=100))throw new Error("The number of messages to load should be a number between 0 and 100");var a=this,s=t.defer(),o={channel:a._channel,count:r,reverse:!1},c=null;return"3"===n.getPubNubVersion()?(o.callback=function(n){a._timeTokenFirstMessage=n[1],a.$$storeBatch(n[0]),n[0].length<r&&(a._messagesAllFetched=!0),s.resolve(n),e.$digest()},o.error=function(e){s.reject(e)}):c=function(n,t){n.error?s.reject(t):(a._timeTokenFirstMessage=t.startTimeToken,a.$$storeBatch(t.messages.map(function(e){return e.entry})),t.messages.length<r&&(a._messagesAllFetched=!0),s.resolve(t),e.$digest())},a._timeTokenFirstMessage&&(o.start=a._timeTokenFirstMessage),a._pubnubInstance.history(o,c),s.promise},$publish:function(e){var r=this,a=t.defer(),s={channel:r._channel,message:e},o=null;return"3"===n.getPubNubVersion()?(s.callback=function(e){a.resolve(e)},s.error=function(e){a.reject(e)}):o=function(e,n){e.error?a.reject(n):a.resolve(n)},r._pubnubInstance.publish(s,o),a.promise},$pubnubInstance:function(){return this._pubnubInstance},$channel:function(){return this._channel},$allLoaded:function(){return this._messagesAllFetched},$destroy:function(){this._unsubscribeHandler&&this._unsubscribeHandler(),this.$messages.length=0},$$newMessage:function(t,r){"3"===n.getPubNubVersion()?this.$$store(r):this.$$store(r.message),e.$digest()},$$store:function(e){this.$messages.push(e)},$$storeBatch:function(e){0===this.$messages.length?angular.extend(this.$messages,e):Array.prototype.unshift.apply(this.$messages,e)},$$getPublicMethods:function(e,n){this.$$getPrototypeMethods(function(t,r){"function"==typeof t&&"_"!==r.charAt(0)&&e.call(n,t,r)})},$$getPrototypeMethods:function(e,n){for(var t={},r=Object.getPrototypeOf({}),a=angular.isFunction(this)&&angular.isObject(this.prototype)?this.prototype:Object.getPrototypeOf(this);a&&a!==r;)Object.keys(a).forEach(function(r){({}).hasOwnProperty.call(a,r)&&!{}.hasOwnProperty.call(t,r)&&(t[r]=!0,e.call(n,a[r],r,a))}),a=Object.getPrototypeOf(a)}},a.$extend=function(e){if(!angular.isObject(e))throw new Error("The methods parameter should be an object");var n=function e(n,t){return this instanceof a?(a.apply(this,arguments),this.$messages):new e(n,t)};return n.prototype=Object.create(a.prototype),angular.extend(n.prototype,e),n},a}])},function(e,n,t){"use strict";var r=t(3);angular.module("pubnub.angular.service").factory("$pubnubChannelGroup",["$rootScope","$q","Pubnub","$pubnubChannel",function(e,n,t,a){function s(n,o){if(!(this instanceof s))return new s(n,o);var c=this,i=o||{};if(!n)throw new Error("The channel group name is required");if(i.autosubscribe&&"boolean"!=typeof i.autosubscribe)throw new Error("The autosubscribe parameter should be a boolean");if(i.presence&&"boolean"!=typeof i.presence)throw new Error("The presence parameter should be a boolean");if(i.channelExtension&&!angular.isObject(i.channelExtension))throw new Error("The channelExtension should be an object");this._channelGroup=n,this.$channels={},this._pubnubInstance=i.instance?t.getInstance(i.instance):t.getInstance(r.default_instance_name),this._presence=null!=i.presence&&i.presence,this._autosubscribe=null==i.autosubscribe||i.autosubscribe,this._extendedChannel=i.channelExtension?a.$extend(i.channelExtension):null,this._unsubscribeHandler=null;var u=null;if(u="3"===t.getPubNubVersion()?["callback","connect","reconnect","disconnect","error","idle"]:["status","message"],this._presence&&u.push("presence"),this._autosubscribe){var l={triggerEvents:u};"3"===t.getPubNubVersion()?l.channel_group=this._channelGroup:l.channelGroups=[this._channelGroup],this._pubnubInstance.subscribe(l)}var b=t.getMessageEventNameFor(c._channelGroup,c._pubnubInstance.label);return this._unsubscribeHandler=e.$on(b,c.$$newMessage.bind(c)),this}return s.prototype={$channel:function(e){if(!angular.isDefined(this.$channels[e])){var n={instance:this._pubnubInstance.label,autosubscribe:!1,presence:!1,autostore:!0},t=this._extendedChannel?new this._extendedChannel(e,n):a(e,n);this.$channels[e]=t}return this.$channels[e]},$pubnubInstance:function(){return this._pubnubInstance},$channelGroup:function(){return this._channelGroup},$destroy:function(){var e=this;this._unsubscribeHandler(),Object.keys(this.$channels).forEach(function(n){({}).hasOwnProperty.call(e.$channels,n)&&delete e.$channels[n]})},$$newMessage:function(e,n,r){var a=null;a="3"===t.getPubNubVersion()?r[3]:n.channel,this.$channel(a).$$newMessage(e,n,r)}},s}])}]);
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide, stConfig) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
	
	stConfig.pagination.template = 'app/theme/components/stPagination/pagination.html';
	
    /* baConfigProvider.changeTheme({blur: true});
    
    baConfigProvider.changeColors({
      default: 'rgba(#000000, 0.2)',
      defaultText: '#ffffff',
      dashboard: {
        white: '#ffffff',
      },
    }); */
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('RmsAppV2.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('RmsAppV2.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      $timeout(2000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 3000);

    //$rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';

    angular.module('RmsAppV2.pages.dashboard.controller', [])
        .controller('DashboardCtrl', DashboardCtrl)
        .controller('AnnouncementModalCtrl', AnnouncementModalCtrl);

    /** @ngInject */
    function DashboardCtrl($scope, $state, $filter, $timeout, Auth, baSidebarService, HttpSvc, RmsApi, toastr, $uibModal) {
        Auth.init();

        var vm = this;
        vm.dashBasic = {};
        vm.dashboardGeneralView = Auth.canViewDashboardGeneral();
        vm.dashboardAfterSalesView = Auth.canViewDashboardAfterSales();

        vm.hasPerm_PO = Auth.hasPerm('purchaseorders', 'ACCESS');
        vm.hasPerm_BBJ = Auth.hasPerm('bulkbreakjobs.bblist', 'ACCESS');
        vm.hasPerm_PJ = Auth.hasPerm('jobs.joblist', 'ACCESS');

        /* *********************************************************** */

        // Calendar Options
        vm.calendarOptions = {
            allDaySlot: false,
            defaultView: 'agendaWeek',
            header: {
                left: 'agendaDay,agendaWeek,month,year',
                center: 'title',
                right: 'today prev,next'
            },
            height: 'auto',
            minTime: '08:00:00',
            maxTime: '20:00:00',
            views: {
                agendaWeek: {
                    columnFormat: 'ddd D/M'
                }
            },
            events: {
                url: RmsApi.URL + 'dashboard/calendar',
                type: 'GET',
                data: {},
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("Authorization", "Basic " + Auth.getTokenId());
                },
                error: function () {
                    toastr.warning('Error loading Calendar events.');
                }
            },
            eventRender: function (event, element) {
                element.qtip({
                    content: {
                        title: event.title,
                        text: "<table>" +
                            "<tr><td colspan='3'><b><big>" + event.customerName + "</big></b></td></tr>" +
                            "<tr>" +
                            "<td>Equipment</td>" +
                            "<td>:</td>" +
                            "<td><b>" + event.equipmentName + "</b></td>" +
                            "</tr>" +
                            "<tr>" +
                            "<td>Technician</td>" +
                            "<td>:</td>" +
                            "<td><b>" + event.technicianName + "</b></td>" +
                            "</tr>" +
                            "<tr>" +
                            "<td>Task Name</td>" +
                            "<td>:</td>" +
                            "<td><b>" + event.processName + "</b></td>" +
                            "</tr>" +
                            "<tr>" +
                            "<td>Task Date</td>" +
                            "<td>:</td>" +
                            "<td><b>" + event.taskDate + "</b></td>" +
                            "</tr>" +
                            "</table>"
                    },
                    position: {
                        my: 'center right',
                        at: 'center left'
                    },
                    style: {
                        width: '300px'
                    }
                });
            }
        };

        vm.loadDashboardBasic = function () {
            HttpSvc.get('dashboard/basic', {}, Auth.getTokenId(), false)
                .then(function (result) {
                    vm.dashBasic = result;
                }, function () {
                    // Failed
                    toastr.error('Failed to retrieve data.', '');
                    return null;
                });
        }

        /* *********************************************************** */

        vm.displayDashboard = function () {
            // if(!vm.hasPerm_PO && !vm.hasPerm_BBJ & !vm.hasPerm_PJ)
            // {
            // 	vm.dashboardGeneralView = true;
            // 	vm.loadDashboardBasic();
            // }
            // else
            // {
            // 	vm.dashboardGeneralView = false;
            // }

            if (vm.dashboardGeneralView)
                vm.loadDashboardBasic();
        }

        /* *********************************************************** */

        // Call Action
        if (Auth.isLoggedIn()) {
            baSidebarService.setMenuCollapsed(true);

            vm.displayDashboard();

            // Check if the modal has already been shown in this session
            if (!Auth.isAnnouncementShown()) {
                Auth.markAnnouncementAsShown();

                HttpSvc.get('announcement/allActiveOnly', {}, Auth.getTokenId(), true)
                    .then(function (result) {
                        var seenAnnouncements = Auth.getSeenAnnouncements();
                        console.log("TESTING 1", seenAnnouncements);
                        var newAnnouncements = result.filter(function (announcement) {
                            return !seenAnnouncements.includes(announcement.id);
                        });
                        console.log("TESTING 2", newAnnouncements);

                        if (newAnnouncements.length > 0) {
                            $uibModal.open({
                                templateUrl: 'announcementModal.html',
                                controller: 'AnnouncementModalCtrl',
                                controllerAs: '$mdl',
                                resolve: {
                                    announcements: function () {
                                        return newAnnouncements;
                                    }
                                }
                            });
                        }

                    }, function (error) {
                        toastr.error("Failed to retrieve announcement list.", "Failed");
                    });

            }
        }
    }

    /** @ngInject */
    function AnnouncementModalCtrl($uibModalInstance, announcements, Auth, HttpSvc, toastr, $filter) {
        var $mdl = this;

        $mdl.announcements = announcements;
        $mdl.isLoading = false;

        /* *************************************************** */

        // Function to format the date
        $mdl.formatDate = function (dateString) {
            if (!dateString) return "";
            var date = new Date(dateString);
            return $filter('date')(date, 'yyyy-MM-dd');
        };

        // Mark new announcements as seen
        $mdl.announcements.forEach(function (announcement) {
            Auth.markAnnouncementAsSeen(announcement.id);
        });

        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };

    };
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.duriandashboard.controller', [])
        .controller('DurianDashboardCtrl', DurianDashboardCtrl);

    /** @ngInject */
    function DurianDashboardCtrl($scope, $state, $filter, $timeout, Auth, baSidebarService, HttpSvc, RmsApi, toastr) {
		Auth.init();	
		
		var vm = this;
		
		// Call Action
		if(Auth.isLoggedIn()){
			baSidebarService.setMenuCollapsed(true);
		}
    }
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.iotlvdashboard.controller', [])
        .controller('IoTLvDashboardCtrl', IoTLvDashboardCtrl)
        .controller('IoTLvDashboardActionPaneCtrl', IoTLvDashboardActionPaneCtrl);

    /** @ngInject */
    function IoTLvDashboardCtrl($scope, $state, $interval, $timeout, $uibModal, Auth, Fullscreen, HttpSvc, RmsApi, toastr) {
      Auth.init();	
      
      var vm = this;
      var interval = null;

      vm.layoutList = [];
      vm.selectedLayout = null;
      vm.currentLayoutImage = null;
      vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
      vm.isLoading = false;
      
      /* ********************************************************* */

      vm.toggleFullscreen = function() {
        var element = document.getElementById('layoutParent');
  
        if(document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement ||
          document.msFullscreenElement)
        {
          document.exitFullscreen();
        }
        else
        {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullScreen) {
            element.msRequestFullScreen();
          }
        }			
      }
      
      $scope.$on('$destroy', function(){
        $interval.cancel(interval);
      });

      /* ********************************************************* */
      
      vm.loadAllLayouts = function() {
        vm.isLoading = true;

        HttpSvc.get('iotfloorviewdesigner/floorview/list', {}, Auth.getTokenId(), true)
          .then(function(result) {	
              vm.layoutList = result;
              if(vm.layoutList.length > 0)
              {
                vm.selectedLayout = vm.layoutList[0];
                vm.showLayout(vm.selectedLayout.id);
              }
              vm.isLoading = false;
          }, function() {
              vm.isLoading = false;
              toastr.error('Failed to retrieve data.', '');
              return null;
          });
      }
      
      vm.loadSingleLayout = function(designId) {
        vm.isLoading = true;
        HttpSvc.get('iotfloorviewdesigner/floorview/' + designId, {}, Auth.getTokenId(), false)
          .then(function(result) {	
              vm.selectedLayout = result;
              vm.processLayoutImage();
          }, function() {
              vm.isLoading = false;
              toastr.error('Failed to retrieve data.', '');
              return null;
          });
      }

      vm.showLayout = function(designId) {
        vm.loadSingleLayout(designId);

        $interval.cancel(interval);
        interval = $interval(vm.loadSingleLayout, 180000, 0, true, designId);
        // 3 minutes
      }

      vm.processLayoutImage = function() {
          if(!vm.selectedLayout.layoutImage || vm.selectedLayout.layoutImage=='') {
            vm.currentLayoutImage = 'assets/img/empty_placeholder_iotdesigner.jpg';
          } else {                  
            vm.currentLayoutImage = vm.rootUrl + vm.selectedLayout.layoutImage;
          }
          vm.isLoading = false;
      }

      /* ********************************************************* */

      vm.showAssetInfoPopup = function(object) {        
        object.tooltipIsOpen = true;  
        $timeout(function() { vm.loadAssetInfoInPopup(object) }, 500);
      }

      vm.loadAssetInfoInPopup = function(asset) {

      }

      vm.showSensorInfoPopup = function(object) {
        object.tooltipIsOpen = true;  
        $timeout(function() { vm.loadSensorInfoInPopup(object) }, 500);
      }

      vm.loadSensorInfoInPopup = function(sensor) {
        
        sensor.chart = {};

        HttpSvc.post('iothub/readinglasthour/'+ sensor.sensorId, {}, Auth.getTokenId(), false)
          .then(function(result) {	
            
            sensor.chart.labels = result.labels;
            sensor.chart.seriesT = result.seriesT;
            sensor.chart.seriesH = result.seriesH;
            sensor.chart.seriesAmp = result.seriesAmp;
            //sensor.chart.dangerZoneList = result.dangerZoneList;
            sensor.chart.suggestedMaxTemp = result.suggestedMaxTemp;
            sensor.chart.suggestedMinTemp = result.suggestedMinTemp;
            sensor.chart.suggestedMaxHumi = result.suggestedMaxHumi;
            sensor.chart.suggestedMinHumi = result.suggestedMinHumi;

            sensor.chart.hasTemp = result.hasTemp;
            sensor.chart.hasHumi = result.hasHumi;
            sensor.chart.hasElecMeter = result.hasElecMeter;

            sensor.chart.currentTemp = result.currentTemp;
            sensor.chart.currentHumi = result.currentHumi;
            sensor.chart.currentAmp = result.currentAmp;
            sensor.chart.currentBatt = result.currentBatt;
            sensor.chart.toAlert = result.toAlert;

            sensor.chart.colors = ['#0000FF', '#3D9400'];
            sensor.chart.seriesMain = ["Temperature", "Humidity"];
            sensor.chart.dataMain = [sensor.chart.seriesT, sensor.chart.seriesH];

            sensor.chart.colorsAmp = ['#FFB800'];
            sensor.chart.seriesAmp = ["Ampere"];
            sensor.chart.dataAmp = [sensor.chart.seriesAmp];

            sensor.chart.optionsMain = {
              scales: {
                yAxes: [
                  {
                    id: 'y-axis-1',
                    type: 'linear',
                    display: true,
                    position: 'left', 
                    ticks: {
                      suggestedMin: sensor.chart.suggestedMinTemp,
                      suggestedMax: sensor.chart.suggestedMaxTemp
                    }
                  },
                  {
                    id: 'y-axis-2',
                    type: 'linear',
                    display: ((sensor.chart.currentHumi!=0 && sensor.chart.currentHumi!=-1) ? true : false),
                    position: 'right', 
                    ticks: {
                      suggestedMin: sensor.chart.suggestedMinHumi,
                      suggestedMax: sensor.chart.suggestedMaxHumi
                    }
                  },
                ]
              },
              legend: {
                display: false,
                position: 'top'
              }
            };

            sensor.chart.optionsOther = {
              scales: {
                  yAxes: [
                  {
                    id: 'y-axis-1',
                    type: 'linear',
                    display: true,
                    position: 'left', 
                    ticks: {
                      //stepSize: 1,
                      suggestedMin: sensor.chart.suggestedMinAmp,
                      suggestedMax: sensor.chart.suggestedMaxAmp
                    }
                  }
                  ]
              },
              legend: {
                display: false,
                position: 'top'
              }
            };
            
            sensor.chart.datasetOverride = [
              {
                borderWidth: 0,
                fill: false,
                yAxisID: 'y-axis-1'
              },
              {
                borderWidth: 0,
                fill: false,
                yAxisID: 'y-axis-2'
              },
              {
                borderWidth: 0,
                fill: false,
                yAxisID: 'y-axis-3'
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              }
            ];

          }, function() {
            toastr.error('[PopUp] Failed to retrieve data.', '');
            return null;
          });
      }
      
      /* ************************************************** */
      
      vm.showActionPane = function (sensor) {
        sensor.tooltipIsOpen = false;

        var parentElem = angular.element(document.getElementById("layoutParent"));

        var modalInstance = $uibModal.open({
            animation: false,
            keyboard: false,
            backdrop: 'static',
            windowClass: 'app-modal-window',
            templateUrl: 'actionPaneModal.html',
            controller: 'IoTLvDashboardActionPaneCtrl',
            controllerAs: '$mdl',
            appendTo: parentElem,
            size: 'sm',
            resolve: {
                item: function () {
                    return {
                        sensor: sensor
                    }
                }
            }
        });

        modalInstance
            .result
            .then(function (data) {
                // sensor.tooltipIsOpen = true;
                // toastr.info(JSON.stringify(data));
            }, function () {
            });
      };

      /* ********************************************************* */

      vm.getLayoutWidth = function() {        
        var element = document.getElementById('layoutParent');
        return element.offsetWidth;
      }
      
      vm.getLayoutHeight = function() {        
        var element = document.getElementById('layoutParent');
        return element.offsetHeight;
      }

      vm.getCoorX = function(currX) {
        var element = document.getElementById('layoutParent');

        var w = element.offsetWidth;
        var h = element.offsetHeight; 
        
        var ratioX = w / 1920;
        var ratioY = h / 1080;

        var diffX = w - 1920;
        var diffY = h - 1080;

        if(diffX < diffY)
        {
          return currX * ratioX;
        }
        else if(diffX > diffY)
        {
          return currX * ratioY;
        }
        else
          return currX;
      }

      vm.getCoorY = function(currY) {
        var element = document.getElementById('layoutParent');

        var w = element.offsetWidth;
        var h = element.offsetHeight; 
        
        var ratioX = w / 1920;
        var ratioY = h / 1080;

        var diffX = w - 1920;
        var diffY = h - 1080;

        if(diffX < diffY)
        {
          return currY * ratioX;
        }
        else if(diffX > diffY)
        {
          return currY * ratioY;
        }
        else
          return currY;
      }

      /* ********************************************************* */

      vm.loadAllLayouts();
    }
    
    /** @ngInject */
    function IoTLvDashboardActionPaneCtrl($uibModalInstance, $timeout, Auth, RmsApi, HttpSvc, UtilSvc, item, toastr) {
      var $mdl = this;

      $mdl.sensor = item.sensor;
      $mdl.item = {};
      $mdl.errorMsg = "";
      $mdl.showError = false;
      $mdl.showSuccess = false;
      $mdl.lockButton = false;

      /* ********************************************************* */
						
      $mdl.confirmModal = function() {
        if($mdl.actionPaneForm.$invalid) {
          $mdl.errorMsg = UtilSvc.getErrorMessage($mdl.actionPaneForm);          
          $mdl.showError = true;
        } else {
          $mdl.lockButton = true;
          $mdl.showError = false;

          $mdl.item.sensorId = $mdl.sensor.sensorId;
          $mdl.item.temperature = $mdl.sensor.seriesMain.currentTemp;
          $mdl.item.humidity = $mdl.sensor.objectStats.currentHumi;
          $mdl.item.amp = $mdl.sensor.objectStats.currentAmp;
          $mdl.item.batteryLevel = $mdl.sensor.objectStats.currentBatt;

          HttpSvc.post('iotcorrectiveactions', $mdl.item, Auth.getTokenId(), false)
            .then(function(result) {
              $mdl.showSuccess = true;
              $timeout($uibModalInstance.close, 1500);
            }, function(error) {
              $mdl.errorMsg = error;
              $mdl.showError = true;
              $mdl.lockButton = false;
            });
        }
      };
      
      // Cancel Action
      $mdl.cancelModal = function() {
        $uibModalInstance.dismiss('cancel');
      };
    };	
    
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.smartkitchendashboard.controller', [])
        .controller('SmartKitchenDashboardCtrl', SmartKitchenDashboardCtrl);

    /** @ngInject */
    function SmartKitchenDashboardCtrl($scope, $state, $timeout, $interval, Auth, HttpSvc, RmsApi, toastr) {
        Auth.init();	
        
        var vm = this;
        vm.currentDate = new Date();
        vm.branchList = [];
        vm.markers = [];
        vm.selectedOutlet = {};
        vm.interval = null;
        vm.refreshInterval = 10000;
        vm.carouselInterval = 5000;
        vm.carouselNoWrap = false;
        vm.activeTab = 0;

        /* ********************************************************************** */
        
        vm.toggleFullscreen = function() {
            var element = document.getElementById('smartkitchen_visualization');
    
            if(document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement)
            {
            document.exitFullscreen();
            }
            else
            {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.msRequestFullScreen) {
                element.msRequestFullScreen();
            }
            }			
        }

        /* ********************************************************************** */

        vm.init = function() {
            vm.loadBranchList();
            vm.run_clock();
            $interval(vm.run_clock, 1000);
        }

        vm.loadMap = function() {

			var mapOptions = {
				center: {
					'lat': 3.1377664033531656, 
					'lng': 101.68700791600979
				}, // Malaysia
				fullscreenControl: false,
				mapTypeControl: false,
				streetViewControl: false,
                zoomControl: false,
				zoom: 12,
                styles: [
                    {
                        "featureType": "all",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#202c3e"
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "gamma": 0.01
                            },
                            {
                                "lightness": 20
                            },
                            {
                                "weight": "1.39"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "weight": "0.96"
                            },
                            {
                                "saturation": "9"
                            },
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#000000"
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "lightness": 30
                            },
                            {
                                "saturation": "9"
                            },
                            {
                                "color": "#29446b"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "saturation": 20
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "lightness": 20
                            },
                            {
                                "saturation": -20
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "lightness": 10
                            },
                            {
                                "saturation": -30
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#193a55"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "saturation": 25
                            },
                            {
                                "lightness": 25
                            },
                            {
                                "weight": "0.01"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "lightness": -20
                            }
                        ]
                    }
                ],
                // zoomControlOptions: {
				// 	position: google.maps.ControlPosition.RIGHT_TOP,
				// }
			};
	
			// Map object
			var map = new google.maps.Map(document.getElementById('dashboardMap'), mapOptions);

            vm.branchList.forEach(function (b) {
                vm.addMarker(map, b);    
            });
            
            vm.fitBounds(map);
		}

        vm.addMarker = function (map, branch) {
            var MARKER = 'https://maps.google.com/mapfiles/ms/icons/green-dot.png';
            var MARKER1 = 'assets/img/marker-food3.png';

            var lat = parseFloat(branch.gps_Latitude);
            var lng = parseFloat(branch.gps_Longitude);

            var pos = {
                lat: isNaN(lat) ? null : lat,
                lng: isNaN(lng) ? null : lng,
            }

			var marker = new google.maps.Marker({
				position: pos,
				map: map,
				opacity: 1,
				icon: MARKER1,
                branchId: branch.branchId,
                branchName: branch.branchName
			});

            marker.addListener("click", function() {
                vm.loadBranchTelemetry(marker.branchId);
                vm.autoFresh();
            });

            vm.markers.push(marker);
		}
	
		vm.fitBounds = function (map) {
			vm.bounds = new google.maps.LatLngBounds;

			for (var i = 0; i < vm.markers.length; i++) {
				vm.bounds.extend(vm.markers[i].getPosition());
			}

			map.fitBounds(vm.bounds, 5);
		}

        /* ********************************************************************** */

        vm.loadBranchList = function() {
            HttpSvc.get('smartkitchendashboard/branchlist', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
                    
                    // Load Selected Branch Telemetry
                    if(vm.branchList.length > 0)
                    {
                        vm.loadBranchTelemetry(vm.branchList[0].branchId);
                    }
                    
                    $timeout(vm.loadMap, 1000);
                    vm.autoFresh();
				}, function(error) {
					toastr.error('Failed to load Smart Kitchen Branch Lsit. ' + error, Auth.translate('ERROR'))
					return;
				});	
        }

        vm.loadBranchTelemetry = function(branchId) {
            // Get Branch Telemetry from API         
            HttpSvc.get('smartkitchendashboard/1/' + branchId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.selectedOutlet = result;
				}, function(error) {
					toastr.error('Failed to load Smart Kitchen Dashboard. ' + error, Auth.translate('ERROR'))
					return;
				});	
        }

        vm.calcStoreRevenuePercentage = function(revenue) {
            var totalRevenue = 0;
            vm.selectedOutlet.topFiveRevenueBranchList.forEach(function(b) {
                totalRevenue += b.totalRevenue;
            });

            var percentage = Math.round(revenue / totalRevenue * 100, 0);

            return percentage + Math.round(80 * percentage / 100, 0);
        }

        vm.autoFresh = function() {
            $interval.cancel(vm.interval);

            vm.interval = $interval(function () {
                vm.loadBranchTelemetry(vm.selectedOutlet.branchId);                
            }, vm.refreshInterval);
        }

        /* ********************************************************************** */

        vm.calcFoodRevenuePercentage = function(revenue) {
            var totalRevenue = 0;
            vm.selectedOutlet.bestSellerList.forEach(function(b) {
                totalRevenue += b.totalRevenue;
            });

            var percentage = Math.round(revenue / totalRevenue * 100, 0);

            return percentage;
        }

        /* ********************************************************************** */

        vm.run_clock = function() {
            vm.currentDate = new Date();
        }

        $scope.$on('$destroy', function() {
            $interval.cancel(vm.interval);
        });

        /* ********************************************************************** */

        vm.getIndex = function(index) {
            return Math.floor(index / 3);
        }

        vm.init();
    };

})();


(function() {
    'use strict';

    angular.module('RmsAppV2.pages.consodeliveryorders.controller', [])
        .controller('ConsoDeliveryOrderMainCtrl', ConsoDeliveryOrderMainCtrl)
        .controller('ConsoDeliveryOrderCreateCtrl', ConsoDeliveryOrderCreateCtrl)
        .controller('ConsoDeliveryOrderUpdateCtrl', ConsoDeliveryOrderUpdateCtrl)
        .controller('ConsoDeliveryOrderProductModalCtrl', ConsoDeliveryOrderProductModalCtrl);

    /** @ngInject */
    function ConsoDeliveryOrderMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.data = [];

		vm.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.docNo,
				createdBy: predicate.createdBy,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('deliveryorderconsolidations/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			return tableState;
		};

		vm.resetSearch = function()
		{
		}

		/* ************************************************************************** */

		vm.printDoc = function(deliveryOrderId, deliveryOrderNo) {

			var filename = "DO_CONSO_" + deliveryOrderNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('deliveryorderconsolidations/print/pdf/' + deliveryOrderId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to print Consolidated Delivery Order. ' + error, '');
							return null;
						});
		}
	};

	/** @ngInject */
    function ConsoDeliveryOrderCreateCtrl($scope, $state, $filter, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.isRmsLite = Auth.isLiteMode();

		vm.doStatuses = ['NEW', 'CONFIRMED'];
		vm.doStatuses.selected = 'NEW';
		vm.mode = 1;
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.originalStatus = 'NEW';
		vm.selectedDebtor = null;
		vm.selectedDebtorBranch = null;
		vm.currency = Auth.getCurrency();
		vm.subtotal = 0;
		vm.grandTotal = 0;

		/* ************************************************************ */

		// Set Default DeliveryOrder Date
		vm.setDefault = function() {
			vm.do = {};
			vm.do.status = 'NEW';
			vm.do.deliveryOrderProducts = [];
			vm.do.deliveryOrderDate = $filter('date')(new Date(), 'yyyy-MM-dd');
			vm.doStatuses.selected = 'NEW';

			vm.loadDebtorList();
		}

		// Load Debtor List
		vm.loadDebtorList = function() {
			HttpSvc.get('debtors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve product list.', '');
					return null;
			});
		}

		// Load Debtor Branch List
		vm.loadDebtorBranchList = function() {
			if(vm.do.debtorId==null || vm.do.debtorId=="") return;

			HttpSvc.get('debtors/' + vm.do.debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorBranchList = result;

					vm.debtorBranchList.forEach(function(d) {
						if(d.id==vm.do.debtorBranchId)
						{
							vm.selectedDebtorBranch = d;
						}
					})
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Customer Branch list.', '');
					return null;
			});
		}

		/* ************************************************************ */

		vm.selectedDebtorChanged = function() {
			vm.do.debtorId = vm.selectedDebtor.id;
			vm.do.debtorBranchId = null;
			vm.selectedDebtorBranch = null;

			if((vm.do.debtorName!=null && vm.do.debtorName!='') ||
				(vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
				(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
				(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
				(vm.do.debtorAddress3!=null && vm.do.debtorAddress3!='') ||
				(vm.do.debtorState!=null && vm.do.debtorState!='') ||
				(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
				(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
				(vm.do.debtorTel!=null && vm.do.debtorTel!='') ||
				(vm.do.debtorFax!=null && vm.do.debtorFax!=''))
			{
				var qst = 'Do you want to overwrite the customer info with these details?\n\n' +
						  'Company Name : ' + (vm.selectedDebtor.name || '') + '\n' +
						  'Contact Person : ' + (vm.selectedDebtor.contactPerson1 || '') + '\n' +
						  'Address 1 : ' + (vm.selectedDebtor.address1 || '') + '\n' +
						  'Address 2 : ' + (vm.selectedDebtor.address2 || '') + '\n' +
						  'Address 3 : ' + (vm.selectedDebtor.address3 || '') + '\n' +
						  'State : ' + (vm.selectedDebtor.state || '') + '\n' +
						  'Postal Code : ' + (vm.selectedDebtor.postCode || '') + '\n' +
						  'Country : ' + (vm.selectedDebtor.country || '') + '\n' +
						  'Telephone : ' + (vm.selectedDebtor.phone1 || '') + '\n' +
						  'Fax : ' + (vm.selectedDebtor.fax1 || '') + '\n\n';
				var cfm = confirm(qst);

				if(cfm)
				{
					vm.do.debtorName = vm.selectedDebtor.name;
					vm.do.debtorContactPerson = vm.selectedDebtor.contactPerson1;
					vm.do.debtorAddress1 = vm.selectedDebtor.address1;
					vm.do.debtorAddress2 = vm.selectedDebtor.address2;
					vm.do.debtorAddress3 = vm.selectedDebtor.address3;
					vm.do.debtorState = vm.selectedDebtor.state;
					vm.do.debtorPostCode = vm.selectedDebtor.postCode;
					vm.do.debtorCountry = vm.selectedDebtor.country;
					vm.do.debtorTel = vm.selectedDebtor.phone1;
					vm.do.debtorFax = vm.selectedDebtor.fax1;
				}
			}
			else
			{
				vm.do.debtorName = vm.selectedDebtor.name;
				vm.do.debtorContactPerson = vm.selectedDebtor.contactPerson1;
				vm.do.debtorAddress1 = vm.selectedDebtor.address1;
				vm.do.debtorAddress2 = vm.selectedDebtor.address2;
				vm.do.debtorAddress3 = vm.selectedDebtor.address3;
				vm.do.debtorState = vm.selectedDebtor.state;
				vm.do.debtorPostCode = vm.selectedDebtor.postCode;
				vm.do.debtorCountry = vm.selectedDebtor.country;
				vm.do.debtorTel = vm.selectedDebtor.phone1;
				vm.do.debtorFax = vm.selectedDebtor.fax1;
			}

			toastr.info("Customer information updated.", "Customer");

			vm.loadDebtorBranchList();
			vm.updateProductPriceFromSalesConfig();
		}

		vm.selectedDebtorBranchChanged = function() {
			vm.do.debtorBranchId = vm.selectedDebtorBranch.id;

			if((vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
				(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
				(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
				(vm.do.debtorAddress3!=null && vm.do.debtorAddress3!='') ||
				(vm.do.debtorState!=null && vm.do.debtorState!='') ||
				(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
				(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
				(vm.do.debtorTel!=null && vm.do.debtorTel!='') ||
				(vm.do.debtorFax!=null && vm.do.debtorFax!=''))
			{
				var qst = 'Do you want to overwrite the customer info with these details?\n\n' +
						  'Contact Person : ' + (vm.selectedDebtorBranch.contactPerson || '') + '\n' +
						  'Address 1 : ' + (vm.selectedDebtorBranch.address1 || '') + '\n' +
						  'Address 2 : ' + (vm.selectedDebtorBranch.address2 || '') + '\n' +
						  'Address 3 : ' + (vm.selectedDebtorBranch.address3 || '') + '\n' +
						  'State : ' + (vm.selectedDebtorBranch.state || '') + '\n' +
						  'Postal Code : ' + (vm.selectedDebtorBranch.postCode || '') + '\n' +
						  'Country : ' + (vm.selectedDebtorBranch.country || '') + '\n' +
						  'Telephone : ' + (vm.selectedDebtorBranch.phone || '') + '\n' +
						  'Fax : ' + (vm.selectedDebtorBranch.fax || '') + '\n\n';
				var cfm = confirm(qst);

				if(cfm)
				{
					vm.do.debtorContactPerson = vm.selectedDebtorBranch.contactPerson;
					vm.do.debtorAddress1 = vm.selectedDebtorBranch.address1;
					vm.do.debtorAddress2 = vm.selectedDebtorBranch.address2;
					vm.do.debtorAddress3 = vm.selectedDebtorBranch.address3;
					vm.do.debtorState = vm.selectedDebtorBranch.state;
					vm.do.debtorPostCode = vm.selectedDebtorBranch.postCode;
					vm.do.debtorCountry = vm.selectedDebtorBranch.country;
					vm.do.debtorTel = vm.selectedDebtorBranch.phone;
					vm.do.debtorFax = vm.selectedDebtorBranch.fax;
				}
			}
			else
			{
				vm.do.debtorContactPerson = vm.selectedDebtorBranch.contactPerson;
				vm.do.debtorAddress1 = vm.selectedDebtorBranch.address1;
				vm.do.debtorAddress2 = vm.selectedDebtorBranch.address2;
				vm.do.debtorAddress3 = vm.selectedDebtorBranch.address3;
				vm.do.debtorState = vm.selectedDebtorBranch.state;
				vm.do.debtorPostCode = vm.selectedDebtorBranch.postCode;
				vm.do.debtorCountry = vm.selectedDebtorBranch.country;
				vm.do.debtorTel = vm.selectedDebtorBranch.phone;
				vm.do.debtorFax = vm.selectedDebtorBranch.fax;
			}

			toastr.info("Customer Address information updated.", "Customer Address");
		}

		/* ************************************************************ */

		vm.updateProductPriceFromSalesConfig = function() {
			var params = {
				salesorderitem: vm.do.deliveryOrderProducts,
				filter: {
					debtorId: vm.do.debtorId
				}
			};

			HttpSvc.post('salesorders/refreshsalesorderproduct', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.do.deliveryOrderProducts = [];
					result.forEach(function(p) {
						vm.do.deliveryOrderProducts.push(p);
					});
					vm.recalculateGrandTotal();

					vm.lockButtons = false;
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					vm.lockButtons = false;
					return;
				});
		}

		/* ************************************************************ */

		// Remove Product
		vm.removeProduct = function(index) {
			vm.do.deliveryOrderProducts.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};

		// Update Product
		vm.updateProduct = function(index, obj) {

			var element = {
				id: obj.id,
				deliveryOrderId: obj.deliveryOrderId,
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				itemType: obj.itemType,
				productCode: obj.productCode==null?obj.itemCode:obj.productCode,
				productName: obj.productName==null?obj.itemName:obj.productName,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId==null?obj.uomId:obj.unitOfMeasurementId,
				uomName: obj.uomName,
				unitPrice: obj.unitPrice,
				discountAmount: obj.discountAmount,
				discountPercentage: obj.discountPercentage,
				taxCode: obj.taxCode,
				tax: obj.tax,
				subtotal: obj.subtotal,
				quantityStockedOut: obj.quantityStockedOut,
				quantityTransported: obj.quantityTransported,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
				remarks: obj.remarks,

				isCwm: obj.isCwm,
				invUomId: obj.invUomId,
				invUomId_Parallel: obj.invUomId_Parallel,
				invUomName: obj.invUomName,
				invUomName_Parallel: obj.invUomName_Parallel,
				invBalance: obj.invBalance,
				invBalance_Parallel: obj.invBalance_Parallel,
				totalNewSalesOrderQuantity: obj.totalNewSalesOrderQuantity,
				totalConfirmedSalesOrderQuantity: obj.totalConfirmedSalesOrderQuantity,
				totalDOPendingQuantity: obj.totalDOPendingQuantity,
			};
			vm.do.deliveryOrderProducts.splice(index, 1, element);
		};

		// Add Product
		vm.addProduct = function(obj) {
			var isFound = false;
			var objIdx = null;

			for (var i = 0; i < vm.do.deliveryOrderProducts.length; i++) {
				var d = vm.do.deliveryOrderProducts[i];
				if(d.itemId==obj.itemId && d.semiFinishedProductId==obj.semiFinishedProductId && d.productId==obj.productId)
				{
					isFound = true;
					objIdx = i;
				}
			}

			if(isFound)
			{
				toastr.warning('The same item already exists on the list. Additional Quantity, Tax and Amount will be added.', 'Duplicate Item');
				var d = vm.do.deliveryOrderProducts[objIdx];
				d.quantity += obj.quantity;
				d.unitPrice = obj.unitPrice;
				d.discountAmount += obj.discountAmount;
				d.discountPercentage += obj.discountPercentage;
				d.tax += obj.tax;
				d.subtotal += obj.subtotal;
				d.quantityStockedOut = obj.quantityStockedOut;
				d.quantityTransported = obj.quantityTransported;
				d.remarks = obj.remarks;

				d.isCwm = obj.isCwm;
				d.invUomId = obj.invUomId;
				d.invUomId_Parallel = obj.invUomId_Parallel;
				d.invUomName = obj.invUomName;
				d.invUomName_Parallel = obj.invUomName_Parallel;
				d.invBalance = obj.invBalance;
				d.invBalance_Parallel = obj.invBalance_Parallel;
				d.totalNewSalesOrderQuantity = obj.totalNewSalesOrderQuantity;
				d.totalConfirmedSalesOrderQuantity = obj.totalConfirmedSalesOrderQuantity;
				d.totalDOPendingQuantity = obj.totalDOPendingQuantity;
				return;
			}

			var element = {
				id: obj.id,
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				itemType: obj.itemType,
				productCode: obj.productCode==null?obj.itemCode:obj.productCode,
				productName: obj.productName==null?obj.itemName:obj.productName,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId==null?obj.uomId:obj.unitOfMeasurementId,
				uomName: obj.uomName,
				unitPrice: obj.unitPrice,
				discountAmount: obj.discountAmount,
				discountPercentage: obj.discountPercentage,
				taxCode: obj.taxCode,
				tax: obj.tax,
				subtotal: obj.subtotal,
				quantityStockedOut: obj.quantityStockedOut,
				quantityTransported: obj.quantityTransported,
				remarks: obj.remarks,

				isCwm: obj.isCwm,
				invUomId: obj.invUomId,
				invUomId_Parallel: obj.invUomId_Parallel,
				invUomName: obj.invUomName,
				invUomName_Parallel: obj.invUomName_Parallel,
				invBalance: obj.invBalance,
				invBalance_Parallel: obj.invBalance_Parallel,
				totalNewSalesOrderQuantity: obj.totalNewSalesOrderQuantity,
				totalConfirmedSalesOrderQuantity: obj.totalConfirmedSalesOrderQuantity,
				totalDOPendingQuantity: obj.totalDOPendingQuantity,
			};
			vm.do.deliveryOrderProducts.push(element);
		};

		// Refresh Product List
		vm.refreshDeliveryOrderProducts = function(tableState) {
			// Do nothing
		};

		vm.recalculateGrandTotal = function() {
			vm.subtotal = 0;
			vm.grandTotal = 0;

			vm.do.deliveryOrderProducts.forEach(function(p) {
				vm.subtotal += p.subtotal;
			});

			vm.grandTotal += vm.subtotal;
			vm.grandTotal -= (vm.do.discountAmount || 0);
			vm.grandTotal += (vm.do.additionalCharges || 0);
			vm.do.grandTotal = vm.grandTotal;
		}

		vm.calculateDiscountAmount1 = function() {
			if(vm.do.discountPercentage!=null)
			{
				vm.do.discountAmount = vm.subtotal * vm.do.discountPercentage / 100;
				vm.do.discountAmount = Math.round(vm.do.discountAmount * 100) / 100;
			}
			else
			{
				vm.do.discountAmount = null;
			}
			vm.recalculateGrandTotal();
		}

		vm.calculateDiscountAmount2 = function() {
			if(vm.do.discountAmount!=null)
			{
				vm.do.discountPercentage = vm.do.discountAmount / vm.subtotal * 100;
				vm.do.discountPercentage = Math.round(vm.do.discountPercentage * 100) / 100;
			}
			else
			{
				vm.do.discountPercentage = null;
			}
			vm.recalculateGrandTotal();
		}

		vm.getReservedQty = function (obj) {
			return (obj.totalNewSalesOrderQuantity +
				obj.totalConfirmedSalesOrderQuantity +
				obj.totalDOPendingQuantity);
		}

		vm.getAvailableQty = function (obj) {
			return (obj.invBalance -
				obj.totalNewSalesOrderQuantity -
				obj.totalConfirmedSalesOrderQuantity -
				obj.totalDOPendingQuantity);
		}

		/* ************************************************************ */

		// Open Modal Dialog
		vm.product = {};
		vm.showAddProductModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'productModal.html',
				controller: 'DeliveryOrderProductModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.product,
							debtorId: vm.do.debtorId
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addProduct(data);
				}, function () {
				});
		};
		vm.showEditProductModal = function (index) {
			vm.product = angular.copy(vm.do.deliveryOrderProducts[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'productModal.html',
				controller: 'DeliveryOrderProductModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.product,
							debtorId: vm.do.debtorId
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateProduct(index, data);
				}, function () {
				});
		};

		/* ************************************************************ */

		vm.clearSelectSalesOrder = function () {
			vm.do.salesOrderId = null;
			vm.do.salesOrderNo = null;
		}

		vm.showSelectSalesOrderModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'salesOrderListModal.html',
				controller: 'DeliveryOrderSelectSOModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (salesOrderId) {
					vm.populateSalesOrder(salesOrderId);
				}, function () {
				});
		};

		vm.populateSalesOrder = function(salesOrderId) {

			if(vm.do.deliveryOrderProducts.length>0) {
				var toProceed = confirm('This action will overwrite the existing products in the Product List.\n\nConfirm Proceed?');
				if(!toProceed) return;

				vm.do.deliveryOrderProducts = [];
			}

			var params = { id: salesOrderId };
			HttpSvc.get('salesorders/web/delivery/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.do.transferId = null;
					vm.do.stockTransferNo = null;

					var salesOrder = result;
					vm.do.debtorId = salesOrder.debtorId;
					vm.do.debtorBranchId = salesOrder.debtorBranchId;
					vm.do.deliveryOrderDate = $filter('date')(salesOrder.deliveryDate, 'yyyy-MM-dd');
					vm.do.salesOrderId = salesOrderId;
					vm.do.salesOrderNo = salesOrder.salesOrderNo;
					vm.do.customerPoNo = salesOrder.customerPoNo;
					vm.do.grandTotal = salesOrder.grandTotal;
					vm.do.remarks = salesOrder.description;
					vm.do.discountAmount = salesOrder.discountAmount;
					vm.do.discountPercentage = salesOrder.discountPercentage;
					vm.do.additionalChargesDesc = salesOrder.additionalChargesDesc;
					vm.do.additionalCharges = salesOrder.additionalCharges;

					vm.debtorList.forEach(function(d) {
						if(d.id==salesOrder.debtorId) {
							vm.selectedDebtor = d;
						}
					});
					vm.loadDebtorBranchList();

					if((vm.do.debtorName!=null && vm.do.debtorName!='') ||
						(vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
						(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
						(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
						(vm.do.debtorState!=null && vm.do.debtorState!='') ||
						(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
						(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
						(vm.do.debtorTel!=null && vm.do.debtorTel!=''))
					{
						var qst = 'Do you want to overwrite the customer info with these details?\n\n' +
								  'Company Name : ' + (salesOrder.userFullName || '') + '\n' +
								  'Contact Person : ' + (salesOrder.userFullName || '') + '\n' +
								  'Address 1 : ' + (salesOrder.debtorAddress1 || '') + '\n' +
								  'Address 2 : ' + (salesOrder.debtorAddress2 || '') + '\n' +
								  'Address 3 :\n' +
								  'State : ' + (salesOrder.debtorState || '') + '\n' +
								  'Postal Code : ' + (salesOrder.debtorPostCode || '') + '\n' +
								  'Country : ' + (salesOrder.debtorCountry || '') + '\n' +
								  'Telephone : ' + (salesOrder.debtorPhone || '') + '\n' +
								  'Fax : \n\n';
						var cfm = confirm(qst);

						if(cfm)
						{
							vm.do.debtorName = salesOrder.debtorName;
							vm.do.debtorContactPerson = salesOrder.debtorContactPerson;
							vm.do.debtorAddress1 = salesOrder.debtorAddress1;
							vm.do.debtorAddress2 = salesOrder.debtorAddress2;
							vm.do.debtorAddress3 = salesOrder.debtorAddress3;
							vm.do.debtorState = salesOrder.debtorState;
							vm.do.debtorPostCode = salesOrder.debtorPostCode;
							vm.do.debtorCountry = salesOrder.debtorCountry;
							vm.do.debtorTel = salesOrder.debtorPhone;
							vm.do.debtorFax = salesOrder.debtorFax;
						}
					}
					else
					{
						vm.do.debtorName = salesOrder.debtorName;
						vm.do.debtorContactPerson = salesOrder.debtorContactPerson;
						vm.do.debtorAddress1 = salesOrder.debtorAddress1;
						vm.do.debtorAddress2 = salesOrder.debtorAddress2;
						vm.do.debtorAddress3 = salesOrder.debtorAddress3;
						vm.do.debtorState = salesOrder.debtorState;
						vm.do.debtorPostCode = salesOrder.debtorPostCode;
						vm.do.debtorCountry = salesOrder.debtorCountry;
						vm.do.debtorTel = salesOrder.debtorPhone;
						vm.do.debtorFax = salesOrder.debtorFax;
					}

					salesOrder.salesOrderProducts.forEach(function(p) {
						vm.addProduct(p);
					});

					vm.recalculateGrandTotal();

				}, function() {
					toastr.error('Failed to load selected Sales Order.', Auth.translate('ERROR'))
					return;
				});
		};

		/* ************************************************************ */

		vm.clearSelectStockTransfer = function () {
			vm.do.transferId = null;
			vm.do.stockTransferNo = null;
		}

		vm.showSelectStockTransferModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'stockTransferListModal.html',
				controller: 'DeliveryOrderSelectSTModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (transferId) {
					vm.populateStockTransfer(transferId);
				}, function () {
				});
		};

		vm.populateStockTransfer = function(transferId) {

			if(vm.do.deliveryOrderProducts.length>0) {
				var toProceed = confirm('This action will overwrite the existing products in the Product List.\n\nConfirm Proceed?');
				if(!toProceed) return;

				vm.do.deliveryOrderProducts = [];
			}

			var params = { id: transferId };
			HttpSvc.get('stocktransfers/web/delivery/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.do.salesOrderId = null;
					vm.do.salesOrderNo = null;
					vm.selectedDebtor = null;
					vm.selectedDebtorBranch = null;

					var transfer = result;
					vm.do.debtorId = null;
					vm.do.debtorBranchId = null;
					vm.do.deliveryOrderDate = $filter('date')(transfer.deliveryDate, 'yyyy-MM-dd');
					vm.do.transferId = transferId;
					vm.do.stockTransferNo = transfer.docNo;
					vm.do.grandTotal = 0;
					vm.do.remarks = transfer.remarks;

					if((vm.do.debtorName!=null && vm.do.debtorName!='') ||
						(vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
						(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
						(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
						(vm.do.debtorAddress3!=null && vm.do.debtorAddress3!='') ||
						(vm.do.debtorState!=null && vm.do.debtorState!='') ||
						(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
						(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
						(vm.do.debtorTel!=null && vm.do.debtorTel!=''))
					{
						var qst = 'Do you want to overwrite the Recipient info with these details?\n\n' +
								  'Company Name : ' + (transfer.destBranchName || '') + '\n' +
								  'Contact Person : ' + (transfer.destBranchContactPerson || '') + '\n' +
								  'Address 1 : ' + (transfer.destBranchAddress1 || '') + '\n' +
								  'Address 2 : ' + (transfer.destBranchAddress2 || '') + '\n' +
								  'Address 3 : ' + (transfer.destBranchAddress3 || '') + '\n' +
								  'State : ' + (transfer.destBranchState || '') + '\n' +
								  'Postal Code : ' + (transfer.destBranchPostCode || '') + '\n' +
								  'Country : ' + (transfer.destBranchCountry || '') + '\n' +
								  'Telephone : ' + (transfer.destBranchTel || '') + '\n' +
								  'Telephone : ' + (transfer.destBranchFax || '') + '\n' +
								  'Fax : \n\n';
						var cfm = confirm(qst);

						if(cfm)
						{
							vm.do.debtorName = transfer.destBranchName;
							vm.do.debtorContactPerson = transfer.destBranchContactPerson;
							vm.do.debtorAddress1 = transfer.destBranchAddress1;
							vm.do.debtorAddress2 = transfer.destBranchAddress2;
							vm.do.debtorAddress3 = transfer.destBranchAddress3;
							vm.do.debtorState = transfer.destBranchState;
							vm.do.debtorPostCode = transfer.destBranchPostCode;
							vm.do.debtorCountry = transfer.destBranchCountry;
							vm.do.debtorTel = transfer.destBranchTel;
							vm.do.debtorFax = transfer.destBranchFax;
						}
					}
					else
					{
						vm.do.debtorName = transfer.destBranchName;
						vm.do.debtorContactPerson = transfer.destBranchContactPerson;
						vm.do.debtorAddress1 = transfer.destBranchAddress1;
						vm.do.debtorAddress2 = transfer.destBranchAddress2;
						vm.do.debtorAddress3 = transfer.destBranchAddress3;
						vm.do.debtorState = transfer.destBranchState;
						vm.do.debtorPostCode = transfer.destBranchPostCode;
						vm.do.debtorCountry = transfer.destBranchCountry;
						vm.do.debtorTel = transfer.destBranchTel;
						vm.do.debtorFax = transfer.destBranchFax;
					}

					transfer.stockTransferDetails.forEach(function(p) {
						vm.addProduct(p);
					});

				}, function() {
					toastr.error('Failed to retrieve selected Stock Transfer details.', Auth.translate('ERROR'))
					return;
				});
		};

		/* ************************************************************ */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				HttpSvc.post('deliveryorderconsolidations', vm.do, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkResult = function(result)
		{
			if(result.httpStatusCode=="200")
			{
				toastr.success('Delivery Order has been created successfully.', Auth.translate('SUCCESS'));
				$state.go('deliveryorderconsolidations.update', {'id': result.id });
			}
			else if(result.httpStatusCode=="400")
			{
				toastr.error(result.message, Auth.translate('ERROR'));
				vm.lockButtons = false;
			}
			else
			{
				toastr.success('Delivery Order has been created successfully.', Auth.translate('SUCCESS'));
				$state.go('deliveryorderconsolidations.update', {'id': result.id });
			}
		}

		// Call Actions
		vm.setDefault();
	};

	/** @ngInject */
    function ConsoDeliveryOrderUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.isRmsLite = Auth.isLiteMode();

		vm.doStatuses = ['NEW', 'CONFIRMED', 'CANCELLED'];
		vm.mode = 2;
		vm.do = {};
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.changeLogs = [];
		vm.originalStatus = null;
		vm.selectedDebtor = null;
		vm.selectedDebtorBranch = null;
		vm.isAdvancedMode = Auth.getSetting_DeliveryOrder_AdvancedMode();
		vm.lockButtons = false;
		vm.approveCreditLimit = false;
		vm.requestCreditApproval = false;
		vm.currency = Auth.getCurrency();
		vm.subtotal = 0;
		vm.grandTotal = 0;

		/* ************************************************************ */

		// Load Debtor List
		vm.loadDebtorList = function() {
			HttpSvc.get('debtors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					vm.loadDeliveryOrder();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve product list.', '');
					return null;
			});
		}

		// Load Debtor Branch List
		vm.loadDebtorBranchList = function() {
			if(vm.do.debtorId==null || vm.do.debtorId=="") return;

			HttpSvc.get('debtors/' + vm.do.debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorBranchList = result;

					vm.debtorBranchList.forEach(function(d) {
						if(d.id==vm.do.debtorBranchId)
						{
							vm.selectedDebtorBranch = d;
						}
					});
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Customer Branch list.', '');
					return null;
			});
		}

		// Load DeliveryOrder List
		vm.loadDeliveryOrder = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('deliveryorderconsolidations/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.do = result;
					vm.do.deliveryDate = $filter('date')(vm.do.deliveryDate, 'yyyy-MM-dd');
					vm.originalStatus = vm.do.status;

					vm.debtorList.forEach(function(d) {
						if(d.id==vm.do.debtorId)
						{
							vm.selectedDebtor = d;
						}
					});

					if(vm.do.debtorId!=null)
					{
						vm.loadDebtorBranchList();
					}

					vm.recalculateGrandTotal();
					vm.loadChangeLogs();
				}, function(error) {
					toastr.error('Failed to load Delivery Order. ' + error, Auth.translate('ERROR'))
					$state.go('deliveryorderconsolidations.list');
					return;
				});
		};

		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('deliveryorderchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};

		/* ************************************************************ */

		// Print Delivery Order
		vm.printDeliveryOrder = function(deliveryOrderId, deliveryOrderNo) {

			var filename = "DELIVERYORDER_" + deliveryOrderNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('deliveryorderconsolidations/print/deliveryorder/' + deliveryOrderId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to print Delivery Order. ' + error, '');
							return null;
						});
		}

		// Print Invoice
		vm.printInvoice = function(deliveryOrderId, invoiceNo) {

			var filename = "INVOICE_" + invoiceNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('deliveryorderconsolidations/print/invoice/' + deliveryOrderId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to print Invoice. ' + error, '');
							return null;
						});
		}

		/* ************************************************************ */

		// Pre-Check Approval
		vm.preCheckApproveDeliveryOrder = function() {
			HttpSvc.post('deliveryorderconsolidations/precheckapprove/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.approveDeliveryOrder();
				}, function(error) {
					var cfm = confirm("----------------------------------------------\n" +
									  " Delivery Criteria Not Fulfilled\n" +
									  "----------------------------------------------\n\n" +
									  error + '\n\n' +
									  "Do you want to continue to Approve the Delivery Order?\n\n\n");
					if(cfm)
					{
						vm.approveDeliveryOrder();
					}
				});
		}

		// Approval
		vm.approveDeliveryOrder = function() {
			vm.lockButtons = true;

			var bApproveCreditLimit = vm.approveCreditLimit ? "/1" : "";

			HttpSvc.post('deliveryorderconsolidations/approve/' + $stateParams.id + bApproveCreditLimit, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.checkResult(result, "approved", 1);
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}

		// Complete DeliveryOrder
		vm.completeDeliveryOrder = function() {
			vm.lockButtons = true;

			HttpSvc.post('deliveryorderconsolidations/complete/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.checkResult(result, "completed");
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}

		// Cancel DeliveryOrder
		vm.cancelDeliveryOrder = function() {
			vm.lockButtons = true;

			HttpSvc.post('deliveryorderconsolidations/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.checkResult(result, "cancelled");
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ************************************************************ */

		// Open Modal Dialog
		vm.showCreditApprovalModal = function (mode) {
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'creditApprovalModal.html',
				controller: 'DOApproveCreditLimitModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							deliveryOrderId: null,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.approveCreditLimit = true;
					if(mode==1)
					{
						vm.approveDeliveryOrder();
					}
					else if(mode==2)
					{
						vm.submit();
					}
				}, function () {
					vm.lockButtons = false;
				});
		};

		// Request for Credit Limit Approval Modal Dialog
		vm.showRequestCreditApprovalModal = function() {
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'requestCreditApprovalModal.html',
				controller: 'SORequestCreditLimitApprovalModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							deliveryOrderId: null,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					vm.requestCreditApproval = true;
					vm.do.status = "NEW";
					vm.submit();
				}, function () {
					vm.do.status = "NEW";
					vm.submit();
				});
		};

		/* ************************************************************ */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				var bApproveCreditLimit = vm.approveCreditLimit ? "/1" : "";

				HttpSvc.put('deliveryorderconsolidations/' + $stateParams.id + bApproveCreditLimit, vm.do, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result, "updated", 2);
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.submitRequestApproval = function(doId) {
			HttpSvc.post('deliveryorderconsolidations/requestcreditlimitapproval/' + doId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Delivery Order has been created successfully.', Auth.translate('SUCCESS'));
					toastr.info("Your request for Credit Limit Approval has been sent. " +
								"This Delivery Order will be created with status [<b>NEW</b>].", "Request Sent")
					$state.go('deliveryorderconsolidations.update', {'id': doId });
				}, function(error) {
					toastr.error(error, 'Failed To Request For Credit Limit Approval');
					vm.lockButtons = false;
				});
		}

		vm.checkResult = function(result, status, mode)
		{
			if(result.httpStatusCode=="200")
			{
				if(vm.requestCreditApproval)
				{
					vm.submitRequestApproval(vm.do.id);
				}
				else
				{
					toastr.success('Delivery Order has been ' + status + ' successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}
			}
			else if(result.httpStatusCode=="300")
			{
				vm.showCreditApprovalModal(mode);
			}
			else if(result.httpStatusCode=="350")
			{
				vm.showRequestCreditApprovalModal();
			}
			else if(result.httpStatusCode=="400")
			{
				toastr.error(result.message, Auth.translate('ERROR'));
				vm.lockButtons = false;
			}
			else
			{
				toastr.success('Delivery Order has been ' + status + ' successfully.', Auth.translate('SUCCESS'));
				$state.reload();
			}
		}

		/* ************************************************************ */

		vm.selectedDebtorChanged = function() {
			vm.do.debtorId = vm.selectedDebtor.id;
			vm.do.debtorBranchId = null;
			vm.selectedDebtorBranch = null;

			if((vm.do.debtorName!=null && vm.do.debtorName!='') ||
				(vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
				(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
				(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
				(vm.do.debtorAddress3!=null && vm.do.debtorAddress3!='') ||
				(vm.do.debtorState!=null && vm.do.debtorState!='') ||
				(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
				(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
				(vm.do.debtorTel!=null && vm.do.debtorTel!='') ||
				(vm.do.debtorFax!=null && vm.do.debtorFax!=''))
			{
				var qst = 'Do you want to overwrite the customer info with these details?\n\n' +
						  'Company Name : ' + (vm.selectedDebtor.name || '') + '\n' +
						  'Contact Person : ' + (vm.selectedDebtor.contactPerson1 || '') + '\n' +
						  'Address 1 : ' + (vm.selectedDebtor.address1 || '') + '\n' +
						  'Address 2 : ' + (vm.selectedDebtor.address2 || '') + '\n' +
						  'Address 3 : ' + (vm.selectedDebtor.address3 || '') + '\n' +
						  'State : ' + (vm.selectedDebtor.state || '') + '\n' +
						  'Postal Code : ' + (vm.selectedDebtor.postCode || '') + '\n' +
						  'Country : ' + (vm.selectedDebtor.country || '') + '\n' +
						  'Telephone : ' + (vm.selectedDebtor.phone1 || '') + '\n' +
						  'Fax : ' + (vm.selectedDebtor.fax1 || '') + '\n\n';
				var cfm = confirm(qst);

				if(cfm)
				{
					vm.do.debtorName = vm.selectedDebtor.name;
					vm.do.debtorContactPerson = vm.selectedDebtor.contactPerson1;
					vm.do.debtorAddress1 = vm.selectedDebtor.address1;
					vm.do.debtorAddress2 = vm.selectedDebtor.address2;
					vm.do.debtorAddress3 = vm.selectedDebtor.address3;
					vm.do.debtorState = vm.selectedDebtor.state;
					vm.do.debtorPostCode = vm.selectedDebtor.postCode;
					vm.do.debtorCountry = vm.selectedDebtor.country;
					vm.do.debtorTel = vm.selectedDebtor.phone1;
					vm.do.debtorFax = vm.selectedDebtor.fax1;
				}
			}
			else
			{
				vm.do.debtorName = vm.selectedDebtor.name;
				vm.do.debtorContactPerson = vm.selectedDebtor.contactPerson1;
				vm.do.debtorAddress1 = vm.selectedDebtor.address1;
				vm.do.debtorAddress2 = vm.selectedDebtor.address2;
				vm.do.debtorAddress3 = vm.selectedDebtor.address3;
				vm.do.debtorState = vm.selectedDebtor.state;
				vm.do.debtorPostCode = vm.selectedDebtor.postCode;
				vm.do.debtorCountry = vm.selectedDebtor.country;
				vm.do.debtorTel = vm.selectedDebtor.phone1;
				vm.do.debtorFax = vm.selectedDebtor.fax1;
			}

			toastr.info("Customer information updated.", "Customer");

			vm.loadDebtorBranchList();
			vm.updateProductPriceFromSalesConfig();
		}

		vm.selectedDebtorBranchChanged = function() {
			vm.do.debtorBranchId = vm.selectedDebtorBranch.id;

			if((vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
				(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
				(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
				(vm.do.debtorAddress3!=null && vm.do.debtorAddress3!='') ||
				(vm.do.debtorState!=null && vm.do.debtorState!='') ||
				(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
				(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
				(vm.do.debtorTel!=null && vm.do.debtorTel!='') ||
				(vm.do.debtorFax!=null && vm.do.debtorFax!=''))
			{
				var qst = 'Do you want to overwrite the customer info with these details?\n\n' +
						  'Contact Person : ' + (vm.selectedDebtorBranch.contactPerson || '') + '\n' +
						  'Address 1 : ' + (vm.selectedDebtorBranch.address1 || '') + '\n' +
						  'Address 2 : ' + (vm.selectedDebtorBranch.address2 || '') + '\n' +
						  'Address 3 : ' + (vm.selectedDebtorBranch.address3 || '') + '\n' +
						  'State : ' + (vm.selectedDebtorBranch.state || '') + '\n' +
						  'Postal Code : ' + (vm.selectedDebtorBranch.postCode || '') + '\n' +
						  'Country : ' + (vm.selectedDebtorBranch.country || '') + '\n' +
						  'Telephone : ' + (vm.selectedDebtorBranch.phone || '') + '\n' +
						  'Fax : ' + (vm.selectedDebtorBranch.fax || '') + '\n\n';
				var cfm = confirm(qst);

				if(cfm)
				{
					vm.do.debtorContactPerson = vm.selectedDebtorBranch.contactPerson;
					vm.do.debtorAddress1 = vm.selectedDebtorBranch.address1;
					vm.do.debtorAddress2 = vm.selectedDebtorBranch.address2;
					vm.do.debtorAddress3 = vm.selectedDebtorBranch.address3;
					vm.do.debtorState = vm.selectedDebtorBranch.state;
					vm.do.debtorPostCode = vm.selectedDebtorBranch.postCode;
					vm.do.debtorCountry = vm.selectedDebtorBranch.country;
					vm.do.debtorTel = vm.selectedDebtorBranch.phone;
					vm.do.debtorFax = vm.selectedDebtorBranch.fax;
				}
			}
			else
			{
				vm.do.debtorContactPerson = vm.selectedDebtorBranch.contactPerson;
				vm.do.debtorAddress1 = vm.selectedDebtorBranch.address1;
				vm.do.debtorAddress2 = vm.selectedDebtorBranch.address2;
				vm.do.debtorAddress3 = vm.selectedDebtorBranch.address3;
				vm.do.debtorState = vm.selectedDebtorBranch.state;
				vm.do.debtorPostCode = vm.selectedDebtorBranch.postCode;
				vm.do.debtorCountry = vm.selectedDebtorBranch.country;
				vm.do.debtorTel = vm.selectedDebtorBranch.phone;
				vm.do.debtorFax = vm.selectedDebtorBranch.fax;
			}

			toastr.info("Customer Address information updated.", "Customer Address");
		}

		/* ************************************************************ */

		vm.updateProductPriceFromSalesConfig = function() {
			var params = {
				salesorderitem: vm.do.deliveryOrderProducts,
				filter: {
					debtorId: vm.do.debtorId
				}
			};

			HttpSvc.post('salesorders/refreshsalesorderproduct', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.do.deliveryOrderProducts = [];
					result.forEach(function(p) {
						vm.do.deliveryOrderProducts.push(p);
					});
					vm.recalculateGrandTotal();

					vm.lockButtons = false;
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					vm.lockButtons = false;
					return;
				});
		}

		/* ************************************************************ */

		// Remove Product
		vm.removeProduct = function(index) {
			vm.do.deliveryOrderProducts.splice(index, 1);
			//$scope.$broadcast('refreshStTable');
		};

		// Update Product
		vm.updateProduct = function(index, obj) {

			var element = {
				id: obj.id,
				deliveryOrderId: obj.deliveryOrderId,
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				itemType: obj.itemType,
				productCode: obj.productCode==null?obj.itemCode:obj.productCode,
				productName: obj.productName==null?obj.itemName:obj.productName,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId==null?obj.uomId:obj.unitOfMeasurementId,
				uomName: obj.uomName,
				unitPrice: obj.unitPrice,
				discountAmount: obj.discountAmount,
				discountPercentage: obj.discountPercentage,
				taxCode: obj.taxCode,
				tax: obj.tax,
				subtotal: obj.subtotal,
				quantityStockedOut: obj.quantityStockedOut,
				quantityTransported: obj.quantityTransported,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
				remarks: obj.remarks,

				isCwm: obj.isCwm,
				invUomId: obj.invUomId,
				invUomId_Parallel: obj.invUomId_Parallel,
				invUomName: obj.invUomName,
				invUomName_Parallel: obj.invUomName_Parallel,
				invBalance: obj.invBalance,
				invBalance_Parallel: obj.invBalance_Parallel,
				totalNewSalesOrderQuantity: obj.totalNewSalesOrderQuantity,
				totalConfirmedSalesOrderQuantity: obj.totalConfirmedSalesOrderQuantity,
				totalDOPendingQuantity: obj.totalDOPendingQuantity,
			};
			vm.do.deliveryOrderProducts.splice(index, 1, element);
		};

		// Add Product
		vm.addProduct = function(obj) {
			var isFound = false;
			var objIdx = null;

			for (var i = 0; i < vm.do.deliveryOrderProducts.length; i++) {
				var d = vm.do.deliveryOrderProducts[i];
				if(d.itemId==obj.itemId && d.semiFinishedProductId==obj.semiFinishedProductId && d.productId==obj.productId)
				{
					isFound = true;
					objIdx = i;
				}
			}

			if(isFound)
			{
				toastr.warning('The same item already exists on the list. Additional Quantity, Tax and Amount will be added.', 'Duplicate Item');
				var d = vm.do.deliveryOrderProducts[objIdx];
				d.quantity += obj.quantity;
				d.unitPrice = obj.unitPrice;
				d.discountAmount += obj.discountAmount;
				d.discountPercentage += obj.discountPercentage;
				d.tax += obj.tax;
				d.subtotal += obj.subtotal;
				d.quantityStockedOut = obj.quantityStockedOut;
				d.quantityTransported = obj.quantityTransported;
				d.remarks = obj.remarks;

				d.isCwm = obj.isCwm;
				d.invUomId = obj.invUomId;
				d.invUomId_Parallel = obj.invUomId_Parallel;
				d.invUomName = obj.invUomName;
				d.invUomName_Parallel = obj.invUomName_Parallel;
				d.invBalance = obj.invBalance;
				d.invBalance_Parallel = obj.invBalance_Parallel;
				d.totalNewSalesOrderQuantity = obj.totalNewSalesOrderQuantity;
				d.totalConfirmedSalesOrderQuantity = obj.totalConfirmedSalesOrderQuantity;
				d.totalDOPendingQuantity = obj.totalDOPendingQuantity;
				return;
			}

			var element = {
				id: obj.id,
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				itemType: obj.itemType,
				productCode: obj.productCode==null?obj.itemCode:obj.productCode,
				productName: obj.productName==null?obj.itemName:obj.productName,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId==null?obj.uomId:obj.unitOfMeasurementId,
				uomName: obj.uomName,
				unitPrice: obj.unitPrice,
				discountAmount: obj.discountAmount,
				discountPercentage: obj.discountPercentage,
				taxCode: obj.taxCode,
				tax: obj.tax,
				subtotal: obj.subtotal,
				quantityStockedOut: obj.quantityStockedOut,
				quantityTransported: obj.quantityTransported,
				remarks: obj.remarks,

				isCwm: obj.isCwm,
				invUomId: obj.invUomId,
				invUomId_Parallel: obj.invUomId_Parallel,
				invUomName: obj.invUomName,
				invUomName_Parallel: obj.invUomName_Parallel,
				invBalance: obj.invBalance,
				invBalance_Parallel: obj.invBalance_Parallel,
				totalNewSalesOrderQuantity: obj.totalNewSalesOrderQuantity,
				totalConfirmedSalesOrderQuantity: obj.totalConfirmedSalesOrderQuantity,
				totalDOPendingQuantity: obj.totalDOPendingQuantity,
			};
			vm.do.deliveryOrderProducts.push(element);
		};

		// Refresh Product List
		vm.refreshDeliveryOrderProducts = function(tableState) {
			// Do nothing
		};

		vm.recalculateGrandTotal = function() {
			vm.subtotal = 0;
			vm.grandTotal = 0;

			vm.do.deliveryOrderProducts.forEach(function(p) {
				vm.subtotal += p.subtotal;
			});

			vm.grandTotal += vm.subtotal;
			vm.grandTotal -= (vm.do.discountAmount || 0);
			vm.grandTotal += (vm.do.additionalCharges || 0);
			vm.do.grandTotal = vm.grandTotal;
		}

		vm.calculateDiscountAmount1 = function() {
			if(vm.do.discountPercentage!=null)
			{
				vm.do.discountAmount = vm.subtotal * vm.do.discountPercentage / 100;
				vm.do.discountAmount = Math.round(vm.do.discountAmount * 100) / 100;
			}
			else
			{
				vm.do.discountAmount = null;
			}
			vm.recalculateGrandTotal();
		}

		vm.calculateDiscountAmount2 = function() {
			if(vm.do.discountAmount!=null)
			{
				vm.do.discountPercentage = vm.do.discountAmount / vm.subtotal * 100;
				vm.do.discountPercentage = Math.round(vm.do.discountPercentage * 100) / 100;
			}
			else
			{
				vm.do.discountPercentage = null;
			}
			vm.recalculateGrandTotal();
		}

		vm.getReservedQty = function (obj) {
			return (obj.totalNewSalesOrderQuantity +
				obj.totalConfirmedSalesOrderQuantity +
				obj.totalDOPendingQuantity);
		}

		vm.getAvailableQty = function (obj) {
			return (obj.invBalance -
				obj.totalNewSalesOrderQuantity -
				obj.totalConfirmedSalesOrderQuantity -
				obj.totalDOPendingQuantity);
		}

		/* ************************************************************ */

		// Open Modal Dialog
		vm.product = {};
		vm.showAddProductModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'productModal.html',
				controller: 'DeliveryOrderProductModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.product,
							debtorId: vm.do.debtorId
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addProduct(data);
				}, function () {
				});
		};
		vm.showEditProductModal = function (index) {
			vm.product = angular.copy(vm.do.deliveryOrderProducts[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'productModal.html',
				controller: 'DeliveryOrderProductModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.product,
							debtorId: vm.do.debtorId
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateProduct(index, data);
				}, function () {
				});
		};

		/* ************************************************************ */

		vm.clearSelectSalesOrder = function () {
			vm.do.salesOrderId = null;
			vm.do.salesOrderNo = null;
		}

		vm.showSelectSalesOrderModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'salesOrderListModal.html',
				controller: 'DeliveryOrderSelectSOModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (salesOrderId) {
					vm.populateSalesOrder(salesOrderId);
				}, function () {
				});
		};

		vm.populateSalesOrder = function(salesOrderId) {

			if(vm.do.deliveryOrderProducts.length>0) {
				var toProceed = confirm('This action will overwrite the existing products in the Product List.\n\nConfirm Proceed?');
				if(!toProceed) return;

				vm.do.deliveryOrderProducts = [];
			}

			var params = { id: salesOrderId };
			HttpSvc.get('salesorders/web/delivery/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.do.transferId = null;
					vm.do.stockTransferNo = null;

					var salesOrder = result;
					vm.do.debtorId = salesOrder.debtorId;
					vm.do.debtorBranchId = salesOrder.debtorBranchId;
					vm.do.deliveryOrderDate = $filter('date')(salesOrder.deliveryDate, 'yyyy-MM-dd');
					vm.do.salesOrderId = salesOrderId;
					vm.do.salesOrderNo = salesOrder.salesOrderNo;
					vm.do.customerPoNo = salesOrder.customerPoNo;
					vm.do.grandTotal = salesOrder.grandTotal;
					vm.do.remarks = salesOrder.description;
					vm.do.discountAmount = salesOrder.discountAmount;
					vm.do.discountPercentage = salesOrder.discountPercentage;
					vm.do.additionalChargesDesc = salesOrder.additionalChargesDesc;
					vm.do.additionalCharges = salesOrder.additionalCharges;

					vm.debtorList.forEach(function(d) {
						if(d.id==salesOrder.debtorId) {
							vm.selectedDebtor = d;
						}
					});

					vm.loadDebtorBranchList();

					if((vm.do.debtorName!=null && vm.do.debtorName!='') ||
						(vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
						(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
						(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
						(vm.do.debtorState!=null && vm.do.debtorState!='') ||
						(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
						(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
						(vm.do.debtorTel!=null && vm.do.debtorTel!=''))
					{
						var qst = 'Do you want to overwrite the customer info with these details?\n\n' +
								  'Company Name : ' + (salesOrder.userFullName || '') + '\n' +
								  'Contact Person : ' + (salesOrder.userFullName || '') + '\n' +
								  'Address 1 : ' + (salesOrder.debtorAddress1 || '') + '\n' +
								  'Address 2 : ' + (salesOrder.debtorAddress2 || '') + '\n' +
								  'Address 3 :\n' +
								  'State : ' + (salesOrder.debtorState || '') + '\n' +
								  'Postal Code : ' + (salesOrder.debtorPostCode || '') + '\n' +
								  'Country : ' + (salesOrder.debtorCountry || '') + '\n' +
								  'Telephone : ' + (salesOrder.debtorPhone || '') + '\n' +
								  'Fax : \n\n';
						var cfm = confirm(qst);

						if(cfm)
						{
							vm.do.debtorName = salesOrder.debtorName;
							vm.do.debtorContactPerson = salesOrder.debtorContactPerson;
							vm.do.debtorAddress1 = salesOrder.debtorAddress1;
							vm.do.debtorAddress2 = salesOrder.debtorAddress2;
							vm.do.debtorAddress3 = salesOrder.debtorAddress3;
							vm.do.debtorState = salesOrder.debtorState;
							vm.do.debtorPostCode = salesOrder.debtorPostCode;
							vm.do.debtorCountry = salesOrder.debtorCountry;
							vm.do.debtorTel = salesOrder.debtorPhone;
							vm.do.debtorFax = salesOrder.debtorFax;
						}
					}
					else
					{
						vm.do.debtorName = salesOrder.debtorName;
						vm.do.debtorContactPerson = salesOrder.debtorContactPerson;
						vm.do.debtorAddress1 = salesOrder.debtorAddress1;
						vm.do.debtorAddress2 = salesOrder.debtorAddress2;
						vm.do.debtorAddress3 = salesOrder.debtorAddress3;
						vm.do.debtorState = salesOrder.debtorState;
						vm.do.debtorPostCode = salesOrder.debtorPostCode;
						vm.do.debtorCountry = salesOrder.debtorCountry;
						vm.do.debtorTel = salesOrder.debtorPhone;
						vm.do.debtorFax = salesOrder.debtorFax;
					}

					salesOrder.salesOrderProducts.forEach(function(p) {
						vm.addProduct(p);
					});

					vm.recalculateGrandTotal();

				}, function() {
					toastr.error('Failed to load selected Sales Order.', Auth.translate('ERROR'))
					return;
				});
		};

		/* ************************************************************ */

		vm.clearSelectStockTransfer = function () {
			vm.do.transferId = null;
			vm.do.stockTransferNo = null;
		}

		vm.showSelectStockTransferModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'stockTransferListModal.html',
				controller: 'DeliveryOrderSelectSTModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (transferId) {
					vm.populateStockTransfer(transferId);
				}, function () {
				});
		};

		vm.populateStockTransfer = function(transferId) {

			if(vm.do.deliveryOrderProducts.length>0) {
				var toProceed = confirm('This action will overwrite the existing products in the Product List.\n\nConfirm Proceed?');
				if(!toProceed) return;

				vm.do.deliveryOrderProducts = [];
			}

			var params = { id: transferId };
			HttpSvc.get('stocktransfers/web/delivery/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.do.salesOrderId = null;
					vm.do.salesOrderNo = null;
					vm.selectedDebtor = null;
					vm.selectedDebtorBranch = null;

					var transfer = result;
					vm.do.debtorId = null;
					vm.do.debtorBranchId = null;
					vm.do.deliveryOrderDate = $filter('date')(new Date(), 'yyyy-MM-dd');
					vm.do.transferId = transferId;
					vm.do.stockTransferNo = transfer.docNo;
					vm.do.grandTotal = 0;

					if((vm.do.debtorName!=null && vm.do.debtorName!='') ||
						(vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
						(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
						(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
						(vm.do.debtorState!=null && vm.do.debtorState!='') ||
						(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
						(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
						(vm.do.debtorTel!=null && vm.do.debtorTel!=''))
					{
						var qst = 'Do you want to overwrite the Recipient info with these details?\n\n' +
								  'Company Name : ' + (transfer.destBranchName || '') + '\n' +
								  'Contact Person : ' + (transfer.destBranchContactPerson || '') + '\n' +
								  'Address 1 : ' + (transfer.destBranchAddress1 || '') + '\n' +
								  'Address 2 : ' + (transfer.destBranchAddress2 || '') + '\n' +
								  'Address 3 : ' + (transfer.destBranchAddress3 || '') + '\n' +
								  'State : ' + (transfer.destBranchState || '') + '\n' +
								  'Postal Code : ' + (transfer.destBranchPostCode || '') + '\n' +
								  'Country : ' + (transfer.destBranchCountry || '') + '\n' +
								  'Telephone : ' + (transfer.destBranchTel || '') + '\n' +
								  'Telephone : ' + (transfer.destBranchFax || '') + '\n' +
								  'Fax : \n\n';
						var cfm = confirm(qst);

						if(cfm)
						{
							vm.do.debtorName = transfer.destBranchName;
							vm.do.debtorContactPerson = transfer.destBranchContactPerson;
							vm.do.debtorAddress1 = transfer.destBranchAddress1;
							vm.do.debtorAddress2 = transfer.destBranchAddress2;
							vm.do.debtorAddress3 = transfer.destBranchAddress3;
							vm.do.debtorState = transfer.destBranchState;
							vm.do.debtorPostCode = transfer.destBranchPostCode;
							vm.do.debtorCountry = transfer.destBranchCountry;
							vm.do.debtorTel = transfer.destBranchTel;
							vm.do.debtorFax = transfer.destBranchFax;
						}
					}
					else
					{
						vm.do.debtorName = transfer.destBranchName;
						vm.do.debtorContactPerson = transfer.destBranchContactPerson;
						vm.do.debtorAddress1 = transfer.destBranchAddress1;
						vm.do.debtorAddress2 = transfer.destBranchAddress2;
						vm.do.debtorAddress3 = transfer.destBranchAddress3;
						vm.do.debtorState = transfer.destBranchState;
						vm.do.debtorPostCode = transfer.destBranchPostCode;
						vm.do.debtorCountry = transfer.destBranchCountry;
						vm.do.debtorTel = transfer.destBranchTel;
						vm.do.debtorFax = transfer.destBranchFax;
					}

					transfer.stockTransferDetails.forEach(function(p) {
						vm.addProduct(p);
					});

				}, function() {
					toastr.error('Failed to retrieve selected Stock Transfer details.', Auth.translate('ERROR'))
					return;
				});
		};

		/* ************************************************************ */

		// Call Actions
		vm.loadDebtorList();
	};

	// Product Modal Controller
	function ConsoDeliveryOrderProductModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.mode = item.mode;
		$mdl.title = item.title;
		$mdl.item = item.object;
		$mdl.debtorId = item.debtorId;
		$mdl.itemList = [];
		$mdl.selectedItem = null;
		$mdl.lockButtons = false;
		$mdl.currencyCode = Auth.getCurrency();
		$mdl.isInit = true;

		/* ********************************************************* */

		$mdl.selectedItemChanged = function() {
			if(!$mdl.selectedItem) return;

			$mdl.item.itemId = $mdl.selectedItem.itemId;
			$mdl.item.semiFinishedProductId = $mdl.selectedItem.semiFinishedProductId;
			$mdl.item.productId = $mdl.selectedItem.productId;
			$mdl.item.productCode = $mdl.selectedItem.productCode;
			$mdl.item.productName = $mdl.selectedItem.productName;
			$mdl.item.itemType = $mdl.selectedItem.itemType;
			$mdl.item.unitPrice = $mdl.selectedItem.posPrice;
			$mdl.item.tax = $mdl.selectedItem.posTax;
			$mdl.item.taxPercent = $mdl.selectedItem.posTaxPercent;
			$mdl.item.taxCode = $mdl.selectedItem.posTaxCode || '';
			if($mdl.mode==2)
			{
				if($mdl.item.unitOfMeasurementId != $mdl.selectedItem.unitOfMeasurementId && $mdl.item.unitOfMeasurementId==null)
				{
					$mdl.item.unitOfMeasurementId = $mdl.selectedItem.unitOfMeasurementId;
					$mdl.item.uomName = $mdl.selectedItem.uomName;
				}
			}
			else
			{
				$mdl.item.unitOfMeasurementId = $mdl.selectedItem.unitOfMeasurementId;
				$mdl.item.uomName = $mdl.selectedItem.uomName;
			}

			$mdl.item.isCwm = $mdl.selectedItem.isCwm;
			$mdl.item.invUomId = $mdl.selectedItem.invUomId;
			$mdl.item.invUomId_Parallel = $mdl.selectedItem.invUomId_Parallel;
			$mdl.item.invUomName = $mdl.selectedItem.invUomName;
			$mdl.item.invUomName_Parallel = $mdl.selectedItem.invUomName_Parallel;
			$mdl.item.invBalance = $mdl.selectedItem.invBalance;
			$mdl.item.invBalance_Parallel = $mdl.selectedItem.invBalance_Parallel;
			$mdl.item.totalNewSalesOrderQuantity = $mdl.selectedItem.totalNewSalesOrderQuantity;
			$mdl.item.totalConfirmedSalesOrderQuantity = $mdl.selectedItem.totalConfirmedSalesOrderQuantity;
			$mdl.item.totalDOPendingQuantity = $mdl.selectedItem.totalDOPendingQuantity;

			$mdl.recalculateTaxAndTotal();
		};

		$mdl.quantityChanged = function()
		{
			$mdl.calculateDiscountAmount1();
		}

		$mdl.calculateDiscountAmount1 = function()
		{
			if($mdl.item.discountPercentage!=null)
			{
				$mdl.item.discountAmount = $mdl.item.unitPrice * $mdl.item.quantity * $mdl.item.discountPercentage / 100;
				$mdl.item.discountAmount = Math.round($mdl.item.discountAmount * 100) / 100;
			}
			else
			{
				$mdl.item.discountAmount = null;
			}

			$mdl.recalculateTaxAndTotal();
		}

		$mdl.calculateDiscountAmount2 = function()
		{
			if($mdl.item.discountAmount!=null)
			{
				$mdl.item.discountPercentage = $mdl.item.discountAmount / ($mdl.item.unitPrice * $mdl.item.quantity) * 100;
				$mdl.item.discountPercentage = Math.round($mdl.item.discountPercentage * 100) / 100;
			}
			else
			{
				$mdl.item.discountPercentage = null;
			}

			$mdl.recalculateTaxAndTotal();
		}

		$mdl.recalculateTaxAndTotal = function()
		{
			$mdl.item.tax = (($mdl.item.unitPrice * $mdl.item.quantity) - $mdl.item.discountAmount) * $mdl.item.taxPercent / 100;
			$mdl.item.tax = Math.round($mdl.item.tax * 100) / 100;
			$mdl.item.subtotal =  (($mdl.item.unitPrice * $mdl.item.quantity) - $mdl.item.discountAmount) + $mdl.item.tax;
			$mdl.item.subtotal = Math.round($mdl.item.subtotal * 100) / 100;
		}

		/* ********************************************************* */

		// Load Item List
		$mdl.searchItem = function(searchString) {

			if(searchString==null || searchString.trim()=="") return;

			$mdl.lockButtons = true;

			var keyword = encodeURIComponent(searchString);
			var params = {
				debtorId: $mdl.debtorId
			};

			HttpSvc.post('searchengine/search/itemssalesconfig/' + keyword, params, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.itemList = result;

					if($mdl.isInit)
					{
						if($mdl.itemList.length>0)
							$mdl.selectedItem = $mdl.itemList[0];
						$mdl.isInit = false;
					}
					$mdl.selectedItemChanged();

					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Raw Material list.', '');
					return null;
				});
		};

		/* ********************************************************* */

		// Initialize
		if(item.mode==1) {
			$mdl.item.itemId = null;
			$mdl.item.productId = null;
			$mdl.item.semiFinishedProductId = null;
			$mdl.item.productCode = "";
			$mdl.item.productName = "";
			$mdl.item.itemType = "";
			$mdl.item.quantity = 1;
			$mdl.item.unitPrice = 0;
			$mdl.item.tax = 0;
			$mdl.item.taxPercent = 0;
			$mdl.item.taxCode = '';
			$mdl.item.discountAmount = null;
			$mdl.item.discountPercentage = null;
			$mdl.item.subtotal = 0;
			$mdl.item.quantityStockedOut = 0;
		} else {
			$mdl.originalQuantity = $mdl.item.quantity;
			$mdl.searchItem($mdl.item.productCode);
		}

		/* ********************************************************* */

		$mdl.confirmModal = function()
		{
			if(!$mdl.productForm.$valid)
			{
				toastr.error('Please fill up all the required fields.', Auth.translate('ERROR'));
			}
			else
			{
				if($mdl.item.quantity < $mdl.item.quantityStockedOut)
				{
					return;
				}
				else
				{
					$uibModalInstance.close($mdl.item);
				}
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

})();


(function() {
    'use strict';

    angular.module('RmsAppV2.pages.deliveryorders.controller', [])
        .controller('DeliveryOrderMainCtrl', DeliveryOrderMainCtrl)
        .controller('DeliveryOrderCreateCtrl', DeliveryOrderCreateCtrl)
        .controller('DeliveryOrderUpdateCtrl', DeliveryOrderUpdateCtrl)
        .controller('DeliveryOrderSerialNumberModalCtrl', DeliveryOrderSerialNumberModalCtrl)
        .controller('DeliveryOrderPrintModalCtrl', DeliveryOrderPrintModalCtrl)
        .controller('DeliveryOrderProductModalCtrl', DeliveryOrderProductModalCtrl)
        .controller('DeliveryOrderSelectSOModalCtrl', DeliveryOrderSelectSOModalCtrl)
        .controller('DeliveryOrderSelectSTModalCtrl', DeliveryOrderSelectSTModalCtrl)
        .controller('DeliveryOrderDownloadExcelModalCtrl', DeliveryOrderDownloadExcelModalCtrl)
        .controller('DOApproveCreditLimitModalCtrl', DOApproveCreditLimitModalCtrl)
        .controller('DORequestCreditLimitApprovalModalCtrl', DORequestCreditLimitApprovalModalCtrl);

    /** @ngInject */
    function DeliveryOrderMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.data = [];
		vm.showCdoPanel = false;
		vm.showPsPanel = false;
		vm.selectedDOs = [];
		vm.isInvoiceEnabledForSO = Auth.isInvoiceEnabledForSO();

		vm.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.deliveryOrderNo,
				deliveryOrderDate: predicate.deliveryOrderDate,
				sourceDocNo: predicate.sourceDocNo,
				debtorName: predicate.debtorName,
				status: predicate.status,
				createdBy: predicate.createdBy,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('deliveryorders/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			return tableState;
		};

		vm.resetSearch = function()
		{
		}

		/* ************************************************************ */

        vm.showSerialNumber = function (docId, docNo) {

            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'serialNumberModal.html',
                controller: 'DeliveryOrderSerialNumberModalCtrl',
                controllerAs: '$mdl',
                size: 'lg',
                resolve: {
                    item: function () {
                        return {
                            object: {
                                docId: docId,
                                docNo: docNo
                            },
                        }
                    }
                }
            });

            modalInstance
                .result
                .then(function (data) {
                }, function () {
                });
        };

		// Show Print Dialog
		vm.showPrintDialog = function (docId, docNo) {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'printModal.html',
				controller: 'DeliveryOrderPrintModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							object: {
								docId: docId,
								docNo: docNo
							},
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

		vm.printDeliveryOrder = function(deliveryOrderId, deliveryOrderNo) {

			var filename = "DELIVERYORDER_" + deliveryOrderNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('deliveryorders/print/deliveryorder/' + deliveryOrderId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to print Delivery Order. ' + error, '');
							return null;
						});
		}

		vm.printInvoice = function(deliveryOrderId, invoiceNo) {

			var filename = "INVOICE_" + invoiceNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('deliveryorders/print/invoice/' + deliveryOrderId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to print Invoice. ' + error, '');
							return null;
						});
		}

		vm.showDownloadExcelModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'downloadModal.html',
				controller: 'DeliveryOrderDownloadExcelModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

		// Confirmed DeliveryOrder
		vm.confirmDeliveryOrder = function(deliveryOrderId) {
			HttpSvc.put('deliveryorders/confirm/' + deliveryOrderId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Delivery Order status updated to CONFIRMED.', 'CONFIRMED');
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		// Complete DeliveryOrder
		vm.completeDeliveryOrder = function(deliveryOrderId) {
			HttpSvc.put('deliveryorders/complete/' + deliveryOrderId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Delivery Order status updated to COMPLETED.', 'COMPLETED');
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		// Cancel DeliveryOrder
		vm.cancelDeliveryOrder = function(deliveryOrderId) {
			HttpSvc.put('deliveryorders/cancel/' + deliveryOrderId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Delivery Order status updated to CANCELLED.', 'CANCELLED');
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		/* ************************************************************* */

		vm.showPSPanel = function() {
			vm.showPsPanel = true;
		}

		vm.closePSPanel = function() {
			vm.selectedDOs = [];
			vm.showPsPanel = false;
		}

		vm.createPS = function() {

			var resp = confirm('Are you sure to proceed to create Picking List from the selected Delivery Order(s)?');
			if(!resp) return;

			if(vm.selectedDOs.length <= 0) {
				alert('You must select at least one Delivery Order to proceed.');
				return;
			}
            var date = new Date();
            var dateString = $filter('date')(date, 'yyyyMMdd');
			
			var filename = "DELIVERYORDER_PICKINGLIST_" + dateString + ".pdf";

			HttpSvc.postPdfObject("deliveryorders/print/pickinglist", vm.selectedDOs, Auth.getTokenId(), filename)
				.then(function(result) {
					toastr.success('Picking List generated successfully!');
					vm.closePSPanel();
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Picking List Failed');
					return null;
				});
		}

		/* ************************************************************* */

		vm.showCDOPanel = function() {
			vm.showCdoPanel = true;
		}

		vm.closeCDOPanel = function() {
			vm.selectedDOs = [];
			vm.showCdoPanel = false;
		}

		vm.selectAll = function() {
			vm.selectedDOs = [];
			vm.data.forEach( function(d) {
				if(d.status=='APPROVED' || d.status=='PROCESSING')
				{
					vm.selectedDOs.push(d.id);
				}
			});
		}

		vm.deselectAll = function() {
			vm.selectedDOs = [];
		}

		vm.createCDO = function() {

			var resp = confirm('Are you sure to proceed to consolidate selected Delivery Order(s)?');
			if(!resp) return;

			if(vm.selectedDOs.length <= 0) {
				alert('You must select at least one Delivery Order to proceed.');
				return;
			}

			HttpSvc.post("deliveryorderconsolidations", vm.selectedDOs, Auth.getTokenId())
				.then(function(result) {
					toastr.success('Consolidated Delivery Order generated successfully!');
					vm.closeCDOPanel();
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Consolidation Failed');
					return null;
				});
		}

		/* ************************************************************* */
	};

	/** @ngInject */
    function DeliveryOrderCreateCtrl($scope, $state, $filter, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.isRmsLite = Auth.isLiteMode();

		vm.doStatuses = ['NEW', 'CONFIRMED'];
		vm.doStatuses.selected = 'NEW';
		vm.mode = 1;
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.shippingMethods = [];
		vm.originalStatus = 'NEW';
		vm.selectedDebtor = null;
		vm.selectedDebtorBranch = null;
		vm.selectedShippingMethod = null;
		vm.currency = Auth.getCurrency();
		vm.subtotal = 0;
		vm.grandTotal = 0;
        vm.isShippingFeesEnabled = Auth.hasCompanyFeature('maintenance.shippingfees');

		/* ************************************************************ */

		// Set Default DeliveryOrder Date
		vm.setDefault = function() {
			vm.do = {};
			vm.do.status = 'NEW';
			vm.do.deliveryOrderProducts = [];
			vm.do.deliveryOrderDate = $filter('date')(new Date(), 'yyyy-MM-dd hh:mma');
			vm.doStatuses.selected = 'NEW';

			vm.loadDebtorList();
		}

		// Load Debtor List
		vm.loadDebtorList = function() {
			HttpSvc.get('debtors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					vm.loadShippingMethods();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve product list.', '');
					return null;
			});
		}

		// Load Debtor List
		vm.loadShippingMethods = function() {

			var params = {
				type: "SPM",
				pageSize: 9999,
				pageNumber: 1,
				sortBy: "name"
			};

			HttpSvc.post('customdatalists/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.shippingMethods = result.data;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Shipping Methods.', '');
					return null;
			});
		}

		// Load Debtor Branch List
		vm.loadDebtorBranchList = function() {
			if(vm.do.debtorId==null || vm.do.debtorId=="") return;

			HttpSvc.get('debtors/' + vm.do.debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorBranchList = result;

					vm.debtorBranchList.forEach(function(d) {
						if(d.id==vm.do.debtorBranchId)
						{
							vm.selectedDebtorBranch = d;
						}
					})
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Customer Branch list.', '');
					return null;
			});
		}

		/* ************************************************************ */

		vm.selectedDebtorChanged = function() {
			vm.do.debtorId = vm.selectedDebtor.id;
			vm.do.debtorBranchId = null;
			vm.selectedDebtorBranch = null;

			if((vm.do.debtorName!=null && vm.do.debtorName!='') ||
				(vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
				(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
				(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
				(vm.do.debtorAddress3!=null && vm.do.debtorAddress3!='') ||
				(vm.do.debtorState!=null && vm.do.debtorState!='') ||
				(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
				(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
				(vm.do.debtorTel!=null && vm.do.debtorTel!='') ||
				(vm.do.debtorFax!=null && vm.do.debtorFax!=''))
			{
				var qst = 'Do you want to overwrite the customer info with these details?\n\n' +
						  'Company Name : ' + (vm.selectedDebtor.name || '') + '\n' +
						  'Contact Person : ' + (vm.selectedDebtor.deliveryContactPerson1 || '') + '\n' +
						  'Address 1 : ' + (vm.selectedDebtor.deliveryAddress1 || '') + '\n' +
						  'Address 2 : ' + (vm.selectedDebtor.deliveryAddress2 || '') + '\n' +
						  'Address 3 : ' + (vm.selectedDebtor.deliveryAddress3 || '') + '\n' +
						  'State : ' + (vm.selectedDebtor.deliveryState || '') + '\n' +
						  'Postal Code : ' + (vm.selectedDebtor.deliveryPostCode || '') + '\n' +
						  'Country : ' + (vm.selectedDebtor.deliveryCountry || '') + '\n' +
						  'Telephone : ' + (vm.selectedDebtor.deliveryPhone1 || '') + '\n' +
						  'Fax : ' + (vm.selectedDebtor.deliveryFax1 || '') + '\n\n';
				var cfm = confirm(qst);

				if(cfm)
				{
					vm.do.debtorName = vm.selectedDebtor.name;
                    vm.do.debtorContactPerson = vm.selectedDebtor.deliveryContactPerson1;
                    vm.do.debtorAddress1 = vm.selectedDebtor.deliveryAddress1;
                    vm.do.debtorAddress2 = vm.selectedDebtor.deliveryAddress2;
                    vm.do.debtorAddress3 = vm.selectedDebtor.deliveryAddress3;
                    vm.do.debtorState = vm.selectedDebtor.deliveryState;
                    vm.do.debtorPostCode = vm.selectedDebtor.deliveryPostCode;
                    vm.do.debtorCountry = vm.selectedDebtor.deliveryCountry;
                    vm.do.debtorTel = vm.selectedDebtor.deliveryPhone1;
                    vm.do.debtorFax = vm.selectedDebtor.deliveryFax1;
				}
			}
			else
			{
				vm.do.debtorName = vm.selectedDebtor.name;
                vm.do.debtorContactPerson = vm.selectedDebtor.deliveryContactPerson1;
                vm.do.debtorAddress1 = vm.selectedDebtor.deliveryAddress1;
                vm.do.debtorAddress2 = vm.selectedDebtor.deliveryAddress2;
                vm.do.debtorAddress3 = vm.selectedDebtor.deliveryAddress3;
                vm.do.debtorState = vm.selectedDebtor.deliveryState;
                vm.do.debtorPostCode = vm.selectedDebtor.deliveryPostCode;
                vm.do.debtorCountry = vm.selectedDebtor.deliveryCountry;
                vm.do.debtorTel = vm.selectedDebtor.deliveryPhone1;
                vm.do.debtorFax = vm.selectedDebtor.deliveryFax1;
			}

			toastr.info("Customer information updated.", "Customer");

			vm.loadDebtorBranchList();
			vm.updateProductPriceFromSalesConfig();
		}

		vm.selectedDebtorBranchChanged = function() {
			vm.do.debtorBranchId = vm.selectedDebtorBranch.id;

			if((vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
				(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
				(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
				(vm.do.debtorAddress3!=null && vm.do.debtorAddress3!='') ||
				(vm.do.debtorState!=null && vm.do.debtorState!='') ||
				(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
				(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
				(vm.do.debtorTel!=null && vm.do.debtorTel!='') ||
				(vm.do.debtorFax!=null && vm.do.debtorFax!=''))
			{
				var qst = 'Do you want to overwrite the customer info with these details?\n\n' +
						  'Contact Person : ' + (vm.selectedDebtorBranch.contactPerson || '') + '\n' +
						  'Address 1 : ' + (vm.selectedDebtorBranch.address1 || '') + '\n' +
						  'Address 2 : ' + (vm.selectedDebtorBranch.address2 || '') + '\n' +
						  'Address 3 : ' + (vm.selectedDebtorBranch.address3 || '') + '\n' +
						  'State : ' + (vm.selectedDebtorBranch.state || '') + '\n' +
						  'Postal Code : ' + (vm.selectedDebtorBranch.postCode || '') + '\n' +
						  'Country : ' + (vm.selectedDebtorBranch.country || '') + '\n' +
						  'Telephone : ' + (vm.selectedDebtorBranch.phone || '') + '\n' +
						  'Fax : ' + (vm.selectedDebtorBranch.fax || '') + '\n\n';
				var cfm = confirm(qst);

				if(cfm)
				{
					vm.do.debtorContactPerson = vm.selectedDebtorBranch.contactPerson;
					vm.do.debtorAddress1 = vm.selectedDebtorBranch.address1;
					vm.do.debtorAddress2 = vm.selectedDebtorBranch.address2;
					vm.do.debtorAddress3 = vm.selectedDebtorBranch.address3;
					vm.do.debtorState = vm.selectedDebtorBranch.state;
					vm.do.debtorPostCode = vm.selectedDebtorBranch.postCode;
					vm.do.debtorCountry = vm.selectedDebtorBranch.country;
					vm.do.debtorTel = vm.selectedDebtorBranch.phone;
					vm.do.debtorFax = vm.selectedDebtorBranch.fax;
				}
			}
			else
			{
				vm.do.debtorContactPerson = vm.selectedDebtorBranch.contactPerson;
				vm.do.debtorAddress1 = vm.selectedDebtorBranch.address1;
				vm.do.debtorAddress2 = vm.selectedDebtorBranch.address2;
				vm.do.debtorAddress3 = vm.selectedDebtorBranch.address3;
				vm.do.debtorState = vm.selectedDebtorBranch.state;
				vm.do.debtorPostCode = vm.selectedDebtorBranch.postCode;
				vm.do.debtorCountry = vm.selectedDebtorBranch.country;
				vm.do.debtorTel = vm.selectedDebtorBranch.phone;
				vm.do.debtorFax = vm.selectedDebtorBranch.fax;
			}

			toastr.info("Customer Address information updated.", "Customer Address");
		}

		vm.selectedShippingMethodChanged = function() {
			vm.do.shippingId = vm.selectedShippingMethod.id;
		}

		/* ************************************************************ */

		vm.updateProductPriceFromSalesConfig = function() {
			var params = {
				salesorderitem: vm.do.deliveryOrderProducts,
				filter: {
					debtorId: vm.do.debtorId
				}
			};

			HttpSvc.post('salesorders/refreshsalesorderproduct', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.do.deliveryOrderProducts = [];
					result.forEach(function(p) {
						vm.do.deliveryOrderProducts.push(p);
					});
					vm.calculateDiscountAmount1(false);
					vm.recalculateGrandTotal(true);

					vm.lockButtons = false;
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					vm.lockButtons = false;
					return;
				});
		}

		/* ************************************************************ */

		// Remove Product
		vm.removeProduct = function(index) {
			vm.do.deliveryOrderProducts.splice(index, 1);
			$scope.$broadcast('refreshStTable');
			vm.calculateDiscountAmount1(false);
            vm.recalculateGrandTotal(true);
		};

		// Update Product
		vm.updateProduct = function(index, obj) {

			var element = {
				id: obj.id,
				deliveryOrderId: obj.deliveryOrderId,
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				itemType: obj.itemType,
				productCode: obj.productCode==null?obj.itemCode:obj.productCode,
				productName: obj.productName==null?obj.itemName:obj.productName,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId==null?obj.uomId:obj.unitOfMeasurementId,
				uomName: obj.uomName,
				unitPrice: obj.unitPrice,
				discountAmount: obj.discountAmount,
				discountPercentage: obj.discountPercentage,
				taxCode: obj.taxCode,
				tax: obj.tax,
				subtotal: obj.subtotal,
				quantityStockedOut: obj.quantityStockedOut,
				quantityTransported: obj.quantityTransported,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
				remarks: obj.remarks,

				isCwm: obj.isCwm,
				invUomId: obj.invUomId,
				invUomId_Parallel: obj.invUomId_Parallel,
				invUomName: obj.invUomName,
				invUomName_Parallel: obj.invUomName_Parallel,
				invBalance: obj.invBalance,
				invBalance_Parallel: obj.invBalance_Parallel,
				totalNewSalesOrderQuantity: obj.totalNewSalesOrderQuantity,
				totalConfirmedSalesOrderQuantity: obj.totalConfirmedSalesOrderQuantity,
				totalDOPendingQuantity: obj.totalDOPendingQuantity,
			};
			vm.do.deliveryOrderProducts.splice(index, 1, element);

			vm.calculateDiscountAmount1(false);
			vm.recalculateGrandTotal(true);
		};

		vm.sortDOItems = function() {
			var categoryOrder = ['RAW MAT', 'SEMI FG', 'F.GOODS'];
			vm.do.deliveryOrderProducts.sort(function (a, b) {
        		var categoryComparison = categoryOrder.indexOf((a.itemType || '').toUpperCase()) - categoryOrder.indexOf((b.itemType || '').toUpperCase());
				if (categoryComparison !== 0) {
				return categoryComparison;
				}
				
				// Sort alphabetically
				var productA = a.productName || '';
				var productB = b.productName || '';
				return productA.localeCompare(productB);
			});
		}
		// Add Product
		vm.addProduct = function(obj, isPopulate) {
			var isFound = false;
			var objIdx = null;

			for (var i = 0; i < vm.do.deliveryOrderProducts.length; i++) {
				var d = vm.do.deliveryOrderProducts[i];
				if(d.itemId==obj.itemId && d.semiFinishedProductId==obj.semiFinishedProductId && d.productId==obj.productId)
				{
					isFound = true;
					objIdx = i;
				}
			}

			if(isFound)
			{
				toastr.warning('The same item already exists on the list. Additional Quantity, Tax and Amount will be added.', 'Duplicate Item');
				var d = vm.do.deliveryOrderProducts[objIdx];
				d.quantity += obj.quantity;
				d.unitPrice = obj.unitPrice;
				d.discountAmount += obj.discountAmount;
				d.discountPercentage += obj.discountPercentage;
				d.tax += obj.tax;
				d.subtotal += obj.subtotal;
				d.quantityStockedOut = obj.quantityStockedOut;
				d.quantityTransported = obj.quantityTransported;
				d.remarks = obj.remarks;

				d.isCwm = obj.isCwm;
				d.invUomId = obj.invUomId;
				d.invUomId_Parallel = obj.invUomId_Parallel;
				d.invUomName = obj.invUomName;
				d.invUomName_Parallel = obj.invUomName_Parallel;
				d.invBalance = obj.invBalance;
				d.invBalance_Parallel = obj.invBalance_Parallel;
				d.totalNewSalesOrderQuantity = obj.totalNewSalesOrderQuantity;
				d.totalConfirmedSalesOrderQuantity = obj.totalConfirmedSalesOrderQuantity;
				d.totalDOPendingQuantity = obj.totalDOPendingQuantity;

				vm.calculateDiscountAmount1(false);
				vm.recalculateGrandTotal(true);
				return;
			}

			var element = {
				id: obj.id,
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				itemType: obj.itemType,
				productCode: obj.productCode==null?obj.itemCode:obj.productCode,
				productName: obj.productName==null?obj.itemName:obj.productName,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId==null?obj.uomId:obj.unitOfMeasurementId,
				uomName: obj.uomName,
				unitPrice: obj.unitPrice,
				discountAmount: obj.discountAmount,
				discountPercentage: obj.discountPercentage,
				taxCode: obj.taxCode,
				tax: obj.tax,
				subtotal: obj.subtotal,
				quantityStockedOut: obj.quantityStockedOut,
				quantityTransported: obj.quantityTransported,
				remarks: obj.remarks,

				isCwm: obj.isCwm,
				invUomId: obj.invUomId,
				invUomId_Parallel: obj.invUomId_Parallel,
				invUomName: obj.invUomName,
				invUomName_Parallel: obj.invUomName_Parallel,
				invBalance: obj.invBalance,
				invBalance_Parallel: obj.invBalance_Parallel,
				totalNewSalesOrderQuantity: obj.totalNewSalesOrderQuantity,
				totalConfirmedSalesOrderQuantity: obj.totalConfirmedSalesOrderQuantity,
				totalDOPendingQuantity: obj.totalDOPendingQuantity,
			};
			// vm.do.deliveryOrderProducts.push(element);
			vm.do.deliveryOrderProducts.unshift(element);

			if(!isPopulate)
			{
				vm.calculateDiscountAmount1(false);
			}
		};

		// Refresh Product List
		vm.refreshDeliveryOrderProducts = function(tableState) {
			// Do nothing
		};

        vm.calculateItemSubtotalExcludeTax = function (product) {
            return (product.unitPrice * product.quantity) - (product.discountAmount || 0);
        };

		vm.recalculateGrandTotal = function(calculateShippingFee) {
            vm.subtotal = 0;
            vm.subtotalExcludeTax = 0;
            vm.grandTotal = 0;

            vm.do.deliveryOrderProducts.forEach(function (p) {
                vm.subtotal += p.subtotal;
                if (vm.isShippingFeesEnabled) {
                    vm.subtotalExcludeTax += vm.calculateItemSubtotalExcludeTax(p);
                }
            });

			if (calculateShippingFee && vm.isShippingFeesEnabled) {
				var params = {
					companyId: Auth.getCompanyId(),
					debtorId: vm.do.debtorId,
					subtotalAmount: vm.subtotalExcludeTax,
				};

				HttpSvc.post('salesorders/calculateShippingFee', params, Auth.getTokenId(), false)
					.then(function (result) {
						vm.do.shippingFeeDesc = result.shippingFeeDesc;
						vm.do.shippingFeeCharges = result.shippingFeeCharges;
					}, function (error) {
						return;
					});
			}

			vm.grandTotal += (vm.subtotal || 0);
            vm.grandTotal += (vm.do.shippingFeeCharges || 0);
			vm.grandTotal -= (vm.do.discountAmount || 0);
			vm.grandTotal += (vm.do.additionalCharges || 0);
			vm.do.grandTotal = vm.grandTotal;
		}

		vm.calculateDiscountAmount1 = function (calculateShippingFee) {
			vm.subtotal = 0;
			vm.do.deliveryOrderProducts.forEach(function(p) {
				vm.subtotal += p.subtotal;
			});
			if(vm.do.discountPercentage!=null)
			{
				vm.do.discountAmount = vm.subtotal * vm.do.discountPercentage / 100;
				vm.do.discountAmount = Math.round(vm.do.discountAmount * 100) / 100;
			}
			else
			{
				vm.do.discountAmount = null;
			}
			vm.recalculateGrandTotal(calculateShippingFee);
		}

		vm.calculateDiscountAmount2 = function(calculateShippingFee) {
			if(vm.do.discountAmount!=null)
			{
				vm.do.discountPercentage = vm.do.discountAmount / vm.subtotal * 100;
				vm.do.discountPercentage = Math.round(vm.do.discountPercentage * 100) / 100;
			}
			else
			{
				vm.do.discountPercentage = null;
			}
			vm.recalculateGrandTotal(calculateShippingFee);
		}

		vm.getReservedQty = function (obj) {
			return (obj.totalNewSalesOrderQuantity +
				obj.totalConfirmedSalesOrderQuantity +
				obj.totalDOPendingQuantity);
		}

		vm.getAvailableQty = function (obj) {
			return (obj.invBalance -
				obj.totalNewSalesOrderQuantity -
				obj.totalConfirmedSalesOrderQuantity -
				obj.totalDOPendingQuantity);
		}

		/* ************************************************************ */

		// Open Modal Dialog
		vm.product = {};
		vm.showAddProductModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'productModal.html',
				controller: 'DeliveryOrderProductModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.product,
							debtorId: vm.do.debtorId
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addProduct(data);
					vm.recalculateGrandTotal(true);
				}, function () {
				});
		};
		vm.showEditProductModal = function (index) {
			vm.product = angular.copy(vm.do.deliveryOrderProducts[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'productModal.html',
				controller: 'DeliveryOrderProductModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.product,
							debtorId: vm.do.debtorId
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateProduct(index, data);
				}, function () {
				});
		};

		/* ************************************************************ */

		vm.clearSelectSalesOrder = function () {
			vm.do.salesOrderId = null;
			vm.do.salesOrderNo = null;
		}

		vm.showSelectSalesOrderModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'salesOrderListModal.html',
				controller: 'DeliveryOrderSelectSOModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (salesOrderId) {
					vm.populateSalesOrder(salesOrderId);
				}, function () {
				});
		};

		vm.populateSalesOrder = function(salesOrderId) {

			if(vm.do.deliveryOrderProducts.length>0) {
				var toProceed = confirm('This action will overwrite the existing products in the Product List.\n\nConfirm Proceed?');
				if(!toProceed) return;

				vm.do.deliveryOrderProducts = [];
			}

			var params = { id: salesOrderId };
			HttpSvc.get('salesorders/web/delivery/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.do.transferId = null;
					vm.do.stockTransferNo = null;

					var salesOrder = result;
					vm.do.debtorId = salesOrder.debtorId;
					vm.do.debtorBranchId = salesOrder.debtorBranchId;
					vm.do.deliveryOrderDate = $filter('date')(salesOrder.deliveryDate, 'yyyy-MM-dd hh:mma');
					vm.do.salesOrderId = salesOrderId;
					vm.do.salesOrderNo = salesOrder.salesOrderNo;
					vm.do.customerPoNo = salesOrder.customerPoNo;
					vm.do.grandTotal = salesOrder.grandTotal;
					vm.do.remarks = salesOrder.description;
					vm.do.discountAmount = salesOrder.discountAmount;
					vm.do.discountPercentage = salesOrder.discountPercentage;
					vm.do.additionalChargesDesc = salesOrder.additionalChargesDesc;
					vm.do.additionalCharges = salesOrder.additionalCharges;
					vm.do.shippingFeeDesc = salesOrder.shippingFeeDesc;
					vm.do.shippingFeeCharges = salesOrder.shippingFeeCharges;

					vm.debtorList.forEach(function(d) {
						if(d.id==salesOrder.debtorId) {
							vm.selectedDebtor = d;
						}
					});
					vm.loadDebtorBranchList();

					if((vm.do.debtorName!=null && vm.do.debtorName!='') ||
						(vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
						(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
						(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
						(vm.do.debtorState!=null && vm.do.debtorState!='') ||
						(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
						(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
						(vm.do.debtorTel!=null && vm.do.debtorTel!=''))
					{
						var qst = 'Do you want to overwrite the customer info with these details?\n\n' +
								  'Company Name : ' + (salesOrder.userFullName || '') + '\n' +
								  'Contact Person : ' + (salesOrder.userFullName || '') + '\n' +
								  'Address 1 : ' + (salesOrder.debtorAddress1 || '') + '\n' +
								  'Address 2 : ' + (salesOrder.debtorAddress2 || '') + '\n' +
								  'Address 3 :\n' +
								  'State : ' + (salesOrder.debtorState || '') + '\n' +
								  'Postal Code : ' + (salesOrder.debtorPostCode || '') + '\n' +
								  'Country : ' + (salesOrder.debtorCountry || '') + '\n' +
								  'Telephone : ' + (salesOrder.debtorPhone || '') + '\n' +
								  'Fax : \n\n';
						var cfm = confirm(qst);

						if(cfm)
						{
							vm.do.debtorName = salesOrder.debtorName;
							vm.do.debtorContactPerson = salesOrder.debtorContactPerson;
							vm.do.debtorAddress1 = salesOrder.debtorAddress1;
							vm.do.debtorAddress2 = salesOrder.debtorAddress2;
							vm.do.debtorAddress3 = salesOrder.debtorAddress3;
							vm.do.debtorState = salesOrder.debtorState;
							vm.do.debtorPostCode = salesOrder.debtorPostCode;
							vm.do.debtorCountry = salesOrder.debtorCountry;
							vm.do.debtorTel = salesOrder.debtorPhone;
							vm.do.debtorFax = salesOrder.debtorFax;
						}
					}
					else
					{
						vm.do.debtorName = salesOrder.debtorName;
						vm.do.debtorContactPerson = salesOrder.debtorContactPerson;
						vm.do.debtorAddress1 = salesOrder.debtorAddress1;
						vm.do.debtorAddress2 = salesOrder.debtorAddress2;
						vm.do.debtorAddress3 = salesOrder.debtorAddress3;
						vm.do.debtorState = salesOrder.debtorState;
						vm.do.debtorPostCode = salesOrder.debtorPostCode;
						vm.do.debtorCountry = salesOrder.debtorCountry;
						vm.do.debtorTel = salesOrder.debtorPhone;
						vm.do.debtorFax = salesOrder.debtorFax;
					}

					salesOrder.salesOrderProducts.forEach(function(p) {
						vm.addProduct(p, true);
					});

					vm.sortDOItems();
					vm.recalculateGrandTotal(true);

				}, function() {
					toastr.error('Failed to load selected Sales Order.', Auth.translate('ERROR'))
					return;
				});
		};

		/* ************************************************************ */

		vm.clearSelectStockTransfer = function () {
			vm.do.transferId = null;
			vm.do.stockTransferNo = null;
		}

		vm.showSelectStockTransferModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'stockTransferListModal.html',
				controller: 'DeliveryOrderSelectSTModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (transferId) {
					vm.populateStockTransfer(transferId);
				}, function () {
				});
		};

		vm.populateStockTransfer = function(transferId) {

			if(vm.do.deliveryOrderProducts.length>0) {
				var toProceed = confirm('This action will overwrite the existing products in the Product List.\n\nConfirm Proceed?');
				if(!toProceed) return;

				vm.do.deliveryOrderProducts = [];
			}

			var params = { id: transferId };
			HttpSvc.get('stocktransfers/web/delivery/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.do.salesOrderId = null;
					vm.do.salesOrderNo = null;
					vm.selectedDebtor = null;
					vm.selectedDebtorBranch = null;

					var transfer = result;
					vm.do.debtorId = null;
					vm.do.debtorBranchId = null;
					vm.do.deliveryOrderDate = $filter('date')(transfer.deliveryDate, 'yyyy-MM-dd hh:mma');
					vm.do.transferId = transferId;
					vm.do.stockTransferNo = transfer.docNo;
					vm.do.grandTotal = 0;
					vm.do.remarks = transfer.remarks;

					if((vm.do.debtorName!=null && vm.do.debtorName!='') ||
						(vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
						(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
						(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
						(vm.do.debtorAddress3!=null && vm.do.debtorAddress3!='') ||
						(vm.do.debtorState!=null && vm.do.debtorState!='') ||
						(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
						(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
						(vm.do.debtorTel!=null && vm.do.debtorTel!=''))
					{
						var qst = 'Do you want to overwrite the Recipient info with these details?\n\n' +
								  'Company Name : ' + (transfer.destBranchName || '') + '\n' +
								  'Contact Person : ' + (transfer.destBranchContactPerson || '') + '\n' +
								  'Address 1 : ' + (transfer.destBranchAddress1 || '') + '\n' +
								  'Address 2 : ' + (transfer.destBranchAddress2 || '') + '\n' +
								  'Address 3 : ' + (transfer.destBranchAddress3 || '') + '\n' +
								  'State : ' + (transfer.destBranchState || '') + '\n' +
								  'Postal Code : ' + (transfer.destBranchPostCode || '') + '\n' +
								  'Country : ' + (transfer.destBranchCountry || '') + '\n' +
								  'Telephone : ' + (transfer.destBranchTel || '') + '\n' +
								  'Telephone : ' + (transfer.destBranchFax || '') + '\n' +
								  'Fax : \n\n';
						var cfm = confirm(qst);

						if(cfm)
						{
							vm.do.debtorName = transfer.destBranchName;
							vm.do.debtorContactPerson = transfer.destBranchContactPerson;
							vm.do.debtorAddress1 = transfer.destBranchAddress1;
							vm.do.debtorAddress2 = transfer.destBranchAddress2;
							vm.do.debtorAddress3 = transfer.destBranchAddress3;
							vm.do.debtorState = transfer.destBranchState;
							vm.do.debtorPostCode = transfer.destBranchPostCode;
							vm.do.debtorCountry = transfer.destBranchCountry;
							vm.do.debtorTel = transfer.destBranchTel;
							vm.do.debtorFax = transfer.destBranchFax;
						}
					}
					else
					{
						vm.do.debtorName = transfer.destBranchName;
						vm.do.debtorContactPerson = transfer.destBranchContactPerson;
						vm.do.debtorAddress1 = transfer.destBranchAddress1;
						vm.do.debtorAddress2 = transfer.destBranchAddress2;
						vm.do.debtorAddress3 = transfer.destBranchAddress3;
						vm.do.debtorState = transfer.destBranchState;
						vm.do.debtorPostCode = transfer.destBranchPostCode;
						vm.do.debtorCountry = transfer.destBranchCountry;
						vm.do.debtorTel = transfer.destBranchTel;
						vm.do.debtorFax = transfer.destBranchFax;
					}

					transfer.stockTransferDetails.forEach(function(p) {
						vm.addProduct(p);
					});
					vm.sortDOItems();
					vm.recalculateGrandTotal(true);
				}, function() {
					toastr.error('Failed to retrieve selected Stock Transfer details.', Auth.translate('ERROR'))
					return;
				});
		};

		/* ************************************************************ */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				HttpSvc.post('deliveryorders', vm.do, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkResult = function(result)
		{
			if(result.httpStatusCode=="200")
			{
				toastr.success('Delivery Order has been created successfully.', Auth.translate('SUCCESS'));
				$state.go('deliveryorders.update', {'id': result.id });
			}
			else if(result.httpStatusCode=="400")
			{
				toastr.error(result.message, Auth.translate('ERROR'));
				vm.lockButtons = false;
			}
			else
			{
				toastr.success('Delivery Order has been created successfully.', Auth.translate('SUCCESS'));
				$state.go('deliveryorders.update', {'id': result.id });
			}
		}

		// Call Actions
		vm.setDefault();
	};

	/** @ngInject */
    function DeliveryOrderUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.isRmsLite = Auth.isLiteMode();

		vm.doStatuses = ['NEW', 'CONFIRMED'];
		vm.mode = 2;
		vm.do = {};
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.changeLogs = [];
		vm.originalStatus = null;
		vm.selectedDebtor = null;
		vm.selectedDebtorBranch = null;
		vm.selectedShippingMethod = null;
		vm.isAdvancedMode = Auth.getSetting_DeliveryOrder_AdvancedMode();
		vm.lockButtons = false;
		vm.approveCreditLimit = false;
		vm.requestCreditApproval = false;
		vm.currency = Auth.getCurrency();
		vm.subtotal = 0;
		vm.grandTotal = 0;
		vm.isInvoiceEnabledForSO = Auth.isInvoiceEnabledForSO();
        vm.isShippingFeesEnabled = Auth.hasCompanyFeature('maintenance.shippingfees');

		/* ************************************************************ */

		// Load Debtor List
		vm.loadDebtorList = function() {
			HttpSvc.get('debtors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					vm.loadShippingMethods();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve product list.', '');
					return null;
			});
		}

		// Load Shipping Method List
		vm.loadShippingMethods = function() {

			var params = {
				type: "SPM",
				pageSize: 9999,
				pageNumber: 1,
				sortBy: "shippingOption"
			};

			HttpSvc.post('customdatalists/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.shippingMethods = result.data;
					vm.loadDeliveryOrder();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Shipping Methods.', '');
					return null;
			});
		}

		// Load Debtor Branch List
		vm.loadDebtorBranchList = function() {
			if(vm.do.debtorId==null || vm.do.debtorId=="") return;

			HttpSvc.get('debtors/' + vm.do.debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorBranchList = result;

					vm.debtorBranchList.forEach(function(d) {
						if(d.id==vm.do.debtorBranchId)
						{
							vm.selectedDebtorBranch = d;
						}
					});
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Customer Branch list.', '');
					return null;
			});
		}

		// Load DeliveryOrder List
		vm.loadDeliveryOrder = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('deliveryorders/web/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.do = result;
					vm.do.deliveryDate = $filter('date')(vm.do.deliveryDate, 'yyyy-MM-dd hh:mma');
					vm.originalStatus = vm.do.status;

					vm.debtorList.forEach(function(d) {
						if(d.id==vm.do.debtorId)
						{
							vm.selectedDebtor = d;
						}
					});

					vm.shippingMethods.forEach(function(s) {
						if(s.id==vm.do.shippingId)
						{
							vm.selectedShippingMethod = s;
						}
					});

					if(vm.do.debtorId!=null)
					{
						vm.loadDebtorBranchList();
					}
					vm.sortDOItems();
					vm.recalculateGrandTotal(false);
					vm.loadChangeLogs();
				}, function(error) {
					toastr.error('Failed to load Delivery Order. ' + error, Auth.translate('ERROR'))
					$state.go('deliveryorders.list');
					return;
				});
		};

		vm.sortDOItems = function() {
			var categoryOrder = ['RAW MAT', 'SEMI FG', 'F.GOODS'];
			vm.do.deliveryOrderProducts.sort(function (a, b) {
        		var categoryComparison = categoryOrder.indexOf((a.itemType || '').toUpperCase()) - categoryOrder.indexOf((b.itemType || '').toUpperCase());
				if (categoryComparison !== 0) {
				return categoryComparison;
				}
				
				// Sort alphabetically
				var productA = a.productName || '';
				var productB = b.productName || '';
				return productA.localeCompare(productB);
			});
		}

		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('deliveryorderchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};

		vm.getInventoryStats = function(item) {

			var params = {
				deliveryOrderId: item.deliveryOrderId,
				itemId: item.itemId,
				semiFinishedProductId: item.semiFinishedProductId,
				productId: item.productId
			}

			HttpSvc.post('deliveryorders/getbalance', params, Auth.getTokenId(), false)
				.then(function(result) {
					item.invUomId = result.invUomId;
					item.invUomId_Parallel = result.invUomId_Parallel;
					item.invUomName = result.invUomName;
					item.invUomName_Parallel = result.invUomName_Parallel;
					item.invBalance = result.invBalance;
					item.invBalance_Parallel = result.invBalance_Parallel;
					item.totalNewSalesOrderQuantity = result.totalNewSalesOrderQuantity;
					item.totalConfirmedSalesOrderQuantity = result.totalConfirmedSalesOrderQuantity;
					item.totalDOPendingQuantity = result.totalDOPendingQuantity;

					item.hasBalanceDetails = true;
				}, function(error) {
					toastr.error('Failed to load inventory stats. ' + error, Auth.translate('ERROR'));
					return;
				});
		}

		vm.getAllInventoryStats = function() {

			vm.do.deliveryOrderProducts.forEach(function(item)
			{
				var params = {
					deliveryOrderId: item.deliveryOrderId,
					itemId: item.itemId,
					semiFinishedProductId: item.semiFinishedProductId,
					productId: item.productId
				}

				HttpSvc.post('deliveryorders/getbalance', params, Auth.getTokenId(), false)
					.then(function(result) {
						item.invUomId = result.invUomId;
						item.invUomId_Parallel = result.invUomId_Parallel;
						item.invUomName = result.invUomName;
						item.invUomName_Parallel = result.invUomName_Parallel;
						item.invBalance = result.invBalance;
						item.invBalance_Parallel = result.invBalance_Parallel;
						item.totalNewSalesOrderQuantity = result.totalNewSalesOrderQuantity;
						item.totalConfirmedSalesOrderQuantity = result.totalConfirmedSalesOrderQuantity;
						item.totalDOPendingQuantity = result.totalDOPendingQuantity;

						item.hasBalanceDetails = true;
					}, function(error) {
						toastr.error('Failed to load inventory stats. ' + error, Auth.translate('ERROR'));
					});
			});


		}

		/* ************************************************************ */

		// Show Print Dialog
		vm.showPrintDialog = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'printModal.html',
				controller: 'DeliveryOrderPrintModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							object: {
								docId: vm.do.id,
								docNo: vm.do.deliveryOrderNo
							},
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

		// Print Delivery Order
		vm.printDeliveryOrder = function(deliveryOrderId, deliveryOrderNo) {

			var filename = "DELIVERYORDER_" + deliveryOrderNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('deliveryorders/print/deliveryorder/' + deliveryOrderId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to print Delivery Order. ' + error, '');
							return null;
						});
		}

		// Print Invoice
		vm.printInvoice = function(deliveryOrderId, invoiceNo) {

			var filename = "INVOICE_" + invoiceNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('deliveryorders/print/invoice/' + deliveryOrderId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to print Invoice. ' + error, '');
							return null;
						});
		}

		/* ************************************************************ */

		// Pre-Check Approval
		vm.preCheckApproveDeliveryOrder = function() {
			HttpSvc.post('deliveryorders/precheckapprove/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.approveDeliveryOrder();
				}, function(error) {
					var cfm = confirm("----------------------------------------------\n" +
									  " Delivery Criteria Not Fulfilled\n" +
									  "----------------------------------------------\n\n" +
									  error + '\n\n' +
									  "Do you want to continue to Approve the Delivery Order?\n\n\n");
					if(cfm)
					{
						vm.approveDeliveryOrder();
					}
				});
		}

		// Approval
		vm.approveDeliveryOrder = function() {
			vm.lockButtons = true;

			var bApproveCreditLimit = vm.approveCreditLimit ? "/1" : "";

			HttpSvc.post('deliveryorders/approve/' + $stateParams.id + bApproveCreditLimit, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.checkResult(result, "approved", 1);
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}

		// Complete DeliveryOrder
		vm.completeDeliveryOrder = function() {
			vm.lockButtons = true;

			HttpSvc.post('deliveryorders/complete/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.checkResult(result, "completed");
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}

		// Cancel DeliveryOrder
		vm.cancelDeliveryOrder = function() {
			vm.lockButtons = true;

			HttpSvc.post('deliveryorders/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.checkResult(result, "cancelled");
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ************************************************************ */

		// Open Modal Dialog
		vm.showCreditApprovalModal = function (mode) {
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'creditApprovalModal.html',
				controller: 'DOApproveCreditLimitModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							deliveryOrderId: null,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.approveCreditLimit = true;
					if(mode==1)
					{
						vm.approveDeliveryOrder();
					}
					else if(mode==2)
					{
						vm.submit();
					}
				}, function () {
					vm.lockButtons = false;
				});
		};

		// Request for Credit Limit Approval Modal Dialog
		vm.showRequestCreditApprovalModal = function() {
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'doRequestCreditApprovalModal.html',
				controller: 'DORequestCreditLimitApprovalModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							deliveryOrderId: null,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					vm.requestCreditApproval = true;
					vm.do.status = "NEW";
					vm.submit();
				}, function () {
					vm.do.status = "NEW";
					vm.submit();
				});
		};

		/* ************************************************************ */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm != undefined && vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				var bApproveCreditLimit = vm.approveCreditLimit ? "/1" : "";

				HttpSvc.put('deliveryorders/' + $stateParams.id + bApproveCreditLimit, vm.do, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result, "updated", 2);
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.submitRequestApproval = function(doId) {
			HttpSvc.post('deliveryorders/requestcreditlimitapproval/' + doId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Delivery Order has been created successfully.', Auth.translate('SUCCESS'));
					toastr.info("Your request for Credit Limit Approval has been sent. " +
								"This Delivery Order will be created with status [<b>NEW</b>].", "Request Sent")
					$state.go('deliveryorders.update', {'id': doId });
				}, function(error) {
					toastr.error(error, 'Failed To Request For Credit Limit Approval');
					vm.lockButtons = false;
				});
		}

		vm.checkResult = function(result, status, mode)
		{
			if(result.httpStatusCode=="200")
			{
				if(vm.requestCreditApproval)
				{
					vm.submitRequestApproval(vm.do.id);
				}
				else
				{
					toastr.success('Delivery Order has been ' + status + ' successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}
			}
			else if(result.httpStatusCode=="300")
			{
				vm.showCreditApprovalModal(mode);
			}
			else if(result.httpStatusCode=="350")
			{
				vm.showRequestCreditApprovalModal();
			}
			else if(result.httpStatusCode=="400")
			{
				toastr.error(result.message, Auth.translate('ERROR'));
				vm.lockButtons = false;
			}
			else
			{
				toastr.success('Delivery Order has been ' + status + ' successfully.', Auth.translate('SUCCESS'));
				$state.reload();
			}
		}

		/* ************************************************************ */

		vm.selectedDebtorChanged = function() {
			vm.do.debtorId = vm.selectedDebtor.id;
			vm.do.debtorBranchId = null;
			vm.selectedDebtorBranch = null;

			if((vm.do.debtorName!=null && vm.do.debtorName!='') ||
				(vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
				(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
				(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
				(vm.do.debtorAddress3!=null && vm.do.debtorAddress3!='') ||
				(vm.do.debtorState!=null && vm.do.debtorState!='') ||
				(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
				(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
				(vm.do.debtorTel!=null && vm.do.debtorTel!='') ||
				(vm.do.debtorFax!=null && vm.do.debtorFax!=''))
			{
				var qst = 'Do you want to overwrite the customer info with these details?\n\n' +
						  'Company Name : ' + (vm.selectedDebtor.name || '') + '\n' +
						  'Contact Person : ' + (vm.selectedDebtor.deliveryContactPerson1 || '') + '\n' +
						  'Address 1 : ' + (vm.selectedDebtor.deliveryAddress1 || '') + '\n' +
						  'Address 2 : ' + (vm.selectedDebtor.deliveryAddress2 || '') + '\n' +
						  'Address 3 : ' + (vm.selectedDebtor.deliveryAddress3 || '') + '\n' +
						  'State : ' + (vm.selectedDebtor.deliveryState || '') + '\n' +
						  'Postal Code : ' + (vm.selectedDebtor.deliveryPostCode || '') + '\n' +
						  'Country : ' + (vm.selectedDebtor.deliveryCountry || '') + '\n' +
						  'Telephone : ' + (vm.selectedDebtor.deliveryPhone1 || '') + '\n' +
						  'Fax : ' + (vm.selectedDebtor.deliveryFax1 || '') + '\n\n';
				var cfm = confirm(qst);

				if(cfm)
				{
					vm.do.debtorName = vm.selectedDebtor.name;
					vm.do.debtorContactPerson = vm.selectedDebtor.contactPerson1;
					vm.do.debtorAddress1 = vm.selectedDebtor.address1;
					vm.do.debtorAddress2 = vm.selectedDebtor.address2;
					vm.do.debtorAddress3 = vm.selectedDebtor.address3;
					vm.do.debtorState = vm.selectedDebtor.state;
					vm.do.debtorPostCode = vm.selectedDebtor.postCode;
					vm.do.debtorCountry = vm.selectedDebtor.country;
					vm.do.debtorTel = vm.selectedDebtor.phone1;
					vm.do.debtorFax = vm.selectedDebtor.fax1;
				}
			}
			else
			{
				vm.do.debtorName = vm.selectedDebtor.name;
				vm.do.debtorContactPerson = vm.selectedDebtor.contactPerson1;
				vm.do.debtorAddress1 = vm.selectedDebtor.address1;
				vm.do.debtorAddress2 = vm.selectedDebtor.address2;
				vm.do.debtorAddress3 = vm.selectedDebtor.address3;
				vm.do.debtorState = vm.selectedDebtor.state;
				vm.do.debtorPostCode = vm.selectedDebtor.postCode;
				vm.do.debtorCountry = vm.selectedDebtor.country;
				vm.do.debtorTel = vm.selectedDebtor.phone1;
				vm.do.debtorFax = vm.selectedDebtor.fax1;
			}

			toastr.info("Customer information updated.", "Customer");

			vm.loadDebtorBranchList();
			vm.updateProductPriceFromSalesConfig();
		}

		vm.selectedDebtorBranchChanged = function() {
			vm.do.debtorBranchId = vm.selectedDebtorBranch.id;

			if((vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
				(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
				(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
				(vm.do.debtorAddress3!=null && vm.do.debtorAddress3!='') ||
				(vm.do.debtorState!=null && vm.do.debtorState!='') ||
				(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
				(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
				(vm.do.debtorTel!=null && vm.do.debtorTel!='') ||
				(vm.do.debtorFax!=null && vm.do.debtorFax!=''))
			{
				var qst = 'Do you want to overwrite the customer info with these details?\n\n' +
						  'Contact Person : ' + (vm.selectedDebtorBranch.contactPerson || '') + '\n' +
						  'Address 1 : ' + (vm.selectedDebtorBranch.address1 || '') + '\n' +
						  'Address 2 : ' + (vm.selectedDebtorBranch.address2 || '') + '\n' +
						  'Address 3 : ' + (vm.selectedDebtorBranch.address3 || '') + '\n' +
						  'State : ' + (vm.selectedDebtorBranch.state || '') + '\n' +
						  'Postal Code : ' + (vm.selectedDebtorBranch.postCode || '') + '\n' +
						  'Country : ' + (vm.selectedDebtorBranch.country || '') + '\n' +
						  'Telephone : ' + (vm.selectedDebtorBranch.phone || '') + '\n' +
						  'Fax : ' + (vm.selectedDebtorBranch.fax || '') + '\n\n';
				var cfm = confirm(qst);

				if(cfm)
				{
					vm.do.debtorContactPerson = vm.selectedDebtorBranch.contactPerson;
					vm.do.debtorAddress1 = vm.selectedDebtorBranch.address1;
					vm.do.debtorAddress2 = vm.selectedDebtorBranch.address2;
					vm.do.debtorAddress3 = vm.selectedDebtorBranch.address3;
					vm.do.debtorState = vm.selectedDebtorBranch.state;
					vm.do.debtorPostCode = vm.selectedDebtorBranch.postCode;
					vm.do.debtorCountry = vm.selectedDebtorBranch.country;
					vm.do.debtorTel = vm.selectedDebtorBranch.phone;
					vm.do.debtorFax = vm.selectedDebtorBranch.fax;
				}
			}
			else
			{
				vm.do.debtorContactPerson = vm.selectedDebtorBranch.contactPerson;
				vm.do.debtorAddress1 = vm.selectedDebtorBranch.address1;
				vm.do.debtorAddress2 = vm.selectedDebtorBranch.address2;
				vm.do.debtorAddress3 = vm.selectedDebtorBranch.address3;
				vm.do.debtorState = vm.selectedDebtorBranch.state;
				vm.do.debtorPostCode = vm.selectedDebtorBranch.postCode;
				vm.do.debtorCountry = vm.selectedDebtorBranch.country;
				vm.do.debtorTel = vm.selectedDebtorBranch.phone;
				vm.do.debtorFax = vm.selectedDebtorBranch.fax;
			}

			toastr.info("Customer Address information updated.", "Customer Address");
		}

		vm.selectedShippingMethodChanged = function() {
			vm.do.shippingId = vm.selectedShippingMethod.id;
		}

		/* ************************************************************ */

		vm.updateProductPriceFromSalesConfig = function() {
			var params = {
				salesorderitem: vm.do.deliveryOrderProducts,
				filter: {
					debtorId: vm.do.debtorId
				}
			};

			HttpSvc.post('salesorders/refreshsalesorderproduct', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.do.deliveryOrderProducts = [];
					result.forEach(function(p) {
						vm.do.deliveryOrderProducts.push(p);
					});
					vm.recalculateGrandTotal(true);

					vm.lockButtons = false;
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					vm.lockButtons = false;
					return;
				});
		}

		/* ************************************************************ */

		// Remove Product
		vm.removeProduct = function(index) {
			vm.do.deliveryOrderProducts.splice(index, 1);
			//$scope.$broadcast('refreshStTable');
			vm.calculateDiscountAmount1(false);
            vm.recalculateGrandTotal(true);
		};

		// Update Product
		vm.updateProduct = function(index, obj) {

			var element = {
				id: obj.id,
				deliveryOrderId: obj.deliveryOrderId,
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				itemType: obj.itemType,
				productCode: obj.productCode==null?obj.itemCode:obj.productCode,
				productName: obj.productName==null?obj.itemName:obj.productName,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId==null?obj.uomId:obj.unitOfMeasurementId,
				uomName: obj.uomName,
				unitPrice: obj.unitPrice,
				discountAmount: obj.discountAmount,
				discountPercentage: obj.discountPercentage,
				taxCode: obj.taxCode,
				tax: obj.tax,
				subtotal: obj.subtotal,
				quantityStockedOut: obj.quantityStockedOut,
				quantityTransported: obj.quantityTransported,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
				remarks: obj.remarks,

				isCwm: obj.isCwm,
				invUomId: obj.invUomId,
				invUomId_Parallel: obj.invUomId_Parallel,
				invUomName: obj.invUomName,
				invUomName_Parallel: obj.invUomName_Parallel,
				invBalance: obj.invBalance,
				invBalance_Parallel: obj.invBalance_Parallel,
				totalNewSalesOrderQuantity: obj.totalNewSalesOrderQuantity,
				totalConfirmedSalesOrderQuantity: obj.totalConfirmedSalesOrderQuantity,
				totalDOPendingQuantity: obj.totalDOPendingQuantity,
			};
			vm.do.deliveryOrderProducts.splice(index, 1, element);

			vm.calculateDiscountAmount1(false);
			vm.recalculateGrandTotal(true);
		};

		// Add Product
		vm.addProduct = function(obj, isPopulate) {
			var isFound = false;
			var objIdx = null;

			for (var i = 0; i < vm.do.deliveryOrderProducts.length; i++) {
				var d = vm.do.deliveryOrderProducts[i];
				if(d.itemId==obj.itemId && d.semiFinishedProductId==obj.semiFinishedProductId && d.productId==obj.productId)
				{
					isFound = true;
					objIdx = i;
				}
			}

			if(isFound)
			{
				toastr.warning('The same item already exists on the list. Additional Quantity, Tax and Amount will be added.', 'Duplicate Item');
				var d = vm.do.deliveryOrderProducts[objIdx];
				d.quantity += obj.quantity;
				d.unitPrice = obj.unitPrice;
				d.discountAmount += obj.discountAmount;
				d.discountPercentage += obj.discountPercentage;
				d.tax += obj.tax;
				d.subtotal += obj.subtotal;
				d.quantityStockedOut = obj.quantityStockedOut;
				d.quantityTransported = obj.quantityTransported;
				d.remarks = obj.remarks;

				d.isCwm = obj.isCwm;
				d.invUomId = obj.invUomId;
				d.invUomId_Parallel = obj.invUomId_Parallel;
				d.invUomName = obj.invUomName;
				d.invUomName_Parallel = obj.invUomName_Parallel;
				d.invBalance = obj.invBalance;
				d.invBalance_Parallel = obj.invBalance_Parallel;
				d.totalNewSalesOrderQuantity = obj.totalNewSalesOrderQuantity;
				d.totalConfirmedSalesOrderQuantity = obj.totalConfirmedSalesOrderQuantity;
				d.totalDOPendingQuantity = obj.totalDOPendingQuantity;

				vm.calculateDiscountAmount1(true);
				vm.recalculateGrandTotal(true);
				return;
			}

			var element = {
				id: obj.id,
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				itemType: obj.itemType,
				productCode: obj.productCode==null?obj.itemCode:obj.productCode,
				productName: obj.productName==null?obj.itemName:obj.productName,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId==null?obj.uomId:obj.unitOfMeasurementId,
				uomName: obj.uomName,
				unitPrice: obj.unitPrice,
				discountAmount: obj.discountAmount,
				discountPercentage: obj.discountPercentage,
				taxCode: obj.taxCode,
				tax: obj.tax,
				subtotal: obj.subtotal,
				quantityStockedOut: obj.quantityStockedOut,
				quantityTransported: obj.quantityTransported,
				remarks: obj.remarks,

				isCwm: obj.isCwm,
				invUomId: obj.invUomId,
				invUomId_Parallel: obj.invUomId_Parallel,
				invUomName: obj.invUomName,
				invUomName_Parallel: obj.invUomName_Parallel,
				invBalance: obj.invBalance,
				invBalance_Parallel: obj.invBalance_Parallel,
				totalNewSalesOrderQuantity: obj.totalNewSalesOrderQuantity,
				totalConfirmedSalesOrderQuantity: obj.totalConfirmedSalesOrderQuantity,
				totalDOPendingQuantity: obj.totalDOPendingQuantity,
			};
			// vm.do.deliveryOrderProducts.push(element);
			vm.do.deliveryOrderProducts.unshift(element);

			if(!isPopulate)
			{
				vm.calculateDiscountAmount1(false);
			}
		};

		// Refresh Product List
		vm.refreshDeliveryOrderProducts = function(tableState) {
			// Do nothing
		};

        vm.calculateItemSubtotalExcludeTax = function (product) {
            return (product.unitPrice * product.quantity) - (product.discountAmount || 0);
        };

		vm.recalculateGrandTotal = function(calculateShippingFee) {
			vm.subtotal = 0;
            vm.subtotalExcludeTax = 0;
			vm.grandTotal = 0;

			vm.do.deliveryOrderProducts.forEach(function(p) {
                vm.subtotal += p.subtotal;
                if (vm.isShippingFeesEnabled) {
                    vm.subtotalExcludeTax += vm.calculateItemSubtotalExcludeTax(p);
                }
			});

			if (calculateShippingFee && vm.isShippingFeesEnabled) {
				var params = {
					companyId: Auth.getCompanyId(),
					debtorId: vm.do.debtorId,
					subtotalAmount: vm.subtotalExcludeTax,
				};

				HttpSvc.post('salesorders/calculateShippingFee', params, Auth.getTokenId(), false)
					.then(function (result) {
						vm.do.shippingFeeDesc = result.shippingFeeDesc;
						vm.do.shippingFeeCharges = result.shippingFeeCharges;
					}, function (error) {
						return;
					});
			}

			vm.grandTotal += (vm.subtotal || 0);
            vm.grandTotal += (vm.do.shippingFeeCharges || 0);
			vm.grandTotal -= (vm.do.discountAmount || 0);
			vm.grandTotal += (vm.do.additionalCharges || 0);
			vm.do.grandTotal = vm.grandTotal;
		}

		vm.calculateDiscountAmount1 = function (calculateShippingFee) {
			vm.subtotal = 0;
			vm.do.deliveryOrderProducts.forEach(function(p) {
				vm.subtotal += p.subtotal;
			});
			if(vm.do.discountPercentage!=null)
			{
				vm.do.discountAmount = vm.subtotal * vm.do.discountPercentage / 100;
				vm.do.discountAmount = Math.round(vm.do.discountAmount * 1000) / 1000;
				vm.do.discountAmount = Math.round(vm.do.discountAmount * 100) / 100;
			}
			else
			{
				vm.do.discountAmount = null;
			}
			vm.recalculateGrandTotal(calculateShippingFee);
		}

		vm.calculateDiscountAmount2 = function(calculateShippingFee) {
			if(vm.do.discountAmount!=null)
			{
				vm.do.discountPercentage = vm.do.discountAmount / vm.subtotal * 100;
				vm.do.discountPercentage = Math.round(vm.do.discountPercentage * 1000) / 1000;
				vm.do.discountPercentage = Math.round(vm.do.discountPercentage * 100) / 100;
			}
			else
			{
				vm.do.discountPercentage = null;
			}
			vm.recalculateGrandTotal(calculateShippingFee);
		}

		vm.getReservedQty = function (obj) {
			return (obj.totalNewSalesOrderQuantity +
				obj.totalConfirmedSalesOrderQuantity +
				obj.totalDOPendingQuantity);
		}

		vm.getAvailableQty = function (obj) {
			return (obj.invBalance -
				obj.totalNewSalesOrderQuantity -
				obj.totalConfirmedSalesOrderQuantity -
				obj.totalDOPendingQuantity);
		}

		/* ************************************************************ */

		// Open Modal Dialog
		vm.product = {};
		vm.showAddProductModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'productModal.html',
				controller: 'DeliveryOrderProductModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.product,
							debtorId: vm.do.debtorId
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addProduct(data);
					vm.recalculateGrandTotal(true);
				}, function () {
				});
		};
		vm.showEditProductModal = function (index) {
			vm.product = angular.copy(vm.do.deliveryOrderProducts[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'productModal.html',
				controller: 'DeliveryOrderProductModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.product,
							debtorId: vm.do.debtorId
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateProduct(index, data);
				}, function () {
				});
		};

		/* ************************************************************ */

		vm.clearSelectSalesOrder = function () {
			vm.do.salesOrderId = null;
			vm.do.salesOrderNo = null;
		}

		vm.showSelectSalesOrderModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'salesOrderListModal.html',
				controller: 'DeliveryOrderSelectSOModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (salesOrderId) {
					vm.populateSalesOrder(salesOrderId);
				}, function () {
				});
		};

		vm.populateSalesOrder = function(salesOrderId) {

			if(vm.do.deliveryOrderProducts.length>0) {
				var toProceed = confirm('This action will overwrite the existing products in the Product List.\n\nConfirm Proceed?');
				if(!toProceed) return;

				vm.do.deliveryOrderProducts = [];
			}

			var params = { id: salesOrderId };
			HttpSvc.get('salesorders/web/delivery/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.do.transferId = null;
					vm.do.stockTransferNo = null;

					var salesOrder = result;
					vm.do.debtorId = salesOrder.debtorId;
					vm.do.debtorBranchId = salesOrder.debtorBranchId;
					vm.do.deliveryOrderDate = $filter('date')(salesOrder.deliveryDate, 'yyyy-MM-dd hh:mma');
					vm.do.salesOrderId = salesOrderId;
					vm.do.salesOrderNo = salesOrder.salesOrderNo;
					vm.do.customerPoNo = salesOrder.customerPoNo;
					vm.do.grandTotal = salesOrder.grandTotal;
					vm.do.remarks = salesOrder.description;
					vm.do.discountAmount = salesOrder.discountAmount;
					vm.do.discountPercentage = salesOrder.discountPercentage;
					vm.do.additionalChargesDesc = salesOrder.additionalChargesDesc;
					vm.do.additionalCharges = salesOrder.additionalCharges;
                    vm.do.shippingFeeDesc = salesOrder.shippingFeeDesc;
                    vm.do.shippingFeeCharges = salesOrder.shippingFeeCharges;

					vm.debtorList.forEach(function(d) {
						if(d.id==salesOrder.debtorId) {
							vm.selectedDebtor = d;
						}
					});

					vm.loadDebtorBranchList();

					if((vm.do.debtorName!=null && vm.do.debtorName!='') ||
						(vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
						(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
						(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
						(vm.do.debtorState!=null && vm.do.debtorState!='') ||
						(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
						(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
						(vm.do.debtorTel!=null && vm.do.debtorTel!=''))
					{
						var qst = 'Do you want to overwrite the customer info with these details?\n\n' +
								  'Company Name : ' + (salesOrder.userFullName || '') + '\n' +
								  'Contact Person : ' + (salesOrder.userFullName || '') + '\n' +
								  'Address 1 : ' + (salesOrder.debtorAddress1 || '') + '\n' +
								  'Address 2 : ' + (salesOrder.debtorAddress2 || '') + '\n' +
								  'Address 3 :\n' +
								  'State : ' + (salesOrder.debtorState || '') + '\n' +
								  'Postal Code : ' + (salesOrder.debtorPostCode || '') + '\n' +
								  'Country : ' + (salesOrder.debtorCountry || '') + '\n' +
								  'Telephone : ' + (salesOrder.debtorPhone || '') + '\n' +
								  'Fax : \n\n';
						var cfm = confirm(qst);

						if(cfm)
						{
							vm.do.debtorName = salesOrder.debtorName;
							vm.do.debtorContactPerson = salesOrder.debtorContactPerson;
							vm.do.debtorAddress1 = salesOrder.debtorAddress1;
							vm.do.debtorAddress2 = salesOrder.debtorAddress2;
							vm.do.debtorAddress3 = salesOrder.debtorAddress3;
							vm.do.debtorState = salesOrder.debtorState;
							vm.do.debtorPostCode = salesOrder.debtorPostCode;
							vm.do.debtorCountry = salesOrder.debtorCountry;
							vm.do.debtorTel = salesOrder.debtorPhone;
							vm.do.debtorFax = salesOrder.debtorFax;
						}
					}
					else
					{
						vm.do.debtorName = salesOrder.debtorName;
						vm.do.debtorContactPerson = salesOrder.debtorContactPerson;
						vm.do.debtorAddress1 = salesOrder.debtorAddress1;
						vm.do.debtorAddress2 = salesOrder.debtorAddress2;
						vm.do.debtorAddress3 = salesOrder.debtorAddress3;
						vm.do.debtorState = salesOrder.debtorState;
						vm.do.debtorPostCode = salesOrder.debtorPostCode;
						vm.do.debtorCountry = salesOrder.debtorCountry;
						vm.do.debtorTel = salesOrder.debtorPhone;
						vm.do.debtorFax = salesOrder.debtorFax;
					}

					salesOrder.salesOrderProducts.forEach(function(p) {
						vm.addProduct(p, true);
					});
					vm.sortDOItems();
					vm.recalculateGrandTotal(true);

				}, function() {
					toastr.error('Failed to load selected Sales Order.', Auth.translate('ERROR'))
					return;
				});
		};

		/* ************************************************************ */

		vm.clearSelectStockTransfer = function () {
			vm.do.transferId = null;
			vm.do.stockTransferNo = null;
		}

		vm.showSelectStockTransferModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'stockTransferListModal.html',
				controller: 'DeliveryOrderSelectSTModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (transferId) {
					vm.populateStockTransfer(transferId);
				}, function () {
				});
		};

		vm.populateStockTransfer = function(transferId) {

			if(vm.do.deliveryOrderProducts.length>0) {
				var toProceed = confirm('This action will overwrite the existing products in the Product List.\n\nConfirm Proceed?');
				if(!toProceed) return;

				vm.do.deliveryOrderProducts = [];
			}

			var params = { id: transferId };
			HttpSvc.get('stocktransfers/web/delivery/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.do.salesOrderId = null;
					vm.do.salesOrderNo = null;
					vm.selectedDebtor = null;
					vm.selectedDebtorBranch = null;

					var transfer = result;
					vm.do.debtorId = null;
					vm.do.debtorBranchId = null;
					vm.do.deliveryOrderDate = $filter('date')(new Date(), 'yyyy-MM-dd hh:mma');
					vm.do.transferId = transferId;
					vm.do.stockTransferNo = transfer.docNo;
					vm.do.grandTotal = 0;

					if((vm.do.debtorName!=null && vm.do.debtorName!='') ||
						(vm.do.debtorContactPerson!=null && vm.do.debtorContactPerson!='') ||
						(vm.do.debtorAddress1!=null && vm.do.debtorAddress1!='') ||
						(vm.do.debtorAddress2!=null && vm.do.debtorAddress2!='') ||
						(vm.do.debtorState!=null && vm.do.debtorState!='') ||
						(vm.do.debtorPostCode!=null && vm.do.debtorPostCode!='') ||
						(vm.do.debtorCountry!=null && vm.do.debtorCountry!='') ||
						(vm.do.debtorTel!=null && vm.do.debtorTel!=''))
					{
						var qst = 'Do you want to overwrite the Recipient info with these details?\n\n' +
								  'Company Name : ' + (transfer.destBranchName || '') + '\n' +
								  'Contact Person : ' + (transfer.destBranchContactPerson || '') + '\n' +
								  'Address 1 : ' + (transfer.destBranchAddress1 || '') + '\n' +
								  'Address 2 : ' + (transfer.destBranchAddress2 || '') + '\n' +
								  'Address 3 : ' + (transfer.destBranchAddress3 || '') + '\n' +
								  'State : ' + (transfer.destBranchState || '') + '\n' +
								  'Postal Code : ' + (transfer.destBranchPostCode || '') + '\n' +
								  'Country : ' + (transfer.destBranchCountry || '') + '\n' +
								  'Telephone : ' + (transfer.destBranchTel || '') + '\n' +
								  'Telephone : ' + (transfer.destBranchFax || '') + '\n' +
								  'Fax : \n\n';
						var cfm = confirm(qst);

						if(cfm)
						{
							vm.do.debtorName = transfer.destBranchName;
							vm.do.debtorContactPerson = transfer.destBranchContactPerson;
							vm.do.debtorAddress1 = transfer.destBranchAddress1;
							vm.do.debtorAddress2 = transfer.destBranchAddress2;
							vm.do.debtorAddress3 = transfer.destBranchAddress3;
							vm.do.debtorState = transfer.destBranchState;
							vm.do.debtorPostCode = transfer.destBranchPostCode;
							vm.do.debtorCountry = transfer.destBranchCountry;
							vm.do.debtorTel = transfer.destBranchTel;
							vm.do.debtorFax = transfer.destBranchFax;
						}
					}
					else
					{
						vm.do.debtorName = transfer.destBranchName;
						vm.do.debtorContactPerson = transfer.destBranchContactPerson;
						vm.do.debtorAddress1 = transfer.destBranchAddress1;
						vm.do.debtorAddress2 = transfer.destBranchAddress2;
						vm.do.debtorAddress3 = transfer.destBranchAddress3;
						vm.do.debtorState = transfer.destBranchState;
						vm.do.debtorPostCode = transfer.destBranchPostCode;
						vm.do.debtorCountry = transfer.destBranchCountry;
						vm.do.debtorTel = transfer.destBranchTel;
						vm.do.debtorFax = transfer.destBranchFax;
					}

					transfer.stockTransferDetails.forEach(function(p) {
						vm.addProduct(p);
					});
					vm.sortDOItems();
					vm.recalculateGrandTotal(true);
				}, function() {
					toastr.error('Failed to retrieve selected Stock Transfer details.', Auth.translate('ERROR'))
					return;
				});
		};

		/* ************************************************************ */

		// Call Actions
		vm.loadDebtorList();
	};

    function DeliveryOrderSerialNumberModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
        var $mdl = this;
        $mdl.item = item.object;

        $mdl.pageSize = 10;
        $mdl.numOfRecord = 0;
		$mdl.numOfPages = 0;
        $mdl.startIndex = 0;
        $mdl.endIndex = 0;
        $mdl.serialNumberData = [];
        $mdl.isLoading = false;

        
        $mdl.retrieveData = function (tableState) {
            var pagination = tableState.pagination;
            $mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of the item in the list that you want to use to display the table.
            $mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries shown per page.

			$mdl.isLoading = true;

			if (!tableState.search.predicateObject) {
                tableState.sort = {};
                tableState.search.predicateObject = {};
                tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject || {};
			
			var body = {
				deliveryOrderId: $mdl.item.docId,
                mainLabelSerialNumber: predicate.mainLabelSerialNumber || '',
                partialLabelSerialNumber: predicate.partialLabelSerialNumber || '',
				pageSize: $mdl.pageSize,
				pageNumber: Math.ceil(($mdl.startIndex + 1) / $mdl.pageSize)
			};

			HttpSvc.post('deliveryorders/labels/lazyload/list', body, Auth.getTokenId(), false)
				.then(function (result) {
					$mdl.isLoading = false;
					$mdl.serialNumberData = result.data;
					$mdl.numOfRecord = result.numberOfRecords;
					$mdl.numOfPages = result.numberOfPages;
					refreshTableState(tableState);
				}, function () {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
				
		};
		
		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = $mdl.numOfPages;
            return tableState;
        }

        // ********************************************************

        // Cancel Action
        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }


	// Print Dialog
	function DeliveryOrderPrintModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;

		$mdl.isLoading = false;
		$mdl.item = item.object;
		$mdl.documentList = [];
		$mdl.isLoading = false;

		$mdl.loadLayouts = function() {
			$mdl.isLoading = true;

			HttpSvc.get('documentlayouts/list/DO', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.isLoading = false;
					$mdl.documentList = result;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve document layout.', '');
					$mdl.cancelModal
				});
		};

		/* *************************************************** */

		$mdl.printDocument = function(layoutId) {
			$mdl.isLoading = true;
			var filename = "DELIVERY_ORDER_" + $mdl.item.docNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('documentlayouts/print/' + layoutId + '/' + $mdl.item.docId, Auth.getTokenId(), filename)
				.then(function(result) {
					$mdl.isLoading = false;
					$mdl.cancelModal();
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to generate Delivery Order. ' + error, '');
					return null;
				});
		}

		/* *************************************************** */

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Init
		$mdl.loadLayouts();
	}


	// Product Modal Controller
	function DeliveryOrderProductModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.mode = item.mode;
		$mdl.title = item.title;
		$mdl.item = item.object;
		$mdl.debtorId = item.debtorId;
		$mdl.itemList = [];
		$mdl.selectedItem = null;
		$mdl.lockButtons = false;
		$mdl.currencyCode = Auth.getCurrency();
		$mdl.isInit = true;

		/* ********************************************************* */

		$mdl.selectedItemChanged = function() {
			if(!$mdl.selectedItem) return;

			$mdl.item.itemId = $mdl.selectedItem.itemId;
			$mdl.item.semiFinishedProductId = $mdl.selectedItem.semiFinishedProductId;
			$mdl.item.productId = $mdl.selectedItem.productId;
			$mdl.item.productCode = $mdl.selectedItem.productCode;
			$mdl.item.productName = $mdl.selectedItem.productName;
			$mdl.item.itemType = $mdl.selectedItem.itemType;
			$mdl.item.unitPrice = $mdl.selectedItem.posPrice;
			$mdl.item.tax = $mdl.selectedItem.posTax;
			$mdl.item.taxPercent = $mdl.selectedItem.posTaxPercent;
			$mdl.item.taxCode = $mdl.selectedItem.posTaxCode || '';
			if($mdl.mode==2)
			{
				if($mdl.item.unitOfMeasurementId != $mdl.selectedItem.unitOfMeasurementId && $mdl.item.unitOfMeasurementId==null)
				{
					$mdl.item.unitOfMeasurementId = $mdl.selectedItem.unitOfMeasurementId;
					$mdl.item.uomName = $mdl.selectedItem.uomName;
				}
			}
			else
			{
				$mdl.item.unitOfMeasurementId = $mdl.selectedItem.unitOfMeasurementId;
				$mdl.item.uomName = $mdl.selectedItem.uomName;
			}

			$mdl.item.isCwm = $mdl.selectedItem.isCwm;
			$mdl.item.invUomId = $mdl.selectedItem.invUomId;
			$mdl.item.invUomId_Parallel = $mdl.selectedItem.invUomId_Parallel;
			$mdl.item.invUomName = $mdl.selectedItem.invUomName;
			$mdl.item.invUomName_Parallel = $mdl.selectedItem.invUomName_Parallel;
			$mdl.item.invBalance = $mdl.selectedItem.invBalance;
			$mdl.item.invBalance_Parallel = $mdl.selectedItem.invBalance_Parallel;
			$mdl.item.totalNewSalesOrderQuantity = $mdl.selectedItem.totalNewSalesOrderQuantity;
			$mdl.item.totalConfirmedSalesOrderQuantity = $mdl.selectedItem.totalConfirmedSalesOrderQuantity;
			$mdl.item.totalDOPendingQuantity = $mdl.selectedItem.totalDOPendingQuantity;

			$mdl.recalculateTaxAndTotal();
		};

		$mdl.quantityChanged = function()
		{
			$mdl.calculateDiscountAmount1();
		}

		$mdl.calculateDiscountAmount1 = function()
		{
			if($mdl.item.discountPercentage!=null)
			{
				$mdl.item.discountAmount = $mdl.item.unitPrice * $mdl.item.quantity * $mdl.item.discountPercentage / 100;
				$mdl.item.discountAmount = Math.round($mdl.item.discountAmount * 100) / 100;
			}
			else
			{
				$mdl.item.discountAmount = null;
			}

			$mdl.recalculateTaxAndTotal();
		}

		$mdl.calculateDiscountAmount2 = function()
		{
			if($mdl.item.discountAmount!=null)
			{
				$mdl.item.discountPercentage = $mdl.item.discountAmount / ($mdl.item.unitPrice * $mdl.item.quantity) * 100;
				$mdl.item.discountPercentage = Math.round($mdl.item.discountPercentage * 100) / 100;
			}
			else
			{
				$mdl.item.discountPercentage = null;
			}

			$mdl.recalculateTaxAndTotal();
		}

		$mdl.recalculateTaxAndTotal = function()
		{
			$mdl.item.tax = (($mdl.item.unitPrice * $mdl.item.quantity) - $mdl.item.discountAmount) * $mdl.item.taxPercent / 100;
			$mdl.item.tax = Math.round($mdl.item.tax * 100) / 100;
			$mdl.item.subtotal =  (($mdl.item.unitPrice * $mdl.item.quantity) - $mdl.item.discountAmount) + $mdl.item.tax;
			$mdl.item.subtotal = Math.round($mdl.item.subtotal * 100) / 100;
		}

		/* ********************************************************* */

		// Load Item List
        $mdl.loadItem = function(searchString) {

			if(searchString==null || searchString.trim()=="") return;

			$mdl.lockButtons = true;

			var keyword = encodeURIComponent(searchString);
			var params = {
				debtorId: $mdl.debtorId
			};

            HttpSvc.post('searchengine/editsaleitem/' + keyword, params, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.itemList = result;

					if($mdl.isInit)
					{
						if($mdl.itemList.length>0)
							$mdl.selectedItem = $mdl.itemList[0];
						$mdl.isInit = false;
					}
					$mdl.selectedItemChanged();

					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
                    toastr.error('Failed to retrieve search results.', '');
					return null;
				});
		};

		// Load Item List
		$mdl.searchItem = function(searchString) {

			if(searchString==null || searchString.trim()=="") return;

			$mdl.lockButtons = true;

			var keyword = encodeURIComponent(searchString);
			var params = {
				debtorId: $mdl.debtorId
			};

            HttpSvc.post('searchengine/search/itemssalesconfig/' + keyword, params, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.itemList = result;

					if($mdl.isInit)
					{
						if($mdl.itemList.length>0)
							$mdl.selectedItem = $mdl.itemList[0];
						$mdl.isInit = false;
					}
					$mdl.selectedItemChanged();

					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Raw Material list.', '');
					return null;
				});
		};

		/* ********************************************************* */

		// Initialize
		if(item.mode==1) {
			$mdl.item.itemId = null;
			$mdl.item.productId = null;
			$mdl.item.semiFinishedProductId = null;
			$mdl.item.productCode = "";
			$mdl.item.productName = "";
			$mdl.item.itemType = "";
			$mdl.item.quantity = 1;
			$mdl.item.unitPrice = 0;
			$mdl.item.tax = 0;
			$mdl.item.taxPercent = 0;
			$mdl.item.taxCode = '';
			$mdl.item.discountAmount = null;
			$mdl.item.discountPercentage = null;
			$mdl.item.subtotal = 0;
			$mdl.item.quantityStockedOut = 0;
		} else {
			$mdl.originalQuantity = $mdl.item.quantity;
			// $mdl.searchItem($mdl.item.productCode);
            $mdl.loadItem($mdl.item.productCode);
		}

		/* ********************************************************* */

		$mdl.confirmModal = function()
		{
			if(!$mdl.productForm.$valid)
			{
				toastr.error('Please fill up all the required fields.', Auth.translate('ERROR'));
			}
			else
			{
				if($mdl.item.quantity < $mdl.item.quantityStockedOut)
				{
					return;
				}
				else
				{
					$uibModalInstance.close($mdl.item);
				}
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	/** @ngInject */
	function DeliveryOrderSelectSOModalCtrl($uibModalInstance, $filter, $scope, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
		var $mdl = this;

		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.startIndex = 0;
		$mdl.endIndex = 0;
		$mdl.data = [];
		$mdl.isLoading = false;

		$mdl.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.salesOrderNo,
				orderDate: predicate.createdDate,
				deliveryDate: predicate.deliveryDate,
				branchName: predicate.branchName,
				debtorName: predicate.debtorName,
				customerPoNo: predicate.customerPoNo,
				orderTitle: predicate.orderTitle,
				status: predicate.status,
				createdBy: predicate.createdBy,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: $mdl.pageSize,
				pageNumber: Math.ceil(($mdl.startIndex + 1) / $mdl.pageSize)
			};

			return params;
		}

		$mdl.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

			$mdl.isLoading = true;

			var params = $mdl.getApiParams(tableState);

			HttpSvc.post('salesorders/lazyload/list/undelivery', params, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.isLoading = false;
					$mdl.data = result.data;
					$mdl.numOfRecord = result.numberOfRecords;
					$mdl.numOfPages = result.numberOfPages;
					refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = $mdl.numOfPages;
			return tableState;
		};

		$mdl.resetSearch = function()
		{
		}

		// ********************************************************

		$mdl.selectSalesOrder = function(itemId) {
			$uibModalInstance.close(itemId);
		}

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	/** @ngInject */
	function DeliveryOrderSelectSTModalCtrl($uibModalInstance, $filter, $scope, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
		var $mdl = this;

		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.startIndex = 0;
		$mdl.endIndex = 0;
		$mdl.data = [];
		$mdl.isLoading = false;

		$mdl.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.docNo,
				orderDate: predicate.createdDate,
				deliveryDate: predicate.deliveryDate,
				sourceBranchName: predicate.sourceBranchName,
				destBranchName: predicate.destBranchName,
				createdBy: predicate.createdBy,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: $mdl.pageSize,
				pageNumber: Math.ceil(($mdl.startIndex + 1) / $mdl.pageSize)
			};

			return params;
		}

		$mdl.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

			$mdl.isLoading = true;

			var params = $mdl.getApiParams(tableState);

			HttpSvc.post('stocktransfers/lazyload/list/undelivery', params, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.isLoading = false;
					$mdl.data = result.data;
					$mdl.numOfRecord = result.numberOfRecords;
					$mdl.numOfPages = result.numberOfPages;
					refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = $mdl.numOfPages;
			return tableState;
		};

		$mdl.resetSearch = function()
		{
		}

		// ********************************************************

		$mdl.selectDocument = function(itemId) {
			$uibModalInstance.close(itemId);
		}

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	/** @ngInject */
	function DeliveryOrderDownloadExcelModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
		var $mdl = this;

		$mdl.batchList = [];
		$mdl.isLoading = false;
		$mdl.selectedBatchId = null;
		$mdl.batchId = null;

		// ********************************************************

		$mdl.loadData = function() {
			$mdl.isLoading = true;

			HttpSvc.get('deliveryorders/list/batchid', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.batchList = result;
					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		// ********************************************************

		$mdl.selectedBatchIdChanged = function() {
		    $mdl.batchId = $mdl.selectedBatchId;
		}

		// ********************************************************

		$mdl.downloadExcel = function() {
			$mdl.isLoading = true;
			var filename = "RMS_DeliveryOrder_Batch_" + $filter('date')(new Date(), 'yyyyMMddhhmmss');

			HttpSvc.getExcelObject("deliveryorders/exportac", Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isLoading = false;
					$mdl.loadData();
					//$uibModalInstance.dismiss('cancel');
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate Excel');
					return null;
				});
		}

		$mdl.downloadExcelPast = function() {
			if($mdl.selectedBatchId == null)
			{
				toastr.warning("Please select a Batch Number to download.");
				return;
			}

			$mdl.isLoading = true;

			var filename = "RMS_DeliveryOrder_" + $mdl.batchId;

			HttpSvc.getExcelObject("deliveryorders/reexportac/" + $mdl.batchId, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isLoading = false;
					//$uibModalInstance.dismiss('cancel');
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate Excel');
					return null;
				});
		}

		// ********************************************************

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// ********************************************************

		$mdl.loadData();
	};

	// (Autocount) Approve Credit Limit Modal
	function DOApproveCreditLimitModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.lockButtons = false;

		/* ********************************************************* */

		$mdl.confirmModal = function()
		{
			$mdl.lockButtons = true;
			$uibModalInstance.close();
		};

		$mdl.cancelModal = function() {
			$mdl.lockButtons = false;
			toastr.warning('Failed to confirm Delivery Order due to Customer has exceeded Credit Limit.', Auth.translate('ERROR'))
			$uibModalInstance.dismiss('cancel');
		};
	};

	// (Autocount) Request for Credit Limit Approval Modal
	function DORequestCreditLimitApprovalModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.lockButtons = false;

		/* ********************************************************* */

		$mdl.confirmModal = function()
		{
			$mdl.lockButtons = true;
			$uibModalInstance.close();
		};

		$mdl.cancelModal = function() {
			$mdl.lockButtons = false;
			$uibModalInstance.dismiss('cancel');
		};
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.ezyshare.controller', [])
        .controller('EzyShareCtrl', EzyShareCtrl)
        .controller('EzySharePasswordDialogCtrl', EzySharePasswordDialogCtrl);
	
	/** @ngInject */
    function EzyShareCtrl($scope, $state, $stateParams, $sce, $uibModal, Auth, HttpSvc, RmsApi, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.shareObj = {};
		vm.entity = {};
		vm.password = "";
		vm.ingredients = [];
		vm.childEntities = [];
		vm.batch = 1;
		vm.prodQty = 1;
		vm.isAuthenticated = false;
		vm.isLoggedIn = Auth.isLoggedIn();
		vm.rootUrl = RmsApi.BLOBURL;
		vm.ingredientGroup = [];
		
		/* ******************************************************* */

		// Go Back
		vm.goBack = function() {
			window.history.back();
		}
		
		// Batch No Changed
		vm.batchChanged = function() {
			if(!angular.isNumber(vm.batch)) {
				vm.batch = 1;
			}
			if(vm.batch<=0) {
				vm.batch = 1;
			}
			vm.prodQty = vm.batch * vm.entity.productionQuantity;
			vm.prodQty = parseFloat(vm.prodQty.toFixed(3));
			
			vm.ingredients.forEach(function (i) {
				i.displayQty = i.quantity * vm.batch;
				i.displayQty = parseFloat(i.displayQty.toFixed(3));
			});	
			
			vm.childEntities.forEach(function(r) {
				r.childRecipeDisplayQty = r.childRecipeQty * vm.batch;
				r.childRecipeDisplayQty = parseFloat(r.childRecipeDisplayQty.toFixed(3));
					
				r.childRecipeItems.forEach(function(x) {
					x.displayQty = x.quantity * vm.batch;
					x.displayQty = parseFloat(x.displayQty.toFixed(3));
				});
			})
			//$scope.$broadcast('refreshStTable');
		};
		
		// Adjust Batch Quantity
		vm.adjustBatch = function(qty) {
			vm.batch = vm.batch + qty;
			vm.batchChanged();
		};
		
		// Show Player
		vm.showPlayer = function(s) {
			s.showPlayer = true;
		};

		/* ******************************************************* */
		
		vm.checkUniqueCode = function() {
			HttpSvc.get('ezyshare/check/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.shareObj.id = result.id;
					vm.promptPassword();
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'))
					$state.go('dashboard');
					return;
				});		
		};

		vm.promptPassword = function() {

			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'passwordDialogModal.html',
				controller: 'EzySharePasswordDialogCtrl',
				controllerAs: '$mdl',
				size: 'sm',
				resolve: {
					item: function () {
						return {
							objectId: vm.shareObj.id
						}
					}
				}
			});
	
			modalInstance
				.result
				.then(function (data) {
					vm.isAuthenticated = true;
					vm.shareObj = data;

					if(vm.shareObj.objectType=="SOP")
					{
						vm.loadSOP(vm.shareObj.objectId);
					}
					else if(vm.shareObj.objectType=="RECIPE")
					{
						vm.loadRecipe(vm.shareObj.objectId);
					}
				}, function () {					
					$state.go("dashboard");
				});

		}
		
		/* ******************************************************* */

		// Load SOP
		vm.loadSOP = function(sopId) {
			
			var params = {
				entityId: sopId,
				id: vm.shareObj.id,
				password: vm.shareObj.password,
			};

			HttpSvc.post('ezyshare/sop', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.entity = result;
					vm.prodQty = vm.entity.productionQuantity;
					
					if(!vm.entity.imageLocation || vm.entity.imageLocation=='') {
						vm.entity.imageLocation = 'assets/img/sop_empty_placeholder.png';
						vm.entity.thumbnail = 'assets/img/sop_empty_placeholder.png';
						vm.entity.oriImageLocation = "";
					} else {
						vm.entity.imageLocation = vm.rootUrl + vm.entity.imageLocation;
						if(!vm.entity.thumbnail || vm.entity.thumbnail==''){
							vm.entity.thumbnail = null;
						} else {
							vm.entity.thumbnail = vm.rootUrl + vm.entity.thumbnail;
						}
					}		
					
					vm.entity.entitySteps.forEach(function (c) {		
						if(c.attachmentType!=null) {
							// if(c.attachmentType=="youtube") {
							// 	c.youtubeId = c.attachmentLocation;
							// 	c.attachmentLocation = "http://www.youtube.com/embed/" + c.attachmentLocation;
							// }
							
							if(c.attachmentType.substr(0,5)=='video') {								
								c.finalVimeoUrl = 
									$sce.trustAsResourceUrl("https://player.vimeo.com/video/" + c.vimeoVideoId);
							}
						}
					});						
				}, function() {
					toastr.error(error, Auth.translate('ERROR'))
					$state.go('dashboard');
					return;
				});		
		};

		// Load Recipe
		vm.loadRecipe = function(recipeId) {
			
			var params = {
				entityId: recipeId,
				id: vm.shareObj.id,
				password: vm.shareObj.password,
			};

			HttpSvc.post('ezyshare/recipe', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.entity = result;
					vm.prodQty = vm.entity.productionQuantity;
					
					if(!vm.entity.imageLocation || vm.entity.imageLocation=='') {
						vm.entity.imageLocation = 'assets/img/empty_placeholder_placeholder.png';
						vm.entity.thumbnail = 'assets/img/empty_placeholder_placeholder.png';
						vm.entity.oriImageLocation = "";
					} else {
						vm.entity.imageLocation = vm.rootUrl + vm.entity.imageLocation;
						if(!vm.entity.thumbnail || vm.entity.thumbnail==''){
							vm.entity.thumbnail = null;
						} else {
							vm.entity.thumbnail = vm.rootUrl + vm.entity.thumbnail;
						}
					}		
					
					vm.entity.recipeItems.forEach(function (i) {
						/* i.displayQty = i.quantity;						
						
						if(vm.ingredientGroup.map(function(e) { return e.groupName; }).indexOf(i.category)<0) {
							vm.ingredientGroup.push({ groupName: i.category });	
						} */
						
						if(i.childRecipeId!=null){
							vm.childEntities.push({
								childRecipeId: i.childRecipeId,
								childRecipeName: i.childRecipeName,								
								childRecipeItems: i.childRecipeItems,
								childRecipeQty: i.quantity,
								childRecipeDisplayQty: i.quantity,
								childRecipeUom: i.unitOfMeasurement.name,
							});
							vm.childEntities.forEach(function(r) {
								r.childRecipeItems.forEach(function(x) {
									x.displayQty = x.quantity;
								});
							})
						} else {							
							vm.ingredients.push({
								itemName: i.itemName,
								groupName: (i.category==null?'General Ingredients':i.category),
								quantity: i.quantity,
								displayQty: i.quantity,
								uom: i.unitOfMeasurement.name,
							});
						}
					});	
					
					vm.entity.entitySteps.forEach(function (c) {						
						if(c.attachmentType!=null) {
							if(c.attachmentType=="youtube") {
								c.youtubeId = c.attachmentLocation;
								c.attachmentLocation = "http://www.youtube.com/embed/" + c.attachmentLocation;
							}
							
							if(c.attachmentType.substr(0,5)=='video') {								
								c.finalVimeoUrl = 
									$sce.trustAsResourceUrl("https://player.vimeo.com/video/" + c.vimeoVideoId);
							}
						}
					});						
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'))
					$state.go('dashboard');
					return;
				});		
		};

		/* ******************************************************* */
		
		// Call Actions
		vm.checkUniqueCode();
	};
    
    /** @ngInject */
    function EzySharePasswordDialogCtrl($uibModalInstance, $timeout, Auth, RmsApi, HttpSvc, UtilSvc, item, toastr) {
		var $mdl = this;
  
		$mdl.objectId = item.objectId;
		$mdl.item = {};
		$mdl.errorMsg = "";
		$mdl.showError = false;
		$mdl.showSuccess = false;
		$mdl.lockButton = false;
  
		/* ********************************************************* */
						  
		$mdl.confirmModal = function() {
		  if($mdl.passwordForm.$invalid) {
			$mdl.errorMsg = UtilSvc.getErrorMessage($mdl.shareForm);
			$mdl.showError = true;
		  } else {
			$mdl.lockButton = true;
			$mdl.showError = false;

			var password = $mdl.item.password;
			$mdl.item.id = $mdl.objectId;
  
			HttpSvc.post('ezyshare/detail', $mdl.item, Auth.getTokenId(), false)
			  .then(function(result) {
				$mdl.item = result;
				$mdl.item.password = password;
				$mdl.showSuccess = true;
				$timeout(function() { $uibModalInstance.close($mdl.item) }, 1500);
			  }, function(error) {
				$mdl.errorMsg = error;
				$mdl.showError = true;
				$mdl.lockButton = false;
			  });
		  }
		};
		
		// Cancel Action
		$mdl.cancelModal = function() {
		  $uibModalInstance.dismiss('cancel');
		};
	};	
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.ezytrack.controller', [])
        .controller('EzyTrackCtrl', EzyTrackCtrl);
	
	/** @ngInject */
    function EzyTrackCtrl($scope, $state, $stateParams, $timeout, $interval, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.isLoggedIn = Auth.isLoggedIn();
		vm.interval = null;
		vm.distance = null;
		vm.duration = null;
		vm.pointA = null;
		vm.pointB = null;

		/* ******************************************************* */

		vm.init = function() {
			vm.loadRoute();
			vm.interval = $interval(vm.loadRoute, 30000);
		}

		// Load Route
		vm.loadRoute = function() {
			HttpSvc.get('routeplans/routeplandebtor/anonymous/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.route = result;									
                    $timeout(vm.loadMap, 1000);
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'))
					return;
				});		
		};

		/* ******************************************************* */

        vm.loadMap = function() 
		{			
			//var pointA = new google.maps.LatLng(3.1936995, 101.6412453); // Latitude and longitude for Driver
			var pointA = new google.maps.LatLng(vm.route.driverGpsLat, vm.route.driverGpsLng); // Latitude and longitude for Driver
			var pointB = new google.maps.LatLng(vm.route.gpsLat, vm.route.gpsLng); // Latitude and longitude for Destination
			if (vm.pointA != null && google.maps.geometry) {
				var distance = new google.maps.geometry.spherical.computeDistanceBetween(vm.pointA, pointA);
				if (distance <= 100) {
					return;
				}
			}
			vm.pointA = pointA;

            var myOptions = {
				mapTypeControl: false,
				fullscreenControl: false,
				streetViewControl: false,
                zoom: 7,
                center: pointA
            };

            var gMap = new google.maps.Map(document.getElementById('googleMap'), myOptions);

            // Instantiate a directions service
            var directionsService = new google.maps.DirectionsService();
            var directionsDisplay = new google.maps.DirectionsRenderer({ map: gMap, suppressMarkers: true });

            // Create markers for Point A and Point B
            var markerA = new google.maps.Marker({
                position: pointA,
				opacity: 1,
				icon: {
					url: "assets/img/truck-icon.png",
					scaledSize: new google.maps.Size(38, 50)
				},			
                map: gMap
            });

            var markerB = new google.maps.Marker({
                position: pointB,
				label: {
					color: 'white',
					fontWeight: 'bold',
					text: 'B',
				},
                map: gMap
            });

            // Get route from Point A to Point B
            calculateAndDisplayRoute(directionsService, directionsDisplay, pointA, pointB);
		}

		function calculateAndDisplayRoute(directionsService, directionsDisplay, pointA, pointB) {
            directionsService.route({
                origin: pointA,
                destination: pointB,
                travelMode: google.maps.TravelMode.DRIVING
            }, function(response, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    directionsDisplay.setDirections(response);

                    // Extract distance and duration
                    vm.distance = response.routes[0].legs[0].distance.text;
                    vm.duration = response.routes[0].legs[0].duration.text;
                } else {                    
                    toastr.warning('Failed to load the route. (' + status + ')');
                }
            });
        }
		
		/* ******************************************************* */		

		$scope.$on('$destroy', function(){
			$interval.cancel(vm.interval);
		});
		
		/* ******************************************************* */
		
		vm.init();
	};
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.login')
        .controller('LoginCtrl', LoginCtrl)
        .controller('LoginChangeCtrl', LoginChangeCtrl)
        .controller('LoginSwitchCtrl', LoginSwitchCtrl);
		
    /** @ngInject */
    function LoginCtrl($scope, $rootScope, $state, Auth, toastr) {       
		
		Auth.init();	
		
		$scope.credential = {}
		$scope.credential.username = "";
		$scope.credential.password = "";
		$scope.credential.failed = false;
		$scope.credential.resetFailed = false;
		$scope.credential.step1 = false;
		$scope.credential.step2 = false;
		$scope.credential.submit1 = false;
		$scope.credential.submit2 = false;
		$scope.credential.selectedCompany = null;
		$scope.credential.selectedBranch = null;
		$scope.credential.isLoggingIn1 = false;
		$scope.credential.isLoggingIn2 = false;
				
		$scope.navigateToReset = function() {			
			$state.go('resetpassword');
		}
		
		$scope.navigateToLogin = function() {			
			$state.go('login');
		}

		$scope.backToLogin = function() {
			$scope.credential.step1 = false;
			$scope.credential.step2 = false;
		}

		$scope.login = function() {
			$scope.credential.isLoggingIn1 = true;

			Auth.login($scope.credential.username, $scope.credential.password)
				.then(function() {
					$scope.credential.isLoggingIn1 = false;

					$scope.credential.username = "";
					$scope.credential.password = "";
					$scope.credential.step1 = true;
					
					if(!Auth.hasMultipleCompanies() && !Auth.hasMultipleBranches()) {
						$scope.credential.step2 = true;
						
						Auth.selectBranchTokenDefault()
							.then(function() {		
								$scope.credential.submit1 = true;  	
								toastr.success('', 'Login successfully!');
								$state.go('dashboard', {}, {reload: true});

								// if(Auth.hasCompanyFeature('durianops'))
								// {
								// 	$state.go('duriandashboard', {}, {reload: true});
								// }
								// else
								// {
								// 	$state.go('dashboard', {}, {reload: true});
								// }
							}, function(error) {
								toastr.warning(error, 'Login Failed');
								$scope.credential.submit1 = false;
							});
					}					
				}, function(errorMessage) {
					$scope.credential.isLoggingIn1 = false;
					$scope.credential.failed = true;
					toastr.error(errorMessage, 'Login Failed');
				});
		};

		$scope.selectedCompanyChanged = function() {
			Auth.selectCompany($scope.credential.selectedCompany.id, $scope.credential.selectedCompany.name);
			$scope.credential.selectedBranch = null;
		};

		$scope.selectedBranchChanged = function(item) {
			Auth.selectBranch($scope.credential.selectedBranch.id, $scope.credential.selectedBranch.name);
		};
		
        $scope.loginBranchToken = function() {
			if($scope.credential.selectedBranch==null) {
				toastr.error('You must select a Branch in order to proceed.', Auth.translate('ERROR'));
				return;
			}
			
			$scope.credential.isLoggingIn2 = true;
			
			Auth.selectBranchToken()
				.then(function() {
					$scope.credential.submit2 = true;  			  
					toastr.success('', 'Login successfully!');
					$state.go('dashboard');
				}, function(error) {
					$scope.credential.isLoggingIn2 = false;
					toastr.warning(error, 'Login Failed');
					$scope.credential.submit2 = false;
				});
        };
		
        $scope.resetPassword = function() {			
						
			Auth.resetPwd($scope.credential.email)
				.then(function() {				  
					toastr.success("An email which contains the new password has been sent to you.", 'Reset Successful');
					$scope.credential.email = "";
				}, function() {
					$scope.credential.resetFailed = true;
					toastr.error('Invalid email address.', 'Reset Failed');
				});
        };
    }
	
	/** @ngInject */
    function LoginChangeCtrl($scope, $rootScope, $state, Auth, toastr) {       
		var vm = this;
		
		Auth.init();	

		vm.oldpassword = "";
		vm.newpassword1 = "";
		vm.newpassword2 = "";
		vm.disableSubmit = false;
		
		vm.changePassword = function() {
			
			vm.submit = true;
			
			Auth.changePwd(vm.oldpassword, vm.newpassword1)
				.then(function() {				  
					toastr.success('You have updated the Password successfully!', '');
					$state.go('dashboard');
				}, function(errorMessage) {
					// Failed
					vm.submit = false;
					toastr.error(errorMessage, 'Update Failed');
				});
		};
		
		vm.onTextChanged = function() {	
			if(typeof vm.oldpassword == "undefined") vm.oldpassword = "";
			if(typeof vm.newpassword1 == "undefined") vm.newpassword1 = "";
			if(typeof vm.newpassword2 == "undefined") vm.newpassword2 = "";
			vm.disableSubmit = vm.oldpassword!=="" && vm.newpassword1!=="" && vm.newpassword2!=="" && vm.newpassword1===vm.newpassword2;			
		}
    }
	
	/** @ngInject */
    function LoginSwitchCtrl($scope, $rootScope, $state, Auth, MsgSvc, toastr) {       
		
		Auth.init();	

		$scope.submit = false;

		$scope.selectCompany = function(item) {
			$scope.selectedCompany = item;
			$scope.selectedBranch = null;
		};

		$scope.selectBranch = function(item) {
			$scope.selectedBranch = item;
			item.selected = true;
		};
		
        $scope.loginBranchToken = function() {			
						
			Auth.selectCompany($scope.selectedCompany.id, $scope.selectedCompany.name);
			Auth.selectBranch($scope.selectedBranch.id, $scope.selectedBranch.name);
			$scope.submit = true;
			
			Auth.selectBranchToken()
				.then(function() {				  
					MsgSvc.loadMessages();
					
					toastr.success('Company: <b>' + 
										$scope.selectedCompany.name + '</b><br />Branch: <b>' + 
										$scope.selectedBranch.name + '</b>', 
								   'You have switched to:');
					$state.go('dashboard');
				}, function() {
					$scope.submit = false;
				});
        };
    }
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.login')
        .directive('valueMatch', [function () {
			return {
				restrict: 'A',
				scope:true,
				require: 'ngModel',
				link: function (scope, elem , attrs,control) {
					var checker = function () {
						var e1 = scope.$eval(attrs.ngModel); 
						var e2 = scope.$eval(attrs.valueMatch);
						return e1 == e2;
					};

					scope.$watch(checker, function (n) {
						control.$setValidity("unique", n);
					});
				}
			};
		}]);
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.permissioncenter.controller', [])
        .controller('PermissionCenterCtrl', PermissionCenterCtrl)
        .controller('PermissionCenterModalCtrl', PermissionCenterModalCtrl);

    /** @ngInject */
    function PermissionCenterCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.permissions = [];
		vm.isLoading = false;
		
		vm.loadPermissionList = function() {
			vm.isLoading = true;
			
			HttpSvc.get('permissioncenter/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.permissions = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data. ' + error, '');
					return null;
				});
		}		
				
		// Open Clone Recipe Modal Dialog
		vm.showAccessModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'accessModal.html',
				controller: 'PermissionCenterModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					vm.loadPermissionList();
				}, function () {
				});
		};	

		vm.revokeAccess = function(accessCompanyId) {
			vm.isLoading = true;
			
			HttpSvc.post('permissioncenter/revokeaccess/' + accessCompanyId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Access has been revoked successfully.', 'Revoke Access');
					vm.loadPermissionList();
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data. ' + error, '');
					return null;
				});
		}
		
		
		vm.loadPermissionList();
	}

	// Grant Access Modal Controller
	function PermissionCenterModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.companies = [];
		$mdl.selectedCompany = null;
		$mdl.isAgreeTnc = false;
		$mdl.lockButtons = false;
		$mdl.isLoading = false;
				
		// Load Company List
		$mdl.loadCompanies = function(keyword) {
			$mdl.isLoading = true;
			
			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.companies = result.filter(function(company) {
						return company.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
					});
					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve Company list.', '');
					$mdl.cancelModal();
					return null;
				});
		};			
				
		/* ******************************************************** */
		
		$mdl.confirmModal = function() {

			if(!$mdl.modalForm.$valid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$mdl.lockButtons = true;
								
				var perm = {
					accessCompanyId: $mdl.selectedCompany.id,
					isAgreeTnc: $mdl.isAgreeTnc
				};
				HttpSvc.post("permissioncenter", perm, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Access has been granted to <b>" + $mdl.selectedCompany.name + "</b> successfully.");
						$uibModalInstance.close();					
					}, function(error) {
						$mdl.lockButtons = false;
						toastr.error(error, 'Failed');
					});	
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Init
		//$mdl.loadCompanies();
	};	

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.affdashboard.controller', [])
        .controller('AffDashboardCtrl', AffDashboardCtrl);

    /** @ngInject */
    function AffDashboardCtrl($filter, $uibModal, Auth, baSidebarService, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.dashboardDataFull = [];
		vm.dashboardData = [];
		vm.isLoading = false;
		vm.selectedStatement = null;
		vm.statementList = [];
		vm.isProcessing = false;

		/* *************************************************************************************************** */

		function refreshTableState(tableState, startIndex, endIndex) {
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.dashboardDataFull, tableState.search.predicateObject) : vm.dashboardDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.dashboardData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.dashboardDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('affiliates/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.dashboardDataFull = result;

						vm.isLoading = false;						
						refreshTableState(tableState, vm.startIndex, vm.endIndex);						
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		/* *************************************************************************************************** */

		vm.loadStatement = function() {
			vm.isLoading = true;
			
			HttpSvc.get('affiliatestatements/list/' + Auth.getCompanyId(), {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.statementList = result;
					vm.isLoading = false;	
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve statement list.', '');
					return null;
				});
		}

		vm.downloadStatement = function() {

			if(vm.selectedStatement==null)
			{
				toastr.warning('Please select a statement first.');
				return;
			}

			vm.isProcessing = true;
			
			var filename = "STATEMENT_" + vm.selectedStatement.statementNo.replace("/", "-") + ".pdf";

			HttpSvc.getPdfObject('affiliatestatements/print/' + vm.selectedStatement.id, Auth.getTokenId(), filename)
				.then(function(result) {
					vm.isProcessing = false;
				}, function(error) {
					vm.isProcessing = false;
					return null;
				});
		}

		/* *************************************************************************************************** */

		vm.getModuleName = function(moduleType)  {
			if(moduleType=="RMS")
			{
				return "RMS Full Edition";
			}
			else if(moduleType=="RMS-L")
			{
				return "RMS Lite Edition";
			}
			else if(moduleType=="RMS-S")
			{
				return "RMS Starter Edition";
			}
		}

		/* *************************************************************************************************** */
		
		// Init Call
		vm.loadStatement();
	}
	
})();

(function() {
  'use strict';

  angular.module('RmsAppV2.pages.salesorders.controller', [])
    .controller('SalesOrderMainCtrl', SalesOrderMainCtrl)
    .controller('SalesOrderCreateCtrl', SalesOrderCreateCtrl)
    .controller('SalesOrderUpdateCtrl', SalesOrderUpdateCtrl)
    .controller('SalesOrderPrintModalCtrl', SalesOrderPrintModalCtrl)
    .controller('SalesOrderCloneCtrl', SalesOrderCloneCtrl)
    .controller('SalesOrderImportCtrl', SalesOrderImportCtrl)
    .controller('SalesOrderItemModalCtrl', SalesOrderItemModalCtrl)
    .controller('SOFoodMenuModalCtrl', SOFoodMenuModalCtrl)
    .controller('SalesOrderEmailModalCtrl', SalesOrderEmailModalCtrl)
    .controller('SODownloadExcelModalCtrl', SODownloadExcelModalCtrl)
    .controller('SOApproveCreditLimitModalCtrl', SOApproveCreditLimitModalCtrl)
    .controller('SORequestCreditLimitApprovalModalCtrl', SORequestCreditLimitApprovalModalCtrl);


  /** @ngInject */
  function SalesOrderMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {

    Auth.init();

    var vm = this;

    vm.pageSizeOption = [10, 20, 50, 100];
    vm.pageSize = 10;
    vm.numOfRecord = 0;
    vm.numOfPages = 0;
    vm.startIndex = 0;
    vm.endIndex = 0;
    vm.data = [];
    vm.currency = Auth.getCurrency();
    vm.isInvoiceEnabledForSO = Auth.isInvoiceEnabledForSO();

    vm.getApiParams = function(tableState)
		{
      if(tableState.search.predicateObject==null)
			{
        tableState.sort = {};
        tableState.search.predicateObject = {};
        tableState.pagination.start = 0;
      }

      var predicate = tableState.search.predicateObject;
      var sortBy = tableState.sort.predicate;
      var sortReverse = tableState.sort.reverse ? "1" : "0";

      var params = {
        keyword:  predicate.salesOrderNo,
        orderDate: predicate.createdDate,
        deliveryDate: predicate.deliveryDate,
        sourceBranchName: predicate.sourceBranchName,
        destBranchName: predicate.destBranchName,
        debtorName: predicate.debtorName,
        orderTitle: predicate.orderTitle,
        status: predicate.status,
        createdBy: predicate.createdBy,
        isOpenDoc: predicate.isOpenDoc,
        sortBy: sortBy,
        sortReverse: sortReverse,
        pageSize: vm.pageSize,
        pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
      };

      return params;
    }

    vm.retrieveData = function(tableState) {

      var pagination = tableState.pagination;

      vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
      vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

      vm.isLoading = true;

      var params = vm.getApiParams(tableState);

      HttpSvc.post('salesorders/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
          vm.isLoading = false;
          vm.data = result.data;
          vm.numOfRecord = result.numberOfRecords;
          vm.numOfPages = result.numberOfPages;
          refreshTableState(tableState, vm.startIndex, vm.endIndex);
        }, function(error) {
          vm.isLoading = false;
          toastr.error('Failed to retrieve data.', '');
          return null;
        });
    };

    function refreshTableState(tableState) {
      tableState.pagination.numberOfPages = vm.numOfPages;
      return tableState;
};

		vm.resetSearch = function()
		{
    }

    /* ****************************************************************** */

      // Show Print Dialog
      vm.showPrintDialog = function (docId, docNo) {

          var modalInstance = $uibModal.open({
              animation: true,
              backdrop: 'static',
              templateUrl: 'printModal.html',
              controller: 'SalesOrderPrintModalCtrl',
              controllerAs: '$mdl',
              size: 'md',
              resolve: {
                  item: function () {
                      return {
                          object: {
                              docId: docId,
                              docNo: docNo
                          },
                      }
                  }
              }
          });

          modalInstance
              .result
              .then(function (data) {
              }, function () {
              });
      };


    vm.printSalesOrder = function(salesOrderId, salesOrderNo) {

      var filename = "SALESORDER_" + salesOrderNo.replace("/", "_") + ".pdf";

      HttpSvc.getPdfObject('salesorders/print/' + salesOrderId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
        // Failed
        toastr.error('Failed to print Sales Order. ' + error, '');
        return null;
      });
    }

    vm.printInvoice = function (salesOrderId, invoiceNo) {

      var filename = "INVOICE_" + invoiceNo.replace("/", "_") + ".pdf";

      HttpSvc.getPdfObject(
        "salesorders/print/invoice/" + salesOrderId,
        Auth.getTokenId(),
        filename
      ).then(null, function (error) {
        // Failed
        toastr.error("Failed to print Invoice. " + error, "");
        return null;
      });
    };

    vm.emailSalesOrder = function (soId) {
      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'emailModal.html',
        controller: 'SalesOrderEmailModalCtrl',
        controllerAs: '$mdl',
        size: 'lg',
        resolve: {
          item: function () {
            return {
              soId: soId,
            }
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
          $scope.$broadcast('refreshStTable');
        }, function () {
          $scope.$broadcast('refreshStTable');
        });
    };

    vm.showDownloadExcelModal = function () {
      vm.product = {};

      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'downloadModal.html',
        controller: 'SODownloadExcelModalCtrl',
        controllerAs: '$mdl',
        size: 'md',
        resolve: {
          item: function () {
            return {}
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
    };

    /* ****************************************************************** */

    // Confirmed SalesOrder
    vm.confirmSalesOrder = function(salesOrderId) {
      HttpSvc.put('salesorders/confirm/' + salesOrderId, {}, Auth.getTokenId(), false)
				.then(function(result) {
          toastr.success('Sales Order status updated to CONFIRMED.', 'CONFIRMED');
          $state.reload();
        }, function(error) {
          toastr.error(error, 'Failed');
        });
    }

    // Complete SalesOrder
    vm.completeSalesOrder = function(salesOrderId) {
      HttpSvc.put('salesorders/complete/' + salesOrderId, {}, Auth.getTokenId(), false)
				.then(function(result) {
          toastr.success('Sales Order status updated to COMPLETED.', 'COMPLETED');
          $state.reload();
        }, function(error) {
          toastr.error(error, 'Failed');
        });
    }

    // Cancel SalesOrder
    vm.cancelSalesOrder = function(salesOrderId) {
      HttpSvc.put('salesorders/cancel/' + salesOrderId, {}, Auth.getTokenId(), false)
				.then(function(result) {
          toastr.success('Sales Order status updated to CANCELLED.', 'CANCELLED');
          $state.reload();
        }, function(error) {
          toastr.error(error, 'Failed');
        });
    }

    // Clone SalesOrder
    vm.cloneSalesOrder = function(salesOrderId) {
      $state.go('salesorders.clone', {'id': salesOrderId });
}
    };

  /** @ngInject */
  function SalesOrderCreateCtrl($scope, $state, $filter, $uibModal, Auth, HttpSvc, toastr) {

    Auth.init();

    var vm = this;
    vm.mode = 1;
    vm.isCloneMode = false;

    vm.statusList = [
      { id:'NEW', name:'NEW'},
      { id:'CONFIRMED', name:'CONFIRMED'}
    ];

    vm.originalStatus = 'NEW';
    vm.grandTotal = 0;
    vm.branchList = [];
    vm.debtorList = [];
    vm.debtorBranchList = [];
    vm.selectedStatus = null;
    vm.selectedDebtor = null;
    vm.selectedDebtorBranch = null;
    vm.isLoading = false;
    vm.lockButtons = false;
    vm.hasPosAccess = Auth.hasCompanyFeature('pos');
    vm.isDirectTriggerJobCreation = Auth.getSetting_SalesOrder_DirectTriggerJobCreation();
        vm.approveCreditLimit = false;
    vm.requestCreditApproval = false;
    vm.showDetailedInvView = false;
    vm.currency = Auth.getCurrency();
    vm.branchId = Auth.getBranchId();
    vm.subtotal = 0;
    vm.grandTotal = 0;
    vm.isShippingFeesEnabled = Auth.hasCompanyFeature('maintenance.shippingfees');

    /* ******************************************************* */
    // Set Default
    vm.setDefault = function() {
      vm.salesOrder = {};
      vm.salesOrder.status = 'NEW';
      vm.salesOrder.destBranchId = vm.branchId;
      vm.salesOrder.isDirectProduction = false;
      vm.salesOrder.salesOrderProducts = [];

      //vm.salesOrder.destBranchId = Auth.getBranchId();
      vm.selectedStatus = vm.statusList[0];
      vm.salesOrder.deliveryDate = $filter('date')(new Date(), 'yyyy-MM-dd hh:mma');

      vm.loadBranchList();
    }

    // Load Branch List
    vm.loadBranchList = function() {
      HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
          vm.branchList = result;

          vm.branchList.forEach(function(b) {
            if(b.id==vm.branchId)
						{
              vm.selectedDestBranch = b;
            }
          });
          vm.loadDebtorList();
        }, function() {
          // Failed
          toastr.error('Failed to retrieve branch list.', '');
          $state.go('salesorders.list');
			});
        }

    // Load Customer List
    vm.loadDebtorList = function() {
      HttpSvc.get('debtors/list/status/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
          vm.debtorList = result;
        }, function() {
          // Failed
          toastr.error('Failed to retrieve customer list.', '');
          $state.go('salesorders.list');
			});
        }

    // Load Customer Branch List
    vm.loadDebtorBranchList = function() {
      HttpSvc.get('debtors/' + vm.salesOrder.debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
          vm.debtorBranchList = result;
        }, function() {
          // Failed
          toastr.error('Failed to retrieve Customer Branch list.', '');
          return null;
});
        }

    /* ************************************************************ */

    vm.selectedStatusChanged = function() {
      vm.salesOrder.status = vm.selectedStatus.id;
    };

    vm.selectedSourceBranchChanged = function() {
      vm.salesOrder.sourceBranchId = vm.selectedSourceBranch.id;
    };

    vm.selectedDestBranchChanged = function() {
      vm.salesOrder.destBranchId = vm.selectedDestBranch.id;
    };

    vm.selectedDebtorBranchChanged = function() {
      vm.salesOrder.debtorBranchId = vm.selectedDebtorBranch.id;
    };

    vm.selectedDebtorChanged = function() {
      vm.salesOrder.debtorId = vm.selectedDebtor.id;
      vm.loadDebtorBranchList();
      vm.updateProductPriceFromSalesConfig();
    };

    vm.calculateItemSubtotalExcludeTax = function(product) {
        return (product.unitPrice * product.quantity) - (product.discountAmount || 0);
    };

    vm.recalculateGrandTotal = function(calculateShippingFee) {
      vm.subtotal = 0;
      vm.subtotalExcludeTax = 0;
      vm.grandTotal = 0;

      vm.salesOrder.salesOrderProducts.forEach(function(p) {
          vm.subtotal += p.subtotal;
          if (vm.isShippingFeesEnabled) {
              vm.subtotalExcludeTax += vm.calculateItemSubtotalExcludeTax(p);
          }
      });

      if (calculateShippingFee && vm.isShippingFeesEnabled) {
          var params = {
              companyId: Auth.getCompanyId(),
              debtorId: vm.salesOrder.debtorId,
              subtotalAmount: vm.subtotalExcludeTax,
          };

          HttpSvc.post('salesorders/calculateShippingFee', params, Auth.getTokenId(), false)
              .then(function (result) {
                  vm.salesOrder.shippingFeeDesc = result.shippingFeeDesc;
                  vm.salesOrder.shippingFeeCharges = result.shippingFeeCharges;
              }, function (error) {
                  return;
              });
      }


      vm.grandTotal += (vm.subtotal || 0);
      vm.grandTotal += (vm.salesOrder.shippingFeeCharges || 0);
      vm.grandTotal -= (vm.salesOrder.discountAmount || 0);
      vm.grandTotal += (vm.salesOrder.additionalCharges || 0);
      vm.salesOrder.grandTotal = vm.grandTotal;
    }

    vm.getReservedQty = function (obj) {
      return (obj.totalNewSalesOrderQuantity +
        obj.totalConfirmedSalesOrderQuantity +
        obj.totalDOPendingQuantity);
    }

    vm.getAvailableQty = function (obj) {
      return (obj.invBalance -
        obj.totalNewSalesOrderQuantity -
        obj.totalConfirmedSalesOrderQuantity -
        obj.totalDOPendingQuantity);
    }

    /* ************************************************************ */

    vm.updateProductPriceFromSalesConfig = function() {
      var params = {
        salesorderitem: vm.salesOrder.salesOrderProducts,
        filter: {
          debtorId: vm.salesOrder.debtorId
				}
      };

      HttpSvc.post('salesorders/refreshsalesorderproduct', params, Auth.getTokenId(), true)
				.then(function(result) {
          vm.processProductPrice(result);
          vm.calculateDiscountAmount1();
          vm.recalculateGrandTotal(true);
          vm.lockButtons = false;
        }, function(error) {
          toastr.error(error, Auth.translate('ERROR'));
          vm.lockButtons = false;
          return;
        });
    }

    vm.processProductPrice = function(itemList)
		{
      itemList.forEach(function(item) {
        vm.salesOrder.salesOrderProducts.forEach(function(prod) {
          if(item.itemId==prod.itemId &&
            item.productId==prod.productId &&
            item.semiFinishedProductId==prod.semiFinishedProductId)
					{
            prod.unitPrice = item.unitPrice;
            prod.discountAmount = item.discountAmount;
            prod.discountPercentage = item.discountPercentage;
            prod.tax = item.tax;
            prod.subtotal = item.subtotal;
            prod.invBalance = item.invBalance;
            prod.totalConfirmedSalesOrderQuantity = item.totalConfirmedSalesOrderQuantity;
            prod.totalDOPendingQuantity = item.totalDOPendingQuantity;
            prod.totalNewSalesOrderQuantity = item.totalNewSalesOrderQuantity;
            prod.totalNewSalesOrderQuantity = item.totalNewSalesOrderQuantity;
            prod.invUomName = item.invUomName;
          }
        })
      });
    }

    vm.calculateDiscountAmount1 = function () {
      vm.subtotal = 0;
      vm.salesOrder.salesOrderProducts.forEach(function(p) {
          vm.subtotal += p.subtotal;
      });
      if(vm.salesOrder.discountPercentage!=null)
			{
        vm.salesOrder.discountAmount = vm.subtotal * vm.salesOrder.discountPercentage / 100;
        vm.salesOrder.discountAmount = Math.round(vm.salesOrder.discountAmount * 100) / 100;
      }
			else
			{
        vm.salesOrder.discountAmount = null;
      }
      vm.recalculateGrandTotal(false);
    }

    vm.calculateDiscountAmount2 = function() {
      if(vm.salesOrder.discountAmount!=null)
			{
        vm.salesOrder.discountPercentage = vm.salesOrder.discountAmount / vm.subtotal * 100;
        vm.salesOrder.discountPercentage = Math.round(vm.salesOrder.discountPercentage * 100) / 100;
      }
			else
			{
        vm.salesOrder.discountPercentage = null;
      }
      vm.recalculateGrandTotal(false);
    }

    /* ************************************************************ */

    // Remove Product
    vm.removeProduct = function(index) {
      vm.salesOrder.salesOrderProducts.splice(index, 1);
      vm.calculateDiscountAmount1();
      vm.recalculateGrandTotal(true);
      $scope.$apply();
    };

    // Update Product
    vm.updateProduct = function(index, obj) {

      var isFound = false;
      vm.salesOrder.salesOrderProducts.forEach(function(i) {
        if(checkProductExist(i, obj))
				{
          i.id = obj.id;
          i.salesOrderId = obj.salesOrderId;
          i.itemId = obj.itemId;
          i.productId = obj.productId;
          i.semiFinishedProductId = obj.semiFinishedProductId;
          i.productCode = obj.productCode;
          i.productName = obj.productName;
          i.itemType = obj.itemType;
          i.quantity = obj.quantity;
          i.unitOfMeasurementId = obj.unitOfMeasurementId;
          i.uomName = obj.uomName;
          i.taxCode = obj.taxCode;
          i.tax = obj.tax;
          i.discountAmount = obj.discountAmount;
          i.discountPercentage = obj.discountPercentage;
          i.unitPrice = obj.unitPrice;
          i.subtotal = obj.subtotal;
          i.createdBy = obj.createdBy;
          i.createdDate = obj.createdDate;
          i.remarks = obj.remarks;
          isFound = true;
        }
      });

      if (isFound) {
        vm.updateProductPriceFromSalesConfig();
        return;
      };

      var element = {
        id: obj.id,
        salesOrderId: obj.salesOrderId,
        itemId: obj.itemId,
        productId: obj.productId,
        semiFinishedProductId: obj.semiFinishedProductId,
        productCode: obj.productCode,
        productName: obj.productName,
        itemType: obj.itemType,
        quantity: obj.quantity,
        unitOfMeasurementId: obj.unitOfMeasurementId,
        uomName: obj.uomName,
        taxCode: obj.taxCode,
        tax: obj.tax,
        discountAmount: obj.discountAmount,
        discountPercentage: obj.discountPercentage,
        unitPrice: obj.unitPrice,
        subtotal: obj.subtotal,
        createdBy: obj.createdBy,
        createdDate: obj.createdDate,
        remarks: obj.remarks,
      };
      vm.salesOrder.salesOrderProducts.splice(index, 1, element);
      vm.updateProductPriceFromSalesConfig();
    };

    // Add Product
    vm.addProduct = function(obj) {

      var isFound = false;
      vm.salesOrder.salesOrderProducts.forEach(function(i) {
        if(checkProductExist(i, obj))
				{
          i.id = obj.id;
          i.salesOrderId = obj.salesOrderId;
          i.itemId = obj.itemId;
          i.productId = obj.productId;
          i.semiFinishedProductId = obj.semiFinishedProductId;
          i.productCode = obj.productCode;
          i.productName = obj.productName;
          i.itemType = obj.itemType;
          i.quantity = obj.quantity;
          i.unitOfMeasurementId = obj.unitOfMeasurementId;
          i.uomName = obj.uomName;
          i.taxCode = obj.taxCode;
          i.tax = obj.tax;
          i.discountAmount = obj.discountAmount;
          i.discountPercentage = obj.discountPercentage;
          i.unitPrice = obj.unitPrice;
          i.subtotal = obj.subtotal;
          i.createdBy = obj.createdBy;
          i.createdDate = obj.createdDate;
          i.remarks = obj.remarks;

          isFound = true;
        }
      });

      if (isFound) {
        vm.updateProductPriceFromSalesConfig();
        return;
      };

      var element = {
        id: obj.id,
        salesOrderId: obj.salesOrderId,
        itemId: obj.itemId,
        productId: obj.productId,
        semiFinishedProductId: obj.semiFinishedProductId,
        productCode: obj.productCode,
        productName: obj.productName,
        itemType: obj.itemType,
        quantity: obj.quantity,
        unitOfMeasurementId: obj.unitOfMeasurementId,
        uomName: obj.uomName,
        taxCode: obj.taxCode,
        tax: obj.tax,
        discountAmount: obj.discountAmount,
        discountPercentage: obj.discountPercentage,
        unitPrice: obj.unitPrice,
        subtotal: obj.subtotal,
        createdBy: obj.createdBy,
        createdDate: obj.createdDate,
        remarks: obj.remarks,
      };
      // vm.salesOrder.salesOrderProducts.push(element);
      vm.salesOrder.salesOrderProducts.unshift(element);
      vm.updateProductPriceFromSalesConfig();
    };

    // Refresh Product List
    vm.refreshSalesOrderProducts = function(tableState) {
      // Do nothing
    };

    /* ************************************************************ */

    vm.addFoodMenuProduct = function(obj) {
      vm.lockButtons = true;

      var params = {
        debtorId: vm.salesOrder.debtorId
			}

      HttpSvc.post('foodmenus/salesconfig/' + obj.menuId, params, Auth.getTokenId(), false)
				.then(function(result) {
          result.foodMenuProducts.forEach(function(obj) {
            var isFound = false;
            vm.salesOrder.salesOrderProducts.forEach(function(i) {
              if(checkProductExist(i, obj))
							{
                i.id = obj.id;
                i.salesOrderId = obj.salesOrderId;
                i.itemId = obj.itemId;
                i.productId = obj.productId;
                i.semiFinishedProductId = obj.semiFinishedProductId;
                i.productCode = obj.productCode;
                i.productName = obj.productName;
                i.itemType = obj.itemType;
                i.quantity = obj.quantity;
                i.unitOfMeasurementId = obj.unitOfMeasurementId;
                i.uomName = obj.uomName;
                i.taxCode = obj.taxCode;
                i.tax = obj.tax;
                i.discountAmount = obj.discountAmount;
                i.discountPercentage = obj.discountPercentage;
                i.unitPrice = obj.unitPrice;
                i.subtotal = obj.subtotal;
                i.createdBy = obj.createdBy;
                i.createdDate = obj.createdDate;
                i.remarks = obj.remarks;

                isFound = true;
              }
            });
            if(isFound) return;

            var element = {
              id: obj.id,
              salesOrderId: obj.salesOrderId,
              itemId: obj.itemId,
              productId: obj.productId,
              semiFinishedProductId: obj.semiFinishedProductId,
              productCode: obj.productCode,
              productName: obj.productName,
              itemType: obj.itemType,
              quantity: obj.quantity,
              unitOfMeasurementId: obj.unitOfMeasurementId,
              uomName: obj.uomName,
              taxCode: obj.taxCode,
              tax: obj.tax,
              discountAmount: obj.discountAmount,
              discountPercentage: obj.discountPercentage,
              unitPrice: obj.unitPrice,
              subtotal: obj.subtotal,
              createdBy: obj.createdBy,
              createdDate: obj.createdDate,
              remarks: obj.remarks,
            };
            // vm.salesOrder.salesOrderProducts.push(element);
            vm.salesOrder.salesOrderProducts.unshift(element);
          });
          // vm.recalculateGrandTotal(false);
          vm.updateProductPriceFromSalesConfig();

          vm.lockButtons = false;
        }, function(error) {
          toastr.error(error, Auth.translate('ERROR'));
          vm.lockButtons = false;
          return;
});
        }

    /* ************************************************************ */

    // Open Modal Dialog
    vm.product = {};
    vm.showAddProductModal = function () {
      vm.product = {};

      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'salesOrderItemModal.html',
        controller: 'SalesOrderItemModalCtrl',
        controllerAs: '$mdl',
        size: 'lg',
        resolve: {
          item: function () {
            return {
              mode: 1,
              title: "ADD_NEW",
              object: vm.product,
              debtorId: vm.salesOrder.debtorId
						}
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
          vm.addProduct(data);
        }, function () {
				});
    };

    vm.showEditProductModal = function (index) {
      vm.product = angular.copy(vm.salesOrder.salesOrderProducts[index]);

      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'salesOrderItemModal.html',
        controller: 'SalesOrderItemModalCtrl',
        controllerAs: '$mdl',
        size: 'lg',
        resolve: {
          item: function () {
            return {
              mode: 2,
              title: "UPDATE",
              object: vm.product,
              debtorId: vm.salesOrder.debtorId
						}
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
          vm.updateProduct(index, data);
        }, function () {
				});
    };

    /* ************************************************************ */

    // Open Modal Dialog
    vm.showAddFoodMenuModal = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'foodMenuModal.html',
        controller: 'SOFoodMenuModalCtrl',
        controllerAs: '$mdl',
        size: 'lg',
        resolve: {
          item: function () {
            return {}
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
          vm.addFoodMenuProduct(data);
        }, function () {
				});
    };

    /* ************************************************************ */

    // Credit Limit Approval Modal Dialog
    vm.showCreditApprovalModal = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'creditApprovalModal.html',
        controller: 'SOApproveCreditLimitModalCtrl',
        controllerAs: '$mdl',
        size: 'md',
        resolve: {
          item: function () {
            return {
              salesOrderId: null,
            }
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
          vm.approveCreditLimit = true;
          vm.submit();
        }, function () {
          vm.lockButtons = false;
        });
    };

    // Request for Credit Limit Approval Modal Dialog
    vm.showRequestCreditApprovalModal = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'requestCreditApprovalModal.html',
        controller: 'SORequestCreditLimitApprovalModalCtrl',
        controllerAs: '$mdl',
        size: 'md',
        resolve: {
          item: function () {
            return {
              salesOrderId: null,
            }
					}
				}
      });

      modalInstance
				.result
				.then(function () {
          vm.requestCreditApproval = true;
          vm.salesOrder.status = "NEW";
          vm.submit();
        }, function () {
          vm.salesOrder.status = "NEW";
          vm.submit();
        });
    };

    /* ************************************************************ */

    // Form Submission
    vm.submit = function() {
      if(vm.dataForm.$invalid) {
        toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
      } else {
        vm.lockButtons = true;

        var bApproveCreditLimit = vm.approveCreditLimit ? "/1" : "";

        HttpSvc.post('salesorders/add' + bApproveCreditLimit, vm.salesOrder, Auth.getTokenId(), false)
					.then(function(result) {
            vm.checkResult(result);
          }, function(error) {
            toastr.error(error, 'Failed');
            vm.lockButtons = false;
          });
      }
    }

    vm.submitRequestApproval = function(salesOrderId) {
      HttpSvc.post('salesorders/requestcreditlimitapproval/' + salesOrderId, {}, Auth.getTokenId(), false)
				.then(function(result) {
          toastr.success('Sales Order has been created successfully.', Auth.translate('SUCCESS'));
          toastr.info("Your request for Credit Limit Approval has been sent. " +
              "This Sales Order will be created with status [<b>NEW</b>].", "Request Sent")
          $state.go('salesorders.update', {'id': salesOrderId });
        }, function(error) {
          toastr.error(error, 'Failed To Request For Credit Limit Approval');
          vm.lockButtons = false;
        });
    }

    vm.checkResult = function(result)
		{
      if(result.httpStatusCode=="200")
			{
        if(vm.requestCreditApproval)
				{
          vm.submitRequestApproval(result.id);
        }
				else
				{
          toastr.success('Sales Order has been created successfully.', Auth.translate('SUCCESS'));
          $state.go('salesorders.update', {'id': result.id });
        }
      }
			else if(result.httpStatusCode=="300")
			{
        vm.showCreditApprovalModal();
      }
			else if(result.httpStatusCode=="350")
			{
        vm.showRequestCreditApprovalModal();
      }
			else if(result.httpStatusCode=="400")
			{
        toastr.error(result.message, Auth.translate('ERROR'));
        vm.lockButtons = false;
      }
			else
			{
        toastr.success('Sales Order has been updated successfully.', Auth.translate('SUCCESS'));
        $state.go('salesorders.update', {'id': result.id });
      }
    }

    /* ************************************************************ */

    // Call Actions
    vm.setDefault();
  };

  /** @ngInject */
  function SalesOrderUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {

    Auth.init();

    var vm = this;
    vm.mode = 2;
    vm.isCloneMode = false;

    vm.statusList = [
      { id:'NEW', name:'NEW'},
      { id:'CONFIRMED', name:'CONFIRMED'}
    ];

    vm.salesOrder = {};
    vm.originalStatus = 'NEW';
    vm.grandTotal = 0;
    vm.branchList = [];
    vm.debtorList = [];
    vm.debtorBranchList = [];
    vm.selectedStatus = null;
    vm.selectedDebtor = null;
    vm.selectedDebtorBranch = null;
    vm.isLoading = false;
    vm.lockButtons = false;
    vm.hasPosAccess = Auth.hasCompanyFeature('pos');
    vm.isDirectTriggerJobCreation = Auth.getSetting_SalesOrder_DirectTriggerJobCreation();
        vm.approveCreditLimit = false;
    vm.requestCreditApproval = false;
    vm.showDetailedInvView = false;
    vm.currency = Auth.getCurrency();
    vm.subtotal = 0;
    vm.grandTotal = 0;
    vm.isInvoiceEnabledForSO = Auth.isInvoiceEnabledForSO();
    vm.isShippingFeesEnabled = Auth.hasCompanyFeature('maintenance.shippingfees');

    /* ************************************************************ */

    // Load Branch List
    vm.loadBranchList = function() {
      HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
          vm.branchList = result;
          vm.loadDebtorList();
        }, function() {
          // Failed
          toastr.error('Failed to retrieve branch list.', '');
          $state.go('salesorders.list');
			});
        }

    // Load Customer List
    vm.loadDebtorList = function() {
      HttpSvc.get('debtors/list/status/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
          vm.debtorList = result;
          vm.loadSalesOrder();
        }, function() {
          // Failed
          toastr.error('Failed to retrieve customer list.', '');
          $state.go('salesorders.list');
			});
        }

    // Load Customer Branch List
    vm.loadDebtorBranchList = function() {
      HttpSvc.get('debtors/' + vm.salesOrder.debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
          vm.debtorBranchList = result;

          vm.debtorBranchList.forEach(function(d) {
            if(d.id==vm.salesOrder.debtorBranchId)
						{
              vm.selectedDebtorBranch = d;
            }
          })
        }, function() {
          // Failed
          toastr.error('Failed to retrieve Customer Branch list.', '');
          return null;
});
        }

    // Load SalesOrder List
    vm.loadSalesOrder = function() {
      var params = { id: $stateParams.id };
      HttpSvc.get('salesorders/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
          vm.salesOrder = result;
          vm.salesOrder.deliveryDate = $filter('date')(vm.salesOrder.deliveryDate, 'yyyy-MM-dd hh:mma');
          vm.originalStatus = vm.salesOrder.status;
          vm.grandTotal = vm.salesOrder.grandTotal;

          vm.debtorList.forEach(function(d) {
            if(d.id==vm.salesOrder.debtorId)
						{
              vm.selectedDebtor = d;
            }
          })

          vm.statusList.forEach(function(s) {
            if(s.id==vm.salesOrder.status)
						{
              vm.selectedStatus = s;
            }
          })

          vm.branchList.forEach(function(s) {

						if(s.id==vm.salesOrder.sourceBranchId)
						{
              vm.selectedSourceBranch = s;
            }

            if(s.id==vm.salesOrder.destBranchId)
						{
              vm.selectedDestBranch = s;
            }
          })

          if(vm.salesOrder.debtorId!=null)
					{
            vm.loadDebtorBranchList();
          }
          vm.sortSOItems();
          vm.recalculateGrandTotal(false);

				}, function() {
          toastr.error('Failed to load selected Sales Order.', Auth.translate('ERROR'))
          $state.go('salesorders.list');
          return;
        });
    };

    vm.sortSOItems = function() {
      var categoryOrder = ['RAW MAT', 'SEMI FG', 'F.GOODS'];
      vm.salesOrder.salesOrderProducts.sort(function(a, b) {
        var categoryComparison = categoryOrder.indexOf((a.itemType || '').toUpperCase()) - categoryOrder.indexOf((b.itemType || '').toUpperCase());

        if (categoryComparison !== 0) {
          return categoryComparison;
        }
        
        // Sort alphabetically
        var productA = a.productName || a.productDescription || '';
        var productB = b.productName || b.productDescription || '';
        return productA.localeCompare(productB);
      });
    }

    /* ************************************************************ */

    vm.showEmailModal = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'emailModal.html',
        controller: 'SalesOrderEmailModalCtrl',
        controllerAs: '$mdl',
        size: 'lg',
        resolve: {
          item: function () {
            return {
              soId: vm.salesOrder.id,
            }
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
    };

      // Show Print Dialog
      vm.showPrintDialog = function () {

          var modalInstance = $uibModal.open({
              animation: true,
              backdrop: 'static',
              templateUrl: 'printModal.html',
              controller: 'SalesOrderPrintModalCtrl',
              controllerAs: '$mdl',
              size: 'md',
              resolve: {
                  item: function () {
                      return {
                          object: {
                              docId: vm.salesOrder.id,
                              docNo: vm.salesOrder.salesOrderNo
                          },
                      }
                  }
              }
          });

          modalInstance
              .result
              .then(function (data) {
              }, function () {
              });
      };

    // Print
    vm.printSalesOrder = function(salesOrderId, salesOrderNo) {

      var filename = "SALESORDER_" + salesOrderNo.replace("/", "_") + ".pdf";

      HttpSvc.getPdfObject('salesorders/print/' + salesOrderId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
        // Failed
        toastr.error('Failed to print Sales Order. ' + error, '');
        return null;
      });
    }

    vm.printInvoice = function (salesOrderId, invoiceNo) {

      var filename = "INVOICE_" + invoiceNo.replace("/", "_") + ".pdf";

      HttpSvc.getPdfObject(
        "salesorders/print/invoice/" + salesOrderId,
        Auth.getTokenId(),
        filename
      ).then(null, function (error) {
        // Failed
        toastr.error("Failed to print Invoice. " + error, "");
        return null;
      });
    };

    // Confirmed SalesOrder
    vm.confirmSalesOrder = function() {
      HttpSvc.put('salesorders/confirm/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
          toastr.success('Sales Order status updated to CONFIRMED.', 'CONFIRMED');
          $state.reload();
        }, function(error) {
          toastr.error(error, 'Failed');
        });
    }

    // Complete SalesOrder
    vm.completeSalesOrder = function() {
      HttpSvc.put('salesorders/complete/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
          toastr.success('Sales Order status updated to COMPLETED.', 'COMPLETED');
          $state.go('salesorders.list');
        }, function(error) {
          toastr.error(error, 'Failed');
        });
    }

    // Cancel SalesOrder
    vm.cancelSalesOrder = function() {
      HttpSvc.put('salesorders/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
          toastr.success('Sales Order status updated to CANCELLED.', 'CANCELLED');
          $state.go('salesorders.list');
        }, function(error) {
          toastr.error(error, 'Failed');
        });
    }

    // Clone SalesOrder
    vm.cloneSalesOrder = function() {
      $state.go('salesorders.clone', {'id': $stateParams.id });
    }

    /* ************************************************************ */

    vm.selectedStatusChanged = function() {
      vm.salesOrder.status = vm.selectedStatus.id;
    };

    vm.selectedSourceBranchChanged = function() {
      vm.salesOrder.sourceBranchId = vm.selectedSourceBranch.id;
    };

    vm.selectedDestBranchChanged = function() {
      vm.salesOrder.destBranchId = vm.selectedDestBranch.id;
    };

    vm.selectedDebtorChanged = function() {
      vm.salesOrder.debtorId = vm.selectedDebtor.id;
      vm.loadDebtorBranchList();
      vm.updateProductPriceFromSalesConfig();
    };

    vm.selectedDebtorBranchChanged = function() {
      vm.salesOrder.debtorBranchId = vm.selectedDebtorBranch.id;
    };

    vm.calculateItemSubtotalExcludeTax = function (product) {
        return (product.unitPrice * product.quantity) - (product.discountAmount || 0);
    };

    vm.recalculateGrandTotal = function (calculateShippingFee) {
      vm.subtotal = 0;
      vm.subtotalExcludeTax = 0;
      vm.grandTotal = 0;

      vm.salesOrder.salesOrderProducts.forEach(function(p) {
          vm.subtotal += p.subtotal;
          if (vm.isShippingFeesEnabled) {
              vm.subtotalExcludeTax += vm.calculateItemSubtotalExcludeTax(p);
          }
      });

      if (calculateShippingFee && vm.isShippingFeesEnabled) {
          var params = {
              companyId: Auth.getCompanyId(),
              debtorId: vm.salesOrder.debtorId,
              subtotalAmount: vm.subtotalExcludeTax,
          };

          HttpSvc.post('salesorders/calculateShippingFee', params, Auth.getTokenId(), false)
              .then(function (result) {
                  vm.salesOrder.shippingFeeDesc = result.shippingFeeDesc;
                  vm.salesOrder.shippingFeeCharges = result.shippingFeeCharges;
              }, function (error) {
                  return;
              });
      }

      vm.grandTotal += (vm.subtotal || 0);
      vm.grandTotal += (vm.salesOrder.shippingFeeCharges || 0);
      vm.grandTotal -= (vm.salesOrder.discountAmount || 0);
      vm.grandTotal += (vm.salesOrder.additionalCharges || 0);
      vm.salesOrder.grandTotal = vm.grandTotal;

    }

    vm.getReservedQty = function (obj) {
      return (obj.totalNewSalesOrderQuantity +
        obj.totalConfirmedSalesOrderQuantity +
        obj.totalDOPendingQuantity);
    }

    vm.getAvailableQty = function (obj) {
      return (obj.invBalance -
        obj.totalNewSalesOrderQuantity -
        obj.totalConfirmedSalesOrderQuantity -
        obj.totalDOPendingQuantity);
    }

    /* ************************************************************ */

    vm.updateProductPriceFromSalesConfig = function() {
      var params = {
        salesorderitem: vm.salesOrder.salesOrderProducts,
        filter: {
          debtorId: vm.salesOrder.debtorId
				}
      };

      HttpSvc.post('salesorders/refreshsalesorderproduct', params, Auth.getTokenId(), true)
				.then(function(result) {
          vm.processProductPrice(result);
          vm.calculateDiscountAmount1();
          vm.recalculateGrandTotal(true);
          vm.lockButtons = false;
        }, function(error) {
          toastr.error(error, Auth.translate('ERROR'));
          vm.lockButtons = false;
          return;
        });
    }

    vm.processProductPrice = function(itemList)
		{
      itemList.forEach(function(item) {
        vm.salesOrder.salesOrderProducts.forEach(function(prod) {
          if(item.itemId==prod.itemId &&
            item.productId==prod.productId &&
            item.semiFinishedProductId==prod.semiFinishedProductId)
					{
            prod.unitPrice = item.unitPrice;
            prod.discountAmount = item.discountAmount;
            prod.discountPercentage = item.discountPercentage;
            prod.tax = item.tax;
            prod.subtotal = item.subtotal;
            prod.invBalance = item.invBalance;
            prod.totalConfirmedSalesOrderQuantity = item.totalConfirmedSalesOrderQuantity;
            prod.totalDOPendingQuantity = item.totalDOPendingQuantity;
            prod.totalNewSalesOrderQuantity = item.totalNewSalesOrderQuantity;
            prod.totalNewSalesOrderQuantity = item.totalNewSalesOrderQuantity;
            prod.invUomName = item.invUomName;
          }
        })
      });
    }

    vm.calculateDiscountAmount1 = function() {
      vm.subtotal = 0;
      vm.salesOrder.salesOrderProducts.forEach(function(p) {
          vm.subtotal += p.subtotal;
      });
       if(vm.salesOrder.discountPercentage!=null)
			{
        vm.salesOrder.discountAmount = vm.subtotal * vm.salesOrder.discountPercentage / 100;
        vm.salesOrder.discountAmount = Math.round(vm.salesOrder.discountAmount * 100) / 100;
      }
			else
			{
        vm.salesOrder.discountAmount = null;
      }
      vm.recalculateGrandTotal(false);
    }
    

    vm.calculateDiscountAmount2 = function() {
      if(vm.salesOrder.discountAmount!=null)
			{
        vm.salesOrder.discountPercentage = vm.salesOrder.discountAmount / vm.subtotal * 100;
        vm.salesOrder.discountPercentage = Math.round(vm.salesOrder.discountPercentage * 100) / 100;
      }
			else
			{
        vm.salesOrder.discountPercentage = null;
      }
      vm.recalculateGrandTotal(false);
    }

    /* ************************************************************ */

    // Remove Product
    vm.removeProduct = function(index) {
      vm.salesOrder.salesOrderProducts.splice(index, 1);
      vm.calculateDiscountAmount1();
      vm.recalculateGrandTotal(true);
      $scope.$apply();
    };

    // Update Product
    vm.updateProduct = function(index, obj) {

      var isFound = false;
      vm.salesOrder.salesOrderProducts.forEach(function(i) {
        if(checkProductExist(i, obj))
				{
          i.id = obj.id;
          i.salesOrderId = obj.salesOrderId;
          i.itemId = obj.itemId;
          i.productId = obj.productId;
          i.semiFinishedProductId = obj.semiFinishedProductId;
          i.productCode = obj.productCode;
          i.productName = obj.productName;
          i.itemType = obj.itemType;
          i.quantity = obj.quantity;
          i.unitOfMeasurementId = obj.unitOfMeasurementId;
          i.uomName = obj.uomName;
          i.taxCode = obj.taxCode;
          i.tax = obj.tax;
          i.discountAmount = obj.discountAmount;
          i.discountPercentage = obj.discountPercentage;
          i.unitPrice = obj.unitPrice;
          i.subtotal = obj.subtotal;
          i.createdBy = obj.createdBy;
          i.createdDate = obj.createdDate;
          i.remarks = obj.remarks;
          isFound = true;
        }
      });

      if (isFound) {
        vm.updateProductPriceFromSalesConfig();
        return;
      };

      var element = {
        id: obj.id,
        salesOrderId: obj.salesOrderId,
        itemId: obj.itemId,
        productId: obj.productId,
        semiFinishedProductId: obj.semiFinishedProductId,
        productCode: obj.productCode,
        productName: obj.productName,
        itemType: obj.itemType,
        quantity: obj.quantity,
        unitOfMeasurementId: obj.unitOfMeasurementId,
        uomName: obj.uomName,
        taxCode: obj.taxCode,
        tax: obj.tax,
        discountAmount: obj.discountAmount,
        discountPercentage: obj.discountPercentage,
        unitPrice: obj.unitPrice,
        subtotal: obj.subtotal,
        createdBy: obj.createdBy,
        createdDate: obj.createdDate,
        remarks: obj.remarks,
      };
      vm.salesOrder.salesOrderProducts.splice(index, 1, element);
      vm.updateProductPriceFromSalesConfig();
    };

    // Add Product
    vm.addProduct = function(obj) {

      var isFound = false;
      vm.salesOrder.salesOrderProducts.forEach(function(i) {
        if(checkProductExist(i, obj))
				{
          i.id = obj.id;
          i.salesOrderId = obj.salesOrderId;
          i.itemId = obj.itemId;
          i.productId = obj.productId;
          i.semiFinishedProductId = obj.semiFinishedProductId;
          i.productCode = obj.productCode;
          i.productName = obj.productName;
          i.itemType = obj.itemType;
          i.quantity = obj.quantity;
          i.unitOfMeasurementId = obj.unitOfMeasurementId;
          i.uomName = obj.uomName;
          i.taxCode = obj.taxCode;
          i.tax = obj.tax;
          i.discountAmount = obj.discountAmount;
          i.discountPercentage = obj.discountPercentage;
          i.unitPrice = obj.unitPrice;
          i.subtotal = obj.subtotal;
          i.createdBy = obj.createdBy;
          i.createdDate = obj.createdDate;
          i.remarks = obj.remarks;
          isFound = true;
        }
      });


      if (isFound) {
        vm.updateProductPriceFromSalesConfig();
        return;
      };

      var element = {
        id: obj.id,
        salesOrderId: obj.salesOrderId,
        itemId: obj.itemId,
        productId: obj.productId,
        semiFinishedProductId: obj.semiFinishedProductId,
        productCode: obj.productCode,
        productName: obj.productName,
        itemType: obj.itemType,
        quantity: obj.quantity,
        unitOfMeasurementId: obj.unitOfMeasurementId,
        uomName: obj.uomName,
        taxCode: obj.taxCode,
        tax: obj.tax,
        discountAmount: obj.discountAmount,
        discountPercentage: obj.discountPercentage,
        unitPrice: obj.unitPrice,
        subtotal: obj.subtotal,
        createdBy: obj.createdBy,
        createdDate: obj.createdDate,
        remarks: obj.remarks,
      };
      // vm.salesOrder.salesOrderProducts.push(element);
      vm.salesOrder.salesOrderProducts.unshift(element);
      // vm.recalculateGrandTotal(false);
      vm.updateProductPriceFromSalesConfig();
    };

    // Refresh Product List
    vm.refreshSalesOrderProducts = function(tableState) {
      // Do nothing
    };

    /* ************************************************************ */

    vm.addFoodMenuProduct = function(obj) {
      vm.lockButtons = true;

      var params = {
        debtorId: vm.salesOrder.debtorId
			}

      HttpSvc.post('foodmenus/salesconfig/' + obj.menuId, params, Auth.getTokenId(), false)
				.then(function(result) {
          result.foodMenuProducts.forEach(function(obj) {
            var isFound = false;
            vm.salesOrder.salesOrderProducts.forEach(function(i) {
              if(checkProductExist(i, obj))
							{
                i.id = obj.id;
                i.salesOrderId = obj.salesOrderId;
                i.itemId = obj.itemId;
                i.productId = obj.productId;
                i.semiFinishedProductId = obj.semiFinishedProductId;
                i.productCode = obj.productCode;
                i.productName = obj.productName;
                i.itemType = obj.itemType;
                i.quantity = obj.quantity;
                i.unitOfMeasurementId = obj.unitOfMeasurementId;
                i.uomName = obj.uomName;
                i.taxCode = obj.taxCode;
                i.tax = obj.tax;
                i.discountAmount = obj.discountAmount;
                i.discountPercentage = obj.discountPercentage;
                i.unitPrice = obj.unitPrice;
                i.subtotal = obj.subtotal;
                i.createdBy = obj.createdBy;
                i.createdDate = obj.createdDate;
                i.remarks = obj.remarks;

                isFound = true;
              }
            });
            if(isFound) return;

            var element = {
              id: obj.id,
              salesOrderId: obj.salesOrderId,
              itemId: obj.itemId,
              productId: obj.productId,
              semiFinishedProductId: obj.semiFinishedProductId,
              productCode: obj.productCode,
              productName: obj.productName,
              itemType: obj.itemType,
              quantity: obj.quantity,
              unitOfMeasurementId: obj.unitOfMeasurementId,
              uomName: obj.uomName,
              taxCode: obj.taxCode,
              tax: obj.tax,
              discountAmount: obj.discountAmount,
              discountPercentage: obj.discountPercentage,
              unitPrice: obj.unitPrice,
              subtotal: obj.subtotal,
              createdBy: obj.createdBy,
              createdDate: obj.createdDate,
              remarks: obj.remarks,
            };
            // vm.salesOrder.salesOrderProducts.push(element);
            vm.salesOrder.salesOrderProducts.unshift(element);
          });
          // vm.recalculateGrandTotal(false);
          vm.updateProductPriceFromSalesConfig();

          vm.lockButtons = false;
        }, function(error) {
          toastr.error(error, Auth.translate('ERROR'));
          vm.lockButtons = false;
          return;
});
        }

    /* ************************************************************ */

    // Open Modal Dialog
    vm.product = {};
    vm.showAddProductModal = function () {
      vm.product = {};

      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'salesOrderItemModal.html',
        controller: 'SalesOrderItemModalCtrl',
        controllerAs: '$mdl',
        size: 'lg',
        resolve: {
          item: function () {
            return {
              mode: 1,
              title: "ADD_NEW",
              object: vm.product,
              debtorId: vm.salesOrder.debtorId
						}
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
          vm.addProduct(data);
        }, function () {
				});
    };
    vm.showEditProductModal = function (index) {
      vm.product = angular.copy(vm.salesOrder.salesOrderProducts[index]);

      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'salesOrderItemModal.html',
        controller: 'SalesOrderItemModalCtrl',
        controllerAs: '$mdl',
        size: 'lg',
        resolve: {
          item: function () {
            return {
              mode: 2,
              title: "UPDATE",
              object: vm.product,
              debtorId: vm.salesOrder.debtorId
						}
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
          vm.updateProduct(index, data);
        }, function () {
				});
    };

    /* ************************************************************ */

    // Open Modal Dialog
    vm.showAddFoodMenuModal = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'foodMenuModal.html',
        controller: 'SOFoodMenuModalCtrl',
        controllerAs: '$mdl',
        size: 'lg',
        resolve: {
          item: function () {
            return {}
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
          vm.addFoodMenuProduct(data);
        }, function () {
				});
    };

    /* ************************************************************ */

    // Open Modal Dialog
    vm.showCreditApprovalModal = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'creditApprovalModal.html',
        controller: 'SOApproveCreditLimitModalCtrl',
        controllerAs: '$mdl',
        size: 'md',
        resolve: {
          item: function () {
            return {
              salesOrderId: null,
            }
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
          vm.approveCreditLimit = true;
          vm.submit();
        }, function () {
          vm.lockButtons = false;
        });
    };

    // Request for Credit Limit Approval Modal Dialog
    vm.showRequestCreditApprovalModal = function() {
      var modalInstance = $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'requestCreditApprovalModal.html',
        controller: 'SORequestCreditLimitApprovalModalCtrl',
        controllerAs: '$mdl',
        size: 'md',
        resolve: {
          item: function () {
            return {
              salesOrderId: null,
            }
					}
				}
      });

      modalInstance
				.result
				.then(function () {
          vm.requestCreditApproval = true;
          vm.salesOrder.status = "NEW";
          vm.submit();
        }, function () {
          vm.salesOrder.status = "NEW";
          vm.submit();
        });
    };

    /* ************************************************************ */

    // Form Submission
    vm.submit = function() {
      if(vm.dataForm.$invalid) {
        toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
      } else {
        vm.lockButtons = true;

        var bApproveCreditLimit = vm.approveCreditLimit ? "/1" : "";

        HttpSvc.put('salesorders/' + $stateParams.id + bApproveCreditLimit, vm.salesOrder, Auth.getTokenId(), false)
					.then(function(result) {
            vm.checkResult(result);
          }, function(error) {
            toastr.error(error, 'Failed');
            vm.lockButtons = false;
          });
      }
    }

    vm.submitRequestApproval = function(salesOrderId) {
      HttpSvc.post('salesorders/requestcreditlimitapproval/' + salesOrderId, {}, Auth.getTokenId(), false)
				.then(function(result) {
          toastr.success('Sales Order has been updated successfully.', Auth.translate('SUCCESS'));
          toastr.info("Your request for approval has been sent. " +
              "This Sales Order will be updated with status [<b>NEW</b>].", "Request Sent")
          $state.reload();
        }, function(error) {
          toastr.error(error, 'Failed To Request For Credit Limit Approval');
          vm.lockButtons = false;
        });
    }

    vm.checkResult = function(result)
		{
      if(result.httpStatusCode=="200")
			{
        if(vm.requestCreditApproval)
				{
          vm.submitRequestApproval(vm.salesOrder.id);
        }
				else
				{
          toastr.success('Sales Order has been updated successfully.', Auth.translate('SUCCESS'));
          $state.reload();
        }
      }
			else if(result.httpStatusCode=="300")
			{
        vm.showCreditApprovalModal();
      }
			else if(result.httpStatusCode=="350")
			{
        vm.showRequestCreditApprovalModal();
      }
			else if(result.httpStatusCode=="400")
			{
        toastr.error(result.message, Auth.translate('ERROR'));
        vm.lockButtons = false;
      }
			else
			{
        toastr.success('Sales Order has been updated successfully.', Auth.translate('SUCCESS'));
        $state.reload();
      }
    }

    /* ************************************************************ */

    // Call Actions
    vm.loadBranchList();
  };

    // Print Dialog
    function SalesOrderPrintModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
        var $mdl = this;

        $mdl.isLoading = false;
        $mdl.item = item.object;
        $mdl.documentList = [];
        $mdl.isLoading = false;

        $mdl.loadLayouts = function () {
            $mdl.isLoading = true;

            HttpSvc.get('documentlayouts/list/SO', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    $mdl.isLoading = false;
                    $mdl.documentList = result;
                }, function (error) {
                    vm.isLoading = false;
                    toastr.error('Failed to retrieve document layout.', '');
                    $mdl.cancelModal
                });
        };

        /* *************************************************** */

        $mdl.printDocument = function (layoutId) {
            $mdl.isLoading = true;
            var filename = "SALES_ORDER_" + $mdl.item.docNo.replace("/", "_") + ".pdf";

            HttpSvc.getPdfObject('documentlayouts/print/' + layoutId + '/' + $mdl.item.docId, Auth.getTokenId(), filename)
                .then(function (result) {
                    $mdl.isLoading = false;
                    $mdl.cancelModal();
                }, function (error) {
                    $mdl.isLoading = false;
                    toastr.error('Failed to generate Sales Order. ' + error, '');
                    return null;
                });
        }

        /* *************************************************** */

        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Init
        $mdl.loadLayouts();
    }

  /** @ngInject */
  function SalesOrderCloneCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {

    Auth.init();

    var vm = this;
    vm.mode = 1;
    vm.isCloneMode = true;

    vm.statusList = [
      { id:'NEW', name:'NEW'},
      { id:'CONFIRMED', name:'CONFIRMED'}
    ];

    vm.salesOrder = {};
    vm.originalStatus = 'NEW';
    vm.grandTotal = 0;
    vm.branchList = [];
    vm.debtorList = [];
    vm.debtorBranchList = [];
    vm.selectedStatus = null;
    vm.selectedDebtor = null;
    vm.selectedDebtorBranch = null;
    vm.isLoading = false;
    vm.lockButtons = false;
    vm.hasPosAccess = Auth.hasCompanyFeature('pos');
    vm.isDirectTriggerJobCreation = Auth.getSetting_SalesOrder_DirectTriggerJobCreation();
        vm.approveCreditLimit = false;
    vm.requestCreditApproval = false;
    vm.showDetailedInvView = false;
    vm.currency = Auth.getCurrency();
    vm.subtotal = 0;
    vm.grandTotal = 0;

    /* ************************************************************ */

    // Load Branch List
    vm.loadBranchList = function() {
      HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
          vm.branchList = result;
          vm.loadDebtorList();
        }, function() {
          // Failed
          toastr.error('Failed to retrieve branch list.', '');
          $state.go('salesorders.list');
			});
        }

    // Load Customer List
    vm.loadDebtorList = function() {
      HttpSvc.get('debtors/list/status/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
          vm.debtorList = result;
          vm.companyId = result[0].companyId;
          vm.loadSalesOrder();
        }, function() {
          // Failed
          toastr.error('Failed to retrieve customer list.', '');
          $state.go('salesorders.list');
			});
        }

    // Load Customer Branch List
    vm.loadDebtorBranchList = function() {
      HttpSvc.get('debtors/' + vm.salesOrder.debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
          vm.debtorBranchList = result;

          vm.debtorBranchList.forEach(function(d) {
            if(d.id==vm.salesOrder.debtorBranchId)
						{
              vm.selectedDebtorBranch = d;
            }
          })
        }, function() {
          // Failed
          toastr.error('Failed to retrieve Customer Branch list.', '');
          return null;
});
        }

    // Load SalesOrder List
    vm.loadSalesOrder = function() {
      var params = { id: $stateParams.id };
      HttpSvc.get('salesorders/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
          vm.salesOrder = result;
          vm.salesOrder.deliveryDate = $filter('date')(vm.salesOrder.deliveryDate, 'yyyy-MM-dd hh:mma');
          vm.grandTotal = vm.salesOrder.grandTotal;
          vm.originalStatus = vm.salesOrder.status;
          vm.originalDocNo = null;
          vm.postedDate = null;

          vm.debtorList.forEach(function(d) {
            if(d.id==vm.salesOrder.debtorId)
						{
              vm.selectedDebtor = d;
            }
          })

          vm.statusList.forEach(function(s) {
            if(s.id==vm.salesOrder.status)
						{
              vm.selectedStatus = s;
            }
          })

          vm.branchList.forEach(function(s) {
            if(s.id==vm.salesOrder.destBranchId)
						{
              vm.selectedDestBranch = s;
            }
          })

          if(vm.salesOrder.debtorId!=null)
					{
            vm.loadDebtorBranchList();
          }

          if(vm.isCloneMode)
					{
            vm.originalStatus = 'NEW';
            vm.selectedStatus = vm.statusList[0];
            vm.salesOrder.status = 'NEW';
            vm.salesOrder.deliveryDate = $filter('date')(new Date(), 'yyyy-MM-dd hh:mma');

            vm.recalculateGrandTotal(false);
          }
        }, function() {
          toastr.error('Failed to load selected Sales Order.', Auth.translate('ERROR'))
          $state.go('salesorders.list');
          return;
        });
    };

    /* ************************************************************ */

    // Print
    vm.printSalesOrder = function(salesOrderId, salesOrderNo) {

      var filename = "SALESORDER_" + salesOrderNo.replace("/", "_") + ".pdf";

      HttpSvc.getPdfObject('salesorders/print/' + salesOrderId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
        // Failed
        toastr.error('Failed to print Sales Order. ' + error, '');
        return null;
      });
    }

    // Confirmed SalesOrder
    vm.confirmSalesOrder = function() {
      HttpSvc.put('salesorders/confirm/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
          toastr.success('Sales Order status updated to CONFIRMED.', 'CONFIRMED');
          $state.reload();
        }, function(error) {
          toastr.error(error, 'Failed');
        });
    }

    // Complete SalesOrder
    vm.completeSalesOrder = function() {
      HttpSvc.put('salesorders/complete/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
          toastr.success('Sales Order status updated to COMPLETED.', 'COMPLETED');
          $state.go('salesorders.list');
        }, function(error) {
          toastr.error(error, 'Failed');
        });
    }

    // Cancel SalesOrder
    vm.cancelSalesOrder = function() {
      HttpSvc.put('salesorders/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
          toastr.success('Sales Order status updated to CANCELLED.', 'CANCELLED');
          $state.go('salesorders.list');
        }, function(error) {
          toastr.error(error, 'Failed');
        });
    }

    /* ************************************************************ */

    vm.selectedStatusChanged = function() {
      vm.salesOrder.status = vm.selectedStatus.id;
    };

    vm.selectedSourceBranchChanged = function() {
      vm.salesOrder.sourceBranchId = vm.selectedSourceBranch.id;
    };

    vm.selectedDestBranchChanged = function() {
      vm.salesOrder.destBranchId = vm.selectedDestBranch.id;
    };

    vm.selectedDebtorChanged = function() {
      vm.salesOrder.debtorId = vm.selectedDebtor.id;
      vm.loadDebtorBranchList();
      vm.updateProductPriceFromSalesConfig();
    };

    vm.selectedDebtorBranchChanged = function() {
      vm.salesOrder.debtorBranchId = vm.selectedDebtorBranch.id;
    };

    vm.calculateItemSubtotalExcludeTax = function(product) {
        return (product.unitPrice * product.quantity) - (product.discountAmount || 0);
    };

    vm.recalculateGrandTotal = function(calculateShippingFee) {
      vm.subtotal = 0;
      vm.subtotalExcludeTax = 0;
      vm.grandTotal = 0;

      vm.salesOrder.salesOrderProducts.forEach(function(p) {
          vm.subtotal += p.subtotal;
          if (vm.isShippingFeesEnabled) {
              vm.subtotalExcludeTax += vm.calculateItemSubtotalExcludeTax(p);
          }
      });

      if (calculateShippingFee && vm.isShippingFeesEnabled) {
          var params = {
              companyId: Auth.getCompanyId(),
              debtorId: vm.salesOrder.debtorId,
              subtotalAmount: vm.subtotalExcludeTax,
          };

          HttpSvc.post('salesorders/calculateShippingFee', params, Auth.getTokenId(), false)
              .then(function (result) {
                  vm.salesOrder.shippingFeeDesc = result.shippingFeeDesc;
                  vm.salesOrder.shippingFeeCharges = result.shippingFeeCharges;
              }, function (error) {
                  return;
              });
      }

      vm.grandTotal += (vm.subtotal || 0);
      vm.grandTotal += (vm.salesOrder.shippingFeeCharges || 0);
      vm.grandTotal -= (vm.salesOrder.discountAmount || 0);
      vm.grandTotal += (vm.salesOrder.additionalCharges || 0);
      vm.salesOrder.grandTotal = vm.grandTotal;
    }

    vm.getReservedQty = function (obj) {
      return (obj.totalNewSalesOrderQuantity +
        obj.totalConfirmedSalesOrderQuantity +
        obj.totalDOPendingQuantity);
    }

    vm.getAvailableQty = function (obj) {
      return (obj.invBalance -
        obj.totalNewSalesOrderQuantity -
        obj.totalConfirmedSalesOrderQuantity -
        obj.totalDOPendingQuantity);
    }

    /* ************************************************************ */

    vm.updateProductPriceFromSalesConfig = function() {
      var params = {
        salesorderitem: vm.salesOrder.salesOrderProducts,
        filter: {
          debtorId: vm.salesOrder.debtorId
				}
      };

      HttpSvc.post('salesorders/refreshsalesorderproduct', params, Auth.getTokenId(), true)
				.then(function(result) {
          vm.salesOrder.salesOrderProducts = angular.copy(result);
          vm.calculateDiscountAmount1();
          vm.recalculateGrandTotal(true);
          //$scope.$broadcast('refreshStTable');

          vm.lockButtons = false;
        }, function(error) {
          toastr.error(error, Auth.translate('ERROR'));
          vm.lockButtons = false;
          return;
        });
    }

    vm.calculateDiscountAmount1 = function () {
      vm.subtotal = 0;
      vm.salesOrder.salesOrderProducts.forEach(function(p) {
          vm.subtotal += p.subtotal;
      });
      if(vm.salesOrder.discountPercentage!=null)
			{
        vm.salesOrder.discountAmount = vm.subtotal * vm.salesOrder.discountPercentage / 100;
        vm.salesOrder.discountAmount = Math.round(vm.salesOrder.discountAmount * 100) / 100;
      }
			else
			{
        vm.salesOrder.discountAmount = null;
      }
      vm.recalculateGrandTotal(false);
    }

    vm.calculateDiscountAmount2 = function() {
      if(vm.salesOrder.discountAmount!=null)
			{
        vm.salesOrder.discountPercentage = vm.salesOrder.discountAmount / vm.subtotal * 100;
        vm.salesOrder.discountPercentage = Math.round(vm.salesOrder.discountPercentage * 100) / 100;
      }
			else
			{
        vm.salesOrder.discountPercentage = null;
      }
      vm.recalculateGrandTotal(false);
    }

    /* ************************************************************ */

    // Remove Product
    vm.removeProduct = function(index) {
      vm.salesOrder.salesOrderProducts.splice(index, 1);
      vm.calculateDiscountAmount1();
      vm.recalculateGrandTotal(true);
      $scope.$apply();
    };

    // Update Product
    vm.updateProduct = function(index, obj) {

      var isFound = false;
      vm.salesOrder.salesOrderProducts.forEach(function(i) {
        if(checkProductExist(i, obj))
				{
          i.id = obj.id;
          i.salesOrderId = obj.salesOrderId;
          i.itemId = obj.itemId;
          i.productId = obj.productId;
          i.semiFinishedProductId = obj.semiFinishedProductId;
          i.productCode = obj.productCode;
          i.productName = obj.productName;
          i.itemType = obj.itemType;
          i.quantity = obj.quantity;
          i.unitOfMeasurementId = obj.unitOfMeasurementId;
          i.uomName = obj.uomName;
          i.taxCode = obj.taxCode;
          i.tax = obj.tax;
          i.discountAmount = obj.discountAmount;
          i.discountPercentage = obj.discountPercentage;
          i.unitPrice = obj.unitPrice;
          i.subtotal = obj.subtotal;
          i.createdBy = obj.createdBy;
          i.createdDate = obj.createdDate;
          i.remarks = obj.remarks;
          isFound = true;
        }
      });
      
      if (isFound) {
        vm.updateProductPriceFromSalesConfig();
        return;
      };

      var element = {
        id: obj.id,
        salesOrderId: obj.salesOrderId,
        itemId: obj.itemId,
        productId: obj.productId,
        semiFinishedProductId: obj.semiFinishedProductId,
        productCode: obj.productCode,
        productName: obj.productName,
        itemType: obj.itemType,
        quantity: obj.quantity,
        unitOfMeasurementId: obj.unitOfMeasurementId,
        uomName: obj.uomName,
        taxCode: obj.taxCode,
        tax: obj.tax,
        discountAmount: obj.discountAmount,
        discountPercentage: obj.discountPercentage,
        unitPrice: obj.unitPrice,
        subtotal: obj.subtotal,
        createdBy: obj.createdBy,
        createdDate: obj.createdDate,
        remarks: obj.remarks,
      };
      vm.salesOrder.salesOrderProducts.splice(index, 1, element);
      // vm.recalculateGrandTotal(false);
      vm.updateProductPriceFromSalesConfig();
    };

    // Add Product
    vm.addProduct = function(obj) {

      var isFound = false;
      vm.salesOrder.salesOrderProducts.forEach(function(i) {
        if(checkProductExist(i, obj))
				{
          i.id = obj.id;
          i.salesOrderId = obj.salesOrderId;
          i.itemId = obj.itemId;
          i.productId = obj.productId;
          i.semiFinishedProductId = obj.semiFinishedProductId;
          i.productCode = obj.productCode;
          i.productName = obj.productName;
          i.itemType = obj.itemType;
          i.quantity = obj.quantity;
          i.unitOfMeasurementId = obj.unitOfMeasurementId;
          i.uomName = obj.uomName;
          i.taxCode = obj.taxCode;
          i.tax = obj.tax;
          i.discountAmount = obj.discountAmount;
          i.discountPercentage = obj.discountPercentage;
          i.unitPrice = obj.unitPrice;
          i.subtotal = obj.subtotal;
          i.createdBy = obj.createdBy;
          i.createdDate = obj.createdDate;
          i.remarks = obj.remarks;
          isFound = true;
        }
      });

      if (isFound) {
        vm.updateProductPriceFromSalesConfig();
        return;
      };

      var element = {
        id: obj.id,
        salesOrderId: obj.salesOrderId,
        itemId: obj.itemId,
        productId: obj.productId,
        semiFinishedProductId: obj.semiFinishedProductId,
        productCode: obj.productCode,
        productName: obj.productName,
        itemType: obj.itemType,
        quantity: obj.quantity,
        unitOfMeasurementId: obj.unitOfMeasurementId,
        uomName: obj.uomName,
        taxCode: obj.taxCode,
        tax: obj.tax,
        discountAmount: obj.discountAmount,
        discountPercentage: obj.discountPercentage,
        unitPrice: obj.unitPrice,
        subtotal: obj.subtotal,
        createdBy: obj.createdBy,
        createdDate: obj.createdDate,
        remarks: obj.remarks,
      };
      // vm.salesOrder.salesOrderProducts.push(element);
      vm.salesOrder.salesOrderProducts.unshift(element);
      // vm.recalculateGrandTotal(false);
      vm.updateProductPriceFromSalesConfig();
    };

    // Refresh Product List
    vm.refreshSalesOrderProducts = function(tableState) {
      // Do nothing
    };

    /* ************************************************************ */

    vm.addFoodMenuProduct = function(obj) {
      vm.lockButtons = true;

      var params = {
        debtorId: vm.salesOrder.debtorId
			}

      HttpSvc.post('foodmenus/salesconfig/' + obj.menuId, params, Auth.getTokenId(), false)
				.then(function(result) {
          result.foodMenuProducts.forEach(function(obj) {
            var isFound = false;
            vm.salesOrder.salesOrderProducts.forEach(function(i) {
              if(checkProductExist(i, obj))
							{
                i.id = obj.id;
                i.salesOrderId = obj.salesOrderId;
                i.itemId = obj.itemId;
                i.productId = obj.productId;
                i.semiFinishedProductId = obj.semiFinishedProductId;
                i.productCode = obj.productCode;
                i.productName = obj.productName;
                i.itemType = obj.itemType;
                i.quantity = obj.quantity;
                i.unitOfMeasurementId = obj.unitOfMeasurementId;
                i.uomName = obj.uomName;
                i.taxCode = obj.taxCode;
                i.tax = obj.tax;
                i.discountAmount = obj.discountAmount;
                i.discountPercentage = obj.discountPercentage;
                i.unitPrice = obj.unitPrice;
                i.subtotal = obj.subtotal;
                i.createdBy = obj.createdBy;
                i.createdDate = obj.createdDate;
                i.remarks = obj.remarks;

                isFound = true;
              }
            });
            if(isFound) return;

            var element = {
              id: obj.id,
              salesOrderId: obj.salesOrderId,
              itemId: obj.itemId,
              productId: obj.productId,
              semiFinishedProductId: obj.semiFinishedProductId,
              productCode: obj.productCode,
              productName: obj.productName,
              itemType: obj.itemType,
              quantity: obj.quantity,
              unitOfMeasurementId: obj.unitOfMeasurementId,
              uomName: obj.uomName,
              taxCode: obj.taxCode,
              tax: obj.tax,
              discountAmount: obj.discountAmount,
              discountPercentage: obj.discountPercentage,
              unitPrice: obj.unitPrice,
              subtotal: obj.subtotal,
              createdBy: obj.createdBy,
              createdDate: obj.createdDate,
              remarks: obj.remarks,
            };
            // vm.salesOrder.salesOrderProducts.push(element);
            vm.salesOrder.salesOrderProducts.unshift(element);
          });
          // vm.recalculateGrandTotal(false);
          vm.updateProductPriceFromSalesConfig();

          vm.lockButtons = false;
        }, function(error) {
          toastr.error(error, Auth.translate('ERROR'));
          vm.lockButtons = false;
          return;
});
        }

    /* ************************************************************ */

    // Open Modal Dialog
    vm.product = {};
    vm.showAddProductModal = function () {
      vm.product = {};

      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'salesOrderItemModal.html',
        controller: 'SalesOrderItemModalCtrl',
        controllerAs: '$mdl',
        size: 'lg',
        resolve: {
          item: function () {
            return {
              mode: 1,
              title: "ADD_NEW",
              object: vm.product,
              debtorId: vm.salesOrder.debtorId
						}
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
          vm.addProduct(data);
        }, function () {
				});
    };
    vm.showEditProductModal = function (index) {
      vm.product = angular.copy(vm.salesOrder.salesOrderProducts[index]);

      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'salesOrderItemModal.html',
        controller: 'SalesOrderItemModalCtrl',
        controllerAs: '$mdl',
        size: 'lg',
        resolve: {
          item: function () {
            return {
              mode: 2,
              title: "UPDATE",
              object: vm.product,
              debtorId: vm.salesOrder.debtorId
						}
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
          vm.updateProduct(index, data);
        }, function () {
				});
    };

    /* ************************************************************ */

    // Open Modal Dialog
    vm.showAddFoodMenuModal = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'foodMenuModal.html',
        controller: 'SOFoodMenuModalCtrl',
        controllerAs: '$mdl',
        size: 'lg',
        resolve: {
          item: function () {
            return {}
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
          vm.addFoodMenuProduct(data);
        }, function () {
				});
    };

    /* ************************************************************ */

    // Open Modal Dialog
    vm.showCreditApprovalModal = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'creditApprovalModal.html',
        controller: 'SOApproveCreditLimitModalCtrl',
        controllerAs: '$mdl',
        size: 'md',
        resolve: {
          item: function () {
            return {
              salesOrderId: null,
            }
					}
				}
      });

      modalInstance
				.result
				.then(function (data) {
          vm.approveCreditLimit = true;
          vm.submit();
        }, function () {
          vm.lockButtons = false;
        });
    };

    // Request for Credit Limit Approval Modal Dialog
    vm.showRequestCreditApprovalModal = function() {
      var modalInstance = $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'requestCreditApprovalModal.html',
        controller: 'SORequestCreditLimitApprovalModalCtrl',
        controllerAs: '$mdl',
        size: 'md',
        resolve: {
          item: function () {
            return {
              salesOrderId: null,
            }
					}
				}
      });

      modalInstance
				.result
				.then(function () {
          vm.requestCreditApproval = true;
          vm.salesOrder.status = "NEW";
          vm.submit();
        }, function () {
          vm.salesOrder.status = "NEW";
          vm.submit();
        });
    };

    /* ************************************************************ */

    // Form Submission
    vm.submit = function() {
      if(vm.dataForm.$invalid) {
        toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
      } else {
        vm.lockButtons = true;

        var bApproveCreditLimit = vm.approveCreditLimit ? "/1" : "";

        HttpSvc.post('salesorders/add' + bApproveCreditLimit, vm.salesOrder, Auth.getTokenId(), false)
					.then(function(result) {
            vm.checkResult(result);
          }, function(error) {
            toastr.error(error, 'Failed');
            vm.lockButtons = false;
          });
      }
    }

    vm.submitRequestApproval = function(salesOrderId) {
      HttpSvc.post('salesorders/requestcreditlimitapproval/' + salesOrderId, {}, Auth.getTokenId(), false)
				.then(function(result) {
          toastr.success('Sales Order has been created successfully.', Auth.translate('SUCCESS'));
          toastr.info("Your request for approval has been sent. " +
              "This Sales Order will be updated with status [<b>NEW</b>].", "Request Sent")
          $state.reload();
        }, function(error) {
          toastr.error(error, 'Failed To Request For Credit Limit Approval');
          vm.lockButtons = false;
        });
    }

    vm.checkResult = function(result)
		{
      if(result.httpStatusCode=="200")
			{
        if(vm.requestCreditApproval)
				{
          vm.submitRequestApproval(vm.salesOrder.id);
        }
				else
				{
          toastr.success('Sales Order has been created successfully.', Auth.translate('SUCCESS'));
          $state.go('salesorders.update', {'id': result.id });
        }
      }
			else if(result.httpStatusCode=="300")
			{
        vm.showCreditApprovalModal();
      }
			else if(result.httpStatusCode=="350")
			{
        vm.showRequestCreditApprovalModal();
      }
			else if(result.httpStatusCode=="400")
			{
        toastr.error(result.message, Auth.translate('ERROR'));
        vm.lockButtons = false;
      }
			else
			{
        toastr.success('Sales Order has been created successfully.', Auth.translate('SUCCESS'));
        $state.go('salesorders.update', {'id': result.id });
      }
    }

    /* ************************************************************ */

    // Call Actions
    vm.loadBranchList();
  };

  /** @ngInject */
  function SalesOrderImportCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
    Auth.init();

    var vm = this;
    var azureStorageUrl = "";
    var localStorageUrl = "";
    vm.lockButtons = false;
    vm.uploadProgess = 0;
    vm.uploadProgessPercent = 0;
    vm.isUploaded = false;
    vm.isSuccess = false;
    vm.isFail = false;
    vm.isImporting = false;
    vm.isImportComplete = false;
    vm.isImportFailed = false;
    vm.serverMode = Auth.getServerMode();
    /* **************************************************** */

    var maxBlockSize = 4194304; // 4MB in bytes
    var numberOfBlocks = 1;
    var currentFilePointer = 0;
    var totalBytesRemaining = 0;
    var blockIds = new Array();
    var blockIdPrefix = "block-";
    var bytesUploaded = 0;
    var fileReader = new FileReader();
    var excelFilename = "";
    /* **************************************************** */

    vm.importOptions = {};
    vm.importOptions.excelContent = [];
    vm.importOptions.createSalesOrder = true;

    /* **************************************************** */

    vm.importResult = {};

    /* **************************************************** */

    vm.downloadTemplate = function() {

      var filename = "Sales Order Template.xlsx";
      vm.isExporting = true;

      HttpSvc.getExcelObject('salesorders/download/template', Auth.getTokenId(), filename)
				.then(
        function() {
          vm.isExporting = false;
        },
        function(error) {
          vm.isExporting = false;
          toastr.error('Failed to download the template. ' + error, 'Failed');
          return null;
        });
    };

    /* **************************************************** */


		vm.importData = function() {
      vm.isImporting = true;

      HttpSvc.post('salesorders/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
          // Do nothing
        }, function(error) {
          // Do nothing
});
        }

    /* **************************************************** */

    // Refresh Page
    vm.refreshPage = function() {
      $state.reload();
    }

    // Set Upload File Object
    vm.setUploadFile = function(excelFile) {
      vm.mediaToUpload = excelFile;
    }

    // Reset File Upload Params
    vm.resetFileUploadParams = function() {
      vm.isUploaded = false;
      vm.isSuccess = false;
      vm.isFail = false;
      vm.excelFilename = "";
      vm.importOptions.excelContent = [];

      numberOfBlocks = 1;
      currentFilePointer = 0;
      totalBytesRemaining = 0;
      blockIds = new Array();
      blockIdPrefix = "block-";
      bytesUploaded = 0;
      fileReader = new FileReader();
      excelFilename = "";
    }

    // Upload File
    vm.uploadFile = function() {
      vm.resetFileUploadParams();

      vm.lockButtons = true;
      vm.uploadProgess = 0;
      vm.uploadProgessPercent = 0;

      var extArray = vm.mediaToUpload.name.split(".");
      var mediaExtension = extArray[extArray.length-1].toLowerCase();
      var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
      excelFilename = newFilename;

      if(vm.serverMode==0)
			{
        localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();
        vm.uploadMedia(vm.mediaToUpload);
      }
			else if(vm.serverMode==1)
			{
        HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {

						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
            vm.uploadMedia(vm.mediaToUpload);

					}, function(error) {
            toastr.error(error, 'Failed');

            vm.isUploaded = false;
            vm.isFail = true;
            vm.lockButtons = false;
});
          }
              }

    // Upload Image to Azure Blob Storage
    vm.uploadMedia = function (_fileToUpload) {

			if(vm.serverMode==0) {	// Local Server

        Upload.upload({
          url: localStorageUrl,
          data: {file: _fileToUpload},
          headers: {'Authorization': 'basic ' + Auth.getTokenId() },
        }).then(function (resp) {
            vm.isUploaded = true;

            // Call Process Excel API
            HttpSvc.post('salesorders/import/' + excelFilename, {}, Auth.getTokenId(), true)
						.then(function(result) {
                vm.isSuccess = true;
                vm.lockButtons = false;

                vm.importOptions.excelContent = result;
                toastr.success("Excel uploaded successfully");
              }, function(error) {
                vm.isFail = true;
                vm.lockButtons = false;
                toastr.error(error);
              });
          }, function (resp) {
            vm.isUploaded = false;
            vm.isFail = true;
            vm.lockButtons = false;
            toastr.error('Excel failed to upload.');
          }, function (evt) {
            //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
          });

			}  else if(vm.serverMode==1) { // Azure Server

        /* Initialize variables */
        /* ************************************* */
        handleFileSelect(_fileToUpload);
        /* ************************************* */

        /* Initialize File Reader */
        /* ************************************* */
        fileReader = new FileReader();
        /* ************************************* */

        /* Upload File (First Block) */
        /* ************************************* */
        uploadFileInBlocks(_fileToUpload, azureStorageUrl);

        fileReader.onload = function(e) {
          if (e.target.readyState == FileReader.DONE) {
            var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];

            Upload.http({
              method: "PUT",
              url: uri,
              headers: {
                'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
              },
              data: e.target.result,
            }).then(function(response) {
                if (response.status==201) {
                  uploadFileInBlocks(_fileToUpload, azureStorageUrl);
                } else {
                  vm.lockButtons = false;
                }
              }, null, function(evt) {
                var uploadProgessTotal = _fileToUpload.size;
                vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
                vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));

                //_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
              });
          }
        };
      }
    };

    function handleFileSelect(_fileToUpload) {
      maxBlockSize = 4194304;
      currentFilePointer = 0;
      totalBytesRemaining = 0;

      var fileSize = _fileToUpload.size;
      if (fileSize < maxBlockSize) {
        maxBlockSize = fileSize;
      }
      totalBytesRemaining = fileSize;
      if (fileSize % maxBlockSize == 0) {
        numberOfBlocks = fileSize / maxBlockSize;
      } else {
        numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
      }
    }

    function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
      if (totalBytesRemaining > 0) {
        var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
        var blockId = blockIdPrefix + pad(blockIds.length+1, 6);

        blockIds.push(btoa(blockId));
        fileReader.readAsArrayBuffer(fileContent);

        currentFilePointer += maxBlockSize;
        totalBytesRemaining -= maxBlockSize;
        if (totalBytesRemaining < maxBlockSize) {
          maxBlockSize = totalBytesRemaining;
        }
      } else {
        commitBlockList(_fileToUpload, _azureStorageUrl);
      }
    }

    function commitBlockList(_fileToUpload, _azureStorageUrl) {
      var uri = _azureStorageUrl + '&comp=blocklist';
      var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
      for (var i = 0; i < blockIds.length; i++) {
        requestBody += '<Latest>' + blockIds[i] + '</Latest>';
      }
      requestBody += '</BlockList>';

      Upload.http({
        method: "PUT",
        url: uri,
        headers: {
          'x-ms-blob-content-type': _fileToUpload.type
        },
        data: requestBody,
      }).then(function(response) {
          vm.isUploaded = true;

          // Call Process Excel API
          HttpSvc.post('salesorders/import/' + excelFilename, {}, Auth.getTokenId(), true)
					.then(function(result) {
              vm.isSuccess = true;
              vm.lockButtons = false;

              vm.importOptions.excelContent = result;
              toastr.success("Excel uploaded successfully");
            }, function(error) {
              vm.isFail = true;
              vm.lockButtons = false;
              toastr.error(error);
            });
        }, function(error) {
          vm.isUploaded = false;
          vm.isFail = true;
          vm.lockButtons = false;
          toastr.error(error);
        });
    }

    function pad(number, length) {
      var str = '' + number;
      while (str.length < length) {
        str = '0' + str;
      }
      return str;
    }
  };

  // Product Modal (New)
  function SalesOrderItemModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
    var $mdl = this;
    $mdl.mode = item.mode;
    $mdl.title = item.title;
    $mdl.item = item.object;
    $mdl.debtorId = item.debtorId
    $mdl.itemList = [];
    $mdl.selectedItem = null;
    $mdl.lockButtons = false;
    $mdl.currencyCode = Auth.getCurrency();
    $mdl.isInit = true;

    /* ********************************************************* */

    $mdl.selectedItemChanged = function() {
      if(!$mdl.selectedItem) return;

      $mdl.item.itemId = $mdl.selectedItem.itemId;
      $mdl.item.semiFinishedProductId = $mdl.selectedItem.semiFinishedProductId;
      $mdl.item.productId = $mdl.selectedItem.productId;
      $mdl.item.productCode = $mdl.selectedItem.productCode;
      $mdl.item.productName = $mdl.selectedItem.productName;
      $mdl.item.itemType = $mdl.selectedItem.itemType;
      $mdl.item.unitPrice = $mdl.selectedItem.posPrice;
      $mdl.item.tax = $mdl.selectedItem.posTax;
      $mdl.item.taxPercent = $mdl.selectedItem.posTaxPercent;
      $mdl.item.taxCode = $mdl.selectedItem.posTaxCode || '';
      $mdl.item.unitOfMeasurementId = $mdl.selectedItem.unitOfMeasurementId;
      $mdl.item.uomName = $mdl.selectedItem.uomName;

      $mdl.recalculateTaxAndTotal();
    };

    $mdl.quantityChanged = function()
		{
      $mdl.calculateDiscountAmount1();
    }

    $mdl.calculateDiscountAmount1 = function()
		{
      if($mdl.item.discountPercentage!=null)
			{
        $mdl.item.discountAmount = $mdl.item.unitPrice * $mdl.item.quantity * $mdl.item.discountPercentage / 100;
        $mdl.item.discountAmount = Math.round($mdl.item.discountAmount * 1000) / 1000;
        $mdl.item.discountAmount = Math.round($mdl.item.discountAmount * 100) / 100;
      }
			else
			{
        $mdl.item.discountAmount = null;
      }

      $mdl.recalculateTaxAndTotal();
    }

    $mdl.calculateDiscountAmount2 = function()
		{
      if($mdl.item.discountAmount!=null)
			{
        $mdl.item.discountPercentage = $mdl.item.discountAmount / ($mdl.item.unitPrice * $mdl.item.quantity) * 100;
        $mdl.item.discountPercentage = Math.round($mdl.item.discountPercentage * 1000) / 1000;
        $mdl.item.discountPercentage = Math.round($mdl.item.discountPercentage * 100) / 100;
      }
			else
			{
        $mdl.item.discountPercentage = null;
      }

      $mdl.recalculateTaxAndTotal();
    }

    $mdl.recalculateTaxAndTotal = function()
		{
      $mdl.item.tax = (($mdl.item.unitPrice * $mdl.item.quantity) - $mdl.item.discountAmount) * $mdl.item.taxPercent / 100;
      $mdl.item.tax = Math.round($mdl.item.tax * 1000) / 1000;
      $mdl.item.tax = Math.round($mdl.item.tax * 100) / 100;
      $mdl.item.subtotal =  (($mdl.item.unitPrice * $mdl.item.quantity) - $mdl.item.discountAmount) + $mdl.item.tax;
      $mdl.item.subtotal = Math.round($mdl.item.subtotal * 1000) / 1000;
      $mdl.item.subtotal = Math.round($mdl.item.subtotal * 100) / 100;
    }

    /* ********************************************************* */

    // Load Item List
    $mdl.loadItem = function(searchString)
		{
      if(searchString==null || searchString.trim()=="") return;

      $mdl.lockButtons = true;

      var keyword = encodeURIComponent(searchString);
      var params = {
        debtorId: $mdl.debtorId,
      }

        HttpSvc.post('searchengine/editsaleitem/' + keyword, params, Auth.getTokenId(), true)
				.then(function(result) {
          $mdl.itemList = result;

          if($mdl.isInit)
			{
            if($mdl.itemList.length>0)
			$mdl.selectedItem = $mdl.itemList[0];
            $mdl.isInit = false;
          }
          $mdl.selectedItemChanged();

          $mdl.lockButtons = false;
        }, function() {
          $mdl.lockButtons = false;
          toastr.error('Failed to retrieve search results.', '');
          return null;
        });
    };

    // Load Item List
    $mdl.searchItem = function(searchString)
		{
      if(searchString==null || searchString.trim()=="") return;

      $mdl.lockButtons = true;

      var keyword = encodeURIComponent(searchString);
      var params = {
        debtorId: $mdl.debtorId,
      }

        HttpSvc.post('searchengine/search/forsaleitems/' + keyword, params, Auth.getTokenId(), true)
				.then(function(result) {
          $mdl.itemList = result;

          if($mdl.isInit)
			{
            if($mdl.itemList.length>0)
			$mdl.selectedItem = $mdl.itemList[0];
            $mdl.isInit = false;
          }
          $mdl.selectedItemChanged();

          $mdl.lockButtons = false;
        }, function() {
          $mdl.lockButtons = false;
          toastr.error('Failed to retrieve search results.', '');
          return null;
        });
    };

    /* ********************************************************* */

    // Initialize
    if(item.mode==1) {
      $mdl.item.itemId = null;
      $mdl.item.productId = null;
      $mdl.item.semiFinishedProductId = null;
      $mdl.item.productCode = "";
      $mdl.item.productName = "";
      $mdl.item.itemType = "";
      $mdl.item.quantity = 1;
      $mdl.item.unitPrice = 0;
      $mdl.item.tax = 0;
      $mdl.item.taxPercent = 0;
      $mdl.item.taxCode = '';
      $mdl.item.discountAmount = null;
      $mdl.item.discountPercentage = null;
      $mdl.item.subtotal = 0;
    } else {
    //   $mdl.searchItem($mdl.item.productCode);
      $mdl.loadItem($mdl.item.productCode);
    }

    /* ********************************************************* */

    $mdl.confirmModal = function()
		{
      if(!$mdl.productForm.$valid)
			{
        toastr.error('Please fill up all the required fields.', Auth.translate('ERROR'));
      }
			else
			{
        $uibModalInstance.close($mdl.item);
      }
    };

    $mdl.cancelModal = function() {
      $uibModalInstance.dismiss('cancel');
    };
  };

  // Food Menu Product Modal
  function SOFoodMenuModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
    var $mdl = this;
    $mdl.foodmenus = [];
    $mdl.item = {};
    $mdl.item.menuId = "";
    $mdl.selectedMenu = null;
    $mdl.lockButtons = false;

    // Load Food Menu List
    $mdl.loadFoodMenus = function() {
      $mdl.lockButtons = true;

      HttpSvc.get('foodmenus/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
          $mdl.foodmenus = result;
          $mdl.lockButtons = false;
        }, function(error) {
          toastr.error(error, Auth.translate('ERROR'));
          $mdl.lockButtons = false;
          return;
        });
    };

    $mdl.selectedMenuChanged = function() {
      $mdl.item.menuId = $mdl.selectedMenu.id;
    };

    $mdl.confirmModal = function() {
      if($mdl.menuForm.$invalid) {
        toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
      } else {
        $uibModalInstance.close($mdl.item);
      }
    };

    $mdl.cancelModal = function() {
      $uibModalInstance.dismiss('cancel');
    };

    // *****************************

    $mdl.loadFoodMenus();
  };

  // Email Modal Controller
  function SalesOrderEmailModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
    var $mdl = this;
    $mdl.soId = item.soId;
    $mdl.template = {};
    $mdl.lockButtons = false;

    $mdl.initData = function() {
      HttpSvc.get('emailtemplates/salesorder/' + $mdl.soId, {}, Auth.getTokenId(), false)
				.then(function(result) {
          $mdl.template = result;
        }, function(error) {
          toastr.error(error, 'Failed');
          $mdl.cancelModal();
        });
    }

    $mdl.sendEmail = function() {
      HttpSvc.put('salesorders/email/' + $mdl.soId, $mdl.template, Auth.getTokenId(), false)
				.then(function(result) {
          toastr.success("Email sent successfully.", Auth.translate('SUCCESS'));
          $uibModalInstance.close($mdl.item);
        }, function(error) {
          toastr.error(error, 'Failed');
          $mdl.lockButtons = false;
});
        }

    $mdl.confirmModal = function() {
      var isValid = true;
      $mdl.lockButtons = true;
      $mdl.itemForm.$submitted = true;

      // Check TO
      if($mdl.template.to=="" || $mdl.template.to==null) {
        $mdl.itemForm.TO.$error.required = true;
        isValid = false;
      } else {
        $mdl.itemForm.TO.$error.required = false;
      }
      // Check Subject
      if($mdl.template.subject=="" || $mdl.template.subject==null) {
        $mdl.itemForm.Subject.$error.required = true;
        isValid = false;
      } else {
        $mdl.itemForm.Subject.$error.required = false;
      }
      // Check Content
      if($mdl.template.subject=="" || $mdl.template.subject==null) {
        $mdl.itemForm.Subject.$error.required = true;
        isValid = false;
      } else {
        $mdl.itemForm.Subject.$error.required = false;
      }

      if(isValid) {
        $mdl.sendEmail();
      } else {
        toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
        $mdl.lockButtons = false;
      }
    };

    $mdl.cancelModal = function() {
      $uibModalInstance.dismiss('cancel');
    };

    $mdl.initData();
  };

  /** @ngInject */
  function SODownloadExcelModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
    var $mdl = this;

    $mdl.batchList = [];
    $mdl.isLoading = false;
    $mdl.selectedBatchId = null;
    $mdl.batchId = null;

    // ********************************************************

    $mdl.loadData = function() {
      $mdl.isLoading = true;

      HttpSvc.get('salesorders/list/batchid', {}, Auth.getTokenId(), true)
				.then(function(result) {
          $mdl.batchList = result;
          $mdl.isLoading = false;
        }, function() {
          $mdl.isLoading = false;
          toastr.error('Failed to retrieve data.', '');
          return null;
        });
    };

    // ********************************************************

    $mdl.selectedBatchIdChanged = function() {
      $mdl.batchId = $mdl.selectedBatchId;
    }

    // ********************************************************

    $mdl.downloadExcel = function() {
      $mdl.isLoading = true;
      var filename = "RMS_SalesOrder_Batch_" + $filter('date')(new Date(), 'yyyyMMddhhmmss');

      HttpSvc.getExcelObject("salesorders/exportac", Auth.getTokenId(), filename)
				.then(function() {
          $mdl.isLoading = false;
          $mdl.loadData();
          //$uibModalInstance.dismiss('cancel');
        }, function(error) {
          $mdl.isLoading = false;
          toastr.error('No record found.', 'Failed to generate Excel');
          return null;
});
        }

    $mdl.downloadExcelPast = function() {
      if($mdl.selectedBatchId == null)
			{
        toastr.warning("Please select a Batch Number to download.");
        return;
      }

      $mdl.isLoading = true;

      var filename = "RMS_SalesOrder_" + $mdl.batchId;

      HttpSvc.getExcelObject("salesorders/reexportac/" + $mdl.batchId, Auth.getTokenId(), filename)
				.then(function() {
          $mdl.isLoading = false;
          //$uibModalInstance.dismiss('cancel');
        }, function(error) {
          $mdl.isLoading = false;
          toastr.error('No record found.', 'Failed to generate Excel');
          return null;
});
        }

    // ********************************************************

    // Cancel Action
    $mdl.cancelModal = function() {
      $uibModalInstance.dismiss('cancel');
    };

    // ********************************************************

    $mdl.loadData();
  };

  // (Autocount) Approve Credit Limit Modal
  function SOApproveCreditLimitModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
    var $mdl = this;
    $mdl.lockButtons = false;

    /* ********************************************************* */

    $mdl.confirmModal = function()
		{
      $mdl.lockButtons = true;
      $uibModalInstance.close();
    };

    $mdl.cancelModal = function() {
      $mdl.lockButtons = false;
      toastr.warning('Failed to confirm Sales Order due to Customer has exceeded Credit Limit.', Auth.translate('ERROR'))
      $uibModalInstance.dismiss('cancel');
    };
  };

  // (Autocount) Request for Credit Limit Approval Modal
  function SORequestCreditLimitApprovalModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
    var $mdl = this;
    $mdl.lockButtons = false;

    /* ********************************************************* */

    $mdl.confirmModal = function()
		{
      $mdl.lockButtons = true;
      $uibModalInstance.close();
    };

    $mdl.cancelModal = function() {
      $mdl.lockButtons = false;
      $uibModalInstance.dismiss('cancel');
    };
  };

  function checkProductExist(i, obj) {

		if((i.itemId==obj.itemId && i.itemId!="" && i.itemId!=null) ||
      (i.productId==obj.productId && i.productId!="" && i.productId!=null) ||
      (i.semiFinishedProductId==obj.semiFinishedProductId && i.semiFinishedProductId!="" && i.semiFinishedProductId!=null))
		{
      return true;
    }
    return false;
  }
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.signup')
        .controller('SignUpCtrl', SignUpCtrl);
		
    /** @ngInject */
    function SignUpCtrl($scope, $rootScope, $state, $stateParams, $filter, $q, Auth, HttpSvc, toastr) {	
		
		Auth.init();
		
		var vm = this;
		
		vm.categories = [
			{ id: 'f5660436-2bee-451e-a1ce-bd80d26d4d3e', name: 'LAINOX COMBI OVEN' },
			{ id: 'fa809a28-8b52-42fa-b9af-e48dd4d7989d', name: 'ROBOT COUPE' },
			{ id: '28ea0bee-5cba-45a1-9e27-26c7924a9d89', name: 'EKA (PASTRY)' },
			{ id: 'e93224fa-7277-4e3f-a6dd-f2988086287d', name: 'EKA (COMBI)' },
			{ id: 'a06d4967-a419-4699-b6ee-34b09eca94a8', name: 'BINGSU' },
			{ id: 'a37363ef-3dd1-4768-bca1-3f2673a6e4e0', name: 'DRINKS & BEVERAGES (KOREA)' },
			{ id: '21b36cb5-58aa-44fb-9a0b-08233245b25c', name: 'GELATO (CERRI)' },
			{ id: '47c561e6-ae39-4bd1-a987-0f9c2dda4e55', name: 'GELATO (MONTE BIANCO)' },
			{ id: '222c720b-2a53-4727-adc7-7756baad7f1d', name: 'GELATO STICK' },
			{ id: 'a8f1ba67-fea8-4e26-a292-8f4c8a54f1cd', name: 'KUIH MUIH' },
			{ id: '56709f3e-5182-48c1-9fa6-a29d1ecb4871', name: 'SOFT SERVE' },
			{ id: '2352676c-804a-4feb-8c85-67f0a1bf70b1', name: 'SORBET STICK' },
		]
		
		vm.signup = {};
		vm.signup.source = null;
		vm.signup.sourceChoice = "";
		vm.signup.recipeCategoryList = [];
		vm.selectedCategories = [];
		vm.lockButtons = false;
				
		vm.submit = function() {
			if(!confirm('Confirm all information is correct?')) {
				return;
			}
			
			vm.lockButtons = true;
			
			if(vm.signup.sourceChoice=="1") {
				vm.signup.source="FNB_CATALOGUE";
			} else if(vm.signup.sourceChoice=="2") {
				vm.signup.source="PD_WEBSITE";
			} else if(vm.signup.sourceChoice=="3") {
				vm.signup.source="SEARCH_ENGINE";
			} else if(vm.signup.sourceChoice=="4") {
				vm.signup.source="EXHIBITION";
			} else if(vm.signup.sourceChoice=="5") {
				vm.signup.source="FNB_EQ_SB";
			}
			
			vm.signup.recipeCategoryList = [];
			vm.selectedCategories.forEach(function(c) {
				vm.signup.recipeCategoryList.push(c.id);
			});
			
			if(vm.dataForm.$invalid) {
				vm.lockButtons = false;
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('subscriptions/signup', vm.signup, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Sign up successfully!", Auth.translate('SUCCESS'));
						vm.resetForm();
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, Auth.translate('ERROR'));
					});
			}
		}
		
		vm.resetForm = function() {			
			vm.signup = {};
			vm.signup.source = null;
			vm.signup.sourceChoice = "";
			vm.signup.recipeCategoryList = [];
			vm.selectedCategories = [];
			vm.lockButtons = false;
			vm.dataForm.$setPristine();
		}
    }
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.signupims.controller', [])
        .controller('SignUpIMSCtrl', SignUpIMSCtrl);
		
    /** @ngInject */
    function SignUpIMSCtrl($scope, $rootScope, $state, $stateParams, $filter, $q, Auth, HttpSvc, UtilSvc, toastr) {	
		
		Auth.init();
		
		var vm = this;

		vm.billingIntervalTypes = [
			{ id: 1, name: "MONTHLY" },
			{ id: 2, name: "QUARTERLY" },
			{ id: 3, name: "ANNUALLY" }
		]

		vm.gatewayRates = [
			{ id: 1, name: "RM100 / Unit / Month (Lease)", amount: 100.0 },
			//{ id: 2, name: "RM0 (One-Time)", amount: 0.0 },
		]

		vm.normalSensorRates = [
			{ id: 1, name: "RM60 / Unit / Month (Lease)", amount: 40.0 },
			//{ id: 2, name: "RM15 (One-Time)", amount: 15.0 },
		]

		vm.specialSensorRates = [
			{ id: 1, name: "RM60 / Unit / Month (Lease)", amount: 60.0 },
			//{ id: 2, name: "RM15 (One-Time)", amount: 15.0 },
		]

		vm.signup = {};
		vm.lockButtons = false;

		vm.initData = function() {
			vm.signup.country = "MALAYSIA";
			vm.signup.source = "SALESREP";
			vm.signup.isPOC = false;
			vm.signup.billingIntervalType = 1;
			vm.selectedBillingIntervalType = null;
			vm.selectedGatewayRate = vm.gatewayRates[0];
			vm.selectedNormalSensorRate = vm.normalSensorRates[0];
			vm.selectedSpecialSensorRate = vm.specialSensorRates[0];

			vm.selectedGatewayRateChanged();
			vm.selectedNormalSensorRateChanged();
			vm.selectedSpecialSensorRateChanged();
		}
				
		/* ********************************************************************************** */

		vm.selectedBillingIntervalTypeChanged = function() 
		{
			vm.signup.billingIntervalType = vm.selectedBillingIntervalType.id;
		}

		vm.selectedGatewayRateChanged = function() 
		{
			vm.signup.gatewayRate = vm.selectedGatewayRate.amount;
		}

		vm.selectedNormalSensorRateChanged = function() 
		{
			vm.signup.normalSensorRate = vm.selectedNormalSensorRate.amount;
		}

		vm.selectedSpecialSensorRateChanged = function() 
		{
			vm.signup.specialSensorRate = vm.selectedSpecialSensorRate.amount;
		}

		/* ********************************************************************************** */
		
		vm.submit = function() {
			if(!confirm('Confirm all information is correct?')) {
				return;
			}
			
			vm.lockButtons = true;
			
			if(vm.dataForm.$invalid) {
				vm.lockButtons = false;
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			} else {
				HttpSvc.post('subscriptions/imssignup', vm.signup, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("New IMS Account created successfully!", Auth.translate('SUCCESS'));
						vm.resetForm();
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, Auth.translate('ERROR'));
					});
			}
		}
		
		vm.resetForm = function() {
			vm.signup = {};
			vm.signup.country = "MALAYSIA";
			vm.signup.source = "SALESREP";
			vm.signup.billingIntervalType = 1;
			vm.selectedBillingIntervalType = vm.billingIntervalTypes[0];
			vm.lockButtons = false;
			vm.dataForm.$setPristine();
		}

		// Call Action
		vm.initData();
    }
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.signupimsassign.controller', [])
        .controller('SignUpIMSAssignCtrl', SignUpIMSAssignCtrl);
		
    /** @ngInject */
    function SignUpIMSAssignCtrl($scope, $rootScope, $state, $stateParams, $filter, $q, Auth, HttpSvc, toastr) {	
		
		Auth.init();
		
		var vm = this;
		vm.uniqueCode = "";
		vm.deviceUID = "";
		vm.deviceList = [];
		vm.company = null;
		vm.selectedDevice = null;
		vm.isCompanyFound = false;
		vm.isDeviceFound = false;
		vm.lockButtons = false;

		/* ********************************************************************************** */

		vm.checkCompany = function() 
		{
			vm.lockButtons = true;

			HttpSvc.get('companies/byuniquecode/' + vm.uniqueCode, {}, Auth.getTokenId(), false)
					.then(function(result) {
						vm.company = result;
						vm.isCompanyFound = true;
						vm.lockButtons = false;
						toastr.success("Client company found successfully!", Auth.translate('SUCCESS'));
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, Auth.translate('ERROR'));
					});
		}

		vm.checkDeviceUID = function() 
		{
			vm.lockButtons = true;

			HttpSvc.get('iotregistereddevices/list/unassigned/' + vm.deviceUID, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.deviceList = result;
						vm.isDeviceFound = true;
						vm.lockButtons = false;
						toastr.success("List of Device(s) found successfully!", Auth.translate('SUCCESS'));
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, Auth.translate('ERROR'));
					});
		}

		vm.selectDevice = function() 
		{
			if(vm.selectedDevice==null)
			{
				toastr.error('Please select a Device first.', Auth.translate('ERROR'));
				return;
			}

			vm.lockButtons = true;

			var assignment = {};
			assignment.companyId = vm.company.id;
			assignment.deviceId = vm.selectedDevice.id;
			
			HttpSvc.post('iotregistereddevices/assigndevice', assignment, Auth.getTokenId(), false)
				.then(function(result) {
					vm.lockButtons = false;
					toastr.success("Assignment is successful!", Auth.translate('SUCCESS'));
					vm.clearDevice();
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, Auth.translate('ERROR'));
				});
		}

		vm.clearDevice = function() 
		{
			vm.deviceUID = ""
			vm.deviceList = [];
			vm.selectedDevice = null;
			vm.isDeviceFound = false;
		}

		vm.resetCompany = function() 
		{
			vm.uniqueCode = "";
			vm.deviceUID = "";
			vm.deviceList = [];
			vm.company = null;
			vm.selectedDevice = null;
			vm.isCompanyFound = false;
			vm.isDeviceFound = false;
			vm.lockButtons = false;
		}

		/* ********************************************************************************** */
		
		vm.submit = function() {
			if(!confirm('Confirm all information is correct?')) {
				return;
			}
			
			vm.lockButtons = true;
			
			if(vm.dataForm.$invalid) {
				vm.lockButtons = false;
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			} else {
				HttpSvc.post('subscriptions/imssignup', vm.signup, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("New IMS Account created successfully!", Auth.translate('SUCCESS'));
						vm.resetForm();
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, Auth.translate('ERROR'));
					});
			}
		}
		
		vm.resetForm = function() {			
			vm.lockButtons = false;
			vm.dataForm.$setPristine();
		}
    }
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.signuprms.controller', [])
        .controller('SignUpRMSCtrl', SignUpRMSCtrl);
		
    /** @ngInject */
    function SignUpRMSCtrl($scope, $rootScope, $state, $stateParams, $filter, $q, Auth, HttpSvc, UtilSvc, toastr) {	
		
		Auth.init();
		
		var vm = this;

		vm.billingIntervalTypes = GetBillingIntervalTypes();
		vm.rmsTypes = GetRmsTypes();

		vm.signup = {};
		vm.ims = {};
		vm.lockButtons = false;
				
		/* ********************************************************************************** */

		vm.gatewayRates = [
			{ id: 1, name: "RM 100 / Unit / Month", amount: 100.0 },
			//{ id: 2, name: "N/A", amount: 0.0 },
		]

		vm.normalSensorRates = [
			{ id: 1, name: "RM 60 / Unit / Month", amount: 60.0 },
			//{ id: 2, name: "RM 25 / Unit / Month", amount: 25.0 },
		]
				
		/* ********************************************************************************** */

		vm.initData = function() {
			vm.signup.isBillable = true;
			vm.signup.country = "MALAYSIA";
			vm.signup.source = "SALESREP";
			vm.signup.billingIntervalType = 1;
			vm.signup.billingPackageFees = [];
			vm.signup.totalStdUserQty = 0;
			vm.signup.totalLtdUserQty = 0;
			vm.extraStdUserCount = 0;
			vm.extraLtdUserCount = 0;
			vm.entitledFeeDiscount = true;

			vm.selectedRmsType = null;
			vm.selectedBillingIntervalType = null;
			
			vm.hasIMS = false;
			vm.ims.hasSimCard = false;
			vm.ims.hasFloorView = false;
			vm.selectedGatewayRate = null;
			vm.selectedSensorRate = null;
			vm.ims.numOfSimCard = 0;
			vm.ims.numOfGateway = 0;
			vm.ims.numOfSensor = 0;
			vm.ims.gatewayRate = 0;
			vm.ims.sensorRate = 0;
			vm.ims.simCardRate = 25;
			vm.ims.floorViewRate = 200;
		}
				
		/* ********************************************************************************** */

		vm.selectedRmsTypeChanged = function() 
		{
			vm.signup.packageMode = vm.selectedRmsType.id;
		}

		vm.selectedBillingIntervalTypeChanged = function() 
		{
			vm.signup.billingIntervalType = vm.selectedBillingIntervalType.id;
		}

		vm.selectedGatewayRateChanged = function() 
		{
			vm.ims.gatewayRate = vm.selectedGatewayRate.amount;
		}

		vm.selectedSensorRateChanged = function() 
		{
			vm.ims.sensorRate = vm.selectedSensorRate.amount;
		}

		/* ********************************************************************************** */
		
		vm.calcPackageFees = function() {
			vm.signup.totalStdUserQty = vm.extraStdUserCount + vm.selectedRmsType.stdUserQty;
			vm.signup.totalLtdUserQty = vm.extraLtdUserCount;

			vm.signup.billingPackageFees = [];

			vm.signup.billingPackageFees.push({
				moduleType: vm.selectedRmsType.moduleType,
				monthlyFee: vm.selectedRmsType.baseFees,
				hasDiscount: vm.entitledFeeDiscount,
				remarks: 'Base Subscription Fees (' + vm.selectedRmsType.name + ')'
			});
			
			if(vm.extraStdUserCount > 0 || vm.extraLtdUserCount > 0)
			{
				var extraStdUserFees = vm.extraStdUserCount * vm.selectedRmsType.extraStdUserFee;
				var extraLtdUserFees = vm.extraLtdUserCount * 80;

				vm.signup.billingPackageFees.push(
					{
						moduleType: vm.selectedRmsType.moduleType,
						monthlyFee: extraStdUserFees + extraLtdUserFees,
						hasDiscount: vm.entitledFeeDiscount,
						remarks: 
							'Extra Fees (' + 
							(vm.extraStdUserCount > 0 ? vm.extraStdUserCount + ' x Std User' : '') + 
							(vm.extraStdUserCount > 0 && vm.extraLtdUserCount > 0 ? ', ' : '') +
							(vm.extraLtdUserCount > 0 ? vm.extraLtdUserCount + ' x Ltd User' : '') +
							')'
					});				
			}

			if(vm.hasIMS)
			{
				var totalFees = 0;
				var remarks = "";

				if(vm.ims.hasFloorView)
				{
					totalFees += vm.ims.floorViewRate;
					remarks = "FloorView + ";
				}
				
				if(vm.ims.numOfGateway > 0)
				{
					totalFees += (vm.ims.numOfGateway * vm.ims.gatewayRate);
					remarks += vm.ims.numOfGateway + "xGW + ";
				}
				
				if(vm.ims.numOfSensor > 0)
				{
					totalFees += (vm.ims.numOfSensor * vm.ims.sensorRate);
					remarks += vm.ims.numOfSensor + "xSS";
				}

				vm.signup.billingPackageFees.push(
					{
						moduleType: "IMS",
						monthlyFee: totalFees,
						hasDiscount: vm.entitledFeeDiscount,
						remarks: remarks
					});		

				if(vm.ims.hasSimCard)
				{
					totalFees = (vm.ims.numOfSimCard * vm.ims.simCardRate);

					vm.signup.billingPackageFees.push(
						{
							moduleType: "SIM",
							monthlyFee: totalFees,
							hasDiscount: false,
							remarks: vm.ims.numOfSimCard + "xSIM"
						});						
				}
			}
		}

		/* ********************************************************************************** */

		vm.submit = function() {
			if(!confirm('Confirm all information is correct?')) {
				return;
			}			
			if(vm.dataForm.$invalid) {

				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));

			} else {
			
				vm.lockButtons = true;
				vm.calcPackageFees();

				HttpSvc.post('subscriptions/rmssignup', vm.signup, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("New " + vm.selectedRmsType.name + " Account created successfully!", Auth.translate('SUCCESS'));
						vm.resetForm();
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, Auth.translate('ERROR'));
					});
			}
		}
		
		vm.resetForm = function() {
			vm.signup = {};
			vm.initData();
			
			vm.lockButtons = false;
			vm.dataForm.$setPristine();
		}

		/* ********************************************************************************** */

		// Call Action
		vm.initData();
    }
	
	function GetBillingIntervalTypes() {
		var types = [
			{ id: 1, name: "MONTHLY" },
			{ id: 2, name: "QUARTERLY" },
			{ id: 3, name: "ANNUALLY" }
		];

		return types;
	}

	function GetRmsTypes() {
		var types = [
			// {
			// 	id: 'RMS_STARTER',
			// 	name: 'RMS Starter',
			// 	moduleType: 'RMS-S',
			// 	stdUserQty: 1,
			// 	baseFees: 150,
			// 	extraStdUserFee: 150,
			// },
			// {
			// 	id: 'RMS_LITE',
			// 	name: 'RMS Lite',
			// 	moduleType: 'RMS-L',
			// 	stdUserQty: 3,
			// 	baseFees: 500,
			// 	extraStdUserFee: 170,
			// },
			{
				id: 'RMS_FULL',
				name: 'RMS Full',
				moduleType: 'RMS',
				stdUserQty: 5,
				baseFees: 2200,
				extraStdUserFee: 440,
			},
		];

		return types;
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.signuprmsdealer.controller', [])
        .controller('SignUpRMSDealerCtrl', SignUpRMSDealerCtrl);
		
    /** @ngInject */
    function SignUpRMSDealerCtrl($scope, $rootScope, $state, $stateParams, $filter, $q, Auth, HttpSvc, UtilSvc, toastr) {	
		
		Auth.init();
		
		var vm = this;

		vm.billingIntervalTypes = GetBillingIntervalTypes();
		vm.rmsTypes = GetRmsTypes();

		vm.signup = {};
		vm.ims = {};
		vm.lockButtons = false;
				
		/* ********************************************************************************** */

		vm.gatewayRates = [
			{ id: 1, name: "RM 100 / Unit / Month", amount: 100.0 },
			{ id: 2, name: "N/A", amount: 0.0 },
		]

		vm.normalSensorRates = [
			{ id: 1, name: "RM 60 / Unit / Month", amount: 60.0 },
			{ id: 2, name: "RM 25 / Unit / Month", amount: 25.0 },
		]
				
		/* ********************************************************************************** */

		vm.initData = function() {
			vm.signup.isBillable = true;
			vm.signup.country = "MALAYSIA";
			vm.signup.source = "AFFILIATE";
			vm.signup.billingIntervalType = 1;
			vm.signup.billingPackageFees = [];
			vm.signup.totalStdUserQty = 0;
			vm.signup.totalLtdUserQty = 0;
			vm.signup.contractStartDate = $filter('date')(new Date(), 'yyyy-MM-dd')
			vm.extraStdUserCount = 0;
			vm.extraLtdUserCount = 0;
			vm.entitledFeeDiscount = true;

			vm.selectedRmsType = null;
			vm.selectedBillingIntervalType = null;
			
			vm.hasIMS = false;
			vm.ims.hasSimCard = false;
			vm.ims.hasFloorView = false;
			vm.selectedGatewayRate = null;
			vm.selectedSensorRate = null;
			vm.ims.numOfSimCard = 0;
			vm.ims.numOfGateway = 0;
			vm.ims.numOfSensor = 0;
			vm.ims.gatewayRate = 0;
			vm.ims.sensorRate = 0;
			vm.ims.simCardRate = 25;
			vm.ims.floorViewRate = 200;
		}
				
		/* ********************************************************************************** */

		vm.selectedRmsTypeChanged = function() 
		{
			vm.signup.packageMode = vm.selectedRmsType.id;
		}

		vm.selectedBillingIntervalTypeChanged = function() 
		{
			vm.signup.billingIntervalType = vm.selectedBillingIntervalType.id;
		}

		vm.selectedGatewayRateChanged = function() 
		{
			vm.ims.gatewayRate = vm.selectedGatewayRate.amount;
		}

		vm.selectedSensorRateChanged = function() 
		{
			vm.ims.sensorRate = vm.selectedSensorRate.amount;
		}

		/* ********************************************************************************** */
		
		vm.calcPackageFees = function() {
			vm.signup.totalStdUserQty = vm.extraStdUserCount + vm.selectedRmsType.stdUserQty;
			vm.signup.totalLtdUserQty = vm.extraLtdUserCount;

			vm.signup.billingPackageFees = [];

			vm.signup.billingPackageFees.push({
				moduleType: vm.selectedRmsType.moduleType,
				monthlyFee: vm.selectedRmsType.baseFees,
				hasDiscount: vm.entitledFeeDiscount,
				remarks: 'Base Subscription Fees (' + vm.selectedRmsType.name + ')'
			});
			
			if(vm.extraStdUserCount > 0 || vm.extraLtdUserCount > 0)
			{
				var extraStdUserFees = vm.extraStdUserCount * vm.selectedRmsType.extraStdUserFee;
				var extraLtdUserFees = vm.extraLtdUserCount * 50;

				vm.signup.billingPackageFees.push(
					{
						moduleType: vm.selectedRmsType.moduleType,
						monthlyFee: extraStdUserFees + extraLtdUserFees,
						hasDiscount: vm.entitledFeeDiscount,
						remarks: 
							'Extra Fees (' + 
							(vm.extraStdUserCount > 0 ? vm.extraStdUserCount + ' x Std User' : '') + 
							(vm.extraStdUserCount > 0 && vm.extraLtdUserCount > 0 ? ', ' : '') +
							(vm.extraLtdUserCount > 0 ? vm.extraLtdUserCount + ' x Ltd User' : '') +
							')'
					});				
			}

			if(vm.hasIMS)
			{
				var totalFees = 0;
				var remarks = "";

				if(vm.ims.hasFloorView)
				{
					totalFees += vm.ims.floorViewRate;
					remarks = "FloorView + ";
				}
				
				if(vm.ims.numOfGateway > 0)
				{
					totalFees += (vm.ims.numOfGateway * vm.ims.gatewayRate);
					remarks += vm.ims.numOfGateway + "xGW + ";
				}
				
				if(vm.ims.numOfSensor > 0)
				{
					totalFees += (vm.ims.numOfSensor * vm.ims.sensorRate);
					remarks += vm.ims.numOfSensor + "xSS";
				}

				vm.signup.billingPackageFees.push(
					{
						moduleType: "IMS",
						monthlyFee: totalFees,
						hasDiscount: vm.entitledFeeDiscount,
						remarks: remarks
					});		

				if(vm.ims.hasSimCard)
				{
					totalFees = (vm.ims.numOfSimCard * vm.ims.simCardRate);

					vm.signup.billingPackageFees.push(
						{
							moduleType: "SIM",
							monthlyFee: totalFees,
							hasDiscount: false,
							remarks: vm.ims.numOfSimCard + "xSIM"
						});						
				}
			}
		}

		/* ********************************************************************************** */

		vm.submit = function() {
			if(!confirm('Confirm all information is correct?')) {
				return;
			}			
			if(vm.dataForm.$invalid) {

				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));

			} else {
			
				vm.lockButtons = true;
				vm.calcPackageFees();

				HttpSvc.post('subscriptions/rmssignup/byaffiliate', vm.signup, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("New " + vm.selectedRmsType.name + " Account created successfully!", Auth.translate('SUCCESS'));
						vm.resetForm();
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, Auth.translate('ERROR'));
					});
			}
		}
		
		vm.resetForm = function() {
			vm.signup = {};
			vm.initData();
			
			vm.lockButtons = false;
			vm.dataForm.$setPristine();
		}

		/* ********************************************************************************** */

		// Call Action
		vm.initData();
    }
	
	function GetBillingIntervalTypes() {
		var types = [
			{ id: 1, name: "MONTHLY" },
			{ id: 2, name: "QUARTERLY" },
			{ id: 3, name: "ANNUALLY" }
		];

		return types;
	}

	function GetRmsTypes() {
		var types = [
			{
				id: 'RMS_STARTER',
				name: 'RMS Starter',
				moduleType: 'RMS-S',
				stdUserQty: 1,
				baseFees: 150,
				extraStdUserFee: 150,
				billingIntervalTypes: [
					{ id: 3, name: "ANNUALLY", discount: 10 }
				]
			},
			{
				id: 'RMS_LITE',
				name: 'RMS Lite',
				moduleType: 'RMS-L',
				stdUserQty: 3,
				baseFees: 500,
				extraStdUserFee: 170,
				billingIntervalTypes: [
					{ id: 1, name: "MONTHLY", discount: 0 },
					{ id: 2, name: "QUARTERLY", discount: 5 },
					{ id: 3, name: "ANNUALLY", discount: 10 }
				]
			},
			{
				id: 'RMS_FULL',
				name: 'RMS Full',
				moduleType: 'RMS',
				stdUserQty: 10,
				baseFees: 3600,
				extraStdUserFee: 360,
				billingIntervalTypes: [
					{ id: 1, name: "MONTHLY", discount: 0 },
					{ id: 2, name: "QUARTERLY", discount: 5 },
					{ id: 3, name: "ANNUALLY", discount: 10 }
				]
			},
		];

		return types;
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.subscribe.controller', [])
        .controller('SubscribeMainCtrl', SubscribeMainCtrl)
        .controller('CategoryModalCtrl', CategoryModalCtrl)
        .controller('EmptyCategoryModalCtrl', EmptyCategoryModalCtrl);

	/** @ngInject */
    function SubscribeMainCtrl($scope, $state, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.submitted = false;
		vm.emptyCateOk = false;
		
		// Init Data
		vm.initData = function() {			
			vm.subs = {};
			vm.subs.serverPackageId = '';
			vm.subs.address1 = '';
			vm.subs.address2 = '';
			vm.subs.address3 = '';
			vm.subs.postCode = '';
			vm.subs.state = '';
			vm.subs.country = '';
			vm.subs.tel = '';
			vm.subs.fax = '';
			vm.subs.recipeCategoryList = [];
			vm.subs.companyRecipeCategories = [];
			vm.categoryList = [];
			vm.serverPackages = [];
			
			vm.loadCategoryList();
		};
		
		// Load Category List
		vm.loadCategoryList = function() {
			HttpSvc.get('recipecategories/list/all', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.categoryList = result;
					vm.loadServerPackages();					
				}, function() {
					return;
				});		
		}
				
		// Load Server Packages
		vm.loadServerPackages = function() {
			HttpSvc.get('serverpackages/list/subscribe', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.serverPackages = result;					
				}, function() {
					return;
				});
		}
		
		// Select Server Package
		vm.selectServerPackage = function(item) {
			vm.serverPackages.selected = item;
			vm.subs.serverPackageId = item.id;
		};		
		
		// **********************************************
		
		// Remove Category
		vm.removeCategory = function(index) {
			vm.subs.companyRecipeCategories.splice(index, 1);
			$scope.$broadcast('refreshStTable');	
		};

		// Add Category
		vm.addCategory = function(obj) {
			var element = {
				recipeCategoryId: obj.id,
				recipeCategory: {
					name: obj.name,
					companyName: obj.companyName
				},
				isReadOnly: true,
				isOriginalOwner: false
			};
			vm.subs.companyRecipeCategories.push(element);
		};

		// Refresh Category List
		vm.refreshRecipeCategories = function(tableState) {
			// Do nothing
		};	
		
		/* ************************************************************** */
		
		// Open Modal Dialog
		vm.recipeCategory = {};		
		vm.showAddCategoryModal = function () {
			vm.recipeCategory = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'categoryModal.html',
				controller: 'CategoryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.recipeCategory,
							itemList: vm.categoryList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addCategory(data);
				}, function () {
				});
		};	
		
		/* ************************************************************** */
		
		// Open Modal Dialog
		vm.showEmptyCategoryModal = function () {
			
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'emptyCategoryModal.html',
				controller: 'EmptyCategoryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.emptyCateOk = true;
					vm.submit();
				}, function () {
				});
		};	
		
		// **********************************************		
		
		// Form Submission
		vm.submit = function() {
			if(vm.subs.serverPackageId=='') {
				vm.dataForm.$invalid = true;
			}
			
			vm.subs.recipeCategoryList = [];
			vm.subs.companyRecipeCategories.forEach( function(c) {
				vm.subs.recipeCategoryList.push(c.recipeCategoryId);
			});
			
			if(vm.subs.recipeCategoryList.length<=0 && !vm.emptyCateOk) {
				vm.showEmptyCategoryModal();
				return;
			}
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {											  
				HttpSvc.post('subscriptions/register', vm.subs, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('New Subscription has been submitted successfully.', Auth.translate('SUCCESS'));
						vm.initData();						
						vm.dataForm.$setPristine();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.initData();
	};

	// Category Modal Controller
	function CategoryModalCtrl($uibModalInstance, item) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.itemList = item.itemList;
		$mdl.item = item.object;
		$mdl.selectedItem = {};
		
		// Initialize
		if(item.mode==1) {
			$mdl.item.id = "";
			$mdl.item.name = "";
		} else {
			if($mdl.item.id!='' && $mdl.item.id!=null){
				$mdl.itemList.forEach(function (i) {
					if(i.id==$mdl.item.id) {
						$mdl.selectedItem = i;
						$mdl.item.name = i.name;
						$mdl.item.companyName = i.companyName;
					}
				});
			}
		}
		
		$mdl.onSelectedItemChanged = function() {
			$mdl.item.id = $mdl.selectedItem.id;
			$mdl.item.name = $mdl.selectedItem.name;
			$mdl.item.companyName = $mdl.selectedItem.companyName;
			
			if($mdl.item.id=="")
				$mdl.categoryForm.$invalid = true;
			else
				$mdl.categoryForm.$invalid = false;
		}	
		
		$mdl.confirmModal = function() {			
			if($mdl.item.id=="" || $mdl.item.id==null) {
				$mdl.categoryForm.$invalid = true;
			} else {
				$mdl.categoryForm.$invalid = false;				
			}
			
			if($mdl.categoryForm.$valid)
				$uibModalInstance.close($mdl.item);
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};		

	// Empty Category Modal Controller
	function EmptyCategoryModalCtrl($uibModalInstance) {
		var $mdl = this;
		
		$mdl.confirmModal = function() {			
			$uibModalInstance.close($mdl.item);
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};		
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.wastagereports.controller', [])
        .controller('WastageReportMainCtrl', WastageReportMainCtrl)
        .controller('WastageReportCreateCtrl', WastageReportCreateCtrl)
        .controller('WastageReportUpdateCtrl', WastageReportUpdateCtrl)
        .controller('WastageReportPopupModalCtrl', WastageReportPopupModalCtrl)
        .controller('WastageReportPictureModalCtrl', WastageReportPictureModalCtrl);

    /** @ngInject */
    function WastageReportMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.statusList = [
			{id: 'NEW', name: 'NEW'},
			{id: 'CONFIRMED', name: 'CONFIRMED'},
			{id: 'APPROVED',  name: 'APPROVED'},
			{id: 'CANCELLED', name: 'CANCELLED'},
		];

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.dataFull = [];
		vm.data = [];
		vm.isLoading = false;

		vm.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.docNo,
				branchName: predicate.branchName,
				createdBy: predicate.createdBy,
				status: predicate.status,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('wastagereports/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			return tableState;
		};

		vm.resetSearch = function()
		{
		}

		vm.printWR = function(wrId, wrNo) {

			var filename = "WR_" + wrNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('wastagereports/print/' + wrId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate Wastage Report Form. ' + error, '');
							return null;
						});
		}
	};

	/** @ngInject */
    function WastageReportCreateCtrl($scope, $state, $filter, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;

		vm.isRmsLite = Auth.isLiteMode();
		vm.isSimpleStockIn = Auth.getSetting_isStockInSimpleMode();

		vm.wrStatuses = [
			{id: 'NEW', name: 'NEW'},
			{id: 'CONFIRMED', name: 'CONFIRMED'},
		];

		vm.mode = 1;
		vm.originalStatus = 'NEW';

		vm.wr = {};
		vm.wr.wastageReportItems = [];
		vm.selectedStatus = null;
		vm.lockButtons = false;
		vm.isLoading = false;

		/* ************************************************************ */

		// Set Default Job Date
		vm.setDefault = function() {
			vm.wrStatuses.selected = {id: 'NEW', name: 'NEW'};
			vm.wr.docDate = $filter('date')(new Date(), 'yyyy-MM-dd');
			vm.wr.status = "NEW";
			vm.wr.remarks = "";
			vm.lockButtons = false;
		};

		// Select Status
		vm.selectedStatusChanged = function() {
			vm.wr.status = vm.selectedStatus.id;
		};

		/* ************************************************************ */

		// Update Entity
		vm.updateEntity = function(index, obj) {
			var element = {
				serialNo: obj.serialNo,
				itemId: obj.itemId,
				semiFinishedProductId: obj.semiFinishedProductId,
				productId: obj.productId,
				code: obj.code,
				description: obj.description,
				quantity: obj.quantity,
				quantity2: obj.quantity2,
				uomName: obj.uomName,
				uomName2: obj.uomName2,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurementId2: obj.unitOfMeasurementId2,
				remarks: obj.remarks,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
			};
			vm.wr.wastageReportItems.splice(index, 1, element);
		};

		// Add Entity
		vm.addEntity = function(obj) {

			var isFound = false;

			vm.wr.wastageReportItems.forEach(function(w) {

				if(!vm.isSimpleStockIn && w.serialNo==obj.serialNo) {
					isFound = true;
					toastr.warning('Serial Number [' + obj.serialNo + '] already exists in the list.');
					return;
				}
			});

			if(isFound==false){
				var element = {
					serialNo: obj.serialNo,
					itemId: obj.itemId,
					semiFinishedProductId: obj.semiFinishedProductId,
					productId: obj.productId,
					code: obj.code,
					description: obj.description,
					quantity: obj.quantity,
					quantity2: obj.quantity2,
					uomName: obj.uomName,
					uomName2: obj.uomName2,
					unitOfMeasurementId: obj.unitOfMeasurementId,
					unitOfMeasurementId2: obj.unitOfMeasurementId2,
					remarks: obj.remarks,
					createdBy: obj.createdBy,
					createdDate: obj.createdDate,
				};

				vm.wr.wastageReportItems.push(element);
			}
		};

		vm.removeEntity = function(item) {
			if(confirm('Confirm remove this item?')) {
				var index = vm.wr.wastageReportItems.indexOf(item);
				vm.wr.wastageReportItems.splice(index, 1);
			}
		}

		/* ************************************************************ */

		// Open Modal Dialog
		vm.showAddEntityModal = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'popupModal.html',
				controller: 'WastageReportPopupModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "Add",
							object: {},
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addEntity(data);
				}, function () {
				});
		};

		vm.showEditEntityModal = function (index) {
			vm.entity = angular.copy(vm.wr.wastageReportItems[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'popupModal.html',
				controller: 'WastageReportPopupModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.entity,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateEntity(index, data);
				}, function () {
				});
		};

		/* ************************************************************ */

		// Form Submission
		vm.submit = function() {

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('wastagereports', vm.wr, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Wastage Report created successfully.', Auth.translate('SUCCESS'));
						$state.go('wastagereports.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Actions
		vm.setDefault();
	}

	/** @ngInject */
    function WastageReportUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, RmsApi, toastr) {

		Auth.init();

		var vm = this;

		vm.isRmsLite = Auth.isLiteMode();
		vm.isSimpleStockIn = Auth.getSetting_isStockInSimpleMode();

		vm.wrStatuses = [
			{id: 'NEW', name: 'NEW'},
			{id: 'CONFIRMED', name: 'CONFIRMED'},
		];

		vm.mode = 2;
		vm.originalStatus = 'NEW';

		vm.wr = {};
		vm.wr.wastageReportItems = [];
		vm.selectedStatus = null;
		vm.lockButtons = false;
		vm.isLoading = false;
		vm.isProcessing = false;

        vm.rootUrl = (Auth.getServerMode() == 1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);

		/* ************************************************************ */

		// Set Default Job Date
		vm.setDefault = function() {
			vm.wrStatuses.selected = {id: 'NEW', name: 'NEW'};
			vm.wr.docDate = $filter('date')(new Date(), 'yyyy-MM-dd');
			vm.wr.status = "NEW";
			vm.wr.remarks = "";
			vm.lockButtons = false;
		};

		// Select Status
		vm.selectedStatusChanged = function() {
			vm.wr.status = vm.selectedStatus.id;
		};

		/* ************************************************************ */

		vm.loadStorages = function(docType) {

			var type = "1";
			if(docType=="RM")
			{
				type = "1";
			}
			else if(docType=="FG")
			{
				type = "2";
			}
			else if(docType=="SFG")
			{
				type = "3";
			}

			HttpSvc.get('storages/listbytypes/' + type, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageList = result;

					if(vm.mode==2){
						vm.storageList.forEach(function(s) {
							if(s.id==vm.wr.storageId)
							{
								vm.selectedStorage=s;
							}
						});
					}
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Storage list.', '');
					return null;
				});
		}

		/* ************************************************************ */

		// Update Entity
		vm.updateEntity = function(index, obj) {
			var element = {
				serialNo: obj.serialNo,
				itemId: obj.itemId,
				semiFinishedProductId: obj.semiFinishedProductId,
				productId: obj.productId,
				code: obj.code,
				description: obj.description,
				quantity: obj.quantity,
				quantity2: obj.quantity2,
				uomName: obj.uomName,
				uomName2: obj.uomName2,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurementId2: obj.unitOfMeasurementId2,
				remarks: obj.remarks,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
			};
			vm.wr.wastageReportItems.splice(index, 1, element);
		};

		// Add Entity
		vm.addEntity = function(obj) {

			var isFound = false;

			vm.wr.wastageReportItems.forEach(function(w) {

				if(!vm.isSimpleStockIn && w.serialNo==obj.serialNo) {
					isFound = true;
					toastr.warning('Serial Number [' + obj.serialNo + '] already exists in the list.');
					return;
				}
			});

			if(isFound==false){
				var element = {
					serialNo: obj.serialNo,
					itemId: obj.itemId,
					semiFinishedProductId: obj.semiFinishedProductId,
					productId: obj.productId,
					code: obj.code,
					description: obj.description,
					quantity: obj.quantity,
					quantity2: obj.quantity2,
					uomName: obj.uomName,
					uomName2: obj.uomName2,
					unitOfMeasurementId: obj.unitOfMeasurementId,
					unitOfMeasurementId2: obj.unitOfMeasurementId2,
					remarks: obj.remarks,
					createdBy: obj.createdBy,
					createdDate: obj.createdDate,
				};

				vm.wr.wastageReportItems.push(element);
			}
		};

		vm.removeEntity = function(item) {
			if(confirm('Confirm remove this item?')) {
				var index = vm.wr.wastageReportItems.indexOf(item);
				vm.wr.wastageReportItems.splice(index, 1);
			}
		}

		/* ************************************************************ */

		// Open Modal Dialog
		vm.showAddEntityModal = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'popupModal.html',
				controller: 'WastageReportPopupModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "Add",
							object: {},
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addEntity(data);
				}, function () {
				});
		};

		vm.showEditEntityModal = function (index) {
			vm.entity = angular.copy(vm.wr.wastageReportItems[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'popupModal.html',
				controller: 'WastageReportPopupModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.entity,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateEntity(index, data);
				}, function () {
				});
		};

        vm.showPictureModal = function (itemCode, itemName, photoAttachment) {

            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'photoModal.html',
                controller: 'WastageReportPictureModalCtrl',
                controllerAs: '$mdl',
                size: 'md',
                resolve: {
					item: function () {
						return {
							itemCode: itemCode,
							itemName: itemName,
							photoAttachment: photoAttachment,
						}
					}
				}
            });

            modalInstance.result.then(function (data) {
            }, function () {
            });
        };

		/* ************************************************************ */

		vm.approveWR = function() {
			vm.lockButtons = true;
			vm.isProcessing = true;

			HttpSvc.put('wastagereports/approve/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Wastage Report has been approved successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
					vm.isProcessing = false;
				});
		};

		vm.cancelWR = function() {
			vm.lockButtons = true;

			HttpSvc.put('wastagereports/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Wastage Report has been cancelled.');
					$state.go('wastagereports.list');
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		};

		/* ************************************************************** */

		// Load Wastage Report
		vm.loadWR = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('wastagereports/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.wr = result;
					vm.wr.docDate = $filter('date')(vm.wr.docDate, 'yyyy-MM-dd');
					vm.originalStatus = vm.wr.status;

					vm.wrStatuses.forEach(function(s) {
						if(s.id==vm.wr.status){
							vm.selectedStatus = s;
						}
					});
					vm.originalStatus = vm.wr.status;

				}, function() {
					toastr.error('Failed to load selected Wastage Report.', Auth.translate('ERROR'))
					$state.go('wastagereports.list');
					return;
				});
		};

		// Print Wastage Report
		vm.printWR = function(wrId, wrNo) {

			var filename = "WASTAGE_" + wrNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('wastagereports/print/' + wrId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate Wastage Report PDF. ' + error, '');
							return null;
						});
		}

		/* ************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('wastagereports/' + $stateParams.id, vm.wr, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Wastage Report updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Actions
		vm.loadWR();
	}

	/** @ngInject */
	function WastageReportPopupModalCtrl($uibModalInstance, item, Auth, HttpSvc, UtilSvc, toastr) {
		var $mdl = this;

		$mdl.isRmsLite = Auth.isLiteMode();
		$mdl.isSimpleStockIn = Auth.getSetting_isStockInSimpleMode();

		$mdl.title = item.title;
		$mdl.entityList = [];
		$mdl.mode = item.mode;
		$mdl.item = item.object;
		$mdl.lockButton1 = false;
		$mdl.lockButton2 = false;
		$mdl.isLoading = false;
		$mdl.isFirstLoad = true;

		/* ************************************************************ */

		$mdl.initData = function() {
			if($mdl.mode==1) {
				$mdl.item.serialNo = "";
			} else {
				if(!$mdl.isRmsLite && !$mdl.isSimpleStockIn)
				{
					$mdl.loadLabelInfo();
				}
				else
				{
					$mdl.searchItem($mdl.item.code);
				}
			}
		}

		/* ************************************************************ */

		$mdl.loadLabelInfo = function() {
			var json = {
				serialNo: $mdl.item.serialNo
			};
			HttpSvc.post('stockmgmts/mainlabelinfo', json, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.labelInfo = result;
					$mdl.item.code = $mdl.labelInfo.itemCode;
					$mdl.item.description = $mdl.labelInfo.itemDescription;
					$mdl.item.itemId = $mdl.labelInfo.itemId;
					$mdl.item.semiFinishedProductId = $mdl.labelInfo.semiFinishedProductId;
					$mdl.item.productId = $mdl.labelInfo.productId;
					$mdl.item.unitOfMeasurementId = $mdl.labelInfo.unitOfMeasurementId;
					$mdl.item.uomName = $mdl.labelInfo.uom1;
					$mdl.item.unitOfMeasurementId2 = $mdl.labelInfo.unitOfMeasurementId2;
					$mdl.item.uomName2 = $mdl.labelInfo.uom2;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve the Label Information.', '');
					return null;
				});
		}

		/* ************************************************************ */

		$mdl.selectedItemChanged = function() {
			$mdl.item.code = $mdl.selectedItem.productCode;
			$mdl.item.description = $mdl.selectedItem.productName;
			$mdl.item.itemId = $mdl.selectedItem.itemId;
			$mdl.item.semiFinishedProductId = $mdl.selectedItem.semiFinishedProductId;
			$mdl.item.productId = $mdl.selectedItem.productId;

			if(!$mdl.isFirstLoad)
			{
				$mdl.selectedUom = $mdl.selectedItem.uomList[0];
				$mdl.selectedUomChanged();
			}
		};

		$mdl.selectedUomChanged = function() {
			$mdl.item.unitOfMeasurementId = $mdl.selectedUom.id
			$mdl.item.uomName = $mdl.selectedUom.name;
		}


		/* ********************************************************* */

		// Load Item List
		$mdl.searchItem = function(searchString) {
			$mdl.lockButtons = true;

			var keyword = encodeURIComponent(searchString);

			HttpSvc.get('searchengine/search/items/' + keyword, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.itemList = result;
					$mdl.lockButtons = false;

					if($mdl.isFirstLoad)
					{
						if($mdl.mode==2) {
							if($mdl.itemList.length > 0)
							{
								$mdl.selectedItem = $mdl.itemList[0];
								$mdl.selectedItemChanged();

								$mdl.selectedItem.uomList.forEach(function(u) {
									if(u.id == $mdl.item.unitOfMeasurementId)
									{
										$mdl.selectedUom = u;
										$mdl.selectedUomChanged();
									}
								});
							}
						}

						$mdl.isFirstLoad = false;
					}
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Item list.', '');
					return null;
				});
		};

		$mdl.loadItem = function() {
			if($mdl.item.itemId!=null)
			{
				$mdl.loadRawMat($mdl.item.itemId);
			}
			else if($mdl.item.semiFgId!=null)
			{
				$mdl.loadSemiFg($mdl.item.semiFgId);
			}
			else if($mdl.item.productId!=null)
			{
				$mdl.loadFg($mdl.item.productId);
			}
		}

		$mdl.loadRawMat = function(itemId) {
			HttpSvc.get('items/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.selectedItem.uomList = result;
					$mdl.selectedItem.uomList.forEach(function(u) {
						if(u.id==$mdl.item.uomId)
						{
							$mdl.selectedUom = u;
						}
					});
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Raw Mat UOM list.', '');
					return null;
				});
		}

		$mdl.loadSemiFg = function(itemId) {
			HttpSvc.get('semifgs/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.selectedItem.uomList = result;
					$mdl.selectedItem.uomList.forEach(function(u) {
						if(u.id==$mdl.item.uomId)
						{
							$mdl.selectedUom = u;
						}
					});
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Semi FG UOM list.', '');
					return null;
				});
		}

		$mdl.loadFg = function(itemId) {
			HttpSvc.get('products/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.selectedItem.uomList = result;
					$mdl.selectedItem.uomList.forEach(function(u) {
						if(u.id==$mdl.item.uomId)
						{
							$mdl.selectedUom = u;
						}
					});
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve FG UOM list.', '');
					return null;
				});
		}
		/* ************************************************************ */

		$mdl.confirmModal = function() {
			if($mdl.popupForm.$invalid) {
				$mdl.errorMsg = UtilSvc.getErrorMessage($mdl.popupForm);
				$mdl.showError = true;
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ************************************************************ */

		$mdl.initData();
	};

    /** @ngInject */
    function WastageReportPictureModalCtrl($uibModalInstance, item, Auth, RmsApi) {
        var $mdl = this;
        $mdl.itemCode = item.itemCode;
		$mdl.itemName = item.itemName;
		$mdl.photoAttachment = item.photoAttachment;
		$mdl.photoArray = $mdl.photoAttachment.split(";");
		$mdl.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		$mdl.selectedPhoto = $mdl.rootUrl + $mdl.photoArray[0];

		// Process Photos
		$mdl.selectPhoto = function(photo) {
			$mdl.selectedPhoto = $mdl.rootUrl + photo;
		}

        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };
	};

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.theme.components')
		.config(toastrLibConfig);

	/** @ngInject */
	function toastrLibConfig(toastrConfig) {
		angular.extend(toastrConfig, {
			allowHtml: true,
			closeButton: true,
			closeHtml: '<button>&times;</button>',
			timeOut: 5000,
			autoDismiss: true,
			containerId: 'toast-container',
			maxOpened: 0,
			newestOnTop: true,
			positionClass: 'toast-bottom-right',
			preventDuplicates: false,
			preventOpenDuplicates: true,
			target: 'body'
		});
	}
})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('RmsAppV2.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();

(function () {
	'use strict';

	angular.module('RmsAppV2.theme')
		.directive('bsDropDown', ['$compile', '$parse', '$timeout', function ($compile, $parse, $timeout) {

			return {
				restrict: 'AE',
				require: ['ngModel'],
				link: function (scope, element, attrs, ctrl) {
					// options
					var autoWidth = attrs.autoWidth === "true" ? true : false;
					var BOOTSTRAP_SELECT_DATA = '$bootstrapSelect';
					var ngModelCtrl = ctrl[0];
					var template =  "<div class=\"btn-group bootstrap-select\" ng-init=\"current = {}\">\n" +
									"	<button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\">\n" +
									"		<span class=\"selected\">{{ current.selection.label }}</span>\n" +
									"		<span class=\"caret\"></span>\n" +
									"	</button>\n" + 
									"	<ul class=\"dropdown-menu\" role=\"menu\">\n" +
									"		<li role=\"presentation\" ng-repeat=\"option in $options\" ng-click=\"current.selection = option\">\n" +
									"			<a role=\"menuitem\" tab-index=\"-1\">{{ option.label }}</a>\n" +
									"		</li>\n" +
									"	</ul>\n" +
									"</div>";

					var dropdown = angular.element(template);
					var dropdownScope = scope.$new(true);
					$compile(dropdown)(dropdownScope);

					// update the classes on the dropdown container whenever they change on the select
					var initialClasses = dropdown[0].className;
					attrs.$observe('class', function(classes) {
						dropdown[0].className = initialClasses + " " + classes;
					});

					element.after(dropdown);
					element.css('display', 'none');

					// from ngOptionsDirective AngularJS 1.2.0-rc2
					var NG_OPTIONS_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w\d]*)|(?:\(\s*([\$\w][\$\w\d]*)\s*,\s*([\$\w][\$\w\d]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/;
					var match = attrs.ngOptions.match(NG_OPTIONS_REGEXP);
					var valuesFn = $parse(match[7]);

					var buildObjFromOptionElement = function (optionEl) {
						return {
							index: optionEl.val(),
							label: optionEl.text()
						};
					};

					var updateOptions = function( items ) {
						var options = element.find('option');
						dropdownScope.$options = [];
						angular.forEach(options, function(option) {
							var o = angular.element(option);
							var data = buildObjFromOptionElement(o);
							if (items && items[data.index]) {
								data.value = items[data.index];
							} else {
								data.value = null;
							}
							o.data(BOOTSTRAP_SELECT_DATA, data);
							dropdownScope.$options.push(data);
						});

						if (autoWidth) {
							// calculate the width of the select
							$timeout(function() {
								// find the longest option
								var last = '';
								angular.forEach(dropdownScope.$options, function(option) {
									if(option.label.length > last.length) {
										last = option.label;
									}
								});

								// put it in an invisible div
								var div = angular.element('<div style="position: absolute; visibility: hidden; height: auto; width: auto;"></div>');
								div.html(last);
								dropdown.after(div);
								var width = div[0].offsetWidth + 'px';
								div.remove();
								// set the css
								angular.element(dropdown.find('span')[0]).css({ 'width': width, 'display': 'inline-block', 'text-align': 'left' });
							});
						}
					};

					var updateSelected = function( val ) {
						var options = element.find('option');
						angular.forEach(options, function(option) {
							var o = angular.element(option);
							if (element.val() === o.val()) {
								dropdownScope.current.selection = o.data(BOOTSTRAP_SELECT_DATA);
								return;
							}
						});
					};

					// update options when the collection changes
					scope.$watch(valuesFn, updateOptions);
					scope.$watch(attrs.ngModel, function (n, o) {
						updateSelected(n);
					});

					// update the select and the model when our selection changes
					dropdownScope.$watch('current.selection', function (n) {
						$timeout(function() {
							element.val(n.index);
							element.triggerHandler('change');
						});
					});
				}
			};
		}])

		/**
		 * From Angular UI Bootstrap
		 * http://angular-ui.github.io/bootstrap/
		 */
		.directive('dropdownToggle', ['$document', '$location', function ($document, $location) {
			
			var openElement = null,
			closeMenu = angular.noop;
			
			return {
				restrict: 'CA',
				link: function(scope, element, attrs) {
					
					scope.$watch('$location.path', function() { closeMenu(); });
					
					element.parent().bind('click', function() { closeMenu(); });
					
					element.bind('click', function (event) {
						var elementWasOpen = (element === openElement);

						event.preventDefault();
						event.stopPropagation();

						if (!!openElement) {
							closeMenu();
						}

						if (!elementWasOpen) {
							element.parent().addClass('open');
							openElement = element;
							closeMenu = function (event) {
								if (event) {
									event.preventDefault();
									event.stopPropagation();
								}
								$document.unbind('click', closeMenu);
								element.parent().removeClass('open');
								closeMenu = angular.noop;
								openElement = null;
							};
							$document.bind('click', closeMenu);
						}
					});
				}
			};
		}]);
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
(function() {
    'use strict';

    angular.module('RmsAppV2.pages.salesordercalendar.controller', [])
        .controller('SalesOrderCalendarMainCtrl', SalesOrderCalendarMainCtrl);
		

    /** @ngInject */
    function SalesOrderCalendarMainCtrl($scope, $filter, $state, RmsApi, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;

		// Calendar Options
		vm.calendarOptions = {
			allDaySlot: false,
			defaultView: 'month',
			// customButtons: {
			// 	pendingButton: {
			// 		text: 'Pending',
			// 		click: function() {
			// 			alert('clicked the Pending button!');
			// 		}
			// 	},
			// 	completedButton: {
			// 		text: 'Completed',
			// 		click: function() {
			// 			alert('clicked the Completed button!');
			// 		}
			// 	}
			// },
			header: {
				center: 'title',
				right: 'today prev,next pendingButton completedButton'
			},
			height: 'auto',
			//minTime: '08:00:00',
			//maxTime: '20:00:00',
			// views: {
			// 	agendaWeek: {
			// 		columnFormat: 'ddd D/M'
			// 	}
			// },
			events: {
				url: RmsApi.URL + 'salesorders/list/calendar/undelivery',
				type: 'GET',
				data: {},
				beforeSend: function(xhr) {
					xhr.setRequestHeader ("Authorization", "Basic " + Auth.getTokenId());
				},
				error: function() {
				  	toastr.warning('Error loading Sales Order Calendar.');
				}
			},
			eventClick: function(event) {
				if(confirm('Confirm navigate to Sales Order [' + event.salesOrderNo + '] ?'))
				{
					$state.go('salesorders.update', {'id': event.id });
				}
			},			
			eventRender: function(event, element) {
				element.qtip({
					content: {
						title: 
							event.salesOrderNo + 
							" <span class='pull-right'>( " + 
							Auth.translate(event.status.replace(' ', '_')) + 
							" )</span>", 
						text: 
							"<div style='padding:15px'>" + 
							Auth.translate('CUSTOMER_NAME') + ":<br />" +
							"<b>" + event.debtorName + "</b><br /><br />" +
							Auth.translate('DELIVERY_DATE') + ":<br />" +
							"<b>" + (event.deliveryDateText || 'n/a') + "</b><br /><br />" +
							Auth.translate('DESCRIPTION') + ":<br />" +
							"<b>" + (event.description || 'n/a') + "</b><br /><br />" +
							Auth.translate('ORDER_ITEMS') + ":<br />" +
							vm.getSalesOrderDetails(event.salesOrderProducts) + 
							"</div>"
					},
					position: {
						at: 'center left',
						my: 'right center',
						viewport: $('body'),
						adjust: {
							method: 'none shift'
						}
					},
					style: {
						width: '400px'
					}
				});
			}		
        };

		vm.getSalesOrderDetails = function(salesOrderProducts) 
		{
			var detailText = "";
			var index = 1;

			salesOrderProducts.forEach(function(s) {
				detailText += 
					index + ") <b>" + s.productName + "</b> x <b>" + 
					(s.quantity - s.deliveredQuantity) + "</b> " + 
					s.uomName + "<br />";
				index++;
			})

			return detailText;
		}
	};
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.assetconfigs.eqbrands.controller', [])
        .controller('EqBrandMainCtrl', EqBrandMainCtrl)
        .controller('EqBrandCreateCtrl', EqBrandCreateCtrl)
        .controller('EqBrandUpdateCtrl', EqBrandUpdateCtrl);

    /** @ngInject */
    function EqBrandMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.brandDataFull = [];
		vm.brandData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.brandDataFull, tableState.search.predicateObject) : vm.brandDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.brandData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.brandDataFull.length <= 0) {
				vm.isLoading = true;

				HttpSvc.get('equipmentbrands/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.brandDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteBrand = function(branchId, branchName) {
			var params = {};
			HttpSvc.delete('equipmentbrands/' + branchId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('equipmentbrands/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.brandDataFull = result;
							
							toastr.success('The branch [' + branchName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the branch [' + branchName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function EqBrandCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.brand = {};	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('equipmentbrands', vm.brand, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Brand has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('assetconfigs.eqbrands.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function EqBrandUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.brand = {};
						
		// Load EqBrand
		vm.loadBrand = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('equipmentbrands/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.brand = result;
				}, function() {
					toastr.error('Failed to load selected Brand.', Auth.translate('ERROR'))
					$state.go('assetconfigs.eqbrands.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('equipmentbrands/' + $stateParams.id, vm.brand, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Brand has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('assetconfigs.eqbrands.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadBrand();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.assetconfigs.equipment.controller', [])
        .controller('EquipmentMainCtrl', EquipmentMainCtrl)
        .controller('EquipmentCreateCtrl', EquipmentCreateCtrl)
        .controller('EquipmentUpdateCtrl', EquipmentUpdateCtrl)
        .controller('EquipmentImportCtrl', EquipmentImportCtrl)
        .controller('EquipmentPropertiesModalCtrl', EquipmentPropertiesModalCtrl)
        .controller('EquipmentDocumentModalCtrl', EquipmentDocumentModalCtrl);

    /** @ngInject */
    function EquipmentMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 20;
		vm.numOfRecord = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.dataFull = [];
		vm.data = [];
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.isLoading = false;
		vm.blobUrl = RmsApi.BLOBURL;

		vm.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}
			
			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.equipmentName,
				model: predicate.model,
				typedName: predicate.typedName,
				brandName: predicate.brandName,
				categoryName: predicate.categoryName,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('equipments/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isLoading = false;		
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;	
					vm.numOfPages = result.numberOfPages;	
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;		
			return tableState;
		};

		vm.resetSearch = function() 
		{
		}	
		
		vm.deleteEquipment = function(equipmentId, equipmentName) {
			var params = {};
			HttpSvc.delete('equipments/' + equipmentId, params, Auth.getTokenId(), false)
				.then(function(result) {					
					toastr.success('The Equipment [<b>' + equipmentName + '</b>] has been deleted.', 'Delete Success');
					$scope.$broadcast('refreshStTable');
				}, function() {
					// Failed
					toastr.error('Failed to delete the Equipment [' + equipmentName + '].', 'Delete Failed');
					return null;
			});
		};			
	};
	
	/** @ngInject */
    function EquipmentCreateCtrl($scope, $state, $uibModal, $location, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {
		Auth.init();
		
		var vm = this;
		
		vm.mode = 1;
		vm.equipment = {};
		vm.equipment.equipmentProperties = [];
		vm.equipment.equipmentDocuments = [];
		vm.types = [];
		vm.brands = [];
		vm.categories = [];
		vm.selectedType = null;
		vm.selectedBrand = null;
		vm.selectedCategory = null;
		vm.isLoading = false;
		vm.lockButtons = false;
		
		vm.equipment.imageLocation = 'assets/img/empty_placeholder.png';
		vm.equipment.oriImageLocation = '';
		vm.blobUrl = RmsApi.BLOBURL;
		vm.fileToUpload = null;
		vm.mediaToUpload = null;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		
		/* ************************************************************* */
		
		vm.loadTypes = function() {
			vm.isLoading = true;
			
			HttpSvc.get('equipmenttypes/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.types = result;	
					vm.loadBrands();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Equipment Type List', Auth.translate('ERROR'))
					$state.go('assetconfigs.equipment.list');
					return;
				});		
		}
		
		vm.loadBrands = function() {
			vm.isLoading = true;
			
			HttpSvc.get('equipmentbrands/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.brands = result;	
					vm.loadCategories();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Equipment Brand List', Auth.translate('ERROR'))
					$state.go('assetconfigs.equipment.list');
					return;
				});		
		}
		
		vm.loadCategories = function() {
			HttpSvc.get('equipmentcategories/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.categories = result;	
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Equipment Categories List', Auth.translate('ERROR'))
					$state.go('assetconfigs.equipment.list');
					return;
				});		
		}
		
		/* ************************************************************* */
		
		vm.selectedTypeChanged = function() {
			vm.equipment.typeId = vm.selectedType.id;
		}
		
		vm.selectedBrandChanged = function() {
			vm.equipment.brandId = vm.selectedBrand.id;
			vm.equipment.brand = vm.selectedBrand.code;
		}
		
		vm.selectedCategoryChanged = function() {
			vm.equipment.categoryId = vm.selectedCategory.id;
			vm.equipment.category = vm.selectedCategory.name;
		}
		
		/* ************************************************************* */
			
		// Open Modal Dialog
		vm.prop = {};		
		vm.showAddPropModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'propModal.html',
				controller: 'EquipmentPropertiesModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.prop,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addProp(data);
				}, function () {
				});
		};	
		vm.showEditPropModal = function (index) {
			vm.prop = vm.equipment.equipmentProperties[index];
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'propModal.html',
				controller: 'EquipmentPropertiesModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.prop,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateProp(index, data);
				}, function () {
				});
		};				
		
		/* ************************************************************* */
		
		// Remove Properties
		vm.removeProp = function(index) {
			vm.equipment.equipmentProperties.splice(index, 1);
		};
			
		// Update Properties
		vm.updateProp = function(index, obj) {
			var element = {
				name: obj.name,
				value: obj.value,
			};
			vm.equipment.equipmentProperties.splice(index, 1, element);
		};

		// Add Properties
		vm.addProp = function(obj) {
			var element = {
				name: obj.name,
				value: obj.value,
			};
			vm.equipment.equipmentProperties.push(element);
		};
		
		/* ************************************************************* */
		
		/* ************************************************************* */
				
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Set Upload Image
		vm.clearImage = function() {			
			vm.equipment.imageLocation = 'assets/img/empty_placeholder.png';
			vm.equipment.oriImageLocation = '';
			vm.fileToUpload = null;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (id) {
			var fileReader = new FileReader();
						
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Equipment has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('assetconfigs.equipment.update', {'id': id });
				}, function (resp) {
					toastr.success('Equipment has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('assetconfigs.equipment.update', {'id': id });
				}, function (evt) {
				});
				
			} else if(vm.serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {
							toastr.success('Equipment has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('assetconfigs.equipment.update', {'id': id });
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
					});
				}
			}
		};
		
		/* ************************************************************* */
						
		// Form Submission
		vm.submit = function() {
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {

				imgLocation = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/equipments/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "equipments/" + newFilename + mediaExtension;

				} else if(vm.equipment.oriImageLocation!="") {
					imgLocation = vm.equipment.oriImageLocation;
				}
				vm.equipment.imageLocation = imgLocation;	

				HttpSvc.post('equipments', vm.equipment, Auth.getTokenId(), false)
					.then(function(result) {	
						azureStorageUrl = "";
						localStorageUrl = "";

						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(result.id);
							
						} 
						else if(vm.serverMode==0 && vm.fileToUpload) 
						{
							localStorageUrl = RmsApi.URL + "upload/equipments/" + vm.item.Id;
							vm.uploadImage(result.id);
							
						} 
						else 
						{					
							toastr.success('Equipment has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('assetconfigs.equipment.update', {'id': result.id });
						}
						
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadTypes();
	}
	
	/** @ngInject */
    function EquipmentUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

		Auth.init();
		
		var vm = this;
		
		vm.fileTypes = [ 
			{id:'CTL', name:'CATALOGUE'},
			{id:'PRL', name:'PRICE LIST'},
			{id:'PTD', name:'PARTS DIAGRAM'},
			{id:'IML', name:'INSTRUCTION MANUAL'},
			{id:'SPS', name:'SPECIFICATION SHEET'},
			{id:'OTH', name:'OTHER'},
		];
		
		vm.mode = 2;
		vm.equipment = {};
		vm.equipment.equipmentProperties = [];
		vm.equipment.equipmentDocuments = [];
		vm.types = [];
		vm.brands = [];
		vm.categories = [];
		vm.selectedType = null;
		vm.selectedBrand = null;
		vm.selectedCategory = null;
		vm.isLoading = false;
		vm.lockButtons = false;
		
		vm.equipment.imageLocation = '';
		vm.equipment.oriImageLocation = '';
		vm.blobUrl = RmsApi.BLOBURL;
		vm.fileToUpload = null;
		vm.mediaToUpload = null;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		
		/* ************************************************************* */
		
		vm.loadTypes = function() {
			vm.isLoading = true;
			
			HttpSvc.get('equipmenttypes/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.types = result;	
					vm.loadBrands();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Equipment Type List', Auth.translate('ERROR'))
					$state.go('assetconfigs.equipment.list');
					return;
				});		
		}
		
		vm.loadBrands = function() {			
			HttpSvc.get('equipmentbrands/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.brands = result;	
					vm.loadCategories();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Equipment Brand List', Auth.translate('ERROR'))
					$state.go('assetconfigs.equipment.list');
					return;
				});		
		}
		
		vm.loadCategories = function() {
			HttpSvc.get('equipmentcategories/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.categories = result;	
					vm.loadEquipment();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Equipment Categories List', Auth.translate('ERROR'))
					$state.go('assetconfigs.equipment.list');
					return;
				});		
		}
		
		/* ************************************************************* */
		
		vm.selectedTypeChanged = function() {
			vm.equipment.typeId = vm.selectedType.id;
		}
		
		vm.selectedBrandChanged = function() {
			vm.equipment.brandId = vm.selectedBrand.id;
		}
		
		vm.selectedCategoryChanged = function() {
			vm.equipment.categoryId = vm.selectedCategory.id;
		}
		
		/* ************************************************************* */
		
		// Load Equipment
		vm.loadEquipment = function() {	
		
			HttpSvc.get('equipments/'+$stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.equipment = result;	
					
					vm.types.forEach(function(t) {
						if(t.id==vm.equipment.typeId) {
							vm.selectedType = t;
						}
					});
					
					vm.brands.forEach(function(b) {
						if(b.id==vm.equipment.brandId) {
							vm.selectedBrand = b;
						}
					});
					
					vm.categories.forEach(function(c) {
						if(c.id==vm.equipment.categoryId) {
							vm.selectedCategory = c;
						}
					});
					
					vm.equipment.equipmentDocuments.forEach(function(d) {
						vm.fileTypes.forEach(function(f) {
							if(f.id == d.fileType) {
								d.fileTypeText = f.name;
							}
						});
					});
					
					if(!vm.equipment.imageLocation || vm.equipment.imageLocation=='') {
						vm.equipment.imageLocation = 'assets/img/empty_placeholder.png';
						vm.equipment.oriImageLocation = "";
					} else {
						vm.equipment.oriImageLocation = vm.equipment.imageLocation;
						vm.equipment.imageLocation = vm.rootUrl + vm.equipment.imageLocation;
					}

					vm.isLoading = false;
					
				}, function() {
					toastr.error('Failed to load selected Equipment', Auth.translate('ERROR'))
					$state.go('assetconfigs.equipment.list');
					return;
				});		
		};	
		
		vm.loadDocuments = function(equipmentId) {
			var params = { id: equipmentId };
			HttpSvc.get('equipmentdocuments/list/:id', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.equipment.equipmentDocuments = result;		
					vm.equipment.equipmentDocuments.forEach(function(d) {
						vm.fileTypes.forEach(function(f) {
							if(f.id == d.fileType) {
								d.fileTypeText = f.name;
							}
						});
					});
					
					$scope.$broadcast('refreshStTable');
				}, function() {
					toastr.error('Failed to load Documents.', Auth.translate('ERROR'))
					return;
				});		
		}
		
		/* ************************************************************* */
			
		// Open Modal Dialog
		vm.prop = {};		
		vm.showAddPropModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'propModal.html',
				controller: 'EquipmentPropertiesModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.prop,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addProp(data);
				}, function () {
				});
		};	
		vm.showEditPropModal = function (index) {
			vm.prop = vm.equipment.equipmentProperties[index];
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'propModal.html',
				controller: 'EquipmentPropertiesModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.prop,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateProp(index, data);
				}, function () {
				});
		};				
		
		/* ************************************************************* */
		
		// Refresh Document List
		vm.refreshDocs = function(tableState) {
			// Do nothing
		};
		
		// Remove Equipment Document
		vm.removeDoc = function(docId) {	
			HttpSvc.delete('equipmentdocuments/' + docId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('The Document has been removed.', Auth.translate('SUCCESS'));
					vm.loadDocuments(vm.equipment.id);
					$scope.$broadcast('refreshStTable');
				}, function(error) {
					// Failed
					toastr.error('Failed to remove the Document.', 'Failed');
					return null;
				});
		};
		
		// Open Document Modal Dialog		
		vm.showAddDocModal = function () {
			vm.doc = {};
			vm.doc.equipmentId = vm.equipment.id;
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'EqDocModal.html',
				controller: 'EquipmentDocumentModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.doc,
							serverMode: vm.serverMode,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadDocuments(vm.equipment.id);
				}, function () {
				});
		};	
		
		vm.showEditDocModal = function (docId) {
			vm.doc = {};
			
			vm.equipment.equipmentDocuments.forEach(function(d){
				if(d.id==docId) {
					vm.doc = d;
				}
			});
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'EqDocModal.html',
				controller: 'EquipmentDocumentModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.doc,
							serverMode: vm.serverMode,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadDocuments(vm.equipment.id);
				}, function () {
				});
		};	
				
		/* ************************************************************* */
		
		// Remove Properties
		vm.removeProp = function(index) {
			vm.equipment.equipmentProperties.splice(index, 1);
		};
			
		// Update Properties
		vm.updateProp = function(index, obj) {
			var element = {
				id: obj.id,
				equipmentId: obj.equipmentId,
				name: obj.name,
				value: obj.value,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
				modifiedBy: obj.modifiedBy,
				modifiedDate: obj.modifiedDate,
			};
			vm.equipment.equipmentProperties.splice(index, 1, element);
		};

		// Add Properties
		vm.addProp = function(obj) {
			var element = {
				name: obj.name,
				value: obj.value,
			};
			vm.equipment.equipmentProperties.push(element);
		};
		
		/* ************************************************************* */
		
		// Clone Equipment
		vm.cloneEquipment = function() {
			vm.lockUpdateButtons = true;
			
			HttpSvc.post('equipments/clone/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {											
						toastr.success('Equipment has been cloned successfully.', Auth.translate('SUCCESS'));	
						$state.go('assetconfigs.equipment.update', {'id': result.id });
				}, function(error) {
					toastr.error(angular.toJson(error), 'Failed');
					vm.dataForm.$setPristine();
				});
		}
		
		/* ************************************************************* */
				
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Set Upload Image
		vm.clearImage = function() {			
			vm.equipment.imageLocation = 'assets/img/empty_placeholder.png';
			vm.equipment.oriImageLocation = '';
			vm.fileToUpload = null;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function () {
			var fileReader = new FileReader();
						
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Equipment has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('Equipment has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
				});
				
			} else if(vm.serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {
							toastr.success('Equipment has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
					});
				}
			}
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {		

				imgLocation = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/equipments/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "equipments/" + newFilename + mediaExtension;

				} else if(vm.equipment.oriImageLocation!="") {
					imgLocation = vm.equipment.oriImageLocation;
				}
				vm.equipment.imageLocation = imgLocation;	

				HttpSvc.put('equipments/' + $stateParams.id, vm.equipment, Auth.getTokenId(), false)
					.then(function(result) {
						azureStorageUrl = "";
						localStorageUrl = "";

						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage();
							
						} 
						else if(vm.serverMode==0 && vm.fileToUpload) 
						{
							localStorageUrl = RmsApi.URL + "upload/equipments/" + vm.item.Id;
							vm.uploadImage();
							
						} 
						else 
						{
							toastr.success('Equipment has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						}
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadTypes();
	}
	
	/** @ngInject */
	function EquipmentImportCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;		
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.importType = 1;
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;
		
		/* **************************************************** */

		vm.scrollLeft = function() {
			document.getElementById('scroll-container').scrollLeft -= 300;
		}
		
		vm.scrollRight = function() {
			document.getElementById('scroll-container').scrollLeft += 300;
		}
		
		/* **************************************************** */
		
		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";

		/* **************************************************** */
		
		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		vm.importOptions.createEquipment = true;
		vm.importOptions.updateEquipment = true;
		vm.importOptions.createEquipmentBrand = true;
		vm.importOptions.updateEquipmentBrand = true;
		vm.importOptions.createEquipmentCategory = true;
		vm.importOptions.updateEquipmentCategory = true;
		vm.importOptions.createEquipmentType = true;
		vm.importOptions.updateEquipmentType = true;
		
		/* **************************************************** */
		
		vm.goBack = function() {
			$state.reload();
		}
		
		/* **************************************************** */
		
		vm.importResult = {};
		
		/* **************************************************** */
				
		vm.downloadTemplate = function(downloadType, templateName) {
			
			var filename = templateName + ".xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject(downloadType + '/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};	
		
		/* **************************************************** */
		
		vm.importData = function() {
			vm.isImporting = true;
			
			HttpSvc.post(vm.importType + '/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
				}, function(error) {
				});
		}
		
		/* **************************************************** */
		
		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}
		
		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;			
		}
		
		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];
			
			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}
		
		// Upload File
		vm.uploadFile = function(importType) {	
			vm.resetFileUploadParams();
			
			vm.lockButtons = true;
			vm.importType = importType;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;
								
			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;
			
			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();	
				vm.uploadMedia(vm.mediaToUpload);
			}	
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {
						
						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);
						
					}, function(error) {
						toastr.error(error, 'Failed');
						
						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {					
					vm.isUploaded = true;
					
					// Call Process Excel API 
					var apiUrl = vm.importType + '/import/' + resp.data;

					HttpSvc.post(apiUrl, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;
							
							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			}  else if(vm.serverMode==1) { // Azure Server
							
				/* Initialize variables */
				/* ************************************* */	
				handleFileSelect(_fileToUpload);
				/* ************************************* */	
				
				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							} 
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,				
			}).then(function(response) {	
				vm.isUploaded = true;
				
				// Call Process Excel API 
				var apiUrl = vm.importType + '/import/' + excelFilename;

				HttpSvc.post(apiUrl, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;
						
						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }		
	};
		
	// Equipment Properties Modal Controller
	function EquipmentPropertiesModalCtrl($uibModalInstance, item, toastr) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.item = item.object;
						
		$mdl.confirmModal = function() {
			if($mdl.propForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	

	// Equipment Documents Modal Controller
	function EquipmentDocumentModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
				
		$mdl.serverMode = item.serverMode;
		$mdl.rootUrl = ($mdl.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		
		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.item = item.object;
		$mdl.fileTypes = [];
		$mdl.selectedFileType = null;		
		$mdl.lockUploadButton = item.lockUploadButton;
		$mdl.lockButton = false;
		$mdl.uploadProgess = 0;
		$mdl.uploadProgessTotal = 0;
		$mdl.uploadProgessPercent = 0;		
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		/* ************************************************************** */

		// Initialize
		if(item.mode==1) {
			$mdl.item.description = "";
			$mdl.item.docTypeId = "";
			$mdl.item.filename = "";
			$mdl.item.createdBy = "";
			$mdl.item.createdDate = "";			
		}
		
		/* ************************************************************** */

		$mdl.loadDocTypes = function () {
			HttpSvc.get('equipmentdoctypes/list', {}, Auth.getTokenId(), true)
			.then(function(result) {	
				$mdl.fileTypes = result;

				if(item.mode==2) {
					$mdl.fileTypes.forEach(function(t) {
						if(t.id==$mdl.item.docTypeId) {
							$mdl.selectedFileType = t;
						}
					});
				}

				$mdl.lockButton = false;
			}, function() {
				toastr.error('Failed to retrieve Document Types.', '');
				$uibModalInstance.dismiss('cancel');
				return null;
			});
		}

		$mdl.selectedFileTypeChanged = function() {
			$mdl.item.docTypeId = $mdl.selectedFileType.id;
			$mdl.item.fileTypeText = $mdl.selectedFileType.name;
		}
		
		// Update Equipment Document
		$mdl.updateDocument = function(obj) {
			$mdl.lockButton = true;		
			
			var element = {
				id: obj.id,
				equipmentId: obj.equipmentId,
				description: obj.description,
				docTypeId: obj.docTypeId,
				filename: obj.filename,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
			};
			
			var mediaLocation = "";
			var mediaExtension = "";
			var newFilename = UtilSvc.generateGuid() + ".";
			azureStorageUrl = "";
			localStorageUrl = "";
			
			if($mdl.serverMode==1 && obj.mediaToUpload) {
				
				var extArray = obj.mediaToUpload.name.split(".");				
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = Auth.getCompanyId() + "/equipmentdocuments/" + newFilename + mediaExtension;
				
			} else if($mdl.serverMode==0 && obj.mediaToUpload) {	
			
				var extArray = obj.mediaToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = "equipmentdocuments/" + newFilename + mediaExtension;
				
			}			
			if(mediaLocation!="") {
				element.filename = mediaLocation;
			}
						
			HttpSvc.put('equipmentdocuments/' + obj.id, element, Auth.getTokenId(), false)
				.then(function(result) {
					
					if($mdl.serverMode==1 && obj.mediaToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + mediaLocation + result.azureSasToken;
						$mdl.uploadMedia(obj.mediaToUpload);
						
					} else if($mdl.serverMode==0 && obj.mediaToUpload) {
						localStorageUrl = RmsApi.URL + "upload/equipmentdocuments/" + obj.id;
						$mdl.uploadMedia(obj.mediaToUpload);
							
					} else {
						$uibModalInstance.close($mdl.item);
					}
					
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					$mdl.lockButton = false;
					$mdl.certForm.$setPristine();
				});	
		};
		
		// Add Equipment Document
		$mdl.addDocument = function(obj) {	
			$mdl.lockButton = true;			
			
			var element = {
				equipmentId: obj.equipmentId,
				description: obj.description,
				docTypeId: obj.docTypeId,
				filename: obj.filename,
			};
			
			var mediaLocation = "";
			var mediaExtension = "";
			var newFilename = UtilSvc.generateGuid() + ".";
			azureStorageUrl = "";
			localStorageUrl = "";
			
			if($mdl.serverMode==1 && obj.mediaToUpload) {
				
				var extArray = obj.mediaToUpload.name.split(".");				
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = Auth.getCompanyId() + "/equipmentdocuments/" + newFilename + mediaExtension;
				
			} else if($mdl.serverMode==0 && obj.mediaToUpload) {	
			
				var extArray = obj.mediaToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = "equipmentdocuments/" + newFilename + mediaExtension;
			
			}
			
			element.filename = mediaLocation;
			
			HttpSvc.post('equipmentdocuments', element, Auth.getTokenId(), false)
				.then(function(result) {
					
					if($mdl.serverMode==1 && obj.mediaToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + mediaLocation + result.azureSasToken;
						$mdl.uploadMedia(obj.mediaToUpload);
						
					} else if($mdl.serverMode==0 && obj.mediaToUpload) {
						localStorageUrl = RmsApi.URL + "upload/equipmentdocuments/" + result.id;
						$mdl.uploadMedia(obj.mediaToUpload);
					
					} else {
						$uibModalInstance.close($mdl.item);
					}
					
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					$mdl.lockButton = false;
					$mdl.docForm.$setPristine();
				});			
		};
		
		// ********************************************************
		
        var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		
		// Upload Image to Azure Blob Storage
		$mdl.uploadMedia = function (_fileToUpload) {
			
			/* Initialize variables */
			/* ************************************* */	
			handleFileSelect(_fileToUpload);
			/* ************************************* */	
			
			/* Initialize File Reader */
			/* ************************************* */
			fileReader = new FileReader();
			/* ************************************* */
			
			if($mdl.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('Document uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (resp) {
					toastr.success('Document uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if($mdl.serverMode==1) { // Azure Server
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								$mdl.lockButton = false;					
								$mdl.stepForm.$setPristine();
							} 
						}, null, function(evt) {
							$mdl.uploadProgessTotal = _fileToUpload.size;
							$mdl.uploadProgess = $mdl.uploadProgessTotal - totalBytesRemaining;
							$mdl.uploadProgessPercent = Math.min(100, parseInt(100.0 * $mdl.uploadProgess / $mdl.uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,
				
			}).then(function(response) {
				toastr.success("Document uploaded successfully.");
				$uibModalInstance.close($mdl.item);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }
		
		// ********************************************************		
		
		//Set Upload Media
		$mdl.setUploadMedia = function(mediaFile) {
			$mdl.item.mediaToUpload = mediaFile;
		}
		
		// Confirm Action
		$mdl.confirmModal = function() {			
			if($mdl.docForm.$valid) {
				if(item.mode==1) {
					$mdl.addDocument($mdl.item);	
				} else if(item.mode==2) {
					$mdl.updateDocument($mdl.item);
				}
				
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Init
		$mdl.loadDocTypes();
	};	
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.assetconfigs.pnreceiversettings.controller', [])
        .controller('PushNotificationReceiverSettingMainCtrl', PushNotificationReceiverSettingMainCtrl)
        .controller('PushNotificationReceiverSettingCreateCtrl', PushNotificationReceiverSettingCreateCtrl)
        .controller('PushNotificationReceiverSettingUpdateCtrl', PushNotificationReceiverSettingUpdateCtrl);

    /** @ngInject */
    function PushNotificationReceiverSettingMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.notifDataFull = [];
		vm.notifData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.notifDataFull, tableState.search.predicateObject) : vm.notifDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.notifData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.notifDataFull.length <= 0) {							
				HttpSvc.get('pnreceiversettings/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.notifDataFull = result;		

						vm.notifDataFull.forEach(function(n) {
							n.module = PushNotificationReceiverSettingGetModuleName(n.module);
						});

						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		vm.deleteNotification = function(notifId) {
			var params = {};
			HttpSvc.delete('pnreceiversettings/' + notifId, params, Auth.getTokenId(), false)
				.then(function(result) {					
					toastr.success('The Push Notification setting has been deleted.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function() {
					// Failed
					toastr.error('Failed to delete the Push Notification setting.', 'Failed');
					return null;
			});
		};			
	}
	
	/** @ngInject */
    function PushNotificationReceiverSettingCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		
		vm.moduleList = PushNotificationReceiverSettingModuleList();
		vm.userList = [];
		
		vm.notif = {};
		vm.selectedModule = null;
		vm.selectedUser = null;
		vm.lockButtons = false;
				
		// Load User List
		vm.loadUserList = function() {
			HttpSvc.get('users/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.userList = result;
				}, function(error) {
					toastr.error(error, 'Failed to load User List');
				});				
		};
		
		vm.selectedModuleChanged = function() {
			vm.notif.module = vm.selectedModule.id;
		};
		
		vm.selectedUserChanged = function() {
			vm.notif.userId = vm.selectedUser.id;
		};
		
		// Form Submission
		vm.submit = function() {
			
			vm.lockButtons = true;
						
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {						
				HttpSvc.post('pnreceiversettings', vm.notif, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Push Notification Setting has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('assetconfigs.pnreceiversettings.list');
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}
		
		// Call Actions
		vm.loadUserList();
	}
	
	/** @ngInject */
    function PushNotificationReceiverSettingUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		
		vm.moduleList = PushNotificationReceiverSettingModuleList();
		vm.userList = [];
		
		vm.notif = {};
		vm.selectedModule = null;
		vm.selectedUser = null;
		vm.lockButtons = false;
				
		// Load User List
		vm.loadUserList = function() {
			HttpSvc.get('users/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.userList = result;
					vm.loadNotif();
				}, function(error) {
					toastr.error(error, 'Failed to load User List');
				});				
		};
				
		// Load NotificationSetting
		vm.loadNotif = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('pnreceiversettings/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.notif = result;

					vm.moduleList.forEach(function(m) {
						if(m.id==vm.notif.module) {
							vm.selectedModule = m;
						}
					});
					vm.userList.forEach(function(u) {
						if(u.id==vm.notif.userId) {
							vm.selectedUser = u;
						}
					});					
				}, function() {
					toastr.error('Failed to load selected Push Notification Setting.', Auth.translate('ERROR'))
					$state.go('assetconfigs.pnreceiversettings.list');
					return;
				});		
		};	
		
		vm.selectedModuleChanged = function() {
			vm.notif.module = vm.selectedModule.id;
		};
		
		vm.selectedUserChanged = function() {
			vm.notif.userId = vm.selectedUser.id;
		};
		
		// Form Submission
		vm.submit = function() {
						
			vm.lockButtons = true;
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {
				HttpSvc.put('pnreceiversettings/' + $stateParams.id, vm.notif, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Push Notification Setting has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('assetconfigs.pnreceiversettings.list');
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}
		
		// Call Actions
		vm.loadUserList();			
	}
	
	function PushNotificationReceiverSettingModuleList() { 
		return [
			{id: 'ASSETCASE', name: 'ASSET CASE REPORTED'}, 
		];
	}
	
	function PushNotificationReceiverSettingGetModuleName(id) { 

		var moduleList = PushNotificationReceiverSettingModuleList();
		
		var result = "-";

		moduleList.forEach(function(m) {
			if(m.id==id)
				result = m.name;
		})

		return result;
	}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.assetconfigs.eqdoctypes.controller', [])
        .controller('EqDocTypeMainCtrl', EqDocTypeMainCtrl)
        .controller('EqDocTypeCreateCtrl', EqDocTypeCreateCtrl)
        .controller('EqDocTypeUpdateCtrl', EqDocTypeUpdateCtrl)
        .controller('EqDocTypeDebtorCategoryModalCtrl', EqDocTypeDebtorCategoryModalCtrl);

    /** @ngInject */
    function EqDocTypeMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.docTypeDataFull = [];
		vm.docTypeData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.docTypeDataFull, tableState.search.predicateObject) : vm.docTypeDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.docTypeData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.docTypeDataFull.length <= 0) {
				vm.isLoading = true;

				HttpSvc.get('equipmentdoctypes/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.docTypeDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteType = function(docTypeId, docTypeName) {
			var params = {};
			HttpSvc.delete('equipmentdoctypes/' + docTypeId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('equipmentdoctypes/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.docTypeDataFull = result;
							
							toastr.success('The Document Type [' + docTypeName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Document Type [' + docTypeName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function EqDocTypeCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.doctype = {};	
		vm.doctype.equipmentDocumentTypeDebtorCategories = [];
		
		/* ************************************************************* */
					
		// Open Debtor Category Modal Dialog
		vm.showAddDebtorCategoryModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'CustomerCategoryModal.html',
				controller: 'EqDocTypeDebtorCategoryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addDebtorCategory(data);
				}, function () {
				});
		};				
		
		// Remove Debtor Category
		vm.removeDebtorCategory = function(index) {
			var result = confirm('Confirm remove this Debtor Category?');
			
			if(result) {
				vm.doctype.equipmentDocumentTypeDebtorCategories.splice(index, 1);				
			}
		};

		// Add Debtor Category
		vm.addDebtorCategory = function(obj) {
			var element = {
				debtorCategoryId: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.doctype.equipmentDocumentTypeDebtorCategories.some(function(el){
				if(el.debtorCategoryId === element.debtorCategoryId){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.doctype.equipmentDocumentTypeDebtorCategories.push(element);
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('equipmentdoctypes', vm.doctype, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Document Type has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('assetconfigs.eqdoctypes.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function EqDocTypeUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.doctype = {};
		vm.doctype.equipmentDocumentTypeDebtorCategories = [];
		
		/* ************************************************************* */
						
		// Load EqDocType
		vm.loadDocTypes = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('equipmentdoctypes/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.doctype = result;
				}, function() {
					toastr.error('Failed to load selected Document Type.', Auth.translate('ERROR'))
					$state.go('assetconfigs.eqdoctypes.list');
					return;
				});		
		};	
		
		/* ************************************************************* */
					
		// Open Debtor Category Modal Dialog
		vm.showAddDebtorCategoryModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'CustomerCategoryModal.html',
				controller: 'EqDocTypeDebtorCategoryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addDebtorCategory(data);
				}, function () {
				});
		};				
		
		// Remove Debtor Category
		vm.removeDebtorCategory = function(index) {
			var result = confirm('Confirm remove this Debtor Category?');
			
			if(result) {
				vm.doctype.equipmentDocumentTypeDebtorCategories.splice(index, 1);				
			}
		};

		// Add Debtor Category
		vm.addDebtorCategory = function(obj) {
			var element = {
				debtorCategoryId: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.doctype.equipmentDocumentTypeDebtorCategories.some(function(el){
				if(el.debtorCategoryId === element.debtorCategoryId){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.doctype.equipmentDocumentTypeDebtorCategories.push(element);
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('equipmentdoctypes/' + $stateParams.id, vm.doctype, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Document Type has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('assetconfigs.eqdoctypes.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadDocTypes();		
	}
			
	// Debtor Category Modal Controller
	function EqDocTypeDebtorCategoryModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		$mdl.item = {};
		$mdl.debtorCategories = [];
		$mdl.selectedCategory = null;
					 
		// Load Customer Categories
		$mdl.loadCategories = function() {			
			HttpSvc.get('debtorcategories/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.debtorCategories = result;
				}, function() {
					toastr.error('Failed to load Customer Category List.', Auth.translate('ERROR'))
					$mdl.cancelModal();
					return;
				});		
		};		
		
		$mdl.selectedCategoryChanged = function() {
			$mdl.item.id = $mdl.selectedCategory.id;
			$mdl.item.name = $mdl.selectedCategory.name;
		}
						
		$mdl.confirmModal = function() {
			if($mdl.categoryForm.$invalid || $mdl.selectedCategory == null) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Init
		$mdl.loadCategories();
	};

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.conference.attendeemgmt.controller', [])
			.controller('ConferenceAttendeeMgmtMainCtrl', ConferenceAttendeeMgmtMainCtrl)
			.controller('ConferenceAttendeeMgmtCreateCtrl', ConferenceAttendeeMgmtCreateCtrl)
			.controller('ConferenceAttendeeMgmtUpdateCtrl', ConferenceAttendeeMgmtUpdateCtrl);

	/** @ngInject */
	function ConferenceAttendeeMgmtMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.conferenceList = [];
		vm.attendeeDataFull = [];
		vm.attendeeData = [];
		vm.isLoading = false;
		vm.selectedConference = {};
		vm.selectedConference.id = "";

		// *****************************************************

		vm.loadConferenceList = function() {
			vm.isLoading = true;

			HttpSvc.get('conferences/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.conferenceList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		// *****************************************************

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.attendeeDataFull, tableState.search.predicateObject) : vm.attendeeDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.attendeeData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.conferenceList.length==0) {
				vm.isLoading = true;
	
				HttpSvc.get('conferences/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.conferenceList = result;
						
						if(vm.conferenceList.length > 0) {
							vm.selectedConference = vm.conferenceList[0];
						}
						
						if(vm.attendeeDataFull.length <= 0) {	
							vm.isLoading = true;
			
							HttpSvc.get('conferenceattendees/listing/' + vm.selectedConference.id, params, Auth.getTokenId(), true)
								.then(function(result) {	
									vm.numOfRecord = result.length;	
									vm.attendeeDataFull = result;		
									refreshTableState(tableState, vm.startIndex, vm.endIndex);
									vm.isLoading = false;
								}, function() {
									vm.isLoading = false;
									toastr.error('Failed to retrieve data.', '');
									return null;
							});
						} else {
							refreshTableState(tableState, vm.startIndex, vm.endIndex);
						}
					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Failed');
					});
			}
			else 
			{
				if(vm.attendeeDataFull.length <= 0) {	
					vm.isLoading = true;
	
					HttpSvc.get('conferenceattendees/listing/' + vm.selectedConference.id, params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;	
							vm.attendeeDataFull = result;		
							refreshTableState(tableState, vm.startIndex, vm.endIndex);
							vm.isLoading = false;
						}, function() {
							vm.isLoading = false;
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				} else {
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}	
			}

			
		};	

		// *****************************************************

		vm.printLabel = function(attendeeId) {
			HttpSvc.post('conferenceattendees/print/' + attendeeId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Print instruction has been sent to printer.', Auth.translate('SUCCESS'));
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
	};

	/** @ngInject */
	function ConferenceAttendeeMgmtCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.attendee = {};
		vm.sources = [];
		vm.conferenceList = [];
		vm.selectedSource = null;
		vm.selectedConference = null;
		vm.attendee.address = "-";
		vm.attendee.email = "-";
		vm.attendee.postcode = "-";
		vm.attendee.nric = "-";
		
		// *********************************************************

		vm.loadConferenceList = function() {
			vm.isLoading = true;

			HttpSvc.get('conferences/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.conferenceList = result;

					if(vm.conferenceList.length > 0)
					{
						vm.selectedConference = vm.conferenceList[0];
						vm.selectedConferenceChanged();
					}
					
					vm.selectedSource = vm.sources[vm.sources.length-1];
					vm.selectedSourceChanged();

					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}
		vm.sources = [
			{
				description: "China-Malaysia AgriFood",
				sourceTag: "CHINA",
				sourceTagPrefix: "CH",
			},
			{
				description: "DBKL",
				sourceTag: "DBKL",
				sourceTagPrefix: "KL",
			},
			{
				description: "FAMA",
				sourceTag: "FAMA",
				sourceTagPrefix: "FA",
			},
			{
				description: "HIJRAH",
				sourceTag: "HIJRAH",
				sourceTagPrefix: "HH",
			},
			{
				description: "SME CORP",
				sourceTag: "SMECORP",
				sourceTagPrefix: "SC",
			},
			{
				description: "SME WANITA",
				sourceTag: "SMEWANITA",
				sourceTagPrefix: "SW",
			},
			{
				description: "TEKUN",
				sourceTag: "TEKUN",
				sourceTagPrefix: "TK",
			},
			{
				description: "Special Invitation / Others",
				sourceTag: "SPECIAL",
				sourceTagPrefix: "SP",
			},
		];

		/* ******************************************************************** */
	
		vm.selectedConferenceChanged = function() {
			vm.attendee.conferenceId = vm.selectedConference.id;
		}

		vm.selectedSourceChanged = function() {
			vm.attendee.sourceTag = vm.selectedSource.sourceTag;
			vm.attendee.sourceTagPrefix = vm.selectedSource.sourceTagPrefix;
		}

		/* ******************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('conferenceattendees/register', vm.attendee, Auth.getTokenId(), false)
					.then(function(result) {
						//vm.printLabel(result.id, true);
						toastr.success('Registration successfully. Print instruction has been sent to printer.', Auth.translate('SUCCESS'));
						$state.go('conference.attendeemgmt.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.printLabel = function(attendeeId, toGoBack) {
			HttpSvc.post('conferenceattendees/print/' + attendeeId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					if(toGoBack)
					{
						toastr.success('Registration successfully. Print instruction has been sent to printer.', Auth.translate('SUCCESS'));
						$state.go('conference.attendeemgmt.list');
					} 
					else
					{
						toastr.success('Print instruction has been sent to printer.', Auth.translate('SUCCESS'));
					}
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
		
		// Call Action
		vm.loadConferenceList();
	}

	/** @ngInject */
	function ConferenceAttendeeMgmtUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.attendee = {};
		vm.sources = [];
		vm.conferenceList = [];
		vm.selectedSource = null;
		vm.selectedConference = null;
		
		// *********************************************************
		
		vm.sources = [
			{
				description: "China-Malaysia AgriFood",
				sourceTag: "CHINA",
				sourceTagPrefix: "CH",
			},
			{
				description: "DBKL",
				sourceTag: "DBKL",
				sourceTagPrefix: "KL",
			},
			{
				description: "FAMA",
				sourceTag: "FAMA",
				sourceTagPrefix: "FA",
			},
			{
				description: "HIJRAH",
				sourceTag: "HIJRAH",
				sourceTagPrefix: "HH",
			},
			{
				description: "SME CORP",
				sourceTag: "SMECORP",
				sourceTagPrefix: "SC",
			},
			{
				description: "SME WANITA",
				sourceTag: "SMEWANITA",
				sourceTagPrefix: "SW",
			},
			{
				description: "TEKUN",
				sourceTag: "TEKUN",
				sourceTagPrefix: "TK",
			},
			{
				description: "Special Invitation / Speaker",
				sourceTag: "SPECIAL",
				sourceTagPrefix: "SP",
			},
		];

		vm.loadConferenceList = function() {
			vm.isLoading = true;

			HttpSvc.get('conferences/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.conferenceList = result;
					vm.loadData();
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.loadData = function() {
			vm.isLoading = true;

			HttpSvc.get('conferenceattendees/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.attendee = result;

					vm.conferenceList.forEach(function(c) {
						if(c.id==vm.attendee.conferenceId) {
							vm.selectedConference = c;
						}
					});

					vm.sources.forEach(function(s) {
						if(s.sourceTag==vm.attendee.sourceTag) {
							vm.selectedSource = s;
						}
					});

					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ******************************************************************** */
	
		vm.selectedConferenceChanged = function() {
			vm.attendee.conferenceId = vm.selectedConference.id;
		}

		vm.selectedSourceChanged = function() {
			vm.attendee.sourceTag = vm.selectedSource.sourceTag;
			vm.attendee.sourceTagPrefix = vm.selectedSource.sourceTagPrefix;
		}

		/* ******************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('conferenceattendees/' + $stateParams.id, vm.attendee, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Update successfully.", 'Update');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadConferenceList();
	}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.assetconfigs.eqtypes.controller', [])
        .controller('EqTypeMainCtrl', EqTypeMainCtrl)
        .controller('EqTypeCreateCtrl', EqTypeCreateCtrl)
        .controller('EqTypeUpdateCtrl', EqTypeUpdateCtrl);

    /** @ngInject */
    function EqTypeMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.typeDataFull = [];
		vm.typeData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.typeDataFull, tableState.search.predicateObject) : vm.typeDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.typeData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.typeDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('equipmenttypes/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.typeDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteType = function(typeId, typeName) {
			var params = {};
			HttpSvc.delete('equipmenttypes/' + typeId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('equipmenttypes/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.typeDataFull = result;
							
							toastr.success('The Equipment Type [' + typeName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Equipment Type [' + typeName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function EqTypeCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.type = {};	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('equipmenttypes', vm.type, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Equipment Type has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('assetconfigs.eqtypes.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function EqTypeUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.type = {};
						
		// Load EqType
		vm.loadType = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('equipmenttypes/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.type = result;
				}, function() {
					toastr.error('Failed to load selected Equipment Type.', Auth.translate('ERROR'))
					$state.go('assetconfigs.eqtypes.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('equipmenttypes/' + $stateParams.id, vm.type, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Equipment Type has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('assetconfigs.eqtypes.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadType();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.conference.datadownload.controller', [])
        .controller('ConferenceDataDownloadCreateCtrl', ConferenceDataDownloadCreateCtrl);
	
	/** @ngInject */
    function ConferenceDataDownloadCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.activeTab = 0;
		vm.conferenceList = [];
		vm.selectedConference = null;
		vm.startColumn = "A";
		vm.endColumn = "H";
		vm.isLoading = false;
		
		// *********************************************************

		vm.loadConferenceList = function() {
			vm.isLoading = true;

			HttpSvc.get('conferences/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.conferenceList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		// *********************************************************

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.isLoading = true;

				if(vm.activeTab == 0)
				{
					HttpSvc.post('conferences/importfromgoogle/' + vm.selectedConference.id + '/' + vm.startColumn + '/' + vm.endColumn, {}, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Data has been downloaded and imported successfully. ' + result.message, Auth.translate('SUCCESS'));
							vm.isLoading = false;
						}, function(error) {
							vm.isLoading = false;
							toastr.error("There are some errors during import. " + error.message, 'Failed');
						});
				} 
				else if(vm.activeTab == 1)
				{
					HttpSvc.post('conferences/sendSmsShortCode/' + vm.selectedConference.id, {}, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('SMS Short Code has been sent. ' + result.message, Auth.translate('SUCCESS'));
							vm.isLoading = false;
						}, function(error) {
							vm.isLoading = false;
							toastr.error("There are some errors while sending SMS. " + error.message, 'Failed');
						});
				}
			}
		}
		
		// Call Action
		vm.loadConferenceList();
	}	
})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.conference.prospectmgmt.controller', [])
			.controller('ConferenceProspectMgmtMainCtrl', ConferenceProspectMgmtMainCtrl)
			.controller('ConferenceProspectMgmtUpdateCtrl', ConferenceProspectMgmtUpdateCtrl);

	/** @ngInject */
	function ConferenceProspectMgmtMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.conferenceList = [];
		vm.attendeeDataFull = [];
		vm.attendeeData = [];
		vm.isLoading = false;
		vm.selectedConference = {};
		vm.selectedConference.id = "";
		vm.serverMode = Auth.getServerMode();
		vm.rootUrl = (vm.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);

		// *****************************************************

		vm.loadConferenceList = function() {
			vm.isLoading = true;

			HttpSvc.get('conferences/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.conferenceList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		// *****************************************************

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.attendeeDataFull, tableState.search.predicateObject) : vm.attendeeDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.attendeeData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.conferenceList.length==0) {
				vm.isLoading = true;
	
				HttpSvc.get('conferences/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.conferenceList = result;
						
						if(vm.conferenceList.length > 0) {
							vm.selectedConference = vm.conferenceList[0];
						}
						
						if(vm.attendeeDataFull.length <= 0) {	
							vm.isLoading = true;
			
							HttpSvc.get('conferenceattendees/listing/prospects/' + vm.selectedConference.id, params, Auth.getTokenId(), true)
								.then(function(result) {	
									vm.numOfRecord = result.length;	
									vm.attendeeDataFull = result;		
									refreshTableState(tableState, vm.startIndex, vm.endIndex);
									vm.isLoading = false;
								}, function() {
									vm.isLoading = false;
									toastr.error('Failed to retrieve data.', '');
									return null;
							});
						} else {
							refreshTableState(tableState, vm.startIndex, vm.endIndex);
						}
					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Failed');
					});
			}
			else 
			{
				if(vm.attendeeDataFull.length <= 0) {	
					vm.isLoading = true;
	
					HttpSvc.get('conferenceattendees/listing/prospects/' + vm.selectedConference.id, params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;	
							vm.attendeeDataFull = result;		
							refreshTableState(tableState, vm.startIndex, vm.endIndex);
							vm.isLoading = false;
						}, function() {
							vm.isLoading = false;
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				} else {
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}	
			}

			
		};
	};

	/** @ngInject */
	function ConferenceProspectMgmtUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.attendee = {};
		vm.sources = [];
		vm.conferenceList = [];
		vm.selectedSource = null;
		vm.selectedConference = null;
		
		// *********************************************************
		
		vm.sources = [
			{
				description: "China-Malaysia AgriFood",
				sourceTag: "CHINA",
				sourceTagPrefix: "CH",
			},
			{
				description: "DBKL",
				sourceTag: "DBKL",
				sourceTagPrefix: "KL",
			},
			{
				description: "FAMA",
				sourceTag: "FAMA",
				sourceTagPrefix: "FA",
			},
			{
				description: "HIJRAH",
				sourceTag: "HIJRAH",
				sourceTagPrefix: "HH",
			},
			{
				description: "SME CORP",
				sourceTag: "SMECORP",
				sourceTagPrefix: "SC",
			},
			{
				description: "SME WANITA",
				sourceTag: "SMEWANITA",
				sourceTagPrefix: "SW",
			},
			{
				description: "TEKUN",
				sourceTag: "TEKUN",
				sourceTagPrefix: "TK",
			},
			{
				description: "Special Invitation / Speaker",
				sourceTag: "SPECIAL",
				sourceTagPrefix: "SP",
			},
		];

		vm.loadConferenceList = function() {
			vm.isLoading = true;

			HttpSvc.get('conferences/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.conferenceList = result;
					vm.loadData();
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.loadData = function() {
			vm.isLoading = true;

			HttpSvc.get('conferenceattendees/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.attendee = result;

					vm.conferenceList.forEach(function(c) {
						if(c.id==vm.attendee.conferenceId) {
							vm.selectedConference = c;
						}
					});

					vm.sources.forEach(function(s) {
						if(s.sourceTag==vm.attendee.source) {
							vm.selectedSource = s;
						}
					});

					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ******************************************************************** */
	
		vm.selectedConferenceChanged = function() {
			vm.attendee.conferenceId = vm.selectedConference.id;
		}

		vm.selectedSourceChanged = function() {
			vm.attendee.sourceTag = vm.selectedSource.sourceTag;
			vm.attendee.sourceTagPrefix = vm.selectedSource.sourceTagPrefix;
		}

		/* ******************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('conferenceattendees/' + $stateParams.id, vm.attendee, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Update successfully.", 'Update');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadConferenceList();
	}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.bulkbreakjobs.bbanalysis.controller', [])
        .controller('BulkBreakAnalysisMainCtrl', BulkBreakAnalysisMainCtrl)		
        .controller('BulkBreakAnalysisSalesOrderModalCtrl', BulkBreakAnalysisSalesOrderModalCtrl);

    /** @ngInject */
    function BulkBreakAnalysisMainCtrl($scope, $filter, $state, $q, $uibModal, $interval, Auth, baSidebarService, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;		
		vm.branchId = Auth.getBranchId();
		vm.lockButtons = false;
		vm.analysisDataFull = [];
		vm.summaryDataFull = [];
		vm.selectedEntries = [];
		vm.timeTaken = 0;
		vm.startDate = new Date();
		vm.startDate = new Date(vm.startDate.setDate(vm.startDate.getDate()));
		vm.startDate = $filter('date')(vm.startDate, 'yyyy-MM-dd');
		vm.endDate = new Date();
		vm.endDate.setDate(vm.endDate.getDate() + 7)
		vm.endDate = $filter('date')(vm.endDate, 'yyyy-MM-dd');
		vm.isLoading = false;
		
		/* ************************************************** */
		
		vm.viewSalesOrders = function (salesOrderList) {
			vm.movements = [];
			
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'jaSalesOrderModal.html',
				controller: 'BulkBreakAnalysisSalesOrderModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							salesOrderList: salesOrderList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};	
		
		/* ************************************************** */
					
		// Select All Products
		vm.selectAll = function() {
			vm.selectedEntries = [];
			vm.summaryDataFull.forEach( function(p) {
				if(p.recommendedJobQuantity>0) {
					vm.selectedEntries.push(p);					
				}
			});
		};
						
		// De-select All Products
		vm.deselectAll = function() {
			vm.selectedEntries = [];
		};
		
		/* ************************************************** */

		// Load Job Analysis
		vm.loadAnalysis = function() {
			vm.isLoading = true;

			vm.timeTaken = 0;
			vm.timerTick();
			vm.interval = $interval(vm.timerTick, 1000);
			

			HttpSvc.post('bulkbreakanalysis/' + vm.branchId + '/'+vm.startDate+'/'+vm.endDate, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					vm.analysisDataFull = result.bbaList;
					vm.summaryDataFull = result.bbaListSummary;
					vm.tableForm.$show();
					$interval.cancel(vm.interval);
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, Auth.translate('ERROR'));
					$interval.cancel(vm.interval);
					return null;
				});
		};	
		
		// Validate Input
		vm.checkValue = function(productId, value) {
			if(isNaN(value)){
				return "Enter numbers only!";
			} else if (parseInt(value)<1) {
				return "Must be greater than Zero!";
			}  else if (!parseInt(value)) {
				return "Enter integer only!";
			}
		};
		
		// Validate Form
		vm.formHasError = function() {
			var totalErrorCount = 0;
			
			vm.tableForm.$editables.forEach(function(field) {
				if(field.error!="") totalErrorCount += 1;
			});
			
			return (totalErrorCount>0) ? true : false;
		}
		
		// Refresh Page
		vm.refreshPage = function() {
			vm.loadAnalysis();
			//$state.reload();
		}
		
		// Generate Jobs
		vm.generateJobs = function() {
			vm.tableForm.$submit();
						
			if(vm.formHasError()) {
				vm.tableForm.$show();
				toastr.error('Please enter the correct value(s).', Auth.translate('ERROR'));
			} else { 			
				vm.lockButtons = true;
				
				HttpSvc.post('bulkbreakjobs/batchcreation', vm.selectedEntries, Auth.getTokenId(), true)
					.then(function(result) {
						toastr.success('Bulk-Break Jobs creation has been completed.', Auth.translate('SUCCESS'));
						vm.refreshPage();
					}, function(error) {
						vm.lockButtons = false;
						vm.tableForm.$show();
						toastr.error(error, 'Failed');
					});
			}
		};

		vm.timerTick = function() {
			vm.timeTaken += 1;
		}
				
		vm.initData = function() {
			vm.loadAnalysis();
		}
		
		// Call Action
		vm.initData();
	};

	/** @ngInject */
	function BulkBreakAnalysisSalesOrderModalCtrl($uibModalInstance, $filter, $sce, Auth, item, toastr) {
		var $mdl = this;
		$mdl.salesOrderList = item.salesOrderList;
		
		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfRecordFiltered = 0;
		$mdl.numOfRecordDisplayed = 0;
		$mdl.startIndex = 0; 
		$mdl.endIndex = 0;
		$mdl.salesDataFull = [];
		$mdl.salesData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.salesDataFull, tableState.search.predicateObject) : $mdl.salesDataFull;
			$mdl.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			$mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
			$mdl.salesData = result;
			
			tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		$mdl.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.
						
			if($mdl.salesDataFull.length <= 0) {
				$mdl.numOfRecord = item.salesOrderList.length;	
				$mdl.salesDataFull = item.salesOrderList;
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);	
			} else {
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
			}
		};		
		
		// ********************************************************		
		
		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.dashboard')
		.controller('AfterSalesWorkOrderClockCtrl', AfterSalesWorkOrderClockCtrl)
		.controller('AfterSalesWorkOrderPersonalCtrl', AfterSalesWorkOrderPersonalCtrl)
		.controller('AfterSalesWorkOrderOpenJobsCtrl', AfterSalesWorkOrderOpenJobsCtrl)
		.controller('AfterSalesWorkOrderStatisticCtrl', AfterSalesWorkOrderStatisticCtrl);

	/** @ngInject */
	function AfterSalesWorkOrderClockCtrl($scope, $filter, $timeout) {
		$scope.currentDate = "";
		$scope.currentTime = "";
		
		$scope.showDate = function() {			
			$scope.currentDate = $filter('date')(new Date(), 'd MMMM yyyy (EEEE)');
		}
		
		$scope.showTime = function() {
			$timeout(function(){
				$scope.currentTime = $filter('date')(new Date(), 'hh:mm:ss a');
				$scope.showTime();
			},1000);			
		}

		$scope.showDate();
		$scope.showTime();
	};

	/** @ngInject */
	function AfterSalesWorkOrderPersonalCtrl($scope, $filter, $timeout) {
	};

	/** @ngInject */
	function AfterSalesWorkOrderOpenJobsCtrl($scope, baConfig) {
		
		var layoutColors = baConfig.colors;
		$scope.colors = [
			layoutColors.warning, 
			layoutColors.success, 
			layoutColors.info, 
			layoutColors.primary, 
			layoutColors.danger, 
			layoutColors.primaryDark
		];
		$scope.areaData = [			
			{y: "2018-01", a: 3, b: 23},
			{y: "2018-02", a: 8, b: 16},
			{y: "2018-03", a: 5, b: 21},
			{y: "2018-04", a: 11, b: 19},
			{y: "2018-05", a: 9, b: 34},
			{y: "2018-06", a: 6, b: 12},
			{y: "2018-07", a: 10, b: 18},
			{y: "2018-08", a: 5, b: 22},
			{y: "2018-09", a: 8, b: 20},
			{y: "2018-10", a: 7, b: 14},
			{y: "2018-11", a: 0, b: 0},
			{y: "2018-12", a: 0, b: 0}
		];
		$scope.lineColors = ['orange','grey'];
	};
	
	/** @ngInject */
	function AfterSalesWorkOrderStatisticCtrl(baConfig, layoutPaths) {
	}
})();

(function () {
	'use strict';

	angular.module('RmsAppV2.pages.dashboard')
		.directive('afterSalesWorkOrderClock', afterSalesWorkOrderClock)
		.directive('afterSalesWorkOrderPersonal', afterSalesWorkOrderPersonal)
		.directive('afterSalesWorkOrderOpenJobs', afterSalesWorkOrderOpenJobs)
		.directive('afterSalesWorkOrderStatistic', afterSalesWorkOrderStatistic);
	
	/** @ngInject */
	function afterSalesWorkOrderClock() {
		return {
			restrict: 'E',
			controller: 'AfterSalesWorkOrderClockCtrl',
			templateUrl: 'app/pages/dashboard/aftersales/workOrderClock.html'
		};
	};
	
	/** @ngInject */
	function afterSalesWorkOrderPersonal() {
		return {
			restrict: 'E',
			controller: 'AfterSalesWorkOrderPersonalCtrl',
			templateUrl: 'app/pages/dashboard/aftersales/workOrderPersonal.html'
		};
	};
	
	/** @ngInject */
	function afterSalesWorkOrderOpenJobs() {
		return {
			restrict: 'E',
			controller: 'AfterSalesWorkOrderOpenJobsCtrl',
			templateUrl: 'app/pages/dashboard/aftersales/workOrderOpenChart.html'
		};
	};
	
	/** @ngInject */
	function afterSalesWorkOrderStatistic() {
		return {
			restrict: 'E',
			controller: 'AfterSalesWorkOrderStatisticCtrl',
			templateUrl: 'app/pages/dashboard/aftersales/workOrderStatistic.html'
		};
	};
	
})();
(function() {
    'use strict';

    angular.module('RmsAppV2.pages.assetconfigs.eqcategories.controller', [])
        .controller('EqCategoryMainCtrl', EqCategoryMainCtrl)
        .controller('EqCategoryCreateCtrl', EqCategoryCreateCtrl)
        .controller('EqCategoryUpdateCtrl', EqCategoryUpdateCtrl);

    /** @ngInject */
    function EqCategoryMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.categoryDataFull = [];
		vm.categoryData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.categoryDataFull, tableState.search.predicateObject) : vm.categoryDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.categoryData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.categoryDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('equipmentcategories/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.categoryDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteCategory = function(categoryId, categoryName) {
			var params = {};
			HttpSvc.delete('equipmentcategories/' + categoryId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('equipmentcategories/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.categoryDataFull = result;
							
							toastr.success('The category [' + categoryName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the category [' + categoryName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function EqCategoryCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.category = {};	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('equipmentcategories', vm.category, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Category has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('assetconfigs.eqcategories.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function EqCategoryUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.category = {};
						
		// Load EqCategory
		vm.loadCategory = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('equipmentcategories/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.category = result;
				}, function() {
					toastr.error('Failed to load selected Category.', Auth.translate('ERROR'))
					$state.go('assetconfigs.eqcategories.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('equipmentcategories/' + $stateParams.id, vm.category, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Category has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('assetconfigs.eqcategories.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadCategory();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.bulkbreakjobs.bblist.controller', [])
        .controller('BulkBreakJobMainCtrl', BulkBreakJobMainCtrl)
        .controller('BulkBreakJobCreateCtrl', BulkBreakJobCreateCtrl)
        .controller('BulkBreakJobUpdateCtrl', BulkBreakJobUpdateCtrl)
        .controller('BulkBreakJobPrintModalCtrl', BulkBreakJobPrintModalCtrl)
        .controller('BulkBreakJobLabelModalCtrl', BulkBreakJobLabelModalCtrl);

    /** @ngInject */
    function BulkBreakJobMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
				
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.jobDataFull = [];
		vm.jobData = [];
		vm.selectedJobs = [];
		vm.isLoading = false;
		vm.showCjsPanel = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.jobDataFull, tableState.search.predicateObject) : vm.jobDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.jobData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.jobDataFull.length <= 0) {
				vm.isLoading = true;

				HttpSvc.get('bulkbreakjobs/list', {}, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.isLoading = false;
						vm.numOfRecord = result.length;	
						vm.jobDataFull = result;
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};
		
		/* ************************************************************* */
		
		vm.showLabelModal = function (item) {
			
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'labelModal.html',
				controller: 'BulkBreakJobLabelModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							jobId: item.id,
							jobNo: item.jobNo,
							productType: item.productType,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};
				
		/* ************************************************************* */
		
		vm.printJobSheet = function(jobId, jobNo) {
			
			var filename = "JOBSHEET_" + jobNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('bulkbreakjobs/print/' + jobId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to generate Job Sheet. ' + error, '');
							return null;
						});
		}
		
		vm.printYieldReport = function(jobId, jobNo) {
			
			var filename = "YIELD_REPORT_" + jobNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('bulkbreakjobs/print/yield/' + jobId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to generate Yield Report. ' + error, '');
							return null;
						});
		}
	}
	
	/** @ngInject */
    function BulkBreakJobCreateCtrl($scope, $state, $filter, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.job = {};
		vm.ym = {};
		vm.jobStatuses = GetJobStatuses();
		vm.selectedStatus = vm.jobStatuses[0];
		vm.originalStatus = vm.selectedStatus.id;
		vm.usergroupList = [];
		vm.sourceItemList = [];
		vm.ymList = [];
		vm.selectedSourceItem = null;
		vm.lockButtons = false;
		
		/* ************************************************************** */

		// Set Default Job Date
		vm.setDefault = function() {
			vm.job.jobDate = $filter('date')(new Date(), 'yyyy-MM-dd hh:mmA');
			vm.job.status = vm.selectedStatus.id;
			vm.job.quantity = 1;
			vm.lockButtons = false;
			
			vm.loadSourceItemList();
		}	
		
		// Load Source Item List
		vm.loadSourceItemList = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('yieldmanagements/list/sourceitems', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.sourceItemList = result;	
					vm.loadUsergroupList();
				}, function(error) {
					vm.lockButtons = false;
					vm.ymList = [];
					toastr.error(error, 'Failed');
				});
		}
		
		// Load Usergroup List
		vm.loadUsergroupList = function() {
			HttpSvc.get('usergroups/list/production', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function(u){
						if(u.isSuperAdmin) {
							if(Auth.isSuperAdmin()){
								vm.usergroupList.push({ id: u.id, name: u.name });
							}
						} else {
							vm.usergroupList.push({ id: u.id, name: u.name });
						}
					});
					vm.lockButtons = false;	
				}, function(error) {
					vm.lockButtons = false;
					vm.usergroupList = [];
					toastr.error(error, 'Failed');
				});
		};
		
		// Load Yield Management List
		vm.loadYieldManagementList = function() {
			vm.lockButtons = true;

			HttpSvc.get('yieldmanagements/list/bysourceitemid/' + vm.selectedSourceItem.sourceItemId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.ymList = result;	
					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					vm.ymList = [];
					toastr.error(error, 'Failed');
				});
		}
		
		// Load Yield Management
		vm.loadYieldManagement = function() {
			if(vm.job.yieldMgmtId==null) return;
			
			vm.lockButtons = true;

			HttpSvc.get('yieldmanagements/' + vm.job.yieldMgmtId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.ym = result;
					vm.job.yieldMgmtId = result.id;
					vm.job.yieldMgmtId = result.id;
					vm.job.itemType = result.itemType;
					vm.job.itemName = result.itemName;
					vm.job.itemId = result.itemId;
					vm.job.semiFinishedProductId = result.semiFgId;
					vm.job.productId = result.productId;
					vm.job.uomId = result.uomId;
					vm.job.uomName = result.uomName;
					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		};

		/* ************************************************************** */

		// Select Job Status
		vm.selectedStatusChanged = function() {
			vm.job.status = vm.selectedStatus.id;
		};

		// Select Source Item Change
		vm.selectedSourceItemChanged = function() {
			vm.job.itemId = vm.selectedSourceItem.itemId;
			vm.job.semiFinishedProductId = vm.selectedSourceItem.semiFgId;
			vm.job.productId = vm.selectedSourceItem.productId;

			vm.ym = {};
			vm.job.yieldMgmtId = null;
			vm.job.itemType = null;
			vm.job.itemName = null;
			vm.job.itemId = null;
			vm.job.semiFinishedProductId = null;
			vm.job.productId = null;
			vm.job.uomId = null;
			vm.job.uomName = null;

			vm.loadYieldManagementList();
		}

		// Select Yield Management Change
		vm.selectedYmChanged = function() {
			if(vm.selectedYm==null) return;
			vm.job.yieldMgmtId = vm.selectedYm.id;
			vm.loadYieldManagement();
		};

		// Select Usergroup Goods
		vm.selectedUsergroupChanged = function() {
			vm.job.userGroupId = vm.selectedUsergroup.id;
		};
		
		/* ************************************************************** */

		// Form Submission
		vm.submit = function() {
									
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;
								
				HttpSvc.post('bulkbreakjobs', vm.job, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Bulk-Break Job has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('bulkbreakjobs.bblist.update', {'id': result.id });
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.setDefault();
	}
	
	/** @ngInject */
    function BulkBreakJobUpdateCtrl($scope, $state, $stateParams, $filter, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;	
		vm.mode = 2;
		vm.job = {};
		vm.ym = {};
		vm.jobStatuses = GetJobStatuses();
		vm.selectedStatus = vm.jobStatuses[0];
		vm.originalStatus = vm.selectedStatus.id;
		vm.lockButtons = false;
		vm.usergroupList = [];
		vm.sourceItemList = [];
		vm.ymList = [];
		vm.selectedSourceItem = null;

		/* ************************************************************** */
		
		// Load Source Item List
		vm.loadSourceItemList = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('yieldmanagements/list/sourceitems', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.sourceItemList = result;	
					vm.loadUsergroupList();
				}, function(error) {
					vm.lockButtons = false;
					toastr.error('Failed to load Source Item list. ' + error, Auth.translate('ERROR'));
				});
		}
		
		// Load Usergroup List
		vm.loadUsergroupList = function() {
			HttpSvc.get('usergroups/list/production', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function(u){
						if(u.isSuperAdmin) {
							if(Auth.isSuperAdmin()){
								vm.usergroupList.push({ id: u.id, name: u.name });
							}
						} else {
							vm.usergroupList.push({ id: u.id, name: u.name });
						}
					});
					vm.loadJob();
				}, function(error) {
					vm.lockButtons = false;
					vm.usergroupList = [];
					toastr.error(error, 'Failed');
				});
		};
		
		// Load Bulk-Break Config List
		vm.loadYieldManagementList = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('yieldmanagements/list/bysourceitemid/' + vm.selectedSourceItem.sourceItemId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.ymList = result;

					vm.ymList.forEach(function(b) {
						if(b.id==vm.job.yieldMgmtId){
							vm.selectedYm = b;
							vm.loadYieldManagement();
						}
					});			
					vm.lockButtons = true;
				}, function(error) {
					vm.lockButtons = false;
					vm.ymList = [];
					toastr.error(error, 'Failed');
				});
		}
		
		// Load Yield Management
		vm.loadYieldManagement = function() {
			if(vm.job.yieldMgmtId==null) return;
			
			vm.lockButtons = true;

			HttpSvc.get('yieldmanagements/' + vm.job.yieldMgmtId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.ym = result;
					vm.job.yieldMgmtId = result.id;
					vm.job.yieldMgmtId = result.id;
					vm.job.itemType = result.itemType;
					vm.job.itemName = result.itemName;
					vm.job.itemId = result.itemId;
					vm.job.semiFinishedProductId = result.semiFgId;
					vm.job.productId = result.productId;
					vm.job.uomId = result.uomId;
					vm.job.uomName = result.uomName;
					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		};
		
		// Load Bulk-Break Job
		vm.loadJob = function() {
			vm.lockButtons = true;

			var params = { id: $stateParams.id };
			HttpSvc.get('bulkbreakjobs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.job = result;
					vm.job.jobDate = $filter('date')(vm.job.jobDate, 'yyyy-MM-dd hh:mma');
					vm.job.neededDate = $filter('date')(vm.job.neededDate, 'yyyy-MM-dd');
					vm.originalStatus = vm.job.status;
					
					vm.jobStatuses.forEach(function(js) {
						if(js.id==vm.job.status){
							vm.jobStatuses.selected = js;
						}
					});
					vm.usergroupList.forEach(function(p) {
						if(p.id==vm.job.userGroupId){
							vm.selectedUsergroup = p;
						}
					});
					vm.sourceItemList.forEach(function(s) {
						if(s.itemId==vm.job.itemId &&
							s.semiFgId==vm.job.semiFinishedProductId && 
							s.productId==vm.job.productId)
						{
							vm.selectedSourceItem = s;
							vm.loadYieldManagementList();
						}
					});

					vm.lockButtons = false;
				}, function(error) {
					toastr.error('Failed to load selected Job. ' + error, Auth.translate('ERROR'))
					$state.go('bulkbreakjobs.bblist');
					return;
				});		
		};	

		/* ************************************************************** */

		// Select Job Status
		vm.selectedStatusChanged = function(item) {
			vm.job.status = vm.selectedStatus.id;
		};

		// Select Source Item Change
		vm.selectedSourceItemChanged = function() {
			vm.job.itemId = vm.selectedSourceItem.itemId;
			vm.job.semiFinishedProductId = vm.selectedSourceItem.semiFgId;
			vm.job.productId = vm.selectedSourceItem.productId;

			vm.ym = {};
			vm.job.yieldMgmtId = null;
			vm.job.itemType = null;
			vm.job.itemName = null;
			vm.job.itemId = null;
			vm.job.semiFinishedProductId = null;
			vm.job.productId = null;
			vm.job.uomId = null;
			vm.job.uomName = null;

			vm.loadYieldManagementList();
		}

		// Select Yield Management Change
		vm.selectedYmChanged = function() {
			vm.job.yieldMgmtId = vm.selectedYm.id;
			vm.loadYieldManagement();
		};

		// Select Usergroup Goods
		vm.selectedUsergroupChanged = function() {
			vm.job.userGroupId = vm.selectedUsergroup.id;
		};
		
		/* ************************************************************** */
		
		// Print Jobsheet		
		vm.printJobSheet = function(jobId, jobNo) {
			
			var filename = "JOBSHEET_" + jobNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('bulkbreakjobs/print/' + jobId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to generate Job Sheet. ' + error, '');
							return null;
						});
		}
				
		vm.printJobTrace = function(jobId, jobNo) {
			
			var filename = "JOBTRACE_" + jobNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('bulkbreakjobs/print/trace/' + jobId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to generate Job Traceability Report. ' + error, '');
							return null;
						});
		}
		
		/* ************************************************************** */
		
		// Submit Cancelled Job
		vm.cancelJob = function() {
			vm.job.status = 5;
								 
			HttpSvc.put('bulkbreakjobs/cancel/' + $stateParams.id, vm.job, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Job Status has been updated to CANCELLED.', Auth.translate('SUCCESS'));
						$state.go('bulkbreakjobs.bblist');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
		}
		
		/* ************************************************************** */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {			
				vm.lockButtons = true;
				
				HttpSvc.put('bulkbreakjobs/' + $stateParams.id, vm.job, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Bulk-Break Job has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadSourceItemList();
	}	
	
	// Print Dialog
	function BulkBreakJobPrintModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		var dt = new Date();
		dt.setUTCDate(dt.getUTCDate() + 4 - (dt.getUTCDay()||7));
		var yearStart = new Date(Date.UTC(dt.getUTCFullYear(),0,1));
		var weekNo = Math.ceil(( ( (dt - yearStart) / 86400000) + 1)/7);
	
		$mdl.lockButton = false;
		$mdl.year = dt.getFullYear();
		$mdl.weekNo = weekNo;
		
		/* *************************************************** */
		
		$mdl.addWeek = function(day) {
			$mdl.weekNo += day;
			
			if($mdl.weekNo < 1) {
				$mdl.weekNo = 1;
			} else if($mdl.weekNo > 53) {
				$mdl.weekNo = 53;
			}
		}
		
		/* *************************************************** */
				
		$mdl.printSchedule = function() {
			
			var filename = "SCHEDULE_YR" + $mdl.year + "_WEEK_#" + $mdl.weekNo + ".pdf";
			
			HttpSvc.getPdfObject('bulkbreakjobs/print/schedule/' + $mdl.year + '/' + $mdl.weekNo, Auth.getTokenId(), filename)
				.then(
					function(result) {
						$uibModalInstance.close();
					}, 
					function(error) {
						// Failed
						toastr.error('Failed to generate Production Schedule. ' + error, '');
						return null;
					});
		}
		
		/* *************************************************** */

		$mdl.confirmModal = function() {	
			
			if($mdl.printForm.$valid) {
				$mdl.lockButton = true;
				$mdl.printSchedule();
			}
		};
		
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}	
	
	/** @ngInject */
	function BulkBreakJobLabelModalCtrl($uibModalInstance, $filter, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.item = {};
		$mdl.item.id = item.jobId;
		$mdl.item.jobNo = item.jobNo;
		$mdl.item.productType = item.productType;
		
		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfRecordFiltered = 0;
		$mdl.numOfRecordDisplayed = 0;
		$mdl.startIndex = 0; 
		$mdl.endIndex = 0;
		$mdl.labelDataFull = [];
		$mdl.labelData = [];
		$mdl.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.labelDataFull, tableState.search.predicateObject) : $mdl.labelDataFull;
			$mdl.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			$mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
			$mdl.labelData = result;
			
			tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};		
		
		$mdl.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.
			
			if($mdl.labelDataFull.length <= 0) {
				$mdl.isLoading = true;
				
				var apiUrl = "";
				if($mdl.item.productType=="FG")
				{
					apiUrl = "bulkbreakjobs/fg/" + $mdl.item.id + "/labels";
				}
				else
				{
					apiUrl = "bulkbreakjobs/sfg/" + $mdl.item.id + "/labels";
				}

				HttpSvc.get(apiUrl, {}, Auth.getTokenId(), true)
					.then(function(result) {	
						$mdl.numOfRecord = result.length;	
						$mdl.labelDataFull = result;
						refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
						$mdl.isLoading = false;
					}, function() {
						$mdl.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
			}
		};		
		
		// ********************************************************		
		
		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}

	function GetJobStatuses() {
		var jobStatuses = [ 
			{id: 'NEW', name: 'NEW'}, 
			{id: 'CONFIRMED', name: 'CONFIRMED'}, 
		];
		return jobStatuses;
	}
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.jobs.jobdashboard.controller', [])
        .controller('JobDashboardMainCtrl', JobDashboardMainCtrl)
        .controller('JobDashboardCompleteModalCtrl', JobDashboardCompleteModalCtrl);

    /** @ngInject */
    function JobDashboardMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, baSidebarService, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.jobDataFull = [];
		vm.jobData = [];
		vm.isLoading = false;		
		vm.isProcessing = false;		
		
		vm.initData = function() {			
			vm.loadDashboard();
			baSidebarService.setMenuCollapsed(true);
		};
		
		vm.loadDashboard = function() {
			vm.isLoading = true;
			
			HttpSvc.get('jobs/dashboard', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.isLoading = false;
					vm.numOfRecord = result.length;	
					vm.jobDataFull = result;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		};
		
		vm.startJob = function(jobId, jobNo) {
			vm.isProcessing = true;
			
			HttpSvc.put('jobs/start/'+jobId, {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isProcessing = false;
					vm.reload();
				}, function(error) {
					vm.isProcessing = false;
					toastr.error(error, '');
				});
		};
		
		vm.reload = function() {
			$state.reload();			
		}		
					
		vm.showCompleteJobModal = function (jobId, jobNo, productName, packingQty, packingUom) {
			vm.job = {};
			vm.job.id = jobId;
			vm.job.jobNo = jobNo;
			vm.job.productName = productName;
			vm.job.packingQty = packingQty;
			vm.job.packingUom = packingUom;
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'confirmModal.html',
				controller: 'JobDashboardCompleteModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							object: vm.job
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.reload();
				}, function () {
				});
		};	
		
		vm.printJobSheet = function(jobId, jobNo) {
			
			var filename = "JOBSHEET_" + jobNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('jobs/print/' + jobId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to generate Job Sheet. ' + error, '');
							return null;
						});
		}
		
		// Call Action
		vm.initData();
	};
	
	// Job Complete Modal Controller
	function JobDashboardCompleteModalCtrl($uibModalInstance, $filter, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.item = item.object;
		$mdl.job = {};
		$mdl.isLoading = false;			
		
		$mdl.loadJob = function() {
			$mdl.isLoading = true;
			
			var params = { id: $mdl.item.id };
			HttpSvc.get('jobs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.job = result;
					$mdl.job.jobDate = $filter('date')($mdl.job.jobDate, 'yyyy-MM-dd');
					$mdl.job.neededDate = $filter('date')($mdl.job.jobDate, 'yyyy-MM-dd');
					$mdl.isLoading = false;
				}, function() {
					toastr.error('Failed to load selected Job.', Auth.translate('ERROR'))
					$uibModalInstance.dismiss('cancel');
					$mdl.isLoading = false;
					return;
				});		
		};	
		
		$mdl.confirmModal = function() {
			$mdl.isLoading = false;
			
			if($mdl.confirmForm.$invalid){
				$mdl.isLoading = false;
			} else {
				$mdl.isLoading = true;
				
				$mdl.job.actualProductionQuantity = $mdl.item.actualProductionQuantity;
				$mdl.job.actualDefectQuantity = $mdl.job.estimatedProductionQuantity - $mdl.job.actualProductionQuantity;
				
				if($mdl.job.actualDefectQuantity<0)
					$mdl.job.actualDefectQuantity = 0;
				
				if($mdl.job.actualDefectQuantity == 0) {
					$mdl.job.status = 3;
				} else if($mdl.job.actualDefectQuantity != 0) {
					$mdl.job.status = 4;
				}		
				
				HttpSvc.put('jobs/' + $mdl.item.id, $mdl.job, Auth.getTokenId(), false)
					.then(function(result) {
						$mdl.isLoading = false;
						if($mdl.job.actualDefectQuantity == 0) {
							toastr.success('Job Status has been updated to <b>COMPLETED</b>.', Auth.translate('SUCCESS'));	
						} else if($mdl.job.actualDefectQuantity != 0) {
							toastr.success('Job Status has been updated to <b>COMPLETED (WITH DEFECTS)</b>.', Auth.translate('SUCCESS'));
						}				
						$uibModalInstance.close($mdl.item);	
					}, function(error) {
						$mdl.isLoading = false;
						toastr.error(error, 'Failed');
					});
			}			
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		$mdl.loadJob();
	};	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.assets.assetlist.controller', [])
        .controller('AssetMainCtrl', AssetMainCtrl)
        .controller('AssetCreateCtrl', AssetCreateCtrl)
        .controller('AssetUpdateCtrl', AssetUpdateCtrl)
        .controller('AssetPropertiesModalCtrl', AssetPropertiesModalCtrl);

    /** @ngInject */
    function AssetMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.assetDataFull = [];
		vm.assetData = [];
		vm.debtorList = [];
		vm.equipmentList = [];
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.isLoading = false;
		
		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.assetDataFull, tableState.search.predicateObject) : vm.assetDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.assetData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.assetDataFull.length <= 0) {							
				vm.isLoading = true;
				
				HttpSvc.get('assets/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.assetDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteAsset = function(assetId, assetName) {
			var params = {};
			HttpSvc.delete('assets/' + assetId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('assets/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.assetDataFull = result;
							
							toastr.success('The Asset [<b>' + assetName + '</b>] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Asset [' + assetName + '].', 'Delete Failed');
					return null;
			});
		};	
		
		vm.printAssetLabel = function(assetId) {
			
			HttpSvc.post('assets/label/create/' + assetId, {}, Auth.getTokenId(), false)
				.then(function(result) {
						toastr.success('Label Print instruction has been sent.', Auth.translate('SUCCESS'));
				}, function() {
					// Failed
					toastr.error('Failed to print the Asset label.', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function AssetCreateCtrl($scope, $state, $uibModal, $location, Auth, RmsApi, HttpSvc, toastr) {
		Auth.init();
		
		var vm = this;	
		
		vm.assetStatuses = [
			{ id: 'ACTIVE', name: 'ACTIVE' },
			{ id: 'INACTIVE', name: 'INACTIVE' },
			{ id: 'RETIRED', name: 'RETIRED' },
			{ id: 'SOLD', name: 'SOLD' }
		];
		
		vm.assetTypes = [
			{ id: 'AIR-CON', name: 'AIR-CON' },
			{ id: 'COMPUTER', name: 'COMPUTER' },
			{ id: 'FAX/COPIER', name: 'FAX/COPIER' },
			{ id: 'INSURANCE', name: 'INSURANCE' },
			{ id: 'IT HARDWARE', name: 'IT HARDWARE' },
			{ id: 'LICENSE', name: 'LICENSE' },
			{ id: 'LAND/PROPERTY', name: 'LAND/PROPERTY' },
			{ id: 'MACHINERY/TOOLS', name: 'MACHINERY/TOOLS' },
			{ id: 'ROAD TAX', name: 'ROAD TAX' },
			{ id: 'PRINTER', name: 'PRINTER' },
			{ id: 'PHONE', name: 'PHONE' },
			{ id: 'FIRE EXTINGUISHER', name: 'FIRE EXTINGUISHER' },
			{ id: 'SOFTWARE', name: 'SOFTWARE' },
			{ id: 'TV', name: 'TV' },
			{ id: 'VEHICLE', name: 'VEHICLE' },
			{ id: 'OTHERS', name: 'OTHERS' },
		];
		
		vm.asset = {};
		vm.asset.amAssetProperties = [];	
		vm.asset.technicalDocuments = [];	
		vm.asset.maintenanceSchedules = [];	
		vm.branchList = [];
		vm.supplierList = [];
		vm.equipmentList = [];
		vm.selectedType = null;
		vm.selectedBranch = null;
		vm.selectedSupplier = null;
		vm.selectedEquipment = null;
		vm.isLoading = false;
		vm.lockButtons = false;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
				
		/* ************************************************************* */
		
		vm.beautify = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			newText = newText + "</span>&nbsp;&nbsp;" + item.name.toUpperCase();
			if(item.description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + item.description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";	
			}			
			return newText;
		}
		
		/* ************************************************************* */
		
		vm.initData = function() {
			vm.loadBranchList();
		};
		
		vm.loadBranchList = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.branchList = result;
					vm.loadSupplierList();
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve branch list.', '');
					return null;
				});
		};
		
		vm.loadSupplierList = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('suppliers/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.supplierList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve supplier list.', '');
					return null;
				});
		};
		
		vm.loadEquipmentList = function(searchString) {
			vm.lockButtons = true;
			
			HttpSvc.get('equipments/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.equipmentList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve equipment list.', '');
					return null;
				});
		};
		
		/* ************************************************************* */
				
		// Branch selection changed
		vm.selectedBranchChanged = function() {
			vm.asset.branchId = vm.selectedBranch.id;
		};
		
		// Supplier selection changed
		vm.selectedSupplierChanged = function() {
			vm.asset.supplierId = vm.selectedSupplier.id;
		};
		
		// Equipment selection changed
		vm.selectedEquipmentChanged = function() {
			vm.asset.equipmentId = vm.selectedEquipment.id;
		};
		
		// Type selection changed
		vm.selectedTypeChanged = function() {
			vm.asset.type = vm.selectedType.id;
		};
		
		// Status selection changed
		vm.selectedStatusChanged = function() {
			vm.asset.status = vm.selectedStatus.id;
		};
		
		/* ************************************************************* */

		// Refresh Properties
		vm.refreshProperties = function(tableState) {
			// Do nothing
		};	
		
		/* ************************************************************* */
			
		// Open Modal Dialog
		vm.prop = {};		
		vm.showAddPropModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'propModal.html',
				controller: 'AssetPropertiesModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.prop,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addProp(data);
				}, function () {
				});
		};	
		
		vm.showEditPropModal = function (index) {
			vm.prop = vm.asset.amAssetProperties[index];
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'propModal.html',
				controller: 'AssetPropertiesModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.prop,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateProp(index, data);
				}, function () {
				});
		};				
		
		/* ************************************************************* */
		
		// Remove Properties
		vm.removeProp = function(index) {
			vm.asset.amAssetProperties.splice(index, 1);
		};
			
		// Update Properties
		vm.updateProp = function(index, obj) {
			var element = {
				name: obj.name,
				value: obj.value,
			};
			vm.asset.amAssetProperties.splice(index, 1, element);
		};

		// Add Properties
		vm.addProp = function(obj) {
			var element = {
				name: obj.name,
				value: obj.value,
			};
			vm.asset.amAssetProperties.push(element);
		};
		
		/* ************************************************************* */
				
		// Form Submission
		vm.submit = function() {
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('assets', vm.asset, Auth.getTokenId(), false)
					.then(function(result) {						
						toastr.success('Asset has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('assets.assetlist.update', {'id': result.id });
						
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function AssetUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, RmsApi, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;		
		
		vm.assetStatuses = [
			{ id: 'ACTIVE', name: 'ACTIVE' },
			{ id: 'INACTIVE', name: 'INACTIVE' },
			{ id: 'RETIRED', name: 'RETIRED' },
			{ id: 'SOLD', name: 'SOLD' }
		];
		
		vm.assetTypes = [
			{ id: 'AIR-CON', name: 'AIR-CON' },
			{ id: 'COMPUTER', name: 'COMPUTER' },
			{ id: 'FAX/COPIER', name: 'FAX/COPIER' },
			{ id: 'INSURANCE', name: 'INSURANCE' },
			{ id: 'IT HARDWARE', name: 'IT HARDWARE' },
			{ id: 'LICENSE', name: 'LICENSE' },
			{ id: 'LAND/PROPERTY', name: 'LAND/PROPERTY' },
			{ id: 'MACHINERY/TOOLS', name: 'MACHINERY/TOOLS' },
			{ id: 'ROAD TAX', name: 'ROAD TAX' },
			{ id: 'PRINTER', name: 'PRINTER' },
			{ id: 'PHONE', name: 'PHONE' },
			{ id: 'FIRE EXTINGUISHER', name: 'FIRE EXTINGUISHER' },
			{ id: 'SOFTWARE', name: 'SOFTWARE' },
			{ id: 'TV', name: 'TV' },
			{ id: 'VEHICLE', name: 'VEHICLE' },
			{ id: 'OTHERS', name: 'OTHERS' },
		];
		
		vm.asset = {};
		vm.equipment = {};				
		vm.branchList = [];
		vm.supplierList = [];
		vm.equipmentList = [];
		vm.changeLogs = [];
		vm.selectedType = null;
		vm.selectedBranch = null;
		vm.selectedSupplier = null;
		vm.selectedEquipment = null;
		vm.isLoading = false;
		vm.lockButtons = false;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
								
		/* ************************************************************* */
		
		vm.beautify = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			newText = newText + "</span>&nbsp;&nbsp;" + item.name.toUpperCase();
			if(item.description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + item.description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";	
			}			
			return newText;
		}
		
		/* ************************************************************* */
		
		vm.initData = function() {
			vm.loadBranchList();
		};
		
		vm.loadBranchList = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					result.forEach(function(r) {
						vm.branchList.push({ id: r.id, name: r.name });
					});	
					vm.loadSupplierList();
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve branch list.', '');
					return null;
				});
		};
		
		vm.loadSupplierList = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('suppliers/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					result.forEach(function(r) {
						vm.supplierList.push({ id: r.id, name: r.name });
					});	
					vm.loadAsset();
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve supplier list.', '');
					return null;
				});
		};
		
		vm.loadEquipmentList = function(searchString) {
			vm.lockButtons = true;
			
			HttpSvc.get('equipments/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.equipmentList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve equipment list.', '');
					return null;
				});
		};
		
		/* ************************************************************* */
						
		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('amassetchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};

		// Load Asset
		vm.loadAsset = function() {	
			vm.lockButtons = true;
		
			HttpSvc.get('assets/'+$stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.asset = result;	
					
					vm.assetTypes.forEach(function(r) {
						if(r.id==vm.asset.type) {
							vm.selectedType = r;
						}
					});					
					vm.assetStatuses.forEach(function(r) {
						if(r.id==vm.asset.status) {
							vm.selectedStatus = r;
						}
					});					
					vm.branchList.forEach(function(r) {
						if(r.id==vm.asset.branchId) {
							vm.selectedBranch = r;
						}
					});
					vm.supplierList.forEach(function(r) {
						if(r.id==vm.asset.supplierId) {
							vm.selectedSupplier = r;
						}
					});	
						
					// Asset with Warranty Info - From FNB
					if(vm.asset.warrantyId==null) {
						vm.equipmentList = [];
						vm.equipmentList.push({ id: vm.asset.equipmentId, code: vm.asset.equipmentCode, name: vm.asset.equipmentName });
						vm.selectedEquipment = vm.equipmentList[0];
					} else {						
						HttpSvc.get('equipments/' + vm.asset.equipmentId, {}, Auth.getTokenId(), false)
							.then(function(result) {	
								vm.selectedEquipment = result;
							}, function() {
							});	
					}
					
					vm.lockButtons = false;

					vm.loadChangeLogs();
					
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to load selected Asset', Auth.translate('ERROR'))
					$state.go('assets.assetlist');
					return;
				});		
		};	
		
		/* ************************************************************* */
				
		// Branch selection changed
		vm.selectedBranchChanged = function() {
			vm.asset.branchId = vm.selectedBranch.id;
		};
		
		// Supplier selection changed
		vm.selectedSupplierChanged = function() {
			vm.asset.supplierId = vm.selectedSupplier.id;
		};
		
		// Equipment selection changed
		vm.selectedEquipmentChanged = function() {
			vm.asset.equipmentId = vm.selectedEquipment.id;
		};
		
		// Type selection changed
		vm.selectedTypeChanged = function() {
			vm.asset.type = vm.selectedType.id;
		};
		
		// Status selection changed
		vm.selectedStatusChanged = function() {
			vm.asset.status = vm.selectedStatus.id;
		};
		
		/* ************************************************************* */
			
		// Open Modal Dialog
		vm.prop = {};		
		vm.showAddPropModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'propModal.html',
				controller: 'AssetPropertiesModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.prop,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addProp(data);
				}, function () {
				});
		};	
		
		vm.showEditPropModal = function (index) {
			vm.prop = vm.asset.amAssetProperties[index];
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'propModal.html',
				controller: 'AssetPropertiesModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.prop,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateProp(index, data);
				}, function () {
				});
		};				
		
		/* ************************************************************* */
		
		// Remove Properties
		vm.removeProp = function(index) {
			vm.asset.amAssetProperties.splice(index, 1);
		};
			
		// Update Properties
		vm.updateProp = function(index, obj) {
			var element = {
				name: obj.name,
				value: obj.value,
			};
			vm.asset.amAssetProperties.splice(index, 1, element);
		};

		// Add Properties
		vm.addProp = function(obj) {
			var element = {
				name: obj.name,
				value: obj.value,
			};
			vm.asset.amAssetProperties.push(element);
		};
		
		/* ************************************************************* */	
		
		vm.printAssetLabel = function(assetId) {
			
			HttpSvc.post('assets/label/create/' + assetId, {}, Auth.getTokenId(), false)
				.then(function(result) {
						toastr.success('Label Print instruction has been sent.', Auth.translate('SUCCESS'));
				}, function() {
					// Failed
					toastr.error('Failed to print the Asset label.', 'Delete Failed');
					return null;
			});
		};
						
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				HttpSvc.put('assets/' + $stateParams.id, vm.asset, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Asset has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.initData();
	}
		
	// Asset Properties Modal Controller
	function AssetPropertiesModalCtrl($uibModalInstance, item, toastr) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.item = item.object;
						
		$mdl.confirmModal = function() {
			if($mdl.propForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.digitalhardware.dhmanagement.controller', [])
        .controller('DigitalHardwareMgmtMainCtrl', DigitalHardwareMgmtMainCtrl)
        .controller('DigitalHardwareMgmtCreateCtrl', DigitalHardwareMgmtCreateCtrl)
		.controller('DigitalHardwareMgmtUpdateCtrl', DigitalHardwareMgmtUpdateCtrl);
		
		/** @ngInject */
		function DigitalHardwareMgmtMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
			
			Auth.init();		
			
			var vm = this;
			
			vm.pageSizeOption = [10, 20, 50, 100];
			vm.pageSize = 10;
			vm.numOfRecord = 0;
			vm.numOfRecordFiltered = 0;
			vm.numOfRecordDisplayed = 0;
			vm.startIndex = 0; 
			vm.endIndex = 0;
			vm.hardwareDataFull = [];
			vm.hardwareData = [];
			vm.isLoading = false;
	
			function refreshTableState(tableState, startIndex, endIndex) {
							
				var filtered = tableState.search.predicateObject ? $filter('filter')(vm.hardwareDataFull, tableState.search.predicateObject) : vm.hardwareDataFull;
				vm.numOfRecordFiltered = filtered.length;
				
				if (tableState.sort.predicate) {
					filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
				}
				var result = filtered.slice(startIndex, startIndex + endIndex);
							
				vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
				vm.hardwareData = result;
				
				tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
				
				return tableState;
			};
			
			vm.retrieveData = function(tableState) {
				
				var params = {}
				var pagination = tableState.pagination;
				vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
				vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
				
				if(vm.hardwareDataFull.length <= 0) {
					vm.isLoading = true;
	
					HttpSvc.get('digitalhardwares/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.isLoading = false;
							vm.hardwareDataFull = result;
							vm.numOfRecord = vm.hardwareDataFull.length;	
							refreshTableState(tableState, vm.startIndex, vm.endIndex);
						}, function() {
							vm.isLoading = false;
							toastr.error('Failed to retrieve data.', '');
							return null;
						});
				} else {
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}
			};
			
			vm.deleteHardware = function(itemId, itemName) {
				var params = {};
				HttpSvc.delete('digitalhardwares/' + itemId, params, Auth.getTokenId(), false)
					.then(function(result) {	
						vm.isLoading = true;				
					
						HttpSvc.get('digitalhardwares/list', params, Auth.getTokenId(), true)
							.then(function(result) {	
								vm.hardwareDataFull = result;
								vm.numOfRecord = vm.hardwareDataFull.length;	
								
								toastr.success('The hardware [' + itemName + '] has been deleted.', 'Delete Success');
								$scope.$broadcast('refreshStTable');
								vm.isLoading = false;
							}, function() {
								vm.isLoading = false;
								toastr.error('Failed to retrieve data.', '');
								return null;
							});
					}, function() {
						// Failed
						toastr.error('Failed to delete the Hardware.', 'Delete Failed');
						return null;
				});
			};			
		};
		
		/** @ngInject */
		function DigitalHardwareMgmtCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, UtilSvc, toastr) {
			Auth.init();		
			
			var vm = this;

			vm.mode = 1;
			vm.hardware = {};
			vm.branchList = [];
			vm.templateList = [];
			vm.selectedBranch = null;
			vm.selectedTemplate1 = null;
			vm.selectedTemplate2 = null;	
			vm.isLoading = false;
						
			/* ************************************************************* */

			vm.loadBranchList = function() {	
				vm.isLoading = true;

				HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.branchList = result;
						vm.loadLabelTemplateList();
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}

			vm.loadLabelTemplateList = function() {	
				vm.isLoading = true;

				HttpSvc.get('companylabeltemplateHeaders/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.templateList = result;
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}

			/* ************************************************************* */
	
			vm.selectedBranchChanged = function() {
				vm.hardware.branchId = vm.selectedBranch.id;
			}
			
			vm.selectedTemplateChanged1 = function() {
				//vm.hardware.printerLabelTemplate1 = vm.selectedTemplate1.labelTemplate;

				HttpSvc.get('companylabeltemplateHeaders/' + vm.selectedTemplate1.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						var template = result.companyLabelTemplateFields;
						template = JSON.stringify(template);
						vm.hardware.printerLabelTemplate1 = template;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}
			
			vm.selectedTemplateChanged2 = function() {
				//vm.hardware.printerLabelTemplate2 = vm.selectedTemplate2.labelTemplate;

				HttpSvc.get('companylabeltemplateHeaders/' + vm.selectedTemplate2.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						var template = result.companyLabelTemplateFields;
						template = JSON.stringify(template);
						vm.hardware.printerLabelTemplate2 = template;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}
	
			/* ************************************************************* */
			
			// Form Submission
			vm.submit = function() {
				vm.hardware.ipAddress = vm.hardware.plc2_IpAddress;
				vm.hardware.port = vm.hardware.plc2_Port;

				if(vm.dataForm.$invalid) {
					var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
					toastr.error(errorMsg, 'Incomplete Fields');
				
				} else {
				
					HttpSvc.post('digitalhardwares', vm.hardware, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Digital Hardware has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('digitalhardware.dhmanagement.update', {'id': result.id });
						}, function(error) {
							toastr.error(error, 'Failed');
						});
				}
			}
			
			// Call Actions
			vm.loadBranchList();
		}
		
		/** @ngInject */
		function DigitalHardwareMgmtUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, UtilSvc, toastr) {	
			
			var vm = this;

			vm.mode = 2;
			vm.hardware = {};
			vm.branchList = [];
			vm.templateList = [];
			vm.selectedBranch = null;
			vm.selectedTemplate1 = null;
			vm.selectedTemplate2 = null;	
			vm.isLoading = false;
						
			/* ************************************************************* */

			vm.loadBranchList = function() {
				vm.isLoading = true;

				HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.branchList = result;
						vm.loadLabelTemplateList();
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}

			vm.loadLabelTemplateList = function() {	
				HttpSvc.get('companylabeltemplateHeaders/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.templateList = result;
						vm.loadHardware();
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}

			vm.loadHardware = function() {	
				vm.isLoading = true;

				HttpSvc.get('digitalhardwares/' + $stateParams.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						vm.hardware = result;

						vm.branchList.forEach(function(b) {
							if(b.id==vm.hardware.branchId)
							{
								vm.selectedBranch = b;
							}
						});

						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}

			/* ************************************************************* */
	
			vm.selectedBranchChanged = function() {
				vm.hardware.branchId = vm.selectedBranch.id;
			}
			
			vm.selectedTemplateChanged1 = function() {
				//vm.hardware.printerLabelTemplate1 = vm.selectedTemplate1.labelTemplate;

				HttpSvc.get('companylabeltemplateHeaders/' + vm.selectedTemplate1.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						var template = result.companyLabelTemplateFields;
						template = JSON.stringify(template);
						vm.hardware.printerLabelTemplate1 = template;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}
			
			vm.selectedTemplateChanged2 = function() {
				//vm.hardware.printerLabelTemplate2 = vm.selectedTemplate2.labelTemplate;

				HttpSvc.get('companylabeltemplateHeaders/' + vm.selectedTemplate2.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						var template = result.companyLabelTemplateFields;
						template = JSON.stringify(template);
						vm.hardware.printerLabelTemplate2 = template;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}
	
			/* ************************************************************* */
			
			// Form Submission
			vm.submit = function() {
				vm.hardware.ipAddress = vm.hardware.plc2_IpAddress;
				vm.hardware.port = vm.hardware.plc2_Port;
				
				if(vm.dataForm.$invalid) {
					var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
					toastr.error(errorMsg, 'Incomplete Fields');
				
				} else {
				
					HttpSvc.put('digitalhardwares/' + $stateParams.id, vm.hardware, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Digital Hardware has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						}, function(error) {
							toastr.error(error, 'Failed');
						});
				}
			}
			
			// Call Actions
			vm.loadBranchList();		
		}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.durianops.collectdurian.controller', [])
        .controller('DurianOpsCollectDurianCtrl', DurianOpsCollectDurianCtrl)
        .controller('DurianOpsCollectDurianSupplierCtrl', DurianOpsCollectDurianSupplierCtrl)
        .controller('DurianOpsCollectDurianDurianTypeCtrl', DurianOpsCollectDurianDurianTypeCtrl)
        .controller('DurianOpsCollectDurianCompleteCtrl', DurianOpsCollectDurianCompleteCtrl);

	/** @ngInject */
    function DurianOpsCollectDurianCtrl($scope, $state, $filter, $interval, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.isBasket = true;
		vm.isJobStarted = false;
		vm.lockButtons = false;
		vm.supplierId = "";
		vm.supplierName = "";
		vm.itemId = "";
		vm.itemName = "";
		vm.grnId = "";
		vm.grnNo = "";
		vm.poLineItemId = "";
		vm.totalWeight = 0;
		vm.grnItems = [];
		vm.interval = null;
		
		/* **************************************************************** */

		vm.showSupplierModel = function() {
			if(vm.lockButtons) return;
			if(vm.isJobStarted) return;

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'DurianOpsSupplierModal.html',
				controller: 'DurianOpsCollectDurianSupplierCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.supplierId = data.supplierId;
					vm.supplierName = data.supplierName;
				}, function () {
				});
		}
		
		vm.showDurianTypeModel = function() {
			if(vm.lockButtons) return;
			if(vm.isJobStarted) return;

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'DurianOpsRawMatModal.html',
				controller: 'DurianOpsCollectDurianDurianTypeCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.itemId = data.itemId;
					vm.itemName = data.itemName;
				}, function () {
				});			
		}
		
		vm.showCompleteModel = function() {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'DurianOpsCompleteModal.html',
				controller: 'DurianOpsCollectDurianCompleteCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {}
			});

			modalInstance
				.result
				.then(function (data) {
					if(data.isCompleted)
					{
						vm.completeJob();
					}
				}, function () {
				});			
		}
		
		/* **************************************************************** */
		
		vm.toggleJob = function() {
			if(vm.itemId=="" || vm.supplierId=="")
			{
				toastr.warning("Please select the Orchard Source and Durian Type first.", "Warning")
				return;
			}

			if(vm.isJobStarted) {				
				vm.showCompleteModel();
			} else {
				vm.startJob();
			}
		}

		vm.startJob = function() {
			if(vm.lockButtons) return;

			vm.lockButtons = true;

			var params = {
				supplierId: vm.supplierId,
				itemId: vm.itemId,
			}

			HttpSvc.post('durianops/duriancollections/newtask', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.grnId = result.id;
					vm.grnNo = result.receivingNo;
					vm.poLineItemId = result.poLineItemId;
					toastr.success('Collection process begins...', 'Collection');
					vm.isJobStarted = true;
					vm.lockButtons = false;

					vm.simulateCollection();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		vm.completeJob = function() {
			vm.isJobStarted = false;
			vm.supplierId = "";
			vm.supplierName = "";
			vm.itemId = "";
			vm.itemName = "";
			vm.grnId = "";
			vm.grnNo = "";
			vm.grnItems = [];
			vm.totalWeight = 0;
			toastr.success('Collection completed.', vm.grnNo);
			$interval.cancel(vm.interval);
		}

		/* **************************************************************** */

		vm.simulateCollection = function() {
			var interval = 2000;
			
			if(!vm.isBasket) {
				interval = 1000;
			}

			vm.interval = $interval(vm.collect, interval);

			$scope.$on('$destroy', function(){
				$interval.cancel(vm.interval);
			});
		}

		vm.collect = function() {
			var quantity = 0;
			
			if(vm.isBasket) {				
				quantity = Math.floor(Math.random() * (150 - 110)) + 110;
			} else {
				quantity = Math.floor(Math.random() * (4 - 2)) + 2;
			}
			
			var params = {
				grnId: vm.grnId,
				itemId: vm.itemId,
				poLineItemId: vm.poLineItemId,
				quantity: quantity,
				labelSerialNo: '',
				unitOfMeasurement: 'KG',
				unitOfMeasurementId: '6c2ccca8-e949-485a-8608-bef7742df1b6'
			};

			HttpSvc.post('durianops/duriancollections/collect/' + vm.grnId, params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.totalWeight += quantity;
					params.labelSerialNo = result.serialNo;
					vm.grnItems.push(params);					

					var count = 11;
					if(!vm.isBasket) {
						count = 17;
					}

					if(vm.grnItems.length >= count)
					{
						$interval.cancel(vm.interval);						
					}
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
	}	
	
	/** @ngInject */
    function DurianOpsCollectDurianSupplierCtrl($scope, $state, $filter, $uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.supplierList = [];
		$mdl.supplierId = "";
		$mdl.supplierName = "";
		$mdl.isLoading = false;

		/* **************************************************************** */

		$mdl.loadSuppliers = function() {
			$mdl.isLoading = true;

			HttpSvc.get('suppliers/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.supplierList = result;
					$mdl.isLoading = false;
				}, function(error) {
					toastr.error('Failed to load supplier list.')
					$uibModalInstance.dismiss('cancel');
				});
		}

		/* **************************************************************** */

		$mdl.selectSupplier = function(item) {
			$mdl.supplierId = item.id;
			$mdl.supplierName = item.name;

			var result = {
				supplierId: $mdl.supplierId,
				supplierName: $mdl.supplierName,
			}
			$uibModalInstance.close(result);
		}

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* **************************************************************** */

		$mdl.loadSuppliers();
	}	
	
	/** @ngInject */
    function DurianOpsCollectDurianDurianTypeCtrl($scope, $state, $filter, $uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.rawMatList = [];
		$mdl.itemId = "";
		$mdl.itemName = "";
		$mdl.isLoading = false;

		/* **************************************************************** */

		$mdl.loadRawMatList = function() {
			$mdl.isLoading = true;

			HttpSvc.get('items/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.rawMatList = result;
					$mdl.isLoading = false;
				}, function(error) {
					toastr.error('Failed to load durian types.')
					$uibModalInstance.dismiss('cancel');
				});
		}

		/* **************************************************************** */

		$mdl.selectRawMat = function(item) {
			$mdl.itemId = item.id;
			$mdl.itemName = item.description;

			var result = {
				itemId: $mdl.itemId,
				itemName: $mdl.itemName,
			}
			$uibModalInstance.close(result);
		}

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* **************************************************************** */

		$mdl.loadRawMatList();
	}
	
	/** @ngInject */
    function DurianOpsCollectDurianCompleteCtrl($scope, $state, $filter, $uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.isCompleted = false;

		/* **************************************************************** */

		$mdl.completeTask = function() {
			$mdl.isCompleted = true;
			$uibModalInstance.close({ isCompleted: $mdl.isCompleted });
		}

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.digitalhardware.dhsettings.controller', [])
        .controller('DigitalHardwareSettingMainCtrl', DigitalHardwareSettingMainCtrl)
        .controller('DigitalHardwareSettingCreateCtrl', DigitalHardwareSettingCreateCtrl)
		.controller('DigitalHardwareSettingUpdateCtrl', DigitalHardwareSettingUpdateCtrl);
		
		/** @ngInject */
		function DigitalHardwareSettingMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
			
			Auth.init();		
			
			var vm = this;
			
			vm.pageSizeOption = [10, 20, 50, 100];
			vm.pageSize = 10;
			vm.numOfRecord = 0;
			vm.numOfRecordFiltered = 0;
			vm.numOfRecordDisplayed = 0;
			vm.startIndex = 0; 
			vm.endIndex = 0;
			vm.settingDataFull = [];
			vm.settingData = [];
			vm.isLoading = false;
	
			function refreshTableState(tableState, startIndex, endIndex) {
							
				var filtered = tableState.search.predicateObject ? $filter('filter')(vm.settingDataFull, tableState.search.predicateObject) : vm.settingDataFull;
				vm.numOfRecordFiltered = filtered.length;
				
				if (tableState.sort.predicate) {
					filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
				}
				var result = filtered.slice(startIndex, startIndex + endIndex);
							
				vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
				vm.settingData = result;
				
				tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
				
				return tableState;
			};
			
			vm.retrieveData = function(tableState) {
				
				var params = {}
				var pagination = tableState.pagination;
				vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
				vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
				
				if(vm.settingDataFull.length <= 0) {
					vm.isLoading = true;
	
					HttpSvc.get('aicombiweighersettings/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.isLoading = false;
							vm.settingDataFull = result;
							vm.numOfRecord = vm.settingDataFull.length;	
							refreshTableState(tableState, vm.startIndex, vm.endIndex);
						}, function() {
							vm.isLoading = false;
							toastr.error('Failed to retrieve data.', '');
							return null;
						});
				} else {
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}
			};
			
			vm.deleteSetting = function(settingId, settingName) {
				var params = {};
				HttpSvc.delete('aicombiweighersettings/' + settingId, params, Auth.getTokenId(), false)
					.then(function(result) {	
						vm.isLoading = true;				
					
						HttpSvc.get('aicombiweighersettings/list', params, Auth.getTokenId(), true)
							.then(function(result) {	
								vm.settingDataFull = result;
								vm.numOfRecord = vm.settingDataFull.length;	
								
								toastr.success('The setting [' + settingName + '] has been deleted.', 'Delete Success');
								$scope.$broadcast('refreshStTable');
							}, function() {
								vm.isLoading = false;
								toastr.error('Failed to retrieve data.', '');
								return null;
							});
					}, function() {
						// Failed
						toastr.error('Failed to delete the Setting.', 'Delete Failed');
						return null;
				});
			};			
		};
		
		/** @ngInject */
		function DigitalHardwareSettingCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, UtilSvc, toastr) {
			Auth.init();		
			
			var vm = this;

			vm.mode = 1;
			vm.setting = {};
			vm.productList = [];
			vm.uomList = [];
			vm.selectedProduct = null;
			vm.selectedUom = null;
			vm.isLoading = false;
						
			/* ************************************************************* */

			vm.loadProductList = function() {	
				vm.isLoading = true;

				HttpSvc.get('products/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.productList = result;
						vm.loadUomList();
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}

			vm.loadUomList = function() {	
				vm.isLoading = true;

				HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.uomList = result;
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}

			/* ************************************************************* */
				
			vm.selectedProductChanged = function() {
				vm.setting.productId = vm.selectedProduct.id;
			}
				
			vm.selectedUomChanged = function() {
				vm.setting.uomId = vm.selectedUom.id;
			}
	
			/* ************************************************************* */
			
			// Form Submission
			vm.submit = function() {
				if(vm.dataForm.$invalid) {
					var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
					toastr.error(errorMsg, 'Incomplete Fields');
				
				} else {
				
					HttpSvc.post('aicombiweighersettings', vm.setting, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Hardware Setting has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('digitalhardware.dhsettings.update', {'id': result.id });
						}, function(error) {
							toastr.error(error, 'Failed');
						});
				}
			}
			
			// Call Actions
			vm.loadProductList();
		}
		
		/** @ngInject */
		function DigitalHardwareSettingUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, UtilSvc, toastr) {	
			
			var vm = this;

			vm.mode = 2;
			vm.setting = {};
			vm.productList = [];
			vm.uomList = [];
			vm.selectedProduct = null;
			vm.selectedUom = null;
			vm.isLoading = false;
						
			/* ************************************************************* */

			vm.loadProductList = function() {	
				vm.isLoading = true;

				HttpSvc.get('products/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.productList = result;
						vm.loadUomList();
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}

			vm.loadUomList = function() {

				HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.uomList = result;
						vm.loadSetting();
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}

			vm.loadSetting = function() {
				HttpSvc.get('aicombiweighersettings/' + $stateParams.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						vm.setting = result;

						vm.productList.forEach(function(p) {
							if(p.id==vm.setting.productId)
							{
								vm.selectedProduct = p;
							}
						});

						vm.uomList.forEach(function(u) {
							if(u.id==vm.setting.uomId)
							{
								vm.selectedUom = u;
							}
						});

						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			}

			/* ************************************************************* */
				
			vm.selectedProductChanged = function() {
				vm.setting.productId = vm.selectedProduct.id;
			}
				
			vm.selectedUomChanged = function() {
				vm.setting.uomId = vm.selectedUom.id;
			}
	
			/* ************************************************************* */
			
			// Form Submission
			vm.submit = function() {
				if(vm.dataForm.$invalid) {
					var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
					toastr.error(errorMsg, 'Incomplete Fields');
				
				} else {
				
					HttpSvc.put('aicombiweighersettings/' + $stateParams.id, vm.setting, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Hardware Setting has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						}, function(error) {
							toastr.error(error, 'Failed');
						});
				}
			}
			
			// Call Actions
			vm.loadProductList();		
		}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.durianops.processpulps.controller', [])
        .controller('DurianOpsProcessPulpsCtrl', DurianOpsProcessPulpsCtrl)
        .controller('DurianOpsProcessPulpSemiFgCtrl', DurianOpsProcessPulpSemiFgCtrl)
        .controller('DurianOpsProcessPulpStockBatchCtrl', DurianOpsProcessPulpStockBatchCtrl)
        .controller('DurianOpsProcessPulpCompleteCtrl', DurianOpsProcessPulpCompleteCtrl);

	/** @ngInject */
    function DurianOpsProcessPulpsCtrl($scope, $state, $filter, $interval, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.isJobStarted = false;
		vm.lockButtons = false;
		vm.storageId = "";
		vm.jobId = "";
		vm.jobNo = "";
		vm.itemId = "";
		vm.itemName = "";
		vm.itemQty = "";
		vm.itemUom = "";
		vm.semiFgId = "";
		vm.semiFgName = "";
		vm.totalWeight = 0;
		vm.labels = [];
		vm.semiFgs = [];
		vm.interval = null;
		
		/* **************************************************************** */

		vm.showSemiFgModel = function() {
			if(vm.lockButtons) return;
			if(vm.isJobStarted) return;

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'DurianOpsSemiFgModal.html',
				controller: 'DurianOpsProcessPulpSemiFgCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.semiFgId = data.semiFgId;
					vm.semiFgName = data.semiFgName;
				}, function () {
				});
		}
		
		vm.showInventoryModel = function() {
			if(vm.semiFgId=="") {
				toastr.warning('Select a Semi FG first', 'Semi FG');
				return;
			}
			if(vm.lockButtons) return;
			if(vm.isJobStarted) return;

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'DurianOpsStockBatchModal.html',
				controller: 'DurianOpsProcessPulpStockBatchCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							semiFgId: vm.semiFgId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.itemId = data.itemId;
					vm.itemName = data.itemName;
					vm.itemQty = data.quantity;
					vm.itemUom = data.uomName;
					vm.storageId = data.storageId;
				}, function () {
				});			
		}
		
		vm.showCompleteModel = function() {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'DurianOpsCompleteModal.html',
				controller: 'DurianOpsProcessPulpCompleteCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							jobId: vm.jobId,
							jobNo: vm.jobNo,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.completeJob();
				}, function () {
				});			
		}
		
		/* **************************************************************** */
		
		vm.toggleJob = function() {
			if(vm.itemId=="" || vm.semiFgId=="")
			{
				toastr.warning("Please select the Semi F.G. and Stock Batch first.", "Warning")
				return;
			}

			if(vm.isJobStarted) {				
				vm.showCompleteModel();
			} else {
				vm.startJob();
			}
		}

		vm.startJob = function() {
			if(vm.lockButtons) return;

			vm.lockButtons = true;

			var params = {
				semiFgId: vm.semiFgId,
				itemId: vm.itemId,
				storageId: vm.storageId,
			}

			HttpSvc.post('durianops/processpulps/newtask', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.jobId = result.id;
					vm.jobNo = result.jobNo;
					vm.labels = result.labels;
					toastr.success('Pulps Processing begins...', 'Process Pulps');
					vm.isJobStarted = true;
					vm.lockButtons = false;

					vm.simulatePulpProcessing();
				}, function(error) {
					vm.isJobStarted = false;
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
					$interval.cancel(vm.interval);
				});
		}

		vm.completeJob = function() {
			vm.isJobStarted = false;
			vm.lockButtons = false;
			vm.jobId = "";
			vm.jobNo = "";
			vm.itemId = "";
			vm.itemName = "";
			vm.semiFgId = "";
			vm.semiFgName = "";
			vm.totalWeight = 0;
			vm.labels = [];
			vm.semiFgs = [];
			toastr.success('Pulp processing completed.', vm.jobNo);
			$interval.cancel(vm.interval);
		}

		/* **************************************************************** */

		vm.simulatePulpProcessing = function() {
			var interval = 1000;

			vm.interval = $interval(vm.processPulp, interval);

			$scope.$on('$destroy', function(){
				$interval.cancel(vm.interval);
			});
		}

		vm.processPulp = function() {
			var quantity = Math.floor(Math.random() * (2 - 1)) + 1;
			
			var params = {
				jobId: vm.jobId,
				quantity: quantity,
				unitOfMeasurement: 'KG',
				unitOfMeasurementId: '6c2ccca8-e949-485a-8608-bef7742df1b6'
			};

			HttpSvc.post('durianops/processpulps/process/' + vm.jobId, params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.totalWeight += quantity;
					vm.semiFgs.push(params);

					var count = 17;

					if(vm.semiFgs.length >= count)
					{
						$interval.cancel(vm.interval);
					}
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
	}	
	
	/** @ngInject */
    function DurianOpsProcessPulpSemiFgCtrl($scope, $state, $filter, $uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.semiFgList = [];
		$mdl.semiFgId = "";
		$mdl.semiFgName = "";
		$mdl.isLoading = false;

		/* **************************************************************** */

		$mdl.loadSemiFgs = function() {
			$mdl.isLoading = true;

			HttpSvc.get('semifgs/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.semiFgList = result;
					$mdl.isLoading = false;
				}, function(error) {
					toastr.error('Failed to load Semi F.G. list.')
					$uibModalInstance.dismiss('cancel');
				});
		}

		/* **************************************************************** */

		$mdl.selectSemiFg = function(item) {
			$mdl.semiFgId = item.id;
			$mdl.semiFgName = item.description;

			var result = {
				semiFgId: $mdl.semiFgId,
				semiFgName: $mdl.semiFgName,
			}
			$uibModalInstance.close(result);
		}

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* **************************************************************** */

		$mdl.loadSemiFgs();
	}	
	
	/** @ngInject */
    function DurianOpsProcessPulpStockBatchCtrl($scope, $state, $filter, $uibModalInstance, Auth, item, HttpSvc, toastr) {
		var $mdl = this;		
		$mdl.semiFgId = item.semiFgId;
		$mdl.storageId = "";
		$mdl.itemId = "";
		$mdl.itemName = "";
		$mdl.uomName = "";
		$mdl.quantity = 0;
		$mdl.inventoryList = [];
		$mdl.isLoading = false;

		/* **************************************************************** */

		$mdl.loadInventoryList = function() {
			$mdl.isLoading = true;

			HttpSvc.get('durianops/processpulps/inventory/list/' + $mdl.semiFgId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.inventoryList = result;
					$mdl.isLoading = false;
				}, function(error) {
					toastr.error('Failed to load Inventory list.')
					$uibModalInstance.dismiss('cancel');
				});
		}

		/* **************************************************************** */

		$mdl.selectStock = function(item) {
			$mdl.itemId = item.id;
			$mdl.itemName = item.description;
			$mdl.quantity = item.quantity;
			$mdl.uomName = item.uom;
			$mdl.storageId = item.storageId;

			var result = {
				itemId: $mdl.itemId,
				itemName: $mdl.itemName,
				quantity: $mdl.quantity,
				uomName: $mdl.uomName,
				storageId: $mdl.storageId,
			}
			$uibModalInstance.close(result);
		}

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* **************************************************************** */

		$mdl.loadInventoryList();
	}
	
	/** @ngInject */
    function DurianOpsProcessPulpCompleteCtrl($scope, $state, $filter, $uibModalInstance, Auth, item, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.jobId = item.jobId;
		$mdl.jobNo = item.jobNo;
		$mdl.lockButtons = false;

		/* **************************************************************** */

		$mdl.completeTask = function() {
			if($mdl.lockButtons) return;

			$mdl.lockButtons = true;

			HttpSvc.post('durianops/processpulps/complete/' + $mdl.jobId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Pulp processing completed.', $mdl.jobNo);
					$uibModalInstance.close();

				}, function(error) {
					$mdl.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.durianops.durianinventory.controller', [])
        .controller('DurianOpsDurianInventoryCtrl', DurianOpsDurianInventoryCtrl);

	/** @ngInject */
    function DurianOpsDurianInventoryCtrl($scope, $state, $filter, $interval, $uibModal, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		vm.data = {};
		vm.data.rawMatResult = [];
		vm.data.semiFgResult = [];
		vm.data.productResult = [];
		vm.isLoading = false;

		/* ******************************************************* */

		vm.loadData = function() {			
			vm.isLoading = true;

			HttpSvc.get('durianops/inventory/list', {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.data = result;	
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		};

		vm.loadData();
	}	
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.billing.invoices.controller', [])
        .controller('BillingInvoicesMainCtrl', BillingInvoicesMainCtrl);

    /** @ngInject */
    function BillingInvoicesMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.invoiceDataFull = [];
		vm.invoiceData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.invoiceDataFull, tableState.search.predicateObject) : vm.invoiceDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.invoiceData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.invoiceDataFull.length <= 0) {							
				HttpSvc.get('billinginvoices/list/company/' + Auth.getCompanyId(), params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.invoiceDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.printInvoice = function(invoiceId, invoiceNo) {
			
			var filename = "INVOICE_" + invoiceNo.replace("/", "_") + ".pdf";
			
			vm.isExporting = true;
			
			HttpSvc.getPdfObject('billinginvoices/print/' + invoiceId, Auth.getTokenId(), filename)
				.then(function(result) {	
					vm.isExporting = false;
				}, function(error) {
					vm.isExporting = false;
					toastr.error('Failed to print the Invoice. ' + error, '');
					return null;
				});
		};		
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.durianops.producepuree.controller', [])
        .controller('DurianOpsProducePureeCtrl', DurianOpsProducePureeCtrl)
        .controller('DurianOpsProducePureeProductCtrl', DurianOpsProducePureeProductCtrl)
        .controller('DurianOpsProducePureeStockBatchCtrl', DurianOpsProducePureeStockBatchCtrl)
        .controller('DurianOpsProducePureeCompleteCtrl', DurianOpsProducePureeCompleteCtrl);

	/** @ngInject */
    function DurianOpsProducePureeCtrl($scope, $state, $filter, $interval, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.isJobStarted = false;
		vm.lockButtons = false;
		vm.storageId = "";
		vm.jobId = "";
		vm.jobNo = "";
		vm.productId = "";
		vm.productName = "";
		vm.semiFgId = "";
		vm.semiFgName = "";
		vm.semiFgQty = "";
		vm.semiFgUom = "";
		vm.totalWeight = 0;
		vm.labels = [];
		vm.products = [];
		vm.interval = null;
		
		/* **************************************************************** */

		vm.showProductModel = function() {
			if(vm.lockButtons) return;
			if(vm.isJobStarted) return;

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'DurianOpsProductModal.html',
				controller: 'DurianOpsProducePureeProductCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.productId = data.productId;
					vm.productName = data.productName;
				}, function () {
				});
		}
		
		vm.showInventoryModel = function() {
			if(vm.productId=="") {
				toastr.warning('Select a Durian Puree first', 'Durian Puree');
				return;
			}
			if(vm.lockButtons) return;
			if(vm.isJobStarted) return;

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'DurianOpsStockBatchModal.html',
				controller: 'DurianOpsProducePureeStockBatchCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							productId: vm.productId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.semiFgId = data.semiFgId;
					vm.semiFgName = data.semiFgName;
					vm.semiFgQty = data.quantity;
					vm.semiFgUom = data.uomName;
					vm.storageId = data.storageId;
				}, function () {
				});			
		}
		
		vm.showCompleteModel = function() {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'DurianOpsCompleteModal.html',
				controller: 'DurianOpsProducePureeCompleteCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							jobId: vm.jobId,
							jobNo: vm.jobNo,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.completeJob();
				}, function () {
				});			
		}
		
		/* **************************************************************** */
		
		vm.toggleJob = function() {
			if(vm.productId=="" || vm.semiFgId=="")
			{
				toastr.warning("Please select the Durian Puree and Stock Batch first.", "Warning")
				return;
			}

			if(vm.isJobStarted) {				
				vm.showCompleteModel();
			} else {
				vm.startJob();
			}
		}

		vm.startJob = function() {
			if(vm.lockButtons) return;

			vm.lockButtons = true;

			var params = {
				productId: vm.productId,
				semiFgId: vm.semiFgId,
				storageId: vm.storageId,
			}

			HttpSvc.post('durianops/producepuree/newtask', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.jobId = result.id;
					vm.jobNo = result.jobNo;
					vm.labels = result.labels;
					toastr.success('Durian Puree production begins...', 'Puree Production');
					vm.isJobStarted = true;
					vm.lockButtons = false;

					vm.simulatePureeProduction();
				}, function(error) {
					vm.isJobStarted = false;
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
					$interval.cancel(vm.interval);
				});
		}

		vm.completeJob = function() {
			vm.isJobStarted = false;
			vm.lockButtons = false;
			vm.jobId = "";
			vm.jobNo = "";
			vm.itemId = "";
			vm.itemName = "";
			vm.semiFgId = "";
			vm.semiFgName = "";
			vm.totalWeight = 0;
			vm.labels = [];
			vm.products = [];
			toastr.success('Durian Puree production completed.', vm.jobNo);
			$interval.cancel(vm.interval);
		}

		/* **************************************************************** */

		vm.simulatePureeProduction = function() {
			var interval = 1000;

			vm.interval = $interval(vm.producePuree, interval);

			$scope.$on('$destroy', function(){
				$interval.cancel(vm.interval);
			});
		}

		vm.producePuree = function() {
			var quantity = Math.floor(Math.random() * (2 - 1)) + 1;
			
			var params = {
				jobId: vm.jobId,
				quantity: quantity,
				unitOfMeasurement: 'KG',
				unitOfMeasurementId: '6c2ccca8-e949-485a-8608-bef7742df1b6'
			};

			HttpSvc.post('durianops/processpulps/process/' + vm.jobId, params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.totalWeight += quantity;
					vm.products.push(params);

					var count = 17;

					if(vm.products.length >= count)
					{
						$interval.cancel(vm.interval);
					}
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
	}	
	
	/** @ngInject */
    function DurianOpsProducePureeProductCtrl($scope, $state, $filter, $uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.productList = [];
		$mdl.productId = "";
		$mdl.productName = "";
		$mdl.isLoading = false;

		/* **************************************************************** */

		$mdl.loadProducts = function() {
			$mdl.isLoading = true;

			HttpSvc.get('products/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.productList = result;
					$mdl.isLoading = false;
				}, function(error) {
					toastr.error('Failed to load Product list.')
					$uibModalInstance.dismiss('cancel');
				});
		}

		/* **************************************************************** */

		$mdl.selectProduct = function(item) {
			$mdl.productId = item.id;
			$mdl.productName = item.name;

			var result = {
				productId: $mdl.productId,
				productName: $mdl.productName,
			}
			$uibModalInstance.close(result);
		}

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* **************************************************************** */

		$mdl.loadProducts();
	}	
	
	/** @ngInject */
    function DurianOpsProducePureeStockBatchCtrl($scope, $state, $filter, $uibModalInstance, Auth, item, HttpSvc, toastr) {
		var $mdl = this;		
		$mdl.productId = item.productId;
		$mdl.storageId = "";
		$mdl.semiFgId = "";
		$mdl.semiFgName = "";
		$mdl.uomName = "";
		$mdl.quantity = 0;
		$mdl.inventoryList = [];
		$mdl.isLoading = false;

		/* **************************************************************** */

		$mdl.loadInventoryList = function() {
			$mdl.isLoading = true;

			HttpSvc.get('durianops/producepuree/inventory/list/' + $mdl.productId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.inventoryList = result;
					$mdl.isLoading = false;
				}, function(error) {
					toastr.error('Failed to load Inventory list.')
					$uibModalInstance.dismiss('cancel');
				});
		}

		/* **************************************************************** */

		$mdl.selectStock = function(item) {
			$mdl.semiFgId = item.id;
			$mdl.semiFgName = item.description;
			$mdl.quantity = item.quantity;
			$mdl.uomName = item.uom;
			$mdl.storageId = item.storageId;

			var result = {
				semiFgId: $mdl.semiFgId,
				semiFgName: $mdl.semiFgName,
				quantity: $mdl.quantity,
				uomName: $mdl.uomName,
				storageId: $mdl.storageId,
			}
			$uibModalInstance.close(result);
		}

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* **************************************************************** */

		$mdl.loadInventoryList();
	}
	
	/** @ngInject */
    function DurianOpsProducePureeCompleteCtrl($scope, $state, $filter, $uibModalInstance, Auth, item, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.jobId = item.jobId;
		$mdl.jobNo = item.jobNo;
		$mdl.lockButtons = false;

		/* **************************************************************** */

		$mdl.completeTask = function() {
			if($mdl.lockButtons) return;

			$mdl.lockButtons = true;

			HttpSvc.post('durianops/producepuree/complete/' + $mdl.jobId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Durian Puree production completed.', $mdl.jobNo);
					$uibModalInstance.close();

				}, function(error) {
					$mdl.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.billing.addons.controller', [])
        .controller('BillingAddOnMainCtrl', BillingAddOnMainCtrl);

    /** @ngInject */
    function BillingAddOnMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		// Load Package List
		vm.loadPackages = function () {
			HttpSvc.get('serverpackages/list/addon', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.packageList = result;					
					vm.loadPurchasedAddOns();
				}, function(err) {
					toastr.error('Failed to load Storage Add-Ons. ' + err.message, Auth.translate('ERROR'));
					return;
				});
		};
		
		// Load Purchased Add-On List
		var totalStorageGB = 0;
		var totalMonthlyFee = 0;
		var totalAnnualFee = 0;
		
		vm.getTotalSpaceGB = function() {
			return totalStorageGB;
		}		
		vm.getTotalMonthlyFee = function() {
			return totalMonthlyFee;
		}		
		vm.getTotalAnnualFee = function() {
			return totalAnnualFee;
		}
		
		vm.loadPurchasedAddOns = function() {
			HttpSvc.get('billingaddons/company/' + Auth.getCompanyId(), {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function(p) {
						totalStorageGB += (p.serverPackage.storageSpaceMB / 1024);
						totalMonthlyFee += p.serverPackage.monthlyFee;
						totalAnnualFee += p.serverPackage.annualFee;
						vm.addOnList.push(p);
					});
				}, function() {
					toastr.error('Failed to load purchased Storage Add-Ons.', Auth.translate('ERROR'));
					return;
				});			
		};

		// Init Data
		vm.initData = function() {
			vm.addOnList = [];
			vm.packageList = [];
			vm.companyId = Auth.getCompanyId();
			vm.isLoading = false;
			vm.loadPackages();
		};
		
		// Purchase 
		vm.selectPackage = function(packageId) {
			vm.isLoading = true;
			
			HttpSvc.post('companies/' + Auth.getCompanyId() + '/packageaddon/' + packageId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					Auth.selectBranchToken()
						.then(function() {	
							toastr.success('Storage Add-On purchased successfully.');
							vm.initData();
						}, function(error) {
							toastr.success('Storage Add-On purchased successfully.');
							vm.initData();
						});	
				}, function() {
					toastr.error('Failed to purchase the Storage Add-On.', Auth.translate('ERROR'));
				});
		};

		// Call Actions
		vm.initData();
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.billing.subscriptions.controller', [])
        .controller('BillingSubscriptionMainCtrl', BillingSubscriptionMainCtrl);

    /** @ngInject */
    function BillingSubscriptionMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;
		vm.packageList = [];
		vm.companyId = Auth.getCompanyId();
		vm.company = {};
		vm.selectedPackage = {};
		vm.selectedPackageId = "";
		vm.isLoading = false;

		// Load Company
		vm.loadCompany = function () {
			var params = { id: vm.companyId };
			HttpSvc.get('companies/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.company = result;
					vm.loadPackages();
				}, function() {
					toastr.error('Failed to load company information.', Auth.translate('ERROR'));
					return;
				});
		};

		// Load Package List
		vm.loadPackages = function () {
			HttpSvc.get('serverpackages/list/public', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.packageList = [];
					result.forEach(function(p) {
						vm.packageList.push(p);
						if(p.id==vm.company.serverPackageId){
							vm.selectedPackage = p;
							vm.selectedPackageId = vm.company.serverPackageId;
						}
					});
					vm.initData();
				}, function() {
					toastr.error('Failed to load subscription plans.', Auth.translate('ERROR'));
					return;
				});
		};

		// Init Data
		vm.initData = function() {
			vm.isLoading = false;
		};
		
		// Select Package
		vm.selectPackage = function(packageId) {
			vm.isLoading = true;
			
			vm.packageList.forEach(function(p) {
				if(p.id==packageId) {
					vm.selectedPackageId = packageId;
				}
			});
			
			HttpSvc.post('companies/' + Auth.getCompanyId() + '/updatepackage/' + vm.selectedPackageId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					Auth.selectBranchToken()
						.then(function() {	
							toastr.success('Subscription Plan updated successfully.');
							vm.loadCompany();
						}, function(error) {
							toastr.success('Subscription Plan updated successfully.');
							vm.loadCompany();
						});	
				}, function(err) {
					toastr.error('Failed to update the Subscription Plan. ' + err.message, Auth.translate('ERROR'));
					vm.loadCompany();
				});
		};

		// Call Actions
		vm.loadCompany();
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.franchise.franchiseemgmt.controller', [])
        .controller('FranchiseeMgmtMainCtrl', FranchiseeMgmtMainCtrl)
        .controller('FranchiseeMgmtCreateCtrl', FranchiseeMgmtCreateCtrl)
        .controller('FranchiseeMgmtUpdateCtrl', FranchiseeMgmtUpdateCtrl);

    /** @ngInject */
    function FranchiseeMgmtMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.franchiseeDataFull = [];
		vm.franchiseeData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.franchiseeDataFull, tableState.search.predicateObject) : vm.franchiseeDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.franchiseeData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.franchiseeDataFull.length <= 0) {
				vm.isLoading = true;

				HttpSvc.get('franchisees/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.isLoading = false;
						vm.franchiseeDataFull = [];
						result.forEach(function(u) {
							if(!u.isSuperAdmin) {
								vm.franchiseeDataFull.push(u);
							} else {
								if(Auth.isSuperAdmin()) {
									vm.franchiseeDataFull.push(u);
								}
							}
						});
						vm.numOfRecord = vm.franchiseeDataFull.length;	
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};
		
		vm.resetUserPwd = function(loginId, userEmail) {
			Auth.resetPwd2(loginId, userEmail)
				.then(function() {				  
					toastr.success("An email which contains the new password has been sent!", 'Reset Successful');
				}, function(error) {
					toastr.error("Error: " + error, 'Reset Failed');
					//toastr.error('Invalid email address.', 'Reset Failed');
				});
		};	
		
		vm.deleteUser = function(userId, username) {
			var params = {};
			HttpSvc.delete('users/' + userId, params, Auth.getTokenId(), false)
				.then(function(result) {					
				
					HttpSvc.get('users/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.franchiseeDataFull = [];
							result.forEach(function(u) {
								if(!u.isSuperAdmin) {
									vm.franchiseeDataFull.push(u);
								} else {
									if(Auth.isSuperAdmin()) {
										vm.franchiseeDataFull.push(u);
									}
								}
							});
							vm.numOfRecord = vm.franchiseeDataFull.length;	
							
							toastr.success('The user [' + username + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
						});
				}, function() {
					// Failed
					toastr.error('Failed to delete the user.', 'Delete Failed');
					return null;
			});
		};			
	};
	
	/** @ngInject */
    function FranchiseeMgmtCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, UtilSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		
		vm.statuses = [ 
			{id: 'NEW', name: 'NEW'}, 
			{id: 'CONFIRMED', name: 'CONFIRMED'}
		];
		vm.originalStatus = 'NEW';
		vm.selectedStatus = vm.statuses[0];

		vm.bankList = GetBankList();
		vm.selectedBank = null;

		vm.mode = 1;
		vm.franchisee = {};
		vm.franchisee.status = "NEW";
		vm.franchisee.isActive = true;
		vm.countries = [];
		vm.hasPosModule = Auth.hasCompanyFeature('pos');
		
		/* ************************************************************* */

		// Approve PO
		vm.approveFranchisee = function() {			
			vm.lockButtons = true;
		
			HttpSvc.put('franchisees/approve/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Franchisee has been approved successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		};
		
		/* ************************************************************* */

		vm.selectedStatusChanged = function() {
			vm.franchisee.status = vm.selectedStatus.id;
		}

		vm.selectedBankChanged = function() {
			vm.franchisee.bankName = vm.selectedBank.id;
		}

		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, 'Incomplete Fields');
			
			} else {
			
				HttpSvc.post('franchisees', vm.franchisee, Auth.getTokenId(), false)
					.then(function(result) {
						Auth.selectBranchToken()
							.then(function() {	
								toastr.success('Franchisee has been created successfully.', Auth.translate('SUCCESS'));
								$state.go('franchise.franchiseemgmt.update', {'id': result.id });
							}, function(error) {								
								toastr.error(error, 'Failed');
							});
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		// Do Nothing
	}
	
	/** @ngInject */
    function FranchiseeMgmtUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, UtilSvc, toastr) {

		Auth.init();
		
		var vm = this;

		vm.statuses = [ 
			{id: 'NEW', name: 'NEW'}, 
			{id: 'CONFIRMED', name: 'CONFIRMED'}
		];
		vm.originalStatus = 'NEW';
		vm.selectedStatus = vm.statuses[0];		

		vm.bankList = GetBankList();
		vm.selectedBank = null;
		
		vm.mode = 2;
		vm.franchisee = {};
		vm.countries = [];
		vm.hasPosModule = Auth.hasCompanyFeature('pos');
		
		/* ************************************************************* */

		vm.loadFranchisee = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('franchisees/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.franchisee = result;
					vm.originalStatus = vm.franchisee.status;
					vm.statuses.forEach(function(s) {
						if(s.id==vm.franchisee.status)
						{
							vm.selectedStatus = s;
						}
					});
					vm.bankList.forEach(function(b) {
						if(b.id==vm.franchisee.bankName)
						{
							vm.selectedBank = b;
						}
					});
				}, function() {
					toastr.error('Failed to load selected Franchisee.', Auth.translate('ERROR'))
					$state.go('franchise.franchiseemgmt.list');
					return;
				});		
		};

		vm.approveFranchisee = function() {
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				if(!vm.checkGHLSettings(errorMsg)) return;

				toastr.error(errorMsg, 'Incomplete Fields');
			} else {				
				if(!vm.checkGHLSettings("")) return;

				HttpSvc.put('franchisees/' + $stateParams.id, vm.franchisee, Auth.getTokenId(), false)
					.then(function(result) {
						
						HttpSvc.post('franchisees/approve/' + $stateParams.id, vm.franchisee, Auth.getTokenId(), false)
							.then(function(result) {
								toastr.success('Franchisee has been approved successfully.', Auth.translate('SUCCESS'));						
								$state.reload();
							}, function(error) {
								toastr.error(error, 'Failed');
							});

					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		/* ************************************************************* */

		vm.selectedStatusChanged = function() {
			vm.franchisee.status = vm.selectedStatus.id;
		}

		vm.selectedBankChanged = function() {
			vm.franchisee.bankName = vm.selectedBank.id;
		}

		vm.checkGHLSettings = function(errorMessage) {
			var errorMsg = '';
			if(vm.franchisee.ghlMerchantID=='' || vm.franchisee.ghlMerchantID==null)
			{
				errorMsg += '<li><b>GHL Merchant ID</b></li>';
			}
			if(vm.franchisee.ghlTerminalID=='' || vm.franchisee.ghlTerminalID==null)
			{
				errorMsg += '<li><b>GHL Terminal ID</b></li>';
			}
			if(vm.franchisee.ghlOperatorID=='' || vm.franchisee.ghlOperatorID==null)
			{
				errorMsg += '<li><b>GHL Operator ID</b></li>';
			}

			if(errorMsg) 
			{
				if(errorMessage!="") {
					errorMsg = errorMessage + '<ul>' + errorMsg + '</ul>'
				} else {					
					errorMsg = 'The following field(s) are required:<br /><br /><ul>' + errorMsg + '</ul>';
				}

				toastr.error(errorMsg, 'Incomplete Fields');
				return false;
			}

			return true;
		}

		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, 'Incomplete Fields');
			} else {				
				HttpSvc.put('franchisees/' + $stateParams.id, vm.franchisee, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Franchisee has been updated successfully.', Auth.translate('SUCCESS'));						
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadFranchisee();		
	}
	
	function GetBankList() {
		var bankList = [
			{ id: 'AFFIN BANK', name: 'AFFIN BANK' },
			{ id: 'AGROBANK', name: 'AGROBANK' },
			{ id: 'ALLIANCE BANK', name: 'ALLIANCE BANK' },
			{ id: 'AMBANK', name: 'AMBANK' },
			{ id: 'BANK ISLAM MALAYSIA', name: 'BANK ISLAM MALAYSIA' },
			{ id: 'BANK RAKYAT', name: 'BANK RAKYAT' },
			{ id: 'BANK SIMPANAN NASIONAL', name: 'BANK SIMPANAN NASIONAL' },
			{ id: 'CIMB BANK', name: 'CIMB BANK' },
			{ id: 'CITIBANK', name: 'CITIBANK' },
			{ id: 'HONG LEONG BANK', name: 'HONG LEONG BANK' },
			{ id: 'HSBC BANK MALAYSIA', name: 'HSBC BANK MALAYSIA' },
			{ id: 'MAYBANK', name: 'MAYBANK' },
			{ id: 'OCBC BANK MALAYSIA', name: 'OCBC BANK MALAYSIA' },
			{ id: 'PUBLIC BANK BERHAD', name: 'PUBLIC BANK BERHAD' },
			{ id: 'RHB BANK', name: 'RHB BANK' },
			{ id: 'STANDARD CHARTERED BANK MALAYSIA', name: 'STANDARD CHARTERED BANK MALAYSIA' },
			{ id: 'UOB BANK MALAYSIA', name: 'UOB BANK MALAYSIA' },
		];

		return bankList;
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.inventory.inventorydashboard.controller', [])
        .controller('InventoryDashboardCtrl', InventoryDashboardCtrl);

	/** @ngInject */
    function InventoryDashboardCtrl($scope, $state, $filter, $interval, $uibModal, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		vm.data = [
			{
				description: 'Caramel Sauce Monin',
				quantity: 750,
				uomName: 'ML',
				percentage: 50,
				stockLevelColor: 'warning',
				isStockLowLevel: true,
			},
			{
				description: 'Chocolate Sauce Monin',
				quantity: 450,
				uomName: 'ML',
				percentage: 30,
				stockLevelColor: 'danger',
				isStockLowLevel: true,
			},
			{
				description: 'Extra Direct Liquid Coffee',
				quantity: 950,
				uomName: 'ML',
				percentage: 95,
				stockLevelColor: 'success',
				isStockLowLevel: true,
			},
			{
				description: 'Nescafe Creamer Powder',
				quantity: 850,
				uomName: 'GM',
				percentage: 85,
				stockLevelColor: 'success',
				isStockLowLevel: true,
			},
			{
				description: 'Rose Syrup',
				quantity: 650,
				uomName: 'ML',
				percentage: 65,
				stockLevelColor: 'warning',
				isStockLowLevel: true,
			},
			{
				description: 'Soft Serve Batter',
				quantity: 550,
				uomName: 'ML',
				percentage: 55,
				stockLevelColor: 'warning',
				isStockLowLevel: true,
			},
			{
				description: 'Vanilla Syrup',
				quantity: 550,
				uomName: 'ML',
				percentage: 73,
				stockLevelColor: 'success',
				isStockLowLevel: true,
			},
		];
		vm.isLoading = false;

		/* ******************************************************* */

		vm.loadData = function() {			
			vm.isLoading = true;

			HttpSvc.get('inventory/dashboard/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					//vm.data = result;	
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		};

		vm.loadData();
	}	
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.inventory.inventorylock.controller', [])
        .controller('InvInventoryLockCtrl', InvInventoryLockCtrl)
        .controller('AuditLogModalCtrl', AuditLogModalCtrl);


	/** @ngInject */
    function InvInventoryLockCtrl($scope, $state, $filter, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;
		vm.branchList = [];
		vm.isLoading = false;


		/* ************************************************************* */

		vm.initData = function() {
			var companyList = Auth.getUser().companies;
			var companyId = Auth.getCompanyId();

			companyList.forEach(function(c) {
				if(c.id == companyId)
				{
					vm.branchList = c.branches;
				}
			});

			vm.loadStorageList();
		}

		vm.loadStorageList = function() {
			vm.isLoading = false;

			vm.branchList.forEach(function(b) {
				b.storageList = [];

				HttpSvc.get('storages/list/bybranchid/' + b.id, {}, Auth.getTokenId(), true)
					.then(function(result) {
						b.storageList = result;

                        b.storageList.forEach(function (storage) {
                            storage.lockedDateFrom = storage.lockedDateFrom ? new Date(storage.lockedDateFrom) : null;
                            storage.lockedDateTo = storage.lockedDateTo ? new Date(storage.lockedDateTo) : null;
                        })

						vm.isLoading = false;
					}, function(error) {
						vm.isLoading = false;
						toastr.error('Failed to retrieve storage list. ' + error, Auth.translate('ERROR'));
					});
			});
		}

		/* ************************************************************* */

		vm.updateLock = function(s) {
			if(s.isInventoryLock)
			{
				HttpSvc.put('storages/lock/' + s.id, {}, Auth.getTokenId())
					.then(function() {
						s.isInventoryLock = true;
						toastr.success('Storage [' + s.description + '] has been locked successfully.');
					}, function(error) {
						s.isInventoryLock = false;
						toastr.warning('Failed to lock the storage. ' + error, Auth.translate('ERROR'));
					});
			}
			else
			{
				HttpSvc.put('storages/unlock/' + s.id, {}, Auth.getTokenId())
					.then(function(result) {
						vm.checkResult1(s, result);
					}, function(error) {
						s.isInventoryLock = true;
						toastr.warning('Failed to unlock the storage. ' + error, Auth.translate('ERROR'));
					});
			}
		}

        vm.submit = function (s) {
            if (!vm.validateDates(s)) {
                return;
            }

            var data = {
                storageId: s.id,
                lockedDateFrom: s.lockedDateFrom ? $filter('date')(s.lockedDateFrom, 'yyyy-MM-dd') : null,
                lockedDateTo: s.lockedDateTo ? $filter('date')(s.lockedDateTo, 'yyyy-MM-dd') : null
            };

            HttpSvc.post('storages/updatelockdate/', data, Auth.getTokenId())
                .then(function (response) {
                    toastr.success('Disable POS sync dates updated successfully.');
                }, function (error) {
                    toastr.error('Failed to update disable POS sync dates. ' + error, Auth.translate('ERROR'));
                });
        }

        vm.clear = function (s) {
            s.lockedDateFrom = null;
            s.lockedDateTo = null;

            var data = {
                storageId: s.id,
                lockedDateFrom: s.lockedDateFrom,
                lockedDateTo: s.lockedDateTo
            };

            HttpSvc.post('storages/updatelockdate/', data, Auth.getTokenId())
                .then(function (response) {
                    toastr.success('Disable POS sync dates cleared successfully.');
                }, function (error) {
                    toastr.error('Failed to clear disable POS sync dates. ' + error, Auth.translate('ERROR'));
                });
        }

        vm.showAuditLogModal = function (s) {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'auditLogModal.html',
                controller: 'AuditLogModalCtrl',
                controllerAs: '$mdl',
                size: 'lg',
                resolve: {
                    item: function () {
                        return {
                            storageId: s.id,
                        }
                    }
                }
            });

            modalInstance
                .result
                .then(function (data) {
                }, function () {
                });
        }

        vm.validateDates = function (s) {
            if (s.lockedDateFrom && !s.lockedDateTo) {
                toastr.error('Please fill in the end date to disable POS sync.');
                return false;
            }

            if (!s.lockedDateFrom && s.lockedDateTo) {
                toastr.error('Please fill in the start date to disable POS sync.');
                return false;
            }

            if (s.lockedDateFrom && s.lockedDateTo) {
                if (new Date(s.lockedDateTo) < new Date(s.lockedDateFrom)) {
                    toastr.error('The end date cannot be earlier than the start date.');
                    return false;
                }
            }

            return true;
        }

		vm.checkResult1 = function (s, result)
		{
			if(result.httpStatusCode=="200")
			{
				s.isInventoryLock = false;
				toastr.success('Storage [' + s.description + '] has been unlocked successfully.');
			}
			else if(result.httpStatusCode=="400")
			{
				s.isInventoryLock = true;
				toastr.warning('Failed to unlock the storage. ' + result.message, Auth.translate('ERROR'));
			}
			else
			{
				s.isInventoryLock = false;
				toastr.success('Storage [' + s.description + '] has been unlocked successfully.');
			}
		}

		/* ************************************************************* */

		vm.lockAll = function(b) {
			HttpSvc.put('storages/lock/bybranchid/' + b.id, {}, Auth.getTokenId())
				.then(function() {
					toastr.success('All storages has been locked successfully.');

					HttpSvc.get('storages/list/bybranchid/' + b.id, {}, Auth.getTokenId(), true)
						.then(function(result) {
							b.storageList = result;
							vm.isLoading = false;
						}, function(error) {
							vm.isLoading = false;
							toastr.error('Failed to retrieve storage list. ' + error, Auth.translate('ERROR'));
						});

				}, function(error) {
					toastr.warning('Failed to lock the storages. ' + error, Auth.translate('ERROR'));
				});
		}

		vm.unlockAll = function(b) {
			HttpSvc.put('storages/unlock/bybranchid/' + b.id, {}, Auth.getTokenId())
				.then(function(result) {
					vm.checkResult2(result, b);
				}, function(error) {
					toastr.warning('Failed to unlock the storages. ' + error, 'Unlock Failed');
				});
		}

		vm.checkResult2 = function (result, b)
		{
			if(result.httpStatusCode=="200")
			{
				toastr.success('All storages has been unlocked successfully.');

				HttpSvc.get('storages/list/bybranchid/' + b.id, {}, Auth.getTokenId(), true)
					.then(function(result) {
						b.storageList = result;
						vm.isLoading = false;
					}, function(error) {
						vm.isLoading = false;
						toastr.error('Failed to retrieve storage list. ' + error, Auth.translate('ERROR'));
					});
			}
			else if(result.httpStatusCode=="400")
			{
				toastr.warning('Failed to unlock the storages. ' + result.message, Auth.translate('ERROR'));
				vm.isLoading = false;
			}
			else
			{
				toastr.success('All storages has been unlocked successfully.');

				HttpSvc.get('storages/list/bybranchid/' + b.id, {}, Auth.getTokenId(), true)
					.then(function(result) {
						b.storageList = result;
						vm.isLoading = false;
					}, function(error) {
						vm.isLoading = false;
						toastr.error('Failed to retrieve storage list. ' + error, Auth.translate('ERROR'));
					});
			}
		}

		/* ************************************************************* */

		// Call Actions
		vm.initData();
	}

    function AuditLogModalCtrl($uibModalInstance, item, toastr, HttpSvc, Auth) {
        var $mdl = this;
        $mdl.storageId = item.storageId;
        $mdl.changeLogs = [];


        /* *************************************************** */

        // Load Change Logs
        $mdl.loadChangeLogs = function () {
            //return;
            HttpSvc.get('storagechangelogs/list/' + $mdl.storageId, {}, Auth.getTokenId(), true)
                .then(function (result) {
                    $mdl.changeLogs = result;

                }, function () {
                    toastr.error('Failed to load the Change Logs.', '');
                });
        };

        $mdl.loadChangeLogs();

        /* *************************************************** */

        // Cancel Action
        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.inventory.items.controller', [])
        .controller('InvItemMainCtrl', InvItemMainCtrl)
        .controller('InvItemStockInCtrl', InvItemStockInCtrl)
        .controller('InvItemStockOutCtrl', InvItemStockOutCtrl)
        .controller('InvItemStockAdjCtrl', InvItemStockAdjCtrl)
        .controller('InvItemMovementModalCtrl', InvItemMovementModalCtrl)
        .controller('InvItemLabelModalCtrl', InvItemLabelModalCtrl);

    /** @ngInject */
    function InvItemMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [50, 100, 200, 300, 400, 500];
		vm.pageSize = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.itemDataFull = [];
		vm.itemData = [];
		vm.isLoading = false;
		vm.integrationMode = Auth.getIntegrationMode();
		vm.isCWM = Auth.getSetting_Stock_EnableCatchWeightManagement();
		vm.isRmsLite = Auth.isLiteMode();
		vm.isRmsStarter = Auth.isStarterMode();

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.itemDataFull, tableState.search.predicateObject) : vm.itemDataFull;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.itemData = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {

			var params = {}
			var pagination = tableState.pagination;

			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.itemDataFull.length <= 0) {
				vm.isLoading = true;

				HttpSvc.get('inventory/items/list', params, Auth.getTokenId(), true)
					.then(function(result) {
						vm.numOfRecord = result.length;
						vm.itemDataFull = result;
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		vm.refresh = function() {
			$state.reload();
		}

		/* ************************************************** */

		vm.showMovementModal = function (item) {
			vm.movements = [];

			var modalInstance = $uibModal.open({
				animation: true,
				windowClass: 'app-modal-window',
				templateUrl: 'movementModal.html',
				controller: 'InvItemMovementModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							code: item.code,
							description: item.description,
							itemId: item.id,
							storageId: item.storageId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

        /* ************************************************** */

        vm.showLabelListingModal = function (item) {
			vm.labels = [];

			var modalInstance = $uibModal.open({
				animation: true,
				windowClass: 'app-modal-window',
				templateUrl: 'labelModal.html',
				controller: 'InvItemLabelModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
                            code: item.code,
                            description: item.description,
                            type: "RM",
                            itemId: item.id,
                            uom: "",
                            branchId: item.branchId,
							storageId: item.storageId,
							storageName: item.storageName,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};
	};

    /** @ngInject */
    function InvItemStockInCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.movement = {};
		vm.stock = {};
		vm.stock.storageId = "";
		vm.stock.grnNo = "";
		vm.stock.serialNo = "";
		vm.storageList = [];
		vm.selectedStorage = {};
		vm.showSuccess = false;
		vm.showError = false;
		vm.retainGrnNo = true;
		vm.promptSameBranchError = false;
		vm.ignoreSameBranch = false;
		vm.result = null;

		// Init Data
		vm.initData = function() {
			vm.stock = {};
			vm.stock.storageId = "";
			vm.stock.serialNo = "";
			vm.stock.grnNo = (vm.retainGrnNo ? vm.stock.grnNo : "");

			vm.loadStorageList();
		}

		// Load Storage List
		vm.loadStorageList = function() {
			HttpSvc.get('storages/listbytypes/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Warehouse list.', '');
					return null;
				});
		};

		vm.selectStorage = function() {
			vm.stock.storageId = vm.storageList.selected.id;
		};

		vm.reset = function() {
			vm.dataForm.$setPristine();
			vm.lockButtons = false;
			vm.showError = false;
			vm.promptSameBranchError = false;
			vm.stock.serialNo = "";
			vm.stock.grnNo = (vm.retainGrnNo ? vm.stock.grnNo : "");
		}

		/* ****************************************** */

		vm.continueSameBranch = function() {
			vm.ignoreSameBranch = true;
			vm.submit()
		}

		/* ****************************************** */

		vm.submit = function(form) {
			vm.lockButtons = true;
			vm.showSuccess = false;
			vm.showError = false;

			if(vm.dataForm.$invalid) {
				vm.lockButtons = false;
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				var ignore = (vm.ignoreSameBranch ? '/1' : '');

				HttpSvc.post('inventory/items/stockin' + ignore, vm.stock, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result)
					}, function(error) {
						vm.lockButtons = false;
						vm.showSuccess = false;
						vm.showError = true;
						vm.promptSameBranchError = false;
						vm.errorMessage = error;
					});
			}
		}

		vm.checkResult = function(result) {

			vm.result = result;

			if(result.httpStatusCode=="200")
			{
				vm.lockButtons = false;
				vm.showSuccess = true;
				vm.showError = false;
				vm.promptSameBranchError = false;
				vm.reset();
			}
			else if (result.httpStatusCode=="300")
			{
				vm.lockButtons = true;
				vm.showSuccess = false;
				vm.showError = true;
				vm.promptSameBranchError = true;
				vm.errorMessage = result.message;
			}
			else
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.showError = true;
				vm.promptSameBranchError = false;
				vm.errorMessage = result.message;
			}
		}

		/* ****************************************** */

		vm.initData();
	}

    /** @ngInject */
    function InvItemStockOutCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.movement = {};
		vm.stock = {};
		vm.stock.docNo = "";
		vm.stock.serialNo = "";
		vm.stock.ignoreExp = false;
		vm.stock.ignoreFifo = false;
		vm.stock.ignoreTolerence = false;

		vm.showSuccess = false;
		vm.showError = false;
		vm.retainDocNo = true;
		vm.promptExp = false;
		vm.promptFIFO = false;
		vm.promptTolerence = false;
		vm.promptCwmInput = false;
		vm.promptCwmInput2 = false;
		vm.result = null;

		// Init Data
		vm.initData = function() {
			vm.stock = {};
			vm.stock.serialNo = null;
			vm.stock.docNo = (vm.retainDocNo ? vm.stock.docNo : null);
		}

		vm.reset = function() {
			vm.showError = false;
			vm.promptExp = false;
			vm.promptFIFO = false;
			vm.promptTolerence = false;
			vm.promptCwmInput = false;
			vm.stock.ignoreExp = false;
			vm.stock.ignoreFifo = false;
			vm.stock.ignoreTolerence = false;
			vm.stock.parallel_quantity_1 = null;
			vm.stock.parallel_quantity_2 = null;

			vm.stock.serialNo = null;
			vm.stock.docNo = (vm.retainDocNo ? vm.stock.docNo : null);
			vm.dataForm.$setPristine();
		}

		/* ****************************************** */

		vm.continueExp = function() {
			vm.stock.ignoreExp = true;
			vm.submit()
		}

		vm.continueFifo = function() {
			vm.stock.ignoreFifo = true;
			vm.submit()
		}

		vm.continueTolerence = function() {
			vm.stock.ignoreTolerence = true;
			vm.submit()
		}

		/* ****************************************** */

		vm.submit = function(form) {
			vm.lockButtons = true;
			vm.showSuccess = false;
			vm.showError = false;

			if(vm.dataForm.$invalid) {
				vm.lockButtons = false;
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('stockmgmts/stockout', vm.stock, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						vm.showSuccess = false;
						vm.promptExp = false;
						vm.promptFIFO = false;
						vm.promptTolerence = false;
						vm.promptCwmInput = false;
						vm.showError = true;
						vm.errorMessage = error;
					});
			}
		}

		vm.checkResult = function(result) {

			vm.result = result;

			if(result.statusCode=="100")
			{
				vm.lockButtons = false;
				vm.showSuccess = true;
				vm.showError = false;
				vm.reset();
				vm.successMessage = result.message;
			}
			else if (result.statusCode=="102")
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.promptExp = false;
				vm.promptFIFO = false;
				vm.promptTolerence = false;
				vm.promptCwmInput = true;
				vm.showError = true;
				vm.errorMessage = result.message;
				vm.itemCode = result.itemCode;
				vm.itemName = result.itemName;
				vm.uomName1 = result.uomName;
				vm.uomName2 = result.parallelUomName;
				vm.stock.parallel_quantity_1 = result.quantity1;
				vm.stock.parallel_quantity_2 = result.quantity2;
			}
			else if (result.statusCode=="110")
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.promptExp = true;
				vm.promptFIFO = false;
				vm.promptTolerence = false;
				vm.promptCwmInput = false;
				vm.showError = true;
				vm.errorMessage = result.message;
			}
			else if (result.statusCode=="111")
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.promptExp = false;
				vm.promptFIFO = true;
				vm.promptTolerence = false;
				vm.promptCwmInput = false;
				vm.showError = true;
				vm.errorMessage = result.message;
			}
			else if (result.statusCode=="112")
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.promptExp = false;
				vm.promptFIFO = false;
				vm.promptTolerence = true;
				vm.promptCwmInput = false;
				vm.showError = true;
				vm.errorMessage = result.message;
			}
		}

		vm.initData();
	}

	/** @ngInject */
    function InvItemStockAdjCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.isRmsLite = Auth.isLiteMode();
		vm.isRmsStarter = Auth.isStarterMode();
		vm.isQuickMode = Auth.isStockOutQuickMode();

		vm.adj = {};
		vm.adj.serialNo = "";
		vm.adj.itemCode = "";
		vm.adj.parallel_Quantity_2 = 0;
		vm.storageList = [];
		vm.selectedStorage = null;
		vm.labelInfo = null;
		vm.itemInfo = null;

		/* *************************************************************** */

		vm.initData = function() {
			if(vm.isQuickMode)
			{
				vm.loadStorageList();
			}
		}

		/* *************************************************************** */

		vm.loadStorageList = function() {
			HttpSvc.get('storages/listbytypes/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Warehouse list.', '');
					return null;
				});
		}

		vm.loadLabelInfo = function() {
			var json = {
				serialNo: vm.adj.serialNo
			};
			HttpSvc.post('stockmgmts/mainlabelinfo', json, Auth.getTokenId(), false)
				.then(function(result) {
					vm.labelInfo = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve the Label Information.', '');
					return null;
				});
		}

		vm.loadItemInfo = function() {
			var json = {
				itemCode: vm.adj.itemCode
			};
			HttpSvc.post('stockmgmts/summaryiteminfo', json, Auth.getTokenId(), false)
				.then(function(result) {
					vm.itemInfo = result;
					vm.adj.itemId = result.itemId;
					vm.adj.itemCode = result.itemCode;
					vm.adj.isCWM = result.isCWM;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve the Item Information.', '');
					return null;
				});
		}

		/* *************************************************************** */

		vm.selectedStorageChanged = function()
		{
			vm.adj.storageId = vm.selectedStorage.id
		}

		/* *************************************************************** */

		vm.submit = function() {
			vm.lockButtons = true;

			if(vm.dataForm.$invalid) {
				vm.lockButtons = false;
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.adj.remarks = vm.adj.remarks.toUpperCase();

				var api	= "stockmgmts/stockadjustment";
				if(vm.isQuickMode)
				{
					api = "stockmgmts/stockadjustmentquickmode";
				}

				HttpSvc.post(api, vm.adj, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('<b>Raw Material Stock Adjustment submitted successfully.</b>', Auth.translate('SUCCESS'));
						$state.go('inventory.items.list');
					}, function(error) {
						vm.lockButtons = false;
						toastr.error("Failed to submit Stock Adjustment. " + error, 'Failed');
					});
			}
		}

		// Call Action
		vm.initData();
	}

	/** @ngInject */
	function InvItemMovementModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
		$mdl.code = item.code;
		$mdl.description = item.description;
		$mdl.itemId = item.itemId;

		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfPages = 0;
		$mdl.startIndex = 0;
		$mdl.endIndex = 0;
		$mdl.data = [];
		$mdl.isLoading = false;

		$mdl.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				remarks:  predicate.remarks,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: $mdl.pageSize,
				pageNumber: Math.ceil(($mdl.startIndex + 1) / $mdl.pageSize)
			};

			return params;
		}

		$mdl.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

			$mdl.isLoading = true;

			var params = $mdl.getApiParams(tableState);

			HttpSvc.post('inventory/items/stockmovementlist/lazyload/' + item.itemId + '/' + item.storageId, params, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.isLoading = false;
					$mdl.data = result.data;
					$mdl.numOfRecord = result.numberOfRecords;
					$mdl.numOfPages = result.numberOfPages;
					refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = $mdl.numOfPages;
			return tableState;
		};

		// ********************************************************

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

    /** @ngInject */
    function InvItemLabelModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
        $mdl.code = item.code;
        $mdl.description = item.description;
		$mdl.type = item.type;
		$mdl.branchId = item.branchId;
		$mdl.storageId = item.storageId;
		$mdl.storageName = item.storageName;
        $mdl.itemId = item.itemId;
        $mdl.uom = item.uom;

		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfPages = 0;
		$mdl.startIndex = 0;
		$mdl.endIndex = 0;
		$mdl.data = [];
		$mdl.isLoading = false;

        $mdl.getApiParams = function (tableState) {
            if (!tableState.search.predicateObject) {
                tableState.sort = {};
                tableState.search.predicateObject = {};
                tableState.pagination.start = 0;
            }

            var predicate = tableState.search.predicateObject || {};
            var sortBy = tableState.sort.predicate || '';
            var sortReverse = tableState.sort.reverse ? "1" : "0";

            var params = {
                serialNo: predicate.serialNo || '',
				uom: predicate.uom || '',
				expiryDate: predicate.expiryDate || '',
                sortBy: sortBy,
                sortReverse: sortReverse,
                pageSize: $mdl.pageSize,
                pageNumber: Math.ceil(($mdl.startIndex + 1) / $mdl.pageSize)
            };

            return params;
        };

		$mdl.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

			$mdl.isLoading = true;

			var params = $mdl.getApiParams(tableState);

            var body = {
                type: $mdl.type,
                branchId: $mdl.branchId,
                storageId: $mdl.storageId,
                itemId: $mdl.itemId,
				serialNo: params.serialNo,
				expiryDate: params.expiryDate,
                uom: params.uom,
                pageSize: params.pageSize,
                pageNumber: params.pageNumber,
            }

            HttpSvc.post('labels/lazyload/list/', body, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.isLoading = false;
					$mdl.data = result.data;
					$mdl.numOfRecord = result.numberOfRecords;
					$mdl.numOfPages = result.numberOfPages;
					refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = $mdl.numOfPages;
			return tableState;
		};

		// ********************************************************

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.inventory.itemreturns.controller', [])
        .controller('InvItemReturnMainCtrl', InvItemReturnMainCtrl)
        .controller('InvItemReturnCreateCtrl', InvItemReturnCreateCtrl)
        .controller('InvItemReturnUpdateCtrl', InvItemReturnUpdateCtrl)
        .controller('InvItemReturnItemModelCtrl', InvItemReturnItemModelCtrl);

    /** @ngInject */
    function InvItemReturnMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.docDataFull = [];
		vm.docData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.docDataFull, tableState.search.predicateObject) : vm.docDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.docData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.docDataFull.length <= 0) {
				vm.isLoading = true;
				
				HttpSvc.get('itemreturns/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.isLoading = false;		
						vm.numOfRecord = result.length;	
						vm.docDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						vm.isLoading = false;		
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};		
		
		vm.printReturnForm = function(docId, docNo) {
			
			var filename = "RM_RETURN_" + docNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('itemreturns/print/' + docId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print Raw Material Return Form. ' + error, '');
							return null;
						});
		}
						
		// Complete InvItemReturn
		vm.completeInvItemReturn = function(docId) {			
			HttpSvc.put('itemreturns/complete/' + docId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Raw Material Return Form status updated to COMPLETED.', 'COMPLETED');
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
		
		// Cancel InvItemReturn
		vm.cancelInvItemReturn = function(docId) {			
			HttpSvc.put('itemreturns/cancel/' + docId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Raw Material Return Form status updated to CANCELLED.', 'CANCELLED');
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
	};
	
	/** @ngInject */
    function InvItemReturnCreateCtrl($scope, $state, $filter, $uibModal, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.statuses = ['NEW', 'CONFIRMED'];
		vm.originalStatus = 'NEW';
		vm.selectedStatus = 'NEW';
		vm.selectedDebtor = null;
		vm.selectedStorage = null;

		vm.itemreturn = {};
		vm.itemreturn.status = 'NEW';
		vm.itemreturn.itemReturnDetails = [];
		vm.debtorList = [];	
		vm.storageList = [];	
		
		/* ************************************************************* */
						
		vm.loadDebtorList = function(searchString) {
			vm.lockButtons = true;
			
			HttpSvc.get('debtors/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.debtorList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Customer list.', '');
					return null;
				});
		};

		vm.loadStorageList = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('storages/listbytypes/1', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.storageList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Storage list.', '');
					return null;
				});
		}
		
		/* ************************************************************ */

		vm.selectedDebtorChanged = function() {
			vm.itemreturn.debtorId = vm.selectedDebtor.id;
		}
		
		vm.selectedStorageChanged = function() {
			vm.itemreturn.storageId = vm.selectedStorage.id;
		}
		
		vm.selectedStatusChanged = function() {
			vm.itemreturn.status = vm.selectedStatus;
		}
				
		vm.clearDebtor = function() {
			vm.selectedDebtor = null;
			vm.itemreturn.debtorId = null;
		}

		/* ************************************************************ */
		
		// Remove Item
		vm.removeItem = function(index) {
			vm.itemreturn.itemReturnDetails.splice(index, 1);
			//$scope.$broadcast('refreshStTable');	
		};
			
		// Update Item
		vm.updateItem = function(index, obj) {

			var isFound = false;

			vm.itemreturn.itemReturnDetails.forEach(function(i) {
				if(i.serialNo==obj.serialNo && i.id!=obj.id) {
					toastr.warning('Raw Material with the same Serial Number already on the list.');
					isFound = true;
				}
			});	

			if(isFound){
				toastr.warning('Raw Material with the same Serial Number already on the list.')
				return;
			}

			var element = {
				id: obj.id,
				itemId: obj.itemId,
				itemCode: obj.itemCode,
				itemDescription: obj.itemDescription,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				uomName: obj.uomName,
				serialNo: obj.serialNo,
				reason: obj.reason,
			};
			vm.itemreturn.itemReturnDetails.splice(index, 1, element);
		};

		// Add Item
		vm.addItem = function(obj) {

			var isFound = false;
			
			vm.itemreturn.itemReturnDetails.forEach(function(i) {
				if(i.serialNo==obj.serialNo && i.itemId==obj.itemId) {
					toastr.warning('Raw Material with the same Serial Number already on the list.');
					isFound = true;
				}
			});	

			if(isFound){
				toastr.warning('Raw Material with the same Serial Number already on the list.')
				return;
			}		

			var element = {
				id: obj.id,
				itemId: obj.itemId,
				itemCode: obj.itemCode,
				itemDescription: obj.itemDescription,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				uomName: obj.uomName,
				serialNo: obj.serialNo,
				reason: obj.reason,
			};
			vm.itemreturn.itemReturnDetails.push(element);
		};

		// Refresh Item List
		vm.refreshInvItemReturnItems = function(tableState) {
			// Do nothing
		};	
		
		/* ************************************************************ */		
			
		// Open Modal Dialog
		vm.item = {};		
		vm.showAddItemModal = function () {
			vm.item = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemReturnModal.html',
				controller: 'InvItemReturnItemModelCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "Add",
							object: vm.item,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};	
		
		vm.showEditItemModel = function (index) {
			vm.item = angular.copy(vm.itemreturn.itemReturnDetails[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemReturnModal.html',
				controller: 'InvItemReturnItemModelCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};		
		
		/* ************************************************************ */	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				HttpSvc.post('itemreturns', vm.itemreturn, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Return Document has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('inventory.itemreturns.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadStorageList();
	}
	
	/** @ngInject */
    function InvItemReturnUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;
		vm.mode = 1;
		vm.statuses = ['NEW', 'CONFIRMED'];
		vm.originalStatus = 'NEW';
		vm.selectedStatus = 'NEW';
		vm.selectedDebtor = null;
		vm.selectedStorage = null;

		vm.itemreturn = {};
		vm.itemreturn.status = 'NEW';
		vm.itemreturn.itemReturnDetails = [];
		vm.debtorList = [];	
		vm.storageList = [];
		
		/* ************************************************************* */	
						
		vm.loadDebtorList = function(searchString) {
			vm.lockButtons = true;
			
			HttpSvc.get('debtors/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.debtorList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Customer list.', '');
					return null;
				});
		};

		vm.loadStorageList = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('storages/listbytypes/1', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.storageList = result;
					vm.loadDocument();
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Storage list.', '');
					return null;
				});
		};
		
		// Load Document
		vm.loadDocument = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('itemreturns/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.itemreturn = result;
					vm.originalStatus = vm.itemreturn.status;

					vm.debtorList.push({
						id: vm.itemreturn.debtorId,
						name: vm.itemreturn.customerName
					});
					vm.selectedDebtor = vm.debtorList[0];

					vm.storageList.forEach(function(s) {
						if(s.id==vm.itemreturn.storageId){
							vm.selectedStorage = s;
						}
					});
				}, function() {
					toastr.error('Failed to load selected Return Form.', Auth.translate('ERROR'))
					$state.go('inventory.itemreturns.list');
					return;
				});		
		};
		
		/* ************************************************************ */
		
		// Print
		vm.printDocument = function(docId, docNo) {
			
			var filename = "RM_RETURN_" + docNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('itemreturns/print/' + docId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print Return Form. ' + error, '');
							return null;
						});
		}
		
		// Approve Document
		vm.approveDocument = function() {							  
			HttpSvc.put('itemreturns/approve/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Return Form status updated to APPROVED.', 'APPROVED');
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
		
		// Complete Document
		vm.completeDocument = function() {							  
			HttpSvc.put('itemreturns/complete/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Return Form status updated to COMPLETED.', 'COMPLETED');
					$state.go('inventory.itemreturns.list');
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
		
		// Cancel Document
		vm.cancelDocument = function() {									  
			HttpSvc.put('itemreturns/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Return Form status updated to CANCELLED.', 'CANCELLED');
					$state.go('inventory.itemreturns.list');
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('itemreturns/' + $stateParams.id, vm.itemreturn, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Return Form has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
						//$state.go('inventory.itemreturns.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		/* ************************************************************ */
		
		// Remove Item
		vm.removeItem = function(index) {
			vm.itemreturn.itemReturnDetails.splice(index, 1);
			//$scope.$broadcast('refreshStTable');	
		};
			
		// Update Item
		vm.updateItem = function(index, obj) {

			var isFound = false;

			vm.itemreturn.itemReturnDetails.forEach(function(i) {
				if(i.serialNo==obj.serialNo && i.id!=obj.id) {
					toastr.warning('Raw Material with the same Serial Number already on the list.');
					isFound = true;
				}
			});	

			if(isFound){
				toastr.warning('Raw Material with the same Serial Number already on the list.')
				return;
			}

			var element = {
				id: obj.id,
				itemId: obj.itemId,
				itemCode: obj.itemCode,
				itemDescription: obj.itemDescription,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				uomName: obj.uomName,
				serialNo: obj.serialNo,
				reason: obj.reason,
			};
			vm.itemreturn.itemReturnDetails.splice(index, 1, element);
		};

		// Add Item
		vm.addItem = function(obj) {

			var isFound = false;
			
			vm.itemreturn.itemReturnDetails.forEach(function(i) {
				if(i.serialNo==obj.serialNo && i.itemId==obj.itemId) {
					toastr.warning('Raw Material with the same Serial Number already on the list.');
					isFound = true;
				}
			});	

			if(isFound){
				toastr.warning('Raw Material with the same Serial Number already on the list.')
				return;
			}		

			var element = {
				id: obj.id,
				itemId: obj.itemId,
				itemCode: obj.itemCode,
				itemDescription: obj.itemDescription,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				uomName: obj.uomName,
				serialNo: obj.serialNo,
				reason: obj.reason,
			};
			vm.itemreturn.itemReturnDetails.push(element);
		};

		// Refresh Item List
		vm.refreshInvItemReturnItems = function(tableState) {
			// Do nothing
		};	
		
		/* ************************************************************ */		
			
		// Open Modal Dialog
		vm.item = {};		
		vm.showAddItemModal = function () {
			vm.item = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemReturnModal.html',
				controller: 'InvItemReturnItemModelCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "Add",
							object: vm.item,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};	
		vm.showEditItemModel = function (index) {
			vm.item = angular.copy(vm.itemreturn.itemReturnDetails[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemReturnModal.html',
				controller: 'InvItemReturnItemModelCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};		
		
		/* ************************************************************ */		
		
		// Call Actions
		vm.loadStorageList();
	}
			
	// Item Modal Controller
	function InvItemReturnItemModelCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.item = item.object;
		$mdl.isLoading = false;
		$mdl.isSubmitting = false;
		$mdl.serialNotValid = true;

		/* ************************************************* */

		// Initialize
		if(item.mode==1) {
			$mdl.item.id = "00000000-0000-0000-0000-000000000000";
			$mdl.item.itemId = "";
			$mdl.item.itemCode = "";
			$mdl.item.itemDescription = "";
			$mdl.item.quantity = 1;
			$mdl.item.unitOfMeasurementId = "";
			$mdl.item.uomName = "";
			$mdl.item.serialNo = "";
			$mdl.item.reason = "";
		} else {
			$mdl.item.id = item.object.id;
			$mdl.item.itemId = item.object.itemId;
			$mdl.item.itemCode = item.object.itemCode;
			$mdl.item.itemDescription = item.object.itemDescription;
			$mdl.item.quantity = item.object.quantity;
			$mdl.item.unitOfMeasurementId = item.object.unitOfMeasurementId;
			$mdl.item.uomName = item.object.uomName;
			$mdl.item.serialNo = item.object.serialNo;
			$mdl.item.reason = item.object.reason;
		}

		//Exchange for Sensor with External Probe
		
		/* ************************************************* */

		$mdl.getLabelInfo = function() {
			$mdl.isLoading = true;

			var params = { serialNo: $mdl.item.serialNo };

			HttpSvc.post('labels/item/labelinfo', params, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.item.itemId = result.itemId,
					$mdl.item.itemCode = result.itemCode;
					$mdl.item.itemDescription = result.itemName;
					$mdl.item.unitOfMeasurementId = result.uomId;
					$mdl.item.uomName = result.uomName;
					toastr.success('Raw Material Label Info successfully retrieved.', Auth.translate('SUCCESS'))
					$mdl.serialNotValid = false;
					$mdl.isLoading = false;
				}, function() {
					$mdl.item.itemId = "",
					$mdl.item.itemCode = "";
					$mdl.item.itemDescription = "";
					$mdl.item.unitOfMeasurementId = "";
					$mdl.item.uomName = "";
					toastr.error('Invalid Serial Number. Please try again.', Auth.translate('ERROR'))
					$mdl.serialNotValid = true;
					$mdl.isLoading = false;
				});		
		}

		/* ************************************************* */
		
		$mdl.confirmModal = function() {	
			
			if($mdl.rawMatForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.inventory.itemstockcounts.controller', [])
        .controller('InvItemStockCountMainCtrl', InvItemStockCountMainCtrl)
        .controller('InvItemStockCountCreateCtrl', InvItemStockCountCreateCtrl)
		.controller('InvItemStockCountUpdateCtrl', InvItemStockCountUpdateCtrl)
        .controller('InvItemStockCountLabelModalCtrl', InvItemStockCountLabelModalCtrl)

    /** @ngInject */
    function InvItemStockCountMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.data = [];
		vm.isLoading = false;

		vm.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.docNo,
				branchName: predicate.branchName,
				storageName: predicate.storageName,
				assigneeName: predicate.assigneeName,
				status: predicate.status,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('itemstockcount/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			return tableState;
		};

		vm.resetSearch = function()
		{
		}

		/* ************************************************** */

		vm.printPDF = function(itemId, docNo) {

			var filename = "StockCount_RawMat_" + docNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('itemstockcount/print/pdf/' + itemId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate PDF. ' + error, '');
							return null;
						});
		}

		vm.printExcel = function(itemId, docNo) {

			var filename = "StockCount_RawMat_" + docNo.replace("/", "_") + ".xlsx";

			HttpSvc.getExcelObject('itemstockcount/print/excel/' + itemId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate Excel. ' + error, '');
							return null;
						});
		}

		/* ************************************************** */

		vm.showLabelModal = function (grn) {

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'labelModal.html',
				controller: 'InvItemStockCountLabelModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							receivingId: grn.id,
							receivingNo: grn.receivingNo,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};
	};

	/** @ngInject */
    function InvItemStockCountCreateCtrl($scope, $state, $filter, $timeout, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;

		vm.statuses = [
			{id: 'NEW', name: 'NEW'},
			{id: 'READY TO COUNT', name: 'READY TO COUNT'}
		];
		vm.mode = 1;
		vm.branches = [];
		vm.storages = [];
		vm.assignees = [];

		vm.pageSizeOption = [10, 30, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.stockcount = {};
		vm.stockcount.items = [];
		vm.stockcount.itemsFiltered = [];
		vm.isLoading = false;

		/* ****************************************************** */

		vm.initData = function() {
			vm.stockcount.status = "NEW";
			vm.stockcount.isPartialCount = true;
			vm.stockcount.remarks = "";
			vm.originalStatus = 'NEW';
			vm.selectedStatus = vm.statuses[0];

			vm.loadBranches();
		}

		vm.loadBranches = function() {
			vm.isLoading = true;

			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.loadStorages = function() {
			HttpSvc.get('storages/list/bybranchid/' + vm.stockcount.branchId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storages = [];
					result.forEach(function(r) {
						if(r.type==1)
						{
							vm.storages.push(r);
						}
					});
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.loadUsers = function() {
			HttpSvc.get('users/list/stockcount/' + vm.stockcount.storageId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.assignees = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ****************************************************** */

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ?
								$filter('filter')(vm.stockcount.items, tableState.search.predicateObject) :
								vm.stockcount.items;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.stockcount.itemsFiltered = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {

			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.stockcount.items.length <= 0 && !vm.isLoading) {
				vm.isLoading = true;

				// Load UOM List
				HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.uomList = result;

						// Load Requisition Items
						/* HttpSvc.get('requisitions/defaultitems', {}, Auth.getTokenId(), true)
							.then(function(result) {
								vm.isLoading = false;
								vm.numOfRecord = result.length;
								vm.stockcount.items = result;
								refreshTableState(tableState, vm.startIndex, vm.endIndex);
							}, function() {
								vm.isLoading = false;
								toastr.error('Failed to retrieve data.', '');
								return null;
						}); */
						vm.isLoading = false;
					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Failed');
					});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		/* ****************************************************** */

		// Select Status
		vm.selectStatus = function() {
			vm.stockcount.status = vm.selectedStatus.id;
		};

		// Select Branch
		vm.selectBranch = function() {
			vm.stockcount.branchId = vm.selectedBranch.id;
			this.loadStorages();
		};

		// Select Storage
		vm.selectStorage = function() {
			vm.stockcount.storageId = vm.selectedStorage.id;
			vm.stockcount.assigneeId = null;
			vm.loadUsers();
		};

		// Select Assignee
		vm.selectAssignee = function() {
			vm.stockcount.assigneeId = vm.selectedAssignee.id;
		};

		/* ****************************************************** */

		// Form Submission
		vm.submit = function() {
			vm.lockButtons = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {
				HttpSvc.post('itemstockcount', vm.stockcount, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Stock Count has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('inventory.itemstockcounts.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
    function InvItemStockCountUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.statuses = [
			{id: 'NEW', name: 'NEW'},
			{id: 'READY TO COUNT', name: 'READY TO COUNT'}
		];
		vm.mode = 2;
		vm.branches = [];
		vm.storages = [];
		vm.assignees = [];
		vm.currency = Auth.getCurrency();

		vm.pageSizeOption = [10, 30, 50, 100];
		vm.pageSize = 30;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.stockcount = {};
		vm.stockcount.items = [];
		vm.stockcount.itemsFiltered = [];
		vm.isLoading = false;

		/* ****************************************************** */

		vm.initData = function() {
			vm.stockcount.status = "";
			vm.originalStatus = "";
			vm.selectedStatus = vm.statuses[0];
			vm.stockcount.remarks = "";
		}

		vm.isPositive = function(diff) {
			if(diff>=0)
				return true;
			else
				return false;
		}

		vm.loadStorages = function() {
			HttpSvc.get('storages/list/bybranchid/' + vm.stockcount.branchId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storages = [];
					result.forEach(function(r) {
						if(r.type==1)
						{
							vm.storages.push(r);
						}
					});

					vm.storages.forEach(function(s) {
						if(s.id==vm.stockcount.storageId) {
							vm.selectedStorage = s;
						}
					});

					vm.loadUsers();
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.loadUsers = function() {
			HttpSvc.get('users/list/stockcount/' + vm.stockcount.storageId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.assignees = result;

					vm.assignees.forEach(function(a) {
						if(a.id==vm.stockcount.assigneeId) {
							vm.selectedAssignee = a;
						}
					});
					vm.isLoading = false;

				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ****************************************************** */

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ?
								$filter('filter')(vm.stockcount.items, tableState.search.predicateObject) :
								vm.stockcount.items;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.stockcount.itemsFiltered = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.stockcount.items.length <= 0 && !vm.isLoading) {
				vm.isLoading = true;

				vm.initData();

				HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.branches = result;

						HttpSvc.get('itemstockcount/' + $stateParams.id, {}, Auth.getTokenId(), false)
							.then(function(result) {
								vm.stockcount = result;
								vm.originalStatus = vm.stockcount.status;

								vm.statuses.forEach(function(s) {
									if(s.id==vm.stockcount.status) {
										vm.selectedStatus = s;
									}
								});

								vm.branches.forEach(function(b) {
									if(b.id==vm.stockcount.branchId) {
										vm.selectedBranch = b;
									}
								});

								vm.loadStorages();

								vm.numOfRecord = vm.stockcount.items.length;
								refreshTableState(tableState, vm.startIndex, vm.endIndex);

							}, function(error) {
								vm.isLoading = false;
								toastr.error(error, 'Failed');
							});

				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});

			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		/* ****************************************************** */

		// Select Status
		vm.selectStatus = function() {
			vm.stockcount.status = vm.selectedStatus.id;
		};

		// Select Branch
		vm.selectBranch = function() {
			vm.stockcount.branchId = vm.selectedBranch.id;
			vm.loadStorages();
		};

		// Select Storage
		vm.selectStorage = function() {
			vm.stockcount.storageId = vm.selectedStorage.id;
			vm.stockcount.assigneeId = null;
			vm.loadUsers();
		};

		// Select Assignee
		vm.selectAssignee = function() {
			vm.stockcount.assigneeId = vm.selectedAssignee.id;
		};

		/* ****************************************************** */

		vm.approveStockCount = function() {
			vm.lockButtons = true;

			var scEntryList = [];
			vm.stockcount.items.forEach(function(i) {
				if (i.isCounted)
				{
					var obj = {};
					obj.detailId = i.id;
					obj.isExcluded = i.isExcluded;
					scEntryList.push(obj);
				}
			})

			HttpSvc.post('itemstockcount/approve/' + $stateParams.id, scEntryList, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Stock Count has been APPROVED successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}

		vm.cancelStockCount = function() {
			vm.lockButtons = true;

			HttpSvc.post('itemstockcount/cancel/' + $stateParams.id, vm.stockcount, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Stock Count has been CANCELLED.', Auth.translate('SUCCESS'));
					$state.go('inventory.itemstockcounts.list');
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}

		vm.postStockCount = function() {
			vm.lockButtons = true;

			HttpSvc.post('itemstockcount/post/' + $stateParams.id, vm.stockcount, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success(vm.stockcount.docNo + ' posted. This will take a few minutes for processing.');
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}

		/* ****************************************************** */

		vm.showMovementModal = function (item) {
			vm.movements = [];

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'countIDetailModal.html',
				controller: 'InvItemStockCountLabelModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							detailId: item.id,
							itemCode: item.itemCode,
							itemName: item.itemDescription,
							docNo: vm.stockcount.docNo
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

		/* ************************************************** */

		vm.printPDF = function() {

			var filename = "StockCount_RawMat_" + vm.stockcount.docNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('itemstockcount/print/pdf/' + vm.stockcount.id, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate PDF. ' + error, '');
							return null;
						});
		}

		vm.printExcel = function() {

			var filename = "StockCount_RawMat_" + vm.stockcount.docNo.replace("/", "_") + ".xlsx";

			HttpSvc.getExcelObject('itemstockcount/print/excel/' + vm.stockcount.id, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate Excel. ' + error, '');
							return null;
						});
		}

		/* ****************************************************** */

		// Form Submission
		vm.submit = function() {
			vm.lockButtons = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {
				HttpSvc.put('itemstockcount/' + $stateParams.id, vm.stockcount, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Status has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
	function InvItemStockCountLabelModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
		$mdl.item = {};
		$mdl.item.detailId = item.detailId;
		$mdl.item.docNo = item.docNo;
		$mdl.item.itemCode = item.itemCode;
		$mdl.item.itemName = item.itemName;

		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfRecordFiltered = 0;
		$mdl.numOfRecordDisplayed = 0;
		$mdl.startIndex = 0;
		$mdl.endIndex = 0;
		$mdl.labelDataFull = [];
		$mdl.labelData = [];
		$mdl.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.labelDataFull, tableState.search.predicateObject) : $mdl.labelDataFull;
			$mdl.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			$mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
			$mdl.labelData = result;

			tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		$mdl.retrieveData = function(tableState) {

			var params = {}
			var pagination = tableState.pagination;
			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

			if($mdl.labelDataFull.length <= 0) {
				$mdl.isLoading = true;

				HttpSvc.get('itemstockcount/info/list/' + $mdl.item.detailId, {}, Auth.getTokenId(), true)
					.then(function(result) {
						$mdl.item.isCwm = result[0].isCwm;
						$mdl.numOfRecord = result[0].infoList.length;
						$mdl.labelDataFull = result[0].infoList;
						refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
						$mdl.isLoading = false;
					}, function() {
						$mdl.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
			}
		};

		// ********************************************************

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.inventory.productstockcounts.controller', [])
        .controller('InvProductStockCountMainCtrl', InvProductStockCountMainCtrl)
        .controller('InvProductStockCountCreateCtrl', InvProductStockCountCreateCtrl)
		.controller('InvProductStockCountUpdateCtrl', InvProductStockCountUpdateCtrl)
        .controller('InvProductStockCountLabelModalCtrl', InvProductStockCountLabelModalCtrl)

    /** @ngInject */
    function InvProductStockCountMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.data = [];
		vm.isLoading = false;

		vm.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.docNo,
				branchName: predicate.branchName,
				storageName: predicate.storageName,
				assigneeName: predicate.assigneeName,
				status: predicate.status,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('productstockcount/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			return tableState;
		};

		vm.resetSearch = function()
		{
		}

		/* ************************************************** */

		vm.printPDF = function(itemId, docNo) {

			var filename = "StockCount_FG_" + docNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('productstockcount/print/pdf/' + itemId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate PDF. ' + error, '');
							return null;
						});
		}

		vm.printExcel = function(itemId, docNo) {

			var filename = "StockCount_FG_" + docNo.replace("/", "_") + ".xlsx";

			HttpSvc.getExcelObject('productstockcount/print/excel/' + itemId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate Excel. ' + error, '');
							return null;
						});
		}

		/* ************************************************** */

		vm.showLabelModal = function (grn) {

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'labelModal.html',
				controller: 'InvProductStockCountLabelModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							receivingId: grn.id,
							receivingNo: grn.receivingNo,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};
	};

	/** @ngInject */
    function InvProductStockCountCreateCtrl($scope, $state, $filter, $timeout, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;

		vm.statuses = [
			{id: 'NEW', name: 'NEW'},
			{id: 'READY TO COUNT', name: 'READY TO COUNT'}
		];
		vm.mode = 1;
		vm.branches = [];
		vm.storages = [];
		vm.assignees = [];

		vm.pageSizeOption = [10, 30, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.stockcount = {};
		vm.stockcount.items = [];
		vm.stockcount.itemsFiltered = [];
		vm.isLoading = false;

		/* ****************************************************** */

		vm.initData = function() {
			vm.stockcount.status = "NEW";
			vm.stockcount.isPartialCount = true;
			vm.stockcount.remarks = "";
			vm.originalStatus = 'NEW';
			vm.selectedStatus = vm.statuses[0];

			vm.loadBranches();
		}

		vm.loadBranches = function() {
			vm.isLoading = true;

			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.loadStorages = function() {
			HttpSvc.get('storages/list/bybranchid/' + vm.stockcount.branchId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storages = [];
					result.forEach(function(r) {
						if(r.type==2)
						{
							vm.storages.push(r);
						}
					});
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.loadUsers = function() {
			HttpSvc.get('users/list/stockcount/' + vm.stockcount.storageId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.assignees = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ****************************************************** */

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ?
								$filter('filter')(vm.stockcount.items, tableState.search.predicateObject) :
								vm.stockcount.items;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.stockcount.itemsFiltered = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {

			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.stockcount.items.length <= 0 && !vm.isLoading) {
				vm.isLoading = true;

				// Load UOM List
				HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.uomList = result;

						// Load Requisition Items
						/* HttpSvc.get('requisitions/defaultitems', {}, Auth.getTokenId(), true)
							.then(function(result) {
								vm.isLoading = false;
								vm.numOfRecord = result.length;
								vm.stockcount.items = result;
								refreshTableState(tableState, vm.startIndex, vm.endIndex);
							}, function() {
								vm.isLoading = false;
								toastr.error('Failed to retrieve data.', '');
								return null;
						}); */
						vm.isLoading = false;
					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Failed');
					});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		/* ****************************************************** */

		// Select Status
		vm.selectStatus = function() {
			vm.stockcount.status = vm.selectedStatus.id;
		};

		// Select Branch
		vm.selectBranch = function() {
			vm.stockcount.branchId = vm.selectedBranch.id;
			this.loadStorages();
		};

		// Select Storage
		vm.selectStorage = function() {
			vm.stockcount.storageId = vm.selectedStorage.id;
			vm.stockcount.assigneeId = null;
			vm.loadUsers();
		};

		// Select Assignee
		vm.selectAssignee = function() {
			vm.stockcount.assigneeId = vm.selectedAssignee.id;
		};

		/* ****************************************************** */

		// Form Submission
		vm.submit = function() {
			vm.lockButtons = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {
				HttpSvc.post('productstockcount', vm.stockcount, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Stock Count has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('inventory.productstockcounts.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
    function InvProductStockCountUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.statuses = [
			{id: 'NEW', name: 'NEW'},
			{id: 'READY TO COUNT', name: 'READY TO COUNT'}
		];
		vm.mode = 2;
		vm.branches = [];
		vm.storages = [];
		vm.assignees = [];
		vm.currency = Auth.getCurrency();

		vm.pageSizeOption = [10, 30, 50, 100];
		vm.pageSize = 30;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.stockcount = {};
		vm.stockcount.items = [];
		vm.stockcount.itemsFiltered = [];
		vm.isLoading = false;

		/* ****************************************************** */

		vm.initData = function() {
			vm.stockcount.status = "";
			vm.originalStatus = "";
			vm.selectedStatus = vm.statuses[0];
			vm.stockcount.remarks = "";
		}

		vm.isPositive = function(diff) {
			if(diff>=0)
				return true;
			else
				return false;
		}

		vm.loadStorages = function() {
			HttpSvc.get('storages/list/bybranchid/' + vm.stockcount.branchId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storages = [];
					result.forEach(function(r) {
						if(r.type==2)
						{
							vm.storages.push(r);
						}
					});

					vm.storages.forEach(function(s) {
						if(s.id==vm.stockcount.storageId) {
							vm.selectedStorage = s;
						}
					});

					vm.loadUsers();
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.loadUsers = function() {
			HttpSvc.get('users/list/stockcount/' + vm.stockcount.storageId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.assignees = result;

					vm.assignees.forEach(function(a) {
						if(a.id==vm.stockcount.assigneeId) {
							vm.selectedAssignee = a;
						}
					});
					vm.isLoading = false;

				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ****************************************************** */

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ?
								$filter('filter')(vm.stockcount.items, tableState.search.predicateObject) :
								vm.stockcount.items;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.stockcount.itemsFiltered = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.stockcount.items.length <= 0 && !vm.isLoading) {
				vm.isLoading = true;

				vm.initData();

				HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.branches = result;

						HttpSvc.get('productstockcount/' + $stateParams.id, {}, Auth.getTokenId(), false)
							.then(function(result) {
								vm.stockcount = result;
								vm.originalStatus = vm.stockcount.status;

								vm.statuses.forEach(function(s) {
									if(s.id==vm.stockcount.status) {
										vm.selectedStatus = s;
									}
								});

								vm.branches.forEach(function(b) {
									if(b.id==vm.stockcount.branchId) {
										vm.selectedBranch = b;
									}
								});

								vm.loadStorages();

								vm.assignees.forEach(function(a) {
									if(a.id==vm.stockcount.assigneeId) {
										vm.selectedAssignee = a;
									}
								});
								vm.isLoading = false;

								vm.numOfRecord = vm.stockcount.items.length;
								refreshTableState(tableState, vm.startIndex, vm.endIndex);

							}, function(error) {
								vm.isLoading = false;
								toastr.error(error, 'Failed');
							});

				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});

			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		/* ****************************************************** */

		// Select Status
		vm.selectStatus = function() {
			vm.stockcount.status = vm.selectedStatus.id;
		};

		// Select Branch
		vm.selectBranch = function() {
			vm.stockcount.branchId = vm.selectedBranch.id;
			vm.loadStorages();
		};

		// Select Storage
		vm.selectStorage = function() {
			vm.stockcount.storageId = vm.selectedStorage.id;
		};

		// Select Assignee
		vm.selectAssignee = function() {
			vm.stockcount.assigneeId = vm.selectedAssignee.id;
		};

		/* ****************************************************** */

		vm.approveStockCount = function() {
			vm.lockButtons = true;

			var scEntryList = [];
			vm.stockcount.items.forEach(function(i) {
				if (i.isCounted)
				{
					var obj = {};
					obj.detailId = i.id;
					obj.isExcluded = i.isExcluded;
					scEntryList.push(obj);
				}
			})

			HttpSvc.post('productstockcount/approve/' + $stateParams.id, scEntryList, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Stock Count has been APPROVED successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}

		vm.cancelStockCount = function() {
			vm.lockButtons = true;

			HttpSvc.post('productstockcount/cancel/' + $stateParams.id, vm.stockcount, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Stock Count has been CANCELLED.', Auth.translate('SUCCESS'));
					$state.go('inventory.productstockcounts.list');
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}

		vm.postStockCount = function() {
			vm.lockButtons = true;

			HttpSvc.post('productstockcount/post/' + $stateParams.id, vm.stockcount, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success(vm.stockcount.docNo + ' posted. This will take a few minutes for processing.');
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}

		/* ****************************************************** */

		vm.showMovementModal = function (item) {
			vm.movements = [];

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'countIDetailModal.html',
				controller: 'InvProductStockCountLabelModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							detailId: item.id,
							itemCode: item.itemCode,
							itemName: item.itemDescription,
							docNo: vm.stockcount.docNo
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

		/* ************************************************** */

		vm.printPDF = function() {

			var filename = "StockCount_FG_" + vm.stockcount.docNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('productstockcount/print/pdf/' + vm.stockcount.id, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate PDF. ' + error, '');
							return null;
						});
		}

		vm.printExcel = function() {

			var filename = "StockCount_FG_" + vm.stockcount.docNo.replace("/", "_") + ".xlsx";

			HttpSvc.getExcelObject('productstockcount/print/excel/' + vm.stockcount.id, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate Excel. ' + error, '');
							return null;
						});
		}

		/* ****************************************************** */

		// Form Submission
		vm.submit = function() {
			vm.lockButtons = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {
				HttpSvc.put('productstockcount/' + $stateParams.id, vm.stockcount, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Status has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
	function InvProductStockCountLabelModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
		$mdl.item = {};
		$mdl.item.detailId = item.detailId;
		$mdl.item.docNo = item.docNo;
		$mdl.item.itemCode = item.itemCode;
		$mdl.item.itemName = item.itemName;

		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfRecordFiltered = 0;
		$mdl.numOfRecordDisplayed = 0;
		$mdl.startIndex = 0;
		$mdl.endIndex = 0;
		$mdl.labelDataFull = [];
		$mdl.labelData = [];
		$mdl.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.labelDataFull, tableState.search.predicateObject) : $mdl.labelDataFull;
			$mdl.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			$mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
			$mdl.labelData = result;

			tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		$mdl.retrieveData = function(tableState) {

			var params = {}
			var pagination = tableState.pagination;
			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

			if($mdl.labelDataFull.length <= 0) {
				$mdl.isLoading = true;

				HttpSvc.get('productstockcount/info/list/' + $mdl.item.detailId, {}, Auth.getTokenId(), true)
					.then(function(result) {
						$mdl.item.isCwm = result[0].isCwm;
						$mdl.numOfRecord = result[0].infoList.length;
						$mdl.labelDataFull = result[0].infoList;
						refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
						$mdl.isLoading = false;
					}, function() {
						$mdl.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
			}
		};

		// ********************************************************

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.inventory.products.controller', [])
        .controller('InvProductMainCtrl', InvProductMainCtrl)
        .controller('InvProductStockInCtrl', InvProductStockInCtrl)
        .controller('InvProductStockOutCtrl', InvProductStockOutCtrl)
        .controller('InvProductStockAdjCtrl', InvProductStockAdjCtrl)
        .controller('InvProductMovementModalCtrl', InvProductMovementModalCtrl)
        .controller('InvProductLabelModalCtrl', InvProductLabelModalCtrl);

	/** @ngInject */
	function InvProductMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [50, 100, 200, 300, 400, 500];
		vm.pageSize = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.itemDataFull = [];
		vm.itemData = [];
		vm.isLoading = false;
		vm.integrationMode = Auth.getIntegrationMode();
		vm.isCWM = Auth.getSetting_Stock_EnableCatchWeightManagement();
		vm.isRmsLite = Auth.isLiteMode();
		vm.isRmsStarter = Auth.isStarterMode();

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.itemDataFull, tableState.search.predicateObject) : vm.itemDataFull;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.itemData = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {

			var params = {}
			var pagination = tableState.pagination;

			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.itemDataFull.length <= 0) {
				vm.isLoading = true;

				HttpSvc.get('inventory/products/list', params, Auth.getTokenId(), true)
					.then(function(result) {
						vm.numOfRecord = result.length;
						vm.itemDataFull = result;
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		vm.refresh = function() {
			$state.reload();
		}

		/* ************************************************** */

		vm.showMovementModal = function (item) {
			vm.movements = [];

			var modalInstance = $uibModal.open({
				animation: true,
				windowClass: 'app-modal-window',
				templateUrl: 'movementModal.html',
				controller: 'InvProductMovementModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							code: item.code,
							name: item.name,
							productId: item.id,
							storageId: item.storageId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

        vm.showLabelListingModal = function (item) {
            vm.labels = [];

            var modalInstance = $uibModal.open({
                animation: true,
                windowClass: 'app-modal-window',
                templateUrl: 'labelModal.html',
                controller: 'InvProductLabelModalCtrl',
                controllerAs: '$mdl',
                size: 'lg',
                resolve: {
                    item: function () {
                        return {
                            code: item.code,
                            name: item.name,
                            type: "FG",
                            itemId: item.id,
                            uom: "",
                            branchId: item.branchId,
							storageId: item.storageId,
							storageName: item.storageName
                        }
                    }
                }
            });

            modalInstance
                .result
                .then(function (data) {
                }, function () {
                });
        };
	};

	/** @ngInject */
	function InvProductStockInCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.movement = {};
		vm.stock = {};
		vm.stock.storageId = "";
		vm.stock.docNo = "";
		vm.stock.serialNo = "";
		vm.storageList = [];
		vm.selectedStorage = {};
		vm.showSuccess = false;
		vm.showError = false;
		vm.retainDocNo = true;
		vm.promptSameBranchError = false;
		vm.ignoreSameBranch = false;
		vm.result = null;

		// Init Data
		vm.initData = function() {
			vm.stock = {};
			vm.stock.storageId = "";
			vm.stock.serialNo = "";
			vm.stock.docNo = (vm.retainDocNo ? vm.stock.docNo : "");

			vm.loadStorageList();
		}

		// Load Storage List
		vm.loadStorageList = function() {
			HttpSvc.get('storages/listbytypes/2', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Warehouse list.', '');
					return null;
				});
		};

		vm.selectStorage = function() {
			vm.stock.storageId = vm.storageList.selected.id;
		};

		vm.reset = function() {
			vm.dataForm.$setPristine();
			vm.lockButtons = false;
			vm.showError = false;
			vm.promptSameBranchError = false;
			vm.stock.serialNo = "";
		}

		/* ****************************************** */

		vm.continueSameBranch = function() {
			vm.ignoreSameBranch = true;
			vm.submit()
		}

		/* ****************************************** */

		vm.submit = function(form) {
			vm.lockButtons = true;
			vm.showSuccess = false;
			vm.showError = false;

			if(vm.dataForm.$invalid) {
				vm.lockButtons = false;
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				var ignore = (vm.ignoreSameBranch ? '/1' : '');

				HttpSvc.post('inventory/products/stockin' + ignore, vm.stock, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						vm.showSuccess = false;
						vm.showError = true;
						vm.errorMessage = error;
					});
			}
		}

		vm.checkResult = function(result) {

			vm.result = result;

			if(result.httpStatusCode=="200")
			{
				vm.lockButtons = false;
				vm.showSuccess = true;
				vm.showError = false;
				vm.promptSameBranchError = false;
				vm.reset();
			}
			else if (result.httpStatusCode=="300")
			{
				vm.lockButtons = true;
				vm.showSuccess = false;
				vm.showError = true;
				vm.promptSameBranchError = true;
				vm.errorMessage = result.message;
			}
			else
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.showError = true;
				vm.promptSameBranchError = false;
				vm.errorMessage = result.message;
			}
		}

		vm.initData();
	}

	/** @ngInject */
	function InvProductStockOutCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.movement = {};
		vm.stock = {};
		vm.stock.docNo = "";
		vm.stock.serialNo = "";
		vm.stock.ignoreExp = false;
		vm.stock.ignoreFifo = false;
		vm.stock.ignoreTolerence = false;
		vm.showSuccess = false;
		vm.showError = false;
		vm.retainDocNo = true;
		vm.promptExp = false;
		vm.promptFIFO = false;
		vm.promptTolerence = false;
		vm.promptCwmInput = false;
		vm.promptCwmInput2 = false;
		vm.result = null;

		// Init Data
		vm.initData = function() {
			vm.stock = {};
			vm.stock.serialNo = null;
			vm.stock.docNo = (vm.retainDocNo ? vm.stock.docNo : null);
		}

		vm.reset = function() {
			vm.showError = false;
			vm.promptExp = false;
			vm.promptFIFO = false;
			vm.promptTolerence = false;
			vm.promptCwmInput = false;
			vm.stock.ignoreExp = false;
			vm.stock.ignoreFifo = false;
			vm.stock.ignoreTolerence = false;
			vm.stock.parallel_quantity_1 = null;
			vm.stock.parallel_quantity_2 = null;

			vm.stock.serialNo = null;
			vm.stock.docNo = (vm.retainDocNo ? vm.stock.docNo : null);
			vm.dataForm.$setPristine();
		}

		/* ****************************************** */

		vm.continueExp = function() {
			vm.stock.ignoreExp = true;
			vm.submit()
		}

		vm.continueFifo = function() {
			vm.stock.ignoreFifo = true;
			vm.submit()
		}

		vm.continueTolerence = function() {
			vm.stock.ignoreTolerence = true;
			vm.submit()
		}

		/* ****************************************** */

		vm.submit = function(form) {
			vm.lockButtons = true;
			vm.showSuccess = false;
			vm.showError = false;

			if(vm.dataForm.$invalid) {
				vm.lockButtons = false;
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('stockmgmts/stockout', vm.stock, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						vm.showSuccess = false;
						vm.promptExp = false;
						vm.promptFIFO = false;
						vm.promptTolerence = false;
						vm.promptCwmInput = false;
						vm.showError = true;
						vm.errorMessage = error;
					});
			}
		}

		vm.checkResult = function(result) {

			vm.result = result;

			if(result.statusCode=="100")
			{
				vm.lockButtons = false;
				vm.showSuccess = true;
				vm.showError = false;
				vm.reset();
				vm.successMessage = result.message;
			}
			else if (result.statusCode=="102")
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.promptExp = false;
				vm.promptFIFO = false;
				vm.promptTolerence = false;
				vm.promptCwmInput = true;
				vm.showError = true;
				vm.errorMessage = result.message;
				vm.itemCode = result.itemCode;
				vm.itemName = result.itemName;
				vm.uomName1 = result.uomName;
				vm.uomName2 = result.parallelUomName;
				vm.stock.parallel_quantity_1 = result.quantity1;
				vm.stock.parallel_quantity_2 = result.quantity2;
			}
			else if (result.statusCode=="110")
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.promptExp = true;
				vm.promptFIFO = false;
				vm.promptTolerence = false;
				vm.promptCwmInput = false;
				vm.showError = true;
				vm.errorMessage = result.message;
			}
			else if (result.statusCode=="111")
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.promptExp = false;
				vm.promptFIFO = true;
				vm.promptTolerence = false;
				vm.promptCwmInput = false;
				vm.showError = true;
				vm.errorMessage = result.message;
			}
			else if (result.statusCode=="112")
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.promptExp = false;
				vm.promptFIFO = false;
				vm.promptTolerence = true;
				vm.promptCwmInput = false;
				vm.showError = true;
				vm.errorMessage = result.message;
			}
		}

		vm.initData();
	}

	/** @ngInject */
	function InvProductStockAdjCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.isRmsLite = Auth.isLiteMode();
		vm.isRmsStarter = Auth.isStarterMode();
		vm.isQuickMode = Auth.isStockOutQuickMode();

		vm.adj = {};
		vm.adj.serialNo = "";
		vm.adj.itemCode = "";
		vm.adj.parallel_Quantity_2 = 0;
		vm.storageList = [];
		vm.selectedStorage = null;
		vm.labelInfo = null;
		vm.itemInfo = null;

		/* *************************************************************** */

		vm.initData = function() {
			if(vm.isQuickMode)
			{
				vm.loadStorageList();
			}
		}

		/* *************************************************************** */

		vm.loadStorageList = function() {
			HttpSvc.get('storages/listbytypes/2', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Warehouse list.', '');
					return null;
				});
		}

		vm.loadLabelInfo = function() {
			var json = {
				serialNo: vm.adj.serialNo
			};
			HttpSvc.post('stockmgmts/mainlabelinfo', json, Auth.getTokenId(), false)
				.then(function(result) {
					vm.labelInfo = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve the Label Information.', '');
					return null;
				});
		}

		vm.loadItemInfo = function() {
			var json = {
				itemCode: vm.adj.itemCode
			};
			HttpSvc.post('stockmgmts/summaryiteminfo', json, Auth.getTokenId(), false)
				.then(function(result) {
					vm.itemInfo = result;
					vm.adj.itemId = result.itemId;
					vm.adj.itemCode = result.itemCode;
					vm.adj.isCWM = result.isCWM;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve the Item Information.', '');
					return null;
				});
		}

		/* *************************************************************** */

		vm.selectedStorageChanged = function()
		{
			vm.adj.storageId = vm.selectedStorage.id
		}

		/* *************************************************************** */

		vm.submit = function() {
			vm.lockButtons = true;

			if(vm.dataForm.$invalid) {
				vm.lockButtons = false;
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.adj.remarks = vm.adj.remarks.toUpperCase();

				var api	= "stockmgmts/stockadjustment";
				if(vm.isQuickMode)
				{
					api = "stockmgmts/stockadjustmentquickmode";
				}

				HttpSvc.post(api, vm.adj, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('<b>Finished Goods Stock Adjustment submitted successfully.</b>', Auth.translate('SUCCESS'));
						$state.go('inventory.products.list');
					}, function(error) {
						vm.lockButtons = false;
						toastr.error("Failed to submit Stock Adjustment. " + error, 'Failed');
					});
			}
		}

		// Call Action
		vm.initData();
	}

	/** @ngInject */
	function InvProductMovementModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
		$mdl.code = item.code;
		$mdl.name = item.name;
		$mdl.productId = item.productId;

		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfPages = 0;
		$mdl.startIndex = 0;
		$mdl.endIndex = 0;
		$mdl.data = [];
		$mdl.isLoading = false;

		$mdl.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				remarks:  predicate.remarks,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: $mdl.pageSize,
				pageNumber: Math.ceil(($mdl.startIndex + 1) / $mdl.pageSize)
			};

			return params;
		}

		$mdl.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

			$mdl.isLoading = true;

			var params = $mdl.getApiParams(tableState);

			HttpSvc.post('inventory/products/stockmovementlist/lazyload/' + item.productId + '/' + item.storageId, params, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.isLoading = false;
					$mdl.data = result.data;
					$mdl.numOfRecord = result.numberOfRecords;
					$mdl.numOfPages = result.numberOfPages;
					refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = $mdl.numOfPages;
			return tableState;
		};

		// ********************************************************

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

    /** @ngInject */
    function InvProductLabelModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
        var $mdl = this;
        $mdl.code = item.code;
        $mdl.name = item.name;
        $mdl.type = item.type;
        $mdl.branchId = item.branchId;
        $mdl.storageId = item.storageId;
        $mdl.itemId = item.itemId;
		$mdl.uom = item.uom;
		$mdl.storageName = item.storageName;

        $mdl.pageSize = 10;
        $mdl.numOfRecord = 0;
        $mdl.numOfPages = 0;
        $mdl.startIndex = 0;
        $mdl.endIndex = 0;
        $mdl.data = [];
        $mdl.isLoading = false;

        $mdl.getApiParams = function (tableState) {
            if (!tableState.search.predicateObject) {
                tableState.sort = {};
                tableState.search.predicateObject = {};
                tableState.pagination.start = 0;
            }

            var predicate = tableState.search.predicateObject;
            var sortBy = tableState.sort.predicate || '';
            var sortReverse = tableState.sort.reverse ? "1" : "0";

            var params = {
                serialNo: predicate.serialNo || '',
				uom: predicate.uom || '',
				expiryDate: predicate.expiryDate || '',
                sortBy: sortBy,
                sortReverse: sortReverse,
                pageSize: $mdl.pageSize,
                pageNumber: Math.ceil(($mdl.startIndex + 1) / $mdl.pageSize)
            };

            return params;
        };


        $mdl.retrieveData = function (tableState) {

            var pagination = tableState.pagination;

            $mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
            $mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

            $mdl.isLoading = true;

            var params = $mdl.getApiParams(tableState);

            var body = {
                type: $mdl.type,
                branchId: $mdl.branchId,
                storageId: $mdl.storageId,
                itemId: $mdl.itemId,
                serialNo: params.serialNo,
                uom: params.uom,
				expiryDate: params.expiryDate,
                pageSize: params.pageSize,
                pageNumber: params.pageNumber,
            }

            HttpSvc.post('labels/lazyload/list/', body, Auth.getTokenId(), false)
                .then(function (result) {
                    $mdl.isLoading = false;
                    $mdl.data = result.data;
                    $mdl.numOfRecord = result.numberOfRecords;
                    $mdl.numOfPages = result.numberOfPages;
                    refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
                }, function (error) {
                    $mdl.isLoading = false;
                    toastr.error('Failed to retrieve data.', '');
                    return null;
                });
        };

        function refreshTableState(tableState) {
            tableState.pagination.numberOfPages = $mdl.numOfPages;
            return tableState;
        };

        // ********************************************************

        // Cancel Action
        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.inventory.semifgs.controller', [])
        .controller('InvSfgMainCtrl', InvSfgMainCtrl)
        .controller('InvSfgStockInCtrl', InvSfgStockInCtrl)
        .controller('InvSfgStockOutCtrl', InvSfgStockOutCtrl)
        .controller('InvSfgStockAdjCtrl', InvSfgStockAdjCtrl)
        .controller('InvSfgMovementModalCtrl', InvSfgMovementModalCtrl)
        .controller('InvSfgLabelModalCtrl', InvSfgLabelModalCtrl);

    /** @ngInject */
    function InvSfgMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [50, 100, 200, 300, 400, 500];
		vm.pageSize = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.itemDataFull = [];
		vm.itemData = [];
		vm.isLoading = false;
		vm.integrationMode = Auth.getIntegrationMode();
		vm.isCWM = Auth.getSetting_Stock_EnableCatchWeightManagement();
		vm.isRmsLite = Auth.isLiteMode();
		vm.isRmsStarter = Auth.isStarterMode();

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.itemDataFull, tableState.search.predicateObject) : vm.itemDataFull;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.itemData = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {

			var params = {}
			var pagination = tableState.pagination;

			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.itemDataFull.length <= 0) {
				vm.isLoading = true;

				HttpSvc.get('inventory/semifgs/list', params, Auth.getTokenId(), true)
					.then(function(result) {
						vm.numOfRecord = result.length;
						vm.itemDataFull = result;
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		vm.refresh = function() {
			$state.reload();
		}

		/* ************************************************** */

		vm.showMovementModal = function (item) {
			vm.movements = [];

			var modalInstance = $uibModal.open({
				animation: true,
				windowClass: 'app-modal-window',
				templateUrl: 'movementModal.html',
				controller: 'InvSfgMovementModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							code: item.code,
							description: item.description,
							productId: item.id,
							storageId: item.storageId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

        /* ************************************************** */

        vm.showLabelListingModal = function (item) {
            vm.labels = [];

            var modalInstance = $uibModal.open({
                animation: true,
                windowClass: 'app-modal-window',
                templateUrl: 'labelModal.html',
                controller: 'InvSfgLabelModalCtrl',
                controllerAs: '$mdl',
                size: 'lg',
                resolve: {
                    item: function () {
                        return {
                            code: item.code,
                            description: item.description,
                            type: "SEMIFG",
                            itemId: item.id,
                            uom: "",
                            branchId: item.branchId,
							storageId: item.storageId,
							storageName: item.storageName
                        }
                    }
                }
            });

            modalInstance
                .result
                .then(function (data) {
                }, function () {
                });
        };
	};

    /** @ngInject */
    function InvSfgStockInCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.movement = {};
		vm.stock = {};
		vm.stock.storageId = "";
		vm.stock.docNo = "";
		vm.stock.serialNo = "";
		vm.storageList = [];
		vm.selectedStorage = {};
		vm.showSuccess = false;
		vm.showError = false;
		vm.retainDocNo = true;
		vm.promptSameBranchError = false;
		vm.ignoreSameBranch = false;
		vm.result = null;

		// Init Data
		vm.initData = function() {
			vm.stock = {};
			vm.stock.storageId = "";
			vm.stock.serialNo = "";
			vm.stock.jobNo = (vm.retainDocNo ? vm.stock.jobNo : "");

			vm.loadStorageList();
		}

		// Load Storage List
		vm.loadStorageList = function() {
			HttpSvc.get('storages/listbytypes/3', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Warehouse list.', '');
					return null;
				});
		};

		vm.selectStorage = function() {
			vm.stock.storageId = vm.storageList.selected.id;
		};

		vm.reset = function() {
			vm.dataForm.$setPristine();
			vm.lockButtons = false;
			vm.showError = false;
			vm.promptSameBranchError = false;
			vm.stock.serialNo = "";
			vm.stock.jobNo = (vm.retainDocNo ? vm.stock.jobNo : "");
		}

		/* ****************************************** */

		vm.continueSameBranch = function() {
			vm.ignoreSameBranch = true;
			vm.submit()
		}

		/* ****************************************** */

		vm.submit = function(form) {
			vm.lockButtons = true;
			vm.showSuccess = false;
			vm.showError = false;

			if(vm.dataForm.$invalid) {
				vm.lockButtons = false;
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				var ignore = (vm.ignoreSameBranch ? '/1' : '');

				HttpSvc.post('inventory/semifgs/stockin' + ignore, vm.stock, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						vm.showSuccess = false;
						vm.showError = true;
						vm.errorMessage = error;
					});
			}
		}

		vm.checkResult = function(result) {

			vm.result = result;

			if(result.httpStatusCode=="200")
			{
				vm.lockButtons = false;
				vm.showSuccess = true;
				vm.showError = false;
				vm.promptSameBranchError = false;
				vm.reset();
			}
			else if (result.httpStatusCode=="300")
			{
				vm.lockButtons = true;
				vm.showSuccess = false;
				vm.showError = true;
				vm.promptSameBranchError = true;
				vm.errorMessage = result.message;
			}
			else
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.showError = true;
				vm.promptSameBranchError = false;
				vm.errorMessage = result.message;
			}
		}

		vm.initData();
	}

    /** @ngInject */
    function InvSfgStockOutCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.movement = {};
		vm.stock = {};
		vm.stock.docNo = "";
		vm.stock.serialNo = "";
		vm.stock.ignoreExp = false;
		vm.stock.ignoreFifo = false;
		vm.stock.ignoreTolerence = false;
		vm.showSuccess = false;
		vm.showError = false;
		vm.retainDocNo = true;
		vm.promptExp = false;
		vm.promptFIFO = false;
		vm.promptTolerence = false;
		vm.promptCwmInput = false;
		vm.promptCwmInput2 = false;
		vm.result = null;

		// Init Data
		vm.initData = function() {
			vm.stock = {};
			vm.stock.serialNo = null;
			vm.stock.docNo = (vm.retainDocNo ? vm.stock.docNo : null);
		}

		vm.reset = function() {
			vm.showError = false;
			vm.promptExp = false;
			vm.promptFIFO = false;
			vm.promptTolerence = false;
			vm.promptCwmInput = false;
			vm.stock.ignoreExp = false;
			vm.stock.ignoreFifo = false;
			vm.stock.ignoreTolerence = false;
			vm.stock.parallel_quantity_1 = null;
			vm.stock.parallel_quantity_2 = null;

			vm.stock.serialNo = null;
			vm.stock.docNo = (vm.retainDocNo ? vm.stock.docNo : null);
			vm.dataForm.$setPristine();
		}

		/* ****************************************** */

		vm.continueExp = function() {
			vm.stock.ignoreExp = true;
			vm.submit()
		}

		vm.continueFifo = function() {
			vm.stock.ignoreFifo = true;
			vm.submit()
		}

		vm.continueTolerence = function() {
			vm.stock.ignoreTolerence = true;
			vm.submit()
		}

		/* ****************************************** */

		vm.submit = function(form) {
			vm.lockButtons = true;
			vm.showSuccess = false;
			vm.showError = false;

			if(vm.dataForm.$invalid) {
				vm.lockButtons = false;
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('stockmgmts/stockout', vm.stock, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						vm.showSuccess = false;
						vm.promptExp = false;
						vm.promptFIFO = false;
						vm.promptTolerence = false;
						vm.promptCwmInput = false;
						vm.showError = true;
						vm.errorMessage = error;
					});
			}
		}

		vm.checkResult = function(result) {

			vm.result = result;

			if(result.statusCode=="100")
			{
				vm.lockButtons = false;
				vm.showSuccess = true;
				vm.showError = false;
				vm.reset();
				vm.successMessage = result.message;
			}
			else if (result.statusCode=="102")
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.promptExp = false;
				vm.promptFIFO = false;
				vm.promptTolerence = false;
				vm.promptCwmInput = true;
				vm.showError = true;
				vm.errorMessage = result.message;
				vm.itemCode = result.itemCode;
				vm.itemName = result.itemName;
				vm.uomName1 = result.uomName;
				vm.uomName2 = result.parallelUomName;
				vm.stock.parallel_quantity_1 = result.quantity1;
				vm.stock.parallel_quantity_2 = result.quantity2;
			}
			else if (result.statusCode=="110")
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.promptExp = true;
				vm.promptFIFO = false;
				vm.promptTolerence = false;
				vm.promptCwmInput = false;
				vm.showError = true;
				vm.errorMessage = result.message;
			}
			else if (result.statusCode=="111")
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.promptExp = false;
				vm.promptFIFO = true;
				vm.promptTolerence = false;
				vm.promptCwmInput = false;
				vm.showError = true;
				vm.errorMessage = result.message;
			}
			else if (result.statusCode=="112")
			{
				vm.lockButtons = false;
				vm.showSuccess = false;
				vm.promptExp = false;
				vm.promptFIFO = false;
				vm.promptTolerence = true;
				vm.promptCwmInput = false;
				vm.showError = true;
				vm.errorMessage = result.message;
			}
		}

		vm.initData();
	}

    /** @ngInject */
    function InvSfgStockAdjCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.isRmsLite = Auth.isLiteMode();
		vm.isRmsStarter = Auth.isStarterMode();
		vm.isQuickMode = Auth.isStockOutQuickMode();

		vm.adj = {};
		vm.adj.serialNo = "";
		vm.adj.itemCode = "";
		vm.adj.parallel_Quantity_2 = 0;
		vm.storageList = [];
		vm.selectedStorage = null;
		vm.labelInfo = null;
		vm.itemInfo = null;

		/* *************************************************************** */

		vm.initData = function() {
			if(vm.isQuickMode)
			{
				vm.loadStorageList();
			}
		}

		/* *************************************************************** */

		vm.loadStorageList = function() {
			HttpSvc.get('storages/listbytypes/3', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Warehouse list.', '');
					return null;
				});
		}

		vm.loadLabelInfo = function() {
			var json = {
				serialNo: vm.adj.serialNo
			};
			HttpSvc.post('stockmgmts/mainlabelinfo', json, Auth.getTokenId(), false)
				.then(function(result) {
					vm.labelInfo = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve the Label Information.', '');
					return null;
				});
		}

		vm.loadItemInfo = function() {
			var json = {
				itemCode: vm.adj.itemCode
			};
			HttpSvc.post('stockmgmts/summaryiteminfo', json, Auth.getTokenId(), false)
				.then(function(result) {
					vm.itemInfo = result;
					vm.adj.itemId = result.itemId;
					vm.adj.itemCode = result.itemCode;
					vm.adj.isCWM = result.isCWM;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve the Item Information.', '');
					return null;
				});
		}

		/* *************************************************************** */

		vm.selectedStorageChanged = function()
		{
			vm.adj.storageId = vm.selectedStorage.id
		}

		/* *************************************************************** */

		vm.submit = function() {
			vm.lockButtons = true;

			if(vm.dataForm.$invalid) {
				vm.lockButtons = false;
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.adj.remarks = vm.adj.remarks.toUpperCase();

				var api	= "stockmgmts/stockadjustment";
				if(vm.isQuickMode)
				{
					api = "stockmgmts/stockadjustmentquickmode";
				}

				HttpSvc.post(api, vm.adj, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('<b>Semi FG Stock Adjustment submitted successfully.</b>', Auth.translate('SUCCESS'));
						$state.go('inventory.semifgs.list');
					}, function(error) {
						vm.lockButtons = false;
						toastr.error("Failed to submit Stock Adjustment. " + error, 'Failed');
					});
			}
		}

		// Call Action
		vm.initData();
	}

	/** @ngInject */
	function InvSfgMovementModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
		$mdl.code = item.code;
		$mdl.name = item.description;
		$mdl.productId = item.productId;

		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfPages = 0;
		$mdl.startIndex = 0;
		$mdl.endIndex = 0;
		$mdl.data = [];
		$mdl.isLoading = false;

		$mdl.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				remarks:  predicate.remarks,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: $mdl.pageSize,
				pageNumber: Math.ceil(($mdl.startIndex + 1) / $mdl.pageSize)
			};

			return params;
		}

		$mdl.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

			$mdl.isLoading = true;

			var params = $mdl.getApiParams(tableState);

			HttpSvc.post('inventory/semifgs/stockmovementlist/lazyload/' + item.productId + '/' + item.storageId, params, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.isLoading = false;
					$mdl.data = result.data;
					$mdl.numOfRecord = result.numberOfRecords;
					$mdl.numOfPages = result.numberOfPages;
					refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = $mdl.numOfPages;
			return tableState;
		};

		// ********************************************************

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

    /** @ngInject */
    function InvSfgLabelModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
        var $mdl = this;
        $mdl.code = item.code;
        $mdl.name = item.description;
        $mdl.type = item.type;
        $mdl.branchId = item.branchId;
        $mdl.storageId = item.storageId;
        $mdl.itemId = item.itemId;
		$mdl.uom = item.uom;
		$mdl.storageName = item.storageName;

        $mdl.pageSize = 10;
        $mdl.numOfRecord = 0;
        $mdl.numOfPages = 0;
        $mdl.startIndex = 0;
        $mdl.endIndex = 0;
        $mdl.data = [];
        $mdl.isLoading = false;

        $mdl.getApiParams = function (tableState) {
            if (!tableState.search.predicateObject) {
                tableState.sort = {};
                tableState.search.predicateObject = {};
                tableState.pagination.start = 0;
            }

            var predicate = tableState.search.predicateObject;
            var sortBy = tableState.sort.predicate || '';
            var sortReverse = tableState.sort.reverse ? "1" : "0";

            var params = {
                serialNo: predicate.serialNo || '',
				uom: predicate.uom || '',
				expiryDate: predicate.expiryDate || '',
                sortBy: sortBy,
                sortReverse: sortReverse,
                pageSize: $mdl.pageSize,
                pageNumber: Math.ceil(($mdl.startIndex + 1) / $mdl.pageSize)
            };

            return params;
        };


        $mdl.retrieveData = function (tableState) {

            var pagination = tableState.pagination;

            $mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
            $mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

            $mdl.isLoading = true;

            var params = $mdl.getApiParams(tableState);

            var body = {
                type: $mdl.type,
                branchId: $mdl.branchId,
                storageId: $mdl.storageId,
                itemId: $mdl.itemId,
                serialNo: params.serialNo,
                uom: params.uom,
				expiryDate: params.expiryDate,
                pageSize: params.pageSize,
                pageNumber: params.pageNumber,
            }

            HttpSvc.post('labels/lazyload/list/', body, Auth.getTokenId(), false)
                .then(function (result) {
                    $mdl.isLoading = false;
                    $mdl.data = result.data;
                    $mdl.numOfRecord = result.numberOfRecords;
                    $mdl.numOfPages = result.numberOfPages;
                    refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
                }, function (error) {
                    $mdl.isLoading = false;
                    toastr.error('Failed to retrieve data.', '');
                    return null;
                });
        };

        function refreshTableState(tableState) {
            tableState.pagination.numberOfPages = $mdl.numOfPages;
            return tableState;
        };

        // ********************************************************

        // Cancel Action
        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.inventory.semifgstockcounts.controller', [])
        .controller('InvSemiFgStockCountMainCtrl', InvSemiFgStockCountMainCtrl)
        .controller('InvSemiFgStockCountCreateCtrl', InvSemiFgStockCountCreateCtrl)
		.controller('InvSemiFgStockCountUpdateCtrl', InvSemiFgStockCountUpdateCtrl)
        .controller('InvSemiFgStockCountLabelModalCtrl', InvSemiFgStockCountLabelModalCtrl)

    /** @ngInject */
    function InvSemiFgStockCountMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.data = [];
		vm.isLoading = false;

		vm.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.docNo,
				branchName: predicate.branchName,
				storageName: predicate.storageName,
				assigneeName: predicate.assigneeName,
				status: predicate.status,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('semifgstockcount/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			return tableState;
		};

		vm.resetSearch = function()
		{
		}

		/* ************************************************** */

		vm.printPDF = function(itemId, docNo) {

			var filename = "StockCount_SemiFG_" + docNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('semifgstockcount/print/pdf/' + itemId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate PDF. ' + error, '');
							return null;
						});
		}

		vm.printExcel = function(itemId, docNo) {

			var filename = "StockCount_SemiFG_" + docNo.replace("/", "_") + ".xlsx";

			HttpSvc.getExcelObject('semifgstockcount/print/excel/' + itemId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate Excel. ' + error, '');
							return null;
						});
		}

		/* ************************************************** */

		vm.showLabelModal = function (grn) {

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'labelModal.html',
				controller: 'InvSemiFgStockCountLabelModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							receivingId: grn.id,
							receivingNo: grn.receivingNo,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};
	};

	/** @ngInject */
    function InvSemiFgStockCountCreateCtrl($scope, $state, $filter, $timeout, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;

		vm.statuses = [
			{id: 'NEW', name: 'NEW'},
			{id: 'READY TO COUNT', name: 'READY TO COUNT'}
		];
		vm.mode = 1;
		vm.branches = [];
		vm.storages = [];
		vm.assignees = [];

		vm.pageSizeOption = [10, 30, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.stockcount = {};
		vm.stockcount.items = [];
		vm.stockcount.itemsFiltered = [];
		vm.isLoading = false;

		/* ****************************************************** */

		vm.initData = function() {
			vm.stockcount.status = "NEW";
			vm.stockcount.isPartialCount = true;
			vm.stockcount.remarks = "";
			vm.originalStatus = 'NEW';
			vm.selectedStatus = vm.statuses[0];

			vm.loadBranches();
		}

		vm.loadBranches = function() {
			vm.isLoading = true;

			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.loadStorages = function() {
			HttpSvc.get('storages/list/bybranchid/' + vm.stockcount.branchId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storages = [];
					result.forEach(function(r) {
						if(r.type==3)
						{
							vm.storages.push(r);
						}
					});
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.loadUsers = function() {
			HttpSvc.get('users/list/stockcount/' + vm.stockcount.storageId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.assignees = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ****************************************************** */

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ?
								$filter('filter')(vm.stockcount.items, tableState.search.predicateObject) :
								vm.stockcount.items;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.stockcount.itemsFiltered = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {

			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.stockcount.items.length <= 0 && !vm.isLoading) {
				vm.isLoading = true;

				// Load UOM List
				HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.uomList = result;

						// Load Requisition Items
						/* HttpSvc.get('requisitions/defaultitems', {}, Auth.getTokenId(), true)
							.then(function(result) {
								vm.isLoading = false;
								vm.numOfRecord = result.length;
								vm.stockcount.items = result;
								refreshTableState(tableState, vm.startIndex, vm.endIndex);
							}, function() {
								vm.isLoading = false;
								toastr.error('Failed to retrieve data.', '');
								return null;
						}); */
						vm.isLoading = false;
					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Failed');
					});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		/* ****************************************************** */

		// Select Status
		vm.selectStatus = function() {
			vm.stockcount.status = vm.selectedStatus.id;
		};

		// Select Branch
		vm.selectBranch = function() {
			vm.stockcount.branchId = vm.selectedBranch.id;
			this.loadStorages();
		};

		// Select Storage
		vm.selectStorage = function() {
			vm.stockcount.storageId = vm.selectedStorage.id;
			vm.stockcount.assigneeId = null;
			vm.loadUsers();
		};

		// Select Assignee
		vm.selectAssignee = function() {
			vm.stockcount.assigneeId = vm.selectedAssignee.id;
		};

		/* ****************************************************** */

		// Form Submission
		vm.submit = function() {
			vm.lockButtons = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {
				HttpSvc.post('semifgstockcount', vm.stockcount, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Stock Count has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('inventory.semifgstockcounts.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
    function InvSemiFgStockCountUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.statuses = [
			{id: 'NEW', name: 'NEW'},
			{id: 'READY TO COUNT', name: 'READY TO COUNT'}
		];
		vm.mode = 2;
		vm.branches = [];
		vm.storages = [];
		vm.assignees = [];
		vm.currency = Auth.getCurrency();

		vm.pageSizeOption = [10, 30, 50, 100];
		vm.pageSize = 30;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.stockcount = {};
		vm.stockcount.items = [];
		vm.stockcount.itemsFiltered = [];
		vm.isLoading = false;

		/* ****************************************************** */

		vm.initData = function() {
			vm.stockcount.status = "";
			vm.originalStatus = "";
			vm.selectedStatus = vm.statuses[0];
			vm.stockcount.remarks = "";
		}

		vm.isPositive = function(diff) {
			if(diff>=0)
				return true;
			else
				return false;
		}

		vm.loadStorages = function() {
			HttpSvc.get('storages/list/bybranchid/' + vm.stockcount.branchId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storages = [];
					result.forEach(function(r) {
						if(r.type==3)
						{
							vm.storages.push(r);
						}
					});

					vm.storages.forEach(function(s) {
						if(s.id==vm.stockcount.storageId) {
							vm.selectedStorage = s;
						}
					});

					vm.loadUsers();
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.loadUsers = function() {
			HttpSvc.get('users/list/stockcount/' + vm.stockcount.storageId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.assignees = result;

					vm.assignees.forEach(function(a) {
						if(a.id==vm.stockcount.assigneeId) {
							vm.selectedAssignee = a;
						}
					});
					vm.isLoading = false;

				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ****************************************************** */

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ?
								$filter('filter')(vm.stockcount.items, tableState.search.predicateObject) :
								vm.stockcount.items;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.stockcount.itemsFiltered = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.stockcount.items.length <= 0 && !vm.isLoading) {
				vm.isLoading = true;

				vm.initData();

				HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.branches = result;

						HttpSvc.get('semifgstockcount/' + $stateParams.id, {}, Auth.getTokenId(), false)
							.then(function(result) {
								vm.stockcount = result;
								vm.originalStatus = vm.stockcount.status;

								vm.statuses.forEach(function(s) {
									if(s.id==vm.stockcount.status) {
										vm.selectedStatus = s;
									}
								});

								vm.branches.forEach(function(b) {
									if(b.id==vm.stockcount.branchId) {
										vm.selectedBranch = b;
									}
								});

								vm.loadStorages();

								vm.numOfRecord = vm.stockcount.items.length;
								refreshTableState(tableState, vm.startIndex, vm.endIndex);

							}, function(error) {
								vm.isLoading = false;
								toastr.error(error, 'Failed');
							});

				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});

			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		/* ****************************************************** */

		// Select Status
		vm.selectStatus = function() {
			vm.stockcount.status = vm.selectedStatus.id;
		};

		// Select Branch
		vm.selectBranch = function() {
			vm.stockcount.branchId = vm.selectedBranch.id;
			vm.loadStorages();
		};

		// Select Storage
		vm.selectStorage = function() {
			vm.stockcount.storageId = vm.selectedStorage.id;
			vm.stockcount.assigneeId = null;
			vm.loadUsers();
		};

		// Select Assignee
		vm.selectAssignee = function() {
			vm.stockcount.assigneeId = vm.selectedAssignee.id;
		};

		/* ****************************************************** */

		vm.approveStockCount = function() {
			vm.lockButtons = true;

			var scEntryList = [];
			vm.stockcount.items.forEach(function(i) {
				if (i.isCounted)
				{
					var obj = {};
					obj.detailId = i.id;
					obj.isExcluded = i.isExcluded;
					scEntryList.push(obj);
				}
			})

			HttpSvc.post('semifgstockcount/approve/' + $stateParams.id, scEntryList, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Stock Count has been APPROVED successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}

		vm.cancelStockCount = function() {
			vm.lockButtons = true;

			HttpSvc.post('semifgstockcount/cancel/' + $stateParams.id, vm.stockcount, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Stock Count has been CANCELLED.', Auth.translate('SUCCESS'));
					$state.go('inventory.semifgstockcounts.list');
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}

		vm.postStockCount = function() {
			vm.lockButtons = true;

			HttpSvc.post('semifgstockcount/post/' + $stateParams.id, vm.stockcount, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success(vm.stockcount.docNo + ' posted. This will take a few minutes for processing.');
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}

		/* ****************************************************** */

		vm.showMovementModal = function (item) {
			vm.movements = [];

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'countIDetailModal.html',
				controller: 'InvSemiFgStockCountLabelModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							detailId: item.id,
							itemCode: item.itemCode,
							itemName: item.itemDescription,
							docNo: vm.stockcount.docNo
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

		/* ************************************************** */

		vm.printPDF = function() {

			var filename = "StockCount_SemiFG_" + vm.stockcount.docNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('semifgstockcount/print/pdf/' + vm.stockcount.id, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate PDF. ' + error, '');
							return null;
						});
		}

		vm.printExcel = function() {

			var filename = "StockCount_SemiFG_" + vm.stockcount.docNo.replace("/", "_") + ".xlsx";

			HttpSvc.getExcelObject('semifgstockcount/print/excel/' + vm.stockcount.id, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate Excel. ' + error, '');
							return null;
						});
		}

		/* ****************************************************** */

		// Form Submission
		vm.submit = function() {
			vm.lockButtons = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {
				HttpSvc.put('semifgstockcount/' + $stateParams.id, vm.stockcount, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Status has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
	function InvSemiFgStockCountLabelModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
		$mdl.item = {};
		$mdl.item.detailId = item.detailId;
		$mdl.item.docNo = item.docNo;
		$mdl.item.itemCode = item.itemCode;
		$mdl.item.itemName = item.itemName;

		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfRecordFiltered = 0;
		$mdl.numOfRecordDisplayed = 0;
		$mdl.startIndex = 0;
		$mdl.endIndex = 0;
		$mdl.labelDataFull = [];
		$mdl.labelData = [];
		$mdl.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.labelDataFull, tableState.search.predicateObject) : $mdl.labelDataFull;
			$mdl.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			$mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
			$mdl.labelData = result;

			tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		$mdl.retrieveData = function(tableState) {

			var params = {}
			var pagination = tableState.pagination;
			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

			if($mdl.labelDataFull.length <= 0) {
				$mdl.isLoading = true;

				HttpSvc.get('semifgstockcount/info/list/' + $mdl.item.detailId, {}, Auth.getTokenId(), true)
					.then(function (result) {
						$mdl.item.isCwm = result[0].isCwm;
						$mdl.numOfRecord = result[0].infoList.length;
						$mdl.labelDataFull = result[0].infoList;
						refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
						$mdl.isLoading = false;
					}, function() {
						$mdl.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
			}
		};

		// ********************************************************

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.inventory.stockreturns.controller', [])
			.controller('StockReturnMainCtrl', StockReturnMainCtrl)
			.controller('StockReturnCreateCtrl', StockReturnCreateCtrl)
			.controller('StockReturnUpdateCtrl', StockReturnUpdateCtrl)
			.controller('StockReturnItemModalCtrl', StockReturnItemModalCtrl)
			.controller('StockReturnSelectDOModalCtrl', StockReturnSelectDOModalCtrl);

	/** @ngInject */
	function StockReturnMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) 
	{	
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.srDataFull = [];
		vm.srData = [];
		vm.showCompleted = false;

		vm.showCompletedChanged = function() {
			vm.srDataFull = [];
			vm.srData = [];
			$scope.$broadcast('refreshStTable');
		};

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.srDataFull, tableState.search.predicateObject) : vm.srDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.srData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.srDataFull.length <= 0) {

				var filter = "";
				if(vm.showCompleted) filter="/1";
				vm.isLoading = true;

				HttpSvc.get('stockreturns/list' + filter, params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.srDataFull = result;		
						vm.isLoading = false;
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteRecord = function(recordId, recordName) {
			var params = {};
			HttpSvc.delete('stockreturns/' + recordId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('stockreturns/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.srDataFull = result;
							
							toastr.success('The record for [' + recordName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete [' + recordName + '].', 'Delete Failed');
					return null;
			});
		};	
		
		vm.printDocument = function(docId, docNo) {
			
			var filename = "STOCKRETURN_" + docNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('stockreturns/print/' + docId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print Stock Return. ' + error, '');
							return null;
						});
		}
	};
	
	/** @ngInject */
    function StockReturnCreateCtrl($scope, $state, $filter, $uibModal, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		vm.statuses = [ 
			{id:'NEW', name:'NEW'}, 
			{id:'CONFIRMED', name:'CONFIRMED'}
		];

		vm.mode = 1;
		vm.sr = {};
		vm.sr.stockReturnDetails = [];
		vm.originalStatus = 'NEW';
		vm.selectedStatus = vm.statuses[0];
		vm.sr.status = vm.statuses[0].id;

		/* ************************************************************ */
		
		vm.selectedStatusChanged = function() {
			vm.sr.status = vm.selectedStatus.id;
		}
		
		/* ************************************************************ */
				
		// Remove Item
		vm.removeItem = function(index) {
			vm.sr.stockReturnDetails.splice(index, 1);
			$scope.$broadcast('refreshStTable');	
		};
			
		// Update Item
		vm.updateItem = function(index, obj) {
			var element = {
				id: obj.id,
				stockReturnId: obj.stockReturnId,
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				itemType: obj.itemType,
				itemName: obj.itemName,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				uomName: obj.uomName,
				quantity2: obj.quantity2,
				unitOfMeasurementId2: obj.unitOfMeasurementId2,
				uomName2: obj.uomName2,
				status: obj.status,
				remarks: obj.remarks,
				isCwm: obj.isCwm,
				labelPrintOption: obj.labelPrintOption
			};
			vm.sr.stockReturnDetails.splice(index, 1, element);
		};

		// Add Item
		vm.addItem = function(obj) {
			var isFound = false;
			var objIdx = null;

			for (var i = 0; i < vm.sr.stockReturnDetails.length; i++) {
				var d = vm.sr.stockReturnDetails[i];
				if(d.itemId==obj.itemId && d.semiFinishedProductId==obj.semiFinishedProductId && d.productId==obj.productId)
				{
					isFound = true;
					objIdx = i;
				}
			} 

			if(isFound)
			{
				toastr.warning('The same item already exists on the list.', 'Duplicate Item');
				return;
			}
			
			var element = {
				id: obj.id,
				stockReturnId: obj.stockReturnId,
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				itemType: obj.itemType,
				itemName: obj.itemName,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				uomName: obj.uomName,
				quantity2: obj.quantity2,
				unitOfMeasurementId2: obj.unitOfMeasurementId2,
				uomName2: obj.uomName2,
				status: obj.status,
				remarks: obj.remarks,
				isCwm: obj.isCwm,
				labelPrintOption: obj.labelPrintOption
			};
			vm.sr.stockReturnDetails.push(element);
		};
		
		/* ************************************************************ */		
					
		vm.showAddItemModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'ItemModal.html',
				controller: 'StockReturnItemModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							deliveryOrderId: vm.sr.deliveryOrderId,
							jobId: vm.sr.jobId,
							withdrawalRequestId: vm.sr.withdrawalRequestId,
							bulkBreakJobId: vm.sr.bulkBreakJobId
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};	
		vm.showEditItemModal = function (index) {
			var item = angular.copy(vm.sr.stockReturnDetails[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'ItemModal.html',
				controller: 'StockReturnItemModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: item,
							deliveryOrderId: vm.sr.deliveryOrderId,
							jobId: vm.sr.jobId,
							withdrawalRequestId: vm.sr.withdrawalRequestId,
							bulkBreakJobId: vm.sr.bulkBreakJobId
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************ */
		
		vm.clearSelectDoc = function() {
			vm.sr.deliveryOrderId = null;
			vm.sr.jobId = null;
			vm.sr.withdrawalRequestId = null;
			vm.sr.bulkBreakJobId = null;
			vm.sr.sourceDocNo = null;
			vm.sr.customerName = null;
		}

		vm.showSelectDocModal = function() {
			vm.item = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'DOListModal.html',
				controller: 'StockReturnSelectDOModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.populateSelectedDoc(data);
				}, function () {
				});
		};		
		
		vm.populateSelectedDoc = function(data) 
		{
			vm.sr.deliveryOrderId = data.deliveryOrderId;
			vm.sr.jobId = data.jobId;
			vm.sr.withdrawalRequestId = data.withdrawalRequestId;
			vm.sr.bulkBreakJobId = data.bulkBreakJobId;
			vm.sr.sourceDocNo = data.sourceDocNo;
			vm.sr.customerName = data.customerName;
		};
		
		/* ************************************************************ */	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;
					
				HttpSvc.post('stockreturns', vm.sr, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Stock Return document has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('inventory.stockreturns.update', {'id': result.id });
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		// Do nothing
	};
	
	/** @ngInject */
    function StockReturnUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;
		vm.statuses = [ 
			{id:'NEW', name:'NEW'}, 
			{id:'CONFIRMED', name:'CONFIRMED'}
		];

		vm.mode = 2;
		vm.sr = {};
		vm.sr.stockReturnDetails = [];
		vm.originalStatus = 'NEW';
		vm.selectedStatus = null;

		/* ************************************************************ */
		
		vm.selectedStatusChanged = function() {
			vm.sr.status = vm.selectedStatus.id;
		}
		
		/* ************************************************************ */		
		
		// Load StockReturn List
		vm.loadData = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('stockreturns/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.sr = result;
					vm.originalStatus = vm.sr.status;

					vm.statuses.forEach(function(s) {
						if(s.id == vm.sr.status)
						{
							vm.selectedStatus = s;
						}
					});
				}, function(error) {
					toastr.error('Failed to load Stock Return. ' + error, Auth.translate('ERROR'))
					$state.go('inventory.stockreturns.list');
					return;
				});		
		};	
		
		/* ************************************************************ */

		// Print Delivery Order
		vm.printStockReturn = function() {
			
			var filename = "STOCKRETURN_" + vm.sr.docNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('stockreturns/print/' + vm.sr.id, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print Stock Return. ' + error, '');
							return null;
						});
		}

		/* ************************************************************ */
				
		// Approval
		vm.approveStockReturn = function() {
			vm.lockButtons = true;

			HttpSvc.post('stockreturns/approve/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Stock Return has been Approved successfully.', 'Approved');
					$state.reload();
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}
		
		// Cancel StockReturn
		vm.cancelStockReturn = function() {
			vm.lockButtons = true;

			HttpSvc.post('stockreturns/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Stock Return has been Cancelled successfully.', 'Cancelled');
					$state.go('inventory.stockreturns.list');
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}
		
		/* ************************************************************ */
				
		// Remove Item
		vm.removeItem = function(index) {
			vm.sr.stockReturnDetails.splice(index, 1);
			$scope.$broadcast('refreshStTable');	
		};
			
		// Update Item
		vm.updateItem = function(index, obj) {
			var element = {
				id: obj.id,
				stockReturnId: obj.stockReturnId,
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				itemType: obj.itemType,
				itemName: obj.itemName,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				uomName: obj.uomName,
				quantity2: obj.quantity2,
				unitOfMeasurementId2: obj.unitOfMeasurementId2,
				uomName2: obj.uomName2,
				status: obj.status,
				remarks: obj.remarks,
				isCwm: obj.isCwm,
				labelPrintOption: obj.labelPrintOption
			};
			vm.sr.stockReturnDetails.splice(index, 1, element);
		};

		// Add Item
		vm.addItem = function(obj) {
			var isFound = false;
			var objIdx = null;

			for (var i = 0; i < vm.sr.stockReturnDetails.length; i++) {
				var d = vm.sr.stockReturnDetails[i];
				if(d.itemId==obj.itemId && d.semiFinishedProductId==obj.semiFinishedProductId && d.productId==obj.productId)
				{
					isFound = true;
					objIdx = i;
				}
			} 

			if(isFound)
			{
				toastr.warning('The same item already exists on the list.', 'Duplicate Item');
				return;
			}
			
			var element = {
				id: obj.id,
				stockReturnId: obj.stockReturnId,
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				itemType: obj.itemType,
				itemName: obj.itemName,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				uomName: obj.uomName,
				quantity2: obj.quantity2,
				unitOfMeasurementId2: obj.unitOfMeasurementId2,
				uomName2: obj.uomName2,
				status: obj.status,
				remarks: obj.remarks,
				isCwm: obj.isCwm,
				labelPrintOption: obj.labelPrintOption
			};
			vm.sr.stockReturnDetails.push(element);
		};
		
		/* ************************************************************ */		
					
		vm.showAddItemModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'ItemModal.html',
				controller: 'StockReturnItemModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							deliveryOrderId: vm.sr.deliveryOrderId,
							jobId: vm.sr.jobId,
							withdrawalRequestId: vm.sr.withdrawalRequestId,
							bulkBreakJobId: vm.sr.bulkBreakJobId
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};	
		vm.showEditItemModal = function (index) {
			var item = angular.copy(vm.sr.stockReturnDetails[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'ItemModal.html',
				controller: 'StockReturnItemModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: item,
							deliveryOrderId: vm.sr.deliveryOrderId,
							jobId: vm.sr.jobId,
							withdrawalRequestId: vm.sr.withdrawalRequestId,
							bulkBreakJobId: vm.sr.bulkBreakJobId
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************ */
		
		vm.clearSelectDoc = function () {
			vm.sr.deliveryOrderId = null;
			vm.sr.jobId = null;
			vm.sr.withdrawalRequestId = null;
			vm.sr.bulkBreakJobId = null;
			vm.sr.sourceDocNo = null;
			vm.sr.customerName = null;
		}

		vm.showSelectDocModal = function () {
			vm.item = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'DOListModal.html',
				controller: 'StockReturnSelectDOModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.populateSelectedDoc(data);
				}, function () {
				});
		};		
		
		vm.populateSelectedDoc = function(data) 
		{
			vm.sr.deliveryOrderId = data.deliveryOrderId;
			vm.sr.jobId = data.jobId;
			vm.sr.withdrawalRequestId = data.withdrawalRequestId;
			vm.sr.bulkBreakJobId = data.bulkBreakJobId;
			vm.sr.sourceDocNo = data.sourceDocNo;
			vm.sr.customerName = data.customerName;
		};	
		
		/* ************************************************************ */	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				HttpSvc.put('stockreturns/' + $stateParams.id, vm.sr, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Stock Return document has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}
		
		/* ************************************************************ */
		
		// Call Actions
		vm.loadData();	
	};

	/** @ngInject */
	function StockReturnItemModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.mode = item.mode;
		$mdl.title = item.title;
		$mdl.item = {};
		$mdl.deliveryOrderId = item.deliveryOrderId;
		$mdl.jobId = item.jobId;
		$mdl.withdrawalRequestId = item.withdrawalRequestId;
		$mdl.bulkBreakJobId = item.bulkBreakJobId;
		$mdl.selectedItem = null;
		$mdl.selectedStatus = null;
		$mdl.lockButtons = false;

		$mdl.itemList = [];
		$mdl.statuses = [
			{ id: 'UNKNOWN', name: 'UNKNOWN'},
			{ id: 'ACCEPTED', name: 'ACCEPTED'},
			{ id: 'REJECTED', name: 'REJECTED'}
		];

		/* ********************************************************* */
				
		// Load Item List
		$mdl.loadDocumentItems = function() 
		{			
			$mdl.lockButtons = true;

			var api = "deliveryorder";
			if($mdl.deliveryOrderId != null) api = "deliveryorder/" + $mdl.deliveryOrderId;
			if($mdl.jobId != null) api = "jobproduction/" + $mdl.jobId;
			if($mdl.withdrawalRequestId != null) api = "withdrawalrequest/" + $mdl.withdrawalRequestId;
			if($mdl.bulkBreakJobId != null) api = "bulkbreakjob/" + $mdl.bulkBreakJobId;

			HttpSvc.get('stockreturns/list/' + api, {}, Auth.getTokenId(), false)
				.then(function(result) {	

					if($mdl.deliveryOrderId != null) $mdl.itemList = result.deliveryOrderProducts;
					if($mdl.jobId != null) $mdl.itemList = result.jobProductionItems;
					if($mdl.withdrawalRequestId != null) $mdl.itemList = result.withdrawalRequestItems;
					if($mdl.bulkBreakJobId != null) $mdl.itemList = result.bulkBreakJobSourceItems;

					if(item.mode==2)
					{
						$mdl.item = item.object;

						$mdl.itemList.forEach(function(i) {
							if(i.itemId==$mdl.item.itemId && 
								i.productId==$mdl.item.productId && 
								i.semiFinishedProductId==$mdl.item.semiFinishedProductId)
							{
								$mdl.selectedItem = i;
							}
						});

						$mdl.statuses.forEach(function(s) {
							if(s.id==$mdl.item.status)
							{
								$mdl.selectedStatus = s;
							}
						});
					}
					else
					{
						$mdl.item.labelPrintOption = false;
					}

					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Delivery Order Item list.', '');
					return null;
				});
		};

		/* ********************************************************* */

		$mdl.selectedItemChanged = function() {
			$mdl.item.itemId = $mdl.selectedItem.itemId;
			$mdl.item.productId = $mdl.selectedItem.productId;
			$mdl.item.semiFinishedProductId = $mdl.selectedItem.semiFinishedProductId;
			$mdl.item.itemCode = $mdl.selectedItem.itemCode;
			$mdl.item.itemName = $mdl.selectedItem.itemName;
			$mdl.item.itemType = $mdl.selectedItem.itemType;
			$mdl.item.unitOfMeasurementId = $mdl.selectedItem.unitOfMeasurementId;
			$mdl.item.uomName = $mdl.selectedItem.uomName;
			$mdl.item.unitOfMeasurementId2 = $mdl.selectedItem.unitOfMeasurementId2;
			$mdl.item.uomName2 = $mdl.selectedItem.uomName2;
			$mdl.item.isCwm = $mdl.selectedItem.isCwm;
		}

		$mdl.selectedStatusChanged = function() {
			$mdl.item.status = $mdl.selectedStatus.id;
		}

		$mdl.clearSelectedItem = function() {
			$mdl.selectedItem=null;
			$mdl.item = {};
		}

		/* ********************************************************* */

		$mdl.confirmModal = function() 
		{	
			if(!$mdl.productForm.$valid) 
			{
				toastr.error('Please fill up all the required fields.', Auth.translate('ERROR'));
			}
			else
			{
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ********************************************************* */

		// Call Init
		$mdl.loadDocumentItems();
	};		
	
	/** @ngInject */
	function StockReturnSelectDOModalCtrl($scope, $uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
		var $mdl = this;
		
		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfRecordFiltered = 0;
		$mdl.numOfRecordDisplayed = 0;
		$mdl.startIndex = 0; 
		$mdl.endIndex = 0;
		$mdl.doDataFull = [];
		$mdl.doData = [];
		$mdl.isLoading = false;
		$mdl.isDO = true;
		$mdl.isJob = false;
		$mdl.isWR = false;
		$mdl.isBBJ = false;
		$mdl.hasChange = false;
		$mdl.hasDocTypeChange = false;
		$mdl.hasSearchChange = false;
		
		/* *************************************************************** */

		function refreshTableState(tableState, startIndex, endIndex) {
						
			var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.doDataFull, tableState.search.predicateObject) : $mdl.doDataFull;
			$mdl.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			$mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
			$mdl.doData = result;
			
			tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		$mdl.retrieveData = function(tableState) {
			
			var pagination = tableState.pagination;
			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.
			var params = {
				documentNo: ""
			};

			if($mdl.search!=null && $mdl.search!="" & $mdl.hasSearchChange)
			{
				$mdl.hasChange = true;
			}

			if($mdl.hasDocTypeChange)
			{
				$mdl.hasChange = true;
				pagination.start = 0;
				$mdl.startIndex = 0;
			}

			if($mdl.doDataFull.length <= 0 || $mdl.hasChange) {
				$mdl.isLoading = true;

				$mdl.doDataFull = [];
				$mdl.doData = [];
				$mdl.numOfRecord = 0;
				
				var docType = "deliveryorder";
				if($mdl.isDO) docType = "deliveryorder";
				if($mdl.isJob) docType = "jobproduction";
				if($mdl.isWR) docType = "withdrawalrequest";
				if($mdl.isBBJ) docType = "bulkbreakjob";

				if($mdl.search!=null && $mdl.search!="")
				{
					params.documentNo = $mdl.search;
				}

				HttpSvc.post('stockreturns/list/' + docType, params, Auth.getTokenId(), true)
					.then(function(result) {	
						$mdl.numOfRecord = result.length;	
						$mdl.doDataFull = result;		
						refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
						$mdl.hasDocTypeChange = false;
						$mdl.hasSearchChange = false;
						$mdl.hasChange = false;
						$mdl.isLoading = false;
					}, function() {
						$mdl.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
			}
		};

		$mdl.searchChanged = function() {
			$mdl.hasSearchChange = true;
			$scope.$broadcast('refreshStTable');
		}

		$mdl.changeDocSource = function(isDO, isJob, isWR, isBBJ) {
			$mdl.isDO = isDO;
			$mdl.isJob = isJob;
			$mdl.isWR = isWR;
			$mdl.isBBJ = isBBJ;	
			$mdl.search = "";
			$mdl.hasDocTypeChange = true;
			$scope.$broadcast('refreshStTable');
		}
		
		/* *************************************************************** */
		
		$mdl.selectDoc = function(item) {
			var result = {
				sourceDocNo: item.jobNo,
				customerName: item.debtorName
			};

			if($mdl.isDO) result.deliveryOrderId = item.id;
			if($mdl.isJob) result.jobId = item.id;
			if($mdl.isWR) result.withdrawalRequestId = item.id;
			if($mdl.isBBJ) result.bulkBreakJobId = item.id;

			$uibModalInstance.close(result);
		}

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.inventory.stocktransfers.controller', [])
			.controller('StockTransferMainCtrl', StockTransferMainCtrl)
			.controller('StockTransferCreateCtrl', StockTransferCreateCtrl)
			.controller('StockTransferUpdateCtrl', StockTransferUpdateCtrl)
			.controller('StockTransferItemModalCtrl', StockTransferItemModalCtrl)
			.controller('StockTransferNewItemModalCtrl', StockTransferNewItemModalCtrl);

	/** @ngInject */
	function StockTransferMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) 
	{	
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.data = [];
		vm.isLoading = false;

		vm.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.docNo,				
				orderDate: predicate.createdDate,
				deliveryDate: predicate.deliveryDate,
				sourceBranchName: predicate.sourceBranchName,
				destBranchName: predicate.destBranchName,
				createdBy: predicate.createdBy,
				status: predicate.status,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('stocktransfers/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isLoading = false;		
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;	
					vm.numOfPages = result.numberOfPages;	
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;		
			return tableState;
		};

		vm.resetSearch = function() 
		{
		}
		
		vm.deleteRecord = function(recordId, recordName) {
			var params = {};
			HttpSvc.delete('stocktransfers/' + recordId, params, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('The record for [' + recordName + '] has been deleted.', 'Delete Success');
					$state.reload();
				}, function() {
					// Failed
					toastr.error('Failed to delete [' + recordName + '].', 'Delete Failed');
					return null;
			});
		};	
		
		vm.printDocument = function(docId, docNo) {
			
			var filename = "STOCKTRANSFER_" + docNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('stocktransfers/print/' + docId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print Stock Transfer. ' + error, '');
							return null;
						});
		}
	};

	/** @ngInject */
	function StockTransferCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();		
		
		var vm = this;
		
		vm.isRmsLite = Auth.isLiteMode();

		vm.mode = 1;
		vm.transfer = {};
		vm.transfer.stockTransferDetails = [];
		vm.branchList = [];
		vm.selectedSourceBranch = null;
		vm.selectedDestBranch = null;
		vm.selectedStatus = null;
		vm.isLoading = false;

		vm.statusList = [ 
			{ id:'NEW', name:'NEW'},
			{ id:'CONFIRMED', name:'CONFIRMED'}
		];
		vm.originalStatus = 'NEW';
		
		/* ************************************************************* */
		
		vm.initData = function() {
			vm.transfer.status = 'NEW';
			vm.selectedStatus = vm.statusList[0];

			vm.loadBranchList();
		}
				
		// Load Branch List
		vm.loadBranchList = function(searchString) {
			vm.isLoading = true;
			
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.branchList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Branch list. ' + error, '');
					return null;
				});
		};	

		/* ************************************************************* */

		vm.selectedSourceBranchChanged = function() {
			vm.transfer.sourceBranchId = vm.selectedSourceBranch.id;
		}

		vm.selectedDestBranchChanged = function() {
			vm.transfer.destBranchId = vm.selectedDestBranch.id;
		}

		vm.selectedStatusChanged = function() {
			vm.transfer.status = vm.selectedStatus.id;
		};

		/* ************************************************************* */
			
		// Open Modal Dialog		
		vm.showAddItemModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'newProductModal.html',
				controller: 'StockTransferNewItemModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: {},
							branchId: vm.transfer.destBranchId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};	

		vm.showEditItemModal = function(index) {
			vm.item = angular.copy(vm.transfer.stockTransferDetails[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'newProductModal.html',
				controller: 'StockTransferNewItemModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
							branchId: vm.transfer.destBranchId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************* */		
		
		// Remove Setting
		vm.removeItem = function(index) {
			vm.transfer.stockTransferDetails.splice(index, 1);
		};
		
		// Update Setting
		vm.updateItem = function(index, obj) {
			
			var isFound = false;			
			vm.transfer.stockTransferDetails.forEach(function(i) {
				if(checkItemExist(i, obj))
				{
					i.id = obj.id;
					i.docId = obj.docId;
					i.itemId = obj.itemId;
					i.semiFgId = obj.semiFgId;
					i.productId = obj.productId;
					i.itemCode = obj.itemCode;
					i.itemName = obj.itemName;
					i.itemType = obj.itemType;
					i.quantity = obj.quantity;
					i.uomId = obj.uomId;
					i.uomName = obj.uomName;
					i.remarks = obj.remarks;
					isFound = true;
				}
			});
			if(isFound) return;

			var element = {
				id: obj.id,
				docId: obj.docId,
				itemId: obj.itemId,
				semiFgId: obj.semiFgId,
				productId: obj.productId,
				itemCode: obj.itemCode,
				itemName: obj.itemName,
				itemType: obj.itemType,
				quantity: obj.quantity,
				uomId: obj.uomId,
				uomName: obj.uomName,
				remarks: obj.remarks
			};
			vm.transfer.stockTransferDetails.splice(index, 1, element);
		};

		// Add Setting
		vm.addItem = function(obj) {
			
			var isFound = false;			
			vm.transfer.stockTransferDetails.forEach(function(i) {
				if(checkItemExist(i, obj))
				{
					i.id = obj.id;
					i.docId = obj.docId;
					i.itemId = obj.itemId;
					i.semiFgId = obj.semiFgId;
					i.productId = obj.productId;
					i.itemCode = obj.itemCode;
					i.itemName = obj.itemName;
					i.itemType = obj.itemType;
					i.quantity = obj.quantity;
					i.uomId = obj.uomId;
					i.uomName = obj.uomName;
					i.remarks = obj.remarks;
					isFound = true;
				}
			});
			if(isFound) return;

			var element = {
				id: obj.id,
				docId: obj.docId,
				itemId: obj.itemId,
				semiFgId: obj.semiFgId,
				productId: obj.productId,
				itemCode: obj.itemCode,
				itemName: obj.itemName,
				itemType: obj.itemType,
				quantity: obj.quantity,
				uomId: obj.uomId,
				uomName: obj.uomName,
				remarks: obj.remarks
			};
			// vm.transfer.stockTransferDetails.push(element);
			vm.transfer.stockTransferDetails.unshift(element);
		};
		
		/* ************************************************************* */	

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.isLoading = true;

				HttpSvc.post('stocktransfers', vm.transfer, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Stock Transfer has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('inventory.stocktransfers.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Call Action
		vm.initData();
	}

	/** @ngInject */
	function StockTransferUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();

		var vm = this;
		
		vm.isRmsLite = Auth.isLiteMode();

		vm.mode = 2;
		vm.transfer = {};
		vm.branchList = [];
		vm.selectedSourceBranch = null;
		vm.selectedDestBranch = null;
		vm.selectedStatus = null;
		vm.isLoading = false;

		vm.statusList = [ 
			{ id:'NEW', name:'NEW'},
			{ id:'CONFIRMED', name:'CONFIRMED'}
		];
		vm.originalStatus = 'NEW';
		
		/* ************************************************************* */

		// Load Branch List
		vm.loadBranchList = function(searchString) {
			vm.isLoading = true;
			
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.branchList = result;
					vm.loadData();
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Branch list. ' + error, '');
					return null;
				});
		};	
						
		// Load Stock Transfer
		vm.loadData = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('stocktransfers/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.transfer = result;
					vm.originalStatus = vm.transfer.status;

					vm.branchList.forEach(function(b) {
						if(vm.transfer.sourceBranchId==b.id)
						{
							vm.selectedSourceBranch = b;
						}
						if(vm.transfer.destBranchId==b.id)
						{
							vm.selectedDestBranch = b;
						}
					});

					vm.statusList.forEach(function(s) {
						if(vm.transfer.status == s.id)
						{
							vm.selectedStatus = s;
						}
					});

					vm.sortItems();

				}, function() {
					toastr.error('Failed to load selected Stock Transfer.', Auth.translate('ERROR'))
					$state.go('inventory.stocktransfers.list');
					return;
				});		
		};	

		vm.sortItems = function() {
			var categoryOrder = ['RAW MAT', 'SEMI FG', 'F.GOODS'];
			vm.transfer.stockTransferDetails.sort(function(a, b) {
				var categoryComparison = categoryOrder.indexOf((a.itemType || '').toUpperCase()) - categoryOrder.indexOf((b.itemType || '').toUpperCase());

				if (categoryComparison !== 0) {
					return categoryComparison;
				}
				
				// Sort alphabetically
				var productA = a.itemName || '';
				var productB = b.itemName || '';
				return productA.localeCompare(productB);
			});
		}
		
		/* ************************************************************* */

		vm.selectedSourceBranchChanged = function() {
			vm.transfer.sourceBranchId = vm.selectedSourceBranch.id;
		}

		vm.selectedDestBranchChanged = function() {
			vm.transfer.destBranchId = vm.selectedDestBranch.id;
		}

		vm.selectedStatusChanged = function() {
			vm.transfer.status = vm.selectedStatus.id;
		};
		
		/* ************************************************************* */
			
		// Open Modal Dialog		
		vm.showAddItemModal = function () {	

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'newProductModal.html',
				controller: 'StockTransferNewItemModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: {},
							branchId: vm.transfer.destBranchId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};	

		vm.showEditItemModal = function (index) {
			vm.item = angular.copy(vm.transfer.stockTransferDetails[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'newProductModal.html',
				controller: 'StockTransferNewItemModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
							branchId: vm.transfer.destBranchId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************* */		
		
		// Remove Setting
		vm.removeItem = function(index) {
			vm.transfer.stockTransferDetails.splice(index, 1);
		};
			
		// Update Setting
		vm.updateItem = function(index, obj) {
			
			var isFound = false;			
			vm.transfer.stockTransferDetails.forEach(function(i) {
				if(checkItemExist(i, obj))
				{
					i.id = obj.id;
					i.docId = obj.docId;
					i.itemId = obj.itemId;
					i.semiFgId = obj.semiFgId;
					i.productId = obj.productId;
					i.itemCode = obj.itemCode;
					i.itemName = obj.itemName;
					i.itemType = obj.itemType;
					i.quantity = obj.quantity;
					i.uomId = obj.uomId;
					i.uomName = obj.uomName;
					i.remarks = obj.remarks;
					isFound = true;
				}
			});
			if(isFound) return;

			var element = {
				id: obj.id,
				docId: obj.docId,
				itemId: obj.itemId,
				semiFgId: obj.semiFgId,
				productId: obj.productId,
				itemCode: obj.itemCode,
				itemName: obj.itemName,
				itemType: obj.itemType,
				quantity: obj.quantity,
				uomId: obj.uomId,
				uomName: obj.uomName,
				remarks: obj.remarks
			};
			vm.transfer.stockTransferDetails.splice(index, 1, element);
		};

		// Add Setting
		vm.addItem = function(obj) {
			
			var isFound = false;			
			vm.transfer.stockTransferDetails.forEach(function(i) {
				if(checkItemExist(i, obj))
				{
					i.id = obj.id;
					i.docId = obj.docId;
					i.itemId = obj.itemId;
					i.semiFgId = obj.semiFgId;
					i.productId = obj.productId;
					i.itemCode = obj.itemCode;
					i.itemName = obj.itemName;
					i.itemType = obj.itemType;
					i.quantity = obj.quantity;
					i.uomId = obj.uomId;
					i.uomName = obj.uomName;
					i.remarks = obj.remarks;
					isFound = true;
				}
			});
			if(isFound) return;

			var element = {
				id: obj.id,
				docId: obj.docId,
				itemId: obj.itemId,
				semiFgId: obj.semiFgId,
				productId: obj.productId,
				itemCode: obj.itemCode,
				itemName: obj.itemName,
				itemType: obj.itemType,
				quantity: obj.quantity,
				uomId: obj.uomId,
				uomName: obj.uomName,
				remarks: obj.remarks
			};
			// vm.transfer.stockTransferDetails.push(element);
			vm.transfer.stockTransferDetails.unshift(element);
		};
		
		/* ************************************************************* */
		
		vm.printDocument = function(docId, docNo) {
			
			var filename = "TRANSFER_" + docNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('stocktransfers/print/' + docId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print Stock Transfer. ' + error, '');
							return null;
						});
		}

		vm.complete = function() {
			HttpSvc.put('stocktransfers/complete/' + $stateParams.id, vm.transfer, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Stock Transfer status updated to COMPLETED.', 'COMPLETED');
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		vm.cancel = function() {
			HttpSvc.put('stocktransfers/cancel/' + $stateParams.id, vm.transfer, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Stock Transfer has been cancelled.', 'Cancellation');
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('stocktransfers/' + $stateParams.id, vm.transfer, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Stock Transfer has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadBranchList();
	}
		
	/** @ngInject */
	function StockTransferItemModalCtrl($uibModalInstance, item, toastr, Auth, HttpSvc) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.item = item.object;
		$mdl.itemList = [];
		$mdl.semiFgList = [];
		$mdl.productList = [];
		$mdl.uomList = [];
		$mdl.selectedItem = null;
		$mdl.selectedSemiFg = null;
		$mdl.selectedProduct = null;
		$mdl.selectedItem = null;
		$mdl.selectedUom = null;
		$mdl.lockButtons = false;
		
		/* ********************************************************* */
				
		// Load Item List
		$mdl.loadItemList = function(searchString) {
			$mdl.lockButtons = true;
			
			HttpSvc.get('items/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.itemList = result;
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Raw Material list.', '');
					return null;
				});
		};		
				
		// Load Semi F.G. List
		$mdl.loadSemiFgList = function(searchString) {
			$mdl.lockButtons = true;
			
			HttpSvc.get('semifgs/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.semiFgList = result;
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Semi F.G. list.', '');
					return null;
				});
		};	
				
		// Load Product List
		$mdl.loadProductList = function(searchString) {			
			$mdl.lockButtons = true;
			
			HttpSvc.get('products/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.productList = result;
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Finished Goods list.', '');
					return null;
				});
		};

		/* ********************************************************* */
				
		// Load Item UOMs
		$mdl.loadItemUoms = function(itemId) {
			$mdl.lockButtons = true;
			
			HttpSvc.get('items/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.uomList = result;
					$mdl.lockButtons = false;
					
					if(item.mode==2)
					{
						$mdl.uomList.forEach(function(u) {
							if(u.id==$mdl.item.uomId)
							{
								$mdl.selectedUom = u;
							}
						});
					}
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Product UOMs
		$mdl.loadSemiFgUoms = function(semiFgId) {
			$mdl.lockButtons = true;

			HttpSvc.get('semifgs/uoms/' + semiFgId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.uomList = result;
					$mdl.lockButtons = false;
					
					if(item.mode==2)
					{
						$mdl.uomList.forEach(function(u) {
							if(u.id==$mdl.item.uomId)
							{
								$mdl.selectedUom = u;
							}
						});
					}
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Semi F.G. UOMs
		$mdl.loadProductUoms = function(productId) {
			$mdl.lockButtons = true;

			HttpSvc.get('products/uoms/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.uomList = result;
					$mdl.lockButtons = false;
					
					if(item.mode==2)
					{
						$mdl.uomList.forEach(function(u) {
							if(u.id==$mdl.item.uomId)
							{
								$mdl.selectedUom = u;
							}
						});
					}
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	

		/* ********************************************************* */
		
		$mdl.selectedItemChanged = function() {
			$mdl.item.productId = null;
			$mdl.item.semiFgId = null;
			$mdl.item.itemId = $mdl.selectedItem.id;
			$mdl.item.itemCode = $mdl.selectedItem.code;
			$mdl.item.itemName = $mdl.selectedItem.description;
			$mdl.item.itemType = "RAW MAT";
			
			$mdl.selectedSemiFg = null;
			$mdl.selectedProduct = null;

			$mdl.loadItemUoms($mdl.item.itemId);
		};
		
		$mdl.selectedSemiFgChanged = function() {
			$mdl.item.itemId = null;
			$mdl.item.productId = null;
			$mdl.item.semiFgId = $mdl.selectedSemiFg.id;
			$mdl.item.itemCode = $mdl.selectedSemiFg.code;
			$mdl.item.itemName = $mdl.selectedSemiFg.description;
			$mdl.item.itemType = "SEMI FG";
			
			$mdl.selectedItem = null;
			$mdl.selectedProduct = null;

			$mdl.loadSemiFgUoms($mdl.item.semiFgId);
		};
		
		$mdl.selectedProductChanged = function() {
			$mdl.item.itemId = null;
			$mdl.item.semiFgId = null;
			$mdl.item.productId = $mdl.selectedProduct.id;
			$mdl.item.itemCode = $mdl.selectedProduct.code;
			$mdl.item.itemName = $mdl.selectedProduct.name;
			$mdl.item.itemType = "F.GOODS";
			
			$mdl.selectedItem = null;
			$mdl.selectedSemiFg = null;

			$mdl.loadProductUoms($mdl.item.productId);
		};
		
		$mdl.selectedUomChanged = function() {
			$mdl.item.uomId = $mdl.selectedUom.id;
			$mdl.item.uomName = $mdl.selectedUom.name;
		};

		$mdl.clearSelection = function() {
			$mdl.selectedItem = null;
			$mdl.selectedSemiFg = null;
			$mdl.selectedProduct = null;
			$mdl.selectedUom = null;

			$mdl.item.itemId = null
			$mdl.item.semiFgId = null;
			$mdl.item.productId = null;
			$mdl.item.uomId = null;
			$mdl.item.uomName = null;

			$mdl.uomList = [];
		}

		/* ********************************************************* */

		$mdl.confirmModal = function() {
			if($mdl.itemForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		/* ********************************************************* */

		// Initialize
		if(item.mode==1) {
			$mdl.item.itemId = "";
			$mdl.item.itemCode = "";			
			$mdl.item.itemName = "";			
			$mdl.item.yieldPercent = 0;
		} else {
			if($mdl.item.itemId!='' && $mdl.item.itemId!=null){
				$mdl.selectedItem = {
					id: $mdl.item.itemId,
					code: $mdl.item.itemCode,
					description: $mdl.item.itemName,
				};
				$mdl.loadItemUoms($mdl.item.itemId);
				$mdl.activeTab = 0;
			};
			
			if($mdl.item.semiFgId!='' && $mdl.item.semiFgId!=null){
				$mdl.selectedSemiFg = {
					id: $mdl.item.semiFgId,
					code: $mdl.item.itemCode,
					description: $mdl.item.itemName,
				};
				$mdl.loadSemiFgUoms($mdl.item.semiFgId);
				$mdl.activeTab = 1;
			};

			if($mdl.item.productId!='' && $mdl.item.productId!=null){
				$mdl.selectedProduct = {
					id: $mdl.item.productId,
					code: $mdl.item.itemCode,
					name: $mdl.item.itemName,
				};
				$mdl.loadProductUoms($mdl.item.productId);
				$mdl.activeTab = 2;
			};
		}
	};	
			
	// Product Modal Controller
	function StockTransferNewItemModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.mode = item.mode;
		$mdl.title = item.title;
		$mdl.item = item.object;
		$mdl.branchId = item.branchId;
		$mdl.itemList = [];
		$mdl.selectedItem = null;
		$mdl.selectedUom = null;
		$mdl.lockButtons = false;
		
		/* ********************************************************* */
				
		// Load Item List
		$mdl.searchItem = function(searchString) {
			$mdl.lockButtons = true;
			
			var params = {
				keyword: encodeURIComponent(searchString),
				branchId: $mdl.branchId,
			};

			HttpSvc.post('searchengine/search/stockrequestconfigitems', params, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.itemList = result;
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Item list.', '');
					return null;
				});
		};
		
		$mdl.loadItem = function() {
			if($mdl.item.itemId!=null)
			{
				$mdl.loadRawMat($mdl.item.itemId);
			}
			else if($mdl.item.semiFgId!=null)
			{
				$mdl.loadSemiFg($mdl.item.semiFgId);
			}
			else if($mdl.item.productId!=null)
			{
				$mdl.loadFg($mdl.item.productId);
			}
		}

		$mdl.loadRawMat = function(itemId) {
			HttpSvc.get('items/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.selectedItem.uomList = result;
					$mdl.selectedItem.uomList.forEach(function(u) {
						if(u.id==$mdl.item.uomId)
						{
							$mdl.selectedUom = u;
						}
					});
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Raw Mat UOM list.', '');
					return null;
				});
		}

		$mdl.loadSemiFg = function(itemId) {
			HttpSvc.get('semifgs/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.selectedItem.uomList = result;
					$mdl.selectedItem.uomList.forEach(function(u) {
						if(u.id==$mdl.item.uomId)
						{
							$mdl.selectedUom = u;
						}
					});
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Semi FG UOM list.', '');
					return null;
				});
		}

		$mdl.loadFg = function(itemId) {
			HttpSvc.get('products/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.selectedItem.uomList = result;
					$mdl.selectedItem.uomList.forEach(function(u) {
						if(u.id==$mdl.item.uomId)
						{
							$mdl.selectedUom = u;
						}
					});
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve FG UOM list.', '');
					return null;
				});
		}
		
		/* ********************************************************* */

		// Initialize
		if(item.mode==1) {
			
			$mdl.item.itemId = null;
			$mdl.item.semiFgId = null;
			$mdl.item.productId = null;
			$mdl.item.itemCode = "";
			$mdl.item.itemName = "";
			$mdl.item.itemType = "";			
			$mdl.item.quantity = 1;
			$mdl.item.unitPrice = 0;
			$mdl.item.tax = 0;
			$mdl.item.taxCode = '';
		} else {
			$mdl.itemList.push({
				itemId: $mdl.item.itemId,
				productId: $mdl.item.productId,
				semiFgId: $mdl.item.semiFgId,
				productCode: $mdl.item.itemCode,
				productName: $mdl.item.itemCode,
				itemType: $mdl.item.itemType,
				unitOfMeasurementId: $mdl.item.uomId,
				uomName: $mdl.item.uomName,
				uomList: [{
					id: $mdl.item.uomId,
					name: $mdl.item.uomName,
				}]
			});
			$mdl.selectedItem = $mdl.itemList[0];
			$mdl.loadItem();
		}

		/* ********************************************************* */
				
		$mdl.selectedItemChanged = function() {
			$mdl.item.itemId = $mdl.selectedItem.itemId;
			$mdl.item.semiFgId = $mdl.selectedItem.semiFinishedProductId;
			$mdl.item.productId = $mdl.selectedItem.productId;
			$mdl.item.itemCode = $mdl.selectedItem.productCode;
			$mdl.item.itemName = $mdl.selectedItem.productName;
			$mdl.item.itemType = $mdl.selectedItem.itemType;
			$mdl.item.unitPrice = $mdl.selectedItem.posPrice;
			$mdl.item.tax = $mdl.selectedItem.posTax;
			$mdl.item.taxCode = $mdl.selectedItem.posTaxCode ? $mdl.selectedItem.posTaxCode : '-';

			$mdl.selectedUom = $mdl.selectedItem.uomList[0];
			$mdl.item.uomId = $mdl.selectedUom.id;
			$mdl.item.uomName = $mdl.selectedUom.name;
			
			$mdl.selectedItem.uomList.forEach(function(u) {
				if(u.id==$mdl.selectedItem.unitOfMeasurementId)
				{
					$mdl.selectedUom = u;
					$mdl.item.uomId = $mdl.selectedUom.id;
					$mdl.item.uomName = $mdl.selectedUom.name;
				}
			});
		};
				
		$mdl.selectedUomChanged = function() {
			$mdl.item.uomId = $mdl.selectedUom.id
			$mdl.item.uomName = $mdl.selectedUom.name;
		}

		/* ********************************************************* */

		$mdl.confirmModal = function() 
		{	
			if(!$mdl.productForm.$valid) 
			{
				toastr.error('Please fill up all the required fields.', Auth.translate('ERROR'));
			}
			else
			{
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	

	function checkItemExist(i, obj) {

		if((i.itemId==obj.itemId && i.itemId!="" && i.itemId!=null) ||
			(i.productId==obj.productId && i.productId!="" && i.productId!=null) ||
			(i.semiFinishedProductId==obj.semiFinishedProductId && i.semiFinishedProductId!="" && i.semiFinishedProductId!=null))
		{
			return true;
		}
		return false;
	}	

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.iotadmin.iotregdevices.controller', [])
        .controller('IoTAdminDeviceMainCtrl', IoTAdminDeviceMainCtrl)
        .controller('IotAdminDeviceCreateCtrl', IotAdminDeviceCreateCtrl)
        .controller('IoTAdminDeviceUpdateCtrl', IoTAdminDeviceUpdateCtrl);

    /** @ngInject */
    function IoTAdminDeviceMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.deviceDataFull = [];
		vm.deviceData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.deviceDataFull, tableState.search.predicateObject) : vm.deviceDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.deviceData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.deviceDataFull.length <= 0) {							
				HttpSvc.get('iotregistereddevices/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.deviceDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteDevice = function(deviceId, deviceName) {
			var params = {};
			HttpSvc.delete('iotregistereddevices/' + deviceId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('iotregistereddevices/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.deviceDataFull = result;
							
							toastr.success('The device [' + deviceName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the device [' + deviceName + '].', 'Delete Failed');
					return null;
			});
		};			
	};
	
	/** @ngInject */
    function IotAdminDeviceCreateCtrl($scope, $state, $filter, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.deviceInfo = {};	
		vm.iotregdevice = {};	
		vm.iotregdevice.mfgDate = new Date();
		vm.iotregdevice.mfgDate = new Date(vm.iotregdevice.mfgDate.setDate(vm.iotregdevice.mfgDate.getDate()));
		vm.iotregdevice.mfgDate = $filter('date')(vm.iotregdevice.mfgDate, 'yyyy-MM-01');
		vm.iotregdevice.isActive = true;
		vm.deviceTypes = [
			{ id:'HANDHELD READER', name:'HANDHELD READER' },
			{ id:'COLD SENSOR', name:'COLD SENSOR' },
			{ id:'HOT SENSOR', name:'HOT SENSOR' },
			{ id:'T+H SENSOR', name:'T+H SENSOR' },
			{ id:'GATEWAY', name:'GATEWAY' },
			{ id:'GATEWAY (GSM)', name:'GATEWAY (GSM)' },
			{ id:'GATEWAY WITH GPS', name:'GATEWAY WITH GPS' },
		];
		vm.isGettingInfo = false;
		vm.getInfoSuccess = false;
		
		/* **************************************************************** */

		// Get Device Info
		vm.getDeviceInfo = function() {
			vm.isGettingInfo = true;

			var params = { url: vm.iotregdevice.qrcode }
			HttpSvc.post('iotregistereddevices/deviceinfo', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.deviceInfo=result;	
					vm.iotregdevice.deviceUID = vm.deviceInfo.uid;
					vm.iotregdevice.deviceUUID = vm.deviceInfo.uuid;
					vm.iotregdevice.mfgDate = vm.deviceInfo.pdt;
					vm.iotregdevice.type = vm.deviceInfo.devm;
					vm.iotregdevice.model = vm.deviceInfo.sens;
					vm.deviceTypes.forEach(function(d) {
						if(d.id==vm.iotregdevice.type){
							vm.selectedType = d;
						}
					});

					vm.isGettingInfo = false;
					vm.getInfoSuccess = true;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		/* **************************************************************** */

		// Select Device Type
		vm.selectedTypeChanged = function() {
			vm.iotregdevice.type = vm.selectedType.id;
		};

		/* **************************************************************** */
				
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('iotregistereddevices', vm.iotregdevice, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Device has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('iotadmin.iotregdevices.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function IoTAdminDeviceUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.deviceInfo = {};	
		vm.iotregdevice = {};
		vm.deviceTypes = [
			{ id:'HANDHELD READER', name:'HANDHELD READER' },
			{ id:'COLD SENSOR', name:'COLD SENSOR' },
			{ id:'HOT SENSOR', name:'HOT SENSOR' },
			{ id:'T+H SENSOR', name:'T+H SENSOR' },
			{ id:'GATEWAY', name:'GATEWAY' },
			{ id:'GATEWAY (GSM)', name:'GATEWAY (GSM)' },
			{ id:'GATEWAY WITH GPS', name:'GATEWAY WITH GPS' },
		];
		vm.isGettingInfo = false;
		vm.getInfoSuccess = false;
		
		/* **************************************************************** */
						
		// Load Device
		vm.loadDevice = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('iotregistereddevices/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.iotregdevice = result;
					vm.deviceTypes.forEach(function(d) {
						if(d.id==vm.iotregdevice.type){
							vm.selectedType = d;
						}
					});
				}, function() {
					toastr.error('Failed to load selected Device.', Auth.translate('ERROR'))
					$state.go('superadmin.iotregdevices.list');
					return;
				});		
		};	

		// Get Device Info
		vm.getDeviceInfo = function() {
			vm.isGettingInfo = true;

			var params = { url: vm.iotregdevice.qrcode }
			HttpSvc.post('iotregistereddevices/deviceinfo', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.deviceInfo=result;	
					vm.iotregdevice.deviceUID = vm.deviceInfo.uid;
					vm.iotregdevice.deviceUUID = vm.deviceInfo.uuid;
					vm.iotregdevice.mfgDate = vm.deviceInfo.pdt;
					vm.iotregdevice.type = vm.deviceInfo.devm;
					vm.iotregdevice.model = vm.deviceInfo.sens;
					vm.deviceTypes.forEach(function(d) {
						if(d.id==vm.iotregdevice.type){
							vm.selectedType = d;
						}
					});

					vm.isGettingInfo = false;
					vm.getInfoSuccess = true;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		/* **************************************************************** */

		// Select Device Type
		vm.selectedTypeChanged = function() {
			vm.iotregdevice.type = vm.selectedType.id;
		};

		/* **************************************************************** */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('iotregistereddevices/' + $stateParams.id, vm.iotregdevice, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Device has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('iotadmin.iotregdevices.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadDevice();		
	}
})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.iotsettings.gateways.controller', [])
			.controller('IoTGatewayMainCtrl', IoTGatewayMainCtrl)
			.controller('IoTGatewayCreateCtrl', IoTGatewayCreateCtrl)
			.controller('IoTGatewayUpdateCtrl', IoTGatewayUpdateCtrl)
			.controller('IoTGatewayCloneModalCtrl', IoTGatewayCloneModalCtrl);

	/** @ngInject */
	function IoTGatewayMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.gatewayDataFull = [];
		vm.gatewayData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.gatewayDataFull, tableState.search.predicateObject) : vm.gatewayDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.gatewayData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.gatewayDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('iotgateways/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.gatewayDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteGateway = function(gatewayId, gatewayName) {
			var params = {};
			HttpSvc.delete('iotgateways/' + gatewayId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('iotgateways/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.gatewayDataFull = result;
							
							toastr.success('The gateway [' + gatewayName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the gateway [' + gatewayName + '].', 'Delete Failed');
					return null;
		});
	};
};

/** @ngInject */
	function IoTGatewayCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.branches = [];
		vm.deviceList = [];
		vm.selectedBranch = null;
		vm.selectedDevice = null;
		vm.gateway = {};
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.canSetIoTHardwareSettings = Auth.canSetIoTHardwareSettings();

		/* ******************************************************************** */
	
		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
					vm.loadDevices();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
	
		}
	
		vm.loadDevices = function() {
			HttpSvc.get('iotregistereddevices/list/available/gateways', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.deviceList = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});
	
		}

		/* ******************************************************************** */

		vm.selectedBranchChanged = function() {
			vm.gateway.branchId = vm.selectedBranch.id;
		}

		vm.selectedDeviceChanged = function() {
			vm.gateway.deviceId = vm.selectedDevice.id;
			vm.gateway.deviceUID = vm.selectedDevice.deviceUID;
		}

		vm.clearDevice = function() {
			vm.selectedDevice = null;
			vm.gateway.deviceId = "";
			vm.gateway.deviceUID = "";
		}

		/* ******************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('iotgateways', vm.gateway, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Gateway has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('iotsettings.gateways.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadBranches();
	}

/** @ngInject */
	function IoTGatewayUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.gateway = {};
		vm.branches = [];
		vm.deviceList = [];
		vm.selectedBranch = null;
		vm.selectedDevice = null;
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.canSetIoTHardwareSettings = Auth.canSetIoTHardwareSettings();

		/* ******************************************************************** */

		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
					vm.loadGateway();
				}, function(error) {
					toastr.error(error, 'Failed');
				});

		}

		vm.loadDevices = function() {
			HttpSvc.get('iotregistereddevices/list/available/gateways/' + vm.gateway.deviceId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.deviceList = result;

					vm.deviceList.forEach(function(d) {
						if(d.id==vm.gateway.deviceId) {
							vm.selectedDevice=d;
						}
					});
				}, function(error) {
					toastr.error(error, 'Failed');
				});

		}
						
		// Load Gateway
		vm.loadGateway = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('iotgateways/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.gateway = result;

					vm.branches.forEach(function(b) {
						if(b.id==vm.gateway.branchId) {
							vm.selectedBranch=b;
						}
					});

					vm.loadDevices();
				}, function() {
					toastr.error('Failed to load selected Gateway.', Auth.translate('ERROR'))
					$state.go('iotsettings.gateways.list');
					return;
				});		
		};	

		/* ******************************************************************** */

		vm.selectedBranchChanged = function() {
			vm.gateway.branchId = vm.selectedBranch.id;
		}

		vm.selectedDeviceChanged = function() {
			vm.gateway.deviceId = vm.selectedDevice.id;
			vm.gateway.deviceUID = vm.selectedDevice.deviceUID;
		}

		vm.clearDevice = function() {
			vm.selectedDevice = null;
			vm.gateway.deviceId = "";
			vm.gateway.deviceUID = "";
		}

		/* ******************************************************************** */
					
		// Open Clone Recipe Modal Dialog
		vm.showTransferModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'TransferGatewayModal.html',
				controller: 'IoTGatewayCloneModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							gatewayId: vm.gateway.id,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					$state.go('iotsettings.gateways.list');
				}, function () {
				});
		};	

		/* ******************************************************************** */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('iotgateways/' + $stateParams.id, vm.gateway, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Gateway has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadBranches();		
	};
	
	// Clone Recipe Modal Controller
	function IoTGatewayCloneModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.companies = [];
		$mdl.branches = [];
		$mdl.gatewayId = item.gatewayId;
		$mdl.selectedCompany = null;
		$mdl.selectedBranch = null;
		$mdl.selectedCompanyId = "";
		$mdl.selectedBranchId = "";
		$mdl.lockButtons = false;
				
		/* ******************************************************** */

		$mdl.loadCompanies = function() {
			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.companies = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		};
		
		$mdl.loadBranches = function() {
			HttpSvc.get('branches/listbycompany/' + $mdl.selectedCompanyId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.branches = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		};

		/* ******************************************************** */

		$mdl.selectedCompanyChanged = function()
		{
			$mdl.selectedCompanyId = $mdl.selectedCompany.id;
			$mdl.loadBranches();
		}
		
		$mdl.selectedBranchChanged = function()
		{
			$mdl.selectedBranchId = $mdl.selectedBranch.id;			
		}

		/* ******************************************************** */
		
		$mdl.confirmModal = function() {			
			if($mdl.cloneForm.$valid) {				
				$mdl.lockButtons = true;
								
				HttpSvc.post("iotgateways/transfer/" + $mdl.gatewayId + "/" + $mdl.selectedCompanyId + "/" + $mdl.selectedBranchId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Gateway has been transferred successfully to <b>' + 
							$mdl.selectedCompany.name + '</b> - <b>' + $mdl.selectedBranch.name + '</b>.')
						$uibModalInstance.close();
					}, function(error) {
						$mdl.lockButtons = false;
						toastr.error(error, 'Failed');
					});	
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Initial Call
		$mdl.loadCompanies();
	};

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.iotsettings.handhelds.controller', [])
			.controller('IoTHandheldMainCtrl', IoTHandheldMainCtrl)
			.controller('IoTHandheldCreateCtrl', IoTHandheldCreateCtrl)
			.controller('IoTHandheldUpdateCtrl', IoTHandheldUpdateCtrl);

	/** @ngInject */
	function IoTHandheldMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
	
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.handheldDataFull = [];
		vm.handheldData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.handheldDataFull, tableState.search.predicateObject) : vm.handheldDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.handheldData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.handheldDataFull.length <= 0) {				
				HttpSvc.get('iothandhelds/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.handheldDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteHandheld = function(handheldId, handheldName) {
			var params = {};
			HttpSvc.delete('iothandhelds/' + handheldId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('iothandhelds/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.handheldDataFull = result;
							
							toastr.success('The handheld [' + handheldName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the handheld [' + handheldName + '].', 'Delete Failed');
					return null;
			});
		};
	};

/** @ngInject */
	function IoTHandheldCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.handheld = {};
		vm.deviceList = [];
		vm.selectedDevice = null;
		
		/* ************************************************************* */

		vm.loadDevices = function() {
			HttpSvc.get('iotregistereddevices/list/available/handhelds', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.deviceList = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});
	
		}
		
		/* ************************************************************* */

		vm.selectedDeviceChanged = function() {
			vm.handheld.deviceId = vm.selectedDevice.id;
			vm.handheld.deviceUID = vm.selectedDevice.deviceUID;
			vm.handheld.deviceType = vm.selectedDevice.type;
			vm.handheld.model = vm.selectedDevice.model;
		}
	
		vm.clearDevice = function() {
			vm.selectedDevice = null;
			vm.handheld.deviceId = "";
			vm.handheld.deviceUID = "";
			vm.handheld.deviceType = "";
			vm.handheld.model = "";
		}
		
		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('iothandhelds', vm.handheld, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Handheld has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('iotsettings.handhelds.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadDevices();
	}

/** @ngInject */
	function IoTHandheldUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.handheld = {};
		vm.deviceList = [];
		vm.selectedDevice = null;
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.lockButtons = false;

		/* ************************************************************* */

		vm.loadDevices = function() {
			var deviceId = vm.handheld.deviceId==null?"":vm.handheld.deviceId;
			HttpSvc.get('iotregistereddevices/list/available/handhelds/' + deviceId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.deviceList = result;

					vm.deviceList.forEach(function(d) {
						if(d.id==vm.handheld.deviceId) {
							vm.selectedDevice=d;
						}
					});

					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
	
		}
						
		// Load Handheld
		vm.loadHandheld = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('iothandhelds/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.handheld = result;

					vm.loadDevices();

				}, function() {
					toastr.error('Failed to load selected Handheld.', Auth.translate('ERROR'))
					$state.go('iotsettings.handhelds.list');
					return;
				});		
		};	
		
		/* ************************************************************* */

		vm.selectedDeviceChanged = function() {
			vm.handheld.deviceId = vm.selectedDevice.id;
			vm.handheld.deviceUID = vm.selectedDevice.deviceUID;
			vm.handheld.deviceType = vm.selectedDevice.type;
			vm.handheld.model = vm.selectedDevice.model;
		}
	
		vm.clearDevice = function() {
			vm.selectedDevice = null;
			vm.handheld.deviceId = "";
			vm.handheld.deviceUID = "";
			vm.handheld.deviceType = "";
			vm.handheld.model = "";
		}
		
		/* ************************************************************* */

		vm.deleteReadings = function() {
			vm.lockButtons = true;

			HttpSvc.delete('iothandhelds/deletereadings/' + vm.handheld.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success(result.message, Auth.translate('SUCCESS'));
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to delete the handheld readings.', 'Delete Failed');
					return null;
				});
		}

		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('iothandhelds/' + $stateParams.id, vm.handheld, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Handheld has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadHandheld();		
	}

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.iotsettings.floorviewdesigner.controller', [])
			.controller('IoTFloorViewDesignerMainCtrl', IoTFloorViewDesignerMainCtrl)
			.controller('IoTFloorViewDesignerCreateCtrl', IoTFloorViewDesignerCreateCtrl)
			.controller('IoTFloorViewDesignerUpdateCtrl', IoTFloorViewDesignerUpdateCtrl);

	/** @ngInject */
	function IoTFloorViewDesignerMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.designDataFull = [];
		vm.designData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.designDataFull, tableState.search.predicateObject) : vm.designDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.designData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.designDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('iotfloorviewdesigner/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.designDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteDesign = function(designId, designName) {
			var params = {};
			HttpSvc.delete('iotfloorviewdesigner/' + designId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('iotfloorviewdesigner/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.designDataFull = result;
							
							toastr.success('The design [' + designName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the design [' + designName + '].', 'Delete Failed');
					return null;
		});
	};
};

	/** @ngInject */
	function IoTFloorViewDesignerCreateCtrl($scope, $state, Auth, HttpSvc, UtilSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.branches = [];
		vm.selectedBranch = null;
		vm.design = {};

		/* ******************************************************************** */
	
		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		/* ******************************************************************** */

		vm.selectedBranchChanged = function() {
			vm.design.branchId = vm.selectedBranch.id;
		}

		/* ******************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, 'Incomplete Fields');
			} else {
				HttpSvc.post('iotfloorviewdesigner', vm.design, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Design has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('iotsettings.floorviewdesigner.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadBranches();
	}

	/** @ngInject */
	function IoTFloorViewDesignerUpdateCtrl($scope, $state, $stateParams, $timeout, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.design = {};
		vm.assets = [];
		vm.branches = [];
		vm.gateways = [];
		vm.selectedBranch = null;
		vm.selectedGateway = null;
		vm.selectedSensor = null;
		vm.fileToUpload = null;
		vm.fileToUpload = null;
		vm.blobUrl = RmsApi.BLOBURL;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		vm.hasAssetAccess = Auth.hasCompanyFeature('assets');
		vm.hasIoTAccess = Auth.hasCompanyFeature('iotdashboard');
		vm.selectedTab = "1";

		/* ******************************************************************** */

		vm.initData = function() {
			if(!vm.hasAssetAccess) vm.selectedTab = "2";

			vm.loadBranches();
		}

		/* ******************************************************************** */

		vm.selectTab = function(tabNo) {
			vm.selectedTab = tabNo;
		}

		vm.selectedBranchChanged = function() {
			vm.design.branchId = vm.selectedBranch.id;
		}

		/* ******************************************************************** */

		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
					vm.loadGateways();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		vm.loadGateways = function() {
			HttpSvc.get('iotgateways/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.gateways = result;
					vm.loadAssets();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		vm.loadAssets = function() {
			HttpSvc.get('assets/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.assets = result;
					vm.loadDesign();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
						
		vm.loadDesign = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('iotfloorviewdesigner/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.design = result;

					vm.branches.forEach(function(b) {
						if(b.id==vm.design.branchId) {
							vm.selectedBranch=b;
						}
					});

					if(!vm.design.layoutImage || vm.design.layoutImage=='') {
						vm.design.layoutImage = 'assets/img/empty_placeholder_iotdesigner.jpg';
						vm.design.orilayoutImage = "";
					} else {
						vm.design.orilayoutImage = vm.design.layoutImage;
						vm.design.layoutImage = vm.rootUrl + vm.design.layoutImage;
					}

					$timeout(vm.loadObjectOnLayout, 1000);

				}, function() {
					toastr.error('Failed to load selected Design.', Auth.translate('ERROR'))
					$state.go('iotsettings.floorviewdesigner.list');
					return;
				});		
		}		

		vm.loadObjectOnLayout = function() {
			
			vm.design.iotFloorViewDesignerDevices.forEach(function(s) {
				// Grid Snapping
				vm.bindInteractJS(s.objectIdText);
			});
		}

		/* ******************************************************************** */

		vm.addAssetToLayout = function(assetId, assetName) {
			if(assetId=='' || assetId==null)
			{
				toastr.error("Select an Asset first.");
				return;
			}

			var obj = null;
			var items = vm.design.iotFloorViewDesignerDevices;

			for (var i=0; i<items.length; i++) 
			{			
				if (items[i].assetId == assetId) 
					obj = items[i];
			}
			
			if(obj!=null)
			{
				toastr.error("Selected asset already exists.");
				return;
			}

			var regex = new RegExp('-', 'g');

			var newAsset = { 
				assetId: assetId, 
				objectIdText: "asset_" + assetId.replace(regex, "_"),
				objectDescription: assetName,
				description: assetName,
				coordinateX: 0,
				coordinateY: 0 
			};
			vm.design.iotFloorViewDesignerDevices.push(newAsset);
			
			// Grid Snapping			
			$timeout(function() { vm.bindInteractJS(newAsset.objectIdText) }, 500);
		}

		vm.addSensorToLayout = function(sensorObj) {
			if(sensorObj==null)
			{
				toastr.error("Select a Sensor first.");
				return;
			}

			var obj = null;
			var items = vm.design.iotFloorViewDesignerDevices;

			for (var i=0; i<items.length; i++) 
			{			
				if (items[i].sensorId == sensorObj.id) 
					obj = items[i];
			}
			
			if(obj!=null)
			{
				toastr.error("Selected sensor already exists.");
				return;
			}

			var regex = new RegExp('-', 'g');

			var newSensor = { 
				sensorId: sensorObj.id, 
				objectCode: sensorObj.deviceUID,
				objectIdText: "sensor_" + sensorObj.id.replace(regex, "_"),
				objectDescription: sensorObj.description,
				description: sensorObj.description,
				coordinateX: 0,
				coordinateY: 0 
			};
			vm.design.iotFloorViewDesignerDevices.push(newSensor);
			
			// Grid Snapping			
			$timeout(function() { vm.bindInteractJS(newSensor.objectIdText) }, 500);
		}

		vm.removeObject = function(objectIdText) {

			var items = vm.design.iotFloorViewDesignerDevices;
			for(var i=0; i<items.length; i++)
			{
				if(items[i].objectIdText == objectIdText) {
					vm.design.iotFloorViewDesignerDevices.splice(i, 1);
					return;
				}
			}
		}

		vm.bindInteractJS = function(objectIdText) {

			var element = document.getElementById(objectIdText);
			interact(element)
				.draggable({
					modifiers: [
						interact.modifiers.snap({
							targets: [
							interact.createSnapGrid({ x: 10, y: 10 })
							],
							range: Infinity,
							relativePoints: [ { x: 0, y: 0 } ]
						}),
						interact.modifiers.restrict({
							restriction: element.parentNode,
							elementRect: { top: 0, left: 0, bottom: 1, right: 1 },
							endOnly: true
						})
					],
					inertia: true
				})
				.on('dragmove', function (event) {	
					var obj = null;
					var items = vm.design.iotFloorViewDesignerDevices;

					for (var i=0; i<items.length; i++) 
					{			
						if (items[i].objectIdText == objectIdText) 
							obj = items[i];
					}
					
					if(obj!=null) {
						obj.coordinateX += event.dx;
						obj.coordinateY += event.dy;

						obj.coordinateX = Math.ceil(obj.coordinateX);
						obj.coordinateY = Math.ceil(obj.coordinateY);

						event.target.style.webkitTransform =
						event.target.style.transform =
							'translate(' + obj.coordinateX + 'px, ' + obj.coordinateY + 'px)';
					}
				});
		}

		/* ******************************************************************** */

		/* ******************************************************************** */
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (azureSasToken) {
			
			if(vm.lockUploadButton) {
				toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Image Upload Error');
				return;
			}

			var azureStorageUrl = RmsApi.BLOBURL + vm.design.layoutImage + azureSasToken;
			var fileReader = new FileReader();
			
			fileReader.readAsArrayBuffer(vm.fileToUpload);
			fileReader.onload = function(e) {
				Upload.http({
					method: "PUT",
					url: azureStorageUrl,
					headers: {
						'x-ms-blob-type': 'BlockBlob',
						'x-ms-blob-content-type': vm.fileToUpload.type
					},
					data: e.target.result
				}).then(function(response) {
					if (response.status==201) {	
															
						// Refresh Clud Storage Stats
						Auth.selectBranchToken()
							.then(function() {	
								toastr.success('Design has been update successfully.', Auth.translate('SUCCESS'));
								$state.reload();
							}, function(error) {
								toastr.success('Design has been update successfully.', Auth.translate('SUCCESS'));
								$state.reload();
							});			
					} else {
						toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						vm.dataForm.$setPristine();
					} 
				}, null, function(evt) {
					//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				});
			}
		};

		/* ******************************************************************** */

		// Form Submission
		vm.submit = function() {
			
			var newFilename = UtilSvc.generateGuid() + ".";
			var imageLocation = null;

			if(vm.fileToUpload) {				
				var extArray = vm.fileToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();				
				imageLocation = Auth.getCompanyId() + "/iotlayout/" + newFilename + mediaExtension;
			}
			else if(vm.design.orilayoutImage!="" || vm.design.orilayoutImage!=null) 
			{
				imageLocation = vm.design.orilayoutImage;
			}
			vm.design.layoutImage = imageLocation;

			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, 'Incomplete Fields');
			} else {
				HttpSvc.put('iotfloorviewdesigner/' + $stateParams.id, vm.design, Auth.getTokenId(), false)
					.then(function(result) {
						if(vm.fileToUpload) {
							vm.uploadImage(result.azureSasToken);
						} else {
							toastr.success('Design has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						}
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		/* ******************************************************************** */
		
		// Call Actions
		vm.initData();		
	};

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.iotsettings.settings.controller', [])
			.controller('IoTSettingMainCtrl', IoTSettingMainCtrl)
			.controller('IoTSettingCreateCtrl', IoTSettingCreateCtrl)
			.controller('IoTSettingUpdateCtrl', IoTSettingUpdateCtrl);

	/** @ngInject */
	function IoTSettingMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.settingDataFull = [];
		vm.settingData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.settingDataFull, tableState.search.predicateObject) : vm.settingDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.settingData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.settingDataFull.length <= 0) {				
				HttpSvc.get('iotnotificationsettings/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.settingDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteSetting = function(settingId) {
			var params = {};
			HttpSvc.delete('iotnotificationsettings/' + settingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('iotnotificationsettings/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.settingDataFull = result;
							
							toastr.success('The setting has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the setting.', 'Delete Failed');
					return null;
			});
	};
};

/** @ngInject */
	function IoTSettingCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.branches = [];
		vm.users = [];
		vm.sensorList = [];
		vm.setting = {};
		vm.setting.isThirdParty = false;
		vm.selectedBranch = null;
		vm.selectedUser = null;
		vm.selectedSensor = null;

		/* **************************************************************** */
	
		vm.loadBranches = function() {
			HttpSvc.get('branches/list', vm.setting, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
					vm.loadUsers();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
	
		vm.loadUsers = function() {
			HttpSvc.get("users/listallwithaccess", vm.setting, Auth.getTokenId(), true)
				.then(function(result) {
					vm.users = result;
					vm.loadSensors();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}		

		vm.loadSensors = function() {			
			HttpSvc.get('iotsensors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.sensorList = result;
				}, function(error) {
					toastr.error('Failed to retrieve active sensor list. ' + error, '');
					return null;
				});
		}

		/* **************************************************************** */

		vm.selectBranch = function() {
			vm.setting.branchId = vm.selectedBranch.id;
		}
		
		vm.selectUser = function() {
			vm.setting.userId = vm.selectedUser.id;
		}

		vm.selectedSensorChanged = function() {
			vm.setting.sensorId = vm.selectedSensor.id;
		}

		vm.clearBranch = function() {
			vm.setting.branchId = null;
			vm.selectedBranch = null;
		}

		vm.clearSensor = function() {
			vm.setting.sensorId = null;
			vm.selectedSensor = null;
		}

		/* **************************************************************** */
	
		vm.checkAlertOptions = function() {
			if(!vm.setting.alertByEmail)
			{
				vm.setting.email = null;
				vm.setting.branchId = null;
				vm.selectedBranch = null;
			}
			if(!vm.setting.alertByPN)
			{
				vm.setting.userId = null;
				vm.selectedUser = null;
			}
		}

		/* **************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.checkAlertOptions();

				HttpSvc.post('iotnotificationsettings', vm.setting, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Setting has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('iotsettings.settings.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadBranches();
	}

/** @ngInject */
	function IoTSettingUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

	Auth.init();		
	
	var vm = this;
	vm.mode = 2;
	vm.setting = {};
	vm.branches = [];
	vm.users = [];
	vm.sensorList = [];
	vm.changeLogs = [];
	vm.selectedBranch = null;
	vm.selectedUser = null;
	vm.selectedSensor = null;

	/* **************************************************************** */

	vm.loadBranches = function() {
		HttpSvc.get('branches/list', vm.setting, Auth.getTokenId(), true)
			.then(function(result) {
				vm.branches = result;
				vm.loadUsers();
			}, function(error) {
				toastr.error(error, 'Failed');
			});
	}

	vm.loadUsers = function() {
		HttpSvc.get('users/listallwithaccess', vm.setting, Auth.getTokenId(), true)
			.then(function(result) {
				vm.users = result;
				vm.loadSensors();
			}, function(error) {
				toastr.error(error, 'Failed');
			});
	}		

	vm.loadSensors = function() {			
		HttpSvc.get('iotsensors/list', {}, Auth.getTokenId(), true)
			.then(function(result) {	
				vm.sensorList = result;				
				vm.loadSetting();
			}, function(error) {
				toastr.error('Failed to retrieve active sensor list. ' + error, '');
				return null;
			});
	}
						
	vm.loadChangeLogs = function() {
		HttpSvc.get('iotnotificationsettingchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
			.then(function(result) {	
				vm.changeLogs = result;
			}, function() {
				toastr.error('Failed to load the Change Logs.', '');
			});
	};
					
	vm.loadSetting = function() {			
		var params = { id: $stateParams.id };
		HttpSvc.get('iotnotificationsettings/:id', params, Auth.getTokenId(), false)
			.then(function(result) {
				vm.setting = result;

				vm.branches.forEach(function(b) {
					if(b.id==vm.setting.branchId) {
						vm.selectedBranch=b;
					}
				});

				vm.users.forEach(function(u) {
					if(u.id==vm.setting.userId) {
						vm.selectedUser=u;
					}
				});

				vm.sensorList.forEach(function(s) {
					if(s.id==vm.setting.sensorId) {
						vm.selectedSensor=s;
					}
				});

				vm.loadChangeLogs();
			}, function() {
				toastr.error('Failed to load selected Setting.', Auth.translate('ERROR'))
				$state.go('iotsettings.settings.list');
				return;
			});		
	};	

	/* **************************************************************** */

	vm.checkAlertOptions = function() {
		if(!vm.setting.alertByEmail)
		{
			vm.setting.email = null;
			vm.setting.branchId = null;
			vm.selectedBranch = null;
		}
		if(!vm.setting.alertByPN)
		{
			vm.setting.userId = null;
			vm.selectedUser = null;
		}
	}

	/* **************************************************************** */

	vm.selectBranch = function() {
		vm.setting.branchId = vm.selectedBranch.id;
	}
	
	vm.selectUser = function() {
		vm.setting.userId = vm.selectedUser.id;
	}

	vm.selectedSensorChanged = function() {
		vm.setting.sensorId = vm.selectedSensor.id;
	}

	vm.clearBranch = function() {
		vm.setting.branchId = null;
		vm.selectedBranch = null;
	}

	vm.clearSensor = function() {
		vm.setting.sensorId = null;
		vm.selectedSensor = null;
	}

	/* **************************************************************** */
	
	// Form Submission
	vm.submit = function() {
		if(vm.dataForm.$invalid) {
			toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
		} else {
			vm.checkAlertOptions();

			HttpSvc.put('iotnotificationsettings/' + $stateParams.id, vm.setting, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Setting has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
	}
		
	// Call Actions
	vm.loadBranches();		
}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.jobs.jobanalysisfg.controller', [])
        .controller('JobAnalysisFGMainCtrl', JobAnalysisFGMainCtrl)		
        .controller('JobAnalysisFGSalesOrderModalCtrl', JobAnalysisFGSalesOrderModalCtrl)
        .controller('JobAnalysisFGDailyLimitErrorModalCtrl', JobAnalysisFGDailyLimitErrorModalCtrl)
        .controller('JobAnalysisFGSplitJobModalCtrl', JobAnalysisFGSplitJobModalCtrl);

    /** @ngInject */
    function JobAnalysisFGMainCtrl($scope, $filter, $state, $q, $uibModal, $interval, Auth, baSidebarService, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;		
		vm.lockButtons = false;
		vm.productDataFull = [];	
		vm.selectedProducts = [];
		vm.productList = {};
		vm.timeTaken = 0;
		vm.skipCheckDailyLimit = false;
		vm.messageList = [];

		vm.executionDate = new Date();
		vm.executionDate.setDate(vm.executionDate.getDate() + 1)
		vm.executionDate.setHours(0,0,0,0); 
		vm.executionDate = $filter('date')(vm.executionDate, 'yyyy-MM-dd hh:mma');

		vm.startDate = new Date();
		vm.startDate.setHours(0,0,0,0); 
		vm.startDate = $filter('date')(vm.startDate, 'yyyy-MM-dd hh:mma');

		vm.endDate = new Date();
		vm.endDate.setDate(vm.endDate.getDate() + 7)
		vm.endDate.setHours(23,59,59,0); 
		vm.endDate = $filter('date')(vm.endDate, 'yyyy-MM-dd hh:mma');
		vm.isLoading = false;
		
		/* ************************************************** */
		
		vm.viewSalesOrders = function (salesOrderList) {
			vm.movements = [];
			
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'jaSalesOrderModal.html',
				controller: 'JobAnalysisFGSalesOrderModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							salesOrderList: salesOrderList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};	
		
		/* ************************************************** */
					
		// Select All Products
		vm.selectAll = function() {
			vm.selectProductIds = [];
			vm.productDataFull.forEach( function(p) {
				if(p.recommendedBatchQuantity>0) {
					vm.selectProductIds.push(p.productId);					
				}
			});
		};
						
		// De-select All Products
		vm.deselectAll = function() {
			vm.selectProductIds = [];
		};
		
		// Load Job Analysis
		vm.loadJobAnalysisFG = function() {
			vm.isLoading = true;
			vm.executionDate = new Date();
			vm.executionDate.setDate(vm.executionDate.getDate() + 1)
			vm.executionDate.setHours(0,0,0,0); 
			vm.executionDate = $filter('date')(vm.executionDate, 'yyyy-MM-dd hh:mma');
			
			vm.timeTaken = 0;
			vm.timerTick();
			vm.interval = $interval(vm.timerTick, 1000);

			var params = {
				deliveryDateFrom: vm.startDate,
				deliveryDateTo: vm.endDate
			}
			
			HttpSvc.post('jobs/analysisfg', params, Auth.getTokenId(), true)
				.then(function (result) {
					vm.isLoading = false;
					vm.productDataFull = result;
					vm.tableForm.$show();
					$interval.cancel(vm.interval);
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, Auth.translate('ERROR'));
					$interval.cancel(vm.interval);
					return null;
				});
		};	
		
		// Validate Input
		vm.checkValue = function(productId, value) {
			if(vm.selectProductIds.indexOf(productId)>=0) {
				if(isNaN(value)){
					return Auth.translate("ENTER_NUMBERS_ONLY");
				} else if (parseInt(value)<1) {
					return Auth.translate("MUST_BE_GREATER_THAN_ZERO");
				}  else if (!parseInt(value)) {
					return Auth.translate("ENTER_NUMBERS_ONLY");
				}
			}
		};
		
		// Validate Form
		vm.formHasError = function() {
			var totalErrorCount = 0;
			
			vm.tableForm.$editables.forEach(function(field) {
				if(field.error!="") totalErrorCount += 1;
			});
			
			return (totalErrorCount>0) ? true : false;
		}
		
		// Refresh Page
		vm.refreshPage = function() {
			vm.selectProductIds = [];
			vm.loadJobAnalysisFG();
			//$state.reload();
		}
		
		// Consolidate Product IDs
		vm.consolidateProducts = function() {
			vm.selectedProducts = [];
			vm.selectProductIds.forEach( function(p1) {
				vm.productDataFull.forEach(function (p2) {
					if (p2.productId == p1) {
						var newObject = {
							neededDate: p2.salesDate,
							productId: p2.productId,
							unitOfMeasurementId: p2.recipeProductionUomId,
							quantity: p2.recommendedBatchQuantity,
							estimatedProductionQuantity: Math.floor(p2.recipeProductionQty * p2.recommendedBatchQuantity),
						}
						if (p2.isSplitJob) {
							var formattedDate = null;
							if (p2.firstSplitJobExecutionDate != null) {
								var date = moment(p2.firstSplitJobExecutionDate, 'YYYY-MM-DD hh:mmA');
								formattedDate = date.format('YYYY-MM-DDTHH:mm:ss');
							}
							newObject.isSplitJob = p2.isSplitJob;
							newObject.numberOfSplitJob = p2.numberOfSplitJob;
							newObject.numberOfBatchPerSplitJob = p2.numberOfBatchPerSplitJob;
							newObject.firstSplitJobExecutionDate = formattedDate;
						}
						vm.selectedProducts.push(newObject);
					}
				});
			});
			
			vm.productList = {
				productList: vm.selectedProducts		
			};
		};
		
		// Generate Jobs
		vm.generateJobs = function() {
			vm.tableForm.$submit();
						
			if(vm.formHasError()) {
				vm.tableForm.$show();
				toastr.error(Auth.translate("PLEASE_ENTER_THE_CORRECT_VALUES"), Auth.translate('ERROR'));
			} else { 			
				vm.lockButtons = true;
				vm.consolidateProducts();
				var date = moment(vm.executionDate, 'YYYY-MM-DD hh:mmA');
				var formattedDate = date.format('YYYY-MM-DDTHH:mm:ss');
				var params = {
					'jobDate': formattedDate,
					'skipCheckDailyLimit': vm.skipCheckDailyLimit,
					'productList': vm.productList.productList
				}
				
				HttpSvc.post('jobs/analysisfg/batchcreation', params, Auth.getTokenId(), true)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						vm.tableForm.$show();
						toastr.error(error, 'Failed');
					});
			}
		};

		vm.checkResult = function (result) {
			vm.messageList = [];
			result.forEach(function (item) {
				if (item.status == 'error') {
					vm.messageList.push(item)
				}
			});
			if (vm.messageList.length > 0) {
				vm.lockButtons = false;
				vm.showDailyLimitErrorModal();
			} else {
				toastr.success(Auth.translate("BATCH_PRODUCTION_COMPLETED"), Auth.translate('SUCCESS'));
				vm.lockButtons = false;
				vm.skipCheckDailyLimit = false;
				vm.refreshPage();
			}
		}
		vm.showDailyLimitErrorModal = function (date) {
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'dailyLimitErrorModal.html',
				controller: 'JobAnalysisFGDailyLimitErrorModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							messageList: vm.messageList,
						}
					}
				}
			});

			modalInstance
						.result
						.then(function (data) {
							vm.skipCheckDailyLimit = true;
							vm.messageList = [];
						vm.generateJobs();
				}, function () {
				vm.lockButtons = false;
				vm.tableForm.$show();
				});
		};

		vm.showSplitJobModal = function (item) {
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'splitJobModal.html',
				controller: 'JobAnalysisFGSplitJobModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							item: item,
						}
					}
				}
			});
			modalInstance
				.result
				.then(function (newItem) {
					vm.assignNewItemSplitJob(newItem);
				}, function () {
				vm.lockButtons = false;
				vm.tableForm.$show();
				});
		};

		vm.assignNewItemSplitJob = function (obj) {
			vm.productDataFull.forEach(function(i) {
				if(i.productId==obj.productId) {
					i = obj;
				}
			});	
		}

		vm.timerTick = function() {
			vm.timeTaken += 1;
		}
				
		vm.initData = function() {			
			baSidebarService.setMenuCollapsed(true);
			vm.loadJobAnalysisFG();
		}
		
		// Call Action
		vm.initData();
	};

	/** @ngInject */
	function JobAnalysisFGSalesOrderModalCtrl($uibModalInstance, $filter, $sce, Auth, item, toastr) {
		var $mdl = this;
		$mdl.salesOrderList = item.salesOrderList;
		
		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfRecordFiltered = 0;
		$mdl.numOfRecordDisplayed = 0;
		$mdl.startIndex = 0; 
		$mdl.endIndex = 0;
		$mdl.salesDataFull = [];
		$mdl.salesData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.salesDataFull, tableState.search.predicateObject) : $mdl.salesDataFull;
			$mdl.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			$mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
			$mdl.salesData = result;
			
			tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		$mdl.retrieveData = function(tableState) {		
			var params = {}
			var pagination = tableState.pagination;
			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.
						
			if($mdl.salesDataFull.length <= 0) {
				$mdl.numOfRecord = item.salesOrderList.length;	
				$mdl.salesDataFull = item.salesOrderList;
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);	
			} else {
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
			}
		};		
		
		// ********************************************************		
		
		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	

	function JobAnalysisFGDailyLimitErrorModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) { 
		var $mdl = this;
		$mdl.lockButtons = false;
		$mdl.messageList = item.messageList;
		$mdl.date = item.date;
		
		$mdl.confirmModal = function()
		{
			$mdl.lockButtons = false;
			$uibModalInstance.close();
		};

		$mdl.cancelModal = function() {
			$mdl.lockButtons = false;
			$uibModalInstance.dismiss('cancel');
		};
	};

	function JobAnalysisFGSplitJobModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr, $filter) { 
		var $mdl = this;
		$mdl.lockButtons = false;
		$mdl.item = item.item;

		$mdl.init = function () {
			if ($mdl.item.firstSplitJobExecutionDate != null) {
				$mdl.item.firstSplitJobExecutionDate = $mdl.formatDateToCurrent($mdl.item.firstSplitJobExecutionDate);
			}
		}
		
		$mdl.confirmModal = function()
		{
			if (!$mdl.splitJobForm.$valid)
			{
				toastr.error('Please fill up all the required fields.', Auth.translate('ERROR'));
			}
			else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

	};
})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.iotsettings.sensors.controller', [])
			.controller('IoTSensorMainCtrl', IoTSensorMainCtrl)
			.controller('IoTSensorCreateCtrl', IoTSensorCreateCtrl)
			.controller('IoTSensorUpdateCtrl', IoTSensorUpdateCtrl)
			.controller('IoTSensorThresholdModalCtrl', IoTSensorThresholdModalCtrl);

	/** @ngInject */
	function IoTSensorMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
	
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.sensorDataFull = [];
		vm.sensorData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.sensorDataFull, tableState.search.predicateObject) : vm.sensorDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.sensorData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.sensorDataFull.length <= 0) {				
				HttpSvc.get('iotsensors/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.sensorDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteSensor = function(sensorId, sensorName) {
			var params = {};
			HttpSvc.delete('iotsensors/' + sensorId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('iotsensors/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.sensorDataFull = result;
							
							toastr.success('The sensor [' + sensorName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the sensor [' + sensorName + '].', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function IoTSensorCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.sensor = {};
		vm.sensor.enabled = true;
		vm.gateways = [];
		vm.deviceList = [];
		vm.selectedGateway = null;
		vm.selectedDevice = null;
		vm.symbol = "C";
		vm.canSetIoTHardwareSettings = Auth.canSetIoTHardwareSettings();
		
		/* ************************************************************* */

		vm.loadGateways = function() {
			HttpSvc.get('iotgateways/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.gateways = result;
					vm.loadDevices();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		vm.loadDevices = function() {
			HttpSvc.get('iotregistereddevices/list/available/sensors', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.deviceList = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});
	
		}
		
		/* ************************************************************* */

		vm.selectedSymbolChanged = function() {
			if(vm.sensor.isFahrenheit)
			{
				vm.symbol = "F";
			}
			else
			{
				vm.symbol = "C";
			}
		}

		vm.selectedGatewayChanged = function() {
			vm.sensor.gatewayId = vm.selectedGateway.id;
		}

		vm.selectedDeviceChanged = function() {
			vm.sensor.deviceId = vm.selectedDevice.id;
			vm.sensor.deviceUID = vm.selectedDevice.deviceUID;
			vm.sensor.deviceType = vm.selectedDevice.type;
			vm.sensor.model = vm.selectedDevice.model;
		}
	
		vm.clearDevice = function() {
			vm.selectedDevice = null;
			vm.sensor.deviceId = "";
			vm.sensor.deviceUID = "";
			vm.sensor.deviceType = "";
			vm.sensor.model = "";
		}

		/* ************************************************************* */
			
		// Open Modal Dialog
		vm.setting = {};		
		vm.showAddSettingModal = function () {
			vm.setting = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'settingModal.html',
				controller: 'IoTSensorThresholdModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.setting,
							symbol: vm.symbol
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addSetting(data);
				}, function () {
				});
		};	
		vm.showEditSettingModal = function (index) {
			vm.setting = vm.sensor.iotSensorThresholdSettings[index];
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'settingModal.html',
				controller: 'IoTSensorThresholdModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.setting,
							symbol: vm.symbol
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateSetting(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************* */		
		
		// Remove Setting
		vm.removeSetting = function(index) {
			vm.sensor.iotSensorThresholdSettings.splice(index, 1);
		};
			
		// Update Setting
		vm.updateSetting = function(index, obj) {
			var element = {
				type: obj.type,
				description: obj.description,
				colorCode: obj.colorCode,
				triggerAlert: obj.triggerAlert,
				valueStart: obj.valueStart,
				valueEnd: obj.valueEnd,
				hitCount: obj.hitCount,
				timeSpan: obj.timeSpan,
				muteMon: obj.muteMon,
				muteTue: obj.muteTue,
				muteWed: obj.muteWed,
				muteThu: obj.muteThu,
				muteFri: obj.muteFri,
				muteSat: obj.muteSat,
				muteSun: obj.muteSun,
				muteFromHour: obj.muteFromHour,
				muteFromMinute: obj.muteFromMinute,
				muteToHour: obj.muteToHour,
				muteToMinute: obj.muteToMinute,
			};
			vm.sensor.iotSensorThresholdSettings.splice(index, 1, element);
		};

		// Add Setting
		vm.addSetting = function(obj) {
			var element = {
				type: obj.type,
				description: obj.description,
				colorCode: obj.colorCode,
				triggerAlert: obj.triggerAlert,
				valueStart: obj.valueStart,
				valueEnd: obj.valueEnd,
				hitCount: obj.hitCount,
				timeSpan: obj.timeSpan,
				muteMon: obj.muteMon,
				muteTue: obj.muteTue,
				muteWed: obj.muteWed,
				muteThu: obj.muteThu,
				muteFri: obj.muteFri,
				muteSat: obj.muteSat,
				muteSun: obj.muteSun,
				muteFromHour: obj.muteFromHour,
				muteFromMinute: obj.muteFromMinute,
				muteToHour: obj.muteToHour,
				muteToMinute: obj.muteToMinute,
			};
			vm.sensor.iotSensorThresholdSettings.push(element);
		};
		
		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('iotsensors', vm.sensor, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Sensor has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('iotsettings.sensors.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadGateways();
	}

/** @ngInject */
	function IoTSensorUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.sensor = {};
		vm.gateways = [];
		vm.deviceList = [];
		vm.changeLogs = [];
		vm.selectedGateway = null;
		vm.selectedDevice = null;
		vm.symbol = "C";
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.lockButtons = false;
		vm.canSetIoTHardwareSettings = Auth.canSetIoTHardwareSettings();

		/* ************************************************************* */

		vm.loadGateways = function() {
			vm.lockButtons = true;

			HttpSvc.get('iotgateways/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.gateways = result;
					vm.loadSensor();
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.loadDevices = function() {
			var deviceId = vm.sensor.deviceId==null?"":vm.sensor.deviceId;
			HttpSvc.get('iotregistereddevices/list/available/sensors/' + deviceId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.deviceList = result;

					vm.deviceList.forEach(function(d) {
						if(d.id==vm.sensor.deviceId) {
							vm.selectedDevice=d;
						}
					});

					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
	
		}
						
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('iotsensorchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};
						
		// Load Sensor
		vm.loadSensor = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('iotsensors/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.sensor = result;

					vm.gateways.forEach(function(b) {
						if(b.id==vm.sensor.gatewayId) {
							vm.selectedGateway=b;
						}
					});

					vm.loadDevices();
					vm.loadChangeLogs();
					vm.selectedSymbolChanged();

				}, function() {
					toastr.error('Failed to load selected Sensor.', Auth.translate('ERROR'))
					$state.go('iotsettings.sensors.list');
					return;
				});		
		};	
		
		/* ************************************************************* */

		vm.selectedSymbolChanged = function() {
			if(vm.sensor.isFahrenheit)
			{
				vm.symbol = "F";
			}
			else
			{
				vm.symbol = "C";
			}
		}

		vm.selectedGatewayChanged = function() {
			vm.sensor.gatewayId = vm.selectedGateway.id;
		}

		vm.selectedDeviceChanged = function() {
			vm.sensor.deviceId = vm.selectedDevice.id;
			vm.sensor.deviceUID = vm.selectedDevice.deviceUID;
			vm.sensor.deviceType = vm.selectedDevice.type;
			vm.sensor.model = vm.selectedDevice.model;
		}
	
		vm.clearDevice = function() {
			vm.selectedDevice = null;
			vm.sensor.deviceId = "";
			vm.sensor.deviceUID = "";
			vm.sensor.deviceType = "";
			vm.sensor.model = "";
		}
			
		/* ************************************************************* */
			
		// Open Modal Dialog
		vm.setting = {};		
		vm.showAddSettingModal = function () {
			vm.setting = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'settingModal.html',
				controller: 'IoTSensorThresholdModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.setting,
							symbol: vm.symbol
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addSetting(data);
				}, function () {
				});
		};	
		vm.showEditSettingModal = function (index) {
			vm.setting = vm.sensor.iotSensorThresholdSettings[index];
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'settingModal.html',
				controller: 'IoTSensorThresholdModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.setting,
							symbol: vm.symbol
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateSetting(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************* */		
		
		// Remove Setting
		vm.removeSetting = function(index) {
			vm.sensor.iotSensorThresholdSettings.splice(index, 1);
		};
			
		// Update Setting
		vm.updateSetting = function(index, obj) {
			var element = {
				type: obj.type,
				description: obj.description,
				colorCode: obj.colorCode,
				triggerAlert: obj.triggerAlert,
				valueStart: obj.valueStart,
				valueEnd: obj.valueEnd,
				hitCount: obj.hitCount,
				timeSpan: obj.timeSpan,
				muteMon: obj.muteMon,
				muteTue: obj.muteTue,
				muteWed: obj.muteWed,
				muteThu: obj.muteThu,
				muteFri: obj.muteFri,
				muteSat: obj.muteSat,
				muteSun: obj.muteSun,
				muteFromHour: obj.muteFromHour,
				muteFromMinute: obj.muteFromMinute,
				muteToHour: obj.muteToHour,
				muteToMinute: obj.muteToMinute,
			};
			vm.sensor.iotSensorThresholdSettings.splice(index, 1, element);
		};

		// Add Setting
		vm.addSetting = function(obj) {
			var element = {
				type: obj.type,
				description: obj.description,
				colorCode: obj.colorCode,
				triggerAlert: obj.triggerAlert,
				valueStart: obj.valueStart,
				valueEnd: obj.valueEnd,
				hitCount: obj.hitCount,
				timeSpan: obj.timeSpan,
				muteMon: obj.muteMon,
				muteTue: obj.muteTue,
				muteWed: obj.muteWed,
				muteThu: obj.muteThu,
				muteFri: obj.muteFri,
				muteSat: obj.muteSat,
				muteSun: obj.muteSun,
				muteFromHour: obj.muteFromHour,
				muteFromMinute: obj.muteFromMinute,
				muteToHour: obj.muteToHour,
				muteToMinute: obj.muteToMinute,
			};
			vm.sensor.iotSensorThresholdSettings.push(element);
		};
		
		/* ************************************************************* */
		
		vm.deleteSensor = function() {
			var params = {};

			HttpSvc.delete('iotsensors/' + vm.sensor.id, params, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('The sensor has been deleted.', 'Delete Success');
					$state.go('iotsettings.sensors.list');
				}, function() {
					// Failed
					toastr.error('Failed to delete the sensor.', 'Delete Failed');
					return null;
			});
		};

		vm.deleteReadings = function() {
			vm.lockButtons = true;

			HttpSvc.delete('iotsensors/deletereadings/' + vm.sensor.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success(result.message, Auth.translate('SUCCESS'));
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to delete the sensor readings.', 'Delete Failed');
					return null;
				});
		}

		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('iotsensors/' + $stateParams.id, vm.sensor, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Sensor has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadGateways();		
	}
		
	function IoTSensorThresholdModalCtrl($uibModalInstance, item, toastr) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.item = item.object;
		$mdl.symbol = item.symbol;
		$mdl.selectedType = null;
		$mdl.selectedTimeSpan = null;
		$mdl.selectedFromHour = null;
		$mdl.selectedFromMinute = null;
		$mdl.selectedTillHour = null;
		$mdl.selectedTillMinute = null;
		$mdl.muteFromTime = "";
		$mdl.muteTillTime = "";

		$mdl.typeList = [
			{id: 'TEMPERATURE', name: 'TEMPERATURE'}, 
			{id: 'HUMIDITY', name: 'HUMIDITY'}, 
		];
		$mdl.periodList = [
			{id: 180, name: 'Instant Alert'}, 
			{id: 1800, name: '30 Minutes'}, 
			{id: 3600, name: '1 Hour'}, 
			{id: 7200, name: '2 Hours'}, 
			{id: 10800, name: '3 Hours'}, 
			{id: 14400, name: '4 Hours'}, 
		];
		$mdl.hourList = [
			{id: 0, name: '00'}, 
			{id: 1, name: '01'}, 
			{id: 2, name: '02'}, 
			{id: 3, name: '03'}, 
			{id: 4, name: '04'}, 
			{id: 5, name: '05'}, 
			{id: 6, name: '06'}, 
			{id: 7, name: '07'}, 
			{id: 8, name: '08'}, 
			{id: 9, name: '09'}, 
			{id: 10, name: '10'}, 
			{id: 11, name: '11'}, 
			{id: 12, name: '12'}, 
			{id: 13, name: '13'}, 
			{id: 14, name: '14'}, 
			{id: 15, name: '15'}, 
			{id: 16, name: '16'}, 
			{id: 17, name: '17'}, 
			{id: 18, name: '18'}, 
			{id: 19, name: '19'}, 
			{id: 20, name: '20'}, 
			{id: 21, name: '21'}, 
			{id: 22, name: '22'}, 
			{id: 23, name: '23'}, 
		];
		$mdl.minuteList = [
			{id: 0, name: '00'}, 
			{id: 15, name: '15'}, 
			{id: 30, name: '30'}, 
			{id: 45, name: '45'}, 
		];

		/* ************************************************************* */

		$mdl.selectColor = function(colorCode) {
			$mdl.item.colorCode = colorCode;
		}

		$mdl.selectedTypeChanged = function() {
			$mdl.item.type = $mdl.selectedType.id;
		}

		$mdl.selectedTimeSpanChanged = function() {
			$mdl.item.timeSpan = $mdl.selectedTimeSpan.id;
		}

		$mdl.selectedFromHourChanged = function() {
			$mdl.item.muteFromHour = $mdl.selectedFromHour.id;
			$mdl.loadMuteFromTime();
		}

		$mdl.selectedFromMinuteChanged = function() {
			$mdl.item.muteFromMinute = $mdl.selectedFromMinute.id;
			$mdl.loadMuteFromTime();
		}

		$mdl.selectedTillHourChanged = function() {
			$mdl.item.muteToHour = $mdl.selectedTillHour.id;
			$mdl.loadMuteTillTime();
		}

		$mdl.selectedTillMinuteChanged = function() {
			$mdl.item.muteToMinute = $mdl.selectedTillMinute.id;
			$mdl.loadMuteTillTime();
		}

		$mdl.loadMuteFromTime = function() {
			var h = $mdl.item.muteFromHour + "";
			var m = $mdl.selectedFromMinute==null?"":$mdl.selectedFromMinute.name;
			var ampm = "AM";

			if($mdl.item.muteFromHour == 0)
			{
				h = "12";
				ampm = "AM";
			}
			else if($mdl.item.muteFromHour == 12)
			{
				h = "12";
				ampm = "PM";
			}
			else if($mdl.item.muteFromHour > 12)
			{
				h = ($mdl.item.muteFromHour - 12) + "";
				ampm = "PM";
			}
			$mdl.muteFromTime = h + ":" + m + " " + ampm;
		}

		$mdl.loadMuteTillTime = function() {
			var h = $mdl.item.muteToHour + "";
			var m = $mdl.selectedTillMinute==null?"":$mdl.selectedTillMinute.name;
			var ampm = "AM";

			if($mdl.item.muteToHour == 0)
			{
				h = "12";
				ampm = "AM";
			}
			else if($mdl.item.muteToHour == 12)
			{
				h = "12";
				ampm = "PM";
			}
			else if($mdl.item.muteToHour > 12)
			{
				h = ($mdl.item.muteToHour - 12) + "";
				ampm = "PM";
			}
			$mdl.muteTillTime = h + ":" + m + " " + ampm;
		}

		/* ************************************************************* */

		if($mdl.mode==1) {
			$mdl.item.triggerAlert = true;
			$mdl.item.timeSpan = 180;
			$mdl.item.hitCount = 0;
			$mdl.item.colorCode = "#00ff00";
		} else if($mdl.mode==2) {
			$mdl.item.hitCount = 0;
			$mdl.typeList.forEach(function(t) {
				if(t.id==$mdl.item.type)
				{
					$mdl.selectedType = t;
				}
			});
			$mdl.periodList.forEach(function(p) {
				if(p.id==$mdl.item.timeSpan)
				{
					$mdl.selectedTimeSpan = p;
				}
			});
			$mdl.hourList.forEach(function(h) {
				if(h.id==$mdl.item.muteFromHour)
				{
					$mdl.selectedFromHour = h;
				}
				if(h.id==$mdl.item.muteToHour)
				{
					$mdl.selectedTillHour = h;
				}
			});
			$mdl.minuteList.forEach(function(m) {
				if(m.id==$mdl.item.muteFromMinute)
				{
					$mdl.selectedFromMinute = m;
				}
				if(m.id==$mdl.item.muteToMinute)
				{
					$mdl.selectedTillMinute = m;
				}
			});

			$mdl.loadMuteFromTime();
			$mdl.loadMuteTillTime();
		}

		/* ************************************************************* */

		$mdl.confirmModal = function() {
			if($mdl.settingForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.jobs.jobanalysissemifg.controller', [])
        .controller('JobAnalysisSFGMainCtrl', JobAnalysisSFGMainCtrl)		
        .controller('JobAnalysisSFGSalesOrderModalCtrl', JobAnalysisSFGSalesOrderModalCtrl)
        .controller('JobAnalysisSFGDailyLimitErrorModalCtrl', JobAnalysisSFGDailyLimitErrorModalCtrl)
        .controller('JobAnalysisSFGSplitJobModalCtrl', JobAnalysisSFGSplitJobModalCtrl);

    /** @ngInject */
    function JobAnalysisSFGMainCtrl($scope, $filter, $state, $q, $uibModal, $interval, Auth, baSidebarService, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;		
		vm.lockButtons = false;
		vm.productDataFull = [];	
		vm.selectedProducts = [];
		vm.productList = {};
		vm.timeTaken = 0;		
		vm.skipCheckDailyLimit = false;
		vm.messageList = [];

		vm.executionDate = new Date();
		vm.executionDate.setDate(vm.executionDate.getDate() + 1)
		vm.executionDate.setHours(0,0,0,0); 
		vm.executionDate = $filter('date')(vm.executionDate, 'yyyy-MM-dd hh:mma');

		vm.startDate = new Date();
		vm.startDate.setHours(0,0,0,0); 
		vm.startDate = $filter('date')(vm.startDate, 'yyyy-MM-dd hh:mma');

		vm.endDate = new Date();
		vm.endDate.setDate(vm.endDate.getDate() + 7)
		vm.endDate.setHours(23,59,59,0); 
		vm.endDate = $filter('date')(vm.endDate, 'yyyy-MM-dd hh:mma');
		vm.isLoading = false;
		
		/* ************************************************** */
		
		vm.viewSalesOrders = function (salesOrderList) {
			vm.movements = [];
			
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'jaSalesOrderModal.html',
				controller: 'JobAnalysisSFGSalesOrderModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							salesOrderList: salesOrderList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};	
		
		/* ************************************************** */
					
		// Select All Products
		vm.selectAll = function() {
			vm.selectProductIds = [];
			vm.productDataFull.forEach( function(p) {
				if(p.recommendedBatchQuantity>0) {
					vm.selectProductIds.push(p.productId);					
				}
			});
		};
						
		// De-select All Products
		vm.deselectAll = function() {
			vm.selectProductIds = [];
		};
		
		// Load Job Analysis
		vm.loadJobAnalysisSemiFG = function() {
			vm.isLoading = true;
			vm.executionDate = new Date();
			vm.executionDate.setDate(vm.executionDate.getDate() + 1)
			vm.executionDate.setHours(0,0,0,0); 
			vm.executionDate = $filter('date')(vm.executionDate, 'yyyy-MM-dd hh:mma');
			
			vm.timeTaken = 0;
			vm.timerTick();
			vm.interval = $interval(vm.timerTick, 1000);

			var params = {
				deliveryDateFrom: vm.startDate,
				deliveryDateTo: vm.endDate
			}
			
			HttpSvc.post('jobs/analysissemifg', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.isLoading = false;
					vm.productDataFull = result;
					vm.tableForm.$show();
					$interval.cancel(vm.interval);
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					$interval.cancel(vm.interval);
					return null;
				});
		};	
		
		// Validate Input
		vm.checkValue = function(productId, value) {
			if(vm.selectProductIds.indexOf(productId)>=0) {
				if(isNaN(value)){
					return Auth.translate("ENTER_NUMBERS_ONLY");
				} else if (parseInt(value)<1) {
					return Auth.translate("MUST_BE_GREATER_THAN_ZERO");
				}  else if (!parseInt(value)) {
					return Auth.translate("ENTER_NUMBERS_ONLY");
				}
			}
		};
		
		// Validate Form
		vm.formHasError = function() {
			var totalErrorCount = 0;
			
			vm.tableForm.$editables.forEach(function(field) {
				if(field.error!="") totalErrorCount += 1;
			});
			
			return (totalErrorCount>0) ? true : false;
		}
		
		// Refresh Page
		vm.refreshPage = function() {
			vm.selectProductIds = [];
			vm.loadJobAnalysisSemiFG();
			//$state.reload();
		}
		
		// Consolidate Product IDs
		vm.consolidateProducts = function() {
			vm.selectedProducts = [];
			vm.selectProductIds.forEach( function(p1) {
				vm.productDataFull.forEach( function(p2) {
					if (p2.productId == p1) {
						var newObject = {
							neededDate: p2.salesDate,
							productId: p2.productId,
							unitOfMeasurementId: p2.recipeProductionUomId,
							quantity: p2.recommendedBatchQuantity,
							estimatedProductionQuantity: Math.floor(p2.recipeProductionQty * p2.recommendedBatchQuantity),
						}
						if (p2.isSplitJob) {
							var formattedDate = null;
							if (p2.firstSplitJobExecutionDate != null) {
								var date = moment(p2.firstSplitJobExecutionDate, 'YYYY-MM-DD hh:mmA');
								formattedDate = date.format('YYYY-MM-DDTHH:mm:ss');
							}
							newObject.isSplitJob = p2.isSplitJob;
							newObject.numberOfSplitJob = p2.numberOfSplitJob;
							newObject.numberOfBatchPerSplitJob = p2.numberOfBatchPerSplitJob;
							newObject.firstSplitJobExecutionDate = formattedDate;
						}
						vm.selectedProducts.push(newObject);
					}
				});
			});
			
			vm.productList = {
				productList: vm.selectedProducts		
			};
		};
		
		// Generate Jobs
		vm.generateJobs = function() {
			vm.tableForm.$submit();
						
			if(vm.formHasError()) {
				vm.tableForm.$show();
				toastr.error(Auth.translate("PLEASE_ENTER_THE_CORRECT_VALUES"), Auth.translate('ERROR'));
			} else { 			
				vm.lockButtons = true;
				vm.consolidateProducts();
				var date = moment(vm.executionDate, 'YYYY-MM-DD hh:mmA');
				var formattedDate = date.format('YYYY-MM-DDTHH:mm:ss');
				var params = {
					'jobDate': formattedDate,
					'skipCheckDailyLimit': vm.skipCheckDailyLimit,
					'productList': vm.productList.productList
				}
				
				HttpSvc.post('jobs/analysissemifg/batchcreation', params, Auth.getTokenId(), true)
					.then(function (result) {
						vm.checkResult(result);
					}, function (error) {
						vm.lockButtons = false;
						vm.tableForm.$show();
						toastr.error(error, 'Failed');
					});
			}
		};

		vm.checkResult = function (result) {
			vm.messageList = [];
			result.forEach(function (item) {
				if (item.status == 'error') {
					vm.messageList.push(item)
				}
			});
			if (vm.messageList.length > 0) {
				vm.lockButtons = false;
				vm.showDailyLimitErrorModal();
			}
			else {
				toastr.success(Auth.translate("BATCH_PRODUCTION_COMPLETED"), Auth.translate('SUCCESS'));
				vm.lockButtons = false;
				vm.skipCheckDailyLimit = false;
				vm.refreshPage();
			}
		}

		 vm.showDailyLimitErrorModal = function (date) {
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'dailyLimitErrorModal.html',
				controller: 'JobAnalysisSFGDailyLimitErrorModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							messageList: vm.messageList,
						}
					}
				}
			});

			modalInstance
						.result
				.then(function (data) {
					vm.skipCheckDailyLimit = true;
					vm.messageList = [];
					vm.generateJobs();
				}, function () {
					vm.lockButtons = false;
					vm.tableForm.$show();
				});
			};

			vm.showSplitJobModal = function (item) {
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'splitJobModal.html',
				controller: 'JobAnalysisFGSplitJobModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							item: item,
						}
					}
				}
			});
			modalInstance
				.result
				.then(function (newItem) {
					vm.assignNewItemSplitJob(newItem);
				}, function () {
				vm.lockButtons = false;
				vm.tableForm.$show();
				});
		};
		
		vm.assignNewItemSplitJob = function (obj) {
			vm.productDataFull.forEach(function(i) {
				if(i.productId==obj.productId) {
					i = obj;
				}
			});	
		}

		vm.timerTick = function() {
			vm.timeTaken += 1;
		}
				
		vm.initData = function() {			
			baSidebarService.setMenuCollapsed(true);
			vm.loadJobAnalysisSemiFG();
		}
		
		// Call Action
		vm.initData();
	};

	/** @ngInject */
	function JobAnalysisSFGSalesOrderModalCtrl($uibModalInstance, $filter, $sce, Auth, item, toastr) {
		var $mdl = this;
		$mdl.salesOrderList = item.salesOrderList;
		
		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfRecordFiltered = 0;
		$mdl.numOfRecordDisplayed = 0;
		$mdl.startIndex = 0; 
		$mdl.endIndex = 0;
		$mdl.salesDataFull = [];
		$mdl.salesData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.salesDataFull, tableState.search.predicateObject) : $mdl.salesDataFull;
			$mdl.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			$mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
			$mdl.salesData = result;
			
			tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		$mdl.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.
						
			if($mdl.salesDataFull.length <= 0) {
				$mdl.numOfRecord = item.salesOrderList.length;	
				$mdl.salesDataFull = item.salesOrderList;
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);	
			} else {
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
			}
		};		
		
		// ********************************************************		
		
		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	

	function JobAnalysisSFGDailyLimitErrorModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) { 
		var $mdl = this;
		$mdl.lockButtons = false;
		$mdl.messageList = item.messageList;
		$mdl.date = item.date;
		
		$mdl.confirmModal = function()
		{
      		$mdl.lockButtons = false;
			$uibModalInstance.close();
		};

		$mdl.cancelModal = function() {
			$mdl.lockButtons = false;
			$uibModalInstance.dismiss('cancel');
		};
	};
	
	function JobAnalysisSFGSplitJobModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr, $filter) { 
		var $mdl = this;
		$mdl.lockButtons = false;
		$mdl.item = item.item;

		$mdl.init = function () {
			if ($mdl.item.firstSplitJobExecutionDate != null) {
				$mdl.item.firstSplitJobExecutionDate = $mdl.formatDateToCurrent($mdl.item.firstSplitJobExecutionDate);
			}
		}
		
		$mdl.confirmModal = function()
		{
			if (!$mdl.splitJobForm.$valid)
			{
				toastr.error('Please fill up all the required fields.', Auth.translate('ERROR'));
			}
			else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

	};
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.jobs.jobdashboard.controller', [])
        .controller('JobDashboardMainCtrl', JobDashboardMainCtrl)
        .controller('JobDashboardCompleteModalCtrl', JobDashboardCompleteModalCtrl);

    /** @ngInject */
    function JobDashboardMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, baSidebarService, HttpSvc, toastr) {

		Auth.init();

		var vm = this;
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.jobDataFull = [];
		vm.jobData = [];
		vm.isLoading = false;
		vm.isProcessing = false;
		vm.ignoreWarning = false;

		/* *************************************************************** */

		vm.initData = function() {
			vm.loadDashboard();
			baSidebarService.setMenuCollapsed(true);
		};

		vm.loadDashboard = function() {
			vm.isLoading = true;

			HttpSvc.get('jobs/dashboard', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.isLoading = false;
					vm.numOfRecord = result.length;
					vm.jobDataFull = result;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		};

		vm.startJob = function(jobId, jobNo) {
			vm.isProcessing = true;

			var isIgnore = vm.ignoreWarning ? "/1" : "";

			HttpSvc.put('jobs/start/'+jobId+isIgnore, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.ignoreWarning = false;
					vm.checkResult(result, jobId, jobNo);
				}, function(error) {
					vm.isProcessing = false;
					toastr.error(error, '');
				});
		};

		vm.checkResult = function(result, jobId, jobNo) {

			vm.result = result;

			if(result.httpStatusCode=="200")
			{
				vm.isProcessing = false;
				vm.reload();
			}
			else if (result.httpStatusCode=="300")
			{
				vm.ignoreWarning = window.confirm(result.message);
				if(vm.ignoreWarning)
					vm.startJob(jobId, jobNo)
				else
					vm.isProcessing = false;
			}
			else
			{
				vm.isProcessing = false;
				toastr.error(result.message, '');
			}
		}

		vm.reload = function() {
			$state.reload();
		}

		/* *************************************************************** */

		vm.showCompleteJobModal = function (jobId, jobNo, productName, packingQty, packingUom) {
			vm.job = {};
			vm.job.id = jobId;
			vm.job.jobNo = jobNo;
			vm.job.productName = productName;
			vm.job.packingQty = packingQty;
			vm.job.packingUom = packingUom;

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'confirmModal.html',
				controller: 'JobDashboardCompleteModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							object: vm.job
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.reload();
				}, function () {
				});
		};

		vm.printJobSheet = function(jobId, jobNo) {

			var filename = "JOBSHEET_" + jobNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('jobs/print/' + jobId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate Job Sheet. ' + error, '');
							return null;
						});
		}

		/* *************************************************************** */

		// Call Action
		vm.initData();
	};

	// Job Complete Modal Controller
	function JobDashboardCompleteModalCtrl($uibModalInstance, $filter, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.item = item.object;
		$mdl.job = {};
		$mdl.isLoading = false;
		$mdl.isRmsLite = Auth.isLiteMode();
		$mdl.isSimpleStockIn = Auth.getSetting_isStockInSimpleMode();

        $mdl.item.actualProductionQuantity = $mdl.item.packingQty;

		$mdl.loadJob = function() {
			$mdl.isLoading = true;

			var params = { id: $mdl.item.id };
			HttpSvc.get('jobs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.job = result;
					$mdl.job.jobDate = $filter('date')($mdl.job.jobDate, 'yyyy-MM-dd hh:mma');
					$mdl.job.neededDate = $filter('date')($mdl.job.jobDate, 'yyyy-MM-dd');
					$mdl.isLoading = false;
				}, function() {
					toastr.error('Failed to load selected Job.', Auth.translate('ERROR'))
					$uibModalInstance.dismiss('cancel');
					$mdl.isLoading = false;
					return;
				});
		};

        $mdl.directToPrintLabel = function() {
            if ($mdl.job.productId && $mdl.job.productName) {
                window.location.href = '/#/label/products/print?jobNo=' + $mdl.job.jobNo;
            } else if ($mdl.job.semiFinishedProductId && $mdl.job.semiFgName) {
                window.location.href = '/#/label/semifgs/print?jobNo=' + $mdl.job.jobNo;
            }
        }

		$mdl.confirmModal = function() {
			$mdl.isLoading = false;

			if($mdl.confirmForm.$invalid){
				$mdl.isLoading = false;
			} else {
				$mdl.isLoading = true;

				$mdl.job.failureReason = $mdl.item.failureReason;
				$mdl.job.actualProductionQuantity = $mdl.item.actualProductionQuantity;
				$mdl.job.actualDefectQuantity = $mdl.job.estimatedProductionQuantity - $mdl.job.actualProductionQuantity;

				if($mdl.job.actualDefectQuantity<0)
					$mdl.job.actualDefectQuantity = 0;

				if($mdl.job.actualDefectQuantity == 0) {
					$mdl.job.status = 3;
				} else if($mdl.job.actualDefectQuantity != 0) {
					$mdl.job.status = 4;
				}

				HttpSvc.put('jobs/' + $mdl.item.id, $mdl.job, Auth.getTokenId(), false)
					.then(function(result) {
						$mdl.isLoading = false;

						if($mdl.job.actualDefectQuantity == 0) {
							toastr.success('Job Status has been updated to <b>COMPLETED</b>.', Auth.translate('SUCCESS'));
						} else if($mdl.job.actualDefectQuantity != 0) {
							toastr.success('Job Status has been updated to <b>COMPLETED (VARIANCE)</b>.', Auth.translate('SUCCESS'));
						}

						$uibModalInstance.close($mdl.item);

					}, function(error) {
						$mdl.isLoading = false;
						toastr.error(error, 'Failed');
					});
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		$mdl.loadJob();
	};
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.jobs.joblist.controller', [])
        .controller('JobMainCtrl', JobMainCtrl)
        .controller('JobCreateCtrl', JobCreateCtrl)
        .controller('JobUpdateCtrl', JobUpdateCtrl)
        .controller('JobPrintModalCtrl', JobPrintModalCtrl)
        .controller('JobLabelModalCtrl', JobLabelModalCtrl)
		.controller('JobCompleteModalCtrl', JobCompleteModalCtrl)
		.controller('JobDailyLimitErrorModalCtrl', JobDailyLimitErrorModalCtrl)
        .controller('JobPhotoModalCtrl', JobPhotoModalCtrl);

    /** @ngInject */
    function JobMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.statusList = [
			{id: 0, name: 'PENDING', label: 'PENDING'},
			{id: 1, name: 'CONFIRMED', label: 'CONFIRMED'},
			{id: 2, name: 'IN PROGRESS', label: 'IN_PROGRESS'},
			{id: 3, name: 'COMPLETED', label: 'COMPLETED'},
			{id: 4, name: 'COMPLETED (VARIANCE)', label: 'COMPLETED_VARIANCE'},
			{id: 5, name: 'CANCELLED', label: 'CANCELLED'}
		];
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.data = [];
		vm.selectedJobs = [];
		vm.isLoading = false;
		vm.showCjsPanel = false;
        vm.showUpdatePanel = false;
        vm.selectedProductionJobs = [];
		vm.isRmsLite = Auth.isLiteMode();
		vm.isRmsStarter = Auth.isStarterMode();

		vm.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.jobNo,
				branchName: predicate.branchName,
				productName: predicate.productName,
				executedBy: predicate.actionBy,
				createdBy: predicate.createdBy,
				status: predicate.status,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('jobs/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			return tableState;
		};

		vm.resetSearch = function()
		{
		}

		/* ************************************************************* */

        vm.showBulkUpdatePanel = function () {
            vm.showUpdatePanel = true;
        }

        vm.closeBulkUpdatePanel = function () {
            vm.selectedProductionJobs = [];
            vm.showUpdatePanel = false;
        }

        vm.selectAllJobs = function () {
            vm.selectedProductionJobs = [];
            vm.data.forEach(function (d) {
                vm.selectedProductionJobs.push(d.id);
            });
        }

        vm.deselectAllJobs = function () {
            vm.selectedProductionJobs = [];
        }

        vm.bulkUpdateConfimed = function () {

            // var resp = confirm('Note:\nOnly Production Jobs with [NEW] status will be updated.\n\nProceed to bulk update status to [CONFIRMED]?');
            // if (!resp) return;

            if (vm.selectedProductionJobs.length <= 0) {
                alert('You must select at least one Production Job to proceed.');
                return;
            }

            HttpSvc.post("jobs/bulkupdatestatus/confirmed", vm.selectedProductionJobs, Auth.getTokenId())
                .then(function (result) {
                    toastr.success('Updated: <b>' + result.totalUpdatedCount + '</b>&nbsp;&nbsp;&nbsp;Skipped: <b>' +
                        result.totalSkippedCount + '</b>', 'Bulk Status Update Successful');
                    vm.closeBulkUpdatePanel();
                    $state.reload();
                }, function (error) {
                    toastr.error(error, 'Bulk Status Update Failed');
                    return null;
                });
        }

        /* ******************************************************************* */


		vm.showLabelModal = function (item) {

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'labelModal.html',
				controller: 'JobLabelModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							jobId: item.id,
							jobNo: item.jobNo,
							productType: item.productType,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

		vm.showGenerateCJSPanel = function() {
			vm.showCjsPanel = true;
		}

		vm.closeGenerateCJSPanel = function() {
			vm.selectedJobs = [];
			vm.showCjsPanel = false;
		}

        vm.selectAllCjs = function() {
			vm.selectedJobs = [];
			vm.data.forEach( function(d) {
				vm.selectedJobs.push(d.id);
			});
		}

		vm.deselectAllCjs = function() {
			vm.selectedJobs = [];
		}

		/* ************************************************************* */

		vm.showPrintScheduleDialog = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'printModal.html',
				controller: 'JobPrintModalCtrl',
				controllerAs: '$mdl',
				size: 'sm',
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

		/* ************************************************************* */

		vm.printJobSheet = function(jobId, jobNo) {

			var filename = "JOBSHEET_" + jobNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('jobs/print/' + jobId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate Job Sheet. ' + error, '');
							return null;
						});
		}

		vm.printJobTrace = function(jobId, jobNo) {

			var filename = "JOBTRACE_" + jobNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('jobs/print/trace/' + jobId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate Job Traceability Report. ' + error, '');
							return null;
						});
		}

		vm.printCJS = function() {

			if(vm.selectedJobs.length <= 0) {
				alert('You must select at least one Job to proceed.');
				return;
			}

			var filename = "CONSOLIDATED_JOBSHEET_SUMMARY.pdf";

			HttpSvc.postPdfObject('jobs/print/cjs', vm.selectedJobs, Auth.getTokenId(), filename)
				.then(
						function() {
							vm.selectedJobs = [];
							vm.showCjsPanel = false;
						},
						function(error) {
							// Failed
							toastr.error('Failed to generate Consolidated Job Sheet Summary. ' + error, '');
							return null;
						});

		}
	};

	/** @ngInject */
    function JobCreateCtrl($scope, $state, $filter, $uibModal, Auth, HttpSvc, UtilSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.statusList = [
			{id: 0, name: 'PENDING'},
			{id: 1, name: 'CONFIRMED'},
		];
		vm.selectedStatus = vm.statusList[0];
		vm.originalStatus = 0;
		vm.mode = 1;
		vm.recipe = {};
		vm.job = {};
		vm.jobDefaultDate = null;
		vm.skipCheckDailyLimit = false;
		vm.branchList = [];
		vm.productList = [];
		vm.usergroups = [];
		vm.lockButtons = false;
		vm.isProductRecipeOk = false;
		vm.isSemiFgRecipeOk = false;
		vm.hasSemiFgAccess = Auth.hasCompanyFeature('maintenance.semifgs');
		vm.activeTab = 0; //vm.hasSemiFgAccess ? 1 : 0;
		vm.branchId = Auth.getBranchId();

		/* ************************************************************** */

		// Set Default Job Date
		vm.setDefault = function() {
			vm.job.jobDate = $filter('date')(new Date(), 'yyyy-MM-dd hh:mma');
			vm.job.neededDate = vm.job.jobDate;
			vm.job.branchId = Auth.getBranchId();
			vm.job.productId = "";
			vm.job.quantity = 1;
			vm.job.estimatedProductionQuantity = 1;
			vm.job.status = 0;
			vm.lockButtons = false;
			vm.isProductRecipeOk = false;
			vm.isSemiFgRecipeOk = false;
			vm.skipCheckDailyLimit = false;

			vm.loadBranchList();
		}

		// Load Product List
		vm.loadProducts = function(searchString) {
			vm.lockButtons = true;

			HttpSvc.get('products/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.productList = [];
					result.forEach(function(p) {
						vm.productList.push({ id: p.id, name: p.name });;
					});
					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}

		// Load Semi F.G. List
		vm.loadSemiFgList = function(searchString) {
			vm.lockButtons = true;

			HttpSvc.get('semifgs/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.semiFgList = [];
					result.forEach( function(i) {
						vm.semiFgList.push({ id: i.id, description: i.description });
					});
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Item list.', '');
					return null;
				});
		};

		// Load Branch List
		vm.loadBranchList = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;

					vm.branchList.forEach(function(b) {
						if(b.id==vm.branchId)
						{
							vm.selectedBranch = b;
						}
					});
					vm.loadUsergroups();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve branch list.', '');
					$state.go('jobs.joblist.list');
			});
		}

		// Load Usergroup List
		vm.loadUsergroups = function() {
			HttpSvc.get('usergroups/list/production', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function(u){
						if(u.isSuperAdmin) {
							if(Auth.isSuperAdmin()){
								vm.usergroups.push({ id: u.id, name: u.name });
							}
						} else {
							vm.usergroups.push({ id: u.id, name: u.name });
						}
					});
				}, function() {
					vm.usergroups = [];
				});
		};

		// Load Product Recipe
		vm.loadProductRecipe = function(productId) {
			HttpSvc.get('products/recipe/' + productId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.recipe = result;
					vm.isProductRecipeOk = true;
					vm.job.unitOfMeasurementId = vm.recipe.uomId;
                    vm.job.uomName = vm.recipe.uomName;

                    if (vm.job.quantity) {
                        vm.job.estimatedProductionQuantity = (vm.job.quantity * vm.recipe.actualQuantity);
						
                    }
				}, function(error) {
					vm.isProductRecipeOk = false;
					toastr.error(error, 'Failed');
				});
		}

		// Load Semi FG Recipe
		vm.loadSemiFgRecipe = function (semiFgId) {
			HttpSvc.get('semifgs/recipe/' + semiFgId, {}, Auth.getTokenId(), false)
				.then(function (result) {
					vm.recipe = result;
					vm.isSemiFgRecipeOk = true;
					vm.job.unitOfMeasurementId = vm.recipe.uomId;
					vm.job.uomName = vm.recipe.uomName;

					if (vm.job.quantity) {
						vm.job.estimatedProductionQuantity = vm.job.quantity * vm.recipe.actualQuantity;
				}
				}, function(error) {
					vm.isSemiFgRecipeOk = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ************************************************************** */

        $scope.$watch('vm.job.quantity', function (newQuantity) {
            if (vm.recipe.actualQuantity && newQuantity) {
				vm.job.estimatedProductionQuantity = newQuantity * vm.recipe.actualQuantity;
				vm.job.estimatedProductionQuantity = Math.round(vm.job.estimatedProductionQuantity * 100) / 100;
            }
        });

		/* ************************************************************** */

		// Select Job Status
		vm.selectedStatusChanged = function() {
			vm.job.status = vm.selectedStatus.id;
		};

		vm.selectedBranchChanged = function() {
			vm.job.branchId = vm.selectedBranch.id;
		};

		// Select Product
		vm.selectedProductChanged = function() {
			vm.selectedSemiFg = null;
			vm.job.semiFinishedProductId=null;
			vm.job.productId = vm.selectedProduct.id;
			vm.loadProductRecipe(vm.selectedProduct.id);
		};

		// Select Semi Finished Goods
		vm.selectedSemiFgChanged = function() {
			vm.job.productId=null;
			vm.selectedProduct = null;
			vm.job.semiFinishedProductId = vm.selectedSemiFg.id;
			vm.loadSemiFgRecipe(vm.selectedSemiFg.id);
		};

		/* ************************************************************** */

		vm.clearProductSelection = function(){
			vm.job.productId=null;
			vm.selectedProduct=null;
			vm.isProductRecipeOk = false;
		}

		vm.clearSemiFgSelection = function(){
			vm.job.semiFinishedProductId=null;
			vm.selectedSemiFg=null;
			vm.isSemiFgRecipeOk = false;
		}

		/* ************************************************************** */

		// Form Submission
		vm.submit = function() {

			if(vm.dataForm.$invalid) {
				var errMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error('Please fill all Required Fields. ' + errMsg, 'Incomplete Fields');
			} else {
				if(vm.job.productId!=null && vm.job.productId!='' && !vm.isProductRecipeOk) {
					toastr.error('There is no recipe associated with the selected Product.', 'Incomplete Fields');
					return;
				}
				if(vm.job.semiFinishedProductId!=null && vm.job.semiFinishedProductId!='' && !vm.isSemiFgRecipeOk) {
					toastr.error('There is no recipe associated with the selected Product.', 'Incomplete Fields');
					return;
				}
				vm.lockButtons = true;

				vm.job.userGroupId = vm.selectedUserGroup.id;
				vm.job.estimatedProductionQuantity = vm.job.quantity * (vm.recipe.actualQuantity || vm.recipe.productionQuantity);

				HttpSvc.post('jobs' + (vm.skipCheckDailyLimit ? '/1' : ''), vm.job, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkResult = function (result) {
			if (result.status === 'error') {
				vm.messageList = result;
				vm.lockButtons = false;
				vm.showDailyLimitErrorModal();
			} 
			else {
				vm.skipCheckDailyLimit = false;
				toastr.success('Job has been created successfully.', Auth.translate('SUCCESS'));
				$state.go('jobs.joblist.update', {'id': result.id });;
			}
		}

		vm.showDailyLimitErrorModal = function () {
		var date = moment(vm.job.jobDate, 'YYYY-MM-DD hh:mmA');
		var formattedDate = date.format('YYYY-MM-DDTHH:mm:ss');
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'dailyLimitErrorModal.html',
				controller: 'JobDailyLimitErrorModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							date: formattedDate,
							messageList: vm.messageList,
						}
					}
				}
			});

			modalInstance
						.result
						.then(function (data) {
							vm.skipCheckDailyLimit = true;
					vm.submit();
				}, function () {
				vm.lockButtons = false;
				});
			};

		// Call Actions
		vm.setDefault();
	}

	/** @ngInject */
    function JobUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;
		vm.statusList = [
			{id: 0, name: 'PENDING', label: 'PENDING'},
			{id: 1, name: 'CONFIRMED', label: 'CONFIRMED'},
			{id: 2, name: 'IN PROGRESS', label: 'IN_PROGRESS'},
			{id: 3, name: 'COMPLETED', label: 'COMPLETED'},
			{id: 4, name: 'COMPLETED (VARIANCE)', label: 'COMPLETED_VARIANCE'},
			{id: 5, name: 'CANCELLED', label: 'CANCELLED'}
		];

		vm.originalStatus = 0;
		vm.mode = 2;
		vm.recipe = {};
		vm.job = {};
		vm.skipCheckDailyLimit = false;
		vm.branchList = [];
		vm.productList = [];
		vm.semiFgList = [];
		vm.usergroups = [];
		vm.lockButtons = false;
		vm.isProductRecipeOk = false;
		vm.isSemiFgRecipeOk = false;
		vm.isRmsLite = Auth.isLiteMode();
		vm.isRmsStarter = Auth.isStarterMode();
		vm.hasSemiFgAccess = Auth.hasCompanyFeature('maintenance.semifgs');
		vm.activeTab = 0; //vm.hasSemiFgAccess ? 1 : 0;

		/* ************************************************************** */

		// Load Product List
		vm.loadProducts = function(searchString) {
			vm.lockButtons = true;

			HttpSvc.get('products/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.productList = [];
					result.forEach(function(p) {
						vm.productList.push({ id: p.id, name: p.name });
					});
					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}

		// Load Semi F.G. List
		vm.loadSemiFgList = function(searchString) {
			vm.lockButtons = true;

			HttpSvc.get('semifgs/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.semiFgList = [];
					result.forEach( function(i) {
						vm.semiFgList.push({ id: i.id, description: i.description });
					});
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Item list.', '');
					return null;
				});
		};

		// Load Branch List
		vm.loadBranchList = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadUsergroups();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve branch list.', '');
					$state.go('jobs.joblist.list');
			});
		}

		// Load Usergroup List
		vm.loadUsergroups = function() {
			vm.lockButtons = true;

			HttpSvc.get('usergroups/list/production', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function(u){
						if(u.isSuperAdmin) {
							if(Auth.isSuperAdmin()){
								vm.usergroups.push({ id: u.id, name: u.name });
							}
						} else {
							vm.usergroups.push({ id: u.id, name: u.name });
						}
					});

					vm.loadJob();
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve UserGroup list.', '');
					$state.go('jobs.joblist');
				});
		};

		// Load Job
		vm.loadJob = function() {
			vm.lockButtons = true;

			var params = { id: $stateParams.id };
			HttpSvc.get('jobs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.job = result;
					vm.job.jobDate = $filter('date')(vm.job.jobDate, 'yyyy-MM-dd hh:mma');
					vm.job.neededDate = $filter('date')(vm.job.neededDate, 'yyyy-MM-dd');
					vm.originalStatus = vm.job.status;

					vm.statusList.forEach(function(js) {
						if(js.id==vm.job.status){
							vm.selectedStatus = js;
						}
					});
					vm.usergroups.forEach(function(p) {
						if(p.id==vm.job.userGroupId){
							vm.selectedUserGroup = p;
						}
					});
					vm.branchList.forEach(function(b) {
						if(b.id==vm.job.branchId){
							vm.selectedBranch = b;
						}
					});

					if(vm.originalStatus==0){
						vm.statusList.splice(2);
						vm.statusList.splice(2);
						vm.statusList.splice(2);
					}

					if(vm.job.productId!='' && vm.job.productId!=null) {
						vm.selectedProduct = { id: vm.job.productId, name: vm.job.productName };
						vm.loadProductRecipe(vm.selectedProduct.id);
						vm.activeTab = 0;
					}

					if(vm.hasSemiFgAccess){
						if(vm.job.semiFinishedProductId!='' && vm.job.semiFinishedProductId!=null) {
							vm.selectedSemiFg = { id: vm.job.semiFinishedProductId, description: vm.job.semiFgName };
							vm.loadSemiFgRecipe(vm.selectedSemiFg.id);
							vm.activeTab = 1;
						}
					}

                    if (vm.job.quantity) {
                        vm.job.estimatedProductionQuantity = vm.job.quantity * vm.job.estimatedProductionQuantityPerBatch;
                    }

					vm.lockButtons = false;
				}, function() {
					toastr.error('Failed to load selected Job.', Auth.translate('ERROR'))
					$state.go('jobs.joblist');
					return;
				});
		};

		// Load Product Recipe
		vm.loadProductRecipe = function(productId, isReselect) {
			HttpSvc.get('products/recipe/' + productId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.recipe = result;
					vm.isProductRecipeOk = true;
					vm.job.unitOfMeasurementId = vm.recipe.uomId;
                    vm.job.uomName = vm.recipe.uomName;

                    if (vm.job.quantity) {
                        vm.job.estimatedProductionQuantity = vm.job.quantity * (isReselect ? vm.recipe.actualQuantity : vm.job.estimatedProductionQuantityPerBatch);
					}
					
					if (isReselect) {
                        vm.job.estimatedProductionQuantityPerBatch = vm.recipe.actualQuantity;
					}

				}, function(error) {
					vm.isProductRecipeOk = false;
					toastr.error(error, 'Failed');
				});
		}

		// Load Semi FG Recipe
		vm.loadSemiFgRecipe = function(semiFgId, isReselect) {
			HttpSvc.get('semifgs/recipe/' + semiFgId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.recipe = result;
					vm.isSemiFgRecipeOk = true;
					vm.job.unitOfMeasurementId = vm.recipe.uomId;
                    vm.job.uomName = vm.recipe.uomName;

                    if (vm.job.quantity) {
                        vm.job.estimatedProductionQuantity = vm.job.quantity * (isReselect ? vm.recipe.actualQuantity : vm.job.estimatedProductionQuantityPerBatch);
					}

					if (isReselect) {
                        vm.job.estimatedProductionQuantityPerBatch = vm.recipe.actualQuantity;
					}
				}, function(error) {
					vm.isSemiFgRecipeOk = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ************************************************************** */

        $scope.$watch('vm.job.quantity', function (newQuantity) {
            if (vm.recipe.actualQuantity && newQuantity) {
				vm.job.estimatedProductionQuantity = newQuantity * vm.job.estimatedProductionQuantityPerBatch;
				vm.job.estimatedProductionQuantity = Math.round(vm.job.estimatedProductionQuantity * 100) / 100;
            }
        });

		/* ************************************************************** */

		// Select Job Status
		vm.selectedStatusChanged = function() {
			vm.job.status = vm.selectedStatus.id;
		};

		vm.selectedBranchChanged = function() {
			vm.job.branchId = vm.selectedBranch.id;
		};

		// Select Product
		vm.selectedProductChanged = function() {
			vm.selectedSemiFg = null;
			vm.job.semiFinishedProductId=null;
			vm.job.productId = vm.selectedProduct.id;
			vm.loadProductRecipe(vm.selectedProduct.id, true);
		};

		// Select Semi Finished Goods
		vm.selectedSemiFgChanged = function() {
			vm.job.productId=null;
			vm.selectedProduct = null;
			vm.job.semiFinishedProductId = vm.selectedSemiFg.id;
			vm.loadSemiFgRecipe(vm.selectedSemiFg.id, true);
		};

		/* ************************************************************** */

		vm.clearProductSelection = function(){
			vm.job.productId=null;
			vm.selectedProduct=null;
			vm.isProductRecipeOk = false;
		}

		vm.clearSemiFgSelection = function(){
			vm.job.semiFinishedProductId=null;
			vm.selectedSemiFg=null;
			vm.isSemiFgRecipeOk = false;
		}

		/* ************************************************************** */

		// Print Jobsheet
		vm.printJobSheet = function(jobId, jobNo) {

			var filename = "JOBSHEET_" + jobNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('jobs/print/' + jobId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate Job Sheet. ' + error, '');
							return null;
						});
		}

		vm.printJobTrace = function(jobId, jobNo) {

			var filename = "JOBTRACE_" + jobNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('jobs/print/trace/' + jobId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to generate Job Traceability Report. ' + error, '');
							return null;
						});
		}

		/* ************************************************************** */

		vm.showCompleteJobModal = function () {
			// vm.job.packingQty = vm.job.quantity * vm.recipe.productionQuantity;
			vm.job.packingQty = vm.job.quantity * vm.recipe.actualQuantity;
			vm.job.packingUom = vm.recipe.uomName;

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'confirmModal.html',
				controller: 'JobDashboardCompleteModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							object: vm.job
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					$state.reload();
				}, function () {
				});
		};

		// Submit Cancelled Job
		vm.cancelJob = function() {
			vm.job.status = 5;

			HttpSvc.put('jobs/cancel/' + $stateParams.id, vm.job, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Job Status has been updated to CANCELLED.', Auth.translate('SUCCESS'));
						$state.go('jobs.joblist');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
		}

		/* ************************************************************** */

		vm.viewPhotos = function() {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'photoModal.html',
				controller: 'JobPhotoModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							photoAttachment: vm.job.photoAttachment,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		}

		/* ************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;
				vm.job.userGroupId = vm.selectedUserGroup.id;

				HttpSvc.put('jobs/' + $stateParams.id + (vm.skipCheckDailyLimit ? '/1' : ''), vm.job, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkResult = function (result) {
			if (result.status === 'error') {
				vm.messageList = result;
				vm.lockButtons = false;
				vm.showDailyLimitErrorModal();
			} 
			else {
				vm.skipCheckDailyLimit = false;
				toastr.success('Job has been updated successfully.', Auth.translate('SUCCESS'));
				$state.reload();
			}
		}

		vm.showDailyLimitErrorModal = function () {
		var date = moment(vm.job.jobDate, 'YYYY-MM-DD hh:mmA');
		var formattedDate = date.format('YYYY-MM-DDTHH:mm:ss');
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'dailyLimitErrorModal.html',
				controller: 'JobDailyLimitErrorModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							date: formattedDate,
							messageList: vm.messageList,
						}
					}
				}
			});

			modalInstance
						.result
						.then(function (data) {
					vm.skipCheckDailyLimit = true;
					vm.submit();
				}, function () {
				vm.lockButtons = false;
				});
			};


		// Call Actions
		vm.loadBranchList();
		
	}

	// Print Dialog
	function JobPrintModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;

		var dt = new Date();
		dt.setUTCDate(dt.getUTCDate() + 4 - (dt.getUTCDay()||7));
		var yearStart = new Date(Date.UTC(dt.getUTCFullYear(),0,1));
		var weekNo = Math.ceil(( ( (dt - yearStart) / 86400000) + 1)/7);

		$mdl.lockButton = false;
		$mdl.year = dt.getFullYear();
		$mdl.weekNo = weekNo;

		/* *************************************************** */

		$mdl.addWeek = function(day) {
			$mdl.weekNo += day;

			if($mdl.weekNo < 1) {
				$mdl.weekNo = 1;
			} else if($mdl.weekNo > 53) {
				$mdl.weekNo = 53;
			}
		}

		/* *************************************************** */

		$mdl.printSchedule = function() {

			var filename = "SCHEDULE_YR" + $mdl.year + "_WEEK_#" + $mdl.weekNo + ".pdf";

			HttpSvc.getPdfObject('jobs/print/schedule/' + $mdl.year + '/' + $mdl.weekNo, Auth.getTokenId(), filename)
				.then(
					function(result) {
						$uibModalInstance.close();
					},
					function(error) {
						// Failed
						toastr.error('Failed to generate Production Schedule. ' + error, '');
						return null;
					});
		}

		/* *************************************************** */

		$mdl.confirmModal = function() {

			if($mdl.printForm.$valid) {
				$mdl.lockButton = true;
				$mdl.printSchedule();
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}

	/** @ngInject */
	function JobLabelModalCtrl($uibModalInstance, $filter, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.item = {};
		$mdl.item.id = item.jobId;
		$mdl.item.jobNo = item.jobNo;
		$mdl.item.productType = item.productType;

		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfRecordFiltered = 0;
		$mdl.numOfRecordDisplayed = 0;
		$mdl.startIndex = 0;
		$mdl.endIndex = 0;
		$mdl.labelDataFull = [];
		$mdl.labelData = [];
		$mdl.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.labelDataFull, tableState.search.predicateObject) : $mdl.labelDataFull;
			$mdl.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			$mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
			$mdl.labelData = result;

			tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		$mdl.retrieveData = function(tableState) {

			var params = {}
			var pagination = tableState.pagination;
			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

			if($mdl.labelDataFull.length <= 0) {
				$mdl.isLoading = true;

				var apiUrl = "";
				if($mdl.item.productType=="FG")
				{
					apiUrl = "jobs/fg/" + $mdl.item.id + "/labels";
				}
				else
				{
					apiUrl = "jobs/sfg/" + $mdl.item.id + "/labels";
				}

				HttpSvc.get(apiUrl, {}, Auth.getTokenId(), true)
					.then(function(result) {
						$mdl.numOfRecord = result.length;
						$mdl.labelDataFull = result;
						refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
						$mdl.isLoading = false;
					}, function() {
						$mdl.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
			}
		};

		// ********************************************************

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	// Job Complete Modal Controller
	function JobCompleteModalCtrl($uibModalInstance, $filter, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.item = item.object;
		$mdl.item.actualProductionQuantity = null;
		$mdl.job = {};
		$mdl.isLoading = false;
		$mdl.isRmsLite = Auth.isLiteMode();

		$mdl.loadJob = function() {
			$mdl.isLoading = true;

			var params = { id: $mdl.item.id };
			HttpSvc.get('jobs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.job = result;
					$mdl.job.jobDate = $filter('date')($mdl.job.jobDate, 'yyyy-MM-dd hh:mma');
					$mdl.job.neededDate = $filter('date')($mdl.job.jobDate, 'yyyy-MM-dd');
					$mdl.isLoading = false;
				}, function() {
					toastr.error('Failed to load selected Job.', Auth.translate('ERROR'))
					$uibModalInstance.dismiss('cancel');
					$mdl.isLoading = false;
					return;
				});
		};

		$mdl.confirmModal = function() {
			$mdl.isLoading = false;

			if($mdl.confirmForm.$invalid){
				$mdl.isLoading = false;
			} else {
				$mdl.isLoading = true;

				$mdl.job.failureReason = $mdl.item.failureReason;
				$mdl.job.actualProductionQuantity = $mdl.item.actualProductionQuantity;
				$mdl.job.actualDefectQuantity = $mdl.job.estimatedProductionQuantity - $mdl.job.actualProductionQuantity;

				if($mdl.job.actualDefectQuantity<0)
					$mdl.job.actualDefectQuantity = 0;

				if($mdl.job.actualDefectQuantity == 0) {
					$mdl.job.status = 3;
				} else if($mdl.job.actualDefectQuantity != 0) {
					$mdl.job.status = 4;
				}

				HttpSvc.put('jobs/' + $mdl.item.id, $mdl.job, Auth.getTokenId(), false)
					.then(function(result) {
						$mdl.isLoading = false;
						if($mdl.job.actualDefectQuantity == 0) {
							toastr.success('Job Status has been updated to <b>COMPLETED</b>.', Auth.translate('SUCCESS'));
						} else if($mdl.job.actualDefectQuantity != 0) {
							toastr.success('Job Status has been updated to <b>COMPLETED (VARIANCE)</b>.', Auth.translate('SUCCESS'));
						}
						$uibModalInstance.close($mdl.item);
					}, function(error) {
						$mdl.isLoading = false;
						toastr.error(error, 'Failed');
					});
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		$mdl.loadJob();
	};

	/** @ngInject */
	function JobPhotoModalCtrl($uibModalInstance, item, Auth, RmsApi, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.photoAttachment = item.photoAttachment;
		$mdl.photoArray = $mdl.photoAttachment.split(";");
		$mdl.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		$mdl.selectedPhoto = $mdl.rootUrl + $mdl.photoArray[0];

		/* *************************************************** */

		// Process Photos
		$mdl.selectPhoto = function(photo) {
			$mdl.selectedPhoto = $mdl.rootUrl + photo;
		}

		/* *************************************************** */

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	function JobDailyLimitErrorModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) { 
		var $mdl = this;
		$mdl.lockButtons = false;
		$mdl.messageList = item.messageList;
		$mdl.date = item.date;
		
		$mdl.confirmModal = function()
		{
      		$mdl.lockButtons = false;
			$uibModalInstance.close();
		};

		$mdl.cancelModal = function() {
			$mdl.lockButtons = false;
			$uibModalInstance.dismiss('cancel');
		};
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.label.items.controller', [])
        .controller('ItemLabelPrintCtrl', ItemLabelPrintCtrl)
        .controller('ItemLabelAdjustmentCtrl', ItemLabelAdjustmentCtrl)
        .controller('ItemLabelImportCtrl', ItemLabelImportCtrl)
        .controller('ItemLabelSelectGrnModalCtrl', ItemLabelSelectGrnModalCtrl)
        .controller('ItemLabelDownloadExcelModalCtrl', ItemLabelDownloadExcelModalCtrl);
	
	/** @ngInject */
    function ItemLabelPrintCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.isLoading = false;
		vm.grn = {};
		vm.label = {};
		vm.reprint = {};
		vm.labelvoid = {};
		vm.labelobal = {};

		vm.branches = [];
		vm.departments = [];
		vm.suppliers = [];
		vm.storages = [];
		vm.items = [];
		vm.uoms = [];
		vm.itemUoms = [];
		vm.pendingLabels = [];
		vm.selectedBranch = null;
		vm.selectedDepartment = null;
		vm.selectedSupplier = null;
		vm.selectedItem = null;
		vm.selectedStorage = null;
		vm.selectedUOM = null;

		vm.autoUpdateUom = Auth.getSetting_Grn_EnableAutoUpdateUom();
		vm.autoUpdateUomText = vm.autoUpdateUom ? "WILL" : "WILL NOT";
		
		// Init Data
		vm.initData = function() {
			vm.grnNo = "";
			vm.label = {
				grnNo: "",
			};
			vm.reprint = {
				grnNo: "",
				serialNo: "",
				numberOfLabel: 1
			};
			vm.labelvoid = {
				serialNoFrom: "",
				serialNoTo: ""
			};
			
			//vm.loadUomList();
			vm.loadBranchList();
		}
		
		/* ***************************************************************************** */
		
		vm.beautify = function(code, name, description) {
			var newText = "";
			if(code) {
				newText = "<span class='dd-code'>" + code.toUpperCase();
			}
			if(name) {
				newText = newText + "</span>&nbsp;&nbsp;" + name.toUpperCase();
			}
			if(description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";	
			}			
			return newText;
		}
		
		/* ***************************************************************************** */
				
		// Load UOM List
		vm.loadUomList = function() {
			HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.uoms = result;
					vm.loadSupplierList();
				}, function(error) {
					toastr.error(error, 'Failed to load UOM List');
				});				
		};
		
		// Load Raw Material's UOM List
		vm.loadItemUomList = function(itemId) {
			HttpSvc.get('items/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.itemUoms = result;
				}, function(error) {
					toastr.error(error, 'Failed to load UOM List');
				});				
		};
		
		// Load Supplier List
		vm.loadSupplierList = function() {
			HttpSvc.get('suppliers/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.suppliers = result;
					vm.loadBranchList();
				}, function(error) {
					toastr.error(error, 'Failed to load Supplier List');
				});				
		};
		
		// Load Branch List
		vm.loadBranchList = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
					vm.branches.forEach(function(b) {
						if(b.id==Auth.getBranchId()) 
						{
							vm.selectedBranch = b;
							vm.loadPendingLabelList();
						}
					});
					//vm.loadDepartments();
				}, function(error) {
					toastr.error(error, 'Failed to load Branch List');
				});				
		};
		
		// Load Departments
		vm.loadDepartments = function() {
			HttpSvc.get('departments/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.departments.push({ id: u.id, name: u.name });
					});		
					vm.loadStorages();
				}, function() {
					vm.departments = [];
				});
		};
		
		// Load Item Receiving Storages
		vm.loadStorages = function() {
			HttpSvc.get('storages/listbytypes/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storages = result;
				}, function(error) {
					toastr.error('Failed to load Storage list. ' + error, 'Failed');
				});
		}
		
		// Load Item List
		vm.loadItemList = function() {
			HttpSvc.get('items/list/supplier/' + vm.selectedSupplier.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.items = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Item list.', Auth.translate('ERROR'));
					return null;

				});
		};

		// Load Pending Label List
		vm.loadPendingLabelList = function() {
			vm.isLoading = true;

			HttpSvc.get('labels/list/item/pending/' + vm.selectedBranch.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.pendingLabels = result;
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Item list.', Auth.translate('ERROR'));
					return null;
				});
		};
	
		vm.promptGrnModal = function () {
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'GrnListModal.html',
				controller: 'ItemLabelSelectGrnModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
			});

			modalInstance
				.result
				.then(function (grnNo) {
					vm.label.grnNo = grnNo;
					vm.loadGrn();
				}, function () {
				});
		};	

		/* ***************************************************************************** */
		
		vm.selectedBranchChanged = function() {
			//vm.labelobal.branchId = vm.selectedBranch.id;
			if(vm.selectedBranch==null) 
			{
				vm.pendingLabels=[];
			}
			else
			{
				vm.loadPendingLabelList();
			}
		}
		
		vm.selectedDepartmentChanged = function() {
			vm.labelobal.departmentId = vm.selectedDepartment.id;
		}

		vm.selectedSupplierChanged = function() {
			vm.labelobal.supplierId = vm.selectedSupplier.id;
			vm.loadItemList();
		}

		vm.selectedItemChanged = function() {
			vm.labelobal.itemId = vm.selectedItem.id;
			vm.loadItemUomList(vm.labelobal.itemId);
		}

		vm.selectedStorageChanged = function() {
			vm.labelobal.storageId = vm.selectedStorage.id;
		}

		vm.selectedUOMChanged = function() {
			vm.adj.uomId1 = vm.selectedUOM.id;
		}
				
		/* ***************************************************************************** */
		
		// Reset Fields
		vm.resetFields = function() {
			vm.dataForm.$setPristine();
			vm.grn = {};
			vm.label = {};
			vm.reprint = {};
			vm.labelvoid = {};
			vm.labelobal = {};
			
			vm.branches = [];
			vm.departments = [];
			vm.suppliers = [];
			vm.storages = [];
			vm.items = [];
			vm.uoms = [];
			vm.itemUoms = [];
			vm.selectedBranch = null;
			vm.selectedDepartment = null;
			vm.selectedSupplier = null;
			vm.selectedItem = null;
			vm.selectedStorage = null;
			vm.selectedUOM = null;
			
			vm.initData();
			vm.isLoading = false;
		}	
					
		// Load GRN
		vm.loadGrn = function() {
			vm.dataForm.$setPristine();
			vm.isLoading = true;
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {	
				HttpSvc.post('inventory/items/label/loadgrn', vm.label, Auth.getTokenId(), false)
					.then(function(result) {
						vm.grn = result;
						toastr.success('GRN loaded.');
						vm.isLoading = false;
					}, function(error) {
						vm.isLoading = false;
						vm.grn = {};
						toastr.error(error, 'GRN failed to load.');
					});	
			}
		}
		
		vm.printOptionChanged = function(item) {
			var noOfLabel = item.noOfLabel;
			item.noOfLabel = item.quantity;
			item.quantity  = noOfLabel;
		}
		
		vm.itemUomChanged = function(item) {		
			item.uomId = item.selectedUom.uomId;
			item.uomName = item.selectedUom.uomName;			
			item.noOfLabel = item.selectedUom.noOfLabel;
			item.quantity  = item.selectedUom.quantity;
			
			if(item.selectedUom.labelPrintOption != item.labelPrintOption) {
				vm.printOptionChanged(item);
			}
		}		
		
		/* ***************************************************************************** */

		// Print Label
		vm.printLabel = function() {
			var hasLabel = false;
			vm.grn.itemList.forEach(function(i) {
				if(!i.isRejected) {
					hasLabel = true;
				}
			});

			if(!hasLabel){
				toastr.warning('The listed items could be rejected items', 'No item is valid for label printing.');
				return;
			}

			HttpSvc.post('inventory/items/label/create', vm.grn, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.info(result.message, 'Result');
					vm.resetFields();
				}, function(error) {
					toastr.error(error, 'Printing Failed');
					vm.isLoading = false;
				});
		}
		
		// Re-print Label
		vm.reprintLabel = function() {
			vm.dataForm.$setPristine();
			vm.isLoading = true;
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {				
				HttpSvc.post('inventory/items/label/reprint', vm.reprint, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Re-print instruction has been sent.', Auth.translate('SUCCESS'));
						vm.resetFields();
						
					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Re-print Failed');
					});
			}
		}
		
		// Void Label
		vm.voidLabel = function() {
			vm.dataForm.$setPristine();
			vm.isLoading = true;
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {	
				HttpSvc.post('inventory/items/label/void', vm.labelvoid, Auth.getTokenId(), true)
					.then(function(result) {
						var errMsg = "";
						result.forEach(function(m) {
							if(m.message=="OK") {
								toastr.success(result, Auth.translate('SUCCESS'));
								vm.resetFields();							
								return;
							} else {
								errMsg += "<b>" + m.serialNo + "</b> - " + m.message + "<br />";
							}
						});
						if(errMsg!=''){
							toastr.error(errMsg, Auth.translate('ERROR'));
						} else {							
							toastr.success('Label <b>' + vm.labelvoid.serialNo + '</b> has been voided.', 'Label Voided');
							vm.loadPendingLabelList();
						}
						vm.resetFields();
						
					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Void Failed');
					});
			}
		}
		
		// Purge All Labels
		vm.purgeLabels = function() {
			vm.dataForm.$setPristine();
			vm.isLoading = true;

			HttpSvc.post('labels/purge/item/pending/' + vm.selectedBranch.id, {}, Auth.getTokenId(), false)
				.then(function(result) {	
					toastr.success('All Labels have been purged successfully.', 'Purge Completed');				
					vm.resetFields();	
					vm.loadPendingLabelList();				
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Purge Failed');
				});
		}
		
		// Purge All Labels
		vm.purgeTestLabels = function() {
			vm.dataForm.$setPristine();
			vm.isLoading = true;

			HttpSvc.post('labels/purge/item/pending/testprint/' + vm.selectedBranch.id, {}, Auth.getTokenId(), false)
				.then(function(result) {	
					toastr.success('All Test Labels have been purged successfully.', 'Purge Completed');				
					vm.resetFields();	
					vm.loadPendingLabelList();				
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Purge Failed');
				});
		}
		
		// Create OBal Label
		vm.createOBalLabel = function() {
			vm.dataForm.$setPristine();
			vm.isLoading = true;
						
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {				
				HttpSvc.post('inventory/items/label/oldlabel', vm.labelobal, Auth.getTokenId(), false)
					.then(function(result) {
						vm.resetFields();
						
					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Void Failed');
					});
			}
		}
				
		/* ***************************************************************************** */

		vm.showDownloadExcelModal = function () {
			if(vm.selectedBranch==null)
			{
				toastr.error('Please select a Branch first.');
				return;
			}

			vm.product = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'downloadModal.html',
				controller: 'ItemLabelDownloadExcelModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							branchId: vm.selectedBranch.id,
							branchName: vm.selectedBranch.name,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.selectedBranchChanged();
				}, function () {
				});
		};	
				
		/* ***************************************************************************** */
		
		// Call Actions
		vm.initData();
	}

	/** @ngInject */
    function ItemLabelAdjustmentCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;

		vm.adj = {};
		vm.itemUoms = [];
		vm.labelInfo = null;
		vm.selectedUOM = null;
		vm.isLoading = false;
		
		// Init Data
		vm.initData = function() {
			vm.adj = {
				serialNo: "",
			};
		}
		
		/* ***************************************************************************** */
		
		// Load Raw Material's UOM List
		vm.loadItemUomList = function(itemId) {
			HttpSvc.get('items/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.itemUoms = result;
				}, function(error) {
					toastr.error(error, 'Failed to load UOM List');
				});				
		};
		
		/* ***************************************************************************** */
		
		vm.selectedUOMChanged = function() {
			vm.adj.uomId1 = vm.selectedUOM.id;
		}
				
		/* ***************************************************************************** */
		
		// Reset Fields
		vm.resetFields = function() {
			vm.dataForm.$setPristine();
			vm.adj = {};
			vm.itemUoms = [];
			vm.selectedUOM = null;
			vm.labelInfo = null;
			
			vm.initData();
			vm.isLoading = false;
		}
		
		/* ***************************************************************************** */

		// Load Label Info
		vm.loadLabelInfo = function() {
			var json = {
				serialNo: vm.adj.serialNo
			};
			HttpSvc.post('stockmgmts/mainlabelinfo', json, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.labelInfo = result;
					vm.loadItemUomList(vm.labelInfo.itemId);
				}, function() {
					// Failed
					toastr.error('Failed to retrieve the Label Information.', '');
					return null;
				});
		}
		
		// Adjust Label
		vm.adjustLabel = function() {	
			vm.dataForm.$setPristine();		
			vm.isLoading = true;
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {				
				HttpSvc.post('stockmgmts/labeladjustment', vm.adj, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Label adjustment is successful.', Auth.translate('SUCCESS'));
						vm.resetFields();
						
					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Label adjustment Failed');
					});
			}
		}
				
		/* ***************************************************************************** */
		
		// Call Actions
		vm.initData();
	}

	/** @ngInject */
	function ItemLabelImportCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;		
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;
		
		/* **************************************************** */
		
		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";
		/* **************************************************** */
		
		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		
		/* **************************************************** */
		
		vm.goBack = function() {
			$state.reload();
		}
		
		/* **************************************************** */
		
		vm.importResult = {};
		
		/* **************************************************** */
				
		vm.downloadTemplate = function(templateName) {
			
			var filename = templateName + ".xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject('inventory/items/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};		
		
		/* **************************************************** */
		
		vm.importData = function() {
			vm.isImporting = true;
			
			HttpSvc.post('inventory/items/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
					//vm.lockButtons = false;
					//vm.isImportComplete = true;
					
					//vm.importResult = result;
					
					//toastr.success("Data imported successfully!");
					//$state.go('maintenance.items.list');
				}, function(error) {
					//vm.lockButtons = false;
					//vm.isImportFailed = true;
					
					//toastr.error("Failed to import data! " + error);
				});
		}
		
		/* **************************************************** */
		
		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}
		
		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;			
		}
		
		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];
			
			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}
		
		// Upload File
		vm.uploadFile = function() {	
			vm.resetFileUploadParams();
			
			vm.lockButtons = true;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;
								
			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;
			
			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();	
				vm.uploadMedia(vm.mediaToUpload);
			}	
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {
						
						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);
						
					}, function(error) {
						toastr.error(error, 'Failed');
						
						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {					
					vm.isUploaded = true;
					
					// Call Process Excel API 
					HttpSvc.post('inventory/items/import/' + resp.data, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;
							
							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			}  else if(vm.serverMode==1) { // Azure Server
							
				/* Initialize variables */
				/* ************************************* */	
				handleFileSelect(_fileToUpload);
				/* ************************************* */	
				
				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							} 
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,				
			}).then(function(response) {	
				vm.isUploaded = true;
				
				// Call Process Excel API 
				HttpSvc.post('inventory/items/import/' + excelFilename, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;
						
						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }		
	};
	
	/** @ngInject */
	function ItemLabelSelectGrnModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
		var $mdl = this;
		
		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfPages = 0;
		$mdl.startIndex = 0; 
		$mdl.endIndex = 0;
		$mdl.dataFull = [];
		$mdl.data = [];
		$mdl.isLoading = false;

		$mdl.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}
			
			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.receivingNo,
				createdDate: predicate.createdDate,
				supplierName: predicate.supplierName,
				supplierDocNo: predicate.supplierDoNo,
				purchaseOrderNo: predicate.purchaseOrderNo,
				branchName: predicate.branchName,
				storageName: predicate.storageName,
				createdBy: predicate.createdBy,
				isLabelPrinted: predicate.isLabelPrinted,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: $mdl.pageSize,
				pageNumber: Math.ceil(($mdl.startIndex + 1) / $mdl.pageSize)
			};

			return params;
		}

		$mdl.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.
			
			$mdl.isLoading = true;

			var params = $mdl.getApiParams(tableState);

			HttpSvc.post('receivings/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					$mdl.isLoading = false;		
					$mdl.data = result.data;
					$mdl.numOfRecord = result.numberOfRecords;	
					$mdl.numOfPages = result.numberOfPages;	
					refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = $mdl.numOfPages;		
			return tableState;
		};

		$mdl.resetSearch = function() 
		{
		}
		
		// ********************************************************		
		
		$mdl.selectGrn = function(grnNo) {
			$uibModalInstance.close(grnNo);
		}

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};
	
	/** @ngInject */
	function ItemLabelDownloadExcelModalCtrl($uibModalInstance, $filter, $sce, item, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
		var $mdl = this;
		
		$mdl.batchList = [];
		$mdl.isLoading = false;
		$mdl.selectedBatchId = null;
		$mdl.branchId = item.branchId;
		$mdl.branchName = item.branchName;
		
		// ********************************************************	
			
		$mdl.loadData = function() {
			$mdl.isLoading = true;
			
			HttpSvc.get('labels/list/' + $mdl.branchId + '/batchid/rm', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.batchList = result;
					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};		

		// ********************************************************
		
		$mdl.selectedBatchIdChanged = function() {
		}

		// ********************************************************
		
		$mdl.downloadExcel = function() {
			$mdl.isLoading = true;
			
			HttpSvc.get("labels/newbatchid/" + $mdl.branchId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.selectedBatchId = result.batchId;
					$mdl.downloadExcelPast();
					$mdl.loadData();
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate Excel');
					return null;
				});
		}
		
		$mdl.downloadExcelPast = function() {
			if($mdl.selectedBatchId == null)
			{
				toastr.warning("Please select a Batch Number to download.");
				return;
			}
			
			$mdl.isLoading = true;

			var filename = "RMS_RawMat_Label_" + $mdl.selectedBatchId + ".xlsx";

			HttpSvc.getExcelObject("labels/exportitemlabel/" + $mdl.branchId + "/" + $mdl.selectedBatchId, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isLoading = false;
					//$uibModalInstance.dismiss('cancel');
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate Excel');
					return null;
				});
		}
		
		// ********************************************************	
		
		$mdl.downloadPdf = function() {
			$mdl.isLoading = true;
			
			HttpSvc.get("labels/newbatchid/" + $mdl.branchId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.selectedBatchId = result.batchId;
					$mdl.downloadPdfPast();
					$mdl.loadData();
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate PDF');
					return null;
				});
		}
		
		$mdl.downloadPdfPast = function() {
			if($mdl.selectedBatchId == null)
			{
				toastr.warning("Please select a Batch Number to download.");
				return;
			}
			
			$mdl.isLoading = true;

			var filename = "RMS_RawMat_Label_" + $mdl.selectedBatchId + ".pdf";

			HttpSvc.getPdfObject("labels/exportitemlabel/pdf/" + $mdl.branchId + "/" + $mdl.selectedBatchId, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isLoading = false;
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate PDF');
					return null;
				});
		}

		// ********************************************************	

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// ********************************************************	

		$mdl.loadData();
	};
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.label.semifgs.controller', [])
        .controller('SemiFGLabelPrintCtrl', SemiFGLabelPrintCtrl)
        .controller('SemiFGLabelAdjustmentCtrl', SemiFGLabelAdjustmentCtrl)
        .controller('SemiFGLabelImportCtrl', SemiFGLabelImportCtrl)
        .controller('SemiFGLabelSelectJobModalCtrl', SemiFGLabelSelectJobModalCtrl)
        .controller('SemiFGLabelDownloadExcelModalCtrl', SemiFGLabelDownloadExcelModalCtrl);

	/** @ngInject */
    function SemiFGLabelPrintCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.submitted = false;
		vm.label = {};
		vm.job = {};
		vm.uomList1 = [];
		vm.uomList2 = [];
		vm.productList = [];
		vm.selectedUom1 = null;
		vm.selectedUom2 = null;
		vm.selectedProduct = null;
		vm.selectedBranch = null;
		vm.isLoading = false;
		vm.isJobValid = false;
		vm.blobUrl = vm.serverMode==1 ? "../" : "";

		// Init Data
		vm.initData = function() {
			vm.isLoading = false;
			vm.isJobValid = false;

			vm.serialNo = "";
			vm.numberOfLabel = 1;

			vm.label = {
				jobId: '',
				jobNo: '',
				jobQty: 0,
				jobUom: '',
				servingSize: 1,
				unitOfMeasurementId: '',
				servingUom: '',
				inventoryQty: 1,
				inventoryUom: '',
				inventoryUnitOfMeasurementId: '',
				printOption: 1,
				numberofLabel: 1,
				numberofLabel_UomId: '',
			};

			vm.selectedUom1 = null;
			vm.selectedUom2 = null;
			vm.selectedProduct = null;

			vm.loadBranchList();

            var jobNo = $stateParams.jobNo || null;

            if (jobNo) {
                vm.label.jobNo = jobNo.toUpperCase();
                vm.loadJob();
            }
		}

		// Reset Fields
		vm.resetFields = function() {
			vm.serialNo = "";
			vm.label.servingSize = "";
			vm.label.inventoryQty = "";
			vm.label.mfgDate = null;
		}

		// Load Semi Finished Goods List
		vm.loadProductList = function() {
			HttpSvc.get('semifgs/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.productList = result;

					vm.productList.forEach(function(p) {
						if(p.id==vm.job.semiFinishedProductId) {
							vm.selectedUom1 = null;
							vm.selectedUom2 = null;
							vm.label.unitOfMeasurementId = null;
							vm.label.inventoryUnitOfMeasurementId = null;

							vm.selectedProduct = p;
							vm.label.productId = p.id;
							vm.loadUomList1(p.id);
							return;
						}
					});
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Semi Finished Goods list.', '');
					return null;
				});
		}

		// Load Branch List
		vm.loadBranchList = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
					vm.branches.forEach(function(b) {
						if(b.id==Auth.getBranchId())
						{
							vm.selectedBranch = b;
							vm.loadPendingLabelList();
						}
					});
					//vm.loadDepartments();
				}, function(error) {
					toastr.error(error, 'Failed to load Branch List');
				});
		};

		// Load UOM List
		vm.loadUomList1 = function(productId) {
			HttpSvc.get('semifgs/uoms/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.uomList1 = result;
					vm.uomList2 = result;

					vm.uomList1.forEach(function(u) {
						if(u.id==vm.job.servingUomId) {
							vm.selectedUom1 = u;
							vm.label.servingUom = u.name;
							vm.label.unitOfMeasurementId = u.id;
						}
					})

					vm.uomList2.forEach(function(u) {
						if(u.id==vm.job.inventoryUomId) {
							vm.selectedUom2 = u;
							vm.label.inventoryUom = u.name;
							vm.label.inventoryUnitOfMeasurementId = u.id;
							vm.label.numberofLabel_UomId = u.id;
						}
					})

					//vm.loadUomList2(productId);
				}, function() {
					// Failed
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		}

		vm.loadUomList2 = function(productId) {
			HttpSvc.get('semifgs/uoms/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.uomList2 = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		}

		// Load Pending Label List
		vm.loadPendingLabelList = function() {
			vm.isLoading = true;

			HttpSvc.get('labels/list/semifg/pending/' + vm.selectedBranch.id, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.pendingLabels = result;
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Semi FG Label list.', Auth.translate('ERROR'));
					return null;
				});
		};

		vm.promptJobModal = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'JobListModal.html',
				controller: 'SemiFGLabelSelectJobModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
			});

			modalInstance
				.result
				.then(function (jobNo) {
					vm.label.jobNo = jobNo;
					vm.loadJob();
				}, function () {
				});
		};

		// Get Job Details
		vm.loadJob = function() {
			vm.isLoading = true;
			vm.isJobValid = false;

			var jobNo = vm.label.jobNo;
			jobNo = jobNo.toUpperCase()
			vm.label.jobNo = jobNo;

			HttpSvc.post('jobs/semifg/jobno', vm.label, Auth.getTokenId(), false)
				.then(function(result) {
					vm.job = result;
					vm.label.jobId = vm.job.id;
					vm.label.inventoryQty = 1;
					vm.label.servingSize = result.jobQty;
					vm.isLoading = false;
					vm.isJobValid = true;
					toastr.success('Production Job Details loaded successfully.', Auth.translate('SUCCESS'));

					vm.loadProductList();

				}, function(error) {
					toastr.error(error, 'Failed');
					var jobNo = vm.label.jobNo;
					vm.initData();
					vm.label.jobNo = jobNo;
				});
		}

		/* ****************************************************** */

		vm.onSelectedProductChanged = function() {
			vm.selectedUom1 = null;
			vm.selectedUom2 = null;
			vm.label.unitOfMeasurementId = null;
			vm.label.inventoryUnitOfMeasurementId = null;

			vm.label.productId = vm.selectedProduct.id;
			vm.loadUomList1(vm.selectedProduct.id);
		}

		vm.onSelectedUom1Changed = function() {
			vm.label.servingUom = vm.selectedUom1.name;
			vm.label.unitOfMeasurementId = vm.selectedUom1.id;
		}

		vm.onSelectedUom2Changed = function() {
			vm.label.inventoryUom = vm.selectedUom2.name;
			vm.label.inventoryUnitOfMeasurementId = vm.selectedUom2.id;
			vm.label.numberofLabel_UomId = vm.selectedUom2.id;
		}

		vm.selectedBranchChanged = function() {
			if(vm.selectedBranch==null)
			{
				vm.pendingLabels=[];
			}
			else
			{
				vm.loadPendingLabelList();
			}
		}

		/* ****************************************************** */

		// Form Submission
		vm.submit = function(form) {

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.label.numberofLabel = vm.label.inventoryQty;

				HttpSvc.post('inventory/semifgs/label/create', vm.label, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Semi Finished Goods Label has been created successfully.', Auth.translate('SUCCESS'));
						vm.resetFields();
						form.$setPristine();
					}, function(error) {
						toastr.error(error, 'Printing Failed');
					});
			}
		}

		// Re-print Label
		vm.reprintLabel = function() {
			if(vm.serialNo=="") {
				toastr.error("Please fill in the Label Serial No.", "Incomplete Fields");
				return;
			}

			var params = {
			 	serialNo: vm.serialNo,
				numberOfLabel: vm.numberOfLabel
			}

			HttpSvc.post('inventory/semifgs/label/reprint', params, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Re-print instruction has been sent.', Auth.translate('SUCCESS'));
					vm.resetFields();
				}, function(error) {
					toastr.error(error, 'Re-print Failed');
				});
		}

		// Void Label
		vm.voidLabel = function() {
			if(vm.serialNo=="") {
				toastr.error("Please fill in the Label Serial No.", "Incomplete Fields");
				return;
			}

			var params = {
			 	serialNo: vm.serialNo
			}
			HttpSvc.post('inventory/semifgs/label/void', params, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Label <b>' + vm.serialNo + '</b> has been voided.', Auth.translate('SUCCESS'));
					vm.resetFields();
					vm.loadPendingLabelList();
				}, function(error) {
					toastr.error(error, 'Void Failed');
				});
		}

		// Purge All Labels
		vm.purgeLabels = function() {
			vm.dataForm.$setPristine();
			vm.isLoading = true;

			HttpSvc.post('labels/purge/semifg/pending/' + vm.selectedBranch.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('All Labels have been purged successfully.', 'Purge Completed');
					vm.resetFields();
					vm.loadPendingLabelList();
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Purge Failed');
				});
		}

		// Purge All Labels
		vm.purgeTestLabels = function() {
			vm.dataForm.$setPristine();
			vm.isLoading = true;

			HttpSvc.post('labels/purge/semifg/pending/testprint/' + vm.selectedBranch.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('All Test Labels have been purged successfully.', 'Purge Completed');
					vm.resetFields();
					vm.loadPendingLabelList();
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Purge Failed');
				});
		}

		/* ***************************************************************************** */

		vm.showDownloadExcelModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'downloadModal.html',
				controller: 'SemiFGLabelDownloadExcelModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							branchId: vm.selectedBranch.id,
							branchName: vm.selectedBranch.name,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.selectedBranchChanged();
				}, function () {
				});
		};

		/* ***************************************************************************** */


		// Call Actions
		vm.initData();
	}

	/** @ngInject */
    function SemiFGLabelAdjustmentCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;

		vm.adj = {};
		vm.itemUoms = [];
		vm.labelInfo = null;
		vm.selectedUOM = null;
		vm.isLoading = false;

		// Init Data
		vm.initData = function() {
			vm.adj = {
				serialNo: "",
			};
		}

		/* ***************************************************************************** */

		// Load Raw Material's UOM List
		vm.loadItemUomList = function(itemId) {
			HttpSvc.get('semifgs/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.itemUoms = result;
				}, function(error) {
					toastr.error(error, 'Failed to load UOM List');
				});
		};

		/* ***************************************************************************** */

		vm.selectedUOMChanged = function() {
			vm.adj.uomId1 = vm.selectedUOM.id;
		}

		/* ***************************************************************************** */

		// Reset Fields
		vm.resetFields = function() {
			vm.dataForm.$setPristine();
			vm.adj = {};
			vm.itemUoms = [];
			vm.selectedUOM = null;
			vm.labelInfo = null;

			vm.initData();
			vm.isLoading = false;
		}

		/* ***************************************************************************** */

		// Load Label Info
		vm.loadLabelInfo = function() {
			var json = {
				serialNo: vm.adj.serialNo
			};
			HttpSvc.post('stockmgmts/mainlabelinfo', json, Auth.getTokenId(), false)
				.then(function(result) {
					vm.labelInfo = result;
					vm.loadItemUomList(vm.labelInfo.semiFinishedProductId);
				}, function() {
					// Failed
					toastr.error('Failed to retrieve the Label Information.', '');
					return null;
				});
		}

		// Adjust Label
		vm.adjustLabel = function() {
			vm.dataForm.$setPristine();
			vm.isLoading = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {
				HttpSvc.post('stockmgmts/labeladjustment', vm.adj, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Label adjustment is successful.', Auth.translate('SUCCESS'));
						vm.resetFields();

					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Label adjustment Failed');
					});
			}
		}

		/* ***************************************************************************** */

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
	function SemiFGLabelImportCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();

		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;

		/* **************************************************** */

		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";
		/* **************************************************** */

		vm.importOptions = {};
		vm.importOptions.excelContent = [];

		/* **************************************************** */

		vm.goBack = function() {
			$state.reload();
		}

		/* **************************************************** */

		vm.importResult = {};

		/* **************************************************** */

		vm.downloadTemplate = function(templateName) {

			var filename = templateName + ".xlsx";
			vm.isExporting = true;

			HttpSvc.getExcelObject('inventory/semifgs/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;
					},
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};

		/* **************************************************** */

		vm.importData = function() {
			vm.isImporting = true;

			HttpSvc.post('inventory/semifgs/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
					//vm.lockButtons = false;
					//vm.isImportComplete = true;

					//vm.importResult = result;

					//toastr.success("Data imported successfully!");
					//$state.go('maintenance.items.list');
				}, function(error) {
					//vm.lockButtons = false;
					//vm.isImportFailed = true;

					//toastr.error("Failed to import data! " + error);
				});
		}

		/* **************************************************** */

		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}

		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;
		}

		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];

			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}

		// Upload File
		vm.uploadFile = function() {
			vm.resetFileUploadParams();

			vm.lockButtons = true;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;

			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;

			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();
				vm.uploadMedia(vm.mediaToUpload);
			}
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {

						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);

					}, function(error) {
						toastr.error(error, 'Failed');

						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}

		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {

			if(vm.serverMode==0) {	// Local Server

				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					vm.isUploaded = true;

					// Call Process Excel API
					HttpSvc.post('inventory/semifgs/import/' + resp.data, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;

							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});

			}  else if(vm.serverMode==1) { // Azure Server

				/* Initialize variables */
				/* ************************************* */
				handleFileSelect(_fileToUpload);
				/* ************************************* */

				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */

				/* Upload File (First Block) */
				/* ************************************* */
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);

				fileReader.onload = function(e) {
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];

						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,
						}).then(function(response) {
							if (response.status==201) {
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							}
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));

							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};

		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;

            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }

        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);

                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);

				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }

        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';

			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,
			}).then(function(response) {
				vm.isUploaded = true;

				// Call Process Excel API
				HttpSvc.post('inventory/semifgs/import/' + excelFilename, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;

						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }

        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }
	};

	/** @ngInject */
	function SemiFGLabelSelectJobModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
		var $mdl = this;

		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfPages = 0;
		$mdl.startIndex = 0;
		$mdl.endIndex = 0;
		$mdl.dataFull = [];
		$mdl.data = [];
		$mdl.isLoading = false;

		$mdl.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.jobNo,
				productName: predicate.productName,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: $mdl.pageSize,
				pageNumber: Math.ceil(($mdl.startIndex + 1) / $mdl.pageSize)
			};

			return params;
		}

		$mdl.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

			$mdl.isLoading = true;

			var params = $mdl.getApiParams(tableState);

			HttpSvc.post('jobs/lazyload/list/completed/sfg', params, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.isLoading = false;
					$mdl.data = result.data;
					$mdl.numOfRecord = result.numberOfRecords;
					$mdl.numOfPages = result.numberOfPages;
					refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = $mdl.numOfPages;
			return tableState;
		};

		$mdl.resetSearch = function()
		{
		}

		// ********************************************************

		$mdl.selectJob = function(jobNo) {
			$uibModalInstance.close(jobNo);
		}

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	/** @ngInject */
	function SemiFGLabelDownloadExcelModalCtrl($uibModalInstance, $filter, $sce, item, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
		var $mdl = this;

		$mdl.batchList = [];
		$mdl.isLoading = false;
		$mdl.selectedBatchId = null;
		$mdl.branchId = item.branchId;
		$mdl.branchName = item.branchName;

		// ********************************************************

		$mdl.loadData = function() {
			$mdl.isLoading = true;

			HttpSvc.get('labels/list/' + $mdl.branchId + '/batchid/semifg', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.batchList = result;
					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		// ********************************************************

		$mdl.selectedBatchIdChanged = function() {
		}

		// ********************************************************

		$mdl.downloadExcel = function() {
			$mdl.isLoading = true;

			HttpSvc.get("labels/newbatchid/" + $mdl.branchId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.selectedBatchId = result.batchId;
					$mdl.downloadExcelPast();
					$mdl.loadData();
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate Excel');
					return null;
				});
		}

		$mdl.downloadExcelPast = function() {
			if($mdl.selectedBatchId == null)
			{
				toastr.warning("Please select a Batch Number to download.");
				return;
			}

			$mdl.isLoading = true;

			var filename = "RMS_SemiFG_Label_" + $mdl.selectedBatchId + ".xlsx";

			HttpSvc.getExcelObject("labels/exportsemifglabel/" + $mdl.branchId + "/" + $mdl.selectedBatchId, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isLoading = false;
					//$uibModalInstance.dismiss('cancel');
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate Excel');
					return null;
				});
		}

		// ********************************************************

		$mdl.downloadPdf = function() {
			$mdl.isLoading = true;

			HttpSvc.get("labels/newbatchid/" + $mdl.branchId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.selectedBatchId = result.batchId;
					$mdl.downloadPdfPast();
					$mdl.loadData();
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate PDF');
					return null;
				});
		}

		$mdl.downloadPdfPast = function() {
			if($mdl.selectedBatchId == null)
			{
				toastr.warning("Please select a Batch Number to download.");
				return;
			}

			$mdl.isLoading = true;

			var filename = "RMS_SemiFG_Label_" + $mdl.selectedBatchId + ".pdf";

			HttpSvc.getPdfObject("labels/exportsemifglabel/pdf/" + $mdl.branchId + "/" + $mdl.selectedBatchId, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isLoading = false;
					//$uibModalInstance.dismiss('cancel');
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate PDF');
					return null;
				});
		}

		// ********************************************************

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// ********************************************************

		$mdl.loadData();
	};

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.bulkbreakconfig.controller', [])
			.controller('BulkBreakConfigMainCtrl', BulkBreakConfigMainCtrl)
			.controller('BulkBreakConfigCreateCtrl', BulkBreakConfigCreateCtrl)
			.controller('BulkBreakConfigUpdateCtrl', BulkBreakConfigUpdateCtrl)
			.controller('BulkBreakConfigItemModalCtrl', BulkBreakConfigItemModalCtrl);

	/** @ngInject */
	function BulkBreakConfigMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) 
	{	
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.mgmtDataFull = [];
		vm.mgmtData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.mgmtDataFull, tableState.search.predicateObject) : vm.mgmtDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.mgmtData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.mgmtDataFull.length <= 0) {				
				HttpSvc.get('bulkbreakconfigs/list', {}, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.mgmtDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteRecord = function(recordId, recordName) {
			var params = {};
			HttpSvc.delete('bulkbreakconfigs/' + recordId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('bulkbreakconfigs/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.mgmtDataFull = result;
							
							toastr.success('The record for [' + recordName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete [' + recordName + '].', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function BulkBreakConfigCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.mgmt = {};
		vm.mgmt.bulkBreakConfigDetails = [];
		vm.itemList = [];
		vm.semiFgList = [];
		vm.productList = [];
		vm.uomList = [];
		vm.selectedItem = null;
		vm.selectedSemiFg = null;
		vm.selectedProduct = null;
		vm.selectedUom = null;
		vm.isLoading = false;
		
		/* ************************************************************* */
				
		// Load Item List
		vm.loadItemList = function(searchString) {
			vm.isLoading = true;
			
			HttpSvc.get('items/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.itemList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Raw Material list. ' + error, '');
					return null;
				});
		};		
				
		// Load Semi F.G. List
		vm.loadSemiFgList = function(searchString) {
			vm.isLoading = true;
			
			HttpSvc.get('semifgs/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.semiFgList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Semi F.G. list. ' + error, '');
					return null;
				});
		};	
				
		// Load Product List
		vm.loadProductList = function(searchString) {			
			vm.isLoading = true;
			
			HttpSvc.get('products/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.productList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Finished Goods list ' + error, '');
					return null;
				});
		};

		/* ********************************************************* */
				
		// Load Item UOMs
		vm.loadItemUoms = function(itemId) {
			vm.lockButtons = true;
			
			HttpSvc.get('items/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.lockButtons = false;
					
					if(vm.mode==2)
					{
						vm.uomList.forEach(function(u) {
							if(u.id==vm.mgmt.uomId)
							{
								vm.selectedUom = u;
							}
						});
					}
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Product UOMs
		vm.loadSemiFgUoms = function(semiFgId) {
			vm.lockButtons = true;

			HttpSvc.get('semifgs/uoms/' + semiFgId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.lockButtons = false;
					
					if(vm.mode==2)
					{
						vm.uomList.forEach(function(u) {
							if(u.id==vm.mgmt.uomId)
							{
								vm.selectedUom = u;
							}
						});
					}
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Semi F.G. UOMs
		vm.loadProductUoms = function(productId) {
			vm.lockButtons = true;

			HttpSvc.get('products/uoms/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.lockButtons = false;
					
					if(vm.mode==2)
					{
						vm.uomList.forEach(function(u) {
							if(u.id==vm.mgmt.uomId)
							{
								vm.selectedUom = u;
							}
						});
					}
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	

		/* ************************************************************* */

		vm.selectedItemChanged = function() {
			vm.mgmt.semiFgId = null;
			vm.mgmt.productId = null;
			vm.mgmt.itemId = vm.selectedItem.id;
			vm.mgmt.itemName = vm.selectedItem.description;
			
			vm.loadItemUoms(vm.mgmt.itemId);
		}

		vm.selectedSemiFgChanged = function() {
			vm.mgmt.itemId = null;
			vm.mgmt.productId = null;
			vm.mgmt.semiFgId = vm.selectedSemiFg.id;
			vm.mgmt.itemName = vm.selectedSemiFg.description;

			vm.loadSemiFgUoms(vm.mgmt.semiFgId);
		}

		vm.selectedProductChanged = function() {
			vm.mgmt.itemId = null;
			vm.mgmt.semiFgId = null;
			vm.mgmt.productId = vm.selectedProduct.id;
			vm.mgmt.itemName = vm.selectedProduct.name;

			vm.loadProductUoms(vm.mgmt.productId);
		}
		
		vm.selectedUomChanged = function() {
			vm.mgmt.uomId = vm.selectedUom.id;
			vm.mgmt.uomName = vm.selectedUom.name;
		};

		vm.clearSelection = function() {
			vm.selectedItem = null;
			vm.selectedSemiFg = null;
			vm.selectedProduct = null;
			vm.selectedUom = null;

			vm.mgmt.itemId = null
			vm.mgmt.semiFgId = null;
			vm.mgmt.productId = null;
			vm.mgmt.uomId = null;
			vm.mgmt.uomName = null;

			vm.uomList = [];
		}

		/* ************************************************************* */
			
		// Open Modal Dialog		
		vm.showAddItemModal = function () {	
			var objectId = null;
			if(vm.mgmt.itemId != null)
			{
				objectId = vm.mgmt.itemId;
			}
			if(vm.mgmt.semiFgId != null)
			{
				objectId = vm.mgmt.semiFgId;
			}
			if(vm.mgmt.productId != null)
			{
				objectId = vm.mgmt.productId;
			}
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'BulkBreakConfigItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: {},
							originalItemId: objectId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};	

		vm.showEditItemModal = function (index) {
			var objectId = null;
			if(vm.mgmt.itemId != null)
			{
				objectId = vm.mgmt.itemId;
			}
			if(vm.mgmt.semiFgId != null)
			{
				objectId = vm.mgmt.semiFgId;
			}
			if(vm.mgmt.productId != null)
			{
				objectId = vm.mgmt.productId;
			}

			vm.item = angular.copy(vm.mgmt.bulkBreakConfigDetails[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'BulkBreakConfigItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
							originalItemId: objectId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************* */		
		
		// Remove Setting
		vm.removeItem = function(index) {
			vm.mgmt.bulkBreakConfigDetails.splice(index, 1);
		};
		
		// Update Setting
		vm.updateItem = function(index, obj) {
			
			var isFound = false;			
			vm.mgmt.bulkBreakConfigDetails.forEach(function(i) {
				if(checkItemExist(i, obj))
				{
					i.id = obj.id;
					i.yieldId = obj.yieldId;
					i.itemId = obj.itemId;
					i.semiFgId = obj.semiFgId;
					i.productId = obj.productId;
					i.itemCode = obj.itemCode;
					i.itemName = obj.itemName;
					i.itemType = obj.itemType;
					i.quantity = obj.quantity;
					i.uomId = obj.uomId;
					i.uomName = obj.uomName;
					isFound = true;
				}
			});
			if(isFound) return;

			var element = {
				id: obj.id,
				yieldId: obj.yieldId,
				itemId: obj.itemId,
				semiFgId: obj.semiFgId,
				productId: obj.productId,
				itemCode: obj.itemCode,
				itemName: obj.itemName,
				itemType: obj.itemType,
				quantity: obj.quantity,
				uomId: obj.uomId,
				uomName: obj.uomName,
			};
			vm.mgmt.bulkBreakConfigDetails.splice(index, 1, element);
		};

		// Add Setting
		vm.addItem = function(obj) {
			
			var isFound = false;			
			vm.mgmt.bulkBreakConfigDetails.forEach(function(i) {
				if(checkItemExist(i, obj))
				{
					i.id = obj.id;
					i.yieldId = obj.yieldId;
					i.itemId = obj.itemId;
					i.semiFgId = obj.semiFgId;
					i.productId = obj.productId;
					i.itemCode = obj.itemCode;
					i.itemName = obj.itemName;
					i.itemType = obj.itemType;
					i.quantity = obj.quantity;
					i.uomId = obj.uomId;
					i.uomName = obj.uomName;
					isFound = true;
				}
			});
			if(isFound) return;

			var element = {
				id: obj.id,
				yieldId: obj.yieldId,
				itemId: obj.itemId,
				semiFgId: obj.semiFgId,
				productId: obj.productId,
				itemCode: obj.itemCode,
				itemName: obj.itemName,
				itemType: obj.itemType,
				quantity: obj.quantity,
				uomId: obj.uomId,
				uomName: obj.uomName,
			};
			vm.mgmt.bulkBreakConfigDetails.push(element);
		};
		
		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.isLoading = true;

				HttpSvc.post('bulkbreakconfigs', vm.mgmt, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Bulk-Break Configuration has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.bulkbreakconfig.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Call Action
		vm.loadItemList();
	}

	/** @ngInject */
	function BulkBreakConfigUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();

		var vm = this;
		vm.mode = 2;
		vm.mgmt = {};
		vm.itemList = [];
		vm.semiFgList = [];
		vm.productList = [];
		vm.uomList = [];
		vm.selectedItem = null;
		vm.selectedSemiFg = null;
		vm.selectedProduct = null;
		vm.selectedUom = null;
		vm.isLoading = false;
		
		/* ************************************************************* */
						
		// Load Menu
		vm.loadData = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('bulkbreakconfigs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.mgmt = result;

					if(vm.mgmt.itemId!='' && vm.mgmt.itemId!=null){
						vm.selectedItem = {
							id: vm.mgmt.itemId,
							code: vm.mgmt.itemCode,
							description: vm.mgmt.itemName,
						};
						vm.loadItemUoms(vm.mgmt.itemId);
						vm.activeTab = 0;
					};
					
					if(vm.mgmt.semiFinishedProductId!='' && vm.mgmt.semiFinishedProductId!=null){
						vm.selectedSemiFg = {
							id: vm.mgmt.semiFgId,
							code: vm.mgmt.itemCode,
							description: vm.mgmt.itemName,
						};
						vm.loadSemiFgUoms(vm.mgmt.semiFgId);
						vm.activeTab = 1;
					};
		
					if(vm.mgmt.productId!='' && vm.mgmt.productId!=null){
						vm.selectedProduct = {
							id: vm.mgmt.productId,
							code: vm.mgmt.itemCode,
							name: vm.mgmt.itemName,
						};
						vm.loadProductUoms(vm.mgmt.productId);
						vm.activeTab = 2;
					};
				}, function() {
					toastr.error('Failed to load selected Configuration.', Auth.translate('ERROR'))
					$state.go('maintenance.bulkbreakconfig.list');
					return;
				});		
		};	
		
		/* ************************************************************* */
				
		// Load Item List
		vm.loadItemList = function(searchString) {
			vm.isLoading = true;
			
			HttpSvc.get('items/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.itemList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Raw Material list. ' + error, '');
					return null;
				});
		};		
				
		// Load Semi F.G. List
		vm.loadSemiFgList = function(searchString) {
			vm.isLoading = true;
			
			HttpSvc.get('semifgs/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.semiFgList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Semi F.G. list. ' + error, '');
					return null;
				});
		};	
				
		// Load Product List
		vm.loadProductList = function(searchString) {			
			vm.isLoading = true;
			
			HttpSvc.get('products/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.productList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Finished Goods list ' + error, '');
					return null;
				});
		};

		/* ********************************************************* */
				
		// Load Item UOMs
		vm.loadItemUoms = function(itemId) {
			vm.lockButtons = true;
			
			HttpSvc.get('items/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.lockButtons = false;
					
					if(vm.mode==2)
					{
						vm.uomList.forEach(function(u) {
							if(u.id==vm.mgmt.uomId)
							{
								vm.selectedUom = u;
							}
						});
					}
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Product UOMs
		vm.loadSemiFgUoms = function(semiFgId) {
			vm.lockButtons = true;

			HttpSvc.get('semifgs/uoms/' + semiFgId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.lockButtons = false;
					
					if(vm.mode==2)
					{
						vm.uomList.forEach(function(u) {
							if(u.id==vm.mgmt.uomId)
							{
								vm.selectedUom = u;
							}
						});
					}
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Semi F.G. UOMs
		vm.loadProductUoms = function(productId) {
			vm.lockButtons = true;

			HttpSvc.get('products/uoms/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.lockButtons = false;
					
					if(vm.mode==2)
					{
						vm.uomList.forEach(function(u) {
							if(u.id==vm.mgmt.uomId)
							{
								vm.selectedUom = u;
							}
						});
					}
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	

		/* ************************************************************* */

		vm.selectedItemChanged = function() {
			vm.mgmt.semiFgId = null;
			vm.mgmt.productId = null;
			vm.mgmt.itemId = vm.selectedItem.id;
			vm.mgmt.itemName = vm.selectedItem.description;
		}

		vm.selectedSemiFgChanged = function() {
			vm.mgmt.itemId = null;
			vm.mgmt.productId = null;
			vm.mgmt.semiFgId = vm.selectedSemiFg.id;
			vm.mgmt.itemName = vm.selectedSemiFg.description;
		}

		vm.selectedProductChanged = function() {
			vm.mgmt.itemId = null;
			vm.mgmt.semiFgId = null;
			vm.mgmt.productId = vm.selectedProduct.id;
			vm.mgmt.itemName = vm.selectedProduct.name;
		}
		
		vm.selectedUomChanged = function() {
			vm.mgmt.uomId = vm.selectedUom.id;
			vm.mgmt.uomName = vm.selectedUom.name;
		};

		vm.clearSelection = function() {
			vm.selectedItem = null;
			vm.selectedSemiFg = null;
			vm.selectedProduct = null;
			vm.selectedUom = null;

			vm.mgmt.itemId = null
			vm.mgmt.semiFgId = null;
			vm.mgmt.productId = null;
			vm.mgmt.uomId = null;
			vm.mgmt.uomName = null;

			vm.uomList = [];
		}
		
		/* ************************************************************* */
			
		// Open Modal Dialog		
		vm.showAddItemModal = function () {
			var objectId = null;
			if(vm.mgmt.itemId != null)
			{
				objectId = vm.mgmt.itemId;
			}
			if(vm.mgmt.semiFgId != null)
			{
				objectId = vm.mgmt.semiFgId;
			}
			if(vm.mgmt.productId != null)
			{
				objectId = vm.mgmt.productId;
			}

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'BulkBreakConfigItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: {},
							originalItemId: objectId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};	

		vm.showEditItemModal = function (index) {
			var objectId = null;
			if(vm.mgmt.itemId != null)
			{
				objectId = vm.mgmt.itemId;
			}
			if(vm.mgmt.semiFgId != null)
			{
				objectId = vm.mgmt.semiFgId;
			}
			if(vm.mgmt.productId != null)
			{
				objectId = vm.mgmt.productId;
			}

			vm.item = angular.copy(vm.mgmt.bulkBreakConfigDetails[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'BulkBreakConfigItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
							originalItemId: objectId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************* */		
		
		// Remove Setting
		vm.removeItem = function(index) {
			vm.mgmt.bulkBreakConfigDetails.splice(index, 1);
		};
			
		// Update Setting
		vm.updateItem = function(index, obj) {
			
			var isFound = false;			
			vm.mgmt.bulkBreakConfigDetails.forEach(function(i) {
				if(checkItemExist(i, obj))
				{
					i.id = obj.id;
					i.yieldId = obj.yieldId;
					i.itemId = obj.itemId;
					i.semiFgId = obj.semiFgId;
					i.productId = obj.productId;
					i.itemCode = obj.itemCode;
					i.itemName = obj.itemName;
					i.itemType = obj.itemType;
					i.quantity = obj.quantity;
					i.uomId = obj.uomId;
					i.uomName = obj.uomName;
					isFound = true;
				}
			});
			if(isFound) return;

			var element = {
				id: obj.id,
				yieldId: obj.yieldId,
				itemId: obj.itemId,
				semiFgId: obj.semiFgId,
				productId: obj.productId,
				itemCode: obj.itemCode,
				itemName: obj.itemName,
				itemType: obj.itemType,
				quantity: obj.quantity,
				uomId: obj.uomId,
				uomName: obj.uomName,
			};
			vm.mgmt.bulkBreakConfigDetails.splice(index, 1, element);
		};

		// Add Setting
		vm.addItem = function(obj) {
			
			var isFound = false;			
			vm.mgmt.bulkBreakConfigDetails.forEach(function(i) {
				if(checkItemExist(i, obj))
				{
					i.id = obj.id;
					i.yieldId = obj.yieldId;
					i.itemId = obj.itemId;
					i.semiFgId = obj.semiFgId;
					i.productId = obj.productId;
					i.itemCode = obj.itemCode;
					i.itemName = obj.itemName;
					i.itemType = obj.itemType;
					i.quantity = obj.quantity;
					i.uomId = obj.uomId;
					i.uomName = obj.uomName;
					isFound = true;
				}
			});
			if(isFound) return;

			var element = {
				id: obj.id,
				yieldId: obj.yieldId,
				itemId: obj.itemId,
				semiFgId: obj.semiFgId,
				productId: obj.productId,
				itemCode: obj.itemCode,
				itemName: obj.itemName,
				itemType: obj.itemType,
				quantity: obj.quantity,
				uomId: obj.uomId,
				uomName: obj.uomName,
			};
			vm.mgmt.bulkBreakConfigDetails.push(element);
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('bulkbreakconfigs/' + $stateParams.id, vm.mgmt, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Bulk-Break Configuration has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadData();
	}
		
	/** @ngInject */
	function BulkBreakConfigItemModalCtrl($uibModalInstance, item, toastr, Auth, HttpSvc) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.item = item.object;
		$mdl.originalItemId = item.originalItemId;
		$mdl.itemList = [];
		$mdl.semiFgList = [];
		$mdl.productList = [];
		$mdl.uomList = [];
		$mdl.selectedItem = null;
		$mdl.selectedSemiFg = null;
		$mdl.selectedProduct = null;
		$mdl.selectedItem = null;
		$mdl.selectedUom = null;
		$mdl.lockButtons = false;
		
		/* ********************************************************* */
				
		// Load Item List
		$mdl.loadItemList = function(searchString) {
			$mdl.lockButtons = true;
			
			HttpSvc.get('items/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.itemList = result;
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Raw Material list.', '');
					return null;
				});
		};		
				
		// Load Semi F.G. List
		$mdl.loadSemiFgList = function(searchString) {
			$mdl.lockButtons = true;
			
			HttpSvc.get('semifgs/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.semiFgList = result;
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Semi F.G. list.', '');
					return null;
				});
		};	
				
		// Load Product List
		$mdl.loadProductList = function(searchString) {			
			$mdl.lockButtons = true;
			
			HttpSvc.get('products/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.productList = result;
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Finished Goods list.', '');
					return null;
				});
		};

		/* ********************************************************* */
				
		// Load Item UOMs
		$mdl.loadItemUoms = function(itemId) {
			$mdl.lockButtons = true;
			
			HttpSvc.get('items/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.uomList = result;
					$mdl.lockButtons = false;
					
					if(item.mode==2)
					{
						$mdl.uomList.forEach(function(u) {
							if(u.id==$mdl.item.uomId)
							{
								$mdl.selectedUom = u;
							}
						});
					}
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Product UOMs
		$mdl.loadSemiFgUoms = function(semiFgId) {
			$mdl.lockButtons = true;

			HttpSvc.get('semifgs/uoms/' + semiFgId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.uomList = result;
					$mdl.lockButtons = false;
					
					if(item.mode==2)
					{
						$mdl.uomList.forEach(function(u) {
							if(u.id==$mdl.item.uomId)
							{
								$mdl.selectedUom = u;
							}
						});
					}
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Semi F.G. UOMs
		$mdl.loadProductUoms = function(productId) {
			$mdl.lockButtons = true;

			HttpSvc.get('products/uoms/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.uomList = result;
					$mdl.lockButtons = false;
					
					if(item.mode==2)
					{
						$mdl.uomList.forEach(function(u) {
							if(u.id==$mdl.item.uomId)
							{
								$mdl.selectedUom = u;
							}
						});
					}
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	

		/* ********************************************************* */
		
		$mdl.selectedItemChanged = function() {
			$mdl.item.productId = null;
			$mdl.item.semiFgId = null;
			$mdl.item.itemId = $mdl.selectedItem.id;
			$mdl.item.itemCode = $mdl.selectedItem.code;
			$mdl.item.itemName = $mdl.selectedItem.description;
			$mdl.item.itemType = "RAW MAT";
			
			$mdl.selectedSemiFg = null;
			$mdl.selectedProduct = null;

			$mdl.loadItemUoms($mdl.item.itemId);
		};
		
		$mdl.selectedSemiFgChanged = function() {
			$mdl.item.itemId = null;
			$mdl.item.productId = null;
			$mdl.item.semiFgId = $mdl.selectedSemiFg.id;
			$mdl.item.itemCode = $mdl.selectedSemiFg.code;
			$mdl.item.itemName = $mdl.selectedSemiFg.description;
			$mdl.item.itemType = "SEMI FG";
			
			$mdl.selectedItem = null;
			$mdl.selectedProduct = null;

			$mdl.loadSemiFgUoms($mdl.item.semiFgId);
		};
		
		$mdl.selectedProductChanged = function() {
			$mdl.item.itemId = null;
			$mdl.item.semiFgId = null;
			$mdl.item.productId = $mdl.selectedProduct.id;
			$mdl.item.itemCode = $mdl.selectedProduct.code;
			$mdl.item.itemName = $mdl.selectedProduct.name;
			$mdl.item.itemType = "F.GOODS";
			
			$mdl.selectedItem = null;
			$mdl.selectedSemiFg = null;

			$mdl.loadProductUoms($mdl.item.productId);
		};
		
		$mdl.selectedUomChanged = function() {
			$mdl.item.uomId = $mdl.selectedUom.id;
			$mdl.item.uomName = $mdl.selectedUom.name;
		};

		$mdl.clearSelection = function() {
			$mdl.selectedItem = null;
			$mdl.selectedSemiFg = null;
			$mdl.selectedProduct = null;
			$mdl.selectedUom = null;

			$mdl.item.itemId = null
			$mdl.item.semiFgId = null;
			$mdl.item.productId = null;
			$mdl.item.uomId = null;
			$mdl.item.uomName = null;

			$mdl.uomList = [];
		}

		/* ********************************************************* */

		$mdl.confirmModal = function() {
			if($mdl.itemForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				if($mdl.originalItemId != null &&
					($mdl.originalItemId == $mdl.item.itemId || 
					 $mdl.originalItemId == $mdl.item.semiFgId ||
					 $mdl.originalItemId == $mdl.item.productId)) 
				{
					toastr.warning("Selected Item cannot be the same as the Original Item.");
					return;
				}

				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		/* ********************************************************* */

		// Initialize
		if(item.mode==1) {
			$mdl.item.itemId = "";
			$mdl.item.itemCode = "";			
			$mdl.item.itemName = "";			
			$mdl.item.yieldPercent = 0;
		} else {
			if($mdl.item.itemId!='' && $mdl.item.itemId!=null){
				$mdl.selectedItem = {
					id: $mdl.item.itemId,
					code: $mdl.item.itemCode,
					description: $mdl.item.itemName,
				};
				$mdl.loadItemUoms($mdl.item.itemId);
				$mdl.activeTab = 0;
			};
			
			if($mdl.item.semiFgId!='' && $mdl.item.semiFgId!=null){
				$mdl.selectedSemiFg = {
					id: $mdl.item.semiFgId,
					code: $mdl.item.itemCode,
					description: $mdl.item.itemName,
				};
				$mdl.loadSemiFgUoms($mdl.item.semiFgId);
				$mdl.activeTab = 1;
			};

			if($mdl.item.productId!='' && $mdl.item.productId!=null){
				$mdl.selectedProduct = {
					id: $mdl.item.productId,
					code: $mdl.item.itemCode,
					name: $mdl.item.itemName,
				};
				$mdl.loadProductUoms($mdl.item.productId);
				$mdl.activeTab = 2;
			};
		}
	};	

	function checkItemExist(i, obj) {

		if((i.itemId==obj.itemId && i.itemId!="" && i.itemId!=null) ||
			(i.productId==obj.productId && i.productId!="" && i.productId!=null) ||
			(i.semiFinishedProductId==obj.semiFinishedProductId && i.semiFinishedProductId!="" && i.semiFinishedProductId!=null))
		{
			return true;
		}
		return false;
	}	

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.label.products.controller', [])
        .controller('ProductLabelPrintCtrl', ProductLabelPrintCtrl)
        .controller('ProductLabelAdjustmentCtrl', ProductLabelAdjustmentCtrl)
        .controller('ProductLabelImportCtrl', ProductLabelImportCtrl)
        .controller('ProductLabelSelectJobModalCtrl', ProductLabelSelectJobModalCtrl)
        .controller('ProductLabelDownloadExcelModalCtrl', ProductLabelDownloadExcelModalCtrl);

	/** @ngInject */
    function ProductLabelPrintCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.submitted = false;
		vm.label = {};
		vm.job = {};
		vm.uomList1 = [];
		vm.uomList2 = [];
		vm.productList = [];
		vm.selectedUom1 = null;
		vm.selectedUom2 = null;
		vm.selectedProduct = null;
		vm.selectedBranch = null;
		vm.isLoading = false;
		vm.isJobValid = false;
		vm.blobUrl = vm.serverMode==1 ? "../" : "";

		// Init Data
		vm.initData = function() {
			vm.isLoading = false;
			vm.isJobValid = false;

			vm.serialNo = "";
			vm.numberOfLabel = 1;

			vm.label = {
				jobId: '',
				jobNo: '',
				jobQty: 0,
				jobUom: '',
				servingSize: 1,
				unitOfMeasurementId: '',
				servingUom: '',
				inventoryQty: 1,
				inventoryUom: '',
				inventoryUnitOfMeasurementId: '',
				printOption: 1,
				numberofLabel: 1,
				numberofLabel_UomId: '',
			};

			vm.selectedUom1 = null;
			vm.selectedUom2 = null;
			vm.selectedProduct = null;

			vm.loadBranchList();

            var jobNo = $stateParams.jobNo || null;

            if (jobNo) {
                vm.label.jobNo = jobNo.toUpperCase();
                vm.loadJob();
            }
		}

		// Reset Fields
		vm.resetFields = function() {
			vm.serialNo = "";
			vm.label.servingSize = "";
			vm.label.inventoryQty = "";
			vm.label.mfgDate = null;
			vm.isLoading = false;
			vm.dataForm.$setPristine();
		}

		// Load Product List
		vm.loadProductList = function() {
			HttpSvc.get('products/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.productList = result;

					vm.productList.forEach(function(p) {
						if(p.id==vm.job.productId) {
							vm.selectedUom1 = null;
							vm.selectedUom2 = null;
							vm.label.unitOfMeasurementId = null;
							vm.label.inventoryUnitOfMeasurementId = null;

							vm.selectedProduct = p;
							vm.label.productId = p.id;
							vm.loadUomList1(p.id);
							return;
						}
					});
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Finished Goods list.', '');
					return null;
				});
		}

		// Load Branch List
		vm.loadBranchList = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
					vm.branches.forEach(function(b) {
						if(b.id==Auth.getBranchId())
						{
							vm.selectedBranch = b;
							vm.loadPendingLabelList();
						}
					});
					//vm.loadDepartments();
				}, function(error) {
					toastr.error(error, 'Failed to load Branch List');
				});
		};

		// Load UOM List
		vm.loadUomList1 = function(productId) {
			HttpSvc.get('products/uoms/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.uomList1 = result;
					vm.uomList2 = result;

					vm.uomList1.forEach(function(u) {
						if(u.id==vm.job.servingUomId) {
							vm.selectedUom1 = u;
							vm.label.servingUom = u.name;
							vm.label.unitOfMeasurementId = u.id;
						}
					})

					vm.uomList2.forEach(function(u) {
						if(u.id==vm.job.inventoryUomId) {
							vm.selectedUom2 = u;
							vm.label.inventoryUom = u.name;
							vm.label.inventoryUnitOfMeasurementId = u.id;
							vm.label.numberofLabel_UomId = u.id;
						}
					})

					//vm.loadUomList2(productId);
				}, function() {
					// Failed
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		}

		vm.loadUomList2 = function(productId) {
			HttpSvc.get('products/uoms/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.uomList2 = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		}

		// Load Pending Label List
		vm.loadPendingLabelList = function() {
			vm.isLoading = true;

			HttpSvc.get('labels/list/product/pending/' + vm.selectedBranch.id, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.pendingLabels = result;
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Product Label list.', Auth.translate('ERROR'));
					return null;
				});
		};

		vm.promptJobModal = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'JobListModal.html',
				controller: 'ProductLabelSelectJobModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
			});

			modalInstance
				.result
				.then(function (jobNo) {
					vm.label.jobNo = jobNo;
					vm.loadJob();
				}, function () {
				});
		};

		// Get Job Details
		vm.loadJob = function() {
			vm.isLoading = true;
			vm.isJobValid = false;

			var jobNo = vm.label.jobNo;
			jobNo = jobNo.toUpperCase()
			vm.label.jobNo = jobNo;

			HttpSvc.post('jobs/fg/jobno', vm.label, Auth.getTokenId(), false)
				.then(function(result) {
					vm.job = result;
					vm.label.jobId = vm.job.id;
					vm.label.inventoryQty = 1;
					vm.label.servingSize = result.jobQty;
					vm.isLoading = false;
					vm.isJobValid = true;
					toastr.success('Production Job Details loaded successfully.', Auth.translate('SUCCESS'));

					vm.loadProductList();

				}, function(error) {
					toastr.error(error, 'Failed');
					var jobNo = vm.label.jobNo;
					vm.initData();
					vm.label.jobNo = jobNo;
				});
		}

		/* ****************************************************** */

		vm.onSelectedProductChanged = function() {
			vm.selectedUom1 = null;
			vm.selectedUom2 = null;
			vm.label.unitOfMeasurementId = null;
			vm.label.inventoryUnitOfMeasurementId = null;

			vm.label.productId = vm.selectedProduct.id;
			vm.loadUomList1(vm.selectedProduct.id);
		}

		vm.onSelectedUom1Changed = function() {
			vm.label.servingUom = vm.selectedUom1.name;
			vm.label.unitOfMeasurementId = vm.selectedUom1.id;
		}

		vm.onSelectedUom2Changed = function() {
			vm.label.inventoryUom = vm.selectedUom2.name;
			vm.label.inventoryUnitOfMeasurementId = vm.selectedUom2.id;
			vm.label.numberofLabel_UomId = vm.selectedUom2.id;
		}

		vm.selectedBranchChanged = function() {
			if(vm.selectedBranch==null)
			{
				vm.pendingLabels=[];
			}
			else
			{
				vm.loadPendingLabelList();
			}
		}

		/* ****************************************************** */

		// Form Submission
		vm.submit = function(form) {

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {

				vm.label.numberofLabel = vm.label.inventoryQty;

				HttpSvc.post('inventory/products/label/create', vm.label, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Finished Goods Label has been created successfully.', Auth.translate('SUCCESS'));
						vm.resetFields();
					}, function(error) {
						toastr.error(error, 'Printing Failed');
					});
			}
		}

		// Re-print Label
		vm.reprintLabel = function() {
			if(vm.serialNo=="") {
				toastr.error("Please fill in the Label Serial No.", "Incomplete Fields");
				return;
			}

			var params = {
			 	serialNo: vm.serialNo,
				numberOfLabel: vm.numberOfLabel
			}
			HttpSvc.post('inventory/products/label/reprint', params, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Re-print instruction has been sent.', Auth.translate('SUCCESS'));
					vm.resetFields();
				}, function(error) {
					toastr.error(error, 'Re-print Failed');
				});
		}

		// Void Label
		vm.voidLabel = function() {
			if(vm.serialNo=="") {
				toastr.error("Please fill in the Label Serial No.", "Incomplete Fields");
				return;
			}

			var params = {
			 	serialNo: vm.serialNo
			}
			HttpSvc.post('inventory/products/label/void', params, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Label <b>' + vm.serialNo + '</b> has been voided.', Auth.translate('SUCCESS'));
					vm.resetFields();
					vm.loadPendingLabelList();
				}, function(error) {
					toastr.error(error, 'Void Failed');
				});
		}

		// Purge All Labels
		vm.purgeLabels = function() {
			vm.dataForm.$setPristine();
			vm.isLoading = true;

			HttpSvc.post('labels/purge/product/pending/' + vm.selectedBranch.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('All Labels have been purged successfully.', 'Purge Completed');
					vm.resetFields();
					vm.loadPendingLabelList();
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Purge Failed');
				});
		}

		// Purge All Labels
		vm.purgeTestLabels = function() {
			vm.dataForm.$setPristine();
			vm.isLoading = true;

			HttpSvc.post('labels/purge/product/pending/testprint/' + vm.selectedBranch.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('All Test Labels have been purged successfully.', 'Purge Completed');
					vm.resetFields();
					vm.loadPendingLabelList();
				}, function(error) {
					vm.isLoading = false;
					toastr.error(error, 'Purge Failed');
				});
		}

		/* ***************************************************************************** */

		vm.showDownloadExcelModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'downloadModal.html',
				controller: 'ProductLabelDownloadExcelModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							branchId: vm.selectedBranch.id,
							branchName: vm.selectedBranch.name,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.selectedBranchChanged();
				}, function () {
				});
		};

		/* ***************************************************************************** */

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
    function ProductLabelAdjustmentCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;

		vm.adj = {};
		vm.itemUoms = [];
		vm.labelInfo = null;
		vm.selectedUOM = null;
		vm.isLoading = false;

		// Init Data
		vm.initData = function() {
			vm.adj = {
				serialNo: "",
			};
		}

		/* ***************************************************************************** */

		// Load Raw Material's UOM List
		vm.loadItemUomList = function(itemId) {
			HttpSvc.get('products/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.itemUoms = result;
				}, function(error) {
					toastr.error(error, 'Failed to load UOM List');
				});
		};

		/* ***************************************************************************** */

		vm.selectedUOMChanged = function() {
			vm.adj.uomId1 = vm.selectedUOM.id;
		}

		/* ***************************************************************************** */

		// Reset Fields
		vm.resetFields = function() {
			vm.dataForm.$setPristine();
			vm.adj = {};
			vm.itemUoms = [];
			vm.selectedUOM = null;
			vm.labelInfo = null;

			vm.initData();
			vm.isLoading = false;
		}

		/* ***************************************************************************** */

		// Load Label Info
		vm.loadLabelInfo = function() {
			var json = {
				serialNo: vm.adj.serialNo
			};
			HttpSvc.post('stockmgmts/mainlabelinfo', json, Auth.getTokenId(), false)
				.then(function(result) {
					vm.labelInfo = result;
					vm.loadItemUomList(vm.labelInfo.productId);
				}, function() {
					// Failed
					toastr.error('Failed to retrieve the Label Information.', '');
					return null;
				});
		}

		// Adjust Label
		vm.adjustLabel = function() {
			vm.dataForm.$setPristine();
			vm.isLoading = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {
				HttpSvc.post('stockmgmts/labeladjustment', vm.adj, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Label adjustment is successful.', Auth.translate('SUCCESS'));
						vm.resetFields();

					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Label adjustment Failed');
					});
			}
		}

		/* ***************************************************************************** */

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
	function ProductLabelImportCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();

		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;

		/* **************************************************** */

		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";
		/* **************************************************** */

		vm.importOptions = {};
		vm.importOptions.excelContent = [];

		/* **************************************************** */

		vm.goBack = function() {
			$state.reload();
		}

		/* **************************************************** */

		vm.importResult = {};

		/* **************************************************** */

		vm.downloadTemplate = function(templateName) {

			var filename = templateName + ".xlsx";
			vm.isExporting = true;

			HttpSvc.getExcelObject('inventory/products/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;
					},
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};

		/* **************************************************** */

		vm.importData = function() {
			vm.isImporting = true;

			HttpSvc.post('inventory/products/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
					//vm.lockButtons = false;
					//vm.isImportComplete = true;

					//vm.importResult = result;

					//toastr.success("Data imported successfully!");
					//$state.go('maintenance.items.list');
				}, function(error) {
					//vm.lockButtons = false;
					//vm.isImportFailed = true;

					//toastr.error("Failed to import data! " + error);
				});
		}

		/* **************************************************** */

		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}

		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;
		}

		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];

			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}

		// Upload File
		vm.uploadFile = function() {
			vm.resetFileUploadParams();

			vm.lockButtons = true;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;

			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;

			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();
				vm.uploadMedia(vm.mediaToUpload);
			}
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {

						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);

					}, function(error) {
						toastr.error(error, 'Failed');

						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}

		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {

			if(vm.serverMode==0) {	// Local Server

				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					vm.isUploaded = true;

					// Call Process Excel API
					HttpSvc.post('inventory/products/import/' + resp.data, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;

							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});

			}  else if(vm.serverMode==1) { // Azure Server

				/* Initialize variables */
				/* ************************************* */
				handleFileSelect(_fileToUpload);
				/* ************************************* */

				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */

				/* Upload File (First Block) */
				/* ************************************* */
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);

				fileReader.onload = function(e) {
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];

						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,
						}).then(function(response) {
							if (response.status==201) {
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							}
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));

							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};

		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;

            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }

        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);

                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);

				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }

        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';

			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,
			}).then(function(response) {
				vm.isUploaded = true;

				// Call Process Excel API
				HttpSvc.post('inventory/products/import/' + excelFilename, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;

						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }

        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }
	};

	/** @ngInject */
	function ProductLabelSelectJobModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
		var $mdl = this;

		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfPages = 0;
		$mdl.startIndex = 0;
		$mdl.endIndex = 0;
		$mdl.dataFull = [];
		$mdl.data = [];
		$mdl.isLoading = false;

		$mdl.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.jobNo,
				productName: predicate.productName,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: $mdl.pageSize,
				pageNumber: Math.ceil(($mdl.startIndex + 1) / $mdl.pageSize)
			};

			return params;
		}

		$mdl.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

			$mdl.isLoading = true;

			var params = $mdl.getApiParams(tableState);

			HttpSvc.post('jobs/lazyload/list/completed/fg', params, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.isLoading = false;
					$mdl.data = result.data;
					$mdl.numOfRecord = result.numberOfRecords;
					$mdl.numOfPages = result.numberOfPages;
					refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = $mdl.numOfPages;
			return tableState;
		};

		$mdl.resetSearch = function()
		{
		}

		// ********************************************************

		$mdl.selectJob = function(jobNo) {
			$uibModalInstance.close(jobNo);
		}

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	/** @ngInject */
	function ProductLabelDownloadExcelModalCtrl($uibModalInstance, $filter, $sce, item, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
		var $mdl = this;

		$mdl.batchList = [];
		$mdl.isLoading = false;
		$mdl.selectedBatchId = null;
		$mdl.branchId = item.branchId;
		$mdl.branchName = item.branchName;

		// ********************************************************

		$mdl.loadData = function() {
			$mdl.isLoading = true;

			HttpSvc.get('labels/list/' + $mdl.branchId + '/batchid/fg', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.batchList = result;
					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		// ********************************************************

		$mdl.selectedBatchIdChanged = function() {
		}

		// ********************************************************

		$mdl.downloadExcel = function() {
			$mdl.isLoading = true;

			HttpSvc.get("labels/newbatchid/" + $mdl.branchId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.selectedBatchId = result.batchId;
					$mdl.downloadExcelPast();
					$mdl.loadData();
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate Excel');
					return null;
				});
		}

		$mdl.downloadExcelPast = function() {
			if($mdl.selectedBatchId == null)
			{
				toastr.warning("Please select a Batch Number to download.");
				return;
			}

			$mdl.isLoading = true;

			var filename = "RMS_Product_Label_" + $mdl.selectedBatchId + ".xlsx";

			HttpSvc.getExcelObject("labels/exportproductlabel/" + $mdl.branchId + "/" + $mdl.selectedBatchId, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isLoading = false;
					//$uibModalInstance.dismiss('cancel');
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate Excel');
					return null;
				});
		}

		// ********************************************************

		$mdl.downloadPdf = function() {
			$mdl.isLoading = true;

			HttpSvc.get("labels/newbatchid/" + $mdl.branchId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.selectedBatchId = result.batchId;
					$mdl.downloadPdfPast();
					$mdl.loadData();
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate PDF');
					return null;
				});
		}

		$mdl.downloadPdfPast = function() {
			if($mdl.selectedBatchId == null)
			{
				toastr.warning("Please select a Batch Number to download.");
				return;
			}

			$mdl.isLoading = true;

			var filename = "RMS_Product_Label_" + $mdl.selectedBatchId + ".pdf";

			HttpSvc.getPdfObject("labels/exportproductlabel/pdf/" + $mdl.branchId + "/" + $mdl.selectedBatchId, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isLoading = false;
					//$uibModalInstance.dismiss('cancel');
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate PDF');
					return null;
				});
		}

		// ********************************************************

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// ********************************************************

		$mdl.loadData();
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.debtorcategories.controller', [])
        .controller('DebtorCategoryMainCtrl', DebtorCategoryMainCtrl)
        .controller('DebtorCategoryCreateCtrl', DebtorCategoryCreateCtrl)
        .controller('DebtorCategoryUpdateCtrl', DebtorCategoryUpdateCtrl);

    /** @ngInject */
    function DebtorCategoryMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.categoryDataFull = [];
		vm.categoryData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.categoryDataFull, tableState.search.predicateObject) : vm.categoryDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.categoryData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.categoryDataFull.length <= 0) {				
				HttpSvc.get('debtorcategories/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.categoryDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteCategory = function(categoryId, categoryName) {
			var params = {};
			HttpSvc.delete('debtorcategories/' + categoryId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('debtorcategories/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.categoryDataFull = result;
							
							toastr.success('The category [' + categoryName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the category [' + categoryName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function DebtorCategoryCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.category = {};	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('debtorcategories', vm.category, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Category has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.debtorcategories.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function DebtorCategoryUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.category = {};
						
		// Load DebtorCategory
		vm.loadCategory = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('debtorcategories/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.category = result;
				}, function() {
					toastr.error('Failed to load selected Category.', Auth.translate('ERROR'))
					$state.go('maintenance.debtorcategories.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('debtorcategories/' + $stateParams.id, vm.category, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Category has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.debtorcategories.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadCategory();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.debtors.controller', [])
        .controller('DebtorsMainCtrl', DebtorsMainCtrl)
        .controller('DebtorsCreateCtrl', DebtorsCreateCtrl)
        .controller('DebtorsUpdateCtrl', DebtorsUpdateCtrl)
        .controller('DebtorsImportCtrl', DebtorsImportCtrl)
        .controller('DebtorsBranchModalCtrl', DebtorsBranchModalCtrl);

    /** @ngInject */
    function DebtorsMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.debtorDataFull = [];
		vm.debtorData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.debtorDataFull, tableState.search.predicateObject) : vm.debtorDataFull;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.debtorData = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;

			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.debtorDataFull.length <= 0) {
				vm.isLoading = true;

				HttpSvc.get('debtors/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isLoading = false;
						vm.numOfRecord = result.length;
						vm.debtorDataFull = result;
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		vm.deleteCustomer = function(debtorId, debtorName) {
			var params = {};
			HttpSvc.delete('debtors/' + debtorId, params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = true;

					HttpSvc.get('debtors/list', params, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isLoading = false;
							vm.numOfRecord = result.length;
							vm.debtorDataFull = result;

							toastr.success('The Customer [<b>' + debtorName + '</b>] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
						vm.isLoading = false;
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Debtor [' + debtorName + '].', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
    function DebtorsCreateCtrl($scope, $state, $uibModal, $timeout, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.submitted = false;
		vm.mode = 1;
		vm.debtor = {};
		vm.debtor.active = true;
		vm.debtor.debtorBranches = [];
		vm.categories = [];
		vm.customerServiceUsers = [];
		vm.selectedCustomerCategory = null;
		vm.selectedCustomerService = null;
		vm.isDeliveryWindowEnabled = Auth.getSetting_DeliveryOrder_EnableDeliveryWindow();
		vm.integrationMode = Auth.getIntegrationMode();
		vm.hasAutoCountFields = vm.integrationMode == 2 && Auth.autoCount_EnableSync_Debtor();
		vm.hasSQLFields = vm.integrationMode == 8 && Auth.sqL_EnableSync_Debtor();
		vm.autoCount_DebtorTypes = [];
		vm.autoCount_ControlAccounts = [];
		vm.autoCount_CurrencyCodes = [];
		vm.autoCount_DisplayTerms = [];
		vm.autoCount_AreaCodes = [];
		vm.autoCount_PriceCategories = [];
		vm.autoCount_SalesAgents = [];
		vm.lockButtons = false;
		vm.autoCode = false;
		vm.originalLat = null;
		vm.originalLng = null;
		vm.sqlFields = {};

		/* ***************************************************************** */

		vm.initData = function() {

			vm.loadCategories();

			if(vm.hasAutoCountFields) {
				vm.loadAutoCountCreditTypes();
			} else if (vm.hasSQLFields) {
				vm.loadSQLFields();
			}
		}

		vm.autoCodeChanged = function() {
			if(vm.autoCode)
			{
				vm.debtor.code = null;
			}
		}

        vm.sameAsBillingAddress = function () {
            if (vm.isSameAsBilling) {
                vm.debtor.deliveryAddress1 = vm.debtor.address1;
                vm.debtor.deliveryAddress2 = vm.debtor.address2;
                vm.debtor.deliveryAddress3 = vm.debtor.address3;
                vm.debtor.deliveryState = vm.debtor.state;
                vm.debtor.deliveryPostCode = vm.debtor.postCode;
                vm.debtor.deliveryCountry = vm.debtor.country;
            } else {
                vm.debtor.deliveryAddress1 = '';
                vm.debtor.deliveryAddress2 = '';
                vm.debtor.deliveryAddress3 = '';
                vm.debtor.deliveryState = '';
                vm.debtor.deliveryPostCode = '';
                vm.debtor.deliveryCountry = '';
            }
        };

        vm.sameAsBillingContactPerson1 = function () {
            if (vm.isSameAsBillingContactPerson1) {
                vm.debtor.deliveryContactPerson1 = vm.debtor.contactPerson1;
                vm.debtor.deliveryPhone1 = vm.debtor.phone1;
                vm.debtor.deliveryFax1 = vm.debtor.fax1;
                vm.debtor.deliveryEmail1 = vm.debtor.email1;
            } else {
                vm.debtor.deliveryContactPerson1 = '';
                vm.debtor.deliveryPhone1 = '';
                vm.debtor.deliveryFax1 = '';
                vm.debtor.deliveryEmail1 = '';
            }
        };

        vm.sameAsBillingContactPerson2 = function () {
            if (vm.isSameAsBillingContactPerson2) {
                vm.debtor.deliveryContactPerson2 = vm.debtor.contactPerson2;
                vm.debtor.deliveryPhone2 = vm.debtor.phone2;
                vm.debtor.deliveryFax2 = vm.debtor.fax2;
                vm.debtor.deliveryEmail2 = vm.debtor.email2;
            } else {
                vm.debtor.deliveryContactPerson2 = '';
                vm.debtor.deliveryPhone2 = '';
                vm.debtor.deliveryFax2 = '';
                vm.debtor.deliveryEmail2 = '';
            }
        };

        /* ***************************************************************** */

        $scope.$watchGroup([
            'vm.debtor.address1',
            'vm.debtor.address2',
            'vm.debtor.address3',
            'vm.debtor.state',
            'vm.debtor.postCode',
            'vm.debtor.country',
            'vm.debtor.deliveryAddress1',
            'vm.debtor.deliveryAddress2',
            'vm.debtor.deliveryAddress3',
            'vm.debtor.deliveryState',
            'vm.debtor.deliveryPostCode',
            'vm.debtor.deliveryCountry'
        ], function (newValues, oldValues) {
            checkIfSameAsBilling();
		});

		$scope.$watch('vm.isSameAsBilling', function (newValue, oldValue) {
			if (newValue === true) {
				setDeliveryAddressFields();
			}
		});
		
		function checkIfEqual(value1, value2) {
			return (value1 && value2 && value1 === value2);
		}

		function setDeliveryAddressFields() {
			vm.debtor.deliveryAddress1 = vm.debtor.address1;
			vm.debtor.deliveryAddress2 = vm.debtor.address2;
			vm.debtor.deliveryAddress3 = vm.debtor.address3;
			vm.debtor.deliveryState = vm.debtor.state;
			vm.debtor.deliveryPostCode = vm.debtor.postCode;
			vm.debtor.deliveryCountry = vm.debtor.country;
		}

		function checkIfSameAsBilling() {
			if (vm.isSameAsBilling) {
				// If isSameAsBilling is checked, set delivery fields to billing fields
				setDeliveryAddressFields();
			} else {
				// Otherwise, check if they are the same for manual changes
				if (checkIfEqual(vm.debtor.deliveryAddress1, vm.debtor.address1) &&
					checkIfEqual(vm.debtor.deliveryAddress2, vm.debtor.address2) &&
					checkIfEqual(vm.debtor.deliveryAddress3, vm.debtor.address3) &&
					checkIfEqual(vm.debtor.deliveryState, vm.debtor.state) &&
					checkIfEqual(vm.debtor.deliveryPostCode, vm.debtor.postCode) &&
					checkIfEqual(vm.debtor.deliveryCountry, vm.debtor.country)) {
					vm.isSameAsBilling = true;
				} else {
					vm.isSameAsBilling = false;
				}
			}
		}

        $scope.$watchGroup([
            'vm.debtor.contactPerson1',
            'vm.debtor.phone1',
            'vm.debtor.fax1',
            'vm.debtor.email1',
            'vm.debtor.deliveryContactPerson1',
            'vm.debtor.deliveryPhone1',
            'vm.debtor.deliveryFax1',
            'vm.debtor.deliveryEmail1',
        ], function (newValues, oldValues) {
            checkIfSameAsBillingContactPerson1();
		});
		
		$scope.$watch('vm.isSameAsBillingContactPerson1', function (newValue, oldValue) {
			if (newValue === true) {
				setContactPersonFields1();
			}
		});

		function setContactPersonFields1() {
			vm.debtor.deliveryContactPerson1 = vm.debtor.contactPerson1;
			vm.debtor.deliveryPhone1 = vm.debtor.phone1;
			vm.debtor.deliveryFax1 = vm.debtor.fax1;
			vm.debtor.deliveryEmail1 = vm.debtor.email1;
		}

		function checkIfSameAsBillingContactPerson1() {
			if (vm.isSameAsBillingContactPerson1) {
				setContactPersonFields1();
			} else {
				if (checkIfEqual(vm.debtor.deliveryContactPerson1, vm.debtor.contactPerson1)
					&& checkIfEqual(vm.debtor.deliveryPhone1, vm.debtor.phone1)
					&& checkIfEqual(vm.debtor.deliveryContactPerson1, vm.debtor.fax1)
					&& checkIfEqual(vm.debtor.deliveryFax1, vm.debtor.email1)) {
					vm.isSameAsBillingContactPerson1 = true;
				} else {
					vm.isSameAsBillingContactPerson1 = false;
				}
			}
        }

        $scope.$watchGroup([
            'vm.debtor.contactPerson2',
            'vm.debtor.phone2',
            'vm.debtor.fax2',
            'vm.debtor.email2',
            'vm.debtor.deliveryContactPerson2',
            'vm.debtor.deliveryPhone2',
            'vm.debtor.deliveryFax2',
            'vm.debtor.deliveryEmail2',
        ], function (newValues, oldValues) {
            checkIfSameAsBillingContactPerson2();
		});
		
		function setContactPersonFields2() {
			vm.debtor.deliveryContactPerson2 = vm.debtor.contactPerson2;
			vm.debtor.deliveryPhone2 = vm.debtor.phone2;
			vm.debtor.deliveryFax2 = vm.debtor.fax2;
			vm.debtor.deliveryEmail2 = vm.debtor.email2;
		}

        function checkIfSameAsBillingContactPerson2() {
			if (vm.isSameAsBillingContactPerson2) {
				setContactPersonFields2();
			} else {
				if (checkIfEqual(vm.debtor.deliveryContactPerson2, vm.debtor.contactPerson2)
					&& checkIfEqual(vm.debtor.deliveryPhone2, vm.debtor.phone2)
					&& checkIfEqual(vm.debtor.deliveryContactPerson2, vm.debtor.fax2)
					&& checkIfEqual(vm.debtor.deliveryFax2, vm.debtor.email2)) {
					vm.isSameAsBillingContactPerson2 = true;
				} else {
					vm.isSameAsBillingContactPerson2 = false;
				}
			}
        }

		/* ***************************************************************** */
		vm.loadSQLFields = function() {
			HttpSvc.get('sqlacc/maintenance/alllist/customer', {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.sqlFields = result;
				}, function() {
					toastr.error('Failed to load SQL Fields.', Auth.translate('ERROR'))
					return;
				});
		};

		vm.loadAutoCountCreditTypes = function() {
			HttpSvc.get('autocount/maintenance/list/debtortypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_DebtorTypes = result;
					vm.loadAutoCountControlAccounts();
				}, function() {
					toastr.error('Failed to load selected AutoCount Debtor Types.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		vm.loadAutoCountControlAccounts = function() {
			HttpSvc.get('autocount/maintenance/list/debtorcontrolaccounts', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_ControlAccounts = result;

					vm.loadAutoCountCurrencies();
				}, function() {
					toastr.error('Failed to load AutoCount Debtor Control Accounts.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		vm.loadAutoCountCurrencies = function() {
			HttpSvc.get('autocount/maintenance/list/currencies', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_CurrencyCodes = result;

					vm.loadAutoCountCreditTerms();
				}, function() {
					toastr.error('Failed to load AutoCount Currencies.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		vm.loadAutoCountCreditTerms = function() {
			HttpSvc.get('autocount/maintenance/list/creditterms', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_DisplayTerms = result;
					vm.loadAutoCountAreaCodes();
				}, function() {
					toastr.error('Failed to load AutoCount Credit Terms.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		vm.loadAutoCountAreaCodes = function() {
			HttpSvc.get('autocount/maintenance/list/areas', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_AreaCodes = result;
					vm.loadAutoCountPriceCategories();
				}, function() {
					toastr.error('Failed to load AutoCount Area Codes.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		vm.loadAutoCountPriceCategories = function() {
			HttpSvc.get('autocount/maintenance/list/pricecategories', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_PriceCategories = result;
					vm.loadAutoCountSalesAgents();
				}, function() {
					toastr.error('Failed to load AutoCount Price Categories.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		vm.loadAutoCountSalesAgents = function() {
			HttpSvc.get('autocount/maintenance/list/salesagents', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_SalesAgents = result;
				}, function() {
					toastr.error('Failed to load AutoCount Sales Agents.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		/* ***************************************************************** */

		vm.selectedDebtorTypeChanged = function() {
			vm.debtor.autoCount_DebtorType = vm.selectedDebtorType.code;
		}

		vm.selectedControlAccountChanged = function() {
			vm.debtor.autoCount_ControlAccount = vm.selectedControlAccount.accNo;
		}

		vm.selectedCurrencyCodeChanged = function() {
			vm.debtor.autoCount_CurrencyCode = vm.selectedCurrencyCode.currencyCode;
		}

		vm.selectedDisplayTermChanged = function() {
			vm.debtor.autoCount_DisplayTerm = vm.selectedDisplayTerm.displayTerm;
		}

		vm.selectedAreaCodeChanged = function() {
			vm.debtor.autoCount_AreaCode = vm.selectedAreaCode.areaCode;
		}

		vm.selectedPriceCategoryChanged = function() {
			vm.debtor.autoCount_PriceCategory = vm.selectedPriceCategory.code;
		}

		vm.selectedSalesAgentChanged = function() {
			vm.debtor.autoCount_SalesAgent = vm.selectedSalesAgent.code;
		}

		vm.selectedCompanyCategoryChanged = function() {
			vm.debtor.sqL_CategoryCode = vm.selectedCompanyCategory.CODE;
		}

		vm.selectedSQLControlAccountChanged = function() {
			vm.debtor.sqL_ControlAccount = vm.selectedSQLControlAccount.CODE;
		}

		vm.selectedSQLAgentChanged = function() {
			vm.debtor.sqL_AgentCode = vm.selectedSQLAgent.CODE;
		}

		vm.selectedSQLAreaCodeChanged = function() {
			vm.debtor.sqL_AreaCode = vm.selectedSQLAreaCode.CODE;
		}

		vm.selectedSQLCurrencyChanged = function() {
			vm.debtor.sqL_CurrencyCode = vm.selectedSQLCurrencyCode.CODE;
		}

		vm.selectedSQLTermChanged = function() {
			vm.debtor.sqL_CreditTerm = vm.selectedSQLTerm.CODE;
		}
		/* ***************************************************************** */

		// Load Debtor Categories
		vm.loadCategories = function() {
			HttpSvc.get('debtorcategories/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.categories = result;
					vm.loadCustomerServiceUsers();
				}, function() {
					toastr.error('Failed to load selected Customer Categories.', Auth.translate('ERROR'))
					$state.go('maintenance.debtors.list');
					return;
				});
		};

		// Load Customer Seervice Users
		vm.loadCustomerServiceUsers = function() {
			HttpSvc.get('users/list/customerservices', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.customerServiceUsers = result;
                    $timeout(vm.loadMap, 1000);
				}, function() {
					toastr.error('Failed to load selected Customer Service Officers.', Auth.translate('ERROR'))
					$state.go('maintenance.debtors.list');
					return;
				});
		};

		// **********************************************

		// Select Debtor Category
		vm.selectedCustomerCategoryChanged = function() {
			vm.debtor.debtorCategoryId = vm.selectedCustomerCategory.id;
		};

		// Select Customer Service Officer
		vm.selectedCustomerServiceChanged = function() {
			vm.debtor.customerServiceUserId = vm.selectedCustomerService.id;
		};

		// **********************************************

		vm.showAddBranchModal = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'branchModal.html',
				controller: 'DebtorsBranchModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: {},
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addBranch(data);
				}, function () {
				});
		};

		vm.showEditBranchModal = function (index) {

			var branch = angular.copy(vm.debtor.debtorBranches[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'branchModal.html',
				controller: 'DebtorsBranchModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: branch,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateBranch(index, data);
				}, function () {
				});
		};

		// **********************************************

		// Remove Branch
		vm.removeBranch = function(index) {
			vm.debtor.debtorBranches.splice(index, 1);
			$scope.$apply();
		};

		// Update Branch
		vm.updateBranch = function(index, obj) {
			var element = {
				id: obj.id,
				debtorId: obj.debtorId,
				code: obj.code,
				name: obj.name,
				address1: obj.address1,
				address2: obj.address2,
				address3: obj.address3,
				state: obj.state,
				postCode: obj.postCode,
				country: obj.country,
				contactPerson: obj.contactPerson,
				phone: obj.phone,
				fax: obj.fax,
				email: obj.email,
				remarks: obj.remarks,
				gpsLat: obj.gpsLat,
				gpsLng: obj.gpsLng,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
				modifiedBy: obj.modifiedBy,
				modifiedDate: obj.modifiedDate,
			};

			vm.debtor.debtorBranches.splice(index, 1, element);
		};

		// Add Branch
		vm.addBranch = function(obj) {
			var element = {
				code: obj.code,
				name: obj.name,
				address1: obj.address1,
				address2: obj.address2,
				address3: obj.address3,
				state: obj.state,
				postCode: obj.postCode,
				country: obj.country,
				contactPerson: obj.contactPerson,
				phone: obj.phone,
				fax: obj.fax,
				email: obj.email,
				remarks: obj.remarks,
				gpsLat: obj.gpsLat,
				gpsLng: obj.gpsLng,
			};

			vm.debtor.debtorBranches.push(element);
		};

		// **********************************************

        function isValidEmail(email) {
            var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        }

        function isValidPhone(phone) {
            var e164Pattern = /^\+?[1-9]\d{1,14}$/; // E.164 format
            var malaysiaPattern = /^\d{3}-\d{7}$/; // Malaysian phone number format XXX-XXXXXXX
            return e164Pattern.test(phone) || malaysiaPattern.test(phone);
        }

        /* ************************************************************* */

		// Form Submission
		vm.submit = function() {

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
            } else {
                

				vm.lockButtons = true;

				vm.debtor.companyId = Auth.getCompanyId();

				HttpSvc.post('debtors', vm.debtor, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkResult = function(result) {
			if(result.httpStatusCode=="200")
			{
				toastr.success('Customer has been created successfully.', Auth.translate('SUCCESS'));
				$state.go('maintenance.debtors.update', {'id': result.id });
			}
			else
			{
				vm.lockButtons = false;
				toastr.error(result.message, 'Failed');
			}
		}

		// **********************************************

		//var infoWindow = new google.maps.InfoWindow();

        vm.loadMap = function() {

			var lat = vm.debtor.gpsLat || 3.1377664033531656;
			var lng = vm.debtor.gpsLng || 101.68700791600979;

			var mapOptions = {
				center: {
					'lat': lat,
					'lng': lng
				}, // Malaysia
				fullscreenControl: false,
				mapTypeControl: false,
				streetViewControl: false,
				clickableIcons: false,
				zoom: 14,
                zoomControlOptions: {
					position: google.maps.ControlPosition.RIGHT_BOTTOM,
				}
			};

			// Map object
			var map = new google.maps.Map(document.getElementById('googleMap'), mapOptions);

			var markers = [];

			var newMarker = new google.maps.Marker({
				position: { lat: lat, lng: lng },
				map: map,
				title: "Here!", // Customize the marker title
			});

			// Add the new marker to the array
			markers.push(newMarker);

			// Add CLICK event
			map.addListener("click", function(event) {
				var latitude = event.latLng.lat();
				var longitude = event.latLng.lng();

				vm.debtor.gpsLat = latitude;
				vm.debtor.gpsLng = longitude;

				$scope.$apply();

				// Remove existing markers
				markers.forEach(function(marker) {
					marker.setMap(null);
				});
				markers.length = 0; // Clear the array

				// Create a marker at the obtained coordinates
				var newMarker = new google.maps.Marker({
					position: { lat: latitude, lng: longitude },
					map: map,
					title: "Here!", // Customize the marker title
				});

				// Add the new marker to the array
				markers.push(newMarker);

				// Display the coordinates in an info window
				// infoWindow.setContent(`<b>Coordinates</b><br /><br />Lat: ${latitude},<br />Lng: ${longitude}`);
				// infoWindow.setPosition(event.latLng);
				// infoWindow.open(map);
			});
		}

		vm.getLatLng = function() {
			// Initialize the geocoder
			var geocoder = new google.maps.Geocoder();

            // Check each address component, if null or undefined, return an empty string
            var address1 = vm.debtor.deliveryAddress1 ? vm.debtor.deliveryAddress1 : "";
            var address2 = vm.debtor.deliveryAddress2 ? vm.debtor.deliveryAddress2 : "";
            var address3 = vm.debtor.deliveryAddress3 ? vm.debtor.deliveryAddress3 : "";
            var postCode = vm.debtor.deliveryPostCode ? vm.debtor.deliveryPostCode : "";
            var country = vm.debtor.deliveryCountry ? vm.debtor.deliveryCountry : "";

			// Get the address from user input (replace 'txtAddress' with your input field ID)
            var address = address1 + " " + address2 + " " + address3 + " " + postCode + " " + country;

			// Geocode the address
			geocoder.geocode({ address: address }, function(results, status) {
				if (status === google.maps.GeocoderStatus.OK) {
					var latitude = results[0].geometry.location.lat();
					var longitude = results[0].geometry.location.lng();

					vm.debtor.gpsLat = latitude;
					vm.debtor.gpsLng = longitude;

					$scope.$apply();

					vm.loadMap();
				} else {
					toastr.warning("Unable to get the Latitude and Longitude. Please check the address.");
				}
			});
		}

		// **********************************************

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
    function DebtorsUpdateCtrl($scope, $state, $stateParams, $uibModal, $timeout, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;
		vm.mode = 2;
		vm.isSameAsBilling = false;
		vm.debtor = {};
		vm.debtor.debtorBranches = [];
		vm.categories = [];
		vm.changeLogs = [];
		vm.customerServiceUsers = [];
		vm.selectedCustomerCategory = null;
		vm.selectedCustomerService = null;
		vm.isDeliveryWindowEnabled = Auth.getSetting_DeliveryOrder_EnableDeliveryWindow();
		vm.integrationMode = Auth.getIntegrationMode();
		vm.hasAutoCountFields = vm.integrationMode == 2 && Auth.autoCount_EnableSync_Debtor();
		vm.hasSQLFields = vm.integrationMode == 8 && Auth.sqL_EnableSync_Debtor();
		vm.autoCount_DebtorTypes = [];
		vm.autoCount_ControlAccounts = [];
		vm.autoCount_CurrencyCodes = [];
		vm.autoCount_DisplayTerms = [];
		vm.autoCount_AreaCodes = [];
		vm.autoCount_PriceCategories = [];
		vm.autoCount_SalesAgents = [];
		vm.lockButtons = false;
		vm.autoCode = false;
		vm.originalLat = null;
		vm.originalLng = null;
        vm.isAfterSalesEnabled = Auth.isAfterSalesEnabled();
		vm.sqlFields = {};

		/* ***************************************************************** */

		vm.initData = function() {

			if(vm.hasAutoCountFields) {
				vm.loadAutoCountCreditTypes();
			}
			else if (vm.hasSQLFields) {
				vm.loadSQLFields();
			} else
			{
				vm.loadCategories();
			}

		}

		vm.autoCodeChanged = function() {
			if(vm.autoCode)
			{
				vm.debtor.code = null;
			}
		}

        vm.sameAsBillingAddress = function () {
            if (vm.isSameAsBilling) {
                vm.debtor.deliveryAddress1 = vm.debtor.address1;
                vm.debtor.deliveryAddress2 = vm.debtor.address2;
                vm.debtor.deliveryAddress3 = vm.debtor.address3;
                vm.debtor.deliveryState = vm.debtor.state;
                vm.debtor.deliveryPostCode = vm.debtor.postCode;
                vm.debtor.deliveryCountry = vm.debtor.country;
			}
			else {
                vm.debtor.deliveryAddress1 = '';
                vm.debtor.deliveryAddress2 = '';
                vm.debtor.deliveryAddress3 = '';
                vm.debtor.deliveryState = '';
                vm.debtor.deliveryPostCode = '';
                vm.debtor.deliveryCountry = '';
            }
        };

        vm.sameAsBillingContactPerson1 = function () {
            if (vm.isSameAsBillingContactPerson1) {
                vm.debtor.deliveryContactPerson1 = vm.debtor.contactPerson1;
                vm.debtor.deliveryPhone1 = vm.debtor.phone1;
                vm.debtor.deliveryFax1 = vm.debtor.fax1;
                vm.debtor.deliveryEmail1 = vm.debtor.email1;
            } else {
                vm.debtor.deliveryContactPerson1 = '';
                vm.debtor.deliveryPhone1 = '';
                vm.debtor.deliveryFax1 = '';
                vm.debtor.deliveryEmail1 = '';
            }
        };

        vm.sameAsBillingContactPerson2 = function () {
            if (vm.isSameAsBillingContactPerson2) {
                vm.debtor.deliveryContactPerson2 = vm.debtor.contactPerson2;
                vm.debtor.deliveryPhone2 = vm.debtor.phone2;
                vm.debtor.deliveryFax2 = vm.debtor.fax2;
                vm.debtor.deliveryEmail2 = vm.debtor.email2;
            } else {
                vm.debtor.deliveryContactPerson2 = '';
                vm.debtor.deliveryPhone2 = '';
                vm.debtor.deliveryFax2 = '';
                vm.debtor.deliveryEmail2 = '';
            }
        };

        /* ***************************************************************** */

        $scope.$watchGroup([
            'vm.debtor.address1',
            'vm.debtor.address2',
            'vm.debtor.address3',
            'vm.debtor.state',
            'vm.debtor.postCode',
            'vm.debtor.country',
            'vm.debtor.deliveryAddress1',
            'vm.debtor.deliveryAddress2',
            'vm.debtor.deliveryAddress3',
            'vm.debtor.deliveryState',
            'vm.debtor.deliveryPostCode',
            'vm.debtor.deliveryCountry'
        ], function (newValues, oldValues) {
            checkIfSameAsBilling();
        });

		$scope.$watch('vm.isSameAsBilling', function (newValue, oldValue) {
			if (newValue === true) {
				setDeliveryAddressFields();
			}
		});
		
		function checkIfEqual(value1, value2) {
			return (value1 && value2 && value1 === value2);
		}

		function setDeliveryAddressFields() {
			vm.debtor.deliveryAddress1 = vm.debtor.address1;
			vm.debtor.deliveryAddress2 = vm.debtor.address2;
			vm.debtor.deliveryAddress3 = vm.debtor.address3;
			vm.debtor.deliveryState = vm.debtor.state;
			vm.debtor.deliveryPostCode = vm.debtor.postCode;
			vm.debtor.deliveryCountry = vm.debtor.country;
		}

		function checkIfSameAsBilling() {
			if (vm.isSameAsBilling) {
				// If isSameAsBilling is checked, set delivery fields to billing fields
				setDeliveryAddressFields();
			} else {
				// Otherwise, check if they are the same for manual changes
				if (checkIfEqual(vm.debtor.deliveryAddress1, vm.debtor.address1) &&
					checkIfEqual(vm.debtor.deliveryAddress2, vm.debtor.address2) &&
					checkIfEqual(vm.debtor.deliveryAddress3, vm.debtor.address3) &&
					checkIfEqual(vm.debtor.deliveryState, vm.debtor.state) &&
					checkIfEqual(vm.debtor.deliveryPostCode, vm.debtor.postCode) &&
					checkIfEqual(vm.debtor.deliveryCountry, vm.debtor.country)) {
					vm.isSameAsBilling = true;
				} else {
					vm.isSameAsBilling = false;
				}
			}
		}

        $scope.$watchGroup([
            'vm.debtor.contactPerson1',
            'vm.debtor.phone1',
            'vm.debtor.fax1',
            'vm.debtor.email1',
            'vm.debtor.deliveryContactPerson1',
            'vm.debtor.deliveryPhone1',
            'vm.debtor.deliveryFax1',
            'vm.debtor.deliveryEmail1',
        ], function (newValues, oldValues) {
            checkIfSameAsBillingContactPerson1();
        });

        function setContactPersonFields1() {
			vm.debtor.deliveryContactPerson1 = vm.debtor.contactPerson1;
			vm.debtor.deliveryPhone1 = vm.debtor.phone1;
			vm.debtor.deliveryFax1 = vm.debtor.fax1;
			vm.debtor.deliveryEmail1 = vm.debtor.email1;
		}

		function checkIfSameAsBillingContactPerson1() {
			if (vm.isSameAsBillingContactPerson1) {
				setContactPersonFields1();
			} else {
				if (checkIfEqual(vm.debtor.deliveryContactPerson1, vm.debtor.contactPerson1)
					&& checkIfEqual(vm.debtor.deliveryPhone1, vm.debtor.phone1)
					&& checkIfEqual(vm.debtor.deliveryContactPerson1, vm.debtor.fax1)
					&& checkIfEqual(vm.debtor.deliveryFax1, vm.debtor.email1)) {
					vm.isSameAsBillingContactPerson1 = true;
				} else {
					vm.isSameAsBillingContactPerson1 = false;
				}
			}
        }

        $scope.$watchGroup([
            'vm.debtor.contactPerson2',
            'vm.debtor.phone2',
            'vm.debtor.fax2',
            'vm.debtor.email2',
            'vm.debtor.deliveryContactPerson2',
            'vm.debtor.deliveryPhone2',
            'vm.debtor.deliveryFax2',
            'vm.debtor.deliveryEmail2',
        ], function (newValues, oldValues) {
            checkIfSameAsBillingContactPerson2();
        });

        function setContactPersonFields2() {
			vm.debtor.deliveryContactPerson2 = vm.debtor.contactPerson2;
			vm.debtor.deliveryPhone2 = vm.debtor.phone2;
			vm.debtor.deliveryFax2 = vm.debtor.fax2;
			vm.debtor.deliveryEmail2 = vm.debtor.email2;
		}

        function checkIfSameAsBillingContactPerson2() {
			if (vm.isSameAsBillingContactPerson2) {
				setContactPersonFields2();
			} else {
				if (checkIfEqual(vm.debtor.deliveryContactPerson2, vm.debtor.contactPerson2)
					&& checkIfEqual(vm.debtor.deliveryPhone2, vm.debtor.phone2)
					&& checkIfEqual(vm.debtor.deliveryContactPerson2, vm.debtor.fax2)
					&& checkIfEqual(vm.debtor.deliveryFax2, vm.debtor.email2)) {
					vm.isSameAsBillingContactPerson2 = true;
				} else {
					vm.isSameAsBillingContactPerson2 = false;
				}
			}
        }

		/* ***************************************************************** */
		
		vm.loadSQLFields = function() {
			HttpSvc.get('sqlacc/maintenance/alllist/customer', {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.sqlFields = result;
					vm.loadCategories();
				}, function() {
					toastr.error('Failed to load SQL Fields.', Auth.translate('ERROR'))
					return;
				});
		};

		vm.loadAutoCountCreditTypes = function() {
			HttpSvc.get('autocount/maintenance/list/debtortypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_DebtorTypes = result;
					vm.loadAutoCountControlAccounts();
				}, function() {
					toastr.error('Failed to load selected AutoCount Debtor Types.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		vm.loadAutoCountControlAccounts = function() {
			HttpSvc.get('autocount/maintenance/list/debtorcontrolaccounts', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_ControlAccounts = result;
					vm.loadAutoCountCurrencies();
				}, function() {
					toastr.error('Failed to load AutoCount Debtor Control Accounts.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		vm.loadAutoCountCurrencies = function() {
			HttpSvc.get('autocount/maintenance/list/currencies', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_CurrencyCodes = result;
					vm.loadAutoCountCreditTerms();
				}, function() {
					toastr.error('Failed to load AutoCount Currencies.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		vm.loadAutoCountCreditTerms = function() {
			HttpSvc.get('autocount/maintenance/list/creditterms', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_DisplayTerms = result;
					vm.loadAutoCountAreaCodes();
				}, function() {
					toastr.error('Failed to load AutoCount Credit Terms.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		vm.loadAutoCountAreaCodes = function() {
			HttpSvc.get('autocount/maintenance/list/areas', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_AreaCodes = result;
					vm.loadAutoCountPriceCategories();
				}, function() {
					toastr.error('Failed to load AutoCount Area Codes.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		vm.loadAutoCountPriceCategories = function() {
			HttpSvc.get('autocount/maintenance/list/pricecategories', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_PriceCategories = result;
					vm.loadAutoCountSalesAgents();
				}, function() {
					toastr.error('Failed to load AutoCount Price Categories.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		vm.loadAutoCountSalesAgents = function() {
			HttpSvc.get('autocount/maintenance/list/salesagents', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_SalesAgents = result;
					vm.loadCategories();
				}, function() {
					toastr.error('Failed to load AutoCount Sales Agents.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};

		/* ***************************************************************** */

		vm.selectedDebtorTypeChanged = function() {
			vm.debtor.autoCount_DebtorType = vm.selectedDebtorType.code;
		}

		vm.selectedControlAccountChanged = function() {
			vm.debtor.autoCount_ControlAccount = vm.selectedControlAccount.accNo;
		}

		vm.selectedCurrencyCodeChanged = function() {
			vm.debtor.autoCount_CurrencyCode = vm.selectedCurrencyCode.currencyCode;
		}

		vm.selectedDisplayTermChanged = function() {
			vm.debtor.autoCount_DisplayTerm = vm.selectedDisplayTerm.displayTerm;
		}

		vm.selectedAreaCodeChanged = function() {
			vm.debtor.autoCount_AreaCode = vm.selectedAreaCode.areaCode;
		}

		vm.selectedPriceCategoryChanged = function() {
			vm.debtor.autoCount_PriceCategory = vm.selectedPriceCategory.code;
		}

		vm.selectedSalesAgentChanged = function() {
			vm.debtor.autoCount_SalesAgent = vm.selectedSalesAgent.code;
		}

		vm.selectedCompanyCategoryChanged = function() {
			vm.debtor.sqL_CategoryCode = vm.selectedCompanyCategory.CODE;
		}

		vm.selectedSQLControlAccountChanged = function() {
			vm.debtor.sqL_ControlAccount = vm.selectedSQLControlAccount.CODE;
		}

		vm.selectedSQLAgentChanged = function() {
			vm.debtor.sqL_AgentCode = vm.selectedSQLAgent.CODE;
		}

		vm.selectedSQLAreaCodeChanged = function() {
			vm.debtor.sqL_AreaCode = vm.selectedSQLAreaCode.CODE;
		}

		vm.selectedSQLCurrencyChanged = function() {
			vm.debtor.sqL_CurrencyCode = vm.selectedSQLCurrencyCode.CODE;
		}

		vm.selectedSQLTermChanged = function() {
			vm.debtor.sqL_CreditTerm = vm.selectedSQLTerm.CODE;
		}
		/* ***************************************************************** */

		// Load Debtor Categories
		vm.loadCategories = function() {
			HttpSvc.get('debtorcategories/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.categories = result;
					vm.loadCustomerServiceUsers();
				}, function() {
					toastr.error('Failed to load selected Customer Categories.', Auth.translate('ERROR'))
					$state.go('maintenance.debtors.list');
					return;
				});
		};

		// Load Customer Seervice Users
		vm.loadCustomerServiceUsers = function() {
			HttpSvc.get('users/list/customerservices', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.customerServiceUsers = result;
					vm.loadDebtor();
				}, function() {
					toastr.error('Failed to load selected Customer Service Officers.', Auth.translate('ERROR'))
					$state.go('maintenance.debtors.list');
					return;
				});
		};

		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('debtorchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.changeLogs = result;

                    $timeout(vm.loadMap, 1000);
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};

		// Load Debtors
		vm.loadDebtor = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('debtors/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.debtor = result;
					vm.originalLat = vm.debtor.gpsLat;
					vm.originalLng = vm.debtor.gpsLng;

					vm.categories.forEach(function(c) {
						if(c.id==vm.debtor.debtorCategoryId) {
							vm.selectedCustomerCategory = c;
						}
					});

					vm.customerServiceUsers.forEach(function(c) {
						if(c.id==vm.debtor.customerServiceUserId) {
							vm.selectedCustomerService = c;
						}
					});

					vm.autoCount_DebtorTypes.forEach(function(d) {
						if(vm.debtor.autoCount_DebtorType == d.code){
							vm.selectedDebtorType = d;
						}
					});

					vm.autoCount_ControlAccounts.forEach(function(c) {
						if(vm.debtor.autoCount_ControlAccount == c.accNo){
							vm.selectedControlAccount = c;
						}
					});

					vm.autoCount_CurrencyCodes.forEach(function(c) {
						if(vm.debtor.autoCount_CurrencyCode == c.currencyCode){
							vm.selectedCurrencyCode = c;
						}
					});

					vm.autoCount_DisplayTerms.forEach(function(c) {
						if(vm.debtor.autoCount_DisplayTerm == c.displayTerm){
							vm.selectedDisplayTerm = c;
						}
					});

					vm.autoCount_AreaCodes.forEach(function(c) {
						if(vm.debtor.autoCount_AreaCode == c.areaCode){
							vm.selectedAreaCode = c;
						}
					});

					vm.autoCount_PriceCategories.forEach(function(c) {
						if(vm.debtor.autoCount_PriceCategory == c.code){
							vm.selectedPriceCategory = c;
						}
					});

					vm.autoCount_SalesAgents.forEach(function(c) {
						if(vm.debtor.autoCount_SalesAgent == c.code){
							vm.selectedSalesAgent = c;
						}
					});

					vm.sqlFields.SQL_Maintenance_CompanyCategory.forEach(function(c) {
						if(vm.debtor.sqL_CategoryCode == c.CODE){
							vm.selectedCompanyCategory = c;
						}
					});

					vm.sqlFields.SQL_Customer_ControlAccount.forEach(function(c) {
						if(vm.debtor.sqL_ControlAccount == c.CODE){
							vm.selectedSQLControlAccount = c;
						}
					});

					vm.sqlFields.SQL_Maintenance_Area.forEach(function(c) {
						if(vm.debtor.sqL_AreaCode == c.CODE){
							vm.selectedSQLAreaCode = c;
						}
					});
					
					vm.sqlFields.SQL_Maintenance_Agent.forEach(function(c) {
						if(vm.debtor.sqL_AgentCode == c.CODE){
							vm.selectedSQLAgent = c;
						}
					});

					vm.sqlFields.SQL_Maintenance_Currency.forEach(function (c) {
						if(vm.debtor.sqL_CurrencyCode == c.CODE){
							vm.selectedSQLCurrencyCode = c;
						}
					});

					vm.sqlFields.SQL_Maintenance_Terms.forEach(function (c) {
						if(vm.debtor.sqL_CreditTerm == c.CODE){
							vm.selectedSQLTerm = c;
						}
					});

                    checkIfSameAsBilling();
                    checkIfSameAsBillingContactPerson1();
                    checkIfSameAsBillingContactPerson2();

					vm.loadChangeLogs();

				}, function() {
					toastr.error('Failed to load selected Customer.', Auth.translate('ERROR'))
					$state.go('maintenance.debtors.list');
					return;
				});
		};
		vm.debtor.debtorBranches = [];

		// **********************************************

		// Select Debtor Category
		vm.selectedCustomerCategoryChanged = function() {
			vm.debtor.debtorCategoryId = vm.selectedCustomerCategory.id;
		};

		// Select Customer Service Officer
		vm.selectedCustomerServiceChanged = function() {
			vm.debtor.customerServiceUserId = vm.selectedCustomerService.id;
		};

		// **********************************************

		vm.showAddBranchModal = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'branchModal.html',
				controller: 'DebtorsBranchModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: {},
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addBranch(data);
				}, function () {
				});
		};

		vm.showEditBranchModal = function (index) {

			var branch = angular.copy(vm.debtor.debtorBranches[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'branchModal.html',
				controller: 'DebtorsBranchModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: branch,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateBranch(index, data);
				}, function () {
				});
		};

		// **********************************************

		// Remove Branch
		vm.removeBranch = function(index) {
			vm.debtor.debtorBranches.splice(index, 1);
			$scope.$apply();
		};

		// Update Branch
		vm.updateBranch = function(index, obj) {
			var element = {
				id: obj.id,
				code: obj.code,
				debtorId: obj.debtorId,
				name: obj.name,
				address1: obj.address1,
				address2: obj.address2,
				address3: obj.address3,
				state: obj.state,
				postCode: obj.postCode,
				country: obj.country,
				contactPerson: obj.contactPerson,
				phone: obj.phone,
				fax: obj.fax,
				email: obj.email,
				remarks: obj.remarks,
				gpsLat: obj.gpsLat,
				gpsLng: obj.gpsLng,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
				modifiedBy: obj.modifiedBy,
				modifiedDate: obj.modifiedDate,
			};

			vm.debtor.debtorBranches.splice(index, 1, element);
		};

		// Add Branch
		vm.addBranch = function(obj) {
			var element = {
				code: obj.code,
				name: obj.name,
				address1: obj.address1,
				address2: obj.address2,
				address3: obj.address3,
				state: obj.state,
				postCode: obj.postCode,
				country: obj.country,
				contactPerson: obj.contactPerson,
				phone: obj.phone,
				fax: obj.fax,
				email: obj.email,
				remarks: obj.remarks,
				gpsLat: obj.gpsLat,
				gpsLng: obj.gpsLng,
			};

			vm.debtor.debtorBranches.push(element);
		};

        /* ***************************************************************** */

        function isValidEmail(email) {
            var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        }

        function isValidPhone(phone) {
            var e164Pattern = /^\+?[1-9]\d{1,14}$/; // E.164 format
            var malaysiaPattern = /^\d{3}-\d{7}$/; // Malaysian phone number format XXX-XXXXXXX
            return e164Pattern.test(phone) || malaysiaPattern.test(phone);
        }

        function getContactPerson() {
            var contactPerson = null;
            if (vm.debtor.contactPerson1) {
                if (!vm.debtor.email1 || !vm.debtor.phone1) {
                    toastr.error(
                        "Contact person #1 email and phone number are required."
                    );
                    return null;
                }

                contactPerson = {
                    name: vm.debtor.contactPerson1,
                    phone: vm.debtor.phone1,
                    email: vm.debtor.email1,
                };
            } else if (vm.debtor.contactPerson2) {
                if (!vm.debtor.email2 || !vm.debtor.phone2) {
                    toastr.error(
                        "Contact person #2 email and phone number are required."
                    );
                    return null;
                }

                contactPerson = {
                    name: vm.debtor.contactPerson2,
                    phone: vm.debtor.phone2,
                    email: vm.debtor.email2,
                };
            } else {
                toastr.error("At least one contact person is required.");
                return null;
            }
            return contactPerson;
        }

        vm.registerFreeAMSAccount = function () {
            if (!vm.debtor.name) {
                toastr.error("Customer name is required.");
                return;
            }

            var contactPerson = getContactPerson();
            if (!contactPerson) {
                return;
            }

            var names = contactPerson.name.split(" ");
            var userFirstName = names[0];
            var userLastName = names.slice(1).join(" ");

            var postData = {
                companyName: vm.debtor.name,
                userFirstName: userFirstName,
                userLastName: userLastName,
                userPhone: contactPerson.phone,
                userEmail: contactPerson.email,
                source: "APP",
                country: (vm.debtor.country || '').toUpperCase(),
            };

            HttpSvc.post("subscriptions/appsignup", postData, Auth.getTokenId(), true)
                .then(
                    function (response) {
                        toastr.success("The Customer [" + vm.debtor.name + "] has been successfully registered.");
                    },
                    function (error) {
                        toastr.error("Failed to register the Customer." + error, Auth.translate('ERROR'));
                    }
                );
        };

		// **********************************************

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
            } else {
                
				vm.lockButtons = true;

				HttpSvc.put('debtors/' + $stateParams.id, vm.debtor, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkResult = function(result) {
			if(result.httpStatusCode=="200")
			{
				toastr.success('Customer has been updated successfully.', Auth.translate('SUCCESS'));
				$state.reload();
			}
			else
			{
				vm.lockButtons = false;
				toastr.error(result.message, 'Failed');
			}
		}

		// **********************************************

		//var infoWindow = new google.maps.InfoWindow();

        vm.loadMap = function() {

			var lat = vm.debtor.gpsLat || 3.1377664033531656;
			var lng = vm.debtor.gpsLng || 101.68700791600979;

			var mapOptions = {
				center: {
					'lat': lat,
					'lng': lng
				}, // Malaysia
				fullscreenControl: false,
				mapTypeControl: false,
				streetViewControl: false,
				clickableIcons: false,
				zoom: 14,
                zoomControlOptions: {
					position: google.maps.ControlPosition.RIGHT_BOTTOM,
				}
			};

			// Map object
			var map = new google.maps.Map(document.getElementById('googleMap'), mapOptions);

			var markers = [];

			var newMarker = new google.maps.Marker({
				position: { lat: lat, lng: lng },
				map: map,
				title: "Here!", // Customize the marker title
			});

			// Add the new marker to the array
			markers.push(newMarker);

			// Add CLICK event
			map.addListener("click", function(event) {
				var latitude = event.latLng.lat();
				var longitude = event.latLng.lng();

				vm.debtor.gpsLat = latitude;
				vm.debtor.gpsLng = longitude;

				$scope.$apply();

				// Remove existing markers
				markers.forEach(function(marker) {
					marker.setMap(null);
				});
				markers.length = 0; // Clear the array

				// Create a marker at the obtained coordinates
				var newMarker = new google.maps.Marker({
					position: { lat: latitude, lng: longitude },
					map: map,
					title: "Here!", // Customize the marker title
				});

				// Add the new marker to the array
				markers.push(newMarker);

				// Display the coordinates in an info window
				// infoWindow.setContent(`<b>Coordinates</b><br /><br />Lat: ${latitude},<br />Lng: ${longitude}`);
				// infoWindow.setPosition(event.latLng);
				// infoWindow.open(map);
			});
		}

		vm.getLatLng = function() {
			// Initialize the geocoder
			var geocoder = new google.maps.Geocoder();

            // Check each address component, if null or undefined, return an empty string
            var address1 = vm.debtor.deliveryAddress1 ? vm.debtor.deliveryAddress1 : "";
            var address2 = vm.debtor.deliveryAddress2 ? vm.debtor.deliveryAddress2 : "";
            var address3 = vm.debtor.deliveryAddress3 ? vm.debtor.deliveryAddress3 : "";
            var postCode = vm.debtor.deliveryPostCode ? vm.debtor.deliveryPostCode : "";
            var country = vm.debtor.deliveryCountry ? vm.debtor.deliveryCountry : "";

            // Get the address from user input (replace 'txtAddress' with your input field ID)
            var address = address1 + " " + address2 + " " + address3 + " " + postCode + " " + country;

            // Geocode the address
			geocoder.geocode({ address: address }, function(results, status) {
				if (status === google.maps.GeocoderStatus.OK) {
					var latitude = results[0].geometry.location.lat();
					var longitude = results[0].geometry.location.lng();

					vm.debtor.gpsLat = latitude;
					vm.debtor.gpsLng = longitude;

					$scope.$apply();

					vm.loadMap();
				} else {
					toastr.warning("Unable to get the Latitude and Longitude. Please check the address.");
				}
			});
		}

		// **********************************************

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
	function DebtorsImportCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();

		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;
		vm.isProcessing = false;
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.serverMode = Auth.getServerMode();
		/* **************************************************** */

		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";
		/* **************************************************** */

		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		vm.importOptions.createDebtor = true;
		vm.importOptions.updateDebtor = true;
		vm.importOptions.createDebtorBranch = true;
		vm.importOptions.updateDebtorBranch = true;

		/* **************************************************** */

		vm.importResult = {};

		/* **************************************************** */

		vm.downloadTemplate = function(templateNo, templateName) {

			var filename = templateName + ".xlsx";
			vm.isExporting = true;

			var api = "";
			if(templateNo==1)
			{
				api = 'debtors/download/template';
			}
			else if(templateNo==2)
			{
				api = 'debtors/debtorbranches/download/template';
			}

			HttpSvc.getExcelObject(api, Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;
					},
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};

		/* **************************************************** */


		vm.importData = function() {
			vm.isImporting = true;

			var api = 'debtors/importData';
			if(vm.importType == "2")
			{
				api = 'debtors/debtorbranches/importData';
			}

			HttpSvc.post(api, vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
					// Do nothing
				}, function(error) {
					// Do nothing
				});
		}

		/* **************************************************** */

		vm.getLatLngForAll = function() {
			vm.isProcessing = true;

			// Initialize the geocoder
			var geocoder = new google.maps.Geocoder();

			vm.importOptions.excelContent.forEach(function(x)
			{
                // Check each address component, if null or undefined, return an empty string
                var address1 = x.deliveryAddress1 ? x.deliveryAddress1 : "";
                var address2 = x.deliveryAddress2 ? x.deliveryAddress2 : "";
                var address3 = x.deliveryAddress3 ? x.deliveryAddress3 : "";
                var postCode = x.deliveryPostCode ? x.deliveryPostCode : "";
                var country = x.deliveryCountry ? x.deliveryCountry : "";

                // Get the address from user input (replace 'txtAddress' with your input field ID)
                var address = address1 + " " + address2 + " " + address3 + " " + postCode + " " + country;

				// Geocode the address
				geocoder.geocode({ address: address }, function(results, status) {
					if (status === google.maps.GeocoderStatus.OK) {
						var latitude = results[0].geometry.location.lat();
						var longitude = results[0].geometry.location.lng();

						x.gpsLat = latitude;
						x.gpsLng = longitude;

						$scope.$apply();
					} else {
						x.gpsLat = 0;
						x.gpsLng = 0;
					}
				});
			});

			toastr.success("Customers' Geo-location coordinates updated successfully.", Auth.translate("SUCCESS"))
			vm.isProcessing = false;
		}

		/* **************************************************** */

		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}

		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;
		}

		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];

			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}

		// Upload File
		vm.uploadFile = function(importType) {
			vm.resetFileUploadParams();

			vm.lockButtons = true;
			vm.importType = importType;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;

			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;

			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();
				vm.uploadMedia(vm.mediaToUpload);
			}
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {

						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);

					}, function(error) {
						toastr.error(error, 'Failed');

						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}

		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {

			if(vm.serverMode==0) {	// Local Server

				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					vm.isUploaded = true;

					// Call Process Excel API
					var api = 'debtors/import/';
					if(vm.importType == "2")
					{
						api = 'debtors/debtorbranches/import/';
					}

					HttpSvc.post(api + excelFilename, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;

							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});

			}  else if(vm.serverMode==1) { // Azure Server

				/* Initialize variables */
				/* ************************************* */
				handleFileSelect(_fileToUpload);
				/* ************************************* */

				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */

				/* Upload File (First Block) */
				/* ************************************* */
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);

				fileReader.onload = function(e) {
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];

						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,
						}).then(function(response) {
							if (response.status==201) {
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							}
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));

							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};

		/* **************************************************** */

		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;

            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }

        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);

                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);

				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }

        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';

			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,
			}).then(function(response) {
				vm.isUploaded = true;

				// Call Process Excel API
				var api = 'debtors/import/';
				if(vm.importType == "2")
				{
					api = 'debtors/debtorbranches/import/';
				}

				HttpSvc.post(api + excelFilename, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;

						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }

        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }
	};

	// Branch Modal Controller
	function DebtorsBranchModalCtrl($scope, $uibModalInstance, $timeout, item, Auth, HttpSvc, toastr) {
		var $mdl = this;

		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.item = item.object;
		$mdl.isLoading = false;
		$mdl.autoCode = false;

		$mdl.originalLat = $mdl.item.gpsLat;
		$mdl.originalLng = $mdl.item.gpsLng;

		// **********************************************

		//var infoWindow = new google.maps.InfoWindow();

        $mdl.loadMap = function() {

			var lat = $mdl.item.gpsLat || 3.1377664033531656;
			var lng = $mdl.item.gpsLng || 101.68700791600979;

			var mapOptions = {
				center: {
					'lat': lat,
					'lng': lng
				}, // Malaysia
				fullscreenControl: false,
				mapTypeControl: false,
				streetViewControl: false,
				clickableIcons: false,
				zoom: 14,
                zoomControlOptions: {
					position: google.maps.ControlPosition.RIGHT_BOTTOM,
				}
			};

			// Map object
			var map = new google.maps.Map(document.getElementById('googleMap'), mapOptions);

			var markers = [];

			var newMarker = new google.maps.Marker({
				position: { lat: lat, lng: lng },
				map: map,
				title: "Here!", // Customize the marker title
			});

			// Add the new marker to the array
			markers.push(newMarker);

			// Add CLICK event
			map.addListener("click", function(event) {
				var latitude = event.latLng.lat();
				var longitude = event.latLng.lng();

				$mdl.item.gpsLat = latitude;
				$mdl.item.gpsLng = longitude;

				$scope.$apply();

				// Remove existing markers
				markers.forEach(function(marker) {
					marker.setMap(null);
				});
				markers.length = 0; // Clear the array

				// Create a marker at the obtained coordinates
				var newMarker = new google.maps.Marker({
					position: { lat: latitude, lng: longitude },
					map: map,
					title: "Here!", // Customize the marker title
				});

				// Add the new marker to the array
				markers.push(newMarker);

				// Display the coordinates in an info window
				// infoWindow.setContent(`<b>Coordinates</b><br /><br />Lat: ${latitude},<br />Lng: ${longitude}`);
				// infoWindow.setPosition(event.latLng);
				// infoWindow.open(map);
			});
		}

		$mdl.getLatLng = function() {
			// Initialize the geocoder
			var geocoder = new google.maps.Geocoder();

            // Check each address component, if null or undefined, return an empty string
            var address1 = $mdl.item.address1 ? $mdl.item.address1 : "";
            var address2 = $mdl.item.address2 ? $mdl.item.address2 : "";
            var address3 = $mdl.item.address3 ? $mdl.item.address3 : "";
            var postCode = $mdl.item.postCode ? $mdl.item.postCode : "";
            var country = $mdl.item.country ? $mdl.item.country : "";

            // Get the address from user input (replace 'txtAddress' with your input field ID)
            var address = address1 + " " + address2 + " " + address3 + " " + postCode + " " + country;

            // Geocode the address
			geocoder.geocode({ address: address }, function(results, status) {
				if (status === google.maps.GeocoderStatus.OK) {
					var latitude = results[0].geometry.location.lat();
					var longitude = results[0].geometry.location.lng();

					$mdl.item.gpsLat = latitude;
					$mdl.item.gpsLng = longitude;

					$scope.$apply();

					$mdl.loadMap();
				} else {
					toastr.warning("Unable to get the Latitude and Longitude. Please check the address.");
				}
			});
		}

		/* *************************************************** */

		$mdl.autoCodeChanged = function() {
			if($mdl.autoCode)
			{
				$mdl.item.code = null;
			}
		}

		$mdl.confirmModal = function() {
			if(!$mdl.branchForm.$valid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* *************************************************** */

		// Init
		$timeout($mdl.loadMap, 1000);
	};

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.foodmenus.controller', [])
			.controller('FoodMenuMainCtrl', FoodMenuMainCtrl)
			.controller('FoodMenuCreateCtrl', FoodMenuCreateCtrl)
			.controller('FoodMenuUpdateCtrl', FoodMenuUpdateCtrl)
			.controller('FoodMenuProductModalCtrl', FoodMenuProductModalCtrl);

	/** @ngInject */
	function FoodMenuMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) 
	{	
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.foodmenuDataFull = [];
		vm.foodmenuData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.foodmenuDataFull, tableState.search.predicateObject) : vm.foodmenuDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.foodmenuData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.foodmenuDataFull.length <= 0) {				
				HttpSvc.get('foodmenus/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.foodmenuDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteMenu = function(menuId, menuName) {
			var params = {};
			HttpSvc.delete('foodmenus/' + menuId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('foodmenus/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.foodmenuDataFull = result;
							
							toastr.success('The menu [' + menuName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the menu [' + menuName + '].', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function FoodMenuCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.foodmenu = {};
		vm.foodmenu.foodMenuProducts = [];
		vm.isLoading = false;
		
		/* ************************************************************* */
			
		// Open Modal Dialog		
		vm.showAddProductModal = function () {			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'productModal.html',
				controller: 'FoodMenuProductModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: {}
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addProduct(data);
				}, function () {
				});
		};	

		vm.showEditProductModal = function (index) {
			vm.product = angular.copy(vm.foodmenu.foodMenuProducts[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'productModal.html',
				controller: 'FoodMenuProductModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.product,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateProduct(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************* */		
		
		// Remove Setting
		vm.removeProduct = function(index) {
			vm.foodmenu.foodMenuProducts.splice(index, 1);
		};
			
		// Update Setting
		vm.updateProduct = function(index, obj) {
			var element = {
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				productCode: obj.productCode,
				productName: obj.productName,
				itemType: obj.itemType,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				uomName: obj.uomName,
			};
			vm.foodmenu.foodMenuProducts.splice(index, 1, element);
		};

		// Add Setting
		vm.addProduct = function(obj) {
			var element = {
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				productCode: obj.productCode,
				productName: obj.productName,
				itemType: obj.itemType,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				uomName: obj.uomName,
			};
			vm.foodmenu.foodMenuProducts.push(element);
		};
		
		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.isLoading = true;

				HttpSvc.post('foodmenus', vm.foodmenu, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Food Menu has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.foodmenus.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Call Action
		// Do Nothing
	}

	/** @ngInject */
	function FoodMenuUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();

		var vm = this;
		vm.mode = 2;
		vm.foodmenu = {};
		vm.isLoading = false;
		
		/* ************************************************************* */
						
		// Load Menu
		vm.loadMenu = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('foodmenus/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.foodmenu = result;
				}, function() {
					toastr.error('Failed to load selected Menu.', Auth.translate('ERROR'))
					$state.go('maintenance.foodmenus.list');
					return;
				});		
		};	
		
		/* ************************************************************* */
			
		// Open Modal Dialog		
		vm.showAddProductModal = function () {			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'productModal.html',
				controller: 'FoodMenuProductModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: {}
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addProduct(data);
				}, function () {
				});
		};	

		vm.showEditProductModal = function (index) {
			vm.product = angular.copy(vm.foodmenu.foodMenuProducts[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'productModal.html',
				controller: 'FoodMenuProductModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.product,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateProduct(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************* */		
		
		// Remove Setting
		vm.removeProduct = function(index) {
			vm.foodmenu.foodMenuProducts.splice(index, 1);
		};
			
		// Update Setting
		vm.updateProduct = function(index, obj) {
			var element = {
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				productCode: obj.productCode,
				productName: obj.productName,
				itemType: obj.itemType,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				uomName: obj.uomName,
			};
			vm.foodmenu.foodMenuProducts.splice(index, 1, element);
		};

		// Add Setting
		vm.addProduct = function(obj) {
			var element = {
				itemId: obj.itemId,
				productId: obj.productId,
				semiFinishedProductId: obj.semiFinishedProductId,
				productCode: obj.productCode,
				productName: obj.productName,
				itemType: obj.itemType,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				uomName: obj.uomName,
			};
			vm.foodmenu.foodMenuProducts.push(element);
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('foodmenus/' + $stateParams.id, vm.foodmenu, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Food Menu has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadMenu();
	}
		
	function FoodMenuProductModalCtrl($uibModalInstance, item, toastr, Auth, HttpSvc) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.item = item.object;
		$mdl.itemList = [];
		$mdl.selectedItem = null;
		$mdl.selectedUom = null;
		$mdl.lockButtons = false;
		
		/* ********************************************************* */

		if($mdl.mode==1) {
			$mdl.item.quantity = 1;
		} else if($mdl.mode==2) {

			$mdl.itemList.push({ 
				itemId: $mdl.item.productId, 
				productId: $mdl.item.productId, 
				semiFinishedProductId: $mdl.item.semiFinishedProductId, 
				productCode: $mdl.item.productCode, 
				productName: $mdl.item.productName,
				itemType: $mdl.item.itemType,
				uomList: [
					{
						id: $mdl.item.unitOfMeasurementId, 
						name: $mdl.item.uomName
					}
				]
			});
			$mdl.selectedItem = $mdl.itemList[0];
			$mdl.selectedUom = $mdl.selectedItem.uomList[0];
		}

		/* ************************************************************* */	
		
		// Load Item List
		$mdl.searchItem = function(searchString) {

			if(searchString==null || searchString.trim()=="") return;

			$mdl.lockButtons = true;

			var keyword = encodeURIComponent(searchString);

			HttpSvc.get('searchengine/search/items/' + keyword, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.itemList = result;
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve search results.', '');
					return null;
				});
		};

		/* ************************************************************* */
	
		$mdl.selectedItemChanged = function() {
			$mdl.item.itemId = $mdl.selectedItem.itemId;
			$mdl.item.semiFinishedProductId = $mdl.selectedItem.semiFinishedProductId;
			$mdl.item.productId = $mdl.selectedItem.productId;
			$mdl.item.productCode = $mdl.selectedItem.productCode;
			$mdl.item.productName = $mdl.selectedItem.productName;
			$mdl.item.itemType = $mdl.selectedItem.itemType;
		};

		$mdl.selectedUomChanged = function() {
			$mdl.item.unitOfMeasurementId = $mdl.selectedUom.id;
			$mdl.item.uomName = $mdl.selectedUom.name;
		}

		/* ************************************************************* */

		$mdl.confirmModal = function() {
			if($mdl.productForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ************************************************************* */
		
	};	

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.intercompanyitemmappings.controller', [])
        .controller('InterCompanyItemMappingMainCtrl', InterCompanyItemMappingMainCtrl)
        .controller('InterCompanyItemMappingCreateCtrl', InterCompanyItemMappingCreateCtrl)
        .controller('InterCompanyItemMappingUpdateCtrl', InterCompanyItemMappingUpdateCtrl)
        .controller('InterCompanyItemMappingImportCtrl', InterCompanyItemMappingImportCtrl);

    /** @ngInject */
    function InterCompanyItemMappingMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 20;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.mappingDataFull = [];
		vm.mappingData = [];
		vm.isLoading = true;
		vm.companyId = Auth.getCompanyId();

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.mappingDataFull, tableState.search.predicateObject) : vm.mappingDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.mappingData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.mappingDataFull.length <= 0) {			
				vm.isLoading = true;

				HttpSvc.get('intercompanyitemmappings/bycompany/' + vm.companyId, params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.mappingDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteMapping = function(mappingId) {
			var params = {};
			vm.isLoading = true;

			HttpSvc.delete('intercompanyitemmappings/' + mappingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('intercompanyitemmappings/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.mappingDataFull = result;
							
							toastr.success('The mapping has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
							vm.isLoading = false;
						}, function() {
							vm.isLoading = false;
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to delete the mapping.', 'Delete Failed');
					return null;
			});
		};
		
		vm.getDestObjectCode = function(item) {
			if(item.destItemName!=null) return item.destItemCode;
			if(item.destSemiFgName!=null) return item.destSemiFgCode;
			if(item.destProductName!=null) return item.destProductCode;
		}
		
		vm.getDestObjectName = function(item) {
			if(item.destItemName!=null) return item.destItemName;
			if(item.destSemiFgName!=null) return item.destSemiFgName;
			if(item.destProductName!=null) return item.destProductName;
		}
		
		vm.getDestObjectType = function(item) {
			if(item.destItemName!=null) return "RM";
			if(item.destSemiFgName!=null) return "SFG";
			if(item.destProductName!=null) return "FG";
		}

		vm.resetSearch = function() 
		{
		}	
	};
	
	/** @ngInject */
    function InterCompanyItemMappingCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.mapping = {};	
		vm.companyList = [];
		vm.branchList = [];
		vm.itemList = [];
		vm.rawMatList = [];
		vm.semiFgList = [];
		vm.productList = [];
		vm.changeLogs = [];
		vm.selectedSourceCompany = null;
		vm.selectedSourceItem = null;
		vm.selectedDestCompany = null;
		vm.selectedDestBranch = null;
		vm.selectedDestRawMat = null;
		vm.selectedDestSemiFg = null;
		vm.selectedDestProduct = null;

		/* ******************************************************** */

		// Load Companies 
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companyList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		// Load Branches 
		vm.loadBranchList = function(companyId) {
			HttpSvc.get('branches/listbycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.branchList = result;

					vm.branchList.forEach(function(b) {
						if(b.id==vm.mapping.destBranchId)
						{
							vm.selectedDestBranch = b;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		// Load Raw Mats (Source)
		vm.loadItemList = function(companyId) {
			HttpSvc.get('items/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.itemList = result;	
					
					vm.itemList.forEach(function(i) {
						if(i.id==vm.mapping.sourceItemId)
						{
							vm.selectedSourceItem = i;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Raw Material list.', '');
					return null;
				});
		};

		// Load Raw Mats (Desitnation)
		vm.loadRawMatList = function(companyId) {
			HttpSvc.get('items/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.rawMatList = result;	
					
					vm.rawMatList.forEach(function(i) {
						if(i.id==vm.mapping.destItemId)
						{
							vm.selectedDestRawMat = i;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Raw Material list.', '');
					return null;
				});
		};

		// Load Semi FGs
		vm.loadSemiFgList = function(companyId) {
			HttpSvc.get('semifgs/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.semiFgList = result;	
					
					if(vm.mapping.destSemiFgId!=null)
					{
						vm.semiFgList.forEach(function(s) {
							if(s.id==vm.mapping.destSemiFgId)
							{
								vm.selectedDestSemiFg = s;
							}
						});	
					}					
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Semi FG list.', '');
					return null;
				});
		};
		
		// Load Products
		vm.loadProductList = function(companyId) {
			HttpSvc.get('products/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.productList = result;
					
					if(vm.mapping.destProductId!=null)
					{
						vm.productList.forEach(function(p) {
							if(p.id==vm.mapping.destProductId)
							{
								vm.selectedDestProduct = p;
							}
						});
					}
				}, function() {
					// Failed
					toastr.error('Failed to retrieve FG list.', '');
					return null;
				});
		};

		/* ******************************************************** */
		
		// Select Source Company
		vm.selectedSourceCompanyChanged = function() {
			vm.mapping.sourceCompanyId = vm.selectedSourceCompany.id;
			vm.loadItemList(vm.mapping.sourceCompanyId);
		};
		
		// Select Source Raw Mat
		vm.selectedSourceItemChanged = function() {
			vm.mapping.sourceItemId = vm.selectedSourceItem.id;
		};
		
		// Select Dest Company
		vm.selectedDestCompanyChanged = function() {
			vm.mapping.destCompanyId = vm.selectedDestCompany.id;
			vm.loadBranchList(vm.mapping.destCompanyId);
			vm.loadRawMatList(vm.mapping.destCompanyId);
			vm.loadSemiFgList(vm.mapping.destCompanyId);
			vm.loadProductList(vm.mapping.destCompanyId);
		};
		
		// Select Dest Branch
		vm.selectedDestBranchChanged = function() {
			vm.mapping.destBranchId = vm.selectedDestBranch.id;
		};
		
		// Select Dest Raw Mat
		vm.selectedDestRawMatChanged = function() {
			vm.mapping.destItemId = vm.selectedDestRawMat.id;
			vm.mapping.destSemiFgId = null;
			vm.mapping.destProductId = null;

			vm.selectedDestSemiFg = null;
			vm.selectedDestProduct = null;
		};
		
		// Select Dest Semi FG
		vm.selectedDestSemiFgChanged = function() {
			vm.mapping.destSemiFgId = vm.selectedDestSemiFg.id;
			vm.mapping.destItemId = null;
			vm.mapping.destProductId = null;
			
			vm.selectedDestRawMat = null;
			vm.selectedDestProduct = null;
		};
		
		// Select Dest Product
		vm.selectedDestProductChanged = function() {
			vm.mapping.destProductId = vm.selectedDestProduct.id;
			vm.mapping.destItemId = null;
			vm.mapping.destSemiFgId = null;
			
			vm.selectedDestRawMat = null;
			vm.selectedDestSemiFg = null;
		};
		
		/* ******************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('intercompanyitemmappings', vm.mapping, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Mapping has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.intercompanyitemmappings.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		/* ******************************************************** */
		
		// Call Action
		vm.loadCompanyList();
	}
	
	/** @ngInject */
    function InterCompanyItemMappingUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.mapping = {};	
		vm.companyList = [];
		vm.branchList = [];
		vm.itemList = [];
		vm.rawMatList = [];
		vm.semiFgList = [];
		vm.productList = [];
		vm.changeLogs = [];
		vm.selectedSourceCompany = null;
		vm.selectedSourceItem = null;
		vm.selectedDestCompany = null;
		vm.selectedDestBranch = null;
		vm.selectedDestRawMat = null;
		vm.selectedDestSemiFg = null;
		vm.selectedDestProduct = null;

		/* ******************************************************** */

		// Load Branches 
		vm.loadBranchList = function(companyId) {
			HttpSvc.get('branches/listbycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.branchList = result;

					vm.branchList.forEach(function(b) {
						if(b.id==vm.mapping.destBranchId)
						{
							vm.selectedDestBranch = b;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		// Load Raw Mats (Source)
		vm.loadItemList = function(companyId) {
			HttpSvc.get('items/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.itemList = result;	
					
					vm.itemList.forEach(function(i) {
						if(i.id==vm.mapping.sourceItemId)
						{
							vm.selectedSourceItem = i;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Raw Material list.', '');
					return null;
				});
		};

		// Load Raw Mats (Desitnation)
		vm.loadRawMatList = function(companyId) {
			HttpSvc.get('items/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.rawMatList = result;	
					
					vm.rawMatList.forEach(function(i) {
						if(i.id==vm.mapping.destItemId)
						{
							vm.selectedDestRawMat = i;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Raw Material list.', '');
					return null;
				});
		};

		// Load Semi FGs
		vm.loadSemiFgList = function(companyId) {
			HttpSvc.get('semifgs/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.semiFgList = result;	
					
					if(vm.mapping.destSemiFgId!=null)
					{
						vm.semiFgList.forEach(function(s) {
							if(s.id==vm.mapping.destSemiFgId)
							{
								vm.selectedDestSemiFg = s;
							}
						});	
					}					
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Semi FG list.', '');
					return null;
				});
		};
		
		// Load Products
		vm.loadProductList = function(companyId) {
			HttpSvc.get('products/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.productList = result;
					
					if(vm.mapping.destProductId!=null)
					{
						vm.productList.forEach(function(p) {
							if(p.id==vm.mapping.destProductId)
							{
								vm.selectedDestProduct = p;
							}
						});
					}
				}, function() {
					// Failed
					toastr.error('Failed to retrieve FG list.', '');
					return null;
				});
		};
				
		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('intercompanyitemmappingchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};	

		// Load Mapping
		vm.loadMapping = function() {
			HttpSvc.get('intercompanyitemmappings/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.mapping = result;

					$scope.user.companies.forEach(function(c) {
						if(c.id==vm.mapping.sourceCompanyId)
						{
							vm.selectedSourceCompany = c;
						}
						if(c.id==vm.mapping.destCompanyId)
						{
							vm.selectedDestCompany = c;
						}
					});

					vm.loadItemList(vm.mapping.sourceCompanyId);
					vm.loadBranchList(vm.mapping.destCompanyId);
					vm.loadRawMatList(vm.mapping.destCompanyId);
					vm.loadSemiFgList(vm.mapping.destCompanyId);
					vm.loadProductList(vm.mapping.destCompanyId);
					vm.loadChangeLogs();

				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer branch list.', '');
					return null;
				});
		};

		/* ******************************************************** */
		
		// Select Source Company
		vm.selectedSourceCompanyChanged = function() {
			vm.mapping.sourceCompanyId = vm.selectedSourceCompany.id;
			vm.loadItemList(vm.mapping.sourceCompanyId);
		};
		
		// Select Source Raw Mat
		vm.selectedSourceItemChanged = function() {
			vm.mapping.sourceItemId = vm.selectedSourceItem.id;
		};
		
		// Select Dest Company
		vm.selectedDestCompanyChanged = function() {
			vm.mapping.destCompanyId = vm.selectedDestCompany.id;
			vm.loadBranchList(vm.mapping.destCompanyId);
			vm.loadRawMatList(vm.mapping.destCompanyId);
			vm.loadSemiFgList(vm.mapping.destCompanyId);
			vm.loadProductList(vm.mapping.destCompanyId);
		};
		
		// Select Dest Branch
		vm.selectedDestBranchChanged = function() {
			vm.mapping.destBranchId = vm.selectedDestBranch.id;
		};
		
		// Select Dest Raw Mat
		vm.selectedDestRawMatChanged = function() {
			vm.mapping.destItemId = vm.selectedDestRawMat.id;
			vm.mapping.destSemiFgId = null;
			vm.mapping.destProductId = null;

			vm.selectedDestSemiFg = null;
			vm.selectedDestProduct = null;
		};
		
		// Select Dest Semi FG
		vm.selectedDestSemiFgChanged = function() {
			vm.mapping.destSemiFgId = vm.selectedDestSemiFg.id;
			vm.mapping.destItemId = null;
			vm.mapping.destProductId = null;
			
			vm.selectedDestRawMat = null;
			vm.selectedDestProduct = null;
		};
		
		// Select Dest Product
		vm.selectedDestProductChanged = function() {
			vm.mapping.destProductId = vm.selectedDestProduct.id;
			vm.mapping.destItemId = null;
			vm.mapping.destSemiFgId = null;
			
			vm.selectedDestRawMat = null;
			vm.selectedDestSemiFg = null;
		};
		
		/* ******************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('intercompanyitemmappings/' + $stateParams.id, vm.mapping, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Mapping has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
						//$state.go('maintenance.intercompanyitemmappings.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		/* ******************************************************** */

		vm.loadMapping();
	}
	
	/** @ngInject */
	function InterCompanyItemMappingImportCtrl($scope, $state, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;		
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;
		
		/* **************************************************** */
		
		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";

		/* **************************************************** */
		
		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		vm.importOptions.createItemMapping = true;
		vm.importOptions.updateItemMapping = true;
		
		/* **************************************************** */
		
		vm.goBack = function() {
			$state.reload();
		}
		
		/* **************************************************** */
		
		vm.importResult = {};
		
		/* **************************************************** */
				
		vm.downloadTemplate = function() {
			
			var filename = "InterCompany Item Mapping Template.xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject('intercompanyitemmappings/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};		
		
		/* **************************************************** */
		
		vm.importData = function() {
			vm.isImporting = true;
			
			HttpSvc.post('intercompanyitemmappings/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
					//vm.lockButtons = false;
					//vm.isImportComplete = true;
					
					//vm.importResult = result;
					
					//toastr.success("Data imported successfully!");
					//$state.go('maintenance.items.list');
				}, function(error) {
					//vm.lockButtons = false;
					//vm.isImportFailed = true;
					
					//toastr.error("Failed to import data! " + error);
				});
		}
		
		/* **************************************************** */
		
		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}
		
		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;			
		}
		
		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];
			
			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}
		
		// Upload File
		vm.uploadFile = function() {	
			vm.resetFileUploadParams();
			
			vm.lockButtons = true;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;
								
			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;
			
			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();	
				vm.uploadMedia(vm.mediaToUpload);
			}	
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {
						
						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);
						
					}, function(error) {
						toastr.error(error, 'Failed');
						
						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {					
					vm.isUploaded = true;
					
					// Call Process Excel API 
					HttpSvc.post('intercompanyitemmappings/import/' + resp.data, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;
							
							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			}  else if(vm.serverMode==1) { // Azure Server
							
				/* Initialize variables */
				/* ************************************* */	
				handleFileSelect(_fileToUpload);
				/* ************************************* */	
				
				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							} 
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,				
			}).then(function(response) {	
				vm.isUploaded = true;
				
				// Call Process Excel API 
				HttpSvc.post('intercompanyitemmappings/import/' + excelFilename, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;
						
						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }		
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.items.controller', [])
        .controller('ItemMainCtrl', ItemMainCtrl)
        .controller('ItemCreateCtrl', ItemCreateCtrl)
        .controller('ItemUpdateCtrl', ItemUpdateCtrl)
        .controller('ItemImportCtrl', ItemImportCtrl)
        .controller('ItemUomModalCtrl', ItemUomModalCtrl)
        .controller('ItemParModalCtrl', ItemParModalCtrl)
        .controller('ItemCertModalCtrl', ItemCertModalCtrl)
        .controller('ItemSalesConfigModalCtrl', ItemSalesConfigModalCtrl)
        .controller('ItemSupplierPriceModalCtrl', ItemSupplierPriceModalCtrl)
        .controller('ItemAuditLogModalCtrl', ItemAuditLogModalCtrl)
        .controller('ItemImportSelectPOModalCtrl', ItemImportSelectPOModalCtrl)
		;

    /** @ngInject */
    function ItemMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.data = [];
		vm.dataFilter = {};

		vm.isLoading = false;
		vm.serverMode = Auth.getServerMode();
		vm.blobUrl = vm.serverMode==1?RmsApi.BLOBURL :RmsApi.LOCALURL;

		vm.loadFilters = function()
		{
			HttpSvc.get('items/filters', {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.dataFilter = result;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		}

		vm.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.code,
				category: predicate.category,
				subcategory: predicate.subCategory,
				active: predicate.active,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('items/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			return tableState;
		};

		vm.resetSearch = function()
		{
		}

		vm.deleteItem = function(itemId, itemName) {
			var params = {};
			HttpSvc.delete('items/' + itemId, params, Auth.getTokenId(), false)
				.then(function(result) {
					$scope.$broadcast('refreshStTable');
				}, function() {
					// Failed
					toastr.error('Failed to delete the item <b>' + itemName + '</b>.', 'Delete Failed');
					return null;
			});
		};

		// Init Call
		//vm.loadFilters();
	};

	/** @ngInject */
    function ItemCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {
		Auth.init();

		var vm = this;
		vm.mode = 1;
		vm.item = {};
		vm.item.itemUnitOfMeasurements = [];
		vm.item.itemPriceHistories = [];
		vm.item.itemPrices = [];
		vm.item.active = true;
		vm.item.yieldPercent = 100;
		vm.item.pax = 0;
		vm.item.lifeTime = 0;
		vm.item.reOrderStockLevel = 0;
		vm.item.reOrderQuantity = 0;
		vm.item.maxStockLevel = 0;
		vm.item.minStockLevel = 0;
		vm.item.safeStockLevel = 0;
		vm.item.templateContent = {};
		vm.supplierList = [];
		vm.priceUomList = [];
		vm.uomList = [];
		vm.uomBase = "";
		vm.uomInventory = "";
		vm.uomOrder = "";
		vm.uomDefault = "";
		vm.isLoading = false;
		vm.currencyCode = Auth.getCurrency();

		vm.integrationMode = Auth.getIntegrationMode();
		vm.hasAutoCountFields = vm.integrationMode == 2 && Auth.autoCount_EnableSync_RawMat();
		vm.hasIDBFields = vm.integrationMode == 7 && Auth.idB_EnableSync_RawMat();
		vm.hasSQLFields = vm.integrationMode == 8 && Auth.sqL_EnableSync_RawMat();
		vm.autoCount_itemGroups = [];
		vm.autoCount_itemTypes = [];
		vm.idbItemTypes = [];
		vm.idbItemClasses = [];
		vm.sql_itemGroups = [];

		vm.item.imageLocation = '';
		vm.blobUrl = vm.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL;
		vm.fileToUpload = null;
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();

		/* ***************************************************************** */

		vm.initData = function() {

			vm.item.imageLocation = 'assets/img/empty_placeholder.png';

			if(vm.hasAutoCountFields) {
				vm.loadAutoCountItemTypes();
			} else if (vm.hasIDBFields) { 
				vm.loadIDBItemTypes();
			} else if (vm.hasSQLFields) { 
				vm.loadSQLItemGroups();
			} else {
				vm.loadSupplierList();
			}
		}

		/* ***************************************************************** */

		// Load Supplier List
		vm.loadSupplierList = function() {
			vm.isLoading = true;

			HttpSvc.get('suppliers/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.supplierList = result;
					vm.loadUomList();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Supplier List.', '');
					return null;
			});
		}

		// Load UOM List
		vm.loadUomList = function() {
			HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.uomList = result;
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};

		/* ***************************************************************** */

		vm.loadAutoCountItemTypes = function() {
			vm.isLoading = true;

			HttpSvc.get('autocount/maintenance/list/itemtypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_itemTypes = result;

					vm.loadAutoCountItemGroups();
				}, function() {
					toastr.error('Failed to load selected AutoCount Item Types.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};

		vm.loadAutoCountItemGroups = function() {
			HttpSvc.get('autocount/maintenance/list/itemgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_itemGroups = result;

					vm.loadSupplierList();
				}, function() {
					toastr.error('Failed to load selected AutoCount Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};

		vm.loadSQLItemGroups = function() {
			HttpSvc.get('sqlacc/maintenance/stockgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sql_itemGroups = result;
					vm.loadSupplierList();
				}, function() {
					toastr.error('Failed to load selected SQL Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};

		vm.loadIDBItemTypes = function() {
			vm.isLoading = true;

			HttpSvc.get('idbs/maintenance/list/poitemtypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.idbItemTypes = result;
					vm.loadIDBItemClasses();
				}, function() {
					toastr.error('Failed to load selected IDB Item Types.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};

		vm.loadIDBItemClasses = function() {
			vm.isLoading = true;
			HttpSvc.get('idbs/maintenance/list/poitemclasses', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.idbItemClasses = result;
					vm.loadSupplierList();
				}, function() {
					toastr.error('Failed to load selected IDB Item Classes.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};

		/* ***************************************************************** */

		vm.selectedItemTypeChanged = function() {
			vm.item.autoCount_ItemType = vm.selectedItemType.itemType1;
		}

		vm.selectedItemGroupChanged = function() {
			vm.item.autoCount_ItemGroup = vm.selectedItemGroup.itemGroup1;
		}

		vm.selectedSQLItemGroupChanged = function() {
			vm.item.sqL_ItemGroup = vm.selectedSQLItemGroup.CODE;
		}

		vm.selectedIDBItemTypeChanged = function() {
			vm.item.idB_ItemType = vm.selectedIDBItemType.code;
		}

		vm.selectedIDBItemClassChanged = function() {
			vm.item.idB_ItemClass = vm.selectedIDBItemClass.code;
		}

		vm.selectedStockControlChanged = function() {
			if(vm.selectedStockControl=="1") {
				vm.item.autoCount_StockControl = true;
			} else if(vm.selectedStockControl=="0") {
				vm.item.autoCount_StockControl = false;
			}
		}
		
		vm.selectedSQLStockControlChanged = function() {
			if(vm.selectedSQLStockControl=="1") {
				vm.item.sqL_StockControl = true;
			} else if(vm.selectedSQLStockControl=="0") {
				vm.item.sqL_StockControl = false;
			}
		}
		// *************************************************************

		vm.selectedParallelUom1Changed = function() {
			vm.item.cwm_ParallelUomId = vm.selectedParallelUom1.unitOfMeasurementId;
		}

		vm.selectedParallelUom2Changed = function() {
			vm.item.cwm_ParallelUomId_Secondary = vm.selectedParallelUom2.unitOfMeasurementId;
		}

		vm.verifyCWMSettings = function() {
			if(!vm.item.isCWM)
			{
				vm.item.syncCwmParallelUom = false;
				vm.item.cwm_ParallelUomId = null;
				vm.item.cwm_ParallelUomId_Secondary = null;
				vm.item.cwm_ParallelMultiplier = 0;
				vm.item.cwm_TolerencePercent = 0;
			}
		}

		// **********************************************

		// Get UOM
		vm.getDisplayUom = function(uomType) {
			var objBase = vm.item.itemUnitOfMeasurements.filter(function( obj ) {
				return obj.isBase==true;
			});
			var objInventory = vm.item.itemUnitOfMeasurements.filter(function( obj ) {
				return obj.isInventory==true;
			});
			var objOrder = vm.item.itemUnitOfMeasurements.filter(function( obj ) {
				return obj.isOrder==true;
			});
			var objDefault = vm.item.itemUnitOfMeasurements.filter(function( obj ) {
				return obj.isDefault==true;
			});

			if(uomType=="BASE") {
				return objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name;
			}
			if(uomType=="INVENTORY") {
				return objInventory.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objInventory[0].unitOfMeasurement.name;
			}
			if(uomType=="ORDER") {
				return objOrder.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objOrder[0].unitOfMeasurement.name;
			}
			if(uomType=="DEFAULT") {
				return objDefault.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objDefault[0].unitOfMeasurement.name;
			}
			return "x";
		}

		// **********************************************

		// Remove UOM
		vm.removeUom = function(index) {
			vm.item.itemUnitOfMeasurements.splice(index, 1);
			vm.refreshDisplayUom();
			$scope.$broadcast('refreshStTable');
		};

		// Update UOM
		vm.updateUom = function(index, obj) {
			var element = {
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,
				},
				baseMultiplier: obj.baseMultiplier,
				isBase: obj.isBase,
				isInventory: obj.isInventory,
				isOrder: obj.isOrder,
				isSales: obj.isSales,
				isDefault: obj.isDefault,
				remarks: obj.remarks,
			};

			if(element.isBase) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isBase = false;
				})
			}
			if(element.isInventory) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isInventory = false;
				})
			}
			if(element.isOrder) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isOrder = false;
				})
			}
			if(element.isSales) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isSales = false;
				})
			}
			if(element.isDefault) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isDefault = false;
				})
			}

			vm.item.itemUnitOfMeasurements.splice(index, 1, element);

			vm.item.itemUnitOfMeasurements.sort(function(a, b) {
				return a.baseMultiplier - b.baseMultiplier;
			});

			vm.refreshDisplayUom();
		};

		// Add UOM
		vm.addUom = function(obj) {
			var element = {
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,
				},
				baseMultiplier: obj.baseMultiplier,
				isBase: obj.isBase,
				isInventory: obj.isInventory,
				isOrder: obj.isOrder,
				isSales: obj.isSales,
				isDefault: obj.isDefault,
				remarks: obj.remarks,
			};

			if(element.isBase) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isBase = false;
				})
			}
			if(element.isInventory) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isInventory = false;
				})
			}
			if(element.isOrder) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isOrder = false;
				})
			}
			if(element.isSales) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isSales = false;
				})
			}
			if(element.isDefault) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isDefault = false;
				})
			}

			vm.item.itemUnitOfMeasurements.push(element);

			vm.item.itemUnitOfMeasurements.sort(function(a, b) {
				return a.baseMultiplier - b.baseMultiplier;
			});

			vm.refreshDisplayUom();
		};

		// Refresh UOM List
		vm.refreshItemUoms = function(tableState) {
			// Do nothing
		};

		vm.refreshDisplayUom = function() {
			vm.uomBase = vm.getDisplayUom('BASE');
			vm.uomInventory = vm.getDisplayUom('INVENTORY');
			vm.uomOrder = vm.getDisplayUom('ORDER');
			vm.uomDefault = vm.getDisplayUom('DEFAULT');
		}

		// **********************************************

		// Remove Supplier
		vm.removeSupplier = function(index) {
			vm.item.itemPrices.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};

		// Update Supplier
		vm.updateSupplier = function(index, obj) {
			var element = {
				id: obj.id,
				itemId: obj.itemId,
				supplierId: obj.supplierId,
				supplier: {
					code: obj.supplierCode,
					name: obj.supplierName,
					currencyCode: obj.currencyCode
				},
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,
				},
				supplierItemDescription: ((obj.supplierItemDescription==""||obj.supplierItemDescription==null)?vm.item.description:obj.supplierItemDescription),
				quantity: obj.quantity,
				cost: obj.cost,
				tax: obj.tax,
				taxPercent: obj.taxPercent,
				costIncGst: obj.costIncGst,
				taxable: obj.taxable,
				taxCode: obj.taxCode,
				remarks: obj.remarks,
				isDefault: obj.isDefault,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
				modifiedBy: obj.modifiedBy,
				modifiedDate: obj.modifiedDate,
			};

			if(element.isDefault) {
				vm.item.itemPrices.forEach(function(p) {
					p.isDefault = false;
				})
			}

            var isElementValid = true;
            var item = vm.item.itemPrices;

            for (var i = 0; i < item.length; i++) {
                // If editing same item with the same supplier and UOM on the list, no need to check
                if (i !== index) {
                    // If the user tries to edit other item with existing supplier and UOM on the list, prompt error msg
                    if (item[i].supplier.name === element.supplier.name
                        && item[i].unitOfMeasurement.name === element.unitOfMeasurement.name) {
                        isElementValid = false;
                        toastr.error('Pricing entry with the same Supplier and UOM already exists.');
                    }
                }
            }

            if (isElementValid) {
                vm.item.itemPrices.splice(index, 1, element);
            }

		};

		// Add Supplier
		vm.addSupplier = function(obj) {
			var element = {
				supplierId: obj.supplierId,
				supplier: {
					code: obj.supplierCode,
					name: obj.supplierName,
					currencyCode: obj.currencyCode
				},
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,
				},
				supplierItemDescription: ((obj.supplierItemDescription==""||obj.supplierItemDescription==null)?vm.item.description:obj.supplierItemDescription),
				quantity: obj.quantity,
				cost: obj.cost,
				tax: obj.tax,
				taxPercent: obj.taxPercent,
				costIncGst: obj.costIncGst,
				taxable: obj.taxable,
				taxCode: obj.taxCode,
				remarks: obj.remarks,
				isDefault: obj.isDefault,
			};

			if(element.isDefault) {
				vm.item.itemPrices.forEach(function(p) {
					p.isDefault = false;
				})
			}

            var isElementValid = true;

            vm.item.itemPrices.forEach(function(item) {
                if (item.supplier.name === element.supplier.name
                    && item.unitOfMeasurement.name === element.unitOfMeasurement.name) {
                        isElementValid = false;
                        toastr.error('Pricing entry with the same Supplier and UOM already exists.');
                }
            })

            if (isElementValid) {
                vm.item.itemPrices.push(element);
            }
		};

		// Refresh UOM List
		vm.refreshItemPrices = function(tableState) {
			// Do nothing
		};

		// **********************************************

		// Open Modal Dialog
		vm.uom = {};
		vm.showAddUomModal = function () {
			vm.uom = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'uomModal.html',
				controller: 'ItemUomModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.uom,
							baseUom: vm.getDisplayUom('BASE'),
							uomList: vm.uomList
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addUom(data);
				}, function () {
				});
		};
		vm.showEditUomModal = function (index) {
			vm.uom = angular.copy(vm.item.itemUnitOfMeasurements[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'uomModal.html',
				controller: 'ItemUomModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.uom,
							baseUom: vm.getDisplayUom('BASE'),
							uomList: vm.uomList
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateUom(index, data);
				}, function () {
				});
		};

		// **********************************************

		vm.supplier	= {};
		vm.showAddSupplierModal = function () {
			vm.supplier = {};

			vm.priceUomList = [];
			vm.item.itemUnitOfMeasurements.forEach(function(u) {
				vm.priceUomList.push({ id: u.unitOfMeasurementId, name: u.unitOfMeasurement.name });
			})

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'supplierModal.html',
				controller: 'ItemSupplierPriceModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.supplier,
							supplierList: vm.supplierList,
							uomList: vm.priceUomList,
							currencyCode: vm.currencyCode
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
                    vm.addSupplier(data);
				}, function () {
				});
		};
		vm.showEditSupplierModal = function (index) {
			vm.supplier = angular.copy(vm.item.itemPrices[index]);

			vm.priceUomList = [];
			vm.item.itemUnitOfMeasurements.forEach(function(u) {
				vm.priceUomList.push({ id: u.unitOfMeasurementId, name: u.unitOfMeasurement.name });
			})

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'supplierModal.html',
				controller: 'ItemSupplierPriceModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.supplier,
							supplierList: vm.supplierList,
							uomList: vm.priceUomList,
							currencyCode: vm.currencyCode
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateSupplier(index, data);
				}, function () {
				});
		};

		/* ***************************************************************** */

		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}

		// Set Upload Image
		vm.clearImage = function() {
			vm.item.imageLocation = 'assets/img/empty_placeholder.png';
			vm.item.oriImageLocation = '';
			vm.fileToUpload = null;
		}

		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (itemId) {
			var fileReader = new FileReader();

			if(vm.serverMode==0) {	// Local Server

				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Raw Material has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('maintenance.items.update', {'id': itemId });
				}, function (resp) {
					toastr.success('Raw Material has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('maintenance.items.update', {'id': itemId });
				}, function (evt) {
				});

			} else if(vm.serverMode==1) { // Azure Server

				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {
							toastr.success('Raw Material has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('maintenance.items.update', {'id': itemId });
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						}
					}, null, function(evt) {
					});
				}
			}
		};

		/* ***************************************************************** */

		vm.submit = function() {

			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, 'Incomplete Fields');
			} else {
				vm.isLoading = true;

				vm.item.companyId = Auth.getCompanyId();

				vm.verifyCWMSettings();

				imgLocation = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				vm.item.templateContent = angular.toJson(vm.item.templateContent);

				if(vm.serverMode==1 && vm.fileToUpload) {

					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/rawmaterials/" + newFilename + mediaExtension;

				} else if(vm.serverMode==0 && vm.fileToUpload) {

					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "rawmaterials/" + newFilename + mediaExtension;

				} else if(vm.item.oriImageLocation!="") {
					imgLocation = vm.item.oriImageLocation;
				}
				vm.item.imageLocation = imgLocation;

				HttpSvc.post('items/add', vm.item, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Failed');
						vm.item.templateContent = angular.fromJson(vm.item.templateContent);
					});
			}
		}

		vm.checkResult = function(result) {
			azureStorageUrl = "";
			localStorageUrl = "";

			if(result.httpStatusCode=="200")
			{
				if(vm.serverMode==1 && vm.fileToUpload) {
					azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
					vm.uploadImage(result.id);

				} else if(vm.serverMode==0 && vm.fileToUpload) {
					localStorageUrl = RmsApi.URL + "upload/rawmaterials/" + result.id;
					vm.uploadImage(result.id);

				} else {
					toastr.success('Raw Material has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('maintenance.items.update', {'id': result.id });
				}
			}
			else
			{
				vm.isLoading = false;
				toastr.error(result.message, 'Failed');
				vm.item.templateContent = angular.fromJson(vm.item.templateContent);
			}
		}

		// **********************************************

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
    function ItemUpdateCtrl($scope, $state, $stateParams, $uibModal, $filter, Auth, HttpSvc, UtilSvc, Upload, RmsApi, toastr) {

		Auth.init();

		var vm = this;

		vm.isRmsLite = Auth.isLiteMode();
		vm.isStarterMode = Auth.isStarterMode();

		vm.mode = 2;
		vm.item = {};
		vm.item.yieldPercent = 100;
		vm.item.templateContent = {};
		vm.item.itemUnitOfMeasurements = [];
		vm.item.itemPriceHistories = [];
		vm.item.itemPrices = [];
		vm.itemData = [];
		vm.branchList = [];
		vm.supplierList = [];
		vm.uomList = [];
		vm.priceUomList = [];
		vm.changeLogs = [];
		vm.salesConfigList = [];
		vm.debtorList = [];
		vm.uomBase = "";
		vm.uomInventory = "";
		vm.uomOrder = "";
		vm.uomDefault = "";
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.serverMode = Auth.getServerMode();
		vm.blobUrl = vm.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL;
		vm.isLoading = false;
		vm.currencyCode = Auth.getCurrency();

		vm.integrationMode = Auth.getIntegrationMode();
		vm.hasAutoCountFields = vm.integrationMode == 2 && Auth.autoCount_EnableSync_RawMat();
		vm.hasIDBFields = vm.integrationMode == 7 && Auth.idB_EnableSync_RawMat();
		vm.hasSQLFields = vm.integrationMode == 8 && Auth.sqL_EnableSync_RawMat();
		vm.autoCount_itemGroups = [];
		vm.autoCount_itemTypes = [];
		vm.idbItemTypes = [];
		vm.idbItemClasses = [];
		vm.sql_itemGroups = [];

		vm.changeLogs = [];
		vm.originalData = {};
		vm.newData = {};

		vm.item.imageLocation = '';
		vm.item.oriImageLocation = '';
		vm.fileToUpload = null;
		vm.mediaToUpload = null;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();

		/* ***************************************************************** */

		vm.initData = function() {

			if(vm.hasAutoCountFields) {
				vm.loadAutoCountItemTypes();
			} else if (vm.hasIDBFields) { 
				vm.loadIDBItemTypes();
			} else if (vm.hasSQLFields) {
				vm.loadSQLItemGroups();
			} else {
				vm.loadSupplierList();
			}
		}

		/* ***************************************************************** */

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ?
							$filter('filter')(vm.item.itemPriceHistories, tableState.search.predicateObject) : vm.item.itemPriceHistories;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.itemData = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {

			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			vm.numOfRecord = vm.item.itemPriceHistories.length;
			vm.itemDataFull = vm.item.itemPriceHistories;

			refreshTableState(tableState, vm.startIndex, vm.endIndex);
		};

		// Load Supplier List
		vm.loadSupplierList = function() {
			HttpSvc.get('suppliers/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.supplierList = result;
					vm.loadBranchList();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve supplier.', '');
					return null;
			});
		}

		// Load Branch List
		vm.loadBranchList = function() {
			vm.isLoading = true;

			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadUomList();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Branch List.', '');
					return null;
			});
		}

		// Load UOM List
		vm.loadUomList = function() {
			HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.uomList = result;
					vm.loadItem();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};

		vm.loadAutoCountItemTypes = function() {
			vm.isLoading = true;

			HttpSvc.get('autocount/maintenance/list/itemtypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_itemTypes = result;

					vm.loadAutoCountItemGroups();
				}, function() {
					toastr.error('Failed to load selected AutoCount Item Types.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};

		vm.loadAutoCountItemGroups = function() {
			HttpSvc.get('autocount/maintenance/list/itemgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_itemGroups = result;

					vm.loadSupplierList();
				}, function() {
					toastr.error('Failed to load selected AutoCount Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};

		vm.loadSQLItemGroups = function() {
			HttpSvc.get('sqlacc/maintenance/stockgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sql_itemGroups = result;
					vm.loadSupplierList();
				}, function() {
					toastr.error('Failed to load selected SQL Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};

		vm.loadIDBItemTypes = function() {
			vm.isLoading = true;

			HttpSvc.get('idbs/maintenance/list/poitemtypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.idbItemTypes = result;
					vm.loadIDBItemClasses();
				}, function() {
					toastr.error('Failed to load selected IDB Item Types.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};

		vm.loadIDBItemClasses = function() {
			vm.isLoading = true;
			HttpSvc.get('idbs/maintenance/list/poitemclasses', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.idbItemClasses = result;
					vm.loadSupplierList();
				}, function() {
					toastr.error('Failed to load selected IDB Item Classes.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};

		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('itemchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};

		// Load Item
		vm.loadItem = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('items/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.item = result;
					vm.originalData = angular.copy(vm.item);

					if(!vm.item.imageLocation || vm.item.imageLocation=='') {
						vm.item.imageLocation = 'assets/img/empty_placeholder.png';
						vm.item.oriImageLocation = "";
					} else {
						vm.item.oriImageLocation = vm.item.imageLocation;
						vm.item.imageLocation = vm.rootUrl + vm.item.imageLocation;
					}

					vm.item.itemUnitOfMeasurements.sort(function(a, b) {
						return a.baseMultiplier - b.baseMultiplier;
					});

					vm.item.itemUnitOfMeasurements.forEach(function(u) {
						if(u.unitOfMeasurementId==vm.item.cwm_ParallelUomId)
						{
							vm.selectedParallelUom1 = u;
						}
						if(u.unitOfMeasurementId==vm.item.cwm_ParallelUomId_Secondary)
						{
							vm.selectedParallelUom2 = u;
						}
					});

					vm.autoCount_itemTypes.forEach(function(c) {
						if(vm.item.autoCount_ItemType == c.itemType1){
							vm.selectedItemType = c;
						}
					});

					vm.autoCount_itemGroups.forEach(function(c) {
						if(vm.item.autoCount_ItemGroup == c.itemGroup1){
							vm.selectedItemGroup = c;
						}
					});

					vm.sql_itemGroups.forEach(function(c) {
						if(vm.item.sqL_ItemGroup == c.CODE){
							vm.selectedSQLItemGroup = c;
						}
					});

					vm.idbItemTypes.forEach(function(c) {
						if(vm.item.idB_ItemType == c.code){
							vm.selectedIDBItemType = c;
						}
					});

					vm.idbItemClasses.forEach(function(c) {
						if(vm.item.idB_ItemClass == c.code){
							vm.selectedIDBItemClass = c;
						}
					});

					if(vm.item.autoCount_StockControl) {
						vm.selectedStockControl = "1";
					} else {
						vm.selectedStockControl = "0";
						vm.item.autoCount_StockControl = false;
					}

					if(vm.item.sqL_StockControl) {
						vm.selectedSQLStockControl = "1";
					} else {
						vm.selectedSQLStockControl = "0";
						vm.item.sqL_StockControl = false;
					}

					try {
						if(vm.item.templateContent==null) {
							vm.item.templateContent = {};
						} else {
							vm.item.templateContent = angular.fromJson(vm.item.templateContent);
						}
					} catch (err) {
						vm.item.templateContent = {};
					}

					vm.loadDebtors();
					vm.loadChangeLogs();

					vm.refreshDisplayUom();
					$scope.$broadcast('refreshStTable');
				}, function() {
					toastr.error('Failed to load selected Item.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};

		// Load Certs
		vm.loadCertificates = function(itemId) {
			var params = { id: itemId };
			HttpSvc.get('itemcertificates/list/:id', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.item.itemCertificates = result;
					//$scope.$broadcast('refreshStTable');
				}, function() {
					toastr.error('Failed to load Certificates.', Auth.translate('ERROR'))
					return;
				});
		};

		// Load Debtor for Sales Config
		vm.loadDebtors = function() {
			HttpSvc.get('debtors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					vm.loadSalesConfigs();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Debtor List.', Auth.translate('ERROR'))
					return;
				});
		}

		// Load Sales Config List
		vm.loadSalesConfigs = function() {
			HttpSvc.get('itemdebtorsalesconfigs/list/byitem/' + vm.item.id, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.salesConfigList = result;
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Sales Config List.', Auth.translate('ERROR'))
					return;
				});
		};

		/* ***************************************************************** */

		vm.selectedItemTypeChanged = function() {
			vm.item.autoCount_ItemType = vm.selectedItemType.itemType1;
		}

		vm.selectedItemGroupChanged = function() {
			vm.item.autoCount_ItemGroup = vm.selectedItemGroup.itemGroup1;
		}

		vm.selectedSQLItemGroupChanged = function() {
			vm.item.sqL_ItemGroup = vm.selectedSQLItemGroup.CODE;
		}

		vm.selectedIDBItemTypeChanged = function() {
			vm.item.idB_ItemType = vm.selectedIDBItemType.code;
		}

		vm.selectedIDBItemClassChanged = function() {
			vm.item.idB_ItemClass = vm.selectedIDBItemClass.code;
		}

		vm.selectedStockControlChanged = function() {
			if(vm.selectedStockControl=="1") {
				vm.item.autoCount_StockControl = true;
			} else if(vm.selectedStockControl=="0") {
				vm.item.autoCount_StockControl = false;
			}
		}

		vm.selectedSQLStockControlChanged = function() {
			if(vm.selectedSQLStockControl=="1") {
				vm.item.sqL_StockControl = true;
			} else if(vm.selectedSQLStockControl=="0") {
				vm.item.sqL_StockControl = false;
			}
		}
		// *************************************************************

		vm.selectedParallelUom1Changed = function() {
			vm.item.cwm_ParallelUomId = vm.selectedParallelUom1.unitOfMeasurementId;
		}

		vm.selectedParallelUom2Changed = function() {
			vm.item.cwm_ParallelUomId_Secondary = vm.selectedParallelUom2.unitOfMeasurementId;
		}

		vm.verifyCWMSettings = function() {
			if(!vm.item.isCWM)
			{
				vm.item.syncCwmParallelUom = false;
				vm.item.cwm_ParallelUomId = null;
				vm.item.cwm_ParallelUomId_Secondary = null;
				vm.item.cwm_ParallelMultiplier = 0;
				vm.item.cwm_TolerencePercent = 0;
			}
		}

		// **********************************************

		// Get UOM
		vm.getDisplayUom = function(uomType) {
			var objBase = vm.item.itemUnitOfMeasurements.filter(function( obj ) {
				return obj.isBase==true;
			});
			var objInventory = vm.item.itemUnitOfMeasurements.filter(function( obj ) {
				return obj.isInventory==true;
			});
			var objOrder = vm.item.itemUnitOfMeasurements.filter(function( obj ) {
				return obj.isOrder==true;
			});
			var objDefault = vm.item.itemUnitOfMeasurements.filter(function( obj ) {
				return obj.isDefault==true;
			});

			if(uomType=="BASE") {
				return objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name;
			}
			if(uomType=="INVENTORY") {
				return objInventory.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objInventory[0].unitOfMeasurement.name;
			}
			if(uomType=="ORDER") {
				return objOrder.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objOrder[0].unitOfMeasurement.name;
			}
			if(uomType=="DEFAULT") {
				return objDefault.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objDefault[0].unitOfMeasurement.name;
			}
			return "x";
		}

		// **********************************************

		// Remove UOM
		vm.removeUom = function(index) {
			vm.item.itemUnitOfMeasurements.splice(index, 1);
			vm.refreshDisplayUom();
			$scope.$broadcast('refreshStTable');
		};

		// Update UOM
		vm.updateUom = function(index, obj) {
			var element = {
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,
				},
				baseMultiplier: obj.baseMultiplier,
				isBase: obj.isBase,
				isInventory: obj.isInventory,
				isOrder: obj.isOrder,
				isSales: obj.isSales,
				isDefault: obj.isDefault,
				remarks: obj.remarks,
			};

			if(element.isBase) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isBase = false;
				})
			}
			if(element.isInventory) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isInventory = false;
				})
			}
			if(element.isOrder) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isOrder = false;
				})
			}
			if(element.isSales) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isSales = false;
				})
			}
			if(element.isDefault) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isDefault = false;
				})
			}

			vm.item.itemUnitOfMeasurements.splice(index, 1, element);

			vm.item.itemUnitOfMeasurements.sort(function(a, b) {
				return a.baseMultiplier - b.baseMultiplier;
			});

			vm.refreshDisplayUom();
		};

		// Add UOM
		vm.addUom = function(obj) {
			var element = {
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,
				},
				baseMultiplier: obj.baseMultiplier,
				isBase: obj.isBase,
				isInventory: obj.isInventory,
				isOrder: obj.isOrder,
				isSales: obj.isSales,
				isDefault: obj.isDefault,
				remarks: obj.remarks,
			};

			if(element.isBase) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isBase = false;
				})
			}
			if(element.isInventory) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isInventory = false;
				})
			}
			if(element.isOrder) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isOrder = false;
				})
			}
			if(element.isSales) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isSales = false;
				})
			}
			if(element.isDefault) {
				vm.item.itemUnitOfMeasurements.forEach(function(p) {
					p.isDefault = false;
				})
			}

			vm.item.itemUnitOfMeasurements.push(element);

			vm.item.itemUnitOfMeasurements.sort(function(a, b) {
				return a.baseMultiplier - b.baseMultiplier;
			});

			vm.refreshDisplayUom();
		};

		// Refresh UOM List
		vm.refreshItemUoms = function(tableState) {
			// Do nothing
		};

		vm.refreshDisplayUom = function() {
			vm.uomBase = vm.getDisplayUom('BASE');
			vm.uomInventory = vm.getDisplayUom('INVENTORY');
			vm.uomOrder = vm.getDisplayUom('ORDER');
			vm.uomDefault = vm.getDisplayUom('DEFAULT');
		}

		// **********************************************

		// Remove Supplier
		vm.removeSupplier = function(index) {
			vm.item.itemPrices.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};

		// Update Supplier
		vm.updateSupplier = function(index, obj) {
			var element = {
				id: obj.id,
				itemId: obj.itemId,
				supplierId: obj.supplierId,
				supplier: {
					code: obj.supplierCode,
					name: obj.supplierName,
					currencyCode: obj.currencyCode
				},
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,
				},
				supplierItemDescription: ((obj.supplierItemDescription==""||obj.supplierItemDescription==null)?vm.item.description:obj.supplierItemDescription),
				quantity: obj.quantity,
				cost: obj.cost,
				tax: obj.tax,
				taxPercent: obj.taxPercent,
				costIncGst: obj.costIncGst,
				taxable: obj.taxable,
				taxCode: obj.taxCode,
				remarks: obj.remarks,
				isDefault: obj.isDefault,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
				modifiedBy: obj.modifiedBy,
				modifiedDate: obj.modifiedDate,
			};

			if(element.isDefault) {
				vm.item.itemPrices.forEach(function(p) {
					p.isDefault = false;
				})
			}

            var isElementValid = true;
            var item = vm.item.itemPrices;

            for (var i = 0; i < item.length; i++) {
                // If editing same item with the same supplier and UOM on the list, no need to check
                if (i !== index) {
                    // If the user tries to edit other item with existing supplier and UOM on the list, prompt error msg
                    if (item[i].supplier.name === element.supplier.name
                        && item[i].unitOfMeasurement.name === element.unitOfMeasurement.name) {
                        isElementValid = false;
                        toastr.error('Pricing entry with the same Supplier and UOM already exists.');
                    }
                }
            }

            if (isElementValid) {
                vm.item.itemPrices.splice(index, 1, element);
            }

		};

		// Add Supplier
		vm.addSupplier = function(obj) {
			var element = {
				supplierId: obj.supplierId,
				supplier: {
					code: obj.supplierCode,
					name: obj.supplierName,
					currencyCode: obj.currencyCode
				},
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,
				},
				supplierItemDescription: ((obj.supplierItemDescription==""||obj.supplierItemDescription==null)?vm.item.description:obj.supplierItemDescription),
				quantity: obj.quantity,
				cost: obj.cost,
				tax: obj.tax,
				taxPercent: obj.taxPercent,
				costIncGst: obj.costIncGst,
				taxable: obj.taxable,
				taxCode: obj.taxCode,
				remarks: obj.remarks,
				isDefault: obj.isDefault,
			};

			if(element.isDefault) {
				vm.item.itemPrices.forEach(function(p) {
					p.isDefault = false;
				})
			}

            var isElementValid = true;

            vm.item.itemPrices.forEach(function (item) {
                if (item.supplier.name === element.supplier.name
                    && item.unitOfMeasurement.name === element.unitOfMeasurement.name) {
                    isElementValid = false;
                    toastr.error('Pricing entry with the same Supplier and UOM already exists.');
                }
            })

            if (isElementValid) {
                vm.item.itemPrices.push(element);
            }
		};

		// Refresh UOM List
		vm.refreshItemPrices = function(tableState) {
			// Do nothing
		};

		// **********************************************

		// Remove Halal Cert
		vm.removeCert = function(certId) {
			HttpSvc.delete('itemcertificates/' + certId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('The Certificate has been removed.', Auth.translate('SUCCESS'));
					vm.loadCertificates(vm.item.id);
					//$scope.$broadcast('refreshStTable');
				}, function(error) {
					// Failed
					toastr.error('Failed to remove the Certificate.', 'Failed');
					return null;
				});
		};

		// Refresh UOM List
		vm.refreshItemCerts = function(tableState) {
			// Do nothing
		};
		// **********************************************

		// Open Step Modal Dialog
		vm.showAddCertModal = function () {
			vm.cert = {};
			vm.cert.itemId = vm.item.id;

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'certModal.html',
				controller: 'ItemCertModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.cert,
							serverMode: vm.serverMode,
							supplierList: vm.item.itemPrices,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadCertificates(vm.item.id);
				}, function () {
				});
		};
		vm.showEditCertModal = function (certId) {
			vm.cert = {};
			vm.item.itemCertificates.forEach(function(s){
				if(s.id==certId) {
					vm.cert = s;
				}
			});

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'certModal.html',
				controller: 'ItemCertModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.cert,
							serverMode: vm.serverMode,
							supplierList: vm.item.itemPrices,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadCertificates(vm.item.id);
				}, function () {
				});
		};

		// **********************************************

		// Open Modal Dialog
		vm.uom = {};
		vm.showAddUomModal = function () {
			vm.uom = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'uomModal.html',
				controller: 'ItemUomModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.uom,
							baseUom: vm.getDisplayUom('BASE'),
							uomList: vm.uomList
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addUom(data);
				}, function () {
				});
		};
		vm.showEditUomModal = function (index) {
			vm.uom = angular.copy(vm.item.itemUnitOfMeasurements[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'uomModal.html',
				controller: 'ItemUomModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.uom,
							baseUom: vm.getDisplayUom('BASE'),
							uomList: vm.uomList
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateUom(index, data);
				}, function () {
				});
		};

		// **********************************************

		vm.showAddParModal = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'parModal.html',
				controller: 'ItemParModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							itemId: vm.item.id,
							branchList: vm.branchList,
							uomInventory: vm.uomInventory,
							uomOrder: vm.uomOrder,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addParLevel(data);
				}, function () {
				});
		};
		vm.showEditParModal = function (index) {
			var parObject = angular.copy(vm.item.itemBranchConfigs[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'parModal.html',
				controller: 'ItemParModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							itemId: vm.item.id,
							branchList: vm.branchList,
							uomInventory: vm.uomInventory,
							uomOrder: vm.uomOrder,
							parObject: parObject
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateParLevel(index, data);
				}, function () {
				});
		};
		vm.removePar = function (index) {
			vm.item.itemBranchConfigs.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};
		vm.addParLevel = function(data) {
			vm.item.itemBranchConfigs.push(data);
		};
		vm.updateParLevel = function(index, data) {
			var obj = vm.item.itemBranchConfigs[index];
			obj.branchId = data.branchId;
			obj.mon = data.mon;
			obj.tue = data.tue;
			obj.wed = data.wed;
			obj.thu = data.thu;
			obj.fri = data.fri;
			obj.sat = data.sat;
			obj.sun = data.sun;
			obj.reOrderLevel = data.reOrderLevel;
			obj.reOrderQuantity = data.reOrderQuantity;
			obj.parLevel = data.parLevel;
		};

		// **********************************************

		vm.supplier	= {};
		vm.showAddSupplierModal = function () {
			vm.supplier = {};

			vm.priceUomList = [];
			vm.item.itemUnitOfMeasurements.forEach(function(u) {
				vm.priceUomList.push({ id: u.unitOfMeasurementId, name: u.unitOfMeasurement.name });
			})

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'supplierModal.html',
				controller: 'ItemSupplierPriceModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.supplier,
							supplierList: vm.supplierList,
							uomList: vm.priceUomList,
							currencyCode: vm.currencyCode
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addSupplier(data);
				}, function () {
				});
		};
		vm.showEditSupplierModal = function (index) {
			vm.supplier = angular.copy(vm.item.itemPrices[index]);

			vm.priceUomList = [];
			vm.item.itemUnitOfMeasurements.forEach(function(u) {
				vm.priceUomList.push({ id: u.unitOfMeasurementId, name: u.unitOfMeasurement.name });
			})

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'supplierModal.html',
				controller: 'ItemSupplierPriceModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.supplier,
							supplierList: vm.supplierList,
							uomList: vm.priceUomList,
							currencyCode: vm.currencyCode
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateSupplier(index, data);
				}, function () {
				});
		};

		// **********************************************

		vm.showAddSalesConfig = function () {

			vm.priceUomList = [];
			vm.item.itemUnitOfMeasurements.forEach(function(u) {
				vm.priceUomList.push({ id: u.unitOfMeasurementId, name: u.unitOfMeasurement.name });
			})

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'salesConfigModal.html',
				controller: 'ItemSalesConfigModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							itemId: vm.item.id,
							debtorList: vm.debtorList,
							currencyCode: vm.currencyCode,
							uomList: vm.priceUomList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadSalesConfigs();
				}, function () {
				});
		};
		vm.showEditSalesConfig = function (configId) {

			vm.priceUomList = [];
			vm.item.itemUnitOfMeasurements.forEach(function(u) {
				vm.priceUomList.push({ id: u.unitOfMeasurementId, name: u.unitOfMeasurement.name });
			})

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'salesConfigModal.html',
				controller: 'ItemSalesConfigModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							itemId: vm.item.id,
							configId: configId,
							debtorList: vm.debtorList,
							currencyCode: vm.currencyCode,
							uomList: vm.priceUomList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadSalesConfigs();
				}, function () {
				});
		};
		vm.deleteSalesConfig = function (configId) {
			vm.isLoading = true;

			HttpSvc.delete('itemdebtorsalesconfigs/' + configId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Sales Config deleted successfully.', 'Delete Successful');
					vm.loadSalesConfigs();
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to delete the config. ' + error, 'Delete Failed');
					return null;
			});
		};

		// **********************************************

		// View Revision Modal Dialog
		vm.showRevisionModal = function (logId) {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'auditLogModal.html',
				controller: 'ItemAuditLogModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							logId: logId,
							itemId: vm.item.id,
							invUom: vm.uomInventory,
							orderUom: vm.uomOrder,
							currentData: vm.originalData
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					$state.reload();
				}, function () {
				});
		};

		/* ***************************************************************** */

		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}

		// Set Upload Image
		vm.clearImage = function() {
			vm.item.imageLocation = 'assets/img/empty_placeholder.png';
			vm.item.oriImageLocation = '';
			vm.fileToUpload = null;
		}

		// Upload Image to Azure Blob Storage
		vm.uploadImage = function () {
			var fileReader = new FileReader();

			if(vm.serverMode==0) {	// Local Server

				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Raw Material has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('Raw Material has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
				});

			} else if(vm.serverMode==1) { // Azure Server

				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {
							toastr.success('Raw Material has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						}
					}, null, function(evt) {
					});
				}
			}
		};

		/* ***************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, 'Incomplete Fields');
			} else {
				vm.isLoading = false;

				vm.newData = vm.item;

				vm.verifyCWMSettings();

				imgLocation = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				vm.item.templateContent = angular.toJson(vm.item.templateContent);

				if(vm.serverMode==1 && vm.fileToUpload) {

					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/rawmaterials/" + newFilename + mediaExtension;

				} else if(vm.serverMode==0 && vm.fileToUpload) {

					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "rawmaterials/" + newFilename + mediaExtension;

				} else if(vm.item.oriImageLocation!="") {
					imgLocation = vm.item.oriImageLocation;
				}
				vm.item.imageLocation = imgLocation;

				HttpSvc.put('items/' + $stateParams.id, vm.item, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Failed');
						vm.item.templateContent = angular.fromJson(vm.item.templateContent);
					});
			}
		}

		vm.checkResult = function(result) {
			azureStorageUrl = "";
			localStorageUrl = "";

			if(result.httpStatusCode=="200")
			{
				if(vm.serverMode==1 && vm.fileToUpload) {
					azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
					vm.uploadImage();

				} else if(vm.serverMode==0 && vm.fileToUpload) {
					localStorageUrl = RmsApi.URL + "upload/rawmaterials/" + $stateParams.id;
					vm.uploadImage();

				} else {
					toastr.success('Raw Material has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}
			}
			else
			{
				vm.isLoading = false;
				toastr.error(result.message, 'Failed');
				vm.item.templateContent = angular.fromJson(vm.item.templateContent);
			}
		}

		// **********************************************

		// Call Actions
		vm.initData();
	};

	/** @ngInject */
	function ItemImportCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();

		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.importType = 1;
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;
		vm.selectedPOList = [];

		/* **************************************************** */

		vm.scrollLeft = function() {
			document.getElementById('scroll-container').scrollLeft -= 300;
		}

		vm.scrollRight = function() {
			document.getElementById('scroll-container').scrollLeft += 300;
		}

		/* **************************************************** */

		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";

		/* **************************************************** */

		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		vm.importOptions.createItem = true;
		vm.importOptions.updateItem = true;
		vm.importOptions.createSupplier = true;
		vm.importOptions.updateSupplier = true;
		vm.importOptions.createPricing = true;
		vm.importOptions.updatePricing = true;
		vm.importOptions.createUom = true;
		vm.importOptions.updateUom = true;

		/* **************************************************** */

		vm.goBack = function() {
			$state.reload();
		}

		/* **************************************************** */

		vm.importResult = {};

		/* **************************************************** */

		vm.downloadTemplate = function(templateNo, templateName) {

			var filename = templateName + ".xlsx";
			vm.isExporting = true;

			HttpSvc.getExcelObject('items/download/template' + templateNo, Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;
					},
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};

		vm.downloadTemplateOther = function(templateName) {

			var filename = templateName + ".xlsx";
			vm.isExporting = true;

			HttpSvc.getExcelObject('itemdebtorsalesconfigs/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;
					},
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};

		/* **************************************************** */

		vm.importData = function() {

			if(vm.importType=="1")
			{
				if(vm.selectedPOList.length==0)
				{
					var result = confirm("You haven't selected any Purchase Order.\nConfirm proceed with import?");
					if(!result)	return;
				}
			}

			vm.isImporting = true;

			HttpSvc.post('items/importData' + vm.importType, vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
					//vm.lockButtons = false;
					//vm.isImportComplete = true;

					//vm.importResult = result;

					//toastr.success("Data imported successfully!");
					//$state.go('maintenance.items.list');
				}, function(error) {
					//vm.lockButtons = false;
					//vm.isImportFailed = true;

					//toastr.error("Failed to import data! " + error);
				});
		}

		vm.importDataOther = function() {
			vm.isImporting = true;

			HttpSvc.post('itemdebtorsalesconfigs/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
				}, function(error) {
				});
		}

		/* **************************************************** */

		vm.selectPO = function () {

			var selectedPOList = angular.copy(vm.selectedPOList);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'purchaseOrderListModal.html',
				controller: 'ItemImportSelectPOModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							poList: selectedPOList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (poList) {
					vm.selectedPOList = poList;
					vm.importOptions.updatePurchaseOrderPricing = angular.copy(vm.selectedPOList);
				}, function () {
				});
		};


		/* **************************************************** */

		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}

		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;
		}

		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];

			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}

		// Upload File
		vm.uploadFile = function(importType) {
			vm.resetFileUploadParams();

			vm.lockButtons = true;
			vm.importType = importType;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;

			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;

			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();
				vm.uploadMedia(vm.mediaToUpload);
			}
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {

						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);

					}, function(error) {
						toastr.error(error, 'Failed');

						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}

		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {

			if(vm.serverMode==0) {	// Local Server

				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					vm.isUploaded = true;

					// Call Process Excel API
					var apiUrl = 'items/import/' + vm.importType + '/' + resp.data;
					if(vm.importType == "5")
					{
						apiUrl = 'itemdebtorsalesconfigs/import/' + resp.data;
					}

					HttpSvc.post(apiUrl, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;

							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});

			}  else if(vm.serverMode==1) { // Azure Server

				/* Initialize variables */
				/* ************************************* */
				handleFileSelect(_fileToUpload);
				/* ************************************* */

				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */

				/* Upload File (First Block) */
				/* ************************************* */
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);

				fileReader.onload = function(e) {
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];

						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,
						}).then(function(response) {
							if (response.status==201) {
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							}
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));

							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};

		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;

            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }

        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);

                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);

				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }

        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';

			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,
			}).then(function(response) {
				vm.isUploaded = true;

				// Call Process Excel API
				var apiUrl = 'items/import/' + vm.importType + '/' + excelFilename;
				if(vm.importType == "5")
				{
					apiUrl = 'itemdebtorsalesconfigs/import/' + excelFilename;
				}

				HttpSvc.post(apiUrl, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;

						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }

        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }
	};

	// U.O.M. Modal Controller
	function ItemUomModalCtrl($uibModalInstance, item, toastr, UtilSvc) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.baseUom = item.baseUom;
		$mdl.uomList = item.uomList;
		$mdl.item = item.object;
		$mdl.selectedUom = null;

		// Initialize
		if(item.mode==1) {
			$mdl.item.unitOfMeasurementId = null;
			$mdl.item.uomName = "";
			$mdl.item.baseMultiplier = 1;
			$mdl.item.isBase = false,
			$mdl.item.isInventory = false,
			$mdl.item.isOrder = false,
			$mdl.item.isDefault = false,
			$mdl.item.remarks = "";
		} else {
			if($mdl.item.unitOfMeasurementId!='' && $mdl.item.unitOfMeasurementId!=null){
				$mdl.uomList.forEach(function (i) {
					if(i.id==$mdl.item.unitOfMeasurementId) {
						$mdl.selectedUom = i;
						$mdl.item.uomName = i.name;
					}
				});
			};
		}

		$mdl.onSelectedUomChanged = function() {
			$mdl.item.unitOfMeasurementId = $mdl.selectedUom.id;
			$mdl.item.uomName = $mdl.selectedUom.name;
		};

		$mdl.confirmModal = function() {
			if($mdl.uomForm.$invalid)
			{
				var errorMsg = UtilSvc.getErrorMessage($mdl.uomForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			}
			else
			{
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	// PAR Modal Controller
	function ItemParModalCtrl($uibModalInstance, item, toastr, UtilSvc) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.branchList = item.branchList;
		$mdl.uomInventory = item.uomInventory;
		$mdl.uomOrder = item.uomOrder;
		$mdl.parObject = item.parObject;
		$mdl.selectedBranch = null;
		$mdl.item = {};
		$mdl.item.itemId = item.itemId;

		/* *************************************************** */

		$mdl.selectedBranchChanged = function() {
			$mdl.item.branchId = $mdl.selectedBranch.id;
			$mdl.item.branch = {}
			$mdl.item.branch.name = $mdl.selectedBranch.name;
		};

		// Initialize
		if(item.mode==2) {
			$mdl.item = item.parObject;
			$mdl.branchList.forEach(function(b) {
				if(b.id == $mdl.parObject.branchId)
				{
					$mdl.selectedBranch = b;
					$mdl.selectedBranchChanged();
				}
			})
		}

		$mdl.isValidDays = function()  {
			return !$mdl.item.mon && !$mdl.item.tue && !$mdl.item.wed && !$mdl.item.thu && !$mdl.item.fri && !$mdl.item.sat && !$mdl.item.sun
		}

		/* *************************************************** */

		$mdl.confirmModal = function() {
			if($mdl.parForm.$invalid)
			{
				var errorMsg = UtilSvc.getErrorMessage($mdl.parForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			}
			else
			{
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	// Supplier Modal Controller
	function ItemSupplierPriceModalCtrl($uibModalInstance, item, toastr, UtilSvc) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.supplierList = item.supplierList;
		$mdl.uomList = item.uomList;
		$mdl.item = item.object;
		$mdl.selectedSupplier = null;
		$mdl.selectedUom = null;
		$mdl.currencyCode = item.currencyCode;

		// Initialize
		if(item.mode==1) {
			$mdl.item.supplierId = "";
			$mdl.item.supplierCode = "";
			$mdl.item.supplierName = "";
			$mdl.item.supplierItemDescription = "";
			$mdl.item.unitOfMeasurementId = "";
			$mdl.item.uomName = "";
			$mdl.item.quantity = 1;
			$mdl.item.cost = 0;
			$mdl.item.tax = 0;
			$mdl.item.taxPercent = 0;
			$mdl.item.costIncGst = 0;
			$mdl.item.taxCode = "ZR";
			$mdl.item.taxable = "";
			$mdl.item.isDefault = false;
		} else {
			if($mdl.item.supplierId!='' && $mdl.item.supplierId!=null){
				$mdl.supplierList.forEach(function (i) {
					if(i.id==$mdl.item.supplierId) {
						$mdl.selectedSupplier = i;
						$mdl.item.supplierCode = i.code;
						$mdl.item.supplierName = i.name;
						$mdl.item.currencyCode = i.currencyCode;
					}
				});
			};
			if($mdl.item.unitOfMeasurementId!='' && $mdl.item.unitOfMeasurementId!=null){
				$mdl.uomList.forEach(function (i) {
					if(i.id==$mdl.item.unitOfMeasurementId) {
						$mdl.selectedUom = i;
						$mdl.item.uomName = i.name;
					}
				});
			};
		}

		$mdl.onQuantityChanged = function() {
			if($mdl.item.quantity<=0) {
				$mdl.supplierForm.Quantity.$error.required = true;
			} else {
				$mdl.supplierForm.Quantity.$error.required = false;
			}
		};

		$mdl.onCostChanged = function() {
			if($mdl.item.cost<0) {
				$mdl.supplierForm.Cost.$error.required = true;
			} else {
				$mdl.supplierForm.Cost.$error.required = false;
			}
			if($mdl.item.cost==0) return;

			$mdl.item.tax = $mdl.item.taxPercent * $mdl.item.cost / 100;
			$mdl.item.tax = parseFloat($mdl.item.tax.toFixed(3));
			$mdl.item.costIncGst = $mdl.item.cost + $mdl.item.tax;
		};

		$mdl.onTaxChanged = function() {
			if($mdl.item.tax<0) {
				$mdl.supplierForm.Tax.$error.required = true;
			} else {
				$mdl.supplierForm.Tax.$error.required = false;
			}
			$mdl.item.costIncGst = $mdl.item.cost + $mdl.item.tax;
		};

		$mdl.onTaxPercentChanged = function() {
			if($mdl.item.taxPercent<0) {
				$mdl.supplierForm.TaxPercent.$error.required = true;
			} else {
				$mdl.supplierForm.TaxPercent.$error.required = false;
			}
			if($mdl.item.cost==0) return;

			$mdl.item.tax = $mdl.item.taxPercent * $mdl.item.cost / 100;
			$mdl.item.tax = parseFloat($mdl.item.tax.toFixed(3));
			$mdl.item.costIncGst = $mdl.item.cost + $mdl.item.tax;
		};

		$mdl.onCostInclGstChanged = function() {
			if($mdl.item.costIncGst<=0) {
				$mdl.supplierForm.CostInclGst.$error.required = true;
			} else {
				$mdl.supplierForm.CostInclGst.$error.required = false;
			}
		};

		$mdl.onSelectedSupplierChanged = function() {
			$mdl.item.supplierId = $mdl.selectedSupplier.id;
			$mdl.item.supplierCode = $mdl.selectedSupplier.code;
			$mdl.item.supplierName = $mdl.selectedSupplier.name;
			$mdl.item.currencyCode = $mdl.selectedSupplier.currencyCode;

			if($mdl.item.supplierId=="")
				$mdl.supplierForm.Supplier.$error.required = true;
			else
				$mdl.supplierForm.Supplier.$error.required = false;
		};

		$mdl.onSelectedUomChanged = function() {
			$mdl.item.unitOfMeasurementId = $mdl.selectedUom.id;
			$mdl.item.uomName = $mdl.selectedUom.name;

			if($mdl.item.unitOfMeasurementId=="")
				$mdl.supplierForm.UOM.$error.required = true;
			else
				$mdl.supplierForm.UOM.$error.required = false;
		};

		$mdl.confirmModal = function() {
			// var isValid = true;

			// // Check Supplier
			// if($mdl.item.supplierId=="" || $mdl.item.supplierId==null) {
			// 	$mdl.supplierForm.Supplier.$error.required = true;
			// 	isValid = false;
			// } else {
			// 	$mdl.supplierForm.Supplier.$error.required = false;
			// }
			// // Check UOM
			// if($mdl.item.unitOfMeasurementId=="" || $mdl.item.unitOfMeasurementId==null) {
			// 	$mdl.supplierForm.UOM.$error.required = true;
			// 	isValid = false;
			// } else {
			// 	$mdl.supplierForm.UOM.$error.required = false;
			// }
			// // Check Quantity
			// if($mdl.item.quantity<=0 || $mdl.item.quantity==null) {
			// 	$mdl.supplierForm.Quantity.$error.required = true;
			// 	isValid = false;
			// } else {
			// 	$mdl.supplierForm.Quantity.$error.required = false;
			// }
			// // Check Tax Code
			// if($mdl.item.taxCode=="") {
			// 	$mdl.supplierForm.TaxCode.$error.required = true;
			// 	isValid = false;
			// } else {
			// 	$mdl.supplierForm.TaxCode.$error.required = false;
			// }
			// // Check Tax Percent
			// if($mdl.item.taxPercent<0 || $mdl.item.taxPercent==null) {
			// 	$mdl.supplierForm.TaxPercent.$error.required = true;
			// 	isValid = false;
			// } else {
			// 	$mdl.supplierForm.TaxPercent.$error.required = false;
			// }
			// // Check Cost
			// if($mdl.item.cost<=0 || $mdl.item.cost==null) {
			// 	$mdl.supplierForm.Cost.$error.required = true;
			// 	isValid = false;
			// } else {
			// 	$mdl.supplierForm.Cost.$error.required = false;
			// }
			// // Check Cost Incl. Tax
			// if($mdl.item.costIncGst<=0 || $mdl.item.costIncGst==null) {
			// 	$mdl.supplierForm.CostIncGst.$error.required = true;
			// 	isValid = false;
			// } else {
			// 	$mdl.supplierForm.CostIncGst.$error.required = false;
			// }

			if($mdl.supplierForm.$invalid)
			{
				var errorMsg = UtilSvc.getErrorMessage($mdl.supplierForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			}
			else
			{
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	// Sales Config Modal Controller
	function ItemSalesConfigModalCtrl($uibModalInstance, Auth, HttpSvc, UtilSvc, item, toastr) {
		var $mdl = this;

		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.itemId = item.itemId;
		$mdl.configId = item.configId;
		$mdl.currencyCode = item.currencyCode;
		$mdl.debtorList = item.debtorList;
		$mdl.uomList = item.uomList;
		$mdl.selectedDebtor = null;
		$mdl.selectedUom = null;
		$mdl.item = {};
		$mdl.item.itemId = item.itemId;
		$mdl.isLoading = false;

		/* ********************************************************************** */

		$mdl.loadConfig = function() {
			$mdl.isLoading = true;

			HttpSvc.get('itemdebtorsalesconfigs/' + $mdl.configId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.item = result;
					$mdl.debtorList.forEach(function(d) {
						if(d.id==$mdl.item.debtorId) {
							$mdl.selectedDebtor = d;
						}
					});
					$mdl.uomList.forEach(function(u) {
						if(u.id==$mdl.item.uomId) {
							$mdl.selectedUom = u;
						}
					});
					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve Sales Config.', Auth.translate('ERROR'));
					$mdl.cancelModal();
			});
		}

		$mdl.createConfig = function() {
			$mdl.isLoading = true;

			HttpSvc.post('itemdebtorsalesconfigs/add', $mdl.item, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('New Sales Config created succeasfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close();
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to create Sales Config.', Auth.translate('ERROR'));
			});
		}

		$mdl.updateConfig = function() {
			$mdl.isLoading = true;

			HttpSvc.put('itemdebtorsalesconfigs/' + $mdl.configId, $mdl.item, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Sales Config updated succeasfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close();
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to update Sales Config.', Auth.translate('ERROR'));
			});
		}

		/* ********************************************************************** */

		$mdl.selectedDebtorChanged = function() {
			$mdl.item.debtorId = $mdl.selectedDebtor.id;
		}

		$mdl.selectedUomChanged = function() {
			$mdl.item.uomId = $mdl.selectedUom.id;
		}

		$mdl.unitPriceChanged = function() {
			if($mdl.item.taxPercentage<0) {
				$mdl.salesConfigForm.TaxPercent.$error.required = true;
			} else {
				$mdl.salesConfigForm.TaxPercent.$error.required = false;
			}
			if($mdl.item.unitPrice==0) return;

			$mdl.item.taxAmount = $mdl.item.taxPercentage * $mdl.item.unitPrice / 100;
			$mdl.item.taxAmount = parseFloat($mdl.item.taxAmount.toFixed(3));
		};

		$mdl.taxPercentChanged = function() {
			if($mdl.item.taxPercentage<0) {
				$mdl.salesConfigForm.TaxPercent.$error.required = true;
			} else {
				$mdl.salesConfigForm.TaxPercent.$error.required = false;
			}
			if($mdl.item.unitPrice==0) return;

			$mdl.item.taxAmount = $mdl.item.taxPercentage * $mdl.item.unitPrice / 100;
			$mdl.item.taxAmount = parseFloat($mdl.item.taxAmount.toFixed(3));
		};

		/* ********************************************************************** */

		// Confirm Action
		$mdl.confirmModal = function() {
			if($mdl.salesConfigForm.$invalid)
			{
				var errorMsg = UtilSvc.getErrorMessage($mdl.salesConfigForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			}
			else
			{
				if(item.mode==1) {
					$mdl.createConfig();
				} else {
					$mdl.updateConfig();
				}
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ********************************************************************** */

		// Initialize
		if(item.mode==1) {
		} else {
			$mdl.loadConfig();
		}
	};

	// Halal Cert Modal Controller
	function ItemCertModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;

		$mdl.serverMode = item.serverMode;
		$mdl.rootUrl = ($mdl.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);

		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.item = item.object;
		$mdl.supplierList = item.supplierList;
		$mdl.lockUploadButton = item.lockUploadButton;
		$mdl.lockButton = false;
		$mdl.uploadProgess = 0;
		$mdl.uploadProgessTotal = 0;
		$mdl.uploadProgessPercent = 0;
		var azureStorageUrl = "";
		var localStorageUrl = "";

		// Initialize
		if(item.mode==1) {
			$mdl.item.supplierId = "";
			$mdl.item.certType = "";
			$mdl.item.certRefNo = "";
			$mdl.item.issueDate = "";
			$mdl.item.expiryDate = "";
			$mdl.item.remarks = "";
			$mdl.item.certFilename = "";
		} else {
			$mdl.item.issueDate = $filter('date')($mdl.item.issueDate, 'yyyy-MM-dd');
			$mdl.item.expiryDate = $filter('date')($mdl.item.expiryDate, 'yyyy-MM-dd');

			$mdl.supplierList.forEach(function(s) {
				if(s.supplierId==$mdl.item.supplierId) {
					$mdl.selectedSupplier = s;
				}
			});
		}

		$mdl.selectedSupplierChanged = function() {
			$mdl.item.supplierId = $mdl.selectedSupplier.supplierId;
		}

		// Update Halal Cert
		$mdl.updateCert = function(obj) {
			$mdl.lockButton = true;

			var element = {
				id: obj.id,
				itemId: obj.itemId,
				supplierId: obj.supplierId,
				certType: obj.certType,
				certRefNo: obj.certRefNo,
				issueDate: obj.issueDate,
				expiryDate: obj.expiryDate,
				remarks: obj.remarks,
				certFilename: obj.certFilename,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
			};

			var mediaLocation = "";
			var mediaExtension = "";
			var newFilename = UtilSvc.generateGuid() + ".";
			azureStorageUrl = "";
			localStorageUrl = "";

			if($mdl.serverMode==1 && obj.mediaToUpload) {

				var extArray = obj.mediaToUpload.name.split(".");
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = Auth.getCompanyId() + "/certificates/" + newFilename + mediaExtension;

			} else if($mdl.serverMode==0 && obj.mediaToUpload) {

				var extArray = obj.mediaToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = "certificates/" + newFilename + mediaExtension;
			}
			if(mediaLocation!="") {
				element.certFilename = mediaLocation;
			}

			HttpSvc.put('itemcertificates/' + obj.id, element, Auth.getTokenId(), false)
				.then(function(result) {

					if($mdl.serverMode==1 && obj.mediaToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + mediaLocation + result.azureSasToken;
						$mdl.uploadMedia(obj.mediaToUpload);

					} else if($mdl.serverMode==0 && obj.mediaToUpload) {
						localStorageUrl = RmsApi.URL + "upload/certificates/" + obj.id;
						$mdl.uploadMedia(obj.mediaToUpload);

					} else {
						$uibModalInstance.close($mdl.item);
					}
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					$mdl.lockButton = false;
					$mdl.certForm.$setPristine();
				});
		};

		// Add Halal Cert
		$mdl.addCert = function(obj) {
			$mdl.lockButton = true;

			var element = {
				itemId: obj.itemId,
				supplierId: obj.supplierId,
				certType: obj.certType,
				certRefNo: obj.certRefNo,
				issueDate: obj.issueDate,
				expiryDate: obj.expiryDate,
				remarks: obj.remarks,
			};

			var mediaLocation = "";
			var mediaExtension = "";
			var newFilename = UtilSvc.generateGuid() + ".";
			azureStorageUrl = "";
			localStorageUrl = "";

			if($mdl.serverMode==1 && obj.mediaToUpload) {

				var extArray = obj.mediaToUpload.name.split(".");
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = Auth.getCompanyId() + "/certificates/" + newFilename + mediaExtension;

			} else if($mdl.serverMode==0 && obj.mediaToUpload) {

				var extArray = obj.mediaToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = "certificates/" + newFilename + mediaExtension;

			}

			element.certFilename = mediaLocation;

			HttpSvc.post('itemcertificates', element, Auth.getTokenId(), false)
				.then(function(result) {

					if($mdl.serverMode==1 && obj.mediaToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + mediaLocation + result.azureSasToken;
						$mdl.uploadMedia(obj.mediaToUpload);

					} else if($mdl.serverMode==0 && obj.mediaToUpload) {
						localStorageUrl = RmsApi.URL + "upload/certificates/" + result.id;
						$mdl.uploadMedia(obj.mediaToUpload);

					} else {
						$uibModalInstance.close($mdl.item);
					}
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					$mdl.lockButton = false;
					$mdl.certForm.$setPristine();
				});
		};

		// ********************************************************

        var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();

		// Upload Image to Azure Blob Storage
		$mdl.uploadMedia = function (_fileToUpload) {

			/* Initialize variables */
			/* ************************************* */
			handleFileSelect(_fileToUpload);
			/* ************************************* */

			/* Initialize File Reader */
			/* ************************************* */
			fileReader = new FileReader();
			/* ************************************* */

			if($mdl.serverMode==0) {	// Local Server

				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (resp) {
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});

			} else if($mdl.serverMode==1) { // Azure Server

				/* Upload File (First Block) */
				/* ************************************* */
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);

				fileReader.onload = function(e) {
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];

						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,
						}).then(function(response) {
							if (response.status==201) {
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								$mdl.lockButton = false;
								$mdl.certForm.$setPristine();
							}
						}, null, function(evt) {
							$mdl.uploadProgessTotal = _fileToUpload.size;
							$mdl.uploadProgess = $mdl.uploadProgessTotal - totalBytesRemaining;
							$mdl.uploadProgessPercent = Math.min(100, parseInt(100.0 * $mdl.uploadProgess / $mdl.uploadProgessTotal).toFixed(2));

							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};

		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;

            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }

        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);

                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);

				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }

        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';

			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,

			}).then(function(response) {
				toastr.success("Media uploaded successfully.");
				$uibModalInstance.close($mdl.item);
			});
        }

        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }

		// ********************************************************

		//Set Upload Media
		$mdl.setUploadMedia = function(mediaFile) {
			$mdl.item.mediaToUpload = mediaFile;
		}

		// Confirm Action
		$mdl.confirmModal = function() {
			if($mdl.certForm.$valid) {
				if(item.mode==1) {
					$mdl.addCert($mdl.item);
				} else if(item.mode==2) {
					$mdl.updateCert($mdl.item);
				}
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	// Audit Log Modal Controller
	function ItemAuditLogModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;

		$mdl.logId = item.logId;
		$mdl.itemId = item.itemId;
		$mdl.invUom = item.invUom;
		$mdl.orderUom = item.orderUom;
		$mdl.log = {};
		$mdl.oriData = {};
		$mdl.newData = {};
		$mdl.currentData = item.currentData;
		$mdl.isLoading = false;

		/* ************************************************************** */

		$mdl.loadData = function() {
			$mdl.isLoading = true;

			HttpSvc.get('itemchangelogs/' + $mdl.logId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.log = result;

					$mdl.oriData = angular.fromJson($mdl.log.originalData);
					$mdl.newData = angular.fromJson($mdl.log.newData);
					$mdl.isLoading = false;
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to load Audit Log. ' + error, Auth.translate('ERROR'))
					$mdl.cancelModal();
				});
		}

		$mdl.saveChangeLog = function() {

			var originalData = JSON.stringify($mdl.currentData);
			var newData = JSON.stringify($mdl.oriData);

			var changeLog = {
				itemId: $mdl.itemId,
				newData: newData,
				originalData: originalData,
				remarks: 'REVERT TO ORIGINAL'
			};

			HttpSvc.post('itemchangelogs', changeLog, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.isLoading = false;
					toastr.success('Revision has been reverted successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close();
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to revert.' + error, 'Failed');
				});
		}

		$mdl.revertRevision = function() {
			$mdl.isLoading = true;

			HttpSvc.put('items/' + $mdl.itemId, $mdl.oriData, Auth.getTokenId(), false)
				.then(function() {
					$mdl.saveChangeLog();
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ************************************************************** */

		// Confirm Action
		$mdl.confirmModal = function() {
			var cfm = confirm("Confirm proceed to revert the Revision?");

			if(cfm)
			{
				$mdl.revertRevision();
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ************************************************************** */

		$mdl.loadData();
	};

	/** @ngInject */
	function ItemImportSelectPOModalCtrl($uibModalInstance, $filter, $scope, Auth, RmsApi, HttpSvc, item, toastr) {
		var $mdl = this;

		$mdl.pageSizeOption = [10, 20, 50, 100];
		$mdl.pageSize = $mdl.pageSizeOption[0];
		$mdl.numOfRecord = 0;
		$mdl.numOfRecordFiltered = 0;
		$mdl.numOfRecordDisplayed = 0;
		$mdl.startIndex = 0;
		$mdl.endIndex = 0;
		$mdl.poDataFull = [];
		$mdl.poData = [];
		$mdl.isLoading = false;
		$mdl.selectedPOs = item.poList;

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.poDataFull, tableState.search.predicateObject) : $mdl.poDataFull;
			$mdl.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			$mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
			$mdl.poData = result;

			tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		$mdl.retrieveData = function(tableState) {

			$mdl.tableState = tableState;

			var pagination = tableState.pagination;
			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

			if($mdl.poDataFull.length <= 0) {
				$mdl.isLoading = true;

				HttpSvc.get('purchaseorders/list/approvedwithoutcheckqtyfulfilled', {}, Auth.getTokenId(), true)
					.then(function(result) {
						$mdl.numOfRecord = result.length;
						$mdl.poDataFull = result;
						refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
						$mdl.isLoading = false;
					}, function() {
						$mdl.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
			}
		};

		// ********************************************************

		$mdl.confirmModal = function() {
			$uibModalInstance.close($mdl.selectedPOs);
		}

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.multilevelapprovals.controller', [])
        .controller('MultiLevelApprovalsMainCtrl', MultiLevelApprovalsMainCtrl)
        .controller('MultiLevelApprovalsCreateCtrl', MultiLevelApprovalsCreateCtrl)
        .controller('MultiLevelApprovalsUpdateCtrl', MultiLevelApprovalsUpdateCtrl);

    /** @ngInject */
    function MultiLevelApprovalsMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.mlaDataFull = [];
		vm.mlaData = [];
		vm.currency = Auth.getCurrency();

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.mlaDataFull, tableState.search.predicateObject) : vm.mlaDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.mlaData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.mlaDataFull.length <= 0) {							
				HttpSvc.get('approvalconfigs/list', {}, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.mlaDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteConfig = function(warehousesId, warehousesName) {
			var params = {};
			HttpSvc.delete('approvalconfigs/' + warehousesId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('approvalconfigs/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.mlaDataFull = result;
							
							toastr.success('The Configuration [<b>' + warehousesName + '</b>] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Configuration [' + warehousesName + '].', 'Delete Failed');
					return null;
			});
		};		
		
		vm.getModuleName = function(moduleCode) {
			var modules = getModules();

			var moduleName = "";

			modules.forEach(function(m) {
				if(m.id==moduleCode)
				{
					moduleName = m.name;
				}
			});

			return moduleName;
		}
	};
	
	/** @ngInject */
    function MultiLevelApprovalsCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();
		
		var vm = this;
		vm.mode = 1;
		vm.mla = {};
		vm.mla.approvalStoreConfigs = [];
		vm.mla.approvalUserGroupConfigs = [];
		vm.branchList = [];
		vm.ugList = [];
		vm.moduleList = getModules();
		vm.conditionList = getConditions();
		vm.lockButtons = false;
		vm.addStorePanelVisible = false;
		vm.selectedType = null;
		vm.currency = Auth.getCurrency();

		/* ********************************************************* */

		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadUsergroups();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});			
		}

		vm.loadUsergroups = function() {
			HttpSvc.get('usergroups/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.ugList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});			
		}

		/* ********************************************************* */

		vm.selectedTypeChanged = function() {
			vm.mla.moduleType = vm.selectedType.id;
		}

		vm.getCondition = function(condition) {
			return condition==1 ? 'ALL' : 'EITHER';
		}

		/* ********************************************************* */

		vm.showAddStorePanel = function() {
			vm.addStorePanelVisible = true;
		}

		vm.closeAddStorePanel = function() {
			vm.selectedStore = null;
			vm.addStorePanelVisible = false;
		}

		vm.addAllStores = function()
		{
			vm.branchList.forEach(function(b) {
				var isFound = false;
				vm.mla.approvalStoreConfigs.forEach(function(d) {
					if(d.branchId==b.id)
					{
						isFound=true;
					}
				});
	
				if(!isFound)
				{	
					vm.mla.approvalStoreConfigs.push({
						branchId: b.id,
						branchCode: b.code,
						branchName: b.name,
					});
				}
			});
			
			toastr.success("All Stores are added to the list.");			
		}

		vm.addStore = function()
		{
			if(vm.selectedStore==null)
			{
				toastr.warning("Select a store first.");
				return;
			}

			var isFound = false;
			vm.mla.approvalStoreConfigs.forEach(function(d) {
				if(d.branchId==vm.selectedStore.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Store is already exist on the list.");
				return;
			}

			vm.mla.approvalStoreConfigs.push({
				branchId: vm.selectedStore.id,
				branchCode: vm.selectedStore.code,
				branchName: vm.selectedStore.name,
			});
			toastr.success("Store [" + vm.selectedStore.name + "] is added to the list.");
		}

		vm.removeStore = function(index) {
			vm.mla.approvalStoreConfigs.splice(index, 1);
			$scope.$apply();
		}

		/* ********************************************************* */

		vm.showAddFlowPanel = function() {
			vm.addFlowPanelVisible = true;
		}

		vm.closeAddFlowPanel = function() {
			vm.selectedUsergroup = null;
			vm.addFlowPanelVisible = false;
		}

		vm.addFlow = function()
		{
			if(vm.selectedUsergroup==null && vm.selectedCondition==null && vm.addFlow.sequence=='')
			{
				toastr.warning("FIll in all the required fields first.");
				return;
			}

			var isFound = false;
			vm.mla.approvalUserGroupConfigs.forEach(function(d) {
				if(d.userGroupId==vm.selectedUsergroup.id || d.sequence==vm.addFlow.sequence)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Usergroup / Sequence is already exist on the list.");
				return;
			}

			vm.mla.approvalUserGroupConfigs.push({
				userGroupId: vm.selectedUsergroup.id,
				userGroupName: vm.selectedUsergroup.name,
				condition: vm.selectedCondition.id,
				sequence: vm.addFlow.sequence,
			});
			toastr.success("Approval Flow with [" + vm.selectedUsergroup.name + "] is added to the list.");
		}

		vm.removeFlow = function(index) {
			vm.mla.approvalUserGroupConfigs.splice(index, 1);
			$scope.$apply();
		}

		/* ********************************************************* */
		
		// Form Submission
		vm.submit = function() {
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				HttpSvc.post('approvalconfigs', vm.mla, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Store Purchase Configuration has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.multilevelapprovals.update', {'id': result.id });
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		/* ********************************************************* */
		
		// Call Actions
		vm.loadBranches();
	}
	
	/** @ngInject */
    function MultiLevelApprovalsUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;
		vm.mode = 2;
		vm.mla = {};
		vm.mla.approvalStoreConfigs = [];
		vm.mla.approvalUserGroupConfigs = [];
		vm.branchList = [];
		vm.ugList = [];
		vm.moduleList = getModules();
		vm.conditionList = getConditions();
		vm.lockButtons = false;
		vm.addStorePanelVisible = false;
		vm.selectedType = null;
		vm.currency = Auth.getCurrency();

		/* ********************************************************* */

		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadUsergroups();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});			
		}

		vm.loadUsergroups = function() {
			HttpSvc.get('usergroups/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.ugList = result;
					vm.loadData();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});			
		}

		// Load Data
		vm.loadData = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('approvalconfigs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.mla = result;
					
					vm.moduleList.forEach(function(m) {
						if(m.id==vm.mla.moduleType)
						{
							vm.selectedType = m;
						}
					});
				}, function() {
					toastr.error('Failed to load selected Store Purchase Configuration.', Auth.translate('ERROR'))
					$state.go('maintenance.approvalconfigs.list');
					return;
				});		
		};	

		/* ********************************************************* */

		vm.selectedTypeChanged = function() {
			vm.mla.moduleType = vm.selectedType.id;
		}

		vm.getCondition = function(condition) {
			return condition==1 ? 'ALL' : 'EITHER';
		}

		/* ********************************************************* */

		vm.showAddStorePanel = function() {
			vm.addStorePanelVisible = true;
		}

		vm.closeAddStorePanel = function() {
			vm.selectedStore = null;
			vm.addStorePanelVisible = false;
		}

		vm.addAllStores = function()
		{
			vm.branchList.forEach(function(b) {
				var isFound = false;
				vm.mla.approvalStoreConfigs.forEach(function(d) {
					if(d.branchId==b.id)
					{
						isFound=true;
					}
				});
	
				if(!isFound)
				{	
					vm.mla.approvalStoreConfigs.push({
						branchId: b.id,
						branchCode: b.code,
						branchName: b.name,
					});
				}
			});
			
			toastr.success("All Stores are added to the list.");			
		}

		vm.addStore = function()
		{
			if(vm.selectedStore==null)
			{
				toastr.warning("Select a store first.");
				return;
			}

			var isFound = false;
			vm.mla.approvalStoreConfigs.forEach(function(d) {
				if(d.branchId==vm.selectedStore.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Store is already exist on the list.");
				return;
			}

			vm.mla.approvalStoreConfigs.push({
				branchId: vm.selectedStore.id,
				branchCode: vm.selectedStore.code,
				branchName: vm.selectedStore.name,
			});
			toastr.success("Store [" + vm.selectedStore.name + "] is added to the list.");
		}

		vm.removeStore = function(index) {
			vm.mla.approvalStoreConfigs.splice(index, 1);
			$scope.$apply();
		}

		/* ********************************************************* */

		vm.showAddFlowPanel = function() {
			vm.addFlowPanelVisible = true;
		}

		vm.closeAddFlowPanel = function() {
			vm.selectedUsergroup = null;
			vm.addFlowPanelVisible = false;
		}

		vm.addFlow = function()
		{
			if(vm.selectedUsergroup==null && vm.selectedCondition==null && vm.addFlow.sequence=='')
			{
				toastr.warning("FIll in all the required fields first.");
				return;
			}

			var isFound = false;
			vm.mla.approvalUserGroupConfigs.forEach(function(d) {
				if(d.userGroupId==vm.selectedUsergroup.id || d.sequence==vm.addFlow.sequence)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Usergroup / Sequence is already exist on the list.");
				return;
			}

			vm.mla.approvalUserGroupConfigs.push({
				userGroupId: vm.selectedUsergroup.id,
				userGroupName: vm.selectedUsergroup.name,
				condition: vm.selectedCondition.id,
				sequence: vm.addFlow.sequence,
			});
			toastr.success("Approval Flow with [" + vm.selectedUsergroup.name + "] is added to the list.");
		}

		vm.removeFlow = function(index) {
			vm.mla.approvalUserGroupConfigs.splice(index, 1);
			$scope.$apply();
		}

		/* ********************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {		
				vm.lockButtons = true;

				HttpSvc.put('approvalconfigs/' + $stateParams.id, vm.mla, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Store Purchase Configuration has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		/* ********************************************************* */
		
		// Call Actions
		vm.loadBranches();
	}

	function getModules() {
		var modules = 
		[
			{ id:'RQ', name:'Store Purchases / Requisitions' },
			// { id:'PO', name:'Purchase Orders' },
			// { id:'DO', name:'Delivery Orders' },
			// { id:'PJ', name:'Production Jobs' },
			// { id:'WR', name:'Withdrawal Requests' },
			// { id:'WS', name:'Wastage Reports' },
		];

		return modules;
	}

	function getConditions() {
		var conditions = 
		[
			{ id: 1, name:'ALL' },
			{ id: 0, name:'EITHER' },
		];

		return conditions;
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.intercompanymappings.controller', [])
        .controller('InterCompanyMappingMainCtrl', InterCompanyMappingMainCtrl)
        .controller('InterCompanyMappingCreateCtrl', InterCompanyMappingCreateCtrl)
        .controller('InterCompanyMappingUpdateCtrl', InterCompanyMappingUpdateCtrl)
        .controller('InterCompanyMappingImportCtrl', InterCompanyMappingImportCtrl);

    /** @ngInject */
    function InterCompanyMappingMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 20;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.mappingDataFull = [];
		vm.mappingData = [];
		vm.isLoading = true;
		vm.companyId = Auth.getCompanyId();

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.mappingDataFull, tableState.search.predicateObject) : vm.mappingDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.mappingData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.mappingDataFull.length <= 0) {			
				vm.isLoading = true;

				HttpSvc.get('intercompanymappings/bycompany/' + vm.companyId, params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.mappingDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteMapping = function(mappingId) {
			var params = {};
			vm.isLoading = true;

			HttpSvc.delete('intercompanymappings/' + mappingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('intercompanymappings/bycompany/' + vm.companyId, params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.mappingDataFull = result;
							
							toastr.success('The mapping has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
							vm.isLoading = false;
						}, function() {
							vm.isLoading = false;
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to delete the mapping.', 'Delete Failed');
					return null;
			});
		};	

		vm.resetSearch = function() 
		{
		}		
	};
	
	/** @ngInject */
    function InterCompanyMappingCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.mapping = {};	
		vm.mapping.active = true;	
		vm.companyList = [];
		vm.supplierList = [];
		vm.sourceBranchList = [];
		vm.destBranchList = [];
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.selectedSourceCompany = null;
		vm.selectedSourceSupplier = null;
		vm.selectedSourceBranch = null;
		vm.selectedDestCompany = null;
		vm.selectedDestBranch = null;
		vm.selectedDestDebtor = null;
		vm.selectedDestDebtorBranch = null;

		/* ******************************************************** */

		// Load Companies 
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companyList = result;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		// Load Suppliers
		vm.loadSupplierList = function(companyId) {
			HttpSvc.get('suppliers/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.supplierList = result;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve supplier list.', '');
					return null;
				});
		};

		// Load Source Branches
		vm.loadSourceBranchList = function(companyId) {
			HttpSvc.get('branches/listbycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.sourceBranchList = result;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve branch list.', '');
					return null;
				});
		};

		// Load Dest Branches
		vm.loadDestBranchList = function(companyId) {
			HttpSvc.get('branches/listbycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.destBranchList = result;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve branch list.', '');
					return null;
				});
		};
		
		// Load Debtors
		vm.loadDebtorList = function(companyId) {
			HttpSvc.get('debtors/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.debtorList = result;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer list.', '');
					return null;
				});
		};

		// Load Debtor's Branches
		vm.loadDebtorBranchList = function(debtorId) {
			HttpSvc.get('debtors/' + debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.debtorBranchList = result;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer branch list.', '');
					return null;
				});
		};

		/* ******************************************************** */
		
		// Select Source Company
		vm.selectedSourceCompanyChanged = function() {
			vm.mapping.sourceCompanyId = vm.selectedSourceCompany.id;
			vm.loadSupplierList(vm.mapping.sourceCompanyId);
			vm.loadSourceBranchList(vm.mapping.sourceCompanyId);
		};
		
		// Select Source Supplier
		vm.selectedSourceSupplierChanged = function() {
			vm.mapping.sourceSupplierId = vm.selectedSourceSupplier.id;
		};
		
		// Select Source Branch
		vm.selectedSourceBranchChanged = function() {
			vm.mapping.sourceBranchId = vm.selectedSourceBranch.id;
		};
		
		// Select Dest Company
		vm.selectedDestCompanyChanged = function() {
			vm.mapping.destCompanyId = vm.selectedDestCompany.id;
			vm.loadDestBranchList(vm.mapping.destCompanyId);
			vm.loadDebtorList(vm.mapping.destCompanyId);
		};
		
		// Select Dest Branch
		vm.selectedDestBranchChanged = function() {
			vm.mapping.destBranchId = vm.selectedDestBranch.id;
		};
		
		// Select Dest Debtor
		vm.selectedDestDebtorChanged = function() {
			vm.mapping.destDebtorId = vm.selectedDestDebtor.id;
			vm.loadDebtorBranchList(vm.mapping.destDebtorId);
		};
		
		// Select Dest Debtor Branch
		vm.selectedDestDebtorBranchChanged = function() {
			vm.mapping.destDebtorBranchId = vm.selectedDestDebtorBranch.id;
		};
		
		/* ******************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('intercompanymappings', vm.mapping, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Mapping has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.intercompanymappings.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}
		
		/* ******************************************************** */
		
		// Call Action
		vm.loadCompanyList();
	}
	
	/** @ngInject */
    function InterCompanyMappingUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.mapping = {};
		vm.companyList = [];
		vm.supplierList = [];
		vm.sourceBranchList = [];
		vm.destBranchList = [];
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.changeLogs = [];
		vm.selectedSourceCompany = null;
		vm.selectedSourceSupplier = null;
		vm.selectedSourceBranch = null;
		vm.selectedDestCompany = null;
		vm.selectedDestBranch = null;
		vm.selectedDestDebtor = null;
		vm.selectedDestDebtorBranch = null;

		/* ******************************************************** */

		// Load Companies 
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companyList = result;
					
					vm.loadMapping();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		// Load Suppliers
		vm.loadSupplierList = function(companyId) {
			HttpSvc.get('suppliers/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.supplierList = result;
					
					vm.supplierList.forEach(function(s) {
						if(s.id==vm.mapping.sourceSupplierId)
						{
							vm.selectedSourceSupplier = s;
						}
					});
				}, function() {
					// Failed
					toastr.error('Failed to retrieve supplier list.', '');
					return null;
				});
		};

		// Load Source Branches
		vm.loadSourceBranchList = function(companyId) {
			HttpSvc.get('branches/listbycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.sourceBranchList = result;
					
					vm.sourceBranchList.forEach(function(b) {
						if(b.id==vm.mapping.sourceBranchId)
						{
							vm.selectedSourceBranch = b;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve branch list.', '');
					return null;
				});
		};

		// Load Dest Branches
		vm.loadDestBranchList = function(companyId) {
			HttpSvc.get('branches/listbycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.destBranchList = result;	
					
					vm.destBranchList.forEach(function(b) {
						if(b.id==vm.mapping.destBranchId)
						{
							vm.selectedDestBranch = b;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve branch list.', '');
					return null;
				});
		};
		
		// Load Debtors
		vm.loadDebtorList = function(companyId) {
			HttpSvc.get('debtors/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.debtorList = result;	
					
					vm.debtorList.forEach(function(d) {
						if(d.id==vm.mapping.destDebtorId)
						{
							vm.selectedDestDebtor = d;

							vm.loadDebtorBranchList(vm.mapping.destDebtorId);
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer list.', '');
					return null;
				});
		};

		// Load Debtor's Branches
		vm.loadDebtorBranchList = function(debtorId) {
			HttpSvc.get('debtors/' + debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.debtorBranchList = result;
					
					vm.debtorBranchList.forEach(function(d) {
						if(d.id==vm.mapping.destDebtorBranchId)
						{
							vm.selectedDestDebtorBranch = d;
						}
					});		
				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer branch list.', '');
					return null;
				});
		};
				
		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('intercompanymappingchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};	

		// Load Mapping
		vm.loadMapping = function() {
			HttpSvc.get('intercompanymappings/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.mapping = result;

					$scope.user.companies.forEach(function(c) {
						if(c.id==vm.mapping.sourceCompanyId)
						{
							vm.selectedSourceCompany = c;
						}
						if(c.id==vm.mapping.destCompanyId)
						{
							vm.selectedDestCompany = c;
						}
					});

					vm.loadSupplierList(vm.mapping.sourceCompanyId);
					vm.loadSourceBranchList(vm.mapping.sourceCompanyId);
					vm.loadDestBranchList(vm.mapping.destCompanyId);
					vm.loadDebtorList(vm.mapping.destCompanyId);
					vm.loadChangeLogs();

				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer branch list.', '');
					return null;
				});
		};

		/* ******************************************************** */
		
		// Select Source Company
		vm.selectedSourceCompanyChanged = function() {
			vm.mapping.sourceCompanyId = vm.selectedSourceCompany.id;
			vm.loadSupplierList(vm.mapping.sourceCompanyId);
			//vm.loadSourceBranchList(vm.mapping.sourceCompanyId);
		};
		
		// Select Source Supplier
		vm.selectedSourceSupplierChanged = function() {
			vm.mapping.sourceSupplierId = vm.selectedSourceSupplier.id;
		};
		
		// Select Source Branch
		vm.selectedSourceBranchChanged = function() {
			vm.mapping.sourceBranchId = vm.selectedSourceBranch.id;
		};
		
		// Select Dest Company
		vm.selectedDestCompanyChanged = function() {
			vm.mapping.destCompanyId = vm.selectedDestCompany.id;
			//vm.loadDestBranchList(vm.mapping.destCompanyId);
			vm.loadDebtorList(vm.mapping.destCompanyId);
		};
		
		// Select Dest Branch
		vm.selectedDestBranchChanged = function() {
			vm.mapping.destBranchId = vm.selectedDestBranch.id;
		};
		
		// Select Dest Debtor
		vm.selectedDestDebtorChanged = function() {
			vm.mapping.destDebtorId = vm.selectedDestDebtor.id;
			vm.loadDebtorBranchList(vm.mapping.destDebtorId);
		};
		
		// Select Dest Debtor Branch
		vm.selectedDestDebtorBranchChanged = function() {
			vm.mapping.destDebtorBranchId = vm.selectedDestDebtorBranch.id;
		};
		
		/* ******************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('intercompanymappings/' + $stateParams.id, vm.mapping, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Mapping has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.intercompanymappings.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}
		
		/* ******************************************************** */
		
		// Call Action
		vm.loadCompanyList();	
	}
	
	/** @ngInject */
	function InterCompanyMappingImportCtrl($scope, $state, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;		
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;
		
		/* **************************************************** */
		
		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";

		/* **************************************************** */
		
		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		vm.importOptions.createCompanyMapping = true;
		vm.importOptions.updateCompanyMapping = true;
		
		/* **************************************************** */
		
		vm.goBack = function() {
			$state.reload();
		}
		
		/* **************************************************** */
		
		vm.importResult = {};
		
		/* **************************************************** */
				
		vm.downloadTemplate = function() {
			
			var filename = "InterCompany Mapping Template.xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject('intercompanymappings/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};		
		
		/* **************************************************** */
		
		vm.importData = function() {
			vm.isImporting = true;
			
			HttpSvc.post('intercompanymappings/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
					//vm.lockButtons = false;
					//vm.isImportComplete = true;
					
					//vm.importResult = result;
					
					//toastr.success("Data imported successfully!");
					//$state.go('maintenance.items.list');
				}, function(error) {
					//vm.lockButtons = false;
					//vm.isImportFailed = true;
					
					//toastr.error("Failed to import data! " + error);
				});
		}
		
		/* **************************************************** */
		
		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}
		
		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;			
		}
		
		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];
			
			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}
		
		// Upload File
		vm.uploadFile = function() {	
			vm.resetFileUploadParams();
			
			vm.lockButtons = true;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;
								
			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;
			
			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();	
				vm.uploadMedia(vm.mediaToUpload);
			}	
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {
						
						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);
						
					}, function(error) {
						toastr.error(error, 'Failed');
						
						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {					
					vm.isUploaded = true;
					
					// Call Process Excel API 
					HttpSvc.post('intercompanymappings/import/' + resp.data, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;
							
							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			}  else if(vm.serverMode==1) { // Azure Server
							
				/* Initialize variables */
				/* ************************************* */	
				handleFileSelect(_fileToUpload);
				/* ************************************* */	
				
				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							} 
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,				
			}).then(function(response) {	
				vm.isUploaded = true;
				
				// Call Process Excel API 
				HttpSvc.post('intercompanymappings/import/' + excelFilename, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;
						
						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }		
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.products.controller', [])
        .controller('ProductMainCtrl', ProductMainCtrl)
        .controller('ProductCreateCtrl', ProductCreateCtrl)
        .controller('ProductUpdateCtrl', ProductUpdateCtrl)
        .controller('ProductUomModalCtrl', ProductUomModalCtrl)
        .controller('ProductParModalCtrl', ProductParModalCtrl)
        .controller('ProductCertModalCtrl', ProductCertModalCtrl)
		.controller('ProductImportCtrl', ProductImportCtrl)
        .controller('ProductAuditLogModalCtrl', ProductAuditLogModalCtrl)
        .controller('ProductSalesConfigModalCtrl', ProductSalesConfigModalCtrl);

    /** @ngInject */
    function ProductMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.data = [];

		vm.isLoading = false;
		vm.serverMode = Auth.getServerMode();
		vm.blobUrl = vm.serverMode==1?RmsApi.BLOBURL :RmsApi.LOCALURL;

		vm.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}
			
			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";
			
			var params = {
				keyword:  predicate.code,
				category: predicate.category,
				subcategory: predicate.subcategory,
				active: predicate.active,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			vm.isLoading = true;			
			
			var params = vm.getApiParams(tableState);

			HttpSvc.post('products/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isLoading = false;		
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;	
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			var predicate = tableState.search.predicateObject;
			vm.keyword = predicate == null ? vm.keyword : (predicate.vm == null ? vm.keyword : predicate.vm.keyword);
			tableState.pagination.numberOfPages = vm.numOfPages;
			
			return tableState;
		};

		vm.resetSearch = function() 
		{			
		}
		
		vm.deleteProduct = function(productId, productName) {
			var params = {};
			HttpSvc.delete('products/' + productId, params, Auth.getTokenId(), false)
				.then(function(result) {
					$scope.$broadcast('refreshStTable');
				}, function() {
					// Failed
					toastr.error('Failed to delete the Product <b>' + productName + '</b>.', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function ProductCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {
		Auth.init();
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 1;
		vm.product = {};
		vm.product.pax = 0;
		vm.product.lifeTime = 0;
		vm.product.reOrderStockLevel = 0;
		vm.product.reOrderQuantity = 0;
		vm.product.maxStockLevel = 0;
		vm.product.minStockLevel = 0;
		vm.product.safeStockLevel = 0;
		vm.product.active = true;
		vm.product.templateContent = {};
		vm.product.templateContent.nutritions = [];
		vm.product.productUnitOfMeasurements = [];
		vm.recipeList = [];
		vm.selectedRecipe = {};
		vm.productList = [];
		vm.uomList = [];
		vm.uomBase = "";
		vm.uomInventory = "";
		vm.uomOrder = "";
		vm.uomDefault = "";
		vm.lockButtons = false;
		vm.loadingRecipe = false;
		vm.hasPosAccess = Auth.hasPerm('pos', 'ACCESS');
		
		vm.useFoodPortioning = Auth.getSetting_Recipe_UseFoodPortioningTable();
		vm.integrationMode = Auth.getIntegrationMode();
		vm.hasAutoCountFields = vm.integrationMode == 2 && Auth.autoCount_EnableSync_Product();
		vm.hasSQLFields = vm.integrationMode == 8 && Auth.sqL_EnableSync_Product();
		vm.autoCount_itemGroups = [];
		vm.autoCount_itemTypes = [];
		vm.sql_itemGroups = [];
		
		vm.product.imageLocation = '';
		vm.blobUrl = vm.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL;
		vm.fileToUpload = null;
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();

		/* ************************************************************* */
		
		vm.initData = function() {
			vm.product.imageLocation = 'assets/img/empty_placeholder.png';

			if(vm.hasAutoCountFields) {
				vm.loadAutoCountItemTypes();
			} else if (vm.hasSQLFields) {
				vm.loadSQLItemGroups();
			} else {
				vm.loadUomList();
			}
		}
				
		// Load Recipe List
		vm.loadRecipeList = function(searchString) {
			vm.loadingRecipe = true;
			
			HttpSvc.post('recipes/listByCompany/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.recipeList = result;
					vm.loadingRecipe = false;
				}, function() {
					vm.loadingRecipe = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		};
				
		// Load UOM List
		vm.loadUomList = function() {
			vm.lockButtons = true;

			HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;	

					// Load Product List only if UseFoodPortioning
					if(vm.useFoodPortioning) {
						vm.loadProductLists();
					} else {
						vm.lockButtons = false;
					}
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
		
		// Load Product List
		vm.loadProductLists = function() {
			HttpSvc.get('products/list', {}, Auth.getTokenId(), true)
				.then(function(result) {					
					result.forEach(function(p) {
						vm.productList.push({ id: p.id, name: p.name });;
					});
					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}	
				
		vm.loadAutoCountItemTypes = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('autocount/maintenance/list/itemtypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_itemTypes = result;
					
					vm.loadAutoCountItemGroups();
				}, function() {
					toastr.error('Failed to load selected AutoCount Item Types.', Auth.translate('ERROR'))
					$state.go('maintenance.products.list');
					return;
				});
		};
				
		vm.loadAutoCountItemGroups = function() {
			HttpSvc.get('autocount/maintenance/list/itemgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_itemGroups = result;	
					vm.loadUomList();
				}, function() {
					toastr.error('Failed to load selected AutoCount Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.products.list');
					return;
				});
		};

		vm.loadSQLItemGroups = function() {
			HttpSvc.get('sqlacc/maintenance/stockgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sql_itemGroups = result;
					vm.loadBranchList();
				}, function() {
					toastr.error('Failed to load selected SQL Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};		
		/* ************************************************************* */
		
		// Recipe selection changed
		vm.onSelectedRecipeChanged = function() {
			vm.product.recipeId = vm.selectedRecipe.id;
		};	

		// Clear Recipe selection
		vm.clearSelectedRecipe = function() {
			vm.selectedRecipe = null;
			vm.product.recipeId = null;
		};
				
		// Select Product
		vm.selectProduct = function(item) {
			vm.product.smallerPackageProductId = item.id;
		};

		// Clear Product selection
		vm.clearSelectedProduct = function() {
			vm.product.smallerPackageProductId = null;
			vm.productList.selected = null;
		};
				
		/* ************************************************************* */
				
		vm.selectedItemTypeChanged = function() {
			vm.product.autoCount_ItemType = vm.selectedItemType.itemType1;
		}

		vm.selectedSQLItemGroupChanged = function() {
			vm.product.sqL_ItemGroup = vm.selectedSQLItemGroup.CODE;
		}

		vm.selectedItemGroupChanged = function() {
			vm.product.autoCount_ItemGroup = vm.selectedItemGroup.itemGroup1;
		}	
		
		vm.selectedStockControlChanged = function() {
			if(vm.selectedStockControl=="1") {
				vm.product.autoCount_StockControl = true;
			} else if(vm.selectedStockControl=="0") {
				vm.product.autoCount_StockControl = false;
			}
		}	
		vm.selectedSQLStockControlChanged = function() {
			if(vm.selectedSQLStockControl=="1") {
				vm.product.sqL_StockControl = true;
			} else if(vm.selectedSQLStockControl=="0") {
				vm.product.sqL_StockControl = false;
			}
		}
		// *************************************************************	

		vm.selectedParallelUom1Changed = function() {
			vm.product.cwm_ParallelUomId = vm.selectedParallelUom1.unitOfMeasurementId;
		}
		
		vm.selectedParallelUom2Changed = function() {
			vm.product.cwm_ParallelUomId_Secondary = vm.selectedParallelUom2.unitOfMeasurementId;
		}

		vm.verifyCWMSettings = function() {
			if(!vm.product.isCWM)
			{
				vm.product.syncCwmParallelUom = false;
				vm.product.cwm_ParallelUomId = null;
				vm.product.cwm_ParallelUomId_Secondary = null;
				vm.product.cwm_ParallelMultiplier = 0;
				vm.product.cwm_TolerencePercent = 0;
			}
		}	
				
		/* ************************************************************* */
		
		// Get UOM
		vm.getDisplayUom = function(uomType) {			
			var objBase = vm.product.productUnitOfMeasurements.filter(function( obj ) {
				return obj.isBase==true;
			});
			var objInventory = vm.product.productUnitOfMeasurements.filter(function( obj ) {
				return obj.isInventory==true;
			});
			var objOrder = vm.product.productUnitOfMeasurements.filter(function( obj ) {
				return obj.isOrder==true;
			});
			var objDefault = vm.product.productUnitOfMeasurements.filter(function( obj ) {
				return obj.isDefault==true;
			});
						
			if(uomType=="BASE") {
				return objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name;
			}
			if(uomType=="INVENTORY") {
				return objInventory.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objInventory[0].unitOfMeasurement.name;
			}		
			if(uomType=="ORDER") {
				return objOrder.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objOrder[0].unitOfMeasurement.name;
			}
			if(uomType=="DEFAULT") {
				return objDefault.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objDefault[0].unitOfMeasurement.name;
			}
			return "x";
		}
		
		/* ************************************************************* */
		
		// Remove UOM
		vm.removeUom = function(index) {
			if(confirm('Confirm remove this U.O.M.?')){
				vm.product.productUnitOfMeasurements.splice(index, 1);
				vm.refreshDisplayUom();
				$scope.$broadcast('refreshStTable');	
			}	
		};
			
		// Update UOM
		vm.updateUom = function(index, obj) {
			var element = {
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,	
				},
				baseMultiplier: obj.baseMultiplier,
				isBase: obj.isBase,
				isInventory: obj.isInventory,
				isDefault: obj.isDefault,
				isOrder: obj.isOrder,
				remarks: obj.remarks,
			};
									
			if(element.isBase) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isBase = false;
				})
			}
			if(element.isInventory) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isInventory = false;
				})
			}
			if(element.isOrder) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isOrder = false;
				})
			}
			if(element.isDefault) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isDefault = false;
				})
			}

			vm.product.productUnitOfMeasurements.splice(index, 1, element);
			
			vm.product.productUnitOfMeasurements.sort(function(a, b) {
				return a.baseMultiplier - b.baseMultiplier;
			});
			
			vm.refreshDisplayUom();
		};

		// Add UOM
		vm.addUom = function(obj) {
			var element = {
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,	
				},
				baseMultiplier: obj.baseMultiplier,
				isBase: obj.isBase,
				isInventory: obj.isInventory,
				isDefault: obj.isDefault,
				isOrder: obj.isOrder,
				remarks: obj.remarks,
			};
									
			if(element.isBase) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isBase = false;
				})
			}
			if(element.isInventory) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isInventory = false;
				})
			}
			if(element.isOrder) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isOrder = false;
				})
			}
			if(element.isDefault) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isDefault = false;
				})
			}

			vm.product.productUnitOfMeasurements.push(element);
			
			vm.product.productUnitOfMeasurements.sort(function(a, b) {
				return a.baseMultiplier - b.baseMultiplier;
			});
			
			vm.refreshDisplayUom();
		};

		// Refresh UOM List
		vm.refreshItemUoms = function(tableState) {
			// Do nothing
		};		
		
		vm.refreshDisplayUom = function() {
			vm.uomBase = vm.getDisplayUom('BASE');
			vm.uomInventory = vm.getDisplayUom('INVENTORY');
			vm.uomOrder = vm.getDisplayUom('ORDER');
			vm.uomDefault = vm.getDisplayUom('DEFAULT');
		}
		
		/* ************************************************************* */
			
		// Open Modal Dialog
		vm.uom = {};		
		vm.showAddUomModal = function () {
			vm.uom = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'uomModal.html',
				controller: 'ProductUomModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.uom,
							baseUom: vm.getDisplayUom('BASE'),
							uomList: vm.uomList
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addUom(data);
				}, function () {
				});
		};	
		vm.showEditUomModal = function (index) {			
			vm.uom = angular.copy(vm.product.productUnitOfMeasurements[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'uomModal.html',
				controller: 'ProductUomModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.uom,
							baseUom: vm.getDisplayUom('BASE'),
							uomList: vm.uomList
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateUom(index, data);
				}, function () {
				});
		};
		
		/* ************************************************************* */
		
		// Remove Nutrition
		vm.removeNutrition = function(index) {
			vm.product.templateContent.nutritions.splice(index, 1);
		};

		// Add Nutrition
		vm.addNutrition = function() {
			var nutrition = {
				name: '',
				quantity: '',
				uom: ''
			};
			vm.product.templateContent.nutritions.push(nutrition);
			vm.tableForm.$show();
		};
		
		// Save Nutritions
		vm.saveNutrition = function() {
			vm.tableForm.$submit();
			
			var results = [];
			vm.product.templateContent.nutritions.forEach(function(n) {
				if(n.name!='' && n.name!=null) {
					results.push(n);
				}
			});
			vm.product.templateContent.nutritions = results;
			vm.product.templateContent = angular.toJson(vm.product.templateContent);
		}
		/* ***************************************************************** */
				
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Set Upload Image
		vm.clearImage = function() {			
			vm.product.imageLocation = 'assets/img/empty_placeholder.png';
			vm.product.oriImageLocation = '';
			vm.fileToUpload = null;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (itemId) {
			var fileReader = new FileReader();
						
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Finished Good has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('maintenance.products.update', {'id': itemId });
				}, function (resp) {
					toastr.success('Finished Good has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('maintenance.products.update', {'id': itemId });
				}, function (evt) {
				});
				
			} else if(vm.serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {
							toastr.success('Finished Good has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('maintenance.products.update', {'id': itemId });
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
					});
				}
			}
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			vm.product.templateContent.shelf_life = vm.product.lifeTime;
			
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, 'Incomplete Fields');
			} else {			
				vm.lockButtons = true;

				vm.verifyCWMSettings();
				vm.saveNutrition();

				imgLocation = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/finishedgoods/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "finishedgoods/" + newFilename + mediaExtension;

				} else if(vm.product.oriImageLocation!="") {
					imgLocation = vm.product.oriImageLocation;
				}
				vm.product.imageLocation = imgLocation;		
				
				HttpSvc.post('products/add', vm.product, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
						vm.product.templateContent = angular.fromJson(vm.product.templateContent);
					});
			}
		}

		vm.checkResult = function(result) {
			azureStorageUrl = "";
			localStorageUrl = "";

			if(result.httpStatusCode=="200")
			{										
				if(vm.serverMode==1 && vm.fileToUpload) {
					azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
					vm.uploadImage(result.id);
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {
					localStorageUrl = RmsApi.URL + "upload/finishedgoods/" + result.id;
					vm.uploadImage(result.id);
					
				} else {
					toastr.success('Finished Good has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('maintenance.products.update', {'id': result.id });
				}
			}
			else
			{
				vm.lockButtons = false;
				toastr.error(result.message, 'Failed');
				vm.product.templateContent = angular.fromJson(vm.product.templateContent);
			}
		}
		
		/* ************************************************************* */
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function ProductUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, UtilSvc, Upload, RmsApi, toastr) {

		Auth.init();
		
		var vm = this;
		
		vm.isRmsLite = Auth.isLiteMode();
		vm.isStarterMode = Auth.isStarterMode();
		
		vm.lockButtons = true;
		vm.mode = 2;
		vm.product = {};
		vm.product.pax = 0;
		vm.product.lifeTime = 0;
		vm.product.reOrderStockLevel = 0;
		vm.product.maxStockLevel = 0;
		vm.product.minStockLevel = 0;
		vm.product.safeStockLevel = 0;
		vm.product.templateContent = {};
		vm.product.templateContent.nutritions = [];		
		vm.product.productUnitOfMeasurements = [];
		vm.branchList = [];
		vm.recipeList = [];
		vm.selectedRecipe = {};
		vm.productList = [];
		vm.uomList = [];
		vm.changeLogs = [];
		vm.salesConfigList = [];
		vm.debtorList = [];
		vm.uomBase = "";
		vm.uomInventory = "";
		vm.uomOrder = "";
		vm.uomDefault = "";
		vm.lockButtons = false;
		vm.loadingRecipe = false;
		vm.hasPosAccess = Auth.hasPerm('pos', 'ACCESS');
		vm.serverMode = Auth.getServerMode();
		vm.blobUrl = vm.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL;
		
		vm.useFoodPortioning = Auth.getSetting_Recipe_UseFoodPortioningTable();
		vm.integrationMode = Auth.getIntegrationMode();
		vm.hasAutoCountFields = vm.integrationMode == 2 && Auth.autoCount_EnableSync_Product();
		vm.hasSQLFields = vm.integrationMode == 8 && Auth.sqL_EnableSync_Product();
		vm.currencyCode = Auth.getCurrency();
		vm.autoCount_itemGroups = [];
		vm.autoCount_itemTypes = [];
		vm.sql_itemGroups = [];
		
		vm.product.imageLocation = '';
		vm.product.oriImageLocation = '';
		vm.fileToUpload = null;
		vm.mediaToUpload = null;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
				
		/* ************************************************************* */
		
		vm.initData = function() {
			if(vm.hasAutoCountFields) {
				vm.loadAutoCountItemTypes();
			} else if (vm.hasSQLFields) {
				vm.loadSQLItemGroups();
			} else {
				vm.loadBranchList();				
			}
		}
				
		// Load Recipe List
		vm.loadRecipeList = function(searchString) {
			vm.loadingRecipe = true;
			
			HttpSvc.post('recipes/listByCompany/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.recipeList = result;
					vm.loadingRecipe = false;
				}, function() {
					vm.loadingRecipe = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		};

		vm.loadRecipe = function() {
			if(vm.product.recipeId==null) return;

			vm.loadingRecipe = true;

			HttpSvc.get('recipes/' + vm.product.recipeId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.recipeList.push({ id: result.id, name: result.name});
					vm.selectedRecipe = vm.recipeList[0];
					vm.loadingRecipe = false;
				}, function() {
					vm.loadingRecipe = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}	
				
		// Load Branch List
		vm.loadBranchList = function() {
			vm.isLoading = true;	
					
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadUomList();
				}, function() {
					vm.isLoading = false;	
					toastr.error('Failed to retrieve Branch List.', '');
					return null;
			});
		}
				
		// Load UOM List
		vm.loadUomList = function() {
			vm.lockButtons = true;
			HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;	

					// Load Product List only if UseFoodPortioning
					if(vm.useFoodPortioning) {
						vm.loadProductLists();
					} else {
						vm.loadProduct();
					}		
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
		
		// Load Product List
		vm.loadProductLists = function() {
			HttpSvc.get('products/list', {}, Auth.getTokenId(), true)
				.then(function(result) {					
					result.forEach(function(p) {
						if(p.id!=$stateParams.id) {
							vm.productList.push({ id: p.id, name: p.name });
						}
					});
					vm.loadProduct();
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		}	

		// Load Debtor for Sales Config
		vm.loadDebtors = function() {
			HttpSvc.get('debtors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					vm.loadSalesConfigs();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Debtor List.', Auth.translate('ERROR'))
					return;
				});		
		}
		
		// Load Sales Config List
		vm.loadSalesConfigs = function() {
			HttpSvc.get('productdebtorsalesconfigs/list/byitem/' + vm.product.id, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.salesConfigList = result;
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Sales Config List.', Auth.translate('ERROR'))
					return;
				});		
		};
		
		/* ************************************************************* */
				
		vm.loadAutoCountItemTypes = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('autocount/maintenance/list/itemtypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_itemTypes = result;
					
					vm.loadAutoCountItemGroups();
				}, function() {
					toastr.error('Failed to load selected AutoCount Item Types.', Auth.translate('ERROR'))
					$state.go('maintenance.products.list');
					return;
				});
		};
				
		vm.loadAutoCountItemGroups = function() {
			HttpSvc.get('autocount/maintenance/list/itemgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_itemGroups = result;
					vm.loadBranchList();	
				}, function() {
					toastr.error('Failed to load selected AutoCount Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.products.list');
					return;
				});
		};

		vm.loadSQLItemGroups = function() {
			HttpSvc.get('sqlacc/maintenance/stockgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sql_itemGroups = result;
					vm.loadBranchList();
				}, function() {
					toastr.error('Failed to load selected SQL Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};		
		/* ************************************************************* */
				
		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('productchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};
				
		// Load Product
		vm.loadProduct = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('products/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.product = result;
										
					vm.loadRecipe();
					
					if(!vm.product.imageLocation || vm.product.imageLocation=='') {
						vm.product.imageLocation = 'assets/img/empty_placeholder.png';
						vm.product.oriImageLocation = "";
					} else {
						vm.product.oriImageLocation = vm.product.imageLocation;
						vm.product.imageLocation = vm.rootUrl + vm.product.imageLocation;
					}

					vm.product.productUnitOfMeasurements.sort(function(a, b) {
						return a.baseMultiplier - b.baseMultiplier;
					});
					
					vm.productList.forEach(function(p) {
						if(p.id==vm.product.smallerPackageProductId){
							vm.productList.selected = { id: p.id, name: p.name };
						}
					});
										
					vm.autoCount_itemTypes.forEach(function(c) {
						if(vm.product.autoCount_ItemType == c.itemType1){
							vm.selectedItemType = c;
						}
					});
										
					vm.autoCount_itemGroups.forEach(function(c) {
						if(vm.product.autoCount_ItemGroup == c.itemGroup1){
							vm.selectedItemGroup = c;
						}
					});

					vm.sql_itemGroups.forEach(function(c) {
						if(vm.product.sqL_ItemGroup == c.CODE){
							vm.selectedSQLItemGroup = c;
						}
					});

					vm.product.productUnitOfMeasurements.forEach(function(u) {
						if(u.unitOfMeasurementId==vm.product.cwm_ParallelUomId)
						{
							vm.selectedParallelUom1 = u;
						}
						if(u.unitOfMeasurementId==vm.product.cwm_ParallelUomId_Secondary)
						{
							vm.selectedParallelUom2 = u;
						}
					});
					
					if(vm.product.autoCount_StockControl) {
						vm.selectedStockControl = "1";
					} else {
						vm.selectedStockControl = "0";
						vm.product.autoCount_StockControl = false;
					}
					
					if(vm.product.sqL_StockControl) {
						vm.selectedSQLStockControl = "1";
					} else {
						vm.selectedSQLStockControl = "0";
						vm.product.sqL_StockControl = false;
					}

					try {
						if(vm.product.templateContent==null) {
							vm.product.templateContent = {};
							vm.product.templateContent.nutritions = [];
						} else {
							vm.product.templateContent = angular.fromJson(vm.product.templateContent);
						}						
					} catch (err) {
						vm.product.templateContent = {};
						vm.product.templateContent.nutritions = [];
					}
					
					vm.loadChangeLogs();
					vm.loadDebtors();

					vm.tableForm.$show();					
					vm.refreshDisplayUom();
					vm.lockButtons = false;
				}, function() {
					toastr.error('Failed to load selected Product.', Auth.translate('ERROR'))
					$state.go('maintenance.products.list');
					return;
				});		
		};	
				
		/* ************************************************************* */
				
		vm.selectedItemTypeChanged = function() {
			vm.product.autoCount_ItemType = vm.selectedItemType.itemType1;
		}
		
		vm.selectedItemGroupChanged = function() {
			vm.product.autoCount_ItemGroup = vm.selectedItemGroup.itemGroup1;
		}

		vm.selectedSQLItemGroupChanged = function() {
			vm.product.sqL_ItemGroup = vm.selectedSQLItemGroup.CODE;
		}
		vm.selectedStockControlChanged = function() {
			if(vm.selectedStockControl=="1") {
				vm.product.autoCount_StockControl = true;
			} else if(vm.selectedStockControl=="0") {
				vm.product.autoCount_StockControl = false;
			}
		}	

		vm.selectedSQLStockControlChanged = function() {
			if(vm.selectedSQLStockControl=="1") {
				vm.product.sqL_StockControl = true;
			} else if(vm.selectedSQLStockControl=="0") {
				vm.product.sqL_StockControl = false;
			}
		}
		// *************************************************************	

		vm.selectedParallelUom1Changed = function() {
			vm.product.cwm_ParallelUomId = vm.selectedParallelUom1.unitOfMeasurementId;
		}
		
		vm.selectedParallelUom2Changed = function() {
			vm.product.cwm_ParallelUomId_Secondary = vm.selectedParallelUom2.unitOfMeasurementId;
		}

		vm.verifyCWMSettings = function() {
			if(!vm.product.isCWM)
			{
				vm.product.syncCwmParallelUom = false;
				vm.product.cwm_ParallelUomId = null;
				vm.product.cwm_ParallelUomId_Secondary = null;
				vm.product.cwm_ParallelMultiplier = 0;
				vm.product.cwm_TolerencePercent = 0;
			}
		}	
		
		/* ************************************************************* */
		
		// Get UOM
		vm.getDisplayUom = function(uomType) {			
			var objBase = vm.product.productUnitOfMeasurements.filter(function( obj ) {
				return obj.isBase==true;
			});
			var objInventory = vm.product.productUnitOfMeasurements.filter(function( obj ) {
				return obj.isInventory==true;
			});
			var objOrder = vm.product.productUnitOfMeasurements.filter(function( obj ) {
				return obj.isOrder==true;
			});
			var objDefault = vm.product.productUnitOfMeasurements.filter(function( obj ) {
				return obj.isDefault==true;
			});
						
			if(uomType=="BASE") {
				return objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name;
			}
			if(uomType=="INVENTORY") {
				return objInventory.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objInventory[0].unitOfMeasurement.name;
			}		
			if(uomType=="ORDER") {
				return objOrder.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objOrder[0].unitOfMeasurement.name;
			}
			if(uomType=="DEFAULT") {
				return objDefault.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objDefault[0].unitOfMeasurement.name;
			}
			return "x";
		}
		
		/* ************************************************************* */
		
		// Remove UOM
		vm.removeUom = function(index) {
			if(confirm('Confirm remove this U.O.M.?')){
				vm.product.productUnitOfMeasurements.splice(index, 1);
				vm.refreshDisplayUom();
				$scope.$broadcast('refreshStTable');	
			}
		};
			
		// Update UOM
		vm.updateUom = function(index, obj) {
			var element = {
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,	
				},
				baseMultiplier: obj.baseMultiplier,
				isBase: obj.isBase,
				isInventory: obj.isInventory,
				isDefault: obj.isDefault,
				isOrder: obj.isOrder,
				remarks: obj.remarks,
			};
									
			if(element.isBase) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isBase = false;
				})
			}
			if(element.isInventory) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isInventory = false;
				})
			}
			if(element.isOrder) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isOrder = false;
				})
			}
			if(element.isDefault) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isDefault = false;
				})
			}
			
			vm.product.productUnitOfMeasurements.splice(index, 1, element);
			
			vm.product.productUnitOfMeasurements.sort(function(a, b) {
				return a.baseMultiplier - b.baseMultiplier;
			});
			
			vm.refreshDisplayUom();
		};

		// Add UOM
		vm.addUom = function(obj) {
			var element = {
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,	
				},
				baseMultiplier: obj.baseMultiplier,
				isBase: obj.isBase,
				isInventory: obj.isInventory,
				isDefault: obj.isDefault,
				isOrder: obj.isOrder,
				remarks: obj.remarks,
			};
									
			if(element.isBase) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isBase = false;
				})
			}
			if(element.isInventory) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isInventory = false;
				})
			}
			if(element.isOrder) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isOrder = false;
				})
			}
			if(element.isDefault) {
				vm.product.productUnitOfMeasurements.forEach(function(p) {
					p.isDefault = false;
				})
			}

			vm.product.productUnitOfMeasurements.push(element);
			
			vm.product.productUnitOfMeasurements.sort(function(a, b) {
				return a.baseMultiplier - b.baseMultiplier;
			});
			
			vm.refreshDisplayUom();
		};

		// Refresh UOM List
		vm.refreshItemUoms = function(tableState) {
			// Do nothing
		};		
		
		vm.refreshDisplayUom = function() {
			vm.uomBase = vm.getDisplayUom('BASE');
			vm.uomInventory = vm.getDisplayUom('INVENTORY');
			vm.uomOrder = vm.getDisplayUom('ORDER');
			vm.uomDefault = vm.getDisplayUom('DEFAULT');
		}
		
		/* ************************************************************* */
			
		// Open Modal Dialog
		vm.uom = {};		
		vm.showAddUomModal = function () {
			vm.uom = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'uomModal.html',
				controller: 'ProductUomModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.uom,
							baseUom: vm.getDisplayUom('BASE'),
							uomList: vm.uomList
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addUom(data);
				}, function () {
				});
		};	
		vm.showEditUomModal = function (index) {
			vm.uom = angular.copy(vm.product.productUnitOfMeasurements[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'uomModal.html',
				controller: 'ProductUomModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.uom,
							baseUom: vm.getDisplayUom('BASE'),
							uomList: vm.uomList
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateUom(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************* */
			
		vm.showAddParModal = function () {
		
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'parModal.html',
				controller: 'ProductParModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							itemId: vm.product.id,
							branchList: vm.branchList,
							uomInventory: vm.uomInventory,
							uomOrder: vm.uomOrder,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addParLevel(data);
				}, function () {
				});
		};	
		vm.showEditParModal = function (index) {
			var parObject = angular.copy(vm.product.productBranchConfigs[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'parModal.html',
				controller: 'ProductParModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							itemId: vm.product.id,
							branchList: vm.branchList,
							uomInventory: vm.uomInventory,
							uomOrder: vm.uomOrder,
							parObject: parObject
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateParLevel(index, data);
				}, function () {
				});
		};
		vm.removePar = function (index) {
			vm.product.productBranchConfigs.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};
		vm.addParLevel = function(data) {
			vm.product.productBranchConfigs.push(data);
		};
		vm.updateParLevel = function(index, data) {
			var obj = vm.product.productBranchConfigs[index];
			obj.branchId = data.branchId;
			obj.mon = data.mon;
			obj.tue = data.tue;
			obj.wed = data.wed;
			obj.thu = data.thu;
			obj.fri = data.fri;
			obj.sat = data.sat;
			obj.sun = data.sun;
			obj.reOrderLevel = data.reOrderLevel;
			obj.reOrderQuantity = data.reOrderQuantity;
			obj.parLevel = data.parLevel; 
		};
				
		/* ************************************************************* */
		
		// Open Cert Modal Dialog		
		vm.showAddCertModal = function () {
			vm.cert = {};
			vm.cert.productId = vm.product.id;
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'certModal.html',
				controller: 'ProductCertModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.cert,
							serverMode: vm.serverMode,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadCertificates(vm.product.id);
				}, function () {
				});
		};			
		vm.showEditCertModal = function (certId) {
			vm.cert = {};
			vm.product.productCertificates.forEach(function(s){
				if(s.id==certId) {
					vm.cert = s;
				}
			});
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'certModal.html',
				controller: 'ProductCertModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.cert,
							serverMode: vm.serverMode,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadCertificates(vm.product.id);
				}, function () {
				});
		};	
		
		/* ************************************************************* */
		
		// Load Certs
		vm.loadCertificates = function(itemId) {
			var params = { id: itemId };
			HttpSvc.get('productcertificates/list/:id', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.product.productCertificates = result;
					//$scope.$broadcast('refreshStTable');
				}, function() {
					toastr.error('Failed to load Certificates.', Auth.translate('ERROR'))
					return;
				});		
		};		

		// Remove Cert
		vm.removeCert = function(certId) {	
			HttpSvc.delete('productcertificates/' + certId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('The Certificate has been removed.', Auth.translate('SUCCESS'));
					vm.loadCertificates(vm.product.id);
				}, function(error) {
					// Failed
					toastr.error('Failed to remove the Certificate.', 'Failed');
					return null;
				});
		};
		
		/* ************************************************************* */
			
		vm.showAddSalesConfig = function () {
						
			vm.priceUomList = [];
			vm.product.productUnitOfMeasurements.forEach(function(u) {
				vm.priceUomList.push({ id: u.unitOfMeasurementId, name: u.unitOfMeasurement.name });
			})
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'salesConfigModal.html',
				controller: 'ProductSalesConfigModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							itemId: vm.product.id,
							debtorList: vm.debtorList,
							currencyCode: vm.currencyCode,
							uomList: vm.priceUomList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadSalesConfigs();
				}, function () {
				});
		};	

		vm.showEditSalesConfig = function (configId) {
						
			vm.priceUomList = [];
			vm.product.productUnitOfMeasurements.forEach(function(u) {
				vm.priceUomList.push({ id: u.unitOfMeasurementId, name: u.unitOfMeasurement.name });
			})
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'salesConfigModal.html',
				controller: 'ProductSalesConfigModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							itemId: vm.product.id,
							configId: configId,
							debtorList: vm.debtorList,
							currencyCode: vm.currencyCode,
							uomList: vm.priceUomList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadSalesConfigs();
				}, function () {
				});
		};

		vm.deleteSalesConfig = function (configId) {
			vm.isLoading = true;
			
			HttpSvc.delete('productdebtorsalesconfigs/' + configId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Sales Config deleted successfully.', 'Delete Successful');
					vm.loadSalesConfigs();
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to delete the config. ' + error, 'Delete Failed');
					return null;
			});
		};
		
		// **********************************************
		
		// Recipe selection changed
		vm.onSelectedRecipeChanged = function() {
			vm.product.recipeId = vm.selectedRecipe.id;
			vm.product.recipeName = vm.selectedRecipe.name;
		};	

		// Clear Recipe selection
		vm.clearSelectedRecipe = function() {
			vm.selectedRecipe = null;
			vm.product.recipeId = null;
		};
				
		// Select Product
		vm.selectProduct = function(item) {
			vm.product.smallerPackageProductId = item.id;
		};

		// Clear Product selection
		vm.clearSelectedProduct = function() {
			vm.product.smallerPackageProductId = null;
			vm.productList.selected = null;
		};
		
		// Select Template
		vm.selectTemplate = function(item) {
			vm.product.companyLabelTemplateId = item.id;
		};
		
		// Remove Nutrition
		vm.removeNutrition = function(index) {
			vm.product.templateContent.nutritions.splice(index, 1);
		};

		// Add Nutrition
		vm.addNutrition = function() {
			var nutrition = {
				name: '',
				quantity: '',
				uom: ''
			};
			vm.product.templateContent.nutritions.push(nutrition);
			vm.tableForm.$show();
		};
		
		// Save Nutritions
		vm.saveNutrition = function() {
			vm.tableForm.$submit();
			
			var results = [];
			vm.product.templateContent.nutritions.forEach(function(n) {
				if(n.name!='' && n.name!=null) {
					results.push(n);
				}
			});
			vm.product.templateContent.nutritions = results;
			vm.product.templateContent = angular.toJson(vm.product.templateContent);
		}
		
		// Clone Product
		vm.cloneProduct = function() {
			vm.lockButtons = true;
			
			HttpSvc.post('products/clone/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {											
						toastr.success('Product has been cloned successfully.', Auth.translate('SUCCESS'));	
						$state.go('maintenance.products.update', {'id': result.newProductId });
				}, function(error) {
					toastr.error(angular.toJson(error), 'Failed');
					vm.dataForm.$setPristine();
					vm.lockButtons = false;
				});
		}

		vm.isJsonEqual = function(a,b) {
			return JSON.stringify(a) === JSON.stringify(b);
		}
		
		/* ***************************************************************** */
				
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Set Upload Image
		vm.clearImage = function() {			
			vm.product.imageLocation = 'assets/img/empty_placeholder.png';
			vm.product.oriImageLocation = '';
			vm.fileToUpload = null;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function () {
			var fileReader = new FileReader();
						
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Finished Good has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('Finished Good has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
				});
				
			} else if(vm.serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {
							toastr.success('Finished Good has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
					});
				}
			}
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {	
			
			vm.product.templateContent.shelf_life = vm.product.lifeTime;
			
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				vm.verifyCWMSettings();
				vm.saveNutrition();

				imgLocation = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/finishedgoods/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "finishedgoods/" + newFilename + mediaExtension;

				} else if(vm.product.oriImageLocation!="") {
					imgLocation = vm.product.oriImageLocation;
				}
				vm.product.imageLocation = imgLocation;	
				
				HttpSvc.put('products/' + $stateParams.id, vm.product, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
						vm.product.templateContent = angular.fromJson(vm.product.templateContent);
					});
			}
		}

		vm.checkResult = function(result) {
			azureStorageUrl = "";
			localStorageUrl = "";

			if(result.httpStatusCode=="200")
			{						
				if(vm.serverMode==1 && vm.fileToUpload) {
					azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
					vm.uploadImage();
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {
					localStorageUrl = RmsApi.URL + "upload/finishedgoods/" + $stateParams.id;
					vm.uploadImage();
					
				} else {
					toastr.success('Finished Good has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}
			}
			else
			{
				vm.lockButtons = false;
				toastr.error(result.message, 'Failed');
				vm.product.templateContent = angular.fromJson(vm.product.templateContent);
			}
		}
		
		/* ************************************************************* */
		
		// Call Actions
		vm.initData();
	}

	/** @ngInject */
	function ProductImportCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;		
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.importType = 1;
		vm.serverMode = Auth.getServerMode();
		vm.lockButtons = false;
		
		/* **************************************************** */

		vm.scrollLeft = function() {
			document.getElementById('scroll-container').scrollLeft -= 300;
		}
		
		vm.scrollRight = function() {
			document.getElementById('scroll-container').scrollLeft += 300;
		}
		
		/* **************************************************** */
				
		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";

		/* **************************************************** */
		
		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		vm.importOptions.createProduct = true;
		vm.importOptions.updateProduct = true;
		vm.importOptions.createUom = true;
		vm.importOptions.updateUom = true;
		
		/* **************************************************** */
		
		vm.goBack = function() {
			$state.reload();
		}
		
		/* **************************************************** */
		
		vm.importResult = {};
		
		/* **************************************************** */
				
		vm.downloadTemplate = function(templateNo, templateName) {
			
			var filename = templateName + ".xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject('products/download/template' + templateNo, Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};
				
		vm.downloadTemplateOther = function(templateName) {
			
			var filename = templateName + ".xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject('productdebtorsalesconfigs/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};			
		
		/* **************************************************** */
		
		vm.importData = function() {
			vm.isImporting = true;
			
			HttpSvc.post('products/importData' + vm.importType, vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
				}, function(error) {
				});
		}
		
		vm.importDataOther = function() {
			vm.isImporting = true;
			
			HttpSvc.post('productdebtorsalesconfigs/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
				}, function(error) {
				});
		}
		
		/* **************************************************** */
		
		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}
		
		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;			
		}
		
		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];
			
			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}
		
		// Upload File
		vm.uploadFile = function(importType) {	
			vm.resetFileUploadParams();
			
			vm.lockButtons = true;
			vm.importType = importType;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;
								
			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;
			
			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();	
				vm.uploadMedia(vm.mediaToUpload);
			}	
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {
						
						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);
						
					}, function(error) {
						toastr.error(error, 'Failed');
						
						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {					
					vm.isUploaded = true;
					
					// Call Process Excel API 
					var apiUrl = 'products/import/' + vm.importType + '/' + resp.data;
					if(vm.importType == "5")
					{
						apiUrl = 'productdebtorsalesconfigs/import/' + resp.data;
					}

					HttpSvc.post(apiUrl, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;
							
							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			}  else if(vm.serverMode==1) { // Azure Server
							
				/* Initialize variables */
				/* ************************************* */	
				handleFileSelect(_fileToUpload);
				/* ************************************* */	
				
				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							} 
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,				
			}).then(function(response) {	
				vm.isUploaded = true;
				
				// Call Process Excel API 
				var apiUrl = 'products/import/' + vm.importType + '/' + excelFilename;
				if(vm.importType == "5")
				{
					apiUrl = 'productdebtorsalesconfigs/import/' + excelFilename;
				}

				HttpSvc.post(apiUrl, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;
						
						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }		
	};
	
	// U.O.M. Modal Controller
	function ProductUomModalCtrl($uibModalInstance, item, toastr, UtilSvc) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.baseUom = item.baseUom;
		$mdl.uomList = item.uomList;
		$mdl.item = item.object;
		$mdl.selectedUom = null;
		
		// Initialize
		if(item.mode==1) {
			$mdl.item.unitOfMeasurementId = null;
			$mdl.item.uomName = "";			
			$mdl.item.baseMultiplier = 1;
			$mdl.item.isBase = false,
			$mdl.item.isInventory = false,
			$mdl.item.isOrder = false,
			$mdl.item.remarks = "";
		} else {
			if($mdl.item.unitOfMeasurementId!='' && $mdl.item.unitOfMeasurementId!=null){
				$mdl.uomList.forEach(function (i) {
					if(i.id==$mdl.item.unitOfMeasurementId) {
						$mdl.selectedUom = i;
						$mdl.item.uomName = i.name;
					}
				});
			};
		}
		
		$mdl.onSelectedUomChanged = function() {
			$mdl.item.unitOfMeasurementId = $mdl.selectedUom.id;
			$mdl.item.uomName = $mdl.selectedUom.name;
		};
		
		$mdl.confirmModal = function() {		
			if($mdl.uomForm.$invalid) 
			{
				var errorMsg = UtilSvc.getErrorMessage($mdl.uomForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			}
			else
			{
				$uibModalInstance.close($mdl.item);
			}	
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
	
	// PAR Modal Controller
	function ProductParModalCtrl($uibModalInstance, item, toastr, UtilSvc) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.branchList = item.branchList;
		$mdl.uomInventory = item.uomInventory;
		$mdl.uomOrder = item.uomOrder;
		$mdl.parObject = item.parObject;
		$mdl.selectedBranch = null;
		$mdl.item = {};
		$mdl.item.productId = item.itemId;

		/* *************************************************** */
		
		$mdl.selectedBranchChanged = function() {
			$mdl.item.branchId = $mdl.selectedBranch.id;
			$mdl.item.branch = {}
			$mdl.item.branch.name = $mdl.selectedBranch.name;
		};
		
		// Initialize
		if(item.mode==2) {
			$mdl.item = item.parObject;
			$mdl.branchList.forEach(function(b) {
				if(b.id == $mdl.parObject.branchId)
				{
					$mdl.selectedBranch = b;
					$mdl.selectedBranchChanged();
				}
			})
		}

		$mdl.isValidDays = function()  {
			return !$mdl.item.mon && !$mdl.item.tue && !$mdl.item.wed && !$mdl.item.thu && !$mdl.item.fri && !$mdl.item.sat && !$mdl.item.sun
		}

		/* *************************************************** */
		
		$mdl.confirmModal = function() {
			if($mdl.parForm.$invalid) 
			{
				var errorMsg = UtilSvc.getErrorMessage($mdl.parForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			}
			else
			{
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	

	// Audit Log Modal Controller
	function ProductAuditLogModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		
		$mdl.logId = item.logId;
		$mdl.productId = item.productId;
		$mdl.invUom = item.invUom;
		$mdl.orderUom = item.orderUom;
		$mdl.log = {};
		$mdl.oriData = {};
		$mdl.newData = {};
		$mdl.currentData = item.currentData;
		$mdl.isLoading = false;

		/* ************************************************************** */
		
		$mdl.loadData = function() {
			$mdl.isLoading = true;

			HttpSvc.get('productchangelogs/' + $mdl.logId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.log = result;
					
					$mdl.oriData = angular.fromJson($mdl.log.originalData);
					$mdl.newData = angular.fromJson($mdl.log.newData);
					$mdl.isLoading = false;
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to load Audit Log. ' + error, Auth.translate('ERROR'))
					$mdl.cancelModal();
				});		
		}

		$mdl.saveChangeLog = function() {
			
			var originalData = JSON.stringify($mdl.currentData);
			var newData = JSON.stringify($mdl.oriData);

			var changeLog = {
				productId: $mdl.productId,
				newData: newData,
				originalData: originalData,
				remarks: 'REVERT TO ORIGINAL'
			};

			HttpSvc.post('productchangelogs', changeLog, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.isLoading = false;
					toastr.success('Revision has been reverted successfully.', Auth.translate('SUCCESS'));						
					$uibModalInstance.close();
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to revert.' + error, 'Failed');
				});
		}
		
		$mdl.revertRevision = function() {
			$mdl.isLoading = true;

			HttpSvc.put('products/' + $mdl.productId, $mdl.oriData, Auth.getTokenId(), false)
				.then(function() {
					$mdl.saveChangeLog();
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ************************************************************** */
		
		// Confirm Action
		$mdl.confirmModal = function() {
			var cfm = confirm("Confirm proceed to revert the Revision?");

			if(cfm)
			{
				$mdl.revertRevision();
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ************************************************************** */

		$mdl.loadData();
	};

	// Sales Config Modal Controller
	function ProductSalesConfigModalCtrl($uibModalInstance, Auth, HttpSvc, UtilSvc, item, toastr) {
		var $mdl = this;

		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.itemId = item.itemId;
		$mdl.configId = item.configId;
		$mdl.currencyCode = item.currencyCode;
		$mdl.debtorList = item.debtorList;		
		$mdl.uomList = item.uomList;		
		$mdl.selectedDebtor = null;
		$mdl.selectedUom = null;
		$mdl.item = {};
		$mdl.item.productId = item.itemId;
		$mdl.isLoading = false;

		/* ********************************************************************** */

		$mdl.loadConfig = function() {
			$mdl.isLoading = true;
			
			HttpSvc.get('productdebtorsalesconfigs/' + $mdl.configId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.item = result;
					$mdl.debtorList.forEach(function(d) {
						if(d.id==$mdl.item.debtorId) {
							$mdl.selectedDebtor = d;
						}
					});
					$mdl.uomList.forEach(function(u) {
						if(u.id==$mdl.item.uomId) {
							$mdl.selectedUom = u;
						}
					});
					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve Sales Config.', Auth.translate('ERROR'));
					$mdl.cancelModal();
			});
		}

		$mdl.createConfig = function() {
			$mdl.isLoading = true;
			
			HttpSvc.post('productdebtorsalesconfigs/add', $mdl.item, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('New Sales Config created succeasfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close();
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to create Sales Config.', Auth.translate('ERROR'));
			});
		}

		$mdl.updateConfig = function() {
			$mdl.isLoading = true;
			
			HttpSvc.put('productdebtorsalesconfigs/' + $mdl.configId, $mdl.item, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Sales Config updated succeasfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close();
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to update Sales Config.', Auth.translate('ERROR'));
			});
		}		

		/* ********************************************************************** */
		
		$mdl.selectedDebtorChanged = function() {
			$mdl.item.debtorId = $mdl.selectedDebtor.id;
		}
		
		$mdl.selectedUomChanged = function() {
			$mdl.item.uomId = $mdl.selectedUom.id;
		}
				
		$mdl.unitPriceChanged = function() {
			if($mdl.item.taxPercentage<0) {
				$mdl.salesConfigForm.TaxPercent.$error.required = true;
			} else {
				$mdl.salesConfigForm.TaxPercent.$error.required = false;
			}
			if($mdl.item.unitPrice==0) return;

			$mdl.item.taxAmount = $mdl.item.taxPercentage * $mdl.item.unitPrice / 100;
			$mdl.item.taxAmount = parseFloat($mdl.item.taxAmount.toFixed(3));
		};
				
		$mdl.taxPercentChanged = function() {
			if($mdl.item.taxPercentage<0) {
				$mdl.salesConfigForm.TaxPercent.$error.required = true;
			} else {
				$mdl.salesConfigForm.TaxPercent.$error.required = false;
			}
			if($mdl.item.unitPrice==0) return;

			$mdl.item.taxAmount = $mdl.item.taxPercentage * $mdl.item.unitPrice / 100;
			$mdl.item.taxAmount = parseFloat($mdl.item.taxAmount.toFixed(3));
		};

		/* ********************************************************************** */

		// Confirm Action
		$mdl.confirmModal = function() {
			if($mdl.salesConfigForm.$invalid) 
			{
				var errorMsg = UtilSvc.getErrorMessage($mdl.salesConfigForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			}
			else
			{
				if(item.mode==1) {
					$mdl.createConfig();
				} else {
					$mdl.updateConfig();
				}
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ********************************************************************** */

		// Initialize
		if(item.mode==1) {
		} else {
			$mdl.loadConfig();
		}
	};

	// Cert Modal Controller
	function ProductCertModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
		
		$mdl.serverMode = item.serverMode;
		$mdl.rootUrl = ($mdl.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		
		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.item = item.object;
		$mdl.lockUploadButton = item.lockUploadButton;
		$mdl.lockButton = false;
		$mdl.uploadProgess = 0;
		$mdl.uploadProgessTotal = 0;
		$mdl.uploadProgessPercent = 0;		
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		// Initialize
		if(item.mode==1) {
			$mdl.item.certType = "";
			$mdl.item.certRefNo = "";
			$mdl.item.issueDate = "";
			$mdl.item.expiryDate = "";
			$mdl.item.remarks = "";
			$mdl.item.certFilename = "";
		} else {
			$mdl.item.issueDate = $filter('date')($mdl.item.issueDate, 'yyyy-MM-dd');
			$mdl.item.expiryDate = $filter('date')($mdl.item.expiryDate, 'yyyy-MM-dd');
		}
		
		// Update Halal Cert
		$mdl.updateCert = function(obj) {
			$mdl.lockButton = true;		
			
			var element = {
				id: obj.id,
				productId: obj.productId,
				certType: obj.certType,
				certRefNo: obj.certRefNo,
				issueDate: obj.issueDate,
				expiryDate: obj.expiryDate,
				remarks: obj.remarks,				
				certFilename: obj.certFilename,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
			};
			
			var mediaLocation = "";
			var mediaExtension = "";
			var newFilename = UtilSvc.generateGuid() + ".";
			azureStorageUrl = "";
			localStorageUrl = "";
						
			if($mdl.serverMode==1 && obj.mediaToUpload) {
				
				var extArray = obj.mediaToUpload.name.split(".");				
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = Auth.getCompanyId() + "/certificates-fg/" + newFilename + mediaExtension;
				
			} else if($mdl.serverMode==0 && obj.mediaToUpload) {	
			
				var extArray = obj.mediaToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = "certificates-fg/" + newFilename + mediaExtension;				
			}	
			if(mediaLocation!="") {
				element.certFilename = mediaLocation;
			}
						
			HttpSvc.put('productcertificates/' + obj.id, element, Auth.getTokenId(), false)
				.then(function(result) {
					
					if($mdl.serverMode==1 && obj.mediaToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + mediaLocation + result.azureSasToken;
						$mdl.uploadMedia(obj.mediaToUpload);
						
					} else if($mdl.serverMode==0 && obj.mediaToUpload) {
						localStorageUrl = RmsApi.URL + "upload/certificates-fg/" + obj.id;
						$mdl.uploadMedia(obj.mediaToUpload);
							
					} else {
						$uibModalInstance.close($mdl.item);
					}					
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					$mdl.lockButton = false;
					$mdl.certForm.$setPristine();
				});	
		};
		
		// Add Halal Cert
		$mdl.addCert = function(obj) {	
			$mdl.lockButton = true;			
			
			var element = {
				productId: obj.productId,
				supplierId: obj.supplierId,
				certType: obj.certType,
				certRefNo: obj.certRefNo,
				issueDate: obj.issueDate,
				expiryDate: obj.expiryDate,
				remarks: obj.remarks,
			};
			
			var mediaLocation = "";
			var mediaExtension = "";
			var newFilename = UtilSvc.generateGuid() + ".";
			azureStorageUrl = "";
			localStorageUrl = "";
			
			if($mdl.serverMode==1 && obj.mediaToUpload) {
				
				var extArray = obj.mediaToUpload.name.split(".");				
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = Auth.getCompanyId() + "/certificates-fg/" + newFilename + mediaExtension;
				
			} else if($mdl.serverMode==0 && obj.mediaToUpload) {	
			
				var extArray = obj.mediaToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = "certificates-fg/" + newFilename + mediaExtension;			
			}

			element.certFilename = mediaLocation;
			
			HttpSvc.post('productcertificates', element, Auth.getTokenId(), false)
				.then(function(result) {
					
					if($mdl.serverMode==1 && obj.mediaToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + mediaLocation + result.azureSasToken;
						$mdl.uploadMedia(obj.mediaToUpload);
						
					} else if($mdl.serverMode==0 && obj.mediaToUpload) {
						localStorageUrl = RmsApi.URL + "upload/certificates-fg/" + result.id;
						$mdl.uploadMedia(obj.mediaToUpload);
					
					} else {
						$uibModalInstance.close($mdl.item);
					}
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					$mdl.lockButton = false;
					$mdl.certForm.$setPristine();
				});			
		};
		
		// ********************************************************
		
        var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		
		// Upload Image to Azure Blob Storage
		$mdl.uploadMedia = function (_fileToUpload) {
			
			/* Initialize variables */
			/* ************************************* */	
			handleFileSelect(_fileToUpload);
			/* ************************************* */	
			
			/* Initialize File Reader */
			/* ************************************* */
			fileReader = new FileReader();
			/* ************************************* */
			
			if($mdl.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (resp) {
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if($mdl.serverMode==1) { // Azure Server
				
				/* Upload File (First Block) */
				/* ************************************* */							
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								$mdl.lockButton = false;					
								$mdl.certForm.$setPristine();
							} 
						}, null, function(evt) {
							$mdl.uploadProgessTotal = _fileToUpload.size;
							$mdl.uploadProgess = $mdl.uploadProgessTotal - totalBytesRemaining;
							$mdl.uploadProgessPercent = Math.min(100, parseInt(100.0 * $mdl.uploadProgess / $mdl.uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,
				
			}).then(function(response) {
				toastr.success("Media uploaded successfully.");
				$uibModalInstance.close($mdl.item);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }
		
		// ********************************************************		
		
		//Set Upload Media
		$mdl.setUploadMedia = function(mediaFile) {
			$mdl.item.mediaToUpload = mediaFile;
		}
		
		// Confirm Action
		$mdl.confirmModal = function() {			
			if($mdl.certForm.$valid) {
				if(item.mode==1) {
					$mdl.addCert($mdl.item);	
				} else if(item.mode==2) {
					$mdl.updateCert($mdl.item);
				}				
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.packagingconditions.controller', [])
        .controller('PackagingConditionMainCtrl', PackagingConditionMainCtrl)
        .controller('PackagingConditionCreateCtrl', PackagingConditionCreateCtrl)
        .controller('PackagingConditionUpdateCtrl', PackagingConditionUpdateCtrl);

    /** @ngInject */
    function PackagingConditionMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.data = [];
		vm.dataFilter = {};

		vm.isLoading = false;

		vm.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}
			
			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";
			
			var params = {
				type: "PKC",
				keyword:  predicate.name,
				isActive: predicate.isActive,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			vm.isLoading = true;
			
			var params = vm.getApiParams(tableState);

			HttpSvc.post('customdatalists/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isLoading = false;		
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;	
					vm.numOfPages = result.numberOfPages;	
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;			
			return tableState;
		};

		vm.resetSearch = function() 
		{		
		}
		
		vm.deleteItem = function(itemId, itemName) {
			var params = {};
			HttpSvc.delete('customdatalists/' + itemId, params, Auth.getTokenId(), false)
				.then(function(result) {
					$scope.$broadcast('refreshStTable');
				}, function() {
					// Failed
					toastr.error('Failed to delete <b>' + itemName + '</b>.', 'Delete Failed');
					return null;
			});
		};	
	};
	
	/** @ngInject */
    function PackagingConditionCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.customdata = {};	
		vm.customdata.type = "PKC";	
		vm.customdata.active = true;	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('customdatalists', vm.customdata, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Packaging Condition has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.packagingconditions.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function PackagingConditionUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.customdata = {};
						
		// Load Packaging Condition
		vm.loadData = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('customdatalists/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.customdata = result;
				}, function() {
					toastr.error('Failed to load selected Packaging Condition.', Auth.translate('ERROR'))
					$state.go('maintenance.packagingconditions.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('customdatalists/' + $stateParams.id, vm.customdata, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Packaging Condition has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadData();		
	}
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.semifgs.controller', [])
        .controller('SfgMainCtrl', SfgMainCtrl)
        .controller('SfgCreateCtrl', SfgCreateCtrl)
        .controller('SfgUpdateCtrl', SfgUpdateCtrl)
        .controller('SfgImportCtrl', SfgImportCtrl)
        .controller('SfgUomModalCtrl', SfgUomModalCtrl)
        .controller('SfgParModalCtrl', SfgParModalCtrl)
        .controller('SfgCertModalCtrl', SfgCertModalCtrl)
        .controller('SfgSalesConfigModalCtrl', SfgSalesConfigModalCtrl);

    /** @ngInject */
    function SfgMainCtrl($scope, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.data = [];
		vm.dataFilter = {};

		vm.isLoading = false;
		vm.serverMode = Auth.getServerMode();
		vm.blobUrl = vm.serverMode==1?RmsApi.BLOBURL :RmsApi.LOCALURL;
		
		vm.loadFilters = function() 
		{
			HttpSvc.get('semifgs/filters', {}, Auth.getTokenId(), false)
				.then(function(result) {		
					vm.dataFilter = result;	
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		}

		vm.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}
			
			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";
			
			var params = {
				keyword:  predicate.code,
				category: predicate.category,
				subcategory: predicate.subCategory,
				active: predicate.active,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			vm.isLoading = true;
			
			var params = vm.getApiParams(tableState);

			HttpSvc.post('semifgs/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isLoading = false;		
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;	
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			var predicate = tableState.search.predicateObject;
			vm.keyword = predicate == null ? vm.keyword : (predicate.vm == null ? vm.keyword : predicate.vm.keyword);
			tableState.pagination.numberOfPages = vm.numOfPages;
			
			return tableState;
		};

		vm.resetSearch = function() 
		{	
		}
		
		vm.deleteItem = function(itemId, itemName) {
			var params = {};
			HttpSvc.delete('semifgs/' + itemId, params, Auth.getTokenId(), false)
				.then(function(result) {
					$scope.$broadcast('refreshStTable');
				}, function() {
					// Failed
					toastr.error('Failed to delete the Semi FG <b>' + itemName + '</b>.', 'Delete Failed');
					return null;
			});
		};		
		
		// Init Call
		//vm.loadFilters();
	};
		
	// 	Auth.init();
		
	// 	var vm = this;
		
	// 	vm.pageSizeOption = [10, 20, 50, 100];
	// 	vm.pageSize = 50;
	// 	vm.numOfRecord = 0;
	// 	vm.numOfRecordFiltered = 0;
	// 	vm.numOfRecordDisplayed = 0;
	// 	vm.startIndex = 0; 
	// 	vm.endIndex = 0;
	// 	vm.itemDataFull = [];
	// 	vm.itemData = [];
	// 	vm.isLoading = false;
	// 	vm.blobUrl = RmsApi.BLOBURL;
	// 	vm.hasPosAccess = Auth.hasCompanyFeature('pos') && Auth.hasPerm('pos', 'ACCESS');

	// 	function refreshTableState(tableState, startIndex, endIndex) {				
						
	// 		var filtered = tableState.search.predicateObject ? $filter('filter')(vm.itemDataFull, tableState.search.predicateObject) : vm.itemDataFull;
	// 		vm.numOfRecordFiltered = filtered.length;
			
	// 		if (tableState.sort.predicate) {
	// 			filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
	// 		}
	// 		var result = filtered.slice(startIndex, startIndex + endIndex);
						
	// 		vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
	// 		vm.itemData = result;
			
	// 		tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
	// 		return tableState;
	// 	};
		
	// 	vm.retrieveData = function(tableState) {
	// 		var pagination = tableState.pagination;
			
	// 		// Restore Table State
    //         // var start = pagination.start2 || pagination.start;
    //         // if (pagination.start != start) {
    //         //     pagination.start = start;
    //         // }
	// 		if(vm.pageSize != pagination.number) {
	// 			vm.pageSize = pagination.number;
	// 		}

	// 		vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
	// 		vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
	// 		if(vm.itemDataFull.length <= 0) {	
	// 			vm.isLoading = true;
				
	// 			HttpSvc.get('semifgs/all', {}, Auth.getTokenId(), true)
	// 				.then(function(result) {	
	// 					vm.isLoading = false;						
	// 					vm.numOfRecord = result.length;	
	// 					vm.itemDataFull = result;		
	// 					refreshTableState(tableState, vm.startIndex, vm.endIndex);
	// 				}, function() {
	// 					vm.isLoading = false;
	// 					toastr.error('Failed to retrieve data.', '');
	// 					return null;
	// 			});
	// 		} else {
	// 			refreshTableState(tableState, vm.startIndex, vm.endIndex);
	// 		}
	// 	};	
		
	// 	vm.deleteItem = function(itemId, itemName) {
	// 		var params = {};
	// 		HttpSvc.delete('semifgs/' + itemId, params, Auth.getTokenId(), false)
	// 			.then(function(result) {
	// 				vm.isLoading = true;
				
	// 				HttpSvc.get('semifgs/all', params, Auth.getTokenId(), true)
	// 					.then(function(result) {	
	// 						vm.isLoading = false;	
	// 						vm.numOfRecord = result.length;
	// 						vm.itemDataFull = result;							
	// 						toastr.success('The item <b>' + itemName + '</b> has been deleted.', 'Delete Success');
	// 						$scope.$broadcast('refreshStTable');
	// 					}, function() {
	// 						vm.isLoading = false;	
	// 						toastr.error('Failed to retrieve data.', '');
	// 						return null;
	// 				});
	// 			}, function() {
	// 				// Failed
	// 				toastr.error('Failed to delete the item <b>' + itemName + '</b>.', 'Delete Failed');
	// 				return null;
	// 		});
	// 	};			
	// };
	
	/** @ngInject */
    function SfgCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {
		Auth.init();
		
		var vm = this;
		vm.mode = 1;
		vm.item = {};
		vm.item.templateContent = {};
		vm.item.semiFinishedProductUnitOfMeasurements = [];
		vm.item.active = true;
		vm.item.yieldPercent = 100;
		vm.item.lifeTime = 0;
		vm.uomList = [];
		vm.recipeList = [];
		vm.selectedRecipe = null;
		vm.uomBase = "";
		vm.uomInventory = "";
		vm.uomOrder = "";
		vm.uomDefault = "";
		vm.isLoading = false;
		vm.hasPosAccess = Auth.hasPerm('pos', 'ACCESS');
		vm.integrationMode = Auth.getIntegrationMode();
		vm.hasAutoCountFields = vm.integrationMode == 2 && Auth.autoCount_EnableSync_SemiFg();
		vm.hasSQLFields = vm.integrationMode == 8 && Auth.sqL_EnableSync_SemiFg();
		vm.autoCount_itemGroups = [];
		vm.autoCount_itemTypes = [];
		vm.sql_itemGroups = [];
		
		vm.item.imageLocation = '';
		vm.blobUrl = vm.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL;
		vm.fileToUpload = null;
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		
		/* ************************************************************* */
		
		vm.initData = function() {
						
			vm.item.imageLocation = 'assets/img/empty_placeholder.png';
			
			if(vm.hasAutoCountFields) {
				vm.loadAutoCountItemTypes();
			} else if (vm.hasSQLFields) {
				vm.loadSQLItemGroups();
			} else {
				vm.loadUomList();
			}
		}

		// Load UOM List
		vm.loadUomList = function() {
			vm.isLoading = true;

			HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;	
					vm.isLoading = false;				
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Recipe List
		vm.loadRecipeList = function(searchString) {
			vm.loadingRecipe = true;
			
			HttpSvc.post('recipes/listByCompany/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.recipeList = result;
					vm.loadingRecipe = false;
				}, function() {
					vm.loadingRecipe = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		};	
		
		/* ************************************************************* */
				
		vm.loadAutoCountItemTypes = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('autocount/maintenance/list/itemtypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_itemTypes = result;
					
					vm.loadAutoCountItemGroups();
				}, function() {
					toastr.error('Failed to load selected AutoCount Item Types.', Auth.translate('ERROR'))
					$state.go('maintenance.products.list');
					return;
				});
		};
				
		vm.loadAutoCountItemGroups = function() {
			HttpSvc.get('autocount/maintenance/list/itemgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_itemGroups = result;
					vm.loadUomList();
				}, function() {
					toastr.error('Failed to load selected AutoCount Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.products.list');
					return;
				});
		};

		vm.loadSQLItemGroups = function() {
			HttpSvc.get('sqlacc/maintenance/stockgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sql_itemGroups = result;
					vm.loadBranchList();
				}, function() {
					toastr.error('Failed to load selected SQL Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};
		/* ************************************************************* */
		
		// Recipe selection changed
		vm.onSelectedRecipeChanged = function() {
			vm.item.recipeId = vm.selectedRecipe.id;
		};		

		// Clear Recipe selection
		vm.clearSelectedRecipe = function() {
			vm.selectedRecipe = null;
			vm.item.recipeId = null;
		};	
		
		// *************************************************************	
		
		vm.selectedItemTypeChanged = function() {
			vm.item.autoCount_ItemType = vm.selectedItemType.itemType1;
		}
		
		vm.selectedItemGroupChanged = function() {
			vm.item.autoCount_ItemGroup = vm.selectedItemGroup.itemGroup1;
		}

		vm.selectedSQLItemGroupChanged = function() {
			vm.item.sqL_ItemGroup = vm.selectedSQLItemGroup.CODE;
		}

		vm.selectedStockControlChanged = function() {
			if(vm.selectedStockControl=="1") {
				vm.item.autoCount_StockControl = true;
			} else if(vm.selectedStockControl=="0") {
				vm.item.autoCount_StockControl = false;
			}
		}

		vm.selectedSQLStockControlChanged = function() {
			if(vm.selectedSQLStockControl=="1") {
				vm.item.sqL_StockControl = true;
			} else if(vm.selectedSQLStockControl=="0") {
				vm.item.sqL_StockControl = false;
			}
		}
		// *************************************************************	

		vm.selectedParallelUom1Changed = function() {
			vm.item.cwm_ParallelUomId = vm.selectedParallelUom1.unitOfMeasurementId;
		}
		
		vm.selectedParallelUom2Changed = function() {
			vm.item.cwm_ParallelUomId_Secondary = vm.selectedParallelUom2.unitOfMeasurementId;
		}

		vm.verifyCWMSettings = function() {
			if(!vm.item.isCWM)
			{
				vm.item.syncCwmParallelUom = false;
				vm.item.cwm_ParallelUomId = null;
				vm.item.cwm_ParallelUomId_Secondary = null;
				vm.item.cwm_ParallelMultiplier = 0;
				vm.item.cwm_TolerencePercent = 0;
			}
		}
		
		// *************************************************************	
		
		// Get UOM
		vm.getDisplayUom = function(uomType) {			
			var objBase = vm.item.semiFinishedProductUnitOfMeasurements.filter(function( obj ) {
				return obj.isBase==true;
			});
			var objInventory = vm.item.semiFinishedProductUnitOfMeasurements.filter(function( obj ) {
				return obj.isInventory==true;
			});
			var objOrder = vm.item.semiFinishedProductUnitOfMeasurements.filter(function( obj ) {
				return obj.isOrder==true;
			});
			var objDefault = vm.item.semiFinishedProductUnitOfMeasurements.filter(function( obj ) {
				return obj.isDefault==true;
			});
						
			if(uomType=="BASE") {
				return objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name;
			}
			if(uomType=="INVENTORY") {
				return objInventory.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objInventory[0].unitOfMeasurement.name;
			}
			if(uomType=="ORDER") {
				return objOrder.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objOrder[0].unitOfMeasurement.name;
			}
			if(uomType=="DEFAULT") {
				return objDefault.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objDefault[0].unitOfMeasurement.name;
			}
			return "x";
		}
		
		// **********************************************
		
		// Remove UOM
		vm.removeUom = function(index) {
			if(confirm('Confirm remove this U.O.M.?')){
				vm.item.semiFinishedProductUnitOfMeasurements.splice(index, 1);
				vm.refreshDisplayUom();
				$scope.$broadcast('refreshStTable');		
			}
		};
			
		// Update UOM
		vm.updateUom = function(index, obj) {
			var element = {
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,	
				},
				baseMultiplier: obj.baseMultiplier,
				isBase: obj.isBase,
				isInventory: obj.isInventory,
				isOrder: obj.isOrder,
				isDefault: obj.isDefault,
				remarks: obj.remarks,
			};
									
			if(element.isBase) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isBase = false;
				})
			}
			if(element.isInventory) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isInventory = false;
				})
			}
			if(element.isOrder) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isOrder = false;
				})
			}
			if(element.isDefault) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isDefault = false;
				})
			}
			
			vm.item.semiFinishedProductUnitOfMeasurements.splice(index, 1, element);			
					
			vm.item.semiFinishedProductUnitOfMeasurements.sort(function(a, b) {
				return a.baseMultiplier - b.baseMultiplier;
			});
			
			vm.refreshDisplayUom();
		};

		// Add UOM
		vm.addUom = function(obj) {
			var element = {
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,	
				},
				baseMultiplier: obj.baseMultiplier,
				isBase: obj.isBase,
				isInventory: obj.isInventory,
				isOrder: obj.isOrder,
				isDefault: obj.isDefault,
				remarks: obj.remarks,
			};
									
			if(element.isBase) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isBase = false;
				})
			}
			if(element.isInventory) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isInventory = false;
				})
			}
			if(element.isOrder) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isOrder = false;
				})
			}
			if(element.isDefault) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isDefault = false;
				})
			}
			
			vm.item.semiFinishedProductUnitOfMeasurements.push(element);
					
			vm.item.semiFinishedProductUnitOfMeasurements.sort(function(a, b) {
				return a.baseMultiplier - b.baseMultiplier;
			});
			
			vm.refreshDisplayUom();
		};

		// Refresh UOM List
		vm.refreshItemUoms = function(tableState) {
			// Do nothing
		};		
		
		vm.refreshDisplayUom = function() {
			vm.uomBase = vm.getDisplayUom('BASE');
			vm.uomInventory = vm.getDisplayUom('INVENTORY');
			vm.uomOrder = vm.getDisplayUom('ORDER');
			vm.uomDefault = vm.getDisplayUom('DEFAULT');
		}
		
		// **********************************************
			
		// Open Modal Dialog
		vm.uom = {};		
		vm.showAddUomModal = function () {
			vm.uom = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'uomModal.html',
				controller: 'SfgUomModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.uom,
							baseUom: vm.getDisplayUom('BASE'),
							uomList: vm.uomList
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addUom(data);
				}, function () {
				});
		};	
		vm.showEditUomModal = function (index) {
			vm.uom = angular.copy(vm.item.semiFinishedProductUnitOfMeasurements[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'uomModal.html',
				controller: 'SfgUomModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.uom,
							baseUom: vm.getDisplayUom('BASE'),
							uomList: vm.uomList
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateUom(index, data);
				}, function () {
				});
		};	
		
		/* ***************************************************************** */
				
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Set Upload Image
		vm.clearImage = function() {			
			vm.item.imageLocation = 'assets/img/empty_placeholder.png';
			vm.item.oriImageLocation = '';
			vm.fileToUpload = null;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (itemId) {
			var fileReader = new FileReader();
						
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Semi FG has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('maintenance.semifgs.update', {'id': itemId });
				}, function (resp) {
					toastr.success('Semi FG has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('maintenance.semifgs.update', {'id': itemId });
				}, function (evt) {
				});
				
			} else if(vm.serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {
							toastr.success('Semi FG has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('maintenance.semifgs.update', {'id': itemId });
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
					});
				}
			}
		};			
		
		// **********************************************
		
		// Form Submission
		vm.submit = function() {
			
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, 'Incomplete Fields');
			} else {
				vm.isLoading = true;

				vm.verifyCWMSettings();

				imgLocation = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/semifgs/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "semifgs/" + newFilename + mediaExtension;

				} else if(vm.item.oriImageLocation!="") {
					imgLocation = vm.item.oriImageLocation;
				}
				vm.item.imageLocation = imgLocation;

				vm.item.companyId = Auth.getCompanyId();
				vm.item.templateContent = angular.toJson(vm.item.templateContent);
				
				HttpSvc.post('semifgs/add', vm.item, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.item.templateContent = angular.fromJson(vm.item.templateContent);
						vm.isLoading = false;
						toastr.error(error, 'Failed');
					});
			}
		}	

		vm.checkResult = function(result) {
			azureStorageUrl = "";
			localStorageUrl = "";

			if(result.httpStatusCode=="200")
			{				
				if(vm.serverMode==1 && vm.fileToUpload) {
					azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
					vm.uploadImage(result.id);
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {
					localStorageUrl = RmsApi.URL + "upload/semifgs/" + result.id;
					vm.uploadImage(result.id);
					
				} else {
					toastr.success('Semi FG has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('maintenance.semifgs.update', {'id': result.id });
				}
			}
			else
			{
				vm.isLoading = false;
				toastr.error(result.message, 'Failed');
				vm.item.templateContent = angular.fromJson(vm.item.templateContent);
			}
		}
		
		// **********************************************
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function SfgUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, UtilSvc, RmsApi, Upload, toastr) {

		Auth.init();
		
		var vm = this;
		
		vm.isRmsLite = Auth.isLiteMode();
		vm.isStarterMode = Auth.isStarterMode();
		
		vm.mode = 2;
		vm.item = {};
		vm.item.yieldPercent = 100;
		vm.item.lifeTime = 0;
		vm.item.templateContent = {};
		vm.item.semiFinishedProductUnitOfMeasurements = [];
		vm.itemData = [];
		vm.branchList = [];
		vm.uomList = [];
		vm.recipeList = [];
		vm.changeLogs = [];
		vm.salesConfigList = [];
		vm.debtorList = [];
		vm.selectedRecipe = null;
		vm.uomBase = "";
		vm.uomInventory = "";
		vm.uomOrder = "";
		vm.uomDefault = "";
		vm.isLoading = false;
		vm.loadingRecipe = false;
		vm.hasPosAccess = Auth.hasPerm('pos', 'ACCESS');
		vm.serverMode = Auth.getServerMode();
		vm.blobUrl = vm.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL;

		vm.integrationMode = Auth.getIntegrationMode();
		vm.hasAutoCountFields = vm.integrationMode == 2 && Auth.autoCount_EnableSync_SemiFg();
		vm.hasSQLFields = vm.integrationMode == 8 && Auth.sqL_EnableSync_SemiFg();
		vm.currencyCode = Auth.getCurrency();
		vm.autoCount_itemGroups = [];
		vm.autoCount_itemTypes = [];
		vm.sql_itemGroups = [];
		
		vm.item.imageLocation = '';
		vm.item.oriImageLocation = '';
		vm.fileToUpload = null;
		vm.mediaToUpload = null;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		
		/* ************************************************************* */
		
		vm.initData = function() {
			if(vm.hasAutoCountFields) {
				vm.loadAutoCountItemTypes();
			} else if (vm.hasSQLFields) {
				vm.loadSQLItemGroups();
			} else {
				vm.loadBranchList();
			}
		}	
				
		// Load Branch List
		vm.loadBranchList = function() {
			vm.isLoading = true;	
					
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadUomList();
				}, function() {
					vm.isLoading = false;	
					toastr.error('Failed to retrieve Branch List.', '');
					return null;
			});
		}
						
		// Load UOM List
		vm.loadUomList = function() {
			vm.isLoading = true;

			HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.loadItem();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};
				
		// Load Recipe List
		vm.loadRecipeList = function(searchString) {
			vm.loadingRecipe = true;
			
			HttpSvc.post('recipes/listByCompany/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.recipeList = result;
					vm.loadingRecipe = false;
				}, function() {
					vm.loadingRecipe = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		};

		vm.loadRecipe = function() {
			if(vm.item.recipeId==null) return;
			
			vm.loadingRecipe = true;

			HttpSvc.get('recipes/' + vm.item.recipeId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.recipeList.push({ id: result.id, name: result.name});
					vm.selectedRecipe = vm.recipeList[0];
					vm.loadingRecipe = false;
				}, function() {
					vm.loadingRecipe = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}	

		// Load Debtor for Sales Config
		vm.loadDebtors = function() {
			HttpSvc.get('debtors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					vm.loadSalesConfigs();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Debtor List.', Auth.translate('ERROR'))
					return;
				});		
		}
		
		// Load Sales Config List
		vm.loadSalesConfigs = function() {
			HttpSvc.get('semifgdebtorsalesconfigs/list/byitem/' + vm.item.id, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.salesConfigList = result;
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Sales Config List.', Auth.translate('ERROR'))
					return;
				});		
		};
		
		/* ************************************************************* */
				
		vm.loadAutoCountItemTypes = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('autocount/maintenance/list/itemtypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_itemTypes = result;
					
					vm.loadAutoCountItemGroups();
				}, function() {
					toastr.error('Failed to load selected AutoCount Item Types.', Auth.translate('ERROR'))
					$state.go('maintenance.products.list');
					return;
				});
		};
				
		vm.loadAutoCountItemGroups = function() {
			HttpSvc.get('autocount/maintenance/list/itemgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_itemGroups = result;
					vm.loadBranchList();
				}, function() {
					toastr.error('Failed to load selected AutoCount Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.products.list');
					return;
				});
		};		
		
		vm.loadSQLItemGroups = function() {
			HttpSvc.get('sqlacc/maintenance/stockgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sql_itemGroups = result;
					vm.loadBranchList();
				}, function() {
					toastr.error('Failed to load selected SQL Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
		};
		// **********************************************

		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('semifgchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};
				
		// Load Item
		vm.loadItem = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('semifgs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.item = result;	
					
					vm.loadRecipe();
					
					if(!vm.item.imageLocation || vm.item.imageLocation=='') {
						vm.item.imageLocation = 'assets/img/empty_placeholder.png';
						vm.item.oriImageLocation = "";
					} else {
						vm.item.oriImageLocation = vm.item.imageLocation;
						vm.item.imageLocation = vm.rootUrl + vm.item.imageLocation;
					}
					
					vm.item.semiFinishedProductUnitOfMeasurements.sort(function(a, b) {
						return a.baseMultiplier - b.baseMultiplier;
					});
					
					vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(u) {
						if(u.unitOfMeasurementId==vm.item.cwm_ParallelUomId)
						{
							vm.selectedParallelUom1 = u;
						}
						if(u.unitOfMeasurementId==vm.item.cwm_ParallelUomId_Secondary)
						{
							vm.selectedParallelUom2 = u;
						}
					});
										
					vm.autoCount_itemTypes.forEach(function(c) {
						if(vm.item.autoCount_ItemType == c.itemType1){
							vm.selectedItemType = c;
						}
					});
										
					vm.autoCount_itemGroups.forEach(function(c) {
						if(vm.item.autoCount_ItemGroup == c.itemGroup1){
							vm.selectedItemGroup = c;
						}
					});

					vm.sql_itemGroups.forEach(function(c) {
						if(vm.item.sqL_ItemGroup == c.CODE){
							vm.selectedSQLItemGroup = c;
						}
					});
					
					if(vm.item.autoCount_StockControl) {
						vm.selectedStockControl = "1";
					} else {
						vm.selectedStockControl = "0";
						vm.item.autoCount_StockControl = false;
					}

					if(vm.item.sqL_StockControl) {
						vm.selectedSQLStockControl = "1";
					} else {
						vm.selectedSQLStockControl = "0";
						vm.item.sqL_StockControl = false;
					}

					try {
						if(vm.item.templateContent==null) {
							vm.item.templateContent = {};
							vm.item.templateContent.nutritions = [];
						} else {
							vm.item.templateContent = angular.fromJson(vm.item.templateContent);
						}						
					} catch (err) {
						vm.item.templateContent = {};
						vm.item.templateContent.nutritions = [];
					}

					vm.loadChangeLogs();
					vm.loadDebtors();
					
					vm.refreshDisplayUom();
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load selected Semi Finished Good.', Auth.translate('ERROR'))
					$state.go('maintenance.semifgs.list');
					return;
				});		
		};
		
		// Recipe selection changed
		vm.onSelectedRecipeChanged = function() {
			vm.item.recipeId = vm.selectedRecipe.id;
		};		

		// Clear Recipe selection
		vm.clearSelectedRecipe = function() {
			vm.selectedRecipe = null;
			vm.item.recipeId = null;
		};
		
		// *************************************************************	
		
		vm.selectedItemTypeChanged = function() {
			vm.item.autoCount_ItemType = vm.selectedItemType.itemType1;
		}
		
		vm.selectedItemGroupChanged = function() {
			vm.item.autoCount_ItemGroup = vm.selectedItemGroup.itemGroup1;
		}

		vm.selectedSQLItemGroupChanged = function() {
			vm.item.sqL_ItemGroup = vm.selectedSQLItemGroup.CODE;
		}

		vm.selectedStockControlChanged = function() {
			if(vm.selectedStockControl=="1") {
				vm.item.autoCount_StockControl = true;
			} else if(vm.selectedStockControl=="0") {
				vm.item.autoCount_StockControl = false;
			}
		}

		vm.selectedSQLStockControlChanged = function() {
			if(vm.selectedSQLStockControl=="1") {
				vm.item.sqL_StockControl = true;
			} else if(vm.selectedSQLStockControl=="0") {
				vm.item.sqL_StockControl = false;
			}
		}
		// *************************************************************	

		vm.selectedParallelUom1Changed = function() {
			vm.item.cwm_ParallelUomId = vm.selectedParallelUom1.unitOfMeasurementId;
		}
		
		vm.selectedParallelUom2Changed = function() {
			vm.item.cwm_ParallelUomId_Secondary = vm.selectedParallelUom2.unitOfMeasurementId;
		}

		vm.verifyCWMSettings = function() {
			if(!vm.item.isCWM)
			{
				vm.item.syncCwmParallelUom = false;
				vm.item.cwm_ParallelUomId = null;
				vm.item.cwm_ParallelUomId_Secondary = null;
				vm.item.cwm_ParallelMultiplier = 0;
				vm.item.cwm_TolerencePercent = 0;
			}
		}

		// *************************************************************	
		
		// Get UOM
		vm.getDisplayUom = function(uomType) {			
			var objBase = vm.item.semiFinishedProductUnitOfMeasurements.filter(function( obj ) {
				return obj.isBase==true;
			});
			var objInventory = vm.item.semiFinishedProductUnitOfMeasurements.filter(function( obj ) {
				return obj.isInventory==true;
			});
			var objOrder = vm.item.semiFinishedProductUnitOfMeasurements.filter(function( obj ) {
				return obj.isOrder==true;
			});
			var objDefault = vm.item.semiFinishedProductUnitOfMeasurements.filter(function( obj ) {
				return obj.isDefault==true;
			});
						
			if(uomType=="BASE") {
				return objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name;
			}
			if(uomType=="INVENTORY") {
				return objInventory.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objInventory[0].unitOfMeasurement.name;
			}
			if(uomType=="ORDER") {
				return objOrder.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objOrder[0].unitOfMeasurement.name;
			}
			if(uomType=="DEFAULT") {
				return objDefault.length<=0 ? (objBase.length<=0 ? 'x' : objBase[0].unitOfMeasurement.name) : objDefault[0].unitOfMeasurement.name;
			}
			return "x";
		}
		
		// **********************************************
		
		// Remove UOM
		vm.removeUom = function(index) {
			if(confirm('Confirm remove this U.O.M.?')){
				vm.item.semiFinishedProductUnitOfMeasurements.splice(index, 1);
				vm.refreshDisplayUom();
				$scope.$broadcast('refreshStTable');		
			}
		};
			
		// Update UOM
		vm.updateUom = function(index, obj) {
			var element = {
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,	
				},
				baseMultiplier: obj.baseMultiplier,
				isBase: obj.isBase,
				isInventory: obj.isInventory,
				isOrder: obj.isOrder,
				isDefault: obj.isDefault,
				remarks: obj.remarks,
			};
									
			if(element.isBase) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isBase = false;
				})
			}
			if(element.isInventory) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isInventory = false;
				})
			}
			if(element.isOrder) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isOrder = false;
				})
			}
			if(element.isDefault) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isDefault = false;
				})
			}
			
			vm.item.semiFinishedProductUnitOfMeasurements.splice(index, 1, element);
			
			vm.item.semiFinishedProductUnitOfMeasurements.sort(function(a, b) {
				return a.baseMultiplier - b.baseMultiplier;
			});
			
			vm.refreshDisplayUom();
		};

		// Add UOM
		vm.addUom = function(obj) {
			var element = {
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.uomName,	
				},
				baseMultiplier: obj.baseMultiplier,
				isBase: obj.isBase,
				isInventory: obj.isInventory,
				isOrder: obj.isOrder,
				isDefault: obj.isDefault,
				remarks: obj.remarks,
			};
									
			if(element.isBase) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isBase = false;
				})
			}
			if(element.isInventory) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isInventory = false;
				})
			}
			if(element.isOrder) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isOrder = false;
				})
			}
			if(element.isDefault) {
				vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(p) {
					p.isDefault = false;
				})
			}
			
			vm.item.semiFinishedProductUnitOfMeasurements.push(element);
					
			vm.item.semiFinishedProductUnitOfMeasurements.sort(function(a, b) {
				return a.baseMultiplier - b.baseMultiplier;
			});
			
			vm.refreshDisplayUom();
		};

		// Refresh UOM List
		vm.refreshItemUoms = function(tableState) {
			// Do nothing
		};		
		
		vm.refreshDisplayUom = function() {
			vm.uomBase = vm.getDisplayUom('BASE');
			vm.uomInventory = vm.getDisplayUom('INVENTORY');
			vm.uomOrder = vm.getDisplayUom('ORDER');
			vm.uomDefault = vm.getDisplayUom('DEFAULT');
		}
				
		/* ************************************************************* */
			
		vm.showAddParModal = function () {
		
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'parModal.html',
				controller: 'SfgParModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							itemId: vm.item.id,
							branchList: vm.branchList,
							uomInventory: vm.uomInventory,
							uomOrder: vm.uomOrder,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addParLevel(data);
				}, function () {
				});
		};	
		vm.showEditParModal = function (index) {
			var parObject = angular.copy(vm.item.semiFinishedProductBranchConfigs[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'parModal.html',
				controller: 'SfgParModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							itemId: vm.item.id,
							branchList: vm.branchList,
							uomInventory: vm.uomInventory,
							uomOrder: vm.uomOrder,
							parObject: parObject
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateParLevel(index, data);
				}, function () {
				});
		};
		vm.removePar = function (index) {
			vm.item.semiFinishedProductBranchConfigs.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};
		vm.addParLevel = function(data) {
			vm.item.semiFinishedProductBranchConfigs.push(data);
		};
		vm.updateParLevel = function(index, data) {
			var obj = vm.item.semiFinishedProductBranchConfigs[index];
			obj.branchId = data.branchId;
			obj.mon = data.mon;
			obj.tue = data.tue;
			obj.wed = data.wed;
			obj.thu = data.thu;
			obj.fri = data.fri;
			obj.sat = data.sat;
			obj.sun = data.sun;
			obj.reOrderLevel = data.reOrderLevel;
			obj.reOrderQuantity = data.reOrderQuantity;
			obj.parLevel = data.parLevel; 
		};
				
		/* ************************************************************* */
		
		/* ************************************************************* */
		
		// Open Cert Modal Dialog		
		vm.showAddCertModal = function () {
			vm.cert = {};
			vm.cert.semiFinishedProductId = vm.item.id;
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'certModal.html',
				controller: 'SfgCertModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.cert,
							serverMode: vm.serverMode,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadCertificates(vm.item.id);
				}, function () {
				});
		};			
		vm.showEditCertModal = function (certId) {
			vm.cert = {};
			vm.item.semiFinishedProductCertificates.forEach(function(s){
				if(s.id==certId) {
					vm.cert = s;
				}
			});
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'certModal.html',
				controller: 'SfgCertModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.cert,
							serverMode: vm.serverMode,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadCertificates(vm.item.id);
				}, function () {
				});
		};	
		
		/* ************************************************************* */
		
		// Load Certs
		vm.loadCertificates = function(itemId) {
			var params = { id: itemId };
			HttpSvc.get('semifgcertificates/list/:id', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.item.semiFinishedProductCertificates = result;
					//$scope.$broadcast('refreshStTable');
				}, function() {
					toastr.error('Failed to load Certificates.', Auth.translate('ERROR'))
					return;
				});		
		};		

		// Remove Cert
		vm.removeCert = function(certId) {	
			HttpSvc.delete('semifgcertificates/' + certId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('The Certificate has been removed.', Auth.translate('SUCCESS'));
					vm.loadCertificates(vm.item.id);
				}, function(error) {
					// Failed
					toastr.error('Failed to remove the Certificate.', 'Failed');
					return null;
				});
		};
		
		/* ************************************************************* */
			
		// Open Modal Dialog
		vm.uom = {};		
		vm.showAddUomModal = function () {
			vm.uom = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'uomModal.html',
				controller: 'SfgUomModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.uom,
							baseUom: vm.getDisplayUom('BASE'),
							uomList: vm.uomList
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addUom(data);
				}, function () {
				});
		};	
		vm.showEditUomModal = function (index) {
			vm.uom = angular.copy(vm.item.semiFinishedProductUnitOfMeasurements[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'uomModal.html',
				controller: 'SfgUomModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.uom,
							baseUom: vm.getDisplayUom('BASE'),
							uomList: vm.uomList
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateUom(index, data);
				}, function () {
				});
		};

		// **********************************************
			
		vm.showAddSalesConfig = function () {
						
			vm.priceUomList = [];
			vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(u) {
				vm.priceUomList.push({ id: u.unitOfMeasurementId, name: u.unitOfMeasurement.name });
			})
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'salesConfigModal.html',
				controller: 'SfgSalesConfigModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							itemId: vm.item.id,
							debtorList: vm.debtorList,
							currencyCode: vm.currencyCode,
							uomList: vm.priceUomList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadSalesConfigs();
				}, function () {
				});
		};	

		vm.showEditSalesConfig = function (configId) {
						
			vm.priceUomList = [];
			vm.item.semiFinishedProductUnitOfMeasurements.forEach(function(u) {
				vm.priceUomList.push({ id: u.unitOfMeasurementId, name: u.unitOfMeasurement.name });
			})
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'salesConfigModal.html',
				controller: 'SfgSalesConfigModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							itemId: vm.item.id,
							configId: configId,
							debtorList: vm.debtorList,
							currencyCode: vm.currencyCode,
							uomList: vm.priceUomList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadSalesConfigs();
				}, function () {
				});
		};

		vm.deleteSalesConfig = function (configId) {
			vm.isLoading = true;
			
			HttpSvc.delete('semifgdebtorsalesconfigs/' + configId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Sales Config deleted successfully.', 'Delete Successful');
					vm.loadSalesConfigs();
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to delete the config. ' + error, 'Delete Failed');
					return null;
			});
		};
		
		/* ***************************************************************** */
				
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Set Upload Image
		vm.clearImage = function() {			
			vm.item.imageLocation = 'assets/img/empty_placeholder.png';
			vm.item.oriImageLocation = '';
			vm.fileToUpload = null;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function () {
			var fileReader = new FileReader();
						
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Semi FG has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('Semi FG has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
				});
				
			} else if(vm.serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {
							toastr.success('Semi FG has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
					});
				}
			}
		};
		
		// **********************************************
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, 'Incomplete Fields');
			} else {
				vm.isLoading = true;	
				vm.item.templateContent = angular.toJson(vm.item.templateContent);

				vm.verifyCWMSettings();

				imgLocation = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/semifgs/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "semifgs/" + newFilename + mediaExtension;

				} else if(vm.item.oriImageLocation!="") {
					imgLocation = vm.item.oriImageLocation;
				}
				vm.item.imageLocation = imgLocation;	

				HttpSvc.put('semifgs/' + $stateParams.id, vm.item, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.isLoading = false;
						toastr.error(error, 'Failed');
						vm.item.templateContent = angular.fromJson(vm.item.templateContent);
					});
			}
		}	

		vm.checkResult = function(result) {
			azureStorageUrl = "";
			localStorageUrl = "";

			if(result.httpStatusCode=="200")
			{
				if(vm.serverMode==1 && vm.fileToUpload) {
					azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
					vm.uploadImage();
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {
					localStorageUrl = RmsApi.URL + "upload/semifgs/" + $stateParams.id;
					vm.uploadImage();
					
				} else {
					toastr.success('Semi FG has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}
			}
			else
			{
				vm.isLoading = false;
				toastr.error(result.message, 'Failed');
				vm.item.templateContent = angular.fromJson(vm.item.templateContent);
			}
		}
		
		// **********************************************
		
		// Call Actions
		vm.initData();
	};
	
	/** @ngInject */
	function SfgImportCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;		
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.importType = 1;
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;
		
		/* **************************************************** */

		vm.scrollLeft = function() {
			document.getElementById('scroll-container').scrollLeft -= 300;
		}
		
		vm.scrollRight = function() {
			document.getElementById('scroll-container').scrollLeft += 300;
		}
		
		/* **************************************************** */
				
		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";

		/* **************************************************** */
		
		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		vm.importOptions.createSemiFg = true;
		vm.importOptions.updateSemiFg = true;
		vm.importOptions.createSupplier = true;
		vm.importOptions.updateSupplier = true;
		vm.importOptions.createPricing = true;
		vm.importOptions.updatePricing = true;
		vm.importOptions.createUom = true;
		vm.importOptions.updateUom = true;
		
		/* **************************************************** */
		
		vm.goBack = function() {
			$state.reload();
		}
		
		/* **************************************************** */
		
		vm.importResult = {};
		
		/* **************************************************** */
				
		vm.downloadTemplate = function(templateNo, templateName) {
			
			var filename = templateName + ".xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject('semifgs/download/template' + templateNo, Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};	
				
		vm.downloadTemplateOther = function(templateName) {
			
			var filename = templateName + ".xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject('semifgdebtorsalesconfigs/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};		
		
		/* **************************************************** */
		
		vm.importData = function() {
			vm.isImporting = true;
			
			HttpSvc.post('semifgs/importData' + vm.importType, vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
				}, function(error) {
				});
		}
		
		vm.importDataOther = function() {
			vm.isImporting = true;
			
			HttpSvc.post('semifgdebtorsalesconfigs/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
				}, function(error) {
				});
		}
		
		/* **************************************************** */
		
		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}
		
		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;			
		}
		
		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];
			
			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}
		
		// Upload File
		vm.uploadFile = function(importType) {	
			vm.resetFileUploadParams();
			
			vm.lockButtons = true;
			vm.importType = importType;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;
								
			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;
			
			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();	
				vm.uploadMedia(vm.mediaToUpload);
			}	
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {
						
						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);
						
					}, function(error) {
						toastr.error(error, 'Failed');
						
						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {					
					vm.isUploaded = true;
					
					// Call Process Excel API 
					var apiUrl = 'semifgs/import/' + vm.importType + '/' + resp.data;
					if(vm.importType == "5")
					{
						apiUrl = 'semifgdebtorsalesconfigs/import/' + resp.data;
					}

					HttpSvc.post(apiUrl, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;
							
							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			}  else if(vm.serverMode==1) { // Azure Server
							
				/* Initialize variables */
				/* ************************************* */	
				handleFileSelect(_fileToUpload);
				/* ************************************* */	
				
				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							} 
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,				
			}).then(function(response) {	
				vm.isUploaded = true;
				
				// Call Process Excel API 
				var apiUrl = 'semifgs/import/' + vm.importType + '/' + excelFilename;
				if(vm.importType == "5")
				{
					apiUrl = 'semifgdebtorsalesconfigs/import/' + excelFilename;
				}

				HttpSvc.post(apiUrl, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;
						
						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }		
	};
	
	// U.O.M. Modal Controller
	function SfgUomModalCtrl($uibModalInstance, item, toastr, UtilSvc) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.baseUom = item.baseUom;
		$mdl.uomList = item.uomList;
		$mdl.item = item.object;
		$mdl.selectedUom = null;
		
		// Initialize
		if(item.mode==1) {
			$mdl.item.unitOfMeasurementId = null;
			$mdl.item.uomName = "";			
			$mdl.item.baseMultiplier = 1;
			$mdl.item.isBase = false,
			$mdl.item.isInventory = false,
			$mdl.item.isOrder = false,
			$mdl.item.isDefault = false,
			$mdl.item.remarks = "";
		} else {
			if($mdl.item.unitOfMeasurementId!='' && $mdl.item.unitOfMeasurementId!=null){
				$mdl.uomList.forEach(function (i) {
					if(i.id==$mdl.item.unitOfMeasurementId) {
						$mdl.selectedUom = i;
						$mdl.item.uomName = i.name;
					}
				});
			};
		}
		
		$mdl.onSelectedUomChanged = function() {
			$mdl.item.unitOfMeasurementId = $mdl.selectedUom.id;
			$mdl.item.uomName = $mdl.selectedUom.name;
		};
		
		$mdl.confirmModal = function() {	
			if($mdl.uomForm.$invalid) 
			{
				var errorMsg = UtilSvc.getErrorMessage($mdl.uomForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			}
			else
			{
				$uibModalInstance.close($mdl.item);
			}			
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
	
	// PAR Modal Controller
	function SfgParModalCtrl($uibModalInstance, item, toastr, UtilSvc) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.branchList = item.branchList;
		$mdl.uomInventory = item.uomInventory;
		$mdl.uomOrder = item.uomOrder;
		$mdl.parObject = item.parObject;
		$mdl.selectedBranch = null;
		$mdl.item = {};
		$mdl.item.semiFinishedProductId = item.itemId;

		/* *************************************************** */
		
		$mdl.selectedBranchChanged = function() {
			$mdl.item.branchId = $mdl.selectedBranch.id;
			$mdl.item.branch = {}
			$mdl.item.branch.name = $mdl.selectedBranch.name;
		};
		
		// Initialize
		if(item.mode==2) {
			$mdl.item = item.parObject;
			$mdl.branchList.forEach(function(b) {
				if(b.id == $mdl.parObject.branchId)
				{
					$mdl.selectedBranch = b;
					$mdl.selectedBranchChanged();
				}
			})
		}

		$mdl.isValidDays = function()  {
			return !$mdl.item.mon && !$mdl.item.tue && !$mdl.item.wed && !$mdl.item.thu && !$mdl.item.fri && !$mdl.item.sat && !$mdl.item.sun
		}

		/* *************************************************** */
		
		$mdl.confirmModal = function() {
			if($mdl.parForm.$invalid) 
			{
				var errorMsg = UtilSvc.getErrorMessage($mdl.parForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			}
			else
			{
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	

	// Sales Config Modal Controller
	function SfgSalesConfigModalCtrl($uibModalInstance, Auth, HttpSvc, UtilSvc, item, toastr) {
		var $mdl = this;

		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.itemId = item.itemId;
		$mdl.configId = item.configId;
		$mdl.currencyCode = item.currencyCode;
		$mdl.debtorList = item.debtorList;		
		$mdl.uomList = item.uomList;		
		$mdl.selectedDebtor = null;
		$mdl.selectedUom = null;
		$mdl.item = {};
		$mdl.item.semiFinishedProductId = item.itemId;
		$mdl.isLoading = false;

		/* ********************************************************************** */

		$mdl.loadConfig = function() {
			$mdl.isLoading = true;
			
			HttpSvc.get('semifgdebtorsalesconfigs/' + $mdl.configId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.item = result;
					$mdl.debtorList.forEach(function(d) {
						if(d.id==$mdl.item.debtorId) {
							$mdl.selectedDebtor = d;
						}
					});
					$mdl.uomList.forEach(function(u) {
						if(u.id==$mdl.item.uomId) {
							$mdl.selectedUom = u;
						}
					});
					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve Sales Config.', Auth.translate('ERROR'));
					$mdl.cancelModal();
			});
		}

		$mdl.createConfig = function() {
			$mdl.isLoading = true;
			
			HttpSvc.post('semifgdebtorsalesconfigs/add', $mdl.item, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('New Sales Config created succeasfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close();
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to create Sales Config.', Auth.translate('ERROR'));
			});
		}

		$mdl.updateConfig = function() {
			$mdl.isLoading = true;
			
			HttpSvc.put('semifgdebtorsalesconfigs/' + $mdl.configId, $mdl.item, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Sales Config updated succeasfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close();
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to update Sales Config.', Auth.translate('ERROR'));
			});
		}		

		/* ********************************************************************** */
		
		$mdl.selectedDebtorChanged = function() {
			$mdl.item.debtorId = $mdl.selectedDebtor.id;
		}
		
		$mdl.selectedUomChanged = function() {
			$mdl.item.uomId = $mdl.selectedUom.id;
		}
				
		$mdl.unitPriceChanged = function() {
			if($mdl.item.taxPercentage<0) {
				$mdl.salesConfigForm.TaxPercent.$error.required = true;
			} else {
				$mdl.salesConfigForm.TaxPercent.$error.required = false;
			}
			if($mdl.item.unitPrice==0) return;

			$mdl.item.taxAmount = $mdl.item.taxPercentage * $mdl.item.unitPrice / 100;
			$mdl.item.taxAmount = parseFloat($mdl.item.taxAmount.toFixed(3));
		};
				
		$mdl.taxPercentChanged = function() {
			if($mdl.item.taxPercentage<0) {
				$mdl.salesConfigForm.TaxPercent.$error.required = true;
			} else {
				$mdl.salesConfigForm.TaxPercent.$error.required = false;
			}
			if($mdl.item.unitPrice==0) return;

			$mdl.item.taxAmount = $mdl.item.taxPercentage * $mdl.item.unitPrice / 100;
			$mdl.item.taxAmount = parseFloat($mdl.item.taxAmount.toFixed(3));
		};

		/* ********************************************************************** */

		// Confirm Action
		$mdl.confirmModal = function() {
			if($mdl.salesConfigForm.$invalid) 
			{
				var errorMsg = UtilSvc.getErrorMessage($mdl.salesConfigForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			}
			else
			{
				if(item.mode==1) {
					$mdl.createConfig();
				} else {
					$mdl.updateConfig();
				}
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ********************************************************************** */

		// Initialize
		if(item.mode==1) {
		} else {
			$mdl.loadConfig();
		}
	};

	// Cert Modal Controller
	function SfgCertModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
		
		$mdl.serverMode = item.serverMode;
		$mdl.rootUrl = ($mdl.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		
		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.item = item.object;
		$mdl.lockUploadButton = item.lockUploadButton;
		$mdl.lockButton = false;
		$mdl.uploadProgess = 0;
		$mdl.uploadProgessTotal = 0;
		$mdl.uploadProgessPercent = 0;		
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		// Initialize
		if(item.mode==1) {
			$mdl.item.certType = "";
			$mdl.item.certRefNo = "";
			$mdl.item.issueDate = "";
			$mdl.item.expiryDate = "";
			$mdl.item.remarks = "";
			$mdl.item.certFilename = "";
		} else {
			$mdl.item.issueDate = $filter('date')($mdl.item.issueDate, 'yyyy-MM-dd');
			$mdl.item.expiryDate = $filter('date')($mdl.item.expiryDate, 'yyyy-MM-dd');
		}
		
		// Update Halal Cert
		$mdl.updateCert = function(obj) {
			$mdl.lockButton = true;		
			
			var element = {
				id: obj.id,
				semiFinishedProductId: obj.semiFinishedProductId,
				certType: obj.certType,
				certRefNo: obj.certRefNo,
				issueDate: obj.issueDate,
				expiryDate: obj.expiryDate,
				remarks: obj.remarks,				
				certFilename: obj.certFilename,
				createdBy: obj.createdBy,
				createdDate: obj.createdDate,
			};
			
			var mediaLocation = "";
			var mediaExtension = "";
			var newFilename = UtilSvc.generateGuid() + ".";
			azureStorageUrl = "";
			localStorageUrl = "";
						
			if($mdl.serverMode==1 && obj.mediaToUpload) {
				
				var extArray = obj.mediaToUpload.name.split(".");				
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = Auth.getCompanyId() + "/certificates-sfg/" + newFilename + mediaExtension;
				
			} else if($mdl.serverMode==0 && obj.mediaToUpload) {	
			
				var extArray = obj.mediaToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = "certificates-sfg/" + newFilename + mediaExtension;				
			}	
			if(mediaLocation!="") {
				element.certFilename = mediaLocation;
			}
						
			HttpSvc.put('semifgcertificates/' + obj.id, element, Auth.getTokenId(), false)
				.then(function(result) {
					
					if($mdl.serverMode==1 && obj.mediaToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + mediaLocation + result.azureSasToken;
						$mdl.uploadMedia(obj.mediaToUpload);
						
					} else if($mdl.serverMode==0 && obj.mediaToUpload) {
						localStorageUrl = RmsApi.URL + "upload/certificates-sfg/" + obj.id;
						$mdl.uploadMedia(obj.mediaToUpload);
							
					} else {
						$uibModalInstance.close($mdl.item);
					}					
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					$mdl.lockButton = false;
					$mdl.certForm.$setPristine();
				});	
		};
		
		// Add Halal Cert
		$mdl.addCert = function(obj) {	
			$mdl.lockButton = true;			
			
			var element = {
				semiFinishedProductId: obj.semiFinishedProductId,
				supplierId: obj.supplierId,
				certType: obj.certType,
				certRefNo: obj.certRefNo,
				issueDate: obj.issueDate,
				expiryDate: obj.expiryDate,
				remarks: obj.remarks,
			};
			
			var mediaLocation = "";
			var mediaExtension = "";
			var newFilename = UtilSvc.generateGuid() + ".";
			azureStorageUrl = "";
			localStorageUrl = "";
			
			if($mdl.serverMode==1 && obj.mediaToUpload) {
				
				var extArray = obj.mediaToUpload.name.split(".");				
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = Auth.getCompanyId() + "/certificates-sfg/" + newFilename + mediaExtension;
				
			} else if($mdl.serverMode==0 && obj.mediaToUpload) {	
			
				var extArray = obj.mediaToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = "certificates-sfg/" + newFilename + mediaExtension;			
			}

			element.certFilename = mediaLocation;
			
			HttpSvc.post('semifgcertificates', element, Auth.getTokenId(), false)
				.then(function(result) {
					
					if($mdl.serverMode==1 && obj.mediaToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + mediaLocation + result.azureSasToken;
						$mdl.uploadMedia(obj.mediaToUpload);
						
					} else if($mdl.serverMode==0 && obj.mediaToUpload) {
						localStorageUrl = RmsApi.URL + "upload/certificates-sfg/" + result.id;
						$mdl.uploadMedia(obj.mediaToUpload);
					
					} else {
						$uibModalInstance.close($mdl.item);
					}
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					$mdl.lockButton = false;
					$mdl.certForm.$setPristine();
				});			
		};
		
		// ********************************************************
		
        var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		
		// Upload Image to Azure Blob Storage
		$mdl.uploadMedia = function (_fileToUpload) {
			
			/* Initialize variables */
			/* ************************************* */	
			handleFileSelect(_fileToUpload);
			/* ************************************* */	
			
			/* Initialize File Reader */
			/* ************************************* */
			fileReader = new FileReader();
			/* ************************************* */
			
			if($mdl.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (resp) {
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if($mdl.serverMode==1) { // Azure Server
				
				/* Upload File (First Block) */
				/* ************************************* */							
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								$mdl.lockButton = false;					
								$mdl.certForm.$setPristine();
							} 
						}, null, function(evt) {
							$mdl.uploadProgessTotal = _fileToUpload.size;
							$mdl.uploadProgess = $mdl.uploadProgessTotal - totalBytesRemaining;
							$mdl.uploadProgessPercent = Math.min(100, parseInt(100.0 * $mdl.uploadProgess / $mdl.uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,
				
			}).then(function(response) {
				toastr.success("Media uploaded successfully.");
				$uibModalInstance.close($mdl.item);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }
		
		// ********************************************************		
		
		//Set Upload Media
		$mdl.setUploadMedia = function(mediaFile) {
			$mdl.item.mediaToUpload = mediaFile;
		}
		
		// Confirm Action
		$mdl.confirmModal = function() {			
			if($mdl.certForm.$valid) {
				if(item.mode==1) {
					$mdl.addCert($mdl.item);	
				} else if(item.mode==2) {
					$mdl.updateCert($mdl.item);
				}				
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
		
})();

(function () {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.shippingfees.controller', [])
        .controller('ShippingFeeMainCtrl', ShippingFeeMainCtrl)
        .controller('ShippingFeeCreateCtrl', ShippingFeeCreateCtrl)
        .controller('ShippingFeeUpdateCtrl', ShippingFeeUpdateCtrl)
        .controller('ShippingFeeDebtorModalCtrl', ShippingFeeDebtorModalCtrl)
        .controller('ShippingFeeViewDebtorModalCtrl', ShippingFeeViewDebtorModalCtrl);

    /** @ngInject */
    function ShippingFeeMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {

        Auth.init();

        var vm = this;
        vm.data = [];
        vm.dataFilter = {};
        vm.isLoading = false;

        vm.currencyCode = Auth.getCurrency();

        vm.retrieveData = function (tableState) {

            vm.isLoading = true;

            HttpSvc.get('shippingfees/list', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.isLoading = false;
                    vm.data = result;
                }, function (error) {
                    vm.isLoading = false;
                    toastr.error('Failed to retrieve data.', '');
                });
        };

        vm.resetSearch = function () {
            vm.dataFilter = {};
            vm.retrieveData({});
        }

        vm.deleteItem = function (itemId, itemName) {
            HttpSvc.delete('shippingfees/' + itemId, {}, Auth.getTokenId(), false)
                .then(function (result) {
                    vm.retrieveData({});
                }, function () {
                    // Failed
                    toastr.error('Failed to delete <b>' + itemName + '</b>.', 'Delete Failed');
                    return null;
                });
        };

        /* ************************************************************* */

        // Open Debtor Modal Dialog
        vm.showViewDebtorModal = function (shippingfeeId) {
            vm.debtors = {};

            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'DebtorModal.html',
                controller: 'ShippingFeeViewDebtorModalCtrl',
                controllerAs: '$mdl',
                size: 'lg',
                resolve: {
                    item: function () {
                        return {
                            id: shippingfeeId,
                        }
                    }
                }
            });

            modalInstance
                .result
                .then(function () {
                }, function () {
                });
        };
    };

    /** @ngInject */
    function ShippingFeeCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
        Auth.init();

        var vm = this;
        vm.mode = 1;
        vm.data = {
            description: "",
            salesAmountStart: 0,
            salesAmountEnd: 0,
            feeAmount: 0,
            active: true,
            debtors: [],
            taxCode: "",
            taxPercentage: 0,
            taxAmount: 0,
            autoCount_ItemCode: "",
            autoCount_ItemGroup: "",
            autoCount_ItemType: "",
            autoCount_ItemUomId: ""
        };
        vm.integrationMode = Auth.getIntegrationMode();
        vm.currencyCode = Auth.getCurrency();
        vm.selectedUom = null;
        vm.uomList = [];
        vm.autoCount_itemGroups = [];
        vm.autoCount_itemTypes = [];
        vm.sql_itemGroups = [];

        /* ***************************************************************** */

        vm.initData = function () {
            vm.loadUomList();
            if (vm.integrationMode == 2) {
                vm.loadAutoCountItemTypes();
            } else if (vm.integrationMode == 8) {
                vm.loadSQLItemGroups();
            } 
        }

        /* ***************************************************************** */

        vm.loadUomList = function () {
            HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.uomList = result;
                }, function () {
                    toastr.error('Failed to retrieve UOM list.', '');
                    return null;
                });
        };

        /* ***************************************************************** */
		vm.loadSQLItemGroups = function() {
			HttpSvc.get('sqlacc/maintenance/stockgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sql_itemGroups = result;
				}, function() {
					toastr.error('Failed to load selected SQL Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
        };

        vm.loadAutoCountItemTypes = function () {
            HttpSvc.get('autocount/maintenance/list/itemtypes', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.autoCount_itemTypes = result;
                    vm.loadAutoCountItemGroups();
                }, function () {
                    toastr.error('Failed to load selected AutoCount Item Types.', Auth.translate('ERROR'))
                    return;
                });
        };

        vm.loadAutoCountItemGroups = function () {
            HttpSvc.get('autocount/maintenance/list/itemgroups', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.autoCount_itemGroups = result;
                }, function () {
                    toastr.error('Failed to load selected AutoCount Item Groups.', Auth.translate('ERROR'))
                    return;
                });
        };

        /* ***************************************************************** */

        vm.selectedUomChanged = function () {
            vm.data.autoCount_ItemUomId = vm.selectedUom.id;

            if (vm.data.autoCount_ItemUomId == "") {
                vm.dataForm.autoCount_ItemUom.$error.required = true;
            }
        }

        vm.selectedSQLUomChanged = function () {
            vm.data.sqL_ItemUomId = vm.selectedUom.id;

            if (vm.data.sqL_ItemUomId == "") {
                vm.dataForm.sqL_ItemUom.$error.required = true;
            }
        }
        /* ***************************************************************** */

        vm.selectedItemTypeChanged = function () {
            vm.data.autoCount_ItemType = vm.selectedItemType.itemType1;
        }

        vm.selectedItemGroupChanged = function () {
            vm.data.autoCount_ItemGroup = vm.selectedItemGroup.itemGroup1;
        }

		vm.selectedSQLItemGroupChanged = function() {
			vm.data.sqL_ItemGroup = vm.selectedSQLItemGroup.CODE;
		}

        /* ***************************************************************** */

        // Watch for changes in feeAmount and taxPercentage to update taxAmount
        $scope.$watchGroup(['vm.data.feeAmount', 'vm.data.taxPercentage'], function (newValues) {
            var feeAmount = parseFloat(newValues[0]);
            var taxPercentage = parseFloat(newValues[1]);

            if (!isNaN(feeAmount) && !isNaN(taxPercentage)) {
                vm.data.taxAmount = (feeAmount * taxPercentage) / 100;
                vm.feeAfterTax = feeAmount + vm.data.taxAmount;
            } else {
                vm.data.taxAmount = 0;
                vm.feeAfterTax = 0;
            }
        });

        // Form Submission
        vm.submit = function () {
            if (vm.dataForm.$invalid) {
                toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
            } else {
                HttpSvc.post('shippingfees', vm.data, Auth.getTokenId(), false)
                    .then(function (result) {
                        toastr.success('Shipping Method has been created successfully.', Auth.translate('SUCCESS'));
                        $state.go('maintenance.shippingfees.list');
                    }, function (error) {
                        toastr.error(error, 'Failed');
                    });
            }
        }

        // Call Action
        vm.initData();
    }

    /** @ngInject */
    function ShippingFeeUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

        Auth.init();

        var vm = this;
        vm.mode = 2;
        vm.data = {};
        vm.integrationMode = Auth.getIntegrationMode();
        vm.currencyCode = Auth.getCurrency();
        vm.selectedUom = null;
        vm.uomList = [];
        vm.autoCount_itemGroups = [];
        vm.autoCount_itemTypes = [];
        vm.sql_itemGroups = [];

        /* ***************************************************************** */

        vm.initData = function () {
            vm.loadUomList();
            if (vm.integrationMode == 2) {
                vm.loadAutoCountItemTypes();
            } else if (vm.integrationMode == 8) {
                vm.loadSQLItemGroups();
            } 
        }

        /* ***************************************************************** */

        // Load Shipping Method
        vm.loadData = function () {
            var params = { id: $stateParams.id };
            HttpSvc.get('shippingfees/:id', params, Auth.getTokenId(), false)
                .then(function (result) {
                    vm.data = result;

                    vm.uomList.forEach(function (u) {
                        if (u.id == vm.data.autoCount_ItemUomId) {
                            vm.selectedUom = u;
                        }
                        if (u.id == vm.data.sqL_ItemUomId) {
                            vm.selectedUom = u;
                        }
                    });

                    vm.autoCount_itemTypes.forEach(function (c) {
                        if (vm.data.autoCount_ItemType == c.itemType1) {
                            vm.selectedItemType = c;
                        }
                    });

                    vm.autoCount_itemGroups.forEach(function (c) {
                        if (vm.data.autoCount_ItemGroup == c.itemGroup1) {
                            vm.selectedItemGroup = c;
                        }
                    });
                    
					vm.sql_itemGroups.forEach(function(c) {
						if(vm.data.sqL_ItemGroup == c.CODE){
							vm.selectedSQLItemGroup = c;
						}
					});
                }, function () {
                    toastr.error('Failed to load selected Shipping Fee.', Auth.translate('ERROR'))
                    $state.go('maintenance.shippingfees.list');
                    return;
                });
        };

        /* ***************************************************************** */

        vm.loadUomList = function () {
            HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.uomList = result;
                    if (vm.integrationMode != 2) {
                        vm.loadData();
                    }
                }, function () {
                    toastr.error('Failed to retrieve UOM list.', '');
                    return null;
                });
        };

        /* ***************************************************************** */
		vm.loadSQLItemGroups = function() {
			HttpSvc.get('sqlacc/maintenance/stockgroups', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sql_itemGroups = result;
				}, function() {
					toastr.error('Failed to load selected SQL Item Groups.', Auth.translate('ERROR'))
					$state.go('maintenance.items.list');
					return;
				});
        };
        
        vm.loadAutoCountItemTypes = function () {
            HttpSvc.get('autocount/maintenance/list/itemtypes', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.autoCount_itemTypes = result;
                    vm.loadAutoCountItemGroups();
                }, function () {
                    toastr.error('Failed to load selected AutoCount Item Types.', Auth.translate('ERROR'))
                    return;
                });
        };

        vm.loadAutoCountItemGroups = function () {
            HttpSvc.get('autocount/maintenance/list/itemgroups', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.autoCount_itemGroups = result;
                    vm.loadData();
                }, function () {
                    toastr.error('Failed to load selected AutoCount Item Groups.', Auth.translate('ERROR'))
                    return;
                });
        };

        /* ***************************************************************** */

        vm.selectedUomChanged = function () {
            vm.data.autoCount_ItemUomId = vm.selectedUom.id;

            if (vm.data.autoCount_ItemUomId == "") {
                vm.dataForm.autoCount_ItemUom.$error.required = true;
            }
        }

        vm.selectedSQLUomChanged = function () {
            vm.data.sqL_ItemUomId = vm.selectedUom.id;

            if (vm.data.sqL_ItemUomId == "") {
                vm.dataForm.sqL_ItemUom.$error.required = true;
            }
        }

        /* ***************************************************************** */

        vm.selectedItemTypeChanged = function () {
            vm.data.autoCount_ItemType = vm.selectedItemType.itemType1;
        }

        vm.selectedItemGroupChanged = function () {
            vm.data.autoCount_ItemGroup = vm.selectedItemGroup.itemGroup1;
        }

		vm.selectedSQLItemGroupChanged = function() {
			vm.data.sqL_ItemGroup = vm.selectedSQLItemGroup.CODE;
		}

        /* ***************************************************************** */

        // Watch for changes in feeAmount and taxPercentage to update taxAmount
        $scope.$watchGroup(['vm.data.feeAmount', 'vm.data.taxPercentage'], function (newValues) {
            var feeAmount = parseFloat(newValues[0]);
            var taxPercentage = parseFloat(newValues[1]);
            if (!isNaN(feeAmount) && !isNaN(taxPercentage)) {
                vm.data.taxAmount = (feeAmount * taxPercentage) / 100;
                vm.feeAfterTax = feeAmount + vm.data.taxAmount;
            } else {
                vm.data.taxAmount = 0;
                vm.feeAfterTax = 0;
            }
        });

        // Form Submission
        vm.submit = function () {
            if (vm.dataForm.$invalid) {
                toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
            } else {
                HttpSvc.put('shippingfees/' + $stateParams.id, vm.data, Auth.getTokenId(), false)
                    .then(function (result) {
                        toastr.success('Shipping Fee has been updated successfully.', Auth.translate('SUCCESS'));
                        $state.reload();
                    }, function (error) {
                        toastr.error(error, 'Failed');
                    });
            }
        }

        /* ************************************************************* */

        // Open Debtor Modal Dialog
        vm.showAddDebtorModal = function () {
            vm.debtors = {};

            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'DebtorModal.html',
                controller: 'ShippingFeeDebtorModalCtrl',
                controllerAs: '$mdl',
                size: 'lg',
                resolve: {
                    item: function () {
                        return {
                        }
                    }
                }
            });

            modalInstance
                .result
                .then(function (dataList) {
                    dataList.forEach(function (debtors) {
                        var isFound = false;
                        vm.data.debtors.forEach(function (debtor) {
                            if (debtor.id == debtors.id) {
                                isFound = true;
                            }
                        });
                        if (!isFound) {
                            vm.data.debtors.push(debtors);
                        }
                        else {
                            toastr.warning('One or more same debtors already exist on the list.');
                        }
                    });
                }, function () {
                });
        };

        // Remove Debtor
        vm.removeDebtor = function (id) {
            for (var i = vm.data.debtors.length - 1; i >= 0; i--) {
                var e = vm.data.debtors[i];
                if (e.id == id) {
                    vm.data.debtors.splice(i, 1);
                }
            };
        };

        // Call Actions
        vm.initData();
    }

    // Debtor Modal Controller
    function ShippingFeeDebtorModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
        var $mdl = this;

        // Initialize
        $mdl.selectedDebtors = [];
        $mdl.debtorList = [];
        $mdl.isLoading = true;
        $mdl.checkAll = false;


        // Load Customer List
        $mdl.loadDebtorList = function () {
            HttpSvc.get('debtors/list', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    $mdl.debtorList = result;
                }, function () {
                    $mdl.isLoading = false;
                    toastr.error("Failed to retrieve Debtor list.", "Failed");
                    $uibModalInstance.dismiss('cancel');
                });
        }

        $mdl.searchDebtor = function () {
            HttpSvc.get('debtors/list/' + $mdl.searchText, {}, Auth.getTokenId(), true)
                .then(function (result) {
                    $mdl.isLoading = false;
                    $mdl.debtorList = result;
                }, function (error) {
                    $mdl.isLoading = false;
                    toastr.error("Failed to retrieve Debtor list.", "Failed");
                    $uibModalInstance.dismiss('cancel');
                });
        }

        $mdl.toggleCheckAll = function () {
            if ($mdl.checkAll) {
                $mdl.selectedDebtors = angular.copy($mdl.debtorList);
            } else {
                $mdl.selectedDebtors = [];
            }
        };

        // Confirm Action
        $mdl.confirmModal = function () {
            var dbList = [];
            $mdl.selectedDebtors.forEach(function (debtors) {
                var debtor = {
                    id: debtors.id,
                    code: debtors.code,
                    name: debtors.name,
                };
                dbList.push(debtor);
            });

            $uibModalInstance.close(dbList);
        };

        // Cancel Action
        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Call Action
        $mdl.loadDebtorList();
    };

    // View Debtor Modal Controller
    function ShippingFeeViewDebtorModalCtrl($uibModalInstance, Auth, HttpSvc, toastr, item) {
        var $mdl = this;

        // Initialize
        $mdl.id = item.id;
        $mdl.description = "";
        $mdl.debtorList = [];
        $mdl.isLoading = true;
        $mdl.checkAll = false;

        // Load Debtor List
        $mdl.loadDebtorList = function () {
            HttpSvc.get('shippingfees/' + $mdl.id, {}, Auth.getTokenId(), false)
                .then(function (result) {
                    $mdl.description = result.description;
                    $mdl.debtorList = result.debtors;
                    $mdl.isLoading = false;
                }, function () {
                    $mdl.isLoading = false;
                    toastr.error("Failed to retrieve Debtor list.", "Failed");
                    $uibModalInstance.dismiss('cancel');
                });
        };

        // Confirm Action
        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Call Action
        $mdl.loadDebtorList();
    }

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.shippingmethods.controller', [])
        .controller('ShippingMethodMainCtrl', ShippingMethodMainCtrl)
        .controller('ShippingMethodCreateCtrl', ShippingMethodCreateCtrl)
        .controller('ShippingMethodUpdateCtrl', ShippingMethodUpdateCtrl)
        .controller('CustomDataListImportCtrl', CustomDataListImportCtrl);

    /** @ngInject */
    function ShippingMethodMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.data = [];
		vm.dataFilter = {};

		vm.isLoading = false;

		vm.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}
			
			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";
			
			var params = {
				type: "SPM",
				keyword:  predicate.name,
				shippingOption: predicate.shippingOption,
				isActive: predicate.isActive,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			vm.isLoading = true;
			
			var params = vm.getApiParams(tableState);

			HttpSvc.post('customdatalists/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isLoading = false;		
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;	
					vm.numOfPages = result.numberOfPages;	
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;			
			return tableState;
		};

		vm.resetSearch = function() 
		{		
		}
		
		vm.deleteItem = function(itemId, itemName) {
			var params = {};
			HttpSvc.delete('customdatalists/' + itemId, params, Auth.getTokenId(), false)
				.then(function(result) {
					$scope.$broadcast('refreshStTable');
				}, function() {
					// Failed
					toastr.error('Failed to delete <b>' + itemName + '</b>.', 'Delete Failed');
					return null;
			});
		};	
	};
	
	/** @ngInject */
    function ShippingMethodCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.customdata = {};	
		vm.customdata.type = "SPM";	
		vm.customdata.shippingOption = 0;	
		vm.customdata.active = true;	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('customdatalists', vm.customdata, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Shipping Method has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.shippingmethods.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function ShippingMethodUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.customdata = {};
						
		// Load Shipping Method
		vm.loadData = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('customdatalists/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.customdata = result;
				}, function() {
					toastr.error('Failed to load selected Shipping Method.', Auth.translate('ERROR'))
					$state.go('maintenance.shippingmethods.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('customdatalists/' + $stateParams.id, vm.customdata, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Shipping Method has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadData();		
	}
	
	/** @ngInject */
	function CustomDataListImportCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;		
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.importType = "";
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;
		
		/* **************************************************** */

		vm.scrollLeft = function() {
			document.getElementById('scroll-container').scrollLeft -= 300;
		}
		
		vm.scrollRight = function() {
			document.getElementById('scroll-container').scrollLeft += 300;
		}
		
		/* **************************************************** */
		
		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";

		/* **************************************************** */
		
		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		vm.importOptions.createCustomData = true;
		vm.importOptions.updateCustomData = true;
		
		/* **************************************************** */
		
		vm.goBack = function() {
			$state.reload();
		}
		
		/* **************************************************** */
		
		vm.importResult = {};
		
		/* **************************************************** */
				
		vm.downloadTemplate = function(templateType, templateName) {
			
			var filename = templateName + ".xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject('customdatalists/download/' + templateType, Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};
		
		/* **************************************************** */
		
		vm.importData = function() 
		{
			vm.isImporting = true;
			
			HttpSvc.post('customdatalists/importData/' + vm.importType, vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
					//vm.lockButtons = false;
					//vm.isImportComplete = true;
					
					//vm.importResult = result;
					
					//toastr.success("Data imported successfully!");
					//$state.go('maintenance.items.list');
				}, function(error) {
					//vm.lockButtons = false;
					//vm.isImportFailed = true;
					
					//toastr.error("Failed to import data! " + error);
				});
		}		

		/* **************************************************** */
		
		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}
		
		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;			
		}
		
		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];
			
			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}
		
		// Upload File
		vm.uploadFile = function(importType) {	
			vm.resetFileUploadParams();
			
			vm.lockButtons = true;
			vm.importType = importType;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;
								
			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;
			
			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();	
				vm.uploadMedia(vm.mediaToUpload);
			}	
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {
						
						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);
						
					}, function(error) {
						toastr.error(error, 'Failed');
						
						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {					
					vm.isUploaded = true;
					
					// Call Process Excel API 
					var apiUrl = 'customdatalists/import/' + vm.importType + '/' + resp.data;

					HttpSvc.post(apiUrl, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;
							
							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			}  else if(vm.serverMode==1) { // Azure Server
							
				/* Initialize variables */
				/* ************************************* */	
				handleFileSelect(_fileToUpload);
				/* ************************************* */	
				
				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							} 
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,				
			}).then(function(response) {	
				vm.isUploaded = true;
				
				// Call Process Excel API 
				var apiUrl = 'customdatalists/import/' + vm.importType + '/' + excelFilename;

				HttpSvc.post(apiUrl, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;
						
						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }		
	};
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.storepurchaseconfigs.controller', [])
        .controller('StorePurchaseConfigsMainCtrl', StorePurchaseConfigsMainCtrl)
        .controller('StorePurchaseConfigsCreateCtrl', StorePurchaseConfigsCreateCtrl)
        .controller('StorePurchaseConfigsUpdateCtrl', StorePurchaseConfigsUpdateCtrl)
        .controller('StorePurchaseConfigsCloneCtrl', StorePurchaseConfigsCloneCtrl);

    /** @ngInject */
    function StorePurchaseConfigsMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.spcDataFull = [];
		vm.spcData = [];

		function refreshTableState(tableState, startIndex, endIndex) {
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.spcDataFull, tableState.search.predicateObject) : vm.spcDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.spcData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.spcDataFull.length <= 0) {							
				HttpSvc.get('storepurchaseconfigs/list', {}, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.spcDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteConfig = function(warehousesId, warehousesName) {
			var params = {};
			HttpSvc.delete('storepurchaseconfigs/' + warehousesId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('storepurchaseconfigs/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.spcDataFull = result;
							
							toastr.success('The Configuration [<b>' + warehousesName + '</b>] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Configuration [' + warehousesName + '].', 'Delete Failed');
					return null;
			});
		};	
		
		// Clone SalesOrder
		vm.cloneConfig = function(configId) {
			$state.go('maintenance.storepurchaseconfigs.clone', {'id': configId });
		}		
	};
	
	/** @ngInject */
    function StorePurchaseConfigsCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();
		
		var vm = this;
		vm.mode = 1;
		vm.spc = {};
		vm.spc.requisitionStorePurchaseStoreLevelConfigs = [];
		vm.spc.requisitionStorePurchaseSupplierLevelConfigs = [];
		vm.spc.requisitionStorePurchaseItemConfigs = [];
		vm.branchList = [];
		vm.supplierList = [];
		vm.rawmatList = [];
		vm.lockButtons = false;
		vm.addStorePanelVisible = false;
		vm.addSupplierPanelVisible = false;
		vm.addRawMatPanelVisible = false;

		/* ********************************************************* */

		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadSuppliers();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});			
		}

		vm.loadSuppliers = function() {
			HttpSvc.get('suppliers/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.supplierList = result;
					vm.loadRawMats();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});			
		}

		vm.loadRawMats = function() {
			HttpSvc.get('items/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.rawmatList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});			
		}

		/* ********************************************************* */

		vm.showAddStorePanel = function() {
			vm.addStorePanelVisible = true;
		}

		vm.closeAddStorePanel = function() {
			vm.selectedStore = null;
			vm.addStorePanelVisible = false;
		}

		vm.addAllStores = function()
		{
			vm.branchList.forEach(function(b) {
				var isFound = false;
				vm.spc.requisitionStorePurchaseStoreLevelConfigs.forEach(function(d) {
					if(d.branchId==b.id)
					{
						isFound=true;
					}
				});
	
				if(!isFound)
				{	
					vm.spc.requisitionStorePurchaseStoreLevelConfigs.push({
						branchId: b.id,
						branchCode: b.code,
						branchName: b.name,
					});
				}
			});
			
			toastr.success("All Stores are added to the list.");			
		}

		vm.addStore = function()
		{
			if(vm.selectedStore==null)
			{
				toastr.warning("Select a store first.");
				return;
			}

			var isFound = false;
			vm.spc.requisitionStorePurchaseStoreLevelConfigs.forEach(function(d) {
				if(d.branchId==vm.selectedStore.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Store is already exist on the list.");
				return;
			}

			vm.spc.requisitionStorePurchaseStoreLevelConfigs.push({
				branchId: vm.selectedStore.id,
				branchCode: vm.selectedStore.code,
				branchName: vm.selectedStore.name,
			});
			toastr.success("Store [" + vm.selectedStore.name + "] is added to the list.");
		}

		vm.removeStore = function(index) {
			vm.spc.requisitionStorePurchaseStoreLevelConfigs.splice(index, 1);
		}

		vm.removeAllStores = function() {
			vm.spc.requisitionStorePurchaseStoreLevelConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddSupplierPanel = function() {
			vm.addSupplierPanelVisible = true;
		}

		vm.closeAddSupplierPanel = function() {
			vm.selectedSupplier = null;
			vm.addSupplierPanelVisible = false;
		}

		vm.addAllSuppliers = function()
		{
			vm.supplierList.forEach(function(s) {
				var isFound = false;
				vm.spc.requisitionStorePurchaseSupplierLevelConfigs.forEach(function(d) {
					if(d.supplierId==s.id)
					{
						isFound=true;
					}
				});
	
				if(!isFound)
				{	
					vm.spc.requisitionStorePurchaseSupplierLevelConfigs.push({
						supplierId: s.id,
						supplierCode: s.code,
						supplierName: s.name,
					});
				}
			});
			
			toastr.success("All Suppliers are added to the list.");			
		}

		vm.addSupplier = function()
		{
			if(vm.selectedSupplier==null)
			{
				toastr.warning("Select a supplier first.");
				return;
			}

			var isFound = false;
			vm.spc.requisitionStorePurchaseSupplierLevelConfigs.forEach(function(d) {
				if(d.supplierId==vm.selectedSupplier.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Supplier is already exist on the list.");
				return;
			}

			vm.spc.requisitionStorePurchaseSupplierLevelConfigs.push({
				supplierId: vm.selectedSupplier.id,
				supplierCode: vm.selectedSupplier.code,
				supplierName: vm.selectedSupplier.name,
			});
			toastr.success("Supplier [" + vm.selectedSupplier.name + "] is added to the list.");
		}

		vm.removeSupplier = function(index) {
			vm.spc.requisitionStorePurchaseSupplierLevelConfigs.splice(index, 1);
		}

		vm.removeAllSuppliers = function() {
			vm.spc.requisitionStorePurchaseSupplierLevelConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddRawMatPanel = function() {
			vm.addRawMatPanelVisible = true;
		}

		vm.closeAddRawMatPanel = function() {
			vm.selectedRawMat = null;
			vm.addRawMatPanelVisible = false;
		}

		vm.addAllRawMats = function()
		{
			vm.rawmatList.forEach(function(b) {
				var isFound = false;
				vm.spc.requisitionStorePurchaseItemConfigs.forEach(function(d) {
					if(d.itemId==b.id)
					{
						isFound=true;
					}
				});
	
				if(!isFound)
				{	
					var item = {
						itemId: b.id,
						itemCode: b.code,
						itemName: b.description,
					};

					var uom = null;
					if(b.uoms.length > 0)
					{
						uom = b.uoms[0];
					};
					
					b.uoms.forEach(function(u) {
						if(u.isInventory)
						{
							uom = u;
						}
					});

					if(uom==null)
					{
						uom = b.uoms[0];
					}

					if(uom!=null)
					{
						item.uomId = uom.uomId;
						item.uomName = uom.uomName;

						vm.spc.requisitionStorePurchaseItemConfigs.push(item);
					}
				}
			});
			
			toastr.success("All Raw Materials are added to the list.");			
		}

		vm.addRawMat = function()
		{
			if(vm.selectedRawMat==null)
			{
				toastr.warning("Select a Raw Material first.");
				return;
			}
			else
			{
				if(vm.selectedRawMatUom==null)
				{
					toastr.warning("Select a UOM first.");
					return;
				}
			}

			var isFound = false;
			vm.spc.requisitionStorePurchaseItemConfigs.forEach(function(d) {
				if(d.itemId==vm.selectedRawMat.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Raw Material is already exist on the list.");
				return;
			}

			vm.spc.requisitionStorePurchaseItemConfigs.push({
				itemId: vm.selectedRawMat.id,
				itemCode: vm.selectedRawMat.code,
				itemName: vm.selectedRawMat.description,
				uomId: vm.selectedRawMatUom.uomId,
				uomName: vm.selectedRawMatUom.uomName,
			});
			toastr.success("Raw Material [" + vm.selectedRawMat.description + "] is added to the list.");

			vm.selectedRawMat = null;
			vm.selectedRawMatUom = null;
		}

		vm.removeRawMat = function(index) 
		{
			vm.spc.requisitionStorePurchaseItemConfigs.splice(index, 1);
		}

		vm.removeAllRawMats = function() 
		{
			vm.spc.requisitionStorePurchaseItemConfigs = [];
		}

		/* ********************************************************* */
		
		// Form Submission
		vm.submit = function() {
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				HttpSvc.post('storepurchaseconfigs', vm.spc, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Store Purchase Configuration has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.storepurchaseconfigs.update', {'id': result.id });
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		/* ********************************************************* */
		
		// Call Actions
		vm.loadBranches();
	}
	
	/** @ngInject */
    function StorePurchaseConfigsUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;
		vm.mode = 2;
		vm.spc = {};
		vm.spc.requisitionStorePurchaseStoreLevelConfigs = [];
		vm.spc.requisitionStorePurchaseSupplierLevelConfigs = [];
		vm.spc.requisitionStorePurchaseItemConfigs = [];
		vm.branchList = [];
		vm.supplierList = [];
		vm.rawmatList = [];
		vm.lockButtons = false;
		vm.addStorePanelVisible = false;
		vm.addSupplierPanelVisible = false;
		vm.addRawMatPanelVisible = false;

		/* ********************************************************* */

		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadSuppliers();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});			
		}

		vm.loadSuppliers = function() {
			HttpSvc.get('suppliers/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.supplierList = result;
					vm.loadRawMats();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});			
		}

		vm.loadRawMats = function() {
			HttpSvc.get('items/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.rawmatList = result;
					vm.loadData();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});			
		}

		vm.loadData = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('storepurchaseconfigs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.spc = result;						
				}, function() {
					toastr.error('Failed to load selected Store Purchase Configuration.', Auth.translate('ERROR'))
					$state.go('maintenance.storepurchaseconfigs.list');
					return;
				});		
		};	

		/* ********************************************************* */

		vm.showAddStorePanel = function() {
			vm.addStorePanelVisible = true;
		}

		vm.closeAddStorePanel = function() {
			vm.selectedStore = null;
			vm.addStorePanelVisible = false;
		}

		vm.addAllStores = function()
		{
			vm.branchList.forEach(function(b) {
				var isFound = false;
				vm.spc.requisitionStorePurchaseStoreLevelConfigs.forEach(function(d) {
					if(d.branchId==b.id)
					{
						isFound=true;
					}
				});
	
				if(!isFound)
				{	
					vm.spc.requisitionStorePurchaseStoreLevelConfigs.push({
						branchId: b.id,
						branchCode: b.code,
						branchName: b.name,
					});
				}
			});
			
			toastr.success("All Stores are added to the list.");			
		}

		vm.addStore = function()
		{
			if(vm.selectedStore==null)
			{
				toastr.warning("Select a store first.");
				return;
			}

			var isFound = false;
			vm.spc.requisitionStorePurchaseStoreLevelConfigs.forEach(function(d) {
				if(d.branchId==vm.selectedStore.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Store is already exist on the list.");
				return;
			}

			vm.spc.requisitionStorePurchaseStoreLevelConfigs.push({
				branchId: vm.selectedStore.id,
				branchCode: vm.selectedStore.code,
				branchName: vm.selectedStore.name,
			});
			toastr.success("Store [" + vm.selectedStore.name + "] is added to the list.");
		}

		vm.removeStore = function(index) {
			vm.spc.requisitionStorePurchaseStoreLevelConfigs.splice(index, 1);
		}

		vm.removeAllStores = function() {
			vm.spc.requisitionStorePurchaseStoreLevelConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddSupplierPanel = function() {
			vm.addSupplierPanelVisible = true;
		}

		vm.closeAddSupplierPanel = function() {
			vm.selectedSupplier = null;
			vm.addSupplierPanelVisible = false;
		}

		vm.addAllSuppliers = function()
		{
			vm.supplierList.forEach(function(s) {
				var isFound = false;
				vm.spc.requisitionStorePurchaseSupplierLevelConfigs.forEach(function(d) {
					if(d.supplierId==s.id)
					{
						isFound=true;
					}
				});
	
				if(!isFound)
				{	
					vm.spc.requisitionStorePurchaseSupplierLevelConfigs.push({
						supplierId: s.id,
						supplierCode: s.code,
						supplierName: s.name,
					});
				}
			});
			
			toastr.success("All Suppliers are added to the list.");			
		}

		vm.addSupplier = function()
		{
			if(vm.selectedSupplier==null)
			{
				toastr.warning("Select a supplier first.");
				return;
			}

			var isFound = false;
			vm.spc.requisitionStorePurchaseSupplierLevelConfigs.forEach(function(d) {
				if(d.supplierId==vm.selectedSupplier.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Supplier is already exist on the list.");
				return;
			}

			vm.spc.requisitionStorePurchaseSupplierLevelConfigs.push({
				supplierId: vm.selectedSupplier.id,
				supplierCode: vm.selectedSupplier.code,
				supplierName: vm.selectedSupplier.name,
			});
			toastr.success("Supplier [" + vm.selectedSupplier.name + "] is added to the list.");
		}

		vm.removeSupplier = function(index) {
			vm.spc.requisitionStorePurchaseSupplierLevelConfigs.splice(index, 1);
		}

		vm.removeAllSuppliers = function() {
			vm.spc.requisitionStorePurchaseSupplierLevelConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddRawMatPanel = function() {
			vm.addRawMatPanelVisible = true;
		}

		vm.closeAddRawMatPanel = function() {
			vm.selectedRawMat = null;
			vm.addRawMatPanelVisible = false;
		}

		vm.addAllRawMats = function()
		{
			vm.rawmatList.forEach(function(b) {
				var isFound = false;
				vm.spc.requisitionStorePurchaseItemConfigs.forEach(function(d) {
					if(d.itemId==b.id)
					{
						isFound=true;
					}
				});
	
				if(!isFound)
				{	
					var item = {
						itemId: b.id,
						itemCode: b.code,
						itemName: b.description,
					};

					var uom = null;
					if(b.uoms.length > 0)
					{
						uom = b.uoms[0];
					};
					
					b.uoms.forEach(function(u) {
						if(u.isInventory)
						{
							uom = u;
						}
					});

					if(uom==null)
					{
						uom = b.uoms[0];
					}

					if(uom!=null)
					{
						item.uomId = uom.uomId;
						item.uomName = uom.uomName;

						vm.spc.requisitionStorePurchaseItemConfigs.push(item);
					}
				}
			});
			
			toastr.success("All Raw Materials are added to the list.");			
		}

		vm.addRawMat = function()
		{
			if(vm.selectedRawMat==null)
			{
				toastr.warning("Select a Raw Material first.");
				return;
			}
			else
			{
				if(vm.selectedRawMatUom==null)
				{
					toastr.warning("Select a UOM first.");
					return;
				}
			}

			var isFound = false;
			vm.spc.requisitionStorePurchaseItemConfigs.forEach(function(d) {
				if(d.itemId==vm.selectedRawMat.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Raw Material is already exist on the list.");
				return;
			}

			vm.spc.requisitionStorePurchaseItemConfigs.push({
				itemId: vm.selectedRawMat.id,
				itemCode: vm.selectedRawMat.code,
				itemName: vm.selectedRawMat.description,
				uomId: vm.selectedRawMatUom.uomId,
				uomName: vm.selectedRawMatUom.uomName,
			});
			toastr.success("Raw Material [" + vm.selectedRawMat.description + "] is added to the list.");

			vm.selectedRawMat = null;
			vm.selectedRawMatUom = null;
		}

		vm.removeRawMat = function(index) 
		{
			vm.spc.requisitionStorePurchaseItemConfigs.splice(index, 1);
		}

		vm.removeAllRawMats = function() 
		{
			vm.spc.requisitionStorePurchaseItemConfigs = [];
		}

		/* ********************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {		
				vm.lockButtons = true;

				HttpSvc.put('storepurchaseconfigs/' + $stateParams.id, vm.spc, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Store Purchase Configuration has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		/* ********************************************************* */
		
		// Call Actions
		vm.loadBranches();
	}
	
	/** @ngInject */
    function StorePurchaseConfigsCloneCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {
		Auth.init();
		
		var vm = this;
		vm.mode = 1;
		vm.spc = {};
		vm.spc.requisitionStorePurchaseStoreLevelConfigs = [];
		vm.spc.requisitionStorePurchaseSupplierLevelConfigs = [];
		vm.spc.requisitionStorePurchaseItemConfigs = [];
		vm.branchList = [];
		vm.supplierList = [];
		vm.rawmatList = [];
		vm.lockButtons = false;
		vm.addStorePanelVisible = false;
		vm.addSupplierPanelVisible = false;
		vm.addRawMatPanelVisible = false;

		/* ********************************************************* */

		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadSuppliers();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});			
		}

		vm.loadSuppliers = function() {
			HttpSvc.get('suppliers/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.supplierList = result;
					vm.loadRawMats();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});			
		}

		vm.loadRawMats = function() {
			HttpSvc.get('items/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.rawmatList = result;
					vm.loadData();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});			
		}

		vm.loadData = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('storepurchaseconfigs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.spc = result;	
					vm.spc.name = vm.spc.name + " (COPY)";				
				}, function() {
					toastr.error('Failed to load selected Store Purchase Configuration.', Auth.translate('ERROR'))
					$state.go('maintenance.storepurchaseconfigs.list');
					return;
				});		
		};	

		/* ********************************************************* */

		vm.showAddStorePanel = function() {
			vm.addStorePanelVisible = true;
		}

		vm.closeAddStorePanel = function() {
			vm.selectedStore = null;
			vm.addStorePanelVisible = false;
		}

		vm.addAllStores = function()
		{
			vm.branchList.forEach(function(b) {
				var isFound = false;
				vm.spc.requisitionStorePurchaseStoreLevelConfigs.forEach(function(d) {
					if(d.branchId==b.id)
					{
						isFound=true;
					}
				});
	
				if(!isFound)
				{	
					vm.spc.requisitionStorePurchaseStoreLevelConfigs.push({
						branchId: b.id,
						branchCode: b.code,
						branchName: b.name,
					});
				}
			});
			
			toastr.success("All Stores are added to the list.");			
		}

		vm.addStore = function()
		{
			if(vm.selectedStore==null)
			{
				toastr.warning("Select a store first.");
				return;
			}

			var isFound = false;
			vm.spc.requisitionStorePurchaseStoreLevelConfigs.forEach(function(d) {
				if(d.branchId==vm.selectedStore.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Store is already exist on the list.");
				return;
			}

			vm.spc.requisitionStorePurchaseStoreLevelConfigs.push({
				branchId: vm.selectedStore.id,
				branchCode: vm.selectedStore.code,
				branchName: vm.selectedStore.name,
			});
			toastr.success("Store [" + vm.selectedStore.name + "] is added to the list.");
		}

		vm.removeStore = function(index) {
			vm.spc.requisitionStorePurchaseStoreLevelConfigs.splice(index, 1);
		}

		vm.removeAllStores = function() {
			vm.spc.requisitionStorePurchaseStoreLevelConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddSupplierPanel = function() {
			vm.addSupplierPanelVisible = true;
		}

		vm.closeAddSupplierPanel = function() {
			vm.selectedSupplier = null;
			vm.addSupplierPanelVisible = false;
		}

		vm.addAllSuppliers = function()
		{
			vm.supplierList.forEach(function(s) {
				var isFound = false;
				vm.spc.requisitionStorePurchaseSupplierLevelConfigs.forEach(function(d) {
					if(d.supplierId==s.id)
					{
						isFound=true;
					}
				});
	
				if(!isFound)
				{	
					vm.spc.requisitionStorePurchaseSupplierLevelConfigs.push({
						supplierId: s.id,
						supplierCode: s.code,
						supplierName: s.name,
					});
				}
			});
			
			toastr.success("All Suppliers are added to the list.");			
		}

		vm.addSupplier = function()
		{
			if(vm.selectedSupplier==null)
			{
				toastr.warning("Select a supplier first.");
				return;
			}

			var isFound = false;
			vm.spc.requisitionStorePurchaseSupplierLevelConfigs.forEach(function(d) {
				if(d.supplierId==vm.selectedSupplier.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Supplier is already exist on the list.");
				return;
			}

			vm.spc.requisitionStorePurchaseSupplierLevelConfigs.push({
				supplierId: vm.selectedSupplier.id,
				supplierCode: vm.selectedSupplier.code,
				supplierName: vm.selectedSupplier.name,
			});
			toastr.success("Supplier [" + vm.selectedSupplier.name + "] is added to the list.");
		}

		vm.removeSupplier = function(index) {
			vm.spc.requisitionStorePurchaseSupplierLevelConfigs.splice(index, 1);
		}

		vm.removeAllSuppliers = function() {
			vm.spc.requisitionStorePurchaseSupplierLevelConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddRawMatPanel = function() {
			vm.addRawMatPanelVisible = true;
		}

		vm.closeAddRawMatPanel = function() {
			vm.selectedRawMat = null;
			vm.addRawMatPanelVisible = false;
		}

		vm.addAllRawMats = function()
		{
			vm.rawmatList.forEach(function(b) {
				var isFound = false;
				vm.spc.requisitionStorePurchaseItemConfigs.forEach(function(d) {
					if(d.itemId==b.id)
					{
						isFound=true;
					}
				});
	
				if(!isFound)
				{	
					var item = {
						itemId: b.id,
						itemCode: b.code,
						itemName: b.description,
					};

					var uom = null;
					if(b.uoms.length > 0)
					{
						uom = b.uoms[0];
					};
					
					b.uoms.forEach(function(u) {
						if(u.isInventory)
						{
							uom = u;
						}
					});

					if(uom==null)
					{
						uom = b.uoms[0];
					}

					if(uom!=null)
					{
						item.uomId = uom.uomId;
						item.uomName = uom.uomName;

						vm.spc.requisitionStorePurchaseItemConfigs.push(item);
					}
				}
			});
			
			toastr.success("All Raw Materials are added to the list.");			
		}

		vm.addRawMat = function()
		{
			if(vm.selectedRawMat==null)
			{
				toastr.warning("Select a Raw Material first.");
				return;
			}
			else
			{
				if(vm.selectedRawMatUom==null)
				{
					toastr.warning("Select a UOM first.");
					return;
				}
			}

			var isFound = false;
			vm.spc.requisitionStorePurchaseItemConfigs.forEach(function(d) {
				if(d.itemId==vm.selectedRawMat.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Raw Material is already exist on the list.");
				return;
			}

			vm.spc.requisitionStorePurchaseItemConfigs.push({
				itemId: vm.selectedRawMat.id,
				itemCode: vm.selectedRawMat.code,
				itemName: vm.selectedRawMat.description,
				uomId: vm.selectedRawMatUom.uomId,
				uomName: vm.selectedRawMatUom.uomName,
			});
			toastr.success("Raw Material [" + vm.selectedRawMat.description + "] is added to the list.");

			vm.selectedRawMat = null;
			vm.selectedRawMatUom = null;
		}

		vm.removeRawMat = function(index) 
		{
			vm.spc.requisitionStorePurchaseItemConfigs.splice(index, 1);
		}

		vm.removeAllRawMats = function() 
		{
			vm.spc.requisitionStorePurchaseItemConfigs = [];
		}

		/* ********************************************************* */
		
		// Form Submission
		vm.submit = function() {
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				HttpSvc.post('storepurchaseconfigs', vm.spc, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Store Purchase Configuration has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.storepurchaseconfigs.update', {'id': result.id });
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		/* ********************************************************* */
		
		// Call Actions
		vm.loadBranches();
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.stockrequestconfigs.controller', [])
        .controller('StockRequestConfigsMainCtrl', StockRequestConfigsMainCtrl)
        .controller('StockRequestConfigsCreateCtrl', StockRequestConfigsCreateCtrl)
        .controller('StockRequestConfigsUpdateCtrl', StockRequestConfigsUpdateCtrl)
        .controller('StockRequestConfigsCloneCtrl', StockRequestConfigsCloneCtrl);

    /** @ngInject */
    function StockRequestConfigsMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.srcDataFull = [];
		vm.srcData = [];

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.srcDataFull, tableState.search.predicateObject) : vm.srcDataFull;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.srcData = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;

			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.srcDataFull.length <= 0) {
				HttpSvc.get('stockrequestconfigs/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.numOfRecord = result.length;
						vm.srcDataFull = result;
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		vm.deleteConfig = function(warehousesId, warehousesName) {
			var params = {};
			HttpSvc.delete('stockrequestconfigs/' + warehousesId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('stockrequestconfigs/list', params, Auth.getTokenId(), true)
						.then(function(result) {
							vm.numOfRecord = result.length;
							vm.srcDataFull = result;

							toastr.success('The Configuration [<b>' + warehousesName + '</b>] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Configuration [' + warehousesName + '].', 'Delete Failed');
					return null;
			});
		};

		// Clone SalesOrder
		vm.cloneConfig = function(configId) {
			$state.go('maintenance.stockrequestconfigs.clone', {'id': configId });
		}
	};

	/** @ngInject */
    function StockRequestConfigsCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.mode = 1;
		vm.src = {};
		vm.src.stockRequestStoreLevelConfigs = [];
		vm.src.stockRequestItemConfigs = [];
		vm.src.stockRequestSemiFinishedProductConfigs = [];
		vm.src.stockRequestProductConfigs = [];
		vm.branchList = [];
		vm.rawmatList = [];
		vm.sfgList = [];
		vm.fgList = [];
		vm.lockButtons = false;
		vm.addStorePanelVisible = false;
		vm.addRawMatPanelVisible = false;
		vm.addSemiFgPanelVisible = false;
		vm.addFgPanelVisible = false;

		/* ********************************************************* */

		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadRawMats();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.loadRawMats = function() {
			HttpSvc.get('items/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.rawmatList = result;
					vm.loadSemiFgs();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.loadSemiFgs = function() {
			HttpSvc.get('semifgs/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sfgList = result;
					vm.loadFgs();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.loadFgs = function() {
			HttpSvc.get('products/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.fgList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		/* ********************************************************* */

		vm.showAddStorePanel = function() {
			vm.addStorePanelVisible = true;
		}

		vm.closeAddStorePanel = function() {
			vm.selectedStore = null;
			vm.addStorePanelVisible = false;
		}

		vm.addAllStores = function()
		{
			vm.branchList.forEach(function(b) {
				var isFound = false;
				vm.src.stockRequestStoreLevelConfigs.forEach(function(d) {
					if(d.branchId==b.id)
					{
						isFound=true;
					}
				});

				if(!isFound)
				{
					vm.src.stockRequestStoreLevelConfigs.push({
						branchId: b.id,
						branchCode: b.code,
						branchName: b.name,
					});
				}
			});

			toastr.success("All Stores are added to the list.");
		}

		vm.addStore = function()
		{
			if(vm.selectedStore==null)
			{
				toastr.warning("Select a store first.");
				return;
			}

			var isFound = false;
			vm.src.stockRequestStoreLevelConfigs.forEach(function(d) {
				if(d.branchId==vm.selectedStore.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Store is already exist on the list.");
				return;
			}

			vm.src.stockRequestStoreLevelConfigs.push({
				branchId: vm.selectedStore.id,
				branchCode: vm.selectedStore.code,
				branchName: vm.selectedStore.name,
			});
			toastr.success("Store [" + vm.selectedStore.name + "] is added to the list.");
		}

		vm.removeStore = function(index) {
			vm.src.stockRequestStoreLevelConfigs.splice(index, 1);
		}

		vm.removeAllStores = function() {
			vm.src.stockRequestStoreLevelConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddRawMatPanel = function() {
			vm.addRawMatPanelVisible = true;
		}

		vm.closeAddRawMatPanel = function() {
			vm.selectedRawMat = null;
			vm.addRawMatPanelVisible = false;
		}

		vm.addAllRawMats = function()
		{
			vm.rawmatList.forEach(function(b) {
				var isFound = false;
				vm.src.stockRequestItemConfigs.forEach(function(d) {
					if(d.itemId==b.id)
					{
						isFound=true;
					}
				});

				if(!isFound)
				{
					var item = {
						itemId: b.id,
						itemCode: b.code,
						itemName: b.description,
					};

					var uom = null;
					if(b.uoms.length > 0)
					{
						uom = b.uoms[0];
					};

					b.uoms.forEach(function(u) {
						if(u.isInventory)
						{
							uom = u;
						}
					});

					if(uom==null)
					{
						uom = b.uoms[0];
					}

					if(uom!=null)
					{
						item.uomId = uom.uomId;
						item.uomName = uom.uomName;

						vm.src.stockRequestItemConfigs.push(item);
					}
				}
			});

			toastr.success("All Raw Materials are added to the list.");
		}

		vm.addRawMat = function()
		{
			if(vm.selectedRawMat==null)
			{
				toastr.warning("Select a Raw Material first.");
				return;
			}
			else
			{
				if(vm.selectedRawMatUom==null)
				{
					toastr.warning("Select a UOM first.");
					return;
				}
			}

			var isFound = false;
			vm.src.stockRequestItemConfigs.forEach(function(d) {
				if(d.itemId==vm.selectedRawMat.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Raw Material is already exist on the list.");
				return;
			}

			vm.src.stockRequestItemConfigs.push({
				itemId: vm.selectedRawMat.id,
				itemCode: vm.selectedRawMat.code,
				itemName: vm.selectedRawMat.description,
				uomId: vm.selectedRawMatUom.uomId,
				uomName: vm.selectedRawMatUom.uomName,
			});
			toastr.success("Raw Material [" + vm.selectedRawMat.description + "] is added to the list.");

			vm.selectedRawMat = null;
			vm.selectedRawMatUom = null;
		}

		vm.removeRawMat = function(index)
		{
			vm.src.stockRequestItemConfigs.splice(index, 1);
		}

		vm.removeAllRawMats = function()
		{
			vm.src.stockRequestItemConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddSemiFgPanel = function() {
			vm.addSemiFgPanelVisible = true;
		}

		vm.closeAddSemiFgPanel = function() {
			vm.selectedSemiFg = null;
			vm.addSemiFgPanelVisible = false;
		}

		vm.addAllSemiFgs = function()
		{
			vm.sfgList.forEach(function(b) {
				var isFound = false;
				vm.src.stockRequestSemiFinishedProductConfigs.forEach(function(d) {
					if(d.semiFinishedProductId==b.id)
					{
						isFound=true;
					}
				});

				if(!isFound)
				{
					var item = {
						semiFinishedProductId: b.id,
						semiFinishedProductCode: b.code,
						semiFinishedProductName: b.description,
					};

					var uom = null;
					if(b.uoms.length > 0)
					{
						uom = b.uoms[0];
					};

					b.uoms.forEach(function(u) {
						if(u.isInventory)
						{
							uom = u;
						}
					});

					if(uom==null)
					{
						uom = b.uoms[0];
					}

					if(uom!=null)
					{
						item.uomId = uom.uomId;
						item.uomName = uom.uomName;

						vm.src.stockRequestSemiFinishedProductConfigs.push(item);
					}
				}
			});

			toastr.success("All Semi Finished Goods are added to the list.");
		}

		vm.addSemiFg = function()
		{
			if(vm.selectedSemiFg==null)
			{
				toastr.warning("Select a Semi Finished Good first.");
				return;
			}
			else
			{
				if(vm.selectedSemiFgUom==null)
				{
					toastr.warning("Select a UOM first.");
					return;
				}
			}

			var isFound = false;
			vm.src.stockRequestSemiFinishedProductConfigs.forEach(function(d) {
				if(d.semiFinishedProductId==vm.selectedSemiFg.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Semi Finished Good is already exist on the list.");
				return;
			}

			vm.src.stockRequestSemiFinishedProductConfigs.push({
				semiFinishedProductId: vm.selectedSemiFg.id,
				semiFinishedProductCode: vm.selectedSemiFg.code,
				semiFinishedProductName: vm.selectedSemiFg.description,
				uomId: vm.selectedSemiFgUom.uomId,
				uomName: vm.selectedSemiFgUom.uomName,
			});
			toastr.success("Semi Finished Good [" + vm.selectedSemiFg.description + "] is added to the list.");

			vm.selectedSemiFg = null;
			vm.selectedSemiFgUom = null;
		}

		vm.removeSemiFg = function(index)
		{
			vm.src.stockRequestSemiFinishedProductConfigs.splice(index, 1);
		}

		vm.removeAllSemiFgs = function()
		{
			vm.src.stockRequestSemiFinishedProductConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddFgPanel = function() {
			vm.addFgPanelVisible = true;
		}

		vm.closeAddFgPanel = function() {
			vm.selectedFg = null;
			vm.addFgPanelVisible = false;
		}

		vm.addAllFgs = function()
		{
			vm.fgList.forEach(function(b) {
				var isFound = false;
				vm.src.stockRequestProductConfigs.forEach(function(d) {
					if(d.productId==b.id)
					{
						isFound=true;
					}
				});

				if(!isFound)
				{
					var item = {
						productId: b.id,
						productCode: b.code,
						productName: b.name,
					};

					var uom = null;
					if(b.uoms.length > 0)
					{
						uom = b.uoms[0];
					};

					b.uoms.forEach(function(u) {
						if(u.isInventory)
						{
							uom = u;
						}
					});

					if(uom==null)
					{
						uom = b.uoms[0];
					}

					if(uom!=null)
					{
						item.uomId = uom.uomId;
						item.uomName = uom.uomName;

						vm.src.stockRequestProductConfigs.push(item);
					}
				}
			});

			toastr.success("All Finished Goods are added to the list.");
		}

		vm.addFg = function()
		{
			if(vm.selectedFg==null)
			{
				toastr.warning("Select a Finished Good first.");
				return;
			}
			else
			{
				if(vm.selectedFgUom==null)
				{
					toastr.warning("Select a UOM first.");
					return;
				}
			}

			var isFound = false;
			vm.src.stockRequestProductConfigs.forEach(function(d) {
				if(d.productId==vm.selectedFg.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Finished Good is already exist on the list.");
				return;
			}

			vm.src.stockRequestProductConfigs.push({
				productId: vm.selectedFg.id,
				productCode: vm.selectedFg.code,
				productName: vm.selectedFg.name,
				uomId: vm.selectedFgUom.uomId,
				uomName: vm.selectedFgUom.uomName,
			});
			toastr.success("Finished Good [" + vm.selectedFg.name + "] is added to the list.");

			vm.selectedFg = null;
			vm.selectedFgUom = null;
		}

		vm.removeFg = function(index)
		{
			vm.src.stockRequestProductConfigs.splice(index, 1);
		}

		vm.removeAllFgs = function()
		{
			vm.src.stockRequestProductConfigs = [];
		}

		/* ********************************************************* */

		// Form Submission
		vm.submit = function() {

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				HttpSvc.post('stockrequestconfigs', vm.src, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Stock Request Configuration has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.stockrequestconfigs.update', {'id': result.id });
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		/* ********************************************************* */

		// Call Actions
		vm.loadBranches();
	}

	/** @ngInject */
    function StockRequestConfigsUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;
		vm.mode = 2;
		vm.src = {};
		vm.src.stockRequestStoreLevelConfigs = [];
		vm.src.stockRequestItemConfigs = [];
		vm.src.stockRequestSemiFinishedProductConfigs = [];
		vm.src.stockRequestProductConfigs = [];
		vm.branchList = [];
		vm.rawmatList = [];
		vm.sfgList = [];
		vm.fgList = [];
		vm.lockButtons = false;
		vm.addStorePanelVisible = false;
		vm.addRawMatPanelVisible = false;
		vm.addSemiFgPanelVisible = false;
		vm.addFgPanelVisible = false;

		/* ********************************************************* */

		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadRawMats();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.loadRawMats = function() {
			HttpSvc.get('items/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.rawmatList = result;
					vm.loadSemiFgs();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.loadSemiFgs = function() {
			HttpSvc.get('semifgs/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sfgList = result;
					vm.loadFgs();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.loadFgs = function() {
			HttpSvc.get('products/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.fgList = result;
					vm.loadData();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.loadData = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('stockrequestconfigs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.src = result;
				}, function() {
					toastr.error('Failed to load selected Stock Request Configuration.', Auth.translate('ERROR'))
					$state.go('maintenance.stockrequestconfigs.list');
					return;
				});
		};

		/* ********************************************************* */

		vm.showAddStorePanel = function() {
			vm.addStorePanelVisible = true;
		}

		vm.closeAddStorePanel = function() {
			vm.selectedStore = null;
			vm.addStorePanelVisible = false;
		}

		vm.addAllStores = function()
		{
			vm.branchList.forEach(function(b) {
				var isFound = false;
				vm.src.stockRequestStoreLevelConfigs.forEach(function(d) {
					if(d.branchId==b.id)
					{
						isFound=true;
					}
				});

				if(!isFound)
				{
					vm.src.stockRequestStoreLevelConfigs.push({
						branchId: b.id,
						branchCode: b.code,
						branchName: b.name,
					});
				}
			});

			toastr.success("All Stores are added to the list.");
		}

		vm.addStore = function()
		{
			if(vm.selectedStore==null)
			{
				toastr.warning("Select a store first.");
				return;
			}

			var isFound = false;
			vm.src.stockRequestStoreLevelConfigs.forEach(function(d) {
				if(d.branchId==vm.selectedStore.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Store is already exist on the list.");
				return;
			}

			vm.src.stockRequestStoreLevelConfigs.push({
				branchId: vm.selectedStore.id,
				branchCode: vm.selectedStore.code,
				branchName: vm.selectedStore.name,
			});
			toastr.success("Store [" + vm.selectedStore.name + "] is added to the list.");
		}

		vm.removeStore = function(index) {
			vm.src.stockRequestStoreLevelConfigs.splice(index, 1);
		}

		vm.removeAllStores = function() {
			vm.src.stockRequestStoreLevelConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddRawMatPanel = function() {
			vm.addRawMatPanelVisible = true;
		}

		vm.closeAddRawMatPanel = function() {
			vm.selectedRawMat = null;
			vm.addRawMatPanelVisible = false;
		}

		vm.addAllRawMats = function()
		{
			vm.rawmatList.forEach(function(b) {
				var isFound = false;
				vm.src.stockRequestItemConfigs.forEach(function(d) {
					if(d.itemId==b.id)
					{
						isFound=true;
					}
				});

				if(!isFound)
				{
					var item = {
						itemId: b.id,
						itemCode: b.code,
						itemName: b.description,
					};

					var uom = null;
					if(b.uoms.length > 0)
					{
						uom = b.uoms[0];
					};

					b.uoms.forEach(function(u) {
						if(u.isInventory)
						{
							uom = u;
						}
					});

					if(uom==null)
					{
						uom = b.uoms[0];
					}

					if(uom!=null)
					{
						item.uomId = uom.uomId;
						item.uomName = uom.uomName;

						vm.src.stockRequestItemConfigs.push(item);
					}
				}
			});

			toastr.success("All Raw Materials are added to the list.");
		}

		vm.addRawMat = function()
		{
			if(vm.selectedRawMat==null)
			{
				toastr.warning("Select a Raw Material first.");
				return;
			}
			else
			{
				if(vm.selectedRawMatUom==null)
				{
					toastr.warning("Select a UOM first.");
					return;
				}
			}

			var isFound = false;
			vm.src.stockRequestItemConfigs.forEach(function(d) {
				if(d.itemId==vm.selectedRawMat.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Raw Material is already exist on the list.");
				return;
			}

			vm.src.stockRequestItemConfigs.push({
				itemId: vm.selectedRawMat.id,
				itemCode: vm.selectedRawMat.code,
				itemName: vm.selectedRawMat.description,
				uomId: vm.selectedRawMatUom.uomId,
				uomName: vm.selectedRawMatUom.uomName,
			});
			toastr.success("Raw Material [" + vm.selectedRawMat.description + "] is added to the list.");

			vm.selectedRawMat = null;
			vm.selectedRawMatUom = null;
		}

		vm.removeRawMat = function(index)
		{
			vm.src.stockRequestItemConfigs.splice(index, 1);
		}

		vm.removeAllRawMats = function()
		{
			vm.src.stockRequestItemConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddSemiFgPanel = function() {
			vm.addSemiFgPanelVisible = true;
		}

		vm.closeAddSemiFgPanel = function() {
			vm.selectedSemiFg = null;
			vm.addSemiFgPanelVisible = false;
		}

		vm.addAllSemiFgs = function()
		{
			vm.sfgList.forEach(function(b) {
				var isFound = false;
				vm.src.stockRequestSemiFinishedProductConfigs.forEach(function(d) {
					if(d.semiFinishedProductId==b.id)
					{
						isFound=true;
					}
				});

				if(!isFound)
				{
					var item = {
						semiFinishedProductId: b.id,
						semiFinishedProductCode: b.code,
						semiFinishedProductName: b.description,
					};

					var uom = null;
					if(b.uoms.length > 0)
					{
						uom = b.uoms[0];
					};

					b.uoms.forEach(function(u) {
						if(u.isInventory)
						{
							uom = u;
						}
					});

					if(uom==null)
					{
						uom = b.uoms[0];
					}

					if(uom!=null)
					{
						item.uomId = uom.uomId;
						item.uomName = uom.uomName;

						vm.src.stockRequestSemiFinishedProductConfigs.push(item);
					}
				}
			});

			toastr.success("All Semi Finished Goods are added to the list.");
		}

		vm.addSemiFg = function()
		{
			if(vm.selectedSemiFg==null)
			{
				toastr.warning("Select a Semi Finished Good first.");
				return;
			}
			else
			{
				if(vm.selectedSemiFgUom==null)
				{
					toastr.warning("Select a UOM first.");
					return;
				}
			}

			var isFound = false;
			vm.src.stockRequestSemiFinishedProductConfigs.forEach(function(d) {
				if(d.semiFinishedProductId==vm.selectedSemiFg.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Semi Finished Good is already exist on the list.");
				return;
			}

			vm.src.stockRequestSemiFinishedProductConfigs.push({
				semiFinishedProductId: vm.selectedSemiFg.id,
				semiFinishedProductCode: vm.selectedSemiFg.code,
				semiFinishedProductName: vm.selectedSemiFg.description,
				uomId: vm.selectedSemiFgUom.uomId,
				uomName: vm.selectedSemiFgUom.uomName,
			});
			toastr.success("Semi Finished Good [" + vm.selectedSemiFg.description + "] is added to the list.");

			vm.selectedSemiFg = null;
			vm.selectedSemiFgUom = null;
		}

		vm.removeSemiFg = function(index)
		{
			vm.src.stockRequestSemiFinishedProductConfigs.splice(index, 1);
		}

		vm.removeAllSemiFgs = function()
		{
			vm.src.stockRequestSemiFinishedProductConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddFgPanel = function() {
			vm.addFgPanelVisible = true;
		}

		vm.closeAddFgPanel = function() {
			vm.selectedFg = null;
			vm.addFgPanelVisible = false;
		}

		vm.addAllFgs = function()
		{
			vm.fgList.forEach(function(b) {
				var isFound = false;
				vm.src.stockRequestProductConfigs.forEach(function(d) {
					if(d.productId==b.id)
					{
						isFound=true;
					}
				});

				if(!isFound)
				{
					var item = {
						productId: b.id,
						productCode: b.code,
						productName: b.name,
					};

					var uom = null;
					if(b.uoms.length > 0)
					{
						uom = b.uoms[0];
					};

					b.uoms.forEach(function(u) {
						if(u.isInventory)
						{
							uom = u;
						}
					});

					if(uom==null)
					{
						uom = b.uoms[0];
					}

					if(uom!=null)
					{
						item.uomId = uom.uomId;
						item.uomName = uom.uomName;

						vm.src.stockRequestProductConfigs.push(item);
					}
				}
			});

			toastr.success("All Finished Goods are added to the list.");
		}

		vm.addFg = function()
		{
			if(vm.selectedFg==null)
			{
				toastr.warning("Select a Finished Good first.");
				return;
			}
			else
			{
				if(vm.selectedFgUom==null)
				{
					toastr.warning("Select a UOM first.");
					return;
				}
			}

			var isFound = false;
			vm.src.stockRequestProductConfigs.forEach(function(d) {
				if(d.productId==vm.selectedFg.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Finished Good is already exist on the list.");
				return;
			}

			vm.src.stockRequestProductConfigs.push({
				productId: vm.selectedFg.id,
				productCode: vm.selectedFg.code,
				productName: vm.selectedFg.name,
				uomId: vm.selectedFgUom.uomId,
				uomName: vm.selectedFgUom.uomName,
			});
			toastr.success("Finished Good [" + vm.selectedFg.name + "] is added to the list.");

			vm.selectedFg = null;
			vm.selectedFgUom = null;
		}

		vm.removeFg = function(index)
		{
			vm.src.stockRequestProductConfigs.splice(index, 1);
		}

		vm.removeAllFgs = function()
		{
			vm.src.stockRequestProductConfigs = [];
		}

		/* ********************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				HttpSvc.put('stockrequestconfigs/' + $stateParams.id, vm.src, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Stock Request Configuration has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		/* ********************************************************* */

		// Call Actions
		vm.loadBranches();
	}

	/** @ngInject */
    function StockRequestConfigsCloneCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.mode = 1;
		vm.src = {};
		vm.src.stockRequestStoreLevelConfigs = [];
		vm.src.stockRequestItemConfigs = [];
		vm.src.stockRequestSemiFinishedProductConfigs = [];
		vm.src.stockRequestProductConfigs = [];
		vm.branchList = [];
		vm.rawmatList = [];
		vm.sfgList = [];
		vm.fgList = [];
		vm.lockButtons = false;
		vm.addStorePanelVisible = false;
		vm.addRawMatPanelVisible = false;
		vm.addSemiFgPanelVisible = false;
		vm.addFgPanelVisible = false;

		/* ********************************************************* */

		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadRawMats();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.loadRawMats = function() {
			HttpSvc.get('items/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.rawmatList = result;
					vm.loadSemiFgs();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.loadSemiFgs = function() {
			HttpSvc.get('semifgs/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sfgList = result;
					vm.loadFgs();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.loadFgs = function() {
			HttpSvc.get('products/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.fgList = result;
					vm.loadData();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.loadData = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('stockrequestconfigs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.src = result;
					vm.src.name = vm.src.name + ' (COPY)';
				}, function() {
					toastr.error('Failed to load selected Stock Request Configuration.', Auth.translate('ERROR'))
					$state.go('maintenance.stockrequestconfigs.list');
					return;
				});
		};

		/* ********************************************************* */

		vm.showAddStorePanel = function() {
			vm.addStorePanelVisible = true;
		}

		vm.closeAddStorePanel = function() {
			vm.selectedStore = null;
			vm.addStorePanelVisible = false;
		}

		vm.addAllStores = function()
		{
			vm.branchList.forEach(function(b) {
				var isFound = false;
				vm.src.stockRequestStoreLevelConfigs.forEach(function(d) {
					if(d.branchId==b.id)
					{
						isFound=true;
					}
				});

				if(!isFound)
				{
					vm.src.stockRequestStoreLevelConfigs.push({
						branchId: b.id,
						branchCode: b.code,
						branchName: b.name,
					});
				}
			});

			toastr.success("All Stores are added to the list.");
		}

		vm.addStore = function()
		{
			if(vm.selectedStore==null)
			{
				toastr.warning("Select a store first.");
				return;
			}

			var isFound = false;
			vm.src.stockRequestStoreLevelConfigs.forEach(function(d) {
				if(d.branchId==vm.selectedStore.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Store is already exist on the list.");
				return;
			}

			vm.src.stockRequestStoreLevelConfigs.push({
				branchId: vm.selectedStore.id,
				branchCode: vm.selectedStore.code,
				branchName: vm.selectedStore.name,
			});
			toastr.success("Store [" + vm.selectedStore.name + "] is added to the list.");
		}

		vm.removeStore = function(index) {
			vm.src.stockRequestStoreLevelConfigs.splice(index, 1);
		}

		vm.removeAllStores = function() {
			vm.src.stockRequestStoreLevelConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddRawMatPanel = function() {
			vm.addRawMatPanelVisible = true;
		}

		vm.closeAddRawMatPanel = function() {
			vm.selectedRawMat = null;
			vm.addRawMatPanelVisible = false;
		}

		vm.addAllRawMats = function()
		{
			vm.rawmatList.forEach(function(b) {
				var isFound = false;
				vm.src.stockRequestItemConfigs.forEach(function(d) {
					if(d.itemId==b.id)
					{
						isFound=true;
					}
				});

				if(!isFound)
				{
					var item = {
						itemId: b.id,
						itemCode: b.code,
						itemName: b.description,
					};

					var uom = null;
					if(b.uoms.length > 0)
					{
						uom = b.uoms[0];
					};

					b.uoms.forEach(function(u) {
						if(u.isInventory)
						{
							uom = u;
						}
					});

					if(uom==null)
					{
						uom = b.uoms[0];
					}

					if(uom!=null)
					{
						item.uomId = uom.uomId;
						item.uomName = uom.uomName;

						vm.src.stockRequestItemConfigs.push(item);
					}
				}
			});

			toastr.success("All Raw Materials are added to the list.");
		}

		vm.addRawMat = function()
		{
			if(vm.selectedRawMat==null)
			{
				toastr.warning("Select a Raw Material first.");
				return;
			}
			else
			{
				if(vm.selectedRawMatUom==null)
				{
					toastr.warning("Select a UOM first.");
					return;
				}
			}

			var isFound = false;
			vm.src.stockRequestItemConfigs.forEach(function(d) {
				if(d.itemId==vm.selectedRawMat.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Raw Material is already exist on the list.");
				return;
			}

			vm.src.stockRequestItemConfigs.push({
				itemId: vm.selectedRawMat.id,
				itemCode: vm.selectedRawMat.code,
				itemName: vm.selectedRawMat.description,
				uomId: vm.selectedRawMatUom.uomId,
				uomName: vm.selectedRawMatUom.uomName,
			});
			toastr.success("Raw Material [" + vm.selectedRawMat.description + "] is added to the list.");

			vm.selectedRawMat = null;
			vm.selectedRawMatUom = null;
		}

		vm.removeRawMat = function(index)
		{
			vm.src.stockRequestItemConfigs.splice(index, 1);
		}

		vm.removeAllRawMats = function()
		{
			vm.src.stockRequestItemConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddSemiFgPanel = function() {
			vm.addSemiFgPanelVisible = true;
		}

		vm.closeAddSemiFgPanel = function() {
			vm.selectedSemiFg = null;
			vm.addSemiFgPanelVisible = false;
		}

		vm.addAllSemiFgs = function()
		{
			vm.sfgList.forEach(function(b) {
				var isFound = false;
				vm.src.stockRequestSemiFinishedProductConfigs.forEach(function(d) {
					if(d.semiFinishedProductId==b.id)
					{
						isFound=true;
					}
				});

				if(!isFound)
				{
					var item = {
						semiFinishedProductId: b.id,
						semiFinishedProductCode: b.code,
						semiFinishedProductName: b.description,
					};

					var uom = null;
					if(b.uoms.length > 0)
					{
						uom = b.uoms[0];
					};

					b.uoms.forEach(function(u) {
						if(u.isInventory)
						{
							uom = u;
						}
					});

					if(uom==null)
					{
						uom = b.uoms[0];
					}

					if(uom!=null)
					{
						item.uomId = uom.uomId;
						item.uomName = uom.uomName;

						vm.src.stockRequestSemiFinishedProductConfigs.push(item);
					}
				}
			});

			toastr.success("All Semi Finished Goods are added to the list.");
		}

		vm.addSemiFg = function()
		{
			if(vm.selectedSemiFg==null)
			{
				toastr.warning("Select a Semi Finished Good first.");
				return;
			}
			else
			{
				if(vm.selectedSemiFgUom==null)
				{
					toastr.warning("Select a UOM first.");
					return;
				}
			}

			var isFound = false;
			vm.src.stockRequestSemiFinishedProductConfigs.forEach(function(d) {
				if(d.semiFinishedProductId==vm.selectedSemiFg.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Semi Finished Good is already exist on the list.");
				return;
			}

			vm.src.stockRequestSemiFinishedProductConfigs.push({
				semiFinishedProductId: vm.selectedSemiFg.id,
				semiFinishedProductCode: vm.selectedSemiFg.code,
				semiFinishedProductName: vm.selectedSemiFg.description,
				uomId: vm.selectedSemiFgUom.uomId,
				uomName: vm.selectedSemiFgUom.uomName,
			});
			toastr.success("Semi Finished Good [" + vm.selectedSemiFg.description + "] is added to the list.");

			vm.selectedSemiFg = null;
			vm.selectedSemiFgUom = null;
		}

		vm.removeSemiFg = function(index)
		{
			vm.src.stockRequestSemiFinishedProductConfigs.splice(index, 1);
		}

		vm.removeAllSemiFgs = function()
		{
			vm.src.stockRequestSemiFinishedProductConfigs = [];
		}

		/* ********************************************************* */

		vm.showAddFgPanel = function() {
			vm.addFgPanelVisible = true;
		}

		vm.closeAddFgPanel = function() {
			vm.selectedFg = null;
			vm.addFgPanelVisible = false;
		}

		vm.addAllFgs = function()
		{
			vm.fgList.forEach(function(b) {
				var isFound = false;
				vm.src.stockRequestProductConfigs.forEach(function(d) {
					if(d.productId==b.id)
					{
						isFound=true;
					}
				});

				if(!isFound)
				{
					var item = {
						productId: b.id,
						productCode: b.code,
						productName: b.name,
					};

					var uom = null;
					if(b.uoms.length > 0)
					{
						uom = b.uoms[0];
					};

					b.uoms.forEach(function(u) {
						if(u.isInventory)
						{
							uom = u;
						}
					});

					if(uom==null)
					{
						uom = b.uoms[0];
					}

					if(uom!=null)
					{
						item.uomId = uom.uomId;
						item.uomName = uom.uomName;

						vm.src.stockRequestProductConfigs.push(item);
					}
				}
			});

			toastr.success("All Finished Goods are added to the list.");
		}

		vm.addFg = function()
		{
			if(vm.selectedFg==null)
			{
				toastr.warning("Select a Finished Good first.");
				return;
			}
			else
			{
				if(vm.selectedFgUom==null)
				{
					toastr.warning("Select a UOM first.");
					return;
				}
			}

			var isFound = false;
			vm.src.stockRequestProductConfigs.forEach(function(d) {
				if(d.productId==vm.selectedFg.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Finished Good is already exist on the list.");
				return;
			}

			vm.src.stockRequestProductConfigs.push({
				productId: vm.selectedFg.id,
				productCode: vm.selectedFg.code,
				productName: vm.selectedFg.name,
				uomId: vm.selectedFgUom.uomId,
				uomName: vm.selectedFgUom.uomName,
			});
			toastr.success("Finished Good [" + vm.selectedFg.name + "] is added to the list.");

			vm.selectedFg = null;
			vm.selectedFgUom = null;
		}

		vm.removeFg = function(index)
		{
			vm.src.stockRequestProductConfigs.splice(index, 1);
		}

		vm.removeAllFgs = function()
		{
			vm.src.stockRequestProductConfigs = [];
		}

		/* ********************************************************* */

		// Form Submission
		vm.submit = function() {

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

                vm.remove(vm.src);

				HttpSvc.post('stockrequestconfigs', vm.src, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Stock Request Configuration has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.stockrequestconfigs.update', {'id': result.id });
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

        // Remove unwanted fields
        vm.remove = function(data) {
            delete data.id;

            if (data.stockRequestItemConfigs) {
                data.stockRequestItemConfigs.forEach(function(item) {
                    delete item.id;
                    delete item.configId;
                })
            }
        }

		/* ********************************************************* */

		// Call Actions
		vm.loadBranches();
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.warehouses.controller', [])
        .controller('WarehousesMainCtrl', WarehousesMainCtrl)
        .controller('WarehousesCreateCtrl', WarehousesCreateCtrl)
        .controller('WarehousesUpdateCtrl', WarehousesUpdateCtrl);

    /** @ngInject */
    function WarehousesMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.warehouseDataFull = [];
		vm.warehouseData = [];
		vm.hasAfterSaleModule = Auth.hasCompanyFeature('services');

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.warehouseDataFull, tableState.search.predicateObject) : vm.warehouseDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.warehouseData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.warehouseDataFull.length <= 0) {							
				HttpSvc.get('storages/list', {}, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.warehouseDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteWarehouse = function(warehousesId, warehousesName) {
			var params = {};
			HttpSvc.delete('storages/' + warehousesId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('storages/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.warehouseDataFull = result;
							
							toastr.success('The Warehouses [<b>' + warehousesName + '</b>] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Warehouses [' + warehousesName + '].', 'Delete Failed');
					return null;
			});
		};	
		
		vm.getTypeVar = function(typeName) {

			typeName = typeName.replaceAll(' ', '_');
			typeName = typeName.toUpperCase();
			return typeName;
		}
	};
	
	/** @ngInject */
    function WarehousesCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 1;
		vm.warehouse = {};
		vm.warehouse.branchId = "";
		vm.warehouse.type = 1;
		vm.branches = [];
		vm.lockButtons = false;
		vm.selectedBranch = null;
		vm.hasAfterSaleModule = Auth.hasCompanyFeature('services');

		/* ********************************************************* */

		// Load Branches
		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}
		
		// Selected Branch Changed
		vm.selectedBranchChanged = function() {
			vm.warehouse.branchId = vm.selectedBranch.id;
		}

		/* ********************************************************* */
		
		// Form Submission
		vm.submit = function() {
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				HttpSvc.post('storages', vm.warehouse, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkResult = function(result) {
			if(result.httpStatusCode=="200")
			{
				toastr.success('Warehouse has been created successfully.', Auth.translate('SUCCESS'));
				$state.go('maintenance.warehouses.update', {'id': result.id });
			}
			else
			{
				vm.lockButtons = false;
				toastr.error(result.message, 'Failed');
			}
		}

		/* ********************************************************* */
		
		// Call Actions
		vm.loadBranches();
	}
	
	/** @ngInject */
    function WarehousesUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;
		vm.mode = 2;
		vm.warehouse = {};
		vm.warehouse.branchId = "";
		vm.branches = [];
		vm.lockButtons = false;
		vm.selectedBranch = null;
		vm.hasAfterSaleModule = Auth.hasCompanyFeature('services');

		/* ********************************************************* */
				
		// Load Branches
		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
					vm.loadWarehouse();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}
		
		// Selected Branch Changed
		vm.selectedBranchChanged = function() {
			vm.warehouse.branchId = vm.selectedBranch.id;
		}
				
		// Load Warehouse
		vm.loadWarehouse = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('storages/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.warehouse = result;	
					
					vm.branches.forEach(function(p) {
						if(p.id==vm.warehouse.branchId){
							vm.selectedBranch = p;
						}
					});
				}, function() {
					toastr.error('Failed to load selected Warehouse.', Auth.translate('ERROR'))
					$state.go('maintenance.warehouses.list');
					return;
				});		
		};	

		/* ********************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {		
				vm.lockButtons = true;

				HttpSvc.put('storages/' + $stateParams.id, vm.warehouse, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkResult = function(result) {
			if(result.httpStatusCode=="200")
			{
				toastr.success('Warehouse has been updated successfully.', Auth.translate('SUCCESS'));
				$state.reload();
			}
			else
			{
				vm.lockButtons = false;
				toastr.error(result.message, 'Failed');
			}
		}

		/* ********************************************************* */
		
		// Call Actions
		vm.loadBranches();
	}
})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.maintenance.yieldmanagement.controller', [])
			.controller('YieldManagementMainCtrl', YieldManagementMainCtrl)
			.controller('YieldManagementCreateCtrl', YieldManagementCreateCtrl)
			.controller('YieldManagementUpdateCtrl', YieldManagementUpdateCtrl)
			.controller('YieldManagementItemModalCtrl', YieldManagementItemModalCtrl);

	/** @ngInject */
	function YieldManagementMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) 
	{	
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.mgmtDataFull = [];
		vm.mgmtData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.mgmtDataFull, tableState.search.predicateObject) : vm.mgmtDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.mgmtData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.mgmtDataFull.length <= 0) {				
				HttpSvc.get('yieldmanagements/list', {}, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.mgmtDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteRecord = function(recordId, recordName) {
			var params = {};
			HttpSvc.delete('yieldmanagements/' + recordId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('yieldmanagements/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.mgmtDataFull = result;
							
							toastr.success('The record for [' + recordName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete [' + recordName + '].', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function YieldManagementCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.mgmt = {};
		vm.mgmt.yieldManagementDetails = [];
		vm.itemList = [];
		vm.semiFgList = [];
		vm.productList = [];
		vm.uomList = [];
		vm.selectedItem = null;
		vm.selectedSemiFg = null;
		vm.selectedProduct = null;
		vm.selectedUom = null;
		vm.isLoading = false;
		
		/* ************************************************************* */
				
		// Load Item List
		vm.loadItemList = function(searchString) {
			vm.isLoading = true;
			
			HttpSvc.get('items/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.itemList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Raw Material list. ' + error, '');
					return null;
				});
		};		
				
		// Load Semi F.G. List
		vm.loadSemiFgList = function(searchString) {
			vm.isLoading = true;
			
			HttpSvc.get('semifgs/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.semiFgList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Semi F.G. list. ' + error, '');
					return null;
				});
		};	
				
		// Load Product List
		vm.loadProductList = function(searchString) {			
			vm.isLoading = true;
			
			HttpSvc.get('products/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.productList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Finished Goods list ' + error, '');
					return null;
				});
		};

		/* ********************************************************* */
				
		// Load Item UOMs
		vm.loadItemUoms = function(itemId) {
			vm.isLoading = true;
			
			HttpSvc.get('items/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.isLoading = false;
					
					if(vm.mode==2)
					{
						vm.uomList.forEach(function(u) {
							if(u.id==vm.mgmt.uomId)
							{
								vm.selectedUom = u;
							}
						});
					}
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Product UOMs
		vm.loadSemiFgUoms = function(semiFgId) {
			vm.isLoading = true;

			HttpSvc.get('semifgs/uoms/' + semiFgId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.isLoading = false;
					
					if(vm.mode==2)
					{
						vm.uomList.forEach(function(u) {
							if(u.id==vm.mgmt.uomId)
							{
								vm.selectedUom = u;
							}
						});
					}
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Semi F.G. UOMs
		vm.loadProductUoms = function(productId) {
			vm.isLoading = true;

			HttpSvc.get('products/uoms/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.isLoading = false;
					
					if(vm.mode==2)
					{
						vm.uomList.forEach(function(u) {
							if(u.id==vm.mgmt.uomId)
							{
								vm.selectedUom = u;
							}
						});
					}
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	

		/* ************************************************************* */

		vm.selectedItemChanged = function() {
			vm.mgmt.semiFgId = null;
			vm.mgmt.productId = null;
			vm.mgmt.itemId = vm.selectedItem.id;
			vm.mgmt.itemName = vm.selectedItem.description;

			vm.loadItemUoms(vm.mgmt.itemId);
		}

		vm.selectedSemiFgChanged = function() {
			vm.mgmt.itemId = null;
			vm.mgmt.productId = null;
			vm.mgmt.semiFgId = vm.selectedSemiFg.id;
			vm.mgmt.itemName = vm.selectedSemiFg.description;

			vm.loadSemiFgUoms(vm.mgmt.semiFgId);
		}

		vm.selectedProductChanged = function() {
			vm.mgmt.itemId = null;
			vm.mgmt.semiFgId = null;
			vm.mgmt.productId = vm.selectedProduct.id;
			vm.mgmt.itemName = vm.selectedProduct.name;

			vm.loadProductUoms(vm.mgmt.productId);
		}
		
		vm.selectedUomChanged = function() {
			vm.mgmt.uomId = vm.selectedUom.id;
			vm.mgmt.uomName = vm.selectedUom.name;
		};

		vm.clearSelection = function() {
			vm.selectedItem = null;
			vm.selectedSemiFg = null;
			vm.selectedProduct = null;
			vm.selectedUom = null;

			vm.mgmt.itemId = null
			vm.mgmt.semiFgId = null;
			vm.mgmt.productId = null;
			vm.mgmt.uomId = null;
			vm.mgmt.uomName = null;

			vm.uomList = [];
		}

		/* ************************************************************* */
			
		// Open Modal Dialog		
		vm.showAddItemModal = function () {	
			var objectId = null;
			if(vm.mgmt.itemId != null)
			{
				objectId = vm.mgmt.itemId;
			}
			if(vm.mgmt.semiFgId != null)
			{
				objectId = vm.mgmt.semiFgId;
			}
			if(vm.mgmt.productId != null)
			{
				objectId = vm.mgmt.productId;
			}

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'YieldManagementItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: {},
							originalItemId: objectId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};	

		vm.showEditItemModal = function (index) {
			var objectId = null;
			if(vm.mgmt.itemId != null)
			{
				objectId = vm.mgmt.itemId;
			}
			if(vm.mgmt.semiFgId != null)
			{
				objectId = vm.mgmt.semiFgId;
			}
			if(vm.mgmt.productId != null)
			{
				objectId = vm.mgmt.productId;
			}

			vm.item = angular.copy(vm.mgmt.yieldManagementDetails[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'YieldManagementItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
							originalItemId: objectId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************* */		
		
		// Remove Setting
		vm.removeItem = function(index) {
			vm.mgmt.yieldManagementDetails.splice(index, 1);

			vm.calculateTotalPercentage();
		};
			
		// Update Setting
		vm.updateItem = function(index, obj) {

			var isFound = false;			
			vm.mgmt.yieldManagementDetails.forEach(function(i) {
				if(checkItemExist(i, obj))
				{
					i.id = obj.id;
					i.yieldId = obj.yieldId;
					i.itemId = obj.itemId;
					i.semiFgId = obj.semiFgId;
					i.productId = obj.productId;
					i.itemCode = obj.itemCode;
					i.itemName = obj.itemName;
					i.itemType = obj.itemType;
					i.yieldPercent = obj.yieldPercent;
					i.quantity = obj.quantity;
					i.uomId = obj.uomId;
					i.uomName = obj.uomName;
					isFound = true;
					vm.calculateTotalPercentage();
				}
			});
			if(isFound) return;

			var element = {
				id: obj.id,
				yieldId: obj.yieldId,
				itemId: obj.itemId,
				semiFgId: obj.semiFgId,
				productId: obj.productId,
				itemCode: obj.itemCode,
				itemName: obj.itemName,
				itemType: obj.itemType,
				yieldPercent: obj.yieldPercent,
				quantity: obj.quantity,
				uomId: obj.uomId,
				uomName: obj.uomName,
			};
			vm.mgmt.yieldManagementDetails.splice(index, 1, element);
			vm.calculateTotalPercentage();
		};

		// Add Setting
		vm.addItem = function(obj) {
			
			var isFound = false;			
			vm.mgmt.yieldManagementDetails.forEach(function(i) {
				if(checkItemExist(i, obj))
				{
					i.id = obj.id;
					i.yieldId = obj.yieldId;
					i.itemId = obj.itemId;
					i.semiFgId = obj.semiFgId;
					i.productId = obj.productId;
					i.itemCode = obj.itemCode;
					i.itemName = obj.itemName;
					i.itemType = obj.itemType;
					i.yieldPercent = obj.yieldPercent;
					i.quantity = obj.quantity;
					i.uomId = obj.uomId;
					i.uomName = obj.uomName;
					isFound = true;
					vm.calculateTotalPercentage();
				}
			});
			if(isFound) return;

			var element = {
				id: obj.id,
				yieldId: obj.yieldId,
				itemId: obj.itemId,
				semiFgId: obj.semiFgId,
				productId: obj.productId,
				itemCode: obj.itemCode,
				itemName: obj.itemName,
				itemType: obj.itemType,
				yieldPercent: obj.yieldPercent,
				quantity: obj.quantity,
				uomId: obj.uomId,
				uomName: obj.uomName,
			};
			vm.mgmt.yieldManagementDetails.push(element);

			vm.calculateTotalPercentage();
		};

		vm.calculateTotalPercentage = function() {
			vm.totalPercentage = 0.0;

			vm.mgmt.yieldManagementDetails.forEach(function(i) {
				vm.totalPercentage += i.yieldPercent;
			});
		}
		
		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.isLoading = true;

				HttpSvc.post('yieldmanagements', vm.mgmt, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Yield Record has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('maintenance.yieldmanagement.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Call Action
		vm.loadItemList();
	}

	/** @ngInject */
	function YieldManagementUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();

		var vm = this;
		vm.mode = 2;
		vm.mgmt = {};
		vm.itemList = [];
		vm.semiFgList = [];
		vm.productList = [];
		vm.changeLogs = [];
		vm.selectedItem = null;
		vm.selectedSemiFg = null;
		vm.selectedProduct = null;
		vm.isLoading = false;
		
		/* ************************************************************* */
				
		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('yieldmanagementchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};	
						
		// Load Menu
		vm.loadData = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('yieldmanagements/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.mgmt = result;

					if(vm.mgmt.itemId!='' && vm.mgmt.itemId!=null){
						vm.selectedItem = {
							id: vm.mgmt.itemId,
							code: vm.mgmt.itemCode,
							description: vm.mgmt.itemName,
						};
						vm.loadItemUoms(vm.mgmt.itemId);
						vm.activeTab = 0;
					};
					
					if(vm.mgmt.semiFgId!='' && vm.mgmt.semiFgId!=null){
						vm.selectedSemiFg = {
							id: vm.mgmt.semiFgId,
							code: vm.mgmt.itemCode,
							description: vm.mgmt.itemName,
						};
						vm.loadSemiFgUoms(vm.mgmt.semiFgId);
						vm.activeTab = 1;
					};
		
					if(vm.mgmt.productId!='' && vm.mgmt.productId!=null){
						vm.selectedProduct = {
							id: vm.mgmt.productId,
							code: vm.mgmt.itemCode,
							name: vm.mgmt.itemName,
						};
						vm.loadProductUoms(vm.mgmt.productId);
						vm.activeTab = 2;
					};

					vm.calculateTotalPercentage();
					vm.loadChangeLogs();
				}, function() {
					toastr.error('Failed to load selected Yield record.', Auth.translate('ERROR'))
					$state.go('maintenance.yieldmanagement.list');
					return;
				});		
		};	
		
		/* ************************************************************* */
				
		// Load Item List
		vm.loadItemList = function(searchString) {
			vm.isLoading = true;
			
			HttpSvc.get('items/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.itemList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Raw Material list. ' + error, '');
					return null;
				});
		};		
				
		// Load Semi F.G. List
		vm.loadSemiFgList = function(searchString) {
			vm.isLoading = true;
			
			HttpSvc.get('semifgs/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.semiFgList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Semi F.G. list. ' + error, '');
					return null;
				});
		};	
				
		// Load Product List
		vm.loadProductList = function(searchString) {			
			vm.isLoading = true;
			
			HttpSvc.get('products/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.productList = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Finished Goods list ' + error, '');
					return null;
				});
		};

		/* ********************************************************* */
				
		// Load Item UOMs
		vm.loadItemUoms = function(itemId) {
			vm.isLoading = true;
			
			HttpSvc.get('items/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.isLoading = false;
					
					if(vm.mode==2)
					{
						vm.uomList.forEach(function(u) {
							if(u.id==vm.mgmt.uomId)
							{
								vm.selectedUom = u;
							}
						});
					}
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Product UOMs
		vm.loadSemiFgUoms = function(semiFgId) {
			vm.isLoading = true;

			HttpSvc.get('semifgs/uoms/' + semiFgId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.isLoading = false;
					
					if(vm.mode==2)
					{
						vm.uomList.forEach(function(u) {
							if(u.id==vm.mgmt.uomId)
							{
								vm.selectedUom = u;
							}
						});
					}
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Semi F.G. UOMs
		vm.loadProductUoms = function(productId) {
			vm.isLoading = true;

			HttpSvc.get('products/uoms/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.isLoading = false;
					
					if(vm.mode==2)
					{
						vm.uomList.forEach(function(u) {
							if(u.id==vm.mgmt.uomId)
							{
								vm.selectedUom = u;
							}
						});
					}
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	

		/* ************************************************************* */

		vm.selectedItemChanged = function() {
			vm.mgmt.semiFgId = null;
			vm.mgmt.productId = null;
			vm.mgmt.itemId = vm.selectedItem.id;
			vm.mgmt.itemName = vm.selectedItem.description;

			vm.loadItemUoms(vm.mgmt.itemId);
		}

		vm.selectedSemiFgChanged = function() {
			vm.mgmt.itemId = null;
			vm.mgmt.productId = null;
			vm.mgmt.semiFgId = vm.selectedSemiFg.id;
			vm.mgmt.itemName = vm.selectedSemiFg.description;
			
			vm.loadSemiFgUoms(vm.mgmt.semiFgId);
		}

		vm.selectedProductChanged = function() {
			vm.mgmt.itemId = null;
			vm.mgmt.semiFgId = null;
			vm.mgmt.productId = vm.selectedProduct.id;
			vm.mgmt.itemName = vm.selectedProduct.name;

			vm.loadProductUoms(vm.mgmt.productId);
		}
		
		vm.selectedUomChanged = function() {
			vm.mgmt.uomId = vm.selectedUom.id;
			vm.mgmt.uomName = vm.selectedUom.name;
		};

		vm.clearSelection = function() {
			vm.selectedItem = null;
			vm.selectedSemiFg = null;
			vm.selectedProduct = null;
			vm.selectedUom = null;

			vm.mgmt.itemId = null
			vm.mgmt.semiFgId = null;
			vm.mgmt.productId = null;
			vm.mgmt.uomId = null;
			vm.mgmt.uomName = null;

			vm.uomList = [];
		}
		
		/* ************************************************************* */
			
		// Open Modal Dialog		
		vm.showAddItemModal = function () {
			var objectId = null;
			if(vm.mgmt.itemId != null)
			{
				objectId = vm.mgmt.itemId;
			}
			if(vm.mgmt.semiFgId != null)
			{
				objectId = vm.mgmt.semiFgId;
			}
			if(vm.mgmt.productId != null)
			{
				objectId = vm.mgmt.productId;
			}

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'YieldManagementItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: {},
							originalItemId: objectId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};	

		vm.showEditItemModal = function (index) {
			var objectId = null;
			if(vm.mgmt.itemId != null)
			{
				objectId = vm.mgmt.itemId;
			}
			if(vm.mgmt.semiFgId != null)
			{
				objectId = vm.mgmt.semiFgId;
			}
			if(vm.mgmt.productId != null)
			{
				objectId = vm.mgmt.productId;
			}

			vm.item = angular.copy(vm.mgmt.yieldManagementDetails[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'YieldManagementItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
							originalItemId: objectId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************* */		
		
		// Remove Setting
		vm.removeItem = function(index) {
			vm.mgmt.yieldManagementDetails.splice(index, 1);

			vm.calculateTotalPercentage();
		};
			
		// Update Setting
		vm.updateItem = function(index, obj) {
			
			var isFound = false;			
			vm.mgmt.yieldManagementDetails.forEach(function(i) {
				if(checkItemExist(i, obj))
				{
					i.id = obj.id;
					i.yieldId = obj.yieldId;
					i.itemId = obj.itemId;
					i.semiFgId = obj.semiFgId;
					i.productId = obj.productId;
					i.itemCode = obj.itemCode;
					i.itemName = obj.itemName;
					i.itemType = obj.itemType;
					i.yieldPercent = obj.yieldPercent;
					i.quantity = obj.quantity;
					i.uomId = obj.uomId;
					i.uomName = obj.uomName;
					isFound = true;
					vm.calculateTotalPercentage();
				}
			});
			if(isFound) return;

			var element = {
				id: obj.id,
				yieldId: obj.yieldId,
				itemId: obj.itemId,
				semiFgId: obj.semiFgId,
				productId: obj.productId,
				itemCode: obj.itemCode,
				itemName: obj.itemName,
				itemType: obj.itemType,
				yieldPercent: obj.yieldPercent,
				quantity: obj.quantity,
				uomId: obj.uomId,
				uomName: obj.uomName,
			};
			vm.mgmt.yieldManagementDetails.splice(index, 1, element);

			vm.calculateTotalPercentage();
		};

		// Add Setting
		vm.addItem = function(obj) {
			
			var isFound = false;			
			vm.mgmt.yieldManagementDetails.forEach(function(i) {
				if(checkItemExist(i, obj))
				{
					i.id = obj.id;
					i.yieldId = obj.yieldId;
					i.itemId = obj.itemId;
					i.semiFgId = obj.semiFgId;
					i.productId = obj.productId;
					i.itemCode = obj.itemCode;
					i.itemName = obj.itemName;
					i.itemType = obj.itemType;
					i.yieldPercent = obj.yieldPercent;
					i.quantity = obj.quantity;
					i.uomId = obj.uomId;
					i.uomName = obj.uomName;
					isFound = true;
					vm.calculateTotalPercentage();
				}
			});
			if(isFound) return;

			var element = {
				id: obj.id,
				yieldId: obj.yieldId,
				itemId: obj.itemId,
				semiFgId: obj.semiFgId,
				productId: obj.productId,
				itemCode: obj.itemCode,
				itemName: obj.itemName,
				itemType: obj.itemType,
				yieldPercent: obj.yieldPercent,
				quantity: obj.quantity,
				uomId: obj.uomId,
				uomName: obj.uomName,
			};
			vm.mgmt.yieldManagementDetails.push(element);

			vm.calculateTotalPercentage();
		};

		vm.calculateTotalPercentage = function() {
			vm.totalPercentage = 0.0;

			vm.mgmt.yieldManagementDetails.forEach(function(i) {
				vm.totalPercentage += i.yieldPercent;
			});
		}
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('yieldmanagements/' + $stateParams.id, vm.mgmt, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Yield Record has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadData();
	}
		
	function YieldManagementItemModalCtrl($uibModalInstance, item, toastr, Auth, HttpSvc) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.item = item.object;
		$mdl.originalItemId = item.originalItemId;
		$mdl.itemList = [];
		$mdl.semiFgList = [];
		$mdl.productList = [];
		$mdl.selectedItem = null;
		$mdl.selectedSemiFg = null;
		$mdl.selectedProduct = null;
		$mdl.selectedItem = null;
		$mdl.lockButtons = false;
		
		/* ********************************************************* */
				
		// Load Item List
		$mdl.loadItemList = function(searchString) {
			$mdl.lockButtons = true;
			
			HttpSvc.get('items/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.itemList = result;
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Raw Material list.', '');
					return null;
				});
		};		
				
		// Load Semi F.G. List
		$mdl.loadSemiFgList = function(searchString) {
			$mdl.lockButtons = true;
			
			HttpSvc.get('semifgs/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.semiFgList = result;
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Semi F.G. list.', '');
					return null;
				});
		};	
				
		// Load Product List
		$mdl.loadProductList = function(searchString) {			
			$mdl.lockButtons = true;
			
			HttpSvc.get('products/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.productList = result;
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Finished Goods list.', '');
					return null;
				});
		};

		/* ********************************************************* */
				
		// Load Item UOMs
		$mdl.loadItemUoms = function(itemId) {
			$mdl.lockButtons = true;
			
			HttpSvc.get('items/uoms/' + itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.uomList = result;
					$mdl.lockButtons = false;
					
					if(item.mode==2)
					{
						$mdl.uomList.forEach(function(u) {
							if(u.id==$mdl.item.uomId)
							{
								$mdl.selectedUom = u;
							}
						});
					}
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Product UOMs
		$mdl.loadSemiFgUoms = function(semiFgId) {
			$mdl.lockButtons = true;

			HttpSvc.get('semifgs/uoms/' + semiFgId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.uomList = result;
					$mdl.lockButtons = false;
					
					if(item.mode==2)
					{
						$mdl.uomList.forEach(function(u) {
							if(u.id==$mdl.item.uomId)
							{
								$mdl.selectedUom = u;
							}
						});
					}
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Semi F.G. UOMs
		$mdl.loadProductUoms = function(productId) {
			$mdl.lockButtons = true;

			HttpSvc.get('products/uoms/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.uomList = result;
					$mdl.lockButtons = false;
					
					if(item.mode==2)
					{
						$mdl.uomList.forEach(function(u) {
							if(u.id==$mdl.item.uomId)
							{
								$mdl.selectedUom = u;
							}
						});
					}
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	

		/* ********************************************************* */
		
		$mdl.selectedItemChanged = function() {
			$mdl.item.productId = null;
			$mdl.item.semiFgId = null;
			$mdl.item.itemId = $mdl.selectedItem.id;
			$mdl.item.itemCode = $mdl.selectedItem.code;
			$mdl.item.itemName = $mdl.selectedItem.description;
			$mdl.item.itemType = "RAW MAT";
			
			$mdl.selectedSemiFg = null;
			$mdl.selectedProduct = null;

			$mdl.loadItemUoms($mdl.item.itemId);
		};
		
		$mdl.selectedSemiFgChanged = function() {
			$mdl.item.itemId = null;
			$mdl.item.productId = null;
			$mdl.item.semiFgId = $mdl.selectedSemiFg.id;
			$mdl.item.itemCode = $mdl.selectedSemiFg.code;
			$mdl.item.itemName = $mdl.selectedSemiFg.description;
			$mdl.item.itemType = "SEMI FG";
			
			$mdl.selectedItem = null;
			$mdl.selectedProduct = null;

			$mdl.loadSemiFgUoms($mdl.item.semiFgId);
		};
		
		$mdl.selectedProductChanged = function() {
			$mdl.item.itemId = null;
			$mdl.item.semiFgId = null;
			$mdl.item.productId = $mdl.selectedProduct.id;
			$mdl.item.itemCode = $mdl.selectedProduct.code;
			$mdl.item.itemName = $mdl.selectedProduct.name;
			$mdl.item.itemType = "F.GOODS";
			
			$mdl.selectedItem = null;
			$mdl.selectedSemiFg = null;

			$mdl.loadProductUoms($mdl.item.productId);
		};
		
		$mdl.selectedUomChanged = function() {
			$mdl.item.uomId = $mdl.selectedUom.id;
			$mdl.item.uomName = $mdl.selectedUom.name;
		};

		$mdl.clearSelection = function() {
			$mdl.selectedItem = null;
			$mdl.selectedSemiFg = null;
			$mdl.selectedProduct = null;
			$mdl.selectedUom = null;

			$mdl.item.itemId = null
			$mdl.item.semiFgId = null;
			$mdl.item.productId = null;
			$mdl.item.uomId = null;
			$mdl.item.uomName = null;

			$mdl.uomList = [];
		}

		/* ********************************************************* */

		$mdl.confirmModal = function() {
			if($mdl.itemForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				if($mdl.originalItemId != null &&
					($mdl.originalItemId == $mdl.item.itemId || 
					 $mdl.originalItemId == $mdl.item.semiFgId ||
					 $mdl.originalItemId == $mdl.item.productId)) 
				{
					toastr.warning("Selected Item cannot be the same as the Original Item.");
					return;
				}

				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		/* ********************************************************* */

		// Initialize
		if(item.mode==1) {
			$mdl.item.itemId = "";
			$mdl.item.itemCode = "";			
			$mdl.item.itemName = "";			
			$mdl.item.yieldPercent = 0;
		} else {
			if($mdl.item.itemId!='' && $mdl.item.itemId!=null){
				$mdl.selectedItem = {
					id: $mdl.item.itemId,
					code: $mdl.item.itemCode,
					description: $mdl.item.itemName,
				};
				$mdl.loadItemUoms($mdl.item.itemId);
				$mdl.activeTab = 0;
			};
			
			if($mdl.item.semiFgId!='' && $mdl.item.semiFgId!=null){
				$mdl.selectedSemiFg = {
					id: $mdl.item.semiFgId,
					code: $mdl.item.itemCode,
					description: $mdl.item.itemName,
				};
				$mdl.loadSemiFgUoms($mdl.item.semiFgId);
				$mdl.activeTab = 1;
			};

			if($mdl.item.productId!='' && $mdl.item.productId!=null){
				$mdl.selectedProduct = {
					id: $mdl.item.productId,
					code: $mdl.item.itemCode,
					name: $mdl.item.itemName,
				};
				$mdl.loadProductUoms($mdl.item.productId);
				$mdl.activeTab = 2;
			};
		}
	};	

	function checkItemExist(i, obj) {

		if((i.itemId==obj.itemId && i.itemId!="" && i.itemId!=null) ||
			(i.productId==obj.productId && i.productId!="" && i.productId!=null) ||
			(i.semiFinishedProductId==obj.semiFinishedProductId && i.semiFinishedProductId!="" && i.semiFinishedProductId!=null))
		{
			return true;
		}
		return false;
	}	

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.maintenance.suppliers.controller', [])
        .controller('SuppliersMainCtrl', SuppliersMainCtrl)
        .controller('SuppliersCreateCtrl', SuppliersCreateCtrl)
        .controller('SuppliersUpdateCtrl', SuppliersUpdateCtrl)
        .controller('SuppliersImportCtrl', SuppliersImportCtrl);

    /** @ngInject */
    function SuppliersMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.supplierDataFull = [];
		vm.supplierData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.supplierDataFull, tableState.search.predicateObject) : vm.supplierDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.supplierData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.supplierDataFull.length <= 0) {	
				vm.isLoading = true;
				
				HttpSvc.get('suppliers/list', {}, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.isLoading = false;
						vm.numOfRecord = result.length;	
						vm.supplierDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {	
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteSupplier = function(suppliersId, suppliersName) {
			var params = {};
			HttpSvc.delete('suppliers/' + suppliersId, params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = true;
					
					HttpSvc.get('suppliers/list', params, Auth.getTokenId(), true)
						.then(function(result) {		
							vm.isLoading = false;
							vm.numOfRecord = result.length;
							vm.supplierDataFull = result;
							
							toastr.success('The Suppliers [<b>' + suppliersName + '</b>] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {	
						vm.isLoading = false;
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Suppliers [' + suppliersName + '].', 'Delete Failed');
					return null;
			});
		};			
	};
	
	/** @ngInject */
    function SuppliersCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 1;
		vm.supplier = {};
		vm.supplier.active = true;
		vm.integrationMode = Auth.getIntegrationMode();
		vm.hasAutoCountFields = vm.integrationMode == 2 && Auth.autoCount_EnableSync_Creditor();
		vm.hasIDBFields = vm.integrationMode == 7 && Auth.idB_EnableSync_Creditor();
		vm.hasSQLFields = vm.integrationMode == 8 && Auth.sqL_EnableSync_Creditor();
		vm.currencyList = [];
		vm.autoCount_CreditorTypes = [];
		vm.autoCount_ControlAccounts = [];
		vm.autoCount_CurrencyCodes = [];
		vm.autoCount_DisplayTerms = [];
		vm.autoCount_AreaCodes = [];
		vm.lockButtons = false;
		vm.sqlFields = {};
		
		/* ***************************************************************** */
		
		vm.initData = function() {	
			
			vm.loadCurrencyList();
			
			if(vm.integrationMode==1) {
				vm.supplier.syspro_BankCode = '3802PB-RES';
				vm.supplier.syspro_BranchCode = '4902OC-RES';
				vm.supplier.syspro_TermCode = '30';
				
			} else if(vm.hasAutoCountFields) {
				vm.loadAutoCountCreditTypes();
			}
			else if(vm.hasIDBFields) {
				vm.loadIDBCreditTypes();
			}
			else if(vm.hasSQLFields) {
				vm.loadSQLFields();
			}
		}
		
		/* ***************************************************************** */

		vm.loadCurrencyList = function() {
			HttpSvc.get('currencies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.currencyList = result;
				}, function() {
					toastr.error('Failed to load Currency List.', Auth.translate('ERROR'))
					return;
				});
		};

		/* ***************************************************************** */

		vm.loadIDBCreditTypes = function() {
			
			HttpSvc.get('idbs/maintenance/list/creditortypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.idbCreditorTypes = result;					
					vm.loadIDBCreditTerms();
				}, function() {
					toastr.error('Failed to load selected IDB Creditor Types.', Auth.translate('ERROR'))
					return;
				});
		};

		vm.loadIDBCreditTerms = function() {
			
			HttpSvc.get('idbs/maintenance/list/creditterms', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.idbCreditTerms = result;					
				}, function() {
					toastr.error('Failed to load selected IDB Creditr Terms.', Auth.translate('ERROR'))
					return;
				});
		};
		vm.loadSQLFields = function() {
			HttpSvc.get('sqlacc/maintenance/alllist/supplier', {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.sqlFields = result;				
				}, function() {
					toastr.error('Failed to load SQL Fields.', Auth.translate('ERROR'))
					return;
				});
		};
		/* ***************************************************************** */
		
		vm.loadAutoCountCreditTypes = function() {
			HttpSvc.get('autocount/maintenance/list/creditortypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_CreditorTypes = result;					
					vm.loadAutoCountControlAccounts();
				}, function() {
					toastr.error('Failed to load selected AutoCount Creditor Types.', Auth.translate('ERROR'))
					//$state.go('maintenance.suppliers.list');
					return;
				});
		};
		
		vm.loadAutoCountControlAccounts = function() {
			HttpSvc.get('autocount/maintenance/list/creditorcontrolaccounts', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_ControlAccounts = result;					
					vm.loadAutoCountCurrencies();
				}, function() {
					toastr.error('Failed to load AutoCount Creditor Control Accounts.', Auth.translate('ERROR'))
					//$state.go('maintenance.suppliers.list');
					return;
				});
		};
		
		vm.loadAutoCountCurrencies = function() {
			HttpSvc.get('autocount/maintenance/list/currencies', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_CurrencyCodes = result;					
					vm.loadAutoCountCreditTerms();
				}, function() {
					toastr.error('Failed to load AutoCount Currencies.', Auth.translate('ERROR'))
					//$state.go('maintenance.suppliers.list');
					return;
				});
		};
		
		vm.loadAutoCountCreditTerms = function() {
			HttpSvc.get('autocount/maintenance/list/creditterms', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_DisplayTerms = result;
					vm.loadAutoCountAreaCodes();
				}, function() {
					toastr.error('Failed to load AutoCount Credit Terms.', Auth.translate('ERROR'))
					//$state.go('maintenance.suppliers.list');
					return;
				});
		};
		
		vm.loadAutoCountAreaCodes = function() {
			HttpSvc.get('autocount/maintenance/list/areas', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_AreaCodes = result;
				}, function() {
					toastr.error('Failed to load AutoCount Area Codes.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};
		
		/* ***************************************************************** */
		
		vm.selectedCurrencyChanged = function() {
			vm.supplier.currencyCode = vm.selectedCurrency.code;
		}
		
		vm.selectedCreditorTypeChanged = function() {
			vm.supplier.autoCount_CreditorType = vm.selectedCreditorType.code;
		}
		
		vm.selectedControlAccountChanged = function() {
			vm.supplier.autoCount_ControlAccount = vm.selectedControlAccount.accNo;
		}
		
		vm.selectedCurrencyCodeChanged = function() {
			vm.supplier.autoCount_CurrencyCode = vm.selectedCurrencyCode.currencyCode;
		}
		
		vm.selectedDisplayTermChanged = function() {
			vm.supplier.autoCount_DisplayTerm = vm.selectedDisplayTerm.displayTerm;
		}

		vm.selectedAreaCodeChanged = function() {
			vm.supplier.autoCount_AreaCode = vm.selectedAreaCode.areaCode;
		}

		vm.selectedCompanyCategoryChanged = function() {
			vm.supplier.sqL_CategoryCode = vm.selectedCompanyCategory.CODE;
		}

		vm.selectedSQLControlAccountChanged = function() {
			vm.supplier.sqL_ControlAccount = vm.selectedSQLControlAccount.CODE;
		}

		vm.selectedSQLAgentChanged = function() {
			vm.supplier.sqL_AgentCode = vm.selectedSQLAgent.CODE;
		}

		vm.selectedSQLAreaCodeChanged = function() {
			vm.supplier.sqL_AreaCode = vm.selectedSQLAreaCode.CODE;
		}

		vm.selectedSQLCurrencyChanged = function() {
			vm.supplier.sqL_CurrencyCode = vm.selectedSQLCurrencyCode.CODE;
		}

		vm.selectedSQLTermChanged = function () {
			vm.supplier.sqL_CreditTerm = vm.selectedSQLTerm.CODE;
		}
		/* ***************************************************************** */
		
		// Form Submission
		vm.submit = function() {
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;
				
				vm.supplier.companyId = Auth.getCompanyId();
				
				HttpSvc.post('suppliers/add', vm.supplier, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkResult = function(result) {
			if(result.httpStatusCode=="200")
			{
				toastr.success('Supplier has been created successfully.', Auth.translate('SUCCESS'));
				$state.go('maintenance.suppliers.update', {'id': result.id });
			}
			else
			{
				vm.lockButtons = false;
				toastr.error(result.message, 'Failed');
			}
		}
		
		/* ***************************************************************** */
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function SuppliersUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;
		vm.mode = 2;
		vm.supplier = {};
		vm.changeLogs = [];
		vm.integrationMode = Auth.getIntegrationMode();
		vm.hasAutoCountFields = vm.integrationMode == 2 && Auth.autoCount_EnableSync_Creditor();
		vm.hasIDBFields = vm.integrationMode == 7 && Auth.idB_EnableSync_Creditor();
		vm.hasSQLFields = vm.integrationMode == 8 && Auth.sqL_EnableSync_Creditor();
		vm.currencyList = [];
		vm.autoCount_CreditorTypes = [];
		vm.autoCount_ControlAccounts = [];
		vm.autoCount_CurrencyCodes = [];
		vm.autoCount_DisplayTerms = [];
		vm.autoCount_AreaCodes = [];
		vm.lockButtons = false;
		vm.sqlFields = {};

		/* ***************************************************************** */
		
		vm.initData = function() {	
		
			if(vm.hasAutoCountFields) {
				vm.loadAutoCountCreditTypes();
			} else if (vm.hasIDBFields){
				vm.loadIDBCreditTypes();
			}
			else if(vm.hasSQLFields) {
				vm.loadSQLFields();
			}
			 else {
				vm.loadCurrencyList();
			}
		}
		
		/* ***************************************************************** */

		vm.loadCurrencyList = function() {
			HttpSvc.get('currencies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.currencyList = result;					
					vm.loadSupplier();
				}, function() {
					toastr.error('Failed to load Currency List.', Auth.translate('ERROR'))
					return;
				});
		};

		/* ***************************************************************** */

		vm.loadIDBCreditTypes = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('idbs/maintenance/list/creditortypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.idbCreditorTypes = result;					
					vm.loadIDBCreditTerms();
				}, function() {
					toastr.error('Failed to load selected IDB Creditor Types.', Auth.translate('ERROR'))
					return;
				});
		};
		vm.loadIDBCreditTerms = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('idbs/maintenance/list/creditterms', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.idbCreditTerms = result;					
					vm.loadCurrencyList();
				}, function() {
					toastr.error('Failed to load selected IDB Creditr Terms.', Auth.translate('ERROR'))
					return;
				});
		};
		
		vm.loadSQLFields = function() {
			HttpSvc.get('sqlacc/maintenance/alllist/supplier', {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.sqlFields = result;				
					vm.loadCurrencyList();
				}, function() {
					toastr.error('Failed to load SQL Fields.', Auth.translate('ERROR'))
					return;
				});
		};
		/* ***************************************************************** */
		
		vm.loadAutoCountCreditTypes = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('autocount/maintenance/list/creditortypes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_CreditorTypes = result;					
					vm.loadAutoCountControlAccounts();
				}, function() {
					toastr.error('Failed to load selected AutoCount Creditor Types.', Auth.translate('ERROR'))
					//$state.go('maintenance.suppliers.list');
					return;
				});
		};
		
		vm.loadAutoCountControlAccounts = function() {
			HttpSvc.get('autocount/maintenance/list/creditorcontrolaccounts', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_ControlAccounts = result;					
					vm.loadAutoCountCurrencies();
				}, function() {
					toastr.error('Failed to load AutoCount Control Accounts.', Auth.translate('ERROR'))
					//$state.go('maintenance.suppliers.list');
					return;
				});
		};
		
		vm.loadAutoCountCurrencies = function() {
			HttpSvc.get('autocount/maintenance/list/currencies', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_CurrencyCodes = result;					
					vm.loadAutoCountCreditTerms();
				}, function() {
					toastr.error('Failed to load AutoCount Currencies.', Auth.translate('ERROR'))
					//$state.go('maintenance.suppliers.list');
					return;
				});
		};
		
		vm.loadAutoCountCreditTerms = function() {
			HttpSvc.get('autocount/maintenance/list/creditterms', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_DisplayTerms = result;					
					vm.loadAutoCountAreaCodes();
				}, function() {
					toastr.error('Failed to load AutoCount Credit Terms.', Auth.translate('ERROR'))
					//$state.go('maintenance.suppliers.list');
					return;
				});
		};
		
		vm.loadAutoCountAreaCodes = function() {
			HttpSvc.get('autocount/maintenance/list/areas', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCount_AreaCodes = result;
					vm.loadCurrencyList();
				}, function() {
					toastr.error('Failed to load AutoCount Area Codes.', Auth.translate('ERROR'))
					//$state.go('maintenance.debtors.list');
					return;
				});
		};
		
		/* ***************************************************************** */
		
		vm.selectedCurrencyChanged = function() {
			vm.supplier.currencyCode = vm.selectedCurrency.code;
		}
		
		vm.selectedCreditorTypeChanged = function() {
			vm.supplier.autoCount_CreditorType = vm.selectedCreditorType.code;
		}
		
		vm.selectedControlAccountChanged = function() {
			vm.supplier.autoCount_ControlAccount = vm.selectedControlAccount.accNo;
		}
		
		vm.selectedCurrencyCodeChanged = function() {
			vm.supplier.autoCount_CurrencyCode = vm.selectedCurrencyCode.currencyCode;
		}
		
		vm.selectedDisplayTermChanged = function() {
			vm.supplier.autoCount_DisplayTerm = vm.selectedDisplayTerm.displayTerm;
		}

		vm.selectedAreaCodeChanged = function() {
			vm.supplier.autoCount_AreaCode = vm.selectedAreaCode.areaCode;
		}

		vm.selectedCompanyCategoryChanged = function() {
			vm.supplier.sqL_CategoryCode = vm.selectedCompanyCategory.CODE;
		}

		vm.selectedSQLControlAccountChanged = function() {
			vm.supplier.sqL_ControlAccount = vm.selectedSQLControlAccount.CODE;
		}

		vm.selectedSQLAgentChanged = function() {
			vm.supplier.sqL_AgentCode = vm.selectedSQLAgent.CODE;
		}

		vm.selectedSQLAreaCodeChanged = function() {
			vm.supplier.sqL_AreaCode = vm.selectedSQLAreaCode.CODE;
		}

		vm.selectedSQLCurrencyChanged = function() {
			vm.supplier.sqL_CurrencyCode = vm.selectedSQLCurrencyCode.CODE;
		}

		vm.selectedSQLTermChanged = function () {
			vm.supplier.sqL_CreditTerm = vm.selectedSQLTerm.CODE;
		}
		/* ***************************************************************** */
				
		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('supplierchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};	
		
		// Load Suppliers
		vm.loadSupplier = function() {
			vm.lockButtons = true;
			var params = { id: $stateParams.id };					
			
			HttpSvc.get('suppliers/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.supplier = result;

					if (vm.hasAutoCountFields){
						vm.autoCount_CreditorTypes.forEach(function(c) {						
							if(vm.supplier.autoCount_CreditorType == c.code){
								vm.selectedCreditorType = c;
							}
						});
						
						vm.autoCount_ControlAccounts.forEach(function(c) {
							if(vm.supplier.autoCount_ControlAccount == c.accNo){
								vm.selectedControlAccount = c;
							}
						});
						
						vm.autoCount_CurrencyCodes.forEach(function(c) {
							if(vm.supplier.autoCount_CurrencyCode == c.currencyCode){
								vm.selectedCurrencyCode = c;
							}
						});
						
						vm.autoCount_DisplayTerms.forEach(function(c) {
							if(vm.supplier.autoCount_DisplayTerm == c.displayTerm){
								vm.selectedDisplayTerm = c;
							}
						});
						
						vm.autoCount_AreaCodes.forEach(function(c) {
							if(vm.supplier.autoCount_AreaCode == c.areaCode){
								vm.selectedAreaCode = c;
							}
						});
					}
					else if (vm.hasIDBFields) {
						vm.idbCreditorTypes.forEach(function(c) {						
							if(vm.supplier.idB_CreditorTypeCode == c.code){
								vm.selectedIDBCreditorType = c;
							}
						});

						vm.idbCreditTerms.forEach(function(c) {						
							if(vm.supplier.idB_CreditTermCode == c.code){
								vm.selectedIDBCreditTerm = c;
							}
						});
					}
					else if (vm.hasSQLFields) {
						vm.sqlFields.SQL_Maintenance_CompanyCategory.forEach(function (c) {
							if (vm.supplier.sqL_CategoryCode == c.CODE) {
								vm.selectedCompanyCategory = c;
							}
						});

						vm.sqlFields.SQL_Supplier_ControlAccount.forEach(function (c) {
							if (vm.supplier.sqL_ControlAccount == c.CODE) {
								vm.selectedSQLControlAccount = c;
							}
						});

						vm.sqlFields.SQL_Maintenance_Area.forEach(function (c) {
							if (vm.supplier.sqL_AreaCode == c.CODE) {
								vm.selectedSQLAreaCode = c;
							}
						});
					
						vm.sqlFields.SQL_Maintenance_Agent.forEach(function (c) {
							if (vm.supplier.sqL_AgentCode == c.CODE) {
								vm.selectedSQLAgent = c;
							}
						});

						vm.sqlFields.SQL_Maintenance_Currency.forEach(function (c) {
							if (vm.supplier.sqL_CurrencyCode == c.CODE) {
								vm.selectedSQLCurrencyCode = c;
							}
						});

						vm.sqlFields.SQL_Maintenance_Terms.forEach(function (c) {
							if (vm.supplier.sqL_CreditTerm == c.CODE) {
								vm.selectedSQLTerm = c;
							}
						});
					}
					vm.currencyList.forEach(function(c) {
						if(vm.supplier.currencyCode == c.code){
							vm.selectedCurrency = c;
						}
					});

					vm.loadChangeLogs();
					
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to load selected Supplier.', Auth.translate('ERROR'))
					$state.go('maintenance.suppliers.list');
					return;
				});
		};	
		
		/* ***************************************************************** */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				vm.lockButtons = true;
				
				HttpSvc.put('suppliers/' + $stateParams.id, vm.supplier, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);
					}, function (error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkResult = function(result) {
			if(result.httpStatusCode=="200")
			{
				toastr.success('Supplier has been updated successfully.', Auth.translate('SUCCESS'));
				$state.reload();
			}
			else
			{
				vm.lockButtons = false;
				toastr.error(result.message, 'Failed');
			}
		}
		
		/* ***************************************************************** */
		
		// Call Actions
		vm.initData();
	}

	/** @ngInject */
	function SuppliersImportCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;		
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.serverMode = Auth.getServerMode();
		/* **************************************************** */
		
		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";
		/* **************************************************** */
		
		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		vm.importOptions.createSupplier = true;
		vm.importOptions.updateSupplier = true;
		
		/* **************************************************** */
		
		vm.importResult = {};
		
		/* **************************************************** */
		
		vm.downloadTemplate = function() {
			
			var filename = "Supplier Template.xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject('suppliers/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};		
		
		/* **************************************************** */
		
		vm.importData = function() {
			vm.isImporting = true;
			
			HttpSvc.post('suppliers/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
					// Do nothing
				}, function(error) {
					// Do nothing
				});
		}
		
		/* **************************************************** */
		
		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}
		
		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;			
		}
		
		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];
			
			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}
		
		// Upload File
		vm.uploadFile = function() {	
			vm.resetFileUploadParams();
			
			vm.lockButtons = true;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;
								
			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;
			
			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();	
				vm.uploadMedia(vm.mediaToUpload);
			}	
			else if(vm.serverMode==1)
			{			
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {
						
						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;					
						vm.uploadMedia(vm.mediaToUpload);
						
					}, function(error) {
						toastr.error(error, 'Failed');
						
						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {					
					vm.isUploaded = true;
					
					// Call Process Excel API 
					HttpSvc.post('suppliers/import/' + resp.data, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;
							
							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			}  else if(vm.serverMode==1) { // Azure Server
									
				/* Initialize variables */
				/* ************************************* */	
				handleFileSelect(_fileToUpload);
				/* ************************************* */	
				
				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							} 
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,				
			}).then(function(response) {	
				vm.isUploaded = true;
				
				// Call Process Excel API 
				HttpSvc.post('suppliers/import/' + excelFilename, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;
						
						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }		
	};
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.pos.products.controller', [])
			.controller('PosProductMainCtrl', PosProductMainCtrl)
			.controller('POSProductCreateCtrl', PosProductCreateCtrl)
			.controller('POSProductUpdateCtrl', POSProductUpdateCtrl);

    /** @ngInject */
    function PosProductMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.prodDataFull = [];
		vm.prodData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.prodDataFull, tableState.search.predicateObject) : vm.prodDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.prodData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.prodDataFull.length <= 0) {				
				HttpSvc.get('posproducts/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.prodDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	

		// Delete Product		
		vm.deletePosProduct = function(id, name) {
			var params = {};
			HttpSvc.delete('posproducts/' + id, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('iotsensors/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.prodDataFull = result;
							
							toastr.success('The POS Product [<b>' + name + '</b>] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function(error) {
					// Failed
					toastr.error(error, 'Delete Failed');
					return null;
			});
		};		
	};
	
	/** @ngInject */
    function PosProductCreateCtrl($scope, $state, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.posprod = {};
		vm.products = [];
		vm.posprod.imageLocation = '';
		vm.selectedProduct = null;
		vm.fileToUpload = null;
		vm.blobUrl = RmsApi.BLOBURL;
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		
		/* ******************************************************************* */

		// Init Data
		vm.initData = function() {			
			vm.posprod.imageLocation = 'assets/img/empty_placeholder.png';	
			vm.loadProducts();
		}	
		
		vm.loadProducts = function() {
			HttpSvc.get('products/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.products.push({ id: u.id, code: u.code, name: u.name });
					});		
				}, function() {
					vm.products = [];
				});
		};
		
		/* ******************************************************************* */

		vm.selectedProductChanged = function() {
			vm.posprod.linkProductId = vm.selectedProduct.id;
		}
	
		vm.clearProduct = function() {
			vm.selectedProduct = null;
			vm.posprod.linkProductId = "";
		}
		
		/* ******************************************************************* */

		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					/* CHECK STORAGE QUOTA */
					if(vm.lockUploadButton) {
						toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Media Upload Error');
						return;
					}
					/* ******************* */
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/posproduct/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "posproduct/" + newFilename + mediaExtension;
				}
				vm.posprod.imageLocation = imgLocation;
						
				HttpSvc.post('posproducts', vm.posprod, Auth.getTokenId(), false)
					.then(function(result) {						
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(vm.serverMode, result.id);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/posproduct/" + result.id;
							vm.uploadImage(vm.serverMode, result.id);
							
						} else {							
							toastr.success('PSO Product has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('pos.products.update', {'id': result.id });
						}
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		};
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (serverMode, productId) {
			var fileReader = new FileReader();
			
			if(serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId()},
				}).then(function (resp) {
					toastr.success('POS Product has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('pos.products.update', {'id': productId });
				}, function (resp) {
					toastr.success('POS Product has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('pos.products.update', {'id': productId });
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {				
									
							// Notify Server POS Product Media ready
							HttpSvc.put('youtube/ready/posproduct/' + productId, {}, Auth.getTokenId(), false)
								.then(function(result) {
									
									// Refresh Clud Storage Stats
									Auth.selectBranchToken()
										.then(function() {	
											toastr.success('POS Product has been created successfully.', Auth.translate('SUCCESS'));
											$state.go('pos.products.update', {'id': productId });
										}, function(error) {
											toastr.success('POS Product has been created successfully.', Auth.translate('SUCCESS'));
											$state.go('pos.products.update', {'id': productId });
										});		
								}, function(error) {
								});	
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function POSProductUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.posprod = {};
		vm.posprod.imageLocation = '';
		vm.posprod.thumbnail = '';
		vm.posprod.oriImageLocation = '';
		vm.posprod.oriThumbnail = '';
		vm.products = [];
		vm.selectedProduct = null;
		vm.fileToUpload = null;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		
		/* ******************************************************************* */

		// Load Products
		vm.loadProducts = function() {
			HttpSvc.get('products/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.products.push({ id: u.id, code: u.code, name: u.name });
					});	

					vm.loadPosProduct();	
				}, function() {
					vm.products = [];
				});
		};
		
		// Load POS Product
		vm.loadPosProduct = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('posproducts/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.posprod = result;
					
					vm.products.forEach(function (p) {
						if(p.id==vm.posprod.linkProductId)
							vm.selectedProduct = p;
					});
					
					if(!vm.posprod.imageLocation || vm.posprod.imageLocation=='') {
						vm.posprod.imageLocation = 'assets/img/empty_placeholder.png';
						vm.posprod.thumbnail = 'assets/img/empty_placeholder.png';
						vm.posprod.oriImageLocation = "";
						vm.posprod.oriThumbnail = "";
					} else {
						vm.posprod.oriImageLocation = vm.posprod.imageLocation;
						vm.posprod.oriThumbnail = vm.posprod.thumbnail;
						vm.posprod.imageLocation = vm.rootUrl + vm.posprod.imageLocation;
						vm.posprod.thumbnail = vm.rootUrl + vm.posprod.thumbnail;
					}
				}, function() {
					toastr.error('Failed to load selected POS Product.', Auth.translate('ERROR'))
					$state.go('pos.products.list');
					return;
				});		
		};
		
		/* ******************************************************************* */

		vm.selectedProductChanged = function() {
			vm.posprod.linkProductId = vm.selectedProduct.id;
		}
	
		vm.clearProduct = function() {
			vm.selectedProduct = null;
			vm.posprod.linkProductId = "";
		}
		
		/* ******************************************************************* */

		// Form Submission
		var thumbnail = "";
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		vm.submit = function(picFile) {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				thumbnail = "";
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					/* CHECK STORAGE QUOTA */
					if(vm.lockUploadButton) {
						toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Media Upload Error');
						return;
					}
					/* ******************* */
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/posproduct/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "posproduct/" + newFilename + mediaExtension;
					
				} else if(vm.posprod.oriImageLocation!="") {
					imgLocation = vm.posprod.oriImageLocation;
					thumbnail = vm.posprod.oriThumbnail;
				}
				
				vm.posprod.thumbnail = thumbnail;
				vm.posprod.imageLocation = imgLocation;
				vm.posprod.isThumbnailGenerated = true;	
								
				HttpSvc.put('posproducts/' + $stateParams.id, vm.posprod, Auth.getTokenId(), false)
					.then(function(result) {							
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(vm.serverMode, result.id);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/posproduct/" + $stateParams.id;
							vm.uploadImage(vm.serverMode, result.id);
							
						} else {							
							toastr.success('POS Product has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						}
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		};
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (serverMode, productId) {
			var fileReader = new FileReader();
			
			if(serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId()},
				}).then(function (resp) {
					toastr.success('POS Product has been created successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('POS Product has been created successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {				
									
							// Notify Server POS Product Media ready
							HttpSvc.put('youtube/ready/posproduct/' + productId, {}, Auth.getTokenId(), false)
								.then(function(result) {
									
									// Refresh Clud Storage Stats
									Auth.selectBranchToken()
										.then(function() {	
											toastr.success('POS Product has been created successfully.', Auth.translate('SUCCESS'));
											$state.reload();
										}, function(error) {
											toastr.success('POS Product has been created successfully.', Auth.translate('SUCCESS'));
											$state.reload();
										});		
								}, function(error) {
								});	
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};
		
		vm.deletePosProduct = function() {
			
			HttpSvc.delete('posproducts/' + vm.posprod.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('The POS Product [<b>' + vm.posprod.name + '</b>] has been deleted.', 'Delete Success');
					$state.go('pos.products.list');
				}, function(error) {
					// Failed
					toastr.error(error, 'Delete Failed');
					return null;
			});
		};
		
		// Call Actions
		vm.loadProducts();
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.outletops.srnlist.controller', [])
        .controller('ReceivingsSrnMainCtrl', ReceivingsSrnMainCtrl)
        .controller('ReceivingsSrnUpdateCtrl', ReceivingsSrnUpdateCtrl)
        .controller('ReceivingSrnItemPhotoModalCtrl', ReceivingSrnItemPhotoModalCtrl);

    /** @ngInject */
    function ReceivingsSrnMainCtrl(Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.data = [];
		vm.dataFilter = {};
		vm.isLoading = false;

		vm.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}
			
			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";
			
			var params = {
				keyword:  predicate.docNo,
				branchName: predicate.branchName,
				deliveryOrderNo: predicate.deliveryOrderNo,
				createdDate: predicate.createdDate,
				isCurrentMonth:  predicate.isCurrentMonth,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			vm.isLoading = true;
			
			var params = vm.getApiParams(tableState);

			HttpSvc.post('storereceivings/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isLoading = false;		
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;	
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			
			return tableState;
		};

		vm.resetSearch = function() 
		{
		}
				
		vm.printSRN = function(rcvId, rcvNo) {
			
			var filename = rcvNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('storereceivings/print/' + rcvId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print SRN. ' + error, '');
							return null;
						});
		}
		
		// Init Call
		//vm.loadFilters();
	};
	
	/** @ngInject */
    function ReceivingsSrnUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.srn = {};			
		vm.storageList = [];
		vm.selectedStorage = {};
		vm.isLoading = false;
		
		// Load Item Receiving Storages
		vm.loadStorages = function() {
			HttpSvc.get('storages/listbytypes/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageList = result;
					vm.loadSrn();
				}, function(error) {
					toastr.error('Failed to load Storage list. ' + error, 'Failed');
				});
		}
		
		// Load SRN
		vm.loadSrn = function() {
			HttpSvc.get('storereceivings/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.srn = result;
					
					vm.storageList.forEach(function(s) {
						if(s.id==vm.srn.storageId) {
							vm.selectedStorage = s;
						}
					});
				}, function(error) {
					toastr.error('Failed to load SRN. ' + error, 'Failed');
				});
		}
		
		vm.printGRN = function(rcvId, rcvNo) {
			
			var filename = rcvNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('storereceivings/print/' + rcvId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print SRN. ' + error, '');
							return null;
						});
		}	
		
		vm.cancelGRN = function(rcvId, rcvNo) {
			if(!confirm('Are you sure you want to cancel this SRN ?')) return;
			
			HttpSvc.post('storereceivings/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('SRN cancelled successfully.', Auth.translate('SUCCESS'));
					$state.go('outletops.srnlist');
				}, function(error) {
					vm.srn.receivingItems = [];
					toastr.error(error, 'Failed');
				});
		}
		
		/* ****************************************************** */
		
		vm.changeItem = function (id) {
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'ReceivingItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							receivingItemId: id,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					$state.reload();
				}, function () {
				});
		};	
		
		/* ****************************************************** */

		vm.viewPhotos = function(itemCode, itemName, photoAttachment) {
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'photoModal.html',
				controller: 'ReceivingSrnItemPhotoModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							itemCode: itemCode,
							itemName: itemName,
							photoAttachment: photoAttachment,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		}

		/* ****************************************************** */
		
		// Form Submission
		vm.submit = function() {						
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				HttpSvc.put('storereceivings/' + $stateParams.id, vm.srn, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('SRN updated successfully.', Auth.translate('SUCCESS'));
					}, function(error) {
						vm.srn.receivingItems = [];
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadSrn();
	}	
	
	/** @ngInject */
	function ReceivingSrnItemPhotoModalCtrl($uibModalInstance, item, Auth, RmsApi, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.itemCode = item.itemCode;
		$mdl.itemName = item.itemName;
		$mdl.photoAttachment = item.photoAttachment;
		$mdl.photoArray = $mdl.photoAttachment.split(";");
		$mdl.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		$mdl.selectedPhoto = $mdl.rootUrl + $mdl.photoArray[0];

		/* *************************************************** */
		
		// Process Photos
		$mdl.selectPhoto = function(photo) {
			$mdl.selectedPhoto = $mdl.rootUrl + photo;
		}
		
		/* *************************************************** */

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.purchaseorders.pofromreq.controller', [])
        .controller('PurchaseOrderFromReqMainCtrl', PurchaseOrderFromReqMainCtrl);

    /** @ngInject */
    function PurchaseOrderFromReqMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
				
		var vm = this;

		vm.currencyCode = Auth.getCurrency();
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.data = [];
		vm.dataFilter = {};
		vm.isLoading = false;
		vm.lockButtons = false;
		vm.isProcessing = false;

		vm.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}
			
			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";
			
			var params = {
				keyword:  predicate.requisitionNo,
				branchName: predicate.branchName,
				departmentName: predicate.departmentName,
				userName: predicate.userName,
				status: 'APPROVED',
				isSameBranch:  predicate.isSameBranch,
				isOpenDoc:  predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			vm.isLoading = true;
			
			var params = vm.getApiParams(tableState);

			HttpSvc.post('requisitions/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isLoading = false;		
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;	
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			
			return tableState;
		};

		vm.resetSearch = function() 
		{
		}
		
		/* ****************************************************** */
						
		// Select All Requisition
		vm.selectAll = function() {
			vm.selectReqIds = [];
			vm.data.forEach( function(p) {
				vm.selectReqIds.push(p.id);
			});
		};
						
		// De-select All Products
		vm.deselectAll = function() {
			vm.selectReqIds = [];
		};
		
		/* ****************************************************** */
				
		// Generate Jobs
		vm.generatePos = function() {
			vm.lockButtons = true;
			vm.isProcessing = true;
			
			HttpSvc.post('purchaseorders/batchgenerate', vm.selectReqIds, Auth.getTokenId(), true)
				.then(function(result) {
					toastr.success('Batch Purchase Orders creation has been completed.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function(error) {
					vm.lockButtons = false;
					vm.isProcessing = false;
					toastr.error(error, 'Failed');
				});
		};
	};
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.purchaseorders.polist.controller', [])
        .controller('PurchaseOrderMainCtrl', PurchaseOrderMainCtrl)
        .controller('PurchaseOrderCreateCtrl', PurchaseOrderCreateCtrl)
        .controller('PurchaseOrderUpdateCtrl', PurchaseOrderUpdateCtrl)
        .controller('PurchaseOrderItemModalCtrl', PurchaseOrderItemModalCtrl)
        .controller('PurchaseOrderEmailModalCtrl', PurchaseOrderEmailModalCtrl)
        .controller('PurchaseOrderDownloadExcelModalCtrl', PurchaseOrderDownloadExcelModalCtrl);

    /** @ngInject */
    function PurchaseOrderMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, baSidebarService, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.statusList = [
			{id: 'NEW', name: 'NEW', label: 'NEW'},
			{id: 'CONFIRMED', name: 'CONFIRMED', label: 'CONFIRMED'},
			{id: 'APPROVED', name: 'APPROVED', label: 'APPROVED'},
			{id: 'COMPLETED', name: 'COMPLETED', label: 'COMPLETED'},
			{id: 'COMPLETED (PARTIAL)', name: 'COMPLETED (PARTIAL)', label: 'COMPLETED_PARTIAL'},
			{id: 'CANCELLED', name: 'CANCELLED', label: 'CANCELLED'}
		];
		vm.emailStatusList = [
			{id: '1', name: 'YES', label: 'YES'},
			{id: '2', name: 'NO', label: 'NO'},
		];
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.data = [];
		vm.showUpdatePanel = false;
		vm.selectedPurchaseOrders = [];
		vm.currencyCode = Auth.getCurrency();


		vm.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var branchSearchTerm = predicate.branchName || predicate.shipToBranchName || "";
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.purchaseOrderNo,
				purchaseOrderDate: predicate.purchaseOrderDate,
				deliveryDate: predicate.deliveryDate,
				requisitionNo: predicate.requisitionNo,
				branchName: branchSearchTerm,
				departmentName: predicate.departmentName,
				supplierName: predicate.supplierName,
				status: predicate.status,
				hasEmailed: predicate.hasEmailed,
				createdBy: predicate.createdBy,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('purchaseorders/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			return tableState;
		};

		vm.resetSearch = function()
		{
		}

		/* ******************************************************************* */

		vm.showBulkUpdatePanel = function() {
			vm.showUpdatePanel = true;
		}

		vm.closeBulkUpdatePanel = function() {
			vm.selectedPurchaseOrders = [];
			vm.showUpdatePanel = false;
		}

		vm.selectAll = function() {
			vm.selectedPurchaseOrders = [];
			vm.data.forEach( function(d) {
				vm.selectedPurchaseOrders.push(d.id);
			});
		}

		vm.deselectAll = function() {
			vm.selectedPurchaseOrders = [];
		}

		vm.bulkUpdateConfimed = function() {

			var resp = confirm('Note:\nOnly Purchase Orders with [NEW] status will be updated.\n\nProceed to bulk update status to [CONFIRMED]?');
			if(!resp) return;

			if(vm.selectedPurchaseOrders.length <= 0) {
				alert('You must select at least one Purchase Order to proceed.');
				return;
			}

			HttpSvc.post("purchaseorders/bulkupdatestatus/confirmed", vm.selectedPurchaseOrders, Auth.getTokenId())
				.then(function(result) {
					toastr.success('Updated: <b>' + result.totalUpdatedCount + '</b>&nbsp;&nbsp;&nbsp;Skipped: <b>' +
									result.totalSkippedCount + '</b>', 'Bulk Status Update Successful');
					vm.closeBulkUpdatePanel();
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Bulk Status Update Failed');
					return null;
				});
		}

		vm.bulkUpdateApproved = function() {

			var resp = confirm('Note:\nOnly Purchase Orders with [NEW] or [CONFIRMED] status will be updated.\n\nProceed to bulk update status to [APPROVED]?');
			if(!resp) return;

			if(vm.selectedPurchaseOrders.length <= 0) {
				alert('You must select at least one Purchase Order to proceed.');
				return;
			}

			HttpSvc.post("purchaseorders/bulkupdatestatus/approved", vm.selectedPurchaseOrders, Auth.getTokenId())
				.then(function(result) {
					toastr.success('Updated: <b>' + result.totalUpdatedCount + '</b>&nbsp;&nbsp;&nbsp;Skipped: <b>' +
									result.totalSkippedCount + '</b>', 'Bulk Status Update Successful');
					vm.closeBulkUpdatePanel();
					$state.reload();;
				}, function(error) {
					toastr.error(error, 'Bulk Status Update Failed');
					return null;
				});
		}

		vm.bulkUpdateFinalize = function() {

			var resp = confirm('Note:\nOnly Purchase Orders with [APPROVED] status will be updated.\n\nProceed to Finalize selected Purchase Order(s)?');
			if(!resp) return;

			if(vm.selectedPurchaseOrders.length <= 0) {
				alert('You must select at least one Purchase Order to proceed.');
				return;
			}

			HttpSvc.post("purchaseorders/bulkupdatestatus/finalize", vm.selectedPurchaseOrders, Auth.getTokenId())
				.then(function(result) {
					toastr.success('Updated: <b>' + result.totalUpdatedCount + '</b>&nbsp;&nbsp;&nbsp;Skipped: <b>' +
									result.totalSkippedCount + '</b>', 'Bulk Status Update Successful');
					vm.closeBulkUpdatePanel();
					$state.reload();;
				}, function(error) {
					toastr.error(error, 'Bulk Status Update Failed');
					return null;
				});
		}

		/* ******************************************************************* */

		vm.showDownloadExcelModal = function () {
			vm.product = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'downloadModal.html',
				controller: 'PurchaseOrderDownloadExcelModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

		vm.printPO = function(poId, poNo) {

			var filename = poNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('purchaseorders/print/' + poId, Auth.getTokenId(), filename)
				.then(
						null,
						function(error) {
							// Failed
							toastr.error('Failed to print the Purchase Order. ' + error, '');
							return null;
						});
		}

		vm.clonePO = function(poId) {
			vm.isLoading = true;

			HttpSvc.post('purchaseorders/clone/' + poId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					$state.reload();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to clone Purchase Order.', '');
					return null;
			});
		};

		vm.exportPO = function(poId, poNo) {

			var filename = poNo.replace("/", "_") + ".xlsx";

			HttpSvc.getExcelObject('purchaseorders/export/' + poId, Auth.getTokenId(), filename)
				.then(
					null,
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to export the Purchase Order to Excel.', 'Failed');
						return null;
					});
		};

		vm.emailPurchaseOrder = function (poId) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'emailModal.html',
				controller: 'PurchaseOrderEmailModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							poId: poId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					$scope.$broadcast('refreshStTable');
				}, function () {
					$scope.$broadcast('refreshStTable');
				});
		};
	};

	/** @ngInject */
    function PurchaseOrderCreateCtrl($scope, $state, $filter, $uibModal, Auth, HttpSvc, UtilSvc, toastr) {
		Auth.init();

		var vm = this;

		vm.poStatuses = [
			{ id: 'NEW', name: 'NEW' },
			{ id: 'CONFIRMED', name: 'CONFIRMED' }
		];
		vm.mode = 1;
		vm.originalStatus = 'NEW';
		vm.subTotalTotal = 0;
		vm.gstTotal = 0;
		vm.totalIncGstTotal = 0;

		vm.po = {};
		vm.po.purchaseOrderItems = [];
		vm.poItemsFiltered = [];
		vm.uomList = [];
		vm.itemList = [];
		vm.branchList = [];
		vm.departments = [];
		vm.supplierList = [];
		vm.searchText = "";

		vm.selectedSupplier = null;
		vm.selectedBranch = null;
		vm.showSelectSupplier = false;
		vm.showSelectBranch = false;

		vm.lockButtons = false;

		/* ****************************************************** */

		vm.initData = function() {
			vm.poStatuses.selected = {id: 'NEW', name: 'NEW'};
			vm.po.purchaseOrderDate = $filter('date')(new Date(), 'yyyy-MM-dd');
			vm.po.status = "NEW";
			vm.po.remarks = "";
			vm.lockButtons = false;

			vm.loadUomList();
		}

		// Load Item List
		vm.loadItemList = function() {
			HttpSvc.get('items/list/supplier/' + vm.po.supplierId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.itemList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Item list.', Auth.translate('ERROR'));
					return null;

				});
		};

		// Load UOM List
		vm.loadUomList = function() {
			HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.uomList = result;
					vm.loadSupplierList();
				}, function(error) {
					toastr.error(error, 'Failed to load UOM List');
				});
		};

		// Load Supplier List
		vm.loadSupplierList = function() {
			HttpSvc.get('suppliers/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.supplierList = result;
					vm.loadBranchList();
				}, function(error) {
					toastr.error(error, 'Failed to load Supplier List');
				});
		};

		// Load Branch List
		vm.loadBranchList = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadDepartments();
				}, function(error) {
					toastr.error(error, 'Failed to load Branch List');
				});
		};

		// Load Departments
		vm.loadDepartments = function() {
			HttpSvc.get('departments/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.departments.push({ id: u.id, name: u.name });
					});
				}, function() {
					vm.departments = [];
				});
		};

		/* ****************************************************** */

		vm.setSelectedSupplier = function() {
			vm.selectedSupplier = vm.supplierList.selected;
		}

		vm.setSelectedBranch = function() {
			vm.selectedBranch = vm.branchList.selected;
		}

		vm.cancelSelectSupplier = function() {
			vm.showSelectSupplier = false;
		}

		vm.cancelSelectBranch = function() {
			vm.showSelectBranch = false;
		}

		vm.selectSupplier = function() {
			/* if(vm.selectedSupplier == vm.supplierList.selected) {
				toastr.info("No changes is made.", "Supplier");
				return;
			} */

			vm.po.supplierId = vm.selectedSupplier.id;
			vm.po.supplierCode = vm.selectedSupplier.code;
			vm.po.supplierName = vm.selectedSupplier.name;
			vm.po.supplierAddress1 = vm.selectedSupplier.address1;
			vm.po.supplierAddress2 = vm.selectedSupplier.address2;
			vm.po.supplierAddress3 = vm.selectedSupplier.address3;
			vm.po.supplierState = vm.selectedSupplier.state;
			vm.po.supplierPostCode = vm.selectedSupplier.postCode;
			vm.po.supplierCountry = vm.selectedSupplier.country;
			vm.po.supplierTel = vm.selectedSupplier.phone1;
			vm.po.supplierFax = vm.selectedSupplier.fax1;

			vm.loadItemList();

			vm.showSelectSupplier = false;
			toastr.info("Supplier information updated.", "Supplier");
		}

		vm.selectBranch = function() {
			/* if(vm.selectedSupplier == vm.branchList.selected) {
				toastr.info("No changes is made.", "Branch");
				return;
			} */

			vm.po.shipToBranchId = vm.selectedBranch.id;
			vm.po.shipToBranchName = vm.selectedBranch.name;
			vm.po.shipToContactPerson = vm.selectedBranch.contactPerson;
			vm.po.shipToAddress1 = vm.selectedBranch.address1;
			vm.po.shipToAddress2 = vm.selectedBranch.address2;
			vm.po.shipToAddress3 = vm.selectedBranch.address3;
			vm.po.shipToState = vm.selectedBranch.state;
			vm.po.shipToPostCode = vm.selectedBranch.postCode;
			vm.po.shipToCountry = vm.selectedBranch.country;
			vm.po.shipToTel = vm.selectedBranch.tel;
			vm.po.shipToFax = vm.selectedBranch.fax;

			vm.showSelectBranch = false;
			toastr.info("Ship-To information updated.", "Ship-To");
		}

		/* ****************************************************** */

		// Get Total Food Cost
		vm.getTotalPrice = function () {
			vm.subTotalTotal = 0;
			vm.gstTotal = 0;
			vm.totalIncGstTotal = 0;

			try {
				vm.po.purchaseOrderItems.forEach(function(p) {
					if(!p.isDeleted)
					{
						vm.subTotalTotal += parseFloat(p.subtotal);
						vm.gstTotal += parseFloat(p.tax);
						vm.totalIncGstTotal += parseFloat(p.subtotalIncTax);
					}
				});
			} catch (ex) {
				console.log(ex);
			}
		}

		/* ****************************************************** */

		// Remove Item
		vm.removeItem = function(index) {
			vm.po.purchaseOrderItems.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};

		// Update Item
		vm.updateItem = function(id, obj) {
			var element = {
				id: obj.id,
				itemId: obj.itemId,
				item: {
					code: obj.itemCode,
					description: obj.itemDescription,
				},
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
                    name: obj.unitOfMeasurement.name
				},
				quantity: obj.quantity,
				cost: obj.cost,
				tax: obj.tax,
				taxPercent: obj.taxPercent,
				costIncGst: obj.costIncGst,
				subtotal: obj.subtotal,
				subtotalIncTax: obj.subtotalIncTax,
				taxCode: obj.taxCode,
				taxable: obj.taxable,
				remarks: obj.remarks,
				isDeleted: false,
				isReceived: false,
			};

			for(var i=0; i<vm.po.purchaseOrderItems.length; i++)
			{
				var p = vm.po.purchaseOrderItems[i];
				if(p.id==id)
				{
					var isFound = false;
					// vm.po.purchaseOrderItems.forEach(function(x) {
					// 	if(x.itemId==obj.itemId && x.id!=p.id)
					// 	{
					// 		isFound=true;
					// 	}
					// })
					if(isFound)
					{
						toastr.warning('Item already exists on the list. Please update the existing item instead.');
						return;
					}

					vm.po.purchaseOrderItems.splice(i, 1, element);
					vm.getTotalPrice();
					return;
				}
			}
		};

		// Add Item
		vm.addItem = function(obj) {
			var element = {
				id: UtilSvc.generateGuid(),
				itemId: obj.itemId,
				item: {
					code: obj.itemCode,
					description: obj.itemDescription,
				},
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
                    name: obj.unitOfMeasurement.name
				},
				quantity: obj.quantity,
				cost: obj.cost,
				tax: obj.tax,
				taxPercent: obj.taxPercent,
				costIncGst: obj.costIncGst,
				subtotal: obj.subtotal,
				subtotalIncTax: obj.subtotalIncTax,
				taxCode: obj.taxCode,
				taxable: obj.taxable,
				remarks: obj.remarks,
				isDeleted: false,
				isReceived: false,
			};

			var isFound = false;
			// vm.po.purchaseOrderItems.forEach(function(i) {
			// 	if(i.itemId==obj.itemId)
			// 	{
			// 		isFound=true;
			// 	}
			// })
			if(isFound)
			{
				toastr.warning('Item already exists on the list.');
				return;
			}

			// vm.po.purchaseOrderItems.push(element);
			vm.po.purchaseOrderItems.unshift(element);
			vm.getTotalPrice();
		};

		/* ****************************************************** */

		vm.item	= {};
		vm.showAddItemModal = function () {
			vm.item = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'PurchaseOrderItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.item,
							supplierId: vm.po.supplierId,
							itemList: vm.itemList,
							uomList: vm.uomList,
							currencyCode: vm.selectedSupplier.currencyCode
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};

		vm.showEditItemModal = function (id) {

			vm.item = {};
			vm.po.purchaseOrderItems.forEach(function(p) {
				if(p.id==id) vm.item = angular.copy(p);
			});

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'PurchaseOrderItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
							supplierId: vm.po.supplierId,
							itemList: vm.itemList,
							uomList: vm.uomList,
							currencyCode: vm.selectedSupplier.currencyCode
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(id, data);
				}, function () {
				});
		};

		/* ****************************************************** */

		// Select PurchaseOrder Status
		vm.selectPoStatus = function() {
			vm.po.status = vm.poStatuses.selected.id;
		};

		// Cancel PurchaseOrder
		vm.cancelPurchaseOrder = function() {
			vm.lockButtons = true;

			HttpSvc.put('purchaseorders/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Purchase Order has been cancelled.');
					$state.go('purchaseorders.polist');
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}

		// Form Submission
		vm.submit = function() {
			vm.lockButtons = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {
				if(vm.departments.selected) {
					vm.po.departmentId = vm.departments.selected.id;
				} else {
					vm.po.departmentId = null;
				}
				vm.po.status = vm.poStatuses.selected.id;
				HttpSvc.post('purchaseorders/add', vm.po, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purchase Order has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('purchaseorders.polist.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
    function PurchaseOrderUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, UtilSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.poStatuses = [
			{ id: 'NEW', name: 'NEW' },
            { id: 'CONFIRMED', name: 'CONFIRMED' }
		];
		vm.mode = 2;
		vm.originalStatus = 'CANCELLED';
		vm.subTotalTotal = 0;
		vm.gstTotal = 0;
		vm.totalIncGstTotal = 0;

		vm.po = {};
		vm.po.purchaseOrderItems = [];
		vm.poItemsFiltered = [];
		vm.uomList = [];
		vm.itemList = [];
		vm.branchList = [];
		vm.departments = [];
		vm.supplierList = [];
		vm.changeLogs = [];
		vm.searchText = "";

		vm.selectedSupplier = null;
		vm.selectedBranch = null;
		vm.showSelectSupplier = false;
		vm.showSelectBranch = false;
		vm.isLoading = false;

		vm.hasApprovedAccess = Auth.hasPerm("purchaseorders.polist", "APPROVE");

		/* ****************************************************** */

		vm.initData = function() {
			vm.lockButtons = false;
			vm.loadUomList();
		}
		
		vm.checkItemsFulfilled = function () {
			var hasFulfilled = false;
			vm.po.purchaseOrderItems.forEach(function (item) {
				if ((item.quantityFulfilled || 0) > 0) {
					hasFulfilled = true;
				}
			});
			return hasFulfilled;
		}

		// Load Item List
		vm.loadItemList = function() {
			HttpSvc.get('items/list/supplier/' + vm.po.supplierId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.itemList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Item list.', '');
					return null;
				});
		};


		vm.sortPOItems = function() {
			vm.po.purchaseOrderItems.sort(function(a, b) {
				// Sort alphabetically
				var productA = a.item.description || '';
				var productB = b.item.description || '';
				return productA.localeCompare(productB);
			});
		}
		// Load UOM List
		vm.loadUomList = function() {
			HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.uomList = result;
					vm.loadSupplierList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		// Load Supplier List
		vm.loadSupplierList = function() {
			HttpSvc.get('suppliers/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.supplierList = result;
					vm.loadBranchList();
				}, function(error) {
					toastr.error(error, 'Failed to load Supplier List');
				});
		};

		// Load Branch List
		vm.loadBranchList = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadDepartments();
				}, function(error) {
					toastr.error(error, 'Failed to load Branch List');
				});
		};

		// Load Departments
		vm.loadDepartments = function() {
			HttpSvc.get('departments/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.departments.push({ id: u.id, name: u.name });
					});
					vm.loadPo();
				}, function() {
					vm.departments = [];
				});
		};

		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('purchaseorderchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};

		vm.loadPo = function() {
			HttpSvc.get('purchaseorders/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.po = result;
					vm.po.purchaseOrderDate = $filter('date')(vm.po.purchaseOrderDate, 'yyyy-MM-dd');
					vm.po.deliveryDate = $filter('date')(vm.po.deliveryDate, 'yyyy-MM-dd');
					vm.originalStatus = vm.po.status;

					vm.supplierList.forEach(function(s) {
                        if(s.id==vm.po.supplierId){
                            vm.selectedSupplier = s;
						}
					});
					vm.departments.forEach(function(d) {
                        if(d.id==vm.po.departmentId){
                            vm.departments.selected = d;
                        }
					});

					vm.poStatuses.forEach(function(sts) {
                        if(sts.id==vm.po.status.toUpperCase()){
							vm.poStatuses.selected = sts;
                        }
					});

					vm.isLoading = false;
					vm.sortPOItems();
					vm.loadItemList();
					vm.getTotalPrice();
					vm.loadChangeLogs();

				}, function(error) {
					toastr.error(error, 'Failed');
					vm.isLoading = false;
				});
		}

		/* ****************************************************** */

		vm.setSelectedSupplier = function() {
			vm.selectedSupplier = vm.supplierList.selected;
		}

		vm.setSelectedBranch = function() {
			vm.selectedBranch = vm.branchList.selected;
		}

		vm.cancelSelectSupplier = function() {
			vm.showSelectSupplier = false;
		}

		vm.cancelSelectBranch = function() {
			vm.showSelectBranch = false;
		}

		vm.selectSupplier = function() {
			/* if(vm.selectedSupplier == null) {
				toastr.info("No changes is made.", "Supplier");
				return;
			} */

			vm.po.supplierId = vm.selectedSupplier.id;
			vm.po.supplierCode = vm.selectedSupplier.code;
			vm.po.supplierName = vm.selectedSupplier.name;
			vm.po.supplierAddress1 = vm.selectedSupplier.address1;
			vm.po.supplierAddress2 = vm.selectedSupplier.address2;
			vm.po.supplierAddress3 = vm.selectedSupplier.address3;
			vm.po.supplierState = vm.selectedSupplier.state;
			vm.po.supplierPostCode = vm.selectedSupplier.postCode;
			vm.po.supplierCountry = vm.selectedSupplier.country;
			vm.po.supplierTel = vm.selectedSupplier.phone1;
			vm.po.supplierFax = vm.selectedSupplier.fax1;

			vm.loadItemList();

			vm.showSelectSupplier = false;
			toastr.info("Supplier information updated.", "Supplier");
		}

		vm.selectBranch = function() {
			/* if(vm.selectedBranch == null) {
				toastr.info("No changes is made.", "Ship-To (Branch)");
				return;
			} */

			vm.po.shipToBranchId = vm.selectedBranch.id;
			vm.po.shipToBranchName = vm.selectedBranch.name;
			vm.po.shipToContactPerson = vm.selectedBranch.contactPerson;
			vm.po.shipToAddress1 = vm.selectedBranch.address1;
			vm.po.shipToAddress2 = vm.selectedBranch.address2;
			vm.po.shipToAddress3 = vm.selectedBranch.address3;
			vm.po.shipToState = vm.selectedBranch.state;
			vm.po.shipToPostCode = vm.selectedBranch.postCode;
			vm.po.shipToCountry = vm.selectedBranch.country;
			vm.po.shipToTel = vm.selectedBranch.tel;
			vm.po.shipToFax = vm.selectedBranch.fax;

			vm.showSelectBranch = false;
			toastr.info("Ship-To information updated.", "Ship-To");
		}

		/* ****************************************************** */

		// Get Total Food Cost
		vm.getTotalPrice = function () {
			vm.subTotalTotal = 0;
			vm.gstTotal = 0;
			vm.totalIncGstTotal = 0;

			try {
				vm.po.purchaseOrderItems.forEach(function(p) {
					if(!p.isDeleted)
					{
						vm.subTotalTotal += parseFloat(p.subtotal);
						vm.gstTotal += parseFloat(p.tax);
						vm.totalIncGstTotal += parseFloat(p.subtotalIncTax);
					}
				});
			} catch (ex) {
				console.log(ex);
			}
		}

		/* ****************************************************** */

		// Remove Item
		vm.removeItem = function(index) {
			vm.po.purchaseOrderItems.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};

		vm.markAsDelete = function(index, id) {

			HttpSvc.post('purchaseorders/item/markasdelete/' + id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.po.purchaseOrderItems[index].isDeleted = true;
					//vm.po.purchaseOrderItems.splice(index, 1);
					toastr.success('Item has been removed.');
					//$scope.$broadcast('refreshStTable');
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		};

		// Update Item
		vm.updateItem = function(id, obj) {
			var element = {
				id: obj.id,
				purchaseOrderId: obj.purchaseOrderId,
				itemId: obj.itemId,
				item: {
					code: obj.itemCode,
					description: obj.itemDescription,
				},
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
                    name: obj.unitOfMeasurement.name
				},
				quantity: obj.quantity,
				quantityFulfilled: obj.quantityFulfilled,
				quantityWriteOff: obj.quantityWriteOff,
				cost: obj.cost,
				tax: obj.tax,
				taxPercent: obj.taxPercent,
				costIncGst: obj.costIncGst,
				subtotal: obj.subtotal,
				subtotalIncTax: obj.subtotalIncTax,
				taxCode: obj.taxCode,
				taxable: obj.taxable,
				remarks: obj.remarks,
				createdDate: obj.createdDate,
				createdBy: obj.createdBy,
				isReceived: obj.isReceived,
				isDeleted: false,
			};

			for(var i=0; i<vm.po.purchaseOrderItems.length; i++)
			{
				var p = vm.po.purchaseOrderItems[i];
				if(p.id==id)
				{
					var isFound = false;
					// vm.po.purchaseOrderItems.forEach(function(x) {
					// 	if(x.itemId==obj.itemId && x.id!=p.id)
					// 	{
					// 		isFound=true;
					// 	}
					// })
					if(isFound)
					{
						toastr.warning('Item already exists on the list. Please update the existing item instead.');
						return;
					}

					vm.po.purchaseOrderItems.splice(i, 1, element);
					vm.getTotalPrice();
					return;
				}
			}
		};

		// Add Item
		vm.addItem = function(obj) {
			var element = {
				id: UtilSvc.generateGuid(),
				itemId: obj.itemId,
				item: {
					code: obj.itemCode,
					description: obj.itemDescription,
				},
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
                    name: obj.unitOfMeasurement.name
				},
				quantity: obj.quantity,
				quantityFulfilled: 0,
				quantityWriteOff: 0,
				cost: obj.cost,
				tax: obj.tax,
				taxPercent: obj.taxPercent,
				costIncGst: obj.costIncGst,
				subtotal: obj.subtotal,
				subtotalIncTax: obj.subtotalIncTax,
				taxCode: obj.taxCode,
				taxable: obj.taxable,
				remarks: obj.remarks,
				isDeleted: false,
				isReceived: false,
			};

			var isFound = false;
			// vm.po.purchaseOrderItems.forEach(function(i) {
			// 	if(i.itemId==obj.itemId)
			// 	{
			// 		isFound=true;
			// 	}
			// })
			if(isFound)
			{
				toastr.warning('Item already exists on the list.');
				return;
			}

			// vm.po.purchaseOrderItems.push(element);
			vm.po.purchaseOrderItems.unshift(element);
			vm.getTotalPrice();
		};

		/* ****************************************************** */

		vm.item	= {};
		vm.showAddItemModal = function () {
			vm.item = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'PurchaseOrderItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.item,
							supplierId: vm.po.supplierId,
							itemList: vm.itemList,
							uomList: vm.uomList,
							currencyCode: vm.selectedSupplier.currencyCode
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};

		vm.showEditItemModal = function (id) {

			vm.item = {};
			vm.po.purchaseOrderItems.forEach(function(p) {
				if(p.id==id) vm.item = angular.copy(p);
			});

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'PurchaseOrderItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
							supplierId: vm.po.supplierId,
							itemList: vm.itemList,
							uomList: vm.uomList,
							currencyCode: vm.selectedSupplier.currencyCode
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(id, data);
				}, function () {
				});
		};

		/* ****************************************************** */

		vm.showEmailModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'emailModal.html',
				controller: 'PurchaseOrderEmailModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							poId: vm.po.id,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

		/* ****************************************************** */

		// Print PO
		vm.printPurchaseOrder = function() {
			var filename = vm.po.purchaseOrderNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('purchaseorders/print/' + vm.po.id, Auth.getTokenId(), filename)
				.then(
					null,
					function(error) {
						// Failed
						toastr.error('Failed to print the Purchase Order. ' + error, '');
						return null;
					});
		};

		vm.exportPurchaseOrder = function() {

			var filename = vm.po.purchaseOrderNo.replace("/", "_") + ".xlsx";

			HttpSvc.getExcelObject('purchaseorders/export/' + $stateParams.id, Auth.getTokenId(), filename)
				.then(
					null,
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to export the Purchase Order to Excel.', 'Failed');
						return null;
					});
		};

		// Approve PO
		vm.approvePurchaseOrder = function() {
			vm.lockButtons = true;

			HttpSvc.put('purchaseorders/approve/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.checkResult(result, 'approved');
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		};

		// Cancel Purchase Order
		vm.cancelPurchaseOrder = function() {
			vm.lockButtons = true;

			HttpSvc.put('purchaseorders/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Purchase Order has been cancelled.');
					$state.go('purchaseorders.polist');
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}

		// Finalize Purchase Order
		vm.finalizePurchaseOrder = function() {
			vm.lockButtons = true;

			HttpSvc.post('purchaseorders/finalizeforce/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Purchase Order has been finalized.');
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}

		// Form Submission
		vm.submit = function() {
			vm.lockButtons = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {
				if(vm.departments.selected) {
					vm.po.departmentId = vm.departments.selected.id;
				} else {
					vm.po.departmentId = null;
				}
                if (vm.poStatuses.selected) {
                    vm.po.status = vm.poStatuses.selected.id;
                } else {
                    vm.po.status = vm.po.status.toUpperCase();
                }
				HttpSvc.put('purchaseorders/' + $stateParams.id, vm.po, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result, 'updated');
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}

		vm.checkResult = function(result, status)
		{
			if(result.httpStatusCode=="200")
			{
				toastr.success('Purchase Order has been ' + status + ' successfully.', Auth.translate('SUCCESS'));
				$state.reload();
			}
			else if(result.httpStatusCode=="400")
			{
				toastr.error(result.message, Auth.translate('ERROR'));
				vm.lockButtons = false;
			}
			else
			{
				toastr.success('Purchase Order has been approved successfully.', Auth.translate('SUCCESS'));
				$state.reload();
			}
		}

		// Call Actions
		vm.initData();
	}

	// Item Modal Controller
	function PurchaseOrderItemModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.itemList = item.itemList;
		$mdl.item = item.object;
		$mdl.supplierId = item.supplierId;
		$mdl.currencyCode = item.currencyCode;
		$mdl.selectedItem = null;
		$mdl.selectedPrice = null;
		$mdl.priceList = [];

		/* ************************************************************* */

		$mdl.onSelectedItemChanged = function(isUpdate) {
			$mdl.item.itemId = $mdl.selectedItem.id;
			$mdl.item.itemCode = $mdl.selectedItem.code;
			$mdl.item.itemDescription = $mdl.selectedItem.description;

			HttpSvc.get('itemprices/list/' + $mdl.item.itemId + '/supplier/' + $mdl.supplierId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.priceList = result;

					if(!isUpdate && $mdl.priceList.length > 0)
					{
						$mdl.selectedPrice = $mdl.priceList[0];

						$mdl.item.quantity = $mdl.selectedPrice.quantity;
						$mdl.item.taxCode = ($mdl.selectedPrice.taxCode=="" ? "ZP" : $mdl.selectedPrice.taxCode);
						$mdl.item.taxable = '';
						$mdl.item.cost = $mdl.selectedPrice.cost;
						$mdl.item.tax = $mdl.selectedPrice.tax;
						$mdl.item.taxPercent = $mdl.selectedPrice.taxPercent;
						$mdl.item.costIncGst = $mdl.selectedPrice.costIncGst;
						$mdl.item.subtotal = $mdl.selectedPrice.cost * $mdl.selectedPrice.quantity;
						$mdl.item.subtotalIncTax = $mdl.item.subtotal + $mdl.item.tax;
						$mdl.item.unitOfMeasurementId = $mdl.selectedPrice.unitOfMeasurementId;
						$mdl.item.unitOfMeasurement.name = $mdl.selectedPrice.uomName;
					}
					else if(isUpdate)
					{
						if($mdl.item.unitOfMeasurementId!='' && $mdl.item.unitOfMeasurementId!=null){
							$mdl.priceList.forEach(function (i) {
								if(i.unitOfMeasurementId==$mdl.item.unitOfMeasurementId) {
									$mdl.selectedPrice = i;
								}
							});
						};
					}
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Supplier Pricing List.', '');
					return null;
				});
		};

		$mdl.onQuantityChanged = function()
		{
			$mdl.recalculate();
		};

		$mdl.onCostChanged = function()
		{
			$mdl.recalculate();
		};

		$mdl.onTaxPercentChanged = function()
		{
			$mdl.recalculate();
		};

		$mdl.onSelectedUomChanged = function() {
			$mdl.item.taxCode = ($mdl.selectedPrice.taxCode=="" ? "ZP" : $mdl.selectedPrice.taxCode);
			$mdl.item.taxable = '';
			$mdl.item.cost = $mdl.selectedPrice.cost;
			$mdl.item.tax = $mdl.selectedPrice.tax;
			$mdl.item.taxPercent = $mdl.selectedPrice.taxPercent;
			$mdl.item.costIncGst = $mdl.selectedPrice.costIncGst;
			$mdl.item.subtotal = $mdl.selectedPrice.cost * $mdl.selectedPrice.quantity;
			$mdl.item.subtotalIncTax = $mdl.item.subtotal + $mdl.item.tax;
			$mdl.item.unitOfMeasurementId = $mdl.selectedPrice.unitOfMeasurementId;
			$mdl.item.unitOfMeasurement.name = $mdl.selectedPrice.uomName;

			$mdl.recalculate();
		};

		$mdl.recalculate = function () {
			$mdl.item.tax = $mdl.item.cost * ($mdl.item.taxPercent / 100);
			$mdl.item.tax = Math.round($mdl.item.tax * 10000) / 10000;
			$mdl.item.tax = Math.round($mdl.item.tax * 1000) / 1000;
			$mdl.item.tax = Math.round($mdl.item.tax * 100) / 100;

			$mdl.item.costIncGst = $mdl.item.cost + $mdl.item.tax;

			$mdl.item.tax = $mdl.item.cost * $mdl.item.quantity * ($mdl.item.taxPercent / 100);
			$mdl.item.tax = Math.round($mdl.item.tax * 10000) / 10000;
			$mdl.item.tax = Math.round($mdl.item.tax * 1000) / 1000;
			$mdl.item.tax = Math.round($mdl.item.tax * 100) / 100;

			$mdl.item.subtotal = $mdl.item.cost * $mdl.item.quantity;
			$mdl.item.subtotal = Math.round($mdl.item.subtotal * 10000) / 10000;
			$mdl.item.subtotal = Math.round($mdl.item.subtotal * 1000) / 1000;
			$mdl.item.subtotal = Math.round($mdl.item.subtotal * 100) / 100;

			$mdl.item.subtotalIncTax = $mdl.item.subtotal + $mdl.item.tax;
			$mdl.item.subtotalIncTax = Math.round($mdl.item.subtotalIncTax * 10000) / 10000;
			$mdl.item.subtotalIncTax = Math.round($mdl.item.subtotalIncTax * 1000) / 1000;
			$mdl.item.subtotalIncTax = Math.round($mdl.item.subtotalIncTax * 100) / 100;
		}

		/* ************************************************************* */

		// Initialize
		if(item.mode==1) {
			$mdl.item.itemId = "";
			$mdl.item.itemCode = "";
			$mdl.item.itemDescription = "";
			$mdl.item.unitOfMeasurementId = "";
			$mdl.item.unitOfMeasurement = {};
			$mdl.item.uomName = "";
			$mdl.item.quantity = 0;
			$mdl.item.tax = 0;
			$mdl.item.taxPercent = 0;
			$mdl.item.cost = 0;
			$mdl.item.costIncGst = 0;
			$mdl.item.subtotal = 0;
			$mdl.item.subtotalIncTax = 0;
			$mdl.item.taxCode = "";
			$mdl.item.taxable = "";
		} else {
			if($mdl.item.itemId!='' && $mdl.item.itemId!=null){
				$mdl.itemList.forEach(function (i) {
					if(i.id==$mdl.item.itemId) {
						$mdl.selectedItem = i;
						$mdl.onSelectedItemChanged(true);
					}
				});
			};
			// if($mdl.item.unitOfMeasurementId!='' && $mdl.item.unitOfMeasurementId!=null){
			// 	$mdl.uomList.forEach(function (i) {
			// 		if(i.id==$mdl.item.unitOfMeasurementId) {
			// 			$mdl.selectedUom = i;
			// 			$mdl.item.uomName = i.name;
			// 		}
			// 	});
			// };
		}

		/* ************************************************************* */

		$mdl.confirmModal = function()
		{
			if(!$mdl.itemForm.$valid)
			{
				toastr.error('Please fill up all the required fiels.', Auth.translate('ERROR'));
			}
			else
			{
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	// Email Modal Controller
	function PurchaseOrderEmailModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.poId = item.poId;
		$mdl.template = {};
		$mdl.lockButtons = false;

		$mdl.initData = function() {
			HttpSvc.get('emailtemplates/purchaseorder/' + $mdl.poId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.template = result;
				}, function(error) {
					toastr.error(error, 'Failed');
					$mdl.cancelModal();
				});
		}

		$mdl.sendEmail = function() {
			HttpSvc.put('purchaseorders/email/' + $mdl.poId, $mdl.template, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success("Email sent successfully.", Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function(error) {
					toastr.error(error, 'Failed');
					$mdl.lockButtons = false;
				});
		}

		$mdl.confirmModal = function() {
			var isValid = true;
			$mdl.lockButtons = true;
			$mdl.itemForm.$submitted = true;

			// Check TO
			if($mdl.template.to=="" || $mdl.template.to==null) {
				$mdl.itemForm.TO.$error.required = true;
				isValid = false;
			} else {
				$mdl.itemForm.TO.$error.required = false;
			}
			// Check Subject
			if($mdl.template.subject=="" || $mdl.template.subject==null) {
				$mdl.itemForm.Subject.$error.required = true;
				isValid = false;
			} else {
				$mdl.itemForm.Subject.$error.required = false;
			}
			// Check Content
			if($mdl.template.subject=="" || $mdl.template.subject==null) {
				$mdl.itemForm.Subject.$error.required = true;
				isValid = false;
			} else {
				$mdl.itemForm.Subject.$error.required = false;
			}

			if(isValid) {
				$mdl.sendEmail();
			} else {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				$mdl.lockButtons = false;
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		$mdl.initData();
	};

	/** @ngInject */
	function PurchaseOrderDownloadExcelModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
		var $mdl = this;

		$mdl.batchList = [];
		$mdl.isLoading = false;
		$mdl.selectedBatchId = null;
		$mdl.batchId = null;

		// ********************************************************

		$mdl.loadData = function() {
			$mdl.isLoading = true;

			HttpSvc.get('purchaseorders/list/batchid', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.batchList = result;
					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		// ********************************************************

		$mdl.selectedBatchIdChanged = function() {
		    $mdl.batchId = $mdl.selectedBatchId;
		}

		// ********************************************************

		$mdl.downloadExcel = function() {
			$mdl.isLoading = true;
			var filename = "RMS_PurchaseOrder_Batch_" + $filter('date')(new Date(), 'yyyyMMddhhmmss');

			HttpSvc.getExcelObject("purchaseorders/exportac", Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isLoading = false;
					$mdl.loadData();
					//$uibModalInstance.dismiss('cancel');
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate Excel');
					return null;
				});
		}

		$mdl.downloadExcelPast = function() {
			if($mdl.selectedBatchId == null)
			{
				toastr.warning("Please select a Batch Number to download.");
				return;
			}

			$mdl.isLoading = true;

			var filename = "RMS_PurchaseOrder_" + $mdl.batchId;

			HttpSvc.getExcelObject("purchaseorders/reexportac/" + $mdl.batchId, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isLoading = false;
					//$uibModalInstance.dismiss('cancel');
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('No record found.', 'Failed to generate Excel');
					return null;
				});
		}

		// ********************************************************

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// ********************************************************

		$mdl.loadData();
	};

})();


(function() {
    'use strict';

    angular.module('RmsAppV2.pages.recipes.cards.controller', [])
        .controller('RecipeCardCategoriesCtrl', RecipeCardCategoriesCtrl)
        .controller('RecipeCardRecipesCtrl', RecipeCardRecipesCtrl)
        .controller('RecipeCardViewCtrl', RecipeCardViewCtrl)
		.controller('RecipeCardShareDialogCtrl', RecipeCardShareDialogCtrl)	
		.controller('RecipeCardSensorDialogCtrl', RecipeCardSensorDialogCtrl)
        .controller('RecipeQuickSearchDialogCtrl', RecipeQuickSearchDialogCtrl);

    /** @ngInject */
    function RecipeCardCategoriesCtrl($scope, $filter, $state, $q, $timeout, $uibModal, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();		
		
		var vm = this;
		vm.cateDataFull = [];
		vm.cateData = [];
		vm.numOfRecord = 0;
		vm.useLainoxNaboo = false;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.isLoading = false;
		vm.isSearching = false;
		
		vm.initData = function() {
			vm.useLainoxNaboo = Auth.getSetting_Recipe_UseLainoxNaboo();
			vm.retrieveData();
		}
		
		vm.retrieveData = function() {	
			vm.isLoading = true;

			HttpSvc.get('recipecategories/list/card', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.numOfRecord = result.length;	
					vm.cateDataFull = result;
					vm.cateDataFull.forEach(function(cat) {
						if(!cat.imageLocation || cat.imageLocation=='') {
							cat.imageLocation = 'assets/img/empty_placeholder.png';
							cat.thumbnail = 'assets/img/empty_placeholder.png';
						} else {
							cat.imageLocation = vm.rootUrl + cat.imageLocation;
							if(!cat.thumbnail){
								cat.thumbnail = null;
							} else {
								cat.thumbnail = vm.rootUrl + cat.thumbnail;
							}
						}
					});
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		vm.searchForText = function() {
			vm.isSearching = true;

			$timeout(function() { 
				vm.searchText = vm.searchTextOri;
				vm.isSearching = false;
			}, 300);
		}
		
		vm.exportLainox = function() {
			var filename = "RECIPE_EXCEL_FOR_LAINOX_CLOUD.xlsx";
			
			HttpSvc.getExcelObject('recipes/exportLainox', Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to generate the Excel. ' + error, '');
							return null;
						});
		}

		/* **************************************************************** */

		vm.showSearchRecipeDialog = function() {

			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'SearchRecipeModal.html',
				controller: 'RecipeQuickSearchDialogCtrl',
				controllerAs: '$mdl',
				size: 'lg',
			});
	
			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		}

		/* **************************************************************** */

		// Call Actions
		vm.initData();		
	};
	
	/** @ngInject */
    function RecipeCardRecipesCtrl($scope, $filter, $state, $stateParams, $q, $timeout, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();		
		
		var vm = this;
		vm.category = {};
		vm.recipeDataFull = [];
		vm.recipeData = [];
		vm.numOfRecord = 0;
		vm.useLainoxNaboo = false;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.isLoading = false;
		vm.isSearching = false;
		
		vm.initData = function() {
			vm.useLainoxNaboo = Auth.getSetting_Recipe_UseLainoxNaboo();
			vm.loadCategory();
		}
		
		// Load Recipe Category
		vm.loadCategory = function() {
			HttpSvc.get('recipecategories/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.category = result;
					vm.loadData();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Category.', '');
					$state.go('recipes.cards.categories');
					return null;
				});
		};
		
		// Load List
		vm.loadData = function() {	
			if(vm.categoryId=="") return;
			
			vm.isLoading = true;
			
			HttpSvc.get('recipes/list/card/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					//vm.recipeDataFull = result;
					result.forEach(function(r) {
						if(r.isApproved && r.isPublic) {
							if(!r.imageLocation || r.imageLocation=='') {
								r.imageLocation = 'assets/img/empty_placeholder.png';
								r.thumbnail = 'assets/img/empty_placeholder.png';
							} else {
								r.imageLocation = vm.rootUrl + r.imageLocation;
								if(!r.thumbnail){
									r.thumbnail = null;
								} else {
									r.thumbnail = vm.rootUrl + r.thumbnail;
								}
							}
							vm.recipeDataFull.push(r);
						}
					});
					vm.numOfRecord = vm.recipeDataFull.length;	

					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					$state.go('recipes.cards.categories');
					return null;
				});
		};		

		vm.searchForText = function() {
			vm.isSearching = true;

			$timeout(function() { 
				vm.searchText = vm.searchTextOri;
				vm.isSearching = false;
			}, 300);
		}

		vm.exportLainox = function() {
			var filename = "RECIPE EXCEL FOR LAINOX CLOUD(" + vm.category.name + ".xlsx";
			
			HttpSvc.getExcelObject('recipes/exportLainox/' + $stateParams.id, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to generate the Excel. ' + error, '');
							return null;
						});
		}

		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function RecipeCardViewCtrl($scope, $state, $stateParams, $sce, $filter, $timeout, $interval, $uibModal, Auth, HttpSvc, RmsApi, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.recipe = {};
		vm.ingredients = [];
		vm.childRecipes = [];
		vm.batch = 1;
		vm.prodQty = 1;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.hasSmartKitchenModule = Auth.hasCompanyFeature('smartkitchen');
		vm.ingredientGroup = [];
		vm.canAccessFoodCost = false;
		vm.canAccessIngredient = false;

		vm.currentStep = null;
		vm.isRunning = false;
		vm.selectedTab1 = true;
		vm.selectedTab2 = false;
		vm.showView1 = true;
		vm.showView2 = false;
		vm.timeout = null;
		vm.selectedSensor = null;
		vm.sensorStats = null;
		vm.interval = null;
		vm.proceedNextStep = false;
		
		vm.initData = function() {
			vm.canAccessFoodCost = Auth.canAccessFoodCost();
			vm.canAccessIngredient = Auth.canAccessIngredient();
			vm.loadRecipe();
		};
		
		// Go Back
		vm.goBack = function() {
			window.history.back();
		}

		vm.goToView1 = function() {
			vm.showView1 = true;
			vm.showView2 = false;
			$timeout.cancel(vm.timeout);
		}

		vm.goToView2 = function() {
			vm.showView1 = false;
			vm.showView2 = true;
			
			vm.restart();
			vm.checkTemperatureControl();
		}
		
		// Batch No Changed
		vm.batchChanged = function() {
			if(!angular.isNumber(vm.batch)) {
				vm.batch = 1;
			}
			if(vm.batch<=0) {
				vm.batch = 1;
			}
			vm.prodQty = vm.batch * vm.recipe.productionQuantity;
			vm.prodQty = parseFloat(vm.prodQty.toFixed(3));
			
			vm.ingredients.forEach(function (i) {
				i.displayQty = i.quantity * vm.batch;
				i.displayQty = parseFloat(i.displayQty.toFixed(3));
			});	
			
			vm.childRecipes.forEach(function(r) {
				r.childRecipeDisplayQty = r.childRecipeQty * vm.batch;
				r.childRecipeDisplayQty = parseFloat(r.childRecipeDisplayQty.toFixed(3));
					
				r.childRecipeItems.forEach(function(x) {
					x.displayQty = x.quantity * vm.batch;
					x.displayQty = parseFloat(x.displayQty.toFixed(3));
				});
			})
			//$scope.$broadcast('refreshStTable');
		};
		
		// Adjust Batch Quantity
		vm.adjustBatch = function(qty) {
			vm.batch = vm.batch + qty;
			vm.batchChanged();
		};
		
		// Start Step
		vm.startStep = function() {
			baSidebarService.setMenuCollapsed(true);
		}
		
		// Show Player
		vm.showPlayer = function(s) {
			s.showPlayer = true;
		};
		
		// Load Recipe
		vm.loadRecipe = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('recipes/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.recipe = result;
					vm.recipe.timeLapsed = 0;
					vm.recipe.totalTimeSecond = 0;
					vm.recipe.isStarted = false;
					vm.recipe.isCompleted = false;
					vm.prodQty = vm.recipe.productionQuantity;
					
					if(!vm.recipe.imageLocation || vm.recipe.imageLocation=='') {
						vm.recipe.imageLocation = 'assets/img/empty_placeholder_placeholder.png';
						vm.recipe.thumbnail = 'assets/img/empty_placeholder_placeholder.png';
						vm.recipe.oriImageLocation = "";
					} else {
						vm.recipe.imageLocation = vm.rootUrl + vm.recipe.imageLocation;
						if(!vm.recipe.thumbnail || vm.recipe.thumbnail==''){
							vm.recipe.thumbnail = null;
						} else {
							vm.recipe.thumbnail = vm.rootUrl + vm.recipe.thumbnail;
						}
					}		
					
					vm.recipe.recipeItems.forEach(function (i) {
						/* i.displayQty = i.quantity;						
						
						if(vm.ingredientGroup.map(function(e) { return e.groupName; }).indexOf(i.category)<0) {
							vm.ingredientGroup.push({ groupName: i.category });	
						} */
						
						if(i.childRecipeId!=null){
							vm.childRecipes.push({
								childRecipeId: i.childRecipeId,
								childRecipeName: i.childRecipeName,								
								childRecipeItems: i.childRecipeItems,
								childRecipeQty: i.quantity,
								childRecipeDisplayQty: i.quantity,
								childRecipeUom: i.unitOfMeasurement.name,
							});
							vm.childRecipes.forEach(function(r) {
								r.childRecipeItems.forEach(function(x) {
									x.displayQty = x.quantity;
								});
							})
						} else {							
							vm.ingredients.push({
								itemName: i.itemName,
								groupName: (i.category==null?'General Ingredients':i.category),
								quantity: i.quantity,
								displayQty: i.quantity,
								uom: i.unitOfMeasurement.name,
							});
						}
					});	
					
					vm.recipe.recipeSteps.forEach(function (c) {
						if(c.attachmentType!=null) {
							if(c.attachmentType=="youtube") {
								c.youtubeId = c.attachmentLocation;
								c.attachmentLocation = "http://www.youtube.com/embed/" + c.attachmentLocation;
							}
							
							if(c.attachmentType.substr(0,5)=='video') {								
								c.finalVimeoUrl = 
									$sce.trustAsResourceUrl("https://player.vimeo.com/video/" + c.vimeoVideoId);
							}
						}
						
						c.timeLapsed = 0;
						vm.recipe.totalTimeSecond += c.totalTimeSecond;
					});						
				}, function() {
					toastr.error('Failed to load selected Recipe.', Auth.translate('ERROR'))
					$state.go('recipes.cards.categories');
					return;
				});		
		};
			
		// Print Recipe
		vm.printRecipe = function(recipeId, recipeName, batchNo) {
			
			var filename = "RECIPE_" + recipeName.replace("/", "_").replace(" ", "_").replace("#", "") + ".pdf";
			
			HttpSvc.getPdfObject('recipes/print/' + recipeId + '/' + batchNo, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print Recipe. ' + error, '');
							return null;
						});
		}
			
		// Print Recipe
		vm.printRecipeSimple = function(recipeId, recipeName, batchNo) {
			
			var filename = "RECIPE_" + recipeName.replace("/", "_").replace(" ", "_").replace("#", "") + ".pdf";
			
			HttpSvc.getPdfObject('recipes/print/simple/' + recipeId + '/' + batchNo, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print Recipe. ' + error, '');
							return null;
						});
		}
			
		// Print Recipe
		vm.printFoodCost = function(recipeId, recipeName, batchNo) {
			
			var filename = "FOODCOST_" + recipeName.replace("/", "_").replace(" ", "_").replace("#", "") + ".pdf";
			
			HttpSvc.getPdfObject('recipes/print/foodcost/' + recipeId + '/' + batchNo, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print Food Cost. ' + error, '');
							return null;
						});
		}

		vm.showShareDialog = function() {

			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'shareDialogModal.html',
				controller: 'RecipeCardShareDialogCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							objectId: vm.recipe.id
						}
					}
				}
			});
	
			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		}

		/* **************************************************************************** */

		vm.sleep = function(ms) {
			return new Promise(function(resolve) {
			  	vm.timeout = $timeout(resolve, ms);
			});
		};
		
		/* *********************************************************** */

		vm.selectTab1 = function() {
			vm.selectedTab1 = true;
			vm.selectedTab2 = false;
		}
		
		vm.selectTab2 = function() {
			vm.selectedTab2 = true;
			vm.selectedTab1 = false;
		}

		/* *********************************************************** */

		vm.restart = function() 
		{			
			vm.recipe.isStarted = false;
			vm.recipe.isCompleted = false;
			vm.recipe.timeLapsed = 0;

			for(var x = 0; x < vm.recipe.recipeSteps.length; x++)
			{
				var s = vm.recipe.recipeSteps[x];
				s.isStarted = false;
				s.isCompleted = false;
				s.timeLapsed = 0;
			}
		}

		vm.startJob = function(isNew) {
			vm.recipe.isStarted = true;
			vm.isRunning = true;
			vm.selectTab2();

			//if(isNew) Auth.tts("Job started.");
			
			vm.sleep(1000).then(function() {
				vm.delayStartJob();
			});
		}

		vm.delayStartJob = function() {

			var isFound = false;
			
			for( var x = 0; x < vm.recipe.recipeSteps.length; x++)
			{
				var s = vm.recipe.recipeSteps[x];

				if(s.isCompleted != true)
				{
					vm.currentStep = s;
					s.isStarted = true;
					isFound = true;

					if(!s.enableTemperatureControl)
					{
						//Auth.tts('Step ' + (s.step+1) + '. ' + s.description);
	
						vm.sleep(500).then(function() { 
							vm.workOnStep(s);
						});
					}
					else
					{
						vm.startSensorMonitoring(s);
					}

					break;
				}
			};

			if(!isFound)
			{
				vm.recipe.isCompleted = true;

				//Auth.tts('Job completed');
			}
		}

		vm.completeJob = function() {
			vm.showView1 = true;
			vm.showView2 = false;
		}

		vm.workOnStep = function(s) {
			
			if(s.timeLapsed < s.totalTimeSecond)
			{
				s.timeLapsed += 1;
				vm.recipe.timeLapsed += 1;

				if(s.timeLapsed == s.totalTimeSecond)
				{
					vm.sleep(900).then(function() { 
						s.isCompleted = true;
					});					
				}
			
				vm.sleep(1000).then(function() { 
					vm.workOnStep(s);
				});
			}
			else
			{
				vm.completeStep(s);
				vm.delayStartJob();
			}
		}

		vm.completeStep = function(s) {

			vm.sleep(500).then(function() { 
				s.isCompleted = true;
			});
		}

		/* *********************************************************** */

		vm.checkTemperatureControl = function() 
		{
			var result = false;
			
			vm.recipe.recipeSteps.forEach(function(s) {
				if(s.enableTemperatureControl==true)
				{
					result = true;
				}
			});

			if(result)
			{
				vm.showSensorSelectionDialog();
			}
		}

		vm.showSensorSelectionDialog = function() {

			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'sensorDialogModal.html',
				controller: 'RecipeCardSensorDialogCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {}
					}
				}
			});
	
			modalInstance
				.result
				.then(function (data) {
					vm.selectedSensor = data;
				}, function () {
				});	
		}

		vm.cancelSelectSensor = function() {
			vm.selectedSensor = null;
		}

		vm.startSensorMonitoring = function(step) {
			vm.interval = $interval(function() {
				vm.checkCurrentTemperature(step)
			}, 3000);
		}

		vm.checkCurrentTemperature = function(step) {

			var startDate = new Date();
			startDate.setTime(startDate.getTime() - (1*30*60*1000)); 
			startDate = new Date(startDate.setDate(startDate.getDate()));
			startDate = $filter('date')(startDate, 'dd-MM-yyyy hh:mma');

			var endDate = new Date();
			endDate.setDate(endDate.getDate())
			endDate = $filter('date')(endDate, 'dd-MM-yyyy hh:mma');

			var params = {
				dateFrom: startDate,
				dateTo: endDate
			}

			HttpSvc.post('smartiot/datahub/stats/sensor/' + vm.selectedSensor.id, params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.sensorStats = result;
					
					console.log (vm.sensorStats.temperature + '|' + step.targetTemperatureCelcius);
					
					if(vm.sensorStats.temperature >= step.targetTemperatureCelcius)
					{
						$interval.cancel(vm.interval);
						vm.interval = null;
						vm.proceedNextStep = true;
						
						vm.sleep(3000).then(function() { 
							step.isCompleted = true;
							vm.startJob();
						});
					}
				}, function() {
					toastr.error('Failed to load the sensor stats.', Auth.translate('ERROR'))
					return;
				});	
		}

		/* *********************************************************** */

		vm.convertStoMs = function(seconds) {
			var minutes = Math.floor(seconds / 60);
			var extraSeconds = seconds % 60;
			minutes = minutes < 10 ? "0" + minutes : minutes;
			extraSeconds = extraSeconds< 10 ? "0" + extraSeconds : extraSeconds;
			return minutes + "m " + extraSeconds + "s";
		}

		/* **************************************************************************** */
				
        $scope.$on('$destroy', function() {
            $timeout.cancel(vm.timeout);
            $interval.cancel(vm.interval);
        });

		// Call Actions
		vm.initData();
	}
    
    /** @ngInject */
    function RecipeCardSensorDialogCtrl($uibModalInstance, $timeout, Auth, RmsApi, HttpSvc, UtilSvc, item, toastr) {
		var $mdl = this;
  
		$mdl.item = {};		
		$mdl.sensorList = [];
		$mdl.selectedSensor = null;
		$mdl.lockButton = false;
		$mdl.isLoading = false;
  
		/* ********************************************************* */

		$mdl.initData = function() {
			$mdl.isLoading = true;

			HttpSvc.get('smartiot/sensors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.sensorList = result;
					$mdl.isLoading = false;
				}, function() {
					toastr.error('Failed to load the sensor list.', Auth.translate('ERROR'))
					return;
				});	
		}
  
		/* ********************************************************* */

		$mdl.selectSensor = function(sensor) {
			$mdl.selectedSensor = sensor;
		}
  
		/* ********************************************************* */
						  
		$mdl.confirmModal = function() {
			$uibModalInstance.close($mdl.selectedSensor);
		};
		
		// Cancel Action
		$mdl.cancelModal = function() {
		  $uibModalInstance.dismiss('cancel');
		};
  
		/* ********************************************************* */

		$mdl.initData();
	};	
    
    /** @ngInject */
    function RecipeCardShareDialogCtrl($uibModalInstance, $timeout, Auth, RmsApi, HttpSvc, UtilSvc, item, toastr) {
		var $mdl = this;
  
		$mdl.objectId = item.objectId;
		$mdl.item = {};
		$mdl.errorMsg = "";
		$mdl.showError = false;
		$mdl.showSuccess = false;
		$mdl.lockButton = false;
  
		/* ********************************************************* */
						  
		$mdl.confirmModal = function() {
		  if($mdl.shareForm.$invalid) {
			$mdl.errorMsg = UtilSvc.getErrorMessage($mdl.shareForm);          
			$mdl.showError = true;
		  } else {
			$mdl.lockButton = true;
			$mdl.showError = false;
  
			$mdl.item.objectType = "RECIPE";
			$mdl.item.objectId = $mdl.objectId;
  
			HttpSvc.post('ezyshare', $mdl.item, Auth.getTokenId(), false)
			  .then(function(result) {
				$mdl.showSuccess = true;
				$timeout($uibModalInstance.close, 1500);
			  }, function(error) {
				$mdl.errorMsg = error;
				$mdl.showError = true;
				$mdl.lockButton = false;
			  });
		  }
		};
		
		// Cancel Action
		$mdl.cancelModal = function() {
		  $uibModalInstance.dismiss('cancel');
		};
	};	
    
    /** @ngInject */
    function RecipeQuickSearchDialogCtrl($uibModalInstance, Auth, RmsApi, HttpSvc, UtilSvc, toastr) {
		var $mdl = this;
  
		$mdl.recipeList = [];
		$mdl.searchText = "";
		$mdl.isLoading = false;
		$mdl.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
  
		/* ********************************************************* */
						  
		$mdl.searchRecipe = function() {
			$mdl.isLoading = true;

			HttpSvc.post('recipes/listByCompany/' + encodeURIComponent($mdl.searchText), {}, Auth.getTokenId(), true)
			  	.then(function(result) {
					$mdl.recipeList = result;
					
					$mdl.recipeList.forEach(function(r) {
						if(r.thumbnail!=null && r.thumbnail!='') {
							r.thumbnail = $mdl.rootUrl + r.thumbnail;
						}
						if(r.imageLocation!=null && r.imageLocation!='') {
							r.imageLocation = $mdl.rootUrl + r.imageLocation;
						}
					});					

					$mdl.isLoading = false;
			  	}, function(error) {
					toastr.error(error, "Search Failed");
					$mdl.isLoading = false;
			  	});
		};
		
		// Cancel Action
		$mdl.cancelModal = function() {
		  	$uibModalInstance.dismiss('cancel');
		};
	};	

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.receivings.grnlist.controller', [])
        .controller('ReceivingsGrnMainCtrl', ReceivingsGrnMainCtrl)
        .controller('ReceivingsGrnCreateCtrl', ReceivingsGrnCreateCtrl)
        .controller('ReceivingsGrnUpdateCtrl', ReceivingsGrnUpdateCtrl)
        .controller('ReceivingItemModalCtrl', ReceivingItemModalCtrl)
        .controller('ReceivingItemPhotoModalCtrl', ReceivingItemPhotoModalCtrl)
        .controller('ReceivingsGrnLabelModalCtrl', ReceivingsGrnLabelModalCtrl)
        .controller('ReceivingsGrnDownloadExcelModalCtrl', ReceivingsGrnDownloadExcelModalCtrl);

    /** @ngInject */
    function ReceivingsGrnMainCtrl($scope, $filter, $state, $uibModal, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.isRmsLite = Auth.isLiteMode();
		vm.isRmsStarter = Auth.isStarterMode();

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.dataFull = [];
		vm.data = [];
		vm.isLoading = false;

		vm.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}
			
			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.receivingNo,
				createdDate: predicate.createdDate,
				supplierName: predicate.supplierName,
				supplierDocNo: predicate.supplierDoNo,
				purchaseOrderNo: predicate.purchaseOrderNo,
				branchName: predicate.branchName,
				storageName: predicate.storageName,
				createdBy: predicate.createdBy,
				isLabelPrinted: predicate.isLabelPrinted,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('receivings/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isLoading = false;		
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;	
					vm.numOfPages = result.numberOfPages;	
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;		
			return tableState;
		};

		vm.resetSearch = function() 
		{
		}	
		
		/* ************************************************** */

		vm.showDownloadExcelModal = function () {
			vm.product = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'downloadModal.html',
				controller: 'ReceivingsGrnDownloadExcelModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};	
		
		vm.showLabelModal = function (grn) {
			
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'labelModal.html',
				controller: 'ReceivingsGrnLabelModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							receivingId: grn.id,
							receivingNo: grn.receivingNo,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};	
		
		vm.printGRN = function(rcvId, rcvNo) {
			
			var filename = rcvNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('receivings/print/' + rcvId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print GRN. ' + error, '');
							return null;
						});
		}
	};
	
	/** @ngInject */
    function ReceivingsGrnCreateCtrl($scope, $state, $filter, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;		
		vm.po = {};
		vm.grn = {};
		vm.grn.receivingItems = [];
		vm.lockButtons = false;
		vm.isShowPoList = false;
		vm.isPoSelected = false;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.poDataFull = [];
		vm.poData = [];
		vm.storageList = [];
		vm.selectedStorage = {};
		vm.isLoading = false;
		
		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.poDataFull, tableState.search.predicateObject) : vm.poDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.poData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			refreshTableState(tableState, vm.startIndex, vm.endIndex);
		};	
		
		// Load Item Receiving Storages
		vm.loadStorages = function() {
			HttpSvc.get('storages/listbytypes/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageList = result;
				}, function(error) {
					toastr.error('Failed to load Storage list. ' + error, 'Failed');
				});
		}
		
		// Load Purchase Order List
		vm.showPoList = function() {		
			vm.isLoading = true;
			vm.isShowPoList = false;
			
			HttpSvc.get('purchaseorders/list/approved', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.isLoading = false;
					vm.isShowPoList = true;
					vm.numOfRecord = result.length;	
					vm.poDataFull = result;		
				}, function() {	
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});		
		}
		
		vm.closePoList = function() {
			vm.isShowPoList = false;
		}
		
		vm.selectPo = function(poId) {
			
			/* vm.poDataFull.forEach(function(p) {
				if(p.id==poId) {
					vm.po = p;
					vm.isPoSelected = true;
					vm.isShowPoList = false;
				}
			}); */
			
			HttpSvc.get('purchaseorders/' + poId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isPoSelected = true;
					vm.isShowPoList = false;
					vm.po = result;
					
					var poItems = [];
					vm.po.purchaseOrderItems.forEach(function(p) {
						poItems.push(p);
					});
					
					vm.po.purchaseOrderItems = [];
					poItems.forEach(function(p) {
						if(p.quantity > p.quantityFulfilled) {
							vm.po.purchaseOrderItems.push(p);
						}
					});
					
				}, function(error) {
					vm.isPoSelected = false;
					toastr.error(error, 'Failed');
				});
		}
		
		// Form Submission
		vm.submit = function() {
			if(!vm.validateItems()){
				toastr.warning('You must receive at least ONE item.', 'Warning');
				return;
			}
			
			vm.grn.purchaseOrderId = vm.po.id;
			vm.grn.storageId = vm.selectedStorage.id;
			
			vm.grn.receivingItems = [];
			vm.po.purchaseOrderItems.forEach(function(i) {				
				if(!i.receivedQuantity || i.receivedQuantity<=0) {
				} else {
					vm.grn.receivingItems.push({
						purchaseOrderItemId: i.id,
						itemId: i.itemId,
						quantity: i.receivedQuantity,
						unitOfMeasurementId: i.unitOfMeasurementId,
						temperature: i.temperature,
						remarks: i.remarks,
						rejectRemark: '',
						photoAttachment: ''
					});
				}
			});
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				HttpSvc.post('receivings/add', vm.grn, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Item received (GRN) successfully.', Auth.translate('SUCCESS'));
						$state.go('receivings.grnlist');
					}, function(error) {
						vm.grn.receivingItems = [];
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Validate if at least ONE item is filled in QTY
		vm.validateItems = function() {
			var isFilled = false;
			
			vm.po.purchaseOrderItems.forEach(function(i) {				
				if(!i.receivedQuantity || i.receivedQuantity<=0) {
				} else {
					isFilled = true;
				}
			});
			
			return isFilled;
		}
		
		// Call Actions
		vm.loadStorages();
	}
	
	/** @ngInject */
    function ReceivingsGrnUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.grn = {};			
		vm.storageList = [];
		vm.selectedStorage = {};
		vm.isLoading = false;
		
		// Load Item Receiving Storages
		vm.loadStorages = function() {
			HttpSvc.get('storages/listbytypes/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageList = result;
					vm.loadGrn();
				}, function(error) {
					toastr.error('Failed to load Storage list. ' + error, 'Failed');
				});
		}
		
		// Load GRN
		vm.loadGrn = function() {
			HttpSvc.get('receivings/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.grn = result;
					
					vm.storageList.forEach(function(s) {
						if(s.id==vm.grn.storageId) {
							vm.selectedStorage = s;
						}
					});
				}, function(error) {
					toastr.error('Failed to load GRN. ' + error, 'Failed');
				});
		}
		
		vm.printGRN = function(rcvId, rcvNo) {
			
			var filename = rcvNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('receivings/print/' + rcvId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print GRN. ' + error, '');
							return null;
						});
		}	
		
		vm.cancelGRN = function(rcvId, rcvNo) {
			if(!confirm('Are you sure you want to cancel this GRN ?')) return;
			
			HttpSvc.post('receivings/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('GRN cancelled successfully.', Auth.translate('SUCCESS'));
					$state.go('receivings.grnlist');
				}, function(error) {
					vm.grn.receivingItems = [];
					toastr.error(error, 'Failed');
				});
		}
		
		/* ****************************************************** */
		
		vm.changeItem = function (id) {
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'itemModal.html',
				controller: 'ReceivingItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							receivingItemId: id,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					$state.reload();
				}, function () {
				});
		};	
		
		/* ****************************************************** */

		vm.viewPhotos = function(itemCode, itemName, photoAttachment) {
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'photoModal.html',
				controller: 'ReceivingItemPhotoModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							itemCode: itemCode,
							itemName: itemName,
							photoAttachment: photoAttachment,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		}

		/* ****************************************************** */
		
		// Form Submission
		vm.submit = function() {						
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				HttpSvc.put('receivings/' + $stateParams.id, vm.grn, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('GRN updated successfully.', Auth.translate('SUCCESS'));
						//$state.go('receivings.grnlist');
					}, function(error) {
						vm.grn.receivingItems = [];
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadGrn();
	}	
	
	/** @ngInject */
	function ReceivingItemModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.receivingItemId = item.receivingItemId;
		$mdl.receivingItem = {};
		$mdl.itemList = [];
		$mdl.uomList = [];			
		$mdl.selectedItem = null;
		$mdl.selectedUom = null;			
		$mdl.lockButtons = false;
		
		// Load Item List
		$mdl.loadItemList = function(searchString) {			
			HttpSvc.get('items/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.itemList = [];
					result.forEach( function(i) {
						$mdl.itemList.push({ id: i.id, description: i.description });
						if(i.id==$mdl.receivingItem.itemId) {
							$mdl.selectedItem = { id: i.id, description: i.description };
						}
					});
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Item list.', '');
					return null;
				});		
		};
		
		// Load Item's UOM List
		$mdl.loadUomList = function() {			
			HttpSvc.get('items/uoms/' + $mdl.receivingItem.itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.uomList = [];
					result.forEach( function(i) {
						$mdl.uomList.push({ id: i.id, name: i.name });
					});				
					
					$mdl.uomList.forEach(function(u) {
						if(u.id==$mdl.receivingItem.unitOfMeasurementId) {
							$mdl.selectedUom = u;
						}
					});
					
					$mdl.lockButtons = false;	
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Item list.', '');
					return null;
				});		
		};
		
		// Load Data
		$mdl.loadData = function() {
			$mdl.lockButtons = true;
			
			HttpSvc.get('receivings/item/' + $mdl.receivingItemId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.receivingItem = result;	
					
					HttpSvc.get('items/' + $mdl.receivingItem.itemId, {}, Auth.getTokenId(), false)
						.then(function(result) {								
							$mdl.selectedItem = { id: result.id, description: result.description };							
							$mdl.loadItemList($mdl.receivingItem.description);				
							$mdl.loadUomList();
						}, function() {
							$mdl.lockButtons = false;
							toastr.error('Failed to retrieve Item.', '');
							return null;
						});	
				}, function(error) {
					toastr.error('Failed to load Storage list. ' + error, 'Failed');
				});			
		};
		
		$mdl.onSelectedItemChanged = function() {
			$mdl.receivingItem.itemId = $mdl.selectedItem.id;
			$mdl.loadUomList();
		};
				
		$mdl.onQuantityChanged = function() {			 
			if($mdl.receivingItem.quantity<=0) {
				$mdl.itemForm.Quantity.$error.required = true;
			} else {
				$mdl.itemForm.Quantity.$error.required = false;
			}				 
		};
		
		$mdl.onSelectedUomChanged = function() {
			$mdl.receivingItem.unitOfMeasurementId = $mdl.selectedUom.id;
			 
			if($mdl.receivingItem.unitOfMeasurementId=="")
				$mdl.itemForm.UOM.$error.required = true;
			else
				$mdl.itemForm.UOM.$error.required = false;
		};
		
		$mdl.confirmModal = function() {
			var isValid = true;
			
			// Check Item
			if($mdl.receivingItem.itemId=="" || $mdl.receivingItem.itemId==null) {
				$mdl.itemForm.Item.$error.required = true;
				isValid = false;
			} else {
				$mdl.itemForm.Item.$error.required = false;
			}
			
			// Check UOM
			if($mdl.receivingItem.unitOfMeasurementId=="" || $mdl.receivingItem.unitOfMeasurementId==null) {
				$mdl.itemForm.UOM.$error.required = true;
				isValid = false;
			} else {
				$mdl.itemForm.UOM.$error.required = false;
			}
			
			// Check Quantity
			if($mdl.receivingItem.quantity<=0 || $mdl.receivingItem.quantity=="") {
				$mdl.itemForm.Quantity.$error.required = true;
				isValid = false;
			} else {
				$mdl.itemForm.Quantity.$error.required = false;
			}
			
			if(isValid) {				
				HttpSvc.put('receivings/item/' + $mdl.receivingItemId, $mdl.receivingItem, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('GRN Item updated successfully.', Auth.translate('SUCCESS'));
						$uibModalInstance.close();
					}, function(error) {
						toastr.error('Failed to load Storage list. ' + error, 'Failed');
					});	
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Init
		$mdl.loadData();
	};		
	
	/** @ngInject */
	function ReceivingItemPhotoModalCtrl($uibModalInstance, item, Auth, RmsApi, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.itemCode = item.itemCode;
		$mdl.itemName = item.itemName;
		$mdl.photoAttachment = item.photoAttachment;
		$mdl.photoArray = $mdl.photoAttachment.split(";");
		$mdl.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		$mdl.selectedPhoto = $mdl.rootUrl + $mdl.photoArray[0];

		/* *************************************************** */
		
		// Process Photos
		$mdl.selectPhoto = function(photo) {
			$mdl.selectedPhoto = $mdl.rootUrl + photo;
		}
		
		/* *************************************************** */

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
	
	/** @ngInject */
	function ReceivingsGrnLabelModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
		$mdl.item = {};
		$mdl.item.id = item.receivingId;
		$mdl.item.receivingNo = item.receivingNo;
		
		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfRecordFiltered = 0;
		$mdl.numOfRecordDisplayed = 0;
		$mdl.startIndex = 0; 
		$mdl.endIndex = 0;
		$mdl.labelDataFull = [];
		$mdl.labelData = [];
		$mdl.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.labelDataFull, tableState.search.predicateObject) : $mdl.labelDataFull;
			$mdl.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			$mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
			$mdl.labelData = result;
			
			tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};		
		
		$mdl.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.
			
			if($mdl.labelDataFull.length <= 0) {
				$mdl.isLoading = true;
				
				HttpSvc.get('receivings/' + $mdl.item.id + '/labels', {}, Auth.getTokenId(), true)
					.then(function(result) {	
						$mdl.numOfRecord = result.length;	
						$mdl.labelDataFull = result;		
						refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
						$mdl.isLoading = false;
					}, function() {
						$mdl.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
			}
		};		
		
		// ********************************************************		
		
		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
	
	/** @ngInject */
	function ReceivingsGrnDownloadExcelModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
		var $mdl = this;
		
		$mdl.batchList = [];
		$mdl.isLoading = false;
		$mdl.selectedBatchId = null;		
		$mdl.batchId = null;
		
		// ********************************************************	
			
		$mdl.loadData = function() {
			$mdl.isLoading = true;
			
			HttpSvc.get('receivings/list/batchid', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.batchList = result;
					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};		

		// ********************************************************
		
		$mdl.selectedBatchIdChanged = function() {
		    $mdl.batchId = $mdl.selectedBatchId;
		}

		// ********************************************************		
		
		$mdl.downloadExcel = function() {
			var filename = "RMS_GRN_Batch_" + $filter('date')(new Date(), 'yyyyMMddhhmmss');

			HttpSvc.getExcelObject("receivings/exportac", Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isLoading = false;
					$mdl.loadData();
					//$uibModalInstance.dismiss('cancel');
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to generate Excel. ' + error, '');
					return null;
				});
		}
		
		$mdl.downloadExcelPast = function() {
			if($mdl.selectedBatchId == null)
			{
				toastr.warning("Please select a Batch Number to download.");
				return;
			}

			var filename = "RMS_GRN_" + $mdl.batchId;

			HttpSvc.getExcelObject("receivings/reexportac/" + $mdl.batchId, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isLoading = false;
					//$uibModalInstance.dismiss('cancel');
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to generate Excel. ' + error, '');
					return null;
				});
		}
		
		// ********************************************************	

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// ********************************************************	

		$mdl.loadData();
	};
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.recipes.categories.controller', [])
        .controller('RecipeCategoryMainCtrl', RecipeCategoryMainCtrl)
        .controller('RecipeCategoryCreateCtrl', RecipeCategoryCreateCtrl)
        .controller('RecipeCategoryUpdateCtrl', RecipeCategoryUpdateCtrl);

    /** @ngInject */
    function RecipeCategoryMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();		
		
		var vm = this;
		vm.cateDataFull = [];
		vm.cateData = [];
		vm.numOfRecord = 0;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		
		vm.retrieveData = function() {			
			HttpSvc.get('recipecategories/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.numOfRecord = result.length;	
					vm.cateDataFull = result;
					vm.cateDataFull.forEach(function(cat) {
						if(!cat.imageLocation || cat.imageLocation=='') {
							cat.imageLocation = 'assets/img/empty_placeholder.png';
							cat.thumbnail = 'assets/img/empty_placeholder.png';
						} else {
							cat.imageLocation = vm.rootUrl + cat.imageLocation;
							if(!cat.thumbnail){
								cat.thumbnail = null;
							} else {
								cat.thumbnail = vm.rootUrl + cat.thumbnail;
							}
						}
					});
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		// Call Actions
		vm.retrieveData();		
	};
	
	/** @ngInject */
    function RecipeCategoryCreateCtrl($scope, $state, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.cate = {};
		vm.cate.branches = [];
		vm.branches = [];
		vm.selectedBranches = [];
		vm.categoryId = "";
		vm.cate.imageLocation = '';
		vm.blobUrl = RmsApi.BLOBURL;
		vm.fileToUpload = null;
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		vm.hasFranchiseAccess = Auth.hasCompanyFeature('franchise');
		
		// Init Data
		vm.initData = function() {
			vm.cate.imageLocation = 'assets/img/empty_placeholder.png';	
			vm.loadBranches();
		}	
		
		// Load Branches
		vm.loadBranches = function() {
			HttpSvc.get('branches/listByUserAccess', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.branches.push({ id: u.id, name: u.name });
					});		
				}, function() {
					vm.branches = [];
				});
		};
		
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					/* CHECK STORAGE QUOTA */
					if(vm.lockUploadButton) {
						toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Media Upload Error');
						return;
					}
					/* ******************* */
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/recipecategory/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "recipecategory/" + newFilename + mediaExtension;
				}
				vm.cate.imageLocation = imgLocation;
								
				vm.cate.branches = [];
				vm.selectedBranches.forEach( function(b) {
					vm.cate.branches.push({ id: b.id });
				});
						
				HttpSvc.post('recipecategories', vm.cate, Auth.getTokenId(), false)
					.then(function(result) {
						vm.categoryId = result.recipeCategory.id;
						
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(vm.serverMode);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/recipecategory/" + vm.categoryId;
							vm.uploadImage(vm.serverMode);
							
						} else {							
							toastr.success('Recipe Category has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('recipes.categories.list');
						}
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');						
						vm.dataForm.$setPristine();
					});
			}
		};
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (serverMode) {
			var fileReader = new FileReader();
			
			if(serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId()},
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('Recipe Category has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('recipes.categories.list');
				}, function (resp) {
					toastr.success('Recipe Category has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('recipes.categories.list');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {				
									
							// Notify Server Recipe Media ready
							HttpSvc.put('youtube/ready/category/' + vm.categoryId, {}, Auth.getTokenId(), false)
								.then(function(result) {
									
									// Refresh Clud Storage Stats
									Auth.selectBranchToken()
										.then(function() {	
											toastr.success('Recipe Category has been created successfully.', Auth.translate('SUCCESS'));
											$state.go('recipes.categories.list');
										}, function(error) {
											toastr.success('Recipe Category has been created successfully.', Auth.translate('SUCCESS'));
											$state.go('recipes.categories.list');
										});		
								}, function(error) {
								});	
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function RecipeCategoryUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.cate = {};
		vm.cate.branches = [];
		vm.branches = [];
		vm.selectedBranches = [];
		vm.cate.imageLocation = '';
		vm.cate.thumbnail = '';
		vm.cate.oriImageLocation = '';
		vm.cate.oriThumbnail = '';
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.fileToUpload = null;
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		vm.hasFranchiseAccess = Auth.hasCompanyFeature('franchise');
		
		// Load Branches
		vm.loadBranches = function() {
			HttpSvc.get('branches/listByUserAccess', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.branches.push({ id: u.id, name: u.name });
					});		
					vm.loadRecipeCategory();
				}, function() {
					vm.branches = [];
				});
		};
		
		// Load Recipe Category
		vm.loadRecipeCategory = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('recipecategories/edit/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.cate = result;
					
					result.branches.forEach(function (b) {
						vm.selectedBranches.push({ id: b.id, name: b.name });
					});
					
					if(!vm.cate.imageLocation || vm.cate.imageLocation=='') {
						vm.cate.imageLocation = 'assets/img/empty_placeholder.png';
						vm.cate.thumbnail = 'assets/img/empty_placeholder.png';
						vm.cate.oriImageLocation = "";
						vm.cate.oriThumbnail = "";
					} else {
						vm.cate.oriImageLocation = vm.cate.imageLocation;
						vm.cate.oriThumbnail = vm.cate.thumbnail;
						vm.cate.imageLocation = vm.rootUrl + vm.cate.imageLocation;
						vm.cate.thumbnail = vm.rootUrl + vm.cate.thumbnail;
					}
				}, function() {
					toastr.error('Failed to load selected Recipe Category.', Auth.translate('ERROR'))
					$state.go('recipes.categories.list');
					return;
				});		
		};
		
		// Form Submission
		var thumbnail = "";
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		vm.submit = function(picFile) {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				thumbnail = "";
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					/* CHECK STORAGE QUOTA */
					if(vm.lockUploadButton) {
						toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Media Upload Error');
						return;
					}
					/* ******************* */
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/recipecategory/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "recipecategory/" + newFilename + mediaExtension;
					
				} else if(vm.cate.oriImageLocation!="") {
					imgLocation = vm.cate.oriImageLocation;
					thumbnail = vm.cate.oriThumbnail;
				}
				
				vm.cate.thumbnail = thumbnail;
				vm.cate.imageLocation = imgLocation;
				vm.cate.isThumbnailGenerated = true;						
				
				vm.cate.branches = [];
				vm.selectedBranches.forEach( function(b) {
					vm.cate.branches.push({ id: b.id });
				});
								
				HttpSvc.put('recipecategories/' + $stateParams.id, vm.cate, Auth.getTokenId(), false)
					.then(function(result) {							
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(vm.serverMode);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/recipecategory/" + $stateParams.id;
							vm.uploadImage(vm.serverMode);
							
						} else {							
							toastr.success('Recipe Category has been updated successfully.', Auth.translate('SUCCESS'));
							$state.go('recipes.categories.list');
						}
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');						
						vm.dataForm.$setPristine();
					});
			}
		};
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (serverMode) {
			var fileReader = new FileReader();
			
			if(serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('Recipe Category has been updated successfully.', Auth.translate('SUCCESS'));
					$state.go('recipes.categories.list');
				}, function (resp) {
					toastr.success('Recipe Category has been updated successfully.', Auth.translate('SUCCESS'));
					$state.go('recipes.categories.list');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {				
									
							// Notify Server Recipe Media ready
							HttpSvc.put('youtube/ready/category/' + $stateParams.id, {}, Auth.getTokenId(), false)
								.then(function(result) {
									
									// Refresh Clud Storage Stats
									Auth.selectBranchToken()
										.then(function() {	
											toastr.success('Recipe Category has been updated successfully.', Auth.translate('SUCCESS'));
											$state.go('recipes.categories.list');
										}, function(error) {
											toastr.success('Recipe Category has been updated successfully.', Auth.translate('SUCCESS'));
											$state.go('recipes.categories.list');
										});		
								}, function(error) {
								});	
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};
		
		vm.deleteRecipeCategory = function() {
			var params = {};
			HttpSvc.delete('recipecategories/' + vm.cate.id, params, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('The category [<b>' + vm.cate.name + '</b>] has been deleted.', 'Delete Success');
					$state.go('recipes.categories.list');
				}, function(error) {
					// Failed
					toastr.error(error, 'Delete Failed');
					return null;
			});
		};

		/* ********************************************* */
		
		// Call Actions
		vm.loadBranches();
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.reportcenter.controller', [])
        .controller('ReportCenterCtrl', ReportCenterCtrl)
        .controller('ReportCenterDownloadCtrl', ReportCenterDownloadCtrl);

    /** @ngInject */
    function ReportCenterCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.reports = [];
		vm.sensorList = [];
		vm.isLoading = false;
		vm.isProcessing = false;

		/* ***************************************************************************** */
		
		vm.loadReports = function() {
			
			HttpSvc.get('reports/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.reports = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data. ' + error, '');
					return null;
				});
		}
      
		/* ***************************************************************************** */
		
		vm.showDownloadDialog = function (reportItem) {
			
		  var modalInstance = $uibModal.open({
			  animation: true,
			  keyboard: false,
			  backdrop: 'static',
			  templateUrl: 'downloadTemplate.html',
			  controller: 'ReportCenterDownloadCtrl',
			  controllerAs: '$mdl',
			  size: 'md',
			  resolve: {
				  item: function () {
					  return {
						object: reportItem,
					  }
				  }
			  }
		  });
  
		  modalInstance
			  .result
			  .then(function (data) {
			  }, function () {
			  });
		};	

		// Init Data
		vm.loadReports();
	}
    
    /** @ngInject */
    function ReportCenterDownloadCtrl($uibModalInstance, $timeout, Auth, RmsApi, HttpSvc, UtilSvc, item, toastr) {
		var $mdl = this;

		$mdl.item = item.object;
		$mdl.sensorList = [];
		$mdl.selectedSensor = null;

		$mdl.errorMsg = "";
		$mdl.isProcessing = false;

		/* ********************************************************* */
		
		$mdl.initData = function() {
			if($mdl.item.hasSensor)
			{
				$mdl.loadSensors();
			}
		}

		$mdl.loadSensors = function() {
			$mdl.isProcessing = true;

			var apiPath = $mdl.item.moduleState=='iotdashboard' ? 'iotsensors' : ($mdl.item.moduleState=='iotdashboard.smartiot' ? 'smartiot/sensors' : '');
			
			HttpSvc.get(apiPath + '/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.sensorList = result;
					$mdl.isProcessing = false;
				}, function(error) {
					$mdl.isProcessing = false;
					toastr.error('Failed to retrieve active sensor list. ' + error, '');
					return null;
				});
		}

		/* ********************************************************* */
		
		$mdl.downloadPdf = function() {
			
			$mdl.isProcessing = true;

			var filename = "REPORT_" + $mdl.item.name.replace(" ", "_") + ".pdf";
			var apiPath = 'reports/print/' + $mdl.item.id;
			
			if($mdl.selectedSensor != null) {
				apiPath += '/' + $mdl.selectedSensor.id;
			}
			if($mdl.item.dateFrom != '' && $mdl.item.dateFrom != null && $mdl.item.dateTo != '' && $mdl.item.dateTo != null) {
				apiPath += '/' + $mdl.item.dateFrom + '/' + $mdl.item.dateTo;
			}
			
			HttpSvc.getPdfObject(apiPath, Auth.getTokenId(), filename)
				.then(function(result) {
						$mdl.isProcessing = false;
						$uibModalInstance.dismiss('cancel');
					}, function(error) {
						$mdl.isProcessing = false;
						toastr.error('Failed to generate PDF. ' + error, '');
						return null;
					});
		}
		
		$mdl.downloadExcel = function() {
			
			$mdl.isProcessing = true;
		
			var filename = "REPORT_" + $mdl.item.name.replace(" ", "_") + ".xlsx";
			var apiPath = 'reports/export/' + $mdl.item.id;
			
			if($mdl.selectedSensor != null) {
				apiPath += '/' + $mdl.selectedSensor.id;
			}
			if($mdl.item.dateFrom != '' && $mdl.item.dateFrom != null && $mdl.item.dateTo != '' && $mdl.item.dateTo != null) {
				apiPath += '/' + $mdl.item.dateFrom + '/' + $mdl.item.dateTo;
			}
					
			HttpSvc.getExcelObject(apiPath, Auth.getTokenId(), filename)
				.then(function(result) {
					$mdl.isProcessing = false;
					$uibModalInstance.dismiss('cancel');
				}, function(error) {
					$mdl.isProcessing = false;
					toastr.error('Failed to generate Excel. ' + error, '');
					return null;
				});
		}	

		/* ********************************************************* */
			
		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Init Data
		$mdl.initData();
    };	
	

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.recipes.recipes.controller', ['ngSanitize'])
        .controller('RecipeCatMainCtrl', RecipeCatMainCtrl)
        .controller('RecipeMainCtrl', RecipeMainCtrl)
        .controller('RecipeCreateCtrl', RecipeCreateCtrl)
        .controller('RecipeUpdateCtrl', RecipeUpdateCtrl)
        .controller('CloneRecipeCategoryModalCtrl', CloneRecipeCategoryModalCtrl)
        .controller('CloneRecipeModalCtrl', CloneRecipeModalCtrl)
        .controller('IngredientModalCtrl', IngredientModalCtrl)
        .controller('AltIngredientModalCtrl', AltIngredientModalCtrl)
        .controller('RecipeStepModalCtrl', RecipeStepModalCtrl)	
        .controller('RecipeManageQuickSearchDialogCtrl', RecipeManageQuickSearchDialogCtrl);

    /** @ngInject */
    function RecipeCatMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();
		
		var vm = this;
		vm.categoryList = [];
		vm.recipeList = [];
		vm.numOfRecord = 0;
		vm.isCategorySelected = false;
		vm.selectedCategory = "";
		vm.selectedCategoryId = "";
		vm.isApprovedOption = [];
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);

		/* **************************************************************** */
		
		// Load Recipe Category List		
		vm.loadCategories = function() {			
			HttpSvc.get('recipecategories/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.categoryList = result;
					vm.categoryList.forEach(function(cat) {
						cat.isVisible = true;
						if(!cat.imageLocation || cat.imageLocation=='') {
							cat.imageLocation = 'assets/img/empty_placeholder.png';
							cat.thumbnail = 'assets/img/empty_placeholder.png';
						} else {
							cat.imageLocation = vm.rootUrl + cat.imageLocation;
							if(!cat.thumbnail){
								cat.thumbnail = null;
							} else {
								cat.thumbnail = vm.rootUrl + cat.thumbnail;
							}
						}
					});
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		/* **************************************************************** */

		vm.showSearchRecipeDialog = function() {

			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'SearchRecipeModal.html',
				controller: 'RecipeManageQuickSearchDialogCtrl',
				controllerAs: '$mdl',
				size: 'lg',
			});
	
			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		}

		/* **************************************************************** */

		// Call Actions
		vm.loadCategories();		
	};
	
    /** @ngInject */
    function RecipeMainCtrl($scope, $filter, $state, $stateParams, $uibModal, $q, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();
		
		var vm = this;
		vm.category = {};
		vm.recipeList = [];		
		vm.companyListWithCategories = [];
		vm.numOfRecord = 0;
		vm.isApprovedOption = [];
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.canCloneRecipe = Auth.canCloneRecipe();
		vm.selectedCategory = null;
		vm.selectedCategoryId = null;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
				
		// Go Back
		vm.goBack = function() {
			window.history.back();
		}
		
		vm.loadCategory = function() {
			
			var params = { id: $stateParams.id };
			HttpSvc.get('recipecategories/edit/:id', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.category = result;
					vm.selectedCategory = vm.category.name;
					vm.selectedCategoryId = vm.category.id;
					
					if(!vm.category.imageLocation || vm.category.imageLocation=='') {
						vm.category.imageLocation = 'assets/img/empty_placeholder.png';
						vm.category.thumbnail = 'assets/img/empty_placeholder.png';
					} else {
						vm.category.imageLocation = vm.rootUrl + vm.category.imageLocation;
						if(!vm.category.thumbnail){
							vm.category.thumbnail = null;
						} else {
							vm.category.thumbnail = vm.rootUrl + vm.category.thumbnail;
						}
					}
						
					vm.loadRecipeList(vm.category.id, vm.category.name);
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
			$stateParams.id
		}		
		
		// Load List
		vm.loadRecipeList = function(catId, catName) {
			if(catId=="") {
				vm.selectedCategoryId = "";
				return;
			} 
			
			vm.searchCategory = "";
			vm.isCategorySelected = true;
			vm.selectedCategory = catName;
			vm.selectedCategoryId = catId;
			
			HttpSvc.get('recipes/list/' + catId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.numOfRecord = result.length;	
					vm.recipeList = result;
					vm.recipeList.forEach(function(r) {
						if(!r.imageLocation || r.imageLocation=='') {
							r.imageLocation = 'assets/img/empty_placeholder.png';
							r.thumbnail = 'assets/img/empty_placeholder.png';
						} else {
							r.imageLocation = vm.rootUrl + r.imageLocation;
							if(!r.thumbnail){
								r.thumbnail = null;
							} else {
								r.thumbnail = vm.rootUrl + r.thumbnail;
							}
						}
					});
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		};	
		
		vm.reselectCategory = function() {
			vm.searchCategory = "";
			vm.searchRecipe = "";
			vm.isCategorySelected = false;
			vm.selectedCategory = "";
			vm.selectedCategoryId = "";
			vm.recipeList = [];		
		}
				
		// **********************************************
				
		// Open Clone Recipe Modal Dialog
		vm.showCloneCategoryModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'cloneCategoryModal.html',
				controller: 'CloneRecipeCategoryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							currentCompanyId: Auth.getCompanyId(),
							currentCategoryId: $stateParams.id,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		};	
		
		// **********************************************
		
		// Call Actions
		vm.loadCategory();		
	};
	
	/** @ngInject */
    function RecipeCreateCtrl($scope, $state, $uibModal, $location, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		vm.mode = 1;
		vm.equipments = [];
		vm.recipe = {};
		vm.recipe.batch = 1;
		vm.recipe.imageLocation = '';
		vm.recipe.labourCost = 0;
		vm.recipe.utilitiesCost = 0;
		vm.recipe.machineCost = 0;
		vm.recipe.packagingCost = 0;
		vm.recipe.grossProfitMargin = 0;
		vm.recipe.recipeCategories = [];
		vm.recipe.recipeItems = [];
		vm.recipe.recipeSteps = [];
		vm.categoryList = [];
		vm.selectedCategories = [];
		vm.itemList = [];
		vm.uomList = [];
		vm.changeLogs = [];
		vm.selectedUom = null;
		vm.selectedAltUom = null;
		vm.selectedEquipment = null;
		vm.blobUrl = RmsApi.BLOBURL;
		vm.fileToUpload = null;
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.lockUpdateButtons = false;
		vm.canAccessFoodCost = false;
		vm.serverMode = Auth.getServerMode();
		vm.hasSAKModule = Auth.hasCompanyFeature('smartkitchen');		
		
		/* ************************************************************* */

		// Init Data
		vm.initData = function() {
			vm.canAccessFoodCost = Auth.canAccessFoodCost();
			
			vm.recipe.batch = 1;
			vm.recipe.imageLocation = 'assets/img/empty_placeholder.png';
			vm.loadUomList();
		}	
				
		// Go Back
		vm.goBack = function() {
			window.history.back();
		}
		
		// Load Item List
		vm.loadItemList = function() {
			HttpSvc.get('items/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					result.forEach( function(i) {
						vm.itemList.push({ id: i.id, description: i.description });
					});
					vm.loadUomList();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Item list.', '');
					return null;
				});
		};	
		
		// Load UOM List
		vm.loadUomList = function() {
			HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.loadCategories();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve UOM list.', '');
					return null;
				});
		};	
				
		// Load Recipe Category List
		vm.loadCategories = function() {
			HttpSvc.get('recipecategories/listformanage', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					result.forEach(function (c) {
						vm.categoryList.push({ id: c.id, name: c.name });
					});
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Category list.', '');
					window.history.back();
					return null;
				});
		};	
		
		// Load Equipment		
		vm.loadEquipmentList = function(searchString) {
			vm.lockButtons = true;
			
			HttpSvc.get('equipments/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.equipmentList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve equipment list.', '');
					return null;
				});
		};
		
		/* ************************************************************* */

		vm.selectedEquipmentChanged = function()
		{
			vm.recipe.equipmentId = vm.selectedEquipment.id;
		}
		
		// On Recipe UOM changed
		vm.selectedUomChanged = function() {
			vm.recipe.unitOfMeasurementId = vm.selectedUom.id;
			 
			if(vm.recipe.unitOfMeasurementId=="")
				vm.dataForm.UOM1.$error.required = true;
			else
				vm.dataForm.UOM1.$error.required = false;
		}
		
		// On Recipe UOM changed
		vm.selectedAltUomChanged = function() {
			vm.recipe.altUomId = vm.selectedAltUom.id;
		}
		
		vm.beautify = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			newText = newText + "</span>&nbsp;&nbsp;" + item.name.toUpperCase();
			if(item.description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + item.description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";	
			}			
			return newText;
		}
			
		/* ************************************************************* */
		
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";	
		
		// Submit Form
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');				
			} else {		
				vm.lockUpdateButtons = true;
				
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				vm.recipe.recipeCategories = vm.selectedCategories;	// Categories				
				
				if(vm.serverMode==1 && vm.fileToUpload) {					
					/* CHECK STORAGE QUOTA */
					if(vm.lockUploadButton) {
						toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Media Upload Error');
						return;
					}
					/* ******************* */
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/recipe/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "recipe/" + newFilename + mediaExtension;
					
				} else if(vm.recipe.oriImageLocation!="") {
					imgLocation = vm.recipe.oriImageLocation;
				}
				vm.recipe.imageLocation = imgLocation;
								
				HttpSvc.post('recipes', vm.recipe, Auth.getTokenId(), false)
					.then(function(result) {
						vm.recipe.id = result.recipeId;
						vm.recipe.productionQuantity = vm.recipe.actualQuantity;
												
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(vm.serverMode);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/recipe/" + vm.recipe.id;
							vm.uploadImage(vm.serverMode);
							
						} else {							
							toastr.success('Recipe has been created successfully.', Auth.translate('SUCCESS'));
							$location.path("/recipes/recipes/update/"+vm.recipe.id);
						}
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.dataForm.$setPristine();
					});
			}
		};
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (serverMode) {
			var fileReader = new FileReader();
			
			if(serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Recipe has been created successfully.', Auth.translate('SUCCESS'));
					$location.path("/recipes/recipes/update/"+vm.recipe.id);
				}, function (resp) {
					toastr.success('Recipe has been created successfully.', Auth.translate('SUCCESS'));
					$location.path("/recipes/recipes/update/"+vm.recipe.id);
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {	
							
							// Notify Server Recipe Media ready
							HttpSvc.put('youtube/ready/recipe/' + vm.recipe.id, {}, Auth.getTokenId(), false)
								.then(function(result) {
									
									// Refresh Clud Storage Stats
									Auth.selectBranchToken()
										.then(function() {	
											toastr.success('Recipe has been created successfully.', Auth.translate('SUCCESS'));
											$location.path("/recipes/recipes/update/"+vm.recipe.id);
										}, function(error) {
											toastr.success('Recipe has been created successfully.', Auth.translate('SUCCESS'));										
											$location.path("/recipes/recipes/update/"+vm.recipe.id);
										});		
								}, function(error) {
								});			
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
							vm.dataForm.$setPristine();
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};

		/* ************************************************************* */
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function RecipeUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {

		Auth.init();
		
		var vm = this;
		
		vm.isRmsLite = Auth.isLiteMode();
		
		vm.mode = 2;
		vm.recipe = {};
		vm.recipe.batch = 1;
		vm.recipe.imageLocation = '';
		vm.recipe.thumbnail = '';
		vm.recipe.oriImageLocation = '';
		vm.recipe.oriThumbnail = '';
		vm.equipments = [];
		vm.changeLogs = [];
		vm.foodCosts = [];
		vm.itemList = [];
		vm.semiFgList = [];
		vm.uomList = [];
		vm.recipeList = [];
		vm.categoryList = [];
		vm.selectedCategories = [];	
		vm.companyListWithCategories = [];	
		vm.selectedUom = null;
		vm.selectedAltUom = null;
		vm.selectedEquipment = null;
		vm.fileToUpload = null;	
		vm.mediaToUpload = null;	
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.isStarterMode = Auth.isStarterMode();
		vm.canCloneRecipe = Auth.canCloneRecipe();
		vm.isCalcFoodCost = false;
		vm.canAccessFoodCost = false;
		vm.lockMoveButtons = false;
		vm.lockUpdateButtons = false;
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.serverMode = Auth.getServerMode();
		vm.hasSAKModule = Auth.hasCompanyFeature('smartkitchen');		
		vm.currencyCode = Auth.getCurrency();
		
		/* ************************************************************* */

		vm.initData = function() {			
			vm.canAccessFoodCost = Auth.canAccessFoodCost();
			vm.loadUomList();
		}
				
		// Go Back
		vm.goBack = function() {
			window.history.back();
		}
								
		// Load UOM List
		vm.loadUomList = function() {
			HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;	
					vm.loadCategories();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve UOM list.', '');
					window.history.back();
					return null;
				});
		};	
				
		// Load Recipe Category List
		vm.loadCategories = function() {
			HttpSvc.get('recipecategories/listformanage', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					result.forEach(function (c) {
						vm.categoryList.push({ id: c.id, name: c.name });
					});	
					vm.loadCompanyListWithCategories();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Category list.', '');
					window.history.back();
					return null;
				});
		};	
				
		// Load Recipe Category List
		vm.loadCompanyListWithCategories = function() {
			HttpSvc.get('companies/listwithcategory', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companyListWithCategories = result;
					vm.loadRecipe();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Company with Category list.', '');
					window.history.back();
					return null;
				});
		};	
				
		// Load Change Logs
		vm.loadChangeLogs = function() {
			HttpSvc.get('recipechangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};	
		
		// Load Recipe
		vm.loadRecipe = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('recipes/edit/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.recipe = result;
					vm.uomList.forEach(function(u){
						if(u.id==vm.recipe.unitOfMeasurementId){
							vm.selectedUom = u;
						}
					});
					vm.uomList.forEach(function(u){
						if(u.id==vm.recipe.altUomId){
							vm.selectedAltUom = u;
						}
					});
					
					if(!vm.recipe.imageLocation || vm.recipe.imageLocation=='') {
						vm.recipe.imageLocation = 'assets/img/empty_placeholder.png';
						vm.recipe.thumbnail = 'assets/img/empty_placeholder.png';
						vm.recipe.oriImageLocation = "";
						vm.recipe.oriThumbnail = "";
					} else {
						vm.recipe.oriImageLocation = vm.recipe.imageLocation;
						vm.recipe.oriThumbnail = vm.recipe.thumbnail;
						vm.recipe.imageLocation = vm.rootUrl + vm.recipe.imageLocation;
						vm.recipe.thumbnail = vm.rootUrl + vm.recipe.thumbnail;
					}
		
					result.recipeCategories.forEach(function (c) {
						vm.selectedCategories.push({ id: c.id, name: c.name });
					});	

					if(vm.recipe.equipmentId!=null)
					{
						vm.equipmentList = [];
						vm.equipmentList.push({ id: vm.recipe.equipmentId, code: vm.recipe.equipmentCode, name: vm.recipe.equipmentName });
						vm.selectedEquipment = vm.equipmentList[0];
					}

					if(vm.canAccessFoodCost) {
						vm.loadRecipeFoodCosts();
						vm.tableForm.$show();
					}

					vm.loadChangeLogs();

				}, function() {
					toastr.error('Failed to load selected Recipe.', Auth.translate('ERROR'))
					window.history.back();
					return;
				});		
		};
		
		// Load Food Costs		
		vm.loadRecipeFoodCosts = function() {
			vm.isCalcFoodCost = true;
			vm.foodCosts = [];
			
			var params = { id: $stateParams.id };
			
			HttpSvc.get('recipes/foodcosts/new/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isCalcFoodCost = false;
					vm.foodCosts = result;
					vm.getTotalCost();
				}, function() {
					vm.isCalcFoodCost = false;
					toastr.error('Failed to load Recipe Food Costs.', Auth.translate('ERROR'))
					return;
				});		
		};
		
		// Load Equipment		
		vm.loadEquipmentList = function(searchString) {
			vm.lockButtons = true;
			
			HttpSvc.get('equipments/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.equipmentList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve equipment list.', '');
					return null;
				});
		};
		
		/* ************************************************************* */
		
		vm.beautify = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			newText = newText + "</span>&nbsp;&nbsp;" + item.name.toUpperCase();
			if(item.description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + item.description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";	
			}			
			return newText;
		}

		// Validate Input
		vm.checkValue = function(value) {			
			if(isNaN(value)){
				return "Enter numbers only!";
			} 
		};
		
		// Validate Form
		vm.formHasError = function() {
			var totalErrorCount = 0;
			
			vm.tableForm.$editables.forEach(function(field) {
				if(field.error!="") totalErrorCount += 1;
			});
			
			return (totalErrorCount>0) ? true : false;
		}			
		
		// Recalculate Food Cost
		vm.reCalcCost = function() {
			vm.tableForm.$submit();
			vm.getTotalCost();
			vm.tableForm.$show();
		}
		
		// Get Total Food Cost
		vm.getTotalCost = function () {		
			vm.totalCost = 0;
			vm.totalCostPerServing = 0;	
			vm.totalPricePerServing = 0;	
			
			try {
				vm.foodCosts.forEach(function(c) {
					vm.totalCost += parseFloat(c.cost);	
				});
				vm.totalCost += vm.recipe.labourCost;	
				vm.totalCost += vm.recipe.utilitiesCost;	
				vm.totalCost += vm.recipe.machineCost;	
				vm.totalCost += vm.recipe.packagingCost;	
			} catch (ex) {	
				console.log(ex);
			}	
			vm.totalCostPerServing = vm.totalCost / vm.recipe.actualQuantity;		
			vm.totalPricePerServing = vm.recipe.grossProfitMargin / vm.recipe.actualQuantity;		
		}
		
		// Load Recipe Steps
		vm.loadRecipeSteps = function(recipeId, upDown, continueAdd) {
			var params = { id: recipeId };
			HttpSvc.get('recipesteps/recipe/:id', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.recipe.recipeSteps = result;	
					if(upDown!="") {
						toastr.success("Step has been moved " + upDown + " and saved.", "Success");	
					}
					if(continueAdd) {
						vm.showAddStepModal(continueAdd);
					}

					vm.lockMoveButtons = false;		
				}, function() {
					toastr.error('Failed to load Recipe Steps.', Auth.translate('ERROR'))					
					vm.lockMoveButtons = false;
					return;
				});		
		};
		
		// Clone Recipe
		vm.cloneRecipe = function() {
			vm.lockUpdateButtons = true;
			
			HttpSvc.post('recipes/clone/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {											
						toastr.success('Recipe has been cloned successfully.', Auth.translate('SUCCESS'));	
						$state.go('recipes.recipes.update', {'id': result.newRecipeId });
				}, function(error) {
					toastr.error(angular.toJson(error), 'Failed');
					vm.dataForm.$setPristine();
				});
		}

		/* ************************************************************* */

		vm.selectedEquipmentChanged = function()
		{
			vm.recipe.equipmentId = vm.selectedEquipment.id;
		}
		
		// On Recipe UOM changed
		vm.selectedUomChanged = function() {
			vm.recipe.unitOfMeasurementId = vm.selectedUom.id;
		}
		
		// On Recipe Alt UOM changed
		vm.selectedAltUomChanged = function() {
			vm.recipe.altUomId = vm.selectedAltUom.id;
		}

		vm.enableAltUomChanged = function() {
			if(vm.recipe.enableAltUom==false)
			{
				vm.selectedAltUom = null;
				vm.recipe.altUomId = null;
				vm.recipe.altUomMultiplier = null;
			}
		}
			
		/* ************************************************************* */

		// Print Recipe
		vm.printFoodCost = function(recipeId, recipeName) {
			
			var filename = "FOODCOST_" + recipeName.replace("/", "_").replace(" ", "_").replace("#", "") + ".pdf";
			
			HttpSvc.getPdfObject('recipes/print/foodcost/' + recipeId + '/1', Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print Food Cost. ' + error, '');
							return null;
						});
		};
			
		// Download Excel
		vm.downloadExcel = function() {
			
			var filename = "RECIPE_" + vm.recipe.name.replace("/", "_").replace(" ", "_").replace("#", "") + ".xlsx";
			
			HttpSvc.getExcelObject('recipes/print/excel/' + vm.recipe.id, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to download Recipe Excel. ' + error, '');
							return null;
						});
		};
		
		/* ************************************************************* */

		var thumbnail = "";
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		// Submit Form
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all the Required Fields in all the Tabs.', 'Incomplete Fields');
			} else {
				vm.lockUpdateButtons = true;
				
				thumbnail = "";
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				vm.recipe.recipeCategories = vm.selectedCategories;	// Categories	
				
				if(vm.serverMode==1 && vm.fileToUpload) {					
					/* CHECK STORAGE QUOTA */
					if(vm.lockUploadButton) {
						toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Media Upload Error');
						return;
					}
					/* ******************* */
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/recipe/" + newFilename + mediaExtension;
					thumbnail = null;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "recipe/" + newFilename + mediaExtension;
										
				} else if(vm.recipe.oriImageLocation!="" || vm.recipe.oriImageLocation!=null) {
					imgLocation = vm.recipe.oriImageLocation;
					thumbnail = vm.recipe.oriThumbnail;
				}
				vm.recipe.imageLocation = imgLocation;
				vm.recipe.thumbnail = thumbnail;
				vm.recipe.isThumbnailGenerated = true;
				vm.recipe.productionQuantity = vm.recipe.actualQuantity;
								
				HttpSvc.put('recipes/' + $stateParams.id, vm.recipe, Auth.getTokenId(), false)
					.then(function(result) {
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadMedia(vm.serverMode);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/recipe/" + $stateParams.id;
							vm.uploadMedia(vm.serverMode);
							
						} else {							
							toastr.success('Recipe has been updated successfully.', Auth.translate('SUCCESS'));
							vm.dataForm.$setPristine();
							vm.lockUpdateButtons = false;
							$state.reload();
							//$state.go('recipes.recipes.recipe-list');
						}
					}, function(error) {
						vm.lockUpdateButtons = false;
						toastr.error(error, 'Failed');
						vm.dataForm.$setPristine();
					});
			}
		};
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Set Upload Image
		vm.clearImage = function() {			
			vm.recipe.imageLocation = 'assets/img/empty_placeholder.png';
			vm.recipe.thumbnail = 'assets/img/empty_placeholder.png';
			vm.recipe.oriImageLocation = '';
			vm.recipe.oriThumbnail = '';
			vm.fileToUpload = null;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (serverMode) {
			var fileReader = new FileReader();
						
			if(serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('Recipe has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('Recipe has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {		
							
							// Notify Server Recipe Media ready
							HttpSvc.put('youtube/ready/recipe/' + $stateParams.id, {}, Auth.getTokenId(), false)
								.then(function(result) {
									
									// Refresh Clud Storage Stats
									Auth.selectBranchToken()
										.then(function() {	
											toastr.success('Recipe has been updated successfully.', Auth.translate('SUCCESS'));
											$state.reload();
										}, function(error) {
											toastr.success('Recipe has been updated successfully.', Auth.translate('SUCCESS'));
											$state.reload();
										});		
								}, function(error) {
									toastr.success('Recipe has been updated successfully.', Auth.translate('SUCCESS'));
									$state.reload();
								});
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};
		
		// Delete Recipe
		vm.deleteRecipe = function() {
			
			HttpSvc.delete('recipes/' + vm.recipe.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('The recipe [<b>' + vm.recipe.name + '</b>] has been deleted.', 'Delete Success');
					window.history.back();
				}, function() {
					// Failed
					toastr.error('Failed to delete the recipe.', 'Delete Failed');
					return null;
			});
		};
				
		/* ************************************************************* */
		
		// Remove Ingredient
		vm.removeIngredient = function(index) {
			vm.recipe.recipeItems.splice(index, 1);
			$scope.$broadcast('refreshStTable');	
		};
			
		// Update Ingredient
		vm.updateIngredient = function(index, obj) {

			var isFound = false;
			vm.recipe.recipeItems.forEach(function (i) {
                if(checkProductExist(i, obj)){
                    i.category = obj.category,
                    i.itemName = obj.itemName,
                    i.itemId = obj.itemId,
                    i.childRecipeId = obj.childRecipeId,
                    i.semiFinishedProductId = obj.semiFinishedProductId,
                    i.quantity = obj.quantity,
                    i.unitOfMeasurementId = obj.unitOfMeasurementId,
                    i.unitOfMeasurement= {
                        name: obj.unitOfMeasurement.name
                    },
                    isFound = true;
                }
            });

            if(isFound) return;
			
			var element = {
				category: obj.category,
				itemName: obj.itemName,
				itemId: obj.itemId,
				childRecipeId: obj.childRecipeId,
				semiFinishedProductId: obj.semiFinishedProductId,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.unitOfMeasurement.name
				},
				recipeItemAlts: []
			};
			vm.recipe.recipeItems.splice(index, 1, element);
		};

		// Add Ingredient
		vm.addIngredient = function(obj) {

			var isFound = false;
			vm.recipe.recipeItems.forEach(function(i) {
				if((i.itemId==obj.itemId && i.itemId!=null) ||
					(i.semiFinishedProductId==obj.semiFinishedProductId && i.semiFinishedProductId!=null) ||
					(i.childRecipeId==obj.childRecipeId && i.childRecipeId!=null))
				{
					isFound = true;
				}
			});

			if(isFound)
			{
				toastr.warning('Failed to add Ingredient. Ingredient already exists on the list.');
				return;
			}

			var element = {
				category: obj.category,
				itemName: obj.itemName,
				itemId: obj.itemId,
				childRecipeId: obj.childRecipeId,
				semiFinishedProductId: obj.semiFinishedProductId,
				quantity: obj.quantity,
				unitOfMeasurementId: obj.unitOfMeasurementId,
				unitOfMeasurement: {
					name: obj.unitOfMeasurement.name
				},
				recipeItemAlts: []
			};
			if (obj.semiFinishedProductId != null) {
				element.sfgRecipeId = obj.recipeId;
			}
			vm.recipe.recipeItems.push(element);
		};

		// Refresh Ingredient List
		vm.refreshRecipeItems = function(tableState) {
			// Do nothing
		};		
		
		/* ************************************************************* */	
		
		vm.showAddAltIngredientModal = function (index) {
			vm.ingredient = vm.recipe.recipeItems[index];
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'altIngredientModal.html',
				controller: 'AltIngredientModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addAltIngredient(index, data);
				}, function () {
				});
		};	
		
		// Remove Alternative Ingredient
		vm.removeAltIngredient = function(parentIndex, index) {			
			if(confirm('Confirm remove this alternative ingredient?')) {
				vm.recipe.recipeItems[parentIndex].recipeItemAlts.splice(index, 1);
				$scope.$broadcast('refreshStTable');		
			}			
		};

		// Add Alternative Ingredient
		vm.addAltIngredient = function(index, obj) {
			
			var isFound = false;
			vm.recipe.recipeItems[index].recipeItemAlts.forEach(function(r) {
				if(r.itemId==obj.itemId && r.semiFinishedProductId==obj.semiFinishedProductId)
				{
					isFound = true;
				}
			});

			if(isFound) {
				toastr.warning('The same alternative ingredient already exists.', 'Duplicate');
				return;
			}

			var element = {
				itemId: obj.itemId,
				semiFinishedProductId: obj.semiFinishedProductId,
				description: obj.itemDescription,
				remarks: obj.remarks,
			};
			vm.recipe.recipeItems[index].recipeItemAlts.push(element);
		};
		
		/* ************************************************************* */

		// Remove Step
		vm.removeStep = function(stepId) {	
			vm.lockMoveButtons = true;
			
			HttpSvc.delete('recipesteps/' + stepId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.recipe.recipeSteps = result;
					toastr.success('The Step has been removed.', Auth.translate('SUCCESS'));
					$scope.$broadcast('refreshStTable');
					vm.lockMoveButtons = false;
					
					vm.loadChangeLogs();
				}, function(error) {
					// Failed
					toastr.error('Failed to remove the Step.', 'Failed');
					vm.lockMoveButtons = false;
					return null;
				});
		};
		
		// Move Up Step
		vm.moveStepUp = function(stepId) {
			vm.lockMoveButtons = true;
			
			HttpSvc.put('recipesteps/moveUp/' + stepId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loadRecipeSteps(vm.recipe.id, "up", false);
				}, function(error) {
					toastr.error("Failed to move Step up. " + error, "Failed");
					vm.lockMoveButtons = false;
				});	
		}
		
		// Move Down Step
		vm.moveStepDown = function(stepId) {
			vm.lockMoveButtons = true;
			
			HttpSvc.put('recipesteps/moveDown/' + stepId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loadRecipeSteps(vm.recipe.id, "down", false);
				}, function(error) {
					toastr.error("Failed to move Step down. " + error, "Failed");
					vm.lockMoveButtons = false;
				});	
		}
		
		/* ************************************************************* */
				
		// Open Clone Recipe Modal Dialog
		vm.showCloneRecipeModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'cloneRecipeModal.html',
				controller: 'CloneRecipeModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							companies: vm.companyListWithCategories,
							currentCompanyId: Auth.getCompanyId(),
							currentRecipeId: vm.recipe.id,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		};	
		
		// Open Ingredient Modal Dialog
		vm.ingredient = {};	
		vm.showAddIngredientModal = function (continueAdd) {
			vm.ingredient = {};
						
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'ingredientModal.html',
				controller: 'IngredientModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.ingredient,
							recipeId: vm.recipe.id,
							itemList: vm.itemList,
							uomList: vm.uomList,
							recipeList: vm.recipeList,
							continueAdd: continueAdd,
						}
					}
				}
			});

            modalInstance
                .result
                .then(function (data) {
                    vm.addIngredient(data);
                    if (data.continueAdd) {
                        vm.showAddIngredientModal(data.continueAdd);
                    }
                }, function () {
                });
        };
        vm.showEditIngredientModal = function (index) {
            vm.ingredient = angular.copy(vm.recipe.recipeItems[index]);

            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'ingredientModal.html',
                controller: 'IngredientModalCtrl',
                controllerAs: '$mdl',
                size: 'lg',
                resolve: {
                    item: function () {
                        return {
                            mode: 2,
                            title: "UPDATE",
                            object: vm.ingredient,
                            recipeId: vm.recipe.id,
                            itemList: vm.itemList,
                            uomList: vm.uomList,
                            recipeList: vm.recipeList,
                        }
                    }
                }
            });

			modalInstance
				.result
				.then(function (data) {
					vm.updateIngredient(index, data);
				}, function () {
				});
		};
		
		// Open Step Modal Dialog
		vm.step = {};
		vm.showAddStepModal = function (continueAdd) {
			vm.step = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'stepModal.html',
				controller: 'RecipeStepModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							recipeId: vm.recipe.id,
							object: vm.step,
							serverMode: vm.serverMode,
							nextStepNo: vm.recipe.recipeSteps.length,
							lockUploadButton: vm.lockUploadButton,
							continueAdd: continueAdd,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadRecipeSteps(vm.recipe.id, "", data.continueAdd);
					vm.loadChangeLogs();
				}, function () {
				});
		};	
		vm.showEditStepModal = function (stepId) {
			vm.recipe.recipeSteps.forEach(function(s){
				if(s.id==stepId) {
					vm.step = s;
				}
			});

			var step = angular.copy(vm.step);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'stepModal.html',
				controller: 'RecipeStepModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: step,
							serverMode: vm.serverMode,
							lockUploadButton: vm.lockUploadButton,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadRecipeSteps(vm.recipe.id, "", false);
					vm.loadChangeLogs();
				}, function () {
				});
		};		
		
		// Call Actions
		vm.initData();		
	}

	// Clone Recipe Category Modal Controller
	function CloneRecipeCategoryModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.companies = [];
		$mdl.currentCompanyId = item.currentCompanyId;
		$mdl.currentCategoryId = item.currentCategoryId;
		$mdl.selectedCompany = {};
		$mdl.selectedCategory = {};
		$mdl.lockButtons = false;
		$mdl.isLoading = false;
				
		// Load Recipe Category List
		$mdl.loadCompanyListWithCategories = function() {
			$mdl.isLoading = true;
			
			HttpSvc.get('companies/listwithcategory', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.companies = result;
					
					// Initialize
					$mdl.companies.forEach( function(c) {
						if(c.id==$mdl.currentCompanyId) {
							$mdl.selectedCompany = c;
							if(c.recipeCategories.length>0) {
								$mdl.selectedCategory = c.recipeCategories[0];
							}
						}
					});
					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve Company with Category list.', '');
					$mdl.cancelModal();
					return null;
				});
		};			
				
		/* ******************************************************** */
		
		$mdl.confirmModal = function() {									
			if($mdl.cloneForm.$valid) {				
				$mdl.lockButtons = true;
								
				HttpSvc.post("recipes/clonecategorytocompany/" + $mdl.currentCategoryId + "/" + $mdl.selectedCompany.id + "/" + $mdl.selectedCategory.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("All Recipes in this Category have been successfully cloned to <b>" + $mdl.selectedCompany.name + "</b> - <b>" + $mdl.selectedCategory.name + "</b>");
						$uibModalInstance.close();					
					}, function(error) {
						$mdl.lockButtons = false;
						toastr.error(angular.toJson(error), 'Failed');
					});	
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Init
		$mdl.loadCompanyListWithCategories();
	};	
	
	// Clone Recipe Modal Controller
	function CloneRecipeModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.companies = item.companies;
		$mdl.currentCompanyId = item.currentCompanyId;
		$mdl.currentRecipeId = item.currentRecipeId;
		$mdl.selectedCompany = {};
		$mdl.selectedCategory = {};
		$mdl.lockButtons = false;
		
		// Initialize
		$mdl.companies.forEach( function(c) {
			if(c.id==$mdl.currentCompanyId) {
				$mdl.selectedCompany = c;
				if(c.recipeCategories.length>0) {
					$mdl.selectedCategory = c.recipeCategories[0];
				}
			}
		});
				
		/* ******************************************************** */
		
		$mdl.confirmModal = function() {									
			if($mdl.cloneForm.$valid) {				
				$mdl.lockButtons = true;
								
				HttpSvc.post("recipes/clonetocompany/" + $mdl.currentRecipeId + "/" + $mdl.selectedCompany.id + "/" + $mdl.selectedCategory.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Recipe is successfully cloned to <b>" + $mdl.selectedCompany.name + "</b> - <b>" + $mdl.selectedCategory.name + "</b>");
						$uibModalInstance.close();					
					}, function(error) {
						$mdl.lockButtons = false;
						toastr.error(angular.toJson(error), 'Failed');
					});	
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
	
	// Ingredient Modal Controller
	function IngredientModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.itemList = [];
		$mdl.semiFgList = [];
		$mdl.recipeList = [];
		$mdl.uomList = item.uomList;
		$mdl.allUomList = item.uomList;
		$mdl.rawMatUomList = item.uomList;
		$mdl.item = item.object;
		$mdl.recipeId = item.recipeId;
		$mdl.selectedItem = null;
		$mdl.selectedSemiFg = null;
		$mdl.selectedUom = null;
		$mdl.selectedRecipe = null;
		$mdl.activeTab = 0;
		$mdl.lockButtons = false;		
		$mdl.hasRawMatAccess = Auth.hasCompanyFeature('maintenance.items');
		$mdl.hasSemiFgAccess = Auth.hasCompanyFeature('maintenance.semifgs');
		
		/* ******************************************************** */	
		
		$mdl.loadRawMatUomList = function() {
			HttpSvc.get('items/uoms/' + $mdl.item.itemId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.rawMatUomList = result;
					$mdl.uomList = $mdl.rawMatUomList;
					$mdl.lockButtons = false;

					if(item.mode==2)
					{
						$mdl.uomList.forEach(function (i) {
							if(i.id==$mdl.item.unitOfMeasurementId) {
								$mdl.selectedUom = i;
								$mdl.item.unitOfMeasurement.name = i.name;
							}
						});
					}
				}, function(error) {
					toastr.error("Failed to retrieve Raw Material's UOMs.", "Failed");
					$mdl.lockButtons = false;
				});	
		}
		
		/* ******************************************************** */	
				
		// Load Item List
		$mdl.loadItemList = function(searchString) {
			$mdl.lockButtons = true;
			
			HttpSvc.get('items/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.itemList = [];
					result.forEach( function(i) {
						$mdl.itemList.push({ id: i.id, description: i.description });
					});

					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Item list.', '');
					return null;
				});
		};		
				
		// Load Semi F.G. List
		$mdl.loadSemiFgList = function(searchString) {
			$mdl.lockButtons = true;
			
			HttpSvc.get('semifgs/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.semiFgList = [];
					result.forEach( function(i) {
						$mdl.semiFgList.push({ id: i.id, description: i.description, recipeId: i.recipeId, sfgRecipeId: i.sfgRecipeId });
					});
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Item list.', '');
					return null;
				});
		};	
										
		// Load Recipe List
		$mdl.loadRecipeList = function(searchString) {		
			$mdl.lockButtons = true;
			
			HttpSvc.get('recipes/listByCompany/except/' + $mdl.recipeId + '/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.recipeList	= [];
					result.forEach( function(i) {
						$mdl.recipeList.push({ id: i.id, name: i.name });
					});	
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Recipe list.', '');
					return null;
				});
		};
		
		/* ******************************************************** */

		$mdl.onItemNameChanged = function() {
			// if($mdl.item.itemId==null && $mdl.item.semiFinishedProductId==null && $mdl.item.childRecipeId==null && $mdl.item.itemName=="") {
			// 	$mdl.ingredientForm.ItemName.$error.required = true;
			// } else {
			// 	$mdl.ingredientForm.ItemName.$error.required = false;
			// }				 
		}
		
		$mdl.onSelectedItemChanged = function() {
			$mdl.item.itemId = $mdl.selectedItem.id;
			$mdl.item.itemName = $mdl.selectedItem.description;
			$mdl.item.semiFinishedProductId = null;
			$mdl.item.childRecipeId = null;	
			$mdl.selectedSemiFg = null;
			$mdl.selectedRecipe = null;
			$mdl.onItemNameChanged();
			$mdl.loadRawMatUomList();
		}	
		
		$mdl.onSelectedSemiFgChanged = function(fromInit) {
			$mdl.item.semiFinishedProductId = $mdl.selectedSemiFg.id;
			$mdl.item.recipeId = $mdl.selectedSemiFg.recipeId;
			if (!fromInit) {
            	$mdl.item.sfgRecipeId = $mdl.selectedSemiFg.recipeId;
			}
			$mdl.item.itemName = $mdl.selectedSemiFg.description;
			$mdl.item.itemId = null;
			$mdl.item.childRecipeId = null;	
			$mdl.selectedItem = null;
			$mdl.selectedRecipe = null;
			$mdl.onItemNameChanged();
			$mdl.getSemiFgRecipeUom($mdl.item.sfgRecipeId);
		}	
		
		$mdl.onSelectedRecipeChanged = function() {
			$mdl.item.childRecipeId = $mdl.selectedRecipe.id;
			$mdl.item.itemName = $mdl.selectedRecipe.name;	
			$mdl.item.itemId = null;
			$mdl.selectedItem = null;
			$mdl.selectedSemiFg = null;
			$mdl.onItemNameChanged();			
						
			$mdl.getRecipeUom($mdl.selectedRecipe.id);
		}	
		
		$mdl.selectedUomChanged = function() {
			$mdl.item.unitOfMeasurementId = $mdl.selectedUom.id;
			$mdl.item.unitOfMeasurement.name = $mdl.selectedUom.name;
		}
		
		/* ******************************************************** */
		
		$mdl.getSemiFgRecipeUom = function(sfgRecipeId) {
			if(sfgRecipeId==null) {
				toastr.warning("Recipe ID is null");
				return;
			}
			
			$mdl.lockButtons = true;
			var recipe = {};
			
			HttpSvc.get('recipes/basic/' + sfgRecipeId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					recipe = result;
					
					$mdl.uomList = $mdl.allUomList;
					$mdl.uomList.forEach(function (u) {
                        if (u.id == recipe.unitOfMeasurementId) {
                            $mdl.selectedUom = u;
                            $mdl.item.unitOfMeasurementId = u.id;
                            $mdl.item.unitOfMeasurement.name = u.name;
                        }
                    });
					$mdl.lockButtons = false;
				}, function(error) {
					toastr.error("Failed to retrieve Recipe UOM.", "Failed");
					$mdl.lockButtons = false;
				});	
		}
		
		$mdl.getRecipeUom = function(recipeId) {
			$mdl.lockButtons = true;
			var recipe = {};
			
			HttpSvc.get('recipes/basic/' + recipeId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					recipe = result;
					
					$mdl.uomList = $mdl.allUomList;					
					$mdl.uomList.forEach(function(u) {
						if(u.id==recipe.unitOfMeasurementId){
							$mdl.selectedUom = u;
							$mdl.item.unitOfMeasurementId = u.id;
							$mdl.item.unitOfMeasurement.name = u.name;
						}
					});
					$mdl.lockButtons = false;
				}, function(error) {
					toastr.error("Failed to retrieve Recipe UOM.", "Failed");
					$mdl.lockButtons = false;
				});	
		}
		
		/* ******************************************************** */
		
		$mdl.confirmModal = function() {	
			
			if(($mdl.item.itemId=="" || $mdl.item.itemId==null) && ($mdl.item.itemName=="" || $mdl.item.itemName==null)) {
				$mdl.ingredientForm.ItemName.$error.required = true;
			} else {
				$mdl.ingredientForm.ItemName.$error.required = false;				
			}
			
			if($mdl.item.unitOfMeasurementId=="")
				$mdl.ingredientForm.UOM.$error.required = true;
			else
				$mdl.ingredientForm.UOM.$error.required = false;
			
			if($mdl.ingredientForm.$valid)
				$uibModalInstance.close($mdl.item);
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		/* ******************************************************** */
		
		// Initialize
		if(item.mode==1) {
			$mdl.item.itemId = null;
			$mdl.item.itemName = "";
			$mdl.item.childRecipeId = null;
			$mdl.item.semiFinishedProductId = null;
			$mdl.item.unitOfMeasurementId = "";	
			$mdl.item.unitOfMeasurement = {};
			$mdl.item.continueAdd = item.continueAdd;
			
			if($mdl.hasRawMatAccess) {
				$mdl.activeTab = 0;
			} else {
				if($mdl.hasSemiFgAccess) {
					$mdl.activeTab = 1;
				} else {
					$mdl.activeTab = 2;
				}
			}			
			
		} else {
			if($mdl.hasRawMatAccess) {
				if($mdl.item.itemId!='' && $mdl.item.itemId!=null){
					$mdl.itemList.push({ id: $mdl.item.itemId, description: $mdl.item.itemName });
					$mdl.selectedItem = $mdl.itemList[0];
					$mdl.activeTab = 0;
					
					$mdl.onSelectedItemChanged();
				}				
			}
			
			if($mdl.hasSemiFgAccess) {
				if($mdl.item.semiFinishedProductId!='' && $mdl.item.semiFinishedProductId!=null){
					$mdl.semiFgList.push({ id: $mdl.item.semiFinishedProductId, description: $mdl.item.itemName, recipeId: $mdl.item.recipeId, sfgRecipeId: $mdl.item.sfgRecipeId });
					$mdl.selectedSemiFg = $mdl.semiFgList[0];
					$mdl.activeTab = 1;

					$mdl.onSelectedSemiFgChanged(true);
				}				
			}
			
			if($mdl.item.childRecipeId!='' && $mdl.item.childRecipeId!=null){
				$mdl.recipeList.push({ id: $mdl.item.childRecipeId, name: $mdl.item.itemName });
				$mdl.selectedRecipe = $mdl.recipeList[0];
				$mdl.activeTab = 2;

				$mdl.onSelectedRecipeChanged();
			}
						
			if($mdl.item.itemId==null &&
				$mdl.item.childRecipeId==null &&
				$mdl.item.semiFinishedProductId==null) {
				
				$mdl.activeTab = 3;
			}
			
			$mdl.uomList.forEach(function (i) {
				if(i.id==$mdl.item.unitOfMeasurementId) {
					$mdl.selectedUom = i;
					$mdl.item.unitOfMeasurement.name = i.name;
				}
			});
		}	
	};	
	
	// Alternative Ingredient Modal Controller
	function AltIngredientModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.item = {};
		$mdl.itemList = [];
		$mdl.selectedItem = null;
		$mdl.lockButtons = false;
		$mdl.isRM = true;
		$mdl.isSFG = false;
		$mdl.title = 'Raw Material';

		/* ******************************************************** */

		// Load Item List
		$mdl.loadItemList = function(searchString) {
			$mdl.lockButtons = true;
			
			var api = ($mdl.isRM?'items':($mdl.isSFG?'semifgs':'items'));

			HttpSvc.get(api + '/list/active/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.itemList = [];
					result.forEach( function(i) {
						$mdl.itemList.push({ id: i.id, description: i.description });
					});
					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Item list.', '');
					return null;
				});
		};
		
		$mdl.onSelectedItemChanged = function() {
			if($mdl.isRM) $mdl.item.itemId = $mdl.selectedItem.id;
			if($mdl.isSFG) $mdl.item.semiFinishedProductId = $mdl.selectedItem.id;

			$mdl.item.itemDescription = $mdl.selectedItem.description;			
		}
		
		/* ******************************************************** */

		$mdl.changeType = function(isRM, isSFG) {
			$mdl.isRM = isRM;
			$mdl.isSFG = isSFG;
			$mdl.selectedItem = null;
			$mdl.title = ($mdl.isRM?'Raw Material':($mdl.isSFG?'Semi Finished Good':''));
		}

		/* ******************************************************** */
		
		$mdl.confirmModal = function() {	
			
			if(($mdl.item.itemId=="" || $mdl.item.itemId==null) && ($mdl.item.semiFinishedProductId=="" || $mdl.item.semiFinishedProductId==null)) {
				$mdl.altIngredientForm.ItemId.$error.required = true;
			} else {
				$mdl.altIngredientForm.ItemId.$error.required = false;				
			}
			
			if($mdl.altIngredientForm.$valid)
				$uibModalInstance.close($mdl.item);
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
	
	// Step Modal Controller
	function RecipeStepModalCtrl($uibModalInstance, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
		$mdl.mode = item.mode;
		$mdl.title = item.title;
		$mdl.item = item.object;
		$mdl.recipeId = item.recipeId;
		$mdl.serverMode = item.serverMode;
		$mdl.rootUrl = ($mdl.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		$mdl.lockUploadButton = item.lockUploadButton;
		$mdl.youtubeUrl = "";
		$mdl.lockButton = false;
		$mdl.uploadProgess = 0;
		$mdl.uploadProgessTotal = 0;
		$mdl.uploadProgessPercent = 0;
		$mdl.activeTab = 0;
		$mdl.hasSmartKitchenFeature = Auth.hasCompanyFeature('smartkitchen');
		
		var thumbnail = "";
		var mediaLocation = "";
		var mediaExtension = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		// Initialize
		if(item.mode==1) {
			$mdl.activeTab = 0;
			$mdl.item.step = item.nextStepNo;
			$mdl.item.name = "";
			$mdl.item.blobLocation = "";
			$mdl.item.description = "";
			$mdl.item.attachmentType = "";
			$mdl.item.attachmentLocation = "";
			$mdl.item.extraDescription = "";
			$mdl.item.continueAdd = item.continueAdd;
			
		} else if(item.mode==2) {
			$mdl.item.blobLocation = $mdl.item.attachmentLocation;
			if($mdl.item.attachmentLocation != "") {
				if($mdl.item.attachmentType) {

					if($mdl.item.attachmentType.substring(0,5)=="video") {
						$mdl.activeTab = 1;
						$mdl.item.blobLocation = $mdl.rootUrl + $mdl.item.attachmentLocation;
					} else if($mdl.item.attachmentType.substring(0,5)=="image") {
						$mdl.activeTab = 1;
						$mdl.item.blobLocation = $mdl.rootUrl + $mdl.item.attachmentLocation;
					}

					if($mdl.item.isVimeoConverted && $mdl.item.vimeoVideoId!=null && $mdl.item.vimeoVideoId!=''){
						$mdl.activeTab = 1;
						$mdl.item.finalVimeoUrl = 
							$sce.trustAsResourceUrl("https://player.vimeo.com/video/" + $mdl.item.vimeoVideoId);
					}
				}
			}
		}
		
		// Update Step
		$mdl.updateStep = function(obj) {
			$mdl.lockButton = true;		
			
			var element = {
				recipeId: obj.recipeId,
				id: obj.id,
				step: obj.step,
				name: obj.name,
				description: obj.description,
				extraDescription: obj.extraDescription,
				totalTimeSecond: obj.totalTimeSecond,
				enableTemperatureControl: obj.enableTemperatureControl,
				targetTemperatureCelcius: obj.targetTemperatureCelcius,
				attachmentType: obj.attachmentType,
				attachmentLocation: obj.attachmentLocation,
				thumbnail: obj.thumbnail
			};
			
			thumbnail = "";
			mediaLocation = "";
			mediaExtension = "";
			azureStorageUrl = "";
			localStorageUrl = "";
			var newFilename = UtilSvc.generateGuid() + ".";
			
			if($mdl.serverMode==1 && obj.mediaToUpload) {
				
				var extArray = obj.mediaToUpload.name.split(".");				
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = Auth.getCompanyId() + "/recipestep/" + newFilename + mediaExtension;
				element.attachmentType = $mdl.getMediaType(mediaExtension);
				
			} else if($mdl.serverMode==0 && obj.mediaToUpload) {	
			
				var extArray = obj.mediaToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = "recipestep/" + newFilename + mediaExtension;
				
			} else {
				if(element.attachmentLocation) {
					mediaLocation = element.attachmentLocation.replace("https://www.youtube.com/watch?v=", "");
					thumbnail = element.thumbnail;	
				}
			}
			element.isConvertedYoutube = true;
			element.attachmentLocation = mediaLocation;
			element.thumbnail = thumbnail;
						
			HttpSvc.put('recipesteps/' + obj.id, element, Auth.getTokenId(), false)
				.then(function(result) {
											
					if($mdl.serverMode==1 && obj.mediaToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + mediaLocation + result.azureSasToken;
						$mdl.uploadMedia(obj.mediaToUpload, obj.id);
						
					} else if($mdl.serverMode==0 && obj.mediaToUpload) {
						localStorageUrl = RmsApi.URL + "upload/recipestep/" + obj.id;
						$mdl.uploadMedia(obj.mediaToUpload, obj.id);
							
					} else {
						$uibModalInstance.close($mdl.item);
					}
				}, function(error) {
					$mdl.lockButton = false;
					$mdl.stepForm.$setPristine();
				});	
		};

		// Add Step
		$mdl.addStep = function(obj) {	
			$mdl.lockButton = true;			
			
			var element = {
				recipeId: $mdl.recipeId,
				step: obj.step,
				name: obj.name,
				description: obj.description,
				extraDescription: obj.extraDescription,
				totalTimeSecond: obj.totalTimeSecond,
				enableTemperatureControl: obj.enableTemperatureControl,
				targetTemperatureCelcius: obj.targetTemperatureCelcius,
				attachmentType: obj.attachmentType,
				attachmentLocation: obj.attachmentLocation,
				thumbnail: ''
			};
			
			thumbnail = "";
			mediaLocation = "";
			mediaExtension = "";
			azureStorageUrl = "";
			localStorageUrl = "";
			var newFilename = UtilSvc.generateGuid() + ".";
			
			if($mdl.serverMode==1 && obj.mediaToUpload) {
				
				var extArray = obj.mediaToUpload.name.split(".");				
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = Auth.getCompanyId() + "/recipestep/" + newFilename + mediaExtension;
				element.attachmentType = $mdl.getMediaType(mediaExtension);
				
			} else if($mdl.serverMode==0 && obj.mediaToUpload) {	
			
				var extArray = obj.mediaToUpload.name.split(".");
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = "recipestep/" + newFilename + mediaExtension;
				element.attachmentType = $mdl.getMediaType(mediaExtension);

			}
			element.IsConvertedYoutube = true;
			element.attachmentLocation = mediaLocation;
			
			HttpSvc.post('recipesteps', element, Auth.getTokenId(), false)
				.then(function(result) {
											
					if($mdl.serverMode==1 && obj.mediaToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + mediaLocation + result.azureSasToken;
						$mdl.uploadMedia(obj.mediaToUpload, result.id);
						
					} else if($mdl.serverMode==0 && obj.mediaToUpload) {
						localStorageUrl = RmsApi.URL + "upload/recipestep/" + result.id;
						$mdl.uploadMedia(obj.mediaToUpload, result.id);
					
					} else {
						$uibModalInstance.close($mdl.item);
					}
					//vm.recipe.recipeSteps.push(element);
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					$mdl.lockButton = false;
					$mdl.stepForm.$setPristine();
				});			
		};
		
		// ********************************************************
		
        var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		
		// Upload Image to Azure Blob Storage
		$mdl.uploadMedia = function (_fileToUpload, _recipeStepId) {
			
			/* Initialize variables */
			/* ************************************* */	
			handleFileSelect(_fileToUpload);
			/* ************************************* */	
			
			/* Initialize File Reader */
			/* ************************************* */
			fileReader = new FileReader();
			/* ************************************* */
			
			if($mdl.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (resp) {
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if($mdl.serverMode==1) { // Azure Server
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl, _recipeStepId);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl, _recipeStepId);
							} else {
								$mdl.lockButton = false;					
								$mdl.stepForm.$setPristine();
							} 
						}, null, function(evt) {
							$mdl.uploadProgessTotal = _fileToUpload.size;
							$mdl.uploadProgess = $mdl.uploadProgessTotal - totalBytesRemaining;
							$mdl.uploadProgessPercent = Math.min(100, parseInt(100.0 * $mdl.uploadProgess / $mdl.uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl, _recipeStepId) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl, _recipeStepId);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl, _recipeStepId) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,
				
			}).then(function(response) {
				HttpSvc.put('mediaconversion/ready/recipestep/' + _recipeStepId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Media uploaded successfully.");
						$uibModalInstance.close($mdl.item);
					}, function(error) {
					});
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }
		
		// ********************************************************		
		
		//Set Upload Media
		$mdl.setUploadMedia = function(mediaFile) {
			$mdl.item.mediaToUpload = mediaFile;
		}
		
		// Confirm Action
		$mdl.confirmModal = function() {			
			if($mdl.stepForm.$valid) {
				if(item.mode==1) {
					$mdl.addStep($mdl.item);	
				} else if(item.mode==2) {
					$mdl.updateStep($mdl.item);
				}
				
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Get Content Type
		$mdl.getMediaType = function(mediaExtension) {
			mediaExtension = mediaExtension.toLowerCase();
			
			if(mediaExtension=='jpg' || mediaExtension=='jpeg') {
				return "image";
			} else if(mediaExtension=='png') {
				return "image";
			} else if(mediaExtension=='gif') {
				return "image";
			} else if(mediaExtension=='mp4') {
				return "video";	
			} else if(mediaExtension=='3gp') {
				return "video";	
			} else if(mediaExtension=='mov') {
				return "video";
			}
		};
	};	
    
    /** @ngInject */
    function RecipeManageQuickSearchDialogCtrl($uibModalInstance, Auth, RmsApi, HttpSvc, UtilSvc, toastr) {
		var $mdl = this;
  
		$mdl.recipeList = [];
		$mdl.searchText = "";
		$mdl.isLoading = false;
		$mdl.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
  
		/* ********************************************************* */
						  
		$mdl.searchRecipe = function() {
			$mdl.isLoading = true;

			HttpSvc.post('recipes/listByCompany/' + encodeURIComponent($mdl.searchText), {}, Auth.getTokenId(), true)
			  	.then(function(result) {
					$mdl.recipeList = result;
					
					$mdl.recipeList.forEach(function(r) {
						if(r.thumbnail!=null && r.thumbnail!='') {
							r.thumbnail = $mdl.rootUrl + r.thumbnail;
						}
						if(r.imageLocation!=null && r.imageLocation!='') {
							r.imageLocation = $mdl.rootUrl + r.imageLocation;
						}
					});					

					$mdl.isLoading = false;
			  	}, function(error) {
					toastr.error(error, "Search Failed");
					$mdl.isLoading = false;
			  	});
		};
		
		// Cancel Action
		$mdl.cancelModal = function() {
		  	$uibModalInstance.dismiss('cancel');
		};
	};	
	
	function checkProductExist(i, obj) {
		if((i.itemId==obj.itemId && i.itemId!="" && i.itemId!=null) ||
            (i.semiFinishedProductId==obj.semiFinishedProductId && i.semiFinishedProductId!="" && i.semiFinishedProductId!=null))
            {
            return true;
        }
        return false;
  }
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.reportinquiry.controller', [])
        .controller('ReportInquiryCtrl', ReportInquiryCtrl);

    /** @ngInject */
    function ReportInquiryCtrl($scope, $filter, $state, $q, $uibModal, $timeout, Auth, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.inq = {};
		vm.inq.dateRange = {startDate: null, endDate: null};
		vm.isLoading = false;

		/* ***************************************************************************** */

		vm.drPickerOptions = {
			//pickerClasses: 'custom-display',
			//buttonClasses: 'btn',
			//applyButtonClasses: 'btn-primary',
			//cancelButtonClasses: 'btn-danger',
			locale: {
				//applyLabel: "Apply",
				//cancelLabel: 'Cancel',
				//customRangeLabel: 'Custom range',
				separator: ' to ',
				format: "DD-MMM-YYYY", //will give you 2017-01-06
				//format: "D-MMM-YY", //will give you 6-Jan-17
				//format: "D-MMMM-YY", //will give you 6-January-17
			},
			eventHandlers: {
				'apply.daterangepicker': function(event, picker) { 
					var startDate = new Date(vm.inq.dateRange.startDate);
					startDate.setDate(startDate.getDate() + 2);
					vm.inq.dateRange.startDate = startDate;
					//console.log(startDate);
				}
			}
		};

		/* ***************************************************************************** */
		
		vm.loadReports = function() {
			
			HttpSvc.get('reports/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.reports = result;
					vm.isLoading = false;
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data. ' + error, '');
					return null;
				});
		}

		/* ***************************************************************************** */
      
		// Init Data
		vm.loadReports();
	};
	

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.tracktrace.controller', [])
        .controller('TrackTraceCtrl', ReportsCtrl);

    /** @ngInject */
    function ReportsCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.job = {};
		vm.tracktrace = [];
		vm.serialNo = "";
		vm.isLoading = false;
		
		vm.printJobTrace = function(jobId, jobNo) {
			
			var filename = "JOBTRACE_" + jobNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('jobs/print/trace/' + jobId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to generate Job Traceability Report. ' + error, '');
							return null;
						});
		}
		
		vm.submit = function(dataForm) {
			vm.isLoading = true;
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;				
			} else {
						
				var params = {
					 serialNo: vm.serialNo
				}	
				HttpSvc.post('inventory/products/trace', params, Auth.getTokenId(), false)
					.then(function(result) {	
						vm.job = result;
						vm.tracktrace = vm.job.ingredientList;
						vm.job.withdrawalRequestList.forEach(function (e) {vm.tracktrace.push(e)});
						vm.job.stockReturnedList.forEach(function (e) {vm.tracktrace.push(e)});
						vm.job.returnedWithdrawalRequestList.forEach(function (e) {vm.tracktrace.push(e)});
						vm.isLoading = false;
					}, function(error) {
						HttpSvc.post('inventory/semifgs/trace', params, Auth.getTokenId(), false)
							.then(function(result) {	
								vm.job = result;
								vm.tracktrace = vm.job.ingredientList;
								vm.job.withdrawalRequestList.forEach(function (e) {vm.tracktrace.push(e)});
								vm.job.stockReturnedList.forEach(function (e) {vm.tracktrace.push(e)});
								vm.job.returnedWithdrawalRequestList.forEach(function (e) {vm.tracktrace.push(e)});
								vm.isLoading = false;
							}, function(error) {
								vm.job = {};
								vm.isLoading = false;
								toastr.error('Failed to retrieve data. ' + error, '');
								return null;
							});
					});
			}
		}
    }
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.requisitions.reqapproval.controller', [])
        .controller('RequisitionApprovalMainCtrl', RequisitionApprovalMainCtrl)
        .controller('RequisitionApprovalUpdateCtrl', RequisitionApprovalUpdateCtrl);

    /** @ngInject */
    function RequisitionApprovalMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.currencyCode = Auth.getCurrency();
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.reqDataFull = [];
		vm.reqData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.reqDataFull, tableState.search.predicateObject) : vm.reqDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.reqData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.reqDataFull.length <= 0) {
				HttpSvc.get('requisitions/list/CONFIRMED', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.reqDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};		
		
		// Approve Requisition
		vm.approveRequisition = function(itemId) {
			vm.lockButtons = true;		
			
			HttpSvc.put('requisitions/approve/' + itemId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Requisition has been APPROVED.', 'Approved');
					$state.reload();
					vm.lockButtons = false;
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}
		
		// Cancel Requisition
		vm.cancelRequisition = function(itemId) {
			vm.lockButtons = true;
			
			HttpSvc.put('requisitions/cancel/' + itemId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Requisition has been CANCELLED.', 'Cancelled');
					$state.reload();
					vm.lockButtons = false;
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}
	};
	
	/** @ngInject */
    function RequisitionApprovalUpdateCtrl($scope, $state, $stateParams, $filter, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;
		vm.canAccessFoodCost = false;
		
		vm.reqStatuses = [ 
			{id: 'PENDING', name: 'PENDING'}, 
			{id: 'CONFIRMED', name: 'CONFIRMED'},
			{id: 'COMPLETED', name: 'COMPLETED'}, 
			{id: 'CANCELLED', name: 'CANCELLED'}
		];
		vm.mode = 2;
		vm.uomList = [];
		
		vm.pageSizeOption = [10, 30, 50, 100];
		vm.pageSize = 30;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.requisition = {};
		vm.requisition.requisitionItems = [];
		vm.requisition.itemsFiltered = [];
		vm.isLoading = false;
		vm.lockButtons = false;

		/* ****************************************************** */
		
		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? 
								$filter('filter')(vm.requisition.requisitionItems, tableState.search.predicateObject) : 
								vm.requisition.requisitionItems;
			vm.numOfRecordFiltered = filtered.length;
			
			filtered = $filter('orderBy')(filtered, ["-quantity", "description"], false);
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.requisition.itemsFiltered = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.requisition.requisitionItems.length <= 0) {
				vm.isLoading = true;
				
				var params = { id: $stateParams.id };
				HttpSvc.get('requisitions/:id', params, Auth.getTokenId(), false)
					.then(function(result) {
						vm.requisition = result;
						vm.reqStatuses.forEach(function(sts) {
							if(sts.id==vm.requisition.status){
								vm.reqStatuses.selected = sts;
							}
						});
						vm.numOfRecord = vm.requisition.requisitionItems.length;
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to load selected Requisition.', Auth.translate('ERROR'))
						$state.go('requisitions.reqapproval');
						return;
					});					
			} else {
				vm.isLoading = false;
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		/* ****************************************************** */
		
		vm.initData = function() {
			vm.lockButtons = false;
			vm.canAccessFoodCost = Auth.canAccessFoodCost();
		}
		
		/* ****************************************************** */
		
		// Select Requisition Status
		vm.selectRequisitionStatus = function(item) {
			vm.requisition.status = item.id;
		};
		
		// Cancel Requisition
		vm.approveRequisition = function() {
			vm.lockButtons = true;		
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {	
				vm.requisition.requisitionItems.forEach( function(i) {
					i.unitOfMeasurementId = i.uom.id;
				});					
				HttpSvc.put('requisitions/approve/' + $stateParams.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Requisition has been approved.', 'Approved');
						$state.go('requisitions.reqapproval');
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}
		
		// Cancel Requisition
		vm.cancelRequisition = function() {
			vm.lockButtons = true;
			
			HttpSvc.put('requisitions/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Requisition has been cancelled.', 'CANCELLED');
					$state.go('requisitions.reqapproval');
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		}	
		
		// Form Submission
		vm.submit = function() {
			vm.lockButtons = true;
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {	
				vm.requisition.requisitionItems.forEach( function(i) {
					i.unitOfMeasurementId = i.uom.id;
				});				 
				HttpSvc.put('requisitions/' + $stateParams.id, vm.requisition, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Requisition has been updated successfully.', Auth.translate('SUCCESS'));
						vm.lockButtons = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}
		
		// Call Actions
		vm.initData();	
	}
})();

(function () {
    'use strict';

    angular.module('RmsAppV2.pages.requisitions.reqlist.controller', [])
        .controller('RequisitionMainCtrl', RequisitionMainCtrl)
        .controller('RequisitionCreateCtrl', RequisitionCreateCtrl)
        .controller('RequisitionUpdateCtrl', RequisitionUpdateCtrl)
        .controller('RequisitionApprovalModalCtrl', RequisitionApprovalModalCtrl);

    /** @ngInject */
    function RequisitionMainCtrl(Auth, HttpSvc, RmsApi, toastr) {

        Auth.init();

        var vm = this;

		vm.currencyCode = Auth.getCurrency();
        vm.pageSizeOption = [10, 20, 50, 100];
        vm.pageSize = 10;
        vm.numOfRecord = 0;
        vm.numOfPages = 0;
        vm.startIndex = 0;
        vm.endIndex = 0;
        vm.data = [];
        vm.dataFilter = {};
        vm.isLoading = false;

        vm.getApiParams = function (tableState) {
            if (tableState.search.predicateObject == null) {
                tableState.sort = {};
                tableState.search.predicateObject = {};
                tableState.pagination.start = 0;
            }

            var predicate = tableState.search.predicateObject;
            var sortBy = tableState.sort.predicate;
            var sortReverse = tableState.sort.reverse ? "1" : "0";

            var params = {
                keyword: predicate.requisitionNo,
                branchName: predicate.branchName,
                departmentName: predicate.departmentName,
                userName: predicate.userName,
                status: predicate.status,
                isSameBranch: predicate.isSameBranch,
                isOpenDoc: predicate.isOpenDoc,
                sortBy: sortBy,
                sortReverse: sortReverse,
                pageSize: vm.pageSize,
                pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
            };

            return params;
        }

        vm.retrieveData = function (tableState) {

            var pagination = tableState.pagination;

            vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
            vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

            vm.isLoading = true;

            var params = vm.getApiParams(tableState);

            HttpSvc.post('requisitions/lazyload/list', params, Auth.getTokenId(), false)
                .then(function (result) {
                    vm.isLoading = false;
                    vm.data = result.data;
                    vm.numOfRecord = result.numberOfRecords;
                    vm.numOfPages = result.numberOfPages;
                    refreshTableState(tableState, vm.startIndex, vm.endIndex);
                }, function (error) {
                    vm.isLoading = false;
                    toastr.error('Failed to retrieve data.', '');
                    return null;
                });
        };

        function refreshTableState(tableState) {
            tableState.pagination.numberOfPages = vm.numOfPages;

            return tableState;
        };

        vm.resetSearch = function () {
        }

        vm.printRequisition = function (reqId, reqNo) {

            var filename = "REQUISITION_" + reqNo.replace("/", "_") + ".pdf";

            HttpSvc.getPdfObject('requisitions/print/' + reqId, Auth.getTokenId(), filename)
                .then(
                    null,
                    function (error) {
                        // Failed
                        toastr.error('Failed to generate Requisition PDF. ' + error, '');
                        return null;
                    });
        }

        // Init Call
        //vm.loadFilters();
    };

    /** @ngInject */
    function RequisitionCreateCtrl($scope, $state, $filter, $interval, $timeout, Auth, HttpSvc, toastr) {
        Auth.init();

        var vm = this;

        vm.isRmsLite = Auth.isLiteMode();
        vm.hasAutofillAccess = Auth.hasPerm('requisitions.reqlist-autofill', 'ACCESS');

        vm.reqStatuses = [
            { id: 'PENDING', name: 'PENDING' },
            { id: 'CONFIRMED', name: 'CONFIRMED' }
        ];
        vm.mode = 1;
        vm.originalStatus = 'PENDING';
        vm.canAccessFoodCost = false;
        vm.timeTaken = 0;

        vm.pageSizeOption = [10, 30, 50, 100];
        vm.pageSize = 10;
        vm.numOfRecord = 0;
        vm.numOfRecordFiltered = 0;
        vm.numOfRecordDisplayed = 0;
        vm.startIndex = 0;
        vm.endIndex = 0;
        vm.requisition = {};
        vm.requisition.requisitionItems = [];
        vm.requisition.itemsFiltered = [];
        vm.branches = [];
        vm.selectedBranch = null;
        vm.isLoading = false;
        vm.isAnalyzing = false;
        vm.userBranchId = Auth.getBranchId();
        vm.currencyCode = Auth.getCurrency();

        /* ****************************************************** */

        function refreshTableState(tableState, startIndex, endIndex) {

            var filtered = tableState.search.predicateObject ?
                $filter('filter')(vm.requisition.requisitionItems, tableState.search.predicateObject) :
                vm.requisition.requisitionItems;
            vm.numOfRecordFiltered = filtered.length;

            filtered = $filter('orderBy')(filtered, ["-quantity", "description"], false);
            var result = filtered.slice(startIndex, startIndex + endIndex);

            vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
            vm.requisition.itemsFiltered = result;

            tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

            return tableState;
        };

        vm.retrieveData = function (tableState) {

            var params = {}
            var pagination = tableState.pagination;
            vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
            vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

            if (vm.requisition.requisitionItems.length <= 0 && !vm.isLoading) {
                vm.isLoading = true;
                vm.timerTick();
                vm.interval = $interval(vm.timerTick, 1000);

                var branchId = vm.selectedBranch == null ? '' : '/' + vm.selectedBranch.id;

                // Load Requisition Items
                HttpSvc.get('requisitions/analyze' + branchId, {}, Auth.getTokenId(), true)
                    .then(function (result) {
                        vm.isLoading = false;
                        vm.numOfRecord = result.length;
                        vm.requisition.requisitionItems = result;

                        refreshTableState(tableState, vm.startIndex, vm.endIndex);
                        $interval.cancel(vm.interval);
                    }, function (error) {
                        vm.isLoading = false;
                        toastr.error(error, Auth.translate('ERROR'));
                        return null;
                    });
            } else {
                refreshTableState(tableState, vm.startIndex, vm.endIndex);
            }
        };

        /* ****************************************************** */

        vm.initData = function () {
            vm.reqStatuses.selected = { id: 'PENDING', name: 'PENDING' };
            vm.requisition.status = "PENDING";
            vm.requisition.remarks = "";
            vm.lockButtons = false;
            vm.canAccessFoodCost = Auth.canAccessFoodCost();

            vm.showTimer = true;
            vm.loadBranches();
        }

        vm.timerTick = function () {
            vm.timeTaken += 1;
        }

        // Perform Requisition Analysis
        vm.requisitionAnalysis = function () {
            vm.isAnalyzing = true;

            var branchId = vm.selectedBranch == null ? '' : '/' + vm.selectedBranch.id;

            HttpSvc.get('requisitions/analyze/:id' + branchId, {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.requisition.requisitionItems = result;

                    vm.requisition.requisitionItems.forEach(function (item) {
                        item.quantity = item.recommendedOrderQty;
                    });

                    vm.requisition.requisitionItems.sort(function (a, b) {
                        return b.quantity - a.quantity;
                    });

                    vm.isAnalyzing = false;
                    toastr.info('', 'Recommended Order Quantity have been populated.');
                }, function () {
                    vm.isAnalyzing = false;
                    toastr.error('Failed to retrieve data for analysis.', 'Error');
                });

            vm.pageSize = 30;
            $timeout(function () { vm.pageSize = 10; }, 300);

        }

        // Load Branches
        vm.loadBranches = function () {

            vm.branches = Auth.getCompanyBranches();

            vm.branches.forEach(function (b) {
                if (b.id == vm.userBranchId) {
                    vm.selectedBranch = b;
                }
            });
            // HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
            // 	.then(function(result) {
            // 		vm.branches = result;

            // 		vm.branches.forEach(function(b) {
            // 			if(b.id==vm.userBranchId)
            // 			{
            // 				vm.selectedBranch = b;
            // 			}
            // 		});
            // 	}, function() {
            // 		// Failed
            // 		toastr.error('Failed to retrieve data.', '');
            // 		return null;
            // 	});
        }

        // Selected Branch Changed
        vm.selectedBranchChanged = function () {
            vm.requisition.requisitionItems = [];
            vm.requisition.itemsFiltered = [];
            $scope.$broadcast('refreshStTable');
        }

        /* ****************************************************** */

        // Select Requisition Status
        vm.selectRequisitionStatus = function () {
            vm.requisition.status = vm.reqStatuses.selected.id;
        };

        vm.calculateGrandTotal = function () {
            var grandTotal = (vm.requisition.requisitionItems || []).reduce((sum, e) => sum + ((e.quantity || 0) * (e.cost || 0)), 0);
            vm.requisition.grandTotal = grandTotal ?? 0.0;
        }

        // Form Submission
        vm.submit = function () {
            vm.lockButtons = true;

            if (vm.dataForm.$invalid) {
                toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
                vm.lockButtons = false;
            } else {
                vm.calculateGrandTotal();
                HttpSvc.post('requisitions/add', vm.requisition, Auth.getTokenId(), false)
                    .then(function (result) {
                        toastr.success('Requisition has been created successfully.', Auth.translate('SUCCESS'));
                        $state.go('requisitions.reqlist.list');
                    }, function (error) {
                        toastr.error(error, 'Failed');
                        vm.lockButtons = false;
                    });
            }
        }

        // Call Actions
        vm.initData();
    }

    /** @ngInject */
    function RequisitionUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {

        Auth.init();

        var vm = this;

        vm.isRmsLite = Auth.isLiteMode();
        vm.hasAutofillAccess = Auth.hasPerm('requisitions.reqlist-autofill', 'ACCESS');

        vm.reqStatuses = [
            { id: 'PENDING', name: 'PENDING' },
            { id: 'CONFIRMED', name: 'CONFIRMED' }
        ];
        vm.mode = 2;
        vm.originalStatus = 'Cancelled';
        vm.canAccessFoodCost = false;

        vm.pageSizeOption = [10, 30, 50, 100];
        vm.pageSize = 10;
        vm.numOfRecord = 0;
        vm.numOfRecordFiltered = 0;
        vm.numOfRecordDisplayed = 0;
        vm.startIndex = 0;
        vm.endIndex = 0;
        vm.requisition = {};
        vm.requisition.requisitionItems = [];
        vm.requisition.itemsFiltered = [];
        vm.branches = [];
        vm.isLoading = false;
        vm.currencyCode = Auth.getCurrency();

        /* ****************************************************** */

        function refreshTableState(tableState, startIndex, endIndex) {

            var filtered = tableState.search.predicateObject ?
                $filter('filter')(vm.requisition.requisitionItems, tableState.search.predicateObject) :
                vm.requisition.requisitionItems;
            vm.numOfRecordFiltered = filtered.length;

            filtered = $filter('orderBy')(filtered, ["-quantity", "description"], false);
            var result = filtered.slice(startIndex, startIndex + endIndex);

            vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
            vm.requisition.itemsFiltered = result;

            tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

            return tableState;
        };

        vm.reanalyzeRequisition = function (tableState) {
             HttpSvc.get('requisitions/analyze/' + vm.requisition.branchId, {}, Auth.getTokenId(), true)
                    .then(function (result) {
                        vm.isLoading = false;
                        vm.requisition.requisitionItems.forEach(function (r) {
                            var index = result.findIndex(function (e) {
                                return (e.itemId.toLowerCase() == r.itemId.toLowerCase());
                            })
                            if (index != -1) {
                                r.stockBalance = result[index].stockBalance;
                                r.recommendedOrderQty = result[index].recommendedOrderQty;
                                r.onOrderQuantity = result[index].onOrderQuantity;
                                r.salesOrderQty = result[index].salesOrderQty;
                                r.bulkBreakJobQty = result[index].bulkBreakJobQty;
                                r.stockTransferQty = result[index].stockTransferQty;
                                r.jobProductionQty = result[index].jobProductionQty;
                                r.parLevel = result[index].parLevel;
                                r.reOrderLevel = result[index].reOrderLevel;
                                r.reOrderQuantity = result[index].reOrderQuantity;
                                r.noOfPendingQty = result[index].noOfPendingQty;
                                r.noOfConfirmedQty = result[index].noOfConfirmedQty;
                            }
                        });
                    }, function (error) {
                        vm.isLoading = false;
                        toastr.error(error, Auth.translate('ERROR'));
                        return null;
                    });
        }

        vm.retrieveData = function (tableState) {

            var params = {}
            var pagination = tableState.pagination;
            vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
            vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

            if (vm.requisition.requisitionItems.length <= 0) {
                vm.isLoading = true;

                var params = { id: $stateParams.id };
                HttpSvc.get('requisitions/:id', params, Auth.getTokenId(), false)
                    .then(function (result) {
                        vm.requisition = result;
                        vm.originalStatus = vm.requisition.status;

                        vm.reqStatuses.forEach(function (sts) {
                            if (sts.id == vm.requisition.status) {
                                vm.reqStatuses.selected = sts;
                            }
                        });

                        if (vm.requisition.status.toUpperCase() == 'PENDING') {
                            vm.reanalyzeRequisition(tableState);
                        }

                        vm.numOfRecord = vm.requisition.requisitionItems.length;
                        refreshTableState(tableState, vm.startIndex, vm.endIndex);

                        vm.isLoading = false;
                    }, function () {
                        vm.isLoading = false;
                        toastr.error('Failed to load selected Requisition.', Auth.translate('ERROR'))
                        $state.go('requisitions.reqlist');
                        return;
                    });
            } else {
                refreshTableState(tableState, vm.startIndex, vm.endIndex);
            }
        };

        /* ****************************************************** */

        vm.initData = function () {
            vm.lockButtons = false;
            vm.canAccessFoodCost = Auth.canAccessFoodCost();
        }

        // Perform Requisition Analysis
        vm.requisitionAnalysis = function () {
            vm.isAnalyzing = true;
            vm.requisition.requisitionItems.forEach(function (item) {
                item.quantity = item.recommendedOrderQty;
            });

            vm.requisition.requisitionItems.sort(function (a, b) {
                return b.quantity - a.quantity;
            });

            vm.isAnalyzing = false;
            toastr.success('Analysis completed.', 'Completed');
        }

        // Load Branches
        vm.loadBranches = function () {

            vm.branches = Auth.getCompanyBranches();

            vm.branches.forEach(function (b) {
                if (b.id == vm.userBranchId) {
                    vm.selectedBranch = b;
                }
            });
        }

        /* ****************************************************** */

        // Select Requisition Status
        vm.selectRequisitionStatus = function (item) {
            vm.requisition.status = vm.reqStatuses.selected.id;
        };

        // Cancel Requisition
        vm.cancelRequisition = function () {
            vm.lockButtons = true;

            HttpSvc.put('requisitions/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
                .then(function (result) {
                    toastr.success('Requisition has been cancelled.');
                    $state.go('requisitions.reqlist');
                }, function (error) {
                    toastr.error(error, 'Failed');
                    vm.lockButtons = false;
                });
        }

        vm.printRequisition = function () {

            var filename = "REQUISITION_" + vm.requisition.requisitionNo.replace("/", "_") + ".pdf";

            HttpSvc.getPdfObject('requisitions/print/' + vm.requisition.id, Auth.getTokenId(), filename)
                .then(
                    null,
                    function (error) {
                        // Failed
                        toastr.error('Failed to generate Requisition PDF. ' + error, '');
                        return null;
                    });
        }

        vm.calculateGrandTotal = function () {
            var grandTotal = (vm.requisition.requisitionItems || []).reduce((sum, e) => sum + ((e.quantity || 0) * (e.cost || 0)), 0);
            vm.requisition.grandTotal = grandTotal ?? 0.0;
        }

        // Form Submission
        vm.submit = function () {
            vm.lockButtons = true;

            if (vm.dataForm.$invalid) {
                toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
                vm.lockButtons = false;
            } else {
                vm.requisition.requisitionItems.forEach(function (i) {
                    i.unitOfMeasurementId = i.uom.id;
                });
                vm.calculateGrandTotal();
                HttpSvc.put('requisitions/' + $stateParams.id, vm.requisition, Auth.getTokenId(), false)
                    .then(function (result) {
                        toastr.success('Requisition has been updated successfully.', Auth.translate('SUCCESS'));
                        $state.go('requisitions.reqlist');
                    }, function (error) {
                        toastr.error(error, 'Failed');
                        vm.lockButtons = false;
                    });
            }
        }

        /* ****************************************************** */

        vm.showApprovalModal = function (grn) {

            var modalInstance = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'approvalModal.html',
                controller: 'RequisitionApprovalModalCtrl',
                controllerAs: '$mdl',
                size: 'md',
                resolve: {
                    item: function () {
                        return {
                            docId: vm.requisition.id,
                            docNo: vm.requisition.requisitionNo,
                            isCreateFromStoreOrdering: vm.requisition.isCreateFromStoreOrdering,
                        }
                    }
                }
            });

            modalInstance
                .result
                .then(function (data) {
                    $state.go('requisitions.reqlist');
                }, function () {
                });
        };

        /* ****************************************************** */

        // Call Actions
        vm.initData();
    }

    /** @ngInject */
    function RequisitionApprovalModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
        var $mdl = this;
        $mdl.docId = item.docId;
        $mdl.docNo = item.docNo;
        $mdl.isCreateFromStoreOrdering = item.isCreateFromStoreOrdering == null ? false : item.isCreateFromStoreOrdering;
        $mdl.lockButtons = false;

        // ********************************************************

        $mdl.approve = function () {
            $mdl.lockButtons = true;

            var params = {
                requisitionId: $mdl.docId
            };

            HttpSvc.put('approvalcenters/approve', params, Auth.getTokenId(), false)
                .then(function (result) {
                    toastr.success('Document has been approved successfully.', Auth.translate('SUCCESS'));
                    $uibModalInstance.close();
                }, function (error) {
                    toastr.error(error, 'Failed To Approve');
                    $mdl.lockButtons = false;
                });
        };

        $mdl.disapprove = function () {
            $mdl.lockButtons = true;

            var params = {
                requisitionId: $mdl.docId
            };

            HttpSvc.put('approvalcenters/disapprove', params, Auth.getTokenId(), false)
                .then(function (result) {
                    toastr.success('Document has been disapproved.', Auth.translate('SUCCESS'));
                    $uibModalInstance.close();
                }, function (error) {
                    toastr.error(error, 'Failed To Disapprove');
                    $mdl.lockButtons = false;
                });
        };

        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };
})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.categories.controller', [])
			.controller('KioskCategoriesMainCtrl', KioskCategoriesMainCtrl)
			.controller('KioskCategoriesCreateCtrl', KioskCategoriesCreateCtrl)
			.controller('KioskCategoriesUpdateCtrl', KioskCategoriesUpdateCtrl);

	/** @ngInject */
	function KioskCategoriesMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.cateDataFull = [];
		vm.cateData = [];
		vm.isLoading=false;
		vm.blobUrl = RmsApi.BLOBURL;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.cateDataFull, tableState.search.predicateObject) : vm.cateDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.cateData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.cateDataFull.length <= 0) {	
				vm.isLoading=true;

				HttpSvc.get('kioskv3categories/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.cateDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading=false;
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						vm.isLoading=false;
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteData = function(mappingId) {
			var params = {};
			HttpSvc.delete('kioskv3categories/' + mappingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('kioskv3categories/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.cateDataFull = result;
							
							toastr.success('Product Category has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Product Category.', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function KioskCategoriesCreateCtrl($scope, $state, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.cate = {};
		vm.cate.imageLocation = 'assets/img/empty_placeholder.png';	
		vm.cate.isActive = true;
		vm.fileToUpload = null;
		vm.blobUrl = RmsApi.BLOBURL;
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;

		/* ******************************************************************* */

		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {		
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				

				if(vm.serverMode==1 && vm.fileToUpload) {
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/kioskproductcategory/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "kioskproductcategory/" + newFilename + mediaExtension;
				}
				vm.cate.imageLocation = imgLocation;

				HttpSvc.post('kioskv3categories', vm.cate, Auth.getTokenId(), false)
					.then(function(result) {
												
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(result.id);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/kioskproductcategory/" + vm.categoryId;
							vm.uploadImage(result.id);
							
						} else {							
							toastr.success('Product Category has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('robotkiosk.categories.update', {'id': result.id });
						}
						
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (categoryId) {
			var fileReader = new FileReader();
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId()},
				}).then(function (resp) {
					toastr.success('Product Category has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('robotkiosk.categories.update', {'id': categoryId });
				}, function (resp) {
					toastr.success('Product Category has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('robotkiosk.categories.update', {'id': categoryId });
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(vm.serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {									
							toastr.success('Product Category has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('robotkiosk.categories.update', {'id': categoryId });
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};
		
		// Call Action
		// Do nothing
	}

	/** @ngInject */
	function KioskCategoriesUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.cate = {};
		vm.cate.imageLocation = 'assets/img/empty_placeholder.png';	
		vm.cate.oriImageLocation = "";
		vm.fileToUpload = null;
		vm.blobUrl = RmsApi.BLOBURL;
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;

		/* ******************************************************************* */
						
		// Load Mapping
		vm.loadCategory = function() {	

			var params = { id: $stateParams.id };
			HttpSvc.get('kioskv3categories/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.cate = result;				
					
					if(!vm.cate.imageLocation || vm.cate.imageLocation=='') {
						vm.cate.imageLocation = 'assets/img/empty_placeholder.png';
						vm.cate.oriImageLocation = "";
					} else {
						vm.cate.oriImageLocation = vm.cate.imageLocation;
						vm.cate.imageLocation = vm.blobUrl + vm.cate.imageLocation;
					}

					vm.isLoading = false;

				}, function() {
					toastr.error('Failed to load selected Product Category.', Auth.translate('ERROR'))
					$state.go('robotkiosk.categories.list');
					return;
				});		
		};	
		
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		vm.submit = function() {
			vm.isLoading = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				

				if(vm.serverMode==1 && vm.fileToUpload) {
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/kioskproductcategory/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "kioskproductcategory/" + newFilename + mediaExtension;

				} else if(vm.cate.oriImageLocation!="") {
					imgLocation = vm.cate.oriImageLocation;
				}
				vm.cate.imageLocation = imgLocation;

				HttpSvc.put('kioskv3categories/' + $stateParams.id, vm.cate, Auth.getTokenId(), false)
					.then(function(result) {	

						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage($stateParams.id);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/kioskproductcategory/" + $stateParams.id;
							vm.uploadImage($stateParams.id);
							
						} else {							
							toastr.success('Product Category has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						}

					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (categoryId) {
			var fileReader = new FileReader();
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId()},
				}).then(function (resp) {
					toastr.success('Product Category has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('Product Category has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(vm.serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {									
							toastr.success('Product Category has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};
		
		// Call Action
		vm.loadCategory();	
	}

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.equipmenttypes.controller', [])
			.controller('KioskEquipmentTypesMainCtrl', KioskEquipmentTypesMainCtrl)
			.controller('KioskEquipmentTypesCreateCtrl', KioskEquipmentTypesCreateCtrl)
			.controller('KioskEquipmentTypesUpdateCtrl', KioskEquipmentTypesUpdateCtrl);

	/** @ngInject */
	function KioskEquipmentTypesMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.typeDataFull = [];
		vm.typeData = [];
		vm.isLoading=false;
		vm.blobUrl = RmsApi.BLOBURL;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.typeDataFull, tableState.search.predicateObject) : vm.typeDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.typeData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.typeDataFull.length <= 0) {	
				vm.isLoading=true;

				HttpSvc.get('kioskv3equipmenttypes/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.typeDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading=false;
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						vm.isLoading=false;
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteData = function(typeId) {
			var params = {};
			HttpSvc.delete('kioskv3equipmenttypes/' + typeId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('kioskv3equipmenttypes/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.typeDataFull = result;
							
							toastr.success('Equipment Type has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Equipment Type.', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function KioskEquipmentTypesCreateCtrl($scope, $state, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.type = {};
		vm.type.isActive = true;
		vm.isLoading = false;

		/* ******************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {	
				HttpSvc.post('kioskv3equipmenttypes', vm.type, Auth.getTokenId(), false)
					.then(function(result) {		
						toastr.success('Equipment Type has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('robotkiosk.equipmenttypes.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Action
		// Do Nothing
	}

	/** @ngInject */
	function KioskEquipmentTypesUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.type = {};
		vm.isLoading = false;

		/* ******************************************************************* */
						
		// Load Mapping
		vm.loadSize = function() {	
			vm.isLoading = true;

			var params = { id: $stateParams.id };
			HttpSvc.get('kioskv3equipmenttypes/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.type = result;
					vm.isLoading = false;
				}, function() {
					toastr.error('Failed to load selected Equipment Type.', Auth.translate('ERROR'))
					$state.go('robotkiosk.equipmenttypes.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {		
			vm.isLoading = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {
				HttpSvc.put('kioskv3equipmenttypes/' + $stateParams.id, vm.type, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Equipment Type has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Call Action
		vm.loadSize();	
	}

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.equipments.controller', [])
			.controller('KioskEquipmentsMainCtrl', KioskEquipmentsMainCtrl)
			.controller('KioskEquipmentsCreateCtrl', KioskEquipmentsCreateCtrl)
			.controller('KioskEquipmentsUpdateCtrl', KioskEquipmentsUpdateCtrl);

	/** @ngInject */
	function KioskEquipmentsMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageEquipmentOption = [10, 20, 50, 100];
		vm.pageEquipment = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.equipmentDataFull = [];
		vm.equipmentData = [];
		vm.isLoading=false;
		vm.blobUrl = RmsApi.BLOBURL;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.equipmentDataFull, tableState.search.predicateObject) : vm.equipmentDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.equipmentData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageEquipment; // Number of entries showed per page.
			
			if(vm.equipmentDataFull.length <= 0) {	
				vm.isLoading=true;

				HttpSvc.get('kioskv3equipments/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.equipmentDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading=false;
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						vm.isLoading=false;
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteData = function(mappingId) {
			var params = {};
			HttpSvc.delete('kioskv3equipments/' + mappingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('kioskv3equipments/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.equipmentDataFull = result;
							
							toastr.success('Kiosk Equipment has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Kiosk Equipment.', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function KioskEquipmentsCreateCtrl($scope, $state, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.equipment = {};
		vm.equipment.isActive = true;
		vm.isLoading = false;

		vm.kioskList = [];
		vm.eqTypeList = [];
		vm.storageListRM = [];
		vm.storageListSFG = [];
		vm.selectedKiosk = null;
		vm.selectedEqType = null;
		vm.selectedStorageRM = null;
		vm.selectedStorageSFG = null;

		/* ******************************************************************* */

		vm.loadKioskList = function() {
			vm.isLoading = true;

			HttpSvc.get('kiosksv3/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.kioskList = result;
					vm.loadEqTypeList();
				}, function() {
					toastr.error('Failed to load Kiosk List.', Auth.translate('ERROR'))
					$state.go('robotkiosk.equipments.list');
					return;
				});		
		}

		vm.loadEqTypeList = function() {
			vm.isLoading = true;

			HttpSvc.get('kioskv3equipmenttypes/list/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.eqTypeList = result;
					vm.loadStorageListRM();
				}, function() {
					toastr.error('Failed to load Equipment Type List.', Auth.translate('ERROR'))
					$state.go('robotkiosk.equipments.list');
					return;
				});		
		}

		vm.loadStorageListRM = function() {

			HttpSvc.get('storages/listbytypes/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageListRM = result;
					vm.loadStorageListSFG();
				}, function() {
					toastr.error('Failed to load Raw Material Storage List.', Auth.translate('ERROR'))
					$state.go('robotkiosk.equipments.list');
					return;
				});		
		}

		vm.loadStorageListSFG = function() {

			HttpSvc.get('storages/listbytypes/3', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageListSFG = result;
					vm.isLoading = false;
				}, function() {
					toastr.error('Failed to load Semi FG Storage List.', Auth.translate('ERROR'))
					$state.go('robotkiosk.equipments.list');
					return;
				});		
		}

		/* ******************************************************************* */

		vm.selectedKioskChanged = function() {
			vm.equipment.kioskId = vm.selectedKiosk.id;
		}
		
		vm.selectedEqTypeChanged = function() {
			vm.equipment.kioskEquipmentTypeId = vm.selectedEqType.id;
		}
		
		vm.selectedStorageRMChanged = function() {
			vm.equipment.rmStorageId = vm.selectedStorageRM.id;
		}
		
		vm.selectedStorageSFGChanged = function() {
			vm.equipment.sfgStorageId = vm.selectedStorageSFG.id;
		}

		vm.clearStorageRM = function() {
			vm.equipment.rmStorageId = null;
			vm.selectedStorageRM = null;
		}

		vm.clearStorageSFG = function() {
			vm.equipment.sfgStorageId = null;
			vm.selectedStorageSFG = null;
		}

		/* ******************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {	
				HttpSvc.post('kioskv3equipments', vm.equipment, Auth.getTokenId(), false)
					.then(function(result) {		
						toastr.success('Kiosk Equipment has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('robotkiosk.equipments.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Action
		vm.loadKioskList();
	}

	/** @ngInject */
	function KioskEquipmentsUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.equipment = {};
		vm.isLoading = false;
		
		vm.kioskList = [];
		vm.eqTypeList = [];
		vm.storageListRM = [];
		vm.storageListSFG = [];
		vm.selectedKiosk = null;
		vm.selectedEqType = null;
		vm.selectedStorageRM = null;
		vm.selectedStorageSFG = null;

		/* ******************************************************************* */

		vm.loadKioskList = function() {
			vm.isLoading = true;

			HttpSvc.get('kiosksv3/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.kioskList = result;
					vm.loadEqTypeList();
				}, function() {
					toastr.error('Failed to load Kiosk List.', Auth.translate('ERROR'))
					$state.go('robotkiosk.equipments.list');
					return;
				});		
		}

		vm.loadEqTypeList = function() {
			vm.isLoading = true;

			HttpSvc.get('kioskv3equipmenttypes/list/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.eqTypeList = result;
					vm.loadStorageListRM();
				}, function() {
					toastr.error('Failed to load Equipment Type List.', Auth.translate('ERROR'))
					$state.go('robotkiosk.equipments.list');
					return;
				});		
		}

		vm.loadStorageListRM = function() {

			HttpSvc.get('storages/listbytypes/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageListRM = result;
					vm.loadStorageListSFG();
				}, function() {
					toastr.error('Failed to load Raw Material Storage List.', Auth.translate('ERROR'))
					$state.go('robotkiosk.equipments.list');
					return;
				});		
		}

		vm.loadStorageListSFG = function() {

			HttpSvc.get('storages/listbytypes/3', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.storageListSFG = result;
					vm.loadEquipment();
				}, function() {
					toastr.error('Failed to load Semi FG Storage List.', Auth.translate('ERROR'))
					$state.go('robotkiosk.equipments.list');
					return;
				});		
		}

		/* ******************************************************************* */

		vm.selectedKioskChanged = function() {
			vm.equipment.kioskId = vm.selectedKiosk.id;
		}
		
		vm.selectedEqTypeChanged = function() {
			vm.equipment.kioskEquipmentTypeId = vm.selectedEqType.id;
		}
		
		vm.selectedStorageRMChanged = function() {
			vm.equipment.rmStorageId = vm.selectedStorageRM.id;
		}
		
		vm.selectedStorageSFGChanged = function() {
			vm.equipment.sfgStorageId = vm.selectedStorageSFG.id;
		}

		vm.clearStorageRM = function() {
			vm.equipment.rmStorageId = null;
			vm.selectedStorageRM = null;
		}

		vm.clearStorageSFG = function() {
			vm.equipment.sfgStorageId = null;
			vm.selectedStorageSFG = null;
		}

		/* ******************************************************************* */
						
		// Load Mapping
		vm.loadEquipment = function() {	
			vm.isLoading = true;

			var params = { id: $stateParams.id };
			HttpSvc.get('kioskv3equipments/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.equipment = result;

					vm.kioskList.forEach(function(k) {
						if(k.id==vm.equipment.kioskId)
						{
							vm.selectedKiosk = k;
						}
					});

					vm.eqTypeList.forEach(function(e) {
						if(e.id==vm.equipment.kioskEquipmentTypeId)
						{
							vm.selectedEqType = e;
						}
					});

					vm.storageListRM.forEach(function(k) {
						if(k.id==vm.equipment.rmStorageId)
						{
							vm.selectedStorageRM = k;
						}
					});

					vm.storageListSFG.forEach(function(k) {
						if(k.id==vm.equipment.sfgStorageId)
						{
							vm.selectedStorageSFG = k;
						}
					});

					vm.isLoading = false;
				}, function() {
					toastr.error('Failed to load selected Kiosk Equipment.', Auth.translate('ERROR'))
					$state.go('robotkiosk.equipments.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {		
			vm.isLoading = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {
				HttpSvc.put('kioskv3equipments/' + $stateParams.id, vm.equipment, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Kiosk Equipment has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Call Action
		vm.loadKioskList();	
	}

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.kiosks.controller', [])
			.controller('KiosksMainCtrl', KiosksMainCtrl)
			.controller('KiosksCreateCtrl', KiosksCreateCtrl)
			.controller('KiosksUpdateCtrl', KiosksUpdateCtrl);

	/** @ngInject */
	function KiosksMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageKioskOption = [10, 20, 50, 100];
		vm.pageKiosk = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.kioskDataFull = [];
		vm.kioskData = [];
		vm.isLoading=false;
		vm.blobUrl = RmsApi.BLOBURL;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.kioskDataFull, tableState.search.predicateObject) : vm.kioskDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.kioskData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageKiosk; // Number of entries showed per page.
			
			if(vm.kioskDataFull.length <= 0) {	
				vm.isLoading=true;

				HttpSvc.get('kiosksv3/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.kioskDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading=false;
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						vm.isLoading=false;
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteData = function(mappingId) {
			var params = {};
			HttpSvc.delete('kiosksv3/' + mappingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('kiosksv3/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.kioskDataFull = result;
							
							toastr.success('Product Kiosk has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Product Kiosk.', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function KiosksCreateCtrl($scope, $state, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.kiosk = {};
		vm.kiosk.isActive = true;
		vm.kiosk.printReceipt = true;
		vm.branchList = [];
		vm.categoryList = [];
		vm.selectedBranch = null;
		vm.selectedCategories = [];
		vm.isLoading = false;

		/* ******************************************************************* */

		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadCategories();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
	
		}
				
		// Load Product Category List
		vm.loadCategories = function() {
			HttpSvc.get('kioskv3categories/list/simple', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.categoryList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Category list.', '');
					window.history.back();
					return null;
				});
		};	

		/* ******************************************************************* */

		vm.selectedBranchChanged = function() {
			vm.kiosk.branchId = vm.selectedBranch.id;
		}

		/* ******************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {	
				vm.kiosk.kioskV3KioskCategory = vm.selectedCategories;

				HttpSvc.post('kiosksv3', vm.kiosk, Auth.getTokenId(), false)
					.then(function(result) {		
						toastr.success('Product Kiosk has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('robotkiosk.kiosks.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Action
		vm.loadBranches();
	}

	/** @ngInject */
	function KiosksUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.kiosk = {};
		vm.branchList = [];
		vm.categoryList = [];
		vm.selectedBranch = null;
		vm.selectedCategories = [];
		vm.isLoading = false;

		/* ******************************************************************* */

		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadCategories();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
	
		}
				
		// Load Product Category List
		vm.loadCategories = function() {
			HttpSvc.get('kioskv3categories/list/simple', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.categoryList = result;
					vm.loadKiosk();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Category list.', '');
					window.history.back();
					return null;
				});
		};	

		/* ******************************************************************* */

		vm.selectedBranchChanged = function() {
			vm.kiosk.branchId = vm.selectedBranch.id;
		}

		/* ******************************************************************* */
						
		// Load Mapping
		vm.loadKiosk = function() {	
			vm.isLoading = true;

			var params = { id: $stateParams.id };
			HttpSvc.get('kiosksv3/simple/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.kiosk = result;

					vm.branchList.forEach(function(b) {
						if(b.id==vm.kiosk.branchId) {
							vm.selectedBranch=b;
						}
					});
		
					result.kioskV3KioskCategory.forEach(function (c) {
						vm.selectedCategories.push(c);
					});	

					vm.isLoading = false;
				}, function() {
					toastr.error('Failed to load selected Kiosk.', Auth.translate('ERROR'))
					$state.go('robotkiosk.kiosks.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {		
			vm.isLoading = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {
				vm.kiosk.kioskV3KioskCategory = vm.selectedCategories;
				
				HttpSvc.put('kiosksv3/' + $stateParams.id, vm.kiosk, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Kiosk has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Call Action
		vm.loadBranches();	
	}

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.productflavors.controller', [])
			.controller('KioskProductFlavorsMainCtrl', KioskProductFlavorsMainCtrl)
			.controller('KioskProductFlavorsCreateCtrl', KioskProductFlavorsCreateCtrl)
			.controller('KioskProductFlavorsUpdateCtrl', KioskProductFlavorsUpdateCtrl);

	/** @ngInject */
	function KioskProductFlavorsMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageFlavorOption = [10, 20, 50, 100];
		vm.pageFlavor = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.flavorDataFull = [];
		vm.flavorData = [];
		vm.isLoading=false;
		vm.blobUrl = RmsApi.BLOBURL;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.flavorDataFull, tableState.search.predicateObject) : vm.flavorDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.flavorData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageFlavor; // Number of entries showed per page.
			
			if(vm.flavorDataFull.length <= 0) {	
				vm.isLoading=true;

				HttpSvc.get('kioskv3productflavors/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.flavorDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading=false;
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						vm.isLoading=false;
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteData = function(mappingId) {
			var params = {};
			HttpSvc.delete('kioskv3productflavors/' + mappingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('kioskv3productflavors/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.flavorDataFull = result;
							
							toastr.success('Product Flavor has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Product Flavor.', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function KioskProductFlavorsCreateCtrl($scope, $state, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.flavor = {};
		vm.flavor.isActive = true;
		vm.isLoading = false;

		/* ******************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {	
				HttpSvc.post('kioskv3productflavors', vm.flavor, Auth.getTokenId(), false)
					.then(function(result) {		
						toastr.success('Product Flavor has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('robotkiosk.productflavors.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Action
		// Do Nothing
	}

	/** @ngInject */
	function KioskProductFlavorsUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.flavor = {};
		vm.isLoading = false;

		/* ******************************************************************* */
						
		// Load Mapping
		vm.loadFlavor = function() {	
			vm.isLoading = true;

			var params = { id: $stateParams.id };
			HttpSvc.get('kioskv3productflavors/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.flavor = result;
					vm.isLoading = false;
				}, function() {
					toastr.error('Failed to load selected Product Flavor.', Auth.translate('ERROR'))
					$state.go('robotkiosk.productflavors.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {		
			vm.isLoading = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {
				HttpSvc.put('kioskv3productflavors/' + $stateParams.id, vm.flavor, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Product Flavor has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Call Action
		vm.loadFlavor();	
	}

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.productmappings.controller', [])
			.controller('KioskProductMappingMainCtrl', KioskProductMappingMainCtrl)
			.controller('KioskProductMappingCreateCtrl', KioskProductMappingCreateCtrl)
			.controller('KioskProductMappingUpdateCtrl', KioskProductMappingUpdateCtrl);

	/** @ngInject */
	function KioskProductMappingMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.mappingDataFull = [];
		vm.mappingData = [];
		vm.isLoading=false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.mappingDataFull, tableState.search.predicateObject) : vm.mappingDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.mappingData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.mappingDataFull.length <= 0) {	
				vm.isLoading=true;

				HttpSvc.get('kioskv3productmappings/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.mappingDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading=false;
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						vm.isLoading=false;
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteMapping = function(mappingId) {
			var params = {};
			HttpSvc.delete('kioskv3productmappings/' + mappingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('kioskv3productmappings/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.mappingDataFull = result;
							
							toastr.success('Product Mapping has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Product Mapping.', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function KioskProductMappingCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.mapping = {};
		vm.mapping.isActive = true;
		vm.kioskList = [];
		vm.productList = [];
		vm.varietyList = [];
		vm.fgList = [];
		vm.selectedKiosk = {};
		vm.selectedProduct = {};
		vm.selectedVariety = {};
		vm.selectedFg = {};
		
		/* ******************************************************************* */
	
		vm.loadKioskList = function() {
			HttpSvc.get('kiosksv3/list/simple', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.kioskList = result;	
					vm.loadFgList();				
				}, function(error) {
					toastr.error(error, 'Failed');
				});

		}

		vm.loadFgList = function() {
			HttpSvc.get('products/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.fgList = result;					
				}, function(error) {
					toastr.error(error, 'Failed');
				});

		}
	
		vm.loadProductList = function(kioskId) {
			HttpSvc.get('kiosksv3products/listbykiosk/' + kioskId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.productList = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});

		}
	
		vm.loadVarietyList = function(productId) {
			HttpSvc.get('kioskv3productvarieties/list/simple/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.varietyList = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});

		}

		/* ******************************************************************* */

		vm.selectedKioskChanged = function() {
			vm.mapping.kioskId = vm.selectedKiosk.id;
			vm.loadProductList(vm.mapping.kioskId)
		}

		vm.selectedFgChanged = function() {
			vm.mapping.fgId = vm.selectedFg.id;
		}

		vm.selectedProductChanged = function() {
			vm.mapping.KioskProductId = vm.selectedProduct.id;
			vm.loadVarietyList(vm.mapping.KioskProductId)
		}

		vm.selectedVarietyChanged = function() {
			vm.mapping.productVarietyId = vm.selectedVariety.id;
		}

		/* ******************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('kioskv3productmappings', vm.mapping, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Product Mapping has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('robotkiosk.productmappings.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadKioskList();
	}

	/** @ngInject */
	function KioskProductMappingUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.mapping = {};
		vm.mapping.isActive = true;
		vm.kioskList = [];
		vm.productList = [];
		vm.varietyList = [];
		vm.fgList = [];
		vm.selectedKiosk = {};
		vm.selectedProduct = {};
		vm.selectedVariety = {};
		vm.selectedFg = {};
		
		/* ******************************************************************* */
	
		vm.loadKioskList = function() {
			HttpSvc.get('kiosksv3/list/simple', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.kioskList = result;	
					vm.loadFgList();				
				}, function(error) {
					toastr.error(error, 'Failed');
				});

		}

		vm.loadFgList = function() {
			HttpSvc.get('products/list/active', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.fgList = result;	
					vm.loadMapping();				
				}, function(error) {
					toastr.error(error, 'Failed');
				});

		}
	
		vm.loadProductList = function(kioskId, autoSelect) {
			HttpSvc.get('kiosksv3products/listbykiosk/' + kioskId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.productList = result;

					if(autoSelect) 
					{						
						vm.productList.forEach(function(a) {
							if(a.id==vm.mapping.kioskProductId) {
								vm.selectedProduct=a;
							}
						});
					}
				}, function(error) {
					toastr.error(error, 'Failed');
				});

		}
	
		vm.loadVarietyList = function(productId, autoSelect) {
			HttpSvc.get('kioskv3productvarieties/list/simple/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.varietyList = result;

					if(autoSelect) 
					{						
						vm.varietyList.forEach(function(a) {
							if(a.id==vm.mapping.productVarietyId) {
								vm.selectedVariety=a;
							}
						});
					}
				}, function(error) {
					toastr.error(error, 'Failed');
				});

		}

		/* ******************************************************************* */

		vm.selectedKioskChanged = function() {
			vm.mapping.kioskId = vm.selectedKiosk.id;
			vm.loadProductList(vm.mapping.kioskId)
		}

		vm.selectedFgChanged = function() {
			vm.mapping.fgId = vm.selectedFg.id;
		}

		vm.selectedProductChanged = function() {
			vm.mapping.KioskProductId = vm.selectedProduct.id;
			vm.loadVarietyList(vm.mapping.KioskProductId)
		}

		vm.selectedVarietyChanged = function() {
			vm.mapping.productVarietyId = vm.selectedVariety.id;
		}

		/* ******************************************************************* */
						
		// Load Mapping
		vm.loadMapping = function() {	
			var params = { id: $stateParams.id };
			HttpSvc.get('kioskv3productmappings/simple/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.mapping = result;

					vm.kioskList.forEach(function(a) {
						if(a.id==vm.mapping.kioskId) {
							vm.selectedKiosk=a;
						}
					});
					
					vm.fgList.forEach(function(a) {
						if(a.id==vm.mapping.fgId) {
							vm.selectedFg=a;
						}
					});

					vm.loadProductList(vm.mapping.kioskId, true);
					vm.loadVarietyList(vm.mapping.kioskProductId, true);

					vm.isLoading = false;
				}, function() {
					toastr.error('Failed to load selected Product Mapping.', Auth.translate('ERROR'))
					$state.go('robotkiosk.productmappings.list');
					return;
				});		
		};	

		/* ******************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			vm.isLoading = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {
				HttpSvc.put('kioskv3productmappings/' + $stateParams.id, vm.mapping, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Product Mapping has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Call Actions
		vm.loadKioskList();		
	}

})();


(function() {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.productothers.controller', [])
			.controller('KioskProductOthersMainCtrl', KioskProductOthersMainCtrl)
			.controller('KioskProductOthersCreateCtrl', KioskProductOthersCreateCtrl)
			.controller('KioskProductOthersUpdateCtrl', KioskProductOthersUpdateCtrl);

	/** @ngInject */
	function KioskProductOthersMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.otherDataFull = [];
		vm.otherData = [];
		vm.isLoading=false;
		vm.blobUrl = RmsApi.BLOBURL;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.otherDataFull, tableState.search.predicateObject) : vm.otherDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.otherData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.otherDataFull.length <= 0) {	
				vm.isLoading=true;

				HttpSvc.get('kioskv3productothers/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.otherDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading=false;
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						vm.isLoading=false;
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteData = function(mappingId) {
			var params = {};
			HttpSvc.delete('kioskv3productothers/' + mappingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('kioskv3productothers/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.otherDataFull = result;
							
							toastr.success('Product Option has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Product Options.', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function KioskProductOthersCreateCtrl($scope, $state, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.option = {};
		vm.option.isActive = true;
		vm.isLoading = false;

		/* ******************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {	
				HttpSvc.post('kioskv3productothers', vm.option, Auth.getTokenId(), false)
					.then(function(result) {		
						toastr.success('Product Option has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('robotkiosk.productothers.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Action
		// Do Nothing
	}

	/** @ngInject */
	function KioskProductOthersUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.option = {};
		vm.isLoading = false;

		/* ******************************************************************* */
						
		// Load Mapping
		vm.loadOption = function() {	
			vm.isLoading = true;

			var params = { id: $stateParams.id };
			HttpSvc.get('kioskv3productothers/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.option = result;
					vm.isLoading = false;
				}, function() {
					toastr.error('Failed to load selected Product Option.', Auth.translate('ERROR'))
					$state.go('robotkiosk.productothers.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {		
			vm.isLoading = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {
				HttpSvc.put('kioskv3productothers/' + $stateParams.id, vm.option, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Product Option has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Call Action
		vm.loadOption();	
	}

})();

(function () {
    'use strict';

    angular.module('RmsAppV2.pages.routeplan.actual.controller', [])
        .controller('RoutePlanActualMainCtrl', RoutePlanActualMainCtrl)
        .controller('RoutePlanActualCreateCtrl', RoutePlanActualCreateCtrl)
        .controller('RoutePlanActualUpdateCtrl', RoutePlanActualUpdateCtrl)
        .controller('RoutePlanActualSelectDOModalCtrl', RoutePlanActualSelectDOModalCtrl)
        .controller('RoutePlanActualAddRemarkModalCtrl', RoutePlanActualAddRemarkModalCtrl);

    /** @ngInject */
    function RoutePlanActualMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
        Auth.init();

        var vm = this;

        vm.pageSizeOption = [10, 20, 50, 100];
        vm.pageSize = 10;
        vm.numOfRecord = 0;
        vm.numOfRecordFiltered = 0;
        vm.numOfRecordDisplayed = 0;
        vm.startIndex = 0;
        vm.endIndex = 0;
        vm.actualDataFull = [];
        vm.actualData = [];
        vm.isLoading = false;

        function refreshTableState(tableState, startIndex, endIndex) {

            var filtered = tableState.search.predicateObject ? $filter('filter')(vm.actualDataFull, tableState.search.predicateObject) : vm.actualDataFull;
            vm.numOfRecordFiltered = filtered.length;

            if (tableState.sort.predicate) {
                filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
            }
            var result = filtered.slice(startIndex, startIndex + endIndex);

            vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
            vm.actualData = result;

            tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

            return tableState;
        };

        vm.retrieveData = function (tableState) {

            var params = {}
            var pagination = tableState.pagination;

            // Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
            if (vm.pageSize != pagination.number) {
                vm.pageSize = pagination.number;
            }

            vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
            vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

            if (vm.actualDataFull.length <= 0) {
                vm.isLoading = true;

                HttpSvc.get('routeplans/list', params, Auth.getTokenId(), true)
                    .then(function (result) {
                        vm.numOfRecord = result.length;
                        vm.actualDataFull = result;
                        refreshTableState(tableState, vm.startIndex, vm.endIndex);
                        vm.isLoading = false;
                    }, function () {
                        vm.isLoading = false;
                        toastr.error('Failed to retrieve data.', '');
                        return null;
                    });
            } else {
                refreshTableState(tableState, vm.startIndex, vm.endIndex);
            }
        };

        vm.deleteRecord = function (recordId, recordName) {
            var params = {};
            HttpSvc.delete('routeplans/' + recordId, params, Auth.getTokenId(), false)
                .then(function (result) {
                    HttpSvc.get('routeplans/list', params, Auth.getTokenId(), true)
                        .then(function (result) {
                            vm.numOfRecord = result.length;
                            vm.actualDataFull = result;

                            toastr.success('The record for [' + recordName + '] has been deleted.', 'Delete Success');
                            $scope.$broadcast('refreshStTable');
                        }, function () {
                            // Failed
                            toastr.error('Failed to retrieve data.', '');
                            return null;
                        });
                }, function () {
                    // Failed
                    toastr.error('Failed to delete [' + recordName + '].', 'Delete Failed');
                    return null;
                });
        };

        vm.print = function (docId, docNo) {

            var filename = docNo.replace("/", "_") + ".pdf";

            HttpSvc.getPdfObject('routeplans/print/' + docId, Auth.getTokenId(), filename)
                .then(
                    null,
                    function (error) {
                        // Failed
                        toastr.error('Failed to print the Route Plan (Actual). ' + error, '');
                        return null;
                    });
        }
    };

    /** @ngInject */
    function RoutePlanActualCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
        Auth.init();

        var vm = this;
        vm.mode = 1;

        vm.actual = {};
        vm.actual.status = "NEW";
        vm.actual.isAdhoc = true;
        vm.routeList = [];
        vm.driverList = [];
        vm.selectedRoute = null;
        vm.selectedDriver = null;
        vm.isLoading = false;
        vm.isIgnore = false;

        /* ************************************************************* */

        vm.initData = function () {
            vm.loadRouteTemplateList();
        }

        // Load Route Template List
        vm.loadRouteTemplateList = function () {
            vm.isLoading = true;

            HttpSvc.get('routeplantemplates/list', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.routeList = result;
                    vm.loadUsers();
                }, function () {
                    vm.isLoading = false;
                    toastr.error('Failed to retrieve Route Template list.', '');
                    $state.go('routeplan.actual.list');
                });
        }

        vm.loadUsers = function () {
            HttpSvc.get('users/list/drivers', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.driverList = result;
                    vm.isLoading = false;
                }, function (error) {
                    vm.isLoading = false;
                    toastr.error(error, 'Failed');
                });
        }

        /* ************************************************************* */

        vm.selectedRouteChanged = function () {
            vm.actual.templateId = vm.selectedRoute.id;
        };

        vm.selectedDriverChanged = function () {
            vm.actual.driverId = vm.selectedDriver.id;
        };

        /* ************************************************************* */

        // Form Submission
        vm.submit = function () {
            if (vm.dataForm.$invalid) {
                toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
            } else {
                vm.isLoading = true;

                HttpSvc.post('routeplans', vm.actual, Auth.getTokenId(), false)
                    .then(function (result) {
                        toastr.success('Route Plan has been created successfully.', Auth.translate('SUCCESS'));
                        $state.go('routeplan.actual.update', { 'id': result.id });
                    }, function (error) {
                        toastr.error('Failed to create Route Plan. ' + error, Auth.translate('ERROR'));
                        vm.isLoading = false;
                    });
            }
        }

        /* ************************************************************* */

        // Call Action
        vm.initData();
    }

    /** @ngInject */
    function RoutePlanActualUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {
        Auth.init();

        var vm = this;
        vm.mode = 2;

        vm.actual = {};
        vm.routeList = [];
        vm.driverList = [];
        vm.selectedRoute = null;
        vm.selectedDriver = null;
        vm.isLoading = false;
        vm.isIgnore = false;

        /* ************************************************************* */

        vm.initData = function () {
            vm.loadRouteTemplateList();
        }

        // Load Route Template List
        vm.loadRouteTemplateList = function () {
            vm.isLoading = true;

            HttpSvc.get('routeplantemplates/list', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.routeList = result;
                    vm.loadUsers();
                }, function () {
                    vm.isLoading = false;
                    toastr.error('Failed to retrieve Route Template list.', '');
                    $state.go('routeplan.actual.list');
                });
        }

        vm.loadUsers = function () {
            HttpSvc.get('users/list/drivers', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.driverList = result;
                    vm.loadData();
                }, function (error) {
                    toastr.error('Failed to retrieve Driver list.', '');
                    $state.go('routeplan.actual.list');
                });
        }

        // Load RP Preview
        vm.loadData = function () {
            var params = { id: $stateParams.id };
            HttpSvc.get('routeplans/:id', params, Auth.getTokenId(), false)
                .then(function (result) {
                    vm.actual = result;

                    vm.routeList.forEach(function (r) {
                        if (r.id == vm.actual.templateId) {
                            vm.selectedRoute = r;
                        }
                    });

                    vm.driverList.forEach(function (d) {
                        if (d.id == vm.actual.driverId) {
                            vm.selectedDriver = d;
                        }
                    });

                    var debtors = [];
                    vm.actual.routePlanDebtors.forEach(function (d) {
                        if (d.routePlanDocuments.length != 0) {
                            debtors.push(d);
                        }
                    });
                    vm.actual.routePlanDebtors = debtors;

                    vm.list = vm.listData(vm.actual.routePlanDebtors, vm.actual.routePlanRemarks);

                    vm.isLoading = false;
                }, function (error) {
                    vm.isLoading = false;
                    toastr.error('Failed to load Route Plan. ' + error, Auth.translate('ERROR'))
                    $state.go('routeplan.actual.list');
                    return;
                });
        };

        vm.listData = function (debtors, remarks) {
            // Concat debtors and remarks, then sort them by sequence
            vm.list = debtors.concat(remarks);
            return vm.list.sort(function (a, b) { a.sequence - b.sequence });
        }

        /* ************************************************************* */

        vm.selectedRouteChanged = function () {
            vm.actual.templateId = vm.selectedRoute.id;
        };

        vm.selectedDriverChanged = function () {
            vm.actual.driverId = vm.selectedDriver.id;
        };

        /* ************************************************************* */

        vm.isItemPresent = function (index) {
            return index !== -1 ? true : false;
        }

        vm.reassignSequence = function (list, direction, index) {
            var item;

            if (list === 'debtor') {
                item = angular.copy(vm.actual.routePlanDebtors[index]);
            } else {
                item = angular.copy(vm.actual.routePlanRemarks[index]);
            }

            if (direction === 'up') {
                item.sequence -= 1;
            } else {
                item.sequence += 1;
            }

            if (list === 'debtor') {
                vm.actual.routePlanDebtors.splice(index, 1, item);
            } else {
                vm.actual.routePlanRemarks.splice(index, 1, item);
            }

            vm.list = vm.listData(vm.actual.routePlanDebtors, vm.actual.routePlanRemarks);
        }

        /* ************************************************************* */

        vm.moveListItem = function (list, direction, currSequence) {
            // The list item affected by the moving, aka the list item opposite of the moved list item
            var affDirection;
            var affSequence;

            switch (direction) {
                case 'up':
                    affDirection = 'down'
                    affSequence = currSequence - 1;
                    break;
                case 'down':
                    affDirection = 'up';
                    affSequence = currSequence + 1;
                    break;
            }

            // Find out if the affected list item is from the debtors list or the remarks list
            var affectedDebtorIndex = vm.actual.routePlanDebtors.findIndex(function (debtor) { return debtor.sequence == affSequence });
            var affectedRemarkIndex = vm.actual.routePlanRemarks.findIndex(function (remark) { return remark.sequence == affSequence });

            // Find out the index of the moved list item
            var movedIndex;

            if (list === 'debtor') {
                movedIndex = vm.actual.routePlanDebtors.findIndex(function (debtor) { return debtor.sequence == currSequence })
            } else {
                movedIndex = vm.actual.routePlanRemarks.findIndex(function (remark) { return remark.sequence == currSequence })
            }

            if (vm.isItemPresent(affectedDebtorIndex)) {
                vm.reassignSequence('debtor', affDirection, affectedDebtorIndex);
            } else if (vm.isItemPresent(affectedRemarkIndex)) {
                vm.reassignSequence('remark', affDirection, affectedRemarkIndex);
            }

            vm.reassignSequence(list, direction, movedIndex);
        }

        vm.deleteListItem = function (type, sequence) {
            switch (type) {
                case 'debtor':
                    var debtorIndex = vm.actual.routePlanDebtors.findIndex(function (debtor) { return debtor.sequence == sequence });
                    if (vm.isItemPresent(debtorIndex)) {
                        vm.actual.routePlanDebtors.splice(debtorIndex, 1);
                    }
                    break;
                case 'remark':
                    var remarkIndex = vm.actual.routePlanRemarks.findIndex(function (remark) { return remark.sequence == sequence });
                    if (vm.isItemPresent(remarkIndex)) {
                        vm.actual.routePlanRemarks.splice(remarkIndex, 1);
                    }
                    break;
            }

            // Reassign the sequence of the list items after the sequence
            vm.actual.routePlanDebtors.forEach(function (debtor) {
                if (debtor.sequence > sequence) {
                    debtor.sequence--;
                }
            })

            vm.actual.routePlanRemarks.forEach(function (remark) {
                if (remark.sequence > sequence) {
                    remark.sequence--;
                }
            })

            vm.list = vm.listData(vm.actual.routePlanDebtors, vm.actual.routePlanRemarks);

        };

        /* ************************************************************* */

        vm.confirmRP = function () {
            if (vm.actual.routePlanDebtors.length == 0) {
                toastr.warning("Please add at least ONE Delivery Order document.", "No Document")
                return;
            }

            vm.actual.status = "CONFIRMED";
            vm.submit();
        }

        vm.completeRP = function () {
            HttpSvc.put('routeplans/complete/' + $stateParams.id, vm.actual, Auth.getTokenId(), false)
                .then(function (result) {
                    toastr.success('Route Plan is completed successfully!', Auth.translate('SUCCESS'));
                    $state.reload();
                }, function (error) {
                    toastr.error('Failed to cancel Route Plan. ' + error, Auth.translate('ERROR'));
                    vm.isLoading = false;
                });
        }

        vm.cancelRP = function () {
            HttpSvc.put('routeplans/cancel/' + $stateParams.id, vm.actual, Auth.getTokenId(), false)
                .then(function (result) {
                    toastr.success('Route Plan is cancelled successfully!', Auth.translate('SUCCESS'));
                    $state.reload();
                }, function (error) {
                    toastr.error('Failed to cancel Route Plan. ' + error, Auth.translate('ERROR'));
                    vm.isLoading = false;
                });
        }

        /* ************************************************************* */

        vm.showSelectDeliveryOrderModal = function () {

            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'app-modal-window',
                templateUrl: 'deliveryOrderListModal.html',
                controller: 'RoutePlanActualSelectDOModalCtrl',
                controllerAs: '$mdl',
                size: 'md',
            });

            modalInstance
                .result
                .then(function (objList) {
                    vm.addDeliveryOrder(objList);
                }, function () {
                });
        };

        vm.showAddRemarkModal = function () {

            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'addRemarkModal.html',
                controller: 'RoutePlanActualAddRemarkModalCtrl',
                controllerAs: '$mdl',
                size: 'md',
            });

            modalInstance
                .result
                .then(function (remark) {
                    vm.addRemark(remark);
                }, function () {
                });

        }

        vm.addDeliveryOrder = function (objList) {

            var isDebtorFound = false;

            objList.forEach(function (o) {
                vm.actual.routePlanDebtors.forEach(function (d) {
                    if (d.debtorId == o.debtorId && d.debtorBranchId == o.debtorBranchId) {
                        isDebtorFound = true;

                        var isDocFound = false;

                        d.routePlanDocuments.forEach(function (r) {
                            if (r.deliveryOrderId == o.id) {
                                isDocFound = true;
                            }
                        });

                        if (!isDocFound) {
                            d.routePlanDocuments.push({
                                deliveryOrderId: o.id,
                                deliveryOrderNo: o.deliveryOrderNo,
                            })
                        }
                    }
                });

                if (!isDebtorFound) {
                    vm.actual.routePlanDebtors.push({
                        debtorId: o.debtorId,
                        debtorBranchId: o.debtorBranchId,
                        debtorCode: o.debtorCode,
                        debtorName: o.debtorName,
                        debtorBranchName: o.debtorBranchName,
                        sequence: vm.actual.routePlanDebtors.length,
                        routePlanDocuments: [
                            {
                                deliveryOrderId: o.id,
                                deliveryOrderNo: o.deliveryOrderNo
                            }
                        ]
                    });
                }

                vm.list = vm.listData(vm.actual.routePlanDebtors, vm.actual.routePlanRemarks);
            });
        }

        vm.addRemark = function (remark) {

            vm.actual.routePlanRemarks.push({
                sequence: vm.list.length,
                remarks: remark,
                status: "PENDING",
                isRemark: true,
            });

            vm.list = vm.listData(vm.actual.routePlanDebtors, vm.actual.routePlanRemarks);

        }

        vm.completeRemark = function (id) {

            var index = vm.actual.routePlanRemarks.findIndex(function (remark) { return remark.id === id; });

            var item = {
                sequence: vm.actual.routePlanRemarks[index].sequence,
                remarks: vm.actual.routePlanRemarks[index].remarks,
                status: "COMPLETED",
                isRemark: true,
            }

            vm.actual.routePlanRemarks.splice(index, 1, item);

            vm.list = vm.listData(vm.actual.routePlanDebtors, vm.actual.routePlanRemarks);

        }

        /* ************************************************************* */

        vm.print = function () {

            var filename = vm.actual.planNo.replace("/", "_") + ".pdf";

            HttpSvc.getPdfObject('routeplans/print/' + vm.actual.id, Auth.getTokenId(), filename)
                .then(
                    null,
                    function (error) {
                        // Failed
                        toastr.error('Failed to print the Route Plan (Actual). ' + error, '');
                        return null;
                    });
        }

        /* ************************************************************* */

        // Form Submission
        vm.submit = function () {
            if (vm.dataForm.$invalid) {
                toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
            } else {
                HttpSvc.put('routeplans/' + $stateParams.id, vm.actual, Auth.getTokenId(), false)
                    .then(function (result) {
                        toastr.success('Route Plan has been updated successfully.', Auth.translate('SUCCESS'));
                        $state.reload();
                    }, function (error) {
                        toastr.error('Failed to update Route Plan. ' + error, Auth.translate('ERROR'));
                    });
            }
        }

        // Call Actions
        vm.initData();
    }

    /** @ngInject */
    function RoutePlanActualSelectDOModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, toastr) {
        var $mdl = this;

        $mdl.pageSize = 10;
        $mdl.numOfRecord = 0;
        $mdl.numOfRecordFiltered = 0;
        $mdl.numOfRecordDisplayed = 0;
        $mdl.startIndex = 0;
        $mdl.endIndex = 0;
        $mdl.doDataFull = [];
        $mdl.doData = [];
        $mdl.isLoading = false;
        $mdl.selectOrderIds = [];

        function refreshTableState(tableState, startIndex, endIndex) {

            var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.doDataFull, tableState.search.predicateObject) : $mdl.doDataFull;
            $mdl.numOfRecordFiltered = filtered.length;

            if (tableState.sort.predicate) {
                filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
            }
            var result = filtered.slice(startIndex, startIndex + endIndex);

            $mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
            $mdl.doData = result;

            tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);

            return tableState;
        };

        $mdl.retrieveData = function (tableState) {

            var pagination = tableState.pagination;
            $mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
            $mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

            if ($mdl.doDataFull.length <= 0) {
                $mdl.isLoading = true;

                HttpSvc.get('routeplans/list/unselected/adhoc', {}, Auth.getTokenId(), true)
                    .then(function (result) {
                        $mdl.numOfRecord = result.length;
                        $mdl.doDataFull = result;
                        refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
                        $mdl.isLoading = false;
                    }, function () {
                        $mdl.isLoading = false;
                        toastr.error('Failed to retrieve data.', '');
                        return null;
                    });
            } else {
                refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
            }
        };

        // ********************************************************

        $mdl.confirmModal = function () {

            var doList = [];

            $mdl.selectOrderIds.forEach(function (s) {
                $mdl.doDataFull.forEach(function (d) {
                    if (d.id == s) {
                        doList.push({
                            id: d.id,
                            debtorId: d.debtorId,
                            debtorCode: d.debtorCode,
                            debtorName: d.debtorName,
                            debtorBranchId: d.debtorBranchId,
                            debtorBranchName: d.debtorBranchName,
                            deliveryOrderNo: d.deliveryOrderNo,
                        });
                    }
                });
            });

            $uibModalInstance.close(doList);
        }

        // Cancel Action
        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    function RoutePlanActualAddRemarkModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, toastr) {
        var $mdl = this;

        $mdl.confirmModal = function () {
            $uibModalInstance.close($mdl.remark);
        };

        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };;
    }

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.products.controller', [])
			.controller('KioskProductsMainCtrl', KioskProductsMainCtrl)
			.controller('KioskProductsCreateCtrl', KioskProductsCreateCtrl)
			.controller('KioskProductsUpdateCtrl', KioskProductsUpdateCtrl)
			.controller('KioskProductsVarietyModalCtrl', KioskProductsVarietyModalCtrl);

	/** @ngInject */
	function KioskProductsMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageKioskOption = [10, 20, 50, 100];
		vm.pageKiosk = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.productDataFull = [];
		vm.productData = [];
		vm.isLoading=false;
		vm.blobUrl = RmsApi.BLOBURL;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.productDataFull, tableState.search.predicateObject) : vm.productDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.productData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageKiosk; // Number of entries showed per page.
			
			if(vm.productDataFull.length <= 0) {	
				vm.isLoading=true;

				HttpSvc.get('kiosksv3products/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.productDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading=false;
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						vm.isLoading=false;
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteData = function(mappingId) {
			var params = {};
			HttpSvc.delete('kiosksv3products/' + mappingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('kiosksv3products/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.productDataFull = result;
							
							toastr.success('Product has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Product.', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function KioskProductsCreateCtrl($scope, $state, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.product = {};
		vm.product.isActive = true;
		vm.product.imageLocation = 'assets/img/empty_placeholder.png';	
		vm.prodCategoryList = [];
		vm.selectedCategories = [];
		vm.fileToUpload = null;
		vm.blobUrl = RmsApi.BLOBURL;
		vm.serverMode = Auth.getServerMode();
		vm.currencyCode = Auth.getCurrency();
		vm.isLoading = false;

		/* ******************************************************************* */
				
		// Load Product Category List
		vm.loadCategories = function() {
			HttpSvc.get('kioskv3categories/list/simple', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.prodCategoryList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Category list.', '');
					window.history.back();
					return null;
				});
		};	

		/* ******************************************************************* */

		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {	
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";

				
				if(vm.serverMode==1 && vm.fileToUpload) {
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/kioskproducts/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "kioskproducts/" + newFilename + mediaExtension;
				}
				vm.product.imageLocation = imgLocation;


				vm.product.kioskV3ProductCategory = vm.selectedCategories;

				HttpSvc.post('kiosksv3products', vm.product, Auth.getTokenId(), false)
					.then(function(result) {	
												
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage();
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/kioskproducts/" + vm.productgoryId;
							vm.uploadImage();
							
						} else {							
							toastr.success('Product has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('robotkiosk.products.update', {'id': result.id });
						}
							
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (productId) {
			var fileReader = new FileReader();
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId()},
				}).then(function (resp) {
					toastr.success('Product has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('robotkiosk.products.update', {'id': productId });
				}, function (resp) {
					toastr.success('Product has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('robotkiosk.products.update', {'id': productId });
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(vm.serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {									
							toastr.success('Product has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('robotkiosk.products.update', {'id': productId });
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};

		/* ******************************************************************* */

		// Call Action
		vm.loadCategories();
	}

	/** @ngInject */
	function KioskProductsUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.product = {};
		vm.product.imageLocation = 'assets/img/empty_placeholder.png';	
		vm.product.oriImageLocation = "";
		vm.equipmentList = [];
		vm.prodCategoryList = [];
		vm.selectedCategories = [];
		vm.selectedEquipment = null;
		vm.fileToUpload = null;
		vm.blobUrl = RmsApi.BLOBURL;
		vm.serverMode = Auth.getServerMode();
		vm.currencyCode = Auth.getCurrency();
		vm.isLoading = false;

		/* ******************************************************************* */
				
		// Load Product Category List
		vm.loadCategories = function() {
			HttpSvc.get('kioskv3categories/list/simple', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.prodCategoryList = result;
					vm.loadEquipments();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Category list.', '');
					window.history.back();
					return null;
				});
		};	
				
		// Load Equipment List
		vm.loadEquipments = function() {
			HttpSvc.get('kioskv3equipments/list/1', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function(e) {
						vm.equipmentList.push({
							id: e.id,
							description: e.description
						});
					});		
					vm.loadProduct();			
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Equipment list.', '');
					window.history.back();
					return null;
				});
		};
						
		// Load Mapping
		vm.loadProduct = function() {	
			vm.isLoading = true;

			var params = { id: $stateParams.id };
			HttpSvc.get('kiosksv3products/simple/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.product = result;
		
					result.kioskV3ProductCategory.forEach(function (c) {
						vm.selectedCategories.push(c);
					});				
					
					if(!vm.product.imageLocation || vm.product.imageLocation=='') {
						vm.product.imageLocation = 'assets/img/empty_placeholder.png';
						vm.product.oriImageLocation = "";
					} else {
						vm.product.oriImageLocation = vm.product.imageLocation;
						vm.product.imageLocation = vm.blobUrl + vm.product.imageLocation;
					}

					vm.isLoading = false;
				}, function() {
					toastr.error('Failed to load selected Product.', Auth.translate('ERROR'))
					$state.go('robotkiosk.products.list');
					return;
				});		
		};	

		vm.loadVarieties = function(productId) {
			HttpSvc.get('kioskv3productvarieties/list/simple/' + productId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.product.kioskV3ProductVariety = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Product Variety list.', '');
					return null;
				});
		};	

		/* ******************************************************************* */

		vm.showAddVarietyModal = function () {
			vm.item = {};
			vm.item.productId = vm.product.id;
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'varietyModal.html',
				controller: 'KioskProductsVarietyModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.item,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadVarieties(vm.product.id);
				}, function () {
				});
		};	
		
		vm.showEditVarietyModal = function (index) {
			vm.item = angular.copy(vm.product.kioskV3ProductVariety[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'varietyModal.html',
				controller: 'KioskProductsVarietyModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadVarieties(vm.product.id);
				}, function () {
				});
		};	

		vm.removeVariety = function(id) {
			HttpSvc.delete('kioskv3productvarieties/' + id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Product Variety has been deleted.', 'Delete Success');
					vm.loadVarieties(vm.product.id);
				}, function() {
					// Failed
					toastr.error('Failed to remove the Product Variety.', 'Delete Failed');
					return null;
			});
		};

		/* ******************************************************************* */
		
		vm.showAddEquipmentPanel = function()
		{
			vm.addEquipmentPanelVisible = true;
		}

		vm.closeAddEquipmentPanel = function()
		{
			vm.addEquipmentPanelVisible = false;
		}

		vm.addEquipment = function()
		{
			if(vm.selectedEquipment==null)
			{
				toastr.warning("Select an Equipment first.");
				return;
			}

			var isFound = false;
			vm.product.kioskV3Equipment.forEach(function(e) {
				if(e.id==vm.selectedEquipment.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Equipment is already exist on the list.");
				return;
			}

			vm.product.kioskV3Equipment.push({
				id: vm.selectedEquipment.id,
				description: vm.selectedEquipment.description,
			});
			toastr.success("Equipment added to the list.");			
		}

		vm.removeEquipment = function(index) {
			vm.product.kioskV3Equipment.splice(index, 1);
			toastr.info("Equipment has been removed.");
		};

		/* ******************************************************************* */
		
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		vm.submit = function() {		
			vm.isLoading = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				

				if(vm.serverMode==1 && vm.fileToUpload) {
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/kioskproducts/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "kioskproducts/" + newFilename + mediaExtension;

				} else if(vm.product.oriImageLocation!="") {
					imgLocation = vm.product.oriImageLocation;
				}
				vm.product.imageLocation = imgLocation;
				vm.product.kioskV3ProductCategory = vm.selectedCategories;
				
				HttpSvc.put('kiosksv3products/' + $stateParams.id, vm.product, Auth.getTokenId(), false)
					.then(function(result) {
												
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(result.id);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/kioskproducts/" + vm.product.Id;
							vm.uploadImage(result.id);
							
						} else {							
							toastr.success('Product has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						}
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function () {
			var fileReader = new FileReader();
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId()},
				}).then(function (resp) {
					toastr.success('Product has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('Product has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(vm.serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {									
							toastr.success('Product has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};
		
		// Call Action
		vm.loadCategories();	
	}
	
	// Step Modal Controller
	function KioskProductsVarietyModalCtrl($uibModalInstance, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
		$mdl.mode = item.mode;
		$mdl.title = item.title;
		$mdl.item = item.object;
		$mdl.serverMode = Auth.getServerMode();
		$mdl.blobUrl = RmsApi.BLOBURL;
		$mdl.fileToUpload = null;
		$mdl.lockButton = false;
		$mdl.sizeList = [];
		$mdl.flavorList = [];
		$mdl.optionList = [];
		$mdl.selectedSize = null;
		$mdl.selectedFlavor = null;
		$mdl.selectedOption = null;
					
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		// Initialize
		if(item.mode==1) {
			$mdl.activeTab = 0;
			$mdl.item.imageLocation = 'assets/img/empty_placeholder.png';	
			$mdl.item.isActive = true;
			
		} else if(item.mode==2) {
			$mdl.item.oriImageLocation = "";			
					
			if(!$mdl.item.imageLocation || $mdl.item.imageLocation=='') {
				$mdl.item.imageLocation = 'assets/img/empty_placeholder.png';
				$mdl.item.oriImageLocation = "";
			} else {
				$mdl.item.oriImageLocation = $mdl.item.imageLocation;
				$mdl.item.imageLocation = $mdl.blobUrl + $mdl.item.imageLocation;
			}
		}

		/* ******************************************************************** */

		$mdl.loadSizeList = function() {
			HttpSvc.get('kioskv3productsizes/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.sizeList = result;
					$mdl.loadFlavorList();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Product Size list.', '');
					return null;
				});
		}

		$mdl.loadFlavorList = function() {
			HttpSvc.get('kioskv3productflavors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.flavorList = result;
					$mdl.loadOptionList();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Product Flavor list.', '');
					return null;
				});
		}

		$mdl.loadOptionList = function() {
			HttpSvc.get('kioskv3productothers/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.optionList = result;

					if(item.mode==2) 
						$mdl.prepareData();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Product Options list.', '');
					return null;
				});
		}		

		$mdl.prepareData = function() {
			$mdl.sizeList.forEach(function(s) {
				if(s.id == $mdl.item.sizeId)
				{
					$mdl.selectedSize = s;
				}
			});
			$mdl.flavorList.forEach(function(f) {
				if(f.id == $mdl.item.favorId)
				{
					$mdl.selectedFlavor = f;
				}
			});
			$mdl.optionList.forEach(function(s) {
				if(s.id == $mdl.item.othersId)
				{
					$mdl.selectedOption = s;
				}
			});
		}

		/* ******************************************************************** */

		$mdl.selectedSizeChanged = function() {
			$mdl.item.sizeId = $mdl.selectedSize.id;
		}
		
		$mdl.selectedFlavorChanged = function() {
			$mdl.item.favorId = $mdl.selectedFlavor.id;
		}
		
		$mdl.selectedOptionChanged = function() {
			$mdl.item.othersId = $mdl.selectedOption.id;
		}

		/* ******************************************************************** */
		
		// Update Step
		$mdl.updateStep = function(obj) {
			imgLocation = "";
			azureStorageUrl = "";
			localStorageUrl = "";
			var newFilename = UtilSvc.generateGuid() + ".";

				
			if($mdl.serverMode==1 && $mdl.fileToUpload) {
				
				var extArray = $mdl.fileToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				imgLocation = Auth.getCompanyId() + "/kioskproductvariety/" + newFilename + mediaExtension;
				
			} else if($mdl.serverMode==0 && $mdl.fileToUpload) {	
			
				var extArray = $mdl.fileToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				imgLocation = "kioskproductvariety/" + newFilename + mediaExtension;

			} else if($mdl.item.oriImageLocation!="") {
				imgLocation = $mdl.item.oriImageLocation;
			}
			$mdl.item.imageLocation = imgLocation;


			$mdl.lockButton = true;	
						
			HttpSvc.put('kioskv3productvarieties/' + $mdl.item.id, $mdl.item, Auth.getTokenId(), false)
				.then(function(result) {
												
					if($mdl.serverMode==1 && $mdl.fileToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
						$mdl.uploadImage();
						
					} else if($mdl.serverMode==0 && $mdl.fileToUpload) {
						localStorageUrl = RmsApi.URL + "upload/kioskproductvariety/" + result.id;
						$mdl.uploadImage();
						
					} else {							
						toastr.success('Product Variety has been updated successfully.', Auth.translate('SUCCESS'));
						$uibModalInstance.close();
					}
				}, function(error) {
					$mdl.lockButton = false;
					$mdl.varietyForm.$setPristine();
				});	
		};

		// Add Step
		$mdl.addStep = function(obj) {	
			imgLocation = "";
			azureStorageUrl = "";
			localStorageUrl = "";
			var newFilename = UtilSvc.generateGuid() + ".";

				
			if($mdl.serverMode==1 && $mdl.fileToUpload) {
				
				var extArray = $mdl.fileToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				imgLocation = Auth.getCompanyId() + "/kioskproductvariety/" + newFilename + mediaExtension;
				
			} else if($mdl.serverMode==0 && $mdl.fileToUpload) {	
			
				var extArray = $mdl.fileToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				imgLocation = "kioskproductvariety/" + newFilename + mediaExtension;
			}
			$mdl.item.imageLocation = imgLocation;


			$mdl.lockButton = true;			
						
			HttpSvc.post('kioskv3productvarieties', $mdl.item, Auth.getTokenId(), false)
				.then(function(result) {	
												
					if($mdl.serverMode==1 && $mdl.fileToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
						$mdl.uploadImage();
						
					} else if($mdl.serverMode==0 && $mdl.fileToUpload) {
						localStorageUrl = RmsApi.URL + "upload/kioskproductvariety/" + result.id;
						$mdl.uploadImage();
						
					} else {							
						toastr.success('Product Variety has been created successfully.', Auth.translate('SUCCESS'));
						$uibModalInstance.close();
					}

				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					$mdl.lockButton = false;
					$mdl.varietyForm.$setPristine();
				});			
		};
		
		/* ******************************************************************** */	
				
		// Set Upload Image
		$mdl.setUploadImage = function(picFile) {
			$mdl.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		$mdl.uploadImage = function () {
			var fileReader = new FileReader();
			
			if($mdl.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: $mdl.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId()},
				}).then(function (resp) {
					toastr.success('Product Variety has been created successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close();
				}, function (resp) {
					toastr.success('Product Variety has been created successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close();
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if($mdl.serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer($mdl.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': $mdl.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {									
							toastr.success('Product Variety has been created successfully.', Auth.translate('SUCCESS'));
							$uibModalInstance.close();
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};				

		/* ******************************************************************** */

		// Confirm Action
		$mdl.confirmModal = function() {

			if($mdl.varietyForm.$valid) {
				if(item.mode==1) {
					$mdl.addStep($mdl.item);	
				} else if(item.mode==2) {
					$mdl.updateStep($mdl.item);
				}
				
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Call Action
		$mdl.loadSizeList()
	};

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.robotkiosk.productsizes.controller', [])
			.controller('KioskProductSizesMainCtrl', KioskProductSizesMainCtrl)
			.controller('KioskProductSizesCreateCtrl', KioskProductSizesCreateCtrl)
			.controller('KioskProductSizesUpdateCtrl', KioskProductSizesUpdateCtrl);

	/** @ngInject */
	function KioskProductSizesMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.sizeDataFull = [];
		vm.sizeData = [];
		vm.isLoading=false;
		vm.blobUrl = RmsApi.BLOBURL;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.sizeDataFull, tableState.search.predicateObject) : vm.sizeDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.sizeData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.sizeDataFull.length <= 0) {	
				vm.isLoading=true;

				HttpSvc.get('kioskv3productsizes/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.sizeDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading=false;
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						vm.isLoading=false;
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteData = function(mappingId) {
			var params = {};
			HttpSvc.delete('kioskv3productsizes/' + mappingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('kioskv3productsizes/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.sizeDataFull = result;
							
							toastr.success('Product Size has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Product Size.', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function KioskProductSizesCreateCtrl($scope, $state, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.size = {};
		vm.size.isActive = true;
		vm.isLoading = false;

		/* ******************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {	
				HttpSvc.post('kioskv3productsizes', vm.size, Auth.getTokenId(), false)
					.then(function(result) {		
						toastr.success('Product Size has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('robotkiosk.productsizes.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Action
		// Do Nothing
	}

	/** @ngInject */
	function KioskProductSizesUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.size = {};
		vm.isLoading = false;

		/* ******************************************************************* */
						
		// Load Mapping
		vm.loadSize = function() {	
			vm.isLoading = true;

			var params = { id: $stateParams.id };
			HttpSvc.get('kioskv3productsizes/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.size = result;
					vm.isLoading = false;
				}, function() {
					toastr.error('Failed to load selected Product Size.', Auth.translate('ERROR'))
					$state.go('robotkiosk.productsizes.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {		
			vm.isLoading = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {
				HttpSvc.put('kioskv3productsizes/' + $stateParams.id, vm.size, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Product Size has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Call Action
		vm.loadSize();	
	}

})();

(function () {
    'use strict';

    angular.module('RmsAppV2.pages.routeplan.actual_mercado.controller', [])
        .controller('RoutePlanActualMainCtrl', RoutePlanActualMainCtrl)
        .controller('RoutePlanActualCreateCtrl', RoutePlanActualCreateCtrl)
        .controller('RoutePlanActualUpdateCtrl', RoutePlanActualUpdateCtrl)
        .controller('RoutePlanActualSelectDOModalCtrl', RoutePlanActualSelectDOModalCtrl)
        .controller('RoutePlanActualAddRemarkModalCtrl', RoutePlanActualAddRemarkModalCtrl);

    /** @ngInject */
    function RoutePlanActualMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
        Auth.init();

        var vm = this;

        vm.pageSizeOption = [10, 20, 50, 100];
        vm.pageSize = 10;
        vm.numOfRecord = 0;
        vm.numOfRecordFiltered = 0;
        vm.numOfRecordDisplayed = 0;
        vm.startIndex = 0;
        vm.endIndex = 0;
        vm.actualDataFull = [];
        vm.actualData = [];
        vm.isLoading = false;

        function refreshTableState(tableState, startIndex, endIndex) {

            var filtered = tableState.search.predicateObject ? $filter('filter')(vm.actualDataFull, tableState.search.predicateObject) : vm.actualDataFull;
            vm.numOfRecordFiltered = filtered.length;

            if (tableState.sort.predicate) {
                filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
            }
            var result = filtered.slice(startIndex, startIndex + endIndex);

            vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
            vm.actualData = result;

            tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

            return tableState;
        };

        vm.retrieveData = function (tableState) {

            var params = {}
            var pagination = tableState.pagination;

            // Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
            if (vm.pageSize != pagination.number) {
                vm.pageSize = pagination.number;
            }

            vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
            vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

            if (vm.actualDataFull.length <= 0) {
                vm.isLoading = true;

                HttpSvc.get('routeplans/list', params, Auth.getTokenId(), true)
                    .then(function (result) {
                        vm.numOfRecord = result.length;
                        vm.actualDataFull = result;
                        refreshTableState(tableState, vm.startIndex, vm.endIndex);
                        vm.isLoading = false;
                    }, function () {
                        vm.isLoading = false;
                        toastr.error('Failed to retrieve data.', '');
                        return null;
                    });
            } else {
                refreshTableState(tableState, vm.startIndex, vm.endIndex);
            }
        };

        vm.deleteRecord = function (recordId, recordName) {
            var params = {};
            HttpSvc.delete('routeplans/' + recordId, params, Auth.getTokenId(), false)
                .then(function (result) {
                    HttpSvc.get('routeplans/list', params, Auth.getTokenId(), true)
                        .then(function (result) {
                            vm.numOfRecord = result.length;
                            vm.actualDataFull = result;

                            toastr.success('The record for [' + recordName + '] has been deleted.', 'Delete Success');
                            $scope.$broadcast('refreshStTable');
                        }, function () {
                            // Failed
                            toastr.error('Failed to retrieve data.', '');
                            return null;
                        });
                }, function () {
                    // Failed
                    toastr.error('Failed to delete [' + recordName + '].', 'Delete Failed');
                    return null;
                });
        };

        vm.print = function (docId, docNo) {

            var filename = docNo.replace("/", "_") + ".pdf";

            HttpSvc.getPdfObject('routeplans/print/' + docId, Auth.getTokenId(), filename)
                .then(
                    null,
                    function (error) {
                        // Failed
                        toastr.error('Failed to print the Route Plan (Actual). ' + error, '');
                        return null;
                    });
        }
    };

    /** @ngInject */
    function RoutePlanActualCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
        Auth.init();

        var vm = this;
        vm.mode = 1;

        vm.actual = {};
        vm.actual.status = "NEW";
        vm.actual.isAdhoc = true;
        vm.routeList = [];
        vm.driverList = [];
        vm.selectedRoute = null;
        vm.selectedDriver = null;
        vm.isLoading = false;
        vm.isIgnore = false;

        /* ************************************************************* */

        vm.initData = function () {
            vm.loadRouteTemplateList();
        }

        // Load Route Template List
        vm.loadRouteTemplateList = function () {
            vm.isLoading = true;

            HttpSvc.get('routeplantemplates/list', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.routeList = result;
                    vm.loadUsers();
                }, function () {
                    vm.isLoading = false;
                    toastr.error('Failed to retrieve Route Template list.', '');
                    $state.go('routeplan.actual_mercado.list');
                });
        }

        vm.loadUsers = function () {
            HttpSvc.get('users/list/drivers', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.driverList = result;
                    vm.isLoading = false;
                }, function (error) {
                    vm.isLoading = false;
                    toastr.error(error, 'Failed');
                });
        }

        /* ************************************************************* */

        vm.selectedRouteChanged = function () {
            vm.actual.templateId = vm.selectedRoute.id;
        };

        vm.selectedDriverChanged = function () {
            vm.actual.driverId = vm.selectedDriver.id;
        };

        /* ************************************************************* */

        // Form Submission
        vm.submit = function () {
            if (vm.dataForm.$invalid) {
                toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
            } else {
                vm.isLoading = true;

                HttpSvc.post('routeplans', vm.actual, Auth.getTokenId(), false)
                    .then(function (result) {
                        toastr.success('Route Plan has been created successfully.', Auth.translate('SUCCESS'));
                        $state.go('routeplan.actual_mercado.update', { 'id': result.id });
                    }, function (error) {
                        toastr.error('Failed to create Route Plan. ' + error, Auth.translate('ERROR'));
                        vm.isLoading = false;
                    });
            }
        }

        /* ************************************************************* */

        // Call Action
        vm.initData();
    }

    /** @ngInject */
    function RoutePlanActualUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {
        Auth.init();

        var vm = this;
        vm.mode = 2;

        vm.actual = {};
        vm.routeList = [];
        vm.driverList = [];
        vm.selectedRoute = null;
        vm.selectedDriver = null;
        vm.isLoading = false;
        vm.isIgnore = false;
        vm.list = [];

        /* ************************************************************* */

        vm.initData = function () {
            vm.loadRouteTemplateList();
        }

        // Load Route Template List
        vm.loadRouteTemplateList = function () {
            vm.isLoading = true;

            HttpSvc.get('routeplantemplates/list', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.routeList = result;
                    vm.loadUsers();
                }, function () {
                    vm.isLoading = false;
                    toastr.error('Failed to retrieve Route Template list.', '');
                    $state.go('routeplan.actual_mercado.list');
                });
        }

        vm.loadUsers = function () {
            HttpSvc.get('users/list/drivers', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.driverList = result;
                    vm.loadData();
                }, function (error) {
                    toastr.error('Failed to retrieve Driver list.', '');
                    $state.go('routeplan.actual_mercado.list');
                });
        }

        // Load RP Preview
        vm.loadData = function () {
            var params = { id: $stateParams.id };
            HttpSvc.get('routeplans/:id', params, Auth.getTokenId(), false)
                .then(function (result) {
                    vm.actual = result;

                    vm.routeList.forEach(function (r) {
                        if (r.id == vm.actual.templateId) {
                            vm.selectedRoute = r;
                        }
                    });

                    vm.driverList.forEach(function (d) {
                        if (d.id == vm.actual.driverId) {
                            vm.selectedDriver = d;
                        }
                    });

                    var debtors = [];
                    vm.actual.routePlanDebtors.forEach(function (d) {
                        if (d.routePlanDocuments.length != 0) {
                            debtors.push(d);
                        }
                    });
                    vm.actual.routePlanDebtors = debtors;

                    vm.list = vm.listData(vm.actual.routePlanDebtors, vm.actual.routePlanRemarks);

                    vm.isLoading = false;
                }, function (error) {
                    vm.isLoading = false;
                    toastr.error('Failed to load Route Plan. ' + error, Auth.translate('ERROR'))
                    $state.go('routeplan.actual_mercado.list');
                    return;
                });
        };

        vm.listData = function (debtors, remarks) {
            // Concat debtors and remarks, then sort them by sequence
            vm.list = debtors.concat(remarks);
            return vm.list.sort(function (a, b) { a.sequence - b.sequence });
        }

        /* ************************************************************* */

        vm.selectedRouteChanged = function () {
            vm.actual.templateId = vm.selectedRoute.id;
        };

        vm.selectedDriverChanged = function () {
            vm.actual.driverId = vm.selectedDriver.id;
        };

        /* ************************************************************* */

        vm.isItemPresent = function (index) {
            return index !== -1 ? true : false;
        }

        vm.reassignSequence = function (list, direction, index) {
            var item;

            if (list === 'debtor') {
                item = angular.copy(vm.actual.routePlanDebtors[index]);
            } else {
                item = angular.copy(vm.actual.routePlanRemarks[index]);
            }

            if (direction === 'up') {
                item.sequence -= 1;
            } else {
                item.sequence += 1;
            }

            if (list === 'debtor') {
                vm.actual.routePlanDebtors.splice(index, 1, item);
            } else {
                vm.actual.routePlanRemarks.splice(index, 1, item);
            }

            vm.list = vm.listData(vm.actual.routePlanDebtors, vm.actual.routePlanRemarks);
        }

        /* ************************************************************* */

        vm.moveListItem = function (list, direction, currSequence) {
            // The list item affected by the moving, aka the list item opposite of the moved list item
            var affDirection;
            var affSequence;

            switch (direction) {
                case 'up':
                    affDirection = 'down'
                    affSequence = currSequence - 1;
                    break;
                case 'down':
                    affDirection = 'up';
                    affSequence = currSequence + 1;
                    break;
            }

            // Find out if the affected list item is from the debtors list or the remarks list
            var affectedDebtorIndex = vm.actual.routePlanDebtors.findIndex(function (debtor) { return debtor.sequence == affSequence });
            var affectedRemarkIndex = vm.actual.routePlanRemarks.findIndex(function (remark) { return remark.sequence == affSequence });

            // Find out the index of the moved list item
            var movedIndex;

            if (list === 'debtor') {
                movedIndex = vm.actual.routePlanDebtors.findIndex(function (debtor) { return debtor.sequence == currSequence })
            } else {
                movedIndex = vm.actual.routePlanRemarks.findIndex(function (remark) { return remark.sequence == currSequence })
            }

            if (vm.isItemPresent(affectedDebtorIndex)) {
                vm.reassignSequence('debtor', affDirection, affectedDebtorIndex);
            } else if (vm.isItemPresent(affectedRemarkIndex)) {
                vm.reassignSequence('remark', affDirection, affectedRemarkIndex);
            }

            vm.reassignSequence(list, direction, movedIndex);
        }

        vm.deleteListItem = function (type, sequence) {
            switch (type) {
                case 'debtor':
                    var debtorIndex = vm.actual.routePlanDebtors.findIndex(function (debtor) { return debtor.sequence == sequence });
                    if (vm.isItemPresent(debtorIndex)) {
                        vm.actual.routePlanDebtors.splice(debtorIndex, 1);
                    }
                    break;
                case 'remark':
                    var remarkIndex = vm.actual.routePlanRemarks.findIndex(function (remark) { return remark.sequence == sequence });
                    if (vm.isItemPresent(remarkIndex)) {
                        vm.actual.routePlanRemarks.splice(remarkIndex, 1);
                    }
                    break;
            }

            // Reassign the sequence of the list items after the sequence
            vm.actual.routePlanDebtors.forEach(function (debtor) {
                if (debtor.sequence > sequence) {
                    debtor.sequence--;
                }
            })

            vm.actual.routePlanRemarks.forEach(function (remark) {
                if (remark.sequence > sequence) {
                    remark.sequence--;
                }
            })

            vm.list = vm.listData(vm.actual.routePlanDebtors, vm.actual.routePlanRemarks);

        };

        /* ************************************************************* */

        vm.confirmRP = function () {
            if (vm.actual.routePlanDebtors.length == 0) {
                toastr.warning("Please add at least ONE Delivery Order document.", "No Document")
                return;
            }

            vm.actual.status = "CONFIRMED";
            vm.submit();
        }

        vm.completeRP = function () {
            HttpSvc.put('routeplans/complete/' + $stateParams.id, vm.actual, Auth.getTokenId(), false)
                .then(function (result) {
                    toastr.success('Route Plan is completed successfully!', Auth.translate('SUCCESS'));
                    $state.reload();
                }, function (error) {
                    toastr.error('Failed to cancel Route Plan. ' + error, Auth.translate('ERROR'));
                    vm.isLoading = false;
                });
        }

        vm.cancelRP = function () {
            HttpSvc.put('routeplans/cancel/' + $stateParams.id, vm.actual, Auth.getTokenId(), false)
                .then(function (result) {
                    toastr.success('Route Plan is cancelled successfully!', Auth.translate('SUCCESS'));
                    $state.reload();
                }, function (error) {
                    toastr.error('Failed to cancel Route Plan. ' + error, Auth.translate('ERROR'));
                    vm.isLoading = false;
                });
        }

        /* ************************************************************* */

        vm.showSelectDeliveryOrderModal = function () {

            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'app-modal-window',
                templateUrl: 'deliveryOrderListModal.html',
                controller: 'RoutePlanActualSelectDOModalCtrl',
                controllerAs: '$mdl',
                size: 'md',
            });

            modalInstance
                .result
                .then(function (objList) {
                    vm.addDeliveryOrder(objList);
                }, function () {
                });
        };

        vm.showAddRemarkModal = function () {

            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'addRemarkModal.html',
                controller: 'RoutePlanActualAddRemarkModalCtrl',
                controllerAs: '$mdl',
                size: 'md',
            });

            modalInstance
                .result
                .then(function (remark) {
                    vm.addRemark(remark);
                }, function () {
                });

        }

        vm.addDeliveryOrder = function (objList) {

            var isDebtorFound = false;


            objList.forEach(function (o) {
                vm.actual.routePlanDebtors.forEach(function (d) {
                    if (d.debtorId == o.debtorId && d.debtorBranchId == o.debtorBranchId) {
                        isDebtorFound = true;

                        var isDocFound = false;

                        d.routePlanDocuments.forEach(function (r) {
                            if (r.deliveryOrderId == o.id) {
                                isDocFound = true;
                            }
                        });

                        if (!isDocFound) {
                            d.routePlanDocuments.push({
                                deliveryOrderId: o.id,
                                deliveryOrderNo: o.deliveryOrderNo,
                            })
                        }
                    }
                });

                if (!isDebtorFound) {
                    vm.actual.routePlanDebtors.push({
                        debtorId: o.debtorId,
                        debtorBranchId: o.debtorBranchId,
                        debtorCode: o.debtorCode,
                        debtorName: o.debtorName,
                        debtorBranchName: o.debtorBranchName,
                        sequence: vm.list.length,
                        routePlanDocuments: [
                            {
                                deliveryOrderId: o.id,
                                deliveryOrderNo: o.deliveryOrderNo
                            }
                        ]
                    });
                }

                vm.list = vm.listData(vm.actual.routePlanDebtors, vm.actual.routePlanRemarks);
            });


        }

        vm.addRemark = function (remark) {

            vm.actual.routePlanRemarks.push({
                sequence: vm.list.length,
                remarks: remark,
                status: "PENDING",
                isRemark: true,
            });

            vm.list = vm.listData(vm.actual.routePlanDebtors, vm.actual.routePlanRemarks);

        }

        vm.completeRemark = function (id) {

            var index = vm.actual.routePlanRemarks.findIndex(function (remark) { return remark.id === id; });

            var item = {
                sequence: vm.actual.routePlanRemarks[index].sequence,
                remarks: vm.actual.routePlanRemarks[index].remarks,
                status: "COMPLETED",
                isRemark: true,
            }

            vm.actual.routePlanRemarks.splice(index, 1, item);

            vm.list = vm.listData(vm.actual.routePlanDebtors, vm.actual.routePlanRemarks);

        }

        /* ************************************************************* */

        vm.print = function () {

            var filename = vm.actual.planNo.replace("/", "_") + ".pdf";

            HttpSvc.getPdfObject('routeplans/print/' + vm.actual.id, Auth.getTokenId(), filename)
                .then(
                    null,
                    function (error) {
                        // Failed
                        toastr.error('Failed to print the Route Plan (Actual). ' + error, '');
                        return null;
                    });
        }

        /* ************************************************************* */

        // Form Submission
        vm.submit = function () {
            if (vm.dataForm.$invalid) {
                toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
            } else {
                HttpSvc.put('routeplans/' + $stateParams.id, vm.actual, Auth.getTokenId(), false)
                    .then(function (result) {
                        toastr.success('Route Plan has been updated successfully.', Auth.translate('SUCCESS'));
                        $state.reload();
                    }, function (error) {
                        toastr.error('Failed to update Route Plan. ' + error, Auth.translate('ERROR'));
                    });
            }
        }

        // Call Actions
        vm.initData();
    }

    /** @ngInject */
    function RoutePlanActualSelectDOModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, toastr) {
        var $mdl = this;

        $mdl.pageSize = 10;
        $mdl.numOfRecord = 0;
        $mdl.numOfRecordFiltered = 0;
        $mdl.numOfRecordDisplayed = 0;
        $mdl.startIndex = 0;
        $mdl.endIndex = 0;
        $mdl.doDataFull = [];
        $mdl.doData = [];
        $mdl.isLoading = false;
        $mdl.selectOrderIds = [];

        function refreshTableState(tableState, startIndex, endIndex) {

            var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.doDataFull, tableState.search.predicateObject) : $mdl.doDataFull;
            $mdl.numOfRecordFiltered = filtered.length;

            if (tableState.sort.predicate) {
                filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
            }
            var result = filtered.slice(startIndex, startIndex + endIndex);

            $mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
            $mdl.doData = result;

            tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);

            return tableState;
        };

        $mdl.retrieveData = function (tableState) {

            var pagination = tableState.pagination;
            $mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
            $mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.

            if ($mdl.doDataFull.length <= 0) {
                $mdl.isLoading = true;

                HttpSvc.get('routeplans/list/unselected/adhoc', {}, Auth.getTokenId(), true)
                    .then(function (result) {
                        $mdl.numOfRecord = result.length;
                        $mdl.doDataFull = result;
                        refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
                        $mdl.isLoading = false;
                    }, function () {
                        $mdl.isLoading = false;
                        toastr.error('Failed to retrieve data.', '');
                        return null;
                    });
            } else {
                refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
            }
        };

        // ********************************************************

        $mdl.confirmModal = function () {

            var doList = [];

            $mdl.selectOrderIds.forEach(function (s) {
                $mdl.doDataFull.forEach(function (d) {
                    if (d.id == s) {
                        doList.push({
                            id: d.id,
                            debtorId: d.debtorId,
                            debtorCode: d.debtorCode,
                            debtorName: d.debtorName,
                            debtorBranchId: d.debtorBranchId,
                            debtorBranchName: d.debtorBranchName,
                            deliveryOrderNo: d.deliveryOrderNo,
                        });
                    }
                });
            });

            $uibModalInstance.close(doList);
        }

        // Cancel Action
        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    function RoutePlanActualAddRemarkModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, toastr) {
        var $mdl = this;

        $mdl.confirmModal = function () {
            $uibModalInstance.close($mdl.remark);
        };

        $mdl.cancelModal = function () {
            $uibModalInstance.dismiss('cancel');
        };;
    }

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.routeplan.preview.controller', [])
			.controller('RoutePlanPreviewMainCtrl', RoutePlanPreviewMainCtrl)
			.controller('RoutePlanPreviewCreateCtrl', RoutePlanPreviewCreateCtrl)
			.controller('RoutePlanPreviewUpdateCtrl', RoutePlanPreviewUpdateCtrl);

	/** @ngInject */
	function RoutePlanPreviewMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) 
	{	
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.previewDataFull = [];
		vm.previewData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.previewDataFull, tableState.search.predicateObject) : vm.previewDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.previewData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.previewDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('routeplanpreviews/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.previewDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteRecord = function(recordId, recordName) {
			var params = {};
			HttpSvc.delete('routeplanpreviews/' + recordId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('routeplanpreviews/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.previewDataFull = result;
							
							toastr.success('The record for [' + recordName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete [' + recordName + '].', 'Delete Failed');
					return null;
			});
		};
		
		vm.print = function(docId, docNo) {
			
			var filename = docNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('routeplanpreviews/print/' + docId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print the Route Plan (Preview). ' + error, '');
							return null;
						});
		}
	};

	/** @ngInject */
	function RoutePlanPreviewCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;

		vm.preview = {};
		vm.preview.status ='ACTIVE'
		vm.routeList = [];
		vm.selectedRoute = null;
		vm.isLoading = false;
		vm.isIgnore = false;

		/* ************************************************************* */
		
		vm.initData = function() {
			vm.loadRouteTemplateList();	
		}

		// Load Route Template List
		vm.loadRouteTemplateList = function() {
			vm.isLoading = true;

			HttpSvc.get('routeplantemplates/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.routeList = result;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Route Template list.', '');
					$state.go('routeplan.preview.list');
			});
		}

		/* ************************************************************* */
		
		vm.selectedRouteChanged = function() {
			vm.preview.templateId = vm.selectedRoute.id;
		};

		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.isLoading = true;

				var ignore = vm.isIgnore ? '/1' : '';
				HttpSvc.post('routeplanpreviews' + ignore, vm.preview, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checkResult(result);						
					}, function(error) {
						toastr.error('Failed to create Route Plan Preview. ' + error, Auth.translate('ERROR'));
						vm.isLoading = false;
					});
			}
		}

		vm.checkResult = function(result) {
			if(result.httpStatusCode=='300')
			{
				var choice = confirm(result.message);
				if(choice)
				{
					vm.isIgnore = true;
					vm.submit();
				}
			}
			else
			{
				toastr.success('Route Plan Preview has been created successfully.', Auth.translate('SUCCESS'));
				$state.go('routeplan.preview.update', {'id': result.id });
			}
		}

		/* ************************************************************* */
		
		// Call Action
		vm.initData();
	}

	/** @ngInject */
	function RoutePlanPreviewUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();

		var vm = this;
		vm.mode = 2;

		vm.preview = {};
		vm.routeList = [];
		vm.selectedRoute = null;
		vm.isLoading = false;

		/* ************************************************************* */
		
		vm.initData = function() {
			vm.loadRouteTemplateList();	
		}

		// Load Route Template List
		vm.loadRouteTemplateList = function() {
			vm.isLoading = true;

			HttpSvc.get('routeplantemplates/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.routeList = result;
					vm.loadData();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve Route Template list.', '');
					$state.go('routeplan.preview.list');
			});
		}
						
		// Load RP Preview
		vm.loadData = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('routeplanpreviews/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.preview = result;

					vm.routeList.forEach(function(r) {
						if(r.id==vm.preview.templateId)
						{
							vm.selectedRoute = r;
						}
					});	

					var debtors = [];
					vm.preview.routePlanPreviewDebtors.forEach(function(d) {
						if(d.routePlanPreviewDocuments.length!=0) {
							debtors.push(d);
						}
					});
					vm.preview.routePlanPreviewDebtors = debtors;

					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Route Plan Preview.', Auth.translate('ERROR'))
					$state.go('routeplan.preview.list');
					return;
				});		
		};	

		/* ************************************************************* */
		
		vm.selectedRouteChanged = function() {
			vm.preview.templateId = vm.selectedRoute.id;
		};
		
		/* ************************************************************* */

		vm.convertRP = function() {
			HttpSvc.put('routeplanpreviews/convert/' + $stateParams.id, vm.preview, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Route Plan Preview has been converted successfully!', Auth.translate('SUCCESS'));
					$state.reload();
				}, function(error) {
					toastr.error('Failed to convert Route Plan. ' + error, Auth.translate('ERROR'));
					vm.isLoading = false;
				});
		}

		vm.cancelRP = function() {
			HttpSvc.put('routeplanpreviews/cancel/' + $stateParams.id, vm.preview, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Route Plan Preview is cancelled successfully!', Auth.translate('SUCCESS'));
					$state.reload();
				}, function(error) {
					toastr.error('Failed to cancel Route Plan. ' + error, Auth.translate('ERROR'));
					vm.isLoading = false;
				});
		}
		
		/* ************************************************************* */
		
		vm.print = function() {
			
			var filename = vm.preview.planNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('routeplanpreviews/print/' + vm.preview.id, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print the Route Plan (Preview). ' + error, '');
							return null;
						});
		}
		
		/* ************************************************************* */
				
		// Call Actions
		vm.initData();
	}

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.routeplan.template.controller', [])
			.controller('RoutePlanTemplateMainCtrl', RoutePlanTemplateMainCtrl)
			.controller('RoutePlanTemplateCreateCtrl', RoutePlanTemplateCreateCtrl)
			.controller('RoutePlanTemplateUpdateCtrl', RoutePlanTemplateUpdateCtrl);

	/** @ngInject */
	function RoutePlanTemplateMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) 
	{	
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.templateDataFull = [];
		vm.templateData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.templateDataFull, tableState.search.predicateObject) : vm.templateDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.templateData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.templateDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('routeplantemplates/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.templateDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteRecord = function(recordId, recordName) {
			var params = {};
			HttpSvc.delete('routeplantemplates/' + recordId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('routeplantemplates/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.templateDataFull = result;
							
							toastr.success('The record for [' + recordName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete [' + recordName + '].', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function RoutePlanTemplateCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;

		vm.template = {};
		vm.template.routePlanTemplateDetails = [];
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.selectedDebtor = null;
		vm.selectedDebtorBranch = null;
		vm.isLoading = false;
		vm.isLoadingDebtor = false;

		/* ************************************************************* */
		
		vm.initData = function() {
			vm.loadDebtorList();	
		}

		// Load Customer List
		vm.loadDebtorList = function() {
			vm.isLoadingDebtor = true;

			HttpSvc.get('debtors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					vm.isLoadingDebtor = false;
				}, function() {
					vm.isLoadingDebtor = false;
					toastr.error('Failed to retrieve Customer list.', '');
					$state.go('salesorders.list');
			});
		}
		
		// Load Customer Branch List
		vm.loadDebtorBranchList = function() {
			vm.isLoadingDebtor = true;

			HttpSvc.get('debtors/' + vm.selectedDebtor.id + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorBranchList = result;
					vm.isLoadingDebtor = false;
				}, function() {
					vm.isLoadingDebtor = false;
					toastr.error('Failed to retrieve Customer Branch list.', '');
					return null;
			});
		}

		/* ************************************************************* */
		
		vm.selectedDebtorChanged = function() {
			vm.loadDebtorBranchList();
		};
		
		/* ************************************************************* */

		vm.addDebtor = function() {
			if(vm.selectedDebtor==null) {
				toastr.warning('Select select a Customer first.','Error');				
				return false;
			}

			var debtorBranchId = vm.selectedDebtorBranch==null? null : vm.selectedDebtorBranch.id;
			var debtorBranchName = vm.selectedDebtorBranch==null? null : vm.selectedDebtorBranch.name;

			var d = {
				debtorId: vm.selectedDebtor.id,
				debtorBranchId: debtorBranchId,
				debtorName: vm.selectedDebtor.name,
				debtorBranchName: debtorBranchName,
				sequence: vm.template.routePlanTemplateDetails.length + 1,
			}
			
			var isExist = false;
			vm.template.routePlanTemplateDetails.forEach(function(s) {
				if(checkDebtorExist(s, d)) {
					isExist = true;
				}
			});

			if(isExist)
			{				
				toastr.warning('Customer & Branch is already on the list.','Error');
				return;
			}

			vm.template.routePlanTemplateDetails.push(d);
		}

		vm.removeDebtor = function(debtorId, debtorBranchId) {
			for (var x=0; x<vm.template.routePlanTemplateDetails.length; x++)
			{
				var obj = vm.template.routePlanTemplateDetails[x];
				if(obj.debtorId==debtorId && obj.debtorBranchId==debtorBranchId)
				{
					vm.template.routePlanTemplateDetails.splice(x, 1);
				}
			}
		}

		/* ************************************************************* */

		vm.moveDebtorUp = function(i) {
			if(i.sequence==1) return;

			var newSeq = i.sequence - 1;

			vm.template.routePlanTemplateDetails.forEach(function(s) {
				if(s.sequence==newSeq)
				{
					s.sequence+=1;
				}
			});

			i.sequence = newSeq;
		}
		
		vm.moveDebtorDown = function(i) {
			if(i.sequence==vm.template.routePlanTemplateDetails.length) return;

			var newSeq = i.sequence + 1;

			vm.template.routePlanTemplateDetails.forEach(function(s) {
				if(s.sequence==newSeq)
				{
					s.sequence-=1;
				}
			});

			i.sequence = newSeq;
		}

		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.isLoading = true;

				HttpSvc.post('routeplantemplates', vm.template, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Route Plan Template has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('routeplan.template.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLoading = false;
					});
			}
		}
		
		// Call Action
		vm.initData();
	}

	/** @ngInject */
	function RoutePlanTemplateUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) 
	{
		Auth.init();

		var vm = this;
		vm.mode = 2;

		vm.template = {};
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.selectedDebtor = null;
		vm.selectedDebtorBranch = null;
		vm.isLoading = false;
		vm.isLoadingDebtor = false;

		/* ************************************************************* */
		
		vm.initData = function() {
			vm.loadDebtorList();	
		}

		// Load Customer List
		vm.loadDebtorList = function() {
			vm.isLoadingDebtor = true;

			HttpSvc.get('debtors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					vm.isLoadingDebtor = false;
					vm.loadData();
				}, function() {
					vm.isLoadingDebtor = false;
					toastr.error('Failed to retrieve Customer list.', '');
					$state.go('salesorders.list');
			});
		}
		
		// Load Customer Branch List
		vm.loadDebtorBranchList = function() {
			vm.isLoadingDebtor = true;

			HttpSvc.get('debtors/' + vm.selectedDebtor.id + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorBranchList = result;
					vm.isLoadingDebtor = false;
				}, function() {
					vm.isLoadingDebtor = false;
					toastr.error('Failed to retrieve Customer Branch list.', '');
					return null;
			});
		}
						
		// Load Menu
		vm.loadData = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('routeplantemplates/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.template = result;
				}, function() {
					toastr.error('Failed to load Route Plan Template.', Auth.translate('ERROR'))
					$state.go('routeplan.template.list');
					return;
				});		
		};	

		/* ************************************************************* */
		
		vm.selectedDebtorChanged = function() {
			vm.loadDebtorBranchList();
		};
		
		/* ************************************************************* */

		vm.addDebtor = function() {
			if(vm.selectedDebtor==null) {
				toastr.warning('Select select a Customer first.','Error');				
				return false;
			}

			var debtorBranchId = vm.selectedDebtorBranch==null? null : vm.selectedDebtorBranch.id;
			var debtorBranchName = vm.selectedDebtorBranch==null? null : vm.selectedDebtorBranch.name;

			var d = {
				debtorId: vm.selectedDebtor.id,
				debtorBranchId: debtorBranchId,
				debtorName: vm.selectedDebtor.name,
				debtorBranchName: debtorBranchName,
				sequence: vm.template.routePlanTemplateDetails.length + 1,
			}
			
			var isExist = false;
			vm.template.routePlanTemplateDetails.forEach(function(s) {
				if(checkDebtorExist(s, d)) {
					isExist = true;
				}
			});

			if(isExist)
			{				
				toastr.warning('Customer & Branch is already on the list.','Error');
				return;
			}

			vm.template.routePlanTemplateDetails.push(d);
		}

		vm.removeDebtor = function(debtorId, debtorBranchId) {
			for (var x=0; x<vm.template.routePlanTemplateDetails.length; x++)
			{
				var obj = vm.template.routePlanTemplateDetails[x];
				if(obj.debtorId==debtorId && obj.debtorBranchId==debtorBranchId)
				{
					vm.template.routePlanTemplateDetails.splice(x, 1);
				}
			}
		}

		/* ************************************************************* */

		vm.moveDebtorUp = function(i) {
			if(i.sequence==1) return;

			var newSeq = i.sequence - 1;

			vm.template.routePlanTemplateDetails.forEach(function(s) {
				if(s.sequence==newSeq)
				{
					s.sequence+=1;
				}
			});

			i.sequence = newSeq;
		}
		
		vm.moveDebtorDown = function(i) {
			if(i.sequence==vm.template.routePlanTemplateDetails.length) return;

			var newSeq = i.sequence + 1;

			vm.template.routePlanTemplateDetails.forEach(function(s) {
				if(s.sequence==newSeq)
				{
					s.sequence-=1;
				}
			});

			i.sequence = newSeq;
		}

		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('routeplantemplates/' + $stateParams.id, vm.template, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Route Plan Template has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error('Failed to update Route Plan Template. ' + error, Auth.translate('ERROR'));
					});
			}
		}
		
		// Call Actions
		vm.initData();
	}

	function checkDebtorExist(i, obj) {

		if(i.debtorId==obj.debtorId && i.debtorBranchId==obj.debtorBranchId)
		{
			return true;
		}
		return false;
	}	

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.checklistentries.controller', [])
        .controller('SvcChecklistEntryMainCtrl', SvcChecklistEntryMainCtrl)
        .controller('SvcChecklistEntryCreateCtrl', SvcChecklistEntryCreateCtrl)
        .controller('SvcChecklistEntryUpdateCtrl', SvcChecklistEntryUpdateCtrl);

    /** @ngInject */
    function SvcChecklistEntryMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.entryDataFull = [];
		vm.entryData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.entryDataFull, tableState.search.predicateObject) : vm.entryDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.entryData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.entryDataFull.length <= 0) {				
				HttpSvc.get('services/entries/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.entryDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteEntry = function(entryId, entryName) {
			var params = {};
			HttpSvc.delete('services/entries/' + entryId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('services/entries/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.entryDataFull = result;
							
							toastr.success('The entry [' + entryName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the entry [' + entryName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function SvcChecklistEntryCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.entry = {};	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/entries', vm.entry, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Checklist Entry has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.checklistentries.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function SvcChecklistEntryUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.entry = {};
						
		// Load Checklist Entry
		vm.loadEntries = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('services/entries/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.entry = result;
				}, function() {
					toastr.error('Failed to load selected Checklist Entry.', Auth.translate('ERROR'))
					$state.go('serviceconfigs.checklistentries.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/entries/' + $stateParams.id, vm.entry, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Checklist Entry has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadEntries();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.loanitemstatuses.controller', [])
        .controller('SvcLoanItemStatusMainCtrl', SvcLoanItemStatusMainCtrl)
        .controller('SvcLoanItemStatusCreateCtrl', SvcLoanItemStatusCreateCtrl)
        .controller('SvcLoanItemStatusUpdateCtrl', SvcLoanItemStatusUpdateCtrl);

    /** @ngInject */
    function SvcLoanItemStatusMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.statusDataFull = [];
		vm.statusData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.statusDataFull, tableState.search.predicateObject) : vm.statusDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.statusData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.statusDataFull.length <= 0) {				
				HttpSvc.get('services/loanitemstates/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.statusDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteEntry = function(entryId, entryName) {
			var params = {};
			HttpSvc.delete('services/loanitemstates/' + entryId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('services/loanitemstates/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.statusDataFull = result;
							
							toastr.success('The status [' + entryName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the status [' + entryName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function SvcLoanItemStatusCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.loanstatus = {};	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/loanitemstates', vm.loanstatus, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Loan Item Status has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.loanitemstatuses.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function SvcLoanItemStatusUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.loanstatus = {};
						
		// Load Loan Item Status
		vm.loadStatuses = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('services/loanitemstates/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loanstatus = result;
				}, function() {
					toastr.error('Failed to load selected Loan Item Status.', Auth.translate('ERROR'))
					$state.go('serviceconfigs.loanitemstatuses.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/loanitemstates/' + $stateParams.id, vm.loanstatus, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Loan Item Status has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadStatuses();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.checklists.controller', [])
        .controller('SvcChecklistMainCtrl', SvcChecklistMainCtrl)
        .controller('SvcChecklistCreateCtrl', SvcChecklistCreateCtrl)
        .controller('SvcChecklistUpdateCtrl', SvcChecklistUpdateCtrl)
        .controller('SvcChecklistEntryModalCtrl', SvcChecklistEntryModalCtrl);

    /** @ngInject */
    function SvcChecklistMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.checklistDataFull = [];
		vm.checklistData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.checklistDataFull, tableState.search.predicateObject) : vm.checklistDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.checklistData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.checklistDataFull.length <= 0) {				
				HttpSvc.get('services/checklists/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.checklistDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteChecklist = function(checklistId, checklistName) {
			var params = {};
			HttpSvc.delete('services/checklists/' + checklistId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('services/checklists/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.checklistDataFull = result;
							
							toastr.success('The Checklist [' + checklistName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Checklist [' + checklistName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function SvcChecklistCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.checklist = {};	
		vm.checklist.asChecklistEntries = [];
		vm.categories = [];
		vm.serviceTypes = [];
		vm.selectedServiceType = null;
		vm.selectedCategory = null;
		vm.isLoading = false;
		
		/* ************************************************************* */
		
		vm.loadTypes = function() {
			vm.isLoading = true;
			
			HttpSvc.get('services/types/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.serviceTypes = result;	
						
						vm.loadCategories();
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve Service Type list.', '');
						return null;
				});
		};
		
		vm.loadCategories = function() {
			vm.isLoading = true;
			
			HttpSvc.get('equipmentcategories/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.categories = result;	
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve Equipment Category list.', '');
						return null;
				});
		};
		
		/* ************************************************************* */
			
		// Open Entry Modal Dialog
		vm.showAddEntryModal = function () {			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'EntryModal.html',
				controller: 'SvcChecklistEntryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addEntry(data);
				}, function () {
				});
		};				
		
		/* ************************************************************* */
		
		// Remove Entry
		vm.removeEntry = function(index) {
			var result = confirm('Confirm remove this Entry?');
			
			if(result) {
				vm.checklist.asChecklistEntries.splice(index, 1);				
			}
		};

		// Add Entry
		vm.addEntry = function(obj) {
			var isFound = false;
			
			vm.checklist.asChecklistEntries.forEach(function(c) {
				if(c.entryId==obj.entryId) {
					toastr.warning('Same entry found on the list already.');
					isFound = true;
				}
			});
			
			if(!isFound) {
				var element = {
					entryId: obj.entryId,
					group: obj.group,
					description: obj.description,
					sequence: vm.checklist.asChecklistEntries.length + 1,
				};
				vm.checklist.asChecklistEntries.push(element);				
			}
		};
		
		// Move Up Entry
		vm.moveUp = function(index) {
			vm.checklist.asChecklistEntries = 
				vm.arrayMove(vm.checklist.asChecklistEntries, index, index-1);
		}
		
		// Move Down Entry
		vm.moveDown = function(index) {
			vm.checklist.asChecklistEntries = 
				vm.arrayMove(vm.checklist.asChecklistEntries, index, index+1);
		}
		
		vm.arrayMove = function(arr, old_index, new_index) {
			arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
			
			var newIndex = 1;
			arr.forEach(function(a) {
				a.sequence = newIndex;
				newIndex = newIndex + 1;
			});
			
			return arr;
		};
		
		/* ************************************************************* */
		
		vm.selectedServiceTypeChanged = function() {
			vm.checklist.typeId = vm.selectedServiceType.id;
		}
		
		vm.selectedCategoryChanged = function() {
			vm.checklist.categoryId = vm.selectedCategory.id;
		}
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/checklists', vm.checklist, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Checklist has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.checklists.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadTypes();
	}
	
	/** @ngInject */
    function SvcChecklistUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.checklist = {};
		vm.categories = [];
		vm.serviceTypes = [];
		vm.selectedServiceType = null;
		vm.selectedCategory = null;
		vm.isLoading = false;
		
		/* ************************************************************* */
		
		vm.loadTypes = function() {
			vm.isLoading = true;
			
			HttpSvc.get('services/types/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.serviceTypes = result;	
						
						vm.loadCategories();
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve Service Type list.', '');
						return null;
				});
		};
		
		vm.loadCategories = function() {
			vm.isLoading = true;
			
			HttpSvc.get('equipmentcategories/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.categories = result;	
						vm.loadChecklist();
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve Equipment Category list.', '');
						return null;
				});
		};
		
		vm.loadChecklist = function() {
			vm.isLoading = true;
			
			HttpSvc.get('services/checklists/' + $stateParams.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						vm.checklist = result;	
						
						vm.serviceTypes.forEach(function(s) {
							if(s.id==vm.checklist.typeId) {
								vm.selectedServiceType = s;
							}
						});		
						
						vm.categories.forEach(function(c) {
							if(c.id==vm.checklist.categoryId) {
								vm.selectedCategory = c;
							}
						});						
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to load selected Service.', Auth.translate('ERROR'))
						$state.go('serviceconfigs.checklists.list');
						return null;
				});
		};
				
		/* ************************************************************* */
			
		// Open Entry Modal Dialog
		vm.showAddEntryModal = function () {			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'EntryModal.html',
				controller: 'SvcChecklistEntryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addEntry(data);
				}, function () {
				});
		};				
		
		/* ************************************************************* */
		
		// Remove Entry
		vm.removeEntry = function(index) {
			var result = confirm('Confirm remove this Entry?');
			
			if(result) {
				vm.checklist.asChecklistEntries.splice(index, 1);				
			}
		};

		// Add Entry
		vm.addEntry = function(obj) {
			
			var isFound = false;
			
			vm.checklist.asChecklistEntries.forEach(function(c) {
				if(c.entryId==obj.entryId) {
					toastr.warning('Same entry found on the list already.');
					isFound = true;
				}
			});
			
			if(!isFound) {
				var element = {
					entryId: obj.entryId,
					group: obj.group,
					description: obj.description,
					sequence: vm.checklist.asChecklistEntries.length + 1,
				};
				vm.checklist.asChecklistEntries.push(element);				
			}
		};
		
		// Move Up Entry
		vm.moveUp = function(index) {
			vm.checklist.asChecklistEntries = 
				vm.arrayMove(vm.checklist.asChecklistEntries, index, index-1);
		}
		
		// Move Down Entry
		vm.moveDown = function(index) {
			vm.checklist.asChecklistEntries = 
				vm.arrayMove(vm.checklist.asChecklistEntries, index, index+1);
		}
		
		vm.arrayMove = function(arr, old_index, new_index) {
			arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
			
			var newIndex = 1;
			arr.forEach(function(a) {
				a.sequence = newIndex;
				newIndex = newIndex + 1;
			});
			
			return arr;
		};
		
		/* ************************************************************* */
		
		vm.selectedServiceTypeChanged = function() {
			vm.checklist.typeId = vm.selectedServiceType.id;
		}
		
		vm.selectedCategoryChanged = function() {
			vm.checklist.categoryId = vm.selectedCategory.id;
		}
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/checklists/' + $stateParams.id, vm.checklist, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Checklist has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadTypes();		
	}
	
	// ZipCode Modal Controller
	function SvcChecklistEntryModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		$mdl.item = {};
		$mdl.entries = [];
		$mdl.selectedEntry = null;
		$mdl.isLoading = false;
		
		/* ************************************************************* */
		
		$mdl.beautify = function(group, description) {
			var newText = "";
			if(group) {
				newText = "<span class='dd-code'>" + group.toUpperCase();
			}
			if(description) {
				newText = newText + "</span>&nbsp;&nbsp;" + description;
			}	
			return newText;
		}
				
		/* ************************************************************* */
		
		$mdl.loadEntries = function(keyword) {
			$mdl.isLoading = true;
			
			HttpSvc.get('services/entries/list/' + keyword, {}, Auth.getTokenId(), true)
					.then(function(result) {	
						$mdl.entries = result;	
						$mdl.isLoading = false;
					}, function() {
						$mdl.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
		}
		
		/* *************************************************** */
				
		$mdl.selectedEntryChanged = function() {
			$mdl.item.entryId = $mdl.selectedEntry.id;
			$mdl.item.group = $mdl.selectedEntry.group;
			$mdl.item.description = $mdl.selectedEntry.description;
		}
		
		/* *************************************************** */
						
		$mdl.confirmModal = function() {
			if($mdl.selectedEntry == null) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
			
	
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.loanstatuses.controller', [])
        .controller('SvcLoanStatusMainCtrl', SvcLoanStatusMainCtrl)
        .controller('SvcLoanStatusCreateCtrl', SvcLoanStatusCreateCtrl)
        .controller('SvcLoanStatusUpdateCtrl', SvcLoanStatusUpdateCtrl)
        .controller('SvcLoanStatusLoanItemStatusModalCtrl', SvcLoanStatusLoanItemStatusModalCtrl);

    /** @ngInject */
    function SvcLoanStatusMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.statusDataFull = [];
		vm.statusData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.statusDataFull, tableState.search.predicateObject) : vm.statusDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.statusData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.statusDataFull.length <= 0) {				
				HttpSvc.get('services/loanstates/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.statusDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteEntry = function(entryId, entryName) {
			var params = {};
			HttpSvc.delete('services/loanstates/' + entryId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('services/loanstates/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.statusDataFull = result;
							
							toastr.success('The status [' + entryName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the status [' + entryName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function SvcLoanStatusCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.loanstatus = {};	
		vm.loanstatus.asLoanStateCheckLoanItemStates = [];
		
		/* ************************************************************* */
					
		// Open Loan Item Status Modal Dialog
		vm.showAddLoanItemStatusModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'LoanItemStatusModal.html',
				controller: 'UsergroupLoanItemStatusModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addLoanItemStatus(data);
				}, function () {
				});
		};				
		
		// Remove Loan Item Status
		vm.removeLoanItemStatus = function(index) {
			var result = confirm('Confirm remove this Loan Item Status?');
			
			if(result) {
				vm.loanstatus.asLoanStateCheckLoanItemStates.splice(index, 1);				
			}
		};

		// Add Loan Item Status
		vm.addLoanItemStatus = function(obj) {
			var element = {
				loanItemStateId: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.loanstatus.asLoanStateCheckLoanItemStates.some(function(el){
				if(el.loanItemStateId === element.loanItemStateId){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.loanstatus.asLoanStateCheckLoanItemStates.push(element);
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/loanstates', vm.loanstatus, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Loan Status has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.loanstatuses.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function SvcLoanStatusUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.loanstatus = {};
						
		// Load Loan Status
		vm.loadStatuses = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('services/loanstates/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loanstatus = result;
				}, function() {
					toastr.error('Failed to load selected Loan Status.', Auth.translate('ERROR'))
					$state.go('serviceconfigs.loanstatuses.list');
					return;
				});		
		};	
		
		/* ************************************************************* */
					
		// Open Loan Item Status Modal Dialog
		vm.showAddLoanItemStatusModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'LoanItemStatusModal.html',
				controller: 'UsergroupLoanItemStatusModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addLoanItemStatus(data);
				}, function () {
				});
		};				
		
		// Remove Loan Item Status
		vm.removeLoanItemStatus = function(index) {
			var result = confirm('Confirm remove this Loan Item Status?');
			
			if(result) {
				vm.loanstatus.asLoanStateCheckLoanItemStates.splice(index, 1);				
			}
		};

		// Add Loan Item Status
		vm.addLoanItemStatus = function(obj) {
			var element = {
				loanItemStateId: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.loanstatus.asLoanStateCheckLoanItemStates.some(function(el){
				if(el.loanItemStateId === element.loanItemStateId){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.loanstatus.asLoanStateCheckLoanItemStates.push(element);
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/loanstates/' + $stateParams.id, vm.loanstatus, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Loan Status has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadStatuses();		
	}
			
	// Loan Item Status Modal Controller
	function SvcLoanStatusLoanItemStatusModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		$mdl.item = {};
		$mdl.statuses = [];
		$mdl.selectedStatus = null;
					 
		// Load Statuses
		$mdl.loadStatuses = function() {			
			HttpSvc.get('services/loanitemstates/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.statuses = result;
				}, function() {
					toastr.error('Failed to load Loan Item Status List.', Auth.translate('ERROR'))
					$mdl.cancelModal();
					return;
				});		
		};		
		
		$mdl.selectedStatusChanged = function() {
			$mdl.item.id = $mdl.selectedStatus.id;
			$mdl.item.name = $mdl.selectedStatus.name;
		}
						
		$mdl.confirmModal = function() {
			if($mdl.statusForm.$invalid || $mdl.selectedStatus == null) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Init
		$mdl.loadStatuses();
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.pnsettings.controller', [])
        .controller('PushNotificationSettingMainCtrl', PushNotificationSettingMainCtrl)
        .controller('PushNotificationSettingCreateCtrl', PushNotificationSettingCreateCtrl)
        .controller('PushNotificationSettingUpdateCtrl', PushNotificationSettingUpdateCtrl);

    /** @ngInject */
    function PushNotificationSettingMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.notifDataFull = [];
		vm.notifData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.notifDataFull, tableState.search.predicateObject) : vm.notifDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.notifData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.notifDataFull.length <= 0) {							
				HttpSvc.get('pnsettings/list', {}, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.notifDataFull = result;		
						
						vm.notifDataFull.forEach(function(n) {
							n.module = PushNotificationSettingGetModuleName(n.moduleEvent);
						});

						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteNotification = function(notifId) {
			var params = {};
			HttpSvc.delete('pnsettings/' + notifId, params, Auth.getTokenId(), false)
				.then(function(result) {					
					toastr.success('The Push Notification Setting has been deleted.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function() {
					// Failed
					toastr.error('Failed to delete the Push Notification Setting.', 'Failed');
					return null;
			});
		};			
	}
	
	/** @ngInject */
    function PushNotificationSettingCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;		
		
		vm.moduleList = PushNotificationSettingModuleList();
		vm.userList = [];
		
		vm.notif = {};
		vm.notif.isActive = true;
		vm.selectedModule = null;
		vm.selectedUser = null;
		vm.lockButtons = false;

		/* *********************************************************************** */
				
		// Load User List
		vm.loadUserList = function() {
			HttpSvc.get('users/listwithsu', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.userList = result;
				}, function(error) {
					toastr.error(error, 'Failed to load User List');
				});				
		};

		vm.clearUser = function() {
			vm.selectedUser = null;
		}

		/* *********************************************************************** */
		
		vm.selectedModuleChanged = function() {
			vm.notif.moduleEvent = vm.selectedModule.id;
		};
		
		vm.selectedUserChanged = function() {
			vm.notif.userId = vm.selectedUser.id;
		};

		/* *********************************************************************** */
		
		// Form Submission
		vm.submit = function() {
			
			vm.lockButtons = true;
						
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {						
				HttpSvc.post('pnsettings', vm.notif, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Push Notification Setting has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.pnsettings.list');
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}
		
		// Call Actions
		vm.loadUserList();
	}
	
	/** @ngInject */
    function PushNotificationSettingUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		
		vm.moduleList = PushNotificationSettingModuleList();
		vm.userList = [];
		
		vm.notif = {};
		vm.selectedModule = null;
		vm.selectedUser = null;
		vm.lockButtons = false;

		/* *********************************************************************** */
				
		// Load User List
		vm.loadUserList = function() {
			HttpSvc.get('users/listwithsu', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.userList = result;
					vm.loadNotif();
				}, function(error) {
					toastr.error(error, 'Failed to load User List');
				});				
		};
				
		// Load NotificationSetting
		vm.loadNotif = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('pnsettings/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.notif = result;

					vm.moduleList.forEach(function(m) {
						if(m.id==vm.notif.moduleEvent) {
							vm.selectedModule = m;
						}
					});
					vm.userList.forEach(function(u) {
						if(u.id==vm.notif.userId) {
							vm.selectedUser = u;
						}
					});					
				}, function() {
					toastr.error('Failed to load selected Push Notification Setting.', Auth.translate('ERROR'))
					$state.go('serviceconfigs.pnsettings.list');
					return;
				});		
		};	

		vm.clearUser = function() {
			vm.selectedUser = null;
		}

		/* *********************************************************************** */
		
		vm.selectedModuleChanged = function() {
			vm.notif.moduleEvent = vm.selectedModule.id;
		};
		
		vm.selectedUserChanged = function() {
			vm.notif.userId = vm.selectedUser.id;
		};

		/* *********************************************************************** */
		
		// Form Submission
		vm.submit = function() {
						
			vm.lockButtons = true;
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {
				HttpSvc.put('pnsettings/' + $stateParams.id, vm.notif, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Push Notification Setting has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.pnsettings.list');
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}
		
		// Call Actions
		vm.loadUserList();			
	}
	
	function PushNotificationSettingModuleList() { 
		return [
			{id: 1, name: 'NEW CASE'}, 
			{id: 2, name: 'CASE ASSIGNED'},
			{id: 3, name: 'CASE NOTES'},
			{id: 4, name: 'CASE CLOSED'},
			{id: 5, name: 'CASE CONVERTED'},
			{id: 6, name: 'NEW WORK ORDER'},
			{id: 7, name: 'WORK ORDER STATUS CHANGED'},
			{id: 8, name: 'WORK ORDER PROCESS ASSIGNED'},
			//{id: 9, name: 'WORK ORDER NOTES'},
			{id: 10, name: 'WORK ORDER PROCESS COMPLETED'},
		];
	}
	
	function PushNotificationSettingGetModuleName(id) { 

		var moduleList = PushNotificationSettingModuleList();
		
		var result = "-";

		moduleList.forEach(function(m) {
			if(m.id==id)
				result = m.name;
		})

		return result;
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.processes.controller', [])
        .controller('SvcProcessMainCtrl', SvcProcessMainCtrl)
        .controller('SvcProcessCreateCtrl', SvcProcessCreateCtrl)
        .controller('SvcProcessUpdateCtrl', SvcProcessUpdateCtrl);

    /** @ngInject */
    function SvcProcessMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.processDataFull = [];
		vm.processData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.processDataFull, tableState.search.predicateObject) : vm.processDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.processData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.processDataFull.length <= 0) {				
				HttpSvc.get('services/processes/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.processDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteProcess = function(processId, processName) {
			var params = {};
			HttpSvc.delete('services/processes/' + processId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('services/processes/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.processDataFull = result;
							
							toastr.success('The process [' + processName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the process [' + processName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function SvcProcessCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.process = {};	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/processes', vm.process, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Process has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.processes.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function SvcProcessUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.process = {};
						
		// Load Process
		vm.loadProcess = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('services/processes/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.process = result;
				}, function() {
					toastr.error('Failed to load selected Process.', Auth.translate('ERROR'))
					$state.go('serviceconfigs.processes.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/processes/' + $stateParams.id, vm.process, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Process has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadProcess();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.rostertypes.controller', [])
        .controller('SvcRosterTypeMainCtrl', SvcRosterTypeMainCtrl)
        .controller('SvcRosterTypeCreateCtrl', SvcRosterTypeCreateCtrl)
        .controller('SvcRosterTypeUpdateCtrl', SvcRosterTypeUpdateCtrl);

    /** @ngInject */
    function SvcRosterTypeMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.rosterTypeDataFull = [];
		vm.rosterTypeData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.rosterTypeDataFull, tableState.search.predicateObject) : vm.rosterTypeDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.rosterTypeData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.rosterTypeDataFull.length <= 0) {				
				HttpSvc.get('services/rostertypes/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.rosterTypeDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteRosterType = function(rosterTypeId, rosterTypeName) {
			var params = {};
			HttpSvc.delete('services/rostertypes/' + rosterTypeId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('services/rostertypes/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.rosterTypeDataFull = result;
							
							toastr.success('The Roster Type [' + rosterTypeName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Roster Type [' + rosterTypeName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function SvcRosterTypeCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.rosterType = {};	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/rostertypes', vm.rosterType, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Roster Type has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.rostertypes.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function SvcRosterTypeUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.rosterType = {};
						
		// Load SvcRosterType
		vm.loadSvcRosterType = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('services/rostertypes/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.rosterType = result;
				}, function() {
					toastr.error('Failed to load selected Roster Type.', Auth.translate('ERROR'))
					$state.go('serviceconfigs.rostertypes.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/rostertypes/' + $stateParams.id, vm.rosterType, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Roster Type has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadSvcRosterType();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.services.controller', [])
        .controller('SvcServiceMainCtrl', SvcServiceMainCtrl)
        .controller('SvcServiceCreateCtrl', SvcServiceCreateCtrl)
        .controller('SvcServiceUpdateCtrl', SvcServiceUpdateCtrl)
        .controller('SvcServiceImportCtrl', SvcServiceImportCtrl)
        .controller('SvcServiceProcessModalCtrl', SvcServiceProcessModalCtrl);

    /** @ngInject */
    function SvcServiceMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.serviceDataFull = [];
		vm.serviceData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.serviceDataFull, tableState.search.predicateObject) : vm.serviceDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.serviceData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.serviceDataFull.length <= 0) {				
				HttpSvc.get('services/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.serviceDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteService = function(serviceId, serviceName) {
			var params = {};
			HttpSvc.delete('services/' + serviceId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('services/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.serviceDataFull = result;
							
							toastr.success('The service [' + serviceName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the service [' + serviceName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function SvcServiceCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.service = {};	
		vm.service.asServiceProcesses = [];
		vm.categories = [];
		vm.serviceTypes = [];
		vm.selectedServiceType = null;
		vm.selectedCategory = null;
		vm.isLoading = false;
		
		/* ************************************************************* */
		
		vm.loadTypes = function() {
			vm.isLoading = true;
			
			HttpSvc.get('services/types/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.serviceTypes = result;	
						
						vm.loadCategories();
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve Service Type list.', '');
						return null;
				});
		};
		
		vm.loadCategories = function() {
			vm.isLoading = true;
			
			HttpSvc.get('equipmentcategories/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.categories = result;	
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve Equipment Category list.', '');
						return null;
				});
		};
		
		/* ************************************************************* */
			
		// Open Process Modal Dialog
		vm.showAddProcessModal = function () {			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'ProcessModal.html',
				controller: 'SvcServiceProcessModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addProcess(data);
				}, function () {
				});
		};				
		
		/* ************************************************************* */
		
		// Remove Process
		vm.removeProcess = function(index) {
			var result = confirm('Confirm remove this Process?');
			
			if(result) {
				vm.service.asServiceProcesses.splice(index, 1);				
			}
		};

		// Add Process
		vm.addProcess = function(obj) {
			var element = {
				processId: obj.processId,
				code: obj.code,
				name: obj.name,
				kpiWeightage: obj.kpiWeightage,
				isRequireSignature: obj.isRequireSignature,
				sequence: vm.service.asServiceProcesses.length + 1,
			};
			vm.service.asServiceProcesses.push(element);
		};
		
		// Move Up Process
		vm.moveUp = function(index) {
			vm.service.asServiceProcesses = 
				vm.arrayMove(vm.service.asServiceProcesses, index, index-1);
		}
		
		// Move Down Process
		vm.moveDown = function(index) {
			vm.service.asServiceProcesses = 
				vm.arrayMove(vm.service.asServiceProcesses, index, index+1);
		}
		
		vm.arrayMove = function(arr, old_index, new_index) {
			arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
			
			var newIndex = 1;
			arr.forEach(function(a) {
				a.sequence = newIndex;
				newIndex = newIndex + 1;
			});
			
			return arr;
		};
		
		/* ************************************************************* */
		
		vm.selectedServiceTypeChanged = function() {
			vm.service.typeId = vm.selectedServiceType.id;
		}
		
		vm.selectedCategoryChanged = function() {
			vm.service.categoryId = vm.selectedCategory.id;
		}
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services', vm.service, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Service has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.services.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadTypes();
	}
	
	/** @ngInject */
    function SvcServiceUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.service = {};
		vm.categories = [];
		vm.serviceTypes = [];
		vm.selectedServiceType = null;
		vm.selectedCategory = null;
		vm.isLoading = false;
		
		/* ************************************************************* */
		
		vm.loadTypes = function() {
			vm.isLoading = true;
			
			HttpSvc.get('services/types/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.serviceTypes = result;	
						
						vm.loadCategories();
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve Service Type list.', '');
						return null;
				});
		};
		
		vm.loadCategories = function() {
			vm.isLoading = true;
			
			HttpSvc.get('equipmentcategories/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.categories = result;	
						vm.loadService();
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve Equipment Category list.', '');
						return null;
				});
		};
		
		vm.loadService = function() {
			vm.isLoading = true;
			
			HttpSvc.get('services/' + $stateParams.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						vm.service = result;	
						
						vm.serviceTypes.forEach(function(s) {
							if(s.id==vm.service.typeId) {
								vm.selectedServiceType = s;
							}
						});		
						
						vm.categories.forEach(function(c) {
							if(c.id==vm.service.categoryId) {
								vm.selectedCategory = c;
							}
						});						
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to load selected Service.', Auth.translate('ERROR'))
						$state.go('serviceconfigs.services.list');
						return null;
				});
		};
				
		/* ************************************************************* */
			
		// Open Process Modal Dialog
		vm.showAddProcessModal = function () {			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'ProcessModal.html',
				controller: 'SvcServiceProcessModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addProcess(data);
				}, function () {
				});
		};				
		
		/* ************************************************************* */
		
		// Remove Process
		vm.removeProcess = function(index) {
			var result = confirm('Confirm remove this Process?');
			
			if(result) {
				vm.service.asServiceProcesses.splice(index, 1);				
			}
		};

		// Add Process
		vm.addProcess = function(obj) {
			var element = {
				processId: obj.processId,
				code: obj.code,
				name: obj.name,
				kpiWeightage: obj.kpiWeightage,
				isRequireSignature: obj.isRequireSignature,
				sequence: vm.service.asServiceProcesses.length + 1,
			};
			vm.service.asServiceProcesses.push(element);
		};
		
		// Move Up Process
		vm.moveUp = function(index) {
			vm.service.asServiceProcesses = 
				vm.arrayMove(vm.service.asServiceProcesses, index, index-1);
		}
		
		// Move Down Process
		vm.moveDown = function(index) {
			vm.service.asServiceProcesses = 
				vm.arrayMove(vm.service.asServiceProcesses, index, index+1);
		}
		
		vm.arrayMove = function(arr, old_index, new_index) {
			arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
			
			var newIndex = 1;
			arr.forEach(function(a) {
				a.sequence = newIndex;
				newIndex = newIndex + 1;
			});
			
			return arr;
		};
		
		/* ************************************************************* */
		
		vm.selectedServiceTypeChanged = function() {
			vm.service.typeId = vm.selectedServiceType.id;
		}
		
		vm.selectedCategoryChanged = function() {
			vm.service.categoryId = vm.selectedCategory.id;
		}
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/' + $stateParams.id, vm.service, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Service has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadTypes();		
	}
	
	/** @ngInject */
	function SvcServiceImportCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;		
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.importType = 1;
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;
		
		/* **************************************************** */

		vm.scrollLeft = function() {
			document.getElementById('scroll-container').scrollLeft -= 300;
		}
		
		vm.scrollRight = function() {
			document.getElementById('scroll-container').scrollLeft += 300;
		}
		
		/* **************************************************** */
		
		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";

		/* **************************************************** */
		
		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		vm.importOptions.createService = true;
		vm.importOptions.updateService = true;
		vm.importOptions.createServiceType = true;
		vm.importOptions.updateServiceType = true;
		vm.importOptions.createProcess = true;
		vm.importOptions.updateProcess = true;
		vm.importOptions.createEquipmentCategory = true;
		vm.importOptions.updateEquipmentCategory = true;
		vm.importOptions.createType = true;
		vm.importOptions.updateType = true;
		vm.importOptions.createProcess = true;
		vm.importOptions.updateProcess = true;
		
		/* **************************************************** */
		
		vm.goBack = function() {
			$state.reload();
		}
		
		/* **************************************************** */
		
		vm.importResult = {};
		
		/* **************************************************** */
				
		vm.downloadTemplate = function(downloadType, templateName) {
			
			var filename = templateName + ".xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject(downloadType + '/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};	
		
		/* **************************************************** */
		
		vm.importData = function() {
			vm.isImporting = true;
			
			HttpSvc.post(vm.importType + '/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
				}, function(error) {
				});
		}
		
		/* **************************************************** */
		
		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}
		
		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;			
		}
		
		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];
			
			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}
		
		// Upload File
		vm.uploadFile = function(importType) {	
			vm.resetFileUploadParams();
			
			vm.lockButtons = true;
			vm.importType = importType;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;
								
			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;
			
			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();	
				vm.uploadMedia(vm.mediaToUpload);
			}	
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {
						
						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);
						
					}, function(error) {
						toastr.error(error, 'Failed');
						
						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {					
					vm.isUploaded = true;
					
					// Call Process Excel API 
					var apiUrl = vm.importType + '/import/' + resp.data;

					HttpSvc.post(apiUrl, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;
							
							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			}  else if(vm.serverMode==1) { // Azure Server
							
				/* Initialize variables */
				/* ************************************* */	
				handleFileSelect(_fileToUpload);
				/* ************************************* */	
				
				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							} 
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,				
			}).then(function(response) {	
				vm.isUploaded = true;
				
				// Call Process Excel API 
				var apiUrl = vm.importType + '/import/' + excelFilename;

				HttpSvc.post(apiUrl, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;
						
						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }		
	};
	
	function SvcServiceProcessModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		$mdl.item = {};
		$mdl.processes = [];
		$mdl.selectedProcess = null;
		$mdl.isLoading = false;
		
		/* *************************************************** */
		
		$mdl.loadProcesses = function(keyword) {
			$mdl.isLoading = true;
			
			HttpSvc.get('services/processes/list/' + keyword, {}, Auth.getTokenId(), true)
					.then(function(result) {	
						$mdl.processes = result;	
						$mdl.isLoading = false;
					}, function() {
						$mdl.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
		}
		
		/* *************************************************** */
				
		$mdl.selectedProcessChanged = function() {
			$mdl.item.processId = $mdl.selectedProcess.id;
			$mdl.item.code = $mdl.selectedProcess.code;
			$mdl.item.name = $mdl.selectedProcess.name;
		}
		
		/* *************************************************** */
						
		$mdl.confirmModal = function() {
			if($mdl.modalForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.svctypes.controller', [])
        .controller('SvcTypeMainCtrl', SvcTypeMainCtrl)
        .controller('SvcTypeCreateCtrl', SvcTypeCreateCtrl)
        .controller('SvcTypeUpdateCtrl', SvcTypeUpdateCtrl);

    /** @ngInject */
    function SvcTypeMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.typeDataFull = [];
		vm.typeData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.typeDataFull, tableState.search.predicateObject) : vm.typeDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.typeData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.typeDataFull.length <= 0) {				
				HttpSvc.get('services/types/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.typeDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteSvcType = function(typeId, typeName) {
			var params = {};
			HttpSvc.delete('services/types/' + typeId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('services/types/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.typeDataFull = result;
							
							toastr.success('The service type [' + typeName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Service Type [' + typeName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function SvcTypeCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.svctype = {};	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/types', vm.svctype, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Service Type has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.svctypes.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function SvcTypeUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.svctype = {};
						
		// Load SvcType
		vm.loadSvcType = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('services/types/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.svctype = result;
				}, function() {
					toastr.error('Failed to load selected Service Type.', Auth.translate('ERROR'))
					$state.go('serviceconfigs.svctypes.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/types/' + $stateParams.id, vm.svctype, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Service Type has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadSvcType();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.spareparts.controller', [])
        .controller('SparePartMainCtrl', SparePartMainCtrl)
        .controller('SparePartCreateCtrl', SparePartCreateCtrl)
        .controller('SparePartUpdateCtrl', SparePartUpdateCtrl)
        .controller('SparePartImportCtrl', SparePartImportCtrl)
        .controller('SparePartEquipmentModalCtrl', SparePartEquipmentModalCtrl);

    /** @ngInject */
    function SparePartMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.dataFull = [];
		vm.data = [];
		vm.blobUrl = RmsApi.BLOBURL;

		vm.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}
			
			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.partName,
				brandName: predicate.brandName,
				equipmentName: predicate.equipmentName,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('spareparts/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isLoading = false;		
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;	
					vm.numOfPages = result.numberOfPages;	
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;		
			return tableState;
		};

		vm.resetSearch = function() 
		{
		}
		
		vm.deleteSparePart = function(partId, partName) {
			var params = {};
			HttpSvc.delete('spareparts/' + partId, params, Auth.getTokenId(), false)
				.then(function(result) {
					
					toastr.success('The Spare Part [' + partName + '] has been deleted.', 'Delete Success');
					$scope.$broadcast('refreshStTable');
				}, function() {
					// Failed
					toastr.error('Failed to delete the Spare Part [' + partName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function SparePartCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.sparepart = {};
		vm.brands = [];
		vm.selectedBrand = null;
		
		vm.sparepart.imageLocation = 'assets/img/empty_placeholder.png';
		vm.sparepart.oriImageLocation = '';
		vm.blobUrl = RmsApi.BLOBURL;
		vm.fileToUpload = null;
		vm.mediaToUpload = null;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		
		/* ************************************************************* */
		
		vm.loadBrands = function() {
			vm.isLoading = true;
			
			HttpSvc.get('equipmentbrands/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.brands = result;	
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Equipment Brand List', Auth.translate('ERROR'))
					$state.go('serviceconfigs.equipment.list');
					return;
				});		
		}		
		
		/* ************************************************************* */
		
		vm.selectedBrandChanged = function() {
			vm.sparepart.brandId = vm.selectedBrand.id;
		}
		
		/* ************************************************************* */
		
		// Refresh Document List
		vm.refreshDocs = function(tableState) {
			// Do nothing
		};
		
		// Remove Equipment Document
		vm.removeEquipment = function(eqId) {				
			for (var i = vm.sparepart.equipments.length-1; i>=0; i--) {
				var e = vm.sparepart.equipments[i];
				if(e.id==eqId) {
					vm.sparepart.equipments.splice(i, 1);
				}
			};
		};
		
		// Open Equipment Modal Dialog		
		vm.showAddEquipmentModal = function () {
			vm.equipment = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'EquipmentModal.html',
				controller: 'SOPEquipmentModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (dataList) {
					dataList.forEach(function(eq) {
						var isFound = false;
						vm.sparepart.equipments.forEach(function(e) {
							if(e.id==eq.id)
							{
								isFound = true;
							}
						});
						if(!isFound)
						{
							vm.sparepart.equipments.push(eq);
						}
						else
						{
							toastr.warning('One or more same equipments already exist on the list.');
						}
					});
				}, function () {
				});
		};	
		
		/* ************************************************************* */
				
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Set Upload Image
		vm.clearImage = function() {			
			vm.sparepart.imageLocation = 'assets/img/empty_placeholder.png';
			vm.sparepart.oriImageLocation = '';
			vm.fileToUpload = null;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (id) {
			var fileReader = new FileReader();
						
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Spare Part has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('serviceconfigs.spareparts.update', {'id': id });
				}, function (resp) {
					toastr.success('Spare Part has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('serviceconfigs.spareparts.update', {'id': id });
				}, function (evt) {
				});
				
			} else if(vm.serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {
							toastr.success('Spare Part has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('serviceconfigs.spareparts.update', {'id': id });
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
					});
				}
			}
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {

				imgLocation = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/spareparts/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "spareparts/" + newFilename + mediaExtension;

				} else if(vm.sparepart.oriImageLocation!="") {
					imgLocation = vm.sparepart.oriImageLocation;
				}
				vm.sparepart.imageLocation = imgLocation;	

				HttpSvc.post('spareparts', vm.sparepart, Auth.getTokenId(), false)
					.then(function(result) {
						azureStorageUrl = "";
						localStorageUrl = "";

						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(result.id);
							
						} 
						else if(vm.serverMode==0 && vm.fileToUpload) 
						{
							localStorageUrl = RmsApi.URL + "upload/spareparts/" + vm.item.Id;
							vm.uploadImage(result.id);
							
						} 
						else 
						{
							toastr.success('Spare Part has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('serviceconfigs.spareparts.update', {'id': result.id });
						}
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadBrands();
	}
	
	/** @ngInject */
    function SparePartUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.sparepart = {};
		vm.brands = [];
		vm.selectedBrand = null;
		
		vm.sparepart.imageLocation = '';
		vm.sparepart.oriImageLocation = '';
		vm.blobUrl = RmsApi.BLOBURL;
		vm.fileToUpload = null;
		vm.mediaToUpload = null;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		
		/* ************************************************************* */
		
		vm.loadBrands = function() {
			vm.isLoading = true;
			
			HttpSvc.get('equipmentbrands/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.brands = result;	
					vm.loadSparePart();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to load Equipment Brand List', Auth.translate('ERROR'))
					$state.go('serviceconfigs.equipment.list');
					return;
				});		
		}	
						
		// Load SparePart
		vm.loadSparePart = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('spareparts/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.sparepart = result;
					
					vm.brands.forEach(function(b) {
						if(b.id==vm.sparepart.brandId) {
							vm.selectedBrand = b;
						}
					});
					
					if(!vm.sparepart.imageLocation || vm.sparepart.imageLocation=='') {
						vm.sparepart.imageLocation = 'assets/img/empty_placeholder.png';
						vm.sparepart.oriImageLocation = "";
					} else {
						vm.sparepart.oriImageLocation = vm.sparepart.imageLocation;
						vm.sparepart.imageLocation = vm.rootUrl + vm.sparepart.imageLocation;
					}
				}, function() {
					toastr.error('Failed to load selected Spare Part.', Auth.translate('ERROR'))
					$state.go('serviceconfigs.spareparts.list');
					return;
				});		
		};	
		
		/* ************************************************************* */
		
		vm.selectedBrandChanged = function() {
			vm.sparepart.brandId = vm.selectedBrand.id;
		}
		
		/* ************************************************************* */
		
		// Refresh Document List
		vm.refreshDocs = function(tableState) {
			// Do nothing
		};
		
		// Remove Equipment Document
		vm.removeEquipment = function(eqId) {
			for (var i = vm.sparepart.equipments.length-1; i>=0; i--) {
				var e = vm.sparepart.equipments[i];
				if(e.id==eqId) {
					vm.sparepart.equipments.splice(i, 1);
				}
			};
		};
		
		// Open Equipment Modal Dialog		
		vm.showAddEquipmentModal = function () {
			vm.equipment = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'EquipmentModal.html',
				controller: 'SOPEquipmentModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (dataList) {
					dataList.forEach(function(eq) {
						var isFound = false;
						vm.sparepart.equipments.forEach(function(e) {
							if(e.id==eq.id)
							{
								isFound = true;
							}
						});
						if(!isFound)
						{
							vm.sparepart.equipments.push(eq);
						}
						else
						{
							toastr.warning('One or more same equipments already exist on the list.');
						}
					});
				}, function () {
				});
		};	
		
		/* ************************************************************* */
				
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Set Upload Image
		vm.clearImage = function() {			
			vm.sparepart.imageLocation = 'assets/img/empty_placeholder.png';
			vm.sparepart.oriImageLocation = '';
			vm.fileToUpload = null;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function () {
			var fileReader = new FileReader();
						
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Spare Part has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('Spare Part has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
				});
				
			} else if(vm.serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {
							toastr.success('Spare Part has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
					});
				}
			}
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.isLoading = true;

				imgLocation = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/spareparts/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "spareparts/" + newFilename + mediaExtension;

				} else if(vm.sparepart.oriImageLocation!="") {
					imgLocation = vm.sparepart.oriImageLocation;
				}
				vm.sparepart.imageLocation = imgLocation;	

				HttpSvc.put('spareparts/' + $stateParams.id, vm.sparepart, Auth.getTokenId(), false)
					.then(function(result) {
						azureStorageUrl = "";
						localStorageUrl = "";

						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage();
							
						} 
						else if(vm.serverMode==0 && vm.fileToUpload) 
						{
							localStorageUrl = RmsApi.URL + "upload/spareparts/" + vm.item.Id;
							vm.uploadImage();
							
						} 
						else 
						{
							toastr.success('Spare Part has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						}
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadBrands();	
	}

	/** @ngInject */
	function SparePartImportCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;		
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.serverMode = Auth.getServerMode();
		
		/* **************************************************** */
		
		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";

		/* **************************************************** */
		
		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		vm.importOptions.createSparePart = true;
		vm.importOptions.updateSparePart = true;
		vm.importOptions.createEquipmentBrand = true;
		vm.importOptions.updateEquipmentBrand = true;
		
		/* **************************************************** */
		
		vm.importResult = {};
		
		/* **************************************************** */
		
		vm.downloadTemplate = function() {
			
			var filename = "Spare Parts Template.xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject('spareparts/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};		
		
		/* **************************************************** */
		
		
		vm.importData = function() {
			vm.isImporting = true;
			
			HttpSvc.post('spareparts/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
					// Do nothing
				}, function(error) {
					// Do nothing
				});
		}
		
		/* **************************************************** */
		
		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}
		
		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;			
		}
		
		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];
			
			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}
		
		// Upload File
		vm.uploadFile = function() {	
			vm.resetFileUploadParams();
			
			vm.lockButtons = true;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;
			
			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;
			
			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();	
				vm.uploadMedia(vm.mediaToUpload);
			}	
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {
						
						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;					
						vm.uploadMedia(vm.mediaToUpload);
						
					}, function(error) {
						toastr.error(error, 'Failed');
						
						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {
						
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {					
					vm.isUploaded = true;
					
					// Call Process Excel API 
					HttpSvc.post('spareparts/import/' + excelFilename, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;
							
							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			}  else if(vm.serverMode==1) { // Azure Server
						
				/* Initialize variables */
				/* ************************************* */	
				handleFileSelect(_fileToUpload);
				/* ************************************* */	
				
				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							} 
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,				
			}).then(function(response) {	
				vm.isUploaded = true;
				
				// Call Process Excel API 
				HttpSvc.post('spareparts/import/' + excelFilename, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;
						
						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }		
	};

	// Equipment Modal Controller
	function SparePartEquipmentModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		// Initialize
		$mdl.selectedEquipments = [];
		$mdl.equipmentList = [];
		$mdl.lockButton = false;

		$mdl.searchEquipment = function() {
			$mdl.lockButton = true;
			
			HttpSvc.get('equipments/list/' + $mdl.searchText, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.equipmentList = result;
					$mdl.lockButton = false;
				}, function(error) {
					toastr.error("Failed to retrieve Equipment list.", "Failed");
					$uibModalInstance.dismiss('cancel');
				});				
		}
		
		// Confirm Action
		$mdl.confirmModal = function() {
			var eqList = [];
			$mdl.selectedEquipments.forEach(function(e) {
				var eq = {
					id: e.id,
					code: e.code,
					name: e.name,
					model: e.model,
					brandName: e.brandName,
					description: e.description,
				};
				eqList.push(eq);
			});
			
			if($mdl.equipmentForm.$valid) {
				$uibModalInstance.close(eqList);
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.techteams.controller', [])
        .controller('TechTeamMainCtrl', TechTeamMainCtrl)
        .controller('TechTeamCreateCtrl', TechTeamCreateCtrl)
        .controller('TechTeamUpdateCtrl', TechTeamUpdateCtrl)
        .controller('TechTeamMemberModalCtrl', TechTeamMemberModalCtrl)
        .controller('TechTeamZoneModalCtrl', TechTeamZoneModalCtrl);

    /** @ngInject */
    function TechTeamMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.teamDataFull = [];
		vm.teamData = [];

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.teamDataFull, tableState.search.predicateObject) : vm.teamDataFull;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.teamData = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {

			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.teamDataFull.length <= 0) {
				HttpSvc.get('services/techteams/list', params, Auth.getTokenId(), true)
					.then(function(result) {
						vm.numOfRecord = result.length;
						vm.teamDataFull = result;
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		vm.deleteTeam = function(teamId, teamName) {
			var params = {};
			HttpSvc.delete('services/techteams/' + teamId, params, Auth.getTokenId(), false)
				.then(function(result) {
                    HttpSvc.get('services/techteams/list', params, Auth.getTokenId(), true)
                        .then(function (result) {
                            vm.numOfRecord = result.length;
                            vm.teamDataFull = result;

                            toastr.success('The team [' + teamName + '] has been deleted.', 'Delete Success');
                            $scope.$broadcast('refreshStTable');
                        }, function () {
                            // Failed
                            toastr.error('Failed to retrieve data.', '');
                            return null;
                        });
				}, function() {
					// Failed
					toastr.error('Failed to delete the team [' + teamName + '].', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
    function TechTeamCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.mode = 1;
		vm.team = {};
		vm.team.asTechTeamMembers = [];
		vm.team.asZones = [];

		/* ************************************************************* */

		// Open Member Modal Dialog
		vm.showAddMemberModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'memberModal.html',
				controller: 'TechTeamMemberModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
                resolve: {
                    selectedMembers: function () {
                        return vm.team.asTechTeamMembers.map(function (member) {
                            return member.userId;
                        });
                    }
                }
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addMember(data);
				}, function () {
				});
		};

		/* ************************************************************* */

		// Remove Member
		vm.removeMember = function(index) {
			var result = confirm('Confirm remove this Team Member?');

			if(result) {
				vm.team.asTechTeamMembers.splice(index, 1);
			}
		};

		// Add Member
		vm.addMember = function(obj) {
			var element = {
				userId: obj.userId,
				name: obj.name,
				seniority: obj.seniority,
				isLeader: obj.isLeader,
			};
			vm.team.asTechTeamMembers.push(element);
		};

		/* ************************************************************* */

		// Open Zone Modal Dialog
		vm.showAddZoneModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'zoneModal.html',
				controller: 'TechTeamZoneModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addZone(data);
				}, function () {
				});
		};

		/* ************************************************************* */

		// Remove Zone
		vm.removeZone = function(index) {
			var result = confirm('Confirm remove this Zone?');

			if(result) {
				vm.team.asZones.splice(index, 1);
			}
		};

		// Add Zone
		vm.addZone = function(obj) {
			var element = {
				id: obj.id,
				code: obj.code,
				name: obj.name,
			};
			vm.team.asZones.push(element);
		};

		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/techteams', vm.team, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Zone has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.techteams.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Action
		// Do nothing
	}

	/** @ngInject */
    function TechTeamUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;
		vm.mode = 2;
		vm.team = {};

		// Load Zone
		vm.loadZone = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('services/techteams/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.team = result;
				}, function() {
					toastr.error('Failed to load selected Zone.', Auth.translate('ERROR'))
					$state.go('serviceconfigs.techteams.list');
					return;
				});
		};

		/* ************************************************************* */

		// Open Member Modal Dialog
		vm.showAddMemberModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'memberModal.html',
				controller: 'TechTeamMemberModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
                resolve: {
                    selectedMembers: function () {
                        return vm.team.asTechTeamMembers.map(function (member) {
                            return member.userId;
                        });
                    }
                }
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addMember(data);
				}, function () {
				});
		};

		/* ************************************************************* */

		// Remove Member
		vm.removeMember = function(index) {
			var result = confirm('Confirm remove this Team Member?');

			if(result) {
				vm.team.asTechTeamMembers.splice(index, 1);
			}
		};

		// Add Member
		vm.addMember = function(obj) {
			var element = {
				userId: obj.userId,
				name: obj.name,
				seniority: obj.seniority,
				isLeader: obj.isLeader,
			};
			vm.team.asTechTeamMembers.push(element);
		};

		/* ************************************************************* */

		// Open Zone Modal Dialog
		vm.showAddZoneModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'zoneModal.html',
				controller: 'TechTeamZoneModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addZone(data);
				}, function () {
				});
		};

		/* ************************************************************* */

		// Remove Zone
		vm.removeZone = function(index) {
			var result = confirm('Confirm remove this Zone?');

			if(result) {
				vm.team.asZones.splice(index, 1);
			}
		};

		// Add Zone
		vm.addZone = function(obj) {
			var element = {
				id: obj.id,
				code: obj.code,
				name: obj.name,
			};
			vm.team.asZones.push(element);
		};

		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/techteams/' + $stateParams.id, vm.team, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Zone has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Actions
		vm.loadZone();
	}

	// Member Modal Controller
    function TechTeamMemberModalCtrl($uibModalInstance, Auth, HttpSvc, toastr, selectedMembers) {
		var $mdl = this;

		$mdl.item = {};
		$mdl.item.isLeader = false;
		$mdl.users = [];
		$mdl.selectedUser = null;
		$mdl.isLoading = false;

		/* *************************************************** */

		$mdl.loadUsers = function(keyword) {
			$mdl.isLoading = true;

			HttpSvc.get('services/techteams/technicians/list/' + keyword, {}, Auth.getTokenId(), true)
					.then(function(result) {
						$mdl.users = result.filter(function(user) {
                            return !selectedMembers.includes(user.id);
                        });
						$mdl.isLoading = false;
					}, function() {
						$mdl.isLoading = false;
						toastr.error('Failed to retrieve technician list.', '');
						return null;
				});
		}

		/* ********************************************** */

		$mdl.selectedUserChanged = function() {
			$mdl.item.userId = $mdl.selectedUser.id;
			$mdl.item.name = $mdl.selectedUser.firstName + ' ' + $mdl.selectedUser.lastName;
		};

		/* ********************************************** */

		$mdl.confirmModal = function() {
			if($mdl.selectedUser == null || $mdl.modalForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Init
		$mdl.loadUsers("");
	};

	// Zone Modal Controller
	function TechTeamZoneModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;

		$mdl.item = {};
		$mdl.zones = [];
		$mdl.selectedZone = null;
		$mdl.isLoading = false;

		/* *************************************************** */

		$mdl.loadZones = function(keyword) {
			$mdl.isLoading = true;

			HttpSvc.get('services/zones/list/' + keyword, {}, Auth.getTokenId(), true)
					.then(function(result) {
						$mdl.zones = result;
						$mdl.isLoading = false;
					}, function() {
						$mdl.isLoading = false;
						toastr.error('Failed to retrieve zone list.', '');
						return null;
				});
		}

		/* ********************************************** */

		$mdl.selectedZoneChanged = function() {
			$mdl.item.id = $mdl.selectedZone.id;
			$mdl.item.code = $mdl.selectedZone.code;
			$mdl.item.name = $mdl.selectedZone.name;
		};

		/* ********************************************** */

		$mdl.confirmModal = function() {
			if($mdl.selectedZone == null || $mdl.modalForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Init
		$mdl.loadZones("");
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.workorderstatuses.controller', [])
        .controller('SvcWorkOrderStatusMainCtrl', SvcWorkOrderStatusMainCtrl)
        .controller('SvcWorkOrderStatusCreateCtrl', SvcWorkOrderStatusCreateCtrl)
        .controller('SvcWorkOrderStatusUpdateCtrl', SvcWorkOrderStatusUpdateCtrl)
        .controller('SvcWorkOrderStatusLoanItemStatusModalCtrl', SvcWorkOrderStatusLoanItemStatusModalCtrl);

    /** @ngInject */
    function SvcWorkOrderStatusMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.statusDataFull = [];
		vm.statusData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.statusDataFull, tableState.search.predicateObject) : vm.statusDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.statusData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.statusDataFull.length <= 0) {				
				HttpSvc.get('services/workorderstates/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.statusDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteEntry = function(entryId, entryName) {
			var params = {};
			HttpSvc.delete('services/workorderstates/' + entryId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('services/workorderstates/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.statusDataFull = result;
							
							toastr.success('The status [' + entryName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the status [' + entryName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function SvcWorkOrderStatusCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.workorderstatus = {};	
		vm.workorderstatus.asServiceWorkStateCheckLoanItemStates = [];
		
		/* ************************************************************* */
					
		// Open Loan Item Status Modal Dialog
		vm.showAddLoanItemStatusModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'LoanItemStatusModal.html',
				controller: 'UsergroupLoanItemStatusModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addLoanItemStatus(data);
				}, function () {
				});
		};				
		
		// Remove Loan Item Status
		vm.removeLoanItemStatus = function(index) {
			var result = confirm('Confirm remove this Loan Item Status?');
			
			if(result) {
				vm.workorderstatus.asServiceWorkStateCheckLoanItemStates.splice(index, 1);				
			}
		};

		// Add Loan Item Status
		vm.addLoanItemStatus = function(obj) {
			var element = {
				loanItemStateId: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.workorderstatus.asServiceWorkStateCheckLoanItemStates.some(function(el){
				if(el.loanItemStateId === element.loanItemStateId){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.workorderstatus.asServiceWorkStateCheckLoanItemStates.push(element);
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/workorderstates', vm.workorderstatus, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Work Order Status has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.workorderstatuses.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function SvcWorkOrderStatusUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.workorderstatus = {};
						
		// Load Work Order Status
		vm.loadStatuses = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('services/workorderstates/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.workorderstatus = result;
				}, function() {
					toastr.error('Failed to load selected Work Order Status.', Auth.translate('ERROR'))
					$state.go('serviceconfigs.workorderstatuses.list');
					return;
				});		
		};	
		
		/* ************************************************************* */
					
		// Open Loan Item Status Modal Dialog
		vm.showAddLoanItemStatusModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'LoanItemStatusModal.html',
				controller: 'UsergroupLoanItemStatusModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addLoanItemStatus(data);
				}, function () {
				});
		};				
		
		// Remove Loan Item Status
		vm.removeLoanItemStatus = function(index) {
			var result = confirm('Confirm remove this Loan Item Status?');
			
			if(result) {
				vm.workorderstatus.asServiceWorkStateCheckLoanItemStates.splice(index, 1);				
			}
		};

		// Add Loan Item Status
		vm.addLoanItemStatus = function(obj) {
			var element = {
				loanItemStateId: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.workorderstatus.asServiceWorkStateCheckLoanItemStates.some(function(el){
				if(el.loanItemStateId === element.loanItemStateId){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.workorderstatus.asServiceWorkStateCheckLoanItemStates.push(element);
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/workorderstates/' + $stateParams.id, vm.workorderstatus, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Work Order Status has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadStatuses();		
	}
			
	// Loan Item Status Modal Controller
	function SvcWorkOrderStatusLoanItemStatusModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		$mdl.item = {};
		$mdl.statuses = [];
		$mdl.selectedStatus = null;
					 
		// Load Statuses
		$mdl.loadStatuses = function() {			
			HttpSvc.get('services/loanitemstates/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.statuses = result;
				}, function() {
					toastr.error('Failed to load Loan Item Status List.', Auth.translate('ERROR'))
					$mdl.cancelModal();
					return;
				});		
		};		
		
		$mdl.selectedStatusChanged = function() {
			$mdl.item.id = $mdl.selectedStatus.id;
			$mdl.item.name = $mdl.selectedStatus.name;
		}
						
		$mdl.confirmModal = function() {
			if($mdl.statusForm.$invalid || $mdl.selectedStatus == null) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Init
		$mdl.loadStatuses();
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.zones.controller', [])
        .controller('SvcZoneMainCtrl', SvcZoneMainCtrl)
        .controller('SvcZoneCreateCtrl', SvcZoneCreateCtrl)
        .controller('SvcZoneUpdateCtrl', SvcZoneUpdateCtrl)
        .controller('SvcZipModalCtrl', SvcZipModalCtrl);

    /** @ngInject */
    function SvcZoneMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.zoneDataFull = [];
		vm.zoneData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.zoneDataFull, tableState.search.predicateObject) : vm.zoneDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.zoneData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.zoneDataFull.length <= 0) {				
				HttpSvc.get('services/zones/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.zoneDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteZone = function(zoneId, zoneName) {
			var params = {};
			HttpSvc.delete('services/zones/' + zoneId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('services/zones/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.zoneDataFull = result;
							
							toastr.success('The zone [' + zoneName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the zone [' + zoneName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function SvcZoneCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.zone = {};	
		vm.zone.asZoneZipCodes = [];
		
		/* ************************************************************* */
			
		// Open ZipCode Modal Dialog
		vm.showAddZipCodeModal = function () {			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'ZipModal.html',
				controller: 'SvcZipModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addZipCode(data);
				}, function () {
				});
		};				
		
		/* ************************************************************* */
		
		// Remove ZipCode
		vm.removeZipCode = function(index) {
			var result = confirm('Confirm remove this Zip Code?');
			
			if(result) {
				vm.zone.asZoneZipCodes.splice(index, 1);				
			}
		};

		// Add ZipCode
		vm.addZipCode = function(obj) {
			var element = {
				id: obj.id,
				zipCodeFrom: obj.zipCodeFrom,
				zipCodeTo: obj.zipCodeTo,
				areaName: obj.areaName,
			};
			vm.zone.asZoneZipCodes.push(element);
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/zones', vm.zone, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Zone has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.zones.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function SvcZoneUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.zone = {};
						
		// Load Zone
		vm.loadZone = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('services/zones/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.zone = result;
				}, function() {
					toastr.error('Failed to load selected Zone.', Auth.translate('ERROR'))
					$state.go('serviceconfigs.zones.list');
					return;
				});		
		};	
		
		/* ************************************************************* */
			
		// Open ZipCode Modal Dialog
		vm.showAddZipCodeModal = function () {			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'ZipModal.html',
				controller: 'SvcZipModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addZipCode(data);
				}, function () {
				});
		};				
		
		/* ************************************************************* */
		
		// Remove ZipCode
		vm.removeZipCode = function(index) {
			var result = confirm('Confirm remove this Zip Code?');
			
			if(result) {
				vm.zone.asZoneZipCodes.splice(index, 1);				
			}
		};

		// Add ZipCode
		vm.addZipCode = function(obj) {
			var element = {
				id: obj.id,
				zipCodeFrom: obj.zipCodeFrom,
				zipCodeTo: obj.zipCodeTo,
				areaName: obj.areaName,
			};
			vm.zone.asZoneZipCodes.push(element);
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/zones/' + $stateParams.id, vm.zone, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Zone has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadZone();		
	}
	
	// ZipCode Modal Controller
	function SvcZipModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		$mdl.item = {};						
						
		$mdl.confirmModal = function() {
			if($mdl.zipForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
			
	
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.serviceconfigs.worktypes.controller', [])
        .controller('SvcWorkTypeMainCtrl', SvcWorkTypeMainCtrl)
        .controller('SvcWorkTypeCreateCtrl', SvcWorkTypeCreateCtrl)
        .controller('SvcWorkTypeUpdateCtrl', SvcWorkTypeUpdateCtrl);

    /** @ngInject */
    function SvcWorkTypeMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.workTypeDataFull = [];
		vm.workTypeData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.workTypeDataFull, tableState.search.predicateObject) : vm.workTypeDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.workTypeData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.workTypeDataFull.length <= 0) {				
				HttpSvc.get('services/worktypes/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.workTypeDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteWorkType = function(workTypeId, workTypeName) {
			var params = {};
			HttpSvc.delete('services/worktypes/' + workTypeId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('services/worktypes/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.workTypeDataFull = result;
							
							toastr.success('The Work Type [' + workTypeName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Work Type [' + workTypeName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function SvcWorkTypeCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.workType = {};	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/worktypes', vm.workType, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Work Type has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('serviceconfigs.worktypes.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function SvcWorkTypeUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.workType = {};
						
		// Load SvcWorkType
		vm.loadSvcWorkType = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('services/worktypes/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.workType = result;
				}, function() {
					toastr.error('Failed to load selected Work Type.', Auth.translate('ERROR'))
					$state.go('serviceconfigs.worktypes.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/worktypes/' + $stateParams.id, vm.workType, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Work Type has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadSvcWorkType();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.services.loanrequests.controller', [])
        .controller('LoanRequestMainCtrl', LoanRequestMainCtrl)
        .controller('LoanRequestCreateCtrl', LoanRequestCreateCtrl)
        .controller('LoanRequestUpdateCtrl', LoanRequestUpdateCtrl)
        .controller('LoanRequestItemModalCtrl', LoanRequestItemModalCtrl)
        .controller('LoanRequestPrintModalCtrl', LoanRequestPrintModalCtrl);

    /** @ngInject */
    function LoanRequestMainCtrl($uibModal, Auth, HttpSvc, RmsApi, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.data = [];
		vm.dataFilter = {};

		vm.isLoading = false;
		vm.blobUrl = RmsApi.BLOBURL;

		vm.loadFilters = function()
		{
			HttpSvc.get('services/loanrequests/filters', {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.dataFilter = result;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		}

		vm.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.requestNo,
				workOrderNo:  predicate.workOrderNo,
				invoiceNo:  predicate.invoiceNo,
				debtorName: predicate.debtorName,
				userName: predicate.userName,
				itemName: predicate.itemName,
				status: predicate.status,
				loanType: predicate.type,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('services/loanrequests/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;

			return tableState;
		};

		vm.resetSearch = function()
		{
		}

        vm.showPrintDialog = function (id, requestNo) {

            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'printModal.html',
                controller: 'LoanRequestPrintModalCtrl',
                controllerAs: '$mdl',
                size: 'md',
                resolve: {
                    item: function () {
                        return {
                            object: {
                                loanId: id,
                                requestNo: requestNo,
                            },
                        }
                    }
                }
            });

            modalInstance
                .result
                .then(function (data) {
                }, function () {
                });
        };

		// Init Call
		//vm.loadFilters();
	};

	/** @ngInject */
    function LoanRequestCreateCtrl($scope, $state, $uibModal, $location, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;

		vm.userGroupId = Auth.getUserGroupId();

		vm.loanTypes = [
			{ id:'REPAIR', name:'REPAIR' },
			{ id:'CUSTOMER LOAN', name:'CUSTOMER LOAN' },
			{ id:'DEMO/INTERNAL LOAN', name:'DEMO/INTERNAL LOAN' },
			{ id:'SPARE PART', name:'SPARE PART' },
			{ id:'DISMANTLE', name:'DISMANTLE' },
		];

		vm.loan = {};
		vm.debtorList = [];
		vm.loanStatusList = [];
		vm.loanItemStatusList = [];
		vm.selectedDebtor = null;
		vm.selectedType = null;
		vm.selectedStatus = null;
		vm.isLoading = false;
		vm.lockButtons = false;

		/* ************************************************************* */

		vm.beautify = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			newText = newText + "</span>&nbsp;&nbsp;" + item.name.toUpperCase();
			if(item.description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + item.description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";
			}
			return newText;
		}

		/* ************************************************************* */

		vm.initData = function() {
			vm.loan.invoiceNo = "";
			vm.loan.purpose = "";
			vm.loan.remarks = "";
			vm.loan.asLoanRequestItems = [];

			vm.loadLoanStatusList();
			vm.loadLoanItemStatusList();
		};

		vm.loadDebtorList = function(searchString) {
			vm.lockButtons = true;

			HttpSvc.get('debtors/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve debtor list.', '');
					return null;
				});
		};

		vm.loadLoanStatusList = function() {
			vm.lockButtons = true;

			HttpSvc.get('services/loanstates/list/usergroup/' + vm.userGroupId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.loanStatusList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Loan Status list.', '');
					return null;
				});
		};

		vm.loadLoanItemStatusList = function() {
			vm.lockButtons = true;

			HttpSvc.get('services/loanitemstates/list/usergroup/' + vm.userGroupId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.loanItemStatusList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Loan Item Status list.', '');
					return null;
				});
		};

		/* ************************************************************* */

		vm.onSelectedDebtorChanged = function() {
			vm.loan.debtorId = vm.selectedDebtor.id;
		};

		vm.clearDebtor = function() {
			vm.selectedDebtor = null;
			vm.loan.debtorId = null;
		}

		vm.onSelectedTypeChanged = function() {
			vm.loan.type = vm.selectedType.id;
		};

		vm.onSelectedStatusChanged = function() {
			vm.loan.loanStateId = vm.selectedStatus.id;
		};

		/* ************************************************************* */

		// Remove Item
		vm.removeItem = function(index) {
			vm.loan.asLoanRequestItems.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};

		// Update Item
		vm.updateItem = function(index, obj) {
			var element = {
				equipmentId: obj.equipmentId,
				partId: obj.partId,
				storageId: obj.storageId,
				loanItemStateId: obj.loanItemStateId,
				itemCode: obj.itemCode,
				itemDescription: obj.itemDescription,
				storageName: obj.storageName,
				status: obj.status,
				quantity: obj.quantity,
				quantityReturn: obj.quantityReturn,
				price: obj.price,
				serialNo: obj.serialNo,
				remarks: obj.remarks,
			};
			vm.loan.asLoanRequestItems.splice(index, 1, element);
		};

		// Add Item
		vm.addItem = function(obj) {
			var element = {
				equipmentId: obj.equipmentId,
				partId: obj.partId,
				storageId: obj.storageId,
				loanItemStateId: obj.loanItemStateId,
				itemCode: obj.itemCode,
				itemDescription: obj.itemDescription,
				storageName: obj.storageName,
				status: obj.status,
				quantity: obj.quantity,
				quantityReturn: obj.quantityReturn,
				price: obj.price,
				serialNo: obj.serialNo,
				remarks: obj.remarks,
			};
			vm.loan.asLoanRequestItems.push(element);
		};

		/* ************************************************************* */

		vm.item = {};
		vm.showAddItemModal = function () {
			vm.item = {};

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'ESPItemModal.html',
				controller: 'LoanRequestItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.item,
							statuses: vm.loanItemStatusList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};

		vm.showEditItemModal = function (index) {
			vm.item = vm.loan.asLoanRequestItems[index];;

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'ESPItemModal.html',
				controller: 'LoanRequestItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
							statuses: vm.loanItemStatusList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};

		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				HttpSvc.post('services/loanrequests', vm.loan, Auth.getTokenId(), false)
					.then(function(result) {

						// Check Status
						vm.checkStatus(result);

					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkStatus = function(result)
		{
			if(result.statusCode=="-1")
			{
				vm.lockButtons = false;
				toastr.warning(result.message, Auth.translate('ERROR'));
			}
			else if(result.statusCode=="1")
			{
				toastr.success('Loan Request has been created successfully.', Auth.translate('SUCCESS'));
				$state.go('services.loanrequests.update', {'id': result.id });
			}
		}

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
    function LoanRequestUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.userGroupId = Auth.getUserGroupId();

		vm.loanTypes = [
			{ id:'REPAIR', name:'REPAIR' },
			{ id:'CUSTOMER LOAN', name:'CUSTOMER LOAN' },
			{ id:'DEMO/INTERNAL LOAN', name:'DEMO/INTERNAL LOAN' },
			{ id:'SPARE PART', name:'SPARE PART' },
			{ id:'DISMANTLE', name:'DISMANTLE' },
		];

		vm.loan = {};
		vm.debtorList = [];
		vm.loanStatusList = [];
		vm.loanItemStatusList = [];
		vm.selectedDebtor = null;
		vm.selectedType = null;
		vm.selectedStatus = null;
		vm.isLoading = false;
		vm.lockButtons = false;

		/* ************************************************************* */

		vm.beautify = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			newText = newText + "</span>&nbsp;&nbsp;" + item.name.toUpperCase();
			if(item.description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + item.description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";
			}
			return newText;
		}

		/* ************************************************************* */

		vm.loadData = function() {

			HttpSvc.get('services/loanrequests/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loan = result;

					HttpSvc.get('debtors/list/' + vm.loan.debtorId, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.debtorList = result;
							vm.debtorList.forEach(function(d) {
								if(d.id==vm.loan.debtorId) {
									vm.selectedDebtor = d;
								}
							});

							vm.loanTypes.forEach(function(p) {
								if(p.id==vm.loan.type) {
									vm.selectedType = p;
								}
							});

							vm.loadLoanStatusList();
							vm.loadLoanItemStatusList();

							vm.lockButtons = false;
						}, function() {
							vm.lockButtons = false;
							toastr.error('Failed to retrieve debtor list.', '');
							return null;
						});

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve debtor list.', '');
					return null;
				});
		};

		vm.loadDebtorList = function(searchString) {
			vm.lockButtons = true;

			HttpSvc.get('debtors/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve debtor list.', '');
					return null;
				});
		};

		vm.loadLoanStatusList = function() {
			vm.lockButtons = true;

			HttpSvc.get('services/loanstates/list/usergroup/' + vm.userGroupId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.loanStatusList = result;
					vm.lockButtons = false;

					vm.loanStatusList.forEach(function(p) {
						if(p.id==vm.loan.loanStateId) {
							vm.selectedStatus = p;
						}
					});

				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Loan Status list.', '');
					return null;
				});
		};

		vm.loadLoanItemStatusList = function() {
			vm.lockButtons = true;

			HttpSvc.get('services/loanitemstates/list/usergroup/' + vm.userGroupId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.loanItemStatusList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Loan Item Status list.', '');
					return null;
				});
		};

		/* ************************************************************* */

		vm.onSelectedDebtorChanged = function() {
			vm.loan.debtorId = vm.selectedDebtor.id;
		};

		vm.clearDebtor = function() {
			vm.selectedDebtor = null;
			vm.loan.debtorId = null;
		}

		vm.onSelectedTypeChanged = function() {
			vm.loan.type = vm.selectedType.id;
		};

		vm.onSelectedStatusChanged = function() {
			vm.loan.loanStateId = vm.selectedStatus.id;
		};

		/* ************************************************************* */

		// Remove Item
		vm.removeItem = function(index) {
			vm.loan.asLoanRequestItems.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};

		// Update Item
		vm.updateItem = function(index, obj) {
			var element = {
				id: obj.id,
				requestId: obj.requestId,
				equipmentId: obj.equipmentId,
				partId: obj.partId,
				storageId: obj.storageId,
				loanItemStateId: obj.loanItemStateId,
				itemCode: obj.itemCode,
				itemDescription: obj.itemDescription,
				storageName: obj.storageName,
				status: obj.status,
				quantity: obj.quantity,
				quantityReturn: obj.quantityReturn,
				price: obj.price,
				serialNo: obj.serialNo,
				remarks: obj.remarks,
			};
			vm.loan.asLoanRequestItems.splice(index, 1, element);
		};

		// Add Item
		vm.addItem = function(obj) {
			var element = {
				id: obj.id,
				requestId: obj.requestId,
				equipmentId: obj.equipmentId,
				partId: obj.partId,
				storageId: obj.storageId,
				loanItemStateId: obj.loanItemStateId,
				itemCode: obj.itemCode,
				itemDescription: obj.itemDescription,
				storageName: obj.storageName,
				status: obj.status,
				quantity: obj.quantity,
				quantityReturn: obj.quantityReturn,
				price: obj.price,
				serialNo: obj.serialNo,
				remarks: obj.remarks,
			};
			vm.loan.asLoanRequestItems.push(element);
		};

		/* ************************************************************* */

		vm.item = {};
		vm.showAddItemModal = function () {
			vm.item = {};

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'ESPItemModal.html',
				controller: 'LoanRequestItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.item,
							statuses: vm.loanItemStatusList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};

		vm.showEditItemModal = function (index) {
			vm.item = vm.loan.asLoanRequestItems[index];;

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'ESPItemModal.html',
				controller: 'LoanRequestItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
							statuses: vm.loanItemStatusList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};

		/* ************************************************************* */

		vm.showPrintDialog = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'printModal.html',
				controller: 'LoanRequestPrintModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							object: {
								loanId: vm.loan.id,
								requestNo: vm.loan.requestNo,
							},
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.lockButtons = true;

				HttpSvc.put('services/loanrequests/' + $stateParams.id, vm.loan, Auth.getTokenId(), false)
					.then(function(result) {

						// Check Status
						vm.checkStatus(result);

					}, function(error) {
						vm.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkStatus = function(result)
		{
			if(result.statusCode=="-1")
			{
				vm.lockButtons = false;
				toastr.warning(result.message, Auth.translate('ERROR'));
			}
			else if(result.statusCode=="1")
			{
				toastr.success('Loan Request has been updated successfully.', Auth.translate('SUCCESS'));
				$state.reload();
			}
		}

		// Call Actions
		vm.loadData();
	};

	// Item Modal Controller
	function LoanRequestItemModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;

		$mdl.title = item.title;
		$mdl.item = item.object;
		$mdl.statusList = item.statuses;
		$mdl.storageList = [];
		$mdl.equipmentList = [];
		$mdl.sparePartList = [];
		$mdl.selectedStorage = null;
		$mdl.selectedEquipment = null;
		$mdl.selectedSparePart = null;
		$mdl.selectedStatus = null;
		$mdl.activeTab = 0;
		$mdl.lockButtons = false;

		/* ******************************************************** */

		$mdl.beautifyWarehouse = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			if(item.description) {
				newText = newText + "</span>&nbsp;&nbsp;" + item.description.toUpperCase();
			}
			return newText;
		}

		$mdl.beautifyEquipment = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			if(item.name) {
				newText = newText + "</span>&nbsp;&nbsp;" + item.name.toUpperCase();
			}
			if(item.description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + item.description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";
			}
			return newText;
		}

		$mdl.beautifySparePart = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			if(item.description) {
				newText = newText + "</span>&nbsp;&nbsp;" + item.description.toUpperCase();
			}
			return newText;
		}

		/* ************************************************************* */

		$mdl.onSelectedStorageChanged = function() {
			$mdl.item.storageId = $mdl.selectedStorage.id;
			$mdl.item.storageName = $mdl.selectedStorage.description;
		}

		$mdl.onSelectedStatusChanged = function() {
			$mdl.item.loanItemStateId = $mdl.selectedStatus.id;
			$mdl.item.status = $mdl.selectedStatus.name;
		}

		$mdl.onSelectedEquipmentChanged = function() {
			$mdl.item.equipmentId = $mdl.selectedEquipment.id;
			$mdl.item.itemCode = $mdl.selectedEquipment.code;
			$mdl.item.itemDescription = $mdl.selectedEquipment.name;
			$mdl.item.partId = null;
		}

		$mdl.onSelectedSparePartChanged = function() {
			$mdl.item.partId = $mdl.selectedSparePart.id;
			$mdl.item.itemCode = $mdl.selectedSparePart.code;
			$mdl.item.itemDescription = $mdl.selectedSparePart.description;
			$mdl.item.equipmentId = null;
		}

		/* ******************************************************** */

		$mdl.loadStorageList = function() {
			$mdl.lockButtons = true;

			HttpSvc.get('storages/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.storageList = result;

					// Select Default Warehouse
					$mdl.storageList.forEach(function(s) {
						if(s.isAfterSalesDefault) {
							$mdl.selectedStorage = s;
						}
					});

					$mdl.storageList.forEach(function(s) {
						if(s.id==$mdl.item.storageId) {
							$mdl.selectedStorage = s;
						}
					});

					if($mdl.selectedStorage==null) {
						if($mdl.storageList.length > 0) {
							$mdl.selectedStorage = $mdl.storageList[0];
							$mdl.item.storageId = $mdl.selectedStorage.id;
							$mdl.item.storageName = $mdl.selectedStorage.description;
						}
						else
						{
							toastr.warning('You must create a <b>Warehouse</b> record first (Maintenance &rarr; Warehouse)', 'Unable to add Equipment / Spart Parts');
							$mdl.cancelModal();
						}
					}
					else
					{
						$mdl.item.storageId = $mdl.selectedStorage.id;
						$mdl.item.storageName = $mdl.selectedStorage.description;
					}

					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Warehouse list.', '');
					return null;
				});
		};

		$mdl.loadEquipmentList = function(searchString, autoSelect) {
			$mdl.lockButtons = true;

			HttpSvc.get('equipments/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.equipmentList = result;

					if(autoSelect) {
						$mdl.equipmentList.forEach(function(e) {
							if(e.id==$mdl.item.equipmentId) {
								$mdl.selectedEquipment = e;
							}
						});
					}

					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Equipment list.', '');
					return null;
				});
		};

		$mdl.loadSparePartList = function(searchString, autoSelect) {
			$mdl.lockButtons = true;

			HttpSvc.get('spareparts/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.sparePartList = result;

					if(autoSelect) {
						$mdl.sparePartList.forEach(function(s) {
							if(s.id==$mdl.item.partId) {
								$mdl.selectedSparePart = s;
							}
						});
					}

					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Spare Part list.', '');
					return null;
				});
		};

		/* ******************************************************** */

		$mdl.confirmModal = function() {

			if($mdl.modalForm.$valid)
				$uibModalInstance.close($mdl.item);
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ******************************************************** */

		// Initialize
		if(item.mode==1) {
			$mdl.activeTab = 0;
			$mdl.item.equipmentId = null;
			$mdl.item.partId = null;
			$mdl.item.loanItemStateId = null;
			$mdl.item.itemDescription = "";
			$mdl.item.price = 0;
			$mdl.item.quantity = 0;
			$mdl.item.quantityReturn = 0;
			$mdl.item.serialNo = "";
			$mdl.item.status = "ON LOAN";
			$mdl.loadStorageList();
		} else {
			$mdl.loadStorageList();

			if($mdl.item.equipmentId!='' && $mdl.item.equipmentId!=null){
				$mdl.activeTab = 0;
				$mdl.loadEquipmentList($mdl.item.equipmentId, true);

			} else if($mdl.item.partId!='' && $mdl.item.partId!=null){
				$mdl.activeTab = 1;
				$mdl.loadSparePartList($mdl.item.partId, true);
			}

			$mdl.statusList.forEach(function(s) {
				if(s.id==$mdl.item.loanItemStateId) {
					$mdl.selectedStatus = s;
				}
			});
		}
	};

	// Print Dialog
	function LoanRequestPrintModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;

        $mdl.isLoading = false;
		$mdl.loanId = item.object.loanId;
		$mdl.requestNo = item.object.requestNo;

		/* *************************************************** */

		$mdl.printLoanForm = function() {
			$mdl.isLoading = true;
			var filename = "LOANREQ_" + $mdl.requestNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('services/loanrequests/print/externalloanform/' + $mdl.loanId, Auth.getTokenId(), filename)
				.then(function(result) {
					$mdl.isLoading = false;
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to generate Loan Request Form. ' + error, '');
					return null;
				});
		}

		$mdl.printPickingList = function() {
			$mdl.isLoading = true;
			var filename = "PICKREQ_" + $mdl.requestNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('services/loanrequests/print/pickingrequestform/' + $mdl.loanId, Auth.getTokenId(), filename)
				.then(function(result) {
					$mdl.isLoading = false;
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to generate Picking Request Form. ' + error, '');
					return null;
				});
		}

		/* *************************************************** */

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.services.dutyrosters.controller', [])
        .controller('DutyRosterMainCtrl', DutyRosterMainCtrl)
        .controller('DutyRosterCreateCtrl', DutyRosterCreateCtrl)
        .controller('DutyRosterUpdateCtrl', DutyRosterUpdateCtrl);

    /** @ngInject */
    function DutyRosterMainCtrl($scope, $filter, $state, $q, Auth, baSidebarService, HttpSvc, toastr) {

		Auth.init();

		var vm = this;
		vm.years = [];
        vm.months = [
            { id: "1", name: "January" },
            { id: "2", name: "February" },
            { id: "3", name: "March" },
            { id: "4", name: "April" },
            { id: "5", name: "May" },
            { id: "6", name: "June" },
            { id: "7", name: "July" },
            { id: "8", name: "August" },
            { id: "9", name: "September" },
            { id: "10", name: "October" },
            { id: "11", name: "November" },
            { id: "12", name: "December" }
        ];

        vm.pageSizeOption = [10, 20, 50, 100, 200];
        vm.pageSize = 100;
        vm.numOfRecord = 0;
        vm.numOfRecordFiltered = 0;
        vm.numOfRecordDisplayed = 0;
        vm.startIndex = 0;
        vm.endIndex = 0;
        vm.rosterDataFull = [];
        vm.rosterData = [];
        vm.year = "2018";
        vm.month = "";
        vm.isLoading = false;

        vm.initData = function () {
            vm.year = $filter('date')(new Date(), 'yyyy');
            vm.month = (new Date().getMonth() + 1).toString();  // getMonth() returns 0-11, so add 1

			var lastYear = parseInt(vm.year)-1;
			vm.years.push(lastYear.toString());
			vm.years.push(vm.year.toString());
			var nextYear = parseInt(vm.year)+1;
			vm.years.push(nextYear.toString());

			baSidebarService.setMenuCollapsed(true);
		};

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.rosterDataFull, tableState.search.predicateObject) : vm.rosterDataFull;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.rosterData = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {

			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.rosterDataFull.length <= 0) {
				vm.isLoading = true;

				HttpSvc.get('services/dutyrosters/list/' + vm.year + '/' + vm.month, params, Auth.getTokenId(), true)
					.then(function(result) {
						vm.numOfRecord = result.length;
						vm.rosterDataFull = result;
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		vm.loadRosters = function() {
			vm.isLoading = true;

			HttpSvc.get('services/dutyrosters/list/' + vm.year + '/' + vm.month, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.isLoading = false;
					vm.numOfRecord = result.length;
					vm.rosterDataFull = result;
					$scope.$broadcast('refreshStTable');
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.deleteDutyRoster = function(categoryId, categoryName) {
			var params = {};
			HttpSvc.delete('services/dutyrosters/' + categoryId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('services/dutyrosters/list', params, Auth.getTokenId(), true)
						.then(function(result) {
							vm.numOfRecord = result.length;
							vm.rosterDataFull = result;

							toastr.success('The category [' + categoryName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the category [' + categoryName + '].', 'Delete Failed');
					return null;
			});
		};

		// Init Data
		vm.initData();
	};

	/** @ngInject */
    function DutyRosterCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.mode = 1;
		vm.roster = {};
		vm.users = [];
		vm.rosterTypes = [];
		vm.selectedUser = null;
		vm.selectedRosterType = null;
		vm.isLoading = false;

		vm.loadUsers = function(keyword) {
			vm.isLoading = true;

			HttpSvc.get('services/techteams/technicians/list/' + keyword, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.users = result;
					vm.loadRosterTypes();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve technician list.', '');
					return null;
			});
		}

		vm.loadRosterTypes = function(keyword) {
			vm.isLoading = true;

			HttpSvc.get('services/rostertypes/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.rosterTypes = result;
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve technician list.', '');
					return null;
			});
		}

		vm.selectedUserChanged = function() {
			vm.roster.userId = vm.selectedUser.id;
		}

		vm.selectedRosterTypeChanged = function() {
			vm.roster.rosterType = vm.selectedRosterType.code;
			vm.roster.rosterTypeId = vm.selectedRosterType.id;
		}

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/dutyrosters', vm.roster, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Roster has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('services.dutyrosters.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Action
		vm.loadUsers("");
	}

	/** @ngInject */
    function DutyRosterUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;
		vm.mode = 2;
		vm.roster = {};
		vm.users = [];
		vm.rosterTypes = [];
		vm.selectedUser = null;
		vm.selectedRosterType = null;
		vm.isLoading = false;

		vm.loadUsers = function(keyword) {
			vm.isLoading = true;

			HttpSvc.get('services/techteams/technicians/list/' + keyword, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.users = result;
					vm.loadRosterTypes();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve technician list.', '');
					return null;
			});
		}

		vm.loadRosterTypes = function(keyword) {
			vm.isLoading = true;

			HttpSvc.get('services/rostertypes/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.rosterTypes = result;
					vm.loadDutyRoster();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve technician list.', '');
					return null;
			});
		}

		// Load DutyRoster
		vm.loadDutyRoster = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('services/dutyrosters/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.roster = result;

					vm.users.forEach(function(u) {
						if(u.id==vm.roster.userId) {
							vm.selectedUser = u;
						}
					});

					vm.rosterTypes.forEach(function(r) {
						if(r.id==vm.roster.rosterTypeId) {
							vm.selectedRosterType = r;
						}
					});
				}, function() {
					toastr.error('Failed to load selected Roster.', Auth.translate('ERROR'))
					$state.go('services.dutyrosters.list');
					return;
				});
		};

		vm.selectedUserChanged = function() {
			vm.roster.userId = vm.selectedUser.id;
		}

		vm.selectedRosterTypeChanged = function() {
			vm.roster.rosterType = vm.selectedRosterType.code;
			vm.roster.rosterTypeId = vm.selectedRosterType.id;
		}

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/dutyrosters/' + $stateParams.id, vm.roster, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Roster has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('services.dutyrosters.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Actions
		vm.loadUsers("");
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.services.warrantyclaim.controller', [])
        .controller('WarrantyClaimMainCtrl', WarrantyClaimMainCtrl)
        .controller('WarrantyClaimCreateCtrl', WarrantyClaimCreateCtrl)
        .controller('WarrantyClaimUpdateCtrl', WarrantyClaimUpdateCtrl)
        .controller('WarrantyClaimItemModalCtrl', WarrantyClaimItemModalCtrl);



    /** @ngInject */
    function WarrantyClaimMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {

		Auth.init();

		var vm = this;vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.data = [];

		vm.isLoading = false;
		vm.blobUrl = RmsApi.BLOBURL;

		vm.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.claimNo,
				status: predicate.status,
				debtorName: predicate.debtorName,
				brand: predicate.equipmentBrand,
				model: predicate.equipmentModel,
				equipmentName: predicate.equipmentName,
				serialNo: predicate.serialNo,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('services/warrantyclaims/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			return tableState;
		};

		vm.resetSearch = function()
		{
		}

		vm.deleteClaim = function(claimId, claimNo) {
			var params = {};
			HttpSvc.delete('services/warrantyclaims/' + claimId, params, Auth.getTokenId(), false)
				.then(function(result) {
					$scope.$broadcast('refreshStTable');
				}, function() {
					// Failed
					toastr.error('Failed to delete the Warranty Claim [' + claimNo + '].', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
    function WarrantyClaimCreateCtrl($scope, $state, $uibModal, $location, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;

		vm.statusList = GetStatuses();

		vm.claim = {};
		vm.claim.asWarrantyClaimSpareParts = [];
		vm.selectedStatus = vm.statusList[0];
		vm.selectedWarranty = null;
		vm.selectedEquipment = null;
		vm.isLoading = false;
		vm.lockButtons = false;

		/* ************************************************************* */

		vm.beautify = function(code, name, description) {
			var newText = "";
			if(code) {
				newText = "<span class='dd-code'>" + code.toUpperCase();
			}
			if(name) {
				newText = newText + "</span>&nbsp;&nbsp;" + name.toUpperCase();
			}
			if(description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";
			}
			return newText;
		}

		/* ************************************************************* */

		vm.initData = function() {
			vm.claim.refNo = '';
			vm.claim.status = 'NEW';
			vm.claim.statusReason = '';
			vm.claim.approvedBy = '';
			vm.claim.remarks = '';
		};

		vm.loadWarrantyList = function(searchString, autoSelect) {
			vm.lockButtons = true;

			var params = { keyword: searchString };

			HttpSvc.post('services/warranties/list', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.warrantyList = result;

					if(autoSelect) {
						vm.warrantyList.forEach(function(w) {
							if(w.id==vm.claim.warrantyId) {
								vm.selectedWarranty = w;
								vm.selectedWarrantyChanged();
							}
						});
					}

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Warranty list.', '');
					return null;
				});
		};

		vm.loadEquipment = function(equipmentId) {
			vm.lockButtons = true;

			HttpSvc.get('equipments/' + equipmentId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.selectedEquipment = result;
					vm.selectedEquipment.brand = vm.selectedWarranty.brand;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Equipment list.', '');
					return null;
				});
		};

		/* ************************************************************* */

		vm.selectedStatusChanged = function() {
			vm.claim.status = vm.selectedStatus.id;
		};

		vm.selectedWarrantyChanged = function() {
			vm.claim.warrantyId = vm.selectedWarranty.id;
			vm.claim.debtorId = vm.selectedWarranty.debtorId;
			vm.claim.equipmentId = vm.selectedWarranty.equipmentId;

			vm.loadEquipment(vm.selectedWarranty.equipmentId);
		};

		vm.clearWarranty = function() {
			vm.selectedWarranty = null;
            vm.claim.warrantyFrom = null;
            vm.claim.warrantyTo = null;
		}

		/* ************************************************************* */

		// Remove Item
		vm.removeItem = function(index) {
			vm.claim.asWarrantyClaimSpareParts.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};

		// Update Item
		vm.updateItem = function(index, obj) {
			var element = {
				partId: obj.partId,
				sparePartCode: obj.sparePartCode,
				sparePartName: obj.sparePartName,
				quantity: obj.quantity,
				cost: obj.cost,
				remarks: obj.remarks,
				status: ''
			};

			var isFound = false;
			for(var i=0; i<vm.claim.asWarrantyClaimSpareParts.length; i++)
			{
				var p = vm.claim.asWarrantyClaimSpareParts[i];
				if(p.partId==partId && i!=index)
				{
					isFound = true;
				}
			}

			if(isFound)
			{
				toastr.warning('Spart Part already exists on the list.');
				return;
			}

			vm.claim.asWarrantyClaimSpareParts.splice(index, 1, element);
		};

		// Add Item
		vm.addItem = function(obj) {
			var element = {
				partId: obj.partId,
				sparePartCode: obj.sparePartCode,
				sparePartName: obj.sparePartName,
				quantity: obj.quantity,
				cost: obj.cost,
				remarks: obj.remarks,
				status: ''
			};

			var isFound = false;
			vm.claim.asWarrantyClaimSpareParts.forEach(function(i) {
				if(i.partId==obj.partId)
				{
					isFound=true;
				}
			})

			if(isFound)
			{
				toastr.warning('Spare Part already exists on the list.');
				return;
			}

			vm.claim.asWarrantyClaimSpareParts.push(element);
		};

		/* ************************************************************* */

		vm.showAddItemModal = function () {
			vm.item = {};

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'ClaimItemModal.html',
				controller: 'WarrantyClaimItemModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.item,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};

		vm.showEditItemModal = function (index) {
			vm.item = vm.claim.asWarrantyClaimSpareParts[index];;

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'ClaimItemModal.html',
				controller: 'WarrantyClaimItemModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};

		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/warrantyclaims', vm.claim, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Warranty Claim has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('services.warrantyclaim.update', {'id': result.id });

					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
    function WarrantyClaimUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.statusList = GetStatuses();

		vm.claim = {};
		vm.claim.asWarrantyClaimSpareParts = [];
		vm.selectedStatus = null;
		vm.selectedWarranty = null;
		vm.selectedEquipment = null;
		vm.isLoading = false;
		vm.lockButtons = false;

		/* ************************************************************* */

		vm.beautify = function(code, name, description) {
			var newText = "";
			if(code) {
				newText = "<span class='dd-code'>" + code.toUpperCase();
			}
			if(name) {
				newText = newText + "</span>&nbsp;&nbsp;" + name.toUpperCase();
			}
			if(description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";
			}
			return newText;
		}

		/* ************************************************************* */

		vm.initData = function() {
			vm.loadData();
		};

		vm.loadData = function() {

			HttpSvc.get('services/warrantyclaims/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.claim = result;

					vm.statusList.forEach(function(s) {
						if(s.id==vm.claim.status) {
							vm.selectedStatus = s;
						}
					});

					vm.loadWarrantyList(vm.claim.warrantyId, true);
					vm.loadEquipment(vm.claim.equipmentId, true);

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Warranty list.', '');
					return null;
				});
		}

		vm.loadWarrantyList = function(searchString, autoSelect) {
			vm.lockButtons = true;

			var params = { keyword: searchString };

			HttpSvc.post('services/warranties/list', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.warrantyList = result;

					if(autoSelect) {
						vm.warrantyList.forEach(function(w) {
							if(w.id==vm.claim.warrantyId) {
								vm.selectedWarranty = w;
								vm.selectedWarrantyChanged();
							}
						});
					}

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Warranty list.', '');
					return null;
				});
		};

		vm.loadEquipment = function(equipmentId) {
			vm.lockButtons = true;

			HttpSvc.get('equipments/' + equipmentId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.selectedEquipment = result;
					vm.selectedEquipment.brand = vm.selectedWarranty.brand;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Equipment list.', '');
					return null;
				});
		};

		/* ************************************************************* */

		vm.selectedStatusChanged = function() {
			vm.claim.status = vm.selectedStatus.id;
		};

		vm.selectedWarrantyChanged = function() {
			vm.claim.warrantyId = vm.selectedWarranty.id;
			vm.claim.equipmentId = vm.selectedWarranty.equipmentId;

			vm.loadEquipment(vm.selectedWarranty.equipmentId);
		};

		vm.clearWarranty = function() {
			vm.selectedWarranty = null;
            vm.claim.warrantyFrom = null;
            vm.claim.warrantyTo = null;
		}

		/* ************************************************************* */

		// Remove Item
		vm.removeItem = function(index) {
			vm.claim.asWarrantyClaimSpareParts.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};

		// Update Item
		vm.updateItem = function(index, obj) {
			var element = {
				partId: obj.partId,
				sparePartCode: obj.sparePartCode,
				sparePartName: obj.sparePartName,
				quantity: obj.quantity,
				cost: obj.cost,
				remarks: obj.remarks,
				status: ''
			};

			var isFound = false;
			for(var i=0; i<vm.claim.asWarrantyClaimSpareParts.length; i++)
			{
				var p = vm.claim.asWarrantyClaimSpareParts[i];
				if(p.partId==partId && i!=index)
				{
					isFound = true;
				}
			}

			if(isFound)
			{
				toastr.warning('Spart Part already exists on the list.');
				return;
			}

			vm.claim.asWarrantyClaimSpareParts.splice(index, 1, element);
		};

		// Add Item
		vm.addItem = function(obj) {
			var element = {
				partId: obj.partId,
				sparePartCode: obj.sparePartCode,
				sparePartName: obj.sparePartName,
				quantity: obj.quantity,
				cost: obj.cost,
				remarks: obj.remarks,
				status: ''
			};

			var isFound = false;
			vm.claim.asWarrantyClaimSpareParts.forEach(function(i) {
				if(i.partId==obj.partId)
				{
					isFound=true;
				}
			})

			if(isFound)
			{
				toastr.warning('Spare Part already exists on the list.');
				return;
			}

			vm.claim.asWarrantyClaimSpareParts.push(element);
		};

		/* ************************************************************* */

		vm.showAddItemModal = function () {
			vm.item = {};

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'ClaimItemModal.html',
				controller: 'WarrantyClaimItemModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.item,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};

		vm.showEditItemModal = function (index) {
			vm.item = vm.claim.asWarrantyClaimSpareParts[index];;

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'ClaimItemModal.html',
				controller: 'WarrantyClaimItemModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};

		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('services/warrantyclaims/' + $stateParams.id, vm.claim, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Warranty Claim has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Actions
		vm.initData();
	}

	// Item Modal Controller
	function WarrantyClaimItemModalCtrl($uibModalInstance, Auth, HttpSvc, RmsApi, item, toastr) {
		var $mdl = this;

		$mdl.title = item.title;
		$mdl.item = item.object;
		$mdl.sparePartList = [];
		$mdl.selectedSparePart = null;
		$mdl.lockButtons = false;
		$mdl.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		$mdl.imageLocation = 'assets/img/empty_placeholder.png';

		/* ******************************************************** */

		$mdl.beautifySparePart = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			if(item.description) {
				newText = newText + "</span>&nbsp;&nbsp;" + item.description.toUpperCase();
			}
			return newText;
		}

		/* ************************************************************* */

		$mdl.selectedSparePartChanged = function() {
			$mdl.item.partId = $mdl.selectedSparePart.id;
			$mdl.item.sparePartCode = $mdl.selectedSparePart.code;
			$mdl.item.sparePartName = $mdl.selectedSparePart.description;
			$mdl.item.cost = $mdl.selectedSparePart.price;
			$mdl.imageLocation =
				$mdl.rootUrl + $mdl.selectedSparePart.imageLocation || 'assets/img/empty_placeholder.png';
		}

		/* ******************************************************** */

		$mdl.loadSparePartList = function(searchString, autoSelect) {
			$mdl.lockButtons = true;

			HttpSvc.get('spareparts/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.sparePartList = result;

					if(autoSelect) {
						$mdl.sparePartList.forEach(function(s) {
							if(s.id==$mdl.item.partId) {
								$mdl.selectedSparePart = s;
							}
						});
					}

					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Spare Part list.', '');
					return null;
				});
		};

		/* ******************************************************** */

		$mdl.confirmModal = function() {

			if($mdl.modalForm.$valid)
				$uibModalInstance.close($mdl.item);
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ******************************************************** */

		// Initialize
		if(item.mode==1) {
			$mdl.item.partId = null;
			$mdl.item.sparePartName = "";
			$mdl.item.cost = 0;
			$mdl.item.quantity = 1;
			$mdl.item.remarks = '';
		} else {
			if($mdl.item.partId!='' && $mdl.item.partId!=null){
				$mdl.loadSparePartList($mdl.item.partId, true);
			}
		}
	};

	function GetStatuses() {
		var statuses = [
			{
				id: 'NEW', name: 'NEW'
			},
			{
				id: 'CONFIRMED', name: 'CONFIRMED'
			}
		];

		return statuses;
	}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.services.casemanagement.controller', [])
        .controller('CaseManagementMainCtrl', CaseManagementMainCtrl)
        .controller('CaseManagementUpdateCtrl', CaseManagementUpdateCtrl)
        .controller('CaseManagementCsoModalCtrl', CaseManagementCsoModalCtrl);

    /** @ngInject */
    function CaseManagementMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();
		
		var vm = this;

		vm.caseStatuses = [
			{ id:'open',       name:'OPEN'},
			{ id:'unassigned', name:'UNASSIGNED'},
			{ id:'closed',     name:'CLOSED / CONVERTED'},
		];
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.casemgmtDataFull = [];
		vm.casemgmtData = [];
		vm.selectedStatus = 'open';
		vm.isLoading = false;
		
		vm.onSelectedStatusChanged = function() {
			vm.casemgmtDataFull = [];
			$scope.$broadcast('refreshStTable');
		};
			
		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.casemgmtDataFull, tableState.search.predicateObject) : vm.casemgmtDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.casemgmtData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.casemgmtDataFull.length <= 0) {							
				vm.isLoading = true;
				
				HttpSvc.get('servicecases/casemanagement/' + vm.selectedStatus, params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.casemgmtDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};
	};
	
	/** @ngInject */
    function CaseManagementUpdateCtrl($scope, $state, $stateParams, $sce, $uibModal, Auth, HttpSvc, RmsApi, UtilSvc, toastr) {

		Auth.init();
		
		var vm = this;
		
		vm.case = {};
		vm.note = "";
		vm.isLoading = false;
		vm.lockButtons = false;
		vm.serverMode = Auth.getServerMode();
		vm.rootUrl = (vm.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
				
		/* ************************************************************* */
		
		vm.initData = function() {
			vm.loadCase();
		};
		
		/* ************************************************************* */
				
		vm.loadCase = function() {
			vm.lockButtons = true;
			
			HttpSvc.get('servicecases/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.case = result;
								
					vm.case.asServiceCaseMedias.forEach(function(m) {
						if(m.mediaFile!=null && m.mediaFile!='') {
							m.finalMediaFile = vm.rootUrl + m.mediaFile;
						}
						if(m.isVimeoConverted && m.vimeoVideoId!=null) {
							m.finalVimeoUrl = $sce.trustAsResourceUrl("https://player.vimeo.com/video/" + m.vimeoVideoId);
						}
					});
					
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to load selected Case.', '');
					$state.go('services.casemanagement.list');
				});
		};
		
		/* ************************************************************* */

		vm.showCsoModal = function () {
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'csoModal.html',
				controller: 'CaseManagementCsoModalCtrl',
				controllerAs: '$mdl',
				size: 'sm',
				resolve: {
					item: function () {
						return {
							caseId: vm.case.id,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {					
					$state.reload();
				}, function () {
				});
		};	

		vm.clearCso = function() {
			vm.isLockButton = true;
			HttpSvc.put('servicecases/casemanagement/' + $stateParams.id + '/unassign', {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('CS Officer has been unassigned.', 'Notification');
					$state.reload();
				}, function(error) {
					vm.isLockButton = false;
					toastr.error(error, 'Failed');
				});
		}
		
		/* ************************************************************* */
		
		vm.addNote = function() {		
			vm.isLockButton = true;

			var newNote = {
				id: UtilSvc.generateGuid(),
				caseId: $stateParams.id,
				remarks: vm.note,
			};

			HttpSvc.post('servicecasenotes', newNote, Auth.getTokenId(), false)
				.then(function(result) {
					
					HttpSvc.get('servicecasenotes/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.case.asServiceCaseNotes = result;
							vm.note = "";		
							vm.isLockButton = false;
						}, function(error) {
							vm.isLockButton = false;
							toastr.error(error, 'Failed');
						});

				}, function(error) {
					vm.isLockButton = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.closeCase = function() {
			vm.isLockButton = true;

			HttpSvc.put('servicecases/closecase/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Case has been closed.', 'Notification');
					$state.reload();
				}, function(error) {
					vm.isLockButton = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.convertWorkOrder = function() {
			vm.isLockButton = true;

			HttpSvc.put('serviceworks/convertfromcase/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Case has been converted to Work Order.', 'Notification');
					$state.go('services.workorders.update', { 'id': result.id });
				}, function(error) {
					vm.isLockButton = false;
					toastr.error(error, 'Failed');
				});			
		}
		
		/* ************************************************************* */
				
		// Call Actions
		vm.initData();
	}

	// Process Modal Controller
	function CaseManagementCsoModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
				
		$mdl.item = item;
		$mdl.item.csoId = "";
		$mdl.selectedCso = null;
		$mdl.csoList = [];
		$mdl.isLockButton = false;
		
		/* *************************************************** */
		
		$mdl.loadCsoList = function() {					
			$mdl.isLockButton = true;

			HttpSvc.get('users/list/customerservices', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.csoList = result;
					$mdl.isLockButton = false;
				}, function() {
					$mdl.isLockButton = false;
					toastr.error('Failed to load CS Officer list.', '');
					return null;
				});
		};
		
		$mdl.onSelectedCsoChanged = function() {
			$mdl.item.csoId = $mdl.selectedCso.id;
		};
		
		/* *************************************************** */
						
		$mdl.confirmModal = function() {			
			if(!$mdl.csoForm.$valid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$mdl.isLockButton = true;

				HttpSvc.put('servicecases/casemanagement/' + $mdl.item.caseId + '/assign/' + $mdl.item.csoId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('CS Officer has been  assigned.', 'Notification');
						$uibModalInstance.close();
						$mdl.isLockButton = false;
					}, function(error) {
						$mdl.isLockButton = false;
						toastr.error(error, 'Failed');
					});
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		/* *************************************************** */
		
		$mdl.loadCsoList();
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.services.warranty.controller', [])
        .controller('WarrantyMainCtrl', WarrantyMainCtrl)
        .controller('WarrantyCreateCtrl', WarrantyCreateCtrl)
        .controller('WarrantyUpdateCtrl', WarrantyUpdateCtrl)
        .controller('WarrantyBatchCreateCtrl', WarrantyBatchCreateCtrl);

    /** @ngInject */
    function WarrantyMainCtrl(Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.data = [];
		vm.dataFilter = {};
		vm.integrationMode = Auth.getIntegrationMode();

		vm.isLoading = false;
		vm.blobUrl = RmsApi.BLOBURL;

		vm.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}
			
			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";
			
			var params = {
				keyword:  predicate.warrantyNo,
				debtorName: predicate.debtorName,
				brand: predicate.brand,
				model: predicate.model,
				equipmentName: predicate.equipmentName,
				invoiceNo:  predicate.invoiceNo,
				serialNo:  predicate.serialNo,
				isValidDoc:  predicate.isValidDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			vm.isLoading = true;
			
			var params = vm.getApiParams(tableState);

			HttpSvc.post('services/warranties/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isLoading = false;		
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;	
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			
			return tableState;
		};

		vm.resetSearch = function() 
		{
		}
		
		vm.printWarrantyLabel = function(warrantyId) {
			HttpSvc.post('services/warranties/label/create/' + warrantyId, {}, Auth.getTokenId(), false)
				.then(function(result) {
						toastr.success('Label Print instruction has been sent.', Auth.translate('SUCCESS'));
				}, function() {
					// Failed
					toastr.error('Failed to print the Warranty label.', 'Delete Failed');
					return null;
			});
		};
		// Init Call
		//vm.loadFilters();
	};

    // function WarrantyMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
		
	// 	Auth.init();
		
	// 	var vm = this;
		
	// 	vm.integrationMode = Auth.getIntegrationMode();
	// 	vm.pageSizeOption = [10, 20, 50, 100];
	// 	vm.pageSize = 10;
	// 	vm.numOfRecord = 0;
	// 	vm.numOfRecordFiltered = 0;
	// 	vm.numOfRecordDisplayed = 0;
	// 	vm.startIndex = 0; 
	// 	vm.endIndex = 0;
	// 	vm.warrantyDataFull = [];
	// 	vm.warrantyData = [];
	// 	vm.search = "";
	// 	vm.isLoading = false;
	// 	vm.showLimited = true;
	// 	vm.isSearch = false;

	// 	vm.showLimitedChanged = function() {
	// 		vm.warrantyDataFull = [];
	// 		vm.warrantyData = [];
	// 		$scope.$broadcast('refreshStTable');
	// 	};
		
	// 	function refreshTableState(tableState, startIndex, endIndex) {				
						
	// 		var filtered = tableState.search.predicateObject ? $filter('filter')(vm.warrantyDataFull, tableState.search.predicateObject) : vm.warrantyDataFull;
	// 		vm.numOfRecordFiltered = filtered.length;
			
	// 		if (tableState.sort.predicate) {
	// 			filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
	// 		}
	// 		var result = filtered.slice(startIndex, startIndex + endIndex);
						
	// 		vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
	// 		vm.warrantyData = result;
			
	// 		tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
	// 		return tableState;
	// 	};
		
	// 	vm.retrieveData = function(tableState) {			
	// 		var params = { keyword: vm.search };
	// 		var pagination = tableState.pagination;
			
	// 		// Restore Table State
    //         // var start = pagination.start2 || pagination.start;
    //         // if (pagination.start != start) {
    //         //     pagination.start = start;
    //         // }
	// 		if(vm.pageSize != pagination.number) {
	// 			vm.pageSize = pagination.number;
	// 		}

	// 		vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
	// 		vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
	// 		if(vm.warrantyDataFull.length <= 0 || vm.isSearch) {							
	// 			vm.isLoading = true;

	// 			var filter = "";
	// 			if(vm.showLimited) filter="50";
				
	// 			HttpSvc.post('services/warranties/list/' + filter, params, Auth.getTokenId(), true)
	// 				.then(function(result) {		
	// 					vm.numOfRecord = result.length;	
	// 					vm.warrantyDataFull = result;
	// 					refreshTableState(tableState, vm.startIndex, vm.endIndex);
	// 					vm.isLoading = false;
	// 					vm.isSearch = false;
	// 				}, function() {
	// 					vm.isLoading = false;
	// 					vm.isSearch = false;
	// 					toastr.error('Failed to retrieve data.', '');
	// 					return null;
	// 				});				
	// 		} else {
	// 			refreshTableState(tableState, vm.startIndex, vm.endIndex);
	// 		}
	// 	};	
		
	// 	vm.loadWarrantyList = function(isClearSearch) {			
			
	// 		if(isClearSearch) {
	// 			vm.search="";
	// 		}

	// 		vm.isLoading = true;
			
	// 		vm.warrantyDataFull = [];
	// 		vm.warrantyData = [];

	// 		$scope.$broadcast('refreshStTable');
	// 	}	
		
	// 	vm.deleteWarranty = function(warrantyId, warrantyName) {
	// 		var params = {};
									 
	// 		HttpSvc.delete('services/warranties/' + warrantyId, params, Auth.getTokenId(), false)
	// 			.then(function(result) {
					
	// 				vm.loadWarrantyList(true);
					
	// 			}, function() {
	// 				// Failed
	// 				toastr.error('Failed to delete the Warranty [' + warrantyName + '].', 'Delete Failed');
	// 				return null;
	// 		});
	// 	};	
		
	// 	vm.printWarrantyLabel = function(warrantyId) {
			
	// 		HttpSvc.post('services/warranties/label/create/' + warrantyId, {}, Auth.getTokenId(), false)
	// 			.then(function(result) {
	// 					toastr.success('Label Print instruction has been sent.', Auth.translate('SUCCESS'));
	// 			}, function() {
	// 				// Failed
	// 				toastr.error('Failed to print the Warranty label.', 'Delete Failed');
	// 				return null;
	// 		});
	// 	};
	// };
	
	/** @ngInject */
    function WarrantyCreateCtrl($scope, $state, $uibModal, $location, Auth, HttpSvc, toastr) {
		Auth.init();
		
		var vm = this;
		vm.warranty = {};
		vm.equipment = {};		
		vm.selectedDebtor = null;
		vm.selectedEquipment = null;
		vm.debtorList = [];
		vm.equipmentList = [];
		vm.isLoading = false;
		vm.lockButtons = false;
				
		/* ************************************************************* */
		
		vm.beautify = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			newText = newText + "</span>&nbsp;&nbsp;" + item.name.toUpperCase();
			if(item.description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + item.description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";	
			}			
			return newText;
		}
		
		/* ************************************************************* */
		
		vm.initData = function() {
			// do nothing
		};
		
		vm.loadDebtorList = function(searchString) {
			vm.lockButtons = true;
			
			HttpSvc.get('debtors/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.debtorList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve debtor list.', '');
					return null;
				});
		};
		
		vm.loadEquipmentList = function(searchString) {
			vm.lockButtons = true;
			
			HttpSvc.get('equipments/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.equipmentList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve equipment list.', '');
					return null;
				});
		};
		
		vm.loadEquipmentData = function(equipmentId) {
			vm.lockButtons = true;
			
			HttpSvc.get('equipments/' + equipmentId, {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.equipment = result;
					
					vm.warranty.brand = vm.equipment.brandName;
					vm.warranty.model = vm.equipment.model;
					vm.warranty.name = vm.equipment.name;
					vm.warranty.description = vm.equipment.description;
					
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve equipment data.', '');
					return null;
				});			
		};
		
		/* ************************************************************* */
				
		// Customer selection changed
		vm.onSelectedDebtorChanged = function() {
			vm.warranty.debtorId = vm.selectedDebtor.id;
		};
		
		// Equipment selection changed
		vm.onSelectedEquipmentChanged = function() {
			vm.warranty.equipmentId = vm.selectedEquipment.id;
			vm.warranty.brand = vm.selectedEquipment.brandName;
			vm.warranty.model = vm.selectedEquipment.model;
			vm.warranty.name = vm.selectedEquipment.name;
			vm.warranty.description = vm.selectedEquipment.description;
			
			//vm.loadEquipmentData(vm.warranty.equipmentId);
		};
		
		vm.clearDebtor = function() {
			vm.selectedDebtor = null;
			vm.warranty.debtorId = null;
		}
		
		vm.clearEquipment = function() {
			vm.selectedEquipment = null;
			vm.warranty.equipmentId = null;
			vm.warranty.brand = "";
			vm.warranty.model = "";
			vm.warranty.name = "";
			vm.warranty.description = "";
		}
		
		/* ************************************************************* */
				
		// Form Submission
		vm.submit = function() {
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('services/warranties', vm.warranty, Auth.getTokenId(), false)
					.then(function(result) {						
						toastr.success('Warranty has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('services.warranty.update', {'id': result.id });
						
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function WarrantyUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;
		vm.warranty = {};
		vm.equipment = {};		
		vm.selectedDebtor = null;
		vm.selectedEquipment = null;
		vm.debtorList = [];
		vm.equipmentList = [];
		vm.isLoading = false;
		vm.lockButtons = false;
				
		/* ************************************************************* */
		
		vm.beautify = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			newText = newText + "</span>&nbsp;&nbsp;" + item.name.toUpperCase();
			if(item.description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + item.description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";	
			}			
			return newText;
		}
		
		/* ************************************************************* */
		
		vm.initData = function() {
			vm.loadWarranty();
		};
		
		vm.loadDebtorList = function(searchString) {
			vm.lockButtons = true;
			
			HttpSvc.get('debtors/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.debtorList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve debtor list.', '');
					return null;
				});
		};
		
		vm.loadEquipmentList = function(searchString) {
			vm.lockButtons = true;
			
			HttpSvc.get('equipments/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.equipmentList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve equipment list.', '');
					return null;
				});
		};
		
		vm.loadEquipmentData = function(equipmentId) {
			vm.lockButtons = true;
			
			HttpSvc.get('equipments/' + equipmentId, {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.equipment = result;
					
					vm.warranty.brand = vm.equipment.brandName;
					vm.warranty.model = vm.equipment.model;
					vm.warranty.name = vm.equipment.name;
					vm.warranty.description = vm.equipment.description;
					
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve equipment data.', '');
					return null;
				});			
		};
		
		// Load Warranty
		vm.loadWarranty = function() {	
			vm.lockButtons = true;
		
			HttpSvc.get('services/warranties/'+$stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.warranty = result;	

					HttpSvc.get('debtors/' + vm.warranty.debtorId, {}, Auth.getTokenId(), false)
						.then(function(result) {	
							vm.selectedDebtor = result;
						}, function() {
						});	

					HttpSvc.get('equipments/' + vm.warranty.equipmentId, {}, Auth.getTokenId(), false)
						.then(function(result) {	
							vm.selectedEquipment = result;
						}, function() {
						});							
					
					vm.lockButtons = false;
					
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to load selected Warranty', Auth.translate('ERROR'))
					$state.go('services.warranty.list');
					return;
				});		
		};	
		
		/* ************************************************************* */
				
		// Equipment selection changed
		vm.onSelectedDebtorChanged = function() {
			vm.warranty.debtorId = vm.selectedDebtor.id;
		};
		
		// Equipment selection changed
		vm.onSelectedEquipmentChanged = function() {
			vm.warranty.equipmentId = vm.selectedEquipment.id;
			vm.warranty.brand = vm.selectedEquipment.brandName;
			vm.warranty.model = vm.selectedEquipment.model;
			vm.warranty.name = vm.selectedEquipment.name;
			vm.warranty.description = vm.selectedEquipment.description;
		};
		
		vm.clearDebtor = function() {
			vm.selectedDebtor = null;
			vm.warranty.debtorId = null;
		}
		
		vm.clearEquipment = function() {
			vm.selectedEquipment = null;
			vm.warranty.equipmentId = null;
			vm.warranty.brand = "";
			vm.warranty.model = "";
			vm.warranty.name = "";
			vm.warranty.description = "";
		}
		
		/* ************************************************************* */	
		
		vm.printWarrantyLabel = function(warrantyId) {
			
			HttpSvc.post('services/warranties/label/create/' + warrantyId, {}, Auth.getTokenId(), false)
				.then(function(result) {
						toastr.success('Label Print instruction has been sent.', Auth.translate('SUCCESS'));
				}, function() {
					// Failed
					toastr.error('Failed to print the Warranty label.', 'Delete Failed');
					return null;
			});
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				HttpSvc.put('services/warranties/' + $stateParams.id, vm.warranty, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Warranty has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.initData();
	}

	/** @ngInject */
    function WarrantyBatchCreateCtrl($scope, $state, $uibModal, $location, Auth, HttpSvc, toastr) {
		Auth.init();
		
		var vm = this;
		vm.invoice = {};
		vm.isLoading = false;
		vm.lockButtons = false;
				
		/* ************************************************************* */
		
		vm.loadInvoice = function() {
			vm.isLoading = true;
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLoading = false;
			} else {
				HttpSvc.get('services/warranties/fnbsystem/invoice/' + vm.invoiceNo, {}, Auth.getTokenId(), false)
					.then(function(result) {	
						vm.invoice = result;
						vm.dataForm.$setPristine();
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve Invoice details.', '');
						return null;
					});
			}
		}
		
		vm.removeItem = function(index) {
			var result = confirm('Remove this item?');
			
			if(result) {
				vm.invoice.invoiceDetails.splice(index, 1);
			}
		}
		
		/* ************************************************************* */
		
		vm.resetFields = function() {
			$state.reload();
		}
		
		/* ************************************************************* */
				
		// Form Submission
		vm.submit = function() {		
			vm.lockButtons = true;
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {
				if(confirm('Confirm all the equipment details are correct?')) {
					HttpSvc.post('services/warranties/fnbsystem/batchcreation', vm.invoice, Auth.getTokenId(), true)
						.then(function(result) {						
							toastr.success('Batch Warranty creation successful. Warranty Label will be printed.', Auth.translate('SUCCESS'));
							$state.reload();
							vm.lockButtons = false;
						}, function(error) {
							vm.lockButtons = false;
							toastr.error(error, 'Failed');
						});					
				}
			}
		}
		
		// Call Actions
		// Do nothing
	}	
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.settings.departments.controller', [])
        .controller('DepartmentMainCtrl', DepartmentMainCtrl)
        .controller('DepartmentCreateCtrl', DepartmentCreateCtrl)
        .controller('DepartmentUpdateCtrl', DepartmentUpdateCtrl);

    /** @ngInject */
    function DepartmentMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.departmentDataFull = [];
		vm.departmentData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.departmentDataFull, tableState.search.predicateObject) : vm.departmentDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.departmentData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.departmentDataFull.length <= 0) {				
				HttpSvc.get('departments/list', {}, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.departmentDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteDepartment = function(departmentId, departmentName) {
			var params = {};
			HttpSvc.delete('departments/' + departmentId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('departments/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.departmentDataFull = result;
							
							toastr.success('The department [' + departmentName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the department [' + departmentName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function DepartmentCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 1;
		vm.department = {};	
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('departments', vm.department, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Department has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('settings.departments.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function DepartmentUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 2;
		vm.department = {};
						
		// Load Department
		vm.loadDepartment = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('departments/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.department = result;	
				}, function() {
					toastr.error('Failed to load selected Department.', Auth.translate('ERROR'))
					$state.go('settings.departments.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('departments/' + $stateParams.id, vm.department, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Department has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('settings.departments.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadDepartment();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.settings.branches.controller', [])
        .controller('BranchMainCtrl', BranchMainCtrl)
        .controller('BranchCreateCtrl', BranchCreateCtrl)
        .controller('BranchUpdateCtrl', BranchUpdateCtrl);

    /** @ngInject */
    function BranchMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.branchDataFull = [];
		vm.branchData = [];
		vm.isLoading = false;
		vm.hasFranchise = Auth.hasCompanyFeature('franchise');

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.branchDataFull, tableState.search.predicateObject) : vm.branchDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.branchData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.branchDataFull.length <= 0) {				
				vm.isLoading = true;

				HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.isLoading = false;
						vm.numOfRecord = result.length;	
						vm.branchDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteBranch = function(branchId, branchName) {
			var params = {};
			HttpSvc.delete('branches/' + branchId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('branches/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.branchDataFull = result;
							
							toastr.success('The branch [' + branchName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the branch [' + branchName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function BranchCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 1;
		vm.branch = {};	
		vm.branch.companyId = Auth.getCompanyId();
		vm.integrationMode = Auth.getIntegrationMode();
		vm.branch.timeZone = 8;
		vm.timezones = GetTimeZones();
		vm.autoCountProjectNo = [];
		vm.selectedProjectNo = null;
		vm.selectedTimeZone = vm.timezones[19];
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.selectedDebtor = null;
		vm.selectedDebtorBranch = null;
		//vm.isRmsLite = Auth.isLiteMode();
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.canEditBranchSettings = Auth.specialAccess_CanEditBranchSettings();
		vm.hasSmartKitchenFeature = Auth.hasCompanyFeature('smartkitchen');
		
		/* ************************************************************* */
		
		// Load Customer List
		vm.loadDebtorList = function() {
			HttpSvc.get('debtors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					if (vm.integrationMode == 2) {
						vm.loadAutocountProjectNumbers();
					} else if (vm.integrationMode == 8) {
						vm.loadSQLProjectNumbers();
					}
				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer list.', '');
					$state.go('salesorders.list');
			});
		}

		vm.loadAutocountProjectNumbers = function() {
			HttpSvc.get('autocount/maintenance/list/projectnumbers', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCountProjectNo = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Autocount Project Nos.', '');
			});
		}
		vm.loadSQLProjectNumbers = function() {
			HttpSvc.get('sqlacc/maintenance/project', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCountProjectNo = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve SQL Project Nos.', '');
			});
		}
		// Load Customer Branch List
		vm.loadDebtorBranchList = function() {
			HttpSvc.get('debtors/' + vm.branch.debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorBranchList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Customer Branch list.', '');
					return null;
			});
		}

		/* ************************************************************* */

		vm.selectedTimeZoneChanged = function() {
			vm.branch.timeZone = vm.selectedTimeZone.id;
		}

		vm.selectedProjectNoChanged = function () {
			if (vm.selectedProjectNo == null) {
				vm.branch.autocount_ProjectNo = null;
				return;
			}
			vm.branch.autocount_ProjectNo = vm.integrationMode == 2 ? vm.selectedProjectNo.code : vm.selectedProjectNo.CODE;
		}

		vm.selectedDebtorChanged = function() {
			vm.branch.debtorId = vm.selectedDebtor.id;
			vm.loadDebtorBranchList();
		};

		vm.selectedDebtorBranchChanged = function() {
			vm.branch.debtorBranchId = vm.selectedDebtorBranch.id;
		};

		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('branches/add', vm.branch, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Branch has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('settings.branches.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadDebtorList();
	};
	
	/** @ngInject */
    function BranchUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 2;
		vm.branch = {};
		vm.selectedTimeZone = null;
		vm.integrationMode = Auth.getIntegrationMode();
		vm.timezones = GetTimeZones();
		vm.autoCountProjectNo = [];
		vm.selectedProjectNo = null;
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.selectedDebtor = null;
		vm.selectedDebtorBranch = null;
		//vm.isRmsLite = Auth.isLiteMode();
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.canEditBranchSettings = Auth.specialAccess_CanEditBranchSettings();
		vm.hasSmartKitchenFeature = Auth.hasCompanyFeature('smartkitchen');

		vm.isInitialLoad = false;
		vm.branchSetting = {};

		/* ************************************************************* */

		vm.initSetting = function() {			
			vm.branchSetting = {
				branchId: $stateParams.id,
				setting_StockCount_SimpleMode: false,
			};

			HttpSvc.post('branchsettings', vm.branchSetting, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loadBranchSetting();
				}, function(error) {
					toastr.error('Failed to save company settings: ' + error, 'Failed');
				});
		}

		vm.loadBranchSetting = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('branchsettings/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.branchSetting = result;					
				}, function() {
					if(vm.isInitialLoad = true)
					{
						vm.isInitialLoad = false;
						vm.initSetting();
					}
					else
					{
						toastr.error('Failed to load selected Branch Settings.', Auth.translate('ERROR'));
						$state.go('settings.branches.list');
						return;
					}
				});		
		}

		vm.saveSetting = function() {
			HttpSvc.put('branchsettings/' + vm.branchSetting.id, vm.branchSetting, Auth.getTokenId(), false)
				.then(function(result) {					
				}, function(error) {
					toastr.warning('Failed to save Branch settings: ' + error, 'Failed');
				});
		}

		/* ************************************************************* */
		
		// Load Customer List
		vm.loadDebtorList = function() {
			HttpSvc.get('debtors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					if (vm.integrationMode == 2) {
						vm.loadAutocountProjectNumbers();
					} else if (vm.integrationMode == 8) {
						vm.loadSQLProjectNumbers();
					} else {
						vm.loadBranch();
					}
				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer list.', '');
					$state.go('salesorders.list');
			});
		}

		vm.loadAutocountProjectNumbers = function() {
			HttpSvc.get('autocount/maintenance/list/projectnumbers', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCountProjectNo = result;
					vm.loadBranch();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Autocount Project Nos.', '');
			});
		}


		vm.loadSQLProjectNumbers = function() {
			HttpSvc.get('sqlacc/maintenance/project', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.autoCountProjectNo = result;
					vm.loadBranch();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve SQL Project Nos.', '');
			});
		}
		// Load Customer Branch List
		vm.loadDebtorBranchList = function() {
			HttpSvc.get('debtors/' + vm.branch.debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorBranchList = result;

					vm.debtorBranchList.forEach(function(d) {
						if(d.id==vm.branch.debtorBranchId)
						{
							vm.selectedDebtorBranch = d;
						}
					})
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Customer Branch list.', '');
					return null;
			});
		}
						
		// Load Branch
		vm.loadBranch = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('branches/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.branch = result;	

					vm.timezones.forEach(function(tz) {
						if(tz.id==vm.branch.timeZone){
							vm.selectedTimeZone = tz;
						}
					});

					vm.debtorList.forEach(function(d) {
						if(d.id==vm.branch.debtorId)
						{
							vm.selectedDebtor = d;
						}
					})

					if (vm.integrationMode == 2) {
						vm.autoCountProjectNo.forEach(function(d) {
							if(d.code==vm.branch.autocount_ProjectNo)
							{
								vm.selectedProjectNo = d;
							}
						})
					} else if (vm.integrationMode == 8) {
						vm.autoCountProjectNo.forEach(function(d) {
							if(d.CODE==vm.branch.autocount_ProjectNo)
							{
								vm.selectedProjectNo = d;
							}
						})
					}

					if(vm.branch.debtorId!=null)
					{
						vm.loadDebtorBranchList();
					}

					vm.loadBranchSetting();
				}, function() {
					toastr.error('Failed to load selected Branch.', Auth.translate('ERROR'))
					$state.go('settings.branches.list');
					return;
				});		
		};	

		/* ************************************************************* */

		vm.selectedTimeZoneChanged = function() {
			vm.branch.timeZone = vm.selectedTimeZone.id;
		}

		vm.selectedProjectNoChanged = function() {
			if (vm.selectedProjectNo == null) {
				vm.branch.autocount_ProjectNo = null;
				return;
			}
			vm.branch.autocount_ProjectNo = vm.integrationMode == 2 ? vm.selectedProjectNo.code : vm.selectedProjectNo.CODE;
		}
		
		vm.selectedDebtorChanged = function() {
			vm.branch.debtorId = vm.selectedDebtor.id;
			vm.loadDebtorBranchList();
		};

		vm.selectedDebtorBranchChanged = function() {
			vm.branch.debtorBranchId = vm.selectedDebtorBranch.id;
		};

		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('branches/' + $stateParams.id, vm.branch, Auth.getTokenId(), false)
					.then(function(result) {
						vm.saveSetting();
						
						toastr.success('Branch has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadDebtorList();		
	};

	function GetTimeZones() {
		var tzs = [
			{ id: -11, name: 'GMT-11' },
			{ id: -10, name: 'GMT-10' },
			{ id: -9, name: 'GMT-9' },
			{ id: -8, name: 'GMT-8' },
			{ id: -7, name: 'GMT-7' },
			{ id: -6, name: 'GMT-6' },
			{ id: -5, name: 'GMT-5' },
			{ id: -4, name: 'GMT-4' },
			{ id: -3, name: 'GMT-3' },
			{ id: -2, name: 'GMT-2' },
			{ id: -1, name: 'GMT-1' },
			{ id: 0, name: 'GMT+0' },
			{ id: 1, name: 'GMT+1' },
			{ id: 2, name: 'GMT+2' },
			{ id: 3, name: 'GMT+3' },
			{ id: 4, name: 'GMT+4' },
			{ id: 5, name: 'GMT+5' },
			{ id: 6, name: 'GMT+6' },
			{ id: 7, name: 'GMT+7' },
			{ id: 8, name: 'GMT+8' },
			{ id: 9, name: 'GMT+9' },
			{ id: 10, name: 'GMT+10' },
			{ id: 11, name: 'GMT+11' }
		];
		return tzs;
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.services.workorders.controller', [])
        .controller('WorkOrderMainCtrl', WorkOrderMainCtrl)
        .controller('WorkOrderCreateCtrl', WorkOrderCreateCtrl)
        .controller('WorkOrderUpdateCtrl', WorkOrderUpdateCtrl)
        .controller('WorkOrderPrintModalCtrl', WorkOrderPrintModalCtrl)
        .controller('WorkOrderDebtorModalCtrl', WorkOrderDebtorModalCtrl)
        .controller('WorkOrderDebtorBranchModalCtrl', WorkOrderDebtorBranchModalCtrl)
        .controller('WorkOrderLoanRequestNewWarrantyModalCtrl', WorkOrderLoanRequestNewWarrantyModalCtrl)
        .controller('WorkOrderTechnicianModalCtrl', WorkOrderTechnicianModalCtrl)
        .controller('WorkOrderProcessModalCtrl', WorkOrderProcessModalCtrl)
		.controller('WorkOrderLoanRequestItemModalCtrl', WorkOrderLoanRequestItemModalCtrl)
		.controller('WorkOrderMediaModalCtrl', WorkOrderMediaModalCtrl)
        .controller('WorkOrderSopModalCtrl', WorkOrderSopModalCtrl);

    /** @ngInject */
    function WorkOrderMainCtrl($scope, Auth, HttpSvc, RmsApi, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.data = [];

		vm.isLoading = false;
		vm.blobUrl = RmsApi.BLOBURL;

		vm.getApiParams = function(tableState)
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}

			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.workNo,
				debtorId: predicate.debtorId,
				debtorName: predicate.debtorName,
				userId: predicate.userId,
				userName: predicate.userName,
				equipmentName: predicate.equipmentName,
				serviceName: predicate.serviceName,
				statusId: predicate.statusId,
				status: predicate.status,
				isOpenDoc: predicate.isOpenDoc,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('serviceworks/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;
					vm.numOfPages = result.numberOfPages;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;
			return tableState;
		};

		vm.resetSearch = function()
		{
		}

		// Init Call
		//vm.loadFilters();
	};

	/** @ngInject */
    function WorkOrderCreateCtrl($scope, $state, $filter, $uibModal, $timeout, Auth, HttpSvc, UtilSvc, toastr) {
		Auth.init();

		var vm = this;

		vm.userGroupId = Auth.getUserGroupId();
		vm.isAfterSalesManager = Auth.isAfterSalesManager();
		vm.isManualChargeInput = Auth.getSetting_IsManualChargeInput();
		vm.hasApproveAccess = Auth.hasPerm("services.workorders", "APPROVE");
		vm.currencyCode = Auth.getCurrency();
		vm.noFurtherEdit = false;

		vm.mode = 1;
		vm.workorder = {};
		vm.loan = {};
		vm.selectedStatus = null;
		vm.selectedDebtor = null;
		vm.selectedDebtorBranch = null;
		vm.selectedServiceType = null;
		vm.selectedZone = null;
		vm.selectedWarranty = null;
		vm.selectedEquipment = null;
		vm.selectedService = null;
		vm.statuses = [];
		vm.serviceTypes = [];
		vm.brandList = [];
		vm.typeList = [];
		vm.categoryList = [];
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.warrantyList = [];
		vm.equipmentList = [];
		vm.serviceList = [];
		vm.checkList = [];
		vm.zoneList = [];
		vm.loanItemStatusList = [];
		vm.note = "";
		vm.isLoading = false;
		vm.lockButtons = false;

		/* ************************************************************* */

		vm.beautify = function(code, name, description) {
			var newText = "";
			if(code) {
				newText = "<span class='dd-code'>" + code.toUpperCase();
			}
			if(name) {
				newText = newText + "</span>&nbsp;&nbsp;" + name.toUpperCase();
			}
			if(description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";
			}
			return newText;
		}

		vm.convert2html = function(description) {
			var newText = "";

			if(description) {
				description.replace(/\r\n|\r|\n/g, '<br />');
			}
			return newText;
		}

		/* ************************************************************* */

		vm.printWarrantyLabel = function() {

			HttpSvc.post('services/warranties/label/create/' + vm.workorder.warrantyId, {}, Auth.getTokenId(), false)
				.then(function(result) {
						toastr.success('Label Print instruction has been sent.', Auth.translate('SUCCESS'));
				}, function() {
					// Failed
					toastr.error('Failed to print the Warranty label.', 'Delete Failed');
					return null;
			});
		}

		/* ************************************************************* */

		vm.createWarranty = function() {
			var equipment = {};
			equipment.id = vm.workorder.equipmentId;
			equipment.brand = vm.selectedBrand.name;
			equipment.model = vm.workorder.eqModel;
			equipment.name = vm.selectedEquipment.name;
			equipment.description = vm.workorder.eqDescription;

			var customer = {};
			customer.id = vm.selectedDebtor.id;
			customer.code = vm.selectedDebtor.code;
			customer.name = vm.selectedDebtor.name;

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'NewWarrantyModal.html',
				controller: 'WorkOrderLoanRequestNewWarrantyModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							equipment: equipment,
							customer: customer,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.setWarranty(data);
				}, function () {
				});
		}

		// Set Warranty
		vm.setWarranty = function(obj) {
			vm.workorder.warrantyId = obj.id;
			vm.loadWarrantyList(obj.id, true);
		};

		/* ************************************************************* */

		vm.initData = function() {

			vm.loan = {};
			vm.loan.type = "REPAIR";
			vm.loan.invoiceNo = "";
			vm.loan.purpose = "";
			vm.loan.remarks = "";
			vm.loan.asLoanRequestItems = [];

			vm.workorder.siteAddress1 = "";
			vm.workorder.siteAddress2 = "";
			vm.workorder.siteAddress3 = "";
			vm.workorder.siteState = "";
			vm.workorder.sitePostCode = "";
			vm.workorder.siteCountry = "";
			vm.workorder.siteContactPerson = "";
			vm.workorder.sitePhone = "";
			vm.workorder.siteFax = "";
			vm.workorder.siteEmail = "";
			vm.workorder.baseKpiScore = 0;
			vm.workorder.extraKpiScore = 0;
			vm.workorder.asServiceWorkProcesses = [];
			vm.workorder.asServiceWorkChecklistEntries = [];
			vm.workorder.asServiceWorkNoteLogs = [];
			vm.workorder.asServiceWorkMedias = [];
			vm.workorder.asServiceWorkInvoices = [];

			vm.loadWorkTypes();
			vm.loadZoneList();
			vm.loadLoanItemStatusList();
		};

		vm.loadWorkTypes = function(searchString) {
			HttpSvc.get('services/worktypes/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.serviceTypes = result;
					vm.loadWorkStatuses();
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Work Types.', '');
					return null;
				});
		};

		vm.loadWorkStatuses = function() {
			HttpSvc.get('services/workorderstates/list/usergroup/' + vm.userGroupId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.statuses = result;

					// Select Default Status
					vm.statuses.forEach(function(s) {
						if(s.defaultStatus) {
							vm.selectedStatus = s;
							vm.workorder.workStateId = s.id;
							vm.workorder.noFurtherEdit = s.noFurtherEdit;
						}
					});

					vm.loadBrandList();
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Work Order Statuses.', '');
					return null;
				});
		};

		vm.loadBrandList = function(searchString) {
			HttpSvc.get('equipmentbrands/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.brandList = result;
					vm.loadTypeList();
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Brand list.', '');
					return null;
				});
		};

		vm.loadTypeList = function(searchString) {
			HttpSvc.get('equipmenttypes/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.typeList = result;
					vm.loadCategoryList();
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Type list.', '');
					return null;
				});
		};

		vm.loadCategoryList = function(searchString) {
			HttpSvc.get('equipmentcategories/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.categoryList = result;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Category list.', '');
					return null;
				});
		};

		vm.loadDebtorList = function(searchString) {
			vm.lockButtons = true;

			HttpSvc.get('debtors/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Customer list.', '');
					return null;
				});
		};

		vm.loadDebtorBranchList = function(debtorId) {
			vm.lockButtons = true;

			// Load Branches
			HttpSvc.get('debtors/' + debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorBranchList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Customer Branch list.', '');
					return null;
				});
		};

		vm.loadEquipmentList = function(searchString, autoSelect) {
			vm.lockButtons = true;

			HttpSvc.get('equipments/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.equipmentList = result;

					if(autoSelect) {
						if(vm.equipmentList.length > 0) {
							vm.selectedEquipment = vm.equipmentList[0];
							vm.onSelectedEquipmentChanged();
						}
					}

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Equipment list.', '');
					return null;
				});
		};

		vm.loadWarrantyList = function(searchString, autoSelect) {
			vm.lockButtons = true;

			var params = { keyword: searchString };

			HttpSvc.post('services/warranties/list', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.warrantyList = result;

					if(autoSelect) {
						vm.warrantyList.forEach(function(w) {
							if(w.id==vm.workorder.warrantyId) {
								vm.selectedWarranty = w;
								vm.onSelectedWarrantyChanged();
							}
						});
					}

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Warranty list.', '');
					return null;
				});
		};

		vm.loadServiceList = function(searchString) {
			vm.lockButtons = true;

			var url = 'services/list/' + searchString;
			if(vm.selectedCategory) {
				var url = 'services/listbycategory/' + vm.selectedCategory.id + '/' + searchString;
			}
			HttpSvc.get(url, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.serviceList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Service list.', '');
					return null;
				});
		};

		vm.loadChecklist = function(searchString) {
			vm.lockButtons = true;

			HttpSvc.get('services/checklists/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.checkList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Checklist.', '');
					return null;
				});
		};

		vm.loadZoneList = function(postcode) {
			vm.lockButtons = true;

			if(postcode!=null && postcode.trim()!='') {
				HttpSvc.get('services/zones/list/postcode/' + postcode, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.zoneList = result;
						vm.lockButtons = false;
					}, function() {
						vm.lockButtons = false;
						//toastr.error('Failed to retrieve Zone list.', '');
						return null;
					});
			} else {
				HttpSvc.get('services/zones/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.zoneList = result;
						vm.lockButtons = false;
					}, function() {
						vm.lockButtons = false;
						//toastr.error('Failed to retrieve Zone list. 2', '');
						return null;
					});
			}
		};

		vm.loadLoanItemStatusList = function() {
			vm.lockButtons = true;

			HttpSvc.get('services/loanitemstates/list/usergroup/' + vm.userGroupId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.loanItemStatusList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Loan Item Status list.', '');
					return null;
				});
		};

		/* ************************************************************* */

		// Service Types changed
		vm.onSelectedServiceTypeChanged = function() {
			vm.workorder.workTypeId = vm.selectedServiceType.id;
		};

		// Service selection changed
		vm.onSelectedStatusChanged = function() {
			vm.workorder.workStateId = vm.selectedStatus.id;
			vm.workorder.noFurtherEdit = vm.selectedStatus.noFurtherEdit;
		};

		// Customer selection changed
		vm.onSelectedDebtorChanged = function() {
			vm.loan.debtorId = vm.selectedDebtor.id;
			vm.workorder.debtorId = vm.selectedDebtor.id;
			vm.workorder.debtorCode = vm.selectedDebtor.code;
			vm.workorder.debtorName = vm.selectedDebtor.name;

			// Load Branch List
			vm.loadDebtorBranchList(vm.selectedDebtor.id);

			// Check Overwrite
			if((vm.workorder.siteAddress1 != vm.selectedDebtor.address1 && vm.workorder.siteAddress1 != '') ||
				(vm.workorder.siteAddress2 != vm.selectedDebtor.address2 && vm.workorder.siteAddress2 != '') ||
				(vm.workorder.siteAddress3 != vm.selectedDebtor.address3 && vm.workorder.siteAddress3 != '') ||
				(vm.workorder.siteState != vm.selectedDebtor.state && vm.workorder.siteState != '') ||
				(vm.workorder.sitePostCode != vm.selectedDebtor.postCode && vm.workorder.sitePostCode != '') ||
				(vm.workorder.siteCountry != vm.selectedDebtor.country && vm.workorder.siteCountry != ''))
			{
				// if(!confirm('Do you want to overwrite the Customer Site Address?')) {
				// 	return;
				// }
			}

			vm.workorder.siteAddress1 = vm.selectedDebtor.address1;
			vm.workorder.siteAddress2 = vm.selectedDebtor.address2;
			vm.workorder.siteAddress3 = vm.selectedDebtor.address3;
			vm.workorder.siteState = vm.selectedDebtor.state;
			vm.workorder.sitePostCode = vm.selectedDebtor.postCode;
			vm.workorder.siteCountry = vm.selectedDebtor.country;
			vm.workorder.siteContactPerson = vm.selectedDebtor.contactPerson1;
			vm.workorder.sitePhone = vm.selectedDebtor.phone1;
			vm.workorder.siteFax = vm.selectedDebtor.fax1;
			vm.workorder.siteEmail = vm.selectedDebtor.email1;

			// Load Zone List
			vm.loadZoneList(vm.workorder.sitePostCode);
		};

		// Customer Branch selection changed
		vm.onSelectedDebtorBranchChanged = function(toHide) {
			if(vm.selectedDebtorBranch == null) return;

			vm.workorder.debtorBranchId = vm.selectedDebtorBranch.id;
			vm.workorder.debtorBranchName = vm.selectedDebtorBranch.name;

			if(!toHide) {
				// if((vm.workorder.siteAddress1 != vm.selectedDebtorBranch.address1 && vm.workorder.siteAddress1 != '') ||
				// 	(vm.workorder.siteAddress2 != vm.selectedDebtorBranch.address2 && vm.workorder.siteAddress2 != '') ||
				// 	(vm.workorder.siteAddress3 != vm.selectedDebtorBranch.address3 && vm.workorder.siteAddress3 != '') ||
				// 	(vm.workorder.siteState != vm.selectedDebtorBranch.state && vm.workorder.siteState != '') ||
				// 	(vm.workorder.sitePostCode != vm.selectedDebtorBranch.postCode && vm.workorder.sitePostCode != '') ||
				// 	(vm.workorder.siteCountry != vm.selectedDebtorBranch.country && vm.workorder.siteCountry != ''))
				// {
				// 	if(!confirm('Do you want to overwrite the Customer Site Address?')) {
				// 		return;
				// 	}
				// }
			}

			vm.workorder.siteAddress1 = vm.selectedDebtorBranch.address1;
			vm.workorder.siteAddress2 = vm.selectedDebtorBranch.address2;
			vm.workorder.siteAddress3 = vm.selectedDebtorBranch.address3;
			vm.workorder.siteState = vm.selectedDebtorBranch.state;
			vm.workorder.sitePostCode = vm.selectedDebtorBranch.postCode;
			vm.workorder.siteCountry = vm.selectedDebtorBranch.country;
			vm.workorder.siteContactPerson = vm.selectedDebtorBranch.contactPerson;
			vm.workorder.sitePhone = vm.selectedDebtorBranch.phone;
			vm.workorder.siteFax = vm.selectedDebtorBranch.fax;
			vm.workorder.siteEmail = vm.selectedDebtorBranch.email;

			// Load Zone List
			vm.loadZoneList(vm.workorder.sitePostCode);
		}

		// Equipment selection changed
		vm.onSelectedEquipmentChanged = function() {

			vm.workorder.equipmentId = vm.selectedEquipment.id;
			vm.workorder.eqBrand = vm.selectedEquipment.brandName;
			vm.workorder.eqType = vm.selectedEquipment.typeName;
			vm.workorder.eqCategory = vm.selectedEquipment.categoryName;
			vm.workorder.eqModel = vm.selectedEquipment.model;
			vm.workorder.eqDescription = vm.selectedEquipment.description;
			vm.workorder.eqVoltageGasType = vm.selectedEquipment.voltageGasType;
			vm.workorder.eqDimension = vm.selectedEquipment.dimension;

			vm.brandList.forEach(function(b) {
				if(b.id==vm.selectedEquipment.brandId) {
					vm.selectedBrand = b;
				}
			});
			vm.typeList.forEach(function(b) {
				if(b.id==vm.selectedEquipment.typeId) {
					vm.selectedType = b;
				}
			});
			vm.categoryList.forEach(function(b) {
				if(b.id==vm.selectedEquipment.categoryId) {
					vm.selectedCategory = b;
				}
			});

			vm.loadServiceList("");
		};

		// Equipment Brand selection changed
		vm.selectedBrandChanged = function() {
			vm.workorder.eqBrand = vm.selectedBrand.name;
		};

		// Equipment Type selection changed
		vm.selectedTypeChanged = function() {
			vm.workorder.eqType = vm.selectedType.name;
		};

		// Equipment Category selection changed
		vm.selectedCategoryChanged = function() {
			vm.workorder.eqCategory = vm.selectedCategory.name;
		};

		// Warranty selection changed
		vm.onSelectedWarrantyChanged = function() {
			vm.workorder.warrantyId = vm.selectedWarranty.id;
			vm.workorder.warrantyNo = vm.selectedWarranty.warrantyNo;
			vm.workorder.warrantyInvoiceNo = vm.selectedWarranty.invoiceNo;
			vm.workorder.warrantySerialNo = vm.selectedWarranty.serialNo;
			vm.workorder.warrantyDescription = vm.selectedWarranty.description;
			vm.workorder.warrantyFrom = $filter('date')(vm.selectedWarranty.warrantyFrom, 'yyyy-MM-dd');
			vm.workorder.warrantyTo = $filter('date')(vm.selectedWarranty.warrantyTo, 'yyyy-MM-dd');

			vm.loadEquipmentList(vm.selectedWarranty.equipmentId, true);
		};

		// Service selection changed
		vm.onSelectedServiceChanged = function() {
			vm.workorder.serviceId = vm.selectedService.id;
			vm.workorder.serviceCode = vm.selectedService.code;
			vm.workorder.serviceName = vm.selectedService.name;
			vm.workorder.asServiceWorkProcesses = [];

			vm.lockButtons = true;

			HttpSvc.get('services/' + vm.selectedService.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					var service = result;
					vm.workorder.baseKpiScore = service.kpiScore;

					service.asServiceProcesses.forEach(function(p) {
						p.status = "NEW";
						p.asServiceWorkTechnicians = [];
						p.asServiceWorkTimeLogs = [];
						vm.workorder.asServiceWorkProcesses.push(p);
					});

					vm.lockButtons = false;

				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Service detail.', '');
					return null;
				});
		};

		// Zone Selection changed
		vm.onSelectedZoneChanged = function() {
			vm.workorder.zoneId = vm.selectedZone.id;
			vm.workorder.zoneCode = vm.selectedZone.code;
			vm.workorder.zoneName = vm.selectedZone.name;
		};

		/* ************************************************************* */

		vm.clearDebtor = function() {
			vm.selectedDebtor = null;
			vm.selectedZone = null;

			vm.workorder.debtorId = null;
			vm.workorder.zoneId = ""

			vm.workorder.siteAddress1 = "";
			vm.workorder.siteAddress2 = "";
			vm.workorder.siteAddress3 = "";
			vm.workorder.siteState = "";
			vm.workorder.sitePostCode = "";
			vm.workorder.siteCountry = "";
			vm.workorder.siteContactPerson = "";
			vm.workorder.sitePhone = "";
			vm.workorder.siteFax = "";
			vm.workorder.siteEmail = "";

			vm.debtorBranchList = [];
			//vm.loadZoneList();

			//$scope.$apply();
		}

		vm.clearEquipment = function() {
			vm.selectedEquipment = null;
			vm.selectedBrand = null;
			vm.selectedType = null;
			vm.selectedCategory = null;

			vm.workorder.equipmentId = null;
			vm.workorder.eqBrand = "";
			vm.workorder.eqType = "";
			vm.workorder.eqCategory = "";
			vm.workorder.eqModel = "";
			vm.workorder.eqDescription  = "";

			$scope.$apply();
		}

		vm.clearWarranty = function() {
			vm.selectedWarranty = null;
			vm.workorder.warrantyId = null;
			vm.workorder.warrantyNo = "";
			vm.workorder.warrantyInvoiceNo = "";
			vm.workorder.warrantySerialNo = "";
            vm.workorder.warrantyFrom = null;
            vm.workorder.warrantyTo = null;

			$scope.$apply();
		}

		vm.clearService = function() {
			vm.selectedService = null;
			vm.workorder.serviceId = null;
			vm.workorder.serviceCode = "";
			vm.workorder.serviceName = "";
			vm.workorder.asServiceWorkProcesses = [];

			$scope.$apply();
		}

		/* ************************************************************* */

		// Remove Item
		vm.removeItem = function(index) {
			vm.loan.asLoanRequestItems.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};

		// Update Item
		vm.updateItem = function(index, obj) {
			var element = {
				equipmentId: obj.equipmentId,
				partId: obj.partId,
				storageId: obj.storageId,
				loanItemStateId: obj.loanItemStateId,
				itemCode: obj.itemCode,
				itemDescription: obj.itemDescription,
				storageName: obj.storageName,
				status: obj.status,
				quantity: obj.quantity,
				quantityReturn: obj.quantityReturn,
				price: obj.price,
				serialNo: obj.serialNo,
				remarks: obj.remarks,
			};
			vm.loan.asLoanRequestItems.splice(index, 1, element);
		};

		// Add Item
		vm.addItem = function(obj) {
			var element = {
				equipmentId: obj.equipmentId,
				partId: obj.partId,
				storageId: obj.storageId,
				loanItemStateId: obj.loanItemStateId,
				itemCode: obj.itemCode,
				itemDescription: obj.itemDescription,
				storageName: obj.storageName,
				status: obj.status,
				quantity: obj.quantity,
				quantityReturn: obj.quantityReturn,
				price: obj.price,
				serialNo: obj.serialNo,
				remarks: obj.remarks,
			};
			vm.loan.asLoanRequestItems.push(element);
		};

		/* ************************************************************* */

		vm.item = {};
		vm.showAddItemModal = function () {
			vm.item = {};

			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'PartModal.html',
				windowClass: 'app-modal-window',
				controller: 'WorkOrderLoanRequestItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.item,
							statuses: vm.loanItemStatusList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};

		vm.showEditItemModal = function (index) {
			vm.item = angular.copy(vm.loan.asLoanRequestItems[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'PartModal.html',
				windowClass: 'app-modal-window',
				controller: 'WorkOrderLoanRequestItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
							statuses: vm.loanItemStatusList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};

		/* ************************************************************* */

		vm.addNote = function() {
			vm.isLockButton = true;

			var newNote = {
				id: UtilSvc.generateGuid(),
				workId: $stateParams.id,
				remarks: vm.note,
			};

			HttpSvc.post('serviceworknotelogs', newNote, Auth.getTokenId(), false)
				.then(function(result) {

					HttpSvc.get('serviceworknotelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.workorder.asServiceWorkNoteLogs = result;
							vm.note = "";
							vm.isLockButton = false;
						}, function(error) {
							vm.isLockButton = false;
							toastr.error(error, 'Failed');
						});

				}, function(error) {
					vm.isLockButton = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ************************************************************* */

		vm.showAddCustomerModal = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'debtorModal.html',
				controller: 'WorkOrderDebtorModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addDebtor(data);
				}, function () {
				});
		};

		vm.addDebtor = function(data) {
			vm.lockButtons = true;

			HttpSvc.post('debtors', data, Auth.getTokenId(), false)
				.then(function(result) {
					vm.autoSelectDebtor(result.id);
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					vm.lockButtons = false;
				});
		}

		// Auto Select Branch
		vm.autoSelectDebtor = function(debtorId) {

			vm.clearDebtor();

			// Load Branches
			HttpSvc.get('debtors/' + debtorId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.selectedDebtor = result;
					vm.onSelectedDebtorChanged(true);

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Customer details.', '');
					return null;
				});
		};

		/* ************************************************************* */

		vm.showAddBranchModal = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'branchModal.html',
				controller: 'WorkOrderDebtorBranchModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: {
								debtorId: vm.selectedDebtor.id,
							},
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addBranch(data);
				}, function () {
				});
		};

		vm.addBranch = function(data) {
			vm.lockButtons = true;

			HttpSvc.post('debtors/' + vm.selectedDebtor.id + '/branches', data, Auth.getTokenId(), false)
				.then(function(result) {
					vm.autoSelectBranch(result.id);
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					vm.lockButtons = false;
				});
		}

		// Auto Select Branch
		vm.autoSelectBranch = function(branchId) {

			// Load Branches
			HttpSvc.get('debtors/' + vm.selectedDebtor.id + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorBranchList = result;

					vm.debtorBranchList.forEach(function(b) {
						if(b.id==branchId) {
							vm.selectedDebtorBranch = b;
							vm.onSelectedDebtorBranchChanged(true);
							toastr.info('New Branch created and selected.', 'New Branch / Site');
						}
					});

					vm.loadZoneList(vm.workorder.sitePostCode);

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Customer Branch list.', '');
					return null;
				});
		};

		/* ************************************************************* */

		// Remove Schedule
		vm.removeInvoiceRow = function(index) {
			vm.workorder.asServiceWorkInvoices.splice(index, 1);
		};

		// Add Schedule
		vm.addInvoiceRow = function() {
			var element = {
				id: UtilSvc.generateGuid(),
				invoiceNo: '',
				invoiceDate: '',
				invoiceAmount: 0
			};
			vm.workorder.asServiceWorkInvoices.push(element);
			//vm.invoiceForm.$show();
		};

		vm.saveInvoiceRows = function() {
			//vm.invoiceForm.$submit();

			for(var x=vm.workorder.asServiceWorkInvoices.length-1; x>=0; x--)
			{
				var inv = vm.workorder.asServiceWorkInvoices[x];
				if(inv.invoiceNo==null || inv.invoiceNo=='')
				{
					vm.workorder.asServiceWorkInvoices.splice(x, 1);
				}
			}
		}

		/* ************************************************************* */

		vm.setOneYear = function() {
			if(vm.workorder.warrantyFrom)
			{
				vm.workorder.warrantyTo = new Date($filter('date')(vm.workorder.warrantyFrom, 'yyyy-MM-dd'));
				vm.workorder.warrantyTo = new Date(
					vm.workorder.warrantyTo.getFullYear() + 1,
					vm.workorder.warrantyTo.getMonth(),
					vm.workorder.warrantyTo.getDate()-1
				);
				vm.workorder.warrantyTo = $filter('date')(vm.workorder.warrantyTo, 'yyyy-MM-dd');
			}
		}

		vm.setTwoYear = function() {
			if(vm.workorder.warrantyFrom)
			{
				vm.workorder.warrantyTo = new Date($filter('date')(vm.workorder.warrantyFrom, 'yyyy-MM-dd'));
				vm.workorder.warrantyTo = new Date(
					vm.workorder.warrantyTo.getFullYear() + 2,
					vm.workorder.warrantyTo.getMonth(),
					vm.workorder.warrantyTo.getDate()-1
				);
				vm.workorder.warrantyTo = $filter('date')(vm.workorder.warrantyTo, 'yyyy-MM-dd');
			}
		}

		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {

			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			} else {
				HttpSvc.post('serviceworks', vm.workorder, Auth.getTokenId(), false)
					.then(function(result) {
						vm.lockButtons = true;

						vm.saveInvoiceRows();

						if(vm.loan.asLoanRequestItems.length>0) {

							vm.loan.workId = result.id;

							HttpSvc.post('services/loanrequests', vm.loan, Auth.getTokenId(), false)
								.then(function(result) {
									toastr.success('Work Order has been created successfully.', Auth.translate('SUCCESS'));
									$state.go('services.workorders.update', {'id': vm.loan.workId });
								}, function(error) {
									toastr.error(error, 'Failed');
								});
						} else {
							toastr.success('Work Order has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('services.workorders.update', {'id': result.id });
						}

					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Actions
		vm.initData();
	}

	/** @ngInject */
    function WorkOrderUpdateCtrl($scope, $state, $stateParams, $sce, $timeout, $uibModal, Auth, HttpSvc, RmsApi, UtilSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.userGroupId = Auth.getUserGroupId();
		vm.isAfterSalesManager = Auth.isAfterSalesManager();
		vm.isManualChargeInput = Auth.getSetting_IsManualChargeInput();
		vm.hasApproveAccess = Auth.hasPerm("services.workorders", "APPROVE");
		vm.currencyCode = Auth.getCurrency();
		vm.noFurtherEdit = false;

		vm.mode = 2;
		vm.workorder = {};
		vm.originalStatus = "NEW";
		vm.selectedStatus = null;
		vm.selectedDebtor = null;
		vm.selectedDebtorBranch = null;
		vm.selectedServiceType = null;
		vm.selectedZone = null;
		vm.selectedWarranty = null;
		vm.selectedEquipment = null;
		vm.selectedService = null;
		vm.statuses = [];
		vm.brandList = [];
		vm.typeList = [];
		vm.categoryList = [];
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.warrantyList = [];
		vm.equipmentList = [];
		vm.serviceList = [];
		vm.zoneList = [];
		vm.loanItemStatusList = [];
		vm.changeLogs = [];
		vm.note = "";
		vm.isLoading = false;
		vm.lockButtons = false;
		vm.serverMode = Auth.getServerMode();
		vm.rootUrl = (vm.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);

		/* ************************************************************* */

		vm.beautify = function(code, name, description) {
			var newText = "";
			if(code) {
				newText = "<span class='dd-code'>" + code.toUpperCase();
			}
			if(name) {
				newText = newText + "</span>&nbsp;&nbsp;" + name.toUpperCase();
			}
			if(description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";
			}
			return newText;
		}

		vm.convert2html = function(description) {
			var newText = "";

			if(description) {
				description.replace(/\r\n|\r|\n/g, '<br />');
			}
			return newText;
		}

		/* ************************************************************* */

		vm.downloadFile = function(downloadPath) {
			window.open(downloadPath, '_blank', '');
		}

		/* ************************************************************* */

		vm.printWarrantyLabel = function() {

			HttpSvc.post('services/warranties/label/create/' + vm.workorder.warrantyId, {}, Auth.getTokenId(), false)
				.then(function(result) {
						toastr.success('Label Print instruction has been sent.', Auth.translate('SUCCESS'));
				}, function() {
					// Failed
					toastr.error('Failed to print the Warranty label.', 'Delete Failed');
					return null;
			});
		}

		/* ************************************************************* */

		vm.createWarranty = function() {
			var equipment = {};
			equipment.id = vm.workorder.equipmentId;
			equipment.brand = vm.selectedBrand.name;
			equipment.model = vm.workorder.eqModel;
			equipment.name = vm.selectedEquipment.name;
			equipment.description = vm.workorder.eqDescription;

			var customer = {};
			customer.id = vm.selectedDebtor.id;
			customer.code = vm.selectedDebtor.code;
			customer.name = vm.selectedDebtor.name;

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'NewWarrantyModal.html',
				controller: 'WorkOrderLoanRequestNewWarrantyModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							equipment: equipment,
							customer: customer,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.setWarranty(data);
				}, function () {
				});
		}

		// Set Warranty
		vm.setWarranty = function(obj) {
			vm.workorder.warrantyId = obj.id;
			vm.loadWarranty(obj.id);
		};

		/* ************************************************************* */

		vm.initData = function() {

			vm.loan = {};
			vm.loan.type = "REPAIR";
			vm.loan.invoiceNo = "";
			vm.loan.purpose = "";
			vm.loan.remarks = "";
			vm.loan.asLoanRequestItems = [];

			vm.workorder.siteAddress1 = "";
			vm.workorder.siteAddress2 = "";
			vm.workorder.siteAddress3 = "";
			vm.workorder.siteState = "";
			vm.workorder.sitePostCode = "";
			vm.workorder.siteCountry = "";
			vm.workorder.siteContactPerson = "";
			vm.workorder.sitePhone = "";
			vm.workorder.siteFax = "";
			vm.workorder.siteEmail = "";
			vm.workorder.asServiceWorkProcesses = [];
			vm.workorder.asServiceWorkNoteLogs = [];
			vm.workorder.asServiceWorkMedias = [];

			vm.loadLoanItemStatusList();
			vm.loadWork();
		};

		/* ************************************************************* */

		vm.loadDebtorList = function(searchString) {
			vm.lockButtons = true;

			HttpSvc.get('debtors/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Customer list.', '');
					return null;
				});
		};

		vm.loadDebtorBranchList = function(debtorId, autoSelect) {
			vm.lockButtons = true;

			// Load Branches
			HttpSvc.get('debtors/' + debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorBranchList = result;

					if(autoSelect){
						vm.debtorBranchList.forEach(function(b) {
							if(b.id==vm.workorder.debtorBranchId) {
								vm.selectedDebtorBranch = b;
							}
						});
					}

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Customer Branch list.', '');
					return null;
				});
		};

		vm.loadEquipmentList = function(searchString, autoSelect) {
			vm.lockButtons = true;

			HttpSvc.get('equipments/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.equipmentList = result;

					if(autoSelect) {
						if(vm.equipmentList.length > 0) {
							vm.selectedEquipment = vm.equipmentList[0];
							vm.onSelectedEquipmentChanged(autoSelect);
						}
					}

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Equipment list.', '');
					return null;
				});
		};

		vm.loadWarranty = function(warrantyId) {
			vm.lockButtons = true;

			HttpSvc.get('services/warranties/' + warrantyId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.warrantyList = [];
					vm.warrantyList.push(result);

					vm.selectedWarranty = result;
					vm.onSelectedWarrantyChanged();

					vm.lockButtons = false;

				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Warranty list.', '');
					return null;
				});
		};

		vm.loadWarrantyList = function(searchString, autoSelect) {
			vm.lockButtons = true;

			var params = { keyword: searchString };

			HttpSvc.post('services/warranties/list', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.warrantyList = result;

					if(autoSelect) {
						vm.warrantyList.forEach(function(w) {
							if(w.id==vm.workorder.warrantyId) {
								vm.selectedWarranty = w;
								vm.onSelectedWarrantyChanged();
							}
						});
					}
					vm.lockButtons = false;

				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Warranty list.', '');
					return null;
				});
		};

		vm.loadServiceList = function(searchString) {
			vm.lockButtons = true;

			var url = 'services/list/' + searchString;
			if(vm.selectedCategory) {
				var url = 'services/listbycategory/' + vm.selectedCategory.id + '/' + searchString;
			}

			HttpSvc.get(url, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.serviceList = result;

					if(vm.workorder.serviceId != null)
					{
						vm.serviceList.forEach(function(s) {
							if(s.id == vm.workorder.serviceId)
							{
								vm.selectedService = s;
							}
						});
					}

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Service list.', '');
					return null;
				});
		};

		vm.loadChecklist = function(searchString) {
			vm.lockButtons = true;

			if(vm.workorder.checklistId!=null && vm.workorder.checklistId!='') {
				HttpSvc.get('services/checklists/' + vm.workorder.checklistId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						vm.selectedChecklist = result;
					}, function() {
						toastr.error('Failed to retrieve Checklist.', '');
					});
			}
			else
			{
				HttpSvc.get('services/checklists/list/' + searchString, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.checkList = result;
						vm.lockButtons = false;
					}, function() {
						vm.lockButtons = false;
						toastr.error('Failed to retrieve Checklists.', '');
						return null;
					});
			}
		};

		vm.loadZoneList = function(postcode, autoSelect) {
			vm.lockButtons = true;

			if(postcode) {
				HttpSvc.get('services/zones/list/postcode/' + postcode, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.zoneList = result;

						if(autoSelect) {
							vm.zoneList.forEach(function(z) {
								if(z.id==vm.workorder.zoneId) {
									vm.selectedZone = z;
								}
							});
						}

						vm.lockButtons = false;
					}, function() {
						vm.lockButtons = false;
						//toastr.error('Failed to retrieve Zone list.', '');
						return null;
					});
			} else {
				HttpSvc.get('services/zones/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.zoneList = result;

						if(autoSelect) {
							vm.zoneList.forEach(function(z) {
								if(z.id==vm.workorder.zoneId) {
									vm.selectedZone = z;
								}
							});
						}

						vm.lockButtons = false;
					}, function() {
						vm.lockButtons = false;
						//toastr.error('Failed to retrieve Zone list.', '');
						return null;
					});
			}
		};

		vm.loadLoanItemStatusList = function() {
			vm.lockButtons = true;

			HttpSvc.get('services/loanitemstates/list/usergroup/' + vm.userGroupId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.loanItemStatusList = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Loan Item Status list.', '');
					return null;
				});
		};

		vm.loadLoanRequest = function() {
			vm.lockButtons = true;

			HttpSvc.get('services/loanrequests/workorder/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loan = result;
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					//toastr.error('Failed to retrieve Loan Request.', '');
					return null;
				});
		};

		vm.loadMediaList = function() {
			vm.lockButtons = true;

			HttpSvc.get('serviceworkmedias/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.workorder.asServiceWorkMedias = result;

					vm.workorder.asServiceWorkMedias.forEach(function(m) {
						if(m.mediaFile!=null && m.mediaFile!='') {
							m.finalMediaFile = vm.rootUrl + m.mediaFile;
						}
						if(m.isVimeoConverted && m.vimeoVideoId!=null) {
							m.finalVimeoUrl = $sce.trustAsResourceUrl("https://player.vimeo.com/video/" + m.vimeoVideoId);
						}
					});

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					//toastr.error('Failed to retrieve Loan Request.', '');
					return null;
				});
		};

		/* ************************************************************* */

		vm.prepareData = function() {

			if(vm.workorder.debtorId!=null) vm.selectedDebtor = vm.workorder.customer;
			if(vm.workorder.warrantyId!=null) vm.selectedWarranty = vm.workorder.warranty;
			if(vm.workorder.serviceId!=null) vm.selectedService = vm.workorder.service;

			vm.statuses = vm.workorder.workStatuses;
			vm.serviceTypes = vm.workorder.workTypeList;
			vm.brandList = vm.workorder.equipmentBrands;
			vm.typeList = vm.workorder.equipmentTypes;
			vm.categoryList = vm.workorder.equipmentCategories;
			vm.zoneList = vm.workorder.zoneList;

			// Media Path
			vm.workorder.asServiceWorkMedias.forEach(function(m) {
				if(m.mediaFile!=null && m.mediaFile!='') {
					m.finalMediaFile = vm.rootUrl + m.mediaFile;
				}
				if(m.isVimeoConverted && m.vimeoVideoId!=null) {
					m.finalVimeoUrl = $sce.trustAsResourceUrl("https://player.vimeo.com/video/" + m.vimeoVideoId);
				}
			});

			// Auto Select Status
			vm.statuses.forEach(function(s) {
				if(s.id==vm.workorder.workStateId) {
					vm.selectedStatus = s;
					vm.workorder.workStateId = s.id;
					vm.workorder.noFurtherEdit = s.noFurtherEdit;
					vm.noFurtherEdit = s.noFurtherEdit;
				}
			});

			// Auto Select Service Type
			vm.serviceTypes.forEach(function(t) {
				if(t.id==vm.workorder.workTypeId) {
					vm.selectedServiceType = t;
				}
			});

			// Auto Select Debtor
			vm.loadDebtorBranchList(vm.workorder.debtorId, true);

			// Auto Select Equipment
			vm.loadEquipmentList(vm.workorder.equipmentId, true);

			// Auto Select Zone
			vm.loadZoneList(vm.workorder.sitePostCode, true);

			// Load Loan Request
			vm.loadLoanRequest();

			// Load Service List
			vm.loadServiceList();

			// Load Checklist
			vm.loadChecklist();

			vm.lockButtons = false;
		}

		vm.getVideoUrl = function(url, filename) {
			return url + filename;
		}

		// Get Content Type
		vm.getMediaType = function(filename) {

			if(filename.endsWith('jpg') || filename.endsWith('jpeg')) {
				return "image/jpeg";
			} else if(filename.endsWith('png')) {
				return "image/png";
			} else if(filename.endsWith('gif')) {
				return "image/gif";
			} else if(filename.endsWith('mp4')) {
				return "video/mp4";
			} else if(filename.endsWith('3gp')) {
				return "video/3gp";
			} else if(filename.endsWith('mov')) {
				return "video/quicktime";
			}
		};

		/* ************************************************************* */

		// Service Types changed
		vm.onSelectedServiceTypeChanged = function() {
			vm.workorder.workTypeId = vm.selectedServiceType.id;
		};

		// Service selection changed
		vm.onSelectedStatusChanged = function() {
			vm.workorder.workStateId = vm.selectedStatus.id;
			vm.workorder.noFurtherEdit = vm.selectedStatus.noFurtherEdit;
		};

		// Customer selection changed
		vm.onSelectedDebtorChanged = function(autoSelect) {
			vm.workorder.debtorId = vm.selectedDebtor.id;
			vm.workorder.debtorCode = vm.selectedDebtor.code;
			vm.workorder.debtorName = vm.selectedDebtor.name;

			// Load Branch List
			vm.loadDebtorBranchList(vm.selectedDebtor.id);

			// Check Overwrite
			if(!autoSelect) {
				// if((vm.workorder.siteAddress1 != vm.selectedDebtor.address1 && vm.workorder.siteAddress1 != '') ||
				// 	(vm.workorder.siteAddress2 != vm.selectedDebtor.address2 && vm.workorder.siteAddress2 != '') ||
				// 	(vm.workorder.siteAddress3 != vm.selectedDebtor.address3 && vm.workorder.siteAddress3 != '') ||
				// 	(vm.workorder.siteState != vm.selectedDebtor.state && vm.workorder.siteState != '') ||
				// 	(vm.workorder.sitePostCode != vm.selectedDebtor.postCode && vm.workorder.sitePostCode != '') ||
				// 	(vm.workorder.siteCountry != vm.selectedDebtor.country && vm.workorder.siteCountry != ''))
				// {
				// 	if(!confirm('Do you want to overwrite the Customer Site Address?')) {
				// 		return;
				// 	}
				// }
			}

			vm.workorder.siteAddress1 = vm.selectedDebtor.address1;
			vm.workorder.siteAddress2 = vm.selectedDebtor.address2;
			vm.workorder.siteAddress3 = vm.selectedDebtor.address3;
			vm.workorder.siteState = vm.selectedDebtor.state;
			vm.workorder.sitePostCode = vm.selectedDebtor.postCode;
			vm.workorder.siteCountry = vm.selectedDebtor.country;
			vm.workorder.siteContactPerson = vm.selectedDebtor.contactPerson1;
			vm.workorder.sitePhone = vm.selectedDebtor.phone1;
			vm.workorder.siteFax = vm.selectedDebtor.fax1;
			vm.workorder.siteEmail = vm.selectedDebtor.email1;

			// Load Zone List
			vm.loadZoneList(vm.workorder.sitePostCode);
		};

		// Customer Branch selection changed
		vm.onSelectedDebtorBranchChanged = function(autoSelect) {

			if(!vm.selectedDebtorBranch) {
				vm.selectedDebtorBranch = null;
				vm.workorder.debtorBranchId = null;
				vm.workorder.debtorBranchName = "";
				return;
			}

			vm.workorder.debtorBranchId = vm.selectedDebtorBranch.id;
			vm.workorder.debtorBranchName = vm.selectedDebtorBranch.name;

			// Check Overwrite
			if(!autoSelect) {
				// if((vm.workorder.siteAddress1 != vm.selectedDebtorBranch.address1 && vm.workorder.siteAddress1 != '') ||
				// 	(vm.workorder.siteAddress2 != vm.selectedDebtorBranch.address2 && vm.workorder.siteAddress2 != '') ||
				// 	(vm.workorder.siteAddress3 != vm.selectedDebtorBranch.address3 && vm.workorder.siteAddress3 != '') ||
				// 	(vm.workorder.siteState != vm.selectedDebtorBranch.state && vm.workorder.siteState != '') ||
				// 	(vm.workorder.sitePostCode != vm.selectedDebtorBranch.postCode && vm.workorder.sitePostCode != '') ||
				// 	(vm.workorder.siteCountry != vm.selectedDebtorBranch.country && vm.workorder.siteCountry != ''))
				// {
				// 	if(!confirm('Do you want to overwrite the Customer Site Address?')) {
				// 		return;
				// 	}
				// }
			}

			vm.workorder.siteAddress1 = vm.selectedDebtorBranch.address1;
			vm.workorder.siteAddress2 = vm.selectedDebtorBranch.address2;
			vm.workorder.siteAddress3 = vm.selectedDebtorBranch.address3;
			vm.workorder.siteState = vm.selectedDebtorBranch.state;
			vm.workorder.sitePostCode = vm.selectedDebtorBranch.postCode;
			vm.workorder.siteCountry = vm.selectedDebtorBranch.country;
			vm.workorder.siteContactPerson = vm.selectedDebtorBranch.contactPerson;
			vm.workorder.sitePhone = vm.selectedDebtorBranch.phone;
			vm.workorder.siteFax = vm.selectedDebtorBranch.fax;
			vm.workorder.siteEmail = vm.selectedDebtorBranch.email;

			// Load Zone List
			vm.loadZoneList(vm.workorder.sitePostCode);
		}

		// Equipment selection changed
		vm.onSelectedEquipmentChanged = function(autoSelect) {

			vm.workorder.equipmentId = vm.selectedEquipment.id;
			vm.workorder.eqBrand = vm.selectedEquipment.brandName;
			vm.workorder.eqType = vm.selectedEquipment.typeName;
			vm.workorder.eqCategory = vm.selectedEquipment.categoryName;
			vm.workorder.eqModel = vm.selectedEquipment.model;
			vm.workorder.eqDescription = vm.selectedEquipment.description;
			vm.workorder.eqVoltageGasType = vm.selectedEquipment.voltageGasType;
			vm.workorder.eqDimension = vm.selectedEquipment.dimension;

			vm.brandList.forEach(function(b) {
				if(b.id==vm.selectedEquipment.brandId) {
					vm.selectedBrand = b;
				}
			});
			vm.typeList.forEach(function(b) {
				if(b.id==vm.selectedEquipment.typeId) {
					vm.selectedType = b;
				}
			});
			vm.categoryList.forEach(function(b) {
				if(b.id==vm.selectedEquipment.categoryId) {
					vm.selectedCategory = b;
				}
			});

			vm.loadServiceList("");
		};

		// Equipment Brand selection changed
		vm.selectedBrandChanged = function() {
			vm.workorder.eqBrand = vm.selectedBrand.name;
		};

		// Equipment Type selection changed
		vm.selectedTypeChanged = function() {
			vm.workorder.eqType = vm.selectedType.name;
		};

		// Equipment Category selection changed
		vm.selectedCategoryChanged = function() {
			vm.workorder.eqCategory = vm.selectedCategory.name;
		};

		// Warranty selection changed
		vm.onSelectedWarrantyChanged = function() {
			vm.workorder.warrantyId = vm.selectedWarranty.id;
			vm.workorder.warrantyNo = vm.selectedWarranty.warrantyNo;
			vm.workorder.warrantyInvoiceNo = vm.selectedWarranty.invoiceNo;
			vm.workorder.warrantySerialNo = vm.selectedWarranty.serialNo;
			vm.workorder.warrantyDescription = vm.selectedWarranty.description;
			vm.workorder.warrantyFrom = $filter('date')(vm.selectedWarranty.warrantyFrom, 'yyyy-MM-dd');
			vm.workorder.warrantyTo = $filter('date')(vm.selectedWarranty.warrantyTo, 'yyyy-MM-dd');

			vm.loadEquipmentList(vm.selectedWarranty.equipmentId, true);
		};

		// Service selection changed
		vm.onSelectedServiceChanged = function() {
			vm.workorder.serviceId = vm.selectedService.id;
			vm.workorder.serviceCode = vm.selectedService.code;
			vm.workorder.serviceName = vm.selectedService.name;
			vm.workorder.asServiceWorkProcesses = [];

			vm.lockButtons = true;

			HttpSvc.get('services/' + vm.selectedService.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					var service = result;
					vm.workorder.baseKpiScore = service.kpiScore;

					service.asServiceProcesses.forEach(function(p) {
						p.status = "NEW";
						p.asServiceWorkTechnicians = [];
						p.asServiceWorkTimeLogs = [];
						vm.workorder.asServiceWorkProcesses.push(p);
					});

					HttpSvc.get('services/checklists/categoryid/' + service.categoryId + '/typeid/' + service.typeId, {}, Auth.getTokenId(), false)
						.then(function(result) {
							vm.selectedChecklist = result;

							vm.workorder.checklistId = vm.selectedChecklist.id;
							vm.workorder.asServiceWorkChecklistEntries = [];

							vm.selectedChecklist.asChecklistEntries.forEach(function(p) {
								p.id = UtilSvc.generateGuid();
								vm.workorder.asServiceWorkChecklistEntries.push(p);
							});

							vm.lockButtons = false;
						}, function() {
							vm.lockButtons = false;
							//toastr.error('Failed to retrieve Checklist.', '');
							return null;
						});
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Service detail.', '');
					return null;
				});
		};

		// Checklist selection changed
		vm.onSelectedChecklistChanged = function() {
			vm.workorder.checklistId = vm.selectedChecklist.id;
			vm.workorder.asServiceWorkChecklistEntries = [];

			vm.lockButtons = true;

			var id = vm.selectedChecklist.id;
			if(id==null) id="";

			HttpSvc.get('services/checklists/' + id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					var checklist = result;

					checklist.asChecklistEntries.forEach(function(p) {
						p.id = UtilSvc.generateGuid();
						vm.workorder.asServiceWorkChecklistEntries.push(p);
					});

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Service detail.', '');
					return null;
				});
		};

		// Zone Selection changed
		vm.onSelectedZoneChanged = function() {

			if(!vm.selectedZone) {
				vm.selectedZone = null;
				vm.workorder.zoneId = null;
				vm.workorder.zoneCode = "";
				vm.workorder.zoneName = "";
				return;
			}

			vm.workorder.zoneId = vm.selectedZone.id;
			vm.workorder.zoneCode = vm.selectedZone.code;
			vm.workorder.zoneName = vm.selectedZone.name;
		};

		/* ************************************************************* */

		vm.clearDebtor = function() {
			vm.selectedDebtor = null;
			vm.selectedZone = null;

			vm.workorder.debtorId = null;
			vm.workorder.zoneId = "";

			vm.workorder.siteAddress1 = "";
			vm.workorder.siteAddress2 = "";
			vm.workorder.siteAddress3 = "";
			vm.workorder.siteState = "";
			vm.workorder.sitePostCode = "";
			vm.workorder.siteCountry = "";
			vm.workorder.siteContactPerson = "";
			vm.workorder.sitePhone = "";
			vm.workorder.siteFax = "";
			vm.workorder.siteEmail = "";

			vm.debtorBranchList = [];
			vm.loadZoneList();

			$scope.$apply();
		}

		vm.clearEquipment = function() {
			vm.selectedEquipment = null;
			vm.selectedBrand = null;
			vm.selectedType = null;
			vm.selectedCategory = null;

			vm.workorder.equipmentId = null;
			vm.workorder.eqBrand = "";
			vm.workorder.eqType = "";
			vm.workorder.eqCategory = "";
			vm.workorder.eqModel = "";
			vm.workorder.eqDescription  = "";

			$scope.$apply();
		}

		vm.clearWarranty = function() {
			vm.selectedWarranty = null;
			vm.workorder.warrantyId = null;
			vm.workorder.warrantyNo = "";
			vm.workorder.warrantyInvoiceNo = "";
			vm.workorder.warrantySerialNo = "";
            vm.workorder.warrantyFrom = null;
            vm.workorder.warrantyTo = null;

			$scope.$apply();
		}

		vm.clearService = function() {
			vm.selectedService = null;
			vm.workorder.serviceId = null;
			vm.workorder.serviceCode = "";
			vm.workorder.serviceName = "";
			vm.workorder.asServiceWorkProcesses = [];

			$scope.$apply();
		}

		vm.clearChecklist = function() {
			vm.selectedChecklist = null;
			vm.workorder.checklistId = null;
			vm.workorder.asServiceWorkChecklistEntries = [];

			$scope.$apply();
		}

		/* ************************************************************* */

		// Remove Item
		vm.removeItem = function(index) {
			vm.loan.asLoanRequestItems.splice(index, 1);
			$scope.$broadcast('refreshStTable');
		};

		// Update Item
		vm.updateItem = function(index, obj) {
			var element = {
				equipmentId: obj.equipmentId,
				partId: obj.partId,
				storageId: obj.storageId,
				loanItemStateId: obj.loanItemStateId,
				itemCode: obj.itemCode,
				itemDescription: obj.itemDescription,
				storageName: obj.storageName,
				status: obj.status,
				quantity: obj.quantity,
				quantityReturn: obj.quantityReturn,
				price: obj.price,
				serialNo: obj.serialNo,
				remarks: obj.remarks,
			};
			vm.loan.asLoanRequestItems.splice(index, 1, element);
		};

		// Add Item
		vm.addItem = function(obj) {
			var element = {
				equipmentId: obj.equipmentId,
				partId: obj.partId,
				storageId: obj.storageId,
				loanItemStateId: obj.loanItemStateId,
				itemCode: obj.itemCode,
				itemDescription: obj.itemDescription,
				storageName: obj.storageName,
				status: obj.status,
				quantity: obj.quantity,
				quantityReturn: obj.quantityReturn,
				price: obj.price,
				serialNo: obj.serialNo,
				remarks: obj.remarks,
			};
			vm.loan.asLoanRequestItems.push(element);
		};

		/* ************************************************************* */

		vm.item = {};
		vm.showAddItemModal = function () {
			vm.item = {};

			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'PartModal.html',
				windowClass: 'app-modal-window',
				controller: 'WorkOrderLoanRequestItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.item,
							statuses: vm.loanItemStatusList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addItem(data);
				}, function () {
				});
		};

		vm.showEditItemModal = function (index) {
			vm.item = angular.copy(vm.loan.asLoanRequestItems[index]);

			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'PartModal.html',
				windowClass: 'app-modal-window',
				controller: 'WorkOrderLoanRequestItemModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.item,
							statuses: vm.loanItemStatusList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateItem(index, data);
				}, function () {
				});
		};

		/* ************************************************************* */

		vm.addNote = function() {
			vm.isLockButton = true;

			var newNote = {
				id: UtilSvc.generateGuid(),
				workId: $stateParams.id,
				remarks: vm.note,
			};

			HttpSvc.post('serviceworknotelogs', newNote, Auth.getTokenId(), false)
				.then(function(result) {

					HttpSvc.get('serviceworknotelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.workorder.asServiceWorkNoteLogs = result;
							vm.note = "";
							vm.isLockButton = false;
						}, function(error) {
							vm.isLockButton = false;
							toastr.error(error, 'Failed');
						});

				}, function(error) {
					vm.isLockButton = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ************************************************************* */

		vm.showPrintDialog = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'printModal.html',
				controller: 'WorkOrderPrintModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							object: {
								workId: vm.workorder.id,
								workNo: vm.workorder.workNo,
							},
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};

		/* ************************************************************* */

		vm.showAddCustomerModal = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'debtorModal.html',
				controller: 'WorkOrderDebtorModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addDebtor(data);
				}, function () {
				});
		};

		vm.addDebtor = function(data) {
			vm.lockButtons = true;

			HttpSvc.post('debtors', data, Auth.getTokenId(), false)
				.then(function(result) {
					vm.autoSelectDebtor(result.id);
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					vm.lockButtons = false;
				});
		}

		// Auto Select Branch
		vm.autoSelectDebtor = function(debtorId) {

			vm.clearDebtor();

			// Load Branches
			HttpSvc.get('debtors/' + debtorId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.selectedDebtor = result;
					vm.onSelectedDebtorChanged(true);

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Customer details.', '');
					return null;
				});
		};

		/* ************************************************************* */

		vm.showAddBranchModal = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'branchModal.html',
				controller: 'WorkOrderDebtorBranchModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							object: {
								debtorId: vm.selectedDebtor.id,
							},
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addBranch(data);
				}, function () {
				});
		};

		vm.addBranch = function(data) {
			vm.lockButtons = true;

			HttpSvc.post('debtors/' + vm.selectedDebtor.id + '/branches', data, Auth.getTokenId(), false)
				.then(function(result) {
					vm.autoSelectBranch(result.id);
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					vm.lockButtons = false;
				});
		}

		// Auto Select Branch
		vm.autoSelectBranch = function(branchId) {

			// Load Branches
			HttpSvc.get('debtors/' + vm.selectedDebtor.id + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.debtorBranchList = result;

					vm.debtorBranchList.forEach(function(b) {
						if(b.id==branchId) {
							vm.selectedDebtorBranch = b;
							vm.onSelectedDebtorBranchChanged(true);
							toastr.info('New Branch created and selected.', 'New Branch / Site');
						}
					});

					vm.loadZoneList(vm.workorder.sitePostCode);

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to retrieve Customer Branch list.', '');
					return null;
				});
		};

		/* ************************************************************* */

		vm.showTechnicianModal = function(workProcessId) {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'technicianModal.html',
				controller: 'WorkOrderTechnicianModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							object: {
								zoneId: vm.selectedZone.id,
								brandId: vm.selectedBrand.id,
								categoryId: vm.selectedCategory.id,
								workProcessId: workProcessId
							},
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					if(!data) {
						vm.reloadProcessList();
					} else {
						vm.assignTechnician(workProcessId, data);
					}
				}, function () {
				});
		}

		vm.reloadProcessList = function() {
			HttpSvc.get('serviceworks/' + $stateParams.id + '/processes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.workorder.asServiceWorkProcesses = result;
					vm.isLockButton = false;
				}, function(error) {
					vm.isLockButton = false;
					toastr.error(error, 'Failed');
				});
		}

		vm.assignTechnician = function(workProcessId, data) {
			vm.isLockButton = true;

			var params = {
				workProcessId: workProcessId,
				userId: data.userId,
				appointmentDate: data.appointmentDate,
			}

			HttpSvc.post('serviceworks/assignment', params, Auth.getTokenId(), false)
				.then(function(result) {

					HttpSvc.get('serviceworks/' + $stateParams.id + '/processes', {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.workorder.asServiceWorkProcesses = result;
							toastr.success('Technician assignment successfully.', Auth.translate('SUCCESS'));
							vm.isLockButton = false;
						}, function(error) {
							vm.isLockButton = false;
							toastr.error(error, 'Failed');
						});

				}, function(error) {
					vm.isLockButton = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ************************************************************* */

		vm.showEditProcessModal = function (process) {

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'processModal.html',
				controller: 'WorkOrderProcessModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							object: {
								id: process.id,
								name: process.name,
								status: process.status,
								remarks: process.remarks,
							},
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					vm.reloadProcessList();
				}, function () {
				});
		};

		/* ************************************************************* */

		vm.showAddMediaModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'uploadMediaModal.html',
				controller: 'WorkOrderMediaModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							workId: vm.workorder.id,
							serverMode: Auth.getServerMode()
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					vm.loadMediaList();
				}, function () {
				});
		};

		/* ************************************************************* */

		vm.showSopModal = function(sopList) {

			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'SopModal.html',
				controller: 'WorkOrderSopModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							sopList: sopList
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		}

		/* ************************************************************* */

		// Remove Schedule
		vm.removeInvoiceRow = function(index) {
			vm.workorder.asServiceWorkInvoices.splice(index, 1);
		};

		// Add Schedule
		vm.addInvoiceRow = function() {
			var element = {
				id: UtilSvc.generateGuid(),
				invoiceNo: '',
				invoiceDate: '',
				invoiceAmount: 0
			};
			vm.workorder.asServiceWorkInvoices.push(element);
			//vm.invoiceForm.$show();
		};

		vm.saveInvoiceRows = function() {
			//vm.invoiceForm.$submit();

			for(var x=vm.workorder.asServiceWorkInvoices.length-1; x>=0; x--)
			{
				var inv = vm.workorder.asServiceWorkInvoices[x];
				if(inv.invoiceNo==null || inv.invoiceNo=='')
				{
					vm.workorder.asServiceWorkInvoices.splice(x, 1);
				}
			}
		}

		/* ************************************************************* */

		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('serviceworkchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};

		// Load Work
		vm.loadWork = function() {
			vm.lockButtons = true;

			HttpSvc.get('serviceworks/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.workorder = result;

					vm.prepareData();
					vm.loadChangeLogs();
					//$timeout(function() { vm.invoiceForm.$show() }, 500);

					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to load selected Work', Auth.translate('ERROR'))
					$state.go('services.workorders.list');
					return;
				});
		};

		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {

			if(vm.dataForm.$invalid) {
				var errMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errMsg, Auth.translate('ERROR'));
			} else {
				vm.lockButtons = true;

				vm.saveInvoiceRows();

				// Load Request
				if(vm.loan.id != null && vm.loan.id != "") {

					HttpSvc.put('services/loanrequests/' + vm.loan.id, vm.loan, Auth.getTokenId(), false)
						.then(function(result) {

							HttpSvc.put('serviceworks/' + $stateParams.id, vm.workorder, Auth.getTokenId(), false)
								.then(function(result) {

									toastr.success('Work Order has been updated successfully.', Auth.translate('SUCCESS'));
									$state.reload();

								}, function(error) {
									toastr.error(error, 'Failed');
									vm.lockButtons = false;
								});

						}, function(error) {
							toastr.error(error, 'Failed');
							vm.lockButtons = false;
						});

				} else {

					if(vm.loan.asLoanRequestItems.length>0) {

						vm.loan.workId = $stateParams.id;
						vm.loan.debtorId = vm.workorder.debtorId;

						HttpSvc.post('services/loanrequests', vm.loan, Auth.getTokenId(), false)
							.then(function(result) {

								HttpSvc.put('serviceworks/' + $stateParams.id, vm.workorder, Auth.getTokenId(), false)
									.then(function(result) {

										toastr.success('Work Order has been updated successfully.', Auth.translate('SUCCESS'));
										$state.reload();

									}, function(error) {
										toastr.error(error, 'Failed');
										vm.lockButtons = false;
									});

							}, function(error) {
								toastr.error(error, 'Failed');
								vm.lockButtons = false;
							});
					} else {

						HttpSvc.put('serviceworks/' + $stateParams.id, vm.workorder, Auth.getTokenId(), false)
							.then(function(result) {

								toastr.success('Work Order has been updated successfully.', Auth.translate('SUCCESS'));
								$state.reload();

							}, function(error) {
								toastr.error(error, 'Failed');
								vm.lockButtons = false;
							});
					}
				}
			}
		}

		// Call Actions
		vm.initData();
	}



	// Print Dialog
	function WorkOrderPrintModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;

		$mdl.isLoading = false;
		$mdl.item = item.object;

		/* *************************************************** */

		$mdl.printWorkOrderSheet = function() {
			$mdl.isLoading = true;
			var filename = "WORKORDER_" + $mdl.item.workNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('serviceworks/print/workordersheet/' + $mdl.item.workId, Auth.getTokenId(), filename)
				.then(function(result) {
					$mdl.isLoading = false;
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to generate Work Order. ' + error, '');
					return null;
				});
		}

		$mdl.printServiceForm = function() {
			$mdl.isLoading = true;
			var filename = "SVCREPAIRFORM_" + $mdl.item.workNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('serviceworks/print/servicerepairform/' + $mdl.item.workId, Auth.getTokenId(), filename)
				.then(function(result) {
					$mdl.isLoading = false;
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to generate Service Repair Form. ' + error, '');
					return null;
				});
		}

		$mdl.printServiceReport = function() {
			$mdl.isLoading = true;
			var filename = "SVCREPORT_" + $mdl.item.workNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('serviceworks/print/servicereport/' + $mdl.item.workId, Auth.getTokenId(), filename)
				.then(function(result) {
					$mdl.isLoading = false;
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to generate Service Report. ' + error, '');
					return null;
				});
		}

		$mdl.printInstallationNote = function() {
			$mdl.isLoading = true;
			var filename = "INSTNOTE_" + $mdl.item.workNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('serviceworks/print/installationnote/' + $mdl.item.workId, Auth.getTokenId(), filename)
				.then(function(result) {
					$mdl.isLoading = false;
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error('Failed to generate Installation Note. ' + error, '');
					return null;
			});
		};

		/* *************************************************** */

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}

	// Quick Create Customer Modal Controller
	function WorkOrderDebtorModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;

		$mdl.item = {};
		$mdl.item.active = true;
		$mdl.isLockButton = false;
		$mdl.autoCode = false;

		/* *************************************************** */

		$mdl.autoCodeChanged = function() {
			if($mdl.autoCode)
			{
				$mdl.item.code = null;
			}
		}

		$mdl.confirmModal = function() {
			$mdl.isLockButton = true;

			if(!$mdl.debtorForm.$valid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				$mdl.isLockButton = false;
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	// Quick Create Branch Modal Controller
	function WorkOrderDebtorBranchModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;

		$mdl.item = item.object;
		$mdl.isLoading = false;
		$mdl.isLockButton = false;
		$mdl.autoCode = false;

		/* *************************************************** */

		$mdl.autoCodeChanged = function() {
			if($mdl.autoCode)
			{
				$mdl.item.code = null;
			}
		}

		$mdl.confirmModal = function() {
			$mdl.isLockButton = true;

			if(!$mdl.branchForm.$valid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				$mdl.isLockButton = false;
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	// Quick Create Warranty Modal Controller
	function WorkOrderLoanRequestNewWarrantyModalCtrl($uibModalInstance, $filter, item, Auth, HttpSvc, toastr) {
		var $mdl = this;

		$mdl.warranty = {};
		$mdl.equipment = item.equipment;
		$mdl.customer = item.customer;
		$mdl.debtorList = [];
		$mdl.equipmentList = [];
		$mdl.isLockButton = false;

		/* *************************************************** */

		$mdl.initData = function() {
			$mdl.warranty.invoiceNo = "-";
			$mdl.warranty.customerPoNo = "-";
			$mdl.warranty.warrantyFrom = $filter('date')(new Date(), 'yyyy-MM-dd');
			$mdl.warranty.warrantyTo = $filter('date')(new Date(), 'yyyy-MM-dd');
			$mdl.warranty.remarks = "QUICK CREATE FROM WORK ORDER";

			$mdl.warranty.equipmentId = $mdl.equipment.id;
			$mdl.warranty.brand = $mdl.equipment.brand;
			$mdl.warranty.model = $mdl.equipment.model;
			$mdl.warranty.name = $mdl.equipment.name;
			$mdl.warranty.description = $mdl.equipment.description;

			$mdl.warranty.debtorId = $mdl.customer.id;

			$mdl.loadDebtorList($mdl.customer.id, true);
			$mdl.loadEquipmentList($mdl.equipment.id, true);
		}

		/* *************************************************** */

		$mdl.loadDebtorList = function(searchString, autoSelect) {
			$mdl.lockButtons = true;

			HttpSvc.get('debtors/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.debtorList = result;

					if(autoSelect) {
						$mdl.debtorList.forEach(function(d) {
							if(d.id==$mdl.warranty.debtorId) {
								$mdl.selectedDebtor = d;
							}
						});
					}

					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve debtor list.', '');
					return null;
				});
		};

		$mdl.loadEquipmentList = function(searchString, autoSelect) {
			$mdl.isLockButton = true;

			HttpSvc.get('equipments/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.equipmentList = result;

					if(autoSelect) {
						$mdl.equipmentList.forEach(function(e) {
							if(e.id==$mdl.warranty.equipmentId) {
								$mdl.selectedEquipment = e;
							}
						});
					}

					$mdl.isLockButton = false;
				}, function() {
					$mdl.isLockButton = false;
					toastr.error('Failed to retrieve equipment list.', '');
					return null;
				});
		};

		/* *************************************************** */

		$mdl.confirmModal = function() {

			if(!$mdl.warrantyForm.$valid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				$mdl.isLockButton = false;
			} else {
				$mdl.isLockButton = true;

				HttpSvc.post('services/warranties', $mdl.warranty, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Warranty has been created successfully.', Auth.translate('SUCCESS'));
						$uibModalInstance.close(result);
					}, function(error) {
						toastr.error(error, 'Failed');
						$mdl.isLockButton = false;
					});
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Init
		$mdl.initData();
	};

	// Technician Assignment Modal Controller
	function WorkOrderTechnicianModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;

		$mdl.mode = item.mode;
		$mdl.item = item.object;
		$mdl.technicianList = [];
		$mdl.selectedTechnicianList = [];
		$mdl.selectedTechnician = null;
		$mdl.appointmentDate = null;
		$mdl.isLoading = false;
		$mdl.isLoading1 = false;
		$mdl.isLockButton = false;

		$mdl.loadSelectedTechnicians = function() {

			$mdl.isLoading1 = true;

			var params = {
				zoneId: $mdl.item.zoneId,
				brandId: $mdl.item.brandId,
				categoryId: $mdl.item.categoryId,
				appointmentDate: $mdl.appointmentDate,
			};

			HttpSvc.get('serviceworks/' + $mdl.item.workProcessId + '/technicians', params, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.selectedTechnicianList = result;

					$mdl.isLoading1 = false;
				}, function() {
					$mdl.isLoading1 = false;
					toastr.error('Failed to retrieve assigned Technician list.', '');
					return null;
				});
		};

		$mdl.loadTechnicians = function() {

			if(!$mdl.appointmentDate) {
				toastr.error('Select an Appointment Date first.', Auth.translate('ERROR'));
				return;
			}

			$mdl.isLoading = true;

			var params = {
				zoneId: $mdl.item.zoneId,
				brandId: $mdl.item.brandId,
				categoryId: $mdl.item.categoryId,
				appointmentDate: $mdl.appointmentDate,
			};

			HttpSvc.post('services/techteams/assignment', params, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.technicianList = result;

					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve Technician list.', '');
					return null;
				});
		};

		/* *************************************************** */

		$mdl.unassignTechnician = function(userId) {

			var params = {
				workProcessId: $mdl.item.workProcessId,
				userId: userId,
			};

			HttpSvc.post('serviceworks/unassignment', params, Auth.getTokenId(), true)
				.then(function(result) {
					toastr.info('Technician unassigned successfully.', '');
					$mdl.loadSelectedTechnicians();
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve unassign Technician.', '');
					return null;
				});
		}

		/* *************************************************** */

		$mdl.confirmModal = function(data) {
			if(!data) {
				$uibModalInstance.close(data);
				return;
			}

			var params = {
				userId: data.userId,
				appointmentDate: $mdl.appointmentDate
			}
			$uibModalInstance.close(params);
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* *************************************************** */

		$mdl.loadSelectedTechnicians();
	}

	// Process Modal Controller
	function WorkOrderProcessModalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;

		$mdl.statuses = [
			{ id: 'NEW', name:'NEW' },
			{ id: 'ASSIGNED', name:'ASSIGNED' },
			{ id: 'IN PROGRESS', name:'IN PROGRESS' },
			{ id: 'ON HOLD', name:'ON HOLD' },
			{ id: 'COMPLETED', name:'COMPLETED' },
		];

		$mdl.item = item.object;
		$mdl.selectedStatus = {};
		$mdl.isLockButton = false;

		/* *************************************************** */

		$mdl.initData = function() {
			$mdl.statuses.forEach(function(s) {
				if(s.id==$mdl.item.status) {
					$mdl.selectedStatus = s;
				}
			});
		};

		$mdl.onSelectedStatusChanged = function() {
			$mdl.item.status = $mdl.selectedStatus.id;
		};

		/* *************************************************** */

		$mdl.confirmModal = function() {
			$mdl.isLockButton = true;

			if(!$mdl.processForm.$valid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				$mdl.isLockButton = false;
			} else {
				HttpSvc.post('serviceworks/updateprocess', $mdl.item, Auth.getTokenId(), true)
					.then(function(result) {
						$mdl.isLockButton = false;
						$uibModalInstance.close();
					}, function() {
						$mdl.isLockButton = false;
						toastr.error('Failed to update Process details.', '');
						return null;
					});
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* *************************************************** */

		$mdl.initData();
	};

	// Item Modal Controller
	function WorkOrderLoanRequestItemModalCtrl($uibModalInstance, Auth, HttpSvc, RmsApi, item, toastr) {
		var $mdl = this;

		$mdl.title = item.title;
		$mdl.item = item.object;
		$mdl.statusList = item.statuses;
		$mdl.storageList = [];
		$mdl.equipmentList = [];
		$mdl.sparePartList = [];
		$mdl.selectedStorage = null;
		$mdl.selectedEquipment = null;
		$mdl.selectedSparePart = null;
		$mdl.selectedStatus = null;
		$mdl.activeTab = 0;
		$mdl.lockButtons = false;
		$mdl.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		$mdl.imageLocation = 'assets/img/empty_placeholder.png';

		/* ******************************************************** */

		$mdl.beautifyEquipment = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			if(item.name) {
				newText = newText + "</span>&nbsp;&nbsp;" + item.name.toUpperCase();
			}
			if(item.description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + item.description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";
			}
			return newText;
		}

		$mdl.beautifySparePart = function(item) {
			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			if(item.description) {
				newText = newText + "</span>&nbsp;&nbsp;" + item.description.toUpperCase();
			}
			return newText;
		}

		/* ************************************************************* */

		$mdl.onSelectedStorageChanged = function() {
			$mdl.item.storageId = $mdl.selectedStorage.id;
			$mdl.item.storageName = $mdl.selectedStorage.description;
		}

		$mdl.onSelectedStatusChanged = function() {
			$mdl.item.loanItemStateId = $mdl.selectedStatus.id;
			$mdl.item.status = $mdl.selectedStatus.name;
		}

		$mdl.onSelectedEquipmentChanged = function() {
			$mdl.item.equipmentId = $mdl.selectedEquipment.id;
			$mdl.item.itemCode = $mdl.selectedEquipment.code;
			$mdl.item.itemDescription = $mdl.selectedEquipment.name;
			$mdl.imageLocation =
				$mdl.rootUrl + $mdl.selectedEquipment.imageLocation || 'assets/img/empty_placeholder.png';
			$mdl.item.partId = null;
		}

		$mdl.onSelectedSparePartChanged = function() {
			$mdl.item.partId = $mdl.selectedSparePart.id;
			$mdl.item.itemCode = $mdl.selectedSparePart.code;
			$mdl.item.itemDescription = $mdl.selectedSparePart.description;
			$mdl.item.price = $mdl.selectedSparePart.price;
			$mdl.imageLocation =
				$mdl.rootUrl + $mdl.selectedSparePart.imageLocation || 'assets/img/empty_placeholder.png';
			$mdl.item.equipmentId = null;
		}

		/* ******************************************************** */

		$mdl.loadStorageList = function() {
			$mdl.lockButtons = true;

			HttpSvc.get('storages/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.storageList = result;

					// Select Default Warehouse
					$mdl.storageList.forEach(function(s) {
						if(s.isAfterSalesDefault) {
							$mdl.selectedStorage = s;
						}
					});

					$mdl.storageList.forEach(function(s) {
						if(s.id==$mdl.item.storageId) {
							$mdl.selectedStorage = s;
						}
					});

					if($mdl.selectedStorage==null) {
						if($mdl.storageList.length > 0) {
							$mdl.selectedStorage = $mdl.storageList[0];
							$mdl.item.storageId = $mdl.selectedStorage.id;
							$mdl.item.storageName = $mdl.selectedStorage.description;
						}
						else
						{
							toastr.warning('You must create a <b>Warehouse</b> record first (Maintenance &rarr; Warehouse)', 'Unable to add Equipment / Spart Parts');
							$mdl.cancelModal();
						}
					}
					else
					{
						$mdl.item.storageId = $mdl.selectedStorage.id;
						$mdl.item.storageName = $mdl.selectedStorage.description;
					}

					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Warehouse list.', '');
					return null;
				});
		};

		$mdl.loadEquipmentList = function(searchString, autoSelect) {
			$mdl.lockButtons = true;

			HttpSvc.get('equipments/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.equipmentList = result;

					if(autoSelect) {
						$mdl.equipmentList.forEach(function(e) {
							if(e.id==$mdl.item.equipmentId) {
								$mdl.selectedEquipment = e;
								$mdl.imageLocation =
									$mdl.rootUrl + $mdl.selectedEquipment.imageLocation ||
									'assets/img/empty_placeholder.png';
							}
						});
					}

					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Equipment list.', '');
					return null;
				});
		};

		$mdl.loadSparePartList = function(searchString, autoSelect) {
			$mdl.lockButtons = true;

			HttpSvc.get('spareparts/list/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.sparePartList = result;

					if(autoSelect) {
						$mdl.sparePartList.forEach(function(s) {
							if(s.id==$mdl.item.partId) {
								$mdl.selectedSparePart = s;
								$mdl.imageLocation =
									$mdl.rootUrl + $mdl.selectedSparePart.imageLocation ||
									'assets/img/empty_placeholder.png';
							}
						});
					}

					$mdl.lockButtons = false;
				}, function() {
					$mdl.lockButtons = false;
					toastr.error('Failed to retrieve Spare Part list.', '');
					return null;
				});
		};

		/* ******************************************************** */

		$mdl.confirmModal = function() {

			if($mdl.modalForm.$valid)
				$uibModalInstance.close($mdl.item);
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ******************************************************** */

		// Initialize
		if(item.mode==1) {
			$mdl.activeTab = 0;
			$mdl.item.equipmentId = null;
			$mdl.item.partId = null;
			$mdl.item.loanItemStateId = null;
			$mdl.item.itemDescription = "";
			$mdl.item.price = 0;
			$mdl.item.quantity = 0;
			$mdl.item.quantityReturn = 0;
			$mdl.item.serialNo = "";
			$mdl.item.status = "ON LOAN";

		} else {

			if($mdl.item.equipmentId!='' && $mdl.item.equipmentId!=null){
				$mdl.activeTab = 0;
				$mdl.loadEquipmentList($mdl.item.equipmentId, true);

			} else if($mdl.item.partId!='' && $mdl.item.partId!=null){
				$mdl.activeTab = 1;
				$mdl.loadSparePartList($mdl.item.partId, true);
			}

			$mdl.statusList.forEach(function(s) {
				if(s.id==$mdl.item.loanItemStateId) {
					$mdl.selectedStatus = s;
				}
			});
		}

		$mdl.loadStorageList();
	};

	// Upload Media Modal Controller
	function WorkOrderMediaModalCtrl($uibModalInstance, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.item = {};
		$mdl.workId = item.workId;
		$mdl.serverMode = item.serverMode;
		$mdl.rootUrl = ($mdl.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		$mdl.youtubeUrl = "";
		$mdl.lockButton = false;
		$mdl.uploadProgess = 0;
		$mdl.uploadProgessTotal = 0;
		$mdl.uploadProgessPercent = 0;
		$mdl.activeTab = 0;

		var mediaLocation = "";
		var mediaExtension = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		// Initialize
		if(item.mode==1) {
			$mdl.item.mediaType = "";
			$mdl.item.mediaFile = "";
			$mdl.item.remarks = "";
			$mdl.activeTab = 0;
		}

		// Add Media
		$mdl.addMedia = function(obj) {
			$mdl.lockButton = true;

			var element = {
				workId: $mdl.workId,
				remarks: obj.remarks,
			};

			mediaLocation = "";
			mediaExtension = "";
			azureStorageUrl = "";
			localStorageUrl = "";
			var newFilename = UtilSvc.generateGuid() + ".";

			if($mdl.serverMode==1 && obj.mediaToUpload) {

				var extArray = obj.mediaToUpload.name.split(".");
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = Auth.getCompanyId() + "/workorder/" + newFilename + mediaExtension;
				element.mediaType = $mdl.getMediaType(mediaExtension);

			} else if($mdl.serverMode==0 && obj.mediaToUpload) {

				var extArray = obj.mediaToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = "workorder/" + newFilename + mediaExtension;

			}
			element.mediaFile = mediaLocation;

			HttpSvc.post('serviceworkmedias', element, Auth.getTokenId(), false)
				.then(function(result) {

					if($mdl.serverMode==1 && obj.mediaToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + mediaLocation + result.azureSasToken;
						$mdl.uploadMedia(obj.mediaToUpload, result.id);

					} else if($mdl.serverMode==0 && obj.mediaToUpload) {
						localStorageUrl = RmsApi.URL + "upload/workorder/" + result.id;
						$mdl.uploadMedia(obj.mediaToUpload, result.id);

					} else {
						$uibModalInstance.close($mdl.item);
					}
					//vm.sop.sopSteps.push(element);
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					$mdl.lockButton = false;
					$mdl.workOrderMediaForm.$setPristine();
				});
		};

		// ********************************************************

        var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();

		// Upload Image to Azure Blob Storage
		$mdl.uploadMedia = function (_fileToUpload, _workMediaId) {

			/* Initialize variables */
			/* ************************************* */
			handleFileSelect(_fileToUpload);
			/* ************************************* */

			/* Initialize File Reader */
			/* ************************************* */
			fileReader = new FileReader();
			/* ************************************* */

			if($mdl.serverMode==0) {	// Local Server

				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (resp) {
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});

			} else if($mdl.serverMode==1) { // Azure Server

				/* Upload File (First Block) */
				/* ************************************* */
				uploadFileInBlocks(_fileToUpload, azureStorageUrl, _workMediaId);

				fileReader.onload = function(e) {
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];

						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,
						}).then(function(response) {
							if (response.status==201) {
								uploadFileInBlocks(_fileToUpload, azureStorageUrl, _workMediaId);
							} else {
								$mdl.lockButton = false;
								$mdl.workOrderMediaForm.$setPristine();
							}
						}, null, function(evt) {
							$mdl.uploadProgessTotal = _fileToUpload.size;
							$mdl.uploadProgess = $mdl.uploadProgessTotal - totalBytesRemaining;
							$mdl.uploadProgessPercent = Math.min(100, parseInt(100.0 * $mdl.uploadProgess / $mdl.uploadProgessTotal).toFixed(2));

							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};

		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;

            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }

        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl, _workMediaId) {
            if (totalBytesRemaining > 0) {
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);

                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);

				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl, _workMediaId);
            }
        }

        function commitBlockList(_fileToUpload, _azureStorageUrl, _workMediaId) {
            var uri = _azureStorageUrl + '&comp=blocklist';
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';

			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,

			}).then(function(response) {
				HttpSvc.put('mediaconversion/ready/workorder/' + _workMediaId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Media uploaded successfully.");
						$uibModalInstance.close($mdl.item);
					}, function(error) {
					});
			});
        }

        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }

		// ********************************************************

		//Set Upload Media
		$mdl.setUploadMedia = function(mediaFile) {
			$mdl.item.mediaToUpload = mediaFile;
		}

		// Confirm Action
		$mdl.confirmModal = function() {
			if($mdl.workOrderMediaForm.$valid) {
				if(item.mode==1) {
					$mdl.addMedia($mdl.item);
				}
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Get Content Type
		$mdl.getMediaType = function(mediaExtension) {
			mediaExtension = mediaExtension.toLowerCase();

			if(mediaExtension=='jpg' || mediaExtension=='jpeg') {
				return "image";
			} else if(mediaExtension=='png') {
				return "image";
			} else if(mediaExtension=='gif') {
				return "image";
			} else if(mediaExtension=='mp4') {
				return "video";
			} else if(mediaExtension=='3gp') {
				return "video";
			} else if(mediaExtension=='mov') {
				return "video";
			}
		};
	};

    /** @ngInject */
    function WorkOrderSopModalCtrl($uibModalInstance, Auth, RmsApi, HttpSvc, item, toastr) {
		var $mdl = this;

		$mdl.sopList = item.sopList;
		$mdl.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);

		$mdl.initData = function()
		{
			$mdl.sopList.forEach(function(r) {
				if(r.thumbnail!=null && r.thumbnail!='') {
					r.thumbnail = $mdl.rootUrl + r.thumbnail;
				}
				if(r.imageLocation!=null && r.imageLocation!='') {
					r.imageLocation = $mdl.rootUrl + r.imageLocation;
				}
			});
		}

		/* ********************************************************* */

		// Cancel Action
		$mdl.cancelModal = function() {
		  	$uibModalInstance.dismiss('cancel');
		};

		$mdl.initData();
	};
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.settings.iprules.controller', [])
        .controller('IPRuleMainCtrl', IPRuleMainCtrl)
        .controller('IPRuleCreateCtrl', IPRuleCreateCtrl)
        .controller('IPRuleUpdateCtrl', IPRuleUpdateCtrl);

    /** @ngInject */
    function IPRuleMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.ipruleDataFull = [];
		vm.ipruleData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.ipruleDataFull, tableState.search.predicateObject) : vm.ipruleDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.ipruleData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.ipruleDataFull.length <= 0) {				
				HttpSvc.get('companyiprules/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.ipruleDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteIpRule = function(ipRuleId, ipRuleName) {
			var params = {};
			HttpSvc.delete('companyiprules/' + ipRuleId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('companyiprules/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.ipruleDataFull = result;
							
							toastr.success('The IP Rule [' + ipRuleName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the IP Rule [' + ipRuleName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function IPRuleCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.isLockButtons = false;
		vm.mode = 1;
		vm.iprule = {};
		vm.currentIp = "0.0.0.0";
		vm.isLockButtons = false;

		vm.getCurrentIp = function() {
			vm.isLockButtons = true;
			
			HttpSvc.get('misc/getclientip', {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.currentIp = result.ip;
					vm.isLockButtons = false;
				}, function() {
					vm.isLockButtons = false;
					toastr.error('Failed to get current IP address.', Auth.translate('ERROR'))
					//$state.go('settings.iprules.list');
					return;
				});
		}

		vm.copyToIp1 = function() {
			var ipSegments = vm.currentIp.split(".");
			vm.iprule.fromIp1 = parseInt(ipSegments[0]);
			vm.iprule.fromIp2 = parseInt(ipSegments[1]);
			vm.iprule.fromIp3 = parseInt(ipSegments[2]);
			vm.iprule.fromIp4 = parseInt(ipSegments[3]);
		}

		vm.copyToIp2 = function() {
			var ipSegments = vm.currentIp.split(".");
			vm.iprule.toIp1 = parseInt(ipSegments[0]);
			vm.iprule.toIp2 = parseInt(ipSegments[1]);
			vm.iprule.toIp3 = parseInt(ipSegments[2]);
			vm.iprule.toIp4 = parseInt(ipSegments[3]);
		}

		// Form Submission
		vm.submit = function() {
			vm.isLockButtons = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');				
				vm.isLockButtons = false;
			} else {
				HttpSvc.post('companyiprules', vm.iprule, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('IP Rule has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('settings.iprules.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');						
						vm.isLockButtons = false;
					});
			}
		}
		
		// Call Action
		vm.getCurrentIp();
	}
	
	/** @ngInject */
    function IPRuleUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.iprule = {};
		vm.currentIp = "0.0.0.0";
		vm.isLockButtons = true;

		vm.getCurrentIp = function() {
			vm.isLockButtons = true;

			HttpSvc.get('misc/getclientip', {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.currentIp = result.ip;
					vm.isLockButtons = false;
				}, function() {
					vm.isLockButtons = false;
					toastr.error('Failed to get current IP address.', Auth.translate('ERROR'))
					//$state.go('settings.iprules.list');
					return;
				});
		}
						
		// Load IP Rule
		vm.loadIPRule = function() {	
			vm.isLockButtons = true;

			var params = { id: $stateParams.id };
			HttpSvc.get('companyiprules/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.iprule = result;	
					vm.isLockButtons = false;
				}, function() {
					toastr.error('Failed to load selected IP Rule.', Auth.translate('ERROR'))
					$state.go('settings.iprules.list');
					return;
				});		
		};

		vm.copyToIp1 = function() {
			var ipSegments = vm.currentIp.split(".");
			vm.iprule.fromIp1 = parseInt(ipSegments[0]);
			vm.iprule.fromIp2 = parseInt(ipSegments[1]);
			vm.iprule.fromIp3 = parseInt(ipSegments[2]);
			vm.iprule.fromIp4 = parseInt(ipSegments[3]);
		}

		vm.copyToIp2 = function() {
			var ipSegments = vm.currentIp.split(".");
			vm.iprule.toIp1 = parseInt(ipSegments[0]);
			vm.iprule.toIp2 = parseInt(ipSegments[1]);
			vm.iprule.toIp3 = parseInt(ipSegments[2]);
			vm.iprule.toIp4 = parseInt(ipSegments[3]);
		}
		
		// Form Submission
		vm.submit = function() {
			vm.isLockButtons = true;

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.isLockButtons = false;
			} else {
				HttpSvc.put('companyiprules/' + $stateParams.id, vm.iprule, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('IP Rule has been updated successfully.', Auth.translate('SUCCESS'));
						//$state.go('settings.iprules.list');
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isLockButtons = true;
					});
			}
		}
		
		// Call Actions
		vm.getCurrentIp();
		vm.loadIPRule();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.settings.labeltemplates.controller', [])
        .controller('LabelTemplateMainCtrl', LabelTemplateMainCtrl)
        .controller('LabelTemplateCreateCtrl', LabelTemplateCreateCtrl)
        .controller('LabelTemplateUpdateCtrl', LabelTemplateUpdateCtrl)
        .controller('LabelTemplateCloneModalCtrl', LabelTemplateCloneModalCtrl);

    /** @ngInject */
    function LabelTemplateMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 20;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.templateDataFull = [];
		vm.templateData = [];

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.templateDataFull, tableState.search.predicateObject) : vm.templateDataFull;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.templateData = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;

			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.templateDataFull.length <= 0) {
				HttpSvc.get('companylabeltemplateHeaders/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.numOfRecord = result.length;
						vm.templateDataFull = result;
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		vm.cloneTemplate = function(templateId) {
			vm.isLoading = true;

			HttpSvc.post('companylabeltemplateHeaders/clone/' + templateId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.isLoading = false;
					$state.reload();
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to clone the Template.', '');
					return null;
			});
		};

		vm.deleteTemplate = function(templateId, templateName) {
			var params = {};
			HttpSvc.put('companylabeltemplateHeaders/setisdeleted/' + templateId + '/1', params, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('The template [' + templateName + '] has been deleted.', 'Delete Success');
					$state.reload();
				}, function() {
					// Failed
					toastr.error('Failed to delete the template [' + templateName + '].', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
    function LabelTemplateCreateCtrl($scope, $state, $location, Auth, HttpSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.mode = 1;
		vm.template = {};
		vm.template.labelWidth = 80;
		vm.template.labelHeight = 50;
		vm.template.companyLabelTemplateFields = [];
		vm.template.labelType = "ITEM";
		vm.isLockButton = false;

		vm.variables = LabelTemplateVariables(Auth);
		vm.selectedVariable = {};

		vm.objTypes = GetObjectTypes();
		vm.boolOptions = GetBooleanTypes();
		vm.orientOptions = GetOrientationTypes();

		/* **************************************************************** */

		vm.init = function() {
			vm.getVariable(vm.template.labelType);
		};

		// Remove Element
		vm.removeLabelElement = function(index) {
			vm.template.companyLabelTemplateFields.splice(index, 1);
		};

		// Add Element
		vm.addLabelElement = function() {
			var element = {
				objType: "text",
				objId: "label999",
				pointX: "0",
				pointY: "0",
				width: "0",
				height: "0",
				fontSize: "0",
				isBold: "0",
				isItalic: "0",
				isUnderline: "0",
				orientation: "0",
				value: "",
			};
			vm.template.companyLabelTemplateFields.push(element);
			vm.tableForm.$show();
		};

		// Save Label Elements
		vm.saveLabelElement = function() {
			vm.tableForm.$submit();

			// var results = [];
			// if(vm.template.companyLabelTemplateFields.length > 0) {
			// 	try {
			// 		vm.template.companyLabelTemplateFields.forEach(function(n) {
			// 			if(n.objType!='' && n.objType!=null) {
			// 				results.push(n);
			// 			}
			// 		});
			// 		vm.template.companyLabelTemplateFields = angular.toJson(results);
			// 	} catch(err) {
			// 		vm.template.companyLabelTemplateFields = "";
			// 	}
			// } else {
			// 	vm.template.companyLabelTemplateFields = "";
			// }
		}

		vm.updateCanvas = function() {
			vm.tableForm.$submit();
			vm.tableForm.$show();
		}

		/* **************************************************************** */

		vm.labelTypeChanged = function() {
			vm.getVariable(vm.template.labelType);
		}

		vm.getVariable = function(labelType) {
			vm.variables.forEach(function(v) {
				if(v.type==labelType) {
					vm.selectedVariable = v;
				}
			});
		}

		vm.convertToScreenReso = function(mmValue) {
			return mmValue * 1;
		}

		vm.getMMfromDpi = function(dpiValue) {
			return dpiValue / 7.992126;
		}

		/* **************************************************************** */

		// Form Submission
		vm.submit = function() {
			vm.isLockButton = true;

			if(vm.dataForm.$invalid) {
				vm.isLockButton = false;
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.saveLabelElement();

				HttpSvc.post('companylabeltemplateHeaders', vm.template, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('New Label Template has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('settings.labeltemplates.update', {'id': result.id });
					}, function(error) {
						vm.isLockButton = false;
						vm.tableForm.$show();
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Action
		vm.init();
	}

	/** @ngInject */
    function LabelTemplateUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;
		vm.mode = 2;
		vm.template = {};
		vm.companyList = [];
		vm.isLockButton = false;
		vm.variables = LabelTemplateVariables(Auth);
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.canCloneRecipe = Auth.canCloneRecipe();
		vm.selectedVariable = {};

		vm.objTypes = GetObjectTypes();
		vm.boolOptions = GetBooleanTypes();
		vm.orientOptions = GetOrientationTypes();

		/* **************************************************************** */

		// Load Company List
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.companyList = result;
					vm.loadLabelTemplate();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Company with Category list.', '');
					window.history.back();
					return null;
				});
		}

		// Open Clone Recipe Modal Dialog
		vm.showCloneTemplateModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'cloneTemplateModal.html',
				controller: 'LabelTemplateCloneModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							companies: vm.companyList,
							templateId: $stateParams.id
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		};

		/* **************************************************************** */

		// Load LabelTemplate
		vm.loadLabelTemplate = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('companylabeltemplateHeaders/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.template = result;

					if(vm.template.companyLabelTemplateFields==null || vm.template.companyLabelTemplateFields=='') {
						vm.template.companyLabelTemplateFields = [];
					} else {
						vm.template.companyLabelTemplateFields = $filter('orderBy')(vm.template.companyLabelTemplateFields, ['objType', 'id']);
					}

					vm.tableForm.$show();
					vm.getVariable(vm.template.labelType);

					// vm.template.companyLabelTemplateFields.forEach(function(s) {
					// 	// Grid Snapping
					// 	vm.bindInteractJS(s.objId);
					// });
				}, function() {
					toastr.error('Failed to load selected Label Template.', Auth.translate('ERROR'))
					$state.go('settings.labeltemplates.list');
					return;
				});
		};

		// Remove Element
		vm.removeLabelElement = function(index) {
			vm.template.companyLabelTemplateFields.splice(index, 1);
		};

		// Add Element
		vm.addLabelElement = function() {
			var element = {
				objType: "text",
				headerId: vm.template.id,
				objId: "label999",
				pointX: "0",
				pointY: "0",
				width: "0",
				height: "0",
				fontSize: "0",
				isBold: "0",
				isItalic: "0",
				isUnderline: "0",
				orientation: "0",
				value: "",
			};
			vm.template.companyLabelTemplateFields.push(element);
			vm.tableForm.$show();
		};

		// Save Label Elements
		vm.saveLabelElement = function() {
			vm.tableForm.$submit();

			// var results = [];
			// if(vm.template.companyLabelTemplateFields.length > 0) {
			// 	try {
			// 		vm.template.companyLabelTemplateFields.forEach(function(n) {
			// 			if(n.objType!='' && n.objType!=null) {
			// 				results.push(n);
			// 			}
			// 		});
			// 		vm.template.companyLabelTemplateFields = angular.toJson(results);
			// 	} catch(err) {
			// 		alert(err);
			// 		//vm.template.companyLabelTemplateFields = "[]";
			// 	}
			// } else {
			// 	vm.template.companyLabelTemplateFields = "";
			// }
		}

		vm.updateCanvas = function() {
			vm.tableForm.$submit();
			vm.tableForm.$show();

			// vm.template.companyLabelTemplateFields.forEach(function(s) {
			// 	// Grid Snapping
			// 	vm.bindInteractJS(s.objId);
			// });
		}

		// Send Test Print
		vm.testPrint = function() {
			if(vm.template.labelType=='ITEM') {
				HttpSvc.post('inventory/items/label/testprint/create', {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Test print sent.", Auth.translate('SUCCESS'));
					}, function(error) {
						toastr.error(error, 'Printing Failed');
					});

			} else if(vm.template.labelType=='SEMIFG') {
				HttpSvc.post('inventory/semifgs/label/testprint/create', {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Test print sent.", Auth.translate('SUCCESS'));
					}, function(error) {
						toastr.error(error, 'Printing Failed');
					});


			} else if(vm.template.labelType=='PRODUCT') {
				HttpSvc.post('inventory/products/label/testprint/create', {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Test print sent.", Auth.translate('SUCCESS'));
					}, function(error) {
						toastr.error(error, 'Printing Failed');
					});

			} else if(vm.template.labelType=='WARRANTY') {
				HttpSvc.post('services/warranties/label/testprint/create', {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Test print sent.", Auth.translate('SUCCESS'));
					}, function(error) {
						toastr.error(error, 'Printing Failed');
					});

			} else if(vm.template.labelType=='SERVICE') {
				HttpSvc.post('serviceworks/label/testprint/create', {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Test print sent.", Auth.translate('SUCCESS'));
					}, function(error) {
						toastr.error(error, 'Printing Failed');
					});

			} else if(vm.template.labelType=='ASSET') {
				HttpSvc.post('assets/label/testprint/create', {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Test print sent.", Auth.translate('SUCCESS'));
					}, function(error) {
						toastr.error(error, 'Printing Failed');
					});

			} else if(vm.template.labelType=='CONFERENCE') {
				HttpSvc.post('conferenceattendees/testprint', {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Test print sent.", Auth.translate('SUCCESS'));
					}, function(error) {
						toastr.error(error, 'Printing Failed');
					});

			}
		}

		/* **************************************************************** */

		vm.labelTypeChanged = function() {
			vm.getVariable(vm.template.labelType);
		}

		vm.getVariable = function(labelType) {
			vm.variables.forEach(function(v) {
				if(v.type==labelType) {
					vm.selectedVariable = v;
				}
			});
		}

		vm.bindInteractJS = function(objectIdText) {

			var element = document.getElementById(objectIdText);
			interact(element)
				.draggable({
					modifiers: [
						interact.modifiers.snap({
							targets: [
							interact.createSnapGrid({ x: 10, y: 10 })
							],
							range: Infinity,
							relativePoints: [ { x: 0, y: 0 } ]
						}),
						interact.modifiers.restrict({
							restriction: element.parentNode,
							elementRect: { top: 0, left: 0, bottom: 1, right: 1 },
							endOnly: true
						})
					],
					inertia: true
				})
				.on('dragmove', function (event) {
					var obj = null;
					var items = vm.template.companyLabelTemplateFields;

					for (var i=0; i<items.length; i++)
					{
						if (items[i].objId == objId)
							obj = items[i];
					}

					if(obj!=null) {
						obj.pointX += event.dx;
						obj.pointY += event.dy;

						obj.pointX = Math.ceil(obj.pointX);
						obj.pointY = Math.ceil(obj.pointY);

						event.target.style.webkitTransform =
						event.target.style.transform =
							'translate(' + obj.pointX + 'px, ' + obj.pointY + 'px)';
					}
				});
		}

		vm.convertToScreenReso = function(mmValue) {
			return mmValue * 1;
		}

		vm.getMMfromDpi = function(dpiValue) {
			return dpiValue / 7.992126;
		}

		/* **************************************************************** */

		// Form Submission
		vm.submit = function() {
			vm.isLockButton = true;

			if(vm.dataForm.$invalid) {
				vm.isLockButton = false;
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.saveLabelElement();

				HttpSvc.put('companylabeltemplateHeaders/' + $stateParams.id, vm.template, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Label Template has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						vm.isLockButton = false;
						vm.tableForm.$show();
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Actions
		vm.loadCompanyList();
	}

	// Clone Recipe Modal Controller
	function LabelTemplateCloneModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.companies = item.companies;
		$mdl.templateId = item.templateId;
		$mdl.selectedCompany = {};
		$mdl.selectedCategory = {};
		$mdl.lockButtons = false;

		/* ******************************************************** */

		$mdl.confirmModal = function() {
			if($mdl.cloneForm.$valid) {
				$mdl.lockButtons = true;

				HttpSvc.post("companylabeltemplateHeaders/clone/" + $mdl.templateId + "/to/" + $mdl.selectedCompany.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Label Template is successfully cloned to <b>" + $mdl.selectedCompany.name + "</b>");
						$uibModalInstance.close();
					}, function(error) {
						$mdl.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	/** @ngInject */
	function LabelTemplateVariables(Auth) {
		var hasConfPerm = Auth.hasCompanyFeature('conference');
		var hasDurianPerm = Auth.hasCompanyFeature('durianops');

		var variables = [
			{
				type: "ITEM",
				variableList: [
					{ name: "[ITEM_CODE]", description: "Item Code / SKU" },
					{ name: "[ITEM_NAME]", description: "Item Name / Description" },
					{ name: "[CUSTOMER_NAME]", description: "Customer Name" },
					{ name: "[SUPPLIER_NAME]", description: "Supplier Name" },
					{ name: "[WEIGHT]", description: "Item Weight" },
					{ name: "[UOM]", description: "UOM of the Item" },
					{ name: "[GRN_NO]", description: "GRN Number" },
					{ name: "[GRN_DATE]", description: "GRN Date" },
					{ name: "[EXPIRY_DATE]", description: "Item's Expiry Date" },
					{ name: "[SERIAL_NO]", description: "Serial No. of the Label" },
					{ name: "[CUSTOM_TEXT_01]", description: "Custom Text #1" },
					{ name: "[CUSTOM_TEXT_02]", description: "Custom Text #2" },
					{ name: "[CUSTOM_TEXT_03]", description: "Custom Text #3" },
					{ name: "[CUSTOM_TEXT_04]", description: "Custom Text #4" },
					{ name: "[CUSTOM_TEXT_05]", description: "Custom Text #5" },
					{ name: "[CUSTOM_TEXT_06]", description: "Custom Text #6" },
					{ name: "[CUSTOM_TEXT_07]", description: "Custom Text #7" },
					{ name: "[CUSTOM_TEXT_08]", description: "Custom Text #8" }
				]
			},
			{
				type: "PRODUCT",
				variableList: [
					{ name: "[PRODUCT_CODE]", description: "Product Code" },
					{ name: "[PRODUCT_NAME]", description: "Product Name / Description" },
					{ name: "[CUSTOMER_NAME]", description: "Customer Name" },
					{ name: "[INGREDIENT_LINE1]", description: "Ingredient Line #1" },
					{ name: "[INGREDIENT_LINE2]", description: "Ingredient Line #2" },
					{ name: "[INGREDIENT_LINE3]", description: "Ingredient Line #3" },
					{ name: "[INGREDIENT_LINE4]", description: "Ingredient Line #4" },
					{ name: "[WEIGHT]", description: "Product Weight" },
					{ name: "[UOM]", description: "UOM of the Product" },
					{ name: "[SHELF_LIFE]", description: "Shelf Life" },
					{ name: "[BARCODE]", description: "Product Barcode " },
					{ name: "[MANUFACTURE_DATE]", description: "Manufacture Date" },
					{ name: "[EXPIRY_DATE]", description: "Expiry Date" },
					{ name: "[SERIAL_NO]", description: "Serial No. of the Label" },
					{ name: "[THAW_TIME]", description: "Thaw Time" },
					{ name: "[RETHERMALIZE_1]", description: "Rethermalization Line #1" },
					{ name: "[RETHERMALIZE_2]", description: "Rethermalization Line #2" },
					{ name: "[HALAL_CERT_1]", description: "HALAL Certificate Number #1" },
					{ name: "[HALAL_CERT_2]", description: "HALAL Certificate Number #2" },
					{ name: "[BATCH_NO]", description: "Production Batch Number" },
					{ name: "[STORAGE]", description: "Storage Instruction" },
					{ name: "[CUSTOM_TEXT_01]", description: "Custom Text #1" },
					{ name: "[CUSTOM_TEXT_02]", description: "Custom Text #2" },
					{ name: "[CUSTOM_TEXT_03]", description: "Custom Text #3" },
					{ name: "[CUSTOM_TEXT_04]", description: "Custom Text #4" },
					{ name: "[NO_OF_LABEL]", description: "Number of Label" },
					{ name: "[NO_OF_LABEL_UOM]", description: "Number of Label's UOM" },
					{ name: "", description: "" },
				]
			},
			{
				type: "SEMIFG",
				variableList: [
					{ name: "[PRODUCT_CODE]", description: "Product Code" },
					{ name: "[PRODUCT_NAME]", description: "Product Name / Description" },
					{ name: "[CUSTOMER_NAME]", description: "Customer Name" },
					{ name: "[INGREDIENT_LINE1]", description: "Ingredient Line #1" },
					{ name: "[INGREDIENT_LINE2]", description: "Ingredient Line #2" },
					{ name: "[INGREDIENT_LINE3]", description: "Ingredient Line #3" },
					{ name: "[INGREDIENT_LINE4]", description: "Ingredient Line #4" },
					{ name: "[WEIGHT]", description: "Product Weight" },
					{ name: "[UOM]", description: "UOM of the Product" },
					{ name: "[SHELF_LIFE]", description: "Shelf Life" },
					{ name: "[BARCODE]", description: "Product Barcode " },
					{ name: "[MANUFACTURE_DATE]", description: "Manufacture Date" },
					{ name: "[EXPIRY_DATE]", description: "Expiry Date" },
					{ name: "[SERIAL_NO]", description: "Serial No. of the Label" },
					{ name: "[THAW_TIME]", description: "Thaw Time" },
					{ name: "[RETHERMALIZE_1]", description: "Rethermalization Line #1" },
					{ name: "[RETHERMALIZE_2]", description: "Rethermalization Line #2" },
					{ name: "[HALAL_CERT_1]", description: "HALAL Certificate Number #1" },
					{ name: "[HALAL_CERT_2]", description: "HALAL Certificate Number #2" },
					{ name: "[BATCH_NO]", description: "Production Batch Number" },
					{ name: "[STORAGE]", description: "Storage Instruction" },
					{ name: "[CUSTOM_TEXT_01]", description: "Custom Text #1" },
					{ name: "[CUSTOM_TEXT_02]", description: "Custom Text #2" },
					{ name: "[CUSTOM_TEXT_03]", description: "Custom Text #3" },
					{ name: "[CUSTOM_TEXT_04]", description: "Custom Text #4" },
					{ name: "[NO_OF_LABEL]", description: "Number of Label" },
					{ name: "[NO_OF_LABEL_UOM]", description: "Number of Label's UOM" },
					{ name: "", description: "" },
				]
			},
			{
				type: "WARRANTY",
				variableList: [
					{ name: "[WARRANTY_ID]", description: "Unique ID of the Warranty (for QR Code)" },
					{ name: "[WARRANTY_NO]", description: "Warranty Number" },
					{ name: "[WARRANTY_FROM]", description: "Date of the Warranty Started" },
					{ name: "[WARRANTY_TO]", description: "Date of the Warranty Ended" },
					{ name: "[INVOICE_NO]", description: "Invoice Number of the Customer Purchase" },
					{ name: "[SERIAL_NO]", description: "Serial No. of the Equipment" },
					{ name: "[EQUIPMENT_NAME]", description: "Equipment Name / Description" },
					{ name: "[EQUIPMENT_BRAND]", description: "Equipment Brand" },
					{ name: "[EQUIPMENT_MODEL]", description: "Equipment Model" },
					{ name: "[EQUIPMENT_SERIAL]", description: "Equipment Serial No." },
				]
			},
			{
				type: "SERVICE",
				variableList: [
					{ name: "[WORK_ID]", description: "Unique ID of the Work Order (for QR Code)" },
					{ name: "[WORK_NO]", description: "Work Order Number" },
					{ name: "[WORK_DATE]", description: "Creation Date of the Work Order Document" },
					{ name: "[WORK_REMARKS]", description: "Remarks / Comment of the Work Order" },
					{ name: "[CUSTOMER_NAME]", description: "Customer Name" },
					{ name: "[CUSTOMER_SITE]", description: "Customer Site Location" },
					{ name: "[SERIAL_NO]", description: "Serial No. of the Equipment" },
					{ name: "[EQUIPMENT_NAME]", description: "Equipment Name / Description" },
					{ name: "[EQUIPMENT_BRAND]", description: "Equipment Brand" },
					{ name: "[EQUIPMENT_MODEL]", description: "Equipment Model" },
				]
			},
			{
				type: "ASSET",
				variableList: [
					{ name: "[ASSET_ID]", description: "Unique ID of the Asset (for QR Code)" },
					{ name: "[ASSET_CODE]", description: "Asset Code" },
					{ name: "[ASSET_NAME]", description: "Asset Name" },
					{ name: "[ASSET_DESC]", description: "Asset Description" },
					{ name: "[SERIAL_NO]", description: "Serial No. of the Label" },
					{ name: "[WARRANTY_FROM]", description: "Date of the Warranty Started" },
					{ name: "[WARRANTY_TO]", description: "Date of the Warranty Ended" },
					{ name: "[SUPPLIER_CODE]", description: "Supplier Code" },
					{ name: "[SUPPLIER_NAME]", description: "Supplier Name / Description" },
				]
			}
		];

		if(hasDurianPerm)
		{
			variables.push({
				type: "COMBIWEIGHER_IN",
				variableList: [
					{ name: "[OBJECT_NO]", description: "Object Running Number " },
					{ name: "[SORTER_NO]", description: "Sorter Number" },
					{ name: "[WEIGHT]", description: "Weight (KG)" },
				]
			});
		}

		if(hasConfPerm)
		{
			variables.push({
				type: "CONFERENCE",
				variableList: [
					{ name: "[ATTENDEE_ID]", description: "Attendee ID" },
					{ name: "[FULL_NAME]", description: "Attendee Full Name" },
					{ name: "[SHORT_CODE]", description: "Unique Short Code" },
					{ name: "[SOURCE]", description: "Source of Attendee" },
				]
			});
		}

		return variables;
	}

	function GetObjectTypes() {
		return [
			// {value: 'box',     text: 'box'},
			{value: 'image',   text: 'Image'},
			{value: 'text',    text: 'Text'},
			{value: 'qrcode',  text: 'QR Code'},
			{value: 'barcode_auto_128', text: 'Code128'},
			{value: 'barcode_std_39', text: 'Code39'},
			{value: 'barcode_std_93', text: 'Code93'},
			{value: 'barcode_ean_13', text: 'EAN13'},
			{value: 'barcode_ean_128', text: 'EAN128'},
		];
	}

	function GetBooleanTypes() {
		return [
			{value: 1, text: '✔'},
			{value: 0, text: '✖'},
		];
	}

	function GetOrientationTypes() {
		return [
			{value: 1, text: 'L'},
			{value: 0, text: 'P'},
		];
	}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.settings.usergroups.controller', [])
        .controller('UsergroupMainCtrl', UsergroupMainCtrl)
        .controller('UsergroupCreateCtrl', UsergroupCreateCtrl)
        .controller('UsergroupUpdateCtrl', UsergroupUpdateCtrl)
        .controller('UsergroupLoanStatusModalCtrl', UsergroupLoanStatusModalCtrl)
        .controller('UsergroupLoanItemStatusModalCtrl', UsergroupLoanItemStatusModalCtrl)
        .controller('UsergroupWorkOrderStatusModalCtrl', UsergroupWorkOrderStatusModalCtrl);

    /** @ngInject */
    function UsergroupMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.usergroupDataFull = [];
		vm.usergroupData = [];
		vm.isLoading = false;
		vm.hasFranchiseAccess = Auth.hasCompanyFeature('franchise');

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.usergroupDataFull, tableState.search.predicateObject) : vm.usergroupDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.usergroupData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.usergroupDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('userGroups/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isLoading = false;
						vm.usergroupDataFull = [];
						result.forEach(function(u){
							if(u.isSuperAdmin) {
								if(Auth.isSuperAdmin()){
									vm.usergroupDataFull.push(u);
								}
							} else {
								vm.usergroupDataFull.push(u);
							}
						});
						vm.numOfRecord = vm.usergroupDataFull.length;
						
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteUsergroup = function(ugId, ugName) {
			var params = {};
			HttpSvc.delete('userGroups/' + ugId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('userGroups/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
						
							vm.usergroupDataFull = [];
							result.forEach(function(u){
								if(u.isSuperAdmin) {
									if(Auth.isSuperAdmin()){
										vm.usergroupDataFull.push(u);
									}
								} else {
									vm.usergroupDataFull.push(u);
								}
							});
							vm.numOfRecord = vm.usergroupDataFull.length;
							
							toastr.success('The usergroup [' + ugName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the usergroup [' + ugName + '].', 'Delete Failed');
					return null;
			});
		};		
	
		vm.cloneUsergroup = function(id, name) {			
			HttpSvc.post('usergroups/clone/' + id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Usergroup [' + name + '] has been cloned successfully.', 'COMPLETED');
					$state.go('settings.usergroups.update', {'id': result.id });
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}	
	};
	
	/** @ngInject */
    function UsergroupCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 1;
		vm.usergroup = {};
		vm.usergroup.userGroupWorkStates = [];
		vm.usergroup.userGroupLoanStates = [];
		vm.usergroup.userGroupLoanItemStates = [];
		vm.usergroups = [];	
		vm.features = [];
		vm.originalFeatures = [];
		vm.limiteds = [];
		vm.selectedLimited = null;
		vm.parentUG = {};
		vm.isUserSuperAdmin = false;
		vm.hasDurianOpsAccess = Auth.hasCompanyFeature('durianops');
		vm.hasWorkOrderAccess = Auth.hasCompanyFeature('services.workorders');
		vm.hasLoanRequestAccess = Auth.hasCompanyFeature('services.loanrequests');
		vm.hasCaseMgmtAccess = Auth.hasCompanyFeature('services.casemanagement');
		vm.hasFranchiseAccess = Auth.hasCompanyFeature('franchise');
		
		// Init Data
		vm.initData = function() {
			vm.isUserSuperAdmin = Auth.isSuperAdmin();
			vm.loadUsergroups();
		}
		
		// Load Usergroups
		vm.loadUsergroups = function() {
			var params = {};
			HttpSvc.get('userGroups/list', params, Auth.getTokenId(), true)
					.then(function(result) {		
						result.forEach(function(ug){
							if(ug.isSuperAdmin) {
								if(Auth.isSuperAdmin()){
									vm.usergroups.push({ id: ug.id, name: ug.name });
								}
							} else {
								vm.usergroups.push(ug);
							}
						});
						vm.loadFeatures();
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
		}
				
		// Load Features
		vm.loadFeatures = function() {
			var params = {};
			
			HttpSvc.get('featuresV2/company/' + Auth.getCompanyId(), params, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (f) {
						var f = { 
							featureId: f.id, 
							name: f.name,
							isParent: f.isParent,
							canAccess: false,
							canCreate: false,
							canRead: false,
							canUpdate: false,
							canDelete: false,
							canExport: false,
							canApprove: false
						};
						vm.features.push(f);
						vm.originalFeatures.push(f);
					});	

					vm.loadLimitedUserTypes();
				}, function() {
					vm.features = [];
					vm.originalFeatures = [];
				});
		};	
				
		// Load Limited Access Features
		vm.loadLimitedUserTypes = function() {
			var params = {};
			
			HttpSvc.get('serverpackages/limitedaccess/' + Auth.getCompanyId() + '/featurelist', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.limiteds = result;
				}, function() {
					vm.limiteds = [];
				});
		};	

		// Select Parent Group
		vm.selectParentUG = function(item) {
			vm.usergroup.parentId = item.id;
			vm.parentUG.selected = item;
		};	
		
		// Select All Features
		vm.selectAll = function(obj) {			
			vm.features.forEach(function(f) {
				if(obj=="ACCESS"){
					f.canAccess = true;
				} else if(obj=="VIEW"){
					f.canRead = true;
				} else if(obj=="CREATE"){
					f.canCreate = true;
				} else if(obj=="UPDATE"){
					f.canUpdate = true;
				} else if(obj=="DELETE"){
					f.canDelete = true;
				} else if(obj=="EXPORT"){
					f.canExport = true;
				} else if(obj=="APPROVE"){
					f.canApprove = true;
				}
			});
		}
		
		// Deselect All Features
		vm.deselectAll = function(obj) {		
			vm.features.forEach(function(f) {
				if(obj=="ACCESS"){
					f.canAccess = false;
				} else if(obj=="VIEW"){
					f.canRead = false;
				} else if(obj=="CREATE"){
					f.canCreate = false;
				} else if(obj=="UPDATE"){
					f.canUpdate = false;
				} else if(obj=="DELETE"){
					f.canDelete = false;
				} else if(obj=="EXPORT"){
					f.canExport = false;
				} else if(obj=="APPROVE"){
					f.canApprove = false;
				}
			});
		}
				
		// Turn On Feature
		vm.toggleFeature = function(featureId) {
			vm.features.forEach(function(f) {
				if(f.featureId==featureId) {
					f.canAccess = !f.canAccess;
					f.canCreate = f.canAccess;
					f.canRead = f.canAccess;
					f.canUpdate = f.canAccess;
					f.canDelete = f.canAccess;
					f.canExport = f.canAccess;
					f.canApprove = f.canAccess;
					return;
				}
			});
		}
		
		/* ************************************************************* */

		vm.selectedLimitedChanged = function() {
			if(!vm.usergroup.isLimitedAccess)
			{
				vm.selectedLimited = null;
				vm.usergroup.packageLimitedId = null;
				vm.features = angular.copy(vm.originalFeatures);
			}
		}

		vm.limitedUserTypeChanged = function() {
			if(vm.selectedLimited!=null)
			{
				vm.usergroup.packageLimitedId = vm.selectedLimited.id;
				vm.features = [];
				vm.selectedLimited.serverPackageLimitedAccesses.forEach(function(f) {
					var f = { 
						featureId: f.featureId, 
						name: f.name,
						isParent: f.isParent,
						canAccess: false,
						canCreate: false,
						canRead: false,
						canUpdate: false,
						canDelete: false,
						canExport: false,
						canApprove: false
					};
					vm.features.push(f);
				});
			}
			else
			{
				vm.usergroup.packageLimitedId = null;
				vm.features = angular.copy(vm.originalFeatures);
			}
		}

		/* ************************************************************* */
					
		// Open Loan Status Modal Dialog
		vm.showAddLoanStatusModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'LoanStatusModal.html',
				controller: 'UsergroupLoanStatusModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addLoanStatus(data);
				}, function () {
				});
		};				
		
		// Remove Loan Status
		vm.removeLoanStatus = function(index) {
			var result = confirm('Confirm remove this Loan Status?');
			
			if(result) {
				vm.usergroup.userGroupLoanStates.splice(index, 1);				
			}
		};

		// Add Loan Status
		vm.addLoanStatus = function(obj) {
			var element = {
				id: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.usergroup.userGroupLoanStates.some(function(el){
				if(el.id === element.id){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.usergroup.userGroupLoanStates.push(element);
		};
		
		/* ************************************************************* */
					
		// Open Loan Item Status Modal Dialog
		vm.showAddLoanItemStatusModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'LoanItemStatusModal.html',
				controller: 'UsergroupLoanItemStatusModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addLoanItemStatus(data);
				}, function () {
				});
		};				
		
		// Remove Loan Item Status
		vm.removeLoanItemStatus = function(index) {
			var result = confirm('Confirm remove this Loan Item Status?');
			
			if(result) {
				vm.usergroup.userGroupLoanItemStates.splice(index, 1);				
			}
		};

		// Add Loan Item Status
		vm.addLoanItemStatus = function(obj) {
			var element = {
				id: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.usergroup.userGroupLoanItemStates.some(function(el){
				if(el.id === element.id){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.usergroup.userGroupLoanItemStates.push(element);
		};
		
		/* ************************************************************* */
					
		// Open Work Order Status Modal Dialog
		vm.showAddWorkOrderStatusModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'WorkOrderStatusModal.html',
				controller: 'UsergroupWorkOrderStatusModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addWorkOrderStatus(data);
				}, function () {
				});
		};				
		
		// Remove Work Order Status
		vm.removeWorkOrderStatus = function(index) {
			var result = confirm('Confirm remove this Work Order Status?');
			
			if(result) {
				vm.usergroup.userGroupWorkStates.splice(index, 1);				
			}
		};

		// Add Loan Status
		vm.addWorkOrderStatus = function(obj) {
			var element = {
				workStateId: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.usergroup.userGroupWorkStates.some(function(el){
				if(el.workStateId === element.workStateId){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.usergroup.userGroupWorkStates.push(element);
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				vm.usergroup.userGroupFeatureV2 = [];
				vm.features.forEach(function(f) {
					vm.usergroup.userGroupFeatureV2.push({
						featureId: f.featureId, 
						name: f.name,
						canAccess: f.canAccess,
						canCreate: f.canCreate,
						canRead: f.canRead,
						canUpdate: f.canUpdate,
						canDelete: f.canDelete,
						canExport: f.canExport,
						canApprove: f.canApprove
					});
				});
				
				HttpSvc.post('userGroups/add', vm.usergroup, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Usergroup has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('settings.usergroups.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function UsergroupUpdateCtrl($scope, $state, $stateParams, $sce, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 2;
		vm.usergroup = {};
		vm.usergroup.userGroupWorkStates = [];
		vm.usergroup.userGroupLoanStates = [];
		vm.usergroup.userGroupLoanItemStates = [];
		vm.usergroups = [{ id: null, name: 'None' }];
		vm.features = [];
		vm.originalFeatures = [];
		vm.limiteds = [];
		vm.selectedLimited = null;
		vm.parentUG = {};
		vm.isUserSuperAdmin = false;
		vm.hasDurianOpsAccess = Auth.hasCompanyFeature('durianops');
		vm.hasWorkOrderAccess = Auth.hasCompanyFeature('services.workorders');
		vm.hasLoanRequestAccess = Auth.hasCompanyFeature('services.loanrequests');
		vm.hasCaseMgmtAccess = Auth.hasCompanyFeature('services.casemanagement');
		vm.hasFranchiseAccess = Auth.hasCompanyFeature('franchise');
		
		/* ************************************************************* */

		// Init Data
		vm.initData = function() {
			vm.isUserSuperAdmin = Auth.isSuperAdmin();
			vm.loadUsergroups();
		}
		
		// Load Usergroups
		vm.loadUsergroups = function() {
			var params = {};
			HttpSvc.get('userGroups/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						result.forEach(function(ug){
							if(ug.isSuperAdmin) {
								if(Auth.isSuperAdmin()){
									vm.usergroups.push({ id: ug.id, name: ug.name });
								}
							} else {
								vm.usergroups.push({ id: ug.id, name: ug.name });
							}
						});
						vm.loadFeatures();
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
		}
		
		// Load Features
		vm.loadFeatures = function() {
			var params = {};
			
			HttpSvc.get('featuresV2/company/' + Auth.getCompanyId(), params, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (f) {						
						var f = { 
							userGroupId: $stateParams.id,
							featureId: f.id, 
							name: f.name,
							isParent: f.isParent,
							canAccess: false,
							canCreate: false,
							canRead: false,
							canUpdate: false,
							canDelete: false,
							canExport: false,
							canApprove: false
						};
						vm.features.push(f);
						vm.originalFeatures.push(f);
					});		
					vm.loadLimitedUserTypes();
				}, function() {
					vm.features = [];
				});
		};	

		// Load Limited Access Features
		vm.loadLimitedUserTypes = function() {
			var params = {};
			
			HttpSvc.get('serverpackages/limitedaccess/' + Auth.getCompanyId() + '/featurelist', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.limiteds = result;
					vm.loadUsergroup();
				}, function() {
					vm.limiteds = [];
				});
		};
		
		// Load Usergroup
		vm.loadUsergroup = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('userGroups/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.usergroup = result;					
					vm.usergroups.forEach(function(ug) {
						if(ug.id==vm.usergroup.parentId){
							vm.parentUG.selected = ug;
						}
					});

					vm.limiteds.forEach(function(f) {
						if(f.id==vm.usergroup.packageLimitedId)
						{
							vm.selectedLimited = f;
							vm.features = [];
							vm.selectedLimited.serverPackageLimitedAccesses.forEach(function (f) {						
								var f = { 
									userGroupId: $stateParams.id,
									featureId: f.featureId, 
									name: f.name,
									isParent: f.isParent,
									canAccess: false,
									canCreate: false,
									canRead: false,
									canUpdate: false,
									canDelete: false,
									canExport: false,
									canApprove: false
								};
								vm.features.push(f);
							});	
						}
					});

					result.userGroupFeatureV2.forEach(function (f1) {
						vm.features.forEach(function(f2) {
							if(f1.featureId==f2.featureId){
								f2.canAccess = f1.canAccess;
								f2.canCreate = f1.canCreate;
								f2.canRead = f1.canRead;
								f2.canUpdate = f1.canUpdate;
								f2.canDelete = f1.canDelete;
								f2.canExport = f1.canExport;
								f2.canApprove = f1.canApprove;
							}
						});
					});
				}, function() {
					toastr.error('Failed to load selected Usergroup.', Auth.translate('ERROR'))
					$state.go('settings.usergroups.list');
					return;
				});		
		};	

		/* ************************************************************* */

		// Select Parent Group
		vm.selectParentUG = function(item) {
			vm.usergroup.parentId = item.id;
			vm.parentUG.selected = item;
		};	
		
		// Select All Features
		vm.selectAll = function(obj) {
			vm.features.forEach(function(f) {
				if(obj=="ACCESS"){
					f.canAccess = true;
				} else if(obj=="VIEW"){
					f.canRead = true;
				} else if(obj=="CREATE"){
					f.canCreate = true;
				} else if(obj=="UPDATE"){
					f.canUpdate = true;
				} else if(obj=="DELETE"){
					f.canDelete = true;
				} else if(obj=="EXPORT"){
					f.canExport = true;
				} else if(obj=="APPROVE"){
					f.canApprove = true;
				}
			});
		}
		
		// Deselect All Features
		vm.deselectAll = function(obj) {
			vm.features.forEach(function(f) {
				if(obj=="ACCESS"){
					f.canAccess = false;
				} else if(obj=="VIEW"){
					f.canRead = false;
				} else if(obj=="CREATE"){
					f.canCreate = false;
				} else if(obj=="UPDATE"){
					f.canUpdate = false;
				} else if(obj=="DELETE"){
					f.canDelete = false;
				} else if(obj=="EXPORT"){
					f.canExport = false;
				} else if(obj=="APPROVE"){
					f.canApprove = false;
				}
			});
		}
		
		// Turn On Feature
		vm.toggleFeature = function(featureId) {
			vm.features.forEach(function(f) {
				if(f.featureId==featureId) {
					f.canAccess = !f.canAccess;
					f.canCreate = f.canAccess;
					f.canRead = f.canAccess;
					f.canUpdate = f.canAccess;
					f.canDelete = f.canAccess;
					f.canExport = f.canAccess;
					f.canApprove = f.canAccess;
				}
			});
		}
						
		/* ************************************************************* */

		vm.selectedLimitedChanged = function() {
			if(!vm.usergroup.isLimitedAccess)
			{
				vm.selectedLimited = null;
				vm.usergroup.packageLimitedId = null;
				vm.features = angular.copy(vm.originalFeatures);
			}
		}

		vm.limitedUserTypeChanged = function() {
			if(vm.selectedLimited!=null)
			{
				vm.usergroup.packageLimitedId = vm.selectedLimited.id;
				vm.features = [];
				vm.selectedLimited.serverPackageLimitedAccesses.forEach(function(f) {
					var f = { 
						featureId: f.featureId, 
						name: f.name,
						isParent: f.isParent,
						canAccess: false,
						canCreate: false,
						canRead: false,
						canUpdate: false,
						canDelete: false,
						canExport: false,
						canApprove: false
					};
					vm.features.push(f);
				});
			}
			else
			{
				vm.usergroup.packageLimitedId = null;
				vm.features = angular.copy(vm.originalFeatures);
			}
		}

		/* ************************************************************* */
					
		// Open Loan Status Modal Dialog
		vm.showAddLoanStatusModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'LoanStatusModal.html',
				controller: 'UsergroupLoanStatusModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					if(data.statuses != null)
					{
						vm.addAllLoanStatus(data);
					}
					else
					{
						vm.addLoanStatus(data);
					}
				}, function () {
				});
		};				
		
		// Remove Loan Status
		vm.removeLoanStatus = function(index) {
			var result = confirm('Confirm remove this Loan Status?');
			
			if(result) {
				vm.usergroup.userGroupLoanStates.splice(index, 1);				
			}
		};

		// Add Loan Status
		vm.addLoanStatus = function(obj) {
			var element = {
				loanStateId: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.usergroup.userGroupLoanStates.some(function(el){
				if(el.loanStateId === element.loanStateId){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.usergroup.userGroupLoanStates.push(element);
		};

		// Add All Loan Status
		vm.addAllLoanStatus = function(obj) {
			obj.statuses.forEach(function(b) {
				var element = {
					loanStateId: b.id,
					name: b.name,
				};
				
				var isFound = false;
			vm.usergroup.userGroupLoanStates.some(function(el){
				if(el.loanStateId === element.loanStateId){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.usergroup.userGroupLoanStates.push(element);
			});
		};
		
		/* ************************************************************* */
					
		// Open Loan Item Status Modal Dialog
		vm.showAddLoanItemStatusModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'LoanItemStatusModal.html',
				controller: 'UsergroupLoanItemStatusModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					if(data.statuses != null)
					{
						vm.addAllLoanItemStatus(data);
					}
					else
					{
						vm.addLoanItemStatus(data);
					}
				}, function () {
				});
		};				
		
		// Remove Loan Item Status
		vm.removeLoanItemStatus = function(index) {
			var result = confirm('Confirm remove this Loan Item Status?');
			
			if(result) {
				vm.usergroup.userGroupLoanItemStates.splice(index, 1);				
			}
		};

		// Add Loan Item Status
		vm.addLoanItemStatus = function(obj) {
			var element = {
				loanItemStateId: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.usergroup.userGroupLoanItemStates.some(function(el){
				if(el.loanItemStateId === element.loanItemStateId){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.usergroup.userGroupLoanItemStates.push(element);
		};

		// Add All Loan Item Status
		vm.addAllLoanItemStatus = function(obj) {
			obj.statuses.forEach(function(b) {
				var element = {
					loanItemStateId: b.id,
					name: b.name,
				};
				
				var isFound = false;
				vm.usergroup.userGroupLoanItemStates.some(function(el){
					if(el.loanItemStateId === element.loanItemStateId){
						isFound = true; 
					} 
				});

				if(!isFound)
					vm.usergroup.userGroupLoanItemStates.push(element);
			});
		};
		
		/* ************************************************************* */
					
		// Open Work Order Status Modal Dialog
		vm.showAddWorkOrderStatusModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'WorkOrderStatusModal.html',
				controller: 'UsergroupWorkOrderStatusModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					if(data.statuses != null)
					{
						vm.addAllWorkOrderStatus(data);
					}
					else
					{
						vm.addWorkOrderStatus(data);
					}
				}, function () {
				});
		};				
		
		// Remove Work Order Status
		vm.removeWorkOrderStatus = function(index) {
			var result = confirm('Confirm remove this Work Order Status?');
			
			if(result) {
				vm.usergroup.userGroupWorkStates.splice(index, 1);				
			}
		};

		// Add Work Order Status
		vm.addWorkOrderStatus = function(obj) {
			var element = {
				workStateId: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.usergroup.userGroupWorkStates.some(function(el){
				if(el.workStateId === element.workStateId){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.usergroup.userGroupWorkStates.push(element);
		};

		// Add All Work Order Status
		vm.addAllWorkOrderStatus = function(obj) {
			obj.statuses.forEach(function(b) {
				var element = {
					workStateId: b.id,
					name: b.name,
				};
				
				var isFound = false;
				vm.usergroup.userGroupWorkStates.some(function(el){
					if(el.workStateId === element.workStateId){
						isFound = true; 
					} 
				});

				if(!isFound)
					vm.usergroup.userGroupWorkStates.push(element);
			});
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				vm.usergroup.userGroupFeatureV2 = [];
				vm.features.forEach(function(f) {
					vm.usergroup.userGroupFeatureV2.push({
						userGroupId: $stateParams.id,
						featureId: f.featureId, 
						name: f.name,
						canAccess: f.canAccess,
						canCreate: f.canCreate,
						canRead: f.canRead,
						canUpdate: f.canUpdate,
						canDelete: f.canDelete,
						canExport: f.canExport,
						canApprove: f.canApprove
					});
				});
								
				HttpSvc.put('userGroups/' + $stateParams.id, vm.usergroup, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Usergroup has been updated successfully.', Auth.translate('SUCCESS'));
						//$state.go('settings.usergroups.list');
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.initData();			
	}
			
	// Loan Status Modal Controller
	function UsergroupLoanStatusModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		$mdl.item = {};
		$mdl.statuses = [];
		$mdl.selectedStatus = null;
					 
		// Load Statuses
		$mdl.loadStatuses = function() {
			HttpSvc.get('services/loanstates/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.statuses = result;
				}, function() {
					toastr.error('Failed to load Loan Status List.', Auth.translate('ERROR'))
					$mdl.cancelModal();
					return;
				});		
		};		
		
		$mdl.selectedStatusChanged = function() {
			$mdl.item.id = $mdl.selectedStatus.id;
			$mdl.item.name = $mdl.selectedStatus.name;
		}

		$mdl.addAll = function() {
			$mdl.item.statuses = $mdl.statuses;
			$mdl.item.id = null;
			$mdl.item.name = null;
			$uibModalInstance.close($mdl.item);
		}
						
		$mdl.confirmModal = function() {
			if($mdl.statusForm.$invalid || $mdl.selectedStatus == null) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Init
		$mdl.loadStatuses();
	};
			
	// Loan Item Status Modal Controller
	function UsergroupLoanItemStatusModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		$mdl.item = {};
		$mdl.statuses = [];
		$mdl.selectedStatus = null;
					 
		// Load Statuses
		$mdl.loadStatuses = function() {
			HttpSvc.get('services/loanitemstates/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.statuses = result;
				}, function() {
					toastr.error('Failed to load Loan Item Status List.', Auth.translate('ERROR'))
					$mdl.cancelModal();
					return;
				});		
		};		
		
		$mdl.selectedStatusChanged = function() {
			$mdl.item.id = $mdl.selectedStatus.id;
			$mdl.item.name = $mdl.selectedStatus.name;
		}

		$mdl.addAll = function() {
			$mdl.item.statuses = $mdl.statuses;
			$mdl.item.id = null;
			$mdl.item.name = null;
			$uibModalInstance.close($mdl.item);
		}
						
		$mdl.confirmModal = function() {
			if($mdl.statusForm.$invalid || $mdl.selectedStatus == null) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Init
		$mdl.loadStatuses();
	};
			
	// Work Order Status Modal Controller
	function UsergroupWorkOrderStatusModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		$mdl.item = {};
		$mdl.statuses = [];
		$mdl.selectedStatus = null;
					 
		// Load Statuses
		$mdl.loadStatuses = function() {
			HttpSvc.get('services/workorderstates/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.statuses = result;
				}, function() {
					toastr.error('Failed to load Work Order Status List.', Auth.translate('ERROR'))
					$mdl.cancelModal();
					return;
				});		
		};		
		
		$mdl.selectedStatusChanged = function() {
			$mdl.item.id = $mdl.selectedStatus.id;
			$mdl.item.name = $mdl.selectedStatus.name;
		}

		$mdl.addAll = function() {
			$mdl.item.statuses = $mdl.statuses;
			$mdl.item.id = null;
			$mdl.item.name = null;
			$uibModalInstance.close($mdl.item);
		}
						
		$mdl.confirmModal = function() {
			if($mdl.statusForm.$invalid || $mdl.selectedStatus == null) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Init
		$mdl.loadStatuses();
	};
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.settings.notificationsettings.controller', [])
        .controller('NotificationSettingMainCtrl', NotificationSettingMainCtrl)
        .controller('NotificationSettingCreateCtrl', NotificationSettingCreateCtrl)
        .controller('NotificationSettingUpdateCtrl', NotificationSettingUpdateCtrl);

    /** @ngInject */
    function NotificationSettingMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.notifDataFull = [];
		vm.notifData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.notifDataFull, tableState.search.predicateObject) : vm.notifDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.notifData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.notifDataFull.length <= 0) {							
				HttpSvc.get('notificationsettings/list', {}, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.notifDataFull = result;		
						
						vm.notifDataFull.forEach(function(n) {
							n.status = NotificationSettingGetStatusName(n.module, n.status, n.status);
							n.module = NotificationSettingGetModuleName(n.module);
						});

						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteNotification = function(notifId) {
			var params = {};
			HttpSvc.delete('notificationsettings/' + notifId, params, Auth.getTokenId(), false)
				.then(function(result) {					
					toastr.success('The notification has been deleted.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function() {
					// Failed
					toastr.error('Failed to delete the notification.', 'Failed');
					return null;
			});
		};			
	}
	
	/** @ngInject */
    function NotificationSettingCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;		
		
		vm.moduleList = NotificationSettingModuleList();
		vm.userList = [];
		
		vm.notif = {};
		vm.notif.isActive = true;
		vm.selectedModule = null;
		vm.selectedStatus = null;
		vm.selectedUser = null;
		vm.lockButtons = false;

		/* **************************************************************** */
				
		// Load User List
		vm.loadUserList = function() {
			HttpSvc.get('users/listallwithaccess', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.userList = result;
				}, function(error) {
					toastr.error(error, 'Failed to load User List');
				});				
		};

		/* **************************************************************** */
		
		vm.selectedModuleChanged = function() {
			vm.notif.module = vm.selectedModule.id;
		};
		
		vm.selectedStatusChanged = function() {
			vm.notif.status = vm.selectedStatus.id;
		};
		
		vm.selectedUserChanged = function() {
			vm.notif.userId = vm.selectedUser.id;
		};
		
		/* **************************************************************** */

		// Form Submission
		vm.submit = function() {
			
			vm.lockButtons = true;
						
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {						
				HttpSvc.post('notificationsettings', vm.notif, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Notification Setting has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('settings.notificationsettings.list');
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}
		
		// Call Actions
		vm.loadUserList();
	}
	
	/** @ngInject */
    function NotificationSettingUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		
		vm.moduleList = NotificationSettingModuleList();
		vm.userList = [];
		
		vm.notif = {};
		vm.selectedModule = null;
		vm.selectedStatus = null;
		vm.selectedUser = null;
		vm.lockButtons = false;
				
		// Load User List
		vm.loadUserList = function() {
			HttpSvc.get('users/listallwithaccess', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.userList = result;
					vm.loadNotif();
				}, function(error) {
					toastr.error(error, 'Failed to load User List');
				});
		};
				
		// Load NotificationSetting
		vm.loadNotif = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('notificationsettings/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.notif = result;

					vm.moduleList.forEach(function(m) {
						if(m.id==vm.notif.module) {
							vm.selectedModule = m;
						}
					});
					vm.selectedModule.statuses.forEach(function(s) {
						if(s.id==vm.notif.status) {
							vm.selectedStatus = s;
						}
					});
					vm.userList.forEach(function(u) {
						if(u.id==vm.notif.userId) {
							vm.selectedUser = u;
						}
					});					
				}, function() {
					toastr.error('Failed to load selected Notification Setting.', Auth.translate('ERROR'))
					$state.go('settings.notifs.list');
					return;
				});		
		};	
		
		vm.selectedModuleChanged = function() {
			vm.notif.module = vm.selectedModule.id;
		};
		
		vm.selectedStatusChanged = function() {
			vm.notif.status = vm.selectedStatus.id;
		};
		
		vm.selectedUserChanged = function() {
			vm.notif.userId = vm.selectedUser.id;
		};
		
		// Form Submission
		vm.submit = function() {
						
			vm.lockButtons = true;
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				vm.lockButtons = false;
			} else {
				HttpSvc.put('notificationsettings/' + $stateParams.id, vm.notif, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Notification Setting has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('settings.notificationsettings.list');
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.lockButtons = false;
					});
			}
		}
		
		// Call Actions
		vm.loadUserList();			
	}
	
	function NotificationSettingModuleList() { 
		// return [
		// 	{id: 'REQUISITION', name: 'REQUISITION'}, 
		// 	{id: 'PURCHASEORDER', name: 'PURCHASE ORDER'},
		// 	{id: 'WITHDRAWALREQUEST', name: 'WITHDRAWAL REQUEST'},
		// 	{id: 'WORKORDER', name: 'WORK ORDER'},
		// 	{id: 'CASEMANAGEMENT', name: 'CASE MANAGEMENT'},
		// 	{id: 'ASSETSCHEDULEREMINDER', name: 'ASSET SCHEDULE REMINDER'},
		// 	{id: 'CERTIFICATEEXPIRYREMINDER', name: 'CERTIFICATE EXPIRY REMINDER'},
		// ];

		return [
			{
				id: 'SALES_ORDER',
				name: 'SALES ORDER',
				statuses: [
					{
						id: 'NEW',
						name: 'NEW'
					},
					{
						id: 'CONFIRMED',
						name: 'CONFIRMED'
					},
					{
						id: 'IN PROCESS',
						name: 'IN PROCESS'
					},
					{
						id: 'COMPLETED',
						name: 'COMPLETED'
					},
					{
						id: 'CANCELLED',
						name: 'CANCELLED'
					},
					{
						id: 'CREDIT LIMIT APPROVAL',
						name: 'CREDIT LIMIT APPROVAL (*FOR AUTOCOUNT ONLY)'
					},
				]
			},
			{
				id: 'DELIVERY_ORDER',
				name: 'DELIVERY ORDER',
				statuses: [
					{
						id: 'NEW',
						name: 'NEW'
					},
					{
						id: 'CONFIRMED',
						name: 'CONFIRMED'
					},
					{
						id: 'APPROVED',
						name: 'APPROVED'
					},
					{
						id: 'PROCESSING',
						name: 'PROCESSING'
					},
					{
						id: 'PROCESSED',
						name: 'PROCESSED'
					},
					{
						id: 'SHIPPED',
						name: 'SHIPPED'
					},
					{
						id: 'COMPLETED',
						name: 'COMPLETED'
					},
					{
						id: 'CANCELLED',
						name: 'CANCELLED'
					},
					{
						id: 'CREDIT LIMIT APPROVAL',
						name: 'CREDIT LIMIT APPROVAL'
					},
				]
			},
			{
				id: 'REQUISITION',
				name: 'REQUISITION',
				statuses: [
					{
						id: 'PENDING',
						name: 'PENDING'
					},
					{
						id: 'CONFIRMED',
						name: 'CONFIRMED'
					},
					{
						id: 'APPROVED',
						name: 'APPROVED'
					},
					{
						id: 'COMPLETED',
						name: 'COMPLETED'
					},
					{
						id: 'CANCELLED',
						name: 'CANCELLED'
					},
				]
			},
			{
				id: 'PURCHASE_ORDER',
				name: 'PURCHASE ORDER',
				statuses: [
					{
						id: 'NEW',
						name: 'NEW'
					},
					{
						id: 'CONFIRMED',
						name: 'CONFIRMED'
					},
					{
						id: 'APPROVED',
						name: 'APPROVED'
					},
					{
						id: 'COMPLETED',
						name: 'COMPLETED'
					},
					{
						id: 'COMPLETED (PARTIAL)',
						name: 'COMPLETED (PARTIAL)'
					},
					{
						id: 'CANCELLED',
						name: 'CANCELLED'
					},
				]
			},
			{
				id: 'GOODS_RECEIVE',
				name: 'GOODS RECEIVE',
				statuses: [
					{
						id: 'RECEIVED',
						name: 'RECEIVED'
					}
				]
			},
			{
				id: 'PRODUCTION',
				name: 'PRODUCTION',
				statuses: [
					{
						id: '0',
						name: 'PENDING'
					},
					{
						id: '1',
						name: 'CONFIRMED'
					},
					{
						id: '2',
						name: 'IN PROGRESS'
					},
					{
						id: '3',
						name: 'COMPLETED'
					},
					{
						id: '4',
						name: 'COMPLETED (VARIANCE)'
					},
					{
						id: '5',
						name: 'CANCELLED'
					},
				]
			},
			{
				id: 'BULKBREAKJOB',
				name: 'BULKBREAKJOB',
				statuses: [ 
					{
						id: 'NEW',
						name: 'NEW'
					},
					{
						id: 'CONFIRMED',
						name: 'CONFIRMED'
					},
					{
						id: 'IN PROGRESS',
						name: 'IN PROGRESS'
					},
					{
						id: 'COMPLETED',
						name: 'COMPLETED'
					},
					{
						id: 'CANCELLED',
						name: 'CANCELLED'
					},
				]
			},
			{
				id: 'STOCK_REQUEST',
				name: 'STOCK REQUEST',
				statuses: [ 
					{
						id: 'NEW',
						name: 'NEW'
					},
					{
						id: 'CONFIRMED',
						name: 'CONFIRMED'
					},
					{
						id: 'COMPLETED',
						name: 'COMPLETED'
					},
					{
						id: 'CANCELLED',
						name: 'CANCELLED'
					},
				]
			},
			{
				id: 'STOCK_TRANSFER',
				name: 'STOCK TRANSFER',
				statuses: [ 
					{
						id: 'NEW',
						name: 'NEW'
					},
					{
						id: 'CONFIRMED',
						name: 'CONFIRMED'
					},
					{
						id: 'IN PROGRESS',
						name: 'IN PROGRESS'
					},
					{
						id: 'COMPLETED',
						name: 'COMPLETED'
					},
					{
						id: 'CANCELLED',
						name: 'CANCELLED'
					},
				]
			},
			{
				id: 'WITHDRAWAL_REQUEST',
				name: 'WITHDRAWAL REQUEST',
				statuses: [
					{
						id: 'NEW',
						name: 'NEW'
					},
					{
						id: 'CONFIRMED',
						name: 'CONFIRMED'
					},
					{
						id: 'APPROVED',
						name: 'APPROVED'
					},
					{
						id: 'DELIVERED',
						name: 'DELIVERED'
					},
					{
						id: 'RECEIVED',
						name: 'RECEIVED'
					},
					{
						id: 'CANCELLED',
						name: 'CANCELLED'
					},
				]
			},
			{
				id: 'WASTAGE_REPORT',
				name: 'WASTAGE REPORT',
				statuses: [
					{
						id: 'NEW',
						name: 'NEW'
					},
					{
						id: 'CONFIRMED',
						name: 'CONFIRMED'
					},
					{
						id: 'APPROVED',
						name: 'APPROVED'
					},
					{
						id: 'CANCELLED',
						name: 'CANCELLED'
					},
				]
			},
			{
				id: 'CERT_EXPIRY_REMINDER',
				name: 'CERTIFICATE EXPIRY REMINDER',
				statuses: [
					{
						id: 'ACTIVE',
						name: 'ACTIVE'
					},
				]
			},
			{
				id: 'ASSET_REMINDER',
				name: 'ASSET SCHEDULE REMINDER',
				statuses: [
					{
						id: 'ACTIVE',
						name: 'ACTIVE'
					},
				]
			},
			{
				id: 'CASE_MGMT',
				name: 'CASE MANAGEMENT',
				statuses: [
					{
						id: 'NEW',
						name: 'NEW'
					},
					{
						id: 'ASSIGNED',
						name: 'ASSIGNED'
					},
					{
						id: 'CONVERTED',
						name: 'CONVERTED'
					},
					{
						id: 'CLOSED',
						name: 'CLOSED'
					},
				]
			},
			{
				id: 'WORK_ORDER',
				name: 'WORK ORDER',
				statuses: [
					{
						id: 'NEW',
						name: 'NEW'
					},
					{
						id: 'CONFIRMED',
						name: 'CONFIRMED'
					},
					{
						id: 'COMPLETED',
						name: 'COMPLETED'
					},
					{
						id: 'CLOSED',
						name: 'CLOSED'
					},
					{
						id: 'CANCELLED',
						name: 'CANCELLED'
					},
				]
			},
			{
				id: 'ROBOT_KIOSK_INVENTORY',
				name: 'ROBOT KIOSK INVENTORY',
				statuses: [
					{
						id: 'REORDER_LEVEL',
						name: 'REACHED/EXCEEDED INVENTORY REORDER LEVEL'
					},
					{
						id: 'INVENTORY_DEPLETED',
						name: 'INVENTORY DEPLETED'
					},
				]
			},
		];
	}
	
	function NotificationSettingGetModuleName(id) { 

		var moduleList = NotificationSettingModuleList();
		
		var result = "-";

		moduleList.forEach(function(m) {
			if(m.id==id)
				result = m.name;
		})

		return result;
	}
	
	function NotificationSettingGetStatusName(moduleId, statusId, statusName) { 

		var moduleList = NotificationSettingModuleList();
		
		var result = "-";

		moduleList.forEach(function(m) {
			if(m.id==moduleId)
			{
				m.statuses.forEach(function(s) {
					if(s.id==statusId)
						result = s.name;		
				});
			}
		})

		return result;
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.settings.resellercommconfig.controller', [])
        .controller('ResellerCommissionConfigMainCtrl', ResellerCommissionConfigMainCtrl)
        .controller('ResellerCommissionConfigUpdateCtrl', ResellerCommissionConfigUpdateCtrl);

    /** @ngInject */
    function ResellerCommissionConfigMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.commDataFull = [];
		vm.commData = [];

		/* ************************************************************ */

		function refreshTableState(tableState, startIndex, endIndex) {
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.commDataFull, tableState.search.predicateObject) : vm.commDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.commData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.commDataFull.length <= 0) {							
				HttpSvc.get('affiliatefeesconfigs/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.commDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		/* ************************************************************ */

		vm.getModuleName = function(moduleType)  {
			return GetModuleName(moduleType);
		}		
	};
	
	/** @ngInject */
    function ResellerCommissionConfigUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.config = {};
				
		/* ************************************************************* */

		// Load Config
		vm.loadConfig = function() {
			var params = { id: $stateParams.id };

			HttpSvc.get('affiliatefeesconfigs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.config = result;	
				}, function() {
					toastr.error('Failed to load selected Configuration.', Auth.translate('ERROR'))
					$state.go('settings.resellercommconfig.list');
					return;
				});		
		};	
		
		/* ************************************************************ */

		vm.getModuleName = function(moduleType)  {
			return GetModuleName(moduleType);
		}

		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('affiliatefeesconfigs/' + $stateParams.id, vm.config, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Commission Configuration has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadConfig();
	};

	
	function GetModuleName(moduleType)  {
		if(moduleType=="RMS")
		{
			return "RMS Full Edition";
		}
		else if(moduleType=="RMS-L")
		{
			return "RMS Lite Edition";
		}
		else if(moduleType=="RMS-S")
		{
			return "RMS Starter Edition";
		}
	}


})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.settings.users.controller', [])
        .controller('UserMainCtrl', UserMainCtrl)
        .controller('UserCreateCtrl', UserCreateCtrl)
        .controller('UserUpdateCtrl', UserUpdateCtrl)
        .controller('UserBrandModalCtrl', UserBrandModalCtrl)
        .controller('UserCategoryModalCtrl', UserCategoryModalCtrl);

    /** @ngInject */
    function UserMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

		Auth.init();

		var vm = this;

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0;
		vm.endIndex = 0;
		vm.userDataFull = [];
		vm.userData = [];

		function refreshTableState(tableState, startIndex, endIndex) {

			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.userDataFull, tableState.search.predicateObject) : vm.userDataFull;
			vm.numOfRecordFiltered = filtered.length;

			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);

			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.userData = result;

			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

			return tableState;
		};

		vm.retrieveData = function(tableState) {
			var pagination = tableState.pagination;

			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

			if(vm.userDataFull.length <= 0) {
				HttpSvc.get('users/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.userDataFull = [];
						result.forEach(function(u) {
							if(!u.isSuperAdmin) {
								vm.userDataFull.push(u);
							} else {
								if(Auth.isSuperAdmin()) {
									vm.userDataFull.push(u);
								}
							}
						});
						vm.numOfRecord = vm.userDataFull.length;
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};

		vm.resetUserPwd = function(loginId, userEmail) {
			Auth.resetPwd2(loginId, userEmail)
				.then(function() {
					toastr.success("An email which contains the new password has been sent!", 'Reset Successful');
				}, function(error) {
					toastr.error("Error: " + error, 'Reset Failed');
					//toastr.error('Invalid email address.', 'Reset Failed');
				});
		};

		vm.deleteUser = function(userId, username) {
			var params = {};
			HttpSvc.delete('users/' + userId, params, Auth.getTokenId(), false)
				.then(function(result) {

					HttpSvc.get('users/list', params, Auth.getTokenId(), true)
						.then(function(result) {
							vm.userDataFull = [];
							result.forEach(function(u) {
								if(!u.isSuperAdmin) {
									vm.userDataFull.push(u);
								} else {
									if(Auth.isSuperAdmin()) {
										vm.userDataFull.push(u);
									}
								}
							});
							vm.numOfRecord = vm.userDataFull.length;

							toastr.success('The user [' + username + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
						});
				}, function() {
					// Failed
					toastr.error('Failed to delete the user.', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
    function UserCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, UtilSvc, toastr) {
		Auth.init();

		var vm = this;
		vm.submitted = false;
		vm.mode = 1;
		vm.user = {};
		vm.user.userGroupId = '';
		vm.user.equipmentBrands = [];
		vm.user.equipmentCategories = [];
		vm.user.active = true;
		vm.user.ghlMerchantID = "";
		vm.user.ghlTerminalID = "";
		vm.user.ghlOperatorID = "";
		vm.user.ghlPrivateKey = "-";
		vm.assets = [];
		vm.branches = [];
		vm.departments = [];
		vm.usergroups = [];
		vm.selectedBranches = [];
		vm.selectedAsset = null;
		vm.hasAfterSaleModule = Auth.hasCompanyFeature('services.workorders');
		vm.hasSmartKitchenModule = Auth.hasCompanyFeature('smartkitchen');
		vm.hasAssetModule = Auth.hasCompanyFeature('assets');
        vm.isSuperAdmin = Auth.isSuperAdmin();

		/* ************************************************************* */

		vm.beautify = function(item) {
            if (item == null) return;

			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			newText = newText + "</span>&nbsp;&nbsp;" + item.name.toUpperCase();
			if(item.description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + item.description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";
			}
			return newText;
		}

		/* ************************************************************* */

		// Load Assets
		vm.loadAssets = function() {
			HttpSvc.get('assets/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.assets = result;
					vm.loadBranches();
				}, function() {
					vm.branches = [];
				});
		};

		// Load Branches
		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.branches.push({ id: u.id, name: u.name });
					});
					vm.loadDepartments();
				}, function() {
					vm.branches = [];
				});
		};

		// Load Departments
		vm.loadDepartments = function() {
			HttpSvc.get('departments/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.departments.push({ id: u.id, name: u.name });
					});
					vm.loadUsergroupList();
				}, function() {
					vm.departments = [];
				});
		};

		// Load Usergroup List
		vm.loadUsergroupList = function() {
			HttpSvc.get('usergroups/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function(u){
						if(u.isSuperAdmin) {
							if(Auth.isSuperAdmin()){
								vm.usergroups.push({ id: u.id, name: u.name });
							}
						} else {
							vm.usergroups.push({ id: u.id, name: u.name });
						}
					});
				}, function() {
					vm.usergroups = [];
				});
		};

		// Generate Random Password
		vm.generatePassword = function() {
			if(vm.isRandomPassword) {
				vm.user.password = UtilSvc.generateRandomString(8);
				vm.user.password1 = vm.user.password;
			} else {
				vm.user.password = "";
				vm.user.password1 = "";
			}
		}

		/* ************************************************************* */

		vm.selectedAssetChanged = function()
		{
			vm.user.assetId = vm.selectedAsset.id;
		}

		/* ************************************************************* */

		// Open Brand Modal Dialog
		vm.showAddBrandModal = function () {
			vm.prop = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'UserBrandModal.html',
				controller: 'UserBrandModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					if(data.brands != null)
					{
						vm.addAllBrands(data);
					}
					else
					{
						vm.addBrand(data);
					}
				}, function () {
				});
		};

		/* ************************************************************* */

		// Remove Brand
		vm.removeBrand = function(index) {
			var result = confirm('Confirm remove this Brand?');

			if(result) {
				vm.user.equipmentBrands.splice(index, 1);
			}
		};

		// Add Brand
		vm.addBrand = function(obj) {
			var element = {
				id: obj.id,
				code: obj.code,
				name: obj.name,
			};
			vm.user.equipmentBrands.push(element);
		};

		// Add Brand
		vm.addAllBrands = function(obj) {
			obj.brands.forEach(function(b) {
				var element = {
					id: b.id,
					code: b.code,
					name: b.name,
				};

				var isFound = false;
				vm.user.equipmentBrands.some(function(el){
					if(el.id === element.id){
						isFound = true;
					}
				});

				if(!isFound)
					vm.user.equipmentBrands.push(element);
			});
		};

		/* ************************************************************* */

		// Open Category Modal Dialog
		vm.showAddCategoryModal = function () {
			vm.prop = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'UserCategoryModal.html',
				controller: 'UserCategoryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					if(data.categories != null)
					{
						vm.addAllCategories(data);
					}
					else
					{
						vm.addCategory(data);
					}
				}, function () {
				});
		};

		/* ************************************************************* */

		// Remove Category
		vm.removeCategory = function(index) {
			var result = confirm('Confirm remove this Category?');

			if(result) {
				vm.user.equipmentCategories.splice(index, 1);
			}
		};

		// Add Category
		vm.addCategory = function(obj) {
			var element = {
				id: obj.id,
				code: obj.code,
				name: obj.name,
			};

			var isFound = false;
			vm.user.equipmentCategories.some(function(el){
				if(el.id === element.id){
					isFound = true;
				 }
			});

			if(!isFound)
				vm.user.equipmentCategories.push(element);
		};

		// Add All Categories
		vm.addAllCategories = function(obj) {
			obj.categories.forEach(function(c) {
				var element = {
					id: c.id,
					code: c.code,
					name: c.name,
				};

				var isFound = false;
				vm.user.equipmentCategories.some(function(el){
					if(el.id === element.id){
						isFound = true;
					}
				});

				if(!isFound)
					vm.user.equipmentCategories.push(element);
			});
		};

        /* ************************************************************* */

        $scope.$watch('vm.user.email', function (newVal) {
            if (!vm.isSuperAdmin && newVal) {
                vm.user.loginId = newVal;
            }
        });

        /* ************************************************************* */

        function isValidEmail(email) {
            var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        }

        function isValidPhone(phone) {
            var e164Pattern = /^\+?[1-9]\d{1,14}$/; // E.164 format
            var malaysiaPattern = /^\d{3}-\d{7}$/; // Malaysian phone number format XXX-XXXXXXX
            return e164Pattern.test(phone) || malaysiaPattern.test(phone);
        }

		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
                if (!isValidEmail(vm.user.email)) {
                    toastr.error("Email is invalid.");
                    return null;
                }

                if (vm.user.phone) {
                    if (!isValidPhone(vm.user.phone)) {
                        toastr.error("Phone number is invalid. Please enter in E.164 format (e.g. +60102345678) or Malaysian phone number format (e.g. 012-3456789)");
                        return null;
                    }
                }

				vm.user.userGroupId = vm.usergroups.selected.id;
				if(vm.departments.selected) {
					vm.user.departmentId = vm.departments.selected.id;
				} else {
					vm.user.departmentId = null;
				}

				vm.user.branches = [];
				vm.selectedBranches.forEach( function(b) {
					vm.user.branches.push({ id: b.id });
				});

                if (!vm.isSuperAdmin) {
                    vm.user.loginId = vm.user.email;
                }

				HttpSvc.post('users/add', vm.user, Auth.getTokenId(), false)
					.then(function(result) {
						Auth.selectBranchToken()
							.then(function() {
								toastr.success('User has been created successfully.', Auth.translate('SUCCESS'));
								$state.go('settings.users.list');
							}, function(error) {
								toastr.error(error, 'Failed');
							});
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Call Actions
		vm.loadAssets();
	}

	/** @ngInject */
    function UserUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {

		Auth.init();

		var vm = this;
		vm.submitted = false;
		vm.mode = 2;
		vm.user = {};
		vm.user.equipmentBrands = [];
		vm.user.equipmentCategories = [];
		vm.user.userGroupId = '';
		vm.user.ghlMerchantID = "";
		vm.user.ghlTerminalID = "";
		vm.user.ghlOperatorID = "";
		vm.user.ghlPrivateKey = "-";
		vm.assets = [];
		vm.branches = [];
		vm.departments = [];
		vm.usergroups = [];
		vm.loadedBranches = [];
		vm.selectedAsset = null;
		vm.selectedBranches = [];
		vm.hasAfterSaleModule = Auth.hasCompanyFeature('services.workorders');
		vm.hasSmartKitchenModule = Auth.hasCompanyFeature('smartkitchen');
		vm.hasAssetModule = Auth.hasCompanyFeature('assets');
		vm.isSuperAdmin = Auth.isSuperAdmin();

		vm.fileToUpload = null;
		vm.serverMode = Auth.getServerMode();
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.user.signatureLocation = "";
		vm.user.oriSignatureLocation = "";

		/* ************************************************************* */

		vm.beautify = function(item) {
			if(item==null) return;

			var newText = "<span class='dd-code'>" + item.code.toUpperCase();
			newText = newText + "</span>&nbsp;&nbsp;" + item.name.toUpperCase();
			if(item.description) {
				newText = newText + "<div class='dd-smalltext'>";
				newText = newText + item.description.replace(/\r\n|\r|\n/g, '<br />').toUpperCase();
				newText = newText + "</div>";
			}
			return newText;
		}

		/* ************************************************************* */

		// Load Assets
		vm.loadAssets = function() {
			HttpSvc.get('assets/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.assets = result;
					vm.loadBranches();
				}, function() {
					vm.branches = [];
				});
		};

		// Load Branches
		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.branches.push({ id: u.id, name: u.name });
					});
					vm.loadDepartments();
				}, function() {
					vm.branches = [];
				});
		};

		// Load Departments
		vm.loadDepartments = function() {
			HttpSvc.get('departments/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.departments.push({ id: u.id, name: u.name });
					});
					vm.loadUsergroupList();
				}, function() {
					vm.departments = [];
				});
		};

		// Load Usergroup List
		vm.loadUsergroupList = function() {
			HttpSvc.get('usergroups/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function(u){
						if(u.isSuperAdmin) {
							if(Auth.isSuperAdmin()){
								vm.usergroups.push({ id: u.id, name: u.name });
							}
						} else {
							vm.usergroups.push({ id: u.id, name: u.name });
						}
					});
					vm.loadUser();
				}, function() {
					vm.usergroups = [];
				});
		};

		vm.loadUser = function() {
			// Load User
			var params = { id: $stateParams.id };
			HttpSvc.get('users/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.user = result;

					vm.departments.forEach(function(d) {
						if(d.id==vm.user.departmentId){
							vm.departments.selected = d;
						}
					});

					vm.usergroups.forEach(function(u) {
						if(u.id==vm.user.userGroupId){
							vm.usergroups.selected = u;
						}
					});

					vm.assets.forEach(function(a) {
						if(a.id==vm.user.assetId){
							vm.selectedAsset = a;
						}
					});

					result.branches.forEach(function (b) {
						vm.selectedBranches.push({ id: b.id, name: b.name });
					});

					if(!vm.user.signatureLocation || vm.user.signatureLocation=='') {
						vm.user.signatureLocation = 'assets/img/empty_placeholder.png';
						vm.user.oriSignatureLocation = "";
					} else {
						vm.user.oriSignatureLocation = vm.user.signatureLocation;
						vm.user.signatureLocation = vm.rootUrl + vm.user.signatureLocation;
					}

				}, function() {
					toastr.error('Failed to load selected User.', Auth.translate('ERROR'))
					$state.go('settings.users.list');
					return;
				});
		};

		// Generate Random Password
		vm.generatePassword = function() {
			if(vm.isRandomPassword) {
				vm.user.password = UtilSvc.generateRandomString(8);
				vm.user.password1 = vm.user.password;
			} else {
				vm.user.password = "";
				vm.user.password1 = "";
			}
		}

		/* ************************************************************* */

		vm.selectedAssetChanged = function()
		{
			vm.user.assetId = vm.selectedAsset.id;
		}

		/* ************************************************************* */

		// Open Modal Dialog
		vm.showAddBrandModal = function () {
			if (vm.user.isPosSyncUser && !vm.isSuperAdmin) {
				return;
			}
			vm.prop = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'UserBrandModal.html',
				controller: 'UserBrandModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					if(data.brands != null)
					{
						vm.addAllBrands(data);
					}
					else
					{
						vm.addBrand(data);
					}
				}, function () {
				});
		};

		/* ************************************************************* */

		// Remove Brand
		vm.removeBrand = function(index) {
			var result = confirm('Confirm remove this Brand?');

			if(result) {
				vm.user.equipmentBrands.splice(index, 1);
			}
		};

		// Add Brand
		vm.addBrand = function(obj) {
			var element = {
				id: obj.id,
				code: obj.code,
				name: obj.name,
			};
			vm.user.equipmentBrands.push(element);
		};

		// Add Brand
		vm.addAllBrands = function(obj) {
			obj.brands.forEach(function(b) {
				var element = {
					id: b.id,
					code: b.code,
					name: b.name,
				};

				var isFound = false;
				vm.user.equipmentBrands.some(function(el){
					if(el.id === element.id){
						isFound = true;
					}
				});

				if(!isFound)
					vm.user.equipmentBrands.push(element);
			});
		};

		/* ************************************************************* */

		// Open Category Modal Dialog
		vm.showAddCategoryModal = function () {
			if (vm.user.isPosSyncUser && !vm.isSuperAdmin) {
				return;
			}
			vm.prop = {};

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'UserCategoryModal.html',
				controller: 'UserCategoryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					if(data.categories != null)
					{
						vm.addAllCategories(data);
					}
					else
					{
						vm.addCategory(data);
					}
				}, function () {
				});
		};

		/* ************************************************************* */

		// Remove Category
		vm.removeCategory = function(index) {
			var result = confirm('Confirm remove this Category?');

			if(result) {
				vm.user.equipmentCategories.splice(index, 1);
			}
		};

		// Add Category
		vm.addCategory = function(obj) {
			var element = {
				id: obj.id,
				code: obj.code,
				name: obj.name,
			};

			var isFound = false;
			vm.user.equipmentCategories.some(function(el){
				if(el.id === element.id){
					isFound = true;
				 }
			});

			if(!isFound)
				vm.user.equipmentCategories.push(element);
		};

		// Add All Categories
		vm.addAllCategories = function(obj) {
			obj.categories.forEach(function(c) {
				var element = {
					id: c.id,
					code: c.code,
					name: c.name,
				};

				var isFound = false;
				vm.user.equipmentCategories.some(function(el){
					if(el.id === element.id){
						isFound = true;
					}
				});

				if(!isFound)
					vm.user.equipmentCategories.push(element);
			});
		};

        /* ************************************************************* */

        $scope.$watch('vm.user.email', function (newVal) {
            if (!vm.isSuperAdmin && newVal) {
                vm.user.loginId = newVal;
            }
        });

        /* ************************************************************* */

        function isValidEmail(email) {
            var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        }

        function isValidPhone(phone) {
            var e164Pattern = /^\+?[1-9]\d{1,14}$/; // E.164 format
            var malaysiaPattern = /^\d{3}-\d{7}$/; // Malaysian phone number format XXX-XXXXXXX
            return e164Pattern.test(phone) || malaysiaPattern.test(phone);
        }

		/* ************************************************************* */

		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
                if (!isValidEmail(vm.user.email)) {
                    toastr.error("Email is invalid.");
                    return null;
                }

                if (vm.user.phone) {
                    if (!isValidPhone(vm.user.phone)) {
                        toastr.error("Phone number is invalid. Please enter in E.164 format (e.g. +60102345678) or Malaysian phone number format (e.g. 012-3456789)");
                        return null;
                    }
                }

				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";

				if(vm.serverMode==1 && vm.fileToUpload) {
					/* CHECK STORAGE QUOTA */
					if(vm.lockUploadButton) {
						toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Media Upload Error');
						return;
					}
					/* ******************* */

					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/usersignature/" + newFilename + mediaExtension;

				} else if(vm.serverMode==0 && vm.fileToUpload) {

					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "usersignature/" + newFilename + mediaExtension;

				} else if(vm.user.oriSignatureLocation!="") {
					imgLocation = vm.user.oriSignatureLocation;
				}

				vm.user.signatureLocation = imgLocation;
				vm.user.userGroupId = vm.usergroups.selected.id;

				if(vm.departments.selected) {
					vm.user.departmentId = vm.departments.selected.id;
				} else {
					vm.user.departmentId = null;
				}

				vm.user.branches = [];
				vm.selectedBranches.forEach( function(b) {
					vm.user.branches.push({ id: b.id });
				});

				HttpSvc.put('users/' + $stateParams.id, vm.user, Auth.getTokenId(), false)
					.then(function(result) {
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(vm.serverMode);

						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/usersignature/" + $stateParams.id;
							vm.uploadImage(vm.serverMode);

						} else {
							toastr.success('User has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						}

					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}

		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (serverMode) {
			var fileReader = new FileReader();

			if(serverMode==0) {	// Local Server

				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('User has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('User has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});

			} else if(serverMode==1) { // Azure Server

				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {
							toastr.success('User has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						}
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};

		/* ********************************************* */

		// Call Actions
		vm.loadAssets();
	}

	// Brand Modal Controller
	function UserBrandModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;

		$mdl.item = {};
		$mdl.brands = [];
		$mdl.selectedBrand = null;

		// Load Brands
		$mdl.loadBrands = function() {
			HttpSvc.get('equipmentbrands/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.brands = result;
				}, function() {
					toastr.error('Failed to load Brand List.', Auth.translate('ERROR'))
					$mdl.cancelModal();
					return;
				});
		};

		$mdl.selectedBrandChanged = function() {
			$mdl.item.id = $mdl.selectedBrand.id;
			$mdl.item.code = $mdl.selectedBrand.code;
			$mdl.item.name = $mdl.selectedBrand.name;
		}

		$mdl.addAll = function() {
			$mdl.item.brands = $mdl.brands;
			$mdl.item.id = null;
			$mdl.item.code = null;
			$mdl.item.name = null;
			$uibModalInstance.close($mdl.item);
		}

		$mdl.confirmModal = function() {
			if($mdl.brandForm.$invalid || $mdl.selectedBrand==null) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Init
		$mdl.loadBrands();
	};

	// Category Modal Controller
	function UserCategoryModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;

		$mdl.item = {};
		$mdl.categories = [];
		$mdl.selectedCategory = null;

		// Load Categories
		$mdl.loadCategories = function() {
			HttpSvc.get('equipmentcategories/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.categories = result;
				}, function() {
					toastr.error('Failed to load Service Category List.', Auth.translate('ERROR'))
					$mdl.cancelModal();
					return;
				});
		};

		$mdl.selectedCategoryChanged = function() {
			$mdl.item.id = $mdl.selectedCategory.id;
			$mdl.item.code = $mdl.selectedCategory.code;
			$mdl.item.name = $mdl.selectedCategory.name;
		}

		$mdl.addAll = function() {
			$mdl.item.categories = $mdl.categories;
			$mdl.item.id = null;
			$mdl.item.code = null;
			$mdl.item.name = null;
			$uibModalInstance.close($mdl.item);
		}

		$mdl.confirmModal = function() {
			if($mdl.categoryForm.$invalid || $mdl.selectedCategory == null) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Init
		$mdl.loadCategories();
	};

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.smartiotsettings.devicegroups.controller', [])
			.controller('SmartIoTDeviceGroupMainCtrl', SmartIoTDeviceGroupMainCtrl)
			.controller('SmartIoTDeviceGroupCreateCtrl', SmartIoTDeviceGroupCreateCtrl)
			.controller('SmartIoTDeviceGroupUpdateCtrl', SmartIoTDeviceGroupUpdateCtrl);

	/** @ngInject */
	function SmartIoTDeviceGroupMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.groupDataFull = [];
		vm.groupData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.groupDataFull, tableState.search.predicateObject) : vm.groupDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.groupData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.groupDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('smartiot/groups/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.groupDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteGateway = function(gatewayId, gatewayName) {
			var params = {};
			HttpSvc.delete('smartiot/groups/' + gatewayId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('smartiot/groups/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.groupDataFull = result;
							
							toastr.success('The Device Group [' + gatewayName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Device Group [' + gatewayName + '].', 'Delete Failed');
					return null;
		});
	};
	};

	/** @ngInject */
	function SmartIoTDeviceGroupCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.group = {};
		vm.group.siotGroupDevices = [];
		vm.group.siotGroupUsers = [];
		vm.gatewayList = [];
		vm.sensorList = [];
		vm.userList = [];
		vm.branchList = [];
		vm.selectedGateway = null;
		vm.selectedSensor = null;
		vm.selectedUser = null;
		vm.addDevicePanelVisible = false;
		vm.addUserPanelVisible = false;

		/* ******************************************************************** */

		vm.loadGatewayList = function() {
			HttpSvc.get('smartiot/gateways/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.gatewayList = result;
					vm.loadSensorList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadSensorList = function() {
			HttpSvc.get('smartiot/sensors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sensorList = result;
					vm.loadUserList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadUserList = function() {
			HttpSvc.get('users/listallwithaccess', {}, Auth.getTokenId(), true)
				.then(function(result) {
					if (Auth.isSuperAdmin()) { 
						vm.userList = result;
					} else {
						vm.userList = [];
						result.forEach(function(e) {
							if (e.isSuperAdmin == false) {
								vm.userList.push(e);
							}
						});
					}
					vm.loadBranchList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadBranchList = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		/* ******************************************************************** */

		vm.selectedBranchChanged = function() 
		{
			vm.group.branchId = vm.selectedBranch.id;
		}

		vm.clearBranch = function() 
		{
			vm.group.branchId = null;
			vm.selectedBranch = null;
		}

		/* ******************************************************************** */

		vm.showAddDevicePanel = function()
		{
			vm.addDevicePanelVisible = true;
		}

		vm.closeAddDevicePanel = function()
		{
			vm.addDevicePanelVisible = false;
		}

		vm.showAddUserPanel = function()
		{
			vm.addUserPanelVisible = true;
		}

		vm.closeAddUserPanel = function()
		{
			vm.addUserPanelVisible = false;
		}

		/* ******************************************************************** */

		vm.addGateway = function()
		{
			if(vm.selectedGateway==null)
			{
				toastr.warning("Select a gateway first.");
				return;
			}

			var isFound = false;
			vm.group.siotGroupDevices.forEach(function(d) {
				if(d.gatewayId==vm.selectedGateway.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Gateway is already exist on the list.");
				return;
			}

			vm.group.siotGroupDevices.push({
				gatewayId: vm.selectedGateway.id,
				deviceUID: vm.selectedGateway.deviceUID,
				deviceUUID: vm.selectedGateway.deviceUUID,
				description: vm.selectedGateway.description,
				deviceType: 'GATEWAY'
			});
			toastr.success("Gateway added to the list.");
		}

		vm.addSensor = function()
		{
			if(vm.selectedSensor==null)
			{
				toastr.warning("Select a sensor first.");
				return;
			}

			var isFound = false;
			vm.group.siotGroupDevices.forEach(function(d) {
				if(d.sensorId==vm.selectedSensor.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Sensor is already exist on the list.");
				return;
			}

			vm.group.siotGroupDevices.push({
				sensorId: vm.selectedSensor.id,
				deviceUID: vm.selectedSensor.deviceUID,
				deviceUUID: vm.selectedSensor.deviceUUID,
				description: vm.selectedSensor.description,
				deviceType: 'SENSOR'
			});
			toastr.success("Sensor added to the list.");			
		}

		vm.removeDevice = function(index)
		{			
			vm.group.siotGroupDevices.splice(index, 1);
			toastr.info("Device has been removed.");
		}		

		/* ******************************************************************** */

		vm.addAllUsers = function()
		{
			vm.userList.forEach(function(u) {
				var isFound = false;
				vm.group.siotGroupUsers.forEach(function(d) {
					if(d.userId==u.id)
					{
						isFound=true;
					}
				});
	
				if(!isFound)
				{	
					vm.group.siotGroupUsers.push({
						userId: u.id,
						name: (u.firstName + ' ' + u.lastName).toUpperCase(),
					});
				}
			});
			
			toastr.success("All Users added to the list.");			
		}

		vm.addUser = function()
		{
			if(vm.selectedUser==null)
			{
				toastr.warning("Select a user first.");
				return;
			}

			var isFound = false;
			vm.group.siotGroupUsers.forEach(function(d) {
				if(d.userId==vm.selectedUser.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected User is already exist on the list.");
				return;
			}

			vm.group.siotGroupUsers.push({
				userId: vm.selectedUser.id,
				name: (vm.selectedUser.firstName + ' ' + vm.selectedUser.lastName).toUpperCase(),
			});
			toastr.success("User added to the list.");			
		}

		vm.removeAllUsers = function()
		{			
			vm.group.siotGroupUsers = [];
			toastr.info("All Users have been removed.");
		}	

		vm.removeUser = function(index)
		{			
			vm.group.siotGroupUsers.splice(index, 1);
			toastr.info("User has been removed.");
		}	

		/* ******************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('smartiot/groups', vm.group, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Device Group has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('smartiotsettings.devicegroups.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadGatewayList();
	}

	/** @ngInject */
	function SmartIoTDeviceGroupUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.group = {};
		vm.gatewayList = [];
		vm.sensorList = [];
		vm.userList = [];
		vm.branchList = [];
		vm.selectedGateway = null;
		vm.selectedSensor = null;
		vm.selectedUser = null;
		vm.addDevicePanelVisible = false;
		vm.addUserPanelVisible = false;

		/* ******************************************************************** */

		vm.loadGatewayList = function() {
			HttpSvc.get('smartiot/gateways/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.gatewayList = result;
					vm.loadSensorList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadSensorList = function() {
			HttpSvc.get('smartiot/sensors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sensorList = result;
					vm.loadUserList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadUserList = function() {
			HttpSvc.get('users/listallwithaccess', {}, Auth.getTokenId(), true)
				.then(function(result) {
					if (Auth.isSuperAdmin()) { 
						vm.userList = result;
					} else {
						vm.userList = [];
						result.forEach(function(e) {
							if (e.isSuperAdmin == false) {
								vm.userList.push(e);
							}
						});
					}
					vm.loadBranchList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadBranchList = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadData();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadData = function() {
			var params = { id: $stateParams.id };

			HttpSvc.get('smartiot/groups/:id' , params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.group = result;

					vm.branchList.forEach(function(b) {
						if(b.id==vm.group.branchId)
						{
							vm.selectedBranch = b;
						}
					});
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		/* ******************************************************************** */

		vm.selectedBranchChanged = function() 
		{
			vm.group.branchId = vm.selectedBranch.id;
		}

		vm.clearBranch = function() 
		{
			vm.group.branchId = null;
			vm.selectedBranch = null;
		}

		/* ******************************************************************** */

		vm.showAddDevicePanel = function()
		{
			vm.addDevicePanelVisible = true;
		}

		vm.closeAddDevicePanel = function()
		{
			vm.addDevicePanelVisible = false;
		}

		vm.showAddUserPanel = function()
		{
			vm.addUserPanelVisible = true;
		}

		vm.closeAddUserPanel = function()
		{
			vm.addUserPanelVisible = false;
		}

		/* ******************************************************************** */

		vm.addGateway = function()
		{
			if(vm.selectedGateway==null)
			{
				toastr.warning("Select a gateway first.");
				return;
			}

			var isFound = false;
			vm.group.siotGroupDevices.forEach(function(d) {
				if(d.gatewayId==vm.selectedGateway.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Gateway is already exist on the list.");
				return;
			}

			vm.group.siotGroupDevices.push({
				gatewayId: vm.selectedGateway.id,
				deviceUID: vm.selectedGateway.deviceUID,
				deviceUUID: vm.selectedGateway.deviceUUID,
				description: vm.selectedGateway.description,
				deviceType: 'GATEWAY'
			});
			toastr.success("Gateway added to the list.");
		}

		vm.addSensor = function()
		{
			if(vm.selectedSensor==null)
			{
				toastr.warning("Select a sensor first.");
				return;
			}

			var isFound = false;
			vm.group.siotGroupDevices.forEach(function(d) {
				if(d.sensorId==vm.selectedSensor.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected Sensor is already exist on the list.");
				return;
			}

			vm.group.siotGroupDevices.push({
				sensorId: vm.selectedSensor.id,
				deviceUID: vm.selectedSensor.deviceUID,
				deviceUUID: vm.selectedSensor.deviceUUID,
				description: vm.selectedSensor.description,
				deviceType: 'SENSOR'
			});
			toastr.success("Sensor added to the list.");			
		}

		vm.removeDevice = function(index)
		{			
			vm.group.siotGroupDevices.splice(index, 1);
			toastr.info("Device has been removed.");
		}		

		/* ******************************************************************** */

		vm.addAllUsers = function()
		{
			vm.userList.forEach(function(u) {
				var isFound = false;
				vm.group.siotGroupUsers.forEach(function(d) {
					if(d.userId==u.id)
					{
						isFound=true;
					}
				});
	
				if(!isFound)
				{	
					vm.group.siotGroupUsers.push({
						userId: u.id,
						name: (u.firstName + ' ' + u.lastName).toUpperCase(),
					});
				}
			});
			
			toastr.success("All Users added to the list.");			
		}

		vm.addUser = function()
		{
			if(vm.selectedUser==null)
			{
				toastr.warning("Select a user first.");
				return;
			}

			var isFound = false;
			vm.group.siotGroupUsers.forEach(function(d) {
				if(d.userId==vm.selectedUser.id)
				{
					isFound=true;
				}
			});

			if(isFound)
			{
				toastr.warning("Selected User is already exist on the list.");
				return;
			}

			vm.group.siotGroupUsers.push({
				userId: vm.selectedUser.id,
				name: (vm.selectedUser.firstName + ' ' + vm.selectedUser.lastName).toUpperCase(),
			});
			toastr.success("User added to the list.");			
		}

		vm.removeAllUsers = function()
		{			
			vm.group.siotGroupUsers = [];
			toastr.info("All Users have been removed.");
		}	

		vm.removeUser = function(index)
		{			
			vm.group.siotGroupUsers.splice(index, 1);
			toastr.info("User has been removed.");
		}	

		/* ******************************************************************** */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('smartiot/groups/' + $stateParams.id, vm.group, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Gateway has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadGatewayList();		
	};

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.smartiotsettings.gateways.controller', [])
			.controller('SmartIoTGatewayMainCtrl', SmartIoTGatewayMainCtrl)
			.controller('SmartIoTGatewayCreateCtrl', SmartIoTGatewayCreateCtrl)
			.controller('SmartIoTGatewayUpdateCtrl', SmartIoTGatewayUpdateCtrl)
			.controller('SmartIoTGatewayCloneModalCtrl', SmartIoTGatewayCloneModalCtrl)
			.controller('SmartIoTGatewayTriggerSetupModalCtrl', SmartIoTGatewayTriggerSetupModalCtrl);

	/** @ngInject */
	function SmartIoTGatewayMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.gatewayDataFull = [];
		vm.gatewayData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.gatewayDataFull, tableState.search.predicateObject) : vm.gatewayDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.gatewayData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.gatewayDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('smartiot/gateways/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.gatewayDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteGateway = function(gatewayId, gatewayName) {
			var params = {};
			HttpSvc.delete('smartiot/gateways/' + gatewayId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('smartiot/gateways/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.gatewayDataFull = result;
							
							toastr.success('The gateway [' + gatewayName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the gateway [' + gatewayName + '].', 'Delete Failed');
					return null;
		});
	};
};

/** @ngInject */
	function SmartIoTGatewayCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.gateway = {};
		vm.deviceList = [];
		vm.timeList = GetTimeList();
		vm.instrumentList = GetInstrumentTypeList();
		vm.selectedBranch = null;
		vm.selectedDevice = null;
		vm.selectedDevice01InstrumentType = null;
		vm.selectedDevice01TimerStartTime = null;
		vm.selectedDevice01TimerEndTime = null;
		vm.selectedDevice02InstrumentType = null;
		vm.selectedDevice02TimerStartTime = null;
		vm.selectedDevice02TimerEndTime = null;
		vm.selectedDevice03InstrumentType = null;
		vm.selectedDevice03TimerStartTime = null;
		vm.selectedDevice03TimerEndTime = null;
		vm.selectedDevice04InstrumentType = null;
		vm.selectedDevice04TimerStartTime = null;
		vm.selectedDevice04TimerEndTime = null;
		vm.selectedDevice05InstrumentType = null;
		vm.selectedDevice05TimerStartTime = null;
		vm.selectedDevice05TimerEndTime = null;

		/* ******************************************************************** */
	
		vm.loadDevices = function() {
			HttpSvc.get('smartiot/devicemasters/list/available/gateways', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.deviceList = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});
	
		}

		/* ******************************************************************** */

		vm.selectedDeviceChanged = function() {
			vm.gateway.deviceId = vm.selectedDevice.id;
			vm.gateway.deviceUID = vm.selectedDevice.deviceUID;
		}

		vm.clearDevice = function() {
			vm.selectedDevice = null;
			vm.gateway.deviceId = "";
			vm.gateway.deviceUID = "";
		}

		/* ******************************************************************** */

		vm.selectedDevice01InstrumentTypeChanged = function() {
			vm.gateway.deviceIO_01_InstrumentType = vm.selectedDevice01InstrumentType.id;
		}

		vm.selectedDevice01TimerStartTimeChanged = function() {
			vm.gateway.deviceIO_01_TimerStartTime = vm.selectedDevice01TimerStartTime.id;
		}

		vm.selectedDevice01TimerEndTimeChanged = function() {
			vm.gateway.deviceIO_01_TimerEndTime = vm.selectedDevice01TimerEndTime.id;
		}

		/* ******************************************************************** */

		vm.selectedDevice02InstrumentTypeChanged = function() {
			vm.gateway.deviceIO_02_InstrumentType = vm.selectedDevice02InstrumentType.id;
		}

		vm.selectedDevice02TimerStartTimeChanged = function() {
			vm.gateway.deviceIO_02_TimerStartTime = vm.selectedDevice02TimerStartTime.id;
		}

		vm.selectedDevice02TimerEndTimeChanged = function() {
			vm.gateway.deviceIO_02_TimerEndTime = vm.selectedDevice02TimerEndTime.id;
		}

		/* ******************************************************************** */

		vm.selectedDevice03InstrumentTypeChanged = function() {
			vm.gateway.deviceIO_03_InstrumentType = vm.selectedDevice03InstrumentType.id;
		}

		vm.selectedDevice03TimerStartTimeChanged = function() {
			vm.gateway.deviceIO_03_TimerStartTime = vm.selectedDevice03TimerStartTime.id;
		}

		vm.selectedDevice03TimerEndTimeChanged = function() {
			vm.gateway.deviceIO_03_TimerEndTime = vm.selectedDevice03TimerEndTime.id;
		}

		/* ******************************************************************** */

		vm.selectedDevice04InstrumentTypeChanged = function() {
			vm.gateway.deviceIO_04_InstrumentType = vm.selectedDevice04InstrumentType.id;
		}

		vm.selectedDevice04TimerStartTimeChanged = function() {
			vm.gateway.deviceIO_04_TimerStartTime = vm.selectedDevice04TimerStartTime.id;
		}

		vm.selectedDevice04TimerEndTimeChanged = function() {
			vm.gateway.deviceIO_04_TimerEndTime = vm.selectedDevice04TimerEndTime.id;
		}

		/* ******************************************************************** */

		vm.selectedDevice05InstrumentTypeChanged = function() {
			vm.gateway.deviceIO_05_InstrumentType = vm.selectedDevice05InstrumentType.id;
		}

		vm.selectedDevice05TimerStartTimeChanged = function() {
			vm.gateway.deviceIO_05_TimerStartTime = vm.selectedDevice05TimerStartTime.id;
		}

		vm.selectedDevice05TimerEndTimeChanged = function() {
			vm.gateway.deviceIO_05_TimerEndTime = vm.selectedDevice05TimerEndTime.id;
		}

		/* ******************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('smartiot/gateways', vm.gateway, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Gateway has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('smartiotsettings.gateways.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadDevices();
	}

/** @ngInject */
	function SmartIoTGatewayUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.gateway = {};
		vm.gateway.siotGatewayIOTriggerConditions = [];
		vm.deviceList = [];
		vm.timeList = GetTimeList();
		vm.instrumentList = GetInstrumentTypeList();
		vm.selectedDevice = null;
		vm.selectedDevice01InstrumentType = null;
		vm.selectedDevice01TimerStartTime = null;
		vm.selectedDevice01TimerEndTime = null;
		vm.selectedDevice02InstrumentType = null;
		vm.selectedDevice02TimerStartTime = null;
		vm.selectedDevice02TimerEndTime = null;
		vm.selectedDevice03InstrumentType = null;
		vm.selectedDevice03TimerStartTime = null;
		vm.selectedDevice03TimerEndTime = null;
		vm.selectedDevice04InstrumentType = null;
		vm.selectedDevice04TimerStartTime = null;
		vm.selectedDevice04TimerEndTime = null;
		vm.selectedDevice05InstrumentType = null;
		vm.selectedDevice05TimerStartTime = null;
		vm.selectedDevice05TimerEndTime = null;

		/* ******************************************************************** */

		vm.loadDevices = function() {
			var deviceId = "";
			if(vm.gateway.deviceId!=null)
			{
				deviceId = "/" + vm.gateway.deviceId;
			}


			HttpSvc.get('smartiot/devicemasters/list/available/gateways' + deviceId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.deviceList = result;

					if(vm.gateway.deviceId!=null)
					{
						vm.deviceList.forEach(function(d) {
							if(d.id==vm.gateway.deviceId) {
								vm.selectedDevice=d;
							}
						});
					}
					
				}, function(error) {
					toastr.error(error, 'Failed');
				});

		}
						
		// Load Gateway
		vm.loadGateway = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('smartiot/gateways/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.gateway = result;

					vm.populateDDSelections();
					vm.loadDevices();
					vm.loadChangeLogs();
				}, function() {
					toastr.error('Failed to load selected Gateway.', Auth.translate('ERROR'))
					$state.go('smartiotsettings.gateways.list');
					return;
				});		
		};	
						
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('smartiot/gateways/changelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};

		vm.populateDDSelections = function() {
			vm.instrumentList.forEach(function(i) {
				if(vm.gateway.deviceIO_01_InstrumentType==i.id)
				{
					vm.selectedDevice01InstrumentType = i;
				}
				if(vm.gateway.deviceIO_02_InstrumentType==i.id)
				{
					vm.selectedDevice02InstrumentType = i;
				}
				if(vm.gateway.deviceIO_03_InstrumentType==i.id)
				{
					vm.selectedDevice03InstrumentType = i;
				}
				if(vm.gateway.deviceIO_04_InstrumentType==i.id)
				{
					vm.selectedDevice04InstrumentType = i;
				}
				if(vm.gateway.deviceIO_05_InstrumentType==i.id)
				{
					vm.selectedDevice05InstrumentType = i;
				}
			});
			
			vm.timeList.forEach(function(t) {
				if(vm.gateway.deviceIO_01_TimerStartTime==t.id)
				{
					vm.selectedDevice01TimerStartTime = t;
				}
				if(vm.gateway.deviceIO_01_TimerEndTime==t.id)
				{
					vm.selectedDevice01TimerEndTime = t;
				}

				if(vm.gateway.deviceIO_02_TimerStartTime==t.id)
				{
					vm.selectedDevice02TimerStartTime = t;
				}
				if(vm.gateway.deviceIO_02_TimerEndTime==t.id)
				{
					vm.selectedDevice02TimerEndTime = t;
				}

				if(vm.gateway.deviceIO_03_TimerStartTime==t.id)
				{
					vm.selectedDevice03TimerStartTime = t;
				}
				if(vm.gateway.deviceIO_03_TimerEndTime==t.id)
				{
					vm.selectedDevice03TimerEndTime = t;
				}

				if(vm.gateway.deviceIO_04_TimerStartTime==t.id)
				{
					vm.selectedDevice04TimerStartTime = t;
				}
				if(vm.gateway.deviceIO_04_TimerEndTime==t.id)
				{
					vm.selectedDevice04TimerEndTime = t;
				}

				if(vm.gateway.deviceIO_05_TimerStartTime==t.id)
				{
					vm.selectedDevice05TimerStartTime = t;
				}
				if(vm.gateway.deviceIO_05_TimerEndTime==t.id)
				{
					vm.selectedDevice05TimerEndTime = t;
				}
			});
		}

		vm.displayTriggerCondition = function(condition) {
			var polishedCondition = "";
			var deviceList = GetDeviceReadingOptions();
			var directionList = GetDirectionList();

			if(condition!=null && condition!='')
			{
				var array = condition.split(' ');
				
				deviceList.forEach(function(d) {
					if(d.id==array[0])
					{
						polishedCondition += d.name + ' ';
					}
				});

				directionList.forEach(function(d) {
					if(d.id==array[1])
					{
						polishedCondition += d.name + ' ';
					}
				});

				polishedCondition += array[2];
			}

			return polishedCondition;
		}

		/* ******************************************************************** */

		vm.selectedDeviceChanged = function() {
			vm.gateway.deviceId = vm.selectedDevice.id;
			vm.gateway.deviceUID = vm.selectedDevice.deviceUID;
		}

		vm.clearDevice = function() {
			vm.selectedDevice = null;
			vm.gateway.deviceId = "";
			vm.gateway.deviceUID = "";
		}

		/* ******************************************************************** */

		vm.selectedDevice01InstrumentTypeChanged = function() {
			vm.gateway.deviceIO_01_InstrumentType = vm.selectedDevice01InstrumentType.id;
		}

		vm.selectedDevice01TimerStartTimeChanged = function() {
			vm.gateway.deviceIO_01_TimerStartTime = vm.selectedDevice01TimerStartTime.id;
		}

		vm.selectedDevice01TimerEndTimeChanged = function() {
			vm.gateway.deviceIO_01_TimerEndTime = vm.selectedDevice01TimerEndTime.id;
		}

		/* ******************************************************************** */

		vm.selectedDevice02InstrumentTypeChanged = function() {
			vm.gateway.deviceIO_02_InstrumentType = vm.selectedDevice02InstrumentType.id;
		}

		vm.selectedDevice02TimerStartTimeChanged = function() {
			vm.gateway.deviceIO_02_TimerStartTime = vm.selectedDevice02TimerStartTime.id;
		}

		vm.selectedDevice02TimerEndTimeChanged = function() {
			vm.gateway.deviceIO_02_TimerEndTime = vm.selectedDevice02TimerEndTime.id;
		}

		/* ******************************************************************** */

		vm.selectedDevice03InstrumentTypeChanged = function() {
			vm.gateway.deviceIO_03_InstrumentType = vm.selectedDevice03InstrumentType.id;
		}

		vm.selectedDevice03TimerStartTimeChanged = function() {
			vm.gateway.deviceIO_03_TimerStartTime = vm.selectedDevice03TimerStartTime.id;
		}

		vm.selectedDevice03TimerEndTimeChanged = function() {
			vm.gateway.deviceIO_03_TimerEndTime = vm.selectedDevice03TimerEndTime.id;
		}

		/* ******************************************************************** */

		vm.selectedDevice04InstrumentTypeChanged = function() {
			vm.gateway.deviceIO_04_InstrumentType = vm.selectedDevice04InstrumentType.id;
		}

		vm.selectedDevice04TimerStartTimeChanged = function() {
			vm.gateway.deviceIO_04_TimerStartTime = vm.selectedDevice04TimerStartTime.id;
		}

		vm.selectedDevice04TimerEndTimeChanged = function() {
			vm.gateway.deviceIO_04_TimerEndTime = vm.selectedDevice04TimerEndTime.id;
		}

		/* ******************************************************************** */

		vm.selectedDevice05InstrumentTypeChanged = function() {
			vm.gateway.deviceIO_05_InstrumentType = vm.selectedDevice05InstrumentType.id;
		}

		vm.selectedDevice05TimerStartTimeChanged = function() {
			vm.gateway.deviceIO_05_TimerStartTime = vm.selectedDevice05TimerStartTime.id;
		}

		vm.selectedDevice05TimerEndTimeChanged = function() {
			vm.gateway.deviceIO_05_TimerEndTime = vm.selectedDevice05TimerEndTime.id;
		}

		/* ******************************************************************** */
					
		// Open Clone Recipe Modal Dialog
		vm.showTransferModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'TransferGatewayModal.html',
				controller: 'SmartIoTGatewayCloneModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							gatewayId: vm.gateway.id,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					$state.go('smartiotsettings.gateways.list');
				}, function () {
				});
		};	

		/* ******************************************************************** */

		vm.addTriggerSetup = function (ioNo) 
		{
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'TriggerSetupModal.html',
				controller: 'SmartIoTGatewayTriggerSetupModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							ioNo: ioNo							
						}
					}
				}
			});
			
			modalInstance
				.result
				.then(function (data) {
					vm.addTrigger(data);
				}, function () {
				});
		}

		vm.editTriggerSetup = function (ioNo, obj) 
		{
			var condition = angular.copy(obj);

			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'TriggerSetupModal.html',
				controller: 'SmartIoTGatewayTriggerSetupModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							ioNo: ioNo,
							condition: condition
						}
					}
				}
			});
			
			modalInstance
				.result
				.then(function (data) {
					vm.updateTrigger(data);
				}, function () {
				});
		}

		vm.deleteTriggerSetup = function (id)
		{
			for	(var x=0; x<vm.gateway.siotGatewayIOTriggerConditions.length; x++)
			{
				var condition = vm.gateway.siotGatewayIOTriggerConditions[x];
				if(condition.id==id)
				{
					vm.gateway.siotGatewayIOTriggerConditions.splice(x, 1);
					return;
				}
			}
		}

		/* ******************************************************************** */
		
		vm.addTrigger = function(data) {
			var isFound = false;
			vm.gateway.siotGatewayIOTriggerConditions.forEach(function(c) {
				if(c.triggerDeviceIO==data.triggerDeviceIO &&
					c.triggerSensorId==data.triggerSensorId &&
					c.triggerMetric==data.triggerMetric)
				{
					isFound = true;	
				}
			})

			if(isFound)
			{
				toastr.warning('The same condition already exists.', 'Opeartion Aborted');
				return;
			}

			vm.gateway.siotGatewayIOTriggerConditions.push(data);
		}
		
		vm.updateTrigger = function(data) {
			var isFound = false;
			vm.gateway.siotGatewayIOTriggerConditions.forEach(function(c) {
				if(c.triggerDeviceIO==data.triggerDeviceIO &&
					c.triggerSensorId==data.triggerSensorId &&
					c.triggerMetric==data.triggerMetric &&
					c.id != data.id)
				{
					isFound = true;	
				}
			})

			if(isFound)
			{
				toastr.warning('The same condition already exists.', 'Opeartion Aborted');
				return;
			}
			
			for	(var x=0; x<vm.gateway.siotGatewayIOTriggerConditions.length; x++)
			{
				var condition = vm.gateway.siotGatewayIOTriggerConditions[x];
				if(condition.id==data.id)
				{
					vm.gateway.siotGatewayIOTriggerConditions.splice(x, 1, data);
					toastr.info('Trigger condition updated.');
					return;
				}
			}
		}

		/* ******************************************************************** */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('smartiot/gateways/' + $stateParams.id, vm.gateway, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Gateway has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadGateway();		
	};
	
	// Clone Recipe Modal Controller
	function SmartIoTGatewayCloneModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.companies = [];
		$mdl.branches = [];
		$mdl.gatewayId = item.gatewayId;
		$mdl.selectedCompany = null;
		$mdl.selectedBranch = null;
		$mdl.selectedCompanyId = "";
		$mdl.selectedBranchId = "";
		$mdl.lockButtons = false;
				
		/* ******************************************************** */

		$mdl.loadCompanies = function() {
			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.companies = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		};
		
		$mdl.loadBranches = function() {
			HttpSvc.get('branches/listbycompany/' + $mdl.selectedCompanyId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.branches = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		};

		/* ******************************************************** */

		$mdl.selectedCompanyChanged = function()
		{
			$mdl.selectedCompanyId = $mdl.selectedCompany.id;
			$mdl.loadBranches();
		}
		
		$mdl.selectedBranchChanged = function()
		{
			$mdl.selectedBranchId = $mdl.selectedBranch.id;			
		}

		/* ******************************************************** */
		
		$mdl.confirmModal = function() {			
			if($mdl.cloneForm.$valid) {				
				$mdl.lockButtons = true;
								
				HttpSvc.post("smartiot/gateways/transfer/" + $mdl.gatewayId + "/" + $mdl.selectedCompanyId + "/" + $mdl.selectedBranchId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Gateway has been transferred successfully to <b>' + 
							$mdl.selectedCompany.name + '</b> - <b>' + $mdl.selectedBranch.name + '</b>.')
						$uibModalInstance.close();
					}, function(error) {
						$mdl.lockButtons = false;
						toastr.error(error, 'Failed');
					});	
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Initial Call
		$mdl.loadCompanies();
	};
	
	// Trigger Setup Modal Controller
	function SmartIoTGatewayTriggerSetupModalCtrl($uibModalInstance, Auth, HttpSvc, UtilSvc, item, toastr) {
		var $mdl = this;
		$mdl.mode = item.mode;
		$mdl.ioNo = item.ioNo;
		
		$mdl.directionList = GetDirectionList();
		$mdl.condition = {};
		$mdl.sensorList = [];
		$mdl.metricList = [];
		$mdl.selectedSensor = null;
		$mdl.selectedMetric = null;
		$mdl.selectedDirection = null;
						
		/* ******************************************************** */

		$mdl.initData = function() 
		{			
			if($mdl.mode==1)
			{
				$mdl.condition.id = UtilSvc.generateGuid();
				$mdl.condition.triggerDeviceIO = $mdl.ioNo;
			}
			else
			{
				$mdl.condition = item.condition;
			}
			$mdl.loadSensorList();
		}

		$mdl.loadSensorList = function() {

			HttpSvc.get('smartiot/sensors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.sensorList = result;

					if($mdl.mode==2)
					{
						$mdl.sensorList.forEach(function(s) {
							if(s.id==$mdl.condition.triggerSensorId)
							{
								$mdl.selectedSensor = s;
								$mdl.selectedSensorChanged();
							}
						});

						$mdl.metricList.forEach(function(m) {
							if(m.id==$mdl.condition.triggerMetric)
							{
								$mdl.selectedMetric = m;
							}
						});

						$mdl.directionList.forEach(function(d) {
							if(d.id==$mdl.condition.triggerCompare)
							{
								$mdl.selectedDirection = d;
							}
						});
					}
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		/* ******************************************************** */

		$mdl.selectedSensorChanged = function() {
			$mdl.condition.triggerSensorId = $mdl.selectedSensor.id;
			$mdl.condition.description = $mdl.selectedSensor.description;
			$mdl.condition.deviceUID = $mdl.selectedSensor.deviceUID;
			$mdl.condition.deviceUUID = $mdl.selectedSensor.deviceUUID;
			$mdl.metricList = [];

			if($mdl.selectedSensor.hasTemp)
			{
				$mdl.metricList.push({ id:'TEMP', name:'TEMPERATURE' });
			}
			if($mdl.selectedSensor.hasHumi)
			{
				$mdl.metricList.push({ id:'HUMI', name:'HUMIDITY' });
			}
			if($mdl.selectedSensor.hasNPK)
			{
				$mdl.metricList.push({ id:'N', name:'NITROGEN (N)' });
				$mdl.metricList.push({ id:'P', name:'PHOSPHORUS (P)' });
				$mdl.metricList.push({ id:'K', name:'POTASSIUM (K)' });
			}
			if($mdl.selectedSensor.hasEc)
			{
				$mdl.metricList.push({ id:'EC', name:'ELEC CONDUCTIVITY' });
			}
			if($mdl.selectedSensor.hasPh)
			{
				$mdl.metricList.push({ id:'PH', name:'PH LEVEL' });
			}
			if($mdl.selectedSensor.hasPm)
			{
				$mdl.metricList.push({ id:'PM', name:'PM2.5' });
			}
		}

		$mdl.selectedMetricChanged = function() {
			$mdl.condition.triggerMetric = $mdl.selectedMetric.id;
		}

		$mdl.selectedDirectionChanged = function() {
			$mdl.condition.triggerCompare = $mdl.selectedDirection.id;
		}

		/* ******************************************************** */
		
		$mdl.confirmModal = function() {
			if($mdl.setupForm.$valid) {
				$uibModalInstance.close($mdl.condition);
			}
			else
			{
				toastr.error('Please fill in all the fields.', Auth.translate('ERROR'));
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Init Call
		$mdl.initData();
	};
	
	
	function GetTimeList() {
		var timeList = [
			{ id:'00:00', name:'12:00 AM' },
			{ id:'01:00', name:'01:00 AM' },
			{ id:'02:00', name:'02:00 AM' },
			{ id:'03:00', name:'03:00 AM' },
			{ id:'04:00', name:'04:00 AM' },
			{ id:'05:00', name:'05:00 AM' },
			{ id:'06:00', name:'06:00 AM' },
			{ id:'07:00', name:'07:00 AM' },
			{ id:'08:00', name:'08:00 AM' },
			{ id:'09:00', name:'09:00 AM' },
			{ id:'10:00', name:'10:00 AM' },
			{ id:'11:00', name:'11:00 AM' },
			{ id:'12:00', name:'12:00 PM' },
			{ id:'13:00', name:'01:00 PM' },
			{ id:'14:00', name:'02:00 PM' },
			{ id:'15:00', name:'03:00 PM' },
			{ id:'16:00', name:'04:00 PM' },
			{ id:'17:00', name:'05:00 PM' },
			{ id:'18:00', name:'06:00 PM' },
			{ id:'19:00', name:'07:00 PM' },
			{ id:'20:00', name:'08:00 PM' },
			{ id:'21:00', name:'09:00 PM' },
			{ id:'22:00', name:'10:00 PM' },
			{ id:'23:00', name:'11:00 PM' }
		];

		return timeList;
	}

	function GetInstrumentTypeList() {
		var instrumentTypes = [
			{ id:'001', name:'T/H Dual Controller' },
			{ id:'002', name:'Audio Equipment' },
			{ id:'003', name:'Standard Electrical Device' }
		];

		return instrumentTypes;
	}

	function GetDirectionList() {
		var directionList = [
			{ id:'>', name:'>' },
			{ id:'>=', name:'>=' },
			{ id:'<', name:'<' },
			{ id:'<=', name:'<=' }
		];

		return directionList;
	}

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.smartiotsettings.notifications.controller', [])
			.controller('SmartIoTNotificationMainCtrl', SmartIoTNotificationMainCtrl)
			.controller('SmartIoTNotificationCreateCtrl', SmartIoTNotificationCreateCtrl)
			.controller('SmartIoTNotificationUpdateCtrl', SmartIoTNotificationUpdateCtrl);

	/** @ngInject */
	function SmartIoTNotificationMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.settingDataFull = [];
		vm.settingData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.settingDataFull, tableState.search.predicateObject) : vm.settingDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.settingData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.settingDataFull.length <= 0) {				
				HttpSvc.get('smartiot/notificationsettings/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.settingDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteSetting = function(settingId) {
			var params = {};
			HttpSvc.delete('smartiot/notificationsettings/' + settingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('smartiot/notificationsettings/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.settingDataFull = result;
							
							toastr.success('The setting has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the setting.', 'Delete Failed');
					return null;
			});
	};
};

/** @ngInject */
	function SmartIoTNotificationCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.users = [];
		vm.sensorList = [];
		vm.setting = {};
		vm.setting.isThirdParty = false;
		vm.selectedBranch = null;
		vm.selectedUser = null;
		vm.selectedSensor = null;

		/* **************************************************************** */
	
		vm.loadUsers = function() {
			HttpSvc.get("users/listallwithaccess", vm.setting, Auth.getTokenId(), true)
				.then(function(result) {
					if (Auth.isSuperAdmin()) { 
						vm.users = result;
					} else {
						vm.users = [];
						result.forEach(function(e) {
							if (e.isSuperAdmin == false) {
								vm.users.push(e);
							}
						});
					}
					vm.loadSensors();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		vm.loadSensors = function() {			
			HttpSvc.get('smartiot/sensors/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.sensorList = result;
				}, function(error) {
					toastr.error('Failed to retrieve active sensor list. ' + error, '');
					return null;
				});
		}

		/* **************************************************************** */

		vm.selectedUserChanged = function() {
			vm.setting.userId = vm.selectedUser.id;
		}

		vm.selectedSensorChanged = function() {
			vm.setting.sensorId = vm.selectedSensor.id;
		}

		vm.clearSensor = function() {
			vm.setting.sensorId = null;
			vm.selectedSensor = null;
		}

		/* **************************************************************** */
	
		vm.checkAlertOptions = function() {
			if(!vm.setting.alertByEmail)
			{
				vm.setting.email = null;
				vm.setting.branchId = null;
				vm.selectedBranch = null;
			}
			if(!vm.setting.alertByPN)
			{
				vm.setting.userId = null;
				vm.selectedUser = null;
			}
		}

		/* **************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.checkAlertOptions();

				HttpSvc.post('smartiot/notificationsettings', vm.setting, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Setting has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('smartiotsettings.notifications.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadUsers();
	}

/** @ngInject */
	function SmartIoTNotificationUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

	Auth.init();		
	
	var vm = this;
	vm.mode = 2;
	vm.setting = {};
	vm.users = [];
	vm.sensorList = [];
	vm.changeLogs = [];
	vm.selectedBranch = null;
	vm.selectedUser = null;
	vm.selectedSensor = null;

	/* **************************************************************** */

	vm.loadUsers = function() {
		HttpSvc.get('users/listallwithaccess', vm.setting, Auth.getTokenId(), true)
			.then(function(result) {
				if (Auth.isSuperAdmin()) { 
					vm.users = result;
				} else {
					vm.users = [];
					result.forEach(function(e) {
						if (e.isSuperAdmin == false) {
							vm.users.push(e);
						}
					});
				}
				vm.loadSensors();
			}, function(error) {
				toastr.error(error, 'Failed');
			});
	}		

	vm.loadSensors = function() {
		HttpSvc.get('smartiot/sensors/list', {}, Auth.getTokenId(), true)
			.then(function(result) {	
				vm.sensorList = result;				
				vm.loadSetting();
			}, function(error) {
				toastr.error('Failed to retrieve active sensor list. ' + error, '');
				return null;
			});
	}
						
	vm.loadChangeLogs = function() {
		HttpSvc.get('smartiot/notificationsettings/changelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
			.then(function(result) {	
				vm.changeLogs = result;
			}, function() {
				toastr.error('Failed to load the Change Logs.', '');
			});
	};
					
	vm.loadSetting = function() {
		var params = { id: $stateParams.id };
		HttpSvc.get('smartiot/notificationsettings/:id', params, Auth.getTokenId(), false)
			.then(function(result) {
				vm.setting = result;

				vm.users.forEach(function(u) {
					if(u.id==vm.setting.userId) {
						vm.selectedUser=u;
					}
				});

				vm.sensorList.forEach(function(s) {
					if(s.id==vm.setting.sensorId) {
						vm.selectedSensor=s;
					}
				});

				vm.loadChangeLogs();
			}, function() {
				toastr.error('Failed to load selected Setting.', Auth.translate('ERROR'))
				$state.go('smartiotsettings.notifications.list');
				return;
			});		
	};	

	/* **************************************************************** */

	vm.checkAlertOptions = function() {
		if(!vm.setting.alertByEmail)
		{
			vm.setting.email = null;
			vm.setting.branchId = null;
			vm.selectedBranch = null;
		}
		if(!vm.setting.alertByPN)
		{
			vm.setting.userId = null;
			vm.selectedUser = null;
		}
	}

	/* **************************************************************** */

	vm.selectedUserChanged = function() {
		vm.setting.userId = vm.selectedUser.id;
	}

	vm.selectedSensorChanged = function() {
		vm.setting.sensorId = vm.selectedSensor.id;
	}

	vm.clearSensor = function() {
		vm.setting.sensorId = null;
		vm.selectedSensor = null;
	}

	/* **************************************************************** */
	
	// Form Submission
	vm.submit = function() {
		if(vm.dataForm.$invalid) {
			toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
		} else {
			vm.checkAlertOptions();

			HttpSvc.put('smartiot/notificationsettings/' + $stateParams.id, vm.setting, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Setting has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
	}
		
	// Call Actions
	vm.loadUsers();		
}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.smartkitchen.joblist.controller', [])
	.controller('SmartKitchenJobListCtrl', SmartKitchenJobListCtrl)
	.controller('SmartKitchenJobCtrl', SmartKitchenJobCtrl);

    /** @ngInject */
    function SmartKitchenJobListCtrl($scope, $interval, Auth, HttpSvc, RmsApi, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.dataList = [];
		vm.blobUrl = RmsApi.BLOBURL;
		vm.isLoading = false;
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.interval = null;

		/* ************************************************************************* */

		vm.init = function() {
			vm.loadList();
			vm.interval = $interval(vm.loadList, 5000);
		};

		vm.loadList = function() {
			vm.isLoading = true;

			HttpSvc.get('smartkitchen/jobs/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.dataList = [];
					vm.dataList = result;
					vm.isLoading = false;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}
		
		vm.navigateJob = function() {

		}

		vm.completeAllJobs= function() {
			vm.isLoading = true;

			HttpSvc.put('smartkitchen/jobs/all/complete', {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('All jobs have been completed.')
					vm.loadList();
				}, function(error) {
					// Failed
					toastr.error('Failed to complete all jobs. ' + error, 'Failed');
					return null;
				});
		}

		/* ************************************************************************* */

		vm.toggleFullscreen = function() {
			var element = document.getElementById('kitchenjoblist');
	  
			if(document.fullscreenElement ||
			  document.webkitFullscreenElement ||
			  document.mozFullScreenElement ||
			  document.msFullscreenElement)
			{
			  document.exitFullscreen();
			}
			else
			{
			  if (element.requestFullscreen) {
				element.requestFullscreen();
			  } else if (element.webkitRequestFullScreen) {
				element.webkitRequestFullScreen();
			  } else if (element.mozRequestFullScreen) {
				element.mozRequestFullScreen();
			  } else if (element.msRequestFullScreen) {
				element.msRequestFullScreen();
			  }
			}			
		}
		
		/* *********************************************************** */

        $scope.$on('$destroy', function() {
            $interval.cancel(vm.interval);
        });

		vm.init();
    };

    /** @ngInject */
    function SmartKitchenJobCtrl($scope, $state, $stateParams, $timeout, Auth, HttpSvc, RmsApi, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.data = {};
		vm.blobUrl = RmsApi.BLOBURL;
		vm.currentStep = null;
		vm.isRunning = false;
		vm.selectedTab1 = true;
		vm.selectedTab2 = false;

		/* *********************************************************** */

		vm.toggleFullscreen = function() {
			var element = document.getElementById('kitchenjobdetail');
	  
			if(document.fullscreenElement ||
			  document.webkitFullscreenElement ||
			  document.mozFullScreenElement ||
			  document.msFullscreenElement)
			{
			  document.exitFullscreen();
			}
			else
			{
			  if (element.requestFullscreen) {
				element.requestFullscreen();
			  } else if (element.webkitRequestFullScreen) {
				element.webkitRequestFullScreen();
			  } else if (element.mozRequestFullScreen) {
				element.mozRequestFullScreen();
			  } else if (element.msRequestFullScreen) {
				element.msRequestFullScreen();
			  }
			}			
		}
		
		vm.sleep = function(ms) {
			return new Promise(function(resolve) {
			  	vm.timeout = $timeout(resolve, ms);
			});
		};
		
		vm.loadData = function() {
			var params = { id: $stateParams.id };

			HttpSvc.get('smartkitchen/jobs/:id', params, Auth.getTokenId(), false)
				.then(function(result) {		
					vm.data = result;	
					vm.data.timeLapsed = 0;
				}, function() {
					toastr.error('Failed to retrieve data.', '');
					$state.go('smartkitchen.joblist');
				});
		}	
		
		/* *********************************************************** */

		vm.selectTab1 = function() {
			vm.selectedTab1 = true;
			vm.selectedTab2 = false;
		}
		
		vm.selectTab2 = function() {
			vm.selectedTab2 = true;
			vm.selectedTab1 = false;
		}

		/* *********************************************************** */

		vm.startJob = function(isNew) {
			vm.data.isStarted = true;
			vm.isRunning = true;
			vm.selectTab2();

			// Start Job API
			HttpSvc.put('smartkitchen/jobs/' + vm.data.id + '/start', {}, Auth.getTokenId())
				.then(function() {	
				}, function() {
				});

			if(isNew) Auth.tts("Job started.");
			
			vm.sleep(1000).then(function() {
				vm.delayStartJob();
			});			  
		}

		vm.resumeJob = function() {		

			for(var x = 0; x < vm.data.retailKitchenJobSteps.length; x++)
			{
				var s = vm.data.retailKitchenJobSteps[x];

				if(s.isCompleted)
				{
					vm.data.timeLapsed += s.totalTimeSecond;
				}
			}

			Auth.tts("Job resumed.");

			vm.startJob();
		}

		vm.delayStartJob = function() {

			var isFound = false;
			
			for(var x = 0; x < vm.data.retailKitchenJobSteps.length; x++)
			{
				var s = vm.data.retailKitchenJobSteps[x];

				if(s.isCompleted != true)
				{
					isFound = true;
					s.isStarted = true;
					vm.currentStep = s;
					Auth.tts('Step ' + (s.step+1) + '. ' + s.description);

					// Start Step API
					HttpSvc.put('smartkitchen/jobs/step/' + s.id + '/start', {}, Auth.getTokenId())
						.then(function() {	
						}, function() {
						});

					vm.sleep(500).then(function() { 
						vm.workOnStep(s);
					});

					break;
				}
			};

			if(!isFound)
			{
				vm.data.isCompleted = true;

				Auth.tts('Job completed');

				// Complete Job API
				HttpSvc.put('smartkitchen/jobs/' + vm.data.id + '/complete', {}, Auth.getTokenId())
					.then(function() {	
					}, function() {
					});
			}
		}

		vm.completeJob = function() {
			$state.go('smartkitchen.joblist');
		}

		vm.workOnStep = function(s) {
			
			if(s.timeLapsed < s.totalTimeSecond)
			{
				s.timeLapsed += 1;
				vm.data.timeLapsed += 1;

				if(s.timeLapsed == s.totalTimeSecond)
				{					
					vm.sleep(900).then(function() { 
						s.isCompleted = true;
					});					
				}
			
				vm.sleep(1000).then(function() { 
					vm.workOnStep(s);
				});
			}
			else
			{
				vm.completeStep(s);
				vm.delayStartJob();
			}
		}

		vm.completeStep = function(s) {

			// Complete Step API
			HttpSvc.put('smartkitchen/jobs/step/' + s.id + '/complete', {}, Auth.getTokenId())
				.then(function() {	
				}, function() {
				});

			vm.sleep(500).then(function() { 
				s.isCompleted = true;
			});
		}

		/* *********************************************************** */

		vm.convertStoMs = function(seconds) {
			var minutes = Math.floor(seconds / 60);
			var extraSeconds = seconds % 60;
			minutes = minutes < 10 ? "0" + minutes : minutes;
			extraSeconds = extraSeconds< 10 ? "0" + extraSeconds : extraSeconds;
			return minutes + "m " + extraSeconds + "s";
		}

		/* *********************************************************** */

		//$timeout(vm.toggleFullscreen, 500);

		vm.loadData();
    };

})();
(function() {
	'use strict';

	angular.module('RmsAppV2.pages.smartiotsettings.planviewdesigner.controller', [])
			.controller('SmartIoTPlanViewDesignerMainCtrl', SmartIoTPlanViewDesignerMainCtrl)
			.controller('SmartIoTPlanViewDesignerCreateCtrl', SmartIoTPlanViewDesignerCreateCtrl)
			.controller('SmartIoTPlanViewDesignerUpdateCtrl', SmartIoTPlanViewDesignerUpdateCtrl);

	/** @ngInject */
	function SmartIoTPlanViewDesignerMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.designDataFull = [];
		vm.designData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.designDataFull, tableState.search.predicateObject) : vm.designDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.designData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.designDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('smartiotplanviewdesigner/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.designDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteDesign = function(designId, designName) {
			var params = {};
			HttpSvc.delete('smartiotplanviewdesigner/' + designId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('smartiotplanviewdesigner/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.designDataFull = result;
							
							toastr.success('The design [' + designName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the design [' + designName + '].', 'Delete Failed');
					return null;
		});
	};
};

	/** @ngInject */
	function SmartIoTPlanViewDesignerCreateCtrl($scope, $state, Auth, HttpSvc, UtilSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.branches = [];
		vm.selectedBranch = null;
		vm.design = {};

		/* ******************************************************************** */
	
		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		/* ******************************************************************** */

		vm.selectedBranchChanged = function() {
			vm.design.branchId = vm.selectedBranch.id;
		}

		/* ******************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, 'Incomplete Fields');
			} else {
				HttpSvc.post('smartiotplanviewdesigner', vm.design, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Design has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('smartiotsettings.planviewdesigner.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadBranches();
	}

	/** @ngInject */
	function SmartIoTPlanViewDesignerUpdateCtrl($scope, $state, $stateParams, $timeout, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.design = {};
		vm.assets = [];
		vm.branches = [];
		vm.deviceGroups = [];
		vm.selectedBranch = null;
		vm.selectedGateway = null;
		vm.selectedSensor = null;
		vm.fileToUpload = null;
		vm.fileToUpload = null;
		vm.blobUrl = RmsApi.BLOBURL;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		vm.hasAssetAccess = Auth.hasCompanyFeature('assets');
		vm.hasIoTAccess = Auth.hasCompanyFeature('iotdashboard');
		vm.selectedTab = "1";

		/* ******************************************************************** */

		vm.initData = function() {
			if(!vm.hasAssetAccess) vm.selectedTab = "2";

			vm.loadBranches();
		}

		/* ******************************************************************** */

		vm.selectTab = function(tabNo) {
			vm.selectedTab = tabNo;
		}

		vm.selectedBranchChanged = function() {
			vm.design.branchId = vm.selectedBranch.id;
		}

		/* ******************************************************************** */

		vm.loadBranches = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branches = result;
					vm.loadDeviceGroups();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		vm.loadDeviceGroups = function() {
			HttpSvc.get('smartiot/groups/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.deviceGroups = result;
					vm.loadDesign();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
						
		vm.loadDesign = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('smartiotplanviewdesigner/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.design = result;

					vm.branches.forEach(function(b) {
						if(b.id==vm.design.branchId) {
							vm.selectedBranch=b;
						}
					});

					if(!vm.design.layoutImage || vm.design.layoutImage=='') {
						vm.design.layoutImage = 'assets/img/empty_placeholder_iotdesigner.jpg';
						vm.design.orilayoutImage = "";
					} else {
						vm.design.orilayoutImage = vm.design.layoutImage;
						vm.design.layoutImage = vm.rootUrl + vm.design.layoutImage;
					}

					$timeout(vm.loadObjectOnLayout, 1000);

				}, function() {
					toastr.error('Failed to load selected Design.', Auth.translate('ERROR'))
					$state.go('smartiotsettings.planviewdesigner.list');
					return;
				});		
		}		

		vm.loadObjectOnLayout = function() {
			
			vm.design.siotPlanViewDesignerDevices.forEach(function(s) {
				// Grid Snapping
				vm.bindInteractJS(s.objectIdText);
			});
		}

		/* ******************************************************************** */

		vm.addAssetToLayout = function(assetId, assetName) {
			if(assetId=='' || assetId==null)
			{
				toastr.error("Select an Asset first.");
				return;
			}

			var obj = null;
			var items = vm.design.siotPlanViewDesignerDevices;

			for (var i=0; i<items.length; i++) 
			{			
				if (items[i].assetId == assetId) 
					obj = items[i];
			}
			
			if(obj!=null)
			{
				toastr.error("Selected asset already exists.");
				return;
			}

			var regex = new RegExp('-', 'g');

			var newAsset = { 
				assetId: assetId, 
				objectIdText: "asset_" + assetId.replace(regex, "_"),
				description: assetName,
				coordinateX: 0,
				coordinateY: 0 
			};
			vm.design.siotPlanViewDesignerDevices.push(newAsset);
			
			// Grid Snapping			
			$timeout(function() { vm.bindInteractJS(newAsset.objectIdText) }, 500);
		}

		vm.addSensorToLayout = function(sensorObj) {
			if(sensorObj==null)
			{
				toastr.error("Select a Sensor first.");
				return;
			}

			var obj = null;
			var items = vm.design.siotPlanViewDesignerDevices;

			for (var i=0; i<items.length; i++) 
			{			
				if (items[i].sensorId == sensorObj.id) 
					obj = items[i];
			}
			
			if(obj!=null)
			{
				toastr.error("Selected sensor already exists.");
				return;
			}

			var regex = new RegExp('-', 'g');

			var newSensor = { 
				sensorId: sensorObj.id, 
				objectCode: sensorObj.deviceUID,
				objectIdText: "sensor_" + sensorObj.id.replace(regex, "_"),
				description: sensorObj.description,
				coordinateX: 0,
				coordinateY: 0 
			};
			vm.design.siotPlanViewDesignerDevices.push(newSensor);
			
			// Grid Snapping			
			$timeout(function() { vm.bindInteractJS(newSensor.objectIdText) }, 500);
		}

		vm.removeObject = function(objectIdText) {

			var items = vm.design.siotPlanViewDesignerDevices;
			for(var i=0; i<items.length; i++)
			{
				if(items[i].objectIdText == objectIdText) {
					vm.design.siotPlanViewDesignerDevices.splice(i, 1);
					return;
				}
			}
		}

		vm.bindInteractJS = function(objectIdText) {

			var element = document.getElementById(objectIdText);
			interact(element)
				.draggable({
					modifiers: [
						interact.modifiers.snap({
							targets: [
							interact.createSnapGrid({ x: 10, y: 10 })
							],
							range: Infinity,
							relativePoints: [ { x: 0, y: 0 } ]
						}),
						interact.modifiers.restrict({
							restriction: element.parentNode,
							elementRect: { top: 0, left: 0, bottom: 1, right: 1 },
							endOnly: true
						})
					],
					inertia: true
				})
				.on('dragmove', function (event) {	
					var obj = null;
					var items = vm.design.siotPlanViewDesignerDevices;

					for (var i=0; i<items.length; i++) 
					{			
						if (items[i].objectIdText == objectIdText) 
							obj = items[i];
					}
					
					if(obj!=null) {
						obj.coordinateX += event.dx;
						obj.coordinateY += event.dy;

						obj.coordinateX = Math.ceil(obj.coordinateX);
						obj.coordinateY = Math.ceil(obj.coordinateY);

						event.target.style.webkitTransform =
						event.target.style.transform =
							'translate(' + obj.coordinateX + 'px, ' + obj.coordinateY + 'px)';
					}
				});
		}

		/* ******************************************************************** */

		/* ******************************************************************** */
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (azureSasToken) {
			
			if(vm.lockUploadButton) {
				toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Image Upload Error');
				return;
			}

			var azureStorageUrl = RmsApi.BLOBURL + vm.design.layoutImage + azureSasToken;
			var fileReader = new FileReader();
			
			fileReader.readAsArrayBuffer(vm.fileToUpload);
			fileReader.onload = function(e) {
				Upload.http({
					method: "PUT",
					url: azureStorageUrl,
					headers: {
						'x-ms-blob-type': 'BlockBlob',
						'x-ms-blob-content-type': vm.fileToUpload.type
					},
					data: e.target.result
				}).then(function(response) {
					if (response.status==201) {	
															
						// Refresh Clud Storage Stats
						Auth.selectBranchToken()
							.then(function() {	
								toastr.success('Design has been update successfully.', Auth.translate('SUCCESS'));
								$state.reload();
							}, function(error) {
								toastr.success('Design has been update successfully.', Auth.translate('SUCCESS'));
								$state.reload();
							});			
					} else {
						toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						vm.dataForm.$setPristine();
					} 
				}, null, function(evt) {
					//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				});
			}
		};

		/* ******************************************************************** */

		// Form Submission
		vm.submit = function() {
			
			var newFilename = UtilSvc.generateGuid() + ".";
			var imageLocation = null;

			if(vm.fileToUpload) {				
				var extArray = vm.fileToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();				
				imageLocation = Auth.getCompanyId() + "/siotp/" + newFilename + mediaExtension;
			}
			else if(vm.design.orilayoutImage!="" || vm.design.orilayoutImage!=null) 
			{
				imageLocation = vm.design.orilayoutImage;
			}
			vm.design.layoutImage = imageLocation;

			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, 'Incomplete Fields');
			} else {
				HttpSvc.put('smartiotplanviewdesigner/' + $stateParams.id, vm.design, Auth.getTokenId(), false)
					.then(function(result) {
						if(vm.fileToUpload) {
							vm.uploadImage(result.azureSasToken);
						} else {
							toastr.success('Design has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						}
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		/* ******************************************************************** */
		
		// Call Actions
		vm.initData();		
	};

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.smartkitchen.machineconnectionprofiles.controller', [])
			.controller('SmartKitchenMachineConnectionProfileMainCtrl', SmartKitchenMachineConnectionProfileMainCtrl)
			.controller('SmartKitchenMachineConnectionProfileCreateCtrl', SmartKitchenMachineConnectionProfileCreateCtrl)
			.controller('SmartKitchenMachineConnectionProfileUpdateCtrl', SmartKitchenMachineConnectionProfileUpdateCtrl);

	/** @ngInject */
	function SmartKitchenMachineConnectionProfileMainCtrl($scope, $filter, $state, $uibModal, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.profileDataFull = [];
		vm.profileData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.profileDataFull, tableState.search.predicateObject) : vm.profileDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.profileData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.profileDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('machineconnectionprofiles/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.profileDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteProfile = function(profileId, profileName) {
			var params = {};
			HttpSvc.delete('machineconnectionprofiles/' + profileId, params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.profileDataFull = [];
					vm.profileData = [];

					toastr.success('The Connection Profile [' + profileName + '] has been removed.', 'Remove Successful');
					$scope.$broadcast('refreshStTable');
				}, function(error) {
					// Failed
					toastr.error('Failed to delete the Connection Profile [' + profileName + ']. ' + error, 'Remove Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function SmartKitchenMachineConnectionProfileCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.profile = {};
		vm.branchList = [];
		vm.equipmentList = [];
		vm.groupCodeList = [];
		vm.authTypeList = [
			{
				id: 'POST',
				name: 'POST'
			}
		];
		vm.selectedBranch = null;
		vm.selectedEquipment = null;
		vm.selectedGroupCode = null;
		vm.selectedAuthType = null;

		/* ******************************************************************** */

		vm.loadBranchList = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadEquipmentList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadEquipmentList = function() {
			HttpSvc.get('equipments/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.equipmentList = result;
					vm.loadGroupCodeList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadGroupCodeList = function() {
			HttpSvc.get('machineconnectionprofiles/middlewaregroupcodes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.groupCodeList = result;
					vm.loadData();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		/* ******************************************************************** */

		vm.selectedBranchChanged = function() 
		{
			vm.profile.branchId = vm.selectedBranch.id;
		}
		
		vm.selectedEquipmentChanged = function() 
		{
			vm.profile.equipmentId = vm.selectedEquipment.id;
		}
		
		vm.selectedGroupCodeChanged = function() 
		{
			vm.profile.middlewareGroupCode = vm.selectedGroupCode.code;
		}
		
		vm.selectedAuthTypeChanged = function() 
		{
			vm.profile.authType = vm.selectedAuthType.id;
		}

		/* ******************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('machineconnectionprofiles', vm.profile, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Connection Profile has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('smartkitchen.machineconnectionprofiles.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadBranchList();
	}

	/** @ngInject */
	function SmartKitchenMachineConnectionProfileUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.profile = {};
		vm.branchList = [];
		vm.equipmentList = [];
		vm.groupCodeList = [];
		vm.authTypeList = [
			{
				id: 'POST',
				name: 'POST'
			}
		];
		vm.selectedBranch = null;
		vm.selectedEquipment = null;
		vm.selectedGroupCode = null;
		vm.selectedAuthType = null;

		/* ******************************************************************** */

		vm.loadBranchList = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadEquipmentList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadEquipmentList = function() {
			HttpSvc.get('equipments/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.equipmentList = result;
					vm.loadGroupCodeList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadGroupCodeList = function() {
			HttpSvc.get('machineconnectionprofiles/middlewaregroupcodes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.groupCodeList = result;
					vm.loadData();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadData = function() {
			var params = { id: $stateParams.id };

			HttpSvc.get('machineconnectionprofiles/:id' , params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.profile = result;

					vm.branchList.forEach(function(b) {
						if(b.id==vm.profile.branchId)
						{
							vm.selectedBranch = b;
						}
					});

					vm.equipmentList.forEach(function(b) {
						if(b.id==vm.profile.equipmentId)
						{
							vm.selectedEquipment = b;
						}
					});

					vm.groupCodeList.forEach(function(b) {
						if(b.code==vm.profile.middlewareGroupCode)
						{
							vm.selectedGroupCode = b;
						}
					});

					vm.authTypeList.forEach(function(b) {
						if(b.id==vm.profile.authType)
						{
							vm.selectedAuthType = b;
						}
					});
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		/* ******************************************************************** */

		vm.selectedBranchChanged = function() 
		{
			vm.profile.branchId = vm.selectedBranch.id;
		}
		
		vm.selectedEquipmentChanged = function() 
		{
			vm.profile.equipmentId = vm.selectedEquipment.id;
		}
		
		vm.selectedGroupCodeChanged = function() 
		{
			vm.profile.middlewareGroupCode = vm.selectedGroupCode.code;
		}
		
		vm.selectedAuthTypeChanged = function() 
		{
			vm.profile.authType = vm.selectedAuthType.id;
		}

		/* ******************************************************************** */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('machineconnectionprofiles/' + $stateParams.id, vm.profile, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Connection Profile has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadBranchList();		
	};
	
})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.smartiotsettings.sensors.controller', [])
			.controller('SmartIoTSensorMainCtrl', SmartIoTSensorMainCtrl)
			.controller('SmartIoTSensorCreateCtrl', SmartIoTSensorCreateCtrl)
			.controller('SmartIoTSensorUpdateCtrl', SmartIoTSensorUpdateCtrl)
			.controller('SmartIoTSensorAlertConditionModalCtrl', SmartIoTSensorAlertConditionModalCtrl);

	/** @ngInject */
	function SmartIoTSensorMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
	
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.sensorDataFull = [];
		vm.sensorData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.sensorDataFull, tableState.search.predicateObject) : vm.sensorDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.sensorData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.sensorDataFull.length <= 0) {				
				HttpSvc.get('smartiot/sensors/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.sensorDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteSensor = function(sensorId, sensorName) {
			var params = {};
			HttpSvc.delete('smartiot/sensors/' + sensorId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('smartiot/sensors/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.sensorDataFull = result;
							
							toastr.success('The sensor [' + sensorName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the sensor [' + sensorName + '].', 'Delete Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function SmartIoTSensorCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, UtilSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.sensor = {};
		vm.sensor.enabled = true;
		vm.sensor.siotSensorAlertConditions = [];
		vm.metricList = [];
		vm.deviceList = [];
		vm.selectedDevice = null;
		vm.canSetIoTHardwareSettings = Auth.canSetIoTHardwareSettings();
		
		/* ************************************************************* */

		vm.loadDevices = function() {
			HttpSvc.get('smartiot/devicemasters/list/available/sensors', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.deviceList = result;
					vm.loadMetrics();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadMetrics = function() {
			HttpSvc.get('smartiot/devicemetrics/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.metricList = result;
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
		
		/* ************************************************************* */

		vm.selectedDeviceChanged = function() {
			vm.sensor.deviceId = vm.selectedDevice.id;
			vm.sensor.deviceUID = vm.selectedDevice.deviceUID;
			vm.sensor.deviceType = vm.selectedDevice.type;
			vm.sensor.model = vm.selectedDevice.model;
		}
	
		vm.clearDevice = function() {
			vm.selectedDevice = null;
			vm.sensor.deviceId = "";
			vm.sensor.deviceUID = "";
			vm.sensor.deviceType = "";
			vm.sensor.model = "";
		}

		/* ************************************************************* */
			
		// Open Modal Dialog
		vm.setting = {};		
		vm.showAddSettingModal = function () {
			vm.setting = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'settingModal.html',
				controller: 'SmartIoTSensorAlertConditionModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.setting,
							metricList: vm.metricList,
							isF: vm.sensor.isFahrenheit
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addSetting(data);
				}, function () {
				});
		};	
		vm.showEditSettingModal = function (index) {
			vm.setting = angular.copy(vm.sensor.siotSensorAlertConditions[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'settingModal.html',
				controller: 'SmartIoTSensorAlertConditionModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.setting,
							metricList: vm.metricList,
							isF: vm.sensor.isFahrenheit
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateSetting(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************* */		
		
		// Remove Setting
		vm.removeSetting = function(index) {
			vm.sensor.siotSensorAlertConditions.splice(index, 1);
		};
			
		// Update Setting
		vm.updateSetting = function(index, obj) {
			var element = {
				id: obj.id,
				metricId: obj.metricId,
				metricName: obj.metricName,
				metricSeq: obj.metricSeq,
				description: obj.description,
				colorCode: obj.colorCode,
				isEnabled: obj.isEnabled,
				valueStart: obj.valueStart,
				valueEnd: obj.valueEnd,
				timeSpan: obj.timeSpan,
				uom: obj.uom,
				siotSensorAlertConditionMuteTimes: obj.siotSensorAlertConditionMuteTimes
			};
			vm.sensor.siotSensorAlertConditions.splice(index, 1, element);
		};

		// Add Setting
		vm.addSetting = function(obj) {
			var element = {
				id: UtilSvc.generateGuid(),
				metricId: obj.metricId,
				metricName: obj.metricName,
				metricSeq: obj.metricSeq,
				description: obj.description,
				colorCode: obj.colorCode,
				isEnabled: obj.isEnabled,
				valueStart: obj.valueStart,
				valueEnd: obj.valueEnd,
				timeSpan: obj.timeSpan,
				uom: obj.uom,
				siotSensorAlertConditionMuteTimes: obj.siotSensorAlertConditionMuteTimes
			};
			vm.sensor.siotSensorAlertConditions.push(element);
		};
		
		/* ************************************************************* */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('smartiot/sensors', vm.sensor, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Sensor has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('smartiotsettings.sensors.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadDevices();
	}

/** @ngInject */
	function SmartIoTSensorUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, UtilSvc, toastr) 
	{
		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.sensor = {};
		vm.deviceList = [];
		vm.metricList = [];
		vm.changeLogs = [];
		vm.selectedDevice = null;
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.canSetIoTHardwareSettings = Auth.canSetIoTHardwareSettings();
		vm.lockButtons = false;

		/* ************************************************************* */

		vm.loadDevices = function() {
			var deviceId = vm.sensor.deviceId==null?"":vm.sensor.deviceId;
			HttpSvc.get('smartiot/devicemasters/list/available/sensors/' + deviceId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.deviceList = result;

					vm.deviceList.forEach(function(d) {
						if(d.id==vm.sensor.deviceId) {
							vm.selectedDevice=d;
						}
					});

					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
	
		}

		vm.loadMetrics = function() {
			HttpSvc.get('smartiot/devicemetrics/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.metricList = result;
					vm.loadSensor();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}
						
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('smartiot/sensors/changelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};
						
		// Load Sensor
		vm.loadSensor = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('smartiot/sensors/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.sensor = result;

					vm.loadDevices();
					vm.loadChangeLogs();

				}, function() {
					toastr.error('Failed to load selected Sensor.', Auth.translate('ERROR'))
					$state.go('smartiotsettings.sensors.list');
					return;
				});		
		};	
		
		/* ************************************************************* */

		vm.selectedDeviceChanged = function() {
			vm.sensor.deviceId = vm.selectedDevice.id;
			vm.sensor.deviceUID = vm.selectedDevice.deviceUID;
			vm.sensor.deviceType = vm.selectedDevice.type;
			vm.sensor.model = vm.selectedDevice.model;
		}
	
		vm.clearDevice = function() {
			vm.selectedDevice = null;
			vm.sensor.deviceId = "";
			vm.sensor.deviceUID = "";
			vm.sensor.deviceType = "";
			vm.sensor.model = "";
		}
			
		/* ************************************************************* */
			
		// Open Modal Dialog
		vm.setting = {};		
		vm.showAddSettingModal = function () {
			vm.setting = {};
			vm.setting.id = UtilSvc.generateGuid();

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'settingModal.html',
				controller: 'SmartIoTSensorAlertConditionModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.setting,
							metricList: vm.metricList,
							isF: vm.sensor.isFahrenheit
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addSetting(data);
				}, function () {
				});
		};	
		vm.showEditSettingModal = function (index) {
			vm.setting = angular.copy(vm.sensor.siotSensorAlertConditions[index]);
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'settingModal.html',
				controller: 'SmartIoTSensorAlertConditionModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.setting,
							metricList: vm.metricList,
							isF: vm.sensor.isFahrenheit
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateSetting(index, data);
				}, function () {
				});
		};	
		
		/* ************************************************************* */		
		
		// Remove Setting
		vm.removeSetting = function(index) {
			vm.sensor.siotSensorAlertConditions.splice(index, 1);
		};
			
		// Update Setting
		vm.updateSetting = function(index, obj) {
			var element = {
				id: obj.id,
				metricId: obj.metricId,
				metricName: obj.metricName,
				metricSeq: obj.metricSeq,
				description: obj.description,
				colorCode: obj.colorCode,
				isEnabled: obj.isEnabled,
				valueStart: obj.valueStart,
				valueEnd: obj.valueEnd,
				timeSpan: obj.timeSpan,
				uom: obj.uom,
				siotSensorAlertConditionMuteTimes: obj.siotSensorAlertConditionMuteTimes
			};
			vm.sensor.siotSensorAlertConditions.splice(index, 1, element);
		};

		// Add Setting
		vm.addSetting = function(obj) {
			var element = {
				id: obj.id,
				metricId: obj.metricId,
				metricName: obj.metricName,
				metricSeq: obj.metricSeq,
				description: obj.description,
				colorCode: obj.colorCode,
				isEnabled: obj.isEnabled,
				valueStart: obj.valueStart,
				valueEnd: obj.valueEnd,
				timeSpan: obj.timeSpan,
				uom: obj.uom,
				siotSensorAlertConditionMuteTimes: obj.siotSensorAlertConditionMuteTimes
			};
			vm.sensor.siotSensorAlertConditions.push(element);
		};
		
		/* ************************************************************* */

		vm.deleteReadings = function() {
			vm.lockButtons = true;

			HttpSvc.delete('smartiot/sensors/deletereadings/' + vm.sensor.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success(result.message, Auth.translate('SUCCESS'));
					vm.lockButtons = false;
				}, function() {
					vm.lockButtons = false;
					toastr.error('Failed to delete the sensor readings.', 'Delete Failed');
					return null;
				});
		}

		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('smartiot/sensors/' + $stateParams.id, vm.sensor, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Sensor has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadMetrics();		
	}
		
	function SmartIoTSensorAlertConditionModalCtrl($uibModalInstance, $timeout, UtilSvc, item, toastr) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.mode = item.mode;
		$mdl.item = item.object;
		$mdl.metricList = item.metricList;
		$mdl.isF = item.isF;
		$mdl.selectedType = null;
		$mdl.selectedTimeSpan = null;
		$mdl.boolOptions = GetBooleanTypes();
		$mdl.boolOptions2 = GetBooleanTypes2();
		$mdl.hourOptions = GetHourList();
		$mdl.minuteOptions = GetMinuteList();

		$mdl.periodList = [
			{id: 180, name: 'Instant Alert'}, 
			{id: 1800, name: '30 Minutes'}, 
			{id: 3600, name: '1 Hour'}, 
			{id: 7200, name: '2 Hours'}, 
			{id: 10800, name: '3 Hours'}, 
			{id: 14400, name: '4 Hours'}, 
		];

		/* ************************************************************* */

		$mdl.selectColor = function(colorCode) {
			$mdl.item.colorCode = colorCode;
		}

		$mdl.selectedTypeChanged = function() {
			$mdl.item.metricId = $mdl.selectedType.id;
			$mdl.item.metricName = $mdl.selectedType.description;
			$mdl.item.metricSeq = $mdl.selectedType.sequence;
			$mdl.item.uom = $mdl.isF ? $mdl.selectedType.uom2 : $mdl.selectedType.uom;
		}

		$mdl.selectedTimeSpanChanged = function() {
			$mdl.item.timeSpan = $mdl.selectedTimeSpan.id;
		}

		/* ************************************************************* */
		
		// Remove Schedule
		$mdl.removeScheduleRow = function(index) {
			$mdl.item.siotSensorAlertConditionMuteTimes.splice(index, 1);
		};

		// Add Schedule
		$mdl.addScheduleRow = function() {
			var element = {
				id: UtilSvc.generateGuid(),
				conditionId: $mdl.item.id,
				isEnabled: true,
				muteMon: false,
				muteTue: false,
				muteWed: false,
				muteThu: false,
				muteFri: false,
				muteSat: false,
				muteSun: false,
				muteFromHour: null,
				muteFromMinute: null,
				muteToHour: null,
				muteToMinute: null,
			};
			$mdl.item.siotSensorAlertConditionMuteTimes.push(element);
			$mdl.tableForm.$show();
		};

		$mdl.saveScheduleRows = function() {
			$mdl.tableForm.$submit();
		}

		/* ************************************************************* */

		if($mdl.mode==1) {
			$mdl.item.isEnabled = true;
			$mdl.item.timeSpan = 180;
			$mdl.item.hitCount = 0;
			$mdl.item.colorCode = "#00ff00";
			$mdl.item.siotSensorAlertConditionMuteTimes = [];
		} else if($mdl.mode==2) {
			$mdl.item.hitCount = 0;
			$mdl.metricList.forEach(function(t) {
				if(t.id==$mdl.item.metricId)
				{
					$mdl.selectedType = t;
				}
			});
			$mdl.periodList.forEach(function(p) {
				if(p.id==$mdl.item.timeSpan)
				{
					$mdl.selectedTimeSpan = p;
				}
			});
		}

		/* ************************************************************* */

		$mdl.confirmModal = function() {
			if($mdl.settingForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$mdl.saveScheduleRows();
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Init				
        $timeout(function() { $mdl.tableForm.$show() }, 500);
	};	
	

	function GetBooleanTypes() {
		return [
			{value: true, text: '✔'},
			{value: false, text: '✖'},
		]; 
	};
	function GetBooleanTypes2() {
		return [
			{value: true, text: 'Y'},
			{value: false, text: 'N'},
		]; 
	};
	
	function GetHourList() {
		return [
			{value: 0, text: '00'}, 
			{value: 1, text: '01'}, 
			{value: 2, text: '02'}, 
			{value: 3, text: '03'}, 
			{value: 4, text: '04'}, 
			{value: 5, text: '05'}, 
			{value: 6, text: '06'}, 
			{value: 7, text: '07'}, 
			{value: 8, text: '08'}, 
			{value: 9, text: '09'}, 
			{value: 10, text: '10'}, 
			{value: 11, text: '11'}, 
			{value: 12, text: '12'}, 
			{value: 13, text: '13'}, 
			{value: 14, text: '14'}, 
			{value: 15, text: '15'}, 
			{value: 16, text: '16'}, 
			{value: 17, text: '17'}, 
			{value: 18, text: '18'}, 
			{value: 19, text: '19'}, 
			{value: 20, text: '20'}, 
			{value: 21, text: '21'}, 
			{value: 22, text: '22'}, 
			{value: 23, text: '23'}, 
		]; 
	};

	function GetMinuteList() {
		return [
			{value: 0, text: '00'}, 
			{value: 15, text: '15'}, 
			{value: 30, text: '30'}, 
			{value: 45, text: '45'}, 
		]; 
	};

})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.smartkitchen.skbranches.controller', [])
			.controller('SmartKitchenBranchesMainCtrl', SmartKitchenBranchesMainCtrl)
			.controller('SmartKitchenBranchesModalCtrl', SmartKitchenBranchesModalCtrl);

	/** @ngInject */
	function SmartKitchenBranchesMainCtrl($scope, $filter, $state, $uibModal, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.branchDataFull = [];
		vm.branchData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.branchDataFull, tableState.search.predicateObject) : vm.branchDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.branchData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.branchDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('smartkitchens/branches/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.branchDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteBranch = function(branchId, branchName) {
			var params = {};
			HttpSvc.delete('smartkitchens/branches/' + branchId, params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.branchDataFull = [];
					vm.branchData = [];

					toastr.success('The branch [' + branchName + '] has been removed.', 'Remove Successful');
					$scope.$broadcast('refreshStTable');
				}, function(error) {
					// Failed
					toastr.error('Failed to delete the branch [' + branchName + ']. ' + error, 'Remove Failed');
					return null;
			});
		};

		vm.showAddBranchModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'SKAddBranchModal.html',
				controller: 'SmartKitchenBranchesModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {}
					}
				}
			});

			modalInstance
				.result
				.then(function () {					
					vm.branchDataFull = [];
					vm.branchData = [];
					$scope.$broadcast('refreshStTable');
				}, function () {
				});
		};	
	};
	
	// Trigger Setup Modal Controller
	function SmartKitchenBranchesModalCtrl($scope, $uibModalInstance, Auth, HttpSvc, UtilSvc, item, toastr) {
		var $mdl = this;
		
		$mdl.branch = {};
		$mdl.branchList = [];
		$mdl.selectedBranch = null;
		$mdl.isLoading = false;
		$mdl.isProcessing = false;
						
		/* ******************************************************** */

		$mdl.loadBranchList = function() {
			$mdl.isLoading = true;
			
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.branchList = result;
					$mdl.isLoading = false;
				}, function(error) {
					toastr.error(error, 'Loading Failed');
					$mdl.cancelModal();
				});
		}

		/* ******************************************************** */

		$mdl.selectedBranchChanged = function() {
			$mdl.branch.branchId = $mdl.selectedBranch.id;
		}

		/* ******************************************************** */
		
		$mdl.confirmModal = function() {
			if($mdl.branchForm.$valid) {
				$mdl.isProcessing = true;

				HttpSvc.post('smartkitchens/branches', $mdl.branch, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Branch has been added successfully.', Auth.translate('SUCCESS'));
						$uibModalInstance.close();
					}, function(error) {
						toastr.error(error, 'Failed To Add Branch');
						$mdl.isProcessing = false;
					});
			}
			else
			{
				toastr.error('Please select a Branch first.', Auth.translate('ERROR'));
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		// Init Call
		$mdl.loadBranchList();
	};
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.sops.categories.controller', [])
        .controller('SOPCategoryMainCtrl', SOPCategoryMainCtrl)
        .controller('SOPCategoryCreateCtrl', SOPCategoryCreateCtrl)
        .controller('SOPCategoryUpdateCtrl', SOPCategoryUpdateCtrl);

    /** @ngInject */
    function SOPCategoryMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();		
		
		var vm = this;
		vm.cateDataFull = [];
		vm.cateData = [];
		vm.numOfRecord = 0;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		
		vm.retrieveData = function() {			
			HttpSvc.get('sopcategories/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.numOfRecord = result.length;	
					vm.cateDataFull = result;
					vm.cateDataFull.forEach(function(cat) {
						if(!cat.imageLocation || cat.imageLocation=='') {
							cat.imageLocation = 'assets/img/sop_empty_placeholder.png';
							cat.thumbnail = 'assets/img/sop_empty_placeholder.png';
						} else {
							cat.imageLocation = vm.rootUrl + cat.imageLocation;
							if(!cat.thumbnail){
								cat.thumbnail = null;
							} else {
								cat.thumbnail = vm.rootUrl + cat.thumbnail;
							}
						}
					});
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		// Call Actions
		vm.retrieveData();		
	};
	
	/** @ngInject */
    function SOPCategoryCreateCtrl($scope, $state, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.cate = {};
		vm.cate.branches = [];
		vm.branches = [];
		vm.selectedBranches = [];
		vm.categoryId = "";
		vm.cate.imageLocation = '';
		vm.blobUrl = RmsApi.BLOBURL;
		vm.fileToUpload = null;
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		vm.hasFranchiseAccess = Auth.hasCompanyFeature('franchise');
		
		// Init Data
		vm.initData = function() {			
			vm.cate.imageLocation = 'assets/img/sop_empty_placeholder.png';	
			vm.loadBranches();
		}	
		
		// Load Branches
		vm.loadBranches = function() {
			HttpSvc.get('branches/listByUserAccess', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.branches.push({ id: u.id, name: u.name });
					});		
				}, function() {
					vm.branches = [];
				});
		};
		
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					/* CHECK STORAGE QUOTA */
					if(vm.lockUploadButton) {
						toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Media Upload Error');
						return;
					}
					/* ******************* */
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/sopcategory/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "sopcategory/" + newFilename + mediaExtension;
				}
				vm.cate.imageLocation = imgLocation;
								
				vm.cate.branches = [];
				vm.selectedBranches.forEach( function(b) {
					vm.cate.branches.push({ id: b.id });
				});
						
				HttpSvc.post('sopcategories', vm.cate, Auth.getTokenId(), false)
					.then(function(result) {
						vm.categoryId = result.sopCategory.id;
						
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(vm.serverMode);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/sopcategory/" + vm.categoryId;
							vm.uploadImage(vm.serverMode);
							
						} else {							
							toastr.success('S.O.P Category has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('sops.categories.list');
						}
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');						
						vm.dataForm.$setPristine();
					});
			}
		};
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (serverMode) {
			var fileReader = new FileReader();
			
			if(serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId()},
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('S.O.P Category has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('sops.categories.list');
				}, function (resp) {
					toastr.success('S.O.P Category has been created successfully.', Auth.translate('SUCCESS'));
					$state.go('sops.categories.list');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {				
									
							// Notify Server Sop Media ready
							HttpSvc.put('youtube/ready/sopcategory/' + vm.categoryId, {}, Auth.getTokenId(), false)
								.then(function(result) {
									
									// Refresh Clud Storage Stats
									Auth.selectBranchToken()
										.then(function() {	
											toastr.success('S.O.P Category has been created successfully.', Auth.translate('SUCCESS'));
											$state.go('sops.categories.list');
										}, function(error) {
											toastr.success('S.O.P Category has been created successfully.', Auth.translate('SUCCESS'));
											$state.go('sops.categories.list');
										});		
								}, function(error) {
								});	
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function SOPCategoryUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.cate = {};
		vm.cate.branches = [];
		vm.branches = [];
		vm.selectedBranches = [];
		vm.cate.imageLocation = '';
		vm.cate.thumbnail = '';
		vm.cate.oriImageLocation = '';
		vm.cate.oriThumbnail = '';
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.fileToUpload = null;
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.serverMode = Auth.getServerMode();
		vm.hasFranchiseAccess = Auth.hasCompanyFeature('franchise');
		
		// Load Branches
		vm.loadBranches = function() {
			HttpSvc.get('branches/listByUserAccess', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.branches.push({ id: u.id, name: u.name });
					});		
					vm.loadSOPCategory();
				}, function() {
					vm.branches = [];
				});
		};
		
		// Load Sop Category
		vm.loadSOPCategory = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('sopcategories/edit/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.cate = result;
					
					result.branches.forEach(function (b) {
						vm.selectedBranches.push({ id: b.id, name: b.name });
					});
					
					if(!vm.cate.imageLocation || vm.cate.imageLocation=='') {
						vm.cate.imageLocation = 'assets/img/sop_empty_placeholder.png';
						vm.cate.thumbnail = 'assets/img/sop_empty_placeholder.png';
						vm.cate.oriImageLocation = "";
						vm.cate.oriThumbnail = "";
					} else {
						vm.cate.oriImageLocation = vm.cate.imageLocation;
						vm.cate.oriThumbnail = vm.cate.thumbnail;
						vm.cate.imageLocation = vm.rootUrl + vm.cate.imageLocation;
						vm.cate.thumbnail = vm.rootUrl + vm.cate.thumbnail;
					}
				}, function() {
					toastr.error('Failed to load selected Sop Category.', Auth.translate('ERROR'))
					$state.go('sops.categories.list');
					return;
				});		
		};
		
		// Form Submission
		var thumbnail = "";
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		vm.submit = function(picFile) {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				thumbnail = "";
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					/* CHECK STORAGE QUOTA */
					if(vm.lockUploadButton) {
						toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Media Upload Error');
						return;
					}
					/* ******************* */
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/sopcategory/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "sopcategory/" + newFilename + mediaExtension;
					
				} else if(vm.cate.oriImageLocation!="") {
					imgLocation = vm.cate.oriImageLocation;
					thumbnail = vm.cate.oriThumbnail;
				}
				
				vm.cate.thumbnail = thumbnail;
				vm.cate.imageLocation = imgLocation;
				vm.cate.isThumbnailGenerated = true;						
				
				vm.cate.branches = [];
				vm.selectedBranches.forEach( function(b) {
					vm.cate.branches.push({ id: b.id });
				});
								
				HttpSvc.put('sopcategories/' + $stateParams.id, vm.cate, Auth.getTokenId(), false)
					.then(function(result) {							
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(vm.serverMode);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/sopcategory/" + $stateParams.id;
							vm.uploadImage(vm.serverMode);
							
						} else {							
							toastr.success('S.O.P Category has been updated successfully.', Auth.translate('SUCCESS'));
							$state.go('sops.categories.list');
						}
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');						
						vm.dataForm.$setPristine();
					});
			}
		};
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (serverMode) {
			var fileReader = new FileReader();
			
			if(serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('S.O.P Category has been updated successfully.', Auth.translate('SUCCESS'));
					$state.go('sops.categories.list');
				}, function (resp) {
					toastr.success('S.O.P Category has been updated successfully.', Auth.translate('SUCCESS'));
					$state.go('sops.categories.list');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {				
									
							// Notify Server Sop Media ready
							HttpSvc.put('youtube/ready/sopcategory/' + $stateParams.id, {}, Auth.getTokenId(), false)
								.then(function(result) {
									
									// Refresh Clud Storage Stats
									Auth.selectBranchToken()
										.then(function() {	
											toastr.success('S.O.P Category has been updated successfully.', Auth.translate('SUCCESS'));
											$state.go('sops.categories.list');
										}, function(error) {
											toastr.success('S.O.P Category has been updated successfully.', Auth.translate('SUCCESS'));
											$state.go('sops.categories.list');
										});		
								}, function(error) {
								});	
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};
		
		vm.deleteCategory = function() {
			var params = {};
			HttpSvc.delete('sopcategories/' + vm.cate.id, params, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('The category [<b>' + vm.cate.name + '</b>] has been deleted.', 'Delete Success');
					$state.go('sops.categories.list');
				}, function() {
					// Failed
					toastr.error('Failed to delete the category.', 'Delete Failed');
					return null;
			});
		};
		
		// Call Actions
		vm.loadBranches();
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.sops.cards.controller', [])
        .controller('SOPCardCategoriesCtrl', SOPCardCategoriesCtrl)
        .controller('SOPCardSOPsCtrl', SOPCardSOPsCtrl)
        .controller('SOPCardViewCtrl', SOPCardViewCtrl)
        .controller('SOPCardShareDialogCtrl', SOPCardShareDialogCtrl)
        .controller('SOPQuickSearchDialogCtrl', SOPQuickSearchDialogCtrl);

    /** @ngInject */
    function SOPCardCategoriesCtrl($scope, $filter, $state, $q, $timeout, $uibModal, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();		
		
		var vm = this;
		vm.cateDataFull = [];
		vm.cateData = [];
		vm.numOfRecord = 0;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.isLoading = false;
		vm.isSearching = false;
		
		vm.initData = function() {
			vm.retrieveData();
		}
		
		vm.retrieveData = function() {		
			vm.isLoading = true;
	
			HttpSvc.get('sopcategories/list/card', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.numOfRecord = result.length;	
					vm.cateDataFull = result;
					vm.cateDataFull.forEach(function(cat) {
						if(!cat.imageLocation || cat.imageLocation=='') {
							cat.imageLocation = 'assets/img/sop_empty_placeholder.png';
							cat.thumbnail = 'assets/img/sop_empty_placeholder.png';
						} else {
							cat.imageLocation = vm.rootUrl + cat.imageLocation;
							if(!cat.thumbnail){
								cat.thumbnail = null;
							} else {
								cat.thumbnail = vm.rootUrl + cat.thumbnail;
							}
						}
					});
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		vm.searchForText = function() {
			vm.isSearching = true;

			$timeout(function() { 
				vm.searchText = vm.searchTextOri;
				vm.isSearching = false;
			}, 300);
		}	

		/* **************************************************************** */

		vm.showSearchSopDialog = function() {

			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'SearchSopModal.html',
				controller: 'SOPQuickSearchDialogCtrl',
				controllerAs: '$mdl',
				size: 'lg',
			});
	
			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		}

		/* **************************************************************** */
		
		// Call Actions
		vm.initData();		
	};
	
	/** @ngInject */
    function SOPCardSOPsCtrl($scope, $filter, $state, $stateParams, $timeout, $q, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();		
		
		var vm = this;
		vm.category = {};
		vm.sopDataFull = [];
		vm.sopData = [];
		vm.numOfRecord = 0;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		
		vm.initData = function() {
			vm.loadCategory();
		}
		
		// Load SOP Category
		vm.loadCategory = function() {
			HttpSvc.get('sopcategories/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.category = result;
					vm.loadSOPs();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Category.', '');
					$state.go('sops.cards.categories');
					return null;
				});
		};	

		vm.searchForText = function() {
			vm.isSearching = true;

			$timeout(function() { 
				vm.searchText = vm.searchTextOri;
				vm.isSearching = false;
			}, 300);
		}
		
		// Load List
		vm.loadSOPs = function() {	
			if(vm.categoryId=="") return;
			
			HttpSvc.get('sops/list/card/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					//vm.sopDataFull = result;
					result.forEach(function(r) {
						if(r.isApproved && r.isPublic) {
							if(!r.imageLocation || r.imageLocation=='') {
								r.imageLocation = 'assets/img/sop_empty_placeholder.png';
								r.thumbnail = 'assets/img/sop_empty_placeholder.png';
							} else {
								r.imageLocation = vm.rootUrl + r.imageLocation;
								if(!r.thumbnail){
									r.thumbnail = null;
								} else {
									r.thumbnail = vm.rootUrl + r.thumbnail;
								}
							}
							vm.sopDataFull.push(r);
						}
					});
					vm.numOfRecord = vm.sopDataFull.length;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					$state.go('sops.cards.categories');
					return null;
				});
		};

		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function SOPCardViewCtrl($sce, $scope, $state, $stateParams, $anchorScroll, $uibModal, Auth, baSidebarService, HttpSvc, RmsApi, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.sop = {};
		vm.ingredients = [];
		vm.childSOPs = [];
		vm.batch = 1;
		vm.prodQty = 1;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.ingredientGroup = [];
		
		/* ****************************************************** */

		vm.initData = function() {
			vm.loadSOP();
		};
		
		// Go Back
		vm.goBack = function() {
			window.history.back();
		}
		
		// Start Step
		vm.startStep = function() {
			baSidebarService.setMenuCollapsed(true);
		}
		
		// Show Player
		vm.showPlayer = function(s) {
			s.showPlayer = true;
		};
		
		/* ****************************************************** */

		// Load SOP
		vm.loadSOP = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('sops/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.sop = result;
					vm.prodQty = vm.sop.productionQuantity;
					
					if(!vm.sop.imageLocation || vm.sop.imageLocation=='') {
						vm.sop.imageLocation = 'assets/img/sop_empty_placeholder.png';
						vm.sop.thumbnail = 'assets/img/sop_empty_placeholder.png';
						vm.sop.oriImageLocation = "";
					} else {
						vm.sop.imageLocation = vm.rootUrl + vm.sop.imageLocation;
						if(!vm.sop.thumbnail || vm.sop.thumbnail==''){
							vm.sop.thumbnail = null;
						} else {
							vm.sop.thumbnail = vm.rootUrl + vm.sop.thumbnail;
						}
					}		
					
					vm.sop.sopSteps.forEach(function (c) {		
						if(c.attachmentType!=null) {
							if(c.attachmentType=="youtube") {
								c.youtubeId = c.attachmentLocation;
								c.attachmentLocation = "http://www.youtube.com/embed/" + c.attachmentLocation;
							}
							
							if(c.attachmentType.substr(0,5)=='video') {								
								c.finalVimeoUrl = 
									$sce.trustAsResourceUrl("https://player.vimeo.com/video/" + c.vimeoVideoId);
							}
						}
					});						
				}, function() {
					toastr.error('Failed to load selected S.O.P.', Auth.translate('ERROR'))
					$state.go('sops.cards.categories');
					return;
				});		
		};
			
		// Print SOP
		vm.printSOP = function(sopId, sopName) {
			
			var filename = "SOP_" + sopName.replace("/", "_").replace(" ", "_").replace("#", "") + ".pdf";
			
			HttpSvc.getPdfObject('sops/print/' + sopId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print S.O.P. ' + error, '');
							return null;
						});
		}
			
		// Print SOP
		vm.printSOPSimple = function(sopId, sopName) {
			
			var filename = "SOP_" + sopName.replace("/", "_").replace(" ", "_").replace("#", "") + ".pdf";
			
			HttpSvc.getPdfObject('sops/print/simple/' + sopId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to print S.O.P. ' + error, '');
							return null;
						});
		}

		vm.showShareDialog = function() {

			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'shareDialogModal.html',
				controller: 'SOPCardShareDialogCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							objectId: vm.sop.id
						}
					}
				}
			});
	
			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		}
		
		/* ****************************************************** */

		// Call Actions
		vm.initData();
	}
    
    /** @ngInject */
    function SOPCardShareDialogCtrl($uibModalInstance, $timeout, Auth, RmsApi, HttpSvc, UtilSvc, item, toastr) {
		var $mdl = this;
  
		$mdl.objectId = item.objectId;
		$mdl.item = {};
		$mdl.errorMsg = "";
		$mdl.showError = false;
		$mdl.showSuccess = false;
		$mdl.lockButton = false;
  
		/* ********************************************************* */
						  
		$mdl.confirmModal = function() {
		  if($mdl.shareForm.$invalid) {
			$mdl.errorMsg = UtilSvc.getErrorMessage($mdl.shareForm);          
			$mdl.showError = true;
		  } else {
			$mdl.lockButton = true;
			$mdl.showError = false;
  
			$mdl.item.objectType = "SOP";
			$mdl.item.objectId = $mdl.objectId;
  
			HttpSvc.post('ezyshare', $mdl.item, Auth.getTokenId(), false)
			  .then(function(result) {
				$mdl.showSuccess = true;
				$timeout($uibModalInstance.close, 1500);
			  }, function(error) {
				$mdl.errorMsg = error;
				$mdl.showError = true;
				$mdl.lockButton = false;
			  });
		  }
		};
		
		// Cancel Action
		$mdl.cancelModal = function() {
		  $uibModalInstance.dismiss('cancel');
		};
	};	
    
    /** @ngInject */
    function SOPQuickSearchDialogCtrl($uibModalInstance, Auth, RmsApi, HttpSvc, UtilSvc, toastr) {
		var $mdl = this;
  
		$mdl.sopList = [];
		$mdl.searchText = "";
		$mdl.isLoading = false;
		$mdl.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
  
		/* ********************************************************* */
						  
		$mdl.searchSop = function() {
			$mdl.isLoading = true;

			HttpSvc.post('sops/listByCompany/' + encodeURIComponent($mdl.searchText), {}, Auth.getTokenId(), true)
			  	.then(function(result) {
					$mdl.sopList = result;
					
					$mdl.sopList.forEach(function(r) {
						if(r.thumbnail!=null && r.thumbnail!='') {
							r.thumbnail = $mdl.rootUrl + r.thumbnail;
						}
						if(r.imageLocation!=null && r.imageLocation!='') {
							r.imageLocation = $mdl.rootUrl + r.imageLocation;
						}
					});					

					$mdl.isLoading = false;
			  	}, function(error) {
					toastr.error(error, "Search Failed");
					$mdl.isLoading = false;
			  	});
		};
		
		// Cancel Action
		$mdl.cancelModal = function() {
		  	$uibModalInstance.dismiss('cancel');
		};
	};	

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.sops.sops.controller', ['ngSanitize'])
		.controller('SOPCatMainCtrl', SOPCatMainCtrl)
        .controller('SOPMainCtrl', SOPMainCtrl)
        .controller('SOPCreateCtrl', SOPCreateCtrl)
        .controller('SOPUpdateCtrl', SOPUpdateCtrl)
        .controller('CloneSOPModalCtrl', CloneSOPModalCtrl)
        .controller('CloneSOPCategoryModalCtrl', CloneSOPCategoryModalCtrl)
        .controller('SOPStepModalCtrl', SOPStepModalCtrl)
        .controller('SOPEquipmentModalCtrl', SOPEquipmentModalCtrl)
        .controller('SOPProcessModalCtrl', SOPProcessModalCtrl);

	/** @ngInject */
	function SOPCatMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, RmsApi, toastr) {
			
			Auth.init();
			
			var vm = this;
			vm.categoryList = [];
			vm.numOfRecord = 0;
			vm.isCategorySelected = false;
			vm.selectedCategory = "";
			vm.selectedCategoryId = "";
			vm.isApprovedOption = [];
			vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
			
			// Load Recipe Category List		
			vm.loadCategories = function() {			
				HttpSvc.get('sopcategories/list', {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.categoryList = result;
						vm.categoryList.forEach(function(cat) {
							cat.isVisible = true;
							if(!cat.imageLocation || cat.imageLocation=='') {
								cat.imageLocation = 'assets/img/empty_placeholder.png';
								cat.thumbnail = 'assets/img/empty_placeholder.png';
							} else {
								cat.imageLocation = vm.rootUrl + cat.imageLocation;
								if(!cat.thumbnail){
									cat.thumbnail = null;
								} else {
									cat.thumbnail = vm.rootUrl + cat.thumbnail;
								}
							}
						});
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			};	
	
			// Call Actions
			vm.loadCategories();		
	};

    /** @ngInject */
    function SOPMainCtrl($scope, $filter, $state, $stateParams, $q, $uibModal, Auth, HttpSvc, RmsApi, toastr) {
		
		Auth.init();
		
		var vm = this;
		vm.category = {};
		vm.sopList = [];
		vm.numOfRecord = 0;
		vm.isCategorySelected = false;
		vm.selectedCategory = "";
		vm.selectedCategoryId = "";
		vm.isApprovedOption = [];
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.canCloneRecipe = Auth.canCloneRecipe();
		vm.selectedCategory = null;
		vm.selectedCategoryId = null;
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
				
		// Go Back
		vm.goBack = function() {
			window.history.back();
		}
		
		// Load SOP Category List		
		vm.loadCategories = function() {
			
			var params = { id: $stateParams.id };

			HttpSvc.get('sopcategories/edit/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.category = result;
					vm.selectedCategory = vm.category.name;
					vm.selectedCategoryId = vm.category.id;
					
					if(!vm.category.imageLocation || vm.category.imageLocation=='') {
						vm.category.imageLocation = 'assets/img/empty_placeholder.png';
						vm.category.thumbnail = 'assets/img/empty_placeholder.png';
					} else {
						vm.category.imageLocation = vm.rootUrl + vm.category.imageLocation;
						if(!vm.category.thumbnail){
							vm.category.thumbnail = null;
						} else {
							vm.category.thumbnail = vm.rootUrl + vm.category.thumbnail;
						}
					}
						
					vm.loadSOPList(vm.category.id, vm.category.name);
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	
				
		// Load List
		vm.loadSOPList = function(catId, catName) {	
			if(catId=="") {
				vm.selectedCategoryId = "";
				return;
			} 
			
			vm.searchCategory = "";
			vm.isCategorySelected = true;
			vm.selectedCategory = catName;
			vm.selectedCategoryId = catId;
			
			HttpSvc.get('sops/list/' + catId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.numOfRecord = result.length;	
					vm.sopList = result;
					vm.sopList.forEach(function(r) {
						if(!r.imageLocation || r.imageLocation=='') {
							r.imageLocation = 'assets/img/sop_empty_placeholder.png';
							r.thumbnail = 'assets/img/sop_empty_placeholder.png';
						} else {
							r.imageLocation = vm.rootUrl + r.imageLocation;
							if(!r.thumbnail){
								r.thumbnail = null;
							} else {
								r.thumbnail = vm.rootUrl + r.thumbnail;
							}
						}
					});
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		};	
		
		vm.reselectCategory = function() {
			vm.searchCategory = "";
			vm.searchSOP = "";
			vm.isCategorySelected = false;
			vm.selectedCategory = "";
			vm.selectedCategoryId = "";
			vm.sopList = [];		
		}
				
		// **********************************************
				
		// Open Clone Recipe Modal Dialog
		vm.showCloneCategoryModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'cloneCategoryModal.html',
				controller: 'CloneSOPCategoryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							currentCompanyId: Auth.getCompanyId(),
							currentCategoryId: vm.selectedCategoryId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		};	
		
		// **********************************************

		// Call Actions
		vm.loadCategories();		
	};
	
	/** @ngInject */
    function SOPCreateCtrl($scope, $state, $uibModal, $location, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		vm.mode = 1;
		vm.sop = {};
		vm.sop.imageLocation = '';
		vm.sop.sopCategories = [];
		vm.sop.sopSteps = [];
		vm.categoryList = [];
		vm.sopTypes = [];
		vm.selectedCategories = [];
		vm.selectedSopType = [];	
		vm.blobUrl = RmsApi.BLOBURL;
		vm.fileToUpload = null;
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.lockUpdateButtons = false;
		vm.serverMode = Auth.getServerMode();
		
		/* ********************************************************************* */
				
		// Init Data
		vm.initData = function() {			
			vm.sop.imageLocation = 'assets/img/sop_empty_placeholder.png';
			vm.loadCategories();
		}
				
		// Go Back
		vm.goBack = function() {
			window.history.back();
		}	
				
		// Load SOP Category List
		vm.loadCategories = function() {
			HttpSvc.get('sopcategories/listformanage', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					result.forEach(function (c) {
						vm.categoryList.push({ id: c.id, name: c.name });
					});
					vm.loadTypes();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Category list.', '');
					$state.go('sops.sops.list');
					return null;
				});
		};
				
		// Load SOP Type List
		vm.loadTypes = function() {
			HttpSvc.get('soptypes/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.sopTypes = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve S.O.P Type list.', '');
					$state.go('sops.sops.list');
					return null;
				});
		};
		
		vm.onSelectedSopTypeChanged = function() {
			vm.sop.sopTypeId = vm.selectedSopType.id;
		}
		
		/* ********************************************************************* */
		
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";	
		
		// Submit Form
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');				
			} else {		
				vm.lockUpdateButtons = true;
				
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				vm.sop.sopCategories = vm.selectedCategories;	// Categories				
				
				if(vm.serverMode==1 && vm.fileToUpload) {					
					/* CHECK STORAGE QUOTA */
					if(vm.lockUploadButton) {
						toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Media Upload Error');
						return;
					}
					/* ******************* */
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/sop/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "sop/" + newFilename + mediaExtension;
					
				} else if(vm.sop.oriImageLocation!="") {
					imgLocation = vm.sop.oriImageLocation;
				}
				vm.sop.imageLocation = imgLocation;
								
				HttpSvc.post('sops', vm.sop, Auth.getTokenId(), false)
					.then(function(result) {
						vm.sop.id = result.sopId;
												
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(vm.serverMode);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/sop/" + vm.sop.id;
							vm.uploadImage(vm.serverMode);
							
						} else {							
							toastr.success('S.O.P has been created successfully.', Auth.translate('SUCCESS'));
							$location.path("/sops/sops/update/"+vm.sop.id);
						}
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.dataForm.$setPristine();
					});
			}
		};
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (serverMode) {
			var fileReader = new FileReader();
			
			if(serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('S.O.P has been created successfully.', Auth.translate('SUCCESS'));
					$location.path("/sops/sops/update/"+vm.sop.id);
				}, function (resp) {
					toastr.success('S.O.P has been created successfully.', Auth.translate('SUCCESS'));
					$location.path("/sops/sops/update/"+vm.sop.id);
					$state.go('sops.categories.list');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {	
							
							// Notify Server SOP Media ready
							HttpSvc.put('youtube/ready/sop/' + vm.sop.id, {}, Auth.getTokenId(), false)
								.then(function(result) {
									
									// Refresh Cloud Storage Stats
									Auth.selectBranchToken()
										.then(function() {	
											toastr.success('S.O.P has been created successfully.', Auth.translate('SUCCESS'));
											$location.path("/sops/sops/update/"+vm.sop.id);
										}, function(error) {
											toastr.success('S.O.P has been created successfully.', Auth.translate('SUCCESS'));										
											$location.path("/sops/sops/update/"+vm.sop.id);
										});		
								}, function(error) {
								});			
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
							vm.dataForm.$setPristine();
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};
					
		/* ********************************************************************* */
		
		// Remove Step
		vm.removeStep = function(stepNo) {			
			for (var i = vm.sop.sopSteps.length-1; i>=0; i--) {
				var s = vm.sop.sopSteps[i];
				if(s.step==stepNo) {
					vm.sop.sopSteps.splice(i, 1);
				}
			};
			for (var i = 0; i<vm.sop.sopSteps.length; i++) {
				var s = vm.sop.sopSteps[i];
				s.step = i;
				vm.sop.sopSteps.splice(i, 1, s);
			};
			$scope.$broadcast('refreshStTable');
		};
					
		// Update Step
		vm.updateStep = function(index, obj) {
			var element = {
				step: obj.step,
				name: obj.name,
				description: obj.description,
				extraDescription: obj.extraDescription,
				attachmentType: obj.attachmentType,
				attachmentLocation: obj.attachmentLocation,
			};
			vm.sop.sopSteps.splice(index, 1, element);
		};

		// Add Step
		vm.addStep = function(obj) {
			var element = {
				step: obj.step,
				name: obj.name,
				description: obj.description,
				extraDescription: obj.extraDescription,
				attachmentType: obj.attachmentType,
				attachmentLocation: obj.attachmentLocation,
			};
			vm.sop.sopSteps.push(element);
		};
		
		/* ********************************************************************* */
		
		// Open Step Modal Dialog
		vm.step = {};
		vm.showAddStepModal = function (continueAdd) {
			vm.step = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'stepModal.html',
				controller: 'SOPStepModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.step,
							nextStepNo: vm.sop.sopSteps.length,
							lockUploadButton: vm.lockUploadButton,
							continueAdd: continueAdd,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addStep(data);
				}, function () {
				});
		};	
		vm.showEditStepModal = function (stepNo) {
			vm.sop.sopSteps.forEach(function(s){
				if(s.step==stepNo) {
					vm.step = s;
				}
			});
			
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'stepModal.html',
				controller: 'SOPStepModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.step,
							blobUrl: RmsApi.BLOBURL,
							lockUploadButton: vm.lockUploadButton,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.updateStep(index, data);
				}, function () {
				});
		};		
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function SOPUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {

		Auth.init();
		
		var vm = this;
		vm.mode = 2;
		vm.sop = {};
		vm.sop.imageLocation = '';
		vm.sop.thumbnail = '';
		vm.sop.oriImageLocation = '';
		vm.sop.oriThumbnail = '';
		vm.categoryList = [];
		vm.sopTypes = [];
		vm.selectedCategories = [];	
		vm.selectedSopType = [];	
		vm.companyListWithCategories = [];	
		vm.changeLogs = [];
		vm.fileToUpload = null;	
		vm.mediaToUpload = null;	
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.canCloneRecipe = Auth.canCloneRecipe();
		vm.lockMoveButtons = false;
		vm.lockUpdateButtons = false;
		vm.lockUploadButton = (Auth.getAzureBlobUsage("mb") >= Auth.getAzureBlobQuota("mb"));
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.serverMode = Auth.getServerMode();
		
		/* ********************************************************************* */
		
		vm.initData = function() {
			vm.loadCategories();
		}
				
		// Go Back
		vm.goBack = function() {
			window.history.back();
		}
				
		// Load SOP Category List
		vm.loadCategories = function() {
			HttpSvc.get('sopcategories/listformanage', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					result.forEach(function (c) {
						vm.categoryList.push({ id: c.id, name: c.name });
					});	
					vm.loadCompanyListWithCategories();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Category list.', '');
					$state.go('sops.sops.list');
					return null;
				});
		};	
				
		// Load SOP Category List
		vm.loadCompanyListWithCategories = function() {
			HttpSvc.get('companies/listwithsopcategory', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companyListWithCategories = result;
					vm.loadTypes();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Company with Category list.', '');
					$state.go('sops.sops.list');
					return null;
				});
		};
				
		// Load SOP Type List
		vm.loadTypes = function() {
			HttpSvc.get('soptypes/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.sopTypes = result;
					vm.loadSOP();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve S.O.P Type list.', '');
					$state.go('sops.sops.list');
					return null;
				});
		};
				
		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('sopchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};	
		
		// Load SOP
		vm.loadSOP = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('sops/edit/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.sop = result;
					
					if(!vm.sop.imageLocation || vm.sop.imageLocation=='') {
						vm.sop.imageLocation = 'assets/img/sop_empty_placeholder.png';
						vm.sop.thumbnail = 'assets/img/sop_empty_placeholder.png';
						vm.sop.oriImageLocation = "";
						vm.sop.oriThumbnail = "";
					} else {
						vm.sop.oriImageLocation = vm.sop.imageLocation;
						vm.sop.oriThumbnail = vm.sop.thumbnail;
						vm.sop.imageLocation = vm.rootUrl + vm.sop.imageLocation;
						vm.sop.thumbnail = vm.rootUrl + vm.sop.thumbnail;
					}
		
					result.sopCategories.forEach(function (c) {
						vm.selectedCategories.push({ id: c.id, name: c.name });
					});	

					vm.sopTypes.forEach(function(t) {
						if(t.id==vm.sop.sopTypeId) {
							vm.selectedSopType = t;
						}
					});

					vm.loadChangeLogs();
					
				}, function() {
					toastr.error('Failed to load selected S.O.P.', Auth.translate('ERROR'))
					$state.go('sops.sops.list');
					return;
				});		
		};
		
		// Load SOP Steps
		vm.loadSOPSteps = function(sopId, upDown, continueAdd) {
			var params = { id: sopId };
			HttpSvc.get('sopsteps/sop/:id', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sop.sopSteps = result;						
					if(upDown!="") {
						toastr.success("Step has been moved " + upDown + " and saved.", "Success");	
					}
					if(continueAdd) {
						vm.showAddStepModal(continueAdd);
					}
					vm.lockMoveButtons = false;		
				}, function() {
					toastr.error('Failed to load S.O.P Steps.', Auth.translate('ERROR'))					
					vm.lockMoveButtons = false;
					return;
				});		
		};
		
		// Clone SOP
		vm.cloneSOP = function() {
			vm.lockUpdateButtons = true;
			
			HttpSvc.post('sops/clone/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {											
						toastr.success('S.O.P has been cloned successfully.', Auth.translate('SUCCESS'));	
						$state.go('sops.sops.update', {'id': result.newSopId });
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.dataForm.$setPristine();
				});
		}
		
		vm.onSelectedSopTypeChanged = function() {
			vm.sop.sopTypeId = vm.selectedSopType.id;
		}
		
		/* ********************************************************************* */
		
		var thumbnail = "";
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		// Submit Form
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all the Required Fields in all the Tabs.', 'Incomplete Fields');
			} else {
				vm.lockUpdateButtons = true;
				
				thumbnail = "";
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				vm.sop.sopCategories = vm.selectedCategories;	// Categories	
				
				if(vm.serverMode==1 && vm.fileToUpload) {					
					/* CHECK STORAGE QUOTA */
					if(vm.lockUploadButton) {
						toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Media Upload Error');
						return;
					}
					/* ******************* */
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/sop/" + newFilename + mediaExtension;
					thumbnail = null;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "sop/" + newFilename + mediaExtension;
										
				} else if(vm.sop.oriImageLocation!="" || vm.sop.oriImageLocation!=null) {
					imgLocation = vm.sop.oriImageLocation;
					thumbnail = vm.sop.oriThumbnail;
				}
				vm.sop.imageLocation = imgLocation;
				vm.sop.thumbnail = thumbnail;
				vm.sop.isThumbnailGenerated = true;
								
				HttpSvc.put('sops/' + $stateParams.id, vm.sop, Auth.getTokenId(), false)
					.then(function(result) {
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadMedia(vm.serverMode);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/sop/" + $stateParams.id;
							vm.uploadMedia(vm.serverMode);
							
						} else {							
							toastr.success('S.O.P has been updated successfully.', Auth.translate('SUCCESS'));
							vm.dataForm.$setPristine();
							vm.lockUpdateButtons = false;
							$state.reload();
							//$state.go('sops.sops.list');
						}
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.dataForm.$setPristine();
					});
			}
		};
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (serverMode) {
			var fileReader = new FileReader();
						
			if(serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('S.O.P has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('S.O.P has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {		
							
							// Notify Server SOP Media ready
							HttpSvc.put('youtube/ready/sop/' + $stateParams.id, {}, Auth.getTokenId(), false)
								.then(function(result) {
									
									// Refresh Clud Storage Stats
									Auth.selectBranchToken()
										.then(function() {	
											toastr.success('S.O.P has been updated successfully.', Auth.translate('SUCCESS'));
											$state.reload();
										}, function(error) {
											toastr.success('S.O.P has been updated successfully.', Auth.translate('SUCCESS'));
											$state.reload();
										});		
								}, function(error) {
								});
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};
		
		// Delete SOP
		vm.deleteSOP = function() {
			
			HttpSvc.delete('sops/' + vm.sop.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('The S.O.P [<b>' + vm.sop.name + '</b>] has been deleted.', 'Delete Success');
					$state.go('sops.sops.list');
				}, function() {
					// Failed
					toastr.error('Failed to delete the S.O.P.', 'Delete Failed');
					return null;
			});
		};

		// **********************************************
		// Remove Step
		vm.removeStep = function(stepId) {	
			vm.lockMoveButtons = true;
			
			HttpSvc.delete('sopsteps/' + stepId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.sop.sopSteps = result;
					toastr.success('The Step has been removed.', Auth.translate('SUCCESS'));
					$scope.$broadcast('refreshStTable');
					vm.lockMoveButtons = false;
				}, function(error) {
					// Failed
					toastr.error('Failed to remove the Step.', 'Failed');
					vm.lockMoveButtons = false;
					return null;
				});
		};
		
		// Move Up Step
		vm.moveStepUp = function(stepId) {
			vm.lockMoveButtons = true;
			
			HttpSvc.put('sopsteps/moveUp/' + stepId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loadSOPSteps(vm.sop.id, "up", false);
				}, function(error) {
					toastr.error("Failed to move Step up. " + error, "Failed");
					vm.lockMoveButtons = false;
				});	
		}
		
		// Move Down Step
		vm.moveStepDown = function(stepId) {
			vm.lockMoveButtons = true;
			
			HttpSvc.put('sopsteps/moveDown/' + stepId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loadSOPSteps(vm.sop.id, "down", false);
				}, function(error) {
					toastr.error("Failed to move Step down. " + error, "Failed");
					vm.lockMoveButtons = false;
				});	
		}
		
		/* ************************************************************* */
		
		// Refresh Document List
		vm.refreshDocs = function(tableState) {
			// Do nothing
		};
		
		// Remove Equipment Document
		vm.removeEquipment = function(eqId) {				
			for (var i = vm.sop.equipments.length-1; i>=0; i--) {
				var e = vm.sop.equipments[i];
				if(e.id==eqId) {
					vm.sop.equipments.splice(i, 1);
				}
			};
		};
		
		// Open Equipment Modal Dialog		
		vm.showAddEquipmentModal = function () {
			vm.equipment = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'EquipmentModal.html',
				controller: 'SOPEquipmentModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (dataList) {
					dataList.forEach(function(eq) {
						var isFound = false;
						vm.sop.equipments.forEach(function(e) {
							if(e.id==eq.id)
							{
								isFound = true;
							}
						});
						if(!isFound)
						{
							vm.sop.equipments.push(eq);
						}
						else
						{
							toastr.warning('One or more same equipments already exist on the list.');
						}
					});
				}, function () {
				});
		};	
		
		/* ************************************************************* */
		
		// Remove Process Document
		vm.removeProcess = function(procId) {				
			for (var i = vm.sop.asProcesses.length-1; i>=0; i--) {
				var e = vm.sop.asProcesses[i];
				if(e.id==procId) {
					vm.sop.asProcesses.splice(i, 1);
				}
			};
		};
		
		// Open Equipment Modal Dialog		
		vm.showAddProcessModal = function () {
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'ProcessModal.html',
				controller: 'SOPProcessModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (dataList) {
					dataList.forEach(function(proc) {
						var isFound = false;
						vm.sop.asProcesses.forEach(function(p) {
							if(p.id==proc.id)
							{
								isFound = true;
							}
						});
						if(!isFound)
						{
							vm.sop.asProcesses.push(proc);
						}
						else
						{
							toastr.warning('One or more processes already exist on the list.');
						}
					});
				}, function () {
				});
		};	
		
		/* ************************************************************* */
				
		// Open Clone SOP Modal Dialog
		vm.showCloneSOPModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'cloneSOPModal.html',
				controller: 'CloneSOPModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							companies: vm.companyListWithCategories,
							currentCompanyId: Auth.getCompanyId(),
							currentSOPId: vm.sop.id,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		};	
		
		// Open Step Modal Dialog
		vm.step = {};
		vm.showAddStepModal = function (continueAdd) {
			vm.step = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'stepModal.html',
				controller: 'SOPStepModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							sopId: vm.sop.id,
							object: vm.step,
							serverMode: vm.serverMode,
							nextStepNo: vm.sop.sopSteps.length,
							lockUploadButton: vm.lockUploadButton,
							continueAdd: continueAdd,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadSOPSteps(vm.sop.id, "", data.continueAdd);
				}, function () {
				});
		};	
		vm.showEditStepModal = function (stepId) {
			vm.sop.sopSteps.forEach(function(s){
				if(s.id==stepId) {
					vm.step = s;
				}
			});
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'stepModal.html',
				controller: 'SOPStepModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							object: vm.step,
							serverMode: vm.serverMode,
							lockUploadButton: vm.lockUploadButton,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.loadSOPSteps(vm.sop.id, "", false);
				}, function () {
				});
		};		
		
		// Call Actions
		vm.initData();		
	}

	// Clone SOP Modal Controller
	function CloneSOPModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.companies = item.companies;
		$mdl.currentCompanyId = item.currentCompanyId;
		$mdl.currentSOPId = item.currentSOPId;
		$mdl.selectedCompany = {};
		$mdl.selectedCategory = {};
		$mdl.lockButtons = false;
		
		// Initialize
		$mdl.companies.forEach( function(c) {
			if(c.id==$mdl.currentCompanyId) {
				$mdl.selectedCompany = c;
				if(c.sopCategories.length>0) {
					$mdl.selectedCategory = c.sopCategories[0];
				}
			}
		});
				
		/* ******************************************************** */
		
		$mdl.confirmModal = function() {									
			if($mdl.cloneForm.$valid) {				
				$mdl.lockButtons = true;
								
				HttpSvc.post("sops/clonetocompany/" + $mdl.currentSOPId + "/" + $mdl.selectedCompany.id + "/" + $mdl.selectedCategory.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("S.O.P is successfully cloned to <b>" + $mdl.selectedCompany.name + "</b> - <b>" + $mdl.selectedCategory.name + "</b>");
						$uibModalInstance.close();					
					}, function(error) {
						$mdl.lockButtons = false;
						toastr.error(error, 'Failed');
					});	
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
	
	// Clone SOP Category Modal Controller
	function CloneSOPCategoryModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.companies = [];
		$mdl.currentCompanyId = item.currentCompanyId;
		$mdl.currentCategoryId = item.currentCategoryId;
		$mdl.selectedCompany = {};
		$mdl.selectedCategory = {};
		$mdl.lockButtons = false;
		$mdl.isLoading = false;
				
		// Load SOP Category List
		$mdl.loadCompanyListWithCategories = function() {
			$mdl.isLoading = true;
			
			HttpSvc.get('companies/listwithsopcategory', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.companies = result;
					
					// Initialize
					$mdl.companies.forEach( function(c) {
						if(c.id==$mdl.currentCompanyId) {
							$mdl.selectedCompany = c;
							if(c.sopCategories.length>0) {
								$mdl.selectedCategory = c.sopCategories[0];
							}
						}
					});
					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve Company with Category list.', '');
					$mdl.cancelModal();
					return null;
				});
		};			
				
		/* ******************************************************** */
		
		$mdl.confirmModal = function() {									
			if($mdl.cloneForm.$valid) {				
				$mdl.lockButtons = true;
								
				HttpSvc.post("sops/clonecategorytocompany/" + $mdl.currentCategoryId + "/" + $mdl.selectedCompany.id + "/" + $mdl.selectedCategory.id, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("All SOPs in this Category have been successfully cloned to <b>" + $mdl.selectedCompany.name + "</b> - <b>" + $mdl.selectedCategory.name + "</b>");
						$uibModalInstance.close();					
					}, function(error) {
						$mdl.lockButtons = false;
						toastr.error(error, 'Failed');
					});	
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Init
		$mdl.loadCompanyListWithCategories();
	};
	
	// Step Modal Controller
	function SOPStepModalCtrl($uibModalInstance, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, item, toastr) {
		var $mdl = this;
		$mdl.mode = item.mode;
		$mdl.title = item.title;
		$mdl.item = item.object;
		$mdl.sopId = item.sopId;
		$mdl.serverMode = item.serverMode;
		$mdl.rootUrl = ($mdl.serverMode==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		$mdl.lockUploadButton = item.lockUploadButton;
		$mdl.youtubeUrl = "";
		$mdl.lockButton = false;
		$mdl.uploadProgess = 0;
		$mdl.uploadProgessTotal = 0;
		$mdl.uploadProgessPercent = 0;
		$mdl.activeTab = 0;
		
		var thumbnail = "";
		var mediaLocation = "";
		var mediaExtension = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		// Initialize
		if(item.mode==1) {
			$mdl.activeTab = 0;
			$mdl.item.step = item.nextStepNo;
			$mdl.item.name = "";
			$mdl.item.blobLocation = "";
			$mdl.item.description = "";
			$mdl.item.attachmentType = "";
			$mdl.item.attachmentLocation = "";
			$mdl.item.extraDescription = "";
			$mdl.item.continueAdd = item.continueAdd;
				
		} else if(item.mode==2) {
			$mdl.item.blobLocation = $mdl.item.attachmentLocation;
			if($mdl.item.attachmentLocation != "") {
				if($mdl.item.attachmentType) {
					/*if($mdl.item.attachmentType=="youtube") {
						$mdl.youtubeUrl = "https://www.youtube.com/watch?v=" + $mdl.item.attachmentLocation;
						$mdl.activeTab = 1;
					} else*/ 
					
					if($mdl.item.attachmentType.substring(0,5)=="video") {
						$mdl.activeTab = 1;
						$mdl.item.blobLocation = $mdl.rootUrl + $mdl.item.attachmentLocation;
					} else if($mdl.item.attachmentType.substring(0,5)=="image") {
						$mdl.activeTab = 1;
						$mdl.item.blobLocation = $mdl.rootUrl + $mdl.item.attachmentLocation;
					}

					if($mdl.item.isVimeoConverted && $mdl.item.vimeoVideoId!=null && $mdl.item.vimeoVideoId!=''){
						$mdl.activeTab = 1;
						$mdl.item.finalVimeoUrl = 
							$sce.trustAsResourceUrl("https://player.vimeo.com/video/" + $mdl.item.vimeoVideoId);
					}
				}
			}
		}
		
		// Update Step
		$mdl.updateStep = function(obj) {
			$mdl.lockButton = true;		
			
			var element = {
				sopId: obj.sopId,
				id: obj.id,
				step: obj.step,
				name: obj.name,
				description: obj.description,
				extraDescription: obj.extraDescription,
				attachmentType: obj.attachmentType,
				attachmentLocation: obj.attachmentLocation,
				thumbnail: obj.thumbnail
			};
			
			thumbnail = "";
			mediaLocation = "";
			mediaExtension = "";
			azureStorageUrl = "";
			localStorageUrl = "";
			var newFilename = UtilSvc.generateGuid() + ".";
			
			if($mdl.serverMode==1 && obj.mediaToUpload) {
				
				var extArray = obj.mediaToUpload.name.split(".");				
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = Auth.getCompanyId() + "/sopstep/" + newFilename + mediaExtension;
				element.attachmentType = $mdl.getMediaType(mediaExtension);
				
			} else if($mdl.serverMode==0 && obj.mediaToUpload) {	
			
				var extArray = obj.mediaToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = "sopstep/" + newFilename + mediaExtension;
				
			} else {
				if(element.attachmentLocation) {
					mediaLocation = element.attachmentLocation.replace("https://www.youtube.com/watch?v=", "");
					thumbnail = element.thumbnail;	
				}
			}
			element.isConvertedYoutube = true;
			element.attachmentLocation = mediaLocation;
			element.thumbnail = thumbnail;
						
			HttpSvc.put('sopsteps/' + obj.id, element, Auth.getTokenId(), false)
				.then(function(result) {
											
					if($mdl.serverMode==1 && obj.mediaToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + mediaLocation + result.azureSasToken;
						$mdl.uploadMedia(obj.mediaToUpload, obj.id);
						
					} else if($mdl.serverMode==0 && obj.mediaToUpload) {
						localStorageUrl = RmsApi.URL + "upload/sopstep/" + obj.id;
						$mdl.uploadMedia(obj.mediaToUpload, obj.id);
							
					} else {
						$uibModalInstance.close($mdl.item);
					}
				}, function(error) {
					$mdl.lockButton = false;
					$mdl.stepForm.$setPristine();
				});	
		};

		// Add Step
		$mdl.addStep = function(obj) {	
			$mdl.lockButton = true;			
			
			var element = {
				sopId: $mdl.sopId,
				step: obj.step,
				name: obj.name,
				description: obj.description,
				extraDescription: obj.extraDescription,
				attachmentType: obj.attachmentType,
				attachmentLocation: obj.attachmentLocation,
				thumbnail: ''
			};
			
			thumbnail = "";
			mediaLocation = "";
			mediaExtension = "";
			azureStorageUrl = "";
			localStorageUrl = "";
			var newFilename = UtilSvc.generateGuid() + ".";
			
			if($mdl.serverMode==1 && obj.mediaToUpload) {
				
				var extArray = obj.mediaToUpload.name.split(".");				
				mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = Auth.getCompanyId() + "/sopstep/" + newFilename + mediaExtension;
				element.attachmentType = $mdl.getMediaType(mediaExtension);
				
			} else if($mdl.serverMode==0 && obj.mediaToUpload) {	
			
				var extArray = obj.mediaToUpload.name.split(".");
				var mediaExtension = extArray[extArray.length-1].toLowerCase();
				mediaLocation = "sopstep/" + newFilename + mediaExtension;			
			}
			element.IsConvertedYoutube = true;
			
			if(obj.attachmentType!="youtube") {
				element.attachmentLocation = mediaLocation;
			}
			
			HttpSvc.post('sopsteps', element, Auth.getTokenId(), false)
				.then(function(result) {
											
					if($mdl.serverMode==1 && obj.mediaToUpload) {
						azureStorageUrl = RmsApi.BLOBURL + mediaLocation + result.azureSasToken;
						$mdl.uploadMedia(obj.mediaToUpload, result.id);
						
					} else if($mdl.serverMode==0 && obj.mediaToUpload) {
						localStorageUrl = RmsApi.URL + "upload/sopstep/" + result.id;
						$mdl.uploadMedia(obj.mediaToUpload, result.id);
					
					} else {
						$uibModalInstance.close($mdl.item);
					}
					//vm.sop.sopSteps.push(element);
				}, function(error) {
					toastr.error(error, Auth.translate('ERROR'));
					$mdl.lockButton = false;
					$mdl.stepForm.$setPristine();
				});			
		};
		
		// ********************************************************
		
        var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		
		// Upload Image to Azure Blob Storage
		$mdl.uploadMedia = function (_fileToUpload, _sopStepId) {
			
			/* Initialize variables */
			/* ************************************* */	
			handleFileSelect(_fileToUpload);
			/* ************************************* */	
			
			/* Initialize File Reader */
			/* ************************************* */
			fileReader = new FileReader();
			/* ************************************* */
			
			if($mdl.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (resp) {
					toastr.success('Media uploaded successfully.', Auth.translate('SUCCESS'));
					$uibModalInstance.close($mdl.item);
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if($mdl.serverMode==1) { // Azure Server
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl, _sopStepId);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl, _sopStepId);
							} else {
								$mdl.lockButton = false;					
								$mdl.stepForm.$setPristine();
							} 
						}, null, function(evt) {
							$mdl.uploadProgessTotal = _fileToUpload.size;
							$mdl.uploadProgess = $mdl.uploadProgessTotal - totalBytesRemaining;
							$mdl.uploadProgessPercent = Math.min(100, parseInt(100.0 * $mdl.uploadProgess / $mdl.uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl, _sopStepId) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl, _sopStepId);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl, _sopStepId) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,
				
			}).then(function(response) {
				HttpSvc.put('mediaconversion/ready/sopstep/' + _sopStepId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success("Media uploaded successfully.");
						$uibModalInstance.close($mdl.item);
					}, function(error) {
					});
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }
		
		// ********************************************************		
		
		//Set Upload Media
		$mdl.setUploadMedia = function(mediaFile) {
			$mdl.item.mediaToUpload = mediaFile;
		}
		
		// Confirm Action
		$mdl.confirmModal = function() {			
			if($mdl.stepForm.$valid) {
				if(item.mode==1) {
					$mdl.addStep($mdl.item);	
				} else if(item.mode==2) {
					$mdl.updateStep($mdl.item);
				}
				
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Get Content Type
		$mdl.getMediaType = function(mediaExtension) {
			mediaExtension = mediaExtension.toLowerCase();
			
			if(mediaExtension=='jpg' || mediaExtension=='jpeg') {
				return "image";
			} else if(mediaExtension=='png') {
				return "image";
			} else if(mediaExtension=='gif') {
				return "image";
			} else if(mediaExtension=='mp4') {
				return "video";	
			} else if(mediaExtension=='3gp') {
				return "video";	
			} else if(mediaExtension=='mov') {
				return "video";
			}
		};
	};	

	// Equipment Modal Controller
	function SOPEquipmentModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		// Initialize
		$mdl.selectedEquipments = [];
		$mdl.equipmentList = [];
		$mdl.lockButton = false;

		$mdl.searchEquipment = function() {
			$mdl.lockButton = true;
			
			HttpSvc.get('equipments/list/' + $mdl.searchText, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.equipmentList = result;
					$mdl.lockButton = false;
				}, function(error) {
					toastr.error("Failed to retrieve Equipment list.", "Failed");
					$uibModalInstance.dismiss('cancel');
				});				
		}
		
		// Confirm Action
		$mdl.confirmModal = function() {
			var eqList = [];
			$mdl.selectedEquipments.forEach(function(e) {
				var eq = {
					id: e.id,
					code: e.code,
					name: e.name,
					model: e.model,
					brandName: e.brandName,
					description: e.description,
				};
				eqList.push(eq);
			});
			
			if($mdl.equipmentForm.$valid) {
				$uibModalInstance.close(eqList);
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	

	// Process Modal Controller
	function SOPProcessModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		// Initialize
		$mdl.selectedProcesses = [];
		$mdl.processList = [];
		$mdl.lockButton = false;

		$mdl.searchProcess = function() {
			$mdl.lockButton = true;
			
			HttpSvc.get('services/processes/list/' + $mdl.searchText, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.processList = result;
					$mdl.lockButton = false;
				}, function(error) {
					toastr.error("Failed to retrieve Process list.", "Failed");
					$uibModalInstance.dismiss('cancel');
				});				
		}
		
		// Confirm Action
		$mdl.confirmModal = function() {
			var procList = [];
			$mdl.selectedProcesses.forEach(function(e) {
				var proc = {
					id: e.id,
					code: e.code,
					name: e.name,
				};
				procList.push(proc);
			});
			
			if($mdl.processForm.$valid) {
				$uibModalInstance.close(procList);
			}
		};

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.sops.soptypes.controller', [])
        .controller('SOPTypeMainCtrl', SOPTypeMainCtrl)
        .controller('SOPTypeCreateCtrl', SOPTypeCreateCtrl)
        .controller('SOPTypeUpdateCtrl', SOPTypeUpdateCtrl)
        .controller('SOPTypeDebtorCategoryModalCtrl', SOPTypeDebtorCategoryModalCtrl);

    /** @ngInject */
    function SOPTypeMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.docTypeDataFull = [];
		vm.docTypeData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.docTypeDataFull, tableState.search.predicateObject) : vm.docTypeDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.docTypeData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.docTypeDataFull.length <= 0) {
				vm.isLoading = true;

				HttpSvc.get('soptypes/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.docTypeDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteType = function(docTypeId, docTypeName) {
			var params = {};
			HttpSvc.delete('soptypes/' + docTypeId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('soptypes/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.docTypeDataFull = result;
							
							toastr.success('The S.O.P Type [' + docTypeName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the S.O.P Type [' + docTypeName + '].', 'Delete Failed');
					return null;
			});
		};
	};
	
	/** @ngInject */
    function SOPTypeCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.soptype = {};	
		vm.soptype.sopTypeDebtorCategories = [];
		
		/* ************************************************************* */
					
		// Open Debtor Category Modal Dialog
		vm.showAddDebtorCategoryModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'CustomerCategoryModal.html',
				controller: 'SOPTypeDebtorCategoryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addDebtorCategory(data);
				}, function () {
				});
		};				
		
		// Remove Debtor Category
		vm.removeDebtorCategory = function(index) {
			var result = confirm('Confirm remove this Debtor Category?');
			
			if(result) {
				vm.soptype.sopTypeDebtorCategories.splice(index, 1);				
			}
		};

		// Add Debtor Category
		vm.addDebtorCategory = function(obj) {
			var element = {
				debtorCategoryId: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.soptype.sopTypeDebtorCategories.some(function(el){
				if(el.debtorCategoryId === element.debtorCategoryId){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.soptype.sopTypeDebtorCategories.push(element);
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('soptypes', vm.soptype, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('S.O.P Type has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('sops.soptypes.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		// Do nothing
	}
	
	/** @ngInject */
    function SOPTypeUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.soptype = {};
		vm.soptype.sopTypeDebtorCategories = [];
		
		/* ************************************************************* */
						
		// Load SOPType
		vm.loadDocTypes = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('soptypes/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.soptype = result;
				}, function() {
					toastr.error('Failed to load selected S.O.P Type.', Auth.translate('ERROR'))
					$state.go('sops.soptypes.list');
					return;
				});		
		};	
		
		/* ************************************************************* */
					
		// Open Debtor Category Modal Dialog
		vm.showAddDebtorCategoryModal = function () {
			vm.prop = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'CustomerCategoryModal.html',
				controller: 'SOPTypeDebtorCategoryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addDebtorCategory(data);
				}, function () {
				});
		};				
		
		// Remove Debtor Category
		vm.removeDebtorCategory = function(index) {
			var result = confirm('Confirm remove this Debtor Category?');
			
			if(result) {
				vm.soptype.sopTypeDebtorCategories.splice(index, 1);				
			}
		};

		// Add Debtor Category
		vm.addDebtorCategory = function(obj) {
			var element = {
				debtorCategoryId: obj.id,
				name: obj.name,
			};
			
			var isFound = false;
			vm.soptype.sopTypeDebtorCategories.some(function(el){
				if(el.debtorCategoryId === element.debtorCategoryId){
					isFound = true; 
				 } 
			});
			
			if(!isFound)
				vm.soptype.sopTypeDebtorCategories.push(element);
		};
		
		/* ************************************************************* */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('soptypes/' + $stateParams.id, vm.soptype, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('S.O.P Type has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('sops.soptypes.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadDocTypes();		
	}
			
	// Debtor Category Modal Controller
	function SOPTypeDebtorCategoryModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		$mdl.item = {};
		$mdl.debtorCategories = [];
		$mdl.selectedCategory = null;
					 
		// Load Customer Categories
		$mdl.loadCategories = function() {			
			HttpSvc.get('debtorcategories/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.debtorCategories = result;
				}, function() {
					toastr.error('Failed to load Customer Category List.', Auth.translate('ERROR'))
					$mdl.cancelModal();
					return;
				});		
		};		
		
		$mdl.selectedCategoryChanged = function() {
			$mdl.item.id = $mdl.selectedCategory.id;
			$mdl.item.name = $mdl.selectedCategory.name;
		}
						
		$mdl.confirmModal = function() {
			if($mdl.categoryForm.$invalid || $mdl.selectedCategory == null) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$uibModalInstance.close($mdl.item);
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Init
		$mdl.loadCategories();
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.affiliates.controller', [])
        .controller('SAAffiliateMainCtrl', SAAffiliateMainCtrl)
        .controller('SAAffiliateCreateCtrl', SAAffiliateCreateCtrl)
        .controller('SAAffiliateUpdateCtrl', SAAffiliateUpdateCtrl);

    /** @ngInject */
    function SAAffiliateMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.affiliateDataFull = [];
		vm.affiliateData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.affiliateDataFull, tableState.search.predicateObject) : vm.affiliateDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.affiliateData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.affiliateDataFull.length <= 0) {							
				HttpSvc.get('affiliates/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.affiliateDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteAffiliation = function(affId) {
			var params = {};
			HttpSvc.delete('affiliates/' + affId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('affiliates/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.affiliateDataFull = result;
							
							toastr.success('The Affiliation has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete this Affiliation.', 'Delete Failed');
					return null;
			});
		};			
	};
	
	/** @ngInject */
    function SAAffiliateCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.aff = {};
		vm.aff.endDate = '2099-12-31';
		vm.companies = [];
		vm.selectedAffiliateCompany = null;
		vm.selectedClientCompany = null;
		
		/* **************************************************************** */

		// Load Companies 
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/search', {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.companies = result.data;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		/* **************************************************************** */

		// Select Affiliate Company
		vm.selectedAffiliateCompanyChanged = function() {
			vm.aff.affiliateCompanyId = vm.selectedAffiliateCompany.id;
		};
		
		vm.clearAffiliateCompany = function() {
			vm.selectedAffiliateCompany = null;
			vm.aff.affiliateCompanyId = null;
		}

		// Select Company
		vm.selectedClientCompanyChanged = function() {
			vm.aff.clientCompanyId = vm.selectedClientCompany.id;
		};
		
		vm.clearClientCompany = function() {
			vm.selectedClientCompany = null;
			vm.aff.clientCompanyId = null;
		}

		/* **************************************************************** */
				
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('affiliates', vm.aff, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Affiliation has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.affiliates.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadCompanyList();
	}
	
	/** @ngInject */
    function SAAffiliateUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.aff = {};	
		vm.companies = [];
		vm.selectedAffiliateCompany = null;
		vm.selectedClientCompany = null;
		
		/* **************************************************************** */

		// Load Companies 
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/search', {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.companies = result.data;
					vm.loadAffiliate();	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};
						
		// Load Affiliation
		vm.loadAffiliate = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('affiliates/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.aff = result;	
					vm.companies.forEach(function(c) {
						if(c.id==vm.aff.affiliateCompanyId){
							vm.selectedAffiliateCompany = c;
						}
						if(c.id==vm.aff.clientCompanyId){
							vm.selectedClientCompany = c;
						}
					});
				}, function() {
					toastr.error('Failed to load selected Affiliation.', Auth.translate('ERROR'))
					$state.go('superadmin.affiliates.list');
					return;
				});		
		};	

		/* **************************************************************** */

		// Select Affiliate Company
		vm.selectedAffiliateCompanyChanged = function() {
			vm.aff.affiliateCompanyId = vm.selectedAffiliateCompany.id;
		};
		
		vm.clearAffiliateCompany = function() {
			vm.selectedAffiliateCompany = null;
			vm.aff.affiliateCompanyId = null;
		}

		// Select Company
		vm.selectedClientCompanyChanged = function() {
			vm.aff.clientCompanyId = vm.selectedClientCompany.id;
		};
		
		vm.clearClientCompany = function() {
			vm.selectedClientCompany = null;
			vm.aff.clientCompanyId = null;
		}

		/* **************************************************************** */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('affiliates/' + $stateParams.id, vm.aff, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Affiliation has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadCompanyList();		
	}
})();

(function () {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.announcements.controller', [])
        .controller('SAAnnouncementMainCtrl', SAAnnouncementMainCtrl)
        .controller('SAAnnouncementCreateCtrl', SAAnnouncementCreateCtrl)
        .controller('SAAnnouncementUpdateCtrl', SAAnnouncementUpdateCtrl);

    /** @ngInject */
    function SAAnnouncementMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

        Auth.init();

        var vm = this;

        vm.pageSizeOption = [10, 20, 50, 100];
        vm.pageSize = 10;
        vm.numOfRecord = 0;
        vm.numOfRecordFiltered = 0;
        vm.numOfRecordDisplayed = 0;
        vm.startIndex = 0;
        vm.endIndex = 0;
        vm.announcementDataFull = [];
        vm.announcementData = [];

        function refreshTableState(tableState, startIndex, endIndex) {

            var filtered = tableState.search.predicateObject ? $filter('filter')(vm.announcementDataFull, tableState.search.predicateObject) : vm.announcementDataFull;
            vm.numOfRecordFiltered = filtered.length;

            if (tableState.sort.predicate) {
                filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
            }
            var result = filtered.slice(startIndex, startIndex + endIndex);

            vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
            vm.announcementData = result;

            tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

            return tableState;
        };

        // Function to format the date
        vm.formatDate = function (dateString) {
            if (!dateString) return "";
            var date = new Date(dateString);
            return $filter('date')(date, 'yyyy-MM-dd HH:mm');
        };

        vm.retrieveData = function (tableState) {

            var params = {}
            var pagination = tableState.pagination;
            vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
            vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

            if (vm.announcementDataFull.length <= 0) {
                HttpSvc.get('announcement/all', params, Auth.getTokenId(), true)
                    .then(function (result) {
                        vm.announcementDataFull = [];
                        result.forEach(function (u) {
                            if (!u.isSuperAdmin) {
                                vm.announcementDataFull.push(u);
                            } else {
                                if (Auth.isSuperAdmin()) {
                                    vm.announcementDataFull.push(u);
                                }
                            }
                        });
                        vm.numOfRecord = vm.announcementDataFull.length;
                        refreshTableState(tableState, vm.startIndex, vm.endIndex);
                    }, function () {
                        // Failed
                        toastr.error('Failed to retrieve data.', '');
                        return null;
                    });
            } else {
                refreshTableState(tableState, vm.startIndex, vm.endIndex);
            }
        };

        vm.deleteAnnouncement = function (announcementId, announcementName) {
            var params = {};
            HttpSvc.delete('announcement/' + announcementId, params, Auth.getTokenId(), false)
                .then(function (result) {
                    HttpSvc.get('announcement/all', params, Auth.getTokenId(), true)
                        .then(function (result) {
                            vm.announcementDataFull = [];
                            result.forEach(function (u) {
                                if (!u.isSuperAdmin) {
                                    vm.announcementDataFull.push(u);
                                } else {
                                    if (Auth.isSuperAdmin()) {
                                        vm.announcementDataFull.push(u);
                                    }
                                }
                            });
                            vm.numOfRecord = vm.announcementDataFull.length;

                            toastr.success('The announcement [' + announcementName + '] has been deleted.', 'Delete Success');
                            $scope.$broadcast('refreshStTable');
                        }, function () {
                            // Failed
                            toastr.error('Failed to retrieve data.', '');
                            return null;
                        });
                }, function () {
                    // Failed
                    toastr.error('Failed to delete the announcement [' + announcementName + '].', 'Delete Failed');
                    return null;
                });
        };
    };

    /** @ngInject */
    function SAAnnouncementCreateCtrl($scope, $state, Auth, HttpSvc, UtilSvc, toastr) {

        Auth.init();

        var vm = this;
        vm.submitted = false;
        vm.announcement = {};
        vm.modules = [];
        vm.importanceLevels = [
            { id: "HIGH", name: "1 - HIGH" },
            { id: "MED", name: "2 - MED" },
            { id: "LOW", name: "3 - LOW" }
        ];
        vm.announcement.isActive = true;

        // Load Module List
        vm.loadModuleList = function () {
            HttpSvc.get('announcement/moduleList', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    result.forEach(function (module) {
                        vm.modules.push({ name: module.name });
                    });
                }, function () {
                    vm.modules = [];
                });
        };

        // Form Submission
        vm.submit = function () {
            if (vm.dataForm.$invalid) {
                toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
            } else {
                vm.announcement.moduleName = vm.modules.selected.name;
                vm.announcement.importanceLevel = vm.importanceLevels.selected.id;
                HttpSvc.post('announcement/add', vm.announcement, Auth.getTokenId(), false)
                    .then(function (result) {
                        toastr.success('Announcement has been created successfully.', Auth.translate('SUCCESS'));
                        $state.go('superadmin.announcements.list');
                    }, function (error) {
                        toastr.error(angular.toJson(error), 'Failed');
                    });
            }
        }

        // Call Actions
        vm.loadModuleList();
    }

    /** @ngInject */
    function SAAnnouncementUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

        Auth.init();

        var vm = this;
        vm.submitted = false;
        vm.announcement = {};
        vm.modules = [];
        vm.importanceLevels = [
            { id: "HIGH", name: "1 - HIGH" },
            { id: "MED", name: "2 - MED" },
            { id: "LOW", name: "3 - LOW" }
        ];

        // Load Module List
        vm.loadModuleList = function () {
            HttpSvc.get('announcement/moduleList', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    result.forEach(function (module) {
                        vm.modules.push({ name: module.name });
                    });

                    vm.modules.forEach(function (module) {
                        if (module.name == vm.announcement.moduleName) {
                            vm.modules.selected = module;
                        }
                    })
                }, function () {
                    vm.modules = [];
                });
        };

        // Load Announcement
        vm.loadAnnouncement = function () {
            var params = { id: $stateParams.id };
            HttpSvc.get('announcement/:id', params, Auth.getTokenId(), false)
                .then(function (result) {
                    vm.announcement = result;

                    vm.modules.forEach(function (module) {
                        if (module.name == vm.announcement.moduleName) {
                            vm.modules.selected = module;
                        }
                    })

                    vm.importanceLevels.forEach(function (level) {
                        if (level.id == vm.announcement.importanceLevel) {
                            vm.importanceLevels.selected = level;
                        }
                    })

                }, function () {
                    toastr.error('Failed to load selected Announcement.', Auth.translate('ERROR'))
                    $state.go('superadmin.announcements.list');
                    return;
                });
        };

        vm.submit = function () {
            if (vm.dataForm.$invalid) {
                toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
            } else {
                vm.announcement.moduleName = vm.modules.selected.name;
                vm.announcement.importanceLevel = vm.importanceLevels.selected.id;
                HttpSvc.put('announcement/' + $stateParams.id, vm.announcement, Auth.getTokenId(), false)
                    .then(function (result) {
                        toastr.success('Announcement has been updated successfully.', Auth.translate('SUCCESS'));
                        $state.go('superadmin.announcements.list');
                    }, function (error) {
                        toastr.error(error, 'Failed');
                    });
            }
        }

        // Call Actions
        vm.loadModuleList();
        vm.loadAnnouncement();

    }
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.affiliates_newcustomer.controller', [])
        .controller('SAAffiliateNewCustomerMainCtrl', SAAffiliateNewCustomerMainCtrl)
        .controller('SAAffiliateNewCustomerApprovalCtrl', SAAffiliateNewCustomerApprovalCtrl);

    /** @ngInject */
    function SAAffiliateNewCustomerMainCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.affiliateDataFull = [];
		vm.affiliateData = [];

		/* ************************************************************ */

		function refreshTableState(tableState, startIndex, endIndex) {
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.affiliateDataFull, tableState.search.predicateObject) : vm.affiliateDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.affiliateData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.affiliateDataFull.length <= 0) {							
				HttpSvc.get('companypendingapprovals/list/pending', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.affiliateDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		/* ************************************************************ */

		vm.showApproval = function(aff) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'approvalModal.html',
				controller: 'SAAffiliateNewCustomerApprovalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							aff: aff,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};
		
		vm.rejectCustomer = function(affId) {
			var params = {};
			HttpSvc.delete('companypendingapprovals/reject/' + affId, params, Auth.getTokenId(), false)
				.then(function(result) {
				}, function() {
					// Failed
					toastr.error('Failed to reject this Affiliate Customer.', 'Reject Failed');
					return null;
			});
		};			
	};
	
	function SAAffiliateNewCustomerApprovalCtrl($uibModalInstance, item, Auth, HttpSvc, toastr) {
		var $mdl = this;
		$mdl.aff = item.aff;
		$mdl.lockButtons = false;
		
		/* ************************************************************ */
		
		$mdl.confirmModal = function() {
				
			if($mdl.approvalForm.$valid) {
				HttpSvc.delete('companypendingapprovals/approve/' + $mdl.aff.id, $mdl.aff, Auth.getTokenId(), false)
					.then(function(result) {
					}, function() {
						toastr.error('Failed to approve this Affiliate Customer.', 'Approval Failed');
						return null;
				});
			} else {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
				$mdl.lockButtons = false;
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.branches.controller', [])
        .controller('SABranchMainCtrl', SABranchMainCtrl)
        .controller('SABranchCreateCtrl', SABranchCreateCtrl)
        .controller('SABranchUpdateCtrl', SABranchUpdateCtrl);

    /** @ngInject */
    function SABranchMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.branchDataFull = [];
		vm.branchData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.branchDataFull, tableState.search.predicateObject) : vm.branchDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.branchData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.branchDataFull.length <= 0) {							
				HttpSvc.get('branches/listall', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.branchDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteBranch = function(branchId, branchName) {
			var params = {};
			HttpSvc.delete('branches/' + branchId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('branches/listall', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.branchDataFull = result;
							
							toastr.success('The branch [' + branchName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the branch [' + branchName + '].', 'Delete Failed');
					return null;
			});
		};			
	};
	
	/** @ngInject */
    function SABranchCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 1;
		vm.branch = {};	
		vm.companies = [];
		vm.timezones = GetTimeZones();
		vm.selectedCompany = null;
		vm.selectedTimeZone = vm.timezones[19];

		// Load Companies 
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/search', {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.companies = result.data;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		// Select Company
		vm.selectCompany = function() {
			vm.branch.companyId = vm.selectedCompany.id;
		};

		// Select Timezone
		vm.selectedTimeZoneChanged = function() {
			vm.branch.timeZone = vm.selectedTimeZone.id;
		}
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('branches/add', vm.branch, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Branch has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.branches.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadCompanyList();
	}
	
	/** @ngInject */
    function SABranchUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 2;
		vm.branch = {};
		vm.companies = [];
		vm.selectedCompany = null;
		vm.selectedTimeZone = null;
		vm.timezones = GetTimeZones();

		// Load Companies 
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/search', {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.companies = result.data;	
					vm.loadBranch();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};
						
		// Load Branch
		vm.loadBranch = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('branches/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.branch = result;	
					vm.companies.forEach(function(c) {
						if(c.id==vm.branch.companyId){
							vm.selectedCompany = c;
						}
					});
					vm.timezones.forEach(function(tz) {
						if(tz.id==vm.branch.timezone){
							vm.timezones.selected = tz;
						}
					});
				}, function() {
					toastr.error('Failed to load selected Branch.', Auth.translate('ERROR'))
					$state.go('superadmin.branches.list');
					return;
				});		
		};	

		// Select Company
		vm.selectCompany = function(item) {
			vm.branch.companyId = item.id;
		};

		// Select Timezone
		vm.selectedTimeZoneChanged = function() {
			vm.branch.timeZone = vm.selectedTimeZone.id;
		}
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('branches/' + $stateParams.id, vm.branch, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Branch has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.branches.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadCompanyList();		
	}

	function GetTimeZones() {
		var tzs = [
			{ id: -11, name: 'GMT-11' },
			{ id: -10, name: 'GMT-10' },
			{ id: -9, name: 'GMT-9' },
			{ id: -8, name: 'GMT-8' },
			{ id: -7, name: 'GMT-7' },
			{ id: -6, name: 'GMT-6' },
			{ id: -5, name: 'GMT-5' },
			{ id: -4, name: 'GMT-4' },
			{ id: -3, name: 'GMT-3' },
			{ id: -2, name: 'GMT-2' },
			{ id: -1, name: 'GMT-1' },
			{ id: 0, name: 'GMT+0' },
			{ id: 1, name: 'GMT+1' },
			{ id: 2, name: 'GMT+2' },
			{ id: 3, name: 'GMT+3' },
			{ id: 4, name: 'GMT+4' },
			{ id: 5, name: 'GMT+5' },
			{ id: 6, name: 'GMT+6' },
			{ id: 7, name: 'GMT+7' },
			{ id: 8, name: 'GMT+8' },
			{ id: 9, name: 'GMT+9' },
			{ id: 10, name: 'GMT+10' },
			{ id: 11, name: 'GMT+11' }
		];
		return tzs;
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.commissions.controller', [])
        .controller('SACommissionCtrl', SACommissionCtrl);

	/** @ngInject */
    function SACommissionCtrl($scope, $state, $filter, Auth, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.payment = {};
		vm.companyList = [];
		vm.statementList = [];
		vm.fullStatementList = [];
		vm.statementGenerationResult = [];
		vm.selectedCompany = null;
		vm.selectedStatement = null;
		vm.selectedTab = 0;
		vm.isLoading = false;

		/* ****************************************************************************** */

		// Init Data
		vm.initData = function() {	
			vm.payment.companyId='';
			vm.payment.statementId='';
			vm.payment.paymentRefNo='';
			vm.payment.amount = null;

			vm.loadCompanyList();
		}
		
		// Reset Fields
		vm.resetFields = function() {
			vm.payment.companyId='';
			vm.payment.statementId='';
			vm.payment.paymentRefNo='';
			vm.payment.amount = null;
			vm.statementList = [];
			vm.selectedCompany = null;
			vm.selectedStatement = null;
		}
					
		// Load Company List
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/listwithosstatement', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companyList = result;	
					
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Company list.', '');
					return null;
				});			
		}
		
		// Load O/S Invoice List
		vm.loadOutstandingInvoiceList = function(companyId) {
			HttpSvc.get('affiliatestatements/list/pending/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.statementList = result;						
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Invoice list.', '');
					return null;
				});			
		}	
				
		/* ****************************************************************************** */
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.stmtDataFull = [];
		vm.stmtData = [];
				
		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.stmtDataFull, tableState.search.predicateObject) : vm.stmtDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.stmtData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.stmtDataFull.length <= 0) {
				HttpSvc.get('affiliatestatements/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.numOfRecord = result.length;
					vm.stmtDataFull = result;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);					
				}, function() {
					toastr.error('Failed to retrieve Full Statement list.', '');
					return null;
				});	
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	

		vm.printStatement = function(statementId, statementNo) {
			var filename = "STATEMENT_" + statementNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('affiliatestatements/print/' + statementId, Auth.getTokenId(), filename)
				.then(function(result) {					
				}, function(error) {					
				});
		}

		/* ****************************************************************************** */
		
		vm.selectedCompanyChanged = function() {
			vm.payment.companyId = vm.selectedCompany.id;
			vm.loadOutstandingInvoiceList(vm.payment.companyId);	
		}
		
		vm.selectedStatementChanged = function() {
			vm.payment.statementId = vm.selectedStatement.id;
		}
		
		/* ****************************************************************************** */
		
		// Form Submission
		vm.submit = function() {
						
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {		
				vm.isLoading = true;
				
				if(vm.selectedTab==0) {
				
					HttpSvc.post('affiliatestatements/payment', vm.payment, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Commission Payment has been submitted successfully.', Auth.translate('SUCCESS'));
							vm.resetFields();
							vm.dataForm.$setPristine();
							
							vm.isLoading = false;
						}, function(error) {
							vm.isLoading = false;
							toastr.error(error, 'Payment Failed');
					});		
						
				} else if(vm.selectedTab==1) { 
					
					HttpSvc.post('affiliatestatements/generate/' + vm.statement.year + '/' + vm.statement.month, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.statementGenerationResult = result;
							toastr.success('Statements have been generated successfully.', Auth.translate('SUCCESS'));
							vm.resetFields();
							vm.dataForm.$setPristine();
							vm.isLoading = false;
						}, function(error) {
							vm.isLoading = false;
							toastr.error(error, 'Statements Generation Failed');
						});			
				}
			
				
			}
		}
		
		// Call Actions
		vm.initData();
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.businessmetrics.controller', ['ngSanitize'])
        .controller('BusinessMetricsCtrl', BusinessMetricsCtrl);

	/** @ngInject */
    function BusinessMetricsCtrl($scope, $state, Auth, HttpSvc, RmsApi, UtilSvc, toastr) {

		Auth.init();			
		
		var vm = this;
		var d = new Date();
		var startYr = d.getFullYear()-1;
		var endYr = d.getFullYear();
  		var startMth = d.getMonth();
  		var endMth = d.getMonth()-1;
		  
		if(startMth>12){
			startMth=0;
			startYr+=1;
		}
		if(endMth<0){
			endMth=11;
			endYr-=1;
			//startYr-=1;
		}

		vm.monthList = GetMonthList();
		vm.yearList = GetYearList();
		vm.startMonth = vm.monthList[startMth].id;
		vm.startYear = startYr;
		vm.endMonth = vm.monthList[endMth].id;
		vm.endYear = endYr;
		
		vm.selectedStartMonth = vm.monthList[startMth];
		vm.selectedEndMonth = vm.monthList[endMth];
		vm.yearList.forEach(function(y) {
			if(y.id==startYr)
			{
				vm.selectedStartYear = y;
			}
			if(y.id==endYr)
			{
				vm.selectedEndYear = y;
			}
		})
		vm.metric_iot = [];
		vm.metric_mrr = [];
		vm.metric_biz = [];
		vm.metric_runway = [];

		/* ********************************************************************* */

		vm.selectedStartMonthChanged = function() {
			vm.startMonth = vm.selectedStartMonth.id;
		}
		
		vm.selectedStartYearChanged = function() {
			vm.startYear = vm.selectedStartYear.id;
		}

		vm.selectedEndMonthChanged = function() {
			vm.endMonth = vm.selectedEndMonth.id;
		}
		
		vm.selectedEndYearChanged = function() {
			vm.endYear = vm.selectedEndYear.id;
		}

		/* ********************************************************************* */
		
		vm.loadMetrics = function() {
			vm.loadIotMetrics();
		}

		// Load IoT Metrics
		vm.loadIotMetrics = function() {			
			var period = vm.startMonth + "/"  + vm.startYear + "/"  + vm.endMonth + "/"  + vm.endYear;
			HttpSvc.get('metrics/sensormetric/' + period, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.metric_iot = result;
					//vm.loadMrrMetrics();
					vm.loadBizMetrics();
				}, function(error) {
					toastr.error('Failed to load IOT Metrics. ' + error, Auth.translate('ERROR'));
					return;
				});		
		};
		
		// Load MRR Metrics
		vm.loadMrrMetrics = function() {			
			var period = vm.startMonth + "/"  + vm.startYear + "/"  + vm.endMonth + "/"  + vm.endYear;
			HttpSvc.get('metrics/mrrmetric/1/' + period + '/1/1/true/', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.metric_mrr = result;	
					vm.loadBizMetrics();		
				}, function(error) {
					toastr.error('Failed to load MRR Metrics. ' + error, Auth.translate('ERROR'));
					$state.go('dashboard');
					return;
				});		
		};
		
		// Load MRR Metrics
		vm.loadBizMetrics = function() {			
			var period = vm.startMonth + "/"  + vm.startYear + "/"  + vm.endMonth + "/"  + vm.endYear;
			HttpSvc.get('metrics/bizmetric/' + period, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.metric_biz = result;
					vm.calcRunway();			
				}, function(error) {
					toastr.error('Failed to load Business Metrics. ' + error, Auth.translate('ERROR'));
					$state.go('dashboard');
					return;
				});		
		};

		vm.calcRunway = function() {
			vm.metric_runway=[];
			for(var i=0; i<vm.metric_biz.length; i++)
			{
				var pnl = vm.metric_biz[i].netProfitLoss;
				var cash = vm.metric_biz[i].cashBalance;

				var runway = cash / Math.abs(pnl);
				vm.metric_runway.push({ runway: runway});
			}
		}

		/* ********************************************************************* */

		vm.loadMetrics();
	};

	function GetMonthList() {
		return [
			{id:1, name:"JAN"},
			{id:2, name:"FEB"},
			{id:3, name:"MAR"},
			{id:4, name:"APR"},
			{id:5, name:"MAY"},
			{id:6, name:"JUN"},
			{id:7, name:"JUL"},
			{id:8, name:"AUG"},
			{id:9, name:"SEP"},
			{id:10, name:"OCT"},
			{id:11, name:"NOV"},
			{id:12, name:"DEC"},
		];
	}

	function GetYearList() {
		return [
			{id:2021, name:"2021"},
			{id:2022, name:"2022"},
			{id:2023, name:"2023"}
		];
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.companies.controller', ['ngSanitize'])
        .controller('CompanyMainCtrl', CompanyMainCtrl)
        .controller('CompanyCreateCtrl', CompanyCreateCtrl)
        .controller('CompanyUpdateCtrl', CompanyUpdateCtrl)		
        .controller('CategoryModalCtrl', CategoryModalCtrl);

	function ObjTypes() {
		return ['image', 'text', 'qrcode', 'barcode'];
	}
	
    /** @ngInject */
    function CompanyMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 20;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.companyDataFull = [];
		vm.companyData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.companyDataFull, tableState.search.predicateObject) : vm.companyDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.companyData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.companyDataFull.length <= 0) {
				HttpSvc.get('companies/search', params, Auth.getTokenId(), false)
					.then(function(result) {	
						vm.numOfRecord = result.data.length;	
						vm.companyDataFull = result.data;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
	};
	
	/** @ngInject */
    function CompanyCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		
		vm.hourList = GetHourList();
		vm.minuteList = GetMinuteList();
		vm.intervalList = GetIntervalList();
		vm.integrationModes = GetIntegrationModes();
		vm.posIntModes = GetPOSIntegrationModes();
		
		vm.submitted = false;
		vm.mode = 1;
		vm.company = {};	
		vm.company.logoFile = '';
		vm.company.oriLogoFile = '';
		vm.company.ghlMainPrivateKey = '';
		vm.company.companyRecipeCategories = [];
		vm.serverPackages = [];
		vm.features = [];
		vm.selectedFeatures = [];
		vm.selectedSOCutOffHour = null;
		vm.selectedSOCutOffMinute = null;
		vm.selectedDOCutOffHour = null;
		vm.selectedDOCutOffMinute = null;
		vm.currencyList = [];
		vm.categoryList = [];
		vm.itemStorageList = [];
		vm.productStorageList = [];
		vm.blobUrl = RmsApi.BLOBURL;		
		vm.fileToUpload = null;
		vm.serverMode = Auth.getServerMode();
		vm.hasPosModule = Auth.hasCompanyFeature('pos');
		vm.attachments = {
			attachmentLocation1: null,
			attachmentLocation2: null,
			attachmentLocation3: null,
		}
		
		/* ********************************************************* */

		// Init Data
		vm.initData = function() {
			vm.company.billingPackageId = '';
			vm.company.serverPackageId = '';
			vm.company.isActive = true;
			vm.company.isBillable = false;
			vm.company.mailServer = "mail.codemax.my";
			vm.company.mailPort = 587;
			vm.company.mailLogin = "rms@codemax.my";
			vm.company.mailPassword = "x9zhR8lSC";
			vm.company.mailUseSsl = false;
			
			vm.loadCurrencyList();
		};

		vm.loadCurrencyList = function() {
			HttpSvc.get('currencies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.currencyList = result;					
					vm.loadItemStorageList();
				}, function() {
					toastr.error('Failed to load Currency List.', Auth.translate('ERROR'))
					return;
				});
		};
				
		// Load Item Storage List
		vm.loadItemStorageList = function() {
			HttpSvc.get('storages/listbytypes/1', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.itemStorageList = result;
					vm.loadProductStorageList();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Item Storage list.', '');
					return null;
				});
		};	
				
		// Load Product Storage List
		vm.loadProductStorageList = function() {
			HttpSvc.get('storages/listbytypes/2', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.productStorageList = result;
					vm.loadCategoryList();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Product Storage list.', '');
					return null;
				});
		};	
		
		// Load Category List
		vm.loadCategoryList = function() {
			HttpSvc.get('recipecategories/list/all', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.categoryList = result;
					vm.loadFeatureList();					
				}, function() {
					return;
				});		
		}
		
		// Load Feature List
		vm.loadFeatureList = function() {
			HttpSvc.get('featuresV2', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.features = result;	
					vm.loadServerPackages();					
				}, function() {
					return;
				});		
		}
		
		// Load Server Packages
		vm.loadServerPackages = function() {
			HttpSvc.get('serverpackages/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.serverPackages = result;					
				}, function() {
					return;
				});
		}

		/* ********************************************************* */
		
		vm.selectedSOCutOffHourChanged = function() {
			vm.company.setting_SalesOrder_CutOffTime_Hour = vm.selectedSOCutOffHour.id;
		}
		
		vm.selectedSOCutOffMinuteChanged = function() {
			vm.company.setting_SalesOrder_CutOffTime_Minute = vm.selectedSOCutOffMinute.id;
		}
		
		vm.selectedDOCutOffHourChanged = function() {
			vm.company.setting_DeliveryOrder_CutOffTime_Hour = vm.selectedDOCutOffHour.id;
		}
		
		vm.selectedDOCutOffMinuteChanged = function() {
			vm.company.setting_DeliveryOrder_CutOffTime_Minute = vm.selectedDOCutOffMinute.id;
		}

		// Select Server Package
		vm.selectedServerPackageChanged = function() {
			vm.company.serverPackageId = vm.selectedServerPackage.id;
		};

		// Select Integration Mode
		vm.selectPOSIntegrationMode = function(item) {
			vm.compSetting.poS_IntegrationMode = item.id;
		};

		vm.starterModeChanged = function() {
			if(vm.compSetting.setting_Company_StarterMode==true) {
				vm.compSetting.setting_Company_LiteMode = false;
			}
		}

		vm.liteModeChanged = function() {
			if(vm.compSetting.setting_Company_LiteMode==true) {
				vm.compSetting.setting_Company_StarterMode = false;
			}
		}

		/* ********************************************************* */		
		
		// Select All Features
		vm.selectAllFeatures = function() {
			vm.selectedFeatures = [];
			vm.features.forEach(function(f) {
				vm.selectedFeatures.push(f);
			});
		}
		
		// Deselect All Features
		vm.deselectAllFeatures = function() {
			vm.selectedFeatures = [];
		}
		
		vm.selectedItemStorageChanged = function(item) {
			vm.company.setting_Job_StockOutUponConfirmation_StorageId = vm.selectedItemStorage.id;
		}
		
		vm.selectedProductStorageChanged = function(item) {
			vm.company.setting_Job_StockInUponCompletion_StorageId = vm.selectedProductStorage.id;
		}

		// Select Integration Mode
		vm.selectIntegrationMode = function(item) {
			vm.company.integrationMode = item.id;
		};

		// Select Integration Mode
		vm.selectPOSIntegrationMode = function(item) {
			vm.compSetting.poS_IntegrationMode = item.id;
		};

		vm.starterModeChanged = function() {
			if(vm.compSetting.setting_Company_StarterMode==true) {
				vm.compSetting.setting_Company_LiteMode = false;
			}
		}

		vm.liteModeChanged = function() {
			if(vm.compSetting.setting_Company_LiteMode==true) {
				vm.compSetting.setting_Company_StarterMode = false;
			}
		}
		
		/* ********************************************************* */

		vm.resetLogo = function() {			
			vm.company.logoFile = 'assets/img/company_logo_placeholder.png';
			vm.company.oriLogoFile = "";
			picFile = null;
		}

		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		vm.submit = function() {
			if(vm.company.serverPackageId=='') {
				vm.dataForm.$invalid = true;
			}
			
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			} else {
				imgLocation = "";
				azureStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {	
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/company/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "company/" + newFilename + mediaExtension;	
					
				} else if(vm.company.oriLogoFile!="") {
					imgLocation = vm.company.oriLogoFile;
				}
				vm.company.logoFile = imgLocation;

				for (var key in vm.attachments) {
					if (vm.attachments[key] !== null) {
						var extArray = vm.attachments[key].name.split(".");
						var mediaExtension = extArray[extArray.length-1].toLowerCase();		
						var newAttachmentName = UtilSvc.generateGuid() + ".";		
						vm.company.companyTncs[0][key] = (vm.serverMode==1 ? (Auth.getCompanyId() + '/') : '') + "companytncs/" + newAttachmentName + mediaExtension;
					} 
				}
				
				vm.company.featureV2 = [];
				vm.selectedFeatures.forEach(function(f) {
					vm.company.featureV2.push({ id: f.id });
				});
				
				HttpSvc.post('companies/add', vm.company, Auth.getTokenId(), false)
					.then(function(result) {
						
						vm.checkTNCImages(result.azureSasToken);
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(vm.serverMode, azureStorageUrl, vm.fileToUpload);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/recipecategory/" + vm.categoryId;
							vm.uploadImage(vm.serverMode, localStorageUrl, vm.fileToUpload);
							
						} else {							
							toastr.success('Company has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('superadmin.companies.list');
						}
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkTNCImages = function (azureSasToken) {
			for (var key in vm.attachments) {
				if (vm.attachments[key] !== null) {
					if (vm.serverMode == 1) {
						azureStorageUrl = RmsApi.BLOBURL + vm.company.companyTncs[0][key] + azureSasToken;
						vm.uploadImage(vm.serverMode, azureStorageUrl, vm.attachments[key]);
					} else {
						localStorageUrl = RmsApi.URL + "upload/companytncs/" + $stateParams.id;
						vm.uploadImage(vm.serverMode, localStorageUrl, vm.attachments[key]);
					}
				}
			}
		}
		vm.setUploadAttachmentImage = function(picFile, attachmentLocation) {
			vm.attachments[attachmentLocation] = picFile;
			var placeholder = '[' + attachmentLocation.toUpperCase() + ']';
			if (picFile && !vm.company.companyTncs[0].salesOrderTnc.includes(placeholder)) {
            	vm.company.companyTncs[0].salesOrderTnc += ' ' + placeholder;
        	}
		}

		vm.deleteImage = function (attachmentLocation, event) {
			event.stopPropagation();
			vm.attachments[attachmentLocation] = null;
			vm.company.companyTncs[0][attachmentLocation] = "";
			var placeholder = '[' + attachmentLocation.toUpperCase() + ']';
			vm.company.companyTncs[0].salesOrderTnc = vm.company.companyTncs[0].salesOrderTnc.replace(placeholder, '').trim();
		}
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (serverMode, storageUrl, fileToUpload) {
			var fileReader = new FileReader();
			
			if(serverMode==0) {	// Local Server
			
				Upload.upload({
					url: storageUrl,
					data: {file: fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Company has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('superadmin.companies.list');
				}, function (resp) {
					toastr.success('Company has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('superadmin.companies.list');
				}, function (evt) {
				});
				
			} else if(serverMode==1) { // Azure Server
				fileReader.readAsArrayBuffer(fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: storageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {						
							toastr.success('Company has been created successfully.', Auth.translate('SUCCESS'));
							$state.go('superadmin.companies.list');
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};
		
		/* ************************************************************** */
		
		// Open Modal Dialog
		vm.recipeCategory = {};		
		vm.showAddCategoryModal = function () {
			vm.recipeCategory = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'categoryModal.html',
				controller: 'CategoryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.recipeCategory,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addCategory(data);
				}, function () {
				});
		};	
		
		// **********************************************
		
		// Remove Category
		vm.removeCategory = function(index) {
			vm.company.companyRecipeCategories.splice(index, 1);
			$scope.$broadcast('refreshStTable');	
		};

		// Add Category
		vm.addCategory = function(obj) {
			var element = {
				recipeCategoryId: obj.id,
				recipeCategory: {
					name: obj.name,
				},
				company: {
					name: obj.companyName,
				},
				isReadOnly: true,
				isOriginalOwner: false
			};
			vm.company.companyRecipeCategories.push(element);
		};

		// Refresh Category List
		vm.refreshRecipeCategories = function(tableState) {
			// Do nothing
		};		
		
		/* ************************************************************** */
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function CompanyUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {

		Auth.init();
		
		var vm = this;
		
		vm.hourList = GetHourList();
		vm.minuteList = GetMinuteList();
		vm.intervalList = GetIntervalList();
		vm.periodList = GetPeriodList();
		vm.integrationModes = GetIntegrationModes();
		vm.posIntModes = GetPOSIntegrationModes();

		vm.submitted = false;
		vm.mode = 2;
		vm.company = {};	
		vm.company.logoFile = '';
		vm.company.oriLogoFile = '';
		vm.company.ghlMainPrivateKey = '';
		vm.currencyList = [];
		vm.billingPackages = [];
		vm.serverPackages = [];
		vm.features = [];
		vm.selectedFeatures = [];
		vm.selectedSOCutOffHour = null;
		vm.selectedSOCutOffMinute = null;
		vm.selectedDOCutOffHour = null;
		vm.selectedDOCutOffMinute = null;
		vm.categoryList = [];
		vm.itemStorageList = [];
		vm.selectedItemStorage = {};
		vm.productStorageList = [];
		vm.selectedProductStorage = {};
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		//vm.blobUrl = RmsApi.BLOBURL;		
		vm.fileToUpload = null;
		vm.serverMode = Auth.getServerMode();
		vm.hasPosModule = Auth.hasCompanyFeature('pos');
		vm.isCheckingSMTP = false;

		vm.isInitialLoad = false;
		vm.compSetting = {};
		vm.attachments = {
			attachmentLocation1: null,
			attachmentLocation2: null,
			attachmentLocation3: null,
		}


		/* ********************************************************* */

		vm.setDefaultMailSettings = function() {
			vm.company.mailServer = "mail.codemax.my";
			vm.company.mailPort = 587;
			vm.company.mailLogin = "rms@codemax.my";
			vm.company.mailPassword = "x9zhR8lSC";
			vm.company.mailUseSsl = false;
		};	

		vm.setGMailSettings = function() {
			vm.company.mailServer = "smtp.gmail.com";
			vm.company.mailPort = 587;
			vm.company.mailLogin = "test@gmail.com";
			vm.company.mailPassword = "123456";
			vm.company.mailUseSsl = true;
		};		

		vm.testEmailSetting = function() {
			vm.isCheckingSMTP = true;

			HttpSvc.post('emails/test/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Email settings are valid.')
					vm.isCheckingSMTP = false;
				}, function(errorMsg) {
					vm.isCheckingSMTP = false;
					toastr.error(errorMsg, 'Test Failed');
					return;
				});	
		}

		/* ********************************************************* */

		vm.loadCurrencyList = function() {
			HttpSvc.get('currencies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.currencyList = result;					
					vm.loadItemStorageList();
				}, function() {
					toastr.error('Failed to load Currency List.', Auth.translate('ERROR'))
					return;
				});
		};
		
		// Load Item Storage List
		vm.loadItemStorageList = function() {
			HttpSvc.get('storages/listbytypes/1', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.itemStorageList = result;
					vm.loadProductStorageList();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Item Storage list.', '');
					return null;
				});
		};	
				
		// Load Product Storage List
		vm.loadProductStorageList = function() {
			HttpSvc.get('storages/listbytypes/2', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.productStorageList = result;
					vm.loadFeatureList();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Product Storage list.', '');
					return null;
				});
		};	
		
		// Load Feature List
		vm.loadFeatureList = function() {
			HttpSvc.get('featuresV2', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (f) {
						vm.features.push({ 
							id: f.id, 
							name: f.name, 
							state: f.state, 
							sequence: f.sequence, 
							isParent: f.isParent, 
							parentId: f.parentId 
						});
					});
					vm.loadServerPackages();					
				}, function() {
					return;
				});		
		}
		
		// Load Server Packages
		vm.loadServerPackages = function() {
			HttpSvc.get('serverpackages/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.serverPackages = result;		
					vm.loadCompany();
				}, function() {
					return;
				});		
		};
		
		// Load Company
		vm.loadCompany = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('companies/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.company = result;
					
					vm.company.featureV2.forEach(function(f) {
						vm.selectedFeatures.push({
							id: f.id, 
							name: f.name, 
							state: f.state, 
							sequence: f.sequence, 
							isParent: f.isParent, 
							parentId: f.parentId 
						});
					});
					
					vm.serverPackages.forEach(function(p) {
						if(p.id==vm.company.serverPackageId){
							vm.selectedServerPackage = p;
						}
					});	
					
					vm.itemStorageList.forEach(function(s) {
						if(s.id==vm.company.setting_Job_StockOutUponConfirmation_StorageId){
							vm.selectedItemStorage = s;
						}
					});	
					
					vm.productStorageList.forEach(function(s) {
						if(s.id==vm.company.setting_Job_StockInUponCompletion_StorageId){
							vm.selectedProductStorage = s;
						}
					});	
					
					vm.integrationModes.forEach(function(im) {
						if(im.id==vm.company.integrationMode){
							vm.integrationModes.selected = im;
						}
					});
					
					vm.currencyList.forEach(function(c) {
						if(vm.company.currencyCode == c.code){
							vm.selectedCurrency = c;
						}
					});

					vm.hourList.forEach(function(h) {
						if(h.id==vm.company.setting_SalesOrder_CutOffTime_Hour){
							vm.selectedSOCutOffHour = h;
						}
						if(h.id==vm.company.setting_DeliveryOrder_CutOffTime_Hour){
							vm.selectedDOCutOffHour = h;
						}
						if(h.id==vm.company.autoCount_Inventory_SyncTime_Hour){
							vm.selectedAutocountInvSyncHour = h;
						}
					});

					vm.minuteList.forEach(function(m) {
						if(m.id==vm.company.setting_SalesOrder_CutOffTime_Minute){
							vm.selectedSOCutOffMinute = m;
						}
						if(m.id==vm.company.setting_DeliveryOrder_CutOffTime_Minute){
							vm.selectedDOCutOffMinute = m;
						}
						if(m.id==vm.company.autoCount_Inventory_SyncTime_Minute){
							vm.selectedAutocountInvSyncMinute = m;
						}
					});

					vm.intervalList.forEach(function(i) {
						if(i.id==vm.company.autoCount_GlobalSyncRetry_Interval){
							vm.selectedAutocountGlobalSyncRetryInterval = i;
						}
					});

					vm.periodList.forEach(function(p) {
						if(p.id==vm.company.autoCount_Inventory_Sync_Interval){
							vm.selectedAutocountInvSyncInterval = p;
						}
					});
					
					if(!vm.company.logoFile || vm.company.logoFile=='') {
						vm.company.logoFile = 'assets/img/company_logo_placeholder.png';
						vm.company.oriLogoFile = "";
					} else {
						vm.company.oriLogoFile = vm.company.logoFile;
						vm.company.logoFile = vm.rootUrl + vm.company.logoFile;
					}

					vm.loadCompanySetting();
					vm.loadFTP();
					
				}, function() {
					toastr.error('Failed to load selected Company.', Auth.translate('ERROR'));
					$state.go('superadmin.companies.list');
					return;
				});		
		};

		vm.loadCompanySetting = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('companysettings/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.compSetting = result;
					
					vm.posIntModes.forEach(function(m) {
						if(m.id==vm.compSetting.poS_IntegrationMode)
						{
							vm.posIntModes.selected = m;
						}
					});

				}, function() {
					if(vm.isInitialLoad = true)
					{
						vm.isInitialLoad = false;
						vm.initSetting();
					}
					else
					{
						toastr.error('Failed to load selected Company Settings.', Auth.translate('ERROR'));
						$state.go('superadmin.companies.list');
						return;
					}
				});		
		}
		
		/* ********************************************************* */
		
		vm.selectedCurrencyChanged = function() {
			vm.company.currencyCode = vm.selectedCurrency.code;
		}
		
		vm.selectedSOCutOffHourChanged = function() {
			vm.company.setting_SalesOrder_CutOffTime_Hour = vm.selectedSOCutOffHour.id;
		}
		
		vm.selectedSOCutOffMinuteChanged = function() {
			vm.company.setting_SalesOrder_CutOffTime_Minute = vm.selectedSOCutOffMinute.id;
		}
		
		vm.selectedDOCutOffHourChanged = function() {
			vm.company.setting_DeliveryOrder_CutOffTime_Hour = vm.selectedDOCutOffHour.id;
		}
		
		vm.selectedDOCutOffMinuteChanged = function() {
			vm.company.setting_DeliveryOrder_CutOffTime_Minute = vm.selectedDOCutOffMinute.id;
		}
		
		vm.selectedAutocountInvSyncHourChanged = function() {
			vm.company.autoCount_Inventory_SyncTime_Hour = vm.selectedAutocountInvSyncHour.id;
		}
		
		vm.selectedAutocountInvSyncMinuteChanged = function() {
			vm.company.autoCount_Inventory_SyncTime_Minute = vm.selectedAutocountInvSyncMinute.id;
		}
		
		vm.selectedAutocountInvSyncIntervalChanged = function() {
			vm.company.autoCount_Inventory_Sync_Interval = vm.selectedAutocountInvSyncInterval.id;
		}
		
		vm.selectedAutocountGlobalSyncRetryIntervalChanged = function() {
			vm.company.autoCount_GlobalSyncRetry_Interval = vm.selectedAutocountGlobalSyncRetryInterval.id;
		}

		// Select Server Package
		vm.selectedServerPackageChanged = function() {
			vm.company.serverPackageId = vm.selectedServerPackage.id;
		};
		
		vm.setting_StockRequest_MultiSplitItemType_Changed = function() {
			if(!vm.compSetting.setting_StockRequest_MultiSplitItemType)
			{
				vm.compSetting.setting_StockRequest_MultiSplitCatAndSubCat = false;
			}
		}

		/* ********************************************************* */
		
		// Select All Features
		vm.selectAllFeatures = function() {
			vm.selectedFeatures = [];
			vm.features.forEach(function(f) {
				vm.selectedFeatures.push(f);
			});
		}
		
		// Deselect All Features
		vm.deselectAllFeatures = function() {
			vm.selectedFeatures = [];
		}	
		
		vm.selectedItemStorageChanged = function(item) {
			vm.company.setting_Job_StockOutUponConfirmation_StorageId = vm.selectedItemStorage.id;
		}
		
		vm.selectedProductStorageChanged = function(item) {
			vm.company.setting_Job_StockInUponCompletion_StorageId = vm.selectedProductStorage.id;
		}

		// Select Integration Mode
		vm.selectIntegrationMode = function(item) {
			vm.company.integrationMode = item.id;
		};

		// Select Integration Mode
		vm.selectPOSIntegrationMode = function(item) {
			vm.compSetting.poS_IntegrationMode = item.id;
		};

		vm.starterModeChanged = function() {
			if(vm.compSetting.setting_Company_StarterMode==true) {
				vm.compSetting.setting_Company_LiteMode = false;
			}
		}

		vm.liteModeChanged = function() {
			if(vm.compSetting.setting_Company_LiteMode==true) {
				vm.compSetting.setting_Company_StarterMode = false;
			}
		}
		
		/* ********************************************************* */

		vm.resetLogo = function() {
			var cfm = confirm("Confirm reset the Company Logo?");

			if(cfm)
			{
				vm.company.logoFile = 'assets/img/company_logo_placeholder.png';
				vm.company.oriLogoFile = "";
				picFile = null;
			}
		}
		
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		vm.submit = function() {
			if(vm.company.serverPackageId=='') {
				vm.dataForm.$invalid = true;
			}
			
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			} else {
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if (vm.serverMode == 1 && vm.fileToUpload) {
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/company/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "company/" + newFilename + mediaExtension;
					
				} else if(vm.company.oriLogoFile!="") {
					imgLocation = vm.company.oriLogoFile;
				}

				vm.company.logoFile = imgLocation;

				for (var key in vm.attachments) {
					if (vm.attachments[key] !== null) {
						var extArray = vm.attachments[key].name.split(".");
						var mediaExtension = extArray[extArray.length-1].toLowerCase();		
						var newAttachmentName = UtilSvc.generateGuid() + ".";		
						vm.company.companyTncs[0][key] = (vm.serverMode==1 ? (Auth.getCompanyId() + '/') : '') + "companytncs/" + newAttachmentName + mediaExtension;
					} 
				}
				
				
				vm.company.featureV2 = [];
				vm.selectedFeatures.forEach(function(f) {
					vm.company.featureV2.push({ id: f.id });
				})
				
				HttpSvc.put('companies/' + $stateParams.id, vm.company, Auth.getTokenId(), false)
					.then(function(result) {

						vm.saveSetting();
						vm.checkTNCImages(result.azureSasToken);
						if (vm.serverMode == 1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(vm.serverMode, azureStorageUrl, vm.fileToUpload);
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/company/" + $stateParams.id;
							vm.uploadImage(vm.serverMode,  localStorageUrl, vm.fileToUpload);
						} else {							
							toastr.success('Company has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						}
						
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkTNCImages = function (azureSasToken) {
			for (var key in vm.attachments) {
				if (vm.attachments[key] !== null) {
					if (vm.serverMode == 1) {
						azureStorageUrl = RmsApi.BLOBURL + vm.company.companyTncs[0][key] + azureSasToken;
						vm.uploadImage(vm.serverMode, azureStorageUrl,  vm.attachments[key]);
					} else {
						localStorageUrl = RmsApi.URL + "upload/companytncs/" + $stateParams.id;
						vm.uploadImage(vm.serverMode, localStorageUrl, vm.attachments[key]);
					}
				}
			}
		}

		vm.saveSetting = function() {
			HttpSvc.put('companysettings/' + vm.compSetting.id, vm.compSetting, Auth.getTokenId(), false)
				.then(function(result) {					
				}, function(error) {
					toastr.error('Failed to save company settings: ' + error, 'Failed');
				});
		}

		vm.initSetting = function() {			
			vm.compSetting = {
				companyId: $stateParams.id,
				setting_ExpiryCertByMonth: 3,
				setting_AssetScheduleByDay: 3,
				setting_Stock_StockOutQuickMode: false,
				setting_DeliveryOrder_DirectDO: false,
				setting_enableFTP: false,
				ftP_WebServiceUrl: null,
				ftP_Username: null,
				ftP_Password: null,
				autoCount_EnableSync_RawMat_StandardCost: false,
				autoCount_EnableSync_RawMat_StandardSellingPrice: false,
				autoCount_EnableSync_SemiFg_StandardSellingPrice: false,
				autoCount_EnableSync_Product_StandardSellingPrice: false,
				autocount_SyncItemPrice_SalesOrder: false,
				autocount_SyncItemPrice_DeliveryOrder: false,
				autocount_EnableSync_PurchaseTaxCode: false,
				autocount_EnableSync_InvoiceNo: false,
				autocount_SyncBack_InvoiceNo: false,
				autoCount_EnableSync_Grn: false,
				autoCount_SyncBack_GrnNo: false,
				autoCount_EnableSync_PurchaseInvoice: false
			};

			HttpSvc.post('companysettings', vm.compSetting, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loadCompanySetting();
				}, function(error) {
					toastr.error('Failed to save company settings: ' + error, 'Failed');
				});
		}
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (serverMode, storageUrl, fileToUpload) {
			var fileReader = new FileReader();
			
			if(serverMode==0) {	// Local Server
			
				Upload.upload({
					url: storageUrl,
					data: {file: fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Company has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('Company has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
				});
				
			} else if(serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: storageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {						
							toastr.success('Company has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
					});
				}
			}
		};
		
		/* ************************************************************** */
		
		// Open Modal Dialog
		vm.recipeCategory = {};		
		vm.showAddCategoryModal = function () {
			vm.recipeCategory = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'categoryModal.html',
				controller: 'CategoryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.recipeCategory,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addCategory(data);
				}, function () {
				});
		};	
		
		// **********************************************
		
		// Remove Category
		vm.removeCategory = function(index) {
			vm.company.companyRecipeCategories.splice(index, 1);
			$scope.$broadcast('refreshStTable');	
		};

		// Add Category
		vm.addCategory = function(obj) {
			var element = {
				recipeCategoryId: obj.id,
				recipeCategory: {
					name: obj.name,
					companyName: obj.companyName
				},
				isReadOnly: true,
				isOriginalOwner: false
			};
			vm.company.companyRecipeCategories.push(element);
		};

		// Refresh Category List
		vm.refreshRecipeCategories = function(tableState) {
			// Do nothing
		};		
		
		/* ************************************************************** */
		
		vm.testIntegrationAutoCount = function() {
			HttpSvc.post('companies/testintegration/autocount/' + vm.company.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Validation success.', Auth.translate('SUCCESS'));
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		};

		vm.testIntegrationSQL = function() {
			HttpSvc.get('sqlacc/maintenance/testconnection/' + vm.company.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('SQL Build No.: ' + result.SQL_BuildNo, 'Codemax Web Service No.: ' + result.Codemax_WebServiceNo);
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		};

		// Call Actions
		vm.loadCurrencyList();
		
		/* ************************************************************** */

		vm.isPurging = false;
		vm.isPurgingRawMat = false;
		vm.isPurgingSupplier = false;

		vm.purgeRawMat = function() {
			if(vm.isPurging) return;
			
			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Raw Material data?');

			if(toProceed) {
				vm.isPurgingRawMat = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/rawmat/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingRawMat = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingRawMat = false;
						vm.isPurging = false;
					});
			}
		}

		vm.purgeSemiFg = function() {
			if(vm.isPurging) return;
			
			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Semi Finished Goods data?');

			if(toProceed) {
				vm.isPurgingSemiFg = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/semifg/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingSemiFg = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingSemiFg = false;
						vm.isPurging = false;
					});
			}
		}

		vm.purgeFG = function() {
			if(vm.isPurging) return;
			
			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Finished Goods data?');

			if(toProceed) {
				vm.isPurgingFG = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/product/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingFG = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingFG = false;
						vm.isPurging = false;
					});
			}
		}

		vm.purgeSupplier = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Supplier data?');

			if(toProceed) {
				vm.isPurgingSupplier = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/supplier/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingSupplier = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingSupplier = false;
						vm.isPurging = false;
					});
			}
		}


		vm.purgePO = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Purchase Order data?');

			if(toProceed) {
				vm.isPurgingPO = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/po/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingPO = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingPO = false;
						vm.isPurging = false;
					});
			}
		}

		vm.purgeGRN = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL GRN data?');

			if(toProceed) {
				vm.isPurgingGRN = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/grn/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingGRN = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingGRN = false;
						vm.isPurging = false;
					});
			}
		}

		vm.purgeProdJobs = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Production Jobs data?');

			if(toProceed) {
				vm.isPurgingProdJobs = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/jobproduction/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingProdJobs = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingProdJobs = false;
						vm.isPurging = false;
					});
			}
		}

		vm.purgeBulkBreakJobs = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Bulk-Break Jobs data?');

			if(toProceed) {
				vm.isPurgingBulkBreakJob = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/bulkbreakjob/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingBulkBreakJob = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingBulkBreakJob = false;
						vm.isPurging = false;
					});
			}
		}


		vm.purgeRecipeItems = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Recipe Items?');

			if(toProceed) {
				vm.isPurgingRecipeItems = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/recipeitems/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingRecipeItems = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingRecipeItems = false;
						vm.isPurging = false;
					});
			}
		}
		

		vm.purgeRawMatInvBal = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Raw Material Inventory Balanace data?');

			if(toProceed) {
				vm.isPurgingRawMatInvBal = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/rawmat/inventory/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingRawMatInvBal = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingRawMatInvBal = false;
						vm.isPurging = false;
					});
			}
		}		

		vm.purgeSemiFgInvBal = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Semi Finished Goods Inventory Balanace data?');

			if(toProceed) {
				vm.isPurgingSemiFgInvBal = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/semifg/inventory/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingSemiFgInvBal = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingSemiFgInvBal = false;
						vm.isPurging = false;
					});
			}
		}	

		vm.purgeProductInvBal = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Finished Goods Inventory Balanace data?');

			if(toProceed) {
				vm.isPurgingProductInvBal = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/product/inventory/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingProductInvBal = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingProductInvBal = false;
						vm.isPurging = false;
					});
			}
		}
		

		vm.purgeRawMatInvMvmt = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Raw Material Inventory Movement data?');

			if(toProceed) {
				vm.isPurgingRawMatInvMvmt = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/rawmat/inventorymovement/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingRawMatInvMvmt = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingRawMatInvMvmt = false;
						vm.isPurging = false;
					});
			}
		}		

		vm.purgeSemiFgInvMvmt = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Semi Finished Goods Inventory Movement data?');

			if(toProceed) {
				vm.isPurgingSemiFgInvMvmt = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/semifg/inventorymovement/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingSemiFgInvMvmt = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingSemiFgInvMvmt = false;
						vm.isPurging = false;
					});
			}
		}	

		vm.purgeProductInvMvmt = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Finished Goods Inventory Movement data?');

			if(toProceed) {
				vm.isPurgingProductInvMvmt = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/product/inventorymovement/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingProductInvMvmt = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingProductInvMvmt = false;
						vm.isPurging = false;
					});
			}
		}
		

		vm.purgeRawMatLabel = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Raw Material Labels data?');

			if(toProceed) {
				vm.isPurgingRawMatLabel = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/rawmat/label/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingRawMatLabel = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingRawMatLabel = false;
						vm.isPurging = false;
					});
			}
		}
		
		vm.purgeSemiFgLabel = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Semi FG Labels data?');

			if(toProceed) {
				vm.isPurgingSemiFgLabel = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/semifg/label/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingSemiFgLabel = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingSemiFgLabel = false;
						vm.isPurging = false;
					});
			}
		}
		
		vm.purgeProductLabel = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL FG Labels data?');

			if(toProceed) {
				vm.isPurgingProductLabel = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/product/label/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingProductLabel = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingProductLabel = false;
						vm.isPurging = false;
					});
			}
		}
		
		/* ************************************************************** */

		vm.ftp = {};
		vm.ftp.dirList = [];
		vm.ftp.fileList = [];
		vm.subfolders = [];
		vm.newFtpFolder = null;
		vm.newFtpFile = null;
		vm.ftpIsUploading = false;
		vm.loadFTP = function() {
			HttpSvc.post('misc/ftp/list/labelfolder', {}, Auth.getTokenId(), false)
				.then(function(result) {

					vm.ftp = result;
					vm.subfolders = [];
					
				}, function(error) {
					toastr.error(error, 'Failed to load FTP content.');
				});
		}

		vm.navigateFolder = function(folderName) {
			
			var isFolderFound = false;
			vm.subfolders.forEach(function(f) {
				if(f==folderName)
				{
					isFolderFound = true;
				}
			});
			
			if(!isFolderFound)
				vm.subfolders.push(folderName);

			HttpSvc.post('misc/ftp/list/labelfolder/' + folderName, {}, Auth.getTokenId(), false)
				.then(function(result) {

					vm.ftp = result;
					
				}, function(error) {
					toastr.error(error, 'Failed to load FTP content.');
				});
		}

		vm.navigateBack = function() {
			vm.subfolders.splice(vm.subfolders.length-1, 1);

			if(vm.subfolders.length == 0)
			{
				vm.loadFTP();
			}
			else
			{
				vm.navigateFolder(vm.subfolders[vm.subfolders.length-1]);
			}
		}

		vm.createFolder = function(folderName) {

			HttpSvc.post('misc/ftp/list/labelfolder/' + folderName, {}, Auth.getTokenId(), false)
				.then(function(result) {
					//vm.loadFTP();
					vm.ftp = result;
					vm.newFtpFolder = null;					
					vm.subfolders.push(folderName);
					toastr.success('Folder created successfully.');

				}, function(error) {
					toastr.error(error, 'Failed to load FTP content.');
				});
		}

		vm.cleanUpPath = function(filename) {

			for(var x=vm.subfolders.length-1; x>=0; x--)
			{
				filename = filename.replace(vm.subfolders[x] + '\\', '');				
			}

			return filename;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadFtpFile = function () {	
			vm.ftpIsUploading = true;

			var api = RmsApi.URL + "misc/ftp/labelfolder/upload";
			for(var x=0; x<vm.subfolders.length; x++)
			{
				api = api + "/" + vm.subfolders[x];
			}
			
			Upload.upload({
				url: api,
				data: {file: vm.newFtpFile},
				headers: {'Authorization': 'basic ' + Auth.getTokenId() },

			}).then(function (resp) {
				
				toastr.success('File uploaded successfully.', Auth.translate('SUCCESS'));

				if(vm.subfolders.length == 0)
				{
					vm.loadFTP();
				}
				else
				{
					vm.navigateFolder(vm.subfolders[vm.subfolders.length-1]);
				}
				vm.resetFtpFile();

			}, function (resp) {

				vm.resetFtpFile();
				toastr.error(resp.data.message, 'Failed');

			}, function (evt) {
				//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
				//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
			});
		};

		vm.resetFtpFile = function () {
			vm.ftpIsUploading = false;
			vm.newFtpFile = null;
		}

		// Sales Order TNC
		vm.setUploadAttachmentImage = function(picFile, attachmentLocation) {
			vm.attachments[attachmentLocation] = picFile;
			var placeholder = '[' + attachmentLocation.toUpperCase() + ']';
			if (picFile && !vm.company.companyTncs[0].salesOrderTnc.includes(placeholder)) {
            	vm.company.companyTncs[0].salesOrderTnc += ' ' + placeholder;
        	}
		}

		vm.deleteImage = function (attachmentLocation, event) {
			event.stopPropagation();
			vm.attachments[attachmentLocation] = null;
			vm.company.companyTncs[0][attachmentLocation] = "";
			var placeholder = '[' + attachmentLocation.toUpperCase() + ']';
			vm.company.companyTncs[0].salesOrderTnc = vm.company.companyTncs[0].salesOrderTnc.replace(placeholder, '').trim();
		}
	}

	// Category Modal Controller
	function CategoryModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.categoryList = [];
		$mdl.item = item.object;
		$mdl.selectedCategory = null;
		
		// Initialize
		if(item.mode==1) {
			$mdl.item.id = "";
			$mdl.item.name = "";
		} else {
			if($mdl.item.id!='' && $mdl.item.id!=null)
			{
				$mdl.searchCategoryList($mdl.item.name);
			// 	$mdl.itemList.forEach(function (i) {
			// 		if(i.id==$mdl.item.id) {
			// 			$mdl.selectedItem = i;
			// 			$mdl.item.name = i.name;
			// 			$mdl.item.companyName = i.companyName;
			// 		}
			// 	});
			}
		}	
		
		// Search Category List
		$mdl.searchCategoryList = function(searchString) {
			var params = {
				keyword: searchString
			};

			HttpSvc.post('recipecategories/search/all', params, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.categoryList = result;
					
					if(item.mode==2) 
					{
						$mdl.categoryList.forEach(function(c) {
							if(c.id == $mdl.item.id)
							{
								$mdl.selectedCategory = c;
							}
						})
					}
				}, function(error) {
					toastr.error(error);
					return;
				});		
		}
		
		$mdl.selectedCategoryChanged = function() {
			$mdl.item.id = $mdl.selectedCategory.id;
			$mdl.item.name = $mdl.selectedCategory.name;
			$mdl.item.companyName = $mdl.selectedCategory.companyName;
			
			if($mdl.item.id=="")
				$mdl.categoryForm.$invalid = true;
			else
				$mdl.categoryForm.$invalid = false;
		}	
		
		$mdl.confirmModal = function() {
			if($mdl.item.id=="" || $mdl.item.id==null) {
				$mdl.categoryForm.$invalid = true;
			} else {
				$mdl.categoryForm.$invalid = false;				
			}
			
			if($mdl.categoryForm.$valid)
				$uibModalInstance.close($mdl.item);
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	

	function GetPOSIntegrationModes() {
		var modes = [ 
			{id: -1, name: '= NONE ='}, 
			{id: 1, name: 'FTP'}, 
			{id: 2, name: 'HUBBO POS'}, 
			{id: 3, name: 'REAL TIME SYNC'}, 
		];
		return modes;
	}

	function GetIntegrationModes() {
		var modes = [ 
			{id: -1, name: '= NONE ='}, 
			{id: 2, name: 'AutoCount Accounting'}, 
			{id: 3, name: 'FNB System'}, 
			{id: 4, name: 'SAP ERP'}, 
			{id: 5, name: 'SAGE ERP'}, 
			{id: 1, name: 'SYSPRO ERP'}, 
			{id: 7, name: 'IDB ERP'}, 
			{id: 8, name: 'SQL Accounting'}, 
		];
		return modes;
	}

	function GetHourList() {
		var hourList = [
			{ id: 0, name: 0 },
			{ id: 1, name: 1 },
			{ id: 2, name: 2 },
			{ id: 3, name: 3 },
			{ id: 4, name: 4 },
			{ id: 5, name: 5 },
			{ id: 6, name: 6 },
			{ id: 7, name: 7 },
			{ id: 8, name: 8 },
			{ id: 9, name: 9 },
			{ id: 10, name: 10 },
			{ id: 11, name: 11 },
			{ id: 12, name: 12 },
			{ id: 13, name: 13 },
			{ id: 14, name: 14 },
			{ id: 15, name: 15 },
			{ id: 16, name: 16 },
			{ id: 17, name: 17 },
			{ id: 18, name: 18 },
			{ id: 19, name: 19 },
			{ id: 20, name: 20 },
			{ id: 21, name: 21 },
			{ id: 22, name: 22 },
			{ id: 23, name: 23 },
		];
		return hourList;
	}

	function GetMinuteList() {
		var minuteList = [
			{ id: 0, name: 0 },
			{ id: 15, name: 15 },
			{ id: 30, name: 30 },
			{ id: 45, name: 45 },
		];
		return minuteList;
	}

	function GetIntervalList() {
		var intervalList = [
			{ id: 5, name: 5 },
			{ id: 10, name: 10 },
			{ id: 20, name: 20 },
			{ id: 30, name: 30 },
			{ id: 45, name: 45 },
			{ id: 60, name: 60 },
		];
		return intervalList;
	}

	function GetPeriodList() {
		var periodList = [
			{ id: 'DAILY', name: 'DAILY' },
			{ id: 'WEEKLY', name: 'WEEKLY (1st Day of the Week)' },
			{ id: 'MONTHLY', name: 'MONTHLY (1st of Every Month)' },
		];
		return periodList;
	}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.features.controller', [])
        .controller('FeatureMainCtrl', FeatureMainCtrl)
        .controller('FeatureCreateCtrl', FeatureCreateCtrl)
        .controller('FeatureUpdateCtrl', FeatureUpdateCtrl);
	
    /** @ngInject */
    function FeatureMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100, 200, 300];
		vm.pageSize = 300;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.featureDataFull = [];
		vm.featureData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.featureDataFull, tableState.search.predicateObject) : vm.featureDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.featureData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.featureDataFull.length <= 0) {
				HttpSvc.get('featuresV2', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.featureDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		// Delete Feature
		vm.deleteFeature = function(featureId, featureName) {
			var params = {};
			HttpSvc.delete('featuresV2/' + featureId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('featuresV2', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;	
							vm.featureDataFull = result;	

							toastr.success('The feature [<b>' + featureName + '</b>] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Feature.', 'Delete Failed');
					return null;
			});
		};			
	};
	
	/** @ngInject */
    function FeatureCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		vm.mode = 1;
		vm.feature = {};
		vm.feature.isParent = false;
		vm.featureList = [];
		vm.selectedParent = {};
		
		// Load Feature List
		vm.loadFeatureList = function() {
			HttpSvc.get('featuresV2', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.featureList.push({ id: '', name: '== Select a parent Feature =='});
					result.forEach(function(f) {
						if(f.isParent) {
							vm.featureList.push({ id: f.id, name: f.name});
						}
					});
					vm.selectedParent = vm.featureList[0];
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		};
		
		// Is Parent Changed
		vm.isParentChanged = function() {
			if(vm.feature.isParent)
				vm.feature.parentId = "";
		};
		
		// On Parent Selection Changed
		vm.selectedParentChanged = function() {
			vm.feature.parentId = vm.selectedParent.id;
		}
		
		// Form Submission
		vm.submit = function() {
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('featuresV2', vm.feature, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Feature has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.features.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		};
		
		// Call Actions
		vm.loadFeatureList();
	}
	
	/** @ngInject */
    function FeatureUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;
		vm.mode = 2;
		vm.feature = {};
		vm.feature.isParent = false;	
		vm.featureList = [];
		vm.selectedParent = {};	
		
		// Load Feature List
		vm.loadFeatureList = function() {
			HttpSvc.get('featuresV2', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.featureList.push({ id: '', name: '== Select a parent Feature =='});
					result.forEach(function(f) {
						if(f.isParent) {
							vm.featureList.push({ id: f.id, name: f.name});
						}
					});
					vm.loadFeature();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		};
				
		// Load Feature
		vm.loadFeature = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('featuresV2/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.feature = result;	

					vm.featureList.forEach(function (f) {
						if(f.id==vm.feature.parentId) {
							vm.selectedParent = f;
						}
					});
					
				}, function() {
					toastr.error('Failed to load selected Feature.', Auth.translate('ERROR'));
					$state.go('superadmin.features.list');
					return;
				});		
		};	
		
		// Is Parent Changed
		vm.isParentChanged = function() {
			if(vm.feature.isParent)
				vm.feature.parentId = "";
		};
		
		// On Parent Selection Changed
		vm.selectedParentChanged = function() {
			vm.feature.parentId = vm.selectedParent.id;
		}
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('featuresV2/' + $stateParams.id, vm.feature, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Feature has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.features.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadFeatureList();
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.companysettings.controller', ['ngSanitize'])
        .controller('CompanySettingMainCtrl', CompanySettingMainCtrl)
        .controller('CompanySettingUpdateCtrl', CompanySettingUpdateCtrl)		
        .controller('CompanySettingCategoryModalCtrl', CompanySettingCategoryModalCtrl);

	function ObjTypes() {
		return ['image', 'text', 'qrcode', 'barcode'];
	}
	
    /** @ngInject */
    function CompanySettingMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 20;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.companyDataFull = [];
		vm.companyData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.companyDataFull, tableState.search.predicateObject) : vm.companyDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.companyData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.companyDataFull.length <= 0) {
				HttpSvc.get('companies/search', params, Auth.getTokenId(), false)
					.then(function(result) {	
						vm.numOfRecord = result.data.length;	
						vm.companyDataFull = result.data;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
	};
		
	/** @ngInject */
    function CompanySettingUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {

		Auth.init();
		
		var vm = this;
		
		vm.hourList = GetHourList();
		vm.minuteList = GetMinuteList();
		vm.intervalList = GetIntervalList();
		vm.periodList = GetPeriodList();
		vm.integrationModes = GetIntegrationModes();
		vm.posIntModes = GetPOSIntegrationModes();

		vm.submitted = false;
		vm.mode = 2;
		vm.company = {};	
		vm.company.logoFile = '';
		vm.company.oriLogoFile = '';
		vm.company.ghlMainPrivateKey = '';
		vm.currencyList = [];
		vm.billingPackages = [];
		vm.serverPackages = [];
		vm.features = [];
		vm.selectedFeatures = [];
		vm.selectedSOCutOffHour = null;
		vm.selectedSOCutOffMinute = null;
		vm.selectedDOCutOffHour = null;
		vm.selectedDOCutOffMinute = null;
		vm.categoryList = [];
		vm.itemStorageList = [];
		vm.selectedItemStorage = {};
		vm.productStorageList = [];
		vm.selectedProductStorage = {};
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		//vm.blobUrl = RmsApi.BLOBURL;		
		vm.fileToUpload = null;
		vm.serverMode = Auth.getServerMode();
		vm.hasPosModule = Auth.hasCompanyFeature('pos');
		vm.isSuperAdmin = Auth.isSuperAdmin();
		vm.isCheckingSMTP = false;

		vm.isInitialLoad = false;
		vm.compSetting = {};
		vm.attachments = {
			attachmentLocation1: null,
			attachmentLocation2: null,
			attachmentLocation3: null,
		}

		/* ********************************************************* */

		vm.setDefaultMailSettings = function() {
			vm.company.mailServer = "mail.codemax.my";
			vm.company.mailPort = 587;
			vm.company.mailLogin = "rms@codemax.my";
			vm.company.mailPassword = "x9zhR8lSC";
			vm.company.mailUseSsl = false;
		};	

		vm.setGMailSettings = function() {
			vm.company.mailServer = "smtp.gmail.com";
			vm.company.mailPort = 587;
			vm.company.mailLogin = "test@gmail.com";
			vm.company.mailPassword = "123456";
			vm.company.mailUseSsl = true;
		};		

		vm.testEmailSetting = function() {
			vm.isCheckingSMTP = true;

			HttpSvc.post('emails/test/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Email settings are valid.')
					vm.isCheckingSMTP = false;
				}, function(errorMsg) {
					vm.isCheckingSMTP = false;
					toastr.error(errorMsg, 'Test Failed');
					return;
				});	
		}

		/* ********************************************************* */

		vm.loadCurrencyList = function() {
			HttpSvc.get('currencies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.currencyList = result;					
					vm.loadItemStorageList();
				}, function() {
					toastr.error('Failed to load Currency List.', Auth.translate('ERROR'))
					return;
				});
		};
		
		// Load Item Storage List
		vm.loadItemStorageList = function() {
			HttpSvc.get('storages/listbytypes/1', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.itemStorageList = result;
					vm.loadProductStorageList();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Item Storage list.', '');
					return null;
				});
		};	
				
		// Load Product Storage List
		vm.loadProductStorageList = function() {
			HttpSvc.get('storages/listbytypes/2', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.productStorageList = result;
					vm.loadFeatureList();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Product Storage list.', '');
					return null;
				});
		};	
		
		// Load Feature List
		vm.loadFeatureList = function() {
			HttpSvc.get('featuresV2', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (f) {
						if(f.state.indexOf('superadmin')>=0)
						{
							if(vm.isSuperAdmin)
							{
								vm.features.push({ 
									id: f.id, 
									name: f.name, 
									state: f.state, 
									sequence: f.sequence, 
									isParent: f.isParent, 
									parentId: f.parentId 
								});
							}
						}
						else
						{							
							vm.features.push({ 
								id: f.id, 
								name: f.name, 
								state: f.state, 
								sequence: f.sequence, 
								isParent: f.isParent, 
								parentId: f.parentId 
							});
						}
					});
					vm.loadServerPackages();					
				}, function() {
					return;
				});		
		}
		
		// Load Server Packages
		vm.loadServerPackages = function() {
			HttpSvc.get('serverpackages/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.serverPackages = result;		
					vm.loadCompany();
				}, function() {
					return;
				});		
		};
		
		// Load Company
		vm.loadCompany = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('companies/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.company = result;
					
					vm.company.featureV2.forEach(function(f) {
						vm.selectedFeatures.push({
							id: f.id, 
							name: f.name, 
							state: f.state, 
							sequence: f.sequence, 
							isParent: f.isParent, 
							parentId: f.parentId 
						});
					});
					
					vm.serverPackages.forEach(function(p) {
						if(p.id==vm.company.serverPackageId){
							vm.selectedServerPackage = p;
						}
					});	
					
					vm.itemStorageList.forEach(function(s) {
						if(s.id==vm.company.setting_Job_StockOutUponConfirmation_StorageId){
							vm.selectedItemStorage = s;
						}
					});	
					
					vm.productStorageList.forEach(function(s) {
						if(s.id==vm.company.setting_Job_StockInUponCompletion_StorageId){
							vm.selectedProductStorage = s;
						}
					});	
					
					vm.integrationModes.forEach(function(im) {
						if(im.id==vm.company.integrationMode){
							vm.integrationModes.selected = im;
						}
					});
					
					vm.currencyList.forEach(function(c) {
						if(vm.company.currencyCode == c.code){
							vm.selectedCurrency = c;
						}
					});

					vm.hourList.forEach(function(h) {
						if(h.id==vm.company.setting_SalesOrder_CutOffTime_Hour){
							vm.selectedSOCutOffHour = h;
						}
						if(h.id==vm.company.setting_DeliveryOrder_CutOffTime_Hour){
							vm.selectedDOCutOffHour = h;
						}
						if(h.id==vm.company.autoCount_Inventory_SyncTime_Hour){
							vm.selectedAutocountInvSyncHour = h;
						}
					});

					vm.minuteList.forEach(function(m) {
						if(m.id==vm.company.setting_SalesOrder_CutOffTime_Minute){
							vm.selectedSOCutOffMinute = m;
						}
						if(m.id==vm.company.setting_DeliveryOrder_CutOffTime_Minute){
							vm.selectedDOCutOffMinute = m;
						}
						if(m.id==vm.company.autoCount_Inventory_SyncTime_Minute){
							vm.selectedAutocountInvSyncMinute = m;
						}
					});

					vm.intervalList.forEach(function(i) {
						if(i.id==vm.company.autoCount_GlobalSyncRetry_Interval){
							vm.selectedAutocountGlobalSyncRetryInterval = i;
						}
					});

					vm.periodList.forEach(function(p) {
						if(p.id==vm.company.autoCount_Inventory_Sync_Interval){
							vm.selectedAutocountInvSyncInterval = p;
						}
					});
					
					if(!vm.company.logoFile || vm.company.logoFile=='') {
						vm.company.logoFile = 'assets/img/company_logo_placeholder.png';
						vm.company.oriLogoFile = "";
					} else {
						vm.company.oriLogoFile = vm.company.logoFile;
						vm.company.logoFile = vm.rootUrl + vm.company.logoFile;
					}

					vm.loadCompanySetting();
					vm.loadFTP();
					
				}, function() {
					toastr.error('Failed to load selected Company.', Auth.translate('ERROR'));
					$state.go('superadmin.companysettings.list');
					return;
				});		
		};

		vm.loadCompanySetting = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('companysettings/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.compSetting = result;	
					vm.posIntModes.forEach(function(m) {
						if(m.id==vm.compSetting.poS_IntegrationMode)
						{
							vm.posIntModes.selected = m;
						}
					});				
				}, function() {
					if(vm.isInitialLoad = true)
					{
						vm.isInitialLoad = false;
						vm.initSetting();
					}
					else
					{
						toastr.error('Failed to load selected Company Settings.', Auth.translate('ERROR'));
						$state.go('superadmin.companysettings.list');
						return;
					}
				});		
		}
		
		/* ********************************************************* */
		
		vm.selectedCurrencyChanged = function() {
			vm.company.currencyCode = vm.selectedCurrency.code;
		}
		
		vm.selectedSOCutOffHourChanged = function() {
			vm.company.setting_SalesOrder_CutOffTime_Hour = vm.selectedSOCutOffHour.id;
		}
		
		vm.selectedSOCutOffMinuteChanged = function() {
			vm.company.setting_SalesOrder_CutOffTime_Minute = vm.selectedSOCutOffMinute.id;
		}
		
		vm.selectedDOCutOffHourChanged = function() {
			vm.company.setting_DeliveryOrder_CutOffTime_Hour = vm.selectedDOCutOffHour.id;
		}
		
		vm.selectedDOCutOffMinuteChanged = function() {
			vm.company.setting_DeliveryOrder_CutOffTime_Minute = vm.selectedDOCutOffMinute.id;
		}
		
		vm.selectedAutocountInvSyncHourChanged = function() {
			vm.company.autoCount_Inventory_SyncTime_Hour = vm.selectedAutocountInvSyncHour.id;
		}
		
		vm.selectedAutocountInvSyncMinuteChanged = function() {
			vm.company.autoCount_Inventory_SyncTime_Minute = vm.selectedAutocountInvSyncMinute.id;
		}
		
		vm.selectedAutocountInvSyncIntervalChanged = function() {
			vm.company.autoCount_Inventory_Sync_Interval = vm.selectedAutocountInvSyncInterval.id;
		}
		
		vm.selectedAutocountGlobalSyncRetryIntervalChanged = function() {
			vm.company.autoCount_GlobalSyncRetry_Interval = vm.selectedAutocountGlobalSyncRetryInterval.id;
		}

		// Select Server Package
		vm.selectedServerPackageChanged = function() {
			vm.company.serverPackageId = vm.selectedServerPackage.id;
		};
		
		/* ********************************************************* */
		
		// Select All Features
		vm.selectAllFeatures = function() {
			vm.selectedFeatures = [];
			vm.features.forEach(function(f) {
				vm.selectedFeatures.push(f);
			});
		}
		
		// Deselect All Features
		vm.deselectAllFeatures = function() {
			vm.selectedFeatures = [];
		}	
		
		vm.selectedItemStorageChanged = function(item) {
			vm.company.setting_Job_StockOutUponConfirmation_StorageId = vm.selectedItemStorage.id;
		}
		
		vm.selectedProductStorageChanged = function(item) {
			vm.company.setting_Job_StockInUponCompletion_StorageId = vm.selectedProductStorage.id;
		}

		// Select Integration Mode
		vm.selectIntegrationMode = function(item) {
			vm.company.integrationMode = item.id;
		};

		// Select Integration Mode
		vm.selectPOSIntegrationMode = function(item) {
			vm.compSetting.poS_IntegrationMode = item.id;
		};
		
		vm.setting_StockRequest_MultiSplitItemType_Changed = function() {
			if(!vm.compSetting.setting_StockRequest_MultiSplitItemType)
			{
				vm.compSetting.setting_StockRequest_MultiSplitCatAndSubCat = false;
			}
		}
		/* ********************************************************* */

		vm.resetLogo = function() {
			var cfm = confirm("Confirm reset the Company Logo?");

			if(cfm)
			{
				vm.company.logoFile = 'assets/img/company_logo_placeholder.png';
				vm.company.oriLogoFile = "";
				picFile = null;
			}
		}
		
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";
		
		vm.submit = function() {
			if(vm.company.serverPackageId=='') {
				vm.dataForm.$invalid = true;
			}
					
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			} else {
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/company/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "company/" + newFilename + mediaExtension;
					
				} else if(vm.company.oriLogoFile!="") {
					imgLocation = vm.company.oriLogoFile;
				}
				vm.company.logoFile = imgLocation;

				for (var key in vm.attachments) {
					if (vm.attachments[key] !== null) {
						var extArray = vm.attachments[key].name.split(".");
						var mediaExtension = extArray[extArray.length-1].toLowerCase();		
						var newAttachmentName = UtilSvc.generateGuid() + ".";		
						vm.company.companyTncs[0][key] = (vm.serverMode==1 ? (Auth.getCompanyId() + '/') : '') + "companytncs/" + newAttachmentName + mediaExtension;
					} 
				}
				
				vm.company.featureV2 = [];
				vm.selectedFeatures.forEach(function(f) {
					vm.company.featureV2.push({ id: f.id });
				})
				
				HttpSvc.put('companies/' + $stateParams.id, vm.company, Auth.getTokenId(), false)
					.then(function(result) {

						vm.saveSetting();
						vm.checkTNCImages(result.azureSasToken);
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(vm.serverMode, azureStorageUrl, vm.fileToUpload);
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/company/" + $stateParams.id;
							vm.uploadImage(vm.serverMode, localStorageUrl, vm.fileToUpload);
						} else {							
							toastr.success('Company has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						}
						
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		vm.checkTNCImages = function (azureSasToken) {
			for (var key in vm.attachments) {
				if (vm.attachments[key] !== null) {
					if (vm.serverMode == 1) {
						azureStorageUrl = RmsApi.BLOBURL + vm.company.companyTncs[0][key] + azureSasToken;
						vm.uploadImage(vm.serverMode, azureStorageUrl, vm.attachments[key]);
					} else {
						localStorageUrl = RmsApi.URL + "upload/companytncs/" + $stateParams.id;
						vm.uploadImage(vm.serverMode, localStorageUrl, vm.attachments[key]);
					}
				}
			}
		}

		vm.setUploadAttachmentImage = function(picFile, attachmentLocation) {
			vm.attachments[attachmentLocation] = picFile;
			var placeholder = '[' + attachmentLocation.toUpperCase() + ']';
			if (picFile && !vm.company.companyTncs[0].salesOrderTnc.includes(placeholder)) {
            	vm.company.companyTncs[0].salesOrderTnc += ' ' + placeholder;
        	}
		}

		vm.deleteImage = function (attachmentLocation, event) {
			event.stopPropagation();
			vm.attachments[attachmentLocation] = null;
			vm.company.companyTncs[0][attachmentLocation] = "";
			var placeholder = '[' + attachmentLocation.toUpperCase() + ']';
			vm.company.companyTncs[0].salesOrderTnc = vm.company.companyTncs[0].salesOrderTnc.replace(placeholder, '').trim();
		}

		vm.saveSetting = function() {
			HttpSvc.put('companysettings/' + vm.compSetting.id, vm.compSetting, Auth.getTokenId(), false)
				.then(function(result) {					
				}, function(error) {
					toastr.error('Failed to save company settings: ' + error, 'Failed');
				});
		}

		vm.initSetting = function() {			
			vm.compSetting = {
				companyId: $stateParams.id,
				setting_ExpiryCertByMonth: 3,
				setting_AssetScheduleByDay: 3,
				setting_Stock_StockOutQuickMode: false,
				setting_DeliveryOrder_DirectDO: false,
				setting_enableFTP: false,
				ftP_WebServiceUrl: null,
				ftP_Username: null,
				ftP_Password: null,
				autoCount_EnableSync_RawMat_StandardCost: false,
				autoCount_EnableSync_RawMat_StandardSellingPrice: false,
				autoCount_EnableSync_SemiFg_StandardSellingPrice: false,
				autoCount_EnableSync_Product_StandardSellingPrice: false,
				autocount_SyncItemPrice_SalesOrder: false,
				autocount_SyncItemPrice_DeliveryOrder: false,
				autocount_EnableSync_PurchaseTaxCode: false,
				autocount_EnableSync_InvoiceNo: false,
				autocount_SyncBack_InvoiceNo: false,
				autoCount_EnableSync_Grn: false,
				autoCount_SyncBack_GrnNo: false,
				autoCount_EnableSync_PurchaseInvoice: false
			};

			HttpSvc.post('companysettings', vm.compSetting, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loadCompanySetting();
				}, function(error) {
					toastr.error('Failed to save company settings: ' + error, 'Failed');
				});
		}
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (serverMode, storageUrl, fileToUpload) {
			var fileReader = new FileReader();
			
			if(serverMode==0) {	// Local Server
				Upload.upload({
					url: storageUrl,
					data: {file: fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					toastr.success('Company has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('Company has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
				});
				
			} else if(serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: storageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {						
							toastr.success('Company has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
					});
				}
			}
		};
		
		/* ************************************************************** */
		
		// Open Modal Dialog
		vm.recipeCategory = {};		
		vm.showAddCategoryModal = function () {
			vm.recipeCategory = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'categoryModal.html',
				controller: 'CompanySettingCategoryModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							object: vm.recipeCategory,
							itemList: vm.categoryList,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
					vm.addCategory(data);
				}, function () {
				});
		};	
		
		// **********************************************
		
		// Remove Category
		vm.removeCategory = function(index) {
			vm.company.companyRecipeCategories.splice(index, 1);
			$scope.$broadcast('refreshStTable');	
		};

		// Add Category
		vm.addCategory = function(obj) {
			var element = {
				recipeCategoryId: obj.id,
				recipeCategory: {
					name: obj.name,
					companyName: obj.companyName
				},
				isReadOnly: true,
				isOriginalOwner: false
			};
			vm.company.companyRecipeCategories.push(element);
		};

		// Refresh Category List
		vm.refreshRecipeCategories = function(tableState) {
			// Do nothing
		};		
		
		/* ************************************************************** */
		
		vm.testIntegrationAutoCount = function() {
						
			HttpSvc.post('companies/testintegration/autocount/' + vm.company.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Validation success.', Auth.translate('SUCCESS'));
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		};

		vm.testIntegrationSQL = function() {
			HttpSvc.get('sqlacc/maintenance/testconnection/' + vm.company.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('SQL Build No.: ' + result.SQL_BuildNo, 'Codemax Web Service No.: ' + result.Codemax_WebServiceNo);
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		};
		
		// Call Actions
		vm.loadCurrencyList();
		
		/* ************************************************************** */

		vm.isPurging = false;
		vm.isPurgingRawMat = false;
		vm.isPurgingSupplier = false;

		vm.purgeRawMat = function() {
			if(vm.isPurging) return;
			
			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Raw Material data?');

			if(toProceed) {
				vm.isPurgingRawMat = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/rawmat/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingRawMat = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingRawMat = false;
						vm.isPurging = false;
					});
			}
		}

		vm.purgeSemiFg = function() {
			if(vm.isPurging) return;
			
			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Semi Finished Goods data?');

			if(toProceed) {
				vm.isPurgingSemiFg = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/semifg/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingSemiFg = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingSemiFg = false;
						vm.isPurging = false;
					});
			}
		}

		vm.purgeFG = function() {
			if(vm.isPurging) return;
			
			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Finished Goods data?');

			if(toProceed) {
				vm.isPurgingFG = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/product/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingFG = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingFG = false;
						vm.isPurging = false;
					});
			}
		}

		vm.purgeSupplier = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Supplier data?');

			if(toProceed) {
				vm.isPurgingSupplier = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/supplier/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingSupplier = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingSupplier = false;
						vm.isPurging = false;
					});
			}
		}


		vm.purgePO = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Purchase Order data?');

			if(toProceed) {
				vm.isPurgingPO = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/po/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingPO = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingPO = false;
						vm.isPurging = false;
					});
			}
		}

		vm.purgeGRN = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL GRN data?');

			if(toProceed) {
				vm.isPurgingGRN = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/grn/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingGRN = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingGRN = false;
						vm.isPurging = false;
					});
			}
		}

		vm.purgeProdJobs = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Production Jobs data?');

			if(toProceed) {
				vm.isPurgingProdJobs = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/jobproduction/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingProdJobs = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingProdJobs = false;
						vm.isPurging = false;
					});
			}
		}

		vm.purgeBulkBreakJobs = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Bulk-Break Jobs data?');

			if(toProceed) {
				vm.isPurgingBulkBreakJob = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/bulkbreakjob/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingBulkBreakJob = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingBulkBreakJob = false;
						vm.isPurging = false;
					});
			}
		}


		vm.purgeRecipeItems = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Recipe Items?');

			if(toProceed) {
				vm.isPurgingRecipeItems = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/recipeitems/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingRecipeItems = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingRecipeItems = false;
						vm.isPurging = false;
					});
			}
		}
		

		vm.purgeRawMatInvBal = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Raw Material Inventory Balanace data?');

			if(toProceed) {
				vm.isPurgingRawMatInvBal = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/rawmat/inventory/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingRawMatInvBal = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingRawMatInvBal = false;
						vm.isPurging = false;
					});
			}
		}		

		vm.purgeSemiFgInvBal = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Semi Finished Goods Inventory Balanace data?');

			if(toProceed) {
				vm.isPurgingSemiFgInvBal = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/semifg/inventory/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingSemiFgInvBal = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingSemiFgInvBal = false;
						vm.isPurging = false;
					});
			}
		}	

		vm.purgeProductInvBal = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Finished Goods Inventory Balanace data?');

			if(toProceed) {
				vm.isPurgingProductInvBal = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/product/inventory/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingProductInvBal = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingProductInvBal = false;
						vm.isPurging = false;
					});
			}
		}
		

		vm.purgeRawMatInvMvmt = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Raw Material Inventory Movement data?');

			if(toProceed) {
				vm.isPurgingRawMatInvMvmt = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/rawmat/inventorymovement/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingRawMatInvMvmt = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingRawMatInvMvmt = false;
						vm.isPurging = false;
					});
			}
		}		

		vm.purgeSemiFgInvMvmt = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Semi Finished Goods Inventory Movement data?');

			if(toProceed) {
				vm.isPurgingSemiFgInvMvmt = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/semifg/inventorymovement/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingSemiFgInvMvmt = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingSemiFgInvMvmt = false;
						vm.isPurging = false;
					});
			}
		}	

		vm.purgeProductInvMvmt = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Finished Goods Inventory Movement data?');

			if(toProceed) {
				vm.isPurgingProductInvMvmt = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/product/inventorymovement/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingProductInvMvmt = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingProductInvMvmt = false;
						vm.isPurging = false;
					});
			}
		}
		

		vm.purgeRawMatLabel = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Raw Material Labels data?');

			if(toProceed) {
				vm.isPurgingRawMatLabel = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/rawmat/label/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingRawMatLabel = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingRawMatLabel = false;
						vm.isPurging = false;
					});
			}
		}
		
		vm.purgeSemiFgLabel = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL Semi FG Labels data?');

			if(toProceed) {
				vm.isPurgingSemiFgLabel = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/semifg/label/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingSemiFgLabel = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingSemiFgLabel = false;
						vm.isPurging = false;
					});
			}
		}
		
		vm.purgeProductLabel = function() {
			if(vm.isPurging) return;

			var companyId = $stateParams.id;
			var toProceed = confirm('Confirm to purge ALL FG Labels data?');

			if(toProceed) {
				vm.isPurgingProductLabel = true;
				vm.isPurging = true;

				HttpSvc.post('datapurge/product/label/' + companyId, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Purge completed.');
						vm.isPurgingProductLabel = false;
						vm.isPurging = false;
					}, function(error) {
						toastr.error(error, 'Failed');
						vm.isPurgingProductLabel = false;
						vm.isPurging = false;
					});
			}
		}
		
		/* ************************************************************** */

		vm.ftp = {};
		vm.ftp.dirList = [];
		vm.ftp.fileList = [];
		vm.subfolders = [];
		vm.newFtpFolder = null;
		vm.newFtpFile = null;
		vm.ftpIsUploading = false;

		vm.loadFTP = function() {
			HttpSvc.post('misc/ftp/list/labelfolder', {}, Auth.getTokenId(), false)
				.then(function(result) {

					vm.ftp = result;
					vm.subfolders = [];
					
				}, function(error) {
					toastr.error(error, 'Failed to load FTP content.');
				});
		}

		vm.navigateFolder = function(folderName) {
			
			var isFolderFound = false;
			vm.subfolders.forEach(function(f) {
				if(f==folderName)
				{
					isFolderFound = true;
				}
			});
			
			if(!isFolderFound)
				vm.subfolders.push(folderName);

			HttpSvc.post('misc/ftp/list/labelfolder/' + folderName, {}, Auth.getTokenId(), false)
				.then(function(result) {

					vm.ftp = result;
					
				}, function(error) {
					toastr.error(error, 'Failed to load FTP content.');
				});
		}

		vm.navigateBack = function() {
			vm.subfolders.splice(vm.subfolders.length-1, 1);

			if(vm.subfolders.length == 0)
			{
				vm.loadFTP();
			}
			else
			{
				vm.navigateFolder(vm.subfolders[vm.subfolders.length-1]);
			}
		}

		vm.createFolder = function(folderName) {

			HttpSvc.post('misc/ftp/list/labelfolder/' + folderName, {}, Auth.getTokenId(), false)
				.then(function(result) {
					//vm.loadFTP();
					vm.ftp = result;
					vm.newFtpFolder = null;					
					vm.subfolders.push(folderName);
					toastr.success('Folder created successfully.');

				}, function(error) {
					toastr.error(error, 'Failed to load FTP content.');
				});
		}

		vm.cleanUpPath = function(filename) {

			for(var x=vm.subfolders.length-1; x>=0; x--)
			{
				filename = filename.replace(vm.subfolders[x] + '\\', '');				
			}

			return filename;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadFtpFile = function () {	
			vm.ftpIsUploading = true;

			var api = RmsApi.URL + "misc/ftp/labelfolder/upload";
			for(var x=0; x<vm.subfolders.length; x++)
			{
				api = api + "/" + vm.subfolders[x];
			}
			
			Upload.upload({
				url: api,
				data: {file: vm.newFtpFile},
				headers: {'Authorization': 'basic ' + Auth.getTokenId() },

			}).then(function (resp) {
				
				toastr.success('File uploaded successfully.', Auth.translate('SUCCESS'));

				if(vm.subfolders.length == 0)
				{
					vm.loadFTP();
				}
				else
				{
					vm.navigateFolder(vm.subfolders[vm.subfolders.length-1]);
				}
				vm.resetFtpFile();

			}, function (resp) {

				vm.resetFtpFile();
				toastr.error(resp.data.message, 'Failed');

			}, function (evt) {
			});
		};

		vm.resetFtpFile = function () {
			vm.ftpIsUploading = false;
			vm.newFtpFile = null;
		}
	}

	// Category Modal Controller
	function CompanySettingCategoryModalCtrl($uibModalInstance, item) {
		var $mdl = this;
		$mdl.title = item.title;
		$mdl.itemList = item.itemList;
		$mdl.item = item.object;
		$mdl.selectedItem = {};
		
		// Initialize
		if(item.mode==1) {
			$mdl.item.id = "";
			$mdl.item.name = "";
		} else {
			if($mdl.item.id!='' && $mdl.item.id!=null){
				$mdl.itemList.forEach(function (i) {
					if(i.id==$mdl.item.id) {
						$mdl.selectedItem = i;
						$mdl.item.name = i.name;
						$mdl.item.companyName = i.companyName;
					}
				});
			}
		}
		
		$mdl.onSelectedItemChanged = function() {
			$mdl.item.id = $mdl.selectedItem.id;
			$mdl.item.name = $mdl.selectedItem.name;
			$mdl.item.companyName = $mdl.selectedItem.companyName;
			
			if($mdl.item.id=="")
				$mdl.categoryForm.$invalid = true;
			else
				$mdl.categoryForm.$invalid = false;
		}	
		
		$mdl.confirmModal = function() {			
			if($mdl.item.id=="" || $mdl.item.id==null) {
				$mdl.categoryForm.$invalid = true;
			} else {
				$mdl.categoryForm.$invalid = false;				
			}
			
			if($mdl.categoryForm.$valid)
				$uibModalInstance.close($mdl.item);
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	

	function GetPOSIntegrationModes() {
		var modes = [ 
			{id: -1, name: '= NONE ='}, 
			{id: 1, name: 'FTP'}, 
			{id: 2, name: 'HUBBO POS'}, 
			{id: 3, name: 'REAL TIME SYNC'}, 
		];
		return modes;
	}

	function GetIntegrationModes() {
		var modes = [ 
			{id: -1, name: '= NONE ='}, 
			{id: 2, name: 'AutoCount Accounting'}, 
			{id: 3, name: 'FNB System'}, 
			{id: 4, name: 'SAP ERP'}, 
			{id: 5, name: 'SAGE ERP'}, 
			{id: 1, name: 'SYSPRO ERP'}, 
			{id: 7, name: 'IDB ERP'}, 
			{id: 8, name: 'SQL Accounting'}, 
		];
		return modes;
	}

	function GetHourList() {
		var hourList = [
			{ id: 0, name: 0 },
			{ id: 1, name: 1 },
			{ id: 2, name: 2 },
			{ id: 3, name: 3 },
			{ id: 4, name: 4 },
			{ id: 5, name: 5 },
			{ id: 6, name: 6 },
			{ id: 7, name: 7 },
			{ id: 8, name: 8 },
			{ id: 9, name: 9 },
			{ id: 10, name: 10 },
			{ id: 11, name: 11 },
			{ id: 12, name: 12 },
			{ id: 13, name: 13 },
			{ id: 14, name: 14 },
			{ id: 15, name: 15 },
			{ id: 16, name: 16 },
			{ id: 17, name: 17 },
			{ id: 18, name: 18 },
			{ id: 19, name: 19 },
			{ id: 20, name: 20 },
			{ id: 21, name: 21 },
			{ id: 22, name: 22 },
			{ id: 23, name: 23 },
		];
		return hourList;
	}

	function GetMinuteList() {
		var minuteList = [
			{ id: 0, name: 0 },
			{ id: 15, name: 15 },
			{ id: 30, name: 30 },
			{ id: 45, name: 45 },
		];
		return minuteList;
	}

	function GetIntervalList() {
		var intervalList = [
			{ id: 5, name: 5 },
			{ id: 10, name: 10 },
			{ id: 20, name: 20 },
			{ id: 30, name: 30 },
			{ id: 45, name: 45 },
			{ id: 60, name: 60 },
		];
		return intervalList;
	}

	function GetPeriodList() {
		var periodList = [
			{ id: 'DAILY', name: 'DAILY' },
			{ id: 'WEEKLY', name: 'WEEKLY (1st Day of the Week)' },
			{ id: 'MONTHLY', name: 'MONTHLY (1st of Every Month)' },
		];
		return periodList;
	}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.intercompanyitemmappings.controller', [])
        .controller('SAInterCompanyItemMappingMainCtrl', SAInterCompanyItemMappingMainCtrl)
        .controller('SAInterCompanyItemMappingCreateCtrl', SAInterCompanyItemMappingCreateCtrl)
        .controller('SAInterCompanyItemMappingUpdateCtrl', SAInterCompanyItemMappingUpdateCtrl)
        .controller('SAInterCompanyItemMappingImportCtrl', SAInterCompanyItemMappingImportCtrl);

    /** @ngInject */
    function SAInterCompanyItemMappingMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 20;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.mappingDataFull = [];
		vm.mappingData = [];
		vm.isLoading = true;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.mappingDataFull, tableState.search.predicateObject) : vm.mappingDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.mappingData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.mappingDataFull.length <= 0) {			
				vm.isLoading = true;

				HttpSvc.get('intercompanyitemmappings/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.mappingDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteMapping = function(mappingId) {
			var params = {};
			vm.isLoading = true;

			HttpSvc.delete('intercompanyitemmappings/' + mappingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('intercompanyitemmappings/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.mappingDataFull = result;
							
							toastr.success('The mapping has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
							vm.isLoading = false;
						}, function() {
							vm.isLoading = false;
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to delete the mapping.', 'Delete Failed');
					return null;
			});
		};
		
		vm.getDestObjectCode = function(item) {
			if(item.destItemName!=null) return item.destItemCode;
			if(item.destSemiFgName!=null) return item.destSemiFgCode;
			if(item.destProductName!=null) return item.destProductCode;
		}
		
		vm.getDestObjectName = function(item) {
			if(item.destItemName!=null) return item.destItemName;
			if(item.destSemiFgName!=null) return item.destSemiFgName;
			if(item.destProductName!=null) return item.destProductName;
		}
		
		vm.getDestObjectType = function(item) {
			if(item.destItemName!=null) return "RM";
			if(item.destSemiFgName!=null) return "SFG";
			if(item.destProductName!=null) return "FG";
		}

		vm.resetSearch = function() 
		{
		}	
	};
	
	/** @ngInject */
    function SAInterCompanyItemMappingCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.mapping = {};	
		vm.companyList = [];
		vm.branchList = [];
		vm.itemList = [];
		vm.rawMatList = [];
		vm.semiFgList = [];
		vm.productList = [];
		vm.changeLogs = [];
		vm.selectedSourceCompany = null;
		vm.selectedSourceItem = null;
		vm.selectedDestCompany = null;
		vm.selectedDestBranch = null;
		vm.selectedDestRawMat = null;
		vm.selectedDestSemiFg = null;
		vm.selectedDestProduct = null;

		/* ******************************************************** */

		// Load Companies 
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companyList = result;
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		// Load Branches 
		vm.loadBranchList = function(companyId) {
			HttpSvc.get('branches/listbycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.branchList = result;

					vm.branchList.forEach(function(b) {
						if(b.id==vm.mapping.destBranchId)
						{
							vm.selectedDestBranch = b;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		// Load Raw Mats (Source)
		vm.loadItemList = function(companyId) {
			HttpSvc.get('items/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.itemList = result;	
					
					vm.itemList.forEach(function(i) {
						if(i.id==vm.mapping.sourceItemId)
						{
							vm.selectedSourceItem = i;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Raw Material list.', '');
					return null;
				});
		};

		// Load Raw Mats (Desitnation)
		vm.loadRawMatList = function(companyId) {
			HttpSvc.get('items/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.rawMatList = result;	
					
					vm.rawMatList.forEach(function(i) {
						if(i.id==vm.mapping.destItemId)
						{
							vm.selectedDestRawMat = i;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Raw Material list.', '');
					return null;
				});
		};

		// Load Semi FGs
		vm.loadSemiFgList = function(companyId) {
			HttpSvc.get('semifgs/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.semiFgList = result;	
					
					if(vm.mapping.destSemiFgId!=null)
					{
						vm.semiFgList.forEach(function(s) {
							if(s.id==vm.mapping.destSemiFgId)
							{
								vm.selectedDestSemiFg = s;
							}
						});	
					}					
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Semi FG list.', '');
					return null;
				});
		};
		
		// Load Products
		vm.loadProductList = function(companyId) {
			HttpSvc.get('products/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.productList = result;
					
					if(vm.mapping.destProductId!=null)
					{
						vm.productList.forEach(function(p) {
							if(p.id==vm.mapping.destProductId)
							{
								vm.selectedDestProduct = p;
							}
						});
					}
				}, function() {
					// Failed
					toastr.error('Failed to retrieve FG list.', '');
					return null;
				});
		};

		/* ******************************************************** */
		
		// Select Source Company
		vm.selectedSourceCompanyChanged = function() {
			vm.mapping.sourceCompanyId = vm.selectedSourceCompany.id;
			vm.loadItemList(vm.mapping.sourceCompanyId);
		};
		
		// Select Source Raw Mat
		vm.selectedSourceItemChanged = function() {
			vm.mapping.sourceItemId = vm.selectedSourceItem.id;
		};
		
		// Select Dest Company
		vm.selectedDestCompanyChanged = function() {
			vm.mapping.destCompanyId = vm.selectedDestCompany.id;
			vm.loadBranchList(vm.mapping.destCompanyId);
			vm.loadRawMatList(vm.mapping.destCompanyId);
			vm.loadSemiFgList(vm.mapping.destCompanyId);
			vm.loadProductList(vm.mapping.destCompanyId);
		};
		
		// Select Dest Branch
		vm.selectedDestBranchChanged = function() {
			vm.mapping.destBranchId = vm.selectedDestBranch.id;
		};
		
		// Select Dest Raw Mat
		vm.selectedDestRawMatChanged = function() {
			vm.mapping.destItemId = vm.selectedDestRawMat.id;
			vm.mapping.destSemiFgId = null;
			vm.mapping.destProductId = null;

			vm.selectedDestSemiFg = null;
			vm.selectedDestProduct = null;
		};
		
		// Select Dest Semi FG
		vm.selectedDestSemiFgChanged = function() {
			vm.mapping.destSemiFgId = vm.selectedDestSemiFg.id;
			vm.mapping.destItemId = null;
			vm.mapping.destProductId = null;
			
			vm.selectedDestRawMat = null;
			vm.selectedDestProduct = null;
		};
		
		// Select Dest Product
		vm.selectedDestProductChanged = function() {
			vm.mapping.destProductId = vm.selectedDestProduct.id;
			vm.mapping.destItemId = null;
			vm.mapping.destSemiFgId = null;
			
			vm.selectedDestRawMat = null;
			vm.selectedDestSemiFg = null;
		};
		
		/* ******************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('intercompanyitemmappings', vm.mapping, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Mapping has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.intercompanyitemmappings.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}
		
		/* ******************************************************** */
		
		// Call Action
		vm.loadCompanyList();
	}
	
	/** @ngInject */
    function SAInterCompanyItemMappingUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.mapping = {};	
		vm.companyList = [];
		vm.branchList = [];
		vm.itemList = [];
		vm.rawMatList = [];
		vm.semiFgList = [];
		vm.productList = [];
		vm.changeLogs = [];
		vm.selectedSourceCompany = null;
		vm.selectedSourceItem = null;
		vm.selectedDestCompany = null;
		vm.selectedDestBranch = null;
		vm.selectedDestRawMat = null;
		vm.selectedDestSemiFg = null;
		vm.selectedDestProduct = null;

		/* ******************************************************** */

		// Load Companies 
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companyList = result;
					vm.loadMapping();	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		// Load Branches 
		vm.loadBranchList = function(companyId) {
			HttpSvc.get('branches/listbycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.branchList = result;

					vm.branchList.forEach(function(b) {
						if(b.id==vm.mapping.destBranchId)
						{
							vm.selectedDestBranch = b;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		// Load Raw Mats (Source)
		vm.loadItemList = function(companyId) {
			HttpSvc.get('items/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.itemList = result;	
					
					vm.itemList.forEach(function(i) {
						if(i.id==vm.mapping.sourceItemId)
						{
							vm.selectedSourceItem = i;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Raw Material list.', '');
					return null;
				});
		};

		// Load Raw Mats (Desitnation)
		vm.loadRawMatList = function(companyId) {
			HttpSvc.get('items/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.rawMatList = result;	
					
					vm.rawMatList.forEach(function(i) {
						if(i.id==vm.mapping.destItemId)
						{
							vm.selectedDestRawMat = i;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Raw Material list.', '');
					return null;
				});
		};

		// Load Semi FGs
		vm.loadSemiFgList = function(companyId) {
			HttpSvc.get('semifgs/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.semiFgList = result;	
					
					if(vm.mapping.destSemiFgId!=null)
					{
						vm.semiFgList.forEach(function(s) {
							if(s.id==vm.mapping.destSemiFgId)
							{
								vm.selectedDestSemiFg = s;
							}
						});	
					}					
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Semi FG list.', '');
					return null;
				});
		};
		
		// Load Products
		vm.loadProductList = function(companyId) {
			HttpSvc.get('products/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.productList = result;
					
					if(vm.mapping.destProductId!=null)
					{
						vm.productList.forEach(function(p) {
							if(p.id==vm.mapping.destProductId)
							{
								vm.selectedDestProduct = p;
							}
						});
					}
				}, function() {
					// Failed
					toastr.error('Failed to retrieve FG list.', '');
					return null;
				});
		};
				
		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('intercompanyitemmappingchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};	

		// Load Mapping
		vm.loadMapping = function() {
			HttpSvc.get('intercompanyitemmappings/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.mapping = result;

					vm.companyList.forEach(function(c) {
						if(c.id==vm.mapping.sourceCompanyId)
						{
							vm.selectedSourceCompany = c;
						}
						if(c.id==vm.mapping.destCompanyId)
						{
							vm.selectedDestCompany = c;
						}
					});

					vm.loadItemList(vm.mapping.sourceCompanyId);
					vm.loadBranchList(vm.mapping.destCompanyId);
					vm.loadRawMatList(vm.mapping.destCompanyId);
					vm.loadSemiFgList(vm.mapping.destCompanyId);
					vm.loadProductList(vm.mapping.destCompanyId);
					vm.loadChangeLogs();

				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer branch list.', '');
					return null;
				});
		};

		/* ******************************************************** */
		
		// Select Source Company
		vm.selectedSourceCompanyChanged = function() {
			vm.mapping.sourceCompanyId = vm.selectedSourceCompany.id;
			vm.loadItemList(vm.mapping.sourceCompanyId);
		};
		
		// Select Source Raw Mat
		vm.selectedSourceItemChanged = function() {
			vm.mapping.sourceItemId = vm.selectedSourceItem.id;
		};
		
		// Select Dest Company
		vm.selectedDestCompanyChanged = function() {
			vm.mapping.destCompanyId = vm.selectedDestCompany.id;
			vm.loadBranchList(vm.mapping.destCompanyId);
			vm.loadRawMatList(vm.mapping.destCompanyId);
			vm.loadSemiFgList(vm.mapping.destCompanyId);
			vm.loadProductList(vm.mapping.destCompanyId);
		};
		
		// Select Dest Branch
		vm.selectedDestBranchChanged = function() {
			vm.mapping.destBranchId = vm.selectedDestBranch.id;
		};
		
		// Select Dest Raw Mat
		vm.selectedDestRawMatChanged = function() {
			vm.mapping.destItemId = vm.selectedDestRawMat.id;
			vm.mapping.destSemiFgId = null;
			vm.mapping.destProductId = null;

			vm.selectedDestSemiFg = null;
			vm.selectedDestProduct = null;
		};
		
		// Select Dest Semi FG
		vm.selectedDestSemiFgChanged = function() {
			vm.mapping.destSemiFgId = vm.selectedDestSemiFg.id;
			vm.mapping.destItemId = null;
			vm.mapping.destProductId = null;
			
			vm.selectedDestRawMat = null;
			vm.selectedDestProduct = null;
		};
		
		// Select Dest Product
		vm.selectedDestProductChanged = function() {
			vm.mapping.destProductId = vm.selectedDestProduct.id;
			vm.mapping.destItemId = null;
			vm.mapping.destSemiFgId = null;
			
			vm.selectedDestRawMat = null;
			vm.selectedDestSemiFg = null;
		};
		
		/* ******************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('intercompanyitemmappings/' + $stateParams.id, vm.mapping, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Mapping has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
						//$state.go('superadmin.intercompanyitemmappings.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}

		/* ******************************************************** */

		vm.loadCompanyList();
	}
	
	/** @ngInject */
	function SAInterCompanyItemMappingImportCtrl($scope, $state, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;		
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;
		
		/* **************************************************** */
		
		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";

		/* **************************************************** */
		
		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		vm.importOptions.createItemMapping = true;
		vm.importOptions.updateItemMapping = true;
		
		/* **************************************************** */
		
		vm.goBack = function() {
			$state.reload();
		}
		
		/* **************************************************** */
		
		vm.importResult = {};
		
		/* **************************************************** */
				
		vm.downloadTemplate = function() {
			
			var filename = "InterCompany Item Mapping Template.xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject('intercompanyitemmappings/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};		
		
		/* **************************************************** */
		
		vm.importData = function() {
			vm.isImporting = true;
			
			HttpSvc.post('intercompanyitemmappings/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
					//vm.lockButtons = false;
					//vm.isImportComplete = true;
					
					//vm.importResult = result;
					
					//toastr.success("Data imported successfully!");
					//$state.go('maintenance.items.list');
				}, function(error) {
					//vm.lockButtons = false;
					//vm.isImportFailed = true;
					
					//toastr.error("Failed to import data! " + error);
				});
		}
		
		/* **************************************************** */
		
		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}
		
		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;			
		}
		
		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];
			
			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}
		
		// Upload File
		vm.uploadFile = function() {	
			vm.resetFileUploadParams();
			
			vm.lockButtons = true;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;
								
			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;
			
			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();	
				vm.uploadMedia(vm.mediaToUpload);
			}	
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {
						
						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);
						
					}, function(error) {
						toastr.error(error, 'Failed');
						
						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {					
					vm.isUploaded = true;
					
					// Call Process Excel API 
					HttpSvc.post('intercompanyitemmappings/import/' + resp.data, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;
							
							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			}  else if(vm.serverMode==1) { // Azure Server
							
				/* Initialize variables */
				/* ************************************* */	
				handleFileSelect(_fileToUpload);
				/* ************************************* */	
				
				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							} 
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,				
			}).then(function(response) {	
				vm.isUploaded = true;
				
				// Call Process Excel API 
				HttpSvc.post('intercompanyitemmappings/import/' + excelFilename, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;
						
						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }		
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.iotregdevices.controller', [])
        .controller('SAIoTRegDeviceMainCtrl', SAIoTRegDeviceMainCtrl)
        .controller('SAIoTRegDeviceCreateCtrl', SAIoTRegDeviceCreateCtrl)
        .controller('SAIoTRegDeviceUpdateCtrl', SAIoTRegDeviceUpdateCtrl);

    /** @ngInject */
    function SAIoTRegDeviceMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.deviceDataFull = [];
		vm.deviceData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.deviceDataFull, tableState.search.predicateObject) : vm.deviceDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.deviceData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.deviceDataFull.length <= 0) {							
				HttpSvc.get('iotregistereddevices/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.deviceDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteDevice = function(deviceId, deviceName) {
			var params = {};
			HttpSvc.delete('iotregistereddevices/' + deviceId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('iotregistereddevices/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.deviceDataFull = result;
							
							toastr.success('The device [' + deviceName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the device [' + deviceName + '].', 'Delete Failed');
					return null;
			});
		};			
	};
	
	/** @ngInject */
    function SAIoTRegDeviceCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.iotregdevice = {};	
		vm.iotregdevice.isActive = true;
		vm.companies = [];
		vm.deviceTypes = [
			{ id:'HANDHELD READER', name:'HANDHELD READER' },
			{ id:'COLD SENSOR', name:'COLD SENSOR' },
			{ id:'HOT SENSOR', name:'HOT SENSOR' },
			{ id:'T+H SENSOR', name:'T+H SENSOR' },
			{ id:'GATEWAY', name:'GATEWAY' },
			{ id:'GATEWAY (GSM)', name:'GATEWAY (GSM)' },
			{ id:'GATEWAY WITH GPS', name:'GATEWAY WITH GPS' },
		];
		
		/* **************************************************************** */

		// Load Companies 
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companies = result;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		/* **************************************************************** */

		// Select Company
		vm.selectedCompanyChanged = function() {
			vm.iotregdevice.companyId = vm.selectedCompany.id;
		};
		
		vm.clearCompany = function() {
			vm.selectedCompany = null;
			vm.iotregdevice.companyId = null;
		}

		// Select Device Type
		vm.selectedTypeChanged = function() {
			vm.iotregdevice.type = vm.selectedType.id;
		};

		/* **************************************************************** */
				
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('iotregistereddevices', vm.iotregdevice, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Device has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.iotregdevices.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadCompanyList();
	}
	
	/** @ngInject */
    function SAIoTRegDeviceUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.iotregdevice = {};
		vm.companies = [];
		vm.deviceTypes = [
			{ id:'HANDHELD READER', name:'HANDHELD READER' },
			{ id:'COLD SENSOR', name:'COLD SENSOR' },
			{ id:'HOT SENSOR', name:'HOT SENSOR' },
			{ id:'T+H SENSOR', name:'T+H SENSOR' },
			{ id:'GATEWAY', name:'GATEWAY' },
			{ id:'GATEWAY (GSM)', name:'GATEWAY (GSM)' },
			{ id:'GATEWAY WITH GPS', name:'GATEWAY WITH GPS' },
		];
		vm.isProcessing = false;

		/* **************************************************************** */

		// Load Companies 
		vm.loadCompanyList = function() {
			vm.isProcessing = true;

			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companies = result;
					vm.loadDevice();	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};
						
		// Load Device
		vm.loadDevice = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('iotregistereddevices/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.iotregdevice = result;	
					
					vm.companies.forEach(function(c) {
						if(c.id==vm.iotregdevice.companyId){
							vm.selectedCompany = c;
						}
					});

					vm.deviceTypes.forEach(function(d) {
						if(d.id==vm.iotregdevice.type){
							vm.selectedType = d;
						}
					});

					vm.isProcessing = false;
				}, function() {
					vm.isProcessing = false;
					toastr.error('Failed to load selected Device.', Auth.translate('ERROR'))
					$state.go('superadmin.iotregdevices.list');
					return;
				});		
		};	

		vm.deleteGatewayAssignment = function(gwId, gwName) {
			
			vm.isProcessing = true;

			HttpSvc.post('iotgateways/unlink/' + gwId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loadDevice();
				}, function() {
					vm.isProcessing = false;
					toastr.error('Failed to remove assignment of the gateway [' + gwName + '].', 'Removal Failed');
					return null;
			});
		}

		vm.deleteSensorAssignment = function(sensorId, sensorName) {
			
			vm.isProcessing = true;

			HttpSvc.post('iotsensors/unlink/' + sensorId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loadDevice();
				}, function() {
					vm.isProcessing = false;
					toastr.error('Failed to remove assignment of the sensor [' + sensorName + '].', 'Removal Failed');
					return null;
			});
		}

		/* **************************************************************** */

		// Select Company
		vm.selectedCompanyChanged = function() {
			vm.iotregdevice.companyId = vm.selectedCompany.id;
		};
		
		vm.clearCompany = function() {
			vm.selectedCompany = null;
			vm.iotregdevice.companyId = null;
		}

		// Select Device Type
		vm.selectedTypeChanged = function() {
			vm.iotregdevice.type = vm.selectedType.id;
		};

		/* **************************************************************** */
		
		// Form Submission
		vm.submit = function() {	

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');				
			} else {				
				vm.isProcessing = true;
				HttpSvc.put('iotregistereddevices/' + $stateParams.id, vm.iotregdevice, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Device has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						vm.isProcessing = false;
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadCompanyList();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.payments.controller', [])
		.controller('SAPaymentCtrl', SAPaymentCtrl)
		.controller('SAPaymentDownloadExcelModalCtrl', SAPaymentDownloadExcelModalCtrl);

	/** @ngInject */
    function SAPaymentCtrl($scope, $state, $filter, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.payment = {};
		vm.companyList = [];
		vm.invoiceList = [];
		vm.fullInvoiceList = [];
		vm.invoiceGenerationResult = [];
		vm.selectedCompany = null;
		vm.selectedInvoice = null;
		vm.selectedTab = 0;
		vm.isLoading = false;

		/* ****************************************************************************** */

		// Init Data
		vm.initData = function() {	
			vm.payment.companyId='';
			vm.payment.invoiceNo='';
			vm.payment.chequeNo = null;
			vm.payment.amount = null;

			vm.loadCompanyList();
		}
		
		// Reset Fields
		vm.resetFields = function() {
			vm.payment.companyId='';
			vm.payment.invoiceNo='';
			vm.payment.chequeNo = null;
			vm.payment.amount = null;
			vm.invoiceList = [];
			vm.selectedCompany = null;
			vm.selectedInvoice = null;
		}
					
		// Load Company List
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/listwithosinvoice', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companyList = result;	
					
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Company list.', '');
					return null;
				});			
		}
		
		// Load O/S Invoice List
		vm.loadOutstandingInvoiceList = function(companyId) {
			HttpSvc.get('billinginvoices/list/pending/company/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.invoiceList = result;						
				}, function() {
					// Failed
					toastr.error('Failed to retrieve Invoice list.', '');
					return null;
				});			
		}	
				
		/* ****************************************************************************** */
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfPages = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.data = [];
		vm.totalUnpaidAmount = 0;	
		vm.totalUnpaidInvoiceCount = 0;	

		vm.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}
			
			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.invoiceNo,
				debtorName: predicate.debtorName,
				isPaid: predicate.isPaid,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('billinginvoices/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isLoading = false;		
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;	
					vm.numOfPages = result.numberOfPages;	
					vm.totalUnpaidAmount = result.totalUnpaidAmount;
					vm.totalUnpaidInvoiceCount = result.totalUnpaidInvoiceCount;
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;		
			return tableState;
		};

		vm.resetSearch = function() 
		{
		}

		vm.printInvoice = function(invoiceId, invoiceNo) {
			var filename = "INVOICE_" + invoiceNo.replace("/", "_") + ".pdf";

			HttpSvc.getPdfObject('billinginvoices/print/' + invoiceId, Auth.getTokenId(), filename)
				.then(function(result) {					
				}, function(error) {					
				});
		}

		/* ****************************************************************************** */
		
		vm.selectedCompanyChanged = function() {
			vm.payment.companyId = vm.selectedCompany.id;
			vm.loadOutstandingInvoiceList(vm.payment.companyId);	
		}
		
		vm.selectedInvoiceChanged = function() {
			vm.payment.invoiceNo = vm.selectedInvoice.invoiceNo;
		}
		
		/* ****************************************************************************** */
		
		vm.showDownloadExcelModal = function () {
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'downloadModal.html',
				controller: 'SAPaymentDownloadExcelModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};	
		
		/* ****************************************************************************** */
		
		// Form Submission
		vm.submit = function() {
						
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {		
				vm.isLoading = true;
				
				if(vm.selectedTab==0) {
				
					HttpSvc.post('billinginvoices/payment', vm.payment, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Payment has been submitted successfully.', Auth.translate('SUCCESS'));
							vm.resetFields();
							vm.dataForm.$setPristine();
							
							vm.isLoading = false;
						}, function(error) {
							vm.isLoading = false;
							toastr.error(error, 'Payment Failed');
					});		
						
				} else if(vm.selectedTab==1) { 
					
					HttpSvc.post('billinginvoices/generate/' + vm.invoice.year + '/' + vm.invoice.month, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.invoiceGenerationResult = result;
							toastr.success('Invoices have been generated successfully.', Auth.translate('SUCCESS'));
							vm.resetFields();
							vm.dataForm.$setPristine();
							vm.isLoading = false;
						}, function(error) {
							vm.isLoading = false;
							toastr.error(error, 'Invoice Generation Failed');
						});			
				}
			
				
			}
		}
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
	function SAPaymentDownloadExcelModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {
		var $mdl = this;
		
		$mdl.yearList = GetYearList();
		$mdl.monthList = GetMonthList();
		$mdl.isLoading = false;
		$mdl.selectedBatchId = null;		
		$mdl.batchId = null;
		
		// ********************************************************		
		
		$mdl.confirmModal = function() {

			if($mdl.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$mdl.isLoading = true;
				var filename = "RMS Invoices List (" + $mdl.selectedYear.id + "-" + $mdl.selectedMonth.name + ").xlsx";

				HttpSvc.getExcelObject("billinginvoices/download/excel/" + $mdl.selectedYear.id + "/" + $mdl.selectedMonth.id, Auth.getTokenId(), filename)
					.then(function() {
						$mdl.isLoading = false;
						$uibModalInstance.dismiss('cancel');
					}, function(error) {
						$mdl.isLoading = false;
						toastr.error('No record found.', 'Failed to generate Excel');
						return null;
					});
			}
		}

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

	function GetYearList() {
		var yearList = [
			{ id: 2022, name: '2022' },
			{ id: 2023, name: '2023' },
			{ id: 2024, name: '2024' },
			{ id: 2025, name: '2025' }
		];
		return yearList;
	}

	function GetMonthList() {
		var yearList = [
			{ id: 1, name: '01' },
			{ id: 2, name: '02' },
			{ id: 3, name: '03' },
			{ id: 4, name: '04' },
			{ id: 5, name: '05' },
			{ id: 6, name: '06' },
			{ id: 7, name: '07' },
			{ id: 8, name: '08' },
			{ id: 9, name: '09' },
			{ id: 10, name: '10' },
			{ id: 11, name: '11' },
			{ id: 12, name: '12' }
		];
		return yearList;
	}

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.intercompanymappings.controller', [])
        .controller('SAInterCompanyMappingMainCtrl', SAInterCompanyMappingMainCtrl)
        .controller('SAInterCompanyMappingCreateCtrl', SAInterCompanyMappingCreateCtrl)
        .controller('SAInterCompanyMappingUpdateCtrl', SAInterCompanyMappingUpdateCtrl)
        .controller('SAInterCompanyMappingImportCtrl', SAInterCompanyMappingImportCtrl);

    /** @ngInject */
    function SAInterCompanyMappingMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 20;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.mappingDataFull = [];
		vm.mappingData = [];
		vm.isLoading = true;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.mappingDataFull, tableState.search.predicateObject) : vm.mappingDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.mappingData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.mappingDataFull.length <= 0) {			
				vm.isLoading = true;

				HttpSvc.get('intercompanymappings/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.mappingDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteMapping = function(mappingId) {
			var params = {};
			vm.isLoading = true;

			HttpSvc.delete('intercompanymappings/' + mappingId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('intercompanymappings/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.mappingDataFull = result;
							
							toastr.success('The mapping has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
							vm.isLoading = false;
						}, function() {
							vm.isLoading = false;
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to delete the mapping.', 'Delete Failed');
					return null;
			});
		};	

		vm.resetSearch = function() 
		{
		}		
	};
	
	/** @ngInject */
    function SAInterCompanyMappingCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.mapping = {};	
		vm.mapping.active = true;	
		vm.companyList = [];
		vm.supplierList = [];
		vm.sourceBranchList = [];
		vm.destBranchList = [];
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.selectedSourceCompany = null;
		vm.selectedSourceSupplier = null;
		vm.selectedSourceBranch = null;
		vm.selectedDestCompany = null;
		vm.selectedDestBranch = null;
		vm.selectedDestDebtor = null;
		vm.selectedDestDebtorBranch = null;

		/* ******************************************************** */

		// Load Companies 
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companyList = result;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		// Load Suppliers
		vm.loadSupplierList = function(companyId) {
			HttpSvc.get('suppliers/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.supplierList = result;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve supplier list.', '');
					return null;
				});
		};

		// Load Source Branches
		vm.loadSourceBranchList = function(companyId) {
			HttpSvc.get('branches/listbycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.sourceBranchList = result;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve branch list.', '');
					return null;
				});
		};

		// Load Dest Branches
		vm.loadDestBranchList = function(companyId) {
			HttpSvc.get('branches/listbycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.destBranchList = result;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve branch list.', '');
					return null;
				});
		};
		
		// Load Debtors
		vm.loadDebtorList = function(companyId) {
			HttpSvc.get('debtors/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.debtorList = result;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer list.', '');
					return null;
				});
		};

		// Load Debtor's Branches
		vm.loadDebtorBranchList = function(debtorId) {
			HttpSvc.get('debtors/' + debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.debtorBranchList = result;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer branch list.', '');
					return null;
				});
		};

		/* ******************************************************** */
		
		// Select Source Company
		vm.selectedSourceCompanyChanged = function() {
			vm.mapping.sourceCompanyId = vm.selectedSourceCompany.id;
			vm.loadSupplierList(vm.mapping.sourceCompanyId);
			vm.loadSourceBranchList(vm.mapping.sourceCompanyId);
		};
		
		// Select Source Supplier
		vm.selectedSourceSupplierChanged = function() {
			vm.mapping.sourceSupplierId = vm.selectedSourceSupplier.id;
		};
		
		// Select Source Branch
		vm.selectedSourceBranchChanged = function() {
			vm.mapping.sourceBranchId = vm.selectedSourceBranch.id;
		};
		
		// Select Dest Company
		vm.selectedDestCompanyChanged = function() {
			vm.mapping.destCompanyId = vm.selectedDestCompany.id;
			vm.loadDestBranchList(vm.mapping.destCompanyId);
			vm.loadDebtorList(vm.mapping.destCompanyId);
		};
		
		// Select Dest Branch
		vm.selectedDestBranchChanged = function() {
			vm.mapping.destBranchId = vm.selectedDestBranch.id;
		};
		
		// Select Dest Debtor
		vm.selectedDestDebtorChanged = function() {
			vm.mapping.destDebtorId = vm.selectedDestDebtor.id;
			vm.loadDebtorBranchList(vm.mapping.destDebtorId);
		};
		
		// Select Dest Debtor Branch
		vm.selectedDestDebtorBranchChanged = function() {
			vm.mapping.destDebtorBranchId = vm.selectedDestDebtorBranch.id;
		};
		
		/* ******************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('intercompanymappings', vm.mapping, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Mapping has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.intercompanymappings.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}
		
		/* ******************************************************** */
		
		// Call Action
		vm.loadCompanyList();
	}
	
	/** @ngInject */
    function SAInterCompanyMappingUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.mapping = {};
		vm.companyList = [];
		vm.supplierList = [];
		vm.sourceBranchList = [];
		vm.destBranchList = [];
		vm.debtorList = [];
		vm.debtorBranchList = [];
		vm.changeLogs = [];
		vm.selectedSourceCompany = null;
		vm.selectedSourceSupplier = null;
		vm.selectedSourceBranch = null;
		vm.selectedDestCompany = null;
		vm.selectedDestBranch = null;
		vm.selectedDestDebtor = null;
		vm.selectedDestDebtorBranch = null;

		/* ******************************************************** */

		// Load Companies 
		vm.loadCompanyList = function() {
			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companyList = result;
					
					vm.loadMapping();
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		};

		// Load Suppliers
		vm.loadSupplierList = function(companyId) {
			HttpSvc.get('suppliers/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.supplierList = result;
					
					vm.supplierList.forEach(function(s) {
						if(s.id==vm.mapping.sourceSupplierId)
						{
							vm.selectedSourceSupplier = s;
						}
					});
				}, function() {
					// Failed
					toastr.error('Failed to retrieve supplier list.', '');
					return null;
				});
		};

		// Load Source Branches
		vm.loadSourceBranchList = function(companyId) {
			HttpSvc.get('branches/listbycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.sourceBranchList = result;
					
					vm.sourceBranchList.forEach(function(b) {
						if(b.id==vm.mapping.sourceBranchId)
						{
							vm.selectedSourceBranch = b;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve branch list.', '');
					return null;
				});
		};

		// Load Dest Branches
		vm.loadDestBranchList = function(companyId) {
			HttpSvc.get('branches/listbycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.destBranchList = result;	
					
					vm.destBranchList.forEach(function(b) {
						if(b.id==vm.mapping.destBranchId)
						{
							vm.selectedDestBranch = b;
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve branch list.', '');
					return null;
				});
		};
		
		// Load Debtors
		vm.loadDebtorList = function(companyId) {
			HttpSvc.get('debtors/bycompany/' + companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.debtorList = result;	
					
					vm.debtorList.forEach(function(d) {
						if(d.id==vm.mapping.destDebtorId)
						{
							vm.selectedDestDebtor = d;

							vm.loadDebtorBranchList(vm.mapping.destDebtorId);
						}
					});	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer list.', '');
					return null;
				});
		};

		// Load Debtor's Branches
		vm.loadDebtorBranchList = function(debtorId) {
			HttpSvc.get('debtors/' + debtorId + '/branches', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.debtorBranchList = result;
					
					vm.debtorBranchList.forEach(function(d) {
						if(d.id==vm.mapping.destDebtorBranchId)
						{
							vm.selectedDestDebtorBranch = d;
						}
					});		
				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer branch list.', '');
					return null;
				});
		};
				
		// Load Change Logs
		vm.loadChangeLogs = function() {
			//return;
			HttpSvc.get('intercompanymappingchangelogs/list/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.changeLogs = result;
				}, function() {
					toastr.error('Failed to load the Change Logs.', '');
				});
		};	

		// Load Mapping
		vm.loadMapping = function() {
			HttpSvc.get('intercompanymappings/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.mapping = result;

					vm.companyList.forEach(function(c) {
						if(c.id==vm.mapping.sourceCompanyId)
						{
							vm.selectedSourceCompany = c;
						}
						if(c.id==vm.mapping.destCompanyId)
						{
							vm.selectedDestCompany = c;
						}
					});

					vm.loadSupplierList(vm.mapping.sourceCompanyId);
					vm.loadSourceBranchList(vm.mapping.sourceCompanyId);
					vm.loadDestBranchList(vm.mapping.destCompanyId);
					vm.loadDebtorList(vm.mapping.destCompanyId);
					vm.loadChangeLogs();

				}, function() {
					// Failed
					toastr.error('Failed to retrieve customer branch list.', '');
					return null;
				});
		};

		/* ******************************************************** */
		
		// Select Source Company
		vm.selectedSourceCompanyChanged = function() {
			vm.mapping.sourceCompanyId = vm.selectedSourceCompany.id;
			vm.loadSupplierList(vm.mapping.sourceCompanyId);
			vm.loadSourceBranchList(vm.mapping.sourceCompanyId);
		};
		
		// Select Source Supplier
		vm.selectedSourceSupplierChanged = function() {
			vm.mapping.sourceSupplierId = vm.selectedSourceSupplier.id;
		};
		
		// Select Source Branch
		vm.selectedSourceBranchChanged = function() {
			vm.mapping.sourceBranchId = vm.selectedSourceBranch.id;
		};
		
		// Select Dest Company
		vm.selectedDestCompanyChanged = function() {
			vm.mapping.destCompanyId = vm.selectedDestCompany.id;
			vm.loadDestBranchList(vm.mapping.destCompanyId);
			vm.loadDebtorList(vm.mapping.destCompanyId);
		};
		
		// Select Dest Branch
		vm.selectedDestBranchChanged = function() {
			vm.mapping.destBranchId = vm.selectedDestBranch.id;
		};
		
		// Select Dest Debtor
		vm.selectedDestDebtorChanged = function() {
			vm.mapping.destDebtorId = vm.selectedDestDebtor.id;
			vm.loadDebtorBranchList(vm.mapping.destDebtorId);
		};
		
		// Select Dest Debtor Branch
		vm.selectedDestDebtorBranchChanged = function() {
			vm.mapping.destDebtorBranchId = vm.selectedDestDebtorBranch.id;
		};
		
		/* ******************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('intercompanymappings/' + $stateParams.id, vm.mapping, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Mapping has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.intercompanymappings.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}
		
		/* ******************************************************** */
		
		// Call Action
		vm.loadCompanyList();	
	}
	
	/** @ngInject */
	function SAInterCompanyMappingImportCtrl($scope, $state, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();
		
		var vm = this;
		var azureStorageUrl = "";
		var localStorageUrl = "";
		vm.lockButtons = false;
		vm.uploadProgess = 0;
		vm.uploadProgessPercent = 0;
		vm.isUploaded = false;
		vm.isSuccess = false;
		vm.isFail = false;		
		vm.isImporting = false;
		vm.isImportComplete = false;
		vm.isImportFailed = false;
		vm.serverMode = Auth.getServerMode();
		vm.isLoading = false;
		
		/* **************************************************** */
		
		var maxBlockSize = 4194304; // 4MB in bytes
        var numberOfBlocks = 1;
        var currentFilePointer = 0;
        var totalBytesRemaining = 0;
        var blockIds = new Array();
        var blockIdPrefix = "block-";
        var bytesUploaded = 0;
		var fileReader = new FileReader();
		var excelFilename = "";

		/* **************************************************** */
		
		vm.importOptions = {};
		vm.importOptions.excelContent = [];
		vm.importOptions.createCompanyMapping = true;
		vm.importOptions.updateCompanyMapping = true;
		
		/* **************************************************** */
		
		vm.goBack = function() {
			$state.reload();
		}
		
		/* **************************************************** */
		
		vm.importResult = {};
		
		/* **************************************************** */
				
		vm.downloadTemplate = function() {
			
			var filename = "InterCompany Mapping Template.xlsx";
			vm.isExporting = true;
			
			HttpSvc.getExcelObject('intercompanymappings/download/template', Auth.getTokenId(), filename)
				.then(
					function() {
						vm.isExporting = false;						
					}, 
					function(error) {
						vm.isExporting = false;
						toastr.error('Failed to download the template. ' + error, 'Failed');
						return null;
					});
		};		
		
		/* **************************************************** */
		
		vm.importData = function() {
			vm.isImporting = true;
			
			HttpSvc.post('intercompanymappings/importData', vm.importOptions, Auth.getTokenId(), false)
				.then(function(result) {
					//vm.lockButtons = false;
					//vm.isImportComplete = true;
					
					//vm.importResult = result;
					
					//toastr.success("Data imported successfully!");
					//$state.go('maintenance.items.list');
				}, function(error) {
					//vm.lockButtons = false;
					//vm.isImportFailed = true;
					
					//toastr.error("Failed to import data! " + error);
				});
		}
		
		/* **************************************************** */
		
		// Refresh Page
		vm.refreshPage = function() {
			$state.reload();
		}
		
		// Set Upload File Object
		vm.setUploadFile = function(excelFile) {
			vm.mediaToUpload = excelFile;			
		}
		
		// Reset File Upload Params
		vm.resetFileUploadParams = function() {
			vm.isUploaded = false;
			vm.isSuccess = false;
			vm.isFail = false;
			vm.excelFilename = "";
			vm.importOptions.excelContent = [];
			
			numberOfBlocks = 1;
			currentFilePointer = 0;
			totalBytesRemaining = 0;
			blockIds = new Array();
			blockIdPrefix = "block-";
			bytesUploaded = 0;
			fileReader = new FileReader();
			excelFilename = "";
		}
		
		// Upload File
		vm.uploadFile = function() {	
			vm.resetFileUploadParams();
			
			vm.lockButtons = true;
			vm.uploadProgess = 0;
			vm.uploadProgessPercent = 0;
								
			var extArray = vm.mediaToUpload.name.split(".");
			var mediaExtension = extArray[extArray.length-1].toLowerCase();
			var newFilename = UtilSvc.generateGuid() + "." + mediaExtension;
			excelFilename = newFilename;
			
			if(vm.serverMode==0)
			{
				localStorageUrl = RmsApi.URL + "upload/fileuploads/" + UtilSvc.generateGuid();	
				vm.uploadMedia(vm.mediaToUpload);
			}	
			else if(vm.serverMode==1)
			{
				HttpSvc.get('misc/getAzureSasToken/fileuploads', {}, Auth.getTokenId(), false)
					.then(function(result) {
						
						azureStorageUrl = RmsApi.BLOBURL + "fileuploads/" + newFilename + result.sasTokenUri;
						vm.uploadMedia(vm.mediaToUpload);
						
					}, function(error) {
						toastr.error(error, 'Failed');
						
						vm.isUploaded = false;
						vm.isFail = true;
						vm.lockButtons = false;
					});
			}
		}
				
		// Upload Image to Azure Blob Storage
		vm.uploadMedia = function (_fileToUpload) {
			
			if(vm.serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: _fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {					
					vm.isUploaded = true;
					
					// Call Process Excel API 
					HttpSvc.post('intercompanymappings/import/' + resp.data, {}, Auth.getTokenId(), true)
						.then(function(result) {
							vm.isSuccess = true;
							vm.lockButtons = false;
							
							vm.importOptions.excelContent = result;
							toastr.success("Excel uploaded successfully");
						}, function(error) {
							vm.isFail = true;
							vm.lockButtons = false;
							toastr.error(error);
						});
				}, function (resp) {
					vm.isUploaded = false;
					vm.isFail = true;
					vm.lockButtons = false;
					toastr.error('Excel failed to upload.');
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			}  else if(vm.serverMode==1) { // Azure Server
							
				/* Initialize variables */
				/* ************************************* */	
				handleFileSelect(_fileToUpload);
				/* ************************************* */	
				
				/* Initialize File Reader */
				/* ************************************* */
				fileReader = new FileReader();
				/* ************************************* */
				
				/* Upload File (First Block) */
				/* ************************************* */						
				uploadFileInBlocks(_fileToUpload, azureStorageUrl);
				
				fileReader.onload = function(e) {				
					if (e.target.readyState == FileReader.DONE) {
						var uri = azureStorageUrl + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
						
						Upload.http({
							method: "PUT",
							url: uri,
							headers: {
								'x-ms-blob-type': 'BlockBlob',
								'x-ms-blob-content-type': _fileToUpload.type
							},
							data: e.target.result,						
						}).then(function(response) {
							if (response.status==201) {							
								uploadFileInBlocks(_fileToUpload, azureStorageUrl);
							} else {
								vm.lockButtons = false;
							} 
						}, null, function(evt) {
							var uploadProgessTotal = _fileToUpload.size;
							vm.uploadProgess = uploadProgessTotal - totalBytesRemaining;
							vm.uploadProgessPercent = Math.min(100, parseInt(100.0 * vm.uploadProgess / uploadProgessTotal).toFixed(2));
								
							//_fileToUpload.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
			}
		};
 
		function handleFileSelect(_fileToUpload) {
            maxBlockSize = 4194304;
            currentFilePointer = 0;
            totalBytesRemaining = 0;
			
            var fileSize = _fileToUpload.size;
            if (fileSize < maxBlockSize) {
                maxBlockSize = fileSize;
            }
            totalBytesRemaining = fileSize;
            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }
        }
		
        function uploadFileInBlocks(_fileToUpload, _azureStorageUrl) {
            if (totalBytesRemaining > 0) {                
				var fileContent = _fileToUpload.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                var blockId = blockIdPrefix + pad(blockIds.length+1, 6);
				
                blockIds.push(btoa(blockId));
                fileReader.readAsArrayBuffer(fileContent);
                
				currentFilePointer += maxBlockSize;
                totalBytesRemaining -= maxBlockSize;				
                if (totalBytesRemaining < maxBlockSize) {
                    maxBlockSize = totalBytesRemaining;
                }
            } else {
                commitBlockList(_fileToUpload, _azureStorageUrl);
            }
        }
         
        function commitBlockList(_fileToUpload, _azureStorageUrl) {
            var uri = _azureStorageUrl + '&comp=blocklist';			
            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockIds.length; i++) {
                requestBody += '<Latest>' + blockIds[i] + '</Latest>';
            }
            requestBody += '</BlockList>';
			
			Upload.http({
				method: "PUT",
				url: uri,
				headers: {
					'x-ms-blob-content-type': _fileToUpload.type
				},
				data: requestBody,				
			}).then(function(response) {	
				vm.isUploaded = true;
				
				// Call Process Excel API 
				HttpSvc.post('intercompanymappings/import/' + excelFilename, {}, Auth.getTokenId(), true)
					.then(function(result) {
						vm.isSuccess = true;
						vm.lockButtons = false;
						
						vm.importOptions.excelContent = result;
						toastr.success("Excel uploaded successfully");
					}, function(error) {
						vm.isFail = true;
						vm.lockButtons = false;
						toastr.error(error);
					});
			}, function(error) {
				vm.isUploaded = false;
				vm.isFail = true;
				vm.lockButtons = false;
				toastr.error(error);
			});
        }
		
        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }		
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.serverpackages.controller', [])
        .controller('PackageMainCtrl', PackageMainCtrl)
        .controller('PackageCreateCtrl', PackageCreateCtrl)
        .controller('PackageUpdateCtrl', PackageUpdateCtrl)
        .controller('PackageFeeModalCtrl', PackageFeeModalCtrl)
        .controller('PackageLimitedUserTypeModalCtrl', PackageLimitedUserTypeModalCtrl);
	
    /** @ngInject */
    function PackageMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 100;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.packageDataFull = [];
		vm.packageData = [];

		vm.totalMonthlyFee = 0.0;
		vm.totalQuarterlyFee = 0.0;
		vm.totalAnnualFee = 0.0;
		vm.totalBiAnnualFee = 0.0;

		vm.actualTotalMonthlyFee = 0.0;
		vm.actualTotalQuarterlyFee = 0.0;
		vm.actualTotalAnnualFee = 0.0;
		vm.actualTotalBiAnnualFee = 0.0;

		vm.actualGrandTotal = 0.0;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.packageDataFull, tableState.search.predicateObject) : vm.packageDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.packageData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			vm.recalculateTotalFee();

			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.packageDataFull.length <= 0) {
				HttpSvc.get('serverpackages/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.packageDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	

		vm.recalculateTotalFee = function() {
			vm.totalMonthlyFee = 0;
			vm.totalQuarterlyFee = 0;
			vm.totalAnnualFee = 0;
			vm.totalBiAnnualFee = 0;

			vm.actualTotalMonthlyFee = 0;
			vm.actualTotalQuarterlyFee = 0;
			vm.actualTotalAnnualFee = 0;
			vm.actualTotalBiAnnualFee = 0;

			vm.packageData.forEach(function(f) {
				vm.totalMonthlyFee += f.monthlyFee;
				vm.totalQuarterlyFee += f.quarterlyFee;
				vm.totalAnnualFee += f.annualFee;
				vm.totalBiAnnualFee += f.biAnnualFee;
				
				if(f.billingIntervalType==1)
				{
					vm.actualTotalMonthlyFee += f.monthlyFee;
				}
				else if(f.billingIntervalType==2)
				{
					vm.actualTotalQuarterlyFee += (f.quarterlyFee * 0.95);
				}
				else if(f.billingIntervalType==3)
				{
					vm.actualTotalAnnualFee += (f.annualFee * 0.9);
				}
				else if(f.billingIntervalType==4)
				{
					vm.actualTotalBiAnnualFee += (f.biAnnualFee * 0.9);
				}
			});
			
			vm.actualTotalAnnualFee += (vm.actualTotalBiAnnualFee / 2);

			vm.actualGrandTotal = 
				(vm.actualTotalMonthlyFee * 12) + 
				(vm.actualTotalQuarterlyFee * 4) + 
				vm.actualTotalAnnualFee + 
				(vm.actualTotalBiAnnualFee / 2);
		}
		
		// Delete Package
		vm.deletePackage = function(packageId, packageName) {
			var params = {};
			HttpSvc.delete('serverpackages/' + packageId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('serverpackages/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;	
							vm.packageDataFull = result;	

							toastr.success('The package [<b>' + packageName + '</b>] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the Package.', 'Delete Failed');
					return null;
				});
		};			
	};
	
	/** @ngInject */
    function PackageCreateCtrl($scope, $state, $uibModal, Auth, HttpSvc, toastr) {		
		Auth.init();
		
		var vm = this;

		vm.billingIntervalTypes = [
			{ id: 1, name: "MONTHLY" },
			{ id: 2, name: "QUARTERLY" },
			{ id: 3, name: "ANNUALLY" },
			{ id: 4, name: "BI-ANNUALLY" }
		];

		vm.mode = 1;
		vm.package = {};
		vm.package.disableDiscount = false;
		vm.package.isPublic = true;
		vm.package.isAddOn = false;
		vm.package.isTrial = false;
		vm.package.trialPeriod = 0;
		vm.package.trialSopCount = -1;
		vm.package.trialRecipeCount = -1;
		vm.package.trialRecipeStepCount = -1;
		vm.package.trialAssetCount = -1;
		vm.package.serverPackageLimitedAccesses = [];
		vm.features = [];
		vm.selectedFeatures = [];
		vm.selectedBillingIntervalType = null;
		
		/* ********************************************************************************** */
		
		// Load Feature List
		vm.loadFeatureList = function() {
			HttpSvc.get('featuresV2', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.features = [];
					result.forEach(function (f) {
						if(f.state.indexOf('superadmin') < 0)
						{
							vm.features.push({ 
								id: f.id, 
								name: f.name, 
								state: f.state, 
								sequence: f.sequence, 
								isParent: f.isParent, 
								parentId: f.parentId 
							});
						}
					});
				}, function() {
					return;
				});		
		}

		/* ********************************************************************************** */

		vm.selectedBillingIntervalTypeChanged = function() 
		{
			vm.package.billingIntervalType = vm.selectedBillingIntervalType.id;
		}
						
		/* ********************************************************************************** */
		
		// Form Submission
		vm.submit = function() {
			if(!vm.package.isTrial){
				vm.package.trialPeriod = 0;
			}
			
			vm.package.serverPackageLimitedAccesses = [];
			vm.selectedFeatures.forEach(function(f) {
				vm.package.serverPackageLimitedAccesses.push({ featureId: f.id });
			})
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('serverpackages/add', vm.package, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Package has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.serverpackages.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		};
						
		/* ********************************************************************************** */

		// Call Actions
		vm.loadFeatureList();
	}
	
	/** @ngInject */
    function PackageUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;

		vm.billingIntervalTypes = [
			{ id: 1, name: "MONTHLY" },
			{ id: 2, name: "QUARTERLY" },
			{ id: 3, name: "ANNUALLY" },
			{ id: 4, name: "BI-ANNUALLY" }
		];

		vm.mode = 2;
		vm.package = {};
		vm.package.isPublic = false;
		vm.package.isAddOn = false;
		vm.package.isTrial = false;
		vm.package.disableDiscount = false;
		vm.package.trialRecipeStepCount = -1;
		vm.selectedBillingIntervalType = null;
		vm.features = [];
		vm.selectedFeatures = [];
			
		vm.totalMonthlyFee = 0.0;
		vm.totalQuarterlyFee = 0.0;
		vm.totalAnnualFee = 0.0;
		vm.totalBiAnnualFee = 0.0;
		
		/* ********************************************************************************** */
		
		// Load Feature List
		vm.loadFeatureList = function() {
			HttpSvc.get('featuresV2', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.features = [];
					result.forEach(function (f) {
						if(f.state.indexOf('superadmin') < 0)
						{
							vm.features.push({ 
								featureId: f.id, 
								name: f.name, 
								state: f.state, 
								sequence: f.sequence, 
								isParent: f.isParent, 
								parentId: f.parentId 
							});
						}
					});
					vm.loadPackage();
				}, function() {
					return;
				});		
		}

		/* ********************************************************************************** */
				
		// Load Package
		vm.loadPackage = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('serverpackages/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.package = result;
					vm.billingIntervalTypes.forEach(function(b) {
						if(b.id==vm.package.billingIntervalType)
						{
							vm.selectedBillingIntervalType=b;
						}
					})

					vm.recalculateTotalFee();
				}, function() {
					toastr.error('Failed to load selected Package.', Auth.translate('ERROR'));
					$state.go('superadmin.serverpackages.list');
					return;
				});		
		};

		vm.loadPackageFees = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('serverpackagefees/list/:id', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.package.serverPackageFees = result;
					vm.recalculateTotalFee();
				}, function() {
					toastr.error('Failed to load selected Package.', Auth.translate('ERROR'));
					$state.go('superadmin.serverpackages.list');
					return;
				});		
		}

		vm.loadPackageLimiteds = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('serverpackagelimiteds/list/:id', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.package.serverPackageLimiteds = result;
				}, function() {
					toastr.error('Failed to load list of Limited User Types.', Auth.translate('ERROR'));
					$state.go('superadmin.serverpackages.list');
					return;
				});		
		}

		vm.recalculateTotalFee = function() {
			vm.totalMonthlyFee = 0;
			vm.totalQuarterlyFee = 0;
			vm.totalAnnualFee = 0;
			vm.totalBiAnnualFee = 0;
					
			vm.package.serverPackageFees.forEach(function(f) {
				vm.totalMonthlyFee += f.monthlyFee;
				vm.totalQuarterlyFee += f.quarterlyFee;
				vm.totalAnnualFee += f.annualFee;
				vm.totalBiAnnualFee += (f.annualFee * 2);
			});
		}
				
		/* ********************************************************************************** */

		vm.selectedBillingIntervalTypeChanged = function() 
		{
			vm.package.billingIntervalType = vm.selectedBillingIntervalType.id;
		}
				
		/* ********************************************************************************** */
					
		vm.showAddFeeModal = function () {
			vm.pkgFee = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'PackageFeeModal.html',
				controller: 'PackageFeeModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							object: vm.pkgFee,
							packageId: vm.package.id,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					vm.loadPackageFees();
				}, function () {
				});
		};	
		
		vm.showEditFeeModal = function (id) {

			vm.pkgFee = {};			
			vm.package.serverPackageFees.forEach(function(p) {
				if(p.id==id) vm.pkgFee = angular.copy(p);
			});
			
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'PackageFeeModal.html',
				controller: 'PackageFeeModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							object: vm.pkgFee,
							packageId: vm.package.id,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					vm.loadPackageFees();
				}, function () {
				});
		};	

		vm.deleteFee = function (id) {
			var params = { id: id };
			HttpSvc.delete('serverpackagefees/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Fee has been deleted.', 'Deleted');
					vm.loadPackageFees();
				}, function() {
					// Failed
					toastr.error('Failed to delete the Package Fee.', 'Delete Failed');
					return null;
				});
		};	

		/* ********************************************************************************** */
					
		vm.showAddLimitedUserType = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'LimitedUserTypeModal.html',
				controller: 'PackageLimitedUserTypeModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							object: {},
							packageId: vm.package.id,
							featureList: vm.features
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					vm.loadPackageLimiteds();
				}, function () {
				});
		};	
		
		vm.showEditLimitedUserType = function (id) {
			vm.pkgLimited;	
			vm.package.serverPackageLimiteds.forEach(function(p) {
				if(p.id==id) vm.pkgLimited = angular.copy(p);
			});
			
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'LimitedUserTypeModal.html',
				controller: 'PackageLimitedUserTypeModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							object: vm.pkgLimited,
							packageId: vm.package.id,
							featureList: vm.features
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					vm.loadPackageLimiteds();
				}, function () {
				});
		};	

		vm.deleteLimitedUserType = function(id) {
			var params = { id: id };
			HttpSvc.delete('serverpackagelimiteds/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Limited User Type has been deleted.', 'Deleted');
					vm.loadPackageLimiteds();
				}, function() {
					// Failed
					toastr.error('Failed to delete the Limited User Type.', 'Delete Failed');
					return null;
				});
		};

		/* ********************************************************************************** */
		
		// Form Submission
		vm.submit = function() {	
			if(!vm.package.isTrial){
				vm.package.trialPeriod = 0;
			}
			
			vm.package.serverPackageLimitedAccesses = [];
			vm.selectedFeatures.forEach(function(f) {
				vm.package.serverPackageLimitedAccesses.push({ featureId: f.id });
			})
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('serverpackages/' + $stateParams.id, vm.package, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Package has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		/* ********************************************************************************** */
		
		// Call Actions
		vm.loadFeatureList();
	}	
	
	function PackageLimitedUserTypeModalCtrl($uibModalInstance, item, Auth, HttpSvc, UtilSvc, toastr) {
		var $mdl = this;
		$mdl.item = item.object;
		$mdl.packageId = item.packageId;
		$mdl.featureList = item.featureList;
		$mdl.selectedFeatures = [];

		/* ********************************************************************************** */

		// Initialize
		if(item.mode==1) {
			$mdl.title = "Add New";
			$mdl.item.description = "";
		}
		else 
		{
			$mdl.title = "Update";
			$mdl.item.serverPackageLimitedAccesses.forEach(function(f) {
				$mdl.selectedFeatures.push({
					featureId: f.featureId, 
					name: f.name, 
					state: f.state, 
					sequence: f.sequence, 
					isParent: f.isParent, 
					parentId: f.parentId 
				});
			});
		}
		
		/* ********************************************************************************** */

		$mdl.applyTemplate_Outlet = function() {
			
			$mdl.item.description = "OUTLET WORKER";

			$mdl.featureList.forEach(function(f) {

				if(f.featureId=='03f58075-1a1c-440d-8a0a-5a26dacee1f9' ||
					f.featureId=='3ffbe37a-7e6c-46f3-a68c-d9c13afc032e' ||
					f.featureId=='774cd1ab-1559-44eb-a7d4-7eb4f261ace4' ||
					f.featureId=='fc5d10b5-02e1-4ea2-9b32-b2ea0ffe3da8' ||
					f.featureId=='af550b1d-7389-45ba-bf05-521c33000beb' ||
					f.featureId=='fc7f0fcf-2bfe-41a4-9d59-9224c978f388' ||
					f.featureId=='73186d8-d9a1-49b3-8eb9-56e6dc2989074' ||
					f.featureId=='02deffbf-b14a-4e21-b6fa-efa248d6873c' ||
					f.featureId=='c537ee6e-459e-43a4-888b-23334328a85e' ||
					f.featureId=='9f3ad82b-1a6f-4d08-a04f-749576d5b0bb' ||
					f.featureId=='4b3651db-38d2-4846-a9d6-072e9ab18386' ||
					f.featureId=='3f9f7562-8085-4ee2-bdfe-203a8db96a6b' ||
					f.featureId=='07d84c24-b7ae-4327-8513-db3d02eaee31' ||
					f.featureId=='ec3280d4-7776-42da-a778-d29ad942e568' ||
					f.featureId=='283d8d78-87c7-4177-8479-1bb39097d98d' ||
					f.featureId=='766715e1-e072-4dd3-9c11-344d9e751a90' ||
					f.featureId=='ce7eca2c-fccf-4d73-8a0b-6f8dfe6c0644' ||
					f.featureId=='7e716168-52c2-41d1-be0c-c9c2ced86f18' ||
					f.featureId=='3695fec7-fb8a-416f-a467-1da4771c9bc6')
				{
					$mdl.selectedFeatures.push({
						featureId: f.featureId, 
						name: f.name, 
						state: f.state, 
						sequence: f.sequence, 
						isParent: f.isParent, 
						parentId: f.parentId 
					});
				};

			});
		}
		
		/* ********************************************************************************** */
		
		$mdl.confirmModal = function() {
			if($mdl.limitedForm.$invalid) 
			{
				var errorMsg = UtilSvc.getErrorMessage($mdl.limitedForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			}
			else
			{
				$mdl.item.packageId = $mdl.packageId;
				$mdl.item.serverPackageLimitedAccesses = $mdl.selectedFeatures;

				if(item.mode==1)
				{
					HttpSvc.post('serverpackagelimiteds', $mdl.item, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Limited User Type has been created successfully.', Auth.translate('SUCCESS'));
							$uibModalInstance.close();
						}, function(error) {
							toastr.error(error, 'Failed');
						});
				} 
				else
				{
					HttpSvc.put('serverpackagelimiteds/' + $mdl.item.id, $mdl.item, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Limited User Type has been updated successfully.', Auth.translate('SUCCESS'));
							$uibModalInstance.close();
						}, function(error) {
							toastr.error(error, 'Failed');
						});
				}
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	
	
	function PackageFeeModalCtrl($uibModalInstance, item, Auth, HttpSvc, UtilSvc, toastr) {
		var $mdl = this;
		$mdl.item = item.object;
		$mdl.item.packageId = item.packageId;
		$mdl.selectedModuleType = null;

		$mdl.isLockDisc = false;
		
		$mdl.moduleTypes = [
			{ id: 'AMS',   name: '(AMS) Asset Management System' },
			{ id: 'ASMS',  name: '(ASMS) Aftersales Management System' },
			{ id: 'IMS',   name: '(IMS) IOT Management System' },
			{ id: 'RMS',   name: '(RMS) RMS Full Edition' },
			{ id: 'RMS-L', name: '(RMS-L) RMS Lite Edition' },
			{ id: 'RMS-S', name: '(RMS-S) RMS Starter Edition' },
			{ id: 'SIM',   name: '(SIM) M2M Sim Card' },
			//{ id: 'RMS for SAP', name: 'RMS for SAP' },
		];

		/* ********************************************************************************** */

		// Initialize
		if(item.mode==1) {
			$mdl.item.moduleType = "";
			$mdl.item.remarks = "";
			$mdl.item.monthlyFee = 0;
			$mdl.item.quarterlyFee = 0;
			$mdl.item.annualFee = 0;
			$mdl.item.biAnnualFee = 0;
			$mdl.item.hasDiscount = true;
			$mdl.item.isTaxable = true;
			$mdl.title = "Add New";
		}
		else 
		{
			$mdl.title = "Update";
			$mdl.moduleTypes.forEach(function(m) {
				if(m.id==$mdl.item.moduleType)
				{
					$mdl.selectedModuleType = m;
				}
			});
		}
				
		/* ********************************************************************************** */

		$mdl.checkDiscountEntitlement = function() 
		{
			if($mdl.item.moduleType == "SIM")
			{
				$mdl.item.hasDiscount = false;
			}
		}

		$mdl.selectedModuleTypeChanged = function() 
		{
			$mdl.item.moduleType = $mdl.selectedModuleType.id;
			$mdl.checkDiscountEntitlement();
		};

		$mdl.monthlyFeeChanged = function()
		{
			$mdl.item.quarterlyFee = $mdl.item.monthlyFee * 3;
			$mdl.item.annualFee = $mdl.item.monthlyFee * 12;
			$mdl.item.biAnnualFee = $mdl.item.annualFee * 2;
		}

		$mdl.quarterlyFeeChanged = function()
		{
			$mdl.item.monthlyFee = $mdl.item.quarterlyFee / 3;
			$mdl.item.annualFee = $mdl.item.quarterlyFee * 4;
			$mdl.item.biAnnualFee = $mdl.item.annualFee * 2;
		}

		$mdl.annualFeeChanged = function()
		{
			$mdl.item.quarterlyFee = $mdl.item.annualFee / 4;
			$mdl.item.monthlyFee = $mdl.item.annualFee / 12;
			$mdl.item.biAnnualFee = $mdl.item.annualFee * 2;
		}

		$mdl.biAnnualFeeChanged = function()
		{
			$mdl.item.annualFee = $mdl.item.biAnnualFee / 2;
			$mdl.item.quarterlyFee = $mdl.item.annualFee / 4;
			$mdl.item.monthlyFee = $mdl.item.annualFee / 12;
		}
		
		/* ********************************************************************************** */
		
		$mdl.confirmModal = function() {
			if($mdl.packageFeeForm.$invalid) 
			{
				var errorMsg = UtilSvc.getErrorMessage($mdl.packageFeeForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			}
			else
			{
				$mdl.checkDiscountEntitlement();

				if(item.mode==1)
				{
					HttpSvc.post('serverpackagefees', $mdl.item, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Package Fee has been created successfully.', Auth.translate('SUCCESS'));
							$uibModalInstance.close();
						}, function(error) {
							toastr.error(error, 'Failed');
						});
				} 
				else
				{
					HttpSvc.put('serverpackagefees/' + $mdl.item.id, $mdl.item, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Package Fee has been update successfully.', Auth.translate('SUCCESS'));
							$uibModalInstance.close();
						}, function(error) {
							toastr.error(error, 'Failed');
						});
				}
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};	

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.serverpackagesettings.controller', [])
        .controller('PackageSettingMainCtrl', PackageSettingMainCtrl)
        .controller('PackageSettingUpdateCtrl', PackageSettingUpdateCtrl)
        .controller('PackageSettingLimitedUserTypeModalCtrl', PackageSettingLimitedUserTypeModalCtrl);
	
    /** @ngInject */
    function PackageSettingMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 100;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.packageDataFull = [];
		vm.packageData = [];

		vm.totalMonthlyFee = 0.0;
		vm.totalQuarterlyFee = 0.0;
		vm.totalAnnualFee = 0.0;
		vm.totalBiAnnualFee = 0.0;

		vm.actualTotalMonthlyFee = 0.0;
		vm.actualTotalQuarterlyFee = 0.0;
		vm.actualTotalAnnualFee = 0.0;
		vm.actualTotalBiAnnualFee = 0.0;

		vm.actualGrandTotal = 0.0;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.packageDataFull, tableState.search.predicateObject) : vm.packageDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.packageData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			vm.recalculateTotalFee();

			return tableState;
		};
		
		vm.retrieveData = function(tableState) {
			
			var params = {}
			var pagination = tableState.pagination;
			
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.packageDataFull.length <= 0) {
				HttpSvc.get('serverpackages/list/billable', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.packageDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	

		vm.recalculateTotalFee = function() {
			vm.totalMonthlyFee = 0;
			vm.totalQuarterlyFee = 0;
			vm.totalAnnualFee = 0;
			vm.totalBiAnnualFee = 0;

			vm.actualTotalMonthlyFee = 0;
			vm.actualTotalQuarterlyFee = 0;
			vm.actualTotalAnnualFee = 0;
			vm.actualTotalBiAnnualFee = 0;

			vm.packageData.forEach(function(f) {
				vm.totalMonthlyFee += f.monthlyFee;
				vm.totalQuarterlyFee += f.quarterlyFee;
				vm.totalAnnualFee += f.annualFee;
				vm.totalBiAnnualFee += f.biAnnualFee;
				
				if(f.billingIntervalType==1)
				{
					vm.actualTotalMonthlyFee += f.monthlyFee;
				}
				else if(f.billingIntervalType==2)
				{
					vm.actualTotalQuarterlyFee += (f.quarterlyFee * 0.95);
				}
				else if(f.billingIntervalType==3)
				{
					vm.actualTotalAnnualFee += (f.annualFee * 0.9);
				}
				else if(f.billingIntervalType==4)
				{
					vm.actualTotalBiAnnualFee += (f.biAnnualFee * 0.9);
				}
			});
			
			vm.actualTotalAnnualFee += (vm.actualTotalBiAnnualFee / 2);

			vm.actualGrandTotal = 
				(vm.actualTotalMonthlyFee * 12) + 
				(vm.actualTotalQuarterlyFee * 4) + 
				vm.actualTotalAnnualFee + 
				(vm.actualTotalBiAnnualFee / 2);
		}			
	};
	
	/** @ngInject */
    function PackageSettingUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;

		vm.billingIntervalTypes = [
			{ id: 1, name: "MONTHLY" },
			{ id: 2, name: "QUARTERLY" },
			{ id: 3, name: "ANNUALLY" },
			{ id: 4, name: "BI-ANNUALLY" }
		];

		vm.mode = 2;
		vm.package = {};
		vm.package.isPublic = false;
		vm.package.isAddOn = false;
		vm.package.isTrial = false;
		vm.package.disableDiscount = false;
		vm.package.trialRecipeStepCount = -1;
		vm.selectedBillingIntervalType = null;
		vm.features = [];
		vm.selectedFeatures = [];
			
		vm.totalMonthlyFee = 0.0;
		vm.totalQuarterlyFee = 0.0;
		vm.totalAnnualFee = 0.0;
		vm.totalBiAnnualFee = 0.0;
		
		/* ********************************************************************************** */
		
		// Load Feature List
		vm.loadFeatureList = function() {
			HttpSvc.get('featuresV2', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.features = [];
					result.forEach(function (f) {
						if(f.state.indexOf('superadmin') < 0)
						{
							vm.features.push({ 
								featureId: f.id, 
								name: f.name, 
								state: f.state, 
								sequence: f.sequence, 
								isParent: f.isParent, 
								parentId: f.parentId 
							});
						}
					});
					vm.loadPackage();
				}, function() {
					return;
				});		
		}

		/* ********************************************************************************** */
				
		// Load Package
		vm.loadPackage = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('serverpackages/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.package = result;
					vm.billingIntervalTypes.forEach(function(b) {
						if(b.id==vm.package.billingIntervalType)
						{
							vm.selectedBillingIntervalType=b;
						}
					})

					vm.recalculateTotalFee();
				}, function() {
					toastr.error('Failed to load selected Package.', Auth.translate('ERROR'));
					$state.go('superadmin.serverpackages.list');
					return;
				});		
		};

		vm.loadPackageFees = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('serverpackagefees/list/:id', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.package.serverPackageFees = result;
					vm.recalculateTotalFee();
				}, function() {
					toastr.error('Failed to load selected Package.', Auth.translate('ERROR'));
					$state.go('superadmin.serverpackages.list');
					return;
				});		
		}

		vm.loadPackageLimiteds = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('serverpackagelimiteds/list/:id', params, Auth.getTokenId(), true)
				.then(function(result) {
					vm.package.serverPackageLimiteds = result;
				}, function() {
					toastr.error('Failed to load list of Limited User Types.', Auth.translate('ERROR'));
					$state.go('superadmin.serverpackages.list');
					return;
				});		
		}

		vm.recalculateTotalFee = function() {
			vm.totalMonthlyFee = 0;
			vm.totalQuarterlyFee = 0;
			vm.totalAnnualFee = 0;
			vm.totalBiAnnualFee = 0;
					
			vm.package.serverPackageFees.forEach(function(f) {
				vm.totalMonthlyFee += f.monthlyFee;
				vm.totalQuarterlyFee += f.quarterlyFee;
				vm.totalAnnualFee += f.annualFee;
				vm.totalBiAnnualFee += (f.annualFee * 2);
			});
		}
				
		/* ********************************************************************************** */

		vm.selectedBillingIntervalTypeChanged = function() 
		{
			vm.package.billingIntervalType = vm.selectedBillingIntervalType.id;
		}

		/* ********************************************************************************** */
					
		vm.showAddLimitedUserType = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'LimitedUserTypeModal.html',
				controller: 'PackageSettingLimitedUserTypeModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							object: {},
							packageId: vm.package.id,
							featureList: vm.features
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					vm.loadPackageLimiteds();
				}, function () {
				});
		};	
		
		vm.showEditLimitedUserType = function (id) {
			vm.pkgLimited;	
			vm.package.serverPackageLimiteds.forEach(function(p) {
				if(p.id==id) vm.pkgLimited = angular.copy(p);
			});
			
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'LimitedUserTypeModal.html',
				controller: 'PackageSettingLimitedUserTypeModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							object: vm.pkgLimited,
							packageId: vm.package.id,
							featureList: vm.features
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					vm.loadPackageLimiteds();
				}, function () {
				});
		};	

		vm.deleteLimitedUserType = function(id) {
			var params = { id: id };
			HttpSvc.delete('serverpackagelimiteds/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Limited User Type has been deleted.', 'Deleted');
					vm.loadPackageLimiteds();
				}, function() {
					// Failed
					toastr.error('Failed to delete the Limited User Type.', 'Delete Failed');
					return null;
				});
		};

		/* ********************************************************************************** */
		
		// Form Submission
		vm.submit = function() {	
			if(!vm.package.isTrial){
				vm.package.trialPeriod = 0;
			}
			
			vm.package.serverPackageLimitedAccesses = [];
			vm.selectedFeatures.forEach(function(f) {
				vm.package.serverPackageLimitedAccesses.push({ featureId: f.id });
			})
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('serverpackages/' + $stateParams.id, vm.package, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Package has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}

		/* ********************************************************************************** */
		
		// Call Actions
		vm.loadFeatureList();
	}	
	
	function PackageSettingLimitedUserTypeModalCtrl($uibModalInstance, item, Auth, HttpSvc, UtilSvc, toastr) {
		var $mdl = this;
		$mdl.item = item.object;
		$mdl.packageId = item.packageId;
		$mdl.featureList = item.featureList;
		$mdl.selectedFeatures = [];

		/* ********************************************************************************** */

		// Initialize
		if(item.mode==1) {
			$mdl.title = "Add New";
			$mdl.item.description = "";
		}
		else 
		{
			$mdl.title = "Update";
			$mdl.item.serverPackageLimitedAccesses.forEach(function(f) {
				$mdl.selectedFeatures.push({
					featureId: f.featureId, 
					name: f.name, 
					state: f.state, 
					sequence: f.sequence, 
					isParent: f.isParent, 
					parentId: f.parentId 
				});
			});
		}
		
		/* ********************************************************************************** */

		$mdl.applyTemplate_Outlet = function() {
			
			$mdl.item.description = "OUTLET WORKER";

			$mdl.featureList.forEach(function(f) {

				if(f.featureId=='03f58075-1a1c-440d-8a0a-5a26dacee1f9' ||
					f.featureId=='3ffbe37a-7e6c-46f3-a68c-d9c13afc032e' ||
					f.featureId=='774cd1ab-1559-44eb-a7d4-7eb4f261ace4' ||
					f.featureId=='fc5d10b5-02e1-4ea2-9b32-b2ea0ffe3da8' ||
					f.featureId=='af550b1d-7389-45ba-bf05-521c33000beb' ||
					f.featureId=='fc7f0fcf-2bfe-41a4-9d59-9224c978f388' ||
					f.featureId=='73186d8-d9a1-49b3-8eb9-56e6dc2989074' ||
					f.featureId=='02deffbf-b14a-4e21-b6fa-efa248d6873c' ||
					f.featureId=='c537ee6e-459e-43a4-888b-23334328a85e' ||
					f.featureId=='9f3ad82b-1a6f-4d08-a04f-749576d5b0bb' ||
					f.featureId=='4b3651db-38d2-4846-a9d6-072e9ab18386' ||
					f.featureId=='3f9f7562-8085-4ee2-bdfe-203a8db96a6b' ||
					f.featureId=='07d84c24-b7ae-4327-8513-db3d02eaee31' ||
					f.featureId=='ec3280d4-7776-42da-a778-d29ad942e568' ||
					f.featureId=='283d8d78-87c7-4177-8479-1bb39097d98d' ||
					f.featureId=='766715e1-e072-4dd3-9c11-344d9e751a90' ||
					f.featureId=='ce7eca2c-fccf-4d73-8a0b-6f8dfe6c0644' ||
					f.featureId=='7e716168-52c2-41d1-be0c-c9c2ced86f18' ||
					f.featureId=='3695fec7-fb8a-416f-a467-1da4771c9bc6')
				{
					$mdl.selectedFeatures.push({
						featureId: f.featureId, 
						name: f.name, 
						state: f.state, 
						sequence: f.sequence, 
						isParent: f.isParent, 
						parentId: f.parentId 
					});
				};

			});
		}
		
		/* ********************************************************************************** */
		
		$mdl.confirmModal = function() {
			if($mdl.limitedForm.$invalid) 
			{
				var errorMsg = UtilSvc.getErrorMessage($mdl.limitedForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			}
			else
			{
				$mdl.item.packageId = $mdl.packageId;
				$mdl.item.serverPackageLimitedAccesses = $mdl.selectedFeatures;

				if(item.mode==1)
				{
					HttpSvc.post('serverpackagelimiteds', $mdl.item, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Limited User Type has been created successfully.', Auth.translate('SUCCESS'));
							$uibModalInstance.close();
						}, function(error) {
							toastr.error(error, 'Failed');
						});
				} 
				else
				{
					HttpSvc.put('serverpackagelimiteds/' + $mdl.item.id, $mdl.item, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Limited User Type has been updated successfully.', Auth.translate('SUCCESS'));
							$uibModalInstance.close();
						}, function(error) {
							toastr.error(error, 'Failed');
						});
				}
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.siotdevices.controller', [])
        .controller('SASiotDeviceMainCtrl', SASiotDeviceMainCtrl)
        .controller('SASiotDeviceCreateCtrl', SASiotDeviceCreateCtrl)
        .controller('SASiotDeviceUpdateCtrl', SASiotDeviceUpdateCtrl);

    /** @ngInject */
    function SASiotDeviceMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 50;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.deviceDataFull = [];
		vm.deviceData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.deviceDataFull, tableState.search.predicateObject) : vm.deviceDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.deviceData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.deviceDataFull.length <= 0) {							
				HttpSvc.get('smartiot/devicemasters/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.deviceDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteDevice = function(deviceId, deviceName) {
			var params = {};
			HttpSvc.delete('smartiot/devicemasters/' + deviceId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('smartiot/devicemasters/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.deviceDataFull = result;
							
							toastr.success('The device [' + deviceName + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function(error) {
					// Failed
					toastr.error(error, 'Delete Failed');
					return null;
			});
		};			
	};
	
	/** @ngInject */
    function SASiotDeviceCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.siotdevice = {};	
		vm.siotdevice.isActive = true;
		vm.siotdevice.assignedGateways = [];
		vm.siotdevice.assignedSensors = [];
		vm.companies = [];
		vm.deviceTypeList = [];
		vm.deviceMetricUoms = null;
		vm.selectedCompany = null;
		vm.selectedDeviceType = null;
		vm.isProcessing = false;
		
		/* **************************************************************** */

		// Load Companies 
		vm.loadCompanyList = function() {
			vm.isProcessing = true;

			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companies = result;
					vm.loadDeviceTypeList();
				}, function(error) {
					vm.isProcessing = false;
					toastr.error('Failed to retrieve company list. ' + error, '');
					return null;
				});
		};

		// Load Device Types
		vm.loadDeviceTypeList = function() {
			HttpSvc.get('smartiot/devicetypes/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.deviceTypeList = result;
					vm.generateUUID();
				}, function(error) {	
					vm.isProcessing = false;
					toastr.error('Failed to retrieve Device Type list. ' + error, '');
					return null;
				});
		};

		vm.generateUUID = function() {
			HttpSvc.get('smartiot/devicemasters/generate/uuid', {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.siotdevice.deviceUUID = result.uuid;	
				}, function() {
					// Failed
					toastr.error('Failed to retrieve company list.', '');
					return null;
				});
		}

		/* **************************************************************** */

		// Select Company
		vm.selectedCompanyChanged = function() {
			vm.siotdevice.companyId = vm.selectedCompany.id;
		};

		// Select Device Type
		vm.selectedDeviceTypeChanged = function() {
			vm.siotdevice.deviceTypeId = vm.selectedDeviceType.id;
		};
		
		vm.clearCompany = function() {
			vm.selectedCompany = null;
			vm.siotdevice.companyId = null;
		}

		/* **************************************************************** */
				
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('smartiot/devicemasters', vm.siotdevice, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Device has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.siotdevices.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadCompanyList();
	}
	
	/** @ngInject */
    function SASiotDeviceUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.siotdevice = {};
		vm.companies = [];
		vm.deviceTypeList = [];
		vm.deviceMetricUoms = null;
		vm.selectedCompany = null;
		vm.selectedDeviceType = null;
		vm.isProcessing = false;

		/* **************************************************************** */

		// Load Companies 
		vm.loadCompanyList = function() {
			vm.isProcessing = true;

			HttpSvc.get('companies/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.companies = result;
					vm.loadDeviceTypeList();	
				}, function(error) {
					vm.isProcessing = false;
					toastr.error('Failed to retrieve company list. ' + error, '');
					return null;
				});
		};

		// Load Device Types
		vm.loadDeviceTypeList = function() {
			HttpSvc.get('smartiot/devicetypes/list', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.deviceTypeList = result;
					vm.loadDevice();
				}, function(error) {
					vm.isProcessing = false;
					toastr.error('Failed to retrieve Device Type list. ' + error, '');
					return null;
				});
		};
						
		// Load Device
		vm.loadDevice = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('smartiot/devicemasters/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.siotdevice = result;	
					
					vm.companies.forEach(function(c) {
						if(c.id==vm.siotdevice.companyId){
							vm.selectedCompany = c;
						}
					});

					vm.deviceTypeList.forEach(function(d) {
						if(d.id==vm.siotdevice.deviceTypeId){
							vm.selectedDeviceType = d;
						}
					});

					vm.isProcessing = false;
				}, function(error) {
					vm.isProcessing = false;
					toastr.error('Failed to load selected Device. ' + error, Auth.translate('ERROR'))
					$state.go('superadmin.siotdevices.list');
					return;
				});		
		};	

		/* **************************************************************** */

		vm.deleteGatewayAssignment = function(gwId, gwName) {
			
			vm.isProcessing = true;

			HttpSvc.post('smartiot/gateways/unlink/' + gwId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loadDevice();
				}, function() {
					vm.isProcessing = false;
					toastr.error('Failed to remove assignment of the gateway [' + gwName + '].', 'Removal Failed');
					return null;
			});
		}

		vm.deleteSensorAssignment = function(sensorId, sensorName) {
			
			vm.isProcessing = true;

			HttpSvc.post('smartiot/sensors/unlink/' + sensorId, {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.loadDevice();
				}, function() {
					vm.isProcessing = false;
					toastr.error('Failed to remove assignment of the sensor [' + sensorName + '].', 'Removal Failed');
					return null;
			});
		}

		/* **************************************************************** */

		// Select Company
		vm.selectedCompanyChanged = function() {
			vm.siotdevice.companyId = vm.selectedCompany.id;
		};

		// Select Device Type
		vm.selectedDeviceTypeChanged = function() {
			vm.siotdevice.deviceTypeId = vm.selectedDeviceType.id;
		};
		
		vm.clearCompany = function() {
			vm.selectedCompany = null;
			vm.siotdevice.companyId = null;
		}

		/* **************************************************************** */
		
		// Form Submission
		vm.submit = function() {	

			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');				
			} else {				
				vm.isProcessing = true;
				HttpSvc.put('smartiot/devicemasters/' + $stateParams.id, vm.siotdevice, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Device has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						vm.isProcessing = false;
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadCompanyList();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.systemsettings.controller', ['ngSanitize'])
        .controller('SystemUpdateCtrl', SystemUpdateCtrl);

	/** @ngInject */
    function SystemUpdateCtrl($scope, $state, Auth, HttpSvc, RmsApi, UtilSvc, toastr) {

		Auth.init();			
		
		var vm = this;
		vm.systemSettings = {};
		
		// Load System
		vm.loadSystemSettings = function() {			
			
			HttpSvc.get('systemsettings', {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.systemSettings = result;			
				}, function() {
					toastr.error('Failed to load System Settings.', Auth.translate('ERROR'));
					$state.go('dashboard');
					return;
				});		
		};	
		
		vm.submit = function() {	
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('systemsettings', vm.systemSettings, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('System Settings has been updated successfully.', Auth.translate('SUCCESS'));
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		};
		
		// Call Actions
		vm.loadSystemSettings();
	};	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.systemschedulersettings.controller', ['ngSanitize'])
        .controller('SystemSchedulerSettingUpdateCtrl', SystemSchedulerSettingUpdateCtrl);

	/** @ngInject */
    function SystemSchedulerSettingUpdateCtrl($scope, $state, Auth, HttpSvc, RmsApi, UtilSvc, toastr) {

		Auth.init();			
		
		var vm = this;

		vm.weekDays = [ 
			{id:'1', name:'Monday'},
			{id:'2', name:'Tuesday'},
			{id:'3', name:'Wednesday'},
			{id:'4', name:'Thurs'},
			{id:'5', name:'Friday'},
			{id:'6', name:'Saturday'},
			{id:'0', name:'Sunday'},
		]

		vm.setting = {};
		vm.selectedAssetWeekDays = [];
		vm.selectedCertWeekDays = [];
		
		// Load System Scheduler Setting
		vm.loadSetting = function() {			
			
			HttpSvc.get('systemschedulersettings', {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.setting = result;
					vm.selectedAssetWeekDays = vm.setting.assetMaintenanceReminderWeekDay.split(',');
					vm.selectedCertWeekDays = vm.setting.certificateExpiryReminderWeekDay.split(',');
				}, function() {
					toastr.error('Failed to load System Scheduler Settings.', Auth.translate('ERROR'));
					$state.go('dashboard');
					return;
				});		
		};	
		
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				vm.setting.assetMaintenanceReminderWeekDay = vm.selectedAssetWeekDays.join();
				vm.setting.certificateExpiryReminderWeekDay = vm.selectedCertWeekDays.join();

				HttpSvc.put('systemschedulersettings', vm.setting, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('System Scheduler Settings has been updated successfully.', Auth.translate('SUCCESS'));
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		};
		
		// Call Actions
		vm.loadSetting();
	};	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.systemversion.controller', ['ngSanitize'])
        .controller('SystemVersionUpdateCtrl', SystemVersionUpdateCtrl);

	/** @ngInject */
    function SystemVersionUpdateCtrl($scope, $state, Auth, HttpSvc, RmsApi, UtilSvc, toastr) {

		Auth.init();			
		
		var vm = this;
		vm.systemversion = {};
		
		// Load System
		vm.loadsystemversion = function() {			
			
			HttpSvc.get('SystemVersions/GetSystemVersion', {}, Auth.getTokenId(), false)
				.then(function(result) {
					vm.systemversion = result;			
				}, function() {
					toastr.error('Failed to load System Version.', Auth.translate('ERROR'));
					$state.go('dashboard');
					return;
				});		
		};	
		
		vm.submit = function() {	
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('SystemVersions/PutSystemVersion', vm.systemversion, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('System Version has been updated successfully.', Auth.translate('SUCCESS'));
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		};
		
		// Call Actions
		vm.loadsystemversion();
	};	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.users.controller', [])
        .controller('SAUserMainCtrl', SAUserMainCtrl)
        .controller('SAUserCreateCtrl', SAUserCreateCtrl)
        .controller('SAUserUpdateCtrl', SAUserUpdateCtrl);

    /** @ngInject */
    function SAUserMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.userDataFull = [];
		vm.userData = [];
		vm.companyList = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.userDataFull, tableState.search.predicateObject) : vm.userDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.userData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			// Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.userDataFull.length <= 0) {
				HttpSvc.get('users/all', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.userDataFull = [];
						result.forEach(function(u) {
							if(!u.isSuperAdmin) {
								vm.userDataFull.push(u);
							} else {
								if(Auth.isSuperAdmin()) {
									vm.userDataFull.push(u);
								}
							}
						});							
						vm.numOfRecord = vm.userDataFull.length;
						
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};
		
		vm.resetUserPwd = function(userEmail) {
			Auth.resetPwd(userEmail)
				.then(function() {				  
					toastr.success("An email which contains the new password has been sent!", 'Reset Successful');
				}, function() {
					toastr.error('Invalid email address.', 'Reset Failed');
				});
		};	
		
		vm.deleteUser = function(userId, username) {
			var params = {};
			HttpSvc.delete('users/' + userId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('users/all', params, Auth.getTokenId(), false)
						.then(function(result) {	
							vm.userDataFull = [];
							result.data.forEach(function(u) {
								if(!u.isSuperAdmin) {
									vm.userDataFull.push(u);
								} else {
									if(Auth.isSuperAdmin()) {
										vm.userDataFull.push(u);
									}
								}
							});							
							vm.numOfRecord = vm.userDataFull.length;
							
							toastr.success('The user [' + username + '] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the user.', 'Delete Failed');
					return null;
			});
		};			
	};
	
	/** @ngInject */
    function SAUserCreateCtrl($scope, $state, Auth, HttpSvc, UtilSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 1;
		vm.user = {};
		vm.user.userGroupId = '';
		vm.user.active = true;
		vm.branches = [];
		vm.selectedBranches = [];
		vm.usergroups = [];
		
		// Load Branches
		vm.loadBranches = function() {
			HttpSvc.get('branches/listall', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.branches.push({ company: u.company, id: u.id, name: u.name });
					});		
					vm.loadUsergroupList();
				}, function() {
					vm.branches = [];
				});
		};
		
		// Load Usergroup List
		vm.loadUsergroupList = function() {
			HttpSvc.get('usergroups/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.usergroups.push({ id: u.id, name: u.name });
					});		
				}, function() {
					vm.usergroups = [];
				});
		};
		
		// Generate Random Password
		vm.generatePassword = function() {
			if(vm.isRandomPassword) {
				vm.user.password = UtilSvc.generateRandomString(8);
				vm.user.password1 = vm.user.password;
			} else {
				vm.user.password = "";
				vm.user.password1 = "";
			}
		}
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				vm.user.userGroupId = vm.usergroups.selected.id;
				
				vm.user.branches = [];
				vm.selectedBranches.forEach( function(b) {
					vm.user.branches.push({ id: b.id });
				});
				
				HttpSvc.post('users/add', vm.user, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('User has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.users.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadBranches();
	}
	
	/** @ngInject */
    function SAUserUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, RmsApi, UtilSvc, Upload, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 2;
		vm.user = {};
		vm.user.userGroupId = '';
		vm.branches = [];
		vm.loadedBranches = [];		
		vm.selectedBranches = [];
		vm.usergroups = [];
		vm.fileToUpload = null;
		vm.serverMode = Auth.getServerMode();
		vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
		vm.user.signatureLocation = "";
		vm.user.oriSignatureLocation = "";
		
		// Load Branches		
		vm.loadBranches = function() {
			HttpSvc.get('branches/listall', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.branches.push({ company: u.company, id: u.id, name: u.name });
					});				
					vm.loadUser();
				}, function() {
					vm.branches = [];
				});
		};
		
		// Load Usergroup List
		vm.loadUsergroupList = function(usergroupId) {
			HttpSvc.get('usergroups/list/byusergroupid/' + usergroupId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.usergroups.push({ id: u.id, name: u.name });
					});	
										
					vm.usergroups.forEach(function(u) {
						if(u.id==vm.user.userGroupId){
							vm.usergroups.selected = u;
						}
					});	
				}, function() {
					vm.usergroups = [];
				});
		};
		
		vm.loadUser = function() {
			// Load User
			var params = { id: $stateParams.id };
			HttpSvc.get('users/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.user = result;
					
					result.branches.forEach(function (b) {
						vm.branches.forEach(function (c) {
							if(c.id==b.id) {
								vm.selectedBranches.push({ company: c.company, id: b.id, name: b.name });
							}
						});
					});			
					
					if(!vm.user.signatureLocation || vm.user.signatureLocation=='') {
						vm.user.signatureLocation = 'assets/img/empty_placeholder.png';
						vm.user.oriSignatureLocation = "";
					} else {
						vm.user.oriSignatureLocation = vm.user.signatureLocation;
						vm.user.signatureLocation = vm.rootUrl + vm.user.signatureLocation;
					}
									
					vm.loadUsergroupList(vm.user.userGroupId);
					
				}, function() {
					toastr.error('Failed to load selected User.', Auth.translate('ERROR'))
					$state.go('superadmin.users.list');
					return;
				});		
		};	
		
		// Generate Random Password
		vm.generatePassword = function() {
			if(vm.isRandomPassword) {
				vm.user.password = UtilSvc.generateRandomString(8);
				vm.user.password1 = vm.user.password;
			} else {
				vm.user.password = "";
				vm.user.password1 = "";
			}
		}
		
		// Form Submission
		var imgLocation = "";
		var azureStorageUrl = "";
		var localStorageUrl = "";

		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				imgLocation = "";
				azureStorageUrl = "";
				localStorageUrl = "";
				var newFilename = UtilSvc.generateGuid() + ".";
				
				if(vm.serverMode==1 && vm.fileToUpload) {
					/* CHECK STORAGE QUOTA */
					if(vm.lockUploadButton) {
						toastr.success('The Cloud Storage Quota has been exceeded. Please contact your administrator for more info.', 'Media Upload Error');
						return;
					}
					/* ******************* */
					
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = Auth.getCompanyId() + "/usersignature/" + newFilename + mediaExtension;
					
				} else if(vm.serverMode==0 && vm.fileToUpload) {	
				
					var extArray = vm.fileToUpload.name.split(".");
					var mediaExtension = extArray[extArray.length-1].toLowerCase();
					imgLocation = "usersignature/" + newFilename + mediaExtension;
					
				} else if(vm.user.oriSignatureLocation!="") {
					imgLocation = vm.user.oriSignatureLocation;
				}

				vm.user.signatureLocation = imgLocation;
				vm.user.userGroupId = vm.usergroups.selected.id;
				
				vm.user.branches = [];
				vm.selectedBranches.forEach( function(b) {
					vm.user.branches.push({ id: b.id });
				});
				
				HttpSvc.put('users/' + $stateParams.id, vm.user, Auth.getTokenId(), false)
					.then(function(result) {
						if(vm.serverMode==1 && vm.fileToUpload) {
							azureStorageUrl = RmsApi.BLOBURL + imgLocation + result.azureSasToken;
							vm.uploadImage(vm.serverMode);
							
						} else if(vm.serverMode==0 && vm.fileToUpload) {
							localStorageUrl = RmsApi.URL + "upload/usersignature/" + $stateParams.id;
							vm.uploadImage(vm.serverMode);
							
						} else {
							toastr.success('User has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						}
						
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Set Upload Image
		vm.setUploadImage = function(picFile) {
			vm.fileToUpload = picFile;
		}
		
		// Upload Image to Azure Blob Storage
		vm.uploadImage = function (serverMode) {
			var fileReader = new FileReader();
			
			if(serverMode==0) {	// Local Server
			
				Upload.upload({
					url: localStorageUrl,
					data: {file: vm.fileToUpload},
					headers: {'Authorization': 'basic ' + Auth.getTokenId() },
				}).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					toastr.success('User has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (resp) {
					toastr.success('User has been updated successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
				
			} else if(serverMode==1) { // Azure Server
			
				fileReader.readAsArrayBuffer(vm.fileToUpload);
				fileReader.onload = function(e) {
					Upload.http({
						method: "PUT",
						url: azureStorageUrl,
						headers: {
						   'x-ms-blob-type': 'BlockBlob',
						   'x-ms-blob-content-type': vm.fileToUpload.type
						},
						data: e.target.result
					}).then(function(response) {
						if (response.status==201) {
							toastr.success('User has been updated successfully.', Auth.translate('SUCCESS'));
							$state.reload();
						} else {
							toastr.error(response.status + ': ' + response.data, 'Upload Failed');
						} 
					}, null, function(evt) {
						//imgFile.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
			}
		};

		/* ********************************************* */
		
		// Call Actions
		vm.loadBranches();		
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.wcsimulator.simulations.controller', [])
			.controller('WcSimulationMainCtrl', WcSimulationMainCtrl)
			.controller('WcSimulationCreateCtrl', WcSimulationCreateCtrl)
			.controller('WcSimulationUpdateCtrl', WcSimulationUpdateCtrl);

    /** @ngInject */
    function WcSimulationMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.simDataFull = [];
		vm.simData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.simDataFull, tableState.search.predicateObject) : vm.simDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.simData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.simDataFull.length <= 0) {				
				HttpSvc.get('weightcheckersimulation/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.simDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	

		// Delete Product		
		vm.deletePosProduct = function(id, name) {
			var params = {};
			HttpSvc.delete('posproducts/' + id, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('iotsensors/list', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.simDataFull = result;
							
							toastr.success('The POS Product [<b>' + name + '</b>] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function(error) {
					// Failed
					toastr.error(error, 'Delete Failed');
					return null;
			});
		};		
	};
	
	/** @ngInject */
    function WcSimulationCreateCtrl($scope, $state, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.sim = {};
		vm.uomList = [];
		vm.selectedUom = null;

		/* ******************************************************************* */

		// Init Data
		vm.initData = function() {
			vm.sim.status = 'NEW';
			vm.loadUomList();
		};
		
		// Load UOM List
		vm.loadUomList = function() {
			HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
				}, function() {
					toastr.error('Failed to retrieve UOM list.', '');
				});
		};	
		
		/* ******************************************************************* */

		vm.selectedUomChanged = function() {
			vm.sim.uomId = vm.selectedUom.id;
		};
		
		/* ******************************************************************* */

		// Form Submission		
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			} else {						
				HttpSvc.post('weightcheckersimulation', vm.sim, Auth.getTokenId(), false)
					.then(function(result) {										
						toastr.success('Simulation has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('wcsimulator.simulations.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		};
		
		// Call Actions
		vm.initData();
	}
	
	/** @ngInject */
    function WcSimulationUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, RmsApi, Upload, UtilSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.sim = {};
		vm.uomList = [];
		vm.selectedUom = null;
		
		/* ******************************************************************* */

		// Init Data
		vm.initData = function() {
			vm.sim.status = 'NEW';
			vm.loadUomList();
		};
		
		// Load UOM List
		vm.loadUomList = function() {
			HttpSvc.get('uoms/all', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.uomList = result;
					vm.loadSimulation();
				}, function() {
					toastr.error('Failed to retrieve UOM list.', '');
				});
		};
		
		// Load Simulation
		vm.loadSimulation = function() {
			HttpSvc.get('weightcheckersimulation/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.sim = result;

					vm.uomList.forEach(function(u) {
						if(u.id==vm.sim.uomId)
						{
							vm.selectedUom = u;
						}
					});
				}, function() {
					toastr.error('Failed to retrieve Simulation data.', '');
				});
		};
		
		/* ******************************************************************* */

		vm.selectedUomChanged = function() {
			vm.sim.uomId = vm.selectedUom.id;
		};
		
		/* ******************************************************************* */
		
		vm.confirmSimulation = function() {
			HttpSvc.post('weightcheckersimulation/confirm/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {										
					toastr.success('Simulation status has been update to CONFIRMED.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
				});
		}

		// Form Submission		
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				var errorMsg = UtilSvc.getErrorMessage(vm.dataForm);
				toastr.error(errorMsg, Auth.translate('ERROR'));
			} else {						
				HttpSvc.put('weightcheckersimulation', vm.sim, Auth.getTokenId(), false)
					.then(function(result) {										
						toastr.success('Simulation has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		};
		
		// Call Actions
		vm.initData();
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.superadmin.uoms.controller', [])
        .controller('UomMainCtrl', UomMainCtrl)
        .controller('UomCreateCtrl', UomCreateCtrl)
        .controller('UomUpdateCtrl', UomUpdateCtrl);

    /** @ngInject */
    function UomMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.uomDataFull = [];
		vm.uomData = [];

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.uomDataFull, tableState.search.predicateObject) : vm.uomDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.uomData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.uomDataFull.length <= 0) {							
				HttpSvc.get('uoms/all', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.uomDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
					}, function() {
						// Failed
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteUom = function(uomId, uomName) {
			var params = {};
			HttpSvc.delete('uoms/' + uomId, params, Auth.getTokenId(), false)
				.then(function(result) {
					HttpSvc.get('uoms/all', params, Auth.getTokenId(), true)
						.then(function(result) {	
							vm.numOfRecord = result.length;
							vm.uomDataFull = result;
							
							toastr.success('The U.O.M. [<b>' + uomName + '</b>] has been deleted.', 'Delete Success');
							$scope.$broadcast('refreshStTable');
						}, function() {
							// Failed
							toastr.error('Failed to retrieve data.', '');
							return null;
					});
				}, function() {
					// Failed
					toastr.error('Failed to delete the U.O.M. [' + uomName + '].', 'Delete Failed');
					return null;
			});
		};			
	};
	
	/** @ngInject */
    function UomCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 1;
		vm.uom = {};
				
		// Form Submission
		vm.submit = function() {
			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('uoms/add', vm.uom, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('U.O.M. has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.uoms.list');
					}, function(error) {
						toastr.error(angular.toJson(error), 'Failed');
					});
			}
		}
		
		// Call Actions
		// None
	}
	
	/** @ngInject */
    function UomUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;
		vm.submitted = false;
		vm.mode = 2;
		vm.uom = {};
				
		// Load Uom
		vm.loadUom = function() {			
			var params = { id: $stateParams.id };
			HttpSvc.get('uoms/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.uom = result;				
				}, function() {
					toastr.error('Failed to load selected U.O.M.', Auth.translate('ERROR'))
					$state.go('superadmin.uoms.list');
					return;
				});		
		};	
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {				
				HttpSvc.put('uoms/' + $stateParams.id, vm.uom, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('U.O.M. has been updated successfully.', Auth.translate('SUCCESS'));
						$state.go('superadmin.uoms.list');
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadUom();
	}
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.withdrawalrequests.wrlist.controller', [])
        .controller('WithdrawalRequestMainCtrl', WithdrawalRequestMainCtrl)
        .controller('WithdrawalRequestCreateCtrl', WithdrawalRequestCreateCtrl)
        .controller('WithdrawalRequestUpdateCtrl', WithdrawalRequestUpdateCtrl)
        .controller('WithdrawalRequestSelectJobModalCtrl', WithdrawalRequestSelectJobModalCtrl);

    /** @ngInject */
    function WithdrawalRequestMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {
		
		Auth.init();
		
		var vm = this;
		
		vm.statusList = [ 
			{id: 'NEW', name: 'NEW'}, 
			{id: 'CONFIRMED', name: 'CONFIRMED'},
			{id: 'APPROVED',  name: 'APPROVED'},
			{id: 'DELIVERED', name: 'DELIVERED'},
			{id: 'RECEIVED',  name: 'RECEIVED'},
			{id: 'CANCELLED', name: 'CANCELLED'},
		];
		
		vm.typeList = [
			{id: 'RM', name: 'RAW MATERIAL'}, 
			{id: 'SFG', name: 'SEMI F.G.'}, 
			{id: 'FG', name: 'FINISHED GOOD'},
		];

		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.dataFull = [];
		vm.isLoading = false;

		vm.getApiParams = function(tableState) 
		{
			if(tableState.search.predicateObject==null)
			{
				tableState.sort = {};
				tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
			}
			
			var predicate = tableState.search.predicateObject;
			var sortBy = tableState.sort.predicate;
			var sortReverse = tableState.sort.reverse ? "1" : "0";

			var params = {
				keyword:  predicate.withdrawalNo,
				jobNo: predicate.jobNo,
				withdrawalType: predicate.withdrawalType,
				branchName: predicate.branchName,
				departmentName: predicate.departmentName,
				createdBy: predicate.createdBy,
				status: predicate.status,
				sortBy: sortBy,
				sortReverse: sortReverse,
				pageSize: vm.pageSize,
				pageNumber: Math.ceil((vm.startIndex + 1) / vm.pageSize)
			};

			return params;
		}

		vm.retrieveData = function(tableState) {

			var pagination = tableState.pagination;
			
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			vm.isLoading = true;

			var params = vm.getApiParams(tableState);

			HttpSvc.post('withdrawalrequests/lazyload/list', params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.isLoading = false;		
					vm.data = result.data;
					vm.numOfRecord = result.numberOfRecords;	
					vm.numOfPages = result.numberOfPages;	
					refreshTableState(tableState, vm.startIndex, vm.endIndex);
				}, function(error) {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
			});
		};	

		function refreshTableState(tableState) {
			tableState.pagination.numberOfPages = vm.numOfPages;		
			return tableState;
		};

		vm.resetSearch = function() 
		{
		}		
		
		vm.printWR = function(wrId, wrNo) {
			
			var filename = "WR_" + wrNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('withdrawalrequests/print/' + wrId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to generate Withdrawal Request Form. ' + error, '');
							return null;
						});
		}
	};
	
	/** @ngInject */
    function WithdrawalRequestCreateCtrl($scope, $state, $filter, $location, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.hasFgAccess = Auth.hasCompanyFeature('maintenance.products');
		vm.hasSemiFgAccess = Auth.hasCompanyFeature('maintenance.semifgs');
		
		vm.wrStatuses = [ 
			{id: 'NEW', name: 'NEW'}, 
			{id: 'CONFIRMED', name: 'CONFIRMED'},
		];
		
		vm.wrTypes = [ 
			{id: 'RM', name: 'RAW MATERIAL'}
		];
		if(vm.hasFgAccess){
			vm.wrTypes.push({id: 'FG', name: 'FINISHED GOODS'});
		}
		if(vm.hasSemiFgAccess){
			vm.wrTypes.push({id: 'SFG', name: 'SEMI F.G.'});
		}
		
		vm.mode = 1;
		vm.originalStatus = 'NEW';
		
		vm.wr = {};
		vm.wr.withdrawalRequestItems = [];
		vm.selectedType = null;
		vm.selectedStatus = null;
		vm.searchResults = [];
		vm.departments = [];
		vm.searchText = "";
		vm.lockButtons = false;
		vm.isLoading = false;
		
		// Set Default Job Date
		vm.setDefault = function() {
			vm.wrStatuses.selected = {id: 'NEW', name: 'NEW'};
			vm.wr.withdrawalDate = $filter('date')(new Date(), 'yyyy-MM-dd');
			vm.wr.status = "NEW";
			vm.wr.remarks = "";
			vm.lockButtons = false;
			
			vm.loadDepartments();
		};

		// Select Type
		vm.selectType = function() {
			vm.wr.withdrawalType = vm.selectedType.id;
			vm.searchText = "";
			vm.searchResults = [];
		};

		// Select Status
		vm.selectStatus = function() {
			vm.wr.status = vm.selectedStatus.id;
		};

		// Select Department
		vm.selectDepartment = function() {
			vm.wr.departmentId = vm.selectedDepartment.id;
		};
		
		vm.searchRawMat = function(searchString) {
			if(searchString.length<3) {
				vm.searchResults = [];
				return;	
			}
			
			vm.lockButtons = true;
			vm.isLoading = true;
			
			HttpSvc.get('withdrawalrequests/list/items/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.searchResults = result;
					vm.lockButtons = false;
					vm.isLoading = false;
				}, function(error) {
					vm.lockButtons = false;
					vm.isLoading = false;
					toastr.error(error, 'Failed');
				});
		};
		
		vm.searchFG = function(searchString) {
			if(searchString.length<3) {
				vm.searchResults = [];
				return;	
			}
			
			vm.lockButtons = true;
			
			HttpSvc.get('withdrawalrequests/list/fg/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.searchResults = result;
					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		};
		
		vm.searchSFG = function(searchString) {
			if(searchString.length<3) {
				vm.searchResults = [];
				return;	
			}
			
			vm.lockButtons = true;
			
			HttpSvc.get('withdrawalrequests/list/sfg/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.searchResults = result;
					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		};
		
		// Load Departments
		vm.loadDepartments = function() {
			HttpSvc.get('departments/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.departments.push({ id: u.id, name: u.name });
					});	
				}, function() {
					vm.departments = [];
				});
		};
		
		
		/* **************************************************** */
		
		vm.addItem = function(item) {
			if(!item.quantity) {
				toastr.error(item.description + ' - Quantity entered is invalid.', Auth.translate('ERROR'));
				return;
			} else if (item.quantity<=0) {
				toastr.error(item.description + ' - Quantity cannot be zero.', Auth.translate('ERROR'));
				return;				
			}
			
			var isFound = false;
			vm.wr.withdrawalRequestItems.forEach(function(w) {
				if(w.itemId==item.id) {
					w.quantity += item.quantity;
					isFound = true;
					return;
				}
			});
			
			if(isFound==false){
				vm.wr.withdrawalRequestItems.push({
					itemId: item.id,
					code: item.code,
					description: item.description,
					quantity: item.quantity,
					unitOfMeasurementId: item.uomId,
					uomName: item.uomName,
					remarks: '',
				});					
			}

			vm.searchText = '';
			vm.searchResults = [];
		};
				
		vm.addFG = function(item) {
			if(!item.quantity) {
				toastr.error(item.description + ' - Quantity entered is invalid.', Auth.translate('ERROR'));
				return;
			} else if (item.quantity<=0) {
				toastr.error(item.description + ' - Quantity cannot be zero.', Auth.translate('ERROR'));
				return;				
			}
			
			var isFound = false;
			vm.wr.withdrawalRequestItems.forEach(function(w) {
				if(w.productId==item.id) {
					w.quantity += item.quantity;
					isFound = true;
					return;
				}
			});
			
			if(isFound==false){
				vm.wr.withdrawalRequestItems.push({
					productId: item.id,
					code: item.code,
					description: item.description,
					quantity: item.quantity,
					unitOfMeasurementId: item.uomId,
					uomName: item.uomName,
					remarks: '',
				});					
			}

			vm.searchText = '';
			vm.searchResults = [];
		};
				
		vm.addSFG = function(item) {
			if(!item.quantity) {
				toastr.error(item.description + ' - Quantity entered is invalid.', Auth.translate('ERROR'));
				return;
			} else if (item.quantity<=0) {
				toastr.error(item.description + ' - Quantity cannot be zero.', Auth.translate('ERROR'));
				return;				
			}
			
			var isFound = false;
			vm.wr.withdrawalRequestItems.forEach(function(w) {
				if(w.semiFinishedProductId==item.id) {
					w.quantity += item.quantity;
					isFound = true;
					return;
				}
			});
			
			if(isFound==false){
				vm.wr.withdrawalRequestItems.push({
					semiFinishedProductId: item.id,
					code: item.code,
					description: item.description,
					quantity: item.quantity,
					unitOfMeasurementId: item.uomId,
					uomName: item.uomName,
					remarks: '',
				});					
			}

			vm.searchText = '';
			vm.searchResults = [];
		};
		
		vm.removeItem = function(item) { 
			if(confirm('Confirm remove this item?')) {
				var index = vm.wr.withdrawalRequestItems.indexOf(item);
				vm.wr.withdrawalRequestItems.splice(index, 1); 				
			}
		}
		
		/* ************************************************************ */
		
		vm.clearSelectJob = function () {
			vm.wr.jobId = null;
			vm.wr.jobNo = null;
		}

		vm.showSelectJobModal = function () {
			vm.item = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'JobListModal.html',
				controller: 'WithdrawalRequestSelectJobModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.populateSelectedJob(data);
				}, function () {
				});
		};		
		
		vm.populateSelectedJob = function(data) 
		{
			vm.wr.jobId = data.jobId;
			vm.wr.jobNo = data.jobNo;
		};
		
		/* ************************************************************ */
		
		// Form Submission
		vm.submit = function() {
									
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {		
				HttpSvc.post('withdrawalrequests', vm.wr, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Withdrawal Request created successfully.', Auth.translate('SUCCESS'));
						$location.path("/withdrawalrequests/wrlist/update/"+result.id);
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.setDefault();
	}
	
	/** @ngInject */
    function WithdrawalRequestUpdateCtrl($scope, $state, $stateParams, $filter, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();
		
		var vm = this;
		vm.hasFgAccess = Auth.hasCompanyFeature('maintenance.products');
		vm.hasSemiFgAccess = Auth.hasCompanyFeature('maintenance.semifgs');
		
		vm.wrStatuses = [ 
			{id: 'NEW', name: 'NEW'}, 
			{id: 'CONFIRMED', name: 'CONFIRMED'},
		];
		
		vm.wrTypes = [ 
			{id: 'RM', name: 'RAW MATERIAL'}
		];
		if(vm.hasFgAccess){
			vm.wrTypes.push({id: 'FG', name: 'FINISHED GOODS'});
		}
		if(vm.hasSemiFgAccess){
			vm.wrTypes.push({id: 'SFG', name: 'SEMI F.G.'});
		}
		
		vm.mode = 2;
		vm.originalStatus = 'NEW';
		
		vm.wr = {};
		vm.wr.withdrawalRequestItems = [];
		vm.selectedType = null;
		vm.selectedStatus = null;
		vm.searchResults = [];
		vm.departments = [];
		vm.searchText = "";
		vm.lockButtons = false;
		vm.hasApprovedAccess = Auth.hasPerm("withdrawalrequests.wrlist", "APPROVE");
		vm.isProcessing = false;
				
		/* ************************************************************** */

		vm.getWithdrawalType = function() {
			if(vm.wr.withdrawalType=="RM") {
				return "RAW MATERIAL";
			} else if(vm.wr.withdrawalType=="FG") {
				return "FINISHED GOODS";
			} else if(vm.wr.withdrawalType=="SFG") {
				return "SEMI FINISHED GOODS";
			}
		}

		// Select Type
		vm.selectType = function() {
			vm.wr.withdrawalType = vm.selectedType.id;
			vm.searchText = "";
			vm.searchResults = [];
		};

		// Select Status
		vm.selectStatus = function() {
			vm.wr.status = vm.selectedStatus.id;
		};

		// Select Department
		vm.selectDepartment = function() {
			vm.wr.departmentId = vm.selectedDepartment.id;
		};
		
		vm.searchRawMat = function(searchString) {
			if(searchString.length<3) {
				vm.searchResults = [];
				return;	
			}
			
			vm.lockButtons = true;
			
			HttpSvc.get('withdrawalrequests/list/items/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.searchResults = result;
					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		};
		
		vm.searchFG = function(searchString) {
			if(searchString.length<3) {
				vm.searchResults = [];
				return;	
			}
			
			vm.lockButtons = true;
			
			HttpSvc.get('withdrawalrequests/list/fg/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.searchResults = result;
					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		};
		
		vm.searchSFG = function(searchString) {
			if(searchString.length<3) {
				vm.searchResults = [];
				return;	
			}
			
			vm.lockButtons = true;
			
			HttpSvc.get('withdrawalrequests/list/sfg/' + searchString, {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.searchResults = result;
					vm.lockButtons = false;
				}, function(error) {
					vm.lockButtons = false;
					toastr.error(error, 'Failed');
				});
		};
		
		// Load Departments
		vm.loadDepartments = function() {
			HttpSvc.get('departments/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					result.forEach(function (u) {
						vm.departments.push({ id: u.id, name: u.name });
					});	
					vm.loadWR();
				}, function() {
					vm.departments = [];
				});
		};
				
		/* ************************************************************** */
		
		vm.addItem = function(item) {
			if(!item.quantity) {
				toastr.error('<b>' + item.description + '</b> - Quantity entered is invalid.', Auth.translate('ERROR'));
				return;
			} else if (item.quantity<=0) {
				toastr.error('<b>' + item.description + '</b> - Quantity cannot be zero.', Auth.translate('ERROR'));
				return;				
			}
			
			var isFound = false;
			vm.wr.withdrawalRequestItems.forEach(function(w) {
				if(w.itemId==item.id) {
					w.quantity += item.quantity;
					isFound = true;
					return;
				}
			});
			
			if(isFound==false){
				vm.wr.withdrawalRequestItems.push({
					itemId: item.id,
					code: item.code,
					description: item.description,
					quantity: item.quantity,
					unitOfMeasurementId: item.uomId,
					uomName: item.uomName,
					remarks: '',
				});					
			}

			vm.searchText = '';
			vm.searchResults = [];
		};
				
		vm.addFG = function(item) {
			if(!item.quantity) {
				toastr.error(item.description + ' - Quantity entered is invalid.', Auth.translate('ERROR'));
				return;
			} else if (item.quantity<=0) {
				toastr.error(item.description + ' - Quantity cannot be zero.', Auth.translate('ERROR'));
				return;				
			}
			
			var isFound = false;
			vm.wr.withdrawalRequestItems.forEach(function(w) {
				if(w.productId==item.id) {
					w.quantity += item.quantity;
					isFound = true;
					return;
				}
			});
			
			if(isFound==false){
				vm.wr.withdrawalRequestItems.push({
					productId: item.id,
					code: item.code,
					description: item.description,
					quantity: item.quantity,
					unitOfMeasurementId: item.uomId,
					uomName: item.uomName,
					remarks: '',
				});					
			}

			vm.searchText = '';
			vm.searchResults = [];
		};
				
		vm.addSFG = function(item) {
			if(!item.quantity) {
				toastr.error(item.description + ' - Quantity entered is invalid.', Auth.translate('ERROR'));
				return;
			} else if (item.quantity<=0) {
				toastr.error(item.description + ' - Quantity cannot be zero.', Auth.translate('ERROR'));
				return;				
			}
			
			var isFound = false;
			vm.wr.withdrawalRequestItems.forEach(function(w) {
				if(w.semiFinishedProductId==item.id) {
					w.quantity += item.quantity;
					isFound = true;
					return;
				}
			});
			
			if(isFound==false){
				vm.wr.withdrawalRequestItems.push({
					semiFinishedProductId: item.id,
					code: item.code,
					description: item.description,
					quantity: item.quantity,
					unitOfMeasurementId: item.uomId,
					uomName: item.uomName,
					remarks: '',
				});					
			}

			vm.searchText = '';
			vm.searchResults = [];
		};
		
		vm.removeItem = function(item) { 
			if(confirm('Confirm remove this item?')) {
				var index = vm.wr.withdrawalRequestItems.indexOf(item);
				vm.wr.withdrawalRequestItems.splice(index, 1); 				
			}
		}
		
		/* ************************************************************ */
		
		vm.clearSelectJob = function () {
			vm.wr.jobId = null;
			vm.wr.jobNo = null;
		}

		vm.showSelectJobModal = function () {
			vm.item = {};
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'JobListModal.html',
				controller: 'WithdrawalRequestSelectJobModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
			});

			modalInstance
				.result
				.then(function (data) {
					vm.populateSelectedJob(data);
				}, function () {
				});
		};		
		
		vm.populateSelectedJob = function(data) 
		{
			vm.wr.jobId = data.jobId;
			vm.wr.jobNo = data.jobNo;
		};
		
		/* ************************************************************ */
		
		vm.approveWR = function() {
			vm.lockButtons = true;
			vm.isProcessing = true;
		
			HttpSvc.put('withdrawalrequests/approve/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Withdrawal Request has been approved successfully.', Auth.translate('SUCCESS'));
					$state.reload();
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
					vm.isProcessing = false;
				});
		};
		
		vm.deliverWR = function() {
			vm.lockButtons = true;
		
			HttpSvc.put('withdrawalrequests/deliver/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Withdrawal Request has been marked as DELIVERED successfully.', Auth.translate('SUCCESS'));
					$state.go('withdrawalrequests.wrlist');
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		};
		
		vm.receiveWR = function() {
			vm.lockButtons = true;
		
			HttpSvc.put('withdrawalrequests/receive/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Withdrawal Request has been marked as RECEIVED successfully.', Auth.translate('SUCCESS'));
					$state.go('withdrawalrequests.wrlist');
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		};
		
		vm.cancelWR = function() {
			vm.lockButtons = true;
		
			HttpSvc.put('withdrawalrequests/cancel/' + $stateParams.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					toastr.success('Withdrawal Request has been cancelled.');
					$state.go('withdrawalrequests.wrlist');					
				}, function(error) {
					toastr.error(error, 'Failed');
					vm.lockButtons = false;
				});
		};
		
		/* ************************************************************** */
				
		// Load Withdrawal Request
		vm.loadWR = function() {
			var params = { id: $stateParams.id };
			HttpSvc.get('withdrawalrequests/:id', params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.wr = result;
					vm.wr.withdrawalDate = $filter('date')(vm.wr.withdrawalDate, 'yyyy-MM-dd');
					vm.originalStatus = vm.wr.status;
					
					vm.wrTypes.forEach(function(t) {
						if(t.id==vm.wr.withdrawalType){
							vm.selectedType = t;
						}
					});
					vm.wrStatuses.forEach(function(s) {
						if(s.id==vm.wr.status){
							vm.selectedStatus = s;
						}
					});
					vm.departments.forEach(function(d) {
						if(d.id==vm.wr.departmentId){
							vm.selectedDepartment = d;							
						}
					});
					vm.originalStatus = vm.wr.status;
				}, function() {
					toastr.error('Failed to load selected Withdrawal Request.', Auth.translate('ERROR'))
					$state.go('withdrawalrequests.wrlist');
					return;
				});		
		};	
		
		// Print Withdrawal Request		
		vm.printWR = function(wrId, wrNo) {
			
			var filename = "WR_" + wrNo.replace("/", "_") + ".pdf";
			
			HttpSvc.getPdfObject('withdrawalrequests/print/' + wrId, Auth.getTokenId(), filename)
				.then(
						null, 
						function(error) {
							// Failed
							toastr.error('Failed to generate Withdrawal Request PDF. ' + error, '');
							return null;
						});
		}
		
		/* ************************************************************** */
		
		// Form Submission
		vm.submit = function() {			
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {					
				HttpSvc.put('withdrawalrequests/' + $stateParams.id, vm.wr, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Withdrawal Request updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadDepartments();	
	}
	
	/** @ngInject */
	function WithdrawalRequestSelectJobModalCtrl($uibModalInstance, $filter, $sce, Auth, RmsApi, HttpSvc, UtilSvc, Upload, toastr) {
		var $mdl = this;
		
		$mdl.pageSize = 10;
		$mdl.numOfRecord = 0;
		$mdl.numOfRecordFiltered = 0;
		$mdl.numOfRecordDisplayed = 0;
		$mdl.startIndex = 0; 
		$mdl.endIndex = 0;
		$mdl.jobDataFull = [];
		$mdl.jobData = [];
		$mdl.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')($mdl.jobDataFull, tableState.search.predicateObject) : $mdl.jobDataFull;
			$mdl.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			$mdl.numOfRecordDisplayed = $mdl.numOfRecordFiltered < $mdl.numOfRecord ? $mdl.numOfRecordFiltered : $mdl.numOfRecord;
			$mdl.jobData = result;
			
			tableState.pagination.numberOfPages = Math.ceil($mdl.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		$mdl.retrieveData = function(tableState) {		
			
			var pagination = tableState.pagination;
			$mdl.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			$mdl.endIndex = pagination.number || $mdl.pageSize; // Number of entries showed per page.
			
			if($mdl.jobDataFull.length <= 0) {
				$mdl.isLoading = true;
				
				HttpSvc.get('withdrawalrequests/list/jobproduction', {}, Auth.getTokenId(), true)
					.then(function(result) {	
						$mdl.numOfRecord = result.length;	
						$mdl.jobDataFull = result;		
						refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
						$mdl.isLoading = false;
					}, function() {
						$mdl.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, $mdl.startIndex, $mdl.endIndex);
			}
		};		
		
		// ********************************************************		
		
		$mdl.selectJob = function(item) {
			var result = {
				jobId: item.id,
				jobNo: item.jobNo,
			}
			$uibModalInstance.close(result);
		}

		// Cancel Action
		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	};

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('RmsAppV2.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        //var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' ' + (attrs.baPanelClass || '');
        //res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += '"' + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('RmsAppV2.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('RmsAppV2.theme.components')
		.controller('BaSidebarCtrl', BaSidebarCtrl);

	/** @ngInject */
	function BaSidebarCtrl($rootScope, $scope, $state, baSidebarService, Auth, toastr) {
		
		Auth.init();
		
		var ba = this;
		
		ba.hoverItem = function ($event) {
			ba.showHoverElem = true;
			ba.hoverElemHeight =  $event.currentTarget.clientHeight;
			var menuTopValue = 66;
			ba.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
		};

		$scope.$on('$stateChangeSuccess', function () {
			ba.menuItems = baSidebarService.getAuthorizedMenuItems(Auth);
			
			if (baSidebarService.canSidebarBeHidden()) {
				baSidebarService.setMenuCollapsed(true);
			}
		});
		
		//ba.menuItems = baSidebarService.getMenuItems();
		ba.menuItems = baSidebarService.getAuthorizedMenuItems(Auth);		
					
		if(!ba.menuItems) return;
		
		if(ba.menuItems.length>0)
			ba.defaultSidebarState = ba.menuItems[0].stateRef;
	}
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
	'use strict';

	angular.module('RmsAppV2.theme.components')
		.directive('baSidebar', baSidebar);

	/** @ngInject */
	function baSidebar($timeout, $window, baSidebarService, baUtil, layoutSizes, toastr) {
		var jqWindow = $(window);
		return {
			restrict: 'E',
			templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
			controller: 'BaSidebarCtrl',
			controllerAs: 'ba',
			link: function(scope, el) {
				
				//scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
				scope.menuHeight = $window.innerHeight - 84;
				jqWindow.on('click', _onWindowClick);
				jqWindow.on('resize', _onWindowResize);

				scope.$on('$destroy', function() {
					jqWindow.off('click', _onWindowClick);
					jqWindow.off('resize', _onWindowResize);
				});

				function _onWindowClick($evt) {
					if (!baUtil.isDescendant(el[0], $evt.target) &&
						!$evt.originalEvent.$sidebarEventProcessed &&
						!baSidebarService.isMenuCollapsed() &&
						baSidebarService.canSidebarBeHidden()) {
						$evt.originalEvent.$sidebarEventProcessed = true;
						$timeout(function () {
						baSidebarService.setMenuCollapsed(true);
					}, 10);
				  }
				}

				// watch window resize to change menu collapsed state if needed
				function _onWindowResize() {
					var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
					var newMenuHeight = _calculateMenuHeight();
					if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
						scope.$apply(function () {
							scope.menuHeight = newMenuHeight;
							baSidebarService.setMenuCollapsed(newMenuCollapsed)
						});
					}
				}

				function _calculateMenuHeight() {
					return el[0].childNodes[0].clientHeight - 84;
				}
			}
		};
	}
})();
(function() {
	'use strict';

	angular.module('RmsAppV2.theme.components')
		.provider('baSidebarService', baSidebarServiceProvider);

	/** @ngInject */
	function baSidebarServiceProvider() {
		var staticMenuItems = [];

		this.addStaticItem = function() {
			staticMenuItems.push.apply(staticMenuItems, arguments);
		};

		/** @ngInject */
		this.$get = function($state, layoutSizes) {
			return new _factory();

			function _factory() {				
				var isMenuCollapsed = shouldMenuBeCollapsed();

				this.getMenuItems = function() {
					var states = defineMenuItemStates();
					var menuItems = states.filter(function(item) {
						return item.level == 0;
					});

					menuItems.forEach(function(item) {
						var children = states.filter(function(child) {
							return child.level == 1 && child.name.indexOf(item.name) === 0;
						});
						item.subMenu = children.length ? children : null;
					});

					return menuItems.concat(staticMenuItems);
				};
		
				// Added 23.02.2016 for Access Control
				this.getAuthorizedMenuItems = function(Auth) {
					
					if(!Auth.isLoggedIn())
						return null;
					
					var states = defineMenuItemStates();
					var menuItems = states.filter(function(item) {
						return item.level == 0 && Auth.hasPerm(item.stateRef, 'ACCESS');
					});										
					
					menuItems.forEach(function(item) {
						var children = states.filter(function(child) {
							return child.level == 1 && child.name.indexOf(item.name) === 0 && Auth.hasPerm(child.stateRef, 'ACCESS');
						});
						item.subMenu = children.length ? children : null;
					});
					
					return menuItems.concat(staticMenuItems);
				};

				this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
				this.canSidebarBeHidden = canSidebarBeHidden;

				this.setMenuCollapsed = function(isCollapsed) {
					isMenuCollapsed = isCollapsed;
				};

				this.isMenuCollapsed = function() {
					return isMenuCollapsed;
				};

				this.toggleMenuCollapsed = function() {
					isMenuCollapsed = !isMenuCollapsed;
				};

				this.getAllStateRefsRecursive = function(item) {
					var result = [];
					_iterateSubItems(item);
					return result;

					function _iterateSubItems(currentItem) {
						currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
							subItem.stateRef && result.push(subItem.stateRef);
							_iterateSubItems(subItem);
						});
					}
				};

				function defineMenuItemStates() {
					return $state.get()
						.filter(function(s) {
							return s.sidebarMeta;
						})
						.map(function(s) {
							var meta = s.sidebarMeta;
							return {
								name: s.name,
								title: s.title,
								level: (s.name.match(/\./g) || []).length,
								order: meta.order,
								icon: meta.icon,
								stateRef: s.name,
							};
						})
						.sort(function(a, b) {
							return (a.level - b.level) * 100 + a.order - b.order;
						});
				}

				function shouldMenuBeCollapsed() {
					return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
				}

				function canSidebarBeHidden() {
					return window.innerWidth <= layoutSizes.resWidthHideSidebar;
				}
			}
		};
	}
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function () {
    'use strict';

    angular.module('RmsAppV2.pages.settings.emailtemplates.controller', [])
        .controller('EmailtemplateMainCtrl', EmailtemplateMainCtrl)
        .controller('EmailtemplateCreateCtrl', EmailtemplateCreateCtrl)
        .controller('EmailtemplateUpdateCtrl', EmailtemplateUpdateCtrl);

    /** @ngInject */
    function EmailtemplateMainCtrl($scope, $filter, $state, $q, Auth, HttpSvc, toastr) {

        Auth.init();

        var vm = this;

        vm.pageSizeOption = [10, 20, 50, 100];
        vm.pageSize = 10;
        vm.numOfRecord = 0;
        vm.numOfRecordFiltered = 0;
        vm.numOfRecordDisplayed = 0;
        vm.startIndex = 0;
        vm.endIndex = 0;
        vm.emailtemplateDataFull = [];
        vm.emailtemplateData = [];

        function refreshTableState(tableState, startIndex, endIndex) {

            var filtered = tableState.search.predicateObject ? $filter('filter')(vm.emailtemplateDataFull, tableState.search.predicateObject) : vm.emailtemplateDataFull;
            vm.numOfRecordFiltered = filtered.length;

            if (tableState.sort.predicate) {
                filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
            }
            var result = filtered.slice(startIndex, startIndex + endIndex);

            vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
            vm.emailtemplateData = result;

            tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);

            return tableState;
        };

        vm.retrieveData = function (tableState) {
            var pagination = tableState.pagination;

            // Restore Table State
            // var start = pagination.start2 || pagination.start;
            // if (pagination.start != start) {
            //     pagination.start = start;
            // }
            if (vm.pageSize != pagination.number) {
                vm.pageSize = pagination.number;
            }

            vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
            vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.

            if (vm.emailtemplateDataFull.length <= 0) {
                HttpSvc.get('emailtemplates/list', {}, Auth.getTokenId(), true)
                    .then(function (result) {
                        vm.numOfRecord = result.length;
                        vm.emailtemplateDataFull = result;
                        refreshTableState(tableState, vm.startIndex, vm.endIndex);
                    }, function () {
                        // Failed
                        toastr.error('Failed to retrieve data.', '');
                        return null;
                    });
            } else {
                refreshTableState(tableState, vm.startIndex, vm.endIndex);
            }
        };

        vm.deleteEmailTemplate = function (templateId, templateName) {
            var params = {};
            HttpSvc.delete('emailtemplates/' + templateId, params, Auth.getTokenId(), false)
                .then(function (result) {
                    toastr.success('The email template [' + templateName + '] has been deleted.', Auth.translate('SUCCESS'));
                    $state.reload();
                }, function () {
                    // Failed
                    toastr.error('Failed to delete the email template [' + templateName + '].', 'Failed');
                    return null;
                });
        };
    };

    /** @ngInject */
    function EmailtemplateCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
        Auth.init();

        var vm = this;

        vm.mode = 1;
        vm.emailtemplate = {};
        vm.emailtemplate.emailType == '';
        vm.emailtemplate.branchId == '';

        vm.selectedEmailType = null;
        vm.selectedBranch = null;

        vm.emailTypeList = GetEmailTypeList();
        vm.branchList = [];
        vm.lockButtons = false;

        /* *************************************************************** */

        // Load Branch List
        vm.loadBranchList = function () {
            HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.branchList = result;
                }, function (error) {
                    toastr.error(error, 'Failed to load Branch List');
                });
        };

        /* *************************************************************** */

        vm.selectedEmailTypeChanged = function () {
            vm.emailtemplate.emailType = vm.selectedEmailType.id;
        };

        vm.selectedBranchChanged = function () {
            vm.emailtemplate.branchId = vm.selectedBranch.id;
        };

        /* *************************************************************** */

        // Form Submission
        vm.submit = function () {

            vm.lockButtons = true;

            if (vm.dataForm.$invalid) {
                toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
                vm.lockButtons = false;
            } else {
                HttpSvc.post('emailtemplates/add', vm.emailtemplate, Auth.getTokenId(), false)
                    .then(function (result) {
                        toastr.success('Email Template has been created successfully.', Auth.translate('SUCCESS'));
                        $state.go('settings.emailtemplates.list');
                    }, function (error) {
                        toastr.error(angular.toJson(error), 'Failed');
                        vm.lockButtons = false;
                    });
            }
        }

        // Call Actions
        vm.loadBranchList();
    }

    /** @ngInject */
    function EmailtemplateUpdateCtrl($scope, $state, $stateParams, Auth, HttpSvc, toastr) {

        Auth.init();

        var vm = this;
        vm.mode = 2;
        vm.emailtemplate = {};
        vm.emailtemplate.emailType == '';
        vm.emailtemplate.branchId == '';

        vm.selectedEmailType = null;
        vm.selectedBranch = null;

        vm.emailTypeList = GetEmailTypeList();
        vm.branchList = [];
        vm.lockButtons = false;

        /* *************************************************************** */

        // Load Branch List
        vm.loadBranchList = function () {
            HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
                .then(function (result) {
                    vm.branchList = result;
                    vm.loadEmailtemplate();
                }, function (error) {
                    toastr.error(error, 'Failed to load Branch List');
                });
        };

        // Load Emailtemplate
        vm.loadEmailtemplate = function () {
            var params = { id: $stateParams.id };
            HttpSvc.get('emailtemplates/:id', params, Auth.getTokenId(), false)
                .then(function (result) {
                    vm.emailtemplate = result;

                    vm.emailTypeList.forEach(function (type) {
                        if (type.id == vm.emailtemplate.emailType) {
                            vm.selectedEmailType = type;
                        }
                    });
                    vm.branchList.forEach(function (branch) {
                        if (branch.id == vm.emailtemplate.branchId) {
                            vm.selectedBranch = branch;
                        }
                    });
                }, function () {
                    toastr.error('Failed to load selected Email Template.', Auth.translate('ERROR'))
                    $state.go('settings.emailtemplates.list');
                    return;
                });
        };

        /* *************************************************************** */

        vm.selectedEmailTypeChanged = function () {
            vm.emailtemplate.emailType = vm.selectedEmailType.id;
        };

        vm.selectedBranchChanged = function () {
            vm.emailtemplate.branchId = vm.selectedBranch.id;
        };

        /* *************************************************************** */

        // Form Submission
        vm.submit = function () {

            vm.lockButtons = true;

            if (vm.dataForm.$invalid) {
                toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
                vm.lockButtons = false;
            } else {
                HttpSvc.put('emailtemplates/' + $stateParams.id, vm.emailtemplate, Auth.getTokenId(), false)
                    .then(function (result) {
                        toastr.success('Email Template has been updated successfully.', Auth.translate('SUCCESS'));
                        $state.go('settings.emailtemplates.list');
                    }, function (error) {
                        toastr.error(error, 'Failed');
                        vm.lockButtons = false;
                    });
            }
        }

        // Call Actions
        vm.loadBranchList();
    }

    function GetEmailTypeList() {
        return [
            {
                id: 'SALES ORDER',
                name: 'SALES ORDER',
                variableList: [
                    {
                        code: '[[SO_NO]]',
                        name: 'SALES_ORDER_DOCUMENT_NUMBER'
                    },
                    {
                        code: '[[USER_FULLNAME]]',
                        name: 'CURRENT_LOGGED_IN_USER_FULL_NAME'
                    },
                    {
                        code: '[[USER_EMAIL]]',
                        name: 'CURRENT_LOGGED_IN_USER_EMAIL_ADDRESS'
                    },
                    {
                        code: '[[CUSTOMER_NAME]]',
                        name: 'CUSTOMER_NAME'
                    },
                    {
                        code: '[[CUSTOMER_BRANCH_NAME]]',
                        name: 'CUSTOMER_BRANCH_NAME'
                    },
                    {
                        code: '[[SHIPTO_ADDRESS1]]',
                        name: 'DELIVERY_ADDRESS_1'
                    },
                    {
                        code: '[[SHIPTO_ADDRESS2]]',
                        name: 'DELIVERY_ADDRESS_2'
                    },
                    {
                        code: '[[SHIPTO_ADDRESS3]]',
                        name: 'DELIVERY_ADDRESS_3'
                    },
                    {
                        code: '[[SHIPTO_POSTCODE]]',
                        name: 'DELIVERY_ADDRESS_POSTAL_CODE'
                    },
                    {
                        code: '[[SHIPTO_STATE]]',
                        name: 'DELIVERY_ADDRESS_STATE'
                    },
                    {
                        code: '[[SHIPTO_COUNTRY]]',
                        name: 'DELIVERY_ADDRESS_COUNTRY'
                    },
                    {
                        code: '[[SHIPTO_CONTACTPERSON]]',
                        name: 'DELIVERY_CONTACT_PERSON'
                    },
                    {
                        code: '[[SHIPTO_TEL]]',
                        name: 'DELIVERY_TELEPHONE'
                    },
                    {
                        code: '[[SHIPTO_FAX]]',
                        name: 'DELIVERY_FAX'
                    }
                ]
            },
            {
                id: 'PURCHASE ORDER',
                name: 'PURCHASE ORDER',
                variableList: [
                    {
                        code: '[[PO_NO]]',
                        name: 'PURCHASE_ORDER_DOCUMENT_NUMBER'
                    },
                    {
                        code: '[[USER_FULLNAME]]',
                        name: 'CURRENT_LOGGED_IN_USER_FULL_NAME'
                    },
                    {
                        code: '[[USER_EMAIL]]',
                        name: 'CURRENT_LOGGED_IN_USER_EMAIL_ADDRESS'
                    },
                    {
                        code: '[[SUPPLIER_NAME]]',
                        name: 'SUPPLIERS_NAME'
                    },
                    {
                        code: '[[SHIPTO_ADDRESS1]]',
                        name: 'DELIVERY_ADDRESS_1'
                    },
                    {
                        code: '[[SHIPTO_ADDRESS2]]',
                        name: 'DELIVERY_ADDRESS_2'
                    },
                    {
                        code: '[[SHIPTO_ADDRESS3]]',
                        name: 'DELIVERY_ADDRESS_3'
                    },
                    {
                        code: '[[SHIPTO_POSTCODE]]',
                        name: 'DELIVERY_ADDRESS_POSTAL_CODE'
                    },
                    {
                        code: '[[SHIPTO_STATE]]',
                        name: 'DELIVERY_ADDRESS_STATE'
                    },
                    {
                        code: '[[SHIPTO_COUNTRY]]',
                        name: 'DELIVERY_ADDRESS_COUNTRY'
                    },
                    {
                        code: '[[SHIPTO_CONTACTPERSON]]',
                        name: 'DELIVERY_CONTACT_PERSON'
                    },
                    {
                        code: '[[SHIPTO_TEL]]',
                        name: 'DELIVERY_TELEPHONE'
                    },
                    {
                        code: '[[SHIPTO_FAX]]',
                        name: 'DELIVERY_FAX'
                    }
                ]
            }
        ];
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
		      $scope.activeParentPath = $state.current.parentPath;
          $scope.activePageTitle = $state.current.pageTitle;
		      $scope.breadcrumbTitle = $state.current.title;
		      $scope.icon = $state.current.icon;
        });
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('RmsAppV2.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('RmsAppV2.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('RmsAppV2.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('RmsAppV2.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();

(function () {
  'use strict';

  angular.module('RmsAppV2.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: 'PageTopCtrl'
    };
  }

})();

(function () {
  'use strict';

	angular.module('RmsAppV2.theme.components')
		.controller('PageTopCtrl', PageTopCtrl)
		.controller('PageTopLanguageModalCtrl', PageTopLanguageModalCtrl)
		.controller('PageTopTokenModalCtrl', PageTopTokenModalCtrl);

	/** @ngInject */
	function PageTopCtrl($scope, $sce, $state, $q, $uibModal, Auth, Fullscreen, MsgSvc, ApprovalSvc, AnnouncementSvc) {

		Auth.init();

		$scope.isSuperAdmin = Auth.isSuperAdmin();
		$scope.languageName = Auth.getLanguageName();
		$scope.miniMenuIsOpen = false;

		$scope.toggled = function(open) {
			$scope.miniMenuIsOpen = open;
		};

		$scope.cls = function() {
			$scope.miniMenuIsOpen = false;
		}

		$scope.markAsRead = function(msgId) {
			MsgSvc.setMessageRead(msgId);
		}

		$scope.markAllAsRead = function() {
			MsgSvc.setMessageAllRead();
		}

		/* *************************************************************** */

		ApprovalSvc.loadList();

		$scope.viewDocument = function(obj) {
            ApprovalSvc.viewDocument(obj);
		}

		$scope.approveRequest = function(obj) {
            ApprovalSvc.approve(obj);
		}

		$scope.disapproveRequest = function(obj) {
            ApprovalSvc.disapprove(obj);
		}

		/* *************************************************************** */

        AnnouncementSvc.loadList();

        // Function to format the date
        $scope.formatDate = function (dateString) {
            return AnnouncementSvc.formatDate(dateString);
        };

		/* *************************************************************** */

		//MsgSvc.loadMessages();

		$scope.loadMessages = function() {
			MsgSvc.loadMessages();
		}

		$scope.goFullscreen = function () {

			// Fullscreen
			if (Fullscreen.isEnabled())
			   Fullscreen.cancel();
			else
			   Fullscreen.all();

			// Set Fullscreen to a specific element (bad practice)
			// Fullscreen.enable( document.getElementById('img') )

		};

		$scope.selectLanguage = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'languageModal.html',
				controller: 'PageTopLanguageModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return { }
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					$scope.languageName = Auth.getLanguageName();
				}, function () {
				});
		}

		$scope.viewToken = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				keyboard: false,
				templateUrl: 'tokenModal.html',
				controller: 'PageTopTokenModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return { }
					}
				}
			});

			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		}

		/* *************************************************************** */

		$scope.hasAccess = function(states) {
			var perms = states.split(',');
			var hasPerm = false;

			perms.forEach(function(s) {
				if(Auth.hasPerm(s, 'ACCESS'))
				{
					hasPerm = true;
				}
			})

			return hasPerm;
		};

		$scope.salesAccess = {};
		$scope.getSalesAccess = function() {
			var count = 0;
			var colWidth = 4;

			if($scope.hasAccess('salesorders')) count++;
			if($scope.hasAccess('deliveryorders')) count++;
			if($scope.hasAccess('routeplan')) count++;

			if(count==2) colWidth = 6;
			if(count==1) colWidth = 12;

			$scope.salesAccess = {
				count: count,
				colWidth: colWidth,
			};
		}

		$scope.procurementAccess = {};
		$scope.getProcurementAccess = function() {
			var count = 0;
			var colWidth = 4;

			if($scope.hasAccess('requisitions')) count++;
			if($scope.hasAccess('purchaseorders')) count++;
			if($scope.hasAccess('receivings')) count++;

			if(count==2) colWidth = 6;
			if(count==1) colWidth = 12;

			$scope.procurementAccess = {
				count: count,
				colWidth: colWidth,
			};
		}

		$scope.productionAccess = {};
		$scope.getProductionAccess = function() {
			var count = 0;
			var colWidth = 4;

			if($scope.hasAccess('jobs')) count++;
			if($scope.hasAccess('bulkbreakjobs')) count++;

			if(count==2) colWidth = 6;
			if(count==1) colWidth = 12;

			$scope.productionAccess = {
				count: count,
				colWidth: colWidth,
			};
		}

		$scope.inventoryAccess = {};
		$scope.getInventoryAccess = function() {
			var invCount = 0;
			var invColWidth = 4;
			var lblCount = 0;
			var lblColWidth = 4;
			var wwCount = 0;
			var wwColWidth = 4;

			if($scope.hasAccess('inventory.items,inventory.itemreturns,inventory.itemstockcounts')) invCount++;
			if($scope.hasAccess('inventory.semifgs,inventory.semifgstockcounts')) invCount++;
			if($scope.hasAccess('inventory.products,inventory.productstockcounts')) invCount++;

			if(invCount==2) invColWidth = 6;
			if(invCount==1) invColWidth = 12;

			if($scope.hasAccess('label.items')) lblCount++;
			if($scope.hasAccess('label.semifgs')) lblCount++;
			if($scope.hasAccess('label.products')) lblCount++;

			if(lblCount==2) lblColWidth = 6;
			if(lblCount==1) lblColWidth = 12;

			if($scope.hasAccess('withdrawalrequests')) wwCount++;
			if($scope.hasAccess('wastagereports')) wwCount++;

			if(wwCount==2) wwColWidth = 6;
			if(wwCount==1) wwColWidth = 12;

			var count = (invCount > lblCount ? invCount : lblCount);
			var colWidth = (invCount > lblCount ? invColWidth : lblColWidth);
			count = (count > wwCount ? count : wwCount);
			colWidth = (count > wwCount ? colWidth : wwColWidth);

			$scope.inventoryAccess = {
				count: count,
				colWidth: colWidth,
			};
		}

		$scope.knowledgeAccess = {};
		$scope.getKnowledgeAccess = function() {
			var count = 0;
			var colWidth = 6;

			if($scope.hasAccess('recipes')) count++;
			if($scope.hasAccess('sops')) count++;

			if(count==1) colWidth = 12;

			$scope.knowledgeAccess = {
				count: count,
				colWidth: colWidth,
			};
		}

		$scope.assetAccess = {};
		$scope.getAssetAccess = function() {
			var count = 0;
			var colWidth = 6;

			if($scope.hasAccess('assets')) count++;
			if($scope.hasAccess('assetconfigs')) count++;

			if(count==1) colWidth = 12;

			$scope.assetAccess = {
				count: count,
				colWidth: colWidth,
			};
		}

		$scope.aftersalesAccess = {};
		$scope.getAftersalesAccess = function() {
			var count = 0;
			var colWidth1 = 5;
			var colWidth2 = 7;

			if($scope.hasAccess('services')) count++;
			if($scope.hasAccess('serviceconfigs')) count++;

			if($scope.hasAccess('services') && $scope.hasAccess('serviceconfigs'))
			{
				count = 3;
				colWidth1 = 5;
				colWidth2 = 7;
			} else if($scope.hasAccess('services')) {
				count = 1;
				colWidth1 = 12;
				colWidth2 = 12;
			} else if($scope.hasAccess('serviceconfigs')) {
				count = 2;
				colWidth1 = 12;
				colWidth2 = 12;
			}

			$scope.aftersalesAccess = {
				count: count,
				colWidth1: colWidth1,
				colWidth2: colWidth2,
			};
		}

		$scope.settingAccess = {};
		$scope.getSettingAccess = function() {
			var count = 0;
			var colWidth = 4;

			if($scope.hasAccess('maintenance')) count++;
			if($scope.hasAccess('settings')) count++;
			if($scope.hasAccess('iotsettings.floorviewdesigner,iotsettings.gateways,iotsettings.sensors,iotsettings.settings')) count++;

			if(count==2) colWidth = 6;
			if(count==1) colWidth = 12;

			$scope.settingAccess = {
				count: count,
				colWidth: colWidth,
			};
		}

		/* *************************************************************** */

		$scope.getSalesAccess();
		$scope.getProcurementAccess();
		$scope.getProductionAccess();
		$scope.getInventoryAccess();
		$scope.getKnowledgeAccess();
		$scope.getAssetAccess();
		$scope.getAftersalesAccess();
		$scope.getSettingAccess();

		//setInterval($scope.loadMessages, 30000);
	}

	/** @ngInject */
	function PageTopLanguageModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {

		var $mdl = this;
		$mdl.selectedLanguage = Auth.getLanguage();

		/* ********************************************************* */

		$mdl.confirmModal = function()
		{
			if(!$mdl.languageForm.$valid)
			{

				toastr.error('Please select a language.', Auth.translate('ERROR'));
			}
			else
			{
				$mdl.lockButtons = true;
				HttpSvc.put('users/loginlanguage/' + Auth.getTokenId() + '/' + $mdl.selectedLanguage, {}, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('The system language has been updated.', Auth.translate('SUCCESS'));
						Auth.setLanguage($mdl.selectedLanguage);
						$uibModalInstance.close();
					}, function(error) {
						$mdl.lockButtons = false;
						toastr.error(error, 'Failed');
					});
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}

	/** @ngInject */
	function PageTopTokenModalCtrl($uibModalInstance, Auth, HttpSvc, toastr) {

		var $mdl = this;
		$mdl.token = Auth.getTokenId();

		/* ********************************************************* */

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}

})();

(function () {
  'use strict';

  angular.module('RmsAppV2.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
(function() {
    'use strict';

    angular.module('RmsAppV2.pages.iotdashboard.ezymap.controller', [])
        .controller('EzyMapCtrl', EzyMapCtrl);

    /** @ngInject */
    function EzyMapCtrl($scope, $filter, $state, $q, $timeout, $uibModal, Auth, Fullscreen, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.gatewaysLastKnown = [];
		vm.gateways = [];
		vm.gpsResult = {};
		vm.selectedGateway = null;

		vm.lockDateRange = false;
		vm.startDate = new Date();
		vm.endDate = new Date();
		vm.isLoading = false;

		vm.bounds = null;
		vm.boundPadding = 5;

		/* ********************************************************************** */

		vm.toggleFullscreen = function() {
			var element = document.getElementById('parentDiv');

			if(document.fullscreenElement ||
				document.webkitFullscreenElement ||
				document.mozFullScreenElement ||
				document.msFullscreenElement)
			{
				document.exitFullscreen();
			}
			else
			{
				if (element.requestFullscreen) {
					element.requestFullscreen();
				} else if (element.webkitRequestFullScreen) {
					element.webkitRequestFullScreen();
				} else if (element.mozRequestFullScreen) {
					element.mozRequestFullScreen();
				} else if (element.msRequestFullScreen) {
					element.msRequestFullScreen();
				}
			}			
		}

		/* ********************************************************************** */

		vm.initData = function() {
			vm.selectedGateway = null;

			if(!vm.lockDateRange)
				vm.initDateRange();
				
			vm.loadGateways();
		}

		vm.initDateRange = function() {

			// 12 hours
			vm.startDate = new Date();
			vm.startDate.setTime(vm.startDate.getTime() - (6*60*60*1000)); 
			vm.startDate = new Date(vm.startDate.setDate(vm.startDate.getDate()));
			vm.startDate = $filter('date')(vm.startDate, 'dd-MM-yyyy hh:mma');
			vm.endDate = new Date();
			vm.endDate.setDate(vm.endDate.getDate())
			vm.endDate = $filter('date')(vm.endDate, 'dd-MM-yyyy hh:mma');
		}

		/* ********************************************************************** */
		
		vm.toggleSelectGateway = function(g) {

			if(!vm.lockDateRange) 
			{
				vm.initDateRange();
			}				

			if(vm.selectedGateway!=null)			
			{
				vm.selectedGateway = g;
				vm.drawRoute(g.id, g.description);
				
				// if(vm.selectedGateway.id == g.id)
				// {
				// 	vm.selectedGateway = null;
				// 	vm.loadGatewaysLastKnown();
				// }
				// else
				// {
				// 	vm.selectedGateway = g;
				// 	vm.drawRoute(g.id, g.description);
				// }
			}
			else
			{
				vm.selectedGateway = g;
				vm.drawRoute(g.id, g.description);
			}
		}

		vm.loadGateways = function() {
			HttpSvc.get('iothub/list/vehiclegateways', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.gateways = result;
					
					$timeout(function() { vm.initialize() }, 1000);				
				}, function() {
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.loadGatewaysLastKnown = function() {
						
			var params = {
				dateFrom: vm.startDate,
				dateTo: vm.endDate,
			}

			HttpSvc.post('iotgpsreadings/list/lastknown', params, Auth.getTokenId(), true)
				.then(function(result) {	
					
					clearMap();

					vm.gatewaysLastKnown = result;
					vm.gatewaysLastKnown.forEach(function(g) {
						
						if(g.gpsLat != '' && g.gpsLng != '')
						{
							var latlng = {
								'gatewayDesc': g.description,
								'lat': parseFloat(g.gpsLat),
								'lng': parseFloat(g.gpsLng),
								'timestamp': g.gpsDatestamp + '&nbsp; ' + g.gpsTimestamp,
								'speedKph': g.speedKph,
								'temperature': g.temperature,
								'temperatureF': g.temperatureF,
								'humidity': g.humidity,
							};
	
							var marker = addMarkerSpecial(latlng);
							var infoWindow = addPopupWIndow(marker, latlng);
							infoWindows.push(infoWindow);
						}
					});

					fitBounds(markers);

				}, function() {
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}	

		/* ********************************************************************** */

		// GOOGLE MAP API v3
	  
		var API_KEY = 'AIzaSyCvNPZvYVZ6OKhtbS4JLr_w6_OeG56eEQk';

		// Icons for markers
		var MARKER = 'https://maps.google.com/mapfiles/ms/icons/red-dot.png';
		var MARKER1 = 'assets/img/red-dot2.png';
		//var MARKER = 'assets/img/red-dot.png';

		var map;
		var infoWindows = [];
		var markers = [];
		var polylines = [];
		var snappedCoordinates = [];
	
		// Symbol that gets animated along the polyline
		var lineSymbol = {
			path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
			scale: 4,
			strokeColor: '#ff0000',
			strokeWidth: '#ff0000'
		};
			
		// Initialize
		vm.initialize = function() {
			// Centre the map on Sydney
			var mapOptions = {
				center: {
					'lat': 3.032604, 
					'lng': 101.617299
				}, // Setiawalk
				fullscreenControl: false,
				mapTypeControl: false,
				streetViewControl: false,
				zoom: 14,
				zoomControlOptions: {
					position: google.maps.ControlPosition.RIGHT_TOP,
				}
			};
	
			// Map object
			map = new google.maps.Map(document.getElementById('ezymap'), mapOptions);
			
			$timeout(function() { vm.loadGatewaysLastKnown() }, 500);
		}

		vm.drawRoute = function(gatewayId) {

			var latlngArrayIndex = 0;
			vm.isLoading = true;			

			var params = {
				dateFrom: vm.startDate,
				dateTo: vm.endDate,
			}

			HttpSvc.post('iotgpsreadings/list/' + gatewayId, params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.gpsResult = result;

					clearMap();
					if (vm.gpsResult.latlngArray.length > 0)
					{
						bend(vm.gpsResult.latlngArray[0]);
					}
					
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return;
				});
		
			// Make AJAX request to the snapToRoadsAPI
			// with coordinates parsed from coors
			function bend(coords) {

				var params = {
					interpolate: true,
					key: API_KEY,
					path: coords
				};

				HttpSvc.getExt('https://roads.googleapis.com/v1/snapToRoads', params, "", false)
					.then(function(result) {	
						processSnapToRoadResponse(result);
						latlngArrayIndex++;

						if(latlngArrayIndex < vm.gpsResult.latlngArray.length)
						{
							bend(vm.gpsResult.latlngArray[latlngArrayIndex])
						}
						else
						{
							snap();
							return;
						}
					}, function() {				
						clearMap();
					});
			}
			
			function snap() {
				drawSnappedPolyline(snappedCoordinates);
				fitBounds(markers);
			}
			
			function processSnapToRoadResponse(data) {
				
				var readings = vm.gpsResult.gwReadings;
				var offset = latlngArrayIndex * 100;

				for (var i = 0; i < data.snappedPoints.length; i++) {
					
					if(data.snappedPoints[i].originalIndex != null) {
						var oriIndex = data.snappedPoints[i].originalIndex;
						var latlng = {
							'gatewayDesc': readings[offset + oriIndex].description,
							'lat': data.snappedPoints[i].location.latitude,
							'lng': data.snappedPoints[i].location.longitude,
							'timestamp': readings[offset + oriIndex].gpsDatestamp + '&nbsp; ' + readings[offset + oriIndex].gpsTimestamp,
							'speedKph': readings[offset + oriIndex].speedKph,
							'temperature': readings[offset + oriIndex].temperature,
							'temperatureF': readings[offset + oriIndex].temperatureF,
							'humidity': readings[offset + oriIndex].humidity,
							'interpolated': false
						};
					}
					else
					{
						var latlng = {
							'lat': data.snappedPoints[i].location.latitude,
							'lng': data.snappedPoints[i].location.longitude,
							'interpolated': true
						};
					}
					snappedCoordinates.push(latlng);
				}
			}
			
			function drawSnappedPolyline(snappedCoords) {
				var snappedPolyline = new google.maps.Polyline({
					path: snappedCoords,
					strokeColor: '#005db5',
					strokeWeight: 4,
					icons: [{
						icon: lineSymbol,
						offset: '100%'
					}]
				});
	
				snappedPolyline.setMap(map);
				animateCircle(snappedPolyline);
				polylines.push(snappedPolyline);
	
				for (var i = 0; i < snappedCoords.length; i++) {
					if(snappedCoords[i].interpolated == false)
					{
						var marker = addMarker(snappedCoords[i]);
						var infoWindow = addPopupWIndow(marker, snappedCoords[i]);
						infoWindows.push(infoWindow);
					}
				}
			}
		}

		vm.fitBounds = function() {
			map.fitBounds(vm.bounds, vm.boundPadding);
		};	

		vm.gmapPrint = function() {
			var content = window.document.getElementById("ezymap");
			var newWindow = window.open(); // open a new window
			newWindow.document.write(content.innerHTML); // write the map into the new window
			newWindow.print(); // print the new window
		}
		
		  		
		function addMarker(coords) {
			var marker = new google.maps.Marker({
				position: coords,
				title: '',
				map: map,
				opacity: 0.5,
				icon: MARKER
			});
	
			// Make markers change opacity when the mouse scrubs across them
			marker.addListener('mouseover', function(mevt) {
				marker.setOpacity(1.0);
			});
			marker.addListener('mouseout', function(mevt) {
				marker.setOpacity(0.5);
			});
	
			coords.marker = marker;
			markers.push(marker);
	
			return marker;
		}

		function addMarkerSpecial(coords) {
			var marker = new google.maps.Marker({
				position: coords,
				title: '',
				map: map,
				opacity: 1,
				icon: MARKER1
			});
	
			coords.marker = marker;
			markers.push(marker);
	
			return marker;
		}
			
		function addPopupWIndow(marker, coords) {
			var infowindow = new google.maps.InfoWindow();
			var content = 
				'<div style="width:350px;padding:15px">' + 
					'<h2>' + coords.gatewayDesc + '</h2>' +
					'<div style="font-size:14pt;margin-bottom:10px"><b>' + coords.timestamp + '</b></div>' + 
					'<div style="margin-bottom:10px">(GPS: ' + coords.lat.toFixed(6) + ', ' + coords.lng.toFixed(6) + ')</div>' + 
					'<div style="width:32%;padding:10px 5px;text-align:center;float:left;border:5px solid #ccc;border-radius:8px;">' + 
						'<img src="assets/img/icon-speedometer.png" alt="" style="margin-bottom:8px" /><br />' + 
							'<div style="font-size:18pt"><b>' + (coords.speedKph!=-1 ? coords.speedKph : '-') + '</b></div>' +
							' <div style="font-size:10pt">km/h</div>' + 
					'</div>' + 
					'<div style="width:32%;padding:10px 5px;text-align:center;float:left;border:5px solid #ccc;border-radius:8px;margin-left:5px">' + 
						'<img src="assets/img/icon-temperature.png" alt="" style="margin-bottom:8px" /><br />' + 
							'<div style="font-size:18pt"><b>' + (coords.temperature!=-999 ? coords.temperature : '-') + '</b></div>' +
							' <div style="font-size:10pt">°C</div>' + 
					'</div>' + 
					'<div style="width:32%;padding:10px 5px;text-align:center;float:left;border:5px solid #ccc;border-radius:8px;margin-left:5px">' + 
						'<img src="assets/img/icon-humidity.png" alt="" style="margin-bottom:8px" /><br />' +
							'<div style="font-size:18pt"><b>' + (coords.humidity!=-1 ? coords.humidity : '-') + '</b></div>' +
							' <div style="font-size:10pt">%RH</div>' + 
					'</div>' + 
					'<br style="clear:both" />'
				'</div>';

			infowindow.setContent(content);

			google.maps.event.addListener(marker, 'mouseover', function() {
				openInfoWindow(infowindow, marker);
			});
			google.maps.event.addListener(marker, 'mouseout', function() {					
				//$timeout(function() { infowindow.close() }, 500);
				infowindow.close();
			});

			return infowindow;
		}
	
		function animateCircle(polyline) {
			var count = 0;
			
			// fallback icon if the poly has no icon to animate
			var defaultIcon = [
				{
					icon: lineSymbol,
					offset: '100%'
				}
			];
			window.setInterval(function() {
				count = (count + 1) % 200;
				var icons = polyline.get('icons') || defaultIcon;
				icons[0].offset = (count / 2) + '%';
				polyline.set('icons', icons);
			}, 50);
		}
	
		function fitBounds(markers) {
			vm.bounds = new google.maps.LatLngBounds;
			for (var i = 0; i < markers.length; i++) {
				vm.bounds.extend(markers[i].getPosition());
			}
			map.fitBounds(vm.bounds, vm.boundPadding);
		}
	
		function openInfoWindow(infowindow, marker) {
			if (map.getStreetView().getVisible()) {
				infowindow.open(map.getStreetView(), marker);
			}
			else {
				infowindow.open(map, marker);
			}
		}

		function clearMap() {
			closeAllInfoWindows()
		
			// Clear the polyline
			for (var i = 0; i < polylines.length; i++) {
				polylines[i].setMap(null);
			}
			// Clear all markers
			for (var i = 0; i < markers.length; i++) {
				markers[i].setMap(null);
			}
			// Clear all info windows
			for (var i = 0; i < infoWindows.length; i++) {
				infoWindows[i].close();
			}

			var center = new google.maps.LatLng(3.032604, 101.617299);
			map.panTo(center);

			// Empty everything
			polylines = [];
			markers = [];
			snappedCoordinates = [];
			infoWindows = [];
		}
	
		function closeAllInfoWindows() {
			for (var i = 0; i < infoWindows.length; i++) {
				infoWindows[i].close();
			}
		}
		
		vm.initData()
	};
	
})();

(function() {
	'use strict';

	angular.module('RmsAppV2.pages.smartkitchen.machineconnectionprofiles.controller', [])
			.controller('SmartKitchenMachineConnectionProfileMainCtrl', SmartKitchenMachineConnectionProfileMainCtrl)
			.controller('SmartKitchenMachineConnectionProfileCreateCtrl', SmartKitchenMachineConnectionProfileCreateCtrl)
			.controller('SmartKitchenMachineConnectionProfileUpdateCtrl', SmartKitchenMachineConnectionProfileUpdateCtrl);

	/** @ngInject */
	function SmartKitchenMachineConnectionProfileMainCtrl($scope, $filter, $state, $uibModal, Auth, HttpSvc, toastr) {
	
		Auth.init();		
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.profileDataFull = [];
		vm.profileData = [];
		vm.isLoading = false;

		function refreshTableState(tableState, startIndex, endIndex) {
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.profileDataFull, tableState.search.predicateObject) : vm.profileDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.profileData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			
			if(vm.pageSize != pagination.number) {
				vm.pageSize = pagination.number;
			}

			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.profileDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('machineconnectionprofiles/list', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.profileDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		vm.deleteProfile = function(profileId, profileName) {
			var params = {};
			HttpSvc.delete('machineconnectionprofiles/' + profileId, params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.profileDataFull = [];
					vm.profileData = [];

					toastr.success('The Connection Profile [' + profileName + '] has been removed.', 'Remove Successful');
					$scope.$broadcast('refreshStTable');
				}, function(error) {
					// Failed
					toastr.error('Failed to delete the Connection Profile [' + profileName + ']. ' + error, 'Remove Failed');
					return null;
			});
		};
	};

	/** @ngInject */
	function SmartKitchenMachineConnectionProfileCreateCtrl($scope, $state, Auth, HttpSvc, toastr) {
		Auth.init();		
		
		var vm = this;
		vm.mode = 1;
		vm.profile = {};
		vm.branchList = [];
		vm.equipmentList = [];
		vm.groupCodeList = [];
		vm.authTypeList = [
			{
				id: 'POST',
				name: 'POST'
			}
		];
		vm.selectedBranch = null;
		vm.selectedEquipment = null;
		vm.selectedGroupCode = null;
		vm.selectedAuthType = null;

		/* ******************************************************************** */

		vm.loadBranchList = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadEquipmentList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadEquipmentList = function() {
			HttpSvc.get('equipments/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.equipmentList = result;
					vm.loadGroupCodeList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadGroupCodeList = function() {
			HttpSvc.get('machineconnectionprofiles/middlewaregroupcodes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.groupCodeList = result;
					vm.loadData();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		/* ******************************************************************** */

		vm.selectedBranchChanged = function() 
		{
			vm.profile.branchId = vm.selectedBranch.id;
		}
		
		vm.selectedEquipmentChanged = function() 
		{
			vm.profile.equipmentId = vm.selectedEquipment.id;
		}
		
		vm.selectedGroupCodeChanged = function() 
		{
			vm.profile.middlewareGroupCode = vm.selectedGroupCode.code;
		}
		
		vm.selectedAuthTypeChanged = function() 
		{
			vm.profile.authType = vm.selectedAuthType.id;
		}

		/* ******************************************************************** */

		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.post('machineconnectionprofiles', vm.profile, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Connection Profile has been created successfully.', Auth.translate('SUCCESS'));
						$state.go('smartkitchen.machineconnectionprofiles.update', {'id': result.id });
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Action
		vm.loadBranchList();
	}

	/** @ngInject */
	function SmartKitchenMachineConnectionProfileUpdateCtrl($scope, $state, $stateParams, $uibModal, Auth, HttpSvc, toastr) {

		Auth.init();		
		
		var vm = this;
		vm.mode = 2;
		vm.profile = {};
		vm.branchList = [];
		vm.equipmentList = [];
		vm.groupCodeList = [];
		vm.authTypeList = [
			{
				id: 'POST',
				name: 'POST'
			}
		];
		vm.selectedBranch = null;
		vm.selectedEquipment = null;
		vm.selectedGroupCode = null;
		vm.selectedAuthType = null;

		/* ******************************************************************** */

		vm.loadBranchList = function() {
			HttpSvc.get('branches/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.branchList = result;
					vm.loadEquipmentList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadEquipmentList = function() {
			HttpSvc.get('equipments/list', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.equipmentList = result;
					vm.loadGroupCodeList();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadGroupCodeList = function() {
			HttpSvc.get('machineconnectionprofiles/middlewaregroupcodes', {}, Auth.getTokenId(), true)
				.then(function(result) {
					vm.groupCodeList = result;
					vm.loadData();
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		vm.loadData = function() {
			var params = { id: $stateParams.id };

			HttpSvc.get('machineconnectionprofiles/:id' , params, Auth.getTokenId(), false)
				.then(function(result) {
					vm.profile = result;

					vm.branchList.forEach(function(b) {
						if(b.id==vm.profile.branchId)
						{
							vm.selectedBranch = b;
						}
					});

					vm.equipmentList.forEach(function(b) {
						if(b.id==vm.profile.equipmentId)
						{
							vm.selectedEquipment = b;
						}
					});

					vm.groupCodeList.forEach(function(b) {
						if(b.code==vm.profile.middlewareGroupCode)
						{
							vm.selectedGroupCode = b;
						}
					});

					vm.authTypeList.forEach(function(b) {
						if(b.id==vm.profile.authType)
						{
							vm.selectedAuthType = b;
						}
					});
				}, function(error) {
					toastr.error(error, 'Failed');
				});	
		}

		/* ******************************************************************** */

		vm.selectedBranchChanged = function() 
		{
			vm.profile.branchId = vm.selectedBranch.id;
		}
		
		vm.selectedEquipmentChanged = function() 
		{
			vm.profile.equipmentId = vm.selectedEquipment.id;
		}
		
		vm.selectedGroupCodeChanged = function() 
		{
			vm.profile.middlewareGroupCode = vm.selectedGroupCode.code;
		}
		
		vm.selectedAuthTypeChanged = function() 
		{
			vm.profile.authType = vm.selectedAuthType.id;
		}

		/* ******************************************************************** */
		
		// Form Submission
		vm.submit = function() {
			if(vm.dataForm.$invalid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				HttpSvc.put('machineconnectionprofiles/' + $stateParams.id, vm.profile, Auth.getTokenId(), false)
					.then(function(result) {
						toastr.success('Connection Profile has been updated successfully.', Auth.translate('SUCCESS'));
						$state.reload();
					}, function(error) {
						toastr.error(error, 'Failed');
					});
			}
		}
		
		// Call Actions
		vm.loadBranchList();		
	};
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.iotdashboard.ezymap.controller', [])
        .controller('EzyMapCtrl', EzyMapCtrl);

    /** @ngInject */
    function EzyMapCtrl($scope, $filter, $state, $q, $timeout, $uibModal, Auth, Fullscreen, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.gatewaysLastKnown = [];
		vm.gateways = [];
		vm.gpsResult = {};
		vm.selectedGateway = null;

		vm.lockDateRange = false;
		vm.startDate = new Date();
		vm.endDate = new Date();
		vm.isLoading = false;

		vm.bounds = null;
		vm.boundPadding = 5;

		/* ********************************************************************** */

		vm.toggleFullscreen = function() {
			var element = document.getElementById('parentDiv');

			if(document.fullscreenElement ||
				document.webkitFullscreenElement ||
				document.mozFullScreenElement ||
				document.msFullscreenElement)
			{
				document.exitFullscreen();
			}
			else
			{
				if (element.requestFullscreen) {
					element.requestFullscreen();
				} else if (element.webkitRequestFullScreen) {
					element.webkitRequestFullScreen();
				} else if (element.mozRequestFullScreen) {
					element.mozRequestFullScreen();
				} else if (element.msRequestFullScreen) {
					element.msRequestFullScreen();
				}
			}			
		}

		/* ********************************************************************** */

		vm.initData = function() {
			vm.selectedGateway = null;

			if(!vm.lockDateRange)
				vm.initDateRange();
				
			vm.loadGateways();
		}

		vm.initDateRange = function() {

			// 12 hours
			vm.startDate = new Date();
			vm.startDate.setTime(vm.startDate.getTime() - (6*60*60*1000)); 
			vm.startDate = new Date(vm.startDate.setDate(vm.startDate.getDate()));
			vm.startDate = $filter('date')(vm.startDate, 'dd-MM-yyyy hh:mma');
			vm.endDate = new Date();
			vm.endDate.setDate(vm.endDate.getDate())
			vm.endDate = $filter('date')(vm.endDate, 'dd-MM-yyyy hh:mma');
		}

		/* ********************************************************************** */
		
		vm.toggleSelectGateway = function(g) {

			if(!vm.lockDateRange) 
			{
				vm.initDateRange();
			}				

			if(vm.selectedGateway!=null)			
			{
				vm.selectedGateway = g;
				vm.drawRoute(g.id, g.description);
				
				// if(vm.selectedGateway.id == g.id)
				// {
				// 	vm.selectedGateway = null;
				// 	vm.loadGatewaysLastKnown();
				// }
				// else
				// {
				// 	vm.selectedGateway = g;
				// 	vm.drawRoute(g.id, g.description);
				// }
			}
			else
			{
				vm.selectedGateway = g;
				vm.drawRoute(g.id, g.description);
			}
		}

		vm.loadGateways = function() {
			HttpSvc.get('iothub/list/vehiclegateways', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.gateways = result;
					
					$timeout(function() { vm.initialize() }, 1000);				
				}, function() {
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.loadGatewaysLastKnown = function() {
						
			var params = {
				dateFrom: vm.startDate,
				dateTo: vm.endDate,
			}

			HttpSvc.post('iotgpsreadings/list/lastknown', params, Auth.getTokenId(), true)
				.then(function(result) {	
					
					clearMap();

					vm.gatewaysLastKnown = result;
					vm.gatewaysLastKnown.forEach(function(g) {
						
						if(g.gpsLat != '' && g.gpsLng != '')
						{
							var latlng = {
								'gatewayDesc': g.description,
								'lat': parseFloat(g.gpsLat),
								'lng': parseFloat(g.gpsLng),
								'timestamp': g.gpsDatestamp + '&nbsp; ' + g.gpsTimestamp,
								'speedKph': g.speedKph,
								'temperature': g.temperature,
								'temperatureF': g.temperatureF,
								'humidity': g.humidity,
							};
	
							var marker = addMarkerSpecial(latlng);
							var infoWindow = addPopupWIndow(marker, latlng);
							infoWindows.push(infoWindow);
						}
					});

					fitBounds(markers);

				}, function() {
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}	

		/* ********************************************************************** */

		// GOOGLE MAP API v3
	  
		var API_KEY = 'AIzaSyCvNPZvYVZ6OKhtbS4JLr_w6_OeG56eEQk';

		// Icons for markers
		var MARKER = 'https://maps.google.com/mapfiles/ms/icons/red-dot.png';
		var MARKER1 = 'assets/img/red-dot2.png';
		//var MARKER = 'assets/img/red-dot.png';

		var map;
		var infoWindows = [];
		var markers = [];
		var polylines = [];
		var snappedCoordinates = [];
	
		// Symbol that gets animated along the polyline
		var lineSymbol = {
			path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
			scale: 4,
			strokeColor: '#ff0000',
			strokeWidth: '#ff0000'
		};
			
		// Initialize
		vm.initialize = function() {
			// Centre the map on Sydney
			var mapOptions = {
				center: {
					'lat': 3.032604, 
					'lng': 101.617299
				}, // Setiawalk
				fullscreenControl: false,
				mapTypeControl: false,
				streetViewControl: false,
				zoom: 14,
				zoomControlOptions: {
					position: google.maps.ControlPosition.RIGHT_TOP,
				}
			};
	
			// Map object
			map = new google.maps.Map(document.getElementById('ezymap'), mapOptions);
			
			$timeout(function() { vm.loadGatewaysLastKnown() }, 500);
		}

		vm.drawRoute = function(gatewayId) {

			var latlngArrayIndex = 0;
			vm.isLoading = true;			

			var params = {
				dateFrom: vm.startDate,
				dateTo: vm.endDate,
			}

			HttpSvc.post('iotgpsreadings/list/' + gatewayId, params, Auth.getTokenId(), false)
				.then(function(result) {	
					vm.gpsResult = result;

					clearMap();
					if (vm.gpsResult.latlngArray.length > 0)
					{
						bend(vm.gpsResult.latlngArray[0]);
					}
					
					vm.isLoading = false;
				}, function() {
					vm.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return;
				});
		
			// Make AJAX request to the snapToRoadsAPI
			// with coordinates parsed from coors
			function bend(coords) {

				var params = {
					interpolate: true,
					key: API_KEY,
					path: coords
				};

				HttpSvc.getExt('https://roads.googleapis.com/v1/snapToRoads', params, "", false)
					.then(function(result) {	
						processSnapToRoadResponse(result);
						latlngArrayIndex++;

						if(latlngArrayIndex < vm.gpsResult.latlngArray.length)
						{
							bend(vm.gpsResult.latlngArray[latlngArrayIndex])
						}
						else
						{
							snap();
							return;
						}
					}, function() {				
						clearMap();
					});
			}
			
			function snap() {
				drawSnappedPolyline(snappedCoordinates);
				fitBounds(markers);
			}
			
			function processSnapToRoadResponse(data) {
				
				var readings = vm.gpsResult.gwReadings;
				var offset = latlngArrayIndex * 100;

				for (var i = 0; i < data.snappedPoints.length; i++) {
					
					if(data.snappedPoints[i].originalIndex != null) {
						var oriIndex = data.snappedPoints[i].originalIndex;
						var latlng = {
							'gatewayDesc': readings[offset + oriIndex].description,
							'lat': data.snappedPoints[i].location.latitude,
							'lng': data.snappedPoints[i].location.longitude,
							'timestamp': readings[offset + oriIndex].gpsDatestamp + '&nbsp; ' + readings[offset + oriIndex].gpsTimestamp,
							'speedKph': readings[offset + oriIndex].speedKph,
							'temperature': readings[offset + oriIndex].temperature,
							'temperatureF': readings[offset + oriIndex].temperatureF,
							'humidity': readings[offset + oriIndex].humidity,
							'interpolated': false
						};
					}
					else
					{
						var latlng = {
							'lat': data.snappedPoints[i].location.latitude,
							'lng': data.snappedPoints[i].location.longitude,
							'interpolated': true
						};
					}
					snappedCoordinates.push(latlng);
				}
			}
			
			function drawSnappedPolyline(snappedCoords) {
				var snappedPolyline = new google.maps.Polyline({
					path: snappedCoords,
					strokeColor: '#005db5',
					strokeWeight: 4,
					icons: [{
						icon: lineSymbol,
						offset: '100%'
					}]
				});
	
				snappedPolyline.setMap(map);
				animateCircle(snappedPolyline);
				polylines.push(snappedPolyline);
	
				for (var i = 0; i < snappedCoords.length; i++) {
					if(snappedCoords[i].interpolated == false)
					{
						var marker = addMarker(snappedCoords[i]);
						var infoWindow = addPopupWIndow(marker, snappedCoords[i]);
						infoWindows.push(infoWindow);
					}
				}
			}
		}

		vm.fitBounds = function() {
			map.fitBounds(vm.bounds, vm.boundPadding);
		};	

		vm.gmapPrint = function() {
			var content = window.document.getElementById("ezymap");
			var newWindow = window.open(); // open a new window
			newWindow.document.write(content.innerHTML); // write the map into the new window
			newWindow.print(); // print the new window
		}
		
		  		
		function addMarker(coords) {
			var marker = new google.maps.Marker({
				position: coords,
				title: '',
				map: map,
				opacity: 0.5,
				icon: MARKER
			});
	
			// Make markers change opacity when the mouse scrubs across them
			marker.addListener('mouseover', function(mevt) {
				marker.setOpacity(1.0);
			});
			marker.addListener('mouseout', function(mevt) {
				marker.setOpacity(0.5);
			});
	
			coords.marker = marker;
			markers.push(marker);
	
			return marker;
		}

		function addMarkerSpecial(coords) {
			var marker = new google.maps.Marker({
				position: coords,
				title: '',
				map: map,
				opacity: 1,
				icon: MARKER1
			});
	
			coords.marker = marker;
			markers.push(marker);
	
			return marker;
		}
			
		function addPopupWIndow(marker, coords) {
			var infowindow = new google.maps.InfoWindow();
			var content = 
				'<div style="width:350px;padding:15px">' + 
					'<h2>' + coords.gatewayDesc + '</h2>' +
					'<div style="font-size:14pt;margin-bottom:10px"><b>' + coords.timestamp + '</b></div>' + 
					'<div style="margin-bottom:10px">(GPS: ' + coords.lat.toFixed(6) + ', ' + coords.lng.toFixed(6) + ')</div>' + 
					'<div style="width:32%;padding:10px 5px;text-align:center;float:left;border:5px solid #ccc;border-radius:8px;">' + 
						'<img src="assets/img/icon-speedometer.png" alt="" style="margin-bottom:8px" /><br />' + 
							'<div style="font-size:18pt"><b>' + (coords.speedKph!=-1 ? coords.speedKph : '-') + '</b></div>' +
							' <div style="font-size:10pt">km/h</div>' + 
					'</div>' + 
					'<div style="width:32%;padding:10px 5px;text-align:center;float:left;border:5px solid #ccc;border-radius:8px;margin-left:5px">' + 
						'<img src="assets/img/icon-temperature.png" alt="" style="margin-bottom:8px" /><br />' + 
							'<div style="font-size:18pt"><b>' + (coords.temperature!=-999 ? coords.temperature : '-') + '</b></div>' +
							' <div style="font-size:10pt">°C</div>' + 
					'</div>' + 
					'<div style="width:32%;padding:10px 5px;text-align:center;float:left;border:5px solid #ccc;border-radius:8px;margin-left:5px">' + 
						'<img src="assets/img/icon-humidity.png" alt="" style="margin-bottom:8px" /><br />' +
							'<div style="font-size:18pt"><b>' + (coords.humidity!=-1 ? coords.humidity : '-') + '</b></div>' +
							' <div style="font-size:10pt">%RH</div>' + 
					'</div>' + 
					'<br style="clear:both" />'
				'</div>';

			infowindow.setContent(content);

			google.maps.event.addListener(marker, 'mouseover', function() {
				openInfoWindow(infowindow, marker);
			});
			google.maps.event.addListener(marker, 'mouseout', function() {					
				//$timeout(function() { infowindow.close() }, 500);
				infowindow.close();
			});

			return infowindow;
		}
	
		function animateCircle(polyline) {
			var count = 0;
			
			// fallback icon if the poly has no icon to animate
			var defaultIcon = [
				{
					icon: lineSymbol,
					offset: '100%'
				}
			];
			window.setInterval(function() {
				count = (count + 1) % 200;
				var icons = polyline.get('icons') || defaultIcon;
				icons[0].offset = (count / 2) + '%';
				polyline.set('icons', icons);
			}, 50);
		}
	
		function fitBounds(markers) {
			vm.bounds = new google.maps.LatLngBounds;
			for (var i = 0; i < markers.length; i++) {
				vm.bounds.extend(markers[i].getPosition());
			}
			map.fitBounds(vm.bounds, vm.boundPadding);
		}
	
		function openInfoWindow(infowindow, marker) {
			if (map.getStreetView().getVisible()) {
				infowindow.open(map.getStreetView(), marker);
			}
			else {
				infowindow.open(map, marker);
			}
		}

		function clearMap() {
			closeAllInfoWindows()
		
			// Clear the polyline
			for (var i = 0; i < polylines.length; i++) {
				polylines[i].setMap(null);
			}
			// Clear all markers
			for (var i = 0; i < markers.length; i++) {
				markers[i].setMap(null);
			}
			// Clear all info windows
			for (var i = 0; i < infoWindows.length; i++) {
				infoWindows[i].close();
			}

			var center = new google.maps.LatLng(3.032604, 101.617299);
			map.panTo(center);

			// Empty everything
			polylines = [];
			markers = [];
			snappedCoordinates = [];
			infoWindows = [];
		}
	
		function closeAllInfoWindows() {
			for (var i = 0; i < infoWindows.length; i++) {
				infoWindows[i].close();
			}
		}
		
		vm.initData()
	};
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.iotdashboard.smartiotobservatory.controller', [])
        .controller('SmartIoTObservatoryCtrl', SmartIoTObservatoryCtrl)
        .controller('SmartIoTObservatoryOverviewCtrl', SmartIoTObservatoryOverviewCtrl)
        .controller('SmartIoTObservatorySettingModalCtrl', SmartIoTObservatorySettingModalCtrl)
        .controller('SmartIoTObservatorySettingManageModalCtrl', SmartIoTObservatorySettingManageModalCtrl)
        .controller('SmartIoTObservatoryReportModalCtrl', SmartIoTObservatoryReportModalCtrl);

    /** @ngInject */
    function SmartIoTObservatoryCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.customerDataFull = [];
		vm.customerData = [];

		/* ***************************************************************** */

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.customerDataFull, tableState.search.predicateObject) : vm.customerDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.customerData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.customerDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('smartiot/observatory/customerlist', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.customerDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		/* ***************************************************************** */

		// Open Setting Modal Dialog
		vm.promptSettingDialog = function (clientCompanyId, clientName) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'settingModal.html',
				controller: 'SmartIoTObservatorySettingModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							accessCompanyId: clientCompanyId,
							clientName: clientName
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		};	

		// Open Report Modal Dialog
		vm.promptReportDialog = function (clientCompanyId, clientName) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'reportModal.html',
				controller: 'SmartIoTObservatoryReportModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							accessCompanyId: clientCompanyId,
							clientName: clientName
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					vm.loadPermissionList();
				}, function () {
				});
		};	

		/* ***************************************************************** */
		
		// Call Action
		// Do nothing
	};
	
    /** @ngInject */
    function SmartIoTObservatoryOverviewCtrl($stateParams, $timeout, Auth, HttpSvc, toastr) {
		
		Auth.init();	
		
		var vm = this;
		vm.groups = [];
		vm.selectedGroup = null;
		vm.hideDateRange = false;
		vm.showAsList = false;
		vm.columnWidth = 6;
		vm.hidePanel = false;
		
		// Go Back
		vm.goBack = function() {
			window.history.back();
		}

		vm.loadGroups = function() {
			HttpSvc.get('smartiot/datahub/list/groups/client/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.groups = result;
				}, function() {
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.selectGroup = function(groupId) {
			vm.groups.forEach(function(g) {
				if(g.id==groupId) {
					vm.selectedGroup=g;
				}
			});
		}	

		vm.refreshPanel = function() {
			vm.hidePanel = true;
			$timeout(function() {
				vm.hidePanel = false;
			}, 50);
		}	
		
		vm.resetGroup = function() {
			vm.selectedGroup = null;
		}

		vm.setColumnWidth = function(columnCount) {
			if(columnCount==2) 
			{
				vm.columnWidth = 6;
				vm.showAsList = false;
				vm.hideDateRange = false;
			}
			else if(columnCount==4) 
			{
				vm.columnWidth = 3;
				vm.showAsList = false;
				vm.hideDateRange = true;
			}
		}

		vm.showList = function() {
			vm.showAsList = true;			
		}
		
			// Call Action
		if(Auth.isLoggedIn()){
			vm.loadGroups();
		}
	}
	
	// Setting Modal Controller
	function SmartIoTObservatorySettingModalCtrl($uibModalInstance, $uibModal, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.accessCompanyId = item.accessCompanyId;
		$mdl.clientName = item.clientName;
		$mdl.settings = [];
		$mdl.isLoading = false;
		$mdl.isLockButtons = false;

		$mdl.loadSettings = function() {
			$mdl.isLoading = true;

			HttpSvc.get('smartiot/notificationsettings/list/thirdparty/' + $mdl.accessCompanyId, {}, Auth.getTokenId(), true)
					.then(function(result) {
						$mdl.settings = result;
						$mdl.isLoading = false;
						$mdl.isLockButtons = false;
					}, function() {
						$mdl.isLoading = false;
						$mdl.isLockButtons = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
		}

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ********************************************************** */

		// Open Setting Modal Dialog
		$mdl.addSetting = function (clientCompanyId) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'manageSettingModal.html',
				controller: 'SmartIoTObservatorySettingManageModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							companyId: clientCompanyId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					$mdl.loadSettings();
				}, function () {
				});
		};

		// Open Setting Modal Dialog
		$mdl.editSetting = function (id, clientCompanyId) {
			var setting = angular.copy(setting);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'manageSettingModal.html',
				controller: 'SmartIoTObservatorySettingManageModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							id: id,
							companyId: clientCompanyId,
							setting: setting,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					$mdl.loadSettings();
				}, function () {
				});
		};

		$mdl.deleteSetting = function (id) {
			$mdl.isLockButtons = true;

			HttpSvc.delete('smartiot/notificationsettings/' + id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.loadSettings();
				}, function() {
					$mdl.loadSettings();
					toastr.error('Failed to delete the setting.', 'Delete Failed');
					return null;
			});
		}

		/* ********************************************************** */
		
		// Init
		$mdl.loadSettings();
	};
	
	// Setting Manage Modal Controller
	function SmartIoTObservatorySettingManageModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.mode = item.mode;
		$mdl.title = item.title;
		$mdl.companyId = item.companyId;
		$mdl.setting = {};
		$mdl.sensorList = [];
		$mdl.branches = [];
		$mdl.users = [];
		$mdl.selectedSensor = null;
		$mdl.selectedBranch = null;
		$mdl.selectedUser = null;
		$mdl.isLoading = false;
		$mdl.lockButtons = false;

		if($mdl.mode==1) {
			$mdl.setting.companyId = $mdl.companyId;
			$mdl.setting.triggerAlert = false;
			$mdl.setting.alertByEmail = false;
			$mdl.setting.alertBySms = false;
			$mdl.setting.alertByPN = false;
			$mdl.setting.isThirdParty = true;
		} 
		else 
		{
			$mdl.id = item.id;
		}

		/* ********************************************************** */
	
		$mdl.loadUsers = function() {
			HttpSvc.get("users/listwithsu", {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.users = result;
					$mdl.loadSensors();
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}	

		$mdl.loadSensors = function() {
			HttpSvc.get('smartiot/sensors/listbycompany/' + $mdl.companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.sensorList = result;

					if($mdl.mode==2) {
						$mdl.loadData();
					} else {						
						$mdl.isLoading = false;
					}
				}, function(error) {
					toastr.error('Failed to retrieve active sensor list. ' + error, '');
					return null;
				});
		}

		$mdl.loadData = function() {
			HttpSvc.get("smartiot/notificationsettings/" + $mdl.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.setting = result;
					
					$mdl.sensorList.forEach(function(s) {
						if(s.id==$mdl.setting.sensorId)
						{
							$mdl.selectedSensor = s;
						}
					});
					
					$mdl.users.forEach(function(u) {
						if(u.id==$mdl.setting.userId)
						{
							$mdl.selectedUser = u;
						}
					});
					$mdl.isLoading = false;
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ********************************************************** */

		$mdl.selectedSensorChanged = function() {
			$mdl.setting.sensorId = $mdl.selectedSensor.id;
		}

		$mdl.selectUser = function() {
			$mdl.setting.userId = $mdl.selectedUser.id;
		}

		$mdl.clearSensor = function() {
			$mdl.setting.sensorId = null;
			$mdl.selectedSensor = null;
		}

		/* ********************************************************** */
		
		$mdl.confirmModal = function() {

			if(!$mdl.modalForm.$valid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$mdl.lockButtons = true;

				if($mdl.mode==1) 
				{
					HttpSvc.post("smartiot/notificationsettings", $mdl.setting, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Notification Setting has been created successfully.', Auth.translate('SUCCESS'));
							$uibModalInstance.close();					
						}, function(error) {
							$mdl.lockButtons = false;
							toastr.error(error, 'Failed');
						});	
				}
				else
				{
					HttpSvc.put("smartiot/notificationsettings/" + $mdl.setting.id, $mdl.setting, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Notification Setting has been updated successfully.', Auth.translate('SUCCESS'));
							$uibModalInstance.close();					
						}, function(error) {
							$mdl.lockButtons = false;
							toastr.error(error, 'Failed');
						});	
				}
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ********************************************************** */

		// Init
		$mdl.loadUsers();
	};
	
	// Report Modal Controller
	function SmartIoTObservatoryReportModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.accessCompanyId = item.accessCompanyId;
		$mdl.clientName = item.clientName;
		$mdl.sensorList = [];
		$mdl.dateFrom = "";
		$mdl.dateTo = "";
		$mdl.selectedSensor = null;
		$mdl.isProcessing = false;

		/* ********************************************************** */

		$mdl.loadSensors = function() {
			$mdl.isProcessing = true;
			
			HttpSvc.get('smartiot/sensors/listbycompany/' + $mdl.accessCompanyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.sensorList = result;
					$mdl.isProcessing = false;
				}, function(error) {
					$mdl.isProcessing = false;
					toastr.error('Failed to retrieve active sensor list. ' + error, '');
					return null;
				});
		}
		
		$mdl.downloadPdf = function() {

			$mdl.isProcessing = true;
			
			var filename = "PDF_Temperature_Report_(Details).pdf";
			
			var apiPath = 'smartiot/observatory/print/' + $mdl.accessCompanyId;
			
			if($mdl.selectedSensor != null) {
				apiPath += '/' + $mdl.selectedSensor.id;
			}
			if($mdl.dateFrom != '' && $mdl.dateFrom != null && $mdl.dateTo != '' && $mdl.dateTo != null) {
				apiPath += '/' + $mdl.dateFrom + '/' + $mdl.dateTo;
			}
			
			HttpSvc.getPdfObject(apiPath, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isProcessing = false;
				}, 
				function(error) {
					$mdl.isProcessing = false;
					toastr.error('Failed to generate PDF. ' + error, '');
					return null;
				});
		}
		
		$mdl.downloadPdf2 = function() {

			$mdl.isProcessing = true;
			
			var filename = "PDF_Temperature_Report_(Hourly).pdf";
			
			var apiPath = 'smartiot/observatory/print2/' + $mdl.accessCompanyId;
			
			if($mdl.selectedSensor != null) {
				apiPath += '/' + $mdl.selectedSensor.id;
			}
			if($mdl.dateFrom != '' && $mdl.dateFrom != null && $mdl.dateTo != '' && $mdl.dateTo != null) {
				apiPath += '/' + $mdl.dateFrom + '/' + $mdl.dateTo;
			}
			
			HttpSvc.getPdfObject(apiPath, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isProcessing = false;
				}, 
				function(error) {
					$mdl.isProcessing = false;
					toastr.error('Failed to generate PDF. ' + error, '');
					return null;
				});
		}
		
		$mdl.downloadExcel = function() {
			
			$mdl.isProcessing = true;
			
			var filename = "EXCEL_Temperature_Report.xlsx";
			
			var apiPath = 'smartiot/observatory/export/' + $mdl.accessCompanyId;
			
			if($mdl.selectedSensor != null) {
				apiPath += '/' + $mdl.selectedSensor.id;
			}
			if($mdl.dateFrom != '' && $mdl.dateFrom != null && $mdl.dateTo != '' && $mdl.dateTo != null) {
				apiPath += '/' + $mdl.dateFrom + '/' + $mdl.dateTo;
			}
					
			HttpSvc.getExcelObject(apiPath, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isProcessing = false;
				}, 
				function(error) {
					$mdl.isProcessing = false;
					toastr.error('Failed to generate Excel. ' + error, '');
					return null;
				});
		}
		/* ********************************************************** */

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Init
		$mdl.loadSensors();
	};
	
})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.iotdashboard.smartiotplanview.controller', [])
        .controller('SmartIoTPlanViewCtrl', SmartIoTPlanViewCtrl)
        .controller('SmartIoTPlanViewActionPaneCtrl', SmartIoTPlanViewActionPaneCtrl);

    /** @ngInject */
    function SmartIoTPlanViewCtrl($scope, $state, $filter, $interval, $timeout, $uibModal, Auth, Fullscreen, HttpSvc, RmsApi, toastr) {
      Auth.init();	
      
      var vm = this;
      var interval = null;

      vm.layoutList = [];
      vm.selectedLayout = null;
      vm.currentLayoutImage = null;
      vm.rootUrl = (Auth.getServerMode()==1 ? RmsApi.BLOBURL : RmsApi.LOCALURL);
      vm.isLoading = false;
      
      /* ********************************************************* */

      vm.toggleFullscreen = function() {
        var element = document.getElementById('layoutParent');
  
        if(document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement ||
          document.msFullscreenElement)
        {
          document.exitFullscreen();
        }
        else
        {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullScreen) {
            element.msRequestFullScreen();
          }
        }			
      }
      
      $scope.$on('$destroy', function(){
        $interval.cancel(interval);
      });

      /* ********************************************************* */
      
      vm.loadAllLayouts = function() {
        vm.isLoading = true;

        HttpSvc.get('smartiotplanviewdesigner/floorview/list', {}, Auth.getTokenId(), true)
          .then(function(result) {	
              vm.layoutList = result;
              if(vm.layoutList.length > 0)
              {
                vm.selectedLayout = vm.layoutList[0];
                vm.showLayout(vm.selectedLayout.id);
              }
              vm.isLoading = false;
          }, function() {
              vm.isLoading = false;
              toastr.error('Failed to retrieve data.', '');
              return null;
          });
      }
      
      vm.loadSingleLayout = function(designId) {
        vm.isLoading = true;
        HttpSvc.get('smartiotplanviewdesigner/floorview/' + designId, {}, Auth.getTokenId(), false)
          .then(function(result) {	
              vm.selectedLayout = result;
              vm.processLayoutImage();
          }, function() {
              vm.isLoading = false;
              toastr.error('Failed to retrieve data.', '');
              return null;
          });
      }

      vm.showLayout = function(designId) {
        vm.loadSingleLayout(designId);

        $interval.cancel(interval);
        interval = $interval(vm.loadSingleLayout, 180000, 0, true, designId);
        // 3 minutes
      }

      vm.processLayoutImage = function() {
          if(!vm.selectedLayout.layoutImage || vm.selectedLayout.layoutImage=='') {
            vm.currentLayoutImage = 'assets/img/empty_placeholder_iotdesigner.jpg';
          } else {                  
            vm.currentLayoutImage = vm.rootUrl + vm.selectedLayout.layoutImage;
          }
          vm.isLoading = false;
      }

      /* ********************************************************* */

      vm.showAssetInfoPopup = function(object) {        
        object.tooltipIsOpen = true;  
        $timeout(function() { vm.loadAssetInfoInPopup(object) }, 500);
      }

      vm.loadAssetInfoInPopup = function(asset) {

      }

      vm.showSensorInfoPopup = function(object) {
        object.tooltipIsOpen = true;  
        $timeout(function() { vm.loadSensorInfoInPopup(object) }, 500);
      }

      vm.loadSensorInfoInPopup = function(sensor) {
        
        sensor.chart = {};
        
        var startDate = new Date();
        startDate.setTime(startDate.getTime() - (1*60*60*1000)); 
        startDate = new Date(startDate.setDate(startDate.getDate()));
        startDate = $filter('date')(startDate, 'dd-MM-yyyy hh:mma');
        var endDate = new Date();
        endDate.setDate(endDate.getDate())
        endDate = $filter('date')(endDate, 'dd-MM-yyyy hh:mma');
        
        var params = {
          dateFrom: startDate,
          dateTo: endDate
        }

        HttpSvc.post('smartiot/datahub/stats/sensor/'+ sensor.sensorId, params, Auth.getTokenId(), false)
          .then(function(result) {	
            
            sensor.chart.labels = result.labels;
            sensor.chart.seriesT = result.seriesT;
            sensor.chart.seriesH = result.seriesH;
            sensor.chart.seriesAmp = result.seriesAmp;
            //sensor.chart.dangerZoneList = result.dangerZoneList;
            sensor.chart.suggestedMaxTemp = result.suggestedMaxTemp;
            sensor.chart.suggestedMinTemp = result.suggestedMinTemp;
            sensor.chart.suggestedMaxHumi = result.suggestedMaxHumi;
            sensor.chart.suggestedMinHumi = result.suggestedMinHumi;

            sensor.chart.temperature = result.temperature;
            sensor.chart.humidity = result.humidity;
            sensor.chart.ec = result.ec;
            sensor.chart.n = result.n;
            sensor.chart.p = result.p;
            sensor.chart.k = result.k;
            sensor.chart.ph = result.ph;
            sensor.chart.pm = result.pm;
            sensor.chart.amp = result.amp;
            sensor.chart.ltr = result.ltr;
            sensor.chart.batteryLevel = result.batteryLevel;

            sensor.chart.hasTemp = result.hasTemp;
            sensor.chart.hasHumi = result.hasHumi;
            sensor.chart.hasNPK = result.hasNPK;
            sensor.chart.hasEc = result.hasEc;
            sensor.chart.hasPh = result.hasPh;
            sensor.chart.hasPm = result.hasPm;
            sensor.chart.hasElecMeter = result.hasElecMeter;
            sensor.chart.hasWaterMeter = result.hasWaterMeter;
            
            sensor.chart.symbolTemp = vm.getMetric(result, 'TEMP', result.isF);
            sensor.chart.symbolHumi = vm.getMetric(result, 'HUMI');
            sensor.chart.symbolN = vm.getMetric(result, 'N');
            sensor.chart.symbolP = vm.getMetric(result, 'P');
            sensor.chart.symbolK = vm.getMetric(result, 'K');
            sensor.chart.symbolEc = vm.getMetric(result, 'EC');
            sensor.chart.symbolPh = vm.getMetric(result, 'PH');
            sensor.chart.symbolPm = vm.getMetric(result, 'PM2.5');
            sensor.chart.symbolAmp = vm.getMetric(result, 'AMP');
            sensor.chart.symbolLtr = vm.getMetric(result, 'LTR');

            sensor.chart.toAlertTemp = result.toAlertTemp;
            sensor.chart.toAlertHumi = result.toAlertHumi;
            sensor.chart.toAlertN = result.toAlertN;
            sensor.chart.toAlertP = result.toAlertP;
            sensor.chart.toAlertK = result.toAlertK;
            sensor.chart.toAlertEc = result.toAlertEc;
            sensor.chart.toAlertPh = result.toAlertPh;
            sensor.chart.toAlertPm = result.toAlertPm;
            sensor.chart.toAlertAmp = result.toAlertAmp;

            sensor.chart.colors = ['#0000FF', '#3D9400'];
            sensor.chart.seriesMain = ["Temperature", "Humidity"];
            sensor.chart.dataMain = [sensor.chart.seriesT, sensor.chart.seriesH];


            sensor.chart.colorsAmp = ['#FFB800'];
            sensor.chart.seriesAmp = ["Ampere"];
            sensor.chart.dataAmp = [sensor.chart.seriesAmp];

            // for(var i=0; i<sensor.chart.dangerZoneList.length; i++) 
            // {
            //   var obj = sensor.chart.dangerZoneList[i];
            //   sensor.chart.seriesMain.push(obj.description);
            //   sensor.chart.dataMain.push(obj.temperatureList);
            //   sensor.chart.colors.push(obj.colorCode);
            // }

            sensor.chart.optionsMain = {
              scales: {
                yAxes: [
                  {
                    id: 'y-axis-1',
                    type: 'linear',
                    display: true,
                    position: 'left', 
                    ticks: {
                      //stepSize: 1,
                      suggestedMin: sensor.chart.suggestedMinTemp,
                      suggestedMax: sensor.chart.suggestedMaxTemp
                    }
                  },
                  {
                    id: 'y-axis-2',
                    type: 'linear',
                    display: true,
                    position: 'right', 
                    ticks: {
                      //stepSize: 1,
                      suggestedMin: sensor.chart.suggestedMinHumi,
                      suggestedMax: sensor.chart.suggestedMaxHumi
                    }
                  }
                ]
              },
              legend: {
                display: false,
                position: 'top'
              }
            };
            
            sensor.chart.optionsOther = {
              animation: false,
              scales: {
                  yAxes: [
                  {
                    id: 'y-axis-1',
                    type: 'linear',
                    display: true,
                    position: 'left', 
                    ticks: {
                      //stepSize: 1,
                    }
                  }
                  ]
              },
              legend: {
                display: false,
                position: 'top'
              }
            };

            sensor.chart.datasetOverride = [
              {
                borderWidth: 0,
                fill: false,
                yAxisID: 'y-axis-1'
              },
              {
                borderWidth: 0,
                fill: false,
                yAxisID: 'y-axis-2'
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              }
            ];

            sensor.chart.datasetOverride2 = [
              {
                borderWidth: 0,
                fill: false,
                yAxisID: 'y-axis-1'
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              },
              {
                borderWidth: 0,
                fill: false,
              }
            ];
          }, function() {
            toastr.error('[PopUp] Failed to retrieve data.', '');
            return null;
          });
      }
      
      /* ************************************************** */
      
      vm.showActionPane = function (sensor) {
        sensor.tooltipIsOpen = false;

        var parentElem = angular.element(document.getElementById("layoutParent"));

        var modalInstance = $uibModal.open({
            animation: false,
            keyboard: false,
            backdrop: 'static',
            windowClass: 'app-modal-window',
            templateUrl: 'actionPaneModal.html',
            controller: 'SmartIoTPlanViewActionPaneCtrl',
            controllerAs: '$mdl',
            appendTo: parentElem,
            size: 'sm',
            resolve: {
                item: function () {
                    return {
                        sensor: sensor
                    }
                }
            }
        });

        modalInstance
            .result
            .then(function (data) {
                // sensor.tooltipIsOpen = true;
                // toastr.info(JSON.stringify(data));
            }, function () {
            });
      };

      /* ********************************************************* */

      vm.hasAlert = function(stats) {
        var result = 
          (stats.toTempAlert ||
            stats.toHumiAlert ||
            stats.toNPKAlert ||
            stats.toPmAlert ||
            stats.toPhAlert ||
            stats.toEcAlert ||
           stats.toAmpAlert);
        
        return result;
      }

		  vm.getMetric = function(sensor, code, isF) {
        var metric = "";
        sensor.metrics.forEach(function(m) {
          if(m.code==code)
          {
            metric = m.uom;
            if(isF)
            {
              metric = m.uom2;
            }
          }
        });

        return metric;
      }

      vm.getLayoutWidth = function() {        
        var element = document.getElementById('layoutParent');
        return element.offsetWidth;
      }
      
      vm.getLayoutHeight = function() {        
        var element = document.getElementById('layoutParent');
        return element.offsetHeight;
      }

      vm.getCoorX = function(currX) {
        var element = document.getElementById('layoutParent');

        var w = element.offsetWidth;
        var h = element.offsetHeight; 
        
        var ratioX = w / 1920;
        var ratioY = h / 1080;

        var diffX = w - 1920;
        var diffY = h - 1080;

        if(diffX < diffY)
        {
          return currX * ratioX;
        }
        else if(diffX > diffY)
        {
          return currX * ratioY;
        }
        else
          return currX;
      }

      vm.getCoorY = function(currY) {
        var element = document.getElementById('layoutParent');

        var w = element.offsetWidth;
        var h = element.offsetHeight; 
        
        var ratioX = w / 1920;
        var ratioY = h / 1080;

        var diffX = w - 1920;
        var diffY = h - 1080;

        if(diffX < diffY)
        {
          return currY * ratioX;
        }
        else if(diffX > diffY)
        {
          return currY * ratioY;
        }
        else
          return currY;
      }

      /* ********************************************************* */

      vm.loadAllLayouts();
    }
    
    /** @ngInject */
    function SmartIoTPlanViewActionPaneCtrl($uibModalInstance, $timeout, Auth, RmsApi, HttpSvc, UtilSvc, item, toastr) {
      var $mdl = this;

      $mdl.sensor = item.sensor;
      $mdl.item = {};
      $mdl.errorMsg = "";
      $mdl.showError = false;
      $mdl.showSuccess = false;
      $mdl.lockButton = false;

      /* ********************************************************* */
						
      $mdl.confirmModal = function() {
        if($mdl.actionPaneForm.$invalid) {
          $mdl.errorMsg = UtilSvc.getErrorMessage($mdl.actionPaneForm);          
          $mdl.showError = true;
        } else {
          $mdl.lockButton = true;
          $mdl.showError = false;

          $mdl.item.sensorId = $mdl.sensor.sensorId;
          $mdl.item.temperature = $mdl.sensor.temperature;
          $mdl.item.temperatureF = $mdl.sensor.temperature;
          $mdl.item.humidity = $mdl.sensor.humidity;
          $mdl.item.amp = $mdl.sensor.amp;
          $mdl.item.ec = $mdl.sensor.ec;
          $mdl.item.n = $mdl.sensor.n;
          $mdl.item.p = $mdl.sensor.p;
          $mdl.item.k = $mdl.sensor.k;
          $mdl.item.ph = $mdl.sensor.ph;
          $mdl.item.pm = $mdl.sensor.pm;
          $mdl.item.batteryLevel = $mdl.sensor.batteryLevel;

          HttpSvc.post('smartiot/correctiveactions', $mdl.item, Auth.getTokenId(), false)
            .then(function(result) {
              $mdl.showSuccess = true;
              $timeout($uibModalInstance.close, 1500);
            }, function(error) {
              $mdl.errorMsg = error;
              $mdl.showError = true;
              $mdl.lockButton = false;
            });
        }
      };
      
      // Cancel Action
      $mdl.cancelModal = function() {
        $uibModalInstance.dismiss('cancel');
      };
    };	
    
})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('RmsAppV2.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '=',
        switcherChange: '&',
      }
    };
  }

})();

(function() {
    'use strict';

    angular.module('RmsAppV2.pages.iotdashboard.ezysite.controller', [])
        .controller('IotEzySiteCtrl', IotEzySiteCtrl)
		.controller('IotEzySiteGraphCtrl', IotEzySiteGraphCtrl)		
		.controller('IotEzySiteGraphModalCtrl', IotEzySiteGraphModalCtrl)		
        .controller('IoTEzySiteActionPaneCtrl', IoTEzySiteActionPaneCtrl);

    /** @ngInject */
    function IotEzySiteCtrl($interval, $scope, $timeout, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.gateways = [];
		vm.sensorList = [];
		vm.selectedGateway = null;
		vm.interval = null;
		vm.isLoadingGateways = false;
		vm.isLoadingSensors = false;
		vm.isFirstLoad = true;
		
		vm.hideDateRange = false;
		vm.hidePanel = false;
		vm.showAsSummary = true;	
		vm.showAsChart = false;
		vm.columnWidth = 6;

		/* ********************************************************************** */

		vm.loadGateways = function() {
			vm.isLoadingGateways = true;

			HttpSvc.get('iothub/list/gateways', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.gateways = result;
					vm.isLoadingGateways = false;
				}, function() {
					toastr.error('Failed to retrieve data.', '');
					vm.isLoadingGateways = false;
					return null;
				});
		}

		vm.loadSensors = function() {
			vm.isLoadingSensors = true;
			if(vm.isFirstLoad)
			{
				vm.isFirstLoad = false;
				vm.sensorList = [];
			}

			HttpSvc.get('iothub/readingbygateway/lasthour/' + vm.selectedGateway.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.sensorList = result;
					vm.isLoadingSensors = false;
				}, function() {
					toastr.error('Failed to retrieve data.', '');
					vm.isLoadingSensors = false;
					return null;
				});
		}

		/* ********************************************************************** */
		
		vm.selectGateway = function(gatewayId) {
			vm.gateways.forEach(function(g) {
				if(g.id==gatewayId) 
				{
					vm.selectedGateway=g;
					vm.loadSensors();
					vm.interval = $interval(vm.loadSensors, 180000);
				}
			});
		}		
		
		vm.resetGateway = function() 
		{
			vm.selectedGateway = null;
			vm.isFirstLoad = true;	
			$interval.cancel(vm.interval);
		}
		
		$scope.$on('$destroy', function()
		{
			$interval.cancel(vm.interval);
		});
		
		/* ********************************************************************** */
		
		vm.refreshPanel = function() {
			vm.hidePanel = true;
			$timeout(function() {
				vm.hidePanel = false;
			}, 50);
		}

		vm.setColumnWidth = function(columnCount) {
			vm.showAsSummary = false;
			vm.showAsChart = true;

			if(columnCount==2) 
			{
				vm.columnWidth = 6;
				vm.hideDateRange = false;
			}
			else if(columnCount==4) 
			{
				vm.columnWidth = 3;
				vm.hideDateRange = true;
			}
		}

		vm.showSummary = function() {
			vm.showAsSummary = true;
			vm.showAsChart = false;
		}
		
		/* ********************************************************************** */

		vm.showGraphModal = function (sensor) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'graphModal.html',
				controller: 'IotEzySiteGraphModalCtrl',
				controllerAs: '$mdl',				
				size: 'lg',
				resolve: {
					item: function () {
						return {
							sensorId: sensor.sensorId,
							sensorDesc: sensor.description,
							sensorUID: sensor.deviceUID,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};
		
		/* ********************************************************************** */
				
		// Call Action
		if(Auth.isLoggedIn())
		{
			vm.loadGateways();
		}
	};
	
	/** @ngInject */
	function IotEzySiteGraphCtrl($scope, $filter, $interval, $timeout, $uibModal, Auth, HttpSvc, toastr) {
		
		$scope.readings = [];
		$scope.toAlertTemp = false;
		$scope.toAlertHumi = false;

		$scope.sensor = {};
		
		$scope.graph = {};
		$scope.graph.lockDateRange = false;
		$scope.graph.startDate = new Date();
		$scope.graph.endDate = new Date();

		$scope.currentTemp = 0;
		$scope.colorCode = "transparent";
		$scope.startDate = new Date();
		$scope.endDate = new Date();
		$scope.isLoading = false;
		$scope.isFirstLoad = true;
		$scope.toBlink = false;
		var timeout = null;

		
		/* ************************************************** */

		$scope.initDateRange = function() {
			$scope.graph.startDate = new Date();
			$scope.graph.startDate.setTime($scope.graph.startDate.getTime() - (1*60*60*1000)); 
			$scope.graph.startDate = new Date($scope.graph.startDate.setDate($scope.graph.startDate.getDate()));
			$scope.graph.startDate = $filter('date')($scope.graph.startDate, 'dd-MM-yyyy hh:mma');
			$scope.graph.endDate = new Date();
			$scope.graph.endDate.setDate($scope.graph.endDate.getDate())
			$scope.graph.endDate = $filter('date')($scope.graph.endDate, 'dd-MM-yyyy hh:mma');
		}

		$scope.loadData = function() {
			
			$scope.isLoading = true;
			
			if(!$scope.graph.lockDateRange)
				$scope.initDateRange();

			var params = {
				dateFrom: $scope.graph.startDate,
				dateTo: $scope.graph.endDate,
			}

			HttpSvc.post('iothub/readingbydaterange/'+ $scope.sensorId, params, Auth.getTokenId(), false)
				.then(function(result) {	
					$scope.sensor.sensorId  = $scope.sensorId;
					$scope.sensor.currentTemp  = result.currentTemp;
					$scope.sensor.currentHumi  = result.currentHumi;
					$scope.sensor.currentBatt  = result.currentBatt;
					$scope.sensor.symbol  = result.symbol;

					$scope.labels = result.labels;
					$scope.seriesT = result.seriesT;
					$scope.seriesH = result.seriesH;
					$scope.tempDangerZoneList = result.tempDangerZoneList;
					$scope.humiDangerZoneList = result.humiDangerZoneList;
					$scope.suggestedMaxTemp = result.suggestedMaxTemp;
					$scope.suggestedMinTemp = result.suggestedMinTemp;
					$scope.currentTemp = result.currentTemp;
					$scope.currentHumi = result.currentHumi;
					$scope.currentBatt = result.currentBatt;
					$scope.symbol = result.symbol;
					$scope.toAlertTemp = result.toAlertTemp;
					$scope.toAlertHumi = result.toAlertHumi;

					$scope.colors = ['#0000FF', '#3D9400'];
					$scope.seriesMain = ["Temperature", "Humidity"];
					$scope.dataMain = [$scope.seriesT, $scope.seriesH];

					if($scope.sensorShowDangerZone)
					{
						for(var i=0; i<$scope.tempDangerZoneList.length; i++) 
						{
							var obj = $scope.tempDangerZoneList[i];
							$scope.seriesMain.push(obj.description);
							$scope.dataMain.push(obj.temperatureList);
							$scope.colors.push(obj.colorCode);
						}
	
						for(var i=0; i<$scope.humiDangerZoneList.length; i++) 
						{
							var obj = $scope.humiDangerZoneList[i];
							$scope.seriesMain.push(obj.description);
							$scope.dataMain.push(obj.humidityList);
							$scope.colors.push(obj.colorCode);
						}
					}

					$scope.optionsMain = {
						animation: false,
						scales: {
							yAxes: [
								{
									id: 'y-axis-1',
									type: 'linear',
									display: true,
									position: 'left', 
									ticks: {
										//stepSize: 1,
										//suggestedMin: ($scope.sensorShowDangerZone ? $scope.suggestedMinTemp : null),
										//suggestedMax: ($scope.sensorShowDangerZone ? $scope.suggestedMaxTemp : null)
										suggestedMin: $scope.suggestedMinTemp,
										suggestedMax: $scope.suggestedMaxTemp
									}
								},
								{
									id: 'y-axis-2',
									type: 'linear',
									display: (($scope.currentHumi!=0 && $scope.currentHumi!=-1) ? true : false),
									position: 'right', 
									ticks: {
										//stepSize: 1,
										//suggestedMin: ($scope.sensorShowDangerZone ? $scope.suggestedMinTemp : null),
										//suggestedMax: ($scope.sensorShowDangerZone ? $scope.suggestedMaxTemp : null)
										suggestedMin: $scope.suggestedMinHumi,
										suggestedMax: $scope.suggestedMaxHumi
									}
								}
							]
						},
						legend: {
							display: false,
							position: 'top'
						}
					};
					
					$scope.datasetOverride = [
						{
							borderWidth: 0,
							fill: false,
							yAxisID: 'y-axis-1'
						},
						{
							borderWidth: 0,
							fill: false,
							yAxisID: 'y-axis-2'
						},
						{
							borderWidth: 0,
							fill: false,
						},
						{
							borderWidth: 0,
							fill: false,
						},
						{
							borderWidth: 0,
							fill: false,
						},
						{
							borderWidth: 0,
							fill: false,
						},
						{
							borderWidth: 0,
							fill: false,
						},
						{
							borderWidth: 0,
							fill: false,
						}
					];
					
					$scope.isFirstLoad = false;
					$scope.isLoading = false;

					if($scope.toAlertTemp || $scope.toAlertHumi) {
						timeout = $timeout($scope.setBlink, 1000);
					} else {
						$timeout.cancel(timeout);
					}
				}, function() {
					$scope.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}
		
		$scope.initDateRange();
		$scope.loadData();
		var interval = $interval($scope.loadData, 180000);
		
		/* ************************************************** */
		
		$scope.showGraphModal = function (item) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'graphModal.html',
				controller: 'IotEzySiteGraphModalCtrl',
				controllerAs: '$mdl',				
				size: 'lg',
				resolve: {
					item: function () {
						return {
							sensorId: $scope.sensorId,
							sensorDesc: $scope.sensorDesc,
							sensorDeviceUid: $scope.sensorDeviceUid,
							lockDateRange: $scope.graph.lockDateRange,
							startDate: $scope.graph.startDate,
							endDate: $scope.graph.endDate,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};
		
		/* ************************************************** */
				
		$scope.showActionPane = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'actionPaneModal.html',
				controller: 'IoTEzySiteActionPaneCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							sensor: $scope.sensor
						}
					}
				}
			});
	
			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		}
		
		/* ************************************************** */

		$scope.setBlink = function() {
			$scope.toBlink = true;
			timeout = $timeout($scope.setNotBlink, 1000);
		}
		
		$scope.setNotBlink = function() {
			$scope.toBlink = false;
			timeout = $timeout($scope.setBlink, 1000);
		}

		/* ************************************************** */

		$scope.$on('$destroy', function(){
			$interval.cancel(interval);
			$timeout.cancel(timeout);
		});
	};

	/** @ngInject */
	function IotEzySiteGraphModalCtrl($uibModalInstance, $filter, $interval, $timeout, Auth, HttpSvc, item, toastr) {
		var $mdl = this;

		$mdl.readings = [];
		$mdl.toAlertTemp = false;
		$mdl.toAlertHumi = false;
		$mdl.lockDateRange = false;
		$mdl.currentTemp = 0;
		$mdl.colorCode = "transparent";
		$mdl.startDate = new Date();
		$mdl.endDate = new Date();
		$mdl.sensorId = item.sensorId;
		$mdl.sensorDesc = item.sensorDesc;
		$mdl.sensorDeviceUid = item.sensorUID;
		$mdl.isLoading = false;
		$mdl.isFirstLoad = true;
		$mdl.toBlink = false;
		var timeout = null;

		$mdl.initDateRange = function() {
			$mdl.startDate = new Date();
			$mdl.startDate.setTime($mdl.startDate.getTime() - (1*60*60*1000)); 
			$mdl.startDate = new Date($mdl.startDate.setDate($mdl.startDate.getDate()));
			$mdl.startDate = $filter('date')($mdl.startDate, 'dd-MM-yyyy hh:mma');
			$mdl.endDate = new Date();
			$mdl.endDate.setDate($mdl.endDate.getDate())
			$mdl.endDate = $filter('date')($mdl.endDate, 'dd-MM-yyyy hh:mma');
		}

		$mdl.loadData = function() {
			
			$mdl.isLoading = true;

			if(!$mdl.lockDateRange)
				$mdl.initDateRange();

			var params = {
				dateFrom: $mdl.startDate,
				dateTo: $mdl.endDate,
			}
			
			HttpSvc.post('iothub/readingbydaterange/'+ $mdl.sensorId, params, Auth.getTokenId(), false)
				.then(function(result) {	
					
					$mdl.labels = result.labels;
					$mdl.seriesT = result.seriesT;
					$mdl.seriesH = result.seriesH;
					$mdl.tempDangerZoneList = result.tempDangerZoneList;
					$mdl.humiDangerZoneList = result.humiDangerZoneList;
					$mdl.suggestedMaxTemp = result.suggestedMaxTemp;
					$mdl.suggestedMinTemp = result.suggestedMinTemp;
					$mdl.currentTemp = result.currentTemp;
					$mdl.currentTemp = result.currentTemp;
					$mdl.currentHumi = result.currentHumi;
					$mdl.currentBatt = result.currentBatt;
					$mdl.symbol = result.symbol;
					$mdl.toAlertTemp = result.toAlertTemp;
					$mdl.toAlertHumi = result.toAlertHumi;

					$mdl.colors = ['#0000FF', '#3D9400'];
					$mdl.seriesMain = ["Temperature", "Humidity"];
					$mdl.dataMain = [$mdl.seriesT, $mdl.seriesH];

					for(var i=0; i<$mdl.tempDangerZoneList.length; i++) 
					{
						var obj = $mdl.tempDangerZoneList[i];
						$mdl.seriesMain.push(obj.description);
						$mdl.dataMain.push(obj.temperatureList);
						$mdl.colors.push(obj.colorCode);
					}

					for(var i=0; i<$mdl.humiDangerZoneList.length; i++) 
					{
						var obj = $mdl.humiDangerZoneList[i];
						$mdl.seriesMain.push(obj.description);
						$mdl.dataMain.push(obj.humidityList);
						$mdl.colors.push(obj.colorCode);
					}

					$mdl.optionsMain = {
						animation: false,
						scales: {
						  	yAxes: [
								{
									id: 'y-axis-1',
									type: 'linear',
									display: true,
									position: 'left', 
									ticks: {
										//stepSize: 1,
										suggestedMin: $mdl.suggestedMinTemp,
										suggestedMax: $mdl.suggestedMaxTemp
									}
								},
								{
									id: 'y-axis-2',
									type: 'linear',
									display: (($mdl.currentHumi!=0 && $mdl.currentHumi!=-1) ? true : false),
									position: 'right', 
									ticks: {
										//stepSize: 1,
										suggestedMin: $mdl.suggestedMinHumi,
										suggestedMax: $mdl.suggestedMaxHumi
									}
								}
						  	]
						},
						legend: {
							display: true,
							position: 'top'
						}
					};
					
					$mdl.datasetOverride = [
						{
							borderWidth: 0,
							fill: false,
							yAxisID: 'y-axis-1'
						},
						{
							borderWidth: 0,
							fill: false,
							yAxisID: ($mdl.currentHumi!=-1 ? 'y-axis-2' : '')
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						}
					];					

					$mdl.isFirstLoad = false;
					$mdl.isLoading = false;

					if($mdl.toAlertTemp || $mdl.toAlertHumi) {
						timeout = $timeout($mdl.setBlink, 1000);
					} else {
						$timeout.cancel(timeout);
					}
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}
		
		$mdl.initDateRange();
		$mdl.loadData();
		var interval = $interval($mdl.loadData, 180000);
		
		/* ************************************************** */

		$mdl.setBlink = function() {
			$mdl.toBlink = true;
			timeout = $timeout($mdl.setNotBlink, 1000);
		}
		
		$mdl.setNotBlink = function() {
			$mdl.toBlink = false;
			timeout = $timeout($mdl.setBlink, 1000);
		}
		
		// ********************************************************		
		
		// Cancel Action
		$mdl.cancelModal = function() {			
			$interval.cancel(interval);
			$timeout.cancel(timeout);
			$uibModalInstance.dismiss('cancel');
		};
	};	
    
    /** @ngInject */
    function IoTEzySiteActionPaneCtrl($uibModalInstance, $timeout, Auth, RmsApi, HttpSvc, UtilSvc, item, toastr) {
      var $mdl = this;

      $mdl.sensor = item.sensor;
      $mdl.item = {};
      $mdl.errorMsg = "";
      $mdl.showError = false;
      $mdl.showSuccess = false;
      $mdl.lockButton = false;

      /* ********************************************************* */
						
      $mdl.confirmModal = function() {
        if($mdl.actionPaneForm.$invalid) {
          $mdl.errorMsg = UtilSvc.getErrorMessage($mdl.actionPaneForm);          
          $mdl.showError = true;
        } else {
          $mdl.lockButton = true;
          $mdl.showError = false;

          $mdl.item.sensorId = $mdl.sensor.sensorId;
          $mdl.item.temperature = $mdl.sensor.currentTemp;
          $mdl.item.humidity = $mdl.sensor.currentHumi;
          $mdl.item.batteryLevel = $mdl.sensor.currentBatt;

          HttpSvc.post('iotcorrectiveactions', $mdl.item, Auth.getTokenId(), false)
            .then(function(result) {
              $mdl.showSuccess = true;
              $timeout($uibModalInstance.close, 1500);
            }, function(error) {
              $mdl.errorMsg = error;
              $mdl.showError = true;
              $mdl.lockButton = false;
            });
        }
      };
      
      // Cancel Action
      $mdl.cancelModal = function() {
        $uibModalInstance.dismiss('cancel');
      };
    };

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotdashboard.ezysite')
		.directive('iotEzySiteGraph', iotEzySiteGraph)
		.directive('iotEzySiteListItem', iotEzySiteListItem);
	
	/** @ngInject */
	function iotEzySiteGraph() {
		return {
			restrict: 'E',
			scope: {
				sensorId: '=',
				sensorDesc: '=',
				sensorDeviceUid: '=',
				sensorHideDateRange: '=',
				sensorShowDangerZone: '=',
			},
			controller: 'IotEzySiteGraphCtrl',
			templateUrl: 'app/pages/dashboard_iot/ezysite/ezysiteGraph.html',
		};
	};
	
	/** @ngInject */
	function iotEzySiteListItem() {
		return {
			restrict: 'E',
			scope: {
				sensorId: '=',
				sensorDesc: '=',
				sensorDeviceUid: '=',
			},
			controller: 'IotEzySiteListCtrl',
			templateUrl: 'app/pages/dashboard_iot/ezysite/ezysiteListItem.html',
		};
	};
	
})();
(function() {
    'use strict';

    angular.module('RmsAppV2.pages.iotdashboard.smartiot.controller', [])
        .controller('SmartIoTCtrl', SmartIoTCtrl)
		.controller('SmartIoTGatewayCtrl', SmartIoTGatewayCtrl)
		.controller('SmartIoTSensorCtrl', SmartIoTSensorCtrl)
		.controller('SmartIoTSensorModalCtrl', SmartIoTSensorModalCtrl)	
        .controller('SmartIoTSensorActionPaneCtrl', SmartIoTSensorActionPaneCtrl);

    /** @ngInject */
    function SmartIoTCtrl($scope, $filter, $timeout, $uibModal, $interval, Auth, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		vm.groups = [];
		vm.sensorList = [];
		vm.selectedGroup = null;
		vm.interval = null;
		vm.isLoadingGateways = false;
		vm.isLoadingSensors = false;
		vm.isFirstLoad = true;
		
		vm.hideDateRange = false;
		vm.hidePanel = false;
		vm.showAsSummary = true;	
		vm.showAsChart = false;
		vm.columnWidth = 6;

		vm.lastRefreshDateTime = null;

		/* ********************************************************************** */

		vm.loadGroups = function() {
			vm.isLoadingGateways = true;

			HttpSvc.post('smartiot/datahub/list/groups', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.groups = result;
					vm.isLoadingGateways = false;
				}, function() {
					toastr.error('Failed to retrieve Smart IoT Groups.', '');
					vm.isLoadingGateways = false;
					return null;
				});
		}

		vm.loadSensors = function() {
			vm.isLoadingSensors = true;
			if(vm.isFirstLoad)
			{
				vm.isFirstLoad = false;
				vm.sensorList = [];
			}

			HttpSvc.post('smartiot/datahub/stats/lasthour/' + vm.selectedGroup.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					vm.sensorList = result;
					vm.isLoadingSensors = false;
					vm.lastRefreshDateTime = $filter('date')(new Date(), 'hh:mma');
				}, function() {
					toastr.error('Failed to retrieve data.', '');
					vm.isLoadingSensors = false;
					return null;
				});
		}

		/* ********************************************************************** */

		vm.getBatteryClass = function (batteryLevel) {
			if (batteryLevel === 0) {
				return '0';
			} else if (batteryLevel >= 1 && batteryLevel <= 20) {
				return '1';
			} else if (batteryLevel >= 21 && batteryLevel <= 40) {
				return '2';
			} else if (batteryLevel >= 41 && batteryLevel <= 80) {
				return '4';
			} else if (batteryLevel >= 81 && batteryLevel <= 100) {
				return '6';
			} 
		}

		vm.selectGroup = function(groupId) {
			vm.groups.forEach(function(g) {
				if(g.id==groupId) {
					vm.selectedGroup=g;
					vm.loadSensors();
					vm.interval = $interval(vm.loadSensors, 180000);
				}
			});
		}		
		
		vm.resetGroup = function() {
			vm.selectedGroup = null;
			vm.isFirstLoad = true;	
			$interval.cancel(vm.interval);
		}
		
		$scope.$on('$destroy', function()
		{
			$interval.cancel(vm.interval);
		});
		
		/* ********************************************************************** */
		
		vm.refreshPanel = function() {
			vm.hidePanel = true;
			$timeout(function() {
				vm.hidePanel = false;
			}, 50);
		}

		vm.setColumnWidth = function(columnCount) {
			vm.showAsSummary = false;
			vm.showAsChart = true;

			if(columnCount==2) 
			{
				vm.columnWidth = 6;
				vm.hideDateRange = false;
			}
			else if(columnCount==4) 
			{
				vm.columnWidth = 3;
				vm.hideDateRange = true;
			}
		}

		vm.showSummary = function() {
			vm.showAsSummary = true;
			vm.showAsChart = false;
		}
		
		/* ********************************************************************** */
		
		vm.showGraphModal = function (sensor) {
			var modalInstance = $uibModal.open({
				animation: false,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'graphModal.html',
				controller: 'SmartIoTSensorModalCtrl',
				controllerAs: '$mdl',				
				size: 'lg',
				resolve: {
					item: function () {
						return {
							sensorId: sensor.sensorId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};
		
		/* ********************************************************************** */
		
		// Call Action
		if(Auth.isLoggedIn()){
			vm.loadGroups();
		}
	};
	
	/** @ngInject */
	function SmartIoTGatewayCtrl($scope, $filter, $interval, $timeout, $uibModal, Auth, HttpSvc, toastr) {
		
		$scope.gateway = {};
		$scope.isLoading = false;
		
		/* ************************************************** */
		
		$scope.initDateRange = function() {
			$scope.params = {};
			$scope.params.startDate = new Date();
			$scope.params.startDate.setTime($scope.params.startDate.getTime() - (1*60*60*1000)); 
			$scope.params.startDate = new Date($scope.params.startDate.setDate($scope.params.startDate.getDate()));
			$scope.params.startDate = $filter('date')($scope.params.startDate, 'dd-MM-yyyy hh:mma');
			$scope.params.endDate = new Date();
			$scope.params.endDate.setDate($scope.params.endDate.getDate())
			$scope.params.endDate = $filter('date')($scope.params.endDate, 'dd-MM-yyyy hh:mma');
		}

		/* ************************************************** */
		
		$scope.loadData = function() {
			
			$scope.isLoading = true;
			
			var params = {
				dateFrom: $scope.params.startDate,
				dateTo: $scope.params.endDate,
			}

			HttpSvc.post('smartiot/datahub/stats/gateway/'+ $scope.sensorId, params, Auth.getTokenId(), false)
				.then(function(result) {
					$scope.gateway = result;
					$scope.isLoading = false;					
				}, function() {
					$scope.isLoading = false;
					toastr.error('Failed to retrieve gateway data.', Auth.translate('ERROR'));
					return null;
				});
		}
		
		$scope.initDateRange();
		$scope.loadData();
		var interval = $interval($scope.loadData, 30000); // 5 secs
		
		/* ************************************************** */
		
		$scope.$on('$destroy', function(){
			$interval.cancel(interval);
		});
	};
	
	/** @ngInject */
	function SmartIoTSensorCtrl($scope, $filter, $interval, $timeout, $uibModal, Auth, HttpSvc, toastr) {
		
		$scope.readings = [];
		$scope.toAlertTemp = false;
		$scope.toAlertHumi = false;
		$scope.toAlertAmp = false;

		$scope.sensor = {};
		
		$scope.graph = {};
		$scope.graph.lockDateRange = false;
		$scope.graph.startDate = new Date();
		$scope.graph.endDate = new Date();

		$scope.startDate = new Date();
		$scope.endDate = new Date();
		$scope.isLoading = false;
		$scope.isFirstLoad = true;
		
		$scope.toBlinkTemp = false;
		$scope.toBlinkHumi = false;
		$scope.toBlinkN = false;
		$scope.toBlinkP = false;
		$scope.toBlinkK = false;
		$scope.toBlinkEc = false;
		$scope.toBlinkPh = false;
		$scope.toBlinkPm = false;
		$scope.toBlinkElecMeter = false;
		//$scope.toBlinkWaterMeter = false;

		$scope.selectedTemp = false;
		$scope.selectedN = false;
		$scope.selectedP = false;
		$scope.selectedK = false;
		$scope.selectedEc = false;
		$scope.selectedPh = false;
		$scope.selectedPm = false;
		$scope.selectedElecMeter = false;
		$scope.selectedWaterMeter = false;
		
		var timeoutTemp = null;
		var timeoutHumi = null;
		var timeoutN = null;
		var timeoutP = null;
		var timeoutK = null;
		var timeoutEc = null;
		var timeoutPh = null;
		var timeoutPm = null;
		var timeoutElecMeter = null;
		var timeoutWaterMeter = null;
		
		/* ************************************************** */

		$scope.initDateRange = function() {
			$scope.graph.startDate = new Date();
			$scope.graph.startDate.setTime($scope.graph.startDate.getTime() - (1*60*60*1000)); 
			$scope.graph.startDate = new Date($scope.graph.startDate.setDate($scope.graph.startDate.getDate()));
			$scope.graph.startDate = $filter('date')($scope.graph.startDate, 'dd-MM-yyyy hh:mma');
			$scope.graph.endDate = new Date();
			$scope.graph.endDate.setDate($scope.graph.endDate.getDate())
			$scope.graph.endDate = $filter('date')($scope.graph.endDate, 'dd-MM-yyyy hh:mma');
		}

		$scope.getBatteryClass= function (batteryLevel) {
			if (batteryLevel === 0) {
				return '0';
			} else if (batteryLevel >= 1 && batteryLevel <= 20) {
				return '1';
			} else if (batteryLevel >= 21 && batteryLevel <= 40) {
				return '2';
			} else if (batteryLevel >= 41 && batteryLevel <= 80) {
				return '4';
			} else if (batteryLevel >= 81 && batteryLevel <= 100) {
				return '6';
			} 
		}

		$scope.loadData = function() {
			
			$scope.isLoading = true;
			
			if(!$scope.graph.lockDateRange)
				$scope.initDateRange();

			var params = {
				dateFrom: $scope.graph.startDate,
				dateTo: $scope.graph.endDate,
			}

			HttpSvc.post('smartiot/datahub/stats/sensor/'+ $scope.sensorId, params, Auth.getTokenId(), false)
				.then(function(result) {	

					$scope.sensor = result;

					$scope.labels = $scope.sensor.labels;
					$scope.colorMain = ['#0000FF', '#3D9400'];
					$scope.colorN = ['#795548'];
					$scope.colorP = ['#FF9800'];
					$scope.colorK = ['#D4C020'];
					$scope.colorEc = ['#9C27B0'];
					$scope.colorPh = ['#47C68B'];
					$scope.colorPm = ['#089A1C'];
					$scope.colorAmp = ['#FFB800'];
					$scope.seriesMain = ["Temperature", "Humidity"];
					$scope.seriesAmp = ["Ampere"];
					$scope.seriesN = ["Nitrogen (N)"];
					$scope.seriesP = ["Phosphorus (P)"];
					$scope.seriesK = ["Potassium (K)"];
					$scope.seriesEc = ["Electric Conductivity (EC)"];
					$scope.seriesPh = ["pH"];
					$scope.seriesPm = ["PM"];
					$scope.dataMain = ($scope.sensor.hasHumi ? [$scope.sensor.seriesT, $scope.sensor.seriesH] : [$scope.sensor.seriesT]);
					$scope.dataAmp = [$scope.sensor.seriesAmp];
					$scope.dataN = [$scope.sensor.seriesN];
					$scope.dataP = [$scope.sensor.seriesP];
					$scope.dataK = [$scope.sensor.seriesK];
					$scope.dataEc = [$scope.sensor.seriesEc];
					$scope.dataPh = [$scope.sensor.seriesPh];
					$scope.dataPm = [$scope.sensor.seriesPm];

					$scope.optionsMain = {
						animation: false,
						scales: {
						  	yAxes: [
								{
									id: 'y-axis-1',
									type: 'linear',
									display: true,
									position: 'left', 
									ticks: {
										//stepSize: 1,
										suggestedMin: $scope.sensor.suggestedMinTemp,
										suggestedMax: $scope.sensor.suggestedMaxTemp
									}
								},								
								{
									id: 'y-axis-2',
									type: 'linear',
									display: ($scope.sensor.hasHumi ? true: false),
									position: 'right', 
									ticks: {
										//stepSize: 1,
										suggestedMin: $scope.sensor.suggestedMinHumi,
										suggestedMax: $scope.sensor.suggestedMaxHumi
									}
								}
						  	]
						},
						legend: {
							display: false,
							position: 'top'
						}
					};
					$scope.optionsOther = {
						animation: false,
						scales: {
						  	yAxes: [
								{
									id: 'y-axis-1',
									type: 'linear',
									display: true,
									position: 'left', 
									ticks: {
										//stepSize: 1,
									}
								}
						  	]
						},
						legend: {
							display: false,
							position: 'top'
						}
					};
					
					$scope.datasetOverride1 = [
						{
							borderWidth: 0,
							fill: false,
							yAxisID: 'y-axis-1'
						},
						{
							borderWidth: 0,
							fill: false,
							yAxisID: 'y-axis-2'
						},,
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						}
					];
					$scope.datasetOverride2 = [
						{
							borderWidth: 0,
							fill: false,
							yAxisID: 'y-axis-1'
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						}
					];
					
					$scope.SetAlertBlinking();

					if($scope.sensorShowDangerZone)
					{
						$scope.PopulateDangerZoneDataPoints();
					}

					if($scope.isFirstLoad)
					{
						$scope.setDefaultSelection();
					}
					
					$scope.isFirstLoad = false;
					$scope.isLoading = false;

				}, function() {
					$scope.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		$scope.PopulateDangerZoneDataPoints = function() 
		{
			// Danger Zone (Temperature)
			if($scope.sensor.hasTemp)
			{
				for(var i=0; i<$scope.sensor.dangerZonesTemp.length; i++) 
				{
					var obj = $scope.sensor.dangerZonesTemp[i];
					$scope.seriesMain.push(obj.description);
					$scope.dataMain.push(obj.dataPointList);
					$scope.colorMain.push(obj.colorCode);
				}
			}

			// Danger Zone (Humidity)
			if($scope.sensor.hasHumi)
			{
				for(var i=0; i<$scope.sensor.dangerZonesHumi.length; i++) 
				{
					var obj = $scope.sensor.dangerZonesHumi[i];
					$scope.seriesMain.push(obj.description);
					$scope.dataMain.push(obj.dataPointList);
					$scope.colorMain.push(obj.colorCode);
				}
			}

			// Danger Zone (NPK)
			if($scope.sensor.hasNPK)
			{
				for(var i=0; i<$scope.sensor.dangerZonesN.length; i++) 
				{
					var obj = $scope.sensor.dangerZonesN[i];
					$scope.seriesN.push(obj.description);
					$scope.dataN.push(obj.dataPointList);
					$scope.colorN.push(obj.colorCode);
				}
				for(var i=0; i<$scope.sensor.dangerZonesP.length; i++) 
				{
					var obj = $scope.sensor.dangerZonesP[i];
					$scope.seriesP.push(obj.description);
					$scope.dataP.push(obj.dataPointList);
					$scope.colorP.push(obj.colorCode);
				}
				for(var i=0; i<$scope.sensor.dangerZonesK.length; i++) 
				{
					var obj = $scope.sensor.dangerZonesK[i];
					$scope.seriesK.push(obj.description);
					$scope.dataK.push(obj.dataPointList);
					$scope.colorK.push(obj.colorCode);
				}
			}

			// Danger Zone (EC)
			if($scope.sensor.hasEc)
			{
				for(var i=0; i<$scope.sensor.dangerZonesEc.length; i++) 
				{
					var obj = $scope.sensor.dangerZonesEc[i];
					$scope.seriesEc.push(obj.description);
					$scope.dataEc.push(obj.dataPointList);
					$scope.colorEc.push(obj.colorCode);
				}
			}

			// Danger Zone (PH)
			if($scope.sensor.hasPh)
			{
				for(var i=0; i<$scope.sensor.dangerZonesPh.length; i++) 
				{
					var obj = $scope.sensor.dangerZonesPh[i];
					$scope.seriesPh.push(obj.description);
					$scope.dataPh.push(obj.dataPointList);
					$scope.colorPh.push(obj.colorCode);
				}
			}

			// Danger Zone (PM2.5)
			if($scope.sensor.hasPm)
			{
				for(var i=0; i<$scope.sensor.dangerZonesPm.length; i++) 
				{
					var obj = $scope.sensor.dangerZonesPm[i];
					$scope.seriesPm.push(obj.description);
					$scope.dataPm.push(obj.dataPointList);
					$scope.colorPm.push(obj.colorCode);
				}
			}

			if($scope.sensor.hasElecMeter)
			{
				for(var i=0; i<$scope.sensor.dangerZonesAmp	.length; i++) 
				{
					var obj = $scope.sensor.dangerZonesAmp[i];
					$scope.seriesAmp.push(obj.description);
					$scope.dataAmp.push(obj.dataPointList);
					$scope.colorAmp.push(obj.colorCode);
				}
			}
		}

		$scope.SetAlertBlinking = function() {		

			// Red Blinking
			// -------------------------------
			if($scope.sensor.toAlertTemp) {
				timeoutTemp = $timeout($scope.setBlinkTemp, 1000);
			} else {
				$timeout.cancel(timeoutTemp);
			}

			if($scope.sensor.toAlertHumi) {
				timeoutHumi = $timeout($scope.setBlinkHumi, 1000);
			} else {
				$timeout.cancel(timeoutHumi);
			}

			if($scope.sensor.toAlertN) {
				timeoutN = $timeout($scope.setBlinkN, 1000);
			} else {
				$timeout.cancel(timeoutN);
			}

			if($scope.sensor.toAlertP) {
				timeoutP = $timeout($scope.setBlinkP, 1000);
			} else {
				$timeout.cancel(timeoutP);
			}

			if($scope.sensor.toAlertK) {
				timeoutK = $timeout($scope.setBlinkK, 1000);
			} else {
				$timeout.cancel(timeoutK);
			}

			if($scope.sensor.toAlertEc) {
				timeoutEc = $timeout($scope.setBlinkEc, 1000);
			} else {
				$timeout.cancel(timeoutEc);
			}

			if($scope.sensor.toAlertPh) {
				timeoutPh = $timeout($scope.setBlinkPh, 1000);
			} else {
				$timeout.cancel(timeoutPh);
			}

			if($scope.sensor.toAlertPm) {
				timeoutPm = $timeout($scope.setBlinkPm, 1000);
			} else {
				$timeout.cancel(timeoutPm);
			}

			if($scope.sensor.toAlertPm) {
				timeoutPm = $timeout($scope.setBlinkPm, 1000);
			} else {
				$timeout.cancel(timeoutPm);
			}

			if($scope.sensor.toAlertAmp) {
				timeoutElecMeter = $timeout($scope.setBlinkElecMeter, 1000);
			} else {
				$timeout.cancel(timeoutElecMeter);
			}
		}
		
		/* ************************************************** */

		$scope.setDefaultSelection = function(objCode) 
		{
			if(objCode != null)
			{
				$scope.selectedTemp = false;
				$scope.selectedN = false;
				$scope.selectedP = false;
				$scope.selectedK = false;
				$scope.selectedEc = false;
				$scope.selectedPh = false;
				$scope.selectedPm = false;		
				$scope.selectedElecMeter = false;		
				$scope.selectedWaterMeter = false;		
				
				if(objCode=="1")
				{
					$scope.selectedTemp = true;
				}
				else if(objCode=="2")
				{
					$scope.selectedN = true;
				}
				else if(objCode=="3")
				{
					$scope.selectedP = true;
				}
				else if(objCode=="4")
				{
					$scope.selectedK = true;
				}
				else if(objCode=="5")
				{
					$scope.selectedEc = true;
				}
				else if(objCode=="6")
				{
					$scope.selectedPh = true;
				}
				else if(objCode=="7")
				{
					$scope.selectedPm = true;
				}
				else if(objCode=="8")
				{
					$scope.selectedElecMeter = true;
				}
				else if(objCode=="9")
				{
					$scope.selectedWaterMeter = true;
				}

				return;
			}

			if($scope.sensor.hasTemp)
			{
				$scope.selectedTemp = true;
			}
			else if($scope.sensor.hasNPK)
			{
				$scope.selectedN = true;
			}
			else if($scope.sensor.hasEc)
			{
				$scope.selectedEc = true;
			}
			else if($scope.sensor.hasPh)
			{
				$scope.selectedPh = true;
			}
			else if($scope.sensor.hasPm)
			{
				$scope.selectedPm = true;
			}
			else if($scope.sensor.hasElecMeter)
			{
				$scope.selectedElecMeter = true;
			}
			else if($scope.sensor.hasWaterMeter)
			{
				$scope.selectedWaterMeter = true;
			}
		}

		$scope.getMetric = function(code, isF) {
			var metric = "";
			$scope.sensor.metrics.forEach(function(m) {
				if(m.code==code)
				{
					metric = m.uom;
					if(isF)
					{
						metric = m.uom2;
					}
				}
			});

			return metric;
		}

		$scope.hasAlert = function(sensor) {
			
			var result = 
				(sensor.toAlertTemp || 
				sensor.toAlertHumi || 
				sensor.toAlertN || 
				sensor.toAlertP || 
				sensor.toAlertK || 
				sensor.toAlertEc || 
				sensor.toAlertPh || 
				sensor.toAlertPm ||
				sensor.toAlertAmp
			);

			return result;
		}
		
		/* ************************************************** */
		
		$scope.showGraphModal = function (item) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				windowClass: 'app-modal-window',
				templateUrl: 'graphModal.html',
				controller: 'SmartIoTSensorModalCtrl',
				controllerAs: '$mdl',				
				size: 'lg',
				resolve: {
					item: function () {
						return {
							sensor: $scope.sensor,
							sensorId: $scope.sensorId,
							lockDateRange: $scope.graph.lockDateRange,
							startDate: $scope.graph.startDate,
							endDate: $scope.graph.endDate,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function (data) {
				}, function () {
				});
		};
		
		/* ************************************************** */
		      
		$scope.showActionPane = function () {
			var modalInstance = $uibModal.open({
				animation: false,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'actionPaneModal.html',
				controller: 'SmartIoTSensorActionPaneCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							sensor: $scope.sensor
						}
					}
				}
			});
	
			modalInstance
				.result
				.then(function (data) {
					// sensor.tooltipIsOpen = true;
					// toastr.info(JSON.stringify(data));
				}, function () {
				});
		}
		
		/* ************************************************** */

		$scope.toBlinkOrNot = function() {
			if($scope.selectedTemp && ($scope.toBlinkTemp || $scope.toBlinkHumi))
			{
				return true;
			}
			else if($scope.selectedN && $scope.toBlinkN)
			{
				return true;
			}
			else if($scope.selectedP && $scope.toBlinkP)
			{
				return true;
			}
			else if($scope.selectedK && $scope.toBlinkK)
			{
				return true;
			}
			else if($scope.selectedEc && $scope.toBlinkEc)
			{
				return true;
			}
			else if($scope.selectedPh && $scope.toBlinkPh)
			{
				return true;
			}
			else if($scope.selectedPm && $scope.toBlinkPm)
			{
				return true;
			}
			else if($scope.selectedElecMeter && $scope.toBlinkElecMeter)
			{
				return true;
			}
			return false;
		}

		$scope.setBlinkTemp = function() {
			$scope.toBlinkTemp = true;
			timeoutTemp = $timeout($scope.setNotBlinkTemp, 1000);
		}
		$scope.setNotBlinkTemp = function() {
			$scope.toBlinkTemp = false;
			timeoutTemp = $timeout($scope.setBlinkTemp, 1000);
		}
		
		$scope.setBlinkHumi = function() {
			$scope.toBlinkHumi = true;
			timeoutHumi = $timeout($scope.setNotBlinkHumi, 1000);
		}
		$scope.setNotBlinkHumi = function() {
			$scope.toBlinkHumi = false;
			timeoutHumi = $timeout($scope.setBlinkHumi, 1000);
		}
		
		$scope.setBlinkN = function() {
			$scope.toBlinkN = true;
			timeoutN = $timeout($scope.setNotBlinkN, 1000);
		}
		$scope.setNotBlinkN = function() {
			$scope.toBlinkN = false;
			timeoutN = $timeout($scope.setBlinkN, 1000);
		}
		
		$scope.setBlinkP = function() {
			$scope.toBlinkP = true;
			timeoutP = $timeout($scope.setNotBlinkP, 1000);
		}
		$scope.setNotBlinkP = function() {
			$scope.toBlinkP = false;
			timeoutP = $timeout($scope.setBlinkP, 1000);
		}
		
		$scope.setBlinkK = function() {
			$scope.toBlinkK = true;
			timeoutK = $timeout($scope.setNotBlinkK, 1000);
		}
		$scope.setNotBlinkK = function() {
			$scope.toBlinkK = false;
			timeoutK = $timeout($scope.setBlinkK, 1000);
		}
		
		$scope.setBlinkEc = function() {
			$scope.toBlinkEc = true;
			timeoutEc = $timeout($scope.setNotBlinkEc, 1000);
		}
		$scope.setNotBlinkEc = function() {
			$scope.toBlinkEc = false;
			timeoutEc = $timeout($scope.setBlinkEc, 1000);
		}
		
		$scope.setBlinkPh = function() {
			$scope.toBlinkPh = true;
			timeoutPh = $timeout($scope.setNotBlinkPh, 1000);
		}
		$scope.setNotBlinkPh = function() {
			$scope.toBlinkPh = false;
			timeoutPh = $timeout($scope.setBlinkPh, 1000);
		}
		
		$scope.setBlinkPm = function() {
			$scope.toBlinkPm = true;
			timeoutPm = $timeout($scope.setNotBlinkPm, 1000);
		}
		$scope.setNotBlinkPm = function() {
			$scope.toBlinkPm = false;
			timeoutPm = $timeout($scope.setBlinkPm, 1000);
		}

		$scope.setBlinkElecMeter = function() {
			$scope.toBlinkElecMeter = true;
			timeoutPm = $timeout($scope.setNotBlinkElecMeter, 1000);
		}
		$scope.setNotBlinkElecMeter = function() {
			$scope.toBlinkElecMeter = false;
			timeoutPm = $timeout($scope.setBlinkElecMeter, 1000);
		}

		/* ************************************************** */

		$scope.$on('$destroy', function(){
			$interval.cancel(interval);
			$timeout.cancel(timeoutTemp);
			$timeout.cancel(timeoutHumi);
			$timeout.cancel(timeoutN);
			$timeout.cancel(timeoutP);
			$timeout.cancel(timeoutK);
			$timeout.cancel(timeoutEc);
			$timeout.cancel(timeoutPh);
			$timeout.cancel(timeoutPm);
			$timeout.cancel(timeoutElecMeter);
		});

		/* ************************************************** */

		$scope.initDateRange();
		$scope.loadData();
		var interval = $interval($scope.loadData, 180000);
	};

	/** @ngInject */
	function SmartIoTSensorModalCtrl($uibModal, $uibModalInstance, $filter, $interval, $timeout, Auth, RmsApi, HttpSvc, item, toastr) {
		var $mdl = this;
		
		$mdl.lockDateRange = item.lockDateRange;
		$mdl.startDate = new Date();
		$mdl.endDate = new Date();
		$mdl.sensor = item.sensor;
		$mdl.sensorId = item.sensorId;
		$mdl.isLoading = false;
		$mdl.isFirstLoad = true;
		
		$mdl.toBlinkTemp = false;
		$mdl.toBlinkHumi = false;
		$mdl.toBlinkN = false;
		$mdl.toBlinkP = false;
		$mdl.toBlinkK = false;
		$mdl.toBlinkEc = false;
		$mdl.toBlinkPh = false;
		$mdl.toBlinkPm = false;
		$mdl.toBlinkElecMeter = false;

		$mdl.selectedTemp = false;
		$mdl.selectedN = false;
		$mdl.selectedP = false;
		$mdl.selectedK = false;
		$mdl.selectedEc = false;
		$mdl.selectedPh = false;
		$mdl.selectedPm = false;
		$mdl.selectedElecMeter = false;
		
		var timeoutTemp = null;
		var timeoutHumi = null;
		var timeoutN = null;
		var timeoutP = null;
		var timeoutK = null;
		var timeoutEc = null;
		var timeoutPh = null;
		var timeoutPm = null;
		var timeoutElecMeter = null;
		
		/* ************************************************** */

		$mdl.getBatteryClass= function (batteryLevel) {
			if (batteryLevel === 0) {
				return '0';
			} else if (batteryLevel >= 1 && batteryLevel <= 20) {
				return '1';
			} else if (batteryLevel >= 21 && batteryLevel <= 40) {
				return '2';
			} else if (batteryLevel >= 41 && batteryLevel <= 80) {
				return '4';
			} else if (batteryLevel >= 81 && batteryLevel <= 100) {
				return '6';
			} 
		}

		$mdl.initDateRange = function() {
			$mdl.startDate = new Date();
			$mdl.startDate.setTime($mdl.startDate.getTime() - (1*60*60*1000)); 
			$mdl.startDate = new Date($mdl.startDate.setDate($mdl.startDate.getDate()));
			$mdl.startDate = $filter('date')($mdl.startDate, 'dd-MM-yyyy hh:mma');
			$mdl.endDate = new Date();
			$mdl.endDate.setDate($mdl.endDate.getDate())
			$mdl.endDate = $filter('date')($mdl.endDate, 'dd-MM-yyyy hh:mma');
		}

		$mdl.loadData = function() {
			
			$mdl.isLoading = true;

			if(!$mdl.lockDateRange)
				$mdl.initDateRange();

			var params = {
				dateFrom: $mdl.startDate,
				dateTo: $mdl.endDate,
			}
			
			HttpSvc.post('smartiot/datahub/stats/sensor/'+ $mdl.sensorId, params, Auth.getTokenId(), false)
				.then(function(result) {	
					
					$mdl.sensor = result;
					
					$mdl.labels = $mdl.sensor.labels;
					$mdl.colorMain = ['#0000FF', '#3D9400'];
					$mdl.colorN = ['#795548'];
					$mdl.colorP = ['#FF9800'];
					$mdl.colorK = ['#D4C020'];
					$mdl.colorEc = ['#9C27B0'];
					$mdl.colorPh = ['#47C68B'];
					$mdl.colorPm = ['#089A1C'];
					$mdl.colorAmp = ['#FFB800'];
					$mdl.seriesMain = ["Temperature", "Humidity"];
					$mdl.seriesN = ["Nitrogen (N)"];
					$mdl.seriesP = ["Phosphorus (P)"];
					$mdl.seriesK = ["Potassium (K)"];
					$mdl.seriesEc = ["Electric Conductivity (EC)"];
					$mdl.seriesPh = ["pH"];
					$mdl.seriesPm = ["PM"];
					$mdl.seriesAmp = ["AMP"];
					$mdl.dataMain = ($mdl.sensor.hasHumi ? [$mdl.sensor.seriesT, $mdl.sensor.seriesH] : [$mdl.sensor.seriesT]);
					$mdl.dataAmp= [$mdl.sensor.seriesAmp];
					$mdl.dataN = [$mdl.sensor.seriesN];
					$mdl.dataP = [$mdl.sensor.seriesP];
					$mdl.dataK = [$mdl.sensor.seriesK];
					$mdl.dataEc = [$mdl.sensor.seriesEc];
					$mdl.dataPh = [$mdl.sensor.seriesPh];
					$mdl.dataPm = [$mdl.sensor.seriesPm];

					$mdl.optionsMain = {
						animation: false,
						scales: {
						  	yAxes: [
								{
									id: 'y-axis-1',
									type: 'linear',
									display: true,
									position: 'left', 
									ticks: {
										//stepSize: 1,
										suggestedMin: $mdl.sensor.suggestedMinTemp,
										suggestedMax: $mdl.sensor.suggestedMaxTemp
									}
								},
								{
									id: 'y-axis-2',
									type: 'linear',
									display: ($mdl.sensor.hasHumi ? true: false),
									position: 'right', 
									ticks: {
										//stepSize: 1,
										suggestedMin: $mdl.sensor.suggestedMinHumi,
										suggestedMax: $mdl.sensor.suggestedMaxHumi
									}
								}
						  	]
						},
						legend: {
							display: false,
							position: 'top'
						}
					};
					$mdl.optionsOther = {
						animation: false,
						scales: {
						  	yAxes: [
								{
									id: 'y-axis-1',
									type: 'linear',
									display: true,
									position: 'left', 
									ticks: {
										//stepSize: 1,
									}
								}
						  	]
						},
						legend: {
							display: false,
							position: 'top'
						}
					};
					
					$mdl.datasetOverride1 = [
						{
							borderWidth: 0,
							fill: false,
							yAxisID: 'y-axis-1'
						},
						{
							borderWidth: 0,
							fill: false,
							yAxisID: 'y-axis-2'
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						}
					];	
					
					$mdl.datasetOverride2 = [
						{
							borderWidth: 0,
							fill: false,
							yAxisID: 'y-axis-1'
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						},
						{
						  borderWidth: 0,
						  fill: false,
						}
					];	
					
					$mdl.PopulateDangerZoneDataPoints();

					if($mdl.isFirstLoad)
					{
						$mdl.setDefaultSelection();
					}			

					$mdl.isFirstLoad = false;
					$mdl.isLoading = false;
				}, function() {
					$mdl.isLoading = false;
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		$mdl.hasAlert = function() {
			var result = 
				($mdl.sensor.toAlertTemp || 
				$mdl.sensor.toAlertHumi || 
				$mdl.sensor.toAlertN || 
				$mdl.sensor.toAlertP || 
				$mdl.sensor.toAlertK || 
				$mdl.sensor.toAlertEc || 
				$mdl.sensor.toAlertPh || 
				$mdl.sensor.toAlertPm ||
				$mdl.sensor.toAlertAmp
			);

			return result;
		}

		$mdl.PopulateDangerZoneDataPoints = function() 
		{
			// Danger Zone (Temperature)
			if($mdl.sensor.hasTemp)
			{
				for(var i=0; i<$mdl.sensor.dangerZonesTemp.length; i++) 
				{
					var obj = $mdl.sensor.dangerZonesTemp[i];
					$mdl.seriesMain.push(obj.description);
					$mdl.dataMain.push(obj.dataPointList);
					$mdl.colorMain.push(obj.colorCode);
				}
			}

			// Danger Zone (Humidity)
			if($mdl.sensor.hasHumi)
			{
				for(var i=0; i<$mdl.sensor.dangerZonesHumi.length; i++) 
				{
					var obj = $mdl.sensor.dangerZonesHumi[i];
					$mdl.seriesMain.push(obj.description);
					$mdl.dataMain.push(obj.dataPointList);
					$mdl.colorMain.push(obj.colorCode);
				}
			}

			// Danger Zone (NPK)
			if($mdl.sensor.hasNPK)
			{
				for(var i=0; i<$mdl.sensor.dangerZonesN.length; i++) 
				{
					var obj = $mdl.sensor.dangerZonesN[i];
					$mdl.seriesN.push(obj.description);
					$mdl.dataN.push(obj.dataPointList);
					$mdl.colorN.push(obj.colorCode);
				}
				for(var i=0; i<$mdl.sensor.dangerZonesP.length; i++) 
				{
					var obj = $mdl.sensor.dangerZonesP[i];
					$mdl.seriesP.push(obj.description);
					$mdl.dataP.push(obj.dataPointList);
					$mdl.colorP.push(obj.colorCode);
				}
				for(var i=0; i<$mdl.sensor.dangerZonesK.length; i++) 
				{
					var obj = $mdl.sensor.dangerZonesK[i];
					$mdl.seriesK.push(obj.description);
					$mdl.dataK.push(obj.dataPointList);
					$mdl.colorK.push(obj.colorCode);
				}
			}

			// Danger Zone (EC)
			if($mdl.sensor.hasEc)
			{
				for(var i=0; i<$mdl.sensor.dangerZonesEc.length; i++) 
				{
					var obj = $mdl.sensor.dangerZonesEc[i];
					$mdl.seriesEc.push(obj.description);
					$mdl.dataEc.push(obj.dataPointList);
					$mdl.colorEc.push(obj.colorCode);
				}
			}

			// Danger Zone (PH)
			if($mdl.sensor.hasPh)
			{
				for(var i=0; i<$mdl.sensor.dangerZonesPh.length; i++) 
				{
					var obj = $mdl.sensor.dangerZonesPh[i];
					$mdl.seriesPh.push(obj.description);
					$mdl.dataPh.push(obj.dataPointList);
					$mdl.colorPh.push(obj.colorCode);
				}
			}

			// Danger Zone (PM2.5)
			if($mdl.sensor.hasPm)
			{
				for(var i=0; i<$mdl.sensor.dangerZonesPm.length; i++) 
				{
					var obj = $mdl.sensor.dangerZonesPm[i];
					$mdl.seriesPm.push(obj.description);
					$mdl.dataPm.push(obj.dataPointList);
					$mdl.colorPm.push(obj.colorCode);
				}
			}

			if($mdl.sensor.hasElecMeter)
			{
				for(var i=0; i<$mdl.sensor.dangerZonesAmp.length; i++) 
				{
					var obj = $mdl.sensor.dangerZonesAmp[i];
					$mdl.seriesAmp.push(obj.description);
					$mdl.dataAmp.push(obj.dataPointList);
					$mdl.colorAmp.push(obj.colorCode);
				}
			}

			// Red Blinking
			// -------------------------------
			if($mdl.sensor.toAlertTemp) {
				timeoutTemp = $timeout($mdl.setBlinkTemp, 1000);
			} else {
				$timeout.cancel(timeoutTemp);
			}

			if($mdl.sensor.toAlertHumi) {
				timeoutHumi = $timeout($mdl.setBlinkHumi, 1000);
			} else {
				$timeout.cancel(timeoutHumi);
			}

			if($mdl.sensor.toAlertN) {
				timeoutN = $timeout($mdl.setBlinkN, 1000);
			} else {
				$timeout.cancel(timeoutN);
			}

			if($mdl.sensor.toAlertP) {
				timeoutP = $timeout($mdl.setBlinkP, 1000);
			} else {
				$timeout.cancel(timeoutP);
			}

			if($mdl.sensor.toAlertK) {
				timeoutK = $timeout($mdl.setBlinkK, 1000);
			} else {
				$timeout.cancel(timeoutK);
			}

			if($mdl.sensor.toAlertEc) {
				timeoutEc = $timeout($mdl.setBlinkEc, 1000);
			} else {
				$timeout.cancel(timeoutEc);
			}

			if($mdl.sensor.toAlertPh) {
				timeoutPh = $timeout($mdl.setBlinkPh, 1000);
			} else {
				$timeout.cancel(timeoutPh);
			}

			if($mdl.sensor.toAlertPm) {
				timeoutPm = $timeout($mdl.setBlinkPm, 1000);
			} else {
				$timeout.cancel(timeoutPm);
			}

			if($mdl.sensor.toAlertAmp) {
				timeoutElecMeter = $timeout($mdl.setBlinkElecMeter, 1000);
			} else {
				$timeout.cancel(timeoutElecMeter);
			}
		}
		
		/* ************************************************** */
		
		$mdl.setDefaultSelection = function(objCode) 
		{
			if(objCode != null)
			{
				$mdl.selectedTemp = false;
				$mdl.selectedN = false;
				$mdl.selectedP = false;
				$mdl.selectedK = false;
				$mdl.selectedEc = false;
				$mdl.selectedPh = false;
				$mdl.selectedPm = false;	
				$mdl.selectedElecMeter = false;	
				
				if(objCode=="1")
				{
					$mdl.selectedTemp = true;
				}
				else if(objCode=="2")
				{
					$mdl.selectedN = true;
				}
				else if(objCode=="3")
				{
					$mdl.selectedP = true;
				}
				else if(objCode=="4")
				{
					$mdl.selectedK = true;
				}
				else if(objCode=="5")
				{
					$mdl.selectedEc = true;
				}
				else if(objCode=="6")
				{
					$mdl.selectedPh = true;
				}
				else if(objCode=="7")
				{
					$mdl.selectedPm = true;
				}

				else if(objCode=="8")
				{
					$mdl.selectedElecMeter = true;
				}
				return;
			}

			if($mdl.sensor.hasTemp)
			{
				$mdl.selectedTemp = true;
			}
			else if($mdl.sensor.hasNPK)
			{
				$mdl.selectedN = true;
			}
			else if($mdl.sensor.hasEc)
			{
				$mdl.selectedEc = true;
			}
			else if($mdl.sensor.hasPh)
			{
				$mdl.selectedPh = true;
			}
			else if($mdl.sensor.hasPm)
			{
				$mdl.selectedPm = true;
			}
			else if ($mdl.sensor.hasElecMeter)
			{
				$mdl.selectedElecMeter = true;
			}
		}

		$mdl.getMetric = function(code, isF) {
			var metric = "";
			$mdl.sensor.metrics.forEach(function(m) {
				if(m.code==code)
				{
					metric = m.uom;
					if(isF)
					{
						metric = m.uom2;
					}
				}
			});

			return metric;
		}
		
		/* ************************************************** */

		$mdl.toBlinkOrNot = function() {
			if($mdl.selectedTemp && ($mdl.toBlinkTemp || $mdl.toBlinkHumi))
			{
				return true;
			}
			else if($mdl.selectedN && $mdl.toBlinkN)
			{
				return true;
			}
			else if($mdl.selectedP && $mdl.toBlinkP)
			{
				return true;
			}
			else if($mdl.selectedK && $mdl.toBlinkK)
			{
				return true;
			}
			else if($mdl.selectedEc && $mdl.toBlinkEc)
			{
				return true;
			}
			else if($mdl.selectedPh && $mdl.toBlinkPh)
			{
				return true;
			}
			else if($mdl.selectedPm && $mdl.toBlinkPm)
			{
				return true;
			}
			else if($mdl.selectedElecMeter && $mdl.toBlinkElecMeter)
			{
				return true;
			}
			return false;
		}

		$mdl.setBlinkTemp = function() {
			$mdl.toBlinkTemp = true;
			timeoutTemp = $timeout($mdl.setNotBlinkTemp, 1000);
		}
		$mdl.setNotBlinkTemp = function() {
			$mdl.toBlinkTemp = false;
			timeoutTemp = $timeout($mdl.setBlinkTemp, 1000);
		}
		
		$mdl.setBlinkHumi = function() {
			$mdl.toBlinkHumi = true;
			timeoutHumi = $timeout($mdl.setNotBlinkHumi, 1000);
		}
		$mdl.setNotBlinkHumi = function() {
			$mdl.toBlinkHumi = false;
			timeoutHumi = $timeout($mdl.setBlinkHumi, 1000);
		}
		
		$mdl.setBlinkN = function() {
			$mdl.toBlinkN = true;
			timeoutN = $timeout($mdl.setNotBlinkN, 1000);
		}
		$mdl.setNotBlinkN = function() {
			$mdl.toBlinkN = false;
			timeoutN = $timeout($mdl.setBlinkN, 1000);
		}
		
		$mdl.setBlinkP = function() {
			$mdl.toBlinkP = true;
			timeoutP = $timeout($mdl.setNotBlinkP, 1000);
		}
		$mdl.setNotBlinkP = function() {
			$mdl.toBlinkP = false;
			timeoutP = $timeout($mdl.setBlinkP, 1000);
		}
		
		$mdl.setBlinkK = function() {
			$mdl.toBlinkK = true;
			timeoutK = $timeout($mdl.setNotBlinkK, 1000);
		}
		$mdl.setNotBlinkK = function() {
			$mdl.toBlinkK = false;
			timeoutK = $timeout($mdl.setBlinkK, 1000);
		}
		
		$mdl.setBlinkEc = function() {
			$mdl.toBlinkEc = true;
			timeoutEc = $timeout($mdl.setNotBlinkEc, 1000);
		}
		$mdl.setNotBlinkEc = function() {
			$mdl.toBlinkEc = false;
			timeoutEc = $timeout($mdl.setBlinkEc, 1000);
		}
		
		$mdl.setBlinkPh = function() {
			$mdl.toBlinkPh = true;
			timeoutPh = $timeout($mdl.setNotBlinkPh, 1000);
		}
		$mdl.setNotBlinkPh = function() {
			$mdl.toBlinkPh = false;
			timeoutPh = $timeout($mdl.setBlinkPh, 1000);
		}
		
		$mdl.setBlinkPm = function() {
			$mdl.toBlinkPm = true;
			timeoutPm = $timeout($mdl.setNotBlinkPm, 1000);
		}
		$mdl.setNotBlinkPm = function() {
			$mdl.toBlinkPm = false;
			timeoutPm = $timeout($mdl.setBlinkPm, 1000);
		}


		$mdl.setBlinkElecMeter = function() {
			$mdl.toBlinkElecMeter = true;
			timeoutPm = $timeout($mdl.setNotBlinkElecMeter, 1000);
		}
		$mdl.setNotBlinkElecMeter = function() {
			$mdl.toBlinkElecMeter = false;
			timeoutPm = $timeout($mdl.setBlinkElecMeter, 1000);
		}

		// ********************************************************		
		      
		$mdl.showActionPane = function () {
			var modalInstance = $uibModal.open({
				animation: false,
				keyboard: false,
				backdrop: 'static',
				templateUrl: 'actionPaneModal.html',
				controller: 'SmartIoTSensorActionPaneCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							sensor: $mdl.sensor
						}
					}
				}
			});
	
			modalInstance
				.result
				.then(function (data) {
					// sensor.tooltipIsOpen = true;
					// toastr.info(JSON.stringify(data));
				}, function () {
				});
		}

		// ********************************************************		
		
		// Cancel Action
		$mdl.cancelModal = function() {
			$interval.cancel(interval);
			$timeout.cancel(timeoutTemp);
			$timeout.cancel(timeoutElecMeter);
			$timeout.cancel(timeoutHumi);
			$timeout.cancel(timeoutN);
			$timeout.cancel(timeoutP);
			$timeout.cancel(timeoutK);
			$timeout.cancel(timeoutEc);
			$timeout.cancel(timeoutPh);
			$timeout.cancel(timeoutPm);
			$uibModalInstance.dismiss('cancel');
		};

		// ********************************************************		
		
		$mdl.initDateRange();
		$mdl.loadData();
		var interval = $interval($mdl.loadData, 180000);
	};
    
    /** @ngInject */
    function SmartIoTSensorActionPaneCtrl($uibModalInstance, $timeout, Auth, RmsApi, HttpSvc, UtilSvc, item, toastr) {
      var $mdl = this;

      $mdl.sensor = item.sensor;
      $mdl.item = {};
      $mdl.errorMsg = "";
      $mdl.showError = false;
      $mdl.showSuccess = false;
	$mdl.lockButton = false;
	

	/* ********************************************************* */
	
	$mdl.getBatteryClass= function (batteryLevel) {
		if (batteryLevel === 0) {
			return '0';
		} else if (batteryLevel >= 1 && batteryLevel <= 20) {
			return '1';
		} else if (batteryLevel >= 21 && batteryLevel <= 40) {
			return '2';
		} else if (batteryLevel >= 41 && batteryLevel <= 80) {
			return '4';
		} else if (batteryLevel >= 81 && batteryLevel <= 100) {
			return '6';
		} 
	}
					
      $mdl.confirmModal = function() {
        if($mdl.actionPaneForm.$invalid) {
          $mdl.errorMsg = UtilSvc.getErrorMessage($mdl.actionPaneForm);          
          $mdl.showError = true;
        } else {
          $mdl.lockButton = true;
          $mdl.showError = false;

          $mdl.item.sensorId = $mdl.sensor.sensorId;
          $mdl.item.temperature = $mdl.sensor.temperature || 0;
          $mdl.item.temperatureF = $mdl.sensor.temperature || 0;
          $mdl.item.humidity = $mdl.sensor.humidity || 0;
          $mdl.item.amp = $mdl.sensor.amp || 0;
          $mdl.item.ec = $mdl.sensor.ec || 0;
          $mdl.item.n = $mdl.sensor.n || 0;
          $mdl.item.p = $mdl.sensor.p || 0;
          $mdl.item.k = $mdl.sensor.k || 0;
          $mdl.item.ph = $mdl.sensor.ph || 0;
          $mdl.item.pm = $mdl.sensor.pm || 0;
          $mdl.item.batteryLevel = $mdl.sensor.batteryLevel || 0;

          HttpSvc.post('smartiot/correctiveactions', $mdl.item, Auth.getTokenId(), false)
            .then(function(result) {
              $mdl.showSuccess = true;
              $timeout($uibModalInstance.close, 1500);
            }, function(error) {
              $mdl.errorMsg = error;
              $mdl.showError = true;
              $mdl.lockButton = false;
            });
        }
      };
      
      // Cancel Action
      $mdl.cancelModal = function() {
        $uibModalInstance.close('cancel');
      };
    };

})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.iotdashboard.smartiot')
		.directive('smartGateway', smartGateway)
		.directive('smartSensor', smartSensor);
	
	/** @ngInject */
	function smartSensor() {
		return {
			restrict: 'E',
			scope: {
				sensorId: '=',
				sensorDesc: '=',
				sensorDeviceUid: '=',
				sensorHideDateRange: '=',
				sensorShowDangerZone: '=',
			},
			controller: 'SmartIoTSensorCtrl',
			templateUrl: 'app/pages/dashboard_iot/smartiot/smartSensor.html',
		};
	};
	
	/** @ngInject */
	function smartGateway() {
		return {
			restrict: 'E',
			scope: {
				sensorId: '=',
				sensorDesc: '=',
				sensorDeviceUid: '=',
			},
			controller: 'SmartIoTGatewayCtrl',
			templateUrl: 'app/pages/dashboard_iot/smartiot/smartGateway.html',
		};
	};
	
})();
(function() {
    'use strict';

    angular.module('RmsAppV2.pages.iotdashboard.observatory.controller', [])
        .controller('IotObservatoryCtrl', IotObservatoryCtrl)
        .controller('IotObservatoryOverviewCtrl', IotObservatoryOverviewCtrl)
        .controller('IotObservatorySettingModalCtrl', IotObservatorySettingModalCtrl)
        .controller('IotObservatorySettingManageModalCtrl', IotObservatorySettingManageModalCtrl)
        .controller('IotObservatoryReportModalCtrl', IotObservatoryReportModalCtrl);

    /** @ngInject */
    function IotObservatoryCtrl($scope, $filter, $state, $q, $uibModal, Auth, HttpSvc, toastr) {
		Auth.init();	
		
		var vm = this;
		
		vm.pageSizeOption = [10, 20, 50, 100];
		vm.pageSize = 10;
		vm.numOfRecord = 0;
		vm.numOfRecordFiltered = 0;
		vm.numOfRecordDisplayed = 0;
		vm.startIndex = 0; 
		vm.endIndex = 0;
		vm.customerDataFull = [];
		vm.customerData = [];

		/* ***************************************************************** */

		function refreshTableState(tableState, startIndex, endIndex) {				
						
			var filtered = tableState.search.predicateObject ? $filter('filter')(vm.customerDataFull, tableState.search.predicateObject) : vm.customerDataFull;
			vm.numOfRecordFiltered = filtered.length;
			
			if (tableState.sort.predicate) {
				filtered = $filter('orderBy')(filtered, tableState.sort.predicate, tableState.sort.reverse);
			}
			var result = filtered.slice(startIndex, startIndex + endIndex);
						
			vm.numOfRecordDisplayed = vm.numOfRecordFiltered < vm.numOfRecord ? vm.numOfRecordFiltered : vm.numOfRecord;
			vm.customerData = result;
			
			tableState.pagination.numberOfPages = Math.ceil(vm.numOfRecordDisplayed / endIndex);
			
			return tableState;
		};
		
		vm.retrieveData = function(tableState) {		
			
			var params = {}
			var pagination = tableState.pagination;
			vm.startIndex = pagination.start || 0;     	  	// This is NOT the page number, but the index of item in the list that you want to use to display the table.
			vm.endIndex = pagination.number || vm.pageSize; // Number of entries showed per page.
			
			if(vm.customerDataFull.length <= 0) {	
				vm.isLoading = true;

				HttpSvc.get('iotobservatory/customerlist', params, Auth.getTokenId(), true)
					.then(function(result) {	
						vm.numOfRecord = result.length;	
						vm.customerDataFull = result;		
						refreshTableState(tableState, vm.startIndex, vm.endIndex);
						vm.isLoading = false;
					}, function() {
						vm.isLoading = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
				});
			} else {
				refreshTableState(tableState, vm.startIndex, vm.endIndex);
			}
		};	
		
		/* ***************************************************************** */

		// Open Setting Modal Dialog
		vm.promptSettingDialog = function (clientCompanyId, clientName) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'settingModal.html',
				controller: 'IotObservatorySettingModalCtrl',
				controllerAs: '$mdl',
				size: 'lg',
				resolve: {
					item: function () {
						return {
							accessCompanyId: clientCompanyId,
							clientName: clientName
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
				}, function () {
				});
		};	

		// Open Report Modal Dialog
		vm.promptReportDialog = function (clientCompanyId, clientName) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'reportModal.html',
				controller: 'IotObservatoryReportModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							accessCompanyId: clientCompanyId,
							clientName: clientName
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					vm.loadPermissionList();
				}, function () {
				});
		};	

		/* ***************************************************************** */
		
		// Call Action
		// Do nothing
	};
	
    /** @ngInject */
    function IotObservatoryOverviewCtrl($stateParams, Auth, baSidebarService, HttpSvc, toastr) {
		
		Auth.init();	
		
		var vm = this;
		vm.gateways = [];
		vm.selectedGateway = null;
		vm.hideDateRange = false;
		vm.showAsList = false;
		vm.columnWidth = 6;
		
		// Go Back
		vm.goBack = function() {
			window.history.back();
		}

		vm.loadGateways = function() {
			HttpSvc.get('iothub/list/gateways/client/' + $stateParams.id, {}, Auth.getTokenId(), true)
				.then(function(result) {	
						vm.gateways = result;
				}, function() {
					toastr.error('Failed to retrieve data.', '');
					return null;
				});
		}

		vm.selectGateway = function(gatewayId) {
			vm.gateways.forEach(function(g) {
				if(g.id==gatewayId) {
					vm.selectedGateway=g;
				}
			});
		}		
		
		vm.resetGateway = function() {
			vm.selectedGateway = null;
		}

		vm.setColumnWidth = function(columnCount) {
			if(columnCount==2) 
			{
				vm.columnWidth = 6;
				vm.showAsList = false;
				vm.hideDateRange = false;
			}
			else if(columnCount==4) 
			{
				vm.columnWidth = 3;
				vm.showAsList = false;
				vm.hideDateRange = true;
			}
		}

		vm.showList = function() {
			vm.showAsList = true;			
		}
		
			// Call Action
		if(Auth.isLoggedIn()){
			baSidebarService.setMenuCollapsed(true);
			vm.loadGateways();
		}
	}
	
	// Setting Modal Controller
	function IotObservatorySettingModalCtrl($uibModalInstance, $uibModal, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.accessCompanyId = item.accessCompanyId;
		$mdl.clientName = item.clientName;
		$mdl.settings = [];
		$mdl.isLoading = false;
		$mdl.isLockButtons = false;

		$mdl.loadSettings = function() {
			$mdl.isLoading = true;

			HttpSvc.get('iotnotificationsettings/list/thirdparty/' + $mdl.accessCompanyId, {}, Auth.getTokenId(), true)
					.then(function(result) {
						$mdl.settings = result;
						$mdl.isLoading = false;
						$mdl.isLockButtons = false;
					}, function() {
						$mdl.isLoading = false;
						$mdl.isLockButtons = false;
						toastr.error('Failed to retrieve data.', '');
						return null;
					});
		}

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ********************************************************** */

		// Open Setting Modal Dialog
		$mdl.addSetting = function (clientCompanyId) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'manageSettingModal.html',
				controller: 'IotObservatorySettingManageModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 1,
							title: "ADD_NEW",
							companyId: clientCompanyId,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					$mdl.loadSettings();
				}, function () {
				});
		};

		// Open Setting Modal Dialog
		$mdl.editSetting = function (id, clientCompanyId) {
			var setting = angular.copy(setting);

			var modalInstance = $uibModal.open({
				animation: true,
				backdrop: 'static',
				templateUrl: 'manageSettingModal.html',
				controller: 'IotObservatorySettingManageModalCtrl',
				controllerAs: '$mdl',
				size: 'md',
				resolve: {
					item: function () {
						return {
							mode: 2,
							title: "UPDATE",
							id: id,
							companyId: clientCompanyId,
							setting: setting,
						}
					}
				}
			});

			modalInstance
				.result
				.then(function () {
					$mdl.loadSettings();
				}, function () {
				});
		};

		$mdl.deleteSetting = function (id) {
			$mdl.isLockButtons = true;

			HttpSvc.delete('iotnotificationsettings/' + id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.loadSettings();
				}, function() {
					$mdl.loadSettings();
					toastr.error('Failed to delete the setting.', 'Delete Failed');
					return null;
			});
		}

		/* ********************************************************** */
		
		// Init
		$mdl.loadSettings();
	};
	
	// Setting Manage Modal Controller
	function IotObservatorySettingManageModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.mode = item.mode;
		$mdl.title = item.title;
		$mdl.companyId = item.companyId;
		$mdl.setting = {};
		$mdl.branches = [];
		$mdl.users = [];
		$mdl.selectedBranch = null;
		$mdl.selectedUser = null;
		$mdl.isLoading = false;
		$mdl.lockButtons = false;

		if($mdl.mode==1) {
			$mdl.setting.companyId = $mdl.companyId;
			$mdl.setting.triggerAlert = false;
			$mdl.setting.alertByEmail = false;
			$mdl.setting.alertBySms = false;
			$mdl.setting.alertByPN = false;
			$mdl.setting.isThirdParty = true;
		} 
		else 
		{
			$mdl.id = item.id;
		}

		/* ********************************************************** */
			
		$mdl.loadBranches = function() {
			$mdl.isLoading = true;

			HttpSvc.get('branches/listbycompany/' + $mdl.companyId, {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.branches = result;
					$mdl.loadUsers();
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}
	
		$mdl.loadUsers = function() {
			HttpSvc.get("users/listwithsu", {}, Auth.getTokenId(), true)
				.then(function(result) {
					$mdl.users = result;

					if($mdl.mode==2) {
						$mdl.loadData();
					} else {						
						$mdl.isLoading = false;
					}
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		$mdl.loadData = function() {
			HttpSvc.get("iotnotificationsettings/" + $mdl.id, {}, Auth.getTokenId(), false)
				.then(function(result) {
					$mdl.setting = result;

					$mdl.branches.forEach(function(b) {
						if(b.id==$mdl.setting.branchId)
						{
							$mdl.selectedBranch = b;
						}
					});
					
					$mdl.users.forEach(function(u) {
						if(u.id==$mdl.setting.userId)
						{
							$mdl.selectedUser = u;
						}
					});
					$mdl.isLoading = false;
				}, function(error) {
					$mdl.isLoading = false;
					toastr.error(error, 'Failed');
				});
		}

		/* ********************************************************** */

		$mdl.selectBranch = function() {
			$mdl.setting.branchId = $mdl.selectedBranch.id;
		}

		$mdl.selectUser = function() {
			$mdl.setting.userId = $mdl.selectedUser.id;
		}

		/* ********************************************************** */
		
		$mdl.confirmModal = function() {

			if(!$mdl.modalForm.$valid) {
				toastr.error('Please fill all Required Fields.', 'Incomplete Fields');
			} else {
				$mdl.lockButtons = true;

				if($mdl.mode==1) 
				{
					HttpSvc.post("iotnotificationsettings", $mdl.setting, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Notification Setting has been created successfully.', Auth.translate('SUCCESS'));
							$uibModalInstance.close();					
						}, function(error) {
							$mdl.lockButtons = false;
							toastr.error(error, 'Failed');
						});	
				}
				else
				{
					HttpSvc.put("iotnotificationsettings/" + $mdl.setting.id, $mdl.setting, Auth.getTokenId(), false)
						.then(function(result) {
							toastr.success('Notification Setting has been updated successfully.', Auth.translate('SUCCESS'));
							$uibModalInstance.close();					
						}, function(error) {
							$mdl.lockButtons = false;
							toastr.error(error, 'Failed');
						});	
				}
			}
		};

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

		/* ********************************************************** */

		// Init
		$mdl.loadBranches();
	};
	
	// Report Modal Controller
	function IotObservatoryReportModalCtrl($uibModalInstance, Auth, HttpSvc, item, toastr) {
		var $mdl = this;
		$mdl.accessCompanyId = item.accessCompanyId;
		$mdl.clientName = item.clientName;
		$mdl.sensorList = [];
		$mdl.dateFrom = "";
		$mdl.dateTo = "";
		$mdl.selectedSensor = null;
		$mdl.isProcessing = false;

		/* ********************************************************** */

		$mdl.loadSensors = function() {
			$mdl.isProcessing = true;
			
			HttpSvc.get('iotsensors/listbycompany/' + $mdl.accessCompanyId, {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$mdl.sensorList = result;
					$mdl.isProcessing = false;
				}, function(error) {
					$mdl.isProcessing = false;
					toastr.error('Failed to retrieve active sensor list. ' + error, '');
					return null;
				});
		}
		
		$mdl.downloadPdf = function() {

			$mdl.isProcessing = true;
			
			var filename = "PDF_Temperature_Report.pdf";
			
			var apiPath = 'iotobservatory/print/' + $mdl.accessCompanyId;
			
			if($mdl.selectedSensor != null) {
				apiPath += '/' + $mdl.selectedSensor.id;
			}
			if($mdl.dateFrom != '' && $mdl.dateFrom != null && $mdl.dateTo != '' && $mdl.dateTo != null) {
				apiPath += '/' + $mdl.dateFrom + '/' + $mdl.dateTo;
			}
			
			HttpSvc.getPdfObject(apiPath, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isProcessing = false;
				}, 
				function(error) {
					$mdl.isProcessing = false;
					toastr.error('Failed to generate PDF. ' + error, '');
					return null;
				});
		}
		
		$mdl.downloadExcel = function() {
			
			$mdl.isProcessing = true;
			
			var filename = "EXCEL_Temperature_Report.xlsx";
			
			var apiPath = 'iotobservatory/export/' + $mdl.accessCompanyId;
			
			if($mdl.selectedSensor != null) {
				apiPath += '/' + $mdl.selectedSensor.id;
			}
			if($mdl.dateFrom != '' && $mdl.dateFrom != null && $mdl.dateTo != '' && $mdl.dateTo != null) {
				apiPath += '/' + $mdl.dateFrom + '/' + $mdl.dateTo;
			}
					
			HttpSvc.getExcelObject(apiPath, Auth.getTokenId(), filename)
				.then(function() {
					$mdl.isProcessing = false;
				}, 
				function(error) {
					$mdl.isProcessing = false;
					toastr.error('Failed to generate Excel. ' + error, '');
					return null;
				});
		}
		/* ********************************************************** */

		$mdl.cancelModal = function() {
			$uibModalInstance.dismiss('cancel');
		};
		
		// Init
		$mdl.loadSensors();
	};
	
})();


(function () {
	'use strict';

	angular.module('RmsAppV2.pages.dashboard')
		.controller('widgetBulkBreakJobAverageYieldCtrl', widgetBulkBreakJobAverageYieldCtrl);

	/** @ngInject */
	function widgetBulkBreakJobAverageYieldCtrl($scope, $filter, $timeout, Auth, HttpSvc) {
		$scope.widgetBb = {};
		$scope.widgetBb.result = [];
		$scope.widgetBb.isLoading = false;
		$scope.widgetBb.selectedYmIds = [];
		$scope.widgetBb.endDate = 
			$filter('date')(new Date(), 'yyyy-MM-dd');
		$scope.widgetBb.startDate = 
			$filter('date')(new Date(new Date().setDate(new Date().getDate()-14)), 'yyyy-MM-dd');
		// $scope.widgetBb.startDate = 
		// 	$filter('date')(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-dd');
		// $scope.widgetBb.endDate = 
		// 	$filter('date')(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), 'yyyy-MM-dd');

		$scope.widgetBb.selectSettings = { 
			scrollableHeight: '300px', 
			scrollable: true,
			selectedToTop: true 
		};

		/* ************************************************* */

		$scope.widgetBb.loadYieldManagementList = function() {
			$scope.widgetBb.isLoading = true;

			HttpSvc.get('dashboardsv2/getYieldManagementList', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$scope.widgetBb.ymList = result;
					// $scope.widgetBb.loadData();
				}, function(error) {
				});
		}

		$scope.widgetBb.loadData = function() {
			$scope.widgetBb.isLoading = true;
			$scope.widgetBb.result = [];
			
			var selectedYmIds = "";
			$scope.widgetBb.selectedYmIds.forEach(function(y) {
				selectedYmIds += y.id + ",";
			});
			selectedYmIds = selectedYmIds.substring(0, selectedYmIds.length-1);

			var params = {
				dateFrom: $scope.widgetBb.startDate,
				dateTo: $scope.widgetBb.endDate,
				yieldIds: selectedYmIds
			};

			HttpSvc.post('dashboardsv2/bulkbreakjobs', params, Auth.getTokenId(), true)
				.then(function(result) {
					$scope.widgetBb.result = result;
					$scope.widgetBb.isLoading = false;
				}, function(error) {
					$scope.widgetBb.isLoading = false;
				});
		}

		/* ************************************************* */

		$scope.init = function() {
			// $scope.widgetBb.isLoading = true;	
			// $timeout($scope.widgetBb.loadYieldManagementList, 1000);
		}

		$scope.init();
	};
})();

(function () {
	'use strict';

	angular.module('RmsAppV2.pages.dashboard')
		.directive('widgetBulkBreakJobAverageYield', widgetBulkBreakJobAverageYield);
	
	/** @ngInject */
	function widgetBulkBreakJobAverageYield() {
		return {
			restrict: 'E',
			controller: 'widgetBulkBreakJobAverageYieldCtrl',
			templateUrl: 'app/pages/dashboard/widgets/bulkBreakJobAverageYield/bulkBreakJobAverageYield.html'
		};
	};
	
})();

(function () {
	'use strict';

	angular.module('RmsAppV2.pages.dashboard')
		.controller('widgetProductionJobYieldCtrl', widgetProductionJobYieldCtrl);

	/** @ngInject */
	function widgetProductionJobYieldCtrl($scope, $filter, $timeout, Auth, HttpSvc) {
		$scope.widgetPj = {};
		$scope.widgetPj.result = [];
		$scope.widgetPj.itemList = [];
		$scope.widgetPj.isLoading = false;
		$scope.widgetPj.selectedIds = [];
		$scope.widgetPj.endDate = 
			$filter('date')(new Date(), 'yyyy-MM-dd');
		$scope.widgetPj.startDate = 
			$filter('date')(new Date(new Date().setDate(new Date().getDate()-14)), 'yyyy-MM-dd');
		// $scope.widgetBb.startDate = 
		// 	$filter('date')(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-dd');
		// $scope.widgetBb.endDate = 
		// 	$filter('date')(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), 'yyyy-MM-dd');

		$scope.widgetPj.selectSettings = { 
			scrollableHeight: '300px', 
			scrollable: true,
			selectedToTop: true,
			externalIdProp: '' // to include as an object in selected-model rather than just id
		};

		/* ************************************************* */

		$scope.widgetPj.loadSFGAndFGList = function() {
			$scope.widgetPj.isLoading = true;

			HttpSvc.get('dashboardsv2/getSfgAndFgList', {}, Auth.getTokenId(), true)
				.then(function(result) {	
					$scope.widgetPj.itemList = result;
					$scope.widgetPj.loadData();
				}, function(error) {
				});
		}

		$scope.widgetPj.loadData = function() {
			$scope.widgetPj.isLoading = true;
			$scope.widgetPj.result = [];
			
			var selectedFgIds = "";
			var selectedSfgIds = "";

			$scope.widgetPj.selectedIds.forEach(function(y) {
				if(y.label.indexOf('[FG]') >= 0)
				{
					selectedFgIds += y.id + ",";
				}
				else if(y.label.indexOf('[SFG]') >= 0)
				{
					selectedSfgIds += y.id + ",";
				}
			});
			selectedFgIds = selectedFgIds.substring(0, selectedFgIds.length-1);
			selectedSfgIds = selectedSfgIds.substring(0, selectedSfgIds.length-1);

			var params = {
				dateFrom: $scope.widgetPj.startDate,
				dateTo: $scope.widgetPj.endDate,
				sfgIds: selectedSfgIds,
				fgIds: selectedFgIds
			};

			HttpSvc.post('dashboardsv2/jobproductions', params, Auth.getTokenId(), true)
				.then(function(result) {
					$scope.widgetPj.result = result;
					$scope.widgetPj.isLoading = false;
				}, function(error) {
					$scope.widgetPj.isLoading = false;
				});
		}

		/* ************************************************* */

		$scope.init = function() {
			$scope.widgetPj.isLoading = true;	
			$timeout($scope.widgetPj.loadSFGAndFGList, 1000);
		}

		$scope.init();
	};
})();

(function () {
	'use strict';

	angular.module('RmsAppV2.pages.dashboard')
		.directive('widgetProductionJobYield', widgetProductionJobYield);
	
	/** @ngInject */
	function widgetProductionJobYield() {
		return {
			restrict: 'E',
			controller: 'widgetProductionJobYieldCtrl',
			templateUrl: 'app/pages/dashboard/widgets/productionJobYield/productionJobYield.html'
		};
	};
	
})();

(function () {
	'use strict';

	angular.module('RmsAppV2.pages.dashboard')
		.controller('widgetPurchaseOrderSummaryCtrl', widgetPurchaseOrderSummaryCtrl);

	/** @ngInject */
	function widgetPurchaseOrderSummaryCtrl($scope, $filter, $timeout, Auth, HttpSvc) {
		$scope.widgetPs = {};
		$scope.widgetPs.result = [];
		$scope.widgetPs.statusList = GetWidgetPOStatuses();
		$scope.widgetPs.isLoading = false;
		$scope.widgetPs.selectedStatuses = [];
		$scope.widgetPs.endDate = 
			$filter('date')(new Date(), 'yyyy-MM-dd');
			//$filter('date')(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), 'yyyy-MM-dd');
		$scope.widgetPs.startDate = 
			$filter('date')(new Date(new Date().setDate(new Date().getDate()-14)), 'yyyy-MM-dd');

		$scope.widgetPs.selectSettings = { 
			// scrollableHeight: '300px', 
			// scrollable: true,
			// selectedToTop: true 
		};
		$scope.widgetPs.currency = Auth.getCurrency();

		/* ************************************************* */

		$scope.widgetPs.loadData = function() {
			$scope.widgetPs.isLoading = true;
			$scope.widgetPs.result = [];
			
			var selectedStatuses = "";

			$scope.widgetPs.selectedStatuses.forEach(function(y) {
				selectedStatuses += y.id + ",";
			});
			selectedStatuses = selectedStatuses.substring(0, selectedStatuses.length-1);

			var params = {
				dateFrom: $scope.widgetPs.startDate,
				dateTo: $scope.widgetPs.endDate,
				status: selectedStatuses
			};

			HttpSvc.post('dashboardsv2/purchaseorders/bybranch', params, Auth.getTokenId(), true)
				.then(function(result) {
					$scope.widgetPs.result = result;
					$scope.widgetPs.isLoading = false;
				}, function(error) {
					$scope.widgetPs.isLoading = false;
				});
		}

		/* ************************************************* */

		$scope.init = function() {
			$scope.widgetPs.isLoading = true;	
			$timeout($scope.widgetPs.loadData, 1000);
		}

		$scope.init();
	};

	function GetWidgetPOStatuses() {
		var statusList = [
			{ id:'New', label:'NEW' },
			{ id:'Confirmed', label:'CONFIRMED' },
			{ id:'Approved', label:'APPROVED' },
			{ id:'Completed', label:'COMPLETED' }
		];

		return statusList;
	}
})();

(function () {
	'use strict';

	angular.module('RmsAppV2.pages.dashboard')
		.directive('widgetPurchaseOrderSummary', widgetPurchaseOrderSummary);
	
	/** @ngInject */
	function widgetPurchaseOrderSummary() {
		return {
			restrict: 'E',
			controller: 'widgetPurchaseOrderSummaryCtrl',
			templateUrl: 'app/pages/dashboard/widgets/purchaseOrderSummary/purchaseOrderSummary.html'
		};
	};
	
})();

(function () {
	'use strict';

	angular.module('RmsAppV2.pages.dashboard')
		.controller('widgetPurchaseOrderYoyComparisonCtrl', widgetPurchaseOrderYoyComparisonCtrl);
  
	/** @ngInject */
	function widgetPurchaseOrderYoyComparisonCtrl($scope, $filter, $timeout, Auth, HttpSvc, baConfig, layoutPaths) {
		var layoutColors = baConfig.colors;

		$scope.widgetPyoy = {};
		$scope.widgetPyoy.result = [];
		$scope.widgetPyoy.yearList = GetYears();
		$scope.widgetPyoy.statusList = GetWidgetPOStatuses();
		$scope.widgetPyoy.isLoading = false;
		$scope.widgetPyoy.hasError = false;
		$scope.widgetPyoy.selectedStatuses = [];
		$scope.widgetPyoy.selectedYears = [];
		$scope.widgetPyoy.startDate = 
			$filter('date')(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-dd');
		$scope.widgetPyoy.endDate = 
			$filter('date')(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), 'yyyy-MM-dd');

		$scope.widgetPyoy.legend1 = "";
		$scope.widgetPyoy.legend2 = "";

		$scope.widgetPyoy.selectSettings = { 
			selectionLimit: 2,
			showCheckAll: false,
			//showUncheckAll: false,
		};

		/* ************************************************* */

		$scope.widgetPyoy.setDefaultYearSelection = function(){
			$scope.widgetPyoy.selectedYears.push($scope.widgetPyoy.yearList[1]);
			$scope.widgetPyoy.selectedYears.push($scope.widgetPyoy.yearList[0]);
			$scope.widgetPyoy.isLoading = false;
			$scope.widgetPyoy.hasError = true;
			// $scope.widgetPyoy.loadData();
		}

		$scope.widgetPyoy.loadData = function() {
			if($scope.widgetPyoy.selectedYears.length < 2)
			{
				return;
			}
			
			$scope.widgetPyoy.isLoading = true;
			$scope.widgetPyoy.result = [];
			
			var selectedYears = "";
			var selectedStatuses = "";

			$scope.widgetPyoy.selectedStatuses.forEach(function(y) {
				selectedStatuses += y.id + ",";
			});
			selectedStatuses = selectedStatuses.substring(0, selectedStatuses.length-1);
			
			$scope.widgetPyoy.selectedYears.forEach(function(y) {
				selectedYears += y.id + ",";
			});
			selectedYears = selectedYears.substring(0, selectedYears.length-1);
			
			$scope.widgetPyoy.legend1 = $scope.widgetPyoy.selectedYears[0].id;
			$scope.widgetPyoy.legend2 = $scope.widgetPyoy.selectedYears[1].id;

			var params = {
				status: selectedStatuses,
				years: selectedYears
			};

			HttpSvc.post('dashboardsv2/purchaseorders/byyear', params, Auth.getTokenId(), true)
				.then(function(result) {
					$scope.widgetPyoy.isLoading = false;
					$scope.widgetPyoy.hasError = false;
					$scope.widgetPyoy.result = result;
					$timeout($scope.widgetPyoy.makeChart, 250);
				}, function(error) {
					$scope.widgetPyoy.isLoading = false;
					$scope.widgetPyoy.hasError = true;
					$timeout($scope.widgetPyoy.makeChart, 250);
				});
		}

		/* ************************************************* */

		$scope.widgetPyoy.makeChart = function() {
			
			AmCharts.makeChart('amchart', {
				type: 'serial',
				dataProvider: $scope.widgetPyoy.result,
				categoryField: 'monthName',
				categoryAxis: {
					parseDates: false,
					gridAlpha: 0,
					color: layoutColors.defaultText,
					axisColor: layoutColors.defaultText
				},
				valueAxes: [
				{
					minVerticalGap: 40,
					gridAlpha: 0,
					color: layoutColors.defaultText,
					axisColor: layoutColors.defaultText
				}
				],
				graphs: [
				{
					id: 'g0',
					bullet: 'none',
					useLineColorForBulletBorder: true,
					lineColor: '#ed7d31',
					lineThickness: 2,
					negativeLineColor: '#ed7d31',
					valueField: 'value1',
					//type: 'smoothedLine',
					fillAlphas: 0,
				},
				{
					id: 'g1',
					bullet: 'none',
					useLineColorForBulletBorder: true,
					lineColor: '#4472c4',
					lineThickness: 2,
					negativeLineColor: '#4472c4',
					valueField: 'value2',
					//type: 'smoothedLine',
					fillAlphas: 0,
				}
				],
				chartCursor: {
					categoryBalloonDateFormat: 'MM YYYY',
					categoryBalloonColor: '#4285F4',
					categoryBalloonAlpha: 0.7,
					cursorAlpha: 0,
					valueLineEnabled: true,
					valueLineBalloonEnabled: true,
					valueLineAlpha: 0.5
				},
				dataDateFormat: 'MMM',
				creditsPosition: 'bottom-right',
				pathToImages: layoutPaths.images.amChart
			});
		}

		/* ************************************************* */

		$scope.init = function() {
			$scope.widgetPyoy.isLoading = true;	
			$timeout($scope.widgetPyoy.setDefaultYearSelection, 1000);
		}

		$scope.init();
	};

	function GetWidgetPOStatuses() {
		var statusList = [
			{ id:'New', label:'New' },
			{ id:'Confirmed', label:'Confirmed' },
			{ id:'Approved', label:'Approved' },
			{ id:'Completed', label:'Completed' }
		];

		return statusList;
	}

	function GetYears() {
		var yearList = [];

		var currentYear = new Date().getFullYear();
		yearList.push({
			id: currentYear,
			label: currentYear
		});

		for(var x=1; x<=4; x++)
		{
			currentYear -= 1;
			yearList.push({
				id: currentYear,
				label: currentYear
			});
		}

		return yearList;
	}
})();

(function () {
	'use strict';

	angular.module('RmsAppV2.pages.dashboard')
		.directive('widgetPurchaseOrderYoyComparison', widgetPurchaseOrderYoyComparison);
	
	/** @ngInject */
	function widgetPurchaseOrderYoyComparison() {
		return {
			restrict: 'E',
			controller: 'widgetPurchaseOrderYoyComparisonCtrl',
			templateUrl: 'app/pages/dashboard/widgets/purchaseOrderYoyComparison/purchaseOrderYoyComparison.html'
		};
	};
	
})();
/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('RmsAppV2').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/dashboard_affiliate/affdashboard.html','<div class="widgets"><div class="row"><div class="col-md-9 col-lg-9" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.dashboardData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search" class="input input-sm form-control"></div></div><div class="col-lg-3" style="height:35px;line-height:35px"></div><div class="col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control btn-sm" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:50px">#</th><th st-sort="resellerName">Reseller Name</th><th st-sort="clientName">Customer Name</th><th>Status</th><th>Sign Up Date</th><th>Software Package</th><th>Billing Interval</th><th class="hide-after" style="text-align:right">Commission (RM)</th></tr></thead><tbody><tr ng-if="vm.dashboardData.length<=0 && !vm.isLoading"><td colspan="8" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="8" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.dashboardData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.resellerName}}</td><td>{{item.clientName}}</td><td>{{item.clientStatus}}</td><td>{{item.clientSignUpDate | date:\'dd-MMM-yyyy\' }}</td><td><div ng-repeat="p in item.packageModule">{{vm.getModuleName(p.moduleType)}}</div></td><td>{{item.billingIntervalType}}</td><td style="text-align:right">{{item.commission | number:2}}</td></tr></tbody><tfoot><tr><td colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div><div class="col-md-3 col-lg-3"><div class="row"><div class="col-lg-12" ba-panel=""><h2>Statement:</h2><hr>Download the monthly statement below:<br><br><select class="form-control" ng-model="vm.selectedStatement" ng-options="s as (s.statementNo + \' (\' + (s.statementDate | date:\'dd-MMM-yyyy\') + \')\') for s in vm.statementList"><option value="">= Select a Statement =</option></select><br><button type="button" class="btn btn-primary btn-with-icon btn-sm pull-right" ng-disabled="vm.isProcessing" ng-click="vm.downloadStatement()"><i class="fa fa-download"></i> Download</button> <span style="margin-left:10px;color:#00f" ng-if="vm.isProcessing"><b><i class="fa fa-spinner fa-spin fa-fw"></i> Preparing download ...</b></span></div></div></div></div></div><script type="text/ng-template" id="PaidInvoiceModal.html"><form name="$mdl.paidInvoiceForm" novalidate> <div class="modal-header" style="background:#2f59d4"> <span class="pull-right"><small>PAID INVOICE</small></span> <h3 class="modal-title" style="color:#fff"> <b>{{$mdl.clientName}}</b> </h3> </div> <div class="modal-body" id="modal-body" style="padding:0px !important"> <table class="table table-striped table-hover" style="font-family:courier;font-size:90%;color:#000" st-pipe="$mdl.retrieveData" st-table="$mdl.invoiceData" refresh-table> <thead> <tr> <th colspan="2"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Invoice" class="input form-control" /> </div> </th> <th colspan="3" style="padding-left:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </th> </tr> <tr> <th style="width:140px"><b>Invoice Date</b></th> <th style="width:170px"><b>Invoice No.</b></th> <th style="text-align:right"><b>Amount (RM)<br />(Excl. SST)</b></th> <th>&nbsp;</th> <th style="width:140px"><b>Paid On</b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="5"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Invoice ...</b></center> </td> </tr> <tr ng-if="!$mdl.isLoading && $mdl.invoiceData.length==0"> <td colspan="5" style="line-height:100px"> <center>No invoice available.</center> </td> </tr> <tr ng-repeat="m in $mdl.invoiceData"> <td>{{m.invoiceDate | date: \'dd/MM/yyyy\' }}</td> <td>{{m.invoiceNo | uppercase}}</td> <td style="text-align:right">{{m.totalTaxableAmount | currency:"" }}</td> <td>&nbsp;</td> <td>{{m.paidOn | date: \'dd/MM/yyyy\' }}</td> </tr> </tbody> </table> </div> <legend></legend> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> Close Window </button> </div> </form></script>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div ng-if="vm.dashboardGeneralView"><div class="row"><div class="col-xs-6 col-sm-4 col-md-3 col-lg-2"><a href="" class="dashlet type3" ui-sref="salesorders.list" rms-check-access="salesorders" rms-check-access-perm-type="ACCESS"><div class="figure">{{vm.dashBasic.newSalesOrderCount || \'0\'}}</div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><i class="fa fa-usd fa-3x fa-inverse"></i></div></div><div class="caption type3"><span translate="NEW_SALES_ORDER"></span></div></a></div><div class="col-xs-6 col-sm-4 col-md-3 col-lg-2"><a href="" class="dashlet type4" ui-sref="jobs.joblist.list" rms-check-access="jobs.joblist" rms-check-access-perm-type="ACCESS"><div class="figure">{{vm.dashBasic.newJobCount || \'0\'}}</div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><i class="fa fa-briefcase fa-3x fa-inverse"></i></div></div><div class="caption type4"><span translate="NEW_JOB_PRODUCTION"></span></div></a></div><div class="col-xs-6 col-sm-4 col-md-3 col-lg-2"><a href="" class="dashlet type1" ui-sref="requisitions.reqlist.list" rms-check-access="requisitions.reqlist" rms-check-access-perm-type="ACCESS"><div class="figure">{{vm.dashBasic.newRequisitionCount || \'0\'}}</div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><i class="fa fa-paw fa-3x fa-inverse"></i></div></div><div class="caption type1"><span translate="NEW_REQUISITION"></span></div></a></div><div class="col-xs-6 col-sm-4 col-md-3 col-lg-2"><a href="" class="dashlet type2" ui-sref="purchaseorders.polist.list" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="ACCESS"><div class="figure">{{vm.dashBasic.newPurchaseOrderCount || \'0\'}}</div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><i class="fa fa-file-powerpoint-o fa-3x fa-inverse"></i></div></div><div class="caption type2"><span translate="NEW_PURCHASE_ORDER"></span></div></a></div></div><div class="row" ng-hide="true"><a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="requisitions.reqlist.list" rms-check-access="requisitions.reqlist" rms-check-access-perm-type="ACCESS"><i class="fa fa-paw fa-3x text-info"></i><h4 translate="REQUISITION"></h4></a> <a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="purchaseorders.polist.list" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="ACCESS"><i class="fa fa-file-powerpoint-o fa-3x text-info"></i><h4 translate="PURCHASE_ORDER"></h4></a> <a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="receivings.grnlist.list" rms-check-access="receivings.grnlist" rms-check-access-perm-type="ACCESS"><i class="ion ion-cube fa-3x text-info"></i><h4 translate="GOOD_RECEIVE"></h4></a> <a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="salesorders.list" rms-check-access="salesorders" rms-check-access-perm-type="ACCESS"><i class="fa fa-magic fa-3x text-info"></i><h4 translate="SALES_ORDER"></h4></a> <a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="deliveryorders.list" rms-check-access="deliveryorders" rms-check-access-perm-type="ACCESS"><i class="fa fa-truck fa-3x text-info"></i><h4 translate="DELIVERY_ORDER"></h4></a></div><div class="row" ng-hide="true"><a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="jobs.jobanalysis.list" rms-check-access="jobs.jobanalysis" rms-check-access-perm-type="ACCESS"><i class="fa fa-area-chart fa-3x text-success"></i><h4 translate="JOB_ANALYSIS"></h4></a><a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="jobs.jobdashboard.list" rms-check-access="jobs.jobdashboard" rms-check-access-perm-type="ACCESS"><i class="fa fa-tachometer fa-3x text-success"></i><h4 translate="PRODUCTION_DASHBOARD"></h4></a> <a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="label.items" rms-check-access="label.items" rms-check-access-perm-type="ACCESS"><span class="fa-stack fa-lg fa-2x text-success"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-tags fa-stack-1x fa-inverse"></i></span><h4 translate="ITEM_LABEL"></h4></a> <a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="label.products" rms-check-access="label.products" rms-check-access-perm-type="ACCESS"><span class="fa-stack fa-lg fa-2x text-success"><i class="fa fa-square-o fa-stack-2x"></i> <i class="fa fa-tag fa-stack-1x"></i></span><h4 translate="PRODUCT_LABEL"></h4></a> <a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="inventory.items.list" rms-check-access="inventory.items" rms-check-access-perm-type="ACCESS"><span class="fa-stack fa-lg fa-2x text-success"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-cubes fa-stack-1x fa-inverse"></i></span><h4 translate="ITEM_INVENTORY"></h4></a> <a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="inventory.products.list" rms-check-access="inventory.products" rms-check-access-perm-type="ACCESS"><span class="fa-stack fa-lg fa-2x text-success"><i class="fa fa-square-o fa-stack-2x"></i> <i class="fa fa-cubes fa-stack-1x"></i></span><h4 translate="PRODUCT_INVENTORY"></h4></a></div><div class="row" ng-hide="true"><a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="recipes.categories.list" rms-check-access="recipes.categories" rms-check-access-perm-type="ACCESS"><i class="fa fa-object-group fa-3x text-danger"></i><h4 translate="RECIPE_CATEGORIES"></h4></a> <a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="recipes.recipes" rms-check-access="recipes.recipes" rms-check-access-perm-type="ACCESS"><i class="fa fa-cutlery fa-3x text-danger"></i><h4 translate="RECIPES"></h4></a> <a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="recipes.cards" rms-check-access="recipes.cards" rms-check-access-perm-type="ACCESS"><i class="fa fa-book fa-3x text-danger"></i><h4 translate="RECIPE_CARDS"></h4></a> <a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="sops.categories.list" rms-check-access="sops.categories" rms-check-access-perm-type="ACCESS"><i class="fa fa-th fa-3x text-default"></i><h4 translate="S.O.P._CATEGORIES"></h4></a> <a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="sops.sops.list" rms-check-access="sops.sops" rms-check-access-perm-type="ACCESS"><i class="fa fa-wrench fa-3x text-default"></i><h4 translate="S.O.P.S"></h4></a> <a href="" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 dashbutton" ba-panel="" ui-sref="sops.cards" rms-check-access="sops.cards" rms-check-access-perm-type="ACCESS"><i class="fa fa-list-ol fa-3x text-default"></i><h4 translate="S.O.P._CARDS"></h4></a></div><div class="col-lg-12"><p><br></p></div></div><div class="row"><div class="col-md-6 col-lg-6" ng-if="vm.hasPerm_PO"><widget-purchase-order-summary ng-if="vm.hasPerm_PO"></widget-purchase-order-summary></div><div class="col-md-6 col-lg-6" ng-if="vm.hasPerm_PO"><widget-purchase-order-yoy-comparison ng-if="vm.hasPerm_PO"></widget-purchase-order-yoy-comparison></div><div class="col-md-6 col-lg-6" ng-if="vm.hasPerm_BBJ"><widget-bulk-break-job-average-yield ng-if="vm.hasPerm_BBJ"></widget-bulk-break-job-average-yield></div><div class="col-md-6 col-lg-6" ng-if="vm.hasPerm_PJ"><widget-production-job-yield ng-if="vm.hasPerm_PJ"></widget-production-job-yield></div><div class="col-lg-12"><p><br></p></div></div><div ng-if="vm.dashboardAfterSalesView"><div class="row"><div class="col-md-6 col-lg-6"><div class="panel panel-default bootstrap-panel"><div class="panel-heading" style="padding:7px 15px;line-height:30px"><span translate="DASHBOARD_VIEW_OPTIONS"></span> <a href="" class="btn btn-default btn-sm pull-right"><i class="fa fa-refresh"></i></a> <span class="pull-right" style="margin-right:5px"><select class="form-control input-sm"><option>2016</option><option>2017</option><option>2018</option></select></span> <span class="pull-right" style="margin-right:5px"><select class="form-control input-sm"><option>{{ \'JAN\' | translate }}</option><option>{{ \'FEB\' | translate }}</option><option>{{ \'MAR\' | translate }}</option></select></span> <span class="pull-right" style="margin-right:5px"><select class="form-control input-sm"><option>KAMAL</option><option>NAJIB</option><option>REDZUAN</option></select></span> <span class="pull-right" style="margin-right:5px"><select class="form-control input-sm"><option>Team A</option><option>Team B</option><option>Team C</option></select></span></div></div></div><div class="col-md-6 col-lg-6"><div class="row"><div class="col-lg-12"><div class="panel panel-default bootstrap-panel"><div class="panel-heading" style="padding:7px 15px;line-height:30px"><after-sales-work-order-clock></after-sales-work-order-clock></div></div></div></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="row"><div class="col-lg-12"><after-sales-work-order-personal></after-sales-work-order-personal></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-title="Work Order Statistics" class="panel with-scroll"><after-sales-work-order-open-jobs></after-sales-work-order-open-jobs></div></div></div><br></div></div><div class="row"><div class="col-lg-12"><after-sales-work-order-statistic></after-sales-work-order-statistic></div></div></div><div class="col-md-6 col-lg-6"><div class="row"><div class="col-lg-12"><div ba-panel=""><div fc="" fc-options="vm.calendarOptions" ng-model="vm.calendarOptions.events"></div></div></div></div></div></div></div><script type="text/ng-template" id="announcementModal.html"><form name="$mdl.itemForm" ng-submit="$mdl.confirmModal()" st-pipe="$mdl.retrieveData" st-table="$mdl.announcements" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff" translate="NEW_ANNOUNCEMENTS_AND_FEATURE_UPDATES"> </h3> </div> <div class="modal-body" id="modal-body" ng-show="$mdl.isLoading"> <div class="flex-center" style="min-height: 30vh;"> <b> <i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ... </b> </div> </div> <div class="modal-body" id="modal-body" ng-show="!$mdl.isLoading"> <ol style="padding:1rem 1rem 1rem 3rem;"> <li class="announcement__post" ng-repeat="announcement in $mdl.announcements"> <div class="announcement__post-wrapper"> <div class="announcement__post-header"> <div class="announcement__post-bullet" ng-class="{ \'importance-level-1\': announcement.importanceLevel === \'HIGH\', \'importance-level-2\': announcement.importanceLevel === \'MED\', \'importance-level-3\': announcement.importanceLevel === \'LOW\' }"></div> <h5 class="announcement__post-module" ng-class="{ \'importance-level-1\': announcement.importanceLevel === \'HIGH\', \'importance-level-2\': announcement.importanceLevel === \'MED\', \'importance-level-3\': announcement.importanceLevel === \'LOW\' }"> {{announcement.moduleName}} </h5> </div> <div class="announcement__post-sub-head"> <span class="announcement__post-title">{{announcement.announcementTitle}}</span> <span class="announcement__post-date">{{$mdl.formatDate(announcement.effectiveStartDate)}}</span> </div> <div class="announcement__post-body"> <p class="announcement__post-body-content"> {{announcement.announcementContent}} </p> </div> </div> </li> </ol> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/dashboard_durian/duriandashboard.html','<div class="widgets"></div><div class="row"><a href="" class="col-sm-3 col-md-3 col-lg-3 durian_dashlet type1" ba-panel=""><div class="figure">135 <sup><small>TON</small></sup></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><img src="assets/img/durian.png" alt=""></div></div><div class="caption type1">Total Durian Collection</div></a> <a href="" class="col-sm-3 col-md-3 col-lg-3 durian_dashlet type2" ba-panel="" ui-sref="purchaseorders.polist.list"><div class="figure">100 <sup><small>TON</small></sup></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><img src="assets/img/durian_pulp.png" alt=""></div></div><div class="caption type2">Total Pulps Collection</div></a> <a href="" class="col-sm-3 col-md-3 col-lg-3 durian_dashlet type3" ba-panel="" ui-sref="salesorders.list"><div class="figure">85 <sup><small>TON</small></sup></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><img src="assets/img/durian_flesh.png" alt=""></div></div><div class="caption type3">Total Flesh Produced</div></a> <a href="" class="col-sm-3 col-md-3 col-lg-3 durian_dashlet type4" ba-panel="" ui-sref="jobs.joblist.list"><div class="figure">63 <sup><small>%</small></sup></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><img src="assets/img/durian_yield.png" alt=""></div></div><div class="caption type4">Average Yield (Gain)</div></a></div><div class="row"><a href="" ba-panel="" class="col-sm-3 col-md-3 col-lg-3 durian_dashlet2" ui-sref="durianops.collectdurian"><center><img src="assets/img/durian_collect.png" alt=""></center><div class="caption">Collect Durian</div></a> <a href="" ba-panel="" class="col-sm-3 col-md-3 col-lg-3 durian_dashlet2" ui-sref="durianops.processpulps"><center><img src="assets/img/durian_pulp_collect.png" alt=""></center><div class="caption">Process Pulps</div></a> <a href="" ba-panel="" class="col-sm-3 col-md-3 col-lg-3 durian_dashlet2" ui-sref="durianops.producepuree"><center><img src="assets/img/durian_flesh_collect.png" alt=""></center><div class="caption">Produce Puree</div></a> <a href="" ba-panel="" class="col-sm-3 col-md-3 col-lg-3 durian_dashlet2" ui-sref="durianops.durianinventory"><center><img src="assets/img/durian_inventory.png" alt=""></center><div class="caption">Inventory</div></a></div>');
$templateCache.put('app/pages/dashboard_iotfloorview/iotlvdashboard.html','<div class="widgets"><div class="row"><div class="col-lg-12"><div ng-if="vm.layoutList.length!=0"><a href="" ng-click="vm.toggleFullscreen()" class="btn btn-primary btn-with-icon btn-sm"><i class="fa fa-expand"></i> <span translate="GO_FULLSCREEN"></span></a> &nbsp; <span style="font-size:130%;color:#00f"><i class="fa fa-info-circle"></i> <span translate="NOTE:_THIS_SCREEN_MUST_BE_VIEWED_IN_FULLSCREEN_MODE_(SCREEN_RESOLUTION:_1920_X_1080_PIXELS)_FOR_BEST_VIEWING_EXPERIENCE"></span></span><br><br><br><div id="layoutParent" style="background-image:url({{vm.currentLayoutImage}})"><div class="layout-title">{{vm.selectedLayout.description}}</div><div class="loading-animation fade-out" ng-hide="!vm.isLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translations="RETRIEVING_THE_LATEST_MONITORING_STATISTICS_..."></span></div><div class="layout-pages" id="pages"><a href="" class="page-button" ng-repeat="p in vm.layoutList | orderBy:\'-pageCode\'" ng-class="{ \'page-button-selected\' : (p.id==vm.currentLayoutId)}" ng-click="vm.showLayout(p.id)">{{p.pageCode}}</a></div><div id="{{s.objectIdText}}" style="-webkit-transform:translate({{vm.getCoorX(s.coordinateX)}}px,{{vm.getCoorY(s.coordinateY)}}px);transform:translate({{vm.getCoorX(s.coordinateX)}}px,{{vm.getCoorY(s.coordinateY)}}px);" ng-class="{\'floorview-sensor\' : s.sensorId!=null, \'floorview-asset\' : s.assetId!=null }" ng-repeat="s in vm.selectedLayout.iotFloorViewDesignerDevices" uib-popover-template="s.sensorId!=null?\'sensorPopoverTemplate.html\':\'assetPopoverTemplate.html\'" ng-click="s.sensorId!=null?vm.showSensorInfoPopup(s):vm.showAssetInfoPopup(s)" popover-class="customClass" popover-trigger="outsideClick" popover-is-open="s.tooltipIsOpen" popover-placement="auto right"><div ng-if="s.sensorId!=null"><div class="alert-animation" ng-if="s.objectStats.toAlert"><div class="loadingio-spinner-ripple-j25d4u41p9o"><div class="ldio-fpjhyjsgrs"><div></div><div></div></div></div></div><img src="assets/img/sensor-icon.png" alt=""><br><p class="description"><big><b>{{s.objectDescription}}</b></big><br>[ {{s.description}} ]</p><div class="extra"><div class="temperature" ng-class="{\'temperature-alert\': s.objectStats.toAlert }"><span ng-if="s.objectStats.currentTemp!=-9999">{{s.objectStats.currentTemp}} <small>&deg;{{s.objectStats.symbol}}</small></span> <span ng-if="s.objectStats.currentTemp==-9999">n/a <small>&deg;{{s.objectStats.symbol}}</small></span></div><div class="humidity" ng-if="s.objectStats.currentHumi!=-1">{{s.objectStats.currentHumi}} <small>%<span translate="RH"></span></small></div><div class="ampere" ng-if="s.objectStats.currentAmp!=-1">{{s.objectStats.currentAmp}} <small><span translate="AMP"></span></small></div></div></div><div ng-if="s.assetId!=null"><img ng-if="s.objectStats.openCaseCount==0 && s.objectStats.openWorkOrderCount==0" src="assets/img/asset-icon.png" alt=""> <img ng-if="s.objectStats.openCaseCount!=0 || s.objectStats.openWorkOrderCount!=0" src="assets/img/asset-icon-warning.png" alt=""><p class="description">{{s.description}}</p></div></div><a href="" class="btn btn-danger btn-sm exit-button" ng-click="vm.toggleFullscreen()"><i class="fa fa-close"></i></a></div></div><div ba-panel="" ng-if="vm.layoutList.length==0 && !vm.isLoading"><div style="line-height:40px;padding-top:80px;padding-bottom:80px;font-size:14pt"><center><img src="assets/img/empty_placeholder_iotdesigner.jpg" style="width:350px"><br><br><h2 translate="THERE_IS_NO_FLOOR_VIEW_AVAILABLE"></h2><span translate="CLICK"></span> <a href="" ui-sref="iotsettings.floorviewdesigner.list" style="color:#00f"><u translate="HERE"></u></a> <span translate="TO_GO_TO_FLOOR_VIEW_DESIGNER"></span></center></div></div></div></div></div><script type="text/ng-template" id="assetPopoverTemplate.html"><div> <div class="popover-title" ng-class="{\'red\' : s.objectStats.toAlert}"> <span translate="ASSET"></span> \u3010{{s.objectCode}}\u3011 </div> <div class="row"> <div class="col-lg-7"> <div class="row"> <div class="col-lg-12"> <b translate="NAME">:</b> </div> </div> <div class="row"> <div class="col-lg-12" style="padding-bottom:15px"> {{s.objectName}} </div> </div> <div class="row"> <div class="col-lg-12"> <b translate="DESCRIPTION">:</b> </div> </div> <div class="row"> <div class="col-lg-12" style="padding-bottom:15px"> <span style="white-space:pre-line">{{s.objectDescription}}</span> </div> </div> <div class="row"> <div class="col-lg-12"> <b translate="SERIAL_NO.">:</b> </div> </div> <div class="row"> <div class="col-lg-12" style="padding-bottom:15px"> {{s.objectSerialNo}} </div> </div> </div> <div class="col-lg-5"> <div class="row"> <div class="col-lg-12"> <div href class="col-md-12 col-lg-12 dashlet-opencase" ba-panel ng-click=""> <div class="figure">{{s.objectStats.openCaseCount}}</div> <div class="caption"> <span translate="OPEN_CASE"></span>(s)</div> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div href class="col-md-12 col-lg-12 dashlet-workorder" ba-panel ng-click=""> <div class="figure">{{s.objectStats.openWorkOrderCount}}</div> <div class="caption"><span translate="WORK_ORDER"></span>(s)</div> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div href class="col-md-12 col-lg-12 dashlet-service" ba-panel ng-click=""> <div class="figure">{{s.objectStats.workOrderHistoryCount}}</div> <div class="caption" translate="SERVICE_HISTORY"></div> </div> </div> </div> </div> </div> <div class="popover-footer"> <div class="footer-note"> <center> <span translate="NOTE:_THIS_DIALOG_WILL_BE_CLOSED_WHEN_THE_FLOOR_VIEW_AUTO-REFRESH_EVERY_3_MINUTES"></span>. </center> </div> <br /> <div> <!-- <a href class="btn btn-warning btn-lg" style="float:left;color:#000" ng-if="s.objectStats.toAlert" ng-click="vm.showActionPane(s)"> <i class="fa fa-life-ring"></i> &nbsp;<span translations="TAKE_ACTION"></span> </a> --> <a href class="btn btn-danger btn-lg pull-right" ng-click="s.tooltipIsOpen=!s.tooltipIsOpen"> <i class="fa fa-close"></i> &nbsp;<span translate="CLOSE_DIALOG"></span> </a> </div> </div> </div></script><script type="text/ng-template" id="sensorPopoverTemplate.html"><div> <div class="popover-title" ng-class="{\'red\' : s.objectStats.toAlert}"> \u3010{{s.objectCode}}\u3011 {{s.objectDescription}} </div> <!-- Graph --> <div class="row"> <div class="col-lg-12" style="height:240px" ng-if="s.chart.hasTemp || s.chart.hasHumi"> <canvas id="popupChart" class="chart chart-line" chart-colors="s.chart.colors" chart-data="s.chart.dataMain" chart-labels="s.chart.labels" chart-series="s.chart.seriesMain" chart-options="s.chart.optionsMain" chart-dataset-override="s.chart.datasetOverride"> </canvas> </div> <div class="col-lg-12" style="height:240px" ng-if="s.chart.hasElecMeter"> <canvas id="popupChart" class="chart chart-line" chart-colors="s.chart.colors" chart-data="s.chart.dataAmp" chart-labels="s.chart.labels" chart-series="s.chart.seriesAmp" chart-options="s.chart.optionsOther" chart-dataset-override="s.chart.datasetOverride2"> </canvas> </div> </div> <legend></legend> <!-- Current Temperature / Humidity / Battery --> <div class="row"> <div class="col-sm-4 col-md-4 col-lg-4" ng-if="s.chart.hasTemp || s.chart.hasHumi"> <div class="temperature" ng-class="{\'red\' : s.objectStats.toAlert}"> <img src="assets/img/icon-temperature.png" align="left middle"> <span ng-if="s.objectStats.currentTemp!=-9999"><b>{{s.objectStats.currentTemp | number:1}}</b> <small>&deg;{{s.objectStats.symbol}}</small></span> <span ng-if="s.objectStats.currentTemp==-9999"><b>n/a</b> <small>&deg;{{s.objectStats.symbol}}</small></span> </div> </div> <div class="col-sm-4 col-md-4 col-lg-4" ng-if="s.objectStats.currentHumi!=-1"> <div class="humidity"> <img src="assets/img/icon-humidity.png" align="left middle"> <b>{{s.objectStats.currentHumi | number:1 }}</b> <small>% <span translate="RH"></span></small> </div> </div> <div class="col-sm-4 col-md-4 col-lg-4" ng-if="s.objectStats.currentAmp!=-1"> <div class="ampere"> <img src="assets/img/icon-ampere.png" align="left middle"> <b>{{s.objectStats.currentAmp | number:1 }}</b> <small><span translate="AMP"></span></small> </div> </div> <div class="col-sm-4 col-md-4 col-lg-4"> <div class="battery"> <img src="assets/img/icon-battery.png" align="left middle"> <div class="batt-{{s.objectStats.currentBatt}}"></div> </div> </div> </div> <div class="popover-footer"> <div class="footer-note"> <center> <span translate="NOTE:_THIS_DIALOG_WILL_BE_CLOSED_WHEN_THE_FLOOR_VIEW_AUTO-REFRESH_EVERY_3_MINUTES"></span>. </center> </div> <br /> <div> <a href class="btn btn-warning btn-md" style="float:left;color:#000" ng-if="s.objectStats.toAlert" ng-click="vm.showActionPane(s)"> <i class="fa fa-life-ring"></i> &nbsp;<span translate="TAKE_ACTION"></span> </a> <div class="last-action" ng-if="s.objectStats.toAlert && s.lastCorrectiveAction!=null" uib-tooltip-template="\'lastCorrectiveAction.html\'" tooltip-class="customClass" tooltip-placement="auto top" tooltip-trigger="outsideClick"> <span> <i class="fa fa-info-circle"></i> <span translate="LAST_ACTION"></span>: </span><br /> <span>{{s.lastCorrectiveAction.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</span> </div> <a href class="btn btn-danger btn-md pull-right" ng-click="s.tooltipIsOpen=!s.tooltipIsOpen"> <i class="fa fa-close"></i> &nbsp; <span translate="CLOSE_DIALOG"></span> </a> </div> </div> </div></script><script type="text/ng-template" id="lastCorrectiveAction.html"><div> <label><span translate="LAST_ACTION_DATE/TIME"></span>:</label> <p>{{s.lastCorrectiveAction.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</p> <label><span translate="CAUSE"></span>:</label> <p>{{s.lastCorrectiveAction.cause}}</p> <label translate="ACTION_TAKEN">:</label> <p>{{s.lastCorrectiveAction.actionTaken}}</p> </div></script><script type="text/ng-template" id="actionPaneModal.html"><form name="$mdl.actionPaneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header" style="background:#2f59d4"> <h3 class="modal-title" style="color:#fff"> \u3010{{$mdl.sensor.objectDescription}}\u3011 <span translate="CORRECTIVE_ACTION"></span> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <h4>{{$mdl.sensor.sensorDescription}}</h4> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b> <span translate="CAUSE_OF_THE_INCIDENT"></span>:</b></label> <textarea name="Cause" class="form-control" style="background:#ffffff" autocomplete="off" ng-model="$mdl.item.cause" ng-disabled="$mdl.lockButton" required> </textarea> <p class="help-block" style="color:#f00" ng-show="$mdl.actionPaneForm.Cause.$error.required && $mdl.actionPaneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b> <span translate="ACTION_TAKEN"></span>:</b></label> <textarea name="ActionTaken" class="form-control" style="background:#ffffff" autocomplete="off" ng-model="$mdl.item.actionTaken" ng-disabled="$mdl.lockButton" required> </textarea> <p class="help-block" style="color:#f00" ng-show="$mdl.actionPaneForm.ActionTaken.$error.required && $mdl.actionPaneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <legend ng-if="$mdl.showSuccess || $mdl.showError"></legend> <div class="row" ng-if="$mdl.showSuccess"> <div class="col-lg-12"> <span style="color:#0a8a0a"> <i class="fa fa-check"></i> &nbsp; <span translate="CORRECTIVE_ACTION_HAS_BEEN_RECORDED_SUCCESSFULLY"></span>. </span> </div> </div> <div class="row" ng-if="$mdl.showError"> <div class="col-lg-12"> <span style="color:#f00"> <i class="fa fa-exclamation-triangle"></i> &nbsp; <span style="color:#f00" ng-bind-html="$mdl.errorMsg"></span> </span> </div> </div> </div> <legend></legend> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon btn-md" type="submit" ng-disabled="$mdl.lockButton" style="float:left"> <i class="fa fa-check"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon btn-md" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/dashboard_smartkitchen/smartkitchendashboard.html','<a href="" ng-click="vm.toggleFullscreen()" class="btn btn-primary btn-with-icon btn-sm"><i class="fa fa-expand"></i> <span translate="GO_FULLSCREEN"></span></a><div id="smartkitchen_visualization"><div class="row"><div class="col-lg-12"><div class="topbar"><div class="logo-container"><img class="logo" src="../../assets/img/login/codemax-logo-transparent.png"></div><div class="title1">Smart Automated Cooking Kitchen</div><div class="title1-sep"></div><div class="title2">Central Kitchen & Franchise Management Solution</div><div class="clock">{{ vm.currentDate | date:\'dd-MMMM-yyyy\'}}<br>{{ vm.currentDate | date:\'hh:mm:ss a\'}}</div></div></div></div><div class="row"><div class="col-md-2 col-lg-2 leftPane"><div class="beststore"><h2>Top 5 Best Stores</h2><div class="beststore-item" ng-repeat="b in vm.selectedOutlet.topFiveRevenueBranchList"><div class="title">{{ b.branchName }}</div><div class="amount"><sup>RM</sup> {{ (b.totalRevenue + (vm.selectedOutlet==null ? 0 : (vm.selectedOutlet.branchName==b.name ? vm.selectedOutlet.revenueSummary.mtdRevenue : 0))) | number:0 }}</div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width:{{ vm.calcStoreRevenuePercentage(b.totalRevenue) }}%"></div></div></div></div><div class="bestseller"><h2>Top 5 Best Sellers</h2><div class="bestseller-item" ng-repeat="b in vm.selectedOutlet.bestSellerList"><div class="title">{{ (b.itemName.length > 20 ? (b.itemName | limitTo:20)+\' ...\' : b.itemName) | lowercase }}</div><div class="amount"><sup>RM</sup> <b>{{ b.totalRevenue | number:0 }}</b></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width:{{ vm.calcFoodRevenuePercentage(b.totalRevenue) }}%"></div></div></div></div><div class="version">Version 2024.02.12</div></div><div class="col-md-6 col-lg-6 centerPane"><div id="dashboardMap"></div><div class="box glowing"></div></div><div class="col-md-4 col-lg-4 rightPane"><div class="row"><h1>{{ vm.selectedOutlet.branchName }}</h1></div><h2><i class="fa fa-eraser"></i> <i class="fa fa-eraser"></i> <i class="fa fa-eraser"></i> &nbsp;&nbsp;&nbsp;&nbsp; Store Revenue Summary &nbsp;&nbsp;&nbsp;&nbsp; <i class="fa fa-eraser"></i> <i class="fa fa-eraser"></i> <i class="fa fa-eraser"></i></h2><div class="row"><div class="col-md-4 col-lg-4 small-box"><div class="title">Total Revenue (Today)</div><div><div class="icon"><i class="fa fa-usd"></i></div><div class="value in-progress">{{ vm.selectedOutlet.revenueSummary.todayRevenue || 0 | number:0 }}</div></div></div><div class="col-md-4 col-lg-4 small-box"><div class="title">Total Food Costs (Today)</div><div><div class="icon"><i class="fa fa-usd"></i></div><div class="value pending">{{ vm.selectedOutlet.revenueSummary.todayFoodCost || 0 | number:0 }}</div></div></div><div class="col-md-4 col-lg-4 small-box"><div class="title">GP Margin (Today)</div><div><div class="value pending">{{ vm.selectedOutlet.revenueSummary.todayProfitMargin || 0 | number:0 }}%</div></div></div></div><div class="row"><div class="col-md-4 col-lg-4 small-box"><div class="title">Total Revenue (MTD)</div><div><div class="icon"><i class="fa fa-usd"></i></div><div class="value in-progress">{{ vm.selectedOutlet.revenueSummary.mtdRevenue || 0 | number:0 }}</div></div></div><div class="col-md-4 col-lg-4 small-box"><div class="title">Total Food Costs (MTD)</div><div><div class="icon"><i class="fa fa-usd"></i></div><div class="value pending">{{ vm.selectedOutlet.revenueSummary.mtdFoodCost || 0 | number:0 }}</div></div></div><div class="col-md-4 col-lg-4 small-box"><div class="title">GP Margin (MTD)</div><div><div class="value pending">{{ vm.selectedOutlet.revenueSummary.mtdProfitMargin || 0 | number:0 }}%</div></div></div></div><h2><i class="fa fa-eraser"></i> <i class="fa fa-eraser"></i> <i class="fa fa-eraser"></i> &nbsp;&nbsp;&nbsp;&nbsp; Kitchen Activity Summary &nbsp;&nbsp;&nbsp;&nbsp; <i class="fa fa-eraser"></i> <i class="fa fa-eraser"></i> <i class="fa fa-eraser"></i></h2><div class="row"><div class="col-md-6 col-lg-6 small-box"><div class="title"># Orders In Progress</div><div><div class="icon"><i class="fa fa-cog fa-spin fa-fw"></i></div><div class="value in-progress">{{ vm.selectedOutlet.kitchenActivitySummary.wipJobCount || 0 | number:0 }}</div></div></div><div class="col-md-6 col-lg-6 small-box"><div class="title"># Orders Pending</div><div><div class="icon"><i class="fa fa-clock-o"></i></div><div class="value pending">{{ vm.selectedOutlet.kitchenActivitySummary.pendingJobCount || 0 | number:0 }}</div></div></div><div class="col-md-6 col-lg-6 small-box"><div class="title"># Orders Completed</div><div><div class="icon"><i class="fa fa-cutlery"></i></div><div class="value completed">{{ vm.selectedOutlet.kitchenActivitySummary.completedJobCount || 0 | number:0 }}</div></div></div></div><div class="row"><div class="col-md-6 col-lg-6 single-chart"><div class="title">Average Cooking Time</div><svg viewbox="0 0 36 36" class="circular-chart green"><path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path><path class="circle" stroke-dasharray="40, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path><text x="18" y="20.35" class="percentage">{{ vm.selectedOutlet.kitchenActivitySummary.avgCookingTime || 0 | numAbs | number:1 }} mins</text></svg></div><div class="col-md-6 col-lg-6 single-chart"><div class="title">Average Waiting Time</div><svg viewbox="0 0 36 36" class="circular-chart orange"><path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path><path class="circle" stroke-dasharray="65, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path><text x="18" y="20.35" class="percentage">{{ vm.selectedOutlet.kitchenActivitySummary.avgWaitingTime || 0 | numAbs | number:1 }} mins</text></svg></div><div class="col-md-6 col-lg-6 single-chart"><div class="title">Machine Utilization</div><svg viewbox="0 0 36 36" class="circular-chart blue"><path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path><path class="circle" stroke-dasharray="75, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path><text x="18" y="20.35" class="percentage">{{ vm.selectedOutlet.kitchenActivitySummary.machineUtilizationRate || 0 | numAbs | number:1 }}%</text></svg></div></div><h2><i class="fa fa-eraser"></i> <i class="fa fa-eraser"></i> <i class="fa fa-eraser"></i> &nbsp;&nbsp;&nbsp;&nbsp; ATTENTIONS &nbsp;&nbsp;&nbsp;&nbsp; <i class="fa fa-eraser"></i> <i class="fa fa-eraser"></i> <i class="fa fa-eraser"></i></h2><div uib-carousel="" active="vm.activeTab" interval="vm.carouselInterval" nowrap="vm.carouselNoWrap" ng-if="vm.selectedOutlet.iotAlertList.length!=0"><div uib-slide="" class="row" ng-repeat="b in vm.selectedOutlet.iotAlertList" ng-if="$index % 3 == 0" index="vm.getIndex($index)"><div class="col-md-3 col-lg-3 alert-box"><div class="title">Temperature Alert</div><div><div class="icon"><i class="fa fa-exclamation-triangle blink"></i></div><div class="value"><div class="equipment">{{ vm.selectedOutlet.iotAlertList[$index].description | limitTo:15 }}{{ (vm.selectedOutlet.iotAlertList[$index].description.length > 15 ? \'...\' : \'\') }}</div><div class="temperature">{{ (vm.selectedOutlet.iotAlertList[$index].temperature==null ? \'No Data\' : (vm.selectedOutlet.iotAlertList[$index].temperature | number:1)) }} <small ng-if="vm.selectedOutlet.iotAlertList[$index].temperature!=null">&deg;C</small></div></div></div></div><div class="col-md-3 col-lg-3 alert-box" ng-if="vm.selectedOutlet.iotAlertList.length>=$index+2"><div class="title">Temperature Alert</div><div><div class="icon"><i class="fa fa-exclamation-triangle blink"></i></div><div class="value"><div class="equipment">{{ vm.selectedOutlet.iotAlertList[$index+1].description | limitTo:15 }}{{ (vm.selectedOutlet.iotAlertList[$index+1].description.length > 15 ? \'...\' : \'\') }}</div><div class="temperature">{{ (vm.selectedOutlet.iotAlertList[$index+1].temperature==null ? \'No Data\' : (vm.selectedOutlet.iotAlertList[$index+1].temperature | number:1)) }} <small ng-if="vm.selectedOutlet.iotAlertList[$index].temperature!=null">&deg;C</small></div></div></div></div><div class="col-md-3 col-lg-3 alert-box" ng-if="vm.selectedOutlet.iotAlertList.length>=$index+3"><div class="title">Temperature Alert</div><div><div class="icon"><i class="fa fa-exclamation-triangle blink"></i></div><div class="value"><div class="equipment">{{ vm.selectedOutlet.iotAlertList[$index+2].description | limitTo:15 }}{{ (vm.selectedOutlet.iotAlertList[$index+2].description.length > 15 ? \'...\' : \'\') }}</div><div class="temperature">{{ (vm.selectedOutlet.iotAlertList[$index+2].temperature==null ? \'No Data\' : (vm.selectedOutlet.iotAlertList[$index+2].temperature | number:1)) }} <small ng-if="vm.selectedOutlet.iotAlertList[$index].temperature!=null">&deg;C</small></div></div></div></div></div></div><div class="col-md-3 col-lg-3 big-box" ng-if="vm.selectedOutlet.iotAlertList.length==0"><div class="value"><i class="fa fa-info-circle"></i> &nbsp;Everything is in good shape!</div></div></div></div></div>');
$templateCache.put('app/pages/deliveryorderconsolidated/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-show="vm.originalStatus==\'NEW\'"><small><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_DELIVERY_ORDER_DETAILS"></span>.</small><br><br></p><p ng-show="vm.originalStatus!=\'NEW\'"><small><i class="fa fa-warning"></i> <span translate="ALL_THE_FIELDS_WILL_BE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="NEW"></b>.</small><br><br></p><div class="row"><div class="col-md-6 col-lg-6"><legend style="height:32.4px;line-height:32.4px"><span translate="DELIVERY_ORDER_INFO"></span></legend></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b><span translate="DELIVERY_ORDER_NO"></span>.</b></label> <span class="form-control" ng-disabled="true" style="color:#00f">{{vm.do.deliveryOrderNo || \'*** AUTONUMBER ***\'}}</span><div ng-if="vm.do.originalDocNo!=null && vm.do.originalDocNo!=\'\'" style="margin-left:5px;color:#00f"><small>(Original Ref: <b>{{vm.do.originalDocNo}}</b>)</small></div></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeliveryDate.$invalid && (vm.dataForm.DeliveryDate.$dirty || vm.dataForm.$submitted)}"><label><b translate="DELIVERY_ORDER_DATE"></b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.do.deliveryOrderDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" name="DeliveryDate" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.deliveryOrderDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeliveryDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Status.$invalid && (vm.dataForm.Status.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="DELIVERY_ORDER_STATUS"></b> <i class="fa fa-asterisk req"></i></label><select name="Status" class="form-control" ng-change="changed()" ng-model="vm.do.status" ng-options="i as (i | translate) for i in vm.doStatuses" ng-show="vm.originalStatus==\'NEW\'" required=""></select><span class="form-control" ng-show="vm.originalStatus!=\'NEW\'" ng-disabled="vm.originalStatus!=\'NEW\'">{{vm.do.status}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Status.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.remarks">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-3 col-lg-3" ng-if="vm.do.createdBy"><div class="form-group"><label><b translate="CREATED_BY">:</b></label><br><span>{{vm.do.createdBy | uppercase}}<br><span translate="DATE"></span>: {{ vm.do.createdDate | date:\'dd/MM/yyyy\' }}</span></div></div><div class="col-md-3 col-lg-3" ng-if="vm.do.modifiedBy"><div class="form-group"><label><b translate="MODIFIED_BY">:</b></label><br><span>{{vm.do.modifiedBy | uppercase}}<br><span translate="DATE"></span>: {{ vm.do.modifiedDate | date:\'dd/MM/yyyy\' }}</span></div></div></div><br><br><div class="row"><div class="col-md-6 col-lg-6"><legend style="height:32.4px;line-height:32.4px"><span translate="TRANSFER_FROM_OTHER_DOCUMENT"></span></legend></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b><span translate="SALES_ORDER_NO"></span>.</b></label><div class="input-group"><span class="form-control" ng-disabled="true" style="color:#00f">{{vm.do.salesOrderNo || \'-\'}}</span> <a href="" class="btn btn-primary btn-with-icon input-group-addon" style="padding:3px 10px;font-size:9pt" ng-click="vm.showSelectSalesOrderModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && !vm.showSelectDebtor && vm.do.salesOrderId==null && vm.do.transferId==null"><i class="ion ion-android-checkmark-circle"></i> <span translate="SELECT"></span></a> <a href="" class="btn btn-default btn-with-icon input-group-addon" style="padding:3px 10px;font-size:9pt;color:#f00" ng-click="vm.clearSelectSalesOrder()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && !vm.showSelectDebtor && vm.do.salesOrderId!=null"><i class="ion ion-close"></i> <span translate="CLEAR"></span></a></div></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b><span translate="STOCK_TRANSFER_NO"></span>.</b></label><div class="input-group"><span class="form-control" ng-disabled="true" style="color:#00f">{{vm.do.stockTransferNo || \'-\'}}</span> <a href="" class="btn btn-primary btn-with-icon input-group-addon" style="padding:3px 10px;font-size:9pt" ng-click="vm.showSelectStockTransferModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && !vm.showSelectDebtor && vm.do.salesOrderId==null && vm.do.transferId==null"><i class="ion ion-android-checkmark-circle"></i> <span translate="SELECT"></span></a> <a href="" class="btn btn-default btn-with-icon input-group-addon" style="padding:3px 10px;font-size:9pt;color:#f00" ng-click="vm.clearSelectStockTransfer()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && !vm.showSelectDebtor && vm.do.transferId!=null"><i class="ion ion-close"></i> <span translate="CLEAR"></span></a></div></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>Customer P.O. No.</b> (<span translate="OPTIONAL"></span>)</label> <input type="text" class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.customerPoNo"></div></div></div><br><br><div class="row"><div class="col-md-6 col-lg-6"><legend style="height:32.4px;line-height:32.4px"><span translate="CUSTOMER_INFO"></span></legend></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'SELECT_A_CUSTOMER\'| translate }}</b> (<span translate="OPTIONAL"></span>)</label> <a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" style="margin-bottom:5px" ng-click="vm.selectedDebtor=null" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && vm.selectedDebtor!=null && vm.do.salesOrderId==null && vm.do.transferId==null"><i class="ion ion-android-checkmark-circle"></i> {{ \'CLEAR_SELECTION\' | translate }}</a><select name="Customer" class="form-control" ng-change="vm.selectedDebtorChanged()" ng-model="vm.selectedDebtor" ng-options="i as i.name for i in vm.debtorList" ng-disabled="vm.originalStatus!=\'NEW\' || vm.do.salesOrderId!=null || vm.do.transferId!=null"></select></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'SELECT_A_CUSTOMER_BRANCH\'| translate }}</b> (<span translate="OPTIONAL"></span>)</label> <a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" style="margin-bottom:5px" ng-click="vm.selectedDebtorBranch=null" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && vm.selectedDebtorBranch!=null && vm.do.salesOrderId==null && vm.do.transferId==null"><i class="ion ion-android-checkmark-circle"></i> {{ \'CLEAR_SELECTION\' | translate }}</a><select name="CustomerBranch" class="form-control" ng-change="vm.selectedDebtorBranchChanged()" ng-model="vm.selectedDebtorBranch" ng-options="i as i.name for i in vm.debtorBranchList" ng-disabled="vm.originalStatus!=\'NEW\' || vm.do.salesOrderId!=null || vm.do.transferId!=null"></select></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DebtorName.$invalid && (vm.dataForm.DebtorName.$dirty || vm.dataForm.$submitted)}"><label><b translate="COMPANY_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DebtorName" ng-model="vm.do.debtorName" ng-disabled="vm.originalStatus!=\'NEW\'" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DebtorName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="CONTACT_PERSON"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorContactPerson" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Address1.$invalid && (vm.dataForm.Address1.$dirty || vm.dataForm.$submitted)}"><label><b translate="ADDRESS_1"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Address1" ng-model="vm.do.debtorAddress1" ng-disabled="vm.originalStatus!=\'NEW\'" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Address1.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="ADDRESS_2"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorAddress2" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="ADDRESS_3"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorAddress3" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="STATE"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorState" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="POSTAL_CODE"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorPostCode" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="COUNTRY"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorCountry" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="TELEPHONE"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorTel" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="FAX"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorFax" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'PRODUCTS\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="ADD_ITEMS_INTO_THIS_DELIVERY_ORDER"></span>. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddProductModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="ion-plus-round"></i>{{ \'ADD_ITEM\' | translate }}</a> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddProductModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'SHIPPED\' && vm.originalStatus!=\'W.I.P\' && vm.originalStatus!=\'COMPLETED\' && vm.originalStatus!=\'CANCELLED\'" rms-check-access="deliveryorders" rms-check-access-perm-type="APPROVE"><i class="ion-plus-round"></i>{{ \'ADD_ITEM\' | translate }}</a><br><br></p><div><toggle ng-model="vm.showDetailedInvView" ng-change="changed()" on="{{ \'DETAILED\' | translate }}" off="{{ \'SUMMARY\' | translate }}" onstyle="btn-success btn-xs" offstyle="btn-default btn-xs"></toggle>&nbsp;&nbsp;<small>{{ \'ITEM_INVENTORY_BAL_VIEW_MODE\' | translate }}</small></div><br><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:2px solid #ccc" st-pipe="vm.refreshBookingProducts" st-table="vm.do.deliveryOrderProducts" refresh-table=""><thead style="border-bottom:3px solid #ccc"><tr class="sortable"><th style="width:60px">#</th><th>{{ \'PRODUCT_NAME\' | translate }}</th><th style="width:100px;text-align:right" class="hide-after">{{ \'QUANTITY\' | translate }}</th><th style="text-align:right;width:120px;line-height:110%" class="hide-after" ng-if="vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\'"><b>{{ \'QUANTITY\' | translate }}<br>{{ \'STOCK_OUT\' | translate }}</b></th><th style="text-align:right;width:120px;line-height:110%" class="hide-after" ng-if="vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\'"><b>{{ \'QUANTITY\' | translate }}<br>{{ \'SHIPPED\' | translate }}</b></th><th style="width:100px"><b>{{ \'U.O.M.\' | translate }}</b></th><th style="width:150px;text-align:right" class="hide-after">{{ \'UNIT_PRICE\' | translate }}<br>({{vm.currency}})</th><th style="width:150px;text-align:right" class="hide-after">{{ \'DISCOUNT\' | translate }}<br>({{vm.currency}})</th><th style="width:100px;text-align:right" class="hide-after">{{ \'TOTAL_TAX\' | translate }}<br>({{vm.currency}})</th><th style="text-align:right;width:150px" class="hide-after">{{ \'SUBTOTAL\' | translate }} ({{vm.currency}})<br><small>(<span translate="INCLUDE_TAX"></span>)</small></th><th style="width:20px"></th><th>{{ \'REMARKS\' | translate }}</th><th style="width:90px"></th><th style="width:90px" ng-if="vm.originalStatus==\'NEW\'"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.do.deliveryOrderProducts"><td>{{$index+1}})</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%"><b>{{ ntn.productName || \'\' }}</b><br><small style="color:#888"><b>{{ ntn.productCode }}</b>&nbsp;&nbsp;({{ ntn.itemType }})</small><div style="margin-top:5px;margin-bottom:10px"><table cellpadding="1" border="1" style="width:500px;font-size:9pt" ng-if="!vm.showDetailedInvView"><tr><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'AVAILABLE\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'RESERVED\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'BALANCE\' | translate }}</td><td style="width: 50px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'U.O.M.\' | translate }}</td></tr><tr><td style="padding: 2px auto;text-align:center"><span ng-class="{\'text-danger\': (vm.getAvailableQty(ntn) < 0), \'text-success\': (vm.getAvailableQty(ntn) > 0)}"><b>{{vm.getAvailableQty(ntn) | number}}</b></span></td><td style="padding: 2px auto;text-align:center">{{vm.getReservedQty(ntn) | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.invBalance | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.invUomName}}</td></tr></table><table cellpadding="1" border="1" style="width:500px;font-size:9pt" ng-if="vm.showDetailedInvView"><tr><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'AVAILABLE\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'SO_NEW\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'SO_CFM\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'DO_PND\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'BALANCE\' | translate }}</td><td style="width: 50px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'U.O.M.\' | translate }}</td></tr><tr><td style="padding: 2px auto;text-align:center"><span ng-class="{\'text-danger\': (vm.getAvailableQty(ntn) < 0), \'text-success\': (vm.getAvailableQty(ntn) > 0)}"><b>{{vm.getAvailableQty(ntn) | number}}</b></span></td><td style="padding: 2px auto;text-align:center">{{ntn.totalNewSalesOrderQuantity | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.totalConfirmedSalesOrderQuantity | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.totalDOPendingQuantity | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.invBalance | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.invUomName}}</td></tr></table></div></td><td style="text-align:right">{{ ntn.quantity }}</td><td style="text-align:right" ng-if="vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\'"><span style="color:#0000ff">{{ ntn.quantityStockedOut }}</span></td><td style="text-align:right" ng-if="vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\'"><span style="color:#009600">{{ ntn.quantityTransported }}</span></td><td>{{ ntn.uomName }}</td><td style="text-align:right">{{ ntn.unitPrice | currency:\'\' }}</td><td style="text-align:right"><span class="text-danger">({{ ntn.discountAmount || 0.00 | currency:\'\' }}) <span></span></span></td><td style="text-align:right">{{ ntn.tax | currency:\'\' }}</td><td style="text-align:right">{{ ntn.subtotal | currency:\'\' }}</td><td style="width:20px"></td><td style="padding-top:8px;padding-bottom:8px;line-height:150%">{{ ntn.remarks }}</td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditProductModal($index)" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditProductModal($index)" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'CANCELLED\' && ntn.quantityStockedOut!=ntn.quantity" rms-check-access="deliveryorders" rms-check-access-perm-type="APPROVE"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeProduct($index)" ng-confirm-click="Confirm remove this Product?" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a> <a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeProduct($index)" ng-confirm-click="Confirm remove this Product?" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'W.I.P\' && vm.originalStatus!=\'CANCELLED\' && ntn.quantityStockedOut==0 && ntn.quantityTransported==0" rms-check-access="deliveryorders" rms-check-access-perm-type="APPROVE"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="12" align="center" ng-show="vm.do.deliveryOrderProducts.length==0"><br><span translate="PRODUCT_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot style="border-top:3px solid #ccc"><tr><td colspan="{{ (vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\' ? 9 : 7) }}" style="text-align:right"><b>{{ \'SUBTOTAL\' | translate }} ({{vm.currency}}) :</b></td><td style="text-align:right"><b>{{ vm.subtotal | currency:\'\'}}</b></td></tr><tr><td colspan="{{ (vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\' ? 9 : 7) }}" rowspan="2" style="text-align:right"><div style="display:inline-block;margin-top:30px;line-height:110%"><b>( <span class="text-danger">&#8722;</span> )&nbsp; {{ \'ADDITIONAL_DISCOUNT\' | translate }} :</b><br><small>({{ \'FILL_IN_EITHER_ONE\' | translate }})<small>&nbsp;</small></small></div></td><td style="text-align:right"><div class="form-group" style="margin-bottom:0px" ng-class="{\'has-error\': vm.dataForm.DiscountPercentage.$invalid && (vm.dataForm.DiscountPercentage.$dirty || vm.dataForm.$submitted)}"><input type="number" name="DiscountPercentage" class="form-control" min="0" style="text-align:right;width:150px;background:#fffced;-webkit-appearance:none;-moz-appearance:textfield" ng-change="vm.calculateDiscountAmount1()" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.discountPercentage"> <span class="help-block" style="margin-top:0px;margin-bottom:0px" ng-show="vm.dataForm.$submitted && vm.dataForm.DiscountPercentage.$error.number"><small>* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</small></span></div></td><td>%</td></tr><tr><td style="text-align:right"><div class="form-group" style="margin-bottom:0px" ng-class="{\'has-error\': vm.dataForm.DiscountAmount.$invalid && (vm.dataForm.DiscountAmount.$dirty || vm.dataForm.$submitted)}"><input type="number" name="DiscountAmount" class="form-control" min="0" style="text-align:right;width:150px;background:#fffced;-webkit-appearance:none;-moz-appearance:textfield" ng-change="vm.calculateDiscountAmount2()" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.discountAmount"> <span class="help-block" style="margin-top:0px;margin-bottom:0px" ng-show="vm.dataForm.$submitted && vm.dataForm.DiscountAmount.$error.number"><small>* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</small></span></div></td><td>({{vm.currency}})</td></tr><tr><td colspan="{{ (vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\' ? 6 : 4) }}" style="text-align:right;font-size:10pt;line-height:110%"><b>( <span class="text-success" style="font-size:12pt !important">+</span> )&nbsp; {{ \'ADDITIONAL_CHARGES\' | translate }} :</b><br><small>({{ \'FURTHER_DESCRIPTION\' | translate}})</small>&nbsp;</td><td colspan="3" style="text-align:right"><input type="text" class="form-control input-sm" style="background:#FFFCED" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.additionalChargesDesc"></td><td style="text-align:right"><div class="form-group" style="margin-bottom:0px" ng-class="{\'has-error\': vm.dataForm.AdditionalCharges.$invalid && (vm.dataForm.AdditionalCharges.$dirty || vm.dataForm.$submitted)}"><input type="number" name="AdditionalCharges" class="form-control" min="0" style="text-align:right;width:150px;background:#fffced;-webkit-appearance:none;-moz-appearance:textfield" ng-change="vm.recalculateGrandTotal()" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.additionalCharges"> <span class="help-block" style="margin-top:0px;margin-bottom:0px" ng-show="vm.dataForm.$submitted && vm.dataForm.AdditionalCharges.$error.number"><small>* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</small></span></div></td></tr><tr><td colspan="{{ (vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\' ? 9 : 7) }}" style="text-align:right"><h3 style="margin-top:8px;margin-bottom:0px;font-weight:bold">{{ \'GRAND_TOTAL\' | translate }} ({{vm.currency}}) :</h3></td><td style="text-align:right;padding:0px"><div style="margin:8px;padding:8px;border:3px solid #000;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;"><h3 style="margin-bottom:0px"><b>{{vm.do.grandTotal || vm.grandTotal | currency:\'\'}}</b></h3></div></td></tr></tfoot></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.do.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_DELIVERY_ORDER"></span>.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br><span translate="THERE_IS_NO_CHANGES_YET"></span>.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="productModal.html"><form name="$mdl.productForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="ITEM"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" style="margin-bottom:5px" ng-if="$mdl.selectedItem!=null" ng-click="$mdl.selectedItem=null"> <i class="fa fa-times"></i> <span style="color:#fff" translate="CLEAR_SELECTION"></span> </button> <label> <b>{{ \'RAW_MATERIAL\' | translate }}</b> / <b>{{ \'SEMI_FINISHED_GOODS\' | translate }}</b> / <b>{{ \'FINISHED_GOODS\' | translate }}</b> </label> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.itemSearch" style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model-options=\'{ debounce: 1500 }\' ng-change="$mdl.searchItem($mdl.itemSearch)" /> </div> </div> <div class="col-lg-9"> <select class="form-control" style="background:#FFFCED" name="ItemName" ng-disabled="$mdl.lockButtons" ng-change="$mdl.selectedItemChanged()" ng-options="u as (\'[\' + u.itemType + \'] \' + u.productName | uppercase) for u in $mdl.itemList" ng-model="$mdl.selectedItem" required> <option value="">{{($mdl.lockButtons ? (\'LOADING...\' | translate) : ($mdl.itemList.length==0 ? ("&lt;&lt; " + (\'ENTER_A_KEYWORD_TO_SEARCH\' | translate)) : ("-- " + (\'SELECT_AN_ITEM\' | translate) + " --")))}}</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted"> * {{"REQUIRED" | translate}} </p> </div> </div> </div> </div> <br /> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.Quantity.$invalid && $mdl.productForm.$submitted}"> <div class="row"> <div class="col-lg-3" ng-if="$mdl.mode!=1"> <label><b>{{ \'QUANTITY\' | translate }} {{ \'STOCK_OUT\' | translate }}</b> </label> <span class="form-control" min=0.001 ng-disabled="true"> {{ $mdl.item.quantityStockedOut }} </span> </div> <div class="col-lg-3"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" name="Quantity" class="form-control" min=0.001 style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.quantity" ng-change="$mdl.quantityChanged()" required /> </div> <div class="col-lg-3"> <label><b translate="U.O.M"></b> <!-- &nbsp;<small>(<span translations="CONFIGURE_AT"></span> <b><em translations= "MAINTENANCE_>_PRODUCTS" ></em></b>)</small> --> </label> <span class="form-control" disabled="disabled"> <b ng-hide="$mdl.item.unitOfMeasurementId==null">{{ $mdl.item.uomName || \'\' }}</b> <span style="color:#f00" ng-if="$mdl.item.unitOfMeasurementId==null"> <small translate="SALES_U.O.M_NOT_AVAILABLE"></small> </span> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> </span> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.required && $mdl.productForm.$submitted">* {{ "REQUIRED" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.number && $mdl.productForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.min && $mdl.productForm.$submitted">* {{ "MINIMUM_VALUE_IS_0.001" | translate }}</p> <p class="help-block" style="color:#f00" ng-if="$mdl.item.quantity < $mdl.item.quantityStockedOut">* {{ "QTY_CANT_BE_LOWER_THAN_QTY_STOCKED_OUT" | translate }} ({{$mdl.item.quantityStockedOut}})</p> </div> <div class="row"> <div class="col-lg-3"> <div class="form-group"> <label><b>{{ \'UNIT_PRICE\' | translate }}</b> ({{ $mdl.currencyCode }})</label> <span class="form-control" disabled="disabled"> {{ $mdl.item.unitPrice | currency:\'\' }} </span> </div> </div> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.DiscountPercentage.$invalid && $mdl.productForm.$submitted}"> <label> <b>{{ \'DISCOUNT\' | translate }} %</b></label> <input type="number" name="DiscountPercentage" class="form-control" min=0 style="background:#fffced;color:#000" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.discountPercentage" ng-change="$mdl.calculateDiscountAmount1()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.DiscountPercentage.$error.number && $mdl.productForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.DiscountPercentage.$error.min && $mdl.productForm.$submitted">* {{ "MINIMUM_VALUE_IS_0" | translate }}</p> </div> </div> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.DiscountAmount.$invalid && $mdl.productForm.$submitted}"> <label> <b>{{ \'DISCOUNT\' | translate }}</b> ({{ $mdl.currencyCode }})</label> <input type="number" name="DiscountAmount" class="form-control" min=0 style="background:#fffced;color:#000" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.discountAmount" ng-change="$mdl.calculateDiscountAmount2()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.DiscountAmount.$error.number && $mdl.productForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.DiscountAmount.$error.min && $mdl.productForm.$submitted">* {{ "MINIMUM_VALUE_IS_0" | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-3"> <div class="form-group"> <label> <b>{{ \'TAX_CODE\' | translate }}</b></label> <span class="form-control" disabled="disabled"> {{ $mdl.item.taxCode }} </span> </div> </div> <div class="col-lg-3"> <div class="form-group"> <label> <b>{{ \'TAX_PERCENT\' | translate }}</b> (%)</label> <span class="form-control" disabled="disabled"> {{ $mdl.item.taxPercent }} </span> </div> </div> <div class="col-lg-3"> <div class="form-group"> <label> <b>{{ \'TAX_AMOUNT\' | translate }}</b> ({{ $mdl.currencyCode }})</label> <span class="form-control" disabled="disabled"> {{ $mdl.item.tax }} </span> </div> </div> <div class="col-lg-3"> <div class="form-group"> <label style="color:#00f"><b>{{ \'SUBTOTAL\' | translate }}</b> ({{ $mdl.currencyCode }})</label> <span class="form-control" style="border:2px solid #000;color:#000"> <b>{{ $mdl.item.subtotal }}</b> </span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <label><b>Remarks</b></label> <input type="text" class="form-control" style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.remarks" /> </div> </div> </div> <hr /> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="salesOrderListModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="SELECT_A_SALES_ORDER"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:9pt" st-pipe="$mdl.retrieveData" st-table="$mdl.data" refresh-table> <thead> <tr> <th colspan="3" style="padding-left:0px"> <select st-search="isOpenDoc" class="form-control" style="background:#fffeed;font-weight:bold"> <option value="">{{ \'SHOW_CONFIRMED_DOCUMENTS\' | translate }}</option> <option value="1">{{ \'SHOW_INPROCESS_DOCUMENTS\' | translate }}</option> </select> </th> <th colspan="4" style="text-align:center"> <span style="color:#00f" ng-if="$mdl.isLoading"> <big><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></big> </span> </th> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th style="width:60px">#</th> <th st-sort="salesOrderNo">{{ \'SO_NO\' | translate }}</th> <th st-sort="createdDate"style="width:100px;padding-top:11px;padding-bottom:11px;line-height:110%"> {{\'ORDER_DATE\' | translate}}<br /><small>(DD/MM/YYYY)</small> </th> <th st-sort="deliveryDate"style="width:100px;padding-top:11px;padding-bottom:11px;line-height:110%"> {{\'DELIVERY_DATE\' | translate}}<br /><small>(DD/MM/YYYY)</small> </th> <th st-sort="branchName">{{ \'BRANCH\' | translate }}</th> <th st-sort="debtorName">{{ \'CUSTOMER\' | translate }}</th> <!-- <th>{{ \'CUSTOMER_PO_NUMBER\' | translate }}</th> --> <th>{{ \'ORDER_TITLE\' | translate }}<br /><small>{{ \'DESCRIPTION\' | translate }}</small></th> <th st-sort="status">{{ \'STATUS\' | translate }}</th> <th st-sort="createdBy">{{ \'ORDERED_BY\' | translate }}</th> <th style="width:40px"></th> </tr> <tr class="sortable "> <th class="form-inline" style="padding-left:0px;padding-right:0px"> <a href class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search> {{ \'RESET\' | translate }} </a> </th> <th class="form-inline"> <input st-search="salesOrderNo" class="form-control input input-sm" style="width:100px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="createdDate" class="form-control input input-sm" style="width:80px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="deliveryDate" class="form-control input input-sm" style="width:80px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="branchName" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="debtorName" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <!-- <th class="form-inline"> <input st-search="customerPoNo" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> --> <th class="form-inline"> <input st-search="orderTitle" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th></th> <th class="form-inline"> <input st-search="createdBy" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th></th> </tr> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.soData.length==0"> <td colspan="11" style="height:100px;line-height:100px;text-align:center"> {{ \'NO_SALES_ORDER_AVAILABLE\' | translate }} </td> </tr> <tr ng-repeat="item in $mdl.data"> <td>{{vm.startIndex+1+$index}})</td> <td nowrap="nowrap" style="padding-top:8px;padding-bottom:8px;line-height:110%"> {{item.salesOrderNo}} <div ng-if="item.stockRequestNo!=null && item.stockRequestNo!=\'\'"> <small>(S/R No: <b>{{item.stockRequestNo}}</b>)</small> </div> <div ng-if="item.originalDocNo!=null && item.originalDocNo!=\'\'"> <small>(Ori Ref: <b>{{item.originalDocNo}}</b>)</small> </div> </td> <td>{{item.createdDate | date: "dd/MM/yyyy"}}</td> <td>{{item.deliveryDate | date: "dd/MM/yyyy"}}</td> <td style="padding-top:11px;padding-bottom:11px;line-height:110%"> {{item.branchName | uppercase}} </td> <td style="padding-top:11px;padding-bottom:11px;line-height:130%"> {{item.debtorName || \'-\'}} <div ng-if="item.debtorBranchName!=null"> <small>{{ item.debtorBranchName }}</small> </div> </td> <!-- <td>{{item.customerPoNo || \'-\'}}</td> --> <td style="padding-top:11px;padding-bottom:11px;line-height:130%"> {{item.name | uppercase}} <br /> <small>{{item.description || \'\' | uppercase}}</small> </td> <td nowrap="nowrap"> <b> <span ng-if="item.status==\'CONFIRMED\'" style="color:#00f">{{item.status}}</span> <span ng-if="item.status==\'IN PROCESS\'" style="color:#31b046">{{item.status}}</span> </b> </td> <td> {{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \'...\' : \'\') }} </td> <td style="text-align:center"> <a href title="Select" class="btn btn-primary btn-xs btn-with-icon" ng-click="$mdl.selectSalesOrder(item.id)"> <big><i class="fa fa-check"></i> {{ "SELECT" | translate }}</big> </a> </td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <div style="float:left"> Total Records: <b>{{$mdl.numOfRecord}}</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="stockTransferListModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="SELECT_A_STOCK_TRANSFER_DOCUMENT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:9pt" st-pipe="$mdl.retrieveData" st-table="$mdl.data" refresh-table> <thead> <tr> <th colspan="3" style="padding-left:0px"> <select st-search="isOpenDoc" class="form-control" style="background:#fffeed;font-weight:bold"> <option value="">{{ \'SHOW_CONFIRMED_DOCUMENTS\' | translate }}</option> <option value="1">{{ \'SHOW_INPROCESS_DOCUMENTS\' | translate }}</option> </select> </th> <th colspan="3" style="text-align:center"> <span style="color:#00f" ng-if="$mdl.isLoading"> <big><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></big> </span> </th> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th style="width:60px">#</th> <th st-sort="docNo" st-sort-default="reverse">{{ \'DOCUMENT_NO\' | translate }}</th> <th st-sort="createdDate"style="padding-top:11px;padding-bottom:11px;line-height:110%"> {{ \'DOCUMENT_DATE\' | translate }}<br /><small>(DD/MM/YYYY)</small> </th> <th st-sort="createdDate"style="padding-top:11px;padding-bottom:11px;line-height:110%"> {{ \'DELIVERY_DATE\' | translate }}<br /><small>(DD/MM/YYYY)</small> </th> <th>{{ \'SOURCE\' | translate }}</th> <th>{{ \'DESTINATION\' | translate }}</th> <!-- <th style="padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'REMARKS\' | translate }}</th> --> <th st-sort="status">{{ \'STATUS\' | translate }}</th> <th st-sort="createdBy">{{ \'ORDERED_BY\' | translate }}</th> <th style="width:40px"></th> </tr> <tr> <th class="form-inline" style="padding-left:0px;padding-right:0px"> <a href class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search> {{ \'RESET\' | translate }} </a> </th> <th class="form-inline"> <input st-search="docNo" class="form-control input input-sm" style="width:100px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="createdDate" class="form-control input input-sm" style="width:80px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="deliveryDate" class="form-control input input-sm" style="width:80px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="sourceBranchName" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="destBranchName" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th></th> <!-- <th></th> --> <th class="form-inline"> <input st-search="createdBy" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th></th> </tr> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.data.length==0"> <td colspan="10" style="height:100px;line-height:100px;text-align:center"> <b>{{ \'NO_STOCK_TRANSFER_DOCUMENT_AVAILABLE\' | translate }}</b> </td> </tr> <tr ng-repeat="item in $mdl.data"> <td>{{vm.startIndex+1+$index}})</td> <td nowrap="nowrap" style="padding-top:8px;padding-bottom:8px;line-height:110%"> {{item.docNo}} <div ng-if="item.stockRequestNo!=null && item.stockRequestNo!=\'\'"> <small>(S/R No: <b>{{item.stockRequestNo}}</b>)</small> </div> </td> <td>{{item.createdDate | date: "dd/MM/yyyy"}}</td> <td>{{item.deliveryDate | date: "dd/MM/yyyy"}}</td> <td>{{item.sourceBranchName | uppercase}}</td> <td>{{item.destBranchName | uppercase}}</td> <!-- <td>{{item.remarks}}</td> --> <td nowrap="nowrap"> <b> <span ng-if="item.status==\'CONFIRMED\'" style="color:#00f">{{item.status}}</span> <span ng-if="item.status==\'IN PROCESS\'" style="color:#31b046">{{item.status}}</span> </b> </td> <td> {{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \'...\' : \'\') }} </td> <td style="text-align:center"> <a href title="Select" class="btn btn-primary btn-xs btn-with-icon" ng-click="$mdl.selectDocument(item.id)"> <big><i class="fa fa-check"></i> {{ "SELECT" | translate }}</big> </a> </td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <div style="float:left"> Total Records: <b>{{$mdl.numOfRecord}}</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="creditApprovalModal.html"><form name="$mdl.approvalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-warning"> <h3 class="modal-title" id="modal-title" style="color:#000"> <i class="fa fa-exclamation-triangle"></i> Customer Credit Limit Exceeded </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <h3 style="color:#f00;line-height:150%;text-align:justify"> System detects that the selected Customer has exceeded the <b><u>Credit Limit</u></b>. Do you want to proceed with the confirmation of this Delivery Order? </h3> <br /> <br /> <br /> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> APPROVE </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> DISAPPROVE </button> </div> </form></script><script type="text/ng-template" id="requestCreditApprovalModal.html"><form name="$mdl.approvalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-warning"> <h3 class="modal-title" id="modal-title" style="color:#000"> <i class="fa fa-exclamation-triangle"></i> Customer Credit Limit Exceeded </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <h3 style="color:#f00;line-height:150%;text-align:justify"> System detects that the selected Customer has exceeded the <b><u>Credit Limit</u></b></b>. Do you want to request for Manager Approval to confirm this Delivery Order? </h3> <br /> <br /> <br /> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" style="width:100px" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> YES </button> <button class="btn btn-danger btn-with-icon" type="button" style="width:80px" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> NO </button> </div> </form></script>');
$templateCache.put('app/pages/deliveryorderconsolidated/doConsoCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/deliveryorderconsolidated/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ui-sref="consodeliveryorders.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_DELIVERY_ORDER"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="consodeliveryorders.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/deliveryorderconsolidated/doConsoList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="DeliveryOrderListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table="" style="font-size:90%"><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_ALL_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:30px;line-height:30px"></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:30px;line-height:30px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="docNo">{{ \'DOC_NO\' | translate }}</th><th st-sort="createdDate">{{ \'DOC_DATE\' | translate }}</th><th st-sort="debtorName">{{ \'CUSTOMER_NAME\' | translate }}</th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th>{{ \'CREATED_BY\' | translate }}</th><th style="width:30px"></th><th style="width:30px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline"><input st-search="docNo" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th class="form-inline"><input st-search="status" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="createdBy" class="form-control input input-sm" style="width:120px"></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.data.length==0 && !vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><center translate="NO_RECORD_FOUND">.</center></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td nowrap="nowrap">{{item.docNo}}</td><td>{{item.createdDate | date: "dd/MM/yyyy" }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{item.debtor.debtorName || "-"}}<div ng-if="item.debtor.debtorBranchName">{{item.debtor.debtorBranchName || "-"}}</div></td><td>{{item.status || "-"}}</td><td>{{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \' ...\' : \'\') }}</td><td align="center"><a href="" title="Print Invoice" class="btn btn-default btn-with-icon btn-xs" style="display:inline-block;font-size:11pt" ng-click="vm.printDoc(item.id, item.docNo)" ng-if="item.status!=\'CANCELLED\'" rms-check-access="consodeliveryorders" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <small>PDF</small></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="consodeliveryorders.update({id:item.id})" rms-check-access="consodeliveryorders" rms-check-access-perm-type="UPDATE"><i class="fa fa-eye" ng-if="item.status.indexOf(\'COMPLETED\')!=-1"></i> <i class="fa fa-pencil" ng-if="item.status.indexOf(\'COMPLETED\')==-1"></i></a></td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:30px;line-height:30px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="downloadModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="EXPORT_TRANSACTIONS_INTO_EXCEL"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <p translate="EXPORT_THE_DELIVERY_ORDER_TRANSACTIONS_INTO_EXCEL_FORMAT_FOR_ACCOUNTING_SOFTWARE">.</p> <br /><br /> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"><span translate="EXPORT_NEW_TRANSACTIONS"></span></legend> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcel()"> <i class="fa fa-download"></i> {{\'GENERATE_EXCEL\' | translate}} </a> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <br /><br /> <div class="row" ng-if="$mdl.batchList.length!=0"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <select name="BatchNo" class="form-control" style="margin-bottom:10px;background:#fffeed" ng-model="$mdl.selectedBatchId" ng-change="$mdl.selectedBatchIdChanged()" ng-options="i as i for i in $mdl.batchList"> <option value="">={{ \'SELECT_ONE\' | translate }}=</option> </select> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcelPast()"> <i class="fa fa-download"></i> {{\'DOWNLOAD_EXCEL\' | translate}} </a> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <div class="row" ng-if="$mdl.batchList.length==0"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <br /> <center> <b class="text-primary"><i class="fa fa-info-circle"></i> <span translate="NO_PREVIOUS_EXPORT_AVAILABLE"></span></b> </center> </div> </div> </div> <hr /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/deliveryorderconsolidated/doConsoUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/deliveryorderconsolidated/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:30px" ui-sref="consodeliveryorders.list"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-if="vm.originalStatus==\'NEW\'" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'SHIPPED\' && vm.originalStatus!=\'COMPLETED\' && vm.originalStatus!=\'CANCELLED\'" ng-disabled="vm.lockButtons" rms-check-access="consodeliveryorders" rms-check-access-perm-type="APPROVE"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-success btn-with-icon" style="margin-right:30px" ng-if="vm.originalStatus==\'CONFIRMED\'" ng-disabled="vm.lockButtons" ng-confirm-click="Are you sure to approve this Delivery Order?" confirmed-click="vm.preCheckApproveDeliveryOrder()" rms-check-access="consodeliveryorders" rms-check-access-perm-type="APPROVE"><i class="ion ion-checkmark"></i> <span translate="APPROVE_D.O."></span></a> <a href="" class="btn btn-danger btn-with-icon" style="margin-right:30px" ng-if="vm.mode==2 && !vm.do.isStockReceiving && (vm.originalStatus==\'NEW\' || vm.originalStatus==\'CONFIRMED\' || vm.originalStatus==\'APPROVED\' || vm.originalStatus==\'PROCESSING\' || vm.originalStatus==\'PROCESSED\')" ng-disabled="vm.lockButtons" ng-confirm-click="Are you sure to cancel this Delivery Order?" confirmed-click="vm.cancelDeliveryOrder()" rms-check-access="consodeliveryorders" rms-check-access-perm-type="APPROVE"><i class="fa fa-trash"></i> <span translate="CANCEL_D.O."></span></a> <a href="" class="btn btn-success btn-with-icon" style="margin-right:30px" ng-if="(vm.isRmsLite && vm.originalStatus==\'APPROVED\') || (!vm.isRmsLite && !vm.isAdvancedMode && vm.originalStatus==\'SHIPPED\')" ng-disabled="vm.lockButtons" ng-confirm-click="Are you sure to complete this Delivery Order?" confirmed-click="vm.completeDeliveryOrder()" rms-check-access="consodeliveryorders" rms-check-access-perm-type="APPROVE"><i class="ion ion-checkmark"></i> <span translate="COMPLETE_D.O."></span></a> <span class="btn btn-with-icon" style="margin-right:30px;color:#fff" ng-if="vm.originalStatus==\'APPROVED\' && vm.isAdvancedMode"><i class="fa fa-info-circle"></i> <span translate="PROCEED_TO_NEXT_STEP_IN_MOBILE_APP"></span></span> <a href="" class="btn btn-primary btn-with-icon" ng-if="vm.originalStatus!=\'CANCELLED\' && vm.originalStatus!=\'CONFIRMED\' && vm.originalStatus!=\'NEW\'" ng-disabled="vm.lockButtons" ng-click="vm.printDeliveryOrder(vm.do.id, vm.do.deliveryOrderNo)" rms-check-access="consodeliveryorders" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT_D.O."></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-if="vm.originalStatus!=\'CANCELLED\' && vm.originalStatus!=\'CONFIRMED\' && vm.originalStatus!=\'NEW\'" ng-disabled="vm.lockButtons" ng-click="vm.printInvoice(vm.do.id, vm.do.invoiceNo)" rms-check-access="consodeliveryorders" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT_INVOICE"></span></a></div></form>');
$templateCache.put('app/pages/deliveryorders/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-show="vm.originalStatus==\'NEW\'"><small><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_DELIVERY_ORDER_DETAILS"></span>.</small><br><br></p><p ng-show="vm.originalStatus!=\'NEW\'"><small><i class="fa fa-warning"></i> <span translate="ALL_THE_FIELDS_WILL_BE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="NEW"></b>.</small><br><br></p><div class="row"><div class="col-md-6 col-lg-6"><legend style="height:32.4px;line-height:32.4px"><span translate="DELIVERY_ORDER_INFO"></span></legend></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b><span translate="DELIVERY_ORDER_NO"></span>.</b></label> <span class="form-control" ng-disabled="true" style="color:#00f">{{vm.do.deliveryOrderNo || \'*** AUTONUMBER ***\'}}</span><div ng-if="vm.do.originalDocNo!=null && vm.do.originalDocNo!=\'\'" style="margin-left:5px;color:#00f"><small>(Original Ref: <b>{{vm.do.originalDocNo}}</b>)</small></div></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeliveryDate.$invalid && (vm.dataForm.DeliveryDate.$dirty || vm.dataForm.$submitted)}"><label><b translate="DELIVERY_DATE"></b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.do.deliveryOrderDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" name="DeliveryDate" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.deliveryOrderDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeliveryDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Status.$invalid && (vm.dataForm.Status.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="DELIVERY_ORDER_STATUS"></b> <i class="fa fa-asterisk req"></i></label><select name="Status" class="form-control" ng-change="changed()" ng-model="vm.do.status" ng-options="i as (i | translate) for i in vm.doStatuses" ng-show="vm.originalStatus==\'NEW\'" required=""></select><span class="form-control" ng-show="vm.originalStatus!=\'NEW\'" ng-disabled="vm.originalStatus!=\'NEW\'">{{vm.do.status}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Status.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'SHIPPING_METHOD\' | translate }}</b></label><select name="ShippingMethod" class="form-control" ng-change="vm.selectedShippingMethodChanged()" ng-model="vm.selectedShippingMethod" ng-options="i as (\'[\' + i.shippingOption + \'] - \' + i.name) for i in vm.shippingMethods | orderBy:[\'shippingOption\',\'name\']" ng-disabled="vm.originalStatus!=\'NEW\'"></select></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.remarks">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-3 col-lg-2" ng-if="vm.do.createdBy"><div class="form-group"><label><b translate="CREATED_BY">:</b></label><br><span>{{vm.do.createdBy | uppercase}}<br><span translate="DATE"></span>: {{ vm.do.createdDate | date:\'dd/MM/yyyy\' }}</span></div></div><div class="col-md-3 col-lg-2" style="padding-left:5rem;" ng-if="vm.do.branchName"><div class="form-group"><label><b translate="CREATED_BRANCH">:</b></label><br><span>{{vm.do.branchName | uppercase}}<br></span></div></div><div class="col-md-3 col-lg-2" ng-if="vm.do.modifiedBy"><div class="form-group"><label><b translate="MODIFIED_BY">:</b></label><br><span>{{vm.do.modifiedBy | uppercase}}<br><span translate="DATE"></span>: {{ vm.do.modifiedDate | date:\'dd/MM/yyyy\' }}</span></div></div></div><br><br><div class="row"><div class="col-md-6 col-lg-6"><legend style="height:32.4px;line-height:32.4px"><span translate="TRANSFER_FROM_OTHER_DOCUMENT"></span></legend></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b><span translate="SALES_ORDER_NO"></span>.</b></label><div class="input-group"><span class="form-control" ng-disabled="true" style="color:#00f">{{vm.do.salesOrderNo || \'-\'}}</span> <a href="" class="btn btn-primary btn-with-icon input-group-addon" style="padding:3px 10px;font-size:9pt" ng-click="vm.showSelectSalesOrderModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && !vm.showSelectDebtor && vm.do.salesOrderId==null && vm.do.transferId==null"><i class="ion ion-android-checkmark-circle"></i> <span translate="SELECT"></span></a> <a href="" class="btn btn-default btn-with-icon input-group-addon" style="padding:3px 10px;font-size:9pt;color:#f00" ng-click="vm.clearSelectSalesOrder()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && !vm.showSelectDebtor && vm.do.salesOrderId!=null"><i class="ion ion-close"></i> <span translate="CLEAR"></span></a></div></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b><span translate="STOCK_TRANSFER_NO"></span>.</b></label><div class="input-group"><span class="form-control" ng-disabled="true" style="color:#00f">{{vm.do.stockTransferNo || \'-\'}}</span> <a href="" class="btn btn-primary btn-with-icon input-group-addon" style="padding:3px 10px;font-size:9pt" ng-click="vm.showSelectStockTransferModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && !vm.showSelectDebtor && vm.do.salesOrderId==null && vm.do.transferId==null"><i class="ion ion-android-checkmark-circle"></i> <span translate="SELECT"></span></a> <a href="" class="btn btn-default btn-with-icon input-group-addon" style="padding:3px 10px;font-size:9pt;color:#f00" ng-click="vm.clearSelectStockTransfer()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && !vm.showSelectDebtor && vm.do.transferId!=null"><i class="ion ion-close"></i> <span translate="CLEAR"></span></a></div></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>Customer P.O. No.</b> (<span translate="OPTIONAL"></span>)</label> <input type="text" class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.customerPoNo"></div></div></div><br><br><div class="row"><div class="col-md-6 col-lg-6"><legend style="height:32.4px;line-height:32.4px"><span translate="CUSTOMER_INFO"></span></legend></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'SELECT_A_CUSTOMER\'| translate }}</b> (<span translate="OPTIONAL"></span>)</label> <a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" style="margin-bottom:5px" ng-click="vm.selectedDebtor=null" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && vm.selectedDebtor!=null && vm.do.salesOrderId==null && vm.do.transferId==null"><i class="ion ion-android-checkmark-circle"></i> {{ \'CLEAR_SELECTION\' | translate }}</a><select name="Customer" class="form-control" ng-change="vm.selectedDebtorChanged()" ng-model="vm.selectedDebtor" ng-options="i as i.name for i in vm.debtorList" ng-disabled="vm.originalStatus!=\'NEW\' || vm.do.salesOrderId!=null || vm.do.transferId!=null"></select></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'SELECT_A_CUSTOMER_BRANCH\'| translate }}</b> (<span translate="OPTIONAL"></span>)</label> <a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" style="margin-bottom:5px" ng-click="vm.selectedDebtorBranch=null" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && vm.selectedDebtorBranch!=null && vm.do.salesOrderId==null && vm.do.transferId==null"><i class="ion ion-android-checkmark-circle"></i> {{ \'CLEAR_SELECTION\' | translate }}</a><select name="CustomerBranch" class="form-control" ng-change="vm.selectedDebtorBranchChanged()" ng-model="vm.selectedDebtorBranch" ng-options="i as i.name for i in vm.debtorBranchList" ng-disabled="vm.originalStatus!=\'NEW\' || vm.do.salesOrderId!=null || vm.do.transferId!=null"></select></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DebtorName.$invalid && (vm.dataForm.DebtorName.$dirty || vm.dataForm.$submitted)}"><label><b translate="COMPANY_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DebtorName" ng-model="vm.do.debtorName" ng-disabled="vm.originalStatus!=\'NEW\'" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DebtorName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="CONTACT_PERSON"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorContactPerson" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Address1.$invalid && (vm.dataForm.Address1.$dirty || vm.dataForm.$submitted)}"><label><b translate="ADDRESS_1"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Address1" ng-model="vm.do.debtorAddress1" ng-disabled="vm.originalStatus!=\'NEW\'" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Address1.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="ADDRESS_2"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorAddress2" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="ADDRESS_3"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorAddress3" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="STATE"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorState" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="POSTAL_CODE"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorPostCode" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="COUNTRY"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorCountry" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="TELEPHONE"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorTel" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="FAX"></b></label> <input type="text" class="form-control" ng-model="vm.do.debtorFax" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'PRODUCTS\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="ADD_ITEMS_INTO_THIS_DELIVERY_ORDER"></span>. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddProductModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="ion-plus-round"></i>{{ \'ADD_ITEM\' | translate }}</a> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddProductModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'SHIPPED\' && vm.originalStatus!=\'W.I.P\' && vm.originalStatus!=\'COMPLETED\' && vm.originalStatus!=\'CANCELLED\'" rms-check-access="deliveryorders" rms-check-access-perm-type="APPROVE"><i class="ion-plus-round"></i>{{ \'ADD_ITEM\' | translate }}</a><br><br></p><div><toggle ng-model="vm.showDetailedInvView" ng-change="changed()" on="{{ \'DETAILED\' | translate }}" off="{{ \'SUMMARY\' | translate }}" onstyle="btn-success btn-xs" offstyle="btn-default btn-xs"></toggle>&nbsp;&nbsp; <small>{{ \'ITEM_INVENTORY_BAL_VIEW_MODE\' | translate }}</small> &nbsp;&nbsp; <a href="" class="btn btn-xs btn-info btn-with-icon" ng-if="vm.mode==2" ng-click="vm.getAllInventoryStats()"><i class="fa fa-search"></i> Show All Inventory Stats</a></div><br><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:2px solid #ccc" st-pipe="vm.refreshBookingProducts" st-table="vm.do.deliveryOrderProducts" refresh-table=""><thead style="border-bottom:3px solid #ccc"><tr class="sortable"><th style="width:60px">#</th><th>{{ \'PRODUCT_NAME\' | translate }}</th><th style="width:100px;text-align:right" class="hide-after">{{ \'QUANTITY\' | translate }}</th><th style="text-align:right;width:120px;line-height:110%" class="hide-after" ng-if="vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\'"><b>{{ \'QUANTITY\' | translate }}<br>{{ \'STOCK_OUT\' | translate }}</b></th><th style="text-align:right;width:120px;line-height:110%" class="hide-after" ng-if="vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\'"><b>{{ \'QUANTITY\' | translate }}<br>{{ \'SHIPPED\' | translate }}</b></th><th style="width:100px"><b>{{ \'U.O.M.\' | translate }}</b></th><th style="width:150px;text-align:right" class="hide-after">{{ \'UNIT_PRICE\' | translate }}<br>({{vm.currency}})</th><th style="width:150px;text-align:right" class="hide-after">{{ \'DISCOUNT\' | translate }}<br>({{vm.currency}})</th><th style="text-align:right;width:150px" class="hide-after"><span ng-if="vm.isShippingFeesEnabled">{{ \'SUBTOTAL\' | translate }} ({{vm.currency}})<br><small>(<span translate="EXCLUDE_TAX"></span>)</small></span> <span ng-if="!vm.isShippingFeesEnabled"></span></th><th style="width:100px;text-align:right" class="hide-after">{{ \'TOTAL_TAX\' | translate }}<br>({{vm.currency}})</th><th style="text-align:right;width:150px" class="hide-after">{{ \'SUBTOTAL\' | translate }} ({{vm.currency}})<br><small>(<span translate="INCLUDE_TAX"></span>)</small></th><th style="width:20px"></th><th>{{ \'REMARKS\' | translate }}</th><th style="width:90px"></th><th style="width:90px" ng-if="vm.originalStatus==\'NEW\'"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.do.deliveryOrderProducts"><td>{{$index+1}})</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%"><b>{{ ntn.productName || \'\' }}</b><br><small style="color:#888"><b>{{ ntn.productCode }}</b>&nbsp;&nbsp;({{ ntn.itemType }})</small><div ng-if="!ntn.hasBalanceDetails"><a href="" class="btn btn-xs btn-info btn-with-icon" ng-if="vm.mode==2" ng-click="vm.getInventoryStats(ntn)"><i class="fa fa-search"></i> Show Inventory Stats</a></div><div style="margin-top:5px;margin-bottom:10px" ng-if="ntn.hasBalanceDetails"><table cellpadding="1" border="1" style="width:500px;font-size:9pt" ng-if="!vm.showDetailedInvView"><tr><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'AVAILABLE\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'RESERVED\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'BALANCE\' | translate }}</td><td style="width: 50px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'U.O.M.\' | translate }}</td></tr><tr><td style="padding: 2px auto;text-align:center"><span ng-class="{\'text-danger\': (vm.getAvailableQty(ntn) < 0), \'text-success\': (vm.getAvailableQty(ntn) > 0)}"><b>{{vm.getAvailableQty(ntn) | number}}</b></span></td><td style="padding: 2px auto;text-align:center">{{vm.getReservedQty(ntn) | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.invBalance | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.invUomName}}</td></tr></table><table cellpadding="1" border="1" style="width:500px;font-size:9pt" ng-if="vm.showDetailedInvView"><tr><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'AVAILABLE\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'SO_NEW\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'SO_CFM\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'DO_PND\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'BALANCE\' | translate }}</td><td style="width: 50px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'U.O.M.\' | translate }}</td></tr><tr><td style="padding: 2px auto;text-align:center"><span ng-class="{\'text-danger\': (vm.getAvailableQty(ntn) < 0), \'text-success\': (vm.getAvailableQty(ntn) > 0)}"><b>{{vm.getAvailableQty(ntn) | number}}</b></span></td><td style="padding: 2px auto;text-align:center">{{ntn.totalNewSalesOrderQuantity | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.totalConfirmedSalesOrderQuantity | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.totalDOPendingQuantity | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.invBalance | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.invUomName}}</td></tr></table></div></td><td style="text-align:right">{{ ntn.quantity }}</td><td style="text-align:right" ng-if="vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\'"><span style="color:#0000ff">{{ ntn.quantityStockedOut }}</span></td><td style="text-align:right" ng-if="vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\'"><span style="color:#009600">{{ ntn.quantityTransported }}</span></td><td>{{ ntn.uomName }}</td><td style="text-align:right">{{ ntn.unitPrice | currency:\'\' }}</td><td style="text-align:right"><span class="text-danger">({{ ntn.discountAmount || 0.00 | currency:\'\' }}) <span></span></span></td><td style="text-align:right"><span ng-if="vm.isShippingFeesEnabled">{{ ( ( ntn.unitPrice * ntn.quantity ) - ntn.discountAmount ) | currency:\'\' }}</span> <span ng-if="!vm.isShippingFeesEnabled"></span></td><td style="text-align:right">{{ ntn.tax | currency:\'\' }}</td><td style="text-align:right">{{ ntn.subtotal | currency:\'\' }}</td><td style="width:20px"></td><td style="padding-top:8px;padding-bottom:8px;line-height:150%">{{ ntn.remarks }}</td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditProductModal($index)" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditProductModal($index)" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'CANCELLED\' && ntn.quantityStockedOut!=ntn.quantity" rms-check-access="deliveryorders" rms-check-access-perm-type="APPROVE"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeProduct($index)" ng-confirm-click="Confirm remove this Product?" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a> <a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeProduct($index)" ng-confirm-click="Confirm remove this Product?" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'W.I.P\' && vm.originalStatus!=\'CANCELLED\' && ntn.quantityStockedOut==0 && ntn.quantityTransported==0" rms-check-access="deliveryorders" rms-check-access-perm-type="APPROVE"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="13" align="center" ng-show="vm.do.deliveryOrderProducts.length==0"><br><span translate="PRODUCT_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot style="border-top:3px solid #ccc"><tr><td colspan="{{ vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\' ? (vm.isShippingFeesEnabled ? 8 : 10) : (vm.isShippingFeesEnabled ? 6 : 8) }}" style="text-align:right"><b>{{ \'SUBTOTAL\' | translate }} ({{vm.currency}}) :</b></td><td style="text-align:right" ng-if="vm.isShippingFeesEnabled"><b>{{ vm.subtotalExcludeTax | currency:\'\'}}</b></td><td ng-if="vm.isShippingFeesEnabled"></td><td style="text-align:right"><b>{{ vm.subtotal | currency:\'\'}}</b></td></tr><tr><td colspan="{{ (vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\' ? 10 : 8) }}" rowspan="2" style="text-align:right"><div style="display:inline-block;margin-top:30px;line-height:110%"><b>( <span class="text-danger">&#8722;</span> )&nbsp; {{ \'ADDITIONAL_DISCOUNT\' | translate }} :</b><br><small>({{ \'FILL_IN_EITHER_ONE\' | translate }})<small>&nbsp;</small></small></div></td><td style="text-align:right"><div class="form-group" style="margin-bottom:0px" ng-class="{\'has-error\': vm.dataForm.DiscountPercentage.$invalid && (vm.dataForm.DiscountPercentage.$dirty || vm.dataForm.$submitted)}"><input type="number" name="DiscountPercentage" class="form-control" min="0" style="text-align:right;width:150px;background:#fffced;-webkit-appearance:none;-moz-appearance:textfield" ng-change="vm.calculateDiscountAmount1(true)" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.discountPercentage"> <span class="help-block" style="margin-top:0px;margin-bottom:0px" ng-show="vm.dataForm.$submitted && vm.dataForm.DiscountPercentage.$error.number"><small>* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</small></span></div></td><td>%</td></tr><tr><td style="text-align:right"><div class="form-group" style="margin-bottom:0px" ng-class="{\'has-error\': vm.dataForm.DiscountAmount.$invalid && (vm.dataForm.DiscountAmount.$dirty || vm.dataForm.$submitted)}"><input type="number" name="DiscountAmount" class="form-control" min="0" style="text-align:right;width:150px;background:#fffced;-webkit-appearance:none;-moz-appearance:textfield" ng-change="vm.calculateDiscountAmount2(true)" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.discountAmount"> <span class="help-block" style="margin-top:0px;margin-bottom:0px" ng-show="vm.dataForm.$submitted && vm.dataForm.DiscountAmount.$error.number"><small>* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</small></span></div></td><td>({{vm.currency}})</td></tr><tr><td colspan="{{ (vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\' ? 6 : 4) }}" style="text-align:right;font-size:10pt;line-height:110%"><b>( <span class="text-success" style="font-size:12pt !important">+</span> )&nbsp; {{ \'ADDITIONAL_CHARGES\' | translate }} :</b><br><small>({{ \'FURTHER_DESCRIPTION\' | translate}})</small>&nbsp;</td><td colspan="4" style="text-align:right"><input type="text" class="form-control input-sm" style="background:#FFFCED" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.additionalChargesDesc"></td><td style="text-align:right"><div class="form-group" style="margin-bottom:0px" ng-class="{\'has-error\': vm.dataForm.AdditionalCharges.$invalid && (vm.dataForm.AdditionalCharges.$dirty || vm.dataForm.$submitted)}"><input type="number" name="AdditionalCharges" class="form-control" min="0" style="text-align:right;width:150px;background:#fffced;-webkit-appearance:none;-moz-appearance:textfield" ng-change="vm.recalculateGrandTotal()" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.do.additionalCharges"> <span class="help-block" style="margin-top:0px;margin-bottom:0px" ng-show="vm.dataForm.$submitted && vm.dataForm.AdditionalCharges.$error.number"><small>* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</small></span></div></td></tr><tr ng-if="vm.isShippingFeesEnabled"><td colspan="{{ (vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\' ? 6 : 4) }}" style="text-align:right;font-size:10pt;line-height:110%"><b>( <span class="text-success">+</span> )&nbsp; {{ \'SHIPPING_FEES\' | translate }} :</b><br><small>({{ \'FURTHER_DESCRIPTION\' | translate}})</small>&nbsp;</td><td colspan="4" style="text-align:right"><input type="text" class="form-control input-sm" style="background:#FFFCED" ng-disabled="true" ng-model="vm.do.shippingFeeDesc"></td><td style="text-align:right"><div class="form-group" style="margin-bottom:0px" ng-class="{\'has-error\': vm.dataForm.ShippingFees.$invalid && (vm.dataForm.ShippingFees.$dirty || vm.dataForm.$submitted)}"><input type="number" name="ShippingFees" class="form-control" min="0" style="text-align:right;width:150px;background:#fffced;-webkit-appearance:none;-moz-appearance:textfield" ng-change="vm.recalculateGrandTotal()" ng-disabled="true" ng-model="vm.do.shippingFeeCharges"> <span class="help-block" style="margin-top:0px;margin-bottom:0px" ng-show="vm.dataForm.$submitted && vm.dataForm.ShippingFees.$error.number"><small>* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</small></span></div></td></tr><tr><td colspan="{{ (vm.do.status && vm.do.status!=\'NEW\' && vm.do.status!=\'CONFIRMED\' && vm.do.status!=\'CANCELLED\' ? 10 : 8) }}" style="text-align:right"><h3 style="margin-top:8px;margin-bottom:0px;font-weight:bold">{{ \'GRAND_TOTAL\' | translate }} ({{vm.currency}}) :</h3></td><td style="text-align:right;padding:0px"><div style="margin:8px;padding:8px;border:3px solid #000;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;"><h3 style="margin-bottom:0px"><b>{{vm.do.grandTotal || vm.grandTotal | currency:\'\'}}</b></h3></div></td></tr></tfoot></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.do.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_DELIVERY_ORDER"></span>.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br><span translate="THERE_IS_NO_CHANGES_YET"></span>.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="productModal.html"><form name="$mdl.productForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="ITEM"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" style="margin-bottom:5px" ng-if="$mdl.selectedItem!=null" ng-click="$mdl.selectedItem=null"> <i class="fa fa-times"></i> <span style="color:#fff" translate="CLEAR_SELECTION"></span> </button> <label> <b>{{ \'RAW_MATERIAL\' | translate }}</b> / <b>{{ \'SEMI_FINISHED_GOODS\' | translate }}</b> / <b>{{ \'FINISHED_GOODS\' | translate }}</b> </label> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.itemSearch" style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model-options=\'{ debounce: 1500 }\' ng-change="$mdl.searchItem($mdl.itemSearch)" /> </div> </div> <div class="col-lg-9"> <select class="form-control" style="background:#FFFCED" name="ItemName" ng-disabled="$mdl.lockButtons" ng-change="$mdl.selectedItemChanged()" ng-options="u as (\'[\' + u.itemType + \'] \' + u.productName | uppercase) for u in $mdl.itemList" ng-model="$mdl.selectedItem" required> <option value="">{{($mdl.lockButtons ? (\'LOADING...\' | translate) : ($mdl.itemList.length==0 ? ("&lt;&lt; " + (\'ENTER_A_KEYWORD_TO_SEARCH\' | translate)) : ("-- " + (\'SELECT_AN_ITEM\' | translate) + " --")))}}</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted"> * {{"REQUIRED" | translate}} </p> </div> </div> </div> </div> <br /> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.Quantity.$invalid && $mdl.productForm.$submitted}"> <div class="row"> <div class="col-lg-3" ng-if="$mdl.mode!=1"> <label><b>{{ \'QUANTITY\' | translate }} {{ \'STOCK_OUT\' | translate }}</b> </label> <span class="form-control" min=0.001 ng-disabled="true"> {{ $mdl.item.quantityStockedOut }} </span> </div> <div class="col-lg-3"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" name="Quantity" class="form-control" min=0.001 style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.quantity" ng-change="$mdl.quantityChanged()" required /> </div> <div class="col-lg-3"> <label><b translate="U.O.M"></b> <!-- &nbsp;<small>(<span translations="CONFIGURE_AT"></span> <b><em translations= "MAINTENANCE_>_PRODUCTS" ></em></b>)</small> --> </label> <span class="form-control" disabled="disabled"> <b ng-hide="$mdl.item.unitOfMeasurementId==null">{{ $mdl.item.uomName || \'\' }}</b> <span style="color:#f00" ng-if="$mdl.item.unitOfMeasurementId==null"> <small translate="SALES_U.O.M_NOT_AVAILABLE"></small> </span> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> </span> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.required && $mdl.productForm.$submitted">* {{ "REQUIRED" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.number && $mdl.productForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.min && $mdl.productForm.$submitted">* {{ "MINIMUM_VALUE_IS_0.001" | translate }}</p> <p class="help-block" style="color:#f00" ng-if="$mdl.item.quantity < $mdl.item.quantityStockedOut">* {{ "QTY_CANT_BE_LOWER_THAN_QTY_STOCKED_OUT" | translate }} ({{$mdl.item.quantityStockedOut}})</p> </div> <div class="row"> <div class="col-lg-3"> <div class="form-group"> <label><b>{{ \'UNIT_PRICE\' | translate }}</b> ({{ $mdl.currencyCode }})</label> <span class="form-control" disabled="disabled"> {{ $mdl.item.unitPrice | currency:\'\' }} </span> </div> </div> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.DiscountPercentage.$invalid && $mdl.productForm.$submitted}"> <label> <b>{{ \'DISCOUNT\' | translate }} %</b></label> <input type="number" name="DiscountPercentage" class="form-control" min=0 style="background:#fffced;color:#000" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.discountPercentage" ng-change="$mdl.calculateDiscountAmount1()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.DiscountPercentage.$error.number && $mdl.productForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.DiscountPercentage.$error.min && $mdl.productForm.$submitted">* {{ "MINIMUM_VALUE_IS_0" | translate }}</p> </div> </div> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.DiscountAmount.$invalid && $mdl.productForm.$submitted}"> <label> <b>{{ \'DISCOUNT\' | translate }}</b> ({{ $mdl.currencyCode }})</label> <input type="number" name="DiscountAmount" class="form-control" min=0 style="background:#fffced;color:#000" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.discountAmount" ng-change="$mdl.calculateDiscountAmount2()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.DiscountAmount.$error.number && $mdl.productForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.DiscountAmount.$error.min && $mdl.productForm.$submitted">* {{ "MINIMUM_VALUE_IS_0" | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-3"> <div class="form-group"> <label> <b>{{ \'TAX_CODE\' | translate }}</b></label> <span class="form-control" disabled="disabled"> {{ $mdl.item.taxCode }} </span> </div> </div> <div class="col-lg-3"> <div class="form-group"> <label> <b>{{ \'TAX_PERCENT\' | translate }}</b> (%)</label> <span class="form-control" disabled="disabled"> {{ $mdl.item.taxPercent }} </span> </div> </div> <div class="col-lg-3"> <div class="form-group"> <label> <b>{{ \'TAX_AMOUNT\' | translate }}</b> ({{ $mdl.currencyCode }})</label> <span class="form-control" disabled="disabled"> {{ $mdl.item.tax }} </span> </div> </div> <div class="col-lg-3"> <div class="form-group"> <label style="color:#00f"><b>{{ \'SUBTOTAL\' | translate }}</b> ({{ $mdl.currencyCode }})</label> <span class="form-control" style="border:2px solid #000;color:#000"> <b>{{ $mdl.item.subtotal }}</b> </span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <label><b>Remarks</b></label> <input type="text" class="form-control" style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.remarks" /> </div> </div> </div> <hr /> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="salesOrderListModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="SELECT_A_SALES_ORDER"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:9pt" st-pipe="$mdl.retrieveData" st-table="$mdl.data" refresh-table> <thead> <tr> <th colspan="3" style="padding-left:0px"> <select st-search="isOpenDoc" class="form-control" style="background:#fffeed;font-weight:bold"> <option value="">{{ \'SHOW_CONFIRMED_DOCUMENTS\' | translate }}</option> <option value="1">{{ \'SHOW_INPROCESS_DOCUMENTS\' | translate }}</option> </select> </th> <th colspan="4" style="text-align:center"> <span style="color:#00f" ng-if="$mdl.isLoading"> <big><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></big> </span> </th> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th style="width:60px">#</th> <th st-sort="salesOrderNo">{{ \'SO_NO\' | translate }}</th> <th st-sort="createdDate"style="width:100px;padding-top:11px;padding-bottom:11px;line-height:110%"> {{\'ORDER_DATE\' | translate}}<br /><small>(DD/MM/YYYY)</small> </th> <th st-sort="deliveryDate"style="width:100px;padding-top:11px;padding-bottom:11px;line-height:110%"> {{\'DELIVERY_DATE\' | translate}}<br /><small>(DD/MM/YYYY)</small> </th> <th st-sort="branchName">{{ \'BRANCH\' | translate }}</th> <th st-sort="debtorName">{{ \'CUSTOMER\' | translate }}</th> <!-- <th>{{ \'CUSTOMER_PO_NUMBER\' | translate }}</th> --> <th>{{ \'ORDER_TITLE\' | translate }}<br /><small>{{ \'DESCRIPTION\' | translate }}</small></th> <th st-sort="status">{{ \'STATUS\' | translate }}</th> <th st-sort="createdBy">{{ \'ORDERED_BY\' | translate }}</th> <th style="width:40px"></th> </tr> <tr class="sortable "> <th class="form-inline" style="padding-left:0px;padding-right:0px"> <a href class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search> {{ \'RESET\' | translate }} </a> </th> <th class="form-inline"> <input st-search="salesOrderNo" class="form-control input input-sm" style="width:100px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="createdDate" class="form-control input input-sm" style="width:80px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="deliveryDate" class="form-control input input-sm" style="width:80px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="branchName" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="debtorName" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <!-- <th class="form-inline"> <input st-search="customerPoNo" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> --> <th class="form-inline"> <input st-search="orderTitle" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th></th> <th class="form-inline"> <input st-search="createdBy" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th></th> </tr> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.soData.length==0"> <td colspan="11" style="height:100px;line-height:100px;text-align:center"> {{ \'NO_SALES_ORDER_AVAILABLE\' | translate }} </td> </tr> <tr ng-repeat="item in $mdl.data"> <td>{{vm.startIndex+1+$index}})</td> <td nowrap="nowrap" style="padding-top:10px;padding-bottom:10px;line-height:130%"> {{item.salesOrderNo}} <div ng-if="item.stockRequestNo!=null && item.stockRequestNo!=\'\'"> <small>(S/R No: <b>{{item.stockRequestNo}}</b>)</small> </div> <div ng-if="item.originalDocNo!=null && item.originalDocNo!=\'\'"> <small>(Ori Ref: <b>{{item.originalDocNo}}</b>)</small> </div> </td> <td>{{item.createdDate | date: "dd/MM/yyyy"}}</td> <td style="padding-top:10px;padding-bottom:10px;line-height:130%"> {{item.deliveryDate | date: "dd/MM/yyyy" }} {{ ((item.deliveryDate | date: "hh:mma")=="12:00AM" ? \'\' : \'&nbsp;\' + (item.deliveryDate | date: "hh:mma")) }} </td> <td style="padding-top:10px;padding-bottom:10px;line-height:110%"> {{item.branchName | uppercase}} </td> <td style="padding-top:10px;padding-bottom:10px;line-height:130%"> {{item.debtorName || \'-\'}} <div ng-if="item.debtorBranchName!=null"> <small>{{ item.debtorBranchName }}</small> </div> </td> <!-- <td>{{item.customerPoNo || \'-\'}}</td> --> <td style="padding-top:10px;padding-bottom:10px;line-height:130%"> {{item.name | uppercase}} <br /> <small>{{item.description || \'\' | uppercase}}</small> </td> <td nowrap="nowrap"> <b> <span ng-if="item.status==\'CONFIRMED\'" style="color:#00f">{{item.status}}</span> <span ng-if="item.status==\'IN PROCESS\'" style="color:#31b046">{{item.status}}</span> </b> </td> <td> {{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \'...\' : \'\') }} </td> <td style="text-align:center"> <a href title="Select" class="btn btn-primary btn-xs btn-with-icon" ng-click="$mdl.selectSalesOrder(item.id)"> <big><i class="fa fa-check"></i> {{ "SELECT" | translate }}</big> </a> </td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <div style="float:left"> Total Records: <b>{{$mdl.numOfRecord}}</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="stockTransferListModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="SELECT_A_STOCK_TRANSFER_DOCUMENT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:9pt" st-pipe="$mdl.retrieveData" st-table="$mdl.data" refresh-table> <thead> <tr> <th colspan="3" style="padding-left:0px"> <select st-search="isOpenDoc" class="form-control" style="background:#fffeed;font-weight:bold"> <option value="">{{ \'SHOW_CONFIRMED_DOCUMENTS\' | translate }}</option> <option value="1">{{ \'SHOW_INPROCESS_DOCUMENTS\' | translate }}</option> </select> </th> <th colspan="3" style="text-align:center"> <span style="color:#00f" ng-if="$mdl.isLoading"> <big><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></big> </span> </th> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th style="width:60px">#</th> <th st-sort="docNo" st-sort-default="reverse">{{ \'DOCUMENT_NO\' | translate }}</th> <th st-sort="createdDate"style="padding-top:11px;padding-bottom:11px;line-height:110%"> {{ \'DOCUMENT_DATE\' | translate }}<br /><small>(DD/MM/YYYY)</small> </th> <th st-sort="createdDate"style="padding-top:11px;padding-bottom:11px;line-height:110%"> {{ \'DELIVERY_DATE\' | translate }}<br /><small>(DD/MM/YYYY)</small> </th> <th>{{ \'SOURCE\' | translate }}</th> <th>{{ \'DESTINATION\' | translate }}</th> <!-- <th style="padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'REMARKS\' | translate }}</th> --> <th st-sort="status">{{ \'STATUS\' | translate }}</th> <th st-sort="createdBy">{{ \'ORDERED_BY\' | translate }}</th> <th style="width:40px"></th> </tr> <tr> <th class="form-inline" style="padding-left:0px;padding-right:0px"> <a href class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search> {{ \'RESET\' | translate }} </a> </th> <th class="form-inline"> <input st-search="docNo" class="form-control input input-sm" style="width:100px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="createdDate" class="form-control input input-sm" style="width:80px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="deliveryDate" class="form-control input input-sm" style="width:80px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="sourceBranchName" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="destBranchName" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th></th> <!-- <th></th> --> <th class="form-inline"> <input st-search="createdBy" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th></th> </tr> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.data.length==0"> <td colspan="10" style="height:100px;line-height:100px;text-align:center"> <b>{{ \'NO_STOCK_TRANSFER_DOCUMENT_AVAILABLE\' | translate }}</b> </td> </tr> <tr ng-repeat="item in $mdl.data"> <td>{{vm.startIndex+1+$index}})</td> <td nowrap="nowrap" style="padding-top:8px;padding-bottom:8px;line-height:110%"> {{item.docNo}} <div ng-if="item.stockRequestNo!=null && item.stockRequestNo!=\'\'"> <small>(S/R No: <b>{{item.stockRequestNo}}</b>)</small> </div> </td> <td>{{item.createdDate | date: "dd/MM/yyyy"}}</td> <td>{{item.deliveryDate | date: "dd/MM/yyyy"}}</td> <td>{{item.sourceBranchName | uppercase}}</td> <td>{{item.destBranchName | uppercase}}</td> <!-- <td>{{item.remarks}}</td> --> <td nowrap="nowrap"> <b> <span ng-if="item.status==\'CONFIRMED\'" style="color:#00f">{{item.status}}</span> <span ng-if="item.status==\'IN PROCESS\'" style="color:#31b046">{{item.status}}</span> </b> </td> <td> {{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \'...\' : \'\') }} </td> <td style="text-align:center"> <a href title="Select" class="btn btn-primary btn-xs btn-with-icon" ng-click="$mdl.selectDocument(item.id)"> <big><i class="fa fa-check"></i> {{ "SELECT" | translate }}</big> </a> </td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <div style="float:left"> Total Records: <b>{{$mdl.numOfRecord}}</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="creditApprovalModal.html"><form name="$mdl.approvalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-warning"> <h3 class="modal-title" id="modal-title" style="color:#000"> <i class="fa fa-exclamation-triangle"></i> Customer Credit Limit Exceeded </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <h3 style="color:#f00;line-height:150%;text-align:justify"> System detects that the selected Customer has exceeded the <b><u>Credit Limit</u></b>. Do you want to proceed with the confirmation of this Delivery Order? </h3> <br /> <br /> <br /> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> APPROVE </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> DISAPPROVE </button> </div> </form></script><script type="text/ng-template" id="doRequestCreditApprovalModal.html"><form name="$mdl.approvalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-warning"> <h3 class="modal-title" id="modal-title" style="color:#000"> <i class="fa fa-exclamation-triangle"></i> Customer Credit Limit Exceeded </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <h3 style="color:#f00;line-height:150%;text-align:justify"> System detects that the selected Customer has exceeded the <b><u>Credit Limit</u></b></b>. Do you want to request for Manager Approval to confirm this Delivery Order? </h3> <br /> <br /> <br /> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" style="width:100px" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> YES </button> <button class="btn btn-danger btn-with-icon" type="button" style="width:80px" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> NO </button> </div> </form></script><script type="text/ng-template" id="printModal.html"><form name="$mdl.printForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="PRINT_DOCUMENT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <table class="table table-striped" style="border:1px solid #ccc"> <thead> <tr> <th style="width:60px">#</th> <th><b translate="DOCUMENT_DESCRIPTION"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="item in $mdl.documentList"> <td>{{ $index+1 }})</td> <td>{{ item.name }}</td> <td> <button class="btn btn-primary btn-with-icon btn-xs" style="width:90px" type="button" ng-click="$mdl.printDocument(item.id)" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-printer" ng-if="!$mdl.isLoading"></i> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> {{ \'PRINT\' | translate}} </button> </td> </tr> </tbody> </table> <div class="row"> <p>&nbsp;</p> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b> <span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/deliveryorders/deliveryorderCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/deliveryorders/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ui-sref="deliveryorders.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_DELIVERY_ORDER"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="deliveryorders.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/deliveryorders/deliveryorderList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="DeliveryOrderListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table="" style="font-size:90%"><thead><tr><th colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_ALL_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-5" style="height:30px;line-height:30px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="deliveryorders.create" rms-check-access="deliveryorders" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="NEW_DO"></span></a>&nbsp; <a href="" class="btn btn-success btn-with-icon" ng-click="vm.showDownloadExcelModal()" rms-check-access="deliveryorders" rms-check-access-perm-type="EXPORT"><i class="fa fa-download"></i> <span translate="DOWNLOAD_EXCEL"></span></a>&nbsp; <a href="" class="btn btn-warning btn-with-icon" ng-if="!vm.showPsPanel" ng-click="vm.showPSPanel()" rms-check-access="deliveryorders" rms-check-access-perm-type="CREATE"><i class="fa fa-file-text-o"></i> <span translate="GENERATE_PICKING_LIST"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-1" style="height:30px;line-height:30px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr ng-if="vm.showPsPanel"><th colspan="13" style="background:#fffc00;"><b>{{ \'SELECT_ONE_OR_MORE_DELIVERY_ORDERS_TO_GENERATE_A_PICKING_LIST\' | translate }} &nbsp;({{ vm.selectedDOs.length }} selected)&nbsp;&nbsp;&nbsp;</b> <button type="button" class="btn btn-primary btn-sm" ng-click="vm.createPS()">{{ \'CONFIRM\' | translate }}</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.closePSPanel()">{{ \'CANCEL\' | translate }}</button></th></tr><tr ng-if="vm.showCdoPanel"><th colspan="13" style="background:#fffc00;"><b>{{ \'SELECT_ONE_OR_MORE_DELIVERY_ORDERS_TO_GENERATE_THE_CONSOLIDATED_DELIVERY_ORDER\' | translate }} &nbsp;({{ vm.selectedDOs.length }} selected)&nbsp;&nbsp;&nbsp;</b> <button type="button" class="btn btn-primary btn-sm" ng-click="vm.createCDO()">{{ \'CONFIRM\' | translate }}</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.closeCDOPanel()">{{ \'CANCEL\' | translate }}</button></th></tr><tr class="sortable"><th style="width:60px">#</th><th ng-if="vm.showCdoPanel || vm.showPsPanel" class="hide-after"></th><th st-sort="delieryOrderNo">{{ \'D.O._NO.\' | translate }}</th><th st-sort="deliveryOrderDate" style="padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'DELIVERY_DATE\' | translate }}<br><small>(DD/MM/YYYY)</small></th><th st-sort="sourceDocNo">{{ \'SO_ST_DOC_NO\' | translate }}</th><th st-sort="debtorName">{{ \'CUSTOMER_NAME\' | translate }}</th><th>{{ \'REMARKS\' | translate }}</th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th>{{ \'CREATED_BY\' | translate }}</th><th style="width:30px"></th><th style="width:30px"></th><th style="width:30px"></th><th style="width:30px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th ng-if="vm.showCdoPanel || vm.showPsPanel" class="hide-after" style="text-align:center;width:50px;font-size:16pt"><a href="" ng-click="vm.selectAll()" title="Select ALL"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll()" title="De-select ALL" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th><th class="form-inline"><input st-search="deliveryOrderNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="deliveryOrderDate" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="sourceDocNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="debtorName" class="form-control input input-sm"></th><th></th><th class="form-inline"><input st-search="status" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="createdBy" class="form-control input input-sm" style="width:120px"></th><th colspan="4"><span ng-if="vm.isLoading" class="pull-right" style="color:#00f"><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</span></th></tr></thead><tbody><tr ng-if="vm.data.length==0 && !vm.isLoading"><td colspan="13" style="height:100px;line-height:100px"><center translate="NO_RECORD_FOUND">.</center></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td ng-if="vm.showPsPanel" style="background:#fffc00;width:50px;text-align:center"><div class="checkbox checkbox-primary checkbox-inline" style="margin-top:4px;margin-bottom:6px"><input type="checkbox" name="doNo" checklist-model="vm.selectedDOs" checklist-value="item.id" checklist-change="vm.dataForm.cate.$setValidity(\'required\', vm.selectedDOs.length > 0)" ng-required="!vm.selectedDOs.length"> <label>&nbsp;</label></div></td><td ng-if="vm.showCdoPanel" style="background:#fffc00;width:50px;text-align:center"><div class="checkbox checkbox-primary checkbox-inline" style="margin-top:4px;margin-bottom:6px" ng-if="(item.status==\'APPROVED\' || item.status==\'PROCESSING\') && item.consolidateDocNo==null"><input type="checkbox" name="doNo" checklist-model="vm.selectedDOs" checklist-value="item.id" checklist-change="vm.dataForm.cate.$setValidity(\'required\', vm.selectedDOs.length > 0)" ng-if="(item.status==\'APPROVED\' || item.status==\'PROCESSING\') && item.consolidateDocNo==null" ng-required="!vm.selectedDOs.length"> <label>&nbsp;</label></div></td><td nowrap="nowrap" style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.deliveryOrderNo}}<div ng-if="item.originalDocNo!=null && item.originalDocNo!=\'\'"><small>(Ori Ref: <b>{{item.originalDocNo}}</b>)</small></div><div ng-if="item.consolidateDocNo!=null && item.consolidateDocNo!=\'\'"><small>(C.DO. No: <b>{{item.consolidateDocNo}}</b>)</small></div></td><td>{{item.deliveryOrderDate | date: "dd/MM/yyyy" }} {{ ((item.deliveryOrderDate | date: "hh:mma")=="12:00AM" ? \'\' : \'&nbsp;\' + (item.deliveryOrderDate | date: "hh:mma")) }}</td><td>{{item.sourceDocNo || "-"}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.debtorName | uppercase}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.remarks || \'-\'}}</td><td><b><span ng-if="item.status==\'NEW\'">{{item.status}}</span> <span ng-if="item.status==\'CONFIRMED\'" class="text-primary">{{item.status}}</span> <span ng-if="item.status==\'APPROVED\'" class="text-warning">{{item.status}}</span> <span ng-if="item.status==\'W.I.P\'" class="text-warning">{{item.status}}</span> <span ng-if="item.status==\'PROCESSING\'" class="text-warning">{{item.status}}</span> <span ng-if="item.status==\'PROCESSED\'" class="text-warning">{{item.status}}</span> <span ng-if="item.status==\'SHIPPED\'" class="text-warning">{{item.status}}</span> <span ng-if="item.status.indexOf(\'COMPLETED\')!=-1" class="text-success">{{item.status}}</span> <span ng-if="item.status==\'CANCELLED\'" class="text-danger">{{item.status}}</span></b></td><td>{{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \' ...\' : \'\') }}</td><td align="center"><a href="" title="Serial Number" class="btn btn-default btn-xs" style="display:inline-block;font-size:11pt" ng-click="vm.showSerialNumber(item.id, item.deliveryOrderNo)" ng-if="item.status==\'SHIPPED\' || item.status==\'PROCESSING\' || item.status==\'COMPLETED\'"><i class="fa fa-file-text text-primary"></i></a></td><td align="center"><a href="" title="Print D.O." class="btn btn-default btn-with-icon btn-xs" style="display:inline-block;font-size:11pt" ng-click="vm.showPrintDialog(item.id, item.deliveryOrderNo)" ng-if="item.status!=\'CANCELLED\' && item.status!=\'CONFIRMED\' && item.status!=\'NEW\'" rms-check-access="deliveryorders" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <small>DO</small></a></td><td align="center"><a href="" title="Print Invoice" class="btn btn-default btn-with-icon btn-xs" style="display:inline-block;font-size:11pt" ng-click="vm.printInvoice(item.id, item.invoiceNo)" ng-if="item.status!=\'CANCELLED\' && item.status!=\'CONFIRMED\' && item.status!=\'NEW\' && !vm.isInvoiceEnabledForSO" rms-check-access="deliveryorders.invoice" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <small>INV</small></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="deliveryorders.update({id:item.id})" rms-check-access="deliveryorders" rms-check-access-perm-type="UPDATE"><i class="fa fa-eye" ng-if="item.status.indexOf(\'COMPLETED\')!=-1"></i> <i class="fa fa-pencil" ng-if="item.status.indexOf(\'COMPLETED\')==-1"></i></a></td></tr></tbody><tfoot><tr><td colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:30px;line-height:30px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="serialNumberModal.html"><form name="$mdl.stepForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:80%" st-pipe="$mdl.retrieveData" st-table="$mdl.serialNumberData" refresh-table> <thead> <tr> <th colspan="5" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{ "SERIAL_NUMBER" | translate}} </div> <span>&#40;{{ $mdl.item.docNo }}&#41;</span> </h3> </div> </th> </tr> <tr> <th colspan="1"> <center ng-if="$mdl.isLoading"> <b style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_LABEL\' | translate }} ... </b> </center> </th> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr> <th><b translate="CODE"></b></th> <th><b translate="DESCRIPTION"></b></th> <th><b translate="SERIAL_NUMBER_MAIN"></b></th> <th><b translate= "SERIAL_NUMBER_PARTIAL"></b></th> <th><b translate= "STORAGE_NAME"></b></th> </tr> <tr> <th class="form-inline"></th> <th class="form-inline"></th> <th class="form-inline"> <input st-search="mainLabelSerialNumber" class="form-control input input-sm" /> </th> <th class="form-inline"> <input st-search="partialLabelSerialNumber" class="form-control input input-sm" /> </th> <th class="form-inline"> </tr> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.serialNumberData.length==0"> <td colspan="5"><span translate="NO_SERIAL_NUMBER_AVAILABLE"></span>.</td> </tr> <tr ng-repeat="m in $mdl.serialNumberData"> <td>{{m.itemCode | uppercase}}</td> <td>{{m.itemDesc | uppercase}}</td> <td>{{m.mainLabelSerialNumber ? (m.mainLabelSerialNumber | uppercase) : "-"}}</td> <td>{{m.partialLabelSerialNumber ? (m.partialLabelSerialNumber | uppercase) : "-"}}</td> <td>{{m.mainLabelStorageName ? (m.mainLabelStorageName | uppercase) : "-"}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="printModal.html"><form name="$mdl.printForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="PRINT_DOCUMENT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <table class="table table-striped" style="border:1px solid #ccc"> <thead> <tr> <th style="width:60px">#</th> <th><b translate="DOCUMENT_DESCRIPTION"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="item in $mdl.documentList"> <td>{{ $index+1 }})</td> <td>{{ item.name }}</td> <td> <a href class="btn btn-primary btn-with-icon btn-xs" style="width:90px" ng-click="$mdl.printDocument(item.id)" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-printer" ng-if="!$mdl.isLoading"></i> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> {{ \'PRINT\' | translate}} </a> </td> </tr> </tbody> </table> <div class="row"> <p>&nbsp;</p> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b> <span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script><script type="text/ng-template" id="downloadModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="EXPORT_TRANSACTIONS_INTO_EXCEL"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <p translate="EXPORT_THE_DELIVERY_ORDER_TRANSACTIONS_INTO_EXCEL_FORMAT_FOR_ACCOUNTING_SOFTWARE">.</p> <br /><br /> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"><span translate="EXPORT_NEW_TRANSACTIONS"></span></legend> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcel()"> <i class="fa fa-download"></i> {{\'GENERATE_EXCEL\' | translate}} </a> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <br /><br /> <div class="row" ng-if="$mdl.batchList.length!=0"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <select name="BatchNo" class="form-control" style="margin-bottom:10px;background:#fffeed" ng-model="$mdl.selectedBatchId" ng-change="$mdl.selectedBatchIdChanged()" ng-options="i as i for i in $mdl.batchList"> <option value="">={{ \'SELECT_ONE\' | translate }}=</option> </select> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcelPast()"> <i class="fa fa-download"></i> {{\'DOWNLOAD_EXCEL\' | translate}} </a> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <div class="row" ng-if="$mdl.batchList.length==0"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <br /> <center> <b class="text-primary"><i class="fa fa-info-circle"></i> <span translate="NO_PREVIOUS_EXPORT_AVAILABLE"></span></b> </center> </div> </div> </div> <hr /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/deliveryorders/deliveryorderUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/deliveryorders/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:30px" ui-sref="deliveryorders.list"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-if="vm.originalStatus==\'NEW\'" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'SHIPPED\' && vm.originalStatus!=\'COMPLETED\' && vm.originalStatus!=\'CANCELLED\'" ng-disabled="vm.lockButtons" rms-check-access="deliveryorders" rms-check-access-perm-type="APPROVE"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <button class="btn btn-success btn-with-icon" style="margin-right:30px" ng-if="vm.originalStatus==\'CONFIRMED\'" ng-disabled="vm.lockButtons" ng-confirm-click="Are you sure to approve this Delivery Order?" confirmed-click="vm.preCheckApproveDeliveryOrder()" rms-check-access="deliveryorders" rms-check-access-perm-type="APPROVE"><i class="ion ion-checkmark"></i> <span translate="APPROVE_D.O."></span></button> <button class="btn btn-danger btn-with-icon" style="margin-right:30px" ng-if="vm.mode==2 && !vm.do.isStockReceiving && (vm.originalStatus==\'NEW\' || vm.originalStatus==\'CONFIRMED\' || vm.originalStatus==\'APPROVED\' || vm.originalStatus==\'PROCESSING\' || vm.originalStatus==\'PROCESSED\')" ng-disabled="vm.lockButtons" ng-confirm-click="Are you sure to cancel this Delivery Order?" confirmed-click="vm.cancelDeliveryOrder()" rms-check-access="deliveryorders" rms-check-access-perm-type="APPROVE"><i class="fa fa-trash"></i> <span translate="CANCEL_D.O."></span></button> <button class="btn btn-success btn-with-icon" style="margin-right:30px" ng-if="(vm.isRmsLite && vm.originalStatus==\'APPROVED\') || (!vm.isRmsLite && !vm.isAdvancedMode && vm.originalStatus==\'SHIPPED\')" ng-disabled="vm.lockButtons" type="button" ng-confirm-click="Are you sure to complete this Delivery Order?" confirmed-click="vm.completeDeliveryOrder()" rms-check-access="deliveryorders" rms-check-access-perm-type="APPROVE"><i class="ion ion-checkmark"></i> <span translate="COMPLETE_D.O."></span></button> <span class="btn btn-with-icon" style="margin-right:30px;color:#fff" ng-if="vm.originalStatus==\'APPROVED\' && vm.isAdvancedMode"><i class="fa fa-info-circle"></i> <span translate="PROCEED_TO_NEXT_STEP_IN_MOBILE_APP"></span></span> <button class="btn btn-primary btn-with-icon" ng-if="vm.originalStatus!=\'CANCELLED\' && vm.originalStatus!=\'CONFIRMED\' && vm.originalStatus!=\'NEW\'" ng-disabled="vm.lockButtons" type="button" ng-click="vm.showPrintDialog()" rms-check-access="deliveryorders" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT_D.O."></span></button> <button class="btn btn-primary btn-with-icon" type="button" ng-if="vm.originalStatus!=\'CANCELLED\' && vm.originalStatus!=\'CONFIRMED\' && vm.originalStatus!=\'NEW\' && !vm.isInvoiceEnabledForSO" ng-disabled="vm.lockButtons" ng-click="vm.printInvoice(vm.do.id, vm.do.invoiceNo)" rms-check-access="deliveryorders" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT_INVOICE"></span></button></div></form>');
$templateCache.put('app/pages/ezyshare/ezyshareView.html','<div ng-if="vm.isAuthenticated" ng-class="{\'al-content\' : !vm.isLoggedIn}"><content-top ng-if="!vm.isLoggedIn"><div class="content-top clearfix"><h1 class="al-title ng-binding"><span translate="RMS_EZYSHARE"></span> <i class="fa fa-paper-plane text-primary"></i></h1></div></content-top><div class="row"><div class="col-md-12" ba-panel=""><div class="row"><div class="col-md-12 col-lg-12" style="font-size:22pt;font-weight:bold;padding:10px 15px 20px"><i class="ion ion-ios-book" style="margin-right:10px"></i> {{vm.entity.name | uppercase}}</div></div><div class="row"><div class="col-md-7 col-lg-5"><div class="row"><img ng-src="{{vm.entity.thumbnail || vm.entity.imageLocation}}" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="margin-bottom:20px"></div><div class="row"><br></div><div class="row"><div class="col-md-12 col-lg-12"><div class="panel panel-default bootstrap-panel" ng-if="vm.entity.dimension"><div class="panel-heading"><b translate="SIZE_/_DIMENSION"></b></div><div class="panel-body">{{vm.entity.dimension}}</div></div></div></div></div><div class="col-md-7 col-lg-7" ng-if="vm.shareObj.objectType==\'RECIPE\'"><div class="row"><div class="col-md-11 col-lg-11"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-sm-7 col-md-7 col-lg-7"><b class="text-danger"><span translate="INGREDIENT_BATCH_QUANTITY"></span></b> <i class="fa fa-asterisk req"></i></div><div class="col-sm-5 col-md-4 col-lg-4" style="text-align:right"><b class="text-danger"><span translate="PRODUCES"></span></b></div></div></div><div class="panel-body"><div class="row" style="padding: 6px 0px; border-bottom: 1px dotted #eee; font-size: 120%"><div class="form-group col-sm-7 col-md-7 col-lg-7"><input type="number" class="form-control" name="Batch" placeholder="Batch Quantity" style="display:inline-block;width:100px" ng-model="vm.batch" ng-change="vm.batchChanged()" min="1"> <a href="" class="btn btn-primary" ng-click="vm.adjustBatch(1)"><i class="ion ion-plus-round"></i></a> <a href="" class="btn btn-primary" ng-click="vm.adjustBatch(-1)"><i class="ion ion-minus-round"></i></a></div><div class="col-sm-5 col-md-5 col-lg-3" style="text-align:right;padding-right:0px;line-height:40px"><big style="color:#2f317a"><b>{{ vm.prodQty }}</b></big></div><div class="col-sm-5 col-md-5 col-lg-2" style="line-height:40px"><big style="color:#2f317a"><b>{{vm.entity.uom}}</b></big></div></div></div></div></div></div><div class="row"><div class="col-md-11 col-lg-11"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-init="isOpen = $index == 0 ? true : false" is-open="isOpen" ng-repeat="recipe in vm.childRecipes"><uib-accordion-heading><div class="row"><div class="col-sm-7 col-md-7 col-lg-7" style="line-height:130%;color:#2f317a"><i class="ion-arrow-expand" style="margin-right:15px"></i> <b>{{recipe.childRecipeName | uppercase}}</b></div><div class="col-sm-3 col-md-3 col-lg-3" style="text-align:right;padding-right:0px;color:#2f317a"><b>{{recipe.childRecipeDisplayQty | number}}</b></div><div class="col-sm-2 col-md-2 col-lg-2" style="color:#2f317a"><b>{{recipe.childRecipeUom}}</b></div></div></uib-accordion-heading><div class="row" style="padding-top:4px;padding-bottom:4px;border-bottom:1px dotted #eee;font-size:110%" ng-repeat="ingredient in recipe.childRecipeItems | orderBy: \'itemName\'"><div class="col-md-8 col-lg-8" style="line-height:130%;padding-left:25px;color:#333">{{ingredient.itemName | uppercase}}</div><div class="col-xs-6 col-sm-6 col-md-2 col-lg-2" style="line-height:130%;text-align:right;padding-right:0px;color:#333"><b>{{ ingredient.displayQty | number }}</b></div><div class="col-xs-6 col-sm-6 col-md-2 col-lg-2" style="line-height:130%;color:#333"><b>{{ingredient.unitOfMeasurement.name}}</b></div></div></uib-accordion-group></uib-accordion></div></div><div class="row"><div class="col-md-11 col-lg-11"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-init="isOpen = $index == 0 ? true : false" is-open="isOpen" ng-repeat="(group, items) in vm.ingredients | groupBy:\'groupName\'"><uib-accordion-heading><div class="row"><div class="col-lg-12" style="line-height:130%"><i class="ion-arrow-expand" style="margin-right:15px"></i> <b>{{group==\'\'?\'Other Ingredients\':group | uppercase}}</b></div></div></uib-accordion-heading><div class="row" style="padding-top:4px;padding-bottom:4px;border-bottom:1px dotted #eee;font-size:110%" ng-repeat="ingredient in items | orderBy: \'itemName\'"><div class="col-md-8 col-lg-8" style="line-height:130%;padding-left:25px">{{ingredient.itemName | uppercase}}</div><div class="col-xs-6 col-sm-6 col-md-2 col-lg-2" style="text-align:right;padding-right:0px;color:#000"><b>{{ ingredient.displayQty | number }}</b></div><div class="col-xs-6 col-sm-6 col-md-2 col-lg-2" style="color:#000"><b>{{ingredient.uom}}</b></div></div></uib-accordion-group></uib-accordion></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><br><center><a href="#step_1" class="btn btn-success btn-with-icon btn-lg" du-smooth-scroll=""><i class="ion ion-flag"></i> <span translate="START_NOW"></span></a></center></div></div></div></div><a name="step_1"></a><div class="row" ng-repeat="s in vm.entity.entitySteps | orderBy: \'step\'"><a name="step_{{s.step+1}}"></a><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="step col-md-5 col-lg-5"><ng-youtube-embed url="s.attachmentLocation" width="100%" height="492px" showinfo="false" controls="false" rel="false" ng-if="s.attachmentType==\'youtube\' && s.attachmentLocation!=\'\' && s.attachmentLocation!=null"></ng-youtube-embed><iframe ng-src="{{s.finalVimeoUrl}}" width="100%" height="400" frameborder="0" style="background:#000" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" ng-if="s.attachmentType.substring(0,5)==\'video\' && s.isVimeoConverted && s.vimeoVideoId!=\'\'"></iframe><img src="{{vm.rootUrl}}{{s.attachmentLocation}}" alt="" style="width:100%" class="step-image-card" fancyboxable="{href:\'{{vm.rootUrl}}{{s.attachmentLocation}}\'}" ng-if="s.attachmentType.substr(0,5)==\'image\' && (s.attachmentLocation!=\'\' && s.attachmentLocation!=null)"> <img src="assets/img/empty_placeholder.png" alt="" style="width:100%" class="step-image-card" ng-if="s.attachmentLocation==\'\' || s.attachmentLocation==null"></div><div class="col-md-7 col-lg-7"><div class="row"><div class="col-md-12 col-lg-12"><div style="padding: 10px;"><h1 style="margin-bottom:20px;"><span translate="STEP"></span> {{s.step+1}}</h1><div style="font-size:16pt;line-height:150%;margin-bottom:20px;white-space:pre-wrap">{{s.description}}</div><div style="font-size:14pt;line-height:150%;color:#b00;" ng-show="s.extraDescription"><em><b>* <span translate="ATTENTION"></span> *</b></em><div style="color:#b00;white-space:pre-wrap">{{s.extraDescription}}</div></div></div></div></div></div><div class="col-md-12 col-lg-12"><div class="row"><div class="col-md-12 col-lg-12"><a href="#step_{{s.step+2}}" class="btn btn-success btn-with-icon btn-lg pull-right" du-smooth-scroll="" ng-hide="s.step+1==vm.entity.entitySteps.length"><i class="ion ion-chevron-right"></i> <span translate="NEXT_STEP"></span></a> <a href="#step_{{s.step}}" class="btn btn-primary btn-with-icon btn-lg pull-right" style="margin-right:10px" du-smooth-scroll="" ng-hide="s.step==0 || s.step+1==vm.entity.entitySteps.length"><i class="ion ion-chevron-left"></i> <span translate="PREV_STEP"></span></a> <a href="#step_1" class="btn btn-primary btn-with-icon btn-lg pull-right" style="margin-right:10px" du-smooth-scroll="" ng-hide="s.step+1!=vm.entity.entitySteps.length"><i class="ion ion-chevron-up"></i> <span translate="START_OVER"></span></a></div></div></div></div></div></div><div class="row" ng-if="vm.entity.entitySteps.length==0"><div class="col-md-12 col-lg-12"><table class="table table-striped"><tbody><tr><td align="center"><br><h2><span translate="THERE_IS_NO_STEPS_AVAILABLE"></span>.</h2><br>&nbsp;</td></tr></tbody></table></div></div><center ng-if="!vm.isLoggedIn"><small>&copy;2019 <b>Codemax&reg; <span translate="RMS"></span></b> by Codemax Sdn Bhd. All Rights Reserved.<br><a href="https://rms.codemax.my" target="_blank" style="color:#00f"><u translate="LOGIN_TO_RMS"></u></a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <a href="http://codemax.my" target="_blank" style="color:#00f"><u>About Codemax</u></a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <a href="http://codemax.my" target="_blank" style="color:#00f"><u translate="CONTACT_US"></u></a></small><p><br><br></p></center></div><script type="text/ng-template" id="passwordDialogModal.html"><form name="$mdl.passwordForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header" style="background:#2f59d4"> <h3 class="modal-title" style="color:#fff"> <span translate="ENTER_PASSWORD"></span> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b><span translate="THE_PASSWORD_CAN_BE_FOUND_IN_THE_EMAIL"></span>:</b></label> <input name="Password" type="password" class="form-control" style="background:#ffffff" autocomplete="off" ng-model="$mdl.item.password" ng-disabled="$mdl.lockButton" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.shareForm.Password.$error.required && $mdl.shareForm.$submitted">* <span translate="PASSWORD_IS_REQUIRED"></span></p> </div> </div> </div> <legend ng-if="$mdl.showSuccess || $mdl.showError"></legend> <div class="row" ng-if="$mdl.showSuccess"> <div class="col-lg-12"> <span style="color:#0a8a0a"> <i class="fa fa-check"></i> &nbsp; <span translate="ACCESS_GRANTED"></span>. </span> </div> </div> <div class="row" ng-if="$mdl.showError"> <div class="col-lg-12"> <span style="color:#f00"> <i class="fa fa-exclamation-triangle"></i> &nbsp; <span style="color:#f00" ng-bind-html="$mdl.errorMsg"></span> </span> </div> </div> </div> <legend></legend> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon btn-lg" type="submit" ng-disabled="$mdl.lockButton" style="float:left"> <i class="fa fa-check"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon btn-lg" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> <br /> <div ng-if="$mdl.lockButton && !$mdl.showSuccess && !$mdl.showError" style="float:left;margin-top:10px"> <i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="VERIFYING_ACCESS"></span> ...</b> </div> </div> </form></script>');
$templateCache.put('app/pages/ezytrack/ezytrackView.html','<div ng-class="{\'al-content\' : !vm.isLoggedIn}"><content-top ng-if="!vm.isLoggedIn"><div class="content-top clearfix"><h1 class="al-title ng-binding"><span translate="RMS_EZYTRACK"></span> <i class="fa fa-truck text-primary"></i></h1></div></content-top><div class="row"><div class="col-lg-12"><table style="border-collapse:collapse;border:1px solid #ccc"><tr><td style="padding:10px;padding-right:30px"><div class="form-group"><label>Driver Name</label>:<br><b style="font-size:16pt">{{ vm.route.driverName | uppercase }}</b></div></td><td style="padding:10px 20px"><div class="form-group"><label>Distance</label>:<br><b style="font-size:16pt">{{ vm.distance }}</b></div></td><td style="padding:10px"><div class="form-group"><label>Est Time</label>:<br><b style="font-size:16pt">{{ vm.duration }}</b></div></td></tr></table></div></div><div class="row"><div class="col-lg-12"><div id="googleMap" style="height:600px"></div></div></div><div class="row"><div class="col-lg-12"></div></div></div>');
$templateCache.put('app/pages/permissioncenter/permissioncenter.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><p><i class="fa fa-info-circle"></i> &nbsp;List of third party companies which are granted access. <a href="" class="btn btn-primary btn-with-icon" style="margin-left:30px" ng-click="vm.showAccessModal()"><i class="ion-plus-round"></i>Grant Access</a></p><table class="table table-striped" style="border:5px solid #eee"><thead><tr class="sortable"><th style="width:20px">#</th><th>Third Party Company</th><th>Access Granted Date</th><th>Access Granted By</th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.permissions.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.permissions"><td>{{vm.startIndex+1+$index}})</td><td>{{item.accessCompanyName | uppercase}}</td><td>{{item.accessGrantDate | date:\'dd/MM/yyyy hh:mma\'}}</td><td>{{item.createdBy | uppercase}}</td><td align="center"><a href="" title="Revoke Access" class="btn btn-danger btn-sm btn-with-icon" confirmed-click="vm.revokeAccess(item.id)" ng-confirm-click="*WARNING* Confirm revoke this company access?" ng-disabled="vm.isLoading"><i class="fa fa-ban"></i> Revoke Access</a></td></tr></tbody></table><p><br></p></div></div></div><script type="text/ng-template" id="accessModal.html"><form name="$mdl.modalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Grant Access To Third Party Company</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <h2>Terms &amp; Conditions</h2> <div style="text-align:justify;padding:15px;border:1px solid #000;background:#eee"> <p style="color:#000 !important">We hereby understand and agree that the selected <b>Third Party Company</b> may access to the our account\'s temperature data in <b>Codemax RMS Software System</b> for the following purposes:</p> <ol style="color:#000 !important"> <li>To view and monitor the temperature of all our sensors.</li> <li>To generate and download reports on all our sensors.</li> <li>To configure and set up alerts for all our sensors.</li> </ol> <p style="color:#000 !important">This agreement is granted to <b>Third Party Company</b> only and does not include any holding, related or subsidiary companies of <b>Third Party Company</b>.</p> <p style="color:#000 !important">We understand that we reserve the final right to revoke the access to the <b>Third Party Company</b> at our own discrete.</p> <p style="color:#000 !important">We agree that <b>Codemax Sdn Bhd</b> shall not be liable to any party for any direct, indirect, incidental, special, or consequential damages, including loss of profits, revenue and data, incurred by any party, under or arising from this agreement.</p> </div> <br /> <checkbox large ng-model="$mdl.isAgreeTnc" ng-change="change()" ng-disabled="$mdl.lockButtons || $mdl.isLoading" style="background:#fffff4"> </checkbox> &nbsp;I have read, understood, and agreed to the Terms and Conditions. <p class="help-block" style="color:#f00" ng-show="!$mdl.isAgreeTnc && $mdl.modalForm.$submitted">* You must agree in order to proceed</p> <p><br /></p> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Company.$invalid && $mdl.modalForm.$submitted}"> <label><b>Third Party Company:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select id="Company" name="Company" class="btn-group bootstrap-select form-control" title="" ng-disabled="$mdl.lockButtons || $mdl.isLoading" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedCompany" required> <ui-select-match placeholder="Type keyword (min 3 letters) to begin searching for companies..."> <span>{{ $select.selected.name | uppercase }}</span> </ui-select-match> <ui-select-choices repeat="t in $mdl.companies | filter: $select.search" refresh="$mdl.loadCompanies($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="t.name | uppercase | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Company.$error.required && $mdl.modalForm.$submitted">* You must select a company</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div ng-show="$mdl.isLoading"> <b style="color:#00f"><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b> </div> <div ng-show="$mdl.lockButtons"> <b style="color:#00f"><i class="fa fa-spinner fa-spin fa-fw"></i> Processing ...</b> </div> </div> <p><br /></p> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons || $mdl.isLoading"> <i class="ion ion-checkmark"></i> Confirm </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons || $mdl.isLoading"> <i class="ion ion-close"></i> Cancel </button> </div> </form></script>');
$templateCache.put('app/pages/salesordercalendar/salesordercalendar.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div fc="" fc-options="vm.calendarOptions" ng-model="vm.calendarOptions.events"></div><br>&nbsp;</div></div></div>');
$templateCache.put('app/pages/salesorders/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-show="vm.originalStatus==\'NEW\'"><small><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_SALES_ORDER_DETAILS"></span>.</small><br><br></p><p ng-show="vm.originalStatus!=\'NEW\'"><small><i class="fa fa-warning"></i> <span translate="ALL_THE_FIELDS_WILL_BE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="NEW"></b>.</small><br><br></p><div class="row" ng-if="vm.isCloneMode"><div class="col-lg-12"><div class="form-group"><label><b>{{ \'CLONE_FROM\' | translate }}:</b></label><h1 style="color:#00f">{{vm.salesOrder.salesOrderNo}}</h1><br></div></div></div><div class="row"><div class="col-md-3 col-lg-3" ng-if="!vm.isCloneMode"><div class="form-group"><label><b>{{ \'SALES_ORDER_NO\' | translate }}</b></label> <span class="form-control" style="color:#00f" ng-disabled="true">{{vm.salesOrder.salesOrderNo || \'AUTONUMBER\'}}</span><div ng-if="vm.salesOrder.originalDocNo!=null && vm.salesOrder.originalDocNo!=\'\'" style="margin-left:5px;color:#00f"><small>(Original Ref: <b>{{vm.salesOrder.originalDocNo}}</b>)</small></div></div></div><div class="col-md-3 col-lg-3" ng-if="vm.isCloneMode"><div class="form-group"><label><b>{{ \'SALES_ORDER_NO\' | translate }}</b></label> <span class="form-control" style="color:#00f" ng-disabled="true">AUTONUMBER</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Status.$invalid && (vm.dataForm.Status.$dirty || vm.dataForm.$submitted)}"><label><b translate="ORDER_STATUS"></b> <i class="fa fa-asterisk req"></i></label><select name="Status" class="form-control" ng-change="vm.selectedStatusChanged()" ng-model="vm.selectedStatus" ng-options="i as i.name for i in vm.statusList" ng-show="vm.originalStatus==\'NEW\'" required=""></select><span class="form-control" ng-if="vm.originalStatus!=\'NEW\'" ng-disabled="vm.originalStatus!=\'NEW\'">{{vm.salesOrder.status}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Status.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3" ng-if="!vm.isCloneMode"><div class="form-group"><label><b>{{ \'STOCK_REQUEST_NO\' | translate }}</b></label> <span class="form-control" style="color:#00f" ng-disabled="true">{{vm.salesOrder.stockRequestNo || \'-\'}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeliveryDate.$invalid && (vm.dataForm.DeliveryDate.$dirty || vm.dataForm.$submitted)}"><label><b style="color:#00f">{{ \'DELIVERY_DATE_TIME\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.salesOrder.deliveryDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" name="DeliveryDate" placeholder="YYYY-MM-DD" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.salesOrder.deliveryDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeliveryDate.$error.required">* {{ \'REQUIRED\' | translate }}</span><div style="clear:both"></div></div></div></div><div class="row"><div class="col-md-3 col-lg-3" ng-if="vm.salesOrder.sourceBranchId!=null"><div class="form-group"><label><b>{{ \'SOURCE_BRANCH\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="SourceBranch" class="form-control" ng-change="vm.selectedSourceBranchChanged()" ng-model="vm.selectedSourceBranch" ng-options="i as i.name for i in vm.branchList" ng-disabled="vm.originalStatus!=\'NEW\' && vm.salesOrder.sourceBranchId!=null" required=""></select></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SalesBranch.$invalid && (vm.dataForm.SalesBranch.$dirty || vm.dataForm.$submitted)}"><label><b ng-if="vm.salesOrder.sourceBranchId==null">{{ \'SALES_BRANCH\' | translate }}</b> <b ng-if="vm.salesOrder.sourceBranchId!=null">{{ \'DESTINATION_BRANCH\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="SalesBranch" class="form-control" ng-change="vm.selectedDestBranchChanged()" ng-model="vm.selectedDestBranch" ng-options="i as i.name for i in vm.branchList" ng-disabled="vm.originalStatus!=\'NEW\'" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SalesBranch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-hide="true"><div class="col-md-3 col-lg-3" ng-if="vm.isDirectTriggerJobCreation"><div class="form-group"><label><b style="color:#00f"><span translate="DIRECT_PRODUCTION_JOB_CREATION"></span></b> <i class="fa fa-asterisk req"></i></label><div><toggle ng-if="vm.originalStatus==\'NEW\'" ng-model="vm.salesOrder.isDirectProduction" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div><span class="form-control" ng-if="vm.originalStatus!=\'NEW\'" ng-disabled="vm.originalStatus!=\'NEW\'">{{vm.salesOrder.isDirectProduction?"YES":"NO"}}</span></div></div></div><br><br><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="CUSTOMER"></b> (<span translate="OPTIONAL"></span>)</label><div class="row"><div class="col-md-3 col-lg-3" style="padding-right:0px"><div class="input-group" style="margin-bottom:0px"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-search"></i></span> <input class="form-control" ng-model="vm.custSearch" ng-disabled="vm.originalStatus!=\'NEW\'"></div></div><div class="col-md-9 col-lg-9"><select class="form-control" ng-change="vm.selectedDebtorChanged()" ng-options="d as (d.name | uppercase) for d in (vm.debtorList | filter:vm.custSearch)" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.selectedDebtor"></select></div></div></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="CUSTOMER_BRANCH"></b> (<span translate="OPTIONAL"></span>)</label><select class="form-control" ng-change="vm.selectedDebtorBranchChanged()" ng-options="d as d.name for d in vm.debtorBranchList" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.selectedDebtorBranch"></select></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'CUSTOMER_PO_NUMBER\' | translate }}</b> (<span translate="OPTIONAL"></span>)</label> <input type="text" class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.salesOrder.customerPoNo"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'DELIVERY_WINDOW\' | translate }}</b></label><table class="deliveryWindowInfo"><tr><td ng-class="{\'highlight\' : vm.selectedDebtor.deliveryWindow1==true}">M</td><td ng-class="{\'highlight\' : vm.selectedDebtor.deliveryWindow2==true}">T</td><td ng-class="{\'highlight\' : vm.selectedDebtor.deliveryWindow3==true}">W</td><td ng-class="{\'highlight\' : vm.selectedDebtor.deliveryWindow4==true}">T</td><td ng-class="{\'highlight\' : vm.selectedDebtor.deliveryWindow5==true}">F</td><td ng-class="{\'highlight\' : vm.selectedDebtor.deliveryWindow6==true}">S</td><td ng-class="{\'highlight\' : vm.selectedDebtor.deliveryWindow7==true}">S</td></tr></table></div></div></div><br><br><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.OrderTitle.$invalid && (vm.dataForm.OrderTitle.$dirty || vm.dataForm.$submitted)}"><label><b translate="ORDER_TITLE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="OrderTitle" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.salesOrder.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.OrderTitle.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="DESCRIPTION"></b></label> <textarea class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.salesOrder.description">\n\t\t\t\t\t\t\t</textarea></div></div></div><hr ng-if="vm.salesOrder.createdBy"><div class="row" ng-if="!vm.isCloneMode"><div class="col-md-3 col-lg-3" ng-if="vm.salesOrder.createdBy"><div class="form-group"><label><b>{{ \'CREATED_BY\' | translate }}</b></label><br><span>{{vm.salesOrder.createdBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.salesOrder.createdDate | date:\'dd/MM/yyyy\' }}</span></div></div><div class="col-md-3 col-lg-3" ng-if="vm.salesOrder.modifiedBy"><div class="form-group"><label><b>{{ \'MODIFIED_BY\' | translate }}</b></label><br><span>{{vm.salesOrder.modifiedBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.salesOrder.modifiedDate | date:\'dd/MM/yyyy\' }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'ORDER_ITEMS\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="ADD_ITEMS_INTO_THIS_SALES_ORDER"></span>. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddProductModal()" ng-if="vm.originalStatus==\'NEW\'"><i class="ion-plus-round"></i> {{ \'ADD_ITEM\' | translate }}</a> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddFoodMenuModal()" ng-if="vm.originalStatus==\'NEW\'"><i class="ion-plus-round"></i> <span translate="ADD_FROM_FOOD_MENU"></span></a><br></p><div><toggle ng-model="vm.showDetailedInvView" ng-change="changed()" on="{{ \'DETAILED\' | translate }}" off="{{ \'SUMMARY\' | translate }}" onstyle="btn-success btn-xs" offstyle="btn-default btn-xs"></toggle>&nbsp;&nbsp;<small>{{ \'ITEM_INVENTORY_BAL_VIEW_MODE\' | translate }}</small></div><br><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:3px solid #ccc" st-pipe="vm.refreshBookingProducts" st-table="vm.salesOrder.salesOrderProducts" refresh-table=""><thead style="border-bottom:3px solid #ccc"><tr class="sortable"><th style="width:60px">#</th><th>{{ \'PRODUCT_NAME\' | translate }}</th><th style="width:100px;text-align:right" class="hide-after">{{ \'QUANTITY\' | translate }}</th><th style="width:100px"><b>{{ \'U.O.M.\' | translate }}</b></th><th style="width:150px;text-align:right" class="hide-after">{{ \'UNIT_PRICE\' | translate }}<br>({{vm.currency}})</th><th style="width:150px;text-align:right" class="hide-after">{{ \'DISCOUNT\' | translate }}<br>({{vm.currency}})</th><th style="text-align:right;width:150px" class="hide-after"><span ng-if="vm.isShippingFeesEnabled">{{ \'SUBTOTAL\' | translate }} ({{vm.currency}})<br><small>(<span translate="EXCLUDE_TAX"></span>)</small></span> <span ng-if="!vm.isShippingFeesEnabled"></span></th><th style="width:100px;text-align:right" class="hide-after">{{ \'TOTAL_TAX\' | translate }}<br>({{vm.currency}})</th><th style="text-align:right;width:150px" class="hide-after">{{ \'SUBTOTAL\' | translate }} ({{vm.currency}})<br><small>(<span translate="INCLUDE_TAX"></span>)</small></th><th style="width:20px"></th><th>{{ \'REMARKS\' | translate }}</th><th style="width:90px" ng-if="vm.originalStatus==\'NEW\'"></th><th style="width:90px" ng-if="vm.originalStatus==\'NEW\'"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.salesOrder.salesOrderProducts"><td>{{$index+1}})</td><td style="padding-top:8px;padding-bottom:8px;line-height:150%"><b>{{ ntn.productName || \'\' }}</b><br><small style="color:#888"><b>{{ ntn.productCode }}</b>&nbsp;&nbsp;({{ ntn.itemType }})</small><div style="margin-top:5px;margin-bottom:10px"><table cellpadding="1" border="1" style="width:500px;font-size:9pt" ng-if="!vm.showDetailedInvView"><tr><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'AVAILABLE\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'RESERVED\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'BALANCE\' | translate }}</td><td style="width: 50px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'U.O.M.\' | translate }}</td></tr><tr><td style="padding: 2px auto;text-align:center"><span ng-class="{\'text-danger\': (vm.getAvailableQty(ntn) < 0), \'text-success\': (vm.getAvailableQty(ntn) > 0)}"><b>{{vm.getAvailableQty(ntn) | number}}</b></span></td><td style="padding: 2px auto;text-align:center">{{vm.getReservedQty(ntn) | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.invBalance | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.invUomName}}</td></tr></table><table cellpadding="1" border="1" style="width:500px;font-size:9pt" ng-if="vm.showDetailedInvView"><tr><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'AVAILABLE\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'SO_NEW\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'SO_CFM\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'DO_PND\' | translate }}</td><td style="width: 80px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'BALANCE\' | translate }}</td><td style="width: 50px;padding: 2px auto;text-align:center;background:#e1eeff">{{ \'U.O.M.\' | translate }}</td></tr><tr><td style="padding: 2px auto;text-align:center"><span ng-class="{\'text-danger\': (vm.getAvailableQty(ntn) < 0), \'text-success\': (vm.getAvailableQty(ntn) > 0)}"><b>{{vm.getAvailableQty(ntn) | number}}</b></span></td><td style="padding: 2px auto;text-align:center">{{ntn.totalNewSalesOrderQuantity | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.totalConfirmedSalesOrderQuantity | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.totalDOPendingQuantity | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.invBalance | number}}</td><td style="padding: 2px auto;text-align:center">{{ntn.invUomName}}</td></tr></table></div></td><td style="text-align:right">{{ ntn.quantity }}</td><td>{{ ntn.uomName }}</td><td style="text-align:right">{{ ntn.unitPrice | currency:\'\' }}</td><td style="text-align:right"><span class="text-danger">({{ ntn.discountAmount || 0.00 | currency:\'\' }}) <span></span></span></td><td style="text-align:right"><span ng-if="vm.isShippingFeesEnabled">{{ ( ( ntn.unitPrice * ntn.quantity ) - ntn.discountAmount ) | currency:\'\' }}</span> <span ng-if="!vm.isShippingFeesEnabled"></span></td><td style="text-align:right">{{ ntn.tax | currency:\'\' }}</td><td style="text-align:right">{{ ntn.subtotal | currency:\'\' }}</td><td style="width:20px"></td><td style="padding-top:8px;padding-bottom:8px;line-height:150%">{{ ntn.remarks }}</td><td ng-if="vm.originalStatus==\'NEW\'"><a class="btn btn-info btn-with-icon btn-sm" style="width:90px" ng-click="vm.showEditProductModal($index)" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td ng-if="vm.originalStatus==\'NEW\'"><a class="btn btn-danger btn-with-icon btn-sm" style="width:90px" confirmed-click="vm.removeProduct($index)" ng-confirm-click="Confirm remove ({{ntn.itemType}}) {{ntn.productName}} ?" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-trash-o"></i> {{ \'REMOVE\' | translate }}</a></td></tr><tr><td colspan="{{ vm.isShippingFeesEnabled ? 14 : 13 }}" align="center" ng-if="vm.salesOrder.salesOrderProducts.length==0"><br><span translate="ITEM_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody><tfoot style="border-top:3px solid #ccc"><tr><td colspan="{{ vm.isShippingFeesEnabled ? 6 : 8 }}" style="text-align:right"><b>{{ \'SUBTOTAL\' | translate }} ({{vm.currency}}) :</b></td><td style="text-align:right" ng-if="vm.isShippingFeesEnabled"><b>{{ vm.subtotalExcludeTax | currency:\'\'}}</b></td><td ng-if="vm.isShippingFeesEnabled"></td><td style="text-align:right"><b>{{ vm.subtotal | currency:\'\'}}</b></td></tr><tr><td colspan="8" rowspan="2" style="text-align:right"><div style="display:inline-block;margin-top:30px;line-height:110%"><b>( <span class="text-danger">&#8722;</span> )&nbsp; {{ \'ADDITIONAL_DISCOUNT\' | translate }} :</b><br><small>({{ \'FILL_IN_EITHER_ONE\' | translate }})<small>&nbsp;</small></small></div></td><td style="text-align:right"><div class="form-group" style="margin-bottom:0px" ng-class="{\'has-error\': vm.dataForm.DiscountPercentage.$invalid && (vm.dataForm.DiscountPercentage.$dirty || vm.dataForm.$submitted)}"><input type="number" name="DiscountPercentage" class="form-control" min="0" style="text-align:right;width:150px;background:#fffced;-webkit-appearance:none;-moz-appearance:textfield" ng-change="vm.calculateDiscountAmount1()" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.salesOrder.discountPercentage"> <span class="help-block" style="margin-top:0px;margin-bottom:0px" ng-show="vm.dataForm.$submitted && vm.dataForm.DiscountPercentage.$error.number"><small>* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</small></span></div></td><td>%</td></tr><tr><td style="text-align:right"><div class="form-group" style="margin-bottom:0px" ng-class="{\'has-error\': vm.dataForm.DiscountAmount.$invalid && (vm.dataForm.DiscountAmount.$dirty || vm.dataForm.$submitted)}"><input type="number" name="DiscountAmount" class="form-control" min="0" style="text-align:right;width:150px;background:#fffced;-webkit-appearance:none;-moz-appearance:textfield" ng-change="vm.calculateDiscountAmount2()" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.salesOrder.discountAmount"> <span class="help-block" style="margin-top:0px;margin-bottom:0px" ng-show="vm.dataForm.$submitted && vm.dataForm.DiscountAmount.$error.number"><small>* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</small></span></div></td><td>({{vm.currency}})</td></tr><tr><td colspan="4" style="text-align:right;font-size:10pt;line-height:110%"><b>( <span class="text-success">+</span> )&nbsp; {{ \'ADDITIONAL_CHARGES\' | translate }} :</b><br><small>({{ \'FURTHER_DESCRIPTION\' | translate}})</small>&nbsp;</td><td colspan="4" style="text-align:right"><input type="text" class="form-control input-sm" style="background:#FFFCED" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.salesOrder.additionalChargesDesc"></td><td style="text-align:right"><div class="form-group" style="margin-bottom:0px" ng-class="{\'has-error\': vm.dataForm.AdditionalCharges.$invalid && (vm.dataForm.AdditionalCharges.$dirty || vm.dataForm.$submitted)}"><input type="number" name="AdditionalCharges" class="form-control" min="0" style="text-align:right;width:150px;background:#fffced;-webkit-appearance:none;-moz-appearance:textfield" ng-change="vm.recalculateGrandTotal()" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.salesOrder.additionalCharges"> <span class="help-block" style="margin-top:0px;margin-bottom:0px" ng-show="vm.dataForm.$submitted && vm.dataForm.AdditionalCharges.$error.number"><small>* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</small></span></div></td></tr><tr ng-if="vm.isShippingFeesEnabled"><td colspan="4" style="text-align:right;font-size:10pt;line-height:110%"><b>( <span class="text-success">+</span> )&nbsp; {{ \'SHIPPING_FEES\' | translate }} :</b><br><small>({{ \'FURTHER_DESCRIPTION\' | translate}})</small>&nbsp;</td><td colspan="4" style="text-align:right"><input type="text" class="form-control input-sm" style="background:#FFFCED" ng-disabled="true" ng-model="vm.salesOrder.shippingFeeDesc"></td><td style="text-align:right"><div class="form-group" style="margin-bottom:0px" ng-class="{\'has-error\': vm.dataForm.ShippingFees.$invalid && (vm.dataForm.ShippingFees.$dirty || vm.dataForm.$submitted)}"><input type="number" name="ShippingFees" class="form-control" min="0" style="text-align:right;width:150px;background:#fffced;-webkit-appearance:none;-moz-appearance:textfield" ng-change="vm.recalculateGrandTotal()" ng-disabled="true" ng-model="vm.salesOrder.shippingFeeCharges"> <span class="help-block" style="margin-top:0px;margin-bottom:0px" ng-show="vm.dataForm.$submitted && vm.dataForm.ShippingFees.$error.number"><small>* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</small></span></div></td></tr><tr><td colspan="8" style="text-align:right"><h3 style="margin-top:8px;margin-bottom:0px;font-weight:bold">{{ \'GRAND_TOTAL\' | translate }} ({{vm.currency}}) :</h3></td><td style="text-align:right;padding:0px"><div style="margin:8px;padding:8px;border:3px solid #000;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;"><h3 style="margin-bottom:0px"><b>{{vm.salesOrder.grandTotal || vm.grandTotal | currency:\'\'}}</b></h3></div></td></tr></tfoot></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="productModal.html"><form name="$mdl.productForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="PRODUCT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div style="background:#d8ffd8;margin-bottom:15px"> <uib-tabset active="$mdl.activeTab"> <uib-tab heading="{{ \'RAW_MATERIAL\' | translate}}"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <label> <b>{{ \'RAW_MATERIAL\' | translate }}</b> <br /> <small><i class="fa fa-info-circle"></i> {{ \'SELECT_RAW_MATERIAL_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small> </label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="$mdl.selectedItem!=null" ng-click="$mdl.selectedItem=null"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> <ui-select ng-model="$mdl.selectedItem" title="Select or Search for Raw Materials..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedItemChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Raw Materials..."> <span>{{ $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.itemList | filter: $select.search" refresh="$mdl.loadItemList($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="i.description | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p> </div> </div> </div> </uib-tab> <uib-tab heading="{{ \'SEMI_FINISHED_GOODS\' | translate}}"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <label> <b>{{ \'SEMI_FINISHED_GOODS\' | translate }}</b> <br /> <small><i class="fa fa-info-circle"></i> {{ \'SELECT_SEMI_FINISHED_GOODS_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small> </label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="$mdl.selectedSemiFg!=null" ng-click="$mdl.selectedSemiFg=null"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> <ui-select ng-model="$mdl.selectedSemiFg" title="Select or Search for Semi Finished Goods..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedSemiFgChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Semi Finished Goods..."> <span>{{ $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.semiFgList | filter: $select.search" refresh="$mdl.loadSemiFgList($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="i.description | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p> </div> </div> </div> </uib-tab> <uib-tab heading="Finished Goods"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <label> <b translate="FINISHED_GOODS"></b> <br /> <small><i class="fa fa-info-circle"></i> {{ \'SELECT_FINISHED_GOODS_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small> </label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" style="color:#fff" ng-if="$mdl.selectedProduct!=null" ng-click="$mdl.selectedProduct=null"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> <ui-select ng-model="$mdl.selectedProduct" title="Select or Search for Finished Goods..." class="btn-group bootstrap-select form-control" append-to-body="false" on-select="$mdl.selectedProductChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Finished Goods..."> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.productList | filter: $select.search" refresh="$mdl.loadProductList($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p> </div> </div> </div> </uib-tab> </uib-tabset> </div> <input type="text" name="ItemName" class="form-control" ng-model="$mdl.item.productName" required ng-hide="true" /> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.Quantity.$invalid && $mdl.productForm.$submitted}"> <div class="row"> <div class="col-lg-6"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" name="Quantity" class="form-control" min=1 ng-model="$mdl.item.quantity" ng-change="$mdl.onQuantityChanged" /> </div> <div class="col-lg-6"> <label><b translate="SALES_U.O.M"></b> <!-- &nbsp;<small>(<span translations="CONFIGURE_AT"></span> <b><em translations= "MAINTENANCE_>_PRODUCTS" ></em></b>)</small> --> </label> <span class="form-control"> <b ng-hide="$mdl.productSalesUom==null">{{ $mdl.productSalesUom.name || \'\' }}</b> <span style="color:#f00" ng-show="$mdl.productSalesUom==null"> <small translate="SALES_U.O.M_NOT_AVAILABLE"></small> </span> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> </span> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.required && $mdl.productForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.number && $mdl.productForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton2"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButton2"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="salesOrderItemModal.html"><form name="$mdl.productForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{$mdl.title | translate}} <span translate="ITEM"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" style="margin-bottom:5px" ng-if="$mdl.selectedItem!=null" ng-click="$mdl.selectedItem=null"> <i class="fa fa-times"></i> <span style="color:#fff" translate="CLEAR_SELECTION"></span> </button> <label> <b>{{ \'RAW_MATERIAL\' | translate }}</b> / <b>{{ \'SEMI_FINISHED_GOODS\' | translate }}</b> / <b>{{ \'FINISHED_GOODS\' | translate }}</b> </label> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group" style="margin-bottom:0px"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.itemSearch" style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model-options=\'{ debounce: 1500 }\' ng-change="$mdl.searchItem($mdl.itemSearch)" /> </div> </div> <div class="col-lg-9"> <select class="form-control" style="background:#FFFCED" name="ItemName" ng-disabled="$mdl.lockButtons" ng-change="$mdl.selectedItemChanged()" ng-options="u as (\'[\' + u.itemType + \'] \' + u.productName | uppercase) for u in $mdl.itemList" ng-model="$mdl.selectedItem" required> <option value="">{{($mdl.lockButtons ? (\'LOADING...\' | translate) : ($mdl.itemList.length==0 ? ("&lt;&lt; " + (\'ENTER_A_KEYWORD_TO_SEARCH\' | translate)) : ("-- " + (\'SELECT_AN_ITEM\' | translate) + " --")))}}</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted"> * {{"REQUIRED" | translate}} </p> </div> </div> </div> </div> <br /> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.Quantity.$invalid && $mdl.productForm.$submitted}"> <div class="row"> <div class="col-lg-3"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" name="Quantity" class="form-control" min=0.001 style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.quantity" ng-change="$mdl.quantityChanged()" required /> </div> <div class="col-lg-3"> <label><b translate="SALES_U.O.M"></b> <!-- &nbsp;<small>(<span translations="CONFIGURE_AT"></span> <b><em translations= "MAINTENANCE_>_PRODUCTS" ></em></b>)</small> --> </label> <span class="form-control" disabled="disabled"> <b ng-hide="$mdl.item.unitOfMeasurementId==null">{{ $mdl.item.uomName || \'\' }}</b> <span style="color:#f00" ng-if="$mdl.item.unitOfMeasurementId==null"> <small translate="SALES_U.O.M_NOT_AVAILABLE"></small> </span> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> </span> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.required && $mdl.productForm.$submitted">* {{ "REQUIRED" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.number && $mdl.productForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.min && $mdl.productForm.$submitted">* {{ "MINIMUM_VALUE_IS_0.001" | translate }}</p> </div> <div class="row"> <div class="col-lg-3"> <div class="form-group"> <label><b>{{ \'UNIT_PRICE\' | translate }}</b> ({{ $mdl.currencyCode }})</label> <span class="form-control" disabled="disabled"> {{ $mdl.item.unitPrice | currency:\'\' }} </span> </div> </div> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.DiscountPercentage.$invalid && $mdl.productForm.$submitted}"> <label> <b>{{ \'DISCOUNT\' | translate }} %</b></label> <input type="number" name="DiscountPercentage" class="form-control" min=0 style="background:#fffced;color:#000" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.discountPercentage" ng-change="$mdl.calculateDiscountAmount1()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.DiscountPercentage.$error.number && $mdl.productForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.DiscountPercentage.$error.min && $mdl.productForm.$submitted">* {{ "MINIMUM_VALUE_IS_0" | translate }}</p> </div> </div> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.DiscountAmount.$invalid && $mdl.productForm.$submitted}"> <label> <b>{{ \'DISCOUNT\' | translate }}</b> ({{ $mdl.currencyCode }})</label> <input type="number" name="DiscountAmount" class="form-control" min=0 style="background:#fffced;color:#000" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.discountAmount" ng-change="$mdl.calculateDiscountAmount2()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.DiscountAmount.$error.number && $mdl.productForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.DiscountAmount.$error.min && $mdl.productForm.$submitted">* {{ "MINIMUM_VALUE_IS_0" | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-3"> <div class="form-group"> <label> <b>{{ \'TAX_CODE\' | translate }}</b></label> <span class="form-control" disabled="disabled"> {{ $mdl.item.taxCode }} </span> </div> </div> <div class="col-lg-3"> <div class="form-group"> <label> <b>{{ \'TAX_PERCENT\' | translate }}</b> (%)</label> <span class="form-control" disabled="disabled"> {{ $mdl.item.taxPercent }} </span> </div> </div> <div class="col-lg-3"> <div class="form-group"> <label> <b>{{ \'TAX_AMOUNT\' | translate }}</b> ({{ $mdl.currencyCode }})</label> <span class="form-control" disabled="disabled"> {{ $mdl.item.tax }} </span> </div> </div> <div class="col-lg-3"> <div class="form-group"> <label style="color:#00f"><b>{{ \'SUBTOTAL\' | translate }}</b> ({{ $mdl.currencyCode }})</label> <span class="form-control" style="border:2px solid #000;color:#000"> <b>{{ $mdl.item.subtotal }}</b> </span> </div> </div> </div> <br /> <div class="row"> <div class="col-lg-12"> <label><b>Remarks</b></label> <input type="text" class="form-control" style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.remarks" /> </div> </div> </div> <hr /> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="foodMenuModal.html"><form name="$mdl.menuForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="ADD_PRODUCTS_FROM_FOOD_MENU"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <label><b>{{ \'SELECT_A_FOOD_MENU\' | translate }}</b></label> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.menuForm.Product.$invalid && $mdl.menuForm.$submitted}"> <select name="FoodMenu" class="form-control" style="background:#FFFCED" ng-change="$mdl.selectedMenuChanged()" ng-options="b as b.description for b in $mdl.foodmenus | filter:{description: $mdl.itemSearch}" ng-model="$mdl.selectedMenu" required> <option value="">{{($mdl.lockButtons ? (\'LOADING...\' | translate) : ($mdl.foodmenus.length==0 ? ("&lt;&lt; " + (\'ENTER_A_KEYWORD_TO_SEARCH\' | translate)) : ("-- " + (\'SELECT_A_FOOD_MENU\' | translate) + " --")))}}</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.menuForm.FoodMenu.$error.required && $mdl.menuForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="creditApprovalModal.html"><form name="$mdl.approvalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-warning"> <h3 class="modal-title" id="modal-title" style="color:#000"> <i class="fa fa-exclamation-triangle"></i> Customer Credit Limit Exceeded </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <h3 style="color:#f00;line-height:150%;text-align:justify"> System detects that the selected Customer has exceeded the <b><u>Credit Limit</u></b>. Do you want to proceed with the confirmation of this Sales Order? </h3> <br /> <br /> <br /> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> APPROVE </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> DISAPPROVE </button> </div> </form></script><script type="text/ng-template" id="requestCreditApprovalModal.html"><form name="$mdl.approvalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-warning"> <h3 class="modal-title" id="modal-title" style="color:#000"> <i class="fa fa-exclamation-triangle"></i> Customer Credit Limit Exceeded </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <h3 style="color:#f00;line-height:150%;text-align:justify"> System detects that the selected Customer has exceeded the <b><u>Credit Limit</u></b></b>. Do you want to request for Manager Approval to confirm this Sales Order? </h3> <br /> <br /> <br /> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" style="width:100px" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> YES </button> <button class="btn btn-danger btn-with-icon" type="button" style="width:80px" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> NO </button> </div> </form></script><script type="text/ng-template" id="emailModal.html"><form name="$mdl.itemForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ \'EMAIL_SALES_ORDER_TO_CUSTOMER\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.TO.$invalid && ($mdl.itemForm.TO.$dirty || $mdl.itemForm.$submitted)}"> <label>{{ \'TO\' | translate }} <i class="fa fa-asterisk req"></i></label><br /> <small><i class="fa fa-info-circle"></i> {{ \'CUSTMOER_EMAIL_ADDRESS\' | translate }}</small><br /> <input type="text" class="form-control" name="TO" ng-model="$mdl.template.to" required /> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.TO.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label>{{ \'CC\' | translate }}</label><br /> <small><i class="fa fa-info-circle"></i> {{ \'SEPARATE_EACH_EMAIL_ADDRESS_USING_SEMI-COLON\' | translate }} (;)</small><br /> <input type="text" class="form-control" name="CC" ng-model="$mdl.template.cc" /> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label>{{ \'BCC\' | translate }}</label><br /> <small><i class="fa fa-info-circle"></i> {{ \'SEPARATE_EACH_EMAIL_ADDRESS_USING_SEMI-COLON\' | translate }} (;)</small><br /> <input type="text" class="form-control" name="BCC" ng-model="$mdl.template.bcc" /> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label>{{ \'REPLY-TO\' | translate }}</label><br /> <small><i class="fa fa-info-circle"></i> {{ \'THE_EMAIL_ADDRESS_THAT_RECIPIENT_WILL_REPLY_TO\' | translate }}</small><br /> <input type="text" class="form-control" name="ReplyTo" ng-model="$mdl.template.replyTo" /> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.Subject.$invalid && ($mdl.itemForm.Subject.$dirty || $mdl.itemForm.$submitted)}"> <label>{{ \'SUBJECT\' | translate }} <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Subject" ng-model="$mdl.template.subject" required /> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Subject.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.EmailContent.$invalid && ($mdl.itemForm.EmailContent.$dirty || $mdl.itemForm.$submitted)}"> <label>{{ \'EMAIL_CONTENT\' | translate }} <i class="fa fa-asterisk req"></i></label> <div text-angular ng-model="$mdl.template.content" placeholder="Type something here..."> </div> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.EmailContent.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> </div> <div class="modal-footer"> <a type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="mdl.lockButtons" confirmed-click="$mdl.confirmModal()" ng-confirm-click="Confirm send email?"> <i class="fa fa-envelope"></i> <span translate="SEND_EMAIL"></span> </a> <a class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </a> </div> </form></script><script type="text/ng-template" id="printModal.html"><form name="$mdl.printForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="PRINT_DOCUMENT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <table class="table table-striped" style="border:1px solid #ccc"> <thead> <tr> <th style="width:60px">#</th> <th><b translate="DOCUMENT_DESCRIPTION"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="item in $mdl.documentList"> <td>{{ $index+1 }})</td> <td>{{ item.name }}</td> <td> <a href class="btn btn-primary btn-with-icon btn-xs" style="width:90px" ng-click="$mdl.printDocument(item.id)" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-printer" ng-if="!$mdl.isLoading"></i> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> {{ \'PRINT\' | translate}} </a> </td> </tr> </tbody> </table> <div class="row"> <p>&nbsp;</p> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b> <span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/salesorders/salesOrderImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend>{{ \'IMPORT_SALES_ORDERS\' | translate }}</legend></fieldset><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile()" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend translate="IMPORT_GUIDELINES:"></legend><ol class="import"><li translate="YOU_NEED_TO_FOLLOW_THE_INSTRUCTION_BELOW_IF_YOU_ARE_NEW_TO_THE_RMS."></li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW_FILL_IT_UP_WITH_THE_DATA_FIRST_THEN_IMPORT_INTO_THE_RMS"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate()"><i class="fa fa-download"></i> <span translate="DOWNLOAD_SALES_ORDER_TEMPLATE"></span></a></li></ol></fieldset></div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong translate="FILE_UPLOADED_SUCCESSFULLY._CHOOSE_THE_OPTIONS_BELOW_AND_PROCEED_TO_IMPORT_THE_DATA."></strong></div><div><fieldset><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createSalesOrder" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'CREATE_NEW_SALES_ORDERS\' | translate }}</label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><br><br><fieldset><legend>{{ \'SALES_ORDER_DATA_PREVIEW\' | translate }}</legend></fieldset></div><div class="horizontal-scroll"><table class="table table-striped table-bordered table-nopadding" border="1" style="norder-collapse:collapse;font-size:8pt !important"><thead><tr><th style="width:60px">#</th><th><b>{{ \'IMPORT_NO\' | translate }}</b></th><th><b>{{ \'CUSTOMER_CODE\' | translate }}</b></th><th><b>{{ \'CUSTOMER_NAME\' | translate }}</b></th><th><b>{{ \'CUSTOMER_BRANCH_CODE\' | translate }}</b></th><th><b>{{ \'STATUS\' | translate }}</b></th><th><b>{{ \'ORDER_TITLE\' | translate }}</b></th><th><b>{{ \'DESCRIPTION\' | translate }}</b></th><th><b>{{ \'CUSTOMER_PO_NO\' | translate }}</b></th><th><b>{{ \'DELIVERY_DATE\' | translate }}</b></th><th><b>{{ \'IS_DIRECT_PRODUCTION\' | translate }}</b></th><th><b>{{ \'ITEM_TYPE\' | translate }}</b></th><th><b>{{ \'ITEM_CODE\' | translate }}</b></th><th><b>{{ \'ITEM_DESCRIPTION\' | translate }}</b></th><th><b>{{ \'QUANTITY\' | translate }}</b></th><th><b>{{ \'UOM\' | translate }}</b></th><th><b>{{ \'REMARKS\' | translate }}</b></th></tr><tr><th colspan="17">{{ \'TOTAL_RECORDS\' | translate }}: {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}})</td><td nowrap="nowrap">{{ row.importNo || \'\' }}</td><td nowrap="nowrap">{{ row.debtorCode || \'\' }}</td><td nowrap="nowrap">{{ row.debtorName || \'\' }}</td><td nowrap="nowrap">{{ row.debtorBranchCode || \'\' }}</td><td nowrap="nowrap">{{ row.status || \'-\' }}</td><td nowrap="nowrap">{{ row.orderTitle || \'-\' }}</td><td nowrap="nowrap">{{ row.description || \'-\' }}</td><td nowrap="nowrap">{{ row.customerPoNo || \'-\' }}</td><td nowrap="nowrap">{{ row.deliveryDate || \'-\' }}</td><td nowrap="nowrap">{{ row.isDirectProduction || \'-\' }}</td><td nowrap="nowrap">{{ row.itemType || \'-\' }}</td><td nowrap="nowrap">{{ row.itemCode || \'-\' }}</td><td nowrap="nowrap">{{ row.itemDescription || \'-\' }}</td><td nowrap="nowrap">{{ row.quantity || \'-\' }}</td><td nowrap="nowrap">{{ row.uom || \'-\' }}</td><td nowrap="nowrap">{{ row.remarks || \'-\' }}</td></tr><tr><td colspan="17" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="17">{{ \'TOTAL_RECORDS\' | translate}}: {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-6 col-lg-6"><em><small><i class="fa fa-info-circle"></i> <span translate="PROCESSING"></span>...</small></em><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><p translate="THE_DATA_IS_CURRENTLY_BEING_PROCESSED._IT_IS_SAFE_TO_LEAVE_THIS_PAGE_NOW."></p><p translate="YOU_WILL_RECEIVE_AN_EMAIL_NOTIFICATION_ABOUT_THE_IMPORT_RESULT_ONCE_THE_SERVER_HAS_FINISHED_PROCESSED_THE_DATA."></p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="salesorders.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a></div></form></div>');
$templateCache.put('app/pages/salesorders/salesorderCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/salesorders/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ui-sref="salesorders.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_SALES_ORDER"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="salesorders.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/salesorders/salesorderList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="SalesOrderListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table="" style="font-size:90%"><thead><tr><th colspan="18" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_ALL_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:30px;line-height:30px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="salesorders.create" rms-check-access="salesorders" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW"></span></a> <a href="" class="btn btn-warning btn-with-icon" ng-click="vm.showDownloadExcelModal()" rms-check-access="salesorders" rms-check-access-perm-type="EXPORT"><i class="fa fa-download"></i> <span translate="DOWNLOAD_EXCEL"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="salesorders.import" rms-check-access="salesorders" rms-check-access-perm-type="CREATE"><i class="fa fa-upload"></i><span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:30px;line-height:30px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="salesOrderNo">{{ \'ORDER_NO.\' | translate }}</th><th st-sort="createdDate" style="padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'ORDER_DATE\' | translate }}<br><small>(DD/MM/YYYY)</small></th><th st-sort="deliveryDate" style="padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'DELIVERY_DATE\' | translate }}<br><small>(DD/MM/YYYY)</small></th><th st-sort="sourceBranchName">{{ \'SOURCE_BRANCH\' | translate }}</th><th st-sort="destBranchName" style="padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'SALES\' | translate }} /<br>{{ \'DESTINATION_BRANCH\' | translate }}</th><th st-sort="debtorName">{{ \'CUSTOMER\' | translate }}</th><th>{{ \'ORDER_TITLE\' | translate }}<br><small>{{ \'DESCRIPTION\' | translate }}</small></th><th st-sort="grandTotal">{{ \'GRAND_TOTAL\' | translate }}</th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th st-sort="createdBy">{{ \'CREATED_BY\' | translate }}</th><th style="width:30px"></th><th style="width:30px"></th><th style="width:30px"></th><th style="width:30px"></th><th style="width:30px"></th><th style="width:30px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline"><input st-search="salesOrderNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="createdDate" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="deliveryDate" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="sourceBranchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="destBranchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="debtorName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="orderTitle" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="grandTotal" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="status" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="createdBy" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.data.length==0 && !vm.isLoading"><td colspan="18" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate}}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="18" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td nowrap="nowrap" style="padding-top:8px;padding-bottom:8px;line-height:110%">{{item.salesOrderNo}}<div ng-if="item.stockRequestNo!=null && item.stockRequestNo!=\'\'"><small>(S/R No: <b>{{item.stockRequestNo}}</b>)</small></div><div ng-if="item.originalDocNo!=null && item.originalDocNo!=\'\'"><small>(Ori Ref: <b>{{item.originalDocNo}}</b>)</small></div></td><td>{{item.createdDate | date: "dd/MM/yyyy"}}</td><td>{{item.deliveryDate | date: "dd/MM/yyyy" }} {{ ((item.deliveryDate | date: "hh:mma")=="12:00AM" ? \'\' : \'&nbsp;\' + (item.deliveryDate | date: "hh:mma")) }}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.sourceBranchName || \'-\' | uppercase}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.destBranchName | uppercase}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.debtorName || \'-\' | uppercase}}<div ng-if="item.debtorBranchName!=null"><small>{{ item.debtorBranchName }}</small></div></td><td style="padding-top:11px;padding-bottom:11px;line-height:110%"><b>{{item.name | uppercase}}</b><br><small>{{item.description || \'\' | uppercase}}</small></td><td><b>{{vm.currency}}&nbsp;{{(item.grandTotal || 0) | number:2}}</b></td><td><b><span ng-if="item.status==\'NEW\'" class="text-warning">{{item.status | translate | uppercase }}</span> <span ng-if="item.status==\'CONFIRMED\'" class="text-success">{{item.status | translate | uppercase }}</span> <span ng-if="item.status==\'IN PROCESS\'" class="text-primary">{{item.status | translate | uppercase }}</span> <span ng-if="item.status==\'CANCELLED\'" class="text-danger">{{item.status | translate | uppercase }}</span> <span ng-if="item.status.indexOf(\'COMPLETED\')!=-1" style="color:#000">{{item.status | translate | uppercase }}</span></b></td><td>{{item.createdBy | uppercase | limitTo: 15}} <span ng-if="item.createdBy.length>15">...</span></td><td></td><td style="text-align:center"><a href="" title="Email Sales Order" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#666" ng-if="item.status==\'CONFIRMED\' && item.status!=\'CANCELLED\'" ng-click="vm.emailSalesOrder(item.id)" rms-check-access="salesorders" rms-check-access-perm-type="EXPORT"><i class="fa fa-envelope"></i></a></td><td style="text-align:center"><a href="" title="Clone Order" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#000" ng-show="item.status!=\'NEW\' && item.status!=\'CANCELLED\'" confirmed-click="vm.cloneSalesOrder(item.id)" ng-confirm-click="Clone this order [{{item.salesOrderNo}}]?" rms-check-access="salesorders" rms-check-access-perm-type="CREATE"><i class="fa fa-copy text-warning"></i></a></td><td style="text-align:center"><a href="" title="Print S.O." class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt" ng-click="vm.showPrintDialog(item.id, item.salesOrderNo)" ng-show="item.status!=\'CANCELLED\'" rms-check-access="salesorders" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <small>SO</small></a></td><td style="text-align:center"><a href="" title="Print Invoice" class="btn btn-default btn-with-icon btn-xs btn-inv" style="font-size:11pt;" ng-click="vm.printInvoice(item.id, item.invoiceNo)" ng-if="item.status!=\'CANCELLED\' && item.status!=\'NEW\' && vm.isInvoiceEnabledForSO && item.invoiceNo && item.invoiceNo!=\'\'" rms-check-access="salesorders.invoice" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <small>INV</small></a></td><td style="text-align:center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="salesorders.update({id:item.id})" rms-check-access="salesorders" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="18" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:30px;line-height:30px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="emailModal.html"><form name="$mdl.itemForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ \'EMAIL_SALES_ORDER_TO_CUSTOMER\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.TO.$invalid && ($mdl.itemForm.TO.$dirty || $mdl.itemForm.$submitted)}"> <label>{{ \'TO\' | translate }} <i class="fa fa-asterisk req"></i></label><br /> <small><i class="fa fa-info-circle"></i> {{ \'CUSTMOER_EMAIL_ADDRESS\' | translate }}</small><br /> <input type="text" class="form-control" name="TO" ng-model="$mdl.template.to" required /> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.TO.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label>{{ \'CC\' | translate }}</label><br /> <small><i class="fa fa-info-circle"></i> {{ \'SEPARATE_EACH_EMAIL_ADDRESS_USING_SEMI-COLON\' | translate }} (;)</small><br /> <input type="text" class="form-control" name="CC" ng-model="$mdl.template.cc" /> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label>{{ \'BCC\' | translate }}</label><br /> <small><i class="fa fa-info-circle"></i> {{ \'SEPARATE_EACH_EMAIL_ADDRESS_USING_SEMI-COLON\' | translate }} (;)</small><br /> <input type="text" class="form-control" name="BCC" ng-model="$mdl.template.bcc" /> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label>{{ \'REPLY-TO\' | translate }}</label><br /> <small><i class="fa fa-info-circle"></i> {{ \'THE_EMAIL_ADDRESS_THAT_RECIPIENT_WILL_REPLY_TO\' | translate }}</small><br /> <input type="text" class="form-control" name="ReplyTo" ng-model="$mdl.template.replyTo" /> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.Subject.$invalid && ($mdl.itemForm.Subject.$dirty || $mdl.itemForm.$submitted)}"> <label>{{ \'SUBJECT\' | translate }} <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Subject" ng-model="$mdl.template.subject" required /> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Subject.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.EmailContent.$invalid && ($mdl.itemForm.EmailContent.$dirty || $mdl.itemForm.$submitted)}"> <label>{{ \'EMAIL_CONTENT\' | translate }} <i class="fa fa-asterisk req"></i></label> <div text-angular ng-model="$mdl.template.content" placeholder="Type something here..."> </div> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.EmailContent.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> </div> <div class="modal-footer"> <a type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="mdl.lockButtons" confirmed-click="$mdl.confirmModal()" ng-confirm-click="Confirm send email?"> <i class="fa fa-envelope"></i> <span translate="SEND_EMAIL"></span> </a> <a class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </a> </div> </form></script><script type="text/ng-template" id="printModal.html"><form name="$mdl.printForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="PRINT_DOCUMENT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <table class="table table-striped" style="border:1px solid #ccc"> <thead> <tr> <th style="width:60px">#</th> <th><b translate="DOCUMENT_DESCRIPTION"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="item in $mdl.documentList"> <td>{{ $index+1 }})</td> <td>{{ item.name }}</td> <td> <a href class="btn btn-primary btn-with-icon btn-xs" style="width:90px" ng-click="$mdl.printDocument(item.id)" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-printer" ng-if="!$mdl.isLoading"></i> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> {{ \'PRINT\' | translate}} </a> </td> </tr> </tbody> </table> <div class="row"> <p>&nbsp;</p> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b> <span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script><script type="text/ng-template" id="downloadModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="EXPORT_TRANSACTIONS_INTO_EXCEL"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <p translate="EXPORT_THE_SALES_ORDER_TRANSACTIONS_INTO_EXCEL_FORMAT_FOR_ACCOUNTING_SOFTWARE">.</p> <br /><br /> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"><span translate="EXPORT_NEW_TRANSACTIONS"></span></legend> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcel()"> <i class="fa fa-download"></i> {{\'GENERATE_EXCEL\' | translate}} </a> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <br /><br /> <div class="row" ng-if="$mdl.batchList.length!=0"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <select name="BatchNo" class="form-control" style="margin-bottom:10px;background:#fffeed" ng-model="$mdl.selectedBatchId" ng-change="$mdl.selectedBatchIdChanged()" ng-options="i as i for i in $mdl.batchList"> <option value="">={{ \'SELECT_ONE\' | translate }}=</option> </select> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcelPast()"> <i class="fa fa-download"></i> {{\'DOWNLOAD_EXCEL\' | translate}} </a> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <div class="row" ng-if="$mdl.batchList.length==0"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <br /> <center> <b class="text-primary"><i class="fa fa-info-circle"></i> <span translate="NO_PREVIOUS_EXPORT_AVAILABLE"></span></b> </center> </div> </div> </div> <hr /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/salesorders/salesorderUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/salesorders/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="salesorders.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-if="vm.originalStatus==\'NEW\'" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="salesorders.list" style="margin-right:30px" ng-if="vm.originalStatus==\'NEW\'" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-success btn-with-icon" ng-if="vm.mode==2 && (vm.originalStatus==\'IN PROCESS\')" ng-disabled="vm.lockButtons" ng-confirm-click="Are you sure to complete this Sales Order?" confirmed-click="vm.completeSalesOrder()"><i class="fa fa-check"></i> {{ \'COMPLETE_ORDER\' | translate }}</a> <a href="" class="btn btn-danger btn-with-icon" ng-if="vm.mode==2 && (vm.originalStatus==\'NEW\' || vm.originalStatus==\'CONFIRMED\')" ng-disabled="vm.lockButtons" ng-confirm-click="Are you sure to cancel this Sales Order?" confirmed-click="vm.cancelSalesOrder()"><i class="fa fa-trash"></i> <span translate="CANCEL_ORDER"></span></a> <a href="" class="btn btn-info btn-with-icon" style="margin-left:30px" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'CANCELLED\'" ng-disabled="vm.lockButtons" ng-click="vm.showPrintDialog()" rms-check-access="salesorders" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT_SALES_ORDER"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-if="vm.originalStatus!=\'CANCELLED\' && vm.originalStatus!=\'NEW\' && vm.isInvoiceEnabledForSO && vm.salesOrder.invoiceNo && vm.salesOrder.invoiceNo!=\'\'" ng-disabled="vm.lockButtons" ng-click="vm.printInvoice(vm.salesOrder.id, vm.salesOrder.invoiceNo)" rms-check-access="salesorders" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT_INVOICE"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.showEmailModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'CANCELLED\'" rms-check-access="salesorders" rms-check-access-perm-type="EXPORT"><i class="fa fa-envelope"></i> <span translate="EMAIL_S.O."></span></a> <a href="" class="btn btn-warning btn-with-icon pull-right" style="margin-left:30px" ng-if="vm.mode==2" confirmed-click="vm.cloneSalesOrder()" ng-confirm-click="Confirm to clone this Sales Order?" ng-disabled="vm.lockUpdateButtons" rms-check-access="salesorders" rms-check-access-perm-type="CREATE"><i class="fa fa-copy"></i> Clone Order</a></div></form>');
$templateCache.put('app/pages/signup/signup.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Customer Details"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p>Fill in all the information below:</p></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CompanyName.$invalid && (vm.dataForm.CompanyName.$dirty || vm.dataForm.$submitted)}"><label><b>Company / Organization Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CompanyName" placeholder="Company Name" autocomplete="off" ng-model="vm.signup.companyName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CompanyName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FirstName.$invalid && (vm.dataForm.FirstName.$dirty || vm.dataForm.$submitted)}"><label><b>First Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="FirstName" placeholder="First Name" autocomplete="off" ng-model="vm.signup.userFirstName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstName.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LastName.$invalid && (vm.dataForm.LastName.$dirty || vm.dataForm.$submitted)}"><label><b>Last Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="LastName" placeholder="Last Name" autocomplete="off" ng-model="vm.signup.userLastName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LastName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MobileNo.$invalid && (vm.dataForm.MobileNo.$dirty || vm.dataForm.$submitted)}"><label><b>Mobile Number</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="MobileNo" placeholder="Mobile No" autocomplete="off" ng-model="vm.signup.tel" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MobileNo.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Email.$invalid && (vm.dataForm.Email.$dirty || vm.dataForm.$submitted)}"><label><b>Email Address</b> <i class="fa fa-asterisk req"></i></label> <input type="email" class="form-control" name="Email" placeholder="Email Address" autocomplete="off" ng-model="vm.signup.userEmail" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.email">* Invalid Email Address</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceChoice.$invalid && (vm.dataForm.SourceChoice.$dirty || vm.dataForm.$submitted)}"><label><b>Select a source below</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="SourceChoice" ng-model="vm.signup.sourceChoice" required=""><option value="">-- Select a Source --</option><option value="5">F&amp;B Equipment Sdn Bhd</option><option value="1">F&amp;B General Catalogue</option><option value="2">CodeMax Website</option><option value="3">Search Engine</option><option value="4">Exhibitions / Events</option><option value="6">Others</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceChoice.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3" ng-if="vm.signup.sourceChoice==6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Source.$invalid && (vm.dataForm.Source.$dirty || vm.dataForm.$submitted)}"><label><b>Please specify the source:</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Source" ng-if="vm.signup.sourceChoice==6" ng-model="vm.signup.source" placeholder="write something" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Source.$error.required">* Required</span></div></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Complimentary"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p>Select one or more complimentary Recipe Categories for this customer:</p></div></div><div class="row" ng-if="vm.dataForm.$submitted && !vm.selectedCategories.length"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.$submitted && !vm.selectedCategories.length}"><span class="help-block">* Choose at least one category</span></div></div></div><div class="row" ng-repeat="c in vm.categories"><div class="col-md-12"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" name="Category" checklist-model="vm.selectedCategories" checklist-value="c" checklist-change="vm.dataForm.Category.$setValidity(\'required\', vm.selectedCategories.length > 0)" ng-required="!vm.selectedCategories.length"> <label><span><b>{{c.name}}</b></span></label></div></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab></uib-tabset></div></div></div><div style="padding-bottom:30px"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> Submit</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> Back</a></div></form></div>');
$templateCache.put('app/pages/signup/thankyou.html','<main class="auth-main" style="padding-top:20px;padding-bottom:10px"><div class="auth-block" style="width:500px;background: #ebf1f6;background: -moz-linear-gradient(top, #ebf1f6 0%, #abd3ee 50%, #89c3eb 51%, #d5ebfb 100%);background: -webkit-linear-gradient(top, #ebf1f6 0%,#abd3ee 50%,#89c3eb 51%,#d5ebfb 100%);background: linear-gradient(to bottom, #ebf1f6 0%,#abd3ee 50%,#89c3eb 51%,#d5ebfb 100%);filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#ebf1f6\', endColorstr=\'#d5ebfb\',GradientType=0 );"><h1 style="margin-bottom:5px;font-size:18pt;color:#000"><img src="{{vm.logo}}" alt="FoodTec Logo" style="height:56px"><br><br><b>Congratulation!</b></h1><h2><center>Your regisration is successful!</center></h2><br><br><h3><center>You will receive an email with your account and login credentials. It also contains some useful links to the User Guide and Videos.</center></h3><br><br><center><a href="#/login" class="btn btn-lg btn-with-icon btn-primary"><i class="fa fa-chevron-left"></i> Back to Login</a></center></div></main>');
$templateCache.put('app/pages/signupims/signupIMS.html','<div class="form-content"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Customer Info"><div class="row"><div class="col-md-12" style="padding-bottom:15px;"><p><i class="fa fa-info-circle"></i> Fill in the Customer Information below:</p></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CompanyName.$invalid && (vm.dataForm.CompanyName.$dirty || vm.dataForm.$submitted)}"><label><b>Company / Organization Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CompanyName" placeholder="Company Name" autocomplete="off" ng-model="vm.signup.companyName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CompanyName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CompanyRegNo.$invalid && (vm.dataForm.CompanyRegNo.$dirty || vm.dataForm.$submitted)}"><label><b>Company Registration No.</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CompanyRegNo" placeholder="Company Registration No." autocomplete="off" ng-model="vm.signup.companyRegNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CompanyRegNo.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ContactPerson.$invalid && (vm.dataForm.ContactPerson.$dirty || vm.dataForm.$submitted)}"><label><b>Contact Person</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ContactPerson" placeholder="Contact Person" autocomplete="off" ng-model="vm.signup.contactPerson" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ContactPerson.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Address1.$invalid && (vm.dataForm.Address1.$dirty || vm.dataForm.$submitted)}"><label><b>Address 1</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Address1" placeholder="Address 1" autocomplete="off" ng-model="vm.signup.address1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Address1.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Address 2</b></label> <input type="text" class="form-control" name="Address2" placeholder="Address 2" autocomplete="off" ng-model="vm.signup.address2"></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Address 3</b></label> <input type="text" class="form-control" name="Address3" placeholder="Address 3" autocomplete="off" ng-model="vm.signup.address3"></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PostalCode.$invalid && (vm.dataForm.PostalCode.$dirty || vm.dataForm.$submitted)}"><label><b>Postal Code</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="PostalCode" placeholder="Postal Code" autocomplete="off" ng-model="vm.signup.postCode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PostalCode.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.State.$invalid && (vm.dataForm.State.$dirty || vm.dataForm.$submitted)}"><label><b>State</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="State" placeholder="State" autocomplete="off" ng-model="vm.signup.state" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.State.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Country.$invalid && (vm.dataForm.Country.$dirty || vm.dataForm.$submitted)}"><label><b>Country</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Country" ng-model="vm.signup.country" required=""><option value="MALAYSIA" selected="selected">MALAYSIA</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Country.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Telephone.$invalid && (vm.dataForm.Telephone.$dirty || vm.dataForm.$submitted)}"><label><b>Telephone</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Telephone" placeholder="Telephone" autocomplete="off" ng-model="vm.signup.tel" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Telephone.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Fax</b></label> <input type="text" class="form-control" name="Fax" placeholder="Fax" autocomplete="off" ng-model="vm.signup.fax"></div></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Manager User"><div class="row"><div class="col-md-12" style="padding-bottom:15px;"><p><i class="fa fa-info-circle"></i> Fill in the Manager User information below for default login.</p></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FirstName.$invalid && (vm.dataForm.FirstName.$dirty || vm.dataForm.$submitted)}"><label><b>First Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="FirstName" placeholder="First Name" autocomplete="off" ng-model="vm.signup.userFirstName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstName.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LastName.$invalid && (vm.dataForm.LastName.$dirty || vm.dataForm.$submitted)}"><label><b>Last Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="LastName" placeholder="Last Name" autocomplete="off" ng-model="vm.signup.userLastName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LastName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Email.$invalid && (vm.dataForm.Email.$dirty || vm.dataForm.$submitted)}"><label><b>Email Address</b> <i class="fa fa-asterisk req"></i></label> <input type="email" class="form-control" name="Email" placeholder="Email Address" autocomplete="off" ng-model="vm.signup.userEmail" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.email">* Invalid Email Address</span></div></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Billing Info"><div class="row"><div class="col-md-12" style="padding-bottom:15px;"><p>Fill in the Billing Information below:</p></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingContactPerson.$invalid && (vm.dataForm.BillingContactPerson.$dirty || vm.dataForm.$submitted)}"><label><b>Billing Contact Person</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BillingContactPerson" placeholder="Billing Contact Person" autocomplete="off" ng-model="vm.signup.billingContact" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingContactPerson.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingEmail.$invalid && (vm.dataForm.BillingEmail.$dirty || vm.dataForm.$submitted)}"><label><b>Billing Email Address</b> <i class="fa fa-asterisk req"></i></label> <input type="email" class="form-control" name="BillingEmail" placeholder="Billing Email Address" autocomplete="off" ng-model="vm.signup.billingEmail" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingEmail.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingEmail.$error.email">* Invalid Email Address</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingIntervalType.$invalid && (vm.dataForm.BillingIntervalType.$dirty || vm.dataForm.$submitted)}"><label><b>Billing Interval Type</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="BillingIntervalType" ng-model="vm.selectedBillingIntervalType" ng-change="vm.selectedBillingIntervalTypeChanged()" ng-options="b as b.name for b in vm.billingIntervalTypes" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingIntervalType.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ContractStartDate.$invalid && (vm.dataForm.ContractStartDate.$dirty || vm.dataForm.$submitted)}"><label><b>Contract {{ \'START_DATE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.signup.contractStartDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="ContractStartDate" autocomplete="off" ng-model="vm.signup.contractStartDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ContractStartDate.$error.required">* Required</span></div></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Subscription Info"><div class="row"><div class="col-md-12" style="padding-bottom:15px;"><p>Fill in the Subscription Information below:</p></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Is this POC ?</b></label><div><toggle ng-model="vm.signup.isPOC" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Require Sim Card?</b></label><div><toggle ng-model="vm.signup.hasSimCard" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.signup.hasSimCard"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumOfSimCard.$invalid && (vm.dataForm.NumOfSimCard.$dirty || vm.dataForm.$submitted)}"><label><b>No. of SIM Cards</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="NumOfSimCard" placeholder="No. of SIM Cards" autocomplete="off" ng-model="vm.signup.numOfSimCard" ng-required="vm.signup.hasSimCard" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSimCard.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSimCard.$error.min">* Minimum is zero</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSimCard.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumOfGateway.$invalid && (vm.dataForm.NumOfGateway.$dirty || vm.dataForm.$submitted)}"><label><b>No. of Gateways</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="NumOfGateway" placeholder="No. of Gateways" autocomplete="off" ng-model="vm.signup.numOfGateway" required="" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfGateway.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfGateway.$error.min">* Minimum is zero</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfGateway.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.GatewayRate.$invalid && (vm.dataForm.GatewayRate.$dirty || vm.dataForm.$submitted)}"><label><b>Rate (RM)</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="GatewayRate" ng-model="vm.selectedGatewayRate" ng-change="vm.selectedGatewayRateChanged()" ng-options="r as r.name for r in vm.gatewayRates" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.GatewayRate.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumOfSensorNormal.$invalid && (vm.dataForm.NumOfSensorNormal.$dirty || vm.dataForm.$submitted)}"><label><b>No. of Sensors</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="NumOfSensorNormal" placeholder="No. of Sensors (Normal)" autocomplete="off" ng-model="vm.signup.numOfSensorNormal" required="" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSensorNormal.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSensorNormal.$error.min">* Minimum is zero</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSensorNormal.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NormalSensorRate.$invalid && (vm.dataForm.NormalSensorRate.$dirty || vm.dataForm.$submitted)}"><label><b>Rate (RM)</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="NormalSensorRate" ng-model="vm.selectedNormalSensorRate" ng-change="vm.selectedNormalSensorRateChanged()" ng-options="r as r.name for r in vm.normalSensorRates" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NormalSensorRate.$error.required">* Required</span></div></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab></uib-tabset></div></div></div><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> Submit</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> Back</a></div></form></div>');
$templateCache.put('app/pages/signupimsassign/signupIMSassign.html','<div class="form-content"><form name="vm.dataForm" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Assignment"><legend style="height:32.4px;line-height:32.4px">Step #1 - Enter the Company Unique Code:</legend><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><input type="text" class="form-control" name="CompanyUniqueCode" placeholder="Company Unique Code" autocomplete="off" ng-disabled="vm.lockButtons || vm.isCompanyFound" ng-model="vm.uniqueCode" ng-required="!vm.isCompanyFound"></div></div><div class="col-md-3 col-lg-3"><button type="button" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons || vm.isCompanyFound" ng-click="vm.checkCompany()"><i class="fa fa-search"></i> Load</button> <button type="button" class="btn btn-danger btn-with-icon" ng-if="vm.isCompanyFound" ng-click="vm.resetCompany()" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> Reset</button></div></div><div class="row" ng-if="vm.isCompanyFound"><div class="col-md-5 col-lg-5"><div style="padding:15px;background:#f0f0f0"><b style="font-size:18pt">{{vm.company.name}}</b></div></div></div><div ng-if="vm.isCompanyFound"><br><br><legend style="height:32.4px;line-height:32.4px">Step #2 - Enter a Device UID:</legend><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><input type="text" class="form-control" name="CompanyUniqueCode" placeholder="Device UID" autocomplete="off" ng-disabled="vm.lockButtons || vm.isDeviceFound" ng-model="vm.deviceUID" ng-required="!vm.isDeviceFound"></div></div><div class="col-md-2 col-lg-2"><button type="button" class="btn btn-primary btn-with-icon" ng-click="vm.checkDeviceUID()" ng-disabled="vm.lockButtons || vm.isDeviceFound"><i class="fa fa-search"></i> Check</button></div></div></div><div ng-if="vm.isDeviceFound"><br><legend style="height:32.4px;line-height:32.4px">Step #3 - Select a Device:</legend><small>(Note: only unassigned devices will be listed here)</small><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceList.$invalid && (vm.dataForm.DeviceList.$dirty || vm.dataForm.$submitted)}"><select class="form-control" name="DeviceList" ng-model="vm.selectedDevice" ng-options="b as (b.deviceUID + \' - \' + b.deviceUUID + \' - (\' + b.model + \') \' + b.description) for b in vm.deviceList" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceList.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><button type="button" class="btn btn-primary btn-with-icon" ng-click="vm.selectDevice()" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> Assign</button> <button type="button" class="btn btn-danger btn-with-icon" ng-click="vm.clearDevice()" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> Clear</button></div></div></div><div class="row"><div class="col-md-4 col-lg-4"></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab></uib-tabset></div></div></div></form></div>');
$templateCache.put('app/pages/signuprms/signupRMS.html','<div class="form-content"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Customer Info"><div class="row"><div class="col-md-12" style="padding-bottom:15px;"><p><i class="fa fa-info-circle"></i> Fill in the Customer Information below:</p></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CompanyName.$invalid && (vm.dataForm.CompanyName.$dirty || vm.dataForm.$submitted)}"><label><b>Company / Organization Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CompanyName" placeholder="Company Name" autocomplete="off" ng-model="vm.signup.companyName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CompanyName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CompanyRegNo.$invalid && (vm.dataForm.CompanyRegNo.$dirty || vm.dataForm.$submitted)}"><label><b>Company Registration No.</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CompanyRegNo" placeholder="Company Registration No." autocomplete="off" ng-model="vm.signup.companyRegNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CompanyRegNo.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ContactPerson.$invalid && (vm.dataForm.ContactPerson.$dirty || vm.dataForm.$submitted)}"><label><b>Contact Person</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ContactPerson" placeholder="Contact Person" autocomplete="off" ng-model="vm.signup.contactPerson" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ContactPerson.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Address1.$invalid && (vm.dataForm.Address1.$dirty || vm.dataForm.$submitted)}"><label><b>Address 1</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Address1" placeholder="Address 1" autocomplete="off" ng-model="vm.signup.address1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Address1.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Address 2</b></label> <input type="text" class="form-control" name="Address2" placeholder="Address 2" autocomplete="off" ng-model="vm.signup.address2"></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Address 3</b></label> <input type="text" class="form-control" name="Address3" placeholder="Address 3" autocomplete="off" ng-model="vm.signup.address3"></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PostalCode.$invalid && (vm.dataForm.PostalCode.$dirty || vm.dataForm.$submitted)}"><label><b>Postal Code</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="PostalCode" placeholder="Postal Code" autocomplete="off" ng-model="vm.signup.postCode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PostalCode.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.State.$invalid && (vm.dataForm.State.$dirty || vm.dataForm.$submitted)}"><label><b>State</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="State" placeholder="State" autocomplete="off" ng-model="vm.signup.state" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.State.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Country.$invalid && (vm.dataForm.Country.$dirty || vm.dataForm.$submitted)}"><label><b>Country</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Country" ng-model="vm.signup.country" required=""><option value="MALAYSIA" selected="selected">MALAYSIA</option><option value="SINGAPORE">SINGAPORE</option><option value="PHILIPPINES">PHILIPPINES</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Country.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Telephone.$invalid && (vm.dataForm.Telephone.$dirty || vm.dataForm.$submitted)}"><label><b>Telephone</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Telephone" placeholder="Telephone" autocomplete="off" ng-model="vm.signup.tel" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Telephone.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Fax</b></label> <input type="text" class="form-control" name="Fax" placeholder="Fax" autocomplete="off" ng-model="vm.signup.fax"></div></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Manager User"><div class="row"><div class="col-md-12" style="padding-bottom:15px;"><p><i class="fa fa-info-circle"></i> Fill in the Manager User information below for default login.</p></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FirstName.$invalid && (vm.dataForm.FirstName.$dirty || vm.dataForm.$submitted)}"><label><b>First Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="FirstName" placeholder="First Name" autocomplete="off" ng-model="vm.signup.userFirstName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstName.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LastName.$invalid && (vm.dataForm.LastName.$dirty || vm.dataForm.$submitted)}"><label><b>Last Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="LastName" placeholder="Last Name" autocomplete="off" ng-model="vm.signup.userLastName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LastName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Email.$invalid && (vm.dataForm.Email.$dirty || vm.dataForm.$submitted)}"><label><b>Email Address</b> <i class="fa fa-asterisk req"></i></label> <input type="email" class="form-control" name="Email" placeholder="Email Address" autocomplete="off" ng-model="vm.signup.userEmail" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.email">* Invalid Email Address</span></div></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Billing Info"><div class="row"><div class="col-md-12" style="padding-bottom:15px;"><p>Fill in the Billing Information below:</p></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingContactPerson.$invalid && (vm.dataForm.BillingContactPerson.$dirty || vm.dataForm.$submitted)}"><label><b>Billing Contact Person</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BillingContactPerson" placeholder="Billing Contact Person" autocomplete="off" ng-model="vm.signup.billingContact" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingContactPerson.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingEmail.$invalid && (vm.dataForm.BillingEmail.$dirty || vm.dataForm.$submitted)}"><label><b>Billing Email Address</b> <i class="fa fa-asterisk req"></i></label> <input type="email" class="form-control" name="BillingEmail" placeholder="Billing Email Address" autocomplete="off" ng-model="vm.signup.billingEmail" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingEmail.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingEmail.$error.email">* Invalid Email Address</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingIntervalType.$invalid && (vm.dataForm.BillingIntervalType.$dirty || vm.dataForm.$submitted)}"><label><b>Billing Interval Type</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="BillingIntervalType" ng-model="vm.selectedBillingIntervalType" ng-change="vm.selectedBillingIntervalTypeChanged()" ng-options="b as b.name for b in vm.billingIntervalTypes" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingIntervalType.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><label><b>Is Billable?</b> <i class="fa fa-asterisk req"></i></label><div><toggle ng-model="vm.signup.isBillable" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ContractStartDate.$invalid && (vm.dataForm.ContractStartDate.$dirty || vm.dataForm.$submitted)}"><label><b>Contract {{ \'START_DATE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.signup.contractStartDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="ContractStartDate" autocomplete="off" ng-model="vm.signup.contractStartDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ContractStartDate.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"></div></div><div class="row"><div class="col-md-6 col-lg-6"><span style="color:#00f"><u>Note</u>:<br><ul style="padding-left:14px"><li>For <b>RMS FULL</b> edition, the Contract {{ \'START_DATE\' | translate }} (next billing date) should be about<u><b>3</b> months</u>from today.</li></ul><span class="text-danger">### Check with Project Team Manager for date if you are not sure. ###</span></span></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Subscription Info"><div class="row"><div class="col-md-12" style="padding-bottom:25px;"><p>Fill in the Subscription Information below:</p></div></div><div class="row"><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Select a RMS Edition:</legend><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.RmsTypes.$invalid && (vm.dataForm.RmsTypes.$dirty || vm.dataForm.$submitted)}"><select class="form-control" style="height:50px;font-size:20pt;font-weight:bold" ng-change="vm.selectedRmsTypeChanged()" ng-options="d as d.name for d in vm.rmsTypes" ng-model="vm.selectedRmsType" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RmsTypes.$error.required">* Required</span></div></div></div><p><br></p><legend style="height:32.4px;line-height:32.4px">Base Susbcription:</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>No. of Standard Users</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">{{ vm.selectedRmsType.stdUserQty }}</b></span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Monthly Subscription Fee (RM)</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">{{ vm.selectedRmsType.baseFees | number }}</b></span></div></div></div><p><br></p><legend style="height:32.4px;line-height:32.4px">Additional Susbcription:</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ExtraStdUser.$invalid && (vm.dataForm.ExtraStdUser.$dirty || vm.dataForm.$submitted)}"><label><b>Extra Standard User(s)</b></label> <input type="number" class="form-control" name="ExtraStdUser" autocomplete="off" style="font-size:12pt" ng-model="vm.extraStdUserCount" required="" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ExtraStdUser.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ExtraStdUser.$error.min">* Minimum is zero</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ExtraStdUser.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Monthly Subscription Fee (RM)</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">+ {{ vm.extraStdUserCount * (vm.selectedRmsType.extraStdUserFee||0) | number }}</b> &nbsp;&nbsp; (RM{{vm.selectedRmsType.extraStdUserFee||0|number:0}}/user)</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ExtraLtdUser.$invalid && (vm.dataForm.ExtraLtdUser.$dirty || vm.dataForm.$submitted)}"><label><b>Extra Limited User(s)</b></label> <input type="number" class="form-control" name="ExtraLtdUser" autocomplete="off" style="font-size:12pt" ng-model="vm.extraLtdUserCount" required="" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ExtraLtdUser.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ExtraLtdUser.$error.min">* Minimum is zero</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ExtraLtdUser.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Monthly Subscription Fee (RM)</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">+ {{ vm.extraLtdUserCount * 50 | number }}</b> &nbsp;&nbsp; (RM50/user)</span></div></div></div></div><div class="col-md-1 col-lg-1">&nbsp;</div><div class="col-md-6 col-lg-6"><legend style="height:32.4px;line-height:32.4px"><div style="float:left">Smart IOT Susbcription:</div><div style="float:left;margin-left:15px"><toggle ng-model="vm.hasIMS" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success btn-sm" offstyle="btn-default btn-sm"></toggle></div></legend><div class="row" ng-if="vm.hasIMS"><div class="col-lg-8"><div class="form-group"><label><b>Require Sim Card?</b></label><div><toggle ng-model="vm.ims.hasSimCard" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.hasIMS && vm.ims.hasSimCard"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumOfSimCard.$invalid && (vm.dataForm.NumOfSimCard.$dirty || vm.dataForm.$submitted)}"><label><b>No. of SIM Cards</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="NumOfSimCard" placeholder="No. of SIM Cards" autocomplete="off" ng-model="vm.ims.numOfSimCard" ng-required="vm.hasIMS && vm.ims.hasSimCard" min="1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSimCard.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSimCard.$error.min">* Minimum is one</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSimCard.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Monthly Subscription Fee (RM)</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">{{ (!(vm.hasIMS && vm.ims.hasSimCard) ? 0 : (vm.ims.numOfSimCard * vm.ims.simCardRate || 0)) | number }}</b></span></div></div></div><div class="row" ng-if="vm.hasIMS"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumOfGateway.$invalid && (vm.dataForm.NumOfGateway.$dirty || vm.dataForm.$submitted)}"><label><b>No. of Gateways</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="NumOfGateway" autocomplete="off" ng-model="vm.ims.numOfGateway" ng-required="vm.hasIMS" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfGateway.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfGateway.$error.min">* Minimum is zero</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfGateway.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.GatewayRate.$invalid && (vm.dataForm.GatewayRate.$dirty || vm.dataForm.$submitted)}"><label><b>Rate (RM)</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="GatewayRate" ng-model="vm.selectedGatewayRate" ng-change="vm.selectedGatewayRateChanged()" ng-options="r as r.name for r in vm.gatewayRates" ng-required="vm.hasIMS"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.GatewayRate.$error.required">* Required</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Monthly Subscription Fee (RM)</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">{{ (!vm.hasIMS ? 0 : (vm.ims.numOfGateway * vm.ims.gatewayRate || 0)) | number }}</b></span></div></div></div><div class="row" ng-if="vm.hasIMS"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumOfSensor.$invalid && (vm.dataForm.NumOfSensor.$dirty || vm.dataForm.$submitted)}"><label><b>No. of Sensors</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="NumOfSensor" autocomplete="off" ng-model="vm.ims.numOfSensor" ng-required="vm.hasIMS" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSensor.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSensor.$error.min">* Minimum is zero</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSensor.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NormalSensorRate.$invalid && (vm.dataForm.NormalSensorRate.$dirty || vm.dataForm.$submitted)}"><label><b>Rate (RM)</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="NormalSensorRate" ng-model="vm.selectedSensorRate" ng-change="vm.selectedSensorRateChanged()" ng-options="r as r.name for r in vm.normalSensorRates" ng-required="vm.hasIMS"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NormalSensorRate.$error.required">* Required</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Monthly Subscription Fee (RM)</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">{{ (!vm.hasIMS ? 0 : (vm.ims.numOfSensor * vm.ims.sensorRate || 0)) | number }}</b></span></div></div></div></div></div><p><br></p><legend style="height:32.4px;line-height:32.4px">Summary:</legend><div class="row"><div class="col-md-2 col-lg-2"><label><b>Total Standard Users</b></label><h1 style="color:#00f">{{ (vm.selectedRmsType.stdUserQty||0) + vm.extraStdUserCount }}</h1></div><div class="col-md-2 col-lg-2"><label><b>Total Limited Users</b></label><h1 style="color:#00f">{{ vm.extraLtdUserCount }}</h1></div><div class="col-md-2 col-lg-2"><label><b>Total Monthly Fees</b></label><h1 style="color:#00f">RM {{ (vm.selectedRmsType.baseFees||0) + (vm.extraStdUserCount * (vm.selectedRmsType.extraStdUserFee||0)) + (vm.extraLtdUserCount * 50) + (!vm.hasIMS ? 0 : (vm.ims.hasFloorView ? vm.ims.floorViewRate : 0)) + (!vm.hasIMS ? 0 : (vm.ims.hasSimCard ? (vm.ims.numOfSimCard * vm.ims.simCardRate || 0) : 0)) + (!vm.hasIMS ? 0 : (vm.ims.numOfGateway * vm.ims.gatewayRate || 0)) + (!vm.hasIMS ? 0 : (vm.ims.numOfSensor * vm.ims.sensorRate || 0)) | number}}</h1></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab></uib-tabset></div></div></div><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> Submit</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> Back</a></div></form></div>');
$templateCache.put('app/pages/signuprms_dealer/signupRMS_dealer.html','<div class="form-content"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Customer Info"><div class="row"><div class="col-md-12" style="padding-bottom:15px;"><p><i class="fa fa-info-circle"></i> Fill in the Customer Information below:</p></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CompanyName.$invalid && (vm.dataForm.CompanyName.$dirty || vm.dataForm.$submitted)}"><label><b>Company / Organization Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CompanyName" placeholder="Company Name" autocomplete="off" ng-model="vm.signup.companyName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CompanyName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CompanyRegNo.$invalid && (vm.dataForm.CompanyRegNo.$dirty || vm.dataForm.$submitted)}"><label><b>Company Registration No.</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CompanyRegNo" placeholder="Company Registration No." autocomplete="off" ng-model="vm.signup.companyRegNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CompanyRegNo.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ContactPerson.$invalid && (vm.dataForm.ContactPerson.$dirty || vm.dataForm.$submitted)}"><label><b>Contact Person</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ContactPerson" placeholder="Contact Person" autocomplete="off" ng-model="vm.signup.contactPerson" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ContactPerson.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Address1.$invalid && (vm.dataForm.Address1.$dirty || vm.dataForm.$submitted)}"><label><b>Address 1</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Address1" placeholder="Address 1" autocomplete="off" ng-model="vm.signup.address1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Address1.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Address 2</b></label> <input type="text" class="form-control" name="Address2" placeholder="Address 2" autocomplete="off" ng-model="vm.signup.address2"></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Address 3</b></label> <input type="text" class="form-control" name="Address3" placeholder="Address 3" autocomplete="off" ng-model="vm.signup.address3"></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PostalCode.$invalid && (vm.dataForm.PostalCode.$dirty || vm.dataForm.$submitted)}"><label><b>Postal Code</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="PostalCode" placeholder="Postal Code" autocomplete="off" ng-model="vm.signup.postCode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PostalCode.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.State.$invalid && (vm.dataForm.State.$dirty || vm.dataForm.$submitted)}"><label><b>State</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="State" placeholder="State" autocomplete="off" ng-model="vm.signup.state" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.State.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Country.$invalid && (vm.dataForm.Country.$dirty || vm.dataForm.$submitted)}"><label><b>Country</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Country" ng-model="vm.signup.country" required=""><option value="MALAYSIA" selected="selected">MALAYSIA</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Country.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Telephone.$invalid && (vm.dataForm.Telephone.$dirty || vm.dataForm.$submitted)}"><label><b>Telephone</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Telephone" placeholder="Telephone" autocomplete="off" ng-model="vm.signup.tel" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Telephone.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Fax</b></label> <input type="text" class="form-control" name="Fax" placeholder="Fax" autocomplete="off" ng-model="vm.signup.fax"></div></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Manager User"><div class="row"><div class="col-md-12" style="padding-bottom:15px;"><p><i class="fa fa-info-circle"></i> Fill in the Manager User information below for default login.</p></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FirstName.$invalid && (vm.dataForm.FirstName.$dirty || vm.dataForm.$submitted)}"><label><b>First Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="FirstName" placeholder="First Name" autocomplete="off" ng-model="vm.signup.userFirstName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstName.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LastName.$invalid && (vm.dataForm.LastName.$dirty || vm.dataForm.$submitted)}"><label><b>Last Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="LastName" placeholder="Last Name" autocomplete="off" ng-model="vm.signup.userLastName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LastName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Email.$invalid && (vm.dataForm.Email.$dirty || vm.dataForm.$submitted)}"><label><b>Email Address</b> <i class="fa fa-asterisk req"></i></label> <input type="email" class="form-control" name="Email" placeholder="Email Address" autocomplete="off" ng-model="vm.signup.userEmail" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.email">* Invalid Email Address</span></div></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Subscription / Billing"><div class="row"><div class="col-md-12" style="padding-bottom:25px;"><p>Fill in the Subscription Information below:</p></div></div><div class="row"><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Select a RMS Edition:</legend><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.RmsTypes.$invalid && (vm.dataForm.RmsTypes.$dirty || vm.dataForm.$submitted)}"><select class="form-control" style="height:50px;font-size:20pt;font-weight:bold" ng-change="vm.selectedRmsTypeChanged()" ng-options="d as d.name for d in vm.rmsTypes" ng-model="vm.selectedRmsType" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RmsTypes.$error.required">* Required</span></div></div></div><p><br></p><legend style="height:32.4px;line-height:32.4px">Base Subscription:</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>No. of Standard Users</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">{{ vm.selectedRmsType.stdUserQty }}</b></span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Monthly Subscription Fee (RM)</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">{{ vm.selectedRmsType.baseFees | number }}</b></span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingContactPerson.$invalid && (vm.dataForm.BillingContactPerson.$dirty || vm.dataForm.$submitted)}"><label><b>Billing Contact Person</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BillingContactPerson" placeholder="Billing Contact Person" autocomplete="off" ng-model="vm.signup.billingContact" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingContactPerson.$error.required">* Required</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingEmail.$invalid && (vm.dataForm.BillingEmail.$dirty || vm.dataForm.$submitted)}"><label><b>Billing Email Address</b> <i class="fa fa-asterisk req"></i></label> <input type="email" class="form-control" name="BillingEmail" placeholder="Billing Email Address" autocomplete="off" ng-model="vm.signup.billingEmail" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingEmail.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingEmail.$error.email">* Invalid Email Address</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingIntervalType.$invalid && (vm.dataForm.BillingIntervalType.$dirty || vm.dataForm.$submitted)}"><label><b>Billing Interval Type</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="BillingIntervalType" ng-model="vm.selectedBillingIntervalType" ng-change="vm.selectedBillingIntervalTypeChanged()" ng-options="b as b.name for b in vm.selectedRmsType.billingIntervalTypes" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingIntervalType.$error.required">* Required</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ContractStartDate.$invalid && (vm.dataForm.ContractStartDate.$dirty || vm.dataForm.$submitted)}"><label><b>Contract {{ \'START_DATE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.signup.contractStartDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="ContractStartDate" autocomplete="off" ng-model="vm.signup.contractStartDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ContractStartDate.$error.required">* Required</span></div></div></div><p ng-hide="true"><br></p><legend style="height:32.4px;line-height:32.4px" ng-hide="true">Additional Susbcription:</legend><div class="row" ng-hide="true"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ExtraStdUser.$invalid && (vm.dataForm.ExtraStdUser.$dirty || vm.dataForm.$submitted)}"><label><b>Extra Standard User(s)</b></label> <input type="number" class="form-control" name="ExtraStdUser" autocomplete="off" style="font-size:12pt" ng-model="vm.extraStdUserCount" required="" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ExtraStdUser.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ExtraStdUser.$error.min">* Minimum is zero</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ExtraStdUser.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Monthly Subscription Fee (RM)</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">+ {{ vm.extraStdUserCount * (vm.selectedRmsType.extraStdUserFee||0) | number }}</b> &nbsp;&nbsp; (RM{{vm.selectedRmsType.extraStdUserFee||0|number:0}}/user)</span></div></div></div><div class="row" ng-hide="true"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ExtraLtdUser.$invalid && (vm.dataForm.ExtraLtdUser.$dirty || vm.dataForm.$submitted)}"><label><b>Extra Limited User(s)</b></label> <input type="number" class="form-control" name="ExtraLtdUser" autocomplete="off" style="font-size:12pt" ng-model="vm.extraLtdUserCount" required="" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ExtraLtdUser.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ExtraLtdUser.$error.min">* Minimum is zero</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ExtraLtdUser.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Monthly Subscription Fee (RM)</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">+ {{ vm.extraLtdUserCount * 50 | number }}</b> &nbsp;&nbsp; (RM50/user)</span></div></div></div></div><div class="col-md-1 col-lg-1">&nbsp;</div><div class="col-md-6 col-lg-6" ng-hide="true"><legend style="height:32.4px;line-height:32.4px"><div style="float:left">IMS Susbcription:</div><div style="float:left;margin-left:15px"><toggle ng-model="vm.hasIMS" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success btn-sm" offstyle="btn-default btn-sm"></toggle></div></legend><div class="row" ng-if="vm.hasIMS"><div class="col-lg-8"><div class="form-group"><label><b>Activate Floor View ?</b></label><div><toggle ng-model="vm.ims.hasFloorView" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Monthly Subscription Fee (RM)</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">{{ (!vm.ims.hasFloorView ? 0 : vm.ims.floorViewRate) | number }}</b></span></div></div></div><div class="row" ng-if="vm.hasIMS"><div class="col-lg-8"><div class="form-group"><label><b>Require Sim Card?</b></label><div><toggle ng-model="vm.ims.hasSimCard" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.hasIMS && vm.ims.hasSimCard"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumOfSimCard.$invalid && (vm.dataForm.NumOfSimCard.$dirty || vm.dataForm.$submitted)}"><label><b>No. of SIM Cards</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="NumOfSimCard" placeholder="No. of SIM Cards" autocomplete="off" ng-model="vm.ims.numOfSimCard" ng-required="vm.hasIMS && vm.ims.hasSimCard" min="1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSimCard.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSimCard.$error.min">* Minimum is one</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSimCard.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Monthly Subscription Fee (RM)</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">{{ (!(vm.hasIMS && vm.ims.hasSimCard) ? 0 : (vm.ims.numOfSimCard * vm.ims.simCardRate || 0)) | number }}</b></span></div></div></div><div class="row" ng-if="vm.hasIMS"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumOfGateway.$invalid && (vm.dataForm.NumOfGateway.$dirty || vm.dataForm.$submitted)}"><label><b>No. of Gateways</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="NumOfGateway" autocomplete="off" ng-model="vm.ims.numOfGateway" ng-required="vm.hasIMS" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfGateway.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfGateway.$error.min">* Minimum is zero</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfGateway.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.GatewayRate.$invalid && (vm.dataForm.GatewayRate.$dirty || vm.dataForm.$submitted)}"><label><b>Rate (RM)</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="GatewayRate" ng-model="vm.selectedGatewayRate" ng-change="vm.selectedGatewayRateChanged()" ng-options="r as r.name for r in vm.gatewayRates" ng-required="vm.hasIMS"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.GatewayRate.$error.required">* Required</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Monthly Subscription Fee (RM)</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">{{ (!vm.hasIMS ? 0 : (vm.ims.numOfGateway * vm.ims.gatewayRate || 0)) | number }}</b></span></div></div></div><div class="row" ng-if="vm.hasIMS"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumOfSensor.$invalid && (vm.dataForm.NumOfSensor.$dirty || vm.dataForm.$submitted)}"><label><b>No. of Sensors</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="NumOfSensor" autocomplete="off" ng-model="vm.ims.numOfSensor" ng-required="vm.hasIMS" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSensor.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSensor.$error.min">* Minimum is zero</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSensor.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NormalSensorRate.$invalid && (vm.dataForm.NormalSensorRate.$dirty || vm.dataForm.$submitted)}"><label><b>Rate (RM)</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="NormalSensorRate" ng-model="vm.selectedSensorRate" ng-change="vm.selectedSensorRateChanged()" ng-options="r as r.name for r in vm.normalSensorRates" ng-required="vm.hasIMS"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NormalSensorRate.$error.required">* Required</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Monthly Subscription Fee (RM)</b></label> <span class="form-control" ng-disabled="true"><b style="font-size:12pt;color:#00f">{{ (!vm.hasIMS ? 0 : (vm.ims.numOfSensor * vm.ims.sensorRate || 0)) | number }}</b></span></div></div></div></div></div><p><br></p><legend style="height:32.4px;line-height:32.4px">Summary:</legend><div class="row"><div class="col-md-2 col-lg-2"><label><b>Total Standard Users</b></label><h1 style="color:#00f">{{ (vm.selectedRmsType.stdUserQty||0) + vm.extraStdUserCount }}</h1></div><div class="col-md-2 col-lg-2" ng-hide="true"><label><b>Total Limited Users</b></label><h1 style="color:#00f">{{ vm.extraLtdUserCount }}</h1></div><div class="col-md-2 col-lg-2" ng-if="vm.selectedBillingIntervalType.id==1"><label><b>Total Monthly Fees</b></label><h1 style="color:#00f">RM {{ (vm.selectedRmsType.baseFees||0) + (vm.extraStdUserCount * (vm.selectedRmsType.extraStdUserFee||0)) + (vm.extraLtdUserCount * 50) | number}}</h1></div><div class="col-md-2 col-lg-2" ng-if="vm.selectedBillingIntervalType.id==2"><label><b>Total Quarter Fees</b></label><h1 style="margin-bottom:5px;color:#00f">RM {{ ((vm.selectedRmsType.baseFees||0) + (vm.extraStdUserCount * (vm.selectedRmsType.extraStdUserFee||0)) + (vm.extraLtdUserCount * 50)) * 3 | number}}</h1><span style="color:#00f">(+ {{vm.selectedBillingIntervalType.discount}}% Discount)</span></div><div class="col-md-2 col-lg-2" ng-if="vm.selectedBillingIntervalType.id==3"><label><b>Total Annual Fees</b></label><h1 style="margin-bottom:5px;color:#00f">RM {{ ((vm.selectedRmsType.baseFees||0) + (vm.extraStdUserCount * (vm.selectedRmsType.extraStdUserFee||0)) + (vm.extraLtdUserCount * 50)) * 12 | number}}</h1><span style="color:#00f">(+ {{vm.selectedBillingIntervalType.discount}}% Discount)</span></div></div><div class="row"><p><br></p></div><div class="row"><p><br></p></div></uib-tab></uib-tabset></div></div></div><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> Submit</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> Back</a></div></form></div>');
$templateCache.put('app/pages/subscribe/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Company Details"><p><i class="fa fa-info-circle"></i> Please fill in the Company Details.</p><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CompanyName.$invalid && (vm.dataForm.CompanyName.$dirty || vm.dataForm.$submitted)}"><label for="CompanyName">Company Name <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CompanyName" placeholder="Company Name" ng-model="vm.subs.companyName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CompanyName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Address1.$invalid && (vm.dataForm.Address1.$dirty || vm.dataForm.$submitted)}"><label>Address 1 <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Address1" placeholder="Address 1" ng-model="vm.subs.address1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Address1.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label>Address 2</label> <input type="text" class="form-control" placeholder="Address 2" ng-model="vm.subs.address2"></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label>Address 3</label> <input type="text" class="form-control" placeholder="Address 3" ng-model="vm.subs.address3"></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label>Postal Code</label> <input type="text" class="form-control" placeholder="Postal Code" ng-model="vm.subs.postcode"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label>State</label> <input type="text" class="form-control" placeholder="State" ng-model="vm.subs.state"></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label>Country</label> <input type="text" class="form-control" placeholder="Country" ng-model="vm.subs.country"></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label>Telephone</label> <input type="text" class="form-control" placeholder="Telephone" ng-model="vm.subs.tel"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label>Fax</label> <input type="text" class="form-control" placeholder="Fax" ng-model="vm.subs.fax"></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label for="CompanyRegNo">Company Registration No.</label> <input type="text" class="form-control" name="CompanyRegNo" placeholder="Company Reg. No." ng-model="vm.subs.companyRegNo"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label for="CompanyGstNo">Company GST ID.</label> <input type="text" class="form-control" name="CompanyGstId" placeholder="Company GST ID." ng-model="vm.subs.companyGstNo"></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="Branch Details"><p><i class="fa fa-info-circle"></i> Please fill in the Branch Details.</p><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BranchCode.$invalid && (vm.dataForm.BranchCode.$dirty || vm.dataForm.$submitted)}"><label for="BranchCode">Branch Code <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BranchCode" placeholder="Branch Code" ng-model="vm.subs.branchCode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BranchCode.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BranchName.$invalid && (vm.dataForm.BranchName.$dirty || vm.dataForm.$submitted)}"><label for="BranchName">Branch Name <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BranchName" placeholder="Branch Name" ng-model="vm.subs.branchName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BranchName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="Subscription"><p><i class="fa fa-info-circle"></i> Please select the appropriate Subscription Plan.</p><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.subs.serverPackageId==\'\' && vm.dataForm.$submitted}"><label>Server Package <i class="fa fa-asterisk req"></i></label><ui-select ng-model="vm.serverPackages.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" on-select="vm.selectServerPackage($item)"><ui-select-match placeholder="-- Select a Package --"><span>{{ $select.selected.name }}</span></ui-select-match><ui-select-choices repeat="p in vm.serverPackages | orderBy: [\'monthlyFee\',\'name\']"><span ng-bind-html="p.name"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.subs.serverPackageId==\'\'">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ContactPerson.$invalid && (vm.dataForm.ContactPerson.$dirty || vm.dataForm.$submitted)}"><label for="ContactPerson">Contact Person <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ContactPerson" placeholder="Contact Person" ng-model="vm.subs.contactPerson" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ContactPerson.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingEmail.$invalid && (vm.dataForm.BillingEmail.$dirty || vm.dataForm.$submitted)}"><label for="BillingEmail">Billing Email <i class="fa fa-asterisk req"></i></label> <input type="email" class="form-control" name="BillingEmail" placeholder="Email for Billing Purpose" ng-model="vm.subs.billingEmail" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingEmail.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingEmail.$error.email">* Email format invalid</span></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="User Details"><p><i class="fa fa-info-circle"></i> Please select the appropriate Subscription Plan.</p><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FirstName.$invalid && (vm.dataForm.FirstName.$dirty || vm.dataForm.$submitted)}"><label for="FirstName">First Name <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="FirstName" placeholder="First Name" ng-model="vm.subs.userFirstName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LastName.$invalid && (vm.dataForm.LastName.$dirty || vm.dataForm.$submitted)}"><label for="LastName">Last Name <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="LastName" placeholder="Last Name" ng-model="vm.subs.userLastName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LastName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UserEmail.$invalid && (vm.dataForm.UserEmail.$dirty || vm.dataForm.$submitted)}"><label for="UserEmail">User Email (also used as Username) <i class="fa fa-asterisk req"></i></label> <input type="email" class="form-control" name="UserEmail" placeholder="User Email" ng-model="vm.subs.userEmail" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UserEmail.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UserEmail.$error.email">* Email format invalid</span></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="Complimentary Access"><p><i class="fa fa-info-circle"></i> Grant complimentary access to Recipe Categories. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddCategoryModal()"><i class="ion-plus-round"></i>Grant Category Access</a><br><br></p><script type="text/ng-template" id="categoryModal.html"><form name="$mdl.categoryForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header"> <h3 class="modal-title" id="modal-title">{{ $mdl.title | translate }} Recipe Category</h3> </div> <div class="modal-body" id="modal-body"> <div class="form-group"> <label>Recipe Category</label> <ui-select ng-model="$mdl.selectedItem" title="Select or Search for Category..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.onSelectedItemChanged()"> <ui-select-match placeholder="Search for Category..."> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.itemList | filter: $select.search" minimum-input-length="2"> <span ng-bind-html="\'(\' + i.companyName + \') - \' + i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.categoryForm.$invalid && $mdl.categoryForm.$submitted">* Required</p> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> Confirm </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> Cancel </button> </div> </form></script><script type="text/ng-template" id="emptyCategoryModal.html"><form name="$mdl.categoryForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header"> <h3 class="modal-title" id="modal-title" style="color:#f00"><i class="fa fa-exclamation-triangle"></i> ALERT</h3> </div> <div class="modal-body" id="modal-body"> <p>You did not select any Complimentary Access (Recipe Category).</p> <p>Confirm proceed with the submission?</p> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> Confirm </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> Cancel </button> </div> </form></script><div class="row"><div class="col-md-9 col-lg-9"><table class="table table-striped" style="border:1px solid #ccc" st-pipe="vm.refreshRecipeCategories" st-table="vm.subs.companyRecipeCategories" refresh-table=""><thead><tr class="sortable"><th style="width:60px">#</th><th><b>Recipe Category</b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.subs.companyRecipeCategories"><td>{{$index+1}}</td><td>{{ ntn.recipeCategory.name || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeCategory($index)" ng-confirm-click="Confirm remove this Category?"><i class="fa fa-trash-o"></i> Delete</a></td></tr><tr><td colspan="3" align="center" ng-show="vm.subs.companyRecipeCategories.length==0"><br>No complimentary access granted.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p><br></p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/subscribe/form.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section data-ng-include="" src="\'app/pages/subscribe/_form.html\'"></section><div style="padding-bottom:30px"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Submit</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="jobs.list"><i class="ion ion-close"></i> Reset</a></div></form></div>');
$templateCache.put('app/pages/wastagereports/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-if="vm.originalStatus==\'NEW\'"><small><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_WITHDRAWAL_DETAILS_BELOW"></span>.</small><br><br></p><p ng-if="vm.originalStatus!=\'NEW\'"><small><i class="fa fa-warning"></i> <span translate="ALL_THE_FIELDS_WILL_BE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NO_LONGER"></span> <b translate="NEW"></b>.</small><br><br></p><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b><span translate="DOCUMENT_NO"></span>.</b></label> <span class="form-control" style="color:#333">{{vm.wr.docNo || \'AUTONUMBER\' }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DocDate.$invalid && (vm.dataForm.DocDate.$dirty || vm.dataForm.$submitted)}"><label for="DocDate"><b translate="DOCUMENT_DATE"></b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.wr.docDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group" ng-if="vm.originalStatus==\'NEW\'"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="DocDate" autocomplete="off" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.wr.docDate" required=""></div><span class="form-control" style="color:#00f" ng-if="vm.originalStatus!=\'NEW\'">{{vm.wr.docDate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DocDate.$error.required">* {{\'REQUIRED\' | translate}}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Status.$invalid && (vm.dataForm.Status.$dirty || vm.dataForm.$submitted)}"><label><b translate="DOCUMENT_STATUS"></b> <i class="fa fa-asterisk req"></i></label><select name="Status" class="form-control" style="color:#333" ng-if="vm.originalStatus==\'NEW\'" ng-change="vm.selectedStatusChanged()" ng-disabled="vm.originalStatus!=\'NEW\'" ng-options="u as u.name for u in vm.wrStatuses track by u.id" ng-model="vm.selectedStatus" required=""><option></option></select><span class="form-control" style="color:#00f" ng-if="vm.originalStatus!=\'NEW\'">{{vm.wr.status}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Status.$error.required">* {{\'REQUIRED\' | translate}}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="REMARKS"></b></label> <textarea class="form-control" style="color:#333" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.wr.remarks">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-3 col-lg-2" ng-if="vm.wr.createdBy"><div class="form-group"><label><b translate="CREATED_BY">:</b></label><br><span>{{vm.wr.createdBy | uppercase}}<br>{{ vm.wr.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</span></div></div><div class="col-md-3 col-lg-2" ng-if="vm.wr.modifiedBy"><div class="form-group"><label><b translate="MODIFIED_BY">:</b></label><br><span>{{vm.wr.modifiedBy | uppercase}}<br>{{ vm.wr.modifiedDate | date:\'dd/MM/yyyy hh:mma\' }}</span></div></div><div class="col-md-3 col-lg-2" ng-if="vm.wr.cancelledBy"><div class="form-group"><label><b translate="CANCELLED_BY">:</b></label><br><span>{{vm.wr.cancelledBy | uppercase}}<br>{{ vm.wr.cancelledDate | date:\'dd/MM/yyyy hh:mma\' }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Add Items"><p><i class="fa fa-info-circle"></i> Add items <span translate="INTO_THIS_WASTAGE_REPORT"></span>. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddEntityModal()" ng-if="vm.originalStatus==\'NEW\'"><i class="ion-plus-round"></i> Add Item</a><br><br></p><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:1px solid #ccc" st-table="vm.wr.wastageReportItems" refresh-table=""><thead><tr class="sortable"><th style="width:60px">#</th><th ng-if="!vm.isRmsLite && !vm.isSimpleStockIn"><b translate="SERIAL_NO"></b></th><th><b translate="CODE"></b></th><th><b translate="DESCRIPTION"></b></th><th style="text-align:right" class="hide-after"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b>{{ \'U.O.M.\' | translate }}</b></th><th ng-if="!vm.isRmsLite && !vm.isSimpleStockIn" style="text-align:right" class="hide-after"><b>{{ \'QUANTITY\' | translate }}</b> #2</th><th ng-if="!vm.isRmsLite && !vm.isSimpleStockIn"><b>{{ \'U.O.M.\' | translate }}</b> #2</th><th><b>{{ \'REMARKS\' | translate }}</b></th><th><b>{{ \'PICTURE\' | translate }}</b></th><th style="width:80px" ng-if="vm.originalStatus==\'NEW\'"></th><th style="width:80px" ng-if="vm.originalStatus==\'NEW\'"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.wr.wastageReportItems"><td>{{$index+1}})</td><td ng-if="!vm.isRmsLite && !vm.isSimpleStockIn">{{ ntn.serialNo || \'\' }}</td><td>{{ ntn.code || \'\' }}</td><td>{{ ntn.description || \'\' }}</td><td style="text-align:right">{{ ntn.quantity }}</td><td>{{ ntn.uomName }}</td><td ng-if="!vm.isRmsLite && !vm.isSimpleStockIn" style="text-align:right">{{ ntn.quantity2 || \'-\' }}</td><td ng-if="!vm.isRmsLite && !vm.isSimpleStockIn">{{ ntn.uomName2 }}</td><td>{{ ntn.remarks }}</td><td><a href="" title="View" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ng-click="vm.showPictureModal(ntn.code, ntn.description, ntn.photoAttachment)" ng-if="ntn.photoAttachment"><i class="fa fa-eye"></i></a> <span ng-if="!ntn.photoAttachment">-</span></td><td ng-if="vm.originalStatus==\'NEW\'"><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditEntityModal($index)" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td ng-if="vm.originalStatus==\'NEW\'"><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeProduct($index)" ng-confirm-click="Confirm remove this Product?" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="12" align="center" ng-if="vm.wr.wastageReportItems.length==0"><br>{{vm.selectedType.name}} <span translate="LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="popupModal.html"><style> .help-block { color:#f00 !important } </style> <form name="$mdl.popupForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} Item</h3> </div> <div class="modal-body" id="modal-body"> <div class="row" ng-if="!$mdl.isRmsLite && !$mdl.isSimpleStockIn"> <div class="col-md-12 col-lg-12"> <div class="form-group" style="margin-bottom:3px" ng-class="{\'has-error\': $mdl.popupForm.SerialNo.$invalid && ($mdl.popupForm.SerialNo.$dirty || $mdl.popupForm.$submitted)}"> <label> <big><b> {{ \'STEP_1\' | translate }}: &nbsp; {{ \'ENTER_LABEL_SERIAL_NO\' | translate }} </b></big> <i class="fa fa-asterisk req"></i> </label> </div> </div> </div> <div class="row" ng-if="!$mdl.isRmsLite && !$mdl.isSimpleStockIn"> <div class="col-md-8 col-lg-8"> <div class="form-group" ng-class="{\'has-error\': $mdl.popupForm.SerialNo.$invalid && ($mdl.popupForm.SerialNo.$dirty || $mdl.popupForm.$submitted)}"> <input type="text" class="form-control" name="SerialNo" style="text-transform:uppercase;background:#fffeed" ng-model="$mdl.item.serialNo" required> <span class="help-block" ng-show="$mdl.popupForm.$submitted && $mdl.popupForm.SerialNo.$error.required"> * {{\'REQUIRED\' | translate}} </span> </div> </div> <div class="col-md-4 col-lg-4"> <a href class="btn btn-primary btn-with-icon" ng-click="$mdl.loadLabelInfo()"> <i class="fa fa-search"></i> Load Label Info </a> </div> </div> <div class="row" ng-if="$mdl.labelInfo!=null"> <div class="col-md-12 col-lg-12"> <div style="background:#eefaff;padding:10px;line-height:150%"> <div class="row"> <div class="col-lg-12"> <b>{{ \'ITEM_CODE\' | translate }}:</b><br /> {{$mdl.labelInfo.itemCode}} </div> </div> <div class="row"> <div class="col-lg-12"> <b>{{ \'ITEM_DESCRIPTION\' | translate }}:</b><br /> {{$mdl.labelInfo.itemDescription}} </div> </div> <div class="row"> <div class="col-lg-6"> <b>{{ \'BALANCE_QTY\' | translate }}:</b><br /> {{$mdl.labelInfo.balanceQty | number}} {{$mdl.labelInfo.uom1}} </div> <div class="col-lg-6" ng-if="$mdl.labelInfo.itemCwm"> <b>{{ \'BALANCE_QTY\' | translate }} #2:</b><br /> {{$mdl.labelInfo.balanceQty2 | number}} {{$mdl.labelInfo.uom2}} </div> </div> </div> </div> </div> <div class="row" ng-if="$mdl.isRmsLite || $mdl.isSimpleStockIn"> <div class="col-md-12 col-lg-12"> <div class="form-group" style="margin-bottom:3px" ng-class="{\'has-error\': $mdl.popupForm.SerialNo.$invalid && ($mdl.popupForm.SerialNo.$dirty || $mdl.popupForm.$submitted)}"> <label> <big><b> {{ \'STEP_1\' | translate }}: &nbsp; {{ \'SEARCH_AND_SELECT_AN_ITEM\' | translate }} </b></big> <i class="fa fa-asterisk req"></i> </label> </div> </div> <div class="col-md-12 col-lg-12"> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.itemSearch" style="background:#fffeed" ng-disabled="$mdl.lockButtons" ng-model-options=\'{ debounce: 500 }\' ng-change="$mdl.searchItem($mdl.itemSearch)" /> </div> </div> <div class="col-lg-9"> <select class="form-control" style="color:#333;background:#fffeed" name="ItemName" ng-disabled="$mdl.lockButtons" ng-change="$mdl.selectedItemChanged()" ng-options="u as (\'[\' + u.itemType + \'] \' + u.productName | uppercase) for u in $mdl.itemList" ng-model="$mdl.selectedItem" required> <option value="">{{($mdl.lockButtons ? (\'LOADING...\' | translate) : ($mdl.itemList.length==0 ? ("&lt;&lt; " + (\'ENTER_A_KEYWORD_TO_SEARCH\' | translate)) : ("-- " + (\'SELECT_AN_ITEM\' | translate) + " --")))}}</option> </select> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" style="margin-top:5px" ng-if="$mdl.selectedItem!=null" ng-click="$mdl.selectedItem=null"> <i class="fa fa-times"></i> <span style="color:#fff" translate="CLEAR_SELECTION"></span> </button> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted"> * {{"REQUIRED" | translate}} </p> </div> </div> </div> </div> <br /> <div class="row" ng-if="$mdl.labelInfo!=null"> <div class="form-group col-md-12 col-lg-12" style="margin-bottom:3px"> <label> <big><b> {{ \'STEP_2\' | translate }}: &nbsp; {{ \'ENTER_THE_WASTAGE_QUANTITY\' | translate }} </b></big> <i class="fa fa-asterisk req" ng-if="!$mdl.labelInfo.itemCwm"></i> </label> </div> </div> <div class="row" ng-if="$mdl.labelInfo!=null"> <div class="col-md-6 col-lg-6" style="padding-right:0px"> <div class="form-group" ng-class="{\'has-error\': $mdl.popupForm.Quantity1.$invalid && ($mdl.popupForm.Quantity1.$dirty || $mdl.popupForm.$submitted)}"> <label ng-if="$mdl.labelInfo.itemCwm">Wastage Quantity #1 <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity1" style="text-transform:uppercase;background:#fffeed" ng-model="$mdl.item.quantity" min=0 max={{$mdl.labelInfo.balanceQty}} required> <span class="help-block" ng-show="$mdl.popupForm.$submitted && $mdl.popupForm.Quantity1.$error.required">* {{\'REQUIRED\' | translate}}</span> <span class="help-block" ng-show="$mdl.popupForm.$submitted && $mdl.popupForm.Quantity1.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="$mdl.popupForm.$submitted && $mdl.popupForm.Quantity1.$error.min">* Minimum is zero</span> <span class="help-block" ng-show="$mdl.popupForm.$submitted && $mdl.popupForm.Quantity1.$error.max">* Maximum is {{$mdl.labelInfo.balanceQty}} {{$mdl.labelInfo.uom1}}</span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group" style="line-height:24px"> <br ng-if="$mdl.labelInfo.itemCwm" /> <b>{{$mdl.labelInfo.uom1}}</b> </div> </div> </div> <div class="row" ng-if="$mdl.labelInfo!=null && $mdl.labelInfo.itemCwm"> <div class="col-md-6 col-lg-6" style="padding-right:0px"> <div class="form-group" ng-class="{\'has-error\': $mdl.popupForm.Quantity2.$invalid && ($mdl.popupForm.Quantity2.$dirty || $mdl.popupForm.$submitted)}"> <label>{{ \'WASTAGE_QUANTITY\' | translate }} #2 <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity2" style="text-transform:uppercase;background:#fffeed" ng-model="$mdl.item.quantity2" min=0 max={{$mdl.labelInfo.balanceQty2}} ng-required="$mdl.labelInfo.itemCwm"> <span class="help-block" ng-show="$mdl.popupForm.$submitted && $mdl.popupForm.Quantity2.$error.required">* {{\'REQUIRED\' | translate}}</span> <span class="help-block" ng-show="$mdl.popupForm.$submitted && $mdl.popupForm.Quantity2.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="$mdl.popupForm.$submitted && $mdl.popupForm.Quantity2.$error.min">* Minimum is zero</span> <span class="help-block" ng-show="$mdl.popupForm.$submitted && $mdl.popupForm.Quantity1.$error.max">* Maximum is {{$mdl.labelInfo.balanceQty2}} {{$mdl.labelInfo.uom2}}</span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group" style="line-height:24px"> <div class="form-group"> <br /> <b>{{$mdl.labelInfo.uom2}}</b> </div> </div> </div> </div> <div class="row" ng-if="($mdl.isRmsLite || $mdl.isSimpleStockIn) && $mdl.selectedItem!=null"> <div class="form-group col-md-7 col-lg-7" style="margin-bottom:3px"> <label> <big><b> {{ \'STEP_2\' | translate }}: &nbsp; {{ \'ENTER_THE_WASTAGE_QUANTITY\' | translate }} </b></big> <i class="fa fa-asterisk req"></i> </label> </div> <div class="form-group col-md-5 col-lg-5" style="margin-bottom:3px"> <label> <big><b> {{ \'U.O.M\' | translate }}: </b></big> <i class="fa fa-asterisk req"></i> </label> </div> <div class="col-md-7 col-lg-7"> <div class="form-group" ng-class="{\'has-error\': $mdl.popupForm.Quantity1.$invalid && ($mdl.popupForm.Quantity1.$dirty || $mdl.popupForm.$submitted)}"> <input type="number" class="form-control" name="Quantity1" style="text-transform:uppercase;background:#fffeed" ng-model="$mdl.item.quantity" min=0 required> <span class="help-block" ng-show="$mdl.popupForm.$submitted && $mdl.popupForm.Quantity1.$error.required">* {{\'REQUIRED\' | translate}}</span> <span class="help-block" ng-show="$mdl.popupForm.$submitted && $mdl.popupForm.Quantity1.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="$mdl.popupForm.$submitted && $mdl.popupForm.Quantity1.$error.min">* Minimum is zero</span> </div> </div> <div class="col-md-5 col-lg-5"> <div class="form-group" ng-class="{\'has-error\': $mdl.popupForm.UOM.$invalid && ($mdl.popupForm.UOM.$dirty || $mdl.productForm.$submitted)}"> <select name="UOM" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.selectedItem.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.selectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.popupForm.UOM.$error.required && $mdl.popupForm.$submitted">* {{"REQUIRED" | translate}}</p> </div> </div> </div> <br /> <div class="row" ng-if="$mdl.labelInfo!=null || $mdl.selectedItem!=null"> <div class="form-group col-md-12 col-lg-12" style="margin-bottom:3px"> <label> <big><b> {{ \'STEP_3\' | translate }}: &nbsp; {{ \'ENTER_A_CAUSE_REASON_OF_THIS_WASTAGE\' | translate }} </b></big> <i class="fa fa-asterisk req"></i> </label> </div> </div> <div class="row" ng-if="$mdl.labelInfo!=null || $mdl.selectedItem!=null"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.popupForm.Remarks.$invalid && ($mdl.popupForm.Remarks.$dirty || $mdl.popupForm.$submitted)}"> <input type="text" class="form-control" name="Remarks" style="text-transform:uppercase;background:#fffeed" ng-model="$mdl.item.remarks" required> <span class="help-block" ng-show="$mdl.popupForm.$submitted && $mdl.popupForm.Remarks.$error.required"> * {{\'REQUIRED\' | translate}} </span> </div> </div> </div> </div> <hr /> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton1"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButton2"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="photoModal.html"><form name="$mdl.itemForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> {{$mdl.itemCode}} - {{$mdl.itemName}} <br /> Photo Gallery </h3> </div> <div class="modal-body" id="modal-body"> <div style="margin-bottom:10px;background:#333;height:350px;"> <center> <img ng-src="{{$mdl.selectedPhoto}}" align="center" style="height:350px" /> </center> </div> <div style="overflow-x:auto"> <img ng-src="{{$mdl.rootUrl}}{{i}}" ng-repeat="i in $mdl.photoArray" style="max-width:150px;max-height:80px;margin-right:5px;border:1px solid #000;cursor:pointer" ng-click="$mdl.selectPhoto(i)" /> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/wastagereports/wastagereportCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/wastagereports/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" style="margin-right:20px" ui-sref="wastagereports.list" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="wastagereports.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/wastagereports/wastagereportList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" style="font-size:85%" st-persist="WastageReportListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_CLOSED_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="wastagereports.create" rms-check-access="wastagereports.list" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="docNo" st-sort-default="reverse"><span translate="DOCUMENT_NO"></span>.</th><th st-sort="docDate"><span translate="DOC_DATE"></span><br><small->(DD/MM/YYYY)</small-></th><th st-sort="branchName">{{ \'BRANCH\' | translate }}</th><th st-sort="createdBy"><span translate="CREATED_BY"></span></th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline" colspan="2"><input st-search="docNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="branchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="createdBy" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><select st-search="status" class="form-control input input-sm" style="width:120px"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.statusList" value="{{ s.id }}">{{ s.name }}</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.data.length<=0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td>{{item.docNo}}</td><td>{{item.docDate | date: "dd/MM/yyyy" }}</td><td>{{item.branchName | uppercase}}</td><td>{{item.createdBy | uppercase | limitTo: 15}}<span ng-if="item.createdBy.length>15">...</span></td><td>{{item.status | uppercase}}</td><td align="center"><a href="" title="Print W.R." class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#00f" ng-if="item.status!=\'CANCELLED\'" ng-click="vm.printWR(item.id, item.docNo)" rms-check-access="wastagereports.list" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="wastagereports.update({id:item.id})" rms-check-access="wastagereports.list" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil" ng-show="item.status==\'NEW\'"></i> <i class="fa fa-eye" ng-show="item.status!=\'NEW\'"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/wastagereports/wastagereportUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/wastagereports/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:30px" ui-sref="wastagereports.list" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && !vm.isLoading"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-success btn-with-icon" ng-disabled="vm.lockButtons" confirmed-click="vm.approveWR()" ng-confirm-click="Approve this Wastage Report?" ng-if="vm.originalStatus==\'CONFIRMED\' && !vm.isLoading && !vm.isProcessing" rms-check-access="wastagereports.list" rms-check-access-perm-type="APPROVE"><i class="fa fa-check-circle"></i> {{ \'APPROVE_REPORT\' | translate }}</a> <a href="" class="btn btn-danger btn-with-icon" ng-disabled="vm.lockButtons" ng-if="vm.mode==2 && (vm.originalStatus==\'NEW\' || vm.originalStatus==\'CONFIRMED\') && !vm.isProcessing" ng-confirm-click="Confirm cancel this Wastage Report?" confirmed-click="vm.cancelWR()" rms-check-access="wastagereports.list" rms-check-access-perm-type="APPROVE"><i class="fa fa-trash"></i> {{ \'CANCEL_REPORT\' | translate }}</a> <span class="btn btn-with-icon" style="margin-right:30px;color:#fff" ng-if="vm.isProcessing"><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'PROCESSING\' | translate }}...</span> <a href="" class="btn btn-default btn-with-icon" style="margin-left:30px" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'CONFIRMED\' && item.status!=\'CANCELLED\' && !vm.isLoading" ng-click="vm.printWR(vm.wr.id, vm.wr.docNo)" rms-check-access="wastagereports.list" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT_REPORT"></span></a></div></form>');
$templateCache.put('app/pages/login/change.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><p translate="YOU_CAN_UPDATE_YOUR_LOGIN_PASSWORD_WITH_A_NEW_ONE_HERE."></p><p><br></p><form name="detailForm" class="form-horizontal"><div class="form-group"><label for="OldPassword" class="col-sm-2 control-label"><span translate="OLD_PASSWORD"></span></label><div class="col-sm-3"><input type="password" class="form-control" name="OldPassword" placeholder="Old Password" ng-model="vm.oldpassword" ng-change="vm.onTextChanged()" required=""></div><div class="col-sm-3" ng-messages="detailForm.OldPassword.$error" style="padding-top:10px"><div ng-message="required" style="color:rgba(223,184,28,.85)"><i class="ion ion-alert-circled"></i> <span translate="OLD_PASSWORD_IS_REQUIRED."></span></div></div></div><div class="form-group"><label for="NewPassword1" class="col-sm-2 control-label"><span translate="NEW_PASSWORD"></span></label><div class="col-sm-3"><input type="password" class="form-control" name="NewPassword1" placeholder="New Password" ng-model="vm.newpassword1" ng-change="vm.onTextChanged()" required=""></div><div class="col-sm-3" ng-messages="detailForm.NewPassword1.$error" style="padding-top:10px"><div ng-message="required" style="color:rgba(223,184,28,.85)"><i class="ion ion-alert-circled"></i> <span translate="NEW_PASSWORD_IS_REQUIRED."></span></div></div></div><div class="form-group"><label for="NewPassword2" class="col-sm-2 control-label"><span translate="CONFIRM_PASSWORD"></span></label><div class="col-sm-3"><input type="password" class="form-control" name="NewPassword2" placeholder="Re-type New Password" ng-model="vm.newpassword2" ng-change="vm.onTextChanged()" value-match="vm.newpassword1" required=""></div><div class="col-sm-3" ng-messages="detailForm.NewPassword2.$error" style="padding-top:10px"><div ng-message="required" style="color:rgba(223,184,28,.85)"><i class="ion ion-alert-circled"></i> <span translate="CONFIRM_PASSWORD_IS_REQUIRED."></span></div><div ng-message="unique" style="color:#f00"><i class="ion ion-alert-circled"></i> <span translate="NEW_PASSWORDS_DOES_NOT_MATCH."></span></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-3"><button type="submit" class="btn btn-primary" ng-model="vm.submit" ng-disabled="!vm.disableSubmit" ng-click="vm.changePassword()"><i class="ion ion-checkmark"></i> <span translate="CHANGE_PASSWORD"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard"><i class="ion ion-close"></i> <span translate="BACK"></span></a></div></div></form></div></div></div>');
$templateCache.put('app/pages/login/login-ori.html','<div id="login-screen"><div class="login-container"><div class="row"><div class="col-md-6 col-lg-6"><img class="iso-art" src="assets/img/login/cloud-isometric.png" alt="Cloud Solution"></div><div class="col-md-6 col-lg-6"><h1><img class="logo" src="assets/img/login/codemax-logo-transparent.png" alt="Codemax Logo"></h1><div class="row"><div class="col-md-1 col-lg-1"></div><div class="col-md-10 col-lg-10"><div ng-if="!credential.step1"><h2>Smart Cloud Integrated Solution</h2><h2><b>User Login</b></h2><form><div class="form-group"><label><span translate="USERNAME"></span></label> <input type="text" class="form-control" id="Username" ng-model="credential.username" placeholder="Username" required=""></div><div class="form-group"><label><span translate="PASSWORD"></span></label> <input type="password" class="form-control" id="Password" ng-model="credential.password" placeholder="Password" required=""></div><div class="form-group"><button type="submit" ng-model="credential.submit1" class="btn" style="padding-left:40px;padding-right:40px" data-ng-disabled="!credential.username || !credential.password || credential.submit1" ng-click="login()"><span translate="SIGN_IN"></span></button> <a href="" ng-click="navigateToReset()" class="forgot-pass"><span translate="FORGOT_PASSWORD?"></span></a></div></form></div><div ng-if="credential.step1 && !credential.step2"><h2>Smart Cloud Integrated Solution</h2><h2><b>Select Company &amp; Branch</b></h2><form><div class="form-group"><label><span translate="COMPANY"></span></label><select class="form-control" ng-options="c as (c.name | uppercase) for c in user.companies track by c.id" ng-model="credential.selectedCompany" ng-change="selectedCompanyChanged()"><option value="">-- {{ \'SELECT_A_COMPANY\' | translate }} --</option></select></div><div class="form-group"><label>{{ \'BRANCH\' | translate }}</label><select class="form-control" ng-options="b as (b.name | uppercase) for b in credential.selectedCompany.branches track by b.id" ng-model="credential.selectedBranch" ng-change="selectedBranchChanged()"><option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option></select></div><div class="form-group"><a href="" ng-click="backToLogin()" style="float:left">&lt; &nbsp;<span translate="BACK"></span></a> <button type="submit" ng-model="credential.submit2" class="btn" style="float:right" data-ng-disabled="!credential.selectedCompany || !credential.selectedBranch || credential.submit2" ng-click="loginBranchToken()">{{ \'CONFIRM\' | translate }} &nbsp;&gt;</button></div></form></div></div></div></div><div class="col-md-6 col-lg-6"><img class="iso-art-bottom" src="assets/img/login/cloud-isometric.png" alt="Cloud Solution"></div></div></div></div>');
$templateCache.put('app/pages/login/login.html','<div class="login-screen-v3"><div class="login-screen-left"><div ng-if="!isKorea"><img class="logo" src="assets/img/login/codemax-logo-blue.png" alt="Codemax"><div class="tagline">Smart Cloud Integrated Solution</div></div><div ng-if="isKorea"><img class="logo" src="assets/img/login/dims-logo.png" alt="DiMS"></div></div><div class="login-screen-right"><div class="login-form"><div ng-if="!credential.step1"><h2><b><span translate="SIGN_IN"></span></b></h2><br><form><div class="form-group"><label><span translate="USERNAME"></span></label> <input type="text" class="form-control" id="Username" ng-model="credential.username" required="" ng-disabled="credential.isLoggingIn1"></div><div class="form-group"><label><span translate="PASSWORD"></span></label> <input type="password" class="form-control" id="Password" ng-model="credential.password" required="" ng-disabled="credential.isLoggingIn1"></div><br><div class="form-group"><a href="" ng-click="navigateToReset()" class="forgot-pass" ng-if="!credential.isLoggingIn1"><span translate="FORGOT_PASSWORD?"></span></a> <button type="submit" ng-model="credential.submit1" class="submit-btn btn btn-info" data-ng-disabled="!credential.username || !credential.password || credential.submit1" ng-if="!credential.isLoggingIn1" ng-click="login()"><span translate="SIGN_IN"></span></button><div class="loading-animation" ng-if="credential.isLoggingIn1"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="SIGNING_IN"></span> ...</div></div></form></div><div ng-if="credential.step1 && !credential.step2"><h2><b><span translate="SELECT_COMPANY_/_BRANCH"></span></b></h2><br><form><div class="form-group"><label><span translate="COMPANY"></span></label><select class="form-control" ng-options="c as (c.name | uppercase) for c in user.companies track by c.id" ng-disabled="credential.isLoggingIn2" ng-model="credential.selectedCompany" ng-change="selectedCompanyChanged()"><option value="">-- {{ \'SELECT_A_COMPANY\' | translate }} --</option></select></div><div class="form-group"><label>{{ \'BRANCH\' | translate }}</label><select class="form-control" ng-options="b as (b.name | uppercase) for b in credential.selectedCompany.branches track by b.id" ng-disabled="credential.isLoggingIn2" ng-model="credential.selectedBranch" ng-change="selectedBranchChanged()"><option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option></select></div><br><div class="form-group"><a href="" ng-click="backToLogin()" class="forgot-pass" ng-if="!credential.isLoggingIn2">&lt; &nbsp;<span translate="BACK"></span></a> <button type="submit" ng-model="credential.submit2" class="submit-btn btn btn-info" data-ng-disabled="!credential.selectedCompany || !credential.selectedBranch || credential.submit2" ng-if="!credential.isLoggingIn2" ng-click="loginBranchToken()">{{ \'CONFIRM\' | translate }} &nbsp;&gt;</button><div class="loading-animation" ng-if="credential.isLoggingIn2"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="SIGNING_IN"></span> ...</div></div></form></div></div></div></div>');
$templateCache.put('app/pages/login/reset.html','<div class="login-screen-v3"><div class="login-screen-left"><div ng-if="!isKorea"><img class="logo" src="assets/img/login/codemax-logo-blue.png" alt="Codemax"><div class="tagline">Smart Cloud Integrated Solution</div></div><div ng-if="isKorea"><img class="logo" src="assets/img/login/dims-logo.png" alt="DiMS"></div></div><div class="login-screen-right"><div class="login-form"><h2><b><span translate="RESET_PASSWORD"></span></b></h2><br><form><div class="form-group"><label><span translate="EMAIL_ADDRESS"></span></label> <input type="text" class="form-control" id="Email" ng-model="credential.email" required=""></div><br><div class="form-group"><a href="" ng-click="navigateToLogin()" class="forgot-pass">&lt; &nbsp;<span translate="BACK_TO_LOGIN"></span></a> <button type="submit" class="submit-btn btn btn-info" ng-click="resetPassword()" data-ng-disabled="!credential.email"><span translate="RESET_NOW"></span></button></div></form></div></div></div>');
$templateCache.put('app/pages/login/switch.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><p translate="SWITCH_TO_A_DIFFERENT_COMPANY_AND_BRANCH."><span translate="SWITCH_TO_A_DIFFERENT_COMPANY_AND_BRANCH."></span></p><p><br></p><form class="form-horizontal"><div class="form-group"><label for="Company" class="col-sm-1 control-label"><span translate="COMPANY"></span></label><div class="col-sm-3"><select class="form-control" ng-options="c as (c.name | uppercase) for c in user.companies track by c.id" ng-model="company" ng-change="selectCompany(company)"><option value="">-- {{ \'SELECT_A_COMPANY\' | translate }} --</option></select></div></div><div class="form-group"><label for="Branch" class="col-sm-1 control-label">{{ \'BRANCH\' | translate }}</label><div class="col-sm-3"><select class="form-control" ng-options="b as (b.name | uppercase) for b in selectedCompany.branches track by b.id" ng-model="selectedCompany.branches.selected" ng-change="selectBranch(selectedCompany.branches.selected)"><option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option></select></div></div><div class="form-group"><div class="col-sm-offset-1 col-sm-4"><button type="submit" ng-model="submit" class="btn btn-primary btn-auth" data-ng-disabled="!selectedCompany || !selectedBranch || submit" ng-click="loginBranchToken()"><i class="ion ion-checkmark"></i> <span translate="CONFIRM_SWITCH"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard"><i class="ion ion-close"></i> <span translate="BACK"></span></a></div></div></form></div></div></div>');
$templateCache.put('app/pages/assets/assetlist/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="ENTER_THE_DETAILS_OF_THE_ASSET"></span><br><br></p><div class="row"><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="ASSET_CODE"></b></label> <input type="text" class="form-control" name="AssetCode" placeholder="AUTONUMBER" style="text-transform:uppercase;color:#00f" ng-disabled="true" ng-model="vm.asset.code"></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AssetType.$invalid && (vm.dataForm.AssetType.$dirty || vm.dataForm.$submitted)}"><label><b translate="ASSET_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select name="AssetType" class="form-control" ng-options="i as (i.name | uppercase) for i in vm.assetTypes" ng-model="vm.selectedType" ng-change="vm.selectedTypeChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AssetType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Name.$invalid && (vm.dataForm.Name.$dirty || vm.dataForm.$submitted)}"><label><b translate="ASSET_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Name" placeholder="Name" style="text-transform:uppercase" ng-model="vm.asset.name" ng-disabled="vm.asset.warrantyId!=null" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Name.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b translate="ASSET_DESCRIPTION"></b></label> <textarea type="text" class="form-control" placeholder="Description" ng-model="vm.asset.description" ng-disabled="vm.asset.warrantyId!=null">\n\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PoNo.$invalid && (vm.dataForm.PoNo.$dirty || vm.dataForm.$submitted)}"><label><b translate="PURCHASE_ORDER_NUMBER"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="PoNo" style="text-transform:uppercase" ng-model="vm.asset.purchaseOrderNo" ng-disabled="vm.asset.warrantyId!=null" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PoNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InvoiceNo.$invalid && (vm.dataForm.InvoiceNo.$dirty || vm.dataForm.$submitted)}"><label><b translate="INVOICE_NO."></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="InvoiceNo" style="text-transform:uppercase" ng-model="vm.asset.invoiceNo" ng-disabled="vm.asset.warrantyId!=null" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InvoiceNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && (vm.dataForm.SerialNo.$dirty || vm.dataForm.$submitted)}"><label><b translate="SERIAL_NUMBER"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SerialNo" placeholder="Serial Number" style="text-transform:uppercase" ng-model="vm.asset.serialNo" ng-disabled="vm.asset.warrantyId!=null" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AssetStatus.$invalid && (vm.dataForm.AssetStatus.$dirty || vm.dataForm.$submitted)}"><label><b translate="STATUS"></b> <i class="fa fa-asterisk req"></i></label><select name="AssetStatus" class="form-control" ng-options="i as (i.name | uppercase) for i in vm.assetStatuses" ng-model="vm.selectedStatus" ng-change="vm.selectedStatusChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AssetStatus.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Branch.$invalid && (vm.dataForm.Branch.$dirty || vm.dataForm.$submitted)}"><label><b translate="BRANCH"></b> <i class="fa fa-asterisk req"></i></label><select name="Branch" class="form-control" ng-options="i as (i.name | uppercase) for i in vm.branchList" ng-model="vm.selectedBranch" ng-change="vm.selectedBranchChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Branch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Supplier.$invalid && (vm.dataForm.Supplier.$dirty || vm.dataForm.$submitted)}"><label><b translate="SUPPLIER"></b> <i class="fa fa-asterisk req"></i></label><div class="input-group"><span class="input-group-addon" style="padding:0px"><i class="fa fa-question-circle" style="padding:3px 10px" uib-tooltip="To create new or edit Supplier, go to: Maintenance &rarr; Suppliers"></i></span><select name="Supplier" class="form-control" ng-disabled="vm.asset.warrantyId!=null" ng-options="i as (i.name | uppercase) for i in vm.supplierList" ng-model="vm.selectedSupplier" ng-change="vm.selectedSupplierChanged()" required=""><option></option></select></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Supplier.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.selectedEquipment==null && (vm.dataForm.Equipment.$dirty || vm.dataForm.$submitted)}"><label><b translate="EQUIPMENT"></b> <i class="fa fa-asterisk req"></i></label><div class="input-group"><span class="input-group-addon" style="padding:0px"><i class="fa fa-question-circle" style="padding:3px 10px" uib-tooltip="To create new or edit Equipment, go to: Maintenance &rarr; Equipment"></i></span><ui-select name="Equipment" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" ng-disabled="vm.asset.warrantyId!=null" append-to-body="false" search-enabled="true" ng-model="vm.selectedEquipment" on-select="vm.selectedEquipmentChanged()"><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.name | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.equipmentList | orderBy:\'code\' | filter: $select.search" refresh="vm.loadEquipmentList($select.search)" refresh-delay="250" minimum-input-length="2"><span ng-bind-html="vm.beautify(i) | highlight: $select.search"></span></ui-select-choices></ui-select></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.selectedEquipment==null">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.asset.warrantyId==null"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.WarrantyFrom.$invalid && (vm.dataForm.WarrantyFrom.$dirty || vm.dataForm.$submitted)}"><label><b translate="WARRANTY_FROM"></b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.asset.warrantyFrom" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="WarrantyFrom" placeholder="YYYY-MM-DD" ng-disabled="vm.asset.warrantyId!=null" ng-model="vm.asset.warrantyFrom" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WarrantyFrom.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.WarrantyTo.$invalid && (vm.dataForm.WarrantyTo.$dirty || vm.dataForm.$submitted)}"><label><b translate="WARRANTY_TO"></b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.asset.warrantyTo" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="WarrantyTo" placeholder="YYYY-MM-DD" ng-disabled="vm.asset.warrantyId!=null" ng-model="vm.asset.warrantyTo" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WarrantyTo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b translate="REMARKS"></b></label> <textarea class="form-control" placeholder="Remarks" ng-model="vm.asset.remarks">\n\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Properties"><p><i class="fa fa-info-circle"></i> <span translate="ADD_THE_ADDITIONAL_DETAILS_FOR_THIS_ASSET"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddPropModal()"><i class="ion-plus-round"></i><span translate="ADD_NEW_PROPERTY"></span></a><br><br></p><script type="text/ng-template" id="propModal.html"><form name="$mdl.propForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="EQUIPMENT_PROPERTY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.propForm.PropertyName.$invalid && $mdl.propForm.$submitted}"> <label><span translate="PROPERTY_NAME"></span> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="text" name="PropertyName" class="form-control" ng-model="$mdl.item.name" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.propForm.PropertyName.$error.required && $mdl.propForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.propForm.PropertyValue.$invalid && $mdl.propForm.$submitted}"> <label><span translate="PROPERTY_VALUE"></span> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="text" name="PropertyValue" class="form-control" ng-model="$mdl.item.value" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.propForm.PropertyValue.$error.required && $mdl.propForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><div class="row"><div class="col-md-9 col-lg-9"><table class="table table-striped" style="border:1px solid #ccc" st-pipe="vm.refreshProperties" st-table="vm.asset.amAssetProperties" refresh-table=""><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="PROPERTY_NAME"></b></th><th><b translate="PROPERTY_VALUE"></b></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.asset.amAssetProperties"><td>{{ $index+1 }}</td><td>{{ ntn.name || \'\' }}</td><td>{{ ntn.value || \'-\' }}</td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditPropModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeProp($index)" ng-confirm-click="Confirm remove this Property?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="8" align="center" ng-show="vm.asset.amAssetProperties.length==0"><br><span translate="PROPERTY_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Technical Docs"><p><i class="fa fa-info-circle"></i> <span translate="THE_DOCUMENTS_ASSOCIATED_WITH_THE_ASSET."></span> <em>(Maintainance -> Equipment)</em><br><br></p><div class="row"><div class="col-md-8 col-lg-8"><table class="table table-striped" style="border:1px solid #ccc" st-pipe="vm.refreshProperties" st-table="vm.asset.technicalDocuments" refresh-table=""><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="DESCRIPTION"></b></th><th></th></tr></thead><tbody><tr ng-repeat="ntn in vm.asset.technicalDocuments"><td>{{ $index+1 }}</td><td>{{ ntn.description || \'\' }}</td><td><a href="{{ vm.rootUrl }}{{ ntn.filename || \'-\' }}" target="_blank" class="btn btn-xs btn-default"><span translate="OPEN_DOCUMENT"></span></a></td></tr><tr><td colspan="3" align="center" ng-show="vm.asset.technicalDocuments.length==0"><br><span translate="DOCUMENT_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Scheduled Maint."><p><i class="fa fa-info-circle"></i> <span translate="SCHEDULED_ACTIVITIES_FOR_THIS_ASSET"></span><br><br></p><div class="row"><div class="col-md-8 col-lg-8"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="SCHEDULE_DATE"></b></th><th><b translate="DESCRIPTION"></b></th></tr></thead><tbody><tr ng-repeat="ntn in vm.asset.maintenanceSchedules"><td>{{ $index+1 }}</td><td>{{ ntn.scheduleDateText || \'\' }}</td><td>{{ ntn.description || \'\' }}</td></tr><tr><td colspan="3" align="center" ng-show="vm.asset.technicalDocuments.length==0"><br><span translate="SCHEDULE_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.asset.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_ASSET."></span><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br>{{ \'THERE_IS_NO_CHANGES_YET\' | translate }}<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/assets/assetlist/assetCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assets/assetlist/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assets.assetlist.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_ASSET"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assets.assetlist.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/assets/assetlist/assetList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.assetData" refresh-table="" style="font-size:80%"><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Asset" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assets.assetlist.create" rms-check-access="assets.assetlist" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_ASSET"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="branchName">{{ \'BRANCH\' | translate }}</th><th st-sort="type" translate="ASSET_TYPE"></th><th st-sort="code" translate="ASSET_CODE"></th><th st-sort="name" translate="ASSET_NAME"></th><th translate="SERIAL_NO"></th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th st-sort="maintainerName"><span translate="MAINTAINED_BY"></span></th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th></th><th class="form-inline"><select st-search="branchName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="ast in vm.assetDataFull | unique:\'branchName\'" value="{{ast.branchName | uppercase}}">{{ast.branchName | uppercase}}</option></select></th><th class="form-inline"><select st-search="type"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="ast in vm.assetDataFull | unique:\'type\'" value="{{ast.type | uppercase}}">{{ast.type | uppercase}}</option></select></th><th></th><th></th><th></th><th class="form-inline"><select st-search="status"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="ast in vm.assetDataFull | unique:\'status\'" value="{{ast.status | uppercase}}">{{ast.status | uppercase}}</option></select></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA_...\' | translate }}</b></center></big></td></tr><tr ng-if="vm.assetData.length<=0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center translate="NO_RECORD_FOUND"></center></td></tr><tr ng-repeat="item in vm.assetData"><td>{{ vm.startIndex+1+$index }}</td><td>{{ item.branchName }}</td><td>{{ item.type }}</td><td>{{ item.code }}</td><td>{{ item.name }}</td><td>{{ item.serialNo }}</td><td>{{ item.status }}</td><td>{{ item.maintainerName || \'\' }}</td><td align="center"><a href="" title="Print" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" confirmed-click="vm.printAssetLabel(item.id)" ng-confirm-click="Print Asset Label?" rms-check-access="assets.assetlist" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="assets.assetlist.update({id:item.id})" rms-check-access="assets.assetlist" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Warranty" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteAsset(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Asset?" rms-check-access="assets.assetlist" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'NO_RECORD_FOUND\' | translate }} <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/assets/assetlist/assetUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assets/assetlist/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assets.assetlist.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assets.assetlist.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-info btn-with-icon" ng-click="vm.printAssetLabel(vm.asset.id)" ng-disabled="vm.lockButtons"><i class="fa fa-print"></i> <span translate="PRINT_LABEL"></span></a></div></form>');
$templateCache.put('app/pages/billing/addons/addOnList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><p><i class="fa fa-info-circle"></i> Purchase the Storage Add-on to increase tour cloud storage space.</p><br><div class="row"><div class="col-lg-9"><p><b>Purchased Add-Ons:</b> <a href="#purchase" class="btn btn-primary btn-with-icon btn-md" style="margin-left:20px" du-smooth-scroll=""><i class="ion ion-ios-cart"></i> Purchase Add-On</a></p><table class="table table-striped table-hover table-bordered"><tr><th><b>Purchased Date</b></th><th><b>Add-On Name</b></th><th><b>Storage Space (GB)</b></th><th><b>Monthly Fee</b><br><small>(If Pay Monthly)</small></th><th><b>Annual Fee</b><br><small>(If Pay Yearly)</small></th></tr><tr ng-repeat="addOn in vm.addOnList"><td>{{addOn.createdDate | date: "dd-MMM-yyyy" }}</td><td>{{addOn.serverPackage.name}}</td><td>{{addOn.serverPackage.storageSpaceMB / 1024}} GB</td><td>RM {{addOn.serverPackage.monthlyFee}}</td><td>RM {{addOn.serverPackage.annualFee}}</td></tr><tr ng-show="vm.addOnList.length<=0"><td colspan="5"><div style="padding: 10px 0px;text-align:center">No purchase found.</div></td></tr><tr class="table-bordered"><th></th><th><b>TOTAL</b>:</th><th><b>{{vm.getTotalSpaceGB()}} GB</b></th><th><b>RM {{vm.getTotalMonthlyFee()}}</b></th><th><b>RM {{vm.getTotalAnnualFee()}}</b></th></tr></table><br><br>&nbsp;</div></div><div class="row"><div class="col-lg-12"><a name="purchase"></a><p><b>Available Add-On Options:</b></p></div><div class="tile-plan col-xs-12 col-sm-6 col-md-4 col-lg-3" ba-panel="" ng-repeat="plan in vm.packageList | orderBy: \'monthlyFee\'"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="plan-name"><h4><i class="fa fa-cloud-upload fa-2x"></i> {{plan.name | uppercase}}</h4></div><div class="row plan-price-row" ng-if="!plan.isTrial"><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">{{plan.monthlyFee | number}}<br><small>MYR / MONTH</small></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><small>OR</small></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">{{plan.annualFee | number}}<br><small>MYR / YEAR</small></div></div><div class="row button-wrapper button-row"><div class="btn btn-info" ng-hide="vm.isLoading" confirmed-click="vm.selectPackage(plan.id)" ng-confirm-click="Confirm purchase this Add-On?">PURCHASE</div><i class="fa fa-refresh fa-spin fa-3x fa-fw" ng-show="vm.isLoading"></i></div></div></div></div></div><div class="row"><p><br></p></div></div></div></div>');
$templateCache.put('app/pages/billing/invoices/invoiceList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.invoiceData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Invoice" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th>Invoice No.</th><th>Invoice Date</th><th>Due Date</th><th>Is Paid?</th><th>Paid On</th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="item in vm.invoiceData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.invoiceNo}}</td><td>{{item.invoiceDate | date:\'dd/MM/yyyy\'}}</td><td>{{item.dueDate | date:\'dd/MM/yyyy\'}}</td><td><i class="fa fa-check" ng-show="item.isPaid" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isPaid" style="color:#f00"></i></td><td>{{item.paidOn | date:\'dd/MM/yyyy\'}}</td><td align="center"><a href="" title="Print" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ng-click="vm.printInvoice(item.id, item.invoiceNo)"><i class="fa fa-print"></i></a></td></tr><tr ng-if="vm.invoiceData.length<=0"><td colspan="7">No record found.</td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/bulkbreakjobs/bbanalysis/bbanalysis.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="row" style="margin-bottom:10px"><div class="col-md-12 col-lg-12" style="height:35px;line-height:35px;text-align:right;color:#00f"><i class="fa fa-info-circle"></i> Select one or more entries to generate Jobs.</div><div class="col-md-12 col-lg-12" style="height:35px"><div style="display:inline-block;float:left;margin-right:20px"><em><b>Sales Order</b><br><small>Delivery Date</small></em></div><div style="display:inline-block;float:left"><b>{{ \'START_DATE\' | translate }}:</b><br><small>(YYYY-MM-DD)</small></div><div style="display:inline-block;float:left;margin-left:7px"><div moment-picker="vm.startDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group" style="width:100px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="StartDate" placeholder="{{ \'START_DATE\' | translate }}" style="width:100px;background:#fffeed" ng-disabled="vm.isLoading" ng-model="vm.startDate" ng-readonly="true" required=""></div></div><div style="display:inline-block;float:left;margin-left:15px"><b>{{ \'END_DATE\' | translate }}:</b><br><small>(YYYY-MM-DD)</small></div><div style="display:inline-block;float:left;margin-left:7px;margin-right:20px"><div moment-picker="vm.endDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group" style="width:100px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="EndDate" placeholder="{{ \'START_DATE\' | translate }}" style="width:100px;background:#fffeed" ng-disabled="vm.isLoading" ng-model="vm.endDate" ng-readonly="true" required=""></div></div><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.refreshPage()" ng-if="!vm.isLoading"><i class="ion-refresh"></i> Run Analysis</a> <a href="" class="btn btn-success btn-with-icon" confirmed-click="vm.generateJobs()" ng-confirm-click="Confirm proceed to generate Job(s)?" ng-if="!vm.isLoading" ng-show="vm.selectedEntries.length!=0" rms-check-access="bulkbreakjobs.bbanalysis" rms-check-access-perm-type="CREATE"><i class="ion-checkmark-round"></i> Generate Job(s)</a> <span>&nbsp;&nbsp;&nbsp;&nbsp; Analysis Time: <b>{{vm.timeTaken | number:0}}</b> seconds</span></div></div><br><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="B/B Analysis"><div class="horizontal-scroll"><div class="form-group"><div class="form-inline"><form editable-form="" name="vm.tableForm"><table class="table table-bordered table-hover table-striped" style="font-size:100%"><tr><th style="width:50px;text-align:left">#</th><th style="border-right:4px solid #888" class="hide-after"><b>Item Name</b></th><th style="text-align:right;color:#000000;line-height:100%;border-right:1px solid #aaa" class="hide-after"><small><b>Sales Order<br>Quantity</b></small></th><th style="text-align:right;color:#0000ff;line-height:100%;border-right:1px solid #aaa" class="hide-after"><small><b>Inventory<br>Quantity</b></small></th><th style="text-align:right;color:#ff0000;line-height:100%;border-right:4px solid #888" class="hide-after"><small><b>Difference<br>Quantity</b></small></th><th style="text-align:right;color:#9f4f00;line-height:100%;border-right:1px solid #aaa" class="hide-after"><small><b>PAR<br>Level</b></small></th><th style="text-align:right;color:#9f4f00;line-height:100%;border-right:1px solid #aaa" class="hide-after"><small><b>ReOrder<br>Level</b></small></th><th style="text-align:right;color:#9f4f00;line-height:100%;border-right:4px solid #888" class="hide-after"><small><b>ReOrder<br>Quantity</b></small></th><th style="text-align:left;color:#000000;line-height:100%;border-right:1px solid #aaa" class="hide-after"><b>Source Item</b></th><th style="text-align:right;color:#000000;line-height:100%;border-right:4px solid #888" class="hide-after"><b>Source<br>Quantity</b></th><th style="text-align:center;color:#228f00;line-height:100%;border-right:1px solid #aaa"><small><b>Delivery Date<br>(Latest)</b></small></th></tr><tr ng-if="vm.analysisDataFull.length==0 && !vm.isLoading"><td colspan="16" style="height:100px;line-height:100px"><center>No analysis available.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="16" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Generating Analysis ...</b></center></big></td></tr><tr ng-repeat="item in vm.analysisDataFull" ng-if="!vm.isLoading"><td style="text-align:left">{{$index+1}})</td><td style="padding-top:6px;padding-bottom:6px;line-height:120%;border-right:4px solid #888"><b>{{item.itemName}}</b><div ng-if="item.productErrorMessage" ng-bind-html="item.productErrorMessage"></div><div style="margin-top:5px" ng-if="item.salesOrderList.length!=0"><a href="" class="btn btn-xs btn-default" style="background:#eee;font-size:8pt;" ng-click="vm.viewSalesOrders(item.salesOrderList)"><i class="fa fa-eye"></i> &nbsp;View Sales Orders</a></div><div ng-if="item.hasError" style="color:#f00;font-size:8pt;margin-top:5px">Error: {{item.errorMessage}}</div></td><td style="padding-top:6px;text-align:right;color:#000000;border-right:1px solid #aaa;line-height:120%"><b>{{item.salesQty}}</b> <small>{{item.salesUomName}}</small><br>({{item.salesQtyInInvUom}} <small>{{item.inventoryUomName1}}</small>)</td><td style="padding-top:6px;line-height:120%;text-align:right;color:#0000ff;border-right:1px solid #aaa"><b>{{item.inventoryQty1}}</b> <small>{{item.inventoryUomName1}}</small></td><td style="padding-top:6px;text-align:right;border-right:4px solid #888"><div style="color:#f00" ng-if="item.bookingBalanceQtyInv!=0"><b>{{item.salesBalanceQtyInInvUom}}</b> <small>{{item.inventoryUomName1}}</small></div><div style="color:#000" ng-if="item.bookingBalanceQtyInv==0"><b>{{item.salesBalanceQtyInInvUom}}</b> <small>{{item.inventoryUomName1}}</small></div></td><td style="padding-top:6px;text-align:right;color:#9f4f00;border-right:1px solid #aaa"><b>{{item.reOrderParLevel}}</b> <small>{{item.inventoryUomName1}}</small></td><td style="padding-top:6px;text-align:right;color:#9f4f00;border-right:1px solid #aaa"><b>{{item.reOrderLevel}}</b> <small>{{item.inventoryUomName1}}</small></td><td style="padding-top:6px;text-align:right;color:#9f4f00;border-right:4px solid #888"><b>{{item.reOrderQty}}</b> <small>{{item.orderUomName}}</small></td><td style="padding-top:6px;text-align:left;color:#000000;border-right:1px solid #aaa"><div style="line-height:25px"><b>{{item.sourceItemName || \'-\'}}</b></div></td><td style="padding-top:6px;text-align:right;color:#000000;border-right:4px solid #888"><b>{{item.sourceItemQty}}</b> <small>{{item.sourceItemUomName}}</small></td><td style="padding-top:6px;text-align:center;color:#228f00;border-right:1px solid #aaa" nowrap="nowrap"><b>{{item.deliveryDate | date: "dd-MMM-yyyy" }}</b></td></tr></table></form></div></div></div></uib-tab><uib-tab heading="Proposed B/B Jobs"><div class="horizontal-scroll"><div class="form-group"><div class="form-inline"><form editable-form="" name="vm.tableForm"><table class="table table-bordered table-hover table-striped" style="font-size:100%"><tr><th style="width:50px;text-align:left">#</th><th style="text-align:left;color:#000000;line-height:100%;border-right:1px solid #aaa" class="hide-after"><b>Source Item</b></th><th style="text-align:center;color:#000000;line-height:100%;border-right:4px solid #888" class="hide-after"><b>Source<br>Quantity</b></th><th style="text-align:center;color:#ff7800;line-height:100%;border-right:1px solid #aaa" class="hide-after"><b>Pending<br>Job QTY</b></th><th style="text-align:center;color:#0000ff;line-height:100%;border-right:4px solid #888" class="hide-after"><b>Confirmed<br>Job QTY</b></th><th style="text-align:center;color:#228f00;line-height:100%;border-right:1px solid #aaa"><b>Delivery Date<br>(Latest)</b></th><th style="text-align:center;color:#228f00;line-height:100%;border-right:1px solid #aaa"><b>Recommended<br>Bulk-Break<br>Quantity</b></th><th style="text-align:center;color:#228f00;line-height:100%;border-right:4px solid #888" class="hide-after"><b>(User Input)<br>Bulk-Break<br>Quantity</b></th><th style="text-align:center;width:70px;font-size:16pt"><a href="" ng-click="vm.selectAll()" title="Select ALL"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll()" title="De-select ALL" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th></tr><tr ng-if="vm.analysisDataFull.length==0 && !vm.isLoading"><td colspan="16" style="height:100px;line-height:100px"><center>No summary available.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="16" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Generating Analysis Summary ...</b></center></big></td></tr><tr ng-repeat="item in vm.summaryDataFull" ng-if="!vm.isLoading"><td style="text-align:left">{{$index+1}})</td><td style="padding-top:8px;padding-bottom:6px;line-height:120%;border-right:1px solid #aaa"><big><b>{{item.sourceItemName}}</b></big><table border="1" style="width:100%;border-collapse:collapse;font-size:90%;margin-top:5px;margin-bottom:8px;border:2px solid #aaa"><tr><td style="width:52%;padding:3px">Break-down Item Name</td><td style="width:16%;padding:3px;text-align:right">Sales QTY</td><td style="width:16%;padding:3px;text-align:right">Inventory QTY</td><td style="width:16%;padding:3px;text-align:right">Sales Bal QTY</td></tr><tr ng-repeat="ntn in item.breakDownItems"><td style="padding:3px"><b>{{ntn.itemName}}</b></td><td style="padding:3px;text-align:right"><b>{{ntn.salesQty}}</b> {{ntn.salesUomName}}<br>({{ntn.salesQtyInInvUom}} <small>{{ntn.inventoryUomName1}}</small>)</td><td style="padding:3px;text-align:right"><b>{{ntn.inventoryQty1}}</b> {{ntn.inventoryUomName1}}</td><td style="padding:3px;text-align:right"><b>{{ntn.salesBalanceQtyInInvUom}}</b> {{ntn.inventoryUomName1}}</td></tr></table></td><td style="padding-top:6px;text-align:center;color:#000000;border-right:4px solid #888"><b>{{item.totalSourceItemQty}}</b> <small>{{item.sourceItemUomName}}</small></td><td style="padding-top:6px;text-align:center;color:#ff7800;border-right:1px solid #aaa"><b>{{item.totalPendingJobQty}}</b> <small>{{item.sourceItemUomName}}</small></td><td style="padding-top:6px;text-align:center;color:#0000ff;border-right:4px solid #888"><b>{{item.totalConfirmedJobQty}}</b> <small>{{item.sourceItemUomName}}</small></td><td style="padding-top:6px;text-align:center;color:#228f00;border-right:1px solid #aaa" nowrap="nowrap"><b>{{item.deliveryDate | date: "dd-MMM-yyyy" }}</b></td><td style="padding-top:6px;text-align:center;border-right:1px solid #aaa"><div style="color:#228f00" ng-if="item.recommendedJobQuantity!=0"><b>{{item.recommendedJobQuantity}}</b> <small>{{item.sourceItemUomName}}</small></div><div style="color:#000" ng-if="item.recommendedJobQuantity==0">-</div></td><td style="padding-top:2px;text-align:center;border-right:4px solid #888"><div ng-hide="item.hasError"><span editable-text="item.recommendedJobQuantity" e-name="recommendedJobQuantity" e-form="vm.tableForm" e-style="width:60px;font-size:9pt;padding:3px 6px;background:#fffeed" e-min="1" onbeforesave="vm.checkValue(item.productId, $data)">{{ item.recommendedJobQuantity || 1 }}</span></div></td><td style="padding-top:8px;text-align:center;"><div class="checkbox checkbox-primary checkbox-inline" style="padding-left:0px" ng-hide="item.hasError"><input type="checkbox" style="cursor:pointer;padding-left:0px" checklist-model="vm.selectedEntries" checklist-value="item"> <label></label></div></td></tr></table></form></div></div></div></uib-tab></uib-tabset></div></div></div></div><script type="text/ng-template" id="jaSalesOrderModal.html"><div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Sales Order List</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <table class="table table-hover table-striped" st-pipe="$mdl.retrieveData" st-table="$mdl.salesData" refresh-table> <thead> <tr> <th colspan="3"> <div class="row"> <div class="col-lg-5" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search" class="input form-control" style="background:#fffeed" /> </div> </div> <div class="col-lg-7" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </div> </th> </tr> <tr> <th><b>Sales Order No.</b></th> <th style="text-align:right"><b>Order QTY</b></th> </tr> </thead> <tbody> <tr ng-repeat="item in $mdl.salesData"> <td>{{item.salesOrderNo}}</td> <td style="text-align:right"><b>{{item.orderQuantity}}</b> <small>{{item.orderUom}}</small></td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> Close </button> </div></script>');
$templateCache.put('app/pages/bulkbreakjobs/bblist/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-show="vm.originalStatus==\'NEW\'"><i class="fa fa-info-circle"></i> Please fill in the Bulk-Break Job details below.<br><br></p><p ng-show="vm.originalStatus!=\'NEW\'"><i class="fa fa-warning"></i> All the fields will be locked to prevent further edit when the Job Status is no longer <b>NEW</b>.<br><br></p><div class="row"><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Bulk-Break Job Number</b></label> <input type="text" class="form-control" placeholder="AUTONUMBER" ng-model="vm.job.jobNo" ng-disabled="true"></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Status.$invalid && (vm.dataForm.Status.$dirty || vm.dataForm.$submitted)}"><label><b>Bulk-Break Job Status</b> <i class="fa fa-asterisk req"></i></label><select name="Status" class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-change="vm.selectedStatusChanged()" ng-model="vm.selectedStatus" ng-options="i as i.name for i in vm.jobStatuses" ng-show="vm.originalStatus==\'NEW\'" required=""></select><span class="form-control" ng-if="vm.originalStatus!=\'NEW\'" ng-disabled="vm.originalStatus!=\'NEW\'">{{vm.job.status}}</span> <span class="help-block" ng-if="vm.dataForm.$submitted && vm.dataForm.Status.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.JobDate.$invalid && (vm.dataForm.JobDate.$dirty || vm.dataForm.$submitted)}"><label><b>Job Execution Date/Time</b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.job.jobDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="JobDate" placeholder="YYYY-MM-DD" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.job.jobDate"></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.JobDate.$error.required">* Required</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UserGroup.$invalid && (vm.dataForm.UserGroup.$dirty || vm.dataForm.$submitted)}"><label><b>Job Execution By (UserGroup)</b> <i class="fa fa-asterisk req" ng-if="vm.job.status==\'CONFIRMED\'"></i></label><select name="UserGroup" class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.selectedUsergroup" ng-change="vm.selectedUsergroupChanged()" ng-options="i as (i.name | uppercase) for i in vm.usergroupList" ng-required="vm.job.status==\'CONFIRMED\'"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UserGroup.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b>Remarks</b></label> <textarea class="form-control" style="color:#333" ng-disabled="vm.originalStatus!=\'NEW\' || (vm.selectedSemiFg!=null && !vm.isSemiFgRecipeOk) || (vm.selectedProduct!=null && !vm.isProductRecipeOk)" ng-model="vm.job.remarks">\n\t\t\t\t\t\t\t\t\t</textarea></div></div></div><hr><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-if="vm.job.createdBy"><label><b>Created By</b></label> <span class="form-control" ng-disabled="true"><b>{{vm.job.createdBy | uppercase}}</b> ({{vm.job.createdDate | date:\'dd/MM/yyyy hh:mma\'}})</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-if="vm.job.modifiedBy"><label><b>Created By</b></label> <span class="form-control" ng-disabled="true"><b>{{vm.job.modifiedBy | uppercase}}</b> ({{vm.job.modifiedDate | date:\'dd/MM/yyyy hh:mma\'}})</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-if="vm.job.startBy"><label><b>Started By</b></label> <span class="form-control" ng-disabled="true"><b>{{vm.job.startBy | uppercase}}</b> ({{vm.job.startDate | date:\'dd/MM/yyyy hh:mma\'}})</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-if="vm.job.completedBy"><label><b>Completed By</b></label> <span class="form-control" ng-disabled="true"><b>{{vm.job.completedBy | uppercase}}</b> ({{vm.job.completedDate | date:\'dd/MM/yyyy hh:mma\'}})</span></div></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceItem.$invalid && (vm.dataForm.BulkBreakConfig.$dirty || vm.dataForm.$submitted)}"><label><b>Source Item</b> <i class="fa fa-asterisk req"></i></label><select name="SourceItem" class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-change="vm.selectedSourceItemChanged()" ng-model="vm.selectedSourceItem" ng-options="i as (i.sourceItemName | uppercase) for i in vm.sourceItemList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceItem.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.YieldManagement.$invalid && (vm.dataForm.BulkBreakConfig.$dirty || vm.dataForm.$submitted)}"><label><b>Yield Management Configuration</b> <i class="fa fa-asterisk req"></i></label><select name="YieldManagement" class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-change="vm.selectedYmChanged()" ng-model="vm.selectedYm" ng-options="i as (i.description | uppercase) for i in vm.ymList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.YieldManagement.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity.$invalid && (vm.dataForm.Quantity.$dirty || vm.dataForm.$submitted)}"><label><b>Quantity</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity" placeholder="Quantity" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.job.quantity" min="1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.number">* Key in numbers only</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>U.O.M</b></label> <span class="form-control" ng-disabled="true"><b>{{vm.job.uomName}}</b></span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b>List of Expected Break-Down Items:</b></label><div class="col-lg-12" style="padding:15px;background:#f9f9f9"><ul style="margin-bottom:0px;padding-left:15px;line-height:24px" ng-if="vm.ym.yieldManagementDetails!=null && vm.ym.yieldManagementDetails!=0"><li ng-repeat="i in vm.ym.yieldManagementDetails"><b>{{i.itemName | uppercase}}</b>&nbsp;[{{i.yieldPercent}} %]&nbsp;[{{i.quantity * vm.job.quantity}}&nbsp;{{i.uomName}}]</li></ul></div></div></div></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="Break-Down Items" ng-if="vm.mode==2"><p><i class="fa fa-info-circle"></i> A list of break-down items acquired via Bulk-Breaking process.</p><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:2px solid #ccc" st-table="vm.job.bulkBreakJobResultItems" refresh-table=""><thead><tr class="sortable"><th style="width:60px">#</th><th></th><th><b>{{ \'PRODUCT_NAME\' | translate }}</b></th><th style="text-align:right" class="hide-after"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b>{{ \'U.O.M.\' | translate }}</b></th></tr></thead><tbody><tr ng-repeat="ntn in vm.job.bulkBreakJobResultItems"><td>{{$index+1}})</td><td class="text-center" style="width:80px;line-height:100%"><div class="report-type-tag">{{ ntn.itemType }}</div></td><td style="padding-top:8px;padding-bottom:8px;line-height:150%">{{ ntn.itemName || \'\' }}</td><td style="text-align:right">{{ ntn.quantity }}</td><td>{{ ntn.uomName }}</td></tr><tr ng-if="vm.job.bulkBreakJobResultItems.length==0"><td colspan="5" align="center"><br><span translate="ITEMS_PRODUCED_DURING_BULKBREAK_APPEAR_HERE"></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/bulkbreakjobs/bblist/bblistCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/bulkbreakjobs/bblist/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> Create Job</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="bulkbreakjobs.bblist" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/bulkbreakjobs/bblist/bblistList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" style="font-size:90%" st-persist="BulkBreakJobListing" st-pipe="vm.retrieveData" st-table="vm.jobData" st-safe-src="vm.jobDataFull" refresh-table=""><thead><tr><th colspan="14" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Job" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="bulkbreakjobs.bblist.create" ng-if="!vm.showCjsPanel" rms-check-access="bulkbreakjobs.bblist" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> New Bulk-Break Job</a>&nbsp;</div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:40px">#</th><th ng-if="vm.showCjsPanel"></th><th st-sort="jobNo">Job No.</th><th st-sort="jobDate" st-sort-default="true" style="width:100px">Exec. Date<br><small>(DD/MM/YYYY)</small></th><th style="width:350px">Y.M. Description<br>&#8618; &nbsp;Source Item Name</th><th class="hide-after">Quantity</th><th>Remarks</th><th st-sort="status">Status</th><th st-sort="actionBy" style="width:100px">Exec. By</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th colspan="{{vm.showCjsPanel ? 7 : 6}}"><select st-search="isOpen"><option value="true">Show Open Jobs Only</option><option value="">Show All Jobs</option></select></th><th class="form-inline"><select st-search="status"><option value="">ALL</option><option ng-repeat="jd in vm.jobDataFull | unique:\'status\'" value="{{jd.status}}">{{jd.status}}</option></select></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="15" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-if="vm.jobData.length<=0 && !vm.isLoading"><td colspan="15" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-repeat="item in vm.jobData"><td>{{vm.startIndex+1+$index}})</td><td ng-if="vm.showCjsPanel" style="background:#fffc00;width:28px !important"><div class="checkbox checkbox-primary checkbox-inline" style="margin-top:4px;margin-bottom:6px;"><input type="checkbox" name="jobNo" checklist-model="vm.selectedJobs" checklist-value="item.id" checklist-change="vm.dataForm.cate.$setValidity(\'required\', vm.selectedJobs.length > 0)" ng-required="!vm.selectedJobs.length"> <label>&nbsp;</label></div></td><td nowrap="nowrap">{{item.jobNo}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:150%">{{item.jobDate | date: "dd/MM/yyyy hh:mma" }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:150%"><span style="color:#00f"><b>{{item.ymDesc}}</b></span><br>&#8618; &nbsp;{{item.itemName}}</td><td><big><b>{{item.quantity}}</b></big>&nbsp;<small>{{item.uomName}}</small></td><td style="padding-top:8px;padding-bottom:8px;line-height:150%;color:#00f"><b>{{item.remarks}}</b></td><td><b>{{item.status}}</b></td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{(item.actionBy || \'-\' | uppercase | limitTo:15) + (item.actionBy.length > 15 ? \'...\' : \'\') }}</td><td align="center"></td><td align="center"><a href="" title="Print Jobsheet" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#00f" ng-if="item.status.indexOf(\'COMPLETED\')!=-1" ng-click="vm.printJobSheet(item.id, item.jobNo)" rms-check-access="bulkbreakjobs.bblist" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Print Traceability Report" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt" ng-if="item.status.indexOf(\'COMPLETED\')!=-1" ng-click="vm.printYieldReport(item.id, item.jobNo)" rms-check-access="bulkbreakjobs.bblist" rms-check-access-perm-type="EXPORT"><i class="fa fa-file-text text-success"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ng-if="item.status.indexOf(\'COMPLETED\')==-1" ui-sref="bulkbreakjobs.bblist.update({id:item.id})" rms-check-access="bulkbreakjobs.bblist" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a> <a href="" title="View" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ng-if="item.status.indexOf(\'COMPLETED\')!=-1" ui-sref="bulkbreakjobs.bblist.update({id:item.id})" rms-check-access="bulkbreakjobs.bblist" rms-check-access-perm-type="UPDATE"><i class="fa fa-eye"></i></a></td></tr></tbody><tfoot><tr><td colspan="15" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="printModal.html"><form name="$mdl.printForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Print Production Schedule</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.printForm.Year.$invalid && $mdl.printForm.$submitted}"> <label><b>Year:</b> </label> <input type="number" class="form-control" name="Year" style="background:#FFFCED" ng-model="$mdl.year" min=2018 required /> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.Year.$error.required && $mdl.printForm.$submitted">* Required</span> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.Year.$error.number && $mdl.printForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.Year.$error.min && $mdl.printForm.$submitted">* Minimum is 2018</span> </div> </div> </div> <div class="row"> <div class="col-lg-7" style="padding-right:0px"> <div class="form-group" ng-class="{\'has-error\': $mdl.printForm.WeekNo.$invalid && $mdl.printForm.$submitted}"> <label><b>Week Number:</b> </label> <input type="number" class="form-control" name="WeekNo" style="background:#FFFCED" ng-model="$mdl.weekNo" min=1 max=53 required /> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.WeekNo.$error.required && $mdl.printForm.$submitted">* Required</span> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.WeekNo.$error.number && $mdl.printForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.WeekNo.$error.min && $mdl.printForm.$submitted">* Minimum is 1</span> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.WeekNo.$error.max && $mdl.printForm.$submitted">* Maximum is 53</span> </div> </div> <div class="col-lg-5"> <label>&nbsp;</label><br /> <a href class="btn btn-success" ng-click="$mdl.addWeek(1)"> <i class="fa fa-plus"></i> </a> <a href class="btn btn-danger" ng-click="$mdl.addWeek(-1)"> <i class="fa fa-minus"></i> </a> </div> </div> </div> <div class="modal-footer"> <hr /> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-checkmark"></i> Confirm </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> Close </button> <div ng-if="$mdl.lockButton" style="text-align:right:color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b>Processing ...</b> </div> </div> </form></script><script type="text/ng-template" id="labelModal.html"><form name="$mdl.stepForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:80%" st-pipe="$mdl.retrieveData" st-table="$mdl.mvmtData" refresh-table> <thead> <tr> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.item.jobNo}} </div> LABEL LIST </h3> </div> </th> </tr> <tr> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="col-md-4 col-lg-4" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Label" class="input form-control" /> </div> </div> <div class="col-md-8 col-lg-8" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr> <th><b>Code</b></th> <th><b>Description</b></th> <th><b>Storage</b></th> <th><b>Serial Number</b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="4"> <div style="padding:20px 0px"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Labels ...</b></center> </div> </td> </tr> <tr ng-if="$mdl.labelData.length==0"> <td colspan="4">No Label available.</td> </tr> <tr ng-repeat="m in $mdl.labelData"> <td>{{m.productCode | uppercase}}</td> <td>{{m.productName | uppercase}}</td> <td>{{m.storageName | uppercase}}</td> <td>{{m.serialNo | uppercase}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> Close Window </button> </div> </form></script>');
$templateCache.put('app/pages/bulkbreakjobs/bblist/bblistUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/bulkbreakjobs/bblist/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:30px" ui-sref="bulkbreakjobs.bblist" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" style="margin-right:30px" ui-sref="bulkbreakjobs.bblist" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="ion ion-close"></i> Discard Changes</a> <span class="btn btn-with-icon" style="margin-right:30px;color:#fff" ng-if="vm.originalStatus==\'CONFIRMED\'"><i class="fa fa-info-circle"></i> Proceed to next step in Mobile App</span><a href="" class="btn btn-success btn-with-icon" style="margin-left:30px" ng-click="vm.completeJob()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'IN PROGRESS\'"><i class="ion ion-checkmark-round"></i> Complete Bulk-Break Job</a> <a href="" class="btn btn-danger btn-with-icon" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'CONFIRMED\'" ng-confirm-click="Confirm cancel this Bulk-Break Job?" confirmed-click="vm.cancelJob()"><i class="fa fa-trash"></i> Cancel Bulk-Break Job</a></div></form>');
$templateCache.put('app/pages/billing/subscriptions/subscriptionList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><p>Browse the available plans and their features.</p><p><small><i class="fa fa-info-circle"></i> <em>The highlighted one is your current plan</em></small></p><div class="row"><div class="tile-plan col-xs-12 col-sm-6 col-md-4 col-lg-3" ba-panel="" ng-repeat="plan in vm.packageList | orderBy: [\'monthlyFee\',\'name\']"><div class="row" ng-class="{ selected : plan.id==vm.selectedPackageId, \'\' : plan.id!=vm.selectedPackageId }" style="padding-bottom:10px"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="plan-name"><h4>{{plan.name | uppercase}}</h4></div><div class="row plan-row"><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><i class="fa fa-cloud-upload fa-2x"></i></div><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7"><b>{{plan.storageSpaceMB/1024}}GB</b><br><small>CLOUD STORAGE</small></div></div><div class="row plan-row"><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><i class="fa fa-users fa-2x"></i></div><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7"><b>{{plan.trialUserCount}} <span ng-show="plan.trialUserCount==1">USER</span> <span ng-show="plan.trialUserCount!=1">USERS</span></b><br><small>LOGIN ACCOUNT</small></div></div><div class="row plan-price-row" ng-if="!plan.isTrial"><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">{{plan.monthlyFee | number}}<br><small>MYR / MONTH</small></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><small>OR</small></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">{{plan.annualFee | number}}<br><small>MYR / YEAR</small></div></div><div class="row plan-price-row" ng-if="plan.isTrial">FREE<br><small>30 DAYS ACCESS</small></div><div class="row button-wrapper button-row"><div class="btn btn-info" ng-hide="plan.id==vm.selectedPackageId || vm.isLoading" confirmed-click="vm.selectPackage(plan.id)" ng-confirm-click="This will modify your current Subscription. Confirm select this Plan?">SELECT</div><div class="btn btn-success" disabled="disabled" ng-show="plan.id==vm.selectedPackageId && !vm.isLoading"><i class="fa fa-check"></i> CURRENT PLAN</div><i class="fa fa-refresh fa-spin fa-3x fa-fw" ng-show="vm.isLoading"></i></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/bulkbreakjobs/jobdashboard/jobdashboard.html','<script type="text/ng-template" id="confirmModal.html"><form name="$mdl.confirmForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Complete Job: {{$mdl.item.jobNo}}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <span style="color:#f00"><b>Note: Fill the Actual Production Quantity.</b></span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label>Finished Goods</label> <span class="form-control" style="height:auto;font-size:16pt;color:#000"><b>{{$mdl.item.productName}}</b></span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label>Estimated Production Quantity</label> <span class="form-control" style="height:auto;font-size:16pt;color:#000"><b>{{$mdl.item.packingQty}} {{$mdl.item.packingUom}}</b></span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label>Actual Production Quantity</label> <div class="row"> <div class="col-lg-6" style="padding-right:0px"> <input type="number" class="form-control" name="Quantity" style="background:#b7ffb7;height:auto;font-size:16pt;color:#000" ng-model="$mdl.item.actualProductionQuantity" min="1" required /> </div> <div class="col-lg-6" style="padding-left:5px"> <span class="form-control" style="height:auto;font-size:16pt;color:#000"><b> {{$mdl.item.packingUom}} </b></span> </div> </div> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.required">* Required</span> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.number">* Key in numbers only</span> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.min">* Minimum quantity is 1</span> </div> </div> </div> <div class="row" ng-if="$mdl.isLoading"> <div class="col-lg-12"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Processing ...</b></center> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="$mdl.isLoading"> <i class="ion ion-checkmark"></i> Complete Job </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.isLoading"> <i class="ion ion-close"></i> Cancel </button> </div> </form></script><div class="jobdashboard"><div class="row row-equal-height"><div class="col-md-3 col-lg-3" style="padding-left:0px"><input type="text" class="form-control searchbox" name="Search" placeholder="Search for Job" ng-model="searchText"></div><div class="col-md-2 col-lg-2"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.reload()"><i class="ion-refresh"></i> Refresh Dashboard</a></div><div class="col-md-7 col-lg-7" style="line-height:200%">Total Records: <b>{{vm.numOfRecord}}</b></div><br><br>&nbsp;</div><div class="row" ng-show="vm.isLoading"><div class="col-lg-12"><div ba-panel=""><br>&nbsp;<center class="text-primary" style="font-size:14pt"><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Dashboard ...</b></center><br>&nbsp;</div></div></div><div class="row" ng-show="vm.isProcessing"><div class="col-lg-12"><div ba-panel=""><br>&nbsp;<center class="text-success" style="font-size:14pt"><b><i class="fa fa-spinner fa-spin fa-fw"></i> Starting Job ...</b></center><br>&nbsp;</div></div></div><div class="row" ng-show="vm.jobDataFull.length<=0 && !vm.isLoading"><div class="col-lg-12"><div ba-panel="" class="bg-primary"><br>&nbsp;<center style="font-size:14pt"><b><i class="fa fa-clock-o fa-spin fa-fw"></i> Job Dashboard is empty for now.</b></center><br>&nbsp;</div></div></div><div class="row" ng-repeat="item in vm.jobDataFull | filter:searchText"><div class="col-md-12"><div ba-panel=""><div class="row row-equal-height"><div class="col-sm-3 col-md-3 col-lg-2" style="line-height:100%;background:#eee;padding:14px;margin:1px;"><small style="color:#666">EXECUTION DATE</small><br><div class="jobdatedayDiv"><span class="jobdateday"><b>{{item.jobDateDay}}</b></span> <span class="jobdatemonth"><b>{{item.jobDateMonth | uppercase}}</b></span></div><div class="jobdatetimeDiv" ng-if="item.jobTime!=\'12:00AM\'"><span class="jobdatetime"><b>{{item.jobTime | uppercase}}</b></span></div><div class="jobdayDiv"><span class="jobday"><b>{{item.jobDay | uppercase}}</b></span></div></div><div class="col-sm-3 col-md-3 col-lg-2" style="line-height:140%;background:#eee;padding:14px;margin:1px;"><small style="color:#666">JOB NUMBER</small><br><span style="font-size:14pt"><b>{{item.jobNo}}</b></span><br><br><div ng-if="item.salesOrderId!=null"><small style="color:#666">SALES ORDER NUMBER</small><br><span style="font-size:14pt;color:#f00"><b>{{item.salesOrderNo}}</b></span><br><br></div><small style="color:#666">ACTION BY</small><br><span style="font-size:14pt"><b>{{item.userGroupName}}</b></span></div><div class="col-sm-6 col-md-4 col-lg-3" style="line-height:140%;background:#eee;padding:14px;margin:1px;"><small style="color:#666">MISE-EN-PLACE &amp; COOKING</small><br><span style="font-size:14pt"><b>{{item.productName}}</b></span><br><br><small style="color:#666">PACKAGING INSTRUCTION</small><br><span style="font-size:14pt"><b>{{item.packagingInstruction || \'-\'}}</b></span></div><div class="col-sm-3 col-md-3 col-lg-2" style="line-height:140%;background:#eee;padding:14px;margin:1px;"><small style="color:#666">QUANTITY</small><br><span style="font-size:14pt"><b>{{item.quantity}} Batch</b></span><br><br><small style="color:#666">EXPECTED OUTPUT</small><br><span style="font-size:14pt"><b>{{item.packingQuantity}} {{item.packingUom}}</b></span></div><button title="View" class="col-sm-3 col-md-2 col-lg-1 btn btn-info" style="width:130px;line-height:140%;padding:14px;margin:1px;" ng-disabled="vm.isProcessing" ui-sref="recipes.cards.view({id:item.recipeId})"><i class="fa fa-book fa-3x"></i><br><br><b>RECIPE</b></button> <button title="Start" class="col-sm-3 col-md-2 col-lg-1 btn btn-primary" style="width:130px;line-height:140%;padding:14px;margin:1px;" ng-if="!item.isStarted" ng-disabled="vm.isProcessing" confirmed-click="vm.startJob(item.id, item.jobNo)" ng-confirm-click="Start Job = {{item.jobNo}} = ?" rms-check-access="jobs.jobdashboard" rms-check-access-perm-type="UPDATE"><i class="fa fa-play fa-3x"></i><br><br><b>START</b></button> <button title="Complete" class="col-sm-3 col-md-2 col-lg-1 btn btn-warning" style="width:130px;line-height:140%;padding:14px;margin:1px;" ng-if="item.isStarted" ng-disabled="vm.isProcessing" ng-click="vm.showCompleteJobModal(item.id, item.jobNo, item.productName, item.packingQuantity, item.packingUom)" rms-check-access="jobs.jobdashboard" rms-check-access-perm-type="UPDATE"><i class="fa fa-spinner fa-spin fa-3x"></i><br><br><b>WORK IN<br>PROGRESS</b></button></div></div></div></div></div>');
$templateCache.put('app/pages/conference/datadownload/datadownload.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="form-content"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="vm.activeTab"><uib-tab heading="Data Download"><p><i class="fa fa-info-circle"></i> Download and import Google Form data<br><br></p><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Conference.$invalid && (vm.dataForm.Conference.$dirty || vm.dataForm.$submitted)}"><label><b>Select a Conference</b> <i class="fa fa-asterisk req"></i></label><select name="Conference" class="form-control" style="background:#FFFCED" ng-disabled="vm.isLoading" ng-options="c as c.description for c in vm.conferenceList" ng-model="vm.selectedConference" ng-required="vm.activeTab==0"><option value="">-- Select a Conference --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Conference.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StartColumn.$invalid && (vm.dataForm.StartColumn.$dirty || vm.dataForm.$submitted)}"><label><b>Start Column</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="StartColumn" class="form-control" ng-model="vm.startColumn" ng-disabled="vm.isLoading" ng-required="vm.activeTab==0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StartColumn.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.EndColumn.$invalid && (vm.dataForm.EndColumn.$dirty || vm.dataForm.$submitted)}"><label><b>End Column</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="EndColumn" class="form-control" ng-model="vm.endColumn" ng-disabled="vm.isLoading" ng-required="vm.activeTab==0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.EndColumn.$error.required">* Required</span></div></div></div><p><br><br><br></p><div><button type="submit" class="btn btn-primary" ng-disabled="vm.isLoading">Proceed To Download &nbsp;<i class="fa fa-chevron-right"></i></button> <b ng-if="vm.isLoading" style="color:#000"><i class="fa fa-spinner fa-spin fa-fw"></i> Please wait, processing ...</b></div><p><br></p></uib-tab><uib-tab heading="Send SMS"><p><i class="fa fa-info-circle"></i> Send SMS Unique Short Code for registered participants<br><br></p><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Conference.$invalid && (vm.dataForm.Conference.$dirty || vm.dataForm.$submitted)}"><label><b>Select a Conference</b> <i class="fa fa-asterisk req"></i></label><select name="Conference" class="form-control" style="background:#FFFCED" ng-disabled="vm.isLoading" ng-options="c as c.description for c in vm.conferenceList" ng-model="vm.selectedConference" ng-required="vm.activeTab==1"><option value="">-- Select a Conference --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Conference.$error.required">* Required</span></div></div></div><p><br></p><div><button type="submit" class="btn btn-primary" onclick="return confirm(\'Confirm send SMS?\')" ng-disabled="vm.isLoading">Send SMS &nbsp;<i class="fa fa-envelope-o"></i></button> <b ng-if="vm.isLoading" style="color:#000"><i class="fa fa-spinner fa-spin fa-fw"></i> Please wait, processing ...</b></div><p><br></p></uib-tab></uib-tabset></div></div></div></div></form>');
$templateCache.put('app/pages/conference/attendeemgmt/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Conference.$invalid && (vm.dataForm.Conference.$dirty || vm.dataForm.$submitted)}"><label><b>Select a Conference</b> <i class="fa fa-asterisk req"></i></label><select name="Conference" class="form-control" style="background:#FFFCED" ng-disabled="vm.isLoading" ng-change="vm.selectedConferenceChanged()" ng-options="c as c.description for c in vm.conferenceList" ng-model="vm.selectedConference" required=""><option value="">-- Select a Conference --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Conference.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NRIC.$invalid && (vm.dataForm.NRIC.$dirty || vm.dataForm.$submitted)}"><label><b>I/C No. or Passport No. (Format: 840123141234)</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="NRIC" placeholder="I/C Number or Passport Number" ng-model="vm.attendee.nric" autocomplete="off" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NRIC.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Source.$invalid && (vm.dataForm.Source.$dirty || vm.dataForm.$submitted)}"><label><b>Select a Source</b> <i class="fa fa-asterisk req"></i></label><select name="Source" class="form-control" style="background:#FFFCED" ng-disabled="vm.isLoading" ng-change="vm.selectedSourceChanged()" ng-options="c as c.description for c in vm.sources" ng-model="vm.selectedSource" required=""><option value="">-- Select a Source --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Source.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Email.$invalid && (vm.dataForm.Email.$dirty || vm.dataForm.$submitted)}"><label><b>Email Address</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Email" placeholder="Email Address" ng-model="vm.attendee.email" autocomplete="off" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Name.$invalid && (vm.dataForm.Name.$dirty || vm.dataForm.$submitted)}"><label><b>Full Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Name" placeholder="Full Name" ng-model="vm.attendee.name" autocomplete="off" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Name.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Address.$invalid && (vm.dataForm.Address.$dirty || vm.dataForm.$submitted)}"><label><b>Home Address</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Address" placeholder="Home Address" ng-model="vm.attendee.address" autocomplete="off" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Address.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Phone.$invalid && (vm.dataForm.Phone.$dirty || vm.dataForm.$submitted)}"><label><b>Mobile Number (Format: 01xxxxxxxx)</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Phone" placeholder="Phone Number" ng-model="vm.attendee.phone" autocomplete="off" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Phone.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Postcode.$invalid && (vm.dataForm.Postcode.$dirty || vm.dataForm.$submitted)}"><label><b>Post Code</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Postcode" ng-model="vm.attendee.postcode" autocomplete="off" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Postcode.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/conference/attendeemgmt/attendeeCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/conference/attendeemgmt/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="conference.attendeemgmt.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/conference/attendeemgmt/attendeeList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.attendeeData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Attendee" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="conference.attendeemgmt.create" rms-check-access="conference.attendeemgmt" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Attendee</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th colspan="3">Select a Conference: &nbsp;<select name="Conference" style="background:#FFFCED;padding:3px" ng-disabled="vm.isLoading" ng-options="c as c.description for c in vm.conferenceList" ng-model="vm.selectedConference"></select></th><th colspan="6"></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:300px" st-sort="fullName">Full Name</th><th>Short Code</th><th style="width:150px" st-sort="icNumber">NRIC</th><th>Phone</th><th>Email</th><th st-sort="source">Source</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.attendeeData.length==0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.attendeeData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.fullName}}</td><td style="font-family:courier;font-size:10pt;letter-spacing:1px"><b>{{item.smsShortCode}}</b></td><td style="font-family:courier;font-size:10pt;letter-spacing:1px"><b>{{item.icNumber}}</b></td><td style="font-family:courier;font-size:10pt;letter-spacing:1px"><b>{{item.phone}}</b></td><td>{{item.email}}</td><td>{{item.source}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="conference.attendeemgmt.update({id:item.id})" rms-check-access="conference.attendeemgmt" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Print Label" class="btn btn-default btn-with-icon btn-xs" style="display:inline-block;font-size:10pt;color:#00f" confirmed-click="vm.printLabel(item.id)" ng-confirm-click="Confirm print?" rms-check-access="conference.attendeemgmt" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> Print Tag</a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/conference/attendeemgmt/attendeeUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/conference/attendeemgmt/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="conference.attendeemgmt.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="conference.attendeemgmt.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/conference/prospectmgmt/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Conference.$invalid && (vm.dataForm.Conference.$dirty || vm.dataForm.$submitted)}"><label><b>Select a Conference</b> <i class="fa fa-asterisk req"></i></label><select name="Conference" class="form-control" style="background:#FFFCED" ng-disabled="vm.isLoading" ng-change="vm.selectedConferenceChanged()" ng-options="c as c.description for c in vm.conferenceList" ng-model="vm.selectedConference" required=""><option value="">-- Select a Conference --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Conference.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Phone.$invalid && (vm.dataForm.Phone.$dirty || vm.dataForm.$submitted)}"><label><b>Mobile Number (Format: 01xxxxxxxx)</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Phone" placeholder="Phone Number" ng-model="vm.attendee.phone" autocomplete="off" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Phone.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Source.$invalid && (vm.dataForm.Source.$dirty || vm.dataForm.$submitted)}"><label><b>Select a Source</b> <i class="fa fa-asterisk req"></i></label><select name="Source" class="form-control" style="background:#FFFCED" ng-disabled="vm.isLoading" ng-change="vm.selectedSourceChanged()" ng-options="c as c.description for c in vm.sources" ng-model="vm.selectedSource" required=""><option value="">-- Select a Source --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Source.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Email.$invalid && (vm.dataForm.Email.$dirty || vm.dataForm.$submitted)}"><label><b>Email Address</b> <i class="fa fa-asterisk req"></i></label> <input type="email" class="form-control" name="Email" placeholder="Email Address" ng-model="vm.attendee.email" autocomplete="off" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.email">* Invalid Email Format</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Name.$invalid && (vm.dataForm.Name.$dirty || vm.dataForm.$submitted)}"><label><b>Full Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Name" placeholder="Full Name" ng-model="vm.attendee.fullName" autocomplete="off" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Name.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Address.$invalid && (vm.dataForm.Address.$dirty || vm.dataForm.$submitted)}"><label><b>Home Address</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Address" placeholder="Home Address" ng-model="vm.attendee.address" autocomplete="off" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Address.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NRIC.$invalid && (vm.dataForm.NRIC.$dirty || vm.dataForm.$submitted)}"><label><b>I/C No. or Passport No. (Format: 840123141234)</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="NRIC" placeholder="I/C Number or Passport Number" ng-model="vm.attendee.icNumber" autocomplete="off" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NRIC.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Postcode.$invalid && (vm.dataForm.Postcode.$dirty || vm.dataForm.$submitted)}"><label><b>Post Code</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Postcode" ng-model="vm.attendee.postcode" autocomplete="off" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Postcode.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/conference/prospectmgmt/prospectList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.attendeeData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Attendee" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th colspan="3">Select a Conference: &nbsp;<select name="Conference" style="background:#FFFCED;padding:3px" ng-disabled="vm.isLoading" ng-options="c as c.description for c in vm.conferenceList" ng-model="vm.selectedConference"></select></th><th colspan="5"></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:300px" st-sort="fullName">Full Name</th><th style="width:150px" st-sort="icNumber">NRIC</th><th>Phone</th><th>Email</th><th>MyKad Pictures</th><th>Bank Statement<br>Picture</th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.attendeeData.length==0 && !vm.isLoading"><td colspan="8" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="8" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.attendeeData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.fullName}}</td><td>{{item.icNumber}}</td><td>{{item.phone}}</td><td>{{item.email}}</td><td style="line-height:150%;padding-top:8px;padding-bottom:8px;"><span ng-if="item.icImageFront!=null && item.icImageFront!=\'\'">Front: <a href="{{vm.rootUrl}}{{item.icImageFront}}" target="_blank" fancyboxable="{href:\'{{vm.rootUrl}}{{item.icImageFront}}\'}"><u>View Picture</u></a><br></span> <span ng-if="item.icImageBack!=null && item.icImageBack!=\'\'">Back: <a href="{{vm.rootUrl}}{{item.icImageBack}}" target="_blank" fancyboxable="{href:\'{{vm.rootUrl}}{{item.icImageBack}}\'}"><u>View Picture</u></a></span></td><td>{{item.bankStatementImage || "-"}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="conference.prospectmgmt.update({id:item.id})" rms-check-access="conference.prospectmgmt" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/conference/prospectmgmt/prospectUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/conference/prospectmgmt/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="conference.prospectmgmt.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="conference.prospectmgmt.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/dashboard/aftersales/workOrderClock.html','<span class="text-primary">{{ currentDate || \'DDD, DD MMMM YYYY\' }}</span> <span class="text-primary pull-right"><i class="fa fa-clock-o"></i> {{currentTime || \'00:00:00 AM\'}}</span>');
$templateCache.put('app/pages/dashboard/aftersales/workOrderOpenChart.html','<div area-chart="" area-data="areaData" area-xkey="y" area-ykeys=\'["a", "b"]\' area-labels=\'["Opened Jobs", "Closed Jobs"]\' line-colors="lineColors" resize="true" style="height:200px"></div>');
$templateCache.put('app/pages/dashboard/aftersales/workOrderPersonal.html','<div class="row"><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><a href="" class="dashlet type3"><div class="figure">{{vm.dashBasic.newRequisitionCount || \'0\'}}</div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><i class="fa fa-tachometer fa-3x fa-inverse"></i></div></div><div class="caption type3"><span translate="MY_OPENED_WORK_ORDERS"></span></div></a></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><a href="" class="dashlet type1"><div class="figure">{{vm.dashBasic.newRequisitionCount || \'0\'}}</div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><i class="fa fa-tasks fa-3x fa-inverse"></i></div></div><div class="caption type1"><span translate="MY_OPENED_TASKS"></span></div></a></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><a href="" class="dashlet type2"><div class="figure">{{vm.dashBasic.newRequisitionCount || \'0\'}}</div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><i class="fa fa-line-chart fa-3x fa-inverse"></i></div></div><div class="caption type2"><span translate="MY_PERFORMANCE_(KPI)"></span></div></a></div></div>');
$templateCache.put('app/pages/dashboard/aftersales/workOrderStatistic.html','<div id="afterSalesWorkOrderStatistic"><div class="row"><a href="" class="col-md-3 col-lg-3 dashlet2" ba-panel="" ng-click=""><div class="figure">{{vm.dashBasic.newRequisitionCount || \'15\'}}</div><div class="caption">&lt; <span translate="7_DAYS"></span><br><small translate="(JOB_OPENED)"></small></div></a> <a href="" class="col-md-3 col-lg-3 dashlet2" ba-panel="" ng-click=""><div class="figure">{{vm.dashBasic.newRequisitionCount || \'28\'}}</div><div class="caption"><span translate="8_-_14_DAYS"></span><br><small translate="(JOB_OPENED)"></small></div></a> <a href="" class="col-md-3 col-lg-3 dashlet2" ba-panel="" ng-click=""><div class="figure">{{vm.dashBasic.newRequisitionCount || \'22\'}}</div><div class="caption"><span translate="14_-_21_DAYS"></span><br><small translate="(JOB_OPENED)"></small></div></a> <a href="" class="col-md-3 col-lg-3 dashlet2" ba-panel="" ng-click=""><div class="figure">{{vm.dashBasic.newRequisitionCount || \'4\'}}</div><div class="caption">&gt; <span translate="21_DAYS"></span><br><small translate="(JOB_OPENED)"></small></div></a></div><div class="row"><a href="" class="col-md-3 col-lg-3 dashlet2" ba-panel="" ng-click=""><div class="figure">{{vm.dashBasic.newRequisitionCount || \'8\'}}</div><div class="caption" translate="CLOSED_JOBS"></div></a> <a href="" class="col-md-3 col-lg-3 dashlet2" ba-panel="" ng-click=""><div class="figure">{{vm.dashBasic.newRequisitionCount || \'17\'}}</div><div class="caption" translate="CLOSED_TASK"></div></a> <a href="" class="col-md-3 col-lg-3 dashlet2" ba-panel="" ng-click=""><div class="figure">{{vm.dashBasic.newRequisitionCount || \'1.0\'}}</div><div class="caption" translate="AVERAGE_JOBS"></div></a> <a href="" class="col-md-3 col-lg-3 dashlet2" ba-panel="" ng-click=""><div class="figure">{{vm.dashBasic.newRequisitionCount || \'2.3K\'}}</div><div class="caption" translate="REVENUE_(RM)"></div></a></div></div>');
$templateCache.put('app/pages/dashboard_iot/ezymap/ezymap.html','<div id="parentDiv" class="widgets"><div class="row"><div class="col-lg-12" ba-panel=""><div class="row"><div class="col-md-2 col-lg-2" style="padding-right:0px"><div class="row"><div class="col-lg-12"><h3><b translate="DATE_RANGE_FILTER:"></b></h3><div class="row"><div class="col-lg-2" style="padding-top:7px"><span translate="START"></span>:</div><div class="col-lg-10"><div moment-picker="vm.startDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 7px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control input-sm date-picker" style="font-family:courier;font-size:10pt" name="StartDate" placeholder="{{ \'START_DATE\' | translate }}" ng-model="vm.startDate" ng-readonly="true" required=""></div></div></div><div class="row"><div class="col-lg-2" style="padding-top:7px"><span translate="END:"></span></div><div class="col-lg-10"><div moment-picker="vm.endDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 7px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control input-sm date-picker" style="font-family:courier;font-size:10pt" name="EndDate" placeholder="{{ \'END_DATE\' | translate }}" ng-model="vm.endDate" ng-readonly="true" required=""></div></div></div></div></div><div class="row"><div class="col-lg-6" style="padding-top:6px;padding-right:0px"><input type="checkbox" ng-model="vm.lockDateRange"> &nbsp; <i class="fa fa-lock"></i> <span translate="LOCK_DATES"></span></div><div class="col-lg-6"><a href="" ng-click="vm.toggleFullscreen()" class="btn btn-primary btn-with-icon btn-sm" style="width:100%"><i class="fa fa-arrows-alt"></i> <span translate="FULLSCREEN"></span></a></div></div><hr><div class="row"><div class="col-lg-12"><h3><b translate="VEHICLE_LIST:"></b></h3></div></div><div class="row"><div class="col-lg-6"><a href="" ng-click="vm.fitBounds()" class="btn btn-primary btn-with-icon btn-sm" style="width:100%;margin-bottom:10px"><i class="fa fa-map-marker"></i> <span translate="FIT_TO_MAP"></span></a></div><div class="col-lg-6"><a href="" ng-click="vm.gmapPrint()" class="btn btn-primary btn-with-icon btn-sm" style="width:100%;margin-bottom:10px"><i class="fa fa-print"></i> <span translate="PRINT_MAP"></span></a></div></div><div class="row"><div class="col-lg-12"><input type="text" class="form-control searchbox" name="Search" ng-model="searchText" placeholder="Search for Vehicle" style="margin-bottom:10px"></div></div><a href="" class="col-lg-12 btn btn-default" style="margin-bottom:10px" ng-class="{ \'btn-success\' : vm.selectedGateway==null }" ng-click="vm.initData()"><h2 style="margin-bottom:0px;padding-top:5px;padding-bottom:5px"><b>* <span translate="ALL_VEHICLES"></span> *</b><br><span style="font-size:10pt"><span translate="LAST_KNOWN_LOCATIONS"></span></span></h2></a> <a href="" class="col-lg-12 btn btn-default" style="margin-bottom:10px" ng-class="{ \'btn-success\' : vm.selectedGateway.id==g.id }" ng-repeat="g in vm.gateways | filter:searchText as filteredRecord" ng-click="vm.toggleSelectGateway(g)"><h2 style="margin-bottom:0px;padding-top:5px;padding-bottom:5px"><b>{{g.description | uppercase}}</b><br><span style="font-size:10pt"><span translate="UID:"></span> {{g.deviceUID}}</span></h2></a><div style="background:#eee;line-height:40px;padding-top:50px;padding-bottom:50px;font-size:11pt" ng-if="vm.gateways.length==0"><center><span translate="THERE_IS_NO_VEHICLE_AVAILABLE."></span><br><span translate="CLICK"></span> <a href="" ui-sref="iotsettings.gateways.list" style="color:#00f"><u translate="HERE"></u></a> <span translate="TO_ADD_A_VEHICLE."></span></center></div></div><div class="col-md-10 col-lg-10"><div id="ezymap"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard_iot/ezyfarm/ezyfarm.html','<div id="parentDiv" class="widgets"><div class="row"><div class="col-lg-12" ba-panel=""><div class="row"><div class="col-md-2 col-lg-2" style="padding-right:0px"><div class="row"><div class="col-lg-12"><h3><b translate="DATE_RANGE_FILTER:"></b></h3><div class="row"><div class="col-lg-2" style="padding-top:7px"><span translate="START"></span>:</div><div class="col-lg-10"><div moment-picker="vm.startDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 7px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control input-sm date-picker" style="font-family:courier;font-size:10pt" name="StartDate" placeholder="{{ \'START_DATE\' | translate }}" ng-model="vm.startDate" ng-readonly="true" required=""></div></div></div><div class="row"><div class="col-lg-2" style="padding-top:7px"><span translate="END:"></span></div><div class="col-lg-10"><div moment-picker="vm.endDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 7px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control input-sm date-picker" style="font-family:courier;font-size:10pt" name="EndDate" placeholder="{{ \'END_DATE\' | translate }}" ng-model="vm.endDate" ng-readonly="true" required=""></div></div></div></div></div><div class="row"><div class="col-lg-6" style="padding-top:6px;padding-right:0px"><input type="checkbox" ng-model="vm.lockDateRange"> &nbsp; <i class="fa fa-lock"></i> <span translate="LOCK_DATES"></span></div><div class="col-lg-6"><a href="" ng-click="vm.toggleFullscreen()" class="btn btn-primary btn-with-icon btn-sm" style="width:100%"><i class="fa fa-arrows-alt"></i> <span translate="FULLSCREEN"></span></a></div></div><hr><div class="row"><div class="col-lg-12"><h3><b translate="VEHICLE_LIST:"></b></h3></div></div><div class="row"><div class="col-lg-6"><a href="" ng-click="vm.fitBounds()" class="btn btn-primary btn-with-icon btn-sm" style="width:100%;margin-bottom:10px"><i class="fa fa-map-marker"></i> <span translate="FIT_TO_MAP"></span></a></div><div class="col-lg-6"><a href="" ng-click="vm.gmapPrint()" class="btn btn-primary btn-with-icon btn-sm" style="width:100%;margin-bottom:10px"><i class="fa fa-print"></i> <span translate="PRINT_MAP"></span></a></div></div><div class="row"><div class="col-lg-12"><input type="text" class="form-control searchbox" name="Search" ng-model="searchText" placeholder="Search for Vehicle" style="margin-bottom:10px"></div></div><a href="" class="col-lg-12 btn btn-default" style="margin-bottom:10px" ng-class="{ \'btn-success\' : vm.selectedGateway==null }" ng-click="vm.initData()"><h2 style="margin-bottom:0px;padding-top:5px;padding-bottom:5px"><b>* <span translate="ALL_VEHICLES"></span> *</b><br><span style="font-size:10pt"><span translate="LAST_KNOWN_LOCATIONS"></span></span></h2></a> <a href="" class="col-lg-12 btn btn-default" style="margin-bottom:10px" ng-class="{ \'btn-success\' : vm.selectedGateway.id==g.id }" ng-repeat="g in vm.gateways | filter:searchText as filteredRecord" ng-click="vm.toggleSelectGateway(g)"><h2 style="margin-bottom:0px;padding-top:5px;padding-bottom:5px"><b>{{g.description | uppercase}}</b><br><span style="font-size:10pt"><span translate="UID:"></span> {{g.deviceUID}}</span></h2></a><div style="background:#eee;line-height:40px;padding-top:50px;padding-bottom:50px;font-size:11pt" ng-if="vm.gateways.length==0"><center><span translate="THERE_IS_NO_VEHICLE_AVAILABLE."></span><br><span translate="CLICK"></span> <a href="" ui-sref="iotsettings.gateways.list" style="color:#00f"><u translate="HERE"></u></a> <span translate="TO_ADD_A_VEHICLE."></span></center></div></div><div class="col-md-10 col-lg-10"><div id="ezymap"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard_iot/ezysite/ezysite.html','<div><div class="row"><div class="col-lg-12"><div class="row" ng-if="!vm.selectedGateway"><div class="col-lg-12"><div class="panel panel-default"><div class="panel-heading"><b style="color:#000"><span translate="SELECT_A_GATEWAY_TO_VIEW"></span></b></div><div class="panel-body"><div class="row" ng-if="vm.isLoadingGateways"><div class="col-lg-12" style="height:250px;line-height:250px"><big><center><i class="fa fa-spinner fa-spin fa-fw fa-2x"></i> {{\'LOADING...\' | translate}}</center></big></div></div><a href="" class="col-xs-12 col-sm-6 col-md-4 col-lg-3 dashbutton_gateway" ng-repeat="g in vm.gateways | orderBy:\'description\'" ng-click="vm.selectGateway(g.id)"><h2><b>{{g.description | uppercase}}</b><br><small><span translate="UID:"></span> {{g.deviceUID}}</small></h2></a><div class="row" ng-if="!vm.isLoadingGateways && vm.gateways.length==0"><div class="col-lg-12" style="height:250px;line-height:250px"><big><center><i class="fa fa-info-circle"></i> &nbsp;{{\'NO_GATEWAY_DEVICE_IS_AVAILABLE\' | translate}}</center></big></div></div></div></div></div></div><div ng-if="vm.selectedGateway"><div class="row"><div class="col-lg-12"><div class="panel panel-default"><div class="panel-heading" style="height:50px"><div class="row"><div class="col-md-4 col-lg-4"><a href="" ng-click="vm.resetGateway()" class="btn btn-primary btn-xs" style="margin-right:20px"><i class="fa fa-chevron-left"></i> &nbsp;<span translate="BACK"></span></a> <b style="color:#000">{{vm.selectedGateway.description}}</b></div><div class="col-md-4 col-lg-4"><div ng-if="!vm.showAsSummary"><ba-switcher switcher-style="primary" switcher-value="vm.showDangerZone" switcher-change="vm.refreshPanel()" style="float:left;margin-top:-7px;margin-right:-10px"></ba-switcher><b style="float:left;margin-left:10px;color:#333">Show / Hide Danger Zone(s)</b></div></div><div class="col-md-4 col-lg-4"><div class="pull-right"><a href="" class="btn btn-default btn-xs" style="width:75px" ng-class="{ \'btn-success\' : vm.showAsSummary }" ng-click="vm.showSummary()">Summary</a> <a href="" class="btn btn-default btn-xs" style="width:75px" ng-class="{ \'btn-success\' : vm.showAsChart }" ng-click="vm.setColumnWidth(2)">Charts</a></div></div></div></div><div class="panel-body"><div class="row" ng-if="vm.showAsSummary"><div class="col-lg-2 iot2-sensor-box" ng-repeat="s in vm.sensorList"><a href="" class="iot2-sensor-content" ng-class="{ \'iot2-sensor-content-alert\' : (s.toAlertTemp || s.toAlertHumi), \'iot2-sensor-content-offline\' : (!s.hasReadings) }" ng-click="vm.showGraphModal(s)"><div class="iots-sensor-title">{{s.description}}</div><div class="iots-sensor-battery"><div class="battery-{{s.currentBatteryLevel}}"></div></div><div class="iots-sensor-value"><div class="temperature" ng-if="s.hasReadings"><img src="assets/img/icon-temperature2.png" align="left middle"> {{s.currentTemp}} <small>&deg;{{(s.isF?"F":"C")}}</small> <i class="fa fa-exclamation-triangle text-danger" ng-if="s.toAlertTemp"></i></div><div class="humidity" ng-if="s.currentHumi!=-1 && s.hasReadings"><img src="assets/img/icon-humidity2.png" align="left middle"> {{s.currentHumi}} <small>%RH</small> <i class="fa fa-exclamation-triangle text-danger" ng-if="s.toAlertHumi"></i></div><div class="noreading" ng-if="!s.hasReadings"><i class="fa fa-exclamation-triangle text-danger"></i> {{\'Offline\' | translate}}</div></div></a></div></div><div class="row" ng-if="vm.showAsChart && !vm.hidePanel"><div class="col-lg-{{vm.columnWidth}}" style="padding-bottom:0px" ng-repeat="s in vm.selectedGateway.sensors"><iot-ezy-site-graph sensor-id="s.id" sensor-desc="s.description" sensor-device-uid="s.deviceUID" sensor-hide-date-range="vm.hideDateRange" sensor-show-danger-zone="vm.showDangerZone"></iot-ezy-site-graph></div></div><div class="row" ng-if="vm.isLoadingSensors"><div class="col-lg-12" style="height:250px;line-height:250px"><big><center><i class="fa fa-spinner fa-spin fa-fw fa-2x"></i> {{\'LOADING...\' | translate}}</center></big></div></div><div class="row" ng-if="!vm.isLoadingSensors && vm.sensorList.length==0"><div class="col-lg-12" style="height:250px;line-height:250px"><big><center><i class="fa fa-info-circle"></i> &nbsp;{{\'NO_IOT_DEVICE_IS_AVAILABLE\' | translate}}</center></big></div></div></div></div></div></div></div></div></div></div><script type="text/ng-template" id="graphModal.html"><form name="$mdl.graphForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <div style="background:#fff"> <div class="row"> <div class="col-lg-12"> <div class="row"> <div class="col-lg-9"> <div class="sensor-description-modal"> <b>{{$mdl.sensorDesc}}</b> </div> </div> <div class="col-lg-3" style="text-align:right"> <b ng-if="!$mdl.toAlertTemp" class="sensor-temperature-modal"> {{$mdl.currentTemp || 0 | number:1 }}<small>&deg;{{$mdl.symbol}}</small> </b> <b ng-if="$mdl.toAlertTemp" class="sensor-reading sensor-temperature-modal" ng-class="$mdl.toBlink ? \'alert-add\' : \'alert-remove\'"> {{$mdl.currentTemp || 0 | number:1 }}<small>&deg;{{$mdl.symbol}}</small> </b> <span ng-if="$mdl.currentHumi!=0 && $mdl.currentHumi!=-1"> &nbsp;/&nbsp; <b ng-if="!$mdl.toAlertHumi" class="sensor-humidity-modal"> {{$mdl.currentHumi || 0 | number:1 }}<small>% <span translate="RH"></span><small> </b> <b ng-if="$mdl.toAlertHumi" class="sensor-reading sensor-humidity-modal" ng-class="$mdl.toBlink ? \'alert-add\' : \'alert-remove\'"> {{$mdl.currentHumi || 0 | number:1 }}<small>% <span translate="RH"></span><small> </b> </span> </div> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="panel panel-default"> <div class="panel-heading" style="height:56px"> <div class="row"> <div class="col-md-3 col-lg-3"> <div style="line-height:30px"> <div class="sensor-uid" ng-if="$mdl.sensorDeviceUid!=null"> <span translate="UID:"></span> <b>{{$mdl.sensorDeviceUid}}</b> </div> <div class="batt-{{$mdl.currentBatt}}"></div> </div> </div> <div class="col-md-9 col-lg-9" style="color:#000;text-align:right"> <div class="pull-right"> <div style="float:left;display:inline-block;line-height:30px"> <i class="fa fa-lock"></i> <input type="checkbox" ng-model="$mdl.lockDateRange" style="width:22px;height:22px" /> </div> <div style="float:left;display:inline-block;margin-left:7px"> <div moment-picker="$mdl.startDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:140px !important"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control input-sm" name="StartDate" placeholder="{{ \'START_DATE\' | translate }}" style="width:140px;background:#fffeed" ng-model="$mdl.startDate" ng-readonly="true" required /> </div> </div> <div style="float:left;display:inline-block;margin-left:7px;line-height:30px"> <small translate="TO"></small> </div> <div style="float:left;display:inline-block;margin-left:7px"> <div moment-picker="$mdl.endDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:140px !important"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control input-sm" name="EndDate" placeholder="{{ \'END_DATE\' | translate }}" style="width:140px;background:#fffeed" ng-model="$mdl.endDate" ng-readonly="true" required /> </div> </div> <div style="float:left;display:inline-block;margin-left:7px"> <a href ng-click="$mdl.loadData()" class="btn btn-sm btn-default"><span translate="GO"></span></a> </div> </div> </div> </div> </div> <div class="panel-body" ng-class="$mdl.toBlink ? \'alert-add\' : \'alert-remove\'"> <div> <canvas id="chartTemp" class="chart chart-line" chart-colors="$mdl.colors" chart-data="$mdl.dataMain" chart-labels="$mdl.labels" chart-series="$mdl.seriesMain" chart-options="$mdl.optionsMain" chart-dataset-override="$mdl.datasetOverride" style="height:100px" height="100"> </canvas> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/dashboard_iot/ezysite/ezysiteGraph.html','<div style="background:#fff"><div class="row iot-dashboard-preheader"><div class="col-lg-12"><div class="row"><div class="col-lg-7"><div class="{{(sensorHideDateRange ? \'sensor-description-small\' : \'sensor-description\')}}"><b>{{sensorDesc}}</b></div></div><div class="col-lg-5" style="text-align:right"><div ng-class="{ \'double-row\' : sensorHideDateRange && currentHumi!=0 && currentHumi!=-1 }"><b ng-if="!toAlertTemp" class="{{(sensorHideDateRange ? \'sensor-temperature-small\' : \'sensor-temperature\')}}">{{currentTemp || 0 | number:1 }}<small>&deg;{{symbol}}</small></b> <b ng-if="toAlertTemp" class="sensor-reading {{(sensorHideDateRange ? \'sensor-temperature-small\' : \'sensor-temperature\')}}" ng-class="toBlink ? \'alert-add\' : \'alert-remove\'">{{currentTemp || 0 | number:1 }}<small>&deg;{{symbol}}</small></b> <span ng-if="currentHumi!=0 && currentHumi!=-1">&nbsp;/&nbsp; <b ng-if="!toAlertHumi" class="{{(sensorHideDateRange ? \'sensor-humidity-small\' : \'sensor-humidity\')}}">{{currentHumi || 0 | number:1 }}<small>% <span translate="RH"></span><small></small></small></b> <b ng-if="toAlertHumi" class="sensor-reading {{(sensorHideDateRange ? \'sensor-humidity-small\' : \'sensor-humidity\')}}" ng-class="toBlink ? \'alert-add\' : \'alert-remove\'">{{currentHumi || 0 | number:1 }}<small>% <span translate="RH"></span><small></small></small></b></span></div></div></div></div></div><div class="row iot-dashboard-header"><div class="col-lg-12"><div class="panel panel-default"><div class="panel-heading" style="height:{{(sensorHideDateRange ? \'36px\' : \'56px\')}};{{(sensorHideDateRange ? \'padding-top:3px;padding-bottom:3px\' : \'\')}}"><div class="row"><div class="col-md-{{(sensorHideDateRange ? 12 : 3)}} col-lg-{{(sensorHideDateRange ? 12 : 3)}}" style="padding-left:0px!important;padding-right:0px!important;"><div style="line-height:30px"><div class="sensor-uid"><span translate="UID:"></span> <b>{{sensorDeviceUid}}</b></div><div class="batt-{{currentBatt}}"></div><a href="" class="btn btn-default btn-xs" style="color:#00f" ng-if="sensorHideDateRange" ng-click="showGraphModal()"><i class="fa fa-expand"></i></a> <a href="" class="btn btn-xs btn-warning" ng-if="(toAlertTemp || toAlertHumi) && sensorHideDateRange" ng-click="showActionPane()"><i class="fa fa-exclamation-triangle"></i></a></div></div><div class="col-md-9 col-lg-9" style="color:#000;text-align:right;padding-right:0px!important" ng-if="!sensorHideDateRange"><div class="pull-right"><div style="float:left;display:inline-block;line-height:30px"><i class="fa fa-lock" style="font-size:15pt"></i> <input type="checkbox" ng-model="graph.lockDateRange" style="width:22px;height:22px"></div><div style="float:left;display:inline-block;margin-left:7px"><div moment-picker="graph.startDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:135px !important"><span class="input-group-addon" style="padding:3px 7px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control input-sm date-picker" name="StartDate" placeholder="{{ \'START_DATE\' | translate }}" ng-model="graph.startDate" ng-readonly="true" required=""></div></div><div style="float:left;display:inline-block;margin-left:7px;line-height:30px"><small translate="TO"></small></div><div style="float:left;display:inline-block;margin-left:7px"><div moment-picker="graph.endDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:135px !important"><span class="input-group-addon" style="padding:3px 7px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control input-sm date-picker" name="EndDate" placeholder="{{ \'END_DATE\' | translate }}" ng-model="graph.endDate" ng-readonly="true" required=""></div></div><div style="float:left;display:inline-block;margin-left:7px"><a href="" ng-click="loadData()" class="btn btn-sm btn-default"><span translate="GO"></span></a> <a href="" ng-click="showActionPane()" ng-if="toAlertTemp || toAlertHumi" class="btn btn-sm btn-warning"><i class="fa fa-exclamation-triangle"></i></a> <a href="" class="btn btn-default btn-sm sensor-zoom" ng-click="showGraphModal()"><i class="fa fa-expand"></i></a></div></div></div></div></div><div class="panel-body" ng-class="toBlink ? \'alert-add\' : \'alert-remove\'"><div><canvas id="chartTemp" class="chart chart-line" chart-colors="colors" chart-data="dataMain" chart-labels="labels" chart-series="seriesMain" chart-options="optionsMain" chart-dataset-override="datasetOverride" style="height:100px" height="100"></canvas></div></div></div></div></div></div><br><script type="text/ng-template" id="graphModal.html"><form name="$mdl.graphForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <div style="background:#fff"> <div class="row"> <div class="col-lg-12"> <div class="row"> <div class="col-lg-9"> <div class="sensor-description-modal"> <b>{{$mdl.sensorDesc}}</b> </div> </div> <div class="col-lg-3" style="text-align:right"> <b ng-if="!$mdl.toAlertTemp" class="sensor-temperature-modal"> {{$mdl.currentTemp || 0 | number:1 }}<small>&deg;{{$mdl.symbol}}</small> </b> <b ng-if="$mdl.toAlertTemp" class="sensor-reading sensor-temperature-modal" ng-class="$mdl.toBlink ? \'alert-add\' : \'alert-remove\'"> {{$mdl.currentTemp || 0 | number:1 }}<small>&deg;{{$mdl.symbol}}</small> </b> <span ng-if="$mdl.currentHumi!=0 && $mdl.currentHumi!=-1"> &nbsp;/&nbsp; <b ng-if="!$mdl.toAlertHumi" class="sensor-humidity-modal"> {{$mdl.currentHumi || 0 | number:1 }}<small>% <span translate="RH"></span><small> </b> <b ng-if="$mdl.toAlertHumi" class="sensor-reading sensor-humidity-modal" ng-class="$mdl.toBlink ? \'alert-add\' : \'alert-remove\'"> {{$mdl.currentHumi || 0 | number:1 }}<small>% <span translate="RH"></span><small> </b> </span> </div> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="panel panel-default"> <div class="panel-heading" style="height:56px"> <div class="row"> <div class="col-md-3 col-lg-3"> <div style="line-height:30px"> <div class="sensor-uid"><span translate="UID:"></span> <b>{{$mdl.sensorDeviceUid}}</b></div> <div class="batt-{{$mdl.currentBatt}}"></div> </div> </div> <div class="col-md-9 col-lg-9" style="color:#000;text-align:right"> <div class="pull-right"> <div style="float:left;display:inline-block;line-height:30px"> <i class="fa fa-lock"></i> <input type="checkbox" ng-model="$mdl.lockDateRange" style="width:22px;height:22px" /> </div> <div style="float:left;display:inline-block;margin-left:7px"> <div moment-picker="$mdl.startDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:140px !important"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control input-sm" name="StartDate" placeholder="{{ \'START_DATE\' | translate }}" style="width:140px;background:#fffeed" ng-model="$mdl.startDate" ng-readonly="true" required /> </div> </div> <div style="float:left;display:inline-block;margin-left:7px;line-height:30px"> <small translate="TO"></small> </div> <div style="float:left;display:inline-block;margin-left:7px"> <div moment-picker="$mdl.endDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:140px !important"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control input-sm" name="EndDate" placeholder="{{ \'END_DATE\' | translate }}" style="width:140px;background:#fffeed" ng-model="$mdl.endDate" ng-readonly="true" required /> </div> </div> <div style="float:left;display:inline-block;margin-left:7px"> <a href ng-click="$mdl.loadData()" class="btn btn-sm btn-default"><span translate="GO"></span></a> </div> </div> </div> </div> </div> <div class="panel-body" ng-class="$mdl.toBlink ? \'alert-add\' : \'alert-remove\'"> <div> <canvas id="chartTemp" class="chart chart-line" chart-colors="$mdl.colors" chart-data="$mdl.dataMain" chart-labels="$mdl.labels" chart-series="$mdl.seriesMain" chart-options="$mdl.optionsMain" chart-dataset-override="$mdl.datasetOverride" style="height:100px" height="100"> </canvas> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="actionPaneModal.html"><form name="$mdl.actionPaneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header" style="background:#2f59d4"> <h3 class="modal-title" style="color:#fff"> \u3010Sensor UID: {{$mdl.sensor.sensorUID}}\u3011 <span translate="CORRECTIVE_ACTION"></span> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <h4>{{$mdl.sensor.sensorDescription}}</h4> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b translate="CAUSE_OF_THE_INCIDENT"></b></label> <textarea name="Cause" class="form-control" style="background:#fffeed" autocomplete="off" ng-model="$mdl.item.cause" ng-disabled="$mdl.lockButton" required> </textarea> <p class="help-block" style="color:#f00" ng-show="$mdl.actionPaneForm.Cause.$error.required && $mdl.actionPaneForm.$submitted"> * {{\'REQUIRED\' | translate}} </p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b translate="ACTION_TAKEN"></b></label> <textarea name="ActionTaken" class="form-control" style="background:#fffeed" autocomplete="off" ng-model="$mdl.item.actionTaken" ng-disabled="$mdl.lockButton" required> </textarea> <p class="help-block" style="color:#f00" ng-show="$mdl.actionPaneForm.ActionTaken.$error.required && $mdl.actionPaneForm.$submitted"> * {{\'REQUIRED\' | translate}} </p> </div> </div> </div> <legend ng-if="$mdl.showSuccess || $mdl.showError"></legend> <div class="row" ng-if="$mdl.showSuccess"> <div class="col-lg-12"> <span style="color:#0a8a0a"> <i class="fa fa-check"></i> &nbsp; <span translate="CORRECTIVE_ACTION_HAS_BEEN_RECORDED_SUCCESSFULLY"></span>. </span> </div> </div> <div class="row" ng-if="$mdl.showError"> <div class="col-lg-12"> <span style="color:#f00"> <i class="fa fa-exclamation-triangle"></i> &nbsp; <span style="color:#f00" ng-bind-html="$mdl.errorMsg"></span> </span> </div> </div> </div> <legend></legend> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon btn-lg" type="submit" ng-disabled="$mdl.lockButton" style="float:left"> <i class="fa fa-check"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon btn-lg" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/dashboard_iot/ezysite/ezysiteListItem.html','<div style="background:#fff"><div class="row"><div class="col-lg-12"><div class="panel panel-default" style="padding-bottom:0px !important"><div class="panel-heading" style="height:56px" ng-class="toBlink ? \'alert-add\' : \'alert-remove2\'"><div class="row"><div class="col-lg-8" style="padding-left:0px!important;padding-right:0px!important"><div class="sensor-description-small"><a href="" class="btn btn-default btn-xs" style="font-size:12pt;color:#00f" ng-click="showGraphModal()"><i class="fa fa-expand"></i></a> <a href="" class="btn btn-xs btn-warning" style="font-size:12pt" ng-click="showActionPane()" ng-if="toAlertTemp || toAlertHumi"><i class="fa fa-exclamation-triangle"></i></a> &nbsp; <b>{{sensorDesc}}</b></div></div><div class="col-lg-4" style="text-align:right;padding-left:0px!important;padding-right:0px!important"><b class="sensor-temperature-small">{{currentTemp || 0 | number:1 }}<small>&deg;{{symbol}}</small></b> <span ng-if="currentHumi!=0 && currentHumi!=-1">&nbsp;/&nbsp; <b class="sensor-humidity-small">{{currentHumi || 0 | number:1 }}<small>%<span translate="RH"></span><small></small></small></b></span></div></div></div></div></div></div></div><script type="text/ng-template" id="graphModal.html"><form name="$mdl.graphForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <div style="background:#fff"> <div class="row"> <div class="col-lg-12"> <div class="row"> <div class="col-lg-9"> <div class="sensor-description-modal"> <b>{{$mdl.sensorDesc}}</b> </div> </div> <div class="col-lg-3" style="text-align:right"> <b ng-if="!$mdl.toAlertTemp" class="sensor-temperature-modal"> {{$mdl.currentTemp || 0 | number:1 }}<small>&deg;{{$mdl.symbol}}</small> </b> <b ng-if="$mdl.toAlertTemp" class="sensor-reading sensor-temperature-modal" ng-class="$mdl.toBlink ? \'alert-add\' : \'alert-remove\'"> {{$mdl.currentTemp || 0 | number:1 }}<small>&deg;{{$mdl.symbol}}</small> </b> <span ng-if="$mdl.currentHumi!=0 && $mdl.currentHumi!=-1"> &nbsp;/&nbsp; <b ng-if="!$mdl.toAlertHumi" class="sensor-humidity-modal"> {{$mdl.currentHumi || 0 | number:1 }}<small>% <span translate="RH"></span><small> </b> <b ng-if="$mdl.toAlertHumi" class="sensor-reading sensor-humidity-modal" ng-class="$mdl.toBlink ? \'alert-add\' : \'alert-remove\'"> {{$mdl.currentHumi || 0 | number:1 }}<small>% <span translate="RH"></span><small> </b> </span> </div> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="panel panel-default"> <div class="panel-heading" style="height:56px"> <div class="row"> <div class="col-md-3 col-lg-3"> <div style="line-height:30px"> <div class="sensor-uid"><span translate="UID:"></span> <b>{{$mdl.sensorDeviceUid}}</b></div> <div class="batt-{{$mdl.currentBatt}}"></div> </div> </div> <div class="col-md-9 col-lg-9" style="color:#000;text-align:right"> <div class="pull-right"> <div style="float:left;display:inline-block;line-height:30px"> <i class="fa fa-lock"></i> <input type="checkbox" ng-model="$mdl.lockDateRange" /> </div> <div style="float:left;display:inline-block;margin-left:7px"> <div moment-picker="$mdl.startDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:140px !important"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control input-sm" name="StartDate" placeholder="{{ \'START_DATE\' | translate }}" style="width:140px;background:#fffeed" ng-model="$mdl.startDate" ng-readonly="true" required /> </div> </div> <div style="float:left;display:inline-block;margin-left:7px;line-height:30px"> <small translate="TO"></small> </div> <div style="float:left;display:inline-block;margin-left:7px"> <div moment-picker="$mdl.endDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:140px !important"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control input-sm" name="EndDate" placeholder="{{ \'END_DATE\' | translate }}" style="width:140px;background:#fffeed" ng-model="$mdl.endDate" ng-readonly="true" required /> </div> </div> <div style="float:left;display:inline-block;margin-left:7px"> <a href ng-click="$mdl.loadData()" class="btn btn-sm btn-default"><span translate="GO"></span></a> </div> </div> </div> </div> </div> <div class="panel-body" ng-class="$mdl.toBlink ? \'alert-add\' : \'alert-remove\'"> <div> <canvas id="chartTemp" class="chart chart-line" chart-colors="$mdl.colors" chart-data="$mdl.dataMain" chart-labels="$mdl.labels" chart-series="$mdl.seriesMain" chart-options="$mdl.optionsMain" chart-dataset-override="$mdl.datasetOverride" style="height:100px" height="100"> </canvas> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/dashboard_iot/observatory/observatory.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.customerData" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Customer" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:50px">#</th><th st-sort="clientName"><span translate="CUSTOMER_NAME"></span></th><th style="text-align:center" class="hide-after"><span translate="NO._OF_GATEWAYS"></span></th><th style="text-align:center" class="hide-after"><span translate="NO._OF_SENSORS"></span></th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.customerData.length==0 && !vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.customerData"><td style="padding-top:10px;padding-bottom:10px">{{vm.startIndex+1+$index}})</td><td style="padding-top:10px;padding-bottom:10px">{{item.clientName}}</td><td style="text-align:center;padding-top:10px;padding-bottom:10px">{{item.gatewayCount}}</td><td style="text-align:center;padding-top:10px;padding-bottom:10px">{{item.sensorCount}}</td><td style="padding-top:10px;padding-bottom:10px"><a href="" title="View" class="btn btn-warning btn-sm btn-with-icon" style="display:inline-block;font-size:10pt" ng-click="vm.promptSettingDialog(item.clientCompanyId, item.clientName)"><i class="fa fa-cog"></i> <span translate="NOTIFICATION_SETTINGS"></span></a></td><td style="padding-top:10px;padding-bottom:10px"><a href="" title="View" class="btn btn-primary btn-sm btn-with-icon" style="display:inline-block;font-size:10pt" ui-sref="iotdashboard.observatory.overview({id:item.clientCompanyId})"><i class="fa fa-area-chart"></i> <span translate="TEMPERATURE_MONITORING"></span></a></td><td style="padding-top:10px;padding-bottom:10px"><a href="" title="View" class="btn btn-success btn-sm btn-with-icon" style="display:inline-block;font-size:10pt" ng-click="vm.promptReportDialog(item.clientCompanyId, item.clientName)"><i class="fa fa-file"></i> <span translate="GENERATE_REPORT"></span></a></td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="settingModal.html"><form name="$mdl.modalForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="NOTIFICATION_SETTINGS"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <i class="fa fa-info-circle"></i> <a href title="Add Setting" class="btn btn-primary btn-sm pull-right" ng-click="$mdl.addSetting($mdl.accessCompanyId)"> <i class="fa fa-plus"></i> <span translate="ADD_NOTIFICATION_SETTING"></span> </a> <span translate="MANAGE_THE_NOTIFICATION_SETTINGS_TO_RECEIVE_ALERTS_WHEN_CUSTOMER\'S_SENSORS_DETECTED_ABNORMAL_TEMPERATURE."></span> <br /><br /> <span translate="CUSTOMER"></span>: <b>{{$mdl.clientName}}</b> <br /><br /> <table class="table table-striped" style="border:5px solid #eee;font-size:90%"> <thead> <tr> <th rowspan="2" style="width:60px"><b>#</b></th> <!-- <th rowspan="2" style="width:150px"><b translate="BRANCH_NAME"></b></th> --> <th rowspan="2" style="width:100px;text-align:center"><b><span translate="TRIGGER"></span><br /><span translate="ALERT"></span></b></th> <th colspan="2" style="width:100px;text-align:center"><b translate="ALERT_METHOD"></b></th> <th rowspan="2">&nbsp;</th> <th rowspan="2"><b translate="EMAIL"></b></th> <th rowspan="2"><b translate="USER"></b></th> <th rowspan="2"></th> <th rowspan="2"></th> </tr> <tr> <th style="width:100px;text-align:center"><b translate="EMAIL"></b></th> <th style="width:100px;text-align:center;line-height:100%"><b translate="PUSH_NOTIFICATION"></b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.settings.length<=0 && !$mdl.isLoading"> <td colspan="9" style="height:100px;line-height:100px"> <center>{{ \'NO_RECORD_FOUND\' | translate }}</center> </td> </tr> <tr ng-if="$mdl.isLoading"> <td colspan="9" style="height:100px;line-height:100px"> <big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big> </td> </tr> <tr ng-repeat="item in $mdl.settings"> <td>{{$mdl.startIndex+1+$index}})</td> <!-- <td>{{item.branchName}}</td> --> <td style="text-align:center"> <i class="fa fa-check" ng-if="item.triggerAlert" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.triggerAlert" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-if="item.alertByEmail" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.alertByEmail" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-if="item.alertByPN" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.alertByPN" style="color:#f00"></i> </td> <td>&nbsp;</td> <td>{{item.email}}</td> <td>{{item.username}}</td> <td align="center"> <a href title="Edit" class="btn btn-primary btn-xs" style="display:inline-block;font-size:10pt" ng-disabled="$mdl.isLoading || $mdl.isLockButtons" ng-click="$mdl.editSetting(item.id, $mdl.accessCompanyId)"> <i class="fa fa-pencil"></i> </a> </td> <td align="center"> <a href title="Delete Setting" class="btn btn-danger btn-xs" style="display:inline-block;font-size:10pt" ng-disabled="$mdl.isLoading || $mdl.isLockButtons" confirmed-click="$mdl.deleteSetting(item.id)" ng-confirm-click="Confirm remove this setting?"> <i class="fa fa-trash"></i> </a> </td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer" style="text-align:center !important"> <br /><br /> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.isLoading || $mdl.isLockButtons"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="manageSettingModal.html"><form name="$mdl.modalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }}<span translate="NOTIFICATION_SETTINGS"></span></h3> </div> <div class="modal-body" id="modal-body"><div class="row"> <div class="col-md-3 col-lg-3"> <div class="form-group"> <label><b translate="ENABLED"></b></label> <div> <toggle ng-model="$mdl.setting.triggerAlert" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> <!-- <div class="col-md-8 col-lg-8"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Branch.$invalid && ($mdl.modalForm.Branch.$dirty || $mdl.modalForm.$submitted)}"> <label><b translate="CUSTOMER\'S_BRANCH"></b> <i class="fa fa-asterisk req"></i></label> <select name="Branch" class="form-control" style="background:#FFFCED" ng-change="$mdl.selectBranch()" ng-disabled="!$mdl.setting.triggerAlert" ng-options="b as b.name for b in $mdl.branches | orderBy:\'name\' " ng-model="$mdl.selectedBranch" required> <option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.modalForm.Branch.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> --> </div> <div class="row"> <div class="col-md-3 col-lg-3"> <div class="form-group"> <label><b translate="EMAIL_ALERT"></b></label> <div> <toggle ng-model="$mdl.setting.alertByEmail" ng-change="changed()" on="ON" off="OFF" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> <div class="col-md-8 col-lg-8" ng-if="$mdl.setting.alertByEmail"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Email.$invalid && ($mdl.modalForm.Email.$dirty || $mdl.modalForm.$submitted)}"> <label><b translate="EMAIL_ADDRESS"></b> <i class="fa fa-asterisk req"></i> &nbsp;<span translate="(USE_SEMI-COLON_TO_SPECIFY_MULTIPLE_EMAILS)"></span></label> <input type="email" class="form-control" name="Email" placeholder="Email" ng-model="$mdl.setting.email" ng-required="$mdl.setting.alertByEmail"> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.modalForm.Email.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.modalForm.Email.$error.email">* <span translate="INVALID_EMAIL_FORMAT"></span></span> </div> </div> </div> <div class="row" ng-hide="true"> <div class="col-md-2 col-lg-2"> <div class="form-group"> <label><b translate="SMS_ALERT"></b></label> <div> <toggle ng-model="$mdl.setting.alertBySms" ng-disabled="true" ng-change="changed()" on="ON" off="OFF" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> <div class="col-md-8 col-lg-8" ng-if="$mdl.setting.alertBySms"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.SMS.$invalid && ($mdl.modalForm.SMS.$dirty || $mdl.modalForm.$submitted)}"> <label><b translate="MOBILE_NUMBER"></b> <small>(<span translate="FORMAT"></span>: 601xxxxxxxx)</small><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SMS" placeholder="Mobile Number" ng-model="$mdl.setting.sms" ng-required="$mdl.setting.alertBySms"> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.modalForm.SMS.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-md-3 col-lg-3"> <div class="form-group"> <label><b translate="PUSH_NOTIFICATION"></b></label> <div> <toggle ng-model="$mdl.setting.alertByPN" ng-change="changed()" on="ON" off="OFF" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> <div class="col-md-8 col-lg-8" ng-if="$mdl.setting.alertByPN"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.User.$invalid && ($mdl.modalForm.User.$dirty || $mdl.modalForm.$submitted)}"> <label><b translate="SELECT_A_USER"></b> <i class="fa fa-asterisk req"></i> &nbsp;( <span translate="USER_WILL_RECEIVE_PUSH_NOTIFICATION_ON_MOBILE_APP"></span>)</label> <select name="User" class="form-control" style="background:#FFFCED" ng-change="$mdl.selectUser()" ng-options="b as (b.firstName + \' \' + b.lastName | uppercase) for b in $mdl.users | orderBy:\'firstName\' " ng-model="$mdl.selectedUser" ng-required="$mdl.setting.alertByPN"> <option value="">-- {{ \'SELECT_A_USER\' | translate }} --</option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.modalForm.User.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="modal-footer"> <br /><br /> <b ng-if="$mdl.isLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="LOADING"></span> ...</b> <b ng-if="$mdl.lockButtons"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons || $mdl.isLoading"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButtons || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="reportModal.html"><form name="$mdl.modalForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="GENERATE_REPORT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12" style="color:#000"> <i class="fa fa-info-circle"></i><span translate="SELECT_A_DATE_RANGE_AND_SENSOR,TO_GENERATE_THE_TEMPERATURE_REPORT_IN_PDF/EXCEL_FORMAT."></span> <br /><br /> <span translate="CUSTOMER_NAME"></span>:<br /> <h2>{{$mdl.clientName}}</h2> <br /> <div class="row"> <div class="col-lg-6"> <div class="form-group"> <label style="color:#000"><b translate="DATE_FROM:"></b> <i class="fa fa-asterisk req"></i></label> <div moment-picker="$mdl.dateFrom" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control" name="DateFrom" autocomplete="off" ng-disabled="$mdl.isProcessing" ng-model="$mdl.dateFrom"> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.downloadForm.DateFrom.$error.required && $mdl.downloadForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label style="color:#000"><b translate="DATE_TO:"></b> <i class="fa fa-asterisk req"></i></label> <div moment-picker="$mdl.dateTo" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control" name="DateTo" autocomplete="off" ng-disabled="$mdl.isProcessing" ng-model="$mdl.dateTo"> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.downloadForm.DateTo.$error.required && $mdl.downloadForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b translate="SELECT_A_SENSOR:"></b></label> <select class="form-control" ng-disabled="$mdl.isProcessing" ng-options="s as (s.gatewayDescription + \' -> \' + s.description | uppercase) for s in $mdl.sensorList | orderBy:[\'gatewayDescription\',\'description\']" ng-model="$mdl.selectedSensor"> <option></option> </select> </div> </div> </div> </div> </div> </div> <hr /> <div class="modal-footer"> <div> <button type="button" class="btn btn-warning btn-with-icon btn-md" style="width:150px;float:left" ng-disabled="$mdl.isProcessing" ng-click="$mdl.downloadPdf()"> <i class="fa fa-download"></i> <b translate="PDF"></b> </button> <button type="button" class="btn btn-primary btn-with-icon btn-md" style="width:150px;float:left" ng-disabled="$mdl.isProcessing" ng-click="$mdl.downloadExcel()"> <i class="fa fa-download"></i> <b translate="EXCEL"></b> </button> <button type="button" class="btn btn-danger btn-with-icon btn-md" ng-disabled="$mdl.isProcessing" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> <div ng-if="$mdl.isProcessing" style="text-align:left !important;padding:10px 0px 0px;color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="GENERATING_REPORT,_PLEASE_WAIT_..."></span> </div> </div> </form></script>');
$templateCache.put('app/pages/dashboard_iot/observatory/observatoryOverview.html','<div><div class="row"><div class="col-lg-12"><div class="row" ng-if="!vm.selectedGateway"><div class="col-lg-12"><div class="panel panel-default"><div class="panel-heading"><a href="" ng-click="vm.goBack()" class="btn btn-primary btn-xs" style="margin-right:20px"><i class="fa fa-chevron-left"></i> &nbsp; <span translate="BACK"></span></a> <b style="color:#000">{{vm.gateways[0].companyName | uppercase}}</b></div><div class="panel-body"><div class="row"><div class="col-lg-12"><span translate="SELECT_A_GATEWAY_TO_VIEW"></span><p><br></p></div></div><div class="row"><a href="" class="col-xs-12 col-sm-6 col-md-3 col-lg-3 dashbutton" ba-panel="" ng-repeat="g in vm.gateways" ng-click="vm.selectGateway(g.id)"><span class="fa-stack fa-lg fa-3x text-info"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-wifi fa-stack-1x fa-inverse"></i></span><h2><b>{{g.description | uppercase}}</b></h2></a></div></div></div></div></div><div ng-if="vm.selectedGateway"><div class="row"><div class="col-lg-12"><div class="panel panel-default"><div class="panel-heading"><a href="" ng-click="vm.resetGateway()" class="btn btn-primary btn-xs" style="margin-right:20px"><i class="fa fa-chevron-left"></i> &nbsp;<span translate="BACK"></span></a> <b style="color:#000">{{vm.gateways[0].companyName | uppercase}}</b> &nbsp;<i class="fa fa-caret-right"></i>&nbsp; <b style="color:#000">{{vm.selectedGateway.description | uppercase}}</b><div class="pull-right"><small translate="COLUMNS:"></small> <a href="" class="btn btn-default btn-xs" ng-click="vm.setColumnWidth(2)">&nbsp;2&nbsp;</a> <a href="" class="btn btn-default btn-xs" ng-click="vm.setColumnWidth(4)">&nbsp;4&nbsp;</a> <a href="" class="btn btn-default btn-xs" ng-click="vm.showList()">&nbsp;<i class="fa fa-list"></i>&nbsp;</a></div></div><div class="panel-body"><div class="row"><div class="col-lg-{{vm.columnWidth}}" style="padding-bottom:0px" ng-if="!vm.showAsList" ng-repeat="s in vm.selectedGateway.sensors"><iot-ezy-site-graph sensor-id="s.id" sensor-desc="s.description" sensor-device-uid="s.deviceUID" sensor-hide-date-range="vm.hideDateRange"></iot-ezy-site-graph></div><div class="col-lg-6" style="padding-bottom:0px" ng-if="vm.showAsList" ng-repeat="s in vm.selectedGateway.sensors"><iot-ezy-site-list-item sensor-id="s.id" sensor-desc="s.description" sensor-device-uid="s.deviceUID" sensor-hide-date-range="vm.hideDateRange"></iot-ezy-site-list-item></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard_iot/smartiot/smartGateway.html','<div style="background:#fff"><div class="row iot-dashboard-preheader"><div class="col-lg-12"><div class="row"><div class="col-lg-7"><div class="{{(sensorHideDateRange ? \'sensor-description-small\' : \'sensor-description\')}}"><b>{{sensorDesc}}</b></div></div><div class="col-lg-5" style="text-align:right"></div></div></div></div><div class="row iot-dashboard-header"><div class="col-lg-12"><div class="panel panel-default"><div class="panel-heading"><div class="row"><div class="col-md-12 col-lg-12" style="padding-left:0px!important;padding-right:0px!important;"><div class="sensor-uid"><span translate="UID:"></span> <b>{{sensorDeviceUid}}</b></div></div></div></div><div class="panel-body" style=""><div class="row"><div class="col-sm-3 col-md-3 col-lg-3" ba-panel=""><div class="row"><div class="col-lg-12"><div class="row"><div class="col-sm-2 col-md-2 col-lg-2" style="padding-top:5px"><i class="fa fa-power-off fa-2x text-success" ng-if="gateway.deviceIO_01_DefaultStatus && gateway.deviceIO_01_Status"></i> <i class="fa fa-power-off fa-2x text-danger" ng-if="gateway.deviceIO_01_DefaultStatus && !gateway.deviceIO_01_Status"></i> <i class="fa fa-power-off fa-2x" ng-if="!gateway.deviceIO_01_DefaultStatus" style="color:#888"></i></div><div class="col-sm-10 col-md-10 col-lg-10"><div style="line-height:120%"><b style="font-size:120%;color:#00f" ng-if="gateway.deviceIO_01_Description!=null">{{gateway.deviceIO_01_Description}}</b> <b style="font-size:120%;color:#666" ng-if="gateway.deviceIO_01_Description==null">I/O Not In Use</b><div class="text-success" ng-if="gateway.deviceIO_01_DefaultStatus && gateway.deviceIO_01_Status">Running normally.</div><div class="text-danger" ng-if="gateway.deviceIO_01_DefaultStatus && !gateway.deviceIO_01_Status">Not Running.</div><div style="color:#888" ng-if="!gateway.deviceIO_01_DefaultStatus">Turned off</div><div ng-if="gateway.deviceIO_01_ErrorCode!=\'\' && gateway.deviceIO_01_ErrorCode!=\'00\' && gateway.deviceIO_01_ErrorCode!=null">Error Code: <b class="text-danger">{{gateway.deviceIO_01_ErrorCode}}</b></div></div></div></div></div></div></div><div class="col-sm-3 col-md-3 col-lg-3" ba-panel=""><div class="row"><div class="col-lg-12"><div class="row"><div class="col-sm-2 col-md-2 col-lg-2" style="padding-top:5px"><i class="fa fa-power-off fa-2x text-success" ng-if="gateway.deviceIO_02_DefaultStatus && gateway.deviceIO_02_Status"></i> <i class="fa fa-power-off fa-2x text-danger" ng-if="gateway.deviceIO_02_DefaultStatus && !gateway.deviceIO_02_Status"></i> <i class="fa fa-power-off fa-2x" ng-if="!gateway.deviceIO_02_DefaultStatus" style="color:#888"></i></div><div class="col-sm-10 col-md-10 col-lg-10"><div style="line-height:120%"><b style="font-size:120%;color:#00f" ng-if="gateway.deviceIO_02_Description!=null">{{gateway.deviceIO_02_Description}}</b> <b style="font-size:120%;color:#666" ng-if="gateway.deviceIO_02_Description==null">I/O Not In Use</b><div class="text-success" ng-if="gateway.deviceIO_02_DefaultStatus && gateway.deviceIO_02_Status">Running normally.</div><div class="text-danger" ng-if="gateway.deviceIO_02_DefaultStatus && !gateway.deviceIO_02_Status">Not Running.</div><div style="color:#888" ng-if="!gateway.deviceIO_02_DefaultStatus">Turned off</div><div ng-if="gateway.deviceIO_02_ErrorCode!=\'\' && gateway.deviceIO_02_ErrorCode!=\'00\' && gateway.deviceIO_02_ErrorCode!=null">Error Code: <b class="text-danger">{{gateway.deviceIO_02_ErrorCode}}</b></div></div></div></div></div></div></div><div class="col-sm-3 col-md-3 col-lg-3" ba-panel=""><div class="row"><div class="col-lg-12"><div class="row"><div class="col-sm-2 col-md-2 col-lg-2" style="padding-top:5px"><i class="fa fa-power-off fa-2x text-success" ng-if="gateway.deviceIO_03_DefaultStatus && gateway.deviceIO_03_Status"></i> <i class="fa fa-power-off fa-2x text-danger" ng-if="gateway.deviceIO_03_DefaultStatus && !gateway.deviceIO_03_Status"></i> <i class="fa fa-power-off fa-2x" ng-if="!gateway.deviceIO_03_DefaultStatus" style="color:#888"></i></div><div class="col-sm-10 col-md-10 col-lg-10"><div style="line-height:120%"><b style="font-size:120%;color:#00f" ng-if="gateway.deviceIO_03_Description!=null">{{gateway.deviceIO_03_Description}}</b> <b style="font-size:120%;color:#666" ng-if="gateway.deviceIO_03_Description==null">I/O Not In Use</b><div class="text-success" ng-if="gateway.deviceIO_03_DefaultStatus && gateway.deviceIO_03_Status">Running normally.</div><div class="text-danger" ng-if="gateway.deviceIO_03_DefaultStatus && !gateway.deviceIO_03_Status">Not Running.</div><div style="color:#888" ng-if="!gateway.deviceIO_03_DefaultStatus">Turned off</div><div ng-if="gateway.deviceIO_03_ErrorCode!=\'\' && gateway.deviceIO_03_ErrorCode!=\'00\' && gateway.deviceIO_03_ErrorCode!=null">Error Code: <b class="text-danger">{{gateway.deviceIO_03_ErrorCode}}</b></div></div></div></div></div></div></div><div class="col-sm-3 col-md-3 col-lg-3" ba-panel=""><div class="row"><div class="col-lg-12"><div class="row"><div class="col-sm-2 col-md-2 col-lg-2" style="padding-top:5px"><i class="fa fa-power-off fa-2x text-success" ng-if="gateway.deviceIO_04_DefaultStatus && gateway.deviceIO_04_Status"></i> <i class="fa fa-power-off fa-2x text-danger" ng-if="gateway.deviceIO_04_DefaultStatus && !gateway.deviceIO_04_Status"></i> <i class="fa fa-power-off fa-2x" ng-if="!gateway.deviceIO_04_DefaultStatus" style="color:#888"></i></div><div class="col-sm-10 col-md-10 col-lg-10"><div style="line-height:120%"><b style="font-size:120%;color:#00f" ng-if="gateway.deviceIO_04_Description!=null">{{gateway.deviceIO_04_Description}}</b> <b style="font-size:120%;color:#666" ng-if="gateway.deviceIO_04_Description==null">I/O Not In Use</b><div class="text-success" ng-if="gateway.deviceIO_04_DefaultStatus && gateway.deviceIO_04_Status">Running normally.</div><div class="text-danger" ng-if="gateway.deviceIO_04_DefaultStatus && !gateway.deviceIO_04_Status">Not Running.</div><div style="color:#888" ng-if="!gateway.deviceIO_04_DefaultStatus">Turned off</div><div ng-if="gateway.deviceIO_04_ErrorCode!=\'\' && gateway.deviceIO_04_ErrorCode!=\'00\' && gateway.deviceIO_04_ErrorCode!=null">Error Code: <b class="text-danger">{{gateway.deviceIO_04_ErrorCode}}</b></div></div></div></div></div></div></div><div class="col-sm-3 col-md-3 col-lg-3" ba-panel=""><div class="row"><div class="col-lg-12"><div class="row"><div class="col-sm-2 col-md-2 col-lg-2" style="padding-top:5px"><i class="fa fa-power-off fa-2x text-success" ng-if="gateway.deviceIO_05_DefaultStatus && gateway.deviceIO_05_Status"></i> <i class="fa fa-power-off fa-2x text-danger" ng-if="gateway.deviceIO_05_DefaultStatus && !gateway.deviceIO_05_Status"></i> <i class="fa fa-power-off fa-2x" ng-if="!gateway.deviceIO_05_DefaultStatus" style="color:#888"></i></div><div class="col-sm-10 col-md-10 col-lg-10"><div style="line-height:120%"><b style="font-size:120%;color:#00f" ng-if="gateway.deviceIO_05_Description!=null">{{gateway.deviceIO_05_Description}}</b> <b style="font-size:120%;color:#666" ng-if="gateway.deviceIO_05_Description==null">I/O Not In Use</b><div class="text-success" ng-if="gateway.deviceIO_05_DefaultStatus && gateway.deviceIO_05_Status">Running normally.</div><div class="text-danger" ng-if="gateway.deviceIO_05_DefaultStatus && !gateway.deviceIO_05_Status">Not Running.</div><div style="color:#888" ng-if="!gateway.deviceIO_05_DefaultStatus">Turned off</div><div ng-if="gateway.deviceIO_05_ErrorCode!=\'\' && gateway.deviceIO_05_ErrorCode!=\'00\' && gateway.deviceIO_05_ErrorCode!=null">Error Code: <b class="text-danger">{{gateway.deviceIO_05_ErrorCode}}</b></div></div></div></div></div></div></div></div></div></div></div></div></div><br>');
$templateCache.put('app/pages/dashboard_iot/smartiot/smartSensor.html','<div style="background:#fff"><div class="row iot-dashboard-preheader"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="{{(sensorHideDateRange ? \'siot-sensor-description-small\' : \'siot-sensor-description\')}}">{{sensor.description}}</div></div></div></div></div><div class="row iot-dashboard-header"><div class="col-lg-12"><div class="panel panel-default"><div class="panel-heading" style="height:{{(sensorHideDateRange ? \'36px\' : \'56px\')}};{{(sensorHideDateRange ? \'padding-top:3px;padding-bottom:3px\' : \'\')}}"><div class="row"><div class="col-md-{{(sensorHideDateRange ? 12 : 4)}} col-lg-{{(sensorHideDateRange ? 12 : 4)}}" style="padding-left:0px!important;padding-right:0px!important;"><div style="line-height:30px"><div class="sensor-uid"><small><b>{{sensor.deviceUID}}</b></small></div><div class="batt-{{getBatteryClass(sensor.batteryLevel)}}"></div><a href="" class="btn btn-default btn-xs" style="color:#00f" ng-if="sensorHideDateRange" ng-click="showGraphModal()"><i class="fa fa-expand"></i></a> <a href="" class="btn btn-xs btn-warning" ng-if="(toAlertTemp || toAlertHumi) && sensorHideDateRange" ng-click="showActionPane()"><i class="fa fa-exclamation-triangle"></i></a></div></div><div class="col-md-8 col-lg-8" style="color:#000;text-align:right;padding-left:0px!important;padding-right:0px!important" ng-if="!sensorHideDateRange"><div class="pull-right"><div style="float:left;display:inline-block;line-height:30px"><i class="fa fa-lock" style="font-size:15pt"></i> <input type="checkbox" ng-model="graph.lockDateRange" style="width:22px;height:22px"></div><div style="float:left;display:inline-block;margin-left:7px"><div moment-picker="graph.startDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:135px !important"><span class="input-group-addon" style="padding:3px 7px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control input-sm date-picker" name="StartDate" placeholder="{{ \'START_DATE\' | translate }}" ng-model="graph.startDate" ng-readonly="true" required=""></div></div><div style="float:left;display:inline-block;margin-left:7px;line-height:30px"><small translate="TO"></small></div><div style="float:left;display:inline-block;margin-left:7px"><div moment-picker="graph.endDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:135px !important"><span class="input-group-addon" style="padding:3px 7px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control input-sm date-picker" name="EndDate" placeholder="{{ \'END_DATE\' | translate }}" ng-model="graph.endDate" ng-readonly="true" required=""></div></div><div style="float:left;display:inline-block;margin-left:7px"><a href="" ng-click="loadData()" class="btn btn-sm btn-default"><span translate="GO"></span></a> <a href="" ng-click="showActionPane()" ng-if="hasAlert(sensor)" class="btn btn-sm btn-warning"><i class="fa fa-exclamation-triangle"></i></a> <a href="" class="btn btn-default btn-sm sensor-zoom" ng-click="showGraphModal()"><i class="fa fa-expand"></i></a></div></div></div></div></div><div class="panel-body" ng-class="toBlinkOrNot() ? \'alert-add\' : \'alert-remove\'"><div ng-if="(sensor.hasTemp || sensor.hasHumi) && selectedTemp"><canvas id="chartTemp" class="chart chart-line" chart-colors="colorMain" chart-data="dataMain" chart-labels="labels" chart-series="seriesMain" chart-options="optionsMain" chart-dataset-override="datasetOverride1" style="height:120px" height="120" ng-if="sensor.seriesT.length!=0 || sensor.seriesH.length!=0"></canvas><div class="chart-na" ng-if="sensor.seriesT.length==0 && sensor.seriesH.length==0">Chart not available</div></div><div ng-if="sensor.hasNPK && selectedN"><canvas id="chartN" class="chart chart-line" chart-colors="colorN" chart-data="dataN" chart-labels="labels" chart-series="seriesN" chart-options="optionsOther" chart-dataset-override="datasetOverride2" style="height:120px" height="120" ng-if="sensor.seriesN.length!=0"></canvas><div class="chart-na" ng-if="sensor.seriesN.length==0">Chart not available</div></div><div ng-if="sensor.hasNPK && selectedP"><canvas id="chartP" class="chart chart-line" chart-colors="colorP" chart-data="dataP" chart-labels="labels" chart-series="seriesP" chart-options="optionsOther" chart-dataset-override="datasetOverride2" style="height:120px" height="120" ng-if="sensor.seriesP.length!=0"></canvas><div class="chart-na" ng-if="sensor.seriesP.length==0">Chart not available</div></div><div ng-if="sensor.hasNPK && selectedK"><canvas id="chartK" class="chart chart-line" chart-colors="colorK" chart-data="dataP" chart-labels="labels" chart-series="seriesK" chart-options="optionsOther" chart-dataset-override="datasetOverride2" style="height:120px" height="120" ng-if="sensor.seriesK.length!=0"></canvas><div class="chart-na" ng-if="sensor.seriesK.length==0">Chart not available</div></div><div ng-if="sensor.hasEc && selectedEc"><canvas id="chartEc" class="chart chart-line" chart-colors="colorEc" chart-data="dataEc" chart-labels="labels" chart-series="seriesEc" chart-options="optionsOther" chart-dataset-override="datasetOverride2" style="height:120px" height="120" ng-if="sensor.seriesEc.length!=0"></canvas><div class="chart-na" ng-if="sensor.seriesEc.length==0">Chart not available</div></div><div ng-if="sensor.hasPh && selectedPh"><canvas id="chartPh" class="chart chart-line" chart-colors="colorPh" chart-data="dataPh" chart-labels="labels" chart-series="seriesPh" chart-options="optionsOther" chart-dataset-override="datasetOverride2" style="height:120px" height="120" ng-if="sensor.seriesPh.length!=0"></canvas><div class="chart-na" ng-if="sensor.seriesPh.length==0">Chart not available</div></div><div ng-if="sensor.hasPm && selectedPm"><canvas id="chartPm" class="chart chart-line" chart-colors="colorPm" chart-data="dataPm" chart-labels="labels" chart-series="seriesPm" chart-options="optionsOther" chart-dataset-override="datasetOverride2" style="height:120px" height="120" ng-if="sensor.seriesPm.length!=0"></canvas><div class="chart-na" ng-if="sensor.seriesPm.length==0">Chart not available</div></div><div ng-if="sensor.hasElecMeter && selectedElecMeter"><canvas id="chartAmp" class="chart chart-line" chart-colors="colorAmp" chart-data="dataAmp" chart-labels="labels" chart-series="seriesAmp" chart-options="optionsOther" chart-dataset-override="datasetOverride2" style="height:120px" height="120" ng-if="sensor.seriesAmp.length!=0"></canvas><div class="chart-na" ng-if="sensor.seriesAmp.length==0">Chart not available</div></div><br><div class="row" ng-if="!sensorHideDateRange"><div class="col-sm-6 col-md-4 col-lg-3" ng-if="sensor.hasTemp" ng-class="toBlinkTemp ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : selectedTemp }" ng-click="setDefaultSelection(\'1\')"><div class="title"><small>Temperature</small></div><div class="value"><b style="color:#0000FF">{{sensor.temperature}}</b> <small>{{getMetric(\'TEMP\', sensor.isF)}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-3" ng-if="sensor.hasHumi" ng-class="toBlinkHumi ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : selectedTemp }" ng-click="setDefaultSelection(\'1\')"><div class="title"><small>Humidity</small></div><div class="value"><b style="color:#3D9400">{{sensor.humidity || \'-\'}}</b> <small>{{getMetric(\'HUMI\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-3" ng-if="sensor.hasNPK" ng-class="toBlinkN ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : selectedN }" ng-click="setDefaultSelection(\'2\')"><div class="title"><small>Nitrogen (N)</small></div><div class="value"><b style="color:#795548">{{sensor.n || \'-\'}}</b> <small>{{getMetric(\'N\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-3" ng-if="sensor.hasNPK" ng-class="toBlinkP ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : selectedP }" ng-click="setDefaultSelection(\'3\')"><div class="title"><small>Phosphorus (P)</small></div><div class="value"><b style="color:#FF9800">{{sensor.p || \'-\'}}</b> <small>{{getMetric(\'P\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-3" ng-if="sensor.hasNPK" ng-class="toBlinkK ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : selectedK }" ng-click="setDefaultSelection(\'4\')"><div class="title"><small>Potassium (K)</small></div><div class="value"><b style="color:#D4C020">{{sensor.k || \'-\'}}</b> <small>{{getMetric(\'K\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-3" ng-if="sensor.hasEc" ng-class="toBlinkEc ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : selectedEc }" ng-click="setDefaultSelection(\'5\')"><div class="title"><small>Elec Conduct</small></div><div class="value"><b style="color:#9C27B0">{{sensor.ec || \'-\'}}</b> <small>{{getMetric(\'EC\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-3" ng-if="sensor.hasPh" ng-class="toBlinkPh ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : selectedPh }" ng-click="setDefaultSelection(\'6\')"><div class="title"><small>pH Level</small></div><div class="value"><b style="color:#47C68B">{{sensor.ph || \'-\'}}</b> <small>{{getMetric(\'PH\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-3" ng-if="sensor.hasPm" ng-class="toBlinkPm ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : selectedPm }" ng-click="setDefaultSelection(\'7\')"><div class="title"><small>PM2.5</small></div><div class="value"><b style="color:#089A1C">{{sensor.pm || \'-\'}}</b> <small>{{getMetric(\'PM2.5\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-3" ng-if="sensor.hasElecMeter" ng-class="toBlinkElecMeter ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : selectedElecMeter }" ng-click=""><div class="title"><small>Ampere (A)</small></div><div class="value"><b style="color:#FFB800">{{sensor.amp || \'-\'}}</b> <small>{{getMetric(\'AMP\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-3" ng-if="sensor.hasWaterMeter" ng-class="toBlinkPm ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : selectedPm }" ng-click=""><div class="title"><small>Water Usage</small></div><div class="value"><b style="color:#795548">{{sensor.ltr || \'-\'}}</b> <small>{{getMetric(\'LTR\')}}</small></div></a></div></div><div class="row" ng-if="sensorHideDateRange"><div class="col-sm-6 col-md-4 col-lg-4" ng-if="sensor.hasTemp" ng-class="toBlinkTemp ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button-sm" ng-class="{ \'siot-db-widget-button-sm-selected\' : selectedTemp }" ng-click="setDefaultSelection(\'1\')"><div class="title"><small>Temperature</small></div><div class="value"><b style="color:#0000FF">{{sensor.temperature || \'-\'}}</b> <small>{{getMetric(\'TEMP\', sensor.isF)}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-4" ng-if="sensor.hasHumi" ng-class="toBlinkHumi ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button-sm" ng-class="{ \'siot-db-widget-button-sm-selected\' : selectedTemp }" ng-click="setDefaultSelection(\'1\')"><div class="title"><small>Humidity</small></div><div class="value"><b style="color:#3D9400">{{sensor.humidity || \'-\'}}</b> <small>{{getMetric(\'HUMI\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-4" ng-if="sensor.hasNPK" ng-class="toBlinkN ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button-sm" ng-class="{ \'siot-db-widget-button-sm-selected\' : selectedN }" ng-click="setDefaultSelection(\'2\')"><div class="title"><small>Nitrogen (N)</small></div><div class="value"><b style="color:#795548">{{sensor.n || \'-\'}}</b> <small>{{getMetric(\'N\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-4" ng-if="sensor.hasNPK" ng-class="toBlinkP ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button-sm" ng-class="{ \'siot-db-widget-button-sm-selected\' : selectedP }" ng-click="setDefaultSelection(\'3\')"><div class="title"><small>Phosphorus (P)</small></div><div class="value"><b style="color:#FF9800">{{sensor.p || \'-\'}}</b> <small>{{getMetric(\'P\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-4" ng-if="sensor.hasNPK" ng-class="toBlinkK ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button-sm" ng-class="{ \'siot-db-widget-button-sm-selected\' : selectedK }" ng-click="setDefaultSelection(\'4\')"><div class="title"><small>Potassium (K)</small></div><div class="value"><b style="color:#D4C020">{{sensor.k || \'-\'}}</b> <small>{{getMetric(\'K\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-4" ng-if="sensor.hasEc" ng-class="toBlinkEc ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button-sm" ng-class="{ \'siot-db-widget-button-sm-selected\' : selectedEc }" ng-click="setDefaultSelection(\'5\')"><div class="title"><small>Elec Conduct</small></div><div class="value"><b style="color:#9C27B0">{{sensor.ec || \'-\'}}</b> <small>{{getMetric(\'EC\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-4" ng-if="sensor.hasPh" ng-class="toBlinkPh ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button-sm" ng-class="{ \'siot-db-widget-button-sm-selected\' : selectedPh }" ng-click="setDefaultSelection(\'6\')"><div class="title"><small>pH Level</small></div><div class="value"><b style="color:#47C68B">{{sensor.ph || \'-\'}}</b> <small>{{getMetric(\'PH\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-4" ng-if="sensor.hasPm" ng-class="toBlinkPm ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button-sm" ng-class="{ \'siot-db-widget-button-sm-selected\' : selectedPm }" ng-click="setDefaultSelection(\'7\')"><div class="title"><small>PM2.5</small></div><div class="value"><b style="color:#795548">{{sensor.pm || \'-\'}}</b> <small>{{getMetric(\'PM2.5\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-4" ng-if="sensor.hasElecMeter" ng-class="toBlinkElecMeter ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button-sm" ng-class="{ \'siot-db-widget-button-sm-selected\' : selectedElecMeter }" ng-click="$mdl.setDefaultSelection(\'8\')"><div class="title"><small>Ampere (A)</small></div><div class="value"><b style="color:#FFB800">{{sensor.amp || \'-\'}}</b> <small>{{getMetric(\'AMP\')}}</small></div></a></div><div class="col-sm-6 col-md-4 col-lg-4" ng-if="sensor.hasWaterMeter" ng-class="toBlinkPm ? \'alert-add-button\' : \'alert-remove-button\'"><a href="" class="form-control siot-db-widget-button-sm" ng-class="{ \'siot-db-widget-button-sm-selected\' : selectedPm }" ng-click=""><div class="title"><small>Water Usage</small></div><div class="value"><b style="color:#795548">{{sensor.ltr || \'-\'}}</b> <small>{{getMetric(\'LTR\')}}</small></div></a></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard_iot/smartiot/smartiot.html','<div><div class="row"><div class="col-lg-12"><div class="row" ng-if="!vm.selectedGroup"><div class="col-lg-12"><div class="panel panel-default"><div class="panel-heading"><b style="color:#000"><span translate="SELECT_A_GROUP_TO_VIEW"></span></b></div><div class="panel-body"><div class="row" ng-if="vm.isLoadingGateways"><div class="col-lg-12" style="height:250px;line-height:250px"><big><center><i class="fa fa-spinner fa-spin fa-fw fa-2x"></i> {{\'LOADING...\' | translate}}</center></big></div></div><a href="" class="col-xs-12 col-sm-6 col-md-4 col-lg-3 dashbutton_gateway" ng-repeat="g in vm.groups | orderBy:\'description\'" ng-click="vm.selectGroup(g.id)"><h2><b>{{g.description | uppercase}}</b></h2></a><div class="row" ng-if="!vm.isLoadingGateways && vm.groups.length==0"><div class="col-lg-12" style="height:250px;line-height:250px"><big><center><i class="fa fa-info-circle"></i> &nbsp;{{\'THERE_IS_NO_AVAILABLE_GROUP\' | translate}}</center></big></div></div></div></div></div></div><div ng-if="vm.selectedGroup"><div class="row"><div class="col-lg-12"><div class="panel panel-default"><div class="panel-heading" style="height:50px"><div class="row"><div class="col-md-4 col-lg-4"><a href="" ng-click="vm.resetGroup()" class="btn btn-primary btn-xs" style="margin-right:20px"><i class="fa fa-chevron-left"></i> &nbsp;<span translate="BACK"></span></a> <b style="color:#000">{{vm.selectedGroup.description}}</b> &nbsp;&nbsp;&nbsp;&nbsp; <small>(Last refreshed: {{ vm.lastRefreshDateTime || \'-\'}})</small></div><div class="col-md-4 col-lg-4"><div ng-if="!vm.showAsSummary"><ba-switcher switcher-style="primary" switcher-value="vm.showDangerZone" switcher-change="vm.refreshPanel()" style="float:left;margin-top:-7px;margin-right:-10px"></ba-switcher><b style="float:left;margin-left:10px;color:#333">Show / Hide Danger Zone(s)</b></div></div><div class="col-md-4 col-lg-4"><div class="pull-right"><a href="" class="btn btn-default btn-xs" style="width:75px" ng-class="{ \'btn-success\' : vm.showAsSummary }" ng-click="vm.showSummary()">Summary</a> <a href="" class="btn btn-default btn-xs" style="width:75px" ng-class="{ \'btn-success\' : vm.showAsChart }" ng-click="vm.setColumnWidth(2)">Charts</a></div></div></div></div><div class="panel-body"><div class="row" ng-if="vm.showAsSummary"><div class="col-lg-2 iot2-sensor-box" ng-repeat="s in vm.sensorList"><a href="" class="iot2-sensor-content" ng-class="{ \'iot2-sensor-content-alert\' : (s.toAlertTemp || s.toAlertHumi), \'iot2-sensor-content-offline\' : (!s.hasReadings) }" ng-click="vm.showGraphModal(s)"><div class="iots-sensor-title">{{s.description}}</div><div class="iots-sensor-battery"><span style="font-size:8pt;color:#b9b9b9">{{s.deviceUID}}</span><div class="battery-{{vm.getBatteryClass(s.batteryLevel)}}"></div></div><div class="iots-sensor-value"><div class="temperature" ng-if="s.hasReadings && s.hasTemp"><img src="assets/img/icon-temperature2.png" align="left middle"> {{s.temperature}} <small>&deg;{{(s.isF?"F":"C")}}</small> <i class="fa fa-exclamation-triangle text-danger" ng-if="s.toAlertTemp"></i></div><div class="humidity" ng-if="s.hasReadings && s.hasHumi"><img src="assets/img/icon-humidity2.png" align="left middle"> {{s.humidity}} <small>%RH</small> <i class="fa fa-exclamation-triangle text-danger" ng-if="s.toAlertHumi"></i></div><div class="ampere" ng-if="s.hasReadings && s.hasElecMeter"><img src="assets/img/icon-ampere2.png" align="left middle"> {{s.amp}} <small>AMP</small> <i class="fa fa-exclamation-triangle text-danger" ng-if="s.toAlertAmp"></i></div><span style="font-size:8pt;color:#b9b9b9" ng-if="s.hasReadings">[{{s.timestamp | date: \'yyyy-MM-dd hh:mma\'}}]</span><div class="noreading" ng-if="!s.hasReadings"><i class="fa fa-exclamation-triangle text-danger"></i> {{\'Offline\' | translate}}</div></div></a></div></div><div class="row" ng-if="vm.showAsChart && !vm.hidePanel"><div class="col-lg-{{(s.deviceType==\'GATEWAY\'?12:vm.columnWidth)}}" style="padding-bottom:0px" ng-if="!vm.hidePanel" ng-repeat="s in vm.selectedGroup.siotGroupDevices"><smart-gateway ng-if="s.deviceType==\'GATEWAY\'" sensor-id="s.gatewayId" sensor-desc="s.description" sensor-device-uid="s.deviceUID" sensor-hide-date-range="vm.hideDateRange"></smart-gateway><smart-sensor ng-if="s.deviceType==\'SENSOR\'" sensor-id="s.sensorId" sensor-desc="s.description" sensor-device-uid="s.deviceUID" sensor-hide-date-range="vm.hideDateRange" sensor-show-danger-zone="vm.showDangerZone"></smart-sensor></div></div><div class="row" ng-if="vm.isLoadingSensors"><div class="col-lg-12" style="height:250px;line-height:250px"><big><center><i class="fa fa-spinner fa-spin fa-fw fa-2x"></i> {{\'LOADING...\' | translate}}</center></big></div></div><div class="row" ng-if="!vm.isLoadingSensors && vm.sensorList.length==0"><div class="col-lg-12" style="height:250px;line-height:250px"><big><center><i class="fa fa-info-circle"></i> &nbsp;{{\'NO_IOT_DEVICE_IS_AVAILABLE\' | translate}}</center></big></div></div></div></div></div></div></div></div></div></div><script type="text/ng-template" id="graphModal.html"><form name="$mdl.graphForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <div style="background:#fff"> <div class="row"> <div class="col-lg-12"> <div class="row"> <div class="col-lg-12"> <div class="siot-sensor-description-modal"> {{$mdl.sensor.description}} </div> </div> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="panel panel-default"> <div class="panel-heading" style="height:56px"> <div class="row"> <div class="col-md-3 col-lg-3"> <div style="line-height:30px"> <div class="sensor-uid"><b>{{$mdl.sensor.deviceUID}}</b></div> <div class="batt-{{$mdl.getBatteryClass($mdl.sensor.batteryLevel)}}"></div> </div> </div> <div class="col-md-9 col-lg-9" style="color:#000;text-align:right"> <div class="pull-right"> <div style="float:left;display:inline-block;line-height:30px"> <i class="fa fa-lock" style="font-size:15pt"></i> <input type="checkbox" ng-model="$mdl.lockDateRange" style="width:22px;height:22px" /> </div> <div style="float:left;display:inline-block;margin-left:7px"> <div moment-picker="$mdl.startDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:140px !important"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control input-sm" name="StartDate" placeholder="{{ \'START_DATE\' | translate }}" style="width:140px;background:#fffeed" ng-model="$mdl.startDate" ng-readonly="true" required /> </div> </div> <div style="float:left;display:inline-block;margin-left:7px;line-height:30px"> <small translate="TO"></small> </div> <div style="float:left;display:inline-block;margin-left:7px"> <div moment-picker="$mdl.endDate" format="DD-MM-YYYY hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:140px !important"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control input-sm" name="EndDate" placeholder="{{ \'END_DATE\' | translate }}" style="width:140px;background:#fffeed" ng-model="$mdl.endDate" ng-readonly="true" required /> </div> </div> <div style="float:left;display:inline-block;margin-left:7px"> <a href ng-click="$mdl.loadData()" class="btn btn-sm btn-default"><span translate="GO"></span></a> </div> <div style="float:left;display:inline-block;margin-left:7px"> <a href ng-click="$mdl.showActionPane()" ng-if="$mdl.hasAlert()" class="btn btn-sm btn-warning"> <i class="fa fa-exclamation-triangle"></i> </a> </div> </div> </div> </div> </div> <div class="panel-body" ng-class="$mdl.toBlinkOrNot() ? \'alert-add\' : \'alert-remove\'"> <div class="row"> <div class="col-md-3 col-lg-3"> <div class="row"> <div class="col-md-6 col-lg-6" ng-if="$mdl.sensor.hasTemp" ng-class="$mdl.toBlinkTemp ? \'alert-add-button\' : \'alert-remove-button\'"> <a href class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : $mdl.selectedTemp }" ng-click="$mdl.setDefaultSelection(\'1\')"> <div class="title"> <small>Temperature</small> </div> <div class="value"> <b style="color:#0000FF">{{$mdl.sensor.temperature || \'-\'}}</b> <small>{{$mdl.getMetric(\'TEMP\', $mdl.sensor.isF)}}</small> </div> </a> </div> <div class="col-md-6 col-lg-6" ng-if="$mdl.sensor.hasHumi" ng-class="$mdl.toBlinkHumi ? \'alert-add-button\' : \'alert-remove-button\'"> <a href class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : $mdl.selectedTemp }" ng-click="$mdl.setDefaultSelection(\'1\')"> <div class="title"> <small>Humidity</small> </div> <div class="value"> <b style="color:#3D9400">{{$mdl.sensor.humidity || \'-\'}}</b> <small>{{$mdl.getMetric(\'HUMI\')}}</small> </div> </a> </div> <div class="col-md-6 col-lg-6" ng-if="$mdl.sensor.hasNPK" ng-class="$mdl.toBlinkN ? \'alert-add-button\' : \'alert-remove-button\'"> <a href class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : $mdl.selectedN }" ng-click="$mdl.setDefaultSelection(\'2\')"> <div class="title"> <small>Nitrogen (N)</small> </div> <div class="value"> <b style="color:#795548">{{$mdl.sensor.n || \'-\'}}</b> <small>{{$mdl.getMetric(\'N\')}}</small> </div> </a> </div> <div class="col-md-6 col-lg-6" ng-if="$mdl.sensor.hasNPK" ng-class="$mdl.toBlinkP ? \'alert-add-button\' : \'alert-remove-button\'"> <a href class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : $mdl.selectedP }" ng-click="$mdl.setDefaultSelection(\'3\')"> <div class="title"> <small>Phosphorus (P)</small> </div> <div class="value"> <b style="color:#FF9800">{{$mdl.sensor.p || \'-\'}}</b> <small>{{$mdl.getMetric(\'P\')}}</small> </div> </a> </div> <div class="col-md-6 col-lg-6" ng-if="$mdl.sensor.hasNPK" ng-class="$mdl.toBlinkK ? \'alert-add-button\' : \'alert-remove-button\'"> <a href class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : $mdl.selectedK }" ng-click="$mdl.setDefaultSelection(\'4\')"> <div class="title"> <small>Potassium (K)</small> </div> <div class="value"> <b style="color:#D4C020">{{$mdl.sensor.k || \'-\'}}</b> <small>{{$mdl.getMetric(\'K\')}}</small> </div> </a> </div> <div class="col-md-6 col-lg-6" ng-if="$mdl.sensor.hasEc" ng-class="$mdl.toBlinkEc ? \'alert-add-button\' : \'alert-remove-button\'"> <a href class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : $mdl.selectedEc }" ng-click="$mdl.setDefaultSelection(\'5\')"> <div class="title"> <small>Elec Conductivity</small> </div> <div class="value"> <b style="color:#9C27B0">{{$mdl.sensor.ec || \'-\'}}</b> <small>{{$mdl.getMetric(\'EC\')}}</small> </div> </a> </div> <div class="col-md-6 col-lg-6" ng-if="$mdl.sensor.hasPh" ng-class="$mdl.toBlinkPh ? \'alert-add-button\' : \'alert-remove-button\'"> <a href class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : $mdl.selectedPh }" ng-click="$mdl.setDefaultSelection(\'6\')"> <div class="title"> <small>pH Level</small> </div> <div class="value"> <b style="color:#47C68B">{{$mdl.sensor.ph || \'-\'}}</b> <small>{{$mdl.getMetric(\'PH\')}}</small> </div> </a> </div> <div class="col-md-6 col-lg-6" ng-if="$mdl.sensor.hasPm" ng-class="$mdl.toBlinkPm ? \'alert-add-button\' : \'alert-remove-button\'"> <a href class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : $mdl.selectedPm }" ng-click="$mdl.setDefaultSelection(\'7\')"> <div class="title"> <small>PM2.5</small> </div> <div class="value"> <b style="color:#089A1C">{{$mdl.sensor.pm || \'-\'}}</b> <small>{{$mdl.getMetric(\'PM2.5\')}}</small> </div> </a> </div> <div class="col-md-6 col-lg-6" ng-if="$mdl.sensor.hasElecMeter" ng-class="$mdl.toBlinkElectMeter ? \'alert-add-button\' : \'alert-remove-button\'"> <a href class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : $mdl.selectedElecMeter }" ng-click="$mdl.setDefaultSelection(\'8\')"> <div class="title"> <small>Ampere (A)</small> </div> <div class="value"> <b style="color:#FFB800">{{$mdl.sensor.amp || \'-\'}}</b> <small>{{$mdl.getMetric(\'AMP\')}}</small> </div> </a> </div> <div class="col-md-6 col-lg-6" ng-if="$mdl.sensor.hasWaterMeter" ng-class="$mdl.toBlinkElectMeter ? \'alert-add-button\' : \'alert-remove-button\'"> <a href class="form-control siot-db-widget-button" ng-class="{ \'siot-db-widget-button-selected\' : $mdl.selectedWaterMeter }" ng-click=""> <div class="title"> <small>Water Usage</small> </div> <div class="value"> <b style="color:#795548">{{$mdl.sensor.ltr || \'-\'}}</b> <small>{{$mdl.getMetric(\'LTR\')}}</small> </div> </a> </div> </div> </div> <div class="col-md-9 col-lg-9"> <div ng-if="($mdl.sensor.hasTemp || $mdl.sensor.hasHumi) && $mdl.selectedTemp"> <canvas id="chartTemp" class="chart chart-line" chart-colors="$mdl.colorMain" chart-data="$mdl.dataMain" chart-labels="$mdl.labels" chart-series="$mdl.seriesMain" chart-options="$mdl.optionsMain" chart-dataset-override="$mdl.datasetOverride1" style="height:100px" height="100"> </canvas> </div> <div ng-if="$mdl.sensor.hasNPK && $mdl.selectedN"> <canvas id="chartN" class="chart chart-line" chart-colors="$mdl.colorN" chart-data="$mdl.dataN" chart-labels="$mdl.labels" chart-series="$mdl.seriesN" chart-options="$mdl.optionsOther" chart-dataset-override="$mdl.datasetOverride2" style="height:100px" height="100"> </canvas> </div> <div ng-if="$mdl.sensor.hasNPK && $mdl.selectedP"> <canvas id="chartP" class="chart chart-line" chart-colors="$mdl.colorP" chart-data="$mdl.dataP" chart-labels="$mdl.labels" chart-series="$mdl.seriesP" chart-options="$mdl.optionsOther" chart-dataset-override="$mdl.datasetOverride2" style="height:100px" height="100"> </canvas> </div> <div ng-if="$mdl.sensor.hasNPK && $mdl.selectedK"> <canvas id="chartK" class="chart chart-line" chart-colors="$mdl.colorK" chart-data="$mdl.dataP" chart-labels="$mdl.labels" chart-series="$mdl.seriesK" chart-options="$mdl.optionsOther" chart-dataset-override="$mdl.datasetOverride2" style="height:100px" height="100"> </canvas> </div> <div ng-if="$mdl.sensor.hasEc && $mdl.selectedEc"> <canvas id="chartEc" class="chart chart-line" chart-colors="$mdl.colorEc" chart-data="$mdl.dataEc" chart-labels="$mdl.labels" chart-series="$mdl.seriesEc" chart-options="$mdl.optionsOther" chart-dataset-override="$mdl.datasetOverride2" style="height:100px" height="100"> </canvas> </div> <div ng-if="$mdl.sensor.hasPh && $mdl.selectedPh"> <canvas id="chartPh" class="chart chart-line" chart-colors="$mdl.colorPh" chart-data="$mdl.dataPh" chart-labels="$mdl.labels" chart-series="$mdl.seriesPh" chart-options="$mdl.optionsOther" chart-dataset-override="$mdl.datasetOverride2" style="height:100px" height="100"> </canvas> </div> <div ng-if="$mdl.sensor.hasPm && $mdl.selectedPm"> <canvas id="chartPm" class="chart chart-line" chart-colors="$mdl.colorPm" chart-data="$mdl.dataPm" chart-labels="$mdl.labels" chart-series="$mdl.seriesPm" chart-options="$mdl.optionsOther" chart-dataset-override="$mdl.datasetOverride2" style="height:100px" height="100"> </canvas> </div> <div ng-if="$mdl.sensor.hasElecMeter && $mdl.selectedElecMeter"> <canvas id="chartAmp" class="chart chart-line" chart-colors="$mdl.colorAmp" chart-data="$mdl.dataAmp" chart-labels="$mdl.labels" chart-series="$mdl.seriesAmp" chart-options="$mdl.optionsOther" chart-dataset-override="$mdl.datasetOverride2" style="height:100px" height="100"> </canvas> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="actionPaneModal.html"><form name="$mdl.actionPaneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header" style="background:#2f59d4"> <h3 class="modal-title" style="color:#fff"> \u3010{{$mdl.sensor.description}}\u3011 <span translate="CORRECTIVE_ACTION"></span> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b translate="CAUSE_OF_THE_INCIDENT"></b></label> <textarea name="Cause" class="form-control" style="background:#fffeed" autocomplete="off" ng-model="$mdl.item.cause" ng-disabled="$mdl.lockButton" required> </textarea> <p class="help-block" style="color:#f00" ng-show="$mdl.actionPaneForm.Cause.$error.required && $mdl.actionPaneForm.$submitted"> * {{\'REQUIRED\' | translate}} </p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b translate="ACTION_TAKEN"></b></label> <textarea name="ActionTaken" class="form-control" style="background:#fffeed" autocomplete="off" ng-model="$mdl.item.actionTaken" ng-disabled="$mdl.lockButton" required> </textarea> <p class="help-block" style="color:#f00" ng-show="$mdl.actionPaneForm.ActionTaken.$error.required && $mdl.actionPaneForm.$submitted"> * {{\'REQUIRED\' | translate}} </p> </div> </div> </div> <legend ng-if="$mdl.showSuccess || $mdl.showError"></legend> <div class="row" ng-if="$mdl.showSuccess"> <div class="col-lg-12"> <span style="color:#0a8a0a"> <i class="fa fa-check"></i> &nbsp; <span translate="CORRECTIVE_ACTION_HAS_BEEN_RECORDED_SUCCESSFULLY"></span>. </span> </div> </div> <div class="row" ng-if="$mdl.showError"> <div class="col-lg-12"> <span style="color:#f00"> <i class="fa fa-exclamation-triangle"></i> &nbsp; <span style="color:#f00" ng-bind-html="$mdl.errorMsg"></span> </span> </div> </div> </div> <legend></legend> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon btn-lg" type="submit" ng-disabled="$mdl.lockButton" style="float:left"> <i class="fa fa-check"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon btn-lg" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/dashboard_iot/smartiotobservatory/observatory.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.customerData" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Customer" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:50px">#</th><th st-sort="clientName"><span translate="CUSTOMER_NAME"></span></th><th style="text-align:center" class="hide-after"><span translate="NO._OF_GATEWAYS"></span></th><th style="text-align:center" class="hide-after"><span translate="NO._OF_SENSORS"></span></th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.customerData.length==0 && !vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.customerData"><td style="padding-top:10px;padding-bottom:10px">{{vm.startIndex+1+$index}})</td><td style="padding-top:10px;padding-bottom:10px">{{item.clientName}}</td><td style="text-align:center;padding-top:10px;padding-bottom:10px">{{item.gatewayCount}}</td><td style="text-align:center;padding-top:10px;padding-bottom:10px">{{item.sensorCount}}</td><td style="padding-top:10px;padding-bottom:10px"><a href="" title="View" class="btn btn-warning btn-sm btn-with-icon" style="display:inline-block;font-size:10pt" ng-click="vm.promptSettingDialog(item.clientCompanyId, item.clientName)"><i class="fa fa-cog"></i> <span translate="NOTIFICATION"></span></a></td><td style="padding-top:10px;padding-bottom:10px"><a href="" title="View" class="btn btn-primary btn-sm btn-with-icon" style="display:inline-block;font-size:10pt" ui-sref="iotdashboard.smartiotobservatory.overview({id:item.clientCompanyId})"><i class="fa fa-area-chart"></i> <span translate="MONITORING"></span></a></td><td style="padding-top:10px;padding-bottom:10px"><a href="" title="View" class="btn btn-success btn-sm btn-with-icon" style="display:inline-block;font-size:10pt" ng-click="vm.promptReportDialog(item.clientCompanyId, item.clientName)"><i class="fa fa-file"></i> <span translate="REPORT"></span></a></td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="settingModal.html"><form name="$mdl.modalForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="NOTIFICATION_SETTINGS"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <i class="fa fa-info-circle"></i> <a href title="Add Setting" class="btn btn-primary btn-sm pull-right" ng-click="$mdl.addSetting($mdl.accessCompanyId)"> <i class="fa fa-plus"></i> {{ \'ADD_NOTIFICATION_SETTING\' | translate }} </a> <span translate="MANAGE_THE_NOTIFICATION_SETTINGS_TO_RECEIVE_ALERTS_WHEN_CUSTOMERS_SENSORS_DETECTED_ABNORMAL_READING"></span> <br /><br /> <span translate="CUSTOMER"></span>: <b>{{$mdl.clientName}}</b> <br /><br /> <table class="table table-striped" style="border:5px solid #eee;font-size:90%"> <thead> <tr> <th rowspan="2" style="width:60px"><b>#</b></th> <!-- <th rowspan="2" style="width:150px"><b translate="BRANCH_NAME"></b></th> --> <th rowspan="2" style="width:100px;text-align:center"><b><span translate="TRIGGER"></span><br /><span translate="ALERT"></span></b></th> <th colspan="2" style="width:100px;text-align:center"><b translate="ALERT_METHOD"></b></th> <th rowspan="2">&nbsp;</th> <th rowspan="2"><b translate="EMAIL"></b></th> <th rowspan="2"><b translate="USER"></b></th> <th rowspan="2" style="width:40px"></th> <th rowspan="2" style="width:40px"></th> </tr> <tr> <th style="width:100px;text-align:center"><b translate="EMAIL"></b></th> <th style="width:100px;text-align:center;line-height:100%"><b translate="PUSH_NOTIFICATION"></b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.settings.length<=0 && !$mdl.isLoading"> <td colspan="9" style="height:100px;line-height:100px"> <center>{{ \'NO_RECORD_FOUND\' | translate }}</center> </td> </tr> <tr ng-if="$mdl.isLoading"> <td colspan="9" style="height:100px;line-height:100px"> <big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big> </td> </tr> <tr ng-repeat="item in $mdl.settings"> <td>{{$mdl.startIndex+1+$index}})</td> <!-- <td>{{item.branchName}}</td> --> <td style="text-align:center"> <i class="fa fa-check" ng-if="item.triggerAlert" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.triggerAlert" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-if="item.alertByEmail" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.alertByEmail" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-if="item.alertByPN" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.alertByPN" style="color:#f00"></i> </td> <td>&nbsp;</td> <td>{{item.email}}</td> <td>{{item.username}}</td> <td align="center"> <a href title="Edit" class="btn btn-primary btn-xs" style="width:40px" style="display:inline-block;font-size:10pt" ng-disabled="$mdl.isLoading || $mdl.isLockButtons" ng-click="$mdl.editSetting(item.id, $mdl.accessCompanyId)"> <i class="fa fa-pencil"></i> </a> </td> <td align="center"> <a href title="Delete Setting" class="btn btn-danger btn-xs" style="width:40px" style="display:inline-block;font-size:10pt" ng-disabled="$mdl.isLoading || $mdl.isLockButtons" confirmed-click="$mdl.deleteSetting(item.id)" ng-confirm-click="Confirm remove this setting?"> <i class="fa fa-trash"></i> </a> </td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer" style="text-align:center !important"> <br /><br /> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.isLoading || $mdl.isLockButtons"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="manageSettingModal.html"><form name="$mdl.modalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="NOTIFICATION_SETTINGS"></span></h3> </div> <div class="modal-body" id="modal-body"><div class="row"> <div class="col-md-2 col-lg-2"> <div class="form-group"> <label><b translate="ENABLED"></b></label> <div> <toggle ng-model="$mdl.setting.triggerAlert" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> <div class="col-md-8 col-lg-8" ng-if="$mdl.setting.triggerAlert"> <div class="form-group" ng-class="{\'has-error\': $mdl.dataForm.Email.$invalid && ($mdl.dataForm.Email.$dirty || $mdl.dataForm.$submitted)}"> <label><b translate="SELECT_A_SENSOR"></b> &nbsp;(<span translate="OPTIONAL"></span>. <span translate="RECIPIENT_WILL_ONLY_RECEIVE_NOTIFICATION_FROM_THE_SELECTED_SENSOR"></span>)</label> <div class="row"> <div class="col-md-9 col-lg-9"> <select name="Sensor" class="form-control" style="background:#FFFCED" ng-change="$mdl.selectedSensorChanged()" ng-options="s as ((s.groupName || \'-NO GROUP-\') + \' >>> \' + s.description | uppercase) for s in $mdl.sensorList | orderBy:[\'groupName\',\'description\']" ng-model="$mdl.selectedSensor" > <option value="">-- {{ \'SELECT_A_SENSOR\' | translate }} --</option> </select> </div> <div class="col-md-3 col-lg-3" style="padding-left:0px"> <a href class="btn btn-with-icon btn-danger" ng-if="$mdl.selectedSensor!=null" ng-click="$mdl.clearSensor()"> <i class="fa fa-trash"></i> {{ "CLEAR" | translate}} </a> </div> </div> </div> </div> </div> <div class="row"> <div class="col-md-2 col-lg-2"> <div class="form-group"> <label><b translate="EMAIL_ALERT"></b></label> <div> <toggle ng-model="$mdl.setting.alertByEmail" ng-change="changed()" on="ON" off="OFF" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> <div class="col-md-8 col-lg-8" ng-if="$mdl.setting.alertByEmail"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Email.$invalid && ($mdl.modalForm.Email.$dirty || $mdl.modalForm.$submitted)}"> <label><b translate="EMAIL_ADDRESS"></b> <i class="fa fa-asterisk req"></i> &nbsp;<span translate="(USE_SEMI-COLON_TO_SPECIFY_MULTIPLE_EMAILS)"></span></label> <input type="email" class="form-control" name="Email" placeholder="Email" style="background:#FFFCED" ng-model="$mdl.setting.email" ng-required="$mdl.setting.alertByEmail"> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.modalForm.Email.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.modalForm.Email.$error.email">* <span translate="INVALID_EMAIL_FORMAT"></span></span> </div> </div> </div> <div class="row"> <div class="col-md-2 col-lg-2"> <div class="form-group"> <label><b translate="PUSH_NOTIFICATION"></b></label> <div> <toggle ng-model="$mdl.setting.alertByPN" ng-change="changed()" on="ON" off="OFF" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> <div class="col-md-8 col-lg-8" ng-if="$mdl.setting.alertByPN"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.User.$invalid && ($mdl.modalForm.User.$dirty || $mdl.modalForm.$submitted)}"> <label><b translate="SELECT_A_USER"></b> <i class="fa fa-asterisk req"></i> &nbsp;( <span translate="USER_WILL_RECEIVE_PUSH_NOTIFICATION_ON_MOBILE_APP"></span>)</label> <select name="User" class="form-control" style="background:#FFFCED" ng-change="$mdl.selectUser()" ng-options="b as (b.firstName + \' \' + b.lastName | uppercase) for b in $mdl.users | orderBy:\'firstName\' " ng-model="$mdl.selectedUser" ng-required="$mdl.setting.alertByPN"> <option value="">-- {{ \'SELECT_A_USER\' | translate }} --</option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.modalForm.User.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <hr /> <div class="modal-footer"> <b ng-if="$mdl.isLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="LOADING"></span> ...</b> <b ng-if="$mdl.lockButtons"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons || $mdl.isLoading"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButtons || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="reportModal.html"><form name="$mdl.modalForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="GENERATE_REPORT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12" style="color:#000"> <i class="fa fa-info-circle"></i><span translate="SELECT_A_DATE_RANGE_AND_SENSOR,TO_GENERATE_THE_TEMPERATURE_REPORT_IN_PDF/EXCEL_FORMAT."></span> <br /><br /> <span translate="CUSTOMER_NAME"></span>:<br /> <h2>{{$mdl.clientName}}</h2> <br /> <div class="row"> <div class="col-lg-6"> <div class="form-group"> <label style="color:#000"><b translate="DATE_FROM:"></b> <i class="fa fa-asterisk req"></i></label> <div moment-picker="$mdl.dateFrom" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control" name="DateFrom" autocomplete="off" ng-disabled="$mdl.isProcessing" ng-model="$mdl.dateFrom"> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.downloadForm.DateFrom.$error.required && $mdl.downloadForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label style="color:#000"><b translate="DATE_TO:"></b> <i class="fa fa-asterisk req"></i></label> <div moment-picker="$mdl.dateTo" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control" name="DateTo" autocomplete="off" ng-disabled="$mdl.isProcessing" ng-model="$mdl.dateTo"> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.downloadForm.DateTo.$error.required && $mdl.downloadForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b translate="SELECT_A_SENSOR:"></b></label> <select class="form-control" ng-disabled="$mdl.isProcessing" ng-options="s as (s.groupName + \' -> \' + s.description | uppercase) for s in $mdl.sensorList | orderBy:[\'groupName\',\'description\']" ng-model="$mdl.selectedSensor"> <option></option> </select> </div> </div> </div> </div> </div> </div> <hr /> <div class="modal-footer"> <div> <button type="button" class="btn btn-primary btn-with-icon btn-md" style="width:150px;float:left" ng-disabled="$mdl.isProcessing" ng-click="$mdl.downloadPdf2()"> <i class="fa fa-download"></i> <b>{{ \'PDF\' | translate }} ({{ \'HOURLY\' | translate | uppercase }})</b> </button> <button type="button" class="btn btn-primary btn-with-icon btn-md" style="width:150px;float:left" ng-disabled="$mdl.isProcessing" ng-click="$mdl.downloadPdf()"> <i class="fa fa-download"></i> <b>{{ \'PDF\' | translate }} ({{ \'DETAILS\' | translate | uppercase }})</b> </button> <!-- <button type="button" class="btn btn-primary btn-with-icon btn-md" style="width:150px;float:left" ng-disabled="$mdl.isProcessing" ng-click="$mdl.downloadExcel()"> <i class="fa fa-download"></i> <b translate="EXCEL"></b> </button> --> <button type="button" class="btn btn-danger btn-with-icon btn-md" ng-disabled="$mdl.isProcessing" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> <div ng-if="$mdl.isProcessing" style="text-align:left !important;padding:10px 0px 0px;color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="GENERATING_REPORT,_PLEASE_WAIT_..."></span> </div> </div> </form></script>');
$templateCache.put('app/pages/dashboard_iot/smartiotobservatory/observatoryOverview.html','<div><div class="row"><div class="col-lg-12"><div class="row" ng-if="!vm.selectedGroup"><div class="col-lg-12"><div class="panel panel-default"><div class="panel-heading"><a href="" ng-click="vm.goBack()" class="btn btn-primary btn-xs" style="margin-right:20px"><i class="fa fa-chevron-left"></i> &nbsp; <span translate="BACK"></span></a> <b style="color:#000">{{vm.groups[0].companyName | uppercase}}</b></div><div class="panel-body"><div class="row" ng-if="vm.groups.length!=0"><div class="col-lg-12"><span translate="SELECT_A_GROUP_TO_VIEW"></span><p><br></p></div></div><div class="row"><a href="" class="col-xs-12 col-sm-6 col-md-4 col-lg-3 dashbutton_gateway" ng-repeat="g in vm.groups | orderBy:\'description\'" ng-click="vm.selectGroup(g.id)"><h2><b>{{g.description | uppercase}}</b></h2></a></div><h3 ng-if="vm.groups.length==0" style="padding:50px 0px"><i class="fa fa-exclamation-triangle text-danger"></i> &nbsp;{{ \'THERE_IS_NO_AVAILABLE_GROUP\' | translate}}.</h3></div></div></div></div><div ng-if="vm.selectedGroup"><div class="row"><div class="col-lg-12"><div class="panel panel-default"><div class="panel-heading"><div class="row"><div class="col-md-4 col-lg-4"><a href="" ng-click="vm.resetGroup()" class="btn btn-primary btn-xs" style="margin-right:20px"><i class="fa fa-chevron-left"></i> &nbsp;<span translate="BACK"></span></a> <b style="color:#000">{{vm.groups[0].companyName | uppercase}}</b> &nbsp;<i class="fa fa-caret-right"></i>&nbsp; <b style="color:#000">{{vm.selectedGroup.description | uppercase}}</b></div><div class="col-md-4 col-lg-4"><ba-switcher switcher-style="primary" switcher-value="vm.showDangerZone" switcher-change="vm.refreshPanel()" style="float:left;margin-top:-7px;margin-right:-10px"></ba-switcher><b style="float:left;margin-left:10px;color:#333">Show / Hide Danger Zone(s)</b></div><div class="col-md-4 col-lg-4"><div class="pull-right"><small translate="COLUMNS:"></small> <a href="" class="btn btn-default btn-xs" ng-click="vm.setColumnWidth(2)">&nbsp;2&nbsp;</a> <a href="" class="btn btn-default btn-xs" ng-click="vm.setColumnWidth(4)">&nbsp;4&nbsp;</a></div></div></div></div><div class="panel-body"><div class="row"><div class="col-lg-{{(s.deviceType==\'GATEWAY\'?12:vm.columnWidth)}}" style="padding-bottom:0px" ng-if="!vm.hidePanel" ng-repeat="s in vm.selectedGroup.siotGroupDevices"><smart-gateway ng-if="s.deviceType==\'GATEWAY\'" sensor-id="s.gatewayId" sensor-desc="s.description" sensor-device-uid="s.deviceUID" sensor-hide-date-range="vm.hideDateRange"></smart-gateway><smart-sensor ng-if="s.deviceType==\'SENSOR\'" sensor-id="s.sensorId" sensor-desc="s.description" sensor-device-uid="s.deviceUID" sensor-hide-date-range="vm.hideDateRange" sensor-show-danger-zone="vm.showDangerZone"></smart-sensor></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard_iot/smartiotplanview/planview.html','<div class="widgets"><div class="row"><div class="col-lg-12"><div ng-if="vm.layoutList.length!=0"><a href="" ng-click="vm.toggleFullscreen()" class="btn btn-primary btn-with-icon btn-sm"><i class="fa fa-expand"></i> <span translate="GO_FULLSCREEN"></span></a> &nbsp; <span style="font-size:130%;color:#00f"><i class="fa fa-info-circle"></i> <span translate="NOTE:_THIS_SCREEN_MUST_BE_VIEWED_IN_FULLSCREEN_MODE_(SCREEN_RESOLUTION:_1920_X_1080_PIXELS)_FOR_BEST_VIEWING_EXPERIENCE"></span></span><br><br><br><div id="layoutParent" style="background-image:url({{vm.currentLayoutImage}})"><div class="layout-title">{{vm.selectedLayout.description}}</div><div class="loading-animation fade-out" ng-hide="!vm.isLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translations="RETRIEVING_THE_LATEST_MONITORING_STATISTICS_..."></span></div><div class="layout-pages" id="pages"><a href="" class="page-button" ng-repeat="p in vm.layoutList | orderBy:\'-pageCode\'" ng-class="{ \'page-button-selected\' : (p.id==vm.currentLayoutId)}" ng-click="vm.showLayout(p.id)">{{p.pageCode}}</a></div><div id="{{s.objectIdText}}" style="-webkit-transform:translate({{vm.getCoorX(s.coordinateX)}}px,{{vm.getCoorY(s.coordinateY)}}px);transform:translate({{vm.getCoorX(s.coordinateX)}}px,{{vm.getCoorY(s.coordinateY)}}px);" ng-class="{\'planview-sensor\' : s.sensorId!=null, \'planview-asset\' : s.assetId!=null }" ng-repeat="s in vm.selectedLayout.siotPlanViewDesignerDevices" uib-popover-template="s.sensorId!=null?\'sensorPopoverTemplate.html\':\'assetPopoverTemplate.html\'" ng-click="s.sensorId!=null?vm.showSensorInfoPopup(s):vm.showAssetInfoPopup(s)" popover-class="customClass" popover-trigger="outsideClick" popover-is-open="s.tooltipIsOpen" popover-placement="auto right"><div ng-if="s.sensorId!=null"><div class="alert-animation" ng-if="vm.hasAlert(s.objectStats)"><div class="loadingio-spinner-ripple-j25d4u41p9o"><div class="ldio-fpjhyjsgrs"><div></div><div></div></div></div></div><img src="assets/img/sensor-icon2.png" alt=""><br><div class="description"><div>{{s.objectDescription}}</div></div><div class="extra"><div class="temperature" ng-class="{\'temperature-alert\': s.objectStats.toAlert }"><span ng-if="s.objectStats.currentTemp!=-9999">{{s.objectStats.currentTemp}} <small>{{s.objectStats.currentTempSymbol}}</small></span> <span ng-if="s.objectStats.currentTemp==-9999">n/a <small>{{s.objectStats.currentTempSymbol}}</small></span></div><div class="humidity" ng-if="s.objectStats.hasHumi">{{s.objectStats.currentHumi}} <small>{{s.objectStats.currentHumiSymbol}}</small></div><div class="ampere" ng-if="s.objectStats.hasElecMeter">{{s.objectStats.currentAmp}} <small>{{s.objectStats.currentAmpSymbol}}</small></div></div></div><div ng-if="s.assetId!=null"><img ng-if="s.objectStats.openCaseCount==0 && s.objectStats.openWorkOrderCount==0" src="assets/img/asset-icon.png" alt=""> <img ng-if="s.objectStats.openCaseCount!=0 || s.objectStats.openWorkOrderCount!=0" src="assets/img/asset-icon-warning.png" alt=""><p class="description">{{s.description}}</p></div></div><a href="" class="btn btn-danger btn-sm exit-button" ng-click="vm.toggleFullscreen()"><i class="fa fa-close"></i></a></div></div><div ba-panel="" ng-if="vm.layoutList.length==0 && !vm.isLoading"><div style="line-height:40px;padding-top:80px;padding-bottom:80px;font-size:14pt"><center><img src="assets/img/empty_placeholder_iotdesigner.jpg" style="width:350px"><br><br><h2 translate="THERE_IS_NO_PLANVIEW_AVAILABLE"></h2><span translate="CLICK"></span> <a href="" ui-sref="smartiotsettings.planviewdesigner.list" style="color:#00f"><u translate="HERE"></u></a> <span translate="TO_NAVIGATE_TO_PLANVIEW_DESIGNER"></span></center></div></div></div></div></div><script type="text/ng-template" id="assetPopoverTemplate.html"><div> <div class="popover-title" ng-class="{\'red\' : s.objectStats.toAlert}"> <span translate="ASSET"></span> \u3010{{s.objectCode}}\u3011 </div> <div class="row"> <div class="col-lg-7"> <div class="row"> <div class="col-lg-12"> <b translate="NAME">:</b> </div> </div> <div class="row"> <div class="col-lg-12" style="padding-bottom:15px"> {{s.objectName}} </div> </div> <div class="row"> <div class="col-lg-12"> <b translate="DESCRIPTION">:</b> </div> </div> <div class="row"> <div class="col-lg-12" style="padding-bottom:15px"> <span style="white-space:pre-line">{{s.objectDescription}}</span> </div> </div> <div class="row"> <div class="col-lg-12"> <b translate="SERIAL_NO.">:</b> </div> </div> <div class="row"> <div class="col-lg-12" style="padding-bottom:15px"> {{s.objectSerialNo}} </div> </div> </div> <div class="col-lg-5"> <div class="row"> <div class="col-lg-12"> <div href class="col-md-12 col-lg-12 dashlet-opencase" ba-panel ng-click=""> <div class="figure">{{s.objectStats.openCaseCount}}</div> <div class="caption"> <span translate="OPEN_CASE"></span>(s)</div> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div href class="col-md-12 col-lg-12 dashlet-workorder" ba-panel ng-click=""> <div class="figure">{{s.objectStats.openWorkOrderCount}}</div> <div class="caption"><span translate="WORK_ORDER"></span>(s)</div> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div href class="col-md-12 col-lg-12 dashlet-service" ba-panel ng-click=""> <div class="figure">{{s.objectStats.workOrderHistoryCount}}</div> <div class="caption" translate="SERVICE_HISTORY"></div> </div> </div> </div> </div> </div> <div class="popover-footer"> <div class="footer-note"> <center> <span translate="NOTE:_THIS_DIALOG_WILL_BE_CLOSED_WHEN_THE_FLOOR_VIEW_AUTO-REFRESH_EVERY_3_MINUTES"></span>. </center> </div> <br /> <div> <!-- <a href class="btn btn-warning btn-lg" style="float:left;color:#000" ng-if="s.objectStats.toAlert" ng-click="vm.showActionPane(s)"> <i class="fa fa-life-ring"></i> &nbsp;<span translations="TAKE_ACTION"></span> </a> --> <a href class="btn btn-danger btn-lg pull-right" ng-click="s.tooltipIsOpen=!s.tooltipIsOpen"> <i class="fa fa-close"></i> &nbsp;<span translate="CLOSE_DIALOG"></span> </a> </div> </div> </div></script><script type="text/ng-template" id="sensorPopoverTemplate.html"><div> <div class="popover-title" ng-class="{\'red\' : vm.hasAlert(s.objectStats)}"> \u3010{{s.objectCode}}\u3011 {{s.objectDescription}} </div> <div class="popover-body"> <!-- Graph --> <div class="row"> <div class="col-lg-12" style="height:240px" ng-if="s.chart.hasTemp || s.chart.hasHumi"> <canvas id="popupChart" class="chart chart-line" chart-colors="s.chart.colors" chart-data="s.chart.dataMain" chart-labels="s.chart.labels" chart-series="s.chart.seriesMain" chart-options="s.chart.optionsMain" chart-dataset-override="s.chart.datasetOverride"> </canvas> </div> <div class="col-lg-12" style="height:240px" ng-if="s.chart.hasElecMeter"> <canvas id="popupChart" class="chart chart-line" chart-colors="s.chart.colors" chart-data="s.chart.dataAmp" chart-labels="s.chart.labels" chart-series="s.chart.seriesAmp" chart-options="s.chart.optionsOther" chart-dataset-override="s.chart.datasetOverride2"> </canvas> </div> </div> <legend></legend> <!-- Current Temperature / Humidity / Battery --> <div class="row"> <div class="col-sm-3 col-md-3 col-lg-3" ng-if="s.chart.hasTemp"> <div class="metricBox" ng-class="{\'red\' : s.chart.toAlertTemp}"> <div class="title">Temperature</div> <b ng-if="s.chart.temperature!=-9999" style="color:#0000FF">{{s.chart.temperature | number:1 }}</b> <b ng-if="s.chart.temperature==-9999">n/a</b> <small>{{s.chart.symbolTemp}}</small> </div> </div> <div class="col-sm-3 col-md-3 col-lg-3" ng-if="s.chart.hasHumi"> <div class="metricBox" ng-class="{\'red\' : s.chart.toAlertHumi}"> <div class="title">Humidity</div> <b ng-if="s.chart.humidity!=-9999" style="color:#3D9400">{{s.chart.humidity | number:1 }}</b> <b ng-if="s.chart.humidity==-9999">n/a</b> <small>{{s.chart.symbolHumi}}</small> </div> </div> <div class="col-sm-3 col-md-3 col-lg-3" ng-if="s.chart.hasNPK"> <div class="metricBox" ng-class="{\'red\' : s.chart.toAlertN}"> <div class="title">Nitrogen (N)</div> <b ng-if="s.chart.n!=-9999" style="color:#795548">{{s.chart.n | number:0 }}</b> <b ng-if="s.chart.n==-9999">n/a</b> <small>{{s.chart.symbolN}}</small> </div> </div> <div class="col-sm-3 col-md-3 col-lg-3" ng-if="s.chart.hasNPK"> <div class="metricBox" ng-class="{\'red\' : s.chart.toAlertP}"> <div class="title">Phosporus (P)</div> <b ng-if="s.chart.p!=-9999" style="color:#FF9800">{{s.chart.p | number:0 }}</b> <b ng-if="s.chart.p==-9999">n/a</b> <small>{{s.chart.symbolP}}</small> </div> </div> <div class="col-sm-3 col-md-3 col-lg-3" ng-if="s.chart.hasNPK"> <div class="metricBox" ng-class="{\'red\' : s.chart.toAlertK}"> <div class="title">Potassium (K)</div> <b ng-if="s.chart.k!=-9999" style="color:#D4C020">{{s.chart.k | number:0 }}</b> <b ng-if="s.chart.k==-9999">n/a</b> <small>{{s.chart.symbolK}}</small> </div> </div> <div class="col-sm-3 col-md-3 col-lg-3" ng-if="s.chart.hasEc"> <div class="metricBox" ng-class="{\'red\' : s.chart.toAlertEc}"> <div class="title">Elec Cond.</div> <b ng-if="s.chart.ec!=-9999" style="color:#9C27B0">{{s.chart.ec | number:0 }}</b> <b ng-if="s.chart.ec==-9999">n/a</b> <small>{{s.chart.symbolEc}}</small> </div> </div> <div class="col-sm-3 col-md-3 col-lg-3" ng-if="s.chart.hasPh"> <div class="metricBox" ng-class="{\'red\' : s.chart.toAlertPh}"> <div class="title">pH Level</div> <b ng-if="s.chart.ph!=-9999" style="color:#47C68B">{{s.chart.ph | number:0 }}</b> <b ng-if="s.chart.ph==-9999">n/a</b> <small>{{s.chart.symbolPh}}</small> </div> </div> <div class="col-sm-3 col-md-3 col-lg-3" ng-if="s.chart.hasPm"> <div class="metricBox" ng-class="{\'red\' : s.chart.toAlertPm}"> <div class="title">PM2.5</div> <b ng-if="s.chart.pm!=-9999" style="color:#795548">{{s.chart.pm | number:0 }}</b> <b ng-if="s.chart.pm==-9999">n/a</b> <small>{{s.chart.symbolPm}}</small> </div> </div> <div class="col-sm-3 col-md-3 col-lg-3" ng-if="s.chart.hasElecMeter"> <div class="metricBox" ng-class="{\'red\' : s.chart.toAlertAmp}"> <div class="title">Elec Meter</div> <b ng-if="s.chart.amp!=-9999" style="color:#9C27B0">{{s.chart.amp | number:1 }}</b> <b ng-if="s.chart.amp==-9999">n/a</b> <small>{{s.chart.symbolAmp}}</small> </div> </div> <div class="col-sm-3 col-md-3 col-lg-3" ng-if="s.chart.hasWaterMeter"> <div class="metricBox"> <div class="title">Water Meter</div> <b ng-if="s.chart.ltr!=-9999" style="color:#795548">{{s.chart.ltr | number:1 }}</b> <b ng-if="s.chart.ltr==-9999">n/a</b> <small>{{s.chart.symbolLtr}}</small> </div> </div> <!-- <div class="col-sm-3 col-md-3 col-lg-3"> <div class="metricBox battery"> <div class="title">Battery</div> <div class="batt-{{s.chart.batteryLevel}}"></div> </div> </div> --> </div> </div> <div class="popover-footer"> <div class="footer-note"> <center> <span translate="NOTE:_THIS_DIALOG_WILL_BE_CLOSED_WHEN_THE_FLOOR_VIEW_AUTO-REFRESH_EVERY_3_MINUTES"></span>. </center> </div> <br /> <div> <a href class="btn btn-warning btn-md" style="float:left;color:#000" ng-if="vm.hasAlert(s.objectStats)" ng-click="vm.showActionPane(s)"> <i class="fa fa-life-ring"></i> &nbsp;<span translate="TAKE_ACTION"></span> </a> <div class="last-action" ng-if="s.objectStats.toAlert && s.lastCorrectiveAction!=null" uib-tooltip-template="\'lastCorrectiveAction.html\'" tooltip-class="customClass" tooltip-placement="auto top" tooltip-trigger="outsideClick"> <span> <i class="fa fa-info-circle"></i> <span translate="LAST_ACTION"></span>: </span><br /> <span>{{s.lastCorrectiveAction.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</span> </div> <a href class="btn btn-danger btn-md pull-right" ng-click="s.tooltipIsOpen=!s.tooltipIsOpen"> <i class="fa fa-close"></i> &nbsp; <span translate="CLOSE_DIALOG"></span> </a> </div> </div> </div></script><script type="text/ng-template" id="lastCorrectiveAction.html"><div> <label><span translate="LAST_ACTION_DATE/TIME"></span>:</label> <p>{{s.lastCorrectiveAction.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</p> <label><span translate="CAUSE"></span>:</label> <p>{{s.lastCorrectiveAction.cause}}</p> <label translate="ACTION_TAKEN">:</label> <p>{{s.lastCorrectiveAction.actionTaken}}</p> </div></script><script type="text/ng-template" id="actionPaneModal.html"><form name="$mdl.actionPaneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header" style="background:#2f59d4"> <h3 class="modal-title" style="color:#fff"> \u3010{{$mdl.sensor.description}}\u3011 <span translate="CORRECTIVE_ACTION"></span> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b> <span translate="CAUSE_OF_THE_INCIDENT"></span>:</b></label> <textarea name="Cause" class="form-control" style="background:#fffeed" autocomplete="off" ng-model="$mdl.item.cause" ng-disabled="$mdl.lockButton" required> </textarea> <p class="help-block" style="color:#f00" ng-show="$mdl.actionPaneForm.Cause.$error.required && $mdl.actionPaneForm.$submitted"> * {{\'REQUIRED\' | translate}} </p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b> <span translate="ACTION_TAKEN"></span>:</b></label> <textarea name="ActionTaken" class="form-control" style="background:#fffeed" autocomplete="off" ng-model="$mdl.item.actionTaken" ng-disabled="$mdl.lockButton" required> </textarea> <p class="help-block" style="color:#f00" ng-show="$mdl.actionPaneForm.ActionTaken.$error.required && $mdl.actionPaneForm.$submitted"> * {{\'REQUIRED\' | translate}} </p> </div> </div> </div> <legend ng-if="$mdl.showSuccess || $mdl.showError"></legend> <div class="row" ng-if="$mdl.showSuccess"> <div class="col-lg-12"> <span style="color:#0a8a0a"> <i class="fa fa-check"></i> &nbsp; <span translate="CORRECTIVE_ACTION_HAS_BEEN_RECORDED_SUCCESSFULLY"></span>. </span> </div> </div> <div class="row" ng-if="$mdl.showError"> <div class="col-lg-12"> <span style="color:#f00"> <i class="fa fa-exclamation-triangle"></i> &nbsp; <span style="color:#f00" ng-bind-html="$mdl.errorMsg"></span> </span> </div> </div> </div> <legend></legend> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon btn-lg" type="submit" ng-disabled="$mdl.lockButton" style="float:left"> <i class="fa fa-check"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon btn-lg" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/assetconfigs/eqbrands/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BrandCode.$invalid && (vm.dataForm.BrandCode.$dirty || vm.dataForm.$submitted)}"><label for="BrandCode"><span translate="BRAND_CODE"></span> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BrandCode" placeholder="Brand Code" ng-model="vm.brand.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BrandCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BrandName.$invalid && (vm.dataForm.BrandName.$dirty || vm.dataForm.$submitted)}"><label for="BrandName"><span translate="BRAND_NAME"></span> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BrandName" placeholder="Brand Name" ng-model="vm.brand.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BrandName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/assetconfigs/eqbrands/eqbrandCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assetconfigs/eqbrands/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_BRAND"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assetconfigs.eqbrands.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/assetconfigs/eqbrands/eqbrandList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.brandData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Brand" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assetconfigs.eqbrands.create" rms-check-access="assetconfigs.eqbrands" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_BRAND"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="assetconfigs.equipment.import" rms-check-access="assetconfigs.eqbrands" rms-check-access-perm-type="CREATE"><i class="fa fa-download"></i> <span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:150px" st-sort="name"><span translate="BRAND_CODE"></span></th><th st-sort="name"><span translate="BRAND_NAME"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.brandData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.brandData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="assetconfigs.eqbrands.update({id:item.id})" rms-check-access="assetconfigs.eqbrands" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Brand" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteBrand(item.id, item.name)" ng-confirm-click="Confirm delete this brand?" rms-check-access="assetconfigs.eqbrands" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/assetconfigs/eqbrands/eqbrandUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assetconfigs/eqbrands/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assetconfigs.eqbrands.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assetconfigs.eqbrands.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/assetconfigs/eqtypes/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TypeCode.$invalid && (vm.dataForm.TypeCode.$dirty || vm.dataForm.$submitted)}"><label for="TypeCode"><span translate="TYPE_CODE"></span> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="TypeCode" placeholder="Type Code" ng-model="vm.type.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TypeCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TypeName.$invalid && (vm.dataForm.TypeName.$dirty || vm.dataForm.$submitted)}"><label for="TypeName"><span translate="TYPE_NAME"></span> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="TypeName" placeholder="Type Name" ng-model="vm.type.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TypeName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><p>&nbsp;</p></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/assetconfigs/eqtypes/eqtypeCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assetconfigs/eqtypes/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_TYPE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assetconfigs.eqtypes.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/assetconfigs/eqtypes/eqtypeList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.typeData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Type" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assetconfigs.eqtypes.create" rms-check-access="assetconfigs.eqtypes" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_TYPE"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="assetconfigs.equipment.import" rms-check-access="assetconfigs.eqtypes" rms-check-access-perm-type="CREATE"><i class="fa fa-download"></i> <span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:150px" st-sort="name"><span translate="TYPE_CODE"></span></th><th st-sort="name"><span translate="TYPE_NAME"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.typeData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.typeData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="assetconfigs.eqtypes.update({id:item.id})" rms-check-access="assetconfigs.eqtypes" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Type" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteType(item.id, item.name)" ng-confirm-click="Confirm delete this brand?" rms-check-access="assetconfigs.eqtypes" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/assetconfigs/eqtypes/eqtypeUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assetconfigs/eqtypes/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assetconfigs.eqtypes.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assetconfigs.eqtypes.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/assetconfigs/eqdoctypes/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DocTypeCode.$invalid && (vm.dataForm.DocTypeCode.$dirty || vm.dataForm.$submitted)}"><label for="DocTypeCode"><b translate="DOCUMENT_TYPE_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DocTypeCode" placeholder="Document Type Code" ng-model="vm.doctype.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DocTypeCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DocTypeName.$invalid && (vm.dataForm.DocTypeName.$dirty || vm.dataForm.$submitted)}"><label for="DocTypeName"><b translate="DOCUMENT_TYPE_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DocTypeName" placeholder="Document Type Name" ng-model="vm.doctype.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DocTypeName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Customer Categories"><p><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_ACCESSIBLE_CUSTOMER_CATEGORIES_FOR_THIS_DOCUMENT_TYPE"></span>.</small> <a href="" class="btn btn-primary btn-with-icon btn-xs" style="margin:5px" ng-click="vm.showAddDebtorCategoryModal()"><i class="ion-plus-round"></i><span translate="ADD_MORE"></span></a><br><br></p><div class="row"><div class="col-md-5 col-lg-5"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="CUSTOMER_CATEGORY"></b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.doctype.equipmentDocumentTypeDebtorCategories"><td>{{ $index+1 }}</td><td>{{ ntn.name || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeLoanStatus($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr ng-if="vm.doctype.equipmentDocumentTypeDebtorCategories.length==0"><td colspan="3" align="center"><br><span translate="CUSTOMER_CATEGORY_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="CustomerCategoryModal.html"><form name="$mdl.categoryForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="ADD_CUSTOMER_CATEGORY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SELECT_A_CUSTOMER_CATEGORY"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select title="Select or Search for Status..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedCategory" on-select="$mdl.selectedCategoryChanged()"> <ui-select-match placeholder="Search for Customer Category..."> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.debtorCategories | filter: $select.search" minimum-input-length="2"> <span ng-bind-html="i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.selectedCategory==null && $mdl.categoryForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING"> ...</b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </div> </form></script>');
$templateCache.put('app/pages/assetconfigs/eqdoctypes/eqdoctypeCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assetconfigs/eqdoctypes/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_DOC_TYPE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assetconfigs.eqdoctypes.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/assetconfigs/eqdoctypes/eqdoctypeList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.docTypeData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Doc Type" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assetconfigs.eqdoctypes.create" rms-check-access="assetconfigs.eqdoctypes" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_DOC_TYPE"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:150px" st-sort="name"><span translate="DOC_TYPE_CODE"></span></th><th st-sort="name"><span translate="DOC_TYPE_NAME"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.docTypeData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.docTypeData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="assetconfigs.eqdoctypes.update({id:item.id})" rms-check-access="assetconfigs.eqdoctypes" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Brand" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteType(item.id, item.name)" ng-confirm-click="Confirm delete this Doc Type?" rms-check-access="assetconfigs.eqdoctypes" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/assetconfigs/eqdoctypes/eqdoctypeUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assetconfigs/eqdoctypes/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assetconfigs.eqdoctypes.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assetconfigs.eqdoctypes.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/assetconfigs/eqcategories/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CategoryCode.$invalid && (vm.dataForm.CategoryCode.$dirty || vm.dataForm.$submitted)}"><label for="CategoryCode"><span translate="CATEGORY_CODE"></span> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CategoryCode" placeholder="Category Code" ng-model="vm.category.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CategoryCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CategoryName.$invalid && (vm.dataForm.CategoryName.$dirty || vm.dataForm.$submitted)}"><label for="CategoryName"><span translate="CATEGORY_NAME"></span> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CategoryName" ng-model="vm.category.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CategoryName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/assetconfigs/eqcategories/eqcategoryCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assetconfigs/eqcategories/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_CATEGORY"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assetconfigs.eqcategories.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/assetconfigs/eqcategories/eqcategoryList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.categoryData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Category" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assetconfigs.eqcategories.create" rms-check-access="assetconfigs.eqcategories" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_CATEGORY"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="assetconfigs.equipment.import" rms-check-access="assetconfigs.eqcategories" rms-check-access-perm-type="CREATE"><i class="fa fa-download"></i> <span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span> :<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:150px" st-sort="code"><span translate="CATEGORY_CODE"></span></th><th st-sort="name"><span translate="CATEGORY_NAME"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.categoryData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.categoryData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="assetconfigs.eqcategories.update({id:item.id})" rms-check-access="assetconfigs.eqcategories" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Category" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteCategory(item.id, item.name)" ng-confirm-click="Confirm delete this category?" rms-check-access="assetconfigs.eqcategories" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/assetconfigs/eqcategories/eqcategoryUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assetconfigs/eqcategories/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assetconfigs.eqcategories.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assetconfigs.eqcategories.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/assetconfigs/equipment/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="ENTER_THE_GENERAL_INFORMATION_OF_THE_EQUIPMENT"></span><br><br></p><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-md-3 col-lg-3"><div class="row"><img ngf-src="picFile || vm.equipment.imageLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div><br><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-hide="vm.lockUploadButton" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> {{ \'UPLOAD_PICTURE\' | translate }}</div><a href="" class="btn btn-default btn-with-icon" ng-click="picFile=null;vm.clearImage()" ng-hide="vm.lockUploadButton" ng-show="(picFile || vm.equipment.imageLocation.indexOf(\'empty_placeholder\')<0)"><i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }}</a></div><div class="row" ng-show="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div><div class="col-md-7 col-lg-7"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Code.$invalid && (vm.dataForm.Code.$dirty || vm.dataForm.$submitted)}"><label><b translate="EQUIPMENT_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Code" placeholder="e.g.: LAI-NB-0001" ng-model="vm.equipment.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Code.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Model.$invalid && (vm.dataForm.Model.$dirty || vm.dataForm.$submitted)}"><label><b translate="EQUIPMENT_MODEL"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Model" placeholder="e.g.: Naboo / IC-5" ng-model="vm.equipment.model" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Model.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Brand.$invalid && (vm.dataForm.Brand.$dirty || vm.dataForm.$submitted)}"><label><b translate="EQUIPMENT_BRAND"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Brand" ng-options="u as u.name for u in vm.brands track by u.id" ng-model="vm.selectedBrand" ng-change="vm.selectedBrandChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Brand.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Type.$invalid && (vm.dataForm.Type.$dirty || vm.dataForm.$submitted)}"><label><b translate="EQUIPMENT_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Type" ng-options="u as u.name for u in vm.types track by u.id" ng-model="vm.selectedType" ng-change="vm.selectedTypeChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Type.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Category.$invalid && (vm.dataForm.Category.$dirty || vm.dataForm.$submitted)}"><label><b translate="EQUIPMENT_CATEGORY"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Category" ng-options="u as u.name for u in vm.categories track by u.id" ng-model="vm.selectedCategory" ng-change="vm.selectedCategoryChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Category.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Name.$invalid && (vm.dataForm.Name.$dirty || vm.dataForm.$submitted)}"><label><b translate="EQUIPMENT_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Name" placeholder="e.g.: Combi Oven 40 Pans" ng-model="vm.equipment.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Name.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group"><label><b translate="EQUIPMENT_DESCRIPTION"></b></label> <textarea class="form-control" placeholder="Description" ng-model="vm.equipment.description">\n\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="VOLTAGE_/_GAS_TYPE"></b></label> <input type="text" class="form-control" ng-model="vm.equipment.voltageGasType"></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="DIMENSION"></b></label> <input type="text" class="form-control" ng-model="vm.equipment.dimension"></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.WarrantyDay.$invalid && (vm.dataForm.WarrantyDay.$dirty || vm.dataForm.$submitted)}"><label><b translate="WARRANTY_DAYS"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="WarrantyDay" ng-model="vm.equipment.warrantyDay" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WarrantyDay.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WarrantyDay.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MaintenanceDay.$invalid && (vm.dataForm.MaintenanceDay.$dirty || vm.dataForm.$submitted)}"><label><b translate="ROUTINE_MAINTENANCE_DAYS"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="MaintenanceDay" ng-model="vm.equipment.routineMaintenanceDay" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MaintenanceDay.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MaintenanceDay.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span></div></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Properties"><p><i class="fa fa-info-circle"></i> <span translate="ADD_THE_PROPERTIES_FOR_THE_EQUIPMENT"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddPropModal()"><i class="ion-plus-round"></i> <span translate="ADD_NEW_PROPERTY"></span></a><br><br></p><script type="text/ng-template" id="propModal.html"><form name="$mdl.propForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="EQUIPMENT_PROPERTY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.propForm.PropertyName.$invalid && $mdl.propForm.$submitted}"> <label><span translate="PROPERTY_NAME"></span> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="text" name="PropertyName" class="form-control" ng-model="$mdl.item.name" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.propForm.PropertyName.$error.required && $mdl.propForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.propForm.PropertyValue.$invalid && $mdl.propForm.$submitted}"> <label><span translate="PROPERTY_VALUE"></span> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="text" name="PropertyValue" class="form-control" ng-model="$mdl.item.value" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.propForm.PropertyValue.$error.required && $mdl.propForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><div class="row"><div class="col-md-9 col-lg-9"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="PROPERTY_NAME"></b></th><th><b translate="PROPERTY_VALUE"></b></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.equipment.equipmentProperties"><td>{{ $index+1 }}</td><td>{{ ntn.name || \'\' }}</td><td>{{ ntn.value || \'-\' }}</td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditPropModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeProp($index)" ng-confirm-click="Confirm remove this Property?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="8" align="center" ng-show="vm.equipment.equipmentProperties.length==0"><br><span translate="PROPERTY_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Documents"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_DOCUMENTS_RELATED_TO_THIS_EQUIPMENT"></span>. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddDocModal()"><i class="ion-plus-round"></i><span translate="ADD_NEW_DOCUMENT"></span></a><br><br></p><script type="text/ng-template" id="EqDocModal.html"><form name="$mdl.docForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="DOCUMENT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><span translate="DOCUMENT_TYPE"></span> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select name="FileType" class="form-control" style="background:#fffeed" ng-change="$mdl.selectedFileTypeChanged()" ng-model="$mdl.selectedFileType" ng-options="i as i.name for i in $mdl.fileTypes" required> <option></option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.docForm.FileType.$error.required && $mdl.docForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label>{{ \'DESCRIPTION\' | translate }} <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="text" name="Description" class="form-control" style="background:#fffeed" ng-model="$mdl.item.description" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.docForm.Description.$error.required && $mdl.docForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" style="margin-top:15px"> <label> <span translate="DOCUMENT_FILE"></span> <small><em translate="(PDF/MS_WORD/EXCEL_FORMAT)"></em></small></label> <div class="row"> <div class="col-lg-6"> <span class="form-control" style="background:#fffeb7" ng-if="$mdl.item.mediaToUpload.name || $mdl.item.filename==\'\' || $mdl.mode==1"> {{ $mdl.item.mediaToUpload.name || \'No file selected\' }} </span> <a class="form-control btn btn-default btn-with-icon" href="{{$mdl.rootUrl}}{{$mdl.item.filename}}" target="_blank" ng-if="$mdl.item.filename!=\'\' && !$mdl.item.mediaToUpload.name"> <i class="fa fa-file-text"></i> <span translate="VIEW_UPLOADED_FILE"></span> </a> </div> <div class="col-lg-6"> <div class="btn btn-default btn-with-icon" name="file" ng-model="$mdl.mediaFile" ngf-select="$mdl.setUploadMedia($mdl.mediaFile)" ngf-accept="\'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-pattern="\'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-upload"></i> {{ \'BROWSE\' | translate}} </div> <a href ng-click="$mdl.mediaFile=null;$mdl.setUploadMedia(null)" ng-show="$mdl.mediaFile" class="btn btn-danger btn-with-icon" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-remove-circle"></i> {{ \'RESET\' | translate}} </a> </div> </div> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING"> ...</b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><div class="row" ng-show="vm.mode==2"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:1px solid #ccc" st-pipe="vm.refreshDocs" st-table="vm.equipment.equipmentDocuments" refresh-table=""><thead><tr><th style="width:60px">#</th><th><b translate="DOCUMENT_TYPE"></b></th><th><b translate="DESCRIPTION"></b></th><th style="width:100px"><b translate="DOCUMENT_FILE"></b></th><th style="width:65px"></th><th style="width:65px"></th><th style="width:65px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.equipment.equipmentDocuments"><td>{{ $index+1 }}</td><td>{{ ntn.docTypeName || \'\' }}</td><td>{{ ntn.description || \'\' }}</td><td><a class="btn btn-default editable-table-button btn-with-icon btn-xs" href="{{vm.rootUrl}}{{ntn.filename}}" target="_blank" ng-if="ntn.filename!=null && ntn.filename!=\'\'"><i class="fa fa-file-text"></i> {{ \'VIEW\' | translate }}</a> <span ng-if="ntn.filename==null || ntn.filename==\'\'">-</span></td><td></td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditDocModal(ntn.id)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeDoc(ntn.id)" ng-confirm-click="Confirm remove this Document?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="7" align="center" ng-show="vm.equipment.equipmentDocuments.length==0"><br><span translate="DOCUMENT_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center><span translate="PLEASE_SAVE_THE_EQUIPMENT_FIRST_BEFORE_ADDING_DOCUMENTS"></span>.</center></h2></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/assetconfigs/equipment/equipmentCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assetconfigs/equipment/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assetconfigs.equipment.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_EQUIPMENT"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assetconfigs.equipment.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/assetconfigs/equipment/equipmentImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b translate="IMPORT_EQUIPMENT_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'equipments\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="(excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons)"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE..."></span></div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_EQUIPMENT_BRANDS_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'equipmentbrands\')" ng-disabled="vm.isExporting || vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="(excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons)"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE..."></span></div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_EQUIPMENT_CATEGORIES_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'equipmentcategories\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="(excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons)"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_EQUIPMENT_TYPES_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'equipmenttypes\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="(excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons)"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend translate="IMPORT_GUIDELINES:"></legend><ol class="import"><li translate="YOU_NEED_TO_FOLLOW_THE_INSTRUCTION_BELOW_IF_YOU_ARE_NEW_TO_THE_RMS."></li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW_FILL_IT_UP_WITH_THE_DATA_FIRST_THEN_IMPORT_INTO_THE_RMS"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'equipments\', \'Equipment Master Data Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_EQUIPMENT_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'equipmentbrands\', \'Equipment Brands Data Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_EQ_BRANDS_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'equipmentcategories\', \'Equipment Categories Data Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_EQ_CATEGORIES_TEMPLATE"></span></a><br>&nbsp;</li><li><span translate="LASTLY,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'equipmenttypes\', \'Equipment Types Data Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_EQ_TYPES_TEMPLATE"></span></a><br>&nbsp;</li></ol></fieldset><br>&nbsp;<br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong translate="FILE_UPLOADED_SUCCESSFULLY._CHOOSE_THE_OPTIONS_BELOW_AND_PROCEED_TO_IMPORT_THE_DATA."></strong></div><div><fieldset ng-if="vm.importType==\'equipments\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createEquipment" ng-change="change()" ng-disabled="true" style="cursor:pointer"> <label>&nbsp;{{ \'CREATE_NEW_EQUIPMENTS\' | translate }}</label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateEquipment" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'UPDATE_EQUIPMENT_IF_EXISTS\' | translate }}</label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createEquipmentBrand" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'CREATE_NEW_EQ_BRAND\' | translate }}</label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateEquipmentBrand" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'UPDATE_EQ_BRAND_IF_EXISTS\' | translate }}</label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createEquipmentCategory" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'CREATE_NEW_EQ_CATE\' | translate }}</label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateEquipmentCategory" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'UPDATE_EQ_CATE_IF_EXISTS\' | translate }}</label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createEquipmentType" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'CREATE_NEW_EQ_TYPE\' | translate }}</label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateEquipmentType" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'UPDATE_EQ_TYPE_IF_EXISTS\' | translate }}</label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'equipments\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'equipmentbrands\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createEquipmentBrand" ng-change="change()" style="cursor:pointer"> <label><span translate="CREATE_NEW_EQ_BRAND"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateEquipmentBrand" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_EQ_BRAND_IF_EXISTS"></span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'equipmentbrands\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'equipmentcategories\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createEquipmentCategory" ng-change="change()" style="cursor:pointer"> <label><span translate="CREATE_NEW_EQ_CATE"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateEquipmentCategory" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_EQ_CATE_IF_EXISTS"></span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'equipmentcategories\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'equipmenttypes\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createEquipmentType" ng-change="change()" style="cursor:pointer"> <label><span translate="CREATE_NEW_EQ_TYPE"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateEquipmentType" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_EQ_TYPE_IF_EXISTS"></span></label></div></div></div><legend>&nbsp;</legend><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'equipmenttypes\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><br><br><fieldset><legend translate="DATA_PREVIEW"></legend></fieldset></div><div id="scroll-container" class="horizontal-scroll"><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'equipments\'"><thead><tr><th style="width:60px">#</th><th><b translate="EQ_CODE"></b></th><th><b translate="EQ_NAME"></b></th><th><b translate="EQ_DESCRIPTION"></b></th><th><b translate="EQ_MODEL"></b></th><th><b translate="EQ_BRAND_CODE"></b></th><th><b translate="EQ_BRAND_NAME"></b></th><th><b translate="EQ_TYPE_CODE"></b></th><th><b translate="EQ_TYPE_NAME"></b></th><th><b translate="EQ_CATEGORY_CODE"></b></th><th><b translate="EQ_CATEGORY_NAME"></b></th><th><b translate="EQ_DIMENSION"></b></th><th><b translate="EQ_VOLTAGE_GAS"></b></th><th><b translate="EQ_WARRANTY_DAY"></b></th><th><b translate="EQ_MAINT_DAY"></b></th></tr><tr><th colspan="15"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.code || \'\' }}</td><td>{{ row.name || \'\' }}</td><td>{{ row.description || \'\' }}</td><td nowrap="nowrap">{{ row.model || \'-\' }}</td><td nowrap="nowrap">{{ row.brandCode || \'-\' }}</td><td nowrap="nowrap">{{ row.brandName || \'-\' }}</td><td nowrap="nowrap">{{ row.typeCode || \'-\' }}</td><td nowrap="nowrap">{{ row.typeName || \'-\' }}</td><td nowrap="nowrap">{{ row.categoryCode || \'-\' }}</td><td nowrap="nowrap">{{ row.categoryName || \'-\' }}</td><td nowrap="nowrap">{{ row.dimension || \'-\' }}</td><td nowrap="nowrap">{{ row.voltageGasType || \'-\' }}</td><td nowrap="nowrap">{{ row.warrantyDay || \'-\' }}</td><td nowrap="nowrap">{{ row.routineMaintenanceDay || \'-\' }}</td></tr><tr><td colspan="15" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="15"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'equipmentbrands\'"><thead><tr><th style="width:60px">#</th><th><b translate="CODE"></b></th><th><b translate="NAME"></b></th></tr><tr><th colspan="3"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.code || \'\' }}</td><td>{{ row.name || \'\' }}</td></tr><tr><td colspan="3" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="3"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'equipmentcategories\'"><thead><tr><th style="width:60px">#</th><th><b translate="CODE"></b></th><th><b translate="NAME"></b></th></tr><tr><th colspan="3"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.code || \'\' }}</td><td>{{ row.name || \'\' }}</td></tr><tr><td colspan="3" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="3"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'equipmenttypes\'"><thead><tr><th style="width:60px">#</th><th><b translate="CODE"></b></th><th><b translate="NAME"></b></th></tr><tr><th colspan="3"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.code || \'\' }}</td><td>{{ row.name || \'\' }}</td></tr><tr><td colspan="3" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="3"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-12 col-lg-12"><br><p translate="THE_DATA_IS_CURRENTLY_BEING_PROCESSED._IT_IS_SAFE_TO_LEAVE_THIS_PAGE_NOW."></p><p><span translate="YOU_WILL_BE_NOTIFIED_BY_EMAIL_WHEN_THE_IMPORT_IS_COMPLETE."></span></p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="assetconfigs.equipment.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a></div></form></div><div class="float-scroll-button"><span class="scroll-caption"><span translate="SCROLL"></span></span> <a href="" class="scroll-left" ng-if="vm.isSuccess && !vm.isImporting" ng-click="vm.scrollLeft()"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-arrow-left fa-stack-1x fa-inverse"></i></span></a> <a href="" class="scroll-right" ng-if="vm.isSuccess && !vm.isImporting" ng-click="vm.scrollRight()"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-arrow-right fa-stack-1x fa-inverse"></i></span></a></div>');
$templateCache.put('app/pages/assetconfigs/equipment/equipmentList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="EquipmntListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table="" style="font-size:85%"><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="height:35px;line-height:35px;padding-left:0px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assetconfigs.equipment.create" rms-check-access="assetconfigs.equipment" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_EQUIPMENT"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="assetconfigs.equipment.import" rms-check-access="assetconfigs.equipment" rms-check-access-perm-type="CREATE"><i class="fa fa-download"></i> <span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:140px">Image</th><th st-sort="code">{{ \'CODE\' | translate }}</th><th st-sort="name">{{ \'DESCRIPTION\' | translate }}</th><th st-sort="model"><span translate="MODEL"></span></th><th st-sort="typeName">{{ \'TYPE\' | translate }}</th><th st-sort="brandName"><span translate="BRAND"></span></th><th st-sort="categoryName">{{ \'CATEGORY\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th></th><th class="form-inline" colspan="2"><input st-search="equipmentName" class="form-control input input-sm"></th><th class="form-inline"><input st-search="model" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="typeName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="brandName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="categoryName" class="form-control input input-sm" style="width:120px"></th><th></th><th></th></tr></thead><tbody><tr ng-show="vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-show="vm.data.length<=0 && !vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td><img ng-if="item.imageLocation==null || item.imageLocation==\'\'" src="assets/img/empty_placeholder.png" style="width:120px;height:80px;margin-top:10px;margin-bottom:10px"> <img ng-if="item.imageLocation!=null && item.imageLocation!=\'\'" src="{{ vm.blobUrl + item.imageLocation }}" style="width:120px;height:80px;margin-top:10px;margin-bottom:10px"></td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{item.code}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{item.name}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{item.model}}</td><td>{{item.typeName || \'-\'}}</td><td>{{item.brandName || \'-\'}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{item.categoryName | limitTo:15 || \'-\'}} <span ng-if="item.categoryName.length>15">...</span></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="assetconfigs.equipment.update({id:item.id})" rms-check-access="assetconfigs.equipment" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Product" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteEquipment(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Equipment?" rms-check-access="assetconfigs.equipment" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/assetconfigs/equipment/equipmentUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assetconfigs/equipment/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assetconfigs.equipment.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assetconfigs.equipment.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-primary btn-with-icon" style="float:right;margin-right:5px" confirmed-click="vm.cloneEquipment()" ng-confirm-click="Confirm to clone this Equipment?" ng-disabled="vm.lockButtons" rms-check-access="assetconfigs.suppliers" rms-check-access-perm-type="CREATE"><i class="ion ion-social-buffer"></i> <span translate="CLONE_EQUIPMENT"></span></a></div></form>');
$templateCache.put('app/pages/assetconfigs/pnreceiversettings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.User.$invalid && (vm.dataForm.User.$dirty || vm.dataForm.$submitted)}"><label><b translate="NOTIFY_USER"></b> <i class="fa fa-asterisk req" ng-if="!vm.notif.notifyDocumentOwner"></i></label><ui-select name="User" class="btn-group bootstrap-select form-control" title="Search for User..." append-to-body="false" search-enabled="true" ng-model="vm.selectedUser" on-select="vm.selectedUserChanged()" ng-disabled="vm.notif.notifyDocumentOwner" ng-required="!vm.notif.notifyDocumentOwner"><ui-select-match placeholder="-- Select a User --"><span style="color:#000 !important">{{ ($select.selected.firstName + \' \' + $select.selected.lastName) | uppercase }}</span></ui-select-match><ui-select-choices repeat="user in vm.userList | filter: $select.search"><span ng-bind-html="(user.firstName + \' \' + user.lastName) | uppercase | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.User.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Module.$invalid && (vm.dataForm.Module.$dirty || vm.dataForm.$submitted)}"><label><b translate="MODULE"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Module" ng-options="m as m.name for m in vm.moduleList" ng-change="vm.selectedModuleChanged()" ng-model="vm.selectedModule" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Module.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="IS_ACTIVE">?</b></label><div><toggle ng-model="vm.notif.isActive" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/assetconfigs/pnreceiversettings/pnreceiversettingCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assetconfigs/pnreceiversettings/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assetconfigs.pnreceiversettings.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/assetconfigs/pnreceiversettings/pnreceiversettingList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><p><i class="fa fa-info-circle"></i> <span translate="THIS_IS_TO_SETUP_THE_RECEIVER_FOR_THE_INCOMING_PUSH_NOTIFICATION_FOR_VARIOUS_SOFTWARE_MODULES"></span>.</p><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.notifData" refresh-table=""><thead><tr><th colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Template" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assetconfigs.pnreceiversettings.create" rms-check-access="assetconfigs.pnreceiversettings" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="module"><span translate="MODULE_NAME"></span></th><th st-sort="user"><span translate="USER"></span></th><th class="hide-after" style="text-align:center"><span translate="IS_ACTIVE"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.notifData.length<=0"><td colspan="6">{{ \'NO_RECORD_FOUND\' | translate }}.</td></tr><tr ng-repeat="item in vm.notifData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.module}}</td><td>{{item.user}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="assetconfigs.pnreceiversettings.update({id:item.id})" rms-check-access="assetconfigs.pnreceiversettings" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Notification" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteNotification(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this notification?" rms-check-access="assetconfigs.pnreceiversettings" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/assetconfigs/pnreceiversettings/pnreceiversettingUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/assetconfigs/pnreceiversettings/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="assetconfigs.pnreceiversettings.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="assetconfigs.pnreceiversettings.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/digitalhardware/dhsettings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Description" ng-model="vm.setting.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{\'REQUIRED\'|translate}}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FinalProduct.$invalid && (vm.dataForm.FinalProduct.$dirty || vm.dataForm.$submitted)}"><label><b translate="FINAL_PRODUCT"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="FinalProduct" style="color:#333" ng-options="b as b.name for b in vm.productList" ng-change="vm.selectedProductChanged()" ng-model="vm.selectedProduct" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FinalProduct.$error.required">* {{\'REQUIRED\'|translate}}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.WeighingUOM.$invalid && (vm.dataForm.WeighingUOM.$dirty || vm.dataForm.$submitted)}"><label><b translate="U.O.M_FOR_WEIGHING"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="WeighingUOM" style="color:#333" ng-options="b as b.name for b in vm.uomList" ng-change="vm.selectedUomChanged()" ng-model="vm.selectedUom" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WeighingUOM.$error.required">* {{\'REQUIRED\'|translate}}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PreWeighCount.$invalid && (vm.dataForm.PreWeighCount.$dirty || vm.dataForm.$submitted)}"><label><b translate="NUMBER_OF_OBJECTS_TO_PRE-WEIGH"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="PreWeighCount" placeholder="Number of object to Pre-Weigh" ng-model="vm.setting.checkerCount" min="30" max="50" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PreWeighCount.$error.required">* {{\'REQUIRED\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PreWeighCount.$error.min">* Minimum value is 30</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PreWeighCount.$error.max">* Maximum value is 34</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PreWeighCount.$error.number">* {{\'ENTER_NUMBERS_ONLY\'|translate}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SorterCount.$invalid && (vm.dataForm.SorterCount.$dirty || vm.dataForm.$submitted)}"><label><b translate="NUMBER_OF_SORTERS"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="SorterCount" placeholder="Number of Sorters" ng-model="vm.setting.sorterCount" min="1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SorterCount.$error.required">* {{\'REQUIRED\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SorterCount.$error.min">* {{\'MINIMUM_VALUE_IS_1\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SorterCount.$error.number">* {{\'ENTER_NUMBERS_ONLY\'|translate}}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FirstRunOffsetCount.$invalid && (vm.dataForm.FirstRunOffsetCount.$dirty || vm.dataForm.$submitted)}"><label><b translate="FIRST_RUN_OFFSET_COUNT"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="FirstRunOffsetCount" placeholder="First Run Offset Count" ng-model="vm.setting.initialOffset" min="1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstRunOffsetCount.$error.required">* {{\'REQUIRED\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstRunOffsetCount.$error.min">* {{\'MINIMUM_VALUE_IS_1\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstRunOffsetCount.$error.number">* {{\'ENTER_NUMBERS_ONLY\'|translate}}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ObjectMinimumWeight.$invalid && (vm.dataForm.ObjectMinimumWeight.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="OBJECT_MINIMUM_WEIGHT"></span> ({{vm.selectedUom.name}})</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="ObjectMinimumWeight" placeholder="Object Minimum Weight" ng-model="vm.setting.productWeightMin" min="0.1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ObjectMinimumWeight.$error.required">* {{\'REQUIRED\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ObjectMinimumWeight.$error.min">* {{\'MINIMUM_VALUE_IS_1\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ObjectMinimumWeight.$error.number">* {{\'ENTER_NUMBERS_ONLY\'|translate}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ObjectMaximumWeight.$invalid && (vm.dataForm.ObjectMaximumWeight.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="OBJECT_MINIMUM_WEIGHT"></span>({{vm.selectedUom.name}})</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="ObjectMaximumWeight" placeholder="Object Maximum Weight" ng-model="vm.setting.productWeightMax" min="1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ObjectMaximumWeight.$error.required">* {{\'REQUIRED\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ObjectMaximumWeight.$error.min">* {{\'MINIMUM_VALUE_IS_1\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ObjectMaximumWeight.$error.number">* {{\'ENTER_NUMBERS_ONLY\'|translate}}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.WrappingOrContainerWeightDeduction.$invalid && (vm.dataForm.WrappingOrContainerWeightDeduction.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="WRAPPING_/_CONTAINER_WEIGHT_DEDUCTION"></span> ({{vm.selectedUom.name}})</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="WrappingOrContainerWeightDeduction" placeholder="Wrapping / Container Weight Deduction" ng-model="vm.setting.wrappingWeightDeduction" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WrappingOrContainerWeightDeduction.$error.required">* {{\'REQUIRED\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WrappingOrContainerWeightDeduction.$error.min">* {{\'MINIMUM_VALUE_IS_1\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WrappingOrContainerWeightDeduction.$error.number">* {{\'ENTER_NUMBERS_ONLY\'|translate}}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TargetBoxWeight.$invalid && (vm.dataForm.TargetBoxWeight.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="TARGET_BOX_WEIGHT"></span> ({{vm.selectedUom.name}})</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="TargetBoxWeight" placeholder="Target Box Weight" ng-model="vm.setting.targetPackageWeight" min="1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TargetBoxWeight.$error.required">* {{\'REQUIRED\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TargetBoxWeight.$error.min">* {{\'MINIMUM_VALUE_IS_1\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TargetBoxWeight.$error.number">* {{\'ENTER_NUMBERS_ONLY\'|translate}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.WastageTolerancePercent.$invalid && (vm.dataForm.WastageTolerancePercent.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="WASTAGE_TOLERANCE_PERCENT"></span> (%)</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="WastageTolerancePercent" placeholder="Wastage Tolerance Percent" ng-model="vm.setting.wastageTolerancePercent" min="0.01" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WastageTolerancePercent.$error.required">* {{\'REQUIRED\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WastageTolerancePercent.$error.min">* {{\'MINIMUM_VALUE_IS_1\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WastageTolerancePercent.$error.number">* {{\'ENTER_NUMBERS_ONLY\'|translate}}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>Limit Item Quantity Per Box?</b></label><div><toggle ng-model="vm.setting.limitItemQuantityPerPackage" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-3 col-lg-3" ng-if="vm.setting.limitItemQuantityPerPackage"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NoOfItemPerPackage.$invalid && (vm.dataForm.NoOfItemPerPackage.$dirty || vm.dataForm.$submitted)}"><label><b>Item Quantity Per Box</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="NoOfItemPerPackage" placeholder="Item Quantity Per Box" ng-model="vm.setting.noOfItemPerPackage" min="1" ng-required="vm.setting.limitItemQuantityPerPackage"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NoOfItemPerPackage.$error.required">* {{\'REQUIRED\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NoOfItemPerPackage.$error.min">* {{\'MINIMUM_VALUE_IS_1\'|translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NoOfItemPerPackage.$error.number">* {{\'ENTER_NUMBERS_ONLY\'|translate}}</span></div></div></div></uib-tab></uib-tabset></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div>');
$templateCache.put('app/pages/digitalhardware/dhsettings/dhsettingCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/digitalhardware/dhsettings/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="digitalhardware.dhsettings.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_SETTING"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="digitalhardware.dhsettings.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/digitalhardware/dhsettings/dhsettingList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.settingData" st-safe-src="vm.settingDataFull" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Setting" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="digitalhardware.dhsettings.create" rms-check-access="digitalhardware.dhsettings" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_SETTING"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="description" translate="DESCRIPTION"></th><th st-sort="productName"><span translate="FINAL_PRODUCT_NAME"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.settingData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center translate="NO_RECORD_FOUND">.</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.settingData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.description}}</td><td>{{item.productName}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="digitalhardware.dhsettings.update({id:item.id})" rms-check-access="digitalhardware.dhsettings" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-danger btn-xs" style="display:inline-block;font-size:12pt;" confirmed-click="vm.deleteSetting(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Setting?" rms-check-access="digitalhardware.dhsettings" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/digitalhardware/dhsettings/dhsettingUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/digitalhardware/dhsettings/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="digitalhardware.dhsettings.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="digitalhardware.dhsettings.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/durianops/collectdurian/collectdurian.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content"><div class="row"><a href="" class="col-md-5 col-lg-5 durian_dashlet3" ba-panel="" ng-class="{\'durian_jobstart\': vm.isJobStarted}" ng-click="vm.showSupplierModel()"><div class="figure">{{ vm.supplierName=="" ? \'ORCHARD SOURCE\' : vm.supplierName }}</div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><img src="assets/img/durian_farm.png" alt=""></div></div><div class="caption" ng-if="!vm.isJobStarted && vm.supplierName==\'\'">Select a Orchard Source &nbsp<i class="fa fa-chevron-right"></i></div><div class="caption" ng-if="!vm.isJobStarted && vm.supplierName!=\'\'">Re-select &nbsp<i class="fa fa-chevron-right"></i></div></a> <a href="" class="col-md-4 col-lg-4 durian_dashlet3" ba-panel="" ng-class="{\'durian_jobstart\': vm.isJobStarted}" ng-click="vm.showDurianTypeModel()"><div class="figure">{{ vm.itemName=="" ? \'DURIAN TYPE\' : vm.itemName }}</div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><img src="assets/img/durian.png" alt=""></div></div><div class="caption" ng-if="!vm.isJobStarted && vm.itemName==\'\'">Select a Durian Type &nbsp<i class="fa fa-chevron-right"></i></div><div class="caption" ng-if="!vm.isJobStarted && vm.itemName!=\'\'">Re-select &nbsp<i class="fa fa-chevron-right"></i></div></a> <a href="" class="col-md-3 col-lg-3 durian_dashlet3" ba-panel="" ng-class="{\'durian_jobstart\': vm.isJobStarted}" ng-click="vm.toggleJob()"><div class="figure2" ng-if="!vm.isJobStarted">START</div><div class="figure2" ng-if="vm.isJobStarted"><small>TASK NO:</small><br>{{vm.grnNo}}</div><div class="caption" ng-if="!vm.isJobStarted">Start Collection Process &nbsp<i class="fa fa-chevron-right"></i></div><div class="caption" ng-if="vm.isJobStarted"><i class="fa fa-spinner fa-spin fa-fw text-danger"></i>&nbsp; Press Here To Complete</div></a></div><div class="row"><div class="col-md-1 col-lg-1" style="padding-right:0px"><div class="form-group"><div><toggle on="Basket" off="Single" onstyle="btn-primary" offstyle="btn-success" ng-if="!vm.isJobStarted" ng-model="vm.isBasket" ng-change="changed()"></toggle><div class="col-lg-12 btn btn-primary" style="margin-bottom:15px" ng-if="vm.isJobStarted && vm.isBasket">Basket</div><div class="col-lg-12 btn btn-success" style="margin-bottom:15px" ng-if="vm.isJobStarted && !vm.isBasket">Single</div></div></div></div><div class="col-md-1 col-lg-1"><b>Processing<br>Mode</b></div></div><div class="row" ng-if="vm.isJobStarted"><div class="col-md-12" ba-panel=""><div class="row" ng-if="vm.grnItems.length!=0"><div class="col-lg-12"><h2>Total Weight: <b>{{vm.totalWeight | number:0 }} KG</b></h2><br>&nbsp;</div></div><div class="row"><div class="col-lg-2" ng-repeat="item in vm.grnItems"><span href="" class="col-lg-12 btn btn-default" style="font-size:14pt"><small>{{item.labelSerialNo}}</small><br><img src="assets/img/durian_collect.png" ng-if="vm.isBasket" style="width:30px;height:30px;margin-right:10px"> <img src="assets/img/durian.png" ng-if="!vm.isBasket" style="width:30px;height:30px;margin-right:10px"><big><b>{{item.quantity}} {{item.unitOfMeasurement}}</b></big></span><br>&nbsp;</div><div class="col-lg-2"><span href="" class="col-lg-12 btn btn-default" style="font-size:14pt"><i class="fa fa-cog fa-spin fa-3x fa-fw text-primary"></i></span><br>&nbsp;</div></div></div></div></section></form><script type="text/ng-template" id="DurianOpsSupplierModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Select an Orchard Source</h3> </div> <div class="modal-body" id="modal-body" style="max-height:380px !important;overflow:auto"> <div class="row" ng-if="$mdl.isLoading"> <div class="col-lg-12"> <h2> <i class="fa fa-spinner fa-spin fa-fw text-danger"></i>&nbsp; Loading List of Orchards... </h2> </div> </div> <div class="row" ng-repeat="item in $mdl.supplierList"> <div class="col-lg-12"> <a href class="col-lg-12 btn btn-default" ng-click="$mdl.selectSupplier(item)" style="font-size:20pt"> {{item.name}} </a> <br />&nbsp; </div> </div> </div> <div class="modal-footer"> <a href class="col-lg-12 btn btn-danger" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()" style="font-size:16pt"> CLOSE </a> </div> </form></script><script type="text/ng-template" id="DurianOpsRawMatModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Select an Durian Type</h3> </div> <div class="modal-body" id="modal-body" style="max-height:380px !important;overflow:auto"> <div class="row" ng-if="$mdl.isLoading"> <div class="col-lg-12"> <h2> <i class="fa fa-spinner fa-spin fa-fw text-danger"></i>&nbsp; Loading List of Durian Types... </h2> </div> </div> <div class="row" ng-repeat="item in $mdl.rawMatList"> <div class="col-lg-12"> <a href class="col-lg-12 btn btn-default" ng-click="$mdl.selectRawMat(item)" style="font-size:20pt"> {{item.description}} </a> <br />&nbsp; </div> </div> </div> <div class="modal-footer"> <a href class="col-lg-12 btn btn-danger" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()" style="font-size:16pt"> CLOSE </a> </div> </form></script><script type="text/ng-template" id="DurianOpsCompleteModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Collection Complete</h3> </div> <div class="modal-body" id="modal-body" style="max-height:380px !important;overflow:auto"> <div class="row"> <div class="col-md-6 col-lg-6"> <a href class="col-lg-12 btn btn-success" ng-click="$mdl.completeTask()" style="font-size:20pt"> <br /> COMPLETE <br />&nbsp; </a> </div> <div class="col-md-6 col-lg-6"> <a href class="col-lg-12 btn btn-danger" ng-click="$mdl.cancelModal()" style="font-size:20pt"> <br /> CLOSE <br />&nbsp; </a> </div> </div> </div> <div class="modal-footer"> &nbsp; </div> </form></script>');
$templateCache.put('app/pages/durianops/processpulps/processpulps.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content"><div class="row"><a href="" class="col-md-4 col-lg-4 durian_dashlet3" ba-panel="" ng-class="{\'durian_jobstart\': vm.isJobStarted}" ng-click="vm.showSemiFgModel()"><div class="figure">{{ vm.semiFgName=="" ? \'DURIAN PULPS\' : vm.semiFgName }}</div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><img src="assets/img/durian_pulp_collect.png" alt=""></div></div><div class="caption" ng-if="!vm.isJobStarted && vm.semiFgName==\'\'">Select a Durian Pulp &nbsp<i class="fa fa-chevron-right"></i></div><div class="caption" ng-if="!vm.isJobStarted && vm.semiFgName!=\'\'">Re-select &nbsp<i class="fa fa-chevron-right"></i></div></a> <a href="" class="col-md-5 col-lg-5 durian_dashlet3" ba-panel="" ng-class="{\'durian_jobstart\': vm.isJobStarted}" ng-click="vm.showInventoryModel()"><div class="figure">{{ vm.itemId=="" ? \'DURIAN STOCK\' : vm.itemName }}<br><small>({{ vm.itemId=="" ? \'QUANTITY\' : vm.itemQty + \' \' + vm.itemUom }})</small></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><img src="assets/img/durian_pulp.png" alt=""></div></div><div class="caption" ng-if="!vm.isJobStarted && vm.itemId==\'\'">Select a Stock Batch &nbsp<i class="fa fa-chevron-right"></i></div><div class="caption" ng-if="!vm.isJobStarted && vm.itemId!=\'\'">Re-select &nbsp<i class="fa fa-chevron-right"></i></div></a> <a href="" class="col-md-3 col-lg-3 durian_dashlet3" ba-panel="" ng-class="{\'durian_jobstart\': vm.isJobStarted}" ng-click="vm.toggleJob()"><div class="figure2" ng-if="!vm.isJobStarted">START</div><div class="figure2" ng-if="vm.isJobStarted"><small>PROCESS NO:</small><br>{{vm.jobNo}}</div><div class="caption" ng-if="!vm.isJobStarted">Start Process &nbsp<i class="fa fa-chevron-right"></i></div><div class="caption" ng-if="vm.isJobStarted"><i class="fa fa-spinner fa-spin fa-fw text-danger"></i>&nbsp; Press Here To Complete</div></a></div><div class="row" ng-if="vm.isJobStarted"><div class="col-md-12" ba-panel=""><div class="row" ng-if="vm.grnItems.length!=0"><div class="col-lg-12"><h2>Total Weight: <b>{{vm.totalWeight | number:0 }} KG</b></h2><br>&nbsp;</div></div><div class="row"><div class="col-lg-2" ng-repeat="item in vm.semiFgs"><span href="" class="col-lg-12 btn btn-default" style="font-size:14pt"><img src="assets/img/durian_pulp.png" ng-if="!vm.isBasket" style="width:30px;height:30px;margin-right:10px"><big><b>{{item.quantity}} {{item.unitOfMeasurement}}</b></big></span><br>&nbsp;</div><div class="col-lg-2"><span href="" class="col-lg-12 btn btn-default" style="font-size:14pt"><i class="fa fa-cog fa-spin fa-3x fa-fw text-primary"></i></span><br>&nbsp;</div></div></div></div></section></form><script type="text/ng-template" id="DurianOpsSemiFgModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Select a Durian Pulp</h3> </div> <div class="modal-body" id="modal-body" style="max-height:380px !important;overflow:auto"> <div class="row" ng-if="$mdl.isLoading"> <div class="col-lg-12"> <h2> <i class="fa fa-spinner fa-spin fa-fw text-danger"></i>&nbsp; Loading List of Semi F.G... </h2> </div> </div> <div class="row" ng-repeat="item in $mdl.semiFgList"> <div class="col-lg-12"> <a href class="col-lg-12 btn btn-default" ng-click="$mdl.selectSemiFg(item)" style="font-size:20pt"> {{item.description}} </a> <br />&nbsp; </div> </div> </div> <div class="modal-footer"> <a href class="col-lg-12 btn btn-danger" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()" style="font-size:16pt"> CLOSE </a> </div> </form></script><script type="text/ng-template" id="DurianOpsStockBatchModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Select a Stock Batch</h3> </div> <div class="modal-body" id="modal-body" style="max-height:380px !important;overflow:auto"> <div class="row" ng-if="$mdl.isLoading"> <div class="col-lg-12"> <h2> <i class="fa fa-spinner fa-spin fa-fw text-danger"></i>&nbsp; Loading List of Stock Batches... </h2> </div> </div> <div class="row" ng-if="!$mdl.isLoading && $mdl.inventoryList.length==0"> <div class="col-lg-12"> <span class="col-lg-12" style="font-size:20pt;color:#f00"> <br /> <br /> <center>There is no available stock.</center> <br /> <br />&nbsp; </span> <br />&nbsp; </div> </div> <div class="row" ng-repeat="item in $mdl.inventoryList"> <div class="col-lg-12"> <a href class="col-lg-12 btn btn-default" ng-click="$mdl.selectStock(item)" style="font-size:20pt"> {{item.description}} ({{item.quantity}} {{item.uom}}) </a> <br />&nbsp; </div> </div> </div> <div class="modal-footer"> <a href class="col-lg-12 btn btn-danger" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()" style="font-size:16pt"> CLOSE </a> </div> </form></script><script type="text/ng-template" id="DurianOpsCompleteModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Collection Complete</h3> </div> <div class="modal-body" id="modal-body" style="max-height:380px !important;overflow:auto"> <div class="row" ng-if="!$mdl.lockButtons"> <div class="col-md-6 col-lg-6"> <a href class="col-lg-12 btn btn-success" ng-click="$mdl.completeTask()" style="font-size:20pt"> <br /> COMPLETE <br />&nbsp; </a> </div> <div class="col-md-6 col-lg-6"> <a href class="col-lg-12 btn btn-danger" ng-click="$mdl.cancelModal()" style="font-size:20pt"> <br /> CLOSE <br />&nbsp; </a> </div> </div> <div class="row" ng-if="$mdl.lockButtons"> <div class="col-lg-12"> <br /> <h2> <i class="fa fa-spinner fa-spin fa-fw text-danger"></i>&nbsp; Completing process... </h2> <br />&nbsp; </div> </div> </div> <div class="modal-footer"> &nbsp; </div> </form></script>');
$templateCache.put('app/pages/durianops/durianinventory/durianinventory.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" style="width:auto;min-width:100%"><div class="col-md-4 col-lg-4"><h3><b>Fresh Fruit</b></h3><table class="table table-striped table-hover" st-table="vm.data.rawMatResult" refresh-table="" style="font-size:90%;border:1px solid #ccc;margin-bottom:30px"><thead><tr class="sortable"><th style="width:30px">#</th><th st-sort="description">Description</th><th style="text-align:right" class="hide-after">Balance</th><th style="width:40px">UOM</th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="4" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-if="!vm.isLoading && vm.data.rawMatResult.length<=0"><td colspan="4">No record found.</td></tr><tr ng-repeat="item in vm.data.rawMatResult"><td>{{vm.startIndex+1+$index}})</td><td>{{item.description | uppercase}}</td><td style="text-align:right"><b>{{ (item.quantity!=0 && item.quantity!=null) ? (item.quantity | number:0) : \'\'}}</b></td><td><b>{{ (item.quantity!=0 && item.quantity!=null) ? item.uom : \'\' | uppercase}}</b></td></tr></tbody></table></div><div class="col-md-4 col-lg-4"><h3><b>Semi FG</b></h3><table class="table table-striped table-hover" st-table="vm.data.semiFgResult" refresh-table="" style="font-size:90%;border:1px solid #ccc;margin-bottom:30px"><thead><tr class="sortable"><th style="width:30px">#</th><th st-sort="description">Description</th><th style="text-align:right" class="hide-after">Balance</th><th style="width:40px">UOM</th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="4" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-if="!vm.isLoading && vm.data.semiFgResult.length<=0"><td colspan="4">No record found.</td></tr><tr ng-repeat="item in vm.data.semiFgResult"><td>{{vm.startIndex+1+$index}})</td><td>{{item.description | uppercase}}</td><td style="text-align:right"><b>{{ (item.quantity!=0 && item.quantity!=null) ? (item.quantity | number:0) : \'\'}}</b></td><td><b>{{ (item.quantity!=0 && item.quantity!=null) ? item.uom : \'\' | uppercase}}</b></td></tr></tbody></table></div><div class="col-md-4 col-lg-4"><h3><b>Products</b></h3><table class="table table-striped table-hover" st-table="vm.data.productResult" refresh-table="" style="font-size:90%;border:1px solid #ccc;margin-bottom:30px"><thead><tr class="sortable"><th style="width:30px">#</th><th st-sort="name">Description</th><th style="text-align:right" class="hide-after">Balance</th><th style="width:40px">UOM</th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="4" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-if="!vm.isLoading && vm.data.productResult.length<=0"><td colspan="4">No record found.</td></tr><tr ng-repeat="item in vm.data.productResult"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name | uppercase}}</td><td style="text-align:right"><b>{{ (item.quantity!=0 && item.quantity!=null) ? (item.quantity | number:0) : \'\'}}</b></td><td><b>{{ (item.quantity!=0 && item.quantity!=null) ? item.uom : \'\' | uppercase}}</b></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/digitalhardware/dhmanagement/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Code.$invalid && (vm.dataForm.Code.$dirty || vm.dataForm.$submitted)}"><label><b translate="CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Code" placeholder="Code" ng-model="vm.hardware.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Code.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Model.$invalid && (vm.dataForm.Model.$dirty || vm.dataForm.$submitted)}"><label><b translate="MODEL"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Model" placeholder="Model" ng-model="vm.hardware.model" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Model.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Description" ng-model="vm.hardware.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Branch.$invalid && (vm.dataForm.Branch.$dirty || vm.dataForm.$submitted)}"><label><b translate="BRANCH"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Branch" style="color:#333" ng-options="b as b.name for b in vm.branchList" ng-change="vm.selectedBranchChanged()" ng-model="vm.selectedBranch" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Branch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.hardware.createdBy!=null"><div class="col-md-3 col-lg-3"><br><label><b translate="CREATED_BY"></b></label><br>{{vm.hardware.createdBy}} ({{vm.hardware.createdDate | date:\'dd-MMM-yyyy hh:mma\' }})<br>&nbsp;</div></div><div class="row" ng-if="vm.hardware.modifiedBy!=null"><div class="col-md-3 col-lg-3"><label><b>{{ \'MODIFIED_BY\' | translate }}</b></label><br>{{vm.hardware.modifiedBy}} ({{vm.hardware.modifiedDate | date:\'dd-MMM-yyyy hh:mma\' }})</div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="PLC #1" ng-hide="true"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PLCIpAddress.$invalid && (vm.dataForm.PLCIpAddress.$dirty || vm.dataForm.$submitted)}"><label><b translate="PLC_IP_ADDRESS"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="PLCIpAddress" placeholder="PLC IP Address" ng-model="vm.hardware.ipAddress" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PLCIpAddress.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PLCPort.$invalid && (vm.dataForm.PLCPort.$dirty || vm.dataForm.$submitted)}"><label><b translate="PLC_PORT"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="PLCPort" placeholder="PLC Port" ng-model="vm.hardware.port" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PLCPort.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PLCItemCountAddress.$invalid && (vm.dataForm.PLCItemCountAddress.$dirty || vm.dataForm.$submitted)}"><label><b translate="PLC_ITEM_COUNT_ADDRESS"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="PLCItemCountAddress" placeholder="PLC Item Count Address" ng-model="vm.hardware.plcItemCountAddr" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PLCItemCountAddress.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PLCScanWeightAddress.$invalid && (vm.dataForm.PLCScanWeightAddress.$dirty || vm.dataForm.$submitted)}"><label><b translate="PLC_SCAN_WEIGHT_ADDRESS"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="PLCScanWeightAddress" placeholder="PLC Scan Weight Address" ng-model="vm.hardware.plcScanWeightAddr" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PLCScanWeightAddress.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Machine PLC"><legend style="height:32.4px;line-height:32.4px">Machine PLC Configuration</legend><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="PLC_IP_ADDRESS"></b></label> <input type="text" class="form-control" placeholder="IP Address" ng-model="vm.hardware.plc2_IpAddress"></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="PLC_PORT"></b></label> <input type="text" class="form-control" placeholder="Port Number (Default: 502)" ng-model="vm.hardware.plc2_Port"></div></div></div><br><br><legend style="height:32.4px;line-height:32.4px">Machine PLC Address Assignment - Part #1</legend><div class="row"><div class="col-md-8 col-lg-8"><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PLCItemCountAddress.$invalid && (vm.dataForm.PLCItemCountAddress.$dirty || vm.dataForm.$submitted)}"><label>C/Weigher Counter <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="PLCItemCountAddress" placeholder="PLC Item Count Address" ng-model="vm.hardware.plcItemCountAddr" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PLCItemCountAddress.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PLCScanWeightAddress.$invalid && (vm.dataForm.PLCScanWeightAddress.$dirty || vm.dataForm.$submitted)}"><label>C/Weigher Weight <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="PLCScanWeightAddress" ng-model="vm.hardware.plcScanWeightAddr" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PLCScanWeightAddress.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Queue Slot No#</b></label> <input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Queue_SlotNo" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Queue Station No#</b></label> <input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Queue_OutletNo" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Queue Trigger</b></label> <input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Queue_Trigger" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Queue New Item</b></label> <input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Queue_NewItem" min="0"></div></div></div></div></div><div class="row"><div class="col-md-8 col-lg-8"><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Total Slot Count</b></label> <input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Queue_SlotCount" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Auto Ending</b></label> <input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_EndProduction" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Complete Job</b></label> <input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_CompleteJob" min="0"></div></div></div></div></div><br><br><legend style="height:32.4px;line-height:32.4px">Machine PLC Address Assignment - Part #2</legend><div class="row"><div class="col-md-8 col-lg-8"><div class="row"><div class="col-md-2 col-lg-2"></div><div class="col-md-2 col-lg-2" style="text-align:center"><div class="form-group"><b>Item Out</b></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div class="form-group"><b>Item Out-Slot No.</b></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div class="form-group"><b>Station Full</b></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div class="form-group"><b>Station Reset</b></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div class="form-group"><b>Is Orphan Station</b></div></div></div><div class="row"><div class="col-md-2 col-lg-2" style="line-height:30px;text-align:right"><b>Station #1</b></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station1_Out" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station1_Out_SlotNo" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station1_Full" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station1_Reset" min="0"></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div><toggle ng-model="vm.hardware.plc2_Station1_IsOrphanStation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-md-2 col-lg-2" style="line-height:30px;text-align:right"><b>Station #2</b></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station2_Out" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station2_Out_SlotNo" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station2_Full" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station2_Reset" min="0"></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div><toggle ng-model="vm.hardware.plc2_Station2_IsOrphanStation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-md-2 col-lg-2" style="line-height:30px;text-align:right"><b>Station #3</b></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station3_Out" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station3_Out_SlotNo" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station3_Full" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station3_Reset" min="0"></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div><toggle ng-model="vm.hardware.plc2_Station3_IsOrphanStation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-md-2 col-lg-2" style="line-height:30px;text-align:right"><b>Station #4</b></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station4_Out" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station4_Out_SlotNo" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station4_Full" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station4_Reset" min="0"></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div><toggle ng-model="vm.hardware.plc2_Station4_IsOrphanStation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-md-2 col-lg-2" style="line-height:30px;text-align:right"><b>Station #5</b></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station5_Out" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station5_Out_SlotNo" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station5_Full" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station5_Reset" min="0"></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div><toggle ng-model="vm.hardware.plc2_Station5_IsOrphanStation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-md-2 col-lg-2" style="line-height:30px;text-align:right"><b>Station #6</b></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station6_Out" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station6_Out_SlotNo" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station6_Full" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station6_Reset" min="0"></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div><toggle ng-model="vm.hardware.plc2_Station6_IsOrphanStation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-md-2 col-lg-2" style="line-height:30px;text-align:right"><b>Station #7</b></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station7_Out" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station7_Out_SlotNo" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station7_Full" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station7_Reset" min="0"></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div><toggle ng-model="vm.hardware.plc2_Station7_IsOrphanStation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-md-2 col-lg-2" style="line-height:30px;text-align:right"><b>Station #8</b></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station8_Out" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station8_Out_SlotNo" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station8_Full" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station8_Reset" min="0"></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div><toggle ng-model="vm.hardware.plc2_Station8_IsOrphanStation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-md-2 col-lg-2" style="line-height:30px;text-align:right"><b>Station #9</b></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station9_Out" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station9_Out_SlotNo" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station9_Full" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station9_Reset" min="0"></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div><toggle ng-model="vm.hardware.plc2_Station9_IsOrphanStation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-md-2 col-lg-2" style="line-height:30px;text-align:right"><b>Station #10</b></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station10_Out" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station10_Out_SlotNo" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station10_Full" min="0"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><input type="number" class="form-control" ng-model="vm.hardware.plc2_Addr_Station10_Reset" min="0"></div></div><div class="col-md-2 col-lg-2" style="text-align:center"><div><toggle ng-model="vm.hardware.plc2_Station10_IsOrphanStation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Label Printer #1"><legend style="height:32.4px;line-height:32.4px">Label Printer #1 Configuration</legend><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="PRINTER_#1_IP_ADDRESS"></b></label> <input type="text" class="form-control" name="PrinterIpAddress1" ng-model="vm.hardware.printerIpAddress1"></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="PRINTER_#1_PORT"></b></label> <input type="text" class="form-control" name="PrinterPort1" ng-model="vm.hardware.printerPort1"></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="SELECT_A_LABEL_TEMPLATE_FOR_PRINTER_#1"></b></label><select class="form-control" style="color:#333" ng-options="b as b.labelTitle for b in vm.templateList" ng-change="vm.selectedTemplateChanged1()" ng-model="vm.selectedTemplate1"></select></div></div></div><div class="row"><div class="col-md-9 col-lg-9"><div class="form-group"><label><b>Selected template format will be displayed here:</b></label> <textarea class="form-control" ng-disabled="true" ng-model="vm.hardware.printerLabelTemplate1" ng-readonly="true" style="height:250px">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Label Printer #2"><legend style="height:32.4px;line-height:32.4px">Label Printer #2 Configuration</legend><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="PRINTER_#2_IP_ADDRESS"></b></label> <input type="text" class="form-control" ng-model="vm.hardware.printerIpAddress2"></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="PRINTER_#2_PORT"></b></label> <input type="text" class="form-control" ng-model="vm.hardware.printerPort2"></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="SELECT_A_LABEL_TEMPLATE_FOR_PRINTER_#2"></b></label><select class="form-control" style="color:#333" ng-options="b as b.labelTitle for b in vm.templateList" ng-change="vm.selectedTemplateChanged2()" ng-model="vm.selectedTemplate2"></select></div></div></div><div class="row"><div class="col-md-9 col-lg-9"><div class="form-group"><label><b>Selected template format will be displayed here:</b></label> <textarea class="form-control" ng-disabled="true" ng-model="vm.hardware.printerLabelTemplate2" ng-readonly="true" style="height:250px">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/digitalhardware/dhmanagement/dhmgmtCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/digitalhardware/dhmanagement/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="digitalhardware.dhmanagement.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_HARDWARE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="digitalhardware.dhmanagement.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/digitalhardware/dhmanagement/dhmgmtList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.hardwareData" st-safe-src="vm.hardwareDataFull" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Hardware" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="digitalhardware.dhmanagement.create" rms-check-access="digitalhardware.dhmanagement" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_HARDWARE"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="code" translate="CODE"></th><th st-sort="model" translate="MODEL"></th><th st-sort="description" translate="DESCRIPTION"></th><th st-sort="branchName" translate="BRANCH"></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.hardwareData.length<=0 && !vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.hardwareData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.model}}</td><td>{{item.description}}</td><td>{{item.branchName}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="digitalhardware.dhmanagement.update({id:item.id})" rms-check-access="digitalhardware.dhmanagement" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-danger btn-xs" style="display:inline-block;font-size:12pt;" confirmed-click="vm.deleteHardware(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Hardware?" rms-check-access="digitalhardware.dhmanagement" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/digitalhardware/dhmanagement/dhmgmtUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/digitalhardware/dhmanagement/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="digitalhardware.dhmanagement.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="digitalhardware.dhmanagement.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/durianops/producepuree/producepuree.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content"><div class="row"><a href="" class="col-md-4 col-lg-4 durian_dashlet3" ba-panel="" ng-class="{\'durian_jobstart\': vm.isJobStarted}" ng-click="vm.showProductModel()"><div class="figure">{{ vm.productName=="" ? \'DURIAN PUREE\' : vm.productName }}</div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><img src="assets/img/durian_flesh_collect.png" alt=""></div></div><div class="caption" ng-if="!vm.isJobStarted && vm.productName==\'\'">Select a Durian Puree &nbsp<i class="fa fa-chevron-right"></i></div><div class="caption" ng-if="!vm.isJobStarted && vm.productName!=\'\'">Re-select &nbsp<i class="fa fa-chevron-right"></i></div></a> <a href="" class="col-md-5 col-lg-5 durian_dashlet3" ba-panel="" ng-class="{\'durian_jobstart\': vm.isJobStarted}" ng-click="vm.showInventoryModel()"><div class="figure">{{ vm.semiFgId=="" ? \'DURIAN PULPS STOCK\' : vm.semiFgName }}<br><small>({{ vm.semiFgId=="" ? \'QUANTITY\' : vm.semiFgQty + \' \' + vm.semiFgUom }})</small></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><img src="assets/img/durian_pulp.png" alt=""></div></div><div class="caption" ng-if="!vm.isJobStarted && vm.productId==\'\'">Select a Stock Batch &nbsp<i class="fa fa-chevron-right"></i></div><div class="caption" ng-if="!vm.isJobStarted && vm.productId!=\'\'">Re-select &nbsp<i class="fa fa-chevron-right"></i></div></a> <a href="" class="col-md-3 col-lg-3 durian_dashlet3" ba-panel="" ng-class="{\'durian_jobstart\': vm.isJobStarted}" ng-click="vm.toggleJob()"><div class="figure2" ng-if="!vm.isJobStarted">START</div><div class="figure2" ng-if="vm.isJobStarted"><small>PROCESS NO:</small><br>{{vm.jobNo}}</div><div class="caption" ng-if="!vm.isJobStarted">Start Process &nbsp<i class="fa fa-chevron-right"></i></div><div class="caption" ng-if="vm.isJobStarted"><i class="fa fa-spinner fa-spin fa-fw text-danger"></i>&nbsp; Press Here To Complete</div></a></div><div class="row" ng-if="vm.isJobStarted"><div class="col-md-12" ba-panel=""><div class="row" ng-if="vm.grnItems.length!=0"><div class="col-lg-12"><h2>Total Weight: <b>{{vm.totalWeight | number:0 }} KG</b></h2><br>&nbsp;</div></div><div class="row"><div class="col-lg-2" ng-repeat="item in vm.products"><span href="" class="col-lg-12 btn btn-default" style="font-size:14pt"><img src="assets/img/durian_flesh_collect.png" ng-if="!vm.isBasket" style="width:30px;height:30px;margin-right:10px"><big><b>{{item.quantity}} {{item.unitOfMeasurement}}</b></big></span><br>&nbsp;</div><div class="col-lg-2"><span href="" class="col-lg-12 btn btn-default" style="font-size:14pt"><i class="fa fa-cog fa-spin fa-3x fa-fw text-primary"></i></span><br>&nbsp;</div></div></div></div></section></form><script type="text/ng-template" id="DurianOpsProductModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Select a Durian Puree</h3> </div> <div class="modal-body" id="modal-body" style="max-height:380px !important;overflow:auto"> <div class="row" ng-if="$mdl.isLoading"> <div class="col-lg-12"> <h2> <i class="fa fa-spinner fa-spin fa-fw text-danger"></i>&nbsp; Loading List of Durian Puree... </h2> </div> </div> <div class="row" ng-repeat="item in $mdl.productList"> <div class="col-lg-12"> <a href class="col-lg-12 btn btn-default" ng-click="$mdl.selectProduct(item)" style="font-size:20pt"> {{item.name}} </a> <br />&nbsp; </div> </div> </div> <div class="modal-footer"> <a href class="col-lg-12 btn btn-danger" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()" style="font-size:16pt"> CLOSE </a> </div> </form></script><script type="text/ng-template" id="DurianOpsStockBatchModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Select a Stock Batch</h3> </div> <div class="modal-body" id="modal-body" style="max-height:380px !important;overflow:auto"> <div class="row" ng-if="$mdl.isLoading"> <div class="col-lg-12"> <h2> <i class="fa fa-spinner fa-spin fa-fw text-danger"></i>&nbsp; Loading List of Stock Batches... </h2> </div> </div> <div class="row" ng-if="!$mdl.isLoading && $mdl.inventoryList.length==0"> <div class="col-lg-12"> <span class="col-lg-12" style="font-size:20pt;color:#f00"> <br /> <br /> <center>There is no available stock.</center> <br /> <br />&nbsp; </span> <br />&nbsp; </div> </div> <div class="row" ng-repeat="item in $mdl.inventoryList"> <div class="col-lg-12"> <a href class="col-lg-12 btn btn-default" ng-click="$mdl.selectStock(item)" style="font-size:20pt"> {{item.description}} ({{item.quantity}} {{item.uom}}) </a> <br />&nbsp; </div> </div> </div> <div class="modal-footer"> <a href class="col-lg-12 btn btn-danger" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()" style="font-size:16pt"> CLOSE </a> </div> </form></script><script type="text/ng-template" id="DurianOpsCompleteModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Collection Complete</h3> </div> <div class="modal-body" id="modal-body" style="max-height:380px !important;overflow:auto"> <div class="row" ng-if="!$mdl.lockButtons"> <div class="col-md-6 col-lg-6"> <a href class="col-lg-12 btn btn-success" ng-click="$mdl.completeTask()" style="font-size:20pt"> <br /> COMPLETE <br />&nbsp; </a> </div> <div class="col-md-6 col-lg-6"> <a href class="col-lg-12 btn btn-danger" ng-click="$mdl.cancelModal()" style="font-size:20pt"> <br /> CLOSE <br />&nbsp; </a> </div> </div> <div class="row" ng-if="$mdl.lockButtons"> <div class="col-lg-12"> <br /> <h2> <i class="fa fa-spinner fa-spin fa-fw text-danger"></i>&nbsp; Completing process... </h2> <br />&nbsp; </div> </div> </div> <div class="modal-footer"> &nbsp; </div> </form></script>');
$templateCache.put('app/pages/franchise/franchiseemgmt/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FullName.$invalid && (vm.dataForm.FullName.$dirty || vm.dataForm.$submitted)}"><label><b>Full Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="FullName" placeholder="Full Name" ng-model="vm.franchisee.fullName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FullName.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.IdentityCardNo.$invalid && (vm.dataForm.FulIdentityCardNolName.$dirty || vm.dataForm.$submitted)}"><label><b>Identity Card No.</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="IdentityCardNo" placeholder="Identity Card No." ng-model="vm.franchisee.identityCardNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.IdentityCardNo.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label for="Status"><b>Franchisee Status</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Status" style="color:#333" ng-if="vm.originalStatus==\'NEW\'" ng-options="s as s.name for s in vm.statuses" ng-change="vm.selectedStatusChanged()" ng-model="vm.selectedStatus"></select><span class="form-control" disabled="disabled" ng-if="vm.originalStatus!=\'NEW\'" style="color:#00f">{{vm.franchisee.status}}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Email.$invalid && (vm.dataForm.Email.$dirty || vm.dataForm.$submitted)}"><label><b>Email</b> <i class="fa fa-asterisk req"></i></label> <input type="email" class="form-control" name="Email" placeholder="Email Address" ng-model="vm.franchisee.email" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.email">* Email format invalid</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Telephone.$invalid && (vm.dataForm.Telephone.$dirty || vm.dataForm.$submitted)}"><label><b>Telephone</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Telephone" placeholder="Telephone" ng-model="vm.franchisee.phone" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Telephone.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>Is Active</b></label><div><toggle ng-model="vm.franchisee.isActive" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><hr></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Address1.$invalid && (vm.dataForm.Address1.$dirty || vm.dataForm.$submitted)}"><label><b>Address 1</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="Address1" class="form-control" placeholder="Address 1" ng-model="vm.franchisee.address1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Address1.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>Address 2</b></label> <input type="text" class="form-control" placeholder="Address 2" ng-model="vm.franchisee.address2"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>Address 3</b></label> <input type="text" class="form-control" placeholder="Address 3" ng-model="vm.franchisee.address3"></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PostCode.$invalid && (vm.dataForm.PostCode.$dirty || vm.dataForm.$submitted)}"><label><b>Post Code</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="PostCode" class="form-control" placeholder="Postal Code" ng-model="vm.franchisee.postcode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PostCode.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.State.$invalid && (vm.dataForm.State.$dirty || vm.dataForm.$submitted)}"><label><b>State</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="State" placeholder="State" ng-model="vm.franchisee.state" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.State.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Country.$invalid && (vm.dataForm.Country.$dirty || vm.dataForm.$submitted)}"><label><b>Country</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="Country" class="form-control" placeholder="Country" ng-model="vm.franchisee.country" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Country.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Bank Details"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BankName.$invalid && (vm.dataForm.BankName.$dirty || vm.dataForm.$submitted)}"><label><b>Bank Name</b> <i class="fa fa-asterisk req" ng-if="vm.franchisee.status==\'CONFIRMED\'"></i></label><select class="form-control" name="BankName" style="color:#333" ng-options="s as s.name for s in vm.bankList" ng-change="vm.selectedBankChanged()" ng-model="vm.selectedBank" ng-required="vm.franchisee.status==\'CONFIRMED\'"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BankName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BankAccName.$invalid && (vm.dataForm.BankAccName.$dirty || vm.dataForm.$submitted)}"><label><b>Bank Account Holder Name</b> <i class="fa fa-asterisk req" ng-if="vm.franchisee.status==\'CONFIRMED\'"></i></label> <input type="text" class="form-control" name="BankAccName" placeholder="Bank Account Holder Name" ng-model="vm.franchisee.bankAccountName" ng-required="vm.franchisee.status==\'CONFIRMED\'"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BankAccName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BankAccNo.$invalid && (vm.dataForm.BankAccNo.$dirty || vm.dataForm.$submitted)}"><label><b>Bank Account No.</b> <i class="fa fa-asterisk req" ng-if="vm.franchisee.status==\'CONFIRMED\'"></i></label> <input type="text" class="form-control" name="BankAccNo" placeholder="Bank Account No." ng-model="vm.franchisee.bankAccountNo" ng-required="vm.franchisee.status==\'CONFIRMED\'"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BankAccNo.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="GHL Merchant" ng-if="vm.hasPosModule"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MerchantID.$invalid && (vm.dataForm.MerchantID.$dirty || vm.dataForm.$submitted)}"><label><b>GHL Merchant ID</b> (Required for Approval)</label> <input type="text" class="form-control" name="MerchantID" placeholder="Merchant ID" ng-model="vm.franchisee.ghlMerchantID"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MerchantID.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TerminalID.$invalid && (vm.dataForm.TerminalID.$dirty || vm.dataForm.$submitted)}"><label><b>GHL Terminal ID</b> (Required for Approval)</label> <input type="text" class="form-control" name="TerminalID" placeholder="Terminal ID" ng-model="vm.franchisee.ghlTerminalID"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TerminalID.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.OperatorID.$invalid && (vm.dataForm.OperatorID.$dirty || vm.dataForm.$submitted)}"><label><b>GHL Operator ID</b> (Required for Approval)</label> <input type="text" class="form-control" name="OperatorID" placeholder="Operator ID" ng-model="vm.franchisee.ghlOperatorID"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.OperatorID.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label><b>Merchant Private Key</b> (Optional)</label> <textarea class="form-control" ng-model="vm.franchisee.ghlPrivateKey" style="font-family:courier;color:#333;height:150px">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/franchise/franchiseemgmt/franchiseeCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/franchise/franchiseemgmt/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="franchise.franchiseemgmt.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create Franchisee</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="franchise.franchiseemgmt.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/franchise/franchiseemgmt/franchiseeList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.franchiseeData" st-safe-src="vm.franchiseeDataFull" refresh-table=""><thead><tr><th colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Franchisee" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="franchise.franchiseemgmt.create" rms-check-access="franchise.franchiseemgmt" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Franchisee</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="fullName">Full Name</th><th st-sort="identityCardNo">Identity Card No.</th><th st-sort="phone">Phone</th><th st-sort="email">Email</th><th st-sort="status">Status</th><th style="text-align:center" class="hide-after">Active</th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.franchiseeData.length<=0 && !vm.isLoading"><td colspan="8" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-show="vm.isLoading"><td colspan="8" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.franchiseeData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.fullName}}</td><td>{{item.identityCardNo}}</td><td>{{item.phone}}</td><td>{{item.email}}</td><td>{{item.status}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="franchise.franchiseemgmt.update({id:item.id})" rms-check-access="franchise.franchiseemgmt" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/franchise/franchiseemgmt/franchiseeUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/franchise/franchiseemgmt/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="franchise.franchiseemgmt.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon" ng-if="vm.originalStatus!=\'APPROVED\'"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="franchise.franchiseemgmt.list" style="margin-right:20px" ng-if="vm.originalStatus!=\'APPROVED\'"><i class="ion ion-close"></i> Discard Changes</a> <a href="" class="btn btn-success btn-with-icon" confirmed-click="vm.approveFranchisee()" ng-confirm-click="Approve this Franchisee?" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'CONFIRMED\'" rms-check-access="franchise.franchiseemgmt.list" rms-check-access-perm-type="APPROVE"><i class="fa fa-check-circle"></i> Approve</a></div></form>');
$templateCache.put('app/pages/inventory/inventorydashboard/inventorydashboard.html','<div class="widgets"><div class="row"><div class="col-lg-12" ba-panel=""><div class="row"><a href="" class="col-lg-3 invdashboard" ba-panel="" ng-repeat="i in vm.data"><div class="title">{{i.description}}</div><div class="quantity"><b>{{i.quantity | number:0}} {{i.uom}}</b></div><div class="progress"><div class="progress-bar progress-bar-striped progress-bar-{{i.stockLevelColor}} active" role="progressbar" aria-valuenow="{{i.percentage}}" aria-valuemin="0" aria-valuemax="100" style="width:{{i.percentage}}%">{{i.percentage}}%</div></div></a></div></div></div></div>');
$templateCache.put('app/pages/inventory/itemreturns/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-show="vm.originalStatus==\'NEW\'"><small><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_RAW_MATERIAL_RETURN_DETAILS"></span>.</small><br><br></p><p ng-show="vm.originalStatus!=\'NEW\'"><small><i class="fa fa-warning"></i> <span translate="ALL_THE_FIELDS_WILL_BE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NO_LONGER"></span> <b translate="PENDING"></b>.</small><br><br></p><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b><span translate="DOCUMENT_NO"></span>.</b></label> <span class="form-control" ng-disabled="true">{{vm.itemreturn.docNo || \'*** AUTONUMBER ***\'}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Status.$invalid && (vm.dataForm.Status.$dirty || vm.dataForm.$submitted)}"><label><b translate="DOCUMENT_STATUS"></b> <i class="fa fa-asterisk req"></i></label><select name="Status" class="form-control" ng-change="changed()" ng-model="vm.itemreturn.status" ng-options="i as i for i in vm.statuses" ng-if="vm.originalStatus==\'NEW\'" required=""></select><span class="form-control" ng-disabled="true" ng-if="vm.originalStatus!=\'NEW\'">{{vm.itemreturn.status}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Status.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.selectedDebtor==null && (vm.dataForm.Customer.$dirty || vm.dataForm.$submitted)}"><label><b translate="CUSTOMER"></b> <i class="fa fa-asterisk req"></i></label> <a href="" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px;margin-left:10px;" confirmed-click="vm.clearDebtor()" ng-confirm-click="Clear selected Customer?" ng-if="vm.selectedDebtor!=null && vm.originalStatus==\'NEW\'"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a><ui-select name="Customer" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" ng-model="vm.selectedDebtor" ng-disabled="vm.originalStatus!=\'NEW\'" append-to-body="false" search-enabled="true" on-select="vm.selectedDebtorChanged()" required=""><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.name | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.debtorList | filter: $select.search" refresh="vm.loadDebtorList($select.search)" refresh-delay="250" minimum-input-length="2"><span ng-bind-html="i.name | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.selectedDebtor==null" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Storage.$invalid && (vm.dataForm.Storage.$dirty || vm.dataForm.$submitted)}"><label><b translate="STORAGE"></b> <i class="fa fa-asterisk req"></i></label><select name="Storage" class="form-control" ng-change="vm.selectedStorageChanged()" ng-model="vm.selectedStorage" ng-disabled="vm.originalStatus!=\'NEW\'" ng-options="i as i.description for i in vm.storageList" required=""><option value="">={{ \'SELECT_A_STORAGE\' | translate }}=</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Storage.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="REMARKS"></b></label> <textarea class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.itemreturn.remarks">\n\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Raw Materials"><p><i class="fa fa-info-circle"></i> <span translate="ADD_RAW_MATERIAL_INTO_THIS_RETURN_FORM"></span>. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddItemModal()" ng-if="vm.originalStatus==\'NEW\'"><i class="ion-plus-round"></i><span translate="ADD_RAW_MATERIAL"></span></a><br><br></p><script type="text/ng-template" id="itemReturnModal.html"><form name="$mdl.rawMatForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="RAW_MATERIAL"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.rawMatForm.SerialNo.$invalid && $mdl.rawMatForm.$submitted}"> <label><b> <span translate="SCAN_QR_CODE_/_KEY_IN_RAW_MATERIAL_LABEL_SERIAL_NO"></span>.</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input name="SerialNo" class="form-control" required ng-disabled="$mdl.isLoading || $mdl.isSubmitting" ng-model="$mdl.item.serialNo" ng-model-options="{ debounce: 500 }" ng-change="$mdl.getLabelInfo()"/> <p class="help-block" style="color:#f00" ng-show="$mdl.rawMatForm.SerialNo.$error.required && $mdl.rawMatForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="RAW_MATERIAL"></b></label> <span class="form-control" ng-disabled="true">{{\'[\' + $mdl.item.itemCode + \'] \' + $mdl.item.itemDescription}}</span> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.rawMatForm.Quantity.$invalid && $mdl.rawMatForm.$submitted}"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" name="Quantity" class="form-control" min=0.1 ng-model="$mdl.item.quantity" ng-change="$mdl.onQuantityChanged" ng-disabled="$mdl.isLoading || $mdl.serialNotValid || $mdl.isSubmitting" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.rawMatForm.Quantity.$error.required && $mdl.rawMatForm.$submitted" translate="REQUIRED">* </p> <p class="help-block" style="color:#f00" ng-show="$mdl.rawMatForm.Quantity.$error.number && $mdl.rawMatForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.rawMatForm.Quantity.$error.min && $mdl.rawMatForm.$submitted">* <span translate="MINIMUM_IS_0.1"></span></p> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b translate="U.O.M"></b></label> <input class="form-control" ng-model="$mdl.item.uomName" required ng-disabled="true"/> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.rawMatForm.Reason.$invalid && $mdl.rawMatForm.$submitted}"> <label><b translate="REASON"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input name="Reason" class="form-control" ng-model="$mdl.item.reason" required ng-disabled="$mdl.isLoading || $mdl.serialNotValid || $mdl.isSubmitting" /> <p class="help-block" style="color:#f00" ng-show="$mdl.rawMatForm.Reason.$error.required && $mdl.rawMatForm.$submitted" translate="REQUIRED">* </p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-if="!$mdl.isSubmitting" ng-disabled="$mdl.isLoading"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-if="!$mdl.isSubmitting" ng-disabled="$mdl.isLoading"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> <div ng-if="$mdl.isSubmitting"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="SUBMITTING"></span> ...</b> </div> </div> </form></script><div class="row"><div class="col-lg-12"><table class="table table-striped" style="border:1px solid #ccc;font-size:90%" st-pipe="vm.refreshBookingProducts" st-table="vm.itemreturn.itemReturnDetails" refresh-table=""><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="CODE"></b></th><th><b translate="DESCRIPTION"></b></th><th style="text-align:right" class="hide-after"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b translate="U.O.M."></b></th><th><b><span translate="SERIAL_NO"></span>.</b></th><th><b translate="RETURN_REASON"></b></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.itemreturn.itemReturnDetails"><td>{{$index+1}}</td><td nowrap="no-wrap">{{ ntn.itemCode || \'\' }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.itemDescription || \'\' }}</td><td style="text-align:right">{{ ntn.quantity }}</td><td>{{ ntn.uomName }}</td><td>{{ ntn.serialNo }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.reason }}</td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditItemModel($index)" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeItem($index)" ng-confirm-click="Confirm remove this Raw Material?" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="9" align="center" ng-show="vm.itemreturn.itemReturnDetails.length==0"><br><span translate="RAW_MATERIAL_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/inventory/itemreturns/itemreturnCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/inventory/itemreturns/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_DOCUMENT"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="inventory.itemreturns.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/inventory/itemreturns/itemreturnList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.docData" style="font-size:85%;" st-safe-src="vm.docDataFull" refresh-table=""><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:30px;line-height:30px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Return Form" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:30px;line-height:30px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="inventory.itemreturns.create" rms-check-access="inventory.itemreturns" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:30px;line-height:30px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="docNo" st-sort-d-efault="reverse"><span translate="DOC_NO"></span></th><th style="padding-top:11px;padding-bottom:11px-;line-height:110%"><span translate="DOC_DATE"></span><br><small>(DD/MM/YYYY)</small></th><th st-sort="branchName" translate="BRANCH"></th><th st-sort="storageName" translate="STORAGE"></th><th st-sort="customerName" translate="CUSTOMER_NAME"></th><th translate="REMARKS"></th><th st-sort="status" translate="STATUS"></th><th style="width:30px"></th><th style="width:30px"></th></tr><tr class="sortable"><th></th><th></th><th></th><th class="form-inline"><select st-search="branchName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="bk in vm.docDataFull | unique:\'branchName\'" value="{{bk.branchName}}">{{bk.branchName}}</option></select></th><th class="form-inline"><select st-search="storageName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="bk in vm.docDataFull | unique:\'storageName\'" value="{{bk.storageName}}">{{bk.storageName | limitTo:15}} <span ng-if="bk.customerName.length>15">...</span></option></select></th><th class="form-inline"><select st-search="customerName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="bk in vm.docDataFull | unique:\'customerName\'" value="{{bk.customerName}}">{{bk.customerName | limitTo:15}} <span ng-if="bk.customerName.length>15">...</span></option></select></th><th></th><th class="form-inline"><select st-search="status"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="bk in vm.docDataFull | unique:\'status\'" value="{{bk.status}}">{{bk.status}}</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.docData.length<=0 && !vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><center translate="NO_RECORD_FOUND">.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.docData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.docNo}}</td><td>{{item.createdDate | date: "dd/MM/yyyy"}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.branchName}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.storageName}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.customerName}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.remarks}}</td><td><b><span ng-if="item.status==\'NEW\'" class="text-warning">{{item.status}}</span> <span ng-if="item.status==\'CONFIRMED\'" class="text-success">{{item.status}}</span> <span ng-if="item.status==\'CANCELLED\'" class="text-danger">{{item.status}}</span> <span ng-if="item.status.indexOf(\'COMPLETED\')!=-1" style="color:#000">{{item.status}}</span></b></td><td align="center"><a href="" title="Print Return Form" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt" ng-click="vm.printReturnForm(item.id, item.salesOrderNo)" ng-show="item.status!=\'CANCELLED\'" rms-check-access="inventory.itemreturns" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="inventory.itemreturns.update({id:item.id})" rms-check-access="inventory.itemreturns" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:30px;line-height:30px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/inventory/itemreturns/itemreturnUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/inventory/itemreturns/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="inventory.itemreturns.list" style="margin-right:20px"><i class="ion ion-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-show="vm.originalStatus==\'NEW\'"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="inventory.itemreturns.list" ng-show="vm.originalStatus==\'NEW\'"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-info btn-with-icon" style="width:120px" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'CANCELLED\'" ng-click="vm.printDocument(vm.itemreturn.id, vm.itemreturn.docNo)" rms-check-access="inventory.itemreturns" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT"></span></a> <a href="" class="btn btn-success btn-with-icon" style="width:120px" ng-show="vm.originalStatus==\'CONFIRMED\'" rms-check-access="inventory.itemreturns" rms-check-access-perm-type="APPROVE" ng-confirm-click="Approve this Document?" confirmed-click="vm.approveDocument()"><i class="fa fa-star"></i> <span translate="APPROVE"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="width:120px" ng-show="vm.originalStatus==\'CONFIRMED\'" rms-check-access="inventory.itemreturns" rms-check-access-perm-type="APPROVE" ng-confirm-click="Trash this Document?" confirmed-click="vm.cancelDocument()"><i class="fa fa-trash"></i> <span translate="TRASH"></span></a> <a href="" class="btn btn-success btn-with-icon" style="width:120px" ng-show="vm.originalStatus==\'APPROVED\'" ng-confirm-click="Complete this Document? Raw Material will be auto Stocked In." confirmed-click="vm.completeDocument()"><i class="ion ion-checkmark"></i> <span translate="COMPLETE"></span></a></div></form>');
$templateCache.put('app/pages/inventory/inventorylock/inventorylock.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><p><i class="fa fa-info-circle"></i> Manage the inventory lock for all the storage locations for stock count purpose.<br><br></p><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true" ng-repeat="b in vm.branchList"><uib-accordion-heading><div class="row"><div class="col-lg-12" style="line-height:130%"><i class="ion-arrow-expand" style="margin-right:15px"></i> <b>{{b.name | uppercase}}</b></div></div></uib-accordion-heading><uib-accordion-body><a href="" class="btn btn-sm btn-success" style="width:100px;margin-top:-5px" confirmed-click="vm.lockAll(b)" ng-confirm-click="Confirm to lock all storages in this branch?">Lock All</a> <a href="" class="btn btn-sm btn-danger" style="width:100px;margin-left:10px;margin-top:-5px" confirmed-click="vm.unlockAll(b)" ng-confirm-click="Confirm to unlock all storages in this branch?">Unlock All</a> &nbsp;&nbsp;&nbsp;&nbsp; Lock / unlock all storages in this branch at one go.<br><br><div class="row"><div class="col-lg-12"><legend style="height:32.4px;line-height:32.4px">Raw Material Storages</legend></div><div class="col-lg-12"><div class="row"><div class="col-md-4 col-lg-3"></div><div class="col-md-8 col-lg-9" colspan="2"><div class="form-group"><b><u>Disable POS Sync (Date Range)</u></b><p style="margin-top:8px;"><i class="fa fa-info-circle"></i> Please note: When entering the date range, input one day later than the intended range. For example, to lock from June 24 to June 26, enter June 25 to June 27.</p></div></div></div></div><div class="col-lg-12" ng-repeat="s in b.storageList | filter:{type:1} | orderBy: \'description\'"><div class="form-group"><div class="row"><div class="col-md-4 col-lg-3"><div><toggle ng-model="s.isInventoryLock" ng-change="vm.updateLock(s)" on="Locked" off="Unlocked" onstyle="btn-success" offstyle="btn-danger"></toggle><span style="margin-left:10px;color:#000">{{s.description | uppercase}}</span></div></div><div class="col-md-5 col-lg-4" ng-if="s.isPosDefault"><div style="display:inline-block;float:left;margin-right:10px"><div moment-picker="s.lockedDateFrom" format="YYYY-MM-DD" start-view="month" set-on-select="true" class="input-group" style="width:120px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="LockedDateFrom" style="width:120px;background:#fffeed" ng-model="s.lockedDateFrom"></div></div><div style="display:inline-block;float:left;margin-right:10px;padding-top:8px;">{{ \'TO\' | translate }}</div><div style="display:inline-block;float:left;margin-right:10px"><div moment-picker="s.lockedDateTo" format="YYYY-MM-DD" start-view="month" set-on-select="true" class="input-group" style="width:120px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="LockedDateTo" style="width:120px;background:#fffeed" ng-model="s.lockedDateTo"></div></div><a href="" title="Confirm" class="btn btn-success" style="display:inline-block" ng-click="vm.submit(s)"><i class="fa fa-check"></i></a> <a href="" title="Clear" class="btn btn-danger" style="display:inline-block" ng-click="vm.clear(s)"><i class="fa fa-times"></i></a></div><div class="col-md-5 col-lg-4" ng-if="!s.isPosDefault"></div><div class="col-md-4 col-lg-3"><a href="" title="View" class="btn btn-primary btn-with-icon" style="display:inline-block" ng-click="vm.showAuditLogModal(s)"><i class="fa fa-eye"></i> <span translate="AUDIT_LOG"></span></a></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><legend style="height:32.4px;line-height:32.4px">Semi Finished Goods Storages</legend></div><div class="col-lg-12" ng-repeat="s in b.storageList | filter:{type:3} | orderBy: \'description\'"><div class="form-group"><div class="row"><div class="col-md-4 col-lg-3"><div><toggle ng-model="s.isInventoryLock" ng-change="vm.updateLock(s)" on="Locked" off="Unlocked" onstyle="btn-success" offstyle="btn-danger"></toggle><span style="margin-left:10px;">{{s.description | uppercase}}</span></div></div><div class="col-md-5 col-lg-4" ng-if="s.isPosDefault"><div style="display:inline-block;float:left;margin-right:10px"><div moment-picker="s.lockedDateFrom" format="YYYY-MM-DD" start-view="month" set-on-select="true" class="input-group" style="width:120px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="LockedDateFrom" style="width:120px;background:#fffeed" ng-model="s.lockedDateFrom"></div></div><div style="display:inline-block;float:left;margin-right:10px;padding-top:8px;">{{ \'TO\' | translate }}</div><div style="display:inline-block;float:left;margin-right:10px"><div moment-picker="s.lockedDateTo" format="YYYY-MM-DD" start-view="month" set-on-select="true" class="input-group" style="width:120px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="LockedDateTo" style="width:120px;background:#fffeed" ng-model="s.lockedDateTo"></div></div><a href="" title="Confirm" class="btn btn-success" style="display:inline-block" ng-click="vm.submit(s)"><i class="fa fa-check"></i></a> <a href="" title="Clear" class="btn btn-danger" style="display:inline-block" ng-click="vm.clear(s)"><i class="fa fa-times"></i></a></div><div class="col-md-5 col-lg-4" ng-if="!s.isPosDefault"></div><div class="col-md-4 col-lg-3"><a href="" title="View" class="btn btn-primary btn-with-icon" style="display:inline-block" ng-click="vm.showAuditLogModal(s)"><i class="fa fa-eye"></i> <span translate="AUDIT_LOG"></span></a></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><legend style="height:32.4px;line-height:32.4px">Finished Goods Storages</legend></div><div class="col-lg-12" ng-repeat="s in b.storageList | filter:{type:2} | orderBy: \'description\'"><div class="form-group"><div class="row"><div class="col-md-4 col-lg-3"><div><toggle ng-model="s.isInventoryLock" ng-change="vm.updateLock(s)" on="Locked" off="Unlocked" onstyle="btn-success" offstyle="btn-danger"></toggle><span style="margin-left:10px;">{{s.description | uppercase}}</span></div></div><div class="col-md-5 col-lg-4" ng-if="s.isPosDefault"><div style="display:inline-block;float:left;margin-right:10px"><div moment-picker="s.lockedDateFrom" format="YYYY-MM-DD" start-view="month" set-on-select="true" class="input-group" style="width:120px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="LockedDateFrom" style="width:120px;background:#fffeed" ng-model="s.lockedDateFrom"></div></div><div style="display:inline-block;float:left;margin-right:10px;padding-top:8px;">{{ \'TO\' | translate }}</div><div style="display:inline-block;float:left;margin-right:10px"><div moment-picker="s.lockedDateTo" format="YYYY-MM-DD" start-view="month" set-on-select="true" class="input-group" style="width:120px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="LockedDateTo" style="width:120px;background:#fffeed" ng-model="s.lockedDateTo"></div></div><a href="" title="Confirm" class="btn btn-success" style="display:inline-block" ng-click="vm.submit(s)"><i class="fa fa-check"></i></a> <a href="" title="Clear" class="btn btn-danger" style="display:inline-block" ng-click="vm.clear(s)"><i class="fa fa-times"></i></a></div><div class="col-md-5 col-lg-4" ng-if="!s.isPosDefault"></div><div class="col-md-4 col-lg-3"><a href="" title="View" class="btn btn-primary btn-with-icon" style="display:inline-block" ng-click="vm.showAuditLogModal(s)"><i class="fa fa-eye"></i> <span translate="AUDIT_LOG"></span></a></div></div></div></div></div></uib-accordion-body></uib-accordion-group></uib-accordion></div></div></div><script type="text/ng-template" id="auditLogModal.html"><div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="AUDIT_LOG"></span></h3> </div> <div class="modal-body" id="modal-body"> <p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_INVENTORY_LOCK"></span><br /></p> <div class="row"> <div class="col-lg-12"> <table class="table table-striped table-bordered" style="font-size:90%"> <thead> <tr> <th style="width:180px"><b translate="DATE_/_TIME"></b></th> <th style="width:180px"><b translate="EDITED_BY"></b></th> <th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th> <th style="width:40%"><b translate="UPDATED_VALUES"></b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.changeLogs.length==0"> <td colspan="4" style="text-align:center"> <br /> {{ \'THERE_IS_NO_CHANGES_YET\' | translate }} <br />&nbsp; </td> </tr> <tr ng-repeat="log in $mdl.changeLogs"> <td style="padding-top:10px;padding-bottom:10px;line-height:130%"> {{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }} </td> <td style="padding-top:10px;padding-bottom:10px;line-height:130%"> {{log.createdBy | uppercase}} </td> <td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td> <td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td> </tr> </tbody> </table> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div></script>');
$templateCache.put('app/pages/inventory/items/itemAdjustment.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div ng-if="!vm.isRmsLite && !vm.isRmsStarter && !vm.isQuickMode"><div class="row"><div class="col-md-7 col-lg-7"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && (vm.dataForm.SerialNo.$dirty || vm.dataForm.$submitted)}"><label><big><b><span translate="STEP_1"></span>: &nbsp; {{ \'ENTER_LABEL_SERIAL_NO\' | translate }}</b></big><i class="fa fa-asterisk req"></i></label></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && (vm.dataForm.SerialNo.$dirty || vm.dataForm.$submitted)}"><input type="text" class="form-control" name="SerialNo" style="text-transform:uppercase" ng-model="vm.adj.serialNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.loadLabelInfo()"><i class="fa fa-search"></i> {{ \'LOAD_LABEL_INFO\' | translate }}</a></div></div><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-4 col-lg-4"><div style="background:#eefaff;padding:10px;line-height:150%"><div class="row"><div class="col-lg-12"><b>Item Code:</b><br>{{vm.labelInfo.itemCode}}</div></div><div class="row"><div class="col-lg-12"><b>Item Description:</b><br>{{vm.labelInfo.itemDescription}}</div></div><div class="row"><div class="col-lg-6"><b>Bal QTY:</b><br>{{vm.labelInfo.balanceQty | number}} {{vm.labelInfo.uom1}}</div><div class="col-lg-6" ng-if="vm.labelInfo.itemCwm"><b>Bal QTY #2:</b><br>{{vm.labelInfo.balanceQty2 | number}} {{vm.labelInfo.uom2}}</div></div></div></div></div><br><br><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-4 col-lg-4"><label><big><b><span translate="STEP_2"></span>: &nbsp; Enter the correct Balance Quantity</b></big></label></div></div><br><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-2 col-lg-2" style="padding-right:0px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity1.$invalid && (vm.dataForm.Quantity1.$dirty || vm.dataForm.$submitted)}"><label><b>New Balance Quantity <span ng-if="vm.labelInfo.itemCwm">#1</span></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity1" style="text-transform:uppercase" ng-model="vm.adj.parallel_Quantity_1" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity1.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity1.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity1.$error.min">* Minimum is zero</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" style="line-height:24px"><br><b>{{vm.labelInfo.uom1}}</b></div></div></div><div class="row" ng-if="vm.labelInfo!=null && vm.labelInfo.itemCwm"><div class="col-md-2 col-lg-2" style="padding-right:0px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity2.$invalid && (vm.dataForm.Quantity2.$dirty || vm.dataForm.$submitted)}"><label><b>New Balance Quantity #2</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity2" style="text-transform:uppercase" ng-model="vm.adj.parallel_Quantity_2" min="0" ng-required="vm.labelInfo.itemCwm"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity2.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity2.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity2.$error.min">* Minimum is zero</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" style="line-height:24px"><div class="form-group"><br><b>{{vm.labelInfo.uom2}}</b></div></div></div></div><br><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Remarks.$invalid && (vm.dataForm.Remarks.$dirty || vm.dataForm.$submitted)}"><label><big><b><span translate="STEP_3"></span>: &nbsp; Enter a reason for Adjustment</b></big><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Remarks" style="text-transform:uppercase" ng-model="vm.adj.remarks" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Remarks.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div><div ng-if="(vm.isRmsLite!=null && vm.isRmsLite) || (vm.isRmsStarter!=null && vm.isRmsStarter) || (vm.isQuickMode!=null && vm.isQuickMode)"><div class="row"><div class="col-md-7 col-lg-7"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ItemCode.$invalid && (vm.dataForm.ItemCode.$dirty || vm.dataForm.$submitted)}"><label><big><b><span translate="STEP_1"></span>: &nbsp; Enter the Item Code</b></big><i class="fa fa-asterisk req"></i></label></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ItemCode.$invalid && (vm.dataForm.ItemCode.$dirty || vm.dataForm.$submitted)}"><input type="text" class="form-control" name="ItemCode" style="text-transform:uppercase" ng-model="vm.adj.itemCode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ItemCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.loadItemInfo()"><i class="fa fa-search"></i> Load Item</a></div></div><div class="row" ng-if="vm.itemInfo!=null"><div class="col-md-4 col-lg-4"><div style="background:#eefaff;padding:10px;line-height:150%"><div class="row"><div class="col-lg-12"><b>Item Code:</b><br>{{vm.itemInfo.itemCode}}</div></div><div class="row"><div class="col-lg-12"><b>Item Description:</b><br>{{vm.itemInfo.itemDesc}}</div></div></div></div></div><br><br><div class="row" ng-if="vm.itemInfo!=null"><div class="col-md-4 col-lg-4"><div class="form-group"><label><big><b><span translate="STEP_2"></span>: &nbsp; Enter the correct Balance Quantity</b></big><i class="fa fa-asterisk req"></i></label></div></div></div><div class="row" ng-if="vm.itemInfo!=null"><div class="col-md-4 col-lg-4"><div class="form-group" style="margin-bottom:0px"><label><b>Quantity #1</b></label></div></div></div><div class="row" ng-if="vm.itemInfo!=null"><div class="col-md-2 col-lg-2" style="padding-right:0px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity.$invalid && (vm.dataForm.Quantity.$dirty || vm.dataForm.$submitted)}"><input type="number" class="form-control" name="Quantity" style="text-transform:uppercase" ng-model="vm.adj.parallel_Quantity_1" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.min">* Minimum is zero</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" style="line-height:35px;color:#00f"><big><b>{{vm.itemInfo.itemUom}}</b></big></div></div></div><div class="row" ng-if="vm.itemInfo!=null && vm.adj.isCWM"><div class="col-md-4 col-lg-4"><div class="form-group" style="margin-bottom:0px"><label><b>Quantity #2</b></label></div></div></div><div class="row" ng-if="vm.itemInfo!=null && vm.adj.isCWM"><div class="col-md-2 col-lg-2" style="padding-right:0px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity.$invalid && (vm.dataForm.Quantity.$dirty || vm.dataForm.$submitted)}"><input type="number" class="form-control" name="Quantity" style="text-transform:uppercase" ng-model="vm.adj.parallel_Quantity_2" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.min">* Minimum is zero</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" style="line-height:35px;color:#00f"><big><b>{{vm.itemInfo.itemUom2}}</b></big></div></div></div><br><div class="row" ng-if="vm.itemInfo!=null && vm.isQuickMode"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Storage.$invalid && vm.dataForm.$submitted}"><label><big><b><span translate="STEP_3"></span>: &nbsp; {{ \'SELECT_A_WAREHOUSE\' | translate}}</b></big><i class="fa fa-asterisk req"></i></label><select name="Storage" class="form-control" ng-change="vm.selectedStorageChanged()" ng-model="vm.selectedStorage" ng-options="i as (i.extendedDescription | uppercase) for i in vm.storageList" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Storage.$invalid" translate="REQUIRED">*</span></div></div></div><br><div class="row" ng-if="vm.itemInfo!=null"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Remarks.$invalid && (vm.dataForm.Remarks.$dirty || vm.dataForm.$submitted)}"><label><big><b><span translate="STEP_4"></span>: &nbsp; Enter a reason for Adjustment</b></big><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Remarks" style="text-transform:uppercase" ng-model="vm.adj.remarks" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Remarks.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons" ui-sref="inventory.items.list" ng-if="vm.labelInfo==null && vm.itemInfo==null"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons" ng-if="vm.labelInfo!=null || vm.itemInfo!=null"><i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }}</button> <a href="" class="btn btn-danger btn-with-icon" ng-disabled="vm.lockButtons" ui-sref="inventory.items.list" ng-if="vm.labelInfo!=null || vm.itemInfo!=null"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/inventory/items/itemList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" style="width:auto;min-width:100%"><div class="row"><div class="col-md-12 col-lg-12"><p><i class="fa fa-info-circle"></i> <span translate="THIS_IS_THE_RAW_MATERIALS_INVENTORY_BALANCE"></span>.</p><a href="" class="btn btn-success btn-with-icon" ng-if="!vm.isRmsLite" ui-sref="inventory.items.stockin" rms-check-access="inventory.items" rms-check-access-perm-type="CREATE"><i class="ion ion-plus-round"></i> <span translate="STOCK_IN"></span></a> <a href="" class="btn btn-danger btn-with-icon" ng-if="!vm.isRmsLite" ui-sref="inventory.items.stockout" rms-check-access="inventory.items" rms-check-access-perm-type="CREATE"><i class="ion ion-minus-round"></i><span translate="STOCK_OUT"></span></a> <a href="" class="btn btn-warning btn-with-icon" ui-sref="inventory.items.stockadjustment" rms-check-access="inventory.itemadjustments" rms-check-access-perm-type="CREATE"><i class="fa fa-adjust"></i><span translate="STOCK_ADJUSTMENT"></span></a></div></div><table class="table table-striped table-hover" st-pipe="vm.retrieveData" st-table="vm.itemData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div></th></tr><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.refresh()"><i class="fa fa-refresh"></i> <span translate="REFRESH"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:80px">#</th><th st-sort="code" translate="CODE"></th><th st-sort="description" translate="DESCRIPTION"></th><th translate="BRANCH"></th><th translate="WAREHOUSE"></th><th style="text-align:right" class="hide-after" translate="BALANCE"></th><th translate="UOM"></th><th ng-if="vm.isCWM" style="text-align:right" class="hide-after"><span translate="ALT"></span>. <span translate="BALANCE"></span></th><th ng-if="vm.isCWM" translate="UOM"></th><th></th><th></th></tr><tr class="sortable"><th></th><th></th><th></th><th class="form-inline"><select st-search="branchName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="i in vm.itemDataFull | unique:\'branchName\' | orderBy:\'branchName\'" value="{{i.branchName}}">{{i.branchName | uppercase}}</option></select></th><th class="form-inline"><select st-search="storageName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="i in vm.itemDataFull | unique:\'storageName\' | orderBy:\'storageName\'" value="{{i.storageName}}">{{i.storageName | uppercase}}</option></select></th><th></th><th></th><th ng-if="vm.isCWM"></th><th ng-if="vm.isCWM"></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-if="!vm.isLoading && vm.itemData.length<=0"><td colspan="11">{{ \'NO_RECORD_FOUND\' | translate }}.</td></tr><tr ng-repeat="item in vm.itemData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code | uppercase}}</td><td>{{item.description | uppercase}}</td><td>{{item.branchName || \'-\' | uppercase}}</td><td>{{item.storageName || \'-\' | uppercase}}</td><td style="text-align:right">{{item.quantity | number}}</td><td>{{item.uom | uppercase}}</td><td ng-if="vm.isCWM" style="text-align:right">{{item.quantity2 | number}}</td><td ng-if="vm.isCWM">{{item.uom2 | uppercase}}</td><td><a href="" title="View Label Listing" class="btn btn-default btn-xs" style="display:inline-block;font-size:14pt;color:#00f" ng-if="item.storageName!=null" ng-click="vm.showLabelListingModal(item)" rms-check-access="inventory.items" rms-check-access-perm-type="READ"><i class="fa fa-tags"></i></a></td><td><a href="" title="View Movement" class="btn btn-default btn-xs" style="display:inline-block;font-size:14pt;color:#00f" ng-if="item.storageName!=null" ng-click="vm.showMovementModal(item)" rms-check-access="inventory.items" rms-check-access-perm-type="READ"><i class="fa fa-stack-overflow"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div><script type="text/ng-template" id="movementModal.html"><form novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:100%;color:#333" st-pipe="$mdl.retrieveData" st-table="$mdl.data" refresh-table> <thead> <tr> <th colspan="7" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.code}} </div> {{$mdl.description}} </h3> </div> <div class="col-xs-10 col-sm-10 col-md-5 col-lg-5 text-right" style="padding-right:0px"> <h3>{{ \'INVENTORY_MOVEMENT\' | translate }}</h3> </div> </th> </tr> <tr> <th colspan="2" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="remarks" type="search" placeholder="Search Movement" class="input form-control" style="background:#fffeed" /> </div> </th> <th colspan="3"> <center ng-if="$mdl.isLoading"> <b style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_MOVEMENT\' | translate }} ... </b> </center> </th> <th colspan="2" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th st-sort="createdDate"><b>{{ \'MOVEMENT_DATE\' | translate }}</b></th> <th><b>{{ \'WAREHOUSE\' | translate }}</b></th> <th style="text-align:right"><b>{{ \'QTY_IN\' | translate }}</b></th> <th style="text-align:right"><b>{{ \'QTY_OUT\' | translate }}</b></th> <th>&nbsp;</th> <th><b>{{ \'CREATED_BY\' | translate }}</b></th> <th><b>{{ \'REMARKS\' | translate }}</b></th> </tr> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.data.length==0"> <td colspan="7" style="height:100px;line-height:100px;color:#000"> {{ \'NO_STOCK_MOVEMENT_AVAILABLE\' | translate }} </td> </tr> <tr ng-repeat="m in $mdl.data"> <td nowrap="nowrap">{{m.createdDate | date: \'dd/MM/yyyy - hh:mm:ssa\' }}</td> <td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{m.storageName | uppercase}}</td> <td style="text-align:right" nowrap="nowrap"> <span style="color:#209e91"> <b>{{(m.in==0||m.in==null)?\'\':m.in || \'\'}}</b> <small>{{(m.in==0||m.in==null)?\'\':m.uom || \'\'}}</small> </span> <span style="color:#209e91" ng-if="m.in2!=0 && m.in2!=null"> &nbsp;(&nbsp;<b>{{m.in2 || \'\'}}</b> <small>{{m.uom2 || \'\'}}</small>&nbsp;) </span> </td> <td style="text-align:right" nowrap="nowrap"> <span style="color:#f00"> <b>{{(m.out==0||m.out==null)?\'\':m.out || \'\'}}</b> <small>{{(m.out==0||m.out==null)?\'\':m.uom || \'\'}}</small> </span> <span style="color:#f00" ng-if="m.out2!=0 && m.out2!=null"> &nbsp;(&nbsp;<b>{{m.out2 || \'\'}}</b> <small>{{m.uom2 || \'\'}}</small>&nbsp;) </span> </td> <td>&nbsp;</td> <td>{{m.createdBy | limitTo:15 | uppercase}}<span ng-if="m.createdBy.length>15">...</span></td> <td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{m.remarks | uppercase}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="labelModal.html"><form novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:100%;color:#333" st-pipe="$mdl.retrieveData" st-table="$mdl.data" refresh-table> <thead> <tr> <th colspan="5" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.code}} </div> {{$mdl.description}} </h3> <div style="color:#00f"> {{$mdl.storageName}} </div> </div> <div class="col-xs-10 col-sm-10 col-md-5 col-lg-5 text-right" style="padding-right:0px"> <h3>{{ \'LABEL_LISTING\' | translate }}</h3> </div> </th> </tr> <tr> <th colspan="1"> <center ng-if="$mdl.isLoading"> <b style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_LABEL\' | translate }} ... </b> </center> </th> <th colspan="2" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th st-sort="serialNo"><b>{{ \'SERIAL_NO.\' | translate }}</b></th> <th><b>{{ \'LABEL_QUANTITY\' | translate }}</b></th> <th><b>{{ \'BALANCE_QUANTITY\' | translate }}</b></th> <th><b>{{ \'EXPIRY_DATE\' | translate }}</b></th> <th><b>{{ \'UOM\' | translate }}</b></th> </tr> <tr class="sortable"> <th class="form-inline"> <input st-search="serialNo" class="form-control input input-sm" /> </th> <th class="form-inline"></th> <th class="form-inline"></th> <th class="form-inline"> <input st-search="expiryDate" class="form-control input input-sm" /> </th> <th class="form-inline"> <input st-search="uom" class="form-control input input-sm" /> </th> </tr> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.data.length==0"> <td colspan="5" style="height:100px;line-height:100px;color:#000"> {{ \'NO_LABEL_LISTING_AVAILABLE\' | translate }} </td> </tr> <tr ng-repeat="m in $mdl.data"> <td>{{ m.serialNo }}</td> <td>{{ m.quantity }}</td> <td>{{ m.balanceQty }}</td> <td>{{ m.expiryDate | date:\'dd/MM/yyyy\' }}</td> <td>{{ m.uom1 }}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/inventory/items/itemStockIn.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_DETAILS"></span>.</p><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StorageId.$invalid && vm.dataForm.$submitted}"><label><i class="fa fa-industry"></i> &nbsp;<big><b translate="SELECT_A_WAREHOUSE"></b></big><i class="fa fa-asterisk req"></i></label><select name="StorageId" class="form-control" style="font-size:150%;color:#00f;height:auto !important" ng-change="vm.selectStorage()" ng-model="vm.storageList.selected" ng-options="i as (i.extendedDescription | uppercase) for i in vm.storageList" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StorageId.$invalid" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><i class="fa fa-qrcode"></i> &nbsp;<big><b translate="KEY_IN_GRN_NO">.</b></big><em>( <span translate="OPTIONAL"></span>)</em></label> <input type="text" class="form-control" name="GrnNo" style="font-size:150%;color:#00f;height:auto !important" ng-model="vm.stock.grnNo"></div></div><div class="col-md-4 col-lg-4"><label style="color:#fff">____</label><div class="checkbox checkbox-primary"><input type="checkbox" ng-model="vm.retainBookingNo"> <label><span translate="RETAIN_GRN_NO">.</span></label></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && vm.dataForm.$submitted}"><label><i class="fa fa-qrcode"></i> &nbsp;<big><b><span translate="KEY_IN_RAW_MATERIAL_LABEL_SERIAL_NO"></span>.</b></big><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SerialNo" style="font-size:150%;color:#00f;height:auto !important" ng-model="vm.stock.serialNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SerialNo.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="alert bg-success" style="color:#000" ng-if="vm.showSuccess"><i class="ion ion-checkmark"></i> <b>Raw Material Stock In successfully.</b></div><div class="alert" style="background:#fffc00;color:#000" ng-if="vm.showError"><h3 style="color:#f00"><i class="ion ion-alert-circled"></i> <b>Error: {{vm.errorMessage || \'Error Message\'}}</b></h3><div ng-if="vm.promptSameBranchError"><br><br><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.continueSameBranch()"><i class="ion ion-checkmark"></i> <span translate="YES"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-close"></i> <span translate="NO"></span></a></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-default btn-with-icon" ng-disabled="vm.lockButtons" ui-sref="inventory.items.list"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }}</button></div></form></div>');
$templateCache.put('app/pages/inventory/items/itemStockOut.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="form-content"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_DETAILS"></span>.</p><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DocumentNumber.$invalid && vm.dataForm.$submitted}"><label><big><b>1)&nbsp;&nbsp;<span translate="ENTER_THE_DOCUMENT_NUMBER"></span>.</b></big><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DocumentNumber" style="font-size:150%;color:#00f;height:auto !important" ng-disabled="vm.promptExp || vm.promptFIFO || vm.promptTolerence || vm.promptCwmInput" ng-model="vm.stock.docNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DocumentNumber.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><label style="color:#fff">____</label><div class="checkbox checkbox-primary"><input type="checkbox" ng-model="vm.retainDocNo"> <label><b><span translate="RETAIN_DOC_NO"></span></b></label></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && vm.dataForm.$submitted}"><label><big><b>2)&nbsp;&nbsp;<span translate="KEY_IN_RAW_MATERIAL_LABEL_SERIAL_NO"></span>.</b></big><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SerialNo" style="font-size:150%;color:#00f;height:auto !important" ng-disabled="vm.promptExp || vm.promptFIFO || vm.promptTolerence || vm.promptCwmInput" ng-model="vm.stock.serialNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="alert bg-success" style="color:#000" ng-show="vm.showSuccess"><h3><i class="ion ion-checkmark"></i> <b>{{vm.successMessage || \'Success Message\'}}</b></h3></div><div class="alert" style="background:#fffc00;color:#000" ng-if="vm.showError"><h3 style="color:#f00"><i class="ion ion-alert-circled"></i> <b>{{vm.errorMessage || \'Error Message\'}}</b></h3><br><br><div ng-if="vm.promptExp"><div style="margin-bottom:10px"><h3><span translate="DO_YOU_WANT_TO_CONTINUE"></span>?</h3></div><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.continueExp()"><i class="ion ion-checkmark"></i> <span translate="YES"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-close"></i> <span translate="NO"></span></a></div><div ng-if="vm.promptFIFO"><div style="margin-bottom:10px"><h3><span translate="DO_YOU_WANT_TO_RE-SELECT"></span>?</h3></div><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-checkmark"></i> <span translate="YES"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.continueFifo()"><i class="ion ion-close"></i> <span translate="NO"></span></a></div><div ng-if="vm.promptTolerence"><div style="margin-bottom:10px"><h3><span translate="DO_YOU_WANT_TO_CONTINUE"></span>?</h3></div><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.continueTolerence()"><i class="ion ion-checkmark"></i> <span translate="YES"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-close"></i> <span translate="NO"></span></a></div><div ng-if="vm.promptCwmInput"><div style="margin-bottom:30px"><big>{{vm.itemCode || \'Item Code\'}}</big><h3>{{vm.itemName || \'Item Name\'}}</h3><div class="row"><div class="col-lg-5"><div class="bg-primary" style="padding:5px 8px"><i class="fa fa-info-circle"></i> This is a Catch-Weight Item.</div></div></div></div><div style="margin-bottom:10px"><div class="row"><div class="col-lg-12"><b>QUANTITY #1:</b></div></div><div class="row" ng-hide="vm.stock.parallel_quantity_1>0"><div class="col-lg-12"><span style="color:#00f"><b>Please enter the quantity below:</b></span></div></div><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity1.$invalid && vm.dataForm.$submitted}"><div class="row"><div class="col-lg-5"><input type="number" class="form-control" name="Quantity1" style="font-size:150%;color:#00f;height:auto !important" ng-model="vm.stock.parallel_quantity_1" min="0.001" ng-disabled="vm.stock.parallel_quantity_1>0" ng-required="vm.promptCwmInput"></div><div class="col-lg-5" style="line-height:41px;padding-left:0px"><b style="font-size:16pt">{{vm.uomName1 || \'KG\'}}</b></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity1.$error.required" translate="REQUIRED">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity1.$error.number" translate="ENTER_NUMBERS_ONLY">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity1.$error.min" translate="MINIMUM_VALUE_IS_0.001">*</span></div></div><div style="margin-bottom:10px"><div class="row"><div class="col-lg-12"><b>QUANTITY #2:</b></div></div><div class="row" ng-hide="vm.stock.parallel_quantity_2>0"><div class="col-lg-12"><span style="color:#00f"><b>Please enter the quantity below:</b></span></div></div><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity2.$invalid && vm.dataForm.$submitted}"><div class="row"><div class="col-lg-5"><input type="number" class="form-control" name="Quantity2" style="font-size:150%;color:#00f;height:auto !important" ng-model="vm.stock.parallel_quantity_2" min="0.001" ng-disabled="vm.stock.parallel_quantity_2>0" ng-required="vm.promptCwmInput"></div><div class="col-lg-5" style="line-height:41px;padding-left:0px"><b style="font-size:16pt">{{vm.uomName2 || \'KG\'}}</b></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity2.$error.required" translate="REQUIRED">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity2.$error.number" translate="ENTER_NUMBERS_ONLY">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity2.$error.min" translate="MINIMUM_VALUE_IS_0.001">*</span></div></div><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.submit()"><i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }}</a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-close"></i> {{ \'CANCEL\' | translate }}</a></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div></div><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ng-hide="vm.lockButtons || vm.promptExp || vm.promptFIFO || vm.promptTolerence || vm.promptCwmInput" style="margin-right:20px" ui-sref="inventory.items.list"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-hide="vm.lockButtons || vm.promptExp || vm.promptFIFO || vm.promptTolerence || vm.promptCwmInput"><i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }}</button></div></form>');
$templateCache.put('app/pages/inventory/products/productAdjustment.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_DETAILS"></span>.<br>&nbsp;</p><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FinishedGood.$invalid && vm.dataForm.$submitted}"><label><b translate="SELECT_A_FINISHED_GOODS"></b> <i class="fa fa-asterisk req"></i></label><select name="FinishedGood" class="form-control" ng-change="vm.selectedProductChanged()" ng-model="vm.selectedProduct" ng-options="i as (i.name | uppercase) for i in vm.itemList" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FinishedGood.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Storage.$invalid && vm.dataForm.$submitted}"><label><b translate="SELECT_A_WAREHOUSE"></b> <i class="fa fa-asterisk req"></i></label><select name="Storage" class="form-control" ng-change="vm.selectedStorageChanged()" ng-model="vm.selectedStorage" ng-options="i as (i.extendedDescription | uppercase) for i in vm.storageList" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Storage.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity.$invalid && vm.dataForm.$submitted}"><label><b translate="QUANTITY"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity" placeholder="Quantity" ng-model="vm.quantity" ng-pattern="/[1-9]/" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.required" translate="REQUIRED">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.pattern">* <span translate="ZERO_IS_NOT_ALLOWED"></span></span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.number" translate="KEY_IN_NUMBERS_ONLY">*</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UOM.$invalid && vm.dataForm.$submitted}"><label><b>{{ \'UNIT_OF_MEASUREMENT\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="UOM" class="form-control" ng-change="vm.selectedUomChanged()" ng-model="vm.selectedUom" ng-options="i as (i.name | uppercase) for i in vm.uomList" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UOM.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Remarks.$invalid && vm.dataForm.$submitted}"><label><b translate="REMARKS"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Remarks" placeholder="Enter some remarks" ng-model="vm.movement.remarks" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Remarks.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons" ui-sref="inventory.products.list" ng-if="vm.labelInfo==null && vm.itemInfo==null"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons" ng-if="vm.labelInfo!=null || vm.itemInfo!=null"><i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }}</button> <a href="" class="btn btn-danger btn-with-icon" ng-disabled="vm.lockButtons" ui-sref="inventory.products.list" ng-if="vm.labelInfo!=null || vm.itemInfo!=null"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/inventory/products/productList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="row"><div class="col-md-12 col-lg-12"><p><i class="fa fa-info-circle"></i> <span translate="THIS_IS_THE_FINISHED_GOODS_INVENTORY_BALANCE"></span>.</p><a href="" class="btn btn-success btn-with-icon" ng-if="!vm.isRmsLite" ui-sref="inventory.products.stockin" rms-check-access="inventory.products" rms-check-access-perm-type="CREATE"><i class="ion ion-plus-round"></i><span translate="STOCK_IN"></span></a> <a href="" class="btn btn-danger btn-with-icon" ng-if="!vm.isRmsLite" ui-sref="inventory.products.stockout" rms-check-access="inventory.products" rms-check-access-perm-type="CREATE"><i class="ion ion-minus-round"></i> <span translate="STOCK_OUT"></span></a> <a href="" class="btn btn-warning btn-with-icon" ui-sref="inventory.products.stockadjustment" rms-check-access="inventory.productadjustments" rms-check-access-perm-type="CREATE"><i class="fa fa-adjust"></i> <span translate="STOCK_ADJUSTMENT"></span></a></div></div><div class="horizontal-scroll"><table class="table table-striped table-hover" st-pipe="vm.retrieveData" st-table="vm.itemData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style=""></div></th></tr><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.refresh()"><i class="fa fa-refresh"></i> <span translate="REFRESH"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:80px">#</th><th st-sort="code" translate="CODE"></th><th st-sort="description" translate="DESCRIPTION"></th><th translate="BRANCH"></th><th translate="WAREHOUSE"></th><th style="text-align:right" class="hide-after" translate="BALANCE"></th><th translate="UOM"></th><th ng-if="vm.isCWM" style="text-align:right" class="hide-after"><span translate="ALT"></span>. <span translate="BALANCE"></span></th><th ng-if="vm.isCWM" translate="UOM"></th><th></th><th></th></tr><tr class="sortable"><th></th><th></th><th></th><th class="form-inline"><select st-search="branchName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="i in vm.itemDataFull | unique:\'branchName\' | orderBy:\'branchName\'" value="{{i.branchName}}">{{i.branchName | uppercase}}</option></select></th><th class="form-inline"><select st-search="storageName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="i in vm.itemDataFull | unique:\'storageName\' | orderBy:\'storageName\'" value="{{i.storageName}}">{{i.storageName | uppercase}}</option></select></th><th></th><th></th><th ng-if="vm.isCWM"></th><th ng-if="vm.isCWM"></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-if="!vm.isLoading && vm.itemData.length<=0"><td colspan="11">{{ \'NO_RECORD_FOUND\' | translate }}.</td></tr><tr ng-repeat="item in vm.itemData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code | uppercase}}</td><td>{{item.name | uppercase}}</td><td>{{item.branchName || \'-\' | uppercase}}</td><td>{{item.storageName || \'-\' | uppercase}}</td><td style="text-align:right">{{item.quantity | number}}</td><td>{{item.uom | uppercase}}</td><td ng-if="vm.isCWM" style="text-align:right">{{item.quantity2 | number}}</td><td ng-if="vm.isCWM">{{item.uom2 | uppercase}}</td><td><a href="" title="View Label Listing" class="btn btn-default btn-xs" style="display:inline-block;font-size:14pt;color:#00f" ng-if="item.storageName!=null" ng-click="vm.showLabelListingModal(item)" rms-check-access="inventory.items" rms-check-access-perm-type="READ"><i class="fa fa-tags"></i></a></td><td><a href="" title="View Movement" class="btn btn-default btn-xs" style="display:inline-block;font-size:14pt;color:#00f" ng-if="item.storageName!=null" ng-click="vm.showMovementModal(item)" rms-check-access="inventory.products" rms-check-access-perm-type="READ"><i class="fa fa-stack-overflow"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="movementModal.html"><form novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:100%;color:#333" st-pipe="$mdl.retrieveData" st-table="$mdl.data" refresh-table> <thead> <tr> <th colspan="7" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.code}} </div> {{$mdl.name}} </h3> </div> <div class="col-xs-10 col-sm-10 col-md-5 col-lg-5 text-right" style="padding-right:0px"> <h3>{{ \'INVENTORY_MOVEMENT\' | translate }}</h3> </div> </th> </tr> <tr> <th colspan="2" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="remarks" type="search" placeholder="Search Movement" class="input form-control" style="background:#fffeed" /> </div> </th> <th colspan="3"> <center ng-if="$mdl.isLoading"> <b style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_MOVEMENT\' | translate }} ... </b> </center> </th> <th colspan="2" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th st-sort="createdDate"><b>{{ \'MOVEMENT_DATE\' | translate }}</b></th> <th><b>{{ \'WAREHOUSE\' | translate }}</b></th> <th style="text-align:right"><b>{{ \'QTY_IN\' | translate }}</b></th> <th style="text-align:right"><b>{{ \'QTY_OUT\' | translate }}</b></th> <th>&nbsp;</th> <th><b>{{ \'CREATED_BY\' | translate }}</b></th> <th><b>{{ \'REMARKS\' | translate }}</b></th> </tr> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.data.length==0"> <td colspan="7" style="height:100px;line-height:100px;color:#000"> {{ \'NO_STOCK_MOVEMENT_AVAILABLE\' | translate }} </td> </tr> <tr ng-repeat="m in $mdl.data"> <td nowrap="nowrap">{{m.createdDate | date: \'dd/MM/yyyy - hh:mm:ssa\' }}</td> <td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{m.storageName | uppercase}}</td> <td style="text-align:right" nowrap="nowrap"> <span style="color:#209e91"> <b>{{(m.in==0||m.in==null)?\'\':m.in || \'\'}}</b> <small>{{(m.in==0||m.in==null)?\'\':m.uom || \'\'}}</small> </span> <span style="color:#209e91" ng-if="m.in2!=0 && m.in2!=null"> &nbsp;(&nbsp;<b>{{m.in2 || \'\'}}</b> <small>{{m.uom2 || \'\'}}</small>&nbsp;) </span> </td> <td style="text-align:right" nowrap="nowrap"> <span style="color:#f00"> <b>{{(m.out==0||m.out==null)?\'\':m.out || \'\'}}</b> <small>{{(m.out==0||m.out==null)?\'\':m.uom || \'\'}}</small> </span> <span style="color:#f00" ng-if="m.out2!=0 && m.out2!=null"> &nbsp;(&nbsp;<b>{{m.out2 || \'\'}}</b> <small>{{m.uom2 || \'\'}}</small>&nbsp;) </span> </td> <td>&nbsp;</td> <td>{{m.createdBy | limitTo:15 | uppercase}}<span ng-if="m.createdBy.length>15">...</span></td> <td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{m.remarks | uppercase}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="labelModal.html"><form novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:100%;color:#333" st-pipe="$mdl.retrieveData" st-table="$mdl.data" refresh-table> <thead> <tr> <th colspan="5" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.code}} </div> {{$mdl.name}} </h3> <div style="color:#00f"> {{$mdl.storageName}} </div> </div> <div class="col-xs-10 col-sm-10 col-md-5 col-lg-5 text-right" style="padding-right:0px"> <h3>{{ \'LABEL_LISTING\' | translate }}</h3> </div> </th> </tr> <tr> <th colspan="1"> <center ng-if="$mdl.isLoading"> <b style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_LABEL\' | translate }} ... </b> </center> </th> <th colspan="2" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th st-sort="serialNo"><b>{{ \'SERIAL_NO.\' | translate }}</b></th> <th><b>{{ \'LABEL_QUANTITY\' | translate }}</b></th> <th><b>{{ \'BALANCE_QUANTITY\' | translate }}</b></th> <th><b>{{ \'EXPIRY_DATE\' | translate }}</b></th> <th><b>{{ \'UOM\' | translate }}</b></th> </tr> <tr class="sortable"> <th class="form-inline"> <input st-search="serialNo" class="form-control input input-sm" /> </th> <th class="form-inline"></th> <th class="form-inline"></th> <th class="form-inline"> <input st-search="expiryDate" class="form-control input input-sm" /> </th> <th class="form-inline"> <input st-search="uom" class="form-control input input-sm" /> </th> </tr> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.data.length==0"> <td colspan="5" style="height:100px;line-height:100px;color:#000"> {{ \'NO_LABEL_LISTING_AVAILABLE\' | translate }} </td> </tr> <tr ng-repeat="m in $mdl.data"> <td>{{ m.serialNo }}</td> <td>{{ m.quantity }}</td> <td>{{ m.balanceQty }}</td> <td>{{ m.expiryDate | date:\'dd/MM/yyyy\' }}</td> <td>{{ m.uom1 }}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/inventory/products/productStockIn.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_DETAILS"></span>.</p><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StorageId.$invalid && vm.dataForm.$submitted}"><label><i class="fa fa-industry"></i> &nbsp;<big><b translate="SELECT_A_WAREHOUSE"></b></big><i class="fa fa-asterisk req"></i></label><select name="StorageId" class="form-control" style="font-size:150%;color:#00f;height:auto !important" ng-change="vm.selectStorage()" ng-model="vm.storageList.selected" ng-options="i as (i.extendedDescription | uppercase) for i in vm.storageList" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StorageId.$invalid" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && vm.dataForm.$submitted}"><label><i class="fa fa-qrcode"></i> &nbsp;<big><b><span translate="KEY_IN_PRODUCT_LABEL_SERIAL_NO"></span>.</b></big><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SerialNo" style="font-size:150%;color:#00f;height:auto !important" ng-model="vm.stock.serialNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SerialNo.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="alert bg-success" style="color:#000" ng-if="vm.showSuccess"><i class="ion ion-checkmark"></i> <b translate="PRODUCT_STOCK_IN_SUCCESSFULLY">.</b></div><div class="alert" style="background:#fffc00;color:#000" ng-if="vm.showError"><h3 style="color:#f00"><i class="ion ion-alert-circled"></i> <b>Error: {{vm.errorMessage || \'Error Message\'}}</b></h3><div ng-if="vm.promptSameBranchError"><br><br><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.continueSameBranch()"><i class="ion ion-checkmark"></i> <span translate="YES"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-close"></i> <span translate="NO"></span></a></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-default btn-with-icon" ng-disabled="vm.lockButtons" ui-sref="inventory.products.list"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }}</button></div></form></div>');
$templateCache.put('app/pages/inventory/products/productStockOut.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="form-content"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_DETAILS"></span>.</p><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DocumentNumber.$invalid && vm.dataForm.$submitted}"><label><big><b>1)&nbsp;&nbsp;<span translate="ENTER_THE_DOCUMENT_NUMBER"></span>.</b></big><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DocumentNumber" style="font-size:150%;color:#00f;height:auto !important" ng-disabled="vm.promptExp || vm.promptFIFO || vm.promptTolerence || vm.promptCwmInput" ng-model="vm.stock.docNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DocumentNumber.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><label style="color:#fff">____</label><div class="checkbox checkbox-primary"><input type="checkbox" ng-model="vm.retainDocNo"> <label><b><span translate="RETAIN_DOC_NO"></span></b></label></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && vm.dataForm.$submitted}"><label><big><b>2)&nbsp;&nbsp;<span translate="KEY_IN_PRODUCT_LABEL_SERIAL_NO"></span>.</b></big><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SerialNo" style="font-size:150%;color:#00f;height:auto !important" ng-disabled="vm.promptExp || vm.promptFIFO || vm.promptTolerence || vm.promptCwmInput" ng-model="vm.stock.serialNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="alert bg-success" style="color:#000" ng-show="vm.showSuccess"><h3><i class="ion ion-checkmark"></i> <b>{{vm.successMessage || \'Success Message\'}}</b></h3></div><div class="alert" style="background:#fffc00;color:#000" ng-if="vm.showError"><h3 style="color:#f00"><i class="ion ion-alert-circled"></i> <b>{{vm.errorMessage || \'Error Message\'}}</b></h3><br><br><div ng-if="vm.promptExp"><div style="margin-bottom:10px"><h3><span translate="DO_YOU_WANT_TO_CONTINUE"></span>?</h3></div><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.continueExp()"><i class="ion ion-checkmark"></i> <span translate="YES"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-close"></i> <span translate="NO"></span></a></div><div ng-if="vm.promptFIFO"><div style="margin-bottom:10px"><h3><span translate="DO_YOU_WANT_TO_RE-SELECT"></span>?</h3></div><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-checkmark"></i> <span translate="YES"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.continueFifo()"><i class="ion ion-close"></i> <span translate="NO"></span></a></div><div ng-if="vm.promptTolerence"><div style="margin-bottom:10px"><h3><span translate="DO_YOU_WANT_TO_CONTINUE"></span>?</h3></div><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.continueTolerence()"><i class="ion ion-checkmark"></i> <span translate="YES"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-close"></i> <span translate="NO"></span></a></div><div ng-if="vm.promptCwmInput"><div style="margin-bottom:30px"><big>{{vm.itemCode || \'Item Code\'}}</big><h3>{{vm.itemName || \'Item Name\'}}</h3><div class="row"><div class="col-lg-5"><div class="bg-primary" style="padding:5px 8px"><i class="fa fa-info-circle"></i> This is a Catch-Weight Item.</div></div></div></div><div style="margin-bottom:10px"><div class="row"><div class="col-lg-12"><b>QUANTITY #1:</b></div></div><div class="row" ng-hide="vm.stock.parallel_quantity_1>0"><div class="col-lg-12"><span style="color:#00f"><b>Please enter the quantity below:</b></span></div></div><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity1.$invalid && vm.dataForm.$submitted}"><div class="row"><div class="col-lg-5"><input type="number" class="form-control" name="Quantity1" style="font-size:150%;color:#00f;height:auto !important" ng-model="vm.stock.parallel_quantity_1" min="0.001" ng-disabled="vm.stock.parallel_quantity_1>0" ng-required="vm.promptCwmInput"></div><div class="col-lg-5" style="line-height:41px;padding-left:0px"><b style="font-size:16pt">{{vm.uomName1 || \'KG\'}}</b></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity1.$error.required" translate="REQUIRED">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity1.$error.number" translate="ENTER_NUMBERS_ONLY">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity1.$error.min" translate="MINIMUM_VALUE_IS_0.001">*</span></div></div><div style="margin-bottom:10px"><div class="row"><div class="col-lg-12"><b>QUANTITY #2:</b></div></div><div class="row" ng-hide="vm.stock.parallel_quantity_2>0"><div class="col-lg-12"><span style="color:#00f"><b>Please enter the quantity below:</b></span></div></div><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity2.$invalid && vm.dataForm.$submitted}"><div class="row"><div class="col-lg-5"><input type="number" class="form-control" name="Quantity2" style="font-size:150%;color:#00f;height:auto !important" ng-model="vm.stock.parallel_quantity_2" min="0.001" ng-disabled="vm.stock.parallel_quantity_2>0" ng-required="vm.promptCwmInput"></div><div class="col-lg-5" style="line-height:41px;padding-left:0px"><b style="font-size:16pt">{{vm.uomName2 || \'KG\'}}</b></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity2.$error.required" translate="REQUIRED">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity2.$error.number" translate="ENTER_NUMBERS_ONLY">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity2.$error.min" translate="MINIMUM_VALUE_IS_0.001">*</span></div></div><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.submit()"><i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }}</a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-close"></i> {{ \'CANCEL\' | translate }}</a></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div></div><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ng-hide="vm.lockButtons || vm.promptExp || vm.promptFIFO || vm.promptTolerence || vm.promptCwmInput" style="margin-right:20px" ui-sref="inventory.products.list"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-hide="vm.lockButtons || vm.promptExp || vm.promptFIFO || vm.promptTolerence || vm.promptCwmInput"><i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }}</button></div></form>');
$templateCache.put('app/pages/inventory/itemstockcounts/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel with-scroll"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-if="vm.originalStatus==\'NEW\' && !vm.isLoading"><small><i class="fa fa-info-circle"></i> <span translate="FILL_IN_THE_REQUISITION_DETAILS"></span>.</small></p><p ng-if="vm.originalStatus!=\'NEW\' && !vm.isLoading"><small><i class="fa fa-exclamation-triangle" style="color:#ffbb00"></i> <span translate="ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_AFTER"></span> <b translate="CONFIRMED"></b>.</small></p><br><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="DOCUMENT_NO">.</b></label> <span class="form-control" style="color:#00f">{{vm.stockcount.docNo || \'AUTONUMBER\' }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DocStatus.$invalid && (vm.dataForm.DocStatus.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="DOCUMENT_STATUS"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="DocStatus" style="color:#333" ng-disabled="vm.originalStatus!=\'NEW\'" ng-options="u as u.name for u in vm.statuses track by u.id" ng-change="vm.selectStatus()" ng-model="vm.selectedStatus" ng-if="vm.originalStatus==\'NEW\'" required=""><option></option></select><span class="form-control" style="color:#00f" ng-if="vm.originalStatus!=\'NEW\'">{{vm.stockcount.status}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DocStatus.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BranchName.$invalid && (vm.dataForm.BranchName.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="BRANCH_NAME"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="BranchName" style="color:#333" ng-disabled="vm.mode==2" ng-options="u as u.name for u in vm.branches track by u.id" ng-change="vm.selectBranch()" ng-model="vm.selectedBranch" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BranchName.$error.required" translate="REQUIRED">*</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StorageName.$invalid && (vm.dataForm.StorageName.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="STORAGE_NAME"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="StorageName" style="color:#333" ng-disabled="vm.mode==2" ng-options="u as u.description for u in vm.storages track by u.id" ng-change="vm.selectStorage()" ng-model="vm.selectedStorage" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StorageName.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AssigneeName.$invalid && (vm.dataForm.BranchName.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="ASSIGNEE"></b> <i ng-if="vm.stockcount.status!=\'NEW\'" class="fa fa-asterisk req"></i></label><select class="form-control" name="AssigneeName" style="color:#333" ng-disabled="vm.originalStatus!=\'NEW\'" ng-options="u as ((u.firstName + \' \' + u.lastName) | uppercase) for u in vm.assignees | orderBy:\'firstName\' track by u.id" ng-change="vm.selectAssignee()" ng-model="vm.selectedAssignee" ng-required="vm.stockcount.status!=\'NEW\'"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AssigneeName.$error.required" translate="REQUIRED">*</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b style="color:#00f"><span translate="ALLOW_SELECTIVE_COUNT"></span></b> <i class="fa fa-asterisk req"></i></label><div><toggle ng-if="vm.originalStatus==\'NEW\'" ng-model="vm.stockcount.isPartialCount" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div><span class="form-control" ng-if="vm.originalStatus!=\'NEW\'" ng-disabled="vm.originalStatus!=\'NEW\'">{{vm.stockcount.isPartialCount?"YES":"NO"}}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="REMARKS"></b></label> <textarea class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.stockcount.remarks">\n\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="CREATED_BY"></b></label><div>{{vm.stockcount.createdBy || \'-\' | uppercase}}<br><small>{{vm.stockcount.createdDate || \'-\' | date:\'dd/MM/yyyy hh:mma\'}}</small></div></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'MODIFIED_BY\' | translate }}</b></label><div>{{vm.stockcount.modifiedBy || \'-\' | uppercase}}<br><small>{{vm.stockcount.modifiedDate || \'-\' |date:\'dd/MM/yyyy hh:mma\'}}</small></div></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="Raw Material List"><p ng-if="vm.originalStatus==\'NEW\'"><small><em><i class="fa fa-info-circle"></i> <span translate="FILL_IN_THE_QUANTITY_FOR_THE_RAW_MATERIAL_LIST"></span>.</em></small></p><p ng-if="vm.originalStatus!=\'NEW\'"><small><em><i class="fa fa-exclamation-triangle" style="color:#fffc00"></i> <span translate="ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="NEW"></b>.</em></small></p><div class="row"><div class="col-md-12 col-lg-12" style="overflow:auto;width:auto;min-width:100%"><table class="table table-striped table-hover" style="font-size:90%" st-pipe="vm.retrieveData" st-table="vm.stockcount.items" st-safe-src="vm.stockcount.items" refresh-table=""><thead><tr><th colspan="14" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Raw Material" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-1 col-lg-1">&nbsp;</div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th class="rowno">#</th><th class="sc-item" st-sort="itemDescription"><b><span translate="RAW_MATERIAL"></span><br>{{ \'CODE\' | translate }} &amp; {{ \'DESCRIPTION\' | translate }}</b></th><th class="sc-counted hide-after" style="text-align:center" ng-if="vm.stockcount.status!=\'NEW\' && vm.stockcount.status!=\'READY TO COUNT\' && vm.stockcount.status!=\'CANCELLED\'"><b><span translate="TO_EXCLUDE"></span>?</b></th><th class="sc-counted hide-after" style="text-align:center"><b><span translate="COUNTED"></span>?</b></th><th class="sc-stock-bal hide-after" colspan="2" st-sort="inventoryQuantity"><b><span translate="STOCK_BALANCE"></span><br><span translate="(QUANTITY_/_UOM)"></span></b></th><th class="sc-count hide-after"><b><span translate="COUNT"></span> <span translate="(QUANTITY_/_UOM)"></span><br><span style="color: #AF0000" translate="INVENTORY_VALUE"></span> <span style="color: #AF0000">({{vm.currency}})</span></b></th><th class="sc-count-detail hide-after"><span translate="COUNT"></span><br><span translate="DETAILS"></span></th><th class="sc-diff hide-after" colspan="2"><b><span translate="VARIANCE"></span><br><span translate="(QUANTITY_/_UOM)"></span></b></th><th class="sc-var hide-after" ng-if="vm.stockcount.status!=\'NEW\' && vm.stockcount.status!=\'READY TO COUNT\' && vm.stockcount.status!=\'CANCELLED\'"><b><span translate="VARIANCE"></span><br>{{ \'VALUE\' | translate }} (%)</b></th><th class="sc-remarks hide-after" style="width:250px;"><b>{{ \'REMARKS\' | translate }}</b></th></tr></thead><tbody><tr ng-if="vm.mode==1"><td colspan="14" style="height:100px;line-height:100px"><center><i class="fa fa-info-circle"></i> &nbsp; <b><span translate="SYSTEM_WILL_GENERATE_THE_INVENTORY_LIST_AFTER_THIS_DOCUMENT_IS_SAVED"></span>.</b></center></td></tr><tr ng-if="vm.isLoading"><td colspan="14" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw fa-2x"></i> <span translate="PLEASE_WAIT_WHILE_THE_SYSTEM_IS_LOADING"></span>...</b></center></big></td></tr><tr><td colspan="14" align="center" ng-if="vm.mode==2 && !vm.isLoading" ng-show="vm.stockcount.items.length==0"><br><span translate="STOCK_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr><tr ng-repeat="ntn in vm.stockcount.itemsFiltered"><td>{{vm.startIndex+1+$index}})</td><td class="sc-item"><small>{{ ntn.itemCode || ntn.code }}</small><br><b>{{ ntn.itemDescription || ntn.description | uppercase }}</b><br><span style="font-size:7pt;color:#f00" ng-if="ntn.hasError">{{ntn.errorMsg}}</span></td><td class="sc-counted" style="text-align:center" ng-if="vm.stockcount.status!=\'NEW\' && vm.stockcount.status!=\'READY TO COUNT\' && vm.stockcount.status!=\'CANCELLED\'"><toggle class="btn-xs" ng-model="ntn.isExcluded" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-sm btn-primary" offstyle="btn-sm btn-default" ng-if="vm.stockcount.status!=\'POSTED\'"></toggle><span ng-if="vm.stockcount.status==\'POSTED\'">{{ (ntn.isExcluded ? \'YES\' : \'NO\') | translate | uppercase }}</span></td><td class="sc-counted" style="text-align:center"><i class="fa fa-check" ng-show="ntn.isCounted" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isCounted" style="color:#f00"></i></td><td class="sc-stock-bal"><b>{{ ntn.inventoryQuantity || 0 | number }}</b><div ng-if="ntn.inventoryUomId2!=null">( {{ ntn.inventoryQuantity2 || 0 | number}}</div></td><td class="sc-stock-bal-uom"><b ng-hide="ntn.hasError">{{ ntn.inventoryUomName || \'-\' | uppercase }}</b><div ng-if="ntn.inventoryUomId2!=null" ng-hide="ntn.hasError">{{ ntn.inventoryUomName2 || \'-\' | uppercase}} )</div></td><td style="vertical-align: middle"><div style="display:flex"><div class="sc-count"><b>{{ ntn.countQuantity || 0 | number }}</b><div ng-if="ntn.countUomId2!=null">( {{ ntn.countQuantity2 || 0 | number}}</div></div><div class="sc-count-uom"><b ng-hide="ntn.hasError">{{ ntn.countUomName || \'-\' | uppercase }}</b><div ng-if="ntn.countUomId2!=null" ng-hide="ntn.hasError">{{ ntn.countUomName2 || \'-\' | uppercase}} )</div></div></div><div ng-if="ntn.countQuantityValue!=null" class="sc-count-quantity-value">{{ ntn.countQuantityValue || 0 | number}}</div></td><td class="sc-count-detail"><a href="" class="btn btn-default btn-sm" ng-if="ntn.isCounted" ng-click="vm.showMovementModal(ntn)"><i class="fa fa-search"></i></a></td><td class="sc-diff"><div ng-if="ntn.isCounted"><b ng-if="vm.isPositive(ntn.countQuantity-ntn.inventoryQuantity)" class="sc-positive">{{ (ntn.countQuantity-ntn.inventoryQuantity) || 0 | number }}</b> <b ng-if="!vm.isPositive(ntn.countQuantity-ntn.inventoryQuantity)" class="sc-negative">{{ (ntn.countQuantity-ntn.inventoryQuantity) || 0 | number }}</b></div><div ng-if="!ntn.isCounted">-</div></td><td class="sc-diff-uom"><div ng-if="ntn.isCounted"><b ng-if="vm.isPositive(ntn.countQuantity-ntn.inventoryQuantity)" class="sc-positive">{{ ntn.inventoryUomName || \'-\' | uppercase }}</b> <b ng-if="!vm.isPositive(ntn.countQuantity-ntn.inventoryQuantity)" class="sc-negative">{{ ntn.inventoryUomName || \'-\' | uppercase }}</b></div></td><td class="sc-var" ng-if="vm.stockcount.status!=\'NEW\' && vm.stockcount.status!=\'READY TO COUNT\' && vm.stockcount.status!=\'CANCELLED\'"><div><span ng-if="ntn.isCounted"><small style="color:#000">{{vm.currency}}</small> <b ng-if="vm.isPositive(ntn.variancePercentage)" class="sc-positive">{{ ntn.varianceValue || \'-\' | number:2 }}</b> <b ng-if="!vm.isPositive(ntn.variancePercentage)" class="sc-negative">{{ ntn.varianceValue || \'-\' | number:2 }}</b></span> <span ng-if="!ntn.isCounted">-</span></div><div><span ng-if="ntn.isCounted">( <b ng-if="vm.isPositive(ntn.variancePercentage)" class="sc-positive">{{ ntn.variancePercentage || \'-\' | number:2 }}</b> <b ng-if="!vm.isPositive(ntn.variancePercentage)" class="sc-negative">{{ ntn.variancePercentage || \'-\' | number:2 }}</b>% )</span></div></td><td class="sc-remarks"><div class="form-group" style="margin-bottom:0px !important"><input type="text" name="remarks_{{ntn.itemId}}" class="form-control" style="width:250px;height:28px;color:#000;font-size:9pt;padding:3px 6px" ng-model="ntn.remarks" ng-disabled="vm.originalStatus==\'COMPLETED\' || vm.originalStatus==\'CANCELLED\'"></div></td></tr></tbody><tfoot><tr><td colspan="14" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table><div><div></div></div></div></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="countIDetailModal.html"><form name="$mdl.stepForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:100%;color:#333" st-pipe="$mdl.retrieveData" st-table="$mdl.mvmtData" refresh-table> <thead> <tr> <th colspan="7" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.item.itemCode}} </div> {{$mdl.item.itemName}} </h3> </div> <div class="col-xs-10 col-sm-10 col-md-5 col-lg-5 text-right" style="padding-right:0px"> <span>Count Info</span> </div> </th> </tr> <tr> <th colspan="2"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Item" class="input form-control" /> </div> </th> <th colspan="5" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr> <th><b>Serial No.</b></th> <th colspan="2" style="text-align:center"><b>Quantity</b></th> <th colspan="2" style="text-align:center" ng-if="$mdl.item.isCwm"><b>Alt. Quantity</b></th> <th><b>Bin Location</b></th> <th><b>Remarks</b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="7"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i>Loading Data ...</b></center> </td> </tr> <tr ng-repeat="m in $mdl.labelData"> <td nowrap="nowrap">{{m.serialNo}}</td> <td style="text-align:right"> {{m.quantity | number}} </td> <td>{{m.uomName}}</td> <td ng-if="$mdl.item.isCwm" style="text-align:right"> {{m.quantity2 || 0 | number}} </td> <td ng-if="$mdl.item.isCwm">{{m.uomName2 || \'\'}}</td> <td>{{m.binLocation || \'-\'}}</td> <td>{{m.remarks || \'-\'}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/inventory/itemstockcounts/itemstockcountCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/inventory/itemstockcounts/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons || vm.isLoading"><i class="ion ion-checkmark"></i> <span translate="CREATE_STOCK_COUNT"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="inventory.itemstockcounts.list" ng-disabled="vm.lockButtons || vm.isLoading"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/inventory/itemstockcounts/itemstockcountList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RawMatStockCountListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table="" style="font-size:100%"><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_CLOSED_DOCUMENTS\' | translate }}</option><option value="1">{{ \'SHOW_ALL_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="inventory.itemstockcounts.create" rms-check-access="inventory.itemstockcounts" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="NEW_STOCK_COUNT"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="docNo">{{\'DOC_NO\' | translate}}</th><th st-sort="createdDate">{{\'DOC_DATE\' | translate}}</th><th st-sort="branchName">{{\'BRANCH\' | translate}}</th><th st-sort="storageName">{{\'STORAGE\' | translate}}</th><th st-sort="assigneeName">{{\'ASSIGNEE\' | translate}}</th><th class="hide-after" style="text-align:center">{{\'SELECTIVE_COUNT\' | translate}}</th><th st-sort="status">{{\'STATUS\' | translate}}</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline" colspan="2"><input st-search="docNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="branchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="storageName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="assigneeName" class="form-control input input-sm" style="width:120px"></th><th></th><th class="form-inline"><input st-search="status" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.data.length<=0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td>{{item.docNo}}</td><td>{{item.createdDate | date: "dd-MMM-yyyy" }}</td><td>{{item.branchName | uppercase}}</td><td>{{item.storageName | limitTo:20 | uppercase}} <span ng-if="item.supplierName.length>20">...</span></td><td>{{item.assigneeName | limitTo:20 | uppercase}} <span ng-if="item.assigneeName.length>20">...</span></td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isPartialCount" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isPartialCount" style="color:#f00"></i></td><td>{{item.status}}</td><td align="center"><a href="" title="Print PDF" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" ng-if="item.status!=\'New\' && item.status!=\'Cancelled\'" ng-click="vm.printPDF(item.id, item.docNo)" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="EXPORT"><i class="fa fa-file-pdf-o"></i></a></td><td align="center"><a href="" title="Export Excel" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#197e19" ng-if="item.status!=\'New\' && item.status!=\'Cancelled\'" ng-click="vm.printExcel(item.id, item.docNo)" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="EXPORT"><i class="fa fa-file-excel-o"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="inventory.itemstockcounts.update({id:item.id})" rms-check-access="inventory.itemstockcounts" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="StockCountLabelModal.html"><form name="$mdl.stepForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:80%" st-pipe="$mdl.retrieveData" st-table="$mdl.mvmtData" refresh-table> <thead> <tr> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.item.docNo}} </div> <span translate="STOCK_COUNT_LABEL_LIST"></span> </h3> </div> </th> </tr> <tr> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="col-md-4 col-lg-4" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Label" class="input form-control" /> </div> </div> <div class="col-md-8 col-lg-8" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr> <th><b translate="SERIAL_NO"></b></th> <th><b translate="QUANTITY"></b></th> <th><b translate="UOM"></b></th> <th><b translate="REMARKS"></b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="4"> <div style="padding:20px 0px"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="LOADING_LABELS"></span> ...</b></center> </div> </td> </tr> <tr ng-if="$mdl.mvmtData.length==0"> <td colspan="4" translate="NO_FIFO_LABEL_AVAILABLE">.</td> </tr> <tr ng-repeat="m in $mdl.labelData"> <td>{{m.serialNo | uppercase}}</td> <td>{{m.quantity | number:2}}</td> <td>{{m.uomName | uppercase}}</td> <td>{{m.remarks || \'-\'}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/inventory/itemstockcounts/itemstockcountUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/inventory/itemstockcounts/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:30px" ui-sref="inventory.itemstockcounts.list" ng-disabled="vm.lockButtons || vm.isLoading"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-disabled="vm.lockButtons || vm.isLoading" ng-show="vm.originalStatus==\'NEW\'"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-success btn-with-icon" rms-check-access="inventory.itemstockcounts" rms-check-access-perm-type="APPROVE" confirmed-click="vm.approveStockCount()" ng-confirm-click="Approve this Stock Count?" ng-disabled="vm.lockButtons || vm.isLoading" ng-show="vm.originalStatus==\'SUBMITTED\'"><i class="ion ion-checkmark"></i> <span translate="APPROVE_STOCK_COUNT"></span></a> <a href="" class="btn btn-danger btn-with-icon" rms-check-access="inventory.itemstockcounts" rms-check-access-perm-type="APPROVE" confirmed-click="vm.cancelStockCount()" ng-confirm-click="Cancel this Stock Count?" ng-disabled="vm.lockButtons || vm.isLoading" ng-if="vm.mode==2 && (vm.originalStatus==\'NEW\' || vm.originalStatus==\'SUBMITTED\' || vm.originalStatus==\'APPROVED\' || vm.originalStatus==\'READY TO COUNT\')"><i class="ion ion-trash-a"></i> <span translate="CANCEL_STOCK_COUNT"></span></a> <a href="" class="btn btn-primary btn-with-icon" style="margin-left:30px" rms-check-access="inventory.itemstockcounts" rms-check-access-perm-type="APPROVE" confirmed-click="vm.postStockCount()" ng-confirm-click="Are you sure to Post this Stock Count?" ng-disabled="vm.lockButtons || vm.isLoading" ng-show="vm.originalStatus==\'APPROVED\'"><i class="ion ion-checkmark"></i> <span translate="POST_STOCK_COUNT"></span></a> <a href="" class="btn btn-default btn-with-icon" style="margin-left:30px" rms-check-access="inventory.itemstockcounts" rms-check-access-perm-type="EXPORT" ng-if="vm.originalStatus!=\'NEW\'" ng-click="vm.printPDF()" ng-disabled="vm.lockButtons || vm.isLoading"><i class="fa fa-file-pdf-o" style="color:#f00"></i> PDF</a> <a href="" class="btn btn-default btn-with-icon" rms-check-access="inventory.itemstockcounts" rms-check-access-perm-type="EXPORT" ng-if="vm.originalStatus!=\'NEW\'" ng-click="vm.printExcel()" ng-disabled="vm.lockButtons || vm.isLoading"><i class="fa fa-file-pdf-o" style="color:#197e19"></i> Excel</a></div></form>');
$templateCache.put('app/pages/inventory/productstockcounts/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel with-scroll"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-if="vm.originalStatus==\'NEW\' && !vm.isLoading"><small><i class="fa fa-info-circle"></i> <span translate="FILL_IN_THE_REQUISITION_DETAILS"></span>.</small></p><p ng-if="vm.originalStatus!=\'NEW\' && !vm.isLoading"><small><i class="fa fa-exclamation-triangle" style="color:#ffbb00"></i> <span translate="ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_AFTER"></span> <b translate="CONFIRMED"></b>.</small></p><br><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b><span translate="DOCUMENT_NO"></span>.</b></label> <span class="form-control" style="color:#00f">{{vm.stockcount.docNo || \'AUTONUMBER\' }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DocStatus.$invalid && (vm.dataForm.DocStatus.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="DOCUMENT_STATUS"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="DocStatus" style="color:#333" ng-disabled="vm.originalStatus!=\'NEW\'" ng-options="u as u.name for u in vm.statuses track by u.id" ng-change="vm.selectStatus()" ng-model="vm.selectedStatus" ng-if="vm.originalStatus==\'NEW\'" required=""><option></option></select><span class="form-control" style="color:#00f" ng-if="vm.originalStatus!=\'NEW\'">{{vm.stockcount.status}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DocStatus.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BranchName.$invalid && (vm.dataForm.BranchName.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="BRANCH_NAME"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="BranchName" style="color:#333" ng-disabled="vm.mode==2" ng-options="u as u.name for u in vm.branches track by u.id" ng-change="vm.selectBranch()" ng-model="vm.selectedBranch" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BranchName.$error.required" translate="REQUIRED">*</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StorageName.$invalid && (vm.dataForm.StorageName.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="STORAGE_NAME"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="StorageName" style="color:#333" ng-disabled="vm.mode==2" ng-options="u as u.description for u in vm.storages track by u.id" ng-change="vm.selectStorage()" ng-model="vm.selectedStorage" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StorageName.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AssigneeName.$invalid && (vm.dataForm.BranchName.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="ASSIGNEE"></b> <i ng-if="vm.stockcount.status!=\'NEW\'" class="fa fa-asterisk req"></i></label><select class="form-control" name="AssigneeName" style="color:#333" ng-disabled="vm.originalStatus!=\'NEW\'" ng-options="u as ((u.firstName + \' \' + u.lastName) | uppercase) for u in vm.assignees | orderBy:\'firstName\' track by u.id" ng-change="vm.selectAssignee()" ng-model="vm.selectedAssignee" ng-required="vm.stockcount.status!=\'NEW\'"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AssigneeName.$error.required" translate="REQUIRED">*</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b style="color:#00f"><span translate="ALLOW_SELECTIVE_COUNT"></span></b> <i class="fa fa-asterisk req"></i></label><div><toggle ng-if="vm.originalStatus==\'NEW\'" ng-model="vm.stockcount.isPartialCount" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div><span class="form-control" ng-if="vm.originalStatus!=\'NEW\'" ng-disabled="vm.originalStatus!=\'NEW\'">{{vm.stockcount.isPartialCount?"YES":"NO"}}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="REMARKS"></b></label> <textarea class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.stockcount.remarks">\n\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="CREATED_BY"></b></label><div>{{vm.stockcount.createdBy || \'-\' | uppercase}}<br><small>{{vm.stockcount.createdDate || \'-\' | date:\'dd/MM/yyyy hh:mma\'}}</small></div></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'MODIFIED_BY\' | translate }}</b></label><div>{{vm.stockcount.modifiedBy || \'-\' | uppercase}}<br><small>{{vm.stockcount.modifiedDate || \'-\' |date:\'dd/MM/yyyy hh:mma\'}}</small></div></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="Finished Goods List"><p ng-if="vm.originalStatus==\'NEW\'"><small><em><i class="fa fa-info-circle"></i> <span translate="FILL_IN_THE_QUANTITY_FOR_THE_FINISHED_GOODS_LIST"></span>.</em></small></p><p ng-if="vm.originalStatus!=\'NEW\'"><small><em><i class="fa fa-exclamation-triangle" style="color:#fffc00"></i> <span translate="ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="NEW"></b>.</em></small></p><div class="row"><div class="col-md-12 col-lg-12" style="overflow:auto;width:auto;min-width:100%"><table class="table table-striped table-hover" style="font-size:90%" st-pipe="vm.retrieveData" st-table="vm.stockcount.items" st-safe-src="vm.stockcount.items" refresh-table=""><thead><tr><th colspan="14" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Finished Goods" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-1 col-lg-1">&nbsp;</div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th class="rowno">#</th><th class="sc-item" st-sort="itemDescription"><b>{{ \'FINISHED_GOODS\' | translate }}<br>{{ \'CODE\' | translate }} &amp; {{ \'DESCRIPTION\' | translate }}</b></th><th class="sc-counted hide-after" style="text-align:center" ng-if="vm.stockcount.status!=\'NEW\' && vm.stockcount.status!=\'READY TO COUNT\' && vm.stockcount.status!=\'CANCELLED\'"><b><span translate="TO_EXCLUDE"></span>?</b></th><th class="sc-counted hide-after" style="text-align:center"><b><span translate="COUNTED"></span>?</b></th><th class="sc-stock-bal hide-after" colspan="2" st-sort="inventoryQuantity"><b><span translate="STOCK_BALANCE"></span><br><span translate="(QUANTITY_/_UOM)"></span></b></th><th class="sc-count hide-after"><b><span translate="COUNT"></span> <span translate="(QUANTITY_/_UOM)"></span><br><span style="color: #AF0000" translate="INVENTORY_VALUE"></span> <span style="color: #AF0000">({{vm.currency}})</span></b></th><th class="sc-count-detail hide-after"><span translate="COUNT"></span><br><span translate="DETAILS"></span></th><th class="sc-diff hide-after" colspan="2"><b><span translate="VARIANCE"></span><br><span translate="(QUANTITY_/_UOM)"></span></b></th><th class="sc-var hide-after" ng-if="vm.stockcount.status!=\'NEW\' && vm.stockcount.status!=\'READY TO COUNT\' && vm.stockcount.status!=\'CANCELLED\'"><b><span translate="VARIANCE"></span><br>{{ \'VALUE\' | translate }} (%)</b></th><th class="sc-remarks hide-after" style="width:250px;"><b>{{ \'REMARKS\' | translate }}</b></th></tr></thead><tbody><tr ng-if="vm.mode==1"><td colspan="14" style="height:100px;line-height:100px"><center><i class="fa fa-info"></i> <b><span translate="SYSTEM_WILL_GENERATE_THE_INVENTORY_LIST_AFTER_THIS_DOCUMENT_IS_SAVED"></span>.</b></center></td></tr><tr ng-if="vm.isLoading"><td colspan="14" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw fa-2x"></i> <span translate="PLEASE_WAIT_WHILE_THE_SYSTEM_IS_LOADING"></span></b></center></big></td></tr><tr><td colspan="14" align="center" ng-if="vm.mode==2 && !vm.isLoading" ng-show="vm.stockcount.items.length==0"><br><span translate="STOCK_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr><tr ng-repeat="ntn in vm.stockcount.itemsFiltered"><td>{{vm.startIndex+1+$index}})</td><td class="sc-item"><small>{{ ntn.itemCode || ntn.code }}</small><br><b>{{ ntn.itemDescription || ntn.description | uppercase }}</b><br><span style="font-size:7pt;color:#f00" ng-if="ntn.hasError">{{ntn.errorMsg}}</span></td><td class="sc-counted" style="text-align:center" ng-if="vm.stockcount.status!=\'NEW\' && vm.stockcount.status!=\'READY TO COUNT\' && vm.stockcount.status!=\'CANCELLED\'"><toggle class="btn-xs" ng-model="ntn.isExcluded" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-xs btn-primary" offstyle="btn-xs btn-default" ng-if="vm.stockcount.status!=\'POSTED\'"></toggle><span ng-if="vm.stockcount.status==\'POSTED\'">{{ (ntn.isExcluded ? \'YES\' : \'NO\') | translate | uppercase }}</span></td><td class="sc-counted" style="text-align:center"><i class="fa fa-check" ng-show="ntn.isCounted" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isCounted" style="color:#f00"></i></td><td class="sc-stock-bal"><b>{{ ntn.inventoryQuantity || 0 | number }}</b><div ng-if="ntn.inventoryUomId2!=null">( {{ ntn.inventoryQuantity2 || 0 | number}}</div></td><td class="sc-stock-bal-uom"><b ng-hide="ntn.hasError">{{ ntn.inventoryUomName || \'-\' | uppercase }}</b><div ng-if="ntn.inventoryUomId2!=null" ng-hide="ntn.hasError">{{ ntn.inventoryUomName2 || \'-\' | uppercase}} )</div></td><td style="vertical-align: middle"><div style="display:flex"><div class="sc-count"><b>{{ ntn.countQuantity || 0 | number }}</b><div ng-if="ntn.countUomId2!=null">( {{ ntn.countQuantity2 || 0 | number}}</div></div><div class="sc-count-uom"><b ng-hide="ntn.hasError">{{ ntn.countUomName || \'-\' | uppercase }}</b><div ng-if="ntn.countUomId2!=null" ng-hide="ntn.hasError">{{ ntn.countUomName2 || \'-\' | uppercase}} )</div></div></div><div ng-if="ntn.countQuantityValue!=null" class="sc-count-quantity-value">{{ ntn.countQuantityValue || 0 | number}}</div></td><td class="sc-count-detail"><a href="" class="btn btn-default btn-sm" ng-if="ntn.isCounted" ng-click="vm.showMovementModal(ntn)"><i class="fa fa-search"></i></a></td><td class="sc-diff"><div ng-if="ntn.isCounted"><b ng-if="vm.isPositive(ntn.countQuantity-ntn.inventoryQuantity)" class="sc-positive">{{ (ntn.countQuantity-ntn.inventoryQuantity) || 0 | number }}</b> <b ng-if="!vm.isPositive(ntn.countQuantity-ntn.inventoryQuantity)" class="sc-negative">{{ (ntn.countQuantity-ntn.inventoryQuantity) || 0 | number }}</b></div><div ng-if="!ntn.isCounted">-</div></td><td class="sc-diff-uom"><div ng-if="ntn.isCounted"><b ng-if="vm.isPositive(ntn.countQuantity-ntn.inventoryQuantity)" class="sc-positive">{{ ntn.inventoryUomName || \'-\' | uppercase }}</b> <b ng-if="!vm.isPositive(ntn.countQuantity-ntn.inventoryQuantity)" class="sc-negative">{{ ntn.inventoryUomName || \'-\' | uppercase }}</b></div></td><td class="sc-var" ng-if="vm.stockcount.status!=\'NEW\' && vm.stockcount.status!=\'READY TO COUNT\' && vm.stockcount.status!=\'CANCELLED\'"><div><small style="color:#000">{{vm.currency}}</small> <span ng-if="ntn.isCounted"><b ng-if="vm.isPositive(ntn.variancePercentage)" class="sc-positive">{{ ntn.varianceValue | number:2 }}</b> <b ng-if="!vm.isPositive(ntn.variancePercentage)" class="sc-negative">{{ ntn.varianceValue | number:2 }}</b></span> <span ng-if="!ntn.isCounted">-</span></div><div><span ng-if="ntn.isCounted">( <b ng-if="vm.isPositive(ntn.variancePercentage)" class="sc-positive">{{ ntn.variancePercentage | number:2 }}</b> <b ng-if="!vm.isPositive(ntn.variancePercentage)" class="sc-negative">{{ ntn.variancePercentage | number:2 }}</b>% )</span></div></td><td class="sc-remarks"><div class="form-group" style="margin-bottom:0px !important"><input type="text" name="remarks_{{ntn.itemId}}" class="form-control" style="width:250px;height:28px;color:#000;font-size:9pt;padding:3px 6px" ng-model="ntn.remarks" ng-disabled="vm.originalStatus==\'COMPLETED\' || vm.originalStatus==\'CANCELLED\'"></div></td></tr></tbody><tfoot><tr><td colspan="14" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table><div><div></div></div></div></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="countIDetailModal.html"><form name="$mdl.stepForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:100%;color:#333" st-pipe="$mdl.retrieveData" st-table="$mdl.mvmtData" refresh-table> <thead> <tr> <th colspan="7" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.item.itemCode}} </div> {{$mdl.item.itemName}} </h3> </div> <div class="col-xs-10 col-sm-10 col-md-5 col-lg-5 text-right" style="padding-right:0px"> <span>Count Info</span> </div> </th> </tr> <tr> <th colspan="2"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Item" class="input form-control" /> </div> </th> <th colspan="5" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr> <th><b>Serial No.</b></th> <th colspan="2" style="text-align:center"><b>Quantity</b></th> <th colspan="2" style="text-align:center" ng-if="$mdl.item.isCwm"><b>Alt. Quantity</b></th> <th><b>Bin Location</b></th> <th><b>Remarks</b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="7"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i>Loading Data ...</b></center> </td> </tr> <tr ng-repeat="m in $mdl.labelData"> <td nowrap="nowrap">{{m.serialNo}}</td> <td style="text-align:right"> {{m.quantity | number}} </td> <td>{{m.uomName}}</td> <td style="text-align:right" ng-if="$mdl.item.isCwm"> {{m.quantity2 || 0 | number}} </td> <td ng-if="$mdl.item.isCwm">{{m.uomName2 || \'\'}}</td> <td>{{m.binLocation || \'-\'}}</td> <td>{{m.remarks || \'-\'}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/inventory/productstockcounts/productstockcountCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/inventory/productstockcounts/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons || vm.isLoading"><i class="ion ion-checkmark"></i> <span translate="CREATE_STOCK_COUNT"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="inventory.productstockcounts.list" ng-disabled="vm.lockButtons || vm.isLoading"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/inventory/productstockcounts/productstockcountList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="FGStockCountListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table="" style="font-size:100%"><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_CLOSED_DOCUMENTS\' | translate }}</option><option value="1">{{ \'SHOW_ALL_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="inventory.productstockcounts.create" rms-check-access="inventory.productstockcounts" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="NEW_STOCK_COUNT"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="docNo">{{\'DOC_NO\' | translate}}</th><th st-sort="createdDate">{{\'DOC_DATE\' | translate}}</th><th st-sort="branchName">{{\'BRANCH\' | translate}}</th><th st-sort="storageName">{{\'STORAGE\' | translate}}</th><th st-sort="assigneeName">{{\'ASSIGNEE\' | translate}}</th><th class="hide-after" style="text-align:center">{{\'SELECTIVE_COUNT\' | translate}}</th><th st-sort="status">{{\'STATUS\' | translate}}</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline" colspan="2"><input st-search="docNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="branchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="storageName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="assigneeName" class="form-control input input-sm" style="width:120px"></th><th></th><th class="form-inline"><input st-search="status" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.data.length<=0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center translate="NO_RECORD_FOUND">.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}}.</td><td>{{item.docNo}}</td><td>{{item.createdDate | date: "dd-MMM-yyyy" }}</td><td>{{item.branchName | uppercase}}</td><td>{{item.storageName | limitTo:20 | uppercase}} <span ng-if="item.supplierName.length>20">...</span></td><td>{{item.assigneeName | limitTo:20 | uppercase}} <span ng-if="item.assigneeName.length>20">...</span></td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isPartialCount" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isPartialCount" style="color:#f00"></i></td><td>{{item.status}}</td><td align="center"><a href="" title="Print PDF" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" ng-if="item.status!=\'New\' && item.status!=\'Cancelled\'" ng-click="vm.printPDF(item.id, item.docNo)" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="EXPORT"><i class="fa fa-file-pdf-o"></i></a></td><td align="center"><a href="" title="Export Excel" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#198019" ng-if="item.status!=\'New\' && item.status!=\'Cancelled\'" ng-click="vm.printExcel(item.id, item.docNo)" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="EXPORT"><i class="fa fa-file-excel-o"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="inventory.productstockcounts.update({id:item.id})" rms-check-access="inventory.productstockcounts" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="StockCountLabelModal.html"><form name="$mdl.stepForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:80%" st-pipe="$mdl.retrieveData" st-table="$mdl.mvmtData" refresh-table> <thead> <tr> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.item.docNo}} </div> <span translate="STOCK_COUNT_LABEL_LIST"></span> </h3> </div> </th> </tr> <tr> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="col-md-4 col-lg-4" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Label" class="input form-control" /> </div> </div> <div class="col-md-8 col-lg-8" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr> <th><b translate="SERIAL_NO"></b></th> <th><b translate="QUANTITY"></b></th> <th><b translate="UOM"></b></th> <th><b translate="REMARKS"></b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="4"> <div style="padding:20px 0px"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="LOADING_LABELS"></span> ...</b></center> </div> </td> </tr> <tr ng-if="$mdl.mvmtData.length==0"> <td colspan="4"><span translate="NO_FIFO_LABEL_AVAILABLE"></span>.</td> </tr> <tr ng-repeat="m in $mdl.labelData"> <td>{{m.serialNo | uppercase}}</td> <td>{{m.quantity | number:2}}</td> <td>{{m.uomName | uppercase}}</td> <td>{{m.remarks || \'-\'}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/inventory/productstockcounts/productstockcountUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/inventory/productstockcounts/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:30px" ui-sref="inventory.productstockcounts.list" ng-disabled="vm.lockButtons || vm.isLoading"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-disabled="vm.lockButtons || vm.isLoading" ng-show="vm.originalStatus==\'NEW\'"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-success btn-with-icon" rms-check-access="inventory.productstockcounts" rms-check-access-perm-type="APPROVE" confirmed-click="vm.approveStockCount()" ng-confirm-click="Are you sure to Post this Stock Count?" ng-disabled="vm.lockButtons || vm.isLoading" ng-show="vm.originalStatus==\'SUBMITTED\'"><i class="ion ion-checkmark"></i> <span translate="APPROVE_STOCK_COUNT"></span></a> <a href="" class="btn btn-danger btn-with-icon" rms-check-access="inventory.productstockcounts" rms-check-access-perm-type="APPROVE" confirmed-click="vm.cancelStockCount()" ng-confirm-click="Cancel this Stock Count?" ng-disabled="vm.lockButtons || vm.isLoading" ng-if="vm.mode==2 && (vm.originalStatus==\'NEW\' || vm.originalStatus==\'SUBMITTED\' || vm.originalStatus==\'APPROVED\' || vm.originalStatus==\'READY TO COUNT\')"><i class="ion ion-trash-a"></i> <span translate="CANCEL_STOCK_COUNT"></span></a> <a href="" class="btn btn-primary btn-with-icon" style="margin-left:30px" rms-check-access="inventory.productstockcounts" rms-check-access-perm-type="APPROVE" confirmed-click="vm.postStockCount()" ng-confirm-click="Approve this Stock Count?" ng-disabled="vm.lockButtons || vm.isLoading" ng-show="vm.originalStatus==\'APPROVED\'"><i class="ion ion-checkmark"></i> <span translate="POST_STOCK_COUNT"></span></a> <a href="" class="btn btn-default btn-with-icon" style="margin-left:30px" rms-check-access="inventory.productstockcounts" rms-check-access-perm-type="EXPORT" ng-if="vm.originalStatus!=\'NEW\'" ng-click="vm.printPDF()" ng-disabled="vm.lockButtons || vm.isLoading"><i class="fa fa-file-pdf-o" style="color:#f00"></i> PDF</a> <a href="" class="btn btn-default btn-with-icon" rms-check-access="inventory.productstockcounts" rms-check-access-perm-type="EXPORT" ng-if="vm.originalStatus!=\'NEW\'" ng-click="vm.printExcel()" ng-disabled="vm.lockButtons || vm.isLoading"><i class="fa fa-file-pdf-o" style="color:#197e19"></i> Excel</a></div></form>');
$templateCache.put('app/pages/inventory/semifgs/sfgAdjustment.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_DETAILS"></span>.<br>&nbsp;</p><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SemiFinishedGood.$invalid && vm.dataForm.$submitted}"><label><b translate="SELECT_A_SEMI_FINISHED_GOODS"></b> <i class="fa fa-asterisk req"></i></label><select name="SemiFinishedGood" class="form-control" ng-change="vm.selectedProductChanged()" ng-model="vm.selectedProduct" ng-options="i as (i.description | uppercase) for i in vm.itemList" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SemiFinishedGood.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Storage.$invalid && vm.dataForm.$submitted}"><label><b translate="SELECT_A_WAREHOUSE"></b> <i class="fa fa-asterisk req"></i></label><select name="Storage" class="form-control" ng-change="vm.selectedStorageChanged()" ng-model="vm.selectedStorage" ng-options="i as (i.extendedDescription | uppercase) for i in vm.storageList" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Storage.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity.$invalid && vm.dataForm.$submitted}"><label><b translate="QUANTITY"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity" placeholder="Quantity" ng-model="vm.quantity" ng-pattern="/[1-9]/" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.required" translate="REQUIRED">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.pattern">* <span translate="ZERO_IS_NOT_ALLOWED"></span></span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.number" translate="KEY_IN_NUMBERS_ONLY">*</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UOM.$invalid && vm.dataForm.$submitted}"><label><b>{{ \'UNIT_OF_MEASUREMENT\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="UOM" class="form-control" ng-change="vm.selectedUomChanged()" ng-model="vm.selectedUom" ng-options="i as (i.name | uppercase) for i in vm.uomList" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UOM.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Remarks.$invalid && vm.dataForm.$submitted}"><label><b translate="REMARKS"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Remarks" placeholder="Enter some remarks" ng-model="vm.movement.remarks" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Remarks.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons" ui-sref="inventory.semifgs.list" ng-if="vm.labelInfo==null && vm.itemInfo==null"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons" ng-if="vm.labelInfo!=null || vm.itemInfo!=null"><i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }}</button> <a href="" class="btn btn-danger btn-with-icon" ng-disabled="vm.lockButtons" ui-sref="inventory.semifgs.list" ng-if="vm.labelInfo!=null || vm.itemInfo!=null"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form></div>');
$templateCache.put('app/pages/inventory/semifgs/sfgList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="row"><div class="col-md-12 col-lg-12"><p><i class="fa fa-info-circle"></i> <span translate="THIS_IS_THE_SEMI_FINISHED_GOODS_INVENTORY_BALANCE"></span>.</p><a href="" class="btn btn-success btn-with-icon" ng-if="!vm.isRmsLite" ui-sref="inventory.semifgs.stockin" rms-check-access="inventory.semifgs" rms-check-access-perm-type="CREATE"><i class="ion ion-plus-round"></i><span translate="STOCK_IN"></span></a> <a href="" class="btn btn-danger btn-with-icon" ng-if="!vm.isRmsLite" ui-sref="inventory.semifgs.stockout" rms-check-access="inventory.semifgs" rms-check-access-perm-type="CREATE"><i class="ion ion-minus-round"></i><span translate="STOCK_OUT"></span></a> <a href="" class="btn btn-warning btn-with-icon" ui-sref="inventory.semifgs.stockadjustment" rms-check-access="inventory.semifgadjustments" rms-check-access-perm-type="CREATE"><i class="fa fa-adjust"></i><span translate="STOCK_ADJUSTMENT"></span></a></div></div><div class="horizontal-scroll"><table class="table table-striped table-hover" st-pipe="vm.retrieveData" st-table="vm.itemData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style=""></div></th></tr><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.refresh()"><i class="fa fa-refresh"></i> <span translate="REFRESH"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:80px">#</th><th st-sort="code" {{="" \'code\'="" |="" translate="" }}=""></th><th st-sort="description" translate="DESCRIPTION"></th><th translate="BRANCH"></th><th translate="WAREHOUSE"></th><th style="text-align:right" class="hide-after" translate="BALANCE"></th><th translate="UOM"></th><th ng-if="vm.isCWM" style="text-align:right" class="hide-after"><span translate="ALT"></span>. <span translate="BALANCE"></span></th><th ng-if="vm.isCWM" translate="UOM"></th><th></th><th></th></tr><tr class="sortable"><th></th><th></th><th></th><th class="form-inline"><select st-search="branchName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="i in vm.itemDataFull | unique:\'branchName\' | orderBy:\'branchName\'" value="{{i.branchName}}">{{i.branchName | uppercase}}</option></select></th><th class="form-inline"><select st-search="storageName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="i in vm.itemDataFull | unique:\'storageName\' | orderBy:\'storageName\'" value="{{i.storageName}}">{{i.storageName | uppercase}}</option></select></th><th></th><th></th><th ng-if="vm.isCWM"></th><th ng-if="vm.isCWM"></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> ...</b></center></big></td></tr><tr ng-if="!vm.isLoading && vm.itemData.length<=0"><td colspan="11">{{ \'NO_RECORD_FOUND\' | translate }}.</td></tr><tr ng-repeat="item in vm.itemData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code | uppercase}}</td><td>{{item.description | uppercase}}</td><td>{{item.branchName || \'-\' | uppercase}}</td><td>{{item.storageName || \'-\' | uppercase}}</td><td style="text-align:right">{{item.quantity | number}}</td><td>{{item.uom | uppercase}}</td><td ng-if="vm.isCWM" style="text-align:right">{{item.quantity2 | number}}</td><td ng-if="vm.isCWM">{{item.uom2 | uppercase}}</td><td><a href="" title="View Label Listing" class="btn btn-default btn-xs" style="display:inline-block;font-size:14pt;color:#00f" ng-if="item.storageName!=null" ng-click="vm.showLabelListingModal(item)" rms-check-access="inventory.items" rms-check-access-perm-type="READ"><i class="fa fa-tags"></i></a></td><td><a href="" title="View Movement" class="btn btn-default btn-xs" style="display:inline-block;font-size:14pt;color:#00f" ng-if="item.storageName!=null" ng-click="vm.showMovementModal(item)" rms-check-access="inventory.semifgs" rms-check-access-perm-type="READ"><i class="fa fa-stack-overflow"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="movementModal.html"><form novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:100%;color:#333" st-pipe="$mdl.retrieveData" st-table="$mdl.data" refresh-table> <thead> <tr> <th colspan="7" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.code}} </div> {{$mdl.name}} </h3> </div> <div class="col-xs-10 col-sm-10 col-md-5 col-lg-5 text-right" style="padding-right:0px"> <h3>{{ \'INVENTORY_MOVEMENT\' | translate }}</h3> </div> </th> </tr> <tr> <th colspan="2" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="remarks" type="search" placeholder="Search Movement" class="input form-control" style="background:#fffeed" /> </div> </th> <th colspan="3"> <center ng-if="$mdl.isLoading"> <b style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_MOVEMENT\' | translate }} ... </b> </center> </th> <th colspan="2" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th st-sort="createdDate"><b>{{ \'MOVEMENT_DATE\' | translate }}</b></th> <th><b>{{ \'WAREHOUSE\' | translate }}</b></th> <th style="text-align:right"><b>{{ \'QTY_IN\' | translate }}</b></th> <th style="text-align:right"><b>{{ \'QTY_OUT\' | translate }}</b></th> <th>&nbsp;</th> <th><b>{{ \'CREATED_BY\' | translate }}</b></th> <th><b>{{ \'REMARKS\' | translate }}</b></th> </tr> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.data.length==0"> <td colspan="7" style="height:100px;line-height:100px;color:#000"> {{ \'NO_STOCK_MOVEMENT_AVAILABLE\' | translate }} </td> </tr> <tr ng-repeat="m in $mdl.data"> <td nowrap="nowrap">{{m.createdDate | date: \'dd/MM/yyyy - hh:mm:ssa\' }}</td> <td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{m.storageName | uppercase}}</td> <td style="text-align:right" nowrap="nowrap"> <span style="color:#209e91"> <b>{{(m.in==0||m.in==null)?\'\':m.in || \'\'}}</b> <small>{{(m.in==0||m.in==null)?\'\':m.uom || \'\'}}</small> </span> <span style="color:#209e91" ng-if="m.in2!=0 && m.in2!=null"> &nbsp;(&nbsp;<b>{{m.in2 || \'\'}}</b> <small>{{m.uom2 || \'\'}}</small>&nbsp;) </span> </td> <td style="text-align:right" nowrap="nowrap"> <span style="color:#f00"> <b>{{(m.out==0||m.out==null)?\'\':m.out || \'\'}}</b> <small>{{(m.out==0||m.out==null)?\'\':m.uom || \'\'}}</small> </span> <span style="color:#f00" ng-if="m.out2!=0 && m.out2!=null"> &nbsp;(&nbsp;<b>{{m.out2 || \'\'}}</b> <small>{{m.uom2 || \'\'}}</small>&nbsp;) </span> </td> <td>&nbsp;</td> <td>{{m.createdBy | limitTo:15 | uppercase}}<span ng-if="m.createdBy.length>15">...</span></td> <td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{m.remarks | uppercase}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="labelModal.html"><form novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:100%;color:#333" st-pipe="$mdl.retrieveData" st-table="$mdl.data" refresh-table> <thead> <tr> <th colspan="5" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.code}} </div> {{$mdl.name}} </h3> <div style="color:#00f"> {{$mdl.storageName}} </div> </div> <div class="col-xs-10 col-sm-10 col-md-5 col-lg-5 text-right" style="padding-right:0px"> <h3>{{ \'LABEL_LISTING\' | translate }}</h3> </div> </th> </tr> <tr> <th colspan="1"> <center ng-if="$mdl.isLoading"> <b style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_LABEL\' | translate }} ... </b> </center> </th> <th colspan="2" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th st-sort="serialNo"><b>{{ \'SERIAL_NO.\' | translate }}</b></th> <th><b>{{ \'LABEL_QUANTITY\' | translate }}</b></th> <th><b>{{ \'BALANCE_QUANTITY\' | translate }}</b></th> <th><b>{{ \'EXPIRY_DATE\' | translate }}</b></th> <th><b>{{ \'UOM\' | translate }}</b></th> </tr> <tr class="sortable"> <th class="form-inline"> <input st-search="serialNo" class="form-control input input-sm" /> </th> <th class="form-inline"></th> <th class="form-inline"></th> <th class="form-inline"> <input st-search="expiryDate" class="form-control input input-sm" /> </th> <th class="form-inline"> <input st-search="uom" class="form-control input input-sm" /> </th> </tr> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.data.length==0"> <td colspan="5" style="height:100px;line-height:100px;color:#000"> {{ \'NO_LABEL_LISTING_AVAILABLE\' | translate }} </td> </tr> <tr ng-repeat="m in $mdl.data"> <td>{{ m.serialNo }}</td> <td>{{ m.quantity }}</td> <td>{{ m.balanceQty }}</td> <td>{{ m.expiryDate | date:\'dd/MM/yyyy\' }}</td> <td>{{ m.uom1 }}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/inventory/semifgs/sfgStockIn.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_DETAILS"></span>.</p><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StorageId.$invalid && vm.dataForm.$submitted}"><label><i class="fa fa-industry"></i> &nbsp;<big><b translate="SELECT_A_WAREHOUSE"></b></big><i class="fa fa-asterisk req"></i></label><select name="StorageId" class="form-control" style="font-size:150%;color:#00f;height:auto !important" ng-change="vm.selectStorage()" ng-model="vm.storageList.selected" ng-options="i as (i.extendedDescription | uppercase) for i in vm.storageList" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StorageId.$invalid" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && vm.dataForm.$submitted}"><label><i class="fa fa-qrcode"></i> &nbsp;<big><b><span translate="KEY_IN_SEMI_F.G._LABEL_SERIAL_NO"></span>.</b></big><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SerialNo" style="font-size:150%;color:#00f;height:auto !important" ng-model="vm.stock.serialNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SerialNo.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="alert bg-success" style="color:#000" ng-if="vm.showSuccess"><i class="ion ion-checkmark"></i> <b translate="SEMI_F.G._STOCK_IN_SUCCESSFULLY">.</b></div><div class="alert" style="background:#fffc00;color:#000" ng-if="vm.showError"><h3 style="color:#f00"><i class="ion ion-alert-circled"></i> <b>Error: {{vm.errorMessage || \'Error Message\'}}</b></h3><div ng-if="vm.promptSameBranchError"><br><br><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.continueSameBranch()"><i class="ion ion-checkmark"></i> <span translate="YES"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-close"></i> <span translate="NO"></span></a></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-default btn-with-icon" ng-disabled="vm.lockButtons" ui-sref="inventory.semifgs.list"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }}</button></div></form></div>');
$templateCache.put('app/pages/inventory/semifgs/sfgStockOut.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="form-content"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_DETAILS"></span>.</p><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DocumentNumber.$invalid && vm.dataForm.$submitted}"><label><big><b>1)&nbsp;&nbsp;<span translate="ENTER_THE_DOCUMENT_NUMBER"></span>.</b></big><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DocumentNumber" style="font-size:150%;color:#00f;height:auto !important" ng-disabled="vm.promptExp || vm.promptFIFO || vm.promptTolerence || vm.promptCwmInput" ng-model="vm.stock.docNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DocumentNumber.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><label style="color:#fff">____</label><div class="checkbox checkbox-primary"><input type="checkbox" ng-model="vm.retainDocNo"> <label><b><span translate="RETAIN_DOC_NO"></span></b></label></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && vm.dataForm.$submitted}"><label><big><b>2)&nbsp;&nbsp;<span translate="KEY_IN_SEMI_F.G._LABEL_SERIAL_NO"></span>.</b></big><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SerialNo" style="font-size:150%;color:#00f;height:auto !important" ng-disabled="vm.promptExp || vm.promptFIFO || vm.promptTolerence || vm.promptCwmInput" ng-model="vm.stock.serialNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="alert bg-success" style="color:#000" ng-show="vm.showSuccess"><h3><i class="ion ion-checkmark"></i> <b>{{vm.successMessage || \'Success Message\'}}</b></h3></div><div class="alert" style="background:#fffc00;color:#000" ng-if="vm.showError"><h3 style="color:#f00"><i class="ion ion-alert-circled"></i> <b>{{vm.errorMessage || \'Error Message\'}}</b></h3><br><br><div ng-if="vm.promptExp"><div style="margin-bottom:10px"><h3><span translate="DO_YOU_WANT_TO_CONTINUE"></span>?</h3></div><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.continueExp()"><i class="ion ion-checkmark"></i> <span translate="YES"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-close"></i> <span translate="NO"></span></a></div><div ng-if="vm.promptFIFO"><div style="margin-bottom:10px"><h3><span translate="DO_YOU_WANT_TO_RE-SELECT"></span>?</h3></div><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-checkmark"></i> <span translate="YES"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.continueFifo()"><i class="ion ion-close"></i> <span translate="NO"></span></a></div><div ng-if="vm.promptTolerence"><div style="margin-bottom:10px"><h3><span translate="DO_YOU_WANT_TO_CONTINUE"></span>?</h3></div><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.continueTolerence()"><i class="ion ion-checkmark"></i> <span translate="YES"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-close"></i> <span translate="NO"></span></a></div><div ng-if="vm.promptCwmInput"><div style="margin-bottom:30px"><big>{{vm.itemCode || \'Item Code\'}}</big><h3>{{vm.itemName || \'Item Name\'}}</h3><div class="row"><div class="col-lg-5"><div class="bg-primary" style="padding:5px 8px"><i class="fa fa-info-circle"></i> This is a Catch-Weight Item.</div></div></div></div><div style="margin-bottom:10px"><div class="row"><div class="col-lg-12"><b>QUANTITY #1:</b></div></div><div class="row" ng-hide="vm.stock.parallel_quantity_1>0"><div class="col-lg-12"><span style="color:#00f"><b>Please enter the quantity below:</b></span></div></div><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity1.$invalid && vm.dataForm.$submitted}"><div class="row"><div class="col-lg-5"><input type="number" class="form-control" name="Quantity1" style="font-size:150%;color:#00f;height:auto !important" ng-model="vm.stock.parallel_quantity_1" min="0.001" ng-disabled="vm.stock.parallel_quantity_1>0" ng-required="vm.promptCwmInput"></div><div class="col-lg-5" style="line-height:41px;padding-left:0px"><b style="font-size:16pt">{{vm.uomName1 || \'KG\'}}</b></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity1.$error.required" translate="REQUIRED">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity1.$error.number" translate="ENTER_NUMBERS_ONLY">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity1.$error.min" translate="MINIMUM_VALUE_IS_0.001">*</span></div></div><div style="margin-bottom:10px"><div class="row"><div class="col-lg-12"><b>QUANTITY #2:</b></div></div><div class="row" ng-hide="vm.stock.parallel_quantity_2>0"><div class="col-lg-12"><span style="color:#00f"><b>Please enter the quantity below:</b></span></div></div><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity2.$invalid && vm.dataForm.$submitted}"><div class="row"><div class="col-lg-5"><input type="number" class="form-control" name="Quantity2" style="font-size:150%;color:#00f;height:auto !important" ng-model="vm.stock.parallel_quantity_2" min="0.001" ng-disabled="vm.stock.parallel_quantity_2>0" ng-required="vm.promptCwmInput"></div><div class="col-lg-5" style="line-height:41px;padding-left:0px"><b style="font-size:16pt">{{vm.uomName2 || \'KG\'}}</b></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity2.$error.required" translate="REQUIRED">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity2.$error.number" translate="ENTER_NUMBERS_ONLY">*</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity2.$error.min" translate="MINIMUM_VALUE_IS_0.001">*</span></div></div><a href="" class="btn btn-success btn-with-icon" style="color:#fff" ng-click="vm.submit()"><i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }}</a> <a href="" class="btn btn-danger btn-with-icon" style="color:#fff" ng-click="vm.reset()"><i class="ion ion-close"></i> {{ \'CANCEL\' | translate }}</a></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div></div><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ng-hide="vm.lockButtons || vm.promptExp || vm.promptFIFO || vm.promptTolerence || vm.promptCwmInput" style="margin-right:20px" ui-sref="inventory.semifgs.list"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-hide="vm.lockButtons || vm.promptExp || vm.promptFIFO || vm.promptTolerence || vm.promptCwmInput"><i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }}</button></div></form>');
$templateCache.put('app/pages/inventory/semifgstockcounts/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel with-scroll"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-if="vm.originalStatus==\'NEW\' && !vm.isLoading"><small><i class="fa fa-info-circle"></i> <span translate="FILL_IN_THE_REQUISITION_DETAILS"></span>.</small></p><p ng-if="vm.originalStatus!=\'NEW\' && !vm.isLoading"><small><i class="fa fa-exclamation-triangle" style="color:#ffbb00"></i> <span translate="ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_AFTER"></span> <b translate="CONFIRMED"></b>.</small></p><br><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b><span translate="DOCUMENT_NO"></span>.</b></label> <span class="form-control" style="color:#00f">{{vm.stockcount.docNo || \'AUTONUMBER\' }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DocStatus.$invalid && (vm.dataForm.DocStatus.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="DOCUMENT_STATUS"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="DocStatus" style="color:#333" ng-disabled="vm.originalStatus!=\'NEW\'" ng-options="u as u.name for u in vm.statuses track by u.id" ng-change="vm.selectStatus()" ng-model="vm.selectedStatus" ng-if="vm.originalStatus==\'NEW\'" required=""><option></option></select><span class="form-control" style="color:#00f" ng-if="vm.originalStatus!=\'NEW\'">{{vm.stockcount.status}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DocStatus.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BranchName.$invalid && (vm.dataForm.BranchName.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="BRANCH_NAME"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="BranchName" style="color:#333" ng-disabled="vm.mode==2" ng-options="u as u.name for u in vm.branches track by u.id" ng-change="vm.selectBranch()" ng-model="vm.selectedBranch" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BranchName.$error.required" translate="REQUIRED">*</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StorageName.$invalid && (vm.dataForm.StorageName.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="STORAGE_NAME"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="StorageName" style="color:#333" ng-disabled="vm.mode==2" ng-options="u as u.description for u in vm.storages track by u.id" ng-change="vm.selectStorage()" ng-model="vm.selectedStorage" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StorageName.$error.required" translate="REQUIRED">*</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AssigneeName.$invalid && (vm.dataForm.BranchName.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="ASSIGNEE"></b> <i ng-if="vm.stockcount.status!=\'NEW\'" class="fa fa-asterisk req"></i></label><select class="form-control" name="AssigneeName" style="color:#333" ng-disabled="vm.originalStatus!=\'NEW\'" ng-options="u as ((u.firstName + \' \' + u.lastName) | uppercase) for u in vm.assignees | orderBy:\'firstName\' track by u.id" ng-change="vm.selectAssignee()" ng-model="vm.selectedAssignee" ng-required="vm.stockcount.status!=\'NEW\'"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AssigneeName.$error.required" translate="REQUIRED">*</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b style="color:#00f"><span translate="ALLOW_SELECTIVE_COUNT"></span></b> <i class="fa fa-asterisk req"></i></label><div><toggle ng-if="vm.originalStatus==\'NEW\'" ng-model="vm.stockcount.isPartialCount" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div><span class="form-control" ng-if="vm.originalStatus!=\'NEW\'" ng-disabled="vm.originalStatus!=\'NEW\'">{{vm.stockcount.isPartialCount?"YES":"NO"}}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.stockcount.remarks">\n\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="CREATED_BY"></b></label><div>{{vm.stockcount.createdBy || \'-\' | uppercase}}<br><small>{{vm.stockcount.createdDate || \'-\' | date:\'dd/MM/yyyy hh:mma\'}}</small></div></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'MODIFIED_BY\' | translate }}</b></label><div>{{vm.stockcount.modifiedBy || \'-\' | uppercase}}<br><small>{{vm.stockcount.modifiedDate || \'-\' |date:\'dd/MM/yyyy hh:mma\'}}</small></div></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="Semi F.G. List"><p ng-if="vm.originalStatus==\'NEW\'"><small><em><i class="fa fa-info-circle"></i> <span translate="FILL_IN_THE_QUANTITY_FOR_THE_SEMI_FINISHED_GOODS_LIST"></span>.</em></small></p><p ng-if="vm.originalStatus!=\'NEW\'"><small><em><i class="fa fa-exclamation-triangle" style="color:#fffc00"></i> <span translate="ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="NEW"></b>.</em></small></p><div class="row"><div class="col-md-12 col-lg-12" style="overflow:auto;width:auto;min-width:100%"><table class="table table-striped table-hover" style="font-size:90%" st-pipe="vm.retrieveData" st-table="vm.stockcount.items" st-safe-src="vm.stockcount.items" refresh-table=""><thead><tr><th colspan="14" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Semi F.G." class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-1 col-lg-1">&nbsp;</div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th class="rowno">#</th><th class="sc-item" st-sort="itemDescription"><b><span translate="SEMI_F.G."></span><br>{{ \'CODE\' | translate }} &amp; {{ \'DESCRIPTION\' | translate }}</b></th><th class="sc-counted hide-after" style="text-align:center" ng-if="vm.stockcount.status!=\'NEW\' && vm.stockcount.status!=\'READY TO COUNT\' && vm.stockcount.status!=\'CANCELLED\'"><b><span translate="TO_EXCLUDE"></span>?</b></th><th class="sc-counted hide-after" style="text-align:center"><b><span translate="COUNTED"></span>?</b></th><th class="sc-stock-bal hide-after" colspan="2" st-sort="inventoryQuantity"><b><span translate="STOCK_BALANCE"></span><br><span translate="(QUANTITY_/_UOM)"></span></b></th><th class="sc-count hide-after"><b><span translate="COUNT"></span> <span translate="(QUANTITY_/_UOM)"></span><br><span style="color: #AF0000" translate="INVENTORY_VALUE"></span> <span style="color: #AF0000">({{vm.currency}})</span></b></th><th class="sc-count-detail hide-after"><span translate="COUNT"></span><br><span translate="DETAILS"></span></th><th class="sc-diff hide-after" colspan="2"><b><span translate="VARIANCE"></span><br><span translate="(QUANTITY_/_UOM)"></span></b></th><th class="sc-var hide-after" ng-if="vm.stockcount.status!=\'NEW\' && vm.stockcount.status!=\'READY TO COUNT\' && vm.stockcount.status!=\'CANCELLED\'"><b><span translate="VARIANCE"></span><br>{{ \'VALUE\' | translate }} (%)</b></th><th class="sc-remarks hide-after" style="width:250px;"><b>{{ \'REMARKS\' | translate }}</b></th></tr></thead><tbody><tr ng-if="vm.mode==1"><td colspan="14" style="height:100px;line-height:100px"><center><i class="fa fa-info"></i> <b><span translate="SYSTEM_WILL_GENERATE_THE_INVENTORY_LIST_AFTER_THIS_DOCUMENT_IS_SAVED"></span>.</b></center></td></tr><tr ng-if="vm.isLoading"><td colspan="14" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw fa-2x"></i> <span translate="PLEASE_WAIT_WHILE_THE_SYSTEM_IS_LOADING"></span>...</b></center></big></td></tr><tr><td colspan="14" align="center" ng-if="vm.mode==2 && !vm.isLoading" ng-show="vm.stockcount.items.length==0"><br><span translate="STOCK_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr><tr ng-repeat="ntn in vm.stockcount.itemsFiltered"><td>{{vm.startIndex+1+$index}})</td><td class="sc-item"><small>{{ ntn.itemCode || ntn.code }}</small><br><b>{{ ntn.itemDescription || ntn.description | uppercase }}</b><br><span style="font-size:7pt;color:#f00" ng-if="ntn.hasError">{{ntn.errorMsg}}</span></td><td class="sc-counted" style="text-align:center" ng-if="vm.stockcount.status!=\'NEW\' && vm.stockcount.status!=\'READY TO COUNT\' && vm.stockcount.status!=\'CANCELLED\'"><toggle class="btn-xs" ng-model="ntn.isExcluded" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-xs btn-primary" offstyle="btn-xs btn-default" ng-if="vm.stockcount.status!=\'POSTED\'"></toggle><span ng-if="vm.stockcount.status==\'POSTED\'">{{ (ntn.isExcluded ? \'YES\' : \'NO\') | translate | uppercase }}</span></td><td class="sc-counted" style="text-align:center"><i class="fa fa-check" ng-show="ntn.isCounted" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isCounted" style="color:#f00"></i></td><td class="sc-stock-bal"><b>{{ ntn.inventoryQuantity || 0 | number }}</b><div ng-if="ntn.inventoryUomId2!=null">( {{ ntn.inventoryQuantity2 || 0 | number}}</div></td><td class="sc-stock-bal-uom"><b ng-hide="ntn.hasError">{{ ntn.inventoryUomName || \'-\' | uppercase }}</b><div ng-if="ntn.inventoryUomId2!=null" ng-hide="ntn.hasError">{{ ntn.inventoryUomName2 || \'-\' | uppercase}} )</div></td><td style="vertical-align: middle"><div style="display:flex"><div class="sc-count"><b>{{ ntn.countQuantity || 0 | number }}</b><div ng-if="ntn.countUomId2!=null">( {{ ntn.countQuantity2 || 0 | number}}</div></div><div class="sc-count-uom"><b ng-hide="ntn.hasError">{{ ntn.countUomName || \'-\' | uppercase }}</b><div ng-if="ntn.countUomId2!=null" ng-hide="ntn.hasError">{{ ntn.countUomName2 || \'-\' | uppercase}} )</div></div></div><div ng-if="ntn.countQuantityValue!=null" class="sc-count-quantity-value">{{ ntn.countQuantityValue || 0 | number}}</div></td><td class="sc-count-detail"><a href="" class="btn btn-default btn-sm" ng-if="ntn.isCounted" ng-click="vm.showMovementModal(ntn)"><i class="fa fa-search"></i></a></td><td class="sc-diff"><div ng-if="ntn.isCounted"><b ng-if="vm.isPositive(ntn.countQuantity-ntn.inventoryQuantity)" class="sc-positive">{{ (ntn.countQuantity-ntn.inventoryQuantity) || 0 | number }}</b> <b ng-if="!vm.isPositive(ntn.countQuantity-ntn.inventoryQuantity)" class="sc-negative">{{ (ntn.countQuantity-ntn.inventoryQuantity) || 0 | number }}</b></div><div ng-if="!ntn.isCounted">-</div></td><td class="sc-diff-uom"><div ng-if="ntn.isCounted"><b ng-if="vm.isPositive(ntn.countQuantity-ntn.inventoryQuantity)" class="sc-positive">{{ ntn.inventoryUomName || \'-\' | uppercase }}</b> <b ng-if="!vm.isPositive(ntn.countQuantity-ntn.inventoryQuantity)" class="sc-negative">{{ ntn.inventoryUomName || \'-\' | uppercase }}</b></div></td><td class="sc-var" ng-if="vm.stockcount.status!=\'NEW\' && vm.stockcount.status!=\'READY TO COUNT\' && vm.stockcount.status!=\'CANCELLED\'"><div><small style="color:#000">{{vm.currency}}</small> <span ng-if="ntn.isCounted"><b ng-if="vm.isPositive(ntn.variancePercentage)" class="sc-positive">{{ ntn.varianceValue || \'-\' | number:2 }}</b> <b ng-if="!vm.isPositive(ntn.variancePercentage)" class="sc-negative">{{ ntn.varianceValue || \'-\' | number:2 }}</b></span> <span ng-if="!ntn.isCounted">-</span></div><div><span ng-if="ntn.isCounted">( <b ng-if="vm.isPositive(ntn.variancePercentage)" class="sc-positive">{{ ntn.variancePercentage || \'-\' | number:2 }}</b> <b ng-if="!vm.isPositive(ntn.variancePercentage)" class="sc-negative">{{ ntn.variancePercentage || \'-\' | number:2 }}</b>% )</span></div></td><td class="sc-remarks"><div class="form-group" style="margin-bottom:0px !important"><input type="text" name="remarks_{{ntn.itemId}}" class="form-control" style="width:250px;height:28px;color:#000;font-size:9pt;padding:3px 6px" ng-model="ntn.remarks" ng-disabled="vm.originalStatus==\'COMPLETED\' || vm.originalStatus==\'CANCELLED\'"></div></td></tr></tbody><tfoot><tr><td colspan="14" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table><div><div></div></div></div></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="countIDetailModal.html"><form name="$mdl.stepForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:100%;color:#333" st-pipe="$mdl.retrieveData" st-table="$mdl.mvmtData" refresh-table> <thead> <tr> <th colspan="7" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.item.itemCode}} </div> {{$mdl.item.itemName}} </h3> </div> <div class="col-xs-10 col-sm-10 col-md-5 col-lg-5 text-right" style="padding-right:0px"> <span>Count Info</span> </div> </th> </tr> <tr> <th colspan="2"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Item" class="input form-control" /> </div> </th> <th colspan="5" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr> <th><b>Serial No.</b></th> <th colspan="2" style="text-align:center"><b>Quantity</b></th> <th colspan="2" style="text-align:center" ng-if="$mdl.item.isCwm"><b>Alt. Quantity</b></th> <th><b>Bin Location</b></th> <th><b>Remarks</b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="7"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i>Loading Data ...</b></center> </td> </tr> <tr ng-repeat="m in $mdl.labelData"> <td nowrap="nowrap">{{m.serialNo}}</td> <td style="text-align:right"> {{m.quantity | number}} </td> <td>{{m.uomName}}</td> <td style="text-align:right" ng-if="$mdl.item.isCwm"> {{m.quantity2 || 0 | number}} </td> <td ng-if="$mdl.item.isCwm">{{m.uomName2 || \'\'}}</td> <td>{{m.binLocation || \'-\'}}</td> <td>{{m.remarks || \'-\'}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/inventory/semifgstockcounts/semifgstockcountCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/inventory/semifgstockcounts/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons || vm.isLoading"><i class="ion ion-checkmark"></i> <span translate="CREATE_STOCK_COUNT"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="inventory.semifgstockcounts.list" ng-disabled="vm.lockButtons || vm.isLoading"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/inventory/semifgstockcounts/semifgstockcountList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="SemiFGStockCountListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table="" style="font-size:100%"><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_CLOSED_DOCUMENTS\' | translate }}</option><option value="1">{{ \'SHOW_ALL_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="inventory.semifgstockcounts.create" rms-check-access="inventory.semifgstockcounts" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="NEW_STOCK_COUNT"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="docNo">{{\'DOC_NO\' | translate}}</th><th st-sort="createdDate">{{\'DOC_DATE\' | translate}}</th><th st-sort="branchName">{{\'BRANCH\' | translate}}</th><th st-sort="storageName">{{\'STORAGE\' | translate}}</th><th st-sort="assigneeName">{{\'ASSIGNEE\' | translate}}</th><th class="hide-after" style="text-align:center">{{\'SELECTIVE_COUNT\' | translate}}</th><th st-sort="status">{{\'STATUS\' | translate}}</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline" colspan="2"><input st-search="docNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="branchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="storageName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="assigneeName" class="form-control input input-sm" style="width:120px"></th><th></th><th class="form-inline"><input st-search="status" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.data.length<=0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center translate="NO_RECORD_FOUND">.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}}.</td><td>{{item.docNo}}</td><td>{{item.createdDate | date: "dd-MMM-yyyy" }}</td><td>{{item.branchName | uppercase}}</td><td>{{item.storageName | limitTo:20 | uppercase}} <span ng-if="item.supplierName.length>20">...</span></td><td>{{item.assigneeName | limitTo:20 | uppercase}} <span ng-if="item.assigneeName.length>20">...</span></td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isPartialCount" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isPartialCount" style="color:#f00"></i></td><td>{{item.status}}</td><td align="center"><a href="" title="Print PDF" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" ng-if="item.status!=\'New\' && item.status!=\'Cancelled\'" ng-click="vm.printPDF(item.id, item.docNo)" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="EXPORT"><i class="fa fa-file-pdf-o"></i></a></td><td align="center"><a href="" title="Export Excel" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#197e19" ng-if="item.status!=\'New\' && item.status!=\'Cancelled\'" ng-click="vm.printExcel(item.id, item.docNo)" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="EXPORT"><i class="fa fa-file-excel-o"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="inventory.semifgstockcounts.update({id:item.id})" rms-check-access="inventory.semifgstockcounts" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="StockCountLabelModal.html"><form name="$mdl.stepForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:80%" st-pipe="$mdl.retrieveData" st-table="$mdl.mvmtData" refresh-table> <thead> <tr> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.item.docNo}} </div> <span translate="STOCK_COUNT_LABEL_LIST"></span> </h3> </div> </th> </tr> <tr> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="col-md-4 col-lg-4" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Label" class="input form-control" /> </div> </div> <div class="col-md-8 col-lg-8" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr> <th><b translate="SERIAL_NO"></b></th> <th> <b>{{ \'QUANTITY\' | translate }}</b></th> <th><b translate="UOM"></b></th> <th><b>{{ \'REMARKS\' | translate }}</b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="4"> <div style="padding:20px 0px"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="LOADING_LABELS"></span> ...</b></center> </div> </td> </tr> <tr ng-if="$mdl.mvmtData.length==0"> <td colspan="4"><span translate="NO_FIFO_LABEL_AVAILABLE"></span>.</td> </tr> <tr ng-repeat="m in $mdl.labelData"> <td>{{m.serialNo | uppercase}}</td> <td>{{m.quantity | number:2}}</td> <td>{{m.uomName | uppercase}}</td> <td>{{m.remarks || \'-\'}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/inventory/semifgstockcounts/semifgstockcountUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/inventory/semifgstockcounts/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:30px;" ui-sref="inventory.semifgstockcounts.list" ng-disabled="vm.lockButtons || vm.isLoading"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-disabled="vm.lockButtons || vm.isLoading" ng-show="vm.originalStatus==\'NEW\'"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-success btn-with-icon" rms-check-access="inventory.semifgstockcounts" rms-check-access-perm-type="APPROVE" confirmed-click="vm.approveStockCount()" ng-confirm-click="Approve this Stock Count?" ng-disabled="vm.lockButtons || vm.isLoading" ng-show="vm.originalStatus==\'SUBMITTED\'"><i class="ion ion-checkmark"></i> <span translate="APPROVE_STOCK_COUNT"></span></a> <a href="" class="btn btn-danger btn-with-icon" rms-check-access="inventory.semifgstockcounts" rms-check-access-perm-type="APPROVE" confirmed-click="vm.cancelStockCount()" ng-confirm-click="Cancel this Stock Count?" ng-disabled="vm.lockButtons || vm.isLoading" ng-if="vm.mode==2 && (vm.originalStatus==\'NEW\' || vm.originalStatus==\'SUBMITTED\' || vm.originalStatus==\'APPROVED\' || vm.originalStatus==\'READY TO COUNT\')"><i class="ion ion-trash-a"></i> <span translate="CANCEL_STOCK_COUNT"></span></a> <a href="" class="btn btn-primary btn-with-icon" style="margin-left:30px" rms-check-access="inventory.semifgstockcounts" rms-check-access-perm-type="APPROVE" confirmed-click="vm.postStockCount()" ng-confirm-click="Are you sure to Post this Stock Count?" ng-disabled="vm.lockButtons || vm.isLoading" ng-show="vm.originalStatus==\'APPROVED\'"><i class="ion ion-checkmark"></i> <span translate="POST_STOCK_COUNT"></span></a> <a href="" class="btn btn-default btn-with-icon" style="margin-left:30px" rms-check-access="inventory.semifgstockcounts" rms-check-access-perm-type="EXPORT" ng-if="vm.originalStatus!=\'NEW\'" ng-click="vm.printPDF()" ng-disabled="vm.lockButtons || vm.isLoading"><i class="fa fa-file-pdf-o" style="color:#f00"></i> PDF</a> <a href="" class="btn btn-default btn-with-icon" rms-check-access="inventory.semifgstockcounts" rms-check-access-perm-type="EXPORT" ng-if="vm.originalStatus!=\'NEW\'" ng-click="vm.printExcel()" ng-disabled="vm.lockButtons || vm.isLoading"><i class="fa fa-file-pdf-o" style="color:#197e19"></i> Excel</a></div></form>');
$templateCache.put('app/pages/inventory/stockreturns/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'STOCK_RETURN_NO\' | translate }}</b></label> <span class="form-control" ng-disabled="true" style="color:#00f">{{vm.sr.docNo || \'*** AUTONUMBER ***\'}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Status.$invalid && (vm.dataForm.Status.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'STATUS\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="Status" class="form-control" ng-change="vm.selectedStatusChanged()" ng-model="vm.selectedStatus" ng-options="i as i.name for i in vm.statuses" ng-show="vm.originalStatus==\'NEW\'" required=""></select><span class="form-control" ng-show="vm.originalStatus!=\'NEW\'" ng-disabled="vm.originalStatus!=\'NEW\'">{{vm.sr.status}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Status.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceDocumentNumber.$invalid && (vm.dataForm.DeliveryDate.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'REF_SOURCE_DOC_NO\' | translate}} ( {{ \'CUSTOMER_NAME\' | translate}} )</b></label><div class="input-group"><span class="form-control" ng-disabled="true" style="color:#00f">{{vm.sr.sourceDocNo || \'-\'}} &nbsp; <span ng-if="vm.sr.customerName">( {{vm.sr.customerName}} )</span></span> <input type="text" class="form-control" name="SourceDocumentNumber" ng-hide="true" ng-model="vm.sr.sourceDocNo" required=""> <a href="" class="btn btn-primary btn-with-icon input-group-addon" style="padding:3px 10px;font-size:9pt" ng-click="vm.showSelectDocModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && vm.sr.deliveryOrderId==null && vm.sr.jobId==null && vm.sr.withdrawalRequestId==null && vm.sr.bulkBreakJobId==null"><i class="ion ion-android-checkmark-circle"></i> <span translate="SELECT"></span></a> <a href="" class="btn btn-default btn-with-icon input-group-addon" style="padding:3px 10px;font-size:9pt;color:#f00" ng-click="vm.clearSelectDoc()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && vm.sr.stockReturnDetails.length==0 && (vm.sr.deliveryOrderId!=null || vm.sr.jobId!=null || vm.sr.withdrawalRequestId!=null || vm.sr.bulkBreakJobId!=null)"><i class="ion ion-close"></i> <span translate="CLEAR"></span></a></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceDocumentNumber.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.sr.remarks">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-md-2 col-lg-2" ng-if="vm.sr.createdBy"><div class="form-group"><label>{{ \'CREATED_BY\' | translate }}</label><br><span>{{vm.sr.createdBy | uppercase}}<br><span translate="DATE"></span>: {{ vm.sr.createdDate | date:\'dd/MM/yyyy\' }}</span></div></div><div class="col-md-2 col-lg-2" ng-if="vm.sr.modifiedBy"><div class="form-group"><label>{{ \'MODIFIED_BY\' | translate }}</label><br><span>{{vm.sr.modifiedBy | uppercase}}<br><span translate="DATE"></span>: {{ vm.sr.modifiedDate | date:\'dd/MM/yyyy\' }}</span></div></div><div class="col-md-2 col-lg-2" ng-if="vm.sr.approvedBy"><div class="form-group"><label><b>{{ \'APPROVED_BY\' | translate }}:</b></label><br><span>{{vm.sr.approvedBy | uppercase}}<br><span translate="DATE"></span>: {{ vm.sr.approvedDate | date:\'dd/MM/yyyy\' }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'RETURNED_ITEMS\' | translate }}" ng-if="vm.sr.sourceDocNo!=\'\' && vm.sr.sourceDocNo!=null"><p><i class="fa fa-info-circle"></i> {{ \'ADD_DO_ITEM_INTO_STOCK_RETURN_DOC\' | translate }}. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddItemModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="ion-plus-round"></i>{{ \'ADD_ITEM\' | translate }}</a><br><br></p><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:2px solid #ccc" st-pipe="vm.refreshBookingProducts" st-table="vm.sr.stockReturnDetails" refresh-table=""><thead><tr class="sortable"><th style="width:60px">#</th><th></th><th><b>{{ \'ITEM_NAME\' | translate }}</b></th><th style="text-align:right" class="hide-after"><b><span translate="QUANTITY"></span></b></th><th style="width:100px"><b>{{ \'U.O.M.\' | translate }}</b></th><th style="text-align:right" class="hide-after"><b>{{ \'QUANTITY\' | translate }} #2</b></th><th style="width:100px"><b><span translate="U.O.M."></span> #2</b></th><th style="width:100px"><b>{{ \'LABEL_PRINT_OPTION\' | translate }}</b></th><th><b>{{ \'STATUS\' | translate }}</b></th><th><b>{{ \'REMARKS\' | translate }}</b></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.sr.stockReturnDetails"><td>{{$index+1}})</td><td class="text-center" style="width:80px;line-height:100%"><div class="report-type-tag">{{ ntn.itemType }}</div></td><td style="padding-top:8px;padding-bottom:8px;line-height:150%">{{ ntn.itemName || \'\' }}</td><td style="text-align:right">{{ ntn.quantity }}</td><td>{{ ntn.uomName }}</td><td style="text-align:right"><span ng-if="ntn.isCwm">{{ ntn.quantity2 }}</span></td><td><span ng-if="ntn.isCwm">{{ ntn.uomName2 }}</span></td><td>{{ (ntn.labelPrintOption ? (\'SINGLE\' | translate ) : (\'MULTIPLE\' | translate ) ) }}</td><td>{{ ntn.status | translate }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:150%">{{ ntn.remarks || \'-\' }}</td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditItemModal($index)" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeItem($index)" ng-confirm-click="Confirm remove this Product?" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="13" align="center" ng-show="vm.sr.stockReturnDetails.length==0"><br><span translate="PRODUCT_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="ItemModal.html"><form name="$mdl.productForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{($mdl.title | uppercase) | translate}} <span translate="ITEM"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <label> <b>{{ \'RAW_MATERIAL\' | translate }}</b> / <b>{{ \'SEMI_FINISHED_GOODS\' | translate }}</b> / <b>{{ \'FINISHED_GOODS\' | translate }}</b> </label> <div class="row"> <div class="col-lg-12"> <select class="form-control" style="background:#fffeed;color:#333" name="ItemName" ng-disabled="$mdl.lockButtons" ng-change="$mdl.selectedItemChanged()" ng-options="u as (\'[\' + u.itemType + \'] \' + u.itemName | uppercase) for u in $mdl.itemList" ng-model="$mdl.selectedItem" required> <option value="">{{($mdl.lockButtons ? (\'LOADING...\' | translate) : ($mdl.itemList.length==0 ? " " : ("-- " + (\'SELECT_AN_ITEM\' | translate) + " --")))}}</option> </select> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" style="margin-top:5px" ng-if="$mdl.selectedItem!=null" ng-click="$mdl.clearSelectedItem()"> <i class="fa fa-times"></i> <span style="color:#fff" translate="CLEAR_SELECTION"></span> </button> <span style="line-height:34px;color:#00f" ng-if="$mdl.item.isCwm"> <i class="fa fa-asterisk"></i> This is a CWM Item </span> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted"> * {{"REQUIRED" | translate}} </p> </div> </div> </div> </div> <br /> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.Quantity.$invalid && $mdl.productForm.$submitted}"> <div class="row"> <div class="col-lg-8"> <div class="row"> <div class="col-lg-4"> <label><b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" name="Quantity" class="form-control" min=0.001 style="background:#fffeed" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.quantity" required /> </div> <div class="col-lg-4"> <label><b>U.O.M</b></label> <span class="form-control" disabled="disabled"> <b ng-hide="$mdl.item.unitOfMeasurementId==null">{{ $mdl.item.uomName || \'\' }}</b> <span style="color:#f00" ng-if="$mdl.item.unitOfMeasurementId==null"> <small>UOM not available</small> </span> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> </span> </div> <div class="col-lg-4"> <label><b>{{ \'LABEL_PRINT_OPTION\' | translate }}</b></label> <div> <toggle ng-model="$mdl.item.labelPrintOption" ng-change="changed()" on="{{ \'SINGLE\' | translate }}" off="{{ \'MULTIPLE\' | translate }}" onstyle="btn-success" offstyle="btn-primary"> </toggle> </div> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.required && $mdl.productForm.$submitted">* {{ "REQUIRED" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.number && $mdl.productForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.min && $mdl.productForm.$submitted">* {{ "MINIMUM_VALUE_IS_0.001" | translate }}</p> </div> <div class="col-lg-4"> <label><b>{{ \'STATUS\' | translate}}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select name="Status" class="form-control" style="background:#fffeed;color:#333" ng-disabled="$mdl.lockButtons" ng-change="$mdl.selectedStatusChanged()" ng-options="u as (u.name | translate | uppercase) for u in $mdl.statuses" ng-model="$mdl.selectedStatus" required> <option></option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Status.$error.required && $mdl.productForm.$submitted">* {{ "REQUIRED" | translate }}</p> </div> </div> </div> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.Quantity2.$invalid && $mdl.productForm.$submitted}"> <div class="row" ng-if="$mdl.item.isCwm"> <div class="col-lg-8"> <div class="row"> <div class="col-lg-4"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <b>#2</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" name="Quantity2" class="form-control" min=0.001 style="background:#fffeed" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.quantity2" required /> </div> <div class="col-lg-4"> <label><b>U.O.M #2</b></label> <span class="form-control" disabled="disabled"> <b>{{ $mdl.item.uomName2 || \'\' }}</b> <span style="color:#f00" ng-if="$mdl.item.unitOfMeasurementId2==null"> <small>UOM not available</small> </span> </span> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity2.$error.required && $mdl.productForm.$submitted">* {{ "REQUIRED" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity2.$error.number && $mdl.productForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity2.$error.min && $mdl.productForm.$submitted">* {{ "MINIMUM_VALUE_IS_0.001" | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" style="background:#fffeed" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.remarks" /> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="DOListModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> Select Source Document </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <b>Select a Source Document Type:</b>&nbsp;&nbsp; <a href class="btn btn-default" ng-class="{ \'bg-success\': $mdl.isDO }" ng-click="$mdl.changeDocSource(true, false, false, false)">Delivery Orders</a> <a href class="btn btn-default" ng-class="{ \'bg-success\': $mdl.isJob }" ng-click="$mdl.changeDocSource(false, true, false, false)">Production Jobs</a> <a href class="btn btn-default" ng-class="{ \'bg-success\': $mdl.isWR }" ng-click="$mdl.changeDocSource(false, false, true, false)">Withdrawal Requests</a> <a href class="btn btn-default" ng-class="{ \'bg-success\': $mdl.isBBJ }" ng-click="$mdl.changeDocSource(false, false, false, true)">Bulk-Break Jobs</a> </div> </div> <br /> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:10pt" st-pipe="$mdl.retrieveData" st-table="$mdl.doData" refresh-table> <thead> <tr> <th colspan="2" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input type="search" ng-model="$mdl.search" ng-model-options=\'{ debounce: 500 }\' ng-change="$mdl.searchChanged()" placeholder="Search Documents" class="input form-control" /> </div> </th> <th colspan="3" style="padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th st-sort="deliveryOrderNo" st-sort-default="reverse"> Document No.</th> <th style="padding-top:11px;padding-bottom:11px;line-height:110%">Document Date<br /><small>(DD/MM/YYYY)</small></th> <th ng-if="$mdl.isDO"><span translate="CUSTOMER_NAME"></span></th> <th st-sort="status">{{ \'STATUS\' | translate }}</th> <th style="width:40px"></th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="9" style="line-height:100px"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading documents ...</b></center> </td> </tr> <tr ng-if="!$mdl.isLoading && $mdl.doData.length==0"> <td colspan="9" style="line-height:100px"> <center><b> No document is available.</b></center> </td> </tr> <tr ng-repeat="item in $mdl.doData"> <td><b>{{item.jobNo}}</b></td> <td>{{item.jobDate | date: "dd/MM/yyyy"}}</td> <td ng-if="$mdl.isDO" style="padding-top:11px;padding-bottom:11px;line-height:130%"> {{item.debtorName || \'-\'}} </td> <td><b>{{item.status}}</b></td> <td align="center"> <a href title="Select" class="btn btn-primary btn-xs btn-with-icon" ng-click="$mdl.selectDoc(item)"> <big><i class="fa fa-check"></i> {{ "SELECT" | translate }}</big> </a> </td> </tr> </tbody> </table> </div> </div> </div> <hr /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.isLoading"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/inventory/stockreturns/stockreturnCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/inventory/stockreturns/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="inventory.stockreturns.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/inventory/stockreturns/stockreturnList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="StockReturnListing" st-pipe="vm.retrieveData" st-table="vm.srData" refresh-table=""><thead><tr><th colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:30px;line-height:30px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Document" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:30px;line-height:30px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="inventory.stockreturns.create" rms-check-access="inventory.stockreturns" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> {{ \'NEW_RETURN\' | translate}}</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:30px;line-height:30px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="docNo">{{ \'DOCUMENT_NO\' | translate }}</th><th st-sort="createdDate">{{ \'DOCUMENT_DATE\' | translate }}</th><th st-sort="fromDocNo">{{ \'REF_DOC_NO\' | translate }}</th><th st-sort="branchName">{{ \'BRANCH\' | translate }}</th><th st-sort="customerName">{{ \'CUSTOMER_NAME\' | translate }}</th><th>{{ \'REMARKS\' | translate }}</th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th st-sort="createdBy">{{ \'CREATED_BY\' | translate }}</th><th style="width:30px"></th></tr><tr class="sortable"><th colspan="3"><checkbox small="" ng-model="vm.showCompleted" ng-change="vm.showCompletedChanged()" style="background:#fffff4"></checkbox>&nbsp; {{ \'INCLUDE_COMPLETED_RETURNS\' | translate }}</th><th></th><th class="form-inline"><select st-search="branchName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="po in vm.srDataFull | unique:\'branchName\' | orderBy:\'branchName\'" value="{{po.customerName}}">{{(po.branchName | uppercase | limitTo:20) + (po.branchName.length > 20 ? \' ...\' : \'\') }}</option></select></th><th class="form-inline"><select st-search="customerName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="po in vm.srDataFull | unique:\'customerName\' | orderBy:\'customerName\'" value="{{po.customerName}}">{{(po.customerName | uppercase | limitTo:20) + (po.customerName.length > 20 ? \' ...\' : \'\') }}</option></select></th><th></th><th class="form-inline"><select st-search="status"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="bk in vm.srDataFull | unique:\'status\'" value="{{bk.status}}">{{bk.status}}</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.srData.length==0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.srData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.docNo}}</td><td>{{item.createdDate | date: "dd/MM/yyyy"}}</td><td>{{item.fromDocNo}}</td><td>{{item.branchName}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{(item.customerName | uppercase | limitTo:20) + (item.customerName.length > 20 ? \' ...\' : \'\') }}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.remarks}}</td><td><b>{{item.status}}</b></td><td>{{item.createdBy | uppercase | limitTo: 10}} <span ng-if="item.createdBy.length>10">...</span></td><td align="center"><a href="" title="Print Document" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt" ng-click="vm.printDocument(item.id, item.docNo)" ng-show="item.status!=\'NEW\' && item.status!=\'CANCELLED\'" rms-check-access="inventory.stockreturns" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="inventory.stockreturns.update({id:item.id})" rms-check-access="inventory.stockreturns" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/inventory/stockreturns/stockreturnUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/inventory/stockreturns/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="inventory.stockreturns.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-if="vm.originalStatus==\'NEW\'" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="inventory.stockreturns.list" style="margin-right:30px" ng-if="vm.originalStatus==\'NEW\'" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="margin-right:30px" ng-if="vm.mode==2 && vm.originalStatus==\'NEW\'" ng-disabled="vm.lockButtons" ng-confirm-click="Are you sure to cancel this Stock Return?" confirmed-click="vm.cancelStockReturn()"><i class="fa fa-trash"></i> Cancel Stock Return</a> <a href="" class="btn btn-primary btn-with-icon" ng-if="vm.mode==2 && vm.originalStatus==\'CONFIRMED\'" ng-disabled="vm.lockButtons" rms-check-access="inventory.stockreturns" rms-check-access-perm-type="APPROVE" ng-confirm-click="Are you sure to approve this Stock Return?" confirmed-click="vm.approveStockReturn()"><i class="fa fa-check-circle"></i> Approve Stock Return</a> <a href="" class="btn btn-danger btn-with-icon" style="margin-right:30px" ng-if="vm.mode==2 && vm.originalStatus==\'CONFIRMED\'" ng-disabled="vm.lockButtons" rms-check-access="inventory.stockreturns" rms-check-access-perm-type="APPROVE" ng-confirm-click="Are you sure to cancel this Stock Return?" confirmed-click="vm.cancelStockReturn()"><i class="fa fa-trash"></i> Cancel Stock Return</a> <a href="" class="btn btn-info btn-with-icon" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'CANCELLED\'" ng-disabled="vm.lockButtons" ng-click="vm.printStockReturn()" rms-check-access="inventory.stockreturns" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT_DOCUMENT"></span></a></div></form>');
$templateCache.put('app/pages/iotsettings/floorviewdesigner/_form.html','<div class="row"><div class="col-md-12" style="width:auto;min-width:100%;"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="FILL_IN_THE_GENERAL_INFORMATION_FOR_THIS_DASHBOARD_DESIGN"></span>.</p><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Branch.$invalid && (vm.dataForm.Branch.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'BRANCH\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="Branch" class="form-control" style="background:#FFFCED" ng-change="vm.selectedBranchChanged()" ng-options="b as b.name for b in vm.branches | orderBy:\'name\'" ng-model="vm.selectedBranch" required=""><option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Branch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Description of this Design" ng-model="vm.design.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PageCode.$invalid && (vm.dataForm.PageCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="BUTTON_SHORT_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="PageCode" placeholder="A short code that will appear as Button description, e.g: GF / 1F / etc" ng-model="vm.design.pageCode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PageCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="IS_ACTIVE"></b></label><br><div><toggle ng-model="vm.design.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Layout Image"><div class="row" ng-if="vm.mode==1"><div class="col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center><span translate="PLEASE_SAVE_THE_DESIGN_FIRST_BEFORE_UPLOADING_LAYOUT_PLAN_IMAGE"></span>.</center></h2></div></div><div class="row" ng-if="vm.mode==2"><div class="col-lg-12"><div class="row"><div class="col-md-12 col-lg-12"><p><i class="fa fa-info-circle"></i> <span translate="UPLOAD_THE_LAYOUT_PLAN_IMAGE_WITH_1920_X_1080_RESOLUTION"></span>. &nbsp; <a class="btn btn-success btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-if="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> <span translate="UPLOAD_IMAGE"></span></a> <a href="" class="btn btn-default btn-with-icon" ng-click="picFile=null;vm.setUploadImage(picFile)" ng-if="!vm.lockUploadButton"><i class="ion ion-android-remove-circle"></i> <span translate="RESET_IMAGE"></span></a></p></div></div><div class="row" ng-if="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row"><img ngf-src="vm.fileToUpload || vm.design.layoutImage" alt="" class="col-lg-6"></div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div></div></uib-tab><uib-tab heading="Objects" ng-if="vm.mode==2 && vm.design.layoutImage!=\'assets/img/empty_placeholder_iotdesigner.jpg\'"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-2 col-lg-2"><div style="margin-bottom:10px"><span translate="CHOOSE_A_TYPE"></span>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <input type="radio" name="TabOption" id="TabOption1" value="1" style="cursor:pointer" ng-if="vm.hasAssetAccess" ng-model="vm.selectedTab" ng-click="vm.selectTab(\'1\')"> <label for="TabOption1" style="cursor:pointer">&nbsp;<b translate="ASSETS"></b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label> <input type="radio" name="TabOption" id="TabOption2" value="2" style="cursor:pointer" ng-if="vm.hasIoTAccess" ng-model="vm.selectedTab" ng-click="vm.selectTab(\'2\')"> <label for="TabOption2" style="cursor:pointer">&nbsp;<b translate="SENSORS"></b></label></div></div></div><div class="row" ng-if="vm.selectedTab==\'1\'"><div class="col-md-8 col-lg-8"><div class="col-lg-8" style="padding:15px;background:#f0f0f0"><div class="row"><div class="col-md-12 col-lg-12"><p><i class="fa fa-info-circle"></i> <span translate="SELECT_AND_ADD_THE_ASSET_ONTO_THE_LAYOUT_PLAN._DRAG_&_DROP_THE_ASSET_ICON_TO_RE-POSITION."></span></p></div></div><div class="row"><div class="col-md-4 col-lg-4"><label><small translate="LOCATION">:</small></label></div><div class="col-md-6 col-lg-6"><label><small><span translate="ASSET"></span>:</small></label></div></div><div class="row"><div class="col-md-4 col-lg-4"><select class="form-control" style="font-family:courier" ng-options="b as b.branchName for b in vm.assets | unique:\'branchName\' | orderBy:\'branchName\'" ng-model="vm.selectedLocation"><option value="">- {{ \'SELECT_A_LOCATION\' | translate }} -</option></select></div><div class="col-md-6 col-lg-6"><select class="form-control" style="background:#FFFCED;font-family:courier" ng-change="vm.selectedAssetChanged()" ng-options="b as b.name for b in vm.assets | filter: { branchName:vm.selectedLocation.branchName} | orderBy:\'name\'" ng-model="vm.selectedAsset"><option value="">- {{ \'SELECT_AN_ASSET\' | translate }} -</option></select></div><div class="col-md-2 col-lg-2"><a href="" class="btn btn-primary" ng-click="vm.addAssetToLayout(vm.selectedAsset.id, vm.selectedAsset.name)"><span translate="ADD_ASSET"></span></a></div></div></div></div></div><div class="row" ng-if="vm.selectedTab==\'2\'"><div class="col-md-8 col-lg-8"><div class="col-lg-8" style="padding:15px;background:#f0f0f0"><div class="row"><div class="col-md-12 col-lg-12"><p><i class="fa fa-info-circle"></i> <span translate="SELECT_AND_ADD_THE_SENSORS_ONTO_THE_LAYOUT_PLAN._DRAG_&_DROP_THE_SENSOR_ICON_TO_RE-POSITION."></span></p></div></div><div class="row"><div class="col-md-4 col-lg-4"><label><small><span translate="GATEWAY"></span>:</small></label></div><div class="col-md-6 col-lg-6"><label><small><span translate="SENSOR"></span>:</small></label></div></div><div class="row"><div class="col-md-4 col-lg-4"><select class="form-control" style="font-family:courier" ng-change="vm.selectedGatewayChanged()" ng-options="b as b.description for b in vm.gateways | orderBy:\'description\'" ng-model="vm.selectedGateway"><option value="">- {{ \'SELECT_A_GATEWAY\' | translate }} -</option></select></div><div class="col-md-6 col-lg-6"><select class="form-control" style="background:#FFFCED;font-family:courier" ng-change="vm.selectedSensorChanged()" ng-options="b as (\'[\' + b.deviceUID + \'] \' + b.description) for b in vm.selectedGateway.sensors | orderBy:\'description\'" ng-model="vm.selectedSensor"><option value="">- {{ \'SELECT_A_SENSOR\' | translate }} -</option></select></div><div class="col-md-2 col-lg-2"><a href="" class="btn btn-primary" ng-click="vm.addSensorToLayout(vm.selectedSensor)"><span translate="ADD_SENSOR"></span></a></div></div></div></div></div><div class="row"><br><div class="col-lg-12"><div id="layoutParent" style="background-image:url({{vm.design.layoutImage}})"><div id="{{s.objectIdText}}" ng-class="{\'designer-sensor\' : s.sensorId!=null, \'designer-asset\' : s.assetId!=null }" ng-repeat="s in vm.design.iotFloorViewDesignerDevices" style="-webkit-transform:translate({{s.coordinateX}}px,{{s.coordinateY}}px);transform:translate({{s.coordinateX}}px,{{s.coordinateY}}px);"><div ng-if="s.sensorId!=null"><a href="" class="sensor-remove" confirmed-click="vm.removeObject(s.objectIdText)" ng-confirm-click="Confirm remove this sensor [UID: {{s.description}}] ?"><img src="assets/img/icon-delete.png" alt=""></a> <img src="assets/img/sensor-icon.png" alt=""><br><p class="description"><big><b>{{s.objectDescription}}</b></big><br>[ {{s.objectCode}} ]</p></div><div ng-if="s.assetId!=null"><a href="" class="asset-remove" confirmed-click="vm.removeObject(s.objectIdText)" ng-confirm-click="Confirm remove this asset [{{s.description}}] ?"><img src="assets/img/icon-delete.png" alt=""></a> <img src="assets/img/asset-icon.png" alt=""><br><p class="description"><big><b>{{(s.description | limitTo:30) + (s.description.length>30?\'...\':\'\')}}</b></big></p></div></div></div></div></div></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/iotsettings/floorviewdesigner/floorviewdesignerCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/iotsettings/floorviewdesigner/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="iotsettings.floorviewdesigner.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/iotsettings/floorviewdesigner/floorviewdesignerList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="IotFloorViewDesignerListing" st-pipe="vm.retrieveData" st-table="vm.designData" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Design" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="iotsettings.floorviewdesigner.create" rms-check-access="iotsettings.floorviewdesigner" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_DESIGN"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:200px" st-sort="branchName">{{ \'BRANCH_NAME\' | translate }}</th><th st-sort="description"><span translate="DESIGN_DESCRIPTION"></span></th><th st-sort="noOfSensors"><span translate="NO._OF_SENSORS"></span></th><th class="hide-after" style="text-align:center">{{ \'ACTIVE\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.designData.length==0 && !vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.designData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.branchName}}</td><td>{{item.description}}</td><td>{{item.noOfSensors}}</td><td style="text-align:center"><i class="fa fa-check" ng-if="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="iotsettings.floorviewdesigner.update({id:item.id})" rms-check-access="iotsettings.floorviewdesigner" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Gateway" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteDesign(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this gateway?" rms-check-access="iotsettings.floorviewdesigner" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/iotsettings/floorviewdesigner/floorviewdesignerUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/iotsettings/floorviewdesigner/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="iotsettings.floorviewdesigner.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="iotsettings.floorviewdesigner.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/inventory/stocktransfers/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-show="vm.originalStatus==\'NEW\'"><small><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_STOCK_TRANSFER_DETAILS"></span>.</small><br><br></p><p ng-show="vm.originalStatus!=\'NEW\'"><small><i class="fa fa-warning"></i> <span translate="ALL_THE_FIELDS_WILL_BE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="NEW"></b>.</small><br><br></p><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="STOCK_TRANSFER_NUMBER"></b></label> <span class="form-control" style="color:#00f" ng-disabled="true">{{vm.transfer.docNo || \'*** AUTONUMBER ***\'}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Status.$invalid && (vm.dataForm.Status.$dirty || vm.dataForm.$submitted)}"><label><b translate="DOCUMENT_STATUS"></b> <i class="fa fa-asterisk req"></i></label><select name="Status" class="form-control" ng-change="vm.selectedStatusChanged()" ng-model="vm.selectedStatus" ng-options="i as i.name for i in vm.statusList" ng-show="vm.originalStatus==\'NEW\'" required=""></select><span class="form-control" ng-if="vm.originalStatus!=\'NEW\'" ng-disabled="vm.originalStatus!=\'NEW\'">{{vm.transfer.status}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Status.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'STOCK_REQUEST_NO\' | translate }}</b></label> <span class="form-control" style="color:#00f" ng-disabled="true">{{vm.transfer.stockRequestNo || \'-\'}}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceBranch.$invalid && (vm.dataForm.SourceBranch.$dirty || vm.dataForm.$submitted)}"><label><b translate="SOURCE_BRANCH"></b> <i class="fa fa-asterisk req"></i></label><select name="SourceBranch" class="form-control" ng-change="vm.selectedSourceBranchChanged()" ng-model="vm.selectedSourceBranch" ng-options="i as i.name for i in vm.branchList" ng-show="vm.originalStatus==\'NEW\'" required=""></select><span class="form-control" ng-if="vm.originalStatus!=\'NEW\'" ng-disabled="vm.originalStatus!=\'NEW\'">{{vm.transfer.sourceBranchName | uppercase}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceBranch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestBranch.$invalid && (vm.dataForm.DestBranch.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESTINATION_BRANCH"></b> <i class="fa fa-asterisk req"></i></label><div class="input-group"><span class="input-group-addon" style="padding:0px"><i class="fa fa-info-circle" style="padding:3px 10px" uib-tooltip="{{ \'SELECTION_IS_LOCKED_WHEN_ITEM_LIST_NOT_EMPTY\' | translate }}"></i></span><select name="DestBranch" class="form-control" ng-disabled="vm.transfer.stockTransferDetails.length!=0" ng-change="vm.selectedDestBranchChanged()" ng-model="vm.selectedDestBranch" ng-options="i as i.name for i in vm.branchList" ng-if="vm.originalStatus==\'NEW\' || vm.transfer.stockTransferDetails.length==0" required=""></select><span class="form-control" ng-if="vm.originalStatus!=\'NEW\' && vm.transfer.stockTransferDetails.length!=0" ng-disabled="vm.originalStatus!=\'NEW\'">{{vm.transfer.destBranchName | uppercase}}</span></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestBranch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeliveryDate.$invalid && (vm.dataForm.DeliveryDate.$dirty || vm.dataForm.$submitted)}"><label><b translate="DELIVERY_DATE"></b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.transfer.deliveryDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="DeliveryDate" autocomplete="off" ng-model="vm.transfer.deliveryDate" ng-disabled="vm.originalStatus!=\'NEW\'" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeliveryDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'REMARKS\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.transfer.remarks" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Transfer Items" ng-if="vm.selectedSourceBranch!=null && vm.selectedDestBranch!=null"><p><i class="fa fa-info-circle"></i> <span translate="ADD_THE_RAW_MATERIAL_/_SEMI_FINISHED_GOODS_/_FINISHED_GOODS_TO_BE_TRANSFERRED"></span>. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-if="vm.originalStatus==\'NEW\'" ng-click="vm.showAddItemModal()"><i class="ion-plus-round"></i>{{ \'ADD_ITEM\' | translate }}</a><br><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th></th><th><b>{{ \'ITEM_CODE\' | translate }}</b></th><th><b>{{ \'ITEM_NAME\' | translate }}</b></th><th class="hide-after" style="text-align:right"><b>{{ \'QUANTITY\' | translate }}</b></th><th style="width:100px"><b translate="U.O.M"></b></th><th><b>{{ \'REMARKS\' | translate }}</b></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="item in vm.transfer.stockTransferDetails"><td>{{ $index+1 }})</td><td class="text-center" style="width:80px;line-height:100%"><div class="report-type-tag">{{ item.itemType }}</div></td><td>{{ item.itemCode }}</td><td>{{ item.itemName }}</td><td style="text-align:right">{{ item.quantity }}</td><td>{{ item.uomName }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:150%">{{ item.remarks }}</td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-if="vm.originalStatus==\'NEW\'" ng-click="vm.showEditItemModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a> <a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-if="vm.isRmsLite && vm.originalStatus==\'CONFIRMED\'" rms-check-access="inventory.stocktransfers" rms-check-access-perm-type="APPROVE" ng-click="vm.showEditItemModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-if="vm.originalStatus==\'NEW\'" confirmed-click="vm.removeItem($index)" ng-confirm-click="Confirm remove this Raw Material?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a> <a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-if="vm.isRmsLite && vm.originalStatus==\'CONFIRMED\'" rms-check-access="inventory.stocktransfers" rms-check-access-perm-type="APPROVE" confirmed-click="vm.removeItem($index)" ng-confirm-click="Confirm remove this Raw Material?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="9" style="text-align:center" ng-if="!vm.transfer.stockTransferDetails || vm.transfer.stockTransferDetails.length==0"><br><span translate="ITEM_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="itemModal.html"><form name="$mdl.itemForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="ITEM"></span></h3> </div> <div class="modal-body" id="modal-body"> <div style="background:#d8ffd8;margin-bottom:15px"> <uib-tabset active="$mdl.activeTab"> <uib-tab heading="{{ \'RAW_MATERIAL\' | translate}}"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <label> <b translate="RAW_MATERIAL"></b> <br /> <small><i class="fa fa-info-circle"></i> {{ \'SELECT_RAW_MATERIAL_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small> </label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="$mdl.selectedItem!=null" ng-click="$mdl.clearSelection()"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> <ui-select ng-model="$mdl.selectedItem" title="Select or Search for Raw Materials..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedItemChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Raw Materials..."> <span>{{ $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.itemList | filter: $select.search" refresh="$mdl.loadItemList($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="i.description | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p> </div> </div> </div> </uib-tab> <uib-tab heading="{{ \'SEMI_FINISHED_GOODS\' | translate}}"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <label> <b translate="SEMI_FINISHED_GOODS"></b> <br /> <small><i class="fa fa-info-circle"></i> {{ \'SELECT_SEMI_FINISHED_GOODS_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small> </label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="$mdl.selectedSemiFg!=null" ng-click="$mdl.clearSelection()"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> <ui-select ng-model="$mdl.selectedSemiFg" title="Select or Search for Semi Finished Goods..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedSemiFgChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Semi Finished Goods..."> <span>{{ $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.semiFgList | filter: $select.search" refresh="$mdl.loadSemiFgList($select.search)" refresh-delay="250" minimum-input-length="2"> <span ng-bind-html="i.description | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p> </div> </div> </div> </uib-tab> <uib-tab heading="Finished Goods"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <label> <b>{{ \'FINISHED_GOODS\' | translate }}</b> <br /> <small><i class="fa fa-info-circle"></i>{{ \'SELECT_FINISHED_GOODS_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small> </label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="$mdl.selectedProduct!=null" ng-click="$mdl.clearSelection()"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> <ui-select ng-model="$mdl.selectedProduct" style="background:#fffeed" title="Select or Search for Finished Goods..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedProductChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Finished Goods..."> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.productList | filter: $select.search" refresh="$mdl.loadProductList($select.search)" refresh-delay="250" minimum-input-length="2"> <span ng-bind-html="i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p> </div> </div> </div> </uib-tab> </uib-tabset> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.Quantity.$invalid && ($mdl.itemForm.Quantity.$dirty || $mdl.itemForm.$submitted)}"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity" style="background:#fffeed" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.quantity" min=0.01 required> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Quantity.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Quantity.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Quantity.$error.min">* {{ \'MINIMUM_IS_0.01\' | translate }}</span> </div> </div> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.UOM.$invalid && ($mdl.itemForm.UOM.$dirty || $mdl.itemForm.$submitted)}"> <label><b>{{ \'U.O.M.\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <select name="UOM" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.selectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.UOM.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="newProductModal.html"><form name="$mdl.productForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="ITEM"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <label> <b>{{ \'RAW_MATERIAL\' | translate }}</b> / <b>{{ \'SEMI_FINISHED_GOODS\' | translate }}</b> / <b>{{ \'FINISHED_GOODS\' | translate }}</b> </label> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.itemSearch" style="background:#fffeed" ng-disabled="$mdl.lockButtons" ng-model-options=\'{ debounce: 500 }\' ng-change="$mdl.searchItem($mdl.itemSearch)" /> </div> </div> <div class="col-lg-9"> <select class="form-control" style="color:#333" name="ItemName" ng-disabled="$mdl.lockButtons" ng-change="$mdl.selectedItemChanged()" ng-options="u as (\'[\' + u.itemType + \'] \' + u.productName | uppercase) for u in $mdl.itemList" ng-model="$mdl.selectedItem" required> <option value="">{{($mdl.lockButtons ? (\'LOADING...\' | translate) : ($mdl.itemList.length==0 ? ("&lt;&lt; " + (\'ENTER_A_KEYWORD_TO_SEARCH\' | translate)) : ("-- " + (\'SELECT_AN_ITEM\' | translate) + " --")))}}</option> </select> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" style="margin-top:5px" ng-if="$mdl.selectedItem!=null" ng-click="$mdl.selectedItem=null"> <i class="fa fa-times"></i> <span style="color:#fff" translate="CLEAR_SELECTION"></span> </button> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted"> * {{"REQUIRED" | translate}} </p> </div> </div> </div> </div> <br /> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.Quantity.$invalid && $mdl.productForm.$submitted}"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" name="Quantity" class="form-control" min=0.01 style="background:#fffeed" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.quantity" ng-change="$mdl.onQuantityChanged" /> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.required && $mdl.productForm.$submitted">* {{"REQUIRED" | translate}}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.Quantity.$error.min && $mdl.productForm.$submitted">* {{"MINIMUM_IS_0.01" | translate}}</p> </div> </div> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.UOM.$invalid && ($mdl.productForm.UOM.$dirty || $mdl.productForm.$submitted)}"> <label><b>{{ \'U.O.M.\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <select name="UOM" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.selectedItem.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.selectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.UOM.$error.required && $mdl.productForm.$submitted">* {{"REQUIRED" | translate}}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" style="background:#fffeed" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.remarks" /> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/inventory/stocktransfers/stocktransferCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/inventory/stocktransfers/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="inventory.stocktransfers.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/inventory/stocktransfers/stocktransferList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="StockTransferListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table=""><thead><tr><th colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:30px;line-height:30px;padding-left:0px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_ALL_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:30px;line-height:30px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="inventory.stocktransfers.create" rms-check-access="inventory.stocktransfers" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="NEW_STOCK_TRANSFER"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:30px;line-height:30px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="docNo" st-sort-default="reverse">{{ \'DOCUMENT_NO\' | translate }}</th><th st-sort="createdDate" style="padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'DOCUMENT_DATE\' | translate }}<br><small>(DD/MM/YYYY)</small></th><th st-sort="createdDate" style="padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'DELIVERY_DATE\' | translate }}<br><small>(DD/MM/YYYY)</small></th><th>{{ \'SOURCE\' | translate }}</th><th>{{ \'DESTINATION\' | translate }}</th><th style="padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'REMARKS\' | translate }}</th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th st-sort="createdBy">{{ \'ORDERED_BY\' | translate }}</th><th style="width:30px"></th><th style="width:30px"></th></tr><tr><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline"><input st-search="docNo" class="form-control input input-sm" style="width:120px;background:#fffeed"></th><th class="form-inline"><input st-search="createdDate" class="form-control input input-sm" style="width:100px;background:#fffeed"></th><th class="form-inline"><input st-search="deliveryDate" class="form-control input input-sm" style="width:100px;background:#fffeed"></th><th class="form-inline"><input st-search="sourceBranchName" class="form-control input input-sm" style="width:120px;background:#fffeed"></th><th class="form-inline"><input st-search="destBranchName" class="form-control input input-sm" style="width:120px;background:#fffeed"></th><th></th><th class="form-inline"><input st-search="status" class="form-control input input-sm" style="width:120px;background:#fffeed"></th><th class="form-inline"><input st-search="createdBy" class="form-control input input-sm" style="width:120px;background:#fffeed"></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.data.length==0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td nowrap="nowrap" style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.docNo}}<div ng-if="item.stockRequestNo!=null && item.stockRequestNo!=\'\'"><small>(S/R No: <b>{{item.stockRequestNo}}</b>)</small></div></td><td>{{item.createdDate | date: "dd/MM/yyyy"}}</td><td>{{item.deliveryDate | date: "dd/MM/yyyy"}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.sourceBranchName}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.destBranchName}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.remarks}}</td><td><b><span ng-if="item.status==\'NEW\'" class="text-warning">{{item.status}}</span> <span ng-if="item.status==\'CONFIRMED\'" class="text-success">{{item.status}}</span> <span ng-if="item.status==\'IN PROCESS\'" class="text-primary">{{item.status}}</span> <span ng-if="item.status==\'CANCELLED\'" class="text-danger">{{item.status}}</span> <span ng-if="item.status.indexOf(\'COMPLETED\')!=-1" style="color:#000">{{item.status}}</span></b></td><td>{{item.createdBy | uppercase | limitTo: 10}} <span ng-if="item.createdBy.length>10">...</span></td><td align="center"><a href="" title="Print Document" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt" ng-click="vm.printDocument(item.id, item.docNo)" ng-show="item.status!=\'NEW\' && item.status!=\'CANCELLED\'" rms-check-access="inventory.stocktransfers" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="inventory.stocktransfers.update({id:item.id})" rms-check-access="inventory.stocktransfers" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/inventory/stocktransfers/stocktransferUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/inventory/stocktransfers/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="inventory.stocktransfers.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-if="vm.originalStatus==\'NEW\'" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-if="vm.isRmsLite && vm.originalStatus==\'CONFIRMED\'" rms-check-access="inventory.stocktransfers" rms-check-access-perm-type="APPROVE" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="inventory.stocktransfers.list" style="margin-right:30px" ng-if="vm.originalStatus==\'NEW\'" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-success btn-with-icon" style="margin-right:30px" ng-if="!vm.isRmsLite && vm.originalStatus==\'IN PROCESS\'" ng-disabled="vm.lockButtons" ng-confirm-click="Are you sure to complete this Stock Transfer?" confirmed-click="vm.complete()"><i class="ion ion-checkmark"></i> <span translate="COMPLETE_STOCK_TRANSFER"></span></a> <a href="" class="btn btn-success btn-with-icon" style="margin-right:30px" ng-if="vm.isRmsLite && vm.originalStatus==\'CONFIRMED\'" rms-check-access="inventory.stocktransfers" rms-check-access-perm-type="APPROVE" ng-disabled="vm.lockButtons" ng-confirm-click="Are you sure to complete this Stock Transfer?" confirmed-click="vm.complete()"><i class="ion ion-checkmark"></i> <span translate="COMPLETE_STOCK_TRANSFER"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="margin-right:30px" ng-if="vm.mode==2 && (vm.originalStatus==\'NEW\' || vm.originalStatus==\'CONFIRMED\')" ng-disabled="vm.lockButtons" rms-check-access="inventory.stocktransfers" rms-check-access-perm-type="APPROVE" ng-confirm-click="Are you sure to cancel this Stock Transfer?" confirmed-click="vm.cancel()"><i class="fa fa-trash"></i> <span translate="CANCEL_STOCK_TRANSFER"></span></a> <a href="" class="btn btn-info btn-with-icon" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'CANCELLED\'" ng-disabled="vm.lockButtons" ng-click="vm.printDocument(vm.transfer.id, vm.transfer.docNo)" rms-check-access="inventory.stocktransfers" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT_DOCUMENT"></span></a></div></form>');
$templateCache.put('app/pages/iotadmin/iotregdevices/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row" ng-if="vm.mode==1"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="SCAN_DEVICE_QR_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceQRCode" ng-disabled="vm.isGettingInfo || vm.getInfoSuccess" ng-model="vm.iotregdevice.qrcode" ng-model-options="{ debounce: 500 }" ng-change="vm.getDeviceInfo()"></div></div></div><div class="row" ng-if="vm.mode==1 && !vm.getInfoSuccess"><div class="col-md-2 col-lg-2"><div class="form-group"><a href="" class="btn btn-success" ng-hide="vm.isGettingInfo || vm.getInfoSuccess" ng-click="vm.getDeviceInfo()"><span translate="GET_DEVICE_INFO"></span></a><div ng-if="vm.isGettingInfo"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="GETTING_DEVICE_INFO"></span> ...</div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceUID.$invalid && (vm.dataForm.DeviceUID.$dirty || vm.dataForm.$submitted)}"><label><b translate="DEVICE_UID"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceUID" ng-model="vm.iotregdevice.deviceUID" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceUID.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceUUID.$invalid && (vm.dataForm.DeviceUUID.$dirty || vm.dataForm.$submitted)}"><label><b translate="DEVICE_UUID"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceUUID" ng-model="vm.iotregdevice.deviceUUID" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceUUID.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceType.$invalid && (vm.dataForm.DeviceType.$dirty || vm.dataForm.$submitted)}"><label><b translate="DEVICE_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select name="DeviceType" class="form-control" style="background:#edfbff" ng-options="i as (i.name | uppercase) for i in vm.deviceTypes" ng-model="vm.selectedType" ng-change="vm.selectedTypeChanged()" required=""><option value="">{{ \'SELECT_A_DEVICE_TYPE\' | translate }}</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceModel.$invalid && (vm.dataForm.DeviceModel.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="DEVICE_MODEL_NO"></span>.</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceModel" placeholder="E.g.: CM-HT59-LE" ng-model="vm.iotregdevice.model" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceModel.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Describe this device" ng-model="vm.iotregdevice.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><input type="hidden" name="companyId" ng-model="vm.iotregdevice.companyId"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/iotadmin/iotregdevices/iotRegDeviceCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/iotadmin/iotregdevices/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> <span translate="CREATE_DEVICE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="iotadmin.iotregdevices.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/iotadmin/iotregdevices/iotRegDeviceList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.deviceData" refresh-table="" style="font-size:80%"><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Device" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="iotadmin.iotregdevices.create" rms-check-access="iotadmin.iotregdevices" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_DEVICE"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="deviceUID"><span translate="DEVICE_UID"></span></th><th st-sort="deviceUUID"><span translate="DEVICE_UID"></span></th><th st-sort="type" translate="TYPE"></th><th st-sort="model" translate="MODEL"></th><th st-sort="mfgDate"><span translate="MFG_DATE"></span></th><th style="width:250px" st-sort="companyName"><span translate="LINKED_COMPANY"></span></th><th st-sort="isActive" translate="ACTIVE"></th><th style="width:40px"></th></tr><tr class="sortable"><th></th><th></th><th></th><th class="form-inline"><select st-search="type"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="c in vm.deviceDataFull | unique:\'type\' | orderBy:\'type\'" value="{{c.type | uppercase}}">{{(c.type | limitTo:25) + (c.type.length > 25 ? \' ...\' : \'\') }}</option></select></th><th class="form-inline"><select st-search="model"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="c in vm.deviceDataFull | unique:\'model\' | orderBy:\'model\'" value="{{c.model | uppercase}}">{{(c.model | limitTo:25) + (c.model.length > 25 ? \' ...\' : \'\') }}</option></select></th><th></th><th class="form-inline"><select st-search="companyName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="c in vm.deviceDataFull | unique:\'companyName\' | orderBy:\'companyName\'" value="{{c.companyName | uppercase}}">{{(c.companyName | limitTo:25) + (c.companyName.length > 25 ? \' ...\' : \'\') }}</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-show="vm.deviceData.length<=0 && !vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i><span translate="LOADING_DATA_"></span> ...</b></center></big></td></tr><tr ng-repeat="item in vm.deviceData | orderBy: \'company\'"><td>{{vm.startIndex+1+$index}})</td><td>{{item.deviceUID}}</td><td>{{item.deviceUUID}}</td><td>{{item.type}}</td><td>{{item.model}}</td><td>{{item.mfgDate | date: "dd-MMM-yyyy" }}</td><td>{{item.companyName}}</td><td><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="iotadmin.iotregdevices.update({id:item.id})" rms-check-access="iotadmin.iotregdevices" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/iotadmin/iotregdevices/iotRegDeviceUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/iotadmin/iotregdevices/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="iotadmin.iotregdevices.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/iotsettings/gateways/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="GATEWAY_DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Description" ng-model="vm.gateway.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="IS_ACTIVE"></b></label><div><toggle ng-model="vm.gateway.isActive" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Branch.$invalid && (vm.dataForm.Branch.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'BRANCH\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="Branch" class="form-control" style="background:#FFFCED" ng-change="vm.selectedBranchChanged()" ng-options="b as b.name for b in vm.branches | orderBy:\'name\'" ng-model="vm.selectedBranch" required=""><option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Branch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="IS_VEHICLE"></b></label><div><toggle ng-model="vm.gateway.isVehicle" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.selectedDevice==null && vm.dataForm.$submitted}"><label><b translate="ASSOCIATE_IOT_DEVICE"></b> <i class="fa fa-asterisk req"></i></label> <a href="" ng-click="vm.clearDevice()" class="btn btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="vm.selectedDevice!=null"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedDeviceChanged()" ng-options="b as (\'[ \' + b.deviceUID + \' ] \' + b.description | uppercase) for b in vm.deviceList | orderBy:\'name\'" ng-model="vm.selectedDevice" required=""><option value="">-- {{ \'SELECT_A_GATEWAY_DEVICE\' | translate }} --</option></select><span class="help-block" ng-show="vm.selectedDevice==null && vm.dataForm.$submitted">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DEVICE_UID"></b></label> <span class="form-control" ng-disabled="true">{{vm.selectedDevice.deviceUID || \'-\'}}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DEVICE_UUID"></b></label> <span class="form-control" ng-disabled="true">{{vm.selectedDevice.deviceUUID || \'-\'}}</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DEVICE_TYPE"></b></label> <span class="form-control" ng-disabled="true">{{vm.selectedDevice.type || \'-\'}}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DEVICE_MODEL"></b></label> <span class="form-control" ng-disabled="true">{{vm.selectedDevice.model || \'-\'}}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="GPS Settings"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b><span translate="GPS_LATITUDE"></span></b></label> <input type="text" class="form-control" placeholder="GPS Latitude" ng-model="vm.gateway.gpsLatitude"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b><span translate="GPS_LONGITUDE"></span></b></label> <input type="text" class="form-control" placeholder="GPS Longitude" ng-model="vm.gateway.gpsLongitude"></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Hardware Settings" ng-if="vm.canSetIoTHardwareSettings"><p><i class="fa fa-info-circle"></i> <span translate="THESE_HARDWARE_SETTINGS_MUST_BE_SET_BEFORE_DEPLOY_TO_PRODUCTION_ENVIRONMENT"></span>.<br><br><span style="color:#f00;text-transform:uppercase"><b translate="THESE_SETTINGS_ARE_IMPORTANT_FOR_HARDWARE_RE-CONFIGURATION_FOR_HARDWARE_REPLACEMENT"></b></span><br><br></p><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceGroupNo.$invalid && (vm.dataForm.DeviceGroupNo.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="DEVICE_GROUP_NO"></span>.</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceGroupNo" placeholder="Device Group No." ng-model="vm.gateway.deviceGroupNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceGroupNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="TransferGatewayModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="TRANSFER_GATEWAY_TO_OTHER_COMPANY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.cloneForm.Company.$invalid && $mdl.cloneForm.$submitted}"> <label><b translate="SELECT_A_COMPANY">:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="Company" ng-options="c as (c.name | uppercase) for c in $mdl.companies track by c.id" ng-change="$mdl.selectedCompanyChanged()" ng-model="$mdl.selectedCompany" required> <option value="">-- {{ \'SELECT_A_COMPANY\' | translate }} --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.cloneForm.Company.$error.required && $mdl.cloneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.cloneForm.Branch.$invalid && $mdl.cloneForm.$submitted}"> <label><b translate="SELECT_A_BRANCH">:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="Branch" ng-options="r as (r.name | uppercase) for r in $mdl.branches track by r.id" ng-disabled="!$mdl.selectedCompany" ng-change="$mdl.selectedBranchChanged()" ng-model="$mdl.selectedBranch" required> <option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.cloneForm.Branch.$error.required && $mdl.cloneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/iotsettings/gateways/gatewayCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/iotsettings/gateways/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="iotsettings.gateways.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/iotsettings/gateways/gatewayList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="IotGatewayListing" st-pipe="vm.retrieveData" st-table="vm.gatewayData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Gateway" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="iotsettings.gateways.create" rms-check-access="iotsettings.gateways" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_GATEWAY"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:250px" st-sort="branchName">{{ \'BRANCH_NAME\' | translate }}</th><th translate="GATEWAY_DESCRIPTION"></th><th style="width:150px" st-sort="deviceUID"><span translate="GATEWAY_UID"></span></th><th style="width:200px" st-sort="deviceUUID"><span translate="GATEWAY_UUID"></span></th><th class="hide-after" style="text-align:center"><span translate="IS_VEHICLE"></span></th><th class="hide-after" style="text-align:center"><span translate="IS_ACTIVE"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.gatewayData.length==0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.gatewayData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.branchName}}</td><td>{{item.description}}</td><td style="font-family:courier;letter-spacing:2px;font-size:110%;"><b>{{item.deviceUID}}</b></td><td style="font-family:courier;letter-spacing:1px;font-size:110%;"><b>{{item.deviceUUID}}</b></td><td style="text-align:center"><i class="fa fa-check" ng-if="item.isVehicle" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.isVehicle" style="color:#f00"></i></td><td style="text-align:center"><i class="fa fa-check" ng-if="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="iotsettings.gateways.update({id:item.id})" rms-check-access="iotsettings.gateways" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Gateway" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteGateway(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this gateway?" rms-check-access="iotsettings.gateways" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/iotsettings/gateways/gatewayUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/iotsettings/gateways/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="iotsettings.gateways.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="iotsettings.gateways.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-primary btn-with-icon pull-right" ng-if="vm.isSuperAdmin" ng-disabled="vm.lockButtons" ng-click="vm.showTransferModal()"><i class="fa fa-exchange"></i> <span translate="TRANSFER_TO_OTHER_COMPANY"></span></a></div></form>');
$templateCache.put('app/pages/iotsettings/handhelds/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_HANDHELD_DEVICE_INFORMATION"></span><br><br></p><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.selectedDevice==null && vm.dataForm.$submitted}"><label><b translate="ASSOCIATE_IOT_DEVICE"></b> <i class="fa fa-asterisk req"></i></label> <a href="" ng-click="vm.clearDevice()" class="btn btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="vm.selectedDevice!=null"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a><ui-select class="btn-group bootstrap-select form-control" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" ng-disabled="false" append-to-body="false" search-enabled="true" ng-model="vm.selectedDevice" on-select="vm.selectedDeviceChanged()" required=""><ui-select-match placeholder="-- Select a Device --"><span>{{ ($select.selected.deviceUID + \' - \' + $select.selected.description) | uppercase }}</span></ui-select-match><ui-select-choices repeat="t in vm.deviceList | filter: $select.search"><span ng-bind-html="(t.deviceUID + \' - \' + t.type) | uppercase | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.selectedDevice==null && vm.dataForm.$submitted">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DEVICE_UID"></b></label> <input type="text" class="form-control" ng-model="vm.selectedDevice.deviceUID" ng-disabled="true"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DEVICE_UUID"></b></label> <input type="text" class="form-control" ng-model="vm.selectedDevice.deviceUUID" ng-disabled="true"></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DEVICE_TYPE"></b></label> <input type="text" class="form-control" ng-model="vm.selectedDevice.type" ng-disabled="true"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DEVICE_MODEL"></b></label> <input type="text" class="form-control" ng-model="vm.selectedDevice.model" ng-disabled="true"></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceGroupNo.$invalid && (vm.dataForm.DeviceGroupNo.$dirty || vm.dataForm.$submitted)}"><label><b translate="DEVICE_GROUP_NO."></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceGroupNo" placeholder="Device Group No." ng-model="vm.handheld.deviceGroupNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceGroupNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceNodeNo.$invalid && (vm.dataForm.DeviceNodeNo.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="DEVICE_NODE_NO"></span>.</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceNodeNo" placeholder="Device Node No." ng-model="vm.handheld.deviceNodeNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceNodeNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.Description.$invalid && ($mdl.settingForm.Description.$dirty || $mdl.settingForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Description" ng-model="vm.handheld.description" required=""> <span class="help-block" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="ENABLED"></b></label><br><div><toggle ng-model="vm.handheld.enabled" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="UNIQUE_KEY"></b> (for Device Configuration)</label> <input type="text" class="form-control" ng-model="vm.handheld.uniqueKey" ng-readonly="true"></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/iotsettings/handhelds/handheldCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/iotsettings/handhelds/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="iotsettings.handhelds.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/iotsettings/handhelds/handheldList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.handheldData" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Handheld" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="iotsettings.handhelds.create" rms-check-access="iotsettings.handhelds" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_HANDHELD"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:100px" st-sort="deviceUID"><span translate="HANDHELD_UID"></span></th><th style="width:150px" st-sort="deviceType"><span translate="HANDHELD_TYPE"></span></th><th st-sort="description" translate="DESCRIPTION"></th><th class="hide-after" style="text-align:center" translate="ENABLED"></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.handheldData.length==0 && !vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.handheldData"><td>{{vm.startIndex+1+$index}})</td><td style="font-family:courier;letter-spacing:2px"><b>{{item.deviceUID}}</b></td><td>{{item.type}}</td><td>{{item.description}}</td><td style="text-align:center"><i class="fa fa-check" ng-if="item.enabled" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.enabled" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="iotsettings.handhelds.update({id:item.id})" rms-check-access="iotsettings.handhelds" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Handheld" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteHandheld(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Handheld device?" rms-check-access="iotsettings.handhelds" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/iotsettings/handhelds/handheldUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/iotsettings/handhelds/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="iotsettings.handhelds.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="iotsettings.handhelds.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-danger btn-with-icon pull-right" ng-if="vm.isSuperAdmin" ng-disabled="vm.lockButtons" confirmed-click="vm.deleteReadings()" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this sensor\'s readings?"><i class="fa fa-trash"></i> <span translate="DELETE_READINGS"></span></a></div></form>');
$templateCache.put('app/pages/iotsettings/sensors/_form.html','<style>\n\t.modal-md {\n\t\twidth: 800px !important;\n\t}\n</style><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_SENSOR_INFORMATION"></span><br><br></p><div class="row"><div class="col-md-4 col-lg-4" style="margin-right:50px"><div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.Description.$invalid && ($mdl.settingForm.Description.$dirty || $mdl.settingForm.$submitted)}"><label><b translate="SENSOR_DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Device UID" ng-model="vm.sensor.description" required=""> <span class="help-block" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="ENABLED"></b></label><br><div><toggle ng-model="vm.sensor.enabled" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4" style="margin-right:50px"><div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.Gateway.$invalid && ($mdl.settingForm.Gateway.$dirty || $mdl.settingForm.$submitted)}"><label><b translate="ASSOCIATE_GATEWAY"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedGatewayChanged()" ng-options="b as (\'[ \' + b.deviceUID + \' ] \' + b.description) for b in vm.gateways | orderBy:\'name\'" ng-model="vm.selectedGateway" required=""><option value="">-- {{ \'SELECT_A_GATEWAY\' | translate }} --</option></select><span class="help-block" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.Gateway.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DISPLAY_FAHRENHEIT"></b> (&deg;F)</label><br><div><toggle ng-model="vm.sensor.isFahrenheit" ng-change="vm.selectedSymbolChanged()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.selectedDevice==null && vm.dataForm.$submitted}"><label><b translate="ASSOCIATE_IOT_DEVICE"></b> <i class="fa fa-asterisk req"></i></label> <a href="" ng-click="vm.clearDevice()" class="btn btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="vm.selectedDevice!=null"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedDeviceChanged()" ng-options="b as (\'[ \' + b.deviceUID + \' ] \' + b.description | uppercase) for b in vm.deviceList | orderBy:\'name\'" ng-model="vm.selectedDevice" required=""><option value="">-- {{ \'SELECT_A_SENSOR\' | translate }} --</option></select><span class="help-block" ng-show="vm.selectedDevice==null && vm.dataForm.$submitted">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DEVICE_UID"></b></label> <input type="text" class="form-control" ng-model="vm.selectedDevice.deviceUID" ng-disabled="true"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DEVICE_UUID"></b></label> <input type="text" class="form-control" ng-model="vm.selectedDevice.deviceUUID" ng-disabled="true"></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DEVICE_TYPE"></b></label> <input type="text" class="form-control" ng-model="vm.selectedDevice.type" ng-disabled="true"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DEVICE_MODEL"></b></label> <input type="text" class="form-control" ng-model="vm.selectedDevice.model" ng-disabled="true"></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Alert Settings"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_SENSOR_ALERT_SETTINGS"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddSettingModal()"><i class="ion-plus-round"></i><span translate="ADD_SETTING"></span></a><br><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="SETTING_TYPE"></b></th><th><b setting="" description=""></b></th><th class="hide-after" style="text-align:center"><b translate="TRIGGER_ALERT"></b></th><th class="hide-after" style="text-align:center"><b translate="RANGE_START"></b></th><th class="hide-after" style="text-align:center"><b translate="RANGE_END"></b></th><th class="hide-after" style="text-align:center"><b translate="MUTE_ALERT_TIME_FRAME"></b></th><th class="hide-after" style="text-align:center"><b translate="COLOR_CODE"></b></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="item in vm.sensor.iotSensorThresholdSettings"><td>{{ $index+1 }})</td><td>{{ item.type || \'\' }}</td><td>{{ item.description || \'\' }}</td><td style="text-align:center"><i class="fa fa-check" ng-if="item.triggerAlert" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.triggerAlert" style="color:#f00"></i></td><td style="text-align:center">{{ item.valueStart || \'-\' }} <span ng-if="item.type==\'TEMPERATURE\'">&deg;{{vm.symbol}}</span> <span ng-if="item.type==\'HUMIDITY\'">%RH</span></td><td style="text-align:center">{{ item.valueEnd || \'-\' }} <span ng-if="item.type==\'TEMPERATURE\'">&deg;{{vm.symbol}}</span> <span ng-if="item.type==\'HUMIDITY\'">%RH</span></td><td style="padding-top:8px;padding-bottom:8px"><div ng-if="!item.muteMon&&!item.muteTue&&!item.muteWed&&!item.muteThu&&!item.muteFri&&!item.muteSat&&!item.muteSun"><center>-</center></div><table border="1" style="width:100%;font-size:90%" ng-if="item.muteMon||item.muteTue||item.muteWed||item.muteThu||item.muteFri||item.muteSat||item.muteSun"><tr><td style="text-align:center;line-height:100%;padding:5px"><b translate="MONDAY"></b></td><td style="text-align:center;line-height:100%;padding:5px"><b translate="TUESDAY"></b></td><td style="text-align:center;line-height:100%;padding:5px"><b translate="WEDNESDAY"></b></td><td style="text-align:center;line-height:100%;padding:5px"><b translate="THURSDAY"></b></td><td style="text-align:center;line-height:100%;padding:5px"><b translate="FRIDAY"></b></td><td style="text-align:center;line-height:100%;padding:5px"><b translate="SATURDAY"></b></td><td style="text-align:center;line-height:100%;padding:5px"><b translate="SUNDAY"></b></td></tr><tr><td style="text-align:center;width:14%;line-height:100%;padding:5px"><span ng-if="item.muteMon"><b>&check;</b></span> <span ng-if="!item.muteMon"><b>&nbsp;</b></span></td><td style="text-align:center;width:14%;line-height:100%;padding:5px"><span ng-if="item.muteTue"><b>&check;</b></span> <span ng-if="!item.muteTue"><b>&nbsp;</b></span></td><td style="text-align:center;width:14%;line-height:100%;padding:5px"><span ng-if="item.muteWed"><b>&check;</b></span> <span ng-if="!item.muteWed"><b>&nbsp;</b></span></td><td style="text-align:center;width:14%;line-height:100%;padding:5px"><span ng-if="item.muteThu"><b>&check;</b></span> <span ng-if="!item.muteThu"><b>&nbsp;</b></span></td><td style="text-align:center;width:14%;line-height:100%;padding:5px"><span ng-if="item.muteFri"><b>&check;</b></span> <span ng-if="!item.muteFri"><b>&nbsp;</b></span></td><td style="text-align:center;width:14%;line-height:100%;padding:5px"><span ng-if="item.muteSat"><b>&check;</b></span> <span ng-if="!item.muteSat"><b>&nbsp;</b></span></td><td style="text-align:center;width:14%;line-height:100%;padding:5px"><span ng-if="item.muteSun"><b>&check;</b></span> <span ng-if="!item.muteSun"><b>&nbsp;</b></span></td></tr></table><div style="text-align:center;line-height:100%;margin-top:3px" ng-if="item.muteMon||item.muteTue||item.muteWed||item.muteThu||item.muteFri||item.muteSat||item.muteSun"><span translate="FROM"></span>: <b>{{item.muteFromHour}}:{{(item.muteFromMinute==0?"00":item.muteFromMinute)}}</b> &nbsp;&nbsp;&nbsp; <span translate="TILL"></span>: <b>{{item.muteToHour}}:{{(item.muteToMinute==0?"00":item.muteToMinute)}}</b></div></td><td><div style="width:80px;height:20px;background:{{item.colorCode}};line-height:20px;margin:8px auto;border:2px solid #333"></div></td><td style="padding-top:6px;padding-bottom:6px"><a class="btn btn-info editable-table-button btn-with-icon btn-sm" style="width:100px;font-size:10pt" ng-click="vm.showEditSettingModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td style="padding-top:6px;padding-bottom:6px"><a class="btn btn-danger editable-table-button btn-with-icon btn-sm" style="width:100px;font-size:10pt" confirmed-click="vm.removeSetting($index)" ng-confirm-click="Confirm remove this Setting?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="9" style="text-align:center" ng-if="!vm.sensor.iotSensorThresholdSettings || vm.sensor.iotSensorThresholdSettings.length==0"><br><span translate="SETTING_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Hardware Settings" ng-if="vm.canSetIoTHardwareSettings"><p><i class="fa fa-info-circle"></i> <span translate="THESE_HARDWARE_SETTINGS_MUST_BE_SET_BEFORE_DEPLOY_TO_PRODUCTION_ENVIRONMENT"></span>.<br><br><span style="color:#f00;text-transform:uppercase"><b><span translate="THESE_HARDWARE_SETTINGS_MUST_BE_SET_BEFORE_DEPLOY_TO_PRODUCTION_ENVIRONMENT"></span></b></span><br><br></p><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceGroupNo.$invalid && (vm.dataForm.DeviceGroupNo.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="DEVICE_GROUP_NO"></span>.</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceGroupNo" placeholder="Device Group No." ng-model="vm.sensor.deviceGroupNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceGroupNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceNodeNo.$invalid && (vm.dataForm.DeviceNodeNo.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="DEVICE_NODE_NO"></span>.</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceNodeNo" placeholder="Device Node No." ng-model="vm.sensor.deviceNodeNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceNodeNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.sensor.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_SENSOR"></span>.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br><span translate="THERE_IS_NO_CHANGES_YET"></span>.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="settingModal.html"><form name="$mdl.settingForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="TEMPERATURE_ALERT_SETTING"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-3"> <div class="form-group"> <label><b translate="ENABLE_ALERT"></b></label><br /> <div> <toggle ng-model="$mdl.item.triggerAlert" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> <div class="col-lg-9"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.Type.$invalid && ($mdl.settingForm.Type.$dirty || $mdl.settingForm.$submitted)}"> <label><b translate="SETTING_TYPE"></b> <i class="fa fa-asterisk req"></i></label> <select name="Type" class="form-control" ng-model="$mdl.selectedType" ng-change="$mdl.selectedTypeChanged()" ng-options="i as i.name for i in $mdl.typeList" required> <option></option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.Type.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-lg-3"></div> <div class="col-lg-9"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.Description.$invalid && $mdl.settingForm.$submitted}"> <label><b translate="SETTING_DESCRIPTION"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="text" name="Description" class="form-control" ng-model="$mdl.item.description" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.settingForm.Description.$error.required && $mdl.settingForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-3"> </div> <div class="col-md-3 col-lg-3" style="padding-right:0px"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.ThresholdStart.$invalid && ($mdl.settingForm.ThresholdStart.$dirty || $mdl.settingForm.$submitted)}"> <label><b>Range Start</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="ThresholdStart" ng-model="$mdl.item.valueStart" required> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.ThresholdStart.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.ThresholdStart.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> </div> </div> <div class="col-md-3 col-lg-3" style="padding-right:0px"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.ThresholdEnd.$invalid && ($mdl.settingForm.ThresholdEnd.$dirty || $mdl.settingForm.$submitted)}"> <label><b>Range End</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="ThresholdEnd" ng-model="$mdl.item.valueEnd" required> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.ThresholdEnd.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.ThresholdEnd.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> </div> </div> <div class="col-md-3 col-lg-3"> <label><b>&nbsp;</b></label> <br /> <div style="line-height:30px"> <b>&deg;{{$mdl.symbol}}</b> </div> </div> </div> <div class="row"> <div class="col-lg-3"> </div> <div class="col-lg-6" style="padding-right:0px"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.ThresholdTimeSpan.$invalid && ($mdl.settingForm.ThresholdTimeSpan.$dirty || $mdl.settingForm.$submitted)}"> <label><b translate="SMART_MONITORING_DURATION"></b> <i class="fa fa-asterisk req"></i></label> <select name="ThresholdTimeSpan" class="form-control" ng-model="$mdl.selectedTimeSpan" ng-change="$mdl.selectedTimeSpanChanged()" ng-options="i as i.name for i in $mdl.periodList" required> <option></option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.ThresholdTimeSpan.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-lg-3"> </div> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.ColorCode.$invalid && ($mdl.settingForm.ColorCode.$dirty || $mdl.settingForm.$submitted)}"> <label><b translate="COLOR_CODE"></b> <i class="fa fa-asterisk req"></i><br /> <span translate="(DISPLAY_ON_GRAPH)"></span> </label> <div class="row"> <div class="col-md-6 col-lg-6" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt;background:{{$mdl.item.colorCode}}"> &nbsp;&nbsp;&nbsp;&nbsp; </span> <input class="form-control" type="text" name="ColorCode" colorpicker colorpicker-close-on-select colorpicker-size="200" colorpicker-position="right" ng-model="$mdl.item.colorCode" required /> </div> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.ColorCode.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> <div class="col-md-6 col-lg-6"> <a href ng-click="$mdl.selectColor(\'#ff0000\')" style="color:#ff0000"> <i class="fa fa-circle fa-2x"></i> </a> <a href ng-click="$mdl.selectColor(\'#ffbf00\')" style="color:#ffbf00"> <i class="fa fa-circle fa-2x"></i> </a> <a href ng-click="$mdl.selectColor(\'#00ff00\')" style="color:#00ff00"> <i class="fa fa-circle fa-2x"></i> </a> </div> </div> </div> </div> </div> <div class="row"> <div class="col-lg-3"> </div> <div class="col-lg-9"> <div class="form-group"> <label><b translate="MUTE_ALERT" ></b><br /> <span translations="TURN_ON_QUIET_MODE_FOR_SELECTED_DAY(S)_AND_TIME_FRAMES"></span> </label> <table cellpadding="5" border="1" style="width:100%"> <tr> <td style="text-align:center;padding:5px"><b translate="MONDAY"></b></td> <td style="text-align:center;padding:5px"><b translate="TUESDAY"></b></td> <td style="text-align:center;padding:5px"><b translate="WEDNESDAY"></b></td> <td style="text-align:center;padding:5px"><b translate="THURSDAY"></b></td> <td style="text-align:center;padding:5px"><b translate="FRIDAY"></b></td> <td style="text-align:center;padding:5px"><b translate="SATURDAY"></b></td> <td style="text-align:center;padding:5px"><b translate="SUNDAY"></b></td> </tr> <tr> <td style="text-align:center;width:14%"> <input type="checkbox" class="form-control" ng-model="$mdl.item.muteMon" /> </td> <td style="text-align:center;width:14%"> <input type="checkbox" class="form-control" ng-model="$mdl.item.muteTue" /> </td> <td style="text-align:center;width:14%"> <input type="checkbox" class="form-control" ng-model="$mdl.item.muteWed" /> </td> <td style="text-align:center;width:14%"> <input type="checkbox" class="form-control" ng-model="$mdl.item.muteThu" /> </td> <td style="text-align:center;width:14%"> <input type="checkbox" class="form-control" ng-model="$mdl.item.muteFri" /> </td> <td style="text-align:center;width:14%"> <input type="checkbox" class="form-control" ng-model="$mdl.item.muteSat" /> </td> <td style="text-align:center;width:14%"> <input type="checkbox" class="form-control" ng-model="$mdl.item.muteSun" /> </td> </tr> </table> </div> </div> </div> <div class="row" ng-if="$mdl.item.muteMon||$mdl.item.muteTue||$mdl.item.muteWed||$mdl.item.muteThu||$mdl.item.muteFri||$mdl.item.muteSat||$mdl.item.muteSun"> <div class="col-lg-3"> </div> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.MuteFromHour.$invalid && ($mdl.settingForm.MuteFromHour.$dirty || $mdl.settingForm.$submitted)}"> <label><b><span translate="MUTE_FROM"></span> ( <span translate="HOUR"></span>)</b></label> <select name="MuteFromHour" class="form-control" ng-model="$mdl.selectedFromHour" ng-change="$mdl.selectedFromHourChanged()" ng-options="i as i.name for i in $mdl.hourList" ng-required="$mdl.item.muteMon||$mdl.item.muteTue||$mdl.item.muteWed||$mdl.item.muteThu||$mdl.item.muteFri||$mdl.item.muteSat||$mdl.item.muteSun"> <option></option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.MuteFromHour.$error.required">* <span translate="HOUR_REQUIRED"></span></span> </div> </div> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.MuteFromMinute.$invalid && ($mdl.settingForm.MuteFromMinute.$dirty || $mdl.settingForm.$submitted)}"> <label><b translate="MUTE_FROM_(MINUTE)"></b></label> <select name="MuteFromMinute" class="form-control" ng-model="$mdl.selectedFromMinute" ng-change="$mdl.selectedFromMinuteChanged()" ng-options="i as i.name for i in $mdl.minuteList" ng-required="$mdl.item.muteMon||$mdl.item.muteTue||$mdl.item.muteWed||$mdl.item.muteThu||$mdl.item.muteFri||$mdl.item.muteSat||$mdl.item.muteSun"> <option></option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.MuteFromMinute.$error.required">* <span translate="MINUTE_REQUIRED"></span></span> </div> </div> <div class="col-lg-3"> <br /><br /><big><b>{{$mdl.muteFromTime}}</b></big> </div> </div> <div class="row" ng-if="$mdl.item.muteMon||$mdl.item.muteTue||$mdl.item.muteWed||$mdl.item.muteThu||$mdl.item.muteFri||$mdl.item.muteSat||$mdl.item.muteSun"> <div class="col-lg-3"> </div> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.MuteTillHour.$invalid && ($mdl.settingForm.MuteTillHour.$dirty || $mdl.settingForm.$submitted)}"> <label><b translations="MUTE_TILL_(HOUR)"></b></label> <select name="MuteTillHour" class="form-control" ng-model="$mdl.selectedTillHour" ng-change="$mdl.selectedTillHourChanged()" ng-options="i as i.name for i in $mdl.hourList" ng-required="$mdl.item.muteMon||$mdl.item.muteTue||$mdl.item.muteWed||$mdl.item.muteThu||$mdl.item.muteFri||$mdl.item.muteSat||$mdl.item.muteSun"> <option></option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.MuteTillHour.$error.required">* <span translate="HOUR_REQUIRED"></span></span> </div> </div> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.MuteTillMinute.$invalid && ($mdl.settingForm.MuteTillMinute.$dirty || $mdl.settingForm.$submitted)}"> <label><b translations="MUTE_TILL_(MINUTE)"></b></label> <select name="MuteTillMinute" class="form-control" ng-model="$mdl.selectedTillMinute" ng-change="$mdl.selectedTillMinuteChanged()" ng-options="i as i.name for i in $mdl.minuteList" ng-required="$mdl.item.muteMon||$mdl.item.muteTue||$mdl.item.muteWed||$mdl.item.muteThu||$mdl.item.muteFri||$mdl.item.muteSat||$mdl.item.muteSun"> <option></option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.MuteTillMinute.$error.required">* <span translate="MINUTE_REQUIRED"></span></span> </div> </div> <div class="col-lg-3"> <br /><br /><big><b>{{$mdl.muteTillTime}}</b></big> </div> </div> </div> <hr /> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/iotsettings/sensors/sensorCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/iotsettings/sensors/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="iotsettings.sensors.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/iotsettings/sensors/sensorList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="IotSensorListing" st-pipe="vm.retrieveData" st-table="vm.sensorData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Sensor" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="iotsettings.sensors.create" rms-check-access="iotsettings.sensors" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_SENSOR"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:250px" st-sort="gatewayDescription"><span translate="ASSOCIATED_GATEWAY"></span></th><th st-sort="description">{{ \'DESCRIPTION\' | translate }}</th><th style="width:150px" st-sort="deviceType"><span translate="SENSOR_TYPE"></span></th><th style="width:100px" st-sort="deviceUID"><span translate="SENSOR_UID"></span></th><th style="width:100px" st-sort="deviceUID"><span translate="SENSOR_UUID"></span></th><th class="hide-after" style="text-align:center"><span translate="ENABLED"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th></th><th><select st-search="gatewayDescription" style="width:100%"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.sensorDataFull | unique:\'gatewayDescription\'" value="{{s.gatewayDescription}}">{{s.gatewayDescription}}</option></select></th><th colspan="7"></th></tr></thead><tbody><tr ng-if="vm.sensorData.length==0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.sensorData"><td>{{vm.startIndex+1+$index}})</td><td>[<span style="font-family:courier;letter-spacing:2px;font-size:110%;"><b>{{item.gatewayDeviceUID}}</b></span>] &nbsp;{{item.gatewayDescription}}</td><td>{{item.description}}</td><td>{{item.type}}</td><td style="font-family:courier;letter-spacing:2px;font-size:110%;"><b>{{item.deviceUID}}</b></td><td style="font-family:courier;letter-spacing:2px;font-size:110%;"><b>{{item.deviceUUID}}</b></td><td style="text-align:center"><i class="fa fa-check" ng-if="item.enabled" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.enabled" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="iotsettings.sensors.update({id:item.id})" rms-check-access="iotsettings.sensors" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Sensor" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteSensor(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this sensor?" rms-check-access="iotsettings.sensors" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/iotsettings/sensors/sensorUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/iotsettings/sensors/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="iotsettings.sensors.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="iotsettings.sensors.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-danger btn-with-icon pull-right" ng-if="vm.isSuperAdmin" ng-disabled="vm.lockButtons" confirmed-click="vm.deleteReadings()" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this sensor\'s readings?"><i class="fa fa-trash"></i> <span translate="DELETE_READINGS"></span></a> <a href="" class="btn btn-danger btn-with-icon pull-right" style="margin-right:20px" rms-check-access="iotsettings.sensors" rms-check-access-perm-type="DELETE" ng-disabled="vm.lockButtons" confirmed-click="vm.deleteSensor()" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this sensor?"><i class="fa fa-trash"></i> <span translate="DELETE_SENSOR"></span></a></div></form>');
$templateCache.put('app/pages/jobs/jobanalysissemifg/jobanalysissemifgList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="row" style="margin-bottom:10px"><div class="col-md-12 col-lg-12" style="height:35px;line-height:35px;text-align:right;color:#00f"><i class="fa fa-info-circle"></i> <span translate="SELECT_ONE_OR_MORE_ENTRIES_TO_GENERATE_JOBS"></span>.</div><div class="col-md-12 col-lg-12" style="height:35px"><div style="display:inline-block;float:left;margin-right:20px"><b>{{ \'SO_ST_JOB\' | translate}}</b><br><small>{{ \'DELIVERY_EXEC_DATE\' | translate }}</small></div><div style="display:inline-block;float:left"><b>{{ \'START_DATE\' | translate }}:</b><br><small>(YYYY-MM-DD)</small></div><div style="display:inline-block;float:left;margin-left:7px"><div moment-picker="vm.startDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:170px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="StartDate" style="width:170px;background:#fffeed" ng-disabled="vm.isLoading" ng-model="vm.startDate" ng-readonly="true" required=""></div></div><div style="display:inline-block;float:left;margin-left:15px"><b>{{ \'END_DATE\' | translate }}:</b><br><small>(YYYY-MM-DD)</small></div><div style="display:inline-block;float:left;margin-left:7px;margin-right:20px"><div moment-picker="vm.endDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:170px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="EndDate" style="width:170px;background:#fffeed" ng-disabled="vm.isLoading" ng-model="vm.endDate" ng-readonly="true" required=""></div></div><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.refreshPage()" ng-if="!vm.isLoading"><i class="ion-refresh"></i> <span translate="LOAD_ANALYSIS"></span></a> <span>&nbsp;&nbsp;&nbsp;&nbsp; <span translate="ANALYSIS_TIME"></span>&nbsp;:&nbsp;<b>{{vm.timeTaken | number:0}}</b> <span translate="SECONDS"></span></span></div><div class="col-md-12 col-lg-12" style="height:35px; margin-top:20px" ng-show="vm.selectProductIds.length>0"><div style="display:inline-block;float:left;margin-right:72px"><b>{{ \'JOB_EXECUTION_DATE/TIME\' | translate }}:</b><br><small>(YYYY-MM-DD)</small></div><div style="display:inline-block;float:left;margin-left:7px;margin-right:20px"><div moment-picker="vm.executionDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:170px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="ExecutionDate" style="width:170px;background:#fffeed" ng-disabled="vm.isLoading" ng-model="vm.executionDate" ng-readonly="true" required=""></div></div><a href="" class="btn btn-success btn-with-icon" confirmed-click="vm.generateJobs()" ng-confirm-click="{{\'CONFIRM_PROCEED_TO_GENERATE_JOBS\' | translate }} ?" ng-if="!vm.isLoading" rms-check-access="jobs.jobanalysissemifg" rms-check-access-perm-type="CREATE"><i class="ion-checkmark-round"></i> <span translate="GENERATE_JOB"></span>(s)</a></div></div><div class="horizontal-scroll"><div class="form-group"><div class="form-inline"><form editable-form="" name="vm.tableForm"><table class="table table-bordered table-hover table-striped" style="font-size:90%"><tr><th style="width:50px;text-align:left">#</th><th style="border-right:4px solid #888" class="hide-after"><b translate="SEMI_FINISHED_GOODS"></b></th><th style="text-align:right;color:#000000;line-height:100%;border-right:1px solid #aaa"><small><b>{{ \'CONSOLIDATED\' | translate }}<br>{{ \'QUANTITY\' | translate }}</b></small></th><th style="text-align:right;color:#0000ff;line-height:100%;border-right:1px solid #aaa"><small><b>{{ \'INVENTORY\' | translate }}<br>{{ \'QUANTITY\' | translate }}</b></small></th><th style="text-align:right;color:#ff0000;line-height:100%;border-right:4px solid #888" class="hide-after"><small><b>{{ \'DIFFERENCE\' | translate }}<br>{{ \'QUANTITY\' | translate }}</b></small></th><th style="text-align:right;color:#9f4f00;line-height:100%;border-right:1px solid #aaa"><small><b>{{ \'PAR_LEVEL\' | translate }}</b></small></th><th style="text-align:right;color:#9f4f00;line-height:100%;border-right:1px solid #aaa"><small><b>{{ \'REORDER\' | translate }}<br>{{ \'LEVEL\' | translate }}</b></small></th><th style="text-align:right;color:#9f4f00;line-height:100%;border-right:4px solid #888" class="hide-after"><small><b>{{ \'REORDER\' | translate }}<br>{{ \'QUANTITY\' | translate }}</b></small></th><th style="text-align:right;color:#cc00ff;line-height:100%;border-right:4px solid #888" class="hide-after"><small><b>{{ \'RECIPE_YIELD\' | translate }}<br>{{ \'QTY_PER_BATCH\' | translate }}</b></small></th><th style="text-align:center;color:#ff7800;line-height:100%;border-right:1px solid #aaa" class="hide-after"><small><b>{{ \'NO_OF_PENDING_JOBS\' | translate }}</b></small></th><th style="text-align:center;color:#0000ff;line-height:100%;border-right:4px solid #888" class="hide-after"><small><b>{{ \'NO_OF_CONFIRMED_JOBS\' | translate }}</b></small></th><th style="text-align:center;color:#228f00;line-height:100%;border-right:1px solid #aaa"><small><b>{{ \'JOB_EXEC._DATE\' | translate }}<br>({{ \'LATEST\' | translate }})</b></small></th><th style="text-align:center;color:#228f00;line-height:100%;border-right:1px solid #aaa"><small><b>{{ \'RECOMMENDED\' | translate }}<br>{{ \'PRODUCTION\' | translate }}<br>({{ \'NO._OF_BATCH\' | translate }})</b></small></th><th style="text-align:center;color:#228f00;line-height:100%;border-right:4px solid #888" class="hide-after"><small><b>{{ \'ACTUAL\' | translate }}<br>{{ \'PRODUCTION\' | translate }}<br>({{ \'NO._OF_BATCH\' | translate }})</b></small></th><th style="text-align:center;width:70px;font-size:16pt"><a href="" ng-click="vm.selectAll()" title="Select ALL"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll()" title="De-select ALL" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th></tr><tr ng-if="vm.productDataFull.length==0 && !vm.isLoading"><td colspan="15" style="height:100px;line-height:100px"><center translate="NO_ANALYSIS_AVAILABLE">.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="15" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="GENERATING_ANALYSIS"></span> ...</b></center></big></td></tr><tr ng-repeat="item in vm.productDataFull" ng-if="!vm.isLoading"><td style="text-align:left">{{$index+1}})</td><td style="padding-top:8px;padding-bottom:6px;line-height:120%;border-right:4px solid #888"><b ng-bind-html="item.productName"></b><div ng-if="item.hasError"><i class="fa fa-exclamation-triangle text-danger"></i>&nbsp; <span class="text-danger" ng-bind-html="item.errorMessage"></span></div><div style="margin-top:5px"><a href="" class="btn btn-xs btn-default" style="background:#eee;font-size:9pt;" ng-if="item.salesOrderList.length!=0" ng-click="vm.viewSalesOrders(item.salesOrderList)"><i class="fa fa-eye"></i> &nbsp; <span translate="VIEW_DOCUMENTS"></span></a></div></td><td style="padding-top:8px;text-align:right;color:#000000;line-height:120%;border-right:1px solid #aaa"><b>{{item.salesQty}}</b> <small>{{item.salesUomName}}</small><br>(<b>{{item.salesQtyInv}}</b> <small>{{item.inventoryUomName}}</small>)</td><td style="padding-top:4px;text-align:right;color:#0000ff;border-right:1px solid #aaa"><b>{{item.inventoryQty}}</b> <small>{{item.inventoryUomName}}</small></td><td style="padding-top:4px;text-align:right;border-right:4px solid #888"><div style="color:#f00" ng-if="item.salesBalanceQtyInv!=0"><b>{{item.salesBalanceQtyInv}}</b> <small>{{item.inventoryUomName}}</small></div><div style="color:#000" ng-if="item.salesBalanceQtyInv==0"><b>{{item.salesBalanceQtyInv}}</b> <small>{{item.inventoryUomName}}</small></div></td><td style="padding-top:4px;text-align:right;color:#9f4f00;border-right:1px solid #aaa"><b>{{item.reOrderParLevel}}</b> <small>{{item.inventoryUomName}}</small></td><td style="padding-top:4px;text-align:right;color:#9f4f00;border-right:1px solid #aaa"><b>{{item.reOrderLevel}}</b> <small>{{item.inventoryUomName}}</small></td><td style="padding-top:4px;text-align:right;color:#9f4f00;border-right:4px solid #888"><b>{{item.reOrderQty}}</b> <small>{{item.salesUomName}}</small></td><td style="padding-top:4px;text-align:right;color:#cc00ff;line-height:130%;padding-top:5px;border-right:4px solid #888"><b>{{item.recipeProductionQty}}</b> <small>{{item.recipeProductionUomName}}</small><br><b>({{item.recipeProductionQtyInv}}</b> <small>{{item.inventoryUomName}}</small>)</td><td style="padding-top:4px;text-align:center;color:#ff7800;border-right:1px solid #aaa"><b>{{item.pendingJobBatch}}</b></td><td style="padding-top:4px;text-align:center;color:#0000ff;border-right:4px solid #888"><b>{{item.confirmedJobBatch}}</b></td><td style="padding-top:4px;text-align:center;color:#228f00;border-right:1px solid #aaa" nowrap="nowrap"><b>{{item.salesDate | date: "dd-MMM-yyyy" }}</b></td><td style="padding-top:4px;text-align:center;border-right:1px solid #aaa"><div style="color:#228f00" ng-if="item.recommendedBatchQuantity!=0"><b>{{item.recommendedBatchQuantity}}</b></div><div style="color:#000" ng-if="item.recommendedBatchQuantity==0">-</div></td><td style="padding-top:2px;text-align:center;border-right:4px solid #888"><div ng-hide="item.hasError"><div ng-hide="item.hasError" style="display: flex; align-items:center;"><span editable-text="item.recommendedBatchQuantity" e-name="recommendedBatchQuantity" e-form="vm.tableForm" e-style="width:60px;font-size:9pt;padding:3px 6px;background:#fffeed" e-min="1" onbeforesave="vm.checkValue(item.productId, $data)">{{ item.recommendedBatchQuantity || 1 }}</span> <button class="btn btn-info btn-with-icon" style="margin-left: 10px;" type="button" ng-click="vm.showSplitJobModal(item)"><i class="fa fa-list"></i></button></div></div></td><td style="padding-top:8px;text-align:center;"><input type="checkbox" style="cursor:pointer;width:25px;height:25px" ng-hide="item.hasError" checklist-model="vm.selectProductIds" checklist-value="item.productId"></td></tr></table></form></div></div></div></div></div></div><script type="text/ng-template" id="jaSalesOrderModal.html"><div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="SO_OR_ST_OR_PARENTJOB_LIST"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <table class="table table-hover table-striped" style="font-size:90%" st-pipe="$mdl.retrieveData" st-table="$mdl.salesData" refresh-table> <thead> <tr> <th colspan="5"> <div class="row"> <div class="col-lg-5" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search" class="input form-control" style="background:#fffeed" /> </div> </div> <div class="col-lg-7" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </div> </th> </tr> <tr> <th><b>{{ \'DOCUMENT_NO\' | translate }}.</b></th> <th><b>{{ \'CUSTOMER_NAME\' | translate }}.</b></th> <th><b>{{ \'DELIVERY_EXEC_DATE\' | translate }}<br /><small>(DD/MM/YYYY)</small></b></th> <th style="text-align:right"><b>{{ \'REQUIRED_QTY\' | translate }}</b></th> <th style="text-align:right"><b>({{ \'EQUIV.\' | translate }})&nbsp;{{ \'INVENTORY_QTY\' | translate }}</b></th> </tr> </thead> <tbody> <tr ng-repeat="item in $mdl.salesData"> <td><b>{{item.salesOrderNo}}</b></td> <td><b>{{item.customerName || \'-\'}}</b></td> <td><b>{{item.deliveryOrderDate || \'-\' | date:\'dd/MM/yyyy hh:mma\'}}</b></td> <td style="text-align:right"><b>{{item.orderQuantity | number}}</b> <small>{{item.orderUom}}</small></td> <td style="text-align:right"><b>{{item.inventoryQuantity | number}}</b> <small>{{item.inventoryUom}}</small></td> </tr> </tbody> </table> <br />&nbsp; </div> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div></script><script type="text/ng-template" id="dailyLimitErrorModal.html"><div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="DAILY_PRODUCTION_BATCH_LIMIT_EXCEEDED"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div ng-repeat="msg in $mdl.messageList"> <p>{{ "MAX_DAILY_PRODUCTION_FOR" | translate }} {{ msg.productName }}: {{ msg.dailyLimitBatch }}</p> <p>{{ "EXECUTION_DATE" | translate }}: {{ msg.jobDate | date:\'dd/MM/yyyy\'}}</p> <p>{{ "CURRENT_JOB_BATCH" | translate }}: {{ msg.currentJobBatch }}</p> <p>{{ "TOTAL_EXISTING_BATCH" | translate }}: {{ msg.totalExistingBatch }}</p> <p>{{ "EXISTING_PRODUCTION_JOB_PENDING_CONFIRMED" | translate }}:</p> <p ng-repeat="job in msg.existingProductionJobs"> {{ job.jobNo | uppercase }} ({{ job.quantity }}) </p> <hr> </div> <p>{{ "PROCEED_TO_CREATE_JOB" | translate }}</p> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.confirmModal()" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div></script><script type="text/ng-template" id="splitJobModal.html"><form name="$mdl.splitJobForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="SPLIT_JOB"></span></h3> </div> <div class="modal-body" id="modal-body"> <div style="color: #0000FF; margin-bottom: 10px;">{{$mdl.item.productName}}</div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SPLIT_JOB"></b>?</label> <div> <toggle ng-model="$mdl.item.isSplitJob" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> </div> <div class="row" ng-if="$mdl.item.isSplitJob"> <div class="col-lg-6 form-group"> <label> <b>{{ \'NUMBER_OF_SPLIT_JOBS\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" name="numberOfSplitJob" class="form-control" min=1 style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.numberOfSplitJob" ng-required="$mdl.item.isSplitJob" /> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.$submitted && $mdl.splitJobForm.numberOfSplitJob.$error.required">* {{ "REQUIRED" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.numberOfSplitJob.$error.number && $mdl.splitJobForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.numberOfSplitJob.$error.min && $mdl.splitJobForm.$submitted">* {{ "MINIMUM_VALUE_IS_1" | translate }}</p> </div> <div class="col-lg-6 form-group"> <label> <b>{{ \'NUMBER_OF_BATCH_PER_SPLIT_JOB\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" name="numberOfBatchPerSplitJob" class="form-control" min=1 style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.numberOfBatchPerSplitJob" ng-required="$mdl.item.isSplitJob" /> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.numberOfBatchPerSplitJob.$error.required && $mdl.splitJobForm.$submitted">* {{ "REQUIRED" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.numberOfBatchPerSplitJob.$error.number && $mdl.splitJobForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.numberOfBatchPerSplitJob.$error.min && $mdl.splitJobForm.$submitted">* {{ "MINIMUM_VALUE_IS_1" | translate }}</p> </div> </div> <div class="row" ng-if="$mdl.item.isSplitJob" style="margin-top: 10px"> <div class="col-lg-12 form-group"> <label><b>{{ \'FIRST_SPLIT_JOB_EXECUTION_DATE/TIME\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <div moment-picker="$mdl.item.firstSplitJobExecutionDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true"> <input type="text" class="form-control calendar" name="firstSplitJobExecutionDate" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.firstSplitJobExecutionDate" ng-required="$mdl.item.isSplitJob" /> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.firstSplitJobExecutionDate.$error.required && $mdl.splitJobForm.$submitted">* {{ "REQUIRED" | translate }}</p> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="submit" ng-click="$mdl.confirmModal()" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/iotsettings/settings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_NOTIFICATION_SETTINGS_WHEN_SENSOR_ALERT_IS_TRIGGERED"></span>.</small><br><br></p><div class="row"><div class="col-md-1 col-lg-1" style="padding-right:0px"><div class="form-group"><label><b translate="ENABLED"></b></label><div><toggle ng-model="vm.setting.triggerAlert" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-6 col-lg-6" ng-if="vm.setting.triggerAlert"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Email.$invalid && (vm.dataForm.Email.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_A_SENSOR"></b> &nbsp;(<span translate="OPTIONAL"></span>. <span translate="RECIPIENT_WILL_ONLY_RECEIVE_NOTIFICATION_FROM_THE_SELECTED_SENSOR"></span>)</label><div class="row"><div class="col-md-8 col-lg-8"><select name="Sensor" class="form-control" style="background:#FFFCED" ng-change="vm.selectedSensorChanged()" ng-options="s as (s.gatewayDescription + \' -> \' + s.description | uppercase) for s in vm.sensorList | orderBy:[\'gatewayDescription\',\'description\']" ng-model="vm.selectedSensor"><option value="">-- {{ \'SELECT_A_SENSOR\' | translate }} --</option></select></div><div class="col-md-4 col-lg-4" style="padding-left:0px"><a href="" class="btn btn-danger" ng-if="vm.selectedSensor!=null" ng-click="vm.clearSensor()">{{ "CLEAR" | translate}}</a></div></div></div></div></div><div class="row"><div class="col-md-1 col-lg-1" style="padding-right:0px"><div class="form-group"><label><b translate="EMAIL_ALERT"></b></label><div><toggle ng-model="vm.setting.alertByEmail" ng-change="changed()" on="ON" off="OFF" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-4 col-lg-4" ng-if="vm.setting.alertByEmail"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Email.$invalid && (vm.dataForm.Email.$dirty || vm.dataForm.$submitted)}"><label><b translate="EMAIL_ADDRESS"></b> <i class="fa fa-asterisk req"></i> &nbsp;(<span translate="USE_SEMI-COLON_TO_SPECIFY_MULTIPLE_EMAILS"></span>)</label> <input type="text" class="form-control" name="Email" placeholder="Email" ng-model="vm.setting.email" ng-required="vm.setting.alertByEmail"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3" ng-if="vm.setting.alertByEmail"><div class="form-group"><label><b>{{ \'BRANCH\' | translate }}</b> <i class="fa fa-asterisk req"></i> &nbsp;(<span translate="LEAVE_IT_BLANK_TO_RECEIVE_EMAIL_ALERT_FROM_ALL_BRANCHES"></span>)</label><select name="Branch" class="form-control" style="background:#FFFCED" ng-change="vm.selectBranch()" ng-options="b as b.name for b in vm.branches | orderBy:\'name\'" ng-model="vm.selectedBranch"><option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option></select></div></div><div class="col-md-2 col-lg-2" ng-if="vm.setting.alertByEmail && vm.selectedBranch!=null"><div class="form-group"><div style="height:21px"></div><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.clearBranch()"><i class="ion ion-close"></i> <span translate="CLEAR_BRANCH"></span></a></div></div></div><div class="row"><div class="col-md-1 col-lg-1" style="padding-right:0px"><div class="form-group"><label><b translate="PUSH_NOTIFICATION"></b></label><div><toggle ng-model="vm.setting.alertByPN" ng-change="changed()" on="ON" off="OFF" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-4 col-lg-4" ng-if="vm.setting.alertByPN"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.User.$invalid && (vm.dataForm.User.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_A_USER"></b> <i class="fa fa-asterisk req"></i> &nbsp;( <span translate="USER_WILL_RECEIVE_PUSH_NOTIFICATION_ON_MOBILE_APP"></span>)</label><select name="User" class="form-control" style="background:#FFFCED" ng-change="vm.selectUser()" ng-options="b as (b.firstName + \' \' + b.lastName | uppercase) for b in vm.users | orderBy:\'firstName\'" ng-model="vm.selectedUser" ng-required="vm.setting.alertByPN"><option value="">-- {{ \'SELECT_A_USER\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.User.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.setting.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_NOTIFICATION_SETTING"></span>.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br><span translate="THERE_IS_NO_CHANGES_YET"></span>.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/iotsettings/settings/settingCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/iotsettings/settings/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="iotsettings.settings.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/iotsettings/settings/settingList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="IotSettingListing" st-pipe="vm.retrieveData" st-table="vm.settingData" refresh-table=""><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Setting" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="iotsettings.settings.create" rms-check-access="iotsettings.settings" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_SETTING"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th rowspan="2" style="width:60px">#</th><th rowspan="2" style="width:100px;text-align:center" class="hide-after"><span translate="ENABLED"></span></th><th colspan="2" style="width:100px;text-align:center"><span translate="ALERT_METHOD"></span></th><th rowspan="2">&nbsp;</th><th rowspan="2" translate="TARGET_SENSOR"></th><th rowspan="2" translate="EMAIL"></th><th rowspan="2" translate="USER"></th><th rowspan="2" style="width:40px"></th><th rowspan="2" style="width:40px"></th></tr><tr class="sortable"><th class="hide-after" style="width:100px;text-align:center"><span translate="EMAIL"></span></th><th class="hide-after" style="width:100px;text-align:center;line-height:100%"><span translate="PUSH_NOTIFICATION"></span></th></tr></thead><tbody><tr ng-if="vm.settingData.length<=0 && !vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.settingData"><td>{{vm.startIndex+1+$index}})</td><td style="text-align:center"><i class="fa fa-check" ng-if="item.triggerAlert" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.triggerAlert" style="color:#f00"></i></td><td style="text-align:center"><i class="fa fa-check" ng-if="item.alertByEmail" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.alertByEmail" style="color:#f00"></i></td><td style="text-align:center"><i class="fa fa-check" ng-if="item.alertByPN" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.alertByPN" style="color:#f00"></i></td><td class="text-center" style="padding-top:1px;padding-bottom:8px;line-height:120%"><div class="report-type-tag" style="width:auto !important" nowrap="nowrap" ng-if="item.alertByEmail && item.branchName!=null">{{ item.branchName }}</div></td><td style="padding-top:8px;padding-bottom:8px;line-height:120%" nowrap="nowrap"><span ng-if="item.sensorName!=null">{{item.gatewayName | uppercase }} &nbsp;&rarr;&nbsp; {{item.sensorName | uppercase}}</span> <span ng-if="item.sensorName==null">-</span></td><td style="padding-top:8px;padding-bottom:8px;line-height:120%">{{item.email}}</td><td>{{item.username | uppercase}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="iotsettings.settings.update({id:item.id})" rms-check-access="iotsettings.settings" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Setting" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteSetting(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this setting?" rms-check-access="iotsettings.settings" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/iotsettings/settings/settingUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/iotsettings/settings/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="iotsettings.settings.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="iotsettings.settings.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/jobs/jobanalysisfg/jobanalysisfgList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="row" style="margin-bottom:10px"><div class="col-md-12 col-lg-12" style="height:35px;line-height:35px;text-align:right;color:#00f"><i class="fa fa-info-circle"></i> <span translate="SELECT_ONE_OR_MORE_ENTRIES_TO_GENERATE_JOBS"></span>.</div><div class="col-md-12 col-lg-12" style="height:35px"><div style="display:inline-block;float:left;margin-right:20px"><b>{{ \'SO_ST\' | translate}}</b><br><small>{{ \'DELIVERY_DATE\' | translate }}</small></div><div style="display:inline-block;float:left"><b>{{ \'START_DATE\' | translate }}:</b><br><small>(YYYY-MM-DD)</small></div><div style="display:inline-block;float:left;margin-left:7px"><div moment-picker="vm.startDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:170px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="StartDate" style="width:170px;background:#fffeed" ng-disabled="vm.isLoading" ng-model="vm.startDate" ng-readonly="true" required=""></div></div><div style="display:inline-block;float:left;margin-left:15px"><b>{{ \'END_DATE\' | translate }}:</b><br><small>(YYYY-MM-DD)</small></div><div style="display:inline-block;float:left;margin-left:7px;margin-right:20px"><div moment-picker="vm.endDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:170px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="EndDate" style="width:170px;background:#fffeed" ng-disabled="vm.isLoading" ng-model="vm.endDate" ng-readonly="true" required=""></div></div><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.refreshPage()" ng-if="!vm.isLoading"><i class="ion-refresh"></i> <span translate="LOAD_ANALYSIS"></span></a> <span>&nbsp;&nbsp;&nbsp;&nbsp; <span translate="ANALYSIS_TIME"></span>&nbsp;:&nbsp;<b>{{vm.timeTaken | number:0}}</b> <span translate="SECONDS"></span></span></div><div class="col-md-12 col-lg-12" style="height:35px; margin-top:20px" ng-show="vm.selectProductIds.length>0"><div style="display:inline-block;float:left;margin-right:12px"><b>{{ \'JOB_EXECUTION_DATE/TIME\' | translate }}:</b><br><small>(YYYY-MM-DD)</small></div><div style="display:inline-block;float:left;margin-left:7px;margin-right:20px"><div moment-picker="vm.executionDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group" style="width:170px !important"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="ExecutionDate" style="width:170px;background:#fffeed" ng-disabled="vm.isLoading" ng-model="vm.executionDate" ng-readonly="true" required=""></div></div><a href="" class="btn btn-success btn-with-icon" confirmed-click="vm.generateJobs()" ng-confirm-click="{{\'CONFIRM_PROCEED_TO_GENERATE_JOBS\' | translate }} ?" ng-if="!vm.isLoading" ng-show="vm.selectProductIds.length>0" rms-check-access="jobs.jobanalysisfg" rms-check-access-perm-type="CREATE"><i class="ion-checkmark-round"></i> <span translate="GENERATE_JOB"></span>(s)</a></div></div><div class="horizontal-scroll"><div class="form-group"><div class="form-inline"><form editable-form="" name="vm.tableForm"><table class="table table-bordered table-hover table-striped" style="font-size:90%"><tr><th style="width:50px;text-align:left">#</th><th style="border-right:4px solid #888" class="hide-after"><b>{{ \'PRODUCT_NAME\' | translate }}</b></th><th style="text-align:right;color:#000000;line-height:100%;border-right:1px solid #aaa"><b>{{ \'CONSOLIDATED\' | translate }}<br>{{ \'QUANTITY\' | translate }}</b></th><th style="text-align:right;color:#0000ff;line-height:100%;border-right:1px solid #aaa"><b>{{ \'INVENTORY\' | translate }}<br>{{ \'QUANTITY\' | translate }}</b></th><th style="text-align:right;color:#ff0000;line-height:100%;border-right:4px solid #888" class="hide-after"><b>{{ \'DIFFERENCE\' | translate }}<br>{{ \'QUANTITY\' | translate }}</b></th><th style="text-align:right;color:#9f4f00;line-height:100%;border-right:1px solid #aaa"><b>{{ \'PAR_LEVEL\' | translate }}</b></th><th style="text-align:right;color:#9f4f00;line-height:100%;border-right:1px solid #aaa"><b>{{ \'REORDER\' | translate }}<br>{{ \'LEVEL\' | translate }}</b></th><th style="text-align:right;color:#9f4f00;line-height:100%;border-right:4px solid #888" class="hide-after"><b>{{ \'REORDER\' | translate }}<br>{{ \'QUANTITY\' | translate }}</b></th><th style="text-align:right;color:#cc00ff;line-height:100%;border-right:4px solid #888" class="hide-after"><b>{{ \'RECIPE_YIELD\' | translate }}<br>{{ \'QTY_PER_BATCH\' | translate }}</b></th><th style="text-align:center;color:#ff7800;line-height:100%;border-right:1px solid #aaa" class="hide-after"><b>{{ \'NO_OF_PENDING_JOBS\' | translate }}</b></th><th style="text-align:center;color:#0000ff;line-height:100%;border-right:4px solid #888" class="hide-after"><b>{{ \'NO_OF_CONFIRMED_JOBS\' | translate }}</b></th><th style="text-align:center;color:#228f00;line-height:100%;border-right:1px solid #aaa"><b>{{ \'DELIVERY_DATE\' | translate }}<br>({{ \'LATEST\' | translate }})</b></th><th style="text-align:center;color:#228f00;line-height:100%;border-right:1px solid #aaa"><b>{{ \'RECOMMENDED\' | translate }}<br>{{ \'PRODUCTION\' | translate }}<br>({{ \'NO._OF_BATCH\' | translate }})</b></th><th style="text-align:center;color:#228f00;line-height:100%;border-right:4px solid #888" class="hide-after"><b>{{ \'ACTUAL\' | translate }}<br>{{ \'PRODUCTION\' | translate }}<br>({{ \'NO._OF_BATCH\' | translate }})</b></th><th style="text-align:center;width:70px;font-size:16pt"><a href="" ng-click="vm.selectAll()" title="Select ALL"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll()" title="De-select ALL" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th></tr><tr ng-if="vm.productDataFull.length==0 && !vm.isLoading"><td colspan="15" style="height:100px;line-height:100px"><center translate="NO_ANALYSIS_AVAILABLE">.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="15" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="GENERATING_ANALYSIS"></span> ...</b></center></big></td></tr><tr ng-repeat="item in vm.productDataFull" ng-if="!vm.isLoading"><td style="text-align:left">{{$index+1}})</td><td style="max-width:400px;padding-top:8px;padding-bottom:6px;line-height:120%;border-right:4px solid #888"><big><b>{{item.productName}}</b></big><div ng-if="item.hasError"><i class="fa fa-exclamation-triangle text-danger"></i>&nbsp; <span class="text-danger" ng-bind-html="item.errorMessage"></span></div><div style="margin-top:5px" ng-if="item.salesOrderList.length!=0"><a href="" class="btn btn-xs btn-default" style="background:#eee;font-size:9pt;" ng-if="item.salesOrderList.length!=0" ng-click="vm.viewSalesOrders(item.salesOrderList)"><i class="fa fa-eye"></i> &nbsp;<span translate="VIEW_DOCUMENTS"></span></a></div></td><td style="padding-top:8px;text-align:right;color:#000000;line-height:120%;border-right:1px solid #aaa"><b>{{item.salesQty}}</b> <small>{{item.salesUomName}}</small><br>(<b>{{item.salesQtyInv}}</b> <small>{{item.inventoryUomName}}</small>)</td><td style="padding-top:4px;text-align:right;color:#0000ff;border-right:1px solid #aaa"><b>{{item.inventoryQty}}</b> <small>{{item.inventoryUomName}}</small></td><td style="padding-top:4px;text-align:right;border-right:4px solid #888"><div style="color:#f00" ng-if="item.salesBalanceQtyInv!=0"><b>{{item.salesBalanceQtyInv}}</b> <small>{{item.inventoryUomName}}</small></div><div style="color:#000" ng-if="item.salesBalanceQtyInv==0"><b>{{item.salesBalanceQtyInv}}</b> <small>{{item.inventoryUomName}}</small></div></td><td style="padding-top:4px;text-align:right;color:#9f4f00;border-right:1px solid #aaa"><b>{{item.reOrderParLevel}}</b> <small>{{item.inventoryUomName}}</small></td><td style="padding-top:4px;text-align:right;color:#9f4f00;border-right:1px solid #aaa"><b>{{item.reOrderLevel}}</b> <small>{{item.inventoryUomName}}</small></td><td style="padding-top:4px;text-align:right;color:#9f4f00;border-right:4px solid #888"><b>{{item.reOrderQty}}</b> <small>{{item.salesUomName}}</small></td><td style="padding-top:4px;text-align:right;color:#cc00ff;line-height:130%;padding-top:5px;border-right:4px solid #888"><b>{{item.recipeProductionQty}}</b> <small>{{item.recipeProductionUomName}}</small><br><b>({{item.recipeProductionQtyInv}}</b> <small>{{item.inventoryUomName}}</small>)</td><td style="padding-top:4px;text-align:center;color:#ff7800;border-right:1px solid #aaa"><b>{{item.pendingJobBatch}}</b></td><td style="padding-top:4px;text-align:center;color:#0000ff;border-right:4px solid #888"><b>{{item.confirmedJobBatch}}</b></td><td style="padding-top:4px;text-align:center;color:#228f00;border-right:1px solid #aaa" nowrap="nowrap"><b>{{item.salesDate | date: "dd-MMM-yyyy" }}</b></td><td style="padding-top:4px;text-align:center;border-right:1px solid #aaa"><div style="color:#228f00" ng-if="item.recommendedBatchQuantity!=0"><b>{{item.recommendedBatchQuantity}}</b></div><div style="color:#000" ng-if="item.recommendedBatchQuantity==0">-</div></td><td style="padding-top:2px;text-align:center;border-right:4px solid #888"><div ng-hide="item.hasError" style="display: flex; align-items:center;"><span editable-text="item.recommendedBatchQuantity" e-name="recommendedBatchQuantity" e-form="vm.tableForm" e-style="width:60px;font-size:9pt;padding:3px 6px;background:#fffeed" e-min="1" onbeforesave="vm.checkValue(item.productId, $data)">{{ item.recommendedBatchQuantity || 1 }}</span> <button class="btn btn-info btn-with-icon" style="margin-left: 10px;" type="button" ng-click="vm.showSplitJobModal(item)"><i class="fa fa-list"></i></button></div></td><td style="padding-top:8px;text-align:center;"><input type="checkbox" style="cursor:pointer;width:25px;height:25px" ng-hide="item.hasError" checklist-model="vm.selectProductIds" checklist-value="item.productId"></td></tr></table></form></div></div></div></div></div></div><script type="text/ng-template" id="jaSalesOrderModal.html"><div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="SO_OR_ST_LIST"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <table class="table table-hover table-striped" style="font-size:90%" st-pipe="$mdl.retrieveData" st-table="$mdl.salesData" refresh-table> <thead> <tr> <th colspan="5"> <div class="row"> <div class="col-lg-5" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search" class="input form-control" style="background:#fffeed" /> </div> </div> <div class="col-lg-7" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </div> </th> </tr> <tr> <th><b>{{ \'DOCUMENT_NO\' | translate }}.</b></th> <th><b>{{ \'CUSTOMER_NAME\' | translate }}.</b></th> <th><b>{{ \'DELIVERY_DATE\' | translate }}<br /><small>(DD/MM/YYYY)</small></b></th> <th style="text-align:right"><b>{{ \'ORDER_QTY\' | translate }}</b></th> <th style="text-align:right"><b>({{ \'EQUIV.\' | translate }})&nbsp;{{ \'INVENTORY_QTY\' | translate }}</b></th> </tr> </thead> <tbody> <tr ng-repeat="item in $mdl.salesData"> <td><b>{{item.salesOrderNo}}</b></td> <td><b>{{item.customerName || \'-\'}}</b></td> <td><b>{{item.deliveryOrderDate || \'-\' | date:\'dd/MM/yyyy hh:mma\'}}</b></td> <td style="text-align:right"><b>{{item.orderQuantity | number}}</b> <small>{{item.orderUom}}</small></td> <td style="text-align:right"><b>{{item.inventoryQuantity | number}}</b> <small>{{item.inventoryUom}}</small></td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div></script><script type="text/ng-template" id="dailyLimitErrorModal.html"><div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="DAILY_PRODUCTION_BATCH_LIMIT_EXCEEDED"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div ng-repeat="msg in $mdl.messageList"> <p>{{ "MAX_DAILY_PRODUCTION_FOR" | translate }} {{ msg.productName }}: {{ msg.dailyLimitBatch }}</p> <p>{{ "EXECUTION_DATE" | translate }}: {{ msg.jobDate | date:\'dd/MM/yyyy\'}}</p> <p>{{ "CURRENT_JOB_BATCH" | translate }}: {{ msg.currentJobBatch }}</p> <p>{{ "TOTAL_EXISTING_BATCH" | translate }}: {{ msg.totalExistingBatch }}</p> <p>{{ "EXISTING_PRODUCTION_JOB_PENDING_CONFIRMED" | translate }}:</p> <p ng-repeat="job in msg.existingProductionJobs"> {{ job.jobNo | uppercase }} ({{ job.quantity }}) </p> <hr> </div> <p>{{ "PROCEED_TO_CREATE_JOB" | translate }}</p> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.confirmModal()" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div></script><script type="text/ng-template" id="splitJobModal.html"><form name="$mdl.splitJobForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="SPLIT_JOB"></span></h3> </div> <div class="modal-body" id="modal-body"> <div style="color: #0000FF; margin-bottom: 10px;">{{$mdl.item.productName}}</div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SPLIT_JOB"></b>?</label> <div> <toggle ng-model="$mdl.item.isSplitJob" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> </div> <div class="row" ng-if="$mdl.item.isSplitJob"> <div class="col-lg-6 form-group"> <label> <b>{{ \'NUMBER_OF_SPLIT_JOBS\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" name="numberOfSplitJob" class="form-control" min=1 style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.numberOfSplitJob" ng-required="$mdl.item.isSplitJob" /> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.$submitted && $mdl.splitJobForm.numberOfSplitJob.$error.required">* {{ "REQUIRED" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.numberOfSplitJob.$error.number && $mdl.splitJobForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.numberOfSplitJob.$error.min && $mdl.splitJobForm.$submitted">* {{ "MINIMUM_VALUE_IS_1" | translate }}</p> </div> <div class="col-lg-6 form-group"> <label> <b>{{ \'NUMBER_OF_BATCH_PER_SPLIT_JOB\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" name="numberOfBatchPerSplitJob" class="form-control" min=1 style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.numberOfBatchPerSplitJob" ng-required="$mdl.item.isSplitJob" /> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.numberOfBatchPerSplitJob.$error.required && $mdl.splitJobForm.$submitted">* {{ "REQUIRED" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.numberOfBatchPerSplitJob.$error.number && $mdl.splitJobForm.$submitted">* {{ "KEY_IN_NUMBERS_ONLY" | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.numberOfBatchPerSplitJob.$error.min && $mdl.splitJobForm.$submitted">* {{ "MINIMUM_VALUE_IS_1" | translate }}</p> </div> </div> <div class="row" ng-if="$mdl.item.isSplitJob" style="margin-top: 10px"> <div class="col-lg-12 form-group"> <label><b>{{ \'FIRST_SPLIT_JOB_EXECUTION_DATE/TIME\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <div moment-picker="$mdl.item.firstSplitJobExecutionDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true"> <input type="text" class="form-control calendar" name="firstSplitJobExecutionDate" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.firstSplitJobExecutionDate" ng-required="$mdl.item.isSplitJob" /> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.splitJobForm.firstSplitJobExecutionDate.$error.required && $mdl.splitJobForm.$submitted">* {{ "REQUIRED" | translate }}</p> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="submit" ng-click="$mdl.confirmModal()" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/jobs/joblist/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-show="vm.originalStatus==0"><small><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_JOB_DETAILS_BELOW"></span>.</small><br><br></p><p ng-show="vm.originalStatus!=0"><small><i class="fa fa-warning"></i> <span translate="ALL_THE_FIELDS_WILL_BE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_JOB_STATUS_IS_NO_LONGER"></span> <b translate="PENDING"></b>.</small><br><br></p><div class="row"><div class="col-md-5 col-lg-5" style="margin-right:40px"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="JOB_NUMBER"></b></label> <input type="text" class="form-control" placeholder="{{ \'AUTONUMBER\' | translate }}" ng-model="vm.job.jobNo" ng-disabled="true"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="BATCH_NUMBER"></b></label> <input type="text" class="form-control" placeholder="{{ \'AUTONUMBER\' | translate }}" ng-model="vm.job.batchNo" ng-disabled="true"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Branch.$invalid && (vm.dataForm.Branch.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'BRANCH\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="Branch" class="form-control" ng-change="vm.selectedBranchChanged()" ng-model="vm.selectedBranch" ng-options="i as i.name for i in vm.branchList" ng-disabled="vm.originalStatus!=0" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Branch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Branch.$invalid && (vm.dataForm.Branch.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b>{{ \'JOB_STATUS\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="Branch" class="form-control" ng-change="vm.selectedStatusChanged()" ng-model="vm.selectedStatus" ng-options="i as i.name for i in vm.statusList" ng-disabled="vm.originalStatus!=0" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Branch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.JobDate.$invalid && (vm.dataForm.JobDate.$dirty || vm.dataForm.$submitted)}"><label for="JobDate"><b translate="JOB_EXECUTION_DATE/TIME"></b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.job.jobDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group"><input type="text" class="form-control calendar" name="JobDate" placeholder="YYYY-MM-DD" ng-disabled="vm.originalStatus!=0" ng-model="vm.job.jobDate"></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.JobDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UserGroup.$invalid && (vm.dataForm.UserGroup.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="EXECUTE_BY"></span> (<span translate="USERGROUP"></span>)</b> <i class="fa fa-asterisk req"></i></label><select name="UserGroup" class="form-control" ng-disabled="vm.originalStatus!=0" ng-model="vm.selectedUserGroup" ng-options="i as (i.name | uppercase) for i in vm.usergroups" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UserGroup.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" style="color:#333" ng-disabled="vm.originalStatus!=0 || (vm.selectedSemiFg!=null && !vm.isSemiFgRecipeOk) || (vm.selectedProduct!=null && !vm.isProductRecipeOk)" ng-model="vm.job.remarks">\n\t\t\t\t\t\t\t\t\t</textarea></div></div></div></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-12 col-lg-12"><br><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="vm.activeTab"><uib-tab heading="{{ \'FINISHED_GOODS\' | translate }}" ng-if="vm.originalStatus==0 || (vm.originalStatus!=0 && vm.selectedProduct!=null)"><div class="form-group"><button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" title="Clear Selection" style="margin-bottom:5px" ng-if="vm.selectedProduct!=null && vm.originalStatus==0" ng-click="vm.clearProductSelection()"><i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }}</button> <label><small><i class="fa fa-info-circle"></i> <span translate="ENTER_KEYWORD_TO_SEARCH_FOR_FINISHED_GOODS"></span></small></label><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.selectedProduct==null && $tabSetStatus.activeTab==0 && vm.dataForm.$submitted}"><ui-select name="Finished Goods" ng-model="vm.selectedProduct" class="btn-group bootstrap-select form-control" ng-disabled="vm.originalStatus!=0" append-to-body="true" search-enabled="true" on-select="vm.selectedProductChanged()" ng-required="$tabSetStatus.activeTab==0" style="background:#fff"><ui-select-match placeholder="{{ \'ENTER_KEYWORD_TO_SEARCH\' | translate }}"><span>{{ $select.selected.name }}</span></ui-select-match><ui-select-choices repeat="p in vm.productList | filter: $select.search" refresh="vm.loadProducts($select.search)" refresh-delay="250" minimum-input-length="3"><span ng-bind-html="p.name | highlight: $select.search"></span></ui-select-choices></ui-select><small ng-show="vm.job.productId!=\'\' && vm.job.productId!=null && !vm.isProductRecipeOk" style="color:#f00"><i class="fa fa-exclamation-triangle"></i> <span translate="THERE_IS_NO_RECIPE_ASSOCIATED_WITH_THE_SELECTED_FINISHED_GOODS"></span></small> <span class="help-block" ng-show="vm.selectedProduct==null && $tabSetStatus.activeTab==0 && vm.dataForm.$submitted">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div></uib-tab><uib-tab heading="{{ \'SEMI_FINISHED_GOODS\' | translate }}" ng-if="vm.hasSemiFgAccess && (vm.originalStatus==0 || (vm.originalStatus!=0 && vm.selectedSemiFg!=null))"><div class="form-group" ng-if="vm.hasSemiFgAccess"><button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" title="Clear Selection" style="margin-bottom:5px" ng-if="vm.selectedSemiFg!=null && vm.originalStatus==0" ng-click="vm.clearSemiFgSelection()"><i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }}</button> <label><small><i class="fa fa-info-circle"></i> <span translate="ENTER_KEYWORD_TO_SEARCH_FOR_SEMI_FINISHED_GOODS"></span></small></label><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.selectedSemiFg==null && $tabSetStatus.activeTab==1 && vm.dataForm.$submitted}"><ui-select name="Semi Finished Goods" ng-model="vm.selectedSemiFg" class="btn-group bootstrap-select form-control" ng-disabled="vm.originalStatus!=0" append-to-body="true" search-enabled="true" on-select="vm.selectedSemiFgChanged()" ng-required="$tabSetStatus.activeTab==1" style="background:#fff"><ui-select-match placeholder="{{ \'ENTER_KEYWORD_TO_SEARCH\' | translate }}"><span>{{ $select.selected.description }}</span></ui-select-match><ui-select-choices repeat="i in vm.semiFgList | filter: $select.search" refresh="vm.loadSemiFgList($select.search)" refresh-delay="250" minimum-input-length="2"><span ng-bind-html="i.description | highlight: $select.search"></span></ui-select-choices></ui-select><small ng-show="vm.job.semiFinishedProductId!=\'\' && vm.job.semiFinishedProductId!=null && !vm.isSemiFgRecipeOk" style="color:#f00"><i class="fa fa-exclamation-triangle"></i> <span translate="THERE_IS_NO_RECIPE_ASSOCIATED_WITH_THE_SELECTED_SEMI_FINISHED_GOODS"></span></small> <span class="help-block" ng-show="vm.selectedSemiFg==null && $tabSetStatus.activeTab==1 && vm.dataForm.$submitted">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div></uib-tab></uib-tabset></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity.$invalid && (vm.dataForm.Quantity.$dirty || vm.dataForm.$submitted)}"><label for="Quantity"><b translate="NO._OF_BATCH"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity" placeholder="No. of Batch (Quantity)" ng-disabled="vm.originalStatus!=0 || (vm.selectedSemiFg!=null && !vm.isSemiFgRecipeOk) || (vm.selectedProduct!=null && !vm.isProductRecipeOk)" ng-model="vm.job.quantity" min="0.1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.min">* {{ \'MINIMUM_IS_0.1\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label for="Quantity"><b translate="EXPECTED_PRODUCTION_QUANTITY"></b></label> <span class="form-control" ng-disabled="true"><b>{{vm.job.estimatedProductionQuantity}} {{vm.job.uomName | uppercase}}</b></span></div></div></div></div></div><div class="row"><div class="col-md-12"><hr></div></div><div class="row"><div class="col-md-3 col-lg-3" ng-if="vm.job.createdBy"><div class="form-group"><label><b>{{ \'CREATED_BY\' | translate }}</b></label><br><span>{{vm.job.createdBy | uppercase}}<br>{{ \'DATE:\' | translate }} {{ vm.job.createdDate | date:\'dd/MM/yyyy\' }}</span></div></div><div class="col-md-3 col-lg-3" ng-if="vm.job.modifiedBy"><div class="form-group"><label><b>{{ \'MODIFIED_BY\' | translate }}</b></label><br><span>{{vm.job.modifiedBy | uppercase}}<br>{{ \'DATE:\' | translate }} {{ vm.job.modifiedDate | date:\'dd/MM/yyyy\' }}</span></div></div><div class="col-md-3 col-lg-3" ng-if="vm.job.startBy"><div class="form-group"><label><b>{{ \'STARTED_BY\' | translate }}</b></label><br><span>{{vm.job.startBy | uppercase}}<br>{{ \'DATE:\' | translate }} {{ vm.job.startDate | date:\'dd/MM/yyyy\' }}</span></div></div><div class="col-md-3 col-lg-3" ng-if="vm.job.completedBy"><div class="form-group"><label><b>{{ \'COMPLETED_BY\' | translate }}</b></label><br><span>{{vm.job.completedBy | uppercase}}<br>{{ \'DATE:\' | translate }} {{ vm.job.completedDate | date:\'dd/MM/yyyy\' }}</span></div></div></div><div class="row" ng-if="vm.originalStatus==3 || vm.originalStatus==4"><div class="col-md-12"><hr></div></div><div class="row" ng-if="vm.originalStatus==3 || vm.originalStatus==4"><div class="col-md-12"><div class="row"><div class="col-lg-5" style="margin-right:40px"><br><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><div style="padding:15px;background:#{{ vm.job.status==4?\'ffffdd\':\'e0ffe0\' }}"><legend style="height:32.4px;line-height:32.4px">{{ \'COMPLETION_DETAILS\' | translate }}</legend><div class="row"><div class="col-lg-12"><div class="form-group"><div class="row"><div class="col-lg-12"><label><b>{{ \'COMPLETION_STATUS\' | translate }}</b></label><h3><b>{{vm.statusList[vm.job.status].label | uppercase | translate }}</b></h3></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><div class="row"><div class="col-md-6 col-lg-6"><label><b>{{ \'FINAL_YIELD\' | translate }}</b></label> <span class="form-control"><b>{{vm.job.actualProductionQuantity}} {{vm.recipe.uomName | uppercase}}</b></span></div><div class="col-md-6 col-lg-6" ng-if="vm.originalStatus==4"><label class="text-danger"><b>{{ \'SHRINKAGE\' | translate }}</b></label> <span class="form-control" style="background:#e800004d"><b>{{vm.job.actualDefectQuantity}} {{vm.recipe.uomName | uppercase}}</b></span></div></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-if="vm.originalStatus==4"><label class="text-danger"><b>{{ \'REASON_OF_SHRINKAGE\' | translate }}</b></label><div class="form-control text-danger">{{vm.job.failureReason || \'-\'}}</div></div></div></div></div></div></div><div class="col-lg-5"><br><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><div style="padding:15px;background:#eefaff"><legend style="height:32.4px;line-height:32.4px">Additional Completion Details</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Cooking Temperature (\xB0C)</b></label> <span class="form-control"><b>{{vm.job.cookingTemperature || \'-\'}}</b></span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Blast Freeze Temperature (\xB0C)</b></label> <span class="form-control"><b>{{vm.job.blastFreezeTemperature || \'-\'}}</b></span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Oil Temperature (\xB0C)</b></label> <span class="form-control"><b>{{vm.job.oilTemperature || \'-\'}}</b></span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Oil TPM</b></label> <span class="form-control"><b>{{vm.job.oilTPM || \'-\'}}</b></span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Brix Sugar Level</b></label> <span class="form-control"><b>{{vm.job.brixSugarLevel || \'-\'}}</b></span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Salt Level</b></label> <span class="form-control"><b>{{vm.job.saltLevel || \'-\'}}</b></span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>pH Level</b></label> <span class="form-control"><b>{{vm.job.phLevel || \'-\'}}</b></span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Viscosity</b></label> <span class="form-control"><b>{{vm.job.viscosity || \'-\'}}</b></span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Production Photos</b></label><div ng-if="vm.job.photoAttachment==\'\' || vm.job.photoAttachment==null">n/a</div><div><a href="" class="btn btn-default btn-sm" ng-if="vm.job.photoAttachment!=\'\' && vm.job.photoAttachment!=null" ng-click="vm.viewPhotos()">Click to View</a></div></div></div></div></div></div></div></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p><p>&nbsp;</p></div></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="confirmModal.html"><form name="$mdl.confirmForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="COMPLETE_JOB"></span>: {{$mdl.item.jobNo}} <span ng-if="$mdl.isLoading"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </span> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b><span translate="PRODUCT_NAME"></span></b></label> <span class="form-control" ng-disabled="true" style="height:auto;font-size:16pt;color:#000"> <b>{{ $mdl.item.productName || $mdl.item.semiFgName}}</b> </span> </div> </div> </div> <!-- <div class="row" ng-if="$mdl.isRmsLite!=null && $mdl.isRmsLite"> <div class="col-lg-9"> <div class="form-group"> <label><b><span translate="ACTUAL_PRODUCTION_QUANTITY"></span></b> <i class="fa fa-asterisk req"></i></label> <div class="row"> <div class="col-lg-6" style="padding-right:0px"> <input type="number" class="form-control" name="Quantity" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.item.actualProductionQuantity" min="1" required /> </div> <div class="col-lg-4" style="padding-left:5px"> <span class="form-control" ng-disabled="true" style="height:auto;font-size:16pt;color:#000"><b> {{$mdl.job.packingUom}} </b></span> </div> </div> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.required">* <span style="color:#f00" translate="REQUIRED"></span></span> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.number">* <span style="color:#f00" translate="KEY_IN_NUMBERS_ONLY"></span></span> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.min">* <span style="color:#f00" translate="MINIMUM_QUANTITY_IS_1"></span></span> </div> </div> </div> --> <!-- <div class="row" ng-if="!$mdl.isRmsLite"> --> <div class="row"> <div class="col-lg-6"> <div class="form-group"> <label><b><span translate="ESTIMATED_PRODUCTION_QUANTITY"></span></b></label> <div class="row"> <div class="col-lg-6" style="padding-right:0px"> <span class="form-control" ng-disabled="true" style="height:auto;font-size:16pt;color:#000"> <b>{{$mdl.item.estimatedProductionQuantity}}</b> </span> </div> <div class="col-lg-6" style="padding-left:5px"> <span class="form-control" ng-disabled="true" style="height:auto;font-size:16pt;color:#000"> <b>{{$mdl.item.uomName}}</b> </span> </div> </div> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b><span translate="ACTUAL_PRODUCTION_QUANTITY"></span></b> <i class="fa fa-asterisk req"></i></label> <div class="row"> <div class="col-lg-6" style="padding-right:0px"> <input type="number" class="form-control" name="Quantity" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.item.actualProductionQuantity" min="1" required /> </div> <div class="col-lg-6" style="padding-left:5px"> <span class="form-control" ng-disabled="true" style="height:auto;font-size:16pt;color:#000"> <b>{{$mdl.item.uomName}}</b> </span> </div> </div> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.required">* <span style="color:#f00" translate="REQUIRED"></span></span> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.number">* <span style="color:#f00" translate="KEY_IN_NUMBERS_ONLY"></span></span> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.min">* <span style="color:#f00" translate="MINIMUM_QUANTITY_IS_1"></span></span> </div> </div> </div> <div class="row" ng-if="$mdl.item.actualProductionQuantity!=null && ($mdl.item.actualProductionQuantity<$mdl.item.packingQty)"> <div class="col-lg-12"> <div class="form-group"> <label><b>Reason of Shrinkage</b> <i class="fa fa-asterisk req" ng-if="$mdl.item.actualProductionQuantity<$mdl.item.packingQty"></i> </label> <input type="text" class="form-control" name="ReasonOfShrinkage" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.item.failureReason" ng-required="$mdl.item.actualProductionQuantity<$mdl.item.packingQty" /> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.ReasonOfShrinkage.$error.required"> * {{ "REQUIRED" | translate}} </span> </div> </div> </div> <hr ng-if="!$mdl.isRmsLite" /> <div class="row" ng-if="!$mdl.isRmsLite"> <div class="col-lg-6"> <div class="form-group"> <label><b>Cooking Temperature (\xB0C)</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.cookingTemperature" /> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>Blast Freeze Temperature (\xB0C)</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.blastFreezeTemperature" /> </div> </div> </div> <div class="row" ng-if="!$mdl.isRmsLite"> <div class="col-lg-6"> <div class="form-group"> <label><b>Oil Temperature (\xB0C)</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.oilTemperature" /> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>Oil TPM</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.oilTPM" /> </div> </div> </div> <div class="row" ng-if="!$mdl.isRmsLite"> <div class="col-lg-6"> <div class="form-group"> <label><b>Brix Sugar Level</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.brixSugarLevel" /> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>Salt Level</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.saltLevel" /> </div> </div> </div> <div class="row" ng-if="!$mdl.isRmsLite"> <div class="col-lg-6"> <div class="form-group"> <label><b>pH Level</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.phLevel" /> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>Viscosity</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.viscosity" /> </div> </div> </div> </div> <hr /> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="$mdl.isLoading"> <i class="ion ion-checkmark"></i> <span translate="COMPLETE_JOB"></span> </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.isLoading"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="photoModal.html"><form name="$mdl.itemForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> Production Photos </h3> </div> <div class="modal-body" id="modal-body"> <div style="margin-bottom:10px;background:#333;height:350px;"> <center> <img ng-src="{{$mdl.selectedPhoto}}" align="center" style="height:350px" /> </center> </div> <div style="overflow-x:auto"> <img ng-src="{{$mdl.rootUrl}}{{i}}" ng-repeat="i in $mdl.photoArray" style="max-width:150px;max-height:80px;margin-right:5px;border:1px solid #000;cursor:pointer" ng-click="$mdl.selectPhoto(i)" /> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script><script type="text/ng-template" id="dailyLimitErrorModal.html"><div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="DAILY_PRODUCTION_BATCH_LIMIT_EXCEEDED"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <p>{{ "MAX_DAILY_PRODUCTION_FOR" | translate }} {{ $mdl.messageList.productName }}: {{ $mdl.messageList.dailyLimitBatch }}</p> <p>{{ "EXECUTION_DATE" | translate }}: {{ $mdl.date | date:\'dd/MM/yyyy\'}}</p> <p>{{ "CURRENT_JOB_BATCH" | translate }}: {{ $mdl.messageList.currentJobBatch }}</p> <p>{{ "TOTAL_EXISTING_BATCH" | translate }}: {{ $mdl.messageList.totalExistingBatch }}</p> <p>{{ "EXISTING_PRODUCTION_JOB_PENDING_CONFIRMED" | translate }}:</p> <p ng-repeat="job in $mdl.messageList.existingProductionJobs"> {{ job.jobNo | uppercase }} ({{ job.quantity }}) </p> <br> <p>{{ "PROCEED_TO_SKIP_DAILY_LIMIT_CHECKING" | translate }}</p> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.confirmModal()" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div></script>');
$templateCache.put('app/pages/jobs/joblist/joblistCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/jobs/joblist/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_JOB"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="jobs.joblist" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/jobs/joblist/joblistList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" style="font-size:90%" st-persist="ProductionJobListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table=""><thead><tr><th colspan="16" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_CLOSED_DOCUMENTS\' | translate }}</option><option value="1">{{ \'SHOW_ALL_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-5" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="jobs.joblist.create" ng-if="!vm.showCjsPanel && !vm.showUpdatePanel" rms-check-access="jobs.joblist" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_JOB"></span></a>&nbsp; <a href="" class="btn btn-success btn-with-icon" ng-if="!vm.showCjsPanel && !vm.showUpdatePanel" ng-click="vm.showPrintScheduleDialog()" rms-check-access="jobs.joblist" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i><span translate="PRINT_SCHEDULE"></span></a>&nbsp; <a href="" class="btn btn-warning btn-with-icon" ng-if="!vm.showCjsPanel && !vm.showUpdatePanel" ng-click="vm.showGenerateCJSPanel()" rms-check-access="jobs.joblist" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <span translate="GENERATE_CJS"></span></a>&nbsp; <a href="" class="btn btn-warning btn-with-icon" ng-if="!vm.showCjsPanel && !vm.showUpdatePanel" ng-click="vm.showBulkUpdatePanel()" rms-check-access="jobs.joblist" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i> <span translate="BULK_UPDATE"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-1" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr ng-if="vm.showCjsPanel"><th colspan="16" style="background:#fffc00;"><b>{{ \'SELECT_ONE_OR_MORE_JOBS_TO_GENERATE_THE_CONSOLIDATED_JOB_SHEET_SUMMARY\' | translate }} &nbsp;({{ vm.selectedJobs.length }} selected)&nbsp;&nbsp;&nbsp;</b> <button type="button" class="btn btn-primary btn-sm" ng-click="vm.printCJS()">{{ \'CONFIRM\' | translate }}</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.closeGenerateCJSPanel()">{{ \'CANCEL\' | translate }}</button></th></tr><tr ng-if="vm.showUpdatePanel"><th colspan="16" style="background:#fffc00;"><b>{{ \'SELECT_ONE_OR_MORE_PRODUCTION_JOB_TO_UPDATE_STATUS\' | translate }} &nbsp;({{ vm.selectedProductionJobs.length }} selected)&nbsp;&nbsp;&nbsp;</b> <button type="button" class="btn btn-primary btn-sm" style="margin-right:15px" rms-check-access="jobs.joblist" rms-check-access-perm-type="UPDATE" ng-click="vm.bulkUpdateConfimed()">{{ \'UPDATE_STATUS_TO_CONFIRMED\' | translate }}</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.closeBulkUpdatePanel()">{{ \'CANCEL\' | translate }}</button></th></tr><tr class="sortable"><th style="width:60px">#</th><th ng-if="vm.showCjsPanel" class="hide-after"></th><th ng-if="vm.showUpdatePanel" class="hide-after"></th><th st-sort="jobNo">{{ \'JOB_NO\' | translate }}.</th><th st-sort="jobDate">{{ \'EXEC._DATE\' | translate }}<br><small>(DD/MM/YYYY)</small></th><th st-sort="branchName">{{ \'BRANCH\' | translate }}</th><th></th><th>{{ \'PRODUCT_NAME\' | translate }}</th><th style="text-align:center !important" class="hide-after"><span translate="QUANTITY"></span><br><small>(<span translate="BATCH"></span>)</small></th><th st-sort="status" st-sort-default="reverse">{{ \'STATUS\' | translate }}</th><th st-sort="createdBy">{{ \'CREATED_BY\' | translate }}</th><th st-sort="actionBy">{{ \'EXECUTE_BY\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th ng-if="vm.showCjsPanel" class="hide-after" style="text-align:center;width:50px;font-size:16pt"><a href="" ng-click="vm.selectAllCjs()" title="Select ALL"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAllCjs()" title="De-select ALL" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th><th ng-if="vm.showUpdatePanel" class="hide-after" style="text-align:center;width:50px;font-size:16pt"><a href="" ng-click="vm.selectAllJobs()" title="Select ALL"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAllJobs()" title="De-select ALL" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th><th class="form-inline" colspan="2"><input st-search="jobNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="branchName" class="form-control input input-sm" style="width:120px"></th><th></th><th class="form-inline"><input st-search="productName" class="form-control input input-sm" style="width:120px"></th><th></th><th class="form-inline"><select st-search="status" class="form-control input input-sm" style="width:120px"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.statusList" value="{{ s.id }}">{{ s.label | translate | uppercase }}</option></select></th><th class="form-inline"><input st-search="createdBy" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="actionBy" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="16" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-if="vm.data.length<=0 && !vm.isLoading"><td colspan="16" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td ng-if="vm.showCjsPanel" style="background:#fffc00;width:50px;text-align:center"><div class="checkbox checkbox-primary checkbox-inline" style="margin-top:4px;margin-bottom:6px"><input type="checkbox" name="jobNo" checklist-model="vm.selectedJobs" checklist-value="item.id" checklist-change="vm.dataForm.cate.$setValidity(\'required\', vm.selectedJobs.length > 0)" ng-required="!vm.selectedJobs.length"> <label>&nbsp;</label></div></td><td ng-if="vm.showUpdatePanel" style="background:#fffc00;width:50px;text-align:center"><div class="checkbox checkbox-primary checkbox-inline" style="margin-top:4px;margin-bottom:6px"><input type="checkbox" name="jobNo" checklist-model="vm.selectedProductionJobs" checklist-value="item.id" checklist-change="vm.dataForm.cate.$setValidity(\'required\', vm.selectedProductionJobs.length > 0)" ng-required="!vm.selectedProductionJobs.length"> <label>&nbsp;</label></div></td><td nowrap="nowrap">{{item.jobNo}}</td><td nowrap="nowrap">{{item.jobDate | date: "dd/MM/yyyy hh:mma" }}</td><td nowrap="nowrap">{{item.branchName || \'-\' | uppercase }}</td><td class="text-center" style="width:80px;line-height:90%"><div class="report-type-tag"><b>{{item.productType}}</b></div></td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{item.productName}}</td><td class="text-center" style="width:80px;line-height:90%"><div class="report-type-tag"><b style="font-size:120%;color:#00f">{{item.quantity}}</b></div></td><td><b><span ng-if="item.status==\'PENDING\'" class="text-warning">{{item.status | translate | uppercase}}</span> <span ng-if="item.status==\'CONFIRMED\'" class="text-info">{{item.status | translate | uppercase}}</span> <span ng-if="item.status==\'IN PROGRESS\'" class="text-success">{{item.status.replace(\' \',\'_\') | translate | uppercase}}</span> <span ng-if="item.status.indexOf(\'COMPLETED\')!=-1" style="color:#000">{{item.status.replace(\' \',\'_\').replace(\'(VARIANCE)\',\'VARIANCE\') | translate | uppercase}}</span> <span ng-if="item.status==\'CANCELLED\'" class="text-danger">{{item.status | translate | uppercase}}</span></b></td><td style="padding-top:8px;padding-bottom:8px;line-height:120%">{{item.createdBy}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:120%">{{item.actionBy}}</td><td align="center"><a href="" title="Show Labels" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt" ng-if="!vm.isRmsLite && !vm.isRmsStarter && item.status.indexOf(\'COMPLETED\')!=-1 && !vm.showCjsPanel && !vm.showUpdatePanel" ng-click="vm.showLabelModal(item)"><i class="fa fa-tags text-primary"></i></a></td><td align="center"><a href="" title="Print Traceability Report" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt" ng-if="!vm.isRmsLite && !vm.isRmsStarter && item.status.indexOf(\'COMPLETED\')!=-1 && !vm.showCjsPanel && !vm.showUpdatePanel" ng-click="vm.printJobTrace(item.id, item.jobNo)" rms-check-access="jobs.joblist" rms-check-access-perm-type="EXPORT"><i class="fa fa-file-text text-success"></i></a></td><td align="center"><a href="" title="Print Jobsheet" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#00f" ng-if="item.status!=\'PENDING\' && item.status!=\'CANCELLED\' && !vm.showCjsPanel && !vm.showUpdatePanel" ng-click="vm.printJobSheet(item.id, item.jobNo)" rms-check-access="jobs.joblist" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="jobs.joblist.update({id:item.id})" ng-if="!vm.showCjsPanel && !vm.showUpdatePanel" rms-check-access="jobs.joblist" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="16" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="printModal.html"><form name="$mdl.printForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="PRINT_PRODUCTION_SCHEDULE"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.printForm.Year.$invalid && $mdl.printForm.$submitted}"> <label><b translate="YEAR">:</b> </label> <input type="number" class="form-control" name="Year" style="background:#FFFCED" ng-model="$mdl.year" min=2018 required /> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.Year.$error.required && $mdl.printForm.$submitted">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.Year.$error.number && $mdl.printForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.Year.$error.min && $mdl.printForm.$submitted">* <span translate="MINIMUM_IS_2018"></span></span> </div> </div> </div> <div class="row"> <div class="col-lg-7" style="padding-right:0px"> <div class="form-group" ng-class="{\'has-error\': $mdl.printForm.WeekNo.$invalid && $mdl.printForm.$submitted}"> <label><b translate="WEEK_NUMBER">:</b> </label> <input type="number" class="form-control" name="WeekNo" style="background:#FFFCED" ng-model="$mdl.weekNo" min=1 max=53 required /> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.WeekNo.$error.required && $mdl.printForm.$submitted">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.WeekNo.$error.number && $mdl.printForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.WeekNo.$error.min && $mdl.printForm.$submitted">* <span translate="MINIMUM_IS_1"></span></span> <span class="help-block" style="color:#f00" ng-show="$mdl.printForm.WeekNo.$error.max && $mdl.printForm.$submitted">* <span translate="MAXIMUM_IS_53"></span></span> </div> </div> <div class="col-lg-5"> <label>&nbsp;</label><br /> <a href class="btn btn-success" ng-click="$mdl.addWeek(1)"> <i class="fa fa-plus"></i> </a> <a href class="btn btn-danger" ng-click="$mdl.addWeek(-1)"> <i class="fa fa-minus"></i> </a> </div> </div> </div> <div class="modal-footer"> <hr /> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> <div ng-if="$mdl.lockButton" style="text-align:right:color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b><span translate="PROCESSING"></span> ...</b> </div> </div> </form></script><script type="text/ng-template" id="labelModal.html"><form name="$mdl.stepForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:80%" st-pipe="$mdl.retrieveData" st-table="$mdl.mvmtData" refresh-table> <thead> <tr> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.item.jobNo}} </div> <span translate="LABEL_LIST"></span> </h3> </div> </th> </tr> <tr> <th colspan="4" style="padding-left:0px;padding-right:0px"> <div class="col-md-4 col-lg-4" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Label" class="input form-control" /> </div> </div> <div class="col-md-8 col-lg-8" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr> <th><b translate="CODE"></b></th> <th><b translate="DESCRIPTION"></b></th> <th><b translate="STORAGE"></b></th> <th><b translate="SERIAL_NUMBER"></b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="4"> <div style="padding:20px 0px"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="LOADING_LABELS"></span> ...</b></center> </div> </td> </tr> <tr ng-if="$mdl.labelData.length==0"> <td colspan="4"><span translate="NO_LABEL_AVAILABLE"></span>.</td> </tr> <tr ng-repeat="m in $mdl.labelData"> <td>{{m.productCode | uppercase}}</td> <td>{{m.productName | uppercase}}</td> <td>{{m.storageName | uppercase}}</td> <td>{{m.serialNo | uppercase}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/jobs/joblist/joblistUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/jobs/joblist/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:30px" ui-sref="jobs.joblist" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons" ng-click="vm.submitted=true" ng-if="vm.originalStatus==0"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-default btn-with-icon" style="margin-left:30px" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus!=0 && vm.originalStatus!=5" ng-click="vm.printJobSheet(vm.job.id, vm.job.jobNo)" rms-check-access="jobs.joblist" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT_JOBSHEET"></span></a> <a href="" class="btn btn-default btn-with-icon" ng-disabled="vm.lockButtons" ng-if="!vm.isRmsLite && !vm.isRmsStarter && (vm.originalStatus==3 || vm.originalStatus==4)" ng-click="vm.printJobTrace(vm.job.id, vm.job.jobNo)" rms-check-access="jobs.joblist" rms-check-access-perm-type="EXPORT"><i class="fa fa-file-text"></i> <span translate="PRINT_TRACE_REPORT"></span></a> <a href="" class="btn btn-success btn-with-icon" style="margin-left:30px" ng-click="vm.showCompleteJobModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==2"><i class="ion ion-checkmark-round"></i> <span translate="COMPLETE_PRODUCTION"></span></a> <a href="" class="btn btn-danger btn-with-icon" style="margin-left:30px" ng-disabled="vm.lockButtons" ng-if="vm.mode==2 && (vm.originalStatus==0 || vm.originalStatus==1)" ng-confirm-click="Confirm cancel this Job?" confirmed-click="vm.cancelJob()"><i class="fa fa-trash"></i> <span translate="CANCEL_PRODUCTION"></span></a></div></form>');
$templateCache.put('app/pages/jobs/jobdashboard/jobdashboard.html','<div class="jobdashboard"><div class="row row-equal-height"><div class="col-md-3 col-lg-3" style="padding-left:0px"><input type="text" class="form-control searchbox" name="Search" placeholder="Search for Job" ng-model="searchText"></div><div class="col-md-2 col-lg-2"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.reload()"><i class="ion-refresh"></i> <span translate="REFRESH_DASHBOARD"></span></a></div><div class="col-md-7 col-lg-7" style="line-height:200%">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{vm.numOfRecord}}</b></div><br><br>&nbsp;</div><div class="row" ng-show="vm.isLoading"><div class="col-lg-12"><div ba-panel=""><br>&nbsp;<center class="text-primary" style="font-size:14pt"><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="LOADING_DASHBOARD"></span> ...</b></center><br>&nbsp;</div></div></div><div class="row" ng-show="vm.isProcessing"><div class="col-lg-12"><div ba-panel=""><br>&nbsp;<center class="text-success" style="font-size:14pt"><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="STARTING_JOB"></span> ...</b></center><br>&nbsp;</div></div></div><div class="row" ng-show="vm.jobDataFull.length<=0 && !vm.isLoading"><div class="col-lg-12"><div ba-panel="" class="bg-primary"><br>&nbsp;<center style="font-size:14pt"><b><i class="fa fa-clock-o fa-spin fa-fw"></i> <span translate="JOB_DASHBOARD_IS_EMPTY_FOR_NOW"></span>.</b></center><br>&nbsp;</div></div></div><div class="row" ng-repeat="item in vm.jobDataFull | filter:searchText"><div class="col-md-12"><div ba-panel=""><div class="row row-equal-height"><div class="col-sm-3 col-md-3 col-lg-2" style="line-height:100%;background:#eee;padding:14px;margin:1px;"><small style="color:#666"><span translate="EXECUTION_DATE"></span></small><br><div class="jobdatedayDiv"><span class="jobdateday"><b>{{item.jobDateDay}}</b></span> <span class="jobdatemonth"><b>{{item.jobDateMonth | uppercase}}</b></span></div><div class="jobdatetimeDiv" ng-if="item.jobTime!=\'12:00AM\'"><span class="jobdatetime"><b>{{item.jobTime | uppercase}}</b></span></div><div class="jobdayDiv"><span class="jobday"><b>{{item.jobDay | uppercase}}</b></span></div></div><div class="col-sm-3 col-md-3 col-lg-2" style="line-height:140%;background:#eee;padding:14px;margin:1px;"><small style="color:#666"><span translate="JOB_NUMBER"></span></small><br><span style="font-size:14pt"><b>{{item.jobNo}}</b></span><br><br><div ng-if="item.salesOrderId!=null"><small style="color:#666"><span translate="SALES_ORDER_NUMBER"></span></small><br><span style="font-size:14pt;color:#f00"><b>{{item.salesOrderNo}}</b></span><br><br></div><small style="color:#666"><span translate="ACTION_BY"></span></small><br><span style="font-size:14pt"><b>{{item.userGroupName}}</b></span></div><div class="col-sm-6 col-md-4 col-lg-3" style="line-height:140%;background:#eee;padding:14px;margin:1px;"><small style="color:#666"><span translate="MISE-EN-PLACE"></span> &amp; <span translate="COOKING"></span></small><br><span style="font-size:14pt"><b>{{item.productName}}</b></span><br><br><small style="color:#666"><span translate="PACKAGING_INSTRUCTION"></span></small><br><span style="font-size:14pt"><b>{{item.packagingInstruction || \'-\'}}</b></span></div><div class="col-sm-3 col-md-3 col-lg-2" style="line-height:140%;background:#eee;padding:14px;margin:1px;"><small style="color:#666"><span translate="QUANTITY"></span></small><br><span style="font-size:14pt"><b>{{item.quantity}} <span translate="BATCH"></span></b></span><br><br><small style="color:#666"><span translate="EXPECTED_OUTPUT"></span></small><br><span style="font-size:14pt"><b>{{item.packingQuantity}} {{item.packingUom}}</b></span></div><button title="View" class="col-sm-3 col-md-2 col-lg-1 btn btn-info" style="width:130px;line-height:140%;padding:14px;margin:1px;" ng-disabled="vm.isProcessing" ui-sref="recipes.cards.view({id:item.recipeId})"><i class="fa fa-book fa-3x"></i><br><br><b translate="RECIPE"></b></button> <button title="Start" class="col-sm-3 col-md-2 col-lg-1 btn btn-primary" style="width:130px;line-height:140%;padding:14px;margin:1px;" ng-if="!item.isStarted" ng-disabled="vm.isProcessing" confirmed-click="vm.startJob(item.id, item.jobNo)" ng-confirm-click="Start Job = {{item.jobNo}} = ?" rms-check-access="jobs.jobdashboard" rms-check-access-perm-type="UPDATE"><i class="fa fa-play fa-3x"></i><br><br><b translate="START"></b></button> <button title="Complete" class="col-sm-3 col-md-2 col-lg-1 btn btn-warning" style="width:130px;line-height:140%;padding:14px;margin:1px;" ng-if="item.isStarted" ng-disabled="vm.isProcessing" ng-click="vm.showCompleteJobModal(item.id, item.jobNo, item.productName, item.packingQuantity, item.packingUom)" rms-check-access="jobs.jobdashboard" rms-check-access-perm-type="UPDATE"><i class="fa fa-spinner fa-spin fa-3x"></i><br><br><b><span translate="WORK_IN"></span><br><span translate="PROGRESS"></span></b></button></div></div></div></div></div><script type="text/ng-template" id="confirmModal.html"><form name="$mdl.confirmForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="COMPLETE_JOB"></span>: {{$mdl.item.jobNo}} <span ng-if="$mdl.isLoading"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </span> </h3> </div> <div class="modal-body" id="modal-body"> <!-- <div class="row"> <div class="col-lg-12"> <div class="form-group"> <span style="color:#f00"><b> <span translate="NOTE:_FILL_THE_ACTUAL_PRODUCTION_QUANTITY"></span>.</b></span> </div> </div> </div> --> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b><span translate="PRODUCT_NAME"></span></b></label> <span class="form-control" ng-disabled="true" style="height:auto;font-size:16pt;color:#000"> <b>{{ $mdl.item.productName || $mdl.item.semiFgName}}</b> </span> </div> </div> </div> <!-- <div class="row" ng-if="$mdl.isRmsLite!=null && $mdl.isRmsLite"> <div class="col-lg-9"> <div class="form-group"> <label><b><span translate="ACTUAL_PRODUCTION_QUANTITY"></span></b> <i class="fa fa-asterisk req"></i></label> <div class="row"> <div class="col-lg-6" style="padding-right:0px"> <input type="number" class="form-control" name="Quantity" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.item.actualProductionQuantity" min="1" required /> </div> <div class="col-lg-4" style="padding-left:5px"> <span class="form-control" ng-disabled="true" style="height:auto;font-size:16pt;color:#000"><b> {{$mdl.item.packingUom}} </b></span> </div> </div> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.required">* <span style="color:#f00" translate="REQUIRED"></span></span> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.number">* <span style="color:#f00" translate="KEY_IN_NUMBERS_ONLY"></span></span> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.min">* <span style="color:#f00" translate="MINIMUM_QUANTITY_IS_1"></span></span> </div> </div> </div> --> <div class="row"> <div class="col-lg-6"> <div class="form-group"> <label><b><span translate="ESTIMATED_PRODUCTION_QUANTITY"></span></b></label> <div class="row"> <div class="col-lg-6" style="padding-right:0px"> <span class="form-control" ng-disabled="true" style="height:auto;font-size:16pt;color:#000"> <b>{{$mdl.item.packingQty}}</b> </span> </div> <div class="col-lg-6" style="padding-left:5px"> <span class="form-control" ng-disabled="true" style="height:auto;font-size:16pt;color:#000"> <b>{{$mdl.item.packingUom}}</b> </span> </div> </div> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b><span translate="ACTUAL_PRODUCTION_QUANTITY"></span></b> <i class="fa fa-asterisk req"></i></label> <div class="row"> <div class="col-lg-6" style="padding-right:0px"> <input type="number" class="form-control" name="Quantity" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.item.actualProductionQuantity" min="0.001" required /> </div> <div class="col-lg-6" style="padding-left:5px"> <span class="form-control" ng-disabled="true" style="height:auto;font-size:16pt;color:#000"> <b>{{$mdl.item.packingUom}}</b> </span> </div> </div> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.required">* {{ \'REQUIRED\' | translate}}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate}}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.Quantity.$error.min">* {{ \'MINIMUM_QUANTITY_IS_0.001\' | translate}}</span> </div> </div> </div> <div class="row" ng-if="($mdl.item.actualProductionQuantity<$mdl.item.packingQty)"> <div class="col-lg-12"> <div class="form-group"> <label><b>Reason of Shrinkage</b> <i class="fa fa-asterisk req" ng-if="$mdl.item.actualProductionQuantity<$mdl.item.packingQty"></i> </label> <input type="text" class="form-control" name="ReasonOfShrinkage" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.item.failureReason" ng-required="$mdl.item.actualProductionQuantity<$mdl.item.packingQty" /> <span class="help-block" style="color:#f00" ng-show="$mdl.confirmForm.$submitted && $mdl.confirmForm.ReasonOfShrinkage.$error.required"> * {{ "REQUIRED" | translate}} </span> </div> </div> </div> <hr ng-if="!$mdl.isRmsLite" /> <div class="row" ng-if="!$mdl.isRmsLite"> <div class="col-lg-6"> <div class="form-group"> <label><b>Cooking Temperature (\xB0C)</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.cookingTemperature" /> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>Blast Freeze Temperature (\xB0C)</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.blastFreezeTemperature" /> </div> </div> </div> <div class="row" ng-if="!$mdl.isRmsLite"> <div class="col-lg-6"> <div class="form-group"> <label><b>Oil Temperature (\xB0C)</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.oilTemperature" /> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>Oil TPM</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.oilTPM" /> </div> </div> </div> <div class="row" ng-if="!$mdl.isRmsLite"> <div class="col-lg-6"> <div class="form-group"> <label><b>Brix Sugar Level</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.brixSugarLevel" /> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>Salt Level</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.saltLevel" /> </div> </div> </div> <div class="row" ng-if="!$mdl.isRmsLite"> <div class="col-lg-6"> <div class="form-group"> <label><b>pH Level</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.phLevel" /> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>Viscosity</b> (Optional)</label> <input type="text" class="form-control" style="background:#fffeed;height:auto;font-size:16pt;color:#000" ng-model="$mdl.job.viscosity" /> </div> </div> </div> </div> <hr /> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="$mdl.isLoading" ng-if="$mdl.isSimpleStockIn" > <i class="ion ion-checkmark"></i> <span translate="COMPLETE_JOB"></span> </button> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="$mdl.isLoading" ng-if="!$mdl.isSimpleStockIn" confirmed-click="$mdl.directToPrintLabel()" ng-confirm-click="Do you want to print label now?" > <i class="ion ion-checkmark"></i> <span translate="COMPLETE_JOB"></span> </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.isLoading"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/label/items/itemAdjustment.html','<form class="form-content" name="vm.dataForm" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'ADJUSTMENT\' | translate }}"><div><div class="row"><div class="col-md-7 col-lg-7"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && (vm.dataForm.SerialNo.$dirty || vm.dataForm.$submitted)}"><label><big><b><span translate="STEP_1"></span>: &nbsp; {{ \'ENTER_LABEL_SERIAL_NO\' | translate }}</b></big><i class="fa fa-asterisk req"></i></label></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && (vm.dataForm.SerialNo.$dirty || vm.dataForm.$submitted)}"><input type="text" class="form-control" name="SerialNo" style="text-transform:uppercase" ng-model="vm.adj.serialNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.loadLabelInfo()"><i class="fa fa-search"></i> {{ \'LOAD_LABEL_INFO\' | translate }}</a></div></div><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-6 col-lg-6"><div style="background:#eefaff;padding:10px;line-height:150%"><div class="row" style="margin-bottom:10px"><div class="col-lg-4">{{\'ITEM_CODE\' | translate }}<br><b>{{vm.labelInfo.itemCode}}</b></div><div class="col-lg-8">{{\'ITEM_NAME\' | translate }}<br><b>{{vm.labelInfo.itemDescription}}</b></div></div><div class="row" style="margin-bottom:5px"><div class="col-lg-4">{{ \'BALANCE_QTY\' | translate }}:<br><b>{{vm.labelInfo.balanceQty | number}}</b></div><div class="col-lg-8">{{ \'U.O.M\' | translate }}:<br><b>{{vm.labelInfo.uom1}}</b></div></div></div></div></div><br><br><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-4 col-lg-4"><label><big><b><span translate="STEP_2"></span>: &nbsp; {{ \'ADJUSTMENT\' | translate }}</b></big></label></div></div><br><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AdjustedQuantity.$invalid && (vm.dataForm.AdjustedQuantity.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'ADJUSTED_QUANTITY\' | translate }} <span ng-if="vm.labelInfo.itemCwm">#1</span></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="AdjustedQuantity" style="text-transform:uppercase" ng-model="vm.adj.parallel_Quantity_1" min="0" ng-required="$tabSetStatus.activeTab==2"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AdjustedQuantity.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AdjustedQuantity.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AdjustedQuantity.$error.min">* Minimum is zero</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AdjustedUOM.$invalid && (vm.dataForm.AdjustedUOM.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'ADJUSTED_UOM\' | translate }} <span ng-if="vm.labelInfo.itemCwm">#1</span></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="AdjustedUOM" ng-options="u as u.name for u in vm.itemUoms track by u.id" ng-model="vm.selectedUOM" ng-change="vm.selectedUOMChanged()" ng-required="$tabSetStatus.activeTab==2"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AdjustedUOM.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Remarks.$invalid && (vm.dataForm.Remarks.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'REMARKS\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Remarks" style="text-transform:uppercase" ng-model="vm.adj.remarks" ng-required="$tabSetStatus.activeTab==2"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Remarks.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row" style="margin-top:10px"><div class="col-md-3 col-lg-3"><button type="submit" class="btn btn-info btn-with-icon btn-lg" style="background:#286090 !important" ng-if="vm.labelInfo!=null" ng-disabled="vm.isLoading" ng-confirm-click="Confirm submit the adjustment?" confirmed-click="vm.adjustLabel()"><i class="fa fa-pencil"></i> {{ \'ADJUST_LABEL\' | translate }}</button></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><div class="footer-bar"><a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard"><i class="fa fa-chevron-left"></i> {{ \'BACK\' | translate }}</a></div></form>');
$templateCache.put('app/pages/label/items/itemCreate.html','<form class="form-content" name="vm.dataForm" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'RAW_MAT_LABEL\' | translate }}"><div class="row"><div class="col-md-6 col-lg-6"><div class="row"><div class="col-md-12 col-lg-12"><h3><b>{{ \'STEP_1:_SCAN_/_KEY_IN_GRN_NUMBER\' | translate }}</b> <i class="fa fa-asterisk req"></i></h3></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><input type="text" class="form-control" name="GrnNo" ng-disabled="true" ng-model="vm.label.grnNo"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.promptGrnModal()"><i class="fa fa-search"></i> {{ \'SELECT_A_GRN\' | translate }}</a><button class="btn btn-danger btn-with-icon" ng-if="vm.grn.grnId!=null" ng-disabled="vm.isLoading" ng-click="vm.resetFields()"><i class="fa fa-print"></i> {{ \'RESET\' | translate}}</button></div></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row" ng-if="vm.grn.grnId!=null"><div class="col-md-12 col-lg-12"><div class="row"><div class="col-md-12 col-lg-12"><legend style="padding-bottom:10px"><b translate="STEP_2:_CHECK_THE_RAW_MATERIAL_LABEL_SETTINGS"></b> <i class="fa fa-asterisk req"></i></legend><p><i class="fa fa-info-circle"></i> <span translate="CHANGING_THE_UOM_SELECTION"></span> <b><u>{{vm.autoUpdateUomText}}</u></b> <span translate="UPDATE_THE_RAW_MATERIAL\'S_LABEL_PRINTING_OPTION_AND_UOM_SETTINGS_IN_MAINTENANCE"></span><br>&nbsp;</p></div></div><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-bordered table-striped table-hover" style="background:#fff"><tr><td>#</td><td align="center"><b translate="REJECTED">?</b></td><td align="center" style="line-height:120%;padding:5px 15px"><small><b><span translate="PRINTED"></span><br><span translate="BEFORE"></span>?</b></small></td><td><b translate="ITEM_DESCRIPTION"></b></td><td><b translate="PRINT_OPTION"></b></td><td align="right"><b translate="NO._OF_LABELS"></b></td><td></td><td style="text-align:center" class="hide-after" colspan="2"><b>{{ \'GRN_QUANTITY\' | translate }}</b></td><td style="text-align:center" class="hide-after" colspan="2"><b>{{ \'LABEL_QUANTITY\' | translate }}</b></td><td align="center" style="line-height:120%;padding:5px 15px"><small><em><span translate="CHANGE_LABEL_UOM"></span><br><span translate="IF_NEEDED"></span></em></small></td></tr><tr ng-repeat="item in vm.grn.itemList"><td style="padding-top:5px">{{$index+1}}.</td><td style="padding-top:9px"><center><i class="fa fa-check-circle fa-2x text-danger" ng-if="item.isRejected"></i></center></td><td style="padding-top:9px"><center><i class="fa fa-check-circle fa-2x text-success" ng-if="item.isPrinted"></i> <i class="fa fa-times-circle fa-2x text-danger" ng-if="!item.isPrinted"></i></center></td><td style="line-height:120%;padding:5px 10px"><small>{{item.code}}</small><br>{{item.description}}</td><td ng-if="item.isRejected" colspan="6" style="line-height:120%;padding:5px 10px"><span class="text-danger"><span translate="REJECT_REASON"></span>:<br><b>{{item.rejectRemark}}</b></span></td><td ng-if="!item.isRejected" style="padding-top:5px;padding-bottom:5px"><toggle on="{{ \'SINGLE\' | translate }}" off="{{ \'MULTIPLE\' | translate }}" onstyle="btn-success" offstyle="btn-primary" ng-model="item.labelPrintOption" ng-change="vm.printOptionChanged(item)"></toggle></td><td ng-if="!item.isRejected" style="padding-top:5px" align="right">{{item.noOfLabel}} x</td><td ng-if="!item.isRejected"></td><td ng-if="!item.isRejected" style="padding-top:5px;color:#00f" align="right"><b>{{item.receivingQuantity}}</b></td><td ng-if="!item.isRejected" style="padding-top:5px;color:#00f"><b>{{item.receivingUomName}}</b></td><td ng-if="!item.isRejected" style="padding-top:5px;color:#00f" align="right"><b>{{item.quantity}}</b></td><td ng-if="!item.isRejected" style="padding-top:5px;color:#00f"><b>{{item.uomName}}</b></td><td ng-if="!item.isRejected" style="padding-top:5px;padding-bottom:5px"><select class="form-control" name="UOM_{{$index}}" ng-model="item.selectedUom" ng-options="s as s.uomName for s in item.uomList" ng-change="vm.itemUomChanged(item)"><option></option></select></td></tr></table></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-lg-12"><button class="btn btn-info btn-with-icon btn-lg" style="background:#286090 !important" ng-disabled="vm.isLoading || vm.grn.grnId==null" ng-confirm-click="Confirm proceed to print label?" confirmed-click="vm.printLabel()"><i class="fa fa-print"></i> <span translate="PRINT_LABEL"></span></button></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'REPRINT_LABEL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="RE-PRINT_RAW_MATERIAL_LABELS_WHICH_FULFILL_THE_FOLLOWING_CONDITIONS"></span>:<ul style="color:#00f"><li translate="THE_LABEL_IS_NOT_VOIDED_BEFORE">.</li></ul></p><br><div class="row"><div class="col-md-3 col-lg-3"><h3><b>{{ \'ENTER_THE_LABEL_SERIAL_NO\' | translate }}</b> <i class="fa fa-asterisk req"></i></h3></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ReprintSerialNo.$invalid && (vm.dataForm.ReprintSerialNo.$dirty || vm.dataForm.$submitted)}"><input type="text" name="ReprintSerialNo" class="form-control" placeholder="e.g. RM/19/00000001" ng-model="vm.reprint.serialNo" ng-disabled="vm.isLoading" ng-required="$tabSetStatus.activeTab==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ReprintSerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><br><div class="row"><div class="col-md-3 col-lg-3"><h3><b>{{ \'NO_OF_LABEL\' | translate }}</b> <i class="fa fa-asterisk req"></i></h3></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumberOfLabel.$invalid && (vm.dataForm.NumberOfLabel.$dirty || vm.dataForm.$submitted)}"><input type="number" name="NumberOfLabel" class="form-control" min="1" ng-model="vm.reprint.numberOfLabel" ng-disabled="vm.isLoading" ng-required="$tabSetStatus.activeTab==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumberOfLabel.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumberOfLabel.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumberOfLabel.$error.min">* Minimum is 1</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-lg-12"><button type="submit" class="btn btn-info btn-with-icon btn-lg" style="background:#286090 !important" ng-disabled="vm.isLoading || $tabSetStatus.activeTab!=1" ng-confirm-click="Confirm re-print this label?" confirmed-click="vm.reprintLabel()"><i class="fa fa-print"></i> <span translate="RE-PRINT_LABEL"></span></button></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'VOID_LABEL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="VOID_RAW_MATERIAL_LABEL_WHICH_FULFILL_THE_FOLLOWING_CONDITIONS"></span>:<ul style="color:#00f"><li><span>{{ \'THE_LABEL_IS_NOT_VOIDED_BEFORE\' | translate }}</span>.</li><li><span>{{ \'THE_LABEL_HAS_NOT_STOCK-IN_BEFORE\' | translate }}</span>.</li><li><span>{{ \'THE_LABEL_DOES_NOT_HAVE_ANY_INVENTORY_MOVEMENT_RECORD\' | translate }}</span>.</li></ul></p><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.VoidSerialNo.$invalid && (vm.dataForm.VoidSerialNo.$dirty || vm.dataForm.$submitted)}"><h3><b>{{ \'ENTER_THE_LABEL_SERIAL_NO\' | translate }}</b> <i class="fa fa-asterisk req"></i></h3><input type="text" name="VoidSerialNo" class="form-control" placeholder="e.g. RM/19/0000001" ng-model="vm.labelvoid.serialNo" ng-disabled="vm.isLoading" ng-required="$tabSetStatus.activeTab==2"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.VoidSerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row" style="margin-top:10px"><div class="col-md-3 col-lg-3"><button type="submit" class="btn btn-info btn-with-icon btn-lg" style="background:#286090 !important" ng-disabled="vm.isLoading || $tabSetStatus.activeTab!=2" ng-confirm-click="Confirm void this label?" confirmed-click="vm.voidLabel()"><i class="fa fa-ban"></i> <span translate="VOID_LABEL"></span></button></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'LABEL_PRINT_QUEUE\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="LIST_OF_RAW_MATERIAL_LABEL_PRINT_QUEUE"></span>.</small></p><br><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.OBalBranch.$invalid && (vm.dataForm.OBalBranch.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_A_BRANCH"></b> <i class="fa fa-asterisk req"></i></label><div class="row"><div class="col-lg-3"><select class="form-control" name="OBalBranch" ng-options="u as (u.name | uppercase) for u in vm.branches track by u.id" ng-model="vm.selectedBranch" ng-change="vm.selectedBranchChanged()" ng-required="$tabSetStatus.activeTab==3"><option></option></select></div><div class="col-lg-9"><button type="button" class="btn btn-success btn-with-icon" style="margin-right:30px" ng-disabled="vm.isLoading || vm.selectedBranch==null" ng-click="vm.showDownloadExcelModal()" rms-check-access="label.items" rms-check-access-perm-type="EXPORT"><i class="fa fa-download"></i> <span translate="DOWNLOAD_EXCEL_OR_PDF"></span></button> <button type="button" class="btn btn-warning btn-with-icon" style="margin-right:10px;color:#000" ng-disabled="vm.isLoading || vm.selectedBranch==null" ng-confirm-click="Confirm purge all Labels Print Queue?" confirmed-click="vm.purgeLabels()"><i class="fa fa-trash"></i> <span translate="PURGE_NORMAL_LABELS"></span></button> <button type="button" class="btn btn-warning btn-with-icon" style="color:#000" ng-disabled="vm.isLoading || vm.selectedBranch==null" ng-confirm-click="Confirm purge all Labels Test Print Queue?" confirmed-click="vm.purgeTestLabels()"><i class="fa fa-trash"></i> <span translate="PURGE_TEST_PRINT_LABELS"></span></button></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.OBalBranch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-8"><div style="max-height:250px;overflow:auto"><table class="table table-striped" style="border:5px solid #eee;font-size:90%"><thead><tr><th><b><span translate="SERIAL_NO"></span>.</b></th><th><b>{{ \'ITEM_CODE\' | translate }}</b></th><th><b>{{ \'ITEM_NAME\' | translate }}</b></th><th><b><span translate="GRN_NO"></span>.</b></th></tr></thead><tbody><tr ng-if="vm.pendingLabels.length==0 && !vm.isLoading"><td colspan="4" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="4" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.pendingLabels"><td>{{item.serialNo}}</td><td>{{item.itemCode}}</td><td>{{item.itemName}}</td><td>{{item.receivingNo || \'-\'}}</td></tr></tbody></table></div><br><span translate="TOTAL_LABELS"></span>: <b>{{vm.pendingLabels.length}}</b></div></div><p><br></p></uib-tab><uib-tab heading="{{ \'OPENBAL_LABEL\' | translate }}" rms-check-access="label.itemsob" rms-check-access-perm-type="ACCESS"><p><i class="fa fa-info-circle"></i> <span translate="CREATE_OPENING_BALANCE_LABEL_FOR_EXISTING_RAW_MATERIAL_STOCKS"></span>:</p><br><div class="row"><div class="col-md-3 col-lg-3"><a href="" class="btn btn-success btn-with-icon" ui-sref="label.items.import" rms-check-access="label.items" rms-check-access-perm-type="CREATE"><i class="fa fa-upload"></i><span translate="IMPORT_FROM_EXCEL"></span></a></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div></form><div class="footer-bar"><a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a></div><script type="text/ng-template" id="downloadModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="EXPORT_TRANSACTIONS_INTO_EXCEL_OR_PDF"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <p translate="EXPORT_RAWMAT_LABEL_INTO_EXCEL">.</p> <p>{{\'BRANCH\' | translate}}: <b>{{$mdl.branchName}}</b></p> <br /><br /> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"><span translate="EXPORT_NEW_TRANSACTIONS"></span></legend> <div class="row" ng-if="!$mdl.isLoading"> <div class="col-md-6 col-lg-6"> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcel()"> <i class="fa fa-file-excel-o"></i> {{\'GENERATE_EXCEL\' | translate}} </a> </div> <div class="col-md-6 col-lg-6"> <a href class="btn btn-danger btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadPdf()"> <i class="fa fa-file-pdf-o"></i> {{\'GENERATE_PDF\' | translate}} </a> </div> </div> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <br /><br /> <div class="row" ng-if="$mdl.batchList.length!=0"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <select name="BatchNo" class="form-control" style="margin-bottom:10px;background:#fffeed" ng-model="$mdl.selectedBatchId" ng-change="$mdl.selectedBatchIdChanged()" ng-options="i as i for i in $mdl.batchList"> <option value="">={{ \'SELECT_ONE\' | translate }}=</option> </select> <div class="row" ng-if="!$mdl.isLoading"> <div class="col-md-6 col-lg-6"> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcelPast()"> <i class="fa fa-download"></i> {{\'DOWNLOAD_EXCEL\' | translate}} </a> </div> <div class="col-md-6 col-lg-6"> <a href class="btn btn-danger btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadPdfPast()"> <i class="fa fa-download"></i> {{\'DOWNLOAD_PDF\' | translate}} </a> </div> </div> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <div class="row" ng-if=$mdl.batchList.length==0> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <br /> <center> <b class="text-primary"><i class="fa fa-info-circle"></i> <span translate="NO_PREVIOUS_EXPORT_AVAILABLE"></span></b> </center> </div> </div> </div> <hr /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script><script type="text/ng-template" id="GrnListModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ \'SELECT_A_GRN\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:9pt;color:#000" st-pipe="$mdl.retrieveData" st-table="$mdl.data" refresh-table> <thead> <tr class="sortable"> <th colspan="3"> <div class="col-md-12 col-lg-12" style="height:35px;line-height:35px;padding-left:0px"> <select st-search="isLabelPrinted" class="form-control input" style="background:#fffeed"> <option value="">{{ \'SHOW_GRN_LABEL_NOT_PRINTED\' | translate }}</option> <option value="1">{{ \'SHOW_GRN_LABEL_PRINTED\' | translate }}</option> <option value="2">{{ \'SHOW_ALL_GRN\' | translate }}</option> </select> </div> </th> <th colspan="3" style="text-align:center"> <b ng-if="$mdl.isLoading" style="color:#00f;font-size:120%"> <i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ... </b> </th> <th colspan="3" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th style="width:60px">#</th> <th st-sort="receivingNo">{{ \'GRN_NO\' | translate }}</th> <th>{{ \'GRN_DATE\' | translate }}<br /><small>(DD/MM/YYYY)</small></th> <th>{{ \'SUPPLIER\' | translate }}</th> <th>{{ \'SUPPLIER_DO_NUMBER\' | translate }}</th> <th>{{ \'P.O._NO\' | translate }}</th> <th>{{ \'BRANCH_NAME\' | translate }}</th> <th>{{ \'STORAGE\' | translate }}</th> <th style="width:40px"></th> </tr> <tr class="sortable"> <th class="form-inline" style="padding-left:0px;padding-right:0px"> <a href class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search> {{ \'RESET\' | translate }} </a> </th> <th class="form-inline"> <input st-search="receivingNo" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="createdDate" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="supplierName" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="supplierDoNo" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="purchaseOrderNo" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="branchName" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th class="form-inline"> <input st-search="storageName" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th></th> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.data.length==0"> <td colspan="9" style="line-height:100px"> <center><b>{{ \'NO_RECORD_FOUND\' | translate }}</b></center> </td> </tr> <tr ng-repeat="item in $mdl.data"> <td>{{vm.startIndex+1+$index}})</td> <td ng-if="item.oldReceivingNo==null" nowrap="nowrap">{{item.receivingNo}}</td> <td ng-if="item.oldReceivingNo!=\'\' && item.oldReceivingNo!=null" nowrap="nowrap" style="line-height:130%;padding-top:5px;padding-bottom:4px"> {{item.receivingNo}}<br /><small><em>(Prev: {{item.oldReceivingNo}})</em></small> </td> <td style="line-height:120%;font-size:9pt;padding-top:5px;padding-bottom:4px;"> {{item.createdDate | date: \'dd-MMM-yyyy\' }}<br /> <small>{{item.createdDate | date: \'hh:mma\' }}</small> </td> <td nowrap="nowrap">{{item.supplierName}}</td> <td>{{ item.supplierDoNo }}</td> <td>{{ item.purchaseOrderNo }}</td> <td nowrap="nowrap">{{ item.branchName || \'-\' | uppercase }}</td> <td nowrap="nowrap">{{ item.storageName || \'-\' | uppercase }}</td> <td align="center"> <a href title="Select" class="btn btn-primary btn-xs btn-with-icon" ng-click="$mdl.selectGrn(item.receivingNo)"> <big><i class="fa fa-check"></i> {{ "SELECT" | translate }}</big> </a> </td> </tr> </tbody> </table> </div> </div> </div> <hr style="margin-top:0px;margin-bottom:10px" /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/label/items/itemImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b translate="IMPORT_RAW_MATERIAL_OPENING_BALANCE_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile()" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS">.</strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong><span translate="FAILED_TO_UPLOAD_FILE"></span>.</strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend translate="IMPORT_GUIDELINES">:</legend><ol class="import"><li><span translate="YOU_NEED_TO_FOLLOW_THE_INSTRUCTION_BELOW_IF_YOU_ARE_NEW_TO_THE_RMS"></span>.</li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA_FIRST,_THEN_IMPORT_INTO_THE_RMS"></span>:<br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'Raw Material Opening Balance Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_RAW_MATERIAL_OPENING_BALANCE_TEMPLATE"></span></a></li></ol></fieldset><br>&nbsp;<br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong><span translate="FILE_UPLOADED_SUCCESSFULLY"></span>. <span translate="CHOOSE_THE_OPTIONS_BELOW_AND_PROCEED_TO_IMPORT_THE_DATA"></span>.</strong></div><div><fieldset><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-warning btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-refresh"></i> {{ \'RESET\' | translate}}</a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><br><br><fieldset><legend><span translate="RAW_MATERIAL_OPENING_BALANCE_DATA_PREVIEW"></span>:</legend></fieldset></div><div class="horizontal-scroll"><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important"><thead><tr><th style="width:60px">#</th><th><b translate="BRANCH_CODE"></b></th><th><b>{{ \'ITEM_CODE\' | translate }}</b></th><th nowrap="nowrap"><b translate="ITEM_DESCRIPTION"></b></th><th style="text-align:right !important" nowrap="nowrap"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b translate="UOM"></b></th></tr><tr><th colspan="7">{{ \'TOTAL_RECORDS\' | translate}}: {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.branchCode || \'\' }}</td><td>{{ row.itemCode || \'\' }}</td><td nowrap="nowrap">{{ row.itemDescription || \'\' }}</td><td style="text-align:right;color:#00f">{{ row.quantity || \'\' | number }}</td><td>{{ row.uom || \'\' }}</td></tr><tr><td colspan="7" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="7">{{ \'TOTAL_RECORDS\' | translate}}: {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-6 col-lg-6"><em><small><i class="fa fa-info-circle"></i> <span translate="PROCESSING"></span>...</small></em><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><p translate="THE_DATA_IS_CURRENTLY_BEING_PROCESSED._IT_IS_SAFE_TO_LEAVE_THIS_PAGE_NOW."></p><p translate="YOU_WILL_RECEIVE_AN_EMAIL_NOTIFICATION_ABOUT_THE_IMPORT_RESULT_ONCE_THE_SERVER_HAS_FINISHED_PROCESSED_THE_DATA."></p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="label.items.print" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_PREVIOUS_SCREEN"></span></a></div></form></div>');
$templateCache.put('app/pages/label/products/productAdjustment.html','<form class="form-content" name="vm.dataForm" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'ADJUSTMENT\' | translate }}"><div><div class="row"><div class="col-md-7 col-lg-7"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && (vm.dataForm.SerialNo.$dirty || vm.dataForm.$submitted)}"><label><big><b><span translate="STEP_1"></span>: &nbsp; {{ \'ENTER_LABEL_SERIAL_NO\' | translate }}</b></big><i class="fa fa-asterisk req"></i></label></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && (vm.dataForm.SerialNo.$dirty || vm.dataForm.$submitted)}"><input type="text" class="form-control" name="SerialNo" style="text-transform:uppercase" ng-model="vm.adj.serialNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.loadLabelInfo()"><i class="fa fa-search"></i> {{ \'LOAD_LABEL_INFO\' | translate }}</a></div></div><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-6 col-lg-6"><div style="background:#eefaff;padding:10px;line-height:150%"><div class="row" style="margin-bottom:10px"><div class="col-lg-4">{{\'ITEM_CODE\' | translate }}<br><b>{{vm.labelInfo.itemCode}}</b></div><div class="col-lg-8">{{\'ITEM_NAME\' | translate }}<br><b>{{vm.labelInfo.itemDescription}}</b></div></div><div class="row" style="margin-bottom:5px"><div class="col-lg-4">{{ \'BALANCE_QTY\' | translate }}:<br><b>{{vm.labelInfo.balanceQty | number}}</b></div><div class="col-lg-8">{{ \'U.O.M\' | translate }}:<br><b>{{vm.labelInfo.uom1}}</b></div></div></div></div></div><br><br><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-4 col-lg-4"><label><big><b><span translate="STEP_2"></span>: &nbsp; {{ \'ADJUSTMENT\' | translate }}</b></big></label></div></div><br><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AdjustedQuantity.$invalid && (vm.dataForm.AdjustedQuantity.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'ADJUSTED_QUANTITY\' | translate }} <span ng-if="vm.labelInfo.itemCwm">#1</span></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="AdjustedQuantity" style="text-transform:uppercase" ng-model="vm.adj.parallel_Quantity_1" min="0" ng-required="$tabSetStatus.activeTab==2"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AdjustedQuantity.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AdjustedQuantity.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AdjustedQuantity.$error.min">* Minimum is zero</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AdjustedUOM.$invalid && (vm.dataForm.AdjustedUOM.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'ADJUSTED_UOM\' | translate }} <span ng-if="vm.labelInfo.itemCwm">#1</span></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="AdjustedUOM" ng-options="u as u.name for u in vm.itemUoms track by u.id" ng-model="vm.selectedUOM" ng-change="vm.selectedUOMChanged()" ng-required="$tabSetStatus.activeTab==2"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AdjustedUOM.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Remarks.$invalid && (vm.dataForm.Remarks.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'REMARKS\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Remarks" style="text-transform:uppercase" ng-model="vm.adj.remarks" ng-required="$tabSetStatus.activeTab==2"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Remarks.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row" style="margin-top:10px"><div class="col-md-3 col-lg-3"><button type="submit" class="btn btn-info btn-with-icon btn-lg" style="background:#286090 !important" ng-if="vm.labelInfo!=null" ng-disabled="vm.isLoading" ng-confirm-click="Confirm submit the adjustment?" confirmed-click="vm.adjustLabel()"><i class="fa fa-pencil"></i> {{ \'ADJUST_LABEL\' | translate }}</button></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><div class="footer-bar"><a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard"><i class="fa fa-chevron-left"></i> {{ \'BACK\' | translate }}</a></div></form>');
$templateCache.put('app/pages/label/products/productCreate.html','<form class="form-content" name="vm.dataForm" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'FG_LABEL\' | translate }}"><div class="row"><div class="col-md-6 col-lg-6"><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label><big><b><span translate="STEP_1"></span>: &nbsp; {{ \'SELECT_A_PROD_JOB\' | translate }}</b></big><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="JobNo" style="text-transform:uppercase" ng-model="vm.label.jobNo" ng-disabled="true"></div></div><div class="col-md-4 col-lg-4"><label>&nbsp;&nbsp;</label><br><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.promptJobModal()"><i class="fa fa-search"></i> {{ \'SELECT_A_PROD_JOB\' | translate }}</a></div></div><div class="row" ng-if="vm.isLoading"><div class="col-md-8 col-lg-8"><i class="fa fa-spinner fa-spin fa-fw"></i> <span style="color:#00f"><span translate="LOADING_JOB_DETAILS"></span> ...</span><br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isJobValid && vm.selectedProduct!=null"><div class="col-md-7 col-lg-7"><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Product.$invalid && (vm.dataForm.Product.$dirty || vm.dataForm.$submitted)}"><label><big><b>{{ \'FINISHED_GOODS\' | translate }}</b></big><i class="fa fa-asterisk req"></i></label><ui-select name="Product" ng-model="vm.selectedProduct" ng-disabled="true" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" on-select="vm.onSelectedProductChanged()" required=""><ui-select-match placeholder="{{ \'ENTER_KEYWORD_TO_SEARCH\' | translate }}"><span>{{ $select.selected.name | uppercase }}</span></ui-select-match><ui-select-choices repeat="p in vm.productList | filter: $select.search"><span ng-bind-html="p.name | uppercase | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Product.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" style="margin-top:20px"><div class="col-md-8 col-lg-8"><div class="form-group" style="margin-bottom:0px"><label><big><b><span translate="Step 2:"></span> &nbsp; <span translate="ENTER_THE_MANUFACTURE_DATE"></span> (<span translate="OPTIONAL"></span>)</b></big><br>(<span translate="FOR_BACK-DATED_MANUFACTURE_DATE"></span>)</label></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><div moment-picker="vm.label.mfgDate" class="input-group" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"><span class="input-group-addon"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="MfgDate" autocomplete="off" ng-disabled="!vm.isJobValid || vm.selectedProduct==null" ng-model="vm.label.mfgDate"></div></div></div></div><div class="row" style="margin-top:20px"><div class="col-md-8 col-lg-8"><div class="form-group" style="margin-bottom:0px"><label><big><b><span translate="Step 3:"></span> &nbsp; <span translate="OMIT_THE_SERIAL_NO_&_QR_CODE"></span> (<span translate="OPTIONAL"></span>)</b></big><br>( <span translate="FOR_NORMAL_INFO_PURPOSE"></span>)</label></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><div><toggle ng-model="vm.label.isHideSerialNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" style="margin-top:20px"><div class="col-md-8 col-lg-8"><div class="form-group" style="margin-bottom:0px"><label><big><b><span translate="Step 4:"></span> &nbsp; {{ \'ENTER_PACKAGING_WEIGHT_AND_QTY\' | translate }}</b></big></label></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div style="width:275px;height:350px;margin:0 auto;"><img ng-src="{{vm.blobUrl}}assets/img/item-pack.png" style="width:275px;height:350px;position:absolute"><div style="width:175px;position:absolute;margin-top:85px;margin-left:50px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ServingSize.$invalid && (vm.dataForm.ServingSize.$dirty || vm.dataForm.$submitted)}"><label style="display:block;text-align:center"><b><big>{{ \'PACKAGING_WEIGHT\' | translate }}</big></b></label> <input type="number" name="ServingSize" class="form-control input-lg" min="1" step="1" required="" ng-disabled="!vm.isJobValid || vm.selectedProduct==null" ng-model="vm.label.servingSize"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ServingSize.$error.required">* {{ \'REQUIRED\' | translate }}</span></div><br><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UOM1.$invalid && vm.dataForm.$submitted}"><label style="display:block;text-align:center"><b><big>{{ \'U.O.M\' | translate }}</big></b></label><select name="UOM1" class="form-control input-lg" ng-options="i as (i.name | uppercase) for i in vm.uomList1" ng-model="vm.selectedUom1" ng-disabled="!vm.isJobValid || vm.selectedProduct==null" ng-change="vm.onSelectedUom1Changed()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UOM1.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div><div class="col-md-2 col-lg-2"><div style="height:350px;line-height:375px"><i class="fa fa-times fa-5x"></i></div></div><div class="col-md-2 col-lg-2" style="padding-left:0px;padding-right:0px;"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InventoryQty.$invalid && (vm.dataForm.InventoryQty.$dirty || vm.dataForm.$submitted)}" style="margin-top:125px"><label style="display:block;text-align:center"><b><big>{{ \'QUANTITY\' | translate }}</big></b></label> <input type="number" class="form-control input-lg" name="InventoryQty" min="1" step="1" required="" ng-disabled="!vm.isJobValid || vm.selectedProduct==null" ng-model="vm.label.inventoryQty"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InventoryQty.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2" ng-if="vm.label.inventoryQty>1" style="padding-right:0px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UOM2.$invalid && vm.dataForm.$submitted}" style="margin-top:125px"><label style="display:block;text-align:center"><b><big>{{ \'U.O.M.\' | translate }}</big></b></label><select name="UOM2" class="form-control input-lg" ng-options="i as (i.name | uppercase) for i in vm.uomList2" ng-model="vm.selectedUom2" ng-disabled="!vm.isJobValid || vm.selectedProduct==null" ng-change="vm.onSelectedUom2Changed()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UOM2.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div></div><br><br><div class="row" ng-if="vm.isJobValid && vm.selectedProduct!=null"><div class="col-md-6 col-lg-6"><br><div class="form-group"><label><big><b><span translate="Step 5:"></span> &nbsp; <span translate="SELECT_A_PRINTING_OPTION"></span></b></big><i class="fa fa-asterisk req"></i></label><div style="padding:15px 15px 15px;background:#fffeb7"><div class="row"><div class="col-md-6 col-lg-6"><label class="radio-inline custom-radio nowrap"><input type="radio" data-ng-model="vm.label.printOption" data-ng-value="1" ng-disabled="!vm.isJobValid"> <span><big><span translate="PRINT"></span> <b translate="ONE"></b> <span translate="LABEL"></span> (<span translate="FOR"></span> <b style="color:#00f">{{vm.label.inventoryQty}}</b> {{ \'PACKAGING\' | translate }} {{ (vm.label.inventoryQty!=1?\'s\':\'\') }})</big></span></label></div><div class="col-md-6 col-lg-6" ng-if="vm.label.inventoryQty>1"><label class="radio-inline custom-radio nowrap"><input type="radio" data-ng-model="vm.label.printOption" data-ng-value="2" ng-disabled="!vm.isJobValid"> <span><big><b translate="MULTIPLE"></b> <span translate="LABELS"></span> ({{ \'ONE_LABEL_FOR_EACH_PACKAGING\' | translate }})</big></span></label></div></div><div class="row" style="margin-top:10px"><div class="col-md-6 col-lg-6"><div class="row"><div class="col-lg-11" ba-panel=""><div style="padding:10px !important;line-height:150%"><span style="color:#bbb">{{ \'PRODUCT_NAME\' | translate }} : XXXXXXX</span><br><span style="color:#bbb">{{ \'INGREDIENT\' | translate }} : XXXXXXX</span><br>{{ \'PACKAGING_WEIGHT\' | translate }} : <b>{{vm.label.servingSize || \'_____\'}}</b> <span>{{vm.label.servingUom || \'KG\'}}</span> {{(vm.label.inventoryQty==1 || !vm.label.inventoryQty)?\'\':\'x \'}} <b ng-show="vm.label.inventoryQty!=null && vm.label.inventoryQty!=1">{{vm.label.inventoryQty || \'\'}}</b> <span ng-show="vm.label.inventoryQty!=null && vm.label.inventoryQty!=1">{{vm.label.inventoryUom || \'\'}}</span><br><span style="color:#bbb"><span translate="MFG_DATE"></span> : dd/mm/yyyy</span><br><span style="color:#bbb"><span translate="EXP_DATE"></span> : dd/mm/yyyy</span><br></div></div></div></div><div class="col-md-6 col-lg-6" ng-if="vm.label.inventoryQty>1"><div class="row"><div class="col-lg-11" ba-panel=""><div style="padding:10px !important;line-height:150%"><span style="color:#bbb">{{ \'PRODUCT_NAME\' | translate }} : XXXXXXX</span><br><span style="color:#bbb">{{ \'INGREDIENT\' | translate }} : XXXXXXX</span><br>{{ \'PACKAGING_WEIGHT\' | translate }} : <b>{{vm.label.servingSize || \'_____\'}}</b> <span>{{vm.label.servingUom || \'KG\'}}</span><br><span style="color:#bbb"><span translate="MFG_DATE"></span> : dd/mm/yyyy</span><br><span style="color:#bbb"><span translate="EXP_DATE"></span> : dd/mm/yyyy</span><br></div></div><div class="col-lg-11" ng-show="vm.label.inventoryQty>1 && !!vm.label.inventoryQty" ba-panel=""><div style="padding:10px 0px"><center><span translate="AND"></span> {{vm.label.inventoryQty-1}} <span translate="MORE"></span>...</center></div></div></div></div></div><div class="row" style="margin-top:10px"><div class="col-md-6 col-lg-6"><button class="btn btn-primary btn-with-icon btn-lg" ng-disabled="!vm.isJobValid" ng-confirm-click="Confirm proceed to print label?" confirmed-click="vm.submit(vm.dataForm)"><i class="fa fa-print"></i> <span translate="PRINT_LABEL"></span></button></div></div></div></div></div></div><div class="row"><p>&nbsp;</p><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'REPRINT_LABEL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="RE-PRINT_PRODUCT_LABEL_WHICH_FULFILL_THE_FOLLOWING_CONDITIONS"></span>:<ul style="color:#00f"><li translate="THE_LABEL_IS_NOT_VOIDED_BEFORE">.</li></ul></p><br><div class="row"><div class="col-md-3 col-lg-3"><h3><b translate="ENTER_THE_LABEL_SERIAL_NO">.</b> <i class="fa fa-asterisk req"></i></h3></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ReprintSerialNo.$invalid && (vm.dataForm.ReprintSerialNo.$dirty || vm.dataForm.$submitted)}"><input type="text" name="ReprintSerialNo" class="form-control" placeholder="e.g. FG/19/00000001" ng-model="vm.serialNo" ng-disabled="vm.isLoading" ng-required="$tabSetStatus.activeTab==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ReprintSerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><br><div class="row"><div class="col-md-3 col-lg-3"><h3><b>{{ \'NO_OF_LABEL\' | translate }}</b> <i class="fa fa-asterisk req"></i></h3></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumberOfLabel.$invalid && (vm.dataForm.NumberOfLabel.$dirty || vm.dataForm.$submitted)}"><input type="number" name="NumberOfLabel" class="form-control" min="1" ng-model="vm.numberOfLabel" ng-disabled="vm.isLoading" ng-required="$tabSetStatus.activeTab==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumberOfLabel.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumberOfLabel.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumberOfLabel.$error.min">* Minimum is 1</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row" style="margin-top:10px"><div class="col-md-3 col-lg-3"><button type="submit" class="btn btn-info btn-with-icon btn-lg" style="background:#286090 !important" ng-disabled="vm.isLoading || $tabSetStatus.activeTab!=1" ng-confirm-click="Confirm re-print this label?" confirmed-click="vm.reprintLabel()"><i class="fa fa-print"></i> <span translate="RE-PRINT_LABEL"></span></button></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'VOID_LABEL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="VOID_PRODUCT_LABEL_WHICH_FULFILL_THE_FOLLOWING_CONDITIONS"></span>:<ul style="color:#00f"><li><span>{{ \'THE_LABEL_IS_NOT_VOIDED_BEFORE\' | translate }}</span>.</li><li><span>{{ \'THE_LABEL_HAS_NOT_STOCK-IN_BEFORE\' | translate }}</span>.</li><li><span>{{ \'THE_LABEL_DOES_NOT_HAVE_ANY_INVENTORY_MOVEMENT_RECORD\' | translate }}</span>.</li></ul></p><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><h3><b translate="ENTER_THE_SERIAL_NO_/_SCAN_QR_CODE"></b> <i class="fa fa-asterisk req"></i></h3><input type="text" class="form-control" placeholder="e.g. FG/19/0000001" ng-model="vm.serialNo" ng-disabled="vm.isLoading"></div></div></div><div class="row" style="margin-top:10px"><div class="col-md-3 col-lg-3"><a href="" class="btn btn-primary btn-with-icon btn-lg" ng-disabled="vm.isLoading" ng-confirm-click="Confirm void this label?" confirmed-click="vm.voidLabel()"><i class="fa fa-ban"></i> <span translate="VOID_LABEL"></span></a></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'LABEL_PRINT_QUEUE\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="LIST_OF_FG_LABEL_PRINT_QUEUE"></span>.</small></p><br><br><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.OBalBranch.$invalid && (vm.dataForm.OBalBranch.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_A_BRANCH"></b> <i class="fa fa-asterisk req"></i></label><div class="row"><div class="col-lg-3"><select class="form-control" name="OBalBranch" ng-options="u as (u.name | uppercase) for u in vm.branches track by u.id" ng-model="vm.selectedBranch" ng-change="vm.selectedBranchChanged()" ng-required="$tabSetStatus.activeTab==3"><option></option></select></div><div class="col-lg-9"><button type="button" class="btn btn-success btn-with-icon" style="margin-right:30px" ng-disabled="vm.isLoading || vm.selectedBranch==null" ng-click="vm.showDownloadExcelModal()" rms-check-access="label.products" rms-check-access-perm-type="EXPORT"><i class="fa fa-download"></i> <span translate="DOWNLOAD_EXCEL_OR_PDF"></span></button> <button type="button" class="btn btn-warning btn-with-icon" style="margin-right:10px;color:#000" ng-disabled="vm.isLoading || vm.selectedBranch==null" ng-confirm-click="Confirm purge all Labels Print Queue?" confirmed-click="vm.purgeLabels()"><i class="fa fa-trash"></i><span translate="PURGE_NORMAL_LABELS"></span></button> <button type="button" class="btn btn-warning btn-with-icon" style="color:#000" ng-disabled="vm.isLoading || vm.selectedBranch==null" ng-confirm-click="Confirm purge all Labels Test Print Queue?" confirmed-click="vm.purgeTestLabels()"><i class="fa fa-trash"></i> <span translate="PURGE_TEST_PRINT_LABELS"></span></button></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.OBalBranch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-8"><div style="max-height:250px;overflow:auto"><table class="table table-striped" style="border:5px solid #eee;font-size:90%"><thead><tr><th><b><span translate="SERIAL_NO"></span>.</b></th><th><b>{{ \'PRODUCT_CODE\' | translate }}</b></th><th><b>{{ \'PRODUCT_NAME\' | translate }}</b></th><th><b><span translate="JOB_NO"></span>.</b></th></tr></thead><tbody><tr ng-if="vm.pendingLabels.length==0 && !vm.isLoading"><td colspan="4" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="4" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.pendingLabels"><td>{{item.serialNo}}</td><td>{{item.productCode}}</td><td>{{item.productName}}</td><td>{{item.jobNo || \'-\'}}</td></tr></tbody></table></div><br><span translate="TOTAL_LABELS"></span>: <b>{{vm.pendingLabels.length}}</b></div></div><p><br></p></uib-tab><uib-tab heading="{{ \'OPENBAL_LABEL\' | translate }}" rms-check-access="label.productsob" rms-check-access-perm-type="ACCESS"><p><i class="fa fa-info-circle"></i> <span translate="CREATE_OPENING_BALANCE_LABEL_FOR_EXISTING_FINISHED_GOODS_STOCKS"></span>:</p><br><div class="row"><div class="col-md-3 col-lg-3"><a href="" class="btn btn-success btn-with-icon" ui-sref="label.products.import" rms-check-access="label.products" rms-check-access-perm-type="CREATE"><i class="fa fa-upload"></i><span translate="IMPORT_FROM_EXCEL"></span></a></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div></form><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ui-sref="dashboard"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a></div><script type="text/ng-template" id="downloadModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="EXPORT_TRANSACTIONS_INTO_EXCEL_OR_PDF"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <p translate="EXPORT_PRODUCT_LABEL_INTO_EXCEL">.</p> <p>{{\'BRANCH\' | translate}}: <b>{{$mdl.branchName}}</b></p> <br /><br /> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"><span translate="EXPORT_NEW_TRANSACTIONS"></span></legend> <div class="row" ng-if="!$mdl.isLoading"> <div class="col-md-6 col-lg-6"> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcel()"> <i class="fa fa-file-excel-o"></i> {{\'GENERATE_EXCEL\' | translate}} </a> </div> <div class="col-md-6 col-lg-6"> <a href class="btn btn-danger btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadPdf()"> <i class="fa fa-file-pdf-o"></i> {{\'GENERATE_PDF\' | translate}} </a> </div> </div> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <br /><br /> <div class="row" ng-if="$mdl.batchList.length!=0"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <select name="BatchNo" class="form-control" style="margin-bottom:10px;background:#fffeed" ng-model="$mdl.selectedBatchId" ng-change="$mdl.selectedBatchIdChanged()" ng-options="i as i for i in $mdl.batchList"> <option value="">={{ \'SELECT_ONE\' | translate }}=</option> </select> <div class="row" ng-if="!$mdl.isLoading"> <div class="col-md-6 col-lg-6"> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcelPast()"> <i class="fa fa-download"></i> {{\'DOWNLOAD_EXCEL\' | translate}} </a> </div> <div class="col-md-6 col-lg-6"> <a href class="btn btn-danger btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadPdfPast()"> <i class="fa fa-download"></i> {{\'DOWNLOAD_PDF\' | translate}} </a> </div> </div> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <div class="row" ng-if=$mdl.batchList.length==0> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <br /> <center> <b class="text-primary"><i class="fa fa-info-circle"></i> <span translate="NO_PREVIOUS_EXPORT_AVAILABLE"></span></b> </center> </div> </div> </div> <hr /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script><script type="text/ng-template" id="JobListModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ \'SELECT_A_COMPLETED_JOB_FG\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:9pt;color:#000" st-pipe="$mdl.retrieveData" st-table="$mdl.data" refresh-table> <thead> <tr class="sortable"> <th colspan="7" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th style="width:60px">#</th> <th st-sort="jobNo" st-sort-default="reverse" style="width:130px">{{ \'JOB_NO\' | translate }}</th> <th st-sort="jobDate">{{ \'JOB_DATE\' | translate }}</th> <th></th> <th st-sort="productName">{{ \'PRODUCT_NAME\' | translate }}</th> <th class="hide-after" style="text-align:center">{{ \'QUANTITY_BATCH\' | translate }}</th> <th style="width:40px"></th> </tr> <tr class="sortable"> <th class="form-inline" style="padding-left:0px;padding-right:0px" colspan="{{vm.showCjsPanel ? 2 : 1}}"> <a href class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search> {{ \'RESET\' | translate }} </a> </th> <th class="form-inline" colspan="2"> <input st-search="jobNo" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th></th> <th class="form-inline"> <input st-search="productName" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th colspan="2"> <b ng-if="$mdl.isLoading" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ... </b> </th> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.data.length==0"> <td colspan="7" style="line-height:100px"> <center><b>{{ \'NO_PROD_JOB_AVAILABLE\' | translate }}</b></center> </td> </tr> <tr ng-repeat="item in $mdl.data"> <td>{{vm.startIndex+1+$index}})</td> <td>{{item.jobNo}}</td> <td>{{item.jobDate | date: "dd/MM/yyyy"}}</td> <td class="text-center" style="width:80px;line-height:90%"> <div class="report-type-tag"> <b>{{item.productType.replace(\' \', \'\') | translate }}</b> </div> </td> <td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{item.productName}}</td> <td style="text-align:center"><b>{{item.quantity}}</b></td> <td align="center"> <a href title="Select" class="btn btn-primary btn-xs btn-with-icon" ng-click="$mdl.selectJob(item.jobNo)"> <big><i class="fa fa-check"></i> {{ "SELECT" | translate }}</big> </a> </td> </tr> </tbody> </table> </div> </div> </div> <hr style="margin-top:0px;margin-bottom:10px" /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/label/products/productImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b translate="IMPORT_FINISHED_GOODS_OPENING_BALANCE_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile()" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS">.</strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong><span translate="FAILED_TO_UPLOAD_FILE"></span>.</strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend translate="IMPORT_GUIDELINES">:</legend><ol class="import"><li><span translate="YOU_NEED_TO_FOLLOW_THE_INSTRUCTION_BELOW_IF_YOU_ARE_NEW_TO_THE_RMS"></span>.</li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA_FIRST,_THEN_IMPORT_INTO_THE_RMS"></span>:<br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'Finished Goods Opening Balance Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_FINISHED_GOODS_OPENING_BALANCE_TEMPLATE"></span></a></li></ol></fieldset><br>&nbsp;<br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong><span translate="FILE_UPLOADED_SUCCESSFULLY"></span>. <span translate="CHOOSE_THE_OPTIONS_BELOW_AND_PROCEED_TO_IMPORT_THE_DATA"></span>.</strong></div><div><fieldset><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-warning btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons || vm.isImporting"><i class="fa fa-refresh"></i> {{ \'RESET\' | translate}}</a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><br><br><fieldset><legend><span translate="FINISHED_GOODS_OPENING_BALANCE_DATA_PREVIEW"></span>:</legend></fieldset></div><div class="horizontal-scroll"><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important"><thead><tr><th style="width:60px">#</th><th><b translate="BRANCH_CODE"></b></th><th><b>{{ \'PRODUCT_CODE\' | translate }}</b></th><th nowrap="nowrap"><b>{{ \'PRODUCT_DESCRIPTION\' | translate }}</b></th><th style="text-align:right !important" nowrap="nowrap"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b translate="UOM"></b></th></tr><tr><th colspan="7">{{ \'TOTAL_RECORDS\' | translate}}: {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.branchCode || \'\' }}</td><td>{{ row.itemCode || \'\' }}</td><td nowrap="nowrap">{{ row.itemDescription || \'\' }}</td><td style="text-align:right;color:#00f">{{ row.quantity || \'\' | number }}</td><td>{{ row.uom || \'\' }}</td></tr><tr><td colspan="7" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="7">{{ \'TOTAL_RECORDS\' | translate}}: {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-6 col-lg-6"><em><small><i class="fa fa-info-circle"></i> <span translate="PROCESSING"></span>...</small></em><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><p><span translate="THE_DATA_IS_CURRENTLY_BEING_PROCESSED"></span>. <span translate="IT_IS_SAFE_TO_LEAVE_THIS_PAGE_NOW"></span>.</p><p><span translate="YOU_WILL_RECEIVE_AN_EMAIL_NOTIFICATION_ABOUT_THE_IMPORT_RESULT_ONCE_THE_SERVER_HAS_FINISHED_PROCESSED_THE_DATA"></span>.</p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="label.products.print" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_PREVIOUS_SCREEN"></span></a></div></form></div>');
$templateCache.put('app/pages/label/semifgs/semifgAdjustment.html','<form class="form-content" name="vm.dataForm" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'ADJUSTMENT\' | translate }}"><div><div class="row"><div class="col-md-7 col-lg-7"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && (vm.dataForm.SerialNo.$dirty || vm.dataForm.$submitted)}"><label><big><b><span translate="STEP_1"></span>: &nbsp; {{ \'ENTER_LABEL_SERIAL_NO\' | translate }}</b></big><i class="fa fa-asterisk req"></i></label></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && (vm.dataForm.SerialNo.$dirty || vm.dataForm.$submitted)}"><input type="text" class="form-control" name="SerialNo" style="text-transform:uppercase" ng-model="vm.adj.serialNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.loadLabelInfo()"><i class="fa fa-search"></i> {{ \'LOAD_LABEL_INFO\' | translate }}</a></div></div><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-6 col-lg-6"><div style="background:#eefaff;padding:10px;line-height:150%"><div class="row" style="margin-bottom:10px"><div class="col-lg-4">{{\'ITEM_CODE\' | translate }}<br><b>{{vm.labelInfo.itemCode}}</b></div><div class="col-lg-8">{{\'ITEM_NAME\' | translate }}<br><b>{{vm.labelInfo.itemDescription}}</b></div></div><div class="row" style="margin-bottom:5px"><div class="col-lg-4">{{ \'BALANCE_QTY\' | translate }}:<br><b>{{vm.labelInfo.balanceQty | number}}</b></div><div class="col-lg-8">{{ \'U.O.M\' | translate }}:<br><b>{{vm.labelInfo.uom1}}</b></div></div></div></div></div><br><br><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-4 col-lg-4"><label><big><b><span translate="STEP_2"></span>: &nbsp; {{ \'ADJUSTMENT\' | translate }}</b></big></label></div></div><br><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AdjustedQuantity.$invalid && (vm.dataForm.AdjustedQuantity.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'ADJUSTED_QUANTITY\' | translate }} <span ng-if="vm.labelInfo.itemCwm">#1</span></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="AdjustedQuantity" style="text-transform:uppercase" ng-model="vm.adj.parallel_Quantity_1" min="0" ng-required="$tabSetStatus.activeTab==2"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AdjustedQuantity.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AdjustedQuantity.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AdjustedQuantity.$error.min">* Minimum is zero</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AdjustedUOM.$invalid && (vm.dataForm.AdjustedUOM.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'ADJUSTED_UOM\' | translate }} <span ng-if="vm.labelInfo.itemCwm">#1</span></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="AdjustedUOM" ng-options="u as u.name for u in vm.itemUoms track by u.id" ng-model="vm.selectedUOM" ng-change="vm.selectedUOMChanged()" ng-required="$tabSetStatus.activeTab==2"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AdjustedUOM.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.labelInfo!=null"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Remarks.$invalid && (vm.dataForm.Remarks.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'REMARKS\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Remarks" style="text-transform:uppercase" ng-model="vm.adj.remarks" ng-required="$tabSetStatus.activeTab==2"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Remarks.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row" style="margin-top:10px"><div class="col-md-3 col-lg-3"><button type="submit" class="btn btn-info btn-with-icon btn-lg" style="background:#286090 !important" ng-if="vm.labelInfo!=null" ng-disabled="vm.isLoading" ng-confirm-click="Confirm submit the adjustment?" confirmed-click="vm.adjustLabel()"><i class="fa fa-pencil"></i> {{ \'ADJUST_LABEL\' | translate }}</button></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><div class="footer-bar"><a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard"><i class="fa fa-chevron-left"></i> {{ \'BACK\' | translate }}</a></div></form>');
$templateCache.put('app/pages/label/semifgs/semifgCreate.html','<form class="form-content" name="vm.dataForm" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'SEMIFG_LABEL\' | translate }}"><div class="row"><div class="col-md-6 col-lg-6"><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label><big><b><span translate="STEP_1"></span>: &nbsp; {{ \'SELECT_A_PROD_JOB\' | translate }}</b></big><i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="JobNo" style="text-transform:uppercase" ng-model="vm.label.jobNo" ng-disabled="true"></div></div><div class="col-md-4 col-lg-4"><label>&nbsp;&nbsp;</label><br><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.promptJobModal()"><i class="fa fa-search"></i> {{ \'SELECT_A_PROD_JOB\' | translate }}</a></div></div><div class="row" ng-if="vm.isLoading"><div class="col-md-8 col-lg-8"><i class="fa fa-spinner fa-spin fa-fw"></i> <span style="color:#00f"><span translate="LOADING_JOB_DETAILS"></span> ...</span><br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isJobValid && vm.selectedProduct!=null"><div class="col-md-7 col-lg-7"><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Product.$invalid && (vm.dataForm.Product.$dirty || vm.dataForm.$submitted)}"><label><big><b>{{ \'SEMI_FINISHED_GOODS\' | translate }}</b></big><i class="fa fa-asterisk req"></i></label><ui-select name="Product" ng-model="vm.selectedProduct" ng-disabled="true" title="Search for Finished Good..." class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" on-select="vm.onSelectedProductChanged()" required=""><ui-select-match placeholder="Search for Semi Finished Good..."><span>{{ $select.selected.description | uppercase }}</span></ui-select-match><ui-select-choices repeat="p in vm.productList | filter: $select.search"><span ng-bind-html="p.description | uppercase | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Product.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" style="margin-top:20px"><div class="col-md-8 col-lg-8"><div class="form-group" style="margin-bottom:0px"><label><big><b><span translate="Step 2:"></span> &nbsp; <span translate="ENTER_THE_MANUFACTURE_DATE"></span> (<span translate="OPTIONAL"></span>)</b></big><br>(<span translate="FOR_BACK-DATED_MANUFACTURE_DATE"></span>)</label></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><div moment-picker="vm.label.mfgDate" class="input-group" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"><span class="input-group-addon"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="MfgDate" autocomplete="off" ng-disabled="!vm.isJobValid || vm.selectedProduct==null" ng-model="vm.label.mfgDate"></div></div></div></div><div class="row" style="margin-top:20px"><div class="col-md-8 col-lg-8"><div class="form-group" style="margin-bottom:0px"><label><big><b><span translate="Step 3:"></span> &nbsp; <span translate="OMIT_THE_SERIAL_NO_&_QR_CODE"></span> (<span translate="OPTIONAL"></span>)</b></big><br>( <span translate="FOR_NORMAL_INFO_PURPOSE"></span>)</label></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><div><toggle ng-model="vm.label.isHideSerialNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" style="margin-top:20px"><div class="col-md-8 col-lg-8"><div class="form-group" style="margin-bottom:0px"><label><big><b><span translate="Step 4:"></span> &nbsp; {{ \'ENTER_PACKAGING_WEIGHT_AND_QTY\' | translate }}</b></big></label></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div style="width:275px;height:350px;margin:0 auto;"><img ng-src="{{vm.blobUrl}}assets/img/item-pack.png" style="width:275px;height:350px;position:absolute"><div style="width:175px;position:absolute;margin-top:85px;margin-left:50px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ServingSize.$invalid && (vm.dataForm.ServingSize.$dirty || vm.dataForm.$submitted)}"><label style="display:block;text-align:center"><b><big>{{ \'PACKAGING_WEIGHT\' | translate }}</big></b></label> <input type="number" name="ServingSize" class="form-control input-lg" min="1" step="1" required="" ng-disabled="!vm.isJobValid || vm.selectedProduct==null" ng-model="vm.label.servingSize"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ServingSize.$error.required">* {{ \'REQUIRED\' | translate }}</span></div><br><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UOM1.$invalid && vm.dataForm.$submitted}"><label style="display:block;text-align:center"><b><big>{{ \'U.O.M.\' | translate }}</big></b></label><select name="UOM1" class="form-control input-lg" ng-options="i as (i.name | uppercase) for i in vm.uomList1" ng-model="vm.selectedUom1" ng-disabled="!vm.isJobValid || vm.selectedProduct==null" ng-change="vm.onSelectedUom1Changed()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UOM1.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div><div class="col-md-2 col-lg-2"><div style="height:350px;line-height:375px"><i class="fa fa-times fa-5x"></i></div></div><div class="col-md-2 col-lg-2" style="padding-left:0px;padding-right:0px;"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InventoryQty.$invalid && (vm.dataForm.InventoryQty.$dirty || vm.dataForm.$submitted)}" style="margin-top:125px"><label style="display:block;text-align:center"><b><big>{{ \'QUANTITY\' | translate }}</big></b></label> <input type="number" class="form-control input-lg" name="InventoryQty" min="1" step="1" required="" ng-disabled="!vm.isJobValid || vm.selectedProduct==null" ng-model="vm.label.inventoryQty"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InventoryQty.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2" ng-if="vm.label.inventoryQty>1" style="padding-right:0px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UOM2.$invalid && vm.dataForm.$submitted}" style="margin-top:125px"><label style="display:block;text-align:center"><b><big>{{ \'U.O.M.\' | translate }}</big></b></label><select name="UOM2" class="form-control input-lg" ng-options="i as (i.name | uppercase) for i in vm.uomList2" ng-model="vm.selectedUom2" ng-disabled="!vm.isJobValid || vm.selectedProduct==null" ng-change="vm.onSelectedUom2Changed()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UOM2.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div></div><br><br><div class="row" ng-if="vm.isJobValid && vm.selectedProduct!=null"><div class="col-md-6 col-lg-6"><br><div class="form-group"><label><big><b><span translate="Step 5:"></span> &nbsp; <span translate="SELECT_A_PRINTING_OPTION"></span></b></big><i class="fa fa-asterisk req"></i></label><div style="padding:15px 15px 15px;background:#fffeb7"><div class="row"><div class="col-md-6 col-lg-6"><label class="radio-inline custom-radio nowrap"><input type="radio" data-ng-model="vm.label.printOption" data-ng-value="1" ng-disabled="!vm.isJobValid"> <span><big><span translate="PRINT"></span> <b translate="ONE"></b> <span translate="LABEL"></span> (<span translate="FOR"></span> <b style="color:#00f">{{vm.label.inventoryQty}}</b> {{ \'PACKAGING\' | translate }} {{ (vm.label.inventoryQty!=1?\'s\':\'\') }})</big></span></label></div><div class="col-md-6 col-lg-6" ng-if="vm.label.inventoryQty>1"><label class="radio-inline custom-radio nowrap"><input type="radio" data-ng-model="vm.label.printOption" data-ng-value="2" ng-disabled="!vm.isJobValid"> <span><big><b translate="MULTIPLE"></b> <span translate="LABELS"></span> ({{ \'ONE_LABEL_FOR_EACH_PACKAGING\' | translate }})</big></span></label></div></div><div class="row" style="margin-top:10px"><div class="col-md-6 col-lg-6"><div class="row"><div class="col-lg-11" ba-panel=""><div style="padding:10px !important;line-height:150%"><span style="color:#bbb">{{ \'PRODUCT_NAME\' | translate }} : XXXXXXX</span><br><span style="color:#bbb">{{ \'INGREDIENT\' | translate }} : XXXXXXX</span><br>{{ \'PACKAGING_WEIGHT\' | translate }} : <b>{{vm.label.servingSize || \'_____\'}}</b> <span>{{vm.label.servingUom || \'KG\'}}</span> {{(vm.label.inventoryQty==1 || !vm.label.inventoryQty)?\'\':\'x \'}} <b ng-show="vm.label.inventoryQty!=null && vm.label.inventoryQty!=1">{{vm.label.inventoryQty || \'\'}}</b> <span ng-show="vm.label.inventoryQty!=null && vm.label.inventoryQty!=1">{{vm.label.inventoryUom || \'\'}}</span><br><span style="color:#bbb"><span translate="MFG_DATE"></span> : dd/mm/yyyy</span><br><span style="color:#bbb"><span translate="EXP_DATE"></span> : dd/mm/yyyy</span><br></div></div></div></div><div class="col-md-6 col-lg-6" ng-if="vm.label.inventoryQty>1"><div class="row"><div class="col-lg-11" ba-panel=""><div style="padding:10px !important;line-height:150%"><span style="color:#bbb">{{ \'PRODUCT_NAME\' | translate }} : XXXXXXX</span><br><span style="color:#bbb">{{ \'INGREDIENT\' | translate }} : XXXXXXX</span><br>{{ \'PACKAGING_WEIGHT\' | translate }} : <b>{{vm.label.servingSize || \'_____\'}}</b> <span>{{vm.label.servingUom || \'KG\'}}</span><br><span style="color:#bbb"><span translate="MFG_DATE"></span> : dd/mm/yyyy</span><br><span style="color:#bbb"><span translate="EXP_DATE"></span> : dd/mm/yyyy</span><br></div></div><div class="col-lg-11" ng-show="vm.label.inventoryQty>1 && !!vm.label.inventoryQty" ba-panel=""><div style="padding:10px 0px"><center><span translate="AND"></span> {{vm.label.inventoryQty-1}} <span translate="MORE"></span>...</center></div></div></div></div></div><div class="row" style="margin-top:10px"><div class="col-md-6 col-lg-6"><button class="btn btn-primary btn-with-icon btn-lg" ng-disabled="!vm.isJobValid" ng-confirm-click="Confirm proceed to print label?" confirmed-click="vm.submit(vm.dataForm)"><i class="fa fa-print"></i> <span translate="PRINT_LABEL"></span></button></div></div></div></div></div></div><div class="row"><p>&nbsp;</p><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'REPRINT_LABEL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="RE-PRINT_PRODUCT_LABEL_WHICH_FULFILL_THE_FOLLOWING_CONDITIONS"></span>:<ul style="color:#00f"><li translate="THE_LABEL_IS_NOT_VOIDED_BEFORE">.</li></ul></p><br><div class="row"><div class="col-md-3 col-lg-3"><h3><b translate="ENTER_THE_LABEL_SERIAL_NO">.</b> <i class="fa fa-asterisk req"></i></h3></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ReprintSerialNo.$invalid && (vm.dataForm.ReprintSerialNo.$dirty || vm.dataForm.$submitted)}"><input type="text" name="ReprintSerialNo" class="form-control" placeholder="e.g. FG/19/00000001" ng-model="vm.serialNo" ng-disabled="vm.isLoading" ng-required="$tabSetStatus.activeTab==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ReprintSerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><br><div class="row"><div class="col-md-3 col-lg-3"><h3><b>{{ \'NO_OF_LABEL\' | translate }}</b> <i class="fa fa-asterisk req"></i></h3></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumberOfLabel.$invalid && (vm.dataForm.NumberOfLabel.$dirty || vm.dataForm.$submitted)}"><input type="number" name="NumberOfLabel" class="form-control" min="1" ng-model="vm.numberOfLabel" ng-disabled="vm.isLoading" ng-required="$tabSetStatus.activeTab==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumberOfLabel.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumberOfLabel.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumberOfLabel.$error.min">* Minimum is 1</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row" style="margin-top:10px"><div class="col-md-3 col-lg-3"><button type="submit" class="btn btn-info btn-with-icon btn-lg" style="background:#286090 !important" ng-disabled="vm.isLoading || $tabSetStatus.activeTab!=1" ng-confirm-click="Confirm re-print this label?" confirmed-click="vm.reprintLabel()"><i class="fa fa-print"></i> <span translate="RE-PRINT_LABEL"></span></button></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'VOID_LABEL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="VOID_PRODUCT_LABEL_WHICH_FULFILL_THE_FOLLOWING_CONDITIONS"></span>:<ul style="color:#00f"><li><span>{{ \'THE_LABEL_IS_NOT_VOIDED_BEFORE\' | translate }}</span>.</li><li><span>{{ \'THE_LABEL_HAS_NOT_STOCK-IN_BEFORE\' | translate }}</span>.</li><li><span>{{ \'THE_LABEL_DOES_NOT_HAVE_ANY_INVENTORY_MOVEMENT_RECORD\' | translate }}</span>.</li></ul></p><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><h3><b translate="ENTER_THE_SERIAL_NO_/_SCAN_QR_CODE"></b> <i class="fa fa-asterisk req"></i></h3><input type="text" class="form-control" placeholder="e.g. SFG/19/0000001" ng-model="vm.serialNo" ng-disabled="vm.isLoading"></div></div></div><div class="row" style="margin-top:10px"><div class="col-md-3 col-lg-3"><a href="" class="btn btn-primary btn-with-icon btn-lg" ng-disabled="vm.isLoading" ng-confirm-click="Confirm void this label?" confirmed-click="vm.voidLabel()"><i class="fa fa-ban"></i> <span translate="VOID_LABEL"></span></a></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'LABEL_PRINT_QUEUE\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="LIST_OF_SEMIFG_LABEL_PRINT_QUEUE"></span>.</small></p><br><br><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.OBalBranch.$invalid && (vm.dataForm.OBalBranch.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_A_BRANCH"></b> <i class="fa fa-asterisk req"></i></label><div class="row"><div class="col-lg-3"><select class="form-control" name="OBalBranch" ng-options="u as (u.name | uppercase) for u in vm.branches track by u.id" ng-model="vm.selectedBranch" ng-change="vm.selectedBranchChanged()" ng-required="$tabSetStatus.activeTab==3"><option></option></select></div><div class="col-lg-9"><button type="button" class="btn btn-success btn-with-icon" style="margin-right:30px" ng-disabled="vm.isLoading || vm.selectedBranch==null" ng-click="vm.showDownloadExcelModal()" rms-check-access="label.semifgs" rms-check-access-perm-type="EXPORT"><i class="fa fa-download"></i> <span translate="DOWNLOAD_EXCEL_OR_PDF"></span></button> <button type="button" class="btn btn-warning btn-with-icon" style="margin-right:10px;color:#000" ng-disabled="vm.isLoading || vm.selectedBranch==null" ng-confirm-click="Confirm purge all Labels Print Queue?" confirmed-click="vm.purgeLabels()"><i class="fa fa-trash"></i> <span translate="PURGE_NORMAL_LABELS"></span></button> <button type="button" class="btn btn-warning btn-with-icon" style="color:#000" ng-disabled="vm.isLoading || vm.selectedBranch==null" ng-confirm-click="Confirm purge all Labels Test Print Queue?" confirmed-click="vm.purgeTestLabels()"><i class="fa fa-trash"></i> <span translate="PURGE_TEST_PRINT_LABELS"></span></button></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.OBalBranch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-8"><div style="max-height:250px;overflow:auto"><table class="table table-striped" style="border:5px solid #eee;font-size:90%"><thead><tr><th><b><span translate="SERIAL_NO"></span>.</b></th><th><b translate="SEMI_FG_CODE"></b></th><th><b translate="SEMI_FG_NAME"></b></th><th><b><span translate="JOB_NO"></span>.</b></th></tr></thead><tbody><tr ng-if="vm.pendingLabels.length==0 && !vm.isLoading"><td colspan="4" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="4" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.pendingLabels"><td>{{item.serialNo}}</td><td>{{item.semiFgCode}}</td><td>{{item.semiFgName}}</td><td>{{item.jobNo || \'-\'}}</td></tr></tbody></table></div><br><span translate="TOTAL_LABELS"></span>: <b>{{vm.pendingLabels.length}}</b></div></div><p><br></p></uib-tab><uib-tab heading="{{ \'OPENBAL_LABEL\' | translate }}" rms-check-access="label.semifgsob" rms-check-access-perm-type="ACCESS"><p><i class="fa fa-info-circle"></i> <span translate="CREATE_OPENING_BALANCE_LABEL_FOR_EXISTING_SEMI_F.G._STOCKS"></span>:</p><br><div class="row"><div class="col-md-3 col-lg-3"><a href="" class="btn btn-success btn-with-icon" ui-sref="label.semifgs.import" rms-check-access="label.semifgs" rms-check-access-perm-type="CREATE"><i class="fa fa-upload"></i><span translate="IMPORT_FROM_EXCEL"></span></a></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div></form><div class="footer-bar"><a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a></div><script type="text/ng-template" id="downloadModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="EXPORT_TRANSACTIONS_INTO_EXCEL_OR_PDF"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <p translate="EXPORT_SEMIFG_LABEL_INTO_EXCEL">.</p> <p>{{\'BRANCH\' | translate}}: <b>{{$mdl.branchName}}</b></p> <br /><br /> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"><span translate="EXPORT_NEW_TRANSACTIONS"></span></legend> <div class="row" ng-if="!$mdl.isLoading"> <div class="col-md-6 col-lg-6"> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcel()"> <i class="fa fa-file-excel-o"></i> {{\'GENERATE_EXCEL\' | translate}} </a> </div> <div class="col-md-6 col-lg-6"> <a href class="btn btn-danger btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadPdf()"> <i class="fa fa-file-pdf-o"></i> {{\'GENERATE_PDF\' | translate}} </a> </div> </div> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <br /><br /> <div class="row" ng-if="$mdl.batchList.length!=0"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <select name="BatchNo" class="form-control" style="margin-bottom:10px;background:#fffeed" ng-model="$mdl.selectedBatchId" ng-change="$mdl.selectedBatchIdChanged()" ng-options="i as i for i in $mdl.batchList"> <option value="">={{ \'SELECT_ONE\' | translate }}=</option> </select> <div class="row" ng-if="!$mdl.isLoading"> <div class="col-md-6 col-lg-6"> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcelPast()"> <i class="fa fa-download"></i> {{\'DOWNLOAD_EXCEL\' | translate}} </a> </div> <div class="col-md-6 col-lg-6"> <a href class="btn btn-danger btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadPdfPast()"> <i class="fa fa-download"></i> {{\'DOWNLOAD_PDF\' | translate}} </a> </div> </div> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <div class="row" ng-if=$mdl.batchList.length==0> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <br /> <center> <b class="text-primary"><i class="fa fa-info-circle"></i> <span translate="NO_PREVIOUS_EXPORT_AVAILABLE"></span></b> </center> </div> </div> </div> <hr /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script><script type="text/ng-template" id="JobListModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ \'SELECT_A_COMPLETED_JOB_SEMIFG\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:9pt;color:#000" st-pipe="$mdl.retrieveData" st-table="$mdl.data" refresh-table> <thead> <tr class="sortable"> <th colspan="7" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th style="width:60px">#</th> <th st-sort="jobNo" st-sort-default="reverse" style="width:130px">{{ \'JOB_NO\' | translate }}</th> <th st-sort="jobDate">{{ \'JOB_DATE\' | translate }}</th> <th></th> <th st-sort="productName">{{ \'PRODUCT_NAME\' | translate }}</th> <th class="hide-after" style="text-align:center">{{ \'QUANTITY_BATCH\' | translate }}</th> <th style="width:40px"></th> </tr> <tr class="sortable"> <th class="form-inline" style="padding-left:0px;padding-right:0px" colspan="{{vm.showCjsPanel ? 2 : 1}}"> <a href class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search> {{ \'RESET\' | translate }} </a> </th> <th class="form-inline" colspan="2"> <input st-search="jobNo" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th></th> <th class="form-inline"> <input st-search="productName" class="form-control input input-sm" style="width:120px;background:#fffeed" /> </th> <th colspan="2"> <b ng-if="$mdl.isLoading" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ... </b> </th> </thead> <tbody> <tr ng-if="!$mdl.isLoading && $mdl.data.length==0"> <td colspan="7" style="line-height:100px"> <center><b>{{ \'NO_PROD_JOB_AVAILABLE\' | translate }}</b></center> </td> </tr> <tr ng-repeat="item in $mdl.data"> <td>{{vm.startIndex+1+$index}})</td> <td>{{item.jobNo}}</td> <td>{{item.jobDate | date: "dd/MM/yyyy"}}</td> <td class="text-center" style="width:80px;line-height:90%"> <div class="report-type-tag"> <b>{{item.productType.replace(\' \', \'\') | translate }}</b> </div> </td> <td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{item.productName}}</td> <td style="text-align:center"><b>{{item.quantity}}</b></td> <td align="center"> <a href title="Select" class="btn btn-primary btn-xs btn-with-icon" ng-click="$mdl.selectJob(item.jobNo)"> <big><i class="fa fa-check"></i> {{ "SELECT" | translate }}</big> </a> </td> </tr> </tbody> </table> </div> </div> </div> <hr style="margin-top:0px;margin-bottom:10px" /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/label/semifgs/semifgImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b translate="IMPORT_SEMI_F.G._OPENING_BALANCE_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile()" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS">.</strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong><span translate="FAILED_TO_UPLOAD_FILE"></span>.</strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend translate="IMPORT_GUIDELINES">:</legend><ol class="import"><li><span translate="YOU_NEED_TO_FOLLOW_THE_INSTRUCTION_BELOW_IF_YOU_ARE_NEW_TO_THE_RMS"></span>.</li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA_FIRST,_THEN_IMPORT_INTO_THE_RMS"></span>:<br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'Semi F.G. Opening Balance Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_SEMI_F.G._OPENING_BALANCE_TEMPLATE"></span></a></li></ol></fieldset><br>&nbsp;<br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong><span translate="FILE_UPLOADED_SUCCESSFULLY"></span>. <span translate="CHOOSE_THE_OPTIONS_BELOW_AND_PROCEED_TO_IMPORT_THE_DATA"></span>.</strong></div><div><fieldset><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-warning btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-refresh"></i> {{ \'RESET\' | translate}}</a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><br><br><fieldset><legend><span translate="SEMI_F.G._OPENING_BALANCE_DATA_PREVIEW"></span>:</legend></fieldset></div><div class="horizontal-scroll"><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important"><thead><tr><th style="width:60px">#</th><th><b translate="BRANCH_CODE"></b></th><th><b>{{ \'PRODUCT_CODE\' | translate }}</b></th><th nowrap="nowrap"><b>{{ \'PRODUCT_DESCRIPTION\' | translate }}</b></th><th style="text-align:right !important" nowrap="nowrap"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b translate="UOM"></b></th></tr><tr><th colspan="7">{{ \'TOTAL_RECORDS\' | translate}}: {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.branchCode || \'\' }}</td><td>{{ row.itemCode || \'\' }}</td><td nowrap="nowrap">{{ row.itemDescription || \'\' }}</td><td style="text-align:right;color:#00f">{{ row.quantity || \'\' | number }}</td><td>{{ row.uom || \'\' }}</td></tr><tr><td colspan="7" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="7">{{ \'TOTAL_RECORDS\' | translate}}: {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-6 col-lg-6"><em><small><i class="fa fa-info-circle"></i> <span translate="PROCESSING"></span>...</small></em><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><p translate="THE_DATA_IS_CURRENTLY_BEING_PROCESSED._IT_IS_SAFE_TO_LEAVE_THIS_PAGE_NOW."></p><p><span translate="YOU_WILL_RECEIVE_AN_EMAIL_NOTIFICATION_ABOUT_THE_IMPORT_RESULT_ONCE_THE_SERVER_HAS_FINISHED_PROCESSED_THE_DATA"></span>.</p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="label.semifgs.print" ng-disabled="vm.isExporting || vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_PREVIOUS_SCREEN"></span></a></div></form></div>');
$templateCache.put('app/pages/outletops/srnlist/srnList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="StoreReceivingNoteList" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table=""><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isCurrentMonth" class="form-control input"><option value="">{{ \'SHOW_CURRENT_MONTH_DOCS_ONLY\' | translate }}</option><option value="1">{{ \'SHOW_ALL_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:35px;line-height:35px"></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="docNo">{{ \'DOC_NO\' | translate}}</th><th st-sort="createdDate">{{ \'DOC_DATE\' | translate}}</th><th st-sort="deliveryOrderNo">{{ \'DELIVERY_ORDER_NO\' | translate}}</th><th st-sort="branchName">{{ \'BRANCH_NAME\' | translate}}</th><th>{{ \'REMARKS\' | translate}}</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th colspan="2" class="form-inline"><input st-search="docNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="deliveryOrderNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="branchName" class="form-control input input-sm" style="width:120px"></th><th colspan="3"></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><center><b style="font-size:16pt"><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></td></tr><tr ng-if="vm.data.length<=0 && !vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}.</center></td></tr><tr ng-repeat="item in vm.data"><td>{{ vm.startIndex+1+$index }})</td><td>{{ item.docNo }}</td><td>{{ item.createdDate | date:\'dd/MM/yyyy\' }}</td><td>{{ item.deliveryOrderNo }}</td><td>{{ item.branchName | uppercase }}</td><td>{{item.remarks || \'-\'}}</td><td align="center"><a href="" title="Print SRN" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#00f" ng-click="vm.printSRN(item.id, item.docNo)" rms-check-access="outletops.srnlist" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="View" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="outletops.srnlist.update({id:item.id})" rms-check-access="outletops.srnlist" rms-check-access-perm-type="UPDATE"><i class="fa fa-eye"></i></a></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="labelModal.html"><form name="$mdl.stepForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:80%" st-pipe="$mdl.retrieveData" st-table="$mdl.mvmtData" refresh-table> <thead> <tr> <th colspan="5" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.item.receivingNo}} </div> <span translations="FIFO_LABEL_LIST"></span> </h3> </div> </th> </tr> <tr> <th colspan="5" style="padding-left:0px;padding-right:0px"> <div class="col-md-4 col-lg-4" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Label" class="input form-control" /> </div> </div> <div class="col-md-8 col-lg-8" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr> <th><b translate="CODE"></b></th> <th><b translate="DESCRIPTION"></b></th> <th><b translate="STORAGE"></b></th> <th><b translations= "S/N_FROM"></b></th> <th><b translations= "S/N_TO"></b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="5"> <div style="padding:20px 0px"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="LOADING_LABELS"></span> ...</b></center> </div> </td> </tr> <tr ng-if="$mdl.labelData.length==0"> <td colspan="5"><span translate="NO_FIFO_LABEL_AVAILABLE"></span>.</td> </tr> <tr ng-repeat="m in $mdl.labelData"> <td>{{m.itemCode | uppercase}}</td> <td>{{m.itemName | uppercase}}</td> <td>{{m.storageName | uppercase}}</td> <td>{{m.serialNoFrom | uppercase}}</td> <td>{{m.serialNoTo | uppercase}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="downloadModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="EXPORT_TRANSACTIONS_INTO_EXCEL"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <p translate="EXPORT_THE_GRN_TRANSACTIONS_INTO_EXCEL_FORMAT_FOR_ACCOUNTING_SOFTWARE"></p> <br /><br /> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"><span translate="EXPORT_NEW_TRANSACTIONS"></span></legend> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcel()"> <i class="fa fa-download"></i> <span translate="GENERATE_EXCEL"></span> </a> <b ng-if="$mdl.isLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </div> </div> <br /><br /> <div class="row" ng-if=$mdl.batchList.length!=0> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <select name="BatchNo" class="form-control" style="margin-bottom:10px;background:#fffeed" ng-model="$mdl.selectedBatchId" ng-change="$mdl.selectedBatchIdChanged()" ng-options="i as i for i in $mdl.batchList"> <option value="">{{ \'SELECT_ONE\' | translate }}</option> </select> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcelPast()"> <i class="fa fa-download"></i> <span translate="DOWNLOAD_EXCEL"></span> </a> <b ng-if="$mdl.isLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </div> </div> <div class="row" ng-if=$mdl.batchList.length==0> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <br /> <center> <b class="text-primary"><i class="fa fa-info-circle"></i> <span translate="NO_PREVIOUS_EXPORT_AVAILABLE"></span></b> </center> </div> </div> </div> <hr /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/outletops/srnlist/srnUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-lg-12"><br><legend style="padding-bottom:5px"><span translate="SRN_NO"></span>: {{vm.srn.docNo}}</legend></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group"><label><b>{{ \'BRANCH_NAME\' | translate }}</b></label> <span class="form-control" ng-disabled="true">{{vm.srn.branchName || \'\'}}</span></div></div><div class="col-md-4 col-lg-3"><div class="form-group"><label><b><span translate="DELIVERY_ORDER_NO"></span></b></label> <span class="form-control" ng-disabled="true">{{vm.srn.deliveryOrderNo || \'\'}}</span></div></div></div><div class="row"><div class="col-md-8 col-lg-6"><div class="form-group"><label><b><span translate="REMARKS"></span></b></label> <textarea class="form-control" placeholder="Remarks" rows="3" ng-model="vm.srn.remarks">\n\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p><br><br></p></div></uib-tab><uib-tab heading="Received Items"><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped table-hover" style="font-size:90%"><thead><tr><th style="width:40px">#</th><th style="width:100px"><b>{{ \'STATUS\' | translate }}</b></th><th style="width:100px;text-align:right"><b translate="QTY_RECV"></b></th><th style="width:80px"><b translate="U.O.M."></b></th><th><b><span translate="SERIAL_NO"></span>.</b></th><th><b><span translate="BATCH_NO"></span>.</b></th><th><b><span translate="TEMP"></span> (&deg;C)</b></th><th><b translate="EXP._DATE"></b></th><th><b>{{ \'REMARKS\' | translate }}</b></th><th></th></tr></thead><tbody ng-if="!vm.isLoading" ng-repeat="(key, value) in vm.srn.stockReceivingItems | groupBy: \'[productCode, productName]\'"><tr ng-if="key !== \'undefined\'" class="text-uppercase"><td colspan="10"><big><b>[{{key.split(\',\')[0]}}] &nbsp;{{key.split(\',\')[1]}}</b></big></td></tr><tr ng-repeat="item in value | orderBy:\'serialNo\'" ng-class="{ \'report-colorchange\' : item.isProcessing }"><td>{{$index+1}})</td><td><span ng-if="item.status!=\'ACCEPTED\'" class="text-danger"><b translate="REJECTED"></b>&nbsp;</span> <span ng-if="item.status==\'ACCEPTED\'" class="text-success"><b translate="ACCEPTED"></b></span></td><td style="text-align:right">{{item.quantity | number }}</td><td>{{item.uomName | uppercase}}</td><td nowrap="nowrap">{{ item.serialNo || \'-\' }}</td><td nowrap="nowrap">{{ item.batchNo || \'-\' }}</td><td nowrap="nowrap">{{ item.temperature || \'-\' }}</td><td nowrap="nowrap">{{ item.expiryDate || \'-\' | date:\'dd/MM/yyyy\' }}</td><td nowrap="nowrap" style="padding-top:8px;padding-top:8px;line-height:150%"><span>{{ item.remarks || \'-\' }}</span></td><td nowrap="nowrap" style="width:80px"><a href="" class="btn btn-with-icon btn-primary btn-xs" ng-if="item.imageLocation!=null && item.imageLocation!=\'\'" ng-click="vm.viewPhotos(item.productCode, item.productName, item.imageLocation)"><i class="fa fa-picture-o"></i> Photos</a></td></tr></tbody><tbody style="display:none"><tr ng-repeat="item in vm.srn.stockReceivingItems"><td>{{$index+1}})</td><td><span ng-if="item.status!=\'ACCEPTED\'" class="text-danger"><b translate="REJECTED"></b>&nbsp;</span> <span ng-if="item.status==\'ACCEPTED\'" class="text-success"><b translate="ACCEPTED"></b></span></td><td>{{ item.productCode || \'\' }}</td><td nowrap="nowrap">{{ item.productName }}</td><td style="text-align:right">{{item.quantity | number }}</td><td>{{item.uomName | uppercase}}</td><td nowrap="nowrap">{{ item.serialNo || \'-\' }}</td><td nowrap="nowrap">{{ item.batchNo || \'-\' }}</td><td nowrap="nowrap">{{ item.temperature || \'-\' }}</td><td nowrap="nowrap">{{ item.expiryDate || \'-\' | date:\'dd/MM/yyyy\' }}</td><td nowrap="nowrap" style="padding-top:8px;padding-top:8px;line-height:150%"><span>{{ item.remarks || \'-\' }}</span></td><td nowrap="nowrap" style="width:80px"><a href="" class="btn btn-with-icon btn-primary btn-xs" ng-if="item.imageLocation!=null && item.imageLocation!=\'\'" ng-click="vm.viewPhotos(item.productCode, item.productName, item.imageLocation)"><i class="fa fa-picture-o"></i> Photos</a></td><td nowrap="nowrap" style="width:80px"></td></tr><tr><td colspan="13" align="center" ng-show="vm.srn.stockReceivingItems.length==0"><br><span translate="RECEIVED_ITEM_LIST_IS_EMPTY"></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.srn.stockReceivingItems.length }}</b></div></td></tr></tfoot></table><div class="row"><p><br><br></p></div></div></div></uib-tab></uib-tabset></div></div></div><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" style="margin-right:30px" ui-sref="outletops.srnlist"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a><a href="" title="Print GRN" class="btn btn-primary btn-with-icon" ng-click="vm.printGRN(vm.srn.id, vm.srn.docNo)" rms-check-access="outletops.srnlist" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <span translate="PRINT_SRN"></span></a></div></section></form><script type="text/ng-template" id="itemModal.html"><form name="$mdl.itemForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="UPDATE_GRN_ITEM_DETAILS"></span></h3> </div> <div class="modal-body" id="modal-body"> <p style="color:#f00"><i class="fa fa-info-circle"></i> <span translate="CHANGES_MADE_HERE_WILL_BE_SAVED_UPON_CONFIRMATION"></span> <br />&nbsp;</p> <div class="form-group"> <label><b translate="SELECT_A_RAW_MATERIAL"></b></label> <ui-select ng-model="$mdl.selectedItem" name="Item" title="Select or Search for Raw Materials..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.onSelectedItemChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Raw Materials..."> <span>{{ $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.itemList | filter: $select.search" refresh="$mdl.loadItemList($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="i.description | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.Item.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> <div class="form-group"> <div class="row"> <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"> <label><b translate="QUANTITY"></b></label> <input type="number" name="Quantity" class="form-control" style="background:#fffeed" ng-model="$mdl.receivingItem.quantity" min="0.01" step="1" required ng-change="$mdl.onQuantityChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.Quantity.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.Quantity.$error.number && $mdl.itemForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> </div> <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"> <label><b translate="UOM"></b></label> <select name="UOM" class="form-control" style="background:#edfbff" ng-disabled="!$mdl.selectedItem" ng-options="i as (i.name | uppercase) for i in $mdl.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.onSelectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.UOM.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="form-group"> <div class="row"> <p>&nbsp;</p> <p>&nbsp;</p> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="photoModal.html"><form name="$mdl.itemForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> {{$mdl.itemCode}} - {{$mdl.itemName}} <br /> Photo Gallery </h3> </div> <div class="modal-body" id="modal-body"> <div style="margin-bottom:10px;background:#333;height:350px;"> <center> <img ng-src="{{$mdl.selectedPhoto}}" align="center" style="height:350px" /> </center> </div> <div style="overflow-x:auto"> <img ng-src="{{$mdl.rootUrl}}{{i}}" ng-repeat="i in $mdl.photoArray" style="max-width:150px;max-height:80px;margin-right:5px;border:1px solid #000;cursor:pointer" ng-click="$mdl.selectPhoto(i)" /> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/maintenance/debtorcategories/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CategoryName.$invalid && (vm.dataForm.CategoryName.$dirty || vm.dataForm.$submitted)}"><label for="CategoryName"><b>{{ \'CATEGORY_NAME\' | translate}}</b>&nbsp; <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CategoryName" ng-model="vm.category.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CategoryName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/maintenance/debtorcategories/debtorcategoryCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/debtorcategories/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_CATEGORY"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.debtorcategories.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/debtorcategories/debtorcategoryList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.categoryData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.debtorcategories.create" rms-check-access="maintenance.debtorcategories" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_CATEGORY"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="name"><span translate="CATEGORY_NAME"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.categoryData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.categoryData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.debtorcategories.update({id:item.id})" rms-check-access="maintenance.debtorcategories" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Category" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteCategory(item.id, item.name)" ng-confirm-click="Confirm delete this category?" rms-check-access="maintenance.debtorcategories" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/debtorcategories/debtorcategoryUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/debtorcategories/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:20px" ui-sref="maintenance.debtorcategories.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.debtorcategories.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/bulkbreakconfig/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_BULK-BREAK_CONFIGURATION_FOR_RAW_MATERIAL_/_SEMI_FINISHED_GOODS_/_FINISHED_GOODS"></span><br><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.RawMaterial.$invalid && vm.dataForm.$submitted}"><label><b translate="SELECT_AN_ORIGINAL_ITEM"></b> <i class="fa fa-asterisk req"></i></label><div style="background:#d8ffd8;margin-bottom:5px"><uib-tabset active="vm.activeTab"><uib-tab heading="{{ \'RAW_MATERIAL\' | translate}}"><div class="form-group"><div class="row"><div class="col-lg-12"><label><b translate="RAW_MATERIAL"></b><br><small><i class="fa fa-info-circle"></i> {{ \'SELECT_RAW_MATERIAL_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small></label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="vm.selectedItem!=null" ng-click="vm.clearSelection()"><i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }}</button><ui-select ng-model="vm.selectedItem" title="Select or Search for Raw Materials..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.selectedItemChanged()" style="background:#fff"><ui-select-match placeholder="Search for Raw Materials..."><span>{{ $select.selected.description }}</span></ui-select-match><ui-select-choices repeat="i in vm.itemList | filter: $select.search" refresh="vm.loadItemList($select.search)" refresh-delay="250" minimum-input-length="3"><span ng-bind-html="i.description | highlight: $select.search"></span></ui-select-choices></ui-select><p class="help-block" style="color:#f00" ng-show="vm.dataForm.ItemName.$error.required && vm.dataForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p></div></div></div></uib-tab><uib-tab heading="{{ \'SEMI_FINISHED_GOODS\' | translate}}"><div class="form-group"><div class="row"><div class="col-lg-12"><label><b translate="SEMI_FINISHED_GOODS"></b><br><small><i class="fa fa-info-circle"></i> <span translate="SELECT_SEMI_FINISHED_GOODS_WHICH_EXISTS_IN_THE_SYSTEM"></span></small></label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="vm.selectedSemiFg!=null" ng-click="vm.clearSelection()"><i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }}</button><ui-select ng-model="vm.selectedSemiFg" title="Select or Search for Semi Finished Goods..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.selectedSemiFgChanged()" style="background:#fff"><ui-select-match placeholder="Search for Semi Finished Goods..."><span>{{ $select.selected.description }}</span></ui-select-match><ui-select-choices repeat="i in vm.semiFgList | filter: $select.search" refresh="vm.loadSemiFgList($select.search)" refresh-delay="250" minimum-input-length="2"><span ng-bind-html="i.description | highlight: $select.search"></span></ui-select-choices></ui-select><p class="help-block" style="color:#f00" ng-show="vm.dataForm.ItemName.$error.required && vm.dataForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p></div></div></div></uib-tab><uib-tab heading="Finished Goods"><div class="form-group"><div class="row"><div class="col-lg-12"><label><b>{{ \'FINISHED_GOODS\' | translate }}</b><br><small><i class="fa fa-info-circle"></i> <span translate="SELECT_FINISHED_GOODS_WHICH_EXISTS_IN_THE_SYSTEM"></span></small></label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="vm.selectedProduct!=null" ng-click="vm.clearSelection()"><i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }}</button><ui-select ng-model="vm.selectedProduct" title="Select or Search for Finished Goods..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.selectedProductChanged()" style="background:#fff"><ui-select-match placeholder="Search for Finished Goods..."><span>{{ $select.selected.name }}</span></ui-select-match><ui-select-choices repeat="i in vm.productList | filter: $select.search" refresh="vm.loadProductList($select.search)" refresh-delay="250" minimum-input-length="2"><span ng-bind-html="i.name | highlight: $select.search"></span></ui-select-choices></ui-select><p class="help-block" style="color:#f00" ng-show="vm.dataForm.ItemName.$error.required && vm.dataForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p></div></div></div></uib-tab></uib-tabset></div><input type="text" name="ItemName" class="form-control" ng-model="vm.mgmt.itemName" required="" ng-hide="true"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity.$invalid && (vm.dataForm.Quantity.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity" ng-model="vm.mgmt.quantity" min="1" required=""> <span class="help-block" style="color:#f00" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.min">* <span translate="MINIMUM_IS_1"></span></span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UOM.$invalid && (vm.dataForm.UOM.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'U.O.M.\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="UOM" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in vm.uomList" ng-model="vm.selectedUom" ng-change="vm.selectedUomChanged()" required=""></select><p class="help-block" style="color:#f00" ng-show="vm.dataForm.UOM.$error.required && vm.dataForm.$submitted">* {{ \'REQUIRED\' | translate }}</p></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION_/_REMARKS"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Description" ng-model="vm.mgmt.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Break-Down Items" ng-if="vm.selectedItem!=null || vm.selectedSemiFg!=null || vm.selectedProduct!=null"><p><i class="fa fa-info-circle"></i> <span translate="ADD_THE_BREAK-DOWN_RAW_MATERIAL_/_SEMI_FINISHED_GOODS_/_FINISHED_GOODS"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddItemModal()"><i class="ion-plus-round"></i> {{ \'ADD_ITEM\' | translate }}</a><br><br></p><div class="row"><div class="col-md-9 col-lg-9"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th></th><th><b>{{ \'ITEM_CODE\' | translate }}</b></th><th><b>{{ \'ITEM_NAME\' | translate }}</b></th><th class="hide-after" style="text-align:right"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b translate="U.O.M"></b></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="item in vm.mgmt.bulkBreakConfigDetails"><td>{{ $index+1 }})</td><td class="text-center" style="width:80px;line-height:100%"><div class="report-type-tag">{{ item.itemType }}</div></td><td>{{ item.itemCode }}</td><td>{{ item.itemName }}</td><td style="text-align:right">{{ item.quantity }}</td><td>{{ item.uomName }}</td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditItemModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeItem($index)" ng-confirm-click="Confirm remove this Raw Material?"><i class="fa fa-trash-o"></i>{{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="8" style="text-align:center" ng-if="!vm.mgmt.bulkBreakConfigDetails || vm.mgmt.bulkBreakConfigDetails.length==0"><br><span translate="ITEM_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="itemModal.html"><form name="$mdl.itemForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="ITEM"></span> </h3> </div> <div class="modal-body" id="modal-body"> <div style="background:#d8ffd8;margin-bottom:15px"> <uib-tabset active="$mdl.activeTab"> <uib-tab heading="{{ \'RAW_MATERIAL\' | translate}}"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <label> <b translate="RAW_MATERIAL"></b> <br /> <small><i class="fa fa-info-circle"></i> <span translate="SELECT_RAW_MATERIAL_WHICH_EXISTS_IN_THE_SYSTEM"></span> </small> </label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="$mdl.selectedItem!=null" ng-click="$mdl.clearSelection()"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> <ui-select ng-model="$mdl.selectedItem" title="Select or Search for Raw Materials..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedItemChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Raw Materials..."> <span>{{ $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.itemList | filter: $select.search" refresh="$mdl.loadItemList($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="i.description | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }} </p> </div> </div> </div> </uib-tab> <uib-tab heading="{{ \'SEMI_FINISHED_GOODS\' | translate}}"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <label> <b translate="SEMI_FINISHED_GOODS"></b> <br /> <small><i class="fa fa-info-circle"></i> <span translate="SELECT_SEMI_FINISHED_GOODS_WHICH_EXISTS_IN_THE_SYSTEM"></span> </small> </label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="$mdl.selectedSemiFg!=null" ng-click="$mdl.clearSelection()"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> <ui-select ng-model="$mdl.selectedSemiFg" title="Select or Search for Semi Finished Goods..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedSemiFgChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Semi Finished Goods..."> <span>{{ $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.semiFgList | filter: $select.search" refresh="$mdl.loadSemiFgList($select.search)" refresh-delay="250" minimum-input-length="2"> <span ng-bind-html="i.description | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }} </p> </div> </div> </div> </uib-tab> <uib-tab heading="Finished Goods"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <label> <b>{{ \'FINISHED_GOODS\' | translate }}</b> <br /> <small><i class="fa fa-info-circle"></i> <span translate="SELECT_FINISHED_GOODS_WHICH_EXISTS_IN_THE_SYSTEM"></span> </small> </label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="$mdl.selectedProduct!=null" ng-click="$mdl.clearSelection()"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> <ui-select ng-model="$mdl.selectedProduct" title="Select or Search for Finished Goods..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedProductChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Finished Goods..."> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.productList | filter: $select.search" refresh="$mdl.loadProductList($select.search)" refresh-delay="250" minimum-input-length="2"> <span ng-bind-html="i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }} </p> </div> </div> </div> </uib-tab> </uib-tabset> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.Quantity.$invalid && ($mdl.itemForm.Quantity.$dirty || $mdl.itemForm.$submitted)}"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.quantity" min=0.01 required> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Quantity.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Quantity.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }} </span> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Quantity.$error.min">* {{ \'MINIMUM_IS_0.01\' | translate }}</span> </div> </div> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.UOM.$invalid && ($mdl.itemForm.UOM.$dirty || $mdl.itemForm.$submitted)}"> <label><b>{{ \'U.O.M.\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <select name="UOM" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.selectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.UOM.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/maintenance/bulkbreakconfig/bulkbreakconfigCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/bulkbreakconfig/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.bulkbreakconfig.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/bulkbreakconfig/bulkbreakconfigList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="BulkBreakConfigListing" st-pipe="vm.retrieveData" st-table="vm.mgmtData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Configuration" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.bulkbreakconfig.create" rms-check-access="maintenance.bulkbreakconfig" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="itemName"><span translate="ORIGINAL_ITEM"></span></th><th st-sort="description">{{ \'DESCRIPTION\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.mgmtData.length==0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="LOADING_DATA_"></span>...</b></center></big></td></tr><tr ng-repeat="item in vm.mgmtData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.itemName}}</td><td>{{item.description}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.bulkbreakconfig.update({id:item.id})" rms-check-access="maintenance.bulkbreakconfig" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Sensor" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteRecord(item.id, item.itemName)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Record?" rms-check-access="maintenance.bulkbreakconfig" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/bulkbreakconfig/bulkbreakconfigUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/bulkbreakconfig/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.bulkbreakconfig.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i><span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.bulkbreakconfig.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/pos/products/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p>Please fill in the POS Product information.</p><div class="row">&nbsp;</div><div class="row"><div class="col-md-4 col-lg-4"><div class="row"><img ngf-src="picFile || vm.posprod.imageLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div><div class="row"><div class="col-md-12 col-lg-12"><p><small><i class="fa fa-info-circle"></i> <em>Recommended to upload a landscape image.</em></small></p>&nbsp;</div></div><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-disabled="vm.lockUploadButton" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> Upload Picture</div><a href="" ng-click="picFile=null;vm.setUploadImage(picFile)" ng-show="picFile" class="btn btn-default btn-with-icon" ng-disabled="vm.lockUploadButton"><i class="ion ion-android-remove-circle"></i> Reset Picture</a></div><div class="row" ng-show="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> Upload function is disabled due to quota limit reached.</div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.selectedProduct==null && vm.dataForm.$submitted}"><label><b>Linked RMS Product</b> <i class="fa fa-asterisk req"></i></label> <a href="" ng-click="vm.clearProduct()" class="btn btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="vm.selectedProduct!=null"><i class="fa fa-trash"></i> Clear</a><ui-select class="btn-group bootstrap-select form-control" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" ng-disabled="false" append-to-body="false" search-enabled="true" ng-model="vm.selectedProduct" on-select="vm.selectedProductChanged()" required=""><ui-select-match placeholder="-- Select a Device --"><span>{{ ($select.selected.code + \' - \' + $select.selected.name) | uppercase }}</span></ui-select-match><ui-select-choices repeat="t in vm.products | filter: $select.search"><span ng-bind-html="(t.code + \' - \' + t.name) | uppercase | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.selectedProduct==null && vm.dataForm.$submitted">* Required</span></div></div></div><div class="row"><div class="form-group col-lg-12" ng-class="{\'has-error\': vm.dataForm.ProductCode.$invalid && (vm.dataForm.ProductCode.$dirty || vm.dataForm.$submitted)}"><label><b>POS Product Code</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ProductCode" ng-model="vm.posprod.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ProductCode.$error.required">* Required</span></div></div><div class="row"><div class="form-group col-lg-12" ng-class="{\'has-error\': vm.dataForm.ProductName.$invalid && (vm.dataForm.ProductName.$dirty || vm.dataForm.$submitted)}"><label><b>POS Product Name</b></label> <input type="text" class="form-control" name="ProductName" ng-model="vm.posprod.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ProductName.$error.required">* Required</span></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Is Active</b></label><br><div><toggle ng-model="vm.posprod.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div></div><div class="col-md-12 col-lg-12"><div><p>&nbsp;</p></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/pos/products/posproductCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/pos/products/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create Product</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="pos.products.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/pos/products/posproductList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.prodData" refresh-table=""><thead><tr><th colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Product" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="pos.products.create" rms-check-access="pos.products" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Product</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:150px" st-sort="code">Product Code</th><th st-sort="name">Product Name</th><th class="hide-after" style="text-align:center">Is Active</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.prodData.length==0 && !vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.prodData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td style="text-align:center"><i class="fa fa-check" ng-if="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="pos.products.update({id:item.id})" rms-check-access="pos.products" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Product" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteProduct(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this product?" rms-check-access="pos.products" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/pos/products/posproductUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/pos/products/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="pos.products.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.dataForm.$valid && vm.dataForm.$submitted"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="pos.products.list" ng-disabled="vm.dataForm.$valid && vm.dataForm.$submitted"><i class="ion ion-close"></i> Discard Changes</a> <a href="" class="btn btn-warning btn-with-icon" style="float:right" ng-disabled="vm.dataForm.$valid && vm.dataForm.$submitted" confirmed-click="vm.deletePosProduct()" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Product?" rms-check-access="pos.products" rms-check-access-perm-type="DELETE"><i class="ion ion-android-delete"></i> Delete Product</a></div></form>');
$templateCache.put('app/pages/maintenance/debtors/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CustomerCode.$invalid && (vm.dataForm.CustomerCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="CUSTOMER_CODE"></b> <i class="fa fa-asterisk req" ng-if="!vm.autoCode"></i></label> <input type="text" class="form-control" name="CustomerCode" ng-model="vm.debtor.code" ng-disabled="vm.autoCode" ng-required="!vm.autoCode"> <input type="checkbox" ng-change="vm.autoCodeChanged()" ng-model="vm.autoCode"> {{\'AUTO_GENERATE\' | translate}} <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CustomerCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><label translate="STATUS"></label><div><toggle ng-model="vm.debtor.active" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CustomerName.$invalid && (vm.dataForm.CustomerName.$dirty || vm.dataForm.$submitted)}"><label><b translate="CUSTOMER_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CustomerName" ng-model="vm.debtor.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CustomerName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CustomerCategory.$invalid && (vm.dataForm.CustomerCategory.$dirty || vm.dataForm.$submitted)}"><label for="Status"><b translate="CUSTOMER_CATEGORY"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="CustomerCategory" style="color:#333" ng-options="u as u.name for u in vm.categories track by u.id" ng-change="vm.selectedCustomerCategoryChanged()" ng-model="vm.selectedCustomerCategory" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CustomerCategory.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label for="Status"><b translate="CUSTOMER_SERVICE_OFFICER"></b></label><select class="form-control" name="CustomerService" style="color:#333" ng-options="u as (u.firstName + \' \' + u.lastName) for u in vm.customerServiceUsers track by u.id" ng-change="vm.selectedCustomerServiceChanged()" ng-model="vm.selectedCustomerService"><option></option></select></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="COMPANY_REGISTRATION_NO"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.companyRegNo"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="GST_REGISTRATION_NO."></b></label> <input type="text" class="form-control" name="CustomerName" ng-model="vm.debtor.gstRegNo"></div></div></div><div class="row" style="padding:1rem 0 2rem 0;"><div class="col-md-6 col-lg-6"><strong><u>{{ \'BILLING_ADDRESS\' | translate }}</u></strong></div><div class="col-md-6 col-lg-6"><strong><u>{{ \'DELIVERY_ADDRESS\' | translate }}</u></strong></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Address1.$invalid && (vm.dataForm.Address1.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'ADDRESS_1\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="Address1" class="form-control" ng-model="vm.debtor.address1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Address1.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="ADDRESS_2"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.address2"></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.deliveryAddress1.$invalid && (vm.dataForm.deliveryAddress1.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'ADDRESS_1\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="deliveryAddress1" class="form-control" ng-model="vm.debtor.deliveryAddress1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.deliveryAddress1.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="ADDRESS_2"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.deliveryAddress2"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="ADDRESS_3"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.address3"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="STATE"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.state"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="ADDRESS_3"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.deliveryAddress3"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="STATE"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.deliveryState"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PostCode.$invalid && (vm.dataForm.PostCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="POSTAL_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="PostCode" ng-model="vm.debtor.postCode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PostCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="COUNTRY"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.country"></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeliveryPostCode.$invalid && (vm.dataForm.DeliveryPostCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="POSTAL_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeliveryPostCode" ng-model="vm.debtor.deliveryPostCode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeliveryPostCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="COUNTRY"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.deliveryCountry"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"></div><div class="col-md-6 col-lg-6"><input type="checkbox" ng-model="vm.isSameAsBilling" ng-change="vm.sameAsBillingAddress()"> {{\'SAME_AS_BILLING_ADDRESS\' | translate}}</div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CONTACT_DETAILS\' | translate }}"><div class="row" style="padding:1rem 0 2rem 0;"><div class="col-md-6 col-lg-6"><strong><u>{{ \'BILLING\' | translate }}</u></strong></div><div class="col-md-6 col-lg-6"><strong><u>{{ \'DELIVERY\' | translate }}</u></strong></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="CONTACT_PERSON_1"></b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields"></i></label> <input type="text" class="form-control" ng-model="vm.debtor.contactPerson1" ng-required="vm.hasAutoCountFields"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="CONTACT_PERSON_1"></b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields"></i></label> <input type="text" class="form-control" ng-model="vm.debtor.deliveryContactPerson1" ng-required="vm.hasAutoCountFields"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="TELEPHONE"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.phone1"><p style="font-size: 9pt; margin-top: 5px; color: #888888">Note: Enter phone number in E.164 format (e.g. +60102345678). Incorrect format will prevent sharing Purchase Order / Sales Order with PIC via messenger.</p></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="FAX"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.fax1"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="TELEPHONE"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.deliveryPhone1"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="FAX"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.deliveryFax1"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="EMAIL_ADDRESS"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.email1"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="EMAIL_ADDRESS"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.deliveryEmail1"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"></div><div class="col-md-6 col-lg-6"><input type="checkbox" ng-model="vm.isSameAsBillingContactPerson1" ng-change="vm.sameAsBillingContactPerson1()"> {{\'SAME_AS_BILLING_CONTACT_PERSON_1\' | translate}}</div></div><div class="row"><div class="col-md-6 col-lg-6"><p><hr></p></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="CONTACT_PERSON_2"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.contactPerson2"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="CONTACT_PERSON_2"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.deliveryContactPerson2"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="TELEPHONE"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.phone2"><p style="font-size: 9pt; margin-top: 5px; color: #888888">Note: Enter phone number in E.164 format (e.g. +60102345678). Incorrect format will prevent sharing Purchase Order / Sales Order with PIC via messenger.</p></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="FAX"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.fax2"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="TELEPHONE"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.deliveryPhone2"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="FAX"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.deliveryFax2"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="EMAIL_ADDRESS"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.email2"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="EMAIL_ADDRESS"></b></label> <input type="text" class="form-control" ng-model="vm.debtor.deliveryEmail2"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"></div><div class="col-md-6 col-lg-6"><input type="checkbox" ng-model="vm.isSameAsBillingContactPerson2" ng-change="vm.sameAsBillingContactPerson2()"> {{\'SAME_AS_BILLING_CONTACT_PERSON_2\' | translate}}</div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'BRANCH_SITES\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_CUSTOMER_BRANCHES_/_SITES."></span></small> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddBranchModal()"><i class="ion-plus-round"></i><span translate="ADD_BRANCH_/_SITE"></span></a><br><br></p><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><div style="max-height:300px;overflow:auto"><table class="table table-striped" style="border:1px solid #ccc;font-size:85%"><thead><tr class="sortable"><th><b translate="BRANCH_CODE"></b></th><th><b translate="BRANCH_NAME"></b></th><th><b translate="BRANCH_ADDRESS"></b></th><th><b translate="CONTACT_PERSON"></b></th><th><b translate="PHONE"></b></th><th style="width:65px"></th><th style="width:65px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.debtor.debtorBranches"><td>{{ ntn.code }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.name }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.address1 }} {{ ntn.address2 }} {{ ntn.address3 }} {{ ntn.postCode }} {{ ntn.state }} {{ ntn.country }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.contactPerson || \'-\' }}</td><td>{{ ntn.phone || \'-\' }}</td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditBranchModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeBranch($index)" ng-confirm-click="Confirm remove this Branch?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="7" align="center" ng-show="vm.debtor.debtorBranches.length==0"><br><span translate="BRANCH_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'GEO_LOCATION\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'GEO_LAT\' | translate }}</b></label> <input type="text" class="form-control" ng-model="vm.debtor.gpsLat"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'GEO_LNG\' | translate }}</b></label> <input type="text" class="form-control" ng-model="vm.debtor.gpsLng"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"></div><div class="col-md-3 col-lg-3"><div class="form-group"><a href="" class="btn btn-primary btn-with-icon pull-right" ng-click="vm.getLatLng()"><i class="fa fa-map-marker"></i> {{ \'GET_GEO_FROM_ADDRESS\' | translate }}</a><br><br></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div id="googleMap" style="height:400px;border:2px solid #666"></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'MISCELLANEOUS\' | translate }}"><div class="row" ng-if="vm.isDeliveryWindowEnabled"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="DELIVERY_WINDOW"></b></label><br><p translate="NOTE:_SELECT_THE_DAY_OF_THE_WEEK_THAT_CUSTOMER_ACCEPT_DELIVERY"></p><div class="row"><div class="col-lg-4"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.debtor.deliveryWindow1"> <label><span ng-class="{ \'text-primary\' : vm.debtor.deliveryWindow1 }"><span translate="MONDAY"></span></span></label></div></div><div class="col-lg-4"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.debtor.deliveryWindow2"> <label><span ng-class="{ \'text-primary\' : vm.debtor.deliveryWindow2 }"><span translate="TUESDAY"></span></span></label></div></div><div class="col-lg-4"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.debtor.deliveryWindow3"> <label><span ng-class="{ \'text-primary\' : vm.debtor.deliveryWindow3 }"><span translate="WEDNESDAY"></span></span></label></div></div></div><div class="row"><div class="col-lg-4"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.debtor.deliveryWindow4"> <label><span ng-class="{ \'text-primary\' : vm.debtor.deliveryWindow4 }"><span translate="THURSDAY"></span></span></label></div></div><div class="col-lg-4"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.debtor.deliveryWindow5"> <label><span ng-class="{ \'text-primary\' : vm.debtor.deliveryWindow5 }"><span translate="FRIDAY"></span></span></label></div></div><div class="col-lg-4"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.debtor.deliveryWindow6"> <label><span ng-class="{ \'text-primary\' : vm.debtor.deliveryWindow6 }"><span translate="SATURDAY"></span></span></label></div></div></div><div class="row"><div class="col-lg-4"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.debtor.deliveryWindow7"> <label><span ng-class="{ \'text-primary\' : vm.debtor.deliveryWindow7 }"><span translate="SUNDAY"></span></span></label></div></div></div></div></div><p><br></p></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" ng-model="vm.debtor.remarks">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="AutoCount Fields" ng-if="vm.hasAutoCountFields"><p><small><i class="fa fa-info-circle"></i> <span translate="THESE_INFORMATION_MUST_BE_FILLED_IN_FOR_AUTOCOUNT_INTEGRATION."></span></small></p><br><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CreditorType.$invalid && (vm.dataForm.CreditorType.$dirty || vm.dataForm.$submitted)}"><label><b translate="DEBTOR_TYPE"></b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields"></i></label><select name="CreditorType" class="form-control" ng-change="vm.selectedDebtorTypeChanged()" ng-model="vm.selectedDebtorType" ng-options="i as (i.description || \'-\') for i in vm.autoCount_DebtorTypes" ng-required="vm.hasAutoCountFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CreditorType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AreaCode.$invalid && (vm.dataForm.AreaCode.$dirty || vm.dataForm.$submitted)}"><label><b>Area Code</b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields"></i></label><select name="AreaCode" class="form-control" ng-change="vm.selectedAreaCodeChanged()" ng-model="vm.selectedAreaCode" ng-options="i as (\'[\'+ i.areaCode + \'] \' + (i.description || \'-\')) for i in vm.autoCount_AreaCodes" ng-required="vm.hasAutoCountFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AreaCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ControlAccount.$invalid && (vm.dataForm.ControlAccount.$dirty || vm.dataForm.$submitted)}"><label><b translate="CONTROL_ACCOUNT"></b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields"></i></label><select name="ControlAccount" class="form-control" ng-change="vm.selectedControlAccountChanged()" ng-model="vm.selectedControlAccount" ng-options="i as (\'[\'+ i.accNo + \'] \' + (i.description || \'-\')) for i in vm.autoCount_ControlAccounts" ng-required="vm.hasAutoCountFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ControlAccount.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PriceCategory.$invalid && (vm.dataForm.AreaCode.$dirty || vm.dataForm.$submitted)}"><label><b>Price Category</b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields"></i></label><select name="PriceCategory" class="form-control" ng-change="vm.selectedPriceCategoryChanged()" ng-model="vm.selectedPriceCategory" ng-options="i as (\'[\'+ i.code + \'] \' + (i.description || \'-\')) for i in vm.autoCount_PriceCategories" ng-required="vm.hasAutoCountFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PriceCategory.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CurrencyCode.$invalid && (vm.dataForm.CurrencyCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="CURRENCY_CODE"></b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields"></i></label><select name="CurrencyCode" class="form-control" ng-change="vm.selectedCurrencyCodeChanged()" ng-model="vm.selectedCurrencyCode" ng-options="i as (\'[\'+ i.currencyCode + \'] \' + i.currencyWord) for i in vm.autoCount_CurrencyCodes" ng-required="vm.hasAutoCountFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CurrencyCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SalesAgent.$invalid && (vm.dataForm.AreaCode.$dirty || vm.dataForm.$submitted)}"><label><b>Sales Agent</b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields"></i></label><select name="SalesAgent" class="form-control" ng-change="vm.selectedSalesAgentChanged()" ng-model="vm.selectedSalesAgent" ng-options="i as (i.description || \'-\') for i in vm.autoCount_SalesAgents" ng-required="vm.hasAutoCountFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SalesAgent.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DisplayTerm.$invalid && (vm.dataForm.DisplayTerm.$dirty || vm.dataForm.$submitted)}"><label><b translate="DISPLAY_TERM"></b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields"></i></label><select name="DisplayTerm" class="form-control" ng-change="vm.selectedDisplayTermChanged()" ng-model="vm.selectedDisplayTerm" ng-options="i as i.displayTerm for i in vm.autoCount_DisplayTerms" ng-required="vm.hasAutoCountFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DisplayTerm.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="SQL Fields" ng-if="vm.hasSQLFields"><p><small><i class="fa fa-info-circle"></i> <span translate="THESE_INFORMATION_MUST_BE_FILLED_IN_FOR_SQL_INTEGRATION."></span></small></p><br><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLCreditorType.$invalid && (vm.dataForm.SQLCreditorType.$dirty || vm.dataForm.$submitted)}"><label><b translate="DEBTOR_TYPE"></b> <i class="fa fa-asterisk req" ng-if="vm.hasSQLFields"></i></label><select name="SQLCreditorType" class="form-control" ng-change="vm.selectedCompanyCategoryChanged()" ng-model="vm.selectedCompanyCategory" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sqlFields.SQL_Maintenance_CompanyCategory" ng-required="vm.hasSQLFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLCreditorType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLAreaCode.$invalid && (vm.dataForm.SQLAreaCode.$dirty || vm.dataForm.$submitted)}"><label><b>Area Code</b> <i class="fa fa-asterisk req" ng-if="vm.hasSQLFields"></i></label><select name="SQLAreaCode" class="form-control" ng-change="vm.selectedSQLAreaCodeChanged()" ng-model="vm.selectedSQLAreaCode" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sqlFields.SQL_Maintenance_Area" ng-required="vm.hasSQLFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLAreaCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLControlAccount.$invalid && (vm.dataForm.SQLControlAccount.$dirty || vm.dataForm.$submitted)}"><label><b translate="CONTROL_ACCOUNT"></b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields"></i></label><select name="SQLControlAccount" class="form-control" ng-change="vm.selectedSQLControlAccountChanged()" ng-model="vm.selectedSQLControlAccount" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sqlFields.SQL_Customer_ControlAccount" ng-required="vm.hasAutoCountFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLControlAccount.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLSalesAgent.$invalid && (vm.dataForm.SQLSalesAgent.$dirty || vm.dataForm.$submitted)}"><label><b>Agent Code</b> <i class="fa fa-asterisk req" ng-if="vm.hasSQLFields"></i></label><select name="SQLSalesAgent" class="form-control" ng-change="vm.selectedSQLAgentChanged()" ng-model="vm.selectedSQLAgent" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sqlFields.SQL_Maintenance_Agent" ng-required="vm.hasSQLFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLSalesAgent.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CurrencyCode.$invalid && (vm.dataForm.CurrencyCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="CURRENCY_CODE"></b> <i class="fa fa-asterisk req" ng-if="vm.hasSQLFields"></i></label><select name="CurrencyCode" class="form-control" ng-change="vm.selectedSQLCurrencyChanged()" ng-model="vm.selectedSQLCurrencyCode" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sqlFields.SQL_Maintenance_Currency" ng-required="vm.hasSQLFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CurrencyCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DisplayTerm.$invalid && (vm.dataForm.DisplayTerm.$dirty || vm.dataForm.$submitted)}"><label><b translate="TERM"></b> <i class="fa fa-asterisk req" ng-if="vm.hasSQLFields"></i></label><select name="DisplayTerm" class="form-control" ng-change="vm.selectedSQLTermChanged()" ng-model="vm.selectedSQLTerm" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sqlFields.SQL_Maintenance_Terms" ng-required="vm.hasSQLFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DisplayTerm.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.debtor.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_CUSTOMER."></span><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br>{{ \'THERE_IS_NO_CHANGES_YET\' | translate }}<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="branchModal.html"><form name="$mdl.branchForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="BRANCH_/_SITE"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div ba-panel-class="horizontal-tabs tabs-panel panel" style="border-left:1px solid #ccc;border-right:1px solid #ccc;border-bottom:1px solid #ccc;margin-bottom:15px"> <uib-tabset active="$mdl.activeTab"> <uib-tab heading="{{ \'GENERAL\' | translate }}"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b translate="BRANCH_CODE"></b> <i class="fa fa-asterisk req" ng-if="!$mdl.autoCode"></i></label> <input type="text" class="form-control" name="BranchCode" style="background:#fffeed" ng-model="$mdl.item.code" ng-disabled="$mdl.autoCode" ng-required="!$mdl.autoCode"> <input type="checkbox" ng-change="$mdl.autoCodeChanged()" ng-model="$mdl.autoCode" /> {{\'AUTO_GENERATE\' | translate}} <span class="help-block" style="color:#f00" ng-show="$mdl.branchForm.$submitted && $mdl.branchForm.CustomerCode.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="BRANCH_NAME"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="text" name="BranchName" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.name" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.branchForm.BranchName.$error.required && $mdl.branchForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b translate="ADDRESS_1">:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address1"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b translate="ADDRESS_2">:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address2"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b translate="ADDRESS_3">:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address3"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b> <span translate="STATE"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.state"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b translate="POST_CODE:"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="PostCode" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.postCode" required> <span class="help-block" style="color:#f00" ng-show="$mdl.branchForm.$submitted && $mdl.branchForm.PostCode.$error.required">* {{ \'REQUIRED\' | translate }} </span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="COUNTRY"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.country"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b> <span translate="CONTACT_PERSON"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.contactPerson"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b translate="PHONE_NUMBER:"></b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.phone"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b translate="FAX_NUMBER:"></b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.fax"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="EMAIL"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.email"> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.remarks"> </div> </div> </div> </uib-tab> <uib-tab heading="{{ \'GEO_LOCATION\' | translate }}"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b>{{ \'GEO_LAT\' | translate }}</b></label> <input type="text" class="form-control" ng-model="$mdl.item.gpsLat" style="background:#fffeed"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b>{{ \'GEO_LNG\' | translate }}</b></label> <input type="text" class="form-control" ng-model="$mdl.item.gpsLng" style="background:#fffeed"> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <a href class="btn btn-primary btn-with-icon pull-right" ng-click="$mdl.getLatLng()"> <i class="fa fa-map-marker"></i> {{ \'GET_GEO_FROM_ADDRESS\' | translate }} </a> <br /><br /> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div id="googleMap" style="height:300px;border:2px solid #666"></div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </uib-tab> </uib-tabset> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/maintenance/debtors/debtorCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/debtors/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_CUSTOMER"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.debtors.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/debtors/debtorImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b>{{ \'IMPORT_CUSTOMER_DATA\' | translate }}</b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'1\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b>{{ \'IMPORT_CUSTOMER_BRANCH_DATA\' | translate }}</b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'2\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend translate="IMPORT_GUIDELINES:"></legend><ol class="import"><li translate="YOU_NEED_TO_FOLLOW_THE_INSTRUCTION_BELOW_IF_YOU_ARE_NEW_TO_THE_RMS."></li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW_FILL_IT_UP_WITH_THE_DATA_FIRST_THEN_IMPORT_INTO_THE_RMS"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(1, \'Customer Data Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_CUSTOMER_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'2\', \'Customer Branches Data Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_CUSTOMER_BRANCH_TEMPLATE"></span></a></li></ol></fieldset></div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong translate="FILE_UPLOADED_SUCCESSFULLY._CHOOSE_THE_OPTIONS_BELOW_AND_PROCEED_TO_IMPORT_THE_DATA."></strong></div><div><fieldset ng-if="vm.importType==\'1\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createDebtor" ng-change="change()" style="cursor:pointer"> <label>&nbsp;&nbsp;{{ \'CREATE_NEW_CUSTOMERS\' | translate }}</label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateDebtor" ng-change="change()" style="cursor:pointer"> <label>&nbsp;&nbsp;{{ \'UPDATE_CUSTOMERS_IF_EXISTS\' | translate }}</label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:15px" ng-hide="vm.isProcessing || vm.lockButtons || vm.importOptions.excelContent.length==0" ng-click="vm.importData()"><i class="fa fa-upload"></i> {{ "CONFIRM_IMPORT" | translate }}</a> <a href="" class="btn btn-info btn-with-icon" ng-hide="vm.isProcessing || vm.lockButtons || vm.importOptions.excelContent.length==0" ng-click="vm.getLatLngForAll()"><i class="fa fa-globe"></i> {{ "GET_GEOLOCATION" | translate }}</a> <span ng-if="vm.isProcessing"><i class="fa fa-spinner fa-spin fa-fw"></i>&nbsp; {{ "PROCESSING_GEOLOCATION" | translate }}...</span></div></div></fieldset><fieldset ng-if="vm.importType==\'2\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createDebtorBranch" ng-change="change()" style="cursor:pointer"> <label>&nbsp;&nbsp;{{ \'CREATE_NEW_CUSTOMER_BRANCHES\' | translate }}</label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateDebtorBranch" ng-change="change()" style="cursor:pointer"> <label>&nbsp;&nbsp;{{ \'UPDATE_CUSTOMER_BRANCHES_IF_EXISTS\' | translate }}</label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:15px" ng-hide="vm.isProcessing || vm.lockButtons || vm.importOptions.excelContent.length==0" ng-click="vm.importData()"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a> <a href="" class="btn btn-info btn-with-icon" ng-hide="vm.isProcessing || vm.lockButtons || vm.importOptions.excelContent.length==0" ng-click="vm.getLatLngForAll()"><i class="fa fa-globe"></i> {{ "GET_GEOLOCATION" | translate }}</a> <span ng-if="vm.isProcessing"><i class="fa fa-spinner fa-spin fa-fw"></i>&nbsp; {{ "PROCESSING_GEOLOCATION" | translate }}...</span></div></div></fieldset><br><br><fieldset><legend translate="CUSTOMER_DATA_PREVIEW:"></legend></fieldset></div><div class="horizontal-scroll"><table class="table table-striped table-bordered table-nopadding" border="1" style="norder-collapse:collapse;font-size:8pt !important" ng-if="vm.importType==\'1\'"><thead><tr><th style="width:60px">#</th><th><b>{{ "CUSTOMER_CODE" | translate }}</b></th><th><b>{{ "CUSTOMER_NAME" | translate }}</b></th><th><b>{{ "CATEGORY" | translate }}</b></th><th><b>{{ "COMPANY_REG._NO." | translate }}</b></th><th><b>{{ "GST_REG._NO." | translate }}</b></th><th><b>{{ "ADDRESS_1" | translate }}</b></th><th><b>{{ "ADDRESS_2" | translate }}</b></th><th><b>{{ "ADDRESS_3" | translate }}</b></th><th><b>{{ "STATE" | translate }}</b></th><th><b>{{ "POSTAL_CODE" | translate }}</b></th><th><b>{{ "COUNTRY" | translate }}</b></th><th><b>{{ "CONTACT_PERSON_#1" | translate }}</b></th><th><b>{{ "TELEPHONE_#1" | translate }}</b></th><th><b>{{ "FAX_#1" | translate }}</b></th><th><b>{{ "EMAIL_#1" | translate }}</b></th><th><b>{{ "CONTACT_PERSON_#2" | translate }}</b></th><th><b>{{ "TELEPHONE_#2" | translate }}</b></th><th><b>{{ "FAX_#2" | translate }}</b></th><th><b>{{ "EMAIL_#2" | translate }}</b></th><th><b>{{ "GEO_LAT" | translate }}</b></th><th><b>{{ "GEO_LNG" | translate }}</b></th><th><b>{{ "DEL_WINDOW" | translate }} #1</b></th><th><b>{{ "DEL_WINDOW" | translate }} #2</b></th><th><b>{{ "DEL_WINDOW" | translate }} #3</b></th><th><b>{{ "DEL_WINDOW" | translate }} #4</b></th><th><b>{{ "DEL_WINDOW" | translate }} #5</b></th><th><b>{{ "DEL_WINDOW" | translate }} #6</b></th><th><b>{{ "DEL_WINDOW" | translate }} #7</b></th></tr><tr><th colspan="29">{{ \'TOTAL_RECORDS\' | translate}}: {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td nowrap="nowrap">{{ row.debtorCode || \'\' }}</td><td nowrap="nowrap">{{ row.debtorName || \'\' }}</td><td nowrap="nowrap">{{ row.category || \'\' }}</td><td nowrap="nowrap">{{ row.companyRegNo || \'-\' }}</td><td nowrap="nowrap">{{ row.gstRegNo || \'-\' }}</td><td nowrap="nowrap">{{ row.address1 || \'-\' }}</td><td nowrap="nowrap">{{ row.address2 || \'-\' }}</td><td nowrap="nowrap">{{ row.address3 || \'-\' }}</td><td nowrap="nowrap">{{ row.state || \'-\' }}</td><td nowrap="nowrap">{{ row.postcode || \'-\' }}</td><td nowrap="nowrap">{{ row.country || \'-\' }}</td><td nowrap="nowrap">{{ row.contactPerson1 || \'-\' }}</td><td nowrap="nowrap">{{ row.phone1 || \'-\' }}</td><td nowrap="nowrap">{{ row.fax1 || \'-\' }}</td><td nowrap="nowrap">{{ row.email1 || \'-\' }}</td><td nowrap="nowrap">{{ row.contactPerson2 || \'-\' }}</td><td nowrap="nowrap">{{ row.phone2 || \'-\' }}</td><td nowrap="nowrap">{{ row.fax2 || \'-\' }}</td><td nowrap="nowrap">{{ row.email2 || \'-\' }}</td><td nowrap="nowrap">{{ row.gpsLat || \'-\' }}</td><td nowrap="nowrap">{{ row.gpsLng || \'-\' }}</td><td nowrap="nowrap">{{ row.deliveryWindow1 || \'-\' }}</td><td nowrap="nowrap">{{ row.deliveryWindow2 || \'-\' }}</td><td nowrap="nowrap">{{ row.deliveryWindow3 || \'-\' }}</td><td nowrap="nowrap">{{ row.deliveryWindow4 || \'-\' }}</td><td nowrap="nowrap">{{ row.deliveryWindow5 || \'-\' }}</td><td nowrap="nowrap">{{ row.deliveryWindow6 || \'-\' }}</td><td nowrap="nowrap">{{ row.deliveryWindow7 || \'-\' }}</td></tr><tr><td colspan="29" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="29">{{ \'TOTAL_RECORDS\' | translate}}: {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table table-striped table-bordered table-nopadding" border="1" style="norder-collapse:collapse;font-size:8pt !important" ng-if="vm.importType==\'2\'"><thead><tr><th style="width:60px">#</th><th><b>{{ "CUSTOMER_CODE" | translate }}</b></th><th><b>{{ "CUSTOMER_NAME" | translate }}</b></th><th><b>{{ "CUSTOMER_BRANCH_CODE" | translate }}</b></th><th><b>{{ "CUSTOMER_BRANCH_NAME" | translate }}</b></th><th><b>{{ "ADDRESS_1" | translate }}</b></th><th><b>{{ "ADDRESS_2" | translate }}</b></th><th><b>{{ "ADDRESS_3" | translate }}</b></th><th><b>{{ "POSTAL_CODE" | translate }}</b></th><th><b>{{ "STATE" | translate }}</b></th><th><b>{{ "COUNTRY" | translate }}</b></th><th><b>{{ "CONTACT_PERSON" | translate }}</b></th><th><b>{{ "TELEPHONE" | translate }}</b></th><th><b>{{ "FAX" | translate }}</b></th><th><b>{{ "EMAIL" | translate }}</b></th><th><b>{{ "REMARKS" | translate }}</b></th><th><b>{{ "GEO_LAT" | translate }}</b></th><th><b>{{ "GEO_LNG" | translate }}</b></th></tr><tr><th colspan="18">{{ \'TOTAL_RECORDS\' | translate}}: {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td nowrap="nowrap">{{ row.debtorCode || \'\' }}</td><td nowrap="nowrap">{{ row.debtorName || \'\' }}</td><td nowrap="nowrap">{{ row.branchCode || \'\' }}</td><td nowrap="nowrap">{{ row.branchName || \'\' }}</td><td nowrap="nowrap">{{ row.address1 || \'-\' }}</td><td nowrap="nowrap">{{ row.address2 || \'-\' }}</td><td nowrap="nowrap">{{ row.address3 || \'-\' }}</td><td nowrap="nowrap">{{ row.postCode || \'-\' }}</td><td nowrap="nowrap">{{ row.state || \'-\' }}</td><td nowrap="nowrap">{{ row.country || \'-\' }}</td><td nowrap="nowrap">{{ row.contactPerson || \'-\' }}</td><td nowrap="nowrap">{{ row.phone || \'-\' }}</td><td nowrap="nowrap">{{ row.fax || \'-\' }}</td><td nowrap="nowrap">{{ row.email || \'-\' }}</td><td nowrap="nowrap">{{ row.remarks || \'-\' }}</td><td nowrap="nowrap">{{ row.gpsLat || \'-\' }}</td><td nowrap="nowrap">{{ row.gpsLng || \'-\' }}</td></tr><tr><td colspan="18" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="18">{{ \'TOTAL_RECORDS\' | translate}}: {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-6 col-lg-6"><em><small><i class="fa fa-info-circle"></i> <span translate="PROCESSING"></span>...</small></em><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><p translate="THE_DATA_IS_CURRENTLY_BEING_PROCESSED._IT_IS_SAFE_TO_LEAVE_THIS_PAGE_NOW."></p><p translate="YOU_WILL_RECEIVE_AN_EMAIL_NOTIFICATION_ABOUT_THE_IMPORT_RESULT_ONCE_THE_SERVER_HAS_FINISHED_PROCESSED_THE_DATA."></p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.debtors.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a></div></form></div>');
$templateCache.put('app/pages/maintenance/debtors/debtorList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="DebtorListing" st-pipe="vm.retrieveData" st-table="vm.debtorData" refresh-table=""><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.debtors.create" rms-check-access="maintenance.debtors" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_CUSTOMER"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="maintenance.debtors.import" rms-check-access="maintenance.debtors" rms-check-access-perm-type="CREATE"><i class="fa fa-upload"></i><span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="code">{{ \'CODE\' | translate }}</th><th st-sort="name">{{ \'NAME\' | translate }}</th><th st-sort="debtorCategory">{{ \'CATEGORY\' | translate }}</th><th><span translate="PHONE"></span></th><th><span translate="FAX"></span></th><th><span translate="EMAIL"></span></th><th>{{ \'ACTIVE\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA_...\' | translate }}</b></center></big></td></tr><tr ng-if="vm.debtorData.length<=0 && !vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-repeat="item in vm.debtorData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td>{{item.debtorCategory}}</td><td>{{item.phone1}}</td><td>{{item.fax1}}</td><td>{{item.email1}}</td><td><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.debtors.update({id:item.id})" rms-check-access="maintenance.debtors" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Customer" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteCustomer(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Customer?" rms-check-access="maintenance.debtors" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/debtors/debtorUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/debtors/_form.html\'"></section><div class="footer-bar" style="display:flex;gap:10px;"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:20px" ui-sref="maintenance.debtors.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.debtors.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <button type="button" class="btn btn-info btn-with-icon" ng-if="vm.isAfterSalesEnabled" ng-disabled="vm.lockButtons" ng-click="vm.registerFreeAMSAccount()"><span translate="REGISTER_FREE_AMS_ACCOUNT"></span></button></div></form>');
$templateCache.put('app/pages/maintenance/foodmenus/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_FOOD_MENU_INFORMATION"></span><br><br></p><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="FOOD_MENU_DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Description" ng-model="vm.foodmenu.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="ENABLED"></b></label><br><div><toggle ng-model="vm.foodmenu.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'MENU_ITEMS\' | translate }}"><p><i class="fa fa-info-circle"></i> {{ \'ADD_ITEM_INTO_THE_MENU\' | translate }} <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddProductModal()"><i class="ion-plus-round"></i> {{ \'ADD_ITEM\' | translate }}</a><br><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th></th><th><b>{{ \'ITEM_CODE\' | translate }}</b></th><th><b>{{ \'ITEM_NAME\' | translate }}</b></th><th style="text-align:right" class="hide-after"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b>{{ \'U.O.M\' | translate }}</b></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="item in vm.foodmenu.foodMenuProducts"><td>{{ $index+1 }})</td><td class="text-center" style="width:80px;line-height:100%"><div class="report-type-tag">{{ item.itemType }}</div></td><td>{{ item.productCode || \'\' }}</td><td>{{ item.productName || \'\' }}</td><td style="text-align:right">{{ item.quantity || \'\' }}</td><td>{{ item.uomName || \'\' }}</td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditProductModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeProduct($index)" ng-confirm-click="Confirm remove this Product?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="8" style="text-align:center" ng-if="!vm.foodmenu.foodMenuProducts || vm.foodmenu.foodMenuProducts.length==0"><br><span translate="PRODUCT_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="productModal.html"><form name="$mdl.productForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} {{ \'MENU_ITEM\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <label> <b translate="RAW_MATERIAL"></b> / <b translate="SEMI_FINISHED_GOODS"></b> / <b>{{ \'FINISHED_GOODS\' | translate }}</b> </label> </div> </div> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.itemSearch" style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model-options=\'{ debounce: 1500 }\' ng-change="$mdl.searchItem($mdl.itemSearch)" /> </div> </div> <div class="col-lg-9"> <select class="form-control" style="background:#FFFCED" name="ItemName" ng-disabled="$mdl.lockButtons" ng-change="$mdl.selectedItemChanged()" ng-options="u as (\'[\' + u.itemType + \'] \' + u.productName | uppercase) for u in $mdl.itemList" ng-model="$mdl.selectedItem" required> <option value="">{{($mdl.lockButtons ? (\'LOADING...\' | translate) : ($mdl.itemList.length==0 ? ("&lt;&lt; " + (\'ENTER_A_KEYWORD_TO_SEARCH\' | translate)) : ("-- " + (\'SELECT_AN_ITEM\' | translate) + " --")))}}</option> </select> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" style="margin-top:5px" ng-if="$mdl.selectedItem!=null" ng-click="$mdl.selectedItem=null"> <i class="fa fa-times"></i> <span style="color:#fff" translate="CLEAR_SELECTION"></span> </button> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted"> * {{"REQUIRED" | translate}} </p> </div> </div> <div class="row"> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.Quantity.$invalid && ($mdl.productForm.Quantity.$dirty || $mdl.productForm.$submitted)}"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity" style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.quantity" required> <span class="help-block" style="color:#f00" ng-show="$mdl.productForm.$submitted && $mdl.productForm.Quantity.$error.required"> * {{"REQUIRED" | translate}}* </span> <span class="help-block" style="color:#f00" ng-show="$mdl.productForm.$submitted && $mdl.productForm.Quantity.$error.number"> * {{"ENTER_NUMBERS_ONLY" | translate}}* </span> </div> </div> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.productForm.UOM.$invalid && ($mdl.productForm.UOM.$dirty || $mdl.productForm.$submitted)}"> <label><b translate="U.O.M"></b> <i class="fa fa-asterisk req"></i></label> <select name="UOM" class="form-control" style="background:#FFFCED" ng-disabled="$mdl.lockButtons" ng-change="$mdl.selectedUomChanged()" ng-options="b as b.name for b in $mdl.selectedItem.uomList" ng-model="$mdl.selectedUom" required> <option value="">-- {{ \'SELECT_A_U.O.M\' | translate }} --</option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.productForm.$submitted && $mdl.productForm.UOM.$error.required"> * {{"REQUIRED" | translate}}* </span> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/maintenance/foodmenus/foodmenuCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/foodmenus/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.foodmenus.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/foodmenus/foodmenuList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.foodmenuData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.foodmenus.create" rms-check-access="maintenance.foodmenus" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>{{ \'ADD_NEW_MENU\' | translate }}</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="description">{{ \'DESCRIPTION\' | translate }}</th><th class="hide-after" style="text-align:center">{{ \'ACTIVE\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.foodmenuData.length==0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA_...\' | translate }}</b></center></big></td></tr><tr ng-repeat="item in vm.foodmenuData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.description}}</td><td style="text-align:center"><i class="fa fa-check" ng-if="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.foodmenus.update({id:item.id})" rms-check-access="maintenance.foodmenus" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Sensor" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteMenu(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Food Menu?" rms-check-access="maintenance.foodmenus" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}} : <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/foodmenus/foodmenuUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/foodmenus/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.foodmenus.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.foodmenus.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/multilevelapprovals/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="DEFINE_APPROVAL_FLOWS"></span><br><br></p><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ModuleType.$invalid && (vm.dataForm.ModuleType.$dirty || vm.dataForm.$submitted)}"><label><b translate="MODULE_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select name="ModuleType" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in vm.moduleList" ng-model="vm.selectedType" ng-change="vm.selectedTypeChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.ModuleType.$error.required && vm.dataForm.$submitted">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-model="vm.mla.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-2 col-lg-2" ng-if="vm.mla.createdBy"><div class="form-group"><label><b>{{ \'CREATED_BY\' | translate }}</b></label><br><span>{{vm.mla.createdBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.mla.createdDate | date:\'dd/MM/yyyy\' }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TriggerAmount.$invalid && (vm.dataForm.TriggerAmount.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'TRIGGER_AMOUNT\' | translate }}&nbsp;({{vm.currency}})</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="TriggerAmount" ng-model="vm.mla.triggerAmount" required="" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TriggerAmount.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TriggerAmount.$error.min">* {{ \'MINIMUM_IS_0\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TriggerAmount.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-5 col-lg-5"><div class="form-group"><label><b>{{ \'STATUS\' | translate }}</b></label><div><toggle ng-model="vm.mla.isActive" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-2 col-lg-2" ng-if="vm.mla.modifiedBy"><div class="form-group"><label><b>{{ \'MODIFIED_BY\' | translate }}</b></label><br><span>{{vm.mla.modifiedBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.mla.modifiedDate | date:\'dd/MM/yyyy\' }}</span></div></div></div><div class="row"></div><hr><br><div class="row"><div class="col-md-5 col-lg-5"><p><i class="fa fa-info-circle"></i> <span translate="APPLY_FOR_SELECTED_STORES"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddStorePanel()"><i class="ion-plus-round"></i><span translate="ADD_STORE"></span></a><br><br></p><div class="row" ng-if="vm.addStorePanelVisible"><div class="col-lg-12"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-lg-6"><b>{{ \'ADD_STORE\' | translate }}</b></div><div class="col-lg-6"><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" ng-click="vm.closeAddStorePanel()"><i class="ion ion-close"></i> {{ \'CLOSE_PANEL\' | translate }}</a></div></div></div><div class="panel-body" style="padding:20px"><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>{{ \'SELECT_A_STORE\' | translate }}:</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedStoreChanged()" ng-options="b as (b.name | uppercase) for b in vm.branchList | orderBy:\'name\'" ng-model="vm.selectedStore"><option value=""></option></select></div></div></div><div class="row"><div class="col-lg-12"><a href="" class="btn btn-primary btn-with-icon btn-sm pull-right" style="margin-top:3px" ng-click="vm.addStore()"><i class="ion-plus-round"></i> {{ \'ADD_STORE\' | translate }}</a> <a href="" class="btn btn-info btn-with-icon btn-sm pull-right" style="margin-top:3px;margin-right:5px" ng-click="vm.addAllStores()"><i class="ion-plus-round"></i> {{ \'ADD_ALL_STORES\' | translate }}</a></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><table class="table table-striped table-hover" style="border:1px solid #ccc"><thead><tr class="sortable"><th><big><b translate="STORE_NAME"></b></big><span ng-if="vm.mla.approvalStoreConfigs.length!=0" style="font-weight:normal !important;">({{vm.mla.approvalStoreConfigs.length}} selected)</span></th></tr></thead></table><div style="max-height:485px;overflow:auto"><table class="table table-striped table-hover" style="border:1px solid #ccc"><tbody><tr ng-repeat="ntn in vm.mla.approvalStoreConfigs"><td style="padding-top:10px;padding-bottom:10px;line-height:150%">{{ ntn.branchName }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%;width:100px"><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" style="width:100px" confirmed-click="vm.removeStore($index)" ng-confirm-click="Confirm remove this Store?"><i class="fa fa-trash-o"></i> {{ \'REMOVE\' | translate }}</a></td></tr><tr><td colspan="7" align="center" ng-show="vm.mla.approvalStoreConfigs.length==0"><br>{{ \'NO_RECORD_FOUND\' | translate }}.<br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row"><p>&nbsp;</p></div></div><div class="col-md-7 col-lg-7"><p><i class="fa fa-info-circle"></i> <span translate="APPROVAL_FLOW_SEQUENCE_CONDITIONS"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddFlowPanel()"><i class="ion-plus-round"></i><span translate="ADD_FLOW"></span></a><br><br></p><div class="row" ng-if="vm.addFlowPanelVisible"><div class="col-lg-12"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-lg-6"><b>{{ \'ADD_FLOW\' | translate }}</b></div><div class="col-lg-6"><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" ng-click="vm.closeAddFlowPanel()"><i class="ion ion-close"></i> {{ \'CLOSE_PANEL\' | translate }}</a></div></div></div><div class="panel-body" style="padding:20px"><div class="row"><div class="col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Sequence.$invalid && (vm.dataForm.Sequence.$dirty || vm.dataForm.$submitted)}"><label><b translate="SEQUENCE"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Sequence" ng-model="vm.addFlow.sequence" ng-required="vm.addFlowPanelVisible" min="1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Sequence.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Sequence.$error.min">* {{ \'MINIMUM_IS_1\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Sequence.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Usergroup.$invalid && (vm.dataForm.Usergroup.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SELECT_A_USERGROUP\' | translate }}:</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Usergroup" style="background:#FFFCED" ng-change="vm.selectedUsergroupChanged()" ng-options="b as (b.name | uppercase) for b in vm.ugList | orderBy:\'name\'" ng-model="vm.selectedUsergroup" ng-required="vm.addFlowPanelVisible"><option value=""></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Usergroup.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Condition.$invalid && (vm.dataForm.Condition.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'CONDITION\' | translate }}:</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Condition" style="background:#FFFCED" ng-change="vm.selectedConditionChanged()" ng-options="b as (b.name | uppercase | translate) for b in vm.conditionList | orderBy:\'name\'" ng-model="vm.selectedCondition" ng-required="vm.addFlowPanelVisible"><option value=""></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Condition.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><a href="" class="btn btn-primary btn-with-icon btn-sm pull-right" style="margin-top:3px" ng-click="vm.addFlow()"><i class="ion-plus-round"></i> {{ \'ADD_FLOW\' | translate }}</a></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><table class="table table-striped table-hover" style="border:1px solid #ccc"></table><div style="max-height:485px;overflow:auto"><table class="table table-striped table-hover" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:120px;border-bottom:2px solid #ccc"><big><b translate="SEQUENCE"></b></big></th><th style="border-bottom:2px solid #ccc"><big><b translate="USERGROUP"></b></big></th><th style="width:150px;border-bottom:2px solid #ccc"><big><b translate="CONDITION"></b></big></th><th style="width:100px;border-bottom:2px solid #ccc"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.mla.approvalUserGroupConfigs"><td style="padding-top:10px;padding-bottom:10px;line-height:150%">#{{ ntn.sequence }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%">{{ ntn.userGroupName }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%">{{ vm.getCondition(ntn.condition) | translate }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%"><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" style="width:100px" confirmed-click="vm.removeFlow($index)" ng-confirm-click="Confirm remove this Flow?"><i class="fa fa-trash-o"></i> {{ \'REMOVE\' | translate }}</a></td></tr><tr><td colspan="7" align="center" ng-if="vm.mla.approvalUserGroupConfigs.length==0"><br>{{ \'NO_RECORD_FOUND\' | translate }}.<br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row"><p>&nbsp;</p></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/maintenance/multilevelapprovals/mlaCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/multilevelapprovals/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.multilevelapprovals.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.multilevelapprovals.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/multilevelapprovals/mlaList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="MLAListing" st-pipe="vm.retrieveData" st-table="vm.mlaData" refresh-table=""><thead><tr><th colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.multilevelapprovals.create" rms-check-access="maintenance.multilevelapprovals" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="name">{{ \'DESCRIPTION\' | translate }}</th><th><span translate="MODULE_TYPE"></span></th><th style="text-align:right" class="hide-after"><span translate="TRIGGER_AMOUNT"></span> ({{ vm.currency }})</th><th></th><th>{{ \'STATUS\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="item in vm.mlaData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td>{{vm.getModuleName(item.moduleType)}}</td><td style="text-align:right">{{item.triggerAmount | currency:\'\'}}</td><td></td><td><span ng-if="item.isActive" class="text-success"><b>{{ \'ACTIVE\' | translate }}</b></span> <span ng-if="!item.isActive" class="text-danger"><b>{{ \'INACTIVE\' | translate }}</b></span></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.multilevelapprovals.update({id:item.id})" rms-check-access="maintenance.multilevelapprovals" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteConfig(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Configuration?" rms-check-access="maintenance.multilevelapprovals" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr><tr ng-show="vm.mlaData.length==0"><td colspan="8" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/multilevelapprovals/mlaUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/multilevelapprovals/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.multilevelapprovals.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.multilevelapprovals.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/intercompanyitemmappings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'STATUS\' | translate }}</b></label><div><toggle ng-model="vm.mapping.active" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceCompany.$invalid && (vm.dataForm.SourceCompany.$dirty || vm.dataForm.$submitted)}"><label><b>Source Company</b> <i class="fa fa-asterisk req"></i></label><select name="SourceCompany" class="form-control" ng-change="vm.selectedSourceCompanyChanged()" ng-model="vm.selectedSourceCompany" ng-options="i as (i.name | uppercase) for i in user.companies" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceCompany.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle">&nbsp;<br><b>&rarr;</b><br><b>&rarr;</b></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestCompany.$invalid && (vm.dataForm.DestCompany.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Company</b> <i class="fa fa-asterisk req"></i></label><select name="DestCompany" class="form-control" ng-change="vm.selectedDestCompanyChanged()" ng-model="vm.selectedDestCompany" ng-options="i as (i.name | uppercase) for i in user.companies" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestCompany.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"></div><div class="col-md-1 col-lg-1"></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestBranch.$invalid && (vm.dataForm.DestBranch.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Branch</b> <i class="fa fa-asterisk req"></i></label><select name="DestBranch" class="form-control" ng-change="vm.selectedDestBranchChanged()" ng-model="vm.selectedDestBranch" ng-options="i as (i.name | uppercase) for i in vm.branchList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestBranch.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-8 col-lg-8"><hr></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceItem.$invalid && (vm.dataForm.SourceItem.$dirty || vm.dataForm.$submitted)}"><label><b>Source Raw Material</b> <i class="fa fa-asterisk req"></i></label><select name="SourceItem" class="form-control" ng-change="vm.selectedSourceItemChanged()" ng-model="vm.selectedSourceItem" ng-options="i as (i.code + \' -- \' + (i.description || \'-\')) for i in vm.itemList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceItem.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle">&nbsp;<br><b>&rarr;</b><br><b>&rarr;</b></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestRawMat.$invalid && (vm.dataForm.DestRawMat.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Raw Material</b> <i ng-if="vm.selectedDestRawMat!=null" class="fa fa-asterisk req"></i></label><select name="DestRawMat" class="form-control" ng-change="vm.selectedDestRawMatChanged()" ng-model="vm.selectedDestRawMat" ng-options="i as (i.code + \' -- \' + (i.description || \'-\')) for i in vm.rawMatList" ng-required="vm.selectedDestRawMat==null && vm.selectedDestSemiFg==null && vm.selectedDestProduct==null"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestRawMat.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1">&nbsp;<br><br><b>= OR =</b></div></div><div class="row"><div class="col-md-4 col-lg-4"></div><div class="col-md-1 col-lg-1"></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestSemiFg.$invalid && (vm.dataForm.DestSemiFg.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Semi F.G.</b> <i ng-if="vm.selectedDestSemiFg!=null" class="fa fa-asterisk req"></i></label><select name="DestSemiFg" class="form-control" ng-change="vm.selectedDestSemiFgChanged()" ng-model="vm.selectedDestSemiFg" ng-options="i as (i.code + \' -- \' + (i.description || \'-\')) for i in vm.semiFgList" ng-required="vm.selectedDestRawMat==null && vm.selectedDestSemiFg==null && vm.selectedDestProduct==null"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestSemiFg.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1">&nbsp;<br><br><b>= OR =</b></div></div><div class="row"><div class="col-md-4 col-lg-4"></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle"></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestProduct.$invalid && (vm.dataForm.DestProduct.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Finished Good</b> <i ng-if="vm.selectedDestProduct!=null" class="fa fa-asterisk req"></i></label><select name="DestProduct" class="form-control" ng-change="vm.selectedDestProductChanged()" ng-model="vm.selectedDestProduct" ng-options="i as (i.code + \' -- \' + i.name) for i in vm.productList" ng-required="vm.selectedDestRawMat==null && vm.selectedDestSemiFg==null && vm.selectedDestProduct==null"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestProduct.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.mapping.id!=null"><p><i class="fa fa-info-circle"></i> Audit trail of changes made to this Item Mapping.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b>Date / Time</b></th><th style="width:180px"><b>Edited By</b></th><th style="width:40%"><b>Original Values</b></th><th style="width:40%"><b>Updated Values</b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br>There is no changes yet.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/maintenance/intercompanyitemmappings/mappingCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/intercompanyitemmappings/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create Mapping</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.intercompanyitemmappings.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/maintenance/intercompanyitemmappings/mappingImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b>Import Item Mapping Data</b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> Browse</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile()" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> Upload File</a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px">Uploading file...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong>Failed to process uploaded file. File might contain errors.</strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong>Failed to upload file.</strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend>Import Guidelines:</legend><ol class="import"><li>You need to follow the instruction below if you are new to the RMS.</li><li>Download the template below, fill it up with the data first, then import into the RMS:<br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate()"><i class="fa fa-download"></i> Download Item Mapping Template</a></li></ol></fieldset><br>&nbsp;<br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong>File uploaded successfully. Choose the options below and proceed to import the data.</strong></div><div><fieldset><legend>Import Options:</legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createItemMapping" ng-change="change()" style="cursor:pointer"> <label><span>Create New Mappings</span></label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateItemMapping" ng-change="change()" style="cursor:pointer"> <label><span>Update Mapping if exists</span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> Confirm Import</a></div></div></fieldset><br><br><fieldset><legend>Item Mapping Data Preview:</legend></fieldset></div><div id="scroll-container" class="horizontal-scroll"><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important"><thead><tr><th style="width:60px">#</th><th><b>Source Company Code</b></th><th><b>Source Company Name</b></th><th><b>Source Item Code</b></th><th><b>Source Item Name</b></th><th><b>Dest Company Code</b></th><th><b>Dest Company Name</b></th><th><b>Dest Semi FG Code</b></th><th><b>Dest Semi FG Name</b></th><th><b>Dest FG Code</b></th><th><b>Dest FG Name</b></th></tr><tr><th colspan="11">Total Records: {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td nowrap="nowrap">{{ row.sourceCompanyCode || \'\' }}</td><td nowrap="nowrap">{{ row.sourceCompanyName || \'\' }}</td><td nowrap="nowrap">{{ row.sourceItemCode || \'\' }}</td><td nowrap="nowrap">{{ row.sourceItemName || \'\' }}</td><td nowrap="nowrap">{{ row.destCompanyCode || \'-\' }}</td><td nowrap="nowrap">{{ row.destCompanyName || \'-\' }}</td><td nowrap="nowrap">{{ row.destSemiFgCode || \'-\' }}</td><td nowrap="nowrap">{{ row.destSemiFgName || \'-\' }}</td><td nowrap="nowrap">{{ row.destProductCode || \'-\' }}</td><td nowrap="nowrap">{{ row.destProductName || \'-\' }}</td></tr><tr><td colspan="11" align="center" ng-show="vm.importOptions.excelContent.length==0"><br>Excel content is empty.<br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="11">Total Records: {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-6 col-lg-6"><em><small><i class="fa fa-info-circle"></i> Processing...</small></em><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><p>The data is currently being processed. It is safe to leave this page now.</p><p>You will receive an email notification about the import result once the server has finished processed the data.</p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.intercompanyitemmappings.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back To List</a></div></form></div>');
$templateCache.put('app/pages/maintenance/intercompanyitemmappings/mappingList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped table-hover" st-persist="InterCompanyItemMapping" st-pipe="vm.retrieveData" st-table="vm.mappingData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Mapping" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.intercompanyitemmappings.create" rms-check-access="maintenance.intercompanyitemmappings" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>New Mapping</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="sourceCompanyName">SOURCE<br>Company Name</th><th st-sort="sourceItemName">SOURCE<br>Raw Mat</th><th st-sort="destCompanyName" style="border-left:2px solid black">DESTINATION<br>Company Name</th><th st-sort="destBranchName">DESTINATION<br>Branch Name</th><th>DESTINATION<br>Raw Mat / SFG / FG</th><th>Active</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline"><input st-search="sourceCompanyName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="sourceItemName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="destCompanyName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="destBranchName" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.mappingData.length==0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.mappingData"><td>{{vm.startIndex+1+$index}})</td><td style="line-height:130%;padding-top:10px;padding-bottom:10px">{{item.sourceCompanyName | uppercase}}</td><td style="line-height:130%;padding-top:10px;padding-bottom:10px">{{item.sourceItemCode}} -- {{item.sourceItemName | uppercase}}</td><td style="line-height:130%;padding-top:10px;padding-bottom:10px;border-left:2px solid black">{{item.destCompanyName || \'-\' | uppercase}}</td><td style="line-height:130%;padding-top:10px;padding-bottom:10px">{{item.destBranchName || \'-\' | uppercase}}</td><td style="line-height:130%;padding-top:10px;padding-bottom:10px">{{vm.getDestObjectCode(item)}} -- {{vm.getDestObjectName(item) | uppercase}}</td><td><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.intercompanyitemmappings.update({id:item.id})" rms-check-access="maintenance.intercompanyitemmappings" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Mapping" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteMapping(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Mapping?" rms-check-access="maintenance.intercompanyitemmappings" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/intercompanyitemmappings/mappingUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/intercompanyitemmappings/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.intercompanyitemmappings.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button></div></form>');
$templateCache.put('app/pages/maintenance/items/_form.html','<style>\n\t.modal-lg {\n\t\twidth: 1400px !important;\n\t}\n</style><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-md-3 col-lg-3"><div class="row"><img ngf-src="picFile || vm.item.imageLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div><br><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-hide="vm.lockUploadButton" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> {{ \'UPLOAD_PICTURE\' | translate }}</div><a href="" class="btn btn-default btn-with-icon" ng-click="picFile=null;vm.clearImage()" ng-hide="vm.lockUploadButton" ng-show="(picFile || vm.item.imageLocation.indexOf(\'empty_placeholder\')<0)"><i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }}</a></div><div class="row" ng-show="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div><div class="col-md-7 col-lg-7"><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ItemCode.$invalid && (vm.dataForm.ItemCode.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'ITEM_CODE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ItemCode" ng-model="vm.item.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ItemCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'STATUS\' | translate }}</b></label><div><toggle ng-model="vm.item.active" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ItemName.$invalid && (vm.dataForm.ItemName.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ItemName" ng-model="vm.item.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ItemName.$error.required">* <span translate="REQUIRED"></span></span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'FOR_SALE\' | translate }}</b></label><div><toggle ng-model="vm.item.isForSale" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group"><label><b translate="ITEM_DESCRIPTION"></b></label> <input type="text" class="form-control" ng-model="vm.item.shortDescription"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="LABEL_PRINT_OPTION"></b></label><div><toggle ng-model="vm.item.labelPrintOption" ng-change="changed()" on="{{ \'SINGLE\' | translate }}" off="{{ \'MULTIPLE\' | translate }}" onstyle="btn-success" offstyle="btn-primary"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Category.$invalid && (vm.dataForm.Category.$dirty || vm.dataForm.$submitted)}"><label><b translate="CATEGORY"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Category" ng-model="vm.item.category" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Category.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="SUB_CATEGORY"></b></label> <input type="text" class="form-control" ng-model="vm.item.subCategory"></div></div></div><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" ng-model="vm.item.remarks">\n\t\t\t\t\t\t\t\t\t</textarea></div></div></div></div></div><div class="row"><p>&nbsp;</p><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'U.O.M.\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="ADD_THE_U.O.M._FOR_THE_ITEM"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddUomModal()"><i class="ion-plus-round"></i><span translate="ADD_NEW_U.O.M."></span></a><br><br></p><div class="row"><div class="col-md-9 col-lg-9"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr><th style="width:60px">#</th><th><b translate="U.O.M._NAME"></b></th><th><b translate="BASE_MUTIPLIER"></b></th><th style="width:150px"><b translate="BASE"></b><br><small translate="UOM"></small></th><th style="width:150px"><b>{{ \'INVENTORY\' | translate }}</b><br><small translate="UOM"></small></th><th style="width:150px"><b translate="P.O."></b><br><small translate="UOM"></small></th><th style="width:150px"><b>{{ \'SALES\' | translate }}</b><br><small translate="UOM"></small></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.item.itemUnitOfMeasurements"><td>{{$index+1}}</td><td>{{ ntn.unitOfMeasurement.name || \'\' }}</td><td>X {{ ntn.baseMultiplier }}</td><td><i class="fa fa-check" ng-show="ntn.isBase" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isBase" style="color:#f00"></i></td><td><i class="fa fa-check" ng-show="ntn.isInventory" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isInventory" style="color:#f00"></i></td><td><i class="fa fa-check" ng-show="ntn.isOrder" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isOrder" style="color:#f00"></i></td><td><i class="fa fa-check" ng-show="ntn.isSales" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isSales" style="color:#f00"></i></td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditUomModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeUom($index)" ng-confirm-click="Confirm remove this U.O.M.?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="9" style="text-align:center" ng-if="vm.item.itemUnitOfMeasurements==null || vm.item.itemUnitOfMeasurements.length==0"><br><span translate="U.O.M._LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CWM\' | translate }}"><p><i class="fa fa-info-circle"></i> <span>{{ \'TO_CONFIG_CWM\' | translate }}</span><br><br></p><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>{{ \'IS_CWM\' | translate }} ?</b></label><div><toggle ng-model="vm.item.isCWM" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-2 col-lg-2" ng-if="vm.item.isCWM && vm.integrationMode!=-1"><div class="form-group"><label><b>{{ \'SYNC_PARALLEL_UOM\' | translate }} ?</b></label><div><toggle ng-model="vm.item.syncCwmParallelUom" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.item.isCWM"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CWMParallelMultiplier.$invalid && (vm.dataForm.CWMTolerance.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'PARALLEL_MULTIPLIER\' | translate }}</b> <i class="fa fa-asterisk req" ng-if="vm.item.isCWM"></i></label> <input type="number" class="form-control" name="CWMParallelMultiplier" min="0.01" ng-model="vm.item.cwm_ParallelMultiplier" ng-required="vm.item.isCWM"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMParallelMultiplier.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMParallelMultiplier.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMParallelMultiplier.$error.min">* {{ \'MINIMUM_VALUE_IS_0\' | translate }}.01</span></div></div></div><div class="row" ng-if="vm.item.isCWM"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ParallelUom1.$invalid && (vm.dataForm.ParallelUom1.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'PARALLEL_UOM\' | translate }} #1</b> <i class="fa fa-asterisk req" ng-if="vm.item.isCWM"></i></label><select class="form-control" name="ParallelUom1" style="color:#333" ng-options="u as u.unitOfMeasurement.name for u in vm.item.itemUnitOfMeasurements" ng-change="vm.selectedParallelUom1Changed()" ng-model="vm.selectedParallelUom1" ng-required="vm.item.isCWM"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ParallelUom1.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.item.isCWM"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ParallelUom2.$invalid && (vm.dataForm.ParallelUom2.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'PARALLEL_UOM\' | translate }} #2</b> <i class="fa fa-asterisk req" ng-if="vm.item.isCWM"></i></label><select class="form-control" name="ParallelUom2" style="color:#333" ng-options="u as u.unitOfMeasurement.name for u in vm.item.itemUnitOfMeasurements" ng-change="vm.selectedParallelUom2Changed()" ng-model="vm.selectedParallelUom2" ng-required="vm.item.isCWM"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ParallelUom2.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.item.isCWM"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CWMTolerance.$invalid && (vm.dataForm.CWMTolerance.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'TOLERANCE_PERCENTAGE\' | translate }} (%)</b> <i class="fa fa-asterisk req" ng-if="vm.item.isCWM"></i></label> <input type="number" class="form-control" name="CWMTolerance" min="0" ng-model="vm.item.cwm_TolerencePercent" ng-required="vm.item.isCWM"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMTolerance.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMTolerance.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMTolerance.$error.min">* {{ \'MINIMUM_VALUE_IS_0\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'INVENTORY\' | translate }}" ng-if="vm.isStarterMode!=null && !vm.isStarterMode && vm.mode==2"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_INVENTORY_CONFIGURATION_FOR_THE_STOCK_LEVEL."></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddParModal()"><i class="ion-plus-round"></i><span translate="ADD_NEW"></span></a><br><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-hover" style="border:1px solid #ccc" st-table="vm.item.itemBranchConfigs"><thead><tr class="sortable"><th><b translate="BRANCH_NAME"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="MON_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="TUE_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="WED_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="THU_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="FRI_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="SAT_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="SUN_SHORT"></b></th><th class="hide-after" style="text-align:center" colspan="2"><b>{{ \'PAR_LEVEL\' | translate }}</b></th><th class="hide-after" style="text-align:center;width:100px" colspan="2"><b>{{ \'REORDER_LEVEL\' | translate }}</b></th><th class="hide-after" style="text-align:center;width:100px" colspan="2"><b>{{ \'REORDER_QUANTITY\' | translate }}</b></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="config in vm.item.itemBranchConfigs"><td nowrap="nowrap"><b>{{ config.branch.name }}</b></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.mon"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.tue"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.wed"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.thu"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.fri"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.sat"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.sun"></i></td><td style="width:100px;text-align:right" nowrap="nowrap"><b>{{ config.parLevel }}</b></td><td>{{ vm.uomInventory }}</td><td style="width:100px;text-align:right" nowrap="nowrap"><b>{{ config.reOrderLevel }}</b></td><td>{{ vm.uomInventory }}</td><td style="width:100px;text-align:right" nowrap="nowrap"><b>{{ config.reOrderQuantity }}</b></td><td>{{ vm.uomOrder }}</td><td></td><td style="padding-left:0px;padding-right:0px"><a class="btn btn-info btn-sm" ng-click="vm.showEditParModal($index)"><i class="fa fa-pencil"></i></a></td><td style="padding-left:0px;padding-right:0px"><a class="btn btn-danger btn-sm" confirmed-click="vm.removePar($index)" ng-confirm-click="Confirm remove this PAR entry?"><i class="fa fa-trash-o"></i></a></td></tr><tr><td colspan="15" style="text-align:center" ng-if="vm.item.itemBranchConfigs==null || vm.item.itemBranchConfigs.length==0"><br><span ng-if="vm.mode==2"><span translate="PAR_LEVEL_LIST_IS_EMPTY."></span></span><h2 ng-if="vm.mode==1" style="color:#f00"><center translate="PLEASE_SAVE_FIRST_BEFORE_SETTING_THE_PAR_LEVEL."></center></h2><br></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'YIELD\' | translate }}"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><span translate="YIELD_PERCENTAGE_(%)"></span> <i class="fa fa-asterisk req"></i></label><p><small><i class="fa fa-info-circle"></i> <span translate="THE_ACTUAL_PERCENTAGE_OF_YIELD_FROM_THE_ORIGINAL_WEIGHT_/_MASS"></span></small></p></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Yield.$invalid && (vm.dataForm.Yield.$dirty || vm.dataForm.$submitted)}"><input type="number" class="form-control" name="Yield" ng-model="vm.item.yieldPercent" required=""></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Yield.$invalid && (vm.dataForm.Yield.$dirty || vm.dataForm.$submitted)}"><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Yield.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Yield.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CERTIFICATES\' | translate }}" ng-if="vm.mode==2"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_FOOD_SAFETY_CERTIFICATES_FOR_THIS_RAW_MATERIAL"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddCertModal()"><i class="ion-plus-round"></i> {{ \'ADD_NEW_CERTIFICATE\' | translate }}</a><br><br></p><div class="row" ng-show="vm.mode==2"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="font-size:85%;border:1px solid #ccc" st-pipe="vm.refreshItemCerts" st-table="vm.item.itemCertificates" refresh-table=""><thead><tr><th style="width:60px">#</th><th><b>{{ \'SUPPLIER\' | translate }}</b></th><th><b>{{ \'CERT_TYPE\' | translate }}</b></th><th><b>{{ \'CERT_REF_NO\' | translate }}</b></th><th><b>{{ \'ISSUE_DATE\' | translate }}</b></th><th><b>{{ \'EXPIRY_DATE\' | translate }}</b></th><th><b>{{ \'REMARKS\' | translate }}</b></th><th style="width:100px"><b>{{ \'ATTACHMENT\' | translate }}</b></th><th style="width:65px"></th><th style="width:65px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.item.itemCertificates"><td>{{ $index+1 }}</td><td>{{ ntn.supplier.name || \'\' }}</td><td>{{ ntn.certType || \'\' }}</td><td>{{ ntn.certRefNo || \'\' }}</td><td>{{ ntn.issueDate | date:\'dd/MM/yyyy\' }}</td><td>{{ ntn.expiryDate | date:\'dd/MM/yyyy\' }}</td><td>{{ ntn.remarks || \'-\'}}</td><td><a class="btn btn-default editable-table-button btn-with-icon btn-xs" href="{{vm.blobUrl}}{{ntn.certFilename}}" target="_blank" ng-if="ntn.certFilename!=null && ntn.certFilename!=\'\'"><i class="fa fa-file-text"></i> {{ \'VIEW\' | translate }}</a> <span ng-if="ntn.certFilename==null || ntn.certFilename==\'\'">-</span></td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditCertModal(ntn.id)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeCert(ntn.id)" ng-confirm-click="Confirm remove this Certificate?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="10" style="text-align:center" ng-show="vm.item.itemCertificates.length==0"><br>{{ \'CERTIFICATE_LIST_IS_EMPTY.\' | translate }}<br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center>{{ \'PLEASE_SAVE_THE_RAW_MATERIAL_FIRST_BEFORE_ADDING_CERTIFICATE.\' | translate }}</center></h2></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'SALES_CONFIG\' | translate }}" ng-if="vm.mode==2"><p><i class="fa fa-info-circle"></i> {{ \'MANAGE_SALES_PRICE_FOR_INDIVIDUAL_CUSTOMER\' | translate }} <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddSalesConfig()"><i class="ion-plus-round"></i> {{ \'ADD_NEW_SALES_CONFIG\' | translate }}</a><br><br></p><div class="row" ng-show="vm.mode==2"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="font-size:85%;border:1px solid #ccc" st-pipe="vm.refreshItemCerts" st-table="vm.salesConfigList" refresh-table=""><thead><tr><th style="width:60px">#</th><th><b>{{ \'CUSTOMER_CODE\' | translate }}</b></th><th><b>{{ \'CUSTOMER_NAME\' | translate }}</b></th><th style="text-align:right" class="hide-after"><b>{{ \'UNIT_PRICE\' | translate }} ({{vm.currencyCode}})</b></th><th style="width:65px"></th><th><b>{{ \'TAX_CODE\' | translate }}</b></th><th style="text-align:right" class="hide-after"><b>{{ \'TAX_PERCENT\' | translate }} (%)</b></th><th style="text-align:right" class="hide-after"><b>{{ \'TAX_AMOUNT\' | translate }} ({{vm.currencyCode}})</b></th><th style="width:65px"></th><th style="width:65px"></th><th style="width:65px"></th></tr></thead><tbody><tr ng-repeat="item in vm.salesConfigList"><td>{{ $index+1 }})</td><td style="width:200px">{{ item.debtorCode || \'-\' }}</td><td>{{ item.debtorName || \'-\' }}</td><td style="text-align:right">{{ item.unitPrice | number:3}} / {{item.uomName}}</td><td></td><td>{{ item.taxCode || \'-\' }}</td><td style="text-align:right">{{ item.taxPercentage | number:2}}%</td><td style="text-align:right">{{ item.taxAmount | number:3}}</td><td></td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditSalesConfig(item.id)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.deleteSalesConfig(item.id)" ng-confirm-click="Confirm remove this Sales Config?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="14" style="text-align:center" ng-show="vm.salesConfigList.length==0"><br><span>{{ \'THE_LIST_IS_EMTPY\' | translate}}</span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center>Please save the Raw Material first before adding Sales Config.</center></h2></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'SUPPLIERS_PRICING\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="ADD_SUPPLIERS"></span> &amp; <span translate="PRICING_FOR_THE_ITEM"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddSupplierModal()"><i class="ion-plus-round"></i> <span translate="ADD_NEW_SUPPLIER"></span> &amp; <span translate="PRICING"></span></a><br><br></p><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="font-size:85%;border:1px solid #ccc" st-pipe="vm.refreshItemPrices" st-table="vm.item.itemPrices" refresh-table=""><thead><tr><th style="width:60px">#</th><th style="text-align:center"><b translate="DEFAULT"></b></th><th><b>{{ \'SUPPLIER_CODE\' | translate }}</b></th><th><b>{{ \'SUPPLIER_NAME\' | translate }}</b></th><th><b translate="SUPPLIER_ITEM_DESCRIPTION"></b></th><th style="text-align:right"><b translate="QTY/VOLUME"></b></th><th><b translate="U.O.M"></b></th><th style="text-align:right;line-height:120%"><b translate="COST"></b><br><span translate="(EXCL._TAX)"></span></th><th style="text-align:right"><b>{{ \'SALES_TAX\' | translate }}</b><br>(%)</th><th style="text-align:right"><b>{{ \'SALES_TAX\' | translate }}</b></th><th style="text-align:right;line-height:120%"><b translate="COST"></b><br><span translate="(INCL._TAX)"></span></th><th style="text-align:center"><b>{{ \'TAX_CODE\' | translate }}</b></th><th><b>{{ \'REMARKS\' | translate }}</b></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.item.itemPrices"><td>{{ $index+1 }})</td><td style="text-align:center"><i class="fa fa-check" ng-show="ntn.isDefault" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isDefault" style="color:#f00"></i></td><td style="line-height:130%;padding-top:10px;padding-bottom:10px">{{ ntn.supplier.code || \'\' }}</td><td style="line-height:130%;padding-top:10px;padding-bottom:10px">{{ ntn.supplier.name || \'\' }}</td><td style="line-height:130%;padding-top:10px;padding-bottom:10px">{{ ntn.supplierItemDescription || \'\' }}</td><td style="text-align:right">{{ ntn.quantity }}</td><td>{{ ntn.unitOfMeasurement.name }}</td><td style="text-align:right" nowrap="nowrap">{{ ntn.supplier.currencyCode}} {{ ntn.cost | number:3 }}</td><td style="text-align:right" nowrap="nowrap">{{ ntn.taxPercent }}%</td><td style="text-align:right" nowrap="nowrap">{{ ntn.supplier.currencyCode}} {{ ntn.tax | number:3 }}</td><td style="text-align:right" nowrap="nowrap">{{ ntn.supplier.currencyCode}} {{ ntn.costIncGst | number:3 }}</td><td style="text-align:center">{{ ntn.taxCode }}</td><td>{{ ntn.remarks }}</td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditSupplierModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeSupplier($index)" ng-confirm-click="Confirm remove this Supplier and Pricing?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="15" style="text-align:center" ng-show="vm.item.itemPrices.length==0"><br><span translate="SUPPLIER_PRICING_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'PRICE_HISTORY\' | translate }}" ng-if="vm.mode==2"><p><i class="fa fa-info-circle"></i> <span translate="LIST_OF_PRICE_CHANGED_HISTORY"></span></p><br><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.itemData" style="font-size:85%;border:1px solid #ccc" st-safe-src="vm.itemDataFull" refresh-table=""><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:" :=""></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th><b translate="LAST_UPDATED"></b></th><th><b>{{ \'SUPPLIER\' | translate }}</b></th><th><b translate="M.O.Q."></b></th><th><b translate="U.O.M"></b></th><th class="hide-after" style="text-align:right"><b translate="COST"></b><br><span translate="(EXCL._TAX)"></span></th><th class="hide-after" style="text-align:right"><b><span translate="TAX"></span><br>{{ \'CODE\' | translate }}</b></th><th class="hide-after" style="text-align:right"><b>{{ \'SALES_TAX\' | translate }}</b><br>(%)</th><th class="hide-after" style="text-align:right"><b>{{ \'SALES_TAX\' | translate }}</b></th><th class="hide-after" style="text-align:right"><b translate="COST"></b><br><span translate="(INCL._TAX)"></span></th><th><b>{{ \'REMARKS\' | translate }}</b></th></tr><tr class="sortable"><th></th><th class="form-inline"><select st-search="supplierName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="i in vm.itemDataFull | unique:\'supplierName\' | orderBy:\'supplierName\'" value="{{i.supplierName}}">{{i.supplierName | uppercase}}</option></select></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in vm.itemData | orderBy:\'-createdDate\'"><td>{{item.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td>{{item.supplierName | uppercase}}</td><td>{{item.quantity | number:0}}</td><td>{{item.unitOfMeasurementName | uppercase}}</td><td style="text-align:right">{{item.currencyCode}} {{item.cost | currency:"" }}</td><td style="text-align:right">{{item.taxCode | uppercase}}</td><td style="text-align:right">{{item.taxPercent}} %</td><td style="text-align:right">{{item.currencyCode}} {{item.tax | currency:"" }}</td><td style="text-align:right">{{item.currencyCode}} {{item.costIncGst | currency:"" }}</td><td>{{item.remarks}}</td></tr><tr ng-show="vm.itemData.length<=0"><td colspan="10" style="height:100px;line-height:100px;text-align:center">{{ \'NO_RECORD_FOUND\' | translate }}</td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'LABEL_DETAILS\' | translate }}"><p><i class="fa fa-info-circle"></i> {{ \'PLEASE_ENTER_THE_RELEVANT_INFORMATION_FOR_THE_LABEL_PRINTING.\' | translate}}<br><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'CUSTOM_TEXT\' | translate }} #1</b></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.customField1"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'CUSTOM_TEXT\' | translate }} #2</b></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.customField2"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'CUSTOM_TEXT\' | translate }} #3</b></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.customField3"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'CUSTOM_TEXT\' | translate }} #4</b></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.customField4"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'CUSTOM_TEXT\' | translate }} #5</b></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.customField5"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'CUSTOM_TEXT\' | translate }} #6</b></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.customField6"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'CUSTOM_TEXT\' | translate }} #7</b></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.customField7"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'CUSTOM_TEXT\' | translate }} #8</b></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.customField8"></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="AutoCount Fields" ng-if="vm.hasAutoCountFields"><p><small><i class="fa fa-info-circle"></i> <span translate="_THESE_INFORMATION_MUST_BE_FILLED_IN_FOR_AUTOCOUNT_INTEGRATION."></span></small></p><br><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AcItemType.$invalid && (vm.dataForm.AcItemType.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select name="AcItemType" class="form-control" ng-change="vm.selectedItemTypeChanged()" ng-model="vm.selectedItemType" ng-options="i as (\'[\'+ i.itemType1 + \'] \' + (i.description || \'-\')) for i in vm.autoCount_itemTypes" ng-required="vm.hasAutoCountFields"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AcItemType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AcItemGroup.$invalid && (vm.dataForm.AcItemGroup.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_GROUP"></b> <i class="fa fa-asterisk req"></i></label><select name="AcItemGroup" class="form-control" ng-change="vm.selectedItemGroupChanged()" ng-model="vm.selectedItemGroup" ng-options="i as (\'[\'+ i.itemGroup1 + \'] \' + (i.description || \'-\')) for i in vm.autoCount_itemGroups" ng-required="vm.hasAutoCountFields"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AcItemGroup.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AcStockControl.$invalid && (vm.dataForm.AcStockControl.$dirty || vm.dataForm.$submitted)}"><label><b>Is Stock Control</b> <i class="fa fa-asterisk req"></i></label><select name="AcStockControl" class="form-control" ng-change="vm.selectedStockControlChanged()" ng-model="vm.selectedStockControl" ng-required="vm.hasAutoCountFields"><option value="1">{{ \'YES\' | translate }}</option><option value="0">{{ \'NO\' | translate }}</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AcStockControl.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group"><label><b>Classification Code</b></label> <input type="text" class="form-control" ng-model="vm.item.irbM_ClassificationCode"></div></div></div></uib-tab><uib-tab heading="SQL Fields" ng-if="vm.hasSQLFields"><p><small><i class="fa fa-info-circle"></i> <span translate="THESE_INFORMATION_MUST_BE_FILLED_IN_FOR_SQL_INTEGRATION."></span></small></p><br><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLItemGroup.$invalid && (vm.dataForm.SQLItemGroup.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_GROUP"></b> <i class="fa fa-asterisk req"></i></label><select name="SQLItemGroup" class="form-control" ng-change="vm.selectedSQLItemGroupChanged()" ng-model="vm.selectedSQLItemGroup" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sql_itemGroups" ng-required="vm.hasSQLFields"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLItemGroup.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLStockControl.$invalid && (vm.dataForm.SQLStockControl.$dirty || vm.dataForm.$submitted)}"><label><b>Is Stock Control</b> <i class="fa fa-asterisk req"></i></label><select name="SQLStockControl" class="form-control" ng-change="vm.selectedSQLStockControlChanged()" ng-model="vm.selectedSQLStockControl" ng-required="vm.hasSQLFields"><option value="1">{{ \'YES\' | translate }}</option><option value="0">{{ \'NO\' | translate }}</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLStockControl.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group"><label><b>Classification Code</b></label> <input type="text" class="form-control" ng-model="vm.item.irbM_ClassificationCode"></div></div></div></uib-tab><uib-tab heading="IDB Fields" ng-if="vm.hasIDBFields"><p><small><i class="fa fa-info-circle"></i> <span translate="THESE_INFORMATION_MUST_BE_FILLED_IN_FOR_IDB_INTEGRATION."></span></small></p><br><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.idbItemType.$invalid && (vm.dataForm.idbItemType.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select name="idbItemType" class="form-control" ng-change="vm.selectedIDBItemTypeChanged()" ng-model="vm.selectedIDBItemType" ng-options="i as (\'[\'+ i.code + \'] \' + (i.desc || \'-\')) for i in vm.idbItemTypes" ng-required="vm.hasIDBFields"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.idbItemType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.idbItemClass.$invalid && (vm.dataForm.idbItemClass.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_CLASS"></b> <i class="fa fa-asterisk req"></i></label><select name="idbItemClass" class="form-control" ng-change="vm.selectedIDBItemClassChanged()" ng-model="vm.selectedIDBItemClass" ng-options="i as (\'[\'+ i.code + \'] \' + (i.desc || \'-\')) for i in vm.idbItemClasses" ng-required="vm.hasIDBFields"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.idbItemClass.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></uib-tab><uib-tab heading="{{ \'RECIPES\' | translate }}" ng-if="vm.mode==2"><p><i class="fa fa-info-circle"></i> {{ \'LIST_OF_RECIPE_USING_THIS_RAWMAT\' | translate }}<br><br></p><div class="row"><div class="col-md-12 col-lg-12"><div style="max-height:300px;overflow-x:none;overflow-y:auto"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:40px">#</th><th>{{ \'RECIPE_NAME\' | translate }}</th><th style="width:80px"></th></tr></thead><tbody><tr ng-if="vm.item.recipeItems.length==0 && !vm.isLoading"><td colspan="3" style="height:100px;line-height:100px"><center>{{ \'NO_RECIPE_FOUND\' | translate }}</center></td></tr><tr ng-repeat="item in vm.item.recipeItems | orderBy:\'name\'"><td>{{ $index+1 }})</td><td>{{ item.name | uppercase }}</td><td style="width:80px"><a class="btn btn-primary editable-table-button btn-with-icon btn-xs" ui-sref="recipes.recipes.update({id:item.recipeId})" rms-check-access="recipes.recipes" rms-check-access-perm-type="UPDATE" style="width:80px"><i class="fa fa-eye"></i> {{ \'VIEW\' | translate }}</a></td></tr></tbody></table></div></div></div><p><br><br></p></uib-tab><uib-tab heading="{{ \'RECIPES_ALT\' | translate }}" ng-if="vm.mode==2"><p><i class="fa fa-info-circle"></i> {{ \'LIST_OF_RECIPE_USING_THIS_RAWMAT_AS_ALT\' | translate }}<br><br></p><div class="row"><div class="col-md-12 col-lg-12"><div style="max-height:300px;overflow-x:none;overflow-y:auto"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:40px">#</th><th>{{ \'RECIPE_NAME\' | translate }}</th><th style="width:80px"></th></tr></thead><tbody><tr ng-if="vm.item.recipeAltItems.length==0 && !vm.isLoading"><td colspan="3" style="height:100px;line-height:100px"><center>{{ \'NO_RECIPE_FOUND\' | translate }}</center></td></tr><tr ng-repeat="item in vm.item.recipeAltItems | orderBy:\'name\'"><td>{{ $index+1 }})</td><td>{{ item.name | uppercase }}</td><td style="width:80px"><a class="btn btn-primary editable-table-button btn-with-icon btn-xs" ui-sref="recipes.recipes.update({id:item.recipeId})" rms-check-access="recipes.recipes" rms-check-access-perm-type="UPDATE" style="width:80px"><i class="fa fa-eye"></i> {{ \'VIEW\' | translate }}</a></td></tr></tbody></table></div></div></div><p><br><br></p></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.item.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_RAW_MATERIAL."></span><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" style="text-align:center"><br>{{ \'THERE_IS_NO_CHANGES_YET\' | translate }}<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="uomModal.html"><form name="$mdl.uomForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} {{ \'U.O.M\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.uomForm.UOM.$invalid && $mdl.uomForm.$submitted}"> <label><b>{{ \'UNIT_OF_MEASUREMENT\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <small><br />&nbsp;</small> <select name="UOM" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.onSelectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.uomForm.UOM.$error.required && $mdl.uomForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> <div class="col-md-4 col-lg-4" style="padding-right:0px"> <div class="form-group" ng-class="{\'has-error\': $mdl.uomForm.BaseMultiplier.$invalid && $mdl.uomForm.$submitted}"> <label><b>{{ \'BASE_MULTIPLIER\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i> <br /><small><em translate="EQUIVALENT_TO_______BASE_UOM"></em></small> </label> <input type="number" name="BaseMultiplier" class="form-control" style="background:#fffeed" ng-model="$mdl.item.baseMultiplier" min="1" ng-min="1" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.uomForm.BaseMultiplier.$error.required && $mdl.uomForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.uomForm.BaseMultiplier.$error.number && $mdl.uomForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.uomForm.BaseMultiplier.$error.min && $mdl.uomForm.$submitted">* <span translate="MINIMUM_VALUE_IS_1"></span></p> </div> </div> <div class="col-md-2 col-lg-2"> <div class="form-group"> <label><br /></label> <small><br />&nbsp;</small> <b class="form-control">{{$mdl.baseUom}}</b> </div> </div> </div> <div class="form-group"> <div class="row"> <div class="col-lg-6"> <div class="checkbox checkbox-primary"> <input type="checkbox" ng-model="$mdl.item.isBase" ng-change="change()" /> <label><span><b translate="BASE_UOM"></b></span></label> <p style="padding-left:20px;line-height:10px"><small><i class="fa fa-info-circle"></i> <em translate="THE_BASE_UNIT_OF_THIS_PRODUCT"></em></small></p> </div> </div> <div class="col-lg-6"> <div class="checkbox checkbox-primary"> <input type="checkbox" ng-model="$mdl.item.isInventory" ng-change="change()" /> <label><span><b translate="INVENTORY_UOM"></b></span></label> <p style="padding-left:20px;line-height:10px"><small><i class="fa fa-info-circle"></i> <em translate="THE_UNIT_USED_FOR_STOCK_INVENTORY"></em></small></p> </div> <!-- <div class="checkbox checkbox-primary"> <input type="checkbox" ng-model="$mdl.item.isDefault" ng-change="change()" /> <label><span><b>{{ \'DEFAULT_UOM\' | translate }}</b></span></label> <p style="padding-left:20px;line-height:10px"><small><i class="fa fa-info-circle"></i> <em translate="THE_DEFAULT_UNIT"></em></small></p> </div> --> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="checkbox checkbox-primary"> <input type="checkbox" ng-model="$mdl.item.isOrder" ng-change="change()" /> <label><span><b translate="P.O._UOM"></b></span></label> <p style="padding-left:20px;line-height:10px"><small><i class="fa fa-info-circle"></i> <em translate="THE_UNIT_USED_FOR_PURCHASER_ORDER"></em></small></p> </div> </div> <div class="col-lg-6"> <div class="checkbox checkbox-primary"> <input type="checkbox" ng-model="$mdl.item.isSales" ng-change="change()" /> <label><span><b>{{ \'SALES_UOM\' | translate }}</b></span></label> <p style="padding-left:20px;line-height:10px"><small><i class="fa fa-info-circle"></i> <em translate="THE_UNIT_USED_FOR__SALES_ORDER"></em></small></p> </div> </div> </div> </div> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b>:</label> <textarea class="form-control" style="background:#fffeed" ng-model="$mdl.item.remarks"> </textarea> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="parModal.html"><form name="$mdl.parForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} {{ \'PAR_LEVEL\' | translate | uppercase}}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.parForm.Branch.$invalid && $mdl.parForm.$submitted}"> <label><b>{{ \'REMARKS\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <small><br />&nbsp;</small> <select name="Branch" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.branchList" ng-model="$mdl.selectedBranch" ng-change="$mdl.selectedBranchChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.Branch.$error.required && $mdl.parForm.$submitted">* {{\'REQUIRED\'|translate}} </p> </div> </div> </div> <hr /> <div class="row"> <div class="col-lg-12"> <table class="table" style="margin-bottom:0px"> <tr> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Monday" ng-model="$mdl.item.mon" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'MONDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Tuesday" ng-model="$mdl.item.tue" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()"/> <label style="margin-left:20px"><span><b>{{ \'TUESDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Wednesday" ng-model="$mdl.item.wed" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'WEDNESDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Thursday" ng-model="$mdl.item.thu" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'THURSDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Friday" ng-model="$mdl.item.fri" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'FRIDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Saturday" ng-model="$mdl.item.sat" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'SATURDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Sunday" ng-model="$mdl.item.sun" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'SUNDAY\' | translate }}</b></span></label> </td> </tr> </table> </div> </div> <div ng-if="$mdl.parForm.$submitted && $mdl.isValidDays()"> <br /> <span style="color:#f00">* {{\'YOU_MUST_SELECT_AT_LEAST_ONE_DAY\' | translate}}</span> </div> <hr /> <div class="row"> <div class="col-md-4 col-lg-4"> <div class="row"> <div class="col-lg-12"> <label><b>{{ \'PAR_LEVEL\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> </div> </div> <div class="row"> <div class="col-lg-7"> <div class="form-group" ng-class="{\'has-error\': $mdl.parForm.ParLevel.$invalid && $mdl.parForm.$submitted}"> <input type="number" name="ParLevel" class="form-control" style="background:#fffeed" ng-model="$mdl.item.parLevel" min="0" ng-min="0" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ParLevel.$error.required && $mdl.parForm.$submitted">* {{\'REQUIRED\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ParLevel.$error.number && $mdl.parForm.$submitted">* {{\'KEY_IN_NUMBERS_ONLY\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ParLevel.$error.min && $mdl.parForm.$submitted">* {{\'MINIMUM_VALUE_IS_0\'|translate}} </p> </div> </div> <div class="col-lg-5" style="padding-left:0px;"> <div class="form-group" style="line-height:34px;color:#00f"> <b>{{$mdl.uomInventory}}</b> </div> </div> </div> </div> <div class="col-md-4 col-lg-4"> <div class="row"> <div class="col-lg-12"> <label><b>{{ \'REORDER_LEVEL\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> </div> </div> <div class="row"> <div class="col-lg-7"> <div class="form-group" ng-class="{\'has-error\': $mdl.parForm.ReorderLevel.$invalid && $mdl.parForm.$submitted}"> <input type="number" name="ReorderLevel" class="form-control" style="background:#fffeed" ng-model="$mdl.item.reOrderLevel" min="0" ng-min="0" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderLevel.$error.required && $mdl.parForm.$submitted">* {{\'REQUIRED\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderLevel.$error.number && $mdl.parForm.$submitted">* {{\'KEY_IN_NUMBERS_ONLY\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderLevel.$error.min && $mdl.parForm.$submitted">* {{\'MINIMUM_VALUE_IS_0\'|translate}} </p> </div> </div> <div class="col-lg-5" style="padding-left:0px;"> <div class="form-group" style="line-height:34px;color:#00f"> <b>{{$mdl.uomInventory}}</b> </div> </div> </div> </div> <div class="col-md-4 col-lg-4"> <div class="row"> <div class="col-lg-12"> <label><b>{{ \'REORDER_QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> </div> </div> <div class="row"> <div class="col-lg-7"> <div class="form-group" ng-class="{\'has-error\': $mdl.parForm.ReorderQuantity.$invalid && $mdl.parForm.$submitted}"> <input type="number" name="ReorderQuantity" class="form-control" style="background:#fffeed" ng-model="$mdl.item.reOrderQuantity" min="0" ng-min="0" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderQuantity.$error.required && $mdl.parForm.$submitted">* {{\'REQUIRED\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderQuantity.$error.number && $mdl.parForm.$submitted">* {{\'KEY_IN_NUMBERS_ONLY\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderQuantity.$error.min && $mdl.parForm.$submitted">* {{\'MINIMUM_VALUE_IS_0\'|translate}} </p> </div> </div> <div class="col-lg-5" style="padding-left:0px;"> <div class="form-group" style="line-height:34px;color:#00f"> <b>{{$mdl.uomOrder}}</b> </div> </div> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="supplierModal.html"><form name="$mdl.supplierForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="SUPPLIER"></span> &amp; <span translate="PRICING"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="form-group"> <label><b>{{ \'SUPPLIER\' | translate }}</b></label> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.supplierSearch" style="background:#fffeed" /> </div> </div> <div class="col-lg-9"> <select name="Supplier" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.supplierList | filter: $mdl.supplierSearch" ng-model="$mdl.selectedSupplier" ng-change="$mdl.onSelectedSupplierChanged()" required> <option value="">-- {{ \'SELECT_A_SUPPLIER\' | translate | uppercase }} --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.Supplier.$error.required && $mdl.supplierForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> </div> <div class="form-group"> <div class="row"> <div class="col-lg-12"><label><b>{{ \'SUPPLIER_ITEM_DESCRIPTION\' | translate }}</b></label> <input type="text" class="form-control" style="background:#fffeed" ng-model="$mdl.item.supplierItemDescription" /> </div> </div> </div> <div class="form-group"> <div class="row"> <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"> <label><b translate="IS_DEFAULT"></b></label> <div> <toggle ng-model="$mdl.item.isDefault" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"> <label><b>{{ \'QUANTITY_/_VOLUME\' | translate }}</b></label> <input type="number" name="Quantity" class="form-control" style="background:#fffeed" ng-model="$mdl.item.quantity" min="1" required ng-change="$mdl.onQuantityChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.Quantity.$error.required && $mdl.supplierForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.Quantity.$error.number && $mdl.supplierForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> </div> <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"> <label><b>{{ \'U.O.M.\' | translate }}</b></label> <select name="UOM" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.onSelectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.UOM.$error.required && $mdl.supplierForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> </div> <div class="form-group"> <div class="row"> <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"> <label><b>{{ \'TAX_CODE\' | translate }}</b></label> <input type="text" name="TaxCode" class="form-control" style="background:#fffeed" autocomplete="off" ng-model="$mdl.item.taxCode" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.TaxCode.$error.required && $mdl.supplierForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"> <label><b>{{ \'SALES_TAX_PERCENT\' | translate }}</b> (%)</small> </label> <input type="number" name="TaxPercent" class="form-control" style="background:#fffeed" ng-model="$mdl.item.taxPercent" min="0" required ng-change="$mdl.onTaxPercentChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.TaxPercent.$error.required && $mdl.supplierForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.TaxPercent.$error.number && $mdl.supplierForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> </div> </div> </div> <div class="form-group"> <div class="row"> <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"> <label><b>{{ \'COST_EXCL._TAX\' | translate }}</b>&nbsp;({{$mdl.selectedSupplier.currencyCode || \' - \'}}) </label> <input type="number" name="Cost" class="form-control" style="background:#fffeed" ng-model="$mdl.item.cost" min="0.01" required ng-change="$mdl.onCostChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.Cost.$error.required && $mdl.supplierForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.Cost.$error.number && $mdl.supplierForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.Cost.$error.min && $mdl.supplierForm.$submitted">* {{ \'MINIMUM_VALUE_IS_0.01\' | translate }}</p> </div> <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"> <label> <b>{{ \'SALES_TAX\' | translate }}</b>&nbsp;({{$mdl.selectedSupplier.currencyCode || \' - \'}}) </label> <span class="form-control" ng-disabled="true">{{$mdl.item.tax}}</span> <!-- <input type="number" name="Tax" class="form-control" style="background:#fffeed" ng-model="" min="0" required ng-change="$mdl.onTaxChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.Tax.$error.required && $mdl.supplierForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.Tax.$error.number && $mdl.supplierForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> --> </div> <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"> <label><b>{{ \'COST_INCL._TAX\' | translate }}</b>&nbsp;({{$mdl.selectedSupplier.currencyCode || \' - \'}}) </label> <input type="number" name="CostIncGst" class="form-control" style="background:#fffeed" ng-model="$mdl.item.costIncGst" min="0.01" required ng-change="$mdl.onCostIncGstChanged()" ng-disabled="true"/> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.CostIncGst.$error.required && $mdl.supplierForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.CostIncGst.$error.number && $mdl.supplierForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.supplierForm.CostIncGst.$error.min && $mdl.supplierForm.$submitted">* {{ \'MINIMUM_VALUE_IS_0.01\' | translate }}</p> </div> </div> </div> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" style="background:#fffeed" ng-model="$mdl.item.remarks" /> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="salesConfigModal.html"><form name="$mdl.salesConfigForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> {{ $mdl.title | translate }} {{ \'SALES_CONFIG\' | translate }} </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'SELECT_A_CUSTOMER\' | translate }}</b> ({{ \'OPTIONAL\' | translate }})</label> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.debtorSearch" style="background:#fffeed" /> </div> </div> <div class="col-lg-9"> <select name="Customer" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.debtorList | filter: $mdl.debtorSearch" ng-model="$mdl.selectedDebtor" ng-change="$mdl.selectedDebtorChanged()"> <option value="">-- {{ \'SELECT_A_CUSTOMER\' | translate }} --</option> </select> </div> </div> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.salesConfigForm.UnitPrice.$invalid && ($mdl.salesConfigForm.UnitPrice.$dirty || $mdl.salesConfigForm.$submitted)}"> <label><b>{{ \'UNIT_PRICE\' | translate }}</b> <small>({{$mdl.currencyCode}})</small> <i class="fa fa-asterisk req" style="color:#f00"></i> </label> <input type="number" name="UnitPrice" class="form-control" style="background:#fffeed" ng-model="$mdl.item.unitPrice" min="0.01" required ng-change="$mdl.unitPriceChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.UnitPrice.$error.required && $mdl.salesConfigForm.$submitted"> * {{"REQUIRED" | translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxPercent.$error.min && $mdl.salesConfigForm.$submitted"> * {{ \'MINIMUM_IS_0\' | translate }} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxPercent.$error.number && $mdl.salesConfigForm.$submitted"> * {{ \'ENTER_NUMBERS_ONLY\' | translate }} </p> </div> </div> <div class="col-lg-6"> <label><b>{{ \'U.O.M.\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select name="UOM" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.selectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.UOM.$error.required && $mdl.salesConfigForm.$submitted"> * {{"REQUIRED" | translate}} </p> </div> </div> <br /> <div class="row"> <div class="col-lg-4"> <div class="form-group" ng-class="{\'has-error\': $mdl.salesConfigForm.TaxCode.$invalid && ($mdl.salesConfigForm.TaxCode.$dirty || $mdl.salesConfigForm.$submitted)}"> <label><b>{{ \'TAX_CODE\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i> </label> <input type="text" name="TaxCode" class="form-control" style="background:#fffeed" ng-model="$mdl.item.taxCode" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxCode.$error.required && $mdl.salesConfigForm.$submitted"> * {{"REQUIRED" | translate}} </p> </div> </div> <div class="col-lg-4"> <div class="form-group" ng-class="{\'has-error\': $mdl.salesConfigForm.TaxPercent.$invalid && ($mdl.salesConfigForm.TaxPercent.$dirty || $mdl.salesConfigForm.$submitted)}"> <label><b>{{ \'TAX_PERCENT\' | translate }} (%)</b> <i class="fa fa-asterisk req" style="color:#f00"></i> </label> <input type="number" name="TaxPercent" class="form-control" style="background:#fffeed" ng-model="$mdl.item.taxPercentage" min="0" required ng-change="$mdl.taxPercentChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxPercent.$error.required && $mdl.salesConfigForm.$submitted"> * {{"REQUIRED" | translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxPercent.$min.required && $mdl.salesConfigForm.$submitted"> * {{ \'MINIMUM_IS_0\' | translate }} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxPercent.$min.required && $mdl.salesConfigForm.$submitted"> * {{ \'ENTER_NUMBERS_ONLY\' | translate }} </p> </div> </div> <div class="col-lg-4"> <div class="form-group"> <label> <b>{{ \'TAX_AMOUNT\' | translate }}</b> <small>({{$mdl.currencyCode}})</small> </label> <span class="form-control" ng-disabled="true"> {{ $mdl.item.taxAmount | number:3 }} </span> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="certModal.html"><form name="$mdl.certForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} {{ \'CERTIFICATE\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'SUPPLIER\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select name="Supplier" class="form-control" style="background:#fffeed" ng-change="$mdl.selectedSupplierChanged()" ng-model="$mdl.selectedSupplier" ng-options="i as i.supplier.name for i in $mdl.supplierList" required> <option></option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.certForm.Supplier.$error.required && $mdl.certForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group"> <label><b>{{ \'CERTIFICATE_TYPE\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select name="Supplier" class="form-control" style="background:#fffeed" ng-model="$mdl.item.certType" required> <option></option> <option value="HACCP">{{ \'HACCP\' | translate }}</option> <option value="HALAL">{{ \'HALAL\' | translate }}</option> <option value="OTHERS">{{ \'OTHERS\' | translate }}</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.certForm.Supplier.$error.required && $mdl.certForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>{{ \'CERTIFICATE_REF_NO\' | translate }}</b></label> <input type="text" name="CertRefNo" class="form-control" style="background:#fffeed" ng-model="$mdl.item.certRefNo" /> <p class="help-block" style="color:#f00" ng-show="$mdl.certForm.CertRefNo.$error.required && $mdl.certForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group"> <label><b>{{ \'ISSUE_DATE\' | translate }}</b></label> <div moment-picker="$mdl.item.issueDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control" name="IssueDate" autocomplete="off" ng-model="$mdl.item.issueDate" style="background:#fffeed"> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.certForm.IssueDate.$error.required && $mdl.certForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>{{ \'EXPIRY_DATE\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <div moment-picker="$mdl.item.expiryDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control" name="ExpiryDate" autocomplete="off" ng-model="$mdl.item.expiryDate" style="background:#fffeed" required> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.certForm.ExpiryDate.$error.required && $mdl.certForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" style="background:#fffeed" ng-model="$mdl.item.remarks" /> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" style="margin-top:15px"> <label><b>{{ \'ATTACHMENT\' | translate }}</b> <small>{{ \'CERTIFICATE_PDF_PNG_JPG_FORMAT\' | translate }}</small></label> <div class="row"> <div class="col-lg-6"> <span class="form-control" style="background:#fffeed" ng-if="$mdl.item.mediaToUpload.name || $mdl.mode==1"> {{ $mdl.item.mediaToUpload.name || (\'NO_FILE_SELECTED\' | translate) }} </span> <a class="btn btn-primary btn-with-icon" style="color:#fff" href="{{$mdl.rootUrl}}{{$mdl.item.certFilename}}" target="_blank" ng-if="$mdl.item.certFilename!=\'\' && !$mdl.item.mediaToUpload.name"> <i class="fa fa-file-text"></i> {{ \'VIEW_UPLOADED_FILE\' | translate}} </a> </div> <div class="col-lg-6"> <div class="btn btn-default btn-with-icon" name="file" ng-model="$mdl.mediaFile" ngf-select="$mdl.setUploadMedia($mdl.mediaFile)" ngf-accept="\'image/*,application/pdf\'" ngf-pattern="\'image/*,application/pdf\'" ngf-model-invalid="errorFile" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-upload"></i> {{ \'BROWSE\' | translate}} </div> <a href ng-click="$mdl.mediaFile=null;$mdl.setUploadMedia(null)" ng-if="$mdl.mediaFile" class="btn btn-danger btn-with-icon" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-remove-circle"></i> {{ \'RESET\' | translate}} </a> </div> </div> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING"></b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="auditLogModal.html"><form name="$mdl.uomForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <b translate="VIEW_REVISION"></b> <div style="font-size:10pt;line-height:110%"> <span translate="REVISION_BY_:"></span> {{$mdl.log.username | uppercase}}<br /> <span translate="REVISION_ON_:"></span> {{$mdl.log.createdDate | date:\'dd/MM/yyyy hh:mma\'}} </div> </h3> </div> <div class="modal-body" id="modal-body" style="font-size:9pt"> <div class="row"> <div class="col-lg-6"> <h3><u><b translate="BEFORE_REVISION"></b></u></h3> </div> <div class="col-lg-6"> <h3><u><b translate="AFTER_REVISION"></b></u></h3> </div> </div> <div class="row"> <div class="col-lg-6"> <span translate="CODE:"></span> <b>{{$mdl.oriData.code}}</b> </div> <div class="col-lg-6"> <span translate="CODE:"></span> <b>{{$mdl.newData.code}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> {{ \'DESCRIPTION\' | translate }}: <b>{{$mdl.oriData.description}}</b> </div> <div class="col-lg-6"> {{ \'DESCRIPTION\' | translate }}: <b>{{$mdl.newData.description}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> <span translate="SHORT_DESCRIPTION:"></span> <b>{{$mdl.oriData.shortDescription}}</b> </div> <div class="col-lg-6"> <span translate="SHORT_DESCRIPTION:"></span> <b>{{$mdl.newData.shortDescription}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> <span translate="CATEGORY:"></span> <b>{{$mdl.oriData.category}}</b> </div> <div class="col-lg-6"> <span translate="CATEGORY:"></span> <b>{{$mdl.newData.category}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> {{ \'SUB-CATEGORY\' | translate }}:<b>{{$mdl.oriData.subCategory}}</b> </div> <div class="col-lg-6"> {{ \'SUB-CATEGORY\' | translate }}: <b>{{$mdl.newData.subCategory}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> <span translate="YIELD:"></span> <b>{{$mdl.oriData.yieldPercent}} %</b> </div> <div class="col-lg-6"> <span translate="YIELD:"></span> <b>{{$mdl.newData.yieldPercent}} %</b> </div> </div> <div class="row"> <div class="col-lg-6"> {{ \'STATUS\' | translate }}: <b>{{$mdl.oriData.active?\'ACTIVE\':\'INACTIVE\'}}</b> </div> <div class="col-lg-6"> {{ \'STATUS\' | translate }}: <b>{{$mdl.newData.active?\'ACTIVE\':\'INACTIVE\'}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> <span translate="LABEL_PRINT_OPTION:"></span> <b>{{$mdl.oriData.labelPrintOption?\'SINGLE\':\'MULTIPLE\'}}</b> </div> <div class="col-lg-6"> <span translate="LABEL_PRINT_OPTION:"></span><b>{{$mdl.newData.labelPrintOption?\'SINGLE\':\'MULTIPLE\'}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> <br /> <span translate="U.O.M_LIST:"></span> <table border=1 style="border:1px solid #aaa;border-collapse:collapse;width:100%" class="table table-striped table-sm"> <tr> <td style="width:20%"><span translate="UOM"></span></td> <td style="width:20%"><span translate="MULTIPLIER"></span></td> <td style="text-align:center;width:15%"><span translate="BASE"></span></td> <td style="text-align:center;width:15%"><span translate="INV"></span></td> <td style="text-align:center;width:15%"><span translate="P.O."></span></td> <td style="text-align:center;width:15%"> <span translate="SALES"></span></td> </tr> <tr ng-repeat="u in $mdl.oriData.itemUnitOfMeasurements | orderBy:\'baseMultiplier\'"> <td><b>{{u.unitOfMeasurement.name}}</b></td> <td>X <b>{{u.baseMultiplier}}</b></td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isBase" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isBase" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isInventory" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isInventory" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isOrder" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isOrder" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isSales" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isSales" style="color:#f00"></i> </td> </tr> </table> </div> <div class="col-lg-6"> <br /> <span translate="U.O.M_LIST:"></span> <table border=1 style="border:1px solid #aaa;border-collapse:collapse;width:100%" class="table table-striped table-sm"> <tr> <td style="width:20%"><span translate="UOM"></span></td> <td style="width:20%"><span translate="MULTIPLIER"></span></td> <td style="text-align:center;width:15%"><span translate="BASE"></span></td> <td style="text-align:center;width:15%"><span translate="INV"></span></td> <td style="text-align:center;width:15%"><span translate="P.O."></span></td> <td style="text-align:center;width:15%"><span translate="SALES"></span></td> </tr> <tr ng-repeat="u in $mdl.newData.itemUnitOfMeasurements | orderBy:\'baseMultiplier\'"> <td><b>{{u.unitOfMeasurement.name}}</b></td> <td>X <b>{{u.baseMultiplier}}</b></td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isBase" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isBase" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isInventory" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isInventory" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isOrder" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isOrder" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isSales" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isSales" style="color:#f00"></i> </td> </tr> </table> </div> </div> <div class="row"> <div class="col-lg-6"> <br /> <span translate="PAR_LEVEL:"></span> <table border=1 style="border:1px solid #aaa;border-collapse:collapse;width:100%" class="table table-striped table-sm"> <tr> <td style="width:40%"> {{ \'BRANCH\' | translate }}</td> <td style="text-align:right;width:20%"><span translate="PAR_LEVEL"></span></td> <td style="text-align:right;width:20%"><span translate="REORDER_LEVEL"></span></td> <td style="text-align:right;width:20%"> <span translate="REORDER_QTY"></span></td> </tr> <tr ng-repeat="b in $mdl.oriData.itemBranchConfigs"> <td><b>{{b.branch.name}}</b></td> <td style="text-align:right"> <b>{{b.parLevel}}</b> {{$mdl.invUom}} </td> <td style="text-align:right"> <b>{{b.reOrderLevel}}</b> {{$mdl.invUom}} </td> <td style="text-align:right"> <b>{{b.reOrderQuantity}}</b> {{$mdl.orderUom}} </td> </tr> </table> </div> <div class="col-lg-6"> <br /> <span translate="PAR_LEVEL:"></span> <table border=1 style="border:1px solid #aaa;border-collapse:collapse;width:100%" class="table table-striped table-sm"> <tr> <td style="width:40%"> {{ \'BRANCH\' | translate }}</td> <td style="text-align:right;width:20%"><span translate="PAR_LEVEL"></span></td> <td style="text-align:right;width:20%"> <span translate="REORDER_LEVEL"></span></td> <td style="text-align:right;width:20%"> <span translate="REORDER_QTY"></span></td> </tr> <tr ng-repeat="b in $mdl.newData.itemBranchConfigs"> <td style="line-height:110%;padding-top:8px;padding-bottom:8px"> <b>{{b.branch.name}}</b> </td> <td style="text-align:right"> <b>{{b.parLevel}}</b> {{$mdl.invUom}} </td> <td style="text-align:right"> <b>{{b.reOrderLevel}}</b> {{$mdl.invUom}} </td> <td style="text-align:right"> <b>{{b.reOrderQuantity}}</b> {{$mdl.orderUom}} </td> </tr> </table> </div> </div> <div class="row"> <div class="col-lg-6"> <br /> <span translate="CERTIFICATES:"></span> <table border=1 style="border:1px solid #aaa;border-collapse:collapse;width:100%" class="table table-striped table-sm"> <tr> <td style="width:35%"><span translate="SUPPLIER"></span></td> <td style="width:20%"><span translate="CERT._TYPE"></span></td> <td style="width:15%;line-height:110%;padding-top:8px;padding-bottom:8px"><span translate="CERT_REF_NO"></span></td> <td style="width:15%"> <span translate="ISSUE_DATE"></span></td> <td style="width:15%"> <span translate="EXPIRY_DATE"></span></td> </tr> <tr ng-repeat="c in $mdl.oriData.itemCertificates"> <td style="line-height:110%;padding-top:8px;padding-bottom:8px"> <b>{{c.supplier.name}}</b> </td> <td><b>{{c.certType}}</b></td> <td><b>{{c.certRefNo}}</b></td> <td><b>{{c.issueDate || \'-\' | date:\'dd/MM/yyyy\'}}</b></td> <td><b>{{c.expiryDate || \'-\' | date:\'dd/MM/yyyy\'}}</b></td> </tr> </table> </div> <div class="col-lg-6"> <br /> <span translate="CERTIFICATES:"></span> <table border=1 style="border:1px solid #aaa;border-collapse:collapse;width:100%" class="table table-striped table-sm"> <tr> <td style="width:35%"> <span translate="SUPPLIER"></span></td> <td style="width:20%"><span translate="CERT._TYPE"></span></td> <td style="width:15%;line-height:110%;padding-top:8px;padding-bottom:8px"><span translate="CERT_REF_NO"></span></td> <td style="width:15%"> <span translate="ISSUE_DATE"></span></td> <td style="width:15%"><span translate="EXPIRY_DATE"></span></td> </tr> <tr ng-repeat="c in $mdl.newData.itemCertificates"> <td style="line-height:110%;padding-top:8px;padding-bottom:8px"> <b>{{c.supplier.name}}</b> </td> <td><b>{{c.certType}}</b></td> <td><b>{{c.certRefNo}}</b></td> <td><b>{{c.issueDate || \'-\' | date:\'dd/MM/yyyy\'}}</b></td> <td><b>{{c.expiryDate || \'-\' | date:\'dd/MM/yyyy\'}}</b></td> </tr> </table> </div> </div> <div class="row"> <div class="col-lg-6"> <br /> <span translate="SUPPLIER_PRICING:"></span> <table border=1 style="border:1px solid #aaa;border-collapse:collapse;width:100%" class="table table-striped table-sm"> <tr> <td style="width:35%"> <span translate="SUPPLIER"></span></td> <td style="width:20%"> {{ \'DESCRIPTION\' | translate }}</td> <td style="width:10%;text-align:right"><span translate="QTY"></span></td> <td style="width:10%"><span translate="UOM"></span></td> <td style="width:20%;text-align:right;line-height:110%;padding-top:8px;padding-bottom:8px"> <span translate="COST"></span><br /><small translate="(EXCL._TAX)"></small> </td> <td style="width:20%;text-align:right;line-height:110%;padding-top:8px;padding-bottom:8px"> <span translate="TAX"></span>(%) </td> <td style="width:20%;text-align:right"> <span translate="TAX"></span></td> <td style="width:20%;text-align:right;line-height:110%;padding-top:8px;padding-bottom:8px"> <span translate="COST"></span><br /><small translate="(INCL._TAX)"></small> </td> <td style="width:20%;text-align:right;line-height:110%;padding-top:8px;padding-bottom:8px"> {{ \'TAX_CODE\' | translate }} </td> </tr> <tr ng-repeat="c in $mdl.oriData.itemPrices"> <td style="line-height:110%;padding-top:8px;padding-bottom:8px"> <b>{{c.supplier.name}}</b> </td> <td style="line-height:110%;padding-top:8px;padding-bottom:8px"> <b>{{c.supplierItemDescription}}</b> </td> <td style="text-align:right"><b>{{c.quantity}}</b></td> <td><b>{{c.unitOfMeasurement.name}}</b></td> <td style="text-align:right"><b>{{c.cost | number:2}}</b></td> <td style="text-align:right"><b>{{c.taxPercent}}</b>%</td> <td style="text-align:right"><b>{{c.tax | number:2}}</b></td> <td style="text-align:right"><b>{{c.costIncGst | number:2}}</b></td> <td style="text-align:right"><b>{{c.taxCode}}</b></td> </tr> </table> </div> <div class="col-lg-6"> <br /> <span translate="SUPPLIER_PRICING:"></span> <table border=1 style="border:1px solid #aaa;border-collapse:collapse;width:100%" class="table table-striped table-sm"> <tr> <td style="width:35%"> <span translate="SUPPLIER"></span></td> <td style="width:20%"> {{ \'DESCRIPTION\' | translate }}</td> <td style="width:10%;text-align:right"><span translate="QTY"></span></td> <td style="width:10%"><span translate="UOM"></span></td> <td style="width:20%;text-align:right;line-height:110%;padding-top:8px;padding-bottom:8px"> <span translate="COST"></span><br /><small translate="(EXCL._TAX)"></small> </td> <td style="width:20%;text-align:right;line-height:110%;padding-top:8px;padding-bottom:8px"> <span translate="TAX"></span>(%) </td> <td style="width:20%;text-align:right"> <span translate="TAX"></span></td> <td style="width:20%;text-align:right;line-height:110%;padding-top:8px;padding-bottom:8px"> <span translate="COST"></span><br /><small translate="(INCL._TAX)"></small> </td> <td style="width:20%;text-align:right;line-height:110%;padding-top:8px;padding-bottom:8px"> {{ \'TAX_CODE\' | translate }} </td> </tr> <tr ng-repeat="c in $mdl.newData.itemPrices"> <td style="line-height:110%;padding-top:8px;padding-bottom:8px"> <b>{{c.supplier.name}}</b> </td> <td style="line-height:110%;padding-top:8px;padding-bottom:8px"> <b>{{c.supplierItemDescription}}</b> </td> <td style="text-align:right"><b>{{c.quantity}}</b></td> <td><b>{{c.unitOfMeasurement.name}}</b></td> <td style="text-align:right"><b>{{c.cost | number:2}}</b></td> <td style="text-align:right"><b>{{c.taxPercent}}</b>%</td> <td style="text-align:right"><b>{{c.tax | number:2}}</b></td> <td style="text-align:right"><b>{{c.costIncGst | number:2}}</b></td> <td style="text-align:right"><b>{{c.taxCode}}</b></td> </tr> </table> </div> </div> </div> <hr /> <div class="modal-footer"> <center> <button type="submit" class="btn btn-warning btn-with-icon btn-lg" type="button" style="color:#000" ng-disabled="$mdl.isLoading" rms-check-access="maintenance.items" rms-check-access-perm-type="APPROVE"> <i class="ion ion-checkmark"></i> <span translate="REVERT_THIS_REVISION"></span> </button> &nbsp;&nbsp;&nbsp;&nbsp; <button class="btn btn-danger btn-with-icon btn-lg" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.isLoading"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </center> <div ng-if="$mdl.isLoading" style="margin-top:10px;color:#00f"> <big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b></center></big> </div> </div> </form></script>');
$templateCache.put('app/pages/maintenance/items/itemCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/items/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true" ng-disabled="vm.isLoading"><i class="ion ion-checkmark"></i> <span translate="CREATE_ITEM"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.items.list" ng-disabled="vm.isLoading"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/items/itemImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b translate="IMPORT_RAW_MATERIAL_PRICING_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'1\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE..."></span></div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_RAW_MATERIAL_UOMS_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'2\')" ng-disabled="vm.isExporting || vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE..."></span></div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_RAW_MATERIAL_PAR_LEVEL_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'3\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_RM_X_DEBTOR_X_SALES_CONFIG_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'5\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_RAW_MATERIAL_LABEL_INFO_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'4\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend translate="IMPORT_GUIDELINES:"></legend><ol class="import"><li translate="YOU_NEED_TO_FOLLOW_THE_INSTRUCTION_BELOW_IF_YOU_ARE_NEW_TO_THE_RMS."></li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW_FILL_IT_UP_WITH_THE_DATA_FIRST_THEN_IMPORT_INTO_THE_RMS"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'1\', \'Raw Material &amp; Pricing Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_RAW_MATERIAL"></span> &amp; <span translate="PRICING_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'2\', \'Raw Material UOM Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_RAW_MATERIAL_UOMS_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'3\', \'Raw Material PAR Level Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_RAW_MATERIAL_PAR_LEVEL_TEMPLATE"></span></a></li><li><span translate="LASTLY,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplateOther(\'Raw Material x Debtor x Sales Config Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_RM_X_DEBTOR_X_SALES_CONFIG_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'4\', \'Raw Material Label Info Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_RAW_MATERIAL_LABEL_INFO_TEMPLATE"></span></a></li><li translate="AFTER_IMPORTED_THE_DATA_ONCE,_YOU_CAN_FREELY_IMPORT_THE_DATA_WITHOUT_FOLLOWING_THE_SEQUENCE."></li></ol></fieldset><br>&nbsp;<br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong translate="FILE_UPLOADED_SUCCESSFULLY._CHOOSE_THE_OPTIONS_BELOW_AND_PROCEED_TO_IMPORT_THE_DATA."></strong></div><div><fieldset ng-if="vm.importType==\'1\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createItem" ng-change="change()" ng-disabled="true" style="cursor:pointer"> <label><span translate="CREATE_NEW_ITEMS"></span></label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateItem" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_ITEM_IF_EXISTS"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createSupplier" ng-change="change()" style="cursor:pointer"> <label><span translate="CREATE_NEW_SUPPLIERS"></span></label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateSupplier" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_SUPPLIERS_IF_EXISTS"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createPricing" ng-change="change()" style="cursor:pointer"> <label><span translate="ADD_NEW_SUPPLIER_PRICING"></span></label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updatePricing" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_SUPPLIER_PRICING_IF_EXISTS"></span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-warning btn-with-icon" style="margin-left:30px;color:#000" ng-click="vm.selectPO()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-file-o"></i> <span translate="SELECT_PO"></span></a> <span style="font-size:120%">&nbsp;<i class="fa fa-info-circle" style="font-size:120%" uib-tooltip="Related item price for the selected P.O. will be updated."></i> &nbsp;<b>{{vm.selectedPOList.length}}</b> {{ \'SELECTED\' | translate}}</span> <a href="" class="btn btn-primary btn-with-icon" style="margin-left:30px" ng-click="vm.importData(\'1\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'2\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createUom" ng-change="change()" style="cursor:pointer"> <label><span translate="ADD_NEW_UOM"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateUom" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_UOM_IF_EXISTS"></span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'2\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'3\'"><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'3\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'4\'"><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'4\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'5\'"><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importDataOther()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><br><br><fieldset><legend translate="ITEM_DATA_PREVIEW:"></legend></fieldset></div><div id="scroll-container" class="horizontal-scroll"><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'1\'"><thead><tr><th style="width:60px">#</th><th><b>{{ \'ITEM_CODE\' | translate }}</b></th><th><b>{{ "ITEM_NAME" | translate }}</b></th><th><b>{{ "ITEM_DESCRIPTION" | translate }}</b></th><th><b>{{ "ITEM_DESCRIPTION" | translate }} (<span>{{ "SUPPLIER"></span>)</b></th><th><b>{{ "CATEGORY" | translate }}</b></th><th><b>{{ "SUB-CATEGORY" | translate }}</b></th><th style="text-align:center !important"><b>{{ "YIELD_(%)" | translate }}</b></th><th><b>{{ "SUPPLIER_CODE" | translate }}</b></th><th><b>{{ "SUPPLIER_NAME" | translate }}</b></th><th style="text-align:center !important"><b>{{ "IS_DEFAULT" | translate }}</b></th><th><b>{{ "TAX_CODE" | translate }}</b></th><th style="text-align:right !important"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b>{{ "U.O.M" | translate }}</b></th><th style="text-align:right !important" nowrap="nowrap"><b><span>{{ "COST_(RM)" | translate }}</span><br><small><span>{{ "EXCL_TAX" | translate }}</span></small></b></th><th style="text-align:center !important" nowrap="nowrap"><b>{{ "SALES" | translate }}<br><span>{{ "TAX" | translate }}</span> (%)</b></th><th style="text-align:right !important" nowrap="nowrap"><b><span>{{ "COST_(RM)" | translate }}</span><br><small>{{ "INCL_TAX" | translate }}</small></b></th><th><b>{{ "ACTIVE" | translate }}</b></th><th><b>{{ "IS_FOR_SALE" | translate }}</b></th></tr><tr><th colspan="18"><span>{{ "TOTAL_RECORDS:" | translate }}</span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.itemCode || \'\' }}</td><td nowrap="nowrap">{{ row.itemName || \'\' }}</td><td nowrap="nowrap">{{ row.shortDescription || \'\' }}</td><td nowrap="nowrap">{{ row.itemDescriptionSupplier || \'\' }}</td><td nowrap="nowrap">{{ row.category || \'-\' }}</td><td nowrap="nowrap">{{ row.subCategory || \'-\' }}</td><td align="center">{{ row.yieldPercent || \'-\' }} %</td><td>{{ row.supplierCode || \'-\' }}</td><td nowrap="nowrap">{{ row.supplierName || \'-\' }}</td><td align="center">{{ row.isDefaultSupplier || \'\' }}</td><td align="center">{{ row.taxCode || \'\' }}</td><td align="right">{{ row.quantity || \'-\' }}</td><td align="left">{{ row.uom || \'-\' }}</td><td align="right">{{ row.cost || \'-\' | number:2 }}</td><td align="center">{{ row.taxPercent || \'-\' }} %</td><td align="right">{{ row.costIncGst || \'-\' | number:2 }}</td><td align="center">{{ row.active || \'\' }}</td><td align="center">{{ row.isForSale || \'\' }}</td></tr><tr><td colspan="18" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span>{{ "EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="18"><span>{{ "TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'2\'"><thead><tr><th style="width:60px">#</th><th><b>{{ \'ITEM_CODE\' | translate }}</b></th><th><b>{{ "ITEM_NAME" | translate }}</b></th><th style="text-align:center !important"><b>{{ "BASE_UOM" | translate }}</b></th><th style="text-align:center !important"><b>{{ "BASE_MULTIPLIER" | translate }}</b></th><th style="text-align:center !important"><b>{{ \'INVENTORY_UOM\' | translate }}</b></th><th style="text-align:center !important"><b>{{ "INVENTORY_UOM_MULTIPLIER" | translate }}</b></th><th style="text-align:center !important"><b>{{ "P.O._UOM" | translate }}</b></th><th style="text-align:center !important"><b>{{ "P.O._UOM_MULTIPLIER" | translate }}</b></th><th style="text-align:center !important"><b>{{ \'SALES_UOM\' | translate }}</b></th><th style="text-align:center !important"><b>{{ "SALES_UOM_MULTIPLIER" | translate }}</b></th><th style="text-align:center !important"><b>{{ "OTHER_UOM_#1" | translate }}</b></th><th style="text-align:center !important"><b>{{ "OTHER_UOM_MULTIPLIER_#1" | translate }}</b></th><th style="text-align:center !important"><b>{{ "OTHER_UOM_#2" | translate }}</b></th><th style="text-align:center !important"><b>{{ "OTHER_UOM_MULTIPLIER_#2" | translate }}</b></th><th style="text-align:center !important"><b>{{ "OTHER_UOM_#3" | translate }}</b></th><th style="text-align:center !important"><b>{{ "OTHER_UOM_MULTIPLIER_#3" | translate }}</b></th><th style="text-align:center !important"><b>{{ "LABEL_PRINT_OPTION" | translate }}</b></th></tr><tr><th colspan="18"><span>{{ "TOTAL_RECORDS:" | translate }}</span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.itemCode || \'\' }}</td><td nowrap="nowrap">{{ row.itemName || \'\' }}</td><td align="center" style="color:#00f">{{ row.baseUom || \'\' }}</td><td align="center">{{ row.baseMultiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.invUom || \'\' }}</td><td align="center">{{ row.invUomMultiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.orderUom || \'\' }}</td><td align="center">{{ row.orderUomMultiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.salesUom || \'\' }}</td><td align="center">{{ row.salesUomMultiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.otherUom1 || \'\' }}</td><td align="center">{{ row.otherUom1Multiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.otherUom2 || \'\' }}</td><td align="center">{{ row.otherUom2Multiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.otherUom3 || \'\' }}</td><td align="center">{{ row.otherUom3Multiplier || \'\' }}</td><td align="center">{{ (row.labelPrintOption==1?\'SINGLE\':\'MULTIPLE\') || \'\' }}</td></tr><tr><td colspan="18" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span>{{ "EXCEL_CONTENT_IS_EMPTY." | translate }}</span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="18"><span>{{ "TOTAL_RECORDS:" | translate }}</span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'3\'"><thead><tr><th style="width:60px">#</th><th><b>{{ "ITEM_CODE" | translate }}</b></th><th nowrap="nowrap"><b>{{ "ITEM_NAME" | translate }}</b></th><th><b>{{ "BRANCH_CODE" | translate }}</b></th><th style="text-align:right !important" nowrap="nowrap"><b>{{ \'PAR_LEVEL\' | translate }}</b></th><th><b>{{ "UOM" | translate }}</b></th><th style="text-align:right !important" nowrap="nowrap"><b>{{ "REORDER_LEVEL" | translate }}</b></th><th><b>{{ "UOM" | translate }}</b></th><th style="text-align:right !important" nowrap="nowrap"><b>{{ \'REORDER_QUANTITY\' | translate }}</b></th><th><b>{{ "UOM" | translate }}</b></th></tr><tr><th colspan="10"><span>{{ "TOTAL_RECORDS:" | translate }}</span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.itemCode || \'\' }}</td><td nowrap="nowrap">{{ row.itemName || \'\' }}</td><td nowrap="nowrap">{{ row.branchCode || \'\' }}</td><td style="text-align:right;color:#00f">{{ row.parLevel || \'\' | number:0 }}</td><td>{{ row.uom1 || \'\' }}</td><td style="text-align:right;color:#00f">{{ row.reorderLevel || \'\' | number:0 }}</td><td>{{ row.uom2 || \'\' }}</td><td style="text-align:right;color:#00f">{{ row.reorderQty || \'\' | number:0 }}</td><td>{{ row.uom3 || \'\' }}</td></tr><tr><td colspan="10" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="10"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'4\'"><thead><tr><th style="width:60px">#</th><th><b translate="ITEM_CODE"></b></th><th nowrap="nowrap"><b translate="ITEM_NAME"></b></th><th><b translate="CUSTOM_TEXT_#1"></b></th><th><b translate="CUSTOM_TEXT_#2"></b></th><th><b translate="CUSTOM_TEXT_#3"></b></th><th><b translate="CUSTOM_TEXT_#4"></b></th><th><b translate="CUSTOM_TEXT_#5"></b></th><th><b translate="CUSTOM_TEXT_#6"></b></th><th><b translate="CUSTOM_TEXT_#7"></b></th><th><b translate="CUSTOM_TEXT_#8"></b></th></tr><tr><th colspan="11"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.itemCode || \'\' }}</td><td nowrap="nowrap">{{ row.itemName || \'\' }}</td><td nowrap="nowrap">{{ row.customField1 || \'\' }}</td><td nowrap="nowrap">{{ row.customField2 || \'\' }}</td><td nowrap="nowrap">{{ row.customField3 || \'\' }}</td><td nowrap="nowrap">{{ row.customField4 || \'\' }}</td><td nowrap="nowrap">{{ row.customField5 || \'\' }}</td><td nowrap="nowrap">{{ row.customField6 || \'\' }}</td><td nowrap="nowrap">{{ row.customField7 || \'\' }}</td><td nowrap="nowrap">{{ row.customField8 || \'\' }}</td></tr><tr><td colspan="11" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="11"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'5\'"><thead><tr><th style="width:60px">#</th><th><b translate="ITEM_CODE"></b></th><th nowrap="nowrap"><b translate="ITEM_NAME"></b></th><th><b translate="DEBTOR_CODE"></b></th><th nowrap="nowrap"><b translate="DEBTOR_NAME"></b></th><th><b translate="SALES_U.O.M"></b></th><th style="text-align:right !important" nowrap="nowrap"><b translate="UNIT_PRICE"></b></th><th><b>{{ \'TAX_CODE\' | translate }}</b></th><th style="text-align:right !important" nowrap="nowrap"><b translate="TAX_PERCENT"></b></th><th style="text-align:right !important" nowrap="nowrap"><b translate="TAX_AMOUNT"></b></th></tr><tr><th colspan="10"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.itemCode || \'-\' }}</td><td nowrap="nowrap">{{ row.itemName || \'-\' }}</td><td>{{ row.debtorCode || \'-\' }}</td><td nowrap="nowrap">{{ row.debtorName || \'-\' }}</td><td>{{ row.uom || \'-\' }}</td><td style="text-align:right;color:#00f">{{ row.unitPrice | number:2 }}</td><td>{{ row.taxCode || \'-\' }}</td><td style="text-align:right;color:#00f">{{ row.taxPercentage | number:0 }}</td><td style="text-align:right;color:#00f">{{ row.taxAmount | number:2 }}</td></tr><tr><td colspan="10" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="7"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-12 col-lg-12"><br><p translate="THE_DATA_IS_CURRENTLY_BEING_PROCESSED._IT_IS_SAFE_TO_LEAVE_THIS_PAGE_NOW."></p><p><span translate="IT_WILL_TAKE_A_FEW_MINUTES_TO_HOURS_TO_COMPLETE_THIS_IMPORT_DEPENDS_ON_THE_DATA_SIZE"></span>. <span translate="YOU_WILL_BE_NOTIFIED_BY_EMAIL_WHEN_THE_IMPORT_IS_COMPLETE."></span></p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.items.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a></div></form></div><div class="float-scroll-button"><span class="scroll-caption"><span translate="SCROLL"></span></span> <a href="" class="scroll-left" ng-if="vm.isSuccess && !vm.isImporting" ng-click="vm.scrollLeft()"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-arrow-left fa-stack-1x fa-inverse"></i></span></a> <a href="" class="scroll-right" ng-if="vm.isSuccess && !vm.isImporting" ng-click="vm.scrollRight()"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-arrow-right fa-stack-1x fa-inverse"></i></span></a></div><script type="text/ng-template" id="purchaseOrderListModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="SELECT_PURCHASE_ORDER"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" st-pipe="$mdl.retrieveData" st-table="$mdl.poData" refresh-table> <thead> <tr class="sortable"> <th colspan="7"> <div class="col-lg-3" style="height:35px;line-height:35px;padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control" style="background:#FFFCED" /> </div> </div> <div class="col-lg-1"></div> <div class="col-lg-3" style="height:35px;line-height:35px"> <span translate="SHOW_PER_PAGE:"></span> <select class="btn-group bootstrap-select form-control" ng-model="$mdl.pageSize" style="background:#FFFCED;width:70px"> <option ng-repeat="i in $mdl.pageSizeOption">{{i}}</option> </select> </div> <div class="col-lg-5" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th style="width:60px">#</th> <th st-sort="purchaseOrderNo" st-sort-default="reverse" style="width:150px"> <span translate="P.O._NO."></span></th> <th st-sort="purchaseOrderDate"style="width:150px;padding-top:11px;padding-bottom:11px;line-height:110%"><span translate="ORDER_DATE"></span><br /><small>(DD/MM/YYYY)</small></th> <th st-sort="deliveryDate" style="width:150px;padding-top:11px;padding-bottom:11px;line-height:110%"><span translate="DELIVERY_DATE"></span><br /><small>(DD/MM/YYYY)</small></th> <th st-sort="supplierName"><span translate="SUPPLIER_NAME"></span></th> <th>{{ \'BRANCH_NAME\' | translate }}</th> <th st-sort="status">{{ \'STATUS\' | translate }}</th> </tr> <tr class="sortable"> <th colspan="4"> </th> <th class="form-inline"> <select st-search="supplierName"> <option value="">{{ \'ALL\' | translate }}</option> <option ng-repeat="po in $mdl.poDataFull | unique:\'supplierName\' | orderBy:\'supplierName\'" value="{{po.supplierName}}"> {{ po.supplierName | uppercase }} </option> </select> </th> <th colspan="2"> </th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="7" style="line-height:100px"> <center> <b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b> </center> </td> </tr> <tr ng-if="!$mdl.isLoading && $mdl.poData.length==0"> <td colspan="7" style="line-height:100px"> <center><b> {{ \'NO_RECORD_FOUND\' | translate }}.</b></center> </td> </tr> <tr ng-repeat="item in $mdl.poData"> <td> <input type="checkbox" name="chkSelect" style="background:#fffff4;width:20px;height:20px;margin-top:10px;" checklist-model="$mdl.selectedPOs" checklist-value="{ purchaseOrderId: item.id, purchaseOrderNo: item.purchaseOrderNo }" checklist-change="$mdl.dataForm.chkSelect.$setValidity(\'required\', $mdl.selectedPOs.length > 0)" ng-required="!$mdl.selectedPOs.length" /> </td> <td>{{item.purchaseOrderNo}}</td> <td>{{item.purchaseOrderDate | date: "dd/MM/yyyy"}}</td> <td>{{item.deliveryDate | date: "dd/MM/yyyy"}}</td> <td style="padding-top:11px;padding-bottom:11px;line-height:130%">{{item.supplierName || \'-\'}}</td> <td>{{item.branchName || \'-\'}}</td> <td> <b> <span style="color:#31b046">{{item.status}}</span> </b> </td> </tr> </tbody> </table> </div> </div> </div> <hr /> <div class="modal-footer"> <div style="float:left" style="color:#000"> <span translate="SELECTED"></span>: <b>{{$mdl.selectedPOs.length}}</b> </div> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.confirmModal()" ng-disabled="$mdl.isLoading"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/maintenance/items/itemList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" style="width:auto;min-width:100%"><table class="table table-hover" st-persist="RawMaterialListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.items.create" rms-check-access="maintenance.items" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="CREATE_NEW"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="maintenance.items.import" rms-check-access="maintenance.items" rms-check-access-perm-type="CREATE"><i class="fa fa-download"></i> <span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:140px">{{ \'IMAGE\' | translate}}</th><th st-sort="code">{{ \'CODE\' | translate }}</th><th st-sort="description">{{ \'ITEM_NAME\' | translate }}</th><th st-sort="category">{{ \'CATEGORY\' | translate }}</th><th st-sort="subCategory">{{ \'SUB-CATEGORY\' | translate }}</th><th st-sort="active">{{ \'STATUS\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th></th><th class="form-inline" colspan="2"><input st-search="code" class="form-control input input-sm" style="width:300px"></th><th class="form-inline"><input st-search="category" class="form-control input input-sm"></th><th class="form-inline"><input st-search="subCategory" class="form-control input input-sm"></th><th class="form-inline"><select st-search="active" class="form-control input input-sm"><option value="">{{ \'ALL\' | translate }}</option><option value="1">{{ \'ACTIVE\' | translate | uppercase }}</option><option value="0">{{ \'INACTIVE\' | translate | uppercase }}</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-show="vm.data.length<=0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA_...\' | translate }}</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td><img src="{{((item.imageLocation==null || item.imageLocation==\'\') ? \'assets/img/empty_placeholder.png\' : vm.blobUrl + item.imageLocation)}}" style="width:96px;height:64px;margin-top:10px;margin-bottom:10px;border:2px solid #ccc"></td><td>{{item.code | uppercase}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.description | uppercase}}</td><td>{{item.category | uppercase}}</td><td>{{item.subCategory | uppercase}}</td><td><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.items.update({id:item.id})" ng-disabled="vm.isLoading" rms-check-access="maintenance.items" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteItem(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this item?" ng-disabled="vm.isLoading" rms-check-access="maintenance.items" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/maintenance/items/itemUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/items/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.items.list" style="margin-right:20px" ng-disabled="vm.isLoading"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true" ng-disabled="vm.isLoading"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.items.list" ng-disabled="vm.isLoading"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/intercompanymappings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>Active</b></label><div><toggle ng-model="vm.mapping.active" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceCompany.$invalid && (vm.dataForm.SourceCompany.$dirty || vm.dataForm.$submitted)}"><label><b>Source Company</b> <i class="fa fa-asterisk req"></i></label><select name="SourceCompany" class="form-control" ng-change="vm.selectedSourceCompanyChanged()" ng-model="vm.selectedSourceCompany" ng-options="i as (i.name | uppercase) for i in user.companies" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceCompany.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle">&nbsp;<br><b>&rarr;</b><br><b>&rarr;</b></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestCompany.$invalid && (vm.dataForm.DestCompany.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Company</b> <i class="fa fa-asterisk req"></i></label><select name="DestCompany" class="form-control" ng-change="vm.selectedDestCompanyChanged()" ng-model="vm.selectedDestCompany" ng-options="i as (i.name | uppercase) for i in user.companies" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestCompany.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle"></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestBranch.$invalid && (vm.dataForm.DestBranch.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Branch</b> <i class="fa fa-asterisk req"></i></label><select name="DestBranch" class="form-control" ng-change="vm.selectedDestBranchChanged()" ng-model="vm.selectedDestBranch" ng-options="i as (i.name | uppercase) for i in vm.destBranchList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestBranch.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceSupplier.$invalid && (vm.dataForm.SourceSupplier.$dirty || vm.dataForm.$submitted)}"><label><b>Source Supplier</b> <i class="fa fa-asterisk req"></i></label><select name="SourceSupplier" class="form-control" ng-change="vm.selectedSourceSupplierChanged()" ng-model="vm.selectedSourceSupplier" ng-options="i as (i.name | uppercase) for i in vm.supplierList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceSupplier.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle">&nbsp;<br><b>&rarr;</b><br><b>&rarr;</b></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestDebtor.$invalid && (vm.dataForm.DestDebtor.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Customer</b> <i class="fa fa-asterisk req"></i></label><select name="DestDebtor" class="form-control" ng-change="vm.selectedDestDebtorChanged()" ng-model="vm.selectedDestDebtor" ng-options="i as (i.name | uppercase) for i in vm.debtorList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestDebtor.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceBranch.$invalid && (vm.dataForm.SourceBranch.$dirty || vm.dataForm.$submitted)}"><label><b>Source Branch</b> <i class="fa fa-asterisk req"></i></label><select name="SourceBranch" class="form-control" ng-change="vm.selectedSourceBranchChanged()" ng-model="vm.selectedSourceBranch" ng-options="i as (i.name | uppercase) for i in vm.sourceBranchList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceBranch.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle">&nbsp;<br><b>&rarr;</b><br><b>&rarr;</b></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestDebtorBranch.$invalid && (vm.dataForm.DestDebtorBranch.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Customer\'s Branch</b> <i class="fa fa-asterisk req"></i></label><select name="DestDebtorBranch" class="form-control" ng-change="vm.selectedDestDebtorBranchChanged()" ng-model="vm.selectedDestDebtorBranch" ng-options="i as (i.name | uppercase) for i in vm.debtorBranchList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestDebtorBranch.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.mapping.id!=null"><p><i class="fa fa-info-circle"></i> Audit trail of changes made to this Company Mapping.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b>Date / Time</b></th><th style="width:180px"><b>Edited By</b></th><th style="width:40%"><b>Original Values</b></th><th style="width:40%"><b>Updated Values</b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br>There is no changes yet.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/maintenance/intercompanymappings/mappingCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/intercompanymappings/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create Mapping</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.intercompanymappings.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/maintenance/intercompanymappings/mappingImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b>Import Mapping Data</b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> Browse</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile()" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> Upload File</a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px">Uploading file...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong>Failed to process uploaded file. File might contain errors.</strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong>Failed to upload file.</strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend>Import Guidelines:</legend><ol class="import"><li>You need to follow the instruction below if you are new to the RMS.</li><li>Download the template below, fill it up with the data first, then import into the RMS:<br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate()"><i class="fa fa-download"></i> Download Mapping Template</a></li></ol></fieldset><br>&nbsp;<br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong>File uploaded successfully. Choose the options below and proceed to import the data.</strong></div><div><fieldset><legend>Import Options:</legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createCompanyMapping" ng-change="change()" style="cursor:pointer"> <label><span>Create New Mappings</span></label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateCompanyMapping" ng-change="change()" style="cursor:pointer"> <label><span>Update Mapping if exists</span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> Confirm Import</a></div></div></fieldset><br><br><fieldset><legend>Mapping Data Preview:</legend></fieldset></div><div id="scroll-container" class="horizontal-scroll"><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important"><thead><tr><th style="width:60px">#</th><th><b>Source Company Code</b></th><th><b>Source Company Name</b></th><th><b>Source Branch Code</b></th><th><b>Source Branch Branch</b></th><th><b>Source Supplier Code</b></th><th><b>Source Supplier Name</b></th><th><b>Dest Company Code</b></th><th><b>Dest Company Name</b></th><th><b>Dest Branch Code</b></th><th><b>Dest Branch Name</b></th><th><b>Dest Customer Code</b></th><th><b>Dest Customer Name</b></th><th><b>Dest Customer Branch Name</b></th><th><b>Active</b></th></tr><tr><th colspan="15">Total Records: {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td nowrap="nowrap">{{ row.sourceCompanyCode || \'-\' }}</td><td nowrap="nowrap">{{ row.sourceCompanyName || \'-\' }}</td><td nowrap="nowrap">{{ row.sourceBranchCode || \'-\' }}</td><td nowrap="nowrap">{{ row.sourceBranchName || \'-\' }}</td><td nowrap="nowrap">{{ row.sourceSupplierCode || \'-\' }}</td><td nowrap="nowrap">{{ row.sourceSupplierName || \'-\' }}</td><td nowrap="nowrap">{{ row.destCompanyCode || \'-\' }}</td><td nowrap="nowrap">{{ row.destCompanyName || \'-\' }}</td><td nowrap="nowrap">{{ row.destBranchCode || \'-\' }}</td><td nowrap="nowrap">{{ row.destBranchName || \'-\' }}</td><td nowrap="nowrap">{{ row.destCustomerCode || \'-\' }}</td><td nowrap="nowrap">{{ row.destCustomerName || \'-\' }}</td><td nowrap="nowrap">{{ row.destCustomerBranchName || \'-\' }}</td><td nowrap="nowrap">{{ row.active || \'N\' }}</td></tr><tr><td colspan="15" align="center" ng-show="vm.importOptions.excelContent.length==0"><br>Excel content is empty.<br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="15">Total Records: {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-6 col-lg-6"><em><small><i class="fa fa-info-circle"></i> Processing...</small></em><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><p>The data is currently being processed. It is safe to leave this page now.</p><p>You will receive an email notification about the import result once the server has finished processed the data.</p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.intercompanymappings.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back To List</a></div></form></div>');
$templateCache.put('app/pages/maintenance/intercompanymappings/mappingList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="InterCompanyMapping" st-pipe="vm.retrieveData" st-table="vm.mappingData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Mapping" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.intercompanymappings.create" rms-check-access="maintenance.intercompanymappings" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>New Mapping</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="sourceCompanyName">SOURCE<br>Company Name</th><th st-sort="sourceBranchName">SOURCE<br>Branch Name</th><th st-sort="sourceSupplierName">SOURCE<br>Supplier Name</th><th st-sort="destCompanyName" style="border-left:2px solid black">DESTINATION<br>Company Name</th><th st-sort="destBranchName">DESTINATION<br>Branch Name</th><th st-sort="destDebtorName">DESTINATION<br>Customer Name</th><th st-sort="destDebtorBranchName">DESTINATION<br>Customer Site Name</th><th class="hide-after" style="text-align:center">Active</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline"><input st-search="sourceCompanyName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="sourceBranchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="sourceSupplierName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="destCompanyName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="destBranchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="destDebtorName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="destDebtorBranchName" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.mappingData.length==0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.mappingData"><td>{{vm.startIndex+1+$index}})</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%">{{item.sourceCompanyName | uppercase}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%">{{item.sourceBranchName | uppercase}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%">{{item.sourceSupplierName | uppercase}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%;border-left:2px solid black">{{item.destCompanyName | uppercase}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%">{{item.destBranchName | uppercase}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%">{{item.destDebtorName | uppercase}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%">{{item.destDebtorBranchName | uppercase}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.intercompanymappings.update({id:item.id})" rms-check-access="maintenance.intercompanymappings" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Mapping" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteMapping(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Mapping?" rms-check-access="maintenance.intercompanymappings" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/intercompanymappings/mappingUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/intercompanymappings/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.intercompanymappings.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button></div></form>');
$templateCache.put('app/pages/maintenance/packagingconditions/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Name.$invalid && (vm.dataForm.Name.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'NAME\' | translate}}</b>&nbsp; <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Name" ng-model="vm.customdata.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Name.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'DESCRIPTION\' | translate}}</b></label> <input type="text" class="form-control" name="Description" ng-model="vm.customdata.description"></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'IS_ACTIVE\' | translate }} ?</b></label><div><toggle ng-model="vm.customdata.active" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/maintenance/packagingconditions/pkgconditionCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/packagingconditions/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_CATEGORY"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.packagingconditions.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/packagingconditions/pkgconditionList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.packagingconditions.create" rms-check-access="maintenance.packagingconditions" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> {{ \'ADD_NEW\' | translate }}</a> <a href="" class="btn btn-success btn-with-icon" ui-sref="maintenance.packagingconditions.import" rms-check-access="maintenance.packagingconditions" rms-check-access-perm-type="CREATE"><i class="fa fa-download"></i> {{ \'IMPORT_EXCEL\' | translate }}</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="name">{{ "NAME" | translate }}</th><th st-sort="description">{{ "DESCRIPTION" | translate }}</th><th>{{ "ACTIVE" | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline" colspan="2"><input st-search="code" class="form-control input input-sm" style="width:300px"></th><th class="form-inline"><select st-search="active" class="form-control input input-sm"><option value="">{{ \'ALL\' | translate }}</option><option value="1">{{ \'ACTIVE\' | translate | uppercase }}</option><option value="0">{{ \'INACTIVE\' | translate | uppercase }}</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-show="vm.data.length<=0 && !vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td>{{item.description}}</td><td><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.packagingconditions.update({id:item.id})" rms-check-access="maintenance.packagingconditions" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Shipping Method" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteItem(item.id, item.name)" ng-confirm-click="Confirm delete this Shipping Method?" rms-check-access="maintenance.packagingconditions" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/packagingconditions/pkgconditionUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/packagingconditions/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:20px" ui-sref="maintenance.packagingconditions.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.packagingconditions.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/shippingmethods/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Name.$invalid && (vm.dataForm.Name.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'NAME\' | translate}}</b>&nbsp; <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Name" ng-model="vm.customdata.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Name.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'DESCRIPTION\' | translate}}</b></label> <input type="text" class="form-control" name="Description" ng-model="vm.customdata.description"></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'SHIPPING_OPTIONS\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><br><label class="radio-inline custom-radio nowrap"><input name="ShippingOptions" type="radio" data-ng-model="vm.customdata.shippingOption" data-ng-value="0"> <span>{{ \'SELF_COLLECT\' | translate }}</span></label> <label class="radio-inline custom-radio nowrap"><input name="ShippingOptions" type="radio" data-ng-model="vm.customdata.shippingOption" data-ng-value="1"> <span>{{ \'DELIVERY\' | translate }}</span></label></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'IS_ACTIVE\' | translate }} ?</b></label><div><toggle ng-model="vm.customdata.active" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/maintenance/shippingmethods/customDataListImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b translate="IMPORT_SHIPPING_METHOD_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'SPM\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="(excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons)"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE..."></span></div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b translate="IMPORT_PACKAGING_CONDITION_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'PKC\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="(excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons)"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE..."></span></div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend translate="IMPORT_GUIDELINES:"></legend><ol class="import"><li translate="YOU_NEED_TO_FOLLOW_THE_INSTRUCTION_BELOW_IF_YOU_ARE_NEW_TO_THE_RMS."></li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW_FILL_IT_UP_WITH_THE_DATA_FIRST_THEN_IMPORT_INTO_THE_RMS"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'SPM\', \'Shipping Method Data Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_SHIPPING_METHOD_TEMPLATE"></span></a></li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW_FILL_IT_UP_WITH_THE_DATA_FIRST_THEN_IMPORT_INTO_THE_RMS"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'PKC\', \'Packaging Condition Data Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_PACKAGING_CONDITION_TEMPLATE"></span></a></li></ol></fieldset><br>&nbsp;<br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong translate="FILE_UPLOADED_SUCCESSFULLY._CHOOSE_THE_OPTIONS_BELOW_AND_PROCEED_TO_IMPORT_THE_DATA."></strong></div><div><fieldset ng-if="vm.importType==\'SPM\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createCustomData" ng-change="change()" ng-disabled="true" style="cursor:pointer"> <label>&nbsp;{{ \'CREATE_NEW_SHIPPING_METHODS\' | translate }}</label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateCustomData" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'UPDATE_SHIPPING_METHOD_IF_EXISTS\' | translate }}</label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'SPM\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'PKC\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createCustomData" ng-change="change()" ng-disabled="true" style="cursor:pointer"> <label>&nbsp;{{ \'CREATE_NEW_PACKAGING_CONDITIONS\' | translate }}</label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateCustomData" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'UPDATE_PACKAGING_CONDITION_IF_EXISTS\' | translate }}</label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'PKC\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><br><br><fieldset><legend translate="DATA_PREVIEW"></legend></fieldset></div><div id="scroll-container" class="horizontal-scroll"><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'SPM\'"><thead><tr><th style="width:60px">#</th><th><b translate="NAME"></b></th><th><b translate="DESCRIPTION"></b></th><th><b translate="SHIPPING_OPTION"></b></th><th><b translate="IS_ACTIVE"></b></th></tr><tr><th colspan="5"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.name || \'\' }}</td><td>{{ row.description || \'\' }}</td><td>{{ row.shippingOption || \'\' }}</td><td>{{ row.active || \'\' }}</td></tr><tr><td colspan="5" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="5"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'PKC\'"><thead><tr><th style="width:60px">#</th><th><b translate="NAME"></b></th><th><b translate="DESCRIPTION"></b></th><th><b translate="IS_ACTIVE"></b></th></tr><tr><th colspan="5"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.name || \'\' }}</td><td>{{ row.description || \'\' }}</td><td>{{ row.active || \'\' }}</td></tr><tr><td colspan="5" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="5"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-12 col-lg-12"><br><p translate="THE_DATA_IS_CURRENTLY_BEING_PROCESSED._IT_IS_SAFE_TO_LEAVE_THIS_PAGE_NOW."></p><p><span translate="YOU_WILL_BE_NOTIFIED_BY_EMAIL_WHEN_THE_IMPORT_IS_COMPLETE."></span></p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.shippingmethods.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a></div></form></div><div class="float-scroll-button"><span class="scroll-caption"><span translate="SCROLL"></span></span> <a href="" class="scroll-left" ng-if="vm.isSuccess && !vm.isImporting" ng-click="vm.scrollLeft()"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-arrow-left fa-stack-1x fa-inverse"></i></span></a> <a href="" class="scroll-right" ng-if="vm.isSuccess && !vm.isImporting" ng-click="vm.scrollRight()"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-arrow-right fa-stack-1x fa-inverse"></i></span></a></div>');
$templateCache.put('app/pages/maintenance/shippingmethods/shippingmethodCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/shippingmethods/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_SHIPPING_METHOD"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.shippingmethods.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/shippingmethods/shippingmethodList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="ShippingMethodListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.shippingmethods.create" rms-check-access="maintenance.shippingmethods" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> {{ \'ADD_NEW\' | translate }}</a> <a href="" class="btn btn-success btn-with-icon" ui-sref="maintenance.shippingmethods.import" rms-check-access="maintenance.shippingmethods" rms-check-access-perm-type="CREATE"><i class="fa fa-download"></i> {{ \'IMPORT_EXCEL\' | translate }}</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="name">{{ "NAME" | translate }}</th><th st-sort="description">{{ "DESCRIPTION" | translate }}</th><th>{{ "SHIPPING_OPTIONS" | translate }}</th><th>{{ "ACTIVE" | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline" colspan="2"><input st-search="code" class="form-control input input-sm" style="width:300px"></th><th class="form-inline"><select st-search="shippingOption" class="form-control input input-sm"><option value="">{{ \'ALL\' | translate }}</option><option value="1">{{ \'DELIVERY\' | translate | uppercase }}</option><option value="0">{{ \'SELF_COLLECT\' | translate | uppercase }}</option></select></th><th class="form-inline"><select st-search="active" class="form-control input input-sm"><option value="">{{ \'ALL\' | translate }}</option><option value="1">{{ \'ACTIVE\' | translate | uppercase }}</option><option value="0">{{ \'INACTIVE\' | translate | uppercase }}</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-show="vm.data.length<=0 && !vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td>{{item.description}}</td><td>{{item.shippingOption | translate | uppercase }}</td><td><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.shippingmethods.update({id:item.id})" rms-check-access="maintenance.shippingmethods" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Shipping Method" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteItem(item.id, item.name)" ng-confirm-click="Confirm delete this Shipping Method?" rms-check-access="maintenance.shippingmethods" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/shippingmethods/shippingmethodUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/shippingmethods/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:20px" ui-sref="maintenance.shippingmethods.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.shippingmethods.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/semifgs/_form.html','<style>\n\t.modal-lg {\n\t\twidth: 1400px !important;\n\t}\n</style><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-md-3 col-lg-3"><div class="row"><img ngf-src="picFile || vm.item.imageLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div><br><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-hide="vm.lockUploadButton" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> {{ \'UPLOAD_PICTURE\' | translate }}</div><a href="" class="btn btn-default btn-with-icon" ng-click="picFile=null;vm.clearImage()" ng-hide="vm.lockUploadButton" ng-show="(picFile || vm.item.imageLocation.indexOf(\'empty_placeholder\')<0)"><i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }}</a></div><div class="row" ng-show="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div><div class="col-md-4 col-lg-4"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SfgCode.$invalid && (vm.dataForm.SfgCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="SFG_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SfgCode" ng-model="vm.item.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SfgCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SfgName.$invalid && (vm.dataForm.SfgName.$dirty || vm.dataForm.$submitted)}"><label><b translate="SFG_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SfgName" ng-model="vm.item.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SfgName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b translate="SFG_DESCRIPTION"></b></label> <input type="text" class="form-control" ng-model="vm.item.shortDescription"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Category.$invalid && (vm.dataForm.Category.$dirty || vm.dataForm.$submitted)}"><label><b translate="CATEGORY"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Category" ng-model="vm.item.category" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Category.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="SUB_CATEGORY"></b></label> <input type="text" class="form-control" ng-model="vm.item.subCategory"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LifeTime.$invalid && (vm.dataForm.LifeTime.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SHELF_LIFE_(DAY)\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="LifeTime" ng-model="vm.item.lifeTime" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LifeTime.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LifeTime.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.JobBatchDailyMaxQuantity.$invalid && (vm.dataForm.JobBatchDailyMaxQuantity.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'MAX_PRODUCTION_BATCH_PER_DAY\' | translate }}</b></label> <input type="number" class="form-control" name="JobBatchDailyMaxQuantity" ng-model="vm.item.jobBatchDailyMaxQuantity"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.JobBatchDailyMaxQuantity.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'STATUS\' | translate }}</b></label><div><toggle ng-model="vm.item.active" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'FOR_SALE\' | translate }}</b></label><div><toggle ng-model="vm.item.isForSale" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label uib-tooltip="{{ \'DRILL_DOWN_SFG_RECIPE\' | translate }}" tooltip-placement="top"><b>{{ \'POS_SYNC_DRILL_DOWN\' | translate }}</b> <i class="fa fa-info-circle"></i></label><div><toggle ng-model="vm.item.hasDrillDown" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-12 col-lg-12"><div class="col-md-12 col-lg-12" style="padding:15px;background:#b7ffb7;margin-bottom:15px"><div class="form-group" style="margin-bottom:0px"><label><b>{{ \'ASSOCIATED_RECIPE_(FROM_RECIPE_CARD)\' | translate }}</b></label><p><small><i class="fa fa-info-circle"></i> <span translate="THIS_IS_REQUIRED_TO_ASSOCIATE_THE_SEMI_FG_WITH_THE_RAW_INGREDIENTS_NEEDED_FOR_PRODUCTION"></span></small></p><div class="row"><div class="col-lg-3" style="padding-right:0px"><div class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-search"></i></span> <input class="form-control" ng-model="vm.recipeSearch" ng-disabled="vm.loadingRecipe" ng-model-options="{ debounce: 1500 }" ng-change="vm.loadRecipeList(vm.recipeSearch)"></div></div><div class="col-lg-9"><select class="form-control" ng-change="vm.onSelectedRecipeChanged()" ng-options="u as (u.name | uppercase) for u in vm.recipeList | filter: vm.recipeSearch" ng-model="vm.selectedRecipe"><option value="">{{(vm.loadingRecipe ? (\'LOADING...\' | translate) : (vm.recipeList.length==0 ? ("&lt;&lt; " + (\'ENTER_A_KEYWORD_TO_SEARCH\' | translate)) : "-- " + (\'SELECT_A_RECIPE\' | translate) + " --"))}}</option></select><button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" title="Clear Selection" style="margin-top:5px" ng-if="vm.selectedRecipe!=null" ng-click="vm.clearSelectedRecipe()"><i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }}</button></div></div></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="col-md-12 col-lg-12" style="padding:15px;background:#fdffde;margin-bottom:15px"><div class="form-group"><label><b>{{ \'PACKAGING_INSTRUCTION\' | translate }}</b></label><p><small><i class="fa fa-info-circle"></i> <span translate="THIS_INSTRUCTION_WILL_APPEAR_IN_THE_JOB_SHEET_AND_JOB_DASHBOARD_ONLY"></span></small></p><textarea class="form-control" rows="5" ng-model="vm.item.packagingInstruction">\n\t\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="col-lg-12" style="padding:15px;background:#f9f9f9"><div class="row"><div class="col-lg-12" style="padding-bottom:5px"><b><u>{{ \'CHECKLISTS:\' | translate }}</u></b></div></div><div class="row"><div class="col-lg-12" style="font-size:90%;margin-bottom:5px"><i class="fa fa-check text-success" ng-if="vm.item.hasBaseUom"></i> <i class="fa fa-times text-danger" ng-if="!vm.item.hasBaseUom"></i> &nbsp;<span translate="HAS_BASE_UOM"></span> <span ng-if="vm.item.baseUom">- (<b>{{vm.item.baseUom}}</b>)</span></div></div><div class="row"><div class="col-lg-12" style="font-size:90%;margin-bottom:5px"><i class="fa fa-check text-success" ng-if="vm.item.hasOrderUom"></i> <i class="fa fa-times text-danger" ng-if="!vm.item.hasOrderUom"></i> &nbsp;<span translate="HAS_SALES_UOM"></span> <span ng-if="vm.item.orderUom">- (<b>{{vm.item.orderUom}}</b>)</span></div></div><div class="row"><div class="col-lg-12" style="font-size:90%;margin-bottom:5px"><i class="fa fa-check text-success" ng-if="vm.item.hasInventoryUom"></i> <i class="fa fa-times text-danger" ng-if="!vm.item.hasInventoryUom"></i> &nbsp;<span translate="HAS_INVENTORY_UOM"></span> <span ng-if="vm.item.inventoryUom">- (<b>{{vm.item.inventoryUom}}</b>)</span></div></div><div class="row"><div class="col-lg-12" style="font-size:90%;margin-bottom:5px"><i class="fa fa-check text-success" ng-if="vm.item.hasRecipe"></i> <i class="fa fa-times text-danger" ng-if="!vm.item.hasRecipe"></i> &nbsp;<span translate="ASSOCIATED_WITH_RECIPE"></span></div></div><div class="row"><div class="col-lg-12" style="font-size:90%"><i class="fa fa-check text-success" ng-if="vm.item.hasRecipeUom"></i> <i class="fa fa-times text-danger" ng-if="!vm.item.hasRecipeUom"></i> &nbsp;<span translate="RECIPES_UOM_INCLUDED"></span> <span ng-if="vm.item.recipeUom">- (<b>{{vm.item.recipeUom}}</b>)</span></div></div><div class="row"><div class="col-lg-12" style="margin-top:15px">{{ \'STATUS:\' | translate }} &nbsp; <b class="text-success" ng-if="vm.item.hasRecipe && vm.item.hasBaseUom && vm.item.hasInventoryUom && vm.item.hasOrderUom && vm.item.hasRecipeUom"><span translate="READY_FOR_SALES"></span> &nbsp;<i class="fa fa-check"></i></b> <b class="text-danger" ng-if="!(vm.item.hasRecipe && vm.item.hasBaseUom && vm.item.hasInventoryUom && vm.item.hasOrderUom && vm.item.hasRecipeUom)"><span translate="CONFIGURATION_INCOMPLETE"></span> &nbsp;<i class="fa fa-warning"></i></b></div></div></div></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'U.O.M.\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="ADD_THE_U.O.M._FOR_THE_SEMI_F.G."></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddUomModal()"><i class="ion-plus-round"></i><span translate="ADD_NEW_U.O.M."></span></a><br><br></p><div class="row"><div class="col-md-9 col-lg-9"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr><th style="width:60px">#</th><th><b translate="U.O.M._NAME"></b></th><th><b translate="BASE_MUTIPLIER"></b></th><th style="width:150px"><b>{{ \'BASE\' | translate }}</b><br><small>{{ \'UOM\' | translate }}</small></th><th style="width:150px"><b>{{ \'INVENTORY\' | translate }}</b><br><small>{{ \'UOM\' | translate }}</small></th><th style="width:150px"><b>{{ \'SALES\' | translate }}</b><br><small>{{ \'UOM\' | translate }}</small></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.item.semiFinishedProductUnitOfMeasurements"><td>{{$index+1}}</td><td>{{ ntn.unitOfMeasurement.name || \'\' }}</td><td>X {{ ntn.baseMultiplier }}</td><td><i class="fa fa-check" ng-show="ntn.isBase" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isBase" style="color:#f00"></i></td><td><i class="fa fa-check" ng-show="ntn.isInventory" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isInventory" style="color:#f00"></i></td><td><i class="fa fa-check" ng-show="ntn.isOrder" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isOrder" style="color:#f00"></i></td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditUomModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeUom($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="8" align="center" ng-if="vm.item.semiFinishedProductUnitOfMeasurements==null || vm.item.semiFinishedProductUnitOfMeasurements.length==0"><br><span translate="U.O.M._LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CWM\' | translate }}"><p><i class="fa fa-info-circle"></i> <span>{{ \'TO_CONFIG_CWM\' | translate }}</span><br><br></p><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>{{ \'IS_CWM\' | translate }} ?</b></label><div><toggle ng-model="vm.item.isCWM" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-2 col-lg-2" ng-if="vm.item.isCWM && vm.integrationMode!=-1"><div class="form-group"><label><b>{{ \'SYNC_PARALLEL_UOM\' | translate }} ?</b></label><div><toggle ng-model="vm.item.syncCwmParallelUom" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.item.isCWM"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CWMParallelMultiplier.$invalid && (vm.dataForm.CWMTolerance.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'PARALLEL_MULTIPLIER\' | translate }}</b> <i class="fa fa-asterisk req" ng-if="vm.item.isCWM"></i></label> <input type="number" class="form-control" name="CWMParallelMultiplier" min="0.01" ng-model="vm.item.cwm_ParallelMultiplier" ng-required="vm.item.isCWM"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMParallelMultiplier.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMParallelMultiplier.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMParallelMultiplier.$error.min">* {{ \'MINIMUM_VALUE_IS_0\' | translate }}.01</span></div></div></div><div class="row" ng-if="vm.item.isCWM"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ParallelUom1.$invalid && (vm.dataForm.ParallelUom1.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'PARALLEL_UOM\' | translate }} #1</b> <i class="fa fa-asterisk req" ng-if="vm.item.isCWM"></i></label><select class="form-control" name="ParallelUom1" style="color:#333" ng-options="u as u.unitOfMeasurement.name for u in vm.item.semiFinishedProductUnitOfMeasurements" ng-change="vm.selectedParallelUom1Changed()" ng-model="vm.selectedParallelUom1" ng-required="vm.item.isCWM"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ParallelUom1.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.item.isCWM"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ParallelUom2.$invalid && (vm.dataForm.ParallelUom2.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'PARALLEL_UOM\' | translate }} #2</b> <i class="fa fa-asterisk req" ng-if="vm.item.isCWM"></i></label><select class="form-control" name="ParallelUom2" style="color:#333" ng-options="u as u.unitOfMeasurement.name for u in vm.item.semiFinishedProductUnitOfMeasurements" ng-change="vm.selectedParallelUom2Changed()" ng-model="vm.selectedParallelUom2" ng-required="vm.item.isCWM"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ParallelUom2.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.item.isCWM"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CWMTolerance.$invalid && (vm.dataForm.CWMTolerance.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'TOLERANCE_PERCENTAGE\' | translate }} (%)</b> <i class="fa fa-asterisk req" ng-if="vm.item.isCWM"></i></label> <input type="number" class="form-control" name="CWMTolerance" min="0" ng-model="vm.item.cwm_TolerencePercent" ng-required="vm.item.isCWM"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMTolerance.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMTolerance.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMTolerance.$error.min">* {{ \'MINIMUM_VALUE_IS_0\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'INVENTORY\' | translate }}" ng-if="vm.isStarterMode!=null && !vm.isStarterMode && vm.mode==2"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_INVENTORY_CONFIGURATION_FOR_THE_STOCK_LEVEL."></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddParModal()"><i class="ion-plus-round"></i><span translate="ADD_NEW"></span></a><br><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped" style="border:1px solid #ccc;font-size:90%" st-table="vm.item.semiFinishedProductBranchConfigs"><thead><tr><th><b translate="BRANCH_NAME"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="MON_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="TUE_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="WED_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="THU_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="FRI_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="SAT_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="SUN_SHORT"></b></th><th class="hide-after" style="text-align:center" colspan="2"><b>{{ \'PAR_LEVEL\' | translate }}</b></th><th class="hide-after" style="text-align:center;width:100px" colspan="2"><b>{{ \'REORDER_LEVEL\' | translate }}</b></th><th class="hide-after" style="text-align:center;width:100px" colspan="2"><b>{{ \'REORDER_QUANTITY\' | translate }}</b></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="config in vm.item.semiFinishedProductBranchConfigs"><td style="color:#00f" nowrap="nowrap">{{ config.branch.name }}</td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.mon"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.tue"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.wed"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.thu"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.fri"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.sat"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.sun"></i></td><td style="width:100px;text-align:right" nowrap="nowrap"><b>{{ config.parLevel }}</b></td><td>{{ vm.uomInventory }}</td><td style="width:100px;text-align:right" nowrap="nowrap"><b>{{ config.reOrderLevel }}</b></td><td>{{ vm.uomInventory }}</td><td style="width:100px;text-align:right" nowrap="nowrap"><b>{{ config.reOrderQuantity }}</b></td><td>{{ vm.uomOrder }}</td><td></td><td style="padding-left:0px;padding-right:0px"><a class="btn btn-info btn-sm" ng-click="vm.showEditParModal($index)"><i class="fa fa-pencil"></i></a></td><td style="padding-left:0px;padding-right:0px"><a class="btn btn-danger btn-sm" confirmed-click="vm.removePar($index)" ng-confirm-click="Confirm remove this PAR entry?"><i class="fa fa-trash-o"></i></a></td></tr><tr><td colspan="15" align="center" ng-if="vm.item.semiFinishedProductBranchConfigs==null || vm.item.semiFinishedProductBranchConfigs.length==0"><br><span ng-if="vm.mode==2"><span translate="PAR_LEVEL_LIST_IS_EMPTY."></span></span><h2 ng-if="vm.mode==1" style="color:#f00"><center translate="PLEASE_SAVE_FIRST_BEFORE_SETTING_THE_PAR_LEVEL."></center></h2><br></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'YIELD\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Yield.$invalid && (vm.dataForm.Yield.$dirty || vm.dataForm.$submitted)}"><label><span translate="YIELD_PERCENTAGE_(%)"></span> <i class="fa fa-asterisk req"></i></label><p><small><i class="fa fa-info-circle"></i> <span translate="THE_ACTUAL_PERCENTAGE_OF_YIELD_FROM_THE_ORIGINAL_WEIGHT_/_MASS"></span></small></p><input type="number" class="form-control" name="Yield" ng-model="vm.item.yieldPercent" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Yield.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Yield.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CERTIFICATES\' | translate }}" ng-if="vm.mode==2"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_FOOD_SAFETY_CERTIFICATES_FOR_THIS_SEMI_FG"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddCertModal()"><i class="ion-plus-round"></i> {{ \'ADD_NEW_CERTIFICATE\' | translate }}</a><br><br></p><div class="row" ng-show="vm.mode==2"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="font-size:85%;border:1px solid #ccc" st-pipe="vm.refreshItemCerts" st-table="vm.item.semiFinishedProductCertificates" refresh-table=""><thead><tr><th style="width:60px">#</th><th><b>{{ \'CERT_TYPE\' | translate }}</b></th><th><b>{{ \'CERT_REF_NO\' | translate }}</b></th><th><b>{{ \'ISSUE_DATE\' | translate }}</b></th><th><b>{{ \'EXPIRY_DATE\' | translate }}</b></th><th><b>{{ \'REMARKS\' | translate }}</b></th><th style="width:100px"><b>{{ \'ATTACHMENT\' | translate }}</b></th><th style="width:65px"></th><th style="width:65px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.item.semiFinishedProductCertificates"><td>{{ $index+1 }}</td><td>{{ ntn.certType || \'\' }}</td><td>{{ ntn.certRefNo || \'\' }}</td><td>{{ ntn.issueDate | date:\'dd/MM/yyyy\' }}</td><td>{{ ntn.expiryDate | date:\'dd/MM/yyyy\' }}</td><td>{{ ntn.remarks || \'-\'}}</td><td><a class="btn btn-default editable-table-button btn-with-icon btn-xs" href="{{vm.blobUrl}}{{ntn.certFilename}}" target="_blank" ng-if="ntn.certFilename!=null && ntn.certFilename!=\'\'"><i class="fa fa-file-text"></i> {{ \'VIEW\' | translate }}</a> <span ng-if="ntn.certFilename==null || ntn.certFilename==\'\'">-</span></td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditCertModal(ntn.id)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeCert(ntn.id)" ng-confirm-click="Confirm remove this Certificate?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr ng-if="vm.item.semiFinishedProductCertificates.length==0"><td colspan="9" align="center"><br><span translate="CERTIFICATE_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center translate="PLEASE_SAVE_THE_SFG_FIRST_BEFORE_ADDING_CERTIFICATE."></center></h2></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'SALES_CONFIG\' | translate }}" ng-if="vm.mode==2"><p><i class="fa fa-info-circle"></i> {{ \'MANAGE_SALES_PRICE_FOR_INDIVIDUAL_CUSTOMER\' | translate }} <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-if="vm.mode==2" ng-click="vm.showAddSalesConfig()"><i class="ion-plus-round"></i> {{ \'ADD_NEW_SALES_CONFIG\' | translate }}</a><br><br></p><div class="row" ng-show="vm.mode==2"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="font-size:85%;border:1px solid #ccc" st-pipe="vm.refreshItemCerts" st-table="vm.salesConfigList" refresh-table=""><thead><tr><th style="width:60px">#</th><th><b>{{ \'CUSTOMER_CODE\' | translate }}</b></th><th><b>{{ \'CUSTOMER_NAME\' | translate }}</b></th><th style="text-align:right" class="hide-after"><b>{{ \'UNIT_PRICE\' | translate }} ({{vm.currencyCode}})</b></th><th style="width:65px"></th><th><b>{{ \'TAX_CODE\' | translate }}</b></th><th style="text-align:right" class="hide-after"><b>{{ \'TAX_PERCENT\' | translate }} (%)</b></th><th style="text-align:right" class="hide-after"><b>{{ \'TAX_AMOUNT\' | translate }} ({{vm.currencyCode}})</b></th><th style="width:65px"></th><th style="width:65px"></th><th style="width:65px"></th></tr></thead><tbody><tr ng-repeat="item in vm.salesConfigList"><td>{{ $index+1 }})</td><td style="width:200px">{{ item.debtorCode || \'-\' }}</td><td>{{ item.debtorName || \'-\' }}</td><td style="text-align:right">{{ item.unitPrice | number:3}} / {{item.uomName}}</td><td></td><td>{{ item.taxCode || \'-\' }}</td><td style="text-align:right">{{ item.taxPercentage | number:2}}%</td><td style="text-align:right">{{ item.taxAmount | number:3}}</td><td></td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditSalesConfig(item.id)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.deleteSalesConfig(item.id)" ng-confirm-click="Confirm remove this Sales Config?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="10" align="center" ng-show="vm.salesConfigList.length==0"><br><span>The list is empty.</span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center>Please save the Semi Finished Good first before adding Sales Config.</center></h2></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'LABEL_DETAILS\' | translate }}"><p translate="PLEASE_ENTER_THE_RELEVANT_INFORMATION_FOR_THE_LABEL_PRINTING."></p><p><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="PRODUCT_NAME"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.product_name"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="INGREDIENT_LINE_#1"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.ingredient_line1"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="INGREDIENT_LINE_#2"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.ingredient_line2"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="INGREDIENT_LINE_#3"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.ingredient_line3"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="INGREDIENT_LINE_#4"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.ingredient_line4"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="RETHERMALIZATION_INSTRUCTION_LINE_#1"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.rethermalize_1"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="RETHERMALIZATION_INSTRUCTION_LINE_#2"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.rethermalize_2"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="STORAGE"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.storage"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="HALAL_CERT_NUMBER_#1"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.halal_cert_1"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="HALAL_CERT_NUMBER_#2"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.halal_cert_2"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="CUSTOM_TEXT_#1"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.custom_text_01"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="CUSTOM_TEXT_#2"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.custom_text_02"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="CUSTOM_TEXT_#3"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.custom_text_03"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="CUSTOM_TEXT_#4"></label> <input type="text" class="form-control" ng-model="vm.item.templateContent.custom_text_04"></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="AutoCount Fields" ng-if="vm.hasAutoCountFields"><p><small><i class="fa fa-info-circle"></i> <span translate="_THESE_INFORMATION_MUST_BE_FILLED_IN_FOR_AUTOCOUNT_INTEGRATION."></span></small></p><br><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AcItemType.$invalid && (vm.dataForm.AcItemType.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select name="AcItemType" class="form-control" ng-change="vm.selectedItemTypeChanged()" ng-model="vm.selectedItemType" ng-options="i as (\'[\'+ i.itemType1 + \'] \' + (i.description || \'-\')) for i in vm.autoCount_itemTypes" ng-required="vm.hasAutoCountFields"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AcItemType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AcItemGroup.$invalid && (vm.dataForm.AcItemGroup.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_GROUP"></b> <i class="fa fa-asterisk req"></i></label><select name="AcItemGroup" class="form-control" ng-change="vm.selectedItemGroupChanged()" ng-model="vm.selectedItemGroup" ng-options="i as (\'[\'+ i.itemGroup1 + \'] \' + (i.description || \'-\')) for i in vm.autoCount_itemGroups" ng-required="vm.hasAutoCountFields"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AcItemGroup.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AcStockControl.$invalid && (vm.dataForm.AcStockControl.$dirty || vm.dataForm.$submitted)}"><label><b>Is Stock Control</b> <i class="fa fa-asterisk req"></i></label><select name="AcStockControl" class="form-control" ng-change="vm.selectedStockControlChanged()" ng-model="vm.selectedStockControl" ng-required="vm.hasAutoCountFields"><option value="1">{{ \'YES\' | translate }}</option><option value="0">{{ \'NO\' | translate }}</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AcStockControl.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group"><label><b>Classification Code</b></label> <input type="text" class="form-control" ng-model="vm.item.irbM_ClassificationCode"></div></div></div></uib-tab><uib-tab heading="SQL Fields" ng-if="vm.hasSQLFields"><p><small><i class="fa fa-info-circle"></i> <span translate="THESE_INFORMATION_MUST_BE_FILLED_IN_FOR_SQL_INTEGRATION."></span></small></p><br><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLItemGroup.$invalid && (vm.dataForm.SQLItemGroup.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_GROUP"></b> <i class="fa fa-asterisk req"></i></label><select name="SQLItemGroup" class="form-control" ng-change="vm.selectedSQLItemGroupChanged()" ng-model="vm.selectedSQLItemGroup" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sql_itemGroups" ng-required="vm.hasSQLFields"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLItemGroup.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLStockControl.$invalid && (vm.dataForm.SQLStockControl.$dirty || vm.dataForm.$submitted)}"><label><b>Is Stock Control</b> <i class="fa fa-asterisk req"></i></label><select name="SQLStockControl" class="form-control" ng-change="vm.selectedSQLStockControlChanged()" ng-model="vm.selectedSQLStockControl" ng-required="vm.hasSQLFields"><option value="1">{{ \'YES\' | translate }}</option><option value="0">{{ \'NO\' | translate }}</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLStockControl.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group"><label><b>Classification Code</b></label> <input type="text" class="form-control" ng-model="vm.item.irbM_ClassificationCode"></div></div></div></uib-tab><uib-tab heading="{{ \'RECIPES\' | translate }}" ng-if="vm.mode==2"><p><i class="fa fa-info-circle"></i> {{ \'LIST_OF_RECIPE_USING_THIS_SEMIFG\' | translate }}<br><br></p><div class="row"><div class="col-md-8 col-lg-8"><div style="max-height:300px;overflow-x:none;overflow-y:auto"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:40px">#</th><th>{{ \'RECIPE_NAME\' | translate }}</th><th style="width:80px"></th></tr></thead><tbody><tr ng-if="vm.item.recipeItems.length==0 && !vm.isLoading"><td colspan="3" style="height:100px;line-height:100px"><center>{{ \'NO_RECIPE_FOUND\' | translate }}</center></td></tr><tr ng-repeat="item in vm.item.recipeItems | orderBy:\'name\'"><td>{{ $index+1 }})</td><td>{{ item.name | uppercase }}</td><td style="width:80px"><a class="btn btn-primary editable-table-button btn-with-icon btn-xs" ui-sref="recipes.recipes.update({id:item.recipeId})" rms-check-access="recipes.recipes" rms-check-access-perm-type="UPDATE" style="width:80px"><i class="fa fa-eye"></i> {{ \'VIEW\' | translate }}</a></td></tr></tbody></table></div></div></div><p><br><br></p></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.item.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_SEMI_FINISHED_GOOD"></span>.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br>{{ \'THERE_IS_NO_CHANGES_YET\' | translate }}<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="uomModal.html"><form name="$mdl.uomForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} {{ \'U.O.M\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.uomForm.UOM.$invalid && $mdl.uomForm.$submitted}"> <label><b>{{ \'UNIT_OF_MEASUREMENT\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <small><br />&nbsp;</small> <select name="UOM" class="form-control" ng-options="i as (i.name | uppercase) for i in $mdl.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.onSelectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.uomForm.UOM.$error.required && $mdl.uomForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> <div class="col-md-4 col-lg-4" style="padding-right:0px"> <div class="form-group" ng-class="{\'has-error\': $mdl.uomForm.BaseMultiplier.$invalid && $mdl.uomForm.$submitted}"> <label><b translate="BASE_MULTIPLIER"></b> <i class="fa fa-asterisk req" style="color:#f00"></i> <br /><small><em translate="EQUIVALENT_TO_______BASE_UOM"></em></small> </label> <input type="number" name="BaseMultiplier" class="form-control" style="background:#fffeed" ng-model="$mdl.item.baseMultiplier" min="1" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.uomForm.BaseMultiplier.$error.required && $mdl.uomForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.uomForm.BaseMultiplier.$error.number && $mdl.uomForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.uomForm.BaseMultiplier.$error.min && $mdl.uomForm.$submitted">* <span translate="MINIMUM_VALUE_IS_1"></span></p> </div> </div> <div class="col-md-2 col-lg-2"> <div class="form-group"> <label><br /></label> <small><br />&nbsp;</small> <b class="form-control">{{$mdl.baseUom}}</b> </div> </div> </div> <div class="form-group"> <div class="row"> <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"> <div class="checkbox checkbox-primary"> <input type="checkbox" ng-model="$mdl.item.isBase" ng-change="change()" /> <label><span><b translate="BASE_UOM"></b></span></label> <p style="padding-left:20px;line-height:10px"><small><i class="fa fa-info-circle"></i> <em translate="THE_BASE_UNIT_OF_THIS_PRODUCT"></em></small></p> </div> </div> <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" ng-hide="true"> <div class="checkbox checkbox-primary"> <input type="checkbox" ng-model="$mdl.item.isDefault" ng-change="change()" /> <label><span><b>{{ \'DEFAULT_UOM\' | translate }}</b></span></label> <p style="padding-left:20px;line-height:10px"><small><i class="fa fa-info-circle"></i> <em translate="THE_DEFAULT_UNIT"></em></small></p> </div> </div> </div> <div class="row"> <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"> <div class="checkbox checkbox-primary"> <input type="checkbox" ng-model="$mdl.item.isInventory" ng-change="change()" /> <label><span><b>{{ \'INVENTORY_UOM\' | translate }}</b></span></label> <p style="padding-left:20px;line-height:10px"><small><i class="fa fa-info-circle"></i> <em translate="THE_UNIT_USED_FOR_STOCK_INVENTORY"></em></small></p> </div> </div> <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"> <div class="checkbox checkbox-primary"> <input type="checkbox" ng-model="$mdl.item.isOrder" ng-change="change()" /> <label><span><b translate="SALES_UOM"></b></span></label> <p style="padding-left:20px;line-height:10px"><small><i class="fa fa-info-circle"></i> <em translate="THE_UNIT_USED_FOR__SALES_ORDER"></em></small></p> </div> </div> </div> </div> <div class="form-group"> {{ \'REMARKS\' | translate }} <textarea class="form-control" ng-model="$mdl.item.remarks" /> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="parModal.html"><form name="$mdl.parForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} {{ \'PAR_LEVEL\' | translate | uppercase}}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.parForm.Branch.$invalid && $mdl.parForm.$submitted}"> <label><b>{{ \'REMARKS\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <small><br />&nbsp;</small> <select name="Branch" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.branchList" ng-model="$mdl.selectedBranch" ng-change="$mdl.selectedBranchChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.Branch.$error.required && $mdl.parForm.$submitted">* {{\'REQUIRED\'|translate}} </p> </div> </div> </div> <hr /> <div class="row"> <div class="col-lg-12"> <table class="table" style="margin-bottom:0px"> <tr> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Monday" ng-model="$mdl.item.mon" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'MONDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Tuesday" ng-model="$mdl.item.tue" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()"/> <label style="margin-left:20px"><span><b>{{ \'TUESDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Wednesday" ng-model="$mdl.item.wed" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'WEDNESDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Thursday" ng-model="$mdl.item.thu" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'THURSDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Friday" ng-model="$mdl.item.fri" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'FRIDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Saturday" ng-model="$mdl.item.sat" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'SATURDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Sunday" ng-model="$mdl.item.sun" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'SUNDAY\' | translate }}</b></span></label> </td> </tr> </table> </div> </div> <div ng-if="$mdl.parForm.$submitted && $mdl.isValidDays()"> <br /> <span style="color:#f00">* {{\'YOU_MUST_SELECT_AT_LEAST_ONE_DAY\' | translate}}</span> </div> <hr /> <div class="row"> <div class="col-md-4 col-lg-4"> <div class="row"> <div class="col-lg-12"> <label><b>{{ \'PAR_LEVEL\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> </div> </div> <div class="row"> <div class="col-lg-7"> <div class="form-group" ng-class="{\'has-error\': $mdl.parForm.ParLevel.$invalid && $mdl.parForm.$submitted}"> <input type="number" name="ParLevel" class="form-control" style="background:#fffeed" ng-model="$mdl.item.parLevel" min="0" ng-min="0" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ParLevel.$error.required && $mdl.parForm.$submitted">* {{\'REQUIRED\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ParLevel.$error.number && $mdl.parForm.$submitted">* {{\'KEY_IN_NUMBERS_ONLY\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ParLevel.$error.min && $mdl.parForm.$submitted">* {{\'MINIMUM_VALUE_IS_0\'|translate}} </p> </div> </div> <div class="col-lg-5" style="padding-left:0px;"> <div class="form-group" style="line-height:34px;color:#00f"> <b>{{$mdl.uomInventory}}</b> </div> </div> </div> </div> <div class="col-md-4 col-lg-4"> <div class="row"> <div class="col-lg-12"> <label><b>{{ \'REORDER_LEVEL\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> </div> </div> <div class="row"> <div class="col-lg-7"> <div class="form-group" ng-class="{\'has-error\': $mdl.parForm.ReorderLevel.$invalid && $mdl.parForm.$submitted}"> <input type="number" name="ReorderLevel" class="form-control" style="background:#fffeed" ng-model="$mdl.item.reOrderLevel" min="0" ng-min="0" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderLevel.$error.required && $mdl.parForm.$submitted">* {{\'REQUIRED\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderLevel.$error.number && $mdl.parForm.$submitted">* {{\'KEY_IN_NUMBERS_ONLY\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderLevel.$error.min && $mdl.parForm.$submitted">* {{\'MINIMUM_VALUE_IS_0\'|translate}} </p> </div> </div> <div class="col-lg-5" style="padding-left:0px;"> <div class="form-group" style="line-height:34px;color:#00f"> <b>{{$mdl.uomInventory}}</b> </div> </div> </div> </div> <div class="col-md-4 col-lg-4"> <div class="row"> <div class="col-lg-12"> <label><b>{{ \'REORDER_QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> </div> </div> <div class="row"> <div class="col-lg-7"> <div class="form-group" ng-class="{\'has-error\': $mdl.parForm.ReorderQuantity.$invalid && $mdl.parForm.$submitted}"> <input type="number" name="ReorderQuantity" class="form-control" style="background:#fffeed" ng-model="$mdl.item.reOrderQuantity" min="0" ng-min="0" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderQuantity.$error.required && $mdl.parForm.$submitted">* {{\'REQUIRED\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderQuantity.$error.number && $mdl.parForm.$submitted">* {{\'KEY_IN_NUMBERS_ONLY\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderQuantity.$error.min && $mdl.parForm.$submitted">* {{\'MINIMUM_VALUE_IS_0\'|translate}} </p> </div> </div> <div class="col-lg-5" style="padding-left:0px;"> <div class="form-group" style="line-height:34px;color:#00f"> <b>{{$mdl.uomOrder}}</b> </div> </div> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="salesConfigModal.html"><form name="$mdl.salesConfigForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} Sales Config</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'SELECT_A_CUSTOMER\' | translate }}</b> ({{ \'OPTIONAL\' | translate }})</label> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.debtorSearch" style="background:#fffeed" /> </div> </div> <div class="col-lg-9"> <select name="Customer" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.debtorList | filter: $mdl.debtorSearch" ng-model="$mdl.selectedDebtor" ng-change="$mdl.selectedDebtorChanged()"> <option value="">-- {{ \'SELECT_A_CUSTOMER\' | translate }} --</option> </select> </div> </div> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.salesConfigForm.UnitPrice.$invalid && ($mdl.salesConfigForm.UnitPrice.$dirty || $mdl.salesConfigForm.$submitted)}"> <label><b>{{ \'UNIT_PRICE\' | translate }}</b> <small>({{$mdl.currencyCode}})</small> <i class="fa fa-asterisk req" style="color:#f00"></i> </label> <input type="number" name="UnitPrice" class="form-control" style="background:#fffeed" ng-model="$mdl.item.unitPrice" min="0.01" required ng-change="$mdl.unitPriceChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.UnitPrice.$error.required && $mdl.salesConfigForm.$submitted"> * {{"REQUIRED" | translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.UnitPrice.$min.required && $mdl.salesConfigForm.$submitted"> * {{ \'MINIMUM_IS_0\' | translate }}.01 </p> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.UnitPrice.$min.required && $mdl.salesConfigForm.$submitted"> * {{ \'ENTER_NUMBERS_ONLY\' | translate }} </p> </div> </div> <div class="col-lg-6"> <label><b>{{ \'U.O.M.\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select name="UOM" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.selectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.UOM.$error.required && $mdl.salesConfigForm.$submitted"> * {{"REQUIRED" | translate}} </p> </div> </div> <br /> <div class="row"> <div class="col-lg-4"> <div class="form-group" ng-class="{\'has-error\': $mdl.salesConfigForm.TaxCode.$invalid && ($mdl.salesConfigForm.TaxCode.$dirty || $mdl.salesConfigForm.$submitted)}"> <label><b>{{ \'TAX_CODE\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i> </label> <input type="text" name="TaxCode" class="form-control" style="background:#fffeed" ng-model="$mdl.item.taxCode" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxCode.$error.required && $mdl.salesConfigForm.$submitted"> * {{"REQUIRED" | translate}} </p> </div> </div> <div class="col-lg-4"> <div class="form-group" ng-class="{\'has-error\': $mdl.salesConfigForm.TaxPercent.$invalid && ($mdl.salesConfigForm.TaxPercent.$dirty || $mdl.salesConfigForm.$submitted)}"> <label><b>{{ \'TAX_PERCENT\' | translate }} (%)</b> <i class="fa fa-asterisk req" style="color:#f00"></i> </label> <input type="number" name="TaxPercent" class="form-control" style="background:#fffeed" ng-model="$mdl.item.taxPercentage" min="0" required ng-change="$mdl.taxPercentChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxPercent.$error.required && $mdl.salesConfigForm.$submitted"> * {{"REQUIRED" | translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxPercent.$error.min && $mdl.salesConfigForm.$submitted"> * {{ \'MINIMUM_IS_0\' | translate }} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxPercent.$error.number && $mdl.salesConfigForm.$submitted"> * {{ \'ENTER_NUMBERS_ONLY\' | translate }} </p> </div> </div> <div class="col-lg-4"> <div class="form-group"> <label> <b>{{ \'TAX_AMOUNT\' | translate }}</b> <small>({{$mdl.currencyCode}})</small> </label> <span class="form-control" ng-disabled="true"> {{ $mdl.item.taxAmount | number:3 }} </span> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="certModal.html"><form name="$mdl.certForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} {{ \'CERTIFICATE\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-6"> <div class="form-group"> <label><b>{{ \'CERTIFICATE_TYPE\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select name="Supplier" class="form-control" style="background:#fffeed" ng-model="$mdl.item.certType" required> <option></option> <option value="GMP">{{ \'GMP\' | translate }}</option> <option value="HACCP">{{ \'HACCP\' | translate }}</option> <option value="HALAL">{{ \'HALAL\' | translate }}</option> <option value="MESTI">{{ \'MESTI\' | translate }}</option> <option value="OTHERS">{{ \'OTHERS\' | translate }}</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.certForm.Supplier.$error.required && $mdl.certForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>{{ \'CERTIFICATE_REF_NO\' | translate }}</b></label> <input type="text" name="CertRefNo" class="form-control" style="background:#fffeed" ng-model="$mdl.item.certRefNo" /> <p class="help-block" style="color:#f00" ng-show="$mdl.certForm.CertRefNo.$error.required && $mdl.certForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group"> <label><b>{{ \'ISSUE_DATE\' | translate }}</b></label> <div moment-picker="$mdl.item.issueDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control" name="IssueDate" autocomplete="off" ng-model="$mdl.item.issueDate" style="background:#fffeed"> </div> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>{{ \'EXPIRY_DATE\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <div moment-picker="$mdl.item.expiryDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control" name="ExpiryDate" autocomplete="off" ng-model="$mdl.item.expiryDate" style="background:#fffeed" required> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.certForm.ExpiryDate.$error.required && $mdl.certForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" style="background:#fffeed" ng-model="$mdl.item.remarks" /> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" style="margin-top:15px"> <label><b>{{ \'ATTACHMENT\' | translate }}</b> <small>{{ \'CERTIFICATE_PDF_PNG_JPG_FORMAT\' | translate }}</small></label> <div class="row"> <div class="col-lg-6"> <span class="form-control" style="background:#fffeed" ng-if="$mdl.mediaFile.name || $mdl.mode==1"> {{ $mdl.mediaFile.name || (\'NO_FILE_SELECTED\' | translate) }} </span> <a class="btn btn-primary btn-with-icon" style="color:#fff" href="{{$mdl.rootUrl}}{{$mdl.item.certFilename}}" target="_blank" ng-if="$mdl.item.certFilename!=\'\' && !$mdl.mediaFile.name"> <i class="fa fa-file-text"></i> {{ \'VIEW_UPLOADED_FILE\' | translate}} </a> </div> <div class="col-lg-6"> <div class="btn btn-default btn-with-icon" name="file" ng-model="$mdl.mediaFile" ngf-select="$mdl.setUploadMedia($mdl.mediaFile)" ngf-accept="\'image/*,application/pdf\'" ngf-pattern="\'image/*,application/pdf\'" ngf-model-invalid="errorFile" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-upload"></i> {{ \'BROWSE\' | translate}} </div> <a href ng-click="$mdl.mediaFile=null;$mdl.setUploadMedia(null)" ng-if="$mdl.mediaFile" class="btn btn-danger btn-with-icon" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-remove-circle"></i> {{ \'RESET\' | translate}} </a> </div> </div> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING"></b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/maintenance/semifgs/sfgCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/semifgs/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.isLoading"><i class="ion ion-checkmark"></i> <span translate="CREATE_SEMI_F.G."></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.semifgs.list" ng-disabled="vm.isLoading"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/semifgs/sfgImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b translate="IMPORT_SEMI_FINISHED_GOODS_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'1\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE..."></span></div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_SEMI_FINISHED_GOODS_UOMS_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'2\')" ng-disabled="vm.isExporting || vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_SEMI_FINISHED_GOODS_PAR_LEVEL_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'3\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_SFG_X_DEBTOR_X_SALES_CONFIG_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'5\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_SEMI_FINISHED_GOODS_LABEL_INFO_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'4\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend translate="IMPORT_GUIDELINES:"></legend><ol class="import"><li translate="YOU_NEED_TO_FOLLOW_THE_INSTRUCTION_BELOW_IF_YOU_ARE_NEW_TO_THE_RMS."></li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW_FILL_IT_UP_WITH_THE_DATA_FIRST_THEN_IMPORT_INTO_THE_RMS"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'1\', \'Semi F.G. Data Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_S.F.G._DATA_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'2\', \'Semi F.G. UOMs Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_S.F.G._UOMS_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'3\', \'Semi F.G. PAR Level Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_S.F.G._PAR_LEVEL_TEMPLATE"></span></a></li><li><span translate="LASTLY,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplateOther(\'Semi F.G. x Debtor x Sales Config Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_SFG_X_DEBTOR_X_SALES_CONFIG_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'4\', \'Semi F.G. Label Info Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_S.F.G._LABEL_INFO_TEMPLATE"></span></a></li><li translate="AFTER_IMPORTED_THE_DATA_ONCE,_YOU_CAN_FREELY_IMPORT_THE_DATA_WITHOUT_FOLLOWING_THE_SEQUENCE."></li></ol></fieldset><br>&nbsp;<br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong translate="FILE_UPLOADED_SUCCESSFULLY._CHOOSE_THE_OPTIONS_BELOW_AND_PROCEED_TO_IMPORT_THE_DATA."></strong></div><div><fieldset ng-if="vm.importType==\'1\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createSemiFg" ng-change="change()" ng-disabled="true" style="cursor:pointer"> <label><span translate="CREATE_NEW_SEMI_F.G."></span></label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateSemiFg" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_SEMI_F.G._IF_EXISTS"></span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'1\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'2\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createUom" ng-change="change()" style="cursor:pointer"> <label><span translate="ADD_NEW_UOM"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateUom" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_UOM_IF_EXISTS"></span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'2\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'3\'"><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'3\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'4\'"><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'4\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'5\'"><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importDataOther()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><br><br><fieldset><legend translate="ITEM_DATA_PREVIEW:"></legend></fieldset></div><div id="scroll-container" class="horizontal-scroll"><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'1\'"><thead><tr><th style="width:60px">#</th><th><b translate="SFG_CODE"></b></th><th><b translate="SFG_NAME"></b></th><th><b translate="SFG_DESCRIPTION"></b></th><th><b translate="CATEGORY"></b></th><th><b translate="SUB-CATEGORY"></b></th><th style="text-align:center !important"><b>{{ \'SHELF_LIFE_(DAY)\' | translate }}</b></th><th style="text-align:center !important"><b translate="YIELD_(%)"></b></th><th><b>{{ \'PACKAGING_INSTRUCTION\' | translate }}</b></th><th><b translate="IS_FOR_SALE"></b></th></tr><tr><th colspan="9"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.code || \'\' }}</td><td nowrap="nowrap">{{ row.description || \'\' }}</td><td nowrap="nowrap">{{ row.shortDescription || \'\' }}</td><td nowrap="nowrap">{{ row.category || \'-\' }}</td><td nowrap="nowrap">{{ row.subCategory || \'-\' }}</td><td align="center">{{ row.lifeTime || \'-\' | number:0 }}</td><td align="center">{{ row.yieldPercent || \'-\' | number:0 }}%</td><td nowrap="nowrap">{{ row.packagingInstruction || \'\' }}</td><td nowrap="nowrap">{{ row.isForSale || \'\' }}</td></tr><tr><td colspan="9" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="9"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'2\'"><thead><tr><th style="width:60px">#</th><th><b translate="SFG_CODE"></b></th><th><b translate="SFG_NAME"></b></th><th style="text-align:center !important"><b translate="BASE_UOM"></b></th><th style="text-align:center !important"><b translate="BASE_MULTIPLIER"></b></th><th style="text-align:center !important"><b>{{ \'INVENTORY_UOM\' | translate }}</b></th><th style="text-align:center !important"><b translate="INVENTORY_UOM_MULTIPLIER"></b></th><th style="text-align:center !important"><b sales="" uom=""></b></th><th style="text-align:center !important"><b translate="SALES_UOM_MULTIPLIER"></b></th><th style="text-align:center !important"><b translate="OTHER_UOM_#1"></b></th><th style="text-align:center !important"><b translate="OTHER_UOM_MULTIPLIER_#1"></b></th><th style="text-align:center !important"><b translate="OTHER_UOM_#2"></b></th><th style="text-align:center !important"><b translate="OTHER_UOM_MULTIPLIER_#2"></b></th><th style="text-align:center !important"><b translate="OTHER_UOM_#3"></b></th><th style="text-align:center !important"><b translate="OTHER_UOM_MULTIPLIER_#3"></b></th></tr><tr><th colspan="15"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.code || \'\' }}</td><td nowrap="nowrap">{{ row.description || \'\' }}</td><td align="center" style="color:#00f">{{ row.baseUom || \'\' }}</td><td align="center">{{ row.baseMultiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.invUom || \'\' }}</td><td align="center">{{ row.invUomMultiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.orderUom || \'\' }}</td><td align="center">{{ row.orderUomMultiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.otherUom1 || \'\' }}</td><td align="center">{{ row.otherUom1Multiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.otherUom2 || \'\' }}</td><td align="center">{{ row.otherUom2Multiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.otherUom3 || \'\' }}</td><td align="center">{{ row.otherUom3Multiplier || \'\' }}</td></tr><tr><td colspan="15" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="15"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'3\'"><thead><tr><th style="width:60px">#</th><th><b translate="SFG_CODE"></b></th><th><b translate="SFG_NAME"></b></th><th><b translate="BRANCH_CODE"></b></th><th style="text-align:right !important" nowrap="nowrap"><b>{{ \'PAR_LEVEL\' | translate }}</b></th><th><b translate="UOM"></b></th><th style="text-align:right !important" nowrap="nowrap"><b>{{ \'REORDER_LEVEL\' | translate }}</b></th><th><b translate="UOM"></b></th><th style="text-align:right !important" nowrap="nowrap"><b>{{ \'REORDER_QUANTITY\' | translate }}</b></th><th><b translate="UOM"></b></th></tr><tr><th colspan="10"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.code || \'\' }}</td><td nowrap="nowrap">{{ row.description || \'\' }}</td><td nowrap="nowrap">{{ row.branchCode || \'\' }}</td><td style="text-align:right;color:#00f">{{ row.parLevel || \'\' | number:0 }}</td><td>{{ row.uom1 || \'\' }}</td><td style="text-align:right;color:#00f">{{ row.reorderLevel || \'\' | number:0 }}</td><td>{{ row.uom2 || \'\' }}</td><td style="text-align:right;color:#00f">{{ row.reorderQty || \'\' | number:0 }}</td><td>{{ row.uom3 || \'\' }}</td></tr><tr><td colspan="10" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="10"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'4\'"><thead><tr><th style="width:60px">#</th><th><b translate="SFG_CODE"></b></th><th nowrap="nowrap"><b translate="SFG_NAME"></b></th><th nowrap="nowrap"><b translate="PRODUCT_NAME"></b></th><th><b translate="INGREDIENT_LINE_#1"></b></th><th><b translate="INGREDIENT_LINE_#2"></b></th><th><b translate="INGREDIENT_LINE_#3"></b></th><th><b translate="INGREDIENT_LINE_#4"></b></th><th><b translate="RETHERMALIZATION_INSTRUCTION_LINE_#1"></b></th><th><b translate="RETHERMALIZATION_INSTRUCTION_LINE_#2"></b></th><th><b translate="STORAGE"></b></th><th><b translate="HALAL_CERT_NUMBER_#1"></b></th><th><b translate="HALAL_CERT_NUMBER_#2"></b></th><th><b translate="CUSTOM_TEXT_#1"></b></th><th><b translate="CUSTOM_TEXT_#2"></b></th><th><b translate="CUSTOM_TEXT_#3"></b></th><th><b translate="CUSTOM_TEXT_#4"></b></th></tr><tr><th colspan="17"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.itemCode || \'\' }}</td><td nowrap="nowrap">{{ row.itemName || \'\' }}</td><td nowrap="nowrap">{{ row.productName || \'\' }}</td><td nowrap="nowrap">{{ row.ingredientLine1 || \'\' }}</td><td nowrap="nowrap">{{ row.ingredientLine2 || \'\' }}</td><td nowrap="nowrap">{{ row.ingredientLine3 || \'\' }}</td><td nowrap="nowrap">{{ row.ingredientLine4 || \'\' }}</td><td nowrap="nowrap">{{ row.rethermalize1 || \'\' }}</td><td nowrap="nowrap">{{ row.rethermalize2 || \'\' }}</td><td nowrap="nowrap">{{ row.storage || \'\' }}</td><td nowrap="nowrap">{{ row.halalCert1 || \'\' }}</td><td nowrap="nowrap">{{ row.halalCert2 || \'\' }}</td><td nowrap="nowrap">{{ row.customText1 || \'\' }}</td><td nowrap="nowrap">{{ row.customText2 || \'\' }}</td><td nowrap="nowrap">{{ row.customText3 || \'\' }}</td><td nowrap="nowrap">{{ row.customText4 || \'\' }}</td></tr><tr><td colspan="17" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="17"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'5\'"><thead><tr><th style="width:60px">#</th><th><b translate="SFG_CODE"></b></th><th nowrap="nowrap"><b translate="SFG_NAME"></b></th><th><b translate="DEBTOR_CODE"></b></th><th nowrap="nowrap"><b translate="DEBTOR_NAME"></b></th><th><b translate="SALES_U.O.M"></b></th><th style="text-align:right !important" nowrap="nowrap"><b translate="UNIT_PRICE"></b></th><th><b>{{ \'TAX_CODE\' | translate }}</b></th><th style="text-align:right !important" nowrap="nowrap"><b translate="TAX_PERCENT"></b></th><th style="text-align:right !important" nowrap="nowrap"><b translate="TAX_AMOUNT"></b></th></tr><tr><th colspan="10"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.itemCode || \'-\' }}</td><td nowrap="nowrap">{{ row.itemName || \'-\' }}</td><td>{{ row.debtorCode || \'-\' }}</td><td nowrap="nowrap">{{ row.debtorName || \'-\' }}</td><td>{{ row.uom || \'-\' }}</td><td style="text-align:right;color:#00f">{{ row.unitPrice | number:2 }}</td><td>{{ row.taxCode || \'-\' }}</td><td style="text-align:right;color:#00f">{{ row.taxPercentage | number:0 }}</td><td style="text-align:right;color:#00f">{{ row.taxAmount | number:2 }}</td></tr><tr><td colspan="10" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="7"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-6 col-lg-6"><em><small><i class="fa fa-info-circle"></i> <span translate="PROCESSING"></span>...</small></em><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><p translate="THE_DATA_IS_CURRENTLY_BEING_PROCESSED._IT_IS_SAFE_TO_LEAVE_THIS_PAGE_NOW."></p><p translate="YOU_WILL_RECEIVE_AN_EMAIL_NOTIFICATION_ABOUT_THE_IMPORT_RESULT_ONCE_THE_SERVER_HAS_FINISHED_PROCESSED_THE_DATA."></p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.semifgs.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a></div></form></div><div class="float-scroll-button"><span class="scroll-caption"><span translate="SCROLL"></span></span> <a href="" class="scroll-left" ng-if="vm.isSuccess && !vm.isImporting" ng-click="vm.scrollLeft()"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-arrow-left fa-stack-1x fa-inverse"></i></span></a> <a href="" class="scroll-right" ng-if="vm.isSuccess && !vm.isImporting" ng-click="vm.scrollRight()"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-arrow-right fa-stack-1x fa-inverse"></i></span></a></div>');
$templateCache.put('app/pages/maintenance/semifgs/sfgList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-hover" st-persist="SemiFinishedGoodsListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table=""><thead><tr><th colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.semifgs.create" rms-check-access="maintenance.semifgs" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="CREATE_NEW"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="maintenance.semifgs.import" rms-check-access="maintenance.semifgs" rms-check-access-perm-type="CREATE"><i class="fa fa-upload"></i><span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:140px">{{ \'IMAGE\' | translate}}</th><th st-sort="code">{{ \'CODE\' | translate }}</th><th st-sort="description">{{ \'SFG_NAME\' | translate }}</th><th st-sort="category">{{ \'CATEGORY\' | translate }}</th><th st-sort="subCategory">{{ \'SUB-CATEGORY\' | translate }}</th><th st-sort="active">{{ \'STATUS\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th></th><th class="form-inline" colspan="2"><input st-search="code" class="form-control input input-sm" style="width:300px"></th><th class="form-inline"><input st-search="category" class="form-control input input-sm"></th><th class="form-inline"><input st-search="subCategory" class="form-control input input-sm"></th><th class="form-inline"><select st-search="active" class="form-control input input-sm"><option value="">{{ \'ALL\' | translate }}</option><option value="1">{{ \'ACTIVE\' | translate | uppercase }}</option><option value="0">{{ \'INACTIVE\' | translate | uppercase }}</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-show="vm.data.length<=0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate}}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td><img src="{{((item.imageLocation==null || item.imageLocation==\'\') ? \'assets/img/empty_placeholder.png\' : vm.blobUrl + item.imageLocation)}}" style="width:96px;height:64px;margin-top:10px;margin-bottom:10px;border:2px solid #ccc"></td><td>{{item.code | uppercase}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.description | uppercase}}</td><td>{{item.category | uppercase}}</td><td>{{item.subCategory | uppercase}}</td><td><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.semifgs.update({id:item.id})" ng-disabled="vm.isLoading" rms-check-access="maintenance.semifgs" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Product" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteItem(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this item?" ng-disabled="vm.isLoading" rms-check-access="maintenance.semifgs" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/semifgs/sfgUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/semifgs/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.semifgs.list" style="margin-right:20px" ng-disabled="vm.isLoading"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.isLoading"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.semifgs.list" ng-disabled="vm.isLoading"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/products/_form.html','<style>\n\t.modal-lg {\n\t\twidth: 1400px !important;\n\t}\n</style><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-md-3 col-lg-3"><div class="row"><img ngf-src="picFile || vm.product.imageLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div><br><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-hide="vm.lockUploadButton" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> {{ \'UPLOAD_PICTURE\' | translate }}</div><a href="" class="btn btn-default btn-with-icon" ng-click="picFile=null;vm.clearImage()" ng-hide="vm.lockUploadButton" ng-show="(picFile || vm.product.imageLocation.indexOf(\'empty_placeholder\')<0)"><i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }}</a></div><div class="row" ng-show="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div><div class="col-md-4 col-lg-4"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ProductCode.$invalid && (vm.dataForm.ProductCode.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'PRODUCT_CODE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ProductCode" ng-model="vm.product.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ProductCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ProductName.$invalid && (vm.dataForm.ProductName.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'PRODUCT_NAME\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ProductName" ng-model="vm.product.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ProductName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b>{{ \'PRODUCT_DESCRIPTION\' | translate }}</b></label> <input type="text" class="form-control" ng-model="vm.product.description"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="CATEGORY"></b></label> <input type="text" class="form-control" name="Category" ng-model="vm.product.category"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="SUB_CATEGORY"></b></label> <input type="text" class="form-control" ng-model="vm.product.subCategory"></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b>{{ \'PRODUCT_DIMENSION\' | translate }}</b></label> <input type="text" class="form-control" ng-model="vm.product.dimension"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LifeTime.$invalid && (vm.dataForm.LifeTime.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SHELF_LIFE_(DAY)\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="LifeTime" ng-model="vm.product.lifeTime" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LifeTime.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LifeTime.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.JobBatchDailyMaxQuantity.$invalid && (vm.dataForm.JobBatchDailyMaxQuantity.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'MAX_PRODUCTION_BATCH_PER_DAY\' | translate }}</b></label> <input type="number" class="form-control" name="JobBatchDailyMaxQuantity" ng-model="vm.product.jobBatchDailyMaxQuantity"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.JobBatchDailyMaxQuantity.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'STATUS\' | translate }}</b></label><div><toggle ng-model="vm.product.active" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'FOR_SALE\' | translate }}</b></label><div><toggle ng-model="vm.product.isForSale" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-12 col-lg-12"><div style="padding:15px;background:#b7ffb7;margin-bottom:15px"><div class="form-group" style="margin-bottom:0px"><label><b>{{ \'ASSOCIATED_RECIPE_(FROM_RECIPE_CARD)\' | translate }}</b></label><p><small><i class="fa fa-info-circle"></i> <span translate="THIS_IS_REQUIRED_TO_ASSOCIATE_THE_PRODUCT_WITH_THE_RAW_INGREDIENTS_NEEDED_FOR_PRODUCTION"></span></small></p><div class="row"><div class="col-lg-3" style="padding-right:0px"><div class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-search"></i></span> <input class="form-control" ng-model="vm.recipeSearch" ng-disabled="vm.loadingRecipe" ng-model-options="{ debounce: 1500 }" ng-change="vm.loadRecipeList(vm.recipeSearch)"></div></div><div class="col-lg-9"><select class="form-control" ng-change="vm.onSelectedRecipeChanged()" ng-options="u as (u.name | uppercase) for u in vm.recipeList | filter: vm.recipeSearch" ng-model="vm.selectedRecipe"><option value="">{{(vm.loadingRecipe ? (\'LOADING...\' | translate) : (vm.recipeList.length==0 ? ("&lt;&lt; " + (\'ENTER_A_KEYWORD_TO_SEARCH\' | translate)) : "-- " + (\'SELECT_A_RECIPE\' | translate) + " --"))}}</option></select><button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" title="Clear Selection" style="margin-top:5px" ng-if="vm.selectedRecipe!=null" ng-click="vm.clearSelectedRecipe()"><i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }}</button></div></div></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div style="padding:15px;background:#fdffde;margin-bottom:15px"><div class="form-group"><label><b>{{ \'PACKAGING_INSTRUCTION\' | translate }}</b></label><p><small><i class="fa fa-info-circle"></i> <span translate="THIS_INSTRUCTION_WILL_APPEAR_IN_THE_JOB_SHEET_AND_JOB_DASHBOARD_ONLY"></span></small></p><textarea class="form-control" rows="5" ng-model="vm.product.packagingInstruction" style="background:#fff">\n\t\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="col-lg-12" style="padding:15px;background:#f9f9f9"><div class="row"><div class="col-lg-12" style="padding-bottom:5px"><b><u>{{ \'CHECKLISTS:\' | translate }}</u></b></div></div><div class="row"><div class="col-lg-12" style="font-size:90%;margin-bottom:5px"><i class="fa fa-check text-success" ng-if="vm.product.hasBaseUom"></i> <i class="fa fa-times text-danger" ng-if="!vm.product.hasBaseUom"></i> &nbsp;<span translate="HAS_BASE_UOM"></span> <span ng-if="vm.product.baseUom">- (<b>{{vm.product.baseUom}}</b>)</span></div></div><div class="row"><div class="col-lg-12" style="font-size:90%;margin-bottom:5px"><i class="fa fa-check text-success" ng-if="vm.product.hasOrderUom"></i> <i class="fa fa-times text-danger" ng-if="!vm.product.hasOrderUom"></i> &nbsp;<span translate="HAS_SALES_UOM"></span> <span ng-if="vm.product.orderUom">- (<b>{{vm.product.orderUom}}</b>)</span></div></div><div class="row"><div class="col-lg-12" style="font-size:90%;margin-bottom:5px"><i class="fa fa-check text-success" ng-if="vm.product.hasInventoryUom"></i> <i class="fa fa-times text-danger" ng-if="!vm.product.hasInventoryUom"></i> &nbsp;<span translate="HAS_INVENTORY_UOM"></span> <span ng-if="vm.product.inventoryUom">- (<b>{{vm.product.inventoryUom}}</b>)</span></div></div><div class="row"><div class="col-lg-12" style="font-size:90%;margin-bottom:5px"><i class="fa fa-check text-success" ng-if="vm.product.hasRecipe"></i> <i class="fa fa-times text-danger" ng-if="!vm.product.hasRecipe"></i> &nbsp;<span translate="ASSOCIATED_WITH_RECIPE"></span></div></div><div class="row"><div class="col-lg-12" style="font-size:90%"><i class="fa fa-check text-success" ng-if="vm.product.hasRecipeUom"></i> <i class="fa fa-times text-danger" ng-if="!vm.product.hasRecipeUom"></i> &nbsp;<span translate="RECIPES_UOM_INCLUDED"></span> <span ng-if="vm.product.recipeUom">- (<b>{{vm.product.recipeUom}}</b>)</span></div></div><div class="row"><div class="col-lg-12" style="margin-top:15px">{{ \'STATUS\' | translate }}: &nbsp; <b class="text-success" ng-if="vm.product.hasRecipe && vm.product.hasBaseUom && vm.product.hasInventoryUom && vm.product.hasOrderUom && vm.product.hasRecipeUom"><span translate="READY_FOR_SALES"></span> &nbsp;<i class="fa fa-check"></i></b> <b class="text-danger" ng-if="!(vm.product.hasRecipe && vm.product.hasBaseUom && vm.product.hasInventoryUom && vm.product.hasOrderUom && vm.product.hasRecipeUom)"><span translate="CONFIGURATION_INCOMPLETE"></span> &nbsp;<i class="fa fa-warning"></i></b></div></div></div></div></div></div></div><div class="row"><p>&nbsp;</p><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'U.O.M.\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="ADD_THE_U.O.M._FOR_THE_PRODUCT"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddUomModal()"><i class="ion-plus-round"></i><span translate="ADD_THE_U.O.M._FOR_THE_PRODUCT"></span></a><br><br></p><div class="row"><div class="col-md-9 col-lg-9"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="U.O.M._NAME"></b></th><th><b translate="BASE_MUTIPLIER"></b></th><th style="width:150px"><b>{{ \'BASE\' | translate }}</b><br><small>{{ \'UOM\' | translate }}</small></th><th style="width:150px"><b>{{ \'INVENTORY\' | translate }}</b><br><small>{{ \'UOM\' | translate }}</small></th><th style="width:150px"><b>{{ \'SALES\' | translate }}</b><br><small>{{ \'UOM\' | translate }}</small></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.product.productUnitOfMeasurements"><td>{{$index+1}}</td><td>{{ ntn.unitOfMeasurement.name || \'\' }}</td><td>X {{ ntn.baseMultiplier }}</td><td><i class="fa fa-check" ng-show="ntn.isBase" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isBase" style="color:#f00"></i></td><td><i class="fa fa-check" ng-show="ntn.isInventory" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isInventory" style="color:#f00"></i></td><td><i class="fa fa-check" ng-show="ntn.isOrder" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isOrder" style="color:#f00"></i></td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditUomModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeUom($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="8" align="center" ng-if="vm.product.productUnitOfMeasurements==null || vm.product.productUnitOfMeasurements.length==0"><br><span translate="U.O.M._LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CWM\' | translate }}"><p><i class="fa fa-info-circle"></i> <span>{{ \'TO_CONFIG_CWM\' | translate }}</span><br><br></p><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>{{ \'IS_CWM\' | translate }} ?</b></label><div><toggle ng-model="vm.product.isCWM" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-2 col-lg-2" ng-if="vm.product.isCWM && vm.integrationMode!=-1"><div class="form-group"><label><b>{{ \'SYNC_PARALLEL_UOM\' | translate }} ?</b></label><div><toggle ng-model="vm.product.syncCwmParallelUom" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.product.isCWM"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CWMParallelMultiplier.$invalid && (vm.dataForm.CWMTolerance.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'PARALLEL_MULTIPLIER\' | translate }}</b> <i class="fa fa-asterisk req" ng-if="vm.product.isCWM"></i></label> <input type="number" class="form-control" name="CWMParallelMultiplier" min="0.01" ng-model="vm.product.cwm_ParallelMultiplier" ng-required="vm.product.isCWM"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMParallelMultiplier.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMParallelMultiplier.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMParallelMultiplier.$error.min">* {{ \'MINIMUM_VALUE_IS_0\' | translate }}.01</span></div></div></div><div class="row" ng-if="vm.product.isCWM"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ParallelUom1.$invalid && (vm.dataForm.ParallelUom1.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'PARALLEL_UOM\' | translate }} #1</b> <i class="fa fa-asterisk req" ng-if="vm.product.isCWM"></i></label><select class="form-control" name="ParallelUom1" style="color:#333" ng-options="u as u.unitOfMeasurement.name for u in vm.product.productUnitOfMeasurements" ng-change="vm.selectedParallelUom1Changed()" ng-model="vm.selectedParallelUom1" ng-required="vm.product.isCWM"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ParallelUom1.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.product.isCWM"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ParallelUom2.$invalid && (vm.dataForm.ParallelUom2.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'PARALLEL_UOM\' | translate }} #2</b> <i class="fa fa-asterisk req" ng-if="vm.product.isCWM"></i></label><select class="form-control" name="ParallelUom2" style="color:#333" ng-options="u as u.unitOfMeasurement.name for u in vm.product.productUnitOfMeasurements" ng-change="vm.selectedParallelUom2Changed()" ng-model="vm.selectedParallelUom2" ng-required="vm.product.isCWM"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ParallelUom2.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.product.isCWM"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CWMTolerance.$invalid && (vm.dataForm.CWMTolerance.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'TOLERANCE_PERCENTAGE\' | translate }} (%)</b> <i class="fa fa-asterisk req" ng-if="vm.product.isCWM"></i></label> <input type="number" class="form-control" name="CWMTolerance" min="0" ng-model="vm.product.cwm_TolerencePercent" ng-required="vm.product.isCWM"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMTolerance.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMTolerance.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CWMTolerance.$error.min">* {{ \'MINIMUM_VALUE_IS_0\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'INVENTORY\' | translate }}" ng-if="vm.isStarterMode!=null && !vm.isStarterMode && vm.mode==2"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_INVENTORY_CONFIGURATION_FOR_THE_STOCK_LEVEL."></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddParModal()"><i class="ion-plus-round"></i><span translate="ADD_NEW"></span></a><br><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped" style="border:1px solid #ccc;font-size:90%" st-table="vm.product.productBranchConfigs"><thead><tr><th><b translate="BRANCH_NAME"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="MON_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="TUE_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="WED_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="THU_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="FRI_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="SAT_SHORT"></b></th><th class="hide-after" style="text-align:center;width:100px"><b translate="SUN_SHORT"></b></th><th class="hide-after" style="text-align:center" colspan="2"><b>{{ \'PAR_LEVEL\' | translate }}</b></th><th class="hide-after" style="text-align:center;width:100px" colspan="2"><b>{{ \'REORDER_LEVEL\' | translate }}</b></th><th class="hide-after" style="text-align:center;width:100px" colspan="2"><b>{{ \'REORDER_QUANTITY\' | translate }}</b></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="config in vm.product.productBranchConfigs"><td style="color:#00f" nowrap="nowrap">{{ config.branch.name }}</td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.mon"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.tue"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.wed"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.thu"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.fri"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.sat"></i></td><td style="text-align:center" nowrap="nowrap"><i class="fa fa-check" ng-show="config.sun"></i></td><td style="width:100px;text-align:right" nowrap="nowrap"><b>{{ config.parLevel }}</b></td><td>{{ vm.uomInventory }}</td><td style="width:100px;text-align:right" nowrap="nowrap"><b>{{ config.reOrderLevel }}</b></td><td>{{ vm.uomInventory }}</td><td style="width:100px;text-align:right" nowrap="nowrap"><b>{{ config.reOrderQuantity }}</b></td><td>{{ vm.uomOrder }}</td><td></td><td style="padding-left:0px;padding-right:0px"><a class="btn btn-info btn-sm" ng-click="vm.showEditParModal($index)"><i class="fa fa-pencil"></i></a></td><td style="padding-left:0px;padding-right:0px"><a class="btn btn-danger btn-sm" confirmed-click="vm.removePar($index)" ng-confirm-click="Confirm remove this PAR entry?"><i class="fa fa-trash-o"></i></a></td></tr><tr><td colspan="15" align="center" ng-if="vm.product.productBranchConfigs==null || vm.product.productBranchConfigs.length==0"><br><span ng-if="vm.mode==2"><span translate="PAR_LEVEL_LIST_IS_EMPTY."></span></span><br><h2 ng-if="vm.mode==1" style="color:#f00"><center translate="PLEASE_SAVE_FIRST_BEFORE_SETTING_THE_PAR_LEVEL."></center></h2><br></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Food Portioning" ng-show="vm.useFoodPortioning"><p translate="THIS_IS_THE_SETTING_FOR_FOOD_PORTIONING._APPLICABLE_FOR_SALES_ORDER_&_INVENTORY_WITHDRAWAL_ESTIMATION."></p><p><br></p><div class="row"><div class="col-md-1 col-lg-1" style="padding-right:0px"><span class="form-control" style="border:none;text-align:right"><b translate="ONE"></b></span></div><div class="col-md-1 col-lg-1" style="padding-left:0px;padding-right:0px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FoodPortionUom.$invalid && (vm.dataForm.FoodPortionUom.$dirty || vm.dataForm.$submitted)}"><select name="FoodPortionUom" class="form-control" style="background:#fffeb7" ng-model="vm.product.foodPortion_UnitOfMeasurementId" ng-options="i.unitOfMeasurementId as i.unitOfMeasurement.name for i in vm.product.productUnitOfMeasurements"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FoodPortionUom.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-1 col-lg-1" style="padding-left:0px;padding-right:0px"><span class="form-control" style="border:none;text-align:center"><b translate="FOR"></b></span></div><div class="col-md-1 col-lg-1" style="padding-left:0px;padding-right:0px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FoodPortionPax.$invalid && (vm.dataForm.FoodPortionPax.$dirty || vm.dataForm.$submitted)}"><input type="text" name="FoodPortionPax" class="form-control" style="background:#fffeb7;text-align:right" ng-model="vm.product.foodPortion_NoOfPax" ng-required="vm.useFoodPortioning"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FoodPortionPax.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-1 col-lg-1" style="padding-left:0px;padding-right:0px"><span class="form-control" style="border:none"><b translate="PAX"></b></span></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" title="Clear Selection" style="margin-bottom:5px" ng-if="vm.productList.selected!=null" ng-click="vm.clearSelectedProduct()"><i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }}</button> <label><b translate="SMALLER_PACKAGING_LINKED_PRODUCT"></b> <em translate="(FOR_INVENTORY_WITHDRAWAL_OPTIMIZATION)"></em></label><ui-select ng-model="vm.productList.selected" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" on-select="vm.selectProduct($item)"><ui-select-match placeholder="-- {{ \'SELECT_A_PRODUCT\' | translate }} --"><span>{{ $select.selected.name }}</span></ui-select-match><ui-select-choices repeat="p in vm.productList | filter: $select.search"><span ng-bind-html="p.name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CERTIFICATES\' | translate }}" ng-if="vm.mode==2"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_FOOD_SAFETY_CERTIFICATES_FOR_THIS_FINISHED_GOOD"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddCertModal()"><i class="ion-plus-round"></i> {{ \'ADD_NEW_CERTIFICATE\' | translate }}</a><br><br></p><div class="row" ng-show="vm.mode==2"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="font-size:85%;border:1px solid #ccc" st-pipe="vm.refreshItemCerts" st-table="vm.product.productCertificates" refresh-table=""><thead><tr><th style="width:60px">#</th><th><b>{{ \'CERT_TYPE\' | translate }}</b></th><th><b>{{ \'CERT_REF_NO\' | translate }}</b></th><th><b>{{ \'ISSUE_DATE\' | translate }}</b></th><th><b>{{ \'EXPIRY_DATE\' | translate }}</b></th><th><b>{{ \'REMARKS\' | translate }}</b></th><th style="width:100px"><b>{{ \'ATTACHMENT\' | translate }}</b></th><th style="width:65px"></th><th style="width:65px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.product.productCertificates"><td>{{ $index+1 }}</td><td>{{ ntn.certType || \'\' }}</td><td>{{ ntn.certRefNo || \'\' }}</td><td>{{ ntn.issueDate | date:\'dd/MM/yyyy\' }}</td><td>{{ ntn.expiryDate | date:\'dd/MM/yyyy\' }}</td><td>{{ ntn.remarks || \'-\'}}</td><td><a class="btn btn-default editable-table-button btn-with-icon btn-xs" href="{{vm.blobUrl}}{{ntn.certFilename}}" target="_blank" ng-if="ntn.certFilename!=null && ntn.certFilename!=\'\'"><i class="fa fa-file-text"></i> {{ \'VIEW\' | translate }}</a> <span ng-if="ntn.certFilename==null || ntn.certFilename==\'\'">-</span></td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditCertModal(ntn.id)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeCert(ntn.id)" ng-confirm-click="Confirm remove this Certificate?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="9" align="center" ng-show="vm.product.productCertificates.length==0"><br><span translate="CERTIFICATE_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center translate="PLEASE_SAVE_THE_FG_FIRST_BEFORE_ADDING_CERTIFICATE."></center></h2></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'SALES_CONFIG\' | translate }}" ng-if="vm.mode==2"><p><i class="fa fa-info-circle"></i> {{ \'MANAGE_SALES_PRICE_FOR_INDIVIDUAL_CUSTOMER\' | translate }} <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-if="vm.mode==2" ng-click="vm.showAddSalesConfig()"><i class="ion-plus-round"></i> {{ \'ADD_NEW_SALES_CONFIG\' | translate }}</a><br><br></p><div class="row" ng-show="vm.mode==2"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="font-size:85%;border:1px solid #ccc" st-pipe="vm.refreshItemCerts" st-table="vm.salesConfigList" refresh-table=""><thead><tr><th style="width:60px">#</th><th><b>{{ \'CUSTOMER_CODE\' | translate }}</b></th><th><b>{{ \'CUSTOMER_NAME\' | translate }}</b></th><th style="text-align:right" class="hide-after"><b>{{ \'UNIT_PRICE\' | translate }} ({{vm.currencyCode}})</b></th><th style="width:65px"></th><th><b>{{ \'TAX_CODE\' | translate }}</b></th><th style="text-align:right" class="hide-after"><b>{{ \'TAX_PERCENT\' | translate }} (%)</b></th><th style="text-align:right" class="hide-after"><b>{{ \'TAX_AMOUNT\' | translate }} ({{vm.currencyCode}})</b></th><th style="width:65px"></th><th style="width:65px"></th><th style="width:65px"></th></tr></thead><tbody><tr ng-repeat="item in vm.salesConfigList"><td>{{ $index+1 }})</td><td style="width:200px">{{ item.debtorCode || \'-\' }}</td><td>{{ item.debtorName || \'-\' }}</td><td style="text-align:right">{{ item.unitPrice | number:3}} / {{item.uomName}}</td><td></td><td>{{ item.taxCode || \'-\' }}</td><td style="text-align:right">{{ item.taxPercentage | number:2}}%</td><td style="text-align:right">{{ item.taxAmount | number:3}}</td><td></td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditSalesConfig(item.id)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.deleteSalesConfig(item.id)" ng-confirm-click="Confirm remove this Sales Config?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="11" align="center" ng-show="vm.salesConfigList.length==0"><br><span>The list is empty.</span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center>Please save the Finished Good first before adding Sales Config.</center></h2></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'LABEL_DETAILS\' | translate }}"><p translate="PLEASE_ENTER_THE_RELEVANT_INFORMATION_FOR_THE_LABEL_PRINTING."></p><p><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="PRODUCT_NAME"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.product_name"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="INGREDIENT_LINE_#1"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.ingredient_line1"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="INGREDIENT_LINE_#2"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.ingredient_line2"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="INGREDIENT_LINE_#3"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.ingredient_line3"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="INGREDIENT_LINE_#4"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.ingredient_line4"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="RETHERMALIZATION_INSTRUCTION_LINE_#1"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.rethermalize_1"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="RETHERMALIZATION_INSTRUCTION_LINE_#2"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.rethermalize_2"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="STORAGE"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.storage"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="HALAL_CERT_NUMBER_#1"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.halal_cert_1"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="HALAL_CERT_NUMBER_#2"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.halal_cert_2"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="CUSTOM_TEXT_#1"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.custom_text_01"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="CUSTOM_TEXT_#2"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.custom_text_02"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="CUSTOM_TEXT_#3"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.custom_text_03"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="CUSTOM_TEXT_#4"></label> <input type="text" class="form-control" ng-model="vm.product.templateContent.custom_text_04"></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Label (Nutrition List)" ng-hide="true"><p translate="PLEASE_ENTER_THE_RELEVANT_NUTRITION_LIST_FOR_THE_LABEL_PRINTING."></p><p><br></p><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group"><div ng-form="" editable-form="" name="vm.tableForm" class="form-inline"><table class="table table-bordered table-hover table-striped"><tr><td style="width:5%">#</td><td style="width:40%"><span translate="NUTRITION_DESCRIPTION"></span></td><td style="width:20%" align="center">Quantity / Value</td><td style="width:20%" align="center"><span translate="UOM"></span></td><td style="width:15%"></td></tr><tr ng-repeat="ntn in vm.product.templateContent.nutritions" class="editable-row"><td>{{$index+1}}</td><td><div editable-text="ntn.name" e-name="name" e-form="vm.tableForm" e-style="width:300px">{{ ntn.name || \'\' }}</div></td><td><div editable-text="ntn.quantity" e-name="quantity" e-form="vm.tableForm">{{ ntn.quantity || \'\' }}</div></td><td><div editable-text="ntn.uom" e-name="uom" e-form="vm.tableForm">{{ ntn.uom || \'\' }}</div></td><td><a class="btn btn-danger editable-table-button btn-xs" ng-click="vm.removeNutrition($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr ng-show="vm.product.templateContent.nutritions.length==0"><td colspan="5" align="center"><span translate="NO_NUTRITION_ADDED."></span></td></tr><tr><td colspan="5"><a class="btn btn-primary btn-xs" ng-click="vm.addNutrition()"><i class="fa fa-plus"></i> <span translate="ADD_MORE"></span></a></td></tr></table></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="AutoCount Fields" ng-if="vm.hasAutoCountFields"><p><small><i class="fa fa-info-circle"></i> <span translate="THESE_INFORMATION_MUST_BE_FILLED_IN_FOR_AUTOCOUNT_INTEGRATION."></span></small></p><br><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AcItemType.$invalid && (vm.dataForm.AcItemType.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select name="AcItemType" class="form-control" ng-change="vm.selectedItemTypeChanged()" ng-model="vm.selectedItemType" ng-options="i as (\'[\'+ i.itemType1 + \'] \' + (i.description || \'-\')) for i in vm.autoCount_itemTypes" ng-required="vm.hasAutoCountFields"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AcItemType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AcItemGroup.$invalid && (vm.dataForm.AcItemGroup.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_GROUP"></b> <i class="fa fa-asterisk req"></i></label><select name="AcItemGroup" class="form-control" ng-change="vm.selectedItemGroupChanged()" ng-model="vm.selectedItemGroup" ng-options="i as (\'[\'+ i.itemGroup1 + \'] \' + (i.description || \'-\')) for i in vm.autoCount_itemGroups" ng-required="vm.hasAutoCountFields"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AcItemGroup.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AcStockControl.$invalid && (vm.dataForm.AcStockControl.$dirty || vm.dataForm.$submitted)}"><label><b>Is Stock Control</b> <i class="fa fa-asterisk req"></i></label><select name="AcStockControl" class="form-control" ng-change="vm.selectedStockControlChanged()" ng-model="vm.selectedStockControl" ng-required="vm.hasAutoCountFields"><option value="1">{{ \'YES\' | translate }}</option><option value="0">{{ \'NO\' | translate }}</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AcStockControl.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group"><label><b>Classification Code</b></label> <input type="text" class="form-control" ng-model="vm.product.irbM_ClassificationCode"></div></div></div></uib-tab><uib-tab heading="SQL Fields" ng-if="vm.hasSQLFields"><p><small><i class="fa fa-info-circle"></i> <span translate="THESE_INFORMATION_MUST_BE_FILLED_IN_FOR_SQL_INTEGRATION."></span></small></p><br><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLItemGroup.$invalid && (vm.dataForm.SQLItemGroup.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_GROUP"></b> <i class="fa fa-asterisk req"></i></label><select name="SQLItemGroup" class="form-control" ng-change="vm.selectedSQLItemGroupChanged()" ng-model="vm.selectedSQLItemGroup" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sql_itemGroups" ng-required="vm.hasSQLFields"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLItemGroup.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLStockControl.$invalid && (vm.dataForm.SQLStockControl.$dirty || vm.dataForm.$submitted)}"><label><b>Is Stock Control</b> <i class="fa fa-asterisk req"></i></label><select name="SQLStockControl" class="form-control" ng-change="vm.selectedSQLStockControlChanged()" ng-model="vm.selectedSQLStockControl" ng-required="vm.hasSQLFields"><option value="1">{{ \'YES\' | translate }}</option><option value="0">{{ \'NO\' | translate }}</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLStockControl.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group"><label><b>Classification Code</b></label> <input type="text" class="form-control" ng-model="vm.product.irbM_ClassificationCode"></div></div></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.product.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_FINISHED_GOOD."></span><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br><span translate="THERE_IS_NO_CHANGES_YET"></span>.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="uomModal.html"><form name="$mdl.uomForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} {{ \'U.O.M\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.uomForm.UOM.$invalid && $mdl.uomForm.$submitted}"> <label><b>{{ \'UNIT_OF_MEASUREMENT\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <small><br />&nbsp;</small> <select name="UOM" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.onSelectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.uomForm.UOM.$error.required && $mdl.uomForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> <div class="col-md-4 col-lg-4" style="padding-right:0px"> <div class="form-group" ng-class="{\'has-error\': $mdl.uomForm.BaseMultiplier.$invalid && $mdl.uomForm.$submitted}"> <label><b>{{ \'BASE_MULTIPLIER\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i> <br /><small><em translate="EQUIVALENT_TO_______BASE_UOM"></em></small> </label> <input type="number" name="BaseMultiplier" class="form-control" style="background:#fffeed" ng-model="$mdl.item.baseMultiplier" min="1" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.uomForm.BaseMultiplier.$error.required && $mdl.uomForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.uomForm.BaseMultiplier.$error.number && $mdl.uomForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.uomForm.BaseMultiplier.$error.min && $mdl.uomForm.$submitted">* <span translate="MINIMUM_VALUE_IS_1"></span></p> </div> </div> <div class="col-md-2 col-lg-2"> <div class="form-group"> <label><br /></label> <small><br />&nbsp;</small> <b class="form-control">{{$mdl.baseUom}}</b> </div> </div> </div> <div class="form-group"> <div class="row"> <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"> <div class="checkbox checkbox-primary"> <input type="checkbox" ng-model="$mdl.item.isBase" ng-change="change()" /> <label><span><b translate="BASE_UOM"></b></span></label> <p style="padding-left:20px;line-height:10px"><small><i class="fa fa-info-circle"></i> <em translate="THE_BASE_UNIT_OF_THIS_PRODUCT"></em></small></p> </div> </div> <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" ng-hide="true"> <div class="checkbox checkbox-primary"> <input type="checkbox" ng-model="$mdl.item.isDefault" ng-change="change()" /> <label><span><b>{{ \'DEFAULT_UOM\' | translate }}</b></span></label> <p style="padding-left:20px;line-height:10px"><small><i class="fa fa-info-circle"></i> <em translate="THE_DEFAULT_UNIT"></em></small></p> </div> </div> </div> <div class="row"> <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"> <div class="checkbox checkbox-primary"> <input type="checkbox" ng-model="$mdl.item.isInventory" ng-change="change()" /> <label><span><b>{{ \'INVENTORY_UOM\' | translate }}</b></span></label> <p style="padding-left:20px;line-height:10px"><small><i class="fa fa-info-circle"></i> <em translate="THE_UNIT_USED_FOR_STOCK_INVENTORY"></em></small></p> </div> </div> <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"> <div class="checkbox checkbox-primary"> <input type="checkbox" ng-model="$mdl.item.isOrder" ng-change="change()" /> <label><span><b translate="SALES_UOM"></b></span></label> <p style="padding-left:20px;line-height:10px"><small><i class="fa fa-info-circle"></i> <em translate="THE_UNIT_USED_FOR__SALES_ORDER"></em></small></p> </div> </div> </div> </div> <div class="form-group"> {{ \'REMARKS\' | translate }} <textarea class="form-control" style="background:#fffeed" ng-model="$mdl.item.remarks" /> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="parModal.html"><form name="$mdl.parForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} {{ \'PAR_LEVEL\' | translate | uppercase}}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.parForm.Branch.$invalid && $mdl.parForm.$submitted}"> <label><b>{{ \'REMARKS\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <small><br />&nbsp;</small> <select name="Branch" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.branchList" ng-model="$mdl.selectedBranch" ng-change="$mdl.selectedBranchChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.Branch.$error.required && $mdl.parForm.$submitted">* {{\'REQUIRED\'|translate}} </p> </div> </div> </div> <hr /> <div class="row"> <div class="col-lg-12"> <table class="table" style="margin-bottom:0px"> <tr> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Monday" ng-model="$mdl.item.mon" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'MONDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Tuesday" ng-model="$mdl.item.tue" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()"/> <label style="margin-left:20px"><span><b>{{ \'TUESDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Wednesday" ng-model="$mdl.item.wed" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'WEDNESDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Thursday" ng-model="$mdl.item.thu" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'THURSDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Friday" ng-model="$mdl.item.fri" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'FRIDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Saturday" ng-model="$mdl.item.sat" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'SATURDAY\' | translate }}</b></span></label> </td> <td style="width:14%;line-height:30px;border-top:0px"> <input type="checkbox" name="Sunday" ng-model="$mdl.item.sun" style="float:left;background:#fffff4;width:25px;height:25px" ng-required="$mdl.isValidDays()" /> <label style="margin-left:20px"><span><b>{{ \'SUNDAY\' | translate }}</b></span></label> </td> </tr> </table> </div> </div> <div ng-if="$mdl.parForm.$submitted && $mdl.isValidDays()"> <br /> <span style="color:#f00">* {{\'YOU_MUST_SELECT_AT_LEAST_ONE_DAY\' | translate}}</span> </div> <hr /> <div class="row"> <div class="col-md-4 col-lg-4"> <div class="row"> <div class="col-lg-12"> <label><b>{{ \'PAR_LEVEL\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> </div> </div> <div class="row"> <div class="col-lg-7"> <div class="form-group" ng-class="{\'has-error\': $mdl.parForm.ParLevel.$invalid && $mdl.parForm.$submitted}"> <input type="number" name="ParLevel" class="form-control" style="background:#fffeed" ng-model="$mdl.item.parLevel" min="0" ng-min="0" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ParLevel.$error.required && $mdl.parForm.$submitted">* {{\'REQUIRED\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ParLevel.$error.number && $mdl.parForm.$submitted">* {{\'KEY_IN_NUMBERS_ONLY\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ParLevel.$error.min && $mdl.parForm.$submitted">* {{\'MINIMUM_VALUE_IS_0\'|translate}} </p> </div> </div> <div class="col-lg-5" style="padding-left:0px;"> <div class="form-group" style="line-height:34px;color:#00f"> <b>{{$mdl.uomInventory}}</b> </div> </div> </div> </div> <div class="col-md-4 col-lg-4"> <div class="row"> <div class="col-lg-12"> <label><b>{{ \'REORDER_LEVEL\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> </div> </div> <div class="row"> <div class="col-lg-7"> <div class="form-group" ng-class="{\'has-error\': $mdl.parForm.ReorderLevel.$invalid && $mdl.parForm.$submitted}"> <input type="number" name="ReorderLevel" class="form-control" style="background:#fffeed" ng-model="$mdl.item.reOrderLevel" min="0" ng-min="0" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderLevel.$error.required && $mdl.parForm.$submitted">* {{\'REQUIRED\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderLevel.$error.number && $mdl.parForm.$submitted">* {{\'KEY_IN_NUMBERS_ONLY\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderLevel.$error.min && $mdl.parForm.$submitted">* {{\'MINIMUM_VALUE_IS_0\'|translate}} </p> </div> </div> <div class="col-lg-5" style="padding-left:0px;"> <div class="form-group" style="line-height:34px;color:#00f"> <b>{{$mdl.uomInventory}}</b> </div> </div> </div> </div> <div class="col-md-4 col-lg-4"> <div class="row"> <div class="col-lg-12"> <label><b>{{ \'REORDER_QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> </div> </div> <div class="row"> <div class="col-lg-7"> <div class="form-group" ng-class="{\'has-error\': $mdl.parForm.ReorderQuantity.$invalid && $mdl.parForm.$submitted}"> <input type="number" name="ReorderQuantity" class="form-control" style="background:#fffeed" ng-model="$mdl.item.reOrderQuantity" min="0" ng-min="0" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderQuantity.$error.required && $mdl.parForm.$submitted">* {{\'REQUIRED\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderQuantity.$error.number && $mdl.parForm.$submitted">* {{\'KEY_IN_NUMBERS_ONLY\'|translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.parForm.ReorderQuantity.$error.min && $mdl.parForm.$submitted">* {{\'MINIMUM_VALUE_IS_0\'|translate}} </p> </div> </div> <div class="col-lg-5" style="padding-left:0px;"> <div class="form-group" style="line-height:34px;color:#00f"> <b>{{$mdl.uomOrder}}</b> </div> </div> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="auditLogModal.html"><form name="$mdl.uomForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <b translate="VIEW_REVISION"></b> <div style="font-size:10pt;line-height:110%"> <span translate="REVISION_BY_:"></span> {{$mdl.log.username | uppercase}}<br /> <span translate="REVISION_ON_:"></span> {{$mdl.log.createdDate | date:\'dd/MM/yyyy hh:mma\'}} </div> </h3> </div> <div class="modal-body" id="modal-body" style="font-size:9pt"> <div class="row"> <div class="col-lg-6"> <h3><u><b translate="BEFORE_REVISION"></b></u></h3> </div> <div class="col-lg-6"> <h3><u><b translate="AFTER_REVISION"></b></u></h3> </div> </div> <div class="row"> <div class="col-lg-6"> <span translate="CODE:"></span> <b>{{$mdl.oriData.code}}</b> </div> <div class="col-lg-6"> <span translate="CODE:"></span> <b>{{$mdl.newData.code}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> {{ \'NAME\' | translate }}: <b>{{$mdl.oriData.name}}</b> </div> <div class="col-lg-6"> {{ \'NAME\' | translate }}: <b>{{$mdl.newData.name}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> {{ \'DESCRIPTION\' | translate }}: <b>{{$mdl.oriData.description}}</b> </div> <div class="col-lg-6"> {{ \'DESCRIPTION\' | translate }}: <b>{{$mdl.newData.description}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> <span translate="DIMENSION"></span>: <b>{{$mdl.oriData.dimension}}</b> </div> <div class="col-lg-6"> <span translate="DIMENSION"></span>: <b>{{$mdl.newData.dimension}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> <span translate="SHELF_LIFE:"></span> <b>{{$mdl.oriData.lifeTime}} Days</b> </div> <div class="col-lg-6"> <span translate="SHELF_LIFE:"></span> <b>{{$mdl.newData.lifeTime}} Days</b> </div> </div> <div class="row"> <div class="col-lg-6"> <span translate="ASSOCIATED_RECIPE:"></span> <b>{{$mdl.oriData.recipeName}}</b> </div> <div class="col-lg-6"> <span translate="ASSOCIATED_RECIPE:"></span> <b>{{$mdl.newData.recipeName || \'-\'}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> <span translate="PACKAGING_INSTRUCTION"></span>: <b>{{$mdl.oriData.packagingInstruction}}</b> </div> <div class="col-lg-6"> <span translate="PACKAGING_INSTRUCTION"></span>: <b>{{$mdl.newData.packagingInstruction}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> {{ \'STATUS:\' | translate }} <b>{{$mdl.oriData.active?\'ACTIVE\':\'INACTIVE\'}}</b> </div> <div class="col-lg-6"> {{ \'STATUS:\' | translate }} <b>{{$mdl.newData.active?\'ACTIVE\':\'INACTIVE\'}}</b> </div> </div> <div class="row"> <div class="col-lg-6"> <br /> <span translate="U.O.M_LIST:"></span> <table border=1 style="border:1px solid #aaa;border-collapse:collapse;width:100%" class="table table-striped table-sm"> <tr> <td style="width:20%"><span translate="UOM"></span></td> <td style="width:20%"><span translate="MULTIPLIER"></span></td> <td style="text-align:center;width:15%"><span translate="BASE"></span></td> <td style="text-align:center;width:15%"><span translate="INV"></span></td> <td style="text-align:center;width:15%"> <span translate="SALES"></span></td> </tr> <tr ng-repeat="u in $mdl.oriData.productUnitOfMeasurements | orderBy:\'baseMultiplier\'"> <td><b>{{u.unitOfMeasurement.name}}</b></td> <td>X <b>{{u.baseMultiplier}}</b></td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isBase" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isBase" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isInventory" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isInventory" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isOrder" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isOrder" style="color:#f00"></i> </td> </tr> </table> </div> <div class="col-lg-6"> <br /> <span translate="U.O.M_LIST:"></span> <table border=1 style="border:1px solid #aaa;border-collapse:collapse;width:100%" class="table table-striped table-sm"> <tr> <td style="width:20%"><span translate="UOM"></span></td> <td style="width:20%"><span translate="MULTIPLIER"></span></td> <td style="text-align:center;width:15%"><span translate="BASE"></span></td> <td style="text-align:center;width:15%"><span translate="INV"></span></td> <td style="text-align:center;width:15%"> <span translate="SALES"></span></td> </tr> <tr ng-repeat="u in $mdl.newData.productUnitOfMeasurements | orderBy:\'baseMultiplier\'"> <td><b>{{u.unitOfMeasurement.name}}</b></td> <td>X <b>{{u.baseMultiplier}}</b></td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isBase" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isBase" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isInventory" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isInventory" style="color:#f00"></i> </td> <td style="text-align:center"> <i class="fa fa-check" ng-show="u.isOrder" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!u.isOrder" style="color:#f00"></i> </td> </tr> </table> </div> </div> <div class="row"> <div class="col-lg-6"> <br /> <span translate="PAR_LEVEL:"></span> <table border=1 style="border:1px solid #aaa;border-collapse:collapse;width:100%" class="table table-striped table-sm"> <tr> <td style="width:40%">{{ \'BRANCH\' | translate }}</td> <td style="text-align:right;width:20%"><span translate="PAR_LEVEL"></span></td> <td style="text-align:right;width:20%"><span translate="REORDER_LEVEL"></span></td> <td style="text-align:right;width:20%"><span translate="REORDER_QTY"></span></td> </tr> <tr ng-repeat="b in $mdl.oriData.productBranchConfigs"> <td><b>{{b.branch.name}}</b></td> <td style="text-align:right"> <b>{{b.parLevel}}</b> {{$mdl.invUom}} </td> <td style="text-align:right"> <b>{{b.reOrderLevel}}</b> {{$mdl.invUom}} </td> <td style="text-align:right"> <b>{{b.reOrderQuantity}}</b> {{$mdl.orderUom}} </td> </tr> </table> </div> <div class="col-lg-6"> <br /> <span translate="PAR_LEVEL"></span> <table border=1 style="border:1px solid #aaa;border-collapse:collapse;width:100%" class="table table-striped table-sm"> <tr> <td style="width:40%">{{ \'BRANCH\' | translate }}</td> <td style="text-align:right;width:20%"><span translate="PAR_LEVEL"></span></td> <td style="text-align:right;width:20%"><span translate="REORDER_LEVEL"></span></td> <td style="text-align:right;width:20%"><span translate="REORDER_QTY"></span></td> </tr> <tr ng-repeat="b in $mdl.newData.productBranchConfigs"> <td style="line-height:110%;padding-top:8px;padding-bottom:8px"> <b>{{b.branch.name}}</b> </td> <td style="text-align:right"> <b>{{b.parLevel}}</b> {{$mdl.invUom}} </td> <td style="text-align:right"> <b>{{b.reOrderLevel}}</b> {{$mdl.invUom}} </td> <td style="text-align:right"> <b>{{b.reOrderQuantity}}</b> {{$mdl.orderUom}} </td> </tr> </table> </div> </div> </div> <hr /> <div class="modal-footer"> <center> <button type="submit" class="btn btn-warning btn-with-icon btn-lg" type="button" style="color:#000" ng-disabled="$mdl.isLoading" rms-check-access="maintenance.items" rms-check-access-perm-type="APPROVE"> <i class="ion ion-checkmark"></i> <span translate="REVERT_THIS_REVISION"></span> </button> &nbsp;&nbsp;&nbsp;&nbsp; <button class="btn btn-danger btn-with-icon btn-lg" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.isLoading"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </center> <div ng-if="$mdl.isLoading" style="margin-top:10px;color:#00f"> <big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b></center></big> </div> </div> </form></script><script type="text/ng-template" id="salesConfigModal.html"><form name="$mdl.salesConfigForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} Sales Config</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'SELECT_A_CUSTOMER\' | translate }}</b> ({{ \'OPTIONAL\' | translate }})</label> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.debtorSearch" style="background:#fffeed" /> </div> </div> <div class="col-lg-9"> <select name="Customer" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.debtorList | filter: $mdl.debtorSearch" ng-model="$mdl.selectedDebtor" ng-change="$mdl.selectedDebtorChanged()"> <option value="">-- {{ \'SELECT_A_CUSTOMER\' | translate }} --</option> </select> </div> </div> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.salesConfigForm.UnitPrice.$invalid && ($mdl.salesConfigForm.UnitPrice.$dirty || $mdl.salesConfigForm.$submitted)}"> <label><b>{{ \'UNIT_PRICE\' | translate }}</b> <small>({{$mdl.currencyCode}})</small> <i class="fa fa-asterisk req" style="color:#f00"></i> </label> <input type="number" name="UnitPrice" class="form-control" style="background:#fffeed" ng-model="$mdl.item.unitPrice" min="0.01" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.UnitPrice.$error.required && $mdl.salesConfigForm.$submitted"> * {{"REQUIRED" | translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxPercent.$error.min && $mdl.salesConfigForm.$submitted"> * {{ \'MINIMUM_IS_0\' | translate }} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxPercent.$error.number && $mdl.salesConfigForm.$submitted"> * {{ \'ENTER_NUMBERS_ONLY\' | translate }} </p> </div> </div> <div class="col-lg-6"> <label><b>{{ \'U.O.M.\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select name="UOM" class="form-control" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.selectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.UOM.$error.required && $mdl.salesConfigForm.$submitted"> * {{"REQUIRED" | translate}} </p> </div> </div> <br /> <div class="row"> <div class="col-lg-4"> <div class="form-group" ng-class="{\'has-error\': $mdl.salesConfigForm.TaxCode.$invalid && ($mdl.salesConfigForm.TaxCode.$dirty || $mdl.salesConfigForm.$submitted)}"> <label><b>{{ \'TAX_CODE\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i> </label> <input type="text" name="TaxCode" class="form-control" style="background:#fffeed" ng-model="$mdl.item.taxCode" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxCode.$error.required && $mdl.salesConfigForm.$submitted"> * {{"REQUIRED" | translate}} </p> </div> </div> <div class="col-lg-4"> <div class="form-group" ng-class="{\'has-error\': $mdl.salesConfigForm.TaxPercent.$invalid && ($mdl.salesConfigForm.TaxPercent.$dirty || $mdl.salesConfigForm.$submitted)}"> <label><b>Tax Percent (%)</b> <i class="fa fa-asterisk req" style="color:#f00"></i> </label> <input type="number" name="TaxPercent" class="form-control" style="background:#fffeed" ng-model="$mdl.item.taxPercentage" min="0" required ng-change="$mdl.taxPercentChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxPercent.$error.required && $mdl.salesConfigForm.$submitted"> * {{"REQUIRED" | translate}} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxPercent.$min.required && $mdl.salesConfigForm.$submitted"> * {{ \'MINIMUM_IS_0\' | translate }} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.salesConfigForm.TaxPercent.$min.required && $mdl.salesConfigForm.$submitted"> * {{ \'ENTER_NUMBERS_ONLY\' | translate }} </p> </div> </div> <div class="col-lg-4"> <div class="form-group"> <label> <b>{{ \'TAX_AMOUNT\' | translate }}</b> <small>({{$mdl.currencyCode}})</small> </label> <span class="form-control" ng-disabled="true"> {{ $mdl.item.taxAmount | number:3 }} </span> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="certModal.html"><form name="$mdl.certForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} {{ \'CERTIFICATE\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-6"> <div class="form-group"> <label><b>{{ \'CERTIFICATE_TYPE\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select name="Supplier" class="form-control" style="background:#fffeed" ng-model="$mdl.item.certType" required> <option></option> <option value="GMP">{{ \'GMP\' | translate }}</option> <option value="HACCP">{{ \'HACCP\' | translate }}</option> <option value="HALAL">{{ \'HALAL\' | translate }}</option> <option value="MESTI">{{ \'MESTI\' | translate }}</option> <option value="OTHERS">{{ \'OTHERS\' | translate }}</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.certForm.Supplier.$error.required && $mdl.certForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>{{ \'CERTIFICATE_REF_NO\' | translate }}</b></label> <input type="text" name="CertRefNo" class="form-control" style="background:#fffeed" ng-model="$mdl.item.certRefNo" /> <p class="help-block" style="color:#f00" ng-show="$mdl.certForm.CertRefNo.$error.required && $mdl.certForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group"> <label><b>{{ \'ISSUE_DATE\' | translate }}</b></label> <div moment-picker="$mdl.item.issueDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control" name="IssueDate" autocomplete="off" ng-model="$mdl.item.issueDate" style="background:#fffeed"> </div> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>{{ \'EXPIRY_DATE\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <div moment-picker="$mdl.item.expiryDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control" name="ExpiryDate" autocomplete="off" ng-model="$mdl.item.expiryDate" style="background:#fffeed" required> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.certForm.ExpiryDate.$error.required && $mdl.certForm.$submitted">* {{ \'REQUIRED\' | translate }} </p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" style="background:#fffeed" ng-model="$mdl.item.remarks" /> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" style="margin-top:15px"> <label><b>{{ \'ATTACHMENT\' | translate }}</b> <small>{{ \'CERTIFICATE_PDF_PNG_JPG_FORMAT\' | translate }}</small></label> <div class="row"> <div class="col-lg-6"> <span class="form-control" style="background:#fffeed" ng-if="$mdl.mediaFile.name || $mdl.mode==1"> {{ $mdl.mediaFile.name || (\'NO_FILE_SELECTED\' | translate) }} </span> <a class="btn btn-primary btn-with-icon" style="color:#fff" href="{{$mdl.rootUrl}}{{$mdl.item.certFilename}}" target="_blank" ng-if="$mdl.item.certFilename!=\'\' && !$mdl.mediaFile.name"> <i class="fa fa-file-text"></i> {{ \'VIEW_UPLOADED_FILE\' | translate}} </a> </div> <div class="col-lg-6"> <div class="btn btn-default btn-with-icon" name="file" ng-model="$mdl.mediaFile" ngf-select="$mdl.setUploadMedia($mdl.mediaFile)" ngf-accept="\'image/*,application/pdf\'" ngf-pattern="\'image/*,application/pdf\'" ngf-model-invalid="errorFile" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-upload"></i> {{ \'BROWSE\' | translate}} </div> <a href ng-click="$mdl.mediaFile=null;$mdl.setUploadMedia(null)" ng-if="$mdl.mediaFile" class="btn btn-danger btn-with-icon" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-remove-circle"></i> {{ \'RESET\' | translate}} </a> </div> </div> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING"></b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/maintenance/products/productCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/products/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_PRODUCT"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.products.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/products/productImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b translate="IMPORT_FINISHED_GOODS_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'1\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_FINISHED_GOODS_UOMS_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'2\')" ng-disabled="vm.isExporting || vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_FINISHED_GOODS_PAR_LEVEL_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'3\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_FG_X_DEBTOR_X_SALES_CONFIG_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'5\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_FINISHED_GOODS_LABEL_INFO_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'4\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend translate="IMPORT_GUIDELINES:"></legend><ol class="import"><li translate="YOU_NEED_TO_FOLLOW_THE_INSTRUCTION_BELOW_IF_YOU_ARE_NEW_TO_THE_RMS."></li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW_FILL_IT_UP_WITH_THE_DATA_FIRST_THEN_IMPORT_INTO_THE_RMS"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'1\', \'Finished Goods Data Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_FINISHED_GOODS_DATA_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'2\', \'Finished Goods UOMs Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_FINISHED_GOODS_UOMS_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'3\', \'Finished Goods PAR Level Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_FINISHED_GOODS_PAR_LEVEL_TEMPLATE"></span></a></li><li><span translate="LASTLY,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplateOther(\'F.G. x Debtor x Sales Config Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_FG_X_DEBTOR_X_SALES_CONFIG_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'4\', \'Finished Goods Label Info Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_FINISHED_GOODS_LABEL_INFO_TEMPLATE"></span></a></li><li translate="AFTER_IMPORTED_THE_DATA_ONCE,_YOU_CAN_FREELY_IMPORT_THE_DATA_WITHOUT_FOLLOWING_THE_SEQUENCE."></li></ol></fieldset><br>&nbsp;<br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong translate="FILE_UPLOADED_SUCCESSFULLY._CHOOSE_THE_OPTIONS_BELOW_AND_PROCEED_TO_IMPORT_THE_DATA."></strong></div><div><fieldset ng-if="vm.importType==\'1\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createProduct" ng-change="change()" ng-disabled="true" style="cursor:pointer"> <label><span translate="CREATE_NEW_FINISHED_GOODS"></span></label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateProduct" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_FINISHED_GOODS_IF_EXISTS"></span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'1\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'2\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createUom" ng-change="change()" style="cursor:pointer"> <label><span translate="ADD_NEW_UOM"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateUom" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_UOM_IF_EXISTS"></span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'2\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'3\'"><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'3\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'4\'"><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'4\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'5\'"><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importDataOther()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><br><br><fieldset><legend translate="ITEM_DATA_PREVIEW:"></legend></fieldset></div><div id="scroll-container" class="horizontal-scroll"><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'1\'"><thead><tr><th style="width:60px">#</th><th><b>{{ \'PRODUCT_CODE\' | translate }}</b></th><th><b>{{ \'PRODUCT_NAME\' | translate }}</b></th><th><b>{{ \'CATEGORY\' | translate }}</b></th><th><b>{{ \'SUB-CATEGORY\' | translate }}</b></th><th style="text-align:center !important"><b>{{ \'SHELF_LIFE_(DAY)\' | translate }}</b></th><th><b>{{ \'PACKAGING_INSTRUCTION\' | translate }}</b></th><th><b>{{ \'IS_FOR_SALE\' | translate }}</b></th><th><b>{{ \'ACTIVE\' | translate }}</b></th></tr><tr><th colspan="9"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.code || \'\' }}</td><td nowrap="nowrap">{{ row.name || \'\' }}</td><td nowrap="nowrap">{{ row.category || \'\' }}</td><td nowrap="nowrap">{{ row.subCategory || \'\' }}</td><td style="text-align:center">{{ row.lifeTime || \'-\' | number:0 }}</td><td nowrap="nowrap">{{ row.packagingInstruction || \'\' }}</td><td style="text-align:center">{{ row.isForSale || \'\' }}</td><td style="text-align:center">{{ row.active || \'\' }}</td></tr><tr><td colspan="9" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="9"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'2\'"><thead><tr><th style="width:60px">#</th><th><b translate="PRODUCT_CODE"></b></th><th><b>{{ \'PRODUCT_NAME\' | translate }}</b></th><th style="text-align:center !important"><b translate="BASE_UOM"></b></th><th style="text-align:center !important"><b translate="BASE_MULTIPLIER"></b></th><th style="text-align:center !important"><b>{{ \'INVENTORY_UOM\' | translate }}</b></th><th style="text-align:center !important"><b translate="INVENTORY_UOM_MULTIPLIER"></b></th><th style="text-align:center !important"><b>{{ \'SALES_UOM\' | translate }}</b></th><th style="text-align:center !important"><b translate="SALES_UOM_MULTIPLIER"></b></th><th style="text-align:center !important"><b translate="OTHER_UOM_#1"></b></th><th style="text-align:center !important"><b translate="OTHER_UOM_MULTIPLIER_#1"></b></th><th style="text-align:center !important"><b translate="OTHER_UOM_#2"></b></th><th style="text-align:center !important"><b translate="OTHER_UOM_MULTIPLIER_#2"></b></th><th style="text-align:center !important"><b translate="OTHER_UOM_#3"></b></th><th style="text-align:center !important"><b translate="OTHER_UOM_MULTIPLIER_#3"></b></th></tr><tr><th colspan="15"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.code || \'\' }}</td><td nowrap="nowrap">{{ row.name || \'\' }}</td><td align="center" style="color:#00f">{{ row.baseUom || \'\' }}</td><td align="center">{{ row.baseMultiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.invUom || \'\' }}</td><td align="center">{{ row.invUomMultiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.orderUom || \'\' }}</td><td align="center">{{ row.orderUomMultiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.otherUom1 || \'\' }}</td><td align="center">{{ row.otherUom1Multiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.otherUom2 || \'\' }}</td><td align="center">{{ row.otherUom2Multiplier || \'\' }}</td><td align="center" style="color:#00f">{{ row.otherUom3 || \'\' }}</td><td align="center">{{ row.otherUom3Multiplier || \'\' }}</td></tr><tr><td colspan="15" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="15"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'3\'"><thead><tr><th style="width:60px">#</th><th><b translate="PRODUCT_CODE"></b></th><th nowrap="nowrap"><b>{{ \'PRODUCT_NAME\' | translate }}</b></th><th><b translate="BRANCH_CODE"></b></th><th style="text-align:right !important" nowrap="nowrap"><b>{{ \'PAR_LEVEL\' | translate }}</b></th><th><b translate="UOM"></b></th><th style="text-align:right !important" nowrap="nowrap"><b>{{ \'REORDER_LEVEL\' | translate }}</b></th><th><b translate="UOM"></b></th><th style="text-align:right !important" nowrap="nowrap"><b>{{ \'REORDER_QUANTITY\' | translate }}</b></th><th><b translate="UOM"></b></th></tr><tr><th colspan="10"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.code || \'\' }}</td><td nowrap="nowrap">{{ row.name || \'\' }}</td><td nowrap="nowrap">{{ row.branchCode || \'\' }}</td><td style="text-align:right;color:#00f">{{ row.parLevel || \'\' | number:0 }}</td><td>{{ row.uom1 || \'\' }}</td><td style="text-align:right;color:#00f">{{ row.reorderLevel || \'\' | number:0 }}</td><td>{{ row.uom2 || \'\' }}</td><td style="text-align:right;color:#00f">{{ row.reorderQty || \'\' | number:0 }}</td><td>{{ row.uom3 || \'\' }}</td></tr><tr><td colspan="10" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="10"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'4\'"><thead><tr><th style="width:60px">#</th><th><b translate="SFG_CODE"></b></th><th nowrap="nowrap"><b translate="SFG_DESCRIPTION"></b></th><th nowrap="nowrap"><b translate="PRODUCT_NAME"></b></th><th><b translate="INGREDIENT_LINE_#1"></b></th><th><b translate="INGREDIENT_LINE_#2"></b></th><th><b translate="INGREDIENT_LINE_#3"></b></th><th><b translate="INGREDIENT_LINE_#4"></b></th><th><b translate="RETHERMALIZATION_INSTRUCTION_LINE_#1"></b></th><th><b translate="RETHERMALIZATION_INSTRUCTION_LINE_#2"></b></th><th><b translate="STORAGE"></b></th><th><b translate="HALAL_CERT_NUMBER_#1"></b></th><th><b translate="HALAL_CERT_NUMBER_#2"></b></th><th><b translate="CUSTOM_TEXT_#1"></b></th><th><b translate="CUSTOM_TEXT_#2"></b></th><th><b translate="CUSTOM_TEXT_#3"></b></th><th><b translate="CUSTOM_TEXT_#4"></b></th></tr><tr><th colspan="17"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.itemCode || \'\' }}</td><td nowrap="nowrap">{{ row.itemName || \'\' }}</td><td nowrap="nowrap">{{ row.productName || \'\' }}</td><td nowrap="nowrap">{{ row.ingredientLine1 || \'\' }}</td><td nowrap="nowrap">{{ row.ingredientLine2 || \'\' }}</td><td nowrap="nowrap">{{ row.ingredientLine3 || \'\' }}</td><td nowrap="nowrap">{{ row.ingredientLine4 || \'\' }}</td><td nowrap="nowrap">{{ row.rethermalize1 || \'\' }}</td><td nowrap="nowrap">{{ row.rethermalize2 || \'\' }}</td><td nowrap="nowrap">{{ row.storage || \'\' }}</td><td nowrap="nowrap">{{ row.halalCert1 || \'\' }}</td><td nowrap="nowrap">{{ row.halalCert2 || \'\' }}</td><td nowrap="nowrap">{{ row.customText1 || \'\' }}</td><td nowrap="nowrap">{{ row.customText2 || \'\' }}</td><td nowrap="nowrap">{{ row.customText3 || \'\' }}</td><td nowrap="nowrap">{{ row.customText4 || \'\' }}</td></tr><tr><td colspan="17" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="17"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'5\'"><thead><tr><th style="width:60px">#</th><th><b translate="ITEM_CODE"></b></th><th nowrap="nowrap"><b translate="ITEM_DESCRIPTION"></b></th><th><b translate="DEBTOR_CODE"></b></th><th nowrap="nowrap"><b translate="DEBTOR_NAME"></b></th><th><b translate="SALES_U.O.M"></b></th><th style="text-align:right !important" nowrap="nowrap"><b translate="UNIT_PRICE"></b></th><th><b>{{ \'TAX_CODE\' | translate }}</b></th><th style="text-align:right !important" nowrap="nowrap"><b translate="TAX_PERCENT"></b></th><th style="text-align:right !important" nowrap="nowrap"><b translate="TAX_AMOUNT"></b></th></tr><tr><th colspan="10"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.itemCode || \'-\' }}</td><td nowrap="nowrap">{{ row.itemDescription || \'-\' }}</td><td>{{ row.debtorCode || \'-\' }}</td><td nowrap="nowrap">{{ row.debtorName || \'-\' }}</td><td>{{ row.uom || \'-\' }}</td><td style="text-align:right;color:#00f">{{ row.unitPrice | number:2 }}</td><td>{{ row.taxCode || \'-\' }}</td><td style="text-align:right;color:#00f">{{ row.taxPercentage | number:0 }}</td><td style="text-align:right;color:#00f">{{ row.taxAmount | number:2 }}</td></tr><tr><td colspan="10" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="7"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-6 col-lg-6"><em><small><i class="fa fa-info-circle"></i> <span translate="PROCESSING"></span>...</small></em><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><p translate="THE_DATA_IS_CURRENTLY_BEING_PROCESSED._IT_IS_SAFE_TO_LEAVE_THIS_PAGE_NOW."></p><p translate="YOU_WILL_RECEIVE_AN_EMAIL_NOTIFICATION_ABOUT_THE_IMPORT_RESULT_ONCE_THE_SERVER_HAS_FINISHED_PROCESSED_THE_DATA."></p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.products.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a></div></form></div><div class="float-scroll-button"><span class="scroll-caption"><span translate="SCROLL"></span></span> <a href="" class="scroll-left" ng-if="vm.isSuccess && !vm.isImporting" ng-click="vm.scrollLeft()"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-arrow-left fa-stack-1x fa-inverse"></i></span></a> <a href="" class="scroll-right" ng-if="vm.isSuccess && !vm.isImporting" ng-click="vm.scrollRight()"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-arrow-right fa-stack-1x fa-inverse"></i></span></a></div>');
$templateCache.put('app/pages/maintenance/products/productList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-hover" st-persist="FinishedGoodsListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.products.create" rms-check-access="maintenance.products" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="CREATE_NEW"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="maintenance.products.import" rms-check-access="maintenance.products" rms-check-access-perm-type="CREATE"><i class="fa fa-upload"></i><span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:140px">{{ \'IMAGE\' | translate}}</th><th st-sort="code">{{ \'CODE\' | translate }}</th><th st-sort="name">{{ \'PRODUCT_NAME\' | translate }}</th><th st-sort="category">{{ \'CATEGORY\' | translate }}</th><th st-sort="subCategory">{{ \'SUB-CATEGORY\' | translate }}</th><th translate="STATUS"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th></th><th class="form-inline" colspan="2"><input st-search="code" class="form-control input input-sm" style="width:300px"></th><th class="form-inline"><input st-search="category" class="form-control input input-sm"></th><th class="form-inline"><input st-search="subCategory" class="form-control input input-sm"></th><th class="form-inline"><select st-search="active" class="form-control input input-sm"><option value="">{{ \'ALL\' | translate }}</option><option value="1">{{ \'ACTIVE\' | translate | uppercase }}</option><option value="0">{{ \'INACTIVE\' | translate | uppercase }}</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.data.length<=0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate}}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td><img src="{{((item.imageLocation==null || item.imageLocation==\'\') ? \'assets/img/empty_placeholder.png\' : vm.blobUrl + item.imageLocation)}}" style="width:96px;height:64px;margin-top:10px;margin-bottom:10px;border:2px solid #ccc"></td><td>{{item.code}}</td><td>{{item.name}}</td><td>{{item.category | uppercase}}</td><td>{{item.subCategory | uppercase}}</td><td><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.products.update({id:item.id})" rms-check-access="maintenance.products" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Product" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteProduct(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this product?" rms-check-access="maintenance.products" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/products/productUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/products/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.products.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.products.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-info btn-with-icon" style="float:right;margin-right:5px" confirmed-click="vm.cloneProduct()" ng-confirm-click="Confirm to clone this Product?" ng-disabled="vm.lockButtons" rms-check-access="maintenance.products" rms-check-access-perm-type="CREATE"><i class="ion ion-social-buffer"></i> <span translate="CLONE_PRODUCT"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/stockrequestconfigs/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="DEFINE_PURCHASE_CONFIG"></span><br><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-model="vm.src.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>{{ \'STATUS\' | translate }}</b></label><div><toggle ng-model="vm.src.isActive" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-2 col-lg-2" ng-if="vm.src.createdDate"><div class="form-group"><label><b>{{ \'CREATED_BY\' | translate }}</b></label><br><span>{{vm.src.createdBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.src.createdDate | date:\'dd/MM/yyyy\' }}</span></div></div><div class="col-md-2 col-lg-2" ng-if="vm.src.modifiedBy"><div class="form-group"><label><b>{{ \'MODIFIED_BY\' | translate }}</b></label><br><span>{{vm.src.modifiedBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.src.modifiedDate | date:\'dd/MM/yyyy\' }}</span></div></div></div><hr><br><div class="row"><div class="col-md-6 col-lg-6"><p><i class="fa fa-info-circle"></i> <span translate="APPLY_FOR_SELECTED_STORES"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddStorePanel()"><i class="ion-plus-round"></i><span translate="ADD_STORE"></span></a><br><br></p><div class="row" ng-if="vm.addStorePanelVisible"><div class="col-lg-12"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-lg-6"><b>{{ \'ADD_STORE\' | translate }}</b></div><div class="col-lg-6"><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" ng-click="vm.closeAddStorePanel()"><i class="ion ion-close"></i> {{ \'CLOSE_PANEL\' | translate }}</a></div></div></div><div class="panel-body" style="padding:20px"><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>{{ \'SELECT_A_STORE\' | translate }}:</b></label><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedStoreChanged()" ng-options="b as (b.name | uppercase) for b in vm.branchList | orderBy:\'name\'" ng-model="vm.selectedStore"><option value="">-- select a store --</option></select><a href="" class="btn btn-primary btn-with-icon btn-sm pull-right" style="margin-top:3px" ng-click="vm.addStore()"><i class="ion-plus-round"></i> {{ \'ADD_STORE\' | translate }}</a> <a href="" class="btn btn-info btn-with-icon btn-sm pull-right" style="margin-top:3px;margin-right:5px" ng-click="vm.addAllStores()"><i class="ion-plus-round"></i> Add All</a></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><table class="table table-striped table-hover" style="border:1px solid #ccc;font-size:85%"><thead><tr class="sortable"><th><big><b translate="STORE_NAME"></b></big><span ng-if="vm.src.stockRequestStoreLevelConfigs.length!=0" style="font-weight:normal !important;">({{vm.src.stockRequestStoreLevelConfigs.length}} selected)</span></th></tr></thead></table><div style="max-height:485px;overflow:auto"><table class="table table-striped table-hover" style="border:1px solid #ccc;font-size:85%"><tbody><tr ng-repeat="ntn in vm.src.stockRequestStoreLevelConfigs"><td style="padding-top:10px;padding-bottom:10px;line-height:150%">{{ ntn.branchName }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%;width:50px"><a class="btn btn-danger editable-table-button btn-xs" style="width:50px" confirmed-click="vm.removeStore($index)" ng-confirm-click="Confirm remove this Store?"><i class="fa fa-trash-o"></i></a></td></tr><tr><td colspan="7" align="center" ng-show="vm.src.stockRequestStoreLevelConfigs.length==0"><br>{{ \'NO_RECORD_FOUND\' | translate }}.<br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row"><p>&nbsp;</p></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Item Restrictions"><div class="row"><div class="col-md-4 col-lg-4"><p><i class="fa fa-info-circle"></i> <span translate="APPLY_FOR_SELECTED_RAWMATS"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm pull-right" style="margin-left:20px" ng-click="vm.showAddRawMatPanel()"><i class="ion-plus-round"></i><span translate="ADD"></span></a><br><br></p><div class="row" ng-if="vm.addRawMatPanelVisible"><div class="col-lg-12"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-lg-6"><b>{{ \'ADD_RAWMAT\' | translate }}</b></div><div class="col-lg-6"><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" ng-click="vm.closeAddRawMatPanel()"><i class="ion ion-close"></i> {{ \'CLOSE_PANEL\' | translate }}</a></div></div></div><div class="panel-body" style="padding:20px"><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>Select a Raw Material:</b></label><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedRawMatChanged()" ng-options="b as (b.code + \' | \' + b.description | uppercase) for b in vm.rawmatList | orderBy:\'code\'" ng-model="vm.selectedRawMat"><option value="">-- select a raw material --</option></select><br><div class="row"><div class="col-md-6 col-lg-6"><label><b>Select a UOM:</b></label><div class="input-group"><span class="input-group-addon" style="padding:0px"><i class="fa fa-question-circle" style="padding:3px 10px" uib-tooltip="Store user to order with this UOM" tooltip-placement="auto bottom"></i></span><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedRawMatUomChanged()" ng-options="b as (b.uomName | uppercase) for b in vm.selectedRawMat.uoms | orderBy:\'baseMultiplier\'" ng-model="vm.selectedRawMatUom"><option value="">-- select a UOM --</option></select></div></div></div><br><a href="" class="btn btn-primary btn-with-icon btn-sm pull-right" style="margin-top:3px" ng-click="vm.addRawMat()"><i class="ion-plus-round"></i> Add Raw Material</a> <a href="" class="btn btn-info btn-with-icon btn-sm pull-right" style="margin-top:3px;margin-right:5px" confirmed-click="vm.addAllRawMats()" ng-confirm-click="Are you sure you want to add all items?"><i class="ion-plus-round"></i> Add All</a></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><table class="table table-striped table-hover" style="border:1px solid #ccc;font-size:85%"><thead><tr class="sortable"><th><big><b translate="RAW_MAT_NAME"></b></big><span ng-if="vm.src.stockRequestItemConfigs.length!=0" style="font-weight:normal !important;">({{vm.src.stockRequestItemConfigs.length}} selected)</span> <a class="btn btn-danger editable-table-button btn-with-icon btn-xs pull-right" style="width:110px" ng-if="vm.src.stockRequestItemConfigs.length!=0" confirmed-click="vm.removeAllRawMats()" ng-confirm-click="Confirm remove all Raw Materials?"><i class="fa fa-trash-o"></i> {{ \'REMOVE_ALL\' | translate }}</a></th></tr></thead></table><div style="max-height:485px;overflow:auto"><table class="table table-striped table-hover" style="border:1px solid #ccc;font-size:85%"><tbody><tr ng-repeat="ntn in vm.src.stockRequestItemConfigs"><td style="padding-top:10px;padding-bottom:10px;line-height:150%">{{ ntn.itemName }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%;color:#00f">{{ ntn.uomName }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%;width:40px"><a class="btn btn-danger editable-table-button btn-xs" style="width:40px" confirmed-click="vm.removeRawMat($index)" ng-confirm-click="Confirm remove this Raw Material?"><i class="fa fa-trash-o"></i></a></td></tr><tr><td colspan="7" align="center" ng-if="vm.src.stockRequestItemConfigs.length==0"><br>{{ \'NO_RECORD_FOUND\' | translate }}.<br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row"><p>&nbsp;</p></div></div><div class="col-md-4 col-lg-4"><p><i class="fa fa-info-circle"></i> <span translate="APPLY_FOR_SELECTED_SEMIFGS"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm pull-right" style="margin-left:20px" ng-click="vm.showAddSemiFgPanel()"><i class="ion-plus-round"></i><span translate="ADD"></span></a><br><br></p><div class="row" ng-if="vm.addSemiFgPanelVisible"><div class="col-lg-12"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-lg-6"><b>{{ \'ADD_SEMIFG\' | translate }}</b></div><div class="col-lg-6"><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" ng-click="vm.closeAddSemiFgPanel()"><i class="ion ion-close"></i> {{ \'CLOSE_PANEL\' | translate }}</a></div></div></div><div class="panel-body" style="padding:20px"><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>Select a Semi Finished Good:</b></label><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedSemiFgChanged()" ng-options="b as (b.code + \' | \' + b.description | uppercase) for b in vm.sfgList | orderBy:\'code\'" ng-model="vm.selectedSemiFg"><option value="">-- select a Semi Finished Good --</option></select><br><div class="row"><div class="col-md-6 col-lg-6"><label><b>Select a UOM:</b></label><div class="input-group"><span class="input-group-addon" style="padding:0px"><i class="fa fa-question-circle" style="padding:3px 10px" uib-tooltip="Store user to order with this UOM" tooltip-placement="auto bottom"></i></span><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedSemiFgUomChanged()" ng-options="b as (b.uomName | uppercase) for b in vm.selectedSemiFg.uoms | orderBy:\'baseMultiplier\'" ng-model="vm.selectedSemiFgUom"><option value="">-- select a UOM --</option></select></div></div></div><br><a href="" class="btn btn-primary btn-with-icon btn-sm pull-right" style="margin-top:3px" ng-click="vm.addSemiFg()"><i class="ion-plus-round"></i> Add Semi Finished Good</a> <a href="" class="btn btn-info btn-with-icon btn-sm pull-right" style="margin-top:3px;margin-right:5px" confirmed-click="vm.addAllSemiFgs()" ng-confirm-click="Are you sure you want to add all items?"><i class="ion-plus-round"></i> Add All</a></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><table class="table table-striped table-hover" style="border:1px solid #ccc;font-size:85%"><thead><tr class="sortable"><th><big><b translate="SEMIFG_NAME"></b></big><span ng-if="vm.src.stockRequestSemiFinishedProductConfigs.length!=0" style="font-weight:normal !important;">({{vm.src.stockRequestSemiFinishedProductConfigs.length}} selected)</span> <a class="btn btn-danger editable-table-button btn-xs pull-right" style="width:110px" ng-if="vm.src.stockRequestSemiFinishedProductConfigs.length!=0" confirmed-click="vm.removeAllSemiFgs()" ng-confirm-click="Confirm remove all Semi Finished Goods?"><i class="fa fa-trash-o"></i> {{ \'REMOVE_ALL\' | translate }}</a></th></tr></thead></table><div style="max-height:485px;overflow:auto"><table class="table table-striped table-hover" style="border:1px solid #ccc;font-size:85%"><tbody><tr ng-repeat="ntn in vm.src.stockRequestSemiFinishedProductConfigs"><td style="padding-top:10px;padding-bottom:10px;line-height:150%">{{ ntn.semiFinishedProductName }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%;color:#00f">{{ ntn.uomName }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%;width:40px"><a class="btn btn-danger editable-table-button btn-xs" style="width:40px" confirmed-click="vm.removeSemiFg($index)" ng-confirm-click="Confirm remove this Semi Finished Good?"><i class="fa fa-trash-o"></i></a></td></tr><tr><td colspan="7" align="center" ng-if="vm.src.stockRequestSemiFinishedProductConfigs.length==0"><br>{{ \'NO_RECORD_FOUND\' | translate }}.<br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row"><p>&nbsp;</p></div></div><div class="col-md-4 col-lg-4"><p><i class="fa fa-info-circle"></i> <span translate="APPLY_FOR_SELECTED_FGS"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm pull-right" style="margin-left:20px" ng-click="vm.showAddFgPanel()"><i class="ion-plus-round"></i><span translate="ADD"></span></a><br><br></p><div class="row" ng-if="vm.addFgPanelVisible"><div class="col-lg-12"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-lg-6"><b>{{ \'ADD_FG\' | translate }}</b></div><div class="col-lg-6"><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" ng-click="vm.closeAddFgPanel()"><i class="ion ion-close"></i> {{ \'CLOSE_PANEL\' | translate }}</a></div></div></div><div class="panel-body" style="padding:20px"><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>Select a Finished Good:</b></label><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedFgChanged()" ng-options="b as (b.code + \' | \' + b.name | uppercase) for b in vm.fgList | orderBy:\'code\'" ng-model="vm.selectedFg"><option value="">-- select a Finished Good --</option></select><br><div class="row"><div class="col-md-6 col-lg-6"><label><b>Select a UOM:</b></label><div class="input-group"><span class="input-group-addon" style="padding:0px"><i class="fa fa-question-circle" style="padding:3px 10px" uib-tooltip="Store user to order with this UOM" tooltip-placement="auto bottom"></i></span><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedFgUomChanged()" ng-options="b as (b.uomName | uppercase) for b in vm.selectedFg.uoms | orderBy:\'baseMultiplier\'" ng-model="vm.selectedFgUom"><option value="">-- select a UOM --</option></select></div></div></div><br><a href="" class="btn btn-primary btn-with-icon btn-sm pull-right" style="margin-top:3px" ng-click="vm.addFg()"><i class="ion-plus-round"></i> Add Finished Good</a> <a href="" class="btn btn-info btn-with-icon btn-sm pull-right" style="margin-top:3px;margin-right:5px" confirmed-click="vm.addAllFgs()" ng-confirm-click="Are you sure you want to add all items?"><i class="ion-plus-round"></i> Add All</a></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><table class="table table-striped table-hover" style="border:1px solid #ccc;font-size:85%"><thead><tr class="sortable"><th><big><b translate="FG_NAME"></b></big><span ng-if="vm.src.stockRequestProductConfigs.length!=0" style="font-weight:normal !important;">({{vm.src.stockRequestProductConfigs.length}} selected)</span> <a class="btn btn-danger editable-table-button btn-xs pull-right" style="width:110px" ng-if="vm.src.stockRequestProductConfigs.length!=0" confirmed-click="vm.removeAllFgs()" ng-confirm-click="Confirm remove all Finished Goods?"><i class="fa fa-trash-o"></i> {{ \'REMOVE_ALL\' | translate }}</a></th></tr></thead></table><div style="max-height:485px;overflow:auto"><table class="table table-striped table-hover" style="border:1px solid #ccc;font-size:85%"><tbody><tr ng-repeat="ntn in vm.src.stockRequestProductConfigs"><td style="padding-top:10px;padding-bottom:10px;line-height:150%">{{ ntn.productName }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%;color:#00f">{{ ntn.uomName }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%;width:40px"><a class="btn btn-danger editable-table-button btn-xs" style="width:40px" confirmed-click="vm.removeFg($index)" ng-confirm-click="Confirm remove this Finished Good?"><i class="fa fa-trash-o"></i></a></td></tr><tr><td colspan="7" align="center" ng-if="vm.src.stockRequestProductConfigs.length==0"><br>{{ \'NO_RECORD_FOUND\' | translate }}.<br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row"><p>&nbsp;</p></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/maintenance/stockrequestconfigs/srcCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/stockrequestconfigs/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.stockrequestconfigs.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.stockrequestconfigs.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/stockrequestconfigs/srcList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="SPCListing" st-pipe="vm.retrieveData" st-table="vm.srcData" refresh-table=""><thead><tr><th colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.stockrequestconfigs.create" rms-check-access="maintenance.stockrequestconfigs" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_CONFIGURATION"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="name">{{ \'DESCRIPTION\' | translate }}</th><th>{{ \'STATUS\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="item in vm.srcData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td><span ng-if="item.isActive" class="text-success"><b>Active</b></span> <span ng-if="!item.isActive" class="text-danger"><b>Inactive</b></span></td><td style="text-align:center"><a href="" title="Clone Config" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#000" confirmed-click="vm.cloneConfig(item.id)" ng-confirm-click="Clone this config [{{item.name}}]?" rms-check-access="maintenance.stockrequestconfigs" rms-check-access-perm-type="CREATE"><i class="fa fa-copy text-warning"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.stockrequestconfigs.update({id:item.id})" rms-check-access="maintenance.stockrequestconfigs" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteConfig(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Configuration?" rms-check-access="maintenance.stockrequestconfigs" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr><tr ng-show="vm.srcData.length<=0"><td colspan="6" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/stockrequestconfigs/srcUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/stockrequestconfigs/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.stockrequestconfigs.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.stockrequestconfigs.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/warehouses/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.warehouse.branchId==\'\' && vm.dataForm.$submitted}"><label><b>{{ \'BRANCH\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="ServiceType" ng-options="t as t.name for t in vm.branches | orderBy:\'name\'" ng-model="vm.selectedBranch" ng-change="vm.selectedBranchChanged()"><option>-- {{\'SELECT_A_BRANCH\' | translate}} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.warehouse.branchId==\'\'">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'IS_RECEIVING_WAREHOUSE?\' | translate }}</b></label><div><toggle ng-model="vm.warehouse.isReceiving" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.WarehouseCode.$invalid && (vm.dataForm.WarehouseCode.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'WAREHOUSE_CODE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="WarehouseCode" ng-model="vm.warehouse.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WarehouseCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'IS_POS_DEFAULT?\' | translate }}</b></label><div><toggle ng-model="vm.warehouse.isPosDefault" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.WarehouseName.$invalid && (vm.dataForm.WarehouseName.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'WAREHOUSE_DESCRIPTION\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="WarehouseName" ng-model="vm.warehouse.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WarehouseName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4" ng-if="vm.hasAfterSaleModule"><div class="form-group"><label><b>{{ \'IS_AFTERSALES_DEFAULT?\' | translate }}</b></label><div><toggle ng-model="vm.warehouse.isAfterSalesDefault" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'WAREHOUSE_TYPE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label></div><div class="form-group"><label class="radio-inline custom-radio nowrap"><input name="WarehouseTypes" type="radio" data-ng-model="vm.warehouse.type" data-ng-value="1"> <span>{{ \'RAW_MATERIALS\' | translate }}</span></label> <label class="radio-inline custom-radio nowrap"><input name="WarehouseTypes" type="radio" data-ng-model="vm.warehouse.type" data-ng-value="2"> <span>{{ \'FINISHED_GOODS\' | translate }}</span></label> <label class="radio-inline custom-radio nowrap"><input name="WarehouseTypes" type="radio" data-ng-model="vm.warehouse.type" data-ng-value="3"> <span>{{ \'SEMI_FINISHED_GOODS\' | translate }}</span></label></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/maintenance/warehouses/warehouseCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/warehouses/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.warehouses.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_WAREHOUSE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.warehouses.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/warehouses/warehouseList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.warehouseData" refresh-table=""><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.warehouses.create" rms-check-access="maintenance.warehouses" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> {{ \'ADD_NEW_WAREHOUSE\' | translate }}</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="branch">{{ \'BRANCH\' | translate }}</th><th st-sort="code">{{ \'CODE\' | translate }}</th><th st-sort="description">{{ \'DESCRIPTION\' | translate }}</th><th st-sort="description">{{ \'TYPE\' | translate }}</th><th style="width:150px">{{ \'IS_RECEIVING_WAREHOUSE?\' | translate }}</th><th style="width:150px">{{ \'IS_POS_DEFAULT?\' | translate }}</th><th style="width:150px" ng-if="vm.hasAfterSaleModule">{{ \'IS_AFTERSALES_DEFAULT?\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="item in vm.warehouseData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.branch}}</td><td>{{item.code}}</td><td>{{item.description}}</td><td>{{ vm.getTypeVar(item.typeName) | translate }}</td><td><i class="fa fa-check" ng-show="item.isReceiving" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isReceiving" style="color:#f00"></i></td><td><i class="fa fa-check" ng-show="item.isPosDefault" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isPosDefault" style="color:#f00"></i></td><td ng-if="vm.hasAfterSaleModule"><i class="fa fa-check" ng-show="item.isAfterSalesDefault" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isAfterSalesDefault" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.warehouses.update({id:item.id})" rms-check-access="maintenance.warehouses" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Product" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteWarehouse(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Warehouse?" rms-check-access="maintenance.warehouses" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr><tr ng-show="vm.warehouseData.length<=0"><td colspan="10" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/warehouses/warehouseUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/warehouses/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.warehouses.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.warehouses.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/storepurchaseconfigs/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="DEFINE_PURCHASE_CONFIG"></span><br><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-model="vm.spc.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>{{ \'STATUS\' | translate }}</b></label><div><toggle ng-model="vm.spc.isActive" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-2 col-lg-2" ng-if="vm.spc.createdDate"><div class="form-group"><label><b>{{ \'CREATED_BY\' | translate }}</b></label><br><span>{{vm.spc.createdBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.spc.createdDate | date:\'dd/MM/yyyy\' }}</span></div></div><div class="col-md-2 col-lg-2" ng-if="vm.spc.modifiedBy"><div class="form-group"><label><b>{{ \'MODIFIED_BY\' | translate }}</b></label><br><span>{{vm.spc.modifiedBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.spc.modifiedDate | date:\'dd/MM/yyyy\' }}</span></div></div></div><hr><br><div class="row"><div class="col-md-4 col-lg-4"><p><i class="fa fa-info-circle"></i> <span translate="APPLY_FOR_SELECTED_STORES"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddStorePanel()"><i class="ion-plus-round"></i><span translate="ADD_STORE"></span></a><br><br></p><div class="row" ng-if="vm.addStorePanelVisible"><div class="col-lg-12"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-lg-6"><b>{{ \'ADD_STORE\' | translate }}</b></div><div class="col-lg-6"><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" ng-click="vm.closeAddStorePanel()"><i class="ion ion-close"></i> {{ \'CLOSE_PANEL\' | translate }}</a></div></div></div><div class="panel-body" style="padding:20px"><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>{{ \'SELECT_A_STORE\' | translate }}:</b></label><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedStoreChanged()" ng-options="b as (b.code + \' | \' + b.name | uppercase) for b in vm.branchList | orderBy:\'code\'" ng-model="vm.selectedStore"><option value="">-- select a store --</option></select><a href="" class="btn btn-primary btn-with-icon btn-sm pull-right" style="margin-top:3px" ng-click="vm.addStore()"><i class="ion-plus-round"></i> {{ \'ADD_STORE\' | translate }}</a> <a href="" class="btn btn-info btn-with-icon btn-sm pull-right" style="margin-top:3px;margin-right:5px" ng-click="vm.addAllStores()"><i class="ion-plus-round"></i> {{ \'ADD_ALL_STORES\' | translate }}</a></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><table class="table table-striped table-hover" style="border:1px solid #ccc"><thead><tr class="sortable"><th><big><b translate="STORE_NAME"></b></big>&nbsp; <span ng-if="vm.spc.requisitionStorePurchaseStoreLevelConfigs.length!=0" style="font-weight:normal !important;">({{vm.spc.requisitionStorePurchaseStoreLevelConfigs.length}} selected)</span> <a class="btn btn-danger editable-table-button btn-with-icon btn-xs pull-right" style="width:110px" ng-if="vm.spc.requisitionStorePurchaseStoreLevelConfigs.length!=0" confirmed-click="vm.removeAllStores()" ng-confirm-click="Confirm remove all Stores?"><i class="fa fa-trash-o"></i> {{ \'REMOVE_ALL\' | translate }}</a></th></tr></thead></table><div style="max-height:485px;overflow:auto"><table class="table table-striped table-hover" style="border:1px solid #ccc"><tbody><tr ng-repeat="ntn in vm.spc.requisitionStorePurchaseStoreLevelConfigs"><td style="padding-top:10px;padding-bottom:10px;line-height:150%">{{ ntn.branchName }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%;width:40px"><a class="btn btn-danger editable-table-button btn-xs" style="width:40px" confirmed-click="vm.removeStore($index)" ng-confirm-click="Confirm remove this Store?"><i class="fa fa-trash-o"></i></a></td></tr><tr><td colspan="7" align="center" ng-show="vm.spc.requisitionStorePurchaseStoreLevelConfigs.length==0"><br>{{ \'NO_RECORD_FOUND\' | translate }}.<br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row"><p>&nbsp;</p></div></div><div class="col-md-4 col-lg-4"><p><i class="fa fa-info-circle"></i> <span translate="APPLY_FOR_SELECTED_SUPPLIERS"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddSupplierPanel()"><i class="ion-plus-round"></i><span translate="ADD_SUPPLIER"></span></a><br><br></p><div class="row" ng-if="vm.addSupplierPanelVisible"><div class="col-lg-12"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-lg-6"><b>{{ \'ADD_SUPPLIER\' | translate }}</b></div><div class="col-lg-6"><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" ng-click="vm.closeAddSupplierPanel()"><i class="ion ion-close"></i> {{ \'CLOSE_PANEL\' | translate }}</a></div></div></div><div class="panel-body" style="padding:20px"><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>{{ \'SELECT_A_SUPPLIER\' | translate }}:</b></label><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedSupplierChanged()" ng-options="b as (b.code + \' | \' + b.name | uppercase) for b in vm.supplierList | orderBy:\'code\'" ng-model="vm.selectedSupplier"><option value="">-- {{ \'SELECT_A_SUPPLIER\' | translate }} --</option></select><a href="" class="btn btn-primary btn-with-icon btn-sm pull-right" style="margin-top:3px" ng-click="vm.addSupplier()"><i class="ion-plus-round"></i> {{ \'ADD_SUPPLIER\' | translate }}</a> <a href="" class="btn btn-info btn-with-icon btn-sm pull-right" style="margin-top:3px;margin-right:5px" ng-click="vm.addAllSuppliers()"><i class="ion-plus-round"></i> {{ \'ADD_ALL_SUPPLIERS\' | translate }}</a></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><table class="table table-striped table-hover" style="border:1px solid #ccc"><thead><tr class="sortable"><th><big><b translate="SUPPLIER_NAME"></b></big>&nbsp; <span ng-if="vm.spc.requisitionStorePurchaseSupplierLevelConfigs.length!=0" style="font-weight:normal !important;">({{vm.spc.requisitionStorePurchaseSupplierLevelConfigs.length}} selected)</span> <a class="btn btn-danger editable-table-button btn-with-icon btn-xs pull-right" style="width:110px" ng-if="vm.spc.requisitionStorePurchaseSupplierLevelConfigs.length!=0" confirmed-click="vm.removeAllSuppliers()" ng-confirm-click="Confirm remove all Suppliers?"><i class="fa fa-trash-o"></i> {{ \'REMOVE_ALL\' | translate }}</a></th></tr></thead></table><div style="max-height:485px;overflow:auto"><table class="table table-striped table-hover" style="border:1px solid #ccc"><tbody><tr ng-repeat="ntn in vm.spc.requisitionStorePurchaseSupplierLevelConfigs"><td style="padding-top:10px;padding-bottom:10px;line-height:150%">{{ ntn.supplierName }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%;width:40px"><a class="btn btn-danger editable-table-button btn-xs" style="width:40px" confirmed-click="vm.removeSupplier($index)" ng-confirm-click="Confirm remove this Supplier?"><i class="fa fa-trash-o"></i></a></td></tr><tr><td colspan="7" align="center" ng-show="vm.spc.requisitionStorePurchaseSupplierLevelConfigs.length==0"><br>{{ \'NO_RECORD_FOUND\' | translate }}.<br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row"><p>&nbsp;</p></div></div><div class="col-md-4 col-lg-4"><p><i class="fa fa-info-circle"></i> <span translate="APPLY_FOR_SELECTED_RAWMATS"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddRawMatPanel()"><i class="ion-plus-round"></i><span translate="ADD_RAWMAT"></span></a><br><br></p><div class="row" ng-if="vm.addRawMatPanelVisible"><div class="col-lg-12"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-lg-6"><b>{{ \'ADD_RAWMAT\' | translate }}</b></div><div class="col-lg-6"><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" ng-click="vm.closeAddRawMatPanel()"><i class="ion ion-close"></i> {{ \'CLOSE_PANEL\' | translate }}</a></div></div></div><div class="panel-body" style="padding:20px"><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>Select a Raw Material:</b></label><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedRawMatChanged()" ng-options="b as (b.code + \' | \' + b.description | uppercase) for b in vm.rawmatList | orderBy:\'code\'" ng-model="vm.selectedRawMat"><option value="">-- select a raw material --</option></select><br><div class="row"><div class="col-md-6 col-lg-6"><label><b>Select a UOM:</b></label><div class="input-group"><span class="input-group-addon" style="padding:0px"><i class="fa fa-question-circle" style="padding:3px 10px" uib-tooltip="Store user to order with this UOM" tooltip-placement="auto bottom"></i></span><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedRawMatUomChanged()" ng-options="b as (b.uomName | uppercase) for b in vm.selectedRawMat.uoms | orderBy:\'baseMultiplier\'" ng-model="vm.selectedRawMatUom"><option value="">-- select a UOM --</option></select></div></div></div><br><a href="" class="btn btn-primary btn-with-icon btn-sm pull-right" style="margin-top:3px" ng-click="vm.addRawMat()"><i class="ion-plus-round"></i> Add Raw Material</a> <a href="" class="btn btn-info btn-with-icon btn-sm pull-right" style="margin-top:3px;margin-right:5px" confirmed-click="vm.addAllRawMats()" ng-confirm-click="Are you sure you want to add all items?"><i class="ion-plus-round"></i> Add All Raw Materials</a></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><table class="table table-striped table-hover" style="border:1px solid #ccc"><thead><tr class="sortable"><th><big><b translate="RAW_MAT_NAME"></b></big>&nbsp; <span ng-if="vm.spc.requisitionStorePurchaseItemConfigs.length!=0" style="font-weight:normal !important;">({{vm.spc.requisitionStorePurchaseItemConfigs.length}} selected)</span> <a class="btn btn-danger editable-table-button btn-with-icon btn-xs pull-right" style="width:110px" ng-if="vm.spc.requisitionStorePurchaseItemConfigs.length!=0" confirmed-click="vm.removeAllRawMats()" ng-confirm-click="Confirm remove all Raw Materials?"><i class="fa fa-trash-o"></i> {{ \'REMOVE_ALL\' | translate }}</a></th></tr></thead></table><div style="max-height:485px;overflow:auto"><table class="table table-striped table-hover" style="border:1px solid #ccc"><tbody><tr ng-repeat="ntn in vm.spc.requisitionStorePurchaseItemConfigs"><td style="padding-top:10px;padding-bottom:10px;line-height:150%">{{ ntn.itemName }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%;color:#00f">{{ ntn.uomName }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:150%;width:40px"><a class="btn btn-danger editable-table-button btn-xs" style="width:40px" confirmed-click="vm.removeRawMat($index)" ng-confirm-click="Confirm remove this Raw Material?"><i class="fa fa-trash-o"></i></a></td></tr><tr><td colspan="3" align="center" ng-if="vm.spc.requisitionStorePurchaseItemConfigs.length==0"><br>{{ \'NO_RECORD_FOUND\' | translate }}.<br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row"><p>&nbsp;</p></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/maintenance/storepurchaseconfigs/spcCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/storepurchaseconfigs/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.storepurchaseconfigs.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.storepurchaseconfigs.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/storepurchaseconfigs/spcList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="SPCListing" st-pipe="vm.retrieveData" st-table="vm.spcData" refresh-table=""><thead><tr><th colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.storepurchaseconfigs.create" rms-check-access="maintenance.storepurchaseconfigs" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_CONFIGURATION"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="description">{{ \'DESCRIPTION\' | translate }}</th><th>{{ \'STATUS\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="item in vm.spcData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td><span ng-if="item.isActive" class="text-success"><b>Active</b></span> <span ng-if="!item.isActive" class="text-danger"><b>Inactive</b></span></td><td style="text-align:center"><a href="" title="Clone Config" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#000" confirmed-click="vm.cloneConfig(item.id)" ng-confirm-click="Clone this config [{{item.name}}]?" rms-check-access="maintenance.storepurchaseconfigs" rms-check-access-perm-type="CREATE"><i class="fa fa-copy text-warning"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.storepurchaseconfigs.update({id:item.id})" rms-check-access="maintenance.storepurchaseconfigs" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteConfig(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Configuration?" rms-check-access="maintenance.storepurchaseconfigs" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr><tr ng-show="vm.spcData.length<=0"><td colspan="6" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/storepurchaseconfigs/spcUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/storepurchaseconfigs/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.storepurchaseconfigs.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.storepurchaseconfigs.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/yieldmanagement/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_YIELD_MANAGEMENT_FOR_RAW_MATERIAL_/_SEMI_FINISHED_GOODS_/_FINISHED_GOODS"></span><br><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.RawMaterial.$invalid && vm.dataForm.$submitted}"><label><b translate="SELECT_AN_ORIGINAL_ITEM"></b> <i class="fa fa-asterisk req"></i></label><div style="background:#d8ffd8;margin-bottom:15px"><uib-tabset active="vm.activeTab"><uib-tab heading="{{ \'RAW_MATERIAL\' | translate }}"><div class="form-group"><div class="row"><div class="col-lg-12"><label><b>{{ \'RAW_MATERIAL\' | translate }}</b><br><small><i class="fa fa-info-circle"></i> {{ \'SELECT_RAW_MATERIAL_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small></label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="vm.selectedItem!=null" ng-click="vm.clearSelection()"><i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }}</button><ui-select ng-model="vm.selectedItem" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.selectedItemChanged()" style="background:#fff"><ui-select-match placeholder="{{ \'ENTER_KEYWORD_TO_SEARCH\' | translate }}"><span>{{ $select.selected.description }}</span></ui-select-match><ui-select-choices repeat="i in vm.itemList | filter: $select.search" refresh="vm.loadItemList($select.search)" refresh-delay="500" minimum-input-length="3"><span ng-bind-html="i.description | highlight: $select.search"></span></ui-select-choices></ui-select><p class="help-block" style="color:#f00" ng-show="vm.dataForm.ItemName.$error.required && vm.dataForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p></div></div></div></uib-tab><uib-tab heading="{{ \'SEMI_FINISHED_GOODS\' | translate }}"><div class="form-group"><div class="row"><div class="col-lg-12"><label><b>{{ \'SEMI_FINISHED_GOODS\' | translate }}</b><br><small><i class="fa fa-info-circle"></i> {{ \'SELECT_SEMI_FINISHED_GOODS_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small></label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="vm.selectedSemiFg!=null" ng-click="vm.clearSelection()"><i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }}</button><ui-select ng-model="vm.selectedSemiFg" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.selectedSemiFgChanged()" style="background:#fff"><ui-select-match placeholder="{{ \'ENTER_KEYWORD_TO_SEARCH\' | translate }}"><span>{{ $select.selected.description }}</span></ui-select-match><ui-select-choices repeat="i in vm.semiFgList | filter: $select.search" refresh="vm.loadSemiFgList($select.search)" refresh-delay="500" minimum-input-length="2"><span ng-bind-html="i.description | highlight: $select.search"></span></ui-select-choices></ui-select><p class="help-block" style="color:#f00" ng-show="vm.dataForm.ItemName.$error.required && vm.dataForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p></div></div></div></uib-tab><uib-tab heading="{{ \'FINISHED_GOODS\' | translate }}"><div class="form-group"><div class="row"><div class="col-lg-12"><label><b>{{ \'FINISHED_GOODS\' | translate }}</b><br><small><i class="fa fa-info-circle"></i> {{ \'SELECT_FINISHED_GOODS_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small></label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="vm.selectedProduct!=null" ng-click="vm.clearSelection()"><i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }}</button><ui-select ng-model="vm.selectedProduct" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.selectedProductChanged()" style="background:#fff"><ui-select-match placeholder="{{ \'ENTER_KEYWORD_TO_SEARCH\' | translate }}"><span>{{ $select.selected.name }}</span></ui-select-match><ui-select-choices repeat="i in vm.productList | filter: $select.search" refresh="vm.loadProductList($select.search)" refresh-delay="500" minimum-input-length="2"><span ng-bind-html="i.name | highlight: $select.search"></span></ui-select-choices></ui-select><p class="help-block" style="color:#f00" ng-show="vm.dataForm.ItemName.$error.required && vm.dataForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p></div></div></div></uib-tab></uib-tabset></div><input type="text" name="ItemName" class="form-control" ng-model="vm.mgmt.itemName" required="" ng-hide="true"></div><br></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="IS_TOP_TIER"></b></label><div><toggle ng-model="vm.mgmt.isTopTier" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="Is Active"></b></label><div><toggle ng-model="vm.mgmt.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Quantity.$invalid && (vm.dataForm.Quantity.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity" ng-disabled="vm.isLoading" ng-model="vm.mgmt.quantity" min="1" required=""> <span class="help-block" style="color:#f00" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity.$error.min">* <span translate="MINIMUM_IS_1"></span></span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UOM.$invalid && (vm.dataForm.UOM.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'U.O.M.\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="UOM" class="form-control" style="background:#fffeed" ng-disabled="vm.isLoading" ng-options="i as (i.name | uppercase) for i in vm.uomList" ng-model="vm.selectedUom" ng-change="vm.selectedUomChanged()" required=""></select><p class="help-block" style="color:#f00" ng-show="vm.dataForm.UOM.$error.required && vm.dataForm.$submitted">* {{ \'REQUIRED\' | translate }}</p></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION_/_REMARKS"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Description" ng-model="vm.mgmt.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'YIELD_BREAK_DOWN\' | translate }}" ng-if="vm.selectedItem!=null || vm.selectedSemiFg!=null || vm.selectedProduct!=null"><p><i class="fa fa-info-circle"></i> <span translate="ADD_THE_BREAK-DOWN_RAW_MATERIAL_/_SEMI_FINISHED_GOODS_/_FINISHED_GOODS_AND_THEIR_YIELD_PERCENTAGES"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddItemModal()"><i class="ion-plus-round"></i>{{ \'ADD_ITEM\' | translate }}</a><br><br></p><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th></th><th><b>{{ \'ITEM_CODE\' | translate }}</b></th><th><b>{{ \'ITEM_NAME\' | translate }}</b></th><th><b><span translate="YIELD_PERCENT"></span> (%)</b></th><th class="hide-after" style="text-align:right"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b translate="U.O.M"></b></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="item in vm.mgmt.yieldManagementDetails"><td>{{ $index+1 }})</td><td class="text-center" style="width:80px;line-height:100%"><div class="report-type-tag">{{ item.itemType }}</div></td><td>{{ item.itemCode }}</td><td>{{ item.itemName }}</td><td>{{ item.yieldPercent || 0 | number:2 }} %</td><td style="text-align:right">{{ item.quantity }}</td><td>{{ item.uomName }}</td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditItemModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeItem($index)" ng-confirm-click="Confirm remove this Raw Material?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="10" style="text-align:center" ng-if="!vm.mgmt.yieldManagementDetails || vm.mgmt.yieldManagementDetails.length==0"><br><span translate="ITEM_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="4" style="text-align:right"><b translate="TOTAL_:"></b></td><td><b>{{vm.totalPercentage || 0 | number:2}} %</b></td><td colspan="3"></td></tr></tfoot></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.mgmt.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_YIELD_MANAGEMENT."></span><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br>{{ \'THERE_IS_NO_CHANGES_YET\' | translate }}<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="itemModal.html"><form name="$mdl.itemForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="ITEM"></span></h3> </div> <div class="modal-body" id="modal-body"> <div style="background:#d8ffd8;margin-bottom:15px"> <uib-tabset active="$mdl.activeTab"> <uib-tab heading="{{ \'RAW_MATERIAL\' | translate }}"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <label> <b translate="RAW_MATERIAL"></b> <br /> <small><i class="fa fa-info-circle"></i>&nbsp;{{ \'SELECT_RAW_MATERIAL_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small> </label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="$mdl.selectedItem!=null" ng-click=$mdl.clearSelection()"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> <ui-select ng-model="$mdl.selectedItem" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedItemChanged()" style="background:#fff"> <ui-select-match placeholder="{{ \'ENTER_KEYWORD_TO_SEARCH\' | translate }}"> <span>{{ $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.itemList | filter: $select.search" refresh="$mdl.loadItemList($select.search)" refresh-delay="500" minimum-input-length="3"> <span ng-bind-html="i.description | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p> </div> </div> </div> </uib-tab> <uib-tab heading="{{ \'SEMI_FINISHED_GOODS\' | translate }}"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <label> <b translate="SEMI_FINISHED_GOODS"></b> <br /> <small><i class="fa fa-info-circle"></i>&nbsp;{{ \'SELECT_SEMI_FINISHED_GOODS_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small> </label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="$mdl.selectedSemiFg!=null" ng-click="$mdl.clearSelection()"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> <ui-select ng-model="$mdl.selectedSemiFg" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedSemiFgChanged()" style="background:#fff"> <ui-select-match placeholder="{{ \'ENTER_KEYWORD_TO_SEARCH\' | translate }}"> <span>{{ $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.semiFgList | filter: $select.search" refresh="$mdl.loadSemiFgList($select.search)" refresh-delay="500" minimum-input-length="2"> <span ng-bind-html="i.description | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p> </div> </div> </div> </uib-tab> <uib-tab heading="{{ \'FINISHED_GOODS\' | translate }}"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <label> <b>{{ \'FINISHED_GOODS\' | translate }}</b> <br /> <small><i class="fa fa-info-circle"></i>&nbsp;{{ \'SELECT_FINISHED_GOODS_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small> </label> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" ng-if="$mdl.selectedProduct!=null" ng-click="$mdl.clearSelection()"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> <ui-select ng-model="$mdl.selectedProduct" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedProductChanged()" style="background:#fff"> <ui-select-match placeholder="{{ \'ENTER_KEYWORD_TO_SEARCH\' | translate }}"> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.productList | filter: $select.search" refresh="$mdl.loadProductList($select.search)" refresh-delay="500" minimum-input-length="2"> <span ng-bind-html="i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.productForm.ItemName.$error.required && $mdl.productForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p> </div> </div> </div> </uib-tab> </uib-tabset> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.Percentage.$invalid && ($mdl.itemForm.Percentage.$dirty || $mdl.itemForm.$submitted)}"> <label> <b>{{ \'PERCENTAGE\' | translate }} (%)</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Percentage" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.yieldPercent" min=0.01 required> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Percentage.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Percentage.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Percentage.$error.min">* {{ \'MINIMUM_IS_0.01\' | translate }}%</span> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.Quantity.$invalid && ($mdl.itemForm.Quantity.$dirty || $mdl.itemForm.$submitted)}"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Quantity" ng-disabled="$mdl.lockButtons" ng-model="$mdl.item.quantity" min=0.01 required> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Quantity.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Quantity.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Quantity.$error.min">* {{ \'MINIMUM_IS_0.01\' | translate }}</span> </div> </div> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.UOM.$invalid && ($mdl.itemForm.UOM.$dirty || $mdl.itemForm.$submitted)}"> <label><b>{{ \'U.O.M.\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <select name="UOM" class="form-control" style="background:#fffeed" ng-disabled="$mdl.lockButtons" ng-options="i as (i.name | uppercase) for i in $mdl.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.selectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.UOM.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/maintenance/yieldmanagement/yieldmgmtCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/yieldmanagement/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.yieldmanagement.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/yieldmanagement/yieldmgmtList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="YieldMgmtListing" st-pipe="vm.retrieveData" st-table="vm.mgmtData" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.yieldmanagement.create" rms-check-access="maintenance.yieldmanagement" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="itemName">{{ \'ORIGINAL_ITEM\' | translate }}</th><th st-sort="description">{{ \'DESCRIPTION\' | translate }}</th><th>{{ \'TOP_TIER?\' | translate }}</th><th>{{ \'ACTIVE\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.mgmtData.length==0 && !vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.mgmtData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.itemName}}</td><td>{{item.description}}</td><td><i class="fa fa-check" ng-show="item.isTopTier" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isTopTier" style="color:#f00"></i></td><td><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.yieldmanagement.update({id:item.id})" rms-check-access="maintenance.yieldmanagement" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Sensor" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteRecord(item.id, item.itemName)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Record?" rms-check-access="maintenance.yieldmanagement" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/yieldmanagement/yieldmgmtUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/yieldmanagement/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.yieldmanagement.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.yieldmanagement.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/shippingfees/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="col-md-4 col-lg-4"><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.description.$invalid && (vm.dataForm.description.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'DESCRIPTION\' | translate}}</b>&nbsp; <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="description" ng-model="vm.data.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.salesAmountStart.$invalid && (vm.dataForm.salesAmountStart.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SALES_RANGE_FROM\' | translate}}</b> <i class="fa fa-asterisk req"></i></label><div class="input-group"><span class="input-group-addon">{{ vm.currencyCode }}</span> <input type="text" class="form-control" name="salesAmountStart" ng-model="vm.data.salesAmountStart" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.salesAmountStart.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.salesAmountEnd.$invalid && (vm.dataForm.salesAmountEnd.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SALES_RANGE_TO\' | translate}}</b> <i class="fa fa-asterisk req"></i></label><div class="input-group"><span class="input-group-addon">{{ vm.currencyCode }}</span> <input type="text" class="form-control" name="salesAmountEnd" ng-model="vm.data.salesAmountEnd" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.salesAmountEnd.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.feeAmount.$invalid && (vm.dataForm.feeAmount.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'FEE\' | translate}}</b> <i class="fa fa-asterisk req"></i></label><div class="input-group"><span class="input-group-addon">{{ vm.currencyCode }}</span> <input type="text" class="form-control" name="feeAmount" ng-model="vm.data.feeAmount" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.feeAmount.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group"><label><b>{{ \'IS_ACTIVE\' | translate }} ?</b></label><div><toggle ng-model="vm.data.active" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-4 col-lg-4"><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.taxCode.$invalid && (vm.dataForm.taxCode.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'TAX_CODE\' | translate}}</b>&nbsp; <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="taxCode" ng-model="vm.data.taxCode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.taxCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.taxPercentage.$invalid && (vm.dataForm.taxPercentage.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'TAX_PERCENTAGE\' | translate}}&nbsp;%</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="taxPercentage" ng-model="vm.data.taxPercentage" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.taxPercentage.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.taxAmount.$invalid && (vm.dataForm.taxAmount.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'TAX_AMOUNT\' | translate}}</b> <i class="fa fa-asterisk req"></i></label><div class="input-group"><span class="input-group-addon">{{ vm.currencyCode }}</span> <input type="text" class="form-control" name="taxAmount" ng-model="vm.data.taxAmount" ng-disabled="true" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.taxAmount.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.taxAmount.$invalid && (vm.dataForm.taxAmount.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'FEE_AFTER_TAX\' | translate}}</b> <i class="fa fa-asterisk req"></i></label><div class="input-group"><span class="input-group-addon">{{ vm.currencyCode }}</span> <input type="text" class="form-control" name="feeAfterTax" ng-model="vm.feeAfterTax" ng-disabled="true" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.taxAmount.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></uib-tab><uib-tab heading="{{ \'DEBTORS\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="ASSOCIATE_RELEVANT_DEBTORS_TO_THIS_SHIPPING_FEE"></span>. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddDebtorModal()"><i class="ion-plus-round"></i> <span translate="ADD_DEBTOR"></span></a><br><br></p><div class="row" ng-show="vm.mode==2"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="font-size:90%;border:1px solid #ccc" st-pipe="vm.refreshDebtors" st-table="vm.data.debtors" refresh-table=""><thead><tr><th style="width:60px">#</th><th><b translate="DEBTOR_CODE"></b></th><th><b translate="DEBTOR_NAME"></b></th><th style="width:65px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.data.debtors"><td>{{ $index+1 }})</td><td>{{ ntn.code || \'\' }}</td><td>{{ ntn.name || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeDebtor(ntn.id)" ng-confirm-click="Confirm remove this Debtor?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="4" align="center" ng-show="vm.data.debtors.length==0"><br><span translate="DEBTOR_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center><span translate="PLEASE_SAVE_THE_SHIPPING_FEE_FIRST_BEFORE_ADDING_DEBTORS"></span>.</center></h2></div></div></uib-tab><uib-tab heading="{{ \'AUTOCOUNT\' | translate }}" ng-if="vm.integrationMode==2"><div class="col-md-4 col-lg-4"><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.autoCount_ItemCode.$invalid && (vm.dataForm.autoCount_ItemCode.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'ITEM_CODE\' | translate}}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="autoCount_ItemCode" ng-model="vm.data.autoCount_ItemCode"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.autoCount_ItemCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.autoCount_ItemType.$invalid && (vm.dataForm.autoCount_ItemType.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select name="autoCount_ItemType" class="form-control" ng-change="vm.selectedItemTypeChanged()" ng-model="vm.selectedItemType" ng-options="i as i.description for i in vm.autoCount_itemTypes" ng-required="vm.integrationMode==2"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.autoCount_ItemType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-4 col-lg-4"><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.autoCount_ItemGroup.$invalid && (vm.dataForm.autoCount_ItemGroup.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_GROUP"></b> <i class="fa fa-asterisk req"></i></label><select name="autoCount_ItemGroup" class="form-control" ng-change="vm.selectedItemGroupChanged()" ng-model="vm.selectedItemGroup" ng-options="i as i.description for i in vm.autoCount_itemGroups" ng-required="vm.integrationMode==2"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.autoCount_ItemGroup.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.autoCount_ItemUom.$invalid && (vm.dataForm.autoCount_ItemUom.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_UOM"></b> <i class="fa fa-asterisk req"></i></label><select name="autoCount_ItemUom" class="form-control" ng-change="vm.selectedUomChanged()" ng-model="vm.selectedUom" ng-options="i as (i.name | uppercase) for i in vm.uomList" ng-required="vm.integrationMode==2"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.autoCount_ItemUom.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></uib-tab><uib-tab heading="{{ \'SQL\' | translate }}" ng-if="vm.integrationMode==8"><div class="col-md-4 col-lg-4"><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.autoCount_ItemCode.$invalid && (vm.dataForm.sqL_ItemCode.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'ITEM_CODE\' | translate}}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="sqL_ItemCode" ng-model="vm.data.sqL_ItemCode"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.sqL_ItemCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.sqL_ItemUom.$invalid && (vm.dataForm.sqL_ItemUom.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_UOM"></b> <i class="fa fa-asterisk req"></i></label><select name="sqL_ItemUom" class="form-control" ng-change="vm.selectedSQLUomChanged()" ng-model="vm.selectedUom" ng-options="i as (i.name | uppercase) for i in vm.uomList" ng-required="vm.integrationMode==8"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.sqL_ItemUom.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-4 col-lg-4"><div class="row"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.sqL_ItemGroup.$invalid && (vm.dataForm.sqL_ItemGroup.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_GROUP"></b> <i class="fa fa-asterisk req"></i></label><select name="sqL_ItemGroup" class="form-control" ng-change="vm.selectedSQLItemGroupChanged()" ng-model="vm.selectedSQLItemGroup" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sql_itemGroups" ng-required="vm.integrationMode==8"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.sqL_ItemGroup.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="DebtorModal.html"><form name="$mdl.debtorForm" ng-submit="$mdl.searchDebtor()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="SELECT_DEBTOR"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SEARCH_DEBTOR"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <div class="row"> <div class="col-lg-6"> <input type="text" name="SearchText" class="form-control" placeholder="{{\'ENTER_KEYWORD_TO_SEARCH\'|translate}}" ng-model="$mdl.searchText" min=3 required /> </div> <div class="col-lg-6" style="display:flex; align-items:center; justify-content:space-between;padding-right:60px;"> <button type="submit" class="btn btn-default btn-with-icon"> <i class="fa fa-search"></i> {{ \'SEARCH\' | translate}} </button> <input type="checkbox" style="background:#fffff4;width:20px;height:20px" ng-model="$mdl.checkAll" ng-change="$mdl.toggleCheckAll()" /> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.debtorForm.SearchText.$error.min && $mdl.debtorForm.$submitted">* {{ \'ENTER_MINIMUM_3_LETTERS\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.debtorForm.SearchText.$error.required && $mdl.debtorForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div style="max-height:400px;overflow-y:scroll"> <table class="table table-striped" style="font-size:90%;border:1px solid #ccc" st-pipe="$mdl.refreshDebtors" st-table="$mdl.debtorList" refresh-table> <thead> <tr> <th style="width:60px">#</th> <th><b translate="DEBTOR_CODE"></b></th> <th><b translate="DEBTOR_NAME"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="ntn in $mdl.debtorList"> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ $index+1 }})</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.code || \'\' }}</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.name || \'\' }}</td> <td style="line-height:130%;padding-top:4px;padding-bottom:8px"> <input type="checkbox" name="chkSelect" style="background:#fffff4;width:20px;height:20px" checklist-model="$mdl.selectedDebtors" checklist-value="ntn" checklist-change="$mdl.debtorForm.chkSelect.$setValidity(\'required\', $mdl.selectedDebtors.length > 0)" ng-required="!$mdl.selectedDebtors.length" /> <!-- <a href class="btn btn-primary editable-table-button btn-with-icon btn-xs" ng-disabled="$mdl.lockButton" ng-click="$mdl.confirmModal(ntn)"> <i class="ion ion-checkmark"></i> <span translations="SELECT""></span> </a> --> </td> </tr> <tr> <td colspan="4" align="center" ng-show="$mdl.debtorList.length==0"> <br /> <span translate="DEBTOR_LIST_IS_EMPTY"></span>. <br />&nbsp; </td> </tr> </tbody> </table> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" style="color:#000"> <span translate="SELECTED"></span>: <b>{{$mdl.selectedDebtors.length}}</b> </div> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.confirmModal()"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/maintenance/shippingfees/shippingfeeCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/shippingfees/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_SHIPPING_FEE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.shippingfees.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/shippingfees/shippingfeeList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="ShippingFeeListing" st-pipe="vm.retrieveData" st-table="vm.data"><thead><tr><th colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.shippingfees.create" rms-check-access="maintenance.shippingfees" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> {{ \'ADD_NEW\' | translate }}</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="description">{{ "DESCRIPTION" | translate }}</th><th>{{ "SALES_RANGE_FROM" | translate }}&nbsp;&#10088;{{ "INCLUSIVE" | translate }}&#10089;</th><th>{{ "SALES_RANGE_TO" | translate }}&nbsp;&#10088;{{ "INCLUSIVE" | translate }}&#10089;</th><th>{{ "FEE" | translate }}</th><th>{{ "FEE_AFTER_TAX" | translate }}</th><th>{{ "DEBTOR" | translate }}</th><th>{{ "ACTIVE" | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline"><input st-search="description" class="form-control input input-sm"></th><th class="form-inline"><input st-search="salesAmountFrom" class="form-control input input-sm"></th><th class="form-inline"><input st-search="salesAmountTo" class="form-control input input-sm"></th><th class="form-inline"><input st-search="feeAmount" class="form-control input input-sm"></th><th class="form-inline"><input st-search="feeAfterTax" class="form-control input input-sm"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-show="vm.data.length<=0 && !vm.isLoading"><td colspan="8" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="8" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td>{{item.description}}</td><td>{{vm.currencyCode}}&nbsp;{{item.salesAmountStart | number:2}}</td><td>{{vm.currencyCode}}&nbsp;{{item.salesAmountEnd | number:2}}</td><td>{{vm.currencyCode}}&nbsp;{{item.feeAmount | number:2}}</td><td>{{vm.currencyCode}}&nbsp;{{item.feeAfterTax | number:2}}</td><td><a href="" title="View Debtor List" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ng-click="vm.showViewDebtorModal(item.id)"><i class="fa fa-file-text"></i></a></td><td><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.shippingfees.update({id:item.id})" rms-check-access="maintenance.shippingfees" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Shipping Fee" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteItem(item.id, item.description)" ng-confirm-click="Confirm delete this Shipping Fee?" rms-check-access="maintenance.shippingfees" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.data.length }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="DebtorModal.html"><form name="$mdl.debtorForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="DEBTOR_LIST"></span><span>&nbsp;&#40;{{ $mdl.description }}&#41;</span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div style="max-height:400px;overflow-y:scroll"> <table class="table table-striped" style="font-size:90%;border:1px solid #ccc" st-pipe="$mdl.refreshDebtors" st-table="$mdl.debtorList" refresh-table> <thead> <tr> <th style="width:60px">#</th> <th><b translate="DEBTOR_CODE"></b></th> <th><b translate="DEBTOR_NAME"></b></th> </tr> </thead> <tbody> <tr ng-repeat="ntn in $mdl.debtorList"> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ $index+1 }})</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.code || \'\' }}</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.name || \'\' }}</td> </tr> <tr> <td colspan="3" align="center" ng-show="$mdl.debtorList.length==0"> <br /> <span translate="DEBTOR_LIST_IS_EMPTY"></span>. <br />&nbsp; </td> </tr> </tbody> </table> </div> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> {{ \'CLOSE\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/maintenance/shippingfees/shippingfeeUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/shippingfees/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:20px" ui-sref="maintenance.shippingfees.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.shippingfees.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/purchaseorders/polist/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-show="vm.originalStatus.toUpperCase()==\'NEW\'"><small><em><i class="fa fa-info-circle"></i> <span translate="FILL_IN_THE_PURCHASE_ORDER_DETAILS"></span></em></small></p><p ng-show="vm.originalStatus.toUpperCase()!=\'NEW\'"><small><i class="fa fa-exclamation-triangle text-warning"></i> <span translate="ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="NEW"></b></small></p><br><div class="row"><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px"><span translate="PURCHASE_ORDER_DETAILS"></span></legend><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b><span translate="PURCHASE_ORDER_NO"></span>.</b></label> <span class="form-control" style="color:#00f">{{vm.po.purchaseOrderNo || \'AUTONUMBER\' | translate }}</span><div ng-if="vm.po.autocountPurchaseInvoiceNo!=null && vm.po.autocountPurchaseInvoiceNo!=\'\'" style="margin-left:5px;color:#00f"><small>(Purchase Invoice No: <b>{{vm.po.autocountPurchaseInvoiceNo}}</b>)</small></div><div ng-if="vm.po.originalDocNo!=null && vm.po.originalDocNo!=\'\'" style="margin-left:5px;color:#00f"><small>(Original Ref: <b>{{vm.po.originalDocNo}}</b>)</small></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PoDate.$invalid && (vm.dataForm.PoDate.$dirty || vm.dataForm.$submitted)}"><label><b translate="PURCHASE_ORDER_DATE"></b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.po.purchaseOrderDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="PoDate" autocomplete="off" ng-model="vm.po.purchaseOrderDate" ng-disabled="vm.originalStatus.toUpperCase()!=\'NEW\'" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PoDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label for="Status"><b translate="PURCHASE_ORDER_STATUS"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Status" style="color:#333" ng-disabled="vm.originalStatus.toUpperCase()!=\'NEW\'" ng-options="u as (u.name | uppercase | translate | uppercase) for u in vm.poStatuses track by u.id" ng-model="vm.poStatuses.selected"><option value="">{{vm.poStatuses.selected ? "" : vm.po.status.toUpperCase()}}</option></select></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeliveryDate.$invalid && (vm.dataForm.DeliveryDate.$dirty || vm.dataForm.$submitted)}"><label><b translate="DELIVERY_DATE"></b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.po.deliveryDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="DeliveryDate" autocomplete="off" ng-model="vm.po.deliveryDate" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\')|| vm.originalStatus.toUpperCase() == \'APPROVED\' || vm.originalStatus.toUpperCase() == \'CANCELLED\'" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeliveryDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b translate="DEPARTMENT"></b></label><select class="form-control" name="Department" style="color:#333" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'APPROVED\' || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-options="u as u.name for u in vm.departments track by u.id" ng-model="vm.departments.selected"><option value="">{{vm.departments.selected ? "" : "-"}}</option></select></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" style="color:#333" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.remarks">\n\t\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></div><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px"><span translate="SUPPLIER"></span> <a href="" class="btn btn-primary btn-with-icon btn-xs" style="margin:5px" ng-click="vm.showSelectSupplier=true" ng-disabled="vm.lockButtons" ng-show="vm.originalStatus.toUpperCase()==\'NEW\' && !vm.showSelectSupplier"><i class="ion ion-android-checkmark-circle"></i> <span translate="SELECT_SUPPLIER"></span></a></legend><div class="row" ng-show="vm.showSelectSupplier"><div class="col-md-12 col-lg-12"><div class="form-group" style="padding:10px;background:#fffc00"><label><b translate="SELECT_A_SUPPLIER"></b><br><small><i class="fa fa-warning"></i> <span translate="SELECTING_A_NEW_SUPPLIER_WILL_OVERWRITE_THE_VALUES_IN_THE_FIELDS_BELOW"></span>.</small></label><div class="row"><div class="col-lg-3" style="padding-right:0px"><div class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-search"></i></span> <input class="form-control" ng-model="vm.supplierSearch"></div></div><div class="col-lg-9"><select class="form-control" name="Department" style="color:#333" ng-disabled="vm.originalStatus.toUpperCase()!=\'NEW\'" ng-change="vm.setSelectedSupplier()" ng-options="u as (u.name | uppercase) for u in vm.supplierList | filter: vm.supplierSearch" ng-model="vm.supplierList.selected"><option value="">-- {{ \'SELECT_A_SUPPLIER\' | translate | uppercase }} --</option></select></div></div><div><a href="" class="btn btn-danger btn-with-icon btn-sm pull-right" style="margin-top:5px" ng-click="vm.cancelSelectSupplier()"><i class="fa fa-times"></i> {{ \'CANCEL\' | translate }}</a> <a href="" class="btn btn-success btn-with-icon btn-sm pull-right" style="margin-top:5px;margin-right:10px" ng-click="vm.selectSupplier()"><i class="fa fa-check"></i> <span translate="SELECT"></span></a><br style="clear:both"></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b translate="SUPPLIER_CODE"></b></label> <span class="form-control" ng-disabled="true">{{ vm.po.supplierCode }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SupplierName.$invalid && (vm.dataForm.SupplierName.$dirty || vm.dataForm.$submitted)}"><label><b translate="SUPPLIER_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="SupplierName" class="form-control" ng-disabled="true" ng-model="vm.po.supplierName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SupplierName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b <span="" translate="ADDRESS_1">></b></label> <input type="text" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.supplierAddress1"></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b <span="" translate="ADDRESS_2">></b></label> <input type="text" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.supplierAddress2"></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b <span="" translate="ADDRESS_3">></b></label> <input type="text" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.supplierAddress3"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="STATE"></b></label> <input type="text" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.supplierState"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="POSTAL_CODE"></b></label> <input type="text" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.supplierPostCode"></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b translate="COUNTRY"></b></label> <input type="text" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.supplierCountry"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="TELEPHONE"></b></label> <input type="text" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.supplierTel"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="FAX"></b></label> <input type="text" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.supplierFax"></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></div><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px"><span translate="SHIP_TO"></span> ({{ \'BRANCH\' | translate }}) <a href="" class="btn btn-primary btn-with-icon btn-xs" style="margin:5px" ng-click="vm.showSelectBranch=true" ng-disabled="vm.lockButtons" ng-show="vm.originalStatus.toUpperCase()==\'NEW\' && !vm.showSelectBranch"><i class="ion ion-android-checkmark-circle"></i> <span translate="SELECT_BRANCH"></span></a></legend><div class="row" ng-show="vm.showSelectBranch"><div class="col-md-12 col-lg-12"><div class="form-group" style="padding:10px;background:#fffc00"><label><b translate="SELECT_A_BRANCH"></b><br><small><i class="fa fa-warning"></i> <span translate="SELECTING_A_NEW_BRANCH_WILL_OVERWRITE_THE_VALUES_IN_THE_FIELDS_BELOW"></span>.</small></label><div class="row"><div class="col-lg-3" style="padding-right:0px"><div class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-search"></i></span> <input class="form-control" ng-model="vm.branchSearch"></div></div><div class="col-lg-9"><select class="form-control" style="color:#333" ng-disabled="vm.originalStatus.toUpperCase()!=\'NEW\'" ng-options="u as (u.name | uppercase) for u in vm.branchList | filter: vm.branchSearch" ng-model="vm.selectedBranch"><option value="">-- {{ \'SELECT_A_BRANCH\' | translate | uppercase }} --</option></select></div></div><div><a href="" class="btn btn-danger btn-with-icon btn-sm pull-right" style="margin-top:5px" ng-click="vm.cancelSelectBranch()"><i class="fa fa-times"></i> {{ \'CANCEL\' | translate }}</a> <a href="" class="btn btn-success btn-with-icon btn-sm pull-right" style="margin-top:5px;margin-right:10px" ng-click="vm.selectBranch()"><i class="fa fa-check"></i> <span translate="SELECT"></span></a><br style="clear:both"></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BranchName.$invalid && (vm.dataForm.BranchName.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'BRANCH_NAME\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="BranchName" class="form-control" ng-model="vm.po.shipToBranchName" ng-disabled="true" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BranchName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b translate="CONTACT_PERSON"></b></label> <input type="text" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.shipToContactPerson"></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ShipToAddress1.$invalid && (vm.dataForm.ShipToAddress1.$dirty || vm.dataForm.$submitted)}"><label><b <span="" translate="ADDRESS_1">></b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="ShipToAddress1" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.shipToAddress1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ShipToAddress1.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b <span="" translate="ADDRESS_2">></b></label> <input type="text" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.shipToAddress2"></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b <span="" translate="ADDRESS_3">></b></label> <input type="text" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.shipToAddress3"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ShipToState.$invalid && (vm.dataForm.ShipToState.$dirty || vm.dataForm.$submitted)}"><label><b translate="STATE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="ShipToState" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.shipToState" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ShipToState.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ShipToPostCode.$invalid && (vm.dataForm.ShipToPostCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="POSTAL_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="ShipToPostCode" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.shipToPostCode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ShipToPostCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ShipToCountry.$invalid && (vm.dataForm.ShipToCountry.$dirty || vm.dataForm.$submitted)}"><label><b translate="COUNTRY"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="ShipToCountry" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.shipToCountry" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ShipToCountry.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ShipToTel.$invalid && (vm.dataForm.ShipToTel.$dirty || vm.dataForm.$submitted)}"><label><b translate="TELEPHONE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="ShipToTel" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.shipToTel" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ShipToTel.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="FAX"></b></label> <input type="text" class="form-control" ng-disabled="vm.originalStatus.toUpperCase().includes(\'COMPLETED\') || vm.originalStatus.toUpperCase() == \'CANCELLED\'" ng-model="vm.po.shipToFax"></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></div></div></uib-tab><uib-tab heading="{{ \'ITEM_LIST\' | translate }}"><p ng-show="vm.originalStatus.toUpperCase()==\'NEW\' || vm.hasApprovedAccess"><small><i class="fa fa-info-circle"></i>&nbsp; <span translate="MANAGE_ITEMS_ON_THE_LIST"></span></small> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddItemModal()" ng-show="vm.po.supplierId!=\'\' && vm.po.supplierId!=null" ng-if="vm.originalStatus.toUpperCase()==\'NEW\' || vm.originalStatus.toUpperCase()==\'CONFIRMED\' || vm.originalStatus.toUpperCase()==\'APPROVED\' && vm.hasApprovedAccess"><i class="ion-plus-round"></i> {{ \'ADD_ITEM\' | translate }}</a><br></p><p ng-show="vm.originalStatus.toUpperCase()!=\'NEW\'"><small><i class="fa fa-exclamation-triangle text-warning"></i> <span translate="ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="NEW"></b>.</small><br><br></p><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:1px solid #ccc;font-size:90%" st-table="vm.po.purchaseOrderItems" refresh-table=""><thead><tr><th style="width:60px"><b>#</b></th><th><b translate="ITEM_DESCRIPTION"></b></th><th style="text-align:right"><b><span translate="QUANTITY"></span><br><small translate="ORDERED"></small></b></th><th style="text-align:right;color:#00f" ng-if="vm.originalStatus.toUpperCase()!=\'NEW\'"><b><span translate="QUANTITY"></span><br><small translate="FULFILLED"></small></b></th><th style="text-align:right;color:#f00" ng-if="vm.originalStatus.toUpperCase()!=\'NEW\'"><b><span translate="QUANTITY"></span><br><small translate="WRITE-OFF"></small></b></th><th><b translate="UOM"></b></th><th style="text-align:center"><b>{{ \'TAX_CODE\' | translate }}</b></th><th style="text-align:right"><b><span translate="UNIT_PRICE"></span><br>({{ vm.selectedSupplier.currencyCode || \'-\'}})</b></th><th style="text-align:right"><b><span translate="SUBTOTAL"></span><br>({{ vm.selectedSupplier.currencyCode || \'-\'}})</b></th><th style="text-align:right"><b><span translate="SALES_TAX"></span><br>({{ vm.selectedSupplier.currencyCode || \'-\'}})</b></th><th style="text-align:right"><b><span translate="TOTAL_INC."></span> <span translate="TAX"></span><br>({{ vm.selectedSupplier.currencyCode || \'-\'}})</b></th><th style="width:30px"></th><th><b>{{ \'REMARKS\' | translate }}</b></th><th style="width:40px" ng-if="vm.originalStatus.toUpperCase()==\'NEW\' || (vm.originalStatus.toUpperCase().indexOf(\'COMPLETED\')==-1 && vm.hasApprovedAccess)"></th><th style="width:40px" ng-if="vm.originalStatus.toUpperCase()==\'NEW\' || (vm.originalStatus.toUpperCase().indexOf(\'COMPLETED\')==-1 && vm.hasApprovedAccess)"></th></tr><tr><th></th><th><div><div class="search-input"><span class="fa fa-search"></span> <input ng-model="vm.searchText" type="search" class="input-sm form-control"></div></div></th><th></th><th colspan="2" ng-if="vm.originalStatus.toUpperCase()!=\'NEW\'"></th><th colspan="8"></th><th style="width:40px" ng-if="vm.originalStatus.toUpperCase()==\'NEW\' || (vm.originalStatus.toUpperCase().indexOf(\'COMPLETED\')==-1 && vm.hasApprovedAccess)"></th><th style="width:40px" ng-if="vm.originalStatus.toUpperCase()==\'NEW\' || (vm.originalStatus.toUpperCase().indexOf(\'COMPLETED\')==-1 && vm.hasApprovedAccess)"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.po.purchaseOrderItems | filter:vm.searchText" ng-if="!ntn.isDeleted"><td>{{ $index+1 }})</td><td style="line-height:110%;padding-top:6px;padding-bottom:6px;"><small style="color:#777">{{ ntn.item.code }}</small><br>{{ ntn.item.description || \'\' }}</td><td style="text-align:right">{{ ntn.quantity | number }}</td><td style="text-align:right;color:#00f" ng-if="vm.originalStatus.toUpperCase()!=\'NEW\'">{{ ntn.quantityFulfilled | number }}</td><td style="text-align:right;color:#f00" ng-if="vm.originalStatus.toUpperCase()!=\'NEW\'">{{ ntn.quantityWriteOff | number }}</td><td>{{ ntn.unitOfMeasurement.name }}</td><td style="text-align:center">{{ ntn.taxCode }}</td><td style="text-align:right">{{ ntn.cost | number:3 }}</td><td style="text-align:right">{{ ntn.subtotal | currency:"" }}</td><td style="text-align:right">{{ ntn.tax | currency:"" }}</td><td style="text-align:right">{{ ntn.subtotalIncTax | currency:"" }}</td><td></td><td>{{ ntn.remarks }}</td><td ng-if="vm.originalStatus.toUpperCase()==\'NEW\' || (vm.originalStatus.toUpperCase().indexOf(\'COMPLETED\')==-1 && vm.hasApprovedAccess)"><a class="btn btn-primary editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditItemModal(ntn.id)" ng-if="vm.originalStatus.toUpperCase()==\'NEW\' || (vm.originalStatus.toUpperCase().indexOf(\'COMPLETED\')==-1 && vm.originalStatus.toUpperCase()!=\'CANCELLED\' && vm.hasApprovedAccess)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td ng-if="vm.originalStatus.toUpperCase()==\'NEW\' || (vm.originalStatus.toUpperCase().indexOf(\'COMPLETED\')==-1 && vm.hasApprovedAccess)"><a class="btn btn-danger editable-table-button btn-xs" style="width:80px" confirmed-click="vm.markAsDelete($index, ntn.id)" ng-confirm-click="Confirm remove this Item?" ng-if="!ntn.isReceived && (vm.originalStatus.toUpperCase()==\'NEW\' || (vm.originalStatus.toUpperCase().indexOf(\'COMPLETED\')==-1 && vm.originalStatus.toUpperCase()!=\'CANCELLED\' && vm.hasApprovedAccess))"><i class="fa fa-trash-o"></i> &nbsp;{{ \'REMOVE\' | translate }}</a></td></tr><tr><td colspan="15" align="center" ng-show="vm.po.purchaseOrderItems.length==0"><br><span translate="ITEM_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="3"><span translate="TOTAL_ITEMS"></span>: <b>{{vm.po.purchaseOrderItems.length}}</b></td><td colspan="2" align="right" ng-if="vm.originalStatus.toUpperCase()==\'NEW\'"><b translate="TOTAL_AMOUNT">(<span translate="RM"></span>)</b></td><td colspan="4" align="right" ng-if="vm.originalStatus.toUpperCase()!=\'NEW\'"><b><span translate="TOTAL_AMOUNT"></span> (<span translate="RM"></span>)</b></td><td></td><td align="right"><b>{{ vm.subTotalTotal | currency:"" }}</b></td><td align="right"><b>{{ vm.gstTotal | currency:"" }}</b></td><td align="right"><b>{{ vm.totalIncGstTotal | currency:"" }}</b></td><td>&nbsp;</td><td>&nbsp;</td><td ng-if="vm.originalStatus.toUpperCase()==\'NEW\' || (vm.originalStatus.toUpperCase().indexOf(\'COMPLETED\')==-1 && vm.hasApprovedAccess)">&nbsp;</td><td ng-if="vm.originalStatus.toUpperCase()==\'NEW\' || (vm.originalStatus.toUpperCase().indexOf(\'COMPLETED\')==-1 && vm.hasApprovedAccess)">&nbsp;</td></tr></tfoot></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.po.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_PURCHASE_ORDER"></span>.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br><span translate="THERE_IS_NO_CHANGES_YET"></span>.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="emailModal.html"><form name="$mdl.itemForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ \'EMAIL_PURCHASE_ORDER_TO_SUPPLIER\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.TO.$invalid && ($mdl.itemForm.TO.$dirty || $mdl.itemForm.$submitted)}"> <label> <span translate="TO"></span> <i class="fa fa-asterisk req"></i></label><br /> <small><em><i class="fa fa-info-circle"></i> <span translations="UPPLIER\'S_EMAIL_ADDRESS"></span></em></small><br /> <input type="text" class="form-control" name="TO" style="background:#fffeed" ng-model="$mdl.template.to" required /> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.TO.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label>{{ \'CC\' | translate }}</label><br /> <small><em><i class="fa fa-info-circle"></i> {{ \'SEPARATE_EACH_EMAIL_ADDRESS_USING_SEMI-COLON\' | translate }} (;)</em></small><br /> <input type="text" class="form-control" name="CC" style="background:#fffeed" ng-model="$mdl.template.cc" /> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label translations="BCC"></label><br /> <small><em><i class="fa fa-info-circle"></i> {{ \'SEPARATE_EACH_EMAIL_ADDRESS_USING_SEMI-COLON\' | translate }} (;)</em></small><br /> <input type="text" class="form-control" name="BCC" style="background:#fffeed" ng-model="$mdl.template.bcc" /> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label translate="REPLY-TO"></label><br /> <small><em><i class="fa fa-info-circle"></i> <span translate="THE_EMAIL_ADDRESS_THAT_RECIPIENT_WILL_REPLY_TO"></span></em></small><br /> <input type="text" class="form-control" name="ReplyTo" style="background:#fffeed" ng-model="$mdl.template.replyTo" /> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.Subject.$invalid && ($mdl.itemForm.Subject.$dirty || $mdl.itemForm.$submitted)}"> <label>{{ \'SUBJECT\' | translate }} <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Subject" style="background:#fffeed" ng-model="$mdl.template.subject" required /> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Subject.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.EmailContent.$invalid && ($mdl.itemForm.EmailContent.$dirty || $mdl.itemForm.$submitted)}"> <label> {{ \'EMAIL_CONTENT\' | translate }} <i class="fa fa-asterisk req"></i></label> <!-- <trix-editor angular-trix name="EmailContent" ng-if="true" ng-model="$mdl.template.content" required> </trix-editor> --> <div text-angular ng-model="$mdl.template.content" style="height:500px;overflow:auto"> </div> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.EmailContent.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> </div> <div class="modal-footer"> <a type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="mdl.lockButtons" confirmed-click="$mdl.confirmModal()" ng-confirm-click="Confirm send email?"> <i class="fa fa-envelope"></i> <span translate="SEND_EMAIL"></span> </a> <a class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="mdl.lockButtons"> <i class="fa fa-times"></i> {{ \'CANCEL\' | translate }} </a> </div> </form></script><script type="text/ng-template" id="itemModal.html"><form name="$mdl.itemForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="RAW_MATERIAL"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.Item.$invalid && ($mdl.itemForm.Item.$dirty || $mdl.itemForm.$submitted)}"> <label><b>{{ \'SELECT_A_RAW_MATERIAL\' | translate }}</b></label> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.itemSearch" /> </div> </div> <div class="col-lg-9"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.Item.$invalid && (vm.dataForm.Item.$dirty || vm.dataForm.$submitted)}"> <select class="form-control" name="Item" style="background:#fffeed;color:#333" ng-change="$mdl.onSelectedItemChanged()" ng-options="u as (u.description | uppercase) for u in $mdl.itemList | filter: $mdl.itemSearch" ng-model="$mdl.selectedItem" required> <option value="">-- {{ \'SELECT_A_RAW_MATERIAL\' | translate | uppercase }} --</option> </select> <span class="help-block" style="color:#f00" ng-show="vm.dataForm.$submitted && vm.dataForm.Item.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.Item.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> <div class="row"> <div class="col-lg-4"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.Quantity.$invalid && ($mdl.itemForm.Quantity.$dirty || $mdl.itemForm.$submitted)}"> <label><b><span translate="QUANTITY"></span></b></label> <input type="number" name="Quantity" class="form-control" style="background:#fffeed" ng-model="$mdl.item.quantity" min="0.01" step="1" required ng-change="$mdl.onQuantityChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.Quantity.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.Quantity.$error.number && $mdl.itemForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> </div> </div> <div class="col-lg-4"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.UOM.$invalid && ($mdl.itemForm.UOM.$dirty || $mdl.itemForm.$submitted)}"> <label><b><span translate="UOM"></span></b></label> <select name="UOM" class="form-control" style="background:#fffeed" ng-options="i as (i.uomName | uppercase) for i in $mdl.priceList" ng-model="$mdl.selectedPrice" ng-change="$mdl.onSelectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.UOM.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> <div class="col-lg-4"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.Cost.$invalid && ($mdl.itemForm.Cost.$dirty || $mdl.itemForm.$submitted)}"> <label><b><span translate="UNIT_PRICE"></span> ({{$mdl.currencyCode}})</b></label> <input type="number" name="Cost" class="form-control" style="background:#fffeed" ng-model="$mdl.item.cost" min="0" step="1" ng-change="$mdl.onCostChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.Cost.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.Cost.$error.number && $mdl.itemForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.Cost.$error.min && $mdl.itemForm.$submitted">* {{ \'MINIMUM_IS_0\' | translate }}</p> </div> </div> </div> <br /> <div class="form-group"> <div class="row"> <div class="col-lg-4"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.TaxCode.$invalid && ($mdl.itemForm.TaxCode.$dirty || $mdl.itemForm.$submitted)}"> <label><b>{{ \'TAX_CODE\' | translate }}</b></label> <input type="text" name="TaxCode" class="form-control" style="background:#fffeed" ng-model="$mdl.item.taxCode" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.TaxCode.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> <div class="col-lg-4"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.TaxPercent.$invalid && ($mdl.itemForm.TaxPercent.$dirty || $mdl.itemForm.$submitted)}"> <label><b> {{ \'SALES_TAX_PERCENT\' | translate }} (%)</b></label> <input type="number" name="TaxPercent" class="form-control" style="background:#fffeed" ng-model="$mdl.item.taxPercent" min=0 required ng-change="$mdl.onTaxPercentChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.TaxPercent.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.TaxPercent.$error.number && $mdl.itemForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.TaxPercent.$error.min && $mdl.itemForm.$submitted">* {{ \'MINIMUM_IS_0\' | translate }}</p> </div> </div> </div> </div> <br /> <div class="row"> <div class="col-lg-4"> <div class="form-group"> <label><b><span translate="SUBTOTAL"></span> ({{$mdl.currencyCode}})</b></label> <span class="form-control" ng-disabled="true"> <b>{{ $mdl.item.subtotal | currency: "" }}</b> </span> </div> </div> <div class="col-lg-4"> <div class="form-group"> <label><b><span translate="SALES_TAX"></span> ({{$mdl.currencyCode}})</b></label> <span class="form-control" ng-disabled="true">{{$mdl.item.tax | currency: ""}}</span> </div> </div> <div class="col-lg-4"> <div class="form-group"> <label><b><span translate="SUBTOTAL_INCL._TAX"></span> ({{$mdl.currencyCode}})</b></label> <span class="form-control" ng-disabled="true"> <b>{{ $mdl.item.subtotalIncTax | currency: "" }}</b> </span> </div> </div> </div> <br /> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" style="background:#fffeed" ng-model="$mdl.item.remarks" /> </div> </div> </div> </div> <hr /> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.selectedItem==null"> <i class="fa fa-check"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="fa fa-times"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/purchaseorders/polist/polistCreate.html','<form class="form-content" name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section data-ng-include="" src="\'app/pages/purchaseorders/polist/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_PURCHASE_ORDER"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="purchaseorders.polist.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/purchaseorders/polist/polistList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" style="width:auto;min-width:100%"><div><table class="table table-striped" st-persist="PurchaseOrderListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table="" style="font-size:90%"><thead><tr><th colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_ALL_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="purchaseorders.polist.create" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="NEW_P.O"></span>.</a> <a href="" class="btn btn-warning btn-with-icon" ng-if="!vm.showUpdatePanel" ng-click="vm.showBulkUpdatePanel()" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i> <span translate="BULK_UPDATE"></span></a> <a href="" class="btn btn-success btn-with-icon" ng-click="vm.showDownloadExcelModal()" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="EXPORT"><i class="fa fa-download"></i> <span translate="DOWNLOAD_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr ng-if="vm.showUpdatePanel"><th colspan="13" style="background:#fffc00;"><b>{{ \'SELECT_ONE_OR_MORE_PO_TO_UPDATE_STATUS\' | translate }} &nbsp;({{ vm.selectedPurchaseOrders.length }} selected)&nbsp;&nbsp;&nbsp;</b> <button type="button" class="btn btn-primary btn-sm" style="margin-right:15px" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="UPDATE" ng-click="vm.bulkUpdateConfimed()">{{ \'UPDATE_STATUS_TO_CONFIRMED\' | translate }}</button> <button type="button" class="btn btn-primary btn-sm" style="margin-right:50px" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="APPROVE" ng-click="vm.bulkUpdateApproved()">{{ \'UPDATE_STATUS_TO_APPROVED\' | translate }}</button> <button type="button" class="btn btn-info btn-sm" style="margin-right:50px" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="APPROVE" ng-click="vm.bulkUpdateFinalize()"><b>{{ \'FINALIZE_PO\' | translate }}</b></button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.closeBulkUpdatePanel()">{{ \'CANCEL\' | translate }}</button></th></tr><tr class="sortable"><th style="width:60px">#</th><th ng-if="vm.showUpdatePanel" class="hide-after"></th><th st-sort="purchaseOrderNo">{{ "P.O._NO." | translate }}</th><th st-sort="purchaseOrderDate" style="padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'P.O._DATE\' | translate }}<br><small>(DD/MM/YYYY)</small></th><th st-sort="deliveryDate" style="padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'DELIVERY_DATE\' | translate }}<br><small>(DD/MM/YYYY)</small></th><th st-sort="requisitionNo">{{ "REQUISITION_NO." | translate }}</th><th st-sort="branchName">{{ "BRANCH_/_DEPARTMENT" | translate }}</th><th st-sort="supplierName">{{ "SUPPLIER" | translate }}</th><th st-sort="createdBy">{{ "CREATED_BY" | translate }}</th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th style="width:65px" class="hide-after">{{ "EMAIL" | translate }}?</th><th style="padding-top:11px;padding-bottom:11px;line-height:110%;text-align:right" class="hide-after">{{ \'GRAND_TOTAL\' | translate }}<br>({{vm.currencyCode}})</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th ng-if="vm.showUpdatePanel" class="hide-after" style="text-align:center;width:50px;font-size:16pt"><a href="" ng-click="vm.selectAll()" title="Select ALL"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll()" title="De-select ALL" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th><th class="form-inline"><input st-search="purchaseOrderNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="purchaseOrderDate" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="deliveryDate" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="requisitionNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline" style="padding-top:11px;padding-bottom:11px;line-height:110%"><input st-search="branchName" class="form-control input input-sm" style="width:120px;height:25px;padding:1px;font-size:8pt"><br><input st-search="departmentName" class="form-control input input-sm" style="width:120px;height:25px;padding:1px;font-size:8pt;margin-top:3px"></th><th class="form-inline"><input st-search="supplierName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="createdBy" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><select st-search="status" class="form-control input input-sm" style="width:120px"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.statusList" value="{{ s.id }}">{{ s.label | translate | uppercase }}</option></select></th><th class="form-inline" style="text-align:center"><select st-search="hasEmailed" class="form-control input input-sm" style="width:65px"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.emailStatusList" value="{{ s.id }}">{{ s.label | translate | uppercase }}</option></select></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.data.length==0 && !vm.isLoading"><td colspan="13" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="13" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td ng-if="vm.showUpdatePanel" style="background:#fffc00;width:50px;text-align:center"><div class="checkbox checkbox-primary checkbox-inline" style="margin-top:4px;margin-bottom:6px"><input type="checkbox" name="jobNo" checklist-model="vm.selectedPurchaseOrders" checklist-value="item.id" checklist-change="vm.dataForm.cate.$setValidity(\'required\', vm.selectedPurchaseOrders.length > 0)" ng-required="!vm.selectedPurchaseOrders.length"> <label>&nbsp;</label></div></td><td nowrap="nowrap" style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.purchaseOrderNo}}<div ng-if="item.autocountPurchaseInvoiceNo!=null && item.autocountPurchaseInvoiceNo!=\'\'"><small>(PI: <b>{{item.autocountPurchaseInvoiceNo}}</b>)</small></div><div ng-if="item.originalDocNo!=null && item.originalDocNo!=\'\'"><small>(Ori Ref: <b>{{item.originalDocNo}}</b>)</small></div></td><td nowrap="nowrap">{{item.purchaseOrderDate | date: "dd-MMM-yyyy" }}</td><td nowrap="nowrap">{{item.deliveryDate | date: "dd-MMM-yyyy" }}</td><td nowrap="nowrap" style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.requisitionNo}}</td><td nowrap="nowrap"><div style="line-height:110%;padding-top:6px;padding-bottom:5px;" ng-if="item.departmentName!=null"><span style="font-size:9pt">{{item.branchName | uppercase}}</span><p style="font-size:9pt" ng-if="item.shipToBranchId != null"><span style="color:#b9b9b9">{{\'SHIP_TO\' | translate}}:</span> {{item.shipToBranchName | uppercase}}</p><br><em style="font-size:9pt">{{item.departmentName | uppercase}}</em></div><div ng-if="item.departmentName==null"><span>{{item.branchName | uppercase}}</span><p ng-if="item.shipToBranchId != null"><span style="color:#b9b9b9">{{\'SHIP_TO\' | translate}}:</span> {{item.shipToBranchName | uppercase}}</p></div></td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{(item.supplierName | uppercase | limitTo:20) + (item.supplierName.length > 20 ? \' ...\' : \'\') }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \' ...\' : \'\') }}</td><td>{{item.status | uppercase | translate | uppercase }}</td><td><span ng-if="item.hasEmailed" style="width:65px;color:rgb(12, 132, 12)"><b>{{ \'YES\' | translate | uppercase }}</b></span> <span ng-if="!item.hasEmailed" style="width:65px;color:#f00"><b>{{ \'NO\' | translate | uppercase }}</b></span></td><td style="color:#00f;text-align:right"><b>{{item.grandTotal | number:2 }}</b></td><td align="center"><a href="" title="Email Purchase Order" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#666" ng-if="item.status.toUpperCase()!=\'NEW\' && item.status!=\'Confirmed\' && item.status!=\'Cancelled\'" ng-click="vm.emailPurchaseOrder(item.id)" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="EXPORT"><i class="fa fa-envelope"></i></a></td><td align="center"><a href="" title="Print Purchase Order" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#00f" ng-if="item.status.toUpperCase()!=\'NEW\' && item.status!=\'Cancelled\'" ng-click="vm.printPO(item.id, item.purchaseOrderNo)" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="purchaseorders.polist.update({id:item.id})" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil" ng-show="item.status.toUpperCase()==\'NEW\'"></i> <i class="fa fa-eye" ng-show="item.status.toUpperCase()!=\'NEW\'"></i></a></td></tr></tbody><tfoot><tr><td colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="emailModal.html"><form name="$mdl.itemForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ \'EMAIL_PURCHASE_ORDER_TO_SUPPLIER\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.TO.$invalid && ($mdl.itemForm.TO.$dirty || $mdl.itemForm.$submitted)}"> <label> <span translate="TO"></span> <i class="fa fa-asterisk req"></i></label><br /> <small><em><i class="fa fa-info-circle"></i><span translate="SUPPLIER\'S_EMAIL_ADDRESS:"></span></em></small><br /> <input type="text" class="form-control" name="TO" ng-model="$mdl.template.to" required /> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.TO.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label translate="CC"></label><br /> <small><em><i class="fa fa-info-circle"></i> {{ \'SEPARATE_EACH_EMAIL_ADDRESS_USING_SEMI-COLON\' | translate }} (;)</em></small><br /> <input type="text" class="form-control" name="CC" ng-model="$mdl.template.cc" /> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label>{{ \'BCC\' | translate }}</label><br /> <small><em><i class="fa fa-info-circle"></i> {{ \'SEPARATE_EACH_EMAIL_ADDRESS_USING_SEMI-COLON\' | translate }} (;)</em></small><br /> <input type="text" class="form-control" name="BCC" ng-model="$mdl.template.bcc" /> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label translate="REPLY-TO"></label><br /> <small><em><i class="fa fa-info-circle"></i> <span translate="THE_EMAIL_ADDRESS_THAT_RECIPIENT_WILL_REPLY_TO"></span></em></small><br /> <input type="text" class="form-control" name="ReplyTo" ng-model="$mdl.template.replyTo" /> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.Subject.$invalid && ($mdl.itemForm.Subject.$dirty || $mdl.itemForm.$submitted)}"> <label>{{ \'SUBJECT\' | translate }} <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Subject" ng-model="$mdl.template.subject" required /> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.Subject.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.itemForm.EmailContent.$invalid && ($mdl.itemForm.EmailContent.$dirty || $mdl.itemForm.$submitted)}"> <label>{{ \'EMAIL_CONTENT\' | translate }} <i class="fa fa-asterisk req"></i></label> <!-- <trix-editor angular-trix name="EmailContent" placeholder="Type something here..." ng-if="true" ng-model="$mdl.template.content" required> </trix-editor> --> <div text-angular ng-model="$mdl.template.content" placeholder="Type something here..."> </div> <span class="help-block" style="color:#f00" ng-show="$mdl.itemForm.$submitted && $mdl.itemForm.EmailContent.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> </div> <div class="modal-footer"> <a type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="mdl.lockButtons" confirmed-click="$mdl.confirmModal()" ng-confirm-click="Confirm send email?"> <i class="fa fa-envelope"></i> <span translate="SEND_EMAIL"></span> </a> <a class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </a> </div> </form></script><script type="text/ng-template" id="downloadModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="EXPORT_TRANSACTIONS_INTO_EXCEL"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <p><span translate="EXPORT_THE_PURCHASE_ORDER_TRANSACTIONS_INTO_EXCEL_FORMAT_FOR_ACCOUNTING_SOFTWARE"></span>.</p> <br /><br /> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"><span translate="EXPORT_NEW_TRANSACTIONS"></span></legend> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcel()"> <i class="fa fa-download"></i> {{\'GENERATE_EXCEL\' | translate}} </a> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <br /><br /> <div class="row" ng-if="$mdl.batchList.length!=0"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <select name="BatchNo" class="form-control" style="margin-bottom:10px;background:#fffeed" ng-model="$mdl.selectedBatchId" ng-change="$mdl.selectedBatchIdChanged()" ng-options="i as i for i in $mdl.batchList"> <option value="">={{ \'SELECT_ONE\' | translate }}=</option> </select> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcelPast()"> <i class="fa fa-download"></i> {{\'DOWNLOAD_EXCEL\' | translate}} </a> <p align="center" ng-if="$mdl.isLoading"> <b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </p> </div> </div> <div class="row" ng-if="$mdl.batchList.length==0"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <br /> <center> <b class="text-primary"><i class="fa fa-info-circle"></i> <span translate="NO_PREVIOUS_EXPORT_AVAILABLE"></span></b> </center> </div> </div> </div> <hr /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/purchaseorders/polist/polistUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/purchaseorders/polist/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:30px" ui-sref="purchaseorders.polist.list" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-disabled="vm.lockButtons" ng-if="(vm.originalStatus.toUpperCase()==\'NEW\' || vm.hasApprovedAccess) && vm.originalStatus.toUpperCase()!=\'COMPLETED\' && vm.originalStatus.toUpperCase()!=\'COMPLETED (PARTIAL)\' && vm.originalStatus.toUpperCase()!=\'CANCELLED\' && !vm.isLoading"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button><a href="" class="btn btn-warning btn-with-icon" style="margin-right:30px" confirmed-click="vm.finalizePurchaseOrder()" ng-confirm-click="Finalize this Purchase Order?" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus.toUpperCase()==\'APPROVED\' && !vm.isLoading" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="APPROVE"><i class="fa fa-check-circle"></i> <span translate="FINALIZE_P.O"></span>.</a> <a href="" class="btn btn-success btn-with-icon" ng-click="vm.exportPurchaseOrder()" ng-disabled="vm.lockButtons" ng-if="false" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="EXPORT"><i class="fa fa-file-excel-o"></i> <span translate="EXPORT_P.O."></span></a> <a href="" class="btn btn-success btn-with-icon" style="margin-right:30px" confirmed-click="vm.approvePurchaseOrder()" ng-confirm-click="Approve this Purchase Order?" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus.toUpperCase()!=\'NEW\' && vm.originalStatus.toUpperCase()!=\'CANCELLED\' && vm.originalStatus.toUpperCase()!=\'APPROVED\' && vm.originalStatus.toUpperCase()!=\'COMPLETED\' && vm.originalStatus.toUpperCase()!=\'COMPLETED (PARTIAL)\' && !vm.isLoading" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="APPROVE"><i class="fa fa-check-circle"></i> <span translate="APPROVE_P.O."></span></a> <a href="" class="btn btn-danger btn-with-icon" style="margin-right:30px" confirmed-click="vm.cancelPurchaseOrder()" ng-confirm-click="Confirm to cancel this Purchase Order?" ng-disabled="vm.lockButtons" ng-if="vm.mode==2 && (vm.originalStatus.toUpperCase()!=\'CANCELLED\' && !vm.originalStatus.toUpperCase().includes(\'COMPLETED\') && !vm.checkItemsFulfilled())" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i> <span translate="CANCEL_P.O."></span></a> <a href="" class="btn btn-default btn-with-icon" style="margin-right:30px" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus.toUpperCase()!=\'NEW\' && !vm.isLoading" ng-click="vm.printPurchaseOrder()" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <span translate="PRINT_P.O."></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.showEmailModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus.toUpperCase()==\'APPROVED\' && !vm.isLoading" rms-check-access="purchaseorders.polist" rms-check-access-perm-type="EXPORT"><i class="fa fa-envelope"></i> <span translate="EMAIL_P.O."></span></a></div></form>');
$templateCache.put('app/pages/purchaseorders/pofromreq/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-show="vm.originalStatus==\'Pending\'"><small><em><i class="fa fa-info-circle"></i> <span translate="FILL_IN_THE_REQUISITION_DETAILS"></span>.</em></small></p><p ng-show="vm.originalStatus!=\'Pending\'"><small><em><i class="fa fa-exclamation-triangle" style="color:#fffc00"></i> <span translate="ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="PENDING"></b>.</em></small></p><br><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><span translate="REQUISITION_NO."></span></label> <span class="form-control">{{vm.requisition.requisitionNo || \'AUTONUMBER\' }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label for="Status"><span translate="JOB_STATUS"></span> <i class="fa fa-asterisk req"></i></label><ui-select ng-model="vm.reqStatuses.selected" class="btn-group bootstrap-select form-control" ng-disabled="vm.originalStatus!=\'Pending\'" append-to-body="true" search-enabled="false" on-select="vm.selectRequisitionStatus($item)"><ui-select-match placeholder="-- Select a Status --"><span style="color:#000 !important">{{ $select.selected.name }}</span></ui-select-match><ui-select-choices repeat="sts in vm.reqStatuses"><span ng-bind-html="sts.name"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group">{{ \'REMARKS\' | translate }} <textarea class="form-control" ng-disabled="vm.originalStatus!=\'Pending\'" ng-model="vm.requisition.remarks">\n\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><hr></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="BRANCH_NAME"></label><div><b>{{vm.requisition.branchName || \'-\' | uppercase}}</b></div></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="CREATED_BY"></label><div><b>{{vm.requisition.createdBy || \'-\' | uppercase}}<br><em><small>{{vm.requisition.createdDate || \'-\' | date:\'dd/MM/yyyy hh:mma\'}}</small></em></b></div></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label translate="MODIFIED_BY"></label><div><b>{{vm.requisition.modifiedBy || \'-\' | uppercase}}<br><em><small>{{vm.requisition.modifiedDate || \'-\' |date:\'dd/MM/yyyy hh:mma\'}}</small></em></b></div></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="{{ \'ITEM_LIST\' | translate }}"><p ng-show="vm.originalStatus==\'Pending\'"><small><em><i class="fa fa-info-circle"></i> <span translate="CHOOSE_AND_FILL_IN_THE_QUANTITY/UOM_FOR_THE_ITEM_LIST"></span>.</em></small></p><p ng-show="vm.originalStatus!=\'Pending\'"><small><em><i class="fa fa-exclamation-triangle" style="color:#fffc00"></i> <span translate="ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="PENDING"></b>.</em></small></p><br><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped table-hover" st-pipe="vm.retrieveData" st-table="vm.requisition.items" st-set-filter="myStrictFilter" st-safe-src="vm.requisition.items" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Item" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-1 col-lg-1">&nbsp;</div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:70px">#</th><th><b>{{ \'ITEM_CODE\' | translate }}</b></th><th><b>{{ \'ITEM_NAME\' | translate }}</b></th><th><b>{{ \'QUANTITY\' | translate }}</b></th><th><b translate="UOM"></b></th><th><b>{{ \'REMARKS\' | translate }}</b></th><th></th></tr></thead><tbody><tr ng-repeat="ntn in vm.requisition.itemsFiltered"><td>{{vm.startIndex+1+$index}})</td><td>{{ ntn.code || \'\' }}</td><td nowrap="nowrap">{{ ntn.description }}</td><td style="line-height:100% !important"><div class="form-group" style="margin-bottom:0px !important" ng-class="{\'has-error\': vm.dataForm.Quantity_{{$index}}.$invalid && (vm.dataForm.Quantity_{{$index}}.$dirty || vm.dataForm.$submitted)}"><input type="number" name="Quantity_{{$index}}" class="form-control" style="width:100px" ng-disabled="vm.originalStatus!=\'Pending\'" ng-model="ntn.quantity" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity_{{$index}}.$error.number"><small>* <span translate="INVALID_NUMBER"></span></small></span><div>{{vm.dataForm.Quantity_$index}}</div></div></td><td><select class="form-control" style="width:100px" ng-disabled="vm.originalStatus!=\'Pending\'" ng-model="ntn.uom" ng-options="uom.name for uom in vm.uomList track by uom.id"></select></td><td><input type="text" class="form-control" style="width:250px" ng-disabled="vm.originalStatus!=\'Pending\'" ng-model="ntn.remarks"></td><td></td></tr><tr><td colspan="7" align="center" ng-show="vm.requisition.items.length==0"><br><span translate="ITEM_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table><div><div></div></div></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/purchaseorders/pofromreq/pofromreqCreate.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section data-ng-include="" src="\'app/pages/requisitions/reqlist/_form.html\'"></section><div style="padding-bottom:30px"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_REQUISITION"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="requisitions.reqlist.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form></div>');
$templateCache.put('app/pages/purchaseorders/pofromreq/pofromreqList copy.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><p style="color:#00f"><i class="fa fa-info-circle"></i> <span translate="SELECT_ONE_OR_MORE_REQUISITIONS_TO_BATCH_GENERATE_PURCHASE_ORDERS"></span>.</p><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.reqData" style="font-size:80%" st-safe-src="vm.reqDataFull" refresh-table=""><thead><tr><th colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="requisitionNo" type="search" class="input form-control" ng-disabled="vm.isProcessing"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><button class="btn btn-primary btn-with-icon" confirmed-click="vm.generatePos()" ng-confirm-click="Confirm proceed to generate P.O.(s)? Items without Supplier Pricing will not be included in the new P.O." ng-disabled="vm.lockButtons" ng-if="vm.selectReqIds.length>0 && !vm.isProcessing" rms-check-access="purchaseorders.pofromreq" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="GENERATE_P.O."></span>(s)</button><div ng-if="vm.isProcessing" style="height:35px;line-height:100% !important"><small translate="PROCESSING">...</small><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width:100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="vm.isProcessing" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="requisitionNo"><span translate="REQ._NO."></span></th><th translate="REQ._DATE"></th><th translate="BRANCH"></th><th translate="DEPARTMENT"></th><th translate="REQUESTED_BY"></th><th translate="STATUS"></th><th style="width:70px;text-align:center;font-size:16pt"><a href="" ng-click="vm.selectAll()" ng-if="!vm.isProcessing"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll()" style="margin-left:10px" ng-if="!vm.isProcessing"><i class="ion ion-android-checkbox-outline-blank"></i></a></th></tr><tr class="sortable"><th></th><th></th><th></th><th class="form-inline"><select st-search="branchName" ng-if="!vm.isProcessing"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="req in vm.reqDataFull | unique:\'branchName\'" value="{{req.branchName}}">{{req.branchName}}</option></select></th><th class="form-inline"><select st-search="departmentName" ng-if="!vm.isProcessing"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="req in vm.reqDataFull | unique:\'departmentName\'" value="{{req.departmentName}}">{{req.departmentName}}</option></select></th><th class="form-inline"><select st-search="userName" ng-if="!vm.isProcessing"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="req in vm.reqDataFull | unique:\'userName\'" value="{{req.status}}">{{req.userName}}</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in vm.reqData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.requisitionNo}}</td><td>{{item.createdDate | date: "dd-MMM-yyyy" }}</td><td>{{item.branchName | uppercase}}</td><td>{{item.departmentName | uppercase}}</td><td>{{item.userName | uppercase}}</td><td>{{item.status | translate}}</td><td align="center"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" checklist-model="vm.selectReqIds" checklist-value="item.id" style="cursor:pointer" ng-disabled="vm.isProcessing"> <label></label></div></td></tr><tr ng-show="vm.reqData.length<=0"><td colspan="8">{{ \'NO_RECORD_FOUND\' | translate }}.</td></tr></tbody><tfoot><tr><td colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/purchaseorders/pofromreq/pofromreqList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RequisitionListing" style="font-size:100%" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table=""><thead><tr><th colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isSameBranch" class="form-control input"><option value="">{{ \'SHOW_CURRENT_BRANCH_ONLY\' | translate }}</option><option value="0">{{ \'SHOW_ALL_BRANCHES\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:35px;line-height:35px"><span ng-if="vm.selectReqIds.length>0 && !vm.isProcessing" style="margin-right:20px"><b>{{ vm.selectReqIds.length }} selected</b></span> <button class="btn btn-primary btn-with-icon" confirmed-click="vm.generatePos()" ng-confirm-click="Confirm proceed to generate P.O.(s)? Items without Supplier Pricing will not be included in the new P.O." ng-disabled="vm.lockButtons" ng-if="vm.selectReqIds.length>0 && !vm.isProcessing" rms-check-access="purchaseorders.pofromreq" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="GENERATE_P.O."></span>(s)</button><div ng-if="vm.isProcessing" style="height:35px;line-height:100% !important"><small translate="PROCESSING">...</small><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width:100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="requisitionNo">{{ \'REQ._NO.\' | translate }}</th><th>{{ \'REQ._DATE\' | translate }}</th><th st-sort="branchName">{{ \'BRANCH\' | translate }}</th><th st-sort="departmentName">{{ \'DEPARTMENT\' | translate }}</th><th st-sort="userName">{{ \'REQUESTED_BY\' | translate }}</th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th st-sort="grandTotal">{{ \'GRAND_TOTAL\' | translate }}<br>({{vm.currencyCode}})</th><th></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th colspan="2" class="form-inline"><input st-search="requisitionNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="branchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="departmentName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="userName" class="form-control input input-sm" style="width:120px"></th><th></th><th class="hide-after" style="width:70px;text-align:center;font-size:16pt"><a href="" ng-click="vm.selectAll()" ng-if="!vm.isProcessing"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll()" style="margin-left:10px" ng-if="!vm.isProcessing"><i class="ion ion-android-checkbox-outline-blank"></i></a></th></tr></thead><tbody><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td>{{item.requisitionNo}}</td><td>{{item.createdDate | date: "dd-MMM-yyyy" }}</td><td>{{item.branchName | uppercase}}</td><td>{{item.departmentName | uppercase}}</td><td>{{item.userName | uppercase}}</td><td>{{item.status | translate | uppercase}}</td><td>{{item.grandTotal | number:\'2\'}}</td><td align="center"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" checklist-model="vm.selectReqIds" checklist-value="item.id" style="cursor:pointer" ng-disabled="vm.isProcessing"> <label></label></div></td></tr><tr ng-show="vm.data.length<=0"><td colspan="8">{{ \'NO_RECORD_FOUND\' | translate }}</td></tr></tbody><tfoot><tr><td colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/receivings/grnlist/grnCreate.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-lg-12"><br><legend style="padding-bottom:5px"><span translate="STEP_1"></span>: <span translate="SELECT_A_PURCHASE_ORDER"></span></legend></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label translate="SELECT_A_PURCHASE_ORDER_DOCUMENT"><i class="fa fa-asterisk req"></i></label><div class="row"><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8"><span class="form-control">{{vm.po.purchaseOrderNo || \'Select a P.O.\'}}</span></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><a href="" class="btn btn-primary btn-with-icon" ng-if="vm.po.purchaseOrderNo==null" ng-click="vm.showPoList()"><i class="fa fa-search"></i> <span translate="SEARCH"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-if="vm.po.purchaseOrderNo" ng-click="vm.showPoList()"><i class="fa fa-search"></i><span translate="RE-SELECT"></span></a></div></div></div></div></div><div class="row" style="background: repeating-linear-gradient(45deg,#fafafa,#fafafa 40px,#ffffff 40px,#ffffff 80px);" ng-if="vm.isShowPoList"><div class="col-sm-9 col-md-9 col-lg-9"><div style="padding:15px"><div style="padding:20px;background:#fff;border:1px solid #ccc"><table class="table table-striped table-hover" style="font-size:90%" st-pipe="vm.retrieveData" st-table="vm.poData" st-safe-src="vm.poData" refresh-table=""><thead><tr><th colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-left:0px"><b translate="PURCHASE_ORDER">( <span translate="APPROVED"></span>)</b> &nbsp;&nbsp; <a href="" class="btn btn-danger btn-sm" ng-click="vm.closePoList()"><i class="fa fa-times"></i> {{ "CLOSE" | translate }}</a></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr><th style="width:70px"><b>#</b></th><th><b><span translate="P.O._NO"></span>.</b></th><th><b translate="P.O._DATE"></b></th><th><b translate="DELIVERY_DATE"></b></th><th><b translate="SUPPLIER_NAME"></b></th><th></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-if="vm.poData.length==0"><td colspan="6" style="height:100px;line-height:100px"><big><center><b translate="NO_APPROVED_P.O._AVAILABLE"></b></center></big></td></tr><tr ng-repeat="item in vm.poData"><td>{{vm.startIndex+1+$index}})</td><td>{{ item.purchaseOrderNo || \'\' }}</td><td>{{ item.purchaseOrderDate }}</td><td>{{ item.deliveryDate }}</td><td>{{item.supplierName | uppercase}}</td><td><a href="" class="btn btn-primary btn-with-icon btn-sm" ng-click="vm.selectPo(item.id)"><i class="fa fa-check"></i><span translate="SELECT"></span></a></td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><div ng-if="vm.isPoSelected"><div class="row"><div class="col-lg-12"><br><legend style="padding-bottom:5px"><span translate="STEP_2"></span>: <span translations="RECEIVE_ITEMS_ACCORDINGLY"></span></legend></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="SUPPLIER_NAME"></label> <span class="form-control" style="height:auto !important;">{{vm.po.supplier.name || \'\'}}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label translate="BRANCH"></label> <span class="form-control">{{vm.po.branch.name || \'\'}}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StorageLocation.$invalid && (vm.dataForm.StorageLocation.$dirty || vm.dataForm.$submitted)}"><label><span translate="STORAGE_LOCATION"></span> <i class="fa fa-asterisk req"></i></label><select name="StorageLocation" class="form-control" ng-model="vm.selectedStorage" ng-options="s as s.description for s in vm.storageList" required=""></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StorageLocation.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SupplierDoNo.$invalid && (vm.dataForm.SupplierDoNo.$dirty || vm.dataForm.$submitted)}"><label translate="SUPPLIER_DO_NUMBER"><i class="fa fa-asterisk req"></i></label> <input type="text" name="SupplierDoNo" class="form-control" placeholder="Supplier D.O. No." ng-model="vm.grn.supplierDoNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SupplierDoNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-lg-12"><div class="form-group"><label translate="REMARKS"></label> <textarea class="form-control" placeholder="Remarks" rows="3" ng-model="vm.grn.remarks">\n\t\t\t\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><hr></div></div><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped table-hover" style="font-size:90%"><thead><tr><th style="width:70px">#</th><th><b translate="ITEM_CODE"></b></th><th><b>{{ \'ITEM_NAME\' | translate }}</b></th><th style="text-align:right"><b translate="ORDER_QUANTITY"></b></th><th><b>{{ \'U.O.M.\' | translate }}</b></th><th></th><th style="width:110px"><b translate="RECIEVED_QUANTITY"></b></th><th><b>{{ \'U.O.M.\' | translate }}</b></th><th><b><span translate="TEMPERATURE"></span> (&deg;C)</b></th><th><b>{{ \'REMARKS\' | translate }}</b></th></tr></thead><tbody><tr ng-repeat="item in vm.po.purchaseOrderItems" ng-hide="item.quantity==item.quantityFulfilled"><td>{{$index+1}})</td><td>{{ item.item.code || \'\' }}</td><td nowrap="nowrap">{{ item.item.description }}</td><td style="text-align:right">{{(item.quantity - item.quantityFulfilled) | number }}</td><td>{{item.unitOfMeasurement.name | uppercase}}</td><td><a href="" class="btn btn-default btn-sm" style="color:#00f" ng-click="item.receivedQuantity=(item.quantity - item.quantityFulfilled)"><i class="fa fa-chevron-right"></i></a></td><td style="line-height:100% !important"><div class="form-group" style="margin-bottom:0px !important" ng-class="{\'has-error\': vm.dataForm.Quantity_{{$index}}.$invalid && (vm.dataForm.Quantity_{{$index}}.$dirty || vm.dataForm.$submitted)}"><input type="number" name="Quantity_{{$index}}" class="form-control" style="width:100px" ng-model="item.receivedQuantity" min="0"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Quantity_{{$index}}.$error.number"><small>* <span translate="INVALID_NUMBER"></span></small></span></div></td><td>{{item.unitOfMeasurement.name | uppercase}}</td><td><div class="form-group" style="margin-bottom:0px !important"><input type="text" class="form-control" style="width:100px" ng-model="item.temperature"></div></td><td><div class="form-group" style="margin-bottom:0px !important"><input type="text" class="form-control" style="width:150px" ng-model="item.remarks"></div></td></tr><tr><td colspan="9" align="center" ng-show="vm.po.purchaseOrderItems.length==0"><br><span translate="PURCHASE_ORDER_ITEM_LIST_IS_EMPTY"></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.po.purchaseOrderItems.length }}</b></div></td></tr></tfoot></table></div></div></div></uib-tab></uib-tabset></div></div></div><div style="padding-bottom:30px" ng-if="vm.isPoSelected"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }}</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="receivings.grnlist"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form></div>');
$templateCache.put('app/pages/receivings/grnlist/grnList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="GRNListing" st-pipe="vm.retrieveData" st-table="vm.data" style="font-size:90%" refresh-table=""><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isLabelPrinted" class="form-control input"><option value="">{{ \'SHOW_GRN_LABEL_NOT_PRINTED\' | translate }}</option><option value="1">{{ \'SHOW_GRN_LABEL_PRINTED\' | translate }}</option><option value="2">{{ \'SHOW_ALL_GRN\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:35px;line-height:35px"><a href="" class="btn btn-success btn-with-icon" ng-click="vm.showDownloadExcelModal()" rms-check-access="receivings.grnlist" rms-check-access-perm-type="EXPORT"><i class="fa fa-download"></i> <span translate="DOWNLOAD_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="receivingNo">{{ \'GRN_NO\' | translate }}</th><th>{{ \'GRN_DATE\' | translate }}<br><small>(DD/MM/YYYY)</small></th><th>{{ \'SUPPLIER\' | translate }}</th><th>{{ \'SUPPLIER_DO_NUMBER\' | translate }}</th><th>{{ \'P.O._NO\' | translate }}</th><th>{{ \'BRANCH_NAME\' | translate }}</th><th>{{ \'STORAGE\' | translate }}</th><th style="width:60px;cursor:default;pointer-events:none;">{{ \'CANCELLED\' | translate }}&#63;</th><th style="width:40px;text-align:center;line-height:100%;cursor:default;pointer-events:none;" class="hide-after" ng-if="!vm.isRmsLite && !vm.isRmsStarter"><small>{{ \'LABEL\' | translate }}<br>{{ \'PRINTED\' | translate }}&#63;</small></th><th style="width:40px;cursor:default;pointer-events:none;"></th><th style="width:40px;cursor:default;pointer-events:none;"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline"><input st-search="receivingNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="createdDate" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="supplierName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="supplierDoNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="purchaseOrderNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="branchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="storageName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline" style="cursor:default;pointer-events:none;"></th><th ng-if="!vm.isRmsLite && !vm.isRmsStarter" style="cursor:default;pointer-events:none;"></th><th style="cursor:default;pointer-events:none;"></th><th style="cursor:default;pointer-events:none;"></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center><b style="font-size:16pt"><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></td></tr><tr ng-if="vm.data.length<=0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}.</center></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td ng-if="item.oldReceivingNo==null" nowrap="nowrap">{{item.receivingNo}}</td><td ng-if="item.oldReceivingNo!=\'\' && item.oldReceivingNo!=null" nowrap="nowrap" style="line-height:130%;padding-top:5px;padding-bottom:4px">{{item.receivingNo}}<br><small><em>(Prev: {{item.oldReceivingNo}})</em></small></td><td style="line-height:120%;font-size:9pt;padding-top:5px;padding-bottom:4px;">{{item.createdDate | date: \'dd-MMM-yyyy\' }}<br><small>{{item.createdDate | date: \'hh:mma\' }}</small></td><td nowrap="nowrap">{{item.supplierName}}</td><td>{{ item.supplierDoNo }}</td><td>{{ item.purchaseOrderNo }}</td><td nowrap="nowrap">{{ item.branchName || \'-\' | uppercase }}</td><td nowrap="nowrap">{{ item.storageName || \'-\' | uppercase }}</td><td nowrap="nowrap" style="text-align: center;"><i class="fa fa-check" ng-if="item.isCancelled" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.isCancelled" style="color:#f00"></i></td><td align="center" ng-if="!vm.isRmsLite && !vm.isRmsStarter"><a href="" title="Show Labels" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt" ng-if="item.isLabelPrinted==\'1\'" ng-click="vm.showLabelModal(item)"><i class="fa fa-file-text text-primary"></i></a> <i class="fa fa-times" ng-if="item.isLabelPrinted==\'0\'" style="color:#f00"></i></td><td align="center"><a href="" title="Print GRN" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#00f" ng-click="vm.printGRN(item.id, item.receivingNo)" rms-check-access="receivings.grnlist" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="View" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="receivings.grnlist.update({id:item.id})" rms-check-access="receivings.grnlist" rms-check-access-perm-type="UPDATE"><i class="fa fa-eye"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="labelModal.html"><form name="$mdl.stepForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:80%" st-pipe="$mdl.retrieveData" st-table="$mdl.mvmtData" refresh-table> <thead> <tr> <th colspan="5" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-7 col-lg-7" style="padding-left:0px"> <h3> <div style="width:auto;display:inline-block;padding:3px 8px;margin-right:3px;border-radius:4px;background:#ccc;color:#333"> {{$mdl.item.receivingNo}} </div> <span translations="FIFO_LABEL_LIST"></span> </h3> </div> </th> </tr> <tr> <th colspan="5" style="padding-left:0px;padding-right:0px"> <div class="col-md-4 col-lg-4" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Label" class="input form-control" /> </div> </div> <div class="col-md-8 col-lg-8" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr> <th><b translate="CODE"></b></th> <th><b translate="DESCRIPTION"></b></th> <th><b translate="STORAGE"></b></th> <th><b translations= "S/N_FROM"></b></th> <th><b translations= "S/N_TO"></b></th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="5"> <div style="padding:20px 0px"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="LOADING_LABELS"></span> ...</b></center> </div> </td> </tr> <tr ng-if="$mdl.labelData.length==0"> <td colspan="5"><span translate="NO_FIFO_LABEL_AVAILABLE"></span>.</td> </tr> <tr ng-repeat="m in $mdl.labelData"> <td>{{m.itemCode | uppercase}}</td> <td>{{m.itemName | uppercase}}</td> <td>{{m.storageName | uppercase}}</td> <td>{{m.serialNoFrom | uppercase}}</td> <td>{{m.serialNoTo | uppercase}}</td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script><script type="text/ng-template" id="downloadModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="EXPORT_TRANSACTIONS_INTO_EXCEL"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <p translate="EXPORT_THE_GRN_TRANSACTIONS_INTO_EXCEL_FORMAT_FOR_ACCOUNTING_SOFTWARE"></p> <br /><br /> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"><span translate="EXPORT_NEW_TRANSACTIONS"></span></legend> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcel()"> <i class="fa fa-download"></i> <span translate="GENERATE_EXCEL"></span> </a> <b ng-if="$mdl.isLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </div> </div> <br /><br /> <div class="row" ng-if=$mdl.batchList.length!=0> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <select name="BatchNo" class="form-control" style="margin-bottom:10px;background:#fffeed" ng-model="$mdl.selectedBatchId" ng-change="$mdl.selectedBatchIdChanged()" ng-options="i as i for i in $mdl.batchList"> <option value="">{{ \'SELECT_ONE\' | translate }}</option> </select> <a href class="btn btn-success btn-with-icon btn-lg" style="width:100%" ng-if="!$mdl.isLoading" ng-click="$mdl.downloadExcelPast()"> <i class="fa fa-download"></i> <span translate="DOWNLOAD_EXCEL"></span> </a> <b ng-if="$mdl.isLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </div> </div> <div class="row" ng-if=$mdl.batchList.length==0> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;text-align:center;margin-bottom:10px"> <span translate="DOWNLOAD_PREVIOUS_EXPORTS"></span></legend> <br /> <center> <b class="text-primary"><i class="fa fa-info-circle"></i> <span translate="NO_PREVIOUS_EXPORT_AVAILABLE"></span></b> </center> </div> </div> </div> <hr /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/receivings/grnlist/grnUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-lg-12"><br><legend style="padding-bottom:5px"><span translate="GRN_NO"></span>: {{vm.grn.receivingNo}}</legend></div></div><div class="row"><div class="col-md-3 col-lg-2"><div class="form-group"><label><b><span translate="P.O._NO"></span></b></label> <span class="form-control" ng-disabled="true">{{vm.grn.purchaseOrder.purchaseOrderNo || \'\'}}</span></div></div><div class="col-md-3 col-lg-2"><div class="form-group"><label><b><span translate="SUPPLIER_NAME"></span></b></label> <span class="form-control" style="height:auto !important;" ng-disabled="true">{{vm.grn.purchaseOrder.supplierName || \'\'}}</span></div></div><div class="col-md-3 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SupplierDoNo.$invalid && (vm.dataForm.SupplierDoNo.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="SUPPLIER_D.O_NUMBER"></span></b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="SupplierDoNo" class="form-control" ng-model="vm.grn.supplierDoNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SupplierDoNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-9 col-lg-6"><div class="form-group"><label><b><span translate="REMARKS"></span></b></label> <textarea class="form-control" rows="3" ng-model="vm.grn.remarks">\n\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p><br><br></p></div></uib-tab><uib-tab heading="{{ \'RECEIVED_ITEMS\' | translate }}"><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped table-hover" style="font-size:90%"><thead><tr><th style="width:40px">#</th><th style="width:100px"><b>{{ \'STATUS\' | translate }}</b></th><th style="width:150px"><b translate="ITEM_CODE"></b></th><th><b translate="ITEM_DESCRIPTION"></b></th><th style="width:100px;text-align:right"><b translate="QTY_RECV"></b></th><th style="width:80px"><b translate="U.O.M."></b></th><th><b><span translate="BATCH_NO"></span>.</b></th><th><b><span translate="TEMP"></span> (&deg;C)</b></th><th><b translate="EXP._DATE"></b></th><th><b>{{ \'REMARKS\' | translate }}</b></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in vm.grn.receivingItems"><td>{{$index+1}})</td><td><span ng-if="item.isRejected" class="text-danger"><b>{{ \'REJECTED\' | translate | uppercase }}</b>&nbsp;<big><i class="fa fa-info-circle" uib-tooltip="Reason: {{item.rejectRemark}}"></i></big></span> <span ng-if="!item.isRejected" class="text-success"><b>{{ \'ACCEPTED\' | translate | uppercase }}</b></span></td><td>{{ item.item.code || \'\' }}</td><td nowrap="nowrap">{{ item.item.description }}</td><td style="text-align:right">{{item.quantity | number }}</td><td>{{item.unitOfMeasurement.name | uppercase}}</td><td nowrap="nowrap">{{ item.batchNo || \'-\' }}</td><td nowrap="nowrap">{{ item.temperature || \'-\' }}</td><td nowrap="nowrap">{{ item.expiryDate || \'-\' | date:\'dd/MM/yyyy\' }}</td><td nowrap="nowrap" style="padding-top:8px;padding-top:8px;line-height:150%"><span>{{ item.remarks || \'-\' }}</span></td><td nowrap="nowrap" style="width:80px"><a href="" class="btn btn-with-icon btn-primary btn-xs" ng-if="item.photoAttachment!=null && item.photoAttachment!=\'\'" ng-click="vm.viewPhotos(item.item.code, item.item.description, item.photoAttachment)"><i class="fa fa-picture-o"></i> Photos</a></td><td nowrap="nowrap" style="width:80px"><a href="" class="btn btn-with-icon btn-warning btn-xs" ng-click="vm.changeItem(item.id)" ng-if="!vm.grn.isCancelled && !vm.grn.purchaseOrder.status.toUpperCase().includes(\'COMPLETED\')" rms-check-access="receivings.grnlist" rms-check-access-perm-type="APPROVE"><i class="fa fa-pencil"></i> <span translate="UPDATE"></span></a></td></tr><tr><td colspan="13" align="center" ng-show="vm.grn.receivingItems.length==0"><br><span translate="RECEIVED_ITEM_LIST_IS_EMPTY"></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.grn.receivingItems.length }}</b></div></td></tr></tfoot></table><div class="row"><p><br><br></p></div></div></div></uib-tab></uib-tabset></div></div></div><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" style="margin-right:30px" ui-sref="receivings.grnlist"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:30px" rms-check-access="receivings.grnlist" rms-check-access-perm-type="APPROVE" ng-if="!vm.grn.isCancelled && vm.grn.purchaseOrder.status.toUpperCase() != \'FINALIZED\' && !vm.grn.purchaseOrder.status.toUpperCase().includes(\'COMPLETED\')"><i class="ion ion-checkmark"></i> <span translate="UPDATE_GRN"></span></button> <a href="" title="Print GRN" class="btn btn-primary btn-with-icon" ng-click="vm.printGRN(vm.grn.id, vm.grn.receivingNo)" rms-check-access="receivings.grnlist" rms-check-access-perm-type="EXPORT" ng-if="!vm.grn.isCancelled"><i class="fa fa-print"></i> <span translate="PRINT_GRN"></span></a> <a href="" title="Cancel GRN" class="btn btn-danger btn-with-icon pull-right" ng-click="vm.cancelGRN(vm.grn.id, vm.grn.receivingNo)" rms-check-access="receivings.grnlist" rms-check-access-perm-type="APPROVE" ng-if="!vm.grn.isCancelled && vm.grn.purchaseOrder.status.toUpperCase() != \'FINALIZED\' && !vm.grn.purchaseOrder.status.toUpperCase().includes(\'COMPLETED\')"><i class="ion ion-close"></i> <span translate="CANCEL_GRN"></span></a></div></section></form><script type="text/ng-template" id="itemModal.html"><form name="$mdl.itemForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="UPDATE_GRN_ITEM_DETAILS"></span></h3> </div> <div class="modal-body" id="modal-body"> <p style="color:#f00"><i class="fa fa-info-circle"></i> <span translate="CHANGES_MADE_HERE_WILL_BE_SAVED_UPON_CONFIRMATION"></span> <br />&nbsp;</p> <div class="form-group"> <label><b translate="SELECT_A_RAW_MATERIAL"></b></label> <ui-select ng-model="$mdl.selectedItem" style="background:#fffeed" name="Item" title="Select or Search for Raw Materials..." class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="false" search-enabled="true" on-select="$mdl.onSelectedItemChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Raw Materials..."> <span>{{ $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.itemList | filter: $select.search" refresh="$mdl.loadItemList($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="i.description | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.Item.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> <div class="form-group"> <div class="row"> <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"> <label><b translate="QUANTITY"></b></label> <input type="number" name="Quantity" class="form-control" style="background:#fffeed" ng-model="$mdl.receivingItem.quantity" min="0.01" step="1" required ng-change="$mdl.onQuantityChanged()" /> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.Quantity.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.Quantity.$error.number && $mdl.itemForm.$submitted">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</p> </div> <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"> <label><b translate="UOM"></b></label> <select name="UOM" class="form-control" ng-disabled="true" style="background:#fffeed" ng-options="i as (i.name | uppercase) for i in $mdl.uomList" ng-model="$mdl.selectedUom" ng-change="$mdl.onSelectedUomChanged()" required> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.itemForm.UOM.$error.required && $mdl.itemForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="form-group"> <div class="row"> <p>&nbsp;</p> <p>&nbsp;</p> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="photoModal.html"><form name="$mdl.itemForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> {{$mdl.itemCode}} - {{$mdl.itemName}} <br /> Photo Gallery </h3> </div> <div class="modal-body" id="modal-body"> <div style="margin-bottom:10px;background:#333;height:350px;"> <center> <img ng-src="{{$mdl.selectedPhoto}}" align="center" style="height:350px" /> </center> </div> <div style="overflow-x:auto"> <img ng-src="{{$mdl.rootUrl}}{{i}}" ng-repeat="i in $mdl.photoArray" style="max-width:150px;max-height:80px;margin-right:5px;border:1px solid #000;cursor:pointer" ng-click="$mdl.selectPhoto(i)" /> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/recipes/cards/cardCategories.html','<div class="widgets recipe"><div class="row"><div class="col-md-12" ba-panel=""><div class="row"><div class="col-md-5 col-lg-5"><p><small><i class="fa fa-info-circle"></i> <em translate="CLICK_ON_ONE_OF_THE_CATEGORIES_TO_SHOW_THE_RECIPES."></em></small><br><small><i class="fa fa-star" style="color:#ffd800"></i> <em translate="INDICATES_THE_COMPLIMENTARY_RECIPES_ACCESS."></em></small><br>&nbsp;</p></div><div class="col-md-4 col-lg-4"><a href="" class="btn btn-with-icon btn-primary pull-right" ng-click="vm.showSearchRecipeDialog()"><i class="fa fa-search"></i> <span translate="QUICK_SEARCH_RECIPE"></span></a> <a href="" class="btn btn-with-icon btn-primary pull-right" style="margin-right:10px" ng-click="vm.exportLainox()" ng-if="vm.useLainoxNaboo" rms-check-access="recipes.cards" rms-check-access-perm-type="EXPORT"><i class="fa fa-file-excel-o"></i> <span translate="EXPORT_FOR_NABOO"></span> ( <span translate="ALL"></span>)</a></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" ng-model="vm.searchTextOri" ng-model-options="{ debounce: 500 }" ng-change="vm.searchForText()"></div></div><div class="row" ng-if="vm.isLoading"><div class="col-lg-12"><div style="background:#fafafa;margin-bottom:15px;padding-top:10px;padding-bottom:10px;font-size:16pt;color:#00f"><center><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA_...\' | translate }}</center></div></div></div><div class="row" ng-if="vm.isSearching"><div class="col-lg-12"><div style="background:#fafafa;margin-bottom:15px;padding-top:10px;padding-bottom:10px;font-size:16pt;color:#00f"><center><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="SEARCHING"></span> ...</center></div></div></div><div class="row" ng-if="!vm.isLoading && !vm.isSearching && filteredRecord.length==0"><div class="tile-container col-lg-12"><div style="background:#fafafa;height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></div></div></div><div class="row"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-repeat="cat in vm.cateDataFull | filter:vm.searchText as filteredRecord"><a href="" ui-sref="recipes.cards.recipes({id:cat.id})"><i class="fa fa-star fa-2x" aria-hidden="true" ng-show="cat.isComplimentary"></i><div class="img" afkl-lazy-image="{{cat.thumbnail || cat.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4><b>{{cat.name | uppercase}}</b></h4><i class="fa fa-eye"></i></a></div></div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3"><br><span translate="TOTAL_RECORDS:"></span> <b>{{filteredRecord.length}}</b><br>&nbsp;</div></div></div></div><script type="text/ng-template" id="SearchRecipeModal.html"><form name="$mdl.searchReicpeForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="QUICK_SEARCH_RECIPE"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <div class="input-group"> <span class="input-group-addon" style="padding:0px"> <i class="fa fa-search" style="padding:3px 10px"></i> </span> <input type="text" name="SearchText" class="form-control" placeholder="Enter keyword to search (Min. 3 letters)" ng-disabled="$mdl.isLoading" ng-model="$mdl.searchText" ng-model-options=\'{ debounce: 500 }\' ng-change="$mdl.searchRecipe()" min=3 /> </div> </div> </div> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div style="max-height:500px;overflow-y:scroll"> <table class="table table-striped" style="border:1px solid #ccc" st-table="$mdl.recipeList" refresh-table> <thead> <tr> <th style="width:60px">#</th> <th style="width:200px"><b translate="RECIPE_IMAGE"></b></th> <th><b translate="RECIPE_NAME"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="ntn in $mdl.recipeList"> <td>{{ $index+1 }})</td> <td style="padding-top:10px;padding-bottom:10px"> <img src="{{ntn.thumbnail || ntn.imageLocation || \'assets/img/empty_placeholder.png\'}}" alt="" style="width:160px;height:85px" /> </td> <td style="padding-top:10px;padding-bottom:10px;line-height:150%;color:#000"> <big><b>{{ ntn.name || \'\' | uppercase }}</b></big> <br /> <div style="width:auto;line-height:100%"> <a href class="report-type-tag" ng-repeat="c in ntn.recipeCategories" ui-sref="recipes.cards.recipes({id:c.id})" ng-click="$mdl.cancelModal()" style="width:auto;margin-right:5px;padding:2px 8px;border:1px solid #888"> {{c.name | uppercase}} </a> </div> </td> <td style="padding-top:10px"> <a href class="btn btn-primary editable-table-button btn-sm" ui-sref="recipes.cards.view({id:ntn.id})" ng-click="$mdl.cancelModal()"> <span style="color:#fff" translate="GO"></span> &nbsp; <i class="fa fa-arrow-circle-right"></i> </a> </td> </tr> <tr> <td colspan="4" align="center" ng-show="$mdl.recipeList.length==0"> <br /> {{ \'NO_RECORD_FOUND\' | translate }}. <br />&nbsp; </td> </tr> </tbody> </table> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.isLoading" style="color:#00f;margin-left:30px"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b> <span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/recipes/cards/cardRecipes.html','<div class="widgets recipe"><div class="row"><div class="col-md-12" ba-panel=""><div class="row"><div class="col-md-1 col-lg-1"><a href="" class="btn btn-primary btn-with-icon" style="float:left;margin-right:20px" ui-sref="recipes.cards.categories"><i class="ion-chevron-left"></i><span translate="BACK"></span></a></div><div class="col-md-5 col-lg-5" style="vertical-align:middle"><div style="font-size:22pt;height:auto;line-height:110%"><big><b>{{ vm.category.name | uppercase }}</b></big></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-2 col-lg-2"><a href="" class="btn btn-with-icon btn-primary" ng-click="vm.exportLainox()" ng-if="vm.useLainoxNaboo" rms-check-access="recipes.cards" rms-check-access-perm-type="EXPORT"><i class="fa fa-file-excel-o"></i> <span translate="EXPORT_FOR_NABOO"></span></a></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" ng-model="vm.searchTextOri" ng-model-options="{ debounce: 500 }" ng-change="vm.searchForText()"></div><p><br></p></div><div class="row"><hr></div><p><small><i class="fa fa-info-circle"></i> <em><span translate="CLICK_ON_ONE_OF_THE_RECIPES_TO_VIEW_THE_RECIPE_CARD"></span>.</em></small><br>&nbsp;</p><div class="row" ng-if="vm.isLoading"><div class="col-lg-12"><div style="background:#fafafa;margin-bottom:15px;padding-top:10px;padding-bottom:10px;font-size:16pt;color:#00f"><center><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA_...\' | translate }}</center></div></div></div><div class="row" ng-if="vm.isSearching"><div class="col-lg-12"><div style="background:#fafafa;margin-bottom:15px;padding-top:10px;padding-bottom:10px;font-size:16pt;color:#00f"><center><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="SEARCHING"></span> ...</center></div></div></div><div class="row" ng-if="!vm.isLoading && !vm.isSearching && filteredRecord.length==0"><div class="tile-container col-lg-12"><div style="background:#fafafa;height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></div></div></div><div class="row"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-repeat="r in vm.recipeDataFull | filter:vm.searchText as filteredRecord"><a href="" ui-sref="recipes.cards.view({id:r.id})"><div class="img" afkl-lazy-image="{{r.thumbnail || r.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4><b>{{r.name | uppercase}}</b></h4></a></div></div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3"><br><span translate="TOTAL_RECORDS:"></span> <b>{{filteredRecord.length}}</b><br>&nbsp;</div></div></div></div>');
$templateCache.put('app/pages/recipes/cards/cardView.html','<div class="widgets recipe"><div ng-if="vm.showView1"><div class="row"><div class="col-md-12" ba-panel=""><div class="row"><div class="col-md-12 col-lg-12" style="font-size:22pt;font-weight:bold;padding:10px 15px 20px"><i class="ion ion-ios-book" style="margin-right:10px"></i> {{vm.recipe.name | uppercase}}</div></div><div class="row"><div class="col-md-12 col-lg-12" style="padding-bottom:25px;"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.goBack()" style="margin-right:20px"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-default btn-with-icon" style="margin-right:20px" ng-if="vm.hasSmartKitchenModule" ng-click="vm.goToView2()"><i class="fa fa-flash"></i> <span translate="ADVANCE_VIEW"></span></a> <a href="" class="btn btn-default btn-with-icon" ng-click="vm.printRecipe(vm.recipe.id, vm.recipe.name, vm.batch)" rms-check-access="recipes.cards" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <span translate="PRINT_RECIPE_FULL"></span></a> <a href="" class="btn btn-default btn-with-icon" ng-click="vm.printRecipeSimple(vm.recipe.id, vm.recipe.name, vm.batch)" rms-check-access="recipes.cards" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <span translate="PRINT_RECIPE_SIMPLE"></span></a> <a href="" class="btn btn-default btn-with-icon" style="margin-right:20px" ng-click="vm.printFoodCost(vm.recipe.id, vm.recipe.name, vm.batch)" ng-if="vm.canAccessFoodCost" rms-check-access="recipes.cards" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <span translate="PRINT_FOOD_COST"></span></a> <a href="" class="btn btn-default btn-with-icon" ng-click="vm.showShareDialog()" rms-check-access="sops.cards" rms-check-access-perm-type="EXPORT"><span class="text-primary"><i class="fa fa-paper-plane"></i> <span translate="EZYSHARE"></span></span></a><div class="pull-right" style="font-size:9pt;line-height:150%;padding:5px 0px"><i class="fa fa-arrows-alt" style="margin-right:5px;color:#2f317a"></i> <em translate="EXPAND_/_COLLAPSE"></em><br><i class="fa fa-external-link" style="margin-right:5px;color:#2f317a"></i> <em translate="VIEW_LINKED_RECIPE"></em></div></div></div><div class="row"><div class="col-md-7 col-lg-5"><div class="row"><img ng-src="{{vm.recipe.thumbnail || vm.recipe.imageLocation}}" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="margin-bottom:20px"></div><div class="row"><br></div><div class="row"><div class="col-md-12 col-lg-12"><div class="panel panel-default bootstrap-panel" ng-if="vm.recipe.dimension"><div class="panel-heading"><b translate="SIZE_/_DIMENSION"></b></div><div class="panel-body">{{vm.recipe.dimension}}</div></div></div></div></div><div class="col-md-7 col-lg-7"><div class="row"><div class="col-md-11 col-lg-11"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-sm-7 col-md-7 col-lg-7"><b class="text-danger"><span translate="INGREDIENT_BATCH_QUANTITY"></span></b> <i class="fa fa-asterisk req"></i></div><div class="col-sm-5 col-md-4 col-lg-4" style="text-align:right"><b class="text-danger"><span translate="PRODUCES"></span></b></div></div></div><div class="panel-body"><div class="row" style="padding: 6px 0px; border-bottom: 1px dotted #eee; font-size: 120%"><div class="form-group col-sm-7 col-md-7 col-lg-7"><input type="number" class="form-control" name="Batch" placeholder="Batch Quantity" style="display:inline-block;width:100px" ng-model="vm.batch" ng-change="vm.batchChanged()" min="1"> <a href="" class="btn btn-primary" ng-click="vm.adjustBatch(1)"><i class="ion ion-plus-round"></i></a> <a href="" class="btn btn-primary" ng-click="vm.adjustBatch(-1)"><i class="ion ion-minus-round"></i></a></div><div class="col-sm-5 col-md-5 col-lg-3" style="text-align:right;padding-right:0px;line-height:40px"><big style="color:#2f317a"><b>{{ vm.prodQty }}</b></big></div><div class="col-sm-5 col-md-5 col-lg-2" style="line-height:40px"><big style="color:#2f317a"><b>{{vm.recipe.uom}}</b></big></div></div></div></div></div></div><div class="row" ng-if="vm.canAccessIngredient"><div class="col-md-11 col-lg-11"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-init="isOpen = $index == 0 ? true : false" is-open="isOpen" ng-repeat="recipe in vm.childRecipes"><uib-accordion-heading><div class="row"><div class="col-sm-7 col-md-7 col-lg-7" style="line-height:130%;color:#2f317a"><i class="ion-arrow-expand" style="margin-right:15px"></i> <b>{{recipe.childRecipeName | uppercase}}</b></div><div class="col-sm-3 col-md-3 col-lg-3" style="text-align:right;padding-right:0px;color:#2f317a"><b>{{recipe.childRecipeDisplayQty | number}}</b></div><div class="col-sm-2 col-md-2 col-lg-2" style="color:#2f317a"><b>{{recipe.childRecipeUom}}</b> <a href="" style="margin-left:15px" title="View Linked Recipe" class="pull-right" ui-sref="recipes.cards.view({id:recipe.childRecipeId})"><i class="fa fa-external-link"></i></a></div></div></uib-accordion-heading><div class="row" style="padding-top:4px;padding-bottom:4px;border-bottom:1px dotted #eee;font-size:110%" ng-repeat="ingredient in recipe.childRecipeItems | orderBy: \'itemName\'"><div class="col-md-8 col-lg-8" style="line-height:130%;padding-left:25px;color:#333">{{ingredient.itemName | uppercase}}</div><div class="col-xs-6 col-sm-6 col-md-2 col-lg-2" style="line-height:130%;text-align:right;padding-right:0px;color:#333"><b>{{ ingredient.displayQty | number }}</b></div><div class="col-xs-6 col-sm-6 col-md-2 col-lg-2" style="line-height:130%;color:#333"><b>{{ingredient.unitOfMeasurement.name}}</b></div></div></uib-accordion-group></uib-accordion></div></div><div class="row" ng-if="vm.canAccessIngredient"><div class="col-md-11 col-lg-11"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-init="isOpen = $index == 0 ? true : false" is-open="isOpen" ng-repeat="(group, items) in vm.ingredients | groupBy:\'groupName\'"><uib-accordion-heading><div class="row"><div class="col-lg-12" style="line-height:130%"><i class="ion-arrow-expand" style="margin-right:15px"></i> <b>{{group==\'\'?(\'OTHER_INGREDIENTS\' | translate ):group | uppercase}}</b></div></div></uib-accordion-heading><div class="row" style="padding-top:4px;padding-bottom:4px;border-bottom:1px dotted #eee;font-size:110%" ng-repeat="ingredient in items | orderBy: \'itemName\'"><div class="col-md-8 col-lg-8" style="line-height:130%;padding-left:25px">{{ingredient.itemName | uppercase}}</div><div class="col-xs-6 col-sm-6 col-md-2 col-lg-2" style="text-align:right;padding-right:0px;color:#000"><b>{{ ingredient.displayQty | number }}</b></div><div class="col-xs-6 col-sm-6 col-md-2 col-lg-2" style="color:#000"><b>{{ingredient.uom}}</b></div></div></uib-accordion-group></uib-accordion></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><br><center><a href="#step_1" class="btn btn-success btn-with-icon btn-lg" du-smooth-scroll="" ng-click="vm.startStep()"><i class="ion ion-flag"></i> <span translate="START_NOW"></span></a></center></div></div></div></div><a ng-if="vm.recipe.recipeSteps==0" name="step_1"></a><div class="row" ng-repeat="s in vm.recipe.recipeSteps | orderBy: \'step\'"><a name="step_{{s.step+1}}"></a><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="step col-md-5 col-lg-5" align="center"><ng-youtube-embed url="s.attachmentLocation" width="100%" height="492px" showinfo="false" controls="false" rel="false" ng-if="s.attachmentType==\'youtube\' && s.attachmentLocation!=\'\' && s.attachmentLocation!=null"></ng-youtube-embed><iframe ng-src="{{s.finalVimeoUrl}}" width="100%" height="400" frameborder="0" style="background:#000" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" ng-if="s.attachmentType.substring(0,5)==\'video\' && s.isVimeoConverted && s.vimeoVideoId!=\'\'"></iframe><img src="{{vm.rootUrl}}{{s.attachmentLocation}}" alt="" class="step-image-card" style="width:100%;cursor:pointer" fancyboxable="{href:\'{{vm.rootUrl}}{{s.attachmentLocation}}\'}" ng-if="s.attachmentType.substr(0,5)==\'image\' && (s.attachmentLocation!=\'\' && s.attachmentLocation!=null)"> <img src="assets/img/empty_placeholder.png" alt="" style="width:100%" class="step-image-card" ng-if="s.attachmentLocation==\'\' || s.attachmentLocation==null"></div><div class="col-md-7 col-lg-7"><div class="row"><div class="col-md-12 col-lg-12"><div style="padding: 10px;"><h1 style="margin-bottom:20px;"><span translate="STEP"></span> {{s.step+1}}</h1><div style="font-size:16pt;line-height:150%;margin-bottom:20px;white-space:pre-wrap">{{s.description}}</div><div style="font-size:14pt;line-height:150%;color:#b00;" ng-show="s.extraDescription"><em><b>* <span translate="ATTENTION"></span> *</b></em><div style="color:#b00;white-space:pre-wrap">{{s.extraDescription}}</div></div></div></div></div></div><div class="col-md-12 col-lg-12"><div class="row"><div class="col-md-12 col-lg-12"><a href="#step_{{s.step+2}}" class="btn btn-success btn-with-icon btn-lg pull-right" du-smooth-scroll="" ng-hide="s.step+1==vm.recipe.recipeSteps.length"><i class="ion ion-chevron-right"></i> <span translate="NEXT_STEP"></span></a> <a href="#step_{{s.step}}" class="btn btn-primary btn-with-icon btn-lg pull-right" style="margin-right:10px" du-smooth-scroll="" ng-hide="s.step==0 || s.step+1==vm.recipe.recipeSteps.length"><i class="ion ion-chevron-left"></i> <span translate="PREV_STEP"></span></a> <a href="#step_1" class="btn btn-primary btn-with-icon btn-lg pull-right" style="margin-right:10px" du-smooth-scroll="" ng-hide="s.step+1!=vm.recipe.recipeSteps.length"><i class="ion ion-chevron-up"></i> <span translate="START_OVER"></span></a></div></div></div></div></div></div><div class="row" ng-show="vm.recipe.recipeSteps.length==0"><div class="col-md-12 col-lg-12"><table class="table table-striped"><tbody><tr><td align="center"><br><span translate="STEP_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div></div><div class="row" ng-if="vm.showView2"><div class="col-lg-12"><div id="kitchenjobdetail" class="kitchenjobdetail"><div class="kj-jobheader" ng-class="{ \'kj-jobheader-start\': vm.recipe.isStarted==true, \'kj-jobheader-hold\': vm.recipe.isOnHold==true }"><div class="kj-left"><img class="kj-image" src="{{vm.recipe.thumbnail || vm.recipe.imageLocation}}"></div><div class="kj-right"><a href="" class="kj-close pull-right" ng-click="vm.goToView1()"><i class="fa fa-times fa-2x"></i></a> <span class="kj-recipename"><b>{{ vm.recipe.name }}</b></span></div><br><div><a href="" class="kj-start btn btn-lg btn-with-icon btn-success" ng-if="vm.recipe.isStarted!=true" ng-click="vm.startJob(true)"><i class="fa fa-play"></i> Start Cooking</a> <a href="" class="kj-start btn btn-lg btn-with-icon btn-success" ng-if="vm.recipe.isStarted==true && !vm.isRunning" ng-click="vm.resumeJob()"><i class="fa fa-play"></i> Continue Cooking</a></div><div class="kj-progress" ng-if="vm.recipe.isStarted==true && vm.isRunning"><div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width:{{ (vm.recipe.timeLapsed / vm.recipe.totalTimeSecond * 100) | number:0 }}%"></div></div><div class="kj-progress-time" ng-if="vm.recipe.isCompleted!=true">Time Remaining : {{ vm.convertStoMs(vm.recipe.totalTimeSecond - vm.recipe.timeLapsed) }}</div><div class="kj-progress-time" ng-if="vm.recipe.isCompleted==true">Ready to serve!</div></div><div style="margin-top:10px" ng-if="vm.selectedSensor!=null">Sensor In Use : <b style="color:#0f0">{{vm.selectedSensor.description}}</b> &nbsp;&nbsp;&nbsp; <a href="" class="btn btn-default btn-xs" ng-if="vm.recipe.isStarted!=true" ng-click="vm.showSensorSelectionDialog()"><i class="fa fa-refresh"></i></a> &nbsp;&nbsp;&nbsp; <a href="" class="btn btn-danger btn-xs" ng-if="vm.recipe.isStarted!=true" ng-click="vm.cancelSelectSensor()"><i class="fa fa-times"></i></a></div></div><div class="kj-tabs" role="group"><a href="" class="btn btn-with-icon" ng-class="{ \'btn-primary\': vm.selectedTab1, \'btn-default\': !vm.selectedTab1 }" ng-click="vm.selectTab1()"><i class="fa fa-leaf"></i> {{ \'INGREDIENTS\' | translate }}</a> <a href="" class="btn btn-with-icon" ng-class="{ \'btn-primary\': vm.selectedTab2, \'btn-default\': !vm.selectedTab2 }" ng-click="vm.selectTab2()"><i class="fa fa-lightbulb-o"></i> {{ \'INSTRUCTIONS\' | translate }}</a></div><div class="kj-jobingredients" ng-if="vm.selectedTab1"><div class="jobingredient" ng-repeat="i in vm.recipe.recipeItems"><div class="kj-uom">{{ i.quantity | number }} {{ i.unitOfMeasurement.name }}</div><div class="kj-itemname">{{ i.itemName }}</div></div></div><div class="kj-jobsteps" ng-if="vm.selectedTab2"><div class="jobstep" ng-class="{ \'inactive\' : s.isStarted==false }" ng-repeat="s in vm.recipe.recipeSteps" ng-if="s.isCompleted!=true"><div class="jobstep-content">Step {{ s.step + 1}} :<div class="row"><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8"><div class="stepdesc">{{ s.description }}</div><div class="stepextradesc" ng-if="s.extraDescription">{{ s.extraDescription }}</div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="row" ng-if="!s.enableTemperatureControl"><div class="col-lg-12 steptime">{{ (s.totalTimeSecond - s.timeLapsed) | number:0 }}s<div ng-if="s.isStarted==true"><small>Remaining</small></div></div></div><div ng-if="s.enableTemperatureControl" class="steptemp"><div ng-if="s.isStarted==true"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" style="margin-bottom:30px"><b>{{ s.targetTemperatureCelcius || \'-\' }}</b><small>&deg;C</small><div style="line-height:11px !important"><small>Target<br>Temp.</small></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><span ng-class="{ \'blink\': vm.interval!=null }" style="margin-bottom:30px;color:#f00"><b>{{ vm.sensorStats.temperature || \'-\' }}</b><small>&deg;C</small></span><div style="line-height:11px !important"><small>Sensor<br>Temp.</small></div></div></div><div class="row" ng-if="vm.interval==null && vm.proceedNextStep"><div class="col-lg-12 success"><i class="fa fa-check"></i> <small class="blink">Proceed To Next Step</small></div></div></div></div></div></div></div><div class="jobstep-progress progress" ng-if="s.isStarted==true"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width:{{ (s.timeLapsed / s.totalTimeSecond * 100) | number:0 }}%"></div></div></div><a href="" class="kj-complete btn btn-lg btn-success" ng-if="vm.recipe.isCompleted==true" ng-click="vm.restart()">RESTART</a></div></div></div></div></div><script type="text/ng-template" id="sensorDialogModal.html"><form name="$mdl.shareForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header" style="background:#2f59d4"> <h3 class="modal-title" style="color:#fff"> <center>{{ \'SELECT_A_SENSOR\' | translate }}</center> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12" style="max-height:400px;overflow:auto"> <div ng-repeat="s in $mdl.sensorList"> <a href class="btn btn-default btn-lg" style="display:block;width:95%;margin:0px auto 5px" ng-class="{ \'btn-primary\': (s.id==$mdl.selectedSensor.id) }" ng-click="$mdl.selectSensor(s)"> {{ s.description }} </a> </div> <div class="col-lg-12" style="height:400px" ng-if="$mdl.isLoading"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center> </div> </div> </div> </div> <legend></legend> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon btn-sm" type="submit" ng-disabled="$mdl.isLoading || $mdl.lockButton || $mdl.selectedSensor==null" style="float:left"> <i class="fa fa-check"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon btn-sm" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="shareDialogModal.html"><form name="$mdl.shareForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header" style="background:#2f59d4"> <h3 class="modal-title" style="color:#fff"> <i class="fa fa-paper-plane"></i> &nbsp;<span translate="EZYSHARE"></span> &nbsp; <span style="font-size:10pt"><span translate="SHARE_SECURELY"></span> &bull; <span translate="EASILY"></span></span> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"> <b><span translate="ENTER_THE_RECIPIENT_EMAIL_ADDRESS"></span>:</b> <br /><small><span translate="NOTE:_ENTER_MULTIPLE_EMAIL_ADDRESSES_AND_SEPARATE_THEM_BY_COMMA_(,)_OR_SEMI-COLON"></span> (;)</small> </label> <input name="Email" type="text" class="form-control" style="background:#ffffff" autocomplete="off" ng-model="$mdl.item.recipientEmail" ng-disabled="$mdl.lockButton" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.shareForm.Email.$error.required && $mdl.shareForm.$submitted">* <span translate="EMAIL_ADDRESS_IS_REQUIRED"></span></p> <p class="help-block" style="color:#f00" ng-show="$mdl.shareForm.Email.$error.email && $mdl.shareForm.$submitted">* <span translate="INVALID_EMAIL_FORMAT"></span></p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b><span translate="ENTER_A_PASSWORD_TO_ACCESS_THE_LINK"></span>:</b></label> <input name="Password" type="password" class="form-control" style="background:#ffffff" autocomplete="off" ng-model="$mdl.item.password" ng-disabled="$mdl.lockButton" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.shareForm.Password.$error.required && $mdl.shareForm.$submitted">* <span translate="PASSWORD_IS_REQUIRED"></span></p> </div> </div> </div> <legend ng-if="$mdl.showSuccess || $mdl.showError"></legend> <div class="row" ng-if="$mdl.showSuccess"> <div class="col-lg-12"> <span style="color:#0a8a0a"> <i class="fa fa-check"></i> &nbsp; <span translate="A_SECURED_LINK_HAS_BEEN_SENT_TO_THE_RECIPIENT_SUCCESSFULLY"></span>. </span> </div> </div> <div class="row" ng-if="$mdl.showError"> <div class="col-lg-12"> <span style="color:#f00"> <i class="fa fa-exclamation-triangle"></i> &nbsp; <span style="color:#f00" ng-bind-html="$mdl.errorMsg"></span> </span> </div> </div> </div> <legend></legend> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon btn-lg" type="submit" ng-disabled="$mdl.lockButton" style="float:left"> <i class="fa fa-paper-plane"></i> <span translate="SHARE"></span> </button> <button class="btn btn-danger btn-with-icon btn-lg" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> <br /> <div ng-if="$mdl.lockButton && !$mdl.showSuccess && !$mdl.showError" style="float:left;margin-top:10px"> <i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </div> </div> </form></script>');
$templateCache.put('app/pages/recipes/categories/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><span translate="PLEASE_FILL_IN_THE_CATEGORY_INFORMATION"></span>.</p><div class="row">&nbsp;</div><div class="row"><div class="col-md-4 col-lg-4"><div class="row"><img ngf-src="picFile || vm.cate.imageLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div><div class="row"><div class="col-md-12 col-lg-12"><p><small><i class="fa fa-info-circle"></i> <em><span translate="RECOMMENDED_TO_UPLOAD_A_LANDSCAPE_IMAGE"></span>.</em></small></p>&nbsp;</div></div><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-disabled="vm.lockUploadButton" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> {{ \'UPLOAD_PICTURE\' | translate }}</div><a href="" ng-click="picFile=null;vm.setUploadImage(picFile)" ng-show="picFile" class="btn btn-default btn-with-icon" ng-disabled="vm.lockUploadButton"><i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }}</a></div><div class="row" ng-show="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div><div class="col-md-4 col-lg-4"><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-class="{\'has-error\': vm.dataForm.CateName.$invalid && (vm.dataForm.CateName.$dirty || vm.dataForm.$submitted)}"><label for="CateName"><b translate="CATEGORY_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CateName" ng-model="vm.cate.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CateName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label for="CateDescription"><b translate="CATEGORY_DESCRIPTION"></b></label> <textarea class="form-control" name="CateDescription" ng-model="vm.cate.description">\n\t\t\t\t\t\t\t\t\t</textarea></div></div><div class="row" ng-if="vm.hasFranchiseAccess"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label><b translate="IS_FRANCHISE?"></b></label><div><toggle ng-model="vm.cate.isFranchise" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div><div class="col-md-12 col-lg-12"><div><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="{{ \'BRANCH_ACCESS\' | translate }}"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p><span translate="SELECT_AT_LEAST_ONE_(1)_BRANCH_WHICH_CAN_ACCESS_THIS_RECIPE_CATEGORY"></span>: <i class="fa fa-asterisk req"></i></p></div></div><div class="row" ng-repeat="b in vm.branches" style="margin-bottom:5px"><div class="col-md-12"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" name="branch" checklist-model="vm.selectedBranches" checklist-value="b" checklist-change="vm.dataForm.branch.$setValidity(\'required\', vm.selectedBranches.length > 0)" ng-required="!vm.selectedBranches.length"> <label><span><b>{{ b.name }}</b></span></label></div></div></div><div class="row"><div class="col-md-12"><p><div class="col-md-12" ng-class="{ \'has-error\': vm.dataForm.$submitted && vm.dataForm.branch.$invalid }"><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.branch.$invalid">* <span translate="REQUIRED_AT_LEAST_ONE_(1)_BRANCH"></span></span></div></p></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/recipes/categories/categoryCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/recipes/categories/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_CATEGORY"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="recipes.categories.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/recipes/categories/categoryList.html','<div class="widgets recipe"><div class="row"><div class="col-md-12" ba-panel=""><div class="row"><div class="col-md-8 col-lg-8"><p><span translate="LIST_OF_RECIPE_CATEGORIES"></span>. <a href="" class="btn btn-primary btn-with-icon" ui-sref="recipes.categories.create" style="margin-left:20px" rms-check-access="recipes.categories" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_CATEGORY"></span></a></p></div><div class="col-md-1 col-lg-1"></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" ng-model="searchText" placeholder="Search for Recipe"></div></div><p><small><i class="fa fa-info-circle"></i> <em><span translate="CLICK_ON_ONE_OF_THE_TILES_TO_EDIT"></span>.</em></small><br>&nbsp;</p><div class="row"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-repeat="cat in vm.cateDataFull | filter:searchText as filteredRecord"><a href="" ui-sref="recipes.categories.update({id:cat.id})"><div class="img" afkl-lazy-image="{{cat.thumbnail || cat.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4><b>{{cat.name | uppercase}}</b></h4><i class="fa fa-pencil" rms-check-access="recipes.categories" rms-check-access-perm-type="UPDATE"></i></a></div></div><div class="row" ng-if="filteredRecord.length==0"><div class="tile-container col-lg-12" ba-panel=""><div style="background:#fafafa;height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></div></div></div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3"><br><span translate="TOTAL_RECORDS:"></span> <b>{{filteredRecord.length}}</b><br>&nbsp;</div></div></div></div>');
$templateCache.put('app/pages/recipes/categories/categoryUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/recipes/categories/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="recipes.categories.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.dataForm.$valid && vm.dataForm.$submitted"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="recipes.categories.list" ng-disabled="vm.dataForm.$valid && vm.dataForm.$submitted"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-warning btn-with-icon" style="float:right" ng-disabled="vm.dataForm.$valid && vm.dataForm.$submitted" confirmed-click="vm.deleteRecipeCategory()" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Recipe Category?" rms-check-access="recipes.categories" rms-check-access-perm-type="DELETE"><i class="ion ion-android-delete"></i> <span translate="DELETE_CATEGORY"></span></a></div></form>');
$templateCache.put('app/pages/report/reportcenter/reportcenter.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><p><i class="fa fa-bar-chart"></i> &nbsp;<span translate="LIST_OF_REPORTS_FOR_ALL_THE_MODULES_AVAILABLE_IN_THE_SYSTEM."></span></p><table class="table table-striped" style="border:5px solid #eee"><thead><tr class="sortable"><th translate="REPORT_NAME"></th><th colspan="2" translate="REPORT_DESCRIPTION"></th><th style="width:10px"></th><th style="width:120px"></th></tr></thead><tbody ng-if="vm.isLoading"><tr><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="LOADING_LIST_OF_REPORTS_..."></span></b></center></big></td></tr></tbody><tbody ng-if="!vm.isLoading" ng-repeat="(key, value) in vm.reports | groupBy: \'moduleName\'"><tr ng-if="key !== \'undefined\'" class="text-uppercase text-danger"><td colspan="9"><b>{{key}}</b></td></tr><tr ng-repeat="item in value" ng-class="{ \'report-colorchange\' : item.isProcessing }"><td style="padding-top:8px;padding-bottom:8px;line-height:150%"><b>{{item.name}}</b></td><td class="text-center" style="width:80px;line-height:100%"><div class="report-type-tag">{{item.type}}</div></td><td style="padding-top:8px;padding-bottom:8px;line-height:150%">{{item.description}}</td><td></td><td><a href="" class="btn btn-primary btn-with-icon btn-xs" style="display:inline-block;font-size:10pt;width:100px" ng-click="vm.showDownloadDialog(item)" rms-check-access="reportcenter" rms-check-access-perm-type="EXPORT"><i class="fa fa-download"></i> <span translate="DOWNLOAD"></span></a></td></tr></tbody></table><p><br></p></div></div></div><script type="text/ng-template" id="downloadTemplate.html"><style type="text/css"> .<span translations="HELP-BLOCK:"></span> { color: #f00 !important; } </style> <form name="$mdl.downloadForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header" style="background:#2f59d4"> <h3 class="modal-title" style="color:#fff"> <b>{{$mdl.item.name}}</b> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row" ng-if="$mdl.item.hasDateRange"> <div class="col-lg-6"> <div class="form-group"> <label style="color:#000"><b translate="DATE_FROM:"></b> <i class="fa fa-asterisk req"></i></label> <div moment-picker="$mdl.item.dateFrom" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control" name="DateFrom" autocomplete="off" style="background:#FFFCED" ng-disabled="$mdl.isProcessing" ng-model="$mdl.item.dateFrom"> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.downloadForm.DateFrom.$error.required && $mdl.downloadForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label style="color:#000"><b translate="DATE_TO:"></b> <i class="fa fa-asterisk req"></i></label> <div moment-picker="$mdl.item.dateTo" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control" name="DateTo" autocomplete="off" style="background:#FFFCED" ng-disabled="$mdl.isProcessing" ng-model="$mdl.item.dateTo"> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.downloadForm.DateTo.$error.required && $mdl.downloadForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row" ng-if="$mdl.item.hasSensor && $mdl.item.moduleState==\'iotdashboard\'"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b translate="SELECT_A_SENSOR:"></b></label> <select class="form-control" style="background:#FFFCED" ng-if="$mdl.item.hasSensor" ng-disabled="$mdl.isProcessing" ng-options="s as (s.gatewayDescription + \' -> \' + s.description | uppercase) for s in $mdl.sensorList | orderBy:[\'gatewayDescription\',\'description\']" ng-model="$mdl.selectedSensor"> <option></option> </select> </div> </div> </div> <div class="row" ng-if="$mdl.item.hasSensor && $mdl.item.moduleState==\'iotdashboard.smartiot\'"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b translate="SELECT_A_SENSOR:"></b></label> <select class="form-control" style="background:#FFFCED" ng-if="$mdl.item.hasSensor" ng-disabled="$mdl.isProcessing" ng-options="s as ((s.groupName || \'NO GROUP\') + \' -> \' + s.description | uppercase) for s in $mdl.sensorList | orderBy:[\'groupName\',\'description\']" ng-model="$mdl.selectedSensor"> <option></option> </select> </div> </div> </div> <div class="row" ng-if="!$mdl.item.hasDateRange && !$mdl.item.hasSensor"> <div class="col-lg-12"> <span translate="PLEASE_PROCEED_TO_DOWNLOAD_PDF"></span> <span ng-if="$mdl.item.hasExcel">/ <span translate="EXCEL"></span></span> <span translate="FORMAT"></span>. </div> </div> </div> <hr /> <div class="modal-footer"> <div> <button type="button" class="btn btn-warning btn-with-icon btn-md" style="width:150px;float:left" ng-disabled="$mdl.isProcessing" ng-if="$mdl.item.hasPdf" ng-click="$mdl.downloadPdf()"> <i class="fa fa-download"></i> {{ \'PDF\' | translate }} </button> <button type="button" class="btn btn-primary btn-with-icon btn-md" style="width:150px;float:left" ng-disabled="$mdl.isProcessing" ng-if="$mdl.item.hasExcel" ng-click="$mdl.downloadExcel()"> <i class="fa fa-download"></i> {{ \'EXCEL\' | translate }} </button> <button type="button" class="btn btn-danger btn-with-icon btn-md" ng-disabled="$mdl.isProcessing" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CLOSE\' | translate }} </button> </div> <div ng-if="$mdl.isProcessing" style="text-align:left !important;padding:10px 0px 0px;color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'GENERATING_REPORT,_PLEASE_WAIT_...\' | translate }} </div> </div> </div></script>');
$templateCache.put('app/pages/recipes/recipes/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><div class="panel-heading"><span translate="RECIPE_NAME"></span>: <b>{{vm.recipe.name | uppercase}}</b></div><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-show="!vm.recipe.isApproved"><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_RECIPE_INFORMATION."></span></p><div ng-show="vm.recipe.isApproved" class="alert bg-warning" style="color:#333"><i class="fa fa-exclamation-triangle"></i> <span translate="ALL_THE_FIELDS_ARE_LOCKED_WHEN_STATUS_IS"></span> <b translate="APPROVED"></b>. <span translate="PLEASE_INFORM_THE_MANAGER_TO"></span> <b translate="UNAPPROVE"></b> <span translate="IF_YOU_WISH_TO_MAKE_CHANGES"></span>.</div><div class="row">&nbsp;</div><div class="row"><div class="col-md-4 col-lg-4"><div class="row"><img ngf-src="picFile || vm.recipe.imageLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div><div class="row"><div class="col-md-12 col-lg-12"><p><small><i class="fa fa-info-circle"></i> <em><span translate="RECOMMENDED_TO_UPLOAD_A_LANDSCAPE_IMAGE"></span>.</em></small></p>&nbsp;</div></div><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-hide="vm.lockUploadButton || vm.recipe.isApproved" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> {{ \'UPLOAD_PICTURE\' | translate }}</div><a href="" class="btn btn-default btn-with-icon" ng-click="picFile=null;vm.clearImage()" ng-hide="vm.lockUploadButton || vm.recipe.isApproved" ng-show="(picFile || vm.recipe.imageLocation) && !vm.lockUploadButton"><i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }}</a></div><div class="row" ng-show="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div><div class="col-md-4 col-lg-4"><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-class="{\'has-error\': vm.dataForm.RecipeName.$invalid && (vm.dataForm.RecipeName.$dirty || vm.dataForm.$submitted)}"><label for="RecipeName"><b translate="RECIPE_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="RecipeName" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RecipeName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label for="ActualQuantity"><b translate="AVERAGE_ACTUAL_YIELD_QUANTITY(PER_BATCH)"></b> <i class="fa fa-asterisk req"></i></label><br><label><small><i class="fa fa-info-circle"></i> {{ \'THE_AVERAGE_ACTUAL_QUANTITY_PRODUCED_PER_BATCH\' | translate }}</small></label><div class="row"><div class="col-sm-6 col-md-6 col-lg-6" style="padding-right:2px" ng-class="{\'has-error\': vm.dataForm.ActualQuantity.$invalid && (vm.dataForm.ActualQuantity.$dirty || vm.dataForm.$submitted) }"><input type="number" class="form-control" min="0.001" name="ActualQuantity" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.actualQuantity" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ActualQuantity.$error.required">* <span translate="QUANTITY_IS_REQUIRED"></span></span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ActualQuantity.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ActualQuantity.$error.min">* {{ \'MINIMUM_VALUE_IS_001\' | translate }}</span></div><div class="col-sm-6 col-md-6 col-lg-6" style="padding-left:2px" ng-class="{\'has-error\': vm.dataForm.UOM2.$invalid && vm.dataForm.$submitted }"><select name="UOM2" class="form-control" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-options="i as (i.name | uppercase) for i in vm.uomList" ng-model="vm.selectedUom" ng-change="vm.selectedUomChanged()" required=""><option value="">{{ \'SELECT_AN_UOM\' | translate }}</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UOM2.$error.required">* <span translate="UOM_IS_REQUIRED"></span></span></div></div></div></div><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label><i class="fa fa-info-circle" uib-tooltip="To enable the final food cost to display in other UOM" tooltip-placement="top"></i>&nbsp; <b>{{ \'ENABLE_ALT_UOM\' | translate }}</b></label><div><toggle ng-model="vm.recipe.enableAltUom" ng-change="vm.enableAltUomChanged()" ng-disabled="vm.recipe.isApproved" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4" style="padding-left:2px;padding-right:2px" ng-if="vm.recipe.enableAltUom"><label><b>{{ \'ALT_UOM\' | translate }}</b></label><select name="Alt_UOM" class="form-control" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-options="i as (i.name | uppercase) for i in vm.uomList" ng-model="vm.selectedAltUom" ng-change="vm.selectedAltUomChanged()" ng-required="vm.recipe.enableAltUom"><option value="">{{ \'SELECT_AN_UOM\' | translate }}</option></select></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4" style="padding-left:2px" ng-class="{\'has-error\': vm.dataForm.Alt_UOM_Multiplier.$invalid && (vm.dataForm.Alt_UOM_Multiplier.$dirty || vm.dataForm.$submitted)}" ng-if="vm.recipe.enableAltUom"><label><b>{{ \'ALT_UOM_MULTIPLIER\' | translate }}</b></label> <input type="number" name="Alt_UOM_Multiplier" class="form-control" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.altUomMultiplier" min="0.001" ng-required="vm.recipe.enableAltUom"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Alt_UOM_Multiplier.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Alt_UOM_Multiplier.$error.min">* {{ \'MINIMUM_VALUE_IS_001\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Alt_UOM_Multiplier.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label><b>{{ \'SIZE_/_DIMENSION\' | translate }}</b></label> <input type="text" class="form-control" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.dimension"></div></div><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.remarks">\n\t\t\t\t\t\t\t\t\t</textarea></div></div><div class="row" ng-if="vm.hasSAKModule"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label><b>{{ \'ASSOCIATED_EQUIPMENT\' | translate }}:</b></label><br><label><small><i class="fa fa-info-circle"></i> {{ \'SELECT_A_EQUIPMENT_SUITABLE_FOR_THIS_RECIPE\' | translate }}</small></label><div class="input-group"><span class="input-group-addon" style="padding:0px"><i class="fa fa-question-circle" style="padding:3px 10px" uib-tooltip="To create new or edit Equipment, go to: Maintenance &rarr; Equipment"></i></span><ui-select name="Equipment" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" ng-disabled="vm.recipe.isApproved" append-to-body="false" search-enabled="true" ng-model="vm.selectedEquipment" on-select="vm.selectedEquipmentChanged()"><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.name | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.equipmentList | orderBy:\'code\' | filter: $select.search" refresh="vm.loadEquipmentList($select.search)" refresh-delay="250" minimum-input-length="2"><span ng-bind-html="vm.beautify(i) | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row" ng-if="vm.hasSAKModule"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label><b>{{ \'SMART_EQUIPMENT_MENU_CODE_OR_ID\' | translate }}:</b></label> <input type="text" class="form-control" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.thirdPartyMenuCode"></div></div></div><div class="col-md-4 col-lg-4" rms-check-access="recipes.recipes" rms-check-access-perm-type="APPROVE"><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label><b translate="IS_APPROVED?"></b></label><div><toggle ng-model="vm.recipe.isApproved" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label><b translate="IS_PUBLISHED?"></b></label><div><toggle ng-model="vm.recipe.isPublic" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label><b translate="CREATED_DATE"></b></label><div>{{ vm.recipe.createdDate | date:\'dd/MM/yyyy\' }}</div></div></div></div></div><hr><div class="row"><div class="col-lg-8"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:40px">#</th><th colspan="2">{{ \'ASSOC_SEMIFG\' | translate }}</th><th style="width:80px"></th></tr></thead><tbody><tr ng-if="(!vm.recipe.semiFinishedProducts || vm.recipe.semiFinishedProducts.length==0) && !vm.isLoading"><td colspan="4" style="height:100px;line-height:100px"><center>{{ \'NO_SEMIFG_ASSOC\' | translate}}</center></td></tr><tr ng-repeat="item in vm.recipe.semiFinishedProducts | orderBy:\'description\'"><td>{{ $index+1 }})</td><td style="width:200px">{{ item.code | uppercase }}</td><td>{{ item.description | uppercase }}</td><td style="width:80px"><a class="btn btn-primary editable-table-button btn-with-icon btn-xs" ui-sref="maintenance.semifgs.update({id:item.id})" rms-check-access="maintenance.semifgs" rms-check-access-perm-type="UPDATE" style="width:80px"><i class="fa fa-eye"></i> {{ \'VIEW\' | translate }}</a></td></tr></tbody></table><br><br><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:40px">#</th><th colspan="2">{{ \'ASSOC_FG\' | translate }}</th><th style="width:80px"></th></tr></thead><tbody><tr ng-if="(!vm.recipe.products || vm.recipe.products.length==0) && !vm.isLoading"><td colspan="4" style="height:100px;line-height:100px"><center>{{ \'NO_FG_ASSOC\' | translate}}</center></td></tr><tr ng-repeat="item in vm.recipe.products | orderBy:\'description\'"><td>{{ $index+1 }})</td><td style="width:200px">{{ item.code | uppercase }}</td><td>{{ item.name | uppercase }}</td><td style="width:80px"><a class="btn btn-primary editable-table-button btn-with-icon btn-xs" ui-sref="maintenance.products.update({id:item.id})" rms-check-access="maintenance.products" rms-check-access-perm-type="UPDATE" style="width:80px"><i class="fa fa-eye"></i> {{ \'VIEW\' | translate }}</a></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CATEGORIES\' | translate }}"><div ng-show="vm.recipe.isApproved" class="alert bg-warning" style="color:#333"><i class="fa fa-exclamation-triangle"></i> <span translate="ALL_THE_FIELDS_ARE_LOCKED_WHEN_STATUS_IS"></span> <b approved=""></b>. <span translate="PLEASE_INFORM_THE_MANAGER_TO"></span> <b translate="UNAPPROVE"></b> <span translate="IF_YOU_WISH_TO_MAKE_CHANGES"></span>.</div><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p><i class="fa fa-info-circle"></i> <span translate="SELECT_AT_LEAST_ONE"></span> (1) <span translate="RECIPE_CATEGORY"></span> <i class="fa fa-asterisk req"></i></p></div></div><div class="row"><div class="col-md-4 col-lg-4" ng-repeat="c in vm.categoryList" style="margin-bottom:8px;line-height:30px"><input type="checkbox" name="cate" style="float:left;cursor:pointer;width:25px;height:25px" checklist-model="vm.selectedCategories" checklist-value="c" checklist-change="vm.dataForm.cate.$setValidity(\'required\', vm.selectedCategories.length > 0)" ng-disabled="vm.recipe.isApproved" ng-required="!vm.selectedCategories.length"> <span style="padding-left:10px">{{ c.name | uppercase }}</span></div></div><div class="row"><div class="col-md-12"><p><div class="col-md-12" ng-class="{\'has-error\': vm.dataForm.$submitted && vm.dataForm.cate.$invalid }"><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.cate.$invalid">* <span translate="REQUIRE_AT_LEAST_ONE_(1)_RECIPE_CATEGORY"></span></span></div></p><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="{{ \'INGREDIENTS\' | translate }}"><div ng-show="vm.recipe.isApproved" class="alert bg-warning" style="color:#333"><i class="fa fa-exclamation-triangle"></i> <span translate="ALL_THE_FIELDS_ARE_LOCKED_WHEN_STATUS_IS"></span> <b translate="APPROVED"></b>. <span translate="PLEASE_INFORM_THE_MANAGER_TO"></span> <b translate="UNAPPROVE"></b> <span translate="IF_YOU_WISH_TO_MAKE_CHANGES"></span>.</div><p><i class="fa fa-info-circle"></i> <span translate="ADD_THE_INGREDIENTS_FOR_THE_RECIPE."></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddIngredientModal()" ng-if="vm.mode==2 && !vm.recipe.isApproved"><i class="ion-plus-round"></i><span translate="ADD_NEW_INGREDIENT"></span></a><br><br></p><div class="row" ng-show="vm.mode==2"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%" st-pipe="vm.refreshRecipeItems" st-table="vm.recipe.recipeItems" refresh-table=""><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="GROUP"></b></th><th style="width:80px"></th><th><b translate="Ingredient Description"></b></th><th style="text-align:right !important"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b translate="UOM"></b></th><th style="width:80px"></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.recipe.recipeItems"><td>{{$index+1}}</td><td>{{ ntn.category || \'\' }}</td><td class="text-center" style="width:80px;line-height:90%"><div class="report-type-tag"><b>{{(ntn.itemId!=null?\'RAW MAT\':(ntn.semiFinishedProductId!=null?\'SEMI FG\':\'MISC\'))}}</b></div></td><td>{{ ntn.itemName || ntn.item.description | uppercase }}<div ng-if="ntn.recipeItemAlts && ntn.recipeItemAlts.length!=0" class="form-control" style="background:#fffeed;margin-bottom:10px;height:auto;line-height:180%"><b translate="ALTERNATIVE_INGREDIENT(S):"></b><br><div ng-repeat="alt in ntn.recipeItemAlts" style="margin-top:4px"><a href="" class="btn btn-xs btn-danger" title="Remove" ng-click="vm.removeAltIngredient($parent.$index, $index)"><i class="fa fa-trash"></i> &nbsp;Remove</a> &nbsp;&nbsp;[ <b>{{(alt.itemId!=null?\'RM\':(alt.semiFinishedProductId!=null?\'SFG\':\'\'))}}</b> ] &nbsp;&nbsp;{{alt.description | uppercase}}</div></div></td><td style="text-align:right">{{ ntn.quantity || \'\' }}</td><td>{{ ntn.unitOfMeasurement.name || \'\' }}</td><td><a class="btn btn-warning btn-with-icon btn-xs" ng-if="vm.isRmsLite!=null && vm.isStarterMode!=null && !vm.isRmsLite && !vm.isStarterMode && (ntn.itemId!=null || ntn.semiFinishedProductId!=null)" ng-click="vm.showAddAltIngredientModal($index)" ng-hide="vm.recipe.isApproved"><i class="fa fa-plus-square"></i> <span translate="ADD_ALT."></span></a></td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditIngredientModal($index)" ng-hide="vm.recipe.isApproved"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeIngredient($index)" ng-confirm-click="Confirm remove this Ingredient?" ng-hide="vm.recipe.isApproved"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="9" align="center" ng-show="vm.recipe.recipeItems.length==0"><br><span translate="INGREDIENT_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center translate="PLEASE_SAVE_THE_RECIPE_FIRST_BEFORE_ADDING_INGREDIENTS."></center></h2></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'INSTRUCTIONS\' | translate }}"><div ng-show="vm.recipe.isApproved" class="alert bg-warning" style="color:#333"><i class="fa fa-exclamation-triangle"></i> <span translate="ALL_THE_FIELDS_ARE_LOCKED_WHEN_STATUS_IS"></span> <b translate="APPROVED"></b>. <span translate="PLEASE_INFORM_THE_MANAGER_TO"></span> <b translate="UNAPPROVE"></b> <span translate="IF_YOU_WISH_TO_MAKE_CHANGES"></span>.</div><p><i class="fa fa-info-circle"></i> <span translate="ADD_THE_STEPS_TO_PRODUCE_THE_FOOD."></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddStepModal()" ng-if="vm.mode==2 && !vm.recipe.isApproved"><i class="ion-plus-round"></i><span translate="ADD_NEW_STEP"></span></a><br><br></p><div class="row" ng-repeat="s in vm.recipe.recipeSteps | orderBy: \'step\'" ng-show="vm.mode==2"><div ba-panel="" class="col-md-12 col-lg-12"><div class="row"><div class="step col-md-4 col-lg-4"><div class="step-image col-md-12 col-lg-12" afkl-lazy-image="{{vm.rootUrl}}{{s.thumbnail || s.attachmentLocation}}" afkl-lazy-image-options="{\'background\': true}" ng-if="s.attachmentType==\'image\' && (s.attachmentLocation!=\'\' && s.attachmentLocation!=null)"></div><div class="step-image col-md-12 col-lg-12" afkl-lazy-image="{{s.vimeoPictureUrl}}" afkl-lazy-image-options="{\'background\': true}" ng-if="s.attachmentType==\'video\' && s.vimeoVideoUrl!=\'\' && s.vimeoVideoUrl!=null"></div><img src="assets/img/video_pending.png" alt="" style="width:100%" class="step-image" ng-if="s.attachmentType==\'video\' && (s.vimeoVideoUrl==\'\' || s.vimeoVideoUrl==null)"> <img src="assets/img/empty_placeholder.png" alt="" style="width:100%" class="step-image" ng-if="s.attachmentLocation==\'\' || s.attachmentLocation==null"></div><div class="col-md-8 col-lg-8"><div class="row"><div class="col-md-12 col-lg-12"><div style="padding:10px;margin-right:20px"><div class="pull-right" style="line-height:200%;margin-top:20px"><div ng-if="s.totalTimeSecond!=0">{{ \'TOTAL_TIME\' | translate }}: <b>{{ s.totalTimeSecond }}</b> {{ \'SECS\' | translate }}</div><div ng-if="vm.hasSmartKitchenModule">{{ \'ENABLE_TEMPERATURE_CONTROL\' | translate }}: <b>{{ s.enableTemperatureControl ? \'YES\' : \'NO\' }}</b></div><div ng-if="vm.hasSmartKitchenModule">{{ \'TARGET_TEMPERATURE\' | translate }}: <b>{{ s.targetTemperatureCelcius || \'-\' }} &deg;C</b></div></div><h4>{{ \'STEP\' | translate }} {{s.step+1}}</h4><p><b>{{s.name}}</b></p><p style="white-space:pre-wrap">{{s.description}}</p><p ng-show="s.extraDescription" style="color:#b00;padding-top:10px"><b>* <span translate="ATTENTION"></span> *</b><div style="color:#b00;white-space:pre-wrap">{{s.extraDescription}}</div></p></div></div></div></div></div><div class="row"><div class="col-md-offset-4 col-lg-offset-4 col-md-7 col-lg-7"><button type="button" class="btn btn-info btn-sm" style="margin-left:15px" ng-click="vm.moveStepUp(s.id)" ng-disabled="s.step==0 || vm.lockMoveButtons" ng-hide="vm.recipe.isApproved"><i class="ion ion-chevron-up"></i></button> <button type="button" class="btn btn-info btn-sm" style="margin-right:10px" ng-click="vm.moveStepDown(s.id)" ng-disabled="s.step==(vm.recipe.recipeSteps.length-1) || vm.lockMoveButtons" ng-hide="vm.recipe.isApproved"><i class="ion ion-chevron-down"></i></button> <button type="button" class="btn btn-info btn-with-icon btn-sm" ng-click="vm.showEditStepModal(s.id)" ng-hide="vm.lockMoveButtons || vm.recipe.isApproved"><i class="ion ion-edit"></i> {{ \'EDIT\' | translate }}</button> <button type="button" class="btn btn-danger btn-with-icon btn-sm" confirmed-click="vm.removeStep(s.id)" ng-confirm-click="Confirm remove this Step?" ng-hide="vm.lockMoveButtons || vm.recipe.isApproved"><i class="fa fa-trash-o"></i> {{ \'REMOVE\' | translate }}</button><br>&nbsp;</div></div></div></div><div class="row" ng-show="vm.mode==2 && vm.recipe.recipeSteps.length==0"><div class="col-md-12 col-lg-12"><table class="table table-striped"><tbody><tr><td align="center"><br><span translate="STEP_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center translate="PLEASE_SAVE_THE_RECIPE_FIRST_BEFORE_ADDING_STEPS."></center></h2></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'OTHER_COSTS\' | translate }}" ng-if="vm.canAccessFoodCost"><div ng-show="vm.recipe.isApproved" class="alert bg-warning" style="color:#333"><i class="fa fa-exclamation-triangle"></i> <span translate="ALL_THE_FIELDS_ARE_LOCKED_WHEN_STATUS_IS"></span> <b translate="APPROVED"></b>. <span translate="PLEASE_INFORM_THE_MANAGER_TO"></span> <b></b> <span translate="IF_YOU_WISH_TO_MAKE_CHANGES"></span></div><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_PRODUCTION_COST_FOR_THIS_RECIPE."></span><br><br></p><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LabourCost.$invalid && (vm.dataForm.LabourCost.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="LABOUR_COST"></span></b> <i class="fa fa-asterisk req"></i></label><p><small><i class="fa fa-info-circle"></i> <span translate="THE_COST_OF_LABOUR_FOR_THE_PRODUCTION_OF_EACH_BATCH_OF_RECIPE"></span></small></p><div class="row"><div class="col-sm-4 col-md-4 col-lg-4"><label>{{ \'AMOUNT\' | translate }} ({{ vm.currencyCode }})</label> <input type="number" class="form-control" name="LabourCost" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.labourCost" required=""></div><div class="col-sm-1 col-md-1 col-lg-1" style="text-align:center"><br>{{ \'OR\' | translate }}</div><div class="col-sm-4 col-md-4 col-lg-4"><label>{{ \'PERCENTAGE\' | translate }} (%)</label> <input type="number" class="form-control" name="LabourCostPercentage" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.labourCostPercentage"></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LabourCost.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LabourCost.$error.number">* <span translate="KEY_IN_NUMBERS_ONLY"></span></span></div></div><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UtilitiesCost.$invalid && (vm.dataForm.UtilitiesCost.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="UTILITIES_COST"></span></b> <i class="fa fa-asterisk req"></i></label><p><small><i class="fa fa-info-circle"></i> <span translate="THE_COST_OF_UTILITIES_FOR_THE_PRODUCTION_OF_EACH_BATCH_OF_RECIPE"></span></small></p><div class="row"><div class="col-sm-4 col-md-4 col-lg-4"><label>{{ \'AMOUNT\' | translate }} ({{ vm.currencyCode }})</label> <input type="number" class="form-control" name="UtilitiesCost" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.utilitiesCost" required=""></div><div class="col-sm-1 col-md-1 col-lg-1" style="text-align:center"><br>{{ \'OR\' | translate }}</div><div class="col-sm-4 col-md-4 col-lg-4"><label>{{ \'PERCENTAGE\' | translate }} (%)</label> <input type="number" class="form-control" name="UtilitiesCostPercentage" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.utilitiesCostPercentage"></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UtilitiesCost.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UtilitiesCost.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span></div></div></div><br><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MachineCost.$invalid && (vm.dataForm.MachineCost.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="MACHINE_COST"></span></b> <i class="fa fa-asterisk req"></i></label><p><small><i class="fa fa-info-circle"></i> <span translate="THE_COST_OF_MACHINE_FOR_THE_PRODUCTION_OF_EACH_BATCH_OF_RECIPE"></span></small></p><div class="row"><div class="col-sm-4 col-md-4 col-lg-4"><label>{{ \'AMOUNT\' | translate }} ({{ vm.currencyCode }})</label> <input type="number" class="form-control" name="MachineCost" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.machineCost" required=""></div><div class="col-sm-1 col-md-1 col-lg-1" style="text-align:center"><br>{{ \'OR\' | translate }}</div><div class="col-sm-4 col-md-4 col-lg-4"><label>{{ \'PERCENTAGE\' | translate }} (%)</label> <input type="number" class="form-control" name="MachineCostPercentage" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.machineCostPercentage"></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MachineCost.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MachineCost.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PackagingCost.$invalid && (vm.dataForm.PackagingCost.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="PACKAGING_COST"></span></b> <i class="fa fa-asterisk req"></i></label><p><small><i class="fa fa-info-circle"></i> <span translate="THE_COST_OF_PACKAGING_FOR_THE_PRODUCTION_OF_EACH_BATCH_OF_RECIPE"></span></small></p><div class="row"><div class="col-sm-4 col-md-4 col-lg-4"><label>{{ \'AMOUNT\' | translate }} ({{ vm.currencyCode }})</label> <input type="number" class="form-control" name="PackagingCost" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.packagingCost" required=""></div><div class="col-sm-1 col-md-1 col-lg-1" style="text-align:center"><br>{{ \'OR\' | translate }}</div><div class="col-sm-4 col-md-4 col-lg-4"><label>{{ \'PERCENTAGE\' | translate }} (%)</label> <input type="number" class="form-control" name="PackagingCostPercentage" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.packagingCostPercentage"></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PackagingCost.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PackagingCost.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span></div></div></div><div class="row"><p><hr></p></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.GrossProfitMargin.$invalid && (vm.dataForm.GrossProfitMargin.$dirty || vm.dataForm.$submitted)}"><label><b>{{\'GROSS_PROFIT_MARGIN\' | translate | uppercase}}</b> <i class="fa fa-asterisk req"></i></label><p><small><i class="fa fa-info-circle"></i> <span translate="THE_GROSS_PROFIT_MARGIN_FOR_THIS_RECIPE"></span></small></p><div class="row"><div class="col-sm-4 col-md-4 col-lg-4"><label>{{ \'AMOUNT\' | translate }} ({{ vm.currencyCode }})</label> <input type="number" class="form-control" name="GrossProfitMargin" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.grossProfitMargin" required=""></div><div class="col-sm-1 col-md-1 col-lg-1" style="text-align:center"><br>{{ \'OR\' | translate }}</div><div class="col-sm-4 col-md-4 col-lg-4"><label>{{ \'PERCENTAGE\' | translate }} (%)</label> <input type="number" class="form-control" name="GrossProfitMarginPercentage" style="color:#333" ng-disabled="vm.recipe.isApproved" ng-model="vm.recipe.grossProfitMarginPercentage"></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.GrossProfitMargin.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.GrossProfitMargin.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'COST_SUMMARY\' | translate }}" ng-if="vm.canAccessFoodCost"><p ng-if="vm.mode==2"><i class="fa fa-info-circle"></i> <span translate="THIS_IS_AN_ESTIMATE_OF_FOOD_COST_BASED_ON_THE_ITEM\'s_SUPPLIER_PRICE_AND_UOM_CONVERSION."></span><br></p><a href="" class="btn btn-warning btn-with-icon btn-sm" style="margin-right:10px" ng-click="vm.printFoodCost(vm.recipe.id, vm.recipe.name)" ng-if="vm.mode==2 && vm.canAccessFoodCost" rms-check-access="recipes.cards" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <span translate="PRINT_FOOD_COST"></span></a> <a href="" class="btn btn-default btn-with-icon btn-sm" style="margin-right:10px" ng-if="vm.mode==2 && vm.canAccessFoodCost" ng-click="vm.loadRecipeFoodCosts()"><i class="ion-ios-calculator"></i> <span translate="RELOAD_COST"></span></a><br><br><div class="row" ng-if="vm.mode==2"><div class="col-lg-12"><div class="form-group"><div class="form-inline"><form editable-form="" name="vm.tableForm"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:60px">#</th><th><b translate="GROUP"></b></th><th><b><span translate="INGREDIENT"></span>&nbsp;({{ \'RAW_MAT_OR_SEMI_FG\' | translate }})</b></th><th style="text-align:right !important"><b quantity=""></b></th><th><b translate="UOM"></b></th><th style="text-align:right"><b><span translate="COST"></span> ({{ vm.currencyCode }})</b><br><small>(<span translate="EXCL_TAX"></span>)</small></th></tr></thead><tbody><tr ng-if="vm.isCalcFoodCost"><td colspan="6" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="CALCULATING_FOOD_COST"></span> ...</b></center></big></td></tr><tr ng-if="vm.recipe.recipeItems.length==0"><td colspan="6" align="center"><br><span translate="INGREDIENT_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr><tr ng-repeat="ntn in vm.foodCosts.foodCostList"><td>{{$index+1}})</td><td>{{ ntn.category || \'\' }}</td><td nowrap="nowrap" style="line-height:150%;padding:5px">{{ ntn.itemName || ntn.item.description | uppercase}}<div ng-if="ntn.childRecipeId!=null || ntn.semiFinishedProductId!=null"><small><a href="" style="color:#00f;z-index:9999" ng-click="ntn.isDisplay=!ntn.isDisplay" ng-show="!ntn.isDisplay"><i class="ion-android-arrow-dropright"></i> <span translate="VIEW_LINKED_RECIPE\'s_INGREDIENTS"></span></a> <a href="" style="color:#00f" ng-click="ntn.isDisplay=!ntn.isDisplay" ng-show="ntn.isDisplay"><i class="ion-android-arrow-dropright"></i> <span translate="HIDE_LINKED_RECIPE\'s_INGREDIENTS"></span></a></small><div class="foodcost-sub-table" ng-show="ntn.isDisplay"><table class="table table-striped table-bordered" style="font-size:90%;margin:5px 0px 10px;border:2px solid #ccc"><tr><th><b><span translate="INGREDIENT"></span> ( <span translate="RAW_MATERIAL"></span>)</b></th><th style="text-align:right !important"><b quantity=""></b></th><th><b translate="UOM"></b></th><th style="text-align:right"><b><span translate="COST"></span> ({{ vm.currencyCode }})</b></th></tr><tr ng-repeat="childNtn in ntn.childFoodCosts"><td nowrap="nowrap">{{ childNtn.itemName || ntn.childNtn.description | uppercase}}</td><td align="right">{{ childNtn.quantity || \'\' }}</td><td>{{ childNtn.uom || \'\' }}</td><td align="right">{{ childNtn.cost | number: 3 }}</td></tr><tr><th><b><span translate="TOTAL_OUTPUT:"></span> {{ ntn.recipeOutputQuantity }} {{ ntn.uom }}</b></th><th colspan="2" style="text-align:right"><b><span translate="TOTAL_COST"></span>:</b></th><th style="text-align:right"><b>{{ ntn.recipeCost | number: 3 }}</b></th></tr></table></div></div></td><td align="right">{{ ntn.quantity || \'\' }}</td><td>{{ ntn.uom || \'\' }}</td><td align="right"><b>{{ ntn.cost | number: 3 }}</b></td></tr><tr><td colspan="6" style="height:10px;line-height:10px;padding:0px !important">&nbsp;</td></tr><tr><td colspan="2"></td><td colspan="3" style="text-align:right"><b><span>{{ \'TOTAL_INGREDIENT_COST\' | uppercase | translate }}</span></b> :</td><td align="right"><b>{{ vm.foodCosts.totalIngredientCost || 0 | number: 3 }}</b></td></tr><tr><td colspan="6" style="height:10px;line-height:10px;padding:0px !important">&nbsp;</td></tr><tr><td colspan="2"></td><td colspan="3" style="text-align:right"><span translate="LABOUR_COST"></span> <span ng-if="vm.recipe.labourCostPercentage!=null && vm.recipe.labourCostPercentage!=0">({{vm.foodCosts.labourCostPercentage | number}}%)</span>:</td><td align="right"><b>{{ vm.foodCosts.labourCost || 0 | number: 3 }}</b></td></tr><tr><td colspan="2"></td><td colspan="3" style="text-align:right"><span translate="PACKAGING_COST"></span> <span ng-if="vm.recipe.packagingCostPercentage!=null && vm.recipe.packagingCostPercentage!=0">({{vm.foodCosts.packagingCostPercentage | number}}%)</span>:</td><td align="right"><b>{{ vm.foodCosts.packagingCost || 0 | number: 3 }}</b></td></tr><tr><td colspan="2"></td><td colspan="3" style="text-align:right"><span translate="UTILITIES_COST"></span> <span ng-if="vm.recipe.utilitiesCostPercentage!=null && vm.recipe.utilitiesCostPercentage!=0">({{vm.foodCosts.utilitiesCostPercentage | number}}%)</span>:</td><td align="right"><b>{{ vm.foodCosts.utilitiesCost || 0 | number: 3 }}</b></td></tr><tr><td colspan="2"></td><td colspan="3" style="text-align:right"><span translate="MACHINE_COST"></span> <span ng-if="vm.recipe.machineCostPercentage!=null && vm.recipe.machineCostPercentage!=0">({{vm.foodCosts.machineCostPercentage | number}}%)</span>:</td><td align="right"><b>{{ vm.foodCosts.machineCost || 0 | number: 3 }}</b></td></tr><tr><td colspan="6" style="height:10px;line-height:10px;padding:0px !important">&nbsp;</td></tr></tbody><tfoot><tr><td colspan="5" align="right"><span translate="TOTAL_COST"></span> (<b>{{vm.recipe.productionQuantity}} {{vm.selectedUom.name}}</b>) :</td><td align="right" style="font-size:14pt;background:rgb(255, 254, 237)"><b>{{ vm.foodCosts.totalFoodCost || 0 | number: 3 }}</b></td></tr><tr><td colspan="5" align="right" nowrap="nowrap"><span translate="COST_PER"></span> <b>{{vm.selectedUom.name}}</b> :</td><td align="right" style="font-size:14pt;background:rgb(255, 254, 237)"><b>{{ vm.foodCosts.costPerKg || 0 | number: 3 }}</b></td></tr><tr><td colspan="5" align="right"><span translate="GROSS_PROFIT_MARGIN"></span> <span ng-if="vm.recipe.grossProfitMarginPercentage!=null && vm.recipe.grossProfitMarginPercentage!=0">({{vm.foodCosts.grossProfitMarginPercentage | number}}%)</span>:</td><td align="right" style="font-size:14pt;background:rgb(255, 254, 237)"><b>{{ vm.foodCosts.grossProfitMargin || 0 | number: 3 }}</b></td></tr><tr><td colspan="5" align="right"><span translate="TOTAL_GROSS_SELLING_PRICE"></span> (<b>{{vm.recipe.productionQuantity}} {{vm.selectedUom.name}}</b>) :</td><td align="right" style="font-size:14pt;background:rgb(255, 254, 237)"><b>{{ vm.foodCosts.totalSellingPrice || 0 | number: 3 }}</b></td></tr><tr><td colspan="5" align="right" nowrap="nowrap">{{ \'SELLING_PRICE_PER\' | translate }} <b>{{vm.selectedUom.name}}</b> :</td><td align="right" style="font-size:14pt;background:rgb(255, 254, 237)"><b>{{ vm.foodCosts.sellingPricePerKg || 0 | number: 3 }}</b></td></tr><tr ng-if="vm.recipe.enableAltUom && vm.recipe.altUomId!=null && vm.recipe.altUomMultiplier!=null"><td colspan="5" align="right" nowrap="nowrap" style="color:#00f">{{ \'SELLING_PRICE_PER\' | translate }} <b>{{vm.selectedAltUom.name}}</b> :</td><td align="right" style="font-size:14pt;background:#fffeed;color:#00f"><b>{{ (vm.foodCosts.totalFoodCost / (vm.recipe.actualQuantity / vm.recipe.altUomMultiplier)) || 0 | number: 3 }}</b></td></tr></tfoot></table></form></div></div></div></div><div class="row" ng-if="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center translate="PLEASE_SAVE_THE_RECIPE_FIRST_(WITH_INGREDIENTS_PROPERLY_SETUP)_BEFORE_FOOD_COSTS_BECOME_AVAILABLE."></center></h2></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_RECIPE."></span><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br>{{ \'THERE_IS_NO_CHANGES_YET\' | translate }}<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.modifiedDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.modifiedBy | uppercase}}</td><td ng-bind-html="log.oriData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="cloneRecipeModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="CLONE_RECIPE_TO_OTHER_COMPANY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.cloneForm.Company.$invalid && $mdl.cloneForm.$submitted}"> <label><b translate="SELECT_A_COMPANY"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="Company" ng-options="c as (c.name | uppercase) for c in $mdl.companies track by c.id" ng-model="$mdl.selectedCompany" required> <option value="">-- {{ \'SELECT_A_COMPANY\' | translate }} --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.cloneForm.Company.$error.required && $mdl.cloneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.cloneForm.RecipeCategory.$invalid && $mdl.cloneForm.$submitted}"> <label><b>Copy to:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="RecipeCategory" ng-options="r as (r.name | uppercase) for r in $mdl.selectedCompany.recipeCategories track by r.id" ng-model="$mdl.selectedCategory" required> <option value="">-- {{ \'SELECT_A_RECIPE_CATEGORY\'| translate }} --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.cloneForm.RecipeCategory.$error.required && $mdl.cloneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="ingredientModal.html"><form name="$mdl.ingredientForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="INGREDIENT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b translate="GROUP_NAME_(IF_ANY)"></b><br /> <small><em><i class="fa fa-info-circle"></i> <span translate="GROUPING_OF_THE_INGREDIENTS_FOR_DISPLAY_IN_RECIPE_CARD"></span></em></small> </label> <input type="text" name="Group" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.category"> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <label><b translate="SELECT_ONE_OF_THE_METHOD_BELOW:"></b></label> <div style="background:#f4f4f4;margin-bottom:15px"> <uib-tabset active="$mdl.activeTab"> <uib-tab heading="{{ \'RAW_MATERIAL\' | translate}}" ng-show="$mdl.hasRawMatAccess"> <div class="form-group" ng-show="$mdl.hasRawMatAccess"> <label><b> <span translate="INGREDIENT"></span> (<span translate="RAW_MATERIAL"></span>)</b><br /> <small><i class="fa fa-info-circle"></i> {{ \'SELECT_RAW_MATERIAL_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small> </label> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.itemSearch" style="background:#fffeed" ng-disabled="$mdl.lockButtons" ng-model-options=\'{ debounce: 1500 }\' ng-change="$mdl.loadItemList($mdl.itemSearch)" /> </div> </div> <div class="col-lg-9"> <select class="form-control" style="background:#fffeed;color:#333" ng-disabled="$mdl.lockButtons" ng-change="$mdl.onSelectedItemChanged()" ng-options="u as (u.description | uppercase) for u in $mdl.itemList" ng-model="$mdl.selectedItem"> <option value="">{{($mdl.lockButtons ? (\'LOADING...\' | translate) : ($mdl.itemList.length==0 ? ("&lt;&lt; " + (\'ENTER_A_KEYWORD_TO_SEARCH\' | translate)) : "-- " + (\'SELECT_A_RAW_MAT\' | translate) + " --"))}}</option> </select> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" style="margin-top:5px" ng-if="$mdl.selectedItem!=null" ng-click="$mdl.selectedItem=null"> <i class="fa fa-times"></i> <span style="color:#fff" translate="CLEAR_SELECTION"></span> </button> </div> </div> <!-- <div class="row"> <div class="col-md-9 col-lg-9" style="padding-right:0px"> <ui-select ng-model="$mdl.selectedItem" title="Select or Search for Raw Materials..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.onSelectedItemChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Raw Materials..."> <span>{{ $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.itemList | filter: $select.search" refresh="$mdl.loadItemList($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="i.description | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="col-md-2 col-lg-2"> <button type="button" class="btn btn-xs btn-danger btn-with-icon" title="Clear Selection" ng-if="$mdl.selectedItem!=null" ng-click="$mdl.selectedItem=null"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> </div> </div> --> <p class="help-block" style="color:#f00" ng-show="$mdl.ingredientForm.ItemName.$error.required && $mdl.ingredientForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p> </div> </uib-tab> <uib-tab heading="{{ \'SEMI_FINISHED_GOODS\' | translate}}" ng-show="$mdl.hasSemiFgAccess && !vm.isStarterMode"> <div class="form-group" ng-show="$mdl.hasSemiFgAccess"> <label><b><span translate="INGREDIENT"></span> ({{ \'SEMI_FINISHED_GOODS\' | translate }})</b><br /> <small><i class="fa fa-info-circle"></i> {{ \'SELECT_SEMI_FINISHED_GOODS_WHICH_EXISTS_IN_THE_SYSTEM\' | translate }}</small> </label> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.sfgSearch" style="background:#fffeed" ng-disabled="$mdl.lockButtons" ng-model-options=\'{ debounce: 1500 }\' ng-change="$mdl.loadSemiFgList($mdl.sfgSearch)" /> </div> </div> <div class="col-lg-9"> <select class="form-control" style="background:#fffeed;color:#333" ng-disabled="$mdl.lockButtons" ng-change="$mdl.onSelectedSemiFgChanged()" ng-options="u as (u.description | uppercase) for u in $mdl.semiFgList" ng-model="$mdl.selectedSemiFg"> <option value="">{{($mdl.lockButtons ? (\'LOADING...\' | translate) : ($mdl.semiFgList.length==0 ? ("&lt;&lt; " + (\'ENTER_A_KEYWORD_TO_SEARCH\' | translate)) : "-- " + (\'SELECT_A_SEMI_FG\' | translate) + " --"))}}</option> </select> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" style="margin-top:5px" ng-if="$mdl.selectedSemiFg!=null" ng-click="$mdl.selectedSemiFg=null"> <i class="fa fa-times"></i> <span style="color:#fff" translate="CLEAR_SELECTION"></span> </button> </div> </div> <!-- <div class="row"> <div class="col-md-9 col-lg-9" style="padding-right:0px"> <ui-select ng-model="$mdl.selectedSemiFg" title="Select or Search for Semi F.G...." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.onSelectedSemiFgChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Semi F.G...."> <span>{{ $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.semiFgList | filter: $select.search" refresh="$mdl.loadSemiFgList($select.search)" refresh-delay="250" minimum-input-length="2"> <span ng-bind-html="i.description | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="col-md-2 col-lg-2"> <button type="button" class="btn btn-xs btn-danger btn-with-icon" title="Clear Selection" ng-if="$mdl.selectedSemiFg!=null" ng-click="$mdl.selectedSemiFg=null"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> </div> </div> --> <p class="help-block" style="color:#f00" ng-show="$mdl.ingredientForm.ItemName.$error.required && $mdl.ingredientForm.$submitted">* {{ \'REQUIRED_(EITHER_ONE)\' | translate }}</p> </div> </uib-tab> <uib-tab heading="{{ \'LINKED_RECIPE\' | translate}}" ng-hide="true"> <div class="form-group"> <label><b translate="LINKED_RECIPE"></b><br /> <small><i class="fa fa-info-circle"></i> <span translate="LINK_WITH_A_CHILD_RECIPE_AND_INHERIT_ALL_ITS_INGREDIENTS"></span></small> </label> <div class="row"> <div class="col-lg-3" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-search"></i> </span> <input class="form-control" ng-model="$mdl.recipeSearch" style="background:#fffeed" ng-disabled="$mdl.lockButtons" ng-model-options=\'{ debounce: 1500 }\' ng-change="$mdl.loadRecipeList($mdl.recipeSearch)" /> </div> </div> <div class="col-lg-9"> <select class="form-control" style="background:#fffeed;color:#333" ng-disabled="$mdl.lockButtons" ng-change="$mdl.onSelectedRecipeChanged()" ng-options="u as (u.name | uppercase) for u in $mdl.recipeList" ng-model="$mdl.selectedRecipe"> <option value="">{{($mdl.lockButtons ? (\'LOADING...\' | translate) : ($mdl.recipeList.length==0 ? ("&lt;&lt; " + (\'ENTER_A_KEYWORD_TO_SEARCH\' | translate)) : "-- " + (\'SELECT_A_RECIPE\' | translate) + " --"))}}</option> <option value="">{{($mdl.lockButtons ? (\'LOADING...\' | translate) : "")}}</option> </select> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" style="margin-top:5px" ng-if="$mdl.selectedRecipe!=null" ng-click="$mdl.selectedRecipe=null"> <i class="fa fa-times"></i> <span style="color:#fff" translate="CLEAR_SELECTION"></span> </button> </div> </div> <!-- <div class="row"> <div class="col-md-9 col-lg-9" style="padding-right:0px"> <ui-select ng-model="$mdl.selectedRecipe" title="Select or Search for Recipe..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.onSelectedRecipeChanged()" style="background:#fff"> <ui-select-match placeholder="Search for Recipe..."> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.recipeList | filter: $select.search" refresh="$mdl.loadRecipeList($select.search)" refresh-delay="250" minimum-input-length="2"> <span ng-bind-html="i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="col-md-2 col-lg-2"> <button type="button" class="btn btn-xs btn-danger btn-with-icon" title="Clear Selection" ng-if="$mdl.selectedRecipe!=null" ng-click="$mdl.selectedRecipe=null"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> </div> </div> --> <p class="help-block" style="color:#f00" ng-show="$mdl.ingredientForm.ItemName.$error.required && $mdl.ingredientForm.$submitted">* {{\'REQUIRED_(EITHER_ONE)\' | translate}}</p> </div> </uib-tab> <uib-tab heading="{{ \'OTHER\' | translate}}"> <div class="form-group"> <label><b translate="MANUAL_KEY-IN_INGREDIENT"></b><br /> <small><i class="fa fa-info-circle"></i> <span translate="KEY_IN_HERE_IF_RAW_MATERIAL_DOES_NOT_EXIST_IN_SYSTEM"></span></small> </label> <div class="row"> <div class="col-lg-12"> <input type="text" name="ItemName" class="form-control" style="background:#fffeed" ng-model="$mdl.item.itemName" ng-disabled="$mdl.item.itemId!=null || $mdl.item.semiFinishedProductId!=null || $mdl.item.semiFinishedProductId!=null" ng-change="$mdl.onItemNameChanged()" /> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.ingredientForm.ItemName.$error.required && $mdl.ingredientForm.$submitted">* {{\'REQUIRED_(EITHER_ONE)\' | translate}}</p> </div> </uib-tab> </uib-tabset> </div> </div> </div> <div class="row"> <div class="col-md-3 col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.ingredientForm.Quantity.$invalid && $mdl.ingredientForm.$submitted}"> <label><b translate="QUANTITY"></b> <i class="fa fa-asterisk req" style="color:#f00"></i> <small ng-show="$mdl.item.childRecipeId!=\'\' && $mdl.item.childRecipeId!=null"> <br />&nbsp; </small> </label> <input type="number" name="Quantity" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.quantity" required> <p class="help-block" style="color:#f00" ng-show="$mdl.ingredientForm.Quantity.$error.required && $mdl.ingredientForm.$submitted">* {{\'REQUIRED\' | translate}}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.ingredientForm.Quantity.$error.number && $mdl.ingredientForm.$submitted">* {{\'KEY_IN_NUMBERS_ONLY\' | translate}}</p> </div> </div> <div class="col-md-4 col-lg-4"> <div class="form-group" ng-class="{\'has-error\': $mdl.ingredientForm.UOM.$invalid && $mdl.ingredientForm.$submitted}"> <label><b translate="U.O.M."></b> <i class="fa fa-asterisk req" style="color:#f00"></i> <small ng-show="$mdl.item.childRecipeId!=\'\' && $mdl.item.childRecipeId!=null"> <br /> <em><i class="fa fa-info-circle"></i> <span translate="UOM_DEFAULT_TO_LINKED_RECIPE\'s_UOM_(LOCKED)"></span></em> </small> </label> <div class="row"> <div class="col-md-8 col-lg-8"> <select name="UOM" class="form-control" style="background:#FFFCED" ng-change="$mdl.selectedUomChanged()" ng-disabled="($mdl.item.childRecipeId!=\'\' && $mdl.item.childRecipeId!=null) || ($mdl.item.semiFinishedProductId!=\'\' && $mdl.item.semiFinishedProductId!=null)" ng-options="i as (i.name | uppercase) for i in $mdl.uomList" ng-model="$mdl.selectedUom" required> <option value="">-- {{ \'SELECT_A_UOM\' | translate }} --</option> </select> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.ingredientForm.Quantity.$error.required && $mdl.ingredientForm.$submitted">* {{\'REQUIRED\' | translate}}</p> </div> </div> </div> </div> <hr /> <div class="modal-footer"> <div style="float:left;margin-bottom:5px;line-height:30px"> <input type="checkbox" name="branch" ng-model="$mdl.item.continueAdd" style="float:left;width:25px;height:25px" /> &nbsp;&nbsp;&nbsp;<b translate="CONTINUE_ADD_NEW_AFTER_SAVE"></b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> <span translate="SAVE"></span> </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="altIngredientModal.html"><form name="$mdl.altIngredientForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="Add Alternative Ingredient"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <b>Select Type:</b>&nbsp;&nbsp; <a href class="btn btn-default" ng-class="{ \'bg-success\': $mdl.isRM }" ng-click="$mdl.changeType(true, false)">Raw Materials</a> <a href class="btn btn-default" ng-class="{ \'bg-success\': $mdl.isSFG }" ng-click="$mdl.changeType(false, true)">Semi Finished Goods</a> </div> </div> <br /> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <button type="button" class="btn btn-xs btn-danger btn-with-icon pull-right" title="Clear Selection" ng-if="$mdl.selectedItem!=null" ng-click="$mdl.selectedItem=null"> <i class="fa fa-times"></i> {{ \'CLEAR_SELECTION\' | translate }} </button> <label><b><span translate="INGREDIENT"></span> ({{ $mdl.title | translate }})</b> <br /> <small><i class="fa fa-info-circle"></i> Search for {{ $mdl.title | translate }} which exists in the system</small> </label> <div class="row"> <div class="col-md-12 col-lg-12"> <ui-select ng-model="$mdl.selectedItem" name="ItemId" title="Select or Search for Raw Materials..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.onSelectedItemChanged()" style="background:#fff"> <ui-select-match placeholder="Type something here..."> <span>{{ $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.itemList | filter: $select.search" refresh="$mdl.loadItemList($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="i.description | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="col-md-2 col-lg-2"> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.altIngredientForm.ItemId.$error.required && $mdl.altIngredientForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.remarks" /> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="stepModal.html"><form name="$mdl.stepForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="STEP"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-5 col-lg-5"> <div ba-panel ba-panel-class="horizontal-tabs tabs-panel panel panel-primary"> <uib-tabset active="$mdl.activeTab"> <uib-tab heading="Upload"> <p><small><i class="fa fa-info-circle"></i> <span translate="UPLOAD_IMAGE_/_VIDEO_FILE_FROM_COMPUTER."></span></small> <br /> </p> <div class="row"> <!-- Preview --> <img alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="max-height:400px" ngf-src="$mdl.mediaFile" ng-if="$mdl.mediaFile" /> <video class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="background:#000;max-height:200px" controls ngf-src="$mdl.mediaFile" ng-if="$mdl.mediaFile"> </video> <!-- Preview --> <!-- Empty Placeholder --> <img alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" src="assets/img/empty_placeholder.png" ng-if="!$mdl.mediaFile" /> <!-- Empty Placeholder --> </div> <div class="row"> <div class="col-md-12 col-lg-12" style="padding-top:5px"> <p><small><i class="fa fa-info-circle"></i> <span translate="RECOMMENDED_TO_UPLOAD_A_LANDSCAPE_MEDIA_FILE."></span></small></p> </div> </div> <div class="row"> &nbsp; </div> <div class="row" style="text-align:center" ng-hide="0 < $mdl.uploadProgess"> <a href class="btn btn-primary btn-with-icon" name="file" ng-model="$mdl.mediaFile" ngf-select="$mdl.setUploadMedia($mdl.mediaFile)" ngf-accept="\'image/*,video/*\'" ngf-pattern="\'image/*,video/*\'" ngf-model-invalid="errorFile" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-upload"></i> {{ \'UPLOAD_MEDIA\' | translate }} </a> <a href ng-click="$mdl.mediaFile=null" ng-show="$mdl.mediaFile" class="btn btn-default btn-with-icon" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-remove-circle"></i> {{ \'RESET_MEDIA\' | translate }} </a> </div> <div class="row" ng-if="$mdl.mediaFile && $mdl.uploadProgess!=0"> <div style="width:85%;height:20px;margin:10px auto 5px"> <span translate="MEDIA_UPLOADING"></span>... </div> <div class="progress" style="background:rgba(255,255,255, 0.6);width:85%;height:20px;margin:0px auto"> <div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000"> {{$mdl.uploadProgessPercent | number:0}}% <!--{{ $mdl.uploadProgess }} / {{ $mdl.uploadProgessTotal }}--> </div> <div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="$mdl.uploadProgess" aria-valuemax="$mdl.uploadProgessTotal" style="width: {{$mdl.uploadProgessPercent | number:0}}%"> </div> </div> </div> <div class="row" ng-show="$mdl.lockUploadButton" style="text-align:center;color:#f00"> <i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED."></span> </div> <div class="row"> &nbsp; </div> <div class="row"> &nbsp; </div> </uib-tab> <uib-tab heading="Video Player" ng-if="$mdl.item.attachmentType.substring(0,5)==\'video\'"> <p><small><i class="fa fa-info-circle"></i> <span translate="THE_CURRENT_VIDEO_OF_THE_STEP."></span></small> <br /> </p> <!-- Video --> <div class="row"> <iframe ng-src="{{$mdl.item.finalVimeoUrl}}" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" height="200" frameborder=\'0\' class="step-image-card" style="background:#000" webkitAllowFullScreen mozallowfullscreen allowFullScreen ng-if="$mdl.item.attachmentType.substring(0,5)==\'video\' && $mdl.item.isVimeoConverted && $mdl.item.vimeoVideoId!=\'\'"> </iframe> </div> <!-- Video --> <div class="row"> &nbsp; </div> <div class="row"> &nbsp; </div> </uib-tab> <uib-tab heading="Image Viewer" ng-if="$mdl.item.attachmentType.substring(0,5)==\'image\'"> <p><small><i class="fa fa-info-circle"></i> <span translate="THE_CURRENT_IMAGE_OF_THE_STEP."></span></small> <br /> </p> <!-- Image --> <div class="row"> <img alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="max-height:400px" ngf-src="$mdl.item.blobLocation" ng-if="$mdl.item.blobLocation!=\'\' && $mdl.item.blobLocation!=null && $mdl.item.attachmentType.substring(0,5)==\'image\'" /> </div> <!-- Image --> <div class="row"> &nbsp; </div> <div class="row"> &nbsp; </div> </uib-tab> </uib-tabset> </div> </div> <div class="col-md-7 col-lg-7"> <div class="row"> <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"> <h2><b> <span translate="STEP"></span> #{{$mdl.item.step+1}}</b></h2> </div> </div> <!--<div class="row"> <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"> <label>Step Name</label> <input type="text" class="form-control" ng-model="$mdl.item.name" /> </div> </div>--> <div class="row"> <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"> <div class="form-group"> <label><b>{{ \'STEP_DESCRIPTION\' | translate }}</b></label> <textarea class="form-control" ng-model="$mdl.item.description" style="background:#FFFCED"></textarea> </div> </div> </div> <div class="row"> <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"> <div class="form-group"> <label><b>{{ \'EXTRA_DESCRIPTION\' | translate }}</b></label><br /> <label> <small><i class="fa fa-info-circle"></i> {{ \'HIGHTLIGHT_IMPORTANT_THING_TO_TAKE_NOTE_IN_THIS_STEP.\' | translate }} </small> </label> <textarea class="form-control" ng-model="$mdl.item.extraDescription" style="background:#FFFCED"></textarea> </div> </div> </div> <div class="row" ng-if="$mdl.hasSmartKitchenFeature"> <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"> <div class="form-group"> <label><b>{{ \'ENABLE_TEMPERATURE_CONTROL\' | translate }} ?</b></label> <div> <toggle ng-model="$mdl.item.enableTemperatureControl" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> </div> <div class="row"> <div class="form-group col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.stepForm.TargetTemperature.$invalid && ($mdl.stepForm.TargetTemperature.$dirty || $mdl.stepForm.$submitted) }" ng-if="$mdl.hasSmartKitchenFeature && $mdl.item.enableTemperatureControl"> <label><b>{{ \'TARGET_TEMPERATURE\' | translate }} (&deg;C)</b></label> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt"> <i class="fa fa-info-circle" uib-tooltip="{{ \'THE_REQUIRED_TEMPERATURE_TO_COMPLETE_THIS_STEP\' | translate }}"></i> </span> <input type="number" class="form-control" name="TargetTemperature" style="background:#FFFCED" ng-model="$mdl.item.targetTemperatureCelcius" ng-required="#mdl.item.enableTemperatureControl" /> </div> <span class="help-block" ng-if="$mdl.stepForm.$submitted && $mdl.stepForm.TargetTemperature.$error.required" style="color:#F00"> * {{ \'REQUIRED\' | translate }} </span> <span class="help-block" ng-if="$mdl.stepForm.$submitted && $mdl.stepForm.TargetTemperature.$error.number" style="color:#F00"> * {{ \'KEY_IN_NUMBERS_ONLY\' | translate }} </span> </div> </div> <div class="form-group col-md-6 col-lg-6" ng-if="$mdl.hasSmartKitchenFeature"> <div class="form-group" ng-class="{\'has-error\': $mdl.stepForm.TotalTimeSecond.$invalid && ($mdl.stepForm.TotalTimeSecond.$dirty || $mdl.stepForm.$submitted) }"> <label><b>{{ \'TOTAL_TIME_SECONDS\' | translate }}</b></label> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt" uib-tooltip="{{ \'TOTAL_TIME_TAKEN_TO_PERFORM_THIS_STEP\' | translate }}"> <i class="fa fa-info-circle"></i> </span> <input type="number" class="form-control" name="TotalTimeSecond" ng-model="$mdl.item.totalTimeSecond" style="background:#FFFCED" /> </div> <span class="help-block" ng-if="$mdl.stepForm.$submitted && $mdl.stepForm.TotalTimeSecond.$error.number" style="color:#F00"> * {{ \'KEY_IN_NUMBERS_ONLY\' | translate }} </span> </div> </div> </div> </div> </div> </div> <div class="modal-footer"> <checkbox large ng-if="$mdl.mode==1" ng-model="$mdl.item.continueAdd" ng-change="change()" style="background:#fffff4"> </checkbox> <b ng-if="$mdl.mode==1">{{ \'CONTINUE_ADD_NEW_AFTER_SAVE\' | translate }}</b> <br /><br /> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONTINUE\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButton"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/recipes/recipes/recipeCategoryList.html','<div class="widgets recipe"><div class="row"><div class="col-md-12" ba-panel=""><p translate="LIST_OF_RECIPE_CATEGORIES"></p><div class="row"><div class="col-lg-12"><legend style="padding-bottom:5px"><div class="row"><div class="col-md-8 col-lg-8" style="padding-top:15px"><span translate="SELECT_A_CATEGORY:"></span> <b>{{vm.selectedCategory | uppercase}}</b></div><div class="col-md-1 col-lg-1"><a href="" class="btn btn-with-icon btn-primary pull-right" ng-click="vm.showSearchRecipeDialog()"><i class="fa fa-search"></i> <span translate="QUICK_SEARCH_RECIPE"></span></a></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" ng-model="vm.searchCategory" ng-hide="vm.isCategorySelected"></div></div></legend></div></div><div class="row" ng-show="vm.categoryList!=0"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-show="vm.isCategorySelected"><a href="" ng-click="vm.reselectCategory()"><div class="img go-back"></div></a></div><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-if="vm.selectedCategoryId==\'\' || vm.selectedCategoryId==cat.id" ng-repeat="cat in vm.categoryList | filter:vm.searchCategory as filteredCategory"><a href="" ui-sref="recipes.recipes.recipelist({id:cat.id})"><div class="img" afkl-lazy-image="{{cat.thumbnail || cat.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4><b>{{cat.name | uppercase}}</b></h4></a></div></div><div class="row" ng-show="vm.isCategorySelected"><div class="col-lg-12"><legend style="padding-bottom:5px"><div class="row"><div class="col-md-7 col-lg-7" style="padding-top:15px"><span translate="RECIPE_LIST:"></span> <small><i class="fa fa-info-circle"></i> <em translate="CLICK_ON_THE_RECIPE_TO_EDIT."></em></small></div><div class="col-md-2 col-lg-2"><select name="IsApproved" class="form-control" ng-model="vm.searchRecipe.isApproved" ng-change="change()"><option value="">{{ \'SHOW_ALL\' | translate }}</option><option value="false">{{ \'SHOW_NOT_APPROVED\' | translate }}</option></select></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" placeholder="Search for Recipe" ng-model="vm.searchRecipe.$" ng-hide="!vm.isCategorySelected"></div></div></legend></div></div><div class="row" ng-show="vm.categoryList!=0"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-repeat="r in vm.recipeList | filter:vm.searchRecipe as filteredRecord"><a href="" ui-sref="recipes.recipes.update({id:r.id})"><div class="img" afkl-lazy-image="{{r.thumbnail || r.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4>{{r.name | uppercase}}</h4><i class="fa fa-pencil" rms-check-access="recipes.recipes" rms-check-access-perm-type="UPDATE"></i><h4 class="top" ng-if="!r.isApproved || !r.isPublic"><center><span ng-if="!r.isApproved"><i class="ion ion-alert-circled"></i> <span translate="NOT_APPROVED"></span></span> <span ng-if="!r.isPublic"><i class="ion ion-minus-circled"></i> <span translate="NOT_PUBLISHED"></span></span></center></h4></a></div></div><div class="row" ng-if="vm.isCategorySelected && filteredRecord.length==0"><div class="tile-container col-lg-12" ba-panel=""><div style="background:#fafafa;height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate}}</center></div></div></div><div class="row" ng-show="vm.categoryList==0"><div class="col-md-12"><p>&nbsp;</p><p>&nbsp;</p><h3 style="color:#f00"><i class="fa fa-exclamation-triangle"></i> <span translate="YOU_MUST_CREATE_AT_LEAST_ONE_(1)_CATEGORY_FIRST."></span></h3><h3 rms-check-access="recipes.categories" rms-check-access-perm-type="CREATE"><span translate="CLICK"></span> <a href="" ui-sref="recipes.categories.create"><u translate="HERE"></u></a> <span translate="TO_CREATE_A_NEW_CATEGORY."></span></h3><p>&nbsp;</p><p>&nbsp;</p></div></div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-if="!vm.isCategorySelected"><br><span translate="TOTAL_RECORDS:"></span> <b>{{filteredCategory.length}}</b><br>&nbsp;</div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-if="vm.isCategorySelected"><br><span translate="TOTAL_RECORDS:"></span> <b>{{filteredRecord.length}}</b><br>&nbsp;</div></div></div></div><script type="text/ng-template" id="SearchRecipeModal.html"><form name="$mdl.searchReicpeForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="QUICK_SEARCH_RECIPE"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <div class="input-group"> <span class="input-group-addon" style="padding:0px"> <i class="fa fa-search" style="padding:3px 10px"></i> </span> <input type="text" name="SearchText" class="form-control" placeholder="{{ \'ENTER_KEYWORD_TO_SEARCH\' | translate }}" ng-disabled="$mdl.isLoading" ng-model="$mdl.searchText" ng-model-options=\'{ debounce: 500 }\' ng-change="$mdl.searchRecipe()" min=3 /> </div> </div> </div> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div style="max-height:500px;overflow-y:scroll"> <table class="table table-striped" style="border:1px solid #ccc" st-table="$mdl.recipeList" refresh-table> <thead> <tr> <th style="width:60px">#</th> <th style="width:200px"><b translate="RECIPE_IMAGE"></b></th> <th><b translate="RECIPE_NAME"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="ntn in $mdl.recipeList"> <td>{{ $index+1 }})</td> <td style="padding-top:10px;padding-bottom:10px"> <img src="{{ntn.thumbnail || ntn.imageLocation || \'assets/img/empty_placeholder.png\'}}" alt="" style="width:160px;height:85px" /> </td> <td style="padding-top:10px;padding-bottom:10px;line-height:150%;color:#000"> <big><b>{{ ntn.name || \'\' | uppercase }}</b></big> <br /> <div style="width:auto;line-height:100%"> <a href class="report-type-tag" ng-repeat="c in ntn.recipeCategories" ui-sref="recipes.recipes.recipelist({id:c.id})" ng-click="$mdl.cancelModal()" style="width:auto;margin-right:5px;padding:2px 8px;border:1px solid #888"> {{c.name | uppercase}} </a> </div> </td> <td style="padding-top:10px"> <a href class="btn btn-primary editable-table-button btn-sm" ui-sref="recipes.recipes.update({id:ntn.id})" ng-click="$mdl.cancelModal()"> <span style="color:#fff" translate="GO"></span> &nbsp; <i class="fa fa-arrow-circle-right"></i> </a> </td> </tr> <tr> <td colspan="4" align="center" ng-show="$mdl.recipeList.length==0"> <br /> {{ \'NO_RECORD_FOUND\' | translate }}. <br />&nbsp; </td> </tr> </tbody> </table> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.isLoading" style="color:#00f;margin-left:30px"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b> <span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/recipes/recipes/recipeCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/recipes/recipes/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockUpdateButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_RECIPE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockUpdateButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/recipes/recipes/recipeList.html','<div class="widgets recipe"><div class="row"><div class="col-md-12" ba-panel=""><p><span translate="LIST_OF_RECIPES"></span> <a href="" class="btn btn-primary btn-with-icon" ui-sref="recipes.recipes.create" style="margin-left:20px" ng-show="vm.categoryList!=0" rms-check-access="recipes.recipes" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_RECIPE"></span></a> <a href="" class="btn btn-success btn-with-icon" style="float:right;margin-right:5px" ng-if="vm.isSuperAdmin || vm.canCloneRecipe" ng-click="vm.showCloneCategoryModal()" ng-disabled="vm.lockUpdateButtons"><i class="ion ion-social-buffer"></i> <span translate="CLONE_WHOLE_CATEGORY_TO_OTHER_COMPANY"></span></a></p><div class="row"><div class="col-lg-12"><legend style="padding-bottom:5px"><div class="row"><div class="col-md-8 col-lg-8" style="padding-top:15px"><span translate="CATEGORY:"></span> <b>{{vm.selectedCategory | uppercase}}</b></div><div class="col-md-1 col-lg-1"></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" ng-model="vm.searchCategory" ng-hide="vm.isCategorySelected"></div></div></legend></div></div><div class="row"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-show="vm.isCategorySelected"><a href="" ui-sref="recipes.recipes.categorylist"><div class="img" style="line-height:200px;font-size:30pt;text-align:center"><i class="fa fa-chevron-left"></i>&nbsp;&nbsp;{{ \'BACK\' | translate }}</div></a></div><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3"><div class="img" afkl-lazy-image="{{vm.category.thumbnail || vm.category.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4>{{vm.category.name | uppercase}}</h4></div></div><div class="row" ng-show="vm.isCategorySelected"><div class="col-lg-12"><legend style="padding-bottom:5px"><div class="row"><div class="col-md-7 col-lg-7" style="padding-top:15px"><span translate="RECIPE_LIST:"></span> <small><i class="fa fa-info-circle"></i> <em translate="CLICK_ON_THE_RECIPE_TO_EDIT."></em></small></div><div class="col-md-2 col-lg-2"><select name="IsApproved" class="form-control" ng-model="vm.searchRecipe.isApproved" ng-change="change()"><option value="">{{ \'SHOW_ALL\' | translate }}</option><option value="false">{{ \'SHOW_NOT_APPROVED\' | translate }}</option></select></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" style="background-color:#fffeed" ng-model="vm.searchRecipe.$" ng-hide="!vm.isCategorySelected"></div></div></legend></div></div><div class="row" ng-show="vm.categoryList!=0"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-repeat="r in vm.recipeList | filter:vm.searchRecipe as filteredRecord"><a href="" ui-sref="recipes.recipes.update({id:r.id})"><div class="img" afkl-lazy-image="{{r.thumbnail || r.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4><b>{{r.name | uppercase}}</b><br><small>{{ r.createdDate | date:\'dd/MM/yyyy\' }}</small></h4><i class="fa fa-pencil" rms-check-access="recipes.recipes" rms-check-access-perm-type="UPDATE"></i><h4 class="top" ng-if="!r.isApproved || !r.isPublic"><center><span ng-if="!r.isApproved"><i class="ion ion-alert-circled"></i> <span translate="NOT_APPROVED"></span></span> <span ng-if="!r.isPublic"><i class="ion ion-minus-circled"></i> <span translate="NOT_PUBLISHED"></span></span></center></h4></a></div></div><div class="row" ng-if="vm.isCategorySelected && filteredRecord.length==0"><div class="tile-container col-lg-12"><div style="background:#fafafa;height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></div></div></div><div class="row" ng-show="vm.categoryList==0"><div class="col-md-12"><p>&nbsp;</p><p>&nbsp;</p><h3 style="color:#f00"><i class="fa fa-exclamation-triangle"></i> <span translate="YOU_MUST_CREATE_AT_LEAST_ONE_(1)_CATEGORY_FIRST."></span></h3><h3 rms-check-access="recipes.categories" rms-check-access-perm-type="CREATE"><span translate="CLICK"></span> <a href="" ui-sref="recipes.categories.create"><u translate="HERE"></u></a> <span translate="TO_CREATE_A_NEW_CATEGORY."></span></h3><p>&nbsp;</p><p>&nbsp;</p></div></div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-if="!vm.isCategorySelected"><br><span translate="TOTAL_RECORDS:"></span> <b>{{filteredCategory.length}}</b><br>&nbsp;</div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-if="vm.isCategorySelected"><br><span translate="TOTAL_RECORDS:"></span> <b>{{filteredRecord.length}}</b><br>&nbsp;</div></div></div></div><script type="text/ng-template" id="cloneCategoryModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="CLONE_CATEGORY_TO_OTHER_COMPANY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.cloneForm.Company.$invalid && $mdl.cloneForm.$submitted}"> <label><b translate="COPY_TO_COMPANY:"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="Company" ng-disabled="$mdl.isLoading" ng-options="c as (c.name | uppercase) for c in $mdl.companies track by c.id" ng-model="$mdl.selectedCompany" required> <option value="">-- {{ \'SELECT_A_COMPANY\' }} --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.cloneForm.Company.$error.required && $mdl.cloneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.cloneForm.RecipeCategory.$invalid && $mdl.cloneForm.$submitted}"> <label><b translate="COPY_TO_CATEGORY:"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="RecipeCategory" ng-disabled="$mdl.isLoading" ng-options="r as (r.name | uppercase) for r in $mdl.selectedCompany.recipeCategories track by r.id" ng-model="$mdl.selectedCategory" required> <option value="">-- {{ \'SELECT_A_RECIPE_CATEGORY\' }} --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.cloneForm.RecipeCategory.$error.required && $mdl.cloneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div ng-show="$mdl.isLoading"> <b style="color:#00f"><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA_...\' | translate }}</b> </div> <div ng-show="$mdl.lockButtons"> <b style="color:#00f"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="COPYING_IN_PROGRESS"></span> ...</b> </div> </div> <p><br /></p> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/recipes/recipes/recipeUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/recipes/recipes/_form.html\'"></section><div class="footer-bar"><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-default btn-with-icon" style="margin-right:30px" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockUpdateButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockUpdateButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-success btn-with-icon" style="margin-left:30px" ng-click="vm.downloadExcel()" ng-disabled="vm.lockUpdateButtons" rms-check-access="recipes.recipes" rms-check-access-perm-type="EXPORT"><i class="fa fa-file-excel-o"></i> <span translate="DOWNLOAD_EXCEL"></span></a></div><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon pull-right" confirmed-click="vm.deleteRecipe()" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Recipe?" ng-disabled="vm.lockUpdateButtons" rms-check-access="recipes.recipes" rms-check-access-perm-type="DELETE"><i class="ion ion-android-delete"></i> <span translate="DELETE_RECIPE"></span></a> <a href="" class="btn btn-primary btn-with-icon pull-right" style="margin-right:5px" ng-if="vm.isSuperAdmin || vm.canCloneRecipe" ng-click="vm.showCloneRecipeModal()" ng-disabled="vm.lockUpdateButtons"><i class="ion ion-social-buffer"></i> <span translate="CLONE_RECIPE_TO_OTHER_COMPANY"></span></a> <a href="" class="btn btn-primary btn-with-icon pull-right" style="margin-right:5px" confirmed-click="vm.cloneRecipe()" ng-confirm-click="Confirm to clone this Recipe?" ng-disabled="vm.lockUpdateButtons" rms-check-access="recipes.recipes" rms-check-access-perm-type="CREATE"><i class="ion ion-social-buffer"></i> <span translate="CLONE_RECIPE"></span></a></div></div></div></form>');
$templateCache.put('app/pages/report/tracktrace/tracktrace.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit(vm.dataForm)" novalidate=""><div class="row"><div class="col-md-12" ba-panel=""><p><i class="fa fa-bar-chart"></i> &nbsp;<span translate="RETRIEVE_ALL_THE_DETAILS_ABOUT_THE_FINISHED_GOODS"></span>.<br>&nbsp;</p><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b><span translate="SCAN_PRODUCT_LABEL_QR_CODE_/_KEY_IN_PRODUCT_SERIAL_NO"></span>.</b> <i class="fa fa-asterisk req"></i></label></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && (vm.dataForm.SerialNo.$dirty || vm.dataForm.$submitted)}"><input type="text" class="form-control" name="SerialNo" placeholder="e.g. FG/00000001" style="background:#fffeb7;text-transform:uppercase" ng-model="vm.serialNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><button type="submit" class="btn btn-primary btn-with-icon" ng-disable="vm.isLoading"><i class="fa fa-search"></i> <span translate="CHECK"></span></button> <a href="" class="btn btn-primary btn-with-icon" ng-if="vm.job.id!=null" ng-click="vm.printJobTrace(vm.job.id, vm.job.jobNo)"><i class="fa fa-print"></i> <span translate="PRINT_TRACE"></span></a></div></div><p><br></p><div class="row"><div class="col-md-3 col-lg-3" style="margin-bottom:10px"><fieldset><legend translate="RESULT">:</legend></fieldset></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-4 col-lg-4">{{ \'PRODUCT_NAME\' | translate }}: <span class="form-control"><b>{{ vm.job.productName || \'-\' }}</b></span></div><div class="col-md-2 col-lg-2">{{ \'EXPIRY_DATE\' | translate }}: <span class="form-control"><b>{{ vm.job.expiryDate | date:\'dd-MMM-yyyy\' }}</b></span></div></div><br><div class="row"><div class="col-md-2 col-lg-2"><span translate="JOB_NO"></span>: <span class="form-control"><b>{{ vm.job.jobNo || \'-\' }}</b></span></div><div class="col-md-2 col-lg-2"><span translate="BATCH_NO"></span>: <span class="form-control"><b>{{ vm.job.batchNo || \'-\' }}</b></span></div><div class="col-md-2 col-lg-2"><span translate="KITCHEN"></span>: <span class="form-control"><b>{{ vm.job.usergroupName || \'-\' }}</b></span></div><div class="col-md-2 col-lg-2"><span translate="JOB_DATE"></span>: <span class="form-control"><b>{{ vm.job.jobDate || \'-\' | date:"dd/MM/yyyy" }}</b></span></div><div class="col-md-2 col-lg-2"><span translate="START_DATE"></span>: <span class="form-control"><b>{{ vm.job.startDate || \'-\' | date:"dd/MM/yyyy h:mm a" }}</b></span></div><div class="col-md-2 col-lg-2"><span translate="COMPLETED_DATE"></span>: <span class="form-control"><b>{{ vm.job.completedDate || \'-\' | date:"dd/MM/yyyy h:mm a" }}</b></span></div></div><br><table class="table table-striped" style="border:5px solid #eee;margin-top:5px"><thead><tr><th></th><th><b translate="INGREDIENT"></b></th><th style="text-align:center"><b>{{ \'RECIPE_QUANTITY\' | translate }}</b></th><th><b translate="TRACE_/_SOURCE"></b></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-if="vm.tracktrace.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center><span translate="RESULT_IS_EMPTY"></span>.</center></td></tr><tr ng-repeat="i in vm.tracktrace"><td class="text-center" style="width:80px;line-height:90%"><div class="report-type-tag"><b ng-if="i.itemId!=null"><span translate="RAW_MAT"></span></b> <b ng-if="i.semiFgId!=null"><span translate="SEMI_FG"></span></b> <b ng-if="i.semiFgId==null && i.itemId==null"><span translate="MISC"></span></b></div></td><td><b>{{i.itemName | uppercase}}</b><br><b ng-if="i.isWithdrawalRequestItem != null && i.isWithdrawalRequestItem">[{{ i.withdrawalNo }}]</b> <b ng-if="i.isStockReturnedItem != null && i.isStockReturnedItem">[{{ i.returnNo }}]</b></td><td align="center">{{i.quantity}} {{i.uom}}</td><td ng-if="i.movement.length==0 && i.movementSemiFg==0 && (i.movementProduct == null || i.movementProduct.length == 0)">No Stock Out.</td><td><table border="1" style="width:auto;font-size:80%;line-height:140%;border-color:#aaa;border-collapse:collapse;margin:5px 3px;" ng-if="i.movement.length!=0 || i.movementSemiFg.length != 0 || (i.movementProduct != null && i.movementProduct.length !=0)"><tr><td style="padding:2px 4px; width: 150px"><b>{{ \'INGREDIENT_USED\' | translate }}</b></td><td style="padding:2px 4px; width: 100px;"><b>{{ \'P.O._NO\' | translate }} / {{\'JOB_NO\' | translate}}</b></td><td style="padding:2px 4px; width: 100px;"><b>{{ \'GRN_NO\' | translate }} / {{\'BATCH_NO\' | translate}}</b></td><td style="padding:2px 4px; width: 70px;"><b>{{ \'GRN_DATE_/_MFG_DATE\' | translate }}</b></td><td style="padding:2px 4px"><b>{{ \'SERIAL_NO\' | translate }}</b></td><td style="padding:2px 4px"><b>{{ \'EXPIRY_DATE\' | translate }}</b></td><td style="padding:2px 4px"><b>{{ \'STOCKED_OUT_QUANTITY\' | translate }}</b></td></tr><tr ng-repeat="m in i.movement"><td style="padding:2px 4px; width: 150px">{{m.isAltIng ? (\'[ALT] \' + m.altIngName) : (i.isStockReturnedItem ? (\'[RETURNED] \' + i.itemName) : i.itemName)}}</td><td style="padding:2px 4px; width: 100px;">{{m.purchaseOrderNo || \'-\'}}</td><td style="padding:2px 4px; width: 100px;">{{m.receivingNo || \'-\'}}</td><td style="padding:2px 4px; width: 70px;">{{(m.receivingDate || m.mfgDate || \'-\') || \'-\' | date:"dd/MM/yyyy" }}</td><td style="padding:2px 4px">{{m.serialNo }}</td><td style="padding:2px 4px">{{m.expiryDate || \'-\' | date:\'dd/MM/yyyy\' }}</td><td style="padding:2px 4px" ng-if="i.isStockReturnedItem == null || i.isStockReturnedItem == false">{{m.stockedOutQuantity}} {{m.stockedOutUomName}}</td><td style="padding:2px 4px" ng-if="i.isStockReturnedItem != null && i.isStockReturnedItem">{{m.returnedQuantity}} {{m.returnedUomName}}</td></tr><tr ng-repeat="m in i.movementSemiFg"><td style="padding:2px 4px; width: 150px">{{m.isAltIng ? (\'[ALT] \' + m.altIngName) : (i.isStockReturnedItem ? (\'[RETURNED] \' + i.itemName) : i.itemName)}}</td><td style="padding:2px 4px; width: 100px;">{{m.purchaseOrderNo || \'-\'}}</td><td style="padding:2px 4px; width: 100px;">{{m.receivingNo || \'-\'}}</td><td style="padding:2px 4px; width: 70px;">{{(m.receivingDate || m.mfgDate || \'-\') | date:"dd/MM/yyyy" }}</td><td style="padding:2px 4px">{{m.serialNo }}</td><td style="padding:2px 4px">{{m.expiryDate || \'-\' | date:\'dd/MM/yyyy\' }}</td><td style="padding:2px 4px" ng-if="i.isStockReturnedItem == null || i.isStockReturnedItem == false">{{m.stockedOutQuantity}} {{m.stockedOutUomName}}</td><td style="padding:2px 4px" ng-if="i.isStockReturnedItem != null && i.isStockReturnedItem">{{m.returnedQuantity}} {{m.returnedUomName}}</td></tr><tr ng-repeat="m in i.movementProduct"><td style="padding:2px 4px; width: 150px">{{m.isAltIng ? (\'[ALT] \' + m.altIngName) : (i.isStockReturnedItem ? (\'[RETURNED] \' + i.itemName) : i.itemName)}}</td><td style="padding:2px 4px; width: 100px;">{{m.purchaseOrderNo || \'-\'}}</td><td style="padding:2px 4px; width: 100px;">{{m.receivingNo || \'-\'}}</td><td style="padding:2px 4px; width: 70px;">{{(m.receivingDate || m.mfgDate || \'-\') | date:"dd/MM/yyyy" }}</td><td style="padding:2px 4px">{{m.serialNo }}</td><td style="padding:2px 4px">{{m.expiryDate || \'-\' | date:\'dd/MM/yyyy\' }}</td><td style="padding:2px 4px" ng-if="i.isStockReturnedItem == null || i.isStockReturnedItem == false">{{m.stockedOutQuantity}} {{m.stockedOutUomName}}</td><td style="padding:2px 4px" ng-if="i.isStockReturnedItem != null && i.isStockReturnedItem">{{m.returnedQuantity}} {{m.returnedUomName}}</td></tr><tr><td colspan="6" style="padding:2px 4px; background-color:#eee; text-align: end">{{ (i.isStockReturnedItem ? \'TOTAL_RETURNED\' : \'TOTAL_STOCKED_OUT\') | translate }}</td><td style="padding:2px 4px; background-color:#eee">{{(i.isStockReturnedItem ? i.quantityReturned : i.quantityStockedOut)}} {{i.uom}}</td></tr></table></td></tr></tbody></table></div></div><p><br></p></div></div></form></div>');
$templateCache.put('app/pages/report/reportinquiry/reportinquiry.html','<style>\n\t.chkbox-custom {\n\t\tfloat:left;\n\t\twidth:20px;\n\t\theight:20px;\n\t\tmargin-top:7px !important;\n\t}\n</style><div class="widgets"><div class="row"><div class="col-md-12"><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-md-4 col-lg-4"><h4><b><u>{{ \'FILTER_OPTIONS\' | translate }}</u></b></h4><div class="form-horizontal"><div class="form-group" style="margin-bottom:4px"><label class="col-md-3 control-label"><input type="checkbox" class="chkbox-custom"> <b>{{ \'DATE_RANGE\' | translate }} :</b></label><div class="col-md-6"><div class="input-group" style="margin-bottom:2px"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input date-range-picker="" class="form-control input-sm date-picker" type="text" autocomplete="off" options="vm.drPickerOptions" ng-model="vm.inq.dateRange" ng-readonly="true"></div></div></div><div class="form-group" style="margin-bottom:4px"><label class="col-md-3 control-label"><input type="checkbox" class="chkbox-custom"> <b>{{ \'BRANCH\' | translate }} :</b></label><div class="col-md-6"><input type="text" class="form-control input-sm"></div></div><div class="form-group" style="margin-bottom:4px"><label class="col-md-3 control-label"><input type="checkbox" class="chkbox-custom"> <b>{{ \'ITEM\' | translate }} :</b></label><div class="col-md-6"><input type="text" class="form-control input-sm"></div></div></div></div><div class="col-md-4 col-lg-4"><h4><b><u>{{ \'GROUP_SORT_OPTIONS\' | translate }}</u></b></h4><div class="form-horizontal"><div class="form-group" style="margin-bottom:4px"><label class="col-md-3 control-label"><input type="checkbox" class="chkbox-custom"> <b>{{ \'BRANCH\' | translate }} :</b></label><div class="col-md-6"><select class="form-control input-sm" style="width:110px" ng-model="vm.selectedBranchSort" ng-change="vm.selectedBranchSortChanged()"><option value="ASC">Ascending</option><option value="DESC">Descending</option></select></div></div><div class="form-group" style="margin-bottom:4px"><label class="col-md-3 control-label"><input type="checkbox" class="chkbox-custom"> <b>{{ \'ITEM\' | translate }} :</b></label><div class="col-md-6"><select class="form-control input-sm" style="width:110px" ng-model="vm.selectedItemSort" ng-change="vm.selectedItemSortChanged()"><option value="ASC">Ascending</option><option value="DESC">Descending</option></select></div></div><div class="form-group" style="margin-bottom:4px"><label class="col-md-3 control-label"><input type="checkbox" class="chkbox-custom"> <b>{{ \'ITEM_TYPE\' | translate }} :</b></label><div class="col-md-6"><select class="form-control input-sm" style="width:110px" ng-model="vm.selectedItemTypeSort" ng-change="vm.selectedItemTypeSortChanged()"><option value="ASC">Ascending</option><option value="DESC">Descending</option></select></div></div></div></div></div></div><div class="panel-footer" style="padding:9px 22px !important;height:50px !important;"><button type="submit" class="btn btn-primary btn-with-icon btn-sm"><i class="fa fa-search"></i> {{ \'GENERATE_REPORT\' | translate }}</button> <button type="button" class="btn btn-danger btn-with-icon btn-sm"><i class="fa fa-trash-o"></i> {{ \'RESET\' | translate }}</button></div></div></div></div><pre>{{ vm.inq }}</pre><div class="row"><div class="col-md-12"><div class="panel panel-default"><div class="panel-heading"><b>Results</b></div><div class="panel-body"></div></div></div></div></div>');
$templateCache.put('app/pages/requisitions/reqapproval/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="PLEASE_CHECK_THE_REQUISITION_DETAILS_THOROUGHLY_BEFORE_APPROVE."></span></small></p><br><div class="row" ng-if="vm.isLoading"><div class="col-lg-12"><div style="height:200px;line-height:200px;background:#eee"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PLEASE_WAIT_WHILE_THE_SYSTEM_IS_LOADING_THE_DATA_..."></span></b></center></big></div></div></div><div class="row" ng-if="!vm.isLoading"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b><span translate="REQUISITION_NO."></span>:</b></label> <span class="form-control" style="color:#00f">{{vm.requisition.requisitionNo || \'AUTONUMBER\' }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="REQUISITION_STATUS"></b></label> <span class="form-control" style="color:#00f" ng-show="vm.requisition.status==\'COMPLETED\' || vm.requisition.status==\'APPROVED\'">{{vm.requisition.status}}</span><select class="form-control" style="color:#333" ng-if="vm.requisition.status!=\'COMPLETED\'&& vm.requisition.status!=\'APPROVED\'" ng-change="vm.selectRequisitionStatus()" ng-disabled="vm.originalStatus!=\'PENDING\'" ng-options="u as u.name for u in vm.reqStatuses track by u.id" ng-model="vm.reqStatuses.selected"><option></option></select></div></div></div><div class="row" ng-if="!vm.isLoading"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="REMARKS:"></b></label> <textarea class="form-control" ng-model="vm.requisition.remarks">\n\t\t\t\t\t\t\t</textarea></div></div></div><div class="row" ng-if="!vm.isLoading"><div class="col-md-6 col-lg-6"><hr></div></div><div class="row" ng-if="!vm.isLoading"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="BRANCH_NAME"></b></label><div>{{vm.requisition.branchName || \'-\' | uppercase}}</div></div></div></div><div class="row" ng-if="!vm.isLoading"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="CREATED_BY"></b></label><div>{{vm.requisition.createdBy || \'-\' | uppercase}}<br><small>{{vm.requisition.createdDate || \'-\' | date:\'dd/MM/yyyy hh:mma\'}}</small></div></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="MODIFIED_BY"></b></label><div>{{vm.requisition.modifiedBy || \'-\' | uppercase}}<br><small>{{vm.requisition.modifiedDate || \'-\' |date:\'dd/MM/yyyy hh:mma\'}}</small></div></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="{{ \'ITEM_LIST\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="PLEASE_CHECK_THE_REQUISITION_DETAILS_THOROUGHLY_BEFORE_APPROVE."></span></small></p><div class="row"><div class="col-md-12 col-lg-12" style="overflow:auto"><table class="table table-hover" style="font-size:80%" st-pipe="vm.retrieveData" st-table="vm.requisition.items" st-safe-src="vm.requisition.items" refresh-table=""><thead><tr><th colspan="24" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Raw Material" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-1 col-lg-1">&nbsp;</div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th class="rowno">#</th><th class="rawmat"><b translate="RAW_MATERIAL"><br>{{ \'CODE\' | translate }} &amp; {{ \'DESCRIPTION\' | translate }}</b></th><th class="supplier"><b><span translate="SUPPLIER"></span><br>{{ \'NAME\' | translate }} &amp; <span translate="PRICING"></span></b></th><th class="stock-bal hide-after" colspan="2"><b><span translate="STOCK"></span><br><span translate="BALANCE"></span></b></th><th class="po hide-after" colspan="2"><b translate="PURCHASE_ORDER"></b><br><b translate="REQUISITION_ISSUED"></b></th><th class="bbjob hide-after" colspan="2"><b translate="REQUISITION_SALESORDER"></b><br><b translate="QTY_NEEDED"></b></th><th class="bbjob hide-after" colspan="2"><b translate="REQUISITION_BULKBREAKJOB"></b><br><b translate="QTY_NEEDED"></b></th><th class="bbjob hide-after" colspan="2"><b translate="REQUISITION_STOCKTRANSFER"></b><br><b translate="QTY_NEEDED"></b></th><th class="job hide-after" colspan="2"><b><span translate="PENDING_JOB"></span><br><span translate="QTY_NEEDED"></span></b></th><th class="par hide-after" colspan="2"><b>{{ \'PAR_LEVEL\' | translate }}</b></th><th class="par hide-after" colspan="2"><b><span translate="REORDER"></span><br><span translate="LEVEL"></span></b></th><th class="par2 hide-after" colspan="2"><b><span translate="REORDER"></span><br><span translate="QTY"></span></b></th><th class="userinput hide-after" st-sort="quantity"><b translate="DELIVERY_DATE"></b><br><small translate="(YYYY-MM-DD)"></small></th><th class="userinput hide-after" st-sort="quantity"><b><span translate="REQUEST"></span><br><span translate="QUANTITY"></span></b></th><th style="border-bottom:2px solid #888" class="hide-after"><b translate="UOM"></b></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="24" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw fa-2x"></i> <span translate="PLEASE_WAIT_WHILE_THE_SYSTEM_IS_LOADING_THE_DATA_..."></span></b></center></big></td></tr><tr><td colspan="24" align="center" ng-show="vm.requisition.items.length==0"><br><span translate="RAW_MATERIAL_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr><tr ng-repeat="ntn in vm.requisition.itemsFiltered"><td>{{vm.startIndex+1+$index}})</td><td class="rawmat" nowrap="nowrap"><small>{{ ntn.itemCode || ntn.code }}</small><br><b>{{ ntn.itemDescription || ntn.description | uppercase }}</b><br><span style="font-size:7pt;color:#f00" ng-if="ntn.hasError">{{ntn.errorMsg}}</span></td><td class="supplier" nowrap="nowrap"><span ng-class="{\'text-danger\': !ntn.supplierName}">{{ntn.supplierName || \'no supplier\' | uppercase | limitTo:25}}</span> <span ng-if="ntn.supplierName.length>25">...</span><br><b ng-if="ntn.supplierName && vm.canAccessFoodCost">RM {{ntn.cost | number:2}} / {{ntn.itemPriceUomName}}</b></td><td class="stock-bal"><b>{{ ntn.stockBalance || 0 | number }}</b></td><td class="stock-bal-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="po"><b>{{ ntn.onOrderQuantity || 0 | number }}</b></td><td class="po-uom">{{ ntn.orderUomName | uppercase }}</td><td class="bbjob"><b>{{ ntn.salesOrderQty || 0 | number }}</b></td><td class="bbjob-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="bbjob"><b>{{ ntn.bulkBreakJobQty || 0 | number }}</b></td><td class="bbjob-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="bbjob"><b>{{ ntn.stockTransferQty || 0 | number }}</b></td><td class="bbjob-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="job"><b>{{ ntn.jobProductionQty || 0 | number }}</b></td><td class="job-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="par"><b>{{ ntn.parLevel || 0 }}</b></td><td class="par-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="par"><b>{{ ntn.reOrderLevel || 0 }}</b></td><td class="par-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="par"><b>{{ ntn.reOrderQuantity || 0 }}</b></td><td class="par2-uom">{{ ntn.orderUomName || ntn.uom.name | uppercase }}</td><td class="userinput"><div moment-picker="ntn.deliveryDate" format="YYYY-MM-DD" max-view="day" start-view="month" today="true" set-on-select="true" ng-hide="ntn.hasError" class="input-group" style="margin-bottom:0px;padding-top:7px;padding-bottom:7px"><span class="input-group-addon" style="padding:3px 6px;font-size:9pt" ng-hide="ntn.hasError"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control userinput-text" autocomplete="off" ng-readonly="true" ng-disabled="vm.originalStatus!=\'Pending\' || ntn.hasError" ng-hide="ntn.hasError" ng-model="ntn.deliveryDate"></div></td><td class="userinput2"><div class="form-group" style="margin-bottom:0px !important" ng-hide="ntn.hasError" ng-class="{\'has-error\': vm.dataForm.Quantity_{{$index}}.$invalid && (vm.dataForm.Quantity_{{$index}}.$dirty || vm.dataForm.$submitted)}"><input type="number" name="Quantity_{{$index}}" class="form-control userinput2-text" ng-disabled="vm.originalStatus!=\'Pending\' || ntn.hasError" ng-hide="ntn.hasError" ng-model="ntn.quantity" min="0"> <span class="help-block" ng-if="vm.dataForm.$submitted && vm.dataForm[\'Quantity_\' + $index].$error.number"><small>* <span translate="INVALID_NUMBER"></span></small></span></div></td><td style="padding-right:0px;line-height:40px"><span ng-hide="ntn.hasError"><b>{{ ntn.orderUomName || ntn.uom.name | uppercase }}</b></span></td></tr></tbody><tfoot><tr><td colspan="24" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table><div><div></div></div></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/requisitions/reqapproval/reqapprovalList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><p><small><i class="fa fa-info-circle"></i> <span translate="THIS_PAGE_WILL_LIST_REQUISTIONS_WITH_STATUS_CONFIRMED_ONLY"></span>.</small></p><br><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.reqData" style="font-size:100%" st-safe-src="vm.reqDataFull" refresh-table=""><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="requisitionNo" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="requisitionNo"><span translate="REQ._NO."></span></th><th translate="REQ._DATE"></th><th translate="BRANCH"></th><th translate="DEPARTMENT"></th><th translate="USER"></th><th translate="STATUS"></th><th st-sort="grandTotal">{{ \'GRAND_TOTAL\' | translate }}<br>({{vm.currencyCode}})</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th></th><th></th><th></th><th class="form-inline"><select st-search="branchName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="req in vm.reqDataFull | unique:\'branchName\'" value="{{req.branchName}}">{{req.branchName}}</option></select></th><th class="form-inline"><select st-search="departmentName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="req in vm.reqDataFull | unique:\'departmentName\'" value="{{req.departmentName}}">{{req.departmentName}}</option></select></th><th class="form-inline"><select st-search="userName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="req in vm.reqDataFull | unique:\'userName\'" value="{{req.status}}">{{req.userName}}</option></select></th><th class="form-inline"><select st-search="status"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="req in vm.reqDataFull | unique:\'status\'" value="{{req.status}}">{{req.status}}</option></select></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in vm.reqData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.requisitionNo}}</td><td>{{item.createdDate | date: "dd-MMM-yyyy" }}</td><td>{{item.branchName | uppercase}}</td><td>{{item.departmentName | uppercase}}</td><td>{{item.userName | uppercase}}</td><td>{{item.status | translate | uppercase}}</td><td>{{item.grandTotal | number:\'2\'}}</td><td align="center"><a href="" title="Approve" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#38ac2c" confirmed-click="vm.approveRequisition(item.id)" ng-confirm-click="Approve this Requisition?" ng-disabled="vm.lockButtons" rms-check-access="requisitions.reqapproval" rms-check-access-perm-type="UPDATE"><i class="fa fa-check-circle"></i></a></td><td align="center"><a href="" title="Cancel" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.cancelRequisition(item.id)" ng-confirm-click="Cancel this Requisition?" ng-disabled="vm.lockButtons" rms-check-access="requisitions.reqapproval" rms-check-access-perm-type="UPDATE"><i class="fa fa-ban"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="requisitions.reqapproval.update({id:item.id})" ng-disabled="vm.lockButtons" rms-check-access="requisitions.reqapproval" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr><tr ng-show="vm.reqData.length<=0"><td colspan="10">{{ \'NO_RECORD_FOUND\' | translate }}</td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/requisitions/reqapproval/reqapprovalUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/requisitions/reqapproval/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" style="margin-right:30px" ui-sref="requisitions.reqapproval.list" ng-disabled="vm.lockButtons || vm.isLoading"><i class="ion ion-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons || vm.isLoading"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-primary btn-with-icon" confirmed-click="vm.approveRequisition()" ng-confirm-click="Confirm to approve this Requisition?" ng-disabled="vm.lockButtons" ng-show="vm.requisition.status==\'CONFIRMED\'"><i class="fa fa-check-circle"></i> <span translate="APPROVE_REQUISITION"></span></a> <a href="" class="btn btn-danger btn-with-icon" confirmed-click="vm.cancelRequisition()" ng-confirm-click="Confirm to cancel this Requisition?" ng-disabled="vm.lockButtons" ng-show="vm.requisition.status==\'CONFIRMED\'"><i class="fa fa-ban"></i> <span translate="CANCEL_REQUISITION"></span></a></div></form>');
$templateCache.put('app/pages/requisitions/reqlist/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel with-scroll"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-show="vm.originalStatus==\'PENDING\' && !vm.isLoading"><small><i class="fa fa-info-circle"></i> <span translate="FILL_IN_THE_REQUISITION_DETAILS."></span></small></p><p ng-show="vm.originalStatus!=\'PENDING\' && !vm.isLoading"><small><i class="fa fa-exclamation-triangle" style="color:#fffc00"></i> {{ \'ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_AFTER\' | translate}} <b>{{ \'CONFIRMED\' | translate }}</b>.</small></p><br><div class="row" ng-if="vm.isLoading"><div class="col-lg-12"><div style="height:200px;line-height:200px;background:#eee"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'PLEASE_WAIT_WHILE_THE_SYSTEM_IS_GENERATING_THE_ANALYSIS\' | translate }}</b></center></big></div></div></div><div class="row" ng-if="!vm.isLoading"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="REQUISITION_NO."></b></label> <span class="form-control" ng-disabled="true" style="color:#00f">{{vm.requisition.requisitionNo || \'AUTONUMBER\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label for="Status"><b translate="REQUISITION_STATUS"></b> <i class="fa fa-asterisk req"></i></label> <span class="form-control" ng-disabled="true" style="color:#00f" ng-if="vm.requisition.status==\'COMPLETED\' || vm.requisition.status==\'CANCELLED\' || vm.requisition.status==\'APPROVED\'">{{vm.requisition.status}}</span><select class="form-control" style="color:#333" ng-if="vm.requisition.status!=\'COMPLETED\' && vm.requisition.status!=\'CANCELLED\' && vm.requisition.status!=\'APPROVED\'" ng-change="vm.selectRequisitionStatus()" ng-disabled="vm.originalStatus!=\'PENDING\'" ng-options="u as (u.name | translate | uppercase) for u in vm.reqStatuses track by u.id" ng-model="vm.reqStatuses.selected"><option></option></select></div></div></div><div class="row" ng-if="!vm.isLoading"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="REMARKS"></b></label> <textarea class="form-control" ng-disabled="vm.originalStatus!=\'PENDING\'" ng-model="vm.requisition.remarks">\n\t\t\t\t\t\t\t</textarea></div></div></div><div class="row" ng-if="vm.mode==2 && !vm.isLoading"><div class="col-md-6 col-lg-6"><hr></div></div><div class="row" ng-if="vm.mode==2 && !vm.isLoading"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="BRANCH_NAME"></b></label><div>{{vm.requisition.branchName || \'-\' | uppercase}}</div></div></div></div><div class="row" ng-if="vm.mode==2 && !vm.isLoading"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="CREATED_BY"></b></label><div>{{vm.requisition.createdBy || \'-\' | uppercase}}<br><small>{{vm.requisition.createdDate || \'-\' | date:\'dd/MM/yyyy hh:mma\'}}</small></div></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="MODIFIED_BY"></b></label><div>{{vm.requisition.modifiedBy || \'-\' | uppercase}}<br><small>{{vm.requisition.modifiedDate || \'-\' |date:\'dd/MM/yyyy hh:mma\'}}</small></div></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div><a class="float-approval-button" ng-if="vm.requisition.isPendingApproval" ng-click="vm.showApprovalModal()"><center><img src="assets/img/approval.png"><div><b>{{\'PENDING\' | translate}}<br>{{\'APPROVAL\' | translate}}</b></div></center></a></uib-tab><uib-tab heading="{{ \'RAW_MATERIALS\' | translate }}"><p ng-if="vm.originalStatus==\'PENDING\'"><i class="fa fa-info-circle"></i> {{ \'FILL_IN_THE_QUANTITY_FOR_THE_RAW_MATERIAL_LIST.\' | translate }} <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-disabled="vm.lockButtons || vm.isAnalyzing" ng-if="(!vm.isRmsLite && !vm.isAnalyzing && !vm.isLoading) || (vm.isRmsLite && vm.hasAutofillAccess && !vm.isAnalyzing && !vm.isLoading)" confirmed-click="vm.requisitionAnalysis()" ng-confirm-click="{{\'CONFIRM_AUTO_FILL_RECOM_QTY\' | translate }} ?"><i class="fa fa-pencil"></i> {{ \'AUTO-FILL_SYSTEM_RECOMMENDED_QUANTITY\' | translate }}</a><div ng-show="vm.isAnalyzing" style="height:35px;line-height:100% !important"><small translate="PROCESSING">...</small><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width:100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></p><p ng-if="vm.originalStatus!=\'PENDING\'"><i class="fa fa-exclamation-triangle" style="color:#fffc00"></i> {{ \'ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT\' | translate}} <b>{{ \'PENDING\' | translate }}</b>.</p><div class="row"><div class="col-md-12 col-lg-12" style="overflow:auto;width:auto;min-width:100%"><table class="table table-hover" style="font-size:80%" st-pipe="vm.retrieveData" st-table="vm.requisition.items" st-safe-src="vm.requisition.items" refresh-table=""><thead><tr><th colspan="24" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="padding-left:0px"><span style="font-size:120%"><b>{{ \'SELECT_A_BRANCH\' | translate }}:</b></span><br><select class="form-control" style="margin-top:2px" ng-disabled="vm.isLoading || vm.requisition.status!=\'PENDING\'" ng-options="t as t.name for t in vm.branches | orderBy:\'name\'" ng-model="vm.selectedBranch" ng-change="vm.selectedBranchChanged()"><option value="">{{vm.requisition.status!=\'PENDING\' ? vm.requisition.branchName : \'SELECT_A_BRANCH\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2"><span style="font-size:120%"><b>{{ \'SEARCH\' | translate }}:</b></span><br><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control" ng-disabled="vm.isLoading"></div></div><div class="col-xs-10 col-sm-10 col-md-1 col-lg-1"></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2"><span>&nbsp;</span><br><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="vm.isLoading" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select><span ng-if="vm.showTimer">&nbsp;&nbsp;&nbsp;&nbsp; {{ \'ANALYSIS_TIME:\' | translate }} <b>{{vm.timeTaken | number:0}}</b> {{ \'SECONDS\' | translate }}</span></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-5" style="padding-right:0px"><span>&nbsp;</span><br><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th class="rowno">#</th><th class="rawmat"><b>{{ \'RAW_MATERIAL\' | translate }}<br>{{ \'CODE\' | translate }} &amp; {{ \'DESCRIPTION\' | translate }}</b></th><th class="supplier"><b>{{ \'SUPPLIER_AND_PRICING\' | translate }}</b><br><select st-search="supplierName" style="width:100%"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="req in vm.requisition.requisitionItems | unique:\'supplierName\'" value="{{req.supplierName | uppercase}}">{{req.supplierName | uppercase}}</option></select></th><th class="stock-bal hide-after" colspan="2"><b>{{ \'STOCK_BALANCE\' | translate }}</b></th><th class="po hide-after" colspan="2"><b translate="PURCHASE_ORDER"></b><br><b translate="REQUISITION_ISSUED"></b></th><th class="bbjob hide-after" colspan="2"><b translate="REQUISITION_SALESORDER"></b><br><b translate="QTY_NEEDED"></b></th><th class="bbjob hide-after" colspan="2"><b translate="REQUISITION_BULKBREAKJOB"></b><br><b translate="QTY_NEEDED"></b></th><th class="bbjob hide-after" colspan="2"><b translate="REQUISITION_STOCKTRANSFER"></b><br><b translate="QTY_NEEDED"></b></th><th class="job hide-after" colspan="2"><b><span translate="PENDING_JOB"></span><br><span translate="QTY_NEEDED"></span></b></th><th class="par hide-after" colspan="2"><b>{{ \'PAR_LEVEL\' | translate }}</b></th><th class="par hide-after" colspan="2"><b><span translate="REORDER"></span><br><span translate="LEVEL"></span></b></th><th class="par2 hide-after" colspan="2"><b><span translate="REORDER"></span><br><span translate="QTY"></span></b></th><th class="userinput hide-after" st-sort="quantity"><b translate="DELIVERY_DATE"></b><br><small translate="(YYYY-MM-DD)"></small></th><th class="userinput hide-after" st-sort="quantity"><b><span translate="REQUEST"></span><br><span translate="QUANTITY"></span></b></th><th style="border-bottom:2px solid #888" class="hide-after"><b translate="UOM"></b></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="24" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw fa-2x"></i> <span translate="PLEASE_WAIT_WHILE_THE_SYSTEM_IS_GENERATING_THE_ANALYSIS"></span></b></center></big></td></tr><tr ng-if="!vm.isLoading && vm.requisition.requisitionItems.length==0"><td colspan="24" align="center"><br>{{ \'RAW_MATERIAL_LIST_IS_EMPTY.\' | translate }}<br>&nbsp;</td></tr><tr ng-repeat="ntn in vm.requisition.itemsFiltered"><td>{{vm.startIndex+1+$index}})</td><td class="rawmat" nowrap="nowrap"><small>{{ ntn.itemCode || ntn.code }}</small><br><b>{{ ntn.itemDescription || ntn.description | uppercase }}</b><br><span style="font-size:7pt;color:#f00" ng-if="ntn.hasError">{{ntn.errorMsg}}</span></td><td class="supplier" nowrap="nowrap"><span ng-class="{\'text-danger\': !ntn.supplierName}">{{ntn.supplierName || \'no supplier\' | uppercase | limitTo:25}}</span> <span ng-if="ntn.supplierName.length>25">...</span><br><b ng-if="ntn.supplierName && vm.canAccessFoodCost">{{vm.currencyCode}} {{ntn.cost | number:2}} / {{ntn.orderUomName}}</b></td><td class="stock-bal"><b>{{ ntn.stockBalance || 0 | number }}</b></td><td class="stock-bal-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="po"><b>{{ ntn.onOrderQuantity || 0 | number }}</b></td><td class="po-uom">{{ ntn.orderUomName | uppercase }}</td><td class="bbjob"><b>{{ ntn.salesOrderQty || 0 | number }}</b></td><td class="bbjob-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="bbjob"><b>{{ ntn.bulkBreakJobQty || 0 | number }}</b></td><td class="bbjob-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="bbjob"><b>{{ ntn.stockTransferQty || 0 | number }}</b></td><td class="bbjob-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="job"><b>{{ ntn.jobProductionQty || 0 | number }}</b></td><td class="job-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="par"><b>{{ ntn.parLevel || 0 }}</b></td><td class="par-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="par"><b>{{ ntn.reOrderLevel || 0 }}</b></td><td class="par-uom">{{ ntn.inventoryUomName | uppercase }}</td><td class="par"><b>{{ ntn.reOrderQuantity || 0 }}</b></td><td class="par2-uom">{{ ntn.orderUomName || ntn.uom.name | uppercase }}</td><td class="userinput"><div moment-picker="ntn.deliveryDate" format="YYYY-MM-DD" max-view="day" start-view="month" today="true" set-on-select="true" ng-hide="ntn.hasError" class="input-group" style="margin-bottom:0px;padding-top:7px;padding-bottom:7px"><span class="input-group-addon" style="padding:3px 6px;font-size:9pt" ng-hide="ntn.hasError"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control userinput-text" autocomplete="off" ng-disabled="vm.originalStatus!=\'PENDING\' || ntn.hasError" ng-hide="ntn.hasError" ng-model="ntn.deliveryDate"></div></td><td class="userinput2"><div class="form-group" style="margin-bottom:0px !important" ng-hide="ntn.hasError" ng-class="{\'has-error\': vm.dataForm.Quantity_{{$index}}.$invalid && (vm.dataForm.Quantity_{{$index}}.$dirty || vm.dataForm.$submitted)}"><input type="number" name="Quantity_{{$index}}" class="form-control userinput2-text" ng-disabled="vm.originalStatus!=\'PENDING\' || ntn.hasError" ng-hide="ntn.hasError" ng-model="ntn.quantity" min="0"> <span class="help-block" ng-if="vm.dataForm.$submitted && vm.dataForm[\'Quantity_\' + $index].$error.number"><small>* <span translate="INVALID_NUMBER"></span></small></span></div></td><td style="padding-right:0px;line-height:40px"><span ng-hide="ntn.hasError">{{ ntn.orderUomName || ntn.uom.name | uppercase }}</span></td></tr></tbody><tfoot><tr><td colspan="24" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table><div><div></div></div></div></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="approvalModal.html"><form name="$mdl.approvalForm" ng-submit="$mdl.approve()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> {{ \'APPROVAL_FOR\' | translate }} [{{$mdl.docNo}}] </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <h3>{{ \'DO_YOU_WANT_TO_APPROVE_THIS_REQ\' | translate }}?</h3> <br /><br /><br /> </div> </div> </div> <hr /> <div class="modal-footer"> <button type="submit" class="btn btn-success btn-with-icon" style="float:left"> <i class="fa fa-check-circle"></i> <span translate="APPROVE"></span> </button> <a href class="btn btn-danger btn-with-icon" ng-click="$mdl.disapprove()" style="float:left"> <i class="fa fa-check-circle"></i> <span translate="DISAPPROVE"></span> </a> <a class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </a> </div> </form></script>');
$templateCache.put('app/pages/requisitions/reqlist/reqlistCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/requisitions/reqlist/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" style="margin-right:30px" ui-sref="requisitions.reqlist.list" ng-disabled="vm.lockButtons || vm.isAnalyzing || vm.isLoading"><i class="ion ion-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons || vm.isAnalyzing || vm.isLoading"><i class="ion ion-checkmark"></i> <span translate="CREATE_REQUISITION"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="requisitions.reqlist.list" ng-disabled="vm.lockButtons || vm.isAnalyzing || vm.isLoading"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/requisitions/reqlist/reqlistList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RequisitionListing" style="font-size:100%" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isSameBranch" class="form-control input"><option value="">{{ \'SHOW_CURRENT_BRANCH_ONLY\' | translate }}</option><option value="0">{{ \'SHOW_ALL_BRANCHES\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_CLOSED_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="requisitions.reqlist.create" rms-check-access="requisitions.reqlist" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="NEW_REQUISITION"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="requisitionNo">{{ \'REQ._NO.\' | translate }}</th><th>{{ \'REQ._DATE\' | translate }}</th><th st-sort="branchName">{{ \'BRANCH\' | translate }}</th><th st-sort="departmentName">{{ \'DEPARTMENT\' | translate }}</th><th st-sort="userName">{{ \'REQUESTED_BY\' | translate }}</th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th st-sort="grandTotal">{{ \'GRAND_TOTAL\' | translate }}<br>({{vm.currencyCode}})</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th colspan="2" class="form-inline"><input st-search="requisitionNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="branchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="departmentName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="userName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="status" class="form-control input input-sm" style="width:120px"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td>{{item.requisitionNo}}</td><td>{{item.createdDate | date: "dd-MMM-yyyy" }}</td><td>{{item.branchName | uppercase}}</td><td>{{item.departmentName | uppercase}}</td><td>{{item.userName | uppercase}}</td><td>{{item.status | translate | uppercase}}</td><td>{{item.grandTotal | number:\'2\'}}</td><td align="center"><a href="" title="Print Requisition" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#00f" ng-if="item.status!=\'Pending\' && item.status!=\'Cancelled\'" ng-click="vm.printRequisition(item.id, item.requisitionNo)" rms-check-access="requisitions.reqlist" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="requisitions.reqlist.update({id:item.id})" rms-check-access="requisitions.reqlist" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr><tr ng-show="vm.data.length<=0"><td colspan="9">{{ \'NO_RECORD_FOUND\' | translate }}</td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/requisitions/reqlist/reqlistUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/requisitions/reqlist/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" style="margin-right:30px" ui-sref="requisitions.reqlist.list" ng-disabled="vm.lockButtons || vm.isAnalyzing || vm.isLoading"><i class="ion ion-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons || vm.isAnalyzing || vm.isLoading" ng-show="vm.originalStatus==\'PENDING\'"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" style="margin-right:30px" ui-sref="requisitions.reqlist.list" ng-disabled="vm.lockButtons || vm.isAnalyzing || vm.isLoading" ng-show="vm.originalStatus==\'PENDING\'"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-warning btn-with-icon" confirmed-click="vm.cancelRequisition()" ng-confirm-click="Confirm to cancel this Requisition?" ng-disabled="vm.lockButtons || vm.isAnalyzing || vm.isLoading" ng-show="vm.originalStatus!=\'COMPLETED\' && vm.originalStatus!=\'CANCELLED\'"><i class="ion ion-trash-a"></i> <span translate="CANCEL_REQUISITION"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.printRequisition()" ng-disabled="vm.lockButtons || vm.isAnalyzing || vm.isLoading" ng-show="vm.originalStatus!=\'PENDING\' && vm.originalStatus!=\'CANCELLED\'"><i class="fa fa-print"></i> <span translate="PRINT_REQUISITION"></span></a></div></form>');
$templateCache.put('app/pages/robotkiosk/equipmenttypes/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SizeCode.$invalid && (vm.dataForm.SizeCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SizeCode" ng-model="vm.type.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SizeCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SizeName.$invalid && (vm.dataForm.SizeName.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SizeName" ng-model="vm.type.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SizeName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_ACTIVE"></b></label><div><toggle ng-model="vm.type.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div></div><div class="col-md-12 col-lg-12"><div><p><br><br>&nbsp;</p></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/robotkiosk/equipmenttypes/typeCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/equipmenttypes/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.equipmenttypes.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/robotkiosk/equipmenttypes/typeList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RobotKioskSizeListing" st-pipe="vm.retrieveData" st-table="vm.typeData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Equipment Type" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.equipmenttypes.create" rms-check-access="robotkiosk.equipmenttypes" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Type</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="code">Code</th><th st-sort="name">Description</th><th class="hide-after" style="text-align:center">Is Active?</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.typeData.length<=0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.typeData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="robotkiosk.equipmenttypes.update({id:item.id})" rms-check-access="robotkiosk.equipmenttypes" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteData(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Equipment Type?" rms-check-access="robotkiosk.equipmenttypes" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/robotkiosk/equipmenttypes/typeUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/equipmenttypes/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.equipmenttypes.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.equipmenttypes.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/robotkiosk/equipments/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-model="vm.equipment.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-lg-3"><div class="form-group"><label><b translate="IS_ACTIVE"></b></label><div><toggle ng-model="vm.equipment.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.EquipmentType.$invalid && (vm.dataForm.EquipmentType.$dirty || vm.dataForm.$submitted)}"><label><b translate="EQUIPMENT_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select name="EquipmentType" class="form-control" ng-change="vm.selectedEqTypeChanged()" ng-options="b as b.name for b in vm.eqTypeList" ng-model="vm.selectedEqType" required=""><option value="">-- {{ \'SELECT_A_TYPE\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.EquipmentType.$error.required">* Required</span></div></div></div><div class="row"><div class="col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.KioskName.$invalid && (vm.dataForm.KioskName.$dirty || vm.dataForm.$submitted)}"><label><b translate="KIOSK_NAME"></b> <i class="fa fa-asterisk req"></i></label><select name="KioskName" class="form-control" ng-change="vm.selectedKioskChanged()" ng-options="b as b.description for b in vm.kioskList" ng-model="vm.selectedKiosk" required=""><option value="">-- {{ \'SELECT_A_KIOSK\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.KioskName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.RawMatStorage.$invalid && (vm.dataForm.RawMatStorage.$dirty || vm.dataForm.$submitted)}"><label><b translate="RAWMAT_STORAGE"></b> <i class="fa fa-asterisk req"></i></label><select name="RawMatStorage" class="form-control" ng-change="vm.selectedStorageRMChanged()" ng-options="b as \'(\' + b.code + \') \' + b.description for b in vm.storageListRM | orderBy:[\'description\', \'code\']" ng-model="vm.selectedStorageRM" required=""><option value="">-- {{ \'SELECT_A_STORAGE\' | translate }} --</option></select><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" style="margin-top:3px" ng-if="vm.selectedStorageRM!=null" ng-click="vm.clearStorageRM()"><i class="ion ion-close"></i> {{\'CLEAR_SELECTION\' | translate}}</a> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RawMatStorage.$error.required">* Required</span></div></div></div><div class="row"><div class="col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SemiFgStorage.$invalid && (vm.dataForm.SemiFgStorage.$dirty || vm.dataForm.$submitted)}"><label><b translate="SEMIFG_STORAGE"></b> <i class="fa fa-asterisk req"></i></label><select name="SemiFgStorage" class="form-control" ng-change="vm.selectedStorageSFGChanged()" ng-options="b as \'(\' + b.code + \') \' + b.description for b in vm.storageListSFG | orderBy:[\'description\', \'code\']" ng-model="vm.selectedStorageSFG" required=""><option value="">-- {{ \'SELECT_A_STORAGE\' | translate }} --</option></select><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" style="margin-top:3px" ng-if="vm.selectedStorageSFG!=null" ng-click="vm.clearStorageSFG()"><i class="ion ion-close"></i> {{\'CLEAR_SELECTION\' | translate}}</a> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SemiFgStorage.$error.required">* Required</span></div></div></div><div><p><br><br></p><p><br><br></p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/robotkiosk/equipments/eqptCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/equipments/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.equipments.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/robotkiosk/equipments/eqptList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RobotKioskEquipmentListing" st-pipe="vm.retrieveData" st-table="vm.equipmentData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Equipment" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.equipments.create" rms-check-access="robotkiosk.equipments" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Equipment</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="kioskBranchName">Branch</th><th st-sort="kioskName">Kiosk Name</th><th st-sort="description">Equipment Name</th><th st-sort="kioskEquipmentTypeName">Equipment Type</th><th st-sort="rawMatStorageName">Raw Mat Storage</th><th st-sort="sfgStorageName">Semi FG Storage</th><th class="hide-after">Active?</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th></th><th><select st-search="kioskBranchName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="b in vm.equipmentDataFull | unique:\'kioskBranchName\' | uppercase | orderBy:\'kioskBranchName\'" value="{{b.kioskBranchName}}">{{(b.kioskBranchName | uppercase | limitTo:40) + (b.kioskBranchName.length > 40 ? \' ...\' : \'\') }}</option></select></th><th><select st-search="kioskName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="b in vm.equipmentDataFull | unique:\'kioskName\' | uppercase | orderBy:\'kioskName\'" value="{{b.kioskName}}">{{(b.kioskName | uppercase | limitTo:40) + (b.kioskName.length > 40 ? \' ...\' : \'\') }}</option></select></th><th></th><th><select st-search="kioskEquipmentTypeName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="b in vm.equipmentDataFull | unique:\'kioskEquipmentTypeName\' | uppercase | orderBy:\'kioskEquipmentTypeName\'" value="{{b.kioskEquipmentTypeName}}">{{(b.kioskEquipmentTypeName | uppercase | limitTo:25) + (b.kioskEquipmentTypeName.length > 25 ? \' ...\' : \'\') }}</option></select></th><th><select st-search="rawMatStorageName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="b in vm.equipmentDataFull | unique:\'rawMatStorageName\' | uppercase | orderBy:\'rawMatStorageName\'" value="{{b.rawMatStorageName}}">{{(b.rawMatStorageName | uppercase | limitTo:40) + (b.rawMatStorageName.length > 40 ? \' ...\' : \'\') }}</option></select></th><th><select st-search="sfgStorageName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="b in vm.equipmentDataFull | unique:\'sfgStorageName\' | uppercase | orderBy:\'sfgStorageName\'" value="{{b.sfgStorageName}}">{{(b.sfgStorageName | uppercase | limitTo:40) + (b.sfgStorageName.length > 40 ? \' ...\' : \'\') }}</option></select></th><th><select st-search="isActive"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="b in vm.equipmentDataFull | unique:\'isActive\' | uppercase | orderBy:\'isActive\'" value="{{b.isActive}}">{{(c.isActive?\'YES\':\'NO\')}}</option></select></th><th colspan="2"></th></tr></thead><tbody><tr ng-if="vm.equipmentData.length<=0 && !vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.equipmentData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.kioskBranchName}}</td><td>{{item.kioskName}}</td><td>{{item.description}}</td><td>{{item.kioskEquipmentTypeName}}</td><td>({{item.rawMatStorageCode}}) {{item.rawMatStorageName}}</td><td>({{item.sfgStorageCode}}) {{item.sfgStorageName}}</td><td><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="robotkiosk.equipments.update({id:item.id})" rms-check-access="robotkiosk.equipments" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteData(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Equipment?" rms-check-access="robotkiosk.equipments" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/robotkiosk/equipments/eqptUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/equipments/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.equipments.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.equipments.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/robotkiosk/kiosks/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.KioskCode.$invalid && (vm.dataForm.KioskCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="KIOSK_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="KioskCode" ng-model="vm.kiosk.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.KioskCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="IS_ACTIVE"></b>?</label><div><toggle ng-model="vm.kiosk.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.KioskName.$invalid && (vm.dataForm.KioskName.$dirty || vm.dataForm.$submitted)}"><label><b translate="KIOSK_DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="KioskName" ng-model="vm.kiosk.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.KioskName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="PRINT_RECEIPT"></b>?</label><div><toggle ng-model="vm.kiosk.printReceipt" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Branch.$invalid && (vm.dataForm.Branch.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'BRANCH\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="Branch" class="form-control" style="background:#FFFCED" ng-change="vm.selectedBranchChanged()" ng-options="b as b.name for b in vm.branchList | orderBy:\'name\'" ng-model="vm.selectedBranch" required=""><option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Branch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="ACCEPT_PAYMENT"></b>?</label><div><toggle ng-model="vm.kiosk.acceptPayment" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" ng-model="vm.kiosk.remarks"></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="HAS_QR_SCANNER"></b>?</label><div><toggle ng-model="vm.kiosk.hasQRScanner" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><p><br><br>&nbsp;</p></uib-tab><uib-tab heading="{{ \'CATEGORIES\' | translate }}"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p><i class="fa fa-info-circle"></i> <span translate="SELECT_AT_LEAST_ONE"></span> {{ \'CATEGORY\' | translate }} <i class="fa fa-asterisk req"></i></p></div></div><div class="row"><div class="col-md-4 col-lg-4" ng-repeat="c in vm.categoryList" style="margin-bottom:8px;line-height:30px"><input type="checkbox" name="cate" style="float:left;cursor:pointer;width:25px;height:25px" checklist-model="vm.selectedCategories" checklist-value="c" checklist-change="vm.dataForm.cate.$setValidity(\'required\', vm.selectedCategories.length > 0)" ng-required="!vm.selectedCategories.length"> <span style="padding-left:10px">{{ c.name | uppercase }}</span></div></div><div class="row"><div class="col-md-12"><p><div class="col-md-12" ng-class="{\'has-error\': vm.dataForm.$submitted && vm.dataForm.cate.$invalid }"><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.cate.$invalid">* {{ \'REQUIRE_AT_LEAST_ONE_CATEGORY\' | translate }}</span></div></p></div></div><p><br><br>&nbsp;</p></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/robotkiosk/kiosks/kioskCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/kiosks/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.kiosks.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/robotkiosk/kiosks/kioskList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RobotKioskListing" st-pipe="vm.retrieveData" st-table="vm.kioskData" refresh-table=""><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Kiosk" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.kiosks.create" rms-check-access="robotkiosk.kiosks" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Kiosk</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="code">Kiosk Code</th><th st-sort="description">Kiosk Name</th><th st-sort="branchName">Branch Name</th><th class="hide-after" style="text-align:center">Has QR?</th><th class="hide-after" style="text-align:center">Print?</th><th class="hide-after" style="text-align:center">Payment?</th><th class="hide-after" style="text-align:center">Is Active?</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.kioskData.length<=0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.kioskData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.description}}</td><td>{{item.branchName}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.hasQRScanner" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.hasQRScanner" style="color:#f00"></i></td><td style="text-align:center"><i class="fa fa-check" ng-show="item.printReceipt" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.printReceipt" style="color:#f00"></i></td><td style="text-align:center"><i class="fa fa-check" ng-show="item.acceptPayment" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.acceptPayment" style="color:#f00"></i></td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="robotkiosk.kiosks.update({id:item.id})" rms-check-access="robotkiosk.kiosks" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteData(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Kiosk?" rms-check-access="robotkiosk.kiosks" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/robotkiosk/kiosks/kioskUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/kiosks/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.kiosks.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.kiosks.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/robotkiosk/categories/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="row"><img ngf-src="picFile || vm.cate.imageLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div><div class="row"><div class="col-md-12 col-lg-12"><p><small><i class="fa fa-info-circle"></i> <em><span translate="RECOMMENDED_TO_UPLOAD_A_LANDSCAPE_IMAGE"></span>.</em></small></p>&nbsp;</div></div><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-disabled="vm.lockUploadButton" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> {{ \'UPLOAD_PICTURE\' | translate }}</div><a href="" ng-click="picFile=null;vm.setUploadImage(picFile)" ng-show="picFile" class="btn btn-default btn-with-icon" ng-disabled="vm.lockUploadButton"><i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }}</a></div><div class="row" ng-show="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-4 col-lg-4"><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CategoryCode.$invalid && (vm.dataForm.CategoryCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="CATEGORY_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CategoryCode" ng-model="vm.cate.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CategoryCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CategoryName.$invalid && (vm.dataForm.CategoryName.$dirty || vm.dataForm.$submitted)}"><label><b translate="CATEGORY_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CategoryName" ng-model="vm.cate.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CategoryName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_ACTIVE"></b></label><div><toggle ng-model="vm.cate.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div></div><div class="col-md-12 col-lg-12"><div><p><br><br>&nbsp;</p></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/robotkiosk/categories/categoryCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/categories/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.categories.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/robotkiosk/categories/categoryList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RobotKioskCategoryListing" st-pipe="vm.retrieveData" st-table="vm.cateData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Category" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.categories.create" rms-check-access="robotkiosk.categories" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Category</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:140px">Image</th><th st-sort="code">Category Code</th><th st-sort="code">Category Name</th><th class="hide-after" style="text-align:center">Is Active?</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.cateData.length<=0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.cateData"><td>{{vm.startIndex+1+$index}})</td><td><img src="{{vm.blobUrl + item.imageLocation || null}}" style="width:100px;height:100px;margin-bottom:10px"></td><td>{{item.code}}</td><td>{{item.name}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="robotkiosk.categories.update({id:item.id})" rms-check-access="robotkiosk.categories" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteData(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Category?" rms-check-access="robotkiosk.categories" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/robotkiosk/categories/categoryUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/categories/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.categories.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.categories.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/robotkiosk/productmappings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Kiosk.$invalid && (vm.dataForm.Kiosk.$dirty || vm.dataForm.$submitted)}"><label><b>Kiosk</b> <i class="fa fa-asterisk req"></i></label><select name="Kiosk" class="form-control" ng-change="vm.selectedKioskChanged()" ng-options="b as b.description for b in vm.kioskList" ng-model="vm.selectedKiosk" required=""><option value="">-- {{ \'SELECT_AN_OPTION\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Kiosk.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.KioskProduct.$invalid && (vm.dataForm.KioskProduct.$dirty || vm.dataForm.$submitted)}"><label><b>Kiosk Product</b> <i class="fa fa-asterisk req"></i></label><select name="KioskProduct" class="form-control" ng-change="vm.selectedProductChanged()" ng-options="b as b.description for b in vm.productList" ng-model="vm.selectedProduct" required=""><option value="">-- {{ \'SELECT_AN_OPTION\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.KioskProduct.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Variety.$invalid && (vm.dataForm.Variety.$dirty || vm.dataForm.$submitted)}"><label><b>Kiosk Product Variety</b> <i class="fa fa-asterisk req"></i></label><select name="Variety" class="form-control" ng-change="vm.selectedVarietyChanged()" ng-options="b as (b.sizeName + (b.flavorName?(\' - \' + b.flavorName):\'\') + (b.otherName?(\' - \' + b.otherName):\'\')) for b in vm.varietyList" ng-model="vm.selectedVariety" required=""><option value="">-- {{ \'SELECT_AN_OPTION\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Variety.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FinishedGood.$invalid && (vm.dataForm.FinishedGood.$dirty || vm.dataForm.$submitted)}"><label><b>Associated Finished Goods</b> <i class="fa fa-asterisk req"></i></label><select name="FinishedGood" class="form-control" ng-change="vm.selectedFgChanged()" ng-options="b as b.name for b in vm.fgList" ng-model="vm.selectedFg" required=""><option value="">-- {{ \'SELECT_AN_OPTION\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FinishedGood.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.RobotProgramCode.$invalid && (vm.dataForm.RobotProgramCode.$dirty || vm.dataForm.$submitted)}"><label><b>Robot PLC Program Code</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="RobotProgramCode" ng-model="vm.mapping.robotProgramCode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RobotProgramCode.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/robotkiosk/productmappings/mappingCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/productmappings/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.productmappings.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/robotkiosk/productmappings/mappingList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RobotKioskProdMapListing" st-pipe="vm.retrieveData" st-table="vm.mappingData" refresh-table=""><thead><tr><th colspan="12" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Gateway" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.productmappings.create" rms-check-access="robotkiosk.productmappings" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Mapping</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="kioskCode">Kiosk</th><th st-sort="kioskProductDescription">Kiosk Product</th><th>Size</th><th>Flavor</th><th>Other Option</th><th>Associated<br>Product Name</th><th>Robot<br>Program Code</th><th class="hide-after" style="text-align:center">Is Active?</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.mappingData.length<=0 && !vm.isLoading"><td colspan="12" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="12" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.mappingData"><td>{{vm.startIndex+1+$index}})</td><td style="line-height:110%;padding-top:8px;padding-bottom:8px"><small>{{item.kioskCode}}</small><br>{{item.kioskDescription}}</td><td style="line-height:110%;padding-top:8px;padding-bottom:8px"><small>{{item.kioskProductCode}}</small><br>{{item.kioskProductDescription}}</td><td>{{item.productSizeName}}</td><td>{{item.productFlavorName || \'-\'}}</td><td>{{item.productOptionName || \'-\'}}</td><td style="line-height:110%;padding-top:8px;padding-bottom:8px"><small>{{item.fgCode}}</small><br>{{item.fgDescription}}</td><td>{{item.robotProgramCode}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="robotkiosk.productmappings.update({id:item.id})" rms-check-access="robotkiosk.productmappings" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteMapping(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Mapping?" rms-check-access="robotkiosk.productmappings" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="12" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/robotkiosk/productmappings/mappingUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/productmappings/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.productmappings.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.productmappings.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/robotkiosk/productothers/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.OptionCode.$invalid && (vm.dataForm.OptionCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="OPTION_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="OptionCode" ng-model="vm.option.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.OptionCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.OptionName.$invalid && (vm.dataForm.OptionName.$dirty || vm.dataForm.$submitted)}"><label><b translate="OPTION_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="OptionName" ng-model="vm.option.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.OptionName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.OptionType.$invalid && (vm.dataForm.OptionType.$dirty || vm.dataForm.$submitted)}"><label><b translate="OPTION_TYPE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="OptionType" ng-model="vm.option.type" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.OptionType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_ACTIVE"></b></label><div><toggle ng-model="vm.option.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div></div><div class="col-md-12 col-lg-12"><div><p><br><br>&nbsp;</p></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/robotkiosk/productothers/otherCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/productothers/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.productothers.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/robotkiosk/productothers/otherList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RobotKioskOtherListing" st-pipe="vm.retrieveData" st-table="vm.otherData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Product Option" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.productothers.create" rms-check-access="robotkiosk.productothers" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Options</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="type">Option Type</th><th st-sort="code">Option Code</th><th st-sort="name">Option Name</th><th class="hide-after" style="text-align:center">Is Active?</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.otherData.length<=0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.otherData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.type}}</td><td>{{item.code}}</td><td>{{item.name}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="robotkiosk.productothers.update({id:item.id})" rms-check-access="robotkiosk.productothers" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteData(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Product Option?" rms-check-access="robotkiosk.productothers" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/robotkiosk/productothers/otherUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/productothers/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.productothers.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.productothers.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/robotkiosk/productflavors/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FlavorCode.$invalid && (vm.dataForm.FlavorCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="FLAVOR_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="FlavorCode" ng-model="vm.flavor.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FlavorCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FlavorName.$invalid && (vm.dataForm.FlavorName.$dirty || vm.dataForm.$submitted)}"><label><b translate="FLAVOR_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="FlavorName" ng-model="vm.flavor.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FlavorName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_ACTIVE"></b></label><div><toggle ng-model="vm.flavor.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div></div><div class="col-md-12 col-lg-12"><div><p><br><br>&nbsp;</p></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/robotkiosk/productflavors/flavorCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/productflavors/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.productflavors.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/robotkiosk/productflavors/flavorList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RobotKioskFlavorListing" st-pipe="vm.retrieveData" st-table="vm.flavorData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Product Flavor" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.productflavors.create" rms-check-access="robotkiosk.productflavors" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Flavor</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="code">Flavor Code</th><th st-sort="name">Flavor Name</th><th class="hide-after" style="text-align:center">Is Active?</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.flavorData.length<=0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.flavorData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="robotkiosk.productflavors.update({id:item.id})" rms-check-access="robotkiosk.productflavors" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteData(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Product Flavor?" rms-check-access="robotkiosk.productflavors" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/robotkiosk/productflavors/flavorUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/productflavors/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.productflavors.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.productflavors.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/robotkiosk/products/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><br><div class="row"><div class="col-md-4 col-lg-4" style="padding-right:50px"><div class="row"><div class="col-md-12 col-lg-12"><img ngf-src="picFile || vm.product.imageLocation" alt="" class="col-lg-12" style="border:1px solid #ccc"></div></div><br><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-disabled="vm.lockUploadButton" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> {{ "UPLOAD_PICTURE" | translate }}</div><a href="" ng-click="picFile=null;vm.setUploadImage(picFile)" ng-if="picFile" class="btn btn-default btn-with-icon" ng-disabled="vm.lockUploadButton" ng-show="!vm.lockUploadButton"><i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }}</a></div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div><div class="col-md-4 col-lg-4"><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ProductCode.$invalid && (vm.dataForm.ProductCode.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'PRODUCT_CODE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ProductCode" ng-model="vm.product.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ProductCode.$error.required">* {{"REQUIRED" | translate}}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ProductName.$invalid && (vm.dataForm.ProductName.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'PRODUCT_NAME\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ProductName" ng-model="vm.product.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ProductName.$error.required">* {{"REQUIRED" | translate}}</span></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BasePrice.$invalid && (vm.dataForm.BasePrice.$dirty || vm.dataForm.$submitted)}"><label><b translate="BASE_PRICE"></b> ({{vm.currencyCode}}) <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="BasePrice" ng-model="vm.product.basePrice" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BasePrice.$error.required">* {{"REQUIRED" | translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BasePrice.$error.min">* {{"MINIMUM_IS_0" | translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BasePrice.$error.number">* {{"ENTER_NUMBERS_ONLY" | translate}}</span></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label><b>{{ \'TAX_CODE\' | translate }}</b></label> <input type="text" class="form-control" name="BasePrice" ng-model="vm.product.taxCode"></div></div><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TaxRate.$invalid && (vm.dataForm.TaxRate.$dirty || vm.dataForm.$submitted)}"><label><b translate="TAX_RATE"></b>% <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="TaxRate" ng-model="vm.product.taxRate" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TaxRate.$error.required">* {{"REQUIRED" | translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TaxRate.$error.min">* {{"MINIMUM_IS_0" | translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TaxRate.$error.number">* {{"ENTER_NUMBERS_ONLY" | translate}}</span></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DiscountRate.$invalid && (vm.dataForm.DiscountRate.$dirty || vm.dataForm.$submitted)}"><label><b translate="DISCOUNT_RATE"></b>% <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="DiscountRate" ng-model="vm.product.discountRate" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DiscountRate.$error.required">* {{"REQUIRED" | translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DiscountRate.$error.min">* {{"MINIMUM_IS_0" | translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DiscountRate.$error.number">* {{"ENTER_NUMBERS_ONLY" | translate}}</span></div></div><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DiscountAmount.$invalid && (vm.dataForm.DiscountAmount.$dirty || vm.dataForm.$submitted)}"><label><b translate="DISCOUNT_AMOUNT"></b> ({{vm.currencyCode}}) <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="DiscountAmount" ng-model="vm.product.discountAmount" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DiscountAmount.$error.required">* {{"REQUIRED" | translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DiscountAmount.$error.min">* {{"MINIMUM_IS_0" | translate}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DiscountAmount.$error.number">* {{"ENTER_NUMBERS_ONLY" | translate}}</span></div></div></div><div class="row"><div class="col-lg-12"></div></div><div class="row"><div class="col-lg-12"></div></div></div><div class="col-md-3 col-lg-3"><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_ACTIVE"></b>?</label><div><toggle ng-model="vm.product.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_SOLD_OUT"></b>?</label><div><toggle ng-model="vm.product.isSoldOut" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div></div><div class="col-md-12 col-lg-12"><div><p><br><br>&nbsp;</p></div></div></uib-tab><uib-tab heading="{{ \'CATEGORIES\' | translate }}"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p><i class="fa fa-info-circle"></i> <span translate="SELECT_AT_LEAST_ONE"></span> {{ \'CATEGORY\' | translate }} <i class="fa fa-asterisk req"></i></p></div></div><div class="row"><div class="col-md-4 col-lg-4" ng-repeat="c in vm.prodCategoryList" style="margin-bottom:8px;line-height:30px"><input type="checkbox" name="cate" style="float:left;cursor:pointer;width:25px;height:25px" checklist-model="vm.selectedCategories" checklist-value="c" checklist-change="vm.dataForm.cate.$setValidity(\'required\', vm.selectedCategories.length > 0)" ng-required="!vm.selectedCategories.length"> <span style="padding-left:10px">{{ c.name | uppercase }}</span></div></div><div class="row"><div class="col-md-12"><p><div class="col-md-12" ng-class="{\'has-error\': vm.dataForm.$submitted && vm.dataForm.cate.$invalid }"><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.cate.$invalid">* {{ \'REQUIRE_AT_LEAST_ONE_CATEGORY\' | translate }}</span></div></p></div></div><p><br><br>&nbsp;</p></uib-tab><uib-tab heading="Varieties" ng-if="vm.mode==2"><a href="" class="btn btn-primary btn-with-icon btn-sm" ng-click="vm.showAddVarietyModal()"><i class="ion-plus-round"></i><span translate="ADD_VARIETY"></span></a><p><br></p><table class="table table-striped" style="border:1px solid #ccc;font-size:85%"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="IMAGE"></b></th><th><b translate="SIZE"></b></th><th><b translate="FLAVOR"></b></th><th><b translate="OTHER_OPTIONS"></b></th><th><b translate="UNIT_PRICE"></b></th><th class="hide-after" style="text-align:center"><b translate="IS_ACTIVE"></b></th><th style="width:65px"></th><th style="width:65px"></th></tr></thead><tbody><tr><td colspan="9" style="text-align:center;line-height:100px" ng-if="vm.product.kioskV3ProductVariety.length==0"><span translate="LIST_IS_EMPTY"></span></td></tr><tr ng-repeat="ntn in vm.product.kioskV3ProductVariety"><td>{{ $index+1 }})</td><td><img src="{{vm.blobUrl + ntn.imageLocation || null}}" style="width:100px;height:100px;margin-bottom:10px"></td><td>{{ ntn.sizeName || \'-\' }}</td><td>{{ ntn.flavorName || \'-\' }}</td><td>{{ ntn.otherName || \'-\' }}</td><td>{{ ntn.unitPrice | number:2 }}</td><td style="text-align:center"><i class="fa fa-check" ng-show="ntn.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isActive" style="color:#f00"></i></td><td><a class="btn btn-info editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditVarietyModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeVariety(ntn.id)" ng-confirm-click="Confirm delete this Variety?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr></tbody></table><p><br></p></uib-tab><uib-tab heading="Equipments" ng-if="vm.mode==2"><a href="" class="btn btn-primary btn-with-icon btn-sm" ng-click="vm.showAddEquipmentPanel()"><i class="ion-plus-round"></i><span translate="ASSOCIATE_EQUIPMENT"></span></a><p><br></p><div class="row" ng-if="vm.addEquipmentPanelVisible"><div class="col-lg-6"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-lg-6">{{\'ASSOCIATE_EQUIPMENT\' | translate}}</div><div class="col-lg-6"><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" ng-click="vm.closeAddEquipmentPanel()"><i class="ion ion-close"></i> {{ \'CLOSE_PANEL\' | translate }}</a></div></div></div><div class="panel-body" style="padding:20px"><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>Select a Equipment:</b></label><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedEquipmentChanged()" ng-options="b as b.description for b in vm.equipmentList | orderBy:\'description\'" ng-model="vm.selectedEquipment"><option value="">-- Select an Equipment --</option></select><a href="" class="btn btn-primary btn-with-icon btn-xs pull-right" style="margin-top:3px" ng-click="vm.addEquipment()"><i class="ion-plus-round"></i> Add Equipment</a></div></div></div></div></div></div></div><div class="row"><div class="col-lg-9"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="DESCRIPTION"></b></th><th style="width:65px"></th></tr></thead><tbody><tr><td colspan="3" style="text-align:center;line-height:100px" ng-if="vm.product.kioskV3Equipment.length==0"><span translate="LIST_IS_EMPTY"></span></td></tr><tr ng-repeat="ntn in vm.product.kioskV3Equipment"><td>{{ $index+1 }})</td><td>{{ ntn.description || \'-\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeEquipment($index)" ng-confirm-click="Confirm remove this Equipment?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr></tbody></table></div></div><p><br></p></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="varietyModal.html"><form name="$mdl.varietyForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="VARIETY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-5 col-lg-5"> <div class="row"> <div class="col-md-12 col-lg-12"> <img ngf-src="picFile || $mdl.item.imageLocation" alt="" class="col-lg-12" style="border:1px solid #666" /> </div> </div> <br /> <div class="row" style="text-align:center"> <div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="$mdl.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-disabled="$mdl.lockUploadButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-upload"></i> {{ \'UPLOAD_PICTURE\' | translate }} </div> <a href ng-click="picFile=null;$mdl.setUploadImage(picFile)" ng-if="picFile" class="btn btn-default btn-with-icon" ng-disabled="$mdl.lockUploadButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }} </a> </div> </div> <div class="col-md-7 col-lg-7"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.varietyForm.ProductSize.$invalid && ($mdl.varietyForm.ProductSize.$dirty || $mdl.varietyForm.$submitted)}"> <label> <b translate="SIZE"></b> <i class="fa fa-asterisk req"></i> </label> <select name="ProductSize" class="form-control" style="background:#FFFCED" ng-change="$mdl.selectedSizeChanged()" ng-options="b as b.name for b in $mdl.sizeList | orderBy:\'name\' " ng-model="$mdl.selectedSize" required> <option value="">-- {{ \'SELECT_A_SIZE\' | translate }} --</option> </select> <span class="help-block" ng-show="$mdl.varietyForm.$submitted && $mdl.varietyForm.ProductSize.$error.required" style="color:#f00">* {{"REQUIRED" | translate}}</span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.varietyForm.ProductFlavor.$invalid && ($mdl.varietyForm.ProductFlavor.$dirty || $mdl.varietyForm.$submitted)}"> <label> <b translate="FLAVOR"></b> <i class="fa fa-asterisk req"></i> </label> <select name="ProductFlavor" class="form-control" style="background:#FFFCED" ng-change="$mdl.selectedFlavorChanged()" ng-options="b as b.name for b in $mdl.flavorList | orderBy:\'name\' " ng-model="$mdl.selectedFlavor" required> <option value="">-- {{ \'SELECT_A_FLAVOR\' | translate }} --</option> </select> <span class="help-block" ng-show="$mdl.varietyForm.$submitted && $mdl.varietyForm.ProductFlavor.$error.required" style="color:#f00">* {{"REQUIRED" | translate}}</span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label> <b translate="OTHER_OPTIONS"></b> </label> <select name="ProductOtherOption" class="form-control" style="background:#FFFCED" ng-change="$mdl.selectedOptionChanged()" ng-options="b as b.name for b in $mdl.optionList | orderBy:\'name\' " ng-model="$mdl.selectedOption"> <option value="">-- {{ \'SELECT_AN_OPTION\' | translate }} --</option> </select> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.varietyForm.UnitPrice.$invalid && ($mdl.varietyForm.UnitPrice.$dirty || $mdl.varietyForm.$submitted)}"> <label> <b translate="UNIT_PRICE"></b> <i class="fa fa-asterisk req"></i> </label> <input type="number" class="form-control" name="UnitPrice" ng-model="$mdl.item.unitPrice" style="background:#FFFCED" min="0" required /> <span class="help-block" ng-show="$mdl.varietyForm.$submitted && $mdl.varietyForm.UnitPrice.$error.required" style="color:#f00">* {{"REQUIRED" | translate}}</span> <span class="help-block" ng-show="$mdl.varietyForm.$submitted && $mdl.varietyForm.UnitPrice.$error.min" style="color:#f00">* {{"MINIMUM_IS_0" | translate}}</span> <span class="help-block" ng-show="$mdl.varietyForm.$submitted && $mdl.varietyForm.UnitPrice.$error.number" style="color:#f00">* {{"ENTER_NUMBERS_ONLY" | translate}}</span> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b translate="IS_ACTIVE"></b>?</label> <div> <toggle ng-model="$mdl.item.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> </div> </div> </div> </div> <hr /> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButton"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/robotkiosk/products/productCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/products/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.products.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/robotkiosk/products/productList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RobotKioskProductListing" st-pipe="vm.retrieveData" st-table="vm.productData" refresh-table=""><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Product" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.products.create" rms-check-access="robotkiosk.products" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Product</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:140px">Image</th><th st-sort="code">Product Code</th><th st-sort="description">Product Description</th><th>Base Price</th><th class="hide-after" style="text-align:center">Is Active?</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.productData.length<=0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.productData"><td>{{vm.startIndex+1+$index}})</td><td><img src="{{vm.blobUrl + item.imageLocation || null}}" style="width:100px;height:100px;margin-bottom:10px"></td><td>{{item.code}}</td><td>{{item.description}}</td><td>{{item.basePrice | number:2}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="robotkiosk.products.update({id:item.id})" rms-check-access="robotkiosk.products" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteData(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Kiosk?" rms-check-access="robotkiosk.products" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/robotkiosk/products/productUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/products/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.products.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.products.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/routeplan/actual/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-12 col-lg-12"><i class="fa fa-info-circle"></i> <span ng-if="vm.mode==1">{{ \'CREATE\' | translate }}</span> <span ng-if="vm.mode==2">{{ \'MANAGE\' | translate }}</span> {{ \'ROUTE_PLAN_ACTUAL\' | translate }}<p><br></p></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'PLAN_NO\' | translate }}</b></label> <span class="form-control" ng-disabled="true" style="color:#00f">{{vm.actual.planNo || \'AUTONUMBER\' | translate}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'STATUS\' | translate }}</b></label> <span class="form-control" ng-disabled="true" style="color:#00f">{{vm.actual.status | translate | uppercase }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'ROUTE_NAME\' | translate }}</b></label> <span class="form-control" ng-disabled="true" style="color:#00f">{{vm.actual.routeName }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeliveryDate.$invalid && (vm.dataForm.DeliveryDate.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SELECT_A_DELIVERY_DATE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.actual.deliveryDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="DeliveryDate" autocomplete="off" ng-disabled="vm.actual.status!=\'ACTIVE\' && vm.actual.status!=\'NEW\'" ng-model="vm.actual.deliveryDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeliveryDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DriverName.$invalid && (vm.dataForm.DriverName.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SELECT_A_DRIVER\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="DriverName" style="color:#333" ng-options="u as ((u.firstName + \' \' + u.lastName) | uppercase) for u in vm.driverList | orderBy:\'firstName\' track by u.id" ng-disabled="vm.actual.status!=\'ACTIVE\' && vm.actual.status!=\'NEW\'" ng-change="vm.selectedDriverChanged()" ng-model="vm.selectedDriver" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DriverName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><hr ng-if="vm.actual.createdBy"><div class="row"><div class="col-md-2 col-lg-2" ng-if="vm.actual.createdBy"><div class="form-group"><label><b>{{ \'CREATED_BY\' | translate }}</b></label><br><span>{{vm.actual.createdBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.actual.createdDate | date:\'dd/MM/yyyy\' }}</span></div></div><div class="col-md-2 col-lg-2" ng-if="vm.actual.modifiedBy"><div class="form-group"><label><b>{{ \'MODIFIED_BY\' | translate }}</b></label><br><span>{{vm.actual.modifiedBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.actual.modifiedDate | date:\'dd/MM/yyyy\' }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'DOCUMENT_LIST\' | translate }}" ng-if="vm.mode==2"><div class="row"><div class="col-md-12 col-lg-12"><i class="fa fa-info-circle"></i> {{ \'LIST_OF_DOCUMENT_FOR_SELECTED_ROUTE\' | translate }}&nbsp; <a href="" class="btn btn-primary btn-with-icon btn-sm" ng-click="vm.showSelectDeliveryOrderModal()" ng-if="vm.actual.status==\'NEW\'"><i class="ion-plus-round"></i> {{ \'ADD_DOCUMENT\' | translate }}</a> <a href="" class="btn btn-primary btn-with-icon btn-sm" ng-click="vm.showAddRemarkModal()" ng-if="vm.actual.status==\'NEW\' || vm.actual.status==\'CONFIRMED\'"><i class="ion-plus-round"></i> {{ \'ADD_REMARK\' | translate }}</a><br><br></div></div><div class="row"><div class="col-lg-12"><table class="table table-striped" style="border:2px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th>{{ \'CUSTOMER_CODE\' | translate }}</th><th>{{ \'CUSTOMER_NAME\' | translate }}</th><th>{{ \'CUSTOMER_BRANCH_NAME\' | translate }}</th><th>{{ \'STATUS\' | translate }}</th><th style="width:100px;line-height:150%">{{ \'DELIVERY_START_TIME\' | translate }}</th><th style="width:100px;line-height:150%">{{ \'DELIVERY_ARRIVAL_TIME\' | translate }}</th><th style="width:50px"></th><th style="width:50px"></th><th style="width:100px"></th></tr></thead><tbody ng-if="vm.isLoading"><tr><td colspan="10" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING\' | translate }}...</b></center></big></td></tr></tbody><tbody ng-if="vm.actual.routePlanDebtors.length==0"><tr><td colspan="10" style="height:100px;line-height:100px"><center>{{ \'DOCUMENT_LIST_IS_EMPTY\' | translate }}</center></td></tr></tbody><tbody ng-if="!vm.isLoading" ng-repeat="d in vm.list | orderBy:\'sequence\'"><tr ng-if="d.debtorCode"><td>{{$index+1}})</td><td>{{ d.debtorCode || \'&lt;Non Customer&gt;\' | uppercase }}</td><td>{{ d.debtorName || \'\' | uppercase }}</td><td>{{ d.debtorBranchName | uppercase }}</td><td><span class="text-success" ng-if="d.debtor_Status==\'COMPLETED\'"><b>{{ d.debtor_Status }}</b></span> <span class="text-danger" ng-if="d.debtor_Status!=\'COMPLETED\'"><b>{{ d.debtor_Status }}</b></span></td><td>{{ d.deliveryStartDateTime || \'-\' | date:\'dd/MM/yyyy hh:mma\' }}</td><td>{{ d.deliveryEndDateTime || \'-\' | date:\'dd/MM/yyyy hh:mma\' }}</td><td><a href="" class="btn btn-primary btn-xs" style="display:inline-block;width:50px" ng-if="d.sequence!=0 && (vm.actual.status==\'ACTIVE\' || vm.actual.status==\'NEW\'\')" ng-click="vm.moveListItem(\'debtor\', \'up\', d.sequence)"><i class="ion ion-chevron-up"></i></a></td><td><a href="" class="btn btn-primary btn-xs" style="display:inline-block;width:50px" ng-if="d.sequence!=(vm.list.length-1) && (vm.actual.status==\'ACTIVE\' || vm.actual.status==\'NEW\'\')" ng-click="vm.moveListItem(\'debtor\', \'down\', d.sequence)"><i class="ion ion-chevron-down"></i></a></td><td><a href="" class="btn btn-danger btn-xs" style="display:inline-block;width:100px" confirmed-click="vm.deleteListItem(\'debtor\', d.sequence)" ng-confirm-click="*WARNING* Confirm to remove this Customer?" ng-if="(vm.actual.status==\'ACTIVE\' || vm.actual.status==\'NEW\' || vm.actual.status==\'CONFIRMED\') && d.debtor_Status!=\'COMPLETED\'"><i class="fa fa-trash"></i> &nbsp;{{ \'REMOVE\' | translate }}</a></td></tr><tr ng-if="d.debtorCode"><td></td><td colspan="2" style="font-size:9pt"><div ng-if="d.routePlanDocuments.length!=0" style="border:4px solid #eee;margin-top:5px;margin-bottom:5px;border-radius:5px;"><table class="table table-striped"><thead><tr class="sortable"><th style="width:60px">#</th><th>{{ \'DELIVERY_ORDER_NO\' | translate }}</th><th>{{ \'STATUS\' | translate }}</th></tr></thead><tbody><tr ng-repeat="item in d.routePlanDocuments | orderBy:\'deliveryOrderNo\'"><td>{{$index+1}})</td><td>{{item.deliveryOrderNo}}</td><td>{{item.status}}</td></tr></tbody></table></div></td></tr><tr ng-if="!d.debtorCode"><td>{{ \'REMARKS\' | translate }}</td><td colspan="3">{{ d.remarks }}</td><td><span class="text-success" ng-if="d.status == \'COMPLETED\'"><b>{{ d.status }}</b></span> <span class="text-danger" ng-if="d.status != \'COMPLETED\'"><b>{{ d.status }}</b></span></td><td><a href="" class="btn btn-primary btn-xs" style="display:inline-block;" ng-if="d.status != \'COMPLETED\'" ng-click="vm.completeRemark(d.id)"><b>{{ \'COMPLETE\' | translate }}</b></a></td><td>&nbsp;</td><td><a href="" class="btn btn-primary btn-xs" style="display:inline-block;width:50px" ng-if="d.sequence != 0 && (vm.actual.status == \'ACTIVE\' || vm.actual.status == \'NEW\' || vm.actual.status == \'CONFIRMED\')" ng-click="vm.moveListItem(\'remark\', \'up\', d.sequence)"><i class="ion ion-chevron-up"></i></a></td><td><a href="" class="btn btn-primary btn-xs" style="display:inline-block;width:50px" ng-if="d.sequence != (vm.list.length - 1) && (vm.actual.status == \'ACTIVE\' || vm.actual.status == \'NEW\' || vm.actual.status == \'CONFIRMED\')" ng-click="vm.moveListItem(\'remark\', \'down\', d.sequence)"><i class="ion ion-chevron-down"></i></a></td><td><a href="" class="btn btn-danger btn-xs" style="display:inline-block;width:100px" confirmed-click="vm.deleteListItem(\'remark\', d.sequence)" ng-confirm-click="*WARNING* Confirm to remove this Customer?" ng-if="(vm.actual.status == \'ACTIVE\' || vm.actual.status == \'NEW\' || vm.actual.status == \'CONFIRMED\')"><i class="fa fa-trash"></i> &nbsp;{{ \'REMOVE\' | translate }}</a></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="deliveryOrderListModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Select any Delivery Order</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:90%;color:#000" st-pipe="$mdl.retrieveData" st-table="$mdl.doData" refresh-table> <thead> <tr> <th colspan="4"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Delivery Order" class="input form-control" style="background:#fffeed" /> </div> </th> <th colspan="6" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th style="width:50px"></th> <th st-sort="deliveryOrderNo" style="width:130px">{{ \'DO_NO\' | translate }}</th> <th style="width:100px;padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'ORDER_DATE\' | translate }}<br /><small>(DD/MM/YYYY)</small></th> <th style="width:100px;padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'DELIVERY_DATE\' | translate }}<br /><small>(DD/MM/YYYY)</small></th> <th>{{ \'CUSTOMER_NAME\' | translate }}</th> <th>{{ \'BRANCH_/_SITE\' | translate }}Customer Branch Name</th> <th>{{ \'CUSTOMER_PO_NUMBER\' | translate }}</th> <th st-sort="shippingMethod">{{ \'SHIPPING_METHOD\' | translate }}</th> <th st-sort="createdBy">{{ \'ORDERED_BY\' | translate }}</th> <th st-sort="status">{{ \'STATUS\' | translate }}</th> </tr> <tr> <td colspan="4"></td> <td> <select st-search="debtorName"> <option value="">{{ \'ALL\' | translate }}</option> <option ng-repeat="item in vm.actualDataFull | unique:\'debtorName\' | orderBy:\'debtorName\'" value="{{item.debtorName}}"> {{ item.debtorName }} </option> </select> </td> <td colspan="2"></td> <td> <select st-search="shippingMethod"> <option value="">{{ \'ALL\' | translate }}</option> <option ng-repeat="item in vm.actualDataFull | unique:\'shippingMethod\' | orderBy:\'shippingMethod\'" value="{{item.shippingMethod}}"> {{ item.shippingMethod }} </option> </select> </td> <td></td> <th class="form-inline"> <select st-search="status"> <option value="">{{ \'ALL\' | translate }}</option> <option ng-repeat="item in vm.actualDataFull | unique:\'status\' | orderBy:\'status\'" value="{{item.status}}"> {{ item.status }} </option> </select> </th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="10" style="line-height:100px"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading ...</b></center> </td> </tr> <tr ng-if="!$mdl.isLoading && $mdl.doData.length==0"> <td colspan="10" style="line-height:100px"> <center><b> No delivery order is available.</b></center> </td> </tr> <tr ng-repeat="item in $mdl.doData"> <td style="padding-top:2px;text-align:center"> <div class="checkbox checkbox-primary checkbox-inline"> <input type="checkbox" style="cursor:pointer;padding-left:0px" checklist-model="$mdl.selectOrderIds" checklist-value="item.id" /> <label></label> </div> </td> <td style="padding-top:11px;padding-bottom:11px;line-height:130%">{{item.deliveryOrderNo}}</td> <td style="padding-top:11px;padding-bottom:11px;line-height:130%">{{item.createdDate | date: "dd/MM/yyyy"}}</td> <td style="padding-top:11px;padding-bottom:11px;line-height:130%">{{item.deliveryDate | date: "dd/MM/yyyy"}}</td> <td style="padding-top:11px;padding-bottom:11px;line-height:130%">{{item.debtorName || \'-\'}}</td> <td style="padding-top:11px;padding-bottom:11px;line-height:130%">{{item.debtorBranchName || \'-\'}}</td> <td>{{item.customerPoNo || \'-\'}}</td> <td>{{item.shippingMethod || \'-\'}}</td> <td> {{(item.createdBy | uppercase | limitTo:20) + (item.createdBy.length > 20 ? \'...\' : \'\') }} </td> <td>{{item.status || \'-\' | uppercase | translate | uppercase}}</td> </tr> </tbody> <tfoot> <tr> <td colspan="10" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"> <span translate="TOTAL_RECORDS:"></span> <b>{{ $mdl.numOfRecordDisplayed }}</b> </div> <div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </td> </tr> </tfoot> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-success btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.confirmModal()"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CLOSE\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="addRemarkModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Add Remark</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.dataForm.Remarks.$invalid && $mdl.dataForm.$submitted}"> <label><span translate="REMARKS"></span></label> <input type="text" name="Remarks" class="form-control" ng-model="$mdl.remark" required /> </div> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.confirmModal()"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CLOSE\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/routeplan/actual/rpactualCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/routeplan/actual/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="routeplan.actual.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/routeplan/actual/rpactualList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RoutePlanActualListing" st-pipe="vm.retrieveData" st-table="vm.actualData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="routeplan.actual.create" rms-check-access="routeplan.actual" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="planNo">{{ \'PLAN_NO\' | translate }}</th><th st-sort="routeName">{{ \'ROUTE_NAME\' | translate }}</th><th st-sort="deliveryDate">{{ \'DELIVERY_DATE\' | translate }}</th><th st-sort="driverName">{{ \'DRIVER_NAME\' | translate }}</th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th>{{ \'CREATED_BY\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th colspan="2"></th><th class="form-inline"><select st-search="routeName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="item in vm.actualDataFull | unique:\'routeName\' | orderBy:\'routeName\'" value="{{item.routeName | uppercase}}">{{(item.routeName | uppercase | limitTo:25) + (item.routeName.length > 25 ? \' ...\' : \'\') }}</option></select></th><th class="form-inline"></th><th class="form-inline"><select st-search="driverName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="item in vm.actualDataFull | unique:\'driverName\' | orderBy:\'driverName\'" value="{{item.driverName | uppercase}}">{{(item.driverName | uppercase | limitTo:15) + (item.driverName.length > 15 ? \' ...\' : \'\') }}</option></select></th><th class="form-inline"><select st-search="status"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="item in vm.actualDataFull | unique:\'status\' | orderBy:\'status\'" value="{{item.status | uppercase}}">{{item.status | translate}}</option></select></th><th class="form-inline"><select st-search="createdBy"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="item in vm.actualDataFull | unique:\'createdBy\' | orderBy:\'createdBy\'" value="{{item.createdBy}}">{{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \' ...\' : \'\') }}</option></select></th><th colspan="3"></th></tr></thead><tbody><tr ng-if="vm.actualData.length==0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.actualData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.planNo}}</td><td>{{item.routeName}}</td><td>{{item.deliveryDate | date:\'dd/MM/yyyy\'}}</td><td>{{(item.driverName || \'-\' | uppercase | limitTo:15) + (item.driverName.length > 15 ? \' ...\' : \'\') }}</td><td>{{item.status | translate | uppercase}}</td><td>{{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \' ...\' : \'\') }}</td><td align="center"><a href="" title="Print" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#00f" ng-if="item.status!=\'CANCELLED\'" ng-click="vm.print(item.id, item.planNo)" rms-check-access="routeplan.preview" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="routeplan.actual.update({id:item.id})" rms-check-access="routeplan.actual" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteRecord(item.id, item.planNo)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Record?" ng-if="item.status==\'ACTIVE\'" rms-check-access="routeplan.actual" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/routeplan/actual/rpactualUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/routeplan/actual/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="routeplan.actual.list" style="margin-right:60px" ng-disabled="vm.isLoading"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:60px" ng-if="vm.actual.status==\'NEW\' || vm.actual.status==\'CONFIRMED\'" ng-disabled="vm.isLoading"><i class="ion ion-checkmark"></i> {{ \'SAVE_CHANGES\' | translate }}</button> <button type="button" class="btn btn-success btn-with-icon" confirmed-click="vm.confirmRP()" ng-confirm-click="Do you want to confirm the Route Plan?" ng-disabled="vm.isLoading" ng-if="vm.actual.status==\'NEW\' && !vm.isLoading"><i class="fa fa-check-circle"></i> {{ \'CONFIRM_ROUTE_PLAN\' | translate }}</button> <button type="button" class="btn btn-success btn-with-icon" confirmed-click="vm.completeRP()" ng-confirm-click="Do you want to complete the Route Plan?" ng-disabled="vm.isLoading" ng-if="vm.actual.status==\'CONFIRMED\' && !vm.isLoading"><i class="fa fa-check-circle"></i> {{ \'COMPLETE_ROUTE_PLAN\' | translate }}</button> <button type="button" class="btn btn-danger btn-with-icon" confirmed-click="vm.cancelRP()" ng-confirm-click="Do you want to cancel this Route Plan?" ng-disabled="vm.isLoading" ng-if="(vm.actual.status==\'NEW\' || vm.actual.status==\'CONFIRMED\') && !vm.isLoading"><i class="fa fa-trash"></i> {{ \'CANCEL_ROUTE_PLAN\' | translate }}</button> <a href="" class="btn btn-primary btn-with-icon" style="margin-left:60px" ng-disabled="vm.isLoading" ng-if="vm.actual.status!=\'CANCELLED\' && !vm.isLoading" ng-click="vm.print()" rms-check-access="routeplan.actual" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> {{ \'PRINT_PDF\' | translate }}</a></div></form>');
$templateCache.put('app/pages/routeplan/actual_mercado/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-12 col-lg-12"><i class="fa fa-info-circle"></i> <span ng-if="vm.mode==1">{{ \'CREATE\' | translate }}</span> <span ng-if="vm.mode==2">{{ \'MANAGE\' | translate }}</span> {{ \'ROUTE_PLAN_ACTUAL\' | translate }}<p><br></p></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'PLAN_NO\' | translate }}</b></label> <span class="form-control" ng-disabled="true" style="color:#00f">{{vm.actual.planNo || \'AUTONUMBER\' | translate}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'STATUS\' | translate }}</b></label> <span class="form-control" ng-disabled="true" style="color:#00f">{{vm.actual.status | translate | uppercase }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'ROUTE_NAME\' | translate }}</b></label> <span class="form-control" ng-disabled="true" style="color:#00f">{{vm.actual.routeName }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeliveryDate.$invalid && (vm.dataForm.DeliveryDate.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SELECT_A_DELIVERY_DATE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.actual.deliveryDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="DeliveryDate" autocomplete="off" ng-disabled="vm.actual.status!=\'ACTIVE\' && vm.actual.status!=\'NEW\' && vm.actual.status!=\'CONFIRMED\'" ng-model="vm.actual.deliveryDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeliveryDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DriverName.$invalid && (vm.dataForm.DriverName.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SELECT_A_DRIVER\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="DriverName" style="color:#333" ng-options="u as ((u.firstName + \' \' + u.lastName) | uppercase) for u in vm.driverList | orderBy:\'firstName\' track by u.id" ng-disabled="vm.actual.status!=\'ACTIVE\' && vm.actual.status!=\'NEW\' && vm.actual.status!=\'CONFIRMED\'" ng-change="vm.selectedDriverChanged()" ng-model="vm.selectedDriver" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DriverName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><hr ng-if="vm.actual.createdBy"><div class="row"><div class="col-md-2 col-lg-2" ng-if="vm.actual.createdBy"><div class="form-group"><label><b>{{ \'CREATED_BY\' | translate }}</b></label><br><span>{{vm.actual.createdBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.actual.createdDate | date:\'dd/MM/yyyy\' }}</span></div></div><div class="col-md-2 col-lg-2" ng-if="vm.actual.modifiedBy"><div class="form-group"><label><b>{{ \'MODIFIED_BY\' | translate }}</b></label><br><span>{{vm.actual.modifiedBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.actual.modifiedDate | date:\'dd/MM/yyyy\' }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'DOCUMENT_LIST\' | translate }}" ng-if="vm.mode==2"><div class="row"><div class="col-md-12 col-lg-12"><i class="fa fa-info-circle"></i> {{ \'LIST_OF_DOCUMENT_FOR_SELECTED_ROUTE\' | translate }}&nbsp; <a href="" class="btn btn-primary btn-with-icon btn-sm" ng-click="vm.showSelectDeliveryOrderModal()" ng-if="vm.actual.status==\'NEW\' || vm.actual.status==\'CONFIRMED\'"><i class="ion-plus-round"></i> {{ \'ADD_DOCUMENT\' | translate }}</a> <a href="" class="btn btn-primary btn-with-icon btn-sm" ng-click="vm.showAddRemarkModal()" ng-if="vm.actual.status==\'NEW\' || vm.actual.status==\'CONFIRMED\'"><i class="ion-plus-round"></i> {{ \'ADD_REMARK\' | translate }}</a><br><br></div></div><div class="row"><div class="col-lg-12"><table class="table table-striped" style="border:2px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th>{{ \'CUSTOMER_CODE\' | translate }}</th><th>{{ \'CUSTOMER_NAME\' | translate }}</th><th>{{ \'CUSTOMER_BRANCH_NAME\' | translate }}</th><th>{{ \'STATUS\' | translate }}</th><th style="width:100px;line-height:150%">{{ \'DELIVERY_START_TIME\' | translate }}</th><th style="width:100px;line-height:150%">{{ \'DELIVERY_ARRIVAL_TIME\' | translate }}</th><th style="width:50px"></th><th style="width:50px"></th><th style="width:100px"></th></tr></thead><tbody ng-if="vm.isLoading"><tr><td colspan="10" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING\' | translate }}...</b></center></big></td></tr></tbody><tbody ng-if="vm.actual.routePlanDebtors.length==0"><tr><td colspan="10" style="height:100px;line-height:100px"><center>{{ \'DOCUMENT_LIST_IS_EMPTY\' | translate }}</center></td></tr></tbody><tbody ng-if="!vm.isLoading" ng-repeat="d in vm.list | orderBy:\'sequence\'"><tr ng-if="d.debtorCode"><td>{{$index+1}})</td><td>{{ d.debtorCode || \'&lt;Non Customer&gt;\' | uppercase }}</td><td>{{ d.debtorName || \'\' | uppercase }}</td><td>{{ d.debtorBranchName | uppercase }}</td><td><span class="text-success" ng-if="d.debtor_Status==\'COMPLETED\'"><b>{{ d.debtor_Status }}</b></span> <span class="text-danger" ng-if="d.debtor_Status!=\'COMPLETED\'"><b>{{ d.debtor_Status }}</b></span></td><td>{{ d.deliveryStartDateTime || \'-\' | date:\'dd/MM/yyyy hh:mma\' }}</td><td>{{ d.deliveryEndDateTime || \'-\' | date:\'dd/MM/yyyy hh:mma\' }}</td><td><a href="" class="btn btn-primary btn-xs" style="display:inline-block;width:50px" ng-if="d.sequence!=0 && (vm.actual.status==\'ACTIVE\' || vm.actual.status==\'NEW\' || vm.actual.status==\'CONFIRMED\')" ng-click="vm.moveListItem(\'debtor\', \'up\', d.sequence)"><i class="ion ion-chevron-up"></i></a></td><td><a href="" class="btn btn-primary btn-xs" style="display:inline-block;width:50px" ng-if="d.sequence!=(vm.list.length-1) && (vm.actual.status==\'ACTIVE\' || vm.actual.status==\'NEW\' || vm.actual.status==\'CONFIRMED\')" ng-click="vm.moveListItem(\'debtor\', \'down\', d.sequence)"><i class="ion ion-chevron-down"></i></a></td><td><a href="" class="btn btn-danger btn-xs" style="display:inline-block;width:100px" confirmed-click="vm.deleteListItem(\'debtor\', d.sequence)" ng-confirm-click="*WARNING* Confirm to remove this Customer?" ng-if="(vm.actual.status==\'ACTIVE\' || vm.actual.status==\'NEW\' || vm.actual.status==\'CONFIRMED\') && d.debtor_Status!=\'COMPLETED\'"><i class="fa fa-trash"></i> &nbsp;{{ \'REMOVE\' | translate }}</a></td></tr><tr ng-if="d.debtorCode"><td></td><td colspan="2" style="font-size:9pt"><div ng-if="d.routePlanDocuments.length!=0" style="border:4px solid #eee;margin-top:5px;margin-bottom:5px;border-radius:5px;"><table class="table table-striped"><thead><tr class="sortable"><th style="width:60px">#</th><th>{{ \'DELIVERY_ORDER_NO\' | translate }}</th><th>{{ \'STATUS\' | translate }}</th></tr></thead><tbody><tr ng-repeat="item in d.routePlanDocuments | orderBy:\'deliveryOrderNo\'"><td>{{$index+1}})</td><td>{{item.deliveryOrderNo}}</td><td>{{item.status}}</td></tr></tbody></table></div></td></tr><tr ng-if="!d.debtorCode"><td>{{ \'REMARKS\' | translate }}</td><td colspan="3">{{ d.remarks }}</td><td><span class="text-success" ng-if="d.status == \'COMPLETED\'"><b>{{ d.status }}</b></span> <span class="text-danger" ng-if="d.status != \'COMPLETED\'"><b>{{ d.status }}</b></span></td><td><a href="" class="btn btn-primary btn-xs" style="display:inline-block;" ng-if="d.status != \'COMPLETED\'" ng-click="vm.completeRemark(d.id)"><b>{{ \'COMPLETE\' | translate }}</b></a></td><td>&nbsp;</td><td><a href="" class="btn btn-primary btn-xs" style="display:inline-block;width:50px" ng-if="d.sequence != 0 && (vm.actual.status == \'ACTIVE\' || vm.actual.status == \'NEW\' || vm.actual.status == \'CONFIRMED\')" ng-click="vm.moveListItem(\'remark\', \'up\', d.sequence)"><i class="ion ion-chevron-up"></i></a></td><td><a href="" class="btn btn-primary btn-xs" style="display:inline-block;width:50px" ng-if="d.sequence != (vm.list.length - 1) && (vm.actual.status == \'ACTIVE\' || vm.actual.status == \'NEW\' || vm.actual.status == \'CONFIRMED\')" ng-click="vm.moveListItem(\'remark\', \'down\', d.sequence)"><i class="ion ion-chevron-down"></i></a></td><td><a href="" class="btn btn-danger btn-xs" style="display:inline-block;width:100px" confirmed-click="vm.deleteListItem(\'remark\', d.sequence)" ng-confirm-click="*WARNING* Confirm to remove this Customer?" ng-if="(vm.actual.status == \'ACTIVE\' || vm.actual.status == \'NEW\' || vm.actual.status == \'CONFIRMED\')"><i class="fa fa-trash"></i> &nbsp;{{ \'REMOVE\' | translate }}</a></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="deliveryOrderListModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Select any Delivery Order</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:90%;color:#000" st-pipe="$mdl.retrieveData" st-table="$mdl.doData" refresh-table> <thead> <tr> <th colspan="4"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Delivery Order" class="input form-control" style="background:#fffeed" /> </div> </th> <th colspan="6" style="padding-left:0px;padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th style="width:50px"></th> <th st-sort="deliveryOrderNo" style="width:130px">{{ \'DO_NO\' | translate }}</th> <th style="width:100px;padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'ORDER_DATE\' | translate }}<br /><small>(DD/MM/YYYY)</small></th> <th style="width:100px;padding-top:11px;padding-bottom:11px;line-height:110%">{{ \'DELIVERY_DATE\' | translate }}<br /><small>(DD/MM/YYYY)</small></th> <th>{{ \'CUSTOMER_NAME\' | translate }}</th> <th>{{ \'BRANCH_/_SITE\' | translate }}Customer Branch Name</th> <th>{{ \'CUSTOMER_PO_NUMBER\' | translate }}</th> <th st-sort="shippingMethod">{{ \'SHIPPING_METHOD\' | translate }}</th> <th st-sort="createdBy">{{ \'ORDERED_BY\' | translate }}</th> <th st-sort="status">{{ \'STATUS\' | translate }}</th> </tr> <tr> <td colspan="4"></td> <td> <select st-search="debtorName"> <option value="">{{ \'ALL\' | translate }}</option> <option ng-repeat="item in vm.actualDataFull | unique:\'debtorName\' | orderBy:\'debtorName\'" value="{{item.debtorName}}"> {{ item.debtorName }} </option> </select> </td> <td colspan="2"></td> <td> <select st-search="shippingMethod"> <option value="">{{ \'ALL\' | translate }}</option> <option ng-repeat="item in vm.actualDataFull | unique:\'shippingMethod\' | orderBy:\'shippingMethod\'" value="{{item.shippingMethod}}"> {{ item.shippingMethod }} </option> </select> </td> <td></td> <th class="form-inline"> <select st-search="status"> <option value="">{{ \'ALL\' | translate }}</option> <option ng-repeat="item in vm.actualDataFull | unique:\'status\' | orderBy:\'status\'" value="{{item.status}}"> {{ item.status }} </option> </select> </th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="10" style="line-height:100px"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading ...</b></center> </td> </tr> <tr ng-if="!$mdl.isLoading && $mdl.doData.length==0"> <td colspan="10" style="line-height:100px"> <center><b> No delivery order is available.</b></center> </td> </tr> <tr ng-repeat="item in $mdl.doData"> <td style="padding-top:2px;text-align:center"> <div class="checkbox checkbox-primary checkbox-inline"> <input type="checkbox" style="cursor:pointer;padding-left:0px" checklist-model="$mdl.selectOrderIds" checklist-value="item.id" /> <label></label> </div> </td> <td style="padding-top:11px;padding-bottom:11px;line-height:130%">{{item.deliveryOrderNo}}</td> <td style="padding-top:11px;padding-bottom:11px;line-height:130%">{{item.createdDate | date: "dd/MM/yyyy"}}</td> <td style="padding-top:11px;padding-bottom:11px;line-height:130%">{{item.deliveryDate | date: "dd/MM/yyyy"}}</td> <td style="padding-top:11px;padding-bottom:11px;line-height:130%">{{item.debtorName || \'-\'}}</td> <td style="padding-top:11px;padding-bottom:11px;line-height:130%">{{item.debtorBranchName || \'-\'}}</td> <td>{{item.customerPoNo || \'-\'}}</td> <td>{{item.shippingMethod || \'-\'}}</td> <td> {{(item.createdBy | uppercase | limitTo:20) + (item.createdBy.length > 20 ? \'...\' : \'\') }} </td> <td>{{item.status || \'-\' | uppercase | translate | uppercase}}</td> </tr> </tbody> <tfoot> <tr> <td colspan="10" style="padding-left:0px;padding-right:0px"> <div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"> <span translate="TOTAL_RECORDS:"></span> <b>{{ $mdl.numOfRecordDisplayed }}</b> </div> <div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </td> </tr> </tfoot> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-success btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.confirmModal()"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CLOSE\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="addRemarkModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">Add Remark</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.dataForm.Remarks.$invalid && $mdl.dataForm.$submitted}"> <label><span translate="REMARKS"></span></label> <input type="text" name="Remarks" class="form-control" ng-model="$mdl.remark" required /> </div> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.confirmModal()"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CLOSE\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/routeplan/actual_mercado/rpactualCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/routeplan/actual_mercado/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="routeplan.actual_mercado.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/routeplan/actual_mercado/rpactualList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RoutePlanActualListing" st-pipe="vm.retrieveData" st-table="vm.actualData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="routeplan.actual_mercado.create" rms-check-access="routeplan.actual_mercado" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="planNo">{{ \'PLAN_NO\' | translate }}</th><th st-sort="routeName">{{ \'ROUTE_NAME\' | translate }}</th><th st-sort="deliveryDate">{{ \'DELIVERY_DATE\' | translate }}</th><th st-sort="driverName">{{ \'DRIVER_NAME\' | translate }}</th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th>{{ \'CREATED_BY\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th colspan="2"></th><th class="form-inline"><select st-search="routeName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="item in vm.actualDataFull | unique:\'routeName\' | orderBy:\'routeName\'" value="{{item.routeName | uppercase}}">{{(item.routeName | uppercase | limitTo:25) + (item.routeName.length > 25 ? \' ...\' : \'\') }}</option></select></th><th class="form-inline"></th><th class="form-inline"><select st-search="driverName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="item in vm.actualDataFull | unique:\'driverName\' | orderBy:\'driverName\'" value="{{item.driverName | uppercase}}">{{(item.driverName | uppercase | limitTo:15) + (item.driverName.length > 15 ? \' ...\' : \'\') }}</option></select></th><th class="form-inline"><select st-search="status"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="item in vm.actualDataFull | unique:\'status\' | orderBy:\'status\'" value="{{item.status | uppercase}}">{{item.status | translate}}</option></select></th><th class="form-inline"><select st-search="createdBy"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="item in vm.actualDataFull | unique:\'createdBy\' | orderBy:\'createdBy\'" value="{{item.createdBy}}">{{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \' ...\' : \'\') }}</option></select></th><th colspan="3"></th></tr></thead><tbody><tr ng-if="vm.actualData.length==0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.actualData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.planNo}}</td><td>{{item.routeName}}</td><td>{{item.deliveryDate | date:\'dd/MM/yyyy\'}}</td><td>{{(item.driverName || \'-\' | uppercase | limitTo:15) + (item.driverName.length > 15 ? \' ...\' : \'\') }}</td><td>{{item.status | translate | uppercase}}</td><td>{{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \' ...\' : \'\') }}</td><td align="center"><a href="" title="Print" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#00f" ng-if="item.status!=\'CANCELLED\'" ng-click="vm.print(item.id, item.planNo)" rms-check-access="routeplan.preview" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="routeplan.actual_mercado.update({id:item.id})" rms-check-access="routeplan.actual_mercado" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteRecord(item.id, item.planNo)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Record?" ng-if="item.status==\'ACTIVE\'" rms-check-access="routeplan.actual_mercado" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/routeplan/actual_mercado/rpactualUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/routeplan/actual_mercado/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="routeplan.actual_mercado.list" style="margin-right:60px" ng-disabled="vm.isLoading"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:60px" ng-if="vm.actual.status==\'NEW\' || vm.actual.status==\'CONFIRMED\'" ng-disabled="vm.isLoading"><i class="ion ion-checkmark"></i> {{ \'SAVE_CHANGES\' | translate }}</button> <button type="button" class="btn btn-success btn-with-icon" confirmed-click="vm.confirmRP()" ng-confirm-click="Do you want to confirm the Route Plan?" ng-disabled="vm.isLoading" ng-if="vm.actual.status==\'NEW\' && !vm.isLoading"><i class="fa fa-check-circle"></i> {{ \'CONFIRM_ROUTE_PLAN\' | translate }}</button> <button type="button" class="btn btn-success btn-with-icon" confirmed-click="vm.completeRP()" ng-confirm-click="Do you want to complete the Route Plan?" ng-disabled="vm.isLoading" ng-if="vm.actual.status==\'CONFIRMED\' && !vm.isLoading"><i class="fa fa-check-circle"></i> {{ \'COMPLETE_ROUTE_PLAN\' | translate }}</button> <button type="button" class="btn btn-danger btn-with-icon" confirmed-click="vm.cancelRP()" ng-confirm-click="Do you want to cancel this Route Plan?" ng-disabled="vm.isLoading" ng-if="(vm.actual.status==\'NEW\' || vm.actual.status==\'CONFIRMED\') && !vm.isLoading"><i class="fa fa-trash"></i> {{ \'CANCEL_ROUTE_PLAN\' | translate }}</button> <a href="" class="btn btn-primary btn-with-icon" style="margin-left:60px" ng-disabled="vm.isLoading" ng-if="vm.actual.status!=\'CANCELLED\' && !vm.isLoading" ng-click="vm.print()" rms-check-access="routeplan.actual_mercado" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> {{ \'PRINT_PDF\' | translate }}</a></div></form>');
$templateCache.put('app/pages/routeplan/preview/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-12 col-lg-12"><i class="fa fa-info-circle"></i> <span ng-if="vm.mode==1">{{ \'CREATE\' | translate }}</span> <span ng-if="vm.mode==2">{{ \'MANAGE\' | translate }}</span> {{ \'ROUTE_PLAN_PREVIEW\' | translate }}<p><br></p></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'PLAN_NO\' | translate }}</b></label> <span class="form-control" ng-disabled="true" style="color:#00f">{{vm.preview.planNo || \'AUTONUMBER\' }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'STATUS\' | translate }}</b></label> <span class="form-control" ng-disabled="true" style="color:#00f">{{vm.preview.status | translate}}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.RouteName.$invalid && (vm.dataForm.RouteName.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SELECT_A_ROUTE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="RouteName" style="color:#333" ng-disabled="vm.preview.status!=\'ACTIVE\'" ng-options="r as r.routeName for r in vm.routeList" ng-change="vm.selectedRouteChanged()" ng-model="vm.selectedRoute" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RouteName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeliveryDate.$invalid && (vm.dataForm.DeliveryDate.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SELECT_A_DELIVERY_DATE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.preview.deliveryDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="DeliveryDate" autocomplete="off" ng-disabled="vm.preview.status!=\'ACTIVE\'" ng-model="vm.preview.deliveryDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeliveryDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><hr ng-if="vm.preview.createdBy"><div class="row"><div class="col-md-2 col-lg-2" ng-if="vm.preview.createdBy"><div class="form-group"><label><b>{{ \'CREATED_BY\' | translate }}</b></label><br><span>{{vm.preview.createdBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.preview.createdDate | date:\'dd/MM/yyyy\' }}</span></div></div><div class="col-md-2 col-lg-2" ng-if="vm.preview.modifiedBy"><div class="form-group"><label><b>{{ \'MODIFIED_BY\' | translate }}</b></label><br><span>{{vm.preview.modifiedBy | uppercase}}<br><span translate="DATE:"></span> {{ vm.preview.modifiedDate | date:\'dd/MM/yyyy\' }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'DOCUMENT_LIST\' | translate }}" ng-if="vm.mode==2"><div class="row"><div class="col-md-12 col-lg-12"><i class="fa fa-info-circle"></i> {{ \'LIST_OF_DOCUMENT_FOR_SELECTED_ROUTE\' | translate}}<p><br></p></div></div><div class="row"><div class="col-lg-12"><div class="row" style="margin-bottom:5px"><div class="col-lg-12">Sales Order Status:<select ng-model="vm.soStatusFilter"><option value="">{{ \'ALL\' | translate }}</option><option value="NEW">{{ \'NEW\' | translate }}</option><option value="CONFIRMED">{{ \'CONFIRMED\' | translate }}</option><option value="IN PROCESS">{{ \'IN_PROCESS\' | translate }}</option><option value="COMPLETED">{{ \'COMPLETED\' | translate }}</option></select></div></div><table class="table table-striped" style="border:2px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th>{{ \'CUSTOMER_CODE\' | translate }}</th><th>{{ \'CUSTOMER_NAME\' | translate }}</th><th>{{ \'CUSTOMER_BRANCH_NAME\' | translate }}</th></tr></thead><tbody ng-if="vm.isLoading"><tr><td colspan="4" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING\' | translate }}...</b></center></big></td></tr></tbody><tbody ng-if="!vm.isLoading && vm.preview.routePlanPreviewDebtors.length==0"><tr><td colspan="4" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr></tbody><tbody ng-if="!vm.isLoading" ng-repeat="d in vm.preview.routePlanPreviewDebtors"><tr><td>{{ $index+1 }})</td><td>{{ d.debtorCode }}</td><td>{{ d.debtorName }}</td><td>{{ d.debtorBranchName }}</td></tr><tr><td></td><td colspan="3" style="font-size:9pt"><div style="border:1px solid #ccc;padding-left:15px;padding-right:15px;margin-bottom:5px"><div class="row" style="border-bottom:1px solid #ccc"><div class="col-sm-2 col-md-2 col-lg-2"><b>{{ \'SALES_ORDER_NO\' | translate }}</b></div><div class="col-sm-2 col-md-2 col-lg-2"><b>{{ \'CUSTOMER_PO_NO\' | translate }}</b></div><div class="col-sm-2 col-md-2 col-lg-2"><b>{{ \'CUSTOMER_PO_NO\' | translate }}</b></div><div class="col-sm-2 col-md-2 col-lg-2"><b>{{ \'DOCUMENT_DATE\' | translate }}</b></div><div class="col-sm-2 col-md-2 col-lg-2"><b>{{ \'DELIVERY_DATE\' | translate }}</b></div></div><div class="row" ng-repeat="item in d.routePlanPreviewDocuments | filter:{salesOrderStatus:vm.soStatusFilter} | orderBy:\'salesOrderNo\'"><div class="col-sm-2 col-md-2 col-lg-2">{{item.salesOrderNo}}</div><div class="col-sm-2 col-md-2 col-lg-2">{{item.salesOrderStatus}}</div><div class="col-sm-2 col-md-2 col-lg-2">{{item.customerPoNo}}</div><div class="col-sm-2 col-md-2 col-lg-2">{{item.createdDate | date:\'dd/MM/yyyy\'}}</div><div class="col-sm-2 col-md-2 col-lg-2">{{item.deliveryDate_doc | date:\'dd/MM/yyyy\'}}</div></div></div></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/routeplan/preview/rppreviewCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/routeplan/preview/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="routeplan.preview.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/routeplan/preview/rppreviewList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RoutePlanPreviewListing" st-pipe="vm.retrieveData" st-table="vm.previewData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="routeplan.preview.create" rms-check-access="routeplan.preview" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="planNo">{{ \'PLAN_NO\' | translate }}</th><th st-sort="routeName">{{ \'ROUTE_NAME\' | translate }}</th><th st-sort="deliveryDate">{{ \'DELIVERY_DATE\' | translate }}</th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th>{{ \'CREATED_BY\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th colspan="2"></th><th class="form-inline"><select st-search="routeName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="item in vm.previewDataFull | unique:\'routeName\' | orderBy:\'routeName\'" value="{{item.routeName | uppercase}}">{{(item.routeName | uppercase | limitTo:25) + (item.routeName.length > 25 ? \' ...\' : \'\') }}</option></select></th><th class="form-inline"></th><th class="form-inline"><select st-search="status"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="item in vm.previewDataFull | unique:\'status\' | orderBy:\'status\'" value="{{item.status | uppercase}}">{{item.status | translate }}</option></select></th><th class="form-inline"><select st-search="createdBy"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="item in vm.previewDataFull | unique:\'createdBy\' | orderBy:\'createdBy\'" value="{{item.createdBy}}">{{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \' ...\' : \'\') }}</option></select></th><th colspan="3"></th></tr></thead><tbody><tr ng-if="vm.previewData.length==0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.previewData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.planNo}}</td><td>{{item.routeName}}</td><td>{{item.deliveryDate | date:\'dd/MM/yyyy\'}}</td><td>{{item.status | translate}}</td><td>{{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \' ...\' : \'\') }}</td><td align="center"><a href="" title="Print" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#00f" ng-if="item.status!=\'CANCELLED\'" ng-click="vm.print(item.id, item.planNo)" rms-check-access="routeplan.preview" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="routeplan.preview.update({id:item.id})" rms-check-access="routeplan.preview" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteRecord(item.id, item.planNo)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Record?" ng-if="item.status==\'ACTIVE\'" rms-check-access="routeplan.preview" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/routeplan/preview/rppreviewUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/routeplan/preview/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="routeplan.preview.list" style="margin-right:30px" ng-disabled="vm.isLoading"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:60px" ng-if="vm.preview.status==\'ACTIVE\'" ng-disabled="vm.isLoading"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <button type="button" class="btn btn-success btn-with-icon" confirmed-click="vm.convertRP()" ng-confirm-click="Do you want to convert to Actual Route Plan?" ng-disabled="vm.isLoading" ng-if="vm.preview.status==\'ACTIVE\' && !vm.isLoading" rms-check-access="routeplan.preview" rms-check-access-perm-type="APPROVE"><i class="fa fa-check-circle"></i> {{ \'CONVERT_ROUTE_PLAN\' | translate }}</button> <button type="button" class="btn btn-danger btn-with-icon" style="margin-right:60px" confirmed-click="vm.cancelRP()" ng-confirm-click="Do you want to cancel this Route Plan?" ng-disabled="vm.isLoading" ng-if="vm.preview.status==\'ACTIVE\' && !vm.isLoading" rms-check-access="routeplan.preview" rms-check-access-perm-type="APPROVE"><i class="fa fa-trash"></i> {{ \'CANCEL_ROUTE_PLAN\' | translate }}</button> <a href="" class="btn btn-primary btn-with-icon" ng-disabled="vm.isLoading" ng-if="vm.actual.status!=\'CANCELLED\' && !vm.isLoading" ng-click="vm.print()" rms-check-access="routeplan.preview" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> {{ \'PRINT_PDF\' | translate }}</a></div></form>');
$templateCache.put('app/pages/services/casemanagement/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="GENERAL_OVERVIEW_OF_THE_CASE_DETAILS."></span></small><br><br></p><div class="row"><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="CASE_NO"></span>.</b></label> <span class="form-control" style="color:#00f"><b>{{vm.case.caseNo}}</b></span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="CASE_CREATED_DATE"></b></label> <span class="form-control">{{vm.case.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="CASE_STATUS"></b></label> <span class="form-control"><b>{{vm.case.status}}</b></span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="CS_OFFICER"></b></label><div class="input-group"><span class="form-control">{{vm.case.customerServiceUser}}</span> <a href="" class="btn btn-primary input-group-addon" style="padding:3px 10px;font-size:9pt" ng-if="vm.case.customerServiceUserId==null && vm.case.status==\'NEW\'" ng-click="vm.showCsoModal()"><i class="fa fa-user-plus"></i> <span translate="ASSIGN"></span></a> <a href="" class="btn btn-default input-group-addon" style="padding:3px 10px;font-size:9pt;color:#f00" ng-if="vm.case.customerServiceUserId!=null && vm.case.status==\'ASSIGNED\'" confirmed-click="vm.clearCso()" ng-confirm-click="*WARNING* Confirm to clear the CS Officer?"><i class="fa fa-user-times"></i> <span translate="CLEAR"></span></a></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="CUSTOMER_NAME"></b></label> <span class="form-control">{{vm.case.debtorName}}</span></div></div></div><div class="row"><div class="col-lg-12"><hr></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b translate="REPORT_REMARKS"></b></label> <span class="form-control" style="height:100px">{{vm.case.remarks}}</span></div></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="CASE_TYPE"></b></label> <span class="form-control">{{vm.case.caseType}}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="EQUIPMENT_NAME"></b></label> <span class="form-control">{{vm.case.assetName}}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b translate="EQUIPMENT_DESCRIPTION"></b></label> <textarea class="form-control" style="height:140px;background:#fffeed;color:#333" ng-model="vm.case.assetDesc" ng-disabled="true">\n\t\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="EQUIPMENT_SERIAL_NO."></b></label> <span class="form-control">{{vm.case.assetSerialNo}}</span></div></div></div></div></div><div class="row"><div class="col-lg-12"><hr></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Notes"><p><small><i class="fa fa-info-circle"></i> <span translate="CHAT_ROOM_FOR_COMMUNICATION."></span></small><br><br></p><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group"><div style="max-height:300px;overflow:auto"><table class="table table-striped" style="border:1px solid #ccc;font-size:85%"><thead><tr class="sortable"><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="AUTHOR"></b></th><th><b translate="NOTES"></b></th></tr></thead><tbody><tr ng-repeat="ntn in vm.case.asServiceCaseNotes"><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.createdDate | date:"dd/MM/yyyy - hh:mma" }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.createdBy | uppercase }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.remarks }}</td></tr><tr><td colspan="3" align="center" ng-show="vm.case.asServiceCaseNotes.length==0"><br><span translate="NOTE_LOG_IS_EMPTY"></span><br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row"><div class="col-md-6 col-lg-6" style="padding-right:2px"><div class="form-group"><input type="text" class="form-control" placeholder="Type something here..." prevent-enter-key="vm.addNote()" ng-disabled="vm.isLockButton || vm.case.status==\'CLOSED\' || vm.case.status==\'CONVERTED\'" ng-model="vm.note"></div></div><div class="col-md-2 col-lg-2" style="padding-left:2px"><a href="" class="btn btn-primary btn-with-icon" ng-disabled="vm.note==\'\' || vm.isLockButton || vm.case.status==\'CLOSED\' || vm.case.status==\'CONVERTED\'" ng-click="vm.addNote()"><i class="fa fa-commenting"></i> <span translate="SUBMIT_NOTE"></span></a></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Media (Pic&sol;Video)"><p><small><i class="fa fa-info-circle"></i> <span translate="A_LIST_OF_PICTURES_OR_VIDEOS_FOR_THIS_CASE" <="" small=""><br><br></span></small></p><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><table class="table table-striped" style="border:1px solid #ccc;font-size:85%"><thead><tr class="sortable"><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="AUTHOR"></b></th><th><b translate="PICTURE/VIDEO"></b></th><th><b>{{ \'REMARKS\' | translate }}</b></th></tr></thead><tbody><tr ng-repeat="ntn in vm.case.asServiceCaseMedias"><td>{{ ntn.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td>{{ ntn.createdBy | uppercase }}</td><td style="padding-top:8px;padding-bottom:8px"><div class="center-cropped step-image-card" style="cursor:pointer;border:4px solid #004285;background-image: url(\'{{ntn.finalMediaFile}}\');" fancyboxable="{href:\'{{ntn.finalMediaFile}}\'}" ng-if="ntn.mediaType==\'image\' && ntn.mediaFile!=null && ntn.mediaFile!=\'\'"><span class="fa-stack fa-lg" style="margin-left:250px;margin-top:100px"><i class="fa fa-circle fa-stack-2x fa-inverse"></i> <i class="fa fa-search fa-stack-1x"></i></span></div><iframe ng-src="{{ntn.finalVimeoUrl}}" width="300" height="150" frameborder="0" class="step-image-card" style="border:4px solid #740085;background:#000" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" ng-if="ntn.mediaType==\'video\' && ntn.isVimeoConverted!=null && ntn.vimeoVideoId!=\'\'"></iframe><img src="assets/img/empty_placeholder.png" alt="" style="width:300px" class="step-image-card" ng-if="ntn.mediaType==\'image\' && (ntn.mediaFile==null || ntn.mediaFile==\'\')"></td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.remarks }}</td></tr><tr><td colspan="4" align="center" ng-show="vm.case.asServiceCaseMedias.length==0"><br><span translate="MEDIA_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div><script type="text/ng-template" id="csoModal.html"><form name="$mdl.csoForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="ASSIGN_CS_OFFICER"></span> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.selectedCso==null && $mdl.csoForm.$submitted}"> <label><b translate=SELECT_A_CUSTOMER_SERVICE_OFFICER></b> <i class="fa fa-asterisk req"></i></label> <select class="form-control" name="Status" style="background:#fffeed" ng-options="u as (\'[ \' + u.caseOnHandCount + \' ] \' + u.firstName + \' \' + u.lastName) for u in $mdl.csoList track by u.id" ng-model="$mdl.selectedCso" ng-change="$mdl.onSelectedCsoChanged()" required> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.selectedCso==null && $mdl.csoForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.isLockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script></div></div>');
$templateCache.put('app/pages/services/casemanagement/casemgmtList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.casemgmtData" refresh-table="" style="font-size:85%"><thead><tr><th colspan="12" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Case" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:40px">#</th><th st-sort="caseNo"><span translate="CASE_NO"></span>.</th><th st-sort="caseDate"><span translate="CASE_DATE" <="" th=""><th st-sort="caseType"><span translate="CASE_TYPE" <="" th=""><th st-sort="debtorName"><span translate="CUSTOMER_NAME"></span></th><th translate="ITEM_NAME"></th><th translate="SERIAL_NO"></th><th translate="REMARKS"></th><th translate="STATUS"></th><th translate="C.S.O"></th><th style="width:40px"></th></span></th></span></th></tr><tr class="sortable"><th colspan="3"><select ng-change="vm.onSelectedStatusChanged()" ng-model="vm.selectedStatus"><option value="open">{{ \'SHOW_OPEN_CASES\' | translate }}</option><option value="unassigned">{{ \'SHOW_UNASSIGNED_CASES\' | translate }}</option><option value="closed">{{ \'SHOW_CLOSED_CASES\' | translate }}</option></select></th><th class="form-inline"><select st-search="caseType"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="c in vm.casemgmtDataFull | unique:\'caseType\' | orderBy:\'caseType\'" value="{{c.caseType}}">{{c.caseType | uppercase}}</option></select></th><th class="form-inline"><select st-search="debtorName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="c in vm.casemgmtDataFull | unique:\'debtorName\' | orderBy:\'debtorName\'" value="{{c.debtorName}}">{{c.debtorName | uppercase}}</option></select></th><th colspan="3"></th><th class="form-inline"><select st-search="status"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="c in vm.casemgmtDataFull | unique:\'status\' | orderBy:\'status\'" value="{{c.status}}">{{c.status | uppercase}}</option></select></th><th class="form-inline"><select st-search="customerServiceUser"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="c in vm.casemgmtDataFull | unique:\'customerServiceUser\' | orderBy:\'customerServiceUser\'" value="{{c.customerServiceUser}}">{{c.customerServiceUser | uppercase}}</option></select></th><th></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA_...\' | translate }}</b></center></big></td></tr><tr ng-if="vm.casemgmtData.length<=0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-repeat="item in vm.casemgmtData"><td>{{vm.startIndex+1+$index}})</td><td nowrap="nowrap">{{item.caseNo}}</td><td nowrap="nowrap">{{item.caseDate}}</td><td nowrap="nowrap">{{item.caseType}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.debtorName}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.assetName}}</td><td nowrap="nowrap">{{item.assetSerialNo}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.remarks}}</td><td>{{item.status}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.customerServiceUser}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="services.casemanagement.update({id:item.id})" rms-check-access="services.casemanagement" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="12" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/services/casemanagement/casemgmtUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/services/casemanagement/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" style="margin-right:30px" ui-sref="services.casemanagement.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a><a href="" class="btn btn-primary btn-with-icon" style="margin-right:20px" ng-if="vm.case.status!=\'CLOSED\' && vm.case.status!=\'CONVERTED\'" confirmed-click="vm.convertWorkOrder()" ng-confirm-click="*WARNING* Confirm convert to Work Order?" ng-disabled="vm.lockButtons"><i class="fa fa-level-up"></i><span translate="CONVERT_TO_WORK_ORDER"></span></a> <a href="" class="btn btn-success btn-with-icon" ng-if="vm.case.status!=\'CLOSED\' && vm.case.status!=\'CONVERTED\'" confirmed-click="vm.closeCase()" ng-confirm-click="*WARNING* Confirm close case?" ng-disabled="vm.lockButtons"><i class="fa fa-check-circle"></i> <span translate="CLOSE_CASE"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/suppliers/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SupplierCode.$invalid && (vm.dataForm.SupplierCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="SUPPLIER_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SupplierCode" ng-model="vm.supplier.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SupplierCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><label translate="STATUS"></label><div><toggle ng-model="vm.supplier.active" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SupplierName.$invalid && (vm.dataForm.SupplierName.$dirty || vm.dataForm.$submitted)}"><label><b translate="SUPPLIER_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SupplierName" ng-model="vm.supplier.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SupplierName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="SUPPLIER_SHORT_NAME"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.shortName"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="COMPANY_REG._NO."></b></label> <input type="text" class="form-control" ng-model="vm.supplier.companyRegNo"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="GST_REG._NO."></b></label> <input type="text" class="form-control" ng-model="vm.supplier.gstRegNo"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="ADDRESS_1"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.address1"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="ADDRESS_2"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.address2"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="ADDRESS_3"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.address3"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="STATE"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.state"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="POSTAL_CODE"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.postCode"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="COUNTRY"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.country"></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CONTACT_DETAILS\' | translate }}"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="CONTACT_PERSON">#1</b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields"></i></label> <input type="text" class="form-control" ng-model="vm.supplier.contactPerson1" ng-required="vm.hasAutoCountFields"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="TELEPHONE"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.phone1"><p style="font-size: 9pt; margin-top: 5px; color: #888888">Note: Enter phone number in E.164 format (e.g. +60102345678). Incorrect format will prevent sharing Purchase Order / Sales Order with PIC via messenger.</p></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="FAX"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.fax1"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="EMAIL_ADDRESS"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.email1"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><p><hr></p></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="CONTACT_PERSON_#2"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.contactPerson2"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="TELEPHONE"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.phone2"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="FAX"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.fax2"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="EMAIL_ADDRESS"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.email2"></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'OTHERS\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CurrencyCode.$invalid && (vm.dataForm.CurrencyCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="CURRENCY_CODE"></b> <i class="fa fa-asterisk req"></i></label><select name="CurrencyCode" class="form-control" ng-options="c as (\'[\' + c.code + \'] \' + c.name) for c in vm.currencyList" ng-model="vm.selectedCurrency" ng-change="vm.selectedCurrencyChanged()" required=""><option value="">-- Select a Currency --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CurrencyCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="PAYMENT_TERM"></b></label> <input type="text" class="form-control" ng-model="vm.supplier.paymentTerm"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="REMARKS"></b></label> <textarea class="form-control" ng-model="vm.supplier.remarks">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="SysPro Fields" ng-if="vm.integrationMode==1"><p><small><i class="fa fa-info-circle"></i> <span translate="THESE_INFORMATION_MUST_BE_FILLED_IN_FOR_SYSPRO_INTEGRATION."></span></small></p><br><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProBankCode.$invalid && (vm.dataForm.SysProBankCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="BANK_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SysProBankCode" ng-model="vm.supplier.syspro_BankCode" ng-required="vm.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProBankCode.$error.required">*</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProBranchCode.$invalid && (vm.dataForm.SysProBranchCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="BRANCH_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SysProBranchCode" ng-model="vm.supplier.syspro_BranchCode" ng-required="vm.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProBranchCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProTermCode.$invalid && (vm.dataForm.SysProTermCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="PAYMENT_TERM_(DAY)"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SysProTermCode" maxlength="2" ng-model="vm.supplier.syspro_TermCode" ng-required="vm.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProTermCode.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProTermCode.$error.maxlength">* <span translate="MAXIMUM_2_CHARACTERS_ONLY"></span></span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="AutoCount Fields" ng-if="vm.hasAutoCountFields"><p><small><i class="fa fa-info-circle"></i> <span translate="THESE_INFORMATION_MUST_BE_FILLED_IN_FOR_AUTOCOUNT_INTEGRATION."></span></small></p><br><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CreditorType.$invalid && (vm.dataForm.CreditorType.$dirty || vm.dataForm.$submitted)}"><label><b translate="CREDITOR_TYPE"></b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields && vm.autoCount_CreditorTypes.length!=0"></i></label><select name="CreditorType" class="form-control" ng-change="vm.selectedCreditorTypeChanged()" ng-model="vm.selectedCreditorType" ng-options="i as (i.description || \'-\') for i in vm.autoCount_CreditorTypes" ng-required="vm.hasAutoCountFields && vm.autoCount_CreditorTypes.length!=0"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CreditorType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AreaCode.$invalid && (vm.dataForm.AreaCode.$dirty || vm.dataForm.$submitted)}"><label><b>Area Code</b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields && vm.autoCount_AreaCodes.length!=0"></i></label><select name="AreaCode" class="form-control" ng-change="vm.selectedAreaCodeChanged()" ng-model="vm.selectedAreaCode" ng-options="i as (\'[\'+ i.areaCode + \'] \' + (i.description || \'-\')) for i in vm.autoCount_AreaCodes" ng-required="vm.hasAutoCountFields && vm.autoCount_AreaCodes.length!=0"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AreaCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ControlAccount.$invalid && (vm.dataForm.ControlAccount.$dirty || vm.dataForm.$submitted)}"><label><b translate="CONTROL_ACCOUNT"></b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields && vm.autoCount_ControlAccounts.length!=0"></i></label><select name="ControlAccount" class="form-control" ng-change="vm.selectedControlAccountChanged()" ng-model="vm.selectedControlAccount" ng-options="i as (\'[\'+ i.accNo + \'] \' + (i.description || \'-\')) for i in vm.autoCount_ControlAccounts" ng-required="vm.hasAutoCountFields && vm.autoCount_ControlAccounts.length!=0"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ControlAccount.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CurrencyCode.$invalid && (vm.dataForm.CurrencyCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="CURRENCY_CODE"></b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields && vm.autoCount_CurrencyCodes.length!=0"></i></label><select name="CurrencyCode" class="form-control" ng-change="vm.selectedCurrencyCodeChanged()" ng-model="vm.selectedCurrencyCode" ng-options="i as (\'[\'+ i.currencyCode + \'] \' + i.currencyWord) for i in vm.autoCount_CurrencyCodes" ng-required="vm.hasAutoCountFields && vm.autoCount_CurrencyCodes.length!=0"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CurrencyCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DisplayTerm.$invalid && (vm.dataForm.DisplayTerm.$dirty || vm.dataForm.$submitted)}"><label><b translate="DISPLAY_TERM"></b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields && vm.autoCount_DisplayTerms.length!=0"></i></label><select name="DisplayTerm" class="form-control" ng-change="vm.selectedDisplayTermChanged()" ng-model="vm.selectedDisplayTerm" ng-options="i as i.displayTerm for i in vm.autoCount_DisplayTerms" ng-required="vm.hasAutoCountFields && vm.autoCount_DisplayTerms.length!=0"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DisplayTerm.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="SQL Fields" ng-if="vm.hasSQLFields"><p><small><i class="fa fa-info-circle"></i> <span translate="THESE_INFORMATION_MUST_BE_FILLED_IN_FOR_SQL_INTEGRATION."></span></small></p><br><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLCreditorType.$invalid && (vm.dataForm.SQLCreditorType.$dirty || vm.dataForm.$submitted)}"><label><b translate="DEBTOR_TYPE"></b> <i class="fa fa-asterisk req" ng-if="vm.hasSQLFields"></i></label><select name="SQLCreditorType" class="form-control" ng-change="vm.selectedCompanyCategoryChanged()" ng-model="vm.selectedCompanyCategory" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sqlFields.SQL_Maintenance_CompanyCategory" ng-required="vm.hasSQLFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLCreditorType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLAreaCode.$invalid && (vm.dataForm.SQLAreaCode.$dirty || vm.dataForm.$submitted)}"><label><b>Area Code</b> <i class="fa fa-asterisk req" ng-if="vm.hasSQLFields"></i></label><select name="SQLAreaCode" class="form-control" ng-change="vm.selectedSQLAreaCodeChanged()" ng-model="vm.selectedSQLAreaCode" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sqlFields.SQL_Maintenance_Area" ng-required="vm.hasSQLFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLAreaCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLControlAccount.$invalid && (vm.dataForm.SQLControlAccount.$dirty || vm.dataForm.$submitted)}"><label><b translate="CONTROL_ACCOUNT"></b> <i class="fa fa-asterisk req" ng-if="vm.hasAutoCountFields"></i></label><select name="SQLControlAccount" class="form-control" ng-change="vm.selectedSQLControlAccountChanged()" ng-model="vm.selectedSQLControlAccount" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sqlFields.SQL_Supplier_ControlAccount" ng-required="vm.hasAutoCountFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLControlAccount.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLSalesAgent.$invalid && (vm.dataForm.SQLSalesAgent.$dirty || vm.dataForm.$submitted)}"><label><b>Agent Code</b> <i class="fa fa-asterisk req" ng-if="vm.hasSQLFields"></i></label><select name="SQLSalesAgent" class="form-control" ng-change="vm.selectedSQLAgentChanged()" ng-model="vm.selectedSQLAgent" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sqlFields.SQL_Maintenance_Agent" ng-required="vm.hasSQLFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLSalesAgent.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CurrencyCode.$invalid && (vm.dataForm.CurrencyCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="CURRENCY_CODE"></b> <i class="fa fa-asterisk req" ng-if="vm.hasSQLFields"></i></label><select name="CurrencyCode" class="form-control" ng-change="vm.selectedSQLCurrencyChanged()" ng-model="vm.selectedSQLCurrencyCode" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sqlFields.SQL_Maintenance_Currency" ng-required="vm.hasSQLFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CurrencyCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DisplayTerm.$invalid && (vm.dataForm.DisplayTerm.$dirty || vm.dataForm.$submitted)}"><label><b translate="TERM"></b> <i class="fa fa-asterisk req" ng-if="vm.hasSQLFields"></i></label><select name="DisplayTerm" class="form-control" ng-change="vm.selectedSQLTermChanged()" ng-model="vm.selectedSQLTerm" ng-options="i as (\'[\'+ i.CODE + \'] \' + (i.DESCRIPTION || \'-\')) for i in vm.sqlFields.SQL_Maintenance_Terms" ng-required="vm.hasSQLFields"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DisplayTerm.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="IDB Fields" ng-if="vm.hasIDBFields"><p><small><i class="fa fa-info-circle"></i> <span translate="THESE_INFORMATION_MUST_BE_FILLED_IN_FOR_IDB_INTEGRATION."></span></small></p><br><div class="row"><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.idbCreditorType.$invalid && (vm.dataForm.idbCreditorType.$dirty || vm.dataForm.$submitted)}"><label><b translate="CREDITOR_TYPE"></b> <i class="fa fa-asterisk req" ng-if="vm.hasIDBFields && vm.idbCreditorTypes.length!=0"></i></label><select name="idbCreditorType" class="form-control" ng-change="vm.selectedIDBCreditorTypeChanged()" ng-model="vm.selectedIDBCreditorType" ng-options="i as (\'[\'+ i.code + \'] \' + (i.desc || \'-\')) for i in vm.idbCreditorTypes" ng-required="vm.hasIDBFields && vm.idbCreditorTypes.length!=0"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.idbCreditorType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.idbCreditTerm.$invalid && (vm.dataForm.idbCreditTerm.$dirty || vm.dataForm.$submitted)}"><label><b translate="DISPLAY_TERM"></b> <i class="fa fa-asterisk req" ng-if="vm.hasIDBFields && vm.idbCreditTerms.length!=0"></i></label><select name="idbCreditTerm" class="form-control" ng-change="vm.selectedIDBCreditTermChanged()" ng-model="vm.selectedIDBCreditTerm" ng-options="i as (\'[\'+ i.code + \'] \' + (i.desc || \'-\')) for i in vm.idbCreditTerms" ng-required="vm.hasIDBFields && vm.idbCreditTerms.length!=0"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.idbCreditTerm.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.supplier.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_SEMI_FINISHED_GOOD"></span><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br>{{ \'THERE_IS_NO_CHANGES_YET\' | translate }}<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/maintenance/suppliers/supplierCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/suppliers/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.suppliers.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_SUPPLIER"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.suppliers.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/maintenance/suppliers/supplierImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b translate="IMPORT_SUPPLIERS_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile()" ng-disabled="vm.isExporting || vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span></div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend translate="IMPORT_GUIDELINES:"></legend><ol class="import"><li translate="YOU_NEED_TO_FOLLOW_THE_INSTRUCTION_BELOW_IF_YOU_ARE_NEW_TO_THE_RMS."></li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW_FILL_IT_UP_WITH_THE_DATA_FIRST_THEN_IMPORT_INTO_THE_RMS"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate()"><i class="fa fa-download"></i> <span translate="DOWNLOAD_SUPPLIER_TEMPLATE"></span></a></li></ol></fieldset></div></div><div class="row"><div class="col-lg-12"><br><br><br><br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong translate="FILE_UPLOADED_SUCCESSFULLY._CHOOSE_THE_OPTIONS_BELOW_AND_PROCEED_TO_IMPORT_THE_DATA."></strong></div><div><fieldset><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createSupplier" ng-change="change()" style="cursor:pointer"> <label><span translate="CREATE_NEW_SUPPLIERS"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateSupplier" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_SUPPLIERS_IF_EXISTS"></span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.suppliers.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><br><br><fieldset><legend translate="SUPPLIER_DATA_PREVIEW:"></legend></fieldset></div><div class="horizontal-scroll"><table class="table table-striped table-bordered table-nopadding" border="1" style="norder-collapse:collapse;font-size:8pt !important"><thead><tr><th style="width:60px">#</th><th><b translate="SUPPLIER_CODE"></b></th><th><b translate="SUPPLIER_NAME"></b></th><th><b translate="COMPANY_REG._NO."></b></th><th><b translate="GST_REG._NO."></b></th><th><b translate="PAYMENT_TERM"></b></th><th><b translate="ADDRESS_1"></b></th><th><b translate="ADDRESS_2"></b></th><th><b translate="ADDRESS_3"></b></th><th><b translate="STATE"></b></th><th><b translate="POSTAL_CODE"></b></th><th><b translate="COUNTRY"></b></th><th><b translate="CONTACT_PERSON_#1"></b></th><th><b translate="TELEPHONE_#1"></b></th><th><b translate="FAX_#1"></b></th><th><b translate="EMAIL_#1"></b></th><th><b translate="CONTACT_PERSON_#2"></b></th><th><b translate="TELEPHONE_#2"></b></th><th><b translate="FAX_#2"></b></th><th><b translate="EMAIL_#2"></b></th><th><b translate="CURRENCY_CODE"></b></th></tr><tr><th colspan="21"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td nowrap="nowrap">{{ row.supplierCode || \'\' }}</td><td nowrap="nowrap">{{ row.supplierName || \'\' }}</td><td nowrap="nowrap">{{ row.companyRegNo || \'-\' }}</td><td nowrap="nowrap">{{ row.gstRegNo || \'-\' }}</td><td nowrap="nowrap">{{ row.paymentTerm || \'-\' }}</td><td nowrap="nowrap">{{ row.address1 || \'-\' }}</td><td nowrap="nowrap">{{ row.address2 || \'-\' }}</td><td nowrap="nowrap">{{ row.address3 || \'-\' }}</td><td nowrap="nowrap">{{ row.state || \'-\' }}</td><td nowrap="nowrap">{{ row.postcode || \'-\' }}</td><td nowrap="nowrap">{{ row.country || \'-\' }}</td><td nowrap="nowrap">{{ row.contactPerson1 || \'-\' }}</td><td nowrap="nowrap">{{ row.phone1 || \'-\' }}</td><td nowrap="nowrap">{{ row.fax1 || \'-\' }}</td><td nowrap="nowrap">{{ row.email1 || \'-\' }}</td><td nowrap="nowrap">{{ row.contactPerson2 || \'-\' }}</td><td nowrap="nowrap">{{ row.phone2 || \'-\' }}</td><td nowrap="nowrap">{{ row.fax2 || \'-\' }}</td><td nowrap="nowrap">{{ row.email2 || \'-\' }}</td><td nowrap="nowrap">{{ row.currencyCode || \'-\' }}</td></tr><tr><td colspan="21" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="21"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-6 col-lg-6"><em><small><i class="fa fa-info-circle"></i> <span translate="PROCESSING"></span>...</small></em><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><p translate="THE_DATA_IS_CURRENTLY_BEING_PROCESSED._IT_IS_SAFE_TO_LEAVE_THIS_PAGE_NOW."></p><p translate="YOU_WILL_RECEIVE_AN_EMAIL_NOTIFICATION_ABOUT_THE_IMPORT_RESULT_ONCE_THE_SERVER_HAS_FINISHED_PROCESSED_THE_DATA."></p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.suppliers.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a></div></form></div>');
$templateCache.put('app/pages/maintenance/suppliers/supplierList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="SupplierListing" st-pipe="vm.retrieveData" st-table="vm.supplierData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.suppliers.create" rms-check-access="maintenance.suppliers" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_SUPPLIER"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="maintenance.suppliers.import" rms-check-access="maintenance.suppliers" rms-check-access-perm-type="CREATE"><i class="fa fa-upload"></i><span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="code">{{ \'CODE\' | translate }}</th><th st-sort="name">{{ \'NAME\' | translate }}</th><th translate="PHONE"></th><th translate="FAX"></th><th translate="EMAIL"></th><th translate="ACTIVE"></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.supplierData.length<=0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="LOADING_DATA_"></span>...</b></center></big></td></tr><tr ng-repeat="item in vm.supplierData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td>{{item.phone1}}</td><td>{{item.fax1}}</td><td>{{item.email1}}</td><td><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="maintenance.suppliers.update({id:item.id})" rms-check-access="maintenance.suppliers" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Supplier" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteSupplier(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Supplier?" rms-check-access="maintenance.suppliers" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/maintenance/suppliers/supplierUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/maintenance/suppliers/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="maintenance.suppliers.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.suppliers.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/services/dutyrosters/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.selectedUser==null && vm.dataForm.$submitted }"><label><b translate="SELECT_A_TECHNICIAN"></b> <i class="fa fa-asterisk req"></i></label><ui-select ng-model="vm.selectedUser" title="Search for Technician..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.selectedUserChanged()"><ui-select-match placeholder="Search for Technician..."><span>{{ ($select.selected.firstName + \' \' + $select.selected.lastName) }}</span></ui-select-match><ui-select-choices repeat="i in vm.users | filter: $select.search" refresh="vm.loadUsers($select.search)" refresh-delay="250" minimum-input-length="3"><span ng-bind-html="(i.firstName + \' \' + i.lastName) | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.selectedUser==null">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.RosterType.$invalid && (vm.dataForm.RosterType.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_A_ROSTER_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="RosterType" ng-options="i as (\'(\' + i.code + \') \' + i.description) for i in vm.rosterTypes track by i.id" ng-model="vm.selectedRosterType" ng-change="vm.selectedRosterTypeChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RosterType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.RosterDate.$invalid && (vm.dataForm.RosterDate.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_A_DATE:"></b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.roster.rosterDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" name="RosterDate" placeholder="YYYY-MM-DD" ng-model="vm.roster.rosterDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RosterDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Remarks.$invalid && (vm.dataForm.Remarks.$dirty || vm.dataForm.$submitted)}"><label><b translate="REMARKS:"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Remarks" placeholder="Remarks" ng-model="vm.roster.remarks" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Remarks.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/services/dutyrosters/dutyrosterCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/services/dutyrosters/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_ROSTER"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="services.dutyrosters.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/services/dutyrosters/dutyrosterList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.rosterData" refresh-table="" style="font-size:70%"><thead><tr><th colspan="33" style="padding-left:0px;padding-bottom:15px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="row"><div class="col-lg-12"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Technician" class="input form-control"></div></div></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" style="margin-left:15px" ui-sref="services.dutyrosters.create" rms-check-access="services.dutyrosters" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_ROSTER"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr><th colspan="33" style="padding-left:0px;padding-bottom:15px;padding-right:0px;border-bottom:1px solid #666"><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:35px;line-height:35px"><div class="row"><div class="col-lg-3" style="padding-left:0px"><select class="form-control" ng-model="vm.year" ng-change="vm.loadRosters()"><option value="{{y}}" ng-repeat="y in vm.years">{{y}}</option></select></div><div class="col-lg-3" style="padding-left:0px"><select class="form-control" ng-model="vm.month" ng-change="vm.loadRosters()"><option ng-repeat="month in vm.months" value="{{month.id}}">{{month.name}}</option></select></div><div class="col-lg-3" style="padding-left:0px"><a href="" class="btn btn-success btn-with-icon" ng-click="vm.loadRosters()" ng-disabled="vm.isLoading"><i class="fa fa-refresh"></i> <span translate="REFRESH"></span></a></div></div></div></th></tr><tr class="sortable"><th style="border-left:1px solid #ccc;border-right:1px solid #ccc;border-bottom:1px solid #666;width:40px" rowspan="2" class="hide-after">#</th><th style="border-right:1px solid #666;border-bottom:1px solid #666;" st-sort="fullName" rowspan="2" class="hide-after"><span translate="TECHNICIAN_NAME"></span></th><th style="border-right:{{ entry.dayOfWeek==\'Sun\' ? \'6px\' : \'1px\' }} solid {{ entry.dayOfWeek==\'Sun\' ? \'#666\' : \'#ccc\' }};text-align:center;min-width:40px" class="hide-after" ng-repeat="entry in vm.rosterData[0].rosterEntries"><b>{{entry.dayOfWeek}}</b></th></tr><tr><th style="border-right:{{ entry.dayOfWeek==\'Sun\' ? \'6px\' : \'1px\' }} solid {{ entry.dayOfWeek==\'Sun\' ? \'#666\' : \'#ccc\' }};border-bottom:1px solid #666;text-align:center;min-width:40px" class="hide-after" ng-repeat="entry in vm.rosterData[0].rosterEntries"><b>{{entry.day}}</b></th></tr></thead><tbody><tr ng-show="vm.rosterData.length<=0 && !vm.isLoading"><td colspan="33" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="33" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA_...\' | translate }}</b></center></big></td></tr><tr ng-repeat="item in vm.rosterData"><td style="border-left:1px solid #ccc;border-right:1px solid #ccc">{{vm.startIndex+1+$index}})</td><td style="border-right:1px solid #666;line-height:110%">{{item.fullName}}</td><td style="background:{{entry.colorCodeHex}};text-align:center;border-right:{{ entry.dayOfWeek==\'Sun\' ? \'6px\' : \'1px\' }} solid {{ entry.dayOfWeek==\'Sun\' ? \'#666\' : \'#ccc\' }};" ng-repeat="entry in item.rosterEntries"><b><a href="" ui-sref="services.dutyrosters.update({id:entry.rosterId})">{{entry.code}}</a></b></td></tr></tbody><tfoot><tr><td colspan="33" style="padding-left:0px;padding-right:0px;border-top:1px solid #666"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/services/dutyrosters/dutyrosterUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/services/dutyrosters/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="services.dutyrosters.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="services.dutyrosters.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/services/loanrequests/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="ENTER_THE_LOAN_REQUEST_DETAILS_BELOW"></span></small><br><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="LOAN_REQUEST_NO"></b></label> <span class="form-control" style="color:#00f" ng-disabled="true">{{vm.loan.requestNo || \'AUTONUMBER\'}}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b span="WORK_ORDER_NO."></b></label> <span class="form-control" style="text-align:left;color:#00f" ng-if="!vm.loan.workId" ng-disabled="true">{{vm.loan.workOrderNo || \'-\'}}</span><div class="input-group" ng-if="vm.loan.workId"><span class="form-control" style="text-align:left;color:#00f" ng-disabled="true">{{vm.loan.workOrderNo || \'-\'}}</span> <a href="" class="btn btn-primary input-group-addon" style="padding:3px 10px;font-size:9pt" ui-sref="services.workorders.update({id:vm.loan.workId})"><i class="fa fa-search"></i> {{ \'VIEW\' | translate }}</a></div></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="LOAN_REQUEST_DATE"></b></label> <span class="form-control" style="color:#00f" ng-disabled="true">{{vm.loan.createdDate || \'-\' | date:\'dd/MM/yyyy hh:mma\'}}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="REQUESTED_BY"></b></label> <span class="form-control" style="color:#00f" ng-disabled="true">{{vm.loan.createdBy || \'-\' | uppercase | limitTo:15}} <span ng-if="vm.loan.createdBy.length>15">...</span></span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.selectedDebtor==null && (vm.dataForm.Customer.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_A_CUSTOMER"></b> <i class="fa fa-asterisk req"></i></label> <a href="" ng-click="vm.clearDebtor()" class="btn btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="vm.selectedDebtor!=null"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a><ui-select name="Customer" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" ng-model="vm.selectedDebtor" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.onSelectedDebtorChanged()"><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.name | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.debtorList | filter: $select.search" refresh="vm.loadDebtorList($select.search)" refresh-delay="250" minimum-input-length="2"><span ng-bind-html="vm.beautify(i) | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.selectedDebtor==null">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LoanType.$invalid && (vm.dataForm.LoanType.$dirty || vm.dataForm.$submitted)}"><label><b translate="LOAN_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="LoanType" ng-options="u as u.name for u in vm.loanTypes" ng-model="vm.selectedType" ng-change="vm.onSelectedTypeChanged()" required=""><option value="">-- {{ \'SELECT_A_TYPE\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LoanType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LoanStatus.$invalid && (vm.dataForm.LoanStatus.$dirty || vm.dataForm.$submitted)}"><label><b translate="LOAN_STATUS"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="LoanStatus" ng-options="u as u.name for u in vm.loanStatusList" ng-model="vm.selectedStatus" ng-change="vm.onSelectedStatusChanged()" required=""><option value="">-- {{ \'SELECT_A_STATUS\'|translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LoanStatus.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="EST_LOAN_FROM"></b></label><div moment-picker="vm.loan.estLoanFrom" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="EstLoanFrom" style="background:#fffeed" ng-disabled="vm.isLoading" ng-model="vm.loan.estLoanFrom" ng-readonly="true"></div></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="EST_LOAN_TO"></b></label><div moment-picker="vm.loan.estLoanTo" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="EstLoanTo" style="background:#fffeed" ng-disabled="vm.isLoading" ng-model="vm.loan.estLoanTo" ng-readonly="true"></div></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="INVOICE_NUMBER"></b></label> <input type="text" class="form-control" name="InvoiceNo" style="text-transform:uppercase" ng-model="vm.loan.invoiceNo"></div></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="LOAN_DATE"></b></label><div class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <span class="form-control" style="color:#00f" ng-disabled="true">{{vm.loan.onLoanDate || \'-\' | date:\'dd/MM/yyyy\'}}</span></div></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="RETURNED_DATE"></b></label><div class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <span class="form-control" style="color:#00f" ng-disabled="true">{{vm.loan.returnDate || \'-\' | date:\'dd/MM/yyyy\'}}</span></div></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="CLOSED_DATE"></b></label><div class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <span class="form-control" style="color:#00f" ng-disabled="true">{{vm.loan.closeDate || \'-\' | date:\'dd/MM/yyyy\'}}</span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b translate="PURPOSE"></b></label> <textarea class="form-control" placeholder="Purpose" ng-model="vm.loan.purpose">\n\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" placeholder="Remarks" ng-model="vm.loan.remarks">\n\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Spare Parts"><p><small><i class="fa fa-info-circle"></i><span translate="MANAGE_THE_EQUIPMENT_OR_SPARE_PARTS_ON_LOAN."></span></small> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddItemModal()"><i class="ion-plus-round"></i> <span translate="EQUIPMENT_/_SPARE_PART"></span></a><br><br></p><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:1px solid #ccc;font-size:90%"><thead><tr class="sortable"><th style="width:60px">#</th><th><b>WH</b></th><th><b translate="CODE_/_DESCRIPTION"></b></th><th style="text-align:right" class="hide-after"><b translate="PRICE"></b></th><th style="text-align:right" class="hide-after"><b translate="QTY"></b></th><th style="text-align:right" class="hide-after"><b translate="QTY_RETURNED"></b></th><th></th><th><b translate="SERIAL_NO."></b></th><th><b>{{ \'STATUS\' | translate }}</b></th><th><b translate="REMARKS"></b></th><th style="width:20px"></th><th style="width:20px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.loan.asLoanRequestItems"><td>{{ $index+1 }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{ ntn.storageName || \'\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%"><small>{{ntn.itemCode}}</small><br>{{ ntn.itemDescription || \'\' }}</td><td style="text-align:right">{{ ntn.price | number:2 }}</td><td style="text-align:right">{{ ntn.quantity | number:0 }}</td><td style="text-align:right">{{ ntn.quantityReturn | number:0 }}</td><td></td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{ ntn.serialNo || \'-\' }}</td><td nowrap="nowrap">{{ ntn.status || \'-\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{ ntn.remarks || \'-\' }}</td><td><a class="btn btn-primary btn-xs" ng-click="vm.showEditItemModal($index)"><i class="fa fa-pencil"></i></a></td><td><a class="btn btn-danger btn-xs" rms-check-access="services.loanrequests" rms-check-access-perm-type="DELETE" ng-click="vm.removeItem($index)"><i class="fa fa-trash-o"></i></a></td></tr><tr><td colspan="12" align="center" ng-if="vm.loan.asLoanRequestItems.length==0"><br><span translate="ITEM_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="ESPItemModal.html"><form name="$mdl.modalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="EQUIPMENT_/_SPARE_PART"></span> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <label><b translate="SELECT_EITHER_EQUIPMENT_/_SPARE_PART:"></b></label> <div ba-panel-class="horizontal-tabs tabs-panel panel" style="background:#fafafa;margin-bottom:15px"> <uib-tabset active="$mdl.activeTab"> <uib-tab heading="Equipment"> <div class="form-group" ng-class="{\'has-error\': $mdl.selectedEquipment==null && ($mdl.modalForm.Equipment.$dirty || $mdl.modalForm.$submitted)}"> <label><b translate="SELECT_A_EQUIPMENT"></b> <i class="fa fa-asterisk req"></i></label> <a href class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="$mdl.clearEquipment()" ng-confirm-click="Clear selected Equipment?" ng-if="$mdl.selectedEquipment!=null && $mdl.originalStatus==\'NEW\'"> <i class="fa fa-trash"></i> <span translate="CLEAR"></span> </a> <ui-select name="Equipment" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedEquipment" ng-required="$mdl.activeTab==0" on-select="$mdl.onSelectedEquipmentChanged()" style="background:#fff"> <ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"> <span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.name | uppercase }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.equipmentList | orderBy:\'code\' | filter: $select.search" refresh="$mdl.loadEquipmentList($select.search)" refresh-delay="250" minimum-input-length="2"> <span ng-bind-html="$mdl.beautifyEquipment(i) | highlight: $select.search"></span> </ui-select-choices> </ui-select> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.selectedEquipment==null">* {{ \'REQUIRED\' | translate }}</span> </div> </uib-tab> <uib-tab heading="Spare Part"> <div class="form-group" ng-class="{\'has-error\': $mdl.selectedSparePart==null && ($mdl.modalForm.SparePart.$dirty || $mdl.modalForm.$submitted)}"> <label><b translate="SELECT_A_SPARE_PART"></b> <i class="fa fa-asterisk req"></i></label> <a href class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="$mdl.clearSparePart()" ng-confirm-click="Clear selected Spare Part?" ng-if="$mdl.selectedEquipment!=null && $mdl.originalStatus==\'NEW\'"> <i class="fa fa-trash"></i> <span translate="CLEAR"></span> </a> <ui-select name="SparePart" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedSparePart" ng-required="$mdl.activeTab==1" on-select="$mdl.onSelectedSparePartChanged()" style="background:#fff"> <ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"> <span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.description | uppercase }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.sparePartList | orderBy:\'code\' | filter: $select.search" refresh="$mdl.loadSparePartList($select.search)" refresh-delay="250" minimum-input-length="2"> <span ng-bind-html="$mdl.beautifySparePart(i) | highlight: $select.search"></span> </ui-select-choices> </ui-select> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.selectedSparePart==null">* {{ \'REQUIRED\' | translate }}</span> </div> </uib-tab> </uib-tabset> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Warehouse.$invalid && $mdl.modalForm.$submitted}"> <label><b translate="SELECT_A_WAREHOUSE"></b> <i class="fa fa-asterisk req"></i></label> <ui-select name="Warehouse" title="-- Select a Warehouse --" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false" ng-model="$mdl.selectedStorage" ng-required="true" on-select="$mdl.onSelectedStorageChanged()" style="background:#FFFCED"> <ui-select-match> <span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.description | uppercase }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.storageList | orderBy:\'code\'"> <span ng-bind-html="$mdl.beautifyWarehouse(i)"></span> </ui-select-choices> </ui-select> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Warehouse.$error.required && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</span> </div> </div> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Status.$invalid && $mdl.modalForm.$submitted}"> <label><b>{{ \'STATUS\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <select name="Status" class="form-control" style="background:#FFFCED" ng-change="$mdl.onSelectedStatusChanged()" ng-options="i as i.name for i in $mdl.statusList" ng-model="$mdl.selectedStatus" required> <option value="">-- {{ \'SELECT_A_STATUS\'|translate }} --</option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Status.$error.required && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Quantity.$invalid && $mdl.modalForm.$submitted}"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="Quantity" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.quantity" min=1 required /> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Quantity.$error.required && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Quantity.$error.number && $mdl.modalForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Quantity.$error.min && $mdl.modalForm.$submitted">* <span translate="MINIMUM_QUANTITY_IS_1"></span> (1)</span> </div> </div> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.QuantityReturned.$invalid && $mdl.modalForm.$submitted}"> <label><b translate="QUANTITY_RETURNED"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="QuantityReturned" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.quantityReturn" min=0 required /> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.QuantityReturned.$error.required && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.QuantityReturned.$error.number && $mdl.modalForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.QuantityReturned.$error.min && $mdl.modalForm.$submitted">* <span translate="MINIMUM_IS_0"></span></span> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Price.$invalid && $mdl.modalForm.$submitted}"> <label><b translate="PRICE"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="Price" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.price" min=0 required /> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Price.$error.required && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Price.$error.number && $mdl.modalForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</p> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Price.$error.min && $mdl.modalForm.$submitted">* <span translate="MINIMUM_IS_0"></span></p> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b translate="SERIAL_NO."></b></label> <input type="text" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.serialNo" /> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.remarks" /> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButtons || $mdl.isLoading" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING_..."></b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons || $mdl.isLoading"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButtons || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="printModal.html"><form name="$mdl.printForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="PRINT_DOCUMENT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <table class="table table-striped" style="border:1px solid #ccc"> <thead> <tr> <th style="width:60px">#</th> <th><b translate="DOCUMENT_DESCRIPTION"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr> <td>1)</td> <td>Loan Request Form</td> <td> <a href class="btn btn-primary btn-with-icon btn-xs" style="width:90px" ng-click="$mdl.printLoanForm()" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-printer" ng-if="!$mdl.isLoading"></i> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> {{ \'PRINT\' | translate}} </a> </td> </tr> <tr> <td>2)</td> <td>Picking List</td> <td> <a href class="btn btn-primary btn-with-icon btn-xs" style="width:90px" ng-click="$mdl.printPickingList()" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-printer" ng-if="!$mdl.isLoading"></i> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> {{ \'PRINT\' | translate}} </a> </td> </tr> </tbody> </table> <div class="row"> <p>&nbsp;</p> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b> <span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/services/loanrequests/loanrequestCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/services/loanrequests/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="services.loanrequests.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_LOAN_REQUEST"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="services.loanrequests.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/services/loanrequests/loanrequestList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="LoanRequestListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table="" style="font-size:90%"><thead><tr><th colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_CLOSED_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="services.loanrequests.create" rms-check-access="services.loanrequests" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> {{ \'ADD_NEW_LOAN\' | translate }}</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="requestNo">{{ \'LOAN_NO\' | translate }}</th><th st-sort="debtorName">{{ \'CUSTOMER_NAME\' | translate }}</th><th st-sort="workNo">{{ \'WORK_ORDER_NO.\' | translate }}</th><th st-sort="type">{{ \'TYPE\' | translate }}</th><th>{{ \'INVOICE_NO.\' | translate }}</th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th>{{ \'LOAN_PARTS\' | translate }}</th><th st-sort="createdBy">{{ \'CREATED_BY\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline"><input st-search="requestNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="debtorName" class="form-control input input-sm"></th><th class="form-inline"><input st-search="workOrderNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="type" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="invoiceNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="status" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="itemName" class="form-control input input-sm" style="width:150px"></th><th class="form-inline"><input st-search="userName" class="form-control input input-sm" style="width:120px"></th><th colspan="3"></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="13" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA_...\' | translate }}</b></center></big></td></tr><tr ng-if="vm.data.length==0 && !vm.isLoading"><td colspan="13" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td nowrap="nowrap">{{item.requestNo}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.debtorName}}</td><td nowrap="nowrap">{{item.workNo || \'-\'}}</td><td nowrap="nowrap">{{item.type}}</td><td nowrap="nowrap">{{item.invoiceNo}}</td><td nowrap="nowrap">{{item.status}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%;font-size:8pt"><div style="max-height:100px;overflow:auto"><ul style="padding-left:12px;margin-bottom:5px"><li ng-repeat="i in item.asLoanRequestItems">{{ i.itemName }} [<b>Qty: {{ i.quantity }}</b>]</li></ul></div></td><td nowrap="nowrap">{{(item.createdBy | uppercase | limitTo:10) + (item.createdBy.length > 10 ? \' ...\' : \'\') }}</td><td align="center"><a href="" title="Print" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ng-click="vm.showPrintDialog(item.id, item.requestNo)" rms-check-access="services.loanrequests" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="services.loanrequests.update({id:item.id})" rms-check-access="services.loanrequests" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Loan" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteLoan(item.id, item.requestNo)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Loan?" rms-check-access="services.loanrequests" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="printModal.html"><form name="$mdl.printForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> {{$mdl.requestNo}} - <span translate="PRINT_DOCUMENT"></span> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <table class="table table-striped" style="border:1px solid #ccc"> <thead> <tr> <th style="width:60px">#</th> <th><b translate="DOCUMENT_DESCRIPTION"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr> <td>1)</td> <td>Loan Request Form</td> <td> <a href class="btn btn-primary btn-with-icon btn-xs" style="width:90px" ng-click="$mdl.printLoanForm()" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-printer" ng-if="!$mdl.isLoading"></i> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> {{ \'PRINT\' | translate}} </a> </td> </tr> <tr> <td>2)</td> <td>Picking List</td> <td> <a href class="btn btn-primary btn-with-icon btn-xs" style="width:90px" ng-click="$mdl.printPickingList()" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-printer" ng-if="!$mdl.isLoading"></i> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> {{ \'PRINT\' | translate}} </a> </td> </tr> </tbody> </table> <div class="row"> <p>&nbsp;</p> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b> <span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/services/loanrequests/loanrequestUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/services/loanrequests/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ui-sref="services.loanrequests.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-if="!vm.loan.noFurtherEdit" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="services.loanrequests.list" ng-if="!vm.loan.noFurtherEdit" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-primary btn-with-icon" style="margin-left:30px" ng-disabled="vm.lockButtons" ng-click="vm.showPrintDialog()" rms-check-access="services.loanrequests" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT_DOCUMENT"></span></a></div></form>');
$templateCache.put('app/pages/services/warranty/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="ENTER_THE_WARRANTY_DETAILS_FOR_THE_ITEM_SOLD."></span></small><br><br></p><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="WARRANTY_NO"></b></label> <span class="form-control" style="color:#00f">{{vm.warranty.warrantyNo || \'AUTONUMBER\'}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SerialNo.$invalid && (vm.dataForm.SerialNo.$dirty || vm.dataForm.$submitted)}"><label><b translate="EQUIPMENT_SERIAL_NO."></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SerialNo" placeholder="Serial Number" style="text-transform:uppercase" ng-model="vm.warranty.serialNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Customer.$invalid && (vm.dataForm.Customer.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_A_CUSTOMER"></b> <i class="fa fa-asterisk req"></i></label> <a href="" ng-click="vm.clearDebtor()" class="btn btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="vm.selectedDebtor!=null"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a><ui-select name="Customer" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" ng-model="vm.selectedDebtor" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.onSelectedDebtorChanged()"><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.name | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.debtorList | filter: $select.search" refresh="vm.loadDebtorList($select.search)" refresh-delay="250" minimum-input-length="2"><span ng-bind-html="vm.beautify(i) | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Customer.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InvoiceNo.$invalid && (vm.dataForm.InvoiceNo.$dirty || vm.dataForm.$submitted)}"><label><b translate="INVOICE_NUMBER"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="InvoiceNo" style="text-transform:uppercase" ng-model="vm.warranty.invoiceNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InvoiceNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CustPoNo.$invalid && (vm.dataForm.CustPoNo.$dirty || vm.dataForm.$submitted)}"><label><b translate="CUSTOMER_PO_NUMBER"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CustPoNo" style="text-transform:uppercase" ng-model="vm.warranty.customerPoNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CustPoNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.WarrantyFrom.$invalid && (vm.dataForm.WarrantyFrom.$dirty || vm.dataForm.$submitted)}"><label><b translate="WARRANTY_FROM"></b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.warranty.warrantyFrom" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" name="WarrantyFrom" placeholder="YYYY-MM-DD" ng-model="vm.warranty.warrantyFrom" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WarrantyFrom.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.WarrantyTo.$invalid && (vm.dataForm.WarrantyTo.$dirty || vm.dataForm.$submitted)}"><label><b translate="WARRANTY_TO"></b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.warranty.warrantyTo" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" name="WarrantyTo" placeholder="YYYY-MM-DD" ng-model="vm.warranty.warrantyTo" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WarrantyTo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" placeholder="Remarks" ng-model="vm.warranty.remarks">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Details"><p><small><i class="fa fa-info-circle"></i> <span translate="ENTER_THE_EQUIPMENT_DETAILS."></span></small><br><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.selectedEquipment==null && (vm.dataForm.Equipment.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_AN_EQUIPMENT"></b> <i class="fa fa-asterisk req"></i></label> <a href="" ng-click="vm.clearEquipment()" class="btn btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="vm.selectedEquipment!=null"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a><ui-select name="Equipment" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" ng-model="vm.selectedEquipment" on-select="vm.onSelectedEquipmentChanged()"><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.name | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.equipmentList | orderBy:\'code\' | filter: $select.search" refresh="vm.loadEquipmentList($select.search)" refresh-delay="250" minimum-input-length="3"><span ng-bind-html="vm.beautify(i)"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.selectedEquipment==null">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Brand.$invalid && (vm.dataForm.Brand.$dirty || vm.dataForm.$submitted)}"><label><b translate="BRAND"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Brand" placeholder="Brand" style="text-transform:uppercase" ng-model="vm.warranty.brand" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Brand.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Model.$invalid && (vm.dataForm.Model.$dirty || vm.dataForm.$submitted)}"><label><b translate="MODEL"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Model" placeholder="Model" style="text-transform:uppercase" ng-model="vm.warranty.model" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Model.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Name.$invalid && (vm.dataForm.Name.$dirty || vm.dataForm.$submitted)}"><label><b translate="ITEM_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Name" placeholder="Item Name" style="text-transform:uppercase" ng-model="vm.warranty.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Name.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="ITEM_DESCRIPTION"></b></label> <textarea class="form-control" placeholder="Description" ng-model="vm.warranty.description">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/services/warranty/warrantyBatchCreate.html','<form name="vm.dataForm" novalidate=""><div class="form-content"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-9 col-lg-9"><p><small><i class="fa fa-info-circle"></i><span translate="LOAD_INVOICE_FROM_FNBSYSTEM:"></span></small><br><br></p><div class="row"><div class="col-md-9 col-lg-9"><legend style="padding-bottom:10px"><b><span translate="STEP_1:"></span> <span translate="ENTER_THE_INVOICE_NUMBER"></span></b> <i class="fa fa-asterisk req"></i></legend></div></div><div class="row"><div class="col-md-6 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InvNo.$invalid && (vm.dataForm.InvNo.$dirty || vm.dataForm.$submitted)}"><input type="text" class="form-control" name="InvNo" ng-disabled="vm.invoice.invoiceNo!=null || isLoading" ng-model="vm.invoiceNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InvNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><button type="submit" class="btn btn-info btn-with-icon" ng-click="vm.loadInvoice()" ng-if="vm.invoice.invoiceNo==null" ng-disabled="vm.isLoading"><i class="fa fa-search"></i> <span translate="LOAD_INVOICE"></span></button> <button class="btn btn-danger btn-with-icon" ng-if="vm.invoice.invoiceNo!=null" ng-disabled="vm.isLoading" ng-click="vm.resetFields()"><i class="fa fa-print"></i> {{ \'RESET\' | translate}}</button> <span ng-if="vm.isLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="LOADING"></span>...</span></div></div></div><div class="row" ng-if="vm.invoice.invoiceNo!=null"><div class="col-md-12 col-lg-12"><br><br><legend style="padding-bottom:10px"><b translate="STEP_2:_ENTER_SERIAL_NUMBER_FOR_THE_EQUIPMENT_BELOW:"></b> <i class="fa fa-asterisk req"></i></legend></div></div><div class="row" ng-if="vm.invoice.invoiceNo!=null"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="TRANS_REF:"></b></label> <span class="form-control">{{vm.invoice.transRef}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="INVOICE_NO."></b></label> <span class="form-control">{{vm.invoice.invoiceNo}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="INVOICE_DATE"></b></label> <span class="form-control">{{vm.invoice.invoiceDate}}</span></div></div></div><div class="row" ng-if="vm.invoice.invoiceNo!=null"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="DEBTOR_CODE"></b></label> <span class="form-control">{{vm.invoice.debtorCode}}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="DEBTOR_NAME"></b></label> <span class="form-control">{{vm.invoice.debtorName}}</span></div></div></div><div class="row" ng-if="vm.invoice.invoiceNo!=null"><div class="col-md-12 col-lg-12"><br><table class="table table-bordered table-striped table-hover" style="background:#fff"><tr><td>#</td><td><b>{{ \'ITEM_CODE\' | translate }}</b></td><td><b translate="ITEM_DESCRIPTION"></b></td><td align="center"><b>{{ \'QUANTITY\' | translate }}</b></td><td align="center"><b><span translate="SERIAL_NUMBER"></span>(s)</b></td><td></td></tr><tr ng-repeat="item in vm.invoice.invoiceDetails"><td>{{$index+1}})</td><td>{{item.itemCode}}</td><td style="line-height:120%;padding-top:8px;padding-bottom:8px">{{item.itemDescription}}</td><td style="text-align:center">{{item.quantity}}</td><td style="line-height:100% !important;width:250px;padding-top:7px;padding-bottom:7px"><div class="form-group" style="margin-bottom:0px !important" ng-class="{\'has-error\': vm.dataForm.SerialNo_{{$index}}.$invalid && (vm.dataForm.SerialNo_{{$index}}.$dirty || vm.dataForm.$submitted)}"><input type="text" name="SerialNo_{{$index}}" class="form-control" style="width:250px;height:28px;color:#000;font-size:9pt;padding:3px 6px" ng-model="item.serialNo" required=""> <span class="help-block" ng-if="vm.dataForm.$submitted && vm.dataForm[\'SerialNo_\' + $index].$error.required"><small>* {{ \'REQUIRED\' | translate }}</small></span></div></td><td style="text-align:center"><a href="" class="btn btn-xs btn-danger" ng-click="vm.removeItem($index)"><i class="ion ion-close"></i></a></td></tr></table></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div></div><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ui-sref="services.warranty.list" style="margin-right:20px" ng-disabled="vm.lockButtons || vm.isLoading"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-if="vm.invoice.invoiceNo!=null" ng-disabled="vm.lockButtons || vm.isLoading" ng-click="vm.submit()"><i class="ion ion-checkmark"></i> <span translate="CREATE_WARRANTY"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="services.warranty.list" ng-if="vm.invoice.invoiceNo!=null" ng-disabled="vm.lockButtons || vm.isLoading"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/services/warranty/warrantyCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/services/warranty/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ui-sref="services.warranty.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_WARRANTY"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="services.warranty.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/services/warranty/warrantyList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" style="width:auto;min-width:100%"><div><table class="table table-striped" st-persist="WarrantyListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table="" style="font-size:80%"><thead><tr><th colspan="12" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isValidDoc" class="form-control input"><option value="">{{ \'SHOW_ACTIVE_WARRANTIES\' | translate }}</option><option value="0">{{ \'SHOW_EXPIRED_WARRANTIES\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:35px;line-height:35px;padding-left:30px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="services.warranty.create" ng-disabled="vm.isLoading" rms-check-access="services.warranty" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_WARRANTY"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="services.warranty.batchcreate" ng-if="vm.integrationMode==3" ng-disabled="vm.isLoading" rms-check-access="services.warranty" rms-check-access-perm-type="CREATE"><i class="fa fa-th-list"></i> <span translate="BATCH_CREATION"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="warrantyNo">{{ \'WARRANTY_NO\' | translate}}</th><th st-sort="debtorName">{{ \'CUSTOMER_NAME\' | translate}}</th><th st-sort="brand">{{ \'BRAND\' | translate}}</th><th st-sort="model">{{ \'MODEL\' | translate}}</th><th st-sort="equipmentName">{{ \'ITEM_NAME\' | translate}}</th><th>{{ \'INVOICE_NO.\' | translate}}</th><th>{{ \'SERIAL_NO.\' | translate}}</th><th style="line-height:100%"><small>{{ \'WARRANTY\' | translate}}<br>{{ \'FROM\' | translate}}</small></th><th style="line-height:100%"><small>{{ \'WARRANTY\' | translate}}<br>{{ \'TO\' | translate}}</small></th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline"><input st-search="warrantyNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="debtorName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="brand" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="model" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="equipmentName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="invoiceNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="serialNo" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="13" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-if="vm.data.length<=0 && !vm.isLoading"><td colspan="13" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate}}</center></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td nowrap="nowrap">{{item.warrantyNo}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{item.debtorName}}</td><td nowrap="nowrap">{{item.brand}}</td><td nowrap="nowrap">{{item.model}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{item.equipmentName}}</td><td nowrap="nowrap">{{item.invoiceNo}}</td><td nowrap="nowrap">{{item.serialNo | limitTo:20}}<span ng-if="item.serialNo.length>20">...</span></td><td nowrap="nowrap">{{item.warrantyFrom | date:\'dd/MM/yyyy\' }}</td><td nowrap="nowrap">{{item.warrantyTo | date:\'dd/MM/yyyy\' }}</td><td align="center"><a href="" title="Print" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" confirmed-click="vm.printWarrantyLabel(item.id)" ng-confirm-click="Print Warranty Label?" rms-check-access="services.warranty" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="services.warranty.update({id:item.id})" rms-check-access="services.warranty" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Warranty" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteWarranty(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Warranty?" rms-check-access="services.warranty" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="13" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/services/warranty/warrantyUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/services/warranty/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ui-sref="services.warranty.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="services.warranty.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-info btn-with-icon" ng-click="vm.printWarrantyLabel(vm.warranty.id)" ng-disabled="vm.lockButtons"><i class="fa fa-print"></i> <span translate="PRINT_LABEL"></span></a></div></form>');
$templateCache.put('app/pages/services/warrantyclaim/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'CLAIM_NO\' | translate }}</b></label> <span class="form-control" style="color:#00f">{{vm.claim.claimNo || \'AUTONUMBER\'}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Status.$invalid && (vm.dataForm.Status.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'STATUS\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Status" ng-options="u as u.name for u in vm.statusList track by u.id" ng-model="vm.selectedStatus" ng-change="vm.selectedStatusChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Status.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FailureDate.$invalid && (vm.dataForm.FailureDate.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'FAILURE_DATE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.claim.failureDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group" style="margin-bottom:0px;"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="FailureDate" placeholder="YYYY-MM-DD" ng-model="vm.claim.failureDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FailureDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FailureReason.$invalid && (vm.dataForm.FailureReason.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'FAILURE_REASON\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <textarea class="form-control" name="FailureReason" style="color:#333" ng-model="vm.claim.failureReason" required="">\n\t\t\t\t\t\t\t\t</textarea> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FailureReason.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'ACTION_TAKEN\' | translate }}</b></label> <textarea class="form-control" style="color:#333" ng-model="vm.claim.actionTaken">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><hr><div class="row"><div class="col-md-5 col-lg-5"><legend style="height:32.4px;line-height:32.4px"><span translate="WARRANTY_RECORD"></span></legend><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.selectedWarranty==null && (vm.dataForm.Warranty.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SELECT_A_WARRANTY\' | translate}}</b> <i class="fa fa-asterisk req"></i><br><small>({{ \'ENTER_KEYWORD_CUSTOMER_SERIALNO_INVOICENO_TO_SEARCH\' | translate }})</small></label> <a href="" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="vm.clearWarranty()" ng-confirm-click="Clear selected Warranty?" ng-if="vm.selectedWarranty!=null && !vm.noFurtherEdit"><i class="fa fa-times"></i> <span translate="CLEAR"></span></a><ui-select name="Warranty" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-model="vm.selectedWarranty" on-select="vm.selectedWarrantyChanged()"><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.warrantyNo + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.debtorName | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.warrantyList | orderBy:\'code\' | filter: $select.search" refresh="vm.loadWarrantyList($select.search)" refresh-delay="1000" minimum-input-length="2"><span ng-bind-html="vm.beautify(i.warrantyNo, i.debtorName, i.extDetails) | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.selectedWarranty==null">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b>{{ \'CUSTOMER_NAME\' | translate }}</b></label> <span class="form-control" ng-disabled="true">{{ vm.selectedWarranty.debtorName }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'WARRANTY_NO\' | translate }}</b></label> <span class="form-control" ng-disabled="true">{{ vm.selectedWarranty.warrantyNo }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'WARRANTY_INVOICE_NO\' | translate }}</b></label> <span class="form-control" ng-disabled="true">{{ vm.selectedWarranty.invoiceNo }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'WARRANTY_FROM\' | translate }}</b></label> <span class="form-control" ng-disabled="true">{{ vm.selectedWarranty.warrantyFrom | date:\'dd-MMM-yyyy\' }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'WARRANTY_TO\' | translate }}</b></label> <span class="form-control" ng-disabled="true">{{ vm.selectedWarranty.warrantyTo | date:\'dd-MMM-yyyy\' }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'EQUIPMENT_SERIAL_NO.\' | translate }}</b></label> <span class="form-control" ng-disabled="true">{{ vm.selectedWarranty.serialNo }}</span></div></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-5 col-lg-5"><legend style="height:32.4px;line-height:32.4px"><span translate="EQUIPMENT_DETAILS"></span></legend><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b>{{ \'EQUIPMENT_NAME\' | translate }}</b></label> <span class="form-control" ng-disabled="true">{{ vm.selectedEquipment.code }} {{ (vm.selectedEquipment==null ? \'\' : \' | \') }} {{ vm.selectedEquipment.name }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'BRAND\' | translate }}</b></label> <span class="form-control" ng-disabled="true">{{ vm.selectedEquipment.brand }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'MODEL\' | translate }}</b></label> <span class="form-control" ng-disabled="true">{{ vm.selectedEquipment.model }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b>{{ \'DESCRIPTION\' | translate }}</b></label> <textarea class="form-control" ng-model="vm.selectedEquipment.description" ng-disabled="true">\n\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'SPARE_PARTS\' | translate }}"><p><small><i class="fa fa-info-circle"></i> {{ \'MANAGE_THE_SPARE_PARTS_FOR_CLAIM\' | translate }}</small> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddItemModal()"><i class="ion-plus-round"></i> <span translate="SPARE_PART"></span></a><br><br></p><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="CODE_/_DESCRIPTION"></b></th><th style="text-align:right" class="hide-after"><b translate="COST"></b></th><th style="text-align:center" class="hide-after"><b translate="QTY"></b></th><th><b translate="REMARKS"></b></th><th style="width:20px"></th><th style="width:20px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.claim.asWarrantyClaimSpareParts"><td>{{ $index+1 }})</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%"><small>{{ntn.sparePartCode}}</small><br>{{ ntn.sparePartName || \'\' }}</td><td style="text-align:right">{{ ntn.cost | number:2 }}</td><td style="text-align:center">{{ ntn.quantity | number:0 }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{ ntn.remarks || \'-\' }}</td><td><a class="btn btn-primary btn-xs" ng-click="vm.showEditItemModal($index)"><i class="fa fa-pencil"></i></a></td><td><a class="btn btn-danger btn-xs" ng-click="vm.removeItem($index)"><i class="fa fa-trash-o"></i></a></td></tr><tr><td colspan="11" align="center" ng-if="vm.claim.asWarrantyClaimSpareParts.length==0"><br>{{ \'ITEM_LIST_IS_EMPTY.\' | translate }}<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="ClaimItemModal.html"><form name="$mdl.modalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> {{ $mdl.title | translate }} {{ \'SPARE_PART\' | translate }} </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="col-md-4 col-lg-4"> <label><b translate="IMAGE"></b>:</label> <img ngf-src="$mdl.imageLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="padding-left:0px !important;padding-right:0px !important;border:1px solid #000" /> </div> <div class="col-md-4 col-lg-8"> <div class="row"> <div class="col-lg-12"> <label><b translate="SELECT_EITHER_EQUIPMENT_/_SPARE_PART:"></b></label> <div ba-panel-class="horizontal-tabs tabs-panel panel" style="background:#fafafa;margin-bottom:15px"> <uib-tabset active="$mdl.activeTab"> <uib-tab heading="Spare Part"> <div class="form-group" ng-class="{\'has-error\': $mdl.selectedSparePart==null && ($mdl.modalForm.SparePart.$dirty || $mdl.modalForm.$submitted)}"> <label><b translate="SELECT_A_SPARE_PART"></b> <i class="fa fa-asterisk req"></i></label> <a href class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="$mdl.clearSparePart()" ng-confirm-click="Clear selected Spare Part?" ng-if="$mdl.selectedEquipment!=null && $mdl.originalStatus==\'NEW\'"> <i class="fa fa-trash"></i> <span translate="CLEAR"></span> </a> <ui-select name="SparePart" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedSparePart" ng-required="$mdl.activeTab==1" on-select="$mdl.selectedSparePartChanged()" style="background:#fff"> <ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"> <span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.description | uppercase }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.sparePartList | orderBy:\'code\' | filter: $select.search" refresh="$mdl.loadSparePartList($select.search)" refresh-delay="250" minimum-input-length="2"> <span ng-bind-html="$mdl.beautifySparePart(i) | highlight: $select.search"></span> </ui-select-choices> </ui-select> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.selectedSparePart==null">* {{ \'REQUIRED\' | translate }}</span> </div> </uib-tab> </uib-tabset> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Quantity.$invalid && $mdl.modalForm.$submitted}"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="Quantity" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.quantity" min=1 required /> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Quantity.$error.required && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Quantity.$error.number && $mdl.modalForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Quantity.$error.min && $mdl.modalForm.$submitted">* <span translate="MINIMUM_QUANTITY_IS_1"></span> (1)</span> </div> </div> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Cost.$invalid && $mdl.modalForm.$submitted}"> <label><b translate="COST"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="Cost" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.cost" min=0 required /> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Cost.$error.required && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Cost.$error.number && $mdl.modalForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</p> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Cost.$error.min && $mdl.modalForm.$submitted">* <span translate="MINIMUM_IS_0"></span></p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.remarks" /> </div> </div> </div> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButtons || $mdl.isLoading" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING_..."></b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons || $mdl.isLoading"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButtons || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/services/warrantyclaim/warrantyclaimCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/services/warrantyclaim/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="services.warrantyclaim.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="services.warrantyclaim.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/services/warrantyclaim/warrantyclaimList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="WarrantyClaimListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table="" style="font-size:90%"><thead><tr><th colspan="12" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_CLOSED_DOCUMENTS\' | translate }}</option><option value="1">{{ \'SHOW_ALL_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="services.warrantyclaim.create" rms-check-access="services.warrantyclaim" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> {{ \'CREATE_WARRANTY_CLAIM\' | translate }}</a></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="claimNo">{{ \'DOC_NO\' | translate }}</th><th st-sort="claimDate">{{ \'DOC_DATE\' | translate }}</th><th>{{ \'STATUS\' | translate }}</th><th st-sort="debtorName">{{ \'CUSTOMER_NAME\' | translate }}</th><th st-sort="brand">{{ \'BRAND\' | translate }}</th><th st-sort="model">{{ \'MODEL\' | translate }}</th><th st-sort="equipmentName">{{ \'EQUIPMENT_NAME\' | translate }}</th><th st-sort="serialNo">{{ \'SERIAL_NO\' | translate }}</th><th>{{ \'CREATED_BY\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline" colspan="2"><input st-search="claimNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="status" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="debtorName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="equipmentBrand" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="equipmentModel" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="equipmentName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="serialNo" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="12" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-if="vm.data.length==0 && !vm.isLoading"><td colspan="12" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate}}</center></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td>{{item.claimNo}}</td><td>{{item.createdDate || \'-\' | date:\'dd/MM/yyyy\' }}</td><td><b style="color:#00f">{{item.status}}</b></td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.debtorName}}</td><td>{{item.equipmentBrand}}</td><td>{{item.equipmentModel}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.equipmentName | uppercase}}</td><td>{{item.serialNo || \'-\'}}</td><td>{{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \' ...\' : \'\') }}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="services.warrantyclaim.update({id:item.id})" rms-check-access="services.warrantyclaim" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Claim" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteClaim(item.id, item.claimNo)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Warranty Claim?" rms-check-access="services.warrantyclaim" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="12" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/services/warrantyclaim/warrantyclaimUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/services/warrantyclaim/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="services.warrantyclaim.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> {{ \'BACK\' | translate }}</a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> {{ \'SAVE_CHANGES\' | translate }}</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="services.warrantyclaim.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> {{ \'DISCARD_CHANGES\' | translate }}</a> <a href="" class="btn btn-success btn-with-icon" confirmed-click="vm.approveClaim()" ng-confirm-click="Approve this Warranty Claim?" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus!=\'APPROVED\' && vm.originalStatus!=\'DISAPPROVED\' && !vm.isLoading" rms-check-access="services.warrantyclaim" rms-check-access-perm-type="APPROVE"><i class="fa fa-check-circle"></i> {{ \'APPROVE\' | translate }}</a> <a href="" class="btn btn-warning btn-with-icon" confirmed-click="vm.approvePurchaseOrder()" ng-confirm-click="Disapprove this Warranty Claim?" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus!=\'APPROVED\' && vm.originalStatus!=\'DISAPPROVED\' && !vm.isLoading" rms-check-access="services.warrantyclaim" rms-check-access-perm-type="APPROVE"><i class="fa fa-check-circle"></i> {{ \'DISAPPROVE\' | translate }}</a></div></form>');
$templateCache.put('app/pages/routeplan/template/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-12 col-lg-12"><i class="fa fa-info-circle"></i> {{ \'GENERAL_DETAILS_OF_ROUTE_PLAN_TEMPLATE\' | translate }}<p><br></p></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label><b>{{ \'ROUTE_NAME\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" ng-model="vm.template.routeName"></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>{{ \'IS_ACTIVE\' | translate }}?</label><div><toggle ng-model="vm.template.active" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CUSTOMER_LIST\' | translate }}"><div class="row"><div class="col-md-12 col-lg-12"><i class="fa fa-info-circle"></i> {{ \'MANAGE_LIST_OF_CUSTOMER_SEQUENCE\' | translate }}<p><br></p></div></div><div class="row"><div class="col-md-6 col-lg-6"><div style="padding:15px;margin-top:10px;margin-bottom:10px;background:#e0ffe0"><div class="form-group" style="margin-bottom:0px"><label><b translate="CUSTOMER"></b></label><div class="row"><div class="col-md-3 col-lg-3" style="padding-right:0px"><div class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-search"></i></span> <input class="form-control" ng-model="vm.custSearch" ng-disabled="vm.isLoadingDebtor"></div></div><div class="col-md-6 col-lg-6"><select class="form-control" ng-change="vm.selectedDebtorChanged()" ng-disabled="vm.isLoadingDebtor" ng-options="d as (d.name | uppercase) for d in (vm.debtorList | filter:vm.custSearch)" ng-model="vm.selectedDebtor"><option></option></select></div></div></div><div class="form-group" style="margin-bottom:0px"><label><b translate="CUSTOMER_BRANCH"></b></label><div class="row"><div class="col-md-9 col-lg-9"><select class="form-control" ng-change="vm.selectedDebtorBranchChanged()" ng-options="d as d.name for d in vm.debtorBranchList" ng-disabled="vm.debtorBranchList.length==0 || vm.isLoadingDebtor" ng-model="vm.selectedDebtorBranch"></select></div><div class="col-md-3 col-lg-3"><button type="button" class="btn btn-primary btn-with-icon btn-sm" ng-disabled="vm.isLoadingDebtor" ng-click="vm.addDebtor()"><i class="ion-plus-round"></i> {{ \'ADD_CUSTOMER\' | translate }}</button></div></div></div></div></div></div><div class="row"><div class="col-md-9 col-lg-9"><table class="table table-striped" style="border:2px solid #ccc" st-pipe="vm.refreshCustomerList" st-table="vm.template.routePlanTemplateDetails" refresh-table=""><thead><tr class="sortable"><th style="width:60px">#</th><th>{{ \'CUSTOMER_NAME\' | translate }}</th><th>{{ \'CUSTOMER_BRANCH_NAME\' | translate }}</th><th style="width:100px"></th><th style="width:150px"></th><th style="width:90px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.template.routePlanTemplateDetails | orderBy:\'sequence\'"><td>{{$index+1}})</td><td>{{ ntn.debtorName }}</td><td>{{ ntn.debtorBranchName }}</td><td><a class="btn btn-default btn-xs" style="width:100px" ng-if="$index!=0" ng-click="vm.moveDebtorUp(ntn)"><i class="fa fa-arrow-up"></i> {{ \'MOVE_UP\' | translate }}</a></td><td><a class="btn btn-default btn-xs" style="width:100px" ng-if="$index!=(vm.template.routePlanTemplateDetails.length-1)" ng-click="vm.moveDebtorDown(ntn)"><i class="fa fa-arrow-down"></i> {{ \'MOVE_DOWN\' | translate }}</a></td><td><a class="btn btn-danger btn-with-icon btn-xs" style="width:90px" confirmed-click="vm.removeDebtor(ntn.debtorId, ntn.debtorBranchId)" ng-confirm-click="Confirm remove {{ntn.debtorName}} - {{ntn.debtorBranchName}} ?"><i class="fa fa-trash-o"></i> {{ \'REMOVE\' | translate }}</a></td></tr><tr><td colspan="6" align="center" ng-if="vm.template.routePlanTemplateDetails.length==0"><br>{{ \'CUSTOMER_LIST_IS_EMPTY\' | translate }}<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/routeplan/template/rptemplateCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/routeplan/template/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="routeplan.template.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/routeplan/template/rptemplateList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RoutePlanTemplateListing" st-pipe="vm.retrieveData" st-table="vm.templateData" refresh-table=""><thead><tr><th colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="routeplan.template.create" rms-check-access="routeplan.template" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="routeName">{{ \'ROUTE_NAME\' | translate }}</th><th>{{ \'ACTIVE\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.templateData.length==0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.templateData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.routeName}}</td><td><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="routeplan.template.update({id:item.id})" rms-check-access="routeplan.template" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Sensor" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteRecord(item.id, item.templateName)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Record?" rms-check-access="routeplan.template" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px"><span translate="TOTAL_RECORDS:"></span> <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/routeplan/template/rptemplateUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/routeplan/template/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="routeplan.template.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="routeplan.template.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/services/workorders/_form_create.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="#1: {{\'CUSTOMER\' | translate}}" form="vm.form_customer"><form name="vm.form_customer" novalidate=""><p><i class="fa fa-info-circle"></i> <span translate="CUSTOMER_DETAILS"></span><br><br></p><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.selectedDebtor==null && (vm.form_customer.Customer.$dirty || vm.form_customer.$submitted)}"><label><b translate="SELECT_A_CUSTOMER"></b> <i class="fa fa-asterisk req"></i></label> <a href="" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px;margin-left:10px;" confirmed-click="vm.clearDebtor()" ng-confirm-click="Clear selected Customer?" ng-if="vm.selectedDebtor!=null && !vm.noFurtherEdit"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a> <a href="" class="btn btn-xs btn-with-icon btn-primary pull-right" style="margin-bottom:5px" ng-if="!vm.noFurtherEdit" ng-click="vm.showAddCustomerModal()"><i class="fa fa-plus"></i> <span translate="QUICK_CREATE"></span></a><ui-select name="Customer" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" ng-model="vm.selectedDebtor" append-to-body="false" search-enabled="true" on-select="vm.onSelectedDebtorChanged()"><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.name | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.debtorList | filter: $select.search" refresh="vm.loadDebtorList($select.search)" refresh-delay="500" minimum-input-length="2"><span ng-bind-html="vm.beautify(i.code, i.name) | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.form_customer.$submitted && vm.selectedDebtor==null">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label><b translate="ADDITIONAL_CUSTOMER_INFORMATION"></b></label> <input type="text" class="form-control" ng-model="vm.workorder.additionalCustomerInfo" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label><b><u translate="CUSTOMER_SITE_ADDRESS:"></u></b></label></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label><b>{{ \'SELECT_A_SITE\' | translate}}</b>&nbsp;({{ \'OPTIONAL\' | translate}})<br><small>({{ \'SELECT_AN_EXISTING_SITE_OR_QUICK_CREATE_A_NEW_SITE\' | translate }})</small></label> <a href="" class="btn btn-xs btn-with-icon btn-primary pull-right" style="margin-bottom:5px" ng-if="vm.selectedDebtor && !vm.noFurtherEdit" ng-click="vm.showAddBranchModal()"><i class="fa fa-plus"></i> <span translate="QUICK_CREATE"></span></a><select class="form-control" name="CustomerSite" ng-disabled="!vm.selectedDebtor || vm.workorder.status==\'CONFIRMED\'" ng-options="u as u.name for u in vm.debtorBranchList track by u.id" ng-model="vm.selectedDebtorBranch" ng-change="vm.onSelectedDebtorBranchChanged()"><option></option></select></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.form_customer.Zone.$invalid && (vm.form_customer.Zone.$dirty || vm.form_customer.$submitted)}"><label><b><span translate="ZONE"></span>:</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Zone" ng-disabled="!vm.selectedDebtor || vm.workorder.status==\'CONFIRMED\'" ng-options="u as u.name for u in vm.zoneList track by u.id" ng-model="vm.selectedZone" ng-change="vm.onSelectedZoneChanged()" ng-required="vm.workorder.status!=\'CANCELLED\'" --=""><option></option></select><span class="help-block" ng-show="vm.form_customer.$submitted && vm.form_customer.Zone.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="CONTACT_PERSON"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteContactPerson" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="PHONE_NUMBER"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.sitePhone" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="FAX_NUMBER"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteFax" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.form_customer.SiteEmail.$invalid && (vm.form_customer.Status.$dirty || vm.form_customer.$submitted)}"><label><b><span translate="EMAIL"></span>:</b></label> <input type="email" class="form-control" name="SiteEmail" ng-model="vm.workorder.siteEmail" ng-disabled="vm.workorder.status==\'CONFIRMED\'"> <span class="help-block" ng-show="vm.form_customer.$submitted && vm.form_customer.SiteEmail.$error.email">* <span translate="EMAIL_IS_INVALID"></span></span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="ADDRESS_1"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteAddress1" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="ADDRESS_2"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteAddress2" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="ADDRESS_3"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteAddress3" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="STATE"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteState" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="POST_CODE"></span>:</b></label> <input type="text" class="form-control" name="SitePostCode" ng-change="vm.loadZoneList()" ng-model="vm.workorder.sitePostCode" ng-model-options="{ debounce: 800 }" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="COUNTRY"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteCountry" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-lg-12"></div></div></div></div><div class="row"><p>&nbsp;</p></div></form></ba-wizard-step><ba-wizard-step title="#2: {{\'WARRANTY_EQUIPMENT\' | translate}}" form="vm.form_equipment"><form name="vm.form_equipment" novalidate=""><p><i class="fa fa-info-circle"></i> <span translate="WARRANTY_DETAILS_(IF_ANY)."></span><br><br></p><div class="row"><div class="col-md-5 col-lg-5"><legend style="height:32.4px;line-height:32.4px"><span translate="WARRANTY_RECORD"></span> <a href="" class="btn btn-primary btn-with-icon btn-xs pull-right" style="margin:5px;margin-right:0px" ng-click="vm.printWarrantyLabel()" ng-disabled="vm.lockButtons" ng-if="vm.selectedWarranty!=null"><i class="fa fa-print"></i> <span translate="PRINT_LABEL"></span></a></legend><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b>{{ \'SELECT_A_WARRANTY\' | translate}}</b>:<br><small>({{ \'ENTER_KEYWORD_CUSTOMER_SERIALNO_INVOICENO_TO_SEARCH\' | translate }})</small></label> <a href="" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="vm.clearWarranty()" ng-confirm-click="Clear selected Warranty?" ng-if="vm.selectedWarranty!=null && !vm.noFurtherEdit"><i class="fa fa-times"></i> <span translate="CLEAR"></span></a><ui-select name="Warranty" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-model="vm.selectedWarranty" on-select="vm.onSelectedWarrantyChanged()"><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.warrantyNo + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.debtorName | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.warrantyList | orderBy:\'code\' | filter: $select.search" refresh="vm.loadWarrantyList($select.search)" refresh-delay="1000" minimum-input-length="2"><span ng-bind-html="vm.beautify(i.warrantyNo, i.debtorName, i.extDetails) | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="WARRANTY_NO"></b></label> <input type="text" class="form-control" style="text-transform:uppercase" ng-model="vm.workorder.warrantyNo" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="WARRANTY_INVOICE_NO"></b></label> <input type="text" class="form-control" style="text-transform:uppercase" ng-model="vm.workorder.warrantyInvoiceNo" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="WARRANTY_FROM"></b></label><div moment-picker="vm.workorder.warrantyFrom" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" autocomplete="off" ng-readonly="true" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-model="vm.workorder.warrantyFrom"></div></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="WARRANTY_TO"></b></label><div moment-picker="vm.workorder.warrantyTo" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" autocomplete="off" ng-readonly="true" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-model="vm.workorder.warrantyTo"></div><a href="" class="btn btn-default btn-xs pull-right" ng-click="vm.setTwoYear()" style="width:100px">{{ \'2_YEAR\' | translate }}</a> <a href="" class="btn btn-default btn-xs pull-right" ng-click="vm.setOneYear()" style="width:100px;margin-right:5px">{{ \'1_YEAR\' | translate }}</a></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="EQUIPMENT_SERIAL_NO."></b></label> <input type="text" class="form-control" style="text-transform:uppercase" ng-model="vm.workorder.warrantySerialNo" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-5 col-lg-5"><legend style="height:32.4px;line-height:32.4px"><span translate="EQUIPMENT_DETAILS"></span></legend><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.selectedEquipment==null && (vm.form_equipment.Equipment.$dirty || vm.form_equipment.$submitted)}"><label><b translate="SELECT_A_EQUIPMENT"></b> <i class="fa fa-asterisk req"></i></label> <a href="" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="vm.clearEquipment()" ng-confirm-click="Clear selected Equipment?" ng-if="vm.selectedEquipment!=null && !vm.noFurtherEdit"><i class="fa fa-times"></i> <span translate="CLEAR"></span></a><ui-select name="Equipment" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-model="vm.selectedEquipment" on-select="vm.onSelectedEquipmentChanged()"><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.name | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.equipmentList | orderBy:\'code\' | filter: $select.search" refresh="vm.loadEquipmentList($select.search)" refresh-delay="500" minimum-input-length="2"><span ng-bind-html="vm.beautify(i.code, i.name, i.description) | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.form_equipment.$submitted && vm.selectedEquipment==null">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.form_equipment.Brand.$invalid && (vm.form_equipment.Brand.$dirty || vm.form_equipment.$submitted)}"><label><b translate="BRAND"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Brand" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-options="u as u.name for u in vm.brandList track by u.id" ng-model="vm.selectedBrand" ng-change="vm.selectedBrandChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.form_equipment.$submitted && vm.form_equipment.Brand.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.form_equipment.Type.$invalid && (vm.form_equipment.Type.$dirty || vm.form_equipment.$submitted)}"><label><b translate="TYPE"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Type" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-options="u as u.name for u in vm.typeList track by u.id" ng-model="vm.selectedType" ng-change="vm.selectedTypeChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.form_equipment.$submitted && vm.form_equipment.Type.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.form_equipment.Category.$invalid && (vm.form_equipment.Category.$dirty || vm.form_equipment.$submitted)}"><label><b translate="CATEGORY"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Category" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-options="u as u.name for u in vm.categoryList track by u.id" ng-model="vm.selectedCategory" ng-change="vm.selectedCategoryChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.form_equipment.$submitted && vm.form_equipment.Category.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.form_equipment.Model.$invalid && (vm.form_equipment.Model.$dirty || vm.form_equipment.$submitted)}"><label><b translate="MODEL"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Model" style="text-transform:uppercase" ng-model="vm.workorder.eqModel" ng-disabled="vm.workorder.status==\'CONFIRMED\'" required=""> <span class="help-block" ng-show="vm.form_equipment.$submitted && vm.form_equipment.Model.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b translate="DESCRIPTION"></b></label> <textarea class="form-control" ng-model="vm.workorder.eqDescription" ng-disabled="vm.workorder.status==\'CONFIRMED\'">\n\t\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="VOLTAGE_/_GAS_TYPE"></b></label> <input type="text" class="form-control" ng-model="vm.workorder.eqVoltageGasType" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="DIMENSION"></b></label> <input type="text" class="form-control" ng-model="vm.workorder.eqDimension" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div></div></div><div class="row"><p>&nbsp;</p></div></form></ba-wizard-step><ba-wizard-step title="#3: {{\'SERVICE\' | translate}}" form="vm.form_service"><form name="vm.form_service" novalidate=""><p><i class="fa fa-info-circle"></i> <span translate="SERVICE_DETAILS"></span><br><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.form_service.ServiceType.$invalid && (vm.form_service.ServiceType.$dirty || vm.form_service.$submitted)}"><label><b translate="WORK_ORDER_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="ServiceType" ng-options="t as t.description for t in vm.serviceTypes track by t.id" ng-model="vm.selectedServiceType" ng-change="vm.onSelectedServiceTypeChanged()" ng-required="vm.workorder.status!=\'CANCELLED\'"><option></option></select><span class="help-block" ng-show="vm.form_service.$submitted && vm.form_service.ServiceType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.form_service.Symptoms.$invalid && (vm.form_service.Symptoms.$dirty || vm.form_service.$submitted)}"><label><b translate="SYMPTOMS"></b> <i class="fa fa-asterisk req"></i></label> <textarea class="form-control" name="Symptoms" style="color:#333" ng-model="vm.workorder.symptoms" required="">\n\t\t\t\t\t\t\t\t\t</textarea> <span class="help-block" ng-show="vm.form_service.$submitted && vm.form_service.Symptoms.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" style="color:#333" ng-model="vm.workorder.remarks">\n\t\t\t\t\t\t\t\t\t</textarea></div></div></div><hr><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'SELECT_A_SERVICE\' | translate}}</b> ({{\'OPTIONAL\' | translate}})</label> <a href="" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="vm.clearService()" ng-confirm-click="Clear selected Service?" ng-if="vm.selectedService!=null && !vm.noFurtherEdit"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a><select class="form-control" name="ServiceType" ng-options="t as (t.code + \' | \' + t.name) for t in vm.serviceList | orderBy:\'name\'" ng-model="vm.selectedService" ng-change="vm.onSelectedServiceChanged()"><option></option></select></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-lg-6"><table class="table table-striped" style="border:1px solid #ccc;font-size:90%"><thead><tr class="sortable"><th style="width:60px">{{ \'SEQ\' | translate }}</th><th><b>{{ \'CODE\' | translate }}</b></th><th><b>{{ \'DESCRIPTION\' | translate }}</b></th></tr></thead><tbody><tr ng-repeat="ntn in vm.workorder.asServiceWorkProcesses"><td>{{ ntn.sequence }})</td><td>{{ ntn.code || \'\' }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.name || \'-\' }}</td></tr><tr><td colspan="3" align="center" ng-show="vm.workorder.asServiceWorkProcesses.length==0"><br><span translate="PROCESS_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></form></ba-wizard-step><ba-wizard-step title="{{\'SUMMARY\' | translate}}"><p><i class="fa fa-info-circle"></i> {{ \'PLEASE_CONFIRM_THE_INFORMATION_BELOW_BEFORE_PROCEED\' | translate }}<br><br></p><div class="row"><div class="col-md-4 col-lg-4"><div class="panel panel-default"><div class="panel-heading"><b>{{ \'CUSTOMER\' | translate }}</b></div><div class="panel-body"><div class="form-group"><label><b>{{ \'CUSTOMER_NAME\' | translate }}</b>:</label><p>{{vm.workorder.debtorName}}</p></div><div class="form-group"><label><b>{{ \'CUSTOMER_BRANCH\' | translate }}</b>:</label><p>{{vm.workorder.debtorBranchName || \'n/a\'}}</p></div><div class="form-group"><label><b>{{ \'CUSTOMER_SITE_ADDRESS:\' | translate }}</b>:</label><p><i class="fa fa-map-marker"></i>&nbsp;&nbsp; {{vm.workorder.siteAddress1}} {{vm.workorder.siteAddress2}} {{vm.workorder.siteAddress3}} {{vm.workorder.siteState}} {{vm.workorder.sitePostCode}} {{vm.workorder.siteCountry}}</p><p ng-if="vm.workorder.siteContactPerson"><i class="fa fa-user"></i>&nbsp;&nbsp; {{vm.workorder.siteContactPerson || \'-\'}}</p><p ng-if="vm.workorder.sitePhone"><i class="fa fa-phone"></i>&nbsp;&nbsp; {{vm.workorder.sitePhone || \'-\'}}</p><p ng-if="vm.workorder.siteEmail"><i class="fa fa-envelope"></i>&nbsp;&nbsp; {{vm.workorder.siteEmail || \'-\'}}</p></div><div class="form-group"><label><b>{{ \'ZONE\' | translate }}</b>:</label><p>{{vm.workorder.zoneName}}</p></div></div></div></div><div class="col-md-4 col-lg-4"><div class="panel panel-default"><div class="panel-heading"><b>{{ \'EQUIPMENT\' | translate}}</b></div><div class="panel-body"><div class="form-group"><label><b>{{ \'EQUIPMENT_NAME\' | translate }}</b>:</label><p>{{vm.selectedEquipment.name || \'-\'}}</p></div><div class="form-group"><label><b>{{ \'BRAND\' | translate }}</b>:</label><p>{{vm.workorder.eqBrand || \'-\'}}</p></div><div class="form-group"><label><b>{{ \'MODEL\' | translate }}</b>:</label><p>{{vm.workorder.eqModel || \'-\'}}</p></div><div class="form-group"><label><b>{{ \'EQUIPMENT_SERIAL_NO.\' | translate }}</b></label><p>{{vm.workorder.warrantySerialNo || \'-\'}}</p></div></div></div></div><div class="col-md-4 col-lg-4"><div class="panel panel-default"><div class="panel-heading"><b>{{ \'WARRANTY\' | translate}}</b></div><div class="panel-body"><div class="form-group" ng-if="!vm.selectedWarranty"><p><i class="fa fa-ban"></i>&nbsp;&nbsp; {{ \'NO_WARRANTY_SELECTED\' | translate }}</p></div><div class="form-group" ng-if="vm.selectedWarranty"><label><b>{{ \'WARRANTY_NO\' | translate }}</b>:</label><p>{{vm.workorder.warrantyNo || \'-\'}}</p></div><div class="form-group" ng-if="vm.selectedWarranty"><label><b>{{ \'WARRANTY_INVOICE_NO\' | translate }}</b>:</label><p>{{vm.workorder.warrantyInvoiceNo || \'-\'}}</p></div><div class="form-group" ng-if="vm.selectedWarranty"><label><b>{{ \'WARRANTY_FROM\' | translate }} / {{ \'WARRANTY_TO\' | translate }}</b>:</label><p>{{vm.workorder.warrantyFrom || \'-\'}}&nbsp;&nbsp;to&nbsp;&nbsp;{{vm.workorder.warrantyTo || \'-\'}}</p></div></div></div></div><div class="col-md-4 col-lg-4"><div class="panel panel-default"><div class="panel-heading"><b>{{ \'SERVICE\' | translate }}</b></div><div class="panel-body"><div class="form-group"><label><b>{{ \'SYMPTOMS\' | translate }}</b>:</label><p>{{vm.workorder.symptoms}}</p></div><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b>:</label><p>{{vm.workorder.remarks || \'-\'}}</p></div><div class="form-group"><label><b>{{ \'SERVICE\' | translate }}</b>:</label><p ng-if="vm.selectedService">{{vm.workorder.serviceName}}</p><p ng-if="!vm.selectedService"><i class="fa fa-ban"></i>&nbsp;&nbsp; {{ \'NO_SERVICE_SELECTED\' | translate}}</p></div></div></div></div></div></ba-wizard-step></ba-wizard></div></div></div><script type="text/ng-template" id="debtorModal.html"><form name="$mdl.debtorForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="QUICK_CREATE_NEW_CUSTOMER"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b translate="CUSTOMER_CODE"></b> <i class="fa fa-asterisk req" ng-if="!$mdl.autoCode"></i></label> <input type="text" class="form-control" name="CustomerCode" style="background:#fffeed" ng-model="$mdl.item.code" ng-disabled="$mdl.autoCode" ng-required="!$mdl.autoCode"> <input type="checkbox" ng-change="$mdl.autoCodeChanged()" ng-model="$mdl.autoCode" /> {{\'AUTO_GENERATE\' | translate}} <span class="help-block" style="color:#f00" ng-show="$mdl.debtorForm.$submitted && $mdl.debtorForm.CustomerCode.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> <div class="col-md-3 col-lg-3"> <div class="form-group"> <label><b>&nbsp;</b></label> <!-- <input type="checkbox" class="form-control" style="cursor:pointer;width:25px;height:25px" ng-change="$mdl.autoCodeChanged()" ng-model="$mdl.autoCode" /> {{\'AUTO_GENERATE\' | translate}} --> </div> </div> <div class="col-md-3 col-lg-3"> <label translate="STATUS"></label> <div> <toggle ng-model="$mdl.item.active" ng-change="changed()" on="{{ \'ACTIVE\' | translate}}" off="{{ \'INACTIVE\' | translate}}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <label><b translate="CUSTOMER_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CustomerName" style="background:#fffeed" ng-model="$mdl.item.name" required /> <span class="help-block" style="color:#f00" ng-show="$mdl.debtorForm.$submitted && $mdl.debtorForm.CustomerName.$error.required">* {{ \'REQUIRED\' | translate }} </span> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="COMPANY_REGISTRATION_NO."></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.companyRegNo"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="GST_REGISTRATION_NO."></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.gstRegNo"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="ADDRESS_1"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address1"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="ADDRESS_2"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address2"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="ADDRESS_3"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address3"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="STATE"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.state"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="POST_CODE"></span>:</b></label> <input type="text" class="form-control" name="PostCode" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.postCode"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="COUNTRY"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.country"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="CONTACT_PERSON"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.contactPerson1"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="PHONE_NUMBER"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.phone1"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b> <span translate="FAX_NUMBER"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.fax1"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="EMAIL"></span>:</b></label> <input type="email" class="form-control" name="Email" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.email1"> <span class="help-block" style="color:#f00" ng-show="$mdl.debtorForm.$submitted && $mdl.debtorForm.Email.$error.email">* <span translate="EMAIL_IS_INVALID"></span></span> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.isLockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="branchModal.html"><form name="$mdl.branchForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="QUICK_CREATE_NEW_BRANCH_/_SITE"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b translate="BRANCH_CODE"></b> <i class="fa fa-asterisk req" ng-if="!$mdl.autoCode"></i></label> <input type="text" class="form-control" name="BranchCode" style="background:#fffeed" ng-model="$mdl.item.code" ng-disabled="$mdl.autoCode" ng-required="!$mdl.autoCode"> <input type="checkbox" ng-change="$mdl.autoCodeChanged()" ng-model="$mdl.autoCode" /> {{\'AUTO_GENERATE\' | translate}} <span class="help-block" style="color:#f00" ng-show="$mdl.branchForm.$submitted && $mdl.branchForm.CustomerCode.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="BRANCH_NAME"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="text" name="BranchName" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.name" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.branchForm.BranchName.$error.required && $mdl.branchForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="ADDRESS_1"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address1"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="ADDRESS_2"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address2"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="ADDRESS_3"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address3"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="STATE"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.state"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b> <span translate="POST_CODE"></span>:</b></label> <input type="text" class="form-control" name="PostCode" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.postCode"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b> <span translate="COUNTRY"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.country"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b> <span translate="CONTACT_PERSON"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.contactPerson"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="PHONE_NUMBER"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.phone"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="FAX_NUMBER"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.fax"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="EMAIL"></span>:</b></label> <input type="email" class="form-control" name="Email" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.email"> <span class="help-block" style="color:#f00" ng-show="$mdl.branchForm.$submitted && $mdl.branchForm.Email.$error.email">* <span translate="EMAIL_IS_INVALID"></span></span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.remarks"> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.isLockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="uploadMediaModal.html"><form name="$mdl.workOrderMediaForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="UPLOAD_PICTURE_/_VIDEO"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div ba-panel ba-panel-class="horizontal-tabs tabs-panel panel panel-primary"> <uib-tabset active="$mdl.activeTab"> <uib-tab heading="{{ \'UPLOAD\' | translate}}"> <p><small><i class="fa fa-info-circle"></i> <span translate="UPLOAD_IMAGE_/_VIDEO_FILE_FROM_COMPUTER."></span></small> <br /> </p> <div class="row"> <!-- Preview --> <img alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="max-height:400px" ngf-src="$mdl.mediaFile" ng-if="$mdl.mediaFile" /> <video class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="background:#000;max-height:200px" controls ngf-src="$mdl.mediaFile" ng-if="$mdl.mediaFile"> </video> <!-- Preview --> <!-- Empty Placeholder --> <img alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" src="assets/img/empty_placeholder.png" ng-if="!$mdl.mediaFile" /> <!-- Empty Placeholder --> </div> <div class="row"> <div class="col-md-12 col-lg-12" style="padding-top:5px"> <p><small><i class="fa fa-info-circle"></i> <span translate="RECOMMENDED_TO_UPLOAD_A_LANDSCAPE_MEDIA_FILE."></span></small></p> </div> </div> <div class="row"> &nbsp; </div> <div class="row" style="text-align:center" ng-hide="0 < $mdl.uploadProgess"> <a href class="btn btn-primary btn-with-icon" name="file" ng-model="$mdl.mediaFile" ngf-select="$mdl.setUploadMedia($mdl.mediaFile)" ngf-accept="\'image/*,video/*\'" ngf-pattern="\'image/*,video/*\'" ngf-model-invalid="errorFile" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-upload"></i> {{ \'UPLOAD_MEDIA\' | translate }} </a> <a href ng-click="$mdl.mediaFile=null" ng-show="$mdl.mediaFile" class="btn btn-default btn-with-icon" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-remove-circle"></i> {{ \'RESET_MEDIA\' | translate }} </a> </div> <div class="row" ng-if="$mdl.mediaFile && $mdl.uploadProgess!=0"> <div style="width:85%;height:20px;margin:10px auto 5px"> <span translate="MEDIA_UPLOADING..."></span> </div> <div class="progress" style="background:rgba(255,255,255, 0.6);width:85%;height:20px;margin:0px auto"> <div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000"> {{$mdl.uploadProgessPercent | number:0}}% <!--{{ $mdl.uploadProgess }} / {{ $mdl.uploadProgessTotal }}--> </div> <div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="$mdl.uploadProgess" aria-valuemax="$mdl.uploadProgessTotal" style="width: {{$mdl.uploadProgessPercent | number:0}}%"> </div> </div> </div> <div class="row" ng-show="$mdl.lockUploadButton" style="text-align:center;color:#f00"> <i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED."></span> </div> <div class="row"> &nbsp; </div> </uib-tab> <uib-tab heading="Video Player" ng-if="$mdl.item.attachmentType.substring(0,5)==\'video\'"> <p><small><i class="fa fa-info-circle"></i> <span translate="THE_CURRENT_VIDEO_OF_THE_STEP."></span></small> <br /> </p> <!-- Video --> <div class="row"> <iframe ng-src="{{$mdl.item.finalVimeoUrl}}" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" height="200" frameborder=\'0\' class="step-image-card" style="background:#000" webkitAllowFullScreen mozallowfullscreen allowFullScreen ng-if="$mdl.item.attachmentType.substring(0,5)==\'video\' && $mdl.item.isVimeoConverted && $mdl.item.vimeoVideoId!=\'\'"> </iframe> </div> <!-- Video --> <div class="row"> &nbsp; </div> </uib-tab> <uib-tab heading="Image Viewer" ng-if="$mdl.item.attachmentType.substring(0,5)==\'image\'"> <p><small><i class="fa fa-info-circle"></i> <span translate="THE_CURRENT_IMAGE_OF_THE_STEP."></span></small> <br /> </p> <!-- Image --> <div class="row"> <img alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="max-height:400px" ngf-src="$mdl.item.blobLocation" ng-if="$mdl.item.blobLocation!=\'\' && $mdl.item.blobLocation!=null && $mdl.item.attachmentType.substring(0,5)==\'image\'" /> </div> <!-- Image --> <div class="row"> &nbsp; </div> </uib-tab> </uib-tabset> </div> </div> <div class="col-md-6 col-lg-6"> <div class="row"> <div class="form-group col-lg-12"> <label><big><b>{{ \'REMARKS\' | translate }}</b></big></label> <p><small translate="ENTER_SOME_REMARKS_ABOUT_THE_MEDIA."></small></p> <textarea class="form-control" ng-model="$mdl.item.remarks" style="background:#fffeed;height:200px !important" /> </div> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButton"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/services/workorders/_form_update.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="ENTER_THE_WORK_ORDER_DETAILS"></span></small><br><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="WORK_ORDER_NO."></b></label> <span class="form-control" style="color:#00f">{{vm.workorder.workNo || \'AUTONUMBER\'}}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="EXPECTED_DATE"></b></label><div moment-picker="vm.workorder.workDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" name="WorkDate" placeholder="YYYY-MM-DD" ng-model="vm.workorder.workDate"></div></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ServiceType.$invalid && (vm.dataForm.ServiceType.$dirty || vm.dataForm.$submitted)}"><label><b translate="WORK_ORDER_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="ServiceType" ng-options="t as t.description for t in vm.serviceTypes track by t.id" ng-model="vm.selectedServiceType" ng-change="vm.onSelectedServiceTypeChanged()" ng-required="vm.workorder.status!=\'CANCELLED\'"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ServiceType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Status.$invalid && (vm.dataForm.Status.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'STATUS\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Status" ng-options="u as u.name for u in vm.statuses track by u.id" ng-model="vm.selectedStatus" ng-change="vm.onSelectedStatusChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Status.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label><b translate="SYMPTOMS"></b></label> <textarea class="form-control" style="color:#333" ng-model="vm.workorder.symptoms">\n\t\t\t\t\t\t\t\t\t\t</textarea></div></div><div class="col-lg-6"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" style="color:#333" ng-model="vm.workorder.remarks">\n\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-lg-12"><hr></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="QUOTATION_NO."></b></label> <input type="text" class="form-control" ng-disabled="vm.noFurtherEdit" ng-model="vm.workorder.quotationNo"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="QUOTATION_DATE"></b></label><div moment-picker="vm.workorder.quotationDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" placeholder="YYYY-MM-DD" ng-disabled="vm.noFurtherEdit" ng-model="vm.workorder.quotationDate"></div></div></div></div><div class="row" ng-if="vm.isManualChargeInput"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'INVOICE_AMOUNT_BEFORE_TAX\' | translate}} ({{ vm.currencyCode }})</b></label> <input type="number" class="form-control" ng-disabled="vm.noFurtherEdit" ng-model="vm.workorder.amount"></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'GST_AMOUNT\' | translate}} ({{ vm.currencyCode }})</b></label> <input type="number" class="form-control" ng-disabled="vm.noFurtherEdit" ng-model="vm.workorder.gst"></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'INVOICE_AMOUNT_INCL_TAX\' | translate}} ({{ vm.currencyCode }})</b></label> <span class="form-control" ng-disabled="true">{{ (vm.workorder.amount + vm.workorder.gst) | currency:\'\' }}</span></div></div></div><div class="row" ng-if="vm.workorder.invoiceNo!=\'\' && vm.workorder.invoiceNo!=null"><div class="col-md-6 col-lg-6"><div class="form-group"><label>*<span class="text-danger">OLD</span>* <b translate="INVOICE_NO."></b></label> <input type="text" class="form-control" ng-model="vm.workorder.invoiceNo"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="INVOICE_DATE"></b></label><div moment-picker="vm.workorder.invoiceDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" placeholder="YYYY-MM-DD" ng-model="vm.workorder.invoiceDate"></div></div></div></div><div class="row" ng-if="!vm.isManualChargeInput"><div class="col-lg-12"><div class="form-group"><label><b>{{ \'INVOICES\' | translate }}</b>:</label><table class="table table-bordered table-striped"><thead><tr><td><b>{{ \'INVOICE_NO\' | translate }}</b></td><td><b>{{ \'INVOICE_DATE\' | translate }}</b></td><td><b>{{ \'AMOUNT\' | translate }} ({{ vm.currencyCode }})</b></td><td style="width:80px"></td></tr></thead><tbody><tr ng-if="vm.workorder.asServiceWorkInvoices.length==0"><td colspan="4" style="height:100px;line-height:100px"><center>{{ \'CLICK_HERE_TO_ADD_INVOICE\' | translate }}. &nbsp;&nbsp;&nbsp; <a class="btn btn-primary btn-with-icon btn-xs" ng-if="!vm.noFurtherEdit" ng-click="vm.addInvoiceRow()"><i class="fa fa-plus"></i> {{ \'ADD_INVOICE\' | translate}}</a></center></td></tr><tr ng-repeat="ntn in vm.workorder.asServiceWorkInvoices"><td style="width:150px;padding-top:8px;padding-bottom:8px;padding-left:8px;line-height:15px !important;"><div ng-class="{\'has-error\': vm.dataForm.InvoiceNo_{{$index}}.$invalid && (vm.dataForm.InvoiceNo_{{$index}}.$dirty || vm.dataForm.$submitted)}"><input type="text" name="InvoiceNo_{{$index}}" class="form-control" ng-model="ntn.invoiceNo" required=""> <span class="text-danger" ng-show="vm.dataForm.$submitted && vm.dataForm.InvoiceNo_{{$index}}.$error.required">* <small>{{ \'REQUIRED\' | translate }}</small></span></div></td><td style="width:150px;padding-top:8px;padding-bottom:8px"><div moment-picker="ntn.invoiceDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"><input type="text" ng-readonly="true" class="form-control calendar" name="InvoiceDate" placeholder="YYYY-MM-DD" ng-model="ntn.invoiceDate"></div></td><td style="width:150px;padding-top:8px;padding-bottom:8px;padding-left:8px;line-height:15px !important;"><div ng-class="{\'has-error\': vm.dataForm.InvoiceAmount_{{$index}}.$invalid && (vm.dataForm.InvoiceAmount_{{$index}}.$dirty || vm.dataForm.$submitted)}"><input type="number" name="InvoiceAmount_{{$index}}" class="form-control" ng-model="ntn.invoiceAmount" min="0" required=""> <span class="text-danger" ng-show="vm.dataForm.$submitted && vm.dataForm.InvoiceAmount_{{$index}}.$error.required">* <small>{{ \'REQUIRED\' | translate }}</small></span> <span class="text-danger" ng-show="vm.dataForm.$submitted && vm.dataForm.InvoiceAmount_{{$index}}.$error.min">* <small><span translate="MINIMUM_IS_0"></span></small></span> <span class="text-danger" ng-show="vm.dataForm.$submitted && vm.dataForm.InvoiceAmount_{{$index}}.$error.number">* <small>{{ \'ENTER_NUMBERS_ONLY\' | translate }}</small></span></div></td><td style="line-height:45px;"><a class="btn btn-danger btn-with-icon" ng-if="!vm.noFurtherEdit" ng-click="vm.removeInvoiceRow($index)"><i class="ion ion-close"></i> Remove</a></td></tr></tbody><tfoot><tr ng-if="vm.workorder.asServiceWorkInvoices.length!=0"><td colspan="4"><a class="btn btn-primary btn-with-icon btn-xs" ng-if="!vm.noFurtherEdit" ng-click="vm.addInvoiceRow()"><i class="fa fa-plus"></i> {{ \'ADD_INVOICE\' | translate}}</a></td></tr></tfoot></table></div></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-lg-12"><p><b>{{ \'SUMMARY\' | translate}}</b>:</p></div></div><div class="row"><div class="col-lg-10"><uib-accordion><uib-accordion-group is-open="true" panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b>{{ \'CUSTOMER\' | translate }}</b></uib-accordion-heading><uib-accordion-body><br><div class="col-lg-12"><div class="col-lg-12"><div class="form-group"><label><b>{{ \'CUSTOMER_NAME\' | translate }}</b>:</label><p>{{vm.workorder.debtorName}}</p></div><div class="form-group"><label><b>{{ \'CUSTOMER_BRANCH\' | translate }}</b>:</label><p>{{vm.workorder.debtorBranchName || \'n/a\'}}</p></div><div class="form-group"><label><b>{{ \'CUSTOMER_SITE_ADDRESS:\' | translate }}</b>:</label><p><i class="fa fa-map-marker"></i>&nbsp;&nbsp; {{vm.workorder.siteAddress1}} {{vm.workorder.siteAddress2}} {{vm.workorder.siteAddress3}} {{vm.workorder.siteState}} {{vm.workorder.sitePostCode}} {{vm.workorder.siteCountry}}</p><p ng-if="vm.workorder.siteContactPerson"><i class="fa fa-user"></i>&nbsp;&nbsp; {{vm.workorder.siteContactPerson || \'-\'}}</p><p ng-if="vm.workorder.sitePhone"><i class="fa fa-phone"></i>&nbsp;&nbsp; {{vm.workorder.sitePhone || \'-\'}}</p><p ng-if="vm.workorder.siteEmail"><i class="fa fa-envelope"></i>&nbsp;&nbsp; {{vm.workorder.siteEmail || \'-\'}}</p></div><div class="form-group"><label><b>{{ \'ZONE\' | translate }}</b>:</label><p>{{vm.workorder.zoneName}}</p></div></div></div><br>&nbsp;</uib-accordion-body></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b>{{ \'EQUIPMENT\' | translate }}</b></uib-accordion-heading><uib-accordion-body><br><div class="col-lg-12"><div class="col-lg-12"><div class="form-group"><label><b>{{ \'EQUIPMENT_NAME\' | translate }}</b>:</label><p>{{vm.selectedEquipment.name || \'-\'}}</p></div><div class="form-group"><label><b>{{ \'BRAND\' | translate }}</b>:</label><p>{{vm.workorder.eqBrand || \'-\'}}</p></div><div class="form-group"><label><b>{{ \'MODEL\' | translate }}</b>:</label><p>{{vm.workorder.eqModel || \'-\'}}</p></div><div class="form-group"><label><b>{{ \'EQUIPMENT_SERIAL_NO.\' | translate }}</b></label><p>{{vm.workorder.warrantySerialNo || \'-\'}}</p></div></div></div><br>&nbsp;</uib-accordion-body></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b>{{ \'WARRANTY\' | translate }}</b></uib-accordion-heading><uib-accordion-body><br><div class="col-lg-12"><div class="col-lg-12"><div class="form-group" ng-if="!vm.selectedWarranty"><p><i class="fa fa-ban"></i>&nbsp;&nbsp; {{ \'NO_WARRANTY_SELECTED\' | translate }}</p></div><div class="form-group" ng-if="vm.selectedWarranty"><label><b>{{ \'WARRANTY_NO\' | translate }}</b>:</label><p>{{vm.workorder.warrantyNo || \'-\'}}</p></div><div class="form-group" ng-if="vm.selectedWarranty"><label><b>{{ \'WARRANTY_INVOICE_NO\' | translate }}</b>:</label><p>{{vm.workorder.warrantyInvoiceNo || \'-\'}}</p></div><div class="form-group" ng-if="vm.selectedWarranty"><label><b>{{ \'WARRANTY_FROM\' | translate }} / {{ \'WARRANTY_TO\' | translate }}</b>:</label><p>{{vm.workorder.warrantyFrom || \'-\'}}&nbsp;&nbsp;to&nbsp;&nbsp;{{vm.workorder.warrantyTo || \'-\'}}</p></div></div></div><br>&nbsp;</uib-accordion-body></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b>{{ \'SERVICE\' | translate }}</b></uib-accordion-heading><uib-accordion-body><br><div class="col-lg-12"><div class="col-lg-12"><div class="form-group"><label><b>{{ \'SYMPTOMS\' | translate }}</b>:</label><p>{{vm.workorder.symptoms}}</p></div><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b>:</label><p>{{vm.workorder.remarks || \'-\'}}</p></div><div class="form-group"><label><b>{{ \'SERVICE\' | translate }}</b>:</label><p ng-if="vm.selectedService">{{vm.workorder.serviceName}}</p><p ng-if="!vm.selectedService"><i class="fa fa-ban"></i>&nbsp;&nbsp; {{ \'NO_SERVICE_SELECTED\' | translate}}</p></div></div></div><br>&nbsp;</uib-accordion-body></uib-accordion-group><uib-accordion></uib-accordion></uib-accordion></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CUSTOMER\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="CUSTOMER_DETAILS"></span></small><br><br></p><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.selectedDebtor==null && (vm.dataForm.Customer.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_A_CUSTOMER"></b> <i class="fa fa-asterisk req"></i></label> <a href="" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px;margin-left:10px;" confirmed-click="vm.clearDebtor()" ng-confirm-click="Clear selected Customer?" ng-if="vm.selectedDebtor!=null && !vm.noFurtherEdit"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a> <a href="" class="btn btn-xs btn-with-icon btn-primary pull-right" style="margin-bottom:5px" ng-if="!vm.noFurtherEdit" ng-click="vm.showAddCustomerModal()"><i class="fa fa-plus"></i> <span translate="QUICK_CREATE"></span></a><ui-select name="Customer" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" ng-model="vm.selectedDebtor" ng-disabled="vm.workorder.status==\'CONFIRMED\'" append-to-body="false" search-enabled="true" on-select="vm.onSelectedDebtorChanged()"><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.name | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.debtorList | filter: $select.search" refresh="vm.loadDebtorList($select.search)" refresh-delay="250" minimum-input-length="2"><span ng-bind-html="vm.beautify(i.code, i.name) | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.selectedDebtor==null">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label><b translate="ADDITIONAL_CUSTOMER_INFORMATION"></b></label> <input type="text" class="form-control" ng-model="vm.workorder.additionalCustomerInfo" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label><b><u translate="CUSTOMER_SITE_ADDRESS:"></u></b></label></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label><b>{{ \'SELECT_A_SITE\' | translate}}</b>&nbsp;({{ \'OPTIONAL\' | translate}})<br><small translate="SELECT_AN_EXISTING_SITE_OR_QUICK_CREATE_A_NEW_SITE"></small></label> <a href="" class="btn btn-xs btn-with-icon btn-primary pull-right" style="margin-bottom:5px" ng-if="vm.selectedDebtor && !vm.noFurtherEdit" ng-click="vm.showAddBranchModal()"><i class="fa fa-plus"></i> <span translate="QUICK_CREATE"></span></a><select class="form-control" name="CustomerSite" ng-disabled="!vm.selectedDebtor || vm.workorder.status==\'CONFIRMED\'" ng-options="u as u.name for u in vm.debtorBranchList track by u.id" ng-model="vm.selectedDebtorBranch" ng-change="vm.onSelectedDebtorBranchChanged()"><option></option></select></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Zone.$invalid && (vm.dataForm.Zone.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="ZONE"></span>:</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Zone" ng-disabled="!vm.selectedDebtor || vm.workorder.status==\'CONFIRMED\'" ng-options="u as u.name for u in vm.zoneList track by u.id" ng-model="vm.selectedZone" ng-change="vm.onSelectedZoneChanged()" ng-required="vm.workorder.status!=\'CANCELLED\'" --=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Zone.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="CONTACT_PERSON"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteContactPerson" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="PHONE_NUMBER"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.sitePhone" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="FAX_NUMBER"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteFax" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SiteEmail.$invalid && (vm.dataForm.Status.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="EMAIL"></span>:</b></label> <input type="email" class="form-control" name="SiteEmail" ng-model="vm.workorder.siteEmail" ng-disabled="vm.workorder.status==\'CONFIRMED\'"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SiteEmail.$error.email">* <span translate="EMAIL_IS_INVALID"></span></span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="ADDRESS_1"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteAddress1" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="ADDRESS_2"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteAddress2" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="ADDRESS_3"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteAddress3" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="STATE"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteState" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="POST_CODE"></span>:</b></label> <input type="text" class="form-control" name="SitePostCode" ng-change="vm.loadZoneList()" ng-model="vm.workorder.sitePostCode" ng-model-options="{ debounce: 800 }" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b><span translate="COUNTRY"></span>:</b></label> <input type="text" class="form-control" ng-model="vm.workorder.siteCountry" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-lg-12"></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'WARRANTY_EQUIPMENT\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="WARRANTY_DETAILS_(IF_ANY)."></span></small><br><br></p><div class="row"><div class="col-md-5 col-lg-5"><legend style="height:32.4px;line-height:32.4px"><span translate="WARRANTY_RECORD"></span> <a href="" class="btn btn-primary btn-with-icon btn-xs pull-right" style="margin:5px;margin-right:0px" ng-click="vm.printWarrantyLabel()" ng-disabled="vm.lockButtons" ng-if="vm.selectedWarranty!=null"><i class="fa fa-print"></i> <span translate="PRINT_LABEL"></span></a></legend><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b>{{ \'SELECT_A_WARRANTY\' | translate}}</b>:<br><small>({{ \'ENTER_KEYWORD_CUSTOMER_SERIALNO_INVOICENO_TO_SEARCH\' | translate }})</small></label> <a href="" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="vm.clearWarranty()" ng-confirm-click="Clear selected Warranty?" ng-if="vm.selectedWarranty!=null && !vm.noFurtherEdit"><i class="fa fa-times"></i> <span translate="CLEAR"></span></a><ui-select name="Warranty" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-model="vm.selectedWarranty" on-select="vm.onSelectedWarrantyChanged()"><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.warrantyNo + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.debtorName | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.warrantyList | orderBy:\'code\' | filter: $select.search" refresh="vm.loadWarrantyList($select.search)" refresh-delay="1000" minimum-input-length="2"><span ng-bind-html="vm.beautify(i.warrantyNo, i.debtorName, i.extDetails) | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="WARRANTY_NO"></b></label> <input type="text" class="form-control" style="text-transform:uppercase" ng-model="vm.workorder.warrantyNo" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="WARRANTY_INVOICE_NO"></b></label> <input type="text" class="form-control" style="text-transform:uppercase" ng-model="vm.workorder.warrantyInvoiceNo" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="WARRANTY_FROM"></b></label><div moment-picker="vm.workorder.warrantyFrom" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" autocomplete="off" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-model="vm.workorder.warrantyFrom"></div></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="WARRANTY_TO"></b></label><div moment-picker="vm.workorder.warrantyTo" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" autocomplete="off" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-model="vm.workorder.warrantyTo"></div></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="EQUIPMENT_SERIAL_NO."></b></label> <input type="text" class="form-control" style="text-transform:uppercase" ng-model="vm.workorder.warrantySerialNo" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-5 col-lg-5"><legend style="height:32.4px;line-height:32.4px"><span translate="EQUIPMENT_DETAILS"></span> <a href="" class="btn btn-primary btn-with-icon btn-xs pull-right" style="margin:5px;margin-right:0px" ng-click="vm.createWarranty()" ng-disabled="vm.lockButtons" ng-if="vm.selectedDebtor!=null && vm.selectedEquipment!=null && vm.selectedWarranty==null"><i class="fa fa-plus"></i> <span translate="QUICK_CREATE_ASSET_STICKER"></span></a></legend><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.selectedEquipment==null && (vm.dataForm.Equipment.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_A_EQUIPMENT"></b> <i class="fa fa-asterisk req"></i></label> <a href="" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="vm.clearEquipment()" ng-confirm-click="Clear selected Equipment?" ng-if="vm.selectedEquipment!=null && !vm.noFurtherEdit"><i class="fa fa-times"></i> <span translate="CLEAR"></span></a><ui-select name="Equipment" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-model="vm.selectedEquipment" on-select="vm.onSelectedEquipmentChanged()"><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.name | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.equipmentList | orderBy:\'code\' | filter: $select.search" refresh="vm.loadEquipmentList($select.search)" refresh-delay="250" minimum-input-length="2"><span ng-bind-html="vm.beautify(i.code, i.name, i.description) | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.selectedEquipment==null">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Brand.$invalid && (vm.dataForm.Brand.$dirty || vm.dataForm.$submitted)}"><label><b translate="BRAND"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Brand" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-options="u as u.name for u in vm.brandList track by u.id" ng-model="vm.selectedBrand" ng-change="vm.selectedBrandChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Brand.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Type.$invalid && (vm.dataForm.Type.$dirty || vm.dataForm.$submitted)}"><label><b translate="TYPE"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Type" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-options="u as u.name for u in vm.typeList track by u.id" ng-model="vm.selectedType" ng-change="vm.selectedTypeChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Type.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Category.$invalid && (vm.dataForm.Category.$dirty || vm.dataForm.$submitted)}"><label><b translate="CATEGORY"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Category" ng-disabled="vm.workorder.status==\'CONFIRMED\'" ng-options="u as u.name for u in vm.categoryList track by u.id" ng-model="vm.selectedCategory" ng-change="vm.selectedCategoryChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Category.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Model.$invalid && (vm.dataForm.Model.$dirty || vm.dataForm.$submitted)}"><label><b translate="MODEL"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Model" style="text-transform:uppercase" ng-model="vm.workorder.eqModel" ng-disabled="vm.workorder.status==\'CONFIRMED\'" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Model.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b translate="DESCRIPTION"></b></label> <textarea class="form-control" placeholder="Description" ng-model="vm.workorder.eqDescription" ng-disabled="vm.workorder.status==\'CONFIRMED\'">\n\t\t\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="VOLTAGE_/_GAS_TYPE"></b></label> <input type="text" class="form-control" ng-model="vm.workorder.eqVoltageGasType" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="DIMENSION"></b></label> <input type="text" class="form-control" ng-model="vm.workorder.eqDimension" ng-disabled="vm.workorder.status==\'CONFIRMED\'"></div></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'SERVICE\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="SERVICE_DETAILS"></span></small><br><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.selectedService==null && (vm.dataForm.Service.$dirty || vm.dataForm.$submitted)}"><label><h3 style="margin-bottom:0px"><b>{{ \'SELECT_A_SERVICE\' | translate }}</b> <i class="fa fa-asterisk req"></i></h3></label> <a href="" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="vm.clearService()" ng-confirm-click="Clear selected Service?" ng-if="vm.selectedService!=null && !vm.noFurtherEdit"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a><select class="form-control" name="ServiceType" ng-options="t as (t.code + \' | \' + t.name) for t in vm.serviceList | orderBy:\'name\'" ng-model="vm.selectedService" ng-change="vm.onSelectedServiceChanged()"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.selectedService==null">* {{ \'REQUIRED\' | translate }}</span></div></div></div><br><div class="row"><div class="col-lg-12"><div class="panel panel-default" ng-repeat="ntn in vm.workorder.asServiceWorkProcesses"><div class="panel-heading text-primary" style="color:#000;"><b>#{{ ntn.sequence || \'-\' }}: {{ ntn.name || \'-\' }}</b> &nbsp;&nbsp; (<span style="color:#00f"><b>{{ ntn.status || \'-\' | translate | uppercase }}</b></span>) &nbsp;&nbsp; <a class="btn btn-primary btn-with-icon btn-sm" style="margin-top:-7px !important" ng-if="vm.mode==2 && ntn.status!=\'COMPLETED\' && ntn.status!=\'COMPLETED\'" ng-click="vm.showEditProcessModal(ntn)"><i class="fa fa-pencil"></i> {{ \'UPDATE\' | translate }}</a> &nbsp;&nbsp; <a class="btn btn-primary btn-with-icon btn-sm" style="margin-top:-7px !important" ng-if="vm.mode==2 && ntn.sops && ntn.sops.length!=0" ng-click="vm.showSopModal(ntn.sops)"><i class="fa fa-list-ol"></i> {{ \'S.O.P.S\' | translate}}</a></div><div class="panel-body"><br><div class="col-lg-12" ng-if="ntn.remarks"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b>:</label><br>{{ ntn.remarks || \'-\' }}</div><br></div><div class="col-md-4 col-lg-4"><div class="panel panel-default"><div class="panel-heading" style="color:#000;padding-left:15px;padding-right:15px"><b>{{\'TECHNICIAN\' | translate}}</b> &nbsp;&nbsp; <a class="btn btn-success btn-with-icon btn-xs pull-right" style="margin-top:0px !important" ng-if="ntn.id!=null && vm.selectedDebtor && vm.selectedEquipment && vm.mode==2 && ntn.status!=\'COMPLETED\'" ng-click="vm.showTechnicianModal(ntn.id)"><i class="fa fa-users"></i> {{ \'MANAGE\' | translate }}</a> <small ng-if="ntn.id==null" class="text-danger pull-right">{{ \'SAVE_CHANGES_FIRST_BEFORE_ASSIGNMENT\' | translate }}</small></div><div class="panel-body"><div class="row"><div class="col-lg-12"><table class="table table-striped" style="width:100%"><tr><td><b><u>{{ \'NAME\' | translate }}</u></b></td><td><b><u>{{ \'APPOINTMENT_DATE\' | translate }}</u></b></td></tr><tr ng-if="ntn.asServiceWorkTechnicians.length!=0" ng-repeat="technician in ntn.asServiceWorkTechnicians"><td>{{technician.technicianName | uppercase}}</td><td>{{technician.appointmentDate | date:\'dd/MM/yyyy - hh:mma (EEEE)\'}}</td></tr><tr ng-if="ntn.asServiceWorkTechnicians.length==0"><td colspan="10" style="height:100px;line-height:100px;text-align:center">{{ \'TECHNICIAN_LIST_IS_EMPTY.\' | translate }}</td></tr></table><br></div></div></div></div></div><div class="col-md-6 col-lg-6"><div class="panel panel-default"><div class="panel-heading" style="color:#000;padding-left:15px;padding-right:15px"><b>{{ \'TIME_LOG\' | translate }}</b></div><div class="panel-body"><div class="row"><div class="col-lg-12"><table class="table table-striped" style="width:100%"><tr><td><b><u>{{ \'TECHNICIAN\' | translate }}</u></b></td><td><b><u>{{ \'START_TIME\' | translate }} / {{ \'END_TIME\' | translate }} / {{ \'TOTAL_TIME\' | translate }}</u></b></td><td><b><u>{{ \'REMARKS\' | translate }}</u></b></td></tr><tr ng-if="ntn.asServiceWorkTimeLogs.length!=0" ng-repeat="tl in ntn.asServiceWorkTimeLogs"><td>{{tl.technicianName | uppercase}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:150%"><div class="row"><div class="col-lg-12"><i class="fa fa-play text-success"></i> &nbsp;&nbsp; <b>{{tl.startTime | date:\'dd/MM/yyyy hh:mma\'}}</b></div></div><div class="row"><div class="col-lg-12"><i class="fa fa-stop text-danger"></i> &nbsp;&nbsp; <b>{{tl.endTime | date:\'dd/MM/yyyy hh:mma\'}}</b></div></div><div class="row"><div class="col-lg-12"><i class="fa fa-hourglass text-primary"></i> &nbsp;&nbsp; <b ng-if="!tl.totalHour">-</b> <b ng-if="tl.totalHour">{{tl.totalHour}} H {{tl.totalMinute}} M</b></div></div></td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{tl.remarks || \'-\' }}</td></tr><tr ng-if="ntn.asServiceWorkTimeLogs.length==0"><td colspan="10" style="height:100px;line-height:100px;text-align:center">{{ \'TIME_LOG_IS_EMPTY\' | translate }}.</td></tr></table><br></div></div></div></div></div><div class="col-md-2 col-lg-2"><div class="panel panel-default"><div class="panel-heading" style="color:#000;padding-left:15px;padding-right:15px"><b>{{\'CUSTOMER\' | translate}} {{\'SIGNATURE\' | translate}}</b></div><div class="panel-body"><div class="row"><div class="col-lg-12"><div ng-if="ntn.imageLocation==null"><div style="height:150px;padding-left:15px;padding-right:15px;display:table-cell;vertical-align:middle"><div style="text-align:center">{{ \'CUSTOMER_SIGNATURE_NOT_AVAILABLE\' | translate }}.</div></div></div><img ng-if="ntn.imageLocation!=null" src="{{(vm.rootUrl + ntn.imageLocation)}}" fancyboxable="{href:\'{{vm.rootUrl}}{{ntn.imageLocation}}\'}" style="width:100%;cursor:pointer"></div></div></div></div></div></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CHECKLIST\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="CHECKLIST_FOR_THE_SELECTED_SERVICE."></span></small><br><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="SELECT_A_CHECKLIST"></b></label> <a href="" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="vm.clearChecklist()" ng-confirm-click="Clear selected Checklist?" ng-if="vm.selectedChecklist!=null && !vm.noFurtherEdit"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a><ui-select name="Checklist" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" append-to-body="false" ng-disabled="vm.workorder.status==\'CONFIRMED\'" search-enabled="true" ng-model="vm.selectedChecklist" on-select="vm.onSelectedChecklistChanged()"><ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"><span>{{ $select.selected.name | uppercase }}</span></ui-select-match><ui-select-choices repeat="i in vm.checkList | orderBy:\'name\' | filter: $select.search" refresh="vm.loadChecklist($select.search)" refresh-delay="250" minimum-input-length="2"><span ng-bind-html="vm.beautify(i.code, i.name) | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-lg-12"><table class="table table-striped" style="border:1px solid #ccc;font-size:80%"><thead><tr class="sortable"><th style="width:60px"><span translate="SEQ"></span>#</th><th><b translate="GROUP"></b></th><th><b translate="DESCRIPTION"></b></th></tr></thead><tbody><tr ng-repeat="ntn in vm.workorder.asServiceWorkChecklistEntries"><td>{{ ntn.sequence }}</td><td>{{ ntn.group || \'\' }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.description || \'-\' }}</td></tr><tr><td colspan="3" align="center" ng-show="vm.workorder.asServiceWorkChecklistEntries.length==0"><br><span translate="CHECKLIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'LOAN_PARTS\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_EQUIPMENT_OR_SPARE_PARTS_ON_LOAN."></span></small> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddItemModal()"><i class="ion-plus-round"></i><span translate="ADD_EQUIPMENT/SPARE_PART"></span></a><div class="input-group" style="width:250px" ng-if="vm.loan.id"><a href="" class="btn btn-primary input-group-addon" style="padding:3px 10px;font-size:9pt" ui-sref="services.loanrequests.update({id:vm.loan.id})"><i class="fa fa-search"></i> &nbsp;<span translate="LOAN_REQUEST"></span></a> <span class="form-control" style="text-align:left;color:#00f" ng-disabled="true">{{vm.loan.requestNo || \'-\'}}</span></div></p><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:1px solid #ccc;font-size:90%"><thead><tr class="sortable"><th style="width:60px">#</th><th><b>{{ \'WAREHOUSE\' | translate }}</b></th><th><b translate="CODE"></b></th><th><b translate="DESCRIPTION"></b></th><th style="text-align:right" class="hide-after"><b translate="PRICE"></b></th><th style="text-align:right" class="hide-after"><b translate="QTY"></b></th><th style="text-align:right" class="hide-after"><b translate="QTY_RETURNED"></b></th><th></th><th><b translate="SERIAL_NO."></b></th><th><b>{{ \'STATUS\' | translate }}</b></th><th><b>{{ \'REMARKS\' | translate }}</b></th><th style="width:20px"></th><th style="width:20px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.loan.asLoanRequestItems"><td>{{ $index+1 }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{ ntn.storageName || \'\' }}</td><td>{{ ntn.itemCode || \'\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{ ntn.itemDescription || \'\' }}</td><td style="text-align:right">{{ ntn.price | number:2 }}</td><td style="text-align:right">{{ ntn.quantity | number:0 }}</td><td style="text-align:right">{{ ntn.quantityReturn | number:0 }}</td><td></td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{ ntn.serialNo || \'-\' }}</td><td>{{ ntn.status || \'-\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{ ntn.remarks || \'-\' }}</td><td><a class="btn btn-primary btn-xs" ng-click="vm.showEditItemModal($index)"><i class="fa fa-pencil"></i></a></td><td><a class="btn btn-danger btn-xs" confirmed-click="vm.removeItem($index)" ng-confirm-click="Confirm remove this Item?"><i class="fa fa-trash-o"></i></a></td></tr><tr><td colspan="13" align="center" ng-if="vm.loan.asLoanRequestItems.length==0"><br><span translate="ITEM_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'NOTES\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="NOTES_HISTORY_OF_THIS_WORK_ORDER"></span></small><br><br></p><div class="row" ng-if="vm.mode!=1"><div class="col-md-8 col-lg-8"><div class="form-group"><div style="max-height:300px;overflow:auto"><table class="table table-striped" style="border:1px solid #ccc;font-size:85%"><thead><tr class="sortable"><th style="width:180px"><b translate="DATE/TIME"></b></th><th style="width:180px"><b translate="AUTHOR"></b></th><th><b translate="NOTES"></b></th></tr></thead><tbody><tr ng-repeat="ntn in vm.workorder.asServiceWorkNoteLogs"><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.createdDate | date:"dd/MM/yyyy - hh:mma" }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.createdBy | uppercase }}</td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.remarks }}</td></tr><tr><td colspan="3" align="center" ng-show="vm.workorder.asServiceWorkNoteLogs.length==0"><br><span translate="NOTE_LOG_IS_EMPTY"></span><br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row" ng-if="vm.mode!=1"><div class="col-md-6 col-lg-6" style="padding-right:2px"><div class="form-group"><input type="text" class="form-control" placeholder="Type something here..." prevent-enter-key="vm.addNote()" ng-model="vm.note"></div></div><div class="col-md-2 col-lg-2" style="padding-left:2px"><a href="" class="btn btn-primary btn-with-icon" ng-disabled="vm.note==\'\'" ng-click="vm.addNote()"><i class="fa fa-commenting"></i> <span translate="SUBMIT_NOTE"></span></a></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center translate="PLEASE_SAVE_THE_WORK_ORDER_FIRST_BEFORE_ADDING_NOTES."></center></h2></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'MEDIA_PIC_VIDEO\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="MEDIA_FILES_OF_THIS_WORK_ORDER."></span></small> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddMediaModal()" ng-show="vm.mode==2"><i class="ion-plus-round"></i><span translate="ADD_NEW_MEDIA"></span></a><br><br></p><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group"><table class="table table-striped" style="border:1px solid #ccc;font-size:85%"><thead><tr class="sortable"><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="AUTHOR"></b></th><th><b translate="PICTURE/VIDEO"></b></th><th><b>{{ \'REMARKS\' | translate }}</b></th></tr></thead><tbody><tr ng-repeat="ntn in vm.workorder.asServiceWorkMedias"><td>{{ ntn.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td>{{ ntn.createdBy | uppercase }}</td><td><div class="center-cropped step-image-card" style="cursor:pointer;background-image: url(\'{{ntn.finalMediaFile}}\');" fancyboxable="{href:\'{{ntn.finalMediaFile}}\'}" ng-if="ntn.mediaType==\'image\' && ntn.mediaFile!=null && ntn.mediaFile!=\'\'"><span class="fa-stack fa-lg" style="margin-left:250px;margin-top:100px"><i class="fa fa-circle fa-stack-2x fa-inverse"></i> <i class="fa fa-search fa-stack-1x"></i></span></div><iframe ng-src="{{ntn.finalVimeoUrl}}" width="300" height="150" frameborder="0" style="background:#000;margin-top:8px" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" ng-if="ntn.mediaType==\'video\' && ntn.isVimeoConverted!=null && ntn.vimeoVideoId!=null"></iframe><img src="assets/img/empty_placeholder.png" alt="" style="width:300px;height:150px" class="step-image-card" ng-if="ntn.mediaType==\'image\' && (ntn.mediaFile==null || ntn.mediaFile==\'\')"> <img src="assets/img/hourglass_loading.gif" alt="" style="width:300px;height:150px" class="step-image-card" ng-if="ntn.mediaType==\'video\' && !ntn.isVimeoConverted"></td><td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.remarks }}</td></tr><tr><td colspan="4" align="center" ng-show="vm.workorder.asServiceWorkMedias.length==0"><br><span translate="MEDIA_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.workorder.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_WORK_ORDER"></span><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br>{{ \'THERE_IS_NO_CHANGES_YET\' | translate }}<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="SopModal.html"><form name="$mdl.searchSopForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="S.O.P.S"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div style="max-height:500px;overflow-y:scroll"> <table class="table table-striped" style="border:1px solid #ccc" st-table="$mdl.sopList" refresh-table> <thead> <tr> <th style="width:60px">#</th> <th style="width:200px"><b translate="S.O.P_IMAGE"></b></th> <th><b translate="S.O.P_NAME"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="ntn in $mdl.sopList"> <td>{{ $index+1 }})</td> <td style="padding-top:10px;padding-bottom:10px"> <img src="{{ntn.thumbnail || ntn.imageLocation || \'assets/img/sop_empty_placeholder.png\'}}" alt="" style="width:160px;height:85px" /> </td> <td style="padding-top:10px;padding-bottom:10px;line-height:150%;color:#000"> <big><b>{{ ntn.name || \'\' | uppercase }}</b></big> <br /> <div style="width:auto;line-height:100%"> <div class="report-type-tag" ng-repeat="c in ntn.sopCategories" style="width:auto;margin-right:5px;padding:2px 8px;border:1px solid #888"> {{c.name | uppercase}} </div> </div> </td> <td style="padding-top:10px"> <a href class="btn btn-primary editable-table-button btn-sm" ui-sref="sops.cards.view({id:ntn.id})" ng-click="$mdl.cancelModal()"> <span style="color:#fff" translate="GO"></span> &nbsp; <i class="fa fa-arrow-circle-right"></i> </a> </td> </tr> <tr> <td colspan="4" align="center" ng-show="$mdl.sopList.length==0"> <br /> {{ \'NO_RECORD_FOUND\' | translate }} <br />&nbsp; </td> </tr> </tbody> </table> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.isLoading" style="color:#00f;margin-left:30px"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b><span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script><script type="text/ng-template" id="printModal.html"><form name="$mdl.printForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="PRINT_DOCUMENT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <table class="table table-striped" style="border:1px solid #ccc"> <thead> <tr> <th style="width:60px">#</th> <th><b translate="DOCUMENT_DESCRIPTION"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr> <td>1.</td> <td><span translate="WORK_ORDER_SHEET"></span></td> <td> <a href class="btn btn-primary btn-with-icon btn-xs" style="width:90px" ng-click="$mdl.printWorkOrderSheet()" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-printer" ng-if="!$mdl.isLoading"></i> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> {{ \'PRINT\' | translate}} </a> </td> </tr> <tr> <td>2.</td> <td><span translate="SERVICE_REPAIR_FORM"></span></td> <td> <a href class="btn btn-primary btn-with-icon btn-xs" style="width:90px" ng-click="$mdl.printServiceForm()" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-printer" ng-if="!$mdl.isLoading"></i> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> {{ \'PRINT\' | translate}} </a> </td> </tr> <tr> <td>3.</td> <td><span translate="SERVICE_REPORT"></span></td> <td> <a href class="btn btn-primary btn-with-icon btn-xs" style="width:90px" ng-click="$mdl.printServiceReport()" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-printer" ng-if="!$mdl.isLoading"></i> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> {{ \'PRINT\' | translate}} </a> </td> </tr> <tr> <td>4.</td> <td><span translate="INSTALLATION_NOTE"></span></td> <td> <a href class="btn btn-primary btn-with-icon btn-xs" style="width:90px" ng-click="$mdl.printInstallationNote()" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-printer" ng-if="!$mdl.isLoading"></i> <i class="fa fa-spinner fa-spin fa-fw" ng-if="$mdl.isLoading"></i> {{ \'PRINT\' | translate}} </a> </td> </tr> </tbody> </table> <div class="row"> <p>&nbsp;</p> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b> <span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script><script type="text/ng-template" id="debtorModal.html"><form name="$mdl.debtorForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="QUICK_CREATE_NEW_CUSTOMER"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b translate="CUSTOMER_CODE"></b> <i class="fa fa-asterisk req" ng-if="!$mdl.autoCode"></i></label> <input type="text" class="form-control" name="CustomerCode" style="background:#fffeed" ng-model="$mdl.item.code" ng-disabled="$mdl.autoCode" ng-required="!$mdl.autoCode"> <input type="checkbox" ng-change="$mdl.autoCodeChanged()" ng-model="$mdl.autoCode" /> {{\'AUTO_GENERATE\' | translate}} <span class="help-block" style="color:#f00" ng-show="$mdl.debtorForm.$submitted && $mdl.debtorForm.CustomerCode.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> <div class="col-md-3 col-lg-3"> <div class="form-group"> <label><b>&nbsp;</b></label> <!-- <input type="checkbox" class="form-control" style="cursor:pointer;width:25px;height:25px" ng-change="$mdl.autoCodeChanged()" ng-model="$mdl.autoCode" /> {{\'AUTO_GENERATE\' | translate}} --> </div> </div> <div class="col-md-3 col-lg-3"> <label translate="STATUS"></label> <div> <toggle ng-model="$mdl.item.active" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <label><b translate="CUSTOMER_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CustomerName" style="background:#fffeed" ng-model="$mdl.item.name" required /> <span class="help-block" style="color:#f00" ng-show="$mdl.debtorForm.$submitted && $mdl.debtorForm.CustomerName.$error.required">* {{ \'REQUIRED\' | translate }} </span> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="COMPANY_REGISTRATION_NO."></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.companyRegNo"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="GST_REGISTRATION_NO."></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.gstRegNo"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="ADDRESS_1"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address1"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="ADDRESS_2"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address2"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="ADDRESS_3"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address3"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="STATE"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.state"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="POST_CODE"></span>:</b></label> <input type="text" class="form-control" name="PostCode" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.postCode"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="COUNTRY"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.country"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="CONTACT_PERSON"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.contactPerson1"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="PHONE_NUMBER"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.phone1"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b> <span translate="FAX_NUMBER"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.fax1"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="EMAIL"></span>:</b></label> <input type="email" class="form-control" name="Email" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.email1"> <span class="help-block" style="color:#f00" ng-show="$mdl.debtorForm.$submitted && $mdl.debtorForm.Email.$error.email">* <span translate="EMAIL_IS_INVALID"></span></span> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.isLockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="branchModal.html"><form name="$mdl.branchForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="QUICK_CREATE_NEW_BRANCH_/_SITE"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b translate="BRANCH_CODE"></b> <i class="fa fa-asterisk req" ng-if="!$mdl.autoCode"></i></label> <input type="text" class="form-control" name="BranchCode" style="background:#fffeed" ng-model="$mdl.item.code" ng-disabled="$mdl.autoCode" ng-required="!$mdl.autoCode"> <input type="checkbox" ng-change="$mdl.autoCodeChanged()" ng-model="$mdl.autoCode" /> {{\'AUTO_GENERATE\' | translate}} <span class="help-block" style="color:#f00" ng-show="$mdl.branchForm.$submitted && $mdl.branchForm.CustomerCode.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="BRANCH_NAME"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="text" name="BranchName" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.name" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.branchForm.BranchName.$error.required && $mdl.branchForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="ADDRESS_1"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address1"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="ADDRESS_2"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address2"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="ADDRESS_3"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.address3"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="STATE"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.state"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b> <span translate="POST_CODE"></span>:</b></label> <input type="text" class="form-control" name="PostCode" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.postCode"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b> <span translate="COUNTRY"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.country"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b> <span translate="CONTACT_PERSON"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.contactPerson"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="PHONE_NUMBER"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.phone"> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="FAX_NUMBER"></span>:</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.fax"> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b><span translate="EMAIL"></span>:</b></label> <input type="email" class="form-control" name="Email" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.email"> <span class="help-block" style="color:#f00" ng-show="$mdl.branchForm.$submitted && $mdl.branchForm.Email.$error.email">* <span translate="EMAIL_IS_INVALID"></span></span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <input type="text" class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.remarks"> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.isLockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="NewWarrantyModal.html"><form name="$mdl.warrantyForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="QUICK_CREATE_ASSET_STICKER"></span></h3> </div> <div class="modal-body" id="modal-body"> <div ba-panel ba-panel-class="horizontal-tabs tabs-panel panel"> <uib-tabset active="$tabSetStatus.activeTab"> <uib-tab heading="Warranty"> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.warrantyForm.Customer.$invalid && ($mdl.warrantyForm.Customer.$dirty || $mdl.warrantyForm.$submitted)}"> <label><b translate="SELECT_A_CUSTOMER"></b> <i class="fa fa-asterisk req"></i></label> <a href ng-click="$mdl.clearDebtor()" class="btn btn-with-icon btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="$mdl.selectedDebtor!=null"> <i class="fa fa-times"></i> <span translate="CLEAR"></span> </a> <ui-select name="Customer" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" ng-model="$mdl.selectedDebtor" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.onSelectedDebtorChanged()" style="background:#fffeed"> <ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"> <span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.name | uppercase }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.debtorList | filter: $select.search" refresh="$mdl.loadDebtorList($select.search)" refresh-delay="250" minimum-input-length="2"> <span ng-bind-html="$mdl.beautify(i) | highlight: $select.search"></span> </ui-select-choices> </ui-select> <span class="help-block" style="color:#f00" ng-show="$mdl.warrantyForm.$submitted && $mdl.warrantyForm.Customer.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.warrantyForm.SerialNo.$invalid && ($mdl.warrantyForm.SerialNo.$dirty || $mdl.warrantyForm.$submitted)}"> <label><b translate="EQUIPMENT_SERIAL_NO"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SerialNo" placeholder="Serial Number" style="background:#fffeed;text-transform:uppercase" ng-model="$mdl.warranty.serialNo" required> <span class="help-block" style="color:#f00" ng-show="$mdl.warrantyForm.$submitted && $mdl.warrantyForm.SerialNo.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <!-- <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b>Warranty Number</b></label> <span class="form-control" style="background:#fffeed;color:#00f">{{$mdl.warranty.warrantyNo || \'AUTONUMBER\'}}</span> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.warrantyForm.InvoiceNo.$invalid && ($mdl.warrantyForm.InvoiceNo.$dirty || $mdl.warrantyForm.$submitted)}"> <label><b translate="INVOICE_NUMBER"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="InvoiceNo" style="background:#fffeed;text-transform:uppercase" ng-model="$mdl.warranty.invoiceNo" required> <span class="help-block" style="color:#f00" ng-show="$mdl.warrantyForm.$submitted && $mdl.warrantyForm.InvoiceNo.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.warrantyForm.CustPoNo.$invalid && ($mdl.warrantyForm.CustPoNo.$dirty || $mdl.warrantyForm.$submitted)}"> <label><b translate="CUSTOMER_PO_NUMBER"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CustPoNo" style="background:#fffeed;text-transform:uppercase" ng-model="$mdl.warranty.customerPoNo" required> <span class="help-block" style="color:#f00" ng-show="$mdl.warrantyForm.$submitted && $mdl.warrantyForm.CustPoNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></span> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.warrantyForm.WarrantyFrom.$invalid && ($mdl.warrantyForm.WarrantyFrom.$dirty || $mdl.warrantyForm.$submitted)}"> <label><b translate="WARRANTY_FROM"></b> <i class="fa fa-asterisk req"></i></label> <div moment-picker="$mdl.warranty.warrantyFrom" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"> <input type="text" class="form-control calendar" name="WarrantyFrom" placeholder="YYYY-MM-DD" ng-model="$mdl.warranty.warrantyFrom" style="background:#fffeed" required> </div> <span class="help-block" style="color:#f00" ng-show="$mdl.warrantyForm.$submitted && $mdl.warrantyForm.WarrantyFrom.$error.required">* {{ \'REQUIRED\' | translate }}</span></span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.warrantyForm.WarrantyTo.$invalid && ($mdl.warrantyForm.WarrantyTo.$dirty || $mdl.warrantyForm.$submitted)}"> <label><b translate= "WARRANTY_TO"></b> <i class="fa fa-asterisk req"></i></label> <div moment-picker="$mdl.warranty.warrantyTo" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"> <input type="text" class="form-control calendar" name="WarrantyTo" placeholder="YYYY-MM-DD" ng-model="$mdl.warranty.warrantyTo" style="background:#fffeed" required> </div> <span class="help-block" style="color:#f00" ng-show="$mdl.warrantyForm.$submitted && $mdl.warrantyForm.WarrantyTo.$error.required">* {{ \'REQUIRED\' | translate }}</span></span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" placeholder="Remarks" ng-model="$mdl.warranty.remarks" style="background:#fffeed" /> </textarea> </div> </div> </div> --> </uib-tab> <uib-tab heading="Equipment"> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.selectedEquipment==null && ($mdl.warrantyForm.Equipment.$dirty || $mdl.warrantyForm.$submitted)}"> <label><b translate="SELECT_AN_EQUIPMENT"></b> <i class="fa fa-asterisk req"></i></label> <a href ng-click="$mdl.clearEquipment()" class="btn btn-with-icon btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="$mdl.selectedEquipment!=null"> <i class="fa fa-times"></i> <span translate="CLEAR"></span> </a> <ui-select name="Equipment" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedEquipment" on-select="$mdl.onSelectedEquipmentChanged()" style="background:#fffeed"> <ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"> <span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.name | uppercase }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.equipmentList | orderBy:\'code\' | filter: $select.search" refresh="$mdl.loadEquipmentList($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="$mdl.beautify(i)"></span> </ui-select-choices> </ui-select> <span class="help-block" style="color:#f00" ng-show="$mdl.warrantyForm.$submitted && $mdl.selectedEquipment==null">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.warrantyForm.Brand.$invalid && ($mdl.warrantyForm.Brand.$dirty || $mdl.warrantyForm.$submitted)}"> <label><b translate="BRAND"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Brand" placeholder="Brand" style="background:#fffeed;text-transform:uppercase" ng-model="$mdl.warranty.brand" required> <span class="help-block" style="color:#f00" ng-show="$mdl.warrantyForm.$submitted && $mdl.warrantyForm.Brand.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.warrantyForm.Model.$invalid && ($mdl.warrantyForm.Model.$dirty || $mdl.warrantyForm.$submitted)}"> <label><b translate="MODEL"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Model" placeholder="Model" style="background:#fffeed;text-transform:uppercase" ng-model="$mdl.warranty.model" required> <span class="help-block" style="color:#f00" ng-show="$mdl.warrantyForm.$submitted && $mdl.warrantyForm.Model.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.warrantyForm.Name.$invalid && ($mdl.warrantyForm.Name.$dirty || $mdl.warrantyForm.$submitted)}"> <label><b>{{ \'ITEM_NAME\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Name" placeholder="Item Name" style="background:#fffeed;text-transform:uppercase" ng-model="$mdl.warranty.name" required> <span class="help-block" style="color:#f00" ng-show="$mdl.warrantyForm.$submitted && $mdl.warrantyForm.Name.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <label><b translate="ITEM_DESCRIPTION"></b></label> <textarea class="form-control" placeholder="Description" ng-model="$mdl.warranty.description" style="background:#fffeed" /> </textarea> </div> </div> </div> </uib-tab> </uib-tabset> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.isLockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="technicianModal.html"><form name="$mdl.technicianForm" ng-submit="$mdl.loadTechnicians()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="SELECT_TECHNICIAN"></span></h3> </div> <div class="modal-body" id="modal-body"> <div ng-if="$mdl.selectedTechnicianList.length"> <div class="row"> <div class="col-lg-12"> <label><b translate="ASSIGNED_TECHNICIAN_LIST:"></b></label> </div> </div> <div class="row"> <div class="col-lg-12"> <table class="table table-striped" style="font-size:80%;border:1px solid #ccc"> <thead> <tr> <th style="width:60px">#</th> <th><b translate="TECHNICIAN"></b></th> <th><b translate="APPOINTMENT_DATE"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="ntn in $mdl.selectedTechnicianList"> <td>{{ $index+1 }})</td> <td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.technicianName || \'\' | uppercase }}</td> <td>{{ntn.appointmentDate | date:\'dd/MM/yyyy - hh:mma (EEE)\'}}</td> <td> <a href class="btn btn-danger btn-with-icon btn-xs" confirmed-click="$mdl.unassignTechnician(ntn.userId)" ng-confirm-click="Confirm remove this Technician?" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="fa fa-trash"></i> {{ \'REMOVE\' | translate }} </a> </td> </tr> <tr ng-if="$mdl.isLoading1"> <td colspan="4" style="height:100px;line-height:100px"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center> </td> </tr> </tbody> </table> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="row"> <div class="col-lg-12"> <label><span translate="APPOINTMENT_DATE""></span> <i class="fa fa-asterisk req"></i> <span style="color:#f00" ng-show="!$mdl.appointmentDate && $mdl.technicianForm.$submitted"> {{ \'REQUIRED\' | translate }}</span> </label> </div> </div> <div class="row"> <div class="col-lg-4" style="padding-right:0px"> <div moment-picker="$mdl.appointmentDate" format="YYYY-MM-DD hh:mma" max-view="hour" start-view="month" today="true" set-on-select="true" class="input-group"> <span class="input-group-addon"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control" placeholder="Select a Date / Time" style="background:#fffeed" autocomplete="off" ng-model="$mdl.appointmentDate"> </div> </div> <div class="col-lg-3"> <button type="submit" class="btn btn-default btn-with-icon" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="fa fa-users"></i> <span translate="GET_TECHNICIANS"></span> </button> </div> <!-- <div class="col-lg-3"> <a href class="btn btn-info btn-with-icon" ng-disabled="$mdl.lockButton || $mdl.isLoading" ng-click="$mdl.viewDuty(ntn.userId)"> <i class="fa fa-calendar"></i> {{ \'VIEW_DUTY_ROSTER\' | translate }} </a> </div> --> </div> <div class="row"> <div class="col-lg-12"> <table class="table table-striped" style="font-size:80%;border:1px solid #ccc"> <thead> <tr> <th style="width:60px">#</th> <th><b translate="TEAM"></b></th> <th><b translate="TECHNICIAN"></b></th> <th><b translate="SENIORITY"></b></th> <th><b translate="LEADER"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="ntn in $mdl.technicianList"> <td>{{ $index+1 }}</td> <td>{{ ntn.teamName || \'\' }}</td> <td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{ ntn.fullName || \'\' }}</td> <td>{{ ntn.seniority || \'\' }}</td> <td> <i class="fa fa-check" ng-if="ntn.isLeader" style="color:#0f0"></i> <span ng-if="!ntn.isLeader">-</span> </td> <td> <a href class="btn btn-success editable-table-button btn-with-icon btn-xs" confirmed-click="$mdl.confirmModal(ntn)" ng-confirm-click="Confirm selection?" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-checkmark"></i> {{ \'SELECT\' | translate }} </a> </td> </tr> <tr ng-if="$mdl.isLoading"> <td colspan="6" style="height:100px;line-height:100px"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center> </td> </tr> <tr> <td colspan="6" align="center" ng-if="$mdl.technicianList.length==0 && !$mdl.isLoading"> <br /> <span ng-if="$mdl.appointmentDate"><span translate="TECHNICIAN_LIST_IS_EMPTY."></span></span> <span ng-if="!$mdl.appointmentDate" style="color:#f00"><span translate="SELECT_AN_APPOINTMENT_DATE_FIRST."></span></span> <br />&nbsp; </td> </tr> </tbody> </table> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b><span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.confirmModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="processModal.html"><form name="$mdl.processForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="MANAGE_PROCESS"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <h2>{{$mdl.item.name}}</h2> <br />&nbsp; </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group"> <label><b translate="PROCESS_STATUS"></b></label> <select class="form-control" name="Status" style="background:#fffeed" ng-options="u as u.name for u in $mdl.statuses" ng-model="$mdl.selectedStatus" ng-change="$mdl.onSelectedStatusChanged()" required> </select> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" autocomplete="off" style="background:#fffeed" ng-model="$mdl.item.remarks"> </textarea> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.isLockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="PartModal.html"><form name="$mdl.modalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="EQUIPMENT_/_SPARE_PART"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-4"> <label><b translate="IMAGE"></b>:</label> <img ngf-src="$mdl.imageLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="padding-left:0px !important;padding-right:0px !important;border:1px solid #000" /> </div> <div class="col-md-12 col-lg-8"> <div class="row"> <div class="col-lg-12"> <label><b translate="SELECT_EITHER_EQUIPMENT_/_SPARE_PART:"></b></label> <div ba-panel-class="horizontal-tabs tabs-panel panel" style="background:#eee;margin-bottom:15px"> <uib-tabset active="$mdl.activeTab"> <uib-tab heading="Equipment"> <div class="form-group" ng-class="{\'has-error\': $mdl.selectedEquipment==null && ($mdl.modalForm.Equipment.$dirty || $mdl.modalForm.$submitted)}"> <label><b translate="SELECT_A_EQUIPMENT"></b> <i class="fa fa-asterisk req"></i></label> <a href class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="$mdl.clearEquipment()" ng-confirm-click="Clear selected Equipment?" ng-if="$mdl.selectedEquipment!=null && $mdl.originalStatus==\'NEW\'"> <i class="fa fa-trash"></i> <span translate="CLEAR"></span> </a> <ui-select name="Equipment" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedEquipment" ng-required="$mdl.activeTab==0" on-select="$mdl.onSelectedEquipmentChanged()" style="background:#fff"> <ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"> <span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.name | uppercase }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.equipmentList | orderBy:\'code\' | filter: $select.search" refresh="$mdl.loadEquipmentList($select.search)" refresh-delay="250" minimum-input-length="2"> <span ng-bind-html="$mdl.beautifyEquipment(i) | highlight: $select.search"></span> </ui-select-choices> </ui-select> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.selectedEquipment==null">* {{ \'REQUIRED\' | translate }}</span> </div> </uib-tab> <uib-tab heading="Spare Part"> <div class="form-group" ng-class="{\'has-error\': $mdl.selectedSparePart==null && ($mdl.modalForm.SparePart.$dirty || $mdl.modalForm.$submitted)}"> <label><b>Select a Spare Part</b> <i class="fa fa-asterisk req"></i></label> <a href class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="$mdl.clearSparePart()" ng-confirm-click="Clear selected Spare Part?" ng-if="$mdl.selectedEquipment!=null && $mdl.originalStatus==\'NEW\'"> <i class="fa fa-trash"></i> <span translate="CLEAR"></span> </a> <ui-select name="SparePart" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedSparePart" ng-required="$mdl.activeTab==1" on-select="$mdl.onSelectedSparePartChanged()" style="background:#fff"> <ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"> <span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.description | uppercase }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.sparePartList | orderBy:\'code\' | filter: $select.search" refresh="$mdl.loadSparePartList($select.search)" refresh-delay="250" minimum-input-length="2"> <span ng-bind-html="$mdl.beautifySparePart(i) | highlight: $select.search"></span> </ui-select-choices> </ui-select> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.selectedSparePart==null">* {{ \'REQUIRED\' | translate }}</span> </div> </uib-tab> </uib-tabset> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Warehouse.$invalid && $mdl.modalForm.$submitted}"> <label><b translate="SELECT_A_WAREHOUSE"></b> <i class="fa fa-asterisk req"></i></label> <ui-select name="Warehouse" title="-- Select a Warehouse --" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false" ng-model="$mdl.selectedStorage" ng-required="true" on-select="$mdl.onSelectedStorageChanged()" style="background:#FFFCED"> <ui-select-match> <span>{{ $select.selected.code + \'&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;\' + $select.selected.description | uppercase }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.storageList | orderBy:\'code\'"> <span ng-bind-html="$mdl.beautifyWarehouse(i)"></span> </ui-select-choices> </ui-select> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Warehouse.$error.required && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</span> </div> </div> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Status.$invalid && $mdl.modalForm.$submitted}"> <label><b translate="STATUS"></b> <i class="fa fa-asterisk req"></i></label> <select name="Status" class="form-control" style="background:#FFFCED" ng-change="$mdl.onSelectedStatusChanged()" ng-options="i as i.name for i in $mdl.statusList" ng-model="$mdl.selectedStatus" required> <option value="">-- {{ \'Select a Status\' }} --</option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Status.$error.required && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Quantity.$invalid && $mdl.modalForm.$submitted}"> <label> <b>{{ \'QUANTITY\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="Quantity" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.quantity" min=1 required /> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Quantity.$error.required && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Quantity.$error.number && $mdl.modalForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Quantity.$error.min && $mdl.modalForm.$submitted">* <span translate="MINIMUM_QUANTITY_IS_1"></span>(1)</span> </div> </div> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.QuantityReturned.$invalid && $mdl.modalForm.$submitted}"> <label><b translate="QUANTITY_RETURNED"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="QuantityReturned" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.quantityReturn" min=0 required /> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.QuantityReturned.$error.required && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.QuantityReturned.$error.number && $mdl.modalForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.QuantityReturned.$error.min && $mdl.modalForm.$submitted">* <span translate="MINIMUM_IS_0"></span></span> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Price.$invalid && $mdl.modalForm.$submitted}"> <label><b translate="PRICE"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="Price" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.price" min=0 required /> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Price.$error.required && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Price.$error.number && $mdl.modalForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</p> <span class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Price.$error.min && $mdl.modalForm.$submitted">* <span translate=MINIMUM_IS_0></span></p> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b translate="SERIAL_NO."></b></label> <input type="text" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.serialNo" /> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="REMARKS"></b></label> <input type="text" class="form-control" style="background:#FFFCED" ng-model="$mdl.item.remarks" /> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButtons || $mdl.isLoading" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b><span translate="PROCESSING_..."></span></b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons || $mdl.isLoading"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButtons || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="uploadMediaModal.html"><form name="$mdl.workOrderMediaForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="UPLOAD_PICTURE_/_VIDEO"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-6 col-lg-6"> <div ba-panel ba-panel-class="horizontal-tabs tabs-panel panel panel-primary"> <uib-tabset active="$mdl.activeTab"> <uib-tab heading="{{ \'UPLOAD\' | translate}}"> <p><small><i class="fa fa-info-circle"></i> <span translate="UPLOAD_IMAGE_/_VIDEO_FILE_FROM_COMPUTER."></span></small> <br /> </p> <div class="row"> <!-- Preview --> <img alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="max-height:400px" ngf-src="$mdl.mediaFile" ng-if="$mdl.mediaFile" /> <video class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="background:#000;max-height:200px" controls ngf-src="$mdl.mediaFile" ng-if="$mdl.mediaFile"> </video> <!-- Preview --> <!-- Empty Placeholder --> <img alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" src="assets/img/empty_placeholder.png" ng-if="!$mdl.mediaFile" /> <!-- Empty Placeholder --> </div> <div class="row"> <div class="col-md-12 col-lg-12" style="padding-top:5px"> <p><small><i class="fa fa-info-circle"></i> <span translate="RECOMMENDED_TO_UPLOAD_A_LANDSCAPE_MEDIA_FILE."></span></small></p> </div> </div> <div class="row"> &nbsp; </div> <div class="row" style="text-align:center" ng-hide="0 < $mdl.uploadProgess"> <a href class="btn btn-primary btn-with-icon" name="file" ng-model="$mdl.mediaFile" ngf-select="$mdl.setUploadMedia($mdl.mediaFile)" ngf-accept="\'image/*,video/*\'" ngf-pattern="\'image/*,video/*\'" ngf-model-invalid="errorFile" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-upload"></i> {{ \'UPLOAD_MEDIA\' | translate }} </a> <a href ng-click="$mdl.mediaFile=null" ng-show="$mdl.mediaFile" class="btn btn-default btn-with-icon" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-remove-circle"></i> {{ \'RESET_MEDIA\' | translate }} </a> </div> <div class="row" ng-if="$mdl.mediaFile && $mdl.uploadProgess!=0"> <div style="width:85%;height:20px;margin:10px auto 5px"> <span translate="MEDIA_UPLOADING..."></span> </div> <div class="progress" style="background:rgba(255,255,255, 0.6);width:85%;height:20px;margin:0px auto"> <div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000"> {{$mdl.uploadProgessPercent | number:0}}% <!--{{ $mdl.uploadProgess }} / {{ $mdl.uploadProgessTotal }}--> </div> <div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="$mdl.uploadProgess" aria-valuemax="$mdl.uploadProgessTotal" style="width: {{$mdl.uploadProgessPercent | number:0}}%"> </div> </div> </div> <div class="row" ng-show="$mdl.lockUploadButton" style="text-align:center;color:#f00"> <i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED."></span> </div> <div class="row"> &nbsp; </div> </uib-tab> <uib-tab heading="Video Player" ng-if="$mdl.item.attachmentType.substring(0,5)==\'video\'"> <p><small><i class="fa fa-info-circle"></i> <span translate="THE_CURRENT_VIDEO_OF_THE_STEP."></span></small> <br /> </p> <!-- Video --> <div class="row"> <iframe ng-src="{{$mdl.item.finalVimeoUrl}}" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" height="200" frameborder=\'0\' class="step-image-card" style="background:#000" webkitAllowFullScreen mozallowfullscreen allowFullScreen ng-if="$mdl.item.attachmentType.substring(0,5)==\'video\' && $mdl.item.isVimeoConverted && $mdl.item.vimeoVideoId!=\'\'"> </iframe> </div> <!-- Video --> <div class="row"> &nbsp; </div> </uib-tab> <uib-tab heading="Image Viewer" ng-if="$mdl.item.attachmentType.substring(0,5)==\'image\'"> <p><small><i class="fa fa-info-circle"></i> <span translate="THE_CURRENT_IMAGE_OF_THE_STEP."></span></small> <br /> </p> <!-- Image --> <div class="row"> <img alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="max-height:400px" ngf-src="$mdl.item.blobLocation" ng-if="$mdl.item.blobLocation!=\'\' && $mdl.item.blobLocation!=null && $mdl.item.attachmentType.substring(0,5)==\'image\'" /> </div> <!-- Image --> <div class="row"> &nbsp; </div> </uib-tab> </uib-tabset> </div> </div> <div class="col-md-6 col-lg-6"> <div class="row"> <div class="form-group col-lg-12"> <label><big><b>{{ \'REMARKS\' | translate }}</b></big></label> <p><small translate="ENTER_SOME_REMARKS_ABOUT_THE_MEDIA."></small></p> <textarea class="form-control" ng-model="$mdl.item.remarks" style="background:#fffeed;height:200px !important" /> </div> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButton"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/services/workorders/workCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/services/workorders/_form_create.html\'"></section></form>');
$templateCache.put('app/pages/services/workorders/workList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="WorkOrderListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table="" style="font-size:90%"><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isOpenDoc" class="form-control input"><option value="">{{ \'SHOW_OPEN_DOCUMENTS\' | translate }}</option><option value="0">{{ \'SHOW_CLOSED_DOCUMENTS\' | translate }}</option></select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="services.workorders.create" rms-check-access="services.workorders" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> {{ \'ADD_NEW_WORK_ORDER\' | translate }}</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE:"></span><ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="workNo">{{ \'W/O_NO.\' | translate }}</th><th st-sort="workDate">{{ \'W/O_DATE\' | translate }}</th><th>{{ \'STATUS\' | translate }}</th><th st-sort="debtorName">{{ \'CUSTOMER_NAME_/_SITE\' | translate }}</th><th st-sort="equipmentName">{{ \'EQUIPMENT_MODEL_/_SERIAL_NO\' | translate }}</th><th>{{ \'WARRANTY?\' | translate }}</th><th st-sort="serviceName">{{ \'SERVICE\' | translate }}</th><th st-sort="hasCompletedProcess">{{ \'COMPLETED\' | translate }}<br>{{ \'PROCESSES\' | translate }}?</th><th>{{ \'CREATED_BY\' | translate }}</th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline" colspan="2"><input st-search="workNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="status" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="debtorName" class="form-control input input-sm"></th><th class="form-inline"><input st-search="equipmentName" class="form-control input input-sm"></th><th></th><th class="form-inline"><input st-search="serviceName" class="form-control input input-sm"></th><th></th><th class="form-inline"><input st-search="userName" class="form-control input input-sm" style="width:120px"></th><th></th></tr></thead><tbody><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-if="vm.data.length==0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate}}</center></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td>{{item.workNo}}</td><td>{{item.createdDate || \'-\' | date:\'dd/MM/yyyy\' }}</td><td><b style="color:#00f">{{item.status}}</b></td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.debtorName}} <span ng-if="item.debtorBranchName!=null && item.debtorBranchName!=\'\'"><br>( {{item.debtorBranchName}} )</span></td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.equipmentName | uppercase}} <span ng-if="item.warrantySerialNo!=null && item.warrantySerialNo!=\'\'"><br>( {{ \'S/N:\' | translate }} <b>{{ item.warrantySerialNo || \'-\'}}</b> )</span></td><td>{{ (item.hasWarranty?\'Yes\':\'No\') || \'No\'}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.serviceName || \'-\'}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%"><i ng-if="item.hasCompletedProcess" class="fa fa-suitcase" style="font-size:150%"></i> <i ng-if="item.hasCompletedProcess" class="fa fa-check text-success" style="font-size:150%"></i></td><td>{{(item.createdBy | uppercase | limitTo:15) + (item.createdBy.length > 15 ? \' ...\' : \'\') }}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="services.workorders.update({id:item.id})" rms-check-access="services.workorders" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="3" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/services/workorders/workUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/services/workorders/_form_update.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" style="margin-right:20px" ui-sref="services.workorders.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-if="!vm.noFurtherEdit || vm.hasApproveAccess" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="services.workorders.list" ng-if="!vm.noFurtherEdit || vm.hasApproveAccess" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-primary btn-with-icon" style="margin-left:20px" ng-disabled="vm.lockButtons" ng-click="vm.showPrintDialog()" rms-check-access="services.workorders" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT_DOCUMENT"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/checklistentries/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Group.$invalid && (vm.dataForm.Group.$dirty || vm.dataForm.$submitted)}"><label><b translate="GROUP"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Group" ng-model="vm.entry.group" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Group.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-model="vm.entry.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/checklistentries/checklistentryCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/checklistentries/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_CHECKLIST_ENTRY"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.checklistentries.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/checklistentries/checklistentryList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.entryData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Entry" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.checklistentries.create" rms-check-access="serviceconfigs.checklistentries" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_ENTRY"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="group"><span translate="GROUP"></span></th><th st-sort="description">{{ \'DESCRIPTION\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.entryData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.entryData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.group}}</td><td>{{item.description}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.checklistentries.update({id:item.id})" rms-check-access="serviceconfigs.checklistentries" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Entry" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteEntry(item.id, item.description)" ng-confirm-click="Confirm delete this Entry?" rms-check-access="serviceconfigs.checklistentries" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/checklistentries/checklistentryUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/checklistentries/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.checklistentries.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.checklistentries.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/checklists/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ChecklistCode.$invalid && (vm.dataForm.ChecklistCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="CHECKLIST_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ChecklistCode" ng-model="vm.checklist.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ChecklistCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ChecklistName.$invalid && (vm.dataForm.ChecklistName.$dirty || vm.dataForm.$submitted)}"><label><b translate="CHECKLIST_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ChecklistName" ng-model="vm.checklist.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ChecklistName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ServiceType.$invalid && (vm.dataForm.ServiceType.$dirty || vm.dataForm.$submitted)}"><label><b translate="FOR_SERVICE_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="ServiceType" ng-options="u as u.name for u in vm.serviceTypes track by u.id" ng-model="vm.selectedServiceType" ng-change="vm.selectedServiceTypeChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ServiceType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.EquipmentCategory.$invalid && (vm.dataForm.EquipmentCategory.$dirty || vm.dataForm.$submitted)}"><label><b translate="EQUIPMENT_CATEGORY"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="EquipmentCategory" ng-options="u as u.name for u in vm.categories track by u.id" ng-model="vm.selectedCategory" ng-change="vm.selectedCategoryChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.EquipmentCategory.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Entries"><p><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_ENTRIES_FOR_THIS_CHECKLIST"></span>.</small> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddEntryModal()"><i class="ion-plus-round"></i><span translate="ADD_ENTRY"></span></a><br><br></p><script type="text/ng-template" id="EntryModal.html"><form name="$mdl.modalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="ADD_ENTRY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SELECT_A_ENTRY">:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select name="Entry" ng-model="$mdl.selectedEntry" title="Search for Entries..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedEntryChanged()"> <ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"> <span>{{ $select.selected.group + \' &nbsp;|&nbsp; \' + $select.selected.description }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.entries | filter: $select.search" refresh="$mdl.loadEntries($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="$mdl.beautify(i.group, i.description) | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.selectedEntry==null && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton || $mdl.isLoading" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b> <span translate="PROCESSING"></span> ...</b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="GROUP"></b></th><th><b translate="DESCRIPTION"></b></th><th style="text-align:center"><b translate="SEQUENCE"></b></th><th style="width:20px"></th><th style="width:20px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.checklist.asChecklistEntries"><td>{{ $index+1 }}</td><td>{{ ntn.group || \'\' }}</td><td>{{ ntn.description || \'\' }}</td><td style="text-align:center">{{ ntn.sequence || \'\' }}</td><td><a class="btn btn-primary editable-table-button btn-xs" ng-if="$index!=0" ng-click="vm.moveUp($index)"><i class="ion ion-chevron-up"></i></a></td><td><a class="btn btn-primary editable-table-button btn-xs" ng-if="($index+1)!=vm.checklist.asChecklistEntries.length" ng-click="vm.moveDown($index)"><i class="ion ion-chevron-down"></i></a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeEntry($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="7" align="center" ng-if="vm.checklist.asChecklistEntries.length==0"><br><span translate="ENTRY_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/checklists/checklistCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/checklists/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_CHECKLIST"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.checklists.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/checklists/checklistList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.checklistData" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Checklist" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.checklists.create" rms-check-access="serviceconfigs.checklists" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_CHECKLIST"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:150px" st-sort="name"><span translate="CHECKLIST_CODE"></span></th><th st-sort="name"><span translate="CHECKLIST_NAME"></span></th><th st-sort="typeName"><span translate="SERVICE_TYPE"></span></th><th st-sort="categoryName"><span translate="EQUIPMENT_CATEGORY"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable" ng-if="vm.checklistData.length>0"><th colspan="3"></th><th class="form-inline" style="padding-top:3px;padding-bottom:3px;"><select st-search="typeName" style="width:100%"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.checklistDataFull | unique:\'typeName\'" value="{{s.typeName | uppercase}}">{{s.typeName | uppercase}}</option></select></th><th class="form-inline" style="padding-top:3px;padding-bottom:3px;"><select st-search="categoryName" style="width:100%"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.checklistDataFull | unique:\'categoryName\'" value="{{s.categoryName | uppercase}}">{{s.categoryName | uppercase}}</option></select></th><th colspan="2"></th></tr></thead><tbody><tr ng-if="vm.checklistData.length<=0 && !vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.checklistData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td>{{item.typeName}}</td><td>{{item.categoryName}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.checklists.update({id:item.id})" rms-check-access="serviceconfigs.checklists" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Checklist" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteChecklist(item.id, item.name)" ng-confirm-click="Confirm delete this Checklist?" rms-check-access="serviceconfigs.checklists" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/checklists/checklistUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/checklists/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.checklists.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.checklists.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/loanstatuses/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-6 col-lg-6"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StatusName.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="LOAN_STATUS"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="StatusName" ng-model="vm.loanstatus.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StatusName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><br><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.loanstatus.defaultStatus" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b translate="IS_DEFAULT_STATUS">?</b></big><br><small translate="THE_DEFAULT_STATUS_SELECTED_WHEN_CREATING_A_NEW_LOAN_REQUEST">.</small></label></div></td></tr></table></div></div><br><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.loanstatus.documentClosed" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b translate="IS_DOCUMENT_CLOSED?"></b></big><br><small translate="THIS_STATUS_INDICATES_THE_DOCUMENT_IS_CLOSED."></small></label></div></td></tr></table></div></div><br><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.loanstatus.noFurtherEdit" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b translate="NO_FURTHER_EDIT">?</b></big><br><small translate="SYSTEM_WILL_PREVENT_FURTHER_CHANGES_TO_THE_DOCUMENT">.</small></label></div></td></tr></table></div></div><br><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.loanstatus.loanItemStateCheck" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b translate="CHECK_LOAN_ITEM_STATUSES">?</b></big><br><small><span translate="SYSTEM_WILL_CHECK_THE_STATUSES_OF_THE_LOAN_ITEMS,_AND_IF_THE_SELECTED_STATUSES"></span><br><span translate="IS_DETECTED,_OPERATION_WILL_ABORT"></span></small></label></div></td></tr></table></div></div><br><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.loanstatus.loanItemQuantityCheck" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b translate="CHECK_LOAN_ITEM_QUANTITIES">?</b></big><br><small translate="SYSTEM_WILL_CHECK_THE_LOAN_QUANTITY_AND_RETURNED_QUANTITY_OF_THE_LOAN_ITEMS">,<br><span translate="IF_BOTH_QUANTITIES_DO_NOT_MATCH,_OPERATION_WILL_ABORT"></span></small></label></div></td></tr></table></div></div><br><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.loanstatus.triggerRemoveResv" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b translate="TRIGGER_REMOVE_RESERVATION">?</b></big><br><small translate="UPON_SELECTING_THIS_STATUS,_SYSTEM_WILL_REMOVE_THE_RESERVATION."></small></label></div></td></tr></table></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-5 col-lg-5" ng-if="vm.loanstatus.loanItemStateCheck"><div class="row"><div class="col-md-10 col-lg-10"><br><br><legend style="height:32.4px;line-height:32.4px"><span translate="LOAN_ITEM_STATUSES"></span> <a href="" class="btn btn-primary btn-with-icon btn-xs" style="margin:5px" ng-click="vm.showAddLoanItemStatusModal()"><i class="ion-plus-round"></i><span translate="ADD_MORE"></span></a></legend><p><i class="fa fa-info-circle"></i> <small>[<b translate="CHECK_LOAN_ITEM_STATUSES"></b>] <span translate="OPTION_IS"></span> <b translate="YES"></b>, <span translate="SELECT_THE_LOAN_ITEM_STATUSES_FOR_SYSTEM_CHECKING"></span></small></p><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="LOAN_ITEM_STATUS"></b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.loanstatus.asLoanStateCheckLoanItemStates"><td>{{ $index+1 }}</td><td>{{ ntn.name || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeLoanItemStatus($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr ng-if="vm.loanstatus.asLoanStateCheckLoanItemStates.length==0"><td colspan="3" align="center"><br><span translate="LOAN_ITEM_STATUS_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="LoanItemStatusModal.html"><form name="$mdl.statusForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="ADD_LOAN_STATUS"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SELECT_A_LOAN_ITEM_STATUS"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select title="Select or Search for Status..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedStatus" on-select="$mdl.selectedStatusChanged()"> <ui-select-match placeholder="Search for Status..."> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.statuses | filter: $select.search" minimum-input-length="2"> <span ng-bind-html="i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.selectedStatus==null && $mdl.statusForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING"> ...</b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/serviceconfigs/loanstatuses/loanstatusCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/loanstatuses/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_LOAN_STATUS"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.loanstatuses.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/loanstatuses/loanstatusList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.statusData" refresh-table=""><thead><tr><th colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Entry" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.loanstatuses.create" rms-check-access="serviceconfigs.loanstatuses" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_STATUS"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="name"><span translate="LOAN_STATUS"></span></th><th translate="DEFAULT_STATUS">?</th><th translate="TRIGGER_REMOVE_RESERVATION">?</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.statusData.length<=0 && !vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.statusData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td>{{ (item.defaultStatus?\'Yes\':\'No\') }}</td><td>{{ (item.triggerRemoveResv?\'Yes\':\'No\') }}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.loanstatuses.update({id:item.id})" rms-check-access="serviceconfigs.loanstatuses" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Entry" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteEntry(item.id, item.description)" ng-confirm-click="Confirm delete this Entry?" rms-check-access="serviceconfigs.loanstatuses" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/loanstatuses/loanstatusUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/loanstatuses/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.loanstatuses.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.loanstatuses.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/pnsettings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.User.$invalid && (vm.dataForm.User.$dirty || vm.dataForm.$submitted)}"><label><b translate="NOTIFY_USER"></b></label> <a href="" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="vm.clearUser()" ng-confirm-click="Clear selected User?" ng-if="vm.selectedUser!=null"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a><ui-select name="User" class="btn-group bootstrap-select form-control" title="Search for User..." append-to-body="false" search-enabled="true" ng-model="vm.selectedUser" on-select="vm.selectedUserChanged()"><ui-select-match placeholder="-- Select a User --"><span style="color:#000 !important">{{ $select.selected.loginId | uppercase }}</span></ui-select-match><ui-select-choices repeat="user in vm.userList | filter: $select.search"><span ng-bind-html="user.loginId | uppercase | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Module.$invalid && (vm.dataForm.Module.$dirty || vm.dataForm.$submitted)}"><label><b translate="MODULE_EVENT"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Module" ng-options="m as m.name for m in vm.moduleList" ng-change="vm.selectedModuleChanged()" ng-model="vm.selectedModule" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Module.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.notif.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b translate="IS_ACTIVE">?</b></big></label></div></td></tr></table></div></div><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.notif.notifyCSO" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b><span translate="NOTIFY_THE_C.S.O"></span>?</b></big><br><small><span translate="PUSH_NOTIFICATION_WILL_BE_SENT_TO_THE_CUSTOMER_SERVICE_OFFICER"></span>.</small></label></div></td></tr></table></div></div><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.notif.notifyCustomer" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b><span translate="NOTIFY_THE_CUSTOMER"></span>?</b></big><br><small><span translate="PUSH_NOTIFICATION_WILL_BE_SENT_TO_THE_CUSTOMER"></span>.</small></label></div></td></tr></table></div></div><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.notif.notifyTechnician" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b><span translate="NOTIFY_THE_TECHNICIAN"></span>?</b></big><br><small><span translate="PUSH_NOTIFICATION_WILL_BE_SENT_TO_THE_TECHNICIAN"></span>.</small></label></div></td></tr></table></div></div><br><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/pnsettings/pnsettingCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/pnsettings/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.pnsettings.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/pnsettings/pnsettingList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.notifData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Template" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.pnsettings.create" rms-check-access="serviceconfigs.pnsettings" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="module"><span translate="MODULE_EVENT"></span></th><th st-sort="user"><span translate="USER"></span></th><th class="hide-after" style="text-align:center"><span translate="NOTIFY"></span><br><span translate="C.S.O"></span></th><th class="hide-after" style="text-align:center"><span translate="NOTIFY"></span><br><span translate="CUSTOMER"></span></th><th class="hide-after" style="text-align:center"><span translate="NOTIFY"></span><br><span translate="TECHNICIAN"></span></th><th class="hide-after" style="text-align:center"><span translate="IS_ACTIVE"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.notifData.length<=0"><td colspan="9">{{ \'NO_RECORD_FOUND\' | translate }}.</td></tr><tr ng-repeat="item in vm.notifData"><td>{{ vm.startIndex+1+$index }})</td><td>{{ item.module }}</td><td>{{ item.user | uppercase }}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.notifyCSO" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.notifyCSO" style="color:#f00"></i></td><td style="text-align:center"><i class="fa fa-check" ng-show="item.notifyCustomer" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.notifyCustomer" style="color:#f00"></i></td><td style="text-align:center"><i class="fa fa-check" ng-show="item.notifyTechnician" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.notifyTechnician" style="color:#f00"></i></td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.pnsettings.update({id:item.id})" rms-check-access="serviceconfigs.pnsettings" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Notification" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteNotification(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Push Notification?" rms-check-access="serviceconfigs.pnsettings" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/pnsettings/pnsettingUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/pnsettings/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.pnsettings.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.pnsettings.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/processes/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ProcessCode.$invalid && (vm.dataForm.ProcessCode.$dirty || vm.dataForm.$submitted)}"><label for="ProcessCode"><b translate="PROCESS_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ProcessCode" placeholder="Process Code" ng-model="vm.process.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ProcessCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ProcessName.$invalid && (vm.dataForm.ProcessName.$dirty || vm.dataForm.$submitted)}"><label for="ProcessName"><b translate="PROCESS_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ProcessName" placeholder="Process Name" ng-model="vm.process.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ProcessName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/processes/processCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/processes/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_PROCESS"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.processes.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/processes/processList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.processData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Process" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.processes.create" rms-check-access="serviceconfigs.processes" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_PROCESS"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="serviceconfigs.processes.import" rms-check-access="serviceconfigs.processes" rms-check-access-perm-type="CREATE"><i class="fa fa-download"></i> <span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:150px" st-sort="name"><span translate="PROCESS_CODE"></span></th><th st-sort="name"><span translate="PROCESS_NAME"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.processData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.processData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.processes.update({id:item.id})" rms-check-access="serviceconfigs.processes" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Process" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteProcess(item.id, item.name)" ng-confirm-click="Confirm delete this process?" rms-check-access="serviceconfigs.processes" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/processes/processUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/processes/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.processes.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.processes.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/rostertypes/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TypeCode.$invalid && (vm.dataForm.TypeCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="ROSTER_TYPE_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="TypeCode" placeholder="Type Code" ng-model="vm.rosterType.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TypeCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TypeDesc.$invalid && (vm.dataForm.TypeDesc.$dirty || vm.dataForm.$submitted)}"><label><b translate="ROSTER_TYPE_DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="TypeDesc" placeholder="Type Name" ng-model="vm.rosterType.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TypeDesc.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ColorCode.$invalid && (vm.dataForm.ColorCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="COLOR_CODE_(HEX)"></b> <i class="fa fa-asterisk req"></i></label><div class="row"><div class="col-md-4 col-lg-4"><span class="form-control" style="background:{{vm.rosterType.colorCodeHex}}"></span></div><div class="col-md-8 col-lg-8" style="padding-left:0px"><input class="form-control" type="text" colorpicker="" colorpicker-close-on-select="" colorpicker-size="200" colorpicker-position="right" ng-model="vm.rosterType.colorCodeHex"></div></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ColorCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/rostertypes/rostertypeCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/rostertypes/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_ROSTER_TYPES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.rostertypes.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/rostertypes/rostertypeList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.rosterTypeData" refresh-table=""><thead><tr><th colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Roster Type" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.rostertypes.create" rms-check-access="serviceconfigs.rostertypes" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_ROSTER_TYPE"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:150px" st-sort="name"><span translate="TYPE_CODE"></span></th><th st-sort="name"><span translate="TYPE_NAME"></span></th><th st-sort="name"><span translate="COLOR_CODE"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.rosterTypeData.length<=0 && !vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.rosterTypeData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.description}}</td><td><div style="width:80px;height:25px;background:{{item.colorCodeHex}};text-align:center;line-height:25px;margin-top:6px;font-family:courier;border:2px solid #333"></div></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.rostertypes.update({id:item.id})" rms-check-access="serviceconfigs.rostertypes" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Roster Type" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteRosterType(item.id, item.description)" ng-confirm-click="Confirm delete this Roster Type?" rms-check-access="serviceconfigs.rostertypes" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/rostertypes/rostertypeUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/rostertypes/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.rostertypes.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.rostertypes.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/services/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ServiceCode.$invalid && (vm.dataForm.ServiceCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="SERVICE_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ServiceCode" placeholder="Service Code" ng-model="vm.service.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ServiceCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ServiceName.$invalid && (vm.dataForm.ServiceName.$dirty || vm.dataForm.$submitted)}"><label><b translate="SERVICE_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ServiceName" placeholder="Service Name" ng-model="vm.service.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ServiceName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ServiceType.$invalid && (vm.dataForm.ServiceType.$dirty || vm.dataForm.$submitted)}"><label><b translate="SERVICE_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="ServiceType" ng-options="u as u.name for u in vm.serviceTypes track by u.id" ng-model="vm.selectedServiceType" ng-change="vm.selectedServiceTypeChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ServiceType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.EquipmentCategory.$invalid && (vm.dataForm.EquipmentCategory.$dirty || vm.dataForm.$submitted)}"><label><b translate="EQUIPMENT_CATEGORY"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="EquipmentCategory" ng-options="u as u.name for u in vm.categories track by u.id" ng-model="vm.selectedCategory" ng-change="vm.selectedCategoryChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.EquipmentCategory.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.KpiScore.$invalid && (vm.dataForm.KpiScore.$dirty || vm.dataForm.$submitted)}"><label><b translate="KPI_SCORE"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="KpiScore" placeholder="Kpi Score" ng-model="vm.service.kpiScore" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.KpiScore.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.KpiScore.$error.number">* {{ \'KEY_IN_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.KpiScore.$error.min">* <span translate="MINIMUM_VALUE_IS_ZERO"></span></span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Processes"><p><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_PROCESSES_FOR_THIS_SERVICE"></span>.</small> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddProcessModal()"><i class="ion-plus-round"></i><span translate="ADD_PROCESS"></span></a><br><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b>{{ \'PROCESS_CODE\' | translate }}</b></th><th><b>{{ \'PROCESS_NAME\' | translate }}</b></th><th><b>{{ \'KPI_WEIGHTAGE\' | translate }}</b></th><th style="width:100px"><b>{{ \'REQUIRE_CUSTOMER_SIGNATURE\' | translate }}</b></th><th style="text-align:center"><b>{{ \'SEQUENCE\' | translate }}</b></th><th style="width:20px"></th><th style="width:20px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.service.asServiceProcesses"><td>{{ $index+1 }})</td><td>{{ ntn.code || \'-\' }}</td><td>{{ ntn.name || \'\' }}</td><td>{{ ntn.kpiWeightage || \'\' }}</td><td><toggle class="btn-xs" ng-model="ntn.isRequireSignature" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-xs btn-success" offstyle="btn-xs btn-danger"></toggle></td><td style="text-align:center">#{{ ntn.sequence || \'\' }}</td><td><a class="btn btn-primary editable-table-button btn-xs" style="width:50px" ng-if="$index!=0" ng-click="vm.moveUp($index)"><i class="ion ion-chevron-up"></i></a></td><td><a class="btn btn-primary editable-table-button btn-xs" style="width:50px" ng-if="($index+1)!=vm.service.asServiceProcesses.length" ng-click="vm.moveDown($index)"><i class="ion ion-chevron-down"></i></a></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" style="width:80px" ng-click="vm.removeProcess($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="8" align="center" ng-if="vm.service.asServiceProcesses.length==0"><br><span translate="PROCESS_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="ProcessModal.html"><form name="$mdl.modalForm" ng-submit="$mdl.confirmModal()" novalidate> <style type="text/css"> .<span translations="HELP-BLOCK"></span>{ color:#f00 !important; } </style> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="ADD_PROCESS"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.Process.$invalid && ($mdl.modalForm.Process.$dirty || $mdl.modalForm.$submitted)}"> <label><b translate="SELECT_A_PROCESS"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select name="Process" style="background:#fffeed" ng-model="$mdl.selectedProcess" title="Search for Processes..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedProcessChanged()" required> <ui-select-match placeholder="Search for Processes..."> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.processes | filter: $select.search" refresh="$mdl.loadProcesses($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="\'(\' + i.code + \') \' + i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.modalForm.Process.$error.required"> * {{ \'REQUIRED\' | translate }} </p> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.modalForm.KpiWeightage.$invalid && ($mdl.modalForm.KpiWeightage.$dirty || $mdl.modalForm.$submitted)}"> <label><b translate="KPI_WEIGHTAGE"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="KpiWeightage" style="background:#fffeed" ng-model="$mdl.item.kpiWeightage" min=0 required> <p class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.modalForm.KpiWeightage.$error.required"> * {{ \'REQUIRED\' | translate }} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.modalForm.KpiWeightage.$error.number"> * {{ \'KEY_IN_NUMBERS_ONLY\' | translate }} </p> <p class="help-block" style="color:#f00" ng-show="$mdl.modalForm.$submitted && $mdl.modalForm.KpiWeightage.$error.min"> * {{ \'MINIMUM_VALUE_IS_ZERO\' | translate }} </p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="REQUIRE_CUSTOMER_SIGNATURE"></b>?</label> <div> <toggle ng-model="$mdl.item.isRequireSignature" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton || $mdl.isLoading" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING"> ...</b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton || $mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/serviceconfigs/services/serviceCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/services/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_SERVICE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.services.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/services/serviceImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b translate="IMPORT_SERVICE_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'services\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="(excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons)"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE..."></span></div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_SVC_TYPE_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'services/types\')" ng-disabled="vm.isExporting || vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="(excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons)"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE..."></span></div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading><b translate="IMPORT_SVC_PROCESS_DATA"></b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile(\'services/processes\')" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="(excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons)"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend translate="IMPORT_GUIDELINES:"></legend><ol class="import"><li translate="YOU_NEED_TO_FOLLOW_THE_INSTRUCTION_BELOW_IF_YOU_ARE_NEW_TO_THE_RMS."></li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW_FILL_IT_UP_WITH_THE_DATA_FIRST_THEN_IMPORT_INTO_THE_RMS"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'services\', \'Service Master Data Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_SERVICE_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'services/types\', \'Service Type Data Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_SVC_TYPE_TEMPLATE"></span></a></li><li><span translate="THEN,_DOWNLOAD_THE_TEMPLATE_BELOW,_FILL_IT_UP_WITH_THE_DATA,_THEN_IMPORT_INTO_THE_RMS:"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate(\'services/processes\', \'Service Process Data Template\')"><i class="fa fa-download"></i> <span translate="DOWNLOAD_SVC_PROCESS_TEMPLATE"></span></a><br>&nbsp;</li></ol></fieldset><br>&nbsp;<br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong translate="FILE_UPLOADED_SUCCESSFULLY._CHOOSE_THE_OPTIONS_BELOW_AND_PROCEED_TO_IMPORT_THE_DATA."></strong></div><div><fieldset ng-if="vm.importType==\'services\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createService" ng-change="change()" ng-disabled="true" style="cursor:pointer"> <label><span translate="CREATE_NEW_SERVICE"></span></label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateService" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_SERVICE_IF_EXISTS"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createServiceType" ng-change="change()" style="cursor:pointer"> <label><span translate="CREATE_NEW_SVC_TYPE"></span></label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateServiceType" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_SVC_TYPE_IF_EXISTS"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createProcess" ng-change="change()" style="cursor:pointer"> <label><span translate="CREATE_NEW_PROCESS"></span></label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateProcess" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_PROCESS_IF_EXISTS"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createEquipmentCategory" ng-change="change()" style="cursor:pointer"> <label><span translate="CREATE_NEW_EQ_CATE"></span></label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateEquipmentCategory" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_EQ_CATE_IF_EXISTS"></span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'services\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'services/types\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createType" ng-change="change()" style="cursor:pointer"> <label><span translate="CREATE_NEW_SVC_TYPE"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateType" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_SVC_TYPE_IF_EXISTS"></span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'services/types\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><fieldset ng-if="vm.importType==\'services/processes\'"><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createProcess" ng-change="change()" style="cursor:pointer"> <label><span translate="CREATE_NEW_PROCESS"></span></label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateProcess" ng-change="change()" style="cursor:pointer"> <label><span translate="UPDATE_PROCESS_IF_EXISTS"></span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData(\'services/processes\')" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><br><br><fieldset><legend translate="DATA_PREVIEW"></legend></fieldset></div><div id="scroll-container" class="horizontal-scroll"><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'services\'"><thead><tr><th style="width:60px">#</th><th><b translate="SERVICE_CODE"></b></th><th><b translate="SERVICE_NAME"></b></th><th><b translate="CATEGORY_CODE"></b></th><th><b translate="CATEGORY_NAME"></b></th><th><b translate="TYPE_CODE"></b></th><th><b translate="TYPE_NAME"></b></th><th><b translate="KPI_SCORE"></b></th><th><b translate="PROCESS_CODE"></b></th><th><b translate="PROCESS_NAME"></b></th><th><b translate="SEQ"></b></th><th><b translate="KPI_WEIGHT"></b></th><th><b translate="REQUIRE_CUSTOMER_SIGNATURE"></b></th></tr><tr><th colspan="13"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td nowrap="nowrap">{{ row.serviceCode || \'-\' }}</td><td nowrap="nowrap">{{ row.serviceName || \'-\' }}</td><td nowrap="nowrap">{{ row.equipmentCategoryCode || \'-\' }}</td><td nowrap="nowrap">{{ row.equipmentCategoryName || \'-\' }}</td><td nowrap="nowrap">{{ row.serviceTypeCode || \'-\' }}</td><td nowrap="nowrap">{{ row.serviceTypeName || \'-\' }}</td><td nowrap="nowrap">{{ row.kpiScore || \'-\' }}</td><td nowrap="nowrap">{{ row.processCode || \'-\' }}</td><td nowrap="nowrap">{{ row.processName || \'-\' }}</td><td nowrap="nowrap">{{ row.sequence || \'-\' }}</td><td nowrap="nowrap">{{ row.kpiWeightage || \'-\' }}</td><td nowrap="nowrap">{{ row.isRequiredSignature || \'-\' }}</td></tr><tr><td colspan="13" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="13"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'services/types\'"><thead><tr><th style="width:60px">#</th><th><b translate="CODE"></b></th><th><b translate="NAME"></b></th></tr><tr><th colspan="3"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.code || \'\' }}</td><td>{{ row.name || \'\' }}</td></tr><tr><td colspan="3" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="3"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important" ng-if="vm.importType==\'services/processes\'"><thead><tr><th style="width:60px">#</th><th><b translate="CODE"></b></th><th><b translate="NAME"></b></th></tr><tr><th colspan="3"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td>{{ row.code || \'\' }}</td><td>{{ row.name || \'\' }}</td></tr><tr><td colspan="3" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="3"><span translate="TOTAL_RECORDS:"></span> {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-12 col-lg-12"><br><p translate="THE_DATA_IS_CURRENTLY_BEING_PROCESSED._IT_IS_SAFE_TO_LEAVE_THIS_PAGE_NOW."></p><p><span translate="YOU_WILL_BE_NOTIFIED_BY_EMAIL_WHEN_THE_IMPORT_IS_COMPLETE."></span></p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.services.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a></div></form></div><div class="float-scroll-button"><span class="scroll-caption"><span translate="SCROLL"></span></span> <a href="" class="scroll-left" ng-if="vm.isSuccess && !vm.isImporting" ng-click="vm.scrollLeft()"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-arrow-left fa-stack-1x fa-inverse"></i></span></a> <a href="" class="scroll-right" ng-if="vm.isSuccess && !vm.isImporting" ng-click="vm.scrollRight()"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-arrow-right fa-stack-1x fa-inverse"></i></span></a></div>');
$templateCache.put('app/pages/serviceconfigs/services/serviceList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.serviceData" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Service" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.services.create" rms-check-access="serviceconfigs.services" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_SERVICE"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="serviceconfigs.services.import" rms-check-access="serviceconfigs.services" rms-check-access-perm-type="CREATE"><i class="fa fa-download"></i> <span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:150px" st-sort="code"><span translate="SERVICE_CODE"></span></th><th st-sort="name"><span translate="SERVICE_NAME"></span></th><th st-sort="typeName"><span translate="SERVICE_TYPE"></span></th><th st-sort="categoryName"><span translate="EQUIPMENT_CATEGORY"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable" ng-if="vm.serviceData.length>0"><th colspan="3"></th><th class="form-inline" style="padding-top:3px;padding-bottom:3px;"><select st-search="typeName" style="width:100%"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.serviceDataFull | unique:\'typeName\'" value="{{s.typeName | uppercase}}">{{s.typeName | uppercase}}</option></select></th><th class="form-inline" style="padding-top:3px;padding-bottom:3px;"><select st-search="categoryName" style="width:100%"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.serviceDataFull | unique:\'categoryName\'" value="{{s.categoryName | uppercase}}">{{s.categoryName | uppercase}}</option></select></th><th colspan="2"></th></tr></thead><tbody><tr ng-if="vm.serviceData.length<=0 && !vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> ...</b></center></big></td></tr><tr ng-repeat="item in vm.serviceData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td>{{item.typeName}}</td><td>{{item.categoryName}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.services.update({id:item.id})" rms-check-access="serviceconfigs.services" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Service" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteService(item.id, item.name)" ng-confirm-click="Confirm delete this service?" rms-check-access="serviceconfigs.services" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/services/serviceUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/services/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.services.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.services.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/servicetypes/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TypeCode.$invalid && (vm.dataForm.TypeCode.$dirty || vm.dataForm.$submitted)}"><label for="TypeCode"><b translate="TYPE_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="TypeCode" placeholder="Type Code" ng-model="vm.svctype.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TypeCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TypeName.$invalid && (vm.dataForm.TypeName.$dirty || vm.dataForm.$submitted)}"><label for="TypeName"><b translate="TYPE_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="TypeName" placeholder="Type Name" ng-model="vm.svctype.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TypeName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/servicetypes/svctypeCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/servicetypes/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_SERVICE_TYPE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.svctypes.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/servicetypes/svctypeList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.typeData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Category" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.svctypes.create" rms-check-access="serviceconfigs.svctypes" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_SERVICE_TYPE"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="serviceconfigs.svctypes.import" rms-check-access="serviceconfigs.svctypes" rms-check-access-perm-type="CREATE"><i class="fa fa-download"></i> <span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:150px" st-sort="name"><span translate="TYPE_CODE"></span></th><th st-sort="name"><span translate="TYPE_NAME"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.typeData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.typeData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.svctypes.update({id:item.id})" rms-check-access="serviceconfigs.svctypes" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Category" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteSvcCategory(item.id, item.name)" ng-confirm-click="Confirm delete this category?" rms-check-access="serviceconfigs.svctypes" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/servicetypes/svctypeUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/servicetypes/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.svctypes.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.svctypes.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/spareparts/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'GENERAL\'|translate}}"><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-md-3 col-lg-3"><div class="row"><img ngf-src="picFile || vm.sparepart.imageLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div><br><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-hide="vm.lockUploadButton" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> {{ \'UPLOAD_PICTURE\' | translate }}</div><a href="" class="btn btn-default btn-with-icon" ng-click="picFile=null;vm.clearImage()" ng-hide="vm.lockUploadButton" ng-show="(picFile || vm.sparepart.imageLocation.indexOf(\'empty_placeholder\')<0)"><i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }}</a></div><div class="row" ng-show="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div><div class="col-md-7 col-lg-7"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Brand.$invalid && (vm.dataForm.Brand.$dirty || vm.dataForm.$submitted)}"><label><b translate="BRAND"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Brand" ng-options="u as u.name for u in vm.brands track by u.id" ng-model="vm.selectedBrand" ng-change="vm.selectedBrandChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Brand.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SparePartCode.$invalid && (vm.dataForm.SparePartCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SparePartCode" ng-model="vm.sparepart.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SparePartCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SparePartDescription.$invalid && (vm.dataForm.SparePartDescription.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SparePartDescription" ng-model="vm.sparepart.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SparePartDescription.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Price.$invalid && (vm.dataForm.Price.$dirty || vm.dataForm.$submitted)}"><label><b translate="PRICE"></b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Price" ng-model="vm.sparepart.price" min="0" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Price.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Price.$error.required">* {{ \'MINIMUM_IS_0\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Price.$error.required">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="BIN_LOCATION"></b></label> <input type="text" class="form-control" name="SparePartBIN" ng-model="vm.sparepart.bin"></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div></uib-tab><uib-tab heading="{{\'EQUIPMENT\'|translate}}"><p><i class="fa fa-info-circle"></i> <span translate="ASSOCIATE_RELEVANT_EQUIPMENTS_TO_THIS_S.O.P"></span>. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddEquipmentModal()"><i class="ion-plus-round"></i> <span translate="ADD_EQUIPMENT"></span></a><br><br></p><div class="row" ng-show="vm.mode==2"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="font-size:90%;border:1px solid #ccc" st-pipe="vm.refreshEquipments" st-table="vm.sparepart.equipments" refresh-table=""><thead><tr><th style="width:60px">#</th><th><b translate="EQUIPMENT_CODE"></b></th><th><b translate="EQUIPMENT_BRAND"></b></th><th><b translate="EQUIPMENT_MODEL"></b></th><th><b translate="EQUIPMENT_NAME"></b></th><th><b translate="EQUIPMENT_DESCRIPTION"></b></th><th style="width:65px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.sparepart.equipments"><td>{{ $index+1 }})</td><td>{{ ntn.code || \'\' }}</td><td>{{ ntn.brandName || \'\' }}</td><td>{{ ntn.model || \'\' }}</td><td style="line-height:130%;padding-top:8px;padding-bottom:8px;">{{ ntn.name || \'\' }}</td><td style="line-height:130%;padding-top:8px;padding-bottom:8px;white-space:pre-wrap;">{{ ntn.description || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeEquipment(ntn.id)" ng-confirm-click="Confirm remove this Equipment?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="7" align="center" ng-show="vm.sparepart.equipments.length==0"><br><span translate="EQUIPMENT_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center><span translate="PLEASE_SAVE_THE_S.O.P._FIRST_BEFORE_ADDING_EQUIPMENTS"></span>.</center></h2></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="EquipmentModal.html"><form name="$mdl.equipmentForm" ng-submit="$mdl.searchEquipment()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="SELECT_EQUIPMENT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SEARCH_EQUIPMENT"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <div class="row"> <div class="col-lg-6"> <input type="text" name="SearchText" class="form-control" style="background:#fffeed" placeholder="{{\'ENTER_KEYWORD_TO_SEARCH\'|translate}}" ng-disabled="$mdl.lockButton" ng-model="$mdl.searchText" min=3 required /> </div> <div class="col-lg-6"> <button type="submit" class="btn btn-default btn-with-icon" ng-disabled="$mdl.lockButton"> <i class="fa fa-search"></i> {{ \'SEARCH\' | translate}} </button> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.equipmentForm.SearchText.$error.min && $mdl.equipmentForm.$submitted">* {{ \'ENTER_MINIMUM_3_LETTERS\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.equipmentForm.SearchText.$error.required && $mdl.equipmentForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div style="max-height:400px;overflow-y:scroll"> <table class="table table-striped" style="font-size:90%;border:1px solid #ccc" st-pipe="$mdl.refreshEquipments" st-table="$mdl.equipmentList" refresh-table> <thead> <tr> <th style="width:60px">#</th> <th><b translate="CODE"></b></th> <th><b translate="BRAND"></b></th> <th><b translate="MODEL"></b></th> <th><b translate="NAME"></b></th> <th><b translate="DESCRIPTION"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="ntn in $mdl.equipmentList"> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ $index+1 }})</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.code || \'\' }}</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.brandName || \'\' }}</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.model || \'\' }}</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.name || \'\' }}</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px;white-space:pre-wrap;">{{ ntn.description || \'\' }}</td> <td style="line-height:130%;padding-top:4px;padding-bottom:8px"> <input type="checkbox" name="chkSelect" style="background:#fffff4;width:20px;height:20px" checklist-model="$mdl.selectedEquipments" checklist-value="ntn" checklist-change="$mdl.equipmentForm.chkSelect.$setValidity(\'required\', $mdl.selectedEquipments.length > 0)" ng-required="!$mdl.selectedEquipments.length" /> <!-- <a href class="btn btn-primary editable-table-button btn-with-icon btn-xs" ng-disabled="$mdl.lockButton" ng-click="$mdl.confirmModal(ntn)"> <i class="ion ion-checkmark"></i> <span translations="SELECT""></span> </a> --> </td> </tr> <tr> <td colspan="7" align="center" ng-show="$mdl.equipmentList.length==0"> <br /> <span translate="EQUIPMENT_LIST_IS_EMPTY"></span>. <br />&nbsp; </td> </tr> </tbody> </table> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" style="color:#000"> <span translate="SELECTED"></span>: <b>{{$mdl.selectedEquipments.length}}</b> </div> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f;margin-left:30px"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b> <span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.confirmModal()" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/serviceconfigs/spareparts/sparepartCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/spareparts/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_SPARE_PART"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.spareparts.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/spareparts/sparepartImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend>{{ \'IMPORT_SPARE_PART_DATA\' | translate }}</legend></fieldset><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> {{ \'BROWSE\' | translate}}</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile()" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> <span translate="UPLOAD_FILE"></span></a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px"><span translate="UPLOADING_FILE"></span>...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_PROCESS_UPLOADED_FILE._FILE_MIGHT_CONTAIN_ERRORS."></strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong translate="FAILED_TO_UPLOAD_FILE."></strong></div></div></div></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend translate="IMPORT_GUIDELINES:"></legend><ol class="import"><li translate="YOU_NEED_TO_FOLLOW_THE_INSTRUCTION_BELOW_IF_YOU_ARE_NEW_TO_THE_RMS."></li><li><span translate="DOWNLOAD_THE_TEMPLATE_BELOW_FILL_IT_UP_WITH_THE_DATA_FIRST_THEN_IMPORT_INTO_THE_RMS"></span><br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate()"><i class="fa fa-download"></i> <span translate="DOWNLOAD_SPARE_PART_TEMPLATE"></span></a></li></ol></fieldset></div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong translate="FILE_UPLOADED_SUCCESSFULLY._CHOOSE_THE_OPTIONS_BELOW_AND_PROCEED_TO_IMPORT_THE_DATA."></strong></div><div><fieldset><legend translate="IMPORT_OPTIONS:"></legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createSparePart" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'CREATE_NEW_SPAREPARTS\' | translate }}</label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createEquipmentBrand" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'CREATE_NEW_EQ_BRAND\' | translate }}</label></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateSparePart" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'UPDATE_SPAREPARTS_IF_EXISTS\' | translate }}</label></div></div><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateEquipmentBrand" ng-change="change()" style="cursor:pointer"> <label>&nbsp;{{ \'UPDATE_EQ_BRAND_IF_EXISTS\' | translate }}</label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> <span translate="CONFIRM_IMPORT"></span></a></div></div></fieldset><br><br><fieldset><legend translate="CUSTOMER_DATA_PREVIEW:"></legend></fieldset></div><div class="horizontal-scroll"><table class="table table-striped table-bordered table-nopadding" border="1" style="norder-collapse:collapse;font-size:8pt !important"><thead><tr><th style="width:60px">#</th><th><b translate="CODE"></b></th><th><b translate="DESCRIPTION"></b></th><th><b translate="EQ_BRAND_CODE"></b></th><th><b translate="EQ_BRAND_NAME"></b></th><th><b translate="BIN"></b></th><th><b translate="PRICE"></b></th><th><b translate="EQ_CODE"></b></th><th><b translate="EQ_NAME"></b></th></tr><tr><th colspan="9">{{ \'TOTAL_RECORDS\' | translate}}: {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td nowrap="nowrap">{{ row.sparePartCode || \'\' }}</td><td nowrap="nowrap">{{ row.sparePartDescription || \'\' }}</td><td nowrap="nowrap">{{ row.equipmentBrandCode || \'\' }}</td><td nowrap="nowrap">{{ row.equipmentBrandName || \'-\' }}</td><td nowrap="nowrap">{{ row.bin || \'-\' }}</td><td nowrap="nowrap">{{ row.price || \'-\' }}</td><td nowrap="nowrap">{{ row.equipmentCode || \'-\' }}</td><td nowrap="nowrap">{{ row.equipmentName || \'-\' }}</td></tr><tr><td colspan="9" align="center" ng-show="vm.importOptions.excelContent.length==0"><br><span translate="EXCEL_CONTENT_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="9">{{ \'TOTAL_RECORDS\' | translate}}: {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-6 col-lg-6"><em><small><i class="fa fa-info-circle"></i> <span translate="PROCESSING"></span>...</small></em><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><p translate="THE_DATA_IS_CURRENTLY_BEING_PROCESSED._IT_IS_SAFE_TO_LEAVE_THIS_PAGE_NOW."></p><p translate="YOU_WILL_RECEIVE_AN_EMAIL_NOTIFICATION_ABOUT_THE_IMPORT_RESULT_ONCE_THE_SERVER_HAS_FINISHED_PROCESSED_THE_DATA."></p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="maintenance.debtors.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a></div></form></div>');
$templateCache.put('app/pages/serviceconfigs/spareparts/sparepartList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="SparePartListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="height:35px;line-height:35px;padding-left:0px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.spareparts.create" rms-check-access="serviceconfigs.spareparts" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_SPARE_PART"></span></a> <a href="" class="btn btn-success btn-with-icon" ui-sref="serviceconfigs.spareparts.import" rms-check-access="serviceconfigs.spareparts" rms-check-access-perm-type="CREATE"><i class="fa fa-upload"></i><span translate="IMPORT_EXCEL"></span></a></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:80px">#</th><th style="width:140px">Image</th><th style="width:150px" st-sort="code">{{ \'CODE\' | translate }}</th><th st-sort="description">{{ \'DESCRIPTION\' | translate }}</th><th style="width:150px" st-sort="brandName"><span translate="BRAND"></span></th><th st-sort="price"><span translate="PRICE"></span></th><th st-sort="bin"><span translate="BIN_LOCATION"></span></th><th><span translate="EQUIPMENT"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th></th><th class="form-inline" colspan="2"><input st-search="partName" class="form-control input input-sm"></th><th class="form-inline"><input st-search="brandName" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th class="form-inline"><input st-search="equipmentName" class="form-control input input-sm"></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.data.length<=0 && !vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}}.</td><td><img ng-if="item.imageLocation==null || item.imageLocation==\'\'" src="assets/img/empty_placeholder.png" style="width:120px;height:80px;margin-top:10px;margin-bottom:10px"> <img ng-if="item.imageLocation!=null && item.imageLocation!=\'\'" src="{{ vm.blobUrl + item.imageLocation }}" style="width:120px;height:80px;margin-top:10px;margin-bottom:10px"></td><td>{{item.code}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:120%">{{item.description}}</td><td>{{item.brandName}}</td><td>{{item.price | number:0}}</td><td>{{item.bin}}</td><td style="padding-top:8px;padding-bottom:10px;line-height:130%;max-width:300px"><ul style="padding-left:20px;font-size:80%"><li ng-repeat="eq in item.equipments">[{{eq.code|uppercase}}] {{eq.name}}</li></ul></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.spareparts.update({id:item.id})" rms-check-access="serviceconfigs.spareparts" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Type" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteSparePart(item.id, item.description)" ng-confirm-click="Confirm delete this Spare Part?" rms-check-access="serviceconfigs.spareparts" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/spareparts/sparepartUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/spareparts/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.spareparts.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.spareparts.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/loanitemstatuses/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StatusName.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="LOAN_STATUS"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="StatusName" ng-model="vm.loanstatus.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StatusName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="SKIP_QUANTITY_CHECK">?</b></label><div><toggle ng-model="vm.loanstatus.skipQuantityCheck" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="TRIGGER_REMOVE_RESERVATION">?</b></label><div><toggle ng-model="vm.loanstatus.triggerRemoveResv" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/loanitemstatuses/loanitemstatusCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/loanitemstatuses/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_LOAN_ITEM_STATUS"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.loanitemstatuses.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/loanitemstatuses/loanitemstatusList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.statusData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Entry" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.loanitemstatuses.create" rms-check-access="serviceconfigs.loanitemstatuses" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_STATUS"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span> :<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="name"><span translate="LOAN_STATUS"></span></th><th translate="SKIP_QUANTITY_CHECK">?</th><th translate="TRIGGER_REMOVE_RESERVATION">?</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.statusData.length<=0 && !vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.statusData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td>{{ (item.skipQuantityCheck?\'Yes\':\'No\') }}</td><td>{{ (item.triggerRemoveResv?\'Yes\':\'No\') }}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.loanitemstatuses.update({id:item.id})" rms-check-access="serviceconfigs.loanitemstatuses" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Entry" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteEntry(item.id, item.description)" ng-confirm-click="Confirm delete this Entry?" rms-check-access="serviceconfigs.loanitemstatuses" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/loanitemstatuses/loanitemstatusUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/loanitemstatuses/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.loanitemstatuses.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.loanitemstatuses.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/techteams/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TeamName.$invalid && (vm.dataForm.TeamName.$dirty || vm.dataForm.$submitted)}"><label for="TeamName"><b translate="TEAM_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="TeamName" placeholder="Team Name" ng-model="vm.team.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TeamName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><hr><p><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_TEAM_MEMBERS_IN_THIS_TEAM"></span>.</small> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddMemberModal()"><i class="ion-plus-round"></i><span translate="ADD_MEMBER"></span></a><br></p><script type="text/ng-template" id="memberModal.html"><form name="$mdl.modalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="ADD_TEAM_MEMBER"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SELECT_A_TEAM_MEMBER">:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select ng-model="$mdl.selectedUser" title="Search for Team Member..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedUserChanged()"> <ui-select-match placeholder="Search for Team Member..."> <span>{{ ($select.selected.firstName + \' \' + $select.selected.lastName) }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.users | filter: $select.search" refresh="$mdl.loadUsers($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="(i.firstName + \' \' + i.lastName) | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.selectedUser==null && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group"> <label><b><span translate="SELECT_THE_SENIORITY"></span>:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="Seniority" ng-model="$mdl.item.seniority" required> <option></option> <option value="JUNIOR">{{ \'JUNIOR\' | translate }}</option> <option value="SENIOR">{{ \'SENIOR\' | translate }}</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.modalForm.Seniority.$error.required && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b translate="IS_TEAM_LEADER">:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <div> <toggle ng-model="$mdl.item.isLeader" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING_">...</b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><div class="row"><div class="col-md-8 col-lg-8"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="MEMBER_NAME"></b></th><th><b translate="SENIORITY"></b></th><th><b>Is Leader</b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.team.asTechTeamMembers"><td>{{ $index+1 }}</td><td>{{ ntn.name || \'-\' }}</td><td>{{ ntn.seniority || \'\' }}</td><td><i class="fa fa-check" ng-show="ntn.isLeader" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!ntn.isLeader" style="color:#f00"></i></td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeMember($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="5" align="center" ng-if="vm.team.asTechTeamMembers.length==0"><br><span translate="TEAM_MEMBER_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Zone Specialization"><p><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_ZONE_SPECIALIZATION_FOR_THIS_TEAM"></span>.</small> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddZoneModal()"><i class="ion-plus-round"></i><span translate="ADD_ZONE"></span></a><br></p><script type="text/ng-template" id="zoneModal.html"><form name="$mdl.modalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="ADD_ZONE"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b><span translate="SELECT_A_ZONE"></span>:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select ng-model="$mdl.selectedZone" title="Search for Zone..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="$mdl.selectedZoneChanged()"> <ui-select-match placeholder="Search for Zone..."> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.zones | filter: $select.search" refresh="$mdl.loadZones($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.selectedZone==null && $mdl.modalForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING"> ...</b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><div class="row"><div class="col-md-6 col-lg-6"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="ZONE_CODE"></b></th><th><b translate="ZONE_NAME"></b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.team.asZones"><td>{{ $index+1 }}</td><td>{{ ntn.code || \'-\' }}</td><td>{{ ntn.name || \'-\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeZone($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="4" align="center" ng-if="vm.team.asZones.length==0"><br><span translate="ZONE_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/techteams/techTeamCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/techteams/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_TEAM"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.techteams.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/techteams/techTeamList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.teamData" refresh-table=""><thead><tr><th colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Team" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.techteams.create" rms-check-access="serviceconfigs.techteams" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_TEAM"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="name"><span translate="TEAM_NAME"></span></th><th translate="MEMBER_COUNT"></th><th translate="ZONE_COUNT"></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.teamData.length<=0 && !vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.teamData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td>{{item.memberCount}}</td><td>{{item.zoneCount}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.techteams.update({id:item.id})" rms-check-access="serviceconfigs.techteams" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Team" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteTeam(item.id, item.name)" ng-confirm-click="Confirm delete this team?" rms-check-access="serviceconfigs.techteams" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/techteams/techTeamUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/techteams/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.techteams.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.techteams.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/workorderstatuses/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-6 col-lg-6"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StatusName.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="WORK_ORDER_STATUS"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="StatusName" ng-model="vm.workorderstatus.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StatusName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><br><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.workorderstatus.defaultStatus" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b translate="IS_DEFAULT_STATUS">?</b></big><br><small translate="THE_DEFAULT_STATUS_SELECTED_WHEN_CREATING_A_NEW_WORK_ORDER."></small></label></div></td></tr></table></div></div><br><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.workorderstatus.documentClosed" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b translate="IS_DOCUMENT_CLOSED?"></b></big><br><small translate="THIS_STATUS_INDICATES_THE_DOCUMENT_IS_CLOSED."></small></label></div></td></tr></table></div></div><br><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.workorderstatus.noFurtherEdit" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b translate="NO_FURTHER_EDIT">?</b></big><br><small translate="SYSTEM_WILL_PREVENT_FURTHER_CHANGES_TO_THE_DOCUMENT">.</small></label></div></td></tr></table></div></div><br><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.workorderstatus.loanItemStateCheck" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b translate="CHECK_LOAN_ITEM_STATUSES">?</b></big><br><small>{{ "SYSTEM_WILL_CHECK_THE_STATUSES_OF_THE_LOAN_ITEMS,_AND_IF_THE_SELECTED_STATUSES" | translate}}<br>{{ "IS_DETECTED,_OPERATION_WILL_ABORT" | translate}}</small></label></div></td></tr></table></div></div><br><div class="row"><div class="col-lg-12"><table cellpadding="5" cellspacing="0" border="0"><tr><td style="padding-right:30px"><div class="form-group"><div><toggle ng-model="vm.workorderstatus.isRequireInvoice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></td><td nowrap="nowrap"><div class="form-group"><label><big><b translate="REQUIRE_INVOICE">?</b></big><br><small>{{ "MUST_HAVE_AT_LEAST_ONE_INVOICE_TO_PROCEED" | translate}}</small></label></div></td></tr></table></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-5 col-lg-5" ng-if="vm.workorderstatus.loanItemStateCheck"><div class="row"><div class="col-md-10 col-lg-10"><br><br><legend style="height:32.4px;line-height:32.4px"><span translate="LOAN_ITEM_STATUSES"></span> <a href="" class="btn btn-primary btn-with-icon btn-xs" style="margin:5px" ng-click="vm.showAddLoanItemStatusModal()"><i class="ion-plus-round"></i><span translate="ADD_MORE"></span></a></legend><p><i class="fa fa-info-circle"></i> <small>[<b translate="CHECK_LOAN_ITEM_STATUSES"></b>] <span translate="OPTION_IS"></span> <b translate="YES"></b>, <span translate="SELECT_THE_LOAN_ITEM_STATUSES_FOR_SYSTEM_CHECKING"></span>.</small></p><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="LOAN_ITEM_STATUS"></b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.workorderstatus.asServiceWorkStateCheckLoanItemStates"><td>{{ $index+1 }}</td><td>{{ ntn.name || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeLoanItemStatus($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr ng-if="vm.workorderstatus.asServiceWorkStateCheckLoanItemStates.length==0"><td colspan="3" align="center"><br><span translate="LOAN_ITEM_STATUS_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="LoanItemStatusModal.html"><form name="$mdl.statusForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="ADD_LOAN_STATUS"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SELECT_A_LOAN_ITEM_STATUS"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select title="Select or Search for Status..." class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedStatus" on-select="$mdl.selectedStatusChanged()"> <ui-select-match placeholder="Search for Status..."> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.statuses | filter: $select.search" minimum-input-length="2"> <span ng-bind-html="i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.selectedStatus==null && $mdl.statusForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING_">...</b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/serviceconfigs/workorderstatuses/workorderstatusCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/workorderstatuses/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_WORK_ORDER_STATUS"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.workorderstatuses.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/workorderstatuses/workorderstatusList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.statusData" refresh-table=""><thead><tr><th colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Entry" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.workorderstatuses.create" rms-check-access="serviceconfigs.workorderstatuses" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_STATUS"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span> :<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="name"><span translate="WORK_ORDER_STATUS"></span></th><th translate="DEFAULT_STATUS">?</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.statusData.length<=0 && !vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="6" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.statusData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td>{{ (item.defaultStatus?\'Yes\':\'No\') }}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.workorderstatuses.update({id:item.id})" rms-check-access="serviceconfigs.workorderstatuses" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Entry" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteEntry(item.id, item.description)" ng-confirm-click="Confirm delete this Entry?" rms-check-access="serviceconfigs.workorderstatuses" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/workorderstatuses/workorderstatusUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/workorderstatuses/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.workorderstatuses.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.workorderstatuses.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/robotkiosk/productsizes/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SizeCode.$invalid && (vm.dataForm.SizeCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="SIZE_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SizeCode" ng-model="vm.size.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SizeCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SizeName.$invalid && (vm.dataForm.SizeName.$dirty || vm.dataForm.$submitted)}"><label><b translate="SIZE_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SizeName" ng-model="vm.size.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SizeName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_ACTIVE"></b></label><div><toggle ng-model="vm.size.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div></div><div class="col-md-12 col-lg-12"><div><p><br><br>&nbsp;</p></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/robotkiosk/productsizes/sizeCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/productsizes/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.productsizes.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/robotkiosk/productsizes/sizeList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="RobotKioskSizeListing" st-pipe="vm.retrieveData" st-table="vm.sizeData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Product Size" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.productsizes.create" rms-check-access="robotkiosk.productsizes" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Size</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="code">Size Code</th><th st-sort="name">Size Name</th><th class="hide-after" style="text-align:center">Is Active?</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.sizeData.length<=0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.sizeData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="robotkiosk.productsizes.update({id:item.id})" rms-check-access="robotkiosk.productsizes" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteData(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Product Size?" rms-check-access="robotkiosk.productsizes" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/robotkiosk/productsizes/sizeUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/robotkiosk/productsizes/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="robotkiosk.productsizes.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="robotkiosk.productsizes.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/serviceconfigs/zones/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ZoneCode.$invalid && (vm.dataForm.ZoneCode.$dirty || vm.dataForm.$submitted)}"><label for="ZoneCode"><b translate="ZONE_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ZoneCode" placeholder="Zone Code" ng-model="vm.zone.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ZoneCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ZoneName.$invalid && (vm.dataForm.ZoneName.$dirty || vm.dataForm.$submitted)}"><label for="ZoneName"><b translate="ZONE_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="ZoneName" placeholder="Zone Name" ng-model="vm.zone.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ZoneName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Zip Codes"><p><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_ZIP_CODES_IN_THIS_ZONE"></span>.</small> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddZipCodeModal()"><i class="ion-plus-round"></i><span translate="ADD_ZIP_CODE"></span></a><br><br></p><script type="text/ng-template" id="ZipModal.html"><form name="$mdl.zipForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="ADD_ZIP_CODE"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="ENTER_THE_AREA_NAME">:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="text" class="form-control" name="AreaName" ng-model="$mdl.item.areaName" required> <p class="help-block" style="color:#f00" ng-show="$mdl.zipForm.AreaName.$error.required && $mdl.zipForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b><span translate="ZIP_CODE_-_RANGE_START"></span>:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" class="form-control" name="ZipCodeFrom" ng-model="$mdl.item.zipCodeFrom" required> <p class="help-block" style="color:#f00" ng-show="$mdl.zipForm.ZipCodeFrom.$error.required && $mdl.zipForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.zipForm.ZipCodeFrom.$error.number && $mdl.zipForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="ZIP_CODE_-_RANGE_TO"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" class="form-control" name="ZipCodeTo" ng-model="$mdl.item.zipCodeTo" required> <p class="help-block" style="color:#f00" ng-show="$mdl.zipForm.ZipCodeTo.$error.required && $mdl.zipForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.zipForm.ZipCodeTo.$error.number && $mdl.zipForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</p> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING"> ...</b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><div class="row"><div class="col-md-6 col-lg-6"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="AREA_NAME"></b></th><th><b translate="ZIP_CODE_-_FROM"></b></th><th><b translate="ZIP_CODE_-_TO"></b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.zone.asZoneZipCodes"><td>{{ $index+1 }}</td><td>{{ ntn.areaName || \'-\' }}</td><td>{{ ntn.zipCodeFrom || \'\' }}</td><td>{{ ntn.zipCodeTo || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeZipCode($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="5" align="center" ng-show="vm.zone.asZoneZipCodes.length==0"><br><span translate="ZIP_CODE_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/zones/zoneCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/zones/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_ZONE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.zones.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/zones/zoneList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.zoneData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Zone" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.zones.create" rms-check-access="serviceconfigs.zones" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_ZONE"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:150px" st-sort="name"><span translate="ZONE_CODE"></span></th><th st-sort="name"><span translate="ZONE_NAME"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.zoneData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.zoneData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.zones.update({id:item.id})" rms-check-access="serviceconfigs.zones" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Zone" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteZone(item.id, item.name)" ng-confirm-click="Confirm delete this zone?" rms-check-access="serviceconfigs.zones" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/zones/zoneUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/zones/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.zones.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.zones.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/settings/branches/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4" style="margin-right:40px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BranchCode.$invalid && (vm.dataForm.BranchCode.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'BRANCH_CODE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BranchCode" ng-model="vm.branch.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BranchCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="IS_DEFAULT_BRANCH"></b></label><div><toggle ng-model="vm.branch.isDefault" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4" style="margin-right:40px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BranchName.$invalid && (vm.dataForm.BranchName.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'BRANCH_NAME\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BranchName" ng-model="vm.branch.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BranchName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>{{ \'IS_FRANCHISEE\' | translate }}</b></label><div><toggle ng-model="vm.branch.isFranchisee" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TimeZone.$invalid && (vm.dataForm.TimeZone.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'TIME_ZONE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="TimeZone" class="form-control" ng-change="vm.selectedTimeZoneChanged()" ng-model="vm.selectedTimeZone" ng-options="i as i.name for i in vm.timezones" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TimeZone.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.branch.isFranchisee"><div class="col-md-4 col-lg-4"><br><br><legend style="height:32.4px;line-height:32.4px"><span translate="FOR_FRANCHISEE_ONLY"></span></legend></div></div><div class="row" ng-if="vm.branch.isFranchisee"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'CUSTOMER\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" ng-change="vm.selectedDebtorChanged()" ng-options="d as d.name for d in vm.debtorList" ng-model="vm.selectedDebtor" ng-required="vm.branch.isFranchisee"></select></div></div></div><div class="row" ng-if="vm.branch.isFranchisee"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'CUSTOMER_BRANCH\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" ng-change="vm.selectedDebtorBranchChanged()" ng-options="d as d.name for d in vm.debtorBranchList" ng-model="vm.selectedDebtorBranch" ng-required="vm.branch.isFranchisee"></select></div></div></div><div class="row"><p>&nbsp;</p><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CONTACT_DETAILS\' | translate }}"><p style="color:#00f"><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_BRANCH_DETAILS"></span>.<br>&nbsp;</p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ContactPerson.$invalid && (vm.dataForm.ContactPerson.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'CONTACT_PERSON\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="ContactPerson" class="form-control" ng-model="vm.branch.contactPerson" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ContactPerson.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Telephone.$invalid && (vm.dataForm.Telephone.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'TELEPHONE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="Telephone" class="form-control" ng-model="vm.branch.tel" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Telephone.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'FAX\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" ng-model="vm.branch.fax"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Address1.$invalid && (vm.dataForm.Address1.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'ADDRESS_1\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="Address1" class="form-control" ng-model="vm.branch.address1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Address1.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'ADDRESS_2\' | translate }}</b></label> <input type="text" class="form-control" ng-model="vm.branch.address2"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'ADDRESS_3\' | translate }}</b></label> <input type="text" class="form-control" ng-model="vm.branch.address3"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.State.$invalid && (vm.dataForm.State.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'STATE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="State" class="form-control" ng-model="vm.branch.state" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.State.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PostalCode.$invalid && (vm.dataForm.PostalCode.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'POSTAL_CODE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="PostalCode" class="form-control" ng-model="vm.branch.postCode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PostalCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Country.$invalid && (vm.dataForm.Country.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'COUNTRY\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="Country" class="form-control" ng-model="vm.branch.country" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Country.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'ADDITIONAL_SETTINGS\' | translate }}" ng-if="vm.mode==2"><p style="color:#00f"><i class="fa fa-info-circle"></i> {{ \'ADDITIONAL_SETTINGS_FOR_BRANCH\' | translate }}<br>&nbsp;</p><div class="row" ng-if="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center>{{ \'PLEASE_SAVE_FIRST_BEFORE_ACCESS_THE_ADDITIONAL_SETTINGS\' | translate }}</center></h2></div></div><div ng-if="vm.mode==2"><div class="row" ng-if="vm.hasSmartKitchenFeature"><div class="col-md-4 col-lg-3"><div class="form-group"><label><b>{{ \'GPS_LATITUDE\' | translate }}</b></label> <input type="text" class="form-control" ng-model="vm.branchSetting.gps_Latitude"></div></div><div class="col-md-4 col-lg-3"><div class="form-group"><label><b>{{ \'GPS_LONGITUDE\' | translate }}</b></label> <input type="text" class="form-control" ng-model="vm.branchSetting.gps_Longitude"></div></div></div><div class="row" ng-if="vm.hasSmartKitchenFeature"><hr></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.branchSetting.setting_StockCount_SimpleMode" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger" ng-if="vm.isSuperAdmin || vm.canEditBranchSettings" ng-change="changed()"></toggle><div class="btn" style="width:100px" ng-class="{\'btn-success\': vm.branchSetting.setting_StockCount_SimpleMode, \'btn-danger\': !vm.branchSetting.setting_StockCount_SimpleMode }" ng-if="!vm.isSuperAdmin && !vm.canEditBranchSettings">{{ (vm.branchSetting.setting_StockCount_SimpleMode ? \'Yes\' : \'No\') }}</div></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>{{ \'SIMPLE_STOCK_COUNT\' | translate }}</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;{{ \'SIMPLE_COUNTING_WITHOUT_SCANNING_QR_CODE\' | translate }}</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.branchSetting.setting_StockIn_SimpleMode" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger" ng-if="vm.isSuperAdmin || vm.canEditBranchSettings" ng-change="changed()"></toggle><div class="btn" style="width:100px" ng-class="{\'btn-success\': vm.branchSetting.setting_StockIn_SimpleMode, \'btn-danger\': !vm.branchSetting.setting_StockIn_SimpleMode }" ng-if="!vm.isSuperAdmin && !vm.canEditBranchSettings">{{ (vm.branchSetting.setting_StockIn_SimpleMode ? \'Yes\' : \'No\') }}</div></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>{{ \'SIMPLE_STOCK_IN\' | translate }}</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;{{ \'SIMPLE_STOCK_IN_WITHOUT_SCANNING_QR_CODE\' | translate }}</div></div></div></div><div class="row"><p>&nbsp;</p><p>&nbsp;</p></div></uib-tab><uib-tab heading="AutoCount Fields" ng-if="vm.integrationMode==2"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'PROJECT_NO\' | translate }}</b></label><select name="projectNo" class="form-control" ng-change="vm.selectedProjectNoChanged()" ng-model="vm.selectedProjectNo" ng-options="i as (\'[\' + i.code + \'] \' + i.description) for i in vm.autoCountProjectNo"><option></option></select></div></div></div></uib-tab><uib-tab heading="SQL Fields" ng-if="vm.integrationMode==8"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'PROJECT_NO\' | translate }}</b></label><select name="projectNo" class="form-control" ng-change="vm.selectedProjectNoChanged()" ng-model="vm.selectedProjectNo" ng-options="i as (\'[\' + i.CODE + \'] \' + i.DESCRIPTION) for i in vm.autoCountProjectNo"><option></option></select></div></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/settings/branches/branchCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/branches/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> <span translate="CREATE_BRANCH"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.branches.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/settings/branches/branchList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.branchData" refresh-table=""><thead><tr><th colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.branches.create" rms-check-access="settings.branches" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_BRANCH"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="code">{{ \'BRANCH_CODE\' | translate }}</th><th st-sort="name">{{ \'BRANCH_NAME\' | translate }}</th><th>{{ \'TIME_ZONE\' | translate }}</th><th style="width:150px">{{ \'IS_DEFAULT_BRANCH\' | translate }}</th><th style="width:150px">{{ \'IS_FRANCHISEE\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th></th><th></th><th></th><th></th><th class="form-inline" style="width:150px"><select st-search="isDefault"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="i in vm.branchDataFull | unique:\'isDefault\' | orderBy:\'isDefault\'" value="{{i.isDefault}}">{{ i.isDefault ? \'Yes\' : \'No\' }}</option></select></th><th class="form-inline" style="width:150px"><select st-search="isFranchisee"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="i in vm.branchDataFull | unique:\'isFranchisee\' | orderBy:\'isFranchisee\'" value="{{i.isFranchisee}}">{{ i.isFranchisee ? \'Yes\' : \'No\' }}</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-show="vm.branchData.length==0 && !vm.isLoading"><td colspan="8" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="8" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.branchData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td>{{(item.timeZone > 0 ? \'GMT+\' : \'GMT\')}}{{item.timeZone | number:0}}</td><td><i class="fa fa-check" ng-show="item.isDefault" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isDefault" style="color:#f00"></i></td><td><i class="fa fa-check" ng-show="item.isFranchisee" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isFranchisee" style="color:#f00"></i></td><td style="width:40px"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="settings.branches.update({id:item.id})" rms-check-access="settings.branches" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td style="width:40px"><a href="" title="Delete Branch" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteBranch(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this branch?" rms-check-access="settings.branches" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/settings/branches/branchUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/branches/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.branches.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.branches.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/settings/emailtemplates/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LabelType.$invalid && (vm.dataForm.LabelType.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'EMAIL_TYPE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="LabelType" class="form-control" ng-change="vm.selectedEmailTypeChanged()" ng-model="vm.selectedEmailType" ng-options="u as u.name for u in vm.emailTypeList" required=""><option value="">-- {{ \'SELECT_AN_EMAIL_TYPE\' | translate }} --</option></select><span class="help-block" ng-if="vm.dataForm.$submitted && vm.dataForm.LabelType.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Branch.$invalid && (vm.dataForm.Branch.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'BRANCH\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="Branch" class="form-control" ng-change="vm.selectedBranchChanged()" ng-model="vm.selectedBranch" ng-options="b as b.name for b in vm.branchList" required=""><option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option></select><span class="help-block" ng-if="vm.dataForm.$submitted && vm.dataForm.Branch.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'DESCRIPTION\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-model="vm.emailtemplate.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'CC\' | translate }}</b></label><br><small><i class="fa fa-info-circle"></i>&nbsp;{{ \'SEPARATE_EACH_EMAIL_ADDRESS_USING_SEMI-COLON\' | translate }} (;)</small><br><input type="text" class="form-control" name="CC" ng-model="vm.emailtemplate.cc"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'BCC\' | translate }}</b></label><br><small><i class="fa fa-info-circle"></i>&nbsp;{{ \'SEPARATE_EACH_EMAIL_ADDRESS_USING_SEMI-COLON\' | translate }} (;)</small><br><input type="text" class="form-control" name="BCC" ng-model="vm.emailtemplate.bcc"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'REPLY-TO\' | translate }}</b></label> <input type="text" class="form-control" name="ReplyTo" ng-model="vm.emailtemplate.replyTo"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Subject.$invalid && (vm.dataForm.Subject.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SUBJECT\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Subject" ng-model="vm.emailtemplate.subject" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Subject.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.EmailContent.$invalid && (vm.dataForm.EmailContent.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'EMAIL_CONTENT\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><br><div text-angular="" ng-model="vm.emailtemplate.content" style="height:600px"></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.EmailContent.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>{{ \'VARIABLES_PLACEHOLDER\' | translate }}</b></label><br><i class="fa fa-info-circle"></i>&nbsp; {{ \'INSERT_THE_VARIABLE_PLACEHOLDER_INTO_THE_EMAIL_CONTENT_AND_IT_WILL_BE_FILLED_WITH_THE_CORRECT_VALUE\' | translate }}</div></div></div><table class="table table-bordered table-striped" style="font-size:80%"><tr ng-repeat="ntn in vm.selectedEmailType.variableList"><td nowrap="nowrap"><b>{{ ntn.code }}</b></td><td nowrap="nowrap">{{ ntn.name | translate }}</td></tr></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/settings/emailtemplates/emailtemplateCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/emailtemplates/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> <span translate="CREATE_TEMPLATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.emailtemplates.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/settings/emailtemplates/emailtemplateList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.emailtemplateData" refresh-table=""><thead><tr><th colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.emailtemplates.create" rms-check-access="settings.emailtemplates" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_TEMPLATE"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="emailType">{{ \'BRANCH\' | translate }}</th><th st-sort="emailType">{{ \'TEMPLATE_TYPE\' | translate }}</th><th st-sort="description">{{ \'TEMPLATE_DESCRIPTION\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="item in vm.emailtemplateData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.branchName}}</td><td>{{item.emailType}}</td><td>{{item.description}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="settings.emailtemplates.update({id:item.id})" rms-check-access="settings.emailtemplates" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Email Template" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteEmailTemplate(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this email template?" rms-check-access="settings.emailtemplates" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr><tr ng-show="vm.emailtemplateData.length<=0"><td colspan="6">{{ \'NO_RECORD_FOUND\' | translate }}.</td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/settings/emailtemplates/emailtemplateUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/emailtemplates/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.emailtemplates.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.emailtemplates.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/worktypes/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Type Code" ng-model="vm.workType.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Type.$invalid && (vm.dataForm.Type.$dirty || vm.dataForm.$submitted)}"><label><b translate="TYPE"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Type" ng-model="vm.workType.type" required=""><option></option><option value="INBOUND">{{ \'INBOUND\' | translate }}</option><option value="OUTBOUND">{{ \'OUTBOUND\' | translate }}</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Type.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/worktypes/worktypeCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/worktypes/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_WORK_TYPE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.worktypes.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/serviceconfigs/worktypes/worktypeList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.workTypeData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Work Type" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.worktypes.create" rms-check-access="serviceconfigs.worktypes" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_WORK_TYPE"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="type">{{ \'TYPE\' | translate }}</th><th st-sort="description">{{ \'DESCRIPTION\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.workTypeData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.workTypeData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.type}}</td><td>{{item.description}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="serviceconfigs.worktypes.update({id:item.id})" rms-check-access="serviceconfigs.worktypes" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Work Type" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteWorkType(item.id, item.description)" ng-confirm-click="Confirm delete this Work Type?" rms-check-access="serviceconfigs.worktypes" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/serviceconfigs/worktypes/worktypeUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/serviceconfigs/worktypes/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="serviceconfigs.worktypes.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="serviceconfigs.worktypes.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/settings/iprules/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_IP_RULES_TO_RESTRICT_UNAUTHORIZED_ACCESS"></span>.<br>&nbsp;</div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="CURRENT_IP_ADDRESS"></b></label><div><big>{{vm.currentIp || \'0.0.0.0\'}}</big></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="RULE_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Rule Name" ng-model="vm.iprule.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" style="margin-bottom:0px"><label><b translate="START_IP"></b> <i class="fa fa-asterisk req"></i></label></div></div></div><div class="row"><div class="col-md-1 col-lg-1"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FromIp1.$invalid && (vm.dataForm.FromIp1.$dirty || vm.dataForm.$submitted)}" style="margin-bottom:0px"><input type="text" class="form-control" name="FromIp1" ng-model="vm.iprule.fromIp1" required=""></div></div><div class="col-md-1 col-lg-1"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FromIp2.$invalid && (vm.dataForm.FromIp2.$dirty || vm.dataForm.$submitted)}" style="margin-bottom:0px"><input type="text" class="form-control" name="FromIp2" ng-model="vm.iprule.fromIp2" required=""></div></div><div class="col-md-1 col-lg-1"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FromIp3.$invalid && (vm.dataForm.FromIp3.$dirty || vm.dataForm.$submitted)}" style="margin-bottom:0px"><input type="text" class="form-control" name="FromIp3" ng-model="vm.iprule.fromIp3" required=""></div></div><div class="col-md-1 col-lg-1"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FromIp4.$invalid && (vm.dataForm.FromIp4.$dirty || vm.dataForm.$submitted)}" style="margin-bottom:0px"><input type="text" class="form-control" name="FromIp4" ng-model="vm.iprule.fromIp4" required=""></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><a href="" class="btn btn-default btn-with-icon" ng-click="vm.copyToIp1()"><i class="fa fa-copy"></i> <span translate="COPY_CURRENT_IP"></span></a></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': (vm.dataForm.FromIp1.$invalid || vm.dataForm.FromIp2.$invalid || vm.dataForm.FromIp3.$invalid || vm.dataForm.FromIp4.$invalid) && (vm.dataForm.FromIp1.$dirty || vm.dataForm.FromIp2.$dirty || vm.dataForm.FromIp3.$dirty || vm.dataForm.FromIp4.$dirty || vm.dataForm.$submitted)}"><span class="help-block" ng-show="vm.dataForm.$submitted && (vm.dataForm.FromIp1.$error.required || vm.dataForm.FromIp2.$error.required || vm.dataForm.FromIp3.$error.required || vm.dataForm.FromIp4.$error.required)">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" style="margin-bottom:0px"><label><b translate="END_IP"></b> <i class="fa fa-asterisk req"></i></label></div></div></div><div class="row"><div class="col-md-1 col-lg-1"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ToIp1.$invalid && (vm.dataForm.ToIp1.$dirty || vm.dataForm.$submitted)}" style="margin-bottom:0px"><input type="text" class="form-control" name="ToIp1" ng-model="vm.iprule.toIp1" required=""></div></div><div class="col-md-1 col-lg-1"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ToIp2.$invalid && (vm.dataForm.ToIp2.$dirty || vm.dataForm.$submitted)}" style="margin-bottom:0px"><input type="text" class="form-control" name="ToIp2" ng-model="vm.iprule.toIp2" required=""></div></div><div class="col-md-1 col-lg-1"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ToIp3.$invalid && (vm.dataForm.ToIp3.$dirty || vm.dataForm.$submitted)}" style="margin-bottom:0px"><input type="text" class="form-control" name="ToIp3" ng-model="vm.iprule.toIp3" required=""></div></div><div class="col-md-1 col-lg-1"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ToIp4.$invalid && (vm.dataForm.ToIp4.$dirty || vm.dataForm.$submitted)}" style="margin-bottom:0px"><input type="text" class="form-control" name="ToIp4" ng-model="vm.iprule.toIp4" required=""></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><a href="" class="btn btn-default btn-with-icon" ng-click="vm.copyToIp2()"><i class="fa fa-copy"></i> <span translate="COPY_CURRENT_IP"></span></a></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': (vm.dataForm.ToIp1.$invalid || vm.dataForm.ToIp2.$invalid || vm.dataForm.ToIp3.$invalid || vm.dataForm.ToIp4.$invalid) && (vm.dataForm.ToIp1.$dirty || vm.dataForm.ToIp2.$dirty || vm.dataForm.ToIp3.$dirty || vm.dataForm.ToIp4.$dirty || vm.dataForm.$submitted)}"><span class="help-block" ng-show="vm.dataForm.$submitted && (vm.dataForm.ToIp1.$error.required || vm.dataForm.ToIp2.$error.required || vm.dataForm.ToIp3.$error.required || vm.dataForm.ToIp4.$error.required)">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/settings/iprules/ipRuleCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/iprules/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_IP_RULE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.iprules.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/settings/iprules/ipRuleList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.ipruleData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search IP Range" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.iprules.create" rms-check-access="settings.iprules" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_IP_RULE"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span> :<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="description"><span translate="RULE_NAME"></span></th><th st-sort="fromIp1"><span translate="START_IP"></span></th><th st-sort="toIp1"><span translate="END_IP"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.ipruleData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.ipruleData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.description}}</td><td>{{item.fromIp1}}.{{item.fromIp2}}.{{item.fromIp3}}.{{item.fromIp4}}</td><td>{{item.toIp1}}.{{item.toIp2}}.{{item.toIp3}}.{{item.toIp4}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="settings.iprules.update({id:item.id})" rms-check-access="settings.iprules" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Branch" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteIpRule(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this IP Rule?" rms-check-access="settings.iprules" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/settings/iprules/ipRuleUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/iprules/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.iprules.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.iprules.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/settings/labeltemplates/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><div class="tab-content"><div class="row"><div class="col-md-6 col-lg-6"><div class="row"><div class="col-md-8 col-lg-8"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LabelTitle.$invalid && (vm.dataForm.LabelTitle.$dirty || vm.dataForm.$submitted)}"><label><b translate="LABEL_TITLE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="LabelTitle" ng-model="vm.template.labelTitle" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LabelTitle.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b><span translate="IS_DEFAULT"></span>?</b></label><div><toggle ng-model="vm.template.isDefault" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LabelType.$invalid && (vm.dataForm.LabelType.$dirty || vm.dataForm.$submitted)}"><label for="LabelType"><b translate="LABEL_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select name="LabelType" class="form-control" ng-change="vm.labelTypeChanged()" ng-model="vm.template.labelType" ng-options="c.type as c.type for c in vm.variables" required=""><option value=""></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LabelType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b><span translate="IS_ACTIVE"></span>?</b></label><div><toggle ng-model="vm.template.isEnabled" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-5 col-lg-5"><p><b><span translate="VARIABLE_LIST"></span>:</b></p><div style="max-height:200px;overflow:auto;border:1px solid #ccc"><table class="table table-bordered table-striped" style="font-size:80%"><tr ng-repeat="ntn in vm.selectedVariable.variableList"><td nowrap="nowrap"><b>{{ntn.name}}</b></td><td nowrap="nowrap">{{ntn.description}}</td></tr></table></div></div></div><br><br><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel panel-primary"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'LABEL_DESIGN\' | translate }}" class="panel-body"><div class="row"><div class="col-md-12 col-lg-12"><p><i class="fa fa-info-circle"></i>&nbsp; {{ \'MANAGE_THE_LABEL_TEMPLATE_STRUCTURE_BELOW\' | translate }}: &nbsp;&nbsp;&nbsp;&nbsp;<br></p></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><div ng-form="" editable-form="" name="vm.tableForm" class="form-inline" style="font-size:90%"><table class="table table-bordered table-striped" st-sticky-header=""><tr><td>#</td><td><b translate="OBJ_TYPE"></b></td><td><b translate="OBJ_ID"></b></td><td><b>X</b></td><td><b>Y</b></td><td><b>W</b></td><td><b>H</b></td><td><b translate="FONT"></b></td><td><b translate="BOLD"></b></td><td><b translate="ITALIC"></b></td><td><b translate="U.LINE"></b></td><td><b translate="ORIENT"></b></td><td><b translate="VALUE"></b></td><td style="width:20px"></td></tr><tr ng-if="vm.template.companyLabelTemplateFields.length==0"><td colspan="14" style="height:100px;line-height:100px"><center>{{ \'CLICK_HERE_TO_ADD_ELEMENT\' | translate }}&nbsp;&nbsp; <a class="btn btn-primary btn-sm" ng-click="vm.addLabelElement()"><i class="fa fa-plus"></i> {{ \'ADD_ITEM\' | translate }}</a></center></td></tr><tr ng-repeat="ntn in vm.template.companyLabelTemplateFields" class="editable-row"><td>{{$index+1}}</td><td><div editable-select="ntn.objType" e-ng-options="s.value as s.text for s in vm.objTypes" e-name="objType" e-form="vm.tableForm" e-style="width:80px;font-size:90%;padding:0px;color:#00f"></div></td><td><div editable-text="ntn.objId" e-name="objId" e-form="vm.tableForm" e-style="width:70px;font-size:90%;padding:5px">{{ ntn.objId || \'\' }}</div></td><td><div editable-text="ntn.pointX" e-name="pointX" e-form="vm.tableForm" e-style="width:45px;font-size:90%;padding:5px">{{ ntn.pointX || \'\' }}</div></td><td><div editable-text="ntn.pointY" e-name="pointY" e-form="vm.tableForm" e-style="width:45px;font-size:90%;padding:5px">{{ ntn.pointY || \'\' }}</div></td><td><div editable-text="ntn.width" e-name="width" e-form="vm.tableForm" e-style="width:45px;font-size:90%;padding:5px">{{ ntn.width || \'\' }}</div></td><td><div editable-text="ntn.height" e-name="height" e-form="vm.tableForm" e-style="width:45px;font-size:90%;padding:5px">{{ ntn.height || \'\' }}</div></td><td><div editable-text="ntn.fontSize" e-name="fontSize" e-form="vm.tableForm" e-style="width:45px;font-size:90%;padding:5px">{{ ntn.fontSize || \'\' }}</div></td><td><div editable-select="ntn.isBold" e-ng-options="s.value as s.text for s in vm.boolOptions" e-name="isBold" e-form="vm.tableForm" e-style="width:45px;font-size:90%;padding:0px;text-align:center"></div></td><td><div editable-select="ntn.isItalic" e-ng-options="s.value as s.text for s in vm.boolOptions" e-name="isItalic" e-form="vm.tableForm" e-style="width:45px;font-size:90%;padding:0px;text-align:center"></div></td><td><div editable-select="ntn.isUnderline" e-ng-options="s.value as s.text for s in vm.boolOptions" e-name="isUnderline" e-form="vm.tableForm" e-style="width:45px;font-size:90%;padding:0px;text-align:center"></div></td><td><div editable-select="ntn.orientation" e-ng-options="s.value as s.text for s in vm.orientOptions" e-name="orientation" e-form="vm.tableForm" e-style="width:45px;font-size:90%;padding:0px;text-align:center"></div></td><td><div editable-text="ntn.value" e-name="value" e-form="vm.tableForm" e-style="width:355px;font-size:90%;padding:5px">{{ ntn.value || \'\' }}</div></td><td><a class="btn btn-danger btn-xs" ng-click="vm.removeLabelElement($index)"><i class="ion ion-close"></i></a></td></tr><tr ng-if="vm.template.companyLabelTemplateFields.length!=0"><td colspan="14"><a class="btn btn-primary btn-xs" ng-click="vm.addLabelElement()"><i class="fa fa-plus"></i> <span translate="ADD_MORE"></span></a></td></tr></table></div></div></div></div></uib-tab></uib-tabset></div></div></div></div></div><script type="text/ng-template" id="cloneTemplateModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="CLONE_TEMPLATE_TO_OTHER_COMPANY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.cloneForm.Company.$invalid && $mdl.cloneForm.$submitted}"> <label><b><span translate="SELECT_A_COMPANY"></span>:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="Company" ng-options="c as (c.name | uppercase) for c in $mdl.companies track by c.id" ng-model="$mdl.selectedCompany" required> <option value="">-- {{ \'SELECT_A_COMPANY\' }} --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.cloneForm.Company.$error.required && $mdl.cloneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/settings/labeltemplates/labeltemplateCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/labeltemplates/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.isLockButton"><i class="ion ion-checkmark"></i> <span translate="CREATE_TEMPLATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.labeltemplates.list" ng-disabled="vm.isLockButton"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/settings/labeltemplates/labeltemplateList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.templateData" refresh-table=""><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.labeltemplates.create" rms-check-access="settings.labeltemplates" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_TEMPLATE"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="labelTitle">{{ \'TEMPLATE_TYPE\' | translate }}</th><th st-sort="labelTitle"><span translate="TEMPLATE_TITLE"></span></th><th translate="IS_DEFAULT"></th><th translate="IS_ACTIVE"></th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.templateData.length<=0 && !vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.templateData | orderBy:[\'labelType\', \'labelTitle\']"><td>{{vm.startIndex+1+$index}})</td><td>{{item.labelType}}</td><td>{{item.labelTitle}}</td><td><i class="fa fa-check" ng-show="item.isDefault" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isDefault" style="color:#f00"></i></td><td><i class="fa fa-check" ng-show="item.isEnabled" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isEnabled" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="settings.labeltemplates.update({id:item.id})" rms-check-access="settings.labeltemplates" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Clone" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#38ac2c" confirmed-click="vm.cloneTemplate(item.id)" ng-confirm-click="Confirm to clone this Template [{{item.labelTitle}}]?" rms-check-access="settings.labeltemplates" rms-check-access-perm-type="UPDATE"><i class="fa fa-clone"></i></a></td><td align="center"><a href="" title="Delete Template" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteTemplate(item.id, item.labelTitle)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Template?" rms-check-access="settings.labeltemplates" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/settings/labeltemplates/labeltemplateUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/labeltemplates/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.labeltemplates.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.isLockButton"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.labeltemplates.list" ng-disabled="vm.isLockButton"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-warning btn-with-icon" style="margin-left:20px" ng-show="vm.mode==2" ng-click="vm.testPrint()" ng-disabled="vm.isLockButton"><i class="fa fa-print"></i> <span translate="TEST_PRINT"></span></a> <a href="" class="btn btn-primary btn-with-icon pull-right" style="margin-right:5px" ng-if="vm.isSuperAdmin || vm.canCloneRecipe" ng-click="vm.showCloneTemplateModal()" ng-disabled="vm.lockUpdateButtons"><i class="ion ion-social-buffer"></i> <span translate="CLONE_TO_OTHER_COMPANY"></span></a></div></form>');
$templateCache.put('app/pages/settings/departments/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DepartmentCode.$invalid && (vm.dataForm.DepartmentCode.$dirty || vm.dataForm.$submitted)}"><label>{{ \'DEPARTMENT_CODE\' | translate }} <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DepartmentCode" ng-model="vm.department.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DepartmentCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DepartmentName.$invalid && (vm.dataForm.DepartmentName.$dirty || vm.dataForm.$submitted)}"><label>{{ \'DEPARTMENT_NAME\' | translate }} <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DepartmentName" ng-model="vm.department.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DepartmentName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/settings/departments/departmentCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/departments/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> <span translate="CREATE_DEPARTMENT"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.departments.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/settings/departments/departmentList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.departmentData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.departments.create" rms-check-access="settings.departments" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_DEPARTMENT"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:180px" st-sort="name">{{ \'DEPARTMENT_CODE\' | translate }}</th><th st-sort="name">{{ \'DEPARTMENT_NAME\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.departmentData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.departmentData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="settings.departments.update({id:item.id})" rms-check-access="settings.departments" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Department" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteDepartment(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this department?" rms-check-access="settings.departments" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/settings/departments/departmentUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/departments/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.departments.list" style="margin-right:10px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.departments.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/settings/resellercommconfig/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span>Manage the commission for your Resellers. Please ensure the commission amount is correct.</span><br><br></p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Software Package</b></label> <span class="form-control" ng-disabled="true">{{vm.getModuleName(vm.config.moduleType)}}</span></div></div></div><hr><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FirstYearCommMonthly.$invalid && (vm.dataForm.FirstYearCommMonthly.$dirty || vm.dataForm.$submitted)}"><label><b>1st Year Commission (Monthly)</b> <i class="fa fa-asterisk req"></i></label><div class="input-group"><span class="input-group-addon">RM</span> <input type="number" class="form-control" name="FirstYearCommMonthly" ng-model="vm.config.firstYearCommMonthly" required="" min="1"></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstYearCommMonthly.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstYearCommMonthly.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstYearCommMonthly.$error.min">* Minimum is 1</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FirstYearCommAnnual.$invalid && (vm.dataForm.FirstYearCommAnnual.$dirty || vm.dataForm.$submitted)}"><label><b>1st Year Commission (Annual)</b> <i class="fa fa-asterisk req"></i></label><div class="input-group"><span class="input-group-addon">RM</span> <input type="number" class="form-control" name="FirstYearCommAnnual" ng-model="vm.config.firstYearCommAnnual" required="" min="1"></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstYearCommAnnual.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstYearCommAnnual.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstYearCommAnnual.$error.min">* Minimum is 1</span></div></div></div><hr><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.RenewalYearCommMonthly.$invalid && (vm.dataForm.RenewalYearCommMonthly.$dirty || vm.dataForm.$submitted)}"><label><b>Subsequent Year Commission (Monthly)</b> <i class="fa fa-asterisk req"></i></label><div class="input-group"><span class="input-group-addon">RM</span> <input type="number" class="form-control" name="RenewalYearCommMonthly" ng-model="vm.config.renewalYearCommMonthly" required="" min="1"></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RenewalYearCommMonthly.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RenewalYearCommMonthly.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RenewalYearCommMonthly.$error.min">* Minimum is 1</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.RenewalYearCommAnnual.$invalid && (vm.dataForm.RenewalYearCommAnnual.$dirty || vm.dataForm.$submitted)}"><label><b>Subsequent Year Commission (Annual)</b> <i class="fa fa-asterisk req"></i></label><div class="input-group"><span class="input-group-addon">RM</span> <input type="number" class="form-control" name="RenewalYearCommAnnual" ng-model="vm.config.renewalYearCommAnnual" required="" min="1"></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RenewalYearCommAnnual.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RenewalYearCommAnnual.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.RenewalYearCommAnnual.$error.min">* Minimum is 1</span></div></div></div><hr><div class="row"><div class="col-lg-6"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" ng-model="vm.config.remarks">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/settings/resellercommconfig/resellerCommConfigList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.commData" refresh-table="" style="font-size:90%"><thead><tr class="sortable"><th rowspan="2" style="width:60px">#</th><th rowspan="2" style="width:200px">Software Package</th><th colspan="2" style="width:300px;border-left:1px solid #ccc;text-align:center" class="hide-after">First Year Commission</th><th colspan="2" style="width:300px;border-left:1px solid #ccc;text-align:center" class="hide-after">Subsequent Year Commission</th><th rowspan="2" style="border-left:1px solid #ccc;width:20px"></th><th rowspan="2">Remarks</th><th rowspan="2" style="width:40px"></th></tr><tr class="sortable"><th style="width:150px;border-left:1px solid #ccc;text-align:center" class="hide-after">Monthly</th><th style="width:150px;border-left:1px solid #ccc;text-align:center" class="hide-after">Yearly</th><th style="width:150px;border-left:1px solid #ccc;text-align:center" class="hide-after">Monthly</th><th style="width:150px;border-left:1px solid #ccc;border-right:1px solid #ccc;text-align:center" class="hide-after">Yearly</th></tr></thead><tbody><tr ng-if="vm.commData.length<=0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.commData | orderBy: \'-moduleType\'"><td>{{vm.startIndex+1+$index}})</td><td>{{vm.getModuleName(item.moduleType)}}</td><td style="border-left:1px solid #ccc;text-align:center">{{item.firstYearCommMonthly | number}}</td><td style="border-left:1px solid #ccc;text-align:center">{{item.firstYearCommAnnual | number}}</td><td style="border-left:1px solid #ccc;text-align:center">{{item.renewalYearCommMonthly | number}}</td><td style="border-left:1px solid #ccc;text-align:center">{{item.renewalYearCommAnnual | number}}</td><td style="border-left:1px solid #ccc"></td><td>{{item.remarks || \'-\'}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-with-icon btn-xs" style="width:80px" ui-sref="settings.resellercommconfig.update({id:item.id})" rms-check-access="settings.resellercommconfig" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i> Manage</a></td></tr></tbody></table></div></div></div></div><script type="text/ng-template" id="approvalModal.html"><form name="$mdl.approvalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> New Customer Approval </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <label><b>Dealer / Agency Name:</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.dealerName}} </span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <label><b>Reseller Name:</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.resellerName}} </span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <label><b>Customer Name:</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.name}} </span> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b>Software Package:</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.packageMode}} </span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b>Package Fee (RM):</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.packageFee}} </span> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b>Billing Option:</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.billingIntervalType | uppercase}} </span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b>Proforma Invoice #:</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.proformaInvoiceNo}} </span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.approvalForm.PaymentRemarks.$invalid && ($mdl.approvalForm.PaymentRemarks.$dirty || $mdl.approvalForm.$submitted)}"> <label><b>Payment Remarks (Cheque No. / Transaction No.):</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="PaymentRemarks" class="form-control" style="background:#fffeed;color:#000" ng-model="$mdl.aff.paymentRemarks" required /> <span class="help-block" style="color:#f00" ng-if="$mdl.approvalForm.$submitted && $mdl.approvalForm.PaymentRemarks.$error.required"> * {{ "REQUIRED" | translate }} </span> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="mdl.lockButtons" ng-click="$mdl.confirmModal()" > <i class="ion ion-checkmark"></i> <span translate="APPROVE"></span> </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/settings/resellercommconfig/resellerCommConfigUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/resellercommconfig/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.resellercommconfig.list" style="margin-right:30px"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.resellercommconfig.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/settings/usergroups/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UgName.$invalid && (vm.dataForm.UgName.$dirty || vm.dataForm.$submitted)}"><label for="UgName"><b translate="USERGROUP_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="UgName" ng-model="vm.usergroup.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p><br></p></div><div class="row"><div class="col-md-3 col-lg-3"><legend style="height:32.4px;line-height:32.4px"><span translate="TEAM_ACCESS"></span></legend><div class="row" ng-if="vm.isUserSuperAdmin"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_SUPER_ADMIN"></b></label><div><toggle ng-model="vm.usergroup.isSuperAdmin" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.hasFranchiseAccess"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_FRANCHISEE_/_OUTLET"></b></label><div><toggle ng-model="vm.usergroup.isFranchisee" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_PRODUCTION_TEAM"></b></label><div><toggle ng-model="vm.usergroup.isProductionTeam" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_DRIVER"></b></label><div><toggle ng-model="vm.usergroup.isDriver" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.hasWorkOrderAccess"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_TECHNICIAN_TEAM"></b></label><div><toggle ng-model="vm.usergroup.isTechnicianTeam" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.hasCaseMgmtAccess"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_CUSTOMER_SERVICE_TEAM"></b></label><div><toggle ng-model="vm.usergroup.isCustomerServiceTeam" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.hasWorkOrderAccess"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_AFTERSALES_MANAGER"></b></label><div><toggle ng-model="vm.usergroup.isAfterSalesManager" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p><br></p></div></div><div class="col-md-3 col-lg-3"><legend style="height:32.4px;line-height:32.4px"><span translate="SPECIAL_ACCESS"></span></legend><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="CAN_ACCESS_RECIPE\'S_FOOD_COST"></b></label><div><toggle ng-model="vm.usergroup.canAccessFoodCost" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="CAN_ACCESS_RECIPE\'S_INGREDIENTS"></b></label><div><toggle ng-model="vm.usergroup.canAccessIngredient" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.isUserSuperAdmin"><div class="col-lg-12"><div class="form-group"><label><b translate="CAN_CLONE_RECIPES_TO_OTHER_COMPANIES"></b></label><div><toggle ng-model="vm.usergroup.canCloneRecipe" ng-if="vm.isUserSuperAdmin" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.isUserSuperAdmin"><div class="col-lg-12"><div class="form-group"><label><b translate="CAN_CLONE_S.O.P_TO_OTHER_COMPANIES"></b></label><div><toggle ng-model="vm.usergroup.canCloneSop" ng-if="vm.isUserSuperAdmin" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.isUserSuperAdmin"><div class="col-lg-12"><div class="form-group"><label><b translate="CAN_SET_IOT_HARDWARE_SETTINGS"></b></label><div><toggle ng-model="vm.usergroup.canSetIoTHardwareSettings" ng-if="vm.isUserSuperAdmin" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p><br></p></div></div><div class="col-md-3 col-lg-3"><legend style="height:32.4px;line-height:32.4px"><span translate="VIEW_ACCESS"></span></legend><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="VIEW_OWN_RECIPES_/_SOP_ONLY"></b></label><div><toggle ng-model="vm.usergroup.isViewOwnRecipe" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="VIEW_OWN_BRANCHS_DATA_ONLY"></b></label><div><toggle ng-model="vm.usergroup.isViewOwnBranch" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="VIEW_OWN_DEPARTMENTS_DATA_ONLY"></b></label><div><toggle ng-model="vm.usergroup.isViewOwnDepartment" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="VIEW_OWN_DOCUMENTS_ONLY"></b></label><div><toggle ng-model="vm.usergroup.isViewOwnDocument" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div><div class="col-md-3 col-lg-3"><legend style="height:32.4px;line-height:32.4px"><span translate="DASHBOARD_ACCESS"></span></legend><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="VIEW_GENERAL_DASHBOARD"></b></label><div><toggle ng-model="vm.usergroup.isDashboardGeneralView" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.hasDurianOpsAccess"><div class="col-lg-12"><div class="form-group"><label><b translate="VIEW_DURIAN_DASHBOARD"></b></label><div><toggle ng-model="vm.usergroup.isDashboardDurianOpsView" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.hasWorkOrderAccess"><div class="col-lg-12"><div class="form-group"><label><b translate="VIEW_AFTERSALES_DASHBOARD"></b></label><div><toggle ng-model="vm.usergroup.isDashboardAfterSalesView" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><br><br><br><legend style="height:32.4px;line-height:32.4px"><span translate="LICENSE_TYPE"></span></legend><div class="row"><div class="col-lg-12"><div class="form-group"><label><b translate="IS_LIMITED_ACCESS"></b></label><div><toggle ng-model="vm.usergroup.isLimitedAccess" ng-change="vm.selectedLimitedChanged()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.usergroup.isLimitedAccess"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LimitedUserType.$invalid && (vm.dataForm.LimitedUserType.$dirty || vm.dataForm.$submitted)}"><label><b translate="LIMITED_USER_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="LimitedUserType" ng-options="u as u.description for u in vm.limiteds" ng-model="vm.selectedLimited" ng-change="vm.limitedUserTypeChanged()" ng-required="vm.usergroup.isLimitedAccess"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LimitedUserType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div></div></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="{{ \'FEATURES\' | translate }}"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p><b translate="SELECT_AT_LEAST_ONE_FEATURE"></b><i class="fa fa-asterisk req"></i></p><p><small><i class="fa fa-info-circle"></i> <span translate="CLICK_ON_THE_FEATURE_NAME_TO_TOGGLE_ACCESS"></span></small></p></div></div><div class="row"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:1px solid #ccc" st-table="" st-sticky-header=""><thead><tr><th><b translate="FEATURE_NAME"></b> <input type="hidden" ng-model="f.featureId"> <input type="hidden" ng-model="f.userGroupId"></th><th style="text-align:center"><b translate="ACCESS"></b><br><a href="" ng-click="vm.selectAll(\'ACCESS\')"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll(\'ACCESS\')" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th><th style="text-align:center"><b translate="VIEW"></b><br><a href="" ng-click="vm.selectAll(\'VIEW\')"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll(\'VIEW\')" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th><th style="text-align:center"><b translate="CREATE"></b><br><a href="" ng-click="vm.selectAll(\'CREATE\')"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll(\'CREATE\')" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th><th style="text-align:center"><b translate="UPDATE"></b><br><a href="" ng-click="vm.selectAll(\'UPDATE\')"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll(\'UPDATE\')" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th><th style="text-align:center"><b translate="DELETE"></b><br><a href="" ng-click="vm.selectAll(\'DELETE\')"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll(\'DELETE\')" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th><th style="text-align:center"><b translate="EXPORT"></b><br><a href="" ng-click="vm.selectAll(\'EXPORT\')"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll(\'EXPORT\')" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th><th style="text-align:center"><b translate="APPROVE"></b><br><a href="" ng-click="vm.selectAll(\'APPROVE\')"><i class="ion ion-android-checkbox-outline"></i></a> <a href="" ng-click="vm.deselectAll(\'APPROVE\')" style="margin-left:10px"><i class="ion ion-android-checkbox-outline-blank"></i></a></th></tr></thead><tbody><tr ng-repeat="f in vm.features | orderBy:\'sequence\'"><td style="width:30%"><a href="" ng-click="vm.toggleFeature(f.featureId)"><span ng-if="!f.isParent"><i class="fa fa-long-arrow-right"></i> &nbsp;&nbsp;{{f.name}}</span> <span ng-if="f.isParent"><b>{{f.name}}</b><span></span></span></a></td><td align="center" style="width:10%;line-height:25px"><input type="checkbox" ng-model="f.canAccess" ng-change="change()" style="background:#fffff4;width:25px;height:25px"></td><td align="center" style="width:10%;line-height:40px"><input type="checkbox" ng-model="f.canRead" ng-change="change()" style="background:#fffff4;width:25px;height:25px"></td><td align="center" style="width:10%;line-height:40px"><input type="checkbox" ng-model="f.canCreate" ng-change="change()" style="background:#fffff4;width:25px;height:25px"></td><td align="center" style="width:10%;line-height:40px"><input type="checkbox" ng-model="f.canUpdate" ng-change="change()" style="background:#fffff4;width:25px;height:25px"></td><td align="center" style="width:10%;line-height:40px"><input type="checkbox" ng-model="f.canDelete" ng-change="change()" style="background:#fffff4;width:25px;height:25px"></td><td align="center" style="width:10%;line-height:40px"><input type="checkbox" ng-model="f.canExport" ng-change="change()" style="background:#fffff4;width:25px;height:25px"></td><td align="center" style="width:10%;line-height:40px"><input type="checkbox" ng-model="f.canApprove" ng-change="change()" style="background:#fffff4;width:25px;height:25px"></td></tr></tbody></table></div></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="{{ \'AFTERSALES_OPTIONS\' | translate }}" ng-if="vm.hasWorkOrderAccess || vm.hasLoanRequestAccess"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_VARIOUS_AFTERSALES_MODULES\'_SETTINGS_(APPLICABLE_TO_AFTERSALES_MODULE_ONLY)."></span><br><br></p><div class="row"><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px"><span translate="WORK_ORDER_STATUSES"></span> <a href="" class="btn btn-primary btn-with-icon btn-xs" style="margin:5px" ng-click="vm.showAddWorkOrderStatusModal()"><i class="ion-plus-round"></i><span translate="ADD_MORE"></span></a></legend><p><i class="fa fa-info-circle"></i> <small><span translate="LIST_OF_STATUSES_PERMISSIBLE_FOR_WORK_ORDER_DOCUMENTS"></span>.</small></p><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="WORK_ORDER_STATUS"></b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.usergroup.userGroupWorkStates"><td>{{ $index+1 }})</td><td>{{ ntn.name || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeWorkOrderStatus($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr ng-if="vm.usergroup.userGroupWorkStates.length==0"><td colspan="3" align="center"><br><span translate="WORK_ORDER_STATUS_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px"><span translate="LOAN_REQUEST_STATUSES"></span> <a href="" class="btn btn-primary btn-with-icon btn-xs" style="margin:5px" ng-click="vm.showAddLoanStatusModal()"><i class="ion-plus-round"></i><span translate="ADD_MORE"></span></a></legend><p><i class="fa fa-info-circle"></i> <small><span translate="LIST_OF_STATUSES_PERMISSIBLE_FOR_LOAN_REQUEST_DOCUMENTS"></span>.</small></p><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="LOAN_REQUEST_STATUS"></b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.usergroup.userGroupLoanStates"><td>{{ $index+1 }})</td><td>{{ ntn.name || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeLoanStatus($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr ng-if="vm.usergroup.userGroupLoanStates.length==0"><td colspan="3" align="center"><br><span translate="LOAN_STATUS_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px"><span translate="LOAN_ITEM_STATUSES"></span> <a href="" class="btn btn-primary btn-with-icon btn-xs" style="margin:5px" ng-click="vm.showAddLoanItemStatusModal()"><i class="ion-plus-round"></i><span translate="ADD_MORE"></span></a></legend><p><i class="fa fa-info-circle"></i> <small><span translate="LIST_OF_STATUSES_PERMISSIBLE_FOR_SPARE_PARTS_IN_LOAN_REQUEST_DOCUMENTS"></span>.</small></p><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="LOAN_ITEM_STATUS"></b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.usergroup.userGroupLoanItemStates"><td>{{ $index+1 }})</td><td>{{ ntn.name || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeLoanItemStatus($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr ng-if="vm.usergroup.userGroupLoanItemStates.length==0"><td colspan="3" align="center"><br><span translate="LOAN_ITEM_STATUS_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="LoanStatusModal.html"><form name="$mdl.statusForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ \'ADD_LOAN_STATUS\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SELECT_A_LOAN_REQUEST_STATUS"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedStatus" on-select="$mdl.selectedStatusChanged()"> <ui-select-match placeholder="{{ \'SEARCH_FOR_STATUS\' | translate }}"> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.statuses | filter: $select.search" minimum-input-length="2"> <span ng-bind-html="i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.selectedStatus==null && $mdl.statusForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING"> ...</b> </div> <button type="button" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-disabled="$mdl.lockButton" confirmed-click="$mdl.addAll()" ng-confirm-click="Confirm add all Statuses?"> <i class="ion ion-checkmark"></i><span translate="ADD_ALL"></span> </button> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="LoanItemStatusModal.html"><form name="$mdl.statusForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ \'ADD_LOAN_ITEM_STATUS\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SELECT_A_LOAN_ITEM_STATUS"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedStatus" on-select="$mdl.selectedStatusChanged()"> <ui-select-match placeholder="{{ \'SEARCH_FOR_STATUS\' | translate }}"> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.statuses | filter: $select.search" minimum-input-length="2"> <span ng-bind-html="i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.selectedStatus==null && $mdl.statusForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING"> ...</b> </div> <button type="button" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-disabled="$mdl.lockButton" confirmed-click="$mdl.addAll()" ng-confirm-click="Confirm add all Statuses?"> <i class="ion ion-checkmark"></i><span translate="ADD_ALL"></span> </button> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="WorkOrderStatusModal.html"><form name="$mdl.statusForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ \'ADD_WORK_ORDER_STATUS\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SELECT_A_WORK_ORDER_STATUS"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedStatus" on-select="$mdl.selectedStatusChanged()"> <ui-select-match placeholder="{{ \'SEARCH_FOR_STATUS\' | translate }}"> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.statuses | filter: $select.search" minimum-input-length="2"> <span ng-bind-html="i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.selectedStatus==null && $mdl.statusForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING"> ...</b> </div> <button type="button" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-disabled="$mdl.lockButton" confirmed-click="$mdl.addAll()" ng-confirm-click="Confirm add all Statuses?"> <i class="ion ion-checkmark"></i><span translate="ADD_ALL"></span> </button> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/settings/usergroups/usergroupCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/usergroups/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> <span translate="CREATE_USERGROUP"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.usergroups.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/settings/usergroups/usergroupList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.usergroupData" st-safe-src="vm.userDataFull" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.usergroups.create" rms-check-access="settings.usergroups" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_USERGROUP"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="name"><span translate="USERGROUP"></span></th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.usergroupData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.usergroupData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td><a href="" title="Clone Useegroup" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#000" confirmed-click="vm.cloneUsergroup(item.id)" ng-confirm-click="Clone this usergroup [{{item.name}}]?" rms-check-access="settings.usergroups" rms-check-access-perm-type="CREATE"><i class="fa fa-copy text-warning"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="settings.usergroups.update({id:item.id})" rms-check-access="settings.usergroups" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Usergroup" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteUsergroup(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this usergroup?" rms-check-access="settings.usergroups" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/settings/usergroups/usergroupUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/usergroups/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.usergroups.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.usergroups.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/settings/notificationsettings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.User.$invalid && (vm.dataForm.User.$dirty || vm.dataForm.$submitted)}"><label><b translate="NOTIFY_USER"></b> <i class="fa fa-asterisk req" ng-if="!vm.notif.notifyDocumentOwner"></i></label><select name="User" class="form-control" ng-change="vm.selectedUserChanged()" ng-model="vm.selectedUser" ng-options="i as (i.loginId | uppercase) for i in vm.userList" ng-required="!vm.notif.notifyDocumentOwner"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.User.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="NOTIFY_DOCUMENT_CREATOR"></b></label><div><toggle ng-model="vm.notif.notifyDocumentOwner" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="IS_ACTIVE"></b></label><div><toggle ng-model="vm.notif.isActive" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Module.$invalid && (vm.dataForm.Module.$dirty || vm.dataForm.$submitted)}"><label><b translate="MODULE"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Module" ng-options="m as m.name for m in vm.moduleList" ng-change="vm.selectedModuleChanged()" ng-model="vm.selectedModule" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Module.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="EMAIL_ALERT"></b></label><div><toggle ng-model="vm.notif.notifyViaEmail" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Status.$invalid && (vm.dataForm.Status.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'STATUS\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Status" ng-options="s as s.name for s in vm.selectedModule.statuses" ng-change="vm.selectedStatusChanged()" ng-model="vm.selectedStatus" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Status.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="PUSH_NOTIFICATION"></b></label><div><toggle ng-model="vm.notif.notifyViaMessage" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/settings/notificationsettings/notificationsettingCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/notificationsettings/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.notificationsettings.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/settings/notificationsettings/notificationsettingList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.notifData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.notificationsettings.create" rms-check-access="settings.notificationsettings" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_NOTIFICATION"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="module"><span translate="MODULE_NAME"></span></th><th st-sort="status"><span translate="STATUS_TRIGGER"></span></th><th st-sort="user"><span translate="NOTIFY_USER"></span></th><th class="hide-after" style="text-align:center"><i class="fa fa-commenting"></i></th><th class="hide-after" style="text-align:center"><i class="fa fa-envelope"></i></th><th class="hide-after" style="text-align:center"><span translate="IS_ACTIVE"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.notifData.length<=0"><td colspan="9">{{ \'NO_RECORD_FOUND\' | translate }}.</td></tr><tr ng-repeat="item in vm.notifData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.module}}</td><td>{{item.status}}</td><td>{{item.user | uppercase}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.notifyViaMessage" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.notifyViaMessage" style="color:#f00"></i></td><td style="text-align:center"><i class="fa fa-check" ng-show="item.notifyViaEmail" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.notifyViaEmail" style="color:#f00"></i></td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="settings.notificationsettings.update({id:item.id})" rms-check-access="settings.notificationsettings" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Notification" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteNotification(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this notification?" rms-check-access="settings.notificationsettings" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/settings/notificationsettings/notificationsettingUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/notificationsettings/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.notificationsettings.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.notificationsettings.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/smartiotsettings/devicegroups/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b>Group Description</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-model="vm.group.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'SELECT_A_BRANCH\' | translate }} ({{ \'OPTIONAL\' | translate }}):</b><br><small>Note: Branch selection is only needed for Smart Automated Kitchen usage.</small></label> <a href="" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" confirmed-click="vm.clearBranch()" ng-confirm-click="Clear selected Branch?" ng-if="vm.selectedBranch!=null"><i class="fa fa-trash"></i> {{ \'CLEAR\' | translate }}</a><select class="form-control" ng-options="b as (b.name | uppercase) for b in vm.branchList track by b.id" ng-change="vm.selectedBranchChanged()" ng-model="vm.selectedBranch"><option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option></select></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="IS_ACTIVE"></b></label><div><toggle ng-model="vm.group.isEnabled" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Devices"><p><i class="fa fa-info-circle"></i> Manage the gateway / sensor devices in this group. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddDevicePanel()"><i class="ion-plus-round"></i> Add Device</a><br><br></p><div class="row" ng-if="vm.addDevicePanelVisible"><div class="col-lg-9"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-lg-6">Add Gateway / Sensor Devices</div><div class="col-lg-6"><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" ng-click="vm.closeAddDevicePanel()"><i class="ion ion-close"></i> {{ \'CLOSE_PANEL\' | translate }}</a></div></div></div><div class="panel-body" style="padding:20px"><div class="row"><div class="col-lg-6"><div class="form-group"><label><b>Select a Gateway device:</b></label><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedGatewayChanged()" ng-options="b as (\'[ \' + b.deviceUID + \' ] \' + b.description | uppercase) for b in vm.gatewayList | orderBy:\'description\'" ng-model="vm.selectedGateway"><option value="">-- select a gateway --</option></select><a href="" class="btn btn-primary btn-with-icon btn-xs pull-right" style="margin-top:3px" ng-click="vm.addGateway()"><i class="ion-plus-round"></i> Add Gateway</a></div></div><div class="col-lg-6"><div class="form-group"><label><b>Select a Sensor device:</b></label><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedSensorChanged()" ng-options="b as (\'[ \' + b.deviceUID + \' ] \' + b.description | uppercase) for b in vm.sensorList | orderBy:\'description\'" ng-model="vm.selectedSensor"><option value="">-- select a sensor --</option></select><a href="" class="btn btn-primary btn-with-icon btn-xs pull-right" style="margin-top:3px" ng-click="vm.addSensor()"><i class="ion-plus-round"></i> Add Sensor</a></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><table class="table table-striped" style="border:1px solid #ccc;font-size:90%"><thead><tr class="sortable"><th style="width:60px">#</th><th style="width:120px">Type</th><th style="width:130px"><b>Device UID</b></th><th style="width:250px"><b>Device UUID</b></th><th><b>Deviec Description</b></th><th style="width:100px"></th></tr></thead><tbody><tr ng-repeat="item in vm.group.siotGroupDevices"><td>{{ $index+1 }})</td><td style="line-height:100%;font-size:110%"><span class="report-type-tag" style="text-align:center">{{item.deviceType}}</span></td><td>{{ item.deviceUID || \'-\' }}</td><td>{{ item.deviceUUID || \'-\' }}</td><td>{{ item.description || \'-\' }}</td><td style="padding-top:2px;padding-bottom:2px"><a class="btn btn-danger btn-with-icon btn-xs" confirmed-click="vm.removeDevice($index)" ng-confirm-click="Confirm remove this Device?"><i class="fa fa-trash-o"></i> Remove</a></td></tr><tr><td colspan="9" style="text-align:center" ng-if="!vm.group.siotGroupDevices || vm.group.siotGroupDevices.length==0"><br><span>Device list is empty.</span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="User Access"><p><i class="fa fa-info-circle"></i> Manage the user access for this group. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddUserPanel()"><i class="ion-plus-round"></i> Add User</a><br><br></p><div class="row" ng-if="vm.addUserPanelVisible"><div class="col-lg-6"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="row"><div class="col-lg-6">Add Authorized Users</div><div class="col-lg-6"><a href="" class="btn btn-danger btn-with-icon btn-xs pull-right" ng-click="vm.closeAddUserPanel()"><i class="ion ion-close"></i> {{ \'CLOSE_PANEL\' | translate }}</a></div></div></div><div class="panel-body" style="padding:20px"><div class="row"><div class="col-lg-9"><div class="form-group"><label><b>Select a User:</b></label><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedUserChanged()" ng-options="b as ((b.firstName + \' \' + b.lastName) | uppercase) for b in vm.userList | orderBy:\'firstName\'" ng-model="vm.selectedUser"><option value="">-- select a user --</option></select><a href="" class="btn btn-primary btn-with-icon btn-xs pull-right" style="margin-top:3px" ng-click="vm.addUser()"><i class="ion-plus-round"></i> Add User</a> <a href="" class="btn btn-info btn-with-icon btn-xs pull-right" style="margin-top:3px;margin-right:5px" ng-click="vm.addAllUsers()"><i class="ion-plus-round"></i> Add All Users</a></div></div></div></div></div></div></div><div class="row"><div class="col-sm-6 col-md-6 col-lg-6"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b>Authorized User</b></th><th style="width:120px;padding-top:10px;padding-bottom:20px" class="hide-after"><a class="btn btn-danger btn-with-icon btn-xs" style="width:120px" ng-if="vm.group.siotGroupUsers.length!=0" confirmed-click="vm.removeAllUsers()" ng-confirm-click="Confirm remove all Users?"><i class="fa fa-trash-o"></i> Remove All</a></th></tr></thead><tbody><tr ng-repeat="item in vm.group.siotGroupUsers"><td>{{ $index+1 }})</td><td>{{ item.name || \'\' }}</td><td style="padding-top:2px;padding-bottom:2px"><a class="btn btn-danger btn-with-icon btn-xs pull-right" style="width:80px" confirmed-click="vm.removeUser($index)" ng-confirm-click="Confirm remove this User?"><i class="fa fa-trash-o"></i> Remove</a></td></tr><tr><td colspan="9" style="text-align:center" ng-if="!vm.group.siotGroupUsers || vm.group.siotGroupUsers.length==0"><br><span>User list is empty.</span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/smartiotsettings/devicegroups/groupingCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartiotsettings/devicegroups/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartiotsettings.devicegroups.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/smartiotsettings/devicegroups/groupingList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.groupData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Group" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartiotsettings.devicegroups.create" rms-check-access="smartiotsettings.devicegroups" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> Add New Group</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="description">{{ \'DESCRIPTION\' | translate }}</th><th style="width:150px;text-align:center" class="hide-after">Gateway<br>Count</th><th style="width:150px;text-align:center" class="hide-after">Sensor<br>Count</th><th class="hide-after" style="text-align:center"><span translate="ENABLED"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.groupData.length==0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.groupData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.description}}</td><td style="text-align:center">{{item.gatewayCount}}</td><td style="text-align:center">{{item.sensorCount}}</td><td style="text-align:center"><i class="fa fa-check" ng-if="item.isEnabled" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.isEnabled" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="smartiotsettings.devicegroups.update({id:item.id})" rms-check-access="smartiotsettings.devicegroups" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Gateway" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteGateway(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Device Group?" rms-check-access="smartiotsettings.devicegroups" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/smartiotsettings/devicegroups/groupingUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartiotsettings/devicegroups/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartiotsettings.devicegroups.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartiotsettings.devicegroups.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/smartiotsettings/gateways/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="GATEWAY_DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Description" ng-model="vm.gateway.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="IS_ACTIVE"></b></label><div><toggle ng-model="vm.gateway.isEnabled" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.selectedDevice==null && vm.dataForm.$submitted}"><label><b translate="Associated Smart IOT Device"></b> <i class="fa fa-asterisk req"></i></label> <a href="" ng-click="vm.clearDevice()" class="btn btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="vm.selectedDevice!=null"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedDeviceChanged()" ng-options="b as (b.deviceUID + \' - \' + b.deviceName | uppercase) for b in vm.deviceList | orderBy:\'deviceName\'" ng-model="vm.selectedDevice" required=""><option value="">-- {{ \'SELECT_A_GATEWAY_DEVICE\' | translate }} --</option></select><span class="help-block" ng-show="vm.selectedDevice==null && vm.dataForm.$submitted">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="DEVICE_UID"></b></label> <span class="form-control" ng-disabled="true">{{vm.selectedDevice.deviceUID || \'-\'}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="DEVICE_UUID"></b></label> <span class="form-control" ng-disabled="true">{{vm.selectedDevice.deviceUUID || \'-\'}}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="DEVICE_MODEL"></b></label> <span class="form-control" ng-disabled="true">{{vm.selectedDevice.deviceModel || \'-\'}}</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>Last Remote Update On:</b></label> <span class="form-control" ng-disabled="true">{{vm.gateway.changesAppliedDate | date:\'dd-MM-yyyy hh:mma\' || \'-\'}}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="I/O Devices"><div class="row"><div class="col-md-4 col-lg-4"><div class="panel panel-default"><div class="panel-heading"><span ng-class="{\'text-success\':vm.gateway.deviceIO_01_Status, \'text-default\':!vm.gateway.deviceIO_01_Status}"><b>I/O #1</b> &nbsp;&nbsp; {{ (vm.gateway.deviceIO_01_Description!=null && vm.gateway.deviceIO_01_Description!=\'\' ? \' [\' + vm.gateway.deviceIO_01_Description + \']\': \'\') }}</span><ba-switcher switcher-style="primary" switcher-value="vm.gateway.deviceIO_01_Status" class="pull-right" style="margin-top:-7px;margin-right:-10px"></ba-switcher></div><div class="panel-body"><div class="col-lg-12"><br><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device01_Description.$invalid && (vm.dataForm.Device01_Description.$dirty || vm.dataForm.$submitted)}"><label><b>Device Description</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Device01_Description" ng-disabled="!vm.gateway.deviceIO_01_Status" ng-model="vm.gateway.deviceIO_01_Description" ng-required="vm.gateway.deviceIO_01_Status"> <span class="help-block" ng-if="vm.dataForm.$submitted && vm.dataForm.Device01_Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device01_InstrumentType.$invalid && (vm.dataForm.Device01_InstrumentType.$dirty || vm.dataForm.$submitted)}"><label><b>Instrument Type</b> <i class="fa fa-asterisk req"></i></label><select name="Device01_InstrumentType" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_01_Status" ng-change="vm.selectedDevice01InstrumentTypeChanged()" ng-options="b as b.name for b in vm.instrumentList" ng-model="vm.selectedDevice01InstrumentType" ng-required="vm.gateway.deviceIO_01_Status"><option value="">-- Select a Instrument Type --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device01_InstrumentType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div><hr></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>Timer Enabled?</b></label><div><toggle ng-model="vm.gateway.deviceIO_01_TimerStatus" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger" ng-disabled="!vm.gateway.deviceIO_01_Status"></toggle></div></div></div></div><div class="row" ng-if="vm.gateway.deviceIO_01_TimerStatus"><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device01_TimerStartTime.$invalid && (vm.dataForm.Device01_TimerStartTime.$dirty || vm.dataForm.$submitted)}"><label><b>Timer - Start Time</b> <i class="fa fa-asterisk req" ng-if="vm.gateway.deviceIO_01_TimerStatus"></i></label><select name="Device01_TimerStartTime" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_01_TimerStatus || !vm.gateway.deviceIO_03_Status" ng-change="vm.selectedDevice01TimerStartTimeChanged()" ng-options="b as b.name for b in vm.timeList" ng-model="vm.selectedDevice01TimerStartTime" ng-required="vm.gateway.deviceIO_01_TimerStatus && vm.gateway.deviceIO_01_Status"><option value="">-- Select a Start Time --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device01_TimerStartTime.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device01_TimerEndTime.$invalid && (vm.dataForm.Device01_TimerEndTime.$dirty || vm.dataForm.$submitted)}"><label><b>Timer - End Time</b> <i class="fa fa-asterisk req" ng-if="vm.gateway.deviceIO_01_TimerStatus"></i></label><select name="Device01_TimerEndTime" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_01_TimerStatus || !vm.gateway.deviceIO_03_Status" ng-change="vm.selectedDevice01TimerEndTimeChanged()" ng-options="b as b.name for b in vm.timeList" ng-model="vm.selectedDevice01TimerEndTime" ng-required="vm.gateway.deviceIO_01_TimerStatus && vm.gateway.deviceIO_01_Status"><option value="">-- Select a End Time --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device01_TimerEndTime.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><hr><div class="row"><div class="col-lg-12"><label><b>Trigger Condition</b></label></div></div><div class="row"><div class="col-lg-12"><table class="table table-bordered table-striped"><thead><tr style="height:40px;line-height:40px;"><th>Sensor</th><th>Metric</th><th>Condition</th><th colspan="2" style="width:60px !important"><a href="" class="btn btn-primary btn-xs pull-right" ng-if="vm.gateway.deviceIO_01_Status" ng-click="vm.addTriggerSetup(\'1\')"><i class="fa fa-plus"></i> Add Trigger</a></th></tr></thead><tbody><tr ng-if="(vm.gateway.siotGatewayIOTriggerConditions | filter:{triggerDeviceIO:\'1\'}).length==0"><td colspan="5"><center>No trigger available.</center></td></tr><tr ng-repeat="item in vm.gateway.siotGatewayIOTriggerConditions | filter:{triggerDeviceIO:\'1\'}"><td style="line-height:12px;padding-top:8px;padding-bottom:8px;"><b>{{item.description}}</b><br><small>UID: {{item.deviceUID}}</small><br><small>UUID: {{item.deviceUUID}}</small></td><td>{{item.triggerMetric}}</td><td>{{item.triggerCompare}}&nbsp; {{item.triggerValue}}</td><td style="width:30px"><a href="" class="btn btn-default btn-sm" ng-if="vm.gateway.deviceIO_01_Status" ng-click="vm.editTriggerSetup(\'1\', item)"><i class="fa fa-pencil"></i></a></td><td style="width:30px"><a href="" class="btn btn-danger btn-sm" ng-if="vm.gateway.deviceIO_01_Status" confirmed-click="vm.deleteTriggerSetup(item.id)" ng-confirm-click="Confirm delete this Trigger?"><i class="fa fa-trash"></i></a></td></tr></tbody></table></div></div><p><br></p></div></div></div></div><div class="col-md-4 col-lg-4"><div class="panel panel-default"><div class="panel-heading"><span ng-class="{\'text-success\':vm.gateway.deviceIO_02_Status, \'text-default\':!vm.gateway.deviceIO_02_Status}"><b>I/O #2</b> &nbsp;&nbsp; {{ (vm.gateway.deviceIO_02_Description!=null && vm.gateway.deviceIO_02_Description!=\'\' ? \' [\' + vm.gateway.deviceIO_02_Description + \']\': \'\') }}</span><ba-switcher switcher-style="primary" switcher-value="vm.gateway.deviceIO_02_Status" class="pull-right" style="margin-top:-7px;margin-right:-10px"></ba-switcher></div><div class="panel-body"><div class="col-lg-12"><br><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device02_Description.$invalid && (vm.dataForm.Device02_Description.$dirty || vm.dataForm.$submitted)}"><label><b>Device Description</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Device02_Description" ng-disabled="!vm.gateway.deviceIO_02_Status" ng-model="vm.gateway.deviceIO_02_Description" ng-required="vm.gateway.deviceIO_02_Status"> <span class="help-block" ng-if="vm.dataForm.$submitted && vm.dataForm.Device02_Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device02_InstrumentType.$invalid && (vm.dataForm.Device02_InstrumentType.$dirty || vm.dataForm.$submitted)}"><label><b>Instrument Type</b> <i class="fa fa-asterisk req"></i></label><select name="Device02_InstrumentType" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_02_Status" ng-change="vm.selectedDevice02InstrumentTypeChanged()" ng-options="b as b.name for b in vm.instrumentList" ng-model="vm.selectedDevice02InstrumentType" ng-required="vm.gateway.deviceIO_02_Status"><option value="">-- Select a Instrument Type --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device02_InstrumentType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div><hr></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>Timer Enabled?</b></label><div><toggle ng-model="vm.gateway.deviceIO_02_TimerStatus" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger" ng-disabled="!vm.gateway.deviceIO_02_Status"></toggle></div></div></div></div><div class="row" ng-if="vm.gateway.deviceIO_02_TimerStatus"><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device02_TimerStartTime.$invalid && (vm.dataForm.Device02_TimerStartTime.$dirty || vm.dataForm.$submitted)}"><label><b>Timer - Start Time</b> <i class="fa fa-asterisk req" ng-if="vm.gateway.deviceIO_02_TimerStatus"></i></label><select name="Device02_TimerStartTime" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_02_TimerStatus || !vm.gateway.deviceIO_03_Status" ng-change="vm.selectedDevice02TimerStartTimeChanged()" ng-options="b as b.name for b in vm.timeList" ng-model="vm.selectedDevice02TimerStartTime" ng-required="vm.gateway.deviceIO_02_TimerStatus && vm.gateway.deviceIO_02_Status"><option value="">-- Select a Start Time --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device02_TimerStartTime.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device02_TimerEndTime.$invalid && (vm.dataForm.Device02_TimerEndTime.$dirty || vm.dataForm.$submitted)}"><label><b>Timer - End Time</b> <i class="fa fa-asterisk req" ng-if="vm.gateway.deviceIO_02_TimerStatus"></i></label><select name="Device02_TimerEndTime" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_02_TimerStatus || !vm.gateway.deviceIO_03_Status" ng-change="vm.selectedDevice02TimerEndTimeChanged()" ng-options="b as b.name for b in vm.timeList" ng-model="vm.selectedDevice02TimerEndTime" ng-required="vm.gateway.deviceIO_02_TimerStatus && vm.gateway.deviceIO_02_Status"><option value="">-- Select a End Time --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device02_TimerEndTime.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><hr><div class="row"><div class="col-lg-8"><label><b>Trigger Condition</b></label></div></div><div class="row"><div class="col-lg-12"><table class="table table-bordered table-striped"><thead><tr style="height:40px;line-height:40px;"><th>Sensor</th><th>Metric</th><th>Condition</th><th colspan="2" style="width:60px !important"><a href="" class="btn btn-primary btn-xs pull-right" ng-if="vm.gateway.deviceIO_02_Status" ng-click="vm.addTriggerSetup(\'2\')"><i class="fa fa-plus"></i> Add Trigger</a></th></tr></thead><tbody><tr ng-if="(vm.gateway.siotGatewayIOTriggerConditions | filter:{triggerDeviceIO:\'2\'}).length==0"><td colspan="5"><center>No trigger available.</center></td></tr><tr ng-repeat="item in vm.gateway.siotGatewayIOTriggerConditions | filter:{triggerDeviceIO:\'2\'}"><td style="line-height:12px;padding-top:8px;padding-bottom:8px;"><b>{{item.description}}</b><br><small>UID: {{item.deviceUID}}</small><br><small>UUID: {{item.deviceUUID}}</small></td><td>{{item.triggerMetric}}</td><td>{{item.triggerCompare}}&nbsp; {{item.triggerValue}}</td><td style="width:30px"><a href="" class="btn btn-default btn-sm" ng-if="vm.gateway.deviceIO_02_Status" ng-click="vm.editTriggerSetup(\'2\', item)"><i class="fa fa-pencil"></i></a></td><td style="width:30px"><a href="" class="btn btn-danger btn-sm" ng-if="vm.gateway.deviceIO_02_Status" confirmed-click="vm.deleteTriggerSetup(item.id)" ng-confirm-click="Confirm delete this Trigger?"><i class="fa fa-trash"></i></a></td></tr></tbody></table></div></div><p><br></p></div></div></div></div><div class="col-md-4 col-lg-4"><div class="panel panel-default"><div class="panel-heading"><span ng-class="{\'text-success\':vm.gateway.deviceIO_03_Status, \'text-default\':!vm.gateway.deviceIO_03_Status}"><b>I/O #3</b> &nbsp;&nbsp; {{ (vm.gateway.deviceIO_03_Description!=null && vm.gateway.deviceIO_03_Description!=\'\' ? \' [\' + vm.gateway.deviceIO_03_Description + \']\': \'\') }}</span><ba-switcher switcher-style="primary" switcher-value="vm.gateway.deviceIO_03_Status" class="pull-right" style="margin-top:-7px;margin-right:-10px"></ba-switcher></div><div class="panel-body"><div class="col-lg-12"><br><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device03_Description.$invalid && (vm.dataForm.Device03_Description.$dirty || vm.dataForm.$submitted)}"><label><b>Device Description</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Device03_Description" ng-disabled="!vm.gateway.deviceIO_03_Status" ng-model="vm.gateway.deviceIO_03_Description" ng-required="vm.gateway.deviceIO_03_Status"> <span class="help-block" ng-if="vm.dataForm.$submitted && vm.dataForm.Device03_Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device03_InstrumentType.$invalid && (vm.dataForm.Device03_InstrumentType.$dirty || vm.dataForm.$submitted)}"><label><b>Instrument Type</b> <i class="fa fa-asterisk req"></i></label><select name="Device03_InstrumentType" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_03_Status" ng-change="vm.selectedDevice03InstrumentTypeChanged()" ng-options="b as b.name for b in vm.instrumentList" ng-model="vm.selectedDevice03InstrumentType" ng-required="vm.gateway.deviceIO_03_Status"><option value="">-- Select a Instrument Type --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device03_InstrumentType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div><hr></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>Timer Enabled?</b></label><div><toggle ng-model="vm.gateway.deviceIO_03_TimerStatus" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger" ng-disabled="!vm.gateway.deviceIO_03_Status"></toggle></div></div></div></div><div class="row" ng-if="vm.gateway.deviceIO_03_TimerStatus"><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device03_TimerStartTime.$invalid && (vm.dataForm.Device03_TimerStartTime.$dirty || vm.dataForm.$submitted)}"><label><b>Timer - Start Time</b> <i class="fa fa-asterisk req" ng-if="vm.gateway.deviceIO_03_TimerStatus"></i></label><select name="Device03_TimerStartTime" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_03_TimerStatus || !vm.gateway.deviceIO_03_Status" ng-change="vm.selectedDevice03TimerStartTimeChanged()" ng-options="b as b.name for b in vm.timeList" ng-model="vm.selectedDevice03TimerStartTime" ng-required="vm.gateway.deviceIO_03_TimerStatus && vm.gateway.deviceIO_03_Status"><option value="">-- Select a Start Time --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device03_TimerStartTime.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device03_TimerEndTime.$invalid && (vm.dataForm.Device03_TimerEndTime.$dirty || vm.dataForm.$submitted)}"><label><b>Timer - End Time</b> <i class="fa fa-asterisk req" ng-if="vm.gateway.deviceIO_03_TimerStatus"></i></label><select name="Device03_TimerEndTime" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_03_TimerStatus || !vm.gateway.deviceIO_03_Status" ng-change="vm.selectedDevice03TimerEndTimeChanged()" ng-options="b as b.name for b in vm.timeList" ng-model="vm.selectedDevice03TimerEndTime" ng-required="vm.gateway.deviceIO_03_TimerStatus && vm.gateway.deviceIO_03_Status"><option value="">-- Select a End Time --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device03_TimerEndTime.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><hr><div class="row"><div class="col-lg-8"><label><b>Trigger Condition</b></label></div></div><div class="row"><div class="col-lg-12"><table class="table table-bordered table-striped"><thead><tr style="height:40px;line-height:40px;"><th>Sensor</th><th>Metric</th><th>Condition</th><th colspan="2" style="width:60px !important"><a href="" class="btn btn-primary btn-xs pull-right" ng-if="vm.gateway.deviceIO_03_Status" ng-click="vm.addTriggerSetup(\'3\')"><i class="fa fa-plus"></i> Add Trigger</a></th></tr></thead><tbody><tr ng-if="(vm.gateway.siotGatewayIOTriggerConditions | filter:{triggerDeviceIO:\'3\'}).length==0"><td colspan="5"><center>No trigger available.</center></td></tr><tr ng-repeat="item in vm.gateway.siotGatewayIOTriggerConditions | filter:{triggerDeviceIO:\'3\'}"><td style="line-height:12px;padding-top:8px;padding-bottom:8px;"><b>{{item.description}}</b><br><small>UID: {{item.deviceUID}}</small><br><small>UUID: {{item.deviceUUID}}</small></td><td>{{item.triggerMetric}}</td><td>{{item.triggerCompare}}&nbsp; {{item.triggerValue}}</td><td style="width:30px"><a href="" class="btn btn-default btn-sm" ng-if="vm.gateway.deviceIO_03_Status" ng-click="vm.editTriggerSetup(\'3\', item)"><i class="fa fa-pencil"></i></a></td><td style="width:30px"><a href="" class="btn btn-danger btn-sm" ng-if="vm.gateway.deviceIO_03_Status" confirmed-click="vm.deleteTriggerSetup(item.id)" ng-confirm-click="Confirm delete this Trigger?"><i class="fa fa-trash"></i></a></td></tr></tbody></table></div></div><p><br></p></div></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="panel panel-default"><div class="panel-heading"><span ng-class="{\'text-success\':vm.gateway.deviceIO_04_Status, \'text-default\':!vm.gateway.deviceIO_04_Status}"><b>I/O #4</b> &nbsp;&nbsp; {{ (vm.gateway.deviceIO_04_Description!=null && vm.gateway.deviceIO_04_Description!=\'\' ? \' [\' + vm.gateway.deviceIO_04_Description + \']\': \'\') }}</span><ba-switcher switcher-style="primary" switcher-value="vm.gateway.deviceIO_04_Status" class="pull-right" style="margin-top:-7px;margin-right:-10px"></ba-switcher></div><div class="panel-body"><div class="col-lg-12"><br><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device04_Description.$invalid && (vm.dataForm.Device04_Description.$dirty || vm.dataForm.$submitted)}"><label><b>Device Description</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Device04_Description" ng-disabled="!vm.gateway.deviceIO_04_Status" ng-model="vm.gateway.deviceIO_04_Description" ng-required="vm.gateway.deviceIO_04_Status"> <span class="help-block" ng-if="vm.dataForm.$submitted && vm.dataForm.Device04_Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device04_InstrumentType.$invalid && (vm.dataForm.Device04_InstrumentType.$dirty || vm.dataForm.$submitted)}"><label><b>Instrument Type</b> <i class="fa fa-asterisk req"></i></label><select name="Device04_InstrumentType" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_04_Status" ng-change="vm.selectedDevice04InstrumentTypeChanged()" ng-options="b as b.name for b in vm.instrumentList" ng-model="vm.selectedDevice04InstrumentType" ng-required="vm.gateway.deviceIO_04_Status"><option value="">-- Select a Instrument Type --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device04_InstrumentType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div><hr></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>Timer Enabled?</b></label><div><toggle ng-model="vm.gateway.deviceIO_04_TimerStatus" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger" ng-disabled="!vm.gateway.deviceIO_04_Status"></toggle></div></div></div></div><div class="row" ng-if="vm.gateway.deviceIO_04_TimerStatus"><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device04_TimerStartTime.$invalid && (vm.dataForm.Device04_TimerStartTime.$dirty || vm.dataForm.$submitted)}"><label><b>Timer - Start Time</b> <i class="fa fa-asterisk req" ng-if="vm.gateway.deviceIO_04_TimerStatus"></i></label><select name="Device04_TimerStartTime" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_04_TimerStatus || !vm.gateway.deviceIO_04_Status" ng-change="vm.selectedDevice04TimerStartTimeChanged()" ng-options="b as b.name for b in vm.timeList" ng-model="vm.selectedDevice04TimerStartTime" ng-required="vm.gateway.deviceIO_04_TimerStatus && vm.gateway.deviceIO_04_Status"><option value="">-- Select a Start Time --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device04_TimerStartTime.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device04_TimerEndTime.$invalid && (vm.dataForm.Device04_TimerEndTime.$dirty || vm.dataForm.$submitted)}"><label><b>Timer - End Time</b> <i class="fa fa-asterisk req" ng-if="vm.gateway.deviceIO_04_TimerStatus"></i></label><select name="Device04_TimerEndTime" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_04_TimerStatus || !vm.gateway.deviceIO_04_Status" ng-change="vm.selectedDevice04TimerEndTimeChanged()" ng-options="b as b.name for b in vm.timeList" ng-model="vm.selectedDevice04TimerEndTime" ng-required="vm.gateway.deviceIO_04_TimerStatus && vm.gateway.deviceIO_04_Status"><option value="">-- Select a End Time --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device04_TimerEndTime.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><hr><div class="row"><div class="col-lg-8"><label><b>Trigger Condition</b></label></div></div><div class="row"><div class="col-lg-12"><table class="table table-bordered table-striped"><thead><tr style="height:40px;line-height:40px;"><th>Sensor</th><th>Metric</th><th>Condition</th><th colspan="2" style="width:60px !important"><a href="" class="btn btn-primary btn-xs pull-right" ng-if="vm.gateway.deviceIO_04_Status" ng-click="vm.addTriggerSetup(\'4\')"><i class="fa fa-plus"></i> Add Trigger</a></th></tr></thead><tbody><tr ng-if="(vm.gateway.siotGatewayIOTriggerConditions | filter:{triggerDeviceIO:\'4\'}).length==0"><td colspan="5"><center>No trigger available.</center></td></tr><tr ng-repeat="item in vm.gateway.siotGatewayIOTriggerConditions | filter:{triggerDeviceIO:\'4\'}"><td style="line-height:12px;padding-top:8px;padding-bottom:8px;"><b>{{item.description}}</b><br><small>UID: {{item.deviceUID}}</small><br><small>UUID: {{item.deviceUUID}}</small></td><td>{{item.triggerMetric}}</td><td>{{item.triggerCompare}}&nbsp; {{item.triggerValue}}</td><td style="width:30px"><a href="" class="btn btn-default btn-sm" ng-if="vm.gateway.deviceIO_04_Status" ng-click="vm.editTriggerSetup(\'4\', item)"><i class="fa fa-pencil"></i></a></td><td style="width:30px"><a href="" class="btn btn-danger btn-sm" ng-if="vm.gateway.deviceIO_04_Status" confirmed-click="vm.deleteTriggerSetup(item.id)" ng-confirm-click="Confirm delete this Trigger?"><i class="fa fa-trash"></i></a></td></tr></tbody></table></div></div><p><br></p></div></div></div></div><div class="col-md-4 col-lg-4"><div class="panel panel-default"><div class="panel-heading"><span ng-class="{\'text-success\':vm.gateway.deviceIO_05_Status, \'text-default\':!vm.gateway.deviceIO_05_Status}"><b>I/O #5</b> &nbsp;&nbsp; {{ (vm.gateway.deviceIO_05_Description!=null && vm.gateway.deviceIO_05_Description!=\'\' ? \' [\' + vm.gateway.deviceIO_05_Description + \']\': \'\') }}</span><ba-switcher switcher-style="primary" switcher-value="vm.gateway.deviceIO_05_Status" class="pull-right" style="margin-top:-7px;margin-right:-10px"></ba-switcher></div><div class="panel-body"><div class="col-lg-12"><br><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device05_Description.$invalid && (vm.dataForm.Device05_Description.$dirty || vm.dataForm.$submitted)}"><label><b>Device Description</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Device05_Description" ng-disabled="!vm.gateway.deviceIO_05_Status" ng-model="vm.gateway.deviceIO_05_Description" ng-required="vm.gateway.deviceIO_05_Status"> <span class="help-block" ng-if="vm.dataForm.$submitted && vm.dataForm.Device05_Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device05_InstrumentType.$invalid && (vm.dataForm.Device05_InstrumentType.$dirty || vm.dataForm.$submitted)}"><label><b>Instrument Type</b> <i class="fa fa-asterisk req"></i></label><select name="Device05_InstrumentType" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_05_Status" ng-change="vm.selectedDevice05InstrumentTypeChanged()" ng-options="b as b.name for b in vm.instrumentList" ng-model="vm.selectedDevice05InstrumentType" ng-required="vm.gateway.deviceIO_05_Status"><option value="">-- Select a Instrument Type --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device05_InstrumentType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div><hr></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label><b>Timer Enabled?</b></label><div><toggle ng-model="vm.gateway.deviceIO_05_TimerStatus" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger" ng-disabled="!vm.gateway.deviceIO_05_Status"></toggle></div></div></div></div><div class="row" ng-if="vm.gateway.deviceIO_05_TimerStatus"><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device05_TimerStartTime.$invalid && (vm.dataForm.Device05_TimerStartTime.$dirty || vm.dataForm.$submitted)}"><label><b>Timer - Start Time</b> <i class="fa fa-asterisk req" ng-if="vm.gateway.deviceIO_05_TimerStatus"></i></label><select name="Device05_TimerStartTime" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_05_TimerStatus || !vm.gateway.deviceIO_05_Status" ng-change="vm.selectedDevice05TimerStartTimeChanged()" ng-options="b as b.name for b in vm.timeList" ng-model="vm.selectedDevice05TimerStartTime" ng-required="vm.gateway.deviceIO_05_TimerStatus && vm.gateway.deviceIO_05_Status"><option value="">-- Select a Start Time --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device05_TimerStartTime.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Device05_TimerEndTime.$invalid && (vm.dataForm.Device05_TimerEndTime.$dirty || vm.dataForm.$submitted)}"><label><b>Timer - End Time</b> <i class="fa fa-asterisk req" ng-if="vm.gateway.deviceIO_05_TimerStatus"></i></label><select name="Device05_TimerEndTime" class="form-control" style="background:#FFFCED" ng-disabled="!vm.gateway.deviceIO_05_TimerStatus || !vm.gateway.deviceIO_05_Status" ng-change="vm.selectedDevice05TimerEndTimeChanged()" ng-options="b as b.name for b in vm.timeList" ng-model="vm.selectedDevice05TimerEndTime" ng-required="vm.gateway.deviceIO_05_TimerStatus && vm.gateway.deviceIO_05_Status"><option value="">-- Select a End Time --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Device05_TimerEndTime.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><hr><div class="row"><div class="col-lg-8"><label><b>Trigger Condition</b></label></div></div><div class="row"><div class="col-lg-12"><table class="table table-bordered table-striped"><thead><tr style="height:40px;line-height:40px;"><th>Sensor</th><th>Metric</th><th>Condition</th><th colspan="2" style="width:60px !important"><a href="" class="btn btn-primary btn-xs pull-right" ng-if="vm.gateway.deviceIO_05_Status" ng-click="vm.addTriggerSetup(\'5\')"><i class="fa fa-plus"></i> Add Trigger</a></th></tr></thead><tbody><tr ng-if="(vm.gateway.siotGatewayIOTriggerConditions | filter:{triggerDeviceIO:\'5\'}).length==0"><td colspan="5"><center>No trigger available.</center></td></tr><tr ng-repeat="item in vm.gateway.siotGatewayIOTriggerConditions | filter:{triggerDeviceIO:\'5\'}"><td style="line-height:12px;padding-top:8px;padding-bottom:8px;"><b>{{item.description}}</b><br><small>UID: {{item.deviceUID}}</small><br><small>UUID: {{item.deviceUUID}}</small></td><td>{{item.triggerMetric}}</td><td>{{item.triggerCompare}}&nbsp; {{item.triggerValue}}</td><td style="width:30px"><a href="" class="btn btn-default btn-sm" ng-if="vm.gateway.deviceIO_05_Status" ng-click="vm.editTriggerSetup(\'5\', item)"><i class="fa fa-pencil"></i></a></td><td style="width:30px"><a href="" class="btn btn-danger btn-sm" ng-if="vm.gateway.deviceIO_05_Status" confirmed-click="vm.deleteTriggerSetup(item.id)" ng-confirm-click="Confirm delete this Trigger?"><i class="fa fa-trash"></i></a></td></tr></tbody></table></div></div><p><br></p></div></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.gateway.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_GATEWAY"></span>.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br><span translate="THERE_IS_NO_CHANGES_YET"></span>.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="TransferGatewayModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="TRANSFER_GATEWAY_TO_OTHER_COMPANY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.cloneForm.Company.$invalid && $mdl.cloneForm.$submitted}"> <label><b translate="SELECT_A_COMPANY">:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="Company" ng-options="c as (c.name | uppercase) for c in $mdl.companies track by c.id" ng-change="$mdl.selectedCompanyChanged()" ng-model="$mdl.selectedCompany" required> <option value="">-- {{ \'SELECT_A_COMPANY\' | translate }} --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.cloneForm.Company.$error.required && $mdl.cloneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.cloneForm.Branch.$invalid && $mdl.cloneForm.$submitted}"> <label><b translate="SELECT_A_BRANCH">:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="Branch" ng-options="r as (r.name | uppercase) for r in $mdl.branches track by r.id" ng-disabled="!$mdl.selectedCompany" ng-change="$mdl.selectedBranchChanged()" ng-model="$mdl.selectedBranch" required> <option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.cloneForm.Branch.$error.required && $mdl.cloneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="TriggerSetupModal.html"><form name="$mdl.setupForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">I/O #{{$mdl.ioNo}} - Trigger Condition Setup</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.setupForm.Sensor.$invalid && $mdl.setupForm.$submitted}"> <label><b>Sensor List:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="Sensor" ng-options="s as s.description for s in $mdl.sensorList" ng-change="$mdl.selectedSensorChanged()" ng-model="$mdl.selectedSensor" required> <option value="">-- Select One --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.setupForm.Sensor.$error.required && $mdl.setupForm.$submitted">* {{ \'REQUIRED\' | translate}}</p> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.setupForm.Metric.$invalid && $mdl.setupForm.$submitted}"> <label><b>Metric:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="Metric" ng-options="s as s.name for s in $mdl.metricList" ng-change="$mdl.selectedMetricChanged()" ng-model="$mdl.selectedMetric" required> <option value="">-- Select One --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.setupForm.Metric.$error.required && $mdl.setupForm.$submitted">* {{ \'REQUIRED\' | translate}}</p> </div> </div> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.setupForm.Direction.$invalid && $mdl.setupForm.$submitted}"> <label><b>Compare</b><i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="Direction" ng-options="c as c.name for c in $mdl.directionList" ng-change="$mdl.selectedDirectionChanged()" ng-model="$mdl.selectedDirection" required> <option value=""></option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.setupForm.Direction.$error.required && $mdl.setupForm.$submitted">* {{ \'REQUIRED\' | translate}}</p> </div> </div> <div class="col-lg-3"> <div class="form-group" ng-class="{\'has-error\': $mdl.setupForm.Value.$invalid && $mdl.setupForm.$submitted}"> <label><b>Value (Number)</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="number" class="form-control" name="Value" ng-model="$mdl.condition.triggerValue" required> <p class="help-block" style="color:#f00" ng-show="$mdl.setupForm.Value.$error.required && $mdl.setupForm.$submitted">* {{ \'REQUIRED\' | translate}}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.setupForm.Value.$error.number && $mdl.setupForm.$submitted">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/smartiotsettings/gateways/gatewayCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartiotsettings/gateways/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartiotsettings.gateways.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/smartiotsettings/gateways/gatewayList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.gatewayData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Gateway" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartiotsettings.gateways.create" rms-check-access="smartiotsettings.gateways" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_GATEWAY"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:120px" st-sort="deviceUID"><span translate="Device UID"></span></th><th style="width:300px" st-sort="deviceUUID"><span translate="Device UUID"></span></th><th translate="DESCRIPTION"></th><th class="hide-after" style="text-align:center"><span translate="IS_ACTIVE"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.gatewayData.length==0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.gatewayData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.deviceUID}}</td><td style="font-family:courier"><big><b>{{item.deviceUUID}}</b></big></td><td>{{item.description}}</td><td style="text-align:center"><i class="fa fa-check" ng-if="item.isEnabled" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.isEnabled" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="smartiotsettings.gateways.update({id:item.id})" rms-check-access="smartiotsettings.gateways" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Gateway" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteGateway(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this gateway?" rms-check-access="smartiotsettings.gateways" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/smartiotsettings/gateways/gatewayUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartiotsettings/gateways/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartiotsettings.gateways.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartiotsettings.gateways.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-primary btn-with-icon pull-right" ng-if="vm.isSuperAdmin" ng-disabled="vm.lockButtons" ng-click="vm.showTransferModal()"><i class="fa fa-exchange"></i> <span translate="TRANSFER_TO_OTHER_COMPANY"></span></a></div></form>');
$templateCache.put('app/pages/settings/users/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FirstName.$invalid && (vm.dataForm.FirstName.$dirty || vm.dataForm.$submitted)}"><label><b translate="FIRST_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="FirstName" ng-model="vm.user.firstName" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LastName.$invalid && (vm.dataForm.LastName.$dirty || vm.dataForm.$submitted)}"><label><b translate="LAST_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="LastName" ng-model="vm.user.lastName" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LastName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'STATUS\' | translate }}</b></label><div><toggle ng-model="vm.user.active" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Email.$invalid && (vm.dataForm.Email.$dirty || vm.dataForm.$submitted)}"><label><b translate="EMAIL"></b> <i class="fa fa-asterisk req"></i></label> <input type="email" class="form-control" name="Email" ng-model="vm.user.email" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.email">* <span translate="EMAIL_FORMAT_INVALID"></span></span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="TELEPHONE"></b></label> <input type="text" class="form-control" name="Telephone" ng-model="vm.user.phone" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'IS_POS_SYNC_USER\' | translate }}</b></label><div><toggle ng-model="vm.user.isPosSyncUser" ng-disabled="!vm.isSuperAdmin" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="JOB_TITLE"></b></label> <input type="text" class="form-control" name="JobTitle" ng-model="vm.user.jobTitle" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin"></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PreferredLanguage.$invalid && (vm.dataForm.PreferredLanguage.$dirty || vm.dataForm.$submitted)}"><label><b translate="PREFERRED_LANGUAGE"></b></label><select class="form-control" name="PreferredLanguage" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin" ng-model="vm.user.preferredLanguage" required=""><option value="">-- {{ \'SELECT_A_LANGUAGE\' | translate }} --</option><option value="en" selected="selected">{{ \'ENGLISH\' | translate }}</option><option value="ko">{{ \'KOREAN\' | translate }}</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PreferredLanguage.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><hr></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Usergroup.$error.required && vm.dataForm.$submitted}"><label><b translate="USERGROUP"></b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Usergroup" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin" ng-options="u as u.name for u in vm.usergroups track by u.id" ng-model="vm.usergroups.selected" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Usergroup.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="DEPARTMENT"></b></label><select class="form-control" name="Department" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin" ng-options="u as u.name for u in vm.departments track by u.id" ng-model="vm.departments.selected"><option></option></select></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Username.$invalid && (vm.dataForm.Username.$dirty || vm.dataForm.$submitted )}"><label><b translate="USERNAME"></b></label> <input type="text" class="form-control" name="Username" ng-model="vm.user.loginId" ng-disabled="!vm.isSuperAdmin || (vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin)"></div></div></div><div class="row" ng-if="vm.mode==1"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Password.$invalid && (vm.dataForm.Password.$dirty || vm.dataForm.$submitted)}"><label><b translate="PASSWORD"></b> <i class="fa fa-asterisk req"></i></label> <input type="password" class="form-control" name="Password" ng-model="vm.user.password" ng-disabled="vm.isRandomPassword" ng-required="vm.mode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Password.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ConfirmPassword.$invalid && (vm.dataForm.ConfirmPassword.$dirty || vm.dataForm.$submitted)}"><label><b translate="CONFIRM_PASSWORD"></b> <i class="fa fa-asterisk req"></i></label> <input type="password" class="form-control" name="ConfirmPassword" ng-model="vm.user.password1" ng-disabled="vm.isRandomPassword" ng-required="vm.mode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ConfirmPassword.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.mode==1"><div class="col-md-6 col-lg-6">&nbsp; <label><input type="checkbox" name="RandomPassword" ng-model="vm.isRandomPassword" ng-change="vm.generatePassword()"> <span style="padding-left:5px;font-weight:normal"><span translate="GENERATE_RANDOM_PASSWORD"></span></span></label></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'PERSONAL_DETAILS\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="FULL_NAME"></b></label> <input type="text" class="form-control" name="FullName" ng-model="vm.user.fullName" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b><span translate="NRIC_NO"></span>.</b></label> <input type="text" class="form-control" name="NRIC" ng-model="vm.user.identityNo" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b <span="" translate="ADDRESS_1">></b></label> <input type="text" class="form-control" name="Address1" ng-model="vm.user.address1" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b <span="" translate="ADDRESS_2">></b></label> <input type="text" class="form-control" name="Address2" ng-model="vm.user.address2" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="POSTAL_CODE"></b></label> <input type="text" class="form-control" name="PostalCode" ng-model="vm.user.postcode" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="STATE"></b></label> <input type="text" class="form-control" name="State" ng-model="vm.user.state" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="COUNTRY"></b></label> <input type="text" class="form-control" name="Country" ng-model="vm.user.country" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="TELEPHONE"></b></label> <input type="text" class="form-control" name="Phone" ng-model="vm.user.phone" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin"></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'BRANCHES\' | translate }}"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p><span translate="SELECT_AT_LEAST_ONE_(1)_BRANCH"></span>: <i class="fa fa-asterisk req"></i></p></div></div><div class="row" ng-repeat="b in vm.branches" style="margin-bottom:5px"><div class="col-md-12"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" name="branch" checklist-model="vm.selectedBranches" checklist-value="b" checklist-change="vm.dataForm.branch.$setValidity(\'required\', vm.selectedBranches.length > 0)" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin" ng-required="!vm.selectedBranches.length"> <label><span><b>{{ b.name }}</b></span></label></div></div></div><div class="row"><div class="col-md-12"><p><div class="col-md-12" ng-class="{ \'has-error\': vm.dataForm.$submitted && vm.dataForm.branch.$invalid }"><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.branch.$invalid">* <span translate="REQUIRED_AT_LEAST_ONE_(1)_BRANCH"></span></span></div></p></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'ASSET\' | translate }}" ng-if="vm.hasAssetModule && vm.hasSmartKitchenModule"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p><i class="fa fa-info-circle"></i>&nbsp; {{ \'SELECT_AN_ASSET_TO_BE_ASSOCIATED\' | translate }}.</p></div></div><div class="row"><div class="col-md-6"><select class="form-control" ng-options="u as u.name for u in vm.assets" ng-change="vm.selectedAssetChanged()" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin" ng-model="vm.selectedAsset"><option value="">-- {{ \'SELECT_AN_ASSET\' | translate }} --</option></select></div></div><div class="row"><div class="col-md-6"><br><span ng-bind-html="vm.beautify(vm.selectedAsset)"></span></div></div><div class="row"><p>&nbsp;</p><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AFTERSALES_SPECIALIZE_BRAND\' | translate }}" ng-if="vm.hasAfterSaleModule"><p><i class="fa fa-info-circle"></i>&nbsp; {{ \'MANAGE_EQUIPMENT_BRAND_SPECIALIZATION_OF_THIS_USER\' | translate }}&nbsp; ({{ \'APPLICABLE_TO_TECHNICIAN_ONLY\' | translate }}) <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddBrandModal()" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin"><i class="ion-plus-round"></i><span translate="ADD_BRAND"></span></a><br><br></p><div class="row"><div class="col-md-8 col-lg-8"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="BRAND_CODE"></b></th><th><b translate="BRAND_NAME"></b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.user.equipmentBrands"><td>{{ $index+1 }}</td><td>{{ ntn.code || \'-\' }}</td><td>{{ ntn.name || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeBrand($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="8" align="center" ng-show="vm.user.equipmentBrands.length==0"><br><span translate="BRAND_SPECIALIZATION_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AFTERSALES_SPECIALIZE_CATEGORY\' | translate }}" ng-if="vm.hasAfterSaleModule"><p><i class="fa fa-info-circle"></i>&nbsp; {{ \'MANAGE_EQUIPMENT_CATEGORY_SPECIALIZATION_OF_THIS_USER\' | translate }}&nbsp; ({{ \'APPLICABLE_TO_TECHNICIAN_ONLY\' | translate }}) <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddCategoryModal()" ng-disabled="vm.mode==2 && vm.user.isPosSyncUser && !vm.isSuperAdmin"><i class="ion-plus-round"></i><span translate="ADD_CATEGORY"></span></a><br><br></p><div class="row"><div class="col-md-8 col-lg-8"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="CATEGORY_CODE"></b></th><th><b translate="CATEGORY_NAME"></b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.user.equipmentCategories"><td>{{ $index+1 }}</td><td>{{ ntn.code || \'-\' }}</td><td>{{ ntn.name || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeCategory($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr ng-if="vm.user.equipmentCategories.length==0"><td colspan="8" align="center"><br><span translate="CATEGORY_SPECIALIZATION_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="GHL Merchant" ng-hide="true"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="GHL_MERCHANT_ID"></b></label> <input type="text" class="form-control" ng-model="vm.user.ghlMerchantID"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="GHL_TERMINAL_ID"></b></label> <input type="text" class="form-control" ng-model="vm.user.ghlTerminalID"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="GHL_OPERATOR_ID"></b></label> <input type="text" class="form-control" ng-model="vm.user.ghlOperatorID"></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label><b translate="MERCHANT_PRIVATE_KEY"></b> (overrides Company Private Key)</label> <textarea class="form-control" style="font-family:courier;color:#333;height:500px" ng-model="vm.user.ghlPrivateKey">\n\t\t\t\t\t\t\t\t</textarea></div></div></div></uib-tab><uib-tab heading="Signature" ng-if="vm.mode==2"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p>Upload a signature image:</p></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="row"><img ngf-src="picFile || vm.user.signatureLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div><div class="row"><div class="col-md-12 col-lg-12"><p><small><i class="fa fa-info-circle"></i> {{ \'RECOMMENDED_TO_UPLOAD_A_LANDSCAPE_IMAGE\' | translate }}</small></p>&nbsp;</div></div><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-disabled="vm.lockUploadButton || (vm.mode == 2 && vm.user.isPosSyncUser && !vm.isSuperAdmin)" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> {{ \'UPLOAD_PICTURE\' | translate }}</div><a href="" ng-click="picFile=null;vm.setUploadImage(picFile)" ng-show="picFile" class="btn btn-default btn-with-icon" ng-disabled="vm.lockUploadButton || (vm.mode == 2 && vm.user.isPosSyncUser && !vm.isSuperAdmin)"><i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }}</a></div><div class="row" ng-show="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="UserBrandModal.html"><form name="$mdl.brandForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="ADD_BRAND"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SELECT_A_BRAND"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedBrand" on-select="$mdl.selectedBrandChanged()"> <ui-select-match placeholder="{{ \'ENTER_A_KEYWORD_TO_SEARCH\' | translate }}"> <span>{{ \'(\' + $select.selected.code + \') \' + $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.brands | filter: $select.search" minimum-input-length="2"> <span style="font-family:courier;font-size:110%" ng-bind-html="\'(\' + i.code + \') \' + i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.selectedBrand==null && $mdl.brandForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b><span translate="PROCESSING"></span> ...</b> </div> <button type="button" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-disabled="$mdl.lockButton" confirmed-click="$mdl.addAll()" ng-confirm-click="Confirm add all Brands?"> <i class="ion ion-checkmark"></i><span translate="ADD_ALL"></span> </button> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="UserCategoryModal.html"><form name="$mdl.categoryForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="ADD_CATEGORY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SELECT_A_EQUIPMENT_CATEGORY"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedCategory" on-select="$mdl.selectedCategoryChanged()"> <ui-select-match placeholder="{{ \'ENTER_A_KEYWORD_TO_SEARCH\' | translate }}"> <span>{{ \'(\' + $select.selected.code + \') \' + $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.categories | filter: $select.search" minimum-input-length="2"> <span style="font-family:courier;font-size:110%" ng-bind-html="\'(\' + i.code + \') \' + i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.selectedCategory==null && $mdl.categoryForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b><span translate="PROCESSING"></span> ...</b> </div> <button type="button" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-disabled="$mdl.lockButton" confirmed-click="$mdl.addAll()" ng-confirm-click="Confirm add all Categories?"> <i class="ion ion-checkmark"></i> <span translate="ADD_ALL"></span> </button> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/settings/users/userCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/users/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> <span translate="CREATE_USER"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.users.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/settings/users/userList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.userData" st-safe-src="vm.userDataFull" refresh-table=""><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.users.create" rms-check-access="settings.users" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_USER"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="loginId"><span translate="USERNAME"></span></th><th st-sort="firstName" colspan="2"><span translate="FULL_NAME"></span></th><th st-sort="email"><span translate="EMAIL"></span></th><th st-sort="userGroup"><span translate="USERGROUP"></span></th><th st-sort="department"><span translate="DEPARTMENT"></span></th><th translate="ACTIVE"></th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr><th colspan="5"></th><th class="form-inline"><select st-search="userGroup"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="u in vm.userDataFull | unique:\'userGroup\' | orderBy:\'userGroup\'" value="{{u.userGroup}}">{{ u.userGroup }}</option></select></th><th class="form-inline"><select st-search="department"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="u in vm.userDataFull | unique:\'department\' | orderBy:\'department\'" value="{{u.department}}">{{ u.department }}</option></select></th><th colspan="4"></th></tr></thead><tbody><tr ng-repeat="item in vm.userData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.loginId}}</td><td colspan="2">{{item.firstName}} {{item.lastName}}</td><td>{{item.email}}</td><td>{{item.userGroup}}</td><td>{{item.department}}</td><td><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="settings.users.update({id:item.id})" rms-check-access="settings.users" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Reset Password" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#d58512" confirmed-click="vm.resetUserPwd(item.loginId, item.email)" ng-confirm-click="Confirm reset password?" rms-check-access="settings.users" rms-check-access-perm-type="UPDATE"><i class="fa fa-key fa-flip-horizontal"></i></a></td><td align="center"><a href="" title="Delete User" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteUser(item.id, item.loginId)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this user?" rms-check-access="settings.users" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/settings/users/userUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/settings/users/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="settings.users.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="settings.users.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/smartiotsettings/planviewdesigner/_form.html','<div class="row"><div class="col-md-12" style="width:auto;min-width:100%;"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="FILL_IN_THE_GENERAL_INFORMATION_FOR_THIS_DASHBOARD_DESIGN"></span>.</p><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Branch.$invalid && (vm.dataForm.Branch.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'BRANCH\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="Branch" class="form-control" style="background:#FFFCED" ng-change="vm.selectedBranchChanged()" ng-options="b as b.name for b in vm.branches | orderBy:\'name\'" ng-model="vm.selectedBranch" required=""><option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Branch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b translate="DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Description of this Design" ng-model="vm.design.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PageCode.$invalid && (vm.dataForm.PageCode.$dirty || vm.dataForm.$submitted)}"><label><b translate="BUTTON_SHORT_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="PageCode" placeholder="A short code that will appear as Button description, e.g: GF / 1F / etc" ng-model="vm.design.pageCode" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PageCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="IS_ACTIVE"></b></label><br><div><toggle ng-model="vm.design.isActive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Layout Image"><div class="row" ng-if="vm.mode==1"><div class="col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center><span translate="PLEASE_SAVE_THE_DESIGN_FIRST_BEFORE_UPLOADING_LAYOUT_PLAN_IMAGE"></span>.</center></h2></div></div><div class="row" ng-if="vm.mode==2"><div class="col-lg-12"><div class="row"><div class="col-md-12 col-lg-12"><p><i class="fa fa-info-circle"></i> <span translate="UPLOAD_THE_LAYOUT_PLAN_IMAGE_WITH_1920_X_1080_RESOLUTION"></span>. &nbsp; <a class="btn btn-success btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-if="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> <span translate="UPLOAD_IMAGE"></span></a> <a href="" class="btn btn-default btn-with-icon" ng-click="picFile=null;vm.setUploadImage(picFile)" ng-if="!vm.lockUploadButton"><i class="ion ion-android-remove-circle"></i> <span translate="RESET_IMAGE"></span></a></p></div></div><div class="row" ng-if="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row"><img ngf-src="vm.fileToUpload || vm.design.layoutImage" alt="" class="col-lg-6"></div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div></div></uib-tab><uib-tab heading="Objects" ng-if="vm.mode==2 && vm.design.layoutImage!=\'assets/img/empty_placeholder_iotdesigner.jpg\'"><div class="row"><div class="col-lg-12"><div class="row" ng-hide="true"><div class="col-md-2 col-lg-2"><div style="margin-bottom:10px"><span translate="CHOOSE_A_TYPE"></span>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <input type="radio" name="TabOption" id="TabOption1" value="1" style="cursor:pointer" ng-if="vm.hasAssetAccess" ng-model="vm.selectedTab" ng-click="vm.selectTab(\'1\')"> <label for="TabOption1" style="cursor:pointer">&nbsp;<b translate="ASSETS"></b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label> <input type="radio" name="TabOption" id="TabOption2" value="2" style="cursor:pointer" ng-if="vm.hasIoTAccess" ng-model="vm.selectedTab" ng-click="vm.selectTab(\'2\')"> <label for="TabOption2" style="cursor:pointer">&nbsp;<b translate="SENSORS"></b></label></div></div></div><div class="row" ng-hide="true"><div class="col-md-8 col-lg-8"><div class="col-lg-8" style="padding:15px;background:#f0f0f0"><div class="row"><div class="col-md-12 col-lg-12"><p><i class="fa fa-info-circle"></i> <span translate="SELECT_AND_ADD_THE_ASSET_ONTO_THE_LAYOUT_PLAN._DRAG_&_DROP_THE_ASSET_ICON_TO_RE-POSITION."></span></p></div></div><div class="row"><div class="col-md-4 col-lg-4"><label><small translate="LOCATION">:</small></label></div><div class="col-md-6 col-lg-6"><label><small><span translate="ASSET"></span>:</small></label></div></div><div class="row"><div class="col-md-4 col-lg-4"><select class="form-control" style="font-family:courier" ng-options="b as b.branchName for b in vm.assets | unique:\'branchName\' | orderBy:\'branchName\'" ng-model="vm.selectedLocation"><option value="">- {{ \'SELECT_A_LOCATION\' | translate }} -</option></select></div><div class="col-md-6 col-lg-6"><select class="form-control" style="background:#FFFCED;font-family:courier" ng-change="vm.selectedAssetChanged()" ng-options="b as b.name for b in vm.assets | filter: { branchName:vm.selectedLocation.branchName} | orderBy:\'name\'" ng-model="vm.selectedAsset"><option value="">- {{ \'SELECT_AN_ASSET\' | translate }} -</option></select></div><div class="col-md-2 col-lg-2"><a href="" class="btn btn-primary" ng-click="vm.addAssetToLayout(vm.selectedAsset.id, vm.selectedAsset.name)"><span translate="ADD_ASSET"></span></a></div></div></div></div></div><div class="row"><div class="col-md-8 col-lg-8"><div class="col-lg-8" style="padding:15px;background:#f0f0f0"><div class="row"><div class="col-md-12 col-lg-12"><p><i class="fa fa-info-circle"></i> <span translate="SELECT_AND_ADD_THE_SENSORS_ONTO_THE_LAYOUT_PLAN._DRAG_&_DROP_THE_SENSOR_ICON_TO_RE-POSITION."></span></p></div></div><div class="row"><div class="col-md-4 col-lg-4"><label><small><span translate="DEVICE_GROUPS"></span>:</small></label></div><div class="col-md-6 col-lg-6"><label><small><span translate="SENSOR"></span>:</small></label></div></div><div class="row"><div class="col-md-4 col-lg-4"><select class="form-control" style="font-family:courier" ng-change="vm.selectedGroupChanged()" ng-options="b as b.description for b in vm.deviceGroups | orderBy:\'description\'" ng-model="vm.selectedGroup"><option value="">- {{ \'SELECT_A_DEVICE_GROUP\' | translate }} -</option></select></div><div class="col-md-6 col-lg-6"><select class="form-control" style="background:#FFFCED;font-family:courier" ng-change="vm.selectedSensorChanged()" ng-options="b as (\'[\' + b.deviceUID + \'] \' + b.description) for b in vm.selectedGroup.sensors | orderBy:\'description\'" ng-model="vm.selectedSensor"><option value="">- {{ \'SELECT_A_SENSOR\' | translate }} -</option></select></div><div class="col-md-2 col-lg-2"><a href="" class="btn btn-primary" ng-click="vm.addSensorToLayout(vm.selectedSensor)"><span translate="ADD_SENSOR"></span></a></div></div></div></div></div><div class="row"><br><div class="col-lg-12"><div id="layoutParent" style="background-image:url({{vm.design.layoutImage}})"><div id="{{s.objectIdText}}" ng-class="{\'planview-sensor\' : s.sensorId!=null, \'planview-asset\' : s.assetId!=null }" ng-repeat="s in vm.design.siotPlanViewDesignerDevices" style="-webkit-transform:translate({{s.coordinateX}}px,{{s.coordinateY}}px);transform:translate({{s.coordinateX}}px,{{s.coordinateY}}px);"><div ng-if="s.sensorId!=null"><a href="" class="sensor-remove" confirmed-click="vm.removeObject(s.objectIdText)" ng-confirm-click="Confirm remove this sensor [{{s.description}} (UID: {s.objectCode})] ?"><img src="assets/img/icon-delete.png" alt=""></a> <img src="assets/img/sensor-icon2.png" alt=""><br><div class="description"><div>{{s.description}}</div><small>{{s.objectCode}}</small></div></div><div ng-if="s.assetId!=null"><a href="" class="asset-remove" confirmed-click="vm.removeObject(s.objectIdText)" ng-confirm-click="Confirm remove this asset [{{s.description}}] ?"><img src="assets/img/icon-delete.png" alt=""></a> <img src="assets/img/asset-icon.png" alt=""><br><p>{{(s.description | limitTo:30) + (s.description.length>30?\'...\':\'\')}}</p></div></div></div></div></div></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/smartiotsettings/planviewdesigner/planviewdesignerCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartiotsettings/planviewdesigner/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartiotsettings.planviewdesigner.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/smartiotsettings/planviewdesigner/planviewdesignerList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.designData" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Design" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartiotsettings.planviewdesigner.create" rms-check-access="smartiotsettings.planviewdesigner" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_DESIGN"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:200px" st-sort="branchName">{{ \'BRANCH_NAME\' | translate }}</th><th st-sort="description"><span translate="DESIGN_DESCRIPTION"></span></th><th st-sort="noOfSensors"><span translate="NO._OF_SENSORS"></span></th><th class="hide-after" style="text-align:center">{{ \'ACTIVE\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.designData.length==0 && !vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.designData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.branchName}}</td><td>{{item.description}}</td><td>{{item.noOfSensors}}</td><td style="text-align:center"><i class="fa fa-check" ng-if="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="smartiotsettings.planviewdesigner.update({id:item.id})" rms-check-access="smartiotsettings.planviewdesigner" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Gateway" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteDesign(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this gateway?" rms-check-access="smartiotsettings.planviewdesigner" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/smartiotsettings/planviewdesigner/planviewdesignerUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartiotsettings/planviewdesigner/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartiotsettings.planviewdesigner.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartiotsettings.planviewdesigner.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/smartiotsettings/sensors/_form.html','<style>\n\t.modal-md {\n\t\twidth: 900px !important;\n\t}\n</style><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_SENSOR_INFORMATION"></span><br><br></p><div class="row"><div class="col-md-6 col-lg-6" style="margin-right:50px"><div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.Description.$invalid && ($mdl.settingForm.Description.$dirty || $mdl.settingForm.$submitted)}"><label><b translate="SENSOR_DESCRIPTION"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-model="vm.sensor.description" required=""> <span class="help-block" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="ENABLED"></b></label><br><div><toggle ng-model="vm.sensor.isEnabled" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-6 col-lg-6" style="margin-right:50px"><div class="form-group" ng-class="{\'has-error\': vm.selectedDevice==null && vm.dataForm.$submitted}"><label><b translate="ASSOCIATE_IOT_DEVICE"></b> <i class="fa fa-asterisk req"></i></label> <a href="" ng-click="vm.clearDevice()" class="btn btn-xs btn-with-icon btn-danger pull-right" style="margin-bottom:5px" ng-if="vm.selectedDevice!=null"><i class="fa fa-trash"></i> <span translate="CLEAR"></span></a><select class="form-control" style="background:#FFFCED" ng-change="vm.selectedDeviceChanged()" ng-options="b as (\'[ \' + b.deviceUID + \' ] [ \' + b.deviceUUID + \' ] \' + b.deviceName | uppercase) for b in vm.deviceList | orderBy:\'deviceUID\'" ng-model="vm.selectedDevice" required=""><option value="">-- {{ \'SELECT_A_SENSOR\' | translate }} --</option></select><span class="help-block" ng-show="vm.selectedDevice==null && vm.dataForm.$submitted">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b translate="DISPLAY_FAHRENHEIT"></b> (&deg;F)</label><br><div><toggle ng-model="vm.sensor.isFahrenheit" ng-change="vm.selectedSymbolChanged()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="DEVICE_UID"></b></label> <span class="form-control" ng-disabled="true">{{vm.selectedDevice.deviceUID || \'-\'}}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b translate="DEVICE_MODEL"></b></label> <span class="form-control" ng-disabled="true">{{vm.selectedDevice.deviceModel || \'-\'}}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b translate="DEVICE_UUID"></b></label> <span class="form-control" ng-disabled="true">{{vm.selectedDevice.deviceUUID || \'-\'}}</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Assigned to Group Name</b></label> <span class="form-control" ng-disabled="true">{{vm.sensor.groupName || \'- no group assigned -\'}}</span></div></div></div><br><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Device Features</b></label><div class="row"><div class="col-md-4 col-lg-4"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDevice.hasTemp"><center><b>TEMP</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDevice.hasTemp"><center><b>TEMP</b></center></span></div><div class="col-md-4 col-lg-4"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDevice.hasHumi"><center><b>HUMI</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDevice.hasHumi"><center><b>HUMI</b></center></span></div><div class="col-md-4 col-lg-4"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDevice.hasNPK"><center><b>NPK</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDevice.hasNPK"><center><b>NPK</b></center></span></div></div><br><div class="row"><div class="col-md-4 col-lg-4"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDevice.hasEc"><center><b>EC</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDevice.hasEc"><center><b>EC</b></center></span></div><div class="col-md-4 col-lg-4"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDevice.hasPh"><center><b>PH</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDevice.hasPh"><center><b>PH</b></center></span></div><div class="col-md-4 col-lg-4"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDevice.hasPm"><center><b>PM2.5</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDevice.hasPm"><center><b>PM2.5</b></center></span></div></div><br><div class="row"><div class="col-md-4 col-lg-4"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDevice.hasWdir"><center><b>WIND DIR</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDevice.hasWdir"><center><b>WIND DIR</b></center></span></div><div class="col-md-4 col-lg-4"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDevice.hasWspd"><center><b>WIND SPEED</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDevice.hasWspd"><center><b>WIND SPEED</b></center></span></div><div class="col-md-4 col-lg-4"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDevice.hasLgtInt"><center><b>LIGHT INT</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDevice.hasLgtInt"><center><b>LIGHT INT</b></center></span></div></div><br><div class="row"><div class="col-md-4 col-lg-4"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDevice.hasElecMeter"><center><b>ELEC METER</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDevice.hasElecMeter"><center><b>ELEC METER</b></center></span></div><div class="col-md-4 col-lg-4"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDevice.hasWaterMeter"><center><b>WATER METER</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDevice.hasWaterMeter"><center><b>WATER METER</b></center></span></div></div></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Alert Settings"><p><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_SENSOR_ALERT_SETTINGS"></span> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddSettingModal()"><i class="ion-plus-round"></i><span translate="ADD_SETTING"></span></a><br><br></p><div class="row"><div class="col-lg-12"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="SETTING_TYPE"></b></th><th><b>Setting Description</b></th><th class="hide-after" style="text-align:center"><b translate="TRIGGER_ALERT"></b></th><th class="hide-after" style="text-align:center"><b translate="RANGE_START"></b></th><th class="hide-after" style="text-align:center"><b translate="RANGE_END"></b></th><th class="hide-after" style="text-align:center"><b translate="COLOR_CODE"></b></th><th style="width:80px"></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="item in vm.sensor.siotSensorAlertConditions"><td>{{ $index+1 }})</td><td>{{ item.metricName || \'\' }}</td><td>{{ item.description || \'\' }}</td><td style="text-align:center"><i class="fa fa-check" ng-if="item.isEnabled" style="color:#7bff7b"></i> <i class="fa fa-times" ng-if="!item.isEnabled" style="color:#f00"></i></td><td style="text-align:center">{{ item.valueStart }} {{item.uom}}</td><td style="text-align:center">{{ item.valueEnd }} {{item.uom}}</td><td><div style="width:80px;height:20px;background:{{item.colorCode}};line-height:20px;margin:8px auto;border:2px solid #333"></div></td><td style=""><a class="btn btn-info btn-with-icon btn-xs" style="width:100px;font-size:10pt" ng-click="vm.showEditSettingModal($index)"><i class="fa fa-pencil"></i> {{ \'EDIT\' | translate }}</a></td><td style=""><a class="btn btn-danger btn-with-icon btn-xs" style="width:100px;font-size:10pt" confirmed-click="vm.removeSetting($index)" ng-confirm-click="Confirm remove this Setting?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="9" style="text-align:center" ng-if="!vm.sensor.siotSensorAlertConditions || vm.sensor.siotSensorAlertConditions.length==0"><br><span translate="SETTING_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Hardware Settings" ng-if="vm.canSetIoTHardwareSettings"><p><i class="fa fa-info-circle"></i> <span translate="THESE_HARDWARE_SETTINGS_MUST_BE_SET_BEFORE_DEPLOY_TO_PRODUCTION_ENVIRONMENT"></span>.<br><br><span style="color:#f00;text-transform:uppercase"><b><span translate="THESE_HARDWARE_SETTINGS_MUST_BE_SET_BEFORE_DEPLOY_TO_PRODUCTION_ENVIRONMENT"></span></b></span><br><br></p><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceGroupNo.$invalid && (vm.dataForm.DeviceGroupNo.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="DEVICE_GROUP_NO"></span>.</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceGroupNo" placeholder="Device Group No." ng-model="vm.sensor.deviceGroupNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceGroupNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceNodeNo.$invalid && (vm.dataForm.DeviceNodeNo.$dirty || vm.dataForm.$submitted)}"><label><b><span translate="DEVICE_NODE_NO"></span>.</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceNodeNo" placeholder="Device Node No." ng-model="vm.sensor.deviceNodeNo" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceNodeNo.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.sensor.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_SENSOR"></span>.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br><span translate="THERE_IS_NO_CHANGES_YET"></span>.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="settingModal.html"><form name="$mdl.settingForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="ALERT_SETTING"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-3"> <div class="form-group"> <label><b translate="ENABLE_ALERT"></b></label><br /> <div> <toggle ng-model="$mdl.item.isEnabled" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> <div class="col-lg-9"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.Type.$invalid && ($mdl.settingForm.Type.$dirty || $mdl.settingForm.$submitted)}"> <label><b translate="SETTING_TYPE"></b> <i class="fa fa-asterisk req"></i></label> <select name="Type" class="form-control" style="background:#fffeed" ng-model="$mdl.selectedType" ng-change="$mdl.selectedTypeChanged()" ng-options="i as i.description for i in $mdl.metricList" required> <option></option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.Type.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-lg-3"></div> <div class="col-lg-9"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.Description.$invalid && $mdl.settingForm.$submitted}"> <label><b translate="SETTING_DESCRIPTION"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <input type="text" name="Description" class="form-control" style="background:#fffeed" ng-model="$mdl.item.description" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.settingForm.Description.$error.required && $mdl.settingForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-3"> </div> <div class="col-md-3 col-lg-3" style="padding-right:0px"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.RangeStart.$invalid && ($mdl.settingForm.RangeStart.$dirty || $mdl.settingForm.$submitted)}"> <label><b>Range Start</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="RangeStart" style="background:#fffeed" ng-model="$mdl.item.valueStart" required> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.RangeStart.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.RangeStart.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> </div> </div> <div class="col-md-3 col-lg-3" style="padding-right:0px"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.RangeEnd.$invalid && ($mdl.settingForm.RangeEnd.$dirty || $mdl.settingForm.$submitted)}"> <label><b>Range End</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="RangeEnd" style="background:#fffeed" ng-model="$mdl.item.valueEnd" required> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.RangeEnd.$error.required">* {{ \'REQUIRED\' | translate }}</span> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.RangeEnd.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> </div> </div> <div class="col-md-3 col-lg-3"> <label><b>&nbsp;</b></label> <br /> <div style="line-height:30px"> <b>{{$mdl.item.uom}}</b> </div> </div> </div> <div class="row"> <div class="col-lg-3"> </div> <div class="col-lg-6" style="padding-right:0px"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.TimeSpan.$invalid && ($mdl.settingForm.TimeSpan.$dirty || $mdl.settingForm.$submitted)}"> <label><b translate="SMART_MONITORING_DURATION"></b> <i class="fa fa-asterisk req"></i></label> <select name="TimeSpan" class="form-control" style="background:#fffeed" ng-model="$mdl.selectedTimeSpan" ng-change="$mdl.selectedTimeSpanChanged()" ng-options="i as i.name for i in $mdl.periodList" required> <option></option> </select> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.TimeSpan.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> <div class="row"> <div class="col-lg-3"> </div> <div class="col-md-6 col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.settingForm.ColorCode.$invalid && ($mdl.settingForm.ColorCode.$dirty || $mdl.settingForm.$submitted)}"> <label><b translate="COLOR_CODE"></b> <i class="fa fa-asterisk req"></i><br /> <span translate="(DISPLAY_ON_GRAPH)"></span> </label> <div class="row"> <div class="col-md-6 col-lg-6" style="padding-right:0px"> <div class="input-group"> <span class="input-group-addon" style="padding:3px 10px;font-size:9pt;background:{{$mdl.item.colorCode}}"> &nbsp;&nbsp;&nbsp;&nbsp; </span> <input class="form-control" type="text" name="ColorCode" style="background:#fffeed" colorpicker colorpicker-close-on-select colorpicker-size="200" colorpicker-position="right" ng-model="$mdl.item.colorCode" required /> </div> <span class="help-block" style="color:#f00" ng-show="$mdl.settingForm.$submitted && $mdl.settingForm.ColorCode.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> <div class="col-md-6 col-lg-6"> <a href ng-click="$mdl.selectColor(\'#ff0000\')" style="color:#ff0000"> <i class="fa fa-circle fa-2x"></i> </a> <a href ng-click="$mdl.selectColor(\'#ffbf00\')" style="color:#ffbf00"> <i class="fa fa-circle fa-2x"></i> </a> <a href ng-click="$mdl.selectColor(\'#00ff00\')" style="color:#00ff00"> <i class="fa fa-circle fa-2x"></i> </a> </div> </div> </div> </div> </div> <hr /> <b>Mute Schedule:</b> <div class="row" style="margin-top:5px;"> <div class="col-lg-12"> <div class="form-group"> <div ng-form editable-form name="$mdl.tableForm" class="form-inline" style="font-size:90%"> <table class="table table-bordered table-striped" st-sticky-header> <tr> <td>#</td> <td style="width:85px"><b>Enable</b></td> <td style="text-align:center;padding:0px"><b>M</b></td> <td style="text-align:center;padding:0px"><b>T</b></td> <td style="text-align:center;padding:0px"><b>W</b></td> <td style="text-align:center;padding:0px"><b>T</b></td> <td style="text-align:center;padding:0px"><b>F</b></td> <td style="text-align:center;padding:0px"><b>S</b></td> <td style="text-align:center;padding:0px"><b>S</b></td> <td style="width:130px;text-align:center;padding:0px"><b>From</b></td> <td style="width:130px;text-align:center;padding:0px"><b>To</b></td> <td style="width:20px"></td> </tr> <tr ng-if="$mdl.item.siotSensorAlertConditionMuteTimes.length==0"> <td colspan="14" style="height:100px;line-height:100px"> <center> Click here to add a new schedule. &nbsp;&nbsp;&nbsp; <a class="btn btn-primary btn-with-icon btn-xs" ng-click="$mdl.addScheduleRow()"> <i class="fa fa-plus"></i> {{ \'ADD_SCHEDULE\' | translate}} </a> </center> </td> </tr> <tr ng-repeat="ntn in $mdl.item.siotSensorAlertConditionMuteTimes" class="editable-row"> <td> {{$index+1}}) </td> <td style="width:85px"> <div editable-select="ntn.isEnabled" e-ng-options="s.value as s.text for s in $mdl.boolOptions2" e-name="isEnabled" e-form="$mdl.tableForm" e-style="width:45px;font-weight:bold;font-size:90%;padding:0px;text-align:center"> </div> </td> <td style="padding:0px"> <div editable-select="ntn.muteMon" e-ng-options="s.value as s.text for s in $mdl.boolOptions" e-name="muteMon" e-form="$mdl.tableForm" e-style="width:45px;font-weight:bold;font-size:90%;padding:0px;text-align:center"> </div> </td> <td style="padding:0px"> <div editable-select="ntn.muteTue" e-ng-options="s.value as s.text for s in $mdl.boolOptions" e-name="muteTue" e-form="$mdl.tableForm" e-style="width:45px;font-weight:bold;font-size:90%;padding:0px;text-align:center"> </div> </td> <td style="padding:0px"> <div editable-select="ntn.muteWed" e-ng-options="s.value as s.text for s in $mdl.boolOptions" e-name="muteWed" e-form="$mdl.tableForm" e-style="width:45px;font-weight:bold;font-size:90%;padding:0px;text-align:center"> </div> </td> <td style="padding:0px"> <div editable-select="ntn.muteThu" e-ng-options="s.value as s.text for s in $mdl.boolOptions" e-name="muteThu" e-form="$mdl.tableForm" e-style="width:45px;font-weight:bold;font-size:90%;padding:0px;text-align:center"> </div> </td> <td style="padding:0px"> <div editable-select="ntn.muteFri" e-ng-options="s.value as s.text for s in $mdl.boolOptions" e-name="muteFri" e-form="$mdl.tableForm" e-style="width:45px;font-weight:bold;font-size:90%;padding:0px;text-align:center"> </div> </td> <td style="padding:0px"> <div editable-select="ntn.muteSat" e-ng-options="s.value as s.text for s in $mdl.boolOptions" e-name="muteSat" e-form="$mdl.tableForm" e-style="width:45px;font-weight:bold;font-size:90%;padding:0px;text-align:center"> </div> </td> <td style="padding:0px;padding-right:15px"> <div editable-select="ntn.muteSun" e-ng-options="s.value as s.text for s in $mdl.boolOptions" e-name="muteSun" e-form="$mdl.tableForm" e-style="width:45px;font-weight:bold;font-size:90%;padding:0px;text-align:center"> </div> </td> <td style="padding:0px;text-align:center"> <div editable-select="ntn.muteFromHour" e-ng-options="s.value as s.text for s in $mdl.hourOptions" e-name="muteFromHour" e-form="$mdl.tableForm" e-style="width:45px;font-weight:bold;font-size:90%;padding:0px;text-align:center"> </div> : <div editable-select="ntn.muteFromMinute" e-ng-options="s.value as s.text for s in $mdl.minuteOptions" e-name="muteFromMinute" e-form="$mdl.tableForm" e-style="width:45px;font-weight:bold;font-size:90%;padding:0px;text-align:center"> </div> </td> <td style="padding:0px;text-align:center"> <div editable-select="ntn.muteToHour" e-ng-options="s.value as s.text for s in $mdl.hourOptions" e-name="muteToHour" e-form="$mdl.tableForm" e-style="width:45px;font-weight:bold;font-size:90%;padding:0px;text-align:center"> </div> : <div editable-select="ntn.muteToMinute" e-ng-options="s.value as s.text for s in $mdl.minuteOptions" e-name="muteToMinute" e-form="$mdl.tableForm" e-style="width:45px;font-weight:bold;font-size:90%;padding:0px;text-align:center"> </div> </td> <td style="line-height:40px"> <a class="btn btn-danger btn-sm" ng-click="$mdl.removeScheduleRow($index)"> <i class="ion ion-close"></i> </a> </td> </tr> <tr ng-if="$mdl.item.siotSensorAlertConditionMuteTimes.length!=0"> <td colspan="14"> <a class="btn btn-primary btn-with-icon btn-xs" ng-click="$mdl.addScheduleRow()"> <i class="fa fa-plus"></i> {{ \'ADD_SCHEDULE\' | translate}} </a> </td> </tr> </table> </div> </div> </div> </div> </div> <hr /> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/smartiotsettings/sensors/sensorCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartiotsettings/sensors/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartiotsettings.sensors.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/smartiotsettings/sensors/sensorList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.sensorData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Sensor" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartiotsettings.sensors.create" rms-check-access="smartiotsettings.sensors" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_SENSOR"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:120px" st-sort="deviceUID"><span translate="SENSOR_UID"></span></th><th style="width:300px" st-sort="deviceUUID"><span translate="SENSOR_UUID"></span></th><th style="width:150px" st-sort="deviceModel"><span translate="Model"></span></th><th st-sort="description">{{ \'DESCRIPTION\' | translate }}</th><th st-sort="groupName"><span translate="Group Name"></span></th><th class="hide-after" style="text-align:center"><span translate="ENABLED"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th colspan="3"></th><th><select st-search="deviceModel"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.sensorDataFull | unique:\'deviceModel\'" value="{{s.deviceModel}}">{{s.deviceModel}}</option></select></th><th></th><th><select st-search="groupName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.sensorDataFull | unique:\'groupName\'" value="{{s.groupName}}">{{s.groupName}}</option></select></th><th colspan="3"></th></tr></thead><tbody><tr ng-if="vm.sensorData.length==0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.sensorData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.deviceUID}}</td><td style="font-family:courier"><big><b>{{item.deviceUUID}}</b></big></td><td>{{item.deviceModel}}</td><td>{{item.description}}</td><td>{{item.groupName || \'-\'}}</td><td style="text-align:center"><i class="fa fa-check" ng-if="item.isEnabled" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.isEnabled" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="smartiotsettings.sensors.update({id:item.id})" rms-check-access="smartiotsettings.sensors" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Sensor" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteSensor(item.id, item.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this sensor?" rms-check-access="smartiotsettings.sensors" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/smartiotsettings/sensors/sensorUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartiotsettings/sensors/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartiotsettings.sensors.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartiotsettings.sensors.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-danger btn-with-icon pull-right" ng-if="vm.isSuperAdmin" ng-disabled="vm.lockButtons" confirmed-click="vm.deleteReadings()" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this sensor\'s readings?"><i class="fa fa-trash"></i> <span translate="DELETE_READINGS"></span></a></div></form>');
$templateCache.put('app/pages/smartkitchen/mcprofiles/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'DESCRIPTION\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-model="vm.profile.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'IS_MIDDLEWARE\' | translate }} ?</b></label><div><toggle ng-model="vm.profile.isMiddleWare" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Branch.$invalid && (vm.dataForm.Branch.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SELECT_A_BRANCH\' | translate }}:</b> <i class="fa fa-asterisk req"></i></label><select name="Branch" class="form-control" ng-options="b as (b.name | uppercase) for b in vm.branchList track by b.id" ng-change="vm.selectedBranchChanged()" ng-model="vm.selectedBranch" required=""><option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Branch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Equipment.$invalid && (vm.dataForm.Equipment.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SELECT_A_EQUIPMENT\' | translate }}:</b> <i class="fa fa-asterisk req"></i></label><select name="Equipment" class="form-control" ng-options="b as (b.name | uppercase) for b in vm.equipmentList track by b.id" ng-change="vm.selectedEquipmentChanged()" ng-model="vm.selectedEquipment" required=""><option value="">-- {{ \'SELECT_A_EQUIPMENT\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Equipment.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="!vm.profile.isMiddleWare"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MiddleWareGroupCode.$invalid && (vm.dataForm.MiddleWareGroupCode.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'MIDDLEWARE_GROUP_CODE\' | translate }}:</b> <i class="fa fa-asterisk req"></i></label><select name="MiddleWareGroupCode" class="form-control" ng-options="b as (b.name | uppercase) for b in vm.groupCodeList track by b.id" ng-change="vm.selectedGroupCodeChanged()" ng-model="vm.selectedGroupCode" ng-required="!vm.profile.isMiddleWare"><option value="">-- {{ \'SELECT_A_GROUP_CODE\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MiddleWareGroupCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><hr></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.API_Endpoint.$invalid && (vm.dataForm.API_Endpoint.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'API_ENDPOINT\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="API_Endpoint" ng-model="vm.profile.endpointUrl" ng-required="vm.profile.isMiddleWare"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.API_Endpoint.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'REQUIRE_AUTH\' | translate }} ?</b></label><div><toggle ng-model="vm.profile.isRequireAuth" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Username.$invalid && (vm.dataForm.Username.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'API_USERNAME\' | translate }}</b> <i class="fa fa-asterisk req" ng-if="vm.profile.isMiddleWare"></i></label> <input type="text" class="form-control" name="Username" ng-model="vm.profile.username" ng-required="vm.profile.isMiddleWare"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Username.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Password.$invalid && (vm.dataForm.Password.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'API_PASSWORD\' | translate }}</b> <i class="fa fa-asterisk req" ng-if="vm.profile.isMiddleWare"></i></label> <input type="text" class="form-control" name="Password" ng-model="vm.profile.password" ng-required="vm.profile.isMiddleWare"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Password.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/smartkitchen/mcprofiles/mcprofileCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartkitchen/mcprofiles/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartkitchen.machineconnectionprofiles.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/smartkitchen/mcprofiles/mcprofileList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.profileData" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Profile" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartkitchen.machineconnectionprofiles.create" rms-check-access="smartkitchen.machineconnectionprofiles" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> {{ \'ADD_NEW\' | translate }}</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th>{{ \'DESCRIPTION\' | translate }}</th><th>{{ \'BRANCH_NAME\' | translate }}</th><th>{{ \'EQUIPMENT_NAME\' | translate }}</th><th>{{ \'IS_MIDDLEWARE\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th colspan="2"></th><th><select st-search="branchName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.profileDataFull | unique:\'branchName\'" value="{{s.branchName}}">{{s.branchName}}</option></select></th><th><select st-search="equipmentName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.profileDataFull | unique:\'equipmentName\'" value="{{s.equipmentName}}">{{s.equipmentName}}</option></select></th><th colspan="3"></th></tr></thead><tbody><tr ng-if="vm.profileData.length==0 && !vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.profileData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td>{{item.branchName}}</td><td>{{item.equipmentName}}</td><td><i class="fa fa-check" ng-show="item.isMiddleWare" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isMiddleWare" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="smartkitchen.machineconnectionprofiles.update({id:item.id})" rms-check-access="smartkitchen.machineconnectionprofiles" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Remove Profile" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteProfile(item.id, item.name)" ng-confirm-click="Confirm remove this Profile?" rms-check-access="smartkitchen.machineconnectionprofiles" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/smartkitchen/mcprofiles/mcprofileUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartkitchen/mcprofiles/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartkitchen.machineconnectionprofiles.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartkitchen.machineconnectionprofiles.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/smartkitchen/machineordermenusetup/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'DESCRIPTION\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-model="vm.profile.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>{{ \'IS_MIDDLEWARE\' | translate }} ?</b></label><div><toggle ng-model="vm.profile.isMiddleWare" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Branch.$invalid && (vm.dataForm.Branch.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SELECT_A_BRANCH\' | translate }}:</b> <i class="fa fa-asterisk req"></i></label><select name="Branch" class="form-control" ng-options="b as (b.name | uppercase) for b in vm.branchList track by b.id" ng-change="vm.selectedBranchChanged()" ng-model="vm.selectedBranch" required=""><option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Branch.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Equipment.$invalid && (vm.dataForm.Equipment.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'SELECT_A_EQUIPMENT\' | translate }}:</b> <i class="fa fa-asterisk req"></i></label><select name="Equipment" class="form-control" ng-options="b as (b.name | uppercase) for b in vm.equipmentList track by b.id" ng-change="vm.selectedEquipmentChanged()" ng-model="vm.selectedEquipment" required=""><option value="">-- {{ \'SELECT_A_EQUIPMENT\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Equipment.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="!vm.profile.isMiddleWare"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MiddleWareGroupCode.$invalid && (vm.dataForm.MiddleWareGroupCode.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'MIDDLEWARE_GROUP_CODE\' | translate }}:</b> <i class="fa fa-asterisk req"></i></label><select name="MiddleWareGroupCode" class="form-control" ng-options="b as (b.name | uppercase) for b in vm.groupCodeList track by b.id" ng-change="vm.selectedGroupCodeChanged()" ng-model="vm.selectedGroupCode" ng-required="!vm.profile.isMiddleWare"><option value="">-- {{ \'SELECT_A_GROUP_CODE\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MiddleWareGroupCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.profile.isMiddleWare"><hr></div><div class="row" ng-if="vm.profile.isMiddleWare"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AuthType.$invalid && (vm.dataForm.AuthType.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'AUTH_TYPE\' | translate }}:</b> <i class="fa fa-asterisk req"></i></label><select name="AuthType" class="form-control" ng-options="b as (b.name | uppercase) for b in vm.authTypeList track by b.id" ng-change="vm.selectedAuthTypeChanged()" ng-model="vm.selectedAuthType" ng-required="vm.profile.isMiddleWare"><option value="">-- {{ \'SELECT_AN_AUTH_TYPE\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AuthType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.profile.isMiddleWare"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.API_Endpoint.$invalid && (vm.dataForm.API_Endpoint.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'API_ENDPOINT\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="API_Endpoint" ng-model="vm.profile.endpointUrl" ng-required="vm.profile.isMiddleWare"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.API_Endpoint.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.profile.isMiddleWare"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Username.$invalid && (vm.dataForm.Username.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'API_USERNAME\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Username" ng-model="vm.profile.username" ng-required="vm.profile.isMiddleWare"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Username.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row" ng-if="vm.profile.isMiddleWare"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Password.$invalid && (vm.dataForm.Password.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'API_PASSWORD\' | translate }}</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Password" ng-model="vm.profile.password" ng-required="vm.profile.isMiddleWare"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Password.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/smartkitchen/machineordermenusetup/momsCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartkitchen/mcprofiles/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartkitchen.machineconnectionprofiles.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/smartkitchen/machineordermenusetup/momsList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.profileData" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Profile" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartkitchen.machineconnectionprofiles.create" rms-check-access="smartkitchen.machineconnectionprofiles" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> {{ \'ADD_NEW\' | translate }}</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th>{{ \'DESCRIPTION\' | translate }}</th><th>{{ \'BRANCH_NAME\' | translate }}</th><th>{{ \'EQUIPMENT_NAME\' | translate }}</th><th>{{ \'IS_MIDDLEWARE\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th colspan="2"></th><th><select st-search="branchName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.profileDataFull | unique:\'branchName\'" value="{{s.branchName}}">{{s.branchName}}</option></select></th><th><select st-search="equipmentName"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.profileDataFull | unique:\'equipmentName\'" value="{{s.equipmentName}}">{{s.equipmentName}}</option></select></th><th colspan="3"></th></tr></thead><tbody><tr ng-if="vm.profileData.length==0 && !vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="7" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.profileData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td>{{item.branchName}}</td><td>{{item.equipmentName}}</td><td><i class="fa fa-check" ng-show="item.isMiddleWare" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isMiddleWare" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="smartkitchen.machineconnectionprofiles.update({id:item.id})" rms-check-access="smartkitchen.machineconnectionprofiles" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Remove Profile" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteProfile(item.id, item.name)" ng-confirm-click="Confirm remove this Profile?" rms-check-access="smartkitchen.machineconnectionprofiles" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/smartkitchen/machineordermenusetup/momsUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartkitchen/mcprofiles/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartkitchen.machineconnectionprofiles.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartkitchen.machineconnectionprofiles.list" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/smartkitchen/joblist/skjob.html','<div class="row"><div class="col-lg-12"><div id="kitchenjobdetail" class="kitchenjobdetail"><div class="kj-jobheader" ng-class="{ \'kj-jobheader-start\': vm.data.isStarted==true, \'kj-jobheader-hold\': vm.data.isOnHold==true }"><div class="kj-left"><img class="kj-image" src="{{((vm.data.recipeThumbnail==null || vm.data.recipeThumbnail==\'\') ? \'assets/img/empty_placeholder.png\' : vm.blobUrl + vm.data.recipeThumbnail)}}"></div><div class="kj-right"><a href="" class="kj-close pull-right" ui-sref="smartkitchen.joblist" ng-if="vm.data.isStarted!=true"><i class="fa fa-times fa-2x"></i></a> {{ vm.data.remarks }}<br><span class="kj-recipename"><b>{{ vm.data.itemName }}</b></span><br>Quantity: {{ vm.data.quantity | number:0 }}</div><a href="" class="kj-start btn btn-lg btn-with-icon btn-success pull-right" ng-if="vm.data.isStarted!=true" ng-click="vm.startJob(true)"><i class="fa fa-play"></i> Start Cooking</a> <a href="" class="kj-start btn btn-lg btn-with-icon btn-success pull-right" ng-if="vm.data.isStarted==true && !vm.isRunning" ng-click="vm.resumeJob()"><i class="fa fa-play"></i> Continue Cooking</a><div class="kj-progress" ng-if="vm.data.isStarted==true && vm.isRunning"><div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width:{{ (vm.data.timeLapsed / vm.data.totalTimeSecond * 100) | number:0 }}%"></div></div><div class="kj-progress-time" ng-if="vm.data.isCompleted!=true">Time Remaining : {{ vm.convertStoMs(vm.data.totalTimeSecond - vm.data.timeLapsed) }}</div><div class="kj-progress-time" ng-if="vm.data.isCompleted==true">Ready to serve!</div></div></div><div class="kj-tabs" role="group"><a href="" class="btn btn-with-icon" ng-class="{ \'btn-primary\': vm.selectedTab1, \'btn-default\': !vm.selectedTab1 }" ng-click="vm.selectTab1()"><i class="fa fa-leaf"></i> {{ \'INGREDIENTS\' | translate }}</a> <a href="" class="btn btn-with-icon" ng-class="{ \'btn-primary\': vm.selectedTab2, \'btn-default\': !vm.selectedTab2 }" ng-click="vm.selectTab2()"><i class="fa fa-lightbulb-o"></i> {{ \'INSTRUCTIONS\' | translate }}</a></div><div class="kj-jobingredients" ng-if="vm.selectedTab1"><div class="jobingredient" ng-repeat="i in vm.data.recipeIngredients"><div class="kj-uom">{{ i.quantity | number }} {{ i.uomName }}</div><div class="kj-itemname">{{ i.itemName }}</div></div></div><div class="kj-jobsteps" ng-if="vm.selectedTab2"><div class="jobstep" ng-class="{ \'inactive\' : s.isStarted==false }" ng-repeat="s in vm.data.retailKitchenJobSteps" ng-if="s.isCompleted!=true"><div class="jobstep-content">Step {{ s.step + 1}} :<div class="row"><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8"><div class="stepdesc">{{ s.description }}</div><div class="stepextradesc" ng-if="s.extraDescription">{{ s.extraDescription }}</div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="row" ng-if="!s.enableTemperatureControl"><div class="col-lg-12 steptime">{{ (s.totalTimeSecond - s.timeLapsed) | number:0 }}s<div ng-if="s.isStarted==true"><small>Remaining</small></div></div></div></div></div></div><div class="jobstep-progress progress" ng-if="s.isStarted==true"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width:{{ (s.timeLapsed / s.totalTimeSecond * 100) | number:0 }}%"></div></div></div><a href="" class="kj-complete btn btn-lg btn-success" ng-if="vm.data.isCompleted==true" ng-click="vm.completeJob()">COMPLETE COOKING</a></div></div></div></div>');
$templateCache.put('app/pages/smartkitchen/joblist/skjobList.html','<div class="row"><div class="col-lg-12"><div ng-if="vm.isSuperAdmin"><a href="" class="btn btn-primary btn-with-icon btn-sm" confirmed-click="vm.completeAllJobs()" ng-confirm-click="*WARNING* Confirm compelte all jobs?"><i class="fa fa-expand"></i> {{ \'COMPLETE_ALL_JOBS\' | translate }}</a><br></div><div id="kitchenjoblist" class="kitchenjoblist"><a href="" class="kitchenjob" ui-sref="smartkitchen.joblist.update({id:j.id})" ng-repeat="j in vm.dataList track by j.id"><span class="kj-status pull-right">{{ j.status }}</span><div class="kj-left"><img class="kj-image" src="{{((j.recipeThumbnail==null || j.recipeThumbnail==\'\') ? \'assets/img/empty_placeholder.png\' : vm.blobUrl + j.recipeThumbnail)}}"></div><div class="kj-right"><span class="kj-jobdate"><b>{{ j.remarks }}</b></span><span class="kj-recipename">{{ j.itemName }}</span><br><span class="kj-quantity">Quantity</span> : <b>{{ j.quantity }}</b></div></a></div><div ng-if="!vm.isLoading && vm.dataList.length==0" style="height:250px;line-height:250px;text-align:center;"><i class="fa fa-info-circle"></i> No new job available.</div><div ng-if="vm.isLoading" style="height:250px;line-height:250px;text-align:center;"><i class="fa fa-spinner fa-spin fa-fw"></i> Loading jobs...</div></div></div>');
$templateCache.put('app/pages/smartiotsettings/notifications/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_NOTIFICATION_SETTINGS_WHEN_SENSOR_ALERT_IS_TRIGGERED"></span>.</small><br><br></p><div class="row"><div class="col-md-1 col-lg-1" style="padding-right:0px"><div class="form-group"><label><b translate="ENABLED"></b></label><div><toggle ng-model="vm.setting.triggerAlert" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-6 col-lg-6" ng-if="vm.setting.triggerAlert"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Email.$invalid && (vm.dataForm.Email.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_A_SENSOR"></b> &nbsp;(<span translate="OPTIONAL"></span>. <span translate="RECIPIENT_WILL_ONLY_RECEIVE_NOTIFICATION_FROM_THE_SELECTED_SENSOR"></span>)</label><div class="row"><div class="col-md-8 col-lg-8"><select name="Sensor" class="form-control" style="background:#FFFCED" ng-change="vm.selectedSensorChanged()" ng-options="s as ((s.groupName || \'-NO GROUP-\') + \' >>> \' + s.description | uppercase) for s in vm.sensorList | orderBy:[\'groupName\',\'description\']" ng-model="vm.selectedSensor"><option value="">-- {{ \'SELECT_A_SENSOR\' | translate }} --</option></select></div><div class="col-md-4 col-lg-4" style="padding-left:0px"><a href="" class="btn btn-with-icon btn-danger" ng-if="vm.selectedSensor!=null" ng-click="vm.clearSensor()"><i class="fa fa-trash"></i> {{ "CLEAR" | translate}}</a></div></div></div></div></div><div class="row"><div class="col-md-1 col-lg-1" style="padding-right:0px"><div class="form-group"><label><b translate="EMAIL_ALERT"></b></label><div><toggle ng-model="vm.setting.alertByEmail" ng-change="changed()" on="ON" off="OFF" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-4 col-lg-4" ng-if="vm.setting.alertByEmail"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Email.$invalid && (vm.dataForm.Email.$dirty || vm.dataForm.$submitted)}"><label><b translate="EMAIL_ADDRESS"></b> <i class="fa fa-asterisk req"></i> &nbsp;(<span translate="USE_SEMI-COLON_TO_SPECIFY_MULTIPLE_EMAILS"></span>)</label> <input type="text" class="form-control" name="Email" placeholder="Email" ng-model="vm.setting.email" ng-required="vm.setting.alertByEmail"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2" ng-if="vm.setting.alertByEmail && vm.selectedBranch!=null"><div class="form-group"><div style="height:21px"></div><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.clearBranch()"><i class="ion ion-close"></i> <span translate="CLEAR_BRANCH"></span></a></div></div></div><div class="row"><div class="col-md-1 col-lg-1" style="padding-right:0px"><div class="form-group"><label><b translate="PUSH_NOTIFICATION"></b></label><div><toggle ng-model="vm.setting.alertByPN" ng-change="changed()" on="ON" off="OFF" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-4 col-lg-4" ng-if="vm.setting.alertByPN"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.User.$invalid && (vm.dataForm.User.$dirty || vm.dataForm.$submitted)}"><label><b translate="SELECT_A_USER"></b> <i class="fa fa-asterisk req"></i> &nbsp;( <span translate="USER_WILL_RECEIVE_PUSH_NOTIFICATION_ON_MOBILE_APP"></span>)</label><select name="User" class="form-control" style="background:#FFFCED" ng-change="vm.selectedUserChanged()" ng-options="b as (b.firstName + \' \' + b.lastName | uppercase) for b in vm.users | orderBy:\'firstName\'" ng-model="vm.selectedUser" ng-required="vm.setting.alertByPN"><option value="">-- {{ \'SELECT_A_USER\' | translate }} --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.User.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.setting.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_NOTIFICATION_SETTING"></span>.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br><span translate="THERE_IS_NO_CHANGES_YET"></span>.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/smartiotsettings/notifications/notificationCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartiotsettings/notifications/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartiotsettings.notifications.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/smartiotsettings/notifications/notificationList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.settingData" refresh-table=""><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Setting" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartiotsettings.notifications.create" rms-check-access="smartiotsettings.notifications" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> <span translate="ADD_NEW_SETTING"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th rowspan="2" style="width:60px">#</th><th rowspan="2" style="width:100px;text-align:center" class="hide-after"><span translate="ENABLED"></span></th><th colspan="2" style="width:100px;text-align:center"><span translate="ALERT_METHOD"></span></th><th rowspan="2">&nbsp;</th><th rowspan="2" translate="TARGET_SENSOR"></th><th rowspan="2" translate="EMAIL"></th><th rowspan="2" translate="USER"></th><th rowspan="2" style="width:40px"></th><th rowspan="2" style="width:40px"></th></tr><tr class="sortable"><th class="hide-after" style="width:100px;text-align:center"><span translate="EMAIL"></span></th><th class="hide-after" style="width:100px;text-align:center;line-height:100%"><span translate="PUSH_NOTIFICATION"></span></th></tr></thead><tbody><tr ng-if="vm.settingData.length<=0 && !vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.settingData"><td>{{vm.startIndex+1+$index}})</td><td style="text-align:center"><i class="fa fa-check" ng-if="item.triggerAlert" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.triggerAlert" style="color:#f00"></i></td><td style="text-align:center"><i class="fa fa-check" ng-if="item.alertByEmail" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.alertByEmail" style="color:#f00"></i></td><td style="text-align:center"><i class="fa fa-check" ng-if="item.alertByPN" style="color:#0f0"></i> <i class="fa fa-times" ng-if="!item.alertByPN" style="color:#f00"></i></td><td class="text-center" style="padding-top:1px;padding-bottom:8px;line-height:120%"><div class="report-type-tag" style="width:auto !important" nowrap="nowrap" ng-if="item.alertByEmail && item.branchName!=null">{{ item.branchName }}</div></td><td style="padding-top:8px;padding-bottom:8px;line-height:120%" nowrap="nowrap"><span ng-if="item.sensorName!=null">{{item.gatewayName | uppercase }} &nbsp;&rarr;&nbsp; {{item.sensorName | uppercase}}</span> <span ng-if="item.sensorName==null">-</span></td><td style="padding-top:8px;padding-bottom:8px;line-height:120%">{{item.email}}</td><td>{{item.username | uppercase}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="smartiotsettings.notifications.update({id:item.id})" rms-check-access="smartiotsettings.notifications" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Setting" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteSetting(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this setting?" rms-check-access="smartiotsettings.notifications" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/smartiotsettings/notifications/notificationUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/smartiotsettings/notifications/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="smartiotsettings.notifications.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="smartiotsettings.notifications.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/smartkitchen/skbranches/skBranchList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.branchData" refresh-table=""><thead><tr><th colspan="4" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Branch" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" rms-check-access="smartkitchen.skbranches" rms-check-access-perm-type="CREATE" ng-click="vm.showAddBranchModal()"><i class="ion-plus-round"></i> {{ \'ADD_BRANCH\' | translate }}</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th>{{ \'BRANCH_CODE\' | translate }}</th><th>{{ \'BRANCH_NAME\' | translate }}</th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.branchData.length==0 && !vm.isLoading"><td colspan="4" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="4" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.branchData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.branchCode}}</td><td>{{item.branchName}}</td><td align="center"><a href="" title="Remove Branch" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteBranch(item.branchId, item.branchName)" ng-confirm-click="Confirm remove this Branch?" rms-check-access="smartkitchen.skbranches" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="4" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="SKAddBranchModal.html"><form name="$mdl.branchForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ \'ADD_BRANCH\' | translate }}</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.branchForm.Company.$invalid && $mdl.branchForm.$submitted}"> <label> <b>{{ \'SELECT_A_BRANCH\' | translate }}</b> <i class="fa fa-asterisk req" style="color:#f00"></i> </label> <select class="form-control" name="Branch" ng-options="b as (b.name | uppercase) for b in $mdl.branchList track by b.id" ng-change="$mdl.selectedBranchChanged()" ng-model="$mdl.selectedBranch" required> <option value="">-- {{ \'SELECT_A_BRANCH\' | translate }} --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.branchForm.Company.$error.required && $mdl.branchForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.isLoading || $mdl.isProcessing"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.isLoading || $mdl.isProcessing"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/sops/cards/cardCategories.html','<div class="widgets recipe"><div class="row"><div class="col-md-12" ba-panel=""><div class="row"><div class="col-md-5 col-lg-5"><p><small><i class="fa fa-info-circle"></i> <em translate="CLICK_ON_ONE_OF_THE_CATEGORIES_TO_SHOW_THE_S.O.P.S"></em></small><br>&nbsp;<br>&nbsp;</p></div><div class="col-md-4 col-lg-4"><a href="" class="btn btn-with-icon btn-primary pull-right" ng-click="vm.showSearchSopDialog()"><i class="fa fa-search"></i> <span translate="QUICK_SEARCH_S.O.P"></span></a></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" style="background-color:#fffeed" ng-model="vm.searchTextOri" ng-model-options="{ debounce: 500 }" ng-change="vm.searchForText()"></div></div><div class="row" ng-if="vm.isLoading"><div class="col-lg-12"><div style="background:#fafafa;margin-bottom:15px;padding-top:10px;padding-bottom:10px;font-size:16pt;color:#00f"><center><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</center></div></div></div><div class="row" ng-if="vm.isSearching"><div class="col-lg-12"><div style="background:#fafafa;margin-bottom:15px;padding-top:10px;padding-bottom:10px;font-size:16pt;color:#00f"><center><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="SEARCHING"></span> ...</center></div></div></div><div class="row" ng-if="!vm.isLoading && !vm.isSearching && filteredRecord.length==0"><div class="tile-container col-lg-12"><div style="background:#fafafa;height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></div></div></div><div class="row"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-repeat="cat in vm.cateDataFull | filter:vm.searchText as filteredRecord"><a href="" ui-sref="sops.cards.sops({id:cat.id})"><i class="fa fa-star fa-2x" aria-hidden="true" ng-show="cat.isComplimentary"></i><div class="img" afkl-lazy-image="{{cat.thumbnail || cat.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4>{{cat.name | uppercase}}</h4><i class="fa fa-eye"></i></a></div></div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3"><br>{{ \'TOTAL_RECORDS\' | translate}}: <b>{{filteredRecord.length}}</b><br>&nbsp;</div></div></div></div><script type="text/ng-template" id="SearchSopModal.html"><form name="$mdl.searchSopForm" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="QUICK_SEARCH_S.O.P"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <div class="row"> <div class="col-lg-12"> <div class="input-group"> <span class="input-group-addon" style="padding:0px"> <i class="fa fa-search" style="padding:3px 10px"></i> </span> <input type="text" name="SearchText" class="form-control" placeholder="Enter keyword to search (Min. 3 letters)" ng-disabled="$mdl.isLoading" ng-model="$mdl.searchText" ng-model-options=\'{ debounce: 500 }\' ng-change="$mdl.searchSop()" min=3 /> </div> </div> </div> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div style="max-height:500px;overflow-y:scroll"> <table class="table table-striped" style="border:1px solid #ccc" st-table="$mdl.sopList" refresh-table> <thead> <tr> <th style="width:60px">#</th> <th style="width:200px"><b translate="S.O.P_IMAGE"></b></th> <th><b translate="S.O.P_NAME"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="ntn in $mdl.sopList"> <td>{{ $index+1 }})</td> <td style="padding-top:10px;padding-bottom:10px"> <img src="{{ntn.thumbnail || ntn.imageLocation || \'assets/img/sop_empty_placeholder.png\'}}" alt="" style="width:160px;height:85px" /> </td> <td style="padding-top:10px;padding-bottom:10px;line-height:150%;color:#000"> <big><b>{{ ntn.name || \'\' | uppercase }}</b></big> <br /> <div style="width:auto;line-height:100%"> <div class="report-type-tag" ng-repeat="c in ntn.sopCategories" style="width:auto;margin-right:5px;padding:2px 8px;border:1px solid #888"> {{c.name | uppercase}} </div> </div> </td> <td style="padding-top:10px"> <a href class="btn btn-primary editable-table-button btn-sm" ui-sref="sops.cards.view({id:ntn.id})" ng-click="$mdl.cancelModal()"> <span style="color:#fff" translate="GO"></span> &nbsp; <i class="fa fa-arrow-circle-right"></i> </a> </td> </tr> <tr> <td colspan="4" align="center" ng-show="$mdl.sopList.length==0"> <br /> {{ \'NO_RECORD_FOUND\' | translate }} <br />&nbsp; </td> </tr> </tbody> </table> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.isLoading" style="color:#00f;margin-left:30px"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b><span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/sops/cards/cardSops.html','<div class="widgets sop"><div class="row"><div class="col-md-12" ba-panel=""><div class="row"><div class="col-md-1 col-lg-1"><a href="" class="btn btn-primary btn-with-icon" style="float:left;margin-right:20px" ui-sref="sops.cards.categories"><i class="ion-chevron-left"></i><span translate="BACK"></span></a></div><div class="col-md-8 col-lg-8" style="vertical-align:middle"><div style="font-size:22pt;height:auto;line-height:110%;"><big><b>{{ vm.category.name | uppercase }}</b></big></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" style="background-color:#fffeed" ng-model="vm.searchTextOri" ng-model-options="{ debounce: 500 }" ng-change="vm.searchForText()"></div><p><br></p></div><div class="row"><hr></div><p><small><i class="fa fa-info-circle"></i> <em><span translate="CLICK_ON_ONE_OF_THE_TILES_TO_VIEW_THE_S.O.P_CARD"></span>.</em></small><br>&nbsp;</p><div class="row" ng-if="vm.isLoading"><div class="col-lg-12"><div style="background:#fafafa;margin-bottom:15px;padding-top:10px;padding-bottom:10px;font-size:16pt;color:#00f"><center><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</center></div></div></div><div class="row" ng-if="vm.isSearching"><div class="col-lg-12"><div style="background:#fafafa;margin-bottom:15px;padding-top:10px;padding-bottom:10px;font-size:16pt;color:#00f"><center><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="SEARCHING"></span> ...</center></div></div></div><div class="row" ng-if="!vm.isLoading && !vm.isSearching && filteredRecord.length==0"><div class="tile-container col-lg-12"><div style="background:#fafafa;height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></div></div></div><div class="row"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-repeat="r in vm.sopDataFull | filter:vm.searchText as filteredRecord"><a href="" ui-sref="sops.cards.view({id:r.id})"><div class="img" afkl-lazy-image="{{r.thumbnail || r.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4><b>{{r.name | uppercase}}</b></h4></a></div></div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3"><br>{{ \'TOTAL_RECORDS\' | translate}}: <b>{{filteredRecord.length}}</b><br>&nbsp;</div></div></div></div>');
$templateCache.put('app/pages/sops/cards/cardView.html','<div class="widgets sop"><div class="row"><div class="col-md-12" ba-panel=""><div class="row"><div class="col-md-12 col-lg-12" style="font-size:22pt;font-weight:bold;padding:10px 15px 20px"><i class="ion ion-ios-book" style="margin-right:10px"></i> {{vm.sop.name | uppercase}}</div></div><div class="row"><div class="col-md-12 col-lg-12" style="padding-bottom:25px;"><a href="" class="btn btn-primary btn-with-icon" ng-click="vm.goBack()"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <a href="" class="btn btn-default btn-with-icon" ng-click="vm.printSOP(vm.sop.id, vm.sop.name)" rms-check-access="sops.cards" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <span translate="PRINT_S.O.P_(FULL)"></span></a> <a href="" class="btn btn-default btn-with-icon" ng-click="vm.printSOPSimple(vm.sop.id, vm.sop.name)" rms-check-access="sops.cards" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i> <span translate="PRINT_S.O.P_(SIMPLE)"></span></a> <a href="" class="btn btn-default btn-with-icon" ng-click="vm.showShareDialog()" rms-check-access="sops.cards" rms-check-access-perm-type="EXPORT"><span class="text-primary"><i class="fa fa-paper-plane"></i> <span translate="EZYSHARE"></span></span></a></div></div><div class="row"><div class="col-md-7 col-lg-5"><div class="row"><img ng-src="{{vm.sop.thumbnail || vm.recipe.imageLocation}}" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="margin-bottom:20px"></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><br><center><a href="#step_1" class="btn btn-success btn-with-icon btn-lg" du-smooth-scroll="" ng-click="vm.startStep()"><i class="ion ion-flag"></i> <span translate="START_NOW"></span></a></center></div></div></div></div><a ng-if="vm.sop.sopSteps==0" name="step_1"></a><div class="row" ng-repeat="s in vm.sop.sopSteps | orderBy: \'step\'"><a name="step_{{s.step+1}}"></a><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="step col-md-5 col-lg-5"><ng-youtube-embed url="s.attachmentLocation" width="100%" height="492px" showinfo="false" controls="false" rel="false" ng-if="s.attachmentType==\'youtube\' && s.attachmentLocation!=\'\' && s.attachmentLocation!=null"></ng-youtube-embed><iframe ng-src="{{s.finalVimeoUrl}}" width="100%" height="400" frameborder="0" style="background:#000" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" ng-if="s.attachmentType.substring(0,5)==\'video\' && s.isVimeoConverted && s.vimeoVideoId!=\'\'"></iframe><img src="{{vm.rootUrl}}{{s.attachmentLocation}}" alt="" style="width:100%" class="step-image-card" fancyboxable="{href:\'{{vm.rootUrl}}{{s.attachmentLocation}}\'}" ng-if="s.attachmentType.substr(0,5)==\'image\' && (s.attachmentLocation!=\'\' && s.attachmentLocation!=null)"> <img src="assets/img/sop_empty_placeholder.png" alt="" style="width:100%" class="step-image-card" ng-if="s.attachmentLocation==\'\' || s.attachmentLocation==null"></div><div class="col-md-7 col-lg-7"><div class="row"><div class="col-md-12 col-lg-12"><div style="padding: 10px;"><h1 style="margin-bottom:20px;"><span translate="STEP"></span> {{s.step+1}}</h1><div style="font-size:16pt;line-height:150%;margin-bottom:20px;"><b>{{s.name}}</b></div><div style="font-size:16pt;line-height:150%;margin-bottom:20px;white-space:pre-wrap">{{s.description}}</div><div style="font-size:14pt;line-height:150%;color:#b00;" ng-show="s.extraDescription"><em><b>* <span translate="ATTENTION"></span> *</b></em><div style="color:#b00;white-space:pre-wrap">{{s.extraDescription}}</div></div></div></div></div></div><div class="col-md-12 col-lg-12"><div class="row"><div class="col-md-12 col-lg-12"><a href="#step_{{s.step+2}}" class="btn btn-success btn-with-icon btn-lg pull-right" du-smooth-scroll="" ng-hide="s.step+1==vm.sop.sopSteps.length"><i class="ion ion-chevron-right"></i> <span translate="NEXT_STEP"></span></a> <a href="#step_{{s.step}}" class="btn btn-primary btn-with-icon btn-lg pull-right" style="margin-right:10px" du-smooth-scroll="" ng-hide="s.step==0 || s.step+1==vm.sop.sopSteps.length"><i class="ion ion-chevron-left"></i> <span translate="PREV_STEP"></span></a> <a href="#step_1" class="btn btn-primary btn-with-icon btn-lg pull-right" style="margin-right:10px" du-smooth-scroll="" ng-hide="s.step+1!=vm.sop.sopSteps.length"><i class="ion ion-chevron-up"></i> <span translate="START_OVER"></span></a></div></div></div></div></div></div><div class="row" ng-show="vm.sop.sopSteps.length==0"><div class="col-md-12 col-lg-12"><table class="table table-striped"><tbody><tr><td align="center"><br><span translate="STEP_LIST_IS_EMPTY."></span><br>&nbsp;</td></tr></tbody></table></div></div></div><script type="text/ng-template" id="shareDialogModal.html"><form name="$mdl.shareForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header" style="background:#2f59d4"> <h3 class="modal-title" style="color:#fff"> <i class="fa fa-paper-plane"></i> &nbsp;<span translate="EZYSHARE"></span> &nbsp; <span style="font-size:10pt"><span translate="SHARE_SECURELY"></span> &bull; <span translate="EASILY"></span></span> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"> <b translate="ENTER_THE_RECIPIENT_EMAIL_ADDRESS(ES):"></b> <br /><small translate="NOTE:_ENTER_MULTIPLE_EMAIL_ADDRESSES_AND_SEPARATE_THEM_BY_COMMA_(,)_OR_SEMI-COLON_(;)"></small> </label> <input name="Email" type="text" class="form-control" style="background:#ffffff" autocomplete="off" ng-model="$mdl.item.recipientEmail" ng-disabled="$mdl.lockButton" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.shareForm.Email.$error.required && $mdl.shareForm.$submitted">* <span translate="EMAIL_ADDRESS_IS_REQUIRED"></span></p> <p class="help-block" style="color:#f00" ng-show="$mdl.shareForm.Email.$error.email && $mdl.shareForm.$submitted">* <span translate="INVALID_EMAIL_FORMAT"></span></p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label style="color:#000"><b translate="ENTER_A_PASSWORD_TO_ACCESS_THE_LINK:"></b></label> <input name="Password" type="password" class="form-control" style="background:#ffffff" autocomplete="off" ng-model="$mdl.item.password" ng-disabled="$mdl.lockButton" required /> <p class="help-block" style="color:#f00" ng-show="$mdl.shareForm.Password.$error.required && $mdl.shareForm.$submitted">* <span translate="PASSWORD_IS_REQUIRED"></span></p> </div> </div> </div> <legend ng-if="$mdl.showSuccess || $mdl.showError"></legend> <div class="row" ng-if="$mdl.showSuccess"> <div class="col-lg-12"> <span style="color:#0a8a0a"> <i class="fa fa-check"></i> &nbsp; <span translate="A_SECURED_LINK_HAS_BEEN_SENT_TO_THE_RECIPIENT_SUCCESSFULLY"></span>. </span> </div> </div> <div class="row" ng-if="$mdl.showError"> <div class="col-lg-12"> <span style="color:#f00"> <i class="fa fa-exclamation-triangle"></i> &nbsp; <span style="color:#f00" ng-bind-html="$mdl.errorMsg"></span> </span> </div> </div> </div> <legend></legend> <div class="modal-footer"> <button class="btn btn-primary btn-with-icon btn-lg" type="submit" ng-disabled="$mdl.lockButton" style="float:left"> <i class="fa fa-paper-plane"></i> <span translate="SHARE"></span> </button> <button class="btn btn-danger btn-with-icon btn-lg" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> <br /> <div ng-if="$mdl.lockButton && !$mdl.showSuccess && !$mdl.showError" style="float:left;margin-top:10px"> <i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="PROCESSING"></span> ...</b> </div> </div> </form></script>');
$templateCache.put('app/pages/sops/sops/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><div class="panel-heading"><span translate="S.O.P_NAME"></span>: <b>{{vm.sop.name | uppercase}}</b></div><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-show="!vm.sop.isApproved"><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_S.O.P._INFORMATION"></span>.</p><div ng-show="vm.sop.isApproved" class="alert bg-warning" style="color:#333"><i class="fa fa-exclamation-triangle"></i> <span translate="ALL_THE_FIELDS_ARE_LOCKED_WHEN_STATUS_IS"></span> <b translate="APPROVED"></b>. <span translate="PLEASE_INFORM_THE_MANAGER_TO"></span> <b translate="UNAPPROVE"></b> <span translate="IF_YOU_WISH_TO_MAKE_CHANGES"></span>.</div><div class="row">&nbsp;</div><div class="row"><div class="col-md-4 col-lg-4"><div class="row"><img ngf-src="picFile || vm.sop.imageLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div><div class="row"><div class="col-md-12 col-lg-12"><p><small><i class="fa fa-info-circle"></i> <em><span translate="RECOMMENDED_TO_UPLOAD_A_LANDSCAPE_IMAGE"></span>.</em></small></p>&nbsp;</div></div><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-hide="vm.lockUploadButton || vm.sop.isApproved" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> {{ \'UPLOAD_PICTURE\' | translate }}</div><a href="" class="btn btn-default btn-with-icon" ng-click="picFile=null;vm.sop.imageLocation=\'\';vm.setUploadImage(picFile)" ng-hide="vm.lockUploadButton || vm.sop.isApproved" ng-show="(picFile || vm.sop.imageLocation) && !vm.lockUploadButton"><i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }}</a></div><div class="row" ng-show="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div><div class="col-md-4 col-lg-4"><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-class="{\'has-error\': vm.dataForm.SOPName.$invalid && (vm.dataForm.SOPName.$dirty || vm.dataForm.$submitted)}"><label"><b>{{ \'S.O.P._TITLE\' | translate }}</b> <i class="fa fa-asterisk req"></i> <input type="text" class="form-control" name="SOPName" ng-disabled="vm.sop.isApproved" ng-model="vm.sop.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SOPName.$error.required">* {{ \'REQUIRED\' | translate }}</span></label"></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SopType.$invalid && (vm.dataForm.SopType.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'S.O.P_TYPE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="SopType" ng-disabled="vm.sop.isApproved" ng-options="t as t.name for t in vm.sopTypes track by t.id" ng-model="vm.selectedSopType" ng-change="vm.onSelectedSopTypeChanged()" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SopType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" ng-disabled="vm.sop.isApproved" ng-model="vm.sop.remarks">\n\t\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="col-md-4 col-lg-4" rms-check-access="sops.sops" rms-check-access-perm-type="APPROVE"><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label><span translate="IS_APPROVED"></span>?</label><div><toggle ng-model="vm.sop.isApproved" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label><span translate="IS_PUBLISHED"></span>?</label><div><toggle ng-model="vm.sop.isPublic" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CATEGORIES\' | translate }}"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p><i class="fa fa-info-circle"></i> <span translate="SELECT_AT_LEAST_ONE_(1)_S.O.P_CATEGORY"></span>: <i class="fa fa-asterisk req"></i></p></div></div><div class="row"><div class="col-md-4 col-lg-4" ng-repeat="c in vm.categoryList" style="margin-bottom:8px;line-height:30px"><input type="checkbox" name="cate" style="float:left;cursor:pointer;width:25px;height:25px" checklist-model="vm.selectedCategories" checklist-value="c" checklist-change="vm.dataForm.cate.$setValidity(\'required\', vm.selectedCategories.length > 0)" ng-disabled="vm.sop.isApproved" ng-required="!vm.selectedCategories.length"> <span style="padding-left:10px">{{ c.name | uppercase }}</span></div></div><div class="row"><div class="col-md-12"><p><div class="col-md-12" ng-class="{\'has-error\': vm.dataForm.$submitted && vm.dataForm.cate.$invalid }"><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.cate.$invalid">* <span translate="REQUIRE_AT_LEAST_ONE_(1)_S.O.P_CATEGORY"></span></span></div></p><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="Equipments"><p><i class="fa fa-info-circle"></i> <span translate="ASSOCIATE_RELEVANT_EQUIPMENTS_TO_THIS_S.O.P"></span>. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-if="!vm.sop.isApproved" ng-click="vm.showAddEquipmentModal()"><i class="ion-plus-round"></i> <span translate="ADD_EQUIPMENT"></span></a><br><br></p><div class="row" ng-show="vm.mode==2"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="font-size:90%;border:1px solid #ccc" st-pipe="vm.refreshEquipments" st-table="vm.sop.equipments" refresh-table=""><thead><tr><th style="width:60px">#</th><th><b translate="EQUIPMENT_CODE"></b></th><th><b translate="EQUIPMENT_BRAND"></b></th><th><b translate="EQUIPMENT_MODEL"></b></th><th><b translate="EQUIPMENT_NAME"></b></th><th><b translate="EQUIPMENT_DESCRIPTION"></b></th><th style="width:65px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.sop.equipments"><td>{{ $index+1 }})</td><td>{{ ntn.code || \'\' }}</td><td>{{ ntn.brandName || \'\' }}</td><td>{{ ntn.model || \'\' }}</td><td style="line-height:130%;padding-top:8px;padding-bottom:8px;">{{ ntn.name || \'\' }}</td><td style="line-height:130%;padding-top:8px;padding-bottom:8px;white-space:pre-wrap;">{{ ntn.description || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-if="!vm.sop.isApproved" confirmed-click="vm.removeEquipment(ntn.id)" ng-confirm-click="Confirm remove this Equipment?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="7" align="center" ng-show="vm.sop.equipments.length==0"><br><span translate="EQUIPMENT_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center><span translate="PLEASE_SAVE_THE_S.O.P._FIRST_BEFORE_ADDING_EQUIPMENTS"></span>.</center></h2></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Processes"><p><i class="fa fa-info-circle"></i> <span translate="ASSOCIATE_RELEVANT_PROCESSES_TO_THIS_S.O.P"></span>. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-if="!vm.sop.isApproved" ng-click="vm.showAddProcessModal()"><i class="ion-plus-round"></i> <span translate="ADD_PROCESS"></span></a><br><br></p><div class="row" ng-show="vm.mode==2"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="font-size:90%;border:1px solid #ccc" st-pipe="vm.refreshProcesses" st-table="vm.sop.asProcesses" refresh-table=""><thead><tr><th style="width:60px">#</th><th><b translate="PROCESS_CODE"></b></th><th><b translate="PROCESS_NAME"></b></th><th style="width:65px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.sop.asProcesses"><td>{{ $index+1 }})</td><td>{{ ntn.code || \'\' }}</td><td>{{ ntn.name || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-if="!vm.sop.isApproved" confirmed-click="vm.removeProcess(ntn.id)" ng-confirm-click="Confirm remove this Process?"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="7" align="center" ng-show="vm.sop.asProcesses.length==0"><br><span translate="LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center><span translate="PLEASE_SAVE_THE_S.O.P._FIRST_BEFORE_ADDING_PROCESSES"></span>.</center></h2></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'STEPS\' | translate }}"><p><i class="fa fa-info-circle"></i> <span translate="ADD_THE_STEPS_TO_EXECUTE_THE_S.O.P"></span>. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddStepModal()" ng-hide="vm.sop.isApproved" ng-show="vm.mode==2"><i class="ion-plus-round"></i><span translate="ADD_NEW_STEP"></span></a><br><br></p><div class="row" ng-repeat="s in vm.sop.sopSteps | orderBy: \'step\'" ng-show="vm.mode==2"><div ba-panel="" class="col-md-12 col-lg-12"><div class="row"><div class="step col-md-4 col-lg-4"><div class="step-image col-md-12 col-lg-12" afkl-lazy-image="{{vm.rootUrl}}{{s.thumbnail || s.attachmentLocation}}" afkl-lazy-image-options="{\'background\': true}" ng-if="s.attachmentType==\'image\' && (s.attachmentLocation!=\'\' && s.attachmentLocation!=null)"></div><div class="step-image col-md-12 col-lg-12" afkl-lazy-image="{{s.vimeoPictureUrl}}" afkl-lazy-image-options="{\'background\': true}" ng-if="s.attachmentType==\'video\' && s.vimeoVideoUrl!=\'\' && s.vimeoVideoUrl!=null"></div><img src="assets/img/video_pending.png" alt="" style="width:100%" class="step-image" ng-if="s.attachmentType==\'video\' && (s.vimeoVideoUrl==\'\' || s.vimeoVideoUrl==null)"> <img src="assets/img/empty_placeholder.png" alt="" style="width:100%" class="step-image" ng-if="s.attachmentLocation==\'\' || s.attachmentLocation==null"></div><div class="col-md-7 col-lg-7"><div class="row"><div class="col-md-12 col-lg-12"><div style="padding:10px;"><h4><span translate="STEP"></span> {{s.step+1}}</h4><p><b>{{s.name}}</b></p><p style="white-space:pre-wrap">{{s.description}}</p><p ng-show="s.extraDescription" style="color:#b00;padding-top:10px"><em><b>* <span translate="ATTENTION"></span> *</b></em><div style="color:#b00;white-space:pre-wrap">{{s.extraDescription}}</div></p></div></div></div></div></div><div class="row"><div class="col-md-offset-4 col-lg-offset-4 col-md-7 col-lg-7"><button type="button" class="btn btn-info btn-sm" ng-click="vm.moveStepUp(s.id)" ng-disabled="s.step==0 || vm.lockMoveButtons" ng-hide="vm.sop.isApproved"><i class="ion ion-chevron-up"></i></button> <button type="button" class="btn btn-info btn-sm" ng-click="vm.moveStepDown(s.id)" ng-disabled="s.step==(vm.sop.sopSteps.length-1) || vm.lockMoveButtons" ng-hide="vm.sop.isApproved"><i class="ion ion-chevron-down"></i></button> <button type="button" class="btn btn-info btn-with-icon btn-sm" ng-click="vm.showEditStepModal(s.id)" ng-hide="vm.lockMoveButtons || vm.sop.isApproved"><i class="ion ion-edit"></i> {{ \'EDIT\' | translate }}</button> <button type="button" class="btn btn-danger btn-with-icon btn-sm" confirmed-click="vm.removeStep(s.id)" ng-confirm-click="Confirm remove this Step?" ng-hide="vm.lockMoveButtons || vm.sop.isApproved"><i class="fa fa-trash-o"></i> {{ \'REMOVE\' | translate }}</button><br>&nbsp;</div></div></div></div><div class="row" ng-show="vm.mode==2 && vm.sop.sopSteps.length==0"><div class="col-md-12 col-lg-12"><table class="table table-striped"><tbody><tr><td align="center"><br><span translate="STEP_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-12 col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center><span translate="PLEASE_SAVE_THE_S.O.P_FIRST_BEFORE_ADDING_STEPS"></span>.</center></h2></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.sop.id!=null"><p><i class="fa fa-info-circle"></i> <span translate="AUDIT_TRAIL_OF_CHANGES_MADE_TO_THIS_S.O.P"></span>.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b translate="DATE_/_TIME"></b></th><th style="width:180px"><b translate="EDITED_BY"></b></th><th style="width:40%"><b translate="ORIGINAL_VALUES"></b></th><th style="width:40%"><b translate="UPDATED_VALUES"></b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br><span translate="THERE_IS_NO_CHANGES_YET"></span>.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="cloneSOPModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="CLONE_S.O.P_TO_OTHER_COMPANY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.cloneForm.Company.$invalid && $mdl.cloneForm.$submitted}"> <label><span translate="SELECT_A_COMPANY"></span> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="Company" ng-options="c as (c.name | uppercase) for c in $mdl.companies track by c.id" ng-model="$mdl.selectedCompany" required> <option value="">-- {{ \'SELECT_A_COMPANY\' }} --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.cloneForm.Company.$error.required && $mdl.cloneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.cloneForm.S.O.PCategory.$invalid && $mdl.cloneForm.$submitted}"> <label><span translate="SELECT_A_S.O.P_CATEGORY"></span> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="S.O.PCategory" ng-options="r as (r.name | uppercase) for r in $mdl.selectedCompany.sopCategories track by r.id" ng-model="$mdl.selectedCategory" required> <option value="">-- {{ \'SELECT_A_S.O.P_CATEGORY\' }} --</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.cloneForm.S.O.PCategory.$error.required && $mdl.cloneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="EquipmentModal.html"><form name="$mdl.equipmentForm" ng-submit="$mdl.searchEquipment()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="SELECT_EQUIPMENT"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SEARCH_EQUIPMENT"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <div class="row"> <div class="col-lg-6"> <input type="text" name="SearchText" class="form-control" placeholder="{{\'ENTER_KEYWORD_TO_SEARCH\'|translate}}" ng-disabled="$mdl.lockButton" ng-model="$mdl.searchText" min=3 required /> </div> <div class="col-lg-6"> <button type="submit" class="btn btn-default btn-with-icon" ng-disabled="$mdl.lockButton"> <i class="fa fa-search"></i> {{ \'SEARCH\' | translate}} </button> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.equipmentForm.SearchText.$error.min && $mdl.equipmentForm.$submitted">* {{ \'ENTER_MINIMUM_3_LETTERS\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.equipmentForm.SearchText.$error.required && $mdl.equipmentForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div style="max-height:400px;overflow-y:scroll"> <table class="table table-striped" style="font-size:90%;border:1px solid #ccc" st-pipe="$mdl.refreshEquipments" st-table="$mdl.equipmentList" refresh-table> <thead> <tr> <th style="width:60px">#</th> <th><b translate="CODE"></b></th> <th><b translate="BRAND"></b></th> <th><b translate="MODEL"></b></th> <th><b translate="NAME"></b></th> <th><b translate="DESCRIPTION"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="ntn in $mdl.equipmentList"> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ $index+1 }})</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.code || \'\' }}</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.brandName || \'\' }}</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.model || \'\' }}</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.name || \'\' }}</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px;white-space:pre-wrap;">{{ ntn.description || \'\' }}</td> <td style="line-height:130%;padding-top:4px;padding-bottom:8px"> <input type="checkbox" name="chkSelect" style="background:#fffff4;width:20px;height:20px" checklist-model="$mdl.selectedEquipments" checklist-value="ntn" checklist-change="$mdl.equipmentForm.chkSelect.$setValidity(\'required\', $mdl.selectedEquipments.length > 0)" ng-required="!$mdl.selectedEquipments.length" /> <!-- <a href class="btn btn-primary editable-table-button btn-with-icon btn-xs" ng-disabled="$mdl.lockButton" ng-click="$mdl.confirmModal(ntn)"> <i class="ion ion-checkmark"></i> <span translations="SELECT""></span> </a> --> </td> </tr> <tr> <td colspan="7" align="center" ng-show="$mdl.equipmentList.length==0"> <br /> <span translate="EQUIPMENT_LIST_IS_EMPTY"></span>. <br />&nbsp; </td> </tr> </tbody> </table> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" style="color:#000"> <span translate="SELECTED"></span>: <b>{{$mdl.selectedEquipments.length}}</b> </div> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f;margin-left:30px"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b> <span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.confirmModal()" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="ProcessModal.html"><form name="$mdl.processForm" ng-submit="$mdl.searchProcess()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="SELECT_PROCESS"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SEARCH_PROCESS"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <div class="row"> <div class="col-lg-6"> <input type="text" name="SearchText" class="form-control" placeholder="{{\'ENTER_KEYWORD_TO_SEARCH\'|translate}}" ng-disabled="$mdl.lockButton" ng-model="$mdl.searchText" min=3 required /> </div> <div class="col-lg-6"> <button type="submit" class="btn btn-default btn-with-icon" ng-disabled="$mdl.lockButton"> <i class="fa fa-search"></i> {{ \'SEARCH\' | translate }} </button> </div> </div> <p class="help-block" style="color:#f00" ng-show="$mdl.processForm.SearchText.$error.min && $mdl.processForm.$submitted">* {{ \'ENTER_MINIMUM_3_LETTERS\' | translate }}</p> <p class="help-block" style="color:#f00" ng-show="$mdl.processForm.SearchText.$error.required && $mdl.processForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div style="max-height:400px;overflow-y:scroll"> <table class="table table-striped" style="font-size:90%;border:1px solid #ccc" st-pipe="$mdl.refreshProcesss" st-table="$mdl.processList" refresh-table> <thead> <tr> <th style="width:60px">#</th> <th><b translate="PROCESS_CODE"></b></th> <th><b translate="PROCESS_NAME"></b></th> <th style="width:65px"></th> </tr> </thead> <tbody> <tr ng-repeat="ntn in $mdl.processList"> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ $index+1 }})</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.code || \'\' }}</td> <td style="line-height:130%;padding-top:8px;padding-bottom:8px">{{ ntn.name || \'\' }}</td> <td style="line-height:130%;padding-top:4px;padding-bottom:8px"> <input type="checkbox" name="chkSelect" style="background:#fffff4;width:20px;height:20px" checklist-model="$mdl.selectedProcesses" checklist-value="ntn" checklist-change="$mdl.processForm.chkSelect.$setValidity(\'required\', $mdl.selectedProcesses.length > 0)" ng-required="!$mdl.selectedProcesses.length" /> </td> </tr> <tr> <td colspan="7" align="center" ng-show="$mdl.processList.length==0"> <br /> <span translate="LIST_IS_EMPTY"></span>. <br />&nbsp; </td> </tr> </tbody> </table> </div> </div> </div> </div> <div class="modal-footer"> <div style="float:left" style="color:#000"> <span translate="SELECTED"></span>: <b>{{$mdl.selectedProcesses.length}}</b> </div> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f;margin-left:30px"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b> <span translate="PROCESSING"></span> ...</b> </div> <button class="btn btn-primary btn-with-icon" type="button" ng-click="$mdl.confirmModal()" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="stepModal.html"><form name="$mdl.stepForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} <span translate="STEP"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-5 col-lg-5"> <div ba-panel ba-panel-class="horizontal-tabs tabs-panel panel panel-primary"> <uib-tabset active="$mdl.activeTab"> <uib-tab heading="Upload"> <p><small><i class="fa fa-info-circle"></i> <span translate="UPLOAD_IMAGE_/_VIDEO_FILE_FROM_COMPUTER"></span>.</small> <br /> </p> <div class="row"> <!-- Preview --> <img alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="max-height:400px" ngf-src="$mdl.mediaFile" ng-if="$mdl.mediaFile" /> <video class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="background:#000;max-height:200px" controls ngf-src="$mdl.mediaFile" ng-if="$mdl.mediaFile"> </video> <!-- Preview --> <!-- Empty Placeholder --> <img alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" src="assets/img/empty_placeholder.png" ng-if="!$mdl.mediaFile" /> <!-- Empty Placeholder --> </div> <div class="row"> <div class="col-md-12 col-lg-12" style="padding-top:5px"> <p><small><i class="fa fa-info-circle"></i> <span translate="RECOMMENDED_TO_UPLOAD_A_LANDSCAPE_MEDIA_FILE"></span>.</small></p> </div> </div> <div class="row"> &nbsp; </div> <div class="row" style="text-align:center" ng-hide="0 < $mdl.uploadProgess"> <a href class="btn btn-primary btn-with-icon" name="file" ng-model="$mdl.mediaFile" ngf-select="$mdl.setUploadMedia($mdl.mediaFile)" ngf-accept="\'image/*,video/*\'" ngf-pattern="\'image/*,video/*\'" ngf-model-invalid="errorFile" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-upload"></i> <span translate="UPLOAD_MEDIA"></span> </a> <a href ng-click="$mdl.mediaFile=null" ng-show="$mdl.mediaFile" class="btn btn-default btn-with-icon" ng-disabled="$mdl.lockUploadButton || $mdl.lockButton" ng-show="!$mdl.lockUploadButton"> <i class="ion ion-android-remove-circle"></i> <span translate="RESET_MEDIA"></span> </a> </div> <div class="row" ng-if="$mdl.mediaFile && $mdl.uploadProgess!=0"> <div style="width:85%;height:20px;margin:10px auto 5px"> <span translate="MEDIA_UPLOADING"></span>... </div> <div class="progress" style="background:rgba(255,255,255, 0.6);width:85%;height:20px;margin:0px auto"> <div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000"> {{$mdl.uploadProgessPercent | number:0}}% <!--{{ $mdl.uploadProgess }} / {{ $mdl.uploadProgessTotal }}--> </div> <div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="$mdl.uploadProgess" aria-valuemax="$mdl.uploadProgessTotal" style="width: {{$mdl.uploadProgessPercent | number:0}}%"> </div> </div> </div> <div class="row" ng-show="$mdl.lockUploadButton" style="text-align:center;color:#f00"> <i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>. </div> <div class="row"> &nbsp; </div> <div class="row"> &nbsp; </div> </uib-tab> <uib-tab heading="Video Player" ng-if="$mdl.item.attachmentType.substring(0,5)==\'video\'"> <p><small><i class="fa fa-info-circle"></i> <span translate="THE_CURRENT_VIDEO_OF_THE_STEP"></span>.</small> <br /> </p> <!-- Video --> <div class="row"> <iframe ng-src="{{$mdl.item.finalVimeoUrl}}" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" height="200" frameborder=\'0\' class="step-image-card" style="background:#000" webkitAllowFullScreen mozallowfullscreen allowFullScreen ng-if="$mdl.item.attachmentType.substring(0,5)==\'video\' && $mdl.item.isVimeoConverted && $mdl.item.vimeoVideoId!=\'\'"> </iframe> </div> <!-- Video --> <div class="row"> &nbsp; </div> <div class="row"> &nbsp; </div> </uib-tab> <uib-tab heading="Image Viewer" ng-if="$mdl.item.attachmentType.substring(0,5)==\'image\'"> <p><small><i class="fa fa-info-circle"></i> <span translate="THE_CURRENT_IMAGE_OF_THE_STEP"></span>.</small> <br /> </p> <!-- Image --> <div class="row"> <img alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="max-height:400px" ngf-src="$mdl.item.blobLocation" ng-if="$mdl.item.blobLocation!=\'\' && $mdl.item.blobLocation!=null && $mdl.item.attachmentType.substring(0,5)==\'image\'" /> </div> <!-- Image --> <div class="row"> &nbsp; </div> <div class="row"> &nbsp; </div> </uib-tab> </uib-tabset> </div> </div> <div class="col-md-7 col-lg-7"> <div class="row"> <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"> <h2><b><span translate="STEP"></span> #{{$mdl.item.step+1}}</b></h2> </div> </div> <div class="row"> <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"> <label translate="STEP_DESCRIPTION"></label> <textarea class="form-control" ng-model="$mdl.item.description" /> </div> </div> <div class="row"> <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"> <label translate="ATTENTION_NOTE"></label><br /> <label> <small><i class="fa fa-info-circle"></i> <span translate="HIGHLIGHT_IMPORTANT_THING_TO_TAKE_NOTE_IN_THIS_STEP"></span>.</small> </label> <textarea class="form-control" ng-model="$mdl.item.extraDescription" /> </div> </div> </div> </div> </div> <div class="modal-footer"> <checkbox large ng-if="$mdl.mode==1" ng-model="$mdl.item.continueAdd" ng-change="change()" style="background:#fffff4"> </checkbox> <b ng-if="$mdl.mode==1"><span translate="CONTINUE_ADD_NEW_AFTER_SAVE"></span></b> <br /><br /> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButton"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/sops/sops/sopCategoryList.html','<div class="widgets recipe"><div class="row"><div class="col-md-12" ba-panel=""><p translate="LIST_OF_S.O.P_CATEGORIES"></p><div class="row"><div class="col-lg-12"><legend style="padding-bottom:5px"><div class="row"><div class="col-md-8 col-lg-8" style="padding-top:15px"><span translate="SELECT_A_CATEGORY"></span>: <b>{{vm.selectedCategory | uppercase}}</b></div><div class="col-md-1 col-lg-1"></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" placeholder="Search for Category" ng-model="vm.searchCategory" ng-hide="vm.isCategorySelected"></div></div></legend></div></div><div class="row" ng-show="vm.categoryList!=0"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-show="vm.isCategorySelected"><a href="" ng-click="vm.reselectCategory()"><div class="img go-back"></div></a></div><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-show="vm.selectedCategoryId==\'\' || vm.selectedCategoryId==cat.id" ng-repeat="cat in vm.categoryList | filter:vm.searchCategory as filteredCategory"><a href="" ui-sref="sops.sops.list({id:cat.id})"><div class="img" afkl-lazy-image="{{cat.thumbnail || cat.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4><b>{{cat.name | uppercase}}</b></h4></a></div></div><div class="row" ng-show="vm.isCategorySelected"><div class="col-lg-12"><legend style="padding-bottom:5px"><div class="row"><div class="col-md-7 col-lg-7" style="padding-top:15px"><span translate="RECIPE_LIST"></span>: <small><i class="fa fa-info-circle"></i> <em><span translate="CLICK_ON_THE_RECIPE_TO_EDIT"></span>.</em></small></div><div class="col-md-2 col-lg-2"><select name="IsApproved" class="form-control" ng-model="vm.searchRecipe.isApproved" ng-change="change()"><option value="">{{ \'SHOW_ALL\' | translate }}</option><option value="false">{{ \'SHOW_NOT_APPROVED\' | translate }}</option></select></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" placeholder="Search for Recipe" ng-model="vm.searchRecipe.$" ng-hide="!vm.isCategorySelected"></div></div></legend></div></div><div class="row" ng-show="vm.categoryList!=0"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-repeat="r in vm.recipeList | filter:vm.searchRecipe as filteredRecord"><a href="" ui-sref="sops.sops.update({id:r.id})"><div class="img" afkl-lazy-image="{{r.thumbnail || r.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4><b>{{r.name | uppercase}}</b></h4><i class="fa fa-pencil" rms-check-access="sops.sops" rms-check-access-perm-type="UPDATE"></i><h4 class="top" ng-if="!r.isApproved || !r.isPublic"><center><span ng-if="!r.isApproved"><i class="ion ion-alert-circled"></i> <span translate="NOT_APPROVED"></span></span> <span ng-if="!r.isPublic"><i class="ion ion-minus-circled"></i> <span translate="NOT_PUBLISHED"></span></span></center></h4></a></div></div><div class="row" ng-if="vm.isCategorySelected && filteredRecord.length==0"><div class="tile-container col-lg-12"><div style="background:#fafafa;height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></div></div></div><div class="row" ng-show="vm.categoryList==0"><div class="col-md-12"><p>&nbsp;</p><p>&nbsp;</p><h3 style="color:#f00"><i class="fa fa-exclamation-triangle"></i> <span translate="YOU_MUST_CREATE_AT_LEAST_ONE_(1)_CATEGORY_FIRST"></span>.</h3><h3 rms-check-access="sops.categories" rms-check-access-perm-type="CREATE"><span translate="CLICK"></span> <a href="" ui-sref="sops.categories.create"><u translate="HERE"></u></a> <span translate="TO_CREATE_A_NEW_CATEGORY"></span>.</h3><p>&nbsp;</p><p>&nbsp;</p></div></div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-if="!vm.isCategorySelected"><br>{{ \'TOTAL_RECORDS\' | translate}}: <b>{{filteredCategory.length}}</b><br>&nbsp;</div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-if="vm.isCategorySelected"><br>{{ \'TOTAL_RECORDS\' | translate}}: <b>{{filteredRecord.length}}</b><br>&nbsp;</div></div></div></div>');
$templateCache.put('app/pages/sops/sops/sopCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/sops/sops/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockUpdateButtons"><i class="ion ion-checkmark"></i> <span translate="CREATE_SOP"></span></button> <a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockUpdateButtons"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/sops/sops/sopList.html','<div class="widgets recipe"><div class="row"><div class="col-md-12" ba-panel=""><p><span translate="LIST_OF_S.O.P.S"></span> <a href="" class="btn btn-primary btn-with-icon" ui-sref="sops.sops.create" style="margin-left:20px" ng-show="vm.categoryList!=0" rms-check-access="sops.sops" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_S.O.P."></span></a> <a href="" class="btn btn-success btn-with-icon" style="float:right;margin-right:5px" ng-if="vm.isSuperAdmin || vm.canCloneRecipe" ng-click="vm.showCloneCategoryModal()" ng-disabled="vm.lockUpdateButtons"><i class="ion ion-social-buffer"></i> <span translate="CLONE_WHOLE_CATEGORY_TO_OTHER_COMPANY"></span></a></p><div class="row"><div class="col-lg-12"><legend style="padding-bottom:5px"><div class="row"><div class="col-md-8 col-lg-8" style="padding-top:15px"><span translate="SELECT_A_CATEGORY"></span>: <b>{{vm.selectedCategory | uppercase}}</b></div><div class="col-md-1 col-lg-1"></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" style="background:#fffeed" ng-model="vm.searchCategory" ng-hide="vm.isCategorySelected"></div></div></legend></div></div><div class="row"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-show="vm.isCategorySelected"><a href="" ui-sref="sops.sops.categorylist"><div class="img go-back"></div></a></div><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3"><div class="img" afkl-lazy-image="{{vm.category.thumbnail || vm.category.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4><b>{{vm.category.name | uppercase}}</b></h4></div></div><div class="row" ng-show="vm.isCategorySelected"><div class="col-lg-12"><legend style="padding-bottom:5px"><div class="row"><div class="col-md-7 col-lg-7" style="padding-top:15px"><span translate="S.O.P._LIST"></span>: <small><i class="fa fa-info-circle"></i> <em><span translate="CLICK_ON_THE_S.O.P_TO_EDIT"></span>.</em></small></div><div class="col-md-2 col-lg-2"><select name="IsApproved" class="form-control" ng-model="vm.searchSOP.isApproved" ng-change="change()"><option value="">{{ \'SHOW_ALL\' | translate }}</option><option value="false">{{ \'SHOW_NOT_APPROVED\' | translate }}</option></select></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" style="background:#fffeed" ng-model="vm.searchSOP.$" ng-hide="!vm.isCategorySelected"></div></div></legend></div></div><div class="row" ng-show="vm.categoryList!=0"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-repeat="r in vm.sopList | filter:vm.searchSOP as filteredRecord"><a href="" ui-sref="sops.sops.update({id:r.id})"><div class="img" afkl-lazy-image="{{r.thumbnail || r.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4><b>{{r.name | uppercase}}</b></h4><i class="fa fa-pencil" rms-check-access="sops.sops" rms-check-access-perm-type="UPDATE"></i><h4 class="top" ng-if="!r.isApproved || !r.isPublic"><center><span ng-if="!r.isApproved"><i class="ion ion-alert-circled"></i> <span translate="NOT_APPROVED"></span></span> <span ng-if="!r.isPublic"><i class="ion ion-minus-circled"></i> <span translate="NOT_PUBLISHED"></span></span></center></h4></a></div></div><div class="row" ng-if="vm.isCategorySelected && filteredRecord.length==0"><div class="tile-container col-lg-12"><div style="background:#fafafa;height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></div></div></div><div class="row" ng-show="vm.categoryList==0"><div class="col-md-12"><p>&nbsp;</p><p>&nbsp;</p><h3 style="color:#f00"><i class="fa fa-exclamation-triangle"></i> <span translate="YOU_MUST_CREATE_AT_LEAST_ONE_(1)_CATEGORY_FIRST"></span>.</h3><h3 rms-check-access="sops.categories" rms-check-access-perm-type="CREATE"><span translate="CLICK"></span> <a href="" ui-sref="sops.categories.create"><u translate="HERE"></u></a> <span translate="TO_CREATE_A_NEW_CATEGORY"></span>.</h3><p>&nbsp;</p><p>&nbsp;</p></div></div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-if="!vm.isCategorySelected"><br>{{ \'TOTAL_RECORDS\' | translate}}: <b>{{filteredCategory.length}}</b><br>&nbsp;</div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-if="vm.isCategorySelected"><br>{{ \'TOTAL_RECORDS\' | translate}}: <b>{{filteredRecord.length}}</b><br>&nbsp;</div></div></div></div><script type="text/ng-template" id="cloneCategoryModal.html"><form name="$mdl.cloneForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="CLONE_CATEGORY_TO_OTHER_COMPANY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.cloneForm.Company.$invalid && $mdl.cloneForm.$submitted}"> <label><b><span translate="COPY_TO_COMPANY"></span>:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="Company" ng-disabled="$mdl.isLoading" ng-options="c as (c.name | uppercase) for c in $mdl.companies track by c.id" ng-model="$mdl.selectedCompany" required> <option value="">{{ \'SELECT_A_COMPANY\' | translate }}</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.cloneForm.Company.$error.required && $mdl.cloneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.cloneForm.SopCategory.$invalid && $mdl.cloneForm.$submitted}"> <label><b><span translate="COPY_TO_CATEGORY"></span>:</b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <select class="form-control" name="SopCategory" ng-disabled="$mdl.isLoading" ng-options="r as (r.name | uppercase) for r in $mdl.selectedCompany.sopCategories track by r.id" ng-model="$mdl.selectedCategory" required> <option value="">{{ \'SELECT_A_SOP_CATEGORY\' | translate }}</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.cloneForm.SopCategory.$error.required && $mdl.cloneForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div ng-show="$mdl.isLoading"> <b style="color:#00f"><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b> </div> <div ng-show="$mdl.lockButtons"> <b style="color:#00f"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="COPYING_IN_PROGRESS"></span> ...</b> </div> </div> <p><br /></p> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/sops/sops/sopUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/sops/sops/_form.html\'"></section><div class="footer-bar"><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-default btn-with-icon" style="margin-right:20px" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.lockUpdateButtons"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="sops.sops.list" ng-disabled="vm.lockUpdateButtons"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon pull-right" confirmed-click="vm.deleteSOP()" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this S.O.P?" ng-disabled="vm.lockUpdateButtons" rms-check-access="sops.sops" rms-check-access-perm-type="DELETE"><i class="ion ion-android-delete"></i> {{ \'DELETE\' | translate }}</a> <a href="" class="btn btn-primary btn-with-icon pull-right" style="margin-right:5px" ng-if="vm.isSuperAdmin || vm.canCloneRecipe" ng-click="vm.showCloneSOPModal()" ng-disabled="vm.lockUpdateButtons"><i class="ion ion-social-buffer"></i> <span translate="CLONE_TO_OTHER_COMPANY"></span></a> <a href="" class="btn btn-primary btn-with-icon pull-right" style="margin-right:5px" confirmed-click="vm.cloneSOP()" ng-confirm-click="Confirm to clone this S.O.P.?" ng-disabled="vm.lockUpdateButtons" rms-check-access="sops.sops" rms-check-access-perm-type="CREATE"><i class="ion ion-social-buffer"></i> <span translate="CLONE_S.O.P"></span></a></div></div></div></form>');
$templateCache.put('app/pages/sops/soptypes/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SopTypeCode.$invalid && (vm.dataForm.SopTypeCode.$dirty || vm.dataForm.$submitted)}"><label for="SopTypeCode"><b translate="S.O.P_TYPE_CODE"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SopTypeCode" ng-model="vm.soptype.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SopTypeCode.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SopTypeName.$invalid && (vm.dataForm.SopTypeName.$dirty || vm.dataForm.$submitted)}"><label for="SopTypeName"><b translate="S.O.P_TYPE_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SopTypeName" ng-model="vm.soptype.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SopTypeName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'CUSTOMER_CATEGORIES\' | translate }}"><p><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_THE_ACCESSIBLE_CUSTOMER_CATEGORIES_FOR_THIS_S.O.P_TYPE"></span>.</small> <a href="" class="btn btn-primary btn-with-icon btn-xs" style="margin:5px" ng-click="vm.showAddDebtorCategoryModal()"><i class="ion-plus-round"></i><span translate="ADD_MORE"></span></a><br><br></p><div class="row"><div class="col-md-5 col-lg-5"><table class="table table-striped" style="border:1px solid #ccc"><thead><tr class="sortable"><th style="width:60px">#</th><th><b translate="CUSTOMER_CATEGORY"></b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.soptype.sopTypeDebtorCategories"><td>{{ $index+1 }}</td><td>{{ ntn.name || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeLoanStatus($index)"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr ng-if="vm.soptype.sopTypeDebtorCategories.length==0"><td colspan="3" align="center"><br><span translate="LOAN_STATUS_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="CustomerCategoryModal.html"><form name="$mdl.categoryForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="ADD_CUSTOMER_CATEGORY"></span></h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b translate="SELECT_A_CUSTOMER_CATEGORY"></b> <i class="fa fa-asterisk req" style="color:#f00"></i></label> <ui-select class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedCategory" on-select="$mdl.selectedCategoryChanged()"> <ui-select-match placeholder="{{ \'ENTER_KEYWORD_TO_SEARCH\' | translate }}"> <span>{{ $select.selected.name }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.debtorCategories | filter: $select.search" minimum-input-length="2"> <span ng-bind-html="i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.selectedCategory==null && $mdl.categoryForm.$submitted">* {{ \'REQUIRED\' | translate }}</p> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <div style="float:left" ng-if="$mdl.lockButton" style="color:#00f"> <i class="fa fa-spinner fa-spin fa-fw"></i> <b translate="PROCESSING"> ...</b> </div> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButton"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.lockButton" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/sops/soptypes/soptypeCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/sops/soptypes/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_S.O.P_TYPE"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="sops.soptypes.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/sops/soptypes/soptypeList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.docTypeData" refresh-table=""><thead><tr><th colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" class="input form-control" style="background-color:#fffeed"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="sops.soptypes.create" rms-check-access="sops.soptypes" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_S.O.P_TYPE"></span></a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:150px" st-sort="name"><span translate="TYPE_CODE"></span></th><th st-sort="name"><span translate="TYPE_NAME"></span></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-show="vm.docTypeData.length<=0 && !vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-show="vm.isLoading"><td colspan="5" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.docTypeData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td>{{item.name}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="sops.soptypes.update({id:item.id})" rms-check-access="sops.soptypes" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Brand" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteType(item.id, item.name)" ng-confirm-click="Confirm delete this S.O.P Type?" rms-check-access="sops.soptypes" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="5" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/sops/soptypes/soptypeUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/sops/soptypes/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="sops.soptypes.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="sops.soptypes.list"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a></div></form>');
$templateCache.put('app/pages/wcsimulator/simulations/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p>Please fill in the Simulation configuration.</p><div class="row">&nbsp;</div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Simulation Ref No.</b></label> <span class="form-control" style="color:#00f">{{vm.sim.simulationNo || \'AUTONUMBER\' }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Simulation Status</b></label> <span class="form-control" style="color:#00f">{{vm.sim.status }}</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b>Description</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-disabled="vm.sim.status!=\'NEW\'" ng-model="vm.sim.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* Required</span></div></div></div><hr><div class="row"><div class="col-md-2 col-lg-2"><legend style="height:32.4px;line-height:32.4px">Cycle Settings</legend><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumOfChecker.$invalid && (vm.dataForm.NumOfChecker.$dirty || vm.dataForm.$submitted)}"><label><b>No. of Checker (Unit)</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="NumOfChecker" ng-disabled="vm.sim.status!=\'NEW\'" ng-model="vm.sim.checkerCount" min="1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfChecker.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfChecker.$error.number">* Key in numbers only</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfChecker.$error.min">* Minimum value is 1</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumOfSorter.$invalid && (vm.dataForm.NumOfSorter.$dirty || vm.dataForm.$submitted)}"><label><b>No. of Sorter (Unit)</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="NumOfSorter" ng-disabled="vm.sim.status!=\'NEW\'" ng-model="vm.sim.sorterCount" min="1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSorter.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSorter.$error.number">* Key in numbers only</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfSorter.$error.min">* Minimum value is 1</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NumOfRunCycle.$invalid && (vm.dataForm.NumOfRunCycle.$dirty || vm.dataForm.$submitted)}"><label><b>No. of Run Cycle</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="NumOfRunCycle" ng-disabled="vm.sim.status!=\'NEW\'" ng-model="vm.sim.targetRunCount" min="1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfRunCycle.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfRunCycle.$error.number">* Key in numbers only</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NumOfRunCycle.$error.min">* Minimum value is 1</span></div></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-3 col-lg-3"><legend style="height:32.4px;line-height:32.4px">Product Settings</legend><div class="row"><div class="col-md-7 col-lg-7"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MinProductWeight.$invalid && (vm.dataForm.MinProductWeight.$dirty || vm.dataForm.$submitted)}"><label><b>Minimum Product Weight</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="MinProductWeight" ng-disabled="vm.sim.status!=\'NEW\'" ng-model="vm.sim.productWeightMin" min="0.1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MinProductWeight.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MinProductWeight.$error.number">* Key in numbers only</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MinProductWeight.$error.min">* Minimum value is 0.1</span></div></div><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UOM.$invalid && (vm.dataForm.UOM.$dirty || vm.dataForm.$submitted)}"><label><b>UOM</b> <i class="fa fa-asterisk req"></i></label><select name="UOM" class="form-control" ng-disabled="vm.sim.status!=\'NEW\'" ng-options="i as (i.name | uppercase) for i in vm.uomList" ng-model="vm.selectedUom" ng-change="vm.selectedUomChanged()" required=""><option value="">Select an UOM</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UOM.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-7 col-lg-7"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MaxProductWeight.$invalid && (vm.dataForm.MaxProductWeight.$dirty || vm.dataForm.$submitted)}"><label><b>Maximum Product Weight</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="MaxProductWeight" ng-disabled="vm.sim.status!=\'NEW\'" ng-model="vm.sim.productWeightMax" min="0.1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MaxProductWeight.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MaxProductWeight.$error.number">* Key in numbers only</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MaxProductWeight.$error.min">* Minimum value is 0.1</span></div></div><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UOM.$invalid && (vm.dataForm.UOM.$dirty || vm.dataForm.$submitted)}"><label><b>UOM</b> <i class="fa fa-asterisk req"></i></label><select name="UOM" class="form-control" ng-disabled="vm.sim.status!=\'NEW\'" ng-options="i as (i.name | uppercase) for i in vm.uomList" ng-model="vm.selectedUom" ng-change="vm.selectedUomChanged()" required=""><option value="">Select an UOM</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UOM.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-7 col-lg-7"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ProductSampleCount.$invalid && (vm.dataForm.ProductSampleCount.$dirty || vm.dataForm.$submitted)}"><label><b>Product Sample Count</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="ProductSampleCount" ng-disabled="vm.sim.status!=\'NEW\'" ng-model="vm.sim.productQuantity" min="0.1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ProductSampleCount.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ProductSampleCount.$error.number">* Key in numbers only</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ProductSampleCount.$error.min">* Minimum value is 0.1</span></div></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-3 col-lg-3"><legend style="height:32.4px;line-height:32.4px">Package Settings</legend><div class="row"><div class="col-md-7 col-lg-7"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TargetPackageWeight.$invalid && (vm.dataForm.TargetPackageWeight.$dirty || vm.dataForm.$submitted)}"><label><b>Target Package Weight</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="TargetPackageWeight" ng-disabled="vm.sim.status!=\'NEW\'" ng-model="vm.sim.targetPackageWeight" min="0.1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TargetPackageWeight.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TargetPackageWeight.$error.number">* Key in numbers only</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TargetPackageWeight.$error.min">* Minimum value is 1</span></div></div><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UOM.$invalid && (vm.dataForm.UOM.$dirty || vm.dataForm.$submitted)}"><label><b>UOM</b> <i class="fa fa-asterisk req"></i></label><select name="UOM" class="form-control" ng-disabled="vm.sim.status!=\'NEW\'" ng-options="i as (i.name | uppercase) for i in vm.uomList" ng-model="vm.selectedUom" ng-change="vm.selectedUomChanged()" required=""><option value="">Select an UOM</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UOM.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-7 col-lg-7"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TargetPackageCount.$invalid && (vm.dataForm.TargetPackageCount.$dirty || vm.dataForm.$submitted)}"><label><b>Target Package Count (Unit)</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="TargetPackageCount" ng-disabled="vm.sim.status!=\'NEW\'" ng-model="vm.sim.targetPackageCount" min="0.1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TargetPackageCount.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TargetPackageCount.$error.number">* Key in numbers only</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TargetPackageCount.$error.min">* Minimum value is 1</span></div></div></div></div></div><div class="col-md-12 col-lg-12"><div><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="Simulation Runs" ng-if="vm.sim.status==\'CONFIRMED\'"></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/wcsimulator/simulations/simulationCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/wcsimulator/simulations/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create Simulation</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="wcsimulator.simulations.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/wcsimulator/simulations/simulationList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.simData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Simulation" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="wcsimulator.simulations.create" rms-check-access="wcsimulator.simulations" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i> New Simulation</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th rowspan="2" style="width:60px">#</th><th rowspan="2" style="width:200px" st-sort="simulationNo">Simulation Ref No.</th><th rowspan="2">Description</th><th colspan="2" style="text-align:center" class="hide-after">Product Weight</th><th rowspan="2" style="width:150px;text-align:center" class="hide-after">Product<br>Count</th><th rowspan="2" style="width:150px;text-align:center" class="hide-after">Target<br>Package<br>Weight</th><th rowspan="2" style="width:150px;text-align:center" class="hide-after">Target<br>Package<br>Count</th><th rowspan="2" style="width:150px;text-align:center" class="hide-after">Target<br>Run<br>Count</th><th rowspan="2" class="hide-after">Status</th><th rowspan="2" style="width:40px"></th></tr><tr class="sortable"><th style="width:100px;text-align:center" class="hide-after">Min.</th><th style="width:100px;text-align:center" class="hide-after">Max.</th></tr><tr class="sortable"><th colspan="9"></th><th class="form-inline"><select st-search="status"><option value="">ALL</option><option ng-repeat="sim in vm.simDataFull | unique:\'status\' | orderBy:\'status\'" value="{{po.status}}">{{ sim.status | uppercase }}</option></select></th><th></th></tr></thead><tbody><tr ng-if="vm.simData.length==0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-repeat="item in vm.simData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.simulationNo}}</td><td>{{item.description}}</td><td style="text-align:center">{{item.productWeightMin}} {{item.uomName}}</td><td style="text-align:center">{{item.productWeightMax}} {{item.uomName}}</td><td style="text-align:center">{{item.productQuantity}}</td><td style="text-align:center">{{item.targetPackageWeight}} {{item.uomName}}</td><td style="text-align:center">{{item.targetPackageCount}}</td><td style="text-align:center">{{item.targetRunCount}}</td><td>{{item.status}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="wcsimulator.simulations.update({id:item.id})" rms-check-access="wcsimulator.simulations" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/wcsimulator/simulations/simulationUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/wcsimulator/simulations/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="wcsimulator.simulations.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon" ng-if="vm.sim.status==\'NEW\'" ng-disabled="vm.lockButtons"><i class="fa fa-floppy-o"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="wcsimulator.simulations.list" style="margin-right:30px" ng-if="vm.sim.status==\'NEW\'" ng-disabled="vm.lockButtons"><i class="ion ion-close"></i> Discard Changes</a> <a href="" class="btn btn-success btn-with-icon" confirmed-click="vm.confirmSimulation()" ng-confirm-click="Are you sure to confirm the status?" ng-if="vm.sim.status==\'NEW\'" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> Confirm Simulation</a></div></form>');
$templateCache.put('app/pages/superadmin/affiliates_newcustomer/affCustomerList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.affiliateData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Customer" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="affiliateCompanyName">Dealer / Agency Name</th><th st-sort="resellerName">Reseller Name</th><th>New Customer Name</th><th>Software Package</th><th>Package Fee</th><th>Billing Option</th><th>Proforma Invoice#</th><th style="width:20px"></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.affiliateData.length<=0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.affiliateData | orderBy: \'company\'"><td>{{vm.startIndex+1+$index}})</td><td>{{item.dealerName}}</td><td>{{item.resellerName}}</td><td>{{item.name}}</td><td>{{item.packageMode}}</td><td>{{item.billingIntervalType | uppercase}}</td><td>{{item.proformaInvoiceNo}}</td><td>{{item.packageFee || \'-\' | number:2}}</td><td>&nbsp;</td><td align="center"><a href="" title="Approve" class="btn btn-success btn-with-icon btn-xs" style="width:80px" ng-click="vm.showApproval(item)" rms-check-access="superadmin.affiliates_newcustomer" rms-check-access-perm-type="APPROVE"><i class="fa fa-check"></i>Approve</a></td><td align="center"><a href="" title="Reject" class="btn btn-danger btn-with-icon btn-xs" style="width:80px" confirmed-click="vm.rejectCustomer(item.id)" ng-confirm-click="Confirm reject this Customer?" rms-check-access="superadmin.affiliates_newcustomer" rms-check-access-perm-type="APPROVE"><i class="fa fa-trash"></i>Reject</a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div><script type="text/ng-template" id="approvalModal.html"><form name="$mdl.approvalForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> New Customer Approval </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <label><b>Dealer / Agency Name:</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.dealerName}} </span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <label><b>Reseller Name:</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.resellerName}} </span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <label><b>Customer Name:</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.name}} </span> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b>Software Package:</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.packageMode}} </span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b>Package Fee (RM):</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.packageFee}} </span> </div> </div> </div> <div class="row"> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b>Billing Option:</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.billingIntervalType | uppercase}} </span> </div> </div> <div class="col-md-6 col-lg-6"> <div class="form-group"> <label><b>Proforma Invoice #:</b></label> <span class="form-control" ng-disabled="true" style="color:#000"> {{$mdl.aff.proformaInvoiceNo}} </span> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.approvalForm.PaymentRemarks.$invalid && ($mdl.approvalForm.PaymentRemarks.$dirty || $mdl.approvalForm.$submitted)}"> <label><b>Payment Remarks (Cheque No. / Transaction No.):</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="PaymentRemarks" class="form-control" style="background:#fffeed;color:#000" ng-model="$mdl.aff.paymentRemarks" required /> <span class="help-block" style="color:#f00" ng-if="$mdl.approvalForm.$submitted && $mdl.approvalForm.PaymentRemarks.$error.required"> * {{ "REQUIRED" | translate }} </span> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="mdl.lockButtons" ng-click="$mdl.confirmModal()" > <i class="ion ion-checkmark"></i> <span translate="APPROVE"></span> </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/sops/categories/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><span translate="PLEASE_FILL_IN_THE_CATEGORY_INFORMATION"></span>.</p><div class="row">&nbsp;</div><div class="row"><div class="col-md-4 col-lg-4"><div class="row"><img ngf-src="picFile || vm.cate.imageLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div><div class="row"><div class="col-md-12 col-lg-12"><p><small><i class="fa fa-info-circle"></i> <em><span translate="RECOMMENDED_TO_UPLOAD_A_LANDSCAPE_IMAGE"></span>.</em></small></p>&nbsp;</div></div><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-disabled="vm.lockUploadButton" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> {{ \'UPLOAD_PICTURE\' | translate }}</div><a href="" ng-click="picFile=null;vm.setUploadImage(picFile)" ng-show="picFile" class="btn btn-default btn-with-icon" ng-disabled="vm.lockUploadButton"><i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }}</a></div><div class="row" ng-show="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div><div class="col-md-4 col-lg-4"><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-class="{\'has-error\': vm.dataForm.CateName.$invalid && (vm.dataForm.CateName.$dirty || vm.dataForm.$submitted)}"><label for="CateName"><b translate="CATEGORY_NAME"></b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CateName" ng-model="vm.cate.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CateName.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="row"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label for="CateDescription"><b translate="CATEGORY_DESCRIPTION"></b></label> <textarea class="form-control" name="CateDescription" ng-model="vm.cate.description">\n\t\t\t\t\t\t\t\t</textarea></div></div><div class="row" ng-if="vm.hasFranchiseAccess"><div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"><label><b translate="VISIBLE_FOR_FRANCHISE_/_OUTLET"></b></label><div><toggle ng-model="vm.cate.isFranchise" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div><div class="col-md-12 col-lg-12"><div><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="{{ \'BRANCH_ACCESS\' | translate }}"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p><span translate="SELECT_AT_LEAST_ONE_(1)_BRANCH_WHICH_CAN_ACCESS_THIS_RECIPE_CATEGORY:"></span> <i class="fa fa-asterisk req"></i></p></div></div><div class="row" ng-repeat="b in vm.branches" style="margin-bottom:5px"><div class="col-md-12"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" name="branch" checklist-model="vm.selectedBranches" checklist-value="b" checklist-change="vm.dataForm.branch.$setValidity(\'required\', vm.selectedBranches.length > 0)" ng-required="!vm.selectedBranches.length"> <label><span><b>{{ b.name }}</b></span></label></div></div></div><div class="row"><div class="col-md-12"><p><div class="col-md-12" ng-class="{ \'has-error\': vm.dataForm.$submitted && vm.dataForm.branch.$invalid }"><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.branch.$invalid">* <span translate="REQUIRED_AT_LEAST_ONE_(1)_BRANCH"></span></span></div></p></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/sops/categories/categoryCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/sops/categories/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_CATEGORY"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="sops.categories.list"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/sops/categories/categoryList.html','<div class="widgets recipe"><div class="row"><div class="col-md-12" ba-panel=""><div class="row"><div class="col-md-8 col-lg-8"><p><span translate="LIST_OF_S.O.P_CATEGORIES"></span>. <a href="" class="btn btn-primary btn-with-icon" ui-sref="sops.categories.create" style="margin-left:20px" rms-check-access="sops.categories" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_CATEGORY"></span></a></p></div><div class="col-md-1 col-lg-1"></div><div class="col-md-3 col-lg-3"><input type="text" class="form-control searchbox" name="Search" ng-model="searchText" style="background:#fffeed"></div></div><p><small><i class="fa fa-info-circle"></i> <em><span translate="CLICK_ON_ONE_OF_THE_TILES_TO_EDIT"></span>.</em></small><br>&nbsp;</p><div class="row"><div class="tile-container col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-repeat="cat in vm.cateDataFull | filter:searchText as filteredRecord"><a href="" ui-sref="sops.categories.update({id:cat.id})"><div class="img" afkl-lazy-image="{{cat.thumbnail || cat.imageLocation}}" afkl-lazy-image-options="{\'background\': true}"></div><h4><b>{{cat.name | uppercase}}</b></h4><i class="fa fa-pencil" rms-check-access="sops.categories" rms-check-access-perm-type="UPDATE"></i></a></div></div><div class="row" ng-if="filteredRecord.length==0"><div class="tile-container col-lg-12"><div style="background:#fafafa;height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></div></div></div><div class="row col-xs-12 col-sm-6 col-md-4 col-lg-3"><br>{{ \'TOTAL_RECORDS\' | translate}}: <b>{{filteredRecord.length}}</b><br>&nbsp;</div></div></div></div>');
$templateCache.put('app/pages/sops/categories/categoryUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/sops/categories/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="sops.categories.list" style="margin-right:20px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="vm.dataForm.$valid && vm.dataForm.$submitted"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="sops.categories.list" ng-disabled="vm.dataForm.$valid && vm.dataForm.$submitted"><i class="ion ion-close"></i> <span translate="DISCARD_CHANGES"></span></a> <a href="" class="btn btn-warning btn-with-icon" style="float:right" ng-disabled="vm.dataForm.$valid && vm.dataForm.$submitted" confirmed-click="vm.deleteCategory()" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Category?" rms-check-access="sops.categories" rms-check-access-perm-type="DELETE"><i class="ion ion-android-delete"></i> <span translate="DELETE_CATEGORY"></span></a></div></form>');
$templateCache.put('app/pages/superadmin/affiliates/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Affiliate Company</b></label> <a href="" ng-click="vm.clearAffiliateCompany()" class="btn btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="vm.selectedAffiliateCompany!=null"><i class="fa fa-trash"></i> Clear</a><select class="form-control" name="AffiliateCompany" ng-model="vm.selectedAffiliateCompany" ng-change="vm.selectedAffiliateCompanyChanged()" ng-options="c as (c.name | uppercase) for c in vm.companies" required=""><option></option></select></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Client Company</b></label> <a href="" ng-click="vm.clearClientCompany()" class="btn btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="vm.selectedClientCompany!=null"><i class="fa fa-trash"></i> Clear</a><select class="form-control" name="AffiliateCompany" ng-model="vm.selectedClientCompany" ng-change="vm.selectedClientCompanyChanged()" ng-options="c as (c.name | uppercase) for c in vm.companies" required=""><option></option></select></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StartDate.$invalid && (vm.dataForm.StartDate.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'START_DATE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.aff.startDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" name="StartDate" placeholder="YYYY-MM-DD" ng-model="vm.aff.startDate" ng-readonly="true" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StartDate.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.EndDate.$invalid && (vm.dataForm.EndDate.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'END_DATE\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.aff.endDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" name="EndDate" placeholder="YYYY-MM-DD" ng-model="vm.aff.endDate" ng-readonly="true" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.EndDate.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UnitEarningValue.$invalid && (vm.dataForm.UnitEarningValue.$dirty || vm.dataForm.$submitted)}"><label><b>Commission Rate (%)</b></label><div class="input-group"><input type="number" class="form-control" name="UnitEarningValue" ng-model="vm.aff.commissionRate" min="1" step="1" required=""> <span class="input-group-addon">%</span></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UnitEarningValue.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UnitEarningValue.$error.min">* Minimum is 1.00</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UnitEarningValue.$error.number">* Key in numbers only</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Remarks</b></label> <input type="text" class="form-control" name="Remarks" placeholder="Any special remarks" ng-model="vm.aff.remarks"></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/affiliates/affiliateCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/affiliates/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Create Affiliate</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.affiliates.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/superadmin/affiliates/affiliateList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.affiliateData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Affiliate" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.affiliates.create" rms-check-access="superadmin.affiliates" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Affiliate</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="affiliateCompanyName">Affiliate Company</th><th st-sort="clientCompanyName">Client Company</th><th>Commission Rate (%)</th><th st-sort="startDate">{{ \'START_DATE\' | translate }}</th><th st-sort="endDate">{{ \'END_DATE\' | translate }}</th><th st-sort="billingIntervalType">Billing Interval</th><th>Commissions</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-if="vm.affiliateData.length<=0 && !vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.affiliateData | orderBy: \'company\'"><td>{{vm.startIndex+1+$index}})</td><td>{{item.affiliateCompanyName}}</td><td>{{item.clientCompanyName}}</td><td>{{item.commissionRate | number:0 }} %</td><td>{{item.startDate | date: "dd-MMM-yyyy" }}</td><td>{{item.endDate | date: "dd-MMM-yyyy" }}</td><td>{{item.billingIntervalType}}</td><td><table class="table table-striped table-bordered" style="margin-top:4px;margin-bottom:4px"><tr ng-repeat="c in item.commission"><td style="width:60px;padding:4px;line-height:15px"><b>{{c.moduleType}}</b></td><td style="width:70px;padding:4px;line-height:15px"><span ng-if="item.billingIntervalType==\'MONTHLY\'">RM {{c.monthlyFeeCommission | currency:""}}</span> <span ng-if="item.billingIntervalType==\'QUARTERLY\'">RM {{c.quarterlyFeeCommission | currency:""}}</span> <span ng-if="item.billingIntervalType==\'ANNUAL\'">RM {{c.annualFeeCommission | currency:""}}</span></td><td style="width:100px;padding:4px;line-height:15px"><span ng-if="item.billingIntervalType==\'MONTHLY\'">(Fees: RM {{c.monthlyFee | currency:""}})</span> <span ng-if="item.billingIntervalType==\'QUARTERLY\'">(Fees: RM {{c.quarterlyFee | currency:""}})</span> <span ng-if="item.billingIntervalType==\'ANNUAL\'">(Fees: RM {{c.annualFee | currency:""}})</span></td></tr></table></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.affiliates.update({id:item.id})" rms-check-access="superadmin.affiliates" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Affiliate" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteAffiliation(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Affiliation?" rms-check-access="superadmin.affiliates" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/affiliates/affiliateUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/affiliates/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.affiliates.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/superadmin/announcements/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.moduleName.$invalid && (vm.dataForm.moduleName.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'MODULE\' | translate}}</b>&nbsp; <i class="fa fa-asterisk req"></i></label><select class="form-control" name="moduleName" ng-options="m as m.name for m in vm.modules track by m.name" ng-model="vm.modules.selected" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.startDate.$invalid && (vm.dataForm.startDate.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'START_DATE\' | translate}}</b>&nbsp; <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.announcement.effectiveStartDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" name="startDate" placeholder="YYYY-MM-DD" ng-model="vm.announcement.effectiveStartDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.startDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.endDate.$invalid && (vm.dataForm.endDate.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'END_DATE\' | translate}}</b>&nbsp; <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.announcement.effectiveEndDate" format="YYYY-MM-DD hh:mmA" max-view="hour" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" name="endDate" placeholder="YYYY-MM-DD" ng-model="vm.announcement.effectiveEndDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.endDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.importanceLevel.$invalid && (vm.dataForm.importanceLevel.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'IMPORTANCE_LEVEL\' | translate}}</b>&nbsp; <i class="fa fa-asterisk req"></i></label><select class="form-control" name="importanceLevel" ng-options="i as i.name for i in vm.importanceLevels track by i.id" ng-model="vm.importanceLevels.selected" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.importanceLevel.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-5 col-lg-5" ng-if="vm.announcement.createdBy"><div class="form-group"><label><b translate="CREATED_BY">:</b></label><br><span>{{vm.announcement.createdBy | uppercase}}<br>{{ vm.announcement.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</span></div></div><div class="col-md-5 col-lg-5" ng-if="vm.announcement.modifiedBy"><div class="form-group"><label><b translate="MODIFIED_BY">:</b></label><br><span>{{vm.announcement.modifiedBy | uppercase}}<br>{{ vm.announcement.modifiedDate | date:\'dd/MM/yyyy hh:mma\' }}</span></div></div></div></div><div class="col-md-1 col-lg-1"></div><div class="col-md-5 col-lg-5"><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.title.$invalid && (vm.dataForm.title.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'TITLE\' | translate}}</b>&nbsp; <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="title" ng-model="vm.announcement.announcementTitle" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.title.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.description.$invalid && (vm.dataForm.description.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'DESCRIPTION\' | translate}}</b>&nbsp; <i class="fa fa-asterisk req"></i></label> <textarea type="text" class="form-control" placeholder="Description" ng-model="vm.announcement.announcementContent">\n                                        </textarea> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.description.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label><b>{{ \'IS_ACTIVE\' | translate }}</b></label><div><toggle ng-model="vm.announcement.isActive" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/announcements/announcementCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/announcements/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Create Announcement</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.announcements.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/superadmin/announcements/announcementList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.announcementData" st-safe-src="vm.announcementDataFull" refresh-table=""><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Announcement" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.announcements.create" rms-check-access="superadmin.announcements" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Announcement</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="module">{{ "MODULE" | translate }}</th><th st-sort="title">{{ "TITLE" | translate }}</th><th st-sort="startDate">{{ "START_DATE" | translate }}</th><th st-sort="endDate">{{ "END_DATE" | translate }}</th><th st-sort="importanceLevel">{{ "IMPORTANCE_LEVEL" | translate }}</th><th st-sort="active">{{ "ACTIVE" | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="item in vm.announcementData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.moduleName}}</td><td>{{item.announcementTitle}}</td><td>{{vm.formatDate(item.effectiveStartDate)}}</td><td>{{vm.formatDate(item.effectiveEndDate)}}</td><td>{{item.importanceLevel}}</td><td><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.announcements.update({id:item.id})" rms-check-access="superadmin.announcements" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Announcement" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteAnnouncement(item.id, item.announcementTitle)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this announcement?" rms-check-access="superadmin.announcements" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.announcementData.length }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/announcements/announcementUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/announcements/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.announcements.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/superadmin/branches/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Company.$invalid && (vm.dataForm.Company.$dirty || vm.dataForm.$submitted)}"><label for="Company">Company <i class="fa fa-asterisk req"></i></label><ui-select ng-model="vm.selectedCompany" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" ng-change="vm.selectCompany()"><ui-select-match placeholder="-- Select a Company --"><span>{{ $select.selected.name }}</span></ui-select-match><ui-select-choices repeat="t in vm.companies | orderBy:\'name\' | filter: $select.search"><span ng-bind-html="t.name | uppercase | highlight: $select.search"></span></ui-select-choices></ui-select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Company.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BranchCode.$invalid && (vm.dataForm.BranchCode.$dirty || vm.dataForm.$submitted)}"><label for="BranchCode">Branch Code <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BranchCode" placeholder="Branch Code" ng-model="vm.branch.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BranchCode.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BranchName.$invalid && (vm.dataForm.BranchName.$dirty || vm.dataForm.$submitted)}"><label for="BranchName">Branch Name <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BranchName" placeholder="Branch Name" ng-model="vm.branch.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BranchName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.TimeZone.$invalid && (vm.dataForm.TimeZone.$dirty || vm.dataForm.$submitted)}"><label><b>Time Zone</b> <i class="fa fa-asterisk req"></i></label><select name="TimeZone" class="form-control" ng-change="vm.selectedTimeZoneChanged()" ng-model="vm.selectedTimeZone" ng-options="i as i.name for i in vm.timezones" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.TimeZone.$error.required">* Required</span></div></div></div><div class="row"><input type="hidden" name="companyId" ng-model="vm.branch.companyId"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/branches/branchCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/branches/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Create Branch</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.branches.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/superadmin/branches/branchList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.branchData" refresh-table=""><thead><tr><th colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Branch" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.branches.create" rms-check-access="superadmin.branches" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Branch</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th style="width:350px" st-sort="company">Company</th><th st-sort="name">Branch Code</th><th st-sort="name">Branch Name</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="item in vm.branchData | orderBy: \'company\'"><td>{{vm.startIndex+1+$index}})</td><td>{{item.company}}</td><td>{{item.code}}</td><td>{{item.name}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.branches.update({id:item.id})" rms-check-access="superadmin.branches" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Branch" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteBranch(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this branch?" rms-check-access="superadmin.branches" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="6" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/branches/branchUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/branches/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.branches.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/superadmin/commissions/commissionCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Commission Details" select="vm.selectedTab=0"><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Company.$invalid && (vm.dataForm.Company.$dirty || vm.dataForm.$submitted)}"><label><b>Select a Dealer</b> <i class="fa fa-asterisk req"></i></label><select name="Company" class="form-control" ng-options="i as (i.name | uppercase) for i in vm.companyList" ng-model="vm.selectedCompany" ng-change="vm.selectedCompanyChanged()" ng-required="$tabSetStatus.activeTab==0"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Company.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Statement.$invalid && (vm.dataForm.Statement.$dirty || vm.dataForm.$submitted)}"><label><b>Select a Statement</b> <i class="fa fa-asterisk req"></i></label><select name="Statement" class="form-control" ng-disabled="vm.payment.companyId==\'\'" ng-options="i as (i.statementNo + \' [RM\' + i.totalCommission + \']\' | uppercase) for i in vm.statementList" ng-model="vm.selectedStatement" ng-change="vm.selectedStatementChanged()" ng-required="$tabSetStatus.activeTab==0"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Statement.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.paymentRefNo.$invalid && (vm.dataForm.paymentRefNo.$dirty || vm.dataForm.$submitted)}"><label><b>Enter Cheque No. / Payment Details</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="paymentRefNo" class="form-control" ng-required="$tabSetStatus.activeTab==0" ng-disabled="vm.payment.statementId==\'\'" ng-model="vm.payment.paymentRefNo"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.paymentRefNo.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Amount.$invalid && (vm.dataForm.Amount.$dirty || vm.dataForm.$submitted)}"><label><b>Enter the Payment Amount (RM)</b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="Amount" class="form-control" min="1" step="1" ng-required="$tabSetStatus.activeTab==0" ng-disabled="vm.payment.statementId==\'\'" ng-model="vm.payment.amount"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Amount.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Amount.$error.min">* Must be greater than ZERO</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-md-6"><a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard"><i class="ion ion-chevron-left"></i> Back</a> <button type="submit" class="btn btn-success btn-with-icon"><i class="fa fa-check"></i> Confirm Payment</button></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Generate Statement" select="vm.selectedTab=1"><p>Generate statement for all active Dealers.<br>&nbsp;</p><div class="row"><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InvoiceYear.$invalid && (vm.dataForm.InvoiceYear.$dirty || vm.dataForm.$submitted)}"><label><b>Select Year</b> <i class="fa fa-asterisk req"></i></label><select name="InvoiceYear" class="form-control" ng-model="vm.statement.year" ng-required="$tabSetStatus.activeTab==1"><option></option><option value="2018">2018</option><option value="2019">2019</option><option value="2020">2020</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InvoiceYear.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InvoiceMonth.$invalid && (vm.dataForm.InvoiceMonth.$dirty || vm.dataForm.$submitted)}"><label><b>Select Month</b> <i class="fa fa-asterisk req"></i></label><select name="InvoiceMonth" class="form-control" ng-model="vm.statement.month" ng-required="$tabSetStatus.activeTab==1"><option></option><option value="1">January</option><option value="2">February</option><option value="3">March</option><option value="4">April</option><option value="5">May</option><option value="6">June</option><option value="7">July</option><option value="8">August</option><option value="9">September</option><option value="10">October</option><option value="11">November</option><option value="12">December</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InvoiceMonth.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-md-6"><a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard"><i class="ion ion-chevron-left"></i> Back</a> <button type="submit" class="btn btn-success btn-with-icon"><i class="fa fa-check"></i> Generate Statements</button></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-lg-12"><table class="table table-hover table-bordered table-striped"><tr><td style="width:40px"><b>#</b></td><td style="width:80px;text-align:center" class="hide-after"><b>Status</b></td><td><b>Dealer Name</b></td><td><b>Message</b></td></tr><tr ng-repeat="ntn in vm.statementGenerationResult"><td>{{$index+1}}</td><td style="text-align:center"><i class="fa fa-check" ng-if="ntn.status==1" style="color:#0f0"></i> <i class="fa fa-warning" ng-if="ntn.status==0" style="color:#ffae00"></i> <i class="fa fa-times" ng-if="ntn.status==-1" style="color:#f00"></i></td><td>{{ntn.companyName}}</td><td>{{ntn.message}}</td></tr></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="All Statements" select="vm.selectedTab=2"><p><i class="fa fa-info-circle"></i> Full list of dealer statements.<br><br></p><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.stmtData" refresh-table="" style="font-family:courier;font-weight:bold;font-size:120%"><thead><tr><th colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Statement" class="input form-control"></div></div><div class="col-lg-2" style="height:35px;line-height:35px"></div><div class="col-lg-3" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th>Statement No.</th><th>Statement Date</th><th st-sort="dealerCompanyName">Dealer Name</th><th class="hide-after" style="text-align:right">Commission Amount (RM)</th><th class="hide-after" style="text-align:center">Paid?</th><th>Paid On</th><th style="width:40px"></th></tr><tr class="sortable"><th></th><th></th><th></th><th class="form-inline"><select st-search="dealerCompanyName"><option value="">ALL</option><option ng-repeat="c in vm.stmtDataFull | unique:\'dealerCompanyName\'" value="{{c.dealerCompanyName | uppercase}}">{{c.dealerCompanyName}}</option></select></th><th></th><th class="form-inline hide-after" style="text-align:center"><select st-search="isPaid"><option value="">ALL</option><option ng-repeat="c in vm.stmtDataFull | unique:\'isPaid\'" value="{{c.isPaid}}">{{(c.isPaid?\'Yes\':\'No\')}}</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in vm.stmtData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.statementNo}}</td><td>{{item.statementDate | date:\'dd/MM/yyyy\'}}</td><td>{{item.dealerCompanyName}}</td><td style="text-align:right">{{item.totalCommission | currency:\'\'}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.isPaid" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isPaid" style="color:#f00"></i></td><td>{{item.paidOn || \'-\' | date:\'dd/MM/yyyy\'}}</td><td style="text-align:center"><a href="" title="Print" class="btn btn-primary btn-xs" ng-click="vm.printStatement(item.id, item.statementNo)"><i class="fa fa-print"></i> Print</a></td></tr><tr ng-if="vm.stmtData.length==0"><td colspan="8">No record found.</td></tr></tbody><tfoot><tr><td colspan="8" style="padding-left:0px;padding-right:0px"><div class="col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></uib-tab></uib-tabset></div></div></div></form>');
$templateCache.put('app/pages/superadmin/companies/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p>Please fill in the relevant company information.</p><p><small><i class="fa fa-info-circle"></i> <em>Recommended to upload a landscape image.</em></small></p><p><br></p><div class="row"><div class="col-md-4 col-lg-4"><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label>Company Logo</label> <img src="assets/img/company_logo_placeholder.png" alt="" style="width:100%" ng-if="picFile==null && vm.company.logoFile==\'\'"> <img ngf-src="picFile || vm.company.logoFile" alt="" style="width:100%;border: 1px solid #ccc" ng-if="picFile || vm.company.logoFile"></div></div></div><div class="row">&nbsp;</div><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile"><i class="ion ion-android-upload"></i> Upload Logo</div><a href="" ng-click="vm.resetLogo()" ng-show="picFile || vm.company.logoFile" class="btn btn-default btn-with-icon"><i class="ion ion-android-remove-circle"></i> Reset Logo</a></div><div class="row" style="text-align:center"><br><small><em>* Recommend dimension 1378px X 160px</em></small></div><div class="row">&nbsp;</div></div><div class="col-md-8 col-lg-8"><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CompanyCode.$invalid && (vm.dataForm.CompanyCode.$dirty || vm.dataForm.$submitted)}"><label>Company Code <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CompanyCode" placeholder="Company Code" ng-model="vm.company.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CompanyCode.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Status</b></label><div><toggle ng-model="vm.company.isActive" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Is Billable?</b></label><div><toggle ng-model="vm.company.isBillable" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Is Taxable?</b></label><div><toggle ng-model="vm.compSetting.isTaxable" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CompanyName.$invalid && (vm.dataForm.CompanyName.$dirty || vm.dataForm.$submitted)}"><label>Company Name <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CompanyName" placeholder="Company Name" ng-model="vm.company.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CompanyName.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Is Dealer / Agency?</b></label><div><toggle ng-model="vm.company.isAffiliate" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Is Email Agent Exclusive?</b></label><div><toggle ng-model="vm.company.isEmailAgentExclusive" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Is Suspended?</b></label><div><toggle ng-model="vm.company.isSuspended" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>Company Registration No.</label> <input type="text" class="form-control" placeholder="Company Registration No." ng-model="vm.company.regNo"></div></div><div class="col-md-5 col-lg-5"><div class="form-group"><label>SST Registration No.</label> <input type="text" class="form-control" placeholder="SST Registration No." ng-model="vm.company.gstNo"></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>Address 1</label> <input type="text" class="form-control" placeholder="Address 1" ng-model="vm.company.address1"></div></div><div class="col-md-5 col-lg-5"><div class="form-group"><label>Address 2</label> <input type="text" class="form-control" placeholder="Address 2" ng-model="vm.company.address2"></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>Address 3</label> <input type="text" class="form-control" placeholder="Address 3" ng-model="vm.company.address3"></div></div><div class="col-md-5 col-lg-5"><div class="form-group"><label>Postal Code</label> <input type="text" class="form-control" placeholder="Postal Code" ng-model="vm.company.postCode"></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>State</label> <input type="text" class="form-control" placeholder="State" ng-model="vm.company.state"></div></div><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Country.$invalid && (vm.dataForm.Country.$dirty || vm.dataForm.$submitted)}"><label>Country</label><select class="form-control" name="Country" ng-model="vm.company.country" required=""><option value="MALAYSIA">MALAYSIA</option><option value="SINGAPORE">SINGAPORE</option><option value="PHILIPPINES">PHILIPPINES</option></select><span class="help-block" ng-if="vm.dataForm.$submitted && vm.dataForm.Country.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>Tel</label> <input type="text" class="form-control" placeholder="Tel" ng-model="vm.company.tel"></div></div><div class="col-md-5 col-lg-5"><div class="form-group"><label>Fax</label> <input type="text" class="form-control" placeholder="Fax" ng-model="vm.company.fax"></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>General Email</label> <input type="text" class="form-control" placeholder="General Email" ng-model="vm.company.email"></div></div></div><div class="row"><div class="col-lg-12"><legend style="height:32.4px;line-height:32.4px">Billing Contact</legend></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>Billing Contact</label> <input type="text" class="form-control" placeholder="General Email" ng-model="vm.company.billingContact"></div></div><div class="col-md-5 col-lg-5"><div class="form-group"><label>Billing Email</label> <input type="text" class="form-control" placeholder="General Email" ng-model="vm.company.billingEmail"></div></div></div><div class="row"><div class="col-lg-12"><legend style="height:32.4px;line-height:32.4px">Support Contact</legend></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>Support Contact</label> <input type="text" class="form-control" placeholder="General Email" ng-model="vm.company.supportContact"></div></div><div class="col-md-5 col-lg-5"><div class="form-group"><label>Support Email</label> <input type="text" class="form-control" placeholder="General Email" ng-model="vm.company.supportEmail"></div></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Billing"><p><i class="fa fa-info-circle"></i> Please select the appropriate Packages.</p><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.company.serverPackageId==\'\' && vm.dataForm.$submitted}"><label>Server Package <i class="fa fa-asterisk req"></i></label><select name="ServerPackage" class="form-control" ng-model="vm.selectedServerPackage" ng-change="vm.selectedServerPackageChanged()" ng-options="i as (i.name | uppercase) for i in vm.serverPackages"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.company.serverPackageId==\'\'">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingContact.$invalid && (vm.dataForm.BillingContact.$dirty || vm.dataForm.$submitted)}"><label>Billing Contact <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BillingContact" placeholder="Billing Contact Person" ng-model="vm.company.billingContact" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingContact.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingEmail.$invalid && (vm.dataForm.BillingEmail.$dirty || vm.dataForm.$submitted)}"><label>Billing Email <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BillingEmail" placeholder="Email address for Billing purpose" ng-model="vm.company.billingEmail" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingEmail.$error.required">* Required</span></div></div></div><hr><div class="row"><div class="col-md-4 col-lg-4"><i class="fa fa-info-circle"></i> Contract Period Information. Applicable for IMS Subscription.<p><br></p></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ContractStartDate.$invalid && (vm.dataForm.ContractStartDate.$dirty || vm.dataForm.$submitted)}"><label><b>Contract {{ \'START_DATE\' | translate }}</b></label><div moment-picker="vm.company.billing_ContractStartDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="ContractStartDate" autocomplete="off" ng-model="vm.company.billing_ContractStartDate" ng-required="vm.company.isBillable"></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ContractStartDate.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ContractEndDate.$invalid && (vm.dataForm.ContractEndDate.$dirty || vm.dataForm.$submitted)}"><label><b>Contract {{ \'END_DATE\' | translate }}</b></label><div moment-picker="vm.company.billing_ContractEndDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="ContractEndDate" autocomplete="off" ng-model="vm.company.billing_ContractEndDate" ng-required="vm.company.isBillable"></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ContractEndDate.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NextBillStartDate.$invalid && (vm.dataForm.NextBillStartDate.$dirty || vm.dataForm.$submitted)}"><label><b>Next Billing {{ \'START_DATE\' | translate }}</b></label><div moment-picker="vm.company.billing_NextBillStartDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="NextBillStartDate" autocomplete="off" ng-model="vm.company.billing_NextBillStartDate" ng-required="vm.company.isBillable"></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NextBillStartDate.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CreditTerm.$invalid && (vm.dataForm.CreditTerm.$dirty || vm.dataForm.$submitted)}"><label><b>Credit Term (Days)</b></label> <input type="number" class="form-control" name="CreditTerm" min="1" max="60" ng-model="vm.company.creditTerm" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CreditTerm.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CreditTerm.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CreditTerm.$error.min">* Minimum is 1</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CreditTerm.$error.max">* Maximum is 60</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Mail"><p>Please enter the relevant information for the SMTP Server. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.setDefaultMailSettings()"><i class="fa fa-wrench"></i> Set Default</a> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.setGMailSettings()"><i class="fa fa-wrench"></i> Set GMail</a> <a href="" class="btn btn-warning btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.testEmailSetting()"><i class="fa fa-flask"></i> Test Setting</a> <span ng-if="vm.isCheckingSMTP" style="margin-left:20px;color:#00f"><i class="fa fa-spinner fa-spin fa-fw"></i> Validating Email Settings, Please Wait...</span></p><p><small><i class="fa fa-info-circle"></i> <em>This section must be all filled</em></small><br><br></p><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MailServer.$invalid && (vm.dataForm.MailServer.$dirty || vm.dataForm.$submitted)}"><label>SMTP Server <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="MailServer" placeholder="e.g.: mail.server.com" ng-model="vm.company.mailServer" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MailServer.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MailPort.$invalid && (vm.dataForm.MailPort.$dirty || vm.dataForm.$submitted)}"><label>SMTP Port <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="MailPort" placeholder="e.g.: 2525 / 465 / 587" ng-model="vm.company.mailPort" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MailPort.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MailLogin.$invalid && (vm.dataForm.MailLogin.$dirty || vm.dataForm.$submitted)}"><label>SMTP Login <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="MailLogin" placeholder="SMTP Login" ng-model="vm.company.mailLogin" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MailLogin.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MailPassword.$invalid && (vm.dataForm.MailPassword.$dirty || vm.dataForm.$submitted)}"><label>SMTP Password <i class="fa fa-asterisk req"></i></label> <input type="password" class="form-control" name="MailPassword" placeholder="SMTP Password" ng-model="vm.company.mailPassword" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MailPassword.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label>Use SSL</label><div><toggle ng-model="vm.company.mailUseSsl" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Features"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p>Please select the features applicable to this Company. Select at least ONE (1) Feature: <i class="fa fa-asterisk req"></i></p><p><small><i class="fa fa-info-circle"></i> <em>Note that some features are company-specific</em></small></p></div></div><div class="row"><div class="col-md-12" style="padding-bottom:20px;"><a href="" class="btn btn-primary btn-with-icon btn-xs" ng-click="vm.selectAllFeatures()"><i class="ion ion-android-checkbox-outline"></i> Select All</a> <a href="" class="btn btn-primary btn-with-icon btn-xs" ng-click="vm.deselectAllFeatures()"><i class="ion ion-android-checkbox-outline-blank"></i> Deselect All</a></div></div><div class="row"><div class="col-md-12"><div ng-repeat="f in vm.features"><div ng-show="f.isParent" style="height:10px;margin-left:0px;"></div><div ng-show="f.isParent" style="height:20px;margin-left:0px;border-top:2px dotted #aaa"></div><div style="line-height:30px"><input type="checkbox" name="Feature" style="float:left;cursor:pointer;width:25px;height:25px" checklist-model="vm.selectedFeatures" checklist-value="f" checklist-change="vm.dataForm.Feature.$setValidity(\'required\', vm.selectedFeatures.length > 0)" ng-required="!vm.selectedFeatures.length"> <span ng-show="f.isParent" style="margin-left:8px;color:#7e3e00"><b>{{ f.name | uppercase }}</b></span> <span ng-show="!f.isParent" style="margin-left:8px">&nbsp;<i class="fa fa-long-arrow-right"></i> &nbsp;&nbsp;{{ f.name }}</span></div></div></div></div><div class="row"><div class="col-md-12"><p><div class="col-md-12" ng-class="{\'has-error\': vm.dataForm.$submitted && vm.dataForm.Feature.$invalid }"><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Feature.$invalid">* Required at least ONE (1) Feature</span></div></p></div></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Specials"><p><i class="fa fa-info-circle"></i> Grant special access to Recipe Categories from other companies. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddCategoryModal()"><i class="ion-plus-round"></i>Grant Category Access</a><br><br></p><script type="text/ng-template" id="categoryModal.html"><form name="$mdl.categoryForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} Recipe Category</h3> </div> <div class="modal-body" id="modal-body"> <div class="form-group"> <label><b>Recipe Category</b></label> <ui-select style="background:#fffeed" title="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" ng-model="$mdl.selectedCategory" on-select="vm.selectedCategoryChanged()"> <ui-select-match placeholder="{{ \'TYPE_KEYWORD_TO_BEIGN_SEARCH\' | translate }}"> <span>{{ (\'(\' + $select.selected.companyName + \') - \' + $select.selected.name) }}</span> </ui-select-match> <ui-select-choices repeat="i in $mdl.categoryList | filter: $select.search" refresh="$mdl.searchCategoryList($select.search)" refresh-delay="250" minimum-input-length="3"> <span ng-bind-html="\'(\' + i.companyName + \') - \' + i.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> <p class="help-block" style="color:#f00" ng-show="$mdl.categoryForm.$invalid && $mdl.categoryForm.$submitted">* Required</p> </div> </div> <hr /> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> Confirm </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> Cancel </button> </div> </form></script><div class="row"><div class="col-md-9 col-lg-9"><table class="table table-striped" style="border:1px solid #ccc" st-pipe="vm.refreshRecipeCategories" st-table="vm.company.companyRecipeCategories" refresh-table=""><thead><tr class="sortable"><th style="width:60px">#</th><th><b>Recipe Category</b></th><th style="width:80px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.company.companyRecipeCategories"><td>{{$index+1}}</td><td>{{ ntn.recipeCategory.name || \'\' }}</td><td><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" confirmed-click="vm.removeCategory($index)" ng-confirm-click="Confirm remove this Category?"><i class="fa fa-trash-o"></i> Delete</a></td></tr><tr><td colspan="3" align="center" ng-show="vm.company.companyRecipeCategories.length==0"><br>No special access granted.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Settings"><p><i class="fa fa-info-circle"></i> These are the company settings for various modules.</p><p><br></p><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LanguageCode.$invalid && (vm.dataForm.LanguageCode.$dirty || vm.dataForm.$submitted)}"><label><b>Language</b></label><select class="form-control" name="LanguageCode" ng-model="vm.company.languageCode" required=""><option value="">-- Select a Language --</option><option value="ar">Arabic</option><option value="cn">Chinese</option><option value="en">English</option><option value="kr">Korean</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LanguageCode.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LanguageDirection.$invalid && (vm.dataForm.LanguageDirection.$dirty || vm.dataForm.$submitted)}"><label><b>Language Direction</b></label><select class="form-control" name="LanguageDirection" ng-model="vm.company.languageDirection" required=""><option value="">-- Select a Direction --</option><option value="left">Left-to-Right (LTR)</option><option value="right">Right-to-Left (RTL)</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LanguageDirection.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CurrencyCode.$invalid && (vm.dataForm.LanguageCode.$dirty || vm.dataForm.$submitted)}"><label><b>Currency</b></label><select class="form-control" name="CurrencyCode" ng-options="c as (\'[\' + c.code + \'] \' + c.name) for c in vm.currencyList" ng-model="vm.selectedCurrency" ng-change="vm.selectedCurrencyChanged()" required=""><option value="">-- Select a Currency --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CurrencyCode.$error.required">* Required</span></div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_Company_StarterMode" ng-change="vm.starterModeChanged()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>RMS Starter Mode</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Switch to RMS Starter mode.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_Company_LiteMode" ng-change="vm.liteModeChanged()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>RMS Lite Mode</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Switch to RMS Lite mode.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Company_DurianMode" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Durian Mode</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Durian Operation Workflow.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Company_SeafoodMode" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Seafood Mode</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Seafood Supplier Operation Workflow.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Company_ButcherMode" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Butcher Mode</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Meat Supplier Operation Workflow.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_Company_EnableFoodSafetyCompliance" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Food Safety Mode</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Food Safety Features &amp; Compliances.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_StockRequest_MultiSplitItemType" ng-change="vm.setting_StockRequest_MultiSplitItemType_Changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Stock Request</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Split Request Items by Item Type (Raw Mat / Semi FG / FG) upon submission.</div></div></div><div class="row" ng-if="vm.compSetting.setting_StockRequest_MultiSplitItemType"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_StockRequest_MultiSplitCatAndSubCat" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Stock Request</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Further split Request Items by Item Category and Sub-Category upon submission.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_StockRequest_ShowPriceForFranchisee" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Stock Request</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable display stock request item price for franchise</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Job_StockOutUponConfirmation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Production Job</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto stock-out Raw Items upon job confirmation.</div></div></div><div class="row" style="margin-bottom:15px" ng-if="vm.company.setting_Job_StockOutUponConfirmation"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:150px;height:50px;padding-right:0px;line-height:50px;text-align:right;background:#eee"><i class="fa fa-archive"></i> <em>Item Storage:</em></div><div class="col-md-5 col-lg-5" style="height:50px;background:#eee;padding-top:8px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ItemStorageId.$invalid && (vm.dataForm.ItemStorageId.$dirty || vm.dataForm.$submitted)}"><select name="ItemStorageId" class="form-control" ng-change="vm.selectedItemStorageChanged($item)" ng-if="vm.company.setting_Job_StockOutUponConfirmation" ng-model="vm.selectedItemStorage" ng-options="i as (i.extendedDescription | uppercase) for i in vm.itemStorageList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ItemStorageId.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Job_StockInUponCompletion" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Production Job</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto stock-In Finished Products upon job completion.</div></div></div><div class="row" style="margin-bottom:15px" ng-if="vm.company.setting_Job_StockInUponCompletion"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:150px;height:50px;padding-right:0px;line-height:50px;text-align:right;background:#eee"><i class="fa fa-archive"></i> <em>Product Storage:</em></div><div class="col-md-5 col-lg-5" style="height:50px;background:#eee;padding-top:8px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ProductStorageId.$invalid && (vm.dataForm.ProductStorageId.$dirty || vm.dataForm.$submitted)}"><select name="ProductStorageId" class="form-control" ng-change="vm.selectedProductStorageChanged($item)" ng-if="vm.company.setting_Job_StockInUponCompletion" ng-model="vm.selectedProductStorage" ng-options="i as (i.extendedDescription | uppercase) for i in vm.productStorageList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ProductStorageId.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_Job_CompleteJobWithFullyStockedOut" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Production Job</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Production Jobs can only be Completed if all ingredients are fully stocked out.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_BulkBreak_AutoPrintLabel" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Bulk-Break Job</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto print label for result items.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_BulkBreak_AutoStockIn" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Bulk-Break Job</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto stock-in after label printed.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Grn_EnableAutoUpdateUom" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Goods Receiving</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto update Raw Material UOM settings based on Label Printing selected UOM option.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Grn_StockInUponConfirmation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Goods Receiving</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto stock-in upon confirmation (Normal Mode).</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Grn_QuickModeAutoStockIn" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Goods Receiving</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto stock-in upon label printed (Quick Mode).</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Grn_EnableLabelPrinting" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Goods Receiving</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Label Printing.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_PurchaseOrder_UseLowerPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Override the default supplier and select the lowest price.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_PurchaseOrder_WriteOffUponGrn" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto write-off remaining balance upon GRN confirmation.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_PurchaseOrder_EnableBulkCreationByBranch" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Bulk creation of P.O. according requester\'s branch.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_PurchaseOrder_EnableDepartmentalized" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Bulk creation of P.O. according requester\'s department.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_PurchaseOrder_UseSupplierDescription" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Use Raw Material\'s Supplier Item Description in P.O.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_PurchaseOrder_DirectPriceUpdate" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Price update in the P.O. Items, will also permanently update the supplier\'s pricing of the Raw Material.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_PurchaseOrder_EnabledLandedCost" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Landed Cost.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_SalesOrder_UsePax" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Sales Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Add finished goods to S.O. using no. of Pax instead of UOMs.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_SalesOrder_DirectTriggerJobCreation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Sales Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Allow direct trigger Production Job creation</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_SalesOrder_EnableCutOffTime" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Sales Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enforce Cut-Off Time control.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_SalesOrder_EnableInvoice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Sales Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Generating Invoice from Sales Order</div></div></div><div class="row" ng-if="vm.company.setting_SalesOrder_EnableCutOffTime"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div style="line-height:32.4px;margin-left:34px;margin-top:-15px"><div class="row"><div class="col-lg-3" style="background:#eee">Cut-Off Hour:</div><div class="col-lg-3" style="background:#eee">Cut-Off Minute:</div></div><div class="row" style="margin-bottom:10px"><div class="col-lg-3" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SalesOrderCutOffHour.$invalid && (vm.dataForm.SalesOrderCutOffHour.$dirty || vm.dataForm.$submitted)}"><select name="SalesOrderCutOffHour" class="form-control input-sm" ng-change="vm.selectedSOCutOffHourChanged()" ng-model="vm.selectedSOCutOffHour" ng-options="i as i.name for i in vm.hourList" ng-required="vm.company.setting_SalesOrder_EnableCutOffTime"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SalesOrderCutOffHour.$error.required">* Required</span></div></div><div class="col-lg-3" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SalesOrderCutOffMinute.$invalid && (vm.dataForm.SalesOrderCutOffMinute.$dirty || vm.dataForm.$submitted)}"><select name="SalesOrderCutOffMinute" class="form-control input-sm" ng-change="vm.selectedSOCutOffMinuteChanged()" ng-model="vm.selectedSOCutOffMinute" ng-options="i as i.name for i in vm.minuteList" ng-required="vm.company.setting_SalesOrder_EnableCutOffTime"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SalesOrderCutOffMinute.$error.required">* Required</span></div></div></div></div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_DeliveryOrder_DirectDO" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Allowed to create DO without selecting any Sales Order / Stock Transfer.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_DeliveryOrder_AdvancedMode" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Turn on Advanced Mode (Complete control mechanism).</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_DeliveryOrder_AdvancedModeAutoDriverVerification" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto perform driver verification after all items are stocked out (in Advanced Mode only).</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_DeliveryOrder_PrintPartialLabel" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable printing label during stock-out partial quantity from original Label.</div></div></div><div class="row" ng-if="vm.company.setting_DeliveryOrder_PrintPartialLabel"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div style="line-height:32.4px;margin-left:34px;margin-top:-15px"><div class="row"><div class="col-lg-2" style="background:#eee;padding:10px;"><toggle ng-model="vm.company.setting_DeliveryOrder_PrintPartialLabel_DOSO" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div><div class="col-lg-8" style="background:#eee;padding:10px;">Enable for Delivery Order transferred from Sales Order.</div></div><div class="row"><div class="col-lg-2" style="background:#eee;padding:10px;"><toggle ng-model="vm.company.setting_DeliveryOrder_PrintPartialLabel_DOST" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div><div class="col-lg-8" style="background:#eee;padding:10px;">Enable for Delivery Order transferred from Stock Transfer.</div></div><div class="row"><div class="col-lg-2" style="background:#eee;padding:10px;"><toggle ng-model="vm.company.setting_DeliveryOrder_PrintPartialLabel_DOXSOST" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div><div class="col-lg-8" style="background:#eee;padding:10px;">Enable for Normal Delivery Order .</div></div></div><br></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_DeliveryOrder_StockOutUponConfirmation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto stock-out Finished Goods upon Delivery Order approval.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_DeliveryOrder_EnableCutOffTime" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enforce Cut-Off Time control.</div></div></div><div class="row" ng-if="vm.company.setting_DeliveryOrder_EnableCutOffTime"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div style="line-height:32.4px;margin-left:34px;margin-top:-15px"><div class="row"><div class="col-lg-3" style="background:#eee">Cut-Off Hour:</div><div class="col-lg-3" style="background:#eee">Cut-Off Minute:</div></div><div class="row" style="margin-bottom:10px"><div class="col-lg-3" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CutOffHour.$invalid && (vm.dataForm.CutOffHour.$dirty || vm.dataForm.$submitted)}"><select name="CutOffHour" class="form-control input-sm" ng-change="vm.selectedDOCutOffHourChanged()" ng-model="vm.selectedDOCutOffHour" ng-options="i as i.name for i in vm.hourList" ng-required="vm.company.setting_DeliveryOrder_EnableCutOffTime"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CutOffHour.$error.required">* Required</span></div></div><div class="col-lg-3" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CutOffMinute.$invalid && (vm.dataForm.CutOffMinute.$dirty || vm.dataForm.$submitted)}"><select name="CutOffMinute" class="form-control input-sm" ng-change="vm.selectedDOCutOffMinuteChanged()" ng-model="vm.selectedDOCutOffMinute" ng-options="i as i.name for i in vm.minuteList" ng-required="vm.company.setting_DeliveryOrder_EnableCutOffTime"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CutOffMinute.$error.required">* Required</span></div></div></div></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_DeliveryOrder_EnableDeliveryWindow" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enforce Customer\'s Delivery Window.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Stock_AllowNegativeBalance" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Stock Inventory</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Allow negative balance (Items &amp; Products).</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Stock_EnableCatchWeightManagement" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Stock Inventory</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Catch-Weight Management (CWM).</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_StockCount_EnabledNonBlindCount" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Stock Inventory</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Non-Blind Count during Stock Count.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Recipe_UseLainoxNaboo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Using Lainox Naboo</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Whether this is Lainox Naboo\'s customer.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Recipe_UseFoodPortioningTable" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Using Food Portioning Table</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Applicable for Sales Order &amp; Job Production product quantity calculation.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Recipe_UseShortDescription" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:120%"><b>Using Raw Material Short Description</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Applicable for Raw Material Maintenance for displaying Short Description on Recipe Card and Product Label.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_WorkOrder_ManualChargeInput" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Work Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;For Aftersales Work Order, enable manual Invoice & GST amount input.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group" style="line-height:60%"><input type="number" class="form-control" ng-model="vm.compSetting.setting_AssetScheduleByDay"><br><center>Days</center></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Asset Management</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp; System will begin sending email reminder from the number of Days before the scheduled maintenance date.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group" style="line-height:60%"><input type="number" class="form-control" ng-model="vm.compSetting.setting_ExpiryCertByMonth"><br><center>Months</center></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Certificate Management</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp; System will begin sending email reminder from the number of Months before the expiry date of the certificates.</div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Integration"><p><i class="fa fa-info-circle"></i> For 3rd Party software integration.</p><br><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.IntegrationMode.$invalid && (vm.dataForm.IntegrationMode.$dirty || vm.dataForm.$submitted)}"><label><b>Integration Mode</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="IntegrationMode" ng-options="c as c.name for c in vm.integrationModes track by c.id" ng-model="vm.integrationModes.selected" ng-change="vm.selectIntegrationMode(vm.integrationModes.selected)" required=""><option value="">-- Select a Mode --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.IntegrationMode.$error.required">* Required</span></div></div></div><br><br><fieldset ng-if="vm.company.integrationMode==1"><legend>SysPro ERP Parameters</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProWebServiceUrl.$invalid && (vm.dataForm.SysProWebServiceUrl.$dirty || vm.dataForm.$submitted)}"><label><b>Web Service URI</b></label> <input type="text" class="form-control" name="SysProWebServiceUrl" placeholder="e.g.: http://192.168.1.1/sysprowebservices/" ng-model="vm.company.syspro_WebServiceUrl" ng-required="vm.company.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProWebServiceUrl.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProUsername.$invalid && (vm.dataForm.SysProUsername.$dirty || vm.dataForm.$submitted)}"><label><b>Operator Username</b></label> <input type="text" class="form-control" name="SysProUsername" ng-model="vm.company.syspro_Username" ng-required="vm.company.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProUsername.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProSupplierBankCode.$invalid && (vm.dataForm.SysProSupplierBankCode.$dirty || vm.dataForm.$submitted)}"><label><b>Default Supplier Bank Code</b></label> <input type="text" class="form-control" name="SysProSupplierBankCode" ng-model="vm.company.syspro_SupplierBankCode" ng-required="vm.company.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProSupplierBankCode.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProPassword.$invalid && (vm.dataForm.SysProPassword.$dirty || vm.dataForm.$submitted)}"><label><b>Operator Password</b></label> <input type="password" class="form-control" name="SysProPassword" ng-model="vm.company.syspro_Password" ng-required="vm.company.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProPassword.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProSupplierBranchCode.$invalid && (vm.dataForm.SysProSupplierBranchCode.$dirty || vm.dataForm.$submitted)}"><label><b>Default Supplier Branch Code</b></label> <input type="text" class="form-control" name="SysProSupplierBranchCode" ng-model="vm.company.syspro_SupplierBranchCode" ng-required="vm.company.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProSupplierBranchCode.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProCompanyId.$invalid && (vm.dataForm.SysProCompanyId.$dirty || vm.dataForm.$submitted)}"><label><b>Company ID</b></label> <input type="text" class="form-control" name="SysProCompanyId" ng-model="vm.company.syspro_CompanyId" ng-required="vm.company.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProCompanyId.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group"><label><b>Company Password</b></label> <input type="password" class="form-control" name="Password" ng-model="vm.company.syspro_CompanyPassword"></div></div></div></fieldset><fieldset ng-if="vm.company.integrationMode==2"><legend>AutoCount Accounting Parameters</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AutoCountWebServiceUrl.$invalid && (vm.dataForm.AutoCountWebServiceUrl.$dirty || vm.dataForm.$submitted)}"><label><b>Web Service URL</b></label> <input type="text" class="form-control" name="AutoCountWebServiceUrl" placeholder="e.g.: https://clientcompany.ddns.net/cmxatcint/api/v1/" ng-model="vm.company.autoCount_WebServiceUrl" ng-required="vm.company.integrationMode==2"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AutoCountWebServiceUrl.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AutoCountUsername.$invalid && (vm.dataForm.AutoCountUsername.$dirty || vm.dataForm.$submitted)}"><label><b>Username</b></label> <input type="text" class="form-control" name="AutoCountUsername" ng-model="vm.company.autoCount_Username" ng-required="vm.company.integrationMode==2"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AutoCountUsername.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AutoCountPassword.$invalid && (vm.dataForm.AutoCountPassword.$dirty || vm.dataForm.$submitted)}"><label><b>Password</b></label> <input type="password" class="form-control" name="AutoCountPassword" ng-model="vm.company.autoCount_Password" ng-required="vm.company.integrationMode==2"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AutoCountPassword.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">&nbsp;<br><a href="" class="btn btn-primary" ng-click="vm.testIntegrationAutoCount()">Validate Connection</a></div></div><hr><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.autoCount_EnableSync_Franchisee" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Franchisee Data (SO, PO, DO, Invoice, Inventory)</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_Debtor" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Debtors</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_Creditor" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Creditors</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_Warehouse" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Branches</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_RawMat" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Materials</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_RawMat"><div class="form-group"><div><toggle ng-model="vm.compSetting.autoCount_EnableSync_RawMat_StandardCost" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_RawMat"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Material Standard Cost</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_RawMat"><div class="form-group"><div><toggle ng-model="vm.compSetting.autoCount_EnableSync_RawMat_StandardSellingPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_RawMat"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Material Standard Selling Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_SemiFg" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Semi F.G.</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_SemiFg"><div class="form-group"><div><toggle ng-model="vm.compSetting.autoCount_EnableSync_SemiFg_StandardSellingPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_SemiFg"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Semi F.G. Standard Selling Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_Product" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Finished Goods</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_Product"><div class="form-group"><div><toggle ng-model="vm.compSetting.autoCount_EnableSync_Product_StandardSellingPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_Product"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Finished Goods Standard Selling Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_Inventory" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Inventory</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_SalesOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Sales Order</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_SalesOrder"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_SyncBack_SalesOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_SalesOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Sales Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_SalesOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_SyncItemPrice_SalesOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_SalesOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Sales Order Item Price</b></div></div><p><br></p></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_PurchaseOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Purchase Orders</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_PurchaseOrder"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_SyncBack_PurchaseOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_PurchaseOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Purchase Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_PurchaseOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_EnableSync_PurchaseTaxCode" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_PurchaseOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Purchase Order Item Tax Code</b></div></div><p><br></p></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_PurchaseOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.autoCount_EnableSync_PurchaseInvoice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_PurchaseOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Purchase Invoice when PO is finalized.</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_DeliveryOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Delivery Orders</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_DeliveryOrder"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_SyncBack_DeliveryOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_DeliveryOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Delivery Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_DeliveryOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_SyncItemPrice_DeliveryOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_DeliveryOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Delivery Order Item Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_EnableSync_InvoiceNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Invoices</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.autocount_EnableSync_InvoiceNo"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_SyncBack_InvoiceNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.autocount_EnableSync_InvoiceNo"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Invoice No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.autocount_EnableSync_InvoiceNo"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_EnableSync_AddInvoice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.autocount_EnableSync_InvoiceNo"><div class="form-group" style="line-height:32.4px"><b>Enable Create Invoice</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.autocount_EnableSync_InvoiceNo"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_EnableSync_UpdateInvoice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.autocount_EnableSync_InvoiceNo"><div class="form-group" style="line-height:32.4px"><b>Enable Update Invoice</b></div></div></div><hr><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_SalesOrder_CheckCreditLimitExceed" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>S.O. - Check Credit Limit</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Check Credit Limit When Confirming Sales Order.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_DeliveryOrder_CheckCreditLimitExceed" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>D.O. - Check Credit Limit</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Check Credit Limit When Confirming Delivery Order.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_DOQM_CheckCreditLimitExceed" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>D.O.Q.M - Check Credit Limit</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Check Credit Limit When Finalizing D.O. Quick Mode.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Global Sync Retry Interval</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Interval (minute) between each synchronization attempt.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div style="line-height:32.4px;margin-left:34px;margin-top:-15px"><div class="row"><div class="col-lg-4" style="background:#eee">Interval (Minutes):</div></div><div class="row" style="margin-bottom:10px"><div class="col-lg-4" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.GlobalSyncRetryInterval.$invalid && (vm.dataForm.GlobalSyncRetryInterval.$dirty || vm.dataForm.$submitted)}"><select name="GlobalSyncRetryInterval" class="form-control input-sm" ng-change="vm.selectedAutocountGlobalSyncRetryIntervalChanged()" ng-model="vm.selectedAutocountGlobalSyncRetryInterval" ng-options="i as i.name for i in vm.intervalList" ng-required="vm.company.integrationMode==2"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.GlobalSyncRetryInterval.$error.required">* Required</span></div></div></div></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Inventory Sync Time</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Scheduled Time for Inventory Synchronization.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div style="line-height:32.4px;margin-left:34px;margin-top:-15px"><div class="row"><div class="col-lg-6" style="background:#eee">Sync Interval: <i class="fa fa-asterisk req" ng-if="vm.company.integrationMode==2 && vm.company.autoCount_EnableSync_Inventory"></i></div></div><div class="row" style="margin-bottom:10px"><div class="col-lg-6" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InventorySyncInterval.$invalid && (vm.dataForm.InventorySyncInterval.$dirty || vm.dataForm.$submitted)}"><select name="InventorySyncInterval" class="form-control input-sm" ng-change="vm.selectedAutocountInvSyncIntervalChanged()" ng-model="vm.selectedAutocountInvSyncInterval" ng-options="i as i.name for i in vm.periodList" ng-required="vm.company.integrationMode==2 && vm.company.autoCount_EnableSync_Inventory"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InventorySyncInterval.$error.required">* Required</span></div></div></div><div class="row"><div class="col-lg-3" style="background:#eee">Sync Hour: <i class="fa fa-asterisk req" ng-if="vm.company.integrationMode==2 && vm.company.autoCount_EnableSync_Inventory"></i></div><div class="col-lg-3" style="background:#eee">Sync Minute: <i class="fa fa-asterisk req" ng-if="vm.company.integrationMode==2 && vm.company.autoCount_EnableSync_Inventory"></i></div></div><div class="row" style="margin-bottom:10px"><div class="col-lg-3" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InventorySyncHour.$invalid && (vm.dataForm.InventorySyncHour.$dirty || vm.dataForm.$submitted)}"><select name="InventorySyncHour" class="form-control input-sm" ng-change="vm.selectedAutocountInvSyncHourChanged()" ng-model="vm.selectedAutocountInvSyncHour" ng-options="i as i.name for i in vm.hourList" ng-required="vm.company.integrationMode==2 && vm.company.autoCount_EnableSync_Inventory"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InventorySyncHour.$error.required">* Required</span></div></div><div class="col-lg-3" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InventorySyncMinute.$invalid && (vm.dataForm.InventorySyncMinute.$dirty || vm.dataForm.$submitted)}"><select name="InventorySyncMinute" class="form-control input-sm" ng-change="vm.selectedAutocountInvSyncMinuteChanged()" ng-model="vm.selectedAutocountInvSyncMinute" ng-options="i as i.name for i in vm.minuteList" ng-required="vm.company.integrationMode==2 && vm.company.autoCount_EnableSync_Inventory"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InventorySyncMinute.$error.required">* Required</span></div></div></div></div></div></div></fieldset><fieldset ng-if="vm.company.integrationMode==8"><legend>SQL Accounting Parameters</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLWebServiceUrl.$invalid && (vm.dataForm.SQLWebServiceUrl.$dirty || vm.dataForm.$submitted)}"><label><b>Web Service URL</b></label> <input type="text" class="form-control" name="SQLWebServiceUrl" placeholder="e.g.: https://clientcompany.ddns.net/cmxatcint/api/v1/" ng-model="vm.compSetting.sqL_WebServiceUrl" ng-required="vm.company.integrationMode==8"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLWebServiceUrl.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLUsername.$invalid && (vm.dataForm.SQLUsername.$dirty || vm.dataForm.$submitted)}"><label><b>Username</b></label> <input type="text" class="form-control" name="SQLUsername" ng-model="vm.compSetting.sqL_Username" ng-required="vm.company.integrationMode==8"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLUsername.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLPassword.$invalid && (vm.dataForm.SQLPassword.$dirty || vm.dataForm.$submitted)}"><label><b>Password</b></label> <input type="password" class="form-control" name="SQLPassword" ng-model="vm.compSetting.sqL_Password" ng-required="vm.company.integrationMode==8"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLPassword.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">&nbsp;<br><a href="" class="btn btn-primary" ng-click="vm.testIntegrationSQL()">Validate Connection</a></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.sqL_DCFPath.$invalid && (vm.dataForm.sqL_DCFPath.$dirty || vm.dataForm.$submitted)}"><label><b>DCF File Path</b></label> <input type="text" class="form-control" name="DCFPath" ng-model="vm.compSetting.sqL_DCFPath" ng-required="vm.company.integrationMode==8"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.sqL_DCFPath.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DatabaseName.$invalid && (vm.dataForm.DatabaseName.$dirty || vm.dataForm.$submitted)}"><label><b>Database Name</b></label> <input type="text" class="form-control" name="DatabaseName" ng-model="vm.compSetting.sqL_DatabaseName" ng-required="vm.company.integrationMode==8"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DatabaseName.$error.required">* Required</span></div></div></div><hr><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_Franchisee" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Franchisee Data (SO, PO, DO, Invoice, Inventory)</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_Debtor" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Debtors</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_Creditor" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Creditors</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_RawMat" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Materials</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_RawMat"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_RawMat_StandardCost" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_RawMat"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Material Standard Cost</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_RawMat"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_RawMat_StandardSellingPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_RawMat"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Material Standard Selling Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_SemiFg" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Semi F.G.</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_SemiFg"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_SemiFg_StandardSellingPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_SemiFg"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Semi F.G. Standard Selling Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_Product" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Finished Goods</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_Product"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_Product_StandardSellingPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_Product"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Finished Goods Standard Selling Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_SalesOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Sales Order</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_SalesOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_SyncBack_SalesOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_SalesOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Sales Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_PurchaseOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Purchase Orders</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_PurchaseOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_SyncBack_PurchaseOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_PurchaseOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Purchase Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_PurchaseOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_PurchaseInvoice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_PurchaseOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Purchase Invoice when PO is finalized.</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_DeliveryOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Delivery Orders</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_DeliveryOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_SyncBack_DeliveryOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_DeliveryOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Delivery Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_Invoice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Invoices</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_Invoice"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_SyncBack_InvoiceNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_Invoice"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Invoice No#</b></div></div></div></fieldset><fieldset ng-if="vm.company.integrationMode==7"><legend>IDB ERP Parameters</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.idB_WebServiceUrl.$invalid && (vm.dataForm.idB_WebServiceUrl.$dirty || vm.dataForm.$submitted)}"><label><b>Web Service URL</b></label> <input type="text" class="form-control" name="idB_WebServiceUrl" placeholder="e.g.: https://clientcompany.ddns.net/cmxatcint/api/v1/" ng-model="vm.compSetting.idB_WebServiceUrl" ng-required="vm.company.integrationMode==7"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.idB_WebServiceUrl.$error.required">* Required</span></div></div></div><hr><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.idB_EnableSync_Creditor" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Creditors</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.idB_EnableSync_RawMat" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Materials</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.idB_EnableSync_PurchaseOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Purchase Orders</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.idB_EnableSync_PurchaseOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.idB_SyncBack_PurchaseOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.idB_EnableSync_PurchaseOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Purchase Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.idB_EnableSync_Grn" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync GRN when PO is Finalized.</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.idB_EnableSync_Grn"><div class="form-group"><div><toggle ng-model="vm.compSetting.idB_SyncBack_GrnNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.idB_EnableSync_Grn"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back GRN No#</b></div></div></div></fieldset><fieldset ng-if="vm.company.integrationMode==3"><legend>FNB System Parameters</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FnbSysWebServiceUrl.$invalid && (vm.dataForm.FnbSysWebServiceUrl.$dirty || vm.dataForm.$submitted)}"><label><b>Web Service URI</b></label> <input type="text" class="form-control" name="FnbSysWebServiceUrl" ng-model="vm.company.fnbSystem_WebServiceUrl" ng-required="vm.company.integrationMode==3"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FnbSysWebServiceUrl.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FnbSysPassword.$invalid && (vm.dataForm.FnbSysPassword.$dirty || vm.dataForm.$submitted)}"><label><b>Password</b></label> <input type="password" class="form-control" name="FnbSysPassword" ng-model="vm.company.fnbSystem_Password" ng-required="vm.company.integrationMode==3"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FnbSysPassword.$error.required">* Required</span></div></div></div></fieldset><fieldset ng-if="vm.company.integrationMode==4"><legend>SAP Hybris C4C Parameters</legend><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SAPC4CTenantId.$invalid && (vm.dataForm.SAPC4CTenantId.$dirty || vm.dataForm.$submitted)}"><label><b>Tenant ID</b></label> <input type="text" class="form-control" name="SAPC4CTenantId" ng-model="vm.company.sapC4C_TenantId" ng-required="vm.company.integrationMode==4"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SAPC4CTenantId.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SAPC4CUsername.$invalid && (vm.dataForm.SAPC4CUsername.$dirty || vm.dataForm.$submitted)}"><label><b>Username</b></label> <input type="text" class="form-control" name="SAPC4CUsername" ng-model="vm.company.sapC4C_Username" ng-required="vm.company.integrationMode==4"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SAPC4CUsername.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SAPC4CPassword.$invalid && (vm.dataForm.SAPC4CPassword.$dirty || vm.dataForm.$submitted)}"><label><b>Password</b></label> <input type="password" class="form-control" name="SAPC4CPassword" ng-model="vm.company.sapC4C_Password" ng-required="vm.company.integrationMode==4"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SAPC4CPassword.$error.required">* Required</span></div></div></div></fieldset><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="POS Integration"><p><i class="fa fa-info-circle"></i> Settings for POS Integration</p><br><p></p><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.POSIntegrationMode.$invalid && (vm.dataForm.POSIntegrationMode.$dirty || vm.dataForm.$submitted)}"><label><b>POS Integration Mode</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="POSIntegrationMode" ng-options="c as c.name for c in vm.posIntModes track by c.id" ng-model="vm.posIntModes.selected" ng-change="vm.selectPOSIntegrationMode(vm.posIntModes.selected)" required=""><option value="">-- Select a Mode --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.POSIntegrationMode.$error.required">* Required</span></div></div></div><div class="row" ng-if="vm.compSetting.poS_IntegrationMode==1"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Enable</b></label><div><toggle ng-model="vm.compSetting.setting_EnableFTP" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.compSetting.poS_IntegrationMode==1"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.POS_FTP_WebURL.$invalid && (vm.dataForm.POS_FTP_WebURL.$dirty || vm.dataForm.$submitted)}"><label><b>FTP Server URL</b> <i class="fa fa-asterisk req" ng-if="vm.compSetting.setting_EnableFTP"></i></label> <input type="text" class="form-control" name="POS_FTP_WebURL" ng-model="vm.compSetting.ftP_WebServiceUrl" ng-required="vm.compSetting.poS_IntegrationMode==1 && vm.compSetting.setting_EnableFTP"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.POS_FTP_WebURL.$error.required">* Required</span></div></div></div><div class="row" ng-if="vm.compSetting.poS_IntegrationMode==1"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.POS_FTP_Username.$invalid && (vm.dataForm.POS_FTP_Username.$dirty || vm.dataForm.$submitted)}"><label><b>FTP Username</b> <i class="fa fa-asterisk req" ng-if="vm.compSetting.setting_EnableFTP"></i></label> <input type="text" class="form-control" name="POS_FTP_Username" ng-model="vm.compSetting.ftP_Username" ng-required="vm.compSetting.poS_IntegrationMode==1 && vm.compSetting.setting_EnableFTP"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.POS_FTP_Username.$error.required">* Required</span></div></div></div><div class="row" ng-if="vm.compSetting.poS_IntegrationMode==1"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.POS_FTP_Password.$invalid && (vm.dataForm.POS_FTP_Password.$dirty || vm.dataForm.$submitted)}"><label><b>FTP Password</b> <i class="fa fa-asterisk req" ng-if="vm.compSetting.setting_EnableFTP"></i></label> <input type="text" class="form-control" name="POS_FTP_Password" ng-model="vm.compSetting.ftP_Password" ng-required="vm.compSetting.poS_IntegrationMode==1 && vm.compSetting.setting_EnableFTP"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.POS_FTP_Password.$error.required">* Required</span></div></div></div><p><br></p><p><br></p></uib-tab><uib-tab heading="Terms & Conditions"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Sales Order T&C</b></label> <textarea class="form-control" style="font-family:courier;color:#333;height:150px" ng-model="vm.company.companyTncs[0].salesOrderTnc">\n                                </textarea></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Upload up to 3 photos.</b></label><div class="row"><div class="col-md-4"><div class="upload-box" style="width: 100%; height: 150px; border: 2px dashed #ccc; display: flex; justify-content: center; align-items: center; cursor: pointer; position: relative; text-align: center;"><div class="upload-content" ng-if="!vm.attachments[\'attachmentLocation1\'] && !vm.company.companyTncs[0].attachmentLocation1" ngf-select="vm.setUploadAttachmentImage(picFile, \'attachmentLocation1\')" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ng-model="picFile" name="file" ng-disabled="vm.attachments[\'attachmentLocation1\'] || vm.company.companyTncs[0].attachmentLocation1" ngf-model-invalid="errorFile" style="display: flex; flex-direction: column; align-items: center; color: #aaa;"><i class="fa fa-plus" style="font-size: 40px; margin-bottom: 10px;"></i></div><div class="image-container" ng-if="vm.attachments[\'attachmentLocation1\'] || vm.company.companyTncs[0].attachmentLocation1" style="position: relative; display: inline-block;"><img ngf-src="vm.attachments[\'attachmentLocation1\'] || (vm.company.companyTncs[0].attachmentLocation1 ? vm.rootUrl + vm.company.companyTncs[0].attachmentLocation1 : \'\')" style="width: 100%; height: 150px; object-fit: cover;"></div><button ng-click="vm.deleteImage(\'attachmentLocation1\', $event)" ng-if="vm.attachments[\'attachmentLocation1\'] || vm.company.companyTncs[0].attachmentLocation1" style="position: absolute; top: 10px; right: 10px; background-color: #e85656; color: white; border: none; padding: 7px 10px; border-radius: 50px; cursor: pointer;"><i class="fa fa-trash"></i></button></div></div><div class="col-md-4"><div class="upload-box" ngf-select="vm.setUploadAttachmentImage($file, \'attachmentLocation2\')" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ng-model="picFile" name="file" ngf-model-invalid="errorFile" ng-if="!vm.lockUploadButton" style="width: 100%; height: 150px; border: 2px dashed #ccc; display: flex; justify-content: center; align-items: center; cursor: pointer; position: relative; text-align: center;"><div class="upload-content" ng-if="!vm.attachments[\'attachmentLocation2\'] && !vm.company.companyTncs[0].attachmentLocation2" style="display: flex; flex-direction: column; align-items: center; color: #aaa;"><i class="fa fa-plus" style="font-size: 40px; margin-bottom: 10px;"></i></div><div class="image-container" ng-if="vm.attachments[\'attachmentLocation2\'] || vm.company.companyTncs[0].attachmentLocation2" style="position: relative; display: inline-block;"><img ngf-src="vm.attachments[\'attachmentLocation2\'] || (vm.company.companyTncs[0].attachmentLocation2 ? vm.rootUrl + vm.company.companyTncs[0].attachmentLocation2 : \'\')" style="width: 100%; height: 150px; object-fit: cover;"></div><button ng-click="vm.deleteImage(\'attachmentLocation2\', $event)" ng-if="vm.attachments[\'attachmentLocation2\'] || vm.company.companyTncs[0].attachmentLocation2" style="position: absolute; top: 10px; right: 10px; background-color: #e85656; color: white; border: none; padding: 7px 10px; border-radius: 50px; cursor: pointer;"><i class="fa fa-trash"></i></button></div></div><div class="col-md-4"><div class="upload-box" ngf-select="vm.setUploadAttachmentImage($file, \'attachmentLocation3\')" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ng-model="picFile" name="file" ngf-model-invalid="errorFile" ng-if="!vm.lockUploadButton" style="width: 100%; height: 150px; border: 2px dashed #ccc; display: flex; justify-content: center; align-items: center; cursor: pointer; position: relative; text-align: center;"><div class="upload-content" ng-if="!vm.attachments[\'attachmentLocation3\'] && !vm.company.companyTncs[0].attachmentLocation3" style="display: flex; flex-direction: column; align-items: center; color: #aaa;"><i class="fa fa-plus" style="font-size: 40px; margin-bottom: 10px;"></i></div><div class="image-container" ng-if="vm.attachments[\'attachmentLocation3\'] || vm.company.companyTncs[0].attachmentLocation3" style="position: relative; display: inline-block;"><img ngf-src="vm.attachments[\'attachmentLocation3\'] || (vm.company.companyTncs[0].attachmentLocation3 ? vm.rootUrl + vm.company.companyTncs[0].attachmentLocation3 : \'\')" style="width: 100%; height: 150px; object-fit: cover;"></div><button ng-click="vm.deleteImage(\'attachmentLocation3\', $event)" ng-if="vm.attachments[\'attachmentLocation3\'] || vm.company.companyTncs[0].attachmentLocation3" style="position: absolute; top: 10px; right: 10px; background-color: #e85656; color: white; border: none; padding: 7px 10px; border-radius: 50px; cursor: pointer;"><i class="fa fa-trash"></i></button></div></div></div></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Purchase Order T&C</b></label> <textarea class="form-control" style="font-family:courier;color:#333;height:150px" ng-model="vm.company.companyTncs[0].purchaseOrderTnc">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Delivery Order T&C</b></label> <textarea class="form-control" style="font-family:courier;color:#333;height:150px" ng-model="vm.company.companyTncs[0].deliveryOrderTnc">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Invoice T&C</b></label> <textarea class="form-control" style="font-family:courier;color:#333;height:150px" ng-model="vm.company.companyTncs[0].invoiceTnc">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="FTP" ng-if="vm.mode==2"><div class="row"><div class="col-lg-12"><p><b>Company Label Folder:</b></p><br><div class="row"><div class="col-md-6 col-lg-6" style="margin-right:30px"><div style="margin-bottom:5px"><a ng-click="vm.loadFTP()" style="font-family:courier;cursor:pointer"><strong>FTP Root</strong></a> <span ng-repeat="folder in vm.subfolders">&nbsp;\\&nbsp;&nbsp; <a href="" ng-click="vm.navigateFolder(folder)" style="font-family:courier;cursor:pointer"><b>{{folder}}</b></a></span></div><table class="table table-striped" style="border:1px solid #888"><tbody><tr ng-if="vm.subfolders.length!=0"><td style="width:30px"><i class="fa fa-level-up"></i></td><td><a href="" ng-click="vm.navigateBack()" style="font-family:courier;cursor:pointer">Up one level</a></td></tr><tr ng-if="vm.subfolders.length==0"><td colspan="2">---</td></tr><tr ng-repeat="folder in vm.ftp.dirList"><td style="width:30px"><i class="fa fa-folder text-primary"></i></td><td><a href="" ng-click="vm.navigateFolder(folder.filename)" style="font-family:courier;cursor:pointer">{{folder.filename}}</a></td></tr><tr ng-repeat="file in vm.ftp.fileList"><td style="width:30px"><i class="fa fa-file"></i></td><td>{{vm.cleanUpPath(file.filename)}}</td></tr><tr ng-if="vm.ftp.dirList.length==0 && vm.ftp.fileList.length==0"><td colspan="2" style="line-height:300px"><center>The folder is empty.</center></td></tr></tbody></table></div><div class="col-md-5 col-lg-5">&nbsp;<br><div style="border:1px solid #888;padding:15px;margin-top:5px;margin-bottom:30px" ng-if="vm.subfolders.length==0"><b><u>Create Folder</u>:</b><br><span style="color:#f00">Note: folder name cannot contain any special characters, symbols, and white spaces.</span><br><br><span style="font-family:courier;cursor:pointer"><b>FTP Root</b></span> <span ng-repeat="folder in vm.subfolders" style="font-family:courier;cursor:pointer">\\&nbsp;<b>{{folder}}</b></span> <span style="font-family:courier;cursor:pointer">\\</span> <input type="text" class="" ng-model="vm.newFtpFolder"> <button type="button" class="btn btn-with-icon btn-xs btn-primary" style="margin-left:10px" ng-disabled="vm.newFtpFolder==null || vm.newFtpFolder==\'\'" ng-click="vm.createFolder(vm.newFtpFolder)"><i class="fa fa-plus"></i> Create</button><br></div><div style="border:1px solid #888;padding:15px" ng-if="vm.subfolders.length!=0"><b><u>Upload File</u>:</b><br><span style="color:#f00">Note: image filename must not contain any special characters, symbols, and white spaces.</span><br><br><b>Target Folder</b>:<br><span style="display:inline-block;background:#f6fdf6;border:1px solid #aaa;padding:10px;margin-top:3px;color:#00f"><span style="font-family:courier"><b>FTP Root</b></span> <span ng-repeat="folder in vm.subfolders" style="font-family:courier;color:#00f">\\&nbsp;<b>{{folder}}</b></span></span><br><br><b>Select a Bitmap (*.bmp) file</b>:<br><span style="display:inline-block;background:#fff;border:1px solid #aaa;padding:10px;margin-top:3px"><span ng-if="vm.newFtpFile" style="color:#00f">{{vm.newFtpFile.name}}</span> <span ng-if="!vm.newFtpFile">No file selected</span><div name="file" class="btn btn-default btn-with-icon btn-xs" style="margin-left:20px" ng-if="!vm.ftpIsUploading" accept=".bmp" ngf-select="" ng-model="vm.newFtpFile" ngf-pattern="\'.bmp\'" ngf-model-invalid="errorFile" ngf-max-size="5MB"><i class="fa fa-search"></i> Choose</div><a href="" class="btn btn-default btn-with-icon btn-xs" ng-if="vm.newFtpFile && !vm.ftpIsUploading" ng-click="vm.resetFtpFile()"><i class="fa fa-ban"></i> Reset</a> <a href="" class="btn btn-primary btn-with-icon btn-xs" style="margin-left:30px" ng-if="vm.newFtpFile && !vm.ftpIsUploading" ng-click="vm.uploadFtpFile()"><i class="fa fa-upload"></i> Upload File</a> <span ng-if="vm.newFtpFile && vm.ftpIsUploading" style="margin-left:20px"><i class="fa fa-spinner fa-spin fa-fw"></i> Uploading file ...</span></span></div></div></div></div></div><p><br><br></p></uib-tab><uib-tab heading="Data Purge" ng-if="vm.mode==2"><p><big><i class="fa fa-exclamation-triangle"></i> Be careful with the operation and it may cause permanent data loss.</big></p><br><br><div class="row"><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Maintenence &gt; Data</legend></div><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Maintenence &gt; Documents</legend></div><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Knowledge &gt; Recipe Items</legend></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Raw Materials</button><spin ng-if="vm.isPurgingRawMat"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Purchase Orders</button><spin ng-if="vm.isPurgingPO"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Recipe Items</button><spin ng-if="vm.isPurgingRecipeItems"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Semi FGs</button><spin ng-if="vm.isPurgingSemiFg"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge GRN</button><spin ng-if="vm.isPurgingGRN"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Finished Goods</button><spin ng-if="vm.isPurgingFG"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Production Jobs</button><spin ng-if="vm.isPurgingProdJobs"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Suppliers</button><spin ng-if="vm.isPurgingSupplier"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Bulk-Break Jobs</button><spin ng-if="vm.isPurgingBulkBreakJob"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><br><div class="row"><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Inventory Balance</legend></div><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Inventory Movements</legend></div><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Labels</legend></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Raw Mat Inventory Balance</button><spin ng-if="vm.isPurgingRawMatInvBal"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Raw Mat Inventory Movement</button><spin ng-if="vm.isPurgingRawMatInvMvmt"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Raw Mat Labels</button><spin ng-if="vm.isPurgingRawMatLabel"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Semi FG Inventory Balance</button><spin ng-if="vm.isPurgingSemiFgInvBal"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Semi FG Inventory Movement</button><spin ng-if="vm.isPurgingSemiFgInvMvmt"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge Semi FG Labels</button><spin ng-if="vm.isPurgingSemiFgLabel"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge FG Inventory Balance</button><spin ng-if="vm.isPurgingProductInvBal"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge FG Inventory Movement</button><spin ng-if="vm.isPurgingProductInvMvmt"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" ng-click="return false" ng-disabled="vm.isPurging">Purge FG Labels</button><spin ng-if="vm.isPurgingProductLabel"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><br><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/companies/companyCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/companies/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Create Company</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.companies.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/superadmin/companies/companyList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.companyData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Company" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.companies.create" rms-check-access="superadmin.companies" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Company</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="code" style="width:200px">Code</th><th st-sort="name">Name</th><th>Billing Interval</th><th>Package Name</th><th>Branches</th><th>Active?</th><th>Billable?</th><th style="width:40px"></th></tr><tr class="sortable"><th colspan="6"><select st-search="isBillable"><option value="true">Show Billable Companies Only</option><option value="">Show All Companies</option></select></th><th class="form-inline"><select st-search="isActive"><option value="">ALL</option><option ng-repeat="c in vm.companyDataFull | unique:\'isActive\'" value="{{c.isActive | uppercase}}">{{c.isActive?\'Active\':\'Inactive\'}}</option></select></th><th class="form-inline"><select st-search="isBillable"><option value="">ALL</option><option ng-repeat="c in vm.companyDataFull | unique:\'isBillable\'" value="{{c.isBillable | uppercase}}">{{c.isBillable?\'Yes\':\'No\'}}</option></select></th><th></th></tr></thead><tbody><tr ng-if="vm.companyData.length==0"><td colspan="9">No record found.</td></tr><tr ng-repeat="item in vm.companyData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.name}}</td><td>{{item.billingIntervalType}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.serverPackageName}}</td><td>{{item.branches}}</td><td><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i><i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td><i class="fa fa-check" ng-show="item.isBillable" style="color:#0f0"></i><i class="fa fa-times" ng-show="!item.isBillable" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.companies.update({id:item.id})" rms-check-access="superadmin.companies" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/companies/companyUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/companies/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true" ng-disabled="vm.isPurging"><i class="ion ion-checkmark"></i> Save Changes</button> <button type="button" class="btn btn-danger btn-with-icon" ui-sref="superadmin.companies.list" ng-disabled="vm.isPurging"><i class="ion ion-close"></i> Discard Changes</button></div></form>');
$templateCache.put('app/pages/superadmin/companysettings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p>Please fill in the relevant company information.</p><p><small><i class="fa fa-info-circle"></i> <em>Recommended to upload a landscape image.</em></small></p><p><br></p><div class="row"><div class="col-md-4 col-lg-4"><div class="row"><div class="col-md-12 col-lg-12"><div class="form-group"><label>Company Logo</label> <img src="assets/img/company_logo_placeholder.png" alt="" style="width:100%" ng-if="picFile==null && vm.company.logoFile==\'\'"> <img ngf-src="picFile || vm.company.logoFile" alt="" style="width:100%;border: 1px solid #ccc" ng-if="picFile || vm.company.logoFile"></div></div></div><div class="row">&nbsp;</div><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile"><i class="ion ion-android-upload"></i> Upload Logo</div><a href="" ng-click="vm.resetLogo()" ng-show="picFile || vm.company.logoFile" class="btn btn-default btn-with-icon"><i class="ion ion-android-remove-circle"></i> Reset Logo</a></div><div class="row" style="text-align:center"><br><small><em>* Recommend dimension 1378px X 160px</em></small></div><div class="row">&nbsp;</div></div><div class="col-md-8 col-lg-8"><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CompanyCode.$invalid && (vm.dataForm.CompanyCode.$dirty || vm.dataForm.$submitted)}"><label>Company Code <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CompanyCode" placeholder="Company Code" ng-model="vm.company.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CompanyCode.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Status</b></label><div><toggle ng-model="vm.company.isActive" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Is Billable?</b></label><div><toggle ng-model="vm.company.isBillable" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CompanyName.$invalid && (vm.dataForm.CompanyName.$dirty || vm.dataForm.$submitted)}"><label>Company Name <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="CompanyName" placeholder="Company Name" ng-model="vm.company.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CompanyName.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Is Suspended?</b></label><div><toggle ng-model="vm.company.isSuspended" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>Company Registration No.</label> <input type="text" class="form-control" placeholder="Company Registration No." ng-model="vm.company.regNo"></div></div><div class="col-md-5 col-lg-5"><div class="form-group"><label>SST Registration No.</label> <input type="text" class="form-control" placeholder="SST Registration No." ng-model="vm.company.gstNo"></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>Address 1</label> <input type="text" class="form-control" placeholder="Address 1" ng-model="vm.company.address1"></div></div><div class="col-md-5 col-lg-5"><div class="form-group"><label>Address 2</label> <input type="text" class="form-control" placeholder="Address 2" ng-model="vm.company.address2"></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>Address 3</label> <input type="text" class="form-control" placeholder="Address 3" ng-model="vm.company.address3"></div></div><div class="col-md-5 col-lg-5"><div class="form-group"><label>Postal Code</label> <input type="text" class="form-control" placeholder="Postal Code" ng-model="vm.company.postCode"></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>State</label> <input type="text" class="form-control" placeholder="State" ng-model="vm.company.state"></div></div><div class="col-md-5 col-lg-5"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Country.$invalid && (vm.dataForm.Country.$dirty || vm.dataForm.$submitted)}"><label>Country</label><select class="form-control" name="Country" ng-model="vm.company.country" required=""><option value="MALAYSIA">MALAYSIA</option><option value="SINGAPORE">SINGAPORE</option><option value="PHILIPPINES">PHILIPPINES</option></select><span class="help-block" ng-if="vm.dataForm.$submitted && vm.dataForm.Country.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>Tel</label> <input type="text" class="form-control" placeholder="Tel" ng-model="vm.company.tel"></div></div><div class="col-md-5 col-lg-5"><div class="form-group"><label>Fax</label> <input type="text" class="form-control" placeholder="Fax" ng-model="vm.company.fax"></div></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>General Email</label> <input type="text" class="form-control" placeholder="General Email" ng-model="vm.company.email"></div></div></div><div class="row"><div class="col-lg-12"><legend style="height:32.4px;line-height:32.4px">Billing Contact</legend></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>Billing Contact</label> <input type="text" class="form-control" placeholder="General Email" ng-model="vm.company.billingContact"></div></div><div class="col-md-5 col-lg-5"><div class="form-group"><label>Billing Email</label> <input type="text" class="form-control" placeholder="General Email" ng-model="vm.company.billingEmail"></div></div></div><div class="row"><div class="col-lg-12"><legend style="height:32.4px;line-height:32.4px">Support Contact</legend></div></div><div class="row"><div class="col-md-5 col-lg-5"><div class="form-group"><label>Support Contact</label> <input type="text" class="form-control" placeholder="General Email" ng-model="vm.company.supportContact"></div></div><div class="col-md-5 col-lg-5"><div class="form-group"><label>Support Email</label> <input type="text" class="form-control" placeholder="General Email" ng-model="vm.company.supportEmail"></div></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Billing"><p><i class="fa fa-info-circle"></i> Please select the appropriate Packages.</p><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.company.serverPackageId==\'\' && vm.dataForm.$submitted}"><label>Server Package <i class="fa fa-asterisk req"></i></label><select name="ServerPackage" class="form-control" ng-disabled="true" ng-model="vm.selectedServerPackage" ng-change="vm.selectedServerPackageChanged()" ng-options="i as (i.name | uppercase) for i in vm.serverPackages"></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.company.serverPackageId==\'\'">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingContact.$invalid && (vm.dataForm.BillingContact.$dirty || vm.dataForm.$submitted)}"><label>Billing Contact <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BillingContact" placeholder="Billing Contact Person" ng-model="vm.company.billingContact" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingContact.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingEmail.$invalid && (vm.dataForm.BillingEmail.$dirty || vm.dataForm.$submitted)}"><label>Billing Email <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="BillingEmail" placeholder="Email address for Billing purpose" ng-model="vm.company.billingEmail" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingEmail.$error.required">* Required</span></div></div></div><hr><div class="row"><div class="col-md-4 col-lg-4"><i class="fa fa-info-circle"></i> Contract Period Information. Applicable for IMS Subscription.<p><br></p></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ContractStartDate.$invalid && (vm.dataForm.ContractStartDate.$dirty || vm.dataForm.$submitted)}"><label><b>Contract {{ \'START_DATE\' | translate }}</b></label><div moment-picker="vm.company.billing_ContractStartDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="ContractStartDate" autocomplete="off" ng-disabled="true" ng-model="vm.company.billing_ContractStartDate" ng-required="vm.company.isBillable"></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ContractStartDate.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ContractEndDate.$invalid && (vm.dataForm.ContractEndDate.$dirty || vm.dataForm.$submitted)}"><label><b>Contract {{ \'END_DATE\' | translate }}</b></label><div moment-picker="vm.company.billing_ContractEndDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="ContractEndDate" autocomplete="off" ng-disabled="true" ng-model="vm.company.billing_ContractEndDate" ng-required="vm.company.isBillable"></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ContractEndDate.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.NextBillStartDate.$invalid && (vm.dataForm.NextBillStartDate.$dirty || vm.dataForm.$submitted)}"><label><b>Next Billing {{ \'START_DATE\' | translate }}</b></label><div moment-picker="vm.company.billing_NextBillStartDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="NextBillStartDate" autocomplete="off" ng-model="vm.company.billing_NextBillStartDate" ng-required="vm.company.isBillable"></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.NextBillStartDate.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CreditTerm.$invalid && (vm.dataForm.CreditTerm.$dirty || vm.dataForm.$submitted)}"><label><b>Credit Term (Days)</b></label> <input type="number" class="form-control" name="CreditTerm" min="1" max="60" ng-disabled="true" ng-model="vm.company.creditTerm" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CreditTerm.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CreditTerm.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CreditTerm.$error.min">* Minimum is 1</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CreditTerm.$error.max">* Maximum is 60</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Mail"><p>Please enter the relevant information for the SMTP Server. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.setDefaultMailSettings()"><i class="fa fa-wrench"></i> Set Default</a> <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.setGMailSettings()"><i class="fa fa-wrench"></i> Set GMail</a> <a href="" class="btn btn-warning btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.testEmailSetting()"><i class="fa fa-flask"></i> Test Setting</a> <span ng-if="vm.isCheckingSMTP" style="margin-left:20px;color:#00f"><i class="fa fa-spinner fa-spin fa-fw"></i> Validating Email Settings, Please Wait...</span></p><p><small><i class="fa fa-info-circle"></i> <em>This section must be all filled</em></small><br><br></p><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MailServer.$invalid && (vm.dataForm.MailServer.$dirty || vm.dataForm.$submitted)}"><label>SMTP Server <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="MailServer" placeholder="e.g.: mail.server.com" ng-model="vm.company.mailServer" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MailServer.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MailPort.$invalid && (vm.dataForm.MailPort.$dirty || vm.dataForm.$submitted)}"><label>SMTP Port <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="MailPort" placeholder="e.g.: 2525 / 465 / 587" ng-model="vm.company.mailPort" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MailPort.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MailLogin.$invalid && (vm.dataForm.MailLogin.$dirty || vm.dataForm.$submitted)}"><label>SMTP Login <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="MailLogin" placeholder="SMTP Login" ng-model="vm.company.mailLogin" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MailLogin.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MailPassword.$invalid && (vm.dataForm.MailPassword.$dirty || vm.dataForm.$submitted)}"><label>SMTP Password <i class="fa fa-asterisk req"></i></label> <input type="password" class="form-control" name="MailPassword" placeholder="SMTP Password" ng-model="vm.company.mailPassword" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MailPassword.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label>Use SSL</label><div><toggle ng-model="vm.company.mailUseSsl" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Features"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p>Please select the features applicable to this Company. Select at least ONE (1) Feature: <i class="fa fa-asterisk req"></i></p><p><small><i class="fa fa-info-circle"></i> <em>Note that some features are company-specific</em></small></p></div></div><div class="row"><div class="col-md-12" style="padding-bottom:20px;"><a href="" class="btn btn-primary btn-with-icon btn-xs" ng-click="vm.selectAllFeatures()"><i class="ion ion-android-checkbox-outline"></i> Select All</a> <a href="" class="btn btn-primary btn-with-icon btn-xs" ng-click="vm.deselectAllFeatures()"><i class="ion ion-android-checkbox-outline-blank"></i> Deselect All</a></div></div><div class="row"><div class="col-md-12"><div ng-repeat="f in vm.features"><div ng-show="f.isParent" style="height:10px;margin-left:0px;"></div><div ng-show="f.isParent" style="height:20px;margin-left:0px;border-top:2px dotted #aaa"></div><div style="line-height:30px"><input type="checkbox" name="Feature" style="float:left;cursor:pointer;width:25px;height:25px" checklist-model="vm.selectedFeatures" checklist-value="f" checklist-change="vm.dataForm.Feature.$setValidity(\'required\', vm.selectedFeatures.length > 0)" ng-required="!vm.selectedFeatures.length"> <span ng-show="f.isParent" style="margin-left:8px;color:#7e3e00"><b>{{ f.name | uppercase }}</b></span> <span ng-show="!f.isParent" style="margin-left:8px">&nbsp;<i class="fa fa-long-arrow-right"></i> &nbsp;&nbsp;{{ f.name }}</span></div></div></div></div><div class="row"><div class="col-md-12"><p><div class="col-md-12" ng-class="{\'has-error\': vm.dataForm.$submitted && vm.dataForm.Feature.$invalid }"><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Feature.$invalid">* Required at least ONE (1) Feature</span></div></p></div></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Settings"><p><i class="fa fa-info-circle"></i> These are the company settings for various modules.</p><p><br></p><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LanguageCode.$invalid && (vm.dataForm.LanguageCode.$dirty || vm.dataForm.$submitted)}"><label><b>Language</b></label><select class="form-control" name="LanguageCode" ng-model="vm.company.languageCode" required=""><option value="">-- Select a Language --</option><option value="ar">Arabic</option><option value="cn">Chinese</option><option value="en">English</option><option value="kr">Korean</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LanguageCode.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LanguageDirection.$invalid && (vm.dataForm.LanguageDirection.$dirty || vm.dataForm.$submitted)}"><label><b>Language Direction</b></label><select class="form-control" name="LanguageDirection" ng-model="vm.company.languageDirection" required=""><option value="">-- Select a Direction --</option><option value="left">Left-to-Right (LTR)</option><option value="right">Right-to-Left (RTL)</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LanguageDirection.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CurrencyCode.$invalid && (vm.dataForm.LanguageCode.$dirty || vm.dataForm.$submitted)}"><label><b>Currency</b></label><select class="form-control" name="CurrencyCode" ng-options="c as (\'[\' + c.code + \'] \' + c.name) for c in vm.currencyList" ng-model="vm.selectedCurrency" ng-change="vm.selectedCurrencyChanged()" required=""><option value="">-- Select a Currency --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CurrencyCode.$error.required">* Required</span></div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><div class="btn" style="width:100px" ng-class="{\'btn-success\': vm.company.setting_Company_DurianMode, \'btn-danger\': !vm.company.setting_Company_DurianMode }">{{ (vm.company.setting_Company_DurianMode ? \'Yes\' : \'No\') }}</div></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Durian Mode</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Durian Operation Workflow.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><div class="btn" style="width:100px" ng-class="{\'btn-success\': vm.company.setting_Company_SeafoodMode, \'btn-danger\': !vm.company.setting_Company_SeafoodMode }">{{ (vm.company.setting_Company_SeafoodMode ? \'Yes\' : \'No\') }}</div></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Seafood Mode</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Seafood Supplier Operation Workflow.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><div class="btn" style="width:100px" ng-class="{\'btn-success\': vm.company.setting_Company_ButcherMode, \'btn-danger\': !vm.company.setting_Company_ButcherMode }">{{ (vm.company.setting_Company_ButcherMode ? \'Yes\' : \'No\') }}</div></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Butcher Mode</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Meat Supplier Operation Workflow.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_Company_EnableFoodSafetyCompliance" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Food Safety Mode</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Food Safety Features &amp; Compliances.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_StockRequest_MultiSplitItemType" ng-change="vm.setting_StockRequest_MultiSplitItemType_Changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Stock Request</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Split Request Items by Item Type (Raw Mat / Semi FG / FG) upon submission.</div></div></div><div class="row" ng-if="vm.compSetting.setting_StockRequest_MultiSplitItemType"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_StockRequest_MultiSplitCatAndSubCat" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Stock Request</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Further split Request Items by Item Category and Sub-Category upon submission.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_StockRequest_ShowPriceForFranchisee" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Stock Request</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable display stock request item price for franchise</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Job_StockOutUponConfirmation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Production Job</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto stock-out Raw Items upon job confirmation.</div></div></div><div class="row" style="margin-bottom:15px" ng-if="vm.company.setting_Job_StockOutUponConfirmation"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:150px;height:50px;padding-right:0px;line-height:50px;text-align:right;background:#eee"><i class="fa fa-archive"></i> <em>Item Storage:</em></div><div class="col-md-5 col-lg-5" style="height:50px;background:#eee;padding-top:8px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ItemStorageId.$invalid && (vm.dataForm.ItemStorageId.$dirty || vm.dataForm.$submitted)}"><select name="ItemStorageId" class="form-control" ng-change="vm.selectedItemStorageChanged($item)" ng-if="vm.company.setting_Job_StockOutUponConfirmation" ng-model="vm.selectedItemStorage" ng-options="i as (i.extendedDescription | uppercase) for i in vm.itemStorageList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ItemStorageId.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Job_StockInUponCompletion" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Production Job</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto stock-In Finished Products upon job completion.</div></div></div><div class="row" style="margin-bottom:15px" ng-if="vm.company.setting_Job_StockInUponCompletion"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:150px;height:50px;padding-right:0px;line-height:50px;text-align:right;background:#eee"><i class="fa fa-archive"></i> <em>Product Storage:</em></div><div class="col-md-5 col-lg-5" style="height:50px;background:#eee;padding-top:8px"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ProductStorageId.$invalid && (vm.dataForm.ProductStorageId.$dirty || vm.dataForm.$submitted)}"><select name="ProductStorageId" class="form-control" ng-change="vm.selectedProductStorageChanged($item)" ng-if="vm.company.setting_Job_StockInUponCompletion" ng-model="vm.selectedProductStorage" ng-options="i as (i.extendedDescription | uppercase) for i in vm.productStorageList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ProductStorageId.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_Job_CompleteJobWithFullyStockedOut" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Production Job</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Production Jobs can only be Completed if all ingredients are fully stocked out.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_BulkBreak_AutoPrintLabel" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Bulk-Break Job</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto print label for result items.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_BulkBreak_AutoStockIn" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Bulk-Break Job</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto stock-in after label printed.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Grn_EnableAutoUpdateUom" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Goods Receiving</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto update Raw Material UOM settings based on Label Printing selected UOM option.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Grn_StockInUponConfirmation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Goods Receiving</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto stock-in upon confirmation (Normal Mode).</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Grn_QuickModeAutoStockIn" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Goods Receiving</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto stock-in upon label printed (Quick Mode).</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Grn_EnableLabelPrinting" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Goods Receiving</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Label Printing.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_PurchaseOrder_UseLowerPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Override the default supplier and select the lowest price.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_PurchaseOrder_WriteOffUponGrn" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto write-off remaining balance upon GRN confirmation.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_PurchaseOrder_EnableBulkCreationByBranch" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Bulk creation of P.O. according requester\'s branch.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_PurchaseOrder_EnableDepartmentalized" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Bulk creation of P.O. according requester\'s department.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_PurchaseOrder_UseSupplierDescription" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Use Raw Material\'s Supplier Item Description in P.O.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_PurchaseOrder_DirectPriceUpdate" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Price update in the P.O. Items, will also permanently update the supplier\'s pricing of the Raw Material.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_PurchaseOrder_EnabledLandedCost" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Purchase Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Landed Cost.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_SalesOrder_UsePax" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Sales Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Add finished goods to S.O. using no. of Pax instead of UOMs.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_SalesOrder_DirectTriggerJobCreation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Sales Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Allow direct trigger Production Job creation</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_SalesOrder_EnableCutOffTime" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Sales Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enforce Cut-Off Time control.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_SalesOrder_EnableInvoice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Sales Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Generating Invoice from Sales Order</div></div></div><div class="row" ng-if="vm.company.setting_SalesOrder_EnableCutOffTime"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div style="line-height:32.4px;margin-left:34px;margin-top:-15px"><div class="row"><div class="col-lg-3" style="background:#eee">Cut-Off Hour:</div><div class="col-lg-3" style="background:#eee">Cut-Off Minute:</div></div><div class="row" style="margin-bottom:10px"><div class="col-lg-3" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SalesOrderCutOffHour.$invalid && (vm.dataForm.SalesOrderCutOffHour.$dirty || vm.dataForm.$submitted)}"><select name="SalesOrderCutOffHour" class="form-control input-sm" ng-change="vm.selectedSOCutOffHourChanged()" ng-model="vm.selectedSOCutOffHour" ng-options="i as i.name for i in vm.hourList" ng-required="vm.company.setting_SalesOrder_EnableCutOffTime"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SalesOrderCutOffHour.$error.required">* Required</span></div></div><div class="col-lg-3" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SalesOrderCutOffMinute.$invalid && (vm.dataForm.SalesOrderCutOffMinute.$dirty || vm.dataForm.$submitted)}"><select name="SalesOrderCutOffMinute" class="form-control input-sm" ng-change="vm.selectedSOCutOffMinuteChanged()" ng-model="vm.selectedSOCutOffMinute" ng-options="i as i.name for i in vm.minuteList" ng-required="vm.company.setting_SalesOrder_EnableCutOffTime"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SalesOrderCutOffMinute.$error.required">* Required</span></div></div></div></div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_DeliveryOrder_DirectDO" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Allowed to create DO without selecting any Sales Order / Stock Transfer.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_DeliveryOrder_AdvancedMode" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Turn on Advanced Mode (Complete control mechanism).</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_DeliveryOrder_AdvancedModeAutoDriverVerification" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto perform driver verification after all items are stocked out (in Advanced Mode only).</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_DeliveryOrder_PrintPartialLabel" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable printing label during stock-out partial quantity from original Label.</div></div></div><div class="row" ng-if="vm.company.setting_DeliveryOrder_PrintPartialLabel"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div style="line-height:32.4px;margin-left:34px;margin-top:-15px"><div class="row"><div class="col-lg-2" style="background:#eee;padding:10px;"><toggle ng-model="vm.company.setting_DeliveryOrder_PrintPartialLabel_DOSO" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div><div class="col-lg-8" style="background:#eee;padding:10px;">Enable for Delivery Order transferred from Sales Order.</div></div><div class="row"><div class="col-lg-2" style="background:#eee;padding:10px;"><toggle ng-model="vm.company.setting_DeliveryOrder_PrintPartialLabel_DOST" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div><div class="col-lg-8" style="background:#eee;padding:10px;">Enable for Delivery Order transferred from Stock Transfer.</div></div><div class="row"><div class="col-lg-2" style="background:#eee;padding:10px;"><toggle ng-model="vm.company.setting_DeliveryOrder_PrintPartialLabel_DOXSOST" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div><div class="col-lg-8" style="background:#eee;padding:10px;">Enable for Normal Delivery Order .</div></div></div><br></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_DeliveryOrder_StockOutUponConfirmation" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Auto stock-out Finished Goods upon Delivery Order approval.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_DeliveryOrder_EnableCutOffTime" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enforce Cut-Off Time control.</div></div></div><div class="row" ng-if="vm.company.setting_DeliveryOrder_EnableCutOffTime"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div style="line-height:32.4px;margin-left:34px;margin-top:-15px"><div class="row"><div class="col-lg-3" style="background:#eee">Cut-Off Hour:</div><div class="col-lg-3" style="background:#eee">Cut-Off Minute:</div></div><div class="row" style="margin-bottom:10px"><div class="col-lg-3" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CutOffHour.$invalid && (vm.dataForm.CutOffHour.$dirty || vm.dataForm.$submitted)}"><select name="CutOffHour" class="form-control input-sm" ng-change="vm.selectedDOCutOffHourChanged()" ng-model="vm.selectedDOCutOffHour" ng-options="i as i.name for i in vm.hourList" ng-required="vm.company.setting_DeliveryOrder_EnableCutOffTime"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CutOffHour.$error.required">* Required</span></div></div><div class="col-lg-3" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CutOffMinute.$invalid && (vm.dataForm.CutOffMinute.$dirty || vm.dataForm.$submitted)}"><select name="CutOffMinute" class="form-control input-sm" ng-change="vm.selectedDOCutOffMinuteChanged()" ng-model="vm.selectedDOCutOffMinute" ng-options="i as i.name for i in vm.minuteList" ng-required="vm.company.setting_DeliveryOrder_EnableCutOffTime"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CutOffMinute.$error.required">* Required</span></div></div></div></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_DeliveryOrder_EnableDeliveryWindow" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Delivery Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enforce Customer\'s Delivery Window.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Stock_AllowNegativeBalance" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Stock Inventory</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Allow negative balance (Items &amp; Products).</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Stock_EnableCatchWeightManagement" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Stock Inventory</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Catch-Weight Management (CWM).</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_StockCount_EnabledNonBlindCount" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Stock Inventory</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Enable Non-Blind Count during Stock Count.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Recipe_UseLainoxNaboo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Using Lainox Naboo</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Whether this is Lainox Naboo\'s customer.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Recipe_UseFoodPortioningTable" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Using Food Portioning Table</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Applicable for Sales Order &amp; Job Production product quantity calculation.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.setting_Recipe_UseShortDescription" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:120%"><b>Using Raw Material Short Description</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Applicable for Raw Material Maintenance for displaying Short Description on Recipe Card and Product Label.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.setting_WorkOrder_ManualChargeInput" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Work Order</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;For Aftersales Work Order, enable manual Invoice & GST amount input.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group" style="line-height:60%"><input type="number" class="form-control" ng-model="vm.compSetting.setting_AssetScheduleByDay"><br><center>Days</center></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Asset Management</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp; System will begin sending email reminder from the number of Days before the scheduled maintenance date.</div></div></div><p><br></p><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group" style="line-height:60%"><input type="number" class="form-control" ng-model="vm.compSetting.setting_ExpiryCertByMonth"><br><center>Months</center></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Certificate Management</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp; System will begin sending email reminder from the number of Months before the expiry date of the certificates.</div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Integration"><p><i class="fa fa-info-circle"></i> For 3rd Party software integration.</p><br><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.IntegrationMode.$invalid && (vm.dataForm.IntegrationMode.$dirty || vm.dataForm.$submitted)}"><label><b>Integration Mode</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="IntegrationMode" ng-options="c as c.name for c in vm.integrationModes track by c.id" ng-model="vm.integrationModes.selected" ng-change="vm.selectIntegrationMode(vm.integrationModes.selected)" required=""><option value="">-- Select a Mode --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.IntegrationMode.$error.required">* Required</span></div></div></div><br><br><fieldset ng-if="vm.company.integrationMode==1"><legend>SysPro ERP Parameters</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProWebServiceUrl.$invalid && (vm.dataForm.SysProWebServiceUrl.$dirty || vm.dataForm.$submitted)}"><label><b>Web Service URI</b></label> <input type="text" class="form-control" name="SysProWebServiceUrl" placeholder="e.g.: http://192.168.1.1/sysprowebservices/" ng-model="vm.company.syspro_WebServiceUrl" ng-required="vm.company.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProWebServiceUrl.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProUsername.$invalid && (vm.dataForm.SysProUsername.$dirty || vm.dataForm.$submitted)}"><label><b>Operator Username</b></label> <input type="text" class="form-control" name="SysProUsername" ng-model="vm.company.syspro_Username" ng-required="vm.company.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProUsername.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProSupplierBankCode.$invalid && (vm.dataForm.SysProSupplierBankCode.$dirty || vm.dataForm.$submitted)}"><label><b>Default Supplier Bank Code</b></label> <input type="text" class="form-control" name="SysProSupplierBankCode" ng-model="vm.company.syspro_SupplierBankCode" ng-required="vm.company.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProSupplierBankCode.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProPassword.$invalid && (vm.dataForm.SysProPassword.$dirty || vm.dataForm.$submitted)}"><label><b>Operator Password</b></label> <input type="password" class="form-control" name="SysProPassword" ng-model="vm.company.syspro_Password" ng-required="vm.company.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProPassword.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProSupplierBranchCode.$invalid && (vm.dataForm.SysProSupplierBranchCode.$dirty || vm.dataForm.$submitted)}"><label><b>Default Supplier Branch Code</b></label> <input type="text" class="form-control" name="SysProSupplierBranchCode" ng-model="vm.company.syspro_SupplierBranchCode" ng-required="vm.company.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProSupplierBranchCode.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SysProCompanyId.$invalid && (vm.dataForm.SysProCompanyId.$dirty || vm.dataForm.$submitted)}"><label><b>Company ID</b></label> <input type="text" class="form-control" name="SysProCompanyId" ng-model="vm.company.syspro_CompanyId" ng-required="vm.company.integrationMode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SysProCompanyId.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group"><label><b>Company Password</b></label> <input type="password" class="form-control" name="Password" ng-model="vm.company.syspro_CompanyPassword"></div></div></div></fieldset><fieldset ng-if="vm.company.integrationMode==2"><legend>AutoCount Accounting Parameters</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AutoCountWebServiceUrl.$invalid && (vm.dataForm.AutoCountWebServiceUrl.$dirty || vm.dataForm.$submitted)}"><label><b>Web Service URL</b></label> <input type="text" class="form-control" name="AutoCountWebServiceUrl" placeholder="e.g.: https://clientcompany.ddns.net/cmxatcint/api/v1/" ng-model="vm.company.autoCount_WebServiceUrl" ng-required="vm.company.integrationMode==2"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AutoCountWebServiceUrl.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AutoCountUsername.$invalid && (vm.dataForm.AutoCountUsername.$dirty || vm.dataForm.$submitted)}"><label><b>Username</b></label> <input type="text" class="form-control" name="AutoCountUsername" ng-model="vm.company.autoCount_Username" ng-required="vm.company.integrationMode==2"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AutoCountUsername.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AutoCountPassword.$invalid && (vm.dataForm.AutoCountPassword.$dirty || vm.dataForm.$submitted)}"><label><b>Password</b></label> <input type="password" class="form-control" name="AutoCountPassword" ng-model="vm.company.autoCount_Password" ng-required="vm.company.integrationMode==2"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AutoCountPassword.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">&nbsp;<br><a href="" class="btn btn-primary" ng-click="vm.testIntegrationAutoCount()">Validate Connection</a></div></div><hr><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.autoCount_EnableSync_Franchisee" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Franchisee Data (SO, PO, DO, Invoice, Inventory)</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_Debtor" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Debtors</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_Creditor" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Creditors</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_Warehouse" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Branches</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_RawMat" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Materials</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_RawMat"><div class="form-group"><div><toggle ng-model="vm.compSetting.autoCount_EnableSync_RawMat_StandardCost" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_RawMat"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Material Standard Cost</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_RawMat"><div class="form-group"><div><toggle ng-model="vm.compSetting.autoCount_EnableSync_RawMat_StandardSellingPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_RawMat"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Material Standard Selling Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_SemiFg" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Semi F.G.</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_SemiFg"><div class="form-group"><div><toggle ng-model="vm.compSetting.autoCount_EnableSync_SemiFg_StandardSellingPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_SemiFg"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Semi F.G. Standard Selling Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_Product" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Finished Goods</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_Product"><div class="form-group"><div><toggle ng-model="vm.compSetting.autoCount_EnableSync_Product_StandardSellingPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_Product"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Finished Goods Standard Selling Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_Inventory" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Inventory</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_SalesOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Sales Order</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_SalesOrder"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_SyncBack_SalesOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_SalesOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Sales Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_SalesOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_SyncItemPrice_SalesOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_SalesOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Sales Order Item Price</b></div></div><p><br></p></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_PurchaseOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Purchase Orders</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_PurchaseOrder"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_SyncBack_PurchaseOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_PurchaseOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Purchase Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_PurchaseOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_EnableSync_PurchaseTaxCode" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_PurchaseOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Purchase Order Item Tax Code</b></div></div><p><br></p></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_PurchaseOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.autoCount_EnableSync_PurchaseInvoice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_PurchaseOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Purchase Invoice when PO is finalized.</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_EnableSync_DeliveryOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Delivery Orders</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_DeliveryOrder"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_SyncBack_DeliveryOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_DeliveryOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Delivery Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.company.autoCount_EnableSync_DeliveryOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_SyncItemPrice_DeliveryOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.company.autoCount_EnableSync_DeliveryOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Delivery Order Item Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_EnableSync_InvoiceNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Invoices</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.autocount_EnableSync_InvoiceNo"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_SyncBack_InvoiceNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.autocount_EnableSync_InvoiceNo"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Invoice No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.autocount_EnableSync_InvoiceNo"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_EnableSync_AddInvoice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.autocount_EnableSync_InvoiceNo"><div class="form-group" style="line-height:32.4px"><b>Enable Create Invoice</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.autocount_EnableSync_InvoiceNo"><div class="form-group"><div><toggle ng-model="vm.compSetting.autocount_EnableSync_UpdateInvoice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.autocount_EnableSync_InvoiceNo"><div class="form-group" style="line-height:32.4px"><b>Enable Update Invoice</b></div></div></div><hr><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_SalesOrder_CheckCreditLimitExceed" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>S.O. - Check Credit Limit</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Check Credit Limit When Confirming Sales Order.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_DeliveryOrder_CheckCreditLimitExceed" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>D.O. - Check Credit Limit</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Check Credit Limit When Confirming Delivery Order.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.company.autoCount_DOQM_CheckCreditLimitExceed" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>D.O.Q.M - Check Credit Limit</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Check Credit Limit When Finalizing D.O. Quick Mode.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Global Sync Retry Interval</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Interval (minute) between each synchronization attempt.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div style="line-height:32.4px;margin-left:34px;margin-top:-15px"><div class="row"><div class="col-lg-4" style="background:#eee">Interval (Minutes):</div></div><div class="row" style="margin-bottom:10px"><div class="col-lg-4" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.GlobalSyncRetryInterval.$invalid && (vm.dataForm.GlobalSyncRetryInterval.$dirty || vm.dataForm.$submitted)}"><select name="GlobalSyncRetryInterval" class="form-control input-sm" ng-change="vm.selectedAutocountGlobalSyncRetryIntervalChanged()" ng-model="vm.selectedAutocountGlobalSyncRetryInterval" ng-options="i as i.name for i in vm.intervalList" ng-required="vm.company.integrationMode==2"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.GlobalSyncRetryInterval.$error.required">* Required</span></div></div></div></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"><div class="form-group" style="line-height:32.4px"><b>Inventory Sync Time</b></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group" style="line-height:32.4px"><i class="fa fa-angle-double-right"></i> &nbsp;&nbsp;Scheduled Time for Inventory Synchronization.</div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:200px;padding-right:0px"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div style="line-height:32.4px;margin-left:34px;margin-top:-15px"><div class="row"><div class="col-lg-6" style="background:#eee">Sync Interval: <i class="fa fa-asterisk req" ng-if="vm.company.integrationMode==2 && vm.company.autoCount_EnableSync_Inventory"></i></div></div><div class="row" style="margin-bottom:10px"><div class="col-lg-6" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InventorySyncInterval.$invalid && (vm.dataForm.InventorySyncInterval.$dirty || vm.dataForm.$submitted)}"><select name="InventorySyncInterval" class="form-control input-sm" ng-change="vm.selectedAutocountInvSyncIntervalChanged()" ng-model="vm.selectedAutocountInvSyncInterval" ng-options="i as i.name for i in vm.periodList" ng-required="vm.company.integrationMode==2 && vm.company.autoCount_EnableSync_Inventory"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InventorySyncInterval.$error.required">* Required</span></div></div></div><div class="row"><div class="col-lg-3" style="background:#eee">Sync Hour: <i class="fa fa-asterisk req" ng-if="vm.company.integrationMode==2 && vm.company.autoCount_EnableSync_Inventory"></i></div><div class="col-lg-3" style="background:#eee">Sync Minute: <i class="fa fa-asterisk req" ng-if="vm.company.integrationMode==2 && vm.company.autoCount_EnableSync_Inventory"></i></div></div><div class="row" style="margin-bottom:10px"><div class="col-lg-3" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InventorySyncHour.$invalid && (vm.dataForm.InventorySyncHour.$dirty || vm.dataForm.$submitted)}"><select name="InventorySyncHour" class="form-control input-sm" ng-change="vm.selectedAutocountInvSyncHourChanged()" ng-model="vm.selectedAutocountInvSyncHour" ng-options="i as i.name for i in vm.hourList" ng-required="vm.company.integrationMode==2 && vm.company.autoCount_EnableSync_Inventory"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InventorySyncHour.$error.required">* Required</span></div></div><div class="col-lg-3" style="background:#eee"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InventorySyncMinute.$invalid && (vm.dataForm.InventorySyncMinute.$dirty || vm.dataForm.$submitted)}"><select name="InventorySyncMinute" class="form-control input-sm" ng-change="vm.selectedAutocountInvSyncMinuteChanged()" ng-model="vm.selectedAutocountInvSyncMinute" ng-options="i as i.name for i in vm.minuteList" ng-required="vm.company.integrationMode==2 && vm.company.autoCount_EnableSync_Inventory"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InventorySyncMinute.$error.required">* Required</span></div></div></div></div></div></div></fieldset><fieldset ng-if="vm.company.integrationMode==8"><legend>SQL Accounting Parameters</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLWebServiceUrl.$invalid && (vm.dataForm.SQLWebServiceUrl.$dirty || vm.dataForm.$submitted)}"><label><b>Web Service URL</b></label> <input type="text" class="form-control" name="SQLWebServiceUrl" placeholder="e.g.: https://clientcompany.ddns.net/cmxatcint/api/v1/" ng-model="vm.compSetting.sqL_WebServiceUrl" ng-required="vm.company.integrationMode==8"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLWebServiceUrl.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLUsername.$invalid && (vm.dataForm.SQLUsername.$dirty || vm.dataForm.$submitted)}"><label><b>Username</b></label> <input type="text" class="form-control" name="SQLUsername" ng-model="vm.compSetting.sqL_Username" ng-required="vm.company.integrationMode==8"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLUsername.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SQLPassword.$invalid && (vm.dataForm.SQLPassword.$dirty || vm.dataForm.$submitted)}"><label><b>Password</b></label> <input type="password" class="form-control" name="SQLPassword" ng-model="vm.compSetting.sqL_Password" ng-required="vm.company.integrationMode==8"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SQLPassword.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">&nbsp;<br><a href="" class="btn btn-primary" ng-click="vm.testIntegrationSQL()">Validate Connection</a></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.sqL_DCFPath.$invalid && (vm.dataForm.sqL_DCFPath.$dirty || vm.dataForm.$submitted)}"><label><b>DCF File Path</b></label> <input type="text" class="form-control" name="DCFPath" ng-model="vm.compSetting.sqL_DCFPath" ng-required="vm.company.integrationMode==8"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.sqL_DCFPath.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DatabaseName.$invalid && (vm.dataForm.DatabaseName.$dirty || vm.dataForm.$submitted)}"><label><b>Database Name</b></label> <input type="text" class="form-control" name="DatabaseName" ng-model="vm.compSetting.sqL_DatabaseName" ng-required="vm.company.integrationMode==8"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DatabaseName.$error.required">* Required</span></div></div></div><hr><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_Franchisee" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Franchisee Data (SO, PO, DO, Invoice, Inventory)</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_Debtor" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Debtors</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_Creditor" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Creditors</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_RawMat" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Materials</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_RawMat"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_RawMat_StandardCost" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_RawMat"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Material Standard Cost</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_RawMat"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_RawMat_StandardSellingPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_RawMat"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Material Standard Selling Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_SemiFg" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Semi F.G.</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_SemiFg"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_SemiFg_StandardSellingPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_SemiFg"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Semi F.G. Standard Selling Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_Product" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Finished Goods</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_Product"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_Product_StandardSellingPrice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_Product"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Finished Goods Standard Selling Price</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_SalesOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Sales Order</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_SalesOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_SyncBack_SalesOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_SalesOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Sales Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_PurchaseOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Purchase Orders</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_PurchaseOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_SyncBack_PurchaseOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_PurchaseOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Purchase Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_PurchaseOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_PurchaseInvoice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_PurchaseOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Purchase Invoice when PO is finalized.</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_DeliveryOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Delivery Orders</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_DeliveryOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_SyncBack_DeliveryOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_DeliveryOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Delivery Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_EnableSync_Invoice" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Invoices</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.sqL_EnableSync_Invoice"><div class="form-group"><div><toggle ng-model="vm.compSetting.sqL_SyncBack_InvoiceNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.sqL_EnableSync_Invoice"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Invoice No#</b></div></div></div></fieldset><fieldset ng-if="vm.company.integrationMode==7"><legend>IDB ERP Parameters</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.idB_WebServiceUrl.$invalid && (vm.dataForm.idB_WebServiceUrl.$dirty || vm.dataForm.$submitted)}"><label><b>Web Service URL</b></label> <input type="text" class="form-control" name="idB_WebServiceUrl" placeholder="e.g.: https://clientcompany.ddns.net/cmxatcint/api/v1/" ng-model="vm.compSetting.idB_WebServiceUrl" ng-required="vm.company.integrationMode==7"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.idB_WebServiceUrl.$error.required">* Required</span></div></div></div><hr><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.idB_EnableSync_Creditor" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Creditors</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.idB_EnableSync_RawMat" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Raw Materials</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.idB_EnableSync_PurchaseOrder" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync Purchase Orders</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.idB_EnableSync_PurchaseOrder"><div class="form-group"><div><toggle ng-model="vm.compSetting.idB_SyncBack_PurchaseOrderNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.idB_EnableSync_PurchaseOrder"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back Purchase Order No#</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"><div class="form-group"><div><toggle ng-model="vm.compSetting.idB_EnableSync_Grn" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group" style="line-height:32.4px"><b>Enable Sync GRN when PO is Finalized.</b></div></div></div><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px"></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1" style="width:130px" ng-if="vm.compSetting.idB_EnableSync_Grn"><div class="form-group"><div><toggle ng-model="vm.compSetting.idB_SyncBack_GrnNo" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" ng-if="vm.compSetting.idB_EnableSync_Grn"><div class="form-group" style="line-height:32.4px"><b>Enable Sync-Back GRN No#</b></div></div></div></fieldset><fieldset ng-if="vm.company.integrationMode==3"><legend>FNB System Parameters</legend><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FnbSysWebServiceUrl.$invalid && (vm.dataForm.FnbSysWebServiceUrl.$dirty || vm.dataForm.$submitted)}"><label><b>Web Service URI</b></label> <input type="text" class="form-control" name="FnbSysWebServiceUrl" ng-model="vm.company.fnbSystem_WebServiceUrl" ng-required="vm.company.integrationMode==3"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FnbSysWebServiceUrl.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FnbSysPassword.$invalid && (vm.dataForm.FnbSysPassword.$dirty || vm.dataForm.$submitted)}"><label><b>Password</b></label> <input type="password" class="form-control" name="FnbSysPassword" ng-model="vm.company.fnbSystem_Password" ng-required="vm.company.integrationMode==3"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FnbSysPassword.$error.required">* Required</span></div></div></div></fieldset><fieldset ng-if="vm.company.integrationMode==4"><legend>SAP Hybris C4C Parameters</legend><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SAPC4CTenantId.$invalid && (vm.dataForm.SAPC4CTenantId.$dirty || vm.dataForm.$submitted)}"><label><b>Tenant ID</b></label> <input type="text" class="form-control" name="SAPC4CTenantId" ng-model="vm.company.sapC4C_TenantId" ng-required="vm.company.integrationMode==4"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SAPC4CTenantId.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SAPC4CUsername.$invalid && (vm.dataForm.SAPC4CUsername.$dirty || vm.dataForm.$submitted)}"><label><b>Username</b></label> <input type="text" class="form-control" name="SAPC4CUsername" ng-model="vm.company.sapC4C_Username" ng-required="vm.company.integrationMode==4"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SAPC4CUsername.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SAPC4CPassword.$invalid && (vm.dataForm.SAPC4CPassword.$dirty || vm.dataForm.$submitted)}"><label><b>Password</b></label> <input type="password" class="form-control" name="SAPC4CPassword" ng-model="vm.company.sapC4C_Password" ng-required="vm.company.integrationMode==4"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SAPC4CPassword.$error.required">* Required</span></div></div></div></fieldset><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="POS Integration"><p><i class="fa fa-info-circle"></i> Settings for POS Integration</p><br><p></p><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.POSIntegrationMode.$invalid && (vm.dataForm.POSIntegrationMode.$dirty || vm.dataForm.$submitted)}"><label><b>POS Integration Mode</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="POSIntegrationMode" ng-options="c as c.name for c in vm.posIntModes track by c.id" ng-model="vm.posIntModes.selected" ng-change="vm.selectPOSIntegrationMode(vm.posIntModes.selected)" required=""><option value="">-- Select a Mode --</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.POSIntegrationMode.$error.required">* Required</span></div></div></div><div class="row" ng-if="vm.compSetting.poS_IntegrationMode==1"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Enable</b></label><div><toggle ng-model="vm.compSetting.setting_EnableFTP" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-if="vm.compSetting.poS_IntegrationMode==1"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.POS_FTP_WebURL.$invalid && (vm.dataForm.POS_FTP_WebURL.$dirty || vm.dataForm.$submitted)}"><label><b>FTP Server URL</b> <i class="fa fa-asterisk req" ng-if="vm.compSetting.setting_EnableFTP"></i></label> <input type="text" class="form-control" name="POS_FTP_WebURL" ng-model="vm.compSetting.ftP_WebServiceUrl" ng-required="vm.compSetting.poS_IntegrationMode==1 && vm.compSetting.setting_EnableFTP"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.POS_FTP_WebURL.$error.required">* Required</span></div></div></div><div class="row" ng-if="vm.compSetting.poS_IntegrationMode==1"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.POS_FTP_Username.$invalid && (vm.dataForm.POS_FTP_Username.$dirty || vm.dataForm.$submitted)}"><label><b>FTP Username</b> <i class="fa fa-asterisk req" ng-if="vm.compSetting.setting_EnableFTP"></i></label> <input type="text" class="form-control" name="POS_FTP_Username" ng-model="vm.compSetting.ftP_Username" ng-required="vm.compSetting.poS_IntegrationMode==1 && vm.compSetting.setting_EnableFTP"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.POS_FTP_Username.$error.required">* Required</span></div></div></div><div class="row" ng-if="vm.compSetting.poS_IntegrationMode==1"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.POS_FTP_Password.$invalid && (vm.dataForm.POS_FTP_Password.$dirty || vm.dataForm.$submitted)}"><label><b>FTP Password</b> <i class="fa fa-asterisk req" ng-if="vm.compSetting.setting_EnableFTP"></i></label> <input type="text" class="form-control" name="POS_FTP_Password" ng-model="vm.compSetting.ftP_Password" ng-required="vm.compSetting.poS_IntegrationMode==1 && vm.compSetting.setting_EnableFTP"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.POS_FTP_Password.$error.required">* Required</span></div></div></div><p><br></p><p><br></p></uib-tab><uib-tab heading="Terms & Conditions"><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Sales Order T&C</b></label> <textarea class="form-control" style="font-family:courier;color:#333;height:150px" ng-model="vm.company.companyTncs[0].salesOrderTnc">\n\t\t\t\t\t\t\t\t</textarea></div></div><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Upload up to 3 photos.</b></label><div class="row"><div class="col-md-4"><div class="upload-box" style="width: 100%; height: 150px; border: 2px dashed #ccc; display: flex; justify-content: center; align-items: center; cursor: pointer; position: relative; text-align: center;"><div class="upload-content" ng-if="!vm.attachments[\'attachmentLocation1\'] && !vm.company.companyTncs[0].attachmentLocation1" ngf-select="vm.setUploadAttachmentImage(attachment1File, \'attachmentLocation1\')" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ng-model="attachment1File" name="file" ng-disabled="vm.attachments[\'attachmentLocation1\'] || vm.company.companyTncs[0].attachmentLocation1" ngf-model-invalid="errorFile" style="display: flex; flex-direction: column; align-items: center; color: #aaa;"><i class="fa fa-plus" style="font-size: 40px; margin-bottom: 10px;"></i></div><div class="image-container" ng-if="vm.attachments[\'attachmentLocation1\'] || vm.company.companyTncs[0].attachmentLocation1" style="position: relative; display: inline-block;"><img ngf-src="vm.attachments[\'attachmentLocation1\'] || (vm.company.companyTncs[0].attachmentLocation1 ? vm.rootUrl + vm.company.companyTncs[0].attachmentLocation1 : \'\')" style="width: 100%; height: 150px; object-fit: cover;"></div><button ng-click="vm.deleteImage(\'attachmentLocation1\', $event)" ng-if="vm.attachments[\'attachmentLocation1\'] || vm.company.companyTncs[0].attachmentLocation1" style="position: absolute; top: 10px; right: 10px; background-color: #e85656; color: white; border: none; padding: 7px 10px; border-radius: 50px; cursor: pointer;"><i class="fa fa-trash"></i></button></div></div><div class="col-md-4"><div class="upload-box" ngf-select="vm.setUploadAttachmentImage(attachment2File, \'attachmentLocation2\')" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ng-model="attachment2File" name="file" ngf-model-invalid="errorFile" ng-if="!vm.lockUploadButton" style="width: 100%; height: 150px; border: 2px dashed #ccc; display: flex; justify-content: center; align-items: center; cursor: pointer; position: relative; text-align: center;"><div class="upload-content" ng-if="!vm.attachments[\'attachmentLocation2\'] && !vm.company.companyTncs[0].attachmentLocation2" style="display: flex; flex-direction: column; align-items: center; color: #aaa;"><i class="fa fa-plus" style="font-size: 40px; margin-bottom: 10px;"></i></div><div class="image-container" ng-if="vm.attachments[\'attachmentLocation2\'] || vm.company.companyTncs[0].attachmentLocation2" style="position: relative; display: inline-block;"><img ngf-src="vm.attachments[\'attachmentLocation2\'] || (vm.company.companyTncs[0].attachmentLocation2 ? vm.rootUrl + vm.company.companyTncs[0].attachmentLocation2 : \'\')" style="width: 100%; height: 150px; object-fit: cover;"></div><button ng-click="vm.deleteImage(\'attachmentLocation2\', $event)" ng-if="vm.attachments[\'attachmentLocation2\'] || vm.company.companyTncs[0].attachmentLocation2" style="position: absolute; top: 10px; right: 10px; background-color: #e85656; color: white; border: none; padding: 7px 10px; border-radius: 50px; cursor: pointer;"><i class="fa fa-trash"></i></button></div></div><div class="col-md-4"><div class="upload-box" ngf-select="vm.setUploadAttachmentImage(attachment3File, \'attachmentLocation3\')" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ng-model="attachment3File" name="file" ngf-model-invalid="errorFile" ng-if="!vm.lockUploadButton" style="width: 100%; height: 150px; border: 2px dashed #ccc; display: flex; justify-content: center; align-items: center; cursor: pointer; position: relative; text-align: center;"><div class="upload-content" ng-if="!vm.attachments[\'attachmentLocation3\'] && !vm.company.companyTncs[0].attachmentLocation3" style="display: flex; flex-direction: column; align-items: center; color: #aaa;"><i class="fa fa-plus" style="font-size: 40px; margin-bottom: 10px;"></i></div><div class="image-container" ng-if="vm.attachments[\'attachmentLocation3\'] || vm.company.companyTncs[0].attachmentLocation3" style="position: relative; display: inline-block;"><img ngf-src="vm.attachments[\'attachmentLocation3\'] || (vm.company.companyTncs[0].attachmentLocation3 ? vm.rootUrl + vm.company.companyTncs[0].attachmentLocation3 : \'\')" style="width: 100%; height: 150px; object-fit: cover;"></div><button ng-click="vm.deleteImage(\'attachmentLocation3\', $event)" ng-if="vm.attachments[\'attachmentLocation3\'] || vm.company.companyTncs[0].attachmentLocation3" style="position: absolute; top: 10px; right: 10px; background-color: #e85656; color: white; border: none; padding: 7px 10px; border-radius: 50px; cursor: pointer;"><i class="fa fa-trash"></i></button></div></div></div></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Purchase Order T&C</b></label> <textarea class="form-control" style="font-family:courier;color:#333;height:150px" ng-model="vm.company.companyTncs[0].purchaseOrderTnc">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Delivery Order T&C</b></label> <textarea class="form-control" style="font-family:courier;color:#333;height:150px" ng-model="vm.company.companyTncs[0].deliveryOrderTnc">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Invoice T&C</b></label> <textarea class="form-control" style="font-family:courier;color:#333;height:150px" ng-model="vm.company.companyTncs[0].invoiceTnc">\n\t\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="FTP" ng-if="vm.mode==2"><div class="row"><div class="col-lg-12"><p><b>Company Label Folder:</b></p><br><div class="row"><div class="col-md-6 col-lg-6" style="margin-right:30px"><div style="margin-bottom:5px"><a ng-click="vm.loadFTP()" style="font-family:courier;cursor:pointer"><strong>FTP Root</strong></a> <span ng-repeat="folder in vm.subfolders">&nbsp;\\&nbsp;&nbsp; <a href="" ng-click="vm.navigateFolder(folder)" style="font-family:courier;cursor:pointer"><b>{{folder}}</b></a></span></div><table class="table table-striped" style="border:1px solid #888"><tbody><tr ng-if="vm.subfolders.length!=0"><td style="width:30px"><i class="fa fa-level-up"></i></td><td><a href="" ng-click="vm.navigateBack()" style="font-family:courier;cursor:pointer">Up one level</a></td></tr><tr ng-if="vm.subfolders.length==0"><td colspan="2">---</td></tr><tr ng-repeat="folder in vm.ftp.dirList"><td style="width:30px"><i class="fa fa-folder text-primary"></i></td><td><a href="" ng-click="vm.navigateFolder(folder.filename)" style="font-family:courier;cursor:pointer">{{folder.filename}}</a></td></tr><tr ng-repeat="file in vm.ftp.fileList"><td style="width:30px"><i class="fa fa-file"></i></td><td>{{vm.cleanUpPath(file.filename)}}</td></tr><tr ng-if="vm.ftp.dirList.length==0 && vm.ftp.fileList.length==0"><td colspan="2" style="line-height:300px"><center>The folder is empty.</center></td></tr></tbody></table></div><div class="col-md-5 col-lg-5">&nbsp;<br><div style="border:1px solid #888;padding:15px;margin-top:5px;margin-bottom:30px" ng-if="vm.subfolders.length==0"><b><u>Create Folder</u>:</b><br><span style="color:#f00">Note: folder name cannot contain any special characters, symbols, and white spaces.</span><br><br><span style="font-family:courier;cursor:pointer"><b>FTP Root</b></span> <span ng-repeat="folder in vm.subfolders" style="font-family:courier;cursor:pointer">\\&nbsp;<b>{{folder}}</b></span> <span style="font-family:courier;cursor:pointer">\\</span> <input type="text" class="" ng-model="vm.newFtpFolder"> <button type="button" class="btn btn-with-icon btn-xs btn-primary" style="margin-left:10px" ng-disabled="vm.newFtpFolder==null || vm.newFtpFolder==\'\'" ng-click="vm.createFolder(vm.newFtpFolder)"><i class="fa fa-plus"></i> Create</button><br></div><div style="border:1px solid #888;padding:15px" ng-if="vm.subfolders.length!=0"><b><u>Upload File</u>:</b><br><span style="color:#f00">Note: image filename must not contain any special characters, symbols, and white spaces.</span><br><br><b>Target Folder</b>:<br><span style="display:inline-block;background:#f6fdf6;border:1px solid #aaa;padding:10px;margin-top:3px;color:#00f"><span style="font-family:courier"><b>FTP Root</b></span> <span ng-repeat="folder in vm.subfolders" style="font-family:courier;color:#00f">\\&nbsp;<b>{{folder}}</b></span></span><br><br><b>Select a Bitmap (*.bmp) file</b>:<br><span style="display:inline-block;background:#fff;border:1px solid #aaa;padding:10px;margin-top:3px"><span ng-if="vm.newFtpFile" style="color:#00f">{{vm.newFtpFile.name}}</span> <span ng-if="!vm.newFtpFile">No file selected</span><div name="file" class="btn btn-default btn-with-icon btn-xs" style="margin-left:20px" ng-if="!vm.ftpIsUploading" accept=".bmp" ngf-select="" ng-model="vm.newFtpFile" ngf-pattern="\'.bmp\'" ngf-model-invalid="errorFile" ngf-max-size="5MB"><i class="fa fa-search"></i> Choose</div><a href="" class="btn btn-default btn-with-icon btn-xs" ng-if="vm.newFtpFile && !vm.ftpIsUploading" ng-click="vm.resetFtpFile()"><i class="fa fa-ban"></i> Reset</a> <a href="" class="btn btn-primary btn-with-icon btn-xs" style="margin-left:30px" ng-if="vm.newFtpFile && !vm.ftpIsUploading" ng-click="vm.uploadFtpFile()"><i class="fa fa-upload"></i> Upload File</a> <span ng-if="vm.newFtpFile && vm.ftpIsUploading" style="margin-left:20px"><i class="fa fa-spinner fa-spin fa-fw"></i> Uploading file ...</span></span></div></div></div></div></div><p><br><br></p></uib-tab><uib-tab heading="Data Purge" ng-if="vm.mode==2"><p><big><i class="fa fa-exclamation-triangle"></i> Be careful with the operation and it may cause permanent data loss.</big></p><br><br><div class="row"><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Maintenence &gt; Data</legend></div><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Maintenence &gt; Documents</legend></div><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Knowledge &gt; Recipe Items</legend></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeRawMat()">Purge Raw Materials</button><spin ng-if="vm.isPurgingRawMat"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgePO()">Purge Purchase Orders</button><spin ng-if="vm.isPurgingPO"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeRecipeItems()">Purge Recipe Items</button><spin ng-if="vm.isPurgingRecipeItems"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeSemiFg()">Purge Semi FGs</button><spin ng-if="vm.isPurgingSemiFg"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeGRN()">Purge GRN</button><spin ng-if="vm.isPurgingGRN"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeFG()">Purge Finished Goods</button><spin ng-if="vm.isPurgingFG"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeProdJobs()">Purge Production Jobs</button><spin ng-if="vm.isPurgingProdJobs"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeSupplier()">Purge Suppliers</button><spin ng-if="vm.isPurgingSupplier"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeBulkBreakJobs()">Purge Bulk-Break Jobs</button><spin ng-if="vm.isPurgingBulkBreakJob"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><br><div class="row"><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Inventory Balance</legend></div><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Inventory Movements</legend></div><div class="col-md-4 col-lg-4"><legend style="height:32.4px;line-height:32.4px">Labels</legend></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeRawMatInvBal()">Purge Raw Mat Inventory Balance</button><spin ng-if="vm.isPurgingRawMatInvBal"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeRawMatInvMvmt()">Purge Raw Mat Inventory Movement</button><spin ng-if="vm.isPurgingRawMatInvMvmt"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeRawMatLabel()">Purge Raw Mat Labels</button><spin ng-if="vm.isPurgingRawMatLabel"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeSemiFgInvBal()">Purge Semi FG Inventory Balance</button><spin ng-if="vm.isPurgingSemiFgInvBal"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeSemiFgInvMvmt()">Purge Semi FG Inventory Movement</button><spin ng-if="vm.isPurgingSemiFgInvMvmt"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeSemiFgLabel()">Purge Semi FG Labels</button><spin ng-if="vm.isPurgingSemiFgLabel"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeProductInvBal()">Purge FG Inventory Balance</button><spin ng-if="vm.isPurgingProductInvBal"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeProductInvMvmt()">Purge FG Inventory Movement</button><spin ng-if="vm.isPurgingProductInvMvmt"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><button type="button" class="btn btn-warning" style="color:#000" onclick="return false" ng-disabled="vm.isPurging" ng-click="vm.purgeProductLabel()">Purge FG Labels</button><spin ng-if="vm.isPurgingProductLabel"><i class="fa fa-spinner fa-spin fa-fw"></i> Purging... Please wait...</spin></div></div></div><br><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/companysettings/companysettingList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.companyData" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Company" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="code" style="width:200px">Code</th><th st-sort="name">Name</th><th>Billing Interval</th><th>Package Name</th><th>Branches</th><th>Active?</th><th>Billable?</th><th style="width:40px"></th></tr><tr class="sortable"><th colspan="6"><select st-search="isBillable"><option value="true">Show Billable Companies Only</option><option value="">Show All Companies</option></select></th><th class="form-inline"><select st-search="isActive"><option value="">ALL</option><option ng-repeat="c in vm.companyDataFull | unique:\'isActive\'" value="{{c.isActive | uppercase}}">{{c.isActive?\'Active\':\'Inactive\'}}</option></select></th><th class="form-inline"><select st-search="isBillable"><option value="">ALL</option><option ng-repeat="c in vm.companyDataFull | unique:\'isBillable\'" value="{{c.isBillable | uppercase}}">{{c.isBillable?\'Yes\':\'No\'}}</option></select></th><th></th></tr></thead><tbody><tr ng-if="vm.companyData.length==0"><td colspan="9">No record found.</td></tr><tr ng-repeat="item in vm.companyData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.name}}</td><td>{{item.billingIntervalType}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:120%">{{item.serverPackageName}}</td><td>{{item.branches}}</td><td><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i><i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td><i class="fa fa-check" ng-show="item.isBillable" style="color:#0f0"></i><i class="fa fa-times" ng-show="!item.isBillable" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.companysettings.update({id:item.id})" rms-check-access="superadmin.companysettings" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/companysettings/companysettingUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/companysettings/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true" ng-disabled="vm.isPurging"><i class="ion ion-checkmark"></i> Save Changes</button> <button type="button" class="btn btn-danger btn-with-icon" ui-sref="superadmin.companysettings.list" ng-disabled="vm.isPurging"><i class="ion ion-close"></i> Discard Changes</button></div></form>');
$templateCache.put('app/pages/superadmin/businessmetrics/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Metrics"><p><i class="fa fa-info-circle"></i> Select a date range and load the metrics.</p><p><br></p><div class="row"><div class="col-lg-12"><b>Start:</b><select name="StartMonth" ng-change="vm.selectedStartMonthChanged()" ng-model="vm.selectedStartMonth" ng-options="i as i.name for i in vm.monthList" required=""></select><select name="StartYear" ng-change="vm.selectedStartYearChanged()" ng-model="vm.selectedStartYear" ng-options="i as i.name for i in vm.yearList" required=""></select>&nbsp;&nbsp;&nbsp;&nbsp; <b>End:</b><select name="EndMonth" ng-change="vm.selectedEndMonthChanged()" ng-model="vm.selectedEndMonth" ng-options="i as i.name for i in vm.monthList" required=""></select><select name="EndYear" ng-change="vm.selectedEndYearChanged()" ng-model="vm.selectedEndYear" ng-options="i as i.name for i in vm.yearList" required=""></select>&nbsp;&nbsp;&nbsp;&nbsp; <button ng-click="vm.loadMetrics()">Load</button></div></div><br><br><div class="row"><div class="col-lg-12"><table border="1" style="font-size:11pt"><tr><td style="padding:10px 5px;width:200px;border-top:5px solid #000;border-bottom:5px solid #000"><b>Metric</b></td><td style="padding:10px 5px;width:120px;border-top:5px solid #000;border-bottom:5px solid #000;text-align:center" ng-repeat="m in vm.metric_iot"><b>{{m.countMonth}} / {{m.countYear}}</b></td></tr><tr><td style="padding:10px;width:130px"><b># Gateways</b></td><td style="padding:10px;text-align:right" ng-repeat="m in vm.metric_iot">{{m.totalGateway}}</td></tr><tr><td style="padding:10px;background:#eaf4fc;"><b># Sensors</b></td><td style="padding:10px;background:#eaf4fc;text-align:right" ng-repeat="m in vm.metric_iot">{{m.totalSensor}}</td></tr><tr><td style="padding:10px"><b>M.R.R</b></td><td style="padding:10px;text-align:right" ng-repeat="m in vm.metric_biz">{{m.mrr | number:2}}</td></tr><tr><td style="padding:10px;background:#eaf4fc;"><b>Full Timer (Nos)</b></td><td style="padding:10px;background:#eaf4fc;text-align:right" ng-repeat="m in vm.metric_biz">{{m.noOfFullTimer | number:0}}</td></tr><tr><td style="padding:10px"><b>Pymt Collected (RM)</b></td><td style="padding:10px;text-align:right" ng-repeat="m in vm.metric_biz">{{m.revenue | number:2}}</td></tr><tr><td style="padding:10px;background:#eaf4fc;"><b>OPEX (RM)</b></td><td style="padding:10px;background:#eaf4fc;text-align:right" ng-repeat="m in vm.metric_biz">{{m.opex | number:2}}</td></tr><tr><td style="padding:10px"><b>Net P/L (RM)</b></td><td style="padding:10px;text-align:right" ng-repeat="m in vm.metric_biz"><span ng-if="m.netProfitLoss<0" style="color:#f00">({{(-1 * m.netProfitLoss) | number:2}})</span> <span ng-if="m.netProfitLoss>=0" style="color:rgb(6, 138, 6)">{{m.netProfitLoss | number:2}}</span></td></tr><tr><td style="padding:10px;background:#eaf4fc"><b>A/R (Total)</b></td><td style="padding:10px;background:#eaf4fc;text-align:right" ng-repeat="m in vm.metric_biz"><span ng-if="m.ar==0">{{m.ar | number:2}}</span><div ng-if="m.ar!=0" style="background:#fffc00">{{m.ar | number:2}}</div></td></tr><tr><td style="padding:10px"><b>A/R (&gt; 3 Mths)</b></td><td style="padding:10px;text-align:right" ng-repeat="m in vm.metric_biz"><span ng-if="m.aR3Months==0">{{m.aR3Months | number:2}}</span><div ng-if="m.aR3Months!=0" style="background:#fffc00">{{m.aR3Months | number:2}}</div></td></tr><tr><td style="padding:10px;background:#eaf4fc"><b>Bank Balance (RM)</b></td><td style="padding:10px;background:#eaf4fc;text-align:right" ng-repeat="m in vm.metric_biz">{{m.cashBalance | number:2}}</td></tr><tr><td style="padding:10px;border-top:5px solid #000;border-bottom:5px solid #000"><b>Runway (Mths)</b></td><td style="padding:5px;border-top:5px solid #000;border-bottom:5px solid #000;text-align:right" ng-repeat="m in vm.metric_runway"><div ng-if="m.runway<3" style="padding:5px;background:#ffbfbf"><b>{{m.runway | number:2}}</b></div><div ng-if="m.runway<6 && m.runway>=3" style="padding:5px;background:#fffd9f"><b>{{m.runway | number:2}}</b></div><div ng-if="m.runway>=6" style="padding:5px;background:#9fffb4"><b>{{m.runway | number:2}}</b></div></td></tr></table></div></div><p><br></p><p><br></p></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/businessmetrics/businessmetric.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/businessmetrics/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="dashboard"><i class="ion ion-close"></i> Back</a></div></form>');
$templateCache.put('app/pages/superadmin/features/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p>Please fill in the feature information.</p><p><br></p><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FeatureName.$invalid && (vm.dataForm.FeatureName.$dirty || vm.dataForm.$submitted)}"><label>Feature Name <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="FeatureName" placeholder="Feature Name" ng-model="vm.feature.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FeatureName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FeatureState.$invalid && (vm.dataForm.FeatureState.$dirty || vm.dataForm.$submitted)}"><label>Feature State <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="FeatureState" placeholder="Feature State" ng-model="vm.feature.state" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FeatureState.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Sequence.$invalid && (vm.dataForm.Sequence.$dirty || vm.dataForm.$submitted)}"><label>Sequence <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="Sequence" placeholder="Sequence" min="1" ng-model="vm.feature.sequence" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Sequence.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Sequence.$error.number">* Key in numbers only</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label>Is Parent</label><div><toggle ng-model="vm.feature.isParent" ng-change="vm.isParentChanged()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row" ng-show="!vm.feature.isParent"><div class="col-md-4 col-lg-4"><div class="form-group"><label>Parent Feature</label><select class="form-control" ng-options="f as (f.name | uppercase) for f in vm.featureList track by f.id" ng-model="vm.selectedParent" ng-change="vm.selectedParentChanged()"></select></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/features/featureCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/features/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Create Feature</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.features.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/superadmin/features/featureList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.featureData" refresh-table=""><thead><tr><th colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Feature" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.features.create" rms-check-access="superadmin.features" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Feature</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="name">Name</th><th>State</th><th>Sequence</th><th>Parent</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="item in vm.featureData"><td>{{vm.startIndex+1+$index}})</td><td><span ng-show="item.isParent"><b>{{item.name}}</b></span> <span ng-show="!item.isParent"><i class="fa fa-long-arrow-right"></i> &nbsp;&nbsp;{{item.name}}</span></td><td>{{item.state}}</td><td>{{item.sequence}}</td><td><i class="ion-checkmark-round" style="color:#0f0" ng-show="item.isParent"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.features.update({id:item.id})" rms-check-access="superadmin.features" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Feature" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteFeature(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this feature?" rms-check-access="superadmin.features" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr><tr ng-show="vm.featureData.length<=0"><td colspan="7">No record found.</td></tr></tbody><tfoot><tr><td colspan="7" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/features/featureUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/features/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.features.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/superadmin/intercompanyitemmappings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>{{ \'STATUS\' | translate }}</b></label><div><toggle ng-model="vm.mapping.active" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><br><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceCompany.$invalid && (vm.dataForm.SourceCompany.$dirty || vm.dataForm.$submitted)}"><label><b>Source Company</b> <i class="fa fa-asterisk req"></i></label><select name="SourceCompany" class="form-control" ng-change="vm.selectedSourceCompanyChanged()" ng-model="vm.selectedSourceCompany" ng-options="i as i.name for i in vm.companyList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceCompany.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle">&nbsp;<br><b>&rarr;</b><br><b>&rarr;</b></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestCompany.$invalid && (vm.dataForm.DestCompany.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Company</b> <i class="fa fa-asterisk req"></i></label><select name="DestCompany" class="form-control" ng-change="vm.selectedDestCompanyChanged()" ng-model="vm.selectedDestCompany" ng-options="i as i.name for i in vm.companyList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestCompany.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"></div><div class="col-md-1 col-lg-1"></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestBranch.$invalid && (vm.dataForm.DestBranch.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Branch</b> <i class="fa fa-asterisk req"></i></label><select name="DestBranch" class="form-control" ng-change="vm.selectedDestBranchChanged()" ng-model="vm.selectedDestBranch" ng-options="i as i.name for i in vm.branchList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestBranch.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-8 col-lg-8"><hr></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceItem.$invalid && (vm.dataForm.SourceItem.$dirty || vm.dataForm.$submitted)}"><label><b>Source Raw Material</b> <i class="fa fa-asterisk req"></i></label><select name="SourceItem" class="form-control" ng-change="vm.selectedSourceItemChanged()" ng-model="vm.selectedSourceItem" ng-options="i as (i.code + \' -- \' + i.description) for i in vm.itemList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceItem.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle">&nbsp;<br><b>&rarr;</b><br><b>&rarr;</b></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestRawMat.$invalid && (vm.dataForm.DestRawMat.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Raw Material</b> <i ng-if="vm.selectedDestRawMat!=null" class="fa fa-asterisk req"></i></label><select name="DestRawMat" class="form-control" ng-change="vm.selectedDestRawMatChanged()" ng-model="vm.selectedDestRawMat" ng-options="i as (i.code + \' -- \' + i.description) for i in vm.rawMatList" ng-required="vm.selectedDestRawMat==null && vm.selectedDestSemiFg==null && vm.selectedDestProduct==null"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestRawMat.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1">&nbsp;<br><br><b>= OR =</b></div></div><div class="row"><div class="col-md-4 col-lg-4"></div><div class="col-md-1 col-lg-1"></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestSemiFg.$invalid && (vm.dataForm.DestSemiFg.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Semi F.G.</b> <i ng-if="vm.selectedDestSemiFg!=null" class="fa fa-asterisk req"></i></label><select name="DestSemiFg" class="form-control" ng-change="vm.selectedDestSemiFgChanged()" ng-model="vm.selectedDestSemiFg" ng-options="i as (i.code + \' -- \' + i.description) for i in vm.semiFgList" ng-required="vm.selectedDestRawMat==null && vm.selectedDestSemiFg==null && vm.selectedDestProduct==null"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestSemiFg.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1">&nbsp;<br><br><b>= OR =</b></div></div><div class="row"><div class="col-md-4 col-lg-4"></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle"></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestProduct.$invalid && (vm.dataForm.DestProduct.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Finished Good</b> <i ng-if="vm.selectedDestProduct!=null" class="fa fa-asterisk req"></i></label><select name="DestProduct" class="form-control" ng-change="vm.selectedDestProductChanged()" ng-model="vm.selectedDestProduct" ng-options="i as (i.code + \' -- \' + i.name) for i in vm.productList" ng-required="vm.selectedDestRawMat==null && vm.selectedDestSemiFg==null && vm.selectedDestProduct==null"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestProduct.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.mapping.id!=null"><p><i class="fa fa-info-circle"></i> Audit trail of changes made to this Item Mapping.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b>Date / Time</b></th><th style="width:180px"><b>Edited By</b></th><th style="width:40%"><b>Original Values</b></th><th style="width:40%"><b>Updated Values</b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br>There is no changes yet.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/intercompanyitemmappings/mappingCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/intercompanyitemmappings/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create Mapping</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.intercompanyitemmappings.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/superadmin/intercompanyitemmappings/mappingImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b>Import Item Mapping Data</b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> Browse</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile()" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> Upload File</a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px">Uploading file...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong>Failed to process uploaded file. File might contain errors.</strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong>Failed to upload file.</strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend>Import Guidelines:</legend><ol class="import"><li>You need to follow the instruction below if you are new to the RMS.</li><li>Download the template below, fill it up with the data first, then import into the RMS:<br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate()"><i class="fa fa-download"></i> Download Item Mapping Template</a></li></ol></fieldset><br>&nbsp;<br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong>File uploaded successfully. Choose the options below and proceed to import the data.</strong></div><div><fieldset><legend>Import Options:</legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createItemMapping" ng-change="change()" style="cursor:pointer"> <label><span>Create New Mappings</span></label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateItemMapping" ng-change="change()" style="cursor:pointer"> <label><span>Update Mapping if exists</span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> Confirm Import</a></div></div></fieldset><br><br><fieldset><legend>Item Mapping Data Preview:</legend></fieldset></div><div id="scroll-container" class="horizontal-scroll"><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important"><thead><tr><th style="width:60px">#</th><th><b>Source Company Code</b></th><th><b>Source Company Name</b></th><th><b>Source Item Code</b></th><th><b>Source Item Name</b></th><th><b>Dest Company Code</b></th><th><b>Dest Company Name</b></th><th><b>Dest Semi FG Code</b></th><th><b>Dest Semi FG Name</b></th><th><b>Dest FG Code</b></th><th><b>Dest FG Name</b></th></tr><tr><th colspan="11">Total Records: {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td nowrap="nowrap">{{ row.sourceCompanyCode || \'\' }}</td><td nowrap="nowrap">{{ row.sourceCompanyName || \'\' }}</td><td nowrap="nowrap">{{ row.sourceItemCode || \'\' }}</td><td nowrap="nowrap">{{ row.sourceItemName || \'\' }}</td><td nowrap="nowrap">{{ row.destCompanyCode || \'-\' }}</td><td nowrap="nowrap">{{ row.destCompanyName || \'-\' }}</td><td nowrap="nowrap">{{ row.destSemiFgCode || \'-\' }}</td><td nowrap="nowrap">{{ row.destSemiFgName || \'-\' }}</td><td nowrap="nowrap">{{ row.destProductCode || \'-\' }}</td><td nowrap="nowrap">{{ row.destProductName || \'-\' }}</td></tr><tr><td colspan="11" align="center" ng-show="vm.importOptions.excelContent.length==0"><br>Excel content is empty.<br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="11">Total Records: {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-6 col-lg-6"><em><small><i class="fa fa-info-circle"></i> Processing...</small></em><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><p>The data is currently being processed. It is safe to leave this page now.</p><p>You will receive an email notification about the import result once the server has finished processed the data.</p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.intercompanyitemmappings.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back To List</a></div></form></div>');
$templateCache.put('app/pages/superadmin/intercompanyitemmappings/mappingList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped table-hover" st-persist="SAInterCompanyItemMapping" st-pipe="vm.retrieveData" st-table="vm.mappingData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Mapping" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.intercompanyitemmappings.create" rms-check-access="superadmin.intercompanyitemmappings" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>New Mapping</a> <a href="" class="btn btn-success btn-with-icon" ui-sref="superadmin.intercompanyitemmappings.import" rms-check-access="superadmin.intercompanyitemmappings" rms-check-access-perm-type="CREATE"><i class="fa fa-download"></i>Import Excel</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-4 col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="sourceCompanyName">SOURCE<br>Company Name</th><th st-sort="sourceItemName">SOURCE<br>Raw Mat</th><th st-sort="destCompanyName" style="border-left:2px solid black">DESTINATION<br>Company Name</th><th st-sort="destBranchName">DESTINATION<br>Branch Name</th><th>DESTINATION<br>Raw Mat / SFG / FG</th><th>Active</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline"><input st-search="sourceCompanyName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="sourceItemName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="destCompanyName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="destBranchName" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.mappingData.length==0 && !vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="9" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.mappingData"><td>{{vm.startIndex+1+$index}})</td><td style="line-height:130%;padding-top:10px;padding-bottom:10px">{{item.sourceCompanyName | uppercase}}</td><td style="line-height:130%;padding-top:10px;padding-bottom:10px">{{item.sourceItemCode}} -- {{item.sourceItemName | uppercase}}</td><td style="line-height:130%;padding-top:10px;padding-bottom:10px;border-left:2px solid black">{{item.destCompanyName || \'-\' | uppercase}}</td><td style="line-height:130%;padding-top:10px;padding-bottom:10px">{{item.destBranchName || \'-\' | uppercase}}</td><td style="line-height:130%;padding-top:10px;padding-bottom:10px">{{vm.getDestObjectCode(item)}} -- {{vm.getDestObjectName(item) | uppercase}}</td><td><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.intercompanyitemmappings.update({id:item.id})" rms-check-access="superadmin.intercompanyitemmappings" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Mapping" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteMapping(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Mapping?" rms-check-access="superadmin.intercompanyitemmappings" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/intercompanyitemmappings/mappingUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/intercompanyitemmappings/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.intercompanyitemmappings.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button></div></form>');
$templateCache.put('app/pages/superadmin/intercompanymappings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>Active</b></label><div><toggle ng-model="vm.mapping.active" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceCompany.$invalid && (vm.dataForm.SourceCompany.$dirty || vm.dataForm.$submitted)}"><label><b>Source Company</b> <i class="fa fa-asterisk req"></i></label><select name="SourceCompany" class="form-control" ng-change="vm.selectedSourceCompanyChanged()" ng-model="vm.selectedSourceCompany" ng-options="i as (i.name | uppercase) for i in vm.companyList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceCompany.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle">&nbsp;<br><b>&rarr;</b><br><b>&rarr;</b></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestCompany.$invalid && (vm.dataForm.DestCompany.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Company</b> <i class="fa fa-asterisk req"></i></label><select name="DestCompany" class="form-control" ng-change="vm.selectedDestCompanyChanged()" ng-model="vm.selectedDestCompany" ng-options="i as (i.name | uppercase) for i in vm.companyList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestCompany.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle"></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestBranch.$invalid && (vm.dataForm.DestBranch.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Branch</b> <i class="fa fa-asterisk req"></i></label><select name="DestBranch" class="form-control" ng-change="vm.selectedDestBranchChanged()" ng-model="vm.selectedDestBranch" ng-options="i as (i.name | uppercase) for i in vm.destBranchList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestBranch.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceSupplier.$invalid && (vm.dataForm.SourceSupplier.$dirty || vm.dataForm.$submitted)}"><label><b>Source Supplier</b> <i class="fa fa-asterisk req"></i></label><select name="SourceSupplier" class="form-control" ng-change="vm.selectedSourceSupplierChanged()" ng-model="vm.selectedSourceSupplier" ng-options="i as (i.name | uppercase) for i in vm.supplierList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceSupplier.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle">&nbsp;<br><b>&rarr;</b><br><b>&rarr;</b></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestDebtor.$invalid && (vm.dataForm.DestDebtor.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Customer</b> <i class="fa fa-asterisk req"></i></label><select name="DestDebtor" class="form-control" ng-change="vm.selectedDestDebtorChanged()" ng-model="vm.selectedDestDebtor" ng-options="i as (i.name | uppercase) for i in vm.debtorList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestDebtor.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SourceBranch.$invalid && (vm.dataForm.SourceBranch.$dirty || vm.dataForm.$submitted)}"><label><b>Source Branch</b> <i class="fa fa-asterisk req"></i></label><select name="SourceBranch" class="form-control" ng-change="vm.selectedSourceBranchChanged()" ng-model="vm.selectedSourceBranch" ng-options="i as (i.name | uppercase) for i in vm.sourceBranchList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SourceBranch.$error.required">* Required</span></div></div><div class="col-md-1 col-lg-1" style="text-align:center;vertical-align:middle">&nbsp;<br><b>&rarr;</b><br><b>&rarr;</b></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DestDebtorBranch.$invalid && (vm.dataForm.DestDebtorBranch.$dirty || vm.dataForm.$submitted)}"><label><b>Destination Customer\'s Branch</b> <i class="fa fa-asterisk req"></i></label><select name="DestDebtorBranch" class="form-control" ng-change="vm.selectedDestDebtorBranchChanged()" ng-model="vm.selectedDestDebtorBranch" ng-options="i as (i.name | uppercase) for i in vm.debtorBranchList" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DestDebtorBranch.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="{{ \'AUDIT_LOG\' | translate }}" ng-if="vm.mapping.id!=null"><p><i class="fa fa-info-circle"></i> Audit trail of changes made to this Company Mapping.<br></p><div class="row"><div class="col-lg-12"><table class="table table-striped table-bordered" style="font-size:90%"><thead><tr><th style="width:180px"><b>Date / Time</b></th><th style="width:180px"><b>Edited By</b></th><th style="width:40%"><b>Original Values</b></th><th style="width:40%"><b>Updated Values</b></th></tr></thead><tbody><tr ng-if="vm.changeLogs.length==0"><td colspan="4" align="center"><br>There is no changes yet.<br>&nbsp;</td></tr><tr ng-repeat="log in vm.changeLogs"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{log.createdBy | uppercase}}</td><td ng-bind-html="log.originalData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td><td ng-bind-html="log.newData" style="padding-top:8px;padding-bottom:8px;line-height:130%;"></td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/intercompanymappings/mappingCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/intercompanymappings/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Create Mapping</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.intercompanymappings.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/superadmin/intercompanymappings/mappingImport.html','<div class="widgets"><form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row" ng-hide="vm.isSuccess"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" is-open="true"><uib-accordion-heading><b>Import Mapping Data</b></uib-accordion-heading><div class="row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control" placeholder="Select a file..." value="{{excelFile.name || \'\'}}" style="color:#333" ng-readonly="true"></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><div class="btn btn-primary btn-with-icon" name="file" ng-disabled="vm.isExporting || vm.lockButtons" ng-model="excelFile" ngf-select="vm.setUploadFile(excelFile)" ngf-accept="\'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-model-invalid="errorFile"><i class="fa fa-search"></i> Browse</div><a href="" class="btn btn-success btn-with-icon" ng-click="vm.uploadFile()" ng-disabled="vm.lockButtons" ng-if="excelFile"><i class="fa fa-upload"></i> Upload File</a></div></div><div class="row" ng-if="excelFile && 0<=vm.uploadProgess && vm.uploadProgessPercent!=100 && vm.lockButtons"><div class="form-group col-sm-12 col-md-6 col-lg-6"><div style="height:20px;margin:10px auto 5px">Uploading file...</div><div class="progress" style="background:rgba(255,255,255, 0.6);height:20px;margin:0px auto"><div align="center" style="position:absolute;width:100%;font-size:10pt;line-height:20px;color:#000">{{vm.uploadProgessPercent | number:0}}%</div><div class="progress-bar progress-bar-success" role="progressbar" aria-valuemin="0" aria-valuenow="vm.uploadProgess" aria-valuemax="vm.uploadProgessTotal" style="width: {{vm.uploadProgessPercent | number:0}}%"></div></div></div></div><div class="row" ng-if="vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong>Failed to process uploaded file. File might contain errors.</strong></div></div></div><div class="row" ng-show="!vm.isUploaded && vm.isFail"><div class="form-group col-sm-12 col-md-11 col-lg-11"><div class="alert bg-danger"><strong>Failed to upload file.</strong></div></div></div></uib-accordion-group></uib-accordion></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><fieldset><legend>Import Guidelines:</legend><ol class="import"><li>You need to follow the instruction below if you are new to the RMS.</li><li>Download the template below, fill it up with the data first, then import into the RMS:<br><br><a href="" class="btn btn-sm btn-primary btn-with-icon" style="margin-bottom:10px" ng-disabled="vm.isExporting || vm.lockButtons" ng-click="vm.downloadTemplate()"><i class="fa fa-download"></i> Download Mapping Template</a></li></ol></fieldset><br>&nbsp;<br>&nbsp;</div></div></div></div><div class="row" ng-if="vm.isSuccess && !vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="alert bg-success"><i class="fa fa-file-text"></i>&nbsp;<i class="fa fa-check"></i> &nbsp;&nbsp; <strong>File uploaded successfully. Choose the options below and proceed to import the data.</strong></div><div><fieldset><legend>Import Options:</legend><div class="row"><div class="col-md-3 col-lg-3"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.createCompanyMapping" ng-change="change()" style="cursor:pointer"> <label><span>Create New Mappings</span></label></div><br><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" ng-model="vm.importOptions.updateCompanyMapping" ng-change="change()" style="cursor:pointer"> <label><span>Update Mapping if exists</span></label></div></div></div><legend>&nbsp;</legend><div class="row"><div class="col-md-6 col-lg-6"><a href="" class="btn btn-danger btn-with-icon" ng-click="vm.goBack()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back</a> <a href="" class="btn btn-primary btn-with-icon" ng-click="vm.importData()" ng-disabled="vm.lockButtons || vm.importOptions.excelContent.length==0"><i class="fa fa-upload"></i> Confirm Import</a></div></div></fieldset><br><br><fieldset><legend>Mapping Data Preview:</legend></fieldset></div><div id="scroll-container" class="horizontal-scroll"><table class="table-nopadding" cellpadding="3" cellspacing="0" border="1" style="border-collapse:collapse;font-family:courier;font-size:8pt !important"><thead><tr><th style="width:60px">#</th><th><b>Source Company Code</b></th><th><b>Source Company Name</b></th><th><b>Source Branch Code</b></th><th><b>Source Branch Branch</b></th><th><b>Source Supplier Code</b></th><th><b>Source Supplier Name</b></th><th><b>Dest Company Code</b></th><th><b>Dest Company Name</b></th><th><b>Dest Branch Code</b></th><th><b>Dest Branch Name</b></th><th><b>Dest Customer Code</b></th><th><b>Dest Customer Name</b></th><th><b>Dest Customer Branch Name</b></th><th><b>Active</b></th></tr><tr><th colspan="15">Total Records: {{vm.importOptions.excelContent.length}}</th></tr></thead><tbody><tr ng-repeat="row in vm.importOptions.excelContent"><td>{{$index+1}}</td><td nowrap="nowrap">{{ row.sourceCompanyCode || \'-\' }}</td><td nowrap="nowrap">{{ row.sourceCompanyName || \'-\' }}</td><td nowrap="nowrap">{{ row.sourceBranchCode || \'-\' }}</td><td nowrap="nowrap">{{ row.sourceBranchName || \'-\' }}</td><td nowrap="nowrap">{{ row.sourceSupplierCode || \'-\' }}</td><td nowrap="nowrap">{{ row.sourceSupplierName || \'-\' }}</td><td nowrap="nowrap">{{ row.destCompanyCode || \'-\' }}</td><td nowrap="nowrap">{{ row.destCompanyName || \'-\' }}</td><td nowrap="nowrap">{{ row.destBranchCode || \'-\' }}</td><td nowrap="nowrap">{{ row.destBranchName || \'-\' }}</td><td nowrap="nowrap">{{ row.destCustomerCode || \'-\' }}</td><td nowrap="nowrap">{{ row.destCustomerName || \'-\' }}</td><td nowrap="nowrap">{{ row.destCustomerBranchName || \'-\' }}</td><td nowrap="nowrap">{{ row.active || \'N\' }}</td></tr><tr><td colspan="15" align="center" ng-show="vm.importOptions.excelContent.length==0"><br>Excel content is empty.<br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="15">Total Records: {{vm.importOptions.excelContent.length}}</td></tr></tfoot></table></div></div></div><div class="row" ng-if="vm.isImporting"><div class="col-md-12 col-lg-12" ba-panel=""><div class="row"><div class="col-md-6 col-lg-6"><em><small><i class="fa fa-info-circle"></i> Processing...</small></em><div class="progress ng-scope"><div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 100%" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"><span class="sr-only"></span></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><p>The data is currently being processed. It is safe to leave this page now.</p><p>You will receive an email notification about the import result once the server has finished processed the data.</p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div></div><div style="padding-bottom:30px"><a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.intercompanymappings.list" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> Back To List</a></div></form></div>');
$templateCache.put('app/pages/superadmin/intercompanymappings/mappingList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="SAInterCompanyMapping" st-pipe="vm.retrieveData" st-table="vm.mappingData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Mapping" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.intercompanymappings.create" rms-check-access="superadmin.intercompanymappings" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>New Mapping</a> <a href="" class="btn btn-success btn-with-icon" ui-sref="superadmin.intercompanymappings.import" rms-check-access="superadmin.intercompanymappings" rms-check-access-perm-type="CREATE"><i class="fa fa-download"></i>Import Excel</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="sourceCompanyName">SOURCE<br>Company Name</th><th st-sort="sourceBranchName">SOURCE<br>Branch Name</th><th st-sort="sourceSupplierName">SOURCE<br>Supplier Name</th><th st-sort="destCompanyName" style="border-left:2px solid black">DESTINATION<br>Company Name</th><th st-sort="destBranchName">DESTINATION<br>Branch Name</th><th st-sort="destDebtorName">DESTINATION<br>Customer Name</th><th st-sort="destDebtorBranchName">DESTINATION<br>Customer Site Name</th><th class="hide-after" style="text-align:center">Active</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline"><input st-search="sourceCompanyName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="sourceBranchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="sourceSupplierName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="destCompanyName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="destBranchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="destDebtorName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="destDebtorBranchName" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.mappingData.length==0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.mappingData"><td>{{vm.startIndex+1+$index}})</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%">{{item.sourceCompanyName | uppercase}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%">{{item.sourceBranchName | uppercase}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%">{{item.sourceSupplierName | uppercase}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%;border-left:2px solid black">{{item.destCompanyName | uppercase}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%">{{item.destBranchName | uppercase}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%">{{item.destDebtorName | uppercase}}</td><td style="padding-top:8px;padding-bottom:8px;line-height:110%">{{item.destDebtorBranchName | uppercase}}</td><td style="text-align:center"><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.intercompanymappings.update({id:item.id})" rms-check-access="superadmin.intercompanymappings" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Mapping" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteMapping(item.id)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this Mapping?" rms-check-access="superadmin.intercompanymappings" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/intercompanymappings/mappingUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/intercompanymappings/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.intercompanymappings.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button></div></form>');
$templateCache.put('app/pages/superadmin/payments/paymentCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Payment Details" select="vm.selectedTab=0"><div class="row"><div class="col-md-4"><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Company.$invalid && (vm.dataForm.Company.$dirty || vm.dataForm.$submitted)}"><label><b>Select a Company</b> <i class="fa fa-asterisk req"></i></label><select name="Company" class="form-control" ng-options="i as (i.name | uppercase) for i in vm.companyList" ng-model="vm.selectedCompany" ng-change="vm.selectedCompanyChanged()" ng-required="$tabSetStatus.activeTab==0"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Company.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Invoice.$invalid && (vm.dataForm.Invoice.$dirty || vm.dataForm.$submitted)}"><label><b>Select an Invoice</b> <i class="fa fa-asterisk req"></i></label><select name="Invoice" class="form-control" ng-disabled="vm.payment.companyId==\'\'" ng-options="i as (i.invoiceNo + \' [ Balance: RM \' + (i.currentMonthAmount - i.totalAmountPaid) + \' ]\' | uppercase) for i in vm.invoiceList" ng-model="vm.selectedInvoice" ng-change="vm.selectedInvoiceChanged()" ng-required="$tabSetStatus.activeTab==0"><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Invoice.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ChequeNo.$invalid && (vm.dataForm.ChequeNo.$dirty || vm.dataForm.$submitted)}"><label><b>Enter Cheque No. / Payment Details</b> <i class="fa fa-asterisk req"></i></label> <input type="text" name="ChequeNo" class="form-control" ng-required="$tabSetStatus.activeTab==0" ng-disabled="vm.payment.invoiceNo==\'\'" ng-model="vm.payment.chequeNo"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ChequeNo.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Amount.$invalid && (vm.dataForm.Amount.$dirty || vm.dataForm.$submitted)}"><label><b>Enter the Payment Amount (RM)</b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="Amount" class="form-control" min="1" step="1" ng-required="$tabSetStatus.activeTab==0" ng-disabled="vm.payment.invoiceNo==\'\'" ng-model="vm.payment.amount"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Amount.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Amount.$error.min">* Must be greater than ZERO</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-md-6"><a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard"><i class="ion ion-chevron-left"></i> Back</a> <button type="submit" class="btn btn-success btn-with-icon"><i class="fa fa-check"></i> Confirm Payment</button></div></div></div><div class="col-md-1" style="width:50px"></div><div class="col-md-6" ng-if="vm.selectedInvoice!=null"><br><span style="margin-bottom:10px">List of Recorded Payments / Credit Notes for <b>{{ vm.selectedInvoice.invoiceNo }}</b>:</span><table class="table table-bordered table-striped table-sm" style="margin-top:10px"><thead><tr><td style="width:180px;text-align:center">Payment Date</td><td>Payment Details</td><td style="width:180px;text-align:center">Amount</td></tr></thead><tbody><tr ng-repeat="p in vm.selectedInvoice.billingPayments"><td style="text-align:center">{{ p.paymentDate | date:\'dd/MM/yyyy\' }}</td><td>{{ p.chequeNo }}</td><td style="text-align:right">{{ p.amount | number:2 }}</td></tr><tr ng-if="vm.selectedInvoice.billingPayments.length==0"><td colspan="3" style="text-align:center"><br>There is no payment record for <b>{{ vm.selectedInvoice.invoiceNo }}</b>.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Generate Invoice" select="vm.selectedTab=1"><p>Generate invoice for all billing customers.<br>&nbsp;</p><div class="row"><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InvoiceYear.$invalid && (vm.dataForm.InvoiceYear.$dirty || vm.dataForm.$submitted)}"><label><b>Select Year</b> <i class="fa fa-asterisk req"></i></label><select name="InvoiceYear" class="form-control" ng-model="vm.invoice.year" ng-required="$tabSetStatus.activeTab==1"><option></option><option value="2024">2024</option><option value="2025">2025</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InvoiceYear.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.InvoiceMonth.$invalid && (vm.dataForm.InvoiceMonth.$dirty || vm.dataForm.$submitted)}"><label><b>Select Month</b> <i class="fa fa-asterisk req"></i></label><select name="InvoiceMonth" class="form-control" ng-model="vm.invoice.month" ng-required="$tabSetStatus.activeTab==1"><option></option><option value="1">January</option><option value="2">February</option><option value="3">March</option><option value="4">April</option><option value="5">May</option><option value="6">June</option><option value="7">July</option><option value="8">August</option><option value="9">September</option><option value="10">October</option><option value="11">November</option><option value="12">December</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.InvoiceMonth.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-md-6"><a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard"><i class="ion ion-chevron-left"></i> Back</a> <button type="submit" class="btn btn-success btn-with-icon"><i class="fa fa-check"></i> Generate Invoices</button></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><div class="col-lg-12"><table class="table table-hover table-bordered table-striped"><tr><td style="width:40px"><b>#</b></td><td style="width:80px;text-align:center" class="hide-after"><b>Status</b></td><td><b>Company Name</b></td><td><b>Message</b></td></tr><tr ng-repeat="ntn in vm.invoiceGenerationResult"><td>{{$index+1}}</td><td style="text-align:center"><i class="fa fa-check" ng-if="ntn.status==1" style="color:#0f0"></i> <i class="fa fa-warning" ng-if="ntn.status==0" style="color:#ffae00"></i> <i class="fa fa-times" ng-if="ntn.status==-1" style="color:#f00"></i></td><td>{{ntn.companyName}}</td><td>{{ntn.message}}</td></tr></table></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="All Invoices" select="vm.selectedTab=2"><p><i class="fa fa-info-circle"></i> Full list of customer invoices.<br><br></p><table class="table table-striped" st-persist="SAInvoiceListing" st-pipe="vm.retrieveData" st-table="vm.data" refresh-table=""><thead><tr><th colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-lg-2" style="height:35px;line-height:35px;padding-left:0px"><select st-search="isPaid" class="form-control input"><option value="">Show Unpaid Invoices</option><option value="0">Show Paid Invoices</option><option value="1">Show All Invoices</option></select></div><div class="col-lg-3" style="height:35px;line-height:35px"><a href="" class="btn btn-success btn-with-icon" ng-click="vm.showDownloadExcelModal()"><i class="fa fa-download"></i> {{ \'DOWNLOAD_EXCEL\' | translate }}</a></div><div class="col-lg-3" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-lg-4" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="invoiceNo">Invoice No.</th><th>Invoice Date</th><th st-sort="clientCompanyName">Customer Name</th><th class="hide-after" style="text-align:right">Invoice Amount (RM)</th><th class="hide-after" style="text-align:right">Total Due (RM)</th><th class="hide-after" style="text-align:center">Paid?</th><th>Paid On</th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline" colspan="2"><input st-search="invoiceNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="debtorName" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td>{{item.invoiceNo}}</td><td>{{item.invoiceDate | date:\'dd/MM/yyyy\'}}</td><td>{{item.clientCompanyName}}</td><td style="text-align:right">{{item.currentMonthAmount | currency:\'\'}}</td><td style="text-align:right">{{(item.totalAmountDue - item.totalAmountPaid) | currency:\'\'}}</td><td style="text-align:center"><span ng-if="item.isPaid" style="color:#107a10">Yes</span> <span ng-if="!item.isPaid" style="color:#f00">No</span></td><td>{{item.paidOn || \'-\' | date:\'dd/MM/yyyy\'}}</td><td style="text-align:center"><a href="" title="Print" class="btn btn-default btn-xs text-primary" ng-click="vm.printInvoice(item.id, item.invoiceNo)" style="padding:4px 8px"><i class="fa fa-download"></i> <b>Download</b></a></td></tr><tr ng-if="vm.data.length==0"><td colspan="9">No record found.</td></tr></tbody><tfoot><tr><td colspan="4" style="text-align:right;color:#f00"><b>Total O/S Amount:</b></td><td style="text-align:right;color:#f00"><b>{{vm.totalUnpaidAmount | number:2}}</b></td><td style="text-align:right;color:#f00"><b>{{vm.totalUnpaidInvoiceCount}} Invoice(s)</b></td><td colspan="3"></td></tr><tr><td colspan="9" style="padding-left:0px;padding-right:0px"><div class="col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecord }}</b></div><div class="col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></uib-tab></uib-tabset></div></div></div></form><script type="text/ng-template" id="downloadModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> Download Customer Invoices by Year and Month </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <legend style="height:32.4px;line-height:32.4px;margin-bottom:10px"> Select Year & Month </legend> <br /> <div class="row"> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.dataForm.Year.$invalid && ($mdl.dataForm.Year.$dirty || $mdl.dataForm.$submitted)}"> <label><b>Year:</b> <i class="fa fa-asterisk req"></i></label> <select name="Year" class="form-control" style="background:#fffeed" ng-model="$mdl.selectedYear" ng-change="$mdl.selectedYearChanged()" ng-options="i as i.name for i in $mdl.yearList" required> <option value="">= {{ \'SELECT_ONE\' | translate }} =</option> </select> <span class="help-block" style="color:#f00" ng-if="$mdl.dataForm.$submitted && $mdl.dataForm.Year.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> <div class="col-lg-6"> <div class="form-group" ng-class="{\'has-error\': $mdl.dataForm.Month.$invalid && ($mdl.dataForm.Month.$dirty || $mdl.dataForm.$submitted)}"> <label><b>Month:</b> <i class="fa fa-asterisk req"></i></label> <select name="Month" class="form-control" style="background:#fffeed" ng-model="$mdl.selectedMonth" ng-change="$mdl.selectedMonthChanged()" ng-options="i as i.name for i in $mdl.monthList" required> <option value="">= {{ \'SELECT_ONE\' | translate }} =</option> </select> <span class="help-block" style="color:#f00" ng-if="$mdl.dataForm.$submitted && $mdl.dataForm.Month.$error.required">* {{ \'REQUIRED\' | translate }}</span> </div> </div> </div> </div> </div> </div> <hr /> <div class="modal-footer"> <b ng-if="$mdl.isLoading" style="margin-right:20px"> <i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'PROCESSING\' | translate }} ... </b> <button class="btn btn-success btn-with-icon" type="submit" ng-disabled="$mdl.isLoading"> <i class="fa fa-download"></i> {{\'DOWNLOAD_EXCEL\' | translate}} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-disabled="$mdl.isLoading" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/pages/superadmin/serverpackagesettings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Package Code</b></label> <span class="form-control" ng-disabled="true">{{ vm.package.code }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Package Name</b></label> <span class="form-control" ng-disabled="true">{{ vm.package.name }}</span></div></div></div><hr><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" style="margin-bottom:0px"><label><b style="color:#00f">No. of Standard Users</b><br><small>(No. of full-license users without feature restriction)</small></label></div></div><div class="col-md-2 col-lg-3"><div class="form-group" style="margin-bottom:0px"><label><b style="color:#f00">No. of Limited Users</b><br><small>(No. of restricted-license users with feature restrictions)</small></label></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><span class="form-control" ng-disabled="true">{{ vm.package.standardUserCount }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><span class="form-control" ng-disabled="true">{{ vm.package.limitedUserCount }}</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Limited Access"><p>List of Limited User Type <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddLimitedUserType()"><i class="ion-plus-round"></i> Add Limited User Type</a><br><br></p><div ng-if="vm.mode==1"><div class="col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center>Please save the Server Package first before adding Limited User Type.</center></h2></div></div><div class="row" ng-if="vm.mode==2"><div class="col-md-9 col-lg-9"><table class="table table-striped" style="border:1px solid #ccc" st-table="vm.package.serverPackageLimiteds" refresh-table=""><thead><tr><th style="width:60px"><b>#</b></th><th><b>Description</b></th><th style="width:180px"><b>Created By</b></th><th style="width:180px"><b>Modified By</b></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.package.serverPackageLimiteds"><td>{{ $index+1 }})</td><td>{{ ntn.description || \'\' }}</td><td style="line-height:110%;padding-top:8px;padding-bottom:8px"><small>{{ ntn.createdBy | uppercase }}<br>{{ ntn.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</small></td><td style="line-height:110%;padding-top:8px;padding-bottom:8px"><small>{{ ntn.modifiedBy | uppercase }}<br>{{ ntn.modifiedDate | date:\'dd/MM/yyyy hh:mma\' }}</small></td><td><a class="btn btn-primary editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditLimitedUserType(ntn.id)"><i class="fa fa-pencil"></i> EDIT</a></td><td><a class="btn btn-danger editable-table-button btn-xs" style="width:80px" confirmed-click="vm.deleteLimitedUserType(ntn.id)" ng-confirm-click="Confirm remove this Limited User Type?"><i class="fa fa-trash-o"></i> &nbsp;DELETE</a></td></tr><tr><td colspan="6" align="center" ng-show="vm.package.serverPackageLimiteds.length==0"><br>The list is empty.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Fees Mgmt" ng-hide="true"><div><i class="fa fa-info-circle"></i> package fees details</div><div class="row" ng-if="vm.mode==2"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:1px solid #ccc;font-size:90%" st-table="vm.package.serverPackageFees" refresh-table=""><thead><tr><th colspan="2"></th><th colspan="4" style="text-align:center;border-left:1px solid #ccc;border-right:1px solid #ccc"><b>Subscription Fees</b></th><th colspan="6"></th></tr><tr><th style="width:60px"><b>#</b></th><th style="width:100px"><b>Module Type</b></th><th style="width:100px;text-align:center;border-left:1px solid #ccc;border-right:1px solid #ccc"><b>Month</b></th><th style="width:100px;text-align:center;border-right:1px solid #ccc"><b>Quarter</b></th><th style="width:100px;text-align:center;border-right:1px solid #ccc"><b>Annual</b></th><th style="width:100px;text-align:center;border-right:1px solid #ccc"><b>Bi-Annual</b></th><th style="width:100px;text-align:center"><b>Discount</b></th><th><b>Remarks</b></th><th style="width:150px"><b>Created By</b></th><th style="width:150px"><b>Modified By</b></th></tr><tr><th></th><th class="form-inline" style="width:100px"><select st-search="moduleType"><option value="">ALL</option><option ng-repeat="m in vm.package.serverPackageFees | unique:\'moduleType\' | orderBy:\'moduleType\'" value="{{m.moduleType}}">{{ m.moduleType | uppercase }}</option></select></th><th colspan="8"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.package.serverPackageFees | filter:vm.searchText"><td>{{ $index+1 }})</td><td>{{ ntn.moduleType || \'\' }}</td><td style="text-align:right;border-left:1px solid #ccc;border-right:1px solid #ccc">{{ ntn.monthlyFee | currency:"" }}</td><td style="text-align:right;border-right:1px solid #ccc">{{ ntn.quarterlyFee | currency:"" }}</td><td style="text-align:right;border-right:1px solid #ccc">{{ ntn.annualFee | currency:"" }}</td><td style="text-align:right;border-right:1px solid #ccc">{{ ntn.biAnnualFee | currency:"" }}</td><td style="text-align:center"><span ng-if="ntn.hasDiscount" style="color:#1d771d"><b>YES</b></span> <span ng-if="!ntn.hasDiscount" style="color:#ff0000"><b>NO</b></span></td><td style="padding-top:8px;padding-bottom:8px;line-height:120%">{{ ntn.remarks }}</td><td style="line-height:110%;padding-top:8px;padding-bottom:8px"><small>{{ ntn.createdBy | uppercase }}<br>{{ ntn.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</small></td><td style="line-height:110%;padding-top:8px;padding-bottom:8px"><small>{{ ntn.modifiedBy | uppercase }}<br>{{ ntn.modifiedDate | date:\'dd/MM/yyyy hh:mma\' }}</small></td></tr><tr><td colspan="10" align="center" ng-show="vm.package.serverPackageFees.length==0"><br>Fee list is empty.<br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="2"><b>Grand Total (RM):</b></td><td style="text-align:right;border-left:1px solid #ccc;border-right:1px solid #ccc"><b>{{ vm.totalMonthlyFee | currency:"" }}</b></td><td style="text-align:right;border-right:1px solid #ccc"><b>{{ vm.totalQuarterlyFee | currency:"" }}</b></td><td style="text-align:right;border-right:1px solid #ccc"><b>{{ vm.totalAnnualFee | currency:"" }}</b></td><td style="text-align:right;border-right:1px solid #ccc"><b>{{ vm.totalBiAnnualFee | currency:"" }}</b></td><td colspan="6">&nbsp;</td></tr></tfoot></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="LimitedUserTypeModal.html"><style type="css/text"> .help-block, .req { color: #f00 !important; } </style> <form name="$mdl.limitedForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} Limited User Type</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.limitedForm.Description.$invalid && ($mdl.limitedForm.Description.$dirty || $mdl.limitedUserTypeForm.$submitted)}"> <label><b>Description:</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-model="$mdl.item.description" required style="background:#fffeed" /> <span style="color:#f00" ng-show="$mdl.limitedForm.$submitted && $mdl.limitedForm.Description.$error.required">* Required</span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div> <label><b>Feature List:</b></label> <span class="pull-right"> Apply Access Template: </span> </div> <div class="form-group"> <a href class="btn btn-primary btn-sm pull-right" confirmed-click="$mdl.applyTemplate_Outlet()" ng-confirm-click="Select modules for \'Outlet Worker\'?"> Outlet Worker </a> </div> <br /> <br /> <div style="max-height:300px;overflow:auto;border:2px solid #ccc"> <div class="checkbox checkbox-primary" style="margin:3px" ng-repeat="f in $mdl.featureList"> <!-- <div ng-show="f.isParent" style="height:10px;margin-left:-20px;"></div> <div ng-show="f.isParent" style="height:20px;margin-left:-20px;border-top:2px dotted #aaa"></div> --> <div style="padding:5px;background-color:#eee;margin-left:-20px;padding-left:30px;" ng-if="f.isParent"> <input type="checkbox" name="Feature" checklist-model="$mdl.selectedFeatures" checklist-value="f" checklist-change="$mdl.limitedForm.Feature.$setValidity(\'required\', $mdl.selectedFeatures.length > 0)" ng-required="!$mdl.selectedFeatures.length" /> <label> <span style="color:#7e3e00"><b>{{ f.name | uppercase }}</b></span> </label> </div> <div style="padding:5px 10px" ng-if="!f.isParent"> <input type="checkbox" name="Feature" checklist-model="$mdl.selectedFeatures" checklist-value="f" checklist-change="$mdl.limitedForm.Feature.$setValidity(\'required\', $mdl.selectedFeatures.length > 0)" ng-required="!$mdl.selectedFeatures.length" /> <label> <span>&nbsp;<i class="fa fa-long-arrow-right"></i> &nbsp;&nbsp;{{ f.name }}</span> </label> </div> </div> </div> <span style="color:#f00" ng-show="$mdl.limitedForm.$submitted && $mdl.limitedForm.Feature.$error.required">* Required</span> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> Confirm </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> Cancel </button> </div> </form></script>');
$templateCache.put('app/pages/superadmin/serverpackagesettings/packageList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped table-hover" st-pipe="vm.retrieveData" st-table="vm.packageData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="14" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Package" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px"><b>#</b></th><th st-sort="code"><b>Code</b></th><th st-sort="name"><b>Package Name</b></th><th><b>Billing Interval</b></th><th><b>Standard Users</b></th><th><b>Limited Users</b></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="item in vm.packageData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.name}}</td><td>{{item.billingIntervalType==1?"MONTH":(item.billingIntervalType==2?"QUARTER":(item.billingIntervalType==3?"ANNUAL":"BI-ANNUAL"))}}</td><td>{{item.standardUserCount}}</td><td>{{item.limitedUserCount}}</td><td></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.serverpackagesettings.update({id:item.id})" rms-check-access="superadmin.serverpackagesettings" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td></tr><tr ng-if="vm.packageData.length<=0"><td colspan="14">No record found.</td></tr></tbody><tfoot><tr><td colspan="14" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/serverpackagesettings/packageUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/serverpackagesettings/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.serverpackagesettings.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/superadmin/serverpackages/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PackageCode.$invalid && (vm.dataForm.PackageCode.$dirty || vm.dataForm.$submitted)}"><label><b>Package Code</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="PackageCode" placeholder="Package Code" ng-model="vm.package.code" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PackageCode.$error.required">* Required</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PackageName.$invalid && (vm.dataForm.PackageName.$dirty || vm.dataForm.$submitted)}"><label><b>Package Name</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="PackageName" placeholder="Package Name" ng-model="vm.package.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PackageName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StorageQuota.$invalid && (vm.dataForm.StorageQuota.$dirty || vm.dataForm.$submitted)}"><label><b>Storage Quota (MB)</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="StorageQuota" placeholder="Feature State" ng-model="vm.package.storageSpaceMB" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StorageQuota.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StorageQuota.$error.number">* Key in Numbers only</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BandwidthQuota.$invalid && (vm.dataForm.BandwidthQuota.$dirty || vm.dataForm.$submitted)}"><label><b>Bandwidth Quota (MB)</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="BandwidthQuota" placeholder="Feature State" ng-model="vm.package.bandwidthMB" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BandwidthQuota.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BandwidthQuota.$error.number">* Key in Numbers only</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.BillingIntervalType.$invalid && (vm.dataForm.BillingIntervalType.$dirty || vm.dataForm.$submitted)}"><label><b>Billing Interval Type</b> <i class="fa fa-asterisk req"></i></label><select class="form-control" name="BillingIntervalType" ng-model="vm.selectedBillingIntervalType" ng-change="vm.selectedBillingIntervalTypeChanged()" ng-options="b as b.name for b in vm.billingIntervalTypes" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.BillingIntervalType.$error.required">* Required</span></div></div></div><hr><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" style="margin-bottom:0px"><label><b style="color:#00f">No. of Standard Users</b> <i class="fa fa-asterisk req"></i><br><small>(No. of full-license users without feature restriction)</small></label></div></div><div class="col-md-2 col-lg-3"><div class="form-group" style="margin-bottom:0px"><label><b style="color:#f00">No. of Limited Users</b> <i class="fa fa-asterisk req"></i><br><small>(No. of restricted-license users with feature restrictions)</small></label></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.StandardUserCount.$invalid && (vm.dataForm.StandardUserCount.$dirty || vm.dataForm.$submitted)}"><input type="number" class="form-control" name="StandardUserCount" ng-model="vm.package.standardUserCount" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StandardUserCount.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.StandardUserCount.$error.number">* Key in Numbers only</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LimitedUserCount.$invalid && (vm.dataForm.LimitedUserCount.$dirty || vm.dataForm.$submitted)}"><input type="number" class="form-control" name="LimitedUserCount" ng-model="vm.package.limitedUserCount" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LimitedUserCount.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LimitedUserCount.$error.number">* Key in Numbers only</span></div></div></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Limited Access"><p>List of Limited User Type <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddLimitedUserType()"><i class="ion-plus-round"></i> Add Limited User Type</a><br><br></p><div ng-if="vm.mode==1"><div class="col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center>Please save the Server Package first before adding Limited User Type.</center></h2></div></div><div class="row" ng-if="vm.mode==2"><div class="col-md-9 col-lg-9"><table class="table table-striped" style="border:1px solid #ccc" st-table="vm.package.serverPackageLimiteds" refresh-table=""><thead><tr><th style="width:60px"><b>#</b></th><th><b>Description</b></th><th style="width:180px"><b>Created By</b></th><th style="width:180px"><b>Modified By</b></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.package.serverPackageLimiteds"><td>{{ $index+1 }})</td><td>{{ ntn.description || \'\' }}</td><td style="line-height:110%;padding-top:8px;padding-bottom:8px"><small>{{ ntn.createdBy | uppercase }}<br>{{ ntn.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</small></td><td style="line-height:110%;padding-top:8px;padding-bottom:8px"><small>{{ ntn.modifiedBy | uppercase }}<br>{{ ntn.modifiedDate | date:\'dd/MM/yyyy hh:mma\' }}</small></td><td><a class="btn btn-primary editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditLimitedUserType(ntn.id)"><i class="fa fa-pencil"></i> EDIT</a></td><td><a class="btn btn-danger editable-table-button btn-xs" style="width:80px" confirmed-click="vm.deleteLimitedUserType(ntn.id)" ng-confirm-click="Confirm remove this Limited User Type?"><i class="fa fa-trash-o"></i> &nbsp;DELETE</a></td></tr><tr><td colspan="6" align="center" ng-show="vm.package.serverPackageLimiteds.length==0"><br>The list is empty.<br>&nbsp;</td></tr></tbody></table></div></div><div class="row"><p><br></p></div></uib-tab><uib-tab heading="Fees Mgmt"><div ng-if="vm.mode!=1"><i class="fa fa-info-circle"></i> Manage package fees. <a href="" class="btn btn-primary btn-with-icon btn-sm" style="margin-left:20px" ng-click="vm.showAddFeeModal()"><i class="ion-plus-round"></i> Add New Fee</a><br>&nbsp;</div><div ng-if="vm.mode==1"><div class="col-lg-12" style="padding:100px 0px 100px;color:#e85656"><h2><center>Please save the Server Package first before adding Fees.</center></h2></div></div><div class="row" ng-if="vm.mode==2"><div class="col-md-12 col-lg-12"><table class="table table-striped" style="border:1px solid #ccc;font-size:90%" st-table="vm.package.serverPackageFees" refresh-table=""><thead><tr><th colspan="2"></th><th colspan="4" style="text-align:center;border-left:1px solid #ccc;border-right:1px solid #ccc"><b>Subscription Fees</b></th><th colspan="7"></th></tr><tr><th style="width:60px"><b>#</b></th><th style="width:100px"><b>Module Type</b></th><th style="width:100px;text-align:center;border-left:1px solid #ccc;border-right:1px solid #ccc"><b>Month</b></th><th style="width:100px;text-align:center;border-right:1px solid #ccc"><b>Quarter</b></th><th style="width:100px;text-align:center;border-right:1px solid #ccc"><b>Annual</b></th><th style="width:100px;text-align:center;border-right:1px solid #ccc"><b>Bi-Annual</b></th><th style="width:100px;text-align:center"><b>Discount</b></th><th style="width:100px;text-align:center"><b>Taxable?</b></th><th><b>Remarks</b></th><th style="width:150px"><b>Created By</b></th><th style="width:150px"><b>Modified By</b></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr><th></th><th class="form-inline" style="width:100px"><select st-search="moduleType"><option value="">ALL</option><option ng-repeat="m in vm.package.serverPackageFees | unique:\'moduleType\' | orderBy:\'moduleType\'" value="{{m.moduleType}}">{{ m.moduleType | uppercase }}</option></select></th><th colspan="11"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.package.serverPackageFees | filter:vm.searchText"><td>{{ $index+1 }})</td><td>{{ ntn.moduleType || \'\' }}</td><td style="text-align:right;border-left:1px solid #ccc;border-right:1px solid #ccc">{{ ntn.monthlyFee | currency:"" }}</td><td style="text-align:right;border-right:1px solid #ccc">{{ ntn.quarterlyFee | currency:"" }}</td><td style="text-align:right;border-right:1px solid #ccc">{{ ntn.annualFee | currency:"" }}</td><td style="text-align:right;border-right:1px solid #ccc">{{ ntn.biAnnualFee | currency:"" }}</td><td style="text-align:center"><span ng-if="ntn.hasDiscount" style="color:#1d771d"><b>YES</b></span> <span ng-if="!ntn.hasDiscount" style="color:#ff0000"><b>NO</b></span></td><td style="text-align:center"><span ng-if="ntn.isTaxable" style="color:#1d771d"><b>YES</b></span> <span ng-if="!ntn.isTaxable" style="color:#ff0000"><b>NO</b></span></td><td style="padding-top:8px;padding-bottom:8px;line-height:120%">{{ ntn.remarks }}</td><td style="line-height:110%;padding-top:8px;padding-bottom:8px"><small>{{ ntn.createdBy | uppercase }}<br>{{ ntn.createdDate | date:\'dd/MM/yyyy hh:mma\' }}</small></td><td style="line-height:110%;padding-top:8px;padding-bottom:8px"><small>{{ ntn.modifiedBy | uppercase }}<br>{{ ntn.modifiedDate | date:\'dd/MM/yyyy hh:mma\' }}</small></td><td><a class="btn btn-primary editable-table-button btn-with-icon btn-xs" ng-click="vm.showEditFeeModal(ntn.id)"><i class="fa fa-pencil"></i> EDIT</a></td><td><a class="btn btn-danger editable-table-button btn-xs" style="width:80px" confirmed-click="vm.deleteFee(ntn.id)" ng-confirm-click="Confirm remove this Fee?"><i class="fa fa-trash-o"></i> &nbsp;DELETE</a></td></tr><tr><td colspan="11" align="center" ng-show="vm.package.serverPackageFees.length==0"><br>Fee list is empty.<br>&nbsp;</td></tr></tbody><tfoot><tr><td colspan="2"><b>Grand Total (RM):</b></td><td style="text-align:right;border-left:1px solid #ccc;border-right:1px solid #ccc"><b>{{ vm.totalMonthlyFee | currency:"" }}</b></td><td style="text-align:right;border-right:1px solid #ccc"><b>{{ vm.totalQuarterlyFee | currency:"" }}</b></td><td style="text-align:right;border-right:1px solid #ccc"><b>{{ vm.totalAnnualFee | currency:"" }}</b></td><td style="text-align:right;border-right:1px solid #ccc"><b>{{ vm.totalBiAnnualFee | currency:"" }}</b></td><td colspan="7">&nbsp;</td></tr></tfoot></table></div></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="LimitedUserTypeModal.html"><style type="css/text"> .help-block, .req { color: #f00 !important; } </style> <form name="$mdl.limitedForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} Limited User Type</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group" ng-class="{\'has-error\': $mdl.limitedForm.Description.$invalid && ($mdl.limitedForm.Description.$dirty || $mdl.limitedUserTypeForm.$submitted)}"> <label><b>Description:</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" ng-model="$mdl.item.description" required /> <span style="color:#f00" ng-show="$mdl.limitedForm.$submitted && $mdl.limitedForm.Description.$error.required">* Required</span> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div> <label><b>Feature List:</b></label> <span class="pull-right"> Apply Access Template: </span> </div> <div class="form-group"> <a href class="btn btn-primary btn-sm pull-right" confirmed-click="$mdl.applyTemplate_Outlet()" ng-confirm-click="Select modules for \'Outlet Worker\'?"> Outlet Worker </a> </div> <br /> <br /> <div style="max-height:300px;overflow:auto;border:2px solid #ccc"> <div class="checkbox checkbox-primary" style="margin:3px" ng-repeat="f in $mdl.featureList"> <!-- <div ng-show="f.isParent" style="height:10px;margin-left:-20px;"></div> <div ng-show="f.isParent" style="height:20px;margin-left:-20px;border-top:2px dotted #aaa"></div> --> <div style="padding:5px;background-color:#eee;margin-left:-20px;padding-left:30px;" ng-if="f.isParent"> <input type="checkbox" name="Feature" checklist-model="$mdl.selectedFeatures" checklist-value="f" checklist-change="$mdl.limitedForm.Feature.$setValidity(\'required\', $mdl.selectedFeatures.length > 0)" ng-required="!$mdl.selectedFeatures.length" /> <label> <span style="color:#7e3e00"><b>{{ f.name | uppercase }}</b></span> </label> </div> <div style="padding:5px 10px" ng-if="!f.isParent"> <input type="checkbox" name="Feature" checklist-model="$mdl.selectedFeatures" checklist-value="f" checklist-change="$mdl.limitedForm.Feature.$setValidity(\'required\', $mdl.selectedFeatures.length > 0)" ng-required="!$mdl.selectedFeatures.length" /> <label> <span>&nbsp;<i class="fa fa-long-arrow-right"></i> &nbsp;&nbsp;{{ f.name }}</span> </label> </div> </div> </div> <span style="color:#f00" ng-show="$mdl.limitedForm.$submitted && $mdl.limitedForm.Feature.$error.required">* Required</span> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> Confirm </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> Cancel </button> </div> </form></script><script type="text/ng-template" id="PackageFeeModal.html"><style type="css/text"> .help-block, .req { color: #f00 !important; } </style> <form name="$mdl.packageFeeForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff">{{ $mdl.title | translate }} Package Fee</h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>Select a Module Type</b> <i class="fa fa-asterisk req"></i></label> <select class="form-control" name="ModuleType" style="background:#fffeed" ng-model="$mdl.selectedModuleType" ng-change="$mdl.selectedModuleTypeChanged()" ng-options="t as t.name for t in $mdl.moduleTypes" required> <option></option> </select> <p class="help-block" ng-show="$mdl.packageFeeForm.Item.$error.required && $mdl.packageFeeForm.$submitted">* Required</p> </div> </div> </div> <div class="row"> <div class="col-lg-4"> <div class="form-group"> <label><b>Monthly Fees</b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="MonthlyFees" class="form-control" ng-model="$mdl.item.monthlyFee" ng-change="$mdl.monthlyFeeChanged()" style="background:#fffeed" min="0" required /> <p class="help-block" ng-show="$mdl.packageFeeForm.MonthlyFees.$error.min && $mdl.packageFeeForm.$submitted">* {{ \'MINIMUM_IS_0\' | translate }}</p> <p class="help-block" ng-show="$mdl.packageFeeForm.MonthlyFees.$error.required && $mdl.packageFeeForm.$submitted">* Required</p> <p class="help-block" ng-show="$mdl.packageFeeForm.MonthlyFees.$error.number && $mdl.packageFeeForm.$submitted">* Key in numbers only</p> </div> </div> <div class="col-lg-4"> <div class="form-group"> <label><b>Quarterly Fees</b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="QuarterlyFees" class="form-control" ng-model="$mdl.item.quarterlyFee" ng-change="$mdl.quarterlyFeeChanged()" style="background:#fffeed" min="0" required /> <p class="help-block" ng-show="$mdl.packageFeeForm.QuarterlyFees.$error.min && $mdl.packageFeeForm.$submitted">* {{ \'MINIMUM_IS_0\' | translate }}</p> <p class="help-block" ng-show="$mdl.packageFeeForm.QuarterlyFees.$error.required && $mdl.packageFeeForm.$submitted">* Required</p> <p class="help-block" ng-show="$mdl.packageFeeForm.QuarterlyFees.$error.number && $mdl.packageFeeForm.$submitted">* Key in numbers only</p> </div> </div> <div class="col-lg-4"> <div class="form-group"> <label><b>Annual Fees</b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="AnnualFees" class="form-control" ng-model="$mdl.item.annualFee" ng-change="$mdl.annualFeeChanged()" style="background:#fffeed" min="0" required /> <p class="help-block" ng-show="$mdl.packageFeeForm.AnnualFees.$error.min && $mdl.packageFeeForm.$submitted">* {{ \'MINIMUM_IS_0\' | translate }}</p> <p class="help-block" ng-show="$mdl.packageFeeForm.AnnualFees.$error.required && $mdl.packageFeeForm.$submitted">* Required</p> <p class="help-block" ng-show="$mdl.packageFeeForm.AnnualFees.$error.number && $mdl.packageFeeForm.$submitted">* Key in numbers only</p> </div> </div> <div class="col-lg-4"> <div class="form-group"> <label><b>Bi-Annual Fees</b> <i class="fa fa-asterisk req"></i></label> <input type="number" name="BiAnnualFees" class="form-control" ng-model="$mdl.item.biAnnualFee" ng-change="$mdl.biAnnualFeeChanged()" style="background:#fffeed" min="0" required /> <p class="help-block" ng-show="$mdl.packageFeeForm.BiAnnualFees.$error.min && $mdl.packageFeeForm.$submitted">* {{ \'MINIMUM_IS_0\' | translate }}</p> <p class="help-block" ng-show="$mdl.packageFeeForm.BiAnnualFees.$error.required && $mdl.packageFeeForm.$submitted">* Required</p> <p class="help-block" ng-show="$mdl.packageFeeForm.BiAnnualFees.$error.number && $mdl.packageFeeForm.$submitted">* Key in numbers only</p> </div> </div> </div> <div class="row"> <div class="col-lg-6"> <div class="form-group"> <label><b>Has Discount?</b><br /> <small>(Quarterly Discount 5%, Annual Discount 10%)</small> </label> <div> <toggle ng-model="$mdl.item.hasDiscount" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger" ng-if="$mdl.item.moduleType!=\'SIM\' && $mdl.item.moduleType!=\'RMS for SAP\'"> </toggle> <span ng-if="$mdl.item.moduleType==\'SIM\'" class="form-control" style="color:#f00"> <b>SIM Card</b> are not entitled to discount. </span> <span ng-if="$mdl.item.moduleType==\'RMS for SAP\'" class="form-control" style="color:#f00"> <b>RMS for SAP</b> are not entitled to discount. </span> </div> </div> </div> <div class="col-lg-6"> <div class="form-group"> <label><b>Is Taxable?</b><br /> <small>(Direct Customer = Yes, Reseller = No)</small> </label> <div> <toggle ng-model="$mdl.item.isTaxable" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"> </toggle> </div> </div> </div> </div> <div class="row"> <div class="col-lg-12"> <div class="form-group"> <label><b>Remarks</b></label> <input type="text" class="form-control" ng-model="$mdl.item.remarks" style="background:#fffeed" /> </div> </div> </div> <div class="row"> <p>&nbsp;</p> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button"> <i class="ion ion-checkmark"></i> Confirm </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> Cancel </button> </div> </form></script>');
$templateCache.put('app/pages/superadmin/serverpackages/packageCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/serverpackages/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Create Package</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.serverpackages.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/superadmin/serverpackages/packageList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.packageData" refresh-table="" style="font-size:90%"><thead><tr><th colspan="14" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Package" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.serverpackages.create" rms-check-access="superadmin.serverpackages" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Package</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px"><b>#</b></th><th st-sort="code"><b>Code</b></th><th st-sort="name"><b>Package Name</b></th><th><b>Billing Interval</b></th><th><b>Currency</b></th><th style="text-align:right" st-sort="monthlyFee"><b>Monthly</b></th><th style="text-align:right" st-sort="quarterlyFee"><b>Quarterly</b></th><th style="text-align:right" st-sort="annualFee"><b>Annual</b></th><th style="text-align:center" class="hide-after">Has Billable?</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th colspan="8"><select st-search="hasBillable"><option value="true">Show Billable Only</option><option value="">Show All</option></select></th><th class="form-inline hide-after" style="text-align:center"><select st-search="hasBillable"><option value="">ALL</option><option ng-repeat="c in vm.packageDataFull | unique:\'hasBillable\'" value="{{c.hasBillable | uppercase}}">{{c.hasBillable?\'Yes\':\'No\'}}</option></select></th><th colspan="3"></th></tr></thead><tbody><tr ng-repeat="item in vm.packageData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.code}}</td><td style="padding-top:11px;padding-bottom:11px;line-height:110%">{{item.name}}</td><td>{{item.billingIntervalType==1?"MONTH":(item.billingIntervalType==2?"QUARTER":(item.billingIntervalType==3?"ANNUAL":"BI-ANNUAL"))}}</td><td>{{ item.currencyCode }}</td><td style="text-align:right !important"><span ng-if="item.billingIntervalType==1" style="color:#00f"><b>{{item.monthlyFee || 0 | number:0}}</b></span> <span ng-if="item.billingIntervalType!=1">{{item.monthlyFee || 0 | number:0}}</span></td><td style="text-align:right !important"><span ng-if="item.billingIntervalType==2" style="color:#00f"><b>{{item.quarterlyFee || 0 | number:0}}</b></span> <span ng-if="item.billingIntervalType!=2">{{item.quarterlyFee || 0 | number:0}}</span></td><td style="text-align:right !important"><span ng-if="item.billingIntervalType==3" style="color:#00f"><b>{{item.annualFee || 0 | number:0}}</b></span> <span ng-if="item.billingIntervalType!=3">{{item.annualFee || 0 | number:0}}</span></td><td style="text-align:center"><i class="fa fa-check" ng-show="item.hasBillable" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.hasBillable" style="color:#f00"></i></td><td></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.serverpackages.update({id:item.id})" rms-check-access="superadmin.serverpackages" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Package" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deletePackage(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this package?" rms-check-access="superadmin.serverpackages" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr><tr ng-if="vm.packageData.length<=0"><td colspan="14">No record found.</td></tr></tbody><tfoot><tr style="color:#00f"><td style="text-align:right" colspan="5"><b>Actual Receivable (RM):</b></td><td style="text-align:right"><b>{{ vm.actualTotalMonthlyFee | currency:"" }}</b></td><td style="text-align:right"><b>{{ vm.actualTotalQuarterlyFee | currency:"" }}</b><br><small>(Discount 5%)</small></td><td style="text-align:right"><b>{{ vm.actualTotalAnnualFee | currency:"" }}</b><br><small>(Discount 10%)</small></td><td style="text-align:right"></td><td colspan="3"></td></tr><tr><td style="text-align:right" colspan="5"><b>Annual Recurring Revenue (RM):</b></td><td colspan="3" style="text-align:center;font-size:14pt;border:1px solid #000"><b>{{ vm.actualGrandTotal | currency:"" }}</b></td><td colspan="4"></td></tr><tr><td colspan="14" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/serverpackages/packageUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/serverpackages/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.serverpackages.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/superadmin/iotregdevices/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> General IoT device information.<br><br>&nbsp;</p><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label for="Company"><b>Linked Company</b></label> <a href="" ng-click="vm.clearCompany()" class="btn btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="vm.selectedCompany!=null"><i class="fa fa-trash"></i> Clear</a><select name="Company" class="form-control" ng-model="vm.selectedCompany" ng-change="vm.selectedCompanyChanged()" ng-options="i as (i.name | uppercase) for i in vm.companies"></select></div></div><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Status</b></label><div><toggle ng-model="vm.iotregdevice.isActive" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceUID.$invalid && (vm.dataForm.DeviceUID.$dirty || vm.dataForm.$submitted)}"><label><b>Device UID</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceUID" placeholder="E.g.: A6E8" ng-model="vm.iotregdevice.deviceUID" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceUID.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MfgDate.$invalid && (vm.dataForm.MfgDate.$dirty || vm.dataForm.$submitted)}"><label><b>Manufactured Date</b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.iotregdevice.mfgDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true"><input type="text" class="form-control calendar" name="MfgDate" placeholder="YYYY-MM-DD" ng-model="vm.iotregdevice.mfgDate" ng-readonly="true" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MfgDate.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceUUID.$invalid && (vm.dataForm.DeviceUUID.$dirty || vm.dataForm.$submitted)}"><label><b>Device UUID</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceUUID" placeholder="E.g.: 0x7D002C000247373530333134" ng-model="vm.iotregdevice.deviceUUID" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceUUID.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceType.$invalid && (vm.dataForm.DeviceType.$dirty || vm.dataForm.$submitted)}"><label><b>Device Type</b> <i class="fa fa-asterisk req"></i></label><select name="DeviceType" class="form-control" style="background:#edfbff" ng-options="i as (i.name | uppercase) for i in vm.deviceTypes" ng-model="vm.selectedType" ng-change="vm.selectedTypeChanged()" required=""><option value="">= Select a Device Type =</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceType.$error.required">* Required</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceModel.$invalid && (vm.dataForm.DeviceModel.$dirty || vm.dataForm.$submitted)}"><label><b>Device Model No.</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceModel" placeholder="E.g.: CM-HT59-LE" ng-model="vm.iotregdevice.model" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceModel.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Description.$invalid && (vm.dataForm.Description.$dirty || vm.dataForm.$submitted)}"><label><b>Description</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Description" placeholder="Describe this device" ng-model="vm.iotregdevice.description" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Description.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group"><label><b>Remarks</b></label> <input type="text" class="form-control" name="Remarks" placeholder="Any special remarks" ng-model="vm.iotregdevice.remarks"></div></div></div><div class="row"><input type="hidden" name="companyId" ng-model="vm.iotregdevice.companyId"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p><p>&nbsp;</p></div></uib-tab><uib-tab heading="Device Associated"><div class="row"><div class="col-md-6 col-lg-6"><p><i class="fa fa-info-circle"></i> A list of gateways assigned to this IoT device.<br>&nbsp;</p><table class="table table-striped table-bordered"><tr><td style="width:30px"><b>#</b></td><td><b>Company</b></td><td><b>Gateway Description</b></td><td style="width:40px"></td></tr><tr ng-repeat="s in vm.iotregdevice.assignedGateways"><td>{{$index+1}})</td><td>{{s.companyName}}</td><td>{{s.description}}</td><td><a href="" class="btn btn-danger btn-xs" ng-if="!vm.isProcessing" confirmed-click="vm.deleteGatewayAssignment(s.id, s.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm remove this Gateway assignment?"><i class="fa fa-trash"></i> Remove Assignment</a> <i class="fa fa-spinner fa-spin fa-fw" ng-if="vm.isProcessing"></i></td></tr><tr ng-if="vm.iotregdevice.assignedGateways.length==0"><td colspan="4"><br><center>No assignment found.</center><br></td></tr></table><br><br>&nbsp;</div></div><div class="row"><div class="col-md-6 col-lg-6"><p><i class="fa fa-info-circle"></i> A list of sensors assigned to this IoT device.<br>&nbsp;</p><table class="table table-striped table-bordered"><tr><td style="width:30px"><b>#</b></td><td><b>Company</b></td><td><b>Sensor Description</b></td><td style="width:40px"></td></tr><tr ng-repeat="s in vm.iotregdevice.assignedSensors"><td>{{$index+1}})</td><td>{{s.companyName}}</td><td>{{s.description}}</td><td><a href="" class="btn btn-danger btn-xs" ng-if="!vm.isProcessing" confirmed-click="vm.deleteSensorAssignment(s.id, s.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm remove the sensor assignment?"><i class="fa fa-trash"></i> Remove Assignment</a> <i class="fa fa-spinner fa-spin fa-fw" ng-if="vm.isProcessing"></i></td></tr><tr ng-if="vm.iotregdevice.assignedSensors.length==0"><td colspan="4"><br><center>No assignment found.</center><br></td></tr></table></div></div><div class="row"><p>&nbsp;</p><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/iotregdevices/iotRegDeviceCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/iotregdevices/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ui-sref="superadmin.iotregdevices.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Create Device</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.iotregdevices.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/superadmin/iotregdevices/iotRegDeviceList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.deviceData" refresh-table="" style="font-size:80%"><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Device" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.iotregdevices.create" rms-check-access="superadmin.iotregdevices" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Device</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="deviceUID">Device UID</th><th st-sort="deviceUUID">Device UUID</th><th st-sort="type">Type</th><th st-sort="model">Model</th><th st-sort="mfgDate">Mfg Date</th><th style="width:250px" st-sort="companyName">Linked Company</th><th st-sort="isActive">Active</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th></th><th></th><th></th><th class="form-inline"><select st-search="type"><option value="">ALL</option><option ng-repeat="c in vm.deviceDataFull | unique:\'type\' | orderBy:\'type\'" value="{{c.type | uppercase}}">{{(c.type | limitTo:25) + (c.type.length > 25 ? \' ...\' : \'\') }}</option></select></th><th class="form-inline"><select st-search="model"><option value="">ALL</option><option ng-repeat="c in vm.deviceDataFull | unique:\'model\' | orderBy:\'model\'" value="{{c.model | uppercase}}">{{(c.model | limitTo:25) + (c.model.length > 25 ? \' ...\' : \'\') }}</option></select></th><th></th><th class="form-inline"><select st-search="companyName"><option value="">ALL</option><option ng-repeat="c in vm.deviceDataFull | unique:\'companyName\' | orderBy:\'companyName\'" value="{{c.companyName | uppercase}}">{{(c.companyName | uppercase | limitTo:25) + (c.companyName.length > 25 ? \' ...\' : \'\') }}</option></select></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-show="vm.deviceData.length<=0 && !vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-show="vm.isLoading"><td colspan="10" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.deviceData | orderBy: \'company\'"><td>{{vm.startIndex+1+$index}})</td><td>{{item.deviceUID}}</td><td>{{item.deviceUUID}}</td><td>{{item.type}}</td><td>{{item.model}}</td><td>{{item.mfgDate | date: "dd-MMM-yyyy" }}</td><td>{{item.companyName | limitTo:25 }} <span ng-if="item.companyName.length>25">...</span></td><td><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.iotregdevices.update({id:item.id})" rms-check-access="superadmin.iotregdevices" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Device" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteDevice(item.id, item.deviceUID)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this device?" rms-check-access="superadmin.iotregdevices" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/iotregdevices/iotRegDeviceUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/iotregdevices/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ui-sref="superadmin.iotregdevices.list" style="margin-right:30px" ng-disabled="vm.isProcessing"><i class="ion ion-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true" ng-disabled="vm.isProcessing"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.iotregdevices.list" ng-disabled="vm.isProcessing"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/superadmin/siotdevices/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> General Smart IOT device information.<br><br>&nbsp;</p><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label for="Company"><b>Linked Company</b></label> <a href="" ng-click="vm.clearCompany()" class="btn btn-xs btn-danger pull-right" style="margin-bottom:5px" ng-if="vm.selectedCompany!=null"><i class="fa fa-trash"></i> Clear</a><select name="Company" class="form-control" ng-model="vm.selectedCompany" ng-change="vm.selectedCompanyChanged()" ng-options="i as (i.name | uppercase) for i in vm.companies"></select></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label><b>Status</b></label><div><toggle ng-model="vm.siotdevice.isActive" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceUID.$invalid && (vm.dataForm.DeviceUID.$dirty || vm.dataForm.$submitted)}"><label><b>Device UID</b> <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="DeviceUID" placeholder="E.g.: A6E8" ng-model="vm.siotdevice.deviceUID" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceUID.$error.required">* Required</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceUUID.$invalid && (vm.dataForm.DeviceUUID.$dirty || vm.dataForm.$submitted)}"><label><b>Device UUID</b> <i class="fa fa-asterisk req"></i></label><div class="input-group"><input type="text" class="form-control" name="DeviceUUID" ng-model="vm.siotdevice.deviceUUID" required=""> <a href="" class="btn btn-primary input-group-addon" style="padding:3px 10px;font-size:9pt" ng-if="vm.mode==1" ng-click="vm.generateUUID()"><i class="fa fa-refresh"></i></a></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceUUID.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.DeviceType.$invalid && (vm.dataForm.DeviceType.$dirty || vm.dataForm.$submitted)}"><label><b>Device Type</b> <i class="fa fa-asterisk req"></i></label><select name="DeviceType" class="form-control" style="background:#edfbff" ng-options="i as (i.description | uppercase) for i in vm.deviceTypeList" ng-model="vm.selectedDeviceType" ng-change="vm.selectedDeviceTypeChanged()" required=""><option value="">= Select a Device Type =</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.DeviceType.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Device Model</b></label> <input type="text" class="form-control" name="DeviceModel" ng-model="vm.selectedDeviceType.deviceModel" ng-disabled="true"></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Device Features</b></label><div class="row"><div class="col-md-3 col-lg-3"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDeviceType.hasTemp"><center><b>TEMP</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDeviceType.hasTemp"><center><b>TEMP</b></center></span></div><div class="col-md-3 col-lg-3"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDeviceType.hasHumi"><center><b>HUMI</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDeviceType.hasHumi"><center><b>HUMI</b></center></span></div><div class="col-md-3 col-lg-3"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDeviceType.hasNPK"><center><b>NPK</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDeviceType.hasNPK"><center><b>NPK</b></center></span></div><div class="col-md-3 col-lg-3"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDeviceType.hasEc"><center><b>EC</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDeviceType.hasEc"><center><b>EC</b></center></span></div></div><br><div class="row"><div class="col-md-3 col-lg-3"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDeviceType.hasPh"><center><b>PH</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDeviceType.hasPh"><center><b>PH</b></center></span></div><div class="col-md-3 col-lg-3"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDeviceType.hasPm"><center><b>PM2.5</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDeviceType.hasPm"><center><b>PM2.5</b></center></span></div><div class="col-md-3 col-lg-3"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDeviceType.hasWdir"><center><b>WIND DIR</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDeviceType.hasWdir"><center><b>WIND DIR</b></center></span></div><div class="col-md-3 col-lg-3"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDeviceType.hasWspd"><center><b>WIND SPD</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDeviceType.hasWspd"><center><b>WIND SPD</b></center></span></div></div><br><div class="row"><div class="col-md-3 col-lg-3"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDeviceType.hasLgtInt"><center><b>LIGHT INT</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDeviceType.hasLgtInt"><center><b>LIGHT INT</b></center></span></div><div class="col-md-3 col-lg-3"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDeviceType.hasElecMeter"><center><b>ELEC METER</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDeviceType.hasElecMeter"><center><b>ELEC METER</b></center></span></div><div class="col-md-3 col-lg-3"><span class="form-control input-sm" style="background:#7bff7b !important" ng-if="vm.selectedDeviceType.hasWaterMeter"><center><b>WATER METER</b></center></span> <span class="form-control input-sm" ng-disabled="true" style="color:#aaa" ng-if="!vm.selectedDeviceType.hasWaterMeter"><center><b>WATER METER</b></center></span></div></div></div></div></div><div class="row"><p>&nbsp;</p><p>&nbsp;</p></div></uib-tab><uib-tab heading="Device Associated"><div class="row"><div class="col-md-6 col-lg-6"><p><i class="fa fa-info-circle"></i> A list of gateways assigned to this IoT device.<br>&nbsp;</p><table class="table table-striped table-bordered"><tr><td style="width:30px"><b>#</b></td><td><b>Company</b></td><td><b>Gateway Description</b></td><td style="width:40px"></td></tr><tr ng-repeat="s in vm.siotdevice.assignedGateways"><td>{{$index+1}})</td><td>{{s.companyName}}</td><td>{{s.description}}</td><td><a href="" class="btn btn-danger btn-xs" ng-if="!vm.isProcessing" confirmed-click="vm.deleteGatewayAssignment(s.id, s.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm remove this Gateway assignment?"><i class="fa fa-trash"></i> Remove Assignment</a> <i class="fa fa-spinner fa-spin fa-fw" ng-if="vm.isProcessing"></i></td></tr><tr ng-if="vm.siotdevice.assignedGateways.length==0"><td colspan="4"><br><center>No assignment found.</center><br></td></tr></table><br><br>&nbsp;</div></div><div class="row"><div class="col-md-6 col-lg-6"><p><i class="fa fa-info-circle"></i> A list of sensors assigned to this IoT device.<br>&nbsp;</p><table class="table table-striped table-bordered"><tr><td style="width:30px"><b>#</b></td><td><b>Company</b></td><td><b>Sensor Description</b></td><td style="width:40px"></td></tr><tr ng-repeat="s in vm.siotdevice.assignedSensors"><td>{{$index+1}})</td><td>{{s.companyName}}</td><td>{{s.description}}</td><td><a href="" class="btn btn-danger btn-xs" ng-if="!vm.isProcessing" confirmed-click="vm.deleteSensorAssignment(s.id, s.description)" ng-confirm-click="*WARNING* This is irreversible. Confirm remove the sensor assignment?"><i class="fa fa-trash"></i> Remove Assignment</a> <i class="fa fa-spinner fa-spin fa-fw" ng-if="vm.isProcessing"></i></td></tr><tr ng-if="vm.siotdevice.assignedSensors.length==0"><td colspan="4"><br><center>No assignment found.</center><br></td></tr></table></div></div><div class="row"><p>&nbsp;</p><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/siotdevices/siotDeviceCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/siotdevices/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ui-sref="superadmin.siotdevices.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Create Device</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.siotdevices.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/superadmin/siotdevices/siotDeviceList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-persist="SASmartIoTDeviceMgmt" st-pipe="vm.retrieveData" st-table="vm.deviceData" refresh-table="" style="font-size:80%"><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Device" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.siotdevices.create" rms-check-access="superadmin.siotdevices" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New Device</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="deviceUID">Device UID</th><th st-sort="deviceUUID">Device UUID</th><th st-sort="deviceType">Type</th><th st-sort="deviceModel">Model</th><th st-sort="deviceName">Name</th><th st-sort="mfgDate">Mfg Date</th><th style="width:250px" st-sort="companyName">Linked Company</th><th st-sort="isActive">Active</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline"><input st-search="deviceUID" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="deviceUUID" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="deviceType" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="deviceModel" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th class="form-inline"><input st-search="companyName" class="form-control input input-sm" style="width:120px"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-show="vm.deviceData.length<=0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>No record found.</center></td></tr><tr ng-show="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-repeat="item in vm.deviceData | orderBy: \'company\'"><td>{{vm.startIndex+1+$index}})</td><td>{{item.deviceUID}}</td><td style="font-family:courier"><b>{{item.deviceUUID}}</b></td><td>{{item.deviceType}}</td><td>{{item.deviceModel}}</td><td>{{item.deviceName}}</td><td>{{item.createdDate | date: "dd-MMM-yyyy" }}</td><td>{{item.companyName | limitTo:25 }} <span ng-if="item.companyName.length>25">...</span></td><td><i class="fa fa-check" ng-show="item.isActive" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.isActive" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.siotdevices.update({id:item.id})" rms-check-access="superadmin.siotdevices" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Device" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteDevice(item.id, item.deviceUID)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this device?" rms-check-access="superadmin.siotdevices" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/siotdevices/siotDeviceUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/siotdevices/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" ui-sref="superadmin.siotdevices.list" style="margin-right:30px" ng-disabled="vm.isProcessing"><i class="ion ion-chevron-left"></i> Back</a> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true" ng-disabled="vm.isProcessing"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.siotdevices.list" ng-disabled="vm.isProcessing"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/superadmin/systemschedulersettings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p><i class="fa fa-info-circle"></i> Please fill in the scheduler settings below.</p><p><br></p><div class="row"><div class="col-lg-12"><legend style="height:32.4px;line-height:32.4px">Asset Maintenance Schedule Reminder</legend></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Enabled</b></label><div><toggle ng-model="vm.setting.assetMaintenanceReminderEnabled" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-lg-2" ng-if="vm.setting.assetMaintenanceReminderEnabled"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AssetTaskHour.$invalid && (vm.dataForm.AssetTaskHour.$dirty || vm.dataForm.$submitted)}"><label><b>Task Hour</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="AssetTaskHour" ng-model="vm.setting.assetMaintenanceReminderHour" min="0" max="23" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AssetTaskHour.$error.min">* {{ \'MINIMUM_IS_0\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AssetTaskHour.$error.max">* Minimum is 23</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AssetTaskHour.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AssetTaskHour.$error.required">* Required</span></div></div><div class="col-lg-2" ng-if="vm.setting.assetMaintenanceReminderEnabled"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.AssetTaskMinute.$invalid && (vm.dataForm.AssetTaskMinute.$dirty || vm.dataForm.$submitted)}"><label><b>Task Minute</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="AssetTaskMinute" ng-model="vm.setting.assetMaintenanceReminderMinute" min="0" max="59" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AssetTaskMinute.$error.min">* {{ \'MINIMUM_IS_0\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AssetTaskMinute.$error.max">* Minimum is 59</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AssetTaskMinute.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.AssetTaskMinute.$error.required">* Required</span></div></div></div><br><div class="row" ng-if="vm.setting.assetMaintenanceReminderEnabled"><div class="col-lg-2"></div><div class="col-lg-10"><div class="form-group" style="margin-bottom:5px"><label><b>Execution Day</b> <i class="fa fa-asterisk req"></i></label></div><div class="row" ng-repeat="c in vm.weekDays"><div class="col-lg-12"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" name="assetweekdays" checklist-model="vm.selectedAssetWeekDays" checklist-value="c.id" checklist-change="vm.dataForm.assetweekdays.$setValidity(\'required\', vm.selectedAssetWeekDays.length > 0)" ng-required="!vm.selectedAssetWeekDays.length"> <label><span style="padding-left:10px">{{ c.name }}</span></label></div></div></div></div></div><div class="row" ng-if="vm.setting.assetMaintenanceReminderEnabled"><div class="col-md-12"><p><div class="col-md-12" ng-class="{\'has-error\': vm.dataForm.$submitted && vm.dataForm.weekdays.$invalid }"><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.weekdays.$invalid">* Require at least ONE (1) Execution Day</span></div></p><p>&nbsp;</p></div></div><p><br></p><div class="row"><div class="col-lg-12"><legend style="height:32.4px;line-height:32.4px">Certificate Expiry Reminder</legend></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b>Enabled</b></label><div><toggle ng-model="vm.setting.certificateExpiryReminderEnabled" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="col-lg-2" ng-if="vm.setting.certificateExpiryReminderEnabled"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CertificateTaskHour.$invalid && (vm.dataForm.CertificateTaskHour.$dirty || vm.dataForm.$submitted)}"><label><b>Task Hour</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="CertificateTaskHour" ng-model="vm.setting.certificateExpiryReminderHour" min="0" max="23" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CertificateTaskHour.$error.min">* {{ \'MINIMUM_IS_0\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CertificateTaskHour.$error.max">* Minimum is 23</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CertificateTaskHour.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CertificateTaskHour.$error.required">* Required</span></div></div><div class="col-lg-2" ng-if="vm.setting.certificateExpiryReminderEnabled"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.CertificateTaskMinute.$invalid && (vm.dataForm.CertificateTaskMinute.$dirty || vm.dataForm.$submitted)}"><label><b>Task Minute</b> <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="CertificateTaskMinute" ng-model="vm.setting.certificateExpiryReminderMinute" min="0" max="59" equired=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CertificateTaskMinute.$error.min">* {{ \'MINIMUM_IS_0\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CertificateTaskMinute.$error.max">* Minimum is 59</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CertificateTaskMinute.$error.number">* {{ \'ENTER_NUMBERS_ONLY\' | translate }}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.CertificateTaskMinute.$error.required">* Required</span></div></div></div><br><div class="row" ng-if="vm.setting.certificateExpiryReminderEnabled"><div class="col-lg-2"></div><div class="col-lg-10"><div class="form-group" style="margin-bottom:5px"><label><b>Execution Day</b> <i class="fa fa-asterisk req"></i></label></div><div class="row" ng-repeat="c in vm.weekDays"><div class="col-lg-12"><div class="checkbox checkbox-primary checkbox-inline"><input type="checkbox" name="certweekdays" checklist-model="vm.selectedCertWeekDays" checklist-value="c.id" checklist-change="vm.dataForm.certweekdays.$setValidity(\'required\', vm.selectedCertWeekDays.length > 0)" ng-required="!vm.selectedCertWeekDays.length"> <label><span style="padding-left:10px">{{ c.name }}</span></label></div></div></div></div></div><div class="row"><div class="col-md-12"><p><div class="col-md-12" ng-class="{\'has-error\': vm.dataForm.$submitted && vm.dataForm.certweekdays.$invalid }"><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.certweekdays.$invalid">* Require at least ONE (1) Execution Day</span></div></p><p>&nbsp;</p></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/systemschedulersettings/systemschedulersettingUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/systemschedulersettings/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/superadmin/systemsettings/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Email Settings"><p><i class="fa fa-info-circle"></i> Please fill in all the relevant information.</p><p><br></p><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SenderName.$invalid && (vm.dataForm.SenderName.$dirty || vm.dataForm.$submitted)}"><label>Sender Name <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SenderName" placeholder="Name to appear as Sender" ng-model="vm.systemSettings.senderName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SenderName.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SenderEmail.$invalid && (vm.dataForm.SenderEmail.$dirty || vm.dataForm.$submitted)}"><label>Sender Email <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SenderEmail" placeholder="Email to appear as Sender Email" ng-model="vm.systemSettings.senderEmail" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SenderEmail.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SMTPServer.$invalid && (vm.dataForm.SMTPServer.$dirty || vm.dataForm.$submitted)}"><label>SMTP Server <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SMTPServer" placeholder="SMTP Server" ng-model="vm.systemSettings.smtpServer" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SMTPServer.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SMTPPort.$invalid && (vm.dataForm.SMTPPort.$dirty || vm.dataForm.$submitted)}"><label>SMTP Port <i class="fa fa-asterisk req"></i></label> <input type="number" class="form-control" name="SMTPPort" placeholder="SMTP Port" ng-model="vm.systemSettings.smtpPort" min="1" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SMTPPort.$error.required">* Required</span></div></div><div class="col-xs-12 col-sm-6 col-md-2 col-lg-2"><div class="form-group"><label>Using SSL <i class="fa fa-asterisk req"></i></label><div><toggle ng-model="vm.systemSettings.smtpUseSsl" ng-change="changed()" on="{{ \'YES\' | translate }}" off="{{ \'NO\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SMTPUsername.$invalid && (vm.dataForm.SMTPUsername.$dirty || vm.dataForm.$submitted)}"><label>SMTP Username <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="SMTPUsername" placeholder="SMTP Username" ng-model="vm.systemSettings.smtpUsername" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SMTPUsername.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.SMTPPassword.$invalid && (vm.dataForm.SMTPPassword.$dirty || vm.dataForm.$submitted)}"><label>SMTP Password <i class="fa fa-asterisk req"></i></label> <input type="password" class="form-control" name="SMTPPassword" placeholder="SMTP Password" ng-model="vm.systemSettings.smtpPassword" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.SMTPPassword.$error.required">* Required</span></div></div></div></uib-tab><uib-tab heading="Copyright"><p><i class="fa fa-info-circle"></i> Please fill in all the relevant information.</p><p><br></p><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Copyright.$invalid && (vm.dataForm.Copyright.$dirty || vm.dataForm.$submitted)}"><label>Copyright <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Copyright" placeholder="Copyright Text" ng-model="vm.systemSettings.copyright" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Copyright.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/systemsettings/systemsettingsUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/systemsettings/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.companies.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/superadmin/uoms/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.UomName.$invalid && (vm.dataForm.UomName.$dirty || vm.dataForm.$submitted)}"><label>U.O.M. Name <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="UomName" placeholder="U.O.M. Name" ng-model="vm.uom.name" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.UomName.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/uoms/uomCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/uoms/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Create U.O.M.</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.uoms.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/superadmin/uoms/uomList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.uomData" refresh-table=""><thead><tr><th colspan="4" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search U.O.M." class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.uoms.create" rms-check-access="superadmin.uoms" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New U.O.M.</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="name">Name</th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="item in vm.uomData"><td>{{vm.startIndex+1+$index}})</td><td>{{item.name}}</td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.uoms.update({id:item.id})" rms-check-access="superadmin.uoms" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Delete Product" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteUom(item.id, item.name)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this U.O.M.?" rms-check-access="superadmin.uoms" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr><tr ng-show="vm.uomData.length<=0"><td colspan="4">No record found.</td></tr></tbody><tfoot><tr><td colspan="4" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/uoms/uomUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/uoms/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.uoms.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/superadmin/systemversion/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Version"><p><i class="fa fa-info-circle"></i> Please fill in the system versions.</p><p><br></p><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.WebAppVersion.$invalid && (vm.dataForm.WebAppVersion.$dirty || vm.dataForm.$submitted)}"><label>Web Application Version <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="WebAppVersion" placeholder="Web UI Version" ng-model="vm.systemversion.webAppVersion" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WebAppVersion.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MobileAppVersion.$invalid && (vm.dataForm.MobileAppVersion.$dirty || vm.dataForm.$submitted)}"><label>Mobile App Version <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="MobileAppVersion" placeholder="Mobile App (Standard) Version" ng-model="vm.systemversion.mobileAppVersion" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MobileAppVersion.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MobileAppVersionV3.$invalid && (vm.dataForm.MobileAppVersionV3.$dirty || vm.dataForm.$submitted)}"><label>Mobile App Version (V3) <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="MobileAppVersionV3" placeholder="Mobile App (Standard) Version" ng-model="vm.systemversion.mobileAppVersionV3" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MobileAppVersionV3.$error.required">* Required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.MobileAppPosVersion.$invalid && (vm.dataForm.MobileAppPosVersion.$dirty || vm.dataForm.$submitted)}"><label>Mobile App (POS) Version <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="MobileAppPosVersion" placeholder="Mobile App (POS) Version" ng-model="vm.systemversion.mobileAppPosVersion" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.MobileAppPosVersion.$error.required">* Required</span></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/systemversion/systemversionUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/systemversion/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="dashboard"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/superadmin/users/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.FirstName.$invalid && (vm.dataForm.FirstName.$dirty || vm.dataForm.$submitted)}"><label for="FirstName">First Name <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="FirstName" placeholder="First Name" ng-model="vm.user.firstName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstName.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.LastName.$invalid && (vm.dataForm.LastName.$dirty || vm.dataForm.$submitted)}"><label for="LastName">Last Name <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="LastName" placeholder="Last Name" ng-model="vm.user.lastName" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.LastName.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label>Status</label><div><toggle ng-model="vm.user.active" ng-change="changed()" on="{{ \'ACTIVE\' | translate }}" off="{{ \'INACTIVE\' | translate }}" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Email.$invalid && (vm.dataForm.Email.$dirty || vm.dataForm.$submitted)}"><label for="Email">Email <i class="fa fa-asterisk req"></i></label> <input type="email" class="form-control" name="Email" placeholder="Email Address" ng-model="vm.user.email" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.required">* Required</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Email.$error.email">* Email format invalid</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label for="Telephone">Telephone</label> <input type="text" class="form-control" name="Telephone" placeholder="Telephone" ng-model="vm.user.phone"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label for="JobTitle">Job Title</label> <input type="text" class="form-control" name="JobTitle" placeholder="Job Title" ng-model="vm.user.jobTitle"></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.PreferredLanguage.$invalid && (vm.dataForm.PreferredLanguage.$dirty || vm.dataForm.$submitted)}"><label><b>Preferred Language</b></label><select class="form-control" name="PreferredLanguage" ng-model="vm.user.preferredLanguage" required=""><option value="">-- {{ \'SELECT_A_LANGUAGE\' | translate }} --</option><option value="en" selected="selected">English</option><option value="ko">Korean</option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.PreferredLanguage.$error.required">* Required</span></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><hr></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Username.$invalid && (vm.dataForm.Username.$dirty || vm.dataForm.$submitted )}"><label for="Username">Username <i class="fa fa-asterisk req"></i></label> <input type="text" class="form-control" name="Username" placeholder="Username" ng-model="vm.user.loginId" required=""> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.FirstName.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.user.usergroupId==\'\' && vm.dataForm.$submitted}"><label>Usergroup <i class="fa fa-asterisk req"></i></label><select class="form-control" name="Usergroup" ng-options="u as u.name for u in vm.usergroups track by u.id" ng-model="vm.usergroups.selected" required=""><option></option></select><span class="help-block" ng-show="vm.dataForm.$submitted && vm.company.usergroupId==\'\'">* Required</span></div></div></div><div class="row" ng-show="vm.mode==1"><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Password.$invalid && (vm.dataForm.Password.$dirty || vm.dataForm.$submitted)}"><label for="password">Password <i class="fa fa-asterisk req"></i></label> <input type="password" class="form-control" name="Password" placeholder="Password" ng-disabled="vm.isRandomPassword" ng-model="vm.user.password" ng-required="vm.mode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Password.$error.required">* Required</span></div></div><div class="col-md-3 col-lg-3"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.ConfirmPassword.$invalid && (vm.dataForm.ConfirmPassword.$dirty || vm.dataForm.$submitted)}"><label for="ConfirmPassword">Confirm Password <i class="fa fa-asterisk req"></i></label> <input type="password" class="form-control" name="ConfirmPassword" placeholder="Confirm Password" ng-disabled="vm.isRandomPassword" ng-required="vm.mode==1"> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.ConfirmPassword.$error.required">* Required</span></div></div></div><div class="row" ng-if="vm.mode==1"><div class="col-md-6 col-lg-6">&nbsp; <label><input type="checkbox" name="RandomPassword" ng-model="vm.isRandomPassword" ng-change="vm.generatePassword()"> <span style="padding-left:5px;font-weight:normal">Generate Random Password</span></label></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="Personal Details"><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label for="FullName">Full Name</label> <input type="text" class="form-control" name="FullName" placeholder="Full Name" ng-model="vm.user.fullName"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label for="NRIC">NRIC No.</label> <input type="text" class="form-control" name="NRIC" placeholder="NRIC No." ng-model="vm.user.identityNo"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label for="Address1">Address 1</label> <input type="text" class="form-control" name="Address1" placeholder="Address 1" ng-model="vm.user.address1"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label for="Address2">Address 2</label> <input type="text" class="form-control" name="Address2" placeholder="Address 2" ng-model="vm.user.address2"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label for="PostalCode">Postal Code</label> <input type="text" class="form-control" name="PostalCode" placeholder="Postal Code" ng-model="vm.user.postcode"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label for="Town">Town / Area</label> <input type="text" class="form-control" name="Town" placeholder="Town / Area" ng-model="vm.user.town"></div></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><label for="State">State</label> <input type="text" class="form-control" name="State" placeholder="State" ng-model="vm.user.state"></div></div><div class="col-md-3 col-lg-3"><div class="form-group"><label for="Country">Country</label> <input type="text" class="form-control" name="Country" placeholder="Country" ng-model="vm.user.country"></div></div></div><div class="row"><div class="col-md-12"><p>&nbsp;</p></div></div></uib-tab><uib-tab heading="Branches"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p>Select at least ONE (1) Branch: <i class="fa fa-asterisk req"></i></p></div></div><div class="row" ng-repeat="(key, value) in vm.branches | groupBy:\'company\'" style="margin-bottom:25px"><div class="col-md-12 col-lg-12"><p style="text-transform:uppercase;color:#7e3e00"><big><b>{{key}}</b></big></p></div><div class="col-md-12 col-lg-12" ng-repeat="b in value | orderBy:\'name\'" style="margin-bottom:5px;line-height:30px"><input type="checkbox" name="branch" style="float:left;width:25px;height:25px" checklist-model="vm.selectedBranches" checklist-value="b" checklist-change="vm.dataForm.branch.$setValidity(\'required\', vm.selectedBranches.length > 0)" ng-required="!vm.selectedBranches.length"><big>&nbsp;&nbsp;&nbsp;{{ b.name }}</big></div></div><div class="row"><div class="col-md-12"><p><div class="col-md-12" ng-class="{\'has-error\': vm.dataForm.$submitted && vm.dataForm.branch.$invalid }"><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.branch.$invalid">* Required at least ONE (1) Branch</span></div></p></div></div></uib-tab><uib-tab heading="Signature" ng-if="vm.mode==2"><div class="row"><div class="col-md-12" style="padding-bottom:10px;"><p>Upload a signature image:</p></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="row"><img ngf-src="picFile || vm.user.signatureLocation" alt="" class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div><div class="row"><div class="col-md-12 col-lg-12"><p><small><i class="fa fa-info-circle"></i> {{ \'RECOMMENDED_TO_UPLOAD_A_LANDSCAPE_IMAGE\' | translate }}</small></p>&nbsp;</div></div><div class="row" style="text-align:center"><div class="btn btn-info btn-with-icon" name="file" ng-model="picFile" ngf-select="vm.setUploadImage(picFile)" ngf-accept="\'image/*\'" ngf-pattern="\'image/*\'" ngf-model-invalid="errorFile" ng-disabled="vm.lockUploadButton" ng-show="!vm.lockUploadButton"><i class="ion ion-android-upload"></i> {{ \'UPLOAD_PICTURE\' | translate }}</div><a href="" ng-click="picFile=null;vm.setUploadImage(picFile)" ng-show="picFile" class="btn btn-default btn-with-icon" ng-disabled="vm.lockUploadButton"><i class="ion ion-android-remove-circle"></i> {{ \'RESET_PICTURE\' | translate }}</a></div><div class="row" ng-show="vm.lockUploadButton" style="text-align:center;color:#f00"><i class="fa fa-info-circle"></i> <span translate="UPLOAD_FUNCTION_IS_DISABLED_DUE_TO_QUOTA_LIMIT_REACHED"></span>.</div><div class="row">&nbsp;</div><div class="row">&nbsp;</div></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/superadmin/users/userCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/users/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Create User</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.users.list"><i class="ion ion-close"></i> Discard</a></div></form>');
$templateCache.put('app/pages/superadmin/users/userList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" st-pipe="vm.retrieveData" st-table="vm.userData" st-safe-src="vm.userDataFull" refresh-table=""><thead><tr><th colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-3 col-lg-3" style="height:35px;line-height:35px;padding-left:0px"><div class="search-input"><span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search User" class="input form-control"></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="superadmin.users.create" rms-check-access="superadmin.users" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i>Add New User</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px">Show per page:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="company">Company</th><th st-sort="loginId">Username</th><th st-sort="firstName" colspan="2">Full Name</th><th st-sort="email">Email</th><th>Active</th><th style="width:40px"></th><th style="width:40px"></th><th style="width:40px"></th></tr></thead><tbody><tr ng-repeat="item in vm.userData | orderBy:\'company\'"><td>{{vm.startIndex+1+$index}})</td><td><div ng-show="item.company.length>1" style="line-height:100%;padding:8px 0px"><div ng-repeat="c in item.company"><small>{{c}}</small></div></div><div ng-show="item.company.length==1" ng-repeat="c in item.company">{{c}}</div></td><td>{{item.loginId}}</td><td colspan="2">{{item.firstName}} {{item.lastName}}</td><td>{{item.email}}</td><td><i class="fa fa-check" ng-show="item.active" style="color:#0f0"></i> <i class="fa fa-times" ng-show="!item.active" style="color:#f00"></i></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="superadmin.users.update({id:item.id})" rms-check-access="superadmin.users" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil"></i></a></td><td align="center"><a href="" title="Reset Password" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#d58512" confirmed-click="vm.resetUserPwd(item.email)" ng-confirm-click="Confirm reset password?" rms-check-access="superadmin.users" rms-check-access-perm-type="UPDATE"><i class="fa fa-key fa-flip-horizontal"></i></a></td><td align="center"><a href="" title="Delete User" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#f00" confirmed-click="vm.deleteUser(item.id, item.loginId)" ng-confirm-click="*WARNING* This is irreversible. Confirm delete this user?" rms-check-access="superadmin.users" rms-check-access-perm-type="DELETE"><i class="fa fa-trash"></i></a></td></tr></tbody><tfoot><tr><td colspan="10" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">Total Records: <b>{{ vm.numOfRecordDisplayed }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/superadmin/users/userUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/superadmin/users/_form.html\'"></section><div class="footer-bar"><button type="submit" class="btn btn-primary btn-with-icon" ng-click="vm.submitted=true"><i class="ion ion-checkmark"></i> Save Changes</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="superadmin.users.list"><i class="ion ion-close"></i> Discard Changes</a></div></form>');
$templateCache.put('app/pages/withdrawalrequests/wrlist/_form.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{ \'GENERAL\' | translate }}"><p ng-if="vm.originalStatus==\'NEW\'"><small><i class="fa fa-info-circle"></i> <span translate="PLEASE_FILL_IN_THE_WITHDRAWAL_DETAILS_BELOW"></span>.</small><br><br></p><p ng-if="vm.originalStatus!=\'NEW\'"><small><i class="fa fa-warning"></i> <span translate="ALL_THE_FIELDS_WILL_BE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NO_LONGER"></span> <b translate="NEW"></b>.</small><br><br></p><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group"><label><b><span translate="WITHDRAWAL_REQUEST_NO"></span>.</b></label> <span class="form-control" style="color:#333">{{vm.wr.withdrawalNo || \'AUTONUMBER\' }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.WithdrawalDate.$invalid && (vm.dataForm.WithdrawalDate.$dirty || vm.dataForm.$submitted)}"><label for="WithdrawalDate"><b translate="WITHDRAWAL_DATE"></b> <i class="fa fa-asterisk req"></i></label><div moment-picker="vm.wr.withdrawalDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="WithdrawalDate" autocomplete="off" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.wr.withdrawalDate" required=""></div><span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WithdrawalDate.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.Status.$invalid && (vm.dataForm.Status.$dirty || vm.dataForm.$submitted)}"><label><b>{{ \'STATUS\' | translate }}</b> <i class="fa fa-asterisk req"></i></label><select name="Status" class="form-control" style="color:#333" ng-if="vm.originalStatus==\'NEW\'" ng-change="vm.selectStatus()" ng-disabled="vm.originalStatus!=\'NEW\'" ng-options="u as u.name for u in vm.wrStatuses track by u.id" ng-model="vm.selectedStatus" required=""><option></option></select><span class="form-control" style="color:#00f" ng-if="vm.originalStatus!=\'NEW\'">{{vm.wr.status}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.Status.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div></div><div class="row"><div class="col-md-2 col-lg-2"><div class="form-group" ng-class="{\'has-error\': vm.dataForm.WithdrawalType.$invalid && (vm.dataForm.WithdrawalType.$dirty || vm.dataForm.$submitted)}"><label><b translate="WITHDRAWAL_TYPE"></b> <i class="fa fa-asterisk req"></i></label><select name="WithdrawalType" class="form-control" style="color:#333" ng-if="vm.originalStatus==\'NEW\'" ng-disabled="vm.wr.withdrawalRequestItems.length!=0" ng-change="vm.selectType()" ng-options="u as u.name for u in vm.wrTypes track by u.id" ng-model="vm.selectedType" required=""><option></option></select><span class="form-control" style="color:#00f" ng-if="vm.originalStatus!=\'NEW\'">{{vm.getWithdrawalType()}}</span> <span class="help-block" ng-show="vm.dataForm.$submitted && vm.dataForm.WithdrawalType.$error.required">* {{ \'REQUIRED\' | translate }}</span></div></div><div class="col-md-4 col-lg-4"><div class="form-group"><label><b translate="DEPARTMENT"></b></label><select class="form-control" name="Department" style="color:#333" ng-disabled="vm.originalStatus!=\'NEW\'" ng-options="u as u.name for u in vm.departments track by u.id" ng-change="vm.selectDepartment()" ng-model="vm.selectedDepartment"><option></option></select></div></div></div><div class="row" ng-if="vm.wr.status==\'NEW\' && vm.wr.withdrawalRequestItems.length!=0"><div class="col-md-6 col-lg-6"><div class="form-group"><small style="color:#f00">* <span translate="WITHDRAWAL_TYPE_OPTION_IS_LOCKED_BECAUSE_YOU_HAVE_ADDED_ITEM(S)_TO_THE_LIST"></span>.<br>* <span translate="TO_CHANGE_WITHDRAWAL_TYPE,_REMOVE_ALL_ITEMS_FROM_THE_LIST_FIRST"></span>.<br></small></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>Ref. Production Job No.</b> (Optional)</label><div class="input-group"><span class="form-control" ng-disabled="true" style="color:#00f">{{vm.wr.jobNo || \'-\'}}</span> <input type="text" class="form-control" name="ProductionJobNo" ng-hide="true" ng-model="vm.wr.jobId"> <a href="" class="btn btn-primary btn-with-icon input-group-addon" style="padding:3px 10px;font-size:9pt" ng-click="vm.showSelectJobModal()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && vm.wr.jobId==null"><i class="ion ion-android-checkmark-circle"></i> <span translate="SELECT"></span></a> <a href="" class="btn btn-default btn-with-icon input-group-addon" style="padding:3px 10px;font-size:9pt;color:#f00" ng-click="vm.clearSelectJob()" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && vm.wr.jobId!=null"><i class="ion ion-close"></i> <span translate="CLEAR"></span></a></div></div></div></div><div class="row"><div class="col-md-6 col-lg-6"><div class="form-group"><label><b>{{ \'REMARKS\' | translate }}</b></label> <textarea class="form-control" style="color:#333" ng-disabled="vm.originalStatus!=\'NEW\'" ng-model="vm.wr.remarks">\n\t\t\t\t\t\t\t</textarea></div></div></div><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></uib-tab><uib-tab heading="Raw Mat List" ng-if="vm.wr.withdrawalType==\'RM\'"><div class="row"><div class="col-md-5 col-lg-5" style="min-height:500px;padding-right:0px"><p ng-show="vm.originalStatus==\'NEW\'"><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_RAW_MATERIALS_ON_THE_LIST"></span>.</small></p><p ng-show="vm.originalStatus!=\'NEW\'"><small><i class="fa fa-exclamation-triangle" style="color:#fffc00"></i> <span translate="ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="NEW"></b>.</small></p><table class="table table-striped" style="border:1px solid #ccc;font-size:90%" st-pipe="vm.refreshItems" st-table="vm.wr.withdrawalRequestItems" refresh-table=""><thead><tr><th style="width:60px"><b>#</b></th><th><b translate="ITEM_DESCRIPTION"></b></th><th style="text-align:right"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b translate="UOM"></b></th><th style="width:80px" ng-if="vm.originalStatus==\'NEW\'"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.wr.withdrawalRequestItems"><td>{{ $index+1 }})</td><td style="line-height:110%;padding-top:6px;padding-bottom:8px;"><small style="color:#777">{{ ntn.code }}</small><br>{{ ntn.description || \'\' }}</td><td style="text-align:right">{{ ntn.quantity | number }}</td><td>{{ ntn.uomName }}</td><td ng-if="vm.originalStatus==\'NEW\'"><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeItem(ntn)" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="5" align="center" ng-if="vm.wr.withdrawalRequestItems.length==0"><br><span translate="ITEM_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div><div class="col-md-1 col-lg-1" style="padding:0px"></div><div class="col-md-6 col-lg-6" style="padding-left:0px"><div class="row"><div class="col-md-6 col-lg-6" ng-if="vm.originalStatus==\'NEW\'"><p><small><span translate="ENTER_MINIMUM_3_CHARACTERS_TO_BEGIN_SEARCH"></span>:</small></p><input type="text" class="form-control searchbox" name="Search" placeholder="Search for Raw Material" ng-change="vm.searchRawMat(vm.searchText)" ng-disabled="vm.lockButtons" ng-model="vm.searchText" ng-model-options="{ debounce: 500 }"><p><small><span translate="SEARCH_RESULT"></span>: {{vm.searchResults.length || 0}}</small> <small style="padding-left:20px" ng-if="vm.isLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="SEARCHING"></span>...</small></p></div></div><div class="row" style="height:360px;overflow:auto"><div class="col-md-12" ba-panel="" ng-repeat="item in vm.searchResults"><div style="padding:15px"><div class="row"><div class="col-md-6 col-lg-6"><small><span ng-bind-html="item.code || \'-\' | highlight: vm.searchText"></span></small><br><b><span ng-bind-html="item.description || \'-\' | highlight: vm.searchText"></span></b></div><div class="col-md-2 col-lg-2" style="padding-right:0px"><div class="form-group"><input type="number" class="form-control" placeholder="QTY" ng-model="item.quantity"></div></div><div class="col-md-2 col-lg-2" style="line-height:32px"><span ng-bind-html="item.uomName || \'-\'" style="font-weight:bold"></span></div><div class="col-md-2 col-lg-2"><a href="" class="btn btn-primary btn-sm btn-with-icon" style="width:100%;" ng-click="vm.addItem(item)"><i class="fa fa-plus"></i> <span translate="ADD"></span></a></div></div></div></div></div></div></div></uib-tab><uib-tab heading="Semi F.G. List" ng-if="vm.wr.withdrawalType==\'SFG\'"><div class="row"><div class="col-md-5 col-lg-5" style="min-height:500px;padding-right:0px"><p ng-show="vm.originalStatus==\'NEW\'"><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_SEMI_F.G._ON_THE_LIST"></span>.</small></p><p ng-show="vm.originalStatus!=\'NEW\'"><small><i class="fa fa-exclamation-triangle" style="color:#fffc00"></i> <span translate="ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="NEW"></b>.</small></p><table class="table table-striped" style="border:1px solid #ccc;font-size:90%" st-pipe="vm.refreshItems" st-table="vm.wr.withdrawalRequestItems" refresh-table=""><thead><tr><th style="width:60px"><b>#</b></th><th><b translate="SEMI_F.G._DESCRIPTION"></b></th><th style="text-align:right"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b translate="UOM"></b></th><th style="width:80px" ng-if="vm.originalStatus==\'NEW\'"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.wr.withdrawalRequestItems"><td>{{ $index+1 }})</td><td style="line-height:110%;padding-top:6px;padding-bottom:8px;"><small style="color:#777">{{ ntn.code }}</small><br>{{ ntn.description || \'\' }}</td><td style="text-align:right">{{ ntn.quantity | number }}</td><td>{{ ntn.uomName }}</td><td ng-if="vm.originalStatus==\'NEW\'"><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeItem(ntn)" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="5" align="center" ng-if="vm.wr.withdrawalRequestItems.length==0"><br><span translate="SEMI_F.G._LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div><div class="col-md-1 col-lg-1" style="padding:0px"></div><div class="col-md-6 col-lg-6" style="padding-left:0px"><div class="row"><div class="col-md-6 col-lg-6" ng-if="vm.originalStatus==\'NEW\'"><p><small><span translate="ENTER_MINIMUM_3_CHARACTERS_TO_BEGIN_SEARCH"></span>:</small></p><input type="text" class="form-control searchbox" name="Search" placeholder="Search for Semi F.G." ng-change="vm.searchSFG(vm.searchText)" ng-disabled="vm.lockButtons" ng-model="vm.searchText" ng-model-options="{ debounce: 500 }"><p><small><span translate="SEARCH_RESULT"></span>: {{vm.searchResults.length || 0}}</small> <small style="padding-left:20px" ng-if="vm.isLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="SEARCHING"></span>...</small></p></div></div><div class="row" style="height:360px;overflow:auto"><div class="col-md-12" ba-panel="" ng-repeat="item in vm.searchResults"><div style="padding:15px"><div class="row"><div class="col-md-6 col-lg-6"><small><span ng-bind-html="item.code || \'-\' | highlight: vm.searchText"></span></small><br><b><span ng-bind-html="item.description || \'-\' | highlight: vm.searchText"></span></b></div><div class="col-md-2 col-lg-2" style="padding-right:0px"><div class="form-group"><input type="number" class="form-control" placeholder="QTY" ng-model="item.quantity"></div></div><div class="col-md-2 col-lg-2" style="line-height:32px"><span ng-bind-html="item.uomName || \'-\'" style="font-weight:bold"></span></div><div class="col-md-2 col-lg-2"><a href="" class="btn btn-primary btn-sm btn-with-icon" style="width:100%;" ng-click="vm.addSFG(item)"><i class="fa fa-plus"></i> <span translate="ADD"></span></a></div></div></div></div></div></div></div></uib-tab><uib-tab heading="F.Goods List" ng-if="vm.wr.withdrawalType==\'FG\'"><div class="row"><div class="col-md-5 col-lg-5" style="min-height:500px;padding-right:0px"><p ng-show="vm.originalStatus==\'NEW\'"><small><i class="fa fa-info-circle"></i> <span translate="MANAGE_FINISHED_GOODS_ON_THE_LIST"></span>.</small></p><p ng-show="vm.originalStatus!=\'NEW\'"><small><i class="fa fa-exclamation-triangle" style="color:#fffc00"></i> <span translate="ALL_FIELDS_ARE_LOCKED_TO_PREVENT_FURTHER_EDIT_WHEN_THE_STATUS_IS_NOT"></span> <b translate="NEW"></b>.</small></p><table class="table table-striped" style="border:1px solid #ccc;font-size:90%" st-pipe="vm.refreshItems" st-table="vm.wr.withdrawalRequestItems" refresh-table=""><thead><tr><th style="width:60px"><b>#</b></th><th><b translate="FINISHED_GOODS_DESCRIPTION"></b></th><th style="text-align:right"><b>{{ \'QUANTITY\' | translate }}</b></th><th><b translate="UOM"></b></th><th style="width:80px" ng-if="vm.originalStatus==\'NEW\'"></th></tr></thead><tbody><tr ng-repeat="ntn in vm.wr.withdrawalRequestItems"><td>{{ $index+1 }})</td><td style="line-height:110%;padding-top:6px;padding-bottom:8px;"><small style="color:#777">{{ ntn.code }}</small><br>{{ ntn.description || \'\' }}</td><td style="text-align:right">{{ ntn.quantity | number }}</td><td>{{ ntn.uomName }}</td><td ng-if="vm.originalStatus==\'NEW\'"><a class="btn btn-danger editable-table-button btn-with-icon btn-xs" ng-click="vm.removeItem(ntn)" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\'"><i class="fa fa-trash-o"></i> {{ \'DELETE\' | translate }}</a></td></tr><tr><td colspan="5" align="center" ng-if="vm.wr.withdrawalRequestItems.length==0"><br><span translate="FINISHED_GOODS_LIST_IS_EMPTY"></span>.<br>&nbsp;</td></tr></tbody></table><div class="row"><p>&nbsp;</p></div><div class="row"><p>&nbsp;</p></div></div><div class="col-md-1 col-lg-1" style="padding:0px"></div><div class="col-md-6 col-lg-6" style="padding-left:0px"><div class="row"><div class="col-md-6 col-lg-6" ng-if="vm.originalStatus==\'NEW\'"><p><small><span translate="ENTER_MINIMUM_3_CHARACTERS_TO_BEGIN_SEARCH"></span>:</small></p><input type="text" class="form-control searchbox" name="Search" placeholder="Search for Finished Goods" ng-change="vm.searchFG(vm.searchText)" ng-disabled="vm.lockButtons" ng-model="vm.searchText" ng-model-options="{ debounce: 500 }"><p><small><span translate="SEARCH_RESULT"></span>: {{vm.searchResults.length || 0}}</small> <small style="padding-left:20px" ng-if="vm.isLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> <span translate="SEARCHING"></span>...</small></p></div></div><div class="row" style="height:360px;overflow:auto"><div class="col-md-12" ba-panel="" ng-repeat="item in vm.searchResults"><div style="padding:15px"><div class="row"><div class="col-md-6 col-lg-6"><small><span ng-bind-html="item.code || \'-\' | highlight: vm.searchText"></span></small><br><b><span ng-bind-html="item.description || \'-\' | highlight: vm.searchText"></span></b></div><div class="col-md-2 col-lg-2" style="padding-right:0px"><div class="form-group"><input type="number" class="form-control" placeholder="QTY" ng-model="item.quantity"></div></div><div class="col-md-2 col-lg-2" style="line-height:32px"><span ng-bind-html="item.uomName || \'-\'" style="font-weight:bold"></span></div><div class="col-md-2 col-lg-2"><a href="" class="btn btn-primary btn-sm btn-with-icon" style="width:100%;" ng-click="vm.addFG(item)"><i class="fa fa-plus"></i> <span translate="ADD"></span></a></div></div></div></div></div></div></div></uib-tab></uib-tabset></div></div></div><script type="text/ng-template" id="JobListModal.html"><form name="$mdl.dataForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> Select a Production Job </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <table class="table table-striped table-hover" style="font-size:10pt" st-pipe="$mdl.retrieveData" st-table="$mdl.jobData" refresh-table> <thead> <tr> <th colspan="1" style="padding-left:0px"> <div class="search-input"> <span class="fa fa-search"></span> <input st-search="" type="search" placeholder="Search Job" class="input form-control" /> </div> </th> <th colspan="5" style="padding-right:0px"> <div class="col-md-12 col-lg-12" style="padding-right:0px"> <div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="$mdl.pageSize"> </div> </div> </th> </tr> <tr class="sortable"> <th st-sort="jobNo" st-sort-default="reverse"> Job No.</th> <th st-sort="jobDate" style="padding-top:11px;padding-bottom:11px;line-height:110%">Job Date<br /><small>(DD/MM/YYYY)</small></th> <th></th> <th st-sort="productName">Product Name</th> <th st-sort="status">Status</th> <th style="width:40px"></th> </tr> </thead> <tbody> <tr ng-if="$mdl.isLoading"> <td colspan="6" style="line-height:100px"> <center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading production jobs ...</b></center> </td> </tr> <tr ng-if="!$mdl.isLoading && $mdl.jobData.length==0"> <td colspan="6" style="line-height:100px"> <center><b> No production job is available.</b></center> </td> </tr> <tr ng-repeat="item in $mdl.jobData"> <td><b>{{item.jobNo}}</b></td> <td>{{item.jobDate | date: "dd/MM/yyyy"}}</td> <td class="text-center" style="width:80px;line-height:90%"> <div class="report-type-tag"> <b>{{item.productType}}</b> </div> </td> <td style="padding-top:8px;padding-bottom:8px;line-height:130%">{{item.productName || \'-\'}}</td> <td><b>{{item.status}}</b></td> <td align="center"> <a href title="Select" class="btn btn-primary btn-xs btn-with-icon" ng-click="$mdl.selectJob(item)"> <big><i class="fa fa-check"></i> {{ "SELECT" | translate }}</big> </a> </td> </tr> </tbody> </table> </div> </div> </div> <hr /> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.isLoading"> <i class="ion ion-close"></i> <span translate="CLOSE_WINDOW"></span> </button> </div> </form></script>');
$templateCache.put('app/pages/withdrawalrequests/wrlist/wrCreate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/withdrawalrequests/wrlist/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-default btn-with-icon" style="margin-right:20px" ui-sref="withdrawalrequests.wrlist" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion ion-checkmark"></i> <span translate="CREATE_W.R"></span>.</button> <a href="" class="btn btn-danger btn-with-icon" ui-sref="withdrawalrequests.wrlist"><i class="ion ion-close"></i> <span translate="DISCARD"></span></a></div></form>');
$templateCache.put('app/pages/withdrawalrequests/wrlist/wrList.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel=""><div class="horizontal-scroll"><table class="table table-striped" style="font-size:85%" st-persist="WithdrawalRequestListing" st-pipe="vm.retrieveData" st-table="vm.data" st-safe-src="vm.dataFull" refresh-table=""><thead><tr><th colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="height:35px;line-height:35px;padding-left:0px"><a href="" class="btn btn-primary btn-with-icon" ui-sref="withdrawalrequests.wrlist.create" rms-check-access="withdrawalrequests.wrlist" rms-check-access-perm-type="CREATE"><i class="ion-plus-round"></i><span translate="ADD_NEW_W.R"></span>.</a></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2" style="height:35px;line-height:35px"><span translate="SHOW_PER_PAGE"></span>:<ui-select ng-model="vm.pageSize" class="btn-group bootstrap-select form-control" style="width:70px" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ vm.pageSize }}</span></ui-select-match><ui-select-choices repeat="i in vm.pageSizeOption"><span ng-bind-html="i"></span></ui-select-choices></ui-select></div><div class="col-xs-10 col-sm-10 col-md-5 col-lg-5" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></th></tr><tr class="sortable"><th style="width:60px">#</th><th st-sort="withdrawalNo" st-sort-default="reverse"><span translate="W.R._NO"></span>.</th><th st-sort="withdrawalDate"><span translate="W.R._DATE"></span><br><small->(DD/MM/YYYY)</small-></th><th st-sort="withdrawalType"><span translate="W.R._TYPE"></span></th><th st-sort="jobNo">{{ \'JOB_NO\' | translate }}</th><th st-sort="branchName">{{ \'BRANCH\' | translate }}</th><th st-sort="departmentName"><span translate="DEPARTMENT"></span></th><th st-sort="createdBy"><span translate="CREATED_BY"></span></th><th st-sort="status">{{ \'STATUS\' | translate }}</th><th style="width:40px"></th><th style="width:40px"></th></tr><tr class="sortable"><th class="form-inline" style="padding-left:0px;padding-right:0px"><a href="" class="btn btn-danger btn-sm" style="padding:3px 10px;font-size:9pt" ng-click="vm.resetSearch()" st-reset-search="">{{ \'RESET\' | translate }}</a></th><th class="form-inline" colspan="2"><input st-search="withdrawalNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><select st-search="withdrawalType" class="form-control input input-sm" style="width:130px"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="t in vm.typeList" value="{{ t.id }}">{{ t.name }}</option></select></th><th class="form-inline"><input st-search="jobNo" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="branchName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="departmentName" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><input st-search="createdBy" class="form-control input input-sm" style="width:120px"></th><th class="form-inline"><select st-search="status" class="form-control input input-sm" style="width:120px"><option value="">{{ \'ALL\' | translate }}</option><option ng-repeat="s in vm.statusList" value="{{ s.id }}">{{ s.name }}</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-if="vm.data.length==0 && !vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><center>{{ \'NO_RECORD_FOUND\' | translate }}</center></td></tr><tr ng-if="vm.isLoading"><td colspan="11" style="height:100px;line-height:100px"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'LOADING_DATA\' | translate }} ...</b></center></big></td></tr><tr ng-repeat="item in vm.data"><td>{{vm.startIndex+1+$index}})</td><td>{{item.withdrawalNo}}</td><td>{{item.withdrawalDate | date: "dd/MM/yyyy" }}</td><td>{{item.withdrawalType}}</td><td>{{item.jobNo || \'-\'}}</td><td>{{item.branchName | uppercase}}</td><td>{{item.departmentName || \'-\' | uppercase}}</td><td>{{item.createdBy | uppercase | limitTo: 10}}<span ng-if="item.createdBy.length>10">...</span></td><td>{{item.status | uppercase}}</td><td align="center"><a href="" title="Print W.R." class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;color:#00f" ng-if="item.status!=\'NEW\' && item.status!=\'CONFIRMED\' && item.status!=\'CANCELLED\'" ng-click="vm.printWR(item.id, item.withdrawalNo)" rms-check-access="withdrawalrequests.wrlist" rms-check-access-perm-type="EXPORT"><i class="fa fa-print"></i></a></td><td align="center"><a href="" title="Edit" class="btn btn-default btn-xs" style="display:inline-block;font-size:12pt;" ui-sref="withdrawalrequests.wrlist.update({id:item.id})" rms-check-access="withdrawalrequests.wrlist" rms-check-access-perm-type="UPDATE"><i class="fa fa-pencil" ng-show="item.status==\'NEW\'"></i> <i class="fa fa-eye" ng-show="item.status!=\'NEW\'"></i></a></td></tr></tbody><tfoot><tr><td colspan="11" style="padding-left:0px;padding-right:0px"><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="height:35px;line-height:35px;padding-left:0px">{{ \'TOTAL_RECORDS\' | translate}}: <b>{{ vm.numOfRecord }}</b></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6" style="padding-right:0px"><div class="text-right" st-pagination="" st-displayed-pages="5" st-items-by-page="vm.pageSize"></div></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/withdrawalrequests/wrlist/wrUpdate.html','<form name="vm.dataForm" ng-submit="vm.submit()" novalidate=""><section class="form-content" data-ng-include="" src="\'app/pages/withdrawalrequests/wrlist/_form.html\'"></section><div class="footer-bar"><a href="" class="btn btn-primary btn-with-icon" style="margin-right:30px" ui-sref="withdrawalrequests.wrlist" ng-disabled="vm.lockButtons"><i class="ion ion-chevron-left"></i> <span translate="BACK"></span></a> <button type="submit" class="btn btn-primary btn-with-icon" style="margin-right:30px" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus==\'NEW\' && !vm.isLoading"><i class="ion ion-checkmark"></i> <span translate="SAVE_CHANGES"></span></button> <a href="" class="btn btn-success btn-with-icon" ng-disabled="vm.lockButtons" confirmed-click="vm.approveWR()" ng-confirm-click="Approve this Withdrawal Request?" ng-if="vm.originalStatus==\'CONFIRMED\' && !vm.isLoading && !vm.isProcessing" rms-check-access="withdrawalrequests.wrlist" rms-check-access-perm-type="APPROVE"><i class="fa fa-check-circle"></i> <span translate="APPROVE_W.R"></span>.</a> <a href="" class="btn btn-danger btn-with-icon" ng-disabled="vm.lockButtons" ng-if="vm.mode==2 && (vm.originalStatus==\'NEW\' || vm.originalStatus==\'CONFIRMED\') && !vm.isProcessing" ng-confirm-click="Confirm cancel this Withdrawal Request?" confirmed-click="vm.cancelWR()" rms-check-access="withdrawalrequests.wrlist" rms-check-access-perm-type="APPROVE"><i class="fa fa-trash"></i> <span translate="CANCEL_W.R"></span>.</a> <span class="btn btn-with-icon" style="margin-right:30px;color:#fff" ng-if="vm.isProcessing"><i class="fa fa-spinner fa-spin fa-fw"></i> {{ \'PROCESSING\' | translate }}...</span> <a href="" class="btn btn-success btn-with-icon" style="margin-left:30px" ng-disabled="vm.lockButtons" confirmed-click="vm.deliverWR()" ng-confirm-click="Confirm Delivery for this Withdrawal Request?" ng-if="vm.originalStatus==\'APPROVED\' && !vm.isLoading"><i class="fa fa-check-circle"></i> <span translate="DELIVER_W.R."></span></a> <a href="" class="btn btn-success btn-with-icon" style="margin-left:30px" ng-disabled="vm.lockButtons" confirmed-click="vm.receiveWR()" ng-confirm-click="Confirm Receipt for this Withdrawal Request?" ng-if="vm.originalStatus==\'DELIVERED\' && !vm.isLoading"><i class="fa fa-check-circle"></i> <span translate="RECEIVE_W.R"></span>.</a> <a href="" class="btn btn-default btn-with-icon" style="margin-left:30px" ng-disabled="vm.lockButtons" ng-if="vm.originalStatus!=\'NEW\' && vm.originalStatus!=\'CONFIRMED\' && item.status!=\'CANCELLED\' && !vm.isLoading" ng-click="vm.printWR(vm.wr.id, vm.wr.withdrawalNo)" rms-check-access="withdrawalrequests.wrlist" rms-check-access-perm-type="EXPORT"><i class="ion ion-printer"></i> <span translate="PRINT_W.R"></span></a></div></form>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div></div><div class="footer-bar ba-wizard-pager"><a href="" class="btn btn-primary btn-with-icon" ui-sref="services.workorders.list" style="margin-right:30px" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i> <span translate="BACK_TO_LIST"></span></a> <button type="button" class="btn btn-primary" style="margin-right:10px" ng-hide="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" ng-disabled="vm.lockButtons"><i class="fa fa-chevron-left"></i>&nbsp;&nbsp;{{ \'PREV_STEP\' | translate }}</button> <button type="button" class="btn btn-primary" ng-hide="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" ng-disabled="vm.lockButtons">{{ \'NEXT_STEP\' | translate }}&nbsp;&nbsp;<i class="fa fa-chevron-right"></i></button> <button type="submit" class="btn btn-warning btn-with-icon" style="color:#000" ng-if="$baWizardController.isLastTab()" ng-disabled="vm.lockButtons"><i class="ion ion-checkmark"></i> {{ \'CREATE_WORK_ORDER\' | translate | uppercase}}</button></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><div class="clearfix"><ul class="breadcrumb al-breadcrumb visible-sm visible-md visible-lg"><li><a href="#/dashboard"><span translate="HOME"></span></a></li><li ng-show="activeParentPath"><span ng-bind-html="activeParentPath | translate"></span></li><li><span ng-bind-html="breadcrumbTitle | translate"></span></li></ul><ul class="breadcrumb al-breadcrumb visible-xs"><li>&nbsp;</li></ul></div><h1 class="al-title"><span ng-bind-html="activePageTitle | translate"></span>&nbsp; <i ng-if="icon!=\'\' && icon!=null" class="fa {{icon}}"></i></h1></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ba.menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="ba.hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="ba.hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="ba.hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="ba.hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="ba.hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="ba.hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="ba.hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="ba.hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/pageTop/mainMenuMini.html','<uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'dashboard,duriandashboard,affdashboard,iotdashboard.ezysite,iotdashboard.ezymap,iotdashboard.observatory,iotlvdashboard\')"><uib-accordion-heading><span translate="DASHBOARD"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><a href="" class="btn menu-link" ng-if="hasAccess(\'dashboard\')" ui-sref="dashboard" ng-click="cls()"><span translate="GENERAL_DASHBOARD"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'affdashboard\')" ui-sref="affdashboard" ng-click="cls()"><span translate="DEALER_DASHBOARD"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'duriandashboard\')" ui-sref="duriandashboard" ng-click="cls()"><span translate="DURIAN_DASHBOARD"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'smartkitchendashboard\')" ui-sref="smartkitchendashboard" ng-click="cls()"><span translate="SMARTKITCHEN_DASHBOARD"></span></a><div class="divider" ng-if="hasAccess(\'iotdashboard.ezysite,iotdashboard.ezymap,iotdashboard.observatory,iotlvdashboard\')" ng-click="cls()"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'iotlvdashboard\')" ui-sref="iotlvdashboard" ng-click="cls()"><span translate="IMS_FLOOR_VIEW"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotdashboard.ezysite\')" ui-sref="iotdashboard.ezysite" ng-click="cls()"><span translate="IMS_EZYSITE"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotdashboard.ezymap\')" ui-sref="iotdashboard.ezymap" ng-click="cls()"><span translate="IMS_EZYMAP"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotdashboard.observatory\')" ui-sref="iotdashboard.observatory" ng-click="cls()"><span translate="IMS_OBSERVATORY"></span></a><div class="divider" ng-if="hasAccess(\'iotdashboard.smartiot,iotdashboard.smartiotplanview,iotdashboard.smartiotobservatory\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'iotdashboard.smartiot\')" ui-sref="iotdashboard.smartiot" ng-click="cls()"><span translate="SMART_IOT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotdashboard.smartiotplanview\')" ui-sref="iotdashboard.smartiotplanview" ng-click="cls()"><span translate="SMART_IOT_PLANVIEW"></span><sup><small><small>TM</small></small></sup></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotdashboard.smartiotobservatory\')" ui-sref="iotdashboard.smartiotobservatory"><span translate="SMART_IOT_OBSERVATORY"></span></a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'salesorders,deliveryorders,routeplan\')"><uib-accordion-heading><span translate="SALES"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><a href="" class="btn menu-link" ng-if="hasAccess(\'salesorders.list\')" ui-sref="salesorders.list" ng-click="cls()"><span translate="SALES_ORDER_LISTING"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'salesorders.calendar.list\')" ui-sref="salesorders.calendar.list" ng-click="cls()"><span translate="SALES_ORDER_CALENDAR"></span></a><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'deliveryorders.list\')" ui-sref="deliveryorders.list" ng-click="cls()"><span translate="DELIVERY_ORDER_LIST"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'consodeliveryorders.list\')" ui-sref="consodeliveryorders.list" ng-click="cls()"><span translate="CONSO_DELIVERY_ORDERS"></span></a><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'routeplan.template\')" ui-sref="routeplan.template" ng-click="cls()">{{ \'ROUTE_PLAN_TEMPLATE\' | translate}}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'routeplan.preview\')" ui-sref="routeplan.preview" ng-click="cls()">{{ \'ROUTE_PLAN_PREVIEW\' | translate}}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'routeplan.actual\')" ui-sref="routeplan.actual" ng-click="cls()">{{ \'ROUTE_PLAN_ACTUAL\' | translate}}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'routeplan.actual_mercado\')" ui-sref="routeplan.actual_mercado" ng-click="cls()">{{ \'ROUTE_PLAN_ACTUAL\' | translate}}</a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'requisitions,purchaseorders,receivings\')"><uib-accordion-heading><span translate="PROCUREMENT"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><b class="menu-title"><span translate="REQUISITION"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'requisitions.reqlist\')" ui-sref="requisitions.reqlist" ng-click="cls()"><span translate="REQUISITION_LISTING"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'requisitions.reqapproval\')" ui-sref="requisitions.reqapproval" ng-click="cls()"><span translate="REQUISITION_APPROVAL"></span></a><div class="divider"></div><b class="menu-title"><span translate="PURCHASE_ORDER"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'purchaseorders.pofromreq\')" ui-sref="purchaseorders.pofromreq" ng-click="cls()"><span translate="APPROVED_REQUISITIONS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'purchaseorders.polist\')" ui-sref="purchaseorders.polist" ng-click="cls()"><span translate="PURCHASE_ORDER_LISTING"></span></a><div class="divider"></div><b class="menu-title"><span translate="GOODS_RECEIVE"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'receivings.grnlist\')" ui-sref="receivings.grnlist" ng-click="cls()"><span translate="GOODS_RECEIVED_LISTING"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'outletops.srnlist\')" ui-sref="outletops.srnlist" ng-click="cls()"><span translate="STORE_RECEIVED_LISTING"></span></a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'jobs,withdrawalrequests\')"><uib-accordion-heading><span translate="PRODUCTION"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><b class="menu-title"><span translate="PRODUCTION"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'jobs.jobanalysisfg\')" ui-sref="jobs.jobanalysisfg" ng-click="cls()"><span translate="PRODUCTION_ANALYSIS_(F.G.)"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'jobs.jobanalysissemifg\')" ui-sref="jobs.jobanalysissemifg" ng-click="cls()"><span translate="PRODUCTION_ANALYSIS_(SEMI_F.G.)"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'jobs.jobdashboard\')" ui-sref="jobs.jobdashboard" ng-click="cls()"><span translate="PRODUCTION_DASHBOARD"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'jobs.joblist\')" ui-sref="jobs.joblist" ng-click="cls()"><span translate="PRODUCTION_LISTING"></span></a><div class="divider" ng-if="hasAccess(\'bulkbreakjobs\')"></div><b class="menu-title" ng-if="hasAccess(\'bulkbreakjobs\')"><span translate="BULK-BREAK"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'bulkbreakjobs.bbanalysis\')" ui-sref="bulkbreakjobs.bbanalysis" ng-click="cls()"><span translate="BULK-BREAK_ANALYSIS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'bulkbreakjobs.bblist\')" ui-sref="bulkbreakjobs.bblist" ng-click="cls()"><span translate="BULK-BREAK_JOB_LISTING"></span></a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'inventory,label\')"><uib-accordion-heading><span translate="INVENTORY"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><b class="menu-title">{{ \'RAW_MATERIALS\' | translate }}</b> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.items\')" ui-sref="inventory.items" ng-click="cls()"><span translate="INVENTORY_VIEW"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.inventorylock\')" ui-sref="inventory.inventorylock" ng-click="cls()"><span translate="INVENTORY_LOCK"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.stocktransfers\')" ui-sref="inventory.stocktransfers" ng-click="cls()"><span translate="STOCK_TRANSFER"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.itemstockcounts\')" ui-sref="inventory.itemstockcounts" ng-click="cls()"><span translate="STOCK_COUNT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.stockreturns\')" ui-sref="inventory.stockreturns" ng-click="cls()"><span translate="STOCK_RETURNS"></span></a><div class="divider" ng-if="hasAccess(\'inventory.semifgs\')"></div><b class="menu-title">{{ \'SEMI_FINISHED_GOODS\' | translate }}</b> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.semifgs\')" ui-sref="inventory.semifgs" ng-click="cls()"><span translate="INVENTORY_VIEW"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.inventorylock\')" ui-sref="inventory.inventorylock" ng-click="cls()"><span translate="INVENTORY_LOCK"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.stocktransfers\')" ui-sref="inventory.stocktransfers" ng-click="cls()"><span translate="STOCK_TRANSFER"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.stockreturns\')" ui-sref="inventory.stockreturns" ng-click="cls()"><span translate="STOCK_RETURNS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.semifgstockcounts\')" ui-sref="inventory.semifgstockcounts" ng-click="cls()"><span translate="STOCK_COUNT"></span></a><div class="divider" ng-if="hasAccess(\'inventory.products\')"></div><b class="menu-title">{{ \'FINISHED_GOODS\' | translate }}</b> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.products\')" ui-sref="inventory.products" ng-click="cls()"><span translate="INVENTORY_VIEW"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.inventorylock\')" ui-sref="inventory.inventorylock" ng-click="cls()"><span translate="INVENTORY_LOCK"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.stocktransfers\')" ui-sref="inventory.stocktransfers" ng-click="cls()"><span translate="STOCK_TRANSFER"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.stockreturns\')" ui-sref="inventory.stockreturns" ng-click="cls()"><span translate="STOCK_RETURNS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.productstockcounts\')" ui-sref="inventory.productstockcounts" ng-click="cls()"><span translate="STOCK_COUNT"></span></a><div class="divider" ng-if="hasAccess(\'label\')"></div><b class="menu-title"><span translate="LABEL_PRINTING"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'label.items\')" ui-sref="label.items" ng-click="cls()"><span translate="RAW_MATERIAL_LABELS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'label.semifgs\')" ui-sref="label.semifgs" ng-click="cls()"><span translate="SEMI_F.G._LABELS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'label.products\')" ui-sref="label.products" ng-click="cls()"><span translate="FINISHED_GOODS_LABELS"></span></a><div class="divider" ng-if="hasAccess(\'withdrawalrequests\')"></div><b class="menu-title">{{ \'WITHDRAWAL\' | translate }}</b> <a href="" class="btn menu-link" ng-if="hasAccess(\'withdrawalrequests.wrlist\')" ui-sref="withdrawalrequests.wrlist" ng-click="cls()"><span translate="WITHDRAWAL_REQUEST_LISTING"></span></a><div class="divider" ng-if="hasAccess(\'wastagereports\')"></div><b class="menu-title">{{ \'WASTAGE\' | translate }}</b> <a href="" class="btn menu-link" ng-if="hasAccess(\'wastagereports.list\')" ui-sref="wastagereports.list" ng-click="cls()"><span translate="WASTAGE_REPORT_LISTING"></span></a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'recipes,sops\')"><uib-accordion-heading><span translate="KNOWLEDGE"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><b class="menu-title"><span translate="RECIPE_MANAGEMENT"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'recipes.categories\')" ui-sref="recipes.categories" ng-click="cls()"><span translate="MANAGE_CATEGORIES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'recipes.recipes\')" ui-sref="recipes.recipes" ng-click="cls()"><span translate="MANAGE_RECIPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'recipes.cards\')" ui-sref="recipes.cards" ng-click="cls()"><span translate="RECIPE_CARDS"></span></a><div class="divider" ng-if="hasAccess(\'sops\')"></div><b class="menu-title"><span translate="S.O.P_MANAGEMENT"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'sops.categories\')" ui-sref="sops.categories" ng-click="cls()"><span translate="MANAGE_CATEGORIES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'sops.soptypes\')" ui-sref="sops.soptypes" ng-click="cls()"><span translate="MANAGE_S.O.P_TYPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'sops.sops\')" ui-sref="sops.sops" ng-click="cls()"><span translate="MANAGE_S.O.P"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'sops.cards\')" ui-sref="sops.cards" ng-click="cls()"><span translate="S.O.P_CARDS"></span></a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'assets,assetconfigs\')"><uib-accordion-heading><span translate="ASSET"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><b class="menu-title"><span translate="ASSET_MANAGEMENT"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'assets.assetlist\')" ui-sref="assets.assetlist" ng-click="cls()"><span translate="ASSET_LISTING"></span></a><div class="divider" ng-if="hasAccess(\'assetconfigs\')"></div><b class="menu-title"><span translate="ASSET_CONFIGURATIONS"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'assetconfigs.equipment\')" ui-sref="assetconfigs.equipment" ng-click="cls()"><span translate="EQUIPMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'assetconfigs.eqbrands\')" ui-sref="assetconfigs.eqbrands" ng-click="cls()"><span translate="EQUIPMENT_BRANDS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'assetconfigs.eqcategories\')" ui-sref="assetconfigs.eqcategories" ng-click="cls()"><span translate="EQUIPMENT_CATEGORIES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'assetconfigs.eqtypes\')" ui-sref="assetconfigs.eqtypes" ng-click="cls()"><span translate="EQUIPMENT_TYPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'assetconfigs.eqdoctypes\')" ui-sref="assetconfigs.eqdoctypes" ng-click="cls()"><span translate="EQUIPMENT_DOC_TYPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'assetconfigs.pnreceiversettings\')" ui-sref="assetconfigs.pnreceiversettings" ng-click="cls()"><span translate="PUSH_NOTIFICATIONS"></span></a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'services,serviceconfigs\')"><uib-accordion-heading><span translate="AFTERSALES"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><b class="menu-title"><span translate="AFTERSALES_SERVICE"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'services.workorders\')" ui-sref="services.workorders" ng-click="cls()"><span translate="WORK_ORDERS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'services.loanrequests\')" ui-sref="services.loanrequests" ng-click="cls()"><span translate="LOAN_REQUESTS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'services.casemanagement\')" ui-sref="services.casemanagement" ng-click="cls()"><span translate="CASE_MANAGEMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'services.warranty\')" ui-sref="services.warranty" ng-click="cls()"><span translate="WARRANTY_MANAGEMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'services.warrantyclaim\')" ui-sref="services.warrantyclaim" ng-click="cls()"><span translate="WARRANTY_CLAIM"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'services.dutyrosters\')" ui-sref="services.dutyrosters" ng-click="cls()"><span translate="DUTY_ROSTERS"></span></a><div class="divider" ng-if="hasAccess(\'serviceconfigs\')"></div><b class="menu-title"><span translate="AFTERSALES_CONFIGURATIONS"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.services\')" ui-sref="serviceconfigs.services" ng-click="cls()"><span translate="SERVICES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.processes\')" ui-sref="serviceconfigs.processes" ng-click="cls()"><span translate="PROCESSES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.spareparts\')" ui-sref="serviceconfigs.spareparts" ng-click="cls()"><span translate="SPARE_PARTS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.rostertypes\')" ui-sref="serviceconfigs.rostertypes" ng-click="cls()"><span translate="ROSTER_TYPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.svctypes\')" ui-sref="serviceconfigs.svctypes" ng-click="cls()"><span translate="SERVICE_TYPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.checklists\')" ui-sref="serviceconfigs.checklists" ng-click="cls()"><span translate="CHECKLISTS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.checklistentries\')" ui-sref="serviceconfigs.checklistentries" ng-click="cls()"><span translate="CHECKLIST_ENTRIES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.loanstatuses\')" ui-sref="serviceconfigs.loanstatuses" ng-click="cls()"><span translate="LOAN_STATUSES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.loanitemstatuses\')" ui-sref="serviceconfigs.loanitemstatuses" ng-click="cls()"><span translate="LOAN_ITEM_STATUSES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.workorderstatuses\')" ui-sref="serviceconfigs.workorderstatuses" ng-click="cls()"><span translate="WORK_ORDER_STATUSES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.worktypes\')" ui-sref="serviceconfigs.worktypes" ng-click="cls()"><span translate="WORK_TYPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.techteams\')" ui-sref="serviceconfigs.techteams" ng-click="cls()"><span translate="TECH_TEAMS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.zones\')" ui-sref="serviceconfigs.zones" ng-click="cls()"><span translate="ZONES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.pnsettings\')" ui-sref="serviceconfigs.pnsettings" ng-click="cls()"><span translate="PUSH_NOTIFICATIONS"></span></a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'reportcenter,tracktrace\')"><uib-accordion-heading><span translate="REPORTS"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><a href="" class="btn menu-link" ng-if="hasAccess(\'reportcenter\')" ui-sref="reportcenter" ng-click="cls()"><span translate="REPORT_CENTER"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'reportinquiry\')" ui-sref="reportinquiry" ng-click="cls()"><span translate="REPORT_INQUIRY"></span></a><div class="divider" ng-if="hasAccess(\'tracktrace\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'tracktrace\')" ui-sref="tracktrace" ng-click="cls()"><span translate="TRACK_AND_TRACE"></span></a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'settings,iotsettings,iotadmin,maintenance\')"><uib-accordion-heading><span translate="SETTINGS"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><b class="menu-title"><span translate="MAINTENANCE"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.debtors\')" ui-sref="maintenance.debtors" ng-click="cls()"><span translate="CUSTOMER"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.debtorcategories\')" ui-sref="maintenance.debtorcategories" ng-click="cls()"><span translate="CUSTOMER_CATEGORIES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.suppliers\')" ui-sref="maintenance.suppliers" ng-click="cls()"><span translate="SUPPLIERS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.items\')" ui-sref="maintenance.items" ng-click="cls()">{{ \'RAW_MATERIALS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.semifgs\')" ui-sref="maintenance.semifgs" ng-click="cls()">{{ \'SEMI_FINISHED_GOODS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.products\')" ui-sref="maintenance.products" ng-click="cls()">{{ \'FINISHED_GOODS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.foodmenus\')" ui-sref="maintenance.foodmenus" ng-click="cls()"><span translate="FOOD_MENUS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.warehouses\')" ui-sref="maintenance.warehouses" ng-click="cls()"><span translate="WAREHOUSES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.shippingfees\')" ui-sref="maintenance.shippingfees" ng-click="cls()"><span translate="SHIPPING_FEES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.shippingmethods\')" ui-sref="maintenance.shippingmethods" ng-click="cls()"><span translate="SHIPPING_METHODS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.packagingconditions\')" ui-sref="maintenance.packagingconditions" ng-click="cls()"><span translate="PACKAGING_CONDITIONS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.yieldmanagement\')" ui-sref="maintenance.yieldmanagement" ng-click="cls()"><span translate="YIELD_MANAGEMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.multilevelapprovals\')" ui-sref="maintenance.multilevelapprovals" ng-click="cls()"><span translate="MULTILEVEL_APPROVALS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.storepurchaseconfigs\')" ui-sref="maintenance.storepurchaseconfigs" ng-click="cls()"><span translate="STORE_PURCHASE_CONFIG"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.stockrequestconfigs\')" ui-sref="maintenance.stockrequestconfigs" ng-click="cls()"><span translate="STOCK_REQUEST_CONFIG"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.intercompanymappings\')" ui-sref="maintenance.intercompanymappings" ng-click="cls()">{{ \'INTER_COMPANY_MAPPINGS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.intercompanyitemmappings\')" ui-sref="maintenance.intercompanyitemmappings" ng-click="cls()">{{ \'INTER_COMPANY_ITEM_MAPPINGS\' | translate }}</a><div class="divider" ng-if="hasAccess(\'settings\')"></div><b class="menu-title"><span translate="SYSTEM_SETTINGS"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.branches\')" ui-sref="settings.branches" ng-click="cls()"><span translate="BRANCHES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.departments\')" ui-sref="settings.departments" ng-click="cls()"><span translate="DEPARTMENTS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.emailtemplates\')" ui-sref="settings.emailtemplates" ng-click="cls()"><span translate="EMAIL_TEMPLATES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.labeltemplates\')" ui-sref="settings.labeltemplates" ng-click="cls()"><span translate="LABEL_TEMPLATES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.notificationsettings\')" ui-sref="settings.notificationsettings" ng-click="cls()"><span translate="NOTIFICATIONS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.usergroups\')" ui-sref="settings.usergroups" ng-click="cls()"><span translate="USERGROUPS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.users\')" ui-sref="settings.users" ng-click="cls()"><span translate="USERS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.iprules\')" ui-sref="settings.iprules" ng-click="cls()"><span translate="IP_RULES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.resellercommconfig\')" ui-sref="settings.resellercommconfig" ng-click="cls()"><span translate="RESELLER_COMMISSION"></span></a><div class="divider" ng-if="hasAccess(\'iotsettings.floorviewdesigner,iotsettings.gateways,iotsettings.handhelds,iotsettings.sensors,iotsettings.settings\')"></div><b class="menu-title"><span translate="IOT_SETTINGS"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotsettings.floorviewdesigner\')" ui-sref="iotsettings.floorviewdesigner" ng-click="cls()"><span translate="FLOOR_VIEW_DESIGNER"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotsettings.gateways\')" ui-sref="iotsettings.gateways" ng-click="cls()"><span translate="GATEWAYS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotsettings.handhelds\')" ui-sref="iotsettings.handhelds" ng-click="cls()"><span translate="HANDHELDS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotsettings.sensors\')" ui-sref="iotsettings.sensors" ng-click="cls()"><span translate="SENSORS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotsettings.settings\')" ui-sref="iotsettings.settings" ng-click="cls()"><span translate="NOTIFICATIONS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'permissioncenter\')" ui-sref="permissioncenter" ng-click="cls()"><span translate="PERMISSION_CENTER"></span></a><div class="divider" ng-if="hasAccess(\'iotadmin.iotregdevices\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'iotadmin.iotregdevices\')" ui-sref="iotadmin.iotregdevices" ng-click="cls()"><span translate="IOT_REGISTERED_DEVICES"></span></a><div class="divider" ng-if="hasAccess(\'digitalhardware.dhmanagement,digitalhardware.dhsettings\')"></div><b class="menu-title"><span translate="DIGITAL_HARDWARE"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'digitalhardware.dhmanagement\')" ui-sref="digitalhardware.dhmanagement" ng-click="cls()"><span translate="DIGITAL_HARDWARE_MANAGEMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'digitalhardware.dhsettings\')" ui-sref="digitalhardware.dhsettings" ng-click="cls()"><span translate="DIGITAL_HARDWARE_SETTINGS"></span></a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'smartiotsettings\')"><uib-accordion-heading><span translate="SMART_IOT_SETTINGS"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><a href="" class="btn menu-link" ng-if="hasAccess(\'smartiotsettings.gateways\')" ui-sref="smartiotsettings.gateways" ng-click="cls()">{{ \'SMART_GATEWAYS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'smartiotsettings.sensors\')" ui-sref="smartiotsettings.sensors" ng-click="cls()">{{ \'SMART_SENSORS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'smartiotsettings.devicegroups\')" ui-sref="smartiotsettings.devicegroups" ng-click="cls()">{{ \'DEVICE_GROUPS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'smartiotsettings.notifications\')" ui-sref="smartiotsettings.notifications" ng-click="cls()">{{ \'NOTIFICATIONS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'smartiotsettings.planviewdesigner\')" ui-sref="smartiotsettings.planviewdesigner" ng-click="cls()">{{ \'PLANVIEW_DESIGNER\' | translate }}</a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'smartkitchen\')"><uib-accordion-heading><span translate="SMART_KITCHEN"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><a href="" class="btn menu-link" ng-if="hasAccess(\'smartkitchen.joblist\')" ui-sref="smartkitchen.joblist" ng-click="cls()">{{ \'SMART_KITCHEN_JOB_LIST\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'smartkitchen.machineconnectionprofiles\')" ui-sref="smartkitchen.machineconnectionprofiles" ng-click="cls()">{{ \'MACHINE_CONNECTION_PROFILES\' | translate }}</a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'robotkiosk\')"><uib-accordion-heading><span translate="ROBOT_KIOSK"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.kiosks\')" ui-sref="robotkiosk.kiosks" ng-click="cls()"><span translate="KIOSK_MANAGEMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.equipments\')" ui-sref="robotkiosk.equipments" ng-click="cls()"><span translate="KIOSK_EQUIPMENTS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.equipmenttypes\')" ui-sref="robotkiosk.equipmenttypes" ng-click="cls()"><span translate="KIOSK_EQUIPMENT_TYPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.products\')" ui-sref="robotkiosk.products" ng-click="cls()"><span translate="PRODUCTS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.categories\')" ui-sref="robotkiosk.categories" ng-click="cls()"><span translate="PRODUCT_CATEGORIES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.productsizes\')" ui-sref="robotkiosk.productsizes" ng-click="cls()"><span translate="PRODUCT_SIZES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.productflavors\')" ui-sref="robotkiosk.productflavors" ng-click="cls()"><span translate="PRODUCT_FLAVORS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.productothers\')" ui-sref="robotkiosk.productothers" ng-click="cls()"><span translate="PRODUCT_OTHER_OPTIONS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.productmappings\')" ui-sref="robotkiosk.productmappings" ng-click="cls()"><span translate="PRODUCT_MAPPING"></span></a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'durianops\')"><uib-accordion-heading><span translate="DURIAN_OPS"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><a href="" class="btn menu-link" ng-if="hasAccess(\'durianops.collectdurian\')" ui-sref="durianops.collectdurian" ng-click="cls()"><span translate="COLLECT_DURIAN"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'durianops.processpulps\')" ui-sref="durianops.processpulps" ng-click="cls()"><span translate="PROCESS_PULPS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'durianops.producepuree\')" ui-sref="durianops.producepuree" ng-click="cls()"><span translate="PROCESS_FLESH"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'durianops.durianinventory\')" ui-sref="durianops.durianinventory" ng-click="cls()"><span translate="INVENTORY"></span></a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'signup,signupims,signupimsassign\')"><uib-accordion-heading><span translate="SIGN_UP"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><a href="" class="btn menu-link" ng-if="hasAccess(\'signuprmsdealer\')" ui-sref="signuprmsdealer" ng-click="cls()"><span>Sign Up RMS (Dealer)</span></a><div class="divider" ng-if="hasAccess(\'signuprmsdealer\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'signuprms\')" ui-sref="signuprms" ng-click="cls()"><span>Sign Up RMS</span></a><div class="divider" ng-if="hasAccess(\'signuprms\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'signupims\')" ui-sref="signupims" ng-click="cls()"><span translate="NEW_ACCOUNT_CREATION_(IMS)"></span></a><div class="divider" ng-if="hasAccess(\'signupims\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'signupimsassign\')" ui-sref="signupimsassign" ng-click="cls()"><span translate="IOT_DEVICE_ASSIGNMENT_(IMS)"></span></a></uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default" ng-if="hasAccess(\'superadmin\')"><uib-accordion-heading><span translate="SUPERADMIN"></span> <i class="fa pull-right fa-caret-down"></i></uib-accordion-heading><b class="menu-title"><span translate="SUPERADMIN_FEATURES"></span></b> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.companies\')" ui-sref="superadmin.companies" ng-click="cls()"><span translate="COMPANIES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.companysettings\')" ui-sref="superadmin.companysettings" ng-click="cls()">Company Settings</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.branches\')" ui-sref="superadmin.branches" ng-click="cls()"><span translate="BRANCHES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.features\')" ui-sref="superadmin.features" ng-click="cls()"><span translate="FEATURES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.serverpackages\')" ui-sref="superadmin.serverpackages" ng-click="cls()"><span translate="PACKAGES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.serverpackagesettings\')" ui-sref="superadmin.serverpackagesettings" ng-click="cls()"><span translate="PACKAGES_SETTINGS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.payments\')" ui-sref="superadmin.payments" ng-click="cls()"><span translate="PAYMENTS_(CUSTOMERS)"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.commissions\')" ui-sref="superadmin.commissions" ng-click="cls()"><span translate="COMMISSIONS_(DEALERS)"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.users\')" ui-sref="superadmin.users" ng-click="cls()"><span translate="USERS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.uoms\')" ui-sref="superadmin.uoms" ng-click="cls()">{{ \'U.O.M\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.announcements\')" ui-sref="superadmin.announcements" ng-click="cls()">{{ \'ANNOUNCEMENTS\' | translate }}</a><div class="divider" ng-if="hasAccess(\'superadmin.companies,superadmin.branches,superadmin.features,superadmin.serverpackages,superadmin.payments,superadmin.commissions,superadmin.users,superadmin.uoms\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.siotdevices\')" ui-sref="superadmin.siotdevices" ng-click="cls()">Smart IOT Devices Management</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.iotregdevices\')" ui-sref="superadmin.iotregdevices" ng-click="cls()"><span translate="IOT_DEVICES_MANAGEMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.affiliates\')" ui-sref="superadmin.affiliates" ng-click="cls()"><span translate="AFFILIATES_MANAGEMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.affiliates_newcustomer\')" ui-sref="superadmin.affiliates_newcustomer" ng-click="cls()"><span translate="Affiliates Customers Approval"></span></a><div class="divider" ng-if="hasAccess(\'superadmin.iotregdevices,superadmin.affiliates,superadmin.affiliates_newcustomer\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.intercompanymappings\')" ui-sref="superadmin.intercompanymappings" ng-click="cls()"><span translate="INTER_COMPANY_MAPPINGS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.intercompanyitemmappings\')" ui-sref="superadmin.intercompanyitemmappings" ng-click="cls()"><span translate="INTER_COMPANY_ITEM_MAPPINGS"></span></a><div class="divider" ng-if="hasAccess(\'superadmin.intercompanymappings,superadmin.intercompanyitemmappings\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.systemschedulersettings\')" ui-sref="superadmin.systemschedulersettings" ng-click="cls()"><span translate="SCHEDULER_SETTINGS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.systemsettings\')" ui-sref="superadmin.systemsettings" ng-click="cls()"><span translate="SYSTEM_SETTINGS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.systemversion\')" ui-sref="superadmin.systemversion" ng-click="cls()"><span translate="SYSTEM_VERSION"></span></a><div class="divider" ng-if="hasAccess(\'superadmin.systemschedulersettings,superadmin.systemsettings,superadmin.systemversion\')"></div><a href="" class="btn menu-link" ng-if="isSuperAdmin && hasAccess(\'superadmin.businessmetrics\')" ui-sref="superadmin.businessmetrics" ng-click="cls()">Business Metrics</a></uib-accordion-group></uib-accordion>');
$templateCache.put('app/theme/components/pageTop/mainMenuTop.html','<div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'dashboard,affdashboard,duriandashboard,iotdashboard.ezysite,iotdashboard.ezymap,iotdashboard.observatory,iotlvdashboard\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-th fa-2x"></i> <span translate="DASHBOARD"></span></a><div uib-dropdown-menu="" class="dropdown-menu dashboard" role="menu"><div class="row"><div class="col-lg-12"><b class="menu-title"><span translate="DASHBOARD"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'dashboard\')" ui-sref="dashboard"><span translate="GENERAL_DASHBOARD"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'affdashboard\')" ui-sref="affdashboard"><span translate="DEALER_DASHBOARD"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'duriandashboard\')" ui-sref="duriandashboard"><span translate="DURIAN_DASHBOARD"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'smartkitchendashboard\')" ui-sref="smartkitchendashboard"><span translate="SMARTKITCHEN_DASHBOARD"></span></a><div class="divider" ng-if="hasAccess(\'iotdashboard.ezysite,iotdashboard.ezymap,iotdashboard.observatory,iotlvdashboard\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'iotlvdashboard\')" ui-sref="iotlvdashboard"><span translate="IMS_FLOOR_VIEW"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotdashboard.ezysite\')" ui-sref="iotdashboard.ezysite"><span translate="IMS_EZYSITE"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotdashboard.ezymap\')" ui-sref="iotdashboard.ezymap"><span translate="IMS_EZYMAP"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotdashboard.observatory\')" ui-sref="iotdashboard.observatory"><span translate="IMS_OBSERVATORY"></span></a><div class="divider" ng-if="hasAccess(\'iotdashboard.smartiot,iotdashboard.smartiotplanview,iotdashboard.smartiotobservatory\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'iotdashboard.smartiot\')" ui-sref="iotdashboard.smartiot"><span translate="SMART_IOT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotdashboard.smartiotplanview\')" ui-sref="iotdashboard.smartiotplanview"><span translate="SMART_IOT_PLANVIEW"></span><sup><small><small>TM</small></small></sup></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotdashboard.smartiotobservatory\')" ui-sref="iotdashboard.smartiotobservatory"><span translate="SMART_IOT_OBSERVATORY"></span></a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'salesorders,deliveryorders,routeplan\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-rocket fa-2x"></i> <span translate="SALES"></span></a><div uib-dropdown-menu="" class="dropdown-menu sales-{{salesAccess.count}}" role="menu"><div class="row"><div class="col-lg-{{salesAccess.colWidth}}" ng-if="hasAccess(\'salesorders\')"><b class="menu-title"><span translate="SALES_ORDER"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'salesorders.list\')" ui-sref="salesorders.list"><span translate="SALES_ORDER_LISTING"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'salesorders.calendar.list\')" ui-sref="salesorders.calendar.list"><span translate="SALES_ORDER_CALENDAR"></span></a></div><div class="col-lg-{{salesAccess.colWidth}}" ng-if="hasAccess(\'deliveryorders\')"><b class="menu-title"><span translate="DELIVERY_ORDER"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'deliveryorders.list\')" ui-sref="deliveryorders.list"><span translate="DELIVERY_ORDER_LIST"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'consodeliveryorders.list\')" ui-sref="consodeliveryorders.list"><span translate="CONSO_DELIVERY_ORDERS"></span></a></div><div class="col-lg-{{salesAccess.colWidth}}" ng-if="hasAccess(\'routeplan\')"><b class="menu-title"><span translate="ROUTE_PLANNING"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'routeplan.template\')" ui-sref="routeplan.template">{{ \'ROUTE_PLAN_TEMPLATE\' | translate}}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'routeplan.preview\')" ui-sref="routeplan.preview">{{ \'ROUTE_PLAN_PREVIEW\' | translate}}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'routeplan.actual\')" ui-sref="routeplan.actual">{{ \'ROUTE_PLAN_ACTUAL\' | translate}}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'routeplan.actual_mercado\')" ui-sref="routeplan.actual_mercado">{{ \'ROUTE_PLAN_ACTUAL\' | translate}}</a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'requisitions,purchaseorders,receivings\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-shopping-cart fa-2x"></i> <span translate="PROCUREMENT"></span></a><div uib-dropdown-menu="" class="dropdown-menu procurement-{{procurementAccess.count}}" role="menu"><div class="row"><div class="col-lg-{{procurementAccess.colWidth}}" ng-if="hasAccess(\'requisitions\')"><b class="menu-title"><span translate="REQUISITION"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'requisitions.reqlist\')" ui-sref="requisitions.reqlist"><span translate="REQUISITION_LISTING"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'requisitions.reqapproval\')" ui-sref="requisitions.reqapproval"><span translate="REQUISITION_APPROVAL"></span></a></div><div class="col-lg-{{procurementAccess.colWidth}}" ng-if="hasAccess(\'purchaseorders\')"><b class="menu-title"><span translate="PURCHASE_ORDER"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'purchaseorders.pofromreq\')" ui-sref="purchaseorders.pofromreq"><span translate="APPROVED_REQUISITIONS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'purchaseorders.polist\')" ui-sref="purchaseorders.polist"><span translate="PURCHASE_ORDER_LISTING"></span></a></div><div class="col-lg-{{procurementAccess.colWidth}}" ng-if="hasAccess(\'receivings.grnlist,outletops.srnlist\')"><b class="menu-title"><span translate="GOODS_RECEIVE"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'receivings.grnlist\')" ui-sref="receivings.grnlist"><span translate="GOODS_RECEIVED_LISTING"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'outletops.srnlist\')" ui-sref="outletops.srnlist"><span translate="STORE_RECEIVED_LISTING"></span></a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'jobs,withdrawalrequests,wastagereports\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-briefcase fa-2x"></i> <span translate="PRODUCTION"></span></a><div uib-dropdown-menu="" class="dropdown-menu production-{{productionAccess.count}}" role="menu"><div class="row"><div class="col-lg-{{productionAccess.colWidth}}" ng-if="hasAccess(\'jobs\')"><b class="menu-title"><span translate="PRODUCTION"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'jobs.jobanalysisfg\')" ui-sref="jobs.jobanalysisfg"><span translate="PRODUCTION_ANALYSIS_(F.G.)"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'jobs.jobanalysissemifg\')" ui-sref="jobs.jobanalysissemifg"><span translate="PRODUCTION_ANALYSIS_(SEMI_F.G.)"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'jobs.jobdashboard\')" ui-sref="jobs.jobdashboard"><span translate="PRODUCTION_DASHBOARD"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'jobs.joblist\')" ui-sref="jobs.joblist"><span translate="PRODUCTION_LISTING"></span></a></div><div class="col-lg-{{productionAccess.colWidth}}" ng-if="hasAccess(\'bulkbreakjobs\')"><b class="menu-title"><span translate="BULK-BREAK"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'bulkbreakjobs.bbanalysis\')" ui-sref="bulkbreakjobs.bbanalysis"><span translate="BULK-BREAK_ANALYSIS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'bulkbreakjobs.bblist\')" ui-sref="bulkbreakjobs.bblist"><span translate="BULK-BREAK_JOB_LISTING"></span></a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'inventory,label\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-cubes fa-2x"></i> <span translate="INVENTORY"></span></a><div uib-dropdown-menu="" class="dropdown-menu inventory-{{inventoryAccess.count}}" role="menu"><div class="row" ng-if="hasAccess(\'inventory\')"><div class="col-lg-{{inventoryAccess.colWidth}}" ng-if="hasAccess(\'inventory.items,inventory.itemstockcounts,inventory.stocktransfers,inventory.stockreturns\')"><b class="menu-title">{{ \'RAW_MATERIALS\' | translate }}</b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.items\')" ui-sref="inventory.items"><span translate="INVENTORY_VIEW"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.inventorylock\')" ui-sref="inventory.inventorylock"><span translate="INVENTORY_LOCK"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.stocktransfers\')" ui-sref="inventory.stocktransfers"><span translate="STOCK_TRANSFER"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.stockreturns\')" ui-sref="inventory.stockreturns"><span translate="STOCK_RETURNS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.itemstockcounts\')" ui-sref="inventory.itemstockcounts"><span translate="STOCK_COUNT"></span></a></div><div class="col-lg-{{inventoryAccess.colWidth}}" ng-if="hasAccess(\'inventory.semifgs,inventory.semifgstockcounts,inventory.stocktransfers,inventory.stockreturns\')"><b class="menu-title">{{ \'SEMI_FINISHED_GOODS\' | translate }}</b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.semifgs\')" ui-sref="inventory.semifgs"><span translate="INVENTORY_VIEW"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.inventorylock\')" ui-sref="inventory.inventorylock"><span translate="INVENTORY_LOCK"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.stocktransfers\')" ui-sref="inventory.stocktransfers"><span translate="STOCK_TRANSFER"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.stockreturns\')" ui-sref="inventory.stockreturns"><span translate="STOCK_RETURNS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.semifgstockcounts\')" ui-sref="inventory.semifgstockcounts"><span translate="STOCK_COUNT"></span></a></div><div class="col-lg-{{inventoryAccess.colWidth}}" ng-if="hasAccess(\'inventory.products,inventory.productstockcounts,inventory.stocktransfers,inventory.stockreturns\')"><b class="menu-title">{{ \'FINISHED_GOODS\' | translate }}</b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.products\')" ui-sref="inventory.products"><span translate="INVENTORY_VIEW"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.inventorylock\')" ui-sref="inventory.inventorylock"><span translate="INVENTORY_LOCK"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.stocktransfers\')" ui-sref="inventory.stocktransfers"><span translate="STOCK_TRANSFER"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.stockreturns\')" ui-sref="inventory.stockreturns"><span translate="STOCK_RETURNS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'inventory.productstockcounts\')" ui-sref="inventory.productstockcounts"><span translate="STOCK_COUNT"></span></a></div></div><div class="row" ng-if="hasAccess(\'label\')"><div class="col-lg-12"><div><br></div></div></div><div class="row" ng-if="hasAccess(\'label\')"><div class="col-lg-12"><b class="menu-title"><span translate="LABEL_PRINTING"></span></b><div class="divider"></div><div class="row"><div class="col-lg-{{inventoryAccess.colWidth}}"><a href="" class="btn menu-link" ng-if="hasAccess(\'label.items\')" ui-sref="label.items"><span translate="RAW_MATERIAL_LABELS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'label.itemadjustment\')" ui-sref="label.itemadjustment"><span translate="RAWMAT_LABEL_ADJUSTMENT"></span></a></div><div class="col-lg-{{inventoryAccess.colWidth}}"><a href="" class="btn menu-link" ng-if="hasAccess(\'label.semifgs\')" ui-sref="label.semifgs"><span translate="SEMI_F.G._LABELS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'label.semifgadjustment\')" ui-sref="label.semifgadjustment"><span translate="SEMIFG_LABEL_ADJUSTMENT"></span></a></div><div class="col-lg-{{inventoryAccess.colWidth}}"><a href="" class="btn menu-link" ng-if="hasAccess(\'label.products\')" ui-sref="label.products"><span translate="FINISHED_GOODS_LABELS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'label.productadjustment\')" ui-sref="label.productadjustment"><span translate="FG_LABEL_ADJUSTMENT"></span></a></div></div></div></div><div class="row" ng-if="hasAccess(\'withdrawalrequests,wastagereports\')"><div class="col-lg-12"><div><br></div></div></div><div class="row" ng-if="hasAccess(\'withdrawalrequests,wastagereports\')"><div class="col-lg-{{inventoryAccess.colWidth}}" ng-if="hasAccess(\'withdrawalrequests\')"><b class="menu-title"><span translate="WITHDRAWAL"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'withdrawalrequests.wrlist\')" ui-sref="withdrawalrequests.wrlist"><span translate="WITHDRAWAL_REQUEST_LISTING"></span></a></div><div class="col-lg-{{inventoryAccess.colWidth}}" ng-if="hasAccess(\'wastagereports\')"><b class="menu-title"><span translate="WASTAGE"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'wastagereports.list\')" ui-sref="wastagereports.list"><span translate="WASTAGE_REPORT_LISTING"></span></a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'recipes,sops\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-book fa-2x"></i> <span translate="KNOWLEDGE"></span></a><div uib-dropdown-menu="" class="dropdown-menu knowledge-{{knowledgeAccess.count}}" role="menu"><div class="row"><div class="col-lg-{{knowledgeAccess.colWidth}}" ng-if="hasAccess(\'recipes\')"><b class="menu-title"><span translate="RECIPE_MANAGEMENT"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'recipes.categories\')" ui-sref="recipes.categories"><span translate="MANAGE_CATEGORIES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'recipes.recipes\')" ui-sref="recipes.recipes"><span translate="MANAGE_RECIPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'recipes.cards\')" ui-sref="recipes.cards"><span translate="RECIPE_CARDS"></span></a></div><div class="col-lg-{{knowledgeAccess.colWidth}}" ng-if="hasAccess(\'sops\')"><b class="menu-title"><span translate="S.O.P_MANAGEMENT"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'sops.categories\')" ui-sref="sops.categories"><span translate="MANAGE_CATEGORIES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'sops.soptypes\')" ui-sref="sops.soptypes"><span translate="MANAGE_S.O.P_TYPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'sops.sops\')" ui-sref="sops.sops"><span translate="MANAGE_S.O.P"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'sops.cards\')" ui-sref="sops.cards"><span translate="S.O.P_CARDS"></span></a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'assets,assetconfigs\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-desktop fa-2x"></i> <span translate="ASSETS"></span></a><div uib-dropdown-menu="" class="dropdown-menu asset-{{assetAccess.count}}" role="menu"><div class="row"><div class="col-lg-{{assetAccess.colWidth}}" ng-if="hasAccess(\'assets\')"><b class="menu-title"><span translate="ASSET_MANAGEMENT"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'assets.assetlist\')" ui-sref="assets.assetlist"><span translate="ASSET_LISTING"></span></a></div><div class="col-lg-{{assetAccess.colWidth}}" ng-if="hasAccess(\'assetconfigs\')"><b class="menu-title"><span translate="ASSET_CONFIGURATIONS"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'assetconfigs.equipment\')" ui-sref="assetconfigs.equipment"><span translate="EQUIPMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'assetconfigs.eqbrands\')" ui-sref="assetconfigs.eqbrands"><span translate="EQUIPMENT_BRANDS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'assetconfigs.eqcategories\')" ui-sref="assetconfigs.eqcategories"><span translate="EQUIPMENT_CATEGORIES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'assetconfigs.eqtypes\')" ui-sref="assetconfigs.eqtypes"><span translate="EQUIPMENT_TYPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'assetconfigs.eqdoctypes\')" ui-sref="assetconfigs.eqdoctypes"><span translate="EQUIPMENT_DOC_TYPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'assetconfigs.pnreceiversettings\')" ui-sref="assetconfigs.pnreceiversettings"><span translate="PUSH_NOTIFICATIONS"></span></a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'services,serviceconfigs\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-puzzle-piece fa-2x"></i> <span translate="AFTERSALES"></span></a><div uib-dropdown-menu="" class="dropdown-menu aftersales-{{aftersalesAccess.count}}" role="menu"><div class="row"><div class="col-lg-{{aftersalesAccess.colWidth1}}" ng-if="hasAccess(\'services\')"><b class="menu-title"><span translate="AFTERSALES_SERVICE"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'services.workorders\')" ui-sref="services.workorders"><span translate="WORK_ORDERS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'services.loanrequests\')" ui-sref="services.loanrequests"><span translate="LOAN_REQUESTS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'services.casemanagement\')" ui-sref="services.casemanagement"><span translate="CASE_MANAGEMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'services.warranty\')" ui-sref="services.warranty"><span translate="WARRANTY_MANAGEMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'services.warrantyclaim\')" ui-sref="services.warrantyclaim"><span translate="WARRANTY_CLAIM"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'services.dutyrosters\')" ui-sref="services.dutyrosters"><span translate="DUTY_ROSTERS"></span></a></div><div class="col-lg-{{aftersalesAccess.colWidth2}}" ng-if="hasAccess(\'serviceconfigs\')"><b class="menu-title"><span translate="AFTERSALES_CONFIGURATIONS"></span></b><div class="divider"></div><div class="row"><div class="col-lg-6" ng-if="hasAccess(\'serviceconfigs.services,serviceconfigs.processes,serviceconfigs.spareparts,serviceconfigs.checklists,serviceconfigs.checklistentries,serviceconfigs.techteams,serviceconfigs.zones\')"><a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.services\')" ui-sref="serviceconfigs.services"><span translate="SERVICES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.processes\')" ui-sref="serviceconfigs.processes"><span translate="PROCESSES"></span></a><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.checklists\')" ui-sref="serviceconfigs.checklists"><span translate="CHECKLISTS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.checklistentries\')" ui-sref="serviceconfigs.checklistentries"><span translate="CHECKLIST_ENTRIES"></span></a><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.spareparts\')" ui-sref="serviceconfigs.spareparts"><span translate="SPARE_PARTS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.techteams\')" ui-sref="serviceconfigs.techteams"><span translate="TECH_TEAMS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.zones\')" ui-sref="serviceconfigs.zones"><span translate="ZONES"></span></a></div><div class="col-lg-6" ng-if="hasAccess(\'serviceconfigs.loanstatuses,serviceconfigs.loanitemstatuses,serviceconfigs.workorderstatuses,serviceconfigs.worktypes,serviceconfigs.rostertypes,serviceconfigs.svctypes\')"><a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.workorderstatuses\')" ui-sref="serviceconfigs.workorderstatuses"><span translate="WORK_ORDER_STATUSES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.loanstatuses\')" ui-sref="serviceconfigs.loanstatuses"><span translate="LOAN_STATUSES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.loanitemstatuses\')" ui-sref="serviceconfigs.loanitemstatuses"><span translate="LOAN_ITEM_STATUSES"></span></a><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.worktypes\')" ui-sref="serviceconfigs.worktypes"><span translate="WORK_TYPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.rostertypes\')" ui-sref="serviceconfigs.rostertypes"><span translate="ROSTER_TYPES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.svctypes\')" ui-sref="serviceconfigs.svctypes"><span translate="SERVICE_TYPES"></span></a><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'serviceconfigs.pnsettings\')" ui-sref="serviceconfigs.pnsettings"><span translate="PUSH_NOTIFICATION"></span></a></div></div></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'reportcenter,tracktrace\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-bar-chart fa-2x"></i> <span translate="REPORTS"></span></a><div uib-dropdown-menu="" class="dropdown-menu report" role="menu"><div class="row"><div class="col-lg-12"><b class="menu-title"><span translate="REPORTS"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'reportcenter\')" ui-sref="reportcenter"><span translate="REPORT_CENTER"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'reportinquiry\')" ui-sref="reportinquiry"><span translate="REPORT_INQUIRY"></span></a><div class="divider" ng-if="hasAccess(\'tracktrace\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'tracktrace\')" ui-sref="tracktrace"><span translate="TRACK_AND_TRACE"></span></a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'settings,iotsettings,iotadmin,maintenance\')"><a href="" class="btn button-mainmenu last" uib-dropdown-toggle=""><i class="fa fa-cogs fa-2x"></i> <span translate="SETTINGS"></span></a><div uib-dropdown-menu="" class="dropdown-menu setting-{{settingAccess.count}}" role="menu"><div class="row"><div class="col-lg-{{settingAccess.colWidth}}" ng-if="hasAccess(\'maintenance\')"><b class="menu-title"><span translate="MAINTENANCE"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.debtors\')" ui-sref="maintenance.debtors">{{ \'CUSTOMER\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.debtorcategories\')" ui-sref="maintenance.debtorcategories">{{ \'CUSTOMER_CATEGORIES\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.suppliers\')" ui-sref="maintenance.suppliers">{{ \'SUPPLIERS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.items\')" ui-sref="maintenance.items">{{ \'RAW_MATERIALS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.semifgs\')" ui-sref="maintenance.semifgs">{{ \'SEMI_FINISHED_GOODS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.products\')" ui-sref="maintenance.products">{{ \'FINISHED_GOODS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.foodmenus\')" ui-sref="maintenance.foodmenus">{{ \'FOOD_MENUS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.warehouses\')" ui-sref="maintenance.warehouses">{{ \'WAREHOUSES\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.shippingfees\')" ui-sref="maintenance.shippingfees">{{ \'SHIPPING_FEES\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.shippingmethods\')" ui-sref="maintenance.shippingmethods">{{ \'SHIPPING_METHODS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.packagingconditions\')" ui-sref="maintenance.packagingconditions">{{ \'PACKAGING_CONDITIONS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.yieldmanagement\')" ui-sref="maintenance.yieldmanagement">{{ \'YIELD_MANAGEMENT\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.multilevelapprovals\')" ui-sref="maintenance.multilevelapprovals">{{ \'MULTILEVEL_APPROVALS\' | translate }}</a></div><div class="col-lg-{{settingAccess.colWidth}}" ng-if="hasAccess(\'settings\')"><b class="menu-title"><span translate="SYSTEM_SETTINGS"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'settings.branches\')" ui-sref="settings.branches"><span translate="BRANCHES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.departments\')" ui-sref="settings.departments"><span translate="DEPARTMENTS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.emailtemplates\')" ui-sref="settings.emailtemplates"><span translate="EMAIL_TEMPLATES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.labeltemplates\')" ui-sref="settings.labeltemplates"><span translate="LABEL_TEMPLATES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.notificationsettings\')" ui-sref="settings.notificationsettings"><span translate="NOTIFICATIONS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.usergroups\')" ui-sref="settings.usergroups"><span translate="USERGROUPS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.users\')" ui-sref="settings.users"><span translate="USERS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'settings.iprules\')" ui-sref="settings.iprules"><span translate="IP_RULES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'permissioncenter\')" ui-sref="permissioncenter"><span translate="PERMISSION_CENTER"></span></a></div><div class="col-lg-{{settingAccess.colWidth}}" ng-if="hasAccess(\'iotsettings.floorviewdesigner,iotsettings.gateways,iotsettings.sensors,iotsettings.settings\')"><b class="menu-title"><span translate="IOT_SETTINGS"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'iotsettings.floorviewdesigner\')" ui-sref="iotsettings.floorviewdesigner"><span translate="FLOOR_VIEW_DESIGNER"></span> <sup><sup><smalll style="color:#f00"><b translate="NEW"></b></smalll></sup></sup></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotsettings.gateways\')" ui-sref="iotsettings.gateways"><span translate="GATEWAYS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotsettings.sensors\')" ui-sref="iotsettings.sensors"><span translate="SENSORS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'iotsettings.settings\')" ui-sref="iotsettings.settings"><span translate="NOTIFICATIONS"></span></a><div class="divider" ng-if="hasAccess(\'iotsettings.gateways,iotsettings.sensors,iotsettings.settings\') && hasAccess(\'iotadmin.iotregdevices\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'iotadmin.iotregdevices\')" ui-sref="iotadmin.iotregdevices"><span translate="IOT_DEVICE_REGISTRATION"></span></a></div></div><div class="row" ng-if="(hasAccess(\'maintenance\') || hasAccess(\'settings\') || hasAccess(\'iotsettings.floorviewdesigner,iotsettings.gateways,iotsettings.sensors,iotsettings.settings\')) && hasAccess(\'digitalhardware,digitalhardware.dhmanagement,digitalhardware.dhsettings\')"><div><br></div></div><div class="row"><div class="col-lg-{{settingAccess.colWidth}}" ng-if="hasAccess(\'digitalhardware,digitalhardware.dhmanagement,digitalhardware.dhsettings\')"><b class="menu-title"><span translate="DIGITAL_HARDWARE"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'digitalhardware.dhmanagement\')" ui-sref="digitalhardware.dhmanagement"><span translate="DIGITAL_HARDWARE_MANAGEMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'digitalhardware.dhsettings\')" ui-sref="digitalhardware.dhsettings"><span translate="DIGITAL_HARDWARE_SETTINGS"></span></a></div><div class="col-lg-{{settingAccess.colWidth}}" ng-if="hasAccess(\'maintenance.storepurchaseconfigs,maintenance.stockrequestconfigs\')"><b class="menu-title"><span translate="STORE"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.storepurchaseconfigs\')" ui-sref="maintenance.storepurchaseconfigs"><span translate="STORE_PURCHASE_CONFIG"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.stockrequestconfigs\')" ui-sref="maintenance.stockrequestconfigs"><span translate="STOCK_REQUEST_CONFIG"></span></a></div><div class="col-lg-{{settingAccess.colWidth}}" ng-if="hasAccess(\'maintenance.intercompanymappings,maintenance.intercompanyitemmappings\')"><b class="menu-title"><span translate="INTER_COMPANY"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.intercompanymappings\')" ui-sref="maintenance.intercompanymappings">{{ \'INTER_COMPANY_MAPPINGS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'maintenance.intercompanyitemmappings\')" ui-sref="maintenance.intercompanyitemmappings">{{ \'INTER_COMPANY_ITEM_MAPPINGS\' | translate }}</a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'smartiotsettings\')"><a href="" class="btn button-mainmenu last" uib-dropdown-toggle=""><i class="fa fa-sliders fa-2x"></i> <span translate="SMART_IOT"></span></a><div uib-dropdown-menu="" class="dropdown-menu report" role="menu"><div class="row"><div class="col-lg-12"><b class="menu-title"><span translate="SMART_IOT_SETTINGS"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'smartiotsettings.gateways\')" ui-sref="smartiotsettings.gateways">{{ \'SMART_GATEWAYS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'smartiotsettings.sensors\')" ui-sref="smartiotsettings.sensors">{{ \'SMART_SENSORS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'smartiotsettings.devicegroups\')" ui-sref="smartiotsettings.devicegroups">{{ \'DEVICE_GROUPS\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'smartiotsettings.notifications\')" ui-sref="smartiotsettings.notifications">{{ \'NOTIFICATIONS\' | translate }}</a><div class="divider" ng-if="hasAccess(\'smartiotsettings.planviewdesigner\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'smartiotsettings.planviewdesigner\')" ui-sref="smartiotsettings.planviewdesigner">{{ \'PLANVIEW_DESIGNER\' | translate }}</a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'smartkitchen,smartkitchen.machineconnectionprofiles\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-slideshare fa-2x" style="font-size:230%;margin-bottom:7px"></i> <span translate="SMART_KITCHEN"></span></a><div uib-dropdown-menu="" class="dropdown-menu report" role="menu"><div class="row" ng-if="hasAccess(\'smartkitchen\')"><div class="col-lg-12"><b class="menu-title"><span translate="SMART_KITCHEN"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'smartkitchen.joblist\')" ui-sref="smartkitchen.joblist">{{\'SMART_KITCHEN_JOB_LIST\' | translate }}</a><div class="divider" ng-if="hasAccess(\'smartkitchen.machineconnectionprofiles\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'smartkitchen.skbranches\')" ui-sref="smartkitchen.skbranches">{{\'SMART_KITCHEN_BRANCH_LIST\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'smartkitchen.machineconnectionprofiles\')" ui-sref="smartkitchen.machineconnectionprofiles">{{\'MACHINE_CONNECTION_PROFILES\' | translate }}</a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'robotkiosk\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-android fa-2x"></i> <span translate="ROBOT_KIOSK"></span></a><div uib-dropdown-menu="" class="dropdown-menu robotkiosk" role="menu"><div class="row"><div class="col-lg-12"><b class="menu-title"><span translate="ROBOT_KIOSK"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.kiosks\')" ui-sref="robotkiosk.kiosks"><span translate="KIOSK_MANAGEMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.equipments\')" ui-sref="robotkiosk.equipments"><span translate="KIOSK_EQUIPMENTS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.equipmenttypes\')" ui-sref="robotkiosk.equipmenttypes"><span translate="KIOSK_EQUIPMENT_TYPES"></span></a><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.products\')" ui-sref="robotkiosk.products"><span translate="PRODUCTS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.categories\')" ui-sref="robotkiosk.categories"><span translate="PRODUCT_CATEGORIES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.productsizes\')" ui-sref="robotkiosk.productsizes"><span translate="PRODUCT_SIZES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.productflavors\')" ui-sref="robotkiosk.productflavors"><span translate="PRODUCT_FLAVORS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.productothers\')" ui-sref="robotkiosk.productothers"><span translate="PRODUCT_OTHER_OPTIONS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'robotkiosk.productmappings\')" ui-sref="robotkiosk.productmappings"><span translate="PRODUCT_MAPPING"></span></a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'durianops\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-tree fa-2x"></i> <span translate="DURIAN_OPS"></span></a><div uib-dropdown-menu="" class="dropdown-menu durianop" role="menu"><div class="row"><div class="col-lg-12"><b class="menu-title"><span translate="DURIAN_OPS"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'durianops.collectdurian\')" ui-sref="durianops.collectdurian"><span translate="COLLECT_DURIAN"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'durianops.processpulps\')" ui-sref="durianops.processpulps"><span translate="PROCESS_PULPS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'durianops.producepuree\')" ui-sref="durianops.producepuree"><span translate="PROCESS_FLESH"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'durianops.durianinventory\')" ui-sref="durianops.durianinventory"><span translate="INVENTORY"></span></a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'wcsimulator\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-simplybuilt fa-2x"></i> <span translate="WC_SIMULATOR"></span></a><div uib-dropdown-menu="" class="dropdown-menu durianop" role="menu"><div class="row"><div class="col-lg-12"><b class="menu-title"><span translate="WEIGHT_CHECKER"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'wcsimulator.simulations\')" ui-sref="wcsimulator.simulations"><span translate="SIMULATIONS"></span></a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'signup,signupims,signupimsassign\')"><a href="" class="btn button-mainmenu" uib-dropdown-toggle=""><i class="fa fa-check-square-o fa-2x"></i> <span translate="SIGN_UP"></span></a><div uib-dropdown-menu="" class="dropdown-menu report" role="menu"><div class="row"><div class="col-lg-12"><b class="menu-title"><span translate="SIGN_UP"></span></b><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'signuprmsdealer\')" ui-sref="signuprmsdealer"><span>Sign Up RMS (Dealer)</span></a><div class="divider" ng-if="hasAccess(\'signuprms\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'signuprms\')" ui-sref="signuprms"><span>Sign Up RMS</span></a><div class="divider" ng-if="hasAccess(\'signupims\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'signupims\')" ui-sref="signupims"><span translate="NEW_ACCOUNT_CREATION_(IMS)"></span></a><div class="divider" ng-if="hasAccess(\'signupimsassign\')"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'signupimsassign\')" ui-sref="signupimsassign"><span translate="IOT_DEVICE_ASSIGNMENT_(IMS)"></span></a></div></div></div></div><div class="btn-group" uib-dropdown="" ng-if="hasAccess(\'superadmin\')"><a href="" class="btn button-mainmenu su" uib-dropdown-toggle=""><i class="fa fa-shield fa-2x"></i> {{ \'SUPERADMIN\' | translate }}</a><div uib-dropdown-menu="" class="dropdown-menu superadmin" role="menu"><div class="row"><div class="col-lg-12"><b class="menu-title"><span translate="SUPERADMIN_FEATURES"></span></b><div class="divider"></div><div class="row"><div class="col-lg-6"><a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.companies\')" ui-sref="superadmin.companies"><span translate="COMPANIES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.companysettings\')" ui-sref="superadmin.companysettings">Company Settings</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.branches\')" ui-sref="superadmin.branches"><span translate="BRANCHES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.features\')" ui-sref="superadmin.features"><span translate="FEATURES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.serverpackages\')" ui-sref="superadmin.serverpackages"><span translate="PACKAGES"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.serverpackagesettings\')" ui-sref="superadmin.serverpackagesettings"><span translate="PACKAGES_SETTINGS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.payments\')" ui-sref="superadmin.payments"><span translate="PAYMENTS_(CUSTOMERS)"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.commissions\')" ui-sref="superadmin.commissions"><span translate="COMMISSIONS_(DEALERS)"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.users\')" ui-sref="superadmin.users"><span translate="USERS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.uoms\')" ui-sref="superadmin.uoms">{{ \'U.O.M\' | translate }}</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.announcements\')" ui-sref="superadmin.announcements">{{ \'ANNOUNCEMENTS\' | translate }}</a></div><div class="col-lg-6"><a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.siotdevices\')" ui-sref="superadmin.siotdevices">Smart IOT Devices Management</a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.iotregdevices\')" ui-sref="superadmin.iotregdevices"><span translate="IOT_DEVICES_MANAGEMENT"></span></a><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.affiliates\')" ui-sref="superadmin.affiliates"><span translate="AFFILIATES_MANAGEMENT"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.affiliates_newcustomer\')" ui-sref="superadmin.affiliates_newcustomer"><span translate="Affiliates Customers Approval"></span></a><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.intercompanymappings\')" ui-sref="superadmin.intercompanymappings"><span translate="INTER_COMPANY_MAPPINGS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.intercompanyitemmappings\')" ui-sref="superadmin.intercompanyitemmappings"><span translate="INTER_COMPANY_ITEM_MAPPINGS"></span></a><div class="divider"></div><a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.systemschedulersettings\')" ui-sref="superadmin.systemschedulersettings"><span translate="SCHEDULER_SETTINGS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.systemsettings\')" ui-sref="superadmin.systemsettings"><span translate="SYSTEM_SETTINGS"></span></a> <a href="" class="btn menu-link" ng-if="hasAccess(\'superadmin.systemversion\')" ui-sref="superadmin.systemversion"><span translate="SYSTEM_VERSION"></span></a><div class="divider"></div><a href="" class="btn menu-link" ng-if="isSuperAdmin && hasAccess(\'superadmin.businessmetrics\')" ui-sref="superadmin.businessmetrics">Business Metrics</a></div></div></div></div></div></div>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><div class="page-top-inner"><div uib-dropdown="" auto-close="outsideClick" dropdown-append-to-body="true" on-toggle="toggled(open)" is-open="miniMenuIsOpen" class="mini-mainmenu"><a href="" class="collapse-menu-link ion-navicon" uib-dropdown-toggle=""></a><div uib-dropdown-menu="" class="mini-dropdown-menu" role="menu"><section data-ng-include="" src="\'app/theme/components/pageTop/mainMenuMini.html\'"></section></div></div><a href="#/dashboard" class="al-logo clearfix al-logo-custom" ng-if="user.companyLogo!=\'\'"><img ng-src="{{user.companyLogo}}" alt="{{user.companyName}}"></a> <a href="#/dashboard" class="al-logo clearfix" ng-if="user.companyLogo==\'\'"><img src="assets/img/foodtec-logo.png" alt="FoodTec RMS"></a><div class="top-mainmenu"><section data-ng-include="" src="\'app/theme/components/pageTop/mainMenuTop.html\'"></section></div><div class="user-profile clearfix"><ul class="al-profile clearfix"><li uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><div class="al-profile-custom-link"><div class="al-profile-custom-link-inner"><div style="font-size:9pt;"><b>{{ user.userName | uppercase }}</b></div><div style="font-size:7pt;">{{ user.companyName | limitTo: 25 }} {{ (user.companyName.length > 25 ? \'...\' : \'\') }}</div><div style="font-size:7pt">{{ user.branchName | limitTo: 25 }} {{ (user.branchName.length > 25 ? \'...\' : \'\') }}</div></div><div style="padding-top:15px; float:right;"><i class="fa fa-chevron-down"></i></div></div><div class="al-profile-custom-icon"><div style="padding-top:10px; float:right;"><i class="fa fa-user fa-2x"></i></div></div></a><ul class="top-dropdown-menu profile-dropdown" style="width:260px;top:60px;margin-right:15px" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><div style="padding:5px;text-align:center;"><div class="profile-mini"><div><b>{{ user.userName | uppercase }}</b></div><div>{{ user.companyName | limitTo: 20 }} {{ (user.companyName.length > 25 ? \'...\' : \'\') }}</div><div>{{ user.branchName | limitTo: 20 }} {{ (user.branchName.length > 25 ? \'...\' : \'\') }}</div><br></div><div style="font-size:80%;text-transform:uppercase;"><i class="fa fa-info-circle fa-fw"></i> <b><span translate="ACCOUNT_INFORMATION"></span></b></div></div><div style="padding:5px"><table class="table table-hover" style="font-size:9pt;background:#eee"><tr ng-if="user.serverMode!=0"><td style="width:55%" translate="CLOUD_STORAGE"></td><td style="width:5%">:</td><td style="width:40%;line-height:120% !important;padding-top:8px;padding-bottom:8px" nowrap="nowrap"><b>{{user.azureBlobUsage | number:2}} / {{user.azureBlobQuota | number:0}} GB<div class="progress progress-custom"><div align="center" style="position:absolute;width:90px;font-size:8pt;line-height:13px;color:#000">{{user.azureBlobUsagePercent | number:2}}%</div><div class="progress-bar progress-bar-info" role="progressbar" aria-valuemin="0" ng-if="user.azureBlobUsagePercent<=85" aria-valuenow="user.azureBlobUsage" aria-valuemax="user.azureBlobQuota" style="width: {{user.azureBlobUsagePercent | number:0}}%"></div><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuemin="0" ng-if="user.azureBlobUsagePercent>85 && user.azureBlobUsagePercent<95" aria-valuenow="user.azureBlobUsage" aria-valuemax="user.azureBlobQuota" style="width: {{user.azureBlobUsagePercent | number:0}}%;font-size:8pt;line-height:13px;color:#000"></div><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuemin="0" ng-if="user.azureBlobUsagePercent>=95" aria-valuenow="user.azureBlobUsage" aria-valuemax="user.azureBlobQuota" style="width: {{user.azureBlobUsagePercent | number:0}}%;font-size:8pt;line-height:13px;color:#000"></div></div></b></td></tr><tr><td style="width:55%" translate="STD_USER_LICENSE"></td><td style="width:5%">:</td><td style="width:40%" nowrap="nowrap"><b>{{ user.totalStdUserCount }} / {{ user.standardUserLimit >= 0 ? user.standardUserLimit : \'&#x221e;\' }}</b> &nbsp;<span translate="USERS"></span></td></tr><tr><td style="width:55%" translate="LTD_USER_LICENSE"></td><td style="width:5%">:</td><td style="width:40%" nowrap="nowrap"><b>{{ user.totalLmtUserCount }} / {{ user.limitedUserLimit >= 0 ? user.limitedUserLimit : \'&#x221e;\' }}</b> &nbsp;<span translate="USERS"></span></td></tr><tr><td translate="LANGUAGE"></td><td>:</td><td nowrap="nowrap"><b>{{ languageName | uppercase | translate }}</b></td></tr></table></div></li><li><a href="" ng-click="selectLanguage()" class="signout"><i class="fa fa-language fa-fw"></i> <span translate="SELECT_LANGUAGE"></span></a></li><li><a href="" ng-click="goFullscreen()" class="signout"><i class="fa fa-arrows-alt fa-fw"></i> <span translate="FULLSCREEN_MODE"></span></a></li><li><a href="" ng-click="viewToken()" class="signout"><i class="fa fa-key fa-fw"></i> <span translate="VIEW_TOKEN"></span></a></li><li><a href="" ng-click="navigateChgPwd()"><i class="fa fa-lock fa-fw"></i> <span translate="CHANGE_PWD"></span></a></li><li><a href="" ng-click="switchCompanyBranch()"><i class="fa fa-refresh fa-fw"></i> <span translate="SWITCH_BRANCH"></span></a></li><li><a href="" ng-click="logout()" class="signout"><i class="fa fa-power-off fa-fw"></i> <span translate="SIGN_OUT"></span></a></li></ul></li></ul><ul class="al-approval-center clearfix"><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><span class="fa-stack fa-lg"><i class="fa fa-certificate fa-stack-2x"></i> <i class="fa fa-check fa-stack-1x fa-inverse"></i></span> <span class="approval-count" ng-if="approvalList.length!=0">{{approvalList.length}}</span></a><div uib-dropdown-menu="" class="top-dropdown-approval-list"><i class="dropdown-arr"></i><div class="header bg-primary"><span translate="APPROVAL_CENTER"></span> <small class="pull-right"><b>{{approvalList.length}}</b> <span>{{ (approvalList.length>1) ? \'Requests\' : \'Request\' }}</span></small></div><div class="approval-list"><div class="no-approval-area" ng-if="approvalList.length==0"><div>{{\'THERE_IS_NO_PENDING_APPROVAL\' | translate}}.</div></div><div class="approval-entry" ng-if="approvalList.length!=0" ng-repeat="app in approvalList"><div class="doc-status pull-right">{{ app.lastStatus }}</div><div class="branch-name"><i class="fa fa-map-marker"></i> {{ app.branchName | uppercase | limitTo:20 }}</div><div class="doc-no">{{ app.docNo }}</div><div class="total-price">{{ currencyCode }} {{app.totalPrice | number: 2}}</div><div class="buttons"><a href="" class="btn btn-success btn-xs btn-approve" ng-click="approveRequest(app)"><i class="fa fa-check"></i> Approve</a> <a href="" class="btn btn-danger btn-xs btn-disapprove" ng-click="disapproveRequest(app)"><i class="fa fa-times"></i> Disapprove</a> <a href="" class="btn btn-default btn-xs btn-view-detail pull-right" ng-click="viewDocument(app)">View Document <i class="fa fa-search"></i></a></div></div></div></div></li></ul><ul class="al-approval-center clearfix"><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><span class="fa-stack fa-lg"><i class="fa fa-bell-o fa-lg"></i></span></a><div uib-dropdown-menu="" class="top-dropdown-approval-list"><i class="dropdown-arr"></i><div class="header bg-primary"><span translate="ANNOUNCEMENT_CENTER"></span> <small class="pull-right"><b>{{announcementList.length}}</b> <span>{{ (announcementList.length>1) ? \'Announcements\' : \'Announcement\' }}</span></small></div><div class="announcement-list"><div class="no-announcement-wrapper" ng-if="announcementList.length==0"><div>{{\'THERE_IS_NO_ANNOUNCEMENT\' | translate}}.</div></div><div class="announcement-wrapper" ng-if="announcementList.length!=0" ng-repeat="announcement in announcementList" ng-class="{ \'list-importance-level-1\': announcement.importanceLevel === \'HIGH\', \'list-importance-level-2\': announcement.importanceLevel === \'MED\', \'list-importance-level-3\': announcement.importanceLevel === \'LOW\' }"><h5 class="announcement-title">{{announcement.moduleName}}</h5><span class="announcement-subtitle">{{announcement.announcementTitle}}</span> <span class="announcement-date">{{formatDate(announcement.effectiveStartDate)}}</span><p class="announcement-content">{{announcement.announcementContent}}</p></div></div></div></li></ul></div></div></div><script type="text/ng-template" id="languageModal.html"><form name="$mdl.languageForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"><span translate="LANGUAGE_SELECTION"></span> </h3> </div> <div class="modal-body" id="modal-body"> <div class="form-group" ng-class="{\'has-error\': $mdl.languageForm.Language.$invalid && $mdl.languageForm.$submitted}"> <label> <i class="fa fa-info-circle"></i>&nbsp; {{ \'PLEASE_SELECT_A_LANGUAGE\' | translate }} </label> <select name="Language" class="form-control" style="background:#FFFCED" ng-model="$mdl.selectedLanguage" required> <option value="en">English</option> <option value="ko">{{ \'KOREAN\' |translate }}</option> </select> <p class="help-block" style="color:#f00" ng-show="$mdl.languageForm.Language.$error.required && $mdl.languageForm.$submitted"> * {{ \'REQUIRED\' | translate }}</p> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary btn-with-icon" type="button" ng-disabled="$mdl.lockButtons"> <i class="ion ion-checkmark"></i> {{ \'CONFIRM\' | translate }} </button> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()" ng-disabled="$mdl.lockButtons"> <i class="ion ion-close"></i> {{ \'CANCEL\' | translate }} </button> </div> </form></script><script type="text/ng-template" id="tokenModal.html"><form name="$mdl.tokenForm" ng-submit="$mdl.confirmModal()" novalidate> <div class="modal-header bg-primary"> <h3 class="modal-title" style="color:#fff"> <span translate="TOKEN_SECRET"></span> </h3> </div> <div class="modal-body" id="modal-body"> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <center class="text-danger"> <b>Do not share this with others!</b> </center> </div> </div> </div> <div class="row"> <div class="col-md-12 col-lg-12"> <div class="form-group"> <span class="form-control" style="background:#FFFCED;height:50px !important;line-height:38px !important;font-family:courier;font-size:16pt;text-align:center"> <b>{{$mdl.token}}</b> </span> </div> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-danger btn-with-icon" type="button" ng-click="$mdl.cancelModal()"> <i class="ion ion-close"></i> {{ "CLOSE" | translate }} </button> </div> </form></script>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/stPagination/pagination.html','<nav ng-show="numPages && pages.length >= 2"><ul class="pagination"><li ng-class="{disabled: currentPage == 1}"><a ng-click="selectPage(1)" aria-label="First"><span aria-hidden="true"><i class="fa fa-angle-double-left"></i></span></a></li><li ng-class="{disabled: currentPage == 1}"><a ng-click="selectPage(currentPage-1)" aria-label="Previous"><span aria-hidden="true"><i class="fa fa-angle-left"></i></span></a></li><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a ng-click="selectPage(page)">{{page}}</a></li><li ng-show="pages.indexOf(numPages -1) == -1"><a ng-click="selectPage(pages[pages.length - 1])">...</a></li><li ng-show="pages.indexOf(numPages) == -1"><a ng-click="selectPage(numPages)">{{numPages}}</a></li><li><a ng-click="selectPage(currentPage+1)" aria-label="Next" ng-disabled="true"><span aria-hidden="true"><i class="fa fa-angle-right"></i></span></a></li><li ng-class="{disabled: currentPage == numPages}"><a ng-click="selectPage(numPages)" aria-label="Next"><span aria-hidden="true"><i class="fa fa-angle-double-right"></i></span></a></li></ul></nav>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue" ng-change="switcherChange()"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on"><span translate="ON"></span></span> <span class="handle"></span> <span class="handle handle-off"><span translate="OFF"></span></span></div></div></label>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/widgets/bulkBreakJobAverageYield/bulkBreakJobAverageYield.html','<div class="panel panel-default bootstrap-panel"><div class="panel-heading widget-panel-heading">{{ \'BULK_BREAK_JOB_AVG_YIELD\' | translate }}</div><div class="panel-body"><div class="placeholder"><center>{{ \'NO_DATA_AVAILABLE\' | translate }}</center></div></div></div>');
$templateCache.put('app/pages/dashboard/widgets/productionJobYield/productionJobYield.html','<div class="panel panel-default bootstrap-panel"><div class="panel-heading widget-panel-heading">{{ \'PROD_JOB_YIELD\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-lg-3"><div class="form-group" style="line-height:120%"><small>{{ \'SELECT_ITEMS\' | translate }}</small><br><div ng-dropdown-multiselect="" options="widgetPj.itemList" ng-disabled="widgetPj.isLoading" selected-model="widgetPj.selectedIds" extra-settings="widgetPj.selectSettings"></div></div></div><div class="col-lg-3"><small>{{ \'START_DATE\' | translate }}</small><br><div moment-picker="widgetPj.startDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="StartDate" placeholder="{{ \'START_DATE\' | translate }}" style="background:#fffeed" ng-disabled="widgetPj.isLoading" ng-model="widgetPj.startDate" ng-readonly="true" required=""></div></div><div class="col-lg-3"><small>{{ \'END_DATE\' | translate }}</small><br><div moment-picker="widgetPj.endDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="StartDate" placeholder="{{ \'START_DATE\' | translate }}" style="background:#fffeed" ng-disabled="widgetPj.isLoading" ng-model="widgetPj.endDate" ng-readonly="true" required=""></div></div><div class="col-lg-3"><small>&nbsp;</small><br><a href="" class="btn btn-primary btn-with-icon pull-right" ng-click="widgetPj.loadData()" ng-disabled="widgetPj.isLoading"><i class="ion-refresh"></i> {{ \'GENERATE\' | translate }}</a></div></div><div class="row"><div class="col-lg-12 widget-table"><table class="table table-striped table-bordered table-hover"><thead><tr><th><b>{{ \'ITEM_CODE\' | translate }}</b></th><th><b>{{ \'ITEM_NAME\' | translate }}</b></th><th style="text-align:center"><b>{{ \'TOTAL_NO_OF_JOB\' | translate }}</b></th><th style="text-align:center"><b>{{ \'TOTAL_NO_OF_BATCH\' | translate }}</b></th><th style="text-align:center"><b>{{ \'TOTAL_YIELD\' | translate }}</b></th><th style="text-align:center"><b>{{ \'VARIANCE\' | translate }} (%)</b></th></tr></thead><tbody><tr ng-if="widgetPj.isLoading"><td colspan="6" class="placeholder"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-if="widgetPj.result.length==0 && !widgetPj.isLoading"><td colspan="6" class="placeholder"><center>{{ \'NO_DATA_AVAILABLE\' | translate }}</center></td></tr><tr ng-repeat="item in widgetPj.result | orderBy:\'varianceInPercentage\'"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{item.itemCode | uppercase}}</td><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{item.itemName | uppercase}}</td><td style="text-align:center">{{item.totalNumberOfJob}}</td><td style="text-align:right">{{item.totalNumberOfBatch}}</td><td style="text-align:right">{{item.totalYield | number:2}}</td><td style="text-align:right"><span ng-if="item.varianceInPercentage>=0" class="text-success">{{item.varianceInPercentage | number:2}}</span> <span ng-if="item.varianceInPercentage<0" class="text-danger">{{item.varianceInPercentage | number:2}}</span></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/dashboard/widgets/purchaseOrderYoyComparison/purchaseOrderYoyComparison.html','<div class="panel panel-default bootstrap-panel"><div class="panel-heading widget-panel-heading">{{ \'PURCHASE_ORDER_YOY_COMPARISON\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-lg-12 widget-chart"><div id="amchart" ng-if="!widgetPyoy.isLoading && !widgetPyoy.hasError"></div><div class="placeholder" ng-if="widgetPyoy.isLoading"><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data...</b></center></div><div class="placeholder" ng-if="!widgetPyoy.isLoading && widgetPyoy.hasError"><center>{{ \'NO_DATA_AVAILABLE\' | translate }}</center></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/widgets/purchaseOrderSummary/purchaseOrderSummary.html','<div class="panel panel-default bootstrap-panel"><div class="panel-heading widget-panel-heading">{{ \'PURCHASE_ORDER_SUMMARY\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-lg-3"><div class="form-group" style="line-height:120%"><small>{{ \'SELECT_STATUSES\' | translate }}</small><br><div ng-dropdown-multiselect="" options="widgetPs.statusList" ng-disabled="widgetPs.isLoading" selected-model="widgetPs.selectedStatuses" extra-settings="widgetPs.selectSettings"></div></div></div><div class="col-lg-3"><small>{{ \'START_DATE\' | translate }}</small><br><div moment-picker="widgetPs.startDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="StartDate" placeholder="{{ \'START_DATE\' | translate }}" style="background:#fffeed" ng-disabled="widgetPs.isLoading" ng-model="widgetPs.startDate" ng-readonly="true" required=""></div></div><div class="col-lg-3"><small>{{ \'END_DATE\' | translate }}</small><br><div moment-picker="widgetPs.endDate" format="YYYY-MM-DD" max-view="month" start-view="month" today="true" set-on-select="true" class="input-group"><span class="input-group-addon" style="padding:3px 10px;font-size:9pt"><i class="fa fa-calendar"></i></span> <input type="text" class="form-control" name="StartDate" placeholder="{{ \'START_DATE\' | translate }}" style="background:#fffeed" ng-disabled="widgetPs.isLoading" ng-model="widgetPs.endDate" ng-readonly="true" required=""></div></div><div class="col-lg-3"><small>&nbsp;</small><br><a href="" class="btn btn-primary btn-with-icon pull-right" ng-click="widgetPs.loadData()" ng-disabled="widgetPs.isLoading"><i class="ion-refresh"></i> {{ \'GENERATE\' | translate }}</a></div></div><div class="row"><div class="col-lg-12 widget-table"><table class="table table-striped table-bordered table-hover"><thead><tr><th><b>{{ \'BRANCH_NAME\' | translate }}</b></th><th style="text-align:center"><b>{{ \'NO_OF_PO\' | translate }}</b></th><th style="text-align:center"><b>{{ \'VALUE\' | translate }} ({{widgetPs.currency}})</b></th></tr></thead><tbody><tr ng-if="widgetPs.isLoading"><td colspan="3" class="placeholder"><big><center><b><i class="fa fa-spinner fa-spin fa-fw"></i> Loading Data ...</b></center></big></td></tr><tr ng-if="widgetPs.result.length==0 && !widgetPs.isLoading"><td colspan="3" class="placeholder"><center>{{ \'NO_DATA_AVAILABLE\' | translate }}</center></td></tr><tr ng-repeat="item in widgetPs.result | orderBy:\'branchName\'"><td style="padding-top:10px;padding-bottom:10px;line-height:130%">{{item.branchName | uppercase}}</td><td style="text-align:right">{{item.numberCount}}</td><td style="text-align:right">{{item.valueSum | number:2}}</td></tr></tbody></table></div></div></div></div>');}]);